// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/simple-line-icons/css/simple-line-icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/fontawesome/css/all.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/material-design-iconic-font/css/materialdesignicons.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/themify-icons/css/themify-icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/line-awesome/css/line-awesome.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/avasta/css/style.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/flaticon/flaticon.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/flaticon-1/font/flaticon-1.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/icomoon/icomoon.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../icons/bootstrap-icons/font/bootstrap-icons.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../other/animate/animate.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../other/aos/css/aos.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_12___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../other/perfect-scrollbar/css/perfect-scrollbar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_13___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../other/metismenu/css/metisMenu.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23a6a2da%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%231EBA62%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23fd5353%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23fd5353%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23453da3%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23A098AE%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/pattern/pattern5.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 352 512%27%3E%3C%21-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license %28Commercial License%29 --%3E%3Cpath d=%27M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z%27 fill=%27%23fff%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/student-bg-Recovered.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./../images/1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/like.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/profile/12.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700,800);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,500,600,700);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:400,600,700);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Material+Icons);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_12___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
    Table of Contents

    Name                 : Akadmi
    Author               : DexignLab
    Author Portfolio     : https://themeforest.net/user/dexignlab/portfolio
    


    Table of Sass Contents
    1. Abstracts
        _bs-custom
        _inheritance
        _maps
        _mixin
        _variable

    2. bootstrap 
        -Here goes all official bootstrap scss files

    3. Global/Base
        _color
        _custom-grid
        _fonts
        _helper
        _reset

    4. layout
        +footer
        +header
        +rtl
        +sidebar
        +tables
        +theme
        +version-dark

    5. Conponents
        +app
        +charts
        +forms
        +map
        +uc
        +ui
        +widget

    6. Page
        _index-1
        _page-error
        _page-register
        _page-signin
        _page-user-lock
        _page-user-lock

*/
:root {
	--primary: #4d44b5;
	--secondary: #fb7d5b;
	--primary-hover: #3d3690;
	--primary-dark: #1e1a46;
	--rgba-primary-1: rgba(77, 68, 181, 0.1);
	--rgba-primary-2: rgba(77, 68, 181, 0.2);
	--rgba-primary-3: rgba(77, 68, 181, 0.3);
	--rgba-primary-4: rgba(77, 68, 181, 0.4);
	--rgba-primary-5: rgba(77, 68, 181, 0.5);
	--rgba-primary-6: rgba(77, 68, 181, 0.6);
	--rgba-primary-7: rgba(77, 68, 181, 0.7);
	--rgba-primary-8: rgba(77, 68, 181, 0.8);
	--rgba-primary-9: rgba(77, 68, 181, 0.9);
	--rgba-secondary-1: rgba(251, 125, 91, 0.1);
	--rgba-secondary-2: rgba(251, 125, 91, 0.2);
	--rgba-secondary-3: rgba(251, 125, 91, 0.3);
	--rgba-secondary-4: rgba(251, 125, 91, 0.4);
	--rgba-secondary-5: rgba(251, 125, 91, 0.5);
	--rgba-secondary-6: rgba(251, 125, 91, 0.6);
	--rgba-secondary-7: rgba(251, 125, 91, 0.7);
	--rgba-secondary-8: rgba(251, 125, 91, 0.8);
	--rgba-secondary-9: rgba(251, 125, 91, 0.9);
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--title: #303972;
}

.gradient_one {
	background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%, rgba(103, 25, 255, 0.85) 100%);
}

.gradient-1 {
	background: #f0a907;
	background: linear-gradient(to bottom, #f0a907 0%, #f53c79 100%) !important;
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f0a907', endColorstr='#f53c79',GradientType=0 );
}

.gradient-2 {
	background: #4dedf5;
	background: linear-gradient(to bottom, #4dedf5 0%, #480ceb 100%) !important;
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4dedf5', endColorstr='#480ceb',GradientType=0 );
}

.gradient-3 {
	background: #51f5ae;
	background: linear-gradient(to bottom, #51f5ae 0%, #3fbcda 100%) !important;
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#51f5ae', endColorstr='#3fbcda',GradientType=0 );
}

.gradient-4 {
	background: #f25521;
	background: linear-gradient(to right, #f25521 0%, #f9c70a 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f25521', endColorstr='#f9c70a',GradientType=1 );
}

.gradient-5 {
	background: #f53c79;
	background: linear-gradient(to right, #f53c79 0%, #f0a907 100%) !important;
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f53c79', endColorstr='#f0a907',GradientType=1 );
}

.gradient-6 {
	background: #36b9d8;
	background: linear-gradient(to right, #36b9d8 0%, #4bffa2 100%) !important;
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#36b9d8', endColorstr='#4bffa2',GradientType=1 );
}

.gradient-7 {
	background: #4400eb;
	background: linear-gradient(to right, #4400eb 0%, #44e7f5 100%) !important;
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4400eb', endColorstr='#44e7f5',GradientType=1 );
}

.gradient-8 {
	background: #f7b00f;
	background: linear-gradient(to bottom, #f7b00f 0%, #f25521 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#F7B00F', endColorstr='#F25521',GradientType=1 );
}

.gradient-9 {
	background: #f31e7a !important;
	background: linear-gradient(to right, #f31e7a 0%, #fd712c 100%) !important;
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f31e7a', endColorstr='#fd712c',GradientType=1 );
}

.gradient-10 {
	background: #f25521 !important;
	background: linear-gradient(to top, #f25521 0%, #f9c70a 100%) !important;
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f25521', endColorstr='#f9c70a',GradientType=1 );
}

.gradient-11 {
	background: #3398fb;
	background: linear-gradient(to right, #3398fb 0%, #8553ee 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3398fb', endColorstr='#8553ee',GradientType=1 );
}

.gradient-12 {
	background: #36e1b4;
	background: linear-gradient(to right, #36e1b4 0%, #11cae7 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#36e1b4', endColorstr='#11cae7',GradientType=1 );
}

.gradient-13 {
	background: #ffbf31;
	background: linear-gradient(to right, #ffbf31 0%, #ff890e 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffbf31', endColorstr='#ff890e',GradientType=1 );
}

.gradient-14 {
	background: #23bdb8;
	background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#23bdb8', endColorstr='#43e794',GradientType=1 );
}

.gradient-15 {
	background: #9a56ff;
	background: linear-gradient(135deg, #9a56ff 0%, #e36cd9 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#9a56ff', endColorstr='#e36cd9',GradientType=1 );
}

.gradient-16 {
	background: #f48665;
	background: linear-gradient(135deg, #f48665 0%, #fda23f 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f48665', endColorstr='#fda23f',GradientType=1 );
}

.gradient-17 {
	background: #e36cd9;
	background: linear-gradient(135deg, #e36cd9 0%, #fe60ae 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e36cd9', endColorstr='#fe60ae',GradientType=1 );
}

.gradient-18 {
	background: #a15cff;
	background: linear-gradient(to right, #a15cff 0%, #ce82fd 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a15cff', endColorstr='#ce82fd',GradientType=1 );
}

/*
0 - 600: Phone
600 - 900: Tablet portrait
900 - 1200: Tablet landscape
1200 - 1800: Normal styles
1800+ : Big Desktop
1em = 16px
The smaller device rules always should write below the bigger device rules
Fixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component
*/
/*!
 * Bootstrap v5.1.3 (https://getbootstrap.com/)
 * Copyright 2011-2021 The Bootstrap Authors
 * Copyright 2011-2021 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
	--bs-blue: #374c98;
	--bs-indigo: #6610f2;
	--bs-purple: #6f42c1;
	--bs-pink: #eb62d0;
	--bs-red: #ee3232;
	--bs-orange: #ff9900;
	--bs-yellow: #fffa6f;
	--bs-green: #297f00;
	--bs-teal: #20c997;
	--bs-cyan: #3065d0;
	--bs-white: #fff;
	--bs-gray: #6c757d;
	--bs-gray-dark: #343a40;
	--bs-gray-100: #f8f9fa;
	--bs-gray-200: #e9ecef;
	--bs-gray-300: #dee2e6;
	--bs-gray-400: #ced4da;
	--bs-gray-500: #adb5bd;
	--bs-gray-600: #6c757d;
	--bs-gray-700: #495057;
	--bs-gray-800: #343a40;
	--bs-gray-900: #212529;
	--bs-primary: #4d44b5;
	--bs-secondary: #fb7d5b;
	--bs-success: #1eba62;
	--bs-info: #00ada3;
	--bs-warning: #fcc43e;
	--bs-danger: #fd5353;
	--bs-light: #ebebf9;
	--bs-dark: #303972;
	--bs-primary-rgb: 77, 68, 181;
	--bs-secondary-rgb: 251, 125, 91;
	--bs-success-rgb: 30, 186, 98;
	--bs-info-rgb: 0, 173, 163;
	--bs-warning-rgb: 252, 196, 62;
	--bs-danger-rgb: 253, 83, 83;
	--bs-light-rgb: 235, 235, 249;
	--bs-dark-rgb: 48, 57, 114;
	--bs-white-rgb: 255, 255, 255;
	--bs-black-rgb: 0, 0, 0;
	--bs-body-color-rgb: 160, 152, 174;
	--bs-body-bg-rgb: 230, 235, 238;
	--bs-font-sans-serif: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif,
		'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
	--bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
	--bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
	--bs-body-font-family: Poppins, sans-serif;
	--bs-body-font-size: 0.875rem;
	--bs-body-font-weight: 400;
	--bs-body-line-height: 1.5;
	--bs-body-color: #a098ae;
	--bs-body-bg: #e6ebee;
}

*,
*::before,
*::after {
	box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
	:root {
		scroll-behavior: smooth;
	}
}

body {
	margin: 0;
	font-family: var(--bs-body-font-family);
	font-size: var(--bs-body-font-size);
	font-weight: var(--bs-body-font-weight);
	line-height: var(--bs-body-line-height);
	color: var(--bs-body-color);
	text-align: var(--bs-body-text-align);
	background-color: var(--bs-body-bg);
	-webkit-text-size-adjust: 100%;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
	margin: 1rem 0;
	color: inherit;
	background-color: currentColor;
	border: 0;
	opacity: 0.25;
}

hr:not([size]) {
	height: 1px;
}

h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
	margin-top: 0;
	margin-bottom: 0.5rem;
	font-weight: 600;
	line-height: 1.2;
	color: #303972;
}

h1,
.h1 {
	font-size: calc(1.35rem + 1.2vw);
}
@media (min-width: 1200px) {
	h1,
	.h1 {
		font-size: 2.25rem;
	}
}

h2,
.h2 {
	font-size: calc(1.3125rem + 0.75vw);
}
@media (min-width: 1200px) {
	h2,
	.h2 {
		font-size: 1.875rem;
	}
}

h3,
.h3 {
	font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
	h3,
	.h3 {
		font-size: 1.5rem;
	}
}

h4,
.h4 {
	font-size: 1.125rem;
}

h5,
.h5 {
	font-size: 1rem;
}

h6,
.h6 {
	font-size: 0.938rem;
}

p {
	margin-top: 0;
	margin-bottom: 1rem;
}

abbr[title],
abbr[data-bs-original-title] {
	-webkit-text-decoration: underline dotted;
	        text-decoration: underline dotted;
	cursor: help;
	text-decoration-skip-ink: none;
}

address {
	margin-bottom: 1rem;
	font-style: normal;
	line-height: inherit;
}

ol,
ul {
	padding-left: 2rem;
}

ol,
ul,
dl {
	margin-top: 0;
	margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
	margin-bottom: 0;
}

dt {
	font-weight: 700;
}

dd {
	margin-bottom: 0.5rem;
	margin-left: 0;
}

blockquote {
	margin: 0 0 1rem;
}

b,
strong {
	font-weight: bolder;
}

small,
.small {
	font-size: 0.875em;
}

mark,
.mark {
	padding: 0.2em;
	background-color: #fcf8e3;
}

sub,
sup {
	position: relative;
	font-size: 0.75em;
	line-height: 0;
	vertical-align: baseline;
}

sub {
	bottom: -0.25em;
}

sup {
	top: -0.5em;
}

a {
	color: #4d44b5;
	text-decoration: underline;
}
a:hover {
	color: #3e3691;
}

a:not([href]):not([class]),
a:not([href]):not([class]):hover {
	color: inherit;
	text-decoration: none;
}

pre,
code,
kbd,
samp {
	font-family: var(--bs-font-monospace);
	font-size: 1em;
	direction: ltr /* rtl:ignore */;
	unicode-bidi: bidi-override;
}

pre {
	display: block;
	margin-top: 0;
	margin-bottom: 1rem;
	overflow: auto;
	font-size: 0.875em;
}
pre code {
	font-size: inherit;
	color: inherit;
	word-break: normal;
}

code {
	font-size: 0.875em;
	color: #eb62d0;
	word-wrap: break-word;
}
a > code {
	color: inherit;
}

kbd {
	padding: 0.2rem 0.4rem;
	font-size: 0.875em;
	color: #fff;
	background-color: #212529;
	border-radius: 0.625rem;
}
kbd kbd {
	padding: 0;
	font-size: 1em;
	font-weight: 700;
}

figure {
	margin: 0 0 1rem;
}

img,
svg {
	vertical-align: middle;
}

table {
	caption-side: bottom;
	border-collapse: collapse;
}

caption {
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
	color: #89879f;
	text-align: left;
}

th {
	text-align: inherit;
	text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
	border-color: inherit;
	border-style: solid;
	border-width: 0;
}

label {
	display: inline-block;
}

button {
	border-radius: 0;
}

button:focus:not(:focus-visible) {
	outline: 0;
}

input,
button,
select,
optgroup,
textarea {
	margin: 0;
	font-family: inherit;
	font-size: inherit;
	line-height: inherit;
}

button,
select {
	text-transform: none;
}

[role='button'] {
	cursor: pointer;
}

select {
	word-wrap: normal;
}
select:disabled {
	opacity: 1;
}

[list]::-webkit-calendar-picker-indicator {
	display: none;
}

button,
[type='button'],
[type='reset'],
[type='submit'] {
	-webkit-appearance: button;
}
button:not(:disabled),
[type='button']:not(:disabled),
[type='reset']:not(:disabled),
[type='submit']:not(:disabled) {
	cursor: pointer;
}

::-moz-focus-inner {
	padding: 0;
	border-style: none;
}

textarea {
	resize: vertical;
}

fieldset {
	min-width: 0;
	padding: 0;
	margin: 0;
	border: 0;
}

legend {
	float: left;
	width: 100%;
	padding: 0;
	margin-bottom: 0.5rem;
	font-size: calc(1.275rem + 0.3vw);
	line-height: inherit;
}
@media (min-width: 1200px) {
	legend {
		font-size: 1.5rem;
	}
}
legend + * {
	clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
	padding: 0;
}

::-webkit-inner-spin-button {
	height: auto;
}

[type='search'] {
	outline-offset: -2px;
	-webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
	-webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
	padding: 0;
}

::file-selector-button {
	font: inherit;
}

::-webkit-file-upload-button {
	font: inherit;
	-webkit-appearance: button;
}

output {
	display: inline-block;
}

iframe {
	border: 0;
}

summary {
	display: list-item;
	cursor: pointer;
}

progress {
	vertical-align: baseline;
}

[hidden] {
	display: none !important;
}

.lead {
	font-size: 1.09375rem;
	font-weight: 300;
}

.display-1 {
	font-size: calc(1.625rem + 4.5vw);
	font-weight: 300;
	line-height: 1.2;
}
@media (min-width: 1200px) {
	.display-1 {
		font-size: 5rem;
	}
}

.display-2 {
	font-size: calc(1.575rem + 3.9vw);
	font-weight: 300;
	line-height: 1.2;
}
@media (min-width: 1200px) {
	.display-2 {
		font-size: 4.5rem;
	}
}

.display-3 {
	font-size: calc(1.525rem + 3.3vw);
	font-weight: 300;
	line-height: 1.2;
}
@media (min-width: 1200px) {
	.display-3 {
		font-size: 4rem;
	}
}

.display-4 {
	font-size: calc(1.475rem + 2.7vw);
	font-weight: 300;
	line-height: 1.2;
}
@media (min-width: 1200px) {
	.display-4 {
		font-size: 3.5rem;
	}
}

.display-5 {
	font-size: calc(1.425rem + 2.1vw);
	font-weight: 300;
	line-height: 1.2;
}
@media (min-width: 1200px) {
	.display-5 {
		font-size: 3rem;
	}
}

.display-6 {
	font-size: calc(1.375rem + 1.5vw);
	font-weight: 300;
	line-height: 1.2;
}
@media (min-width: 1200px) {
	.display-6 {
		font-size: 2.5rem;
	}
}

.list-unstyled {
	padding-left: 0;
	list-style: none;
}

.list-inline {
	padding-left: 0;
	list-style: none;
}

.list-inline-item {
	display: inline-block;
}
.list-inline-item:not(:last-child) {
	margin-right: 0.5rem;
}

.initialism {
	font-size: 0.875em;
	text-transform: uppercase;
}

.blockquote {
	margin-bottom: 1rem;
	font-size: 1.09375rem;
}
.blockquote > :last-child {
	margin-bottom: 0;
}

.blockquote-footer {
	margin-top: -1rem;
	margin-bottom: 1rem;
	font-size: 0.875em;
	color: #6c757d;
}
.blockquote-footer::before {
	content: '\\2014\\00A0';
}

.img-fluid {
	max-width: 100%;
	height: auto;
}

.img-thumbnail {
	padding: 0.25rem;
	background-color: #e6ebee;
	border: 1px solid #dee2e6;
	border-radius: 0.625rem;
	max-width: 100%;
	height: auto;
}

.figure {
	display: inline-block;
}

.figure-img {
	margin-bottom: 0.5rem;
	line-height: 1;
}

.figure-caption {
	font-size: 0.875em;
	color: #6c757d;
}

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
	width: 100%;
	padding-right: var(--bs-gutter-x, 15px);
	padding-left: var(--bs-gutter-x, 15px);
	margin-right: auto;
	margin-left: auto;
}

@media (min-width: 576px) {
	.container,
	.container-sm {
		max-width: 540px;
	}
}

@media (min-width: 768px) {
	.container,
	.container-sm,
	.container-md {
		max-width: 720px;
	}
}

@media (min-width: 992px) {
	.container,
	.container-sm,
	.container-md,
	.container-lg {
		max-width: 960px;
	}
}

@media (min-width: 1200px) {
	.container,
	.container-sm,
	.container-md,
	.container-lg,
	.container-xl {
		max-width: 1140px;
	}
}

@media (min-width: 1440) {
	.container,
	.container-sm,
	.container-md,
	.container-lg,
	.container-xl,
	.container-xxl {
		max-width: 1320px;
	}
}

.row {
	--bs-gutter-x: 30px;
	--bs-gutter-y: 0;
	display: flex;
	flex-wrap: wrap;
	margin-top: calc(-1 * var(--bs-gutter-y));
	margin-right: calc(-0.5 * var(--bs-gutter-x));
	margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
	flex-shrink: 0;
	width: 100%;
	max-width: 100%;
	padding-right: calc(var(--bs-gutter-x) * 0.5);
	padding-left: calc(var(--bs-gutter-x) * 0.5);
	margin-top: var(--bs-gutter-y);
}

.col {
	flex: 1 0;
}

.row-cols-auto > * {
	flex: 0 0 auto;
	width: auto;
}

.row-cols-1 > * {
	flex: 0 0 auto;
	width: 100%;
}

.row-cols-2 > * {
	flex: 0 0 auto;
	width: 50%;
}

.row-cols-3 > * {
	flex: 0 0 auto;
	width: 33.33333%;
}

.row-cols-4 > * {
	flex: 0 0 auto;
	width: 25%;
}

.row-cols-5 > * {
	flex: 0 0 auto;
	width: 20%;
}

.row-cols-6 > * {
	flex: 0 0 auto;
	width: 16.66667%;
}

.col-auto {
	flex: 0 0 auto;
	width: auto;
}

.col-1 {
	flex: 0 0 auto;
	width: 8.33333%;
}

.col-2 {
	flex: 0 0 auto;
	width: 16.66667%;
}

.col-3 {
	flex: 0 0 auto;
	width: 25%;
}

.col-4 {
	flex: 0 0 auto;
	width: 33.33333%;
}

.col-5 {
	flex: 0 0 auto;
	width: 41.66667%;
}

.col-6 {
	flex: 0 0 auto;
	width: 50%;
}

.col-7 {
	flex: 0 0 auto;
	width: 58.33333%;
}

.col-8 {
	flex: 0 0 auto;
	width: 66.66667%;
}

.col-9 {
	flex: 0 0 auto;
	width: 75%;
}

.col-10 {
	flex: 0 0 auto;
	width: 83.33333%;
}

.col-11 {
	flex: 0 0 auto;
	width: 91.66667%;
}

.col-12 {
	flex: 0 0 auto;
	width: 100%;
}

.offset-1 {
	margin-left: 8.33333%;
}

.offset-2 {
	margin-left: 16.66667%;
}

.offset-3 {
	margin-left: 25%;
}

.offset-4 {
	margin-left: 33.33333%;
}

.offset-5 {
	margin-left: 41.66667%;
}

.offset-6 {
	margin-left: 50%;
}

.offset-7 {
	margin-left: 58.33333%;
}

.offset-8 {
	margin-left: 66.66667%;
}

.offset-9 {
	margin-left: 75%;
}

.offset-10 {
	margin-left: 83.33333%;
}

.offset-11 {
	margin-left: 91.66667%;
}

.g-0,
.gx-0 {
	--bs-gutter-x: 0;
}

.g-0,
.gy-0 {
	--bs-gutter-y: 0;
}

.g-1,
.gx-1 {
	--bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
	--bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
	--bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
	--bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
	--bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
	--bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
	--bs-gutter-x: 1.875rem;
}

.g-4,
.gy-4 {
	--bs-gutter-y: 1.875rem;
}

.g-5,
.gx-5 {
	--bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
	--bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
	.col-sm {
		flex: 1 0;
	}
	.row-cols-sm-auto > * {
		flex: 0 0 auto;
		width: auto;
	}
	.row-cols-sm-1 > * {
		flex: 0 0 auto;
		width: 100%;
	}
	.row-cols-sm-2 > * {
		flex: 0 0 auto;
		width: 50%;
	}
	.row-cols-sm-3 > * {
		flex: 0 0 auto;
		width: 33.33333%;
	}
	.row-cols-sm-4 > * {
		flex: 0 0 auto;
		width: 25%;
	}
	.row-cols-sm-5 > * {
		flex: 0 0 auto;
		width: 20%;
	}
	.row-cols-sm-6 > * {
		flex: 0 0 auto;
		width: 16.66667%;
	}
	.col-sm-auto {
		flex: 0 0 auto;
		width: auto;
	}
	.col-sm-1 {
		flex: 0 0 auto;
		width: 8.33333%;
	}
	.col-sm-2 {
		flex: 0 0 auto;
		width: 16.66667%;
	}
	.col-sm-3 {
		flex: 0 0 auto;
		width: 25%;
	}
	.col-sm-4 {
		flex: 0 0 auto;
		width: 33.33333%;
	}
	.col-sm-5 {
		flex: 0 0 auto;
		width: 41.66667%;
	}
	.col-sm-6 {
		flex: 0 0 auto;
		width: 50%;
	}
	.col-sm-7 {
		flex: 0 0 auto;
		width: 58.33333%;
	}
	.col-sm-8 {
		flex: 0 0 auto;
		width: 66.66667%;
	}
	.col-sm-9 {
		flex: 0 0 auto;
		width: 75%;
	}
	.col-sm-10 {
		flex: 0 0 auto;
		width: 83.33333%;
	}
	.col-sm-11 {
		flex: 0 0 auto;
		width: 91.66667%;
	}
	.col-sm-12 {
		flex: 0 0 auto;
		width: 100%;
	}
	.offset-sm-0 {
		margin-left: 0;
	}
	.offset-sm-1 {
		margin-left: 8.33333%;
	}
	.offset-sm-2 {
		margin-left: 16.66667%;
	}
	.offset-sm-3 {
		margin-left: 25%;
	}
	.offset-sm-4 {
		margin-left: 33.33333%;
	}
	.offset-sm-5 {
		margin-left: 41.66667%;
	}
	.offset-sm-6 {
		margin-left: 50%;
	}
	.offset-sm-7 {
		margin-left: 58.33333%;
	}
	.offset-sm-8 {
		margin-left: 66.66667%;
	}
	.offset-sm-9 {
		margin-left: 75%;
	}
	.offset-sm-10 {
		margin-left: 83.33333%;
	}
	.offset-sm-11 {
		margin-left: 91.66667%;
	}
	.g-sm-0,
	.gx-sm-0 {
		--bs-gutter-x: 0;
	}
	.g-sm-0,
	.gy-sm-0 {
		--bs-gutter-y: 0;
	}
	.g-sm-1,
	.gx-sm-1 {
		--bs-gutter-x: 0.25rem;
	}
	.g-sm-1,
	.gy-sm-1 {
		--bs-gutter-y: 0.25rem;
	}
	.g-sm-2,
	.gx-sm-2 {
		--bs-gutter-x: 0.5rem;
	}
	.g-sm-2,
	.gy-sm-2 {
		--bs-gutter-y: 0.5rem;
	}
	.g-sm-3,
	.gx-sm-3 {
		--bs-gutter-x: 1rem;
	}
	.g-sm-3,
	.gy-sm-3 {
		--bs-gutter-y: 1rem;
	}
	.g-sm-4,
	.gx-sm-4 {
		--bs-gutter-x: 1.875rem;
	}
	.g-sm-4,
	.gy-sm-4 {
		--bs-gutter-y: 1.875rem;
	}
	.g-sm-5,
	.gx-sm-5 {
		--bs-gutter-x: 3rem;
	}
	.g-sm-5,
	.gy-sm-5 {
		--bs-gutter-y: 3rem;
	}
}

@media (min-width: 768px) {
	.col-md {
		flex: 1 0;
	}
	.row-cols-md-auto > * {
		flex: 0 0 auto;
		width: auto;
	}
	.row-cols-md-1 > * {
		flex: 0 0 auto;
		width: 100%;
	}
	.row-cols-md-2 > * {
		flex: 0 0 auto;
		width: 50%;
	}
	.row-cols-md-3 > * {
		flex: 0 0 auto;
		width: 33.33333%;
	}
	.row-cols-md-4 > * {
		flex: 0 0 auto;
		width: 25%;
	}
	.row-cols-md-5 > * {
		flex: 0 0 auto;
		width: 20%;
	}
	.row-cols-md-6 > * {
		flex: 0 0 auto;
		width: 16.66667%;
	}
	.col-md-auto {
		flex: 0 0 auto;
		width: auto;
	}
	.col-md-1 {
		flex: 0 0 auto;
		width: 8.33333%;
	}
	.col-md-2 {
		flex: 0 0 auto;
		width: 16.66667%;
	}
	.col-md-3 {
		flex: 0 0 auto;
		width: 25%;
	}
	.col-md-4 {
		flex: 0 0 auto;
		width: 33.33333%;
	}
	.col-md-5 {
		flex: 0 0 auto;
		width: 41.66667%;
	}
	.col-md-6 {
		flex: 0 0 auto;
		width: 50%;
	}
	.col-md-7 {
		flex: 0 0 auto;
		width: 58.33333%;
	}
	.col-md-8 {
		flex: 0 0 auto;
		width: 66.66667%;
	}
	.col-md-9 {
		flex: 0 0 auto;
		width: 75%;
	}
	.col-md-10 {
		flex: 0 0 auto;
		width: 83.33333%;
	}
	.col-md-11 {
		flex: 0 0 auto;
		width: 91.66667%;
	}
	.col-md-12 {
		flex: 0 0 auto;
		width: 100%;
	}
	.offset-md-0 {
		margin-left: 0;
	}
	.offset-md-1 {
		margin-left: 8.33333%;
	}
	.offset-md-2 {
		margin-left: 16.66667%;
	}
	.offset-md-3 {
		margin-left: 25%;
	}
	.offset-md-4 {
		margin-left: 33.33333%;
	}
	.offset-md-5 {
		margin-left: 41.66667%;
	}
	.offset-md-6 {
		margin-left: 50%;
	}
	.offset-md-7 {
		margin-left: 58.33333%;
	}
	.offset-md-8 {
		margin-left: 66.66667%;
	}
	.offset-md-9 {
		margin-left: 75%;
	}
	.offset-md-10 {
		margin-left: 83.33333%;
	}
	.offset-md-11 {
		margin-left: 91.66667%;
	}
	.g-md-0,
	.gx-md-0 {
		--bs-gutter-x: 0;
	}
	.g-md-0,
	.gy-md-0 {
		--bs-gutter-y: 0;
	}
	.g-md-1,
	.gx-md-1 {
		--bs-gutter-x: 0.25rem;
	}
	.g-md-1,
	.gy-md-1 {
		--bs-gutter-y: 0.25rem;
	}
	.g-md-2,
	.gx-md-2 {
		--bs-gutter-x: 0.5rem;
	}
	.g-md-2,
	.gy-md-2 {
		--bs-gutter-y: 0.5rem;
	}
	.g-md-3,
	.gx-md-3 {
		--bs-gutter-x: 1rem;
	}
	.g-md-3,
	.gy-md-3 {
		--bs-gutter-y: 1rem;
	}
	.g-md-4,
	.gx-md-4 {
		--bs-gutter-x: 1.875rem;
	}
	.g-md-4,
	.gy-md-4 {
		--bs-gutter-y: 1.875rem;
	}
	.g-md-5,
	.gx-md-5 {
		--bs-gutter-x: 3rem;
	}
	.g-md-5,
	.gy-md-5 {
		--bs-gutter-y: 3rem;
	}
}

@media (min-width: 992px) {
	.col-lg {
		flex: 1 0;
	}
	.row-cols-lg-auto > * {
		flex: 0 0 auto;
		width: auto;
	}
	.row-cols-lg-1 > * {
		flex: 0 0 auto;
		width: 100%;
	}
	.row-cols-lg-2 > * {
		flex: 0 0 auto;
		width: 50%;
	}
	.row-cols-lg-3 > * {
		flex: 0 0 auto;
		width: 33.33333%;
	}
	.row-cols-lg-4 > * {
		flex: 0 0 auto;
		width: 25%;
	}
	.row-cols-lg-5 > * {
		flex: 0 0 auto;
		width: 20%;
	}
	.row-cols-lg-6 > * {
		flex: 0 0 auto;
		width: 16.66667%;
	}
	.col-lg-auto {
		flex: 0 0 auto;
		width: auto;
	}
	.col-lg-1 {
		flex: 0 0 auto;
		width: 8.33333%;
	}
	.col-lg-2 {
		flex: 0 0 auto;
		width: 16.66667%;
	}
	.col-lg-3 {
		flex: 0 0 auto;
		width: 25%;
	}
	.col-lg-4 {
		flex: 0 0 auto;
		width: 33.33333%;
	}
	.col-lg-5 {
		flex: 0 0 auto;
		width: 41.66667%;
	}
	.col-lg-6 {
		flex: 0 0 auto;
		width: 50%;
	}
	.col-lg-7 {
		flex: 0 0 auto;
		width: 58.33333%;
	}
	.col-lg-8 {
		flex: 0 0 auto;
		width: 66.66667%;
	}
	.col-lg-9 {
		flex: 0 0 auto;
		width: 75%;
	}
	.col-lg-10 {
		flex: 0 0 auto;
		width: 83.33333%;
	}
	.col-lg-11 {
		flex: 0 0 auto;
		width: 91.66667%;
	}
	.col-lg-12 {
		flex: 0 0 auto;
		width: 100%;
	}
	.offset-lg-0 {
		margin-left: 0;
	}
	.offset-lg-1 {
		margin-left: 8.33333%;
	}
	.offset-lg-2 {
		margin-left: 16.66667%;
	}
	.offset-lg-3 {
		margin-left: 25%;
	}
	.offset-lg-4 {
		margin-left: 33.33333%;
	}
	.offset-lg-5 {
		margin-left: 41.66667%;
	}
	.offset-lg-6 {
		margin-left: 50%;
	}
	.offset-lg-7 {
		margin-left: 58.33333%;
	}
	.offset-lg-8 {
		margin-left: 66.66667%;
	}
	.offset-lg-9 {
		margin-left: 75%;
	}
	.offset-lg-10 {
		margin-left: 83.33333%;
	}
	.offset-lg-11 {
		margin-left: 91.66667%;
	}
	.g-lg-0,
	.gx-lg-0 {
		--bs-gutter-x: 0;
	}
	.g-lg-0,
	.gy-lg-0 {
		--bs-gutter-y: 0;
	}
	.g-lg-1,
	.gx-lg-1 {
		--bs-gutter-x: 0.25rem;
	}
	.g-lg-1,
	.gy-lg-1 {
		--bs-gutter-y: 0.25rem;
	}
	.g-lg-2,
	.gx-lg-2 {
		--bs-gutter-x: 0.5rem;
	}
	.g-lg-2,
	.gy-lg-2 {
		--bs-gutter-y: 0.5rem;
	}
	.g-lg-3,
	.gx-lg-3 {
		--bs-gutter-x: 1rem;
	}
	.g-lg-3,
	.gy-lg-3 {
		--bs-gutter-y: 1rem;
	}
	.g-lg-4,
	.gx-lg-4 {
		--bs-gutter-x: 1.875rem;
	}
	.g-lg-4,
	.gy-lg-4 {
		--bs-gutter-y: 1.875rem;
	}
	.g-lg-5,
	.gx-lg-5 {
		--bs-gutter-x: 3rem;
	}
	.g-lg-5,
	.gy-lg-5 {
		--bs-gutter-y: 3rem;
	}
}

@media (min-width: 1200px) {
	.col-xl {
		flex: 1 0;
	}
	.row-cols-xl-auto > * {
		flex: 0 0 auto;
		width: auto;
	}
	.row-cols-xl-1 > * {
		flex: 0 0 auto;
		width: 100%;
	}
	.row-cols-xl-2 > * {
		flex: 0 0 auto;
		width: 50%;
	}
	.row-cols-xl-3 > * {
		flex: 0 0 auto;
		width: 33.33333%;
	}
	.row-cols-xl-4 > * {
		flex: 0 0 auto;
		width: 25%;
	}
	.row-cols-xl-5 > * {
		flex: 0 0 auto;
		width: 20%;
	}
	.row-cols-xl-6 > * {
		flex: 0 0 auto;
		width: 16.66667%;
	}
	.col-xl-auto {
		flex: 0 0 auto;
		width: auto;
	}
	.col-xl-1 {
		flex: 0 0 auto;
		width: 8.33333%;
	}
	.col-xl-2 {
		flex: 0 0 auto;
		width: 16.66667%;
	}
	.col-xl-3 {
		flex: 0 0 auto;
		width: 25%;
	}
	.col-xl-4 {
		flex: 0 0 auto;
		width: 33.33333%;
	}
	.col-xl-5 {
		flex: 0 0 auto;
		width: 41.66667%;
	}
	.col-xl-6 {
		flex: 0 0 auto;
		width: 50%;
	}
	.col-xl-7 {
		flex: 0 0 auto;
		width: 58.33333%;
	}
	.col-xl-8 {
		flex: 0 0 auto;
		width: 66.66667%;
	}
	.col-xl-9 {
		flex: 0 0 auto;
		width: 75%;
	}
	.col-xl-10 {
		flex: 0 0 auto;
		width: 83.33333%;
	}
	.col-xl-11 {
		flex: 0 0 auto;
		width: 91.66667%;
	}
	.col-xl-12 {
		flex: 0 0 auto;
		width: 100%;
	}
	.offset-xl-0 {
		margin-left: 0;
	}
	.offset-xl-1 {
		margin-left: 8.33333%;
	}
	.offset-xl-2 {
		margin-left: 16.66667%;
	}
	.offset-xl-3 {
		margin-left: 25%;
	}
	.offset-xl-4 {
		margin-left: 33.33333%;
	}
	.offset-xl-5 {
		margin-left: 41.66667%;
	}
	.offset-xl-6 {
		margin-left: 50%;
	}
	.offset-xl-7 {
		margin-left: 58.33333%;
	}
	.offset-xl-8 {
		margin-left: 66.66667%;
	}
	.offset-xl-9 {
		margin-left: 75%;
	}
	.offset-xl-10 {
		margin-left: 83.33333%;
	}
	.offset-xl-11 {
		margin-left: 91.66667%;
	}
	.g-xl-0,
	.gx-xl-0 {
		--bs-gutter-x: 0;
	}
	.g-xl-0,
	.gy-xl-0 {
		--bs-gutter-y: 0;
	}
	.g-xl-1,
	.gx-xl-1 {
		--bs-gutter-x: 0.25rem;
	}
	.g-xl-1,
	.gy-xl-1 {
		--bs-gutter-y: 0.25rem;
	}
	.g-xl-2,
	.gx-xl-2 {
		--bs-gutter-x: 0.5rem;
	}
	.g-xl-2,
	.gy-xl-2 {
		--bs-gutter-y: 0.5rem;
	}
	.g-xl-3,
	.gx-xl-3 {
		--bs-gutter-x: 1rem;
	}
	.g-xl-3,
	.gy-xl-3 {
		--bs-gutter-y: 1rem;
	}
	.g-xl-4,
	.gx-xl-4 {
		--bs-gutter-x: 1.875rem;
	}
	.g-xl-4,
	.gy-xl-4 {
		--bs-gutter-y: 1.875rem;
	}
	.g-xl-5,
	.gx-xl-5 {
		--bs-gutter-x: 3rem;
	}
	.g-xl-5,
	.gy-xl-5 {
		--bs-gutter-y: 3rem;
	}
}

@media (min-width: 1440) {
	.col-xxl {
		flex: 1 0;
	}
	.row-cols-xxl-auto > * {
		flex: 0 0 auto;
		width: auto;
	}
	.row-cols-xxl-1 > * {
		flex: 0 0 auto;
		width: 100%;
	}
	.row-cols-xxl-2 > * {
		flex: 0 0 auto;
		width: 50%;
	}
	.row-cols-xxl-3 > * {
		flex: 0 0 auto;
		width: 33.33333%;
	}
	.row-cols-xxl-4 > * {
		flex: 0 0 auto;
		width: 25%;
	}
	.row-cols-xxl-5 > * {
		flex: 0 0 auto;
		width: 20%;
	}
	.row-cols-xxl-6 > * {
		flex: 0 0 auto;
		width: 16.66667%;
	}
	.col-xxl-auto {
		flex: 0 0 auto;
		width: auto;
	}
	.col-xxl-1 {
		flex: 0 0 auto;
		width: 8.33333%;
	}
	.col-xxl-2 {
		flex: 0 0 auto;
		width: 16.66667%;
	}
	.col-xxl-3 {
		flex: 0 0 auto;
		width: 25%;
	}
	.col-xxl-4 {
		flex: 0 0 auto;
		width: 33.33333%;
	}
	.col-xxl-5 {
		flex: 0 0 auto;
		width: 41.66667%;
	}
	.col-xxl-6 {
		flex: 0 0 auto;
		width: 50%;
	}
	.col-xxl-7 {
		flex: 0 0 auto;
		width: 58.33333%;
	}
	.col-xxl-8 {
		flex: 0 0 auto;
		width: 66.66667%;
	}
	.col-xxl-9 {
		flex: 0 0 auto;
		width: 75%;
	}
	.col-xxl-10 {
		flex: 0 0 auto;
		width: 83.33333%;
	}
	.col-xxl-11 {
		flex: 0 0 auto;
		width: 91.66667%;
	}
	.col-xxl-12 {
		flex: 0 0 auto;
		width: 100%;
	}
	.offset-xxl-0 {
		margin-left: 0;
	}
	.offset-xxl-1 {
		margin-left: 8.33333%;
	}
	.offset-xxl-2 {
		margin-left: 16.66667%;
	}
	.offset-xxl-3 {
		margin-left: 25%;
	}
	.offset-xxl-4 {
		margin-left: 33.33333%;
	}
	.offset-xxl-5 {
		margin-left: 41.66667%;
	}
	.offset-xxl-6 {
		margin-left: 50%;
	}
	.offset-xxl-7 {
		margin-left: 58.33333%;
	}
	.offset-xxl-8 {
		margin-left: 66.66667%;
	}
	.offset-xxl-9 {
		margin-left: 75%;
	}
	.offset-xxl-10 {
		margin-left: 83.33333%;
	}
	.offset-xxl-11 {
		margin-left: 91.66667%;
	}
	.g-xxl-0,
	.gx-xxl-0 {
		--bs-gutter-x: 0;
	}
	.g-xxl-0,
	.gy-xxl-0 {
		--bs-gutter-y: 0;
	}
	.g-xxl-1,
	.gx-xxl-1 {
		--bs-gutter-x: 0.25rem;
	}
	.g-xxl-1,
	.gy-xxl-1 {
		--bs-gutter-y: 0.25rem;
	}
	.g-xxl-2,
	.gx-xxl-2 {
		--bs-gutter-x: 0.5rem;
	}
	.g-xxl-2,
	.gy-xxl-2 {
		--bs-gutter-y: 0.5rem;
	}
	.g-xxl-3,
	.gx-xxl-3 {
		--bs-gutter-x: 1rem;
	}
	.g-xxl-3,
	.gy-xxl-3 {
		--bs-gutter-y: 1rem;
	}
	.g-xxl-4,
	.gx-xxl-4 {
		--bs-gutter-x: 1.875rem;
	}
	.g-xxl-4,
	.gy-xxl-4 {
		--bs-gutter-y: 1.875rem;
	}
	.g-xxl-5,
	.gx-xxl-5 {
		--bs-gutter-x: 3rem;
	}
	.g-xxl-5,
	.gy-xxl-5 {
		--bs-gutter-y: 3rem;
	}
}

.table {
	--bs-table-bg: transparent;
	--bs-table-accent-bg: transparent;
	--bs-table-striped-color: #a098ae;
	--bs-table-striped-bg: rgba(0, 0, 0, 0.05);
	--bs-table-active-color: #a098ae;
	--bs-table-active-bg: rgba(0, 0, 0, 0.1);
	--bs-table-hover-color: #a098ae;
	--bs-table-hover-bg: rgba(0, 0, 0, 0.075);
	width: 100%;
	margin-bottom: 1rem;
	color: #a098ae;
	vertical-align: top;
	border-color: #eeeeee;
}
.table > :not(caption) > * > * {
	padding: 0.5rem 0.5rem;
	background-color: var(--bs-table-bg);
	border-bottom-width: 1px;
	box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}
.table > tbody {
	vertical-align: inherit;
}
.table > thead {
	vertical-align: bottom;
}
.table > :not(:first-child) {
	border-top: 2px solid currentColor;
}

.caption-top {
	caption-side: top;
}

.table-sm > :not(caption) > * > * {
	padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
	border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
	border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
	border-bottom-width: 0;
}

.table-borderless > :not(:first-child) {
	border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
	--bs-table-accent-bg: var(--bs-table-striped-bg);
	color: var(--bs-table-striped-color);
}

.table-active {
	--bs-table-accent-bg: var(--bs-table-active-bg);
	color: var(--bs-table-active-color);
}

.table-hover > tbody > tr:hover > * {
	--bs-table-accent-bg: var(--bs-table-hover-bg);
	color: var(--bs-table-hover-color);
}

.table-primary {
	--bs-table-bg: #dbdaf0;
	--bs-table-striped-bg: #d0cfe4;
	--bs-table-striped-color: #000;
	--bs-table-active-bg: #c5c4d8;
	--bs-table-active-color: #000;
	--bs-table-hover-bg: #cbcade;
	--bs-table-hover-color: #000;
	color: #000;
	border-color: #c5c4d8;
}

.table-secondary {
	--bs-table-bg: #fee5de;
	--bs-table-striped-bg: #f1dad3;
	--bs-table-striped-color: #000;
	--bs-table-active-bg: #e5cec8;
	--bs-table-active-color: #000;
	--bs-table-hover-bg: #ebd4cd;
	--bs-table-hover-color: #000;
	color: #000;
	border-color: #e5cec8;
}

.table-success {
	--bs-table-bg: #d2f1e0;
	--bs-table-striped-bg: #c8e5d5;
	--bs-table-striped-color: #000;
	--bs-table-active-bg: #bdd9ca;
	--bs-table-active-color: #000;
	--bs-table-hover-bg: #c2dfcf;
	--bs-table-hover-color: #000;
	color: #000;
	border-color: #bdd9ca;
}

.table-info {
	--bs-table-bg: #ccefed;
	--bs-table-striped-bg: #c2e3e1;
	--bs-table-striped-color: #000;
	--bs-table-active-bg: #b8d7d5;
	--bs-table-active-color: #000;
	--bs-table-hover-bg: #bddddb;
	--bs-table-hover-color: #000;
	color: #000;
	border-color: #b8d7d5;
}

.table-warning {
	--bs-table-bg: #fef3d8;
	--bs-table-striped-bg: #f1e7cd;
	--bs-table-striped-color: #000;
	--bs-table-active-bg: #e5dbc2;
	--bs-table-active-color: #000;
	--bs-table-hover-bg: #ebe1c8;
	--bs-table-hover-color: #000;
	color: #000;
	border-color: #e5dbc2;
}

.table-danger {
	--bs-table-bg: #ffdddd;
	--bs-table-striped-bg: #f2d2d2;
	--bs-table-striped-color: #000;
	--bs-table-active-bg: #e6c7c7;
	--bs-table-active-color: #000;
	--bs-table-hover-bg: #eccccc;
	--bs-table-hover-color: #000;
	color: #000;
	border-color: #e6c7c7;
}

.table-light {
	--bs-table-bg: #ebebf9;
	--bs-table-striped-bg: #dfdfed;
	--bs-table-striped-color: #000;
	--bs-table-active-bg: #d4d4e0;
	--bs-table-active-color: #000;
	--bs-table-hover-bg: #d9d9e6;
	--bs-table-hover-color: #000;
	color: #000;
	border-color: #d4d4e0;
}

.table-dark {
	--bs-table-bg: #303972;
	--bs-table-striped-bg: #3a4379;
	--bs-table-striped-color: #fff;
	--bs-table-active-bg: #454d80;
	--bs-table-active-color: #fff;
	--bs-table-hover-bg: #40487d;
	--bs-table-hover-color: #fff;
	color: #fff;
	border-color: #454d80;
}

.table-responsive {
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
	.table-responsive-sm {
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
	}
}

@media (max-width: 767.98px) {
	.table-responsive-md {
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
	}
}

@media (max-width: 991.98px) {
	.table-responsive-lg {
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
	}
}

@media (max-width: 1199.98px) {
	.table-responsive-xl {
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
	}
}

@media (max-width: 1439.98) {
	.table-responsive-xxl {
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
	}
}

.form-label {
	margin-bottom: 0.5rem;
}

.col-form-label {
	padding-top: calc(0.6875rem + 1px);
	padding-bottom: calc(0.6875rem + 1px);
	margin-bottom: 0;
	font-size: inherit;
	line-height: 1.5;
}

.col-form-label-lg {
	padding-top: calc(0.5rem + 1px);
	padding-bottom: calc(0.5rem + 1px);
	font-size: 1.09375rem;
}

.col-form-label-sm {
	padding-top: calc(0.25rem + 1px);
	padding-bottom: calc(0.25rem + 1px);
	font-size: 0.76563rem;
}
@media (min-width: 1200px) {
	.col-form-label-sm {
		font-size: 0.76562rem;
	}
}

.form-text {
	margin-top: 0.25rem;
	font-size: 0.875em;
	color: #89879f;
}

.form-control {
	display: block;
	width: 100%;
	padding: 0.6875rem 1.25rem;
	font-size: 0.875rem;
	font-weight: 400;
	line-height: 1.5;
	color: #a098ae;
	background-color: #e6ebee;
	background-clip: padding-box;
	border: 1px solid #f2f2f2;
	appearance: none;
	border-radius: 0.625rem;
	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
	.form-control {
		transition: none;
	}
}
.form-control[type='file'] {
	overflow: hidden;
}
.form-control[type='file']:not(:disabled):not([readonly]) {
	cursor: pointer;
}
.form-control:focus {
	color: #a098ae;
	background-color: #e6ebee;
	border-color: #a6a2da;
	outline: 0;
	box-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.25);
}
.form-control::-webkit-date-and-time-value {
	height: 1.5em;
}
.form-control::placeholder {
	color: #6c757d;
	opacity: 1;
}
.form-control:disabled,
.form-control[readonly] {
	background-color: #e9ecef;
	opacity: 1;
}
.form-control::file-selector-button {
	padding: 0.6875rem 1.25rem;
	margin: -0.6875rem -1.25rem;
	margin-inline-end: 1.25rem;
	color: #a098ae;
	background-color: #e9ecef;
	pointer-events: none;
	border-color: inherit;
	border-style: solid;
	border-width: 0;
	border-inline-end-width: 1px;
	border-radius: 0;
	transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
	.form-control::file-selector-button {
		transition: none;
	}
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
	background-color: #dde0e3;
}
.form-control::-webkit-file-upload-button {
	padding: 0.6875rem 1.25rem;
	margin: -0.6875rem -1.25rem;
	margin-inline-end: 1.25rem;
	color: #a098ae;
	background-color: #e9ecef;
	pointer-events: none;
	border-color: inherit;
	border-style: solid;
	border-width: 0;
	border-inline-end-width: 1px;
	border-radius: 0;
	-webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
	.form-control::-webkit-file-upload-button {
		-webkit-transition: none;
		transition: none;
	}
}
.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
	background-color: #dde0e3;
}

.form-control-plaintext {
	display: block;
	width: 100%;
	padding: 0.6875rem 0;
	margin-bottom: 0;
	line-height: 1.5;
	color: #a098ae;
	background-color: transparent;
	border: solid transparent;
	border-width: 1px 0;
}
.form-control-plaintext.form-control-sm,
.form-control-plaintext.form-control-lg {
	padding-right: 0;
	padding-left: 0;
}

.form-control-sm {
	min-height: calc(1.5em + 0.5rem + 2px);
	padding: 0.25rem 0.5rem;
	font-size: 0.76563rem;
	border-radius: 0.625rem;
}
@media (min-width: 1200px) {
	.form-control-sm {
		font-size: 0.76562rem;
	}
}
.form-control-sm::file-selector-button {
	padding: 0.25rem 0.5rem;
	margin: -0.25rem -0.5rem;
	margin-inline-end: 0.5rem;
}
.form-control-sm::-webkit-file-upload-button {
	padding: 0.25rem 0.5rem;
	margin: -0.25rem -0.5rem;
	margin-inline-end: 0.5rem;
}

.form-control-lg {
	min-height: calc(1.5em + 1rem + 2px);
	padding: 0.5rem 1rem;
	font-size: 1.09375rem;
	border-radius: 0.625rem;
}
.form-control-lg::file-selector-button {
	padding: 0.5rem 1rem;
	margin: -0.5rem -1rem;
	margin-inline-end: 1rem;
}
.form-control-lg::-webkit-file-upload-button {
	padding: 0.5rem 1rem;
	margin: -0.5rem -1rem;
	margin-inline-end: 1rem;
}

textarea.form-control {
	min-height: calc(1.5em + 1.375rem + 2px);
}

textarea.form-control-sm {
	min-height: calc(1.5em + 0.5rem + 2px);
}

textarea.form-control-lg {
	min-height: calc(1.5em + 1rem + 2px);
}

.form-control-color {
	width: 3rem;
	height: auto;
	padding: 0.6875rem;
}
.form-control-color:not(:disabled):not([readonly]) {
	cursor: pointer;
}
.form-control-color::-moz-color-swatch {
	height: 1.5em;
	border-radius: 0.625rem;
}
.form-control-color::-webkit-color-swatch {
	height: 1.5em;
	border-radius: 0.625rem;
}

.form-select {
	display: block;
	width: 100%;
	padding: 0.6875rem 3.75rem 0.6875rem 1.25rem;
	-moz-padding-start: calc(1.25rem - 3px);
	font-size: 0.875rem;
	font-weight: 400;
	line-height: 1.5;
	color: #a098ae;
	background-color: #e6ebee;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-position: right 1.25rem center;
	background-size: 16px 12px;
	border: 1px solid #f2f2f2;
	border-radius: 0.625rem;
	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	appearance: none;
}
@media (prefers-reduced-motion: reduce) {
	.form-select {
		transition: none;
	}
}
.form-select:focus {
	border-color: #a6a2da;
	outline: 0;
	box-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.25);
}
.form-select[multiple],
.form-select[size]:not([size='1']) {
	padding-right: 1.25rem;
	background-image: none;
}
.form-select:disabled {
	background-color: #e9ecef;
}
.form-select:-moz-focusring {
	color: transparent;
	text-shadow: 0 0 0 #a098ae;
}

.form-select-sm {
	padding-top: 0.25rem;
	padding-bottom: 0.25rem;
	padding-left: 0.5rem;
	font-size: 0.76563rem;
	border-radius: 0.625rem;
}
@media (min-width: 1200px) {
	.form-select-sm {
		font-size: 0.76562rem;
	}
}

.form-select-lg {
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
	padding-left: 1rem;
	font-size: 1.09375rem;
	border-radius: 0.625rem;
}

.form-check {
	display: block;
	min-height: 1.3125rem;
	padding-left: 1.5em;
	margin-bottom: 0.125rem;
}
.form-check .form-check-input {
	float: left;
	margin-left: -1.5em;
}

.form-check-input {
	width: 1em;
	height: 1em;
	margin-top: 0.25em;
	vertical-align: top;
	background-color: #e6ebee;
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
	border: 1px solid rgba(0, 0, 0, 0.25);
	appearance: none;
	-webkit-print-color-adjust: exact;
	        print-color-adjust: exact;
}
.form-check-input[type='checkbox'] {
	border-radius: 0.25em;
}
.form-check-input[type='radio'] {
	border-radius: 50%;
}
.form-check-input:active {
	filter: brightness(90%);
}
.form-check-input:focus {
	border-color: #a6a2da;
	outline: 0;
	box-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.25);
}
.form-check-input:checked {
	background-color: #4d44b5;
	border-color: #4d44b5;
}
.form-check-input:checked[type='checkbox'] {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.form-check-input:checked[type='radio'] {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input[type='checkbox']:indeterminate {
	background-color: #4d44b5;
	border-color: #4d44b5;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input:disabled {
	pointer-events: none;
	filter: none;
	opacity: 1;
}
.form-check-input[disabled] ~ .form-check-label,
.form-check-input:disabled ~ .form-check-label {
	opacity: 1;
}

.form-switch {
	padding-left: 2.5em;
}
.form-switch .form-check-input {
	width: 2.5em;
	margin-left: -2.5em;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
	/* background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e"); */
	background-position: left center;
	border-radius: 2em;
	transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
	.form-switch .form-check-input {
		transition: none;
	}
}
.form-switch .form-check-input:focus {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-switch .form-check-input:checked {
	background-position: right center;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.form-check-inline {
	display: inline-block;
	margin-right: 1rem;
}

.btn-check {
	position: absolute;
	clip: rect(0, 0, 0, 0);
	pointer-events: none;
}
.btn-check[disabled] + .btn,
.btn-check:disabled + .btn {
	pointer-events: none;
	filter: none;
	opacity: 0.65;
}

.form-range {
	width: 100%;
	height: 1.5rem;
	padding: 0;
	background-color: transparent;
	appearance: none;
}
.form-range:focus {
	outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
	box-shadow: 0 0 0 1px #e6ebee, 0 0 0 0.25rem rgba(77, 68, 181, 0.25);
}
.form-range:focus::-moz-range-thumb {
	box-shadow: 0 0 0 1px #e6ebee, 0 0 0 0.25rem rgba(77, 68, 181, 0.25);
}
.form-range::-moz-focus-outer {
	border: 0;
}
.form-range::-webkit-slider-thumb {
	width: 1rem;
	height: 1rem;
	margin-top: -0.25rem;
	background-color: #4d44b5;
	border: 0;
	border-radius: 1rem;
	-webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	appearance: none;
}
@media (prefers-reduced-motion: reduce) {
	.form-range::-webkit-slider-thumb {
		-webkit-transition: none;
		transition: none;
	}
}
.form-range::-webkit-slider-thumb:active {
	background-color: #cac7e9;
}
.form-range::-webkit-slider-runnable-track {
	width: 100%;
	height: 0.5rem;
	color: transparent;
	cursor: pointer;
	background-color: #dee2e6;
	border-color: transparent;
	border-radius: 1rem;
}
.form-range::-moz-range-thumb {
	width: 1rem;
	height: 1rem;
	background-color: #4d44b5;
	border: 0;
	border-radius: 1rem;
	-moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	appearance: none;
}
@media (prefers-reduced-motion: reduce) {
	.form-range::-moz-range-thumb {
		-moz-transition: none;
		transition: none;
	}
}
.form-range::-moz-range-thumb:active {
	background-color: #cac7e9;
}
.form-range::-moz-range-track {
	width: 100%;
	height: 0.5rem;
	color: transparent;
	cursor: pointer;
	background-color: #dee2e6;
	border-color: transparent;
	border-radius: 1rem;
}
.form-range:disabled {
	pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
	background-color: #adb5bd;
}
.form-range:disabled::-moz-range-thumb {
	background-color: #adb5bd;
}

.form-floating {
	position: relative;
}
.form-floating > .form-control,
.form-floating > .form-select {
	height: calc(3.5rem + 2px);
	line-height: 1.25;
}
.form-floating > label {
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	padding: 1rem 1.25rem;
	pointer-events: none;
	border: 1px solid transparent;
	transform-origin: 0 0;
	transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
	.form-floating > label {
		transition: none;
	}
}
.form-floating > .form-control {
	padding: 1rem 1.25rem;
}
.form-floating > .form-control::placeholder {
	color: transparent;
}
.form-floating > .form-control:focus,
.form-floating > .form-control:not(:placeholder-shown) {
	padding-top: 1.625rem;
	padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill {
	padding-top: 1.625rem;
	padding-bottom: 0.625rem;
}
.form-floating > .form-select {
	padding-top: 1.625rem;
	padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
	opacity: 0.65;
	transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
	opacity: 0.65;
	transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}

.input-group {
	position: relative;
	display: flex;
	flex-wrap: wrap;
	align-items: stretch;
	width: 100%;
}
.input-group > .form-control,
.input-group > .form-select {
	position: relative;
	flex: 1 1 auto;
	width: 1%;
	min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus {
	z-index: 3;
}
.input-group .btn {
	position: relative;
	z-index: 2;
}
.input-group .btn:focus {
	z-index: 3;
}

.input-group-text {
	display: flex;
	align-items: center;
	padding: 0.6875rem 1.25rem;
	font-size: 0.875rem;
	font-weight: 400;
	line-height: 1.5;
	color: #a098ae;
	text-align: center;
	white-space: nowrap;
	background-color: #e9ecef;
	border: 1px solid #f2f2f2;
	border-radius: 0.625rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
	padding: 0.5rem 1rem;
	font-size: 1.09375rem;
	border-radius: 0.625rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
	padding: 0.25rem 0.5rem;
	font-size: 0.76563rem;
	border-radius: 0.625rem;
}
@media (min-width: 1200px) {
	.input-group-sm > .form-control,
	.input-group-sm > .form-select,
	.input-group-sm > .input-group-text,
	.input-group-sm > .btn {
		font-size: 0.76562rem;
	}
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
	padding-right: 5rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3) {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}

.input-group.has-validation > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4) {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}

.input-group
	> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
	margin-left: -1px;
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}

.valid-feedback {
	display: none;
	width: 100%;
	margin-top: 0.25rem;
	font-size: 0.875em;
	color: #1eba62;
}

.valid-tooltip {
	position: absolute;
	top: 100%;
	z-index: 5;
	display: none;
	max-width: 100%;
	padding: 0.25rem 0.5rem;
	margin-top: 0.1rem;
	font-size: 0.76563rem;
	color: #000;
	background-color: rgba(30, 186, 98, 0.9);
	border-radius: 0.625rem;
}
@media (min-width: 1200px) {
	.valid-tooltip {
		font-size: 0.76562rem;
	}
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
	display: block;
}

.was-validated .form-control:valid,
.form-control.is-valid {
	border-color: #1eba62;
	padding-right: calc(1.5em + 1.375rem);
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
	background-repeat: no-repeat;
	background-position: right calc(0.375em + 0.34375rem) center;
	background-size: calc(0.75em + 0.6875rem) calc(0.75em + 0.6875rem);
}
.was-validated .form-control:valid:focus,
.form-control.is-valid:focus {
	border-color: #1eba62;
	box-shadow: 0 0 0 0.25rem rgba(30, 186, 98, 0.25);
}

.was-validated textarea.form-control:valid,
textarea.form-control.is-valid {
	padding-right: calc(1.5em + 1.375rem);
	background-position: top calc(0.375em + 0.34375rem) right calc(0.375em + 0.34375rem);
}

.was-validated .form-select:valid,
.form-select.is-valid {
	border-color: #1eba62;
}
.was-validated .form-select:valid:not([multiple]):not([size]),
.was-validated .form-select:valid:not([multiple])[size='1'],
.form-select.is-valid:not([multiple]):not([size]),
.form-select.is-valid:not([multiple])[size='1'] {
	padding-right: 6.875rem;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
		url(${___CSS_LOADER_URL_REPLACEMENT_6___});
	background-position: right 1.25rem center, center right 3.75rem;
	background-size: 16px 12px, calc(0.75em + 0.6875rem) calc(0.75em + 0.6875rem);
}
.was-validated .form-select:valid:focus,
.form-select.is-valid:focus {
	border-color: #1eba62;
	box-shadow: 0 0 0 0.25rem rgba(30, 186, 98, 0.25);
}

.was-validated .form-check-input:valid,
.form-check-input.is-valid {
	border-color: #1eba62;
}
.was-validated .form-check-input:valid:checked,
.form-check-input.is-valid:checked {
	background-color: #1eba62;
}
.was-validated .form-check-input:valid:focus,
.form-check-input.is-valid:focus {
	box-shadow: 0 0 0 0.25rem rgba(30, 186, 98, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label,
.form-check-input.is-valid ~ .form-check-label {
	color: #1eba62;
}

.form-check-inline .form-check-input ~ .valid-feedback {
	margin-left: 0.5em;
}

.was-validated .input-group .form-control:valid,
.input-group .form-control.is-valid,
.was-validated .input-group .form-select:valid,
.input-group .form-select.is-valid {
	z-index: 1;
}
.was-validated .input-group .form-control:valid:focus,
.input-group .form-control.is-valid:focus,
.was-validated .input-group .form-select:valid:focus,
.input-group .form-select.is-valid:focus {
	z-index: 3;
}

.invalid-feedback {
	display: none;
	width: 100%;
	margin-top: 0.25rem;
	font-size: 0.875em;
	color: #fd5353;
}

.invalid-tooltip {
	position: absolute;
	top: 100%;
	z-index: 5;
	display: none;
	max-width: 100%;
	padding: 0.25rem 0.5rem;
	margin-top: 0.1rem;
	font-size: 0.76563rem;
	color: #000;
	background-color: rgba(253, 83, 83, 0.9);
	border-radius: 0.625rem;
}
@media (min-width: 1200px) {
	.invalid-tooltip {
		font-size: 0.76562rem;
	}
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
	display: block;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
	border-color: #fd5353;
	padding-right: calc(1.5em + 1.375rem);
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
	background-repeat: no-repeat;
	background-position: right calc(0.375em + 0.34375rem) center;
	background-size: calc(0.75em + 0.6875rem) calc(0.75em + 0.6875rem);
}
.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus {
	border-color: #fd5353;
	box-shadow: 0 0 0 0.25rem rgba(253, 83, 83, 0.25);
}

.was-validated textarea.form-control:invalid,
textarea.form-control.is-invalid {
	padding-right: calc(1.5em + 1.375rem);
	background-position: top calc(0.375em + 0.34375rem) right calc(0.375em + 0.34375rem);
}

.was-validated .form-select:invalid,
.form-select.is-invalid {
	border-color: #fd5353;
}
.was-validated .form-select:invalid:not([multiple]):not([size]),
.was-validated .form-select:invalid:not([multiple])[size='1'],
.form-select.is-invalid:not([multiple]):not([size]),
.form-select.is-invalid:not([multiple])[size='1'] {
	padding-right: 6.875rem;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}),
		url(${___CSS_LOADER_URL_REPLACEMENT_7___});
	background-position: right 1.25rem center, center right 3.75rem;
	background-size: 16px 12px, calc(0.75em + 0.6875rem) calc(0.75em + 0.6875rem);
}
.was-validated .form-select:invalid:focus,
.form-select.is-invalid:focus {
	border-color: #fd5353;
	box-shadow: 0 0 0 0.25rem rgba(253, 83, 83, 0.25);
}

.was-validated .form-check-input:invalid,
.form-check-input.is-invalid {
	border-color: #fd5353;
}
.was-validated .form-check-input:invalid:checked,
.form-check-input.is-invalid:checked {
	background-color: #fd5353;
}
.was-validated .form-check-input:invalid:focus,
.form-check-input.is-invalid:focus {
	box-shadow: 0 0 0 0.25rem rgba(253, 83, 83, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label,
.form-check-input.is-invalid ~ .form-check-label {
	color: #fd5353;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
	margin-left: 0.5em;
}

.was-validated .input-group .form-control:invalid,
.input-group .form-control.is-invalid,
.was-validated .input-group .form-select:invalid,
.input-group .form-select.is-invalid {
	z-index: 2;
}
.was-validated .input-group .form-control:invalid:focus,
.input-group .form-control.is-invalid:focus,
.was-validated .input-group .form-select:invalid:focus,
.input-group .form-select.is-invalid:focus {
	z-index: 3;
}

.btn {
	display: inline-block;
	font-weight: 400;
	line-height: 1.5;
	color: #a098ae;
	text-align: center;
	text-decoration: none;
	vertical-align: middle;
	cursor: pointer;
	-webkit-user-select: none;
	        user-select: none;
	background-color: transparent;
	border: 1px solid transparent;
	padding: 0.375rem 0.75rem;
	font-size: 0.875rem;
	border-radius: 0.625rem;
	transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
	.btn {
		transition: none;
	}
}
.btn:hover {
	color: #a098ae;
}
.btn-check:focus + .btn,
.btn:focus {
	outline: 0;
	box-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.25);
}
.btn:disabled,
.btn.disabled,
fieldset:disabled .btn {
	pointer-events: none;
	opacity: 0.65;
}

.btn-primary {
	color: #fff;
	background-color: #4d44b5;
	border-color: #4d44b5;
}
.btn-primary:hover {
	color: #fff;
	background-color: #413a9a;
	border-color: #3e3691;
}
.btn-check:focus + .btn-primary,
.btn-primary:focus {
	color: #fff;
	background-color: #413a9a;
	border-color: #3e3691;
	box-shadow: 0 0 0 0.25rem rgba(104, 96, 192, 0.5);
}
.btn-check:checked + .btn-primary,
.btn-check:active + .btn-primary,
.btn-primary:active,
.btn-primary.active,
.show > .btn-primary.dropdown-toggle {
	color: #fff;
	background-color: #3e3691;
	border-color: #3a3388;
}
.btn-check:checked + .btn-primary:focus,
.btn-check:active + .btn-primary:focus,
.btn-primary:active:focus,
.btn-primary.active:focus,
.show > .btn-primary.dropdown-toggle:focus {
	box-shadow: 0 0 0 0.25rem rgba(104, 96, 192, 0.5);
}
.btn-primary:disabled,
.btn-primary.disabled {
	color: #fff;
	background-color: #4d44b5;
	border-color: #4d44b5;
}

.btn-secondary {
	color: #000;
	background-color: #fb7d5b;
	border-color: #fb7d5b;
}
.btn-secondary:hover {
	color: #000;
	background-color: #fc9174;
	border-color: #fb8a6b;
}
.btn-check:focus + .btn-secondary,
.btn-secondary:focus {
	color: #000;
	background-color: #fc9174;
	border-color: #fb8a6b;
	box-shadow: 0 0 0 0.25rem rgba(213, 106, 77, 0.5);
}
.btn-check:checked + .btn-secondary,
.btn-check:active + .btn-secondary,
.btn-secondary:active,
.btn-secondary.active,
.show > .btn-secondary.dropdown-toggle {
	color: #000;
	background-color: #fc977c;
	border-color: #fb8a6b;
}
.btn-check:checked + .btn-secondary:focus,
.btn-check:active + .btn-secondary:focus,
.btn-secondary:active:focus,
.btn-secondary.active:focus,
.show > .btn-secondary.dropdown-toggle:focus {
	box-shadow: 0 0 0 0.25rem rgba(213, 106, 77, 0.5);
}
.btn-secondary:disabled,
.btn-secondary.disabled {
	color: #000;
	background-color: #fb7d5b;
	border-color: #fb7d5b;
}

.btn-success {
	color: #000;
	background-color: #1eba62;
	border-color: #1eba62;
}
.btn-success:hover {
	color: #000;
	background-color: #40c47a;
	border-color: #35c172;
}
.btn-check:focus + .btn-success,
.btn-success:focus {
	color: #000;
	background-color: #40c47a;
	border-color: #35c172;
	box-shadow: 0 0 0 0.25rem rgba(26, 158, 83, 0.5);
}
.btn-check:checked + .btn-success,
.btn-check:active + .btn-success,
.btn-success:active,
.btn-success.active,
.show > .btn-success.dropdown-toggle {
	color: #000;
	background-color: #4bc881;
	border-color: #35c172;
}
.btn-check:checked + .btn-success:focus,
.btn-check:active + .btn-success:focus,
.btn-success:active:focus,
.btn-success.active:focus,
.show > .btn-success.dropdown-toggle:focus {
	box-shadow: 0 0 0 0.25rem rgba(26, 158, 83, 0.5);
}
.btn-success:disabled,
.btn-success.disabled {
	color: #000;
	background-color: #1eba62;
	border-color: #1eba62;
}

.btn-info {
	color: #000;
	background-color: #00ada3;
	border-color: #00ada3;
}
.btn-info:hover {
	color: #000;
	background-color: #26b9b1;
	border-color: #1ab5ac;
}
.btn-check:focus + .btn-info,
.btn-info:focus {
	color: #000;
	background-color: #26b9b1;
	border-color: #1ab5ac;
	box-shadow: 0 0 0 0.25rem rgba(0, 147, 139, 0.5);
}
.btn-check:checked + .btn-info,
.btn-check:active + .btn-info,
.btn-info:active,
.btn-info.active,
.show > .btn-info.dropdown-toggle {
	color: #000;
	background-color: #33bdb5;
	border-color: #1ab5ac;
}
.btn-check:checked + .btn-info:focus,
.btn-check:active + .btn-info:focus,
.btn-info:active:focus,
.btn-info.active:focus,
.show > .btn-info.dropdown-toggle:focus {
	box-shadow: 0 0 0 0.25rem rgba(0, 147, 139, 0.5);
}
.btn-info:disabled,
.btn-info.disabled {
	color: #000;
	background-color: #00ada3;
	border-color: #00ada3;
}

.btn-warning {
	color: #000;
	background-color: #fcc43e;
	border-color: #fcc43e;
}
.btn-warning:hover {
	color: #000;
	background-color: #fccd5b;
	border-color: #fcca51;
}
.btn-check:focus + .btn-warning,
.btn-warning:focus {
	color: #000;
	background-color: #fccd5b;
	border-color: #fcca51;
	box-shadow: 0 0 0 0.25rem rgba(214, 167, 53, 0.5);
}
.btn-check:checked + .btn-warning,
.btn-check:active + .btn-warning,
.btn-warning:active,
.btn-warning.active,
.show > .btn-warning.dropdown-toggle {
	color: #000;
	background-color: #fdd065;
	border-color: #fcca51;
}
.btn-check:checked + .btn-warning:focus,
.btn-check:active + .btn-warning:focus,
.btn-warning:active:focus,
.btn-warning.active:focus,
.show > .btn-warning.dropdown-toggle:focus {
	box-shadow: 0 0 0 0.25rem rgba(214, 167, 53, 0.5);
}
.btn-warning:disabled,
.btn-warning.disabled {
	color: #000;
	background-color: #fcc43e;
	border-color: #fcc43e;
}

.btn-danger {
	color: #000;
	background-color: #fd5353;
	border-color: #fd5353;
}
.btn-danger:hover {
	color: #000;
	background-color: #fd6d6d;
	border-color: #fd6464;
}
.btn-check:focus + .btn-danger,
.btn-danger:focus {
	color: #000;
	background-color: #fd6d6d;
	border-color: #fd6464;
	box-shadow: 0 0 0 0.25rem rgba(215, 71, 71, 0.5);
}
.btn-check:checked + .btn-danger,
.btn-check:active + .btn-danger,
.btn-danger:active,
.btn-danger.active,
.show > .btn-danger.dropdown-toggle {
	color: #000;
	background-color: #fd7575;
	border-color: #fd6464;
}
.btn-check:checked + .btn-danger:focus,
.btn-check:active + .btn-danger:focus,
.btn-danger:active:focus,
.btn-danger.active:focus,
.show > .btn-danger.dropdown-toggle:focus {
	box-shadow: 0 0 0 0.25rem rgba(215, 71, 71, 0.5);
}
.btn-danger:disabled,
.btn-danger.disabled {
	color: #000;
	background-color: #fd5353;
	border-color: #fd5353;
}

.btn-light {
	color: #000;
	background-color: #ebebf9;
	border-color: #ebebf9;
}
.btn-light:hover {
	color: #000;
	background-color: #eeeefa;
	border-color: #ededfa;
}
.btn-check:focus + .btn-light,
.btn-light:focus {
	color: #000;
	background-color: #eeeefa;
	border-color: #ededfa;
	box-shadow: 0 0 0 0.25rem rgba(200, 200, 212, 0.5);
}
.btn-check:checked + .btn-light,
.btn-check:active + .btn-light,
.btn-light:active,
.btn-light.active,
.show > .btn-light.dropdown-toggle {
	color: #000;
	background-color: #efeffa;
	border-color: #ededfa;
}
.btn-check:checked + .btn-light:focus,
.btn-check:active + .btn-light:focus,
.btn-light:active:focus,
.btn-light.active:focus,
.show > .btn-light.dropdown-toggle:focus {
	box-shadow: 0 0 0 0.25rem rgba(200, 200, 212, 0.5);
}
.btn-light:disabled,
.btn-light.disabled {
	color: #000;
	background-color: #ebebf9;
	border-color: #ebebf9;
}

.btn-dark {
	color: #fff;
	background-color: #303972;
	border-color: #303972;
}
.btn-dark:hover {
	color: #fff;
	background-color: #293061;
	border-color: #262e5b;
}
.btn-check:focus + .btn-dark,
.btn-dark:focus {
	color: #fff;
	background-color: #293061;
	border-color: #262e5b;
	box-shadow: 0 0 0 0.25rem rgba(79, 87, 135, 0.5);
}
.btn-check:checked + .btn-dark,
.btn-check:active + .btn-dark,
.btn-dark:active,
.btn-dark.active,
.show > .btn-dark.dropdown-toggle {
	color: #fff;
	background-color: #262e5b;
	border-color: #242b56;
}
.btn-check:checked + .btn-dark:focus,
.btn-check:active + .btn-dark:focus,
.btn-dark:active:focus,
.btn-dark.active:focus,
.show > .btn-dark.dropdown-toggle:focus {
	box-shadow: 0 0 0 0.25rem rgba(79, 87, 135, 0.5);
}
.btn-dark:disabled,
.btn-dark.disabled {
	color: #fff;
	background-color: #303972;
	border-color: #303972;
}

.btn-outline-primary {
	color: #4d44b5;
	border-color: #4d44b5;
}
.btn-outline-primary:hover {
	color: #fff;
	background-color: #4d44b5;
	border-color: #4d44b5;
}
.btn-check:focus + .btn-outline-primary,
.btn-outline-primary:focus {
	box-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.5);
}
.btn-check:checked + .btn-outline-primary,
.btn-check:active + .btn-outline-primary,
.btn-outline-primary:active,
.btn-outline-primary.active,
.btn-outline-primary.dropdown-toggle.show {
	color: #fff;
	background-color: #4d44b5;
	border-color: #4d44b5;
}
.btn-check:checked + .btn-outline-primary:focus,
.btn-check:active + .btn-outline-primary:focus,
.btn-outline-primary:active:focus,
.btn-outline-primary.active:focus,
.btn-outline-primary.dropdown-toggle.show:focus {
	box-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.5);
}
.btn-outline-primary:disabled,
.btn-outline-primary.disabled {
	color: #4d44b5;
	background-color: transparent;
}

.btn-outline-secondary {
	color: #fb7d5b;
	border-color: #fb7d5b;
}
.btn-outline-secondary:hover {
	color: #000;
	background-color: #fb7d5b;
	border-color: #fb7d5b;
}
.btn-check:focus + .btn-outline-secondary,
.btn-outline-secondary:focus {
	box-shadow: 0 0 0 0.25rem rgba(251, 125, 91, 0.5);
}
.btn-check:checked + .btn-outline-secondary,
.btn-check:active + .btn-outline-secondary,
.btn-outline-secondary:active,
.btn-outline-secondary.active,
.btn-outline-secondary.dropdown-toggle.show {
	color: #000;
	background-color: #fb7d5b;
	border-color: #fb7d5b;
}
.btn-check:checked + .btn-outline-secondary:focus,
.btn-check:active + .btn-outline-secondary:focus,
.btn-outline-secondary:active:focus,
.btn-outline-secondary.active:focus,
.btn-outline-secondary.dropdown-toggle.show:focus {
	box-shadow: 0 0 0 0.25rem rgba(251, 125, 91, 0.5);
}
.btn-outline-secondary:disabled,
.btn-outline-secondary.disabled {
	color: #fb7d5b;
	background-color: transparent;
}

.btn-outline-success {
	color: #1eba62;
	border-color: #1eba62;
}
.btn-outline-success:hover {
	color: #000;
	background-color: #1eba62;
	border-color: #1eba62;
}
.btn-check:focus + .btn-outline-success,
.btn-outline-success:focus {
	box-shadow: 0 0 0 0.25rem rgba(30, 186, 98, 0.5);
}
.btn-check:checked + .btn-outline-success,
.btn-check:active + .btn-outline-success,
.btn-outline-success:active,
.btn-outline-success.active,
.btn-outline-success.dropdown-toggle.show {
	color: #000;
	background-color: #1eba62;
	border-color: #1eba62;
}
.btn-check:checked + .btn-outline-success:focus,
.btn-check:active + .btn-outline-success:focus,
.btn-outline-success:active:focus,
.btn-outline-success.active:focus,
.btn-outline-success.dropdown-toggle.show:focus {
	box-shadow: 0 0 0 0.25rem rgba(30, 186, 98, 0.5);
}
.btn-outline-success:disabled,
.btn-outline-success.disabled {
	color: #1eba62;
	background-color: transparent;
}

.btn-outline-info {
	color: #00ada3;
	border-color: #00ada3;
}
.btn-outline-info:hover {
	color: #000;
	background-color: #00ada3;
	border-color: #00ada3;
}
.btn-check:focus + .btn-outline-info,
.btn-outline-info:focus {
	box-shadow: 0 0 0 0.25rem rgba(0, 173, 163, 0.5);
}
.btn-check:checked + .btn-outline-info,
.btn-check:active + .btn-outline-info,
.btn-outline-info:active,
.btn-outline-info.active,
.btn-outline-info.dropdown-toggle.show {
	color: #000;
	background-color: #00ada3;
	border-color: #00ada3;
}
.btn-check:checked + .btn-outline-info:focus,
.btn-check:active + .btn-outline-info:focus,
.btn-outline-info:active:focus,
.btn-outline-info.active:focus,
.btn-outline-info.dropdown-toggle.show:focus {
	box-shadow: 0 0 0 0.25rem rgba(0, 173, 163, 0.5);
}
.btn-outline-info:disabled,
.btn-outline-info.disabled {
	color: #00ada3;
	background-color: transparent;
}

.btn-outline-warning {
	color: #fcc43e;
	border-color: #fcc43e;
}
.btn-outline-warning:hover {
	color: #000;
	background-color: #fcc43e;
	border-color: #fcc43e;
}
.btn-check:focus + .btn-outline-warning,
.btn-outline-warning:focus {
	box-shadow: 0 0 0 0.25rem rgba(252, 196, 62, 0.5);
}
.btn-check:checked + .btn-outline-warning,
.btn-check:active + .btn-outline-warning,
.btn-outline-warning:active,
.btn-outline-warning.active,
.btn-outline-warning.dropdown-toggle.show {
	color: #000;
	background-color: #fcc43e;
	border-color: #fcc43e;
}
.btn-check:checked + .btn-outline-warning:focus,
.btn-check:active + .btn-outline-warning:focus,
.btn-outline-warning:active:focus,
.btn-outline-warning.active:focus,
.btn-outline-warning.dropdown-toggle.show:focus {
	box-shadow: 0 0 0 0.25rem rgba(252, 196, 62, 0.5);
}
.btn-outline-warning:disabled,
.btn-outline-warning.disabled {
	color: #fcc43e;
	background-color: transparent;
}

.btn-outline-danger {
	color: #fd5353;
	border-color: #fd5353;
}
.btn-outline-danger:hover {
	color: #000;
	background-color: #fd5353;
	border-color: #fd5353;
}
.btn-check:focus + .btn-outline-danger,
.btn-outline-danger:focus {
	box-shadow: 0 0 0 0.25rem rgba(253, 83, 83, 0.5);
}
.btn-check:checked + .btn-outline-danger,
.btn-check:active + .btn-outline-danger,
.btn-outline-danger:active,
.btn-outline-danger.active,
.btn-outline-danger.dropdown-toggle.show {
	color: #000;
	background-color: #fd5353;
	border-color: #fd5353;
}
.btn-check:checked + .btn-outline-danger:focus,
.btn-check:active + .btn-outline-danger:focus,
.btn-outline-danger:active:focus,
.btn-outline-danger.active:focus,
.btn-outline-danger.dropdown-toggle.show:focus {
	box-shadow: 0 0 0 0.25rem rgba(253, 83, 83, 0.5);
}
.btn-outline-danger:disabled,
.btn-outline-danger.disabled {
	color: #fd5353;
	background-color: transparent;
}

.btn-outline-light {
	color: #ebebf9;
	border-color: #ebebf9;
}
.btn-outline-light:hover {
	color: #000;
	background-color: #ebebf9;
	border-color: #ebebf9;
}
.btn-check:focus + .btn-outline-light,
.btn-outline-light:focus {
	box-shadow: 0 0 0 0.25rem rgba(235, 235, 249, 0.5);
}
.btn-check:checked + .btn-outline-light,
.btn-check:active + .btn-outline-light,
.btn-outline-light:active,
.btn-outline-light.active,
.btn-outline-light.dropdown-toggle.show {
	color: #000;
	background-color: #ebebf9;
	border-color: #ebebf9;
}
.btn-check:checked + .btn-outline-light:focus,
.btn-check:active + .btn-outline-light:focus,
.btn-outline-light:active:focus,
.btn-outline-light.active:focus,
.btn-outline-light.dropdown-toggle.show:focus {
	box-shadow: 0 0 0 0.25rem rgba(235, 235, 249, 0.5);
}
.btn-outline-light:disabled,
.btn-outline-light.disabled {
	color: #ebebf9;
	background-color: transparent;
}

.btn-outline-dark {
	color: #303972;
	border-color: #303972;
}
.btn-outline-dark:hover {
	color: #fff;
	background-color: #303972;
	border-color: #303972;
}
.btn-check:focus + .btn-outline-dark,
.btn-outline-dark:focus {
	box-shadow: 0 0 0 0.25rem rgba(48, 57, 114, 0.5);
}
.btn-check:checked + .btn-outline-dark,
.btn-check:active + .btn-outline-dark,
.btn-outline-dark:active,
.btn-outline-dark.active,
.btn-outline-dark.dropdown-toggle.show {
	color: #fff;
	background-color: #303972;
	border-color: #303972;
}
.btn-check:checked + .btn-outline-dark:focus,
.btn-check:active + .btn-outline-dark:focus,
.btn-outline-dark:active:focus,
.btn-outline-dark.active:focus,
.btn-outline-dark.dropdown-toggle.show:focus {
	box-shadow: 0 0 0 0.25rem rgba(48, 57, 114, 0.5);
}
.btn-outline-dark:disabled,
.btn-outline-dark.disabled {
	color: #303972;
	background-color: transparent;
}

.btn-link {
	font-weight: 400;
	color: #4d44b5;
	text-decoration: underline;
}
.btn-link:hover {
	color: #3e3691;
}
.btn-link:disabled,
.btn-link.disabled {
	color: #6c757d;
}

.btn-lg,
.btn-group-lg > .btn {
	padding: 0.5rem 1rem;
	font-size: 1.09375rem;
	border-radius: 0.625rem;
}

.btn-sm,
.btn-group-sm > .btn {
	padding: 0.25rem 0.5rem;
	font-size: 0.76563rem;
	border-radius: 0.625rem;
}
@media (min-width: 1200px) {
	.btn-sm,
	.btn-group-sm > .btn {
		font-size: 0.76562rem;
	}
}

.fade {
	transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
	.fade {
		transition: none;
	}
}
.fade:not(.show) {
	opacity: 0;
}

.collapse:not(.show) {
	display: none;
}

.collapsing {
	height: 0;
	overflow: hidden;
	transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
	.collapsing {
		transition: none;
	}
}
.collapsing.collapse-horizontal {
	width: 0;
	height: auto;
	transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
	.collapsing.collapse-horizontal {
		transition: none;
	}
}

.dropup,
.dropend,
.dropdown,
.dropstart {
	position: relative;
}

.dropdown-toggle {
	white-space: nowrap;
}
.dropdown-toggle::after {
	display: inline-block;
	margin-left: 0.255em;
	vertical-align: 0.255em;
	content: '';
	border-top: 0.3em solid;
	border-right: 0.3em solid transparent;
	border-bottom: 0;
	border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
	margin-left: 0;
}

.dropdown-menu {
	position: absolute;
	z-index: 1000;
	display: none;
	min-width: 10rem;
	padding: 0.5rem 0;
	margin: 0;
	font-size: 0.875rem;
	color: #a098ae;
	text-align: left;
	list-style: none;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid rgba(0, 0, 0, 0.15);
	border-radius: 0.625rem;
}
.dropdown-menu[data-bs-popper] {
	top: 100%;
	left: 0;
	margin-top: 0.125rem;
}

.dropdown-menu-start {
	--bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
	right: auto;
	left: 0;
}

.dropdown-menu-end {
	--bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
	right: 0;
	left: auto;
}

@media (min-width: 576px) {
	.dropdown-menu-sm-start {
		--bs-position: start;
	}
	.dropdown-menu-sm-start[data-bs-popper] {
		right: auto;
		left: 0;
	}
	.dropdown-menu-sm-end {
		--bs-position: end;
	}
	.dropdown-menu-sm-end[data-bs-popper] {
		right: 0;
		left: auto;
	}
}

@media (min-width: 768px) {
	.dropdown-menu-md-start {
		--bs-position: start;
	}
	.dropdown-menu-md-start[data-bs-popper] {
		right: auto;
		left: 0;
	}
	.dropdown-menu-md-end {
		--bs-position: end;
	}
	.dropdown-menu-md-end[data-bs-popper] {
		right: 0;
		left: auto;
	}
}

@media (min-width: 992px) {
	.dropdown-menu-lg-start {
		--bs-position: start;
	}
	.dropdown-menu-lg-start[data-bs-popper] {
		right: auto;
		left: 0;
	}
	.dropdown-menu-lg-end {
		--bs-position: end;
	}
	.dropdown-menu-lg-end[data-bs-popper] {
		right: 0;
		left: auto;
	}
}

@media (min-width: 1200px) {
	.dropdown-menu-xl-start {
		--bs-position: start;
	}
	.dropdown-menu-xl-start[data-bs-popper] {
		right: auto;
		left: 0;
	}
	.dropdown-menu-xl-end {
		--bs-position: end;
	}
	.dropdown-menu-xl-end[data-bs-popper] {
		right: 0;
		left: auto;
	}
}

@media (min-width: 1440) {
	.dropdown-menu-xxl-start {
		--bs-position: start;
	}
	.dropdown-menu-xxl-start[data-bs-popper] {
		right: auto;
		left: 0;
	}
	.dropdown-menu-xxl-end {
		--bs-position: end;
	}
	.dropdown-menu-xxl-end[data-bs-popper] {
		right: 0;
		left: auto;
	}
}

.dropup .dropdown-menu[data-bs-popper] {
	top: auto;
	bottom: 100%;
	margin-top: 0;
	margin-bottom: 0.125rem;
}

.dropup .dropdown-toggle::after {
	display: inline-block;
	margin-left: 0.255em;
	vertical-align: 0.255em;
	content: '';
	border-top: 0;
	border-right: 0.3em solid transparent;
	border-bottom: 0.3em solid;
	border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
	margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
	top: 0;
	right: auto;
	left: 100%;
	margin-top: 0;
	margin-left: 0.125rem;
}

.dropend .dropdown-toggle::after {
	display: inline-block;
	margin-left: 0.255em;
	vertical-align: 0.255em;
	content: '';
	border-top: 0.3em solid transparent;
	border-right: 0;
	border-bottom: 0.3em solid transparent;
	border-left: 0.3em solid;
}

.dropend .dropdown-toggle:empty::after {
	margin-left: 0;
}

.dropend .dropdown-toggle::after {
	vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
	top: 0;
	right: 100%;
	left: auto;
	margin-top: 0;
	margin-right: 0.125rem;
}

.dropstart .dropdown-toggle::after {
	display: inline-block;
	margin-left: 0.255em;
	vertical-align: 0.255em;
	content: '';
}

.dropstart .dropdown-toggle::after {
	display: none;
}

.dropstart .dropdown-toggle::before {
	display: inline-block;
	margin-right: 0.255em;
	vertical-align: 0.255em;
	content: '';
	border-top: 0.3em solid transparent;
	border-right: 0.3em solid;
	border-bottom: 0.3em solid transparent;
}

.dropstart .dropdown-toggle:empty::after {
	margin-left: 0;
}

.dropstart .dropdown-toggle::before {
	vertical-align: 0;
}

.dropdown-divider {
	height: 0;
	margin: 0.5rem 0;
	overflow: hidden;
	border-top: 1px solid rgba(0, 0, 0, 0.15);
}

.dropdown-item {
	display: block;
	width: 100%;
	padding: 0.25rem 1.25rem;
	clear: both;
	font-weight: 400;
	color: #212529;
	text-align: inherit;
	text-decoration: none;
	white-space: nowrap;
	background-color: transparent;
	border: 0;
}
.dropdown-item:hover,
.dropdown-item:focus {
	color: #1e2125;
	background-color: #e9ecef;
}
.dropdown-item.active,
.dropdown-item:active {
	color: #fff;
	text-decoration: none;
	background-color: #4d44b5;
}
.dropdown-item.disabled,
.dropdown-item:disabled {
	color: #adb5bd;
	pointer-events: none;
	background-color: transparent;
}

.dropdown-menu.show {
	display: block;
}

.dropdown-header {
	display: block;
	padding: 0.5rem 1.25rem;
	margin-bottom: 0;
	font-size: 0.76563rem;
	color: #6c757d;
	white-space: nowrap;
}
@media (min-width: 1200px) {
	.dropdown-header {
		font-size: 0.76562rem;
	}
}

.dropdown-item-text {
	display: block;
	padding: 0.25rem 1.25rem;
	color: #212529;
}

.dropdown-menu-dark {
	color: #dee2e6;
	background-color: #343a40;
	border-color: rgba(0, 0, 0, 0.15);
}
.dropdown-menu-dark .dropdown-item {
	color: #dee2e6;
}
.dropdown-menu-dark .dropdown-item:hover,
.dropdown-menu-dark .dropdown-item:focus {
	color: #fff;
	background-color: rgba(255, 255, 255, 0.15);
}
.dropdown-menu-dark .dropdown-item.active,
.dropdown-menu-dark .dropdown-item:active {
	color: #fff;
	background-color: #4d44b5;
}
.dropdown-menu-dark .dropdown-item.disabled,
.dropdown-menu-dark .dropdown-item:disabled {
	color: #adb5bd;
}
.dropdown-menu-dark .dropdown-divider {
	border-color: rgba(0, 0, 0, 0.15);
}
.dropdown-menu-dark .dropdown-item-text {
	color: #dee2e6;
}
.dropdown-menu-dark .dropdown-header {
	color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
	position: relative;
	display: inline-flex;
	vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
	position: relative;
	flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
	z-index: 1;
}

.btn-toolbar {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
}
.btn-toolbar .input-group {
	width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
	margin-left: -1px;
}

.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}

.btn-group > .btn:nth-child(n + 3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
	padding-right: 0.5625rem;
	padding-left: 0.5625rem;
}
.dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after,
.dropend .dropdown-toggle-split::after {
	margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
	margin-right: 0;
}

.btn-sm + .dropdown-toggle-split,
.btn-group-sm > .btn + .dropdown-toggle-split {
	padding-right: 0.375rem;
	padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split,
.btn-group-lg > .btn + .dropdown-toggle-split {
	padding-right: 0.75rem;
	padding-left: 0.75rem;
}

.btn-group-vertical {
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
	width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
	margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
	border-bottom-right-radius: 0;
	border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}

.nav {
	display: flex;
	flex-wrap: wrap;
	padding-left: 0;
	margin-bottom: 0;
	list-style: none;
}

.nav-link {
	display: block;
	padding: 0.5rem 1rem;
	color: #4d44b5;
	text-decoration: none;
	transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
	.nav-link {
		transition: none;
	}
}
.nav-link:hover,
.nav-link:focus {
	color: #3e3691;
}
.nav-link.disabled {
	color: #6c757d;
	pointer-events: none;
	cursor: default;
}

.nav-tabs {
	border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-link {
	margin-bottom: -1px;
	background: none;
	border: 1px solid transparent;
	border-top-left-radius: 0.625rem;
	border-top-right-radius: 0.625rem;
}
.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
	border-color: #e9ecef #e9ecef #dee2e6;
	isolation: isolate;
}
.nav-tabs .nav-link.disabled {
	color: #6c757d;
	background-color: transparent;
	border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
	color: #495057;
	background-color: #e6ebee;
	border-color: #dee2e6 #dee2e6 #e6ebee;
}
.nav-tabs .dropdown-menu {
	margin-top: -1px;
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}

.nav-pills .nav-link {
	background: none;
	border: 0;
	border-radius: 0.625rem;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
	color: #fff;
	background-color: #4d44b5;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
	flex: 1 1 auto;
	text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
	flex-basis: 0;
	flex-grow: 1;
	text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
	width: 100%;
}

.tab-content > .tab-pane {
	display: none;
}

.tab-content > .active {
	display: block;
}

.navbar {
	position: relative;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
	display: flex;
	flex-wrap: inherit;
	align-items: center;
	justify-content: space-between;
}

.navbar-brand {
	padding-top: 0.33594rem;
	padding-bottom: 0.33594rem;
	margin-right: 1rem;
	font-size: 1.09375rem;
	text-decoration: none;
	white-space: nowrap;
}

.navbar-nav {
	display: flex;
	flex-direction: column;
	padding-left: 0;
	margin-bottom: 0;
	list-style: none;
}
.navbar-nav .nav-link {
	padding-right: 0;
	padding-left: 0;
}
.navbar-nav .dropdown-menu {
	position: static;
}

.navbar-text {
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
}

.navbar-collapse {
	flex-basis: 100%;
	flex-grow: 1;
	align-items: center;
}

.navbar-toggler {
	padding: 0.25rem 0.75rem;
	font-size: 1.09375rem;
	line-height: 1;
	background-color: transparent;
	border: 1px solid transparent;
	border-radius: 0.625rem;
	transition: box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
	.navbar-toggler {
		transition: none;
	}
}
.navbar-toggler:hover {
	text-decoration: none;
}
.navbar-toggler:focus {
	text-decoration: none;
	outline: 0;
	box-shadow: 0 0 0 0.25rem;
}

.navbar-toggler-icon {
	display: inline-block;
	width: 1.5em;
	height: 1.5em;
	vertical-align: middle;
	background-repeat: no-repeat;
	background-position: center;
	background-size: 100%;
}

.navbar-nav-scroll {
	max-height: var(--bs-scroll-height, 75vh);
	overflow-y: auto;
}

@media (min-width: 576px) {
	.navbar-expand-sm {
		flex-wrap: nowrap;
		justify-content: flex-start;
	}
	.navbar-expand-sm .navbar-nav {
		flex-direction: row;
	}
	.navbar-expand-sm .navbar-nav .dropdown-menu {
		position: absolute;
	}
	.navbar-expand-sm .navbar-nav .nav-link {
		padding-right: 0.5rem;
		padding-left: 0.5rem;
	}
	.navbar-expand-sm .navbar-nav-scroll {
		overflow: visible;
	}
	.navbar-expand-sm .navbar-collapse {
		display: flex !important;
		flex-basis: auto;
	}
	.navbar-expand-sm .navbar-toggler {
		display: none;
	}
	.navbar-expand-sm .offcanvas-header {
		display: none;
	}
	.navbar-expand-sm .offcanvas {
		position: inherit;
		bottom: 0;
		z-index: 1000;
		flex-grow: 1;
		visibility: visible !important;
		background-color: transparent;
		border-right: 0;
		border-left: 0;
		transition: none;
		transform: none;
	}
	.navbar-expand-sm .offcanvas-top,
	.navbar-expand-sm .offcanvas-bottom {
		height: auto;
		border-top: 0;
		border-bottom: 0;
	}
	.navbar-expand-sm .offcanvas-body {
		display: flex;
		flex-grow: 0;
		padding: 0;
		overflow-y: visible;
	}
}

@media (min-width: 768px) {
	.navbar-expand-md {
		flex-wrap: nowrap;
		justify-content: flex-start;
	}
	.navbar-expand-md .navbar-nav {
		flex-direction: row;
	}
	.navbar-expand-md .navbar-nav .dropdown-menu {
		position: absolute;
	}
	.navbar-expand-md .navbar-nav .nav-link {
		padding-right: 0.5rem;
		padding-left: 0.5rem;
	}
	.navbar-expand-md .navbar-nav-scroll {
		overflow: visible;
	}
	.navbar-expand-md .navbar-collapse {
		display: flex !important;
		flex-basis: auto;
	}
	.navbar-expand-md .navbar-toggler {
		display: none;
	}
	.navbar-expand-md .offcanvas-header {
		display: none;
	}
	.navbar-expand-md .offcanvas {
		position: inherit;
		bottom: 0;
		z-index: 1000;
		flex-grow: 1;
		visibility: visible !important;
		background-color: transparent;
		border-right: 0;
		border-left: 0;
		transition: none;
		transform: none;
	}
	.navbar-expand-md .offcanvas-top,
	.navbar-expand-md .offcanvas-bottom {
		height: auto;
		border-top: 0;
		border-bottom: 0;
	}
	.navbar-expand-md .offcanvas-body {
		display: flex;
		flex-grow: 0;
		padding: 0;
		overflow-y: visible;
	}
}

@media (min-width: 992px) {
	.navbar-expand-lg {
		flex-wrap: nowrap;
		justify-content: flex-start;
	}
	.navbar-expand-lg .navbar-nav {
		flex-direction: row;
	}
	.navbar-expand-lg .navbar-nav .dropdown-menu {
		position: absolute;
	}
	.navbar-expand-lg .navbar-nav .nav-link {
		padding-right: 0.5rem;
		padding-left: 0.5rem;
	}
	.navbar-expand-lg .navbar-nav-scroll {
		overflow: visible;
	}
	.navbar-expand-lg .navbar-collapse {
		display: flex !important;
		flex-basis: auto;
	}
	.navbar-expand-lg .navbar-toggler {
		display: none;
	}
	.navbar-expand-lg .offcanvas-header {
		display: none;
	}
	.navbar-expand-lg .offcanvas {
		position: inherit;
		bottom: 0;
		z-index: 1000;
		flex-grow: 1;
		visibility: visible !important;
		background-color: transparent;
		border-right: 0;
		border-left: 0;
		transition: none;
		transform: none;
	}
	.navbar-expand-lg .offcanvas-top,
	.navbar-expand-lg .offcanvas-bottom {
		height: auto;
		border-top: 0;
		border-bottom: 0;
	}
	.navbar-expand-lg .offcanvas-body {
		display: flex;
		flex-grow: 0;
		padding: 0;
		overflow-y: visible;
	}
}

@media (min-width: 1200px) {
	.navbar-expand-xl {
		flex-wrap: nowrap;
		justify-content: flex-start;
	}
	.navbar-expand-xl .navbar-nav {
		flex-direction: row;
	}
	.navbar-expand-xl .navbar-nav .dropdown-menu {
		position: absolute;
	}
	.navbar-expand-xl .navbar-nav .nav-link {
		padding-right: 0.5rem;
		padding-left: 0.5rem;
	}
	.navbar-expand-xl .navbar-nav-scroll {
		overflow: visible;
	}
	.navbar-expand-xl .navbar-collapse {
		display: flex !important;
		flex-basis: auto;
	}
	.navbar-expand-xl .navbar-toggler {
		display: none;
	}
	.navbar-expand-xl .offcanvas-header {
		display: none;
	}
	.navbar-expand-xl .offcanvas {
		position: inherit;
		bottom: 0;
		z-index: 1000;
		flex-grow: 1;
		visibility: visible !important;
		background-color: transparent;
		border-right: 0;
		border-left: 0;
		transition: none;
		transform: none;
	}
	.navbar-expand-xl .offcanvas-top,
	.navbar-expand-xl .offcanvas-bottom {
		height: auto;
		border-top: 0;
		border-bottom: 0;
	}
	.navbar-expand-xl .offcanvas-body {
		display: flex;
		flex-grow: 0;
		padding: 0;
		overflow-y: visible;
	}
}

@media (min-width: 1440) {
	.navbar-expand-xxl {
		flex-wrap: nowrap;
		justify-content: flex-start;
	}
	.navbar-expand-xxl .navbar-nav {
		flex-direction: row;
	}
	.navbar-expand-xxl .navbar-nav .dropdown-menu {
		position: absolute;
	}
	.navbar-expand-xxl .navbar-nav .nav-link {
		padding-right: 0.5rem;
		padding-left: 0.5rem;
	}
	.navbar-expand-xxl .navbar-nav-scroll {
		overflow: visible;
	}
	.navbar-expand-xxl .navbar-collapse {
		display: flex !important;
		flex-basis: auto;
	}
	.navbar-expand-xxl .navbar-toggler {
		display: none;
	}
	.navbar-expand-xxl .offcanvas-header {
		display: none;
	}
	.navbar-expand-xxl .offcanvas {
		position: inherit;
		bottom: 0;
		z-index: 1000;
		flex-grow: 1;
		visibility: visible !important;
		background-color: transparent;
		border-right: 0;
		border-left: 0;
		transition: none;
		transform: none;
	}
	.navbar-expand-xxl .offcanvas-top,
	.navbar-expand-xxl .offcanvas-bottom {
		height: auto;
		border-top: 0;
		border-bottom: 0;
	}
	.navbar-expand-xxl .offcanvas-body {
		display: flex;
		flex-grow: 0;
		padding: 0;
		overflow-y: visible;
	}
}

.navbar-expand {
	flex-wrap: nowrap;
	justify-content: flex-start;
}
.navbar-expand .navbar-nav {
	flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
	position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
	padding-right: 0.5rem;
	padding-left: 0.5rem;
}
.navbar-expand .navbar-nav-scroll {
	overflow: visible;
}
.navbar-expand .navbar-collapse {
	display: flex !important;
	flex-basis: auto;
}
.navbar-expand .navbar-toggler {
	display: none;
}
.navbar-expand .offcanvas-header {
	display: none;
}
.navbar-expand .offcanvas {
	position: inherit;
	bottom: 0;
	z-index: 1000;
	flex-grow: 1;
	visibility: visible !important;
	background-color: transparent;
	border-right: 0;
	border-left: 0;
	transition: none;
	transform: none;
}
.navbar-expand .offcanvas-top,
.navbar-expand .offcanvas-bottom {
	height: auto;
	border-top: 0;
	border-bottom: 0;
}
.navbar-expand .offcanvas-body {
	display: flex;
	flex-grow: 0;
	padding: 0;
	overflow-y: visible;
}

.navbar-light .navbar-brand {
	color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover,
.navbar-light .navbar-brand:focus {
	color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-nav .nav-link {
	color: rgba(0, 0, 0, 0.55);
}
.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link:focus {
	color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
	color: rgba(0, 0, 0, 0.3);
}

.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .nav-link.active {
	color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-toggler {
	color: rgba(0, 0, 0, 0.55);
	border-color: rgba(0, 0, 0, 0.1);
}

.navbar-light .navbar-toggler-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.navbar-light .navbar-text {
	color: rgba(0, 0, 0, 0.55);
}
.navbar-light .navbar-text a,
.navbar-light .navbar-text a:hover,
.navbar-light .navbar-text a:focus {
	color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
	color: #fff;
}
.navbar-dark .navbar-brand:hover,
.navbar-dark .navbar-brand:focus {
	color: #fff;
}

.navbar-dark .navbar-nav .nav-link {
	color: rgba(255, 255, 255, 0.55);
}
.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus {
	color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
	color: rgba(255, 255, 255, 0.25);
}

.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .nav-link.active {
	color: #fff;
}

.navbar-dark .navbar-toggler {
	color: rgba(255, 255, 255, 0.55);
	border-color: rgba(255, 255, 255, 0.1);
}

.navbar-dark .navbar-toggler-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.navbar-dark .navbar-text {
	color: rgba(255, 255, 255, 0.55);
}
.navbar-dark .navbar-text a,
.navbar-dark .navbar-text a:hover,
.navbar-dark .navbar-text a:focus {
	color: #fff;
}

.card {
	position: relative;
	display: flex;
	flex-direction: column;
	min-width: 0;
	word-wrap: break-word;
	background-color: #fff;
	background-clip: border-box;
	border: 1px solid rgba(0, 0, 0, 0.125);
	border-radius: 0.625rem;
}
.card > hr {
	margin-right: 0;
	margin-left: 0;
}
.card > .list-group {
	border-top: inherit;
	border-bottom: inherit;
}
.card > .list-group:first-child {
	border-top-width: 0;
	border-top-left-radius: calc(0.625rem - 1px);
	border-top-right-radius: calc(0.625rem - 1px);
}
.card > .list-group:last-child {
	border-bottom-width: 0;
	border-bottom-right-radius: calc(0.625rem - 1px);
	border-bottom-left-radius: calc(0.625rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
	border-top: 0;
}

.card-body {
	flex: 1 1 auto;
	padding: 1rem 1rem;
}

.card-title {
	margin-bottom: 0.5rem;
}

.card-subtitle {
	margin-top: -0.25rem;
	margin-bottom: 0;
}

.card-text:last-child {
	margin-bottom: 0;
}

.card-link + .card-link {
	margin-left: 1rem;
}

.card-header {
	padding: 0.5rem 1rem;
	margin-bottom: 0;
	background-color: rgba(0, 0, 0, 0.03);
	border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.card-header:first-child {
	border-radius: calc(0.625rem - 1px) calc(0.625rem - 1px) 0 0;
}

.card-footer {
	padding: 0.5rem 1rem;
	background-color: rgba(0, 0, 0, 0.03);
	border-top: 1px solid rgba(0, 0, 0, 0.125);
}
.card-footer:last-child {
	border-radius: 0 0 calc(0.625rem - 1px) calc(0.625rem - 1px);
}

.card-header-tabs {
	margin-right: -0.5rem;
	margin-bottom: -0.5rem;
	margin-left: -0.5rem;
	border-bottom: 0;
}
.card-header-tabs .nav-link.active {
	background-color: #fff;
	border-bottom-color: #fff;
}

.card-header-pills {
	margin-right: -0.5rem;
	margin-left: -0.5rem;
}

.card-img-overlay {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	padding: 1rem;
	border-radius: calc(0.625rem - 1px);
}

.card-img,
.card-img-top,
.card-img-bottom {
	width: 100%;
}

.card-img,
.card-img-top {
	border-top-left-radius: calc(0.625rem - 1px);
	border-top-right-radius: calc(0.625rem - 1px);
}

.card-img,
.card-img-bottom {
	border-bottom-right-radius: calc(0.625rem - 1px);
	border-bottom-left-radius: calc(0.625rem - 1px);
}

.card-group > .card {
	margin-bottom: 15px;
}

@media (min-width: 576px) {
	.card-group {
		display: flex;
		flex-flow: row wrap;
	}
	.card-group > .card {
		flex: 1 0;
		margin-bottom: 0;
	}
	.card-group > .card + .card {
		margin-left: 0;
		border-left: 0;
	}
	.card-group > .card:not(:last-child) {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}
	.card-group > .card:not(:last-child) .card-img-top,
	.card-group > .card:not(:last-child) .card-header {
		border-top-right-radius: 0;
	}
	.card-group > .card:not(:last-child) .card-img-bottom,
	.card-group > .card:not(:last-child) .card-footer {
		border-bottom-right-radius: 0;
	}
	.card-group > .card:not(:first-child) {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}
	.card-group > .card:not(:first-child) .card-img-top,
	.card-group > .card:not(:first-child) .card-header {
		border-top-left-radius: 0;
	}
	.card-group > .card:not(:first-child) .card-img-bottom,
	.card-group > .card:not(:first-child) .card-footer {
		border-bottom-left-radius: 0;
	}
}

.accordion-button {
	position: relative;
	display: flex;
	align-items: center;
	width: 100%;
	padding: 1rem 1.25rem;
	font-size: 0.875rem;
	color: #a098ae;
	text-align: left;
	background-color: #e6ebee;
	border: 0;
	border-radius: 0;
	overflow-anchor: none;
	transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
		border-radius 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
	.accordion-button {
		transition: none;
	}
}
.accordion-button:not(.collapsed) {
	color: #453da3;
	background-color: #edecf8;
	box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);
}
.accordion-button:not(.collapsed)::after {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
	transform: rotate(-180deg);
}
.accordion-button::after {
	flex-shrink: 0;
	width: 1.25rem;
	height: 1.25rem;
	margin-left: auto;
	content: '';
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
	background-repeat: no-repeat;
	background-size: 1.25rem;
	transition: transform 0.2s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
	.accordion-button::after {
		transition: none;
	}
}
.accordion-button:hover {
	z-index: 2;
}
.accordion-button:focus {
	z-index: 3;
	border-color: #a6a2da;
	outline: 0;
	box-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.25);
}

.accordion-header {
	margin-bottom: 0;
}

.accordion-item {
	background-color: #e6ebee;
	border: 1px solid rgba(0, 0, 0, 0.125);
}
.accordion-item:first-of-type {
	border-top-left-radius: 0.625rem;
	border-top-right-radius: 0.625rem;
}
.accordion-item:first-of-type .accordion-button {
	border-top-left-radius: calc(0.625rem - 1px);
	border-top-right-radius: calc(0.625rem - 1px);
}
.accordion-item:not(:first-of-type) {
	border-top: 0;
}
.accordion-item:last-of-type {
	border-bottom-right-radius: 0.625rem;
	border-bottom-left-radius: 0.625rem;
}
.accordion-item:last-of-type .accordion-button.collapsed {
	border-bottom-right-radius: calc(0.625rem - 1px);
	border-bottom-left-radius: calc(0.625rem - 1px);
}
.accordion-item:last-of-type .accordion-collapse {
	border-bottom-right-radius: 0.625rem;
	border-bottom-left-radius: 0.625rem;
}

.accordion-body {
	padding: 1rem 1.25rem;
}

.accordion-flush .accordion-collapse {
	border-width: 0;
}

.accordion-flush .accordion-item {
	border-right: 0;
	border-left: 0;
	border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
	border-top: 0;
}
.accordion-flush .accordion-item:last-child {
	border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button {
	border-radius: 0;
}

.breadcrumb {
	display: flex;
	flex-wrap: wrap;
	padding: 0 0;
	margin-bottom: 1rem;
	list-style: none;
}

.breadcrumb-item + .breadcrumb-item {
	padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
	float: left;
	padding-right: 0.5rem;
	color: #6c757d;
	content: var(--bs-breadcrumb-divider, '/') /* rtl: var(--bs-breadcrumb-divider, "/") */;
}

.breadcrumb-item.active {
	color: #6c757d;
}

.pagination {
	display: flex;
	padding-left: 0;
	list-style: none;
}

.page-link {
	position: relative;
	display: block;
	color: #4d44b5;
	text-decoration: none;
	background-color: #fff;
	border: 1px solid #dee2e6;
	transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
	.page-link {
		transition: none;
	}
}
.page-link:hover {
	z-index: 2;
	color: #3e3691;
	background-color: #e9ecef;
	border-color: #dee2e6;
}
.page-link:disabled {
	opacity: 0.5;
}
.page-link:focus {
	z-index: 3;
	color: #3e3691;
	background-color: #e9ecef;
	outline: 0;
	box-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.25);
}

.page-item:not(:first-child) .page-link {
	margin-left: -1px;
}

.page-item.active .page-link {
	z-index: 3;
	color: #fff;
	background-color: #4d44b5;
	border-color: #4d44b5;
}

.page-item.disabled .page-link {
	color: #6c757d;
	pointer-events: none;
	background-color: #fff;
	border-color: #dee2e6;
}

.page-link {
	padding: 0.375rem 0.75rem;
}

.page-item:first-child .page-link {
	border-top-left-radius: 0.625rem;
	border-bottom-left-radius: 0.625rem;
}

.page-item:last-child .page-link {
	border-top-right-radius: 0.625rem;
	border-bottom-right-radius: 0.625rem;
}

.pagination-lg .page-link {
	padding: 0.75rem 1.5rem;
	font-size: 1.09375rem;
}

.pagination-lg .page-item:first-child .page-link {
	border-top-left-radius: 0.625rem;
	border-bottom-left-radius: 0.625rem;
}

.pagination-lg .page-item:last-child .page-link {
	border-top-right-radius: 0.625rem;
	border-bottom-right-radius: 0.625rem;
}

.pagination-sm .page-link {
	padding: 0.25rem 0.5rem;
	font-size: 0.76563rem;
}
@media (min-width: 1200px) {
	.pagination-sm .page-link {
		font-size: 0.76562rem;
	}
}

.pagination-sm .page-item:first-child .page-link {
	border-top-left-radius: 0.625rem;
	border-bottom-left-radius: 0.625rem;
}

.pagination-sm .page-item:last-child .page-link {
	border-top-right-radius: 0.625rem;
	border-bottom-right-radius: 0.625rem;
}

.badge {
	display: inline-block;
	padding: 0.35em 0.65em;
	font-size: 0.75em;
	font-weight: 700;
	line-height: 1;
	color: #fff;
	text-align: center;
	white-space: nowrap;
	vertical-align: baseline;
	border-radius: 0.625rem;
}
.badge:empty {
	display: none;
}

.btn .badge {
	position: relative;
	top: -1px;
}

.alert {
	position: relative;
	padding: 1rem 1rem;
	margin-bottom: 1rem;
	border: 1px solid transparent;
	border-radius: 0.625rem;
}

.alert-heading {
	color: inherit;
}

.alert-link {
	font-weight: 700;
}

.alert-dismissible {
	padding-right: 3rem;
}
.alert-dismissible .btn-close {
	position: absolute;
	top: 0;
	right: 0;
	z-index: 2;
	padding: 1.25rem 1rem;
}

.alert-primary {
	color: #2e296d;
	background-color: #dbdaf0;
	border-color: #cac7e9;
}
.alert-primary .alert-link {
	color: #252157;
}

.alert-secondary {
	color: #974b37;
	background-color: #fee5de;
	border-color: #fed8ce;
}
.alert-secondary .alert-link {
	color: #793c2c;
}

.alert-success {
	color: #12703b;
	background-color: #d2f1e0;
	border-color: #bcead0;
}
.alert-success .alert-link {
	color: #0e5a2f;
}

.alert-info {
	color: #006862;
	background-color: #ccefed;
	border-color: #b3e6e3;
}
.alert-info .alert-link {
	color: #00534e;
}

.alert-warning {
	color: #654e19;
	background-color: #fef3d8;
	border-color: #feedc5;
}
.alert-warning .alert-link {
	color: #513e14;
}

.alert-danger {
	color: #983232;
	background-color: #ffdddd;
	border-color: #fecbcb;
}
.alert-danger .alert-link {
	color: #7a2828;
}

.alert-light {
	color: #5e5e64;
	background-color: #fbfbfe;
	border-color: #f9f9fd;
}
.alert-light .alert-link {
	color: #4b4b50;
}

.alert-dark {
	color: #1d2244;
	background-color: #d6d7e3;
	border-color: #c1c4d5;
}
.alert-dark .alert-link {
	color: #171b36;
}

@keyframes progress-bar-stripes {
	0% {
		background-position-x: 1rem;
	}
}

.progress {
	display: flex;
	height: 1rem;
	overflow: hidden;
	font-size: 0.65625rem;
	background-color: #e9ecef;
	border-radius: 0.625rem;
}

.progress-bar {
	display: flex;
	flex-direction: column;
	justify-content: center;
	overflow: hidden;
	color: #fff;
	text-align: center;
	white-space: nowrap;
	background-color: #4d44b5;
	transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
	.progress-bar {
		transition: none;
	}
}

.progress-bar-striped {
	background-image: linear-gradient(
		45deg,
		rgba(255, 255, 255, 0.15) 25%,
		transparent 25%,
		transparent 50%,
		rgba(255, 255, 255, 0.15) 50%,
		rgba(255, 255, 255, 0.15) 75%,
		transparent 75%,
		transparent
	);
	background-size: 1rem 1rem;
}

.progress-bar-animated {
	animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
	.progress-bar-animated {
		animation: none;
	}
}

.list-group {
	display: flex;
	flex-direction: column;
	padding-left: 0;
	margin-bottom: 0;
	border-radius: 0.625rem;
}

.list-group-numbered {
	list-style-type: none;
	counter-reset: section;
}
.list-group-numbered > li::before {
	content: counters(section, '.') '. ';
	counter-increment: section;
}

.list-group-item-action {
	width: 100%;
	color: #495057;
	text-align: inherit;
}
.list-group-item-action:hover,
.list-group-item-action:focus {
	z-index: 1;
	color: #495057;
	text-decoration: none;
	background-color: #f8f9fa;
}
.list-group-item-action:active {
	color: #a098ae;
	background-color: #e9ecef;
}

.list-group-item {
	position: relative;
	display: block;
	padding: 0.5rem 1rem;
	color: #212529;
	text-decoration: none;
	background-color: #fff;
	border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group-item:first-child {
	border-top-left-radius: inherit;
	border-top-right-radius: inherit;
}
.list-group-item:last-child {
	border-bottom-right-radius: inherit;
	border-bottom-left-radius: inherit;
}
.list-group-item.disabled,
.list-group-item:disabled {
	color: #6c757d;
	pointer-events: none;
	background-color: #fff;
}
.list-group-item.active {
	z-index: 2;
	color: #fff;
	background-color: #4d44b5;
	border-color: #4d44b5;
}
.list-group-item + .list-group-item {
	border-top-width: 0;
}
.list-group-item + .list-group-item.active {
	margin-top: -1px;
	border-top-width: 1px;
}

.list-group-horizontal {
	flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
	border-bottom-left-radius: 0.625rem;
	border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
	border-top-right-radius: 0.625rem;
	border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
	margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
	border-top-width: 1px;
	border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
	margin-left: -1px;
	border-left-width: 1px;
}

@media (min-width: 576px) {
	.list-group-horizontal-sm {
		flex-direction: row;
	}
	.list-group-horizontal-sm > .list-group-item:first-child {
		border-bottom-left-radius: 0.625rem;
		border-top-right-radius: 0;
	}
	.list-group-horizontal-sm > .list-group-item:last-child {
		border-top-right-radius: 0.625rem;
		border-bottom-left-radius: 0;
	}
	.list-group-horizontal-sm > .list-group-item.active {
		margin-top: 0;
	}
	.list-group-horizontal-sm > .list-group-item + .list-group-item {
		border-top-width: 1px;
		border-left-width: 0;
	}
	.list-group-horizontal-sm > .list-group-item + .list-group-item.active {
		margin-left: -1px;
		border-left-width: 1px;
	}
}

@media (min-width: 768px) {
	.list-group-horizontal-md {
		flex-direction: row;
	}
	.list-group-horizontal-md > .list-group-item:first-child {
		border-bottom-left-radius: 0.625rem;
		border-top-right-radius: 0;
	}
	.list-group-horizontal-md > .list-group-item:last-child {
		border-top-right-radius: 0.625rem;
		border-bottom-left-radius: 0;
	}
	.list-group-horizontal-md > .list-group-item.active {
		margin-top: 0;
	}
	.list-group-horizontal-md > .list-group-item + .list-group-item {
		border-top-width: 1px;
		border-left-width: 0;
	}
	.list-group-horizontal-md > .list-group-item + .list-group-item.active {
		margin-left: -1px;
		border-left-width: 1px;
	}
}

@media (min-width: 992px) {
	.list-group-horizontal-lg {
		flex-direction: row;
	}
	.list-group-horizontal-lg > .list-group-item:first-child {
		border-bottom-left-radius: 0.625rem;
		border-top-right-radius: 0;
	}
	.list-group-horizontal-lg > .list-group-item:last-child {
		border-top-right-radius: 0.625rem;
		border-bottom-left-radius: 0;
	}
	.list-group-horizontal-lg > .list-group-item.active {
		margin-top: 0;
	}
	.list-group-horizontal-lg > .list-group-item + .list-group-item {
		border-top-width: 1px;
		border-left-width: 0;
	}
	.list-group-horizontal-lg > .list-group-item + .list-group-item.active {
		margin-left: -1px;
		border-left-width: 1px;
	}
}

@media (min-width: 1200px) {
	.list-group-horizontal-xl {
		flex-direction: row;
	}
	.list-group-horizontal-xl > .list-group-item:first-child {
		border-bottom-left-radius: 0.625rem;
		border-top-right-radius: 0;
	}
	.list-group-horizontal-xl > .list-group-item:last-child {
		border-top-right-radius: 0.625rem;
		border-bottom-left-radius: 0;
	}
	.list-group-horizontal-xl > .list-group-item.active {
		margin-top: 0;
	}
	.list-group-horizontal-xl > .list-group-item + .list-group-item {
		border-top-width: 1px;
		border-left-width: 0;
	}
	.list-group-horizontal-xl > .list-group-item + .list-group-item.active {
		margin-left: -1px;
		border-left-width: 1px;
	}
}

@media (min-width: 1440) {
	.list-group-horizontal-xxl {
		flex-direction: row;
	}
	.list-group-horizontal-xxl > .list-group-item:first-child {
		border-bottom-left-radius: 0.625rem;
		border-top-right-radius: 0;
	}
	.list-group-horizontal-xxl > .list-group-item:last-child {
		border-top-right-radius: 0.625rem;
		border-bottom-left-radius: 0;
	}
	.list-group-horizontal-xxl > .list-group-item.active {
		margin-top: 0;
	}
	.list-group-horizontal-xxl > .list-group-item + .list-group-item {
		border-top-width: 1px;
		border-left-width: 0;
	}
	.list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
		margin-left: -1px;
		border-left-width: 1px;
	}
}

.list-group-flush {
	border-radius: 0;
}
.list-group-flush > .list-group-item {
	border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
	border-bottom-width: 0;
}

.list-group-item-primary {
	color: #2e296d;
	background-color: #dbdaf0;
}
.list-group-item-primary.list-group-item-action:hover,
.list-group-item-primary.list-group-item-action:focus {
	color: #2e296d;
	background-color: #c5c4d8;
}
.list-group-item-primary.list-group-item-action.active {
	color: #fff;
	background-color: #2e296d;
	border-color: #2e296d;
}

.list-group-item-secondary {
	color: #974b37;
	background-color: #fee5de;
}
.list-group-item-secondary.list-group-item-action:hover,
.list-group-item-secondary.list-group-item-action:focus {
	color: #974b37;
	background-color: #e5cec8;
}
.list-group-item-secondary.list-group-item-action.active {
	color: #fff;
	background-color: #974b37;
	border-color: #974b37;
}

.list-group-item-success {
	color: #12703b;
	background-color: #d2f1e0;
}
.list-group-item-success.list-group-item-action:hover,
.list-group-item-success.list-group-item-action:focus {
	color: #12703b;
	background-color: #bdd9ca;
}
.list-group-item-success.list-group-item-action.active {
	color: #fff;
	background-color: #12703b;
	border-color: #12703b;
}

.list-group-item-info {
	color: #006862;
	background-color: #ccefed;
}
.list-group-item-info.list-group-item-action:hover,
.list-group-item-info.list-group-item-action:focus {
	color: #006862;
	background-color: #b8d7d5;
}
.list-group-item-info.list-group-item-action.active {
	color: #fff;
	background-color: #006862;
	border-color: #006862;
}

.list-group-item-warning {
	color: #654e19;
	background-color: #fef3d8;
}
.list-group-item-warning.list-group-item-action:hover,
.list-group-item-warning.list-group-item-action:focus {
	color: #654e19;
	background-color: #e5dbc2;
}
.list-group-item-warning.list-group-item-action.active {
	color: #fff;
	background-color: #654e19;
	border-color: #654e19;
}

.list-group-item-danger {
	color: #983232;
	background-color: #ffdddd;
}
.list-group-item-danger.list-group-item-action:hover,
.list-group-item-danger.list-group-item-action:focus {
	color: #983232;
	background-color: #e6c7c7;
}
.list-group-item-danger.list-group-item-action.active {
	color: #fff;
	background-color: #983232;
	border-color: #983232;
}

.list-group-item-light {
	color: #5e5e64;
	background-color: #fbfbfe;
}
.list-group-item-light.list-group-item-action:hover,
.list-group-item-light.list-group-item-action:focus {
	color: #5e5e64;
	background-color: #e2e2e5;
}
.list-group-item-light.list-group-item-action.active {
	color: #fff;
	background-color: #5e5e64;
	border-color: #5e5e64;
}

.list-group-item-dark {
	color: #1d2244;
	background-color: #d6d7e3;
}
.list-group-item-dark.list-group-item-action:hover,
.list-group-item-dark.list-group-item-action:focus {
	color: #1d2244;
	background-color: #c1c2cc;
}
.list-group-item-dark.list-group-item-action.active {
	color: #fff;
	background-color: #1d2244;
	border-color: #1d2244;
}

.btn-close {
	box-sizing: content-box;
	width: 1em;
	height: 1em;
	padding: 0.25em 0.25em;
	color: #000;
	background: transparent
		url(${___CSS_LOADER_URL_REPLACEMENT_12___})
		center/1em auto no-repeat;
	border: 0;
	border-radius: 0.625rem;
	opacity: 0.5;
}
.btn-close:hover {
	color: #000;
	text-decoration: none;
	opacity: 0.75;
}
.btn-close:focus {
	outline: 0;
	box-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.25);
	opacity: 1;
}
.btn-close:disabled,
.btn-close.disabled {
	pointer-events: none;
	-webkit-user-select: none;
	        user-select: none;
	opacity: 0.25;
}

.btn-close-white {
	filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
	width: 350px;
	max-width: 100%;
	font-size: 0.875rem;
	pointer-events: auto;
	background-color: rgba(255, 255, 255, 0.85);
	background-clip: padding-box;
	border: 1px solid rgba(0, 0, 0, 0.1);
	box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
	border-radius: 0.625rem;
}
.toast.showing {
	opacity: 0;
}
.toast:not(.show) {
	display: none;
}

.toast-container {
	width: max-content;
	max-width: 100%;
	pointer-events: none;
}
.toast-container > :not(:last-child) {
	margin-bottom: 15px;
}

.toast-header {
	display: flex;
	align-items: center;
	padding: 0.5rem 0.75rem;
	color: #6c757d;
	background-color: rgba(255, 255, 255, 0.85);
	background-clip: padding-box;
	border-bottom: 1px solid rgba(0, 0, 0, 0.05);
	border-top-left-radius: calc(0.625rem - 1px);
	border-top-right-radius: calc(0.625rem - 1px);
}
.toast-header .btn-close {
	margin-right: -0.375rem;
	margin-left: 0.75rem;
}

.toast-body {
	padding: 0.75rem;
	word-wrap: break-word;
}

.modal {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1055;
	display: none;
	width: 100%;
	height: 100%;
	overflow-x: hidden;
	overflow-y: auto;
	outline: 0;
}

.modal-dialog {
	position: relative;
	width: auto;
	margin: 0.5rem;
	pointer-events: none;
}
.modal.fade .modal-dialog {
	transition: transform 0.3s ease-out;
	transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
	.modal.fade .modal-dialog {
		transition: none;
	}
}
.modal.show .modal-dialog {
	transform: none;
}
.modal.modal-static .modal-dialog {
	transform: scale(1.02);
}

.modal-dialog-scrollable {
	height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
	max-height: 100%;
	overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
	overflow-y: auto;
}

.modal-dialog-centered {
	display: flex;
	align-items: center;
	min-height: calc(100% - 1rem);
}

.modal-content {
	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	pointer-events: auto;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid rgba(0, 0, 0, 0.2);
	border-radius: 0.625rem;
	outline: 0;
}

.modal-backdrop {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1050;
	width: 100vw;
	height: 100vh;
	background-color: #000;
}
.modal-backdrop.fade {
	opacity: 0;
}
.modal-backdrop.show {
	opacity: 0.5;
}

.modal-header {
	display: flex;
	flex-shrink: 0;
	align-items: center;
	justify-content: space-between;
	padding: 1rem 1rem;
	border-bottom: 1px solid #eeeeee;
	border-top-left-radius: calc(0.625rem - 1px);
	border-top-right-radius: calc(0.625rem - 1px);
}
.modal-header .btn-close {
	padding: 0.5rem 0.5rem;
	margin: -0.5rem -0.5rem -0.5rem auto;
}

.modal-title {
	margin-bottom: 0;
	line-height: 1.5;
}

.modal-body {
	position: relative;
	flex: 1 1 auto;
	padding: 1rem;
}

.modal-footer {
	display: flex;
	flex-wrap: wrap;
	flex-shrink: 0;
	align-items: center;
	justify-content: flex-end;
	padding: 0.75rem;
	border-top: 1px solid #eeeeee;
	border-bottom-right-radius: calc(0.625rem - 1px);
	border-bottom-left-radius: calc(0.625rem - 1px);
}
.modal-footer > * {
	margin: 0.25rem;
}

@media (min-width: 576px) {
	.modal-dialog {
		max-width: 500px;
		margin: 1.75rem auto;
	}
	.modal-dialog-scrollable {
		height: calc(100% - 3.5rem);
	}
	.modal-dialog-centered {
		min-height: calc(100% - 3.5rem);
	}
	.modal-sm {
		max-width: 300px;
	}
}

@media (min-width: 992px) {
	.modal-lg,
	.modal-xl {
		max-width: 800px;
	}
}

@media (min-width: 1200px) {
	.modal-xl {
		max-width: 1140px;
	}
}

.modal-fullscreen {
	width: 100vw;
	max-width: none;
	height: 100%;
	margin: 0;
}
.modal-fullscreen .modal-content {
	height: 100%;
	border: 0;
	border-radius: 0;
}
.modal-fullscreen .modal-header {
	border-radius: 0;
}
.modal-fullscreen .modal-body {
	overflow-y: auto;
}
.modal-fullscreen .modal-footer {
	border-radius: 0;
}

@media (max-width: 575.98px) {
	.modal-fullscreen-sm-down {
		width: 100vw;
		max-width: none;
		height: 100%;
		margin: 0;
	}
	.modal-fullscreen-sm-down .modal-content {
		height: 100%;
		border: 0;
		border-radius: 0;
	}
	.modal-fullscreen-sm-down .modal-header {
		border-radius: 0;
	}
	.modal-fullscreen-sm-down .modal-body {
		overflow-y: auto;
	}
	.modal-fullscreen-sm-down .modal-footer {
		border-radius: 0;
	}
}

@media (max-width: 767.98px) {
	.modal-fullscreen-md-down {
		width: 100vw;
		max-width: none;
		height: 100%;
		margin: 0;
	}
	.modal-fullscreen-md-down .modal-content {
		height: 100%;
		border: 0;
		border-radius: 0;
	}
	.modal-fullscreen-md-down .modal-header {
		border-radius: 0;
	}
	.modal-fullscreen-md-down .modal-body {
		overflow-y: auto;
	}
	.modal-fullscreen-md-down .modal-footer {
		border-radius: 0;
	}
}

@media (max-width: 991.98px) {
	.modal-fullscreen-lg-down {
		width: 100vw;
		max-width: none;
		height: 100%;
		margin: 0;
	}
	.modal-fullscreen-lg-down .modal-content {
		height: 100%;
		border: 0;
		border-radius: 0;
	}
	.modal-fullscreen-lg-down .modal-header {
		border-radius: 0;
	}
	.modal-fullscreen-lg-down .modal-body {
		overflow-y: auto;
	}
	.modal-fullscreen-lg-down .modal-footer {
		border-radius: 0;
	}
}

@media (max-width: 1199.98px) {
	.modal-fullscreen-xl-down {
		width: 100vw;
		max-width: none;
		height: 100%;
		margin: 0;
	}
	.modal-fullscreen-xl-down .modal-content {
		height: 100%;
		border: 0;
		border-radius: 0;
	}
	.modal-fullscreen-xl-down .modal-header {
		border-radius: 0;
	}
	.modal-fullscreen-xl-down .modal-body {
		overflow-y: auto;
	}
	.modal-fullscreen-xl-down .modal-footer {
		border-radius: 0;
	}
}

@media (max-width: 1439.98) {
	.modal-fullscreen-xxl-down {
		width: 100vw;
		max-width: none;
		height: 100%;
		margin: 0;
	}
	.modal-fullscreen-xxl-down .modal-content {
		height: 100%;
		border: 0;
		border-radius: 0;
	}
	.modal-fullscreen-xxl-down .modal-header {
		border-radius: 0;
	}
	.modal-fullscreen-xxl-down .modal-body {
		overflow-y: auto;
	}
	.modal-fullscreen-xxl-down .modal-footer {
		border-radius: 0;
	}
}

.tooltip {
	position: absolute;
	z-index: 1080;
	display: block;
	margin: 0;
	font-family: 'Poppins', sans-serif;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
	text-align: left;
	text-align: start;
	text-decoration: none;
	text-shadow: none;
	text-transform: none;
	letter-spacing: normal;
	word-break: normal;
	word-spacing: normal;
	white-space: normal;
	line-break: auto;
	font-size: 0.76563rem;
	word-wrap: break-word;
	opacity: 0;
}
@media (min-width: 1200px) {
	.tooltip {
		font-size: 0.76562rem;
	}
}
.tooltip.show {
	opacity: 0.9;
}
.tooltip .tooltip-arrow {
	position: absolute;
	display: block;
	width: 0.8rem;
	height: 0.4rem;
}
.tooltip .tooltip-arrow::before {
	position: absolute;
	content: '';
	border-color: transparent;
	border-style: solid;
}

.bs-tooltip-top,
.bs-tooltip-auto[data-popper-placement^='top'] {
	padding: 0.4rem 0;
}
.bs-tooltip-top .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^='top'] .tooltip-arrow {
	bottom: 0;
}
.bs-tooltip-top .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^='top'] .tooltip-arrow::before {
	top: -1px;
	border-width: 0.4rem 0.4rem 0;
	border-top-color: #000;
}

.bs-tooltip-end,
.bs-tooltip-auto[data-popper-placement^='right'] {
	padding: 0 0.4rem;
}
.bs-tooltip-end .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^='right'] .tooltip-arrow {
	left: 0;
	width: 0.4rem;
	height: 0.8rem;
}
.bs-tooltip-end .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^='right'] .tooltip-arrow::before {
	right: -1px;
	border-width: 0.4rem 0.4rem 0.4rem 0;
	border-right-color: #000;
}

.bs-tooltip-bottom,
.bs-tooltip-auto[data-popper-placement^='bottom'] {
	padding: 0.4rem 0;
}
.bs-tooltip-bottom .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^='bottom'] .tooltip-arrow {
	top: 0;
}
.bs-tooltip-bottom .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^='bottom'] .tooltip-arrow::before {
	bottom: -1px;
	border-width: 0 0.4rem 0.4rem;
	border-bottom-color: #000;
}

.bs-tooltip-start,
.bs-tooltip-auto[data-popper-placement^='left'] {
	padding: 0 0.4rem;
}
.bs-tooltip-start .tooltip-arrow,
.bs-tooltip-auto[data-popper-placement^='left'] .tooltip-arrow {
	right: 0;
	width: 0.4rem;
	height: 0.8rem;
}
.bs-tooltip-start .tooltip-arrow::before,
.bs-tooltip-auto[data-popper-placement^='left'] .tooltip-arrow::before {
	left: -1px;
	border-width: 0.4rem 0 0.4rem 0.4rem;
	border-left-color: #000;
}

.tooltip-inner {
	max-width: 200px;
	padding: 0.25rem 0.5rem;
	color: #fff;
	text-align: center;
	background-color: #000;
	border-radius: 0.625rem;
}

.popover {
	position: absolute;
	top: 0;
	left: 0 /* rtl:ignore */;
	z-index: 1070;
	display: block;
	max-width: 276px;
	font-family: 'Poppins', sans-serif;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
	text-align: left;
	text-align: start;
	text-decoration: none;
	text-shadow: none;
	text-transform: none;
	letter-spacing: normal;
	word-break: normal;
	word-spacing: normal;
	white-space: normal;
	line-break: auto;
	font-size: 0.76563rem;
	word-wrap: break-word;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid rgba(0, 0, 0, 0.2);
	border-radius: 0.625rem;
}
@media (min-width: 1200px) {
	.popover {
		font-size: 0.76562rem;
	}
}
.popover .popover-arrow {
	position: absolute;
	display: block;
	width: 1rem;
	height: 0.5rem;
}
.popover .popover-arrow::before,
.popover .popover-arrow::after {
	position: absolute;
	display: block;
	content: '';
	border-color: transparent;
	border-style: solid;
}

.bs-popover-top > .popover-arrow,
.bs-popover-auto[data-popper-placement^='top'] > .popover-arrow {
	bottom: calc(-0.5rem - 1px);
}
.bs-popover-top > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^='top'] > .popover-arrow::before {
	bottom: 0;
	border-width: 0.5rem 0.5rem 0;
	border-top-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-top > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^='top'] > .popover-arrow::after {
	bottom: 1px;
	border-width: 0.5rem 0.5rem 0;
	border-top-color: #fff;
}

.bs-popover-end > .popover-arrow,
.bs-popover-auto[data-popper-placement^='right'] > .popover-arrow {
	left: calc(-0.5rem - 1px);
	width: 0.5rem;
	height: 1rem;
}
.bs-popover-end > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^='right'] > .popover-arrow::before {
	left: 0;
	border-width: 0.5rem 0.5rem 0.5rem 0;
	border-right-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-end > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^='right'] > .popover-arrow::after {
	left: 1px;
	border-width: 0.5rem 0.5rem 0.5rem 0;
	border-right-color: #fff;
}

.bs-popover-bottom > .popover-arrow,
.bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow {
	top: calc(-0.5rem - 1px);
}
.bs-popover-bottom > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow::before {
	top: 0;
	border-width: 0 0.5rem 0.5rem 0.5rem;
	border-bottom-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-bottom > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow::after {
	top: 1px;
	border-width: 0 0.5rem 0.5rem 0.5rem;
	border-bottom-color: #fff;
}

.bs-popover-bottom .popover-header::before,
.bs-popover-auto[data-popper-placement^='bottom'] .popover-header::before {
	position: absolute;
	top: 0;
	left: 50%;
	display: block;
	width: 1rem;
	margin-left: -0.5rem;
	content: '';
	border-bottom: 1px solid #f0f0f0;
}

.bs-popover-start > .popover-arrow,
.bs-popover-auto[data-popper-placement^='left'] > .popover-arrow {
	right: calc(-0.5rem - 1px);
	width: 0.5rem;
	height: 1rem;
}
.bs-popover-start > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^='left'] > .popover-arrow::before {
	right: 0;
	border-width: 0.5rem 0 0.5rem 0.5rem;
	border-left-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-start > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^='left'] > .popover-arrow::after {
	right: 1px;
	border-width: 0.5rem 0 0.5rem 0.5rem;
	border-left-color: #fff;
}

.popover-header {
	padding: 0.5rem 1rem;
	margin-bottom: 0;
	font-size: 0.875rem;
	color: #303972;
	background-color: #f0f0f0;
	border-bottom: 1px solid rgba(0, 0, 0, 0.2);
	border-top-left-radius: calc(0.625rem - 1px);
	border-top-right-radius: calc(0.625rem - 1px);
}
.popover-header:empty {
	display: none;
}

.popover-body {
	padding: 1rem 1rem;
	color: #a098ae;
}

.carousel {
	position: relative;
}

.carousel.pointer-event {
	touch-action: pan-y;
}

.carousel-inner {
	position: relative;
	width: 100%;
	overflow: hidden;
}
.carousel-inner::after {
	display: block;
	clear: both;
	content: '';
}

.carousel-item {
	position: relative;
	display: none;
	float: left;
	width: 100%;
	margin-right: -100%;
	backface-visibility: hidden;
	transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
	.carousel-item {
		transition: none;
	}
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
	display: block;
}

/* rtl:begin:ignore */
.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
	transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
	transform: translateX(-100%);
}

/* rtl:end:ignore */
.carousel-fade .carousel-item {
	opacity: 0;
	transition-property: opacity;
	transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
	z-index: 1;
	opacity: 1;
}

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
	z-index: 0;
	opacity: 0;
	transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
	.carousel-fade .active.carousel-item-start,
	.carousel-fade .active.carousel-item-end {
		transition: none;
	}
}

.carousel-control-prev,
.carousel-control-next {
	position: absolute;
	top: 0;
	bottom: 0;
	z-index: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 15%;
	padding: 0;
	color: #fff;
	text-align: center;
	background: none;
	border: 0;
	opacity: 0.5;
	transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
	.carousel-control-prev,
	.carousel-control-next {
		transition: none;
	}
}
.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
	color: #fff;
	text-decoration: none;
	outline: 0;
	opacity: 0.9;
}

.carousel-control-prev {
	left: 0;
}

.carousel-control-next {
	right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
	display: inline-block;
	width: 2rem;
	height: 2rem;
	background-repeat: no-repeat;
	background-position: 50%;
	background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

.carousel-control-next-icon {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.carousel-indicators {
	position: absolute;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 2;
	display: flex;
	justify-content: center;
	padding: 0;
	margin-right: 15%;
	margin-bottom: 1rem;
	margin-left: 15%;
	list-style: none;
}
.carousel-indicators [data-bs-target] {
	box-sizing: content-box;
	flex: 0 1 auto;
	width: 30px;
	height: 3px;
	padding: 0;
	margin-right: 3px;
	margin-left: 3px;
	text-indent: -999px;
	cursor: pointer;
	background-color: #fff;
	background-clip: padding-box;
	border: 0;
	border-top: 10px solid transparent;
	border-bottom: 10px solid transparent;
	opacity: 0.5;
	transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
	.carousel-indicators [data-bs-target] {
		transition: none;
	}
}
.carousel-indicators .active {
	opacity: 1;
}

.carousel-caption {
	position: absolute;
	right: 15%;
	bottom: 1.25rem;
	left: 15%;
	padding-top: 1.25rem;
	padding-bottom: 1.25rem;
	color: #fff;
	text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
	filter: invert(1) grayscale(100);
}

.carousel-dark .carousel-indicators [data-bs-target] {
	background-color: #000;
}

.carousel-dark .carousel-caption {
	color: #000;
}

@keyframes spinner-border {
	to {
		transform: rotate(360deg) /* rtl:ignore */;
	}
}

.spinner-border {
	display: inline-block;
	width: 2rem;
	height: 2rem;
	vertical-align: -0.125em;
	border: 0.25em solid currentColor;
	border-right-color: transparent;
	border-radius: 50%;
	animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
	width: 1rem;
	height: 1rem;
	border-width: 0.2em;
}

@keyframes spinner-grow {
	0% {
		transform: scale(0);
	}
	50% {
		opacity: 1;
		transform: none;
	}
}

.spinner-grow {
	display: inline-block;
	width: 2rem;
	height: 2rem;
	vertical-align: -0.125em;
	background-color: currentColor;
	border-radius: 50%;
	opacity: 0;
	animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
	width: 1rem;
	height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
	.spinner-border,
	.spinner-grow {
		animation-duration: 1.5s;
	}
}

.offcanvas {
	position: fixed;
	bottom: 0;
	z-index: 1045;
	display: flex;
	flex-direction: column;
	max-width: 100%;
	visibility: hidden;
	background-color: #fff;
	background-clip: padding-box;
	outline: 0;
	transition: transform 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
	.offcanvas {
		transition: none;
	}
}

.offcanvas-backdrop {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1040;
	width: 100vw;
	height: 100vh;
	background-color: #000;
}
.offcanvas-backdrop.fade {
	opacity: 0;
}
.offcanvas-backdrop.show {
	opacity: 0.5;
}

.offcanvas-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem 1rem;
}
.offcanvas-header .btn-close {
	padding: 0.5rem 0.5rem;
	margin-top: -0.5rem;
	margin-right: -0.5rem;
	margin-bottom: -0.5rem;
}

.offcanvas-title {
	margin-bottom: 0;
	line-height: 1.5;
}

.offcanvas-body {
	flex-grow: 1;
	padding: 1rem 1rem;
	overflow-y: auto;
}

.offcanvas-start {
	top: 0;
	left: 0;
	width: 400px;
	border-right: 1px solid rgba(0, 0, 0, 0.2);
	transform: translateX(-100%);
}

.offcanvas-end {
	top: 0;
	right: 0;
	width: 400px;
	border-left: 1px solid rgba(0, 0, 0, 0.2);
	transform: translateX(100%);
}

.offcanvas-top {
	top: 0;
	right: 0;
	left: 0;
	height: 30vh;
	max-height: 100%;
	border-bottom: 1px solid rgba(0, 0, 0, 0.2);
	transform: translateY(-100%);
}

.offcanvas-bottom {
	right: 0;
	left: 0;
	height: 30vh;
	max-height: 100%;
	border-top: 1px solid rgba(0, 0, 0, 0.2);
	transform: translateY(100%);
}

.offcanvas.show {
	transform: none;
}

.placeholder {
	display: inline-block;
	min-height: 1em;
	vertical-align: middle;
	cursor: wait;
	background-color: currentColor;
	opacity: 0.5;
}
.placeholder.btn::before {
	display: inline-block;
	content: '';
}

.placeholder-xs {
	min-height: 0.6em;
}

.placeholder-sm {
	min-height: 0.8em;
}

.placeholder-lg {
	min-height: 1.2em;
}

.placeholder-glow .placeholder {
	animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
	50% {
		opacity: 0.2;
	}
}

.placeholder-wave {
	mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
	mask-size: 200% 100%;
	animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
	100% {
		mask-position: -200% 0%;
	}
}

.clearfix::after {
	display: block;
	clear: both;
	content: '';
}

.link-primary {
	color: #4d44b5;
}
.link-primary:hover,
.link-primary:focus {
	color: #3e3691;
}

.link-secondary {
	color: #fb7d5b;
}
.link-secondary:hover,
.link-secondary:focus {
	color: #fc977c;
}

.link-success {
	color: #1eba62;
}
.link-success:hover,
.link-success:focus {
	color: #4bc881;
}

.link-info {
	color: #00ada3;
}
.link-info:hover,
.link-info:focus {
	color: #33bdb5;
}

.link-warning {
	color: #fcc43e;
}
.link-warning:hover,
.link-warning:focus {
	color: #fdd065;
}

.link-danger {
	color: #fd5353;
}
.link-danger:hover,
.link-danger:focus {
	color: #fd7575;
}

.link-light {
	color: #ebebf9;
}
.link-light:hover,
.link-light:focus {
	color: #efeffa;
}

.link-dark {
	color: #303972;
}
.link-dark:hover,
.link-dark:focus {
	color: #262e5b;
}

.ratio {
	position: relative;
	width: 100%;
}
.ratio::before {
	display: block;
	padding-top: var(--bs-aspect-ratio);
	content: '';
}
.ratio > * {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

.ratio-1x1 {
	--bs-aspect-ratio: 100%;
}

.ratio-4x3 {
	--bs-aspect-ratio: calc(3 / 4 * 100%);
}

.ratio-16x9 {
	--bs-aspect-ratio: calc(9 / 16 * 100%);
}

.ratio-21x9 {
	--bs-aspect-ratio: calc(9 / 21 * 100%);
}

.fixed-top {
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	z-index: 1030;
}

.fixed-bottom {
	position: fixed;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1030;
}

.sticky-top {
	position: sticky;
	top: 0;
	z-index: 1020;
}

@media (min-width: 576px) {
	.sticky-sm-top {
		position: sticky;
		top: 0;
		z-index: 1020;
	}
}

@media (min-width: 768px) {
	.sticky-md-top {
		position: sticky;
		top: 0;
		z-index: 1020;
	}
}

@media (min-width: 992px) {
	.sticky-lg-top {
		position: sticky;
		top: 0;
		z-index: 1020;
	}
}

@media (min-width: 1200px) {
	.sticky-xl-top {
		position: sticky;
		top: 0;
		z-index: 1020;
	}
}

@media (min-width: 1440) {
	.sticky-xxl-top {
		position: sticky;
		top: 0;
		z-index: 1020;
	}
}

.hstack {
	display: flex;
	flex-direction: row;
	align-items: center;
	align-self: stretch;
}

.vstack {
	display: flex;
	flex: 1 1 auto;
	flex-direction: column;
	align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
	position: absolute !important;
	width: 1px !important;
	height: 1px !important;
	padding: 0 !important;
	margin: -1px !important;
	overflow: hidden !important;
	clip: rect(0, 0, 0, 0) !important;
	white-space: nowrap !important;
	border: 0 !important;
}

.stretched-link::after {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 1;
	content: '';
}

.text-truncate {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.vr {
	display: inline-block;
	align-self: stretch;
	width: 1px;
	min-height: 1em;
	background-color: currentColor;
	opacity: 0.25;
}

.align-baseline {
	vertical-align: baseline !important;
}

.align-top {
	vertical-align: top !important;
}

.align-middle {
	vertical-align: middle !important;
}

.align-bottom {
	vertical-align: bottom !important;
}

.align-text-bottom {
	vertical-align: text-bottom !important;
}

.align-text-top {
	vertical-align: text-top !important;
}

.float-start {
	float: left !important;
}

.float-end {
	float: right !important;
}

.float-none {
	float: none !important;
}

.opacity-0 {
	opacity: 0 !important;
}

.opacity-25 {
	opacity: 0.25 !important;
}

.opacity-50 {
	opacity: 0.5 !important;
}

.opacity-75 {
	opacity: 0.75 !important;
}

.opacity-100 {
	opacity: 1 !important;
}

.overflow-auto {
	overflow: auto !important;
}

.overflow-hidden {
	overflow: hidden !important;
}

.overflow-visible {
	overflow: visible !important;
}

.overflow-scroll {
	overflow: scroll !important;
}

.d-inline {
	display: inline !important;
}

.d-inline-block {
	display: inline-block !important;
}

.d-block {
	display: block !important;
}

.d-grid {
	display: grid !important;
}

.d-table {
	display: table !important;
}

.d-table-row {
	display: table-row !important;
}

.d-table-cell {
	display: table-cell !important;
}

.d-flex {
	display: flex !important;
}

.d-inline-flex {
	display: inline-flex !important;
}

.d-none {
	display: none !important;
}

.shadow {
	box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-sm {
	box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-lg {
	box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
	box-shadow: none !important;
}

.position-static {
	position: static !important;
}

.position-relative {
	position: relative !important;
}

.position-absolute {
	position: absolute !important;
}

.position-fixed {
	position: fixed !important;
}

.position-sticky {
	position: sticky !important;
}

.top-0 {
	top: 0 !important;
}

.top-50 {
	top: 50% !important;
}

.top-100 {
	top: 100% !important;
}

.bottom-0 {
	bottom: 0 !important;
}

.bottom-50 {
	bottom: 50% !important;
}

.bottom-100 {
	bottom: 100% !important;
}

.start-0 {
	left: 0 !important;
}

.start-50 {
	left: 50% !important;
}

.start-100 {
	left: 100% !important;
}

.end-0 {
	right: 0 !important;
}

.end-50 {
	right: 50% !important;
}

.end-100 {
	right: 100% !important;
}

.translate-middle {
	transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
	transform: translateX(-50%) !important;
}

.translate-middle-y {
	transform: translateY(-50%) !important;
}

.border {
	border: 1px solid #eeeeee !important;
}

.border-0 {
	border: 0 !important;
}

.border-top {
	border-top: 1px solid #eeeeee !important;
}

.border-top-0 {
	border-top: 0 !important;
}

.border-end {
	border-right: 1px solid #eeeeee !important;
}

.border-end-0 {
	border-right: 0 !important;
}

.border-bottom {
	border-bottom: 1px solid #eeeeee !important;
}

.border-bottom-0 {
	border-bottom: 0 !important;
}

.border-start {
	border-left: 1px solid #eeeeee !important;
}

.border-start-0 {
	border-left: 0 !important;
}

.border-primary {
	border-color: #4d44b5 !important;
}

.swal-border-danger {
	border: 2px solid #e64942 !important;
}

.border-secondary {
	border-color: #fb7d5b !important;
}

.border-success {
	border-color: #1eba62 !important;
}

.border-info {
	border-color: #00ada3 !important;
}

.border-warning {
	border-color: #fcc43e !important;
}

.border-danger {
	border-color: #fd5353 !important;
}

.border-light {
	border-color: #ebebf9 !important;
}

.border-dark {
	border-color: #303972 !important;
}

.border-white {
	border-color: #fff !important;
}

.border-1 {
	border-width: 1px !important;
}

.border-2 {
	border-width: 2px !important;
}

.border-3 {
	border-width: 3px !important;
}

.border-4 {
	border-width: 4px !important;
}

.border-5 {
	border-width: 5px !important;
}

.w-25 {
	width: 25% !important;
}

.w-50 {
	width: 50% !important;
}

.w-75 {
	width: 75% !important;
}

.w-100 {
	width: 100% !important;
}

.w-auto {
	width: auto !important;
}

.mw-100 {
	max-width: 100% !important;
}

.vw-100 {
	width: 100vw !important;
}

.min-vw-100 {
	min-width: 100vw !important;
}

.h-25 {
	height: 25% !important;
}

.h-50 {
	height: 50% !important;
}

.h-75 {
	height: 75% !important;
}

.h-100 {
	height: 100% !important;
}

.h-auto {
	height: auto !important;
}

.mh-100 {
	max-height: 100% !important;
}

.vh-100 {
	height: 100vh !important;
}

.min-vh-100 {
	min-height: 100vh !important;
}

.flex-fill {
	flex: 1 1 auto !important;
}

.flex-row {
	flex-direction: row !important;
}

.flex-column {
	flex-direction: column !important;
}

.flex-row-reverse {
	flex-direction: row-reverse !important;
}

.flex-column-reverse {
	flex-direction: column-reverse !important;
}

.flex-grow-0 {
	flex-grow: 0 !important;
}

.flex-grow-1 {
	flex-grow: 1 !important;
}

.flex-shrink-0 {
	flex-shrink: 0 !important;
}

.flex-shrink-1 {
	flex-shrink: 1 !important;
}

.flex-wrap {
	flex-wrap: wrap !important;
}

.flex-nowrap {
	flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
	flex-wrap: wrap-reverse !important;
}

.gap-0 {
	gap: 0 !important;
}

.gap-1 {
	gap: 0.25rem !important;
}

.gap-2 {
	gap: 0.5rem !important;
}

.gap-3 {
	gap: 1rem !important;
}

.gap-4 {
	gap: 1.875rem !important;
}

.gap-5 {
	gap: 3rem !important;
}

.justify-content-start {
	justify-content: flex-start !important;
}

.justify-content-end {
	justify-content: flex-end !important;
}

.justify-content-center {
	justify-content: center !important;
}

.justify-content-between {
	justify-content: space-between !important;
}

.justify-content-around {
	justify-content: space-around !important;
}

.justify-content-evenly {
	justify-content: space-evenly !important;
}

.align-items-start {
	align-items: flex-start !important;
}

.align-items-end {
	align-items: flex-end !important;
}

.align-items-center {
	align-items: center !important;
}

.align-items-baseline {
	align-items: baseline !important;
}

.align-items-stretch {
	align-items: stretch !important;
}

.align-content-start {
	align-content: flex-start !important;
}

.align-content-end {
	align-content: flex-end !important;
}

.align-content-center {
	align-content: center !important;
}

.align-content-between {
	align-content: space-between !important;
}

.align-content-around {
	align-content: space-around !important;
}

.align-content-stretch {
	align-content: stretch !important;
}

.align-self-auto {
	align-self: auto !important;
}

.align-self-start {
	align-self: flex-start !important;
}

.align-self-end {
	align-self: flex-end !important;
}

.align-self-center {
	align-self: center !important;
}

.align-self-baseline {
	align-self: baseline !important;
}

.align-self-stretch {
	align-self: stretch !important;
}

.order-first {
	order: -1 !important;
}

.order-0 {
	order: 0 !important;
}

.order-1 {
	order: 1 !important;
}

.order-2 {
	order: 2 !important;
}

.order-3 {
	order: 3 !important;
}

.order-4 {
	order: 4 !important;
}

.order-5 {
	order: 5 !important;
}

.order-last {
	order: 6 !important;
}

.m-0 {
	margin: 0 !important;
}

.m-1 {
	margin: 0.25rem !important;
}

.m-2 {
	margin: 0.5rem !important;
}

.m-3 {
	margin: 1rem !important;
}

.m-4 {
	margin: 1.875rem !important;
}

.m-5 {
	margin: 3rem !important;
}

.m-auto {
	margin: auto !important;
}

.mx-0 {
	margin-right: 0 !important;
	margin-left: 0 !important;
}

.mx-1 {
	margin-right: 0.25rem !important;
	margin-left: 0.25rem !important;
}

.mx-2 {
	margin-right: 0.5rem !important;
	margin-left: 0.5rem !important;
}

.mx-3 {
	margin-right: 1rem !important;
	margin-left: 1rem !important;
}

.mx-4 {
	margin-right: 1.875rem !important;
	margin-left: 1.875rem !important;
}

.mx-5 {
	margin-right: 3rem !important;
	margin-left: 3rem !important;
}

.mx-auto {
	margin-right: auto !important;
	margin-left: auto !important;
}

.my-0 {
	margin-top: 0 !important;
	margin-bottom: 0 !important;
}

.my-1 {
	margin-top: 0.25rem !important;
	margin-bottom: 0.25rem !important;
}

.my-2 {
	margin-top: 0.5rem !important;
	margin-bottom: 0.5rem !important;
}

.my-3 {
	margin-top: 1rem !important;
	margin-bottom: 1rem !important;
}

.my-4 {
	margin-top: 1.875rem !important;
	margin-bottom: 1.875rem !important;
}

.my-5 {
	margin-top: 3rem !important;
	margin-bottom: 3rem !important;
}

.my-auto {
	margin-top: auto !important;
	margin-bottom: auto !important;
}

.mt-0 {
	margin-top: 0 !important;
}

.mt-1 {
	margin-top: 0.25rem !important;
}

.mt-2 {
	margin-top: 0.5rem !important;
}

.mt-3 {
	margin-top: 1rem !important;
}

.mt-4 {
	margin-top: 1.875rem !important;
}

.mt-5 {
	margin-top: 3rem !important;
}

.mt-auto {
	margin-top: auto !important;
}

.me-0 {
	margin-right: 0 !important;
}

.me-1 {
	margin-right: 0.25rem !important;
}

.me-2 {
	margin-right: 0.5rem !important;
}

.me-3 {
	margin-right: 1rem !important;
}

.me-4 {
	margin-right: 1.875rem !important;
}

.me-5 {
	margin-right: 3rem !important;
}

.me-auto {
	margin-right: auto !important;
}

.mb-0 {
	margin-bottom: 0 !important;
}

.mb-1 {
	margin-bottom: 0.25rem !important;
}

.mb-2 {
	margin-bottom: 0.5rem !important;
}

.mb-3 {
	margin-bottom: 1rem !important;
}

.mb-4 {
	margin-bottom: 1.875rem !important;
}

.mb-5 {
	margin-bottom: 3rem !important;
}

.mb-auto {
	margin-bottom: auto !important;
}

.ms-0 {
	margin-left: 0 !important;
}

.ms-1 {
	margin-left: 0.25rem !important;
}

.ms-2 {
	margin-left: 0.5rem !important;
}

.ms-3 {
	margin-left: 1rem !important;
}

.ms-4 {
	margin-left: 1.875rem !important;
}

.ms-5 {
	margin-left: 3rem !important;
}

.ms-auto {
	margin-left: auto !important;
}

.p-0 {
	padding: 0 !important;
}

.p-1 {
	padding: 0.25rem !important;
}

.p-2 {
	padding: 0.5rem !important;
}

.p-3 {
	padding: 1rem !important;
}

.p-4 {
	padding: 1.875rem !important;
}

.p-5 {
	padding: 3rem !important;
}

.px-0 {
	padding-right: 0 !important;
	padding-left: 0 !important;
}

.px-1 {
	padding-right: 0.25rem !important;
	padding-left: 0.25rem !important;
}

.px-2 {
	padding-right: 0.5rem !important;
	padding-left: 0.5rem !important;
}

.px-3 {
	padding-right: 1rem !important;
	padding-left: 1rem !important;
}

.px-4 {
	padding-right: 1.875rem !important;
	padding-left: 1.875rem !important;
}

.px-5 {
	padding-right: 3rem !important;
	padding-left: 3rem !important;
}

.py-0 {
	padding-top: 0 !important;
	padding-bottom: 0 !important;
}

.py-1 {
	padding-top: 0.25rem !important;
	padding-bottom: 0.25rem !important;
}

.py-2 {
	padding-top: 0.5rem !important;
	padding-bottom: 0.5rem !important;
}

.py-3 {
	padding-top: 1rem !important;
	padding-bottom: 1rem !important;
}

.py-4 {
	padding-top: 1.875rem !important;
	padding-bottom: 1.875rem !important;
}

.py-5 {
	padding-top: 3rem !important;
	padding-bottom: 3rem !important;
}

.pt-0 {
	padding-top: 0 !important;
}

.pt-1 {
	padding-top: 0.25rem !important;
}

.pt-2 {
	padding-top: 0.5rem !important;
}

.pt-3 {
	padding-top: 1rem !important;
}

.pt-4 {
	padding-top: 1.875rem !important;
}

.pt-5 {
	padding-top: 3rem !important;
}

.pe-0 {
	padding-right: 0 !important;
}

.pe-1 {
	padding-right: 0.25rem !important;
}

.pe-2 {
	padding-right: 0.5rem !important;
}

.pe-3 {
	padding-right: 1rem !important;
}

.pe-4 {
	padding-right: 1.875rem !important;
}

.pe-5 {
	padding-right: 3rem !important;
}

.pb-0 {
	padding-bottom: 0 !important;
}

.pb-1 {
	padding-bottom: 0.25rem !important;
}

.pb-2 {
	padding-bottom: 0.5rem !important;
}

.pb-3 {
	padding-bottom: 1rem !important;
}

.pb-4 {
	padding-bottom: 1.875rem !important;
}

.pb-5 {
	padding-bottom: 3rem !important;
}

.ps-0 {
	padding-left: 0 !important;
}

.ps-1 {
	padding-left: 0.25rem !important;
}

.ps-2 {
	padding-left: 0.5rem !important;
}

.ps-3 {
	padding-left: 1rem !important;
}

.ps-4 {
	padding-left: 1.875rem !important;
}

.ps-5 {
	padding-left: 3rem !important;
}

.font-monospace {
	font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
	font-size: calc(1.35rem + 1.2vw) !important;
}

.fs-2 {
	font-size: calc(1.3125rem + 0.75vw) !important;
}

.fs-3 {
	font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-4 {
	font-size: 1.125rem !important;
}

.fs-5 {
	font-size: 1rem !important;
}

.fs-6 {
	font-size: 0.938rem !important;
}

.fst-italic {
	font-style: italic !important;
}

.fst-normal {
	font-style: normal !important;
}

.fw-light {
	font-weight: 300 !important;
}

.fw-lighter {
	font-weight: lighter !important;
}

.fw-normal {
	font-weight: 400 !important;
}

.fw-semi-bold {
	font-weight: 600 !important;
}

.fw-bold {
	font-weight: 700 !important;
}

.fw-bolder {
	font-weight: bolder !important;
}

.lh-1 {
	line-height: 1 !important;
}

.lh-sm {
	line-height: 1.25 !important;
}

.lh-base {
	line-height: 1.5 !important;
}

.lh-lg {
	line-height: 2 !important;
}

.text-start {
	text-align: left !important;
}

.text-end {
	text-align: right !important;
}

.text-center {
	text-align: center !important;
}

.text-decoration-none {
	text-decoration: none !important;
}

.text-decoration-underline {
	text-decoration: underline !important;
}

.text-decoration-line-through {
	text-decoration: line-through !important;
}

.text-lowercase {
	text-transform: lowercase !important;
}

.text-uppercase {
	text-transform: uppercase !important;
}

.text-capitalize {
	text-transform: capitalize !important;
}

.text-wrap {
	white-space: normal !important;
}

.text-nowrap {
	white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
	word-wrap: break-word !important;
	word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
	--bs-text-opacity: 1;
	color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
	--bs-text-opacity: 1;
	color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
	--bs-text-opacity: 1;
	color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
	--bs-text-opacity: 1;
	color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
	--bs-text-opacity: 1;
	color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
	--bs-text-opacity: 1;
	color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
	--bs-text-opacity: 1;
	color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
	--bs-text-opacity: 1;
	color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
	--bs-text-opacity: 1;
	color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
	--bs-text-opacity: 1;
	color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
	--bs-text-opacity: 1;
	color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
	--bs-text-opacity: 1;
	color: #89879f !important;
}

.text-black-50 {
	--bs-text-opacity: 1;
	color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
	--bs-text-opacity: 1;
	color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
	--bs-text-opacity: 1;
	color: inherit !important;
}

.text-opacity-25 {
	--bs-text-opacity: 0.25;
}

.text-opacity-50 {
	--bs-text-opacity: 0.5;
}

.text-opacity-75 {
	--bs-text-opacity: 0.75;
}

.text-opacity-100 {
	--bs-text-opacity: 1;
}

.bg-primary {
	--bs-bg-opacity: 1;
	background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
	--bs-bg-opacity: 1;
	background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
	--bs-bg-opacity: 1;
	background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
	--bs-bg-opacity: 1;
	background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
	--bs-bg-opacity: 1;
	background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
	--bs-bg-opacity: 1;
	background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
	--bs-bg-opacity: 1;
	background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
	--bs-bg-opacity: 1;
	background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
	--bs-bg-opacity: 1;
	background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
	--bs-bg-opacity: 1;
	background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
	--bs-bg-opacity: 1;
	background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
	--bs-bg-opacity: 1;
	background-color: transparent !important;
}

.bg-opacity-10 {
	--bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
	--bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
	--bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
	--bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
	--bs-bg-opacity: 1;
}

.bg-gradient {
	background-image: var(--bs-gradient) !important;
}

.user-select-all {
	-webkit-user-select: all !important;
	        user-select: all !important;
}

.user-select-auto {
	-webkit-user-select: auto !important;
	        user-select: auto !important;
}

.user-select-none {
	-webkit-user-select: none !important;
	        user-select: none !important;
}

.pe-none {
	pointer-events: none !important;
}

.pe-auto {
	pointer-events: auto !important;
}

.rounded {
	border-radius: 0.625rem !important;
}

.rounded-0 {
	border-radius: 0 !important;
}

.rounded-1 {
	border-radius: 0.625rem !important;
}

.rounded-2 {
	border-radius: 0.625rem !important;
}

.rounded-3 {
	border-radius: 0.625rem !important;
}

.rounded-circle {
	border-radius: 50% !important;
}

.rounded-pill {
	border-radius: 0.625rem !important;
}

.rounded-top {
	border-top-left-radius: 0.625rem !important;
	border-top-right-radius: 0.625rem !important;
}

.rounded-end {
	border-top-right-radius: 0.625rem !important;
	border-bottom-right-radius: 0.625rem !important;
}

.rounded-bottom {
	border-bottom-right-radius: 0.625rem !important;
	border-bottom-left-radius: 0.625rem !important;
}

.rounded-start {
	border-bottom-left-radius: 0.625rem !important;
	border-top-left-radius: 0.625rem !important;
}

.visible {
	visibility: visible !important;
}

.invisible {
	visibility: hidden !important;
}

@media (min-width: 576px) {
	.float-sm-start {
		float: left !important;
	}
	.float-sm-end {
		float: right !important;
	}
	.float-sm-none {
		float: none !important;
	}
	.d-sm-inline {
		display: inline !important;
	}
	.d-sm-inline-block {
		display: inline-block !important;
	}
	.d-sm-block {
		display: block !important;
	}
	.d-sm-grid {
		display: grid !important;
	}
	.d-sm-table {
		display: table !important;
	}
	.d-sm-table-row {
		display: table-row !important;
	}
	.d-sm-table-cell {
		display: table-cell !important;
	}
	.d-sm-flex {
		display: flex !important;
	}
	.d-sm-inline-flex {
		display: inline-flex !important;
	}
	.d-sm-none {
		display: none !important;
	}
	.flex-sm-fill {
		flex: 1 1 auto !important;
	}
	.flex-sm-row {
		flex-direction: row !important;
	}
	.flex-sm-column {
		flex-direction: column !important;
	}
	.flex-sm-row-reverse {
		flex-direction: row-reverse !important;
	}
	.flex-sm-column-reverse {
		flex-direction: column-reverse !important;
	}
	.flex-sm-grow-0 {
		flex-grow: 0 !important;
	}
	.flex-sm-grow-1 {
		flex-grow: 1 !important;
	}
	.flex-sm-shrink-0 {
		flex-shrink: 0 !important;
	}
	.flex-sm-shrink-1 {
		flex-shrink: 1 !important;
	}
	.flex-sm-wrap {
		flex-wrap: wrap !important;
	}
	.flex-sm-nowrap {
		flex-wrap: nowrap !important;
	}
	.flex-sm-wrap-reverse {
		flex-wrap: wrap-reverse !important;
	}
	.gap-sm-0 {
		gap: 0 !important;
	}
	.gap-sm-1 {
		gap: 0.25rem !important;
	}
	.gap-sm-2 {
		gap: 0.5rem !important;
	}
	.gap-sm-3 {
		gap: 1rem !important;
	}
	.gap-sm-4 {
		gap: 1.875rem !important;
	}
	.gap-sm-5 {
		gap: 3rem !important;
	}
	.justify-content-sm-start {
		justify-content: flex-start !important;
	}
	.justify-content-sm-end {
		justify-content: flex-end !important;
	}
	.justify-content-sm-center {
		justify-content: center !important;
	}
	.justify-content-sm-between {
		justify-content: space-between !important;
	}
	.justify-content-sm-around {
		justify-content: space-around !important;
	}
	.justify-content-sm-evenly {
		justify-content: space-evenly !important;
	}
	.align-items-sm-start {
		align-items: flex-start !important;
	}
	.align-items-sm-end {
		align-items: flex-end !important;
	}
	.align-items-sm-center {
		align-items: center !important;
	}
	.align-items-sm-baseline {
		align-items: baseline !important;
	}
	.align-items-sm-stretch {
		align-items: stretch !important;
	}
	.align-content-sm-start {
		align-content: flex-start !important;
	}
	.align-content-sm-end {
		align-content: flex-end !important;
	}
	.align-content-sm-center {
		align-content: center !important;
	}
	.align-content-sm-between {
		align-content: space-between !important;
	}
	.align-content-sm-around {
		align-content: space-around !important;
	}
	.align-content-sm-stretch {
		align-content: stretch !important;
	}
	.align-self-sm-auto {
		align-self: auto !important;
	}
	.align-self-sm-start {
		align-self: flex-start !important;
	}
	.align-self-sm-end {
		align-self: flex-end !important;
	}
	.align-self-sm-center {
		align-self: center !important;
	}
	.align-self-sm-baseline {
		align-self: baseline !important;
	}
	.align-self-sm-stretch {
		align-self: stretch !important;
	}
	.order-sm-first {
		order: -1 !important;
	}
	.order-sm-0 {
		order: 0 !important;
	}
	.order-sm-1 {
		order: 1 !important;
	}
	.order-sm-2 {
		order: 2 !important;
	}
	.order-sm-3 {
		order: 3 !important;
	}
	.order-sm-4 {
		order: 4 !important;
	}
	.order-sm-5 {
		order: 5 !important;
	}
	.order-sm-last {
		order: 6 !important;
	}
	.m-sm-0 {
		margin: 0 !important;
	}
	.m-sm-1 {
		margin: 0.25rem !important;
	}
	.m-sm-2 {
		margin: 0.5rem !important;
	}
	.m-sm-3 {
		margin: 1rem !important;
	}
	.m-sm-4 {
		margin: 1.875rem !important;
	}
	.m-sm-5 {
		margin: 3rem !important;
	}
	.m-sm-auto {
		margin: auto !important;
	}
	.mx-sm-0 {
		margin-right: 0 !important;
		margin-left: 0 !important;
	}
	.mx-sm-1 {
		margin-right: 0.25rem !important;
		margin-left: 0.25rem !important;
	}
	.mx-sm-2 {
		margin-right: 0.5rem !important;
		margin-left: 0.5rem !important;
	}
	.mx-sm-3 {
		margin-right: 1rem !important;
		margin-left: 1rem !important;
	}
	.mx-sm-4 {
		margin-right: 1.875rem !important;
		margin-left: 1.875rem !important;
	}
	.mx-sm-5 {
		margin-right: 3rem !important;
		margin-left: 3rem !important;
	}
	.mx-sm-auto {
		margin-right: auto !important;
		margin-left: auto !important;
	}
	.my-sm-0 {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}
	.my-sm-1 {
		margin-top: 0.25rem !important;
		margin-bottom: 0.25rem !important;
	}
	.my-sm-2 {
		margin-top: 0.5rem !important;
		margin-bottom: 0.5rem !important;
	}
	.my-sm-3 {
		margin-top: 1rem !important;
		margin-bottom: 1rem !important;
	}
	.my-sm-4 {
		margin-top: 1.875rem !important;
		margin-bottom: 1.875rem !important;
	}
	.my-sm-5 {
		margin-top: 3rem !important;
		margin-bottom: 3rem !important;
	}
	.my-sm-auto {
		margin-top: auto !important;
		margin-bottom: auto !important;
	}
	.mt-sm-0 {
		margin-top: 0 !important;
	}
	.mt-sm-1 {
		margin-top: 0.25rem !important;
	}
	.mt-sm-2 {
		margin-top: 0.5rem !important;
	}
	.mt-sm-3 {
		margin-top: 1rem !important;
	}
	.mt-sm-4 {
		margin-top: 1.875rem !important;
	}
	.mt-sm-5 {
		margin-top: 3rem !important;
	}
	.mt-sm-auto {
		margin-top: auto !important;
	}
	.me-sm-0 {
		margin-right: 0 !important;
	}
	.me-sm-1 {
		margin-right: 0.25rem !important;
	}
	.me-sm-2 {
		margin-right: 0.5rem !important;
	}
	.me-sm-3 {
		margin-right: 1rem !important;
	}
	.me-sm-4 {
		margin-right: 1.875rem !important;
	}
	.me-sm-5 {
		margin-right: 3rem !important;
	}
	.me-sm-auto {
		margin-right: auto !important;
	}
	.mb-sm-0 {
		margin-bottom: 0 !important;
	}
	.mb-sm-1 {
		margin-bottom: 0.25rem !important;
	}
	.mb-sm-2 {
		margin-bottom: 0.5rem !important;
	}
	.mb-sm-3 {
		margin-bottom: 1rem !important;
	}
	.mb-sm-4 {
		margin-bottom: 1.875rem !important;
	}
	.mb-sm-5 {
		margin-bottom: 3rem !important;
	}
	.mb-sm-auto {
		margin-bottom: auto !important;
	}
	.ms-sm-0 {
		margin-left: 0 !important;
	}
	.ms-sm-1 {
		margin-left: 0.25rem !important;
	}
	.ms-sm-2 {
		margin-left: 0.5rem !important;
	}
	.ms-sm-3 {
		margin-left: 1rem !important;
	}
	.ms-sm-4 {
		margin-left: 1.875rem !important;
	}
	.ms-sm-5 {
		margin-left: 3rem !important;
	}
	.ms-sm-auto {
		margin-left: auto !important;
	}
	.p-sm-0 {
		padding: 0 !important;
	}
	.p-sm-1 {
		padding: 0.25rem !important;
	}
	.p-sm-2 {
		padding: 0.5rem !important;
	}
	.p-sm-3 {
		padding: 1rem !important;
	}
	.p-sm-4 {
		padding: 1.875rem !important;
	}
	.p-sm-5 {
		padding: 3rem !important;
	}
	.px-sm-0 {
		padding-right: 0 !important;
		padding-left: 0 !important;
	}
	.px-sm-1 {
		padding-right: 0.25rem !important;
		padding-left: 0.25rem !important;
	}
	.px-sm-2 {
		padding-right: 0.5rem !important;
		padding-left: 0.5rem !important;
	}
	.px-sm-3 {
		padding-right: 1rem !important;
		padding-left: 1rem !important;
	}
	.px-sm-4 {
		padding-right: 1.875rem !important;
		padding-left: 1.875rem !important;
	}
	.px-sm-5 {
		padding-right: 3rem !important;
		padding-left: 3rem !important;
	}
	.py-sm-0 {
		padding-top: 0 !important;
		padding-bottom: 0 !important;
	}
	.py-sm-1 {
		padding-top: 0.25rem !important;
		padding-bottom: 0.25rem !important;
	}
	.py-sm-2 {
		padding-top: 0.5rem !important;
		padding-bottom: 0.5rem !important;
	}
	.py-sm-3 {
		padding-top: 1rem !important;
		padding-bottom: 1rem !important;
	}
	.py-sm-4 {
		padding-top: 1.875rem !important;
		padding-bottom: 1.875rem !important;
	}
	.py-sm-5 {
		padding-top: 3rem !important;
		padding-bottom: 3rem !important;
	}
	.pt-sm-0 {
		padding-top: 0 !important;
	}
	.pt-sm-1 {
		padding-top: 0.25rem !important;
	}
	.pt-sm-2 {
		padding-top: 0.5rem !important;
	}
	.pt-sm-3 {
		padding-top: 1rem !important;
	}
	.pt-sm-4 {
		padding-top: 1.875rem !important;
	}
	.pt-sm-5 {
		padding-top: 3rem !important;
	}
	.pe-sm-0 {
		padding-right: 0 !important;
	}
	.pe-sm-1 {
		padding-right: 0.25rem !important;
	}
	.pe-sm-2 {
		padding-right: 0.5rem !important;
	}
	.pe-sm-3 {
		padding-right: 1rem !important;
	}
	.pe-sm-4 {
		padding-right: 1.875rem !important;
	}
	.pe-sm-5 {
		padding-right: 3rem !important;
	}
	.pb-sm-0 {
		padding-bottom: 0 !important;
	}
	.pb-sm-1 {
		padding-bottom: 0.25rem !important;
	}
	.pb-sm-2 {
		padding-bottom: 0.5rem !important;
	}
	.pb-sm-3 {
		padding-bottom: 1rem !important;
	}
	.pb-sm-4 {
		padding-bottom: 1.875rem !important;
	}
	.pb-sm-5 {
		padding-bottom: 3rem !important;
	}
	.ps-sm-0 {
		padding-left: 0 !important;
	}
	.ps-sm-1 {
		padding-left: 0.25rem !important;
	}
	.ps-sm-2 {
		padding-left: 0.5rem !important;
	}
	.ps-sm-3 {
		padding-left: 1rem !important;
	}
	.ps-sm-4 {
		padding-left: 1.875rem !important;
	}
	.ps-sm-5 {
		padding-left: 3rem !important;
	}
	.text-sm-start {
		text-align: left !important;
	}
	.text-sm-end {
		text-align: right !important;
	}
	.text-sm-center {
		text-align: center !important;
	}
}

@media (min-width: 768px) {
	.float-md-start {
		float: left !important;
	}
	.float-md-end {
		float: right !important;
	}
	.float-md-none {
		float: none !important;
	}
	.d-md-inline {
		display: inline !important;
	}
	.d-md-inline-block {
		display: inline-block !important;
	}
	.d-md-block {
		display: block !important;
	}
	.d-md-grid {
		display: grid !important;
	}
	.d-md-table {
		display: table !important;
	}
	.d-md-table-row {
		display: table-row !important;
	}
	.d-md-table-cell {
		display: table-cell !important;
	}
	.d-md-flex {
		display: flex !important;
	}
	.d-md-inline-flex {
		display: inline-flex !important;
	}
	.d-md-none {
		display: none !important;
	}
	.flex-md-fill {
		flex: 1 1 auto !important;
	}
	.flex-md-row {
		flex-direction: row !important;
	}
	.flex-md-column {
		flex-direction: column !important;
	}
	.flex-md-row-reverse {
		flex-direction: row-reverse !important;
	}
	.flex-md-column-reverse {
		flex-direction: column-reverse !important;
	}
	.flex-md-grow-0 {
		flex-grow: 0 !important;
	}
	.flex-md-grow-1 {
		flex-grow: 1 !important;
	}
	.flex-md-shrink-0 {
		flex-shrink: 0 !important;
	}
	.flex-md-shrink-1 {
		flex-shrink: 1 !important;
	}
	.flex-md-wrap {
		flex-wrap: wrap !important;
	}
	.flex-md-nowrap {
		flex-wrap: nowrap !important;
	}
	.flex-md-wrap-reverse {
		flex-wrap: wrap-reverse !important;
	}
	.gap-md-0 {
		gap: 0 !important;
	}
	.gap-md-1 {
		gap: 0.25rem !important;
	}
	.gap-md-2 {
		gap: 0.5rem !important;
	}
	.gap-md-3 {
		gap: 1rem !important;
	}
	.gap-md-4 {
		gap: 1.875rem !important;
	}
	.gap-md-5 {
		gap: 3rem !important;
	}
	.justify-content-md-start {
		justify-content: flex-start !important;
	}
	.justify-content-md-end {
		justify-content: flex-end !important;
	}
	.justify-content-md-center {
		justify-content: center !important;
	}
	.justify-content-md-between {
		justify-content: space-between !important;
	}
	.justify-content-md-around {
		justify-content: space-around !important;
	}
	.justify-content-md-evenly {
		justify-content: space-evenly !important;
	}
	.align-items-md-start {
		align-items: flex-start !important;
	}
	.align-items-md-end {
		align-items: flex-end !important;
	}
	.align-items-md-center {
		align-items: center !important;
	}
	.align-items-md-baseline {
		align-items: baseline !important;
	}
	.align-items-md-stretch {
		align-items: stretch !important;
	}
	.align-content-md-start {
		align-content: flex-start !important;
	}
	.align-content-md-end {
		align-content: flex-end !important;
	}
	.align-content-md-center {
		align-content: center !important;
	}
	.align-content-md-between {
		align-content: space-between !important;
	}
	.align-content-md-around {
		align-content: space-around !important;
	}
	.align-content-md-stretch {
		align-content: stretch !important;
	}
	.align-self-md-auto {
		align-self: auto !important;
	}
	.align-self-md-start {
		align-self: flex-start !important;
	}
	.align-self-md-end {
		align-self: flex-end !important;
	}
	.align-self-md-center {
		align-self: center !important;
	}
	.align-self-md-baseline {
		align-self: baseline !important;
	}
	.align-self-md-stretch {
		align-self: stretch !important;
	}
	.order-md-first {
		order: -1 !important;
	}
	.order-md-0 {
		order: 0 !important;
	}
	.order-md-1 {
		order: 1 !important;
	}
	.order-md-2 {
		order: 2 !important;
	}
	.order-md-3 {
		order: 3 !important;
	}
	.order-md-4 {
		order: 4 !important;
	}
	.order-md-5 {
		order: 5 !important;
	}
	.order-md-last {
		order: 6 !important;
	}
	.m-md-0 {
		margin: 0 !important;
	}
	.m-md-1 {
		margin: 0.25rem !important;
	}
	.m-md-2 {
		margin: 0.5rem !important;
	}
	.m-md-3 {
		margin: 1rem !important;
	}
	.m-md-4 {
		margin: 1.875rem !important;
	}
	.m-md-5 {
		margin: 3rem !important;
	}
	.m-md-auto {
		margin: auto !important;
	}
	.mx-md-0 {
		margin-right: 0 !important;
		margin-left: 0 !important;
	}
	.mx-md-1 {
		margin-right: 0.25rem !important;
		margin-left: 0.25rem !important;
	}
	.mx-md-2 {
		margin-right: 0.5rem !important;
		margin-left: 0.5rem !important;
	}
	.mx-md-3 {
		margin-right: 1rem !important;
		margin-left: 1rem !important;
	}
	.mx-md-4 {
		margin-right: 1.875rem !important;
		margin-left: 1.875rem !important;
	}
	.mx-md-5 {
		margin-right: 3rem !important;
		margin-left: 3rem !important;
	}
	.mx-md-auto {
		margin-right: auto !important;
		margin-left: auto !important;
	}
	.my-md-0 {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}
	.my-md-1 {
		margin-top: 0.25rem !important;
		margin-bottom: 0.25rem !important;
	}
	.my-md-2 {
		margin-top: 0.5rem !important;
		margin-bottom: 0.5rem !important;
	}
	.my-md-3 {
		margin-top: 1rem !important;
		margin-bottom: 1rem !important;
	}
	.my-md-4 {
		margin-top: 1.875rem !important;
		margin-bottom: 1.875rem !important;
	}
	.my-md-5 {
		margin-top: 3rem !important;
		margin-bottom: 3rem !important;
	}
	.my-md-auto {
		margin-top: auto !important;
		margin-bottom: auto !important;
	}
	.mt-md-0 {
		margin-top: 0 !important;
	}
	.mt-md-1 {
		margin-top: 0.25rem !important;
	}
	.mt-md-2 {
		margin-top: 0.5rem !important;
	}
	.mt-md-3 {
		margin-top: 1rem !important;
	}
	.mt-md-4 {
		margin-top: 1.875rem !important;
	}
	.mt-md-5 {
		margin-top: 3rem !important;
	}
	.mt-md-auto {
		margin-top: auto !important;
	}
	.me-md-0 {
		margin-right: 0 !important;
	}
	.me-md-1 {
		margin-right: 0.25rem !important;
	}
	.me-md-2 {
		margin-right: 0.5rem !important;
	}
	.me-md-3 {
		margin-right: 1rem !important;
	}
	.me-md-4 {
		margin-right: 1.875rem !important;
	}
	.me-md-5 {
		margin-right: 3rem !important;
	}
	.me-md-auto {
		margin-right: auto !important;
	}
	.mb-md-0 {
		margin-bottom: 0 !important;
	}
	.mb-md-1 {
		margin-bottom: 0.25rem !important;
	}
	.mb-md-2 {
		margin-bottom: 0.5rem !important;
	}
	.mb-md-3 {
		margin-bottom: 1rem !important;
	}
	.mb-md-4 {
		margin-bottom: 1.875rem !important;
	}
	.mb-md-5 {
		margin-bottom: 3rem !important;
	}
	.mb-md-auto {
		margin-bottom: auto !important;
	}
	.ms-md-0 {
		margin-left: 0 !important;
	}
	.ms-md-1 {
		margin-left: 0.25rem !important;
	}
	.ms-md-2 {
		margin-left: 0.5rem !important;
	}
	.ms-md-3 {
		margin-left: 1rem !important;
	}
	.ms-md-4 {
		margin-left: 1.875rem !important;
	}
	.ms-md-5 {
		margin-left: 3rem !important;
	}
	.ms-md-auto {
		margin-left: auto !important;
	}
	.p-md-0 {
		padding: 0 !important;
	}
	.p-md-1 {
		padding: 0.25rem !important;
	}
	.p-md-2 {
		padding: 0.5rem !important;
	}
	.p-md-3 {
		padding: 1rem !important;
	}
	.p-md-4 {
		padding: 1.875rem !important;
	}
	.p-md-5 {
		padding: 3rem !important;
	}
	.px-md-0 {
		padding-right: 0 !important;
		padding-left: 0 !important;
	}
	.px-md-1 {
		padding-right: 0.25rem !important;
		padding-left: 0.25rem !important;
	}
	.px-md-2 {
		padding-right: 0.5rem !important;
		padding-left: 0.5rem !important;
	}
	.px-md-3 {
		padding-right: 1rem !important;
		padding-left: 1rem !important;
	}
	.px-md-4 {
		padding-right: 1.875rem !important;
		padding-left: 1.875rem !important;
	}
	.px-md-5 {
		padding-right: 3rem !important;
		padding-left: 3rem !important;
	}
	.py-md-0 {
		padding-top: 0 !important;
		padding-bottom: 0 !important;
	}
	.py-md-1 {
		padding-top: 0.25rem !important;
		padding-bottom: 0.25rem !important;
	}
	.py-md-2 {
		padding-top: 0.5rem !important;
		padding-bottom: 0.5rem !important;
	}
	.py-md-3 {
		padding-top: 1rem !important;
		padding-bottom: 1rem !important;
	}
	.py-md-4 {
		padding-top: 1.875rem !important;
		padding-bottom: 1.875rem !important;
	}
	.py-md-5 {
		padding-top: 3rem !important;
		padding-bottom: 3rem !important;
	}
	.pt-md-0 {
		padding-top: 0 !important;
	}
	.pt-md-1 {
		padding-top: 0.25rem !important;
	}
	.pt-md-2 {
		padding-top: 0.5rem !important;
	}
	.pt-md-3 {
		padding-top: 1rem !important;
	}
	.pt-md-4 {
		padding-top: 1.875rem !important;
	}
	.pt-md-5 {
		padding-top: 3rem !important;
	}
	.pe-md-0 {
		padding-right: 0 !important;
	}
	.pe-md-1 {
		padding-right: 0.25rem !important;
	}
	.pe-md-2 {
		padding-right: 0.5rem !important;
	}
	.pe-md-3 {
		padding-right: 1rem !important;
	}
	.pe-md-4 {
		padding-right: 1.875rem !important;
	}
	.pe-md-5 {
		padding-right: 3rem !important;
	}
	.pb-md-0 {
		padding-bottom: 0 !important;
	}
	.pb-md-1 {
		padding-bottom: 0.25rem !important;
	}
	.pb-md-2 {
		padding-bottom: 0.5rem !important;
	}
	.pb-md-3 {
		padding-bottom: 1rem !important;
	}
	.pb-md-4 {
		padding-bottom: 1.875rem !important;
	}
	.pb-md-5 {
		padding-bottom: 3rem !important;
	}
	.ps-md-0 {
		padding-left: 0 !important;
	}
	.ps-md-1 {
		padding-left: 0.25rem !important;
	}
	.ps-md-2 {
		padding-left: 0.5rem !important;
	}
	.ps-md-3 {
		padding-left: 1rem !important;
	}
	.ps-md-4 {
		padding-left: 1.875rem !important;
	}
	.ps-md-5 {
		padding-left: 3rem !important;
	}
	.text-md-start {
		text-align: left !important;
	}
	.text-md-end {
		text-align: right !important;
	}
	.text-md-center {
		text-align: center !important;
	}
}

@media (min-width: 992px) {
	.float-lg-start {
		float: left !important;
	}
	.float-lg-end {
		float: right !important;
	}
	.float-lg-none {
		float: none !important;
	}
	.d-lg-inline {
		display: inline !important;
	}
	.d-lg-inline-block {
		display: inline-block !important;
	}
	.d-lg-block {
		display: block !important;
	}
	.d-lg-grid {
		display: grid !important;
	}
	.d-lg-table {
		display: table !important;
	}
	.d-lg-table-row {
		display: table-row !important;
	}
	.d-lg-table-cell {
		display: table-cell !important;
	}
	.d-lg-flex {
		display: flex !important;
	}
	.d-lg-inline-flex {
		display: inline-flex !important;
	}
	.d-lg-none {
		display: none !important;
	}
	.flex-lg-fill {
		flex: 1 1 auto !important;
	}
	.flex-lg-row {
		flex-direction: row !important;
	}
	.flex-lg-column {
		flex-direction: column !important;
	}
	.flex-lg-row-reverse {
		flex-direction: row-reverse !important;
	}
	.flex-lg-column-reverse {
		flex-direction: column-reverse !important;
	}
	.flex-lg-grow-0 {
		flex-grow: 0 !important;
	}
	.flex-lg-grow-1 {
		flex-grow: 1 !important;
	}
	.flex-lg-shrink-0 {
		flex-shrink: 0 !important;
	}
	.flex-lg-shrink-1 {
		flex-shrink: 1 !important;
	}
	.flex-lg-wrap {
		flex-wrap: wrap !important;
	}
	.flex-lg-nowrap {
		flex-wrap: nowrap !important;
	}
	.flex-lg-wrap-reverse {
		flex-wrap: wrap-reverse !important;
	}
	.gap-lg-0 {
		gap: 0 !important;
	}
	.gap-lg-1 {
		gap: 0.25rem !important;
	}
	.gap-lg-2 {
		gap: 0.5rem !important;
	}
	.gap-lg-3 {
		gap: 1rem !important;
	}
	.gap-lg-4 {
		gap: 1.875rem !important;
	}
	.gap-lg-5 {
		gap: 3rem !important;
	}
	.justify-content-lg-start {
		justify-content: flex-start !important;
	}
	.justify-content-lg-end {
		justify-content: flex-end !important;
	}
	.justify-content-lg-center {
		justify-content: center !important;
	}
	.justify-content-lg-between {
		justify-content: space-between !important;
	}
	.justify-content-lg-around {
		justify-content: space-around !important;
	}
	.justify-content-lg-evenly {
		justify-content: space-evenly !important;
	}
	.align-items-lg-start {
		align-items: flex-start !important;
	}
	.align-items-lg-end {
		align-items: flex-end !important;
	}
	.align-items-lg-center {
		align-items: center !important;
	}
	.align-items-lg-baseline {
		align-items: baseline !important;
	}
	.align-items-lg-stretch {
		align-items: stretch !important;
	}
	.align-content-lg-start {
		align-content: flex-start !important;
	}
	.align-content-lg-end {
		align-content: flex-end !important;
	}
	.align-content-lg-center {
		align-content: center !important;
	}
	.align-content-lg-between {
		align-content: space-between !important;
	}
	.align-content-lg-around {
		align-content: space-around !important;
	}
	.align-content-lg-stretch {
		align-content: stretch !important;
	}
	.align-self-lg-auto {
		align-self: auto !important;
	}
	.align-self-lg-start {
		align-self: flex-start !important;
	}
	.align-self-lg-end {
		align-self: flex-end !important;
	}
	.align-self-lg-center {
		align-self: center !important;
	}
	.align-self-lg-baseline {
		align-self: baseline !important;
	}
	.align-self-lg-stretch {
		align-self: stretch !important;
	}
	.order-lg-first {
		order: -1 !important;
	}
	.order-lg-0 {
		order: 0 !important;
	}
	.order-lg-1 {
		order: 1 !important;
	}
	.order-lg-2 {
		order: 2 !important;
	}
	.order-lg-3 {
		order: 3 !important;
	}
	.order-lg-4 {
		order: 4 !important;
	}
	.order-lg-5 {
		order: 5 !important;
	}
	.order-lg-last {
		order: 6 !important;
	}
	.m-lg-0 {
		margin: 0 !important;
	}
	.m-lg-1 {
		margin: 0.25rem !important;
	}
	.m-lg-2 {
		margin: 0.5rem !important;
	}
	.m-lg-3 {
		margin: 1rem !important;
	}
	.m-lg-4 {
		margin: 1.875rem !important;
	}
	.m-lg-5 {
		margin: 3rem !important;
	}
	.m-lg-auto {
		margin: auto !important;
	}
	.mx-lg-0 {
		margin-right: 0 !important;
		margin-left: 0 !important;
	}
	.mx-lg-1 {
		margin-right: 0.25rem !important;
		margin-left: 0.25rem !important;
	}
	.mx-lg-2 {
		margin-right: 0.5rem !important;
		margin-left: 0.5rem !important;
	}
	.mx-lg-3 {
		margin-right: 1rem !important;
		margin-left: 1rem !important;
	}
	.mx-lg-4 {
		margin-right: 1.875rem !important;
		margin-left: 1.875rem !important;
	}
	.mx-lg-5 {
		margin-right: 3rem !important;
		margin-left: 3rem !important;
	}
	.mx-lg-auto {
		margin-right: auto !important;
		margin-left: auto !important;
	}
	.my-lg-0 {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}
	.my-lg-1 {
		margin-top: 0.25rem !important;
		margin-bottom: 0.25rem !important;
	}
	.my-lg-2 {
		margin-top: 0.5rem !important;
		margin-bottom: 0.5rem !important;
	}
	.my-lg-3 {
		margin-top: 1rem !important;
		margin-bottom: 1rem !important;
	}
	.my-lg-4 {
		margin-top: 1.875rem !important;
		margin-bottom: 1.875rem !important;
	}
	.my-lg-5 {
		margin-top: 3rem !important;
		margin-bottom: 3rem !important;
	}
	.my-lg-auto {
		margin-top: auto !important;
		margin-bottom: auto !important;
	}
	.mt-lg-0 {
		margin-top: 0 !important;
	}
	.mt-lg-1 {
		margin-top: 0.25rem !important;
	}
	.mt-lg-2 {
		margin-top: 0.5rem !important;
	}
	.mt-lg-3 {
		margin-top: 1rem !important;
	}
	.mt-lg-4 {
		margin-top: 1.875rem !important;
	}
	.mt-lg-5 {
		margin-top: 3rem !important;
	}
	.mt-lg-auto {
		margin-top: auto !important;
	}
	.me-lg-0 {
		margin-right: 0 !important;
	}
	.me-lg-1 {
		margin-right: 0.25rem !important;
	}
	.me-lg-2 {
		margin-right: 0.5rem !important;
	}
	.me-lg-3 {
		margin-right: 1rem !important;
	}
	.me-lg-4 {
		margin-right: 1.875rem !important;
	}
	.me-lg-5 {
		margin-right: 3rem !important;
	}
	.me-lg-auto {
		margin-right: auto !important;
	}
	.mb-lg-0 {
		margin-bottom: 0 !important;
	}
	.mb-lg-1 {
		margin-bottom: 0.25rem !important;
	}
	.mb-lg-2 {
		margin-bottom: 0.5rem !important;
	}
	.mb-lg-3 {
		margin-bottom: 1rem !important;
	}
	.mb-lg-4 {
		margin-bottom: 1.875rem !important;
	}
	.mb-lg-5 {
		margin-bottom: 3rem !important;
	}
	.mb-lg-auto {
		margin-bottom: auto !important;
	}
	.ms-lg-0 {
		margin-left: 0 !important;
	}
	.ms-lg-1 {
		margin-left: 0.25rem !important;
	}
	.ms-lg-2 {
		margin-left: 0.5rem !important;
	}
	.ms-lg-3 {
		margin-left: 1rem !important;
	}
	.ms-lg-4 {
		margin-left: 1.875rem !important;
	}
	.ms-lg-5 {
		margin-left: 3rem !important;
	}
	.ms-lg-auto {
		margin-left: auto !important;
	}
	.p-lg-0 {
		padding: 0 !important;
	}
	.p-lg-1 {
		padding: 0.25rem !important;
	}
	.p-lg-2 {
		padding: 0.5rem !important;
	}
	.p-lg-3 {
		padding: 1rem !important;
	}
	.p-lg-4 {
		padding: 1.875rem !important;
	}
	.p-lg-5 {
		padding: 3rem !important;
	}
	.px-lg-0 {
		padding-right: 0 !important;
		padding-left: 0 !important;
	}
	.px-lg-1 {
		padding-right: 0.25rem !important;
		padding-left: 0.25rem !important;
	}
	.px-lg-2 {
		padding-right: 0.5rem !important;
		padding-left: 0.5rem !important;
	}
	.px-lg-3 {
		padding-right: 1rem !important;
		padding-left: 1rem !important;
	}
	.px-lg-4 {
		padding-right: 1.875rem !important;
		padding-left: 1.875rem !important;
	}
	.px-lg-5 {
		padding-right: 3rem !important;
		padding-left: 3rem !important;
	}
	.py-lg-0 {
		padding-top: 0 !important;
		padding-bottom: 0 !important;
	}
	.py-lg-1 {
		padding-top: 0.25rem !important;
		padding-bottom: 0.25rem !important;
	}
	.py-lg-2 {
		padding-top: 0.5rem !important;
		padding-bottom: 0.5rem !important;
	}
	.py-lg-3 {
		padding-top: 1rem !important;
		padding-bottom: 1rem !important;
	}
	.py-lg-4 {
		padding-top: 1.875rem !important;
		padding-bottom: 1.875rem !important;
	}
	.py-lg-5 {
		padding-top: 3rem !important;
		padding-bottom: 3rem !important;
	}
	.pt-lg-0 {
		padding-top: 0 !important;
	}
	.pt-lg-1 {
		padding-top: 0.25rem !important;
	}
	.pt-lg-2 {
		padding-top: 0.5rem !important;
	}
	.pt-lg-3 {
		padding-top: 1rem !important;
	}
	.pt-lg-4 {
		padding-top: 1.875rem !important;
	}
	.pt-lg-5 {
		padding-top: 3rem !important;
	}
	.pe-lg-0 {
		padding-right: 0 !important;
	}
	.pe-lg-1 {
		padding-right: 0.25rem !important;
	}
	.pe-lg-2 {
		padding-right: 0.5rem !important;
	}
	.pe-lg-3 {
		padding-right: 1rem !important;
	}
	.pe-lg-4 {
		padding-right: 1.875rem !important;
	}
	.pe-lg-5 {
		padding-right: 3rem !important;
	}
	.pb-lg-0 {
		padding-bottom: 0 !important;
	}
	.pb-lg-1 {
		padding-bottom: 0.25rem !important;
	}
	.pb-lg-2 {
		padding-bottom: 0.5rem !important;
	}
	.pb-lg-3 {
		padding-bottom: 1rem !important;
	}
	.pb-lg-4 {
		padding-bottom: 1.875rem !important;
	}
	.pb-lg-5 {
		padding-bottom: 3rem !important;
	}
	.ps-lg-0 {
		padding-left: 0 !important;
	}
	.ps-lg-1 {
		padding-left: 0.25rem !important;
	}
	.ps-lg-2 {
		padding-left: 0.5rem !important;
	}
	.ps-lg-3 {
		padding-left: 1rem !important;
	}
	.ps-lg-4 {
		padding-left: 1.875rem !important;
	}
	.ps-lg-5 {
		padding-left: 3rem !important;
	}
	.text-lg-start {
		text-align: left !important;
	}
	.text-lg-end {
		text-align: right !important;
	}
	.text-lg-center {
		text-align: center !important;
	}
}

@media (min-width: 1200px) {
	.float-xl-start {
		float: left !important;
	}
	.float-xl-end {
		float: right !important;
	}
	.float-xl-none {
		float: none !important;
	}
	.d-xl-inline {
		display: inline !important;
	}
	.d-xl-inline-block {
		display: inline-block !important;
	}
	.d-xl-block {
		display: block !important;
	}
	.d-xl-grid {
		display: grid !important;
	}
	.d-xl-table {
		display: table !important;
	}
	.d-xl-table-row {
		display: table-row !important;
	}
	.d-xl-table-cell {
		display: table-cell !important;
	}
	.d-xl-flex {
		display: flex !important;
	}
	.d-xl-inline-flex {
		display: inline-flex !important;
	}
	.d-xl-none {
		display: none !important;
	}
	.flex-xl-fill {
		flex: 1 1 auto !important;
	}
	.flex-xl-row {
		flex-direction: row !important;
	}
	.flex-xl-column {
		flex-direction: column !important;
	}
	.flex-xl-row-reverse {
		flex-direction: row-reverse !important;
	}
	.flex-xl-column-reverse {
		flex-direction: column-reverse !important;
	}
	.flex-xl-grow-0 {
		flex-grow: 0 !important;
	}
	.flex-xl-grow-1 {
		flex-grow: 1 !important;
	}
	.flex-xl-shrink-0 {
		flex-shrink: 0 !important;
	}
	.flex-xl-shrink-1 {
		flex-shrink: 1 !important;
	}
	.flex-xl-wrap {
		flex-wrap: wrap !important;
	}
	.flex-xl-nowrap {
		flex-wrap: nowrap !important;
	}
	.flex-xl-wrap-reverse {
		flex-wrap: wrap-reverse !important;
	}
	.gap-xl-0 {
		gap: 0 !important;
	}
	.gap-xl-1 {
		gap: 0.25rem !important;
	}
	.gap-xl-2 {
		gap: 0.5rem !important;
	}
	.gap-xl-3 {
		gap: 1rem !important;
	}
	.gap-xl-4 {
		gap: 1.875rem !important;
	}
	.gap-xl-5 {
		gap: 3rem !important;
	}
	.justify-content-xl-start {
		justify-content: flex-start !important;
	}
	.justify-content-xl-end {
		justify-content: flex-end !important;
	}
	.justify-content-xl-center {
		justify-content: center !important;
	}
	.justify-content-xl-between {
		justify-content: space-between !important;
	}
	.justify-content-xl-around {
		justify-content: space-around !important;
	}
	.justify-content-xl-evenly {
		justify-content: space-evenly !important;
	}
	.align-items-xl-start {
		align-items: flex-start !important;
	}
	.align-items-xl-end {
		align-items: flex-end !important;
	}
	.align-items-xl-center {
		align-items: center !important;
	}
	.align-items-xl-baseline {
		align-items: baseline !important;
	}
	.align-items-xl-stretch {
		align-items: stretch !important;
	}
	.align-content-xl-start {
		align-content: flex-start !important;
	}
	.align-content-xl-end {
		align-content: flex-end !important;
	}
	.align-content-xl-center {
		align-content: center !important;
	}
	.align-content-xl-between {
		align-content: space-between !important;
	}
	.align-content-xl-around {
		align-content: space-around !important;
	}
	.align-content-xl-stretch {
		align-content: stretch !important;
	}
	.align-self-xl-auto {
		align-self: auto !important;
	}
	.align-self-xl-start {
		align-self: flex-start !important;
	}
	.align-self-xl-end {
		align-self: flex-end !important;
	}
	.align-self-xl-center {
		align-self: center !important;
	}
	.align-self-xl-baseline {
		align-self: baseline !important;
	}
	.align-self-xl-stretch {
		align-self: stretch !important;
	}
	.order-xl-first {
		order: -1 !important;
	}
	.order-xl-0 {
		order: 0 !important;
	}
	.order-xl-1 {
		order: 1 !important;
	}
	.order-xl-2 {
		order: 2 !important;
	}
	.order-xl-3 {
		order: 3 !important;
	}
	.order-xl-4 {
		order: 4 !important;
	}
	.order-xl-5 {
		order: 5 !important;
	}
	.order-xl-last {
		order: 6 !important;
	}
	.m-xl-0 {
		margin: 0 !important;
	}
	.m-xl-1 {
		margin: 0.25rem !important;
	}
	.m-xl-2 {
		margin: 0.5rem !important;
	}
	.m-xl-3 {
		margin: 1rem !important;
	}
	.m-xl-4 {
		margin: 1.875rem !important;
	}
	.m-xl-5 {
		margin: 3rem !important;
	}
	.m-xl-auto {
		margin: auto !important;
	}
	.mx-xl-0 {
		margin-right: 0 !important;
		margin-left: 0 !important;
	}
	.mx-xl-1 {
		margin-right: 0.25rem !important;
		margin-left: 0.25rem !important;
	}
	.mx-xl-2 {
		margin-right: 0.5rem !important;
		margin-left: 0.5rem !important;
	}
	.mx-xl-3 {
		margin-right: 1rem !important;
		margin-left: 1rem !important;
	}
	.mx-xl-4 {
		margin-right: 1.875rem !important;
		margin-left: 1.875rem !important;
	}
	.mx-xl-5 {
		margin-right: 3rem !important;
		margin-left: 3rem !important;
	}
	.mx-xl-auto {
		margin-right: auto !important;
		margin-left: auto !important;
	}
	.my-xl-0 {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}
	.my-xl-1 {
		margin-top: 0.25rem !important;
		margin-bottom: 0.25rem !important;
	}
	.my-xl-2 {
		margin-top: 0.5rem !important;
		margin-bottom: 0.5rem !important;
	}
	.my-xl-3 {
		margin-top: 1rem !important;
		margin-bottom: 1rem !important;
	}
	.my-xl-4 {
		margin-top: 1.875rem !important;
		margin-bottom: 1.875rem !important;
	}
	.my-xl-5 {
		margin-top: 3rem !important;
		margin-bottom: 3rem !important;
	}
	.my-xl-auto {
		margin-top: auto !important;
		margin-bottom: auto !important;
	}
	.mt-xl-0 {
		margin-top: 0 !important;
	}
	.mt-xl-1 {
		margin-top: 0.25rem !important;
	}
	.mt-xl-2 {
		margin-top: 0.5rem !important;
	}
	.mt-xl-3 {
		margin-top: 1rem !important;
	}
	.mt-xl-4 {
		margin-top: 1.875rem !important;
	}
	.mt-xl-5 {
		margin-top: 3rem !important;
	}
	.mt-xl-auto {
		margin-top: auto !important;
	}
	.me-xl-0 {
		margin-right: 0 !important;
	}
	.me-xl-1 {
		margin-right: 0.25rem !important;
	}
	.me-xl-2 {
		margin-right: 0.5rem !important;
	}
	.me-xl-3 {
		margin-right: 1rem !important;
	}
	.me-xl-4 {
		margin-right: 1.875rem !important;
	}
	.me-xl-5 {
		margin-right: 3rem !important;
	}
	.me-xl-auto {
		margin-right: auto !important;
	}
	.mb-xl-0 {
		margin-bottom: 0 !important;
	}
	.mb-xl-1 {
		margin-bottom: 0.25rem !important;
	}
	.mb-xl-2 {
		margin-bottom: 0.5rem !important;
	}
	.mb-xl-3 {
		margin-bottom: 1rem !important;
	}
	.mb-xl-4 {
		margin-bottom: 1.875rem !important;
	}
	.mb-xl-5 {
		margin-bottom: 3rem !important;
	}
	.mb-xl-auto {
		margin-bottom: auto !important;
	}
	.ms-xl-0 {
		margin-left: 0 !important;
	}
	.ms-xl-1 {
		margin-left: 0.25rem !important;
	}
	.ms-xl-2 {
		margin-left: 0.5rem !important;
	}
	.ms-xl-3 {
		margin-left: 1rem !important;
	}
	.ms-xl-4 {
		margin-left: 1.875rem !important;
	}
	.ms-xl-5 {
		margin-left: 3rem !important;
	}
	.ms-xl-auto {
		margin-left: auto !important;
	}
	.p-xl-0 {
		padding: 0 !important;
	}
	.p-xl-1 {
		padding: 0.25rem !important;
	}
	.p-xl-2 {
		padding: 0.5rem !important;
	}
	.p-xl-3 {
		padding: 1rem !important;
	}
	.p-xl-4 {
		padding: 1.875rem !important;
	}
	.p-xl-5 {
		padding: 3rem !important;
	}
	.px-xl-0 {
		padding-right: 0 !important;
		padding-left: 0 !important;
	}
	.px-xl-1 {
		padding-right: 0.25rem !important;
		padding-left: 0.25rem !important;
	}
	.px-xl-2 {
		padding-right: 0.5rem !important;
		padding-left: 0.5rem !important;
	}
	.px-xl-3 {
		padding-right: 1rem !important;
		padding-left: 1rem !important;
	}
	.px-xl-4 {
		padding-right: 1.875rem !important;
		padding-left: 1.875rem !important;
	}
	.px-xl-5 {
		padding-right: 3rem !important;
		padding-left: 3rem !important;
	}
	.py-xl-0 {
		padding-top: 0 !important;
		padding-bottom: 0 !important;
	}
	.py-xl-1 {
		padding-top: 0.25rem !important;
		padding-bottom: 0.25rem !important;
	}
	.py-xl-2 {
		padding-top: 0.5rem !important;
		padding-bottom: 0.5rem !important;
	}
	.py-xl-3 {
		padding-top: 1rem !important;
		padding-bottom: 1rem !important;
	}
	.py-xl-4 {
		padding-top: 1.875rem !important;
		padding-bottom: 1.875rem !important;
	}
	.py-xl-5 {
		padding-top: 3rem !important;
		padding-bottom: 3rem !important;
	}
	.pt-xl-0 {
		padding-top: 0 !important;
	}
	.pt-xl-1 {
		padding-top: 0.25rem !important;
	}
	.pt-xl-2 {
		padding-top: 0.5rem !important;
	}
	.pt-xl-3 {
		padding-top: 1rem !important;
	}
	.pt-xl-4 {
		padding-top: 1.875rem !important;
	}
	.pt-xl-5 {
		padding-top: 3rem !important;
	}
	.pe-xl-0 {
		padding-right: 0 !important;
	}
	.pe-xl-1 {
		padding-right: 0.25rem !important;
	}
	.pe-xl-2 {
		padding-right: 0.5rem !important;
	}
	.pe-xl-3 {
		padding-right: 1rem !important;
	}
	.pe-xl-4 {
		padding-right: 1.875rem !important;
	}
	.pe-xl-5 {
		padding-right: 3rem !important;
	}
	.pb-xl-0 {
		padding-bottom: 0 !important;
	}
	.pb-xl-1 {
		padding-bottom: 0.25rem !important;
	}
	.pb-xl-2 {
		padding-bottom: 0.5rem !important;
	}
	.pb-xl-3 {
		padding-bottom: 1rem !important;
	}
	.pb-xl-4 {
		padding-bottom: 1.875rem !important;
	}
	.pb-xl-5 {
		padding-bottom: 3rem !important;
	}
	.ps-xl-0 {
		padding-left: 0 !important;
	}
	.ps-xl-1 {
		padding-left: 0.25rem !important;
	}
	.ps-xl-2 {
		padding-left: 0.5rem !important;
	}
	.ps-xl-3 {
		padding-left: 1rem !important;
	}
	.ps-xl-4 {
		padding-left: 1.875rem !important;
	}
	.ps-xl-5 {
		padding-left: 3rem !important;
	}
	.text-xl-start {
		text-align: left !important;
	}
	.text-xl-end {
		text-align: right !important;
	}
	.text-xl-center {
		text-align: center !important;
	}
}

@media (min-width: 1440) {
	.float-xxl-start {
		float: left !important;
	}
	.float-xxl-end {
		float: right !important;
	}
	.float-xxl-none {
		float: none !important;
	}
	.d-xxl-inline {
		display: inline !important;
	}
	.d-xxl-inline-block {
		display: inline-block !important;
	}
	.d-xxl-block {
		display: block !important;
	}
	.d-xxl-grid {
		display: grid !important;
	}
	.d-xxl-table {
		display: table !important;
	}
	.d-xxl-table-row {
		display: table-row !important;
	}
	.d-xxl-table-cell {
		display: table-cell !important;
	}
	.d-xxl-flex {
		display: flex !important;
	}
	.d-xxl-inline-flex {
		display: inline-flex !important;
	}
	.d-xxl-none {
		display: none !important;
	}
	.flex-xxl-fill {
		flex: 1 1 auto !important;
	}
	.flex-xxl-row {
		flex-direction: row !important;
	}
	.flex-xxl-column {
		flex-direction: column !important;
	}
	.flex-xxl-row-reverse {
		flex-direction: row-reverse !important;
	}
	.flex-xxl-column-reverse {
		flex-direction: column-reverse !important;
	}
	.flex-xxl-grow-0 {
		flex-grow: 0 !important;
	}
	.flex-xxl-grow-1 {
		flex-grow: 1 !important;
	}
	.flex-xxl-shrink-0 {
		flex-shrink: 0 !important;
	}
	.flex-xxl-shrink-1 {
		flex-shrink: 1 !important;
	}
	.flex-xxl-wrap {
		flex-wrap: wrap !important;
	}
	.flex-xxl-nowrap {
		flex-wrap: nowrap !important;
	}
	.flex-xxl-wrap-reverse {
		flex-wrap: wrap-reverse !important;
	}
	.gap-xxl-0 {
		gap: 0 !important;
	}
	.gap-xxl-1 {
		gap: 0.25rem !important;
	}
	.gap-xxl-2 {
		gap: 0.5rem !important;
	}
	.gap-xxl-3 {
		gap: 1rem !important;
	}
	.gap-xxl-4 {
		gap: 1.875rem !important;
	}
	.gap-xxl-5 {
		gap: 3rem !important;
	}
	.justify-content-xxl-start {
		justify-content: flex-start !important;
	}
	.justify-content-xxl-end {
		justify-content: flex-end !important;
	}
	.justify-content-xxl-center {
		justify-content: center !important;
	}
	.justify-content-xxl-between {
		justify-content: space-between !important;
	}
	.justify-content-xxl-around {
		justify-content: space-around !important;
	}
	.justify-content-xxl-evenly {
		justify-content: space-evenly !important;
	}
	.align-items-xxl-start {
		align-items: flex-start !important;
	}
	.align-items-xxl-end {
		align-items: flex-end !important;
	}
	.align-items-xxl-center {
		align-items: center !important;
	}
	.align-items-xxl-baseline {
		align-items: baseline !important;
	}
	.align-items-xxl-stretch {
		align-items: stretch !important;
	}
	.align-content-xxl-start {
		align-content: flex-start !important;
	}
	.align-content-xxl-end {
		align-content: flex-end !important;
	}
	.align-content-xxl-center {
		align-content: center !important;
	}
	.align-content-xxl-between {
		align-content: space-between !important;
	}
	.align-content-xxl-around {
		align-content: space-around !important;
	}
	.align-content-xxl-stretch {
		align-content: stretch !important;
	}
	.align-self-xxl-auto {
		align-self: auto !important;
	}
	.align-self-xxl-start {
		align-self: flex-start !important;
	}
	.align-self-xxl-end {
		align-self: flex-end !important;
	}
	.align-self-xxl-center {
		align-self: center !important;
	}
	.align-self-xxl-baseline {
		align-self: baseline !important;
	}
	.align-self-xxl-stretch {
		align-self: stretch !important;
	}
	.order-xxl-first {
		order: -1 !important;
	}
	.order-xxl-0 {
		order: 0 !important;
	}
	.order-xxl-1 {
		order: 1 !important;
	}
	.order-xxl-2 {
		order: 2 !important;
	}
	.order-xxl-3 {
		order: 3 !important;
	}
	.order-xxl-4 {
		order: 4 !important;
	}
	.order-xxl-5 {
		order: 5 !important;
	}
	.order-xxl-last {
		order: 6 !important;
	}
	.m-xxl-0 {
		margin: 0 !important;
	}
	.m-xxl-1 {
		margin: 0.25rem !important;
	}
	.m-xxl-2 {
		margin: 0.5rem !important;
	}
	.m-xxl-3 {
		margin: 1rem !important;
	}
	.m-xxl-4 {
		margin: 1.875rem !important;
	}
	.m-xxl-5 {
		margin: 3rem !important;
	}
	.m-xxl-auto {
		margin: auto !important;
	}
	.mx-xxl-0 {
		margin-right: 0 !important;
		margin-left: 0 !important;
	}
	.mx-xxl-1 {
		margin-right: 0.25rem !important;
		margin-left: 0.25rem !important;
	}
	.mx-xxl-2 {
		margin-right: 0.5rem !important;
		margin-left: 0.5rem !important;
	}
	.mx-xxl-3 {
		margin-right: 1rem !important;
		margin-left: 1rem !important;
	}
	.mx-xxl-4 {
		margin-right: 1.875rem !important;
		margin-left: 1.875rem !important;
	}
	.mx-xxl-5 {
		margin-right: 3rem !important;
		margin-left: 3rem !important;
	}
	.mx-xxl-auto {
		margin-right: auto !important;
		margin-left: auto !important;
	}
	.my-xxl-0 {
		margin-top: 0 !important;
		margin-bottom: 0 !important;
	}
	.my-xxl-1 {
		margin-top: 0.25rem !important;
		margin-bottom: 0.25rem !important;
	}
	.my-xxl-2 {
		margin-top: 0.5rem !important;
		margin-bottom: 0.5rem !important;
	}
	.my-xxl-3 {
		margin-top: 1rem !important;
		margin-bottom: 1rem !important;
	}
	.my-xxl-4 {
		margin-top: 1.875rem !important;
		margin-bottom: 1.875rem !important;
	}
	.my-xxl-5 {
		margin-top: 3rem !important;
		margin-bottom: 3rem !important;
	}
	.my-xxl-auto {
		margin-top: auto !important;
		margin-bottom: auto !important;
	}
	.mt-xxl-0 {
		margin-top: 0 !important;
	}
	.mt-xxl-1 {
		margin-top: 0.25rem !important;
	}
	.mt-xxl-2 {
		margin-top: 0.5rem !important;
	}
	.mt-xxl-3 {
		margin-top: 1rem !important;
	}
	.mt-xxl-4 {
		margin-top: 1.875rem !important;
	}
	.mt-xxl-5 {
		margin-top: 3rem !important;
	}
	.mt-xxl-auto {
		margin-top: auto !important;
	}
	.me-xxl-0 {
		margin-right: 0 !important;
	}
	.me-xxl-1 {
		margin-right: 0.25rem !important;
	}
	.me-xxl-2 {
		margin-right: 0.5rem !important;
	}
	.me-xxl-3 {
		margin-right: 1rem !important;
	}
	.me-xxl-4 {
		margin-right: 1.875rem !important;
	}
	.me-xxl-5 {
		margin-right: 3rem !important;
	}
	.me-xxl-auto {
		margin-right: auto !important;
	}
	.mb-xxl-0 {
		margin-bottom: 0 !important;
	}
	.mb-xxl-1 {
		margin-bottom: 0.25rem !important;
	}
	.mb-xxl-2 {
		margin-bottom: 0.5rem !important;
	}
	.mb-xxl-3 {
		margin-bottom: 1rem !important;
	}
	.mb-xxl-4 {
		margin-bottom: 1.875rem !important;
	}
	.mb-xxl-5 {
		margin-bottom: 3rem !important;
	}
	.mb-xxl-auto {
		margin-bottom: auto !important;
	}
	.ms-xxl-0 {
		margin-left: 0 !important;
	}
	.ms-xxl-1 {
		margin-left: 0.25rem !important;
	}
	.ms-xxl-2 {
		margin-left: 0.5rem !important;
	}
	.ms-xxl-3 {
		margin-left: 1rem !important;
	}
	.ms-xxl-4 {
		margin-left: 1.875rem !important;
	}
	.ms-xxl-5 {
		margin-left: 3rem !important;
	}
	.ms-xxl-auto {
		margin-left: auto !important;
	}
	.p-xxl-0 {
		padding: 0 !important;
	}
	.p-xxl-1 {
		padding: 0.25rem !important;
	}
	.p-xxl-2 {
		padding: 0.5rem !important;
	}
	.p-xxl-3 {
		padding: 1rem !important;
	}
	.p-xxl-4 {
		padding: 1.875rem !important;
	}
	.p-xxl-5 {
		padding: 3rem !important;
	}
	.px-xxl-0 {
		padding-right: 0 !important;
		padding-left: 0 !important;
	}
	.px-xxl-1 {
		padding-right: 0.25rem !important;
		padding-left: 0.25rem !important;
	}
	.px-xxl-2 {
		padding-right: 0.5rem !important;
		padding-left: 0.5rem !important;
	}
	.px-xxl-3 {
		padding-right: 1rem !important;
		padding-left: 1rem !important;
	}
	.px-xxl-4 {
		padding-right: 1.875rem !important;
		padding-left: 1.875rem !important;
	}
	.px-xxl-5 {
		padding-right: 3rem !important;
		padding-left: 3rem !important;
	}
	.py-xxl-0 {
		padding-top: 0 !important;
		padding-bottom: 0 !important;
	}
	.py-xxl-1 {
		padding-top: 0.25rem !important;
		padding-bottom: 0.25rem !important;
	}
	.py-xxl-2 {
		padding-top: 0.5rem !important;
		padding-bottom: 0.5rem !important;
	}
	.py-xxl-3 {
		padding-top: 1rem !important;
		padding-bottom: 1rem !important;
	}
	.py-xxl-4 {
		padding-top: 1.875rem !important;
		padding-bottom: 1.875rem !important;
	}
	.py-xxl-5 {
		padding-top: 3rem !important;
		padding-bottom: 3rem !important;
	}
	.pt-xxl-0 {
		padding-top: 0 !important;
	}
	.pt-xxl-1 {
		padding-top: 0.25rem !important;
	}
	.pt-xxl-2 {
		padding-top: 0.5rem !important;
	}
	.pt-xxl-3 {
		padding-top: 1rem !important;
	}
	.pt-xxl-4 {
		padding-top: 1.875rem !important;
	}
	.pt-xxl-5 {
		padding-top: 3rem !important;
	}
	.pe-xxl-0 {
		padding-right: 0 !important;
	}
	.pe-xxl-1 {
		padding-right: 0.25rem !important;
	}
	.pe-xxl-2 {
		padding-right: 0.5rem !important;
	}
	.pe-xxl-3 {
		padding-right: 1rem !important;
	}
	.pe-xxl-4 {
		padding-right: 1.875rem !important;
	}
	.pe-xxl-5 {
		padding-right: 3rem !important;
	}
	.pb-xxl-0 {
		padding-bottom: 0 !important;
	}
	.pb-xxl-1 {
		padding-bottom: 0.25rem !important;
	}
	.pb-xxl-2 {
		padding-bottom: 0.5rem !important;
	}
	.pb-xxl-3 {
		padding-bottom: 1rem !important;
	}
	.pb-xxl-4 {
		padding-bottom: 1.875rem !important;
	}
	.pb-xxl-5 {
		padding-bottom: 3rem !important;
	}
	.ps-xxl-0 {
		padding-left: 0 !important;
	}
	.ps-xxl-1 {
		padding-left: 0.25rem !important;
	}
	.ps-xxl-2 {
		padding-left: 0.5rem !important;
	}
	.ps-xxl-3 {
		padding-left: 1rem !important;
	}
	.ps-xxl-4 {
		padding-left: 1.875rem !important;
	}
	.ps-xxl-5 {
		padding-left: 3rem !important;
	}
	.text-xxl-start {
		text-align: left !important;
	}
	.text-xxl-end {
		text-align: right !important;
	}
	.text-xxl-center {
		text-align: center !important;
	}
}

@media (min-width: 1200px) {
	.fs-1 {
		font-size: 2.25rem !important;
	}
	.fs-2 {
		font-size: 1.875rem !important;
	}
	.fs-3 {
		font-size: 1.5rem !important;
	}
}

@media print {
	.d-print-inline {
		display: inline !important;
	}
	.d-print-inline-block {
		display: inline-block !important;
	}
	.d-print-block {
		display: block !important;
	}
	.d-print-grid {
		display: grid !important;
	}
	.d-print-table {
		display: table !important;
	}
	.d-print-table-row {
		display: table-row !important;
	}
	.d-print-table-cell {
		display: table-cell !important;
	}
	.d-print-flex {
		display: flex !important;
	}
	.d-print-inline-flex {
		display: inline-flex !important;
	}
	.d-print-none {
		display: none !important;
	}
}

.c-pointer {
	cursor: pointer;
}

* {
	outline: none;
	padding: 0;
}
*::after {
	margin: 0;
	padding: 0;
}
*::before {
	margin: 0;
	padding: 0;
}

::selection {
	color: #fff;
	background: var(--primary);
}

.dropzone .dz-message {
	margin: 5em 0;
}

h1 a,
.h1 a,
h2 a,
.h2 a,
h3 a,
.h3 a,
h4 a,
.h4 a,
h5 a,
.h5 a,
h6 a,
.h6 a {
	color: #303972;
}
h1 a:hover,
.h1 a:hover,
h2 a:hover,
.h2 a:hover,
h3 a:hover,
.h3 a:hover,
h4 a:hover,
.h4 a:hover,
h5 a:hover,
.h5 a:hover,
h6 a:hover,
.h6 a:hover {
	color: var(--primary) !important;
}

.light-logo {
	display: none;
}

[data-theme-version='dark'] .light-logo {
	display: block;
}

[data-theme-version='dark'] .dark-logo {
	display: none;
}

body {
	-ms-overflow-style: none;
	scrollbar-width: none;
}

body::-webkit-scrollbar {
	display: none;
}

@media only screen and (max-width: 100rem) {
	:root {
		font-size: 0.875rem;
	}
}

body {
	overflow-x: hidden;
	height: 100%;
	position: relative;
	max-width: 100%;
	font-size: 0.875rem;
}
@media only screen and (max-width: 61.9375rem) {
	body {
		font-size: 0.875rem;
	}
}

textarea.form-control {
	min-height: auto !important;
	height: auto !important;
}

.form-label {
	margin-bottom: 0.5rem;
}

.required {
	color: #fd5353 !important;
}

p {
	line-height: 1.8;
	font-weight: 400;
	color: #a098ae;
}

.box-shadow-none {
	box-shadow: none !important;
}

.media {
	display: flex;
	align-items: flex-start;
}

.media-body {
	flex: 1 1;
}

#main-wrapper {
	opacity: 0;
	transition: all 0.25s ease-in;
	position: relative;
	background-color: #e6ebee;
}
#main-wrapper.show {
	opacity: 1;
}

.rounded-lg {
	border-radius: 0.375rem;
}

ul {
	padding: 0;
	margin: 0;
}

li {
	list-style: none;
}

a {
	color: #a098ae;
	text-decoration: none;
}
a:hover,
a:focus,
a.active {
	text-decoration: none;
}

.btn-link:hover,
.btn-link:focus,
.btn-link.active {
	text-decoration: none;
}

.bg-primary {
	background-color: var(--primary) !important;
}

.text-primary {
	color: var(--primary) !important;
}

.fs-12 {
	font-size: 0.75rem !important;
	line-height: 1.5;
}

.fs-13 {
	font-size: 0.8125rem !important;
	line-height: 1.5;
}

.fs-14 {
	font-size: 0.875rem !important;
	line-height: 1.6;
}

.fs-15 {
	font-size: 0.938rem !important;
	line-height: 1.5;
}

.fs-16 {
	font-size: 1rem !important;
	line-height: 1.6;
}
@media only screen and (max-width: 35.9375rem) {
	.fs-16 {
		font-size: 0.875rem !important;
	}
}

.fs-18 {
	font-size: 1.125rem !important;
	line-height: 1.5;
}
@media only screen and (max-width: 35.9375rem) {
	.fs-18 {
		font-size: 1rem !important;
	}
}

.fs-20 {
	font-size: 1.25rem !important;
	line-height: 1.5;
}

.fs-22 {
	font-size: 1.375rem !important;
	line-height: 1.5;
}

.fs-24 {
	font-size: 1.5rem !important;
	line-height: 1.4;
}

.fs-26 {
	font-size: 1.625rem !important;
	line-height: 1.4;
}

.fs-28 {
	font-size: 1.75rem !important;
	line-height: 1.4;
}
@media only screen and (max-width: 35.9375rem) {
	.fs-28 {
		font-size: 1.5rem !important;
	}
}

.fs-30 {
	font-size: 1.875rem !important;
	line-height: 1.4;
}

.fs-32 {
	font-size: 2rem !important;
	line-height: 1.25;
}

.fs-34 {
	font-size: 2.125rem !important;
	line-height: 1.25;
}

.fs-35 {
	font-size: 2.1875rem !important;
	line-height: 1.25;
}

.fs-36 {
	font-size: 2.25rem !important;
	line-height: 1.25;
}

.fs-38 {
	font-size: 2.375rem !important;
	line-height: 1.25;
}

.fs-46 {
	font-size: 2.875rem !important;
	line-height: 1.25;
}

.fs-48 {
	font-size: 3rem !important;
	line-height: 1.25;
}

.font-w100 {
	font-weight: 100;
}

.font-w200 {
	font-weight: 200;
}

.font-w300 {
	font-weight: 300;
}

.font-w400 {
	font-weight: 400 !important;
}

.font-w500 {
	font-weight: 500;
}

.font-w600 {
	font-weight: 600;
}

.font-w700 {
	font-weight: 700;
}

.font-w800 {
	font-weight: 800;
}

.font-w900 {
	font-weight: 900;
}

h1,
.h1,
.h1,
h2,
.h2,
.h2,
h3,
.h3,
.h3,
h4,
.h4,
.h4,
h5,
.h5,
.h5,
h6,
.h6,
.h6 {
	line-height: 1.5;
	color: #303972;
}

.w-space-no {
	white-space: nowrap;
}

.content-body .container {
	margin-top: 2.5rem;
}

.content-body .container-fluid,
.content-body .container-sm,
.content-body .container-md,
.content-body .container-lg,
.content-body .container-xl,
.content-body .container-xxl {
	padding-top: 1.875rem;
	padding-right: 1.875rem;
	padding-left: 1.875rem;
}
@media only screen and (max-width: 75rem) {
	.content-body .container-fluid,
	.content-body .container-sm,
	.content-body .container-md,
	.content-body .container-lg,
	.content-body .container-xl,
	.content-body .container-xxl {
		padding-top: 1.875rem;
		padding-right: 1.875rem;
		padding-left: 1.875rem;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.content-body .container-fluid,
	.content-body .container-sm,
	.content-body .container-md,
	.content-body .container-lg,
	.content-body .container-xl,
	.content-body .container-xxl {
		padding-top: 1.25rem;
		padding-right: 1.25rem;
		padding-left: 1.25rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.content-body .container-fluid,
	.content-body .container-sm,
	.content-body .container-md,
	.content-body .container-lg,
	.content-body .container-xl,
	.content-body .container-xxl {
		padding-top: 15px;
		padding-right: 15px;
		padding-left: 15px;
	}
}

/*sp*/
.row.sp4,
.sp4 {
	margin-left: -0.125rem;
	margin-right: -0.125rem;
}
.row.sp4 [class*='col-'],
.sp4 [class*='col-'] {
	padding-left: 0.125rem;
	padding-right: 0.125rem;
}

.op1 {
	opacity: 0.1;
}

.op2 {
	opacity: 0.2;
}

.op3 {
	opacity: 0.3;
}

.op4 {
	opacity: 0.4;
}

.op5 {
	opacity: 0.5;
}

.op6 {
	opacity: 0.6;
}

.op7 {
	opacity: 0.7;
}

.op8 {
	opacity: 0.8;
}

.op9 {
	opacity: 0.9;
}

.content-heading {
	font-size: 1rem;
	margin-bottom: 1.875rem;
	margin-top: 3.125rem;
	border-bottom: 0.0625rem solid #f2f2f2;
	padding-bottom: 0.625rem;
}
[direction='rtl'] .content-heading {
	text-align: right;
}

.btn-primary:not(:disabled):not(.disabled):active:focus,
.btn-primary:not(:disabled):not(.disabled).active:focus {
	box-shadow: none;
}

.vh-100 {
	height: 100vh !important;
}

.img-fix {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.support-ticket {
	position: fixed;
	bottom: 1.875rem;
	right: 0.9375rem;
	z-index: 999999;
}

.support-ticket-btn {
	width: 6.25rem;
	background: #7cb442;
	animation: 0.7s ease-in-out 0s infinite alternate none running crescendo;
	border-radius: 3.125rem;
	color: #fff;
	font-size: 0.5rem;
	font-size: 1rem;
	padding: 0.3125rem 0.625rem 0.4375rem;
	text-align: center;
	display: inline-block;
	box-shadow: rgba(124, 180, 66, 0.7) 0rem 0.5rem 2.1875rem 0rem;
}
.support-ticket-btn:hover,
.support-ticket-btn:focus {
	color: #fff;
}

.text-blue {
	color: #374c98;
}

.text-indigo {
	color: #6610f2;
}

.text-purple {
	color: #6f42c1;
}

.text-pink {
	color: #eb62d0 !important;
}

.text-red {
	color: #ee3232;
}

.text-orange {
	color: #ff9900;
}

.text-yellow {
	color: #fffa6f;
}

.text-green {
	color: #297f00;
}

.text-teal {
	color: #20c997;
}

.text-cyan {
	color: #3065d0;
}

/* .bg-gray-dark{
	background:\$color_pallate_2 !important;
}
.bg-purpal{
	background:\$color_pallate_4 !important;
}
.bg-red{
	background:\$color_pallate_5 !important;
}
.bg-blue-dark{
	background:\$color_pallate_6 !important;
} */
.bg-blue {
	background: #496ecc !important;
}

.bg-orange {
	background: #ed8030 !important;
}

.bg-green {
	background: #299e4a !important;
}

.bg-purpel {
	background: #9517c1 !important;
}

.bg-dark-blue {
	background: #251e71 !important;
}

/* .bg-blue-light{
	background:\$color_pallate_8 !important;
}
.bg-green-light{
	background:\$color_pallate_9 !important;
}
.bg-green{
	background:\$color_pallate_10 !important;
} */
.bg-black {
	background: #000;
}

.text-black {
	color: #000 !important;
}

.dlab-scroll {
	position: relative;
}

.scale1 {
	transform: scale(1.1);
	-moz-transform: scale(1.1);
	-webkit-transform: scale(1.1);
	-ms-transform: scale(1.1);
	-o-transform: scale(1.1);
	display: inline-block;
}

.scale2 {
	transform: scale(1.2);
	-moz-transform: scale(1.2);
	-webkit-transform: scale(1.2);
	-ms-transform: scale(1.2);
	-o-transform: scale(1.2);
	display: inline-block;
}

.scale3 {
	transform: scale(1.3);
	-moz-transform: scale(1.3);
	-webkit-transform: scale(1.3);
	-ms-transform: scale(1.3);
	-o-transform: scale(1.3);
	display: inline-block;
}

.scale4 {
	transform: scale(1.4);
	-moz-transform: scale(1.4);
	-webkit-transform: scale(1.4);
	-ms-transform: scale(1.4);
	-o-transform: scale(1.4);
	display: inline-block;
}

.scale5 {
	transform: scale(1.5);
	-moz-transform: scale(1.5);
	-webkit-transform: scale(1.5);
	-ms-transform: scale(1.5);
	-o-transform: scale(1.5);
	display: inline-block;
}

.scale-2 {
	transform: scale(2);
	-moz-transform: scale(2);
	-webkit-transform: scale(2);
	-ms-transform: scale(2);
	-o-transform: scale(2);
	display: inline-block;
}

.mh-auto {
	min-height: auto !important;
}

.out-footer {
	width: calc(100% - 22.625rem);
	margin-right: 1.875rem;
	margin-left: auto;
}
@media only screen and (max-width: 87.5rem) {
	.out-footer {
		width: calc(100% - 20.625rem);
	}
}
@media only screen and (max-width: 63.938rem) {
	.out-footer {
		width: calc(100% - 10.125rem);
	}
}
@media only screen and (max-width: 61.9375rem) {
	.out-footer {
		width: calc(100% - 10.125rem);
	}
}
@media only screen and (max-width: 47.9375rem) {
	.out-footer {
		width: 100%;
	}
}

.overflow-y-scroll {
	overflow-y: scroll;
}

.height10 {
	height: 0.625rem;
}

.height20 {
	height: 1.25rem;
}

.height30 {
	height: 1.875rem;
}

.height40 {
	height: 2.5rem;
}

.height50 {
	height: 3.125rem;
}

.height60 {
	height: 3.75rem;
}

.height70 {
	height: 4.375rem;
}

.height80 {
	height: 5rem;
}

.height90 {
	height: 5.625rem;
}

.height100 {
	height: 6.25rem;
}

.height110 {
	height: 6.875rem;
}

.height120 {
	height: 7.5rem;
}

.height130 {
	height: 8.125rem;
}

.height140 {
	height: 8.75rem;
}

.height150 {
	height: 9.375rem;
}

.height160 {
	height: 10rem;
}

.height170 {
	height: 10.625rem;
}

.height180 {
	height: 11.25rem;
}

.height190 {
	height: 11.875rem;
}

.height200 {
	height: 12.5rem;
}

.height210 {
	height: 13.125rem;
}

.height220 {
	height: 13.75rem;
}

.height230 {
	height: 14.375rem;
}

.height240 {
	height: 15rem;
}

.height250 {
	height: 15.625rem;
}

.height260 {
	height: 16.25rem;
}

.height270 {
	height: 16.875rem;
}

.height280 {
	height: 17.5rem;
}

.height290 {
	height: 18.125rem;
}

.height300 {
	height: 18.75rem;
}

.height310 {
	height: 19.375rem;
}

.height320 {
	height: 20rem;
}

.height330 {
	height: 20.625rem;
}

.height340 {
	height: 21.25rem;
}

.height350 {
	height: 21.875rem;
}

.height360 {
	height: 22.5rem;
}

.height370 {
	height: 23.125rem;
}

.height380 {
	height: 23.75rem;
}

.height390 {
	height: 24.375rem;
}

.height400 {
	height: 25rem;
}

.height415 {
	height: 25.9375rem;
}

.height450 {
	height: 28.125rem;
}

.height500 {
	height: 31.25rem;
}

.height550 {
	height: 34.375rem;
}

.height600 {
	height: 37.5rem;
}

.height630 {
	height: 39.375rem;
}

.height720 {
	height: 45rem;
}

.height750 {
	height: 46.875rem;
}

.height800 {
	height: 50rem;
}

.width10 {
	width: 0.625rem;
}

.width20 {
	width: 1.25rem;
}

.width30 {
	width: 1.875rem;
}

.width40 {
	width: 2.5rem;
}

.width50 {
	width: 3.125rem;
}

.width60 {
	width: 3.75rem;
}

.width70 {
	width: 4.375rem;
}

.width80 {
	width: 5rem;
}

.width90 {
	width: 5.625rem;
}

.width100 {
	width: 6.25rem;
}

.width110 {
	width: 6.875rem;
}

.width120 {
	width: 7.5rem;
}

.width130 {
	width: 8.125rem;
}

.width140 {
	width: 8.75rem;
}

.width150 {
	width: 9.375rem;
}

.width160 {
	width: 10rem;
}

.width170 {
	width: 10.625rem;
}

.width180 {
	width: 11.25rem;
}

.width190 {
	width: 11.875rem;
}

.width200 {
	width: 12.5rem;
}

.width210 {
	width: 13.125rem;
}

.width220 {
	width: 13.75rem;
}

.width230 {
	width: 14.375rem;
}

.width240 {
	width: 15rem;
}

.width250 {
	width: 15.625rem;
}

.width260 {
	width: 16.25rem;
}

.width270 {
	width: 16.875rem;
}

.width280 {
	width: 17.5rem;
}

.width290 {
	width: 18.125rem;
}

.width300 {
	width: 18.75rem;
}

.width310 {
	width: 19.375rem;
}

.width320 {
	width: 20rem;
}

.width330 {
	width: 20.625rem;
}

.width340 {
	width: 21.25rem;
}

.width350 {
	width: 21.875rem;
}

.width360 {
	width: 22.5rem;
}

.width370 {
	width: 23.125rem;
}

.width380 {
	width: 23.75rem;
}

.width390 {
	width: 24.375rem;
}

.width400 {
	width: 25rem;
}

.rounded {
	border-radius: 0.375rem !important;
}

label {
	margin-bottom: 0.5rem;
}

@keyframes gXGDoR {
	from {
		transform: translateY(0.3125rem) scale(0.8);
	}
	to {
		transform: translateY(0rem) scale(1);
	}
}

@keyframes crescendo {
	from {
		transform: translateY(0.3125rem) scale(0.8);
	}
	to {
		transform: translateY(0rem) scale(1);
	}
}

@keyframes gXGDoR {
	from {
		transform: translateY(0.3125rem) scale(0.8);
	}
	to {
		transform: translateY(0rem) scale(1);
	}
}

.bg-pink {
	background-color: #eb62d0 !important;
}

div,
span,
ol,
ul {
	scrollbar-width: thin;
}

@media only screen and (min-width: 1200px) and (max-width: 1600px) {
	.col-xxl-1 {
		flex: 0 0 8.33333%;
		max-width: 8.33333%;
	}
	.col-xxl-2 {
		flex: 0 0 16.66667%;
		max-width: 16.66667%;
	}
	.col-xxl-3 {
		flex: 0 0 25%;
		max-width: 25%;
	}
	.col-xxl-4 {
		flex: 0 0 33.33333%;
		max-width: 33.33333%;
	}
	.col-xxl-5 {
		flex: 0 0 41.66667%;
		max-width: 41.66667%;
	}
	.col-xxl-6 {
		flex: 0 0 50%;
		max-width: 50%;
	}
	.col-xxl-7 {
		flex: 0 0 58.33333%;
		max-width: 58.33333%;
	}
	.col-xxl-8 {
		flex: 0 0 66.66667%;
		max-width: 66.66667%;
	}
	.col-xxl-9 {
		flex: 0 0 75%;
		max-width: 75%;
	}
	.col-xxl-10 {
		flex: 0 0 83.33333%;
		max-width: 83.33333%;
	}
	.col-xxl-11 {
		flex: 0 0 91.66667%;
		max-width: 91.66667%;
	}
	.col-xxl-12 {
		flex: 0 0 100%;
		max-width: 100%;
	}
	.mb-xxl-4 {
		margin-bottom: 1.5rem !important;
	}
}

#preloader {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100vh;
	position: fixed;
	width: 100%;
	z-index: 999999;
}
#preloader .dot {
	background: var(--primary);
	border-radius: 50%;
	display: inline-block;
	margin-right: 20px;
	width: 25px;
	height: 25px;
}
#preloader .dot:first-child {
	animation: FirstDot 3s infinite;
}
#preloader .dot:nth-child(2) {
	animation: SecondDot 3s infinite;
}
#preloader .dot:nth-child(3) {
	animation: ThirdDot 3s infinite;
}
#preloader .dot:nth-child(4) {
	animation: FourthDot 3s infinite;
}
#preloader .dot:nth-child(5) {
	animation: FifthDot 3s infinite;
}

@keyframes FirstDot {
	0% {
		transform: scale(1) translateX(0);
	}
	25% {
		transform: scale(2.5) translateX(0);
	}
	50% {
		transform: scale(1) translateX(0);
	}
	83% {
		transform: scale(1) translateX(240px);
	}
	100% {
		transform: scale(1) translateX(0);
	}
}

@keyframes SecondDot {
	0% {
		transform: translateX(0px);
	}
	27% {
		transform: translateX(-40px);
	}
	50% {
		transform: translateX(0px);
	}
	81% {
		transform: translateX(180px);
	}
	100% {
		transform: translateX(0);
	}
}

@keyframes ThirdDot {
	0% {
		transform: translateX(0px);
	}
	29% {
		transform: translateX(-100px);
	}
	50% {
		transform: translateX(0px);
	}
	79% {
		transform: translateX(120px);
	}
	100% {
		transform: translateX(0);
	}
}

@keyframes FourthDot {
	0% {
		transform: translateX(0px);
	}
	31% {
		transform: translateX(-160px);
	}
	50% {
		transform: translateX(0px);
	}
	77% {
		transform: translateX(60px);
	}
	100% {
		transform: translateX(0);
	}
}

@keyframes FifthDot {
	0% {
		transform: scale(1) translateX(0);
	}
	33% {
		transform: scale(1) translateX(-220px);
	}
	50% {
		transform: scale(1) translateX(0);
	}
	75% {
		transform: scale(2.5) translateX(0);
	}
	100% {
		transform: scale(1) translateX(0);
	}
}

.footer {
	padding: 0.3875rem 0;
	font-size: 0.875rem;
	background-color: #ffffff;
	border-top-left-radius: 0.375rem;
	border-top-right-radius: 0.375rem;
	margin-top: 1rem;
}
.footer .copyright {
	padding: 0.5375rem;
	margin: 0;
}
.footer .copyright p {
	text-align: center;
	margin: 0;
}
.footer .copyright a {
	color: var(--primary);
}
.footer.footer-outer {
	/* width: calc(100% - 43.225rem); */
	margin-right: 2rem;
	margin-left: 20.5rem;
}
@media only screen and (max-width: 87.5rem) {
	.footer.footer-outer {
		width: calc(100% - 20.525rem);
		margin-right: 1.575rem;
	}
}
@media only screen and (max-width: 61.9375rem) {
	.footer.footer-outer {
		width: calc(100% - 9.625rem);
		margin-right: 1.575rem;
		padding-left: 0.8rem !important;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.footer.footer-outer {
		width: calc(100% - 2.825rem) !important;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.footer.footer-outer {
		width: calc(100% - 2.025rem) !important;
		margin-right: 0.875rem;
	}
}
.footer.style-1 {
	width: calc(100% - 39.125rem);
	margin-right: 19.975rem;
}
@media only screen and (max-width: 61.9375rem) {
	.footer.style-1 {
		width: calc(100% - 9.625rem);
		margin-right: 1.475rem;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.footer.style-1 {
		width: calc(100% - 2.725rem) !important;
		margin-right: 1.475rem !important;
	}
}
.footer.style-2 {
	width: calc(100% - 21.325rem);
}
@media only screen and (max-width: 61.9375rem) {
	.footer.style-2 {
		width: calc(100% - 9.925rem);
	}
}
@media only screen and (max-width: 47.9375rem) {
	.footer.style-2 {
		width: calc(100% - 2.325rem) !important;
		margin-right: 0.975rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.footer.style-2 {
		width: calc(100% - 1.825rem) !important;
	}
}

[data-sidebar-style='mini'] .nav-control,
[data-layout='horizontal'] .nav-control {
	display: none;
}

@media only screen and (max-width: 47.9375rem) {
	[data-sidebar-style='overlay'] .nav-header .logo-abbr {
		display: block;
	}
}

[data-header-position='fixed'] .nav-header {
	position: fixed;
}

.nav-header {
	height: 5rem;
	width: var(--width);
	display: inline-block;
	background-color: var(--nav-headbg);
	text-align: left;
	position: absolute;
	top: 0;
	transition: all 0.2s ease;
	z-index: 5;
}
.nav-header .logo-abbr {
	max-width: 2.9375rem;
}
@media only screen and (max-width: 87.5rem) {
	.nav-header .logo-abbr {
		max-width: 2.8125rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.nav-header .logo-abbr {
		width: 4.1875rem;
		height: 4.1875rem;
	}
}
.nav-header .logo-compact {
	display: none;
}
@media only screen and (max-width: 87.5rem) {
	.nav-header {
		height: 6.5rem;
		width: 17rem;
	}
}
.nav-header .brand-logo {
	display: flex;
	height: 100%;
	width: 100%;
	justify-content: flex-start;
	align-items: center;
	font-size: 1.125rem;
	color: #fff;
	text-decoration: none;
	padding-left: 1.675rem;
	padding-right: 1.675rem;
	font-weight: 700;
}
@media only screen and (max-width: 87.5rem) {
	.nav-header .brand-logo {
		padding-left: 1.25rem;
		padding-right: 1.25rem;
	}
}
[data-sidebar-style='compact'] .nav-header .brand-logo,
[data-sidebar-style='mini'] .nav-header .brand-logo {
	padding-left: 0;
	padding-right: 0;
	justify-content: center;
}
@media only screen and (max-width: 47.9375rem) {
	.nav-header .brand-logo {
		padding-left: 0;
		padding-right: 0;
		justify-content: center;
	}
}
.nav-header .brand-title {
	margin-left: 0.9375rem;
	max-width: 8.75rem;
	color: #000;
}
.nav-header .brand-title svg path {
	fill: var(--primary);
}
[data-theme-version='dark'] .nav-header .brand-title {
	background-position: 0 120%;
}
.nav-header .brand-title h2,
.nav-header .brand-title .h2 {
	line-height: 0;
	font-weight: bold;
	font-size: 1.75rem;
	margin-bottom: 12px;
}
.nav-header .brand-title .brand-sub-title {
	font-size: 0.875rem;
	font-weight: 400;
	white-space: nowrap;
	font-family: Nunito;
}
@media only screen and (max-width: 47.9375rem) {
	.nav-header {
		top: 0px;
		background: transparent;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.nav-header {
		top: 0px;
	}
}
.nav-header .rect-primary-rect {
	fill: var(--primary);
}

@media only screen and (max-width: 74.9375rem) {
	.nav-header {
		height: 5rem;
	}
}

@media only screen and (max-width: 63.9375rem) {
	.nav-header {
		width: 5rem;
	}
	.nav-header .brand-title {
		display: none;
	}
}

.nav-control {
	cursor: pointer;
	position: absolute;
	right: -4rem;
	text-align: center;
	top: 46%;
	transform: translateY(-43%);
	z-index: 9999;
	font-size: 1.4rem;
	background: transparent;
	height: 2.5rem;
	width: 2.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 0.375rem;
}
@media only screen and (max-width: 87.5rem) {
	.nav-control {
		right: -4.1rem;
		top: 40%;
	}
}
@media only screen and (max-width: 74.9375rem) {
	.nav-control {
		top: 45%;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.nav-control {
		right: -3rem;
		top: 43%;
		height: 43px;
		width: 43px;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.nav-control {
		top: 43%;
		height: 39px;
		width: 39px;
		right: -1.875rem;
	}
}

.hamburger {
	display: inline-block;
	left: 0.2rem;
	position: relative;
	transition: all 0.3s ease-in-out 0s;
	width: 1.625rem;
	z-index: 999;
}
.hamburger svg {
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1;
}

.hamburger .line {
	background: #303972;
	display: block;
	height: 0.188rem;
	border-radius: 0.1875rem;
	margin-top: 0.25rem;
	margin-bottom: 0.25rem;
	margin-right: auto;
	transition: all 0.3s ease-in-out;
	opacity: 0;
}

.hamburger.is-active {
	left: -0.9rem;
}
.hamburger.is-active svg {
	display: none;
}
.hamburger.is-active line {
	opacity: 1;
}

.hamburger .line:nth-child(1) {
	width: 1.375rem;
}

.hamburger .line:nth-child(2) {
	width: 1.375rem;
}

.hamburger .line:nth-child(3) {
	width: 0.875rem;
}

.hamburger:hover {
	cursor: pointer;
}

.hamburger:hover .line {
	width: 1.625rem;
}

.hamburger.is-active .line:nth-child(1),
.hamburger.is-active .line:nth-child(3) {
	width: 0.625rem;
	height: 0.125rem;
}

.hamburger.is-active .line:nth-child(2) {
	transform: translateX(0px);
	width: 1.375rem;
	height: 0.125rem;
}

.hamburger.is-active .line:nth-child(1) {
	transform: translateY(2px) translateX(12px) rotate(45deg);
}

.hamburger.is-active .line:nth-child(3) {
	transform: translateY(-2px) translateX(12px) rotate(-45deg);
}

@media (min-width: 47.9375rem) {
	[data-sidebar-style='compact'] .nav-control {
		display: none;
	}
	[data-sidebar-style='compact'] .nav-header {
		width: 11.25rem;
	}
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .brand-title {
	display: none;
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .nav-header .logo-abbr {
	display: block;
}

[data-sidebar-style='full'][data-layout='horizontal'] .logo-compact {
	display: none;
}

[data-sidebar-style='mini'] .nav-header {
	height: 5.3rem;
}
[data-sidebar-style='mini'] .nav-header .logo-abbr {
	display: block;
}
@media only screen and (max-width: 100rem) {
	[data-sidebar-style='mini'] .nav-header {
		height: 6.1rem;
	}
}
@media only screen and (max-width: 64rem) {
	[data-sidebar-style='mini'] .nav-header {
		height: 5.5rem;
	}
}

[data-sidebar-style='compact'][data-layout='vertical'] .nav-header .brand-title {
	display: none;
}

[data-sidebar-style='compact'][data-layout='vertical'] .nav-header .logo-compact {
	max-width: 4.6875rem;
}

[data-sidebar-style='compact'][data-layout='horizontal'] .nav-header .brand-logo {
	padding-left: 1.875rem;
	padding-right: 1.875rem;
	justify-content: start;
}

[data-sidebar-style='modern'][data-layout='vertical'] .nav-header {
	width: 14.625rem;
}
[data-sidebar-style='modern'][data-layout='vertical'] .nav-header .brand-title {
	display: none;
}
[data-sidebar-style='modern'][data-layout='vertical'] .nav-header .logo-compact {
	display: none;
}

.header {
	z-index: 1;
	position: relative;
	padding: 0rem;
	background: var(--headerbg);
	z-index: 3;
	padding-left: 17rem;
	transition: all 0.2s ease;
	background-position: center;
	background-size: cover;
	box-sizing: border-box;
}
.header .is-fixed {
	background: #3736af;
}
.header .header-content {
	height: 5rem;
	padding-left: 5.5rem;
	padding-right: 0rem;
	align-items: center;
	display: flex;
	left: 16.2rem;
	position: unset;
	top: 0;
	width: calc(100% - var(--width));
	margin-left: var(--width);
	border-top: none;
	padding-right: 2rem;
}
@media only screen and (max-width: 87.5rem) {
	.header .header-content {
		padding-left: 5rem;
		width: calc(100% - 0rem);
		margin-left: 0rem;
		height: 100%;
	}
}
@media only screen and (max-width: 64rem) {
	.header .header-content {
		left: 6.3rem;
		width: calc(100% - 0rem);
		height: 5rem;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.header .header-content {
		padding-left: 3.75rem;
		padding-right: 0.938rem;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.header .header-content {
		left: 0rem;
		width: calc(100% - 0.3rem);
	}
}
.header .navbar {
	padding: 0;
	height: 100%;
	width: 100%;
}
.header .navbar .navbar-collapse {
	height: 100%;
	width: 100%;
}

[data-headerbg='color_2'] .header.is-fixed {
	background: var(--headerbg);
}

[data-headerbg='color_3'] .header.is-fixed {
	background: var(--headerbg);
}

[data-headerbg='color_4'] .header.is-fixed {
	background: var(--headerbg);
}

[data-headerbg='color_5'] .header.is-fixed {
	background: var(--headerbg);
}

[data-headerbg='color_6'] .header.is-fixed {
	background: var(--headerbg);
}

[data-headerbg='color_7'] .header.is-fixed {
	background: var(--headerbg);
}

[data-headerbg='color_8'] .header.is-fixed {
	background: var(--headerbg);
}

[data-headerbg='color_9'] .header.is-fixed {
	background: var(--headerbg);
}

[data-headerbg='color_10'] .header.is-fixed {
	background: var(--headerbg);
}

[data-headerbg='color_11'] .header.is-fixed {
	background: var(--headerbg);
}

[data-headerbg='color_12'] .header.is-fixed {
	background: var(--headerbg);
}

[data-headerbg='color_13'] .header.is-fixed {
	background: var(--headerbg);
}

[data-headerbg='color_14'] .header.is-fixed {
	background: var(--headerbg);
}

[data-headerbg='color_15'] .header.is-fixed {
	background: var(--headerbg);
}

[data-nav-headbg='color_2'] .nav-header {
	background: var(--nav-headbg);
}

[data-nav-headbg='color_3'] .nav-header {
	background: var(--nav-headbg);
}

[data-nav-headbg='color_4'] .nav-header {
	background: var(--nav-headbg);
}

[data-nav-headbg='color_5'] .nav-header {
	background: var(--nav-headbg);
}

[data-nav-headbg='color_6'] .nav-header {
	background: var(--nav-headbg);
}

[data-nav-headbg='color_7'] .nav-header {
	background: var(--nav-headbg);
}

[data-nav-headbg='color_8'] .nav-header {
	background: var(--nav-headbg);
}

[data-nav-headbg='color_9'] .nav-header {
	background: var(--nav-headbg);
}

[data-nav-headbg='color_10'] .nav-header {
	background: var(--nav-headbg);
}

[data-nav-headbg='color_11'] .nav-header {
	background: var(--nav-headbg);
}

[data-nav-headbg='color_12'] .nav-header {
	background: var(--nav-headbg);
}

[data-nav-headbg='color_13'] .nav-header {
	background: var(--nav-headbg);
}

[data-nav-headbg='color_14'] .nav-header {
	background: var(--nav-headbg);
}

[data-nav-headbg='color_15'] .nav-header {
	background: var(--nav-headbg);
}

/* pulse in SVG */
svg.pulse-svg {
	overflow: visible;
}
svg.pulse-svg .first-circle,
svg.pulse-svg .second-circle,
svg.pulse-svg .third-circle {
	transform: scale(0.3);
	transform-origin: center center;
	animation: pulse-me 3s linear infinite;
	fill: var(--primary);
}
svg.pulse-svg .second-circle {
	animation-delay: 1s;
}
svg.pulse-svg .third-circle {
	animation-delay: 2s;
}

/* pulse in CSS */
.pulse-css {
	width: 1rem;
	height: 1rem;
	border-radius: 0.5rem;
	border-radius: 3.5rem;
	height: 1.25rem;
	position: absolute;
	background: #fe8630;
	right: 0.375rem;
	top: 0.3125rem;
	border: 0.25rem solid #fff;
	width: 1.25rem;
}
.pulse-css:after,
.pulse-css:before {
	content: '';
	width: 1rem;
	height: 1rem;
	border-radius: 0.5rem;
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: -0.2rem;
	background-color: #d8b9c3;
	margin: auto;
	transform: scale(0.3);
	transform-origin: center center;
	animation: pulse-me 3s linear infinite;
}
[direction='rtl'] .pulse-css:after,
[direction='rtl'] .pulse-css:before {
	left: auto;
	right: -0.2rem;
}
@media only screen and (max-width: 87.5rem) {
	.pulse-css {
		height: 1rem;
		width: 1rem;
	}
}

@keyframes pulse-me {
	0% {
		transform: scale(0.3);
		opacity: 0;
	}
	50% {
		opacity: 0.1;
	}
	70% {
		opacity: 0.09;
	}
	100% {
		transform: scale(3);
		opacity: 0;
	}
}

[data-sidebar-style='full'] .header,
[data-sidebar-style='overlay'] .header {
	width: 100%;
	padding-left: 0;
	/* .page-titles{
			padding-left: 20.3rem;
		} */
}
@media only screen and (max-width: 87.5rem) {
	[data-sidebar-style='full'] .header,
	[data-sidebar-style='overlay'] .header {
		width: 100%;
		padding-left: 17rem;
	}
}
@media only screen and (max-width: 63.9375rem) {
	[data-sidebar-style='full'] .header,
	[data-sidebar-style='overlay'] .header {
		width: 100%;
		padding-left: 0rem;
	}
}

[data-sidebar-style='mini'] .header {
	width: 100%;
	height: 5rem;
	padding-left: 6.32rem;
}
@media only screen and (max-width: 63.9375rem) {
	[data-sidebar-style='mini'] .header {
		padding-left: 6rem;
	}
}

[data-sidebar-style='compact'] .header {
	width: 100%;
	padding-left: 1.75rem;
}
[data-sidebar-style='compact'] .header .header-content {
	padding-left: 2.5rem;
	left: 1.75rem;
	width: auto;
	margin-left: 9.2rem;
}

[data-header-position='fixed'] .header {
	position: fixed;
	top: 0;
	width: 100%;
}

[data-header-position='fixed'] .content-body {
	padding-top: 5rem;
}

[data-header-position='fixed'] .dlabnav {
	margin-top: 0;
}

[data-sidebar-style='compact'][data-header-position='fixed'][data-container='boxed'][data-layout='vertical'] .header {
	width: 74.9375rem;
}

[data-sidebar-style='modern'] .header {
	width: 100%;
	padding-left: 0rem;
}

[data-sidebar-style='modern'][data-layout='horizontal'] .nav-header .brand-logo {
	justify-content: start;
}

[data-sidebar-style='modern'][data-layout='horizontal'] .header .header-content {
	padding-left: 1.875rem;
}

.header.is-fixed {
	position: fixed;
	background: #e6ebee;
	transition: all 0.5s;
	/*     -webkit-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;
    -khtml-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;
    -moz-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;
    -ms-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;
    -o-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;
    animation: 0.95s ease 0s normal forwards 1 running headerSlideDown; */
}

@keyframes headerSlideDown {
	0% {
		margin-top: -150px;
	}
	100% {
		margin-top: 0;
	}
}

.sidebar-info h4,
.sidebar-info .h4 {
	font-size: 0.875rem;
	font-weight: 700;
	white-space: nowrap;
}

.header-left {
	height: 100%;
	display: flex;
	align-items: center;
}
.header-left .search-area {
	width: 25rem;
	flex-direction: row-reverse;
	border: 1px solid #dddddd;
	overflow: hidden;
	border-radius: 0.375rem;
	box-sizing: border-box;
	height: 3rem;
}
@media only screen and (max-width: 117.5rem) {
	.header-left .search-area {
		width: 22rem;
	}
}
@media only screen and (max-width: 81.25rem) {
	.header-left .search-area {
		width: 17.5rem;
	}
}
@media only screen and (max-width: 74.9375rem) {
	.header-left .search-area {
		width: 15.625rem;
	}
}
@media only screen and (max-width: 68.75rem) {
	.header-left .search-area {
		display: none;
	}
}
.header-left .search-area .form-control {
	font-size: 15px;
	border-right: 0;
	border: none;
	padding: 0rem;
	border-radius: 0 0.375rem 0.375rem 0;
	padding-left: 0.2rem;
	height: 3rem;
}
.header-left .search-area .form-control:focus {
	border-color: white;
	box-shadow: none;
}
.header-left .search-area .input-group-text {
	background: #fff !important;
	border: none;
	padding-right: 0;
	height: 3rem;
	border-radius: 0.375rem 0 0 0.375rem;
}
.header-left .search-area .input-group-text svg {
	transform: scale(1.2);
}
.header-left .search-area .input-group-text svg path {
	fill: var(--primary);
}
.header-left .breadcrumb {
	margin-bottom: 0;
}
.header-left .agenda a {
	border-radius: 1.75rem;
}
.header-left .agenda a i {
	margin-right: 0.75rem;
}
@media only screen and (max-width: 87.5rem) {
	.header-left .agenda a i {
		margin-right: 0rem;
	}
}
@media only screen and (max-width: 93.75rem) {
	.header-left .agenda a {
		font-size: 0;
		border-radius: 0.75rem;
		padding: 0.8125rem 0.9375rem;
	}
	.header-left .agenda a i {
		font-size: 1.25rem;
		margin-right: 0;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.header-left .agenda {
		display: none;
	}
}
.header-left .dashboard_bar {
	font-size: 1.563rem;
	font-weight: 600;
	color: #303972;
}
@media only screen and (max-width: 47.9375rem) {
	.header-left .dashboard_bar {
		display: none;
	}
}
.header-left .dashboard_bar.sub-bar {
	font-size: 1.875rem;
}

[data-sidebar-style='compact'] .header-left {
	margin-left: 0;
}

.nav-item.notification_dropdown a.nav-link {
	position: relative;
	/* &::before{
			content: '';
			display: block;
			background-color: \$pink;
			width: 0.5rem;
			height: 0.5rem;
			border-radius: 50%;
			position: absolute;
			top: -2px;
			right: 0;
			
		}
		 */
}

.nav-item.notification_dropdown .nav-link.menu-wallet::before {
	content: '';
	display: none;
}

.modal .modal-content input.form-control {
	border-top-right-radius: 0.375rem !important;
	border-bottom-right-radius: 0.375rem !important;
}

.header-right {
	height: 100%;
	align-items: center;
}
.header-right .nav-item {
	height: 100%;
	display: flex;
	align-items: center;
}
.header-right .nav-item .nav-link {
	color: #464a53;
}
.header-right .right-sidebar {
	margin-right: -1.875rem;
}
.header-right .right-sidebar a {
	height: 5rem;
	width: 5rem;
	text-align: center;
	justify-content: center;
	display: flex;
	align-items: center;
	border-left: 0.0625rem solid #ebebf9;
}
@media only screen and (max-width: 74.9375rem) {
	.header-right > li:not(:first-child) {
		padding-left: 0rem;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.header-right > li:not(:first-child) {
		padding-left: 0;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.header-right .notification_dropdown {
		position: static;
	}
}
.header-right .notification_dropdown .nav-link {
	position: relative;
	color: var(--primary);
	border-radius: 0.375rem;
	background-color: #ffffff;
	width: 3rem;
	min-width: 3rem;
	height: 3rem;
	line-height: 1;
	margin-right: 1.125rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
@media only screen and (max-width: 112rem) {
	.header-right .notification_dropdown .nav-link {
		margin-right: 0.625rem;
	}
}
@media only screen and (max-width: 87.5rem) {
	.header-right .notification_dropdown .nav-link {
		padding: 0.625rem;
		margin-right: 0.625rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.header-right .notification_dropdown .nav-link {
		padding: 0.325rem;
		margin-right: 0.5rem !important;
		width: 2.3rem;
		height: 2.3rem;
		min-width: 2.3rem;
	}
}
.header-right .notification_dropdown .nav-link i {
	font-size: 1.5rem;
	color: #666666;
}
@media only screen and (max-width: 87.5rem) {
	.header-right .notification_dropdown .nav-link i {
		font-size: 1.125rem;
	}
}
@media only screen and (max-width: 87.5rem) {
	.header-right .notification_dropdown .nav-link svg {
		width: 1.75rem;
		height: 1.75rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.header-right .notification_dropdown .nav-link svg {
		width: 1.3rem;
		height: 1.3rem;
	}
}
.header-right .notification_dropdown .nav-link.bell-link svg path {
	stroke: #a098ae;
}
.header-right .notification_dropdown .nav-link.dz-fullscreen svg path {
	stroke: #a098ae;
}
.header-right .notification_dropdown .nav-link.dz-theme-mode svg path {
	stroke: #a098ae;
}
.header-right .notification_dropdown .nav-link #icon-light,
.header-right .notification_dropdown .nav-link #icon-dark,
.header-right .notification_dropdown .nav-link #icon-light-1,
.header-right .notification_dropdown .nav-link #icon-dark-1 {
	color: #a098ae;
}
.header-right .notification_dropdown .nav-link.menu-wallet svg path {
	fill: #a098ae;
}
.header-right .notification_dropdown .nav-link .badge {
	position: absolute;
	font-size: 0.625rem;
	border-radius: 50%;
	right: 5px;
	top: 0px;
	font-weight: normal;
	height: 25px;
	width: 25px;
	line-height: 16px;
	text-align: center;
	padding: 4px;
	font-size: 11px;
}
@media only screen and (max-width: 87.5rem) {
	.header-right .notification_dropdown .nav-link .badge {
		height: 1.25rem;
		width: 1.25rem;
		border-width: 0.125rem;
		line-height: 0.4375rem;
		font-size: 0.5625rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.header-right .notification_dropdown .nav-link .badge {
		height: 1.125rem;
		width: 1.125rem;
		padding: 0;
		line-height: 0.9375rem;
		right: 0rem;
		top: -0.125rem;
	}
}
.header-right .notification_dropdown .dropdown-item:focus a,
.header-right .notification_dropdown .dropdown-item:active a {
	color: #fff;
}
.header-right .notification_dropdown .dropdown-item a {
	color: #303972;
}
.header-right .notification_dropdown .dropdown-item a:hover {
	text-decoration: none;
}
.header-right .dropdown-menu {
	border-width: 0;
	box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
	margin: 0;
	width: 14.188rem;
	margin: 0;
	border-radius: 0px 0px 5px 5px;
	margin-top: -8px;
}
@media only screen and (max-width: 35.9375rem) {
	.header-right .dropdown-menu {
		width: 11.875rem;
	}
	.header-right .dropdown-menu h4,
	.header-right .dropdown-menu .h4 {
		font-size: 14px;
	}
	.header-right .dropdown-menu span {
		font-size: 11px;
	}
}
[data-theme-version='dark'] .header-right .dropdown-menu {
	box-shadow: none;
}
.header-right .dropdown-menu.dropdown-menu-end .card-footer {
	border-radius: 0;
}
.header-right .dropdown-menu.dropdown-menu-end .dropdown-item:hover {
	border-radius: 6px;
}
.header-right .dropdown-menu.dropdown-menu-end .light.btn-primary:hover span {
	color: #fff !important;
}
.header-right .dropdown-menu.dropdown-menu-end .light.btn-primary:hover svg {
	stroke: #fff;
}
.header-right .search-area {
	width: 21.875rem;
	flex-direction: row-reverse;
	overflow: hidden;
	border-radius: 0.375rem;
	box-sizing: border-box;
	height: 3rem;
	border: 1px solid #eeeeee !important;
}
@media only screen and (max-width: 117.5rem) {
	.header-right .search-area {
		width: 22rem;
	}
}
@media only screen and (max-width: 81.25rem) {
	.header-right .search-area {
		width: 17.5rem;
	}
}
@media only screen and (max-width: 74.9375rem) {
	.header-right .search-area {
		width: 15.625rem;
	}
}
.header-right .search-area .form-control {
	font-size: 15px;
	border-right: 0;
	border: none;
	padding: 0rem;
	border-radius: 0 0.375rem 0.375rem 0;
	padding-left: 0.2rem;
	height: 3rem;
}
.header-right .search-area .form-control:focus {
	border-color: white;
	box-shadow: none;
}
.header-right .search-area .input-group-text {
	background: #fff;
	border: none;
	padding-right: 20px;
	height: 3rem;
	border-radius: 0.375rem 0 0 0.375rem;
}
.header-right .search-area .input-group-text svg {
	transform: scale(1.2);
}
.header-right .search-area .input-group-text svg path {
	fill: var(--primary);
}

.dlab-fullscreen #icon-minimize {
	display: none;
}

.dlab-fullscreen.active #icon-full {
	display: none;
}

.dlab-fullscreen.active #icon-minimize {
	display: inline-block;
}

.dlab-fullscreen #icon-minimize {
	display: none;
}

.dlab-fullscreen.active #icon-full-1 {
	display: none;
}

.dlab-fullscreen.active #icon-minimize-1 {
	display: inline-block;
}

/* .notification_dropdown {
    .dropdown-menu-end {
        min-width: 19.375rem;
        padding: 1rem 0 1rem;
        top: 100%;
		
        .notification_title {
            background: var(--primary);
            color: \$white;
            padding: 0.625rem 1.25rem;
            h5 {
                color: \$white;
                margin-bottom: 0.1875rem;
            }
        }
        .media {
			width: 2.8125rem ;
			height: 2.8125rem ;
			font-size: 1.125rem ;
			
            // &:last-child{
            //     border-bottom: 0rem;
            // }
            @at-root [data-theme-version="dark"] & {
                border-color: \$d-border;
            }
            &>span {
                width: 2.1875rem;
                height: 2.1875rem;
                border-radius: 3.125rem;
                display: inline-block;
                padding: 0.4375rem 0.5625rem;
                margin-right: 0.625rem;
				@at-root [direction="rtl"] {
					 margin-right: 0;
					 margin-left: 0.625rem
				}
                &.success {
                    background: \$success-light;
                    color: \$success;
                }
                &.primary {
                    background: var(--rgba-primary-1);
                    color: var(--primary);
                }
                &.danger {
                    background: \$danger-light;
                    color: \$danger;
                }
            }
            .notify-time {
                width: 100%;
                margin-right: 0;
                color: \$l-ctl;
            }
            p {
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                max-width: 12.5rem;
                margin-bottom: 0;
                margin-top: 0.3125rem;
				@include respond('phone') {
				    max-width: 6.25rem;
				}
            }
        }
        .all-notification {
            display: block;
            padding: 0.9375rem 1.875rem 0;
    }
	            // color: \$dark;
            text-align: center;
			border-top: 0.0625rem solid \$b-color;
				
            i {
                margin-left: 0.625rem;
            }
        }

} */
.notification_dropdown .dropdown-menu-end {
	min-width: 19.375rem;
	padding: 1rem 0 1rem;
	top: 100%;
}
.notification_dropdown .dropdown-menu-end.show {
	right: 0;
	overflow: unset !important;
}
.notification_dropdown .dropdown-menu-end .notification_title {
	background: var(--primary);
	color: #fff;
	padding: 0.625rem 1.25rem;
}
.notification_dropdown .dropdown-menu-end .notification_title h5,
.notification_dropdown .dropdown-menu-end .notification_title .h5 {
	color: #fff;
	margin-bottom: 0.1875rem;
}
.notification_dropdown .dropdown-menu-end .media {
	width: 2.8125rem;
	height: 2.8125rem;
	font-size: 1.125rem;
}
[data-theme-version='dark'] .notification_dropdown .dropdown-menu-end .media {
	border-color: rgba(255, 255, 255, 0.1);
}
.notification_dropdown .dropdown-menu-end .media > span {
	width: 2.1875rem;
	height: 2.1875rem;
	border-radius: 3.125rem;
	display: inline-block;
	padding: 0.4375rem 0.5625rem;
	margin-right: 0.625rem;
}
[direction='rtl'].notification_dropdown .dropdown-menu-end .media > span {
	margin-right: 0;
	margin-left: 0.625rem;
}
.notification_dropdown .dropdown-menu-end .media > span.success {
	background: #ddfaea;
	color: #1eba62;
}
.notification_dropdown .dropdown-menu-end .media > span.primary {
	background: var(--rgba-primary-1);
	color: var(--primary);
}
.notification_dropdown .dropdown-menu-end .media > span.danger {
	background: #ffeaea;
	color: #fd5353;
}
.notification_dropdown .dropdown-menu-end .media .notify-time {
	width: 100%;
	margin-right: 0;
	color: #828690;
}
.notification_dropdown .dropdown-menu-end .media p {
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	max-width: 12.5rem;
	margin-bottom: 0;
	margin-top: 0.3125rem;
}
@media only screen and (max-width: 35.9375rem) {
	.notification_dropdown .dropdown-menu-end .media p {
		max-width: 6.25rem;
	}
}
.notification_dropdown .dropdown-menu-end .all-notification {
	display: block;
	padding: 0.9375rem 1.875rem 0;
	color: var(--primary);
	text-align: center;
	border-top: 0.0625rem solid #f1f1f1;
	font-size: 0.813rem;
}
.notification_dropdown .dropdown-menu-end .all-notification i {
	margin-left: 0.625rem;
}
@media only screen and (max-width: 47.9375rem) {
	.notification_dropdown .dropdown-menu-end {
		right: 0;
		height: 27rem;
		top: 45px;
		transform: translateX(0);
		padding-right: 0;
		width: 18rem;
		display: none !important;
		border-radius: 0.375rem;
	}
	.notification_dropdown .dropdown-menu-end.show {
		display: block !important;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.notification_dropdown .dropdown-menu-end {
		min-width: 18.5rem;
		right: -4rem;
		top: 62px;
	}
}

.notification_dropdown .attc {
	display: flex;
	align-items: flex-start;
	border: 1px solid #f1f1f1;
	border-radius: 0.375rem;
	padding: 0.313rem 0.625rem;
}
.notification_dropdown .attc .media {
	border-radius: 6px;
	border: 1px solid #eee;
}
.notification_dropdown .attc .media-body h6,
.notification_dropdown .attc .media-body .h6 {
	font-size: 0.813rem;
	line-height: 1rem;
	margin-bottom: 0;
}
.notification_dropdown .attc .media-body span {
	border: 1px solid #e6e6e6;
	font-size: 0.75rem;
}

.header-profile > a.nav-link {
	padding: 0;
	display: flex;
	align-items: center;
	margin-left: 0.9375rem;
}
.header-profile > a.nav-link i {
	font-weight: 700;
}
.header-profile > a.nav-link .header-info {
	padding-left: 0rem;
	text-align: left;
}
@media only screen and (max-width: 87.5rem) {
	.header-profile > a.nav-link .header-info {
		padding-left: 0.625rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.header-profile > a.nav-link .header-info {
		display: none;
	}
}
.header-profile > a.nav-link .header-info span {
	font-size: 1rem;
	color: #000;
	display: block;
	font-weight: 600;
}
.header-profile > a.nav-link .header-info strong {
	color: #303972;
}
.header-profile > a.nav-link .header-info small,
.header-profile > a.nav-link .header-info .small {
	display: block;
	font-size: 0.8125rem;
	color: #89879f;
	font-weight: 400;
	line-height: 1.2;
}
@media only screen and (max-width: 87.5rem) {
	.header-profile > a.nav-link {
		margin-left: 0rem;
		padding-left: 0rem;
	}
	.header-profile > a.nav-link .header-info span {
		font-size: 1rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.header-profile > a.nav-link {
		margin-left: 0rem;
		padding-left: 0rem;
		border-left: 0;
	}
}

.header-profile .dropdown-menu {
	padding: 0.9375rem 0;
	min-width: 12.5rem;
}
.header-profile .dropdown-menu a:hover,
.header-profile .dropdown-menu a:focus,
.header-profile .dropdown-menu a.active {
	color: var(--primary);
}

.header-profile img {
	width: 3.5rem;
	height: 3.5rem;
	border-radius: 0.375rem;
}
@media only screen and (max-width: 87.5rem) {
	.header-profile img {
		width: 2.4375rem;
		height: 2.4375rem;
	}
}

.header-profile .dropdown-toggle i {
	font-size: 1.25rem;
}

@media only screen and (max-width: 35.9375rem) {
	.header-profile .dropdown-toggle span {
		display: none;
	}
}

.header-profile .profile_title {
	background: #4d44b5;
	color: #fff;
	padding: 0.625rem 1.25rem;
}
.header-profile .profile_title h5,
.header-profile .profile_title .h5 {
	color: #fff;
	margin-bottom: 0.1875rem;
}

.header-profile .dropdown-item {
	padding: 0.5rem 1.5rem;
}

.dropdown.header-profile2 .nav-link {
	margin-left: 1rem;
	padding-right: 0;
}
@media only screen and (max-width: 87.5rem) {
	.dropdown.header-profile2 .nav-link {
		margin-left: 0rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.dropdown.header-profile2 .nav-link {
		padding-left: 0;
	}
}

@keyframes icon-bounce {
	100%,
	0% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(-5px);
	}
	80% {
		transform: translateY(5px);
	}
}

.dz-theme-mode #icon-light {
	display: none;
}

.dz-theme-mode.active #icon-light {
	display: inline-block;
}

.dz-theme-mode.active #icon-dark {
	display: none;
}

.dz-fullscreen #icon-minimize {
	display: none;
}

.dz-fullscreen.active #icon-minimize {
	display: inline-block;
}

.dz-fullscreen.active #icon-full {
	display: none;
}

.dz-theme-mode #icon-light-1 {
	display: none;
}

.dz-theme-mode.active #icon-light-1 {
	display: inline-block;
}

.dz-theme-mode.active #icon-dark-1 {
	display: none;
}

.dz-fullscreen #icon-minimize-1 {
	display: none;
}

.dz-fullscreen.active #icon-minimize-1 {
	display: inline-block;
}

.dz-fullscreen.active #icon-full-1 {
	display: none;
}

:root {
	--width: 18.5rem;
}
:root [data-sidebar-style='mini'] {
	--width: 6.25rem;
}

.nav-label {
	margin: 0.625rem 1.875rem 0;
	padding: 1.5625rem 0 0.625rem;
	text-transform: uppercase;
	font-size: 0.75rem;
	letter-spacing: 0.05rem;
	border-top: 0.0625rem solid #eaeaea;
	color: #999999;
}
[data-theme-version='dark'] .nav-label {
	border-color: rgba(255, 255, 255, 0.1);
}
.nav-label.first {
	border: 0rem;
	margin-top: 0rem;
}

.nav-badge {
	position: absolute;
	right: 2.8125rem;
	top: 0.625rem;
}

.dlabnav .ps__rail-y {
	left: 0;
	width: 5px;
}

.content-body {
	margin-left: var(--width);
	z-index: 0;
	transition: all 0.2s ease;
}
@media only screen and (max-width: 87.5rem) {
	.content-body {
		margin-left: 17rem;
	}
}

.bell img {
	-webkit-animation: ring 8s 0.7s ease-in-out infinite;
	-webkit-transform-origin: 50% 0.25rem;
	-moz-animation: ring 8s 0.7s ease-in-out infinite;
	-moz-transform-origin: 50% 0.25rem;
	animation: ring 8s 0.7s ease-in-out infinite;
}

@keyframes ring {
	0% {
		transform: rotate(0);
	}
	1% {
		transform: rotate(30deg);
	}
	3% {
		transform: rotate(-28deg);
	}
	5% {
		transform: rotate(34deg);
	}
	7% {
		transform: rotate(-32deg);
	}
	9% {
		transform: rotate(30deg);
	}
	11% {
		transform: rotate(-28deg);
	}
	13% {
		transform: rotate(26deg);
	}
	15% {
		transform: rotate(-24deg);
	}
	17% {
		transform: rotate(22deg);
	}
	19% {
		transform: rotate(-20deg);
	}
	21% {
		transform: rotate(18deg);
	}
	23% {
		transform: rotate(-16deg);
	}
	25% {
		transform: rotate(14deg);
	}
	27% {
		transform: rotate(-12deg);
	}
	29% {
		transform: rotate(10deg);
	}
	31% {
		transform: rotate(-8deg);
	}
	33% {
		transform: rotate(6deg);
	}
	35% {
		transform: rotate(-4deg);
	}
	37% {
		transform: rotate(2deg);
	}
	39% {
		transform: rotate(-1deg);
	}
	41% {
		transform: rotate(1deg);
	}
	43% {
		transform: rotate(0);
	}
	100% {
		transform: rotate(0);
	}
}

.dlabnav {
	width: var(--width);
	padding-bottom: 0;
	height: calc(100% - 4.5rem);
	position: absolute;
	top: 5rem;
	padding-top: 0;
	z-index: 6;
	background-color: var(--sidebar-bg);
	border-top: none;
	transition: all 0.2s ease;
	box-shadow: 0rem 0.9375rem 1.875rem 0rem rgba(0, 0, 0, 0.02);
}
@media only screen and (max-width: 100rem) {
	.dlabnav {
		top: 4.9rem;
	}
}
@media only screen and (max-width: 87.5rem) {
	.dlabnav {
		height: calc(100% - 64.7px);
	}
}
@media only screen and (max-width: 74.9375rem) {
	.dlabnav {
		height: calc(100% - 70px);
	}
}
@media only screen and (max-width: 47.9375rem) {
	.dlabnav {
		width: 18rem;
	}
}
.dlabnav .menu-scroll {
	height: 55.4rem;
}
@media only screen and (max-width: 61.9375rem) {
	.dlabnav .menu-scroll {
		height: 57.4rem;
	}
}
.dlabnav .dlabnav-scroll {
	position: relative;
	height: 100%;
	overflow-y: scroll;
}
@media only screen and (max-width: 87.5rem) {
	.dlabnav {
		width: 17rem;
	}
}
.dlabnav ul {
	padding: 0;
	margin: 0;
	list-style: none;
}
.dlabnav .metismenu {
	display: flex;
	flex-direction: column;
	padding: 0.5rem 0;
}
.dlabnav .metismenu.fixed {
	position: fixed;
	top: 0;
	width: 100%;
	left: 0;
}
.dlabnav .metismenu > li {
	display: flex;
	flex-direction: column;
	margin: 5px 0;
}
.dlabnav .metismenu > li a > i {
	font-size: 1.3rem;
	display: inline-block;
	vertical-align: middle;
	position: relative;
	top: 0;
	height: auto;
	width: auto;
	text-align: center;
	margin-right: 0.75rem;
	border-radius: 0.125rem;
	line-height: 1;
}
[data-sidebar-style='compact'] .dlabnav .metismenu > li a > i {
	display: block;
	padding: 0;
	background: rgba(0, 0, 0, 0.05);
	/* background:rgba(\$light,0.2); */
	color: rgba(0, 0, 0, 0.3);
	width: 3.25rem;
	height: 3.25rem;
	border-radius: 0.375rem;
	line-height: 3.25rem;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 0.3125rem;
}
[data-sidebar-style='compact'] .dlabnav .metismenu > li a > i[data-theme-version='dark'] {
	color: #fff;
}
@media only screen and (max-width: 84.375rem) {
	.dlabnav .metismenu > li a > i {
		height: auto;
		line-height: 0.0625rem;
		width: auto;
		font-size: 1.5rem;
		padding: 0;
		color: #969ba0;
	}
}
.dlabnav .metismenu > li > a {
	font-weight: 500;
	display: inline-block;
	font-size: 0.875rem;
	color: #a098ae;
}
.dlabnav .metismenu > li > a svg {
	max-width: 1.5rem;
	max-height: 1.5rem;
	height: 100%;
	margin-right: 0.625rem;
	margin-top: -0.1875rem;
	color: var(--primary);
}
.dlabnav .metismenu > li > a i {
	font-family: 'Material Icons';
	font-style: normal;
	-webkit-font-feature-settings: 'liga';
	-webkit-font-smoothing: antialiased;
	font-weight: normal;
}
.dlabnav .metismenu > li > a g [fill] {
	fill: #8088a1;
}
.dlabnav .metismenu > li:hover > a,
.dlabnav .metismenu > li:focus > a {
	/*  background-color: lighten(\$color: \$primary, \$amount: 40%); */
	color: var(--primary);
}
.dlabnav .metismenu > li:hover > a g [fill],
.dlabnav .metismenu > li:focus > a g [fill] {
	fill: var(--primary);
}
.dlabnav .metismenu > li:hover > a::after,
.dlabnav .metismenu > li:focus > a::after {
	border-top: 0.2125rem solid var(--primary);
	border-left: 0.2125rem solid var(--primary);
}
.dlabnav .metismenu > li.mm-active > a {
	color: #fff;
	background: var(--primary);
	font-weight: 600;
	box-shadow: none;
}
.dlabnav .metismenu > li.mm-active > a i {
	font-weight: 900;
}
.dlabnav .metismenu > li.mm-active > a svg path {
	fill: #fff;
	stroke: #fff;
}
.dlabnav .metismenu > li.mm-active > a g [fill] {
	fill: var(--primary);
}
.dlabnav .metismenu > li.mm-active > a:after {
	border-top: 0.2125rem solid var(--primary);
	border-left: 0.2125rem solid var(--primary);
}
[data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a i {
	background: var(--primary);
	color: #fff;
}
.dlabnav .metismenu li {
	position: relative;
}
.dlabnav .metismenu ul {
	transition: all 0.2s ease-in-out;
	position: relative;
	z-index: 1;
	padding: 0.5rem 0;
}
.dlabnav .metismenu ul a {
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
	position: relative;
	font-size: 0.875rem;
	padding-left: 3.8rem;
	transition: all 0.5s;
	/* @at-root [data-sidebar-style="full"] & {
					&:before{
						content: "";
						height: 0.125rem;
						width: 0.375rem;
						background: var(--rgba-primary-5);
						position: absolute;
						left: 2.5rem;
						top: 50%;
						transform: translateY(-50%);
						@include transitionMedium;
					}
					&:hover{
						padding-left:5.5rem;
						@include custommq(\$max:78.125rem){
							padding-left:4.5rem;
						}
						&:before{
							width:1.25rem;
						}
					}
				} */
}
@media only screen and (max-width: 84.375rem) {
	.dlabnav .metismenu ul a {
		padding-left: 3.6rem;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.dlabnav .metismenu ul a {
		padding-left: 3.5rem;
		font-size: 0.875rem;
	}
}
.dlabnav .metismenu ul a:hover,
.dlabnav .metismenu ul a:focus,
.dlabnav .metismenu ul a.mm-active {
	text-decoration: none;
	color: var(--primary);
}
.dlabnav .metismenu ul a:before {
	position: absolute;
	content: none;
	height: 0.125rem;
	width: 0.5rem;
	top: 50%;
	left: 1.75rem;
	border-radius: 3.75rem;
	transform: translateY(-50%);
}
@media only screen and (max-width: 84.375rem) {
	.dlabnav .metismenu ul a:before {
		left: 2.8125rem;
	}
}
.dlabnav .metismenu a {
	position: relative;
	display: block;
	padding: 0.7375rem 1.2rem;
	outline-width: 0;
	color: #373a54;
	text-decoration: none;
}
@media only screen and (max-width: 47.9375rem) {
	.dlabnav .metismenu a {
		padding: 0.625rem 1.25rem;
	}
}
.dlabnav .metismenu a:hover svg path {
	fill: var(--primary);
	stroke: var(--primary);
}
.dlabnav .metismenu a:hover i {
	color: var(--primary);
}
.dlabnav .metismenu .has-arrow:after {
	/* width:  .5rem;
                height: .5rem;
                border-color: inherit; */
	border-top: 0.2125rem solid #c8c8c8;
	border-left: 0.2125rem solid #c8c8c8;
	border-bottom: 0.2125rem solid transparent;
	border-right: 0.2125rem solid transparent;
	right: 1.875rem;
	top: 48%;
	transform: rotate(-225deg) translateY(-50%);
}
.dlabnav .metismenu .has-arrow[aria-expanded='true']:after,
.dlabnav .metismenu .mm-active > .has-arrow:after {
	transform: rotate(-135deg) translateY(-50%);
	/* margin-right: 2rem; */
}
.dlabnav .main-menu {
	padding: 1.025rem 1.875rem;
	display: block;
	padding-bottom: 0;
	color: var(--primary);
	text-transform: capitalize;
}

.header-profile2 .nav-link {
	background-color: transparent !important;
}

.header-profile2 img {
	height: 3rem;
	width: 3rem;
	border-radius: 0.375rem;
	margin-left: 0.8rem;
	object-fit: contain;
}
@media only screen and (max-width: 112rem) {
	.header-profile2 img {
		margin-left: 0.5rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.header-profile2 img {
		height: 2.325rem;
		width: 2.325rem;
		margin-left: 0;
	}
}

.header-profile2 span {
	color: #666666;
}
@media only screen and (max-width: 87.5rem) {
	.header-profile2 span {
		font-size: 0.9rem;
	}
}

.header-profile2 i {
	margin-left: 1rem;
	font-size: 1.2rem;
}

@media only screen and (max-width: 87.5rem) {
	.header-profile2 {
		padding: 0.5rem 0.5rem;
		padding-right: 0;
	}
}

@media only screen and (max-width: 47.9375rem) {
	.header-profile2 {
		margin-left: 2px !important;
	}
	.header-profile2 .sidebar-info {
		display: none !important;
	}
}

@media only screen and (max-width: 35.9375rem) {
	.header-profile2 {
		padding: 0;
	}
}

.header-profile2 .dropdown-menu a svg path {
	fill: var(--primary);
}

@media only screen and (max-width: 35.9375rem) {
	.header-profile2 .dropdown-menu a svg {
		width: 1.25rem;
		height: 1.25rem;
	}
}

.header-profile2 .dropdown-menu a span {
	font-size: 15px;
	font-weight: 400;
	color: #a098ae;
}
@media only screen and (max-width: 35.9375rem) {
	.header-profile2 .dropdown-menu a span {
		font-size: 12px;
	}
}

.header-profile2 .dropdown-menu .dropdown-item {
	padding: 0.5rem 0.75rem;
}

.copyright {
	padding: 0 1.875rem;
	color: #9fa4a6;
	margin-top: 1.875rem;
	/* p{
		font-size: 0.875rem;
		/color:#fff;
	} */
}
.copyright strong {
	display: block;
	font-size: 0.875rem;
	font-weight: 700;
	color: var(--primary);
	white-space: nowrap;
}

@media only screen and (max-width: 63.9375rem) {
	.nav-header {
		width: 5rem;
	}
}

@media (max-width: 47.9375rem) {
	.brand-title {
		display: none;
	}
	.footer {
		padding-left: 0;
	}
	.dlabnav {
		left: 0;
		top: 5rem;
	}
}

@media only screen and (min-width: 1024px) and (max-width: 1422px) {
	[data-sidebar-style='full'][data-header-position='fixed'][data-layout='horizontal'][data-container='wide'] .content-body {
		padding-top: 14rem !important;
	}
}

[data-sidebar-style='full'][data-header-position='fixed'][data-layout='vertical'][data-container='wide-boxed'] .content-body {
	padding-top: 5rem !important;
}

[data-header-position='fixed'][data-layout='horizontal'][data-container='wide'][data-sidebar-position='static'] .content-body {
	padding-top: 10rem;
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu > ul.collapse:not(.in),
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu > ul.collapse:not(.in) {
	height: 15.75rem !important;
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu:hover > a,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu:hover > a {
	width: calc(70vw + 3.75rem);
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu:hover > ul,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu:hover > ul {
	display: flex;
	flex-wrap: wrap;
	flex-direction: column;
	max-height: 13.75rem;
	width: 70vw;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu:hover > ul ul a,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu:hover > ul ul a {
	width: 101%;
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-xl:hover > a,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-xl:hover > a {
	width: calc(70vw + 3rem);
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-xl:hover > ul,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-xl:hover > ul {
	max-height: 12.5rem;
	width: 70vw;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-xl:hover > ul ul a,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-xl:hover > ul ul a {
	width: 101%;
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-lg:hover > a,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-lg:hover > a {
	width: calc(55vw + 3rem);
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-lg:hover > ul,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-lg:hover > ul {
	max-height: 12.5rem;
	width: 55vw;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-lg:hover > ul ul a,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-lg:hover > ul ul a {
	width: 101%;
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-md:hover > a,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-md:hover > a {
	width: calc(45vw + 3);
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-md:hover > ul,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-md:hover > ul {
	max-height: 18.75rem;
	width: 45vw;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-md:hover > ul ul a,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-md:hover > ul ul a {
	width: 101%;
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-sm:hover > a,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-sm:hover > a {
	width: calc(30vw + 3);
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-sm:hover > ul,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-sm:hover > ul {
	max-height: 18.125rem;
	width: 30vw;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-sm:hover > ul ul a,
[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-sm:hover > ul ul a {
	width: 101%;
}

[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu:hover > a {
	width: calc(60vw + 3.75rem);
}

[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu:hover > ul {
	display: flex;
	flex-wrap: wrap;
	flex-direction: column;
	max-height: 25rem;
	width: 60vw;
}
[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu:hover > ul ul a {
	width: 101%;
}

[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-xl:hover > a {
	width: calc(60vw + 3.75rem);
}

[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-xl:hover > ul {
	max-height: 25.625rem;
	width: 60vw;
}

[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-lg:hover > a {
	width: calc(50vw + 3.75rem);
}

[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-lg:hover > ul {
	max-height: 16.25rem;
	width: 50vw;
}

[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-md:hover > a {
	width: calc(40vw + 3.75rem);
}

[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-md:hover > ul {
	max-height: 18.75rem;
	width: 40vw;
}

[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-sm:hover > a {
	width: calc(22vw + 3.75rem);
}

[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-sm:hover > ul {
	max-height: 18.125rem;
	width: 22vw;
}

[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:not(:last-child) {
	position: static;
}

[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul {
	left: 0;
	right: 0;
}
[data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {
	border-color: rgba(255, 255, 255, 0.1);
}
[data-sibebarbg='color_2'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {
	border-color: #2d286b;
}
[data-sibebarbg='color_3'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {
	border-color: #000607;
}
[data-sibebarbg='color_4'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {
	border-color: #1f0243;
}
[data-sibebarbg='color_5'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {
	border-color: #921925;
}
[data-sibebarbg='color_6'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {
	border-color: #aa4e01;
}
[data-sibebarbg='color_7'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {
	border-color: #2d3081;
}
[data-sibebarbg='color_8'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {
	border-color: #4e0ecc;
}
[data-sibebarbg='color_9'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {
	border-color: #127155;
}
[data-sibebarbg='color_10'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {
	border-color: #0c525d;
}
[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li a {
	transition: all 0.4s ease-in-out;
}
[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li a:hover {
	border-radius: 0.25rem;
}

[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul {
	display: flex;
	flex-wrap: wrap;
	flex-direction: column;
	max-height: 13.75rem;
	width: 70vw;
	z-index: 99;
}
[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {
	content: '';
	height: 100%;
	width: 0.0625rem;
	position: absolute;
	background-color: #fff;
	right: 2.8125rem;
	top: 0;
}
[data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {
	background-color: #282828;
}
[data-sibebarbg='color_2'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {
	background-color: #3d3690;
}
[data-sibebarbg='color_3'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {
	background-color: #033537;
}
[data-sibebarbg='color_4'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {
	background-color: #360474;
}
[data-sibebarbg='color_5'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {
	background-color: #bd2130;
}
[data-sibebarbg='color_6'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {
	background-color: #dc6502;
}
[data-sibebarbg='color_7'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {
	background-color: #3a3ea7;
}
[data-sibebarbg='color_8'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {
	background-color: #641df0;
}
[data-sibebarbg='color_9'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {
	background-color: #199d76;
}
[data-sibebarbg='color_10'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {
	background-color: #117a8b;
}
[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul ul a {
	width: 101%;
}

[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu-xl:hover > ul {
	max-height: 13.125rem;
	width: 70vw;
}

[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu-lg:hover > ul {
	max-height: 13.125rem;
	width: 43.75rem;
	height: 13.125rem !important;
}
@media only screen and (min-width: 75rem) and (max-width: 93.75rem) {
	[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu-lg:hover > ul {
		width: 43.75rem;
	}
}

[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu-md:hover > ul {
	max-height: 20rem;
	width: 54vw;
}
@media only screen and (min-width: 75rem) and (max-width: 93.75rem) {
	[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu-md:hover > ul {
		width: 60vw;
	}
}

[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu-sm:hover > ul {
	max-height: 20rem;
	width: 25vw;
}
@media only screen and (min-width: 75rem) and (max-width: 93.75rem) {
	[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu-sm:hover > ul {
		width: 35vw;
	}
}

[data-layout='horizontal'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu:hover > ul {
	display: flex;
	flex-wrap: wrap;
	flex-direction: column;
}

[data-layout='horizontal'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-xl:hover > ul {
	max-height: 21.875rem;
	width: 100%;
}

[data-layout='horizontal'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-lg:hover > ul {
	max-height: 21.875rem;
	width: 55vw;
}

[data-layout='horizontal'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-md:hover > ul {
	max-height: 18.75rem;
	width: 45vw;
}

[data-layout='horizontal'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-sm:hover > ul {
	max-height: 18.125rem;
	width: 50vw;
}

:root {
	--primary: #4d44b5;
	--secondary: #fb7d5b;
	--primary-hover: #3d3690;
	--primary-dark: #1e1a46;
	--rgba-primary-1: rgba(77, 68, 181, 0.1);
	--rgba-primary-2: rgba(77, 68, 181, 0.2);
	--rgba-primary-3: rgba(77, 68, 181, 0.3);
	--rgba-primary-4: rgba(77, 68, 181, 0.4);
	--rgba-primary-5: rgba(77, 68, 181, 0.5);
	--rgba-primary-6: rgba(77, 68, 181, 0.6);
	--rgba-primary-7: rgba(77, 68, 181, 0.7);
	--rgba-primary-8: rgba(77, 68, 181, 0.8);
	--rgba-primary-9: rgba(77, 68, 181, 0.9);
	--rgba-secondary-1: rgba(251, 125, 91, 0.1);
	--rgba-secondary-2: rgba(251, 125, 91, 0.2);
	--rgba-secondary-3: rgba(251, 125, 91, 0.3);
	--rgba-secondary-4: rgba(251, 125, 91, 0.4);
	--rgba-secondary-5: rgba(251, 125, 91, 0.5);
	--rgba-secondary-6: rgba(251, 125, 91, 0.6);
	--rgba-secondary-7: rgba(251, 125, 91, 0.7);
	--rgba-secondary-8: rgba(251, 125, 91, 0.8);
	--rgba-secondary-9: rgba(251, 125, 91, 0.9);
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--title: #303972;
}

/*
0 - 600: Phone
600 - 900: Tablet portrait
900 - 1200: Tablet landscape
1200 - 1800: Normal styles
1800+ : Big Desktop
1em = 16px
The smaller device rules always should write below the bigger device rules
Fixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component
*/
[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li {
	padding: 0 1.25rem 0 1.25rem;
}
[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li > a {
	font-size: 0.875rem;
	padding: 0.638rem 1.5rem;
	font-weight: 400;
	border-radius: 0.375rem;
	transition: all 0.5s;
	line-height: 1.5rem;
	/* &:before{
						position:absolute;
						content:"";
						background:var(--primary);
						width:0;
						height:100%;
						top:0;
						left:0rem;
						@include transitionMedium;
						border-radius:1.25rem;
						
					} */
}
[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a {
	font-weight: 500;
	background: var(--bs-body-bg);
	color: var(--primary);
}
[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a:before {
	width: 0.375rem;
}
@media only screen and (max-width: 87.5rem) {
	[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a:before {
		width: 0.6rem;
	}
}
[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a svg path {
	fill: var(--primary);
}
[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: var(--primary);
	font-weight: 900;
}
[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li .has-arrow:after {
	right: 1.5rem;
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .nav-header {
	width: 5.5rem;
	z-index: 999;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .nav-header .brand-logo {
	padding-left: 0;
	padding-right: 0;
	justify-content: center;
	.main-logo {
		width: 40%;
	}
}
.brand-logo .main-logo {
	width: 20%;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .nav-header .nav-control {
	right: -5.2rem;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .nav-header .nav-control .hamburger .line {
	background-color: #303972;
	opacity: 1;
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .copyright,
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .plus-box {
	display: none;
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .header {
	padding-left: 5.5rem;
	width: 100%;
}
[direction='rtl'][data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .header {
	padding: 0 0.9375rem;
	padding-right: 7.5rem;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .header .header-content {
	width: calc(100% - 0rem);
	left: 5.5rem;
	margin-left: 0rem;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .header .page-titles {
	padding-left: 7.3rem;
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav {
	width: 5.5rem;
	overflow: visible;
	position: absolute;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .nav-text {
	display: none;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .slimScrollDiv,
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .dlabnav-scroll {
	overflow: visible !important;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .header-info2 {
	padding: 0;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .header-info2 img {
	margin-left: -1rem;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .sidebar-info {
	display: none !important;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .header-profile2 {
	margin: 0 0.5rem;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li {
	position: relative;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li a {
	background: transparent;
	margin: 0.125rem 0;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li a svg {
	max-width: 1.5rem;
	max-height: 1.5rem;
	margin-right: 0;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li a:before {
	content: none;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li a i {
	margin: 0;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li > ul {
	position: absolute;
	left: 5.5rem;
	top: 0;
	width: 12rem;
	z-index: 1001;
	display: none;
	padding-left: 0.0625rem;
	height: auto !important;
	box-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);
	border-radius: 0.375rem;
	margin-left: 0;
	border: 0;
	background: #fff;
}
[direction='rtl'][data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li > ul {
	left: auto;
	right: 5rem;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li > ul li:hover ul {
	left: 11.8125rem;
	top: 0;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li > ul li:hover ul:after {
	content: none;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li:hover > ul {
	display: block;
	height: auto;
	overflow: visible;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li {
	transition: all 0.4s ease-in-out;
	padding: 0 1.125rem;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li > a {
	padding: 0.75rem 0.925rem;
	text-align: center;
	border-radius: 0.5rem;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li > a.has-arrow:after {
	display: none;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mm-active > a {
	background: var(--primary);
	border-radius: 0.375rem;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
	padding: 0;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover:nth-last-child(-n + 1) > ul {
	bottom: 0;
	top: auto;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > a {
	border-radius: 0.375rem;
	background: var(--primary);
	color: #fff;
}
[data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > a {
	background: var(--primary);
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > a i {
	color: #fff;
	/* background:\$primary; */
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > a svg path {
	fill: #fff;
	stroke: #fff;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > ul {
	height: auto !important;
	padding: 0.625rem 0;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > ul a {
	padding: 0.375rem 1.25rem 0.375rem 1.25rem;
	margin-left: -0.1rem;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > ul ul {
	padding: 0.625rem 0;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > ul ul a {
	padding: 0.375rem 1.25rem 0.375rem 1.25rem;
	margin-left: -0.1rem;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu .nav-label,
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu .nav-badge {
	display: none;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .feature-box {
	display: none;
}
[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .support-box {
	display: none;
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .content-body {
	margin-left: 5.5rem;
}
[direction='rtl'][data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .content-body {
	margin-right: 5.7rem;
	margin-left: auto;
	border: 0;
}

[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle + .footer {
	padding-left: 5.7rem;
}
[direction='rtl'][data-sidebar-style='full'][data-layout='vertical'] .menu-toggle + .footer {
	padding-left: 0;
	padding-right: 5.7rem;
}

[data-sidebar-style='full'][data-layout='horizontal'] .header .header-content {
	padding-left: 1.875rem;
}

/*
0 - 600: Phone
600 - 900: Tablet portrait
900 - 1200: Tablet landscape
1200 - 1800: Normal styles
1800+ : Big Desktop
1em = 16px
The smaller device rules always should write below the bigger device rules
Fixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component
*/
:root {
	--primary: #4d44b5;
	--secondary: #fb7d5b;
	--primary-hover: #3d3690;
	--primary-dark: #1e1a46;
	--rgba-primary-1: rgba(77, 68, 181, 0.1);
	--rgba-primary-2: rgba(77, 68, 181, 0.2);
	--rgba-primary-3: rgba(77, 68, 181, 0.3);
	--rgba-primary-4: rgba(77, 68, 181, 0.4);
	--rgba-primary-5: rgba(77, 68, 181, 0.5);
	--rgba-primary-6: rgba(77, 68, 181, 0.6);
	--rgba-primary-7: rgba(77, 68, 181, 0.7);
	--rgba-primary-8: rgba(77, 68, 181, 0.8);
	--rgba-primary-9: rgba(77, 68, 181, 0.9);
	--rgba-secondary-1: rgba(251, 125, 91, 0.1);
	--rgba-secondary-2: rgba(251, 125, 91, 0.2);
	--rgba-secondary-3: rgba(251, 125, 91, 0.3);
	--rgba-secondary-4: rgba(251, 125, 91, 0.4);
	--rgba-secondary-5: rgba(251, 125, 91, 0.5);
	--rgba-secondary-6: rgba(251, 125, 91, 0.6);
	--rgba-secondary-7: rgba(251, 125, 91, 0.7);
	--rgba-secondary-8: rgba(251, 125, 91, 0.8);
	--rgba-secondary-9: rgba(251, 125, 91, 0.9);
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--title: #303972;
}

@media only screen and (min-width: 48rem) {
	[data-sidebar-style='mini'] .nav-header {
		width: 6.25rem;
	}
	[data-sidebar-style='mini'] .nav-header .nav-control {
		z-index: -1;
	}
	[data-sidebar-style='mini'] .nav-header .nav-control .hamburger {
		left: 6.25rem !important;
	}
	[data-sidebar-style='mini'] .nav-header .nav-control .hamburger .line {
		background-color: #303972 !important;
	}
	[data-sidebar-style='mini'] .nav-header .brand-title {
		display: none;
	}
	[data-sidebar-style='mini'] .nav-header .hamburger {
		display: none;
	}
	[data-sidebar-style='mini'] .header .header-content {
		padding-left: 1.875rem;
		left: 6.32rem;
		padding-right: 2rem;
		width: auto;
		margin-left: 0;
	}
	[direction='rtl'][data-sidebar-style='mini'] .header .header-content {
		padding-right: 1.875rem;
	}
	[data-sidebar-style='mini'] .dlabnav {
		width: 6.25rem;
		overflow: visible;
		position: absolute;
		z-index: 2;
		top: 5rem;
	}
	[data-sidebar-style='mini'] .dlabnav .copyright,
	[data-sidebar-style='mini'] .dlabnav .plus-box {
		display: none;
	}
	[data-sidebar-style='mini'] .dlabnav .nav-text {
		display: none;
	}
	[data-sidebar-style='mini'] .dlabnav .slimScrollDiv,
	[data-sidebar-style='mini'] .dlabnav .dlabnav-scroll {
		overflow: visible !important;
	}
	[data-sidebar-style='mini'] .dlabnav .nav-user {
		padding: 0.6875rem;
	}
	[data-sidebar-style='mini'] .dlabnav .nav-user .media-body {
		display: none;
	}
	[data-sidebar-style='mini'] .dlabnav .header-profile {
		margin-bottom: 0;
		margin-top: 0.75rem;
	}
	[data-sidebar-style='mini'] .dlabnav .header-profile:hover > a.nav-link {
		border-radius: 3rem;
	}
	[data-sidebar-style='mini'] .dlabnav .header-profile img {
		width: 3rem;
		height: 3rem;
	}
	[data-sidebar-style='mini'] .dlabnav .header-profile > a.nav-link {
		border-radius: 3rem;
		padding: 0.3125rem 0.3125rem;
	}
	[data-sidebar-style='mini'] .dlabnav .header-profile .header-info {
		display: none;
	}
	[data-sidebar-style='mini'] .dlabnav .metismenu li a {
		padding: 0.813rem 0.875rem;
	}
	[data-sidebar-style='mini'] .dlabnav .metismenu li a svg {
		margin-right: 0;
	}
	[data-sidebar-style='mini'] .dlabnav .metismenu li a i {
		height: auto;
		width: auto;
		line-height: 1;
		margin: 0;
	}
	[data-sidebar-style='mini'] .dlabnav .metismenu li > ul {
		position: absolute;
		left: 6.25rem;
		top: 2.9375rem;
		width: 11.875rem;
		z-index: 1001;
		display: none;
		padding-left: 0.0625rem;
		box-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);
		height: auto !important;
		border-radius: 0.375rem;
		background: #fff;
	}
	[direction='rtl']:not([data-layout='horizontal'])[data-sidebar-style='mini'] .dlabnav .metismenu li > ul {
		left: auto;
		right: 6.25rem;
		box-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);
	}
	[data-sidebar-style='mini'] .dlabnav .metismenu > li {
		padding: 0.125rem 1.55rem;
	}
	[data-sidebar-style='mini'] .dlabnav .metismenu > li > a {
		padding: 0.825rem 0.875rem;
		/* width: 64px;
						height: 64px; */
		text-align: center;
		line-height: 1;
		transition: all 0.5s;
		-moz-transition: all 0.5s;
		-webkit-transition: all 0.5s;
		-ms-transition: all 0.5s;
		-o-transition: all 0.5s;
	}
	[data-sidebar-style='mini'] .dlabnav .metismenu > li > a > i {
		padding: 0;
		font-size: 1.2rem;
		font-weight: 900;
	}
	[data-sidebar-style='mini'] .dlabnav .metismenu > li > a.has-arrow:after {
		display: none;
	}
	[data-sidebar-style='mini'] .dlabnav .metismenu .nav-label,
	[data-sidebar-style='mini'] .dlabnav .metismenu .nav-badge {
		display: none;
	}
	[data-sidebar-style='mini'] .dlabnav .header-info2 {
		padding: 0;
	}
	[data-sidebar-style='mini'] .dlabnav .header-info2 img {
		margin-left: -1rem;
	}
	[data-sidebar-style='mini'] .dlabnav .sidebar-info {
		display: none !important;
	}
	[data-sidebar-style='mini'] .dlabnav .header-profile2 {
		margin: 0 0.5rem;
	}
	[data-sidebar-style='mini'] .content-body {
		margin-left: 6.25rem;
	}
	[data-sidebar-style='mini'] .footer {
		padding-left: 1rem;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav {
		position: absolute;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu li:hover > ul {
		display: block;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li {
		position: relative;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:after {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		background: var(--primary);
		width: 3px;
		height: 0;
		display: none;
		transition: all 0.5s;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:nth-last-child(-n + 1) > ul {
		bottom: 0;
		top: auto !important;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:nth-last-child(-n + 1) > ul:after {
		top: auto;
		bottom: 1.25rem;
	}
}
@media only screen and (min-width: 48rem) and (max-width: 74.9375rem) {
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:nth-last-child(-n + 1) > ul {
		bottom: 0;
		top: auto !important;
	}
}

@media only screen and (min-width: 48rem) {
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li > ul {
		overflow: visible;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li > ul:after {
		content: none;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li > ul li:hover ul {
		padding: 0.625rem 0;
		width: 13rem;
		left: 13rem;
		top: -0.625rem;
		border: 0;
		margin: 0;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li > ul li:hover ul:after {
		content: none;
	}
	[direction='rtl'][data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li > ul li:hover ul {
		left: auto;
		right: 13rem;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active:after {
		height: 100%;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a {
		background: var(--primary);
		color: #fff;
		border-radius: 0.375rem;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
		color: #fff;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active svg path {
		fill: #fff;
		stroke: #fff;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
		background: var(--primary);
		color: #fff;
		/* box-shadow:0 12px 15px 0 var(--rgba-primary-1); */
		border-radius: 0.375rem;
		position: unset;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
		color: #fff;
	}
	[direction='rtl'][data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a .nav-text {
		padding-left: auto;
		padding-right: 1.6875rem;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul {
		height: auto !important;
		overflow: visible;
		border: 0;
		margin-left: 0;
		left: 6.25rem;
		width: 13rem;
		border-radius: 0.375rem;
		border: 0;
		padding: 0.625rem 0;
		top: 0;
	}
	[data-theme-version='dark'][data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul {
		box-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);
	}
	[direction='rtl'][data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul {
		left: auto;
		right: 6.25rem;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul a {
		padding: 0.375rem 1.25rem 0.375rem 1.25rem;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul a:before {
		content: none;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul a.has-arrow:after {
		right: 1.25rem;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul ul a {
		padding: 0.375rem 1.25rem 0.375rem 1.25rem;
		margin-left: -0.1rem;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul ul a:before {
		content: none;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .feature-box {
		display: none;
	}
	[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .support-box {
		display: none;
	}
	[data-sidebar-style='mini'][data-header-position='fixed'][data-container='boxed'][data-layout='vertical'] .header {
		width: 74.9375rem;
	}
	[data-sidebar-style='mini'][data-layout='horizontal'] .dlabnav .metismenu > li {
		padding: 0;
	}
	[data-sidebar-style='mini'][data-layout='horizontal'] .dlabnav .metismenu > li > a {
		padding: 0.725rem;
	}
	[data-sidebar-style='mini'][data-layout='horizontal'] .dlabnav .metismenu > li > a i {
		padding: 0;
		margin: 0;
	}
	[direction='rtl'][data-sidebar-style='mini'][data-layout='horizontal'] .dlabnav .metismenu > li > a {
		padding: 1.125rem;
	}
	[direction='rtl'][data-sidebar-style='mini'][data-layout='horizontal'] .dlabnav .metismenu > li > a svg {
		margin-left: 0;
	}
	[data-sidebar-style='mini'][data-layout='horizontal'] .dlabnav .metismenu > li > a svg {
		margin-right: 0;
		margin-top: 0;
	}
	[data-sidebar-style='mini'][data-layout='horizontal'] .dlabnav .metismenu > li > ul li a {
		padding: 0.5rem 1.25rem 0.5rem 1.25rem;
	}
}

@media only screen and (max-width: 74.9375rem) {
	[data-sidebar-style='mini'] .dlabnav li.mm-active ul {
		height: auto !important;
	}
	[data-sidebar-style='mini'] .dlabnav li a.has-arrow::after {
		transform: rotate(-225deg) translateY(-50%);
	}
}

:root {
	--primary: #4d44b5;
	--secondary: #fb7d5b;
	--primary-hover: #3d3690;
	--primary-dark: #1e1a46;
	--rgba-primary-1: rgba(77, 68, 181, 0.1);
	--rgba-primary-2: rgba(77, 68, 181, 0.2);
	--rgba-primary-3: rgba(77, 68, 181, 0.3);
	--rgba-primary-4: rgba(77, 68, 181, 0.4);
	--rgba-primary-5: rgba(77, 68, 181, 0.5);
	--rgba-primary-6: rgba(77, 68, 181, 0.6);
	--rgba-primary-7: rgba(77, 68, 181, 0.7);
	--rgba-primary-8: rgba(77, 68, 181, 0.8);
	--rgba-primary-9: rgba(77, 68, 181, 0.9);
	--rgba-secondary-1: rgba(251, 125, 91, 0.1);
	--rgba-secondary-2: rgba(251, 125, 91, 0.2);
	--rgba-secondary-3: rgba(251, 125, 91, 0.3);
	--rgba-secondary-4: rgba(251, 125, 91, 0.4);
	--rgba-secondary-5: rgba(251, 125, 91, 0.5);
	--rgba-secondary-6: rgba(251, 125, 91, 0.6);
	--rgba-secondary-7: rgba(251, 125, 91, 0.7);
	--rgba-secondary-8: rgba(251, 125, 91, 0.8);
	--rgba-secondary-9: rgba(251, 125, 91, 0.9);
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--title: #303972;
}

@media (min-width: 64rem) {
	[data-layout='horizontal'][data-sidebarbg='color_1'] .dlabnav {
		background-color: #fff;
	}
	[data-theme-version='dark'][data-layout='horizontal'][data-sidebarbg='color_1'] .dlabnav {
		background-color: #272738;
	}
	[data-layout='horizontal'] .dlabnav .menu-scroll {
		height: unset;
	}
	[data-layout='horizontal'] .nav-header {
		width: 18.563rem;
		height: 5rem;
		top: 0;
	}
	[data-layout='horizontal'] .nav-header .nav-control {
		display: none;
	}
	[data-layout='horizontal'] .nav-header .brand-logo {
		padding-left: 2.5rem;
		padding-right: 2.5rem;
	}
	[data-layout='horizontal'] .header {
		width: 100%;
		height: 5rem;
		padding-left: 0;
		padding-top: 0;
	}
	[data-layout='horizontal'] .dlabnav {
		width: 100%;
		position: relative;
		height: auto;
		padding-bottom: 0;
		top: 0;
		z-index: 2;
	}
	[data-layout='horizontal'] .dlabnav .slimScrollDiv {
		overflow: visible !important;
	}
	[data-layout='horizontal'] .dlabnav .slimScrollDiv .dlabnav-scroll {
		overflow: visible !important;
	}
	[data-layout='horizontal'] .dlabnav .dlabnav-scroll {
		overflow: visible !important;
	}
	[data-layout='horizontal'] .dlabnav .slimScrollBar {
		display: none !important;
	}
	[data-layout='horizontal'] .dlabnav .header-profile {
		margin-right: 0.9375rem;
		margin-bottom: 0;
		display: none;
	}
	[data-layout='horizontal'] .dlabnav .header-profile:hover > a.nav-link {
		border-radius: 3rem;
	}
	[data-layout='horizontal'] .dlabnav .header-profile img {
		height: 2.8125rem;
		width: 2.8125rem;
	}
	[data-layout='horizontal'] .dlabnav .header-profile > a.nav-link {
		border-radius: 3rem;
		padding: 0.3125rem 0.3125rem;
	}
	[data-layout='horizontal'] .dlabnav .header-profile .header-info {
		display: none;
	}
	[data-layout='horizontal'] .dlabnav .header-profile2 {
		display: none;
	}
	[data-layout='horizontal'] .dlabnav .nav-user,
	[data-layout='horizontal'] .dlabnav .nav-label {
		display: none;
	}
	[data-layout='horizontal'] .dlabnav .metismenu {
		flex-direction: row;
		padding: 0.625rem 1.25rem;
		margin-bottom: 0;
		display: inline-flex;
		flex-wrap: wrap;
	}
	[data-layout='horizontal'] .dlabnav .metismenu .collapse.in {
		display: none;
	}
	[data-layout='horizontal'] .dlabnav .metismenu ul {
		border-left: 0;
	}
	[data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu ul {
		box-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);
	}
	[data-layout='horizontal'] .dlabnav .metismenu li {
		flex-direction: column;
		position: relative;
	}
	[data-layout='horizontal'] .dlabnav .metismenu li:hover > ul {
		display: block;
	}
	[data-layout='horizontal'] .dlabnav .metismenu li > ul {
		position: absolute;
		height: auto !important;
		top: 100%;
		width: 100%;
		min-width: 13.75rem;
		z-index: 999;
		left: auto;
		right: auto;
		padding: 0.5rem 0;
		display: none;
		box-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);
		margin: 0;
		background: #fff;
		border-radius: 0.375rem;
	}
	[data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu li > ul {
		box-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);
		background: #272738;
	}
	[data-layout='horizontal'] .dlabnav .metismenu li > ul li {
		padding: 0;
	}
	[data-layout='horizontal'] .dlabnav .metismenu li > ul li a {
		transition: all 0.4s ease-in-out;
		padding: 0.5rem 1.25rem 0.5rem 1.25rem;
		margin-left: -0.1rem;
	}
	[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu li > ul li a {
		padding: 0.5rem 1.25rem 0.5rem 1.25rem;
		text-align: right;
	}
	[data-layout='horizontal'] .dlabnav .metismenu li > ul li a:hover {
		border-radius: 0.4rem;
		padding-left: 1.25rem;
	}
	[data-layout='horizontal'] .dlabnav .metismenu li > ul li a:before {
		content: none;
		left: 1.375rem;
	}
	[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu li > ul li a:before {
		left: auto;
		right: 0.375rem;
	}
	[data-layout='horizontal'] .dlabnav .metismenu li > ul ul {
		left: 100%;
		top: 0;
		box-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);
	}
	[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu li > ul ul {
		left: auto;
		right: 100%;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li {
		flex: 0 0 auto;
		position: relative;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li > a i {
		margin-right: 0.3125rem;
	}
	[data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu > li {
		border-color: rgba(255, 255, 255, 0.07);
	}
	[data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active {
		border-color: transparent;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li:hover,
	[data-layout='horizontal'] .dlabnav .metismenu > li.mm-active {
		padding: 0;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
	[data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a {
		background: var(--primary);
		color: #fff;
		border-radius: 0.375rem;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li:hover > a i,
	[data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a i {
		color: #fff;
		background: transparent;
		box-shadow: none;
	}
	[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li:first-child {
		border-right: 0;
	}
	[data-theme-version='dark'][direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li {
		border-color: rgba(255, 255, 255, 0.1);
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li > a {
		padding: 0.7375rem 2.4rem 0.7375rem 0.7375rem;
		margin: 0.125rem 0.125rem;
	}
	[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li > a {
		padding: 0.9375rem 0.9375rem 0.9375rem 2.5rem;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li > a i {
		padding: 0 0.4375rem 0 0;
		height: auto;
		width: auto;
		line-height: 1;
	}
	[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li > a i {
		padding: 0 0 0 0.4375rem;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li > a .nav-badge {
		display: none;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li > a:after {
		right: 1.25rem;
		transform: rotate(-135deg) translateY(-50%);
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li:hover {
		border-color: transparent;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li:hover > ul {
		display: flex !important;
		flex-direction: column;
		flex-wrap: wrap;
		height: auto !important;
		box-shadow: 0.3125rem 0.3125rem 1.875rem 0rem rgba(20, 0, 30, 0.1);
		border-radius: 0.375rem;
	}
	[data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > ul {
		box-shadow: 0.3125rem 0.3125rem 1.875rem 0rem rgba(0, 0, 0, 0.1);
		background: #272738;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li > ul > li:hover ul.collapse {
		display: block !important;
		position: absolute;
		left: auto !important;
		right: -100% !important;
		top: 0 !important;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li:nth-last-child(-n + 5) > ul {
		left: auto;
		right: 0;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li:nth-last-child(-n + 5) > ul > li:hover ul.collapse {
		right: auto !important;
		left: -100% !important;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li:nth-last-child(-n + 5) > ul.left {
		left: 0;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li:nth-last-child(-n + 5) > ul.left > li:hover ul.collapse {
		left: 100% !important;
	}
	[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li:nth-last-child(-n + 5) > ul.left {
		left: auto;
		right: 0;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li:last-child > ul ul {
		left: -100%;
	}
	[data-layout='horizontal'] .dlabnav .metismenu > li:last-child > ul.left ul {
		left: 100%;
	}
	[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li:last-child > ul.left ul {
		left: auto;
		right: 100%;
	}
	[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li:nth-last-child(-n + 3) > ul {
		left: 0;
		right: auto;
	}
	[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li:nth-last-child(-n + 3) > ul > li:hover ul.collapse {
		right: -100% !important;
		left: auto !important;
	}
	[data-layout='horizontal'] .dlabnav .copyright,
	[data-layout='horizontal'] .dlabnav .feature-box,
	[data-layout='horizontal'] .dlabnav .support-box {
		display: none;
	}
	[data-layout='horizontal'] .content-body {
		margin-left: 0;
	}
	[data-layout='horizontal'] .content-body .container-fluid,
	[data-layout='horizontal'] .content-body .container-sm,
	[data-layout='horizontal'] .content-body .container-md,
	[data-layout='horizontal'] .content-body .container-lg,
	[data-layout='horizontal'] .content-body .container-xl,
	[data-layout='horizontal'] .content-body .container-xxl {
		padding-top: 2.5rem;
	}
}
@media only screen and (min-width: 64rem) and (max-width: 74.9375rem) {
	[data-layout='horizontal'] .content-body .container-fluid,
	[data-layout='horizontal'] .content-body .container-sm,
	[data-layout='horizontal'] .content-body .container-md,
	[data-layout='horizontal'] .content-body .container-lg,
	[data-layout='horizontal'] .content-body .container-xl,
	[data-layout='horizontal'] .content-body .container-xxl {
		padding-top: 4.5rem;
	}
}

@media (min-width: 64rem) {
	[data-layout='horizontal'] .content-body .page-titles {
		margin-left: 0 !important;
		margin-right: 0 !important;
		margin-bottom: 1.875rem;
	}
	[data-layout='horizontal'] .footer {
		margin-left: 0;
		margin: 0 auto;
		padding-left: 0;
	}
	[data-layout='horizontal'] .footer.footer-outer {
		width: calc(100% - 25.225rem);
		margin-left: 1.775rem;
	}
	[data-layout='horizontal'] .footer.style-2 {
		width: calc(100% - 3.825rem);
	}
	[data-layout='horizontal'] .footer.style-1 {
		width: calc(100% - 22.325rem);
		margin-right: 19.975rem !important;
	}
	[data-header-position='fixed'][data-layout='horizontal'] .dlabnav {
		top: 5rem;
	}
	[data-header-position='fixed'][data-layout='horizontal'] .header {
		height: 5rem;
	}
	[data-header-position='fixed'][data-layout='horizontal'] .header.is-fixed {
		border-bottom: 1px solid #eeeeee;
	}
	[data-header-position='fixed'][data-layout='horizontal'] .content-body {
		padding-top: 5rem;
	}
	[data-header-position='fixed'][data-layout='horizontal'] {
		/* [data-header-position="fixed"][data-sidebar-position="static"] {
		.dlabnav {
            top: 0rem;
        }
		.content-body {
			padding-top: 0rem;
		}
	} */
	}
	[data-header-position='fixed'][data-layout='horizontal'] .dlabnav {
		position: fixed;
	}
	[data-header-position='fixed'][data-layout='horizontal'][data-sidebar-position='fixed'] .content-body {
		padding-top: 10rem;
	}
}

@media only screen and (min-width: 64rem) and (max-width: 88.75rem) {
	[data-header-position='fixed'][data-layout='horizontal'] [data-sidebar-style='full'] .content-body {
		padding-top: 14rem;
	}
}

@media (min-width: 64rem) {
	[data-header-position='fixed'][data-layout='horizontal'][data-sidebar-position='fixed'][data-sidebar-style='modern'] .content-body {
		padding-top: 13rem;
	}
	[data-layout='horizontal'][data-container='boxed'] .footer {
		margin-left: 0;
		max-width: 74.9375rem;
		margin: 0 auto;
	}
	[data-layout='horizontal'][data-container='wide'] .page-titles {
		margin-left: -1.875rem;
		margin-right: -1.875rem;
		display: none;
	}
	[data-layout='horizontal'][data-container='wide'] .header-banner {
		display: none;
	}
	[data-layout='horizontal'][data-sidebar-style='modern'] .dlabnav .header-profile {
		margin-bottom: 0;
	}
	[data-layout='horizontal'][data-sidebar-style='modern'] .dlabnav .header-profile img {
		height: 3.75rem;
		width: 3.75rem;
		margin-bottom: 0 !important;
	}
	[data-layout='horizontal'][data-sidebar-style='modern'] .dlabnav .header-profile > a.nav-link {
		border: 0.0625rem solid #eeeeee;
		padding: 0.25rem 0.25rem;
		border-radius: 3rem;
	}
	[data-layout='horizontal'][data-sidebar-style='compact'] .page-titles {
		margin-top: 0;
	}
	[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .header-profile {
		margin-bottom: 0;
	}
	[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .header-profile img {
		height: 3.75rem;
		width: 3.75rem;
		margin-bottom: 0 !important;
	}
	[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .header-profile > a.nav-link {
		border: 0.0625rem solid #eeeeee;
	}
	[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .metismenu > li > ul {
		top: 5.1rem;
	}
	[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .metismenu > li > a {
		padding: 1.125rem 1.25rem 0.625rem 1.25rem;
	}
	[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .metismenu > li > a::after {
		display: none;
	}
	[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .metismenu > li > a .nav-text {
		margin-top: 0.3125rem;
	}
	[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .metismenu > li > a > i {
		width: auto;
		margin: 0;
		height: auto;
		line-height: 1;
		padding: 0;
		background: transparent;
		border-radius: 0;
		margin-bottom: 0;
	}
	[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .metismenu > li li {
		text-align: left;
	}
	[data-sidebar-style='mini'][data-layout='horizontal'] .nav-header {
		width: 7.75rem;
		padding-left: 2.5rem;
		padding-right: 2.5rem;
	}
	[data-sidebar-style='mini'][data-layout='horizontal'] .nav-header .brand-logo {
		justify-content: start;
		padding-left: 0;
		padding-right: 0;
	}
	[data-sidebar-style='mini'][data-layout='horizontal'] .header {
		width: 100%;
		padding-left: 7.75rem;
	}
	[data-sidebar-style='mini'][data-layout='horizontal'] .metismenu > li a {
		width: auto;
	}
	[data-sidebar-style='mini'][data-layout='horizontal'] .metismenu > li:hover a .nav-text {
		display: none;
	}
	[data-header-position='fixed'][data-layout='horizontal'][data-sidebar-position='fixed'][data-sidebar-style='compact'] .content-body {
		padding-top: 11.8rem;
	}
	[data-sidebar-position='fixed'][data-layout='horizontal'] .dlabnav.fixed {
		position: fixed;
		padding: 0 0.9375rem;
		left: 0;
		top: 0;
		border-radius: 0;
		width: 100%;
	}
	[data-sidebar-position='fixed'][data-layout='horizontal'] .wallet-open.show.active .dlabnav-scroll {
		padding-right: 352px;
	}
	[data-sidebar-position='fixed'][data-layout='horizontal'] .wallet-open.show.active .content-body {
		padding-top: 13rem;
	}
}

@media (min-width: 47.9375rem) {
	[data-sidebar-style='compact'] .nav-header {
		width: 11.25rem;
	}
	[data-sidebar-style='compact'] .dlabnav .metismenu .has-arrow[aria-expanded='true']:after,
	[data-sidebar-style='compact'] .dlabnav .metismenu .mm-active > .has-arrow:after {
		margin-right: 0;
	}
	[data-sidebar-style='compact'] .dlabnav .header-profile {
		margin-bottom: 0.3125rem;
	}
	[data-sidebar-style='compact'] .dlabnav .header-profile > a.nav-link {
		display: block;
		text-align: center;
		border: 0;
	}
	[data-sidebar-style='compact'] .dlabnav .header-profile > a.nav-link img {
		margin-bottom: 0.3125rem;
	}
	[data-sidebar-style='compact'] .dlabnav .header-profile > a.nav-link .header-info {
		margin-left: 0 !important;
		text-align: center;
		display: none;
	}
	[data-sidebar-style='compact'] .dlabnav .header-profile > a.nav-link .header-info small,
	[data-sidebar-style='compact'] .dlabnav .header-profile > a.nav-link .header-info .small {
		text-align: center !important;
	}
	[data-sidebar-style='compact'] .dlabnav .header-profile .dropdown-menu {
		min-width: 11rem;
	}
	[data-sidebar-style='compact'] .dlabnav .header-profile a svg {
		display: unset !important;
	}
	[data-sidebar-style='compact'] .dlabnav .nav-user {
		display: none;
	}
	[data-sidebar-style='compact'] .dlabnav .metismenu li {
		text-align: center;
	}
	[data-sidebar-style='compact'] .dlabnav .metismenu li a {
		padding: 0.7rem 0.5rem;
	}
	[data-sidebar-style='compact'] .dlabnav .metismenu li a svg {
		max-width: 1.3125rem;
		max-height: 1.3125rem;
		display: block;
		margin-left: auto;
		margin-right: auto;
	}
	[data-sidebar-style='compact'] .dlabnav .metismenu li a i {
		transition: all 0.5s;
	}
	[data-sidebar-style='compact'] .dlabnav .metismenu li ul:after {
		content: none;
	}
	[data-sidebar-style='compact'] .dlabnav .metismenu li > a {
		box-shadow: none;
		font-size: 0.9375rem;
	}
	[data-sidebar-style='compact'] .dlabnav .plus-box,
	[data-sidebar-style='compact'] .dlabnav .copyright {
		display: none;
	}
	[data-sidebar-style='compact'] .dlabnav .copyright {
		padding: 0 1.25rem;
		margin-top: 1.25rem;
	}
	[data-sidebar-style='compact'] .dlabnav .header-info2 {
		padding: 0;
	}
	[data-sidebar-style='compact'] .dlabnav .header-info2 img {
		margin-left: -1rem;
	}
	[data-sidebar-style='compact'] .dlabnav .sidebar-info {
		display: none !important;
	}
	[data-sidebar-style='compact'] .dlabnav .header-profile2 {
		margin: 0 3rem;
	}
	[data-sidebar-style='compact'] .dlabnav .feature-box,
	[data-sidebar-style='compact'] .dlabnav .support-box {
		display: none;
	}
	[data-sidebar-style='compact'] .nav-text {
		display: inline-block;
		margin-top: 0.3125rem;
	}
	[data-sidebar-style='compact'] .nav-label.first {
		display: none;
	}
	[data-sidebar-style='compact'] .nav-badge {
		display: none;
	}
	[data-sidebar-style='compact'] .footer {
		padding-left: 0;
		width: calc(100% - 37.225rem);
	}
	[data-sidebar-style='compact'] .content-body {
		margin-left: 11.2rem;
	}
	[data-sidebar-style='compact'][data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu li > a i {
		color: #fff;
	}
	[data-sidebar-style='compact'][data-theme-version='dark'][data-layout='vertical'] .dlabnav .metismenu li.mm-active > a i {
		background: var(--primary);
		color: #fff;
	}
	[data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu li:hover > a i {
		background: var(--primary);
		color: #fff;
	}
}

[data-layout='horizontal'][data-sidebar-style='compact'] .footer {
	padding-left: 0;
}

[data-layout='horizontal'][data-sidebar-style='compact'] .content-body {
	margin-left: 0;
}

[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav {
	margin-bottom: 0;
}

[data-layout='horizontal'][data-sidebar-style='compact'] .nav-header {
	width: 13.25rem;
}

[data-layout='vertical'][data-sidebar-style='compact'] .dlabnav {
	width: 11.25rem;
}
[data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu ul {
	margin-left: 0;
	border: 0;
	background: rgba(0, 0, 0, 0.02);
	padding: 0.625rem 0;
}
[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu ul {
	background: 255, 255, 255, 0.05;
}
[data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu ul a:before {
	content: none;
}
[data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu ul ul a {
	padding: 0.625rem 0.9375rem;
}
[data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li > a {
	padding: 1.2rem 0.5rem;
}
[data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li > a.has-arrow::after {
	top: 0.0625rem;
	display: inline-block;
	right: auto;
	margin-left: 0.3125rem;
	position: relative;
	width: 0.4375rem;
	height: 0.4375rem;
	border-width: 0.125rem 0rem 0rem 0.125rem;
}
[direction='rtl'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li > a.has-arrow::after {
	left: auto;
	margin-left: 0;
	margin-right: 0.3125rem;
}
[data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a {
	background: transparent;
	color: var(--primary);
}

@media (min-width: 47.9375rem) {
	[data-sidebar-style='icon-hover'][data-layout='horizontal'] .header .header-content {
		padding-left: 1.875rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu li.mm-active > ul {
		display: none;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .header-info2 {
		justify-content: space-between;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .header-info2 img {
		order: 1;
		margin-right: 0;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .dlabnav .metismenu li.mm-active > ul {
		display: block;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .nav-header {
		width: 4.36rem;
		border-radius: 0 0 0 0 !important;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .nav-header .brand-logo {
		padding: 0;
		padding-left: 0.5rem;
	}
	[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .nav-header .brand-logo {
		padding-left: 1.875rem;
		padding-right: 1.875rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .nav-header .brand-logo .logo-abbr {
		display: block;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .nav-header .brand-logo .brand-title {
		display: none;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .nav-header .nav-control {
		display: none;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .header {
		padding-left: 5rem;
	}
	[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .header {
		padding-right: 7rem;
		padding-left: 0.9375rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .header .header-content {
		padding-left: 2rem;
		left: 5rem;
		width: auto;
		margin-left: 0.8rem;
	}
	[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .header .header-content {
		padding-right: 1.375rem;
		padding-left: 0;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav {
		overflow: visible;
		position: absolute;
		left: -13.2rem;
	}
}
@media only screen and (min-width: 47.9375rem) and (min-width: 47.9375rem) and (max-width: 87.5rem) {
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav {
		left: -10rem;
	}
}

@media (min-width: 47.9375rem) {
	[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav {
		left: auto;
		right: -14.563rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .nav-label {
		display: none;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .header-profile img {
		order: 1;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .header-profile .header-info {
		margin-left: 0 !important;
		padding-left: 0 !important;
		margin-right: 0.625rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li {
		padding: 0 1rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li > a {
		display: flex;
		justify-content: space-between;
		font-size: 0.938rem;
		border-radius: 0.375rem;
		align-items: center;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li > a > svg,
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
		order: 1;
		margin-right: 0;
		margin-top: 0;
		padding-right: 0;
		height: auto;
		width: auto;
		line-height: 1;
	}
	[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li > a > svg,
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
		padding-left: 0;
		padding-right: 0;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a,
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a {
		background: var(--primary);
		color: #fff;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i,
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
		color: #fff;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul {
		border-left: 0;
		padding-left: 0;
		padding-right: 0;
	}
	[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul {
		padding-right: 0;
		padding-left: 0;
	}
	[data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul {
		border-color: rgba(255, 255, 255, 0.1);
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul:after {
		left: auto;
		right: 1.75rem;
	}
	[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul:after {
		left: 1.75rem;
		right: auto;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul a {
		position: relative;
		padding-left: 1.8rem;
	}
	[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul a {
		padding-right: 1.25rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul a::before {
		left: 1.25rem;
		right: auto;
	}
	[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul a::before {
		right: auto;
		left: -0.3125rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu .has-arrow::after {
		right: 5rem;
		opacity: 0;
	}
	[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu .has-arrow::after {
		right: auto;
		left: 5rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .copyright,
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .support-box {
		display: none;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav.mm-show {
		display: none;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .nav-header {
		width: 17.5rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .nav-header .brand-logo {
		padding-left: 1.6rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .nav-header .brand-logo .brand-title {
		display: block;
	}
}
@media only screen and (min-width: 47.9375rem) and (max-width: 87.5rem) {
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .nav-header {
		width: 1rem;
	}
}

@media (min-width: 47.9375rem) {
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle.mm-show {
		display: block;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .header {
		padding-left: 4.38rem;
	}
	[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .header {
		padding-right: 4.38rem;
		padding-left: 0.9375rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .dlabnav {
		left: 0;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .dlabnav .metismenu .has-arrow:after {
		opacity: 1;
	}
	[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .dlabnav {
		left: auto;
		right: 0;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .dlabnav .support-box {
		display: block;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .content-body {
		margin-left: 5.6rem;
	}
	[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .content-body {
		margin-left: 0;
		margin-right: 7rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .footer {
		padding-left: 7rem;
	}
	[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .footer {
		margin-left: 0;
		margin-right: 7rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .footer.style-1 {
		width: calc(100% - 28.125rem);
		margin-right: 20.675rem;
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .footer.footer-outer {
		width: calc(100% - 31.225rem);
	}
	[data-sidebar-style='icon-hover'][data-layout='vertical'] .footer.style-2 {
		width: calc(100% - 9.325rem);
	}
}

@media (min-width: 47.9375rem) {
	[data-sidebar-style='modern'] .nav-header {
		width: 10.625rem;
	}
	[data-sidebar-style='modern'] .nav-header .brand-logo {
		justify-content: center;
	}
	[data-sidebar-style='modern'] .dlabnav .header-profile {
		margin-bottom: 0.3125rem;
	}
	[data-sidebar-style='modern'] .dlabnav .header-profile > a.nav-link {
		display: block;
		text-align: center;
		margin: 0 -0.625rem 0.9375rem;
		padding: 0.9375rem 0.625rem;
		border-radius: 0.375rem;
	}
	[data-sidebar-style='modern'] .dlabnav .header-profile > a.nav-link img {
		margin-bottom: 0.3125rem;
	}
	[data-sidebar-style='modern'] .dlabnav .header-profile > a.nav-link .header-info {
		margin-left: 0 !important;
		text-align: center;
		display: none;
	}
	[data-sidebar-style='modern'] .dlabnav .header-profile > a.nav-link .header-info small,
	[data-sidebar-style='modern'] .dlabnav .header-profile > a.nav-link .header-info .small {
		text-align: center !important;
	}
	[data-sidebar-style='modern'] .dlabnav .metismenu > li {
		text-align: center;
	}
	[data-sidebar-style='modern'] .dlabnav .metismenu > li > a {
		padding: 1.25rem 0.9375rem 1.25rem 0.9375rem;
		margin: 0.125rem 0;
		transition: all 0.5s;
	}
	[data-sidebar-style='modern'] .dlabnav .metismenu > li > a::after {
		display: none;
	}
	[data-sidebar-style='modern'] .dlabnav .metismenu > li > a:hover > a,
	[data-sidebar-style='modern'] .dlabnav .metismenu > li > a:focus > a,
	[data-sidebar-style='modern'] .dlabnav .metismenu > li > a:active > a,
	[data-sidebar-style='modern'] .dlabnav .metismenu > li > a.mm-active > a {
		background-color: var(--primary-dark);
	}
	[data-sidebar-style='modern'] .dlabnav .metismenu > li:hover,
	[data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active {
		padding: 0;
	}
	[data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
	[data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a {
		background: var(--primary);
		color: #fff;
		border-radius: 0.375rem;
	}
	[data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a i,
	[data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a i {
		color: #fff;
	}
	[data-sidebar-style='modern'] .dlabnav .metismenu > li li {
		text-align: left;
	}
	[direction='rtl'][data-sidebar-style='modern'] .dlabnav .metismenu > li li {
		text-align: right;
	}
	[data-sidebar-style='modern'] .dlabnav .metismenu li a {
		padding: 0.625rem 0.9375rem 0.625rem 0.9375rem;
		font-size: 0.9375rem;
	}
	[data-sidebar-style='modern'] .dlabnav .metismenu li ul:after {
		content: none;
	}
	[data-sidebar-style='modern'] .dlabnav .metismenu li > ul {
		height: auto !important;
	}
	[data-sidebar-style='modern'] .dlabnav .metismenu .nav-label {
		display: none;
	}
	[data-sidebar-style='modern'] .dlabnav .nav-label {
		display: none;
	}
	[data-sidebar-style='modern'] .dlabnav .nav-text {
		display: block;
		margin-top: 0.3125rem;
	}
	[data-sidebar-style='modern'] .dlabnav .feature-box,
	[data-sidebar-style='modern'] .dlabnav .support-box,
	[data-sidebar-style='modern'] .dlabnav .copyright {
		display: none;
	}
	[data-sidebar-style='modern'] .footer {
		padding-left: 11.9rem;
	}
	[data-sidebar-style='modern'] .content-body {
		margin-left: 10.9rem;
	}
	[data-sidebar-style='modern'][data-layout='horizontal'] .dlabnav .metismenu li > a i {
		padding: 0;
		margin: 0;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav {
		width: 10.625rem;
		left: 0;
	}
	[direction='rtl'][data-sidebar-style='modern'][data-layout='vertical'] .dlabnav {
		left: auto;
		right: 0;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .slimScrollDiv,
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .dlabnav-scroll {
		overflow: visible !important;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu {
		padding: 0.625rem 0.875rem;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu > li > a {
		padding: 1.375rem 0.6em 0.9375rem;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu > li > a i {
		padding: 0;
		height: auto;
		width: auto;
		margin: 0;
		line-height: 1;
		margin-bottom: 0.3125rem;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu > li > ul {
		display: none;
		padding: 1.875rem 0.9375rem;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li {
		position: relative;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li a {
		padding: 1rem 1rem;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li a:before {
		content: none;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li ul {
		position: absolute;
		left: 105%;
		top: 0;
		bottom: auto;
		background-color: #fff;
		border: 0.0625rem solid #f2f2f2;
		width: 12.5rem;
	}
	[data-theme-version='dark'][data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li ul {
		background: #272738;
		box-shadow: 0rem 0rem 0.8125rem 0rem rgba(0, 0, 0, 0.1);
	}
	[direction='rtl'][data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li ul {
		left: auto;
		right: 105%;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li:hover > ul {
		display: block;
		left: 100%;
		padding: 1rem 0;
		margin-left: 0;
		border: 0;
		box-shadow: 0.3125rem 0.3125rem 1.875rem 0rem rgba(20, 0, 30, 0.1);
		border-radius: 0.375rem;
	}
	[data-theme-version='dark'][data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li:hover > ul {
		box-shadow: 0.3125rem 0.3125rem 1.875rem 0rem rgba(20, 0, 30, 0.1);
	}
	[direction='rtl'][data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li:hover > ul {
		left: auto;
		right: 100%;
		box-shadow: -0.3125rem 0.3125rem 1.875rem 0rem rgba(20, 0, 30, 0.1);
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .nav-label {
		display: none;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .nav-text {
		display: block;
		margin-top: 0;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .header-profile2 {
		padding: 0 2.5rem;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .nav-control {
		right: -4.25rem;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .header .header-content {
		padding-left: 0rem;
		left: 13.6rem;
		width: calc(100% - 18.75rem);
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .menu-toggle .dlabnav,
	[data-sidebar-style='modern'][data-layout='vertical'] .menu-toggle .nav-header {
		left: -10.625rem;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .menu-toggle .header {
		padding-left: 0;
	}
	[data-sidebar-style='modern'][data-layout='vertical'] .menu-toggle .content-body {
		margin-left: 0;
	}
	[data-sidebar-style='modern'][data-layout='horizontal'] .nav-header {
		width: 17.05rem;
	}
	[data-sidebar-style='modern'][data-layout='horizontal'] .footer,
	[data-sidebar-style='modern'][data-layout='horizontal'] .content-body {
		margin-left: 0;
	}
	[data-sidebar-style='modern'][data-layout='horizontal'] .footer.footer-outer,
	[data-sidebar-style='modern'][data-layout='horizontal'] .content-body.footer-outer {
		width: calc(100% - 25.225rem);
		margin-left: 1.775rem !important;
	}
	[data-sidebar-style='modern'][data-layout='horizontal'] .footer.style-2,
	[data-sidebar-style='modern'][data-layout='horizontal'] .content-body.style-2 {
		width: calc(100% - 3.225rem);
		margin-left: 1.775rem !important;
	}
	[data-sidebar-style='modern'][data-layout='horizontal'] .footer.style-1,
	[data-sidebar-style='modern'][data-layout='horizontal'] .content-body.style-1 {
		width: calc(100% - 22.225rem);
		margin-left: 1.775rem !important;
	}
	[data-sidebar-style='modern'][data-layout='horizontal'] .dlabnav .metismenu > li > a {
		padding: 0.9375rem 1.5625rem 0.75rem 1.4625rem;
		margin: 0 0.125rem;
	}
	[data-sidebar-style='modern'][data-layout='horizontal'] .dlabnav .metismenu > li > ul {
		top: 4.8rem;
	}
	[data-sidebar-style='modern'][data-layout='horizontal'][data-container='boxed'] .dlabnav .metismenu > li > a {
		padding: 0.8125rem 1.25rem;
	}
}

[data-container='boxed'][data-layout='vertical'] .header .header-content,
[data-container='boxed'][data-sidebar-style='modern'] .header .header-content,
[data-container='wide-boxed'][data-layout='vertical'] .header .header-content,
[data-container='wide-boxed'][data-sidebar-style='modern'] .header .header-content {
	padding-left: 0rem;
	width: calc(100% - 0.1rem);
}

[data-container='wide-boxed'] .header-content {
	padding-left: 5.2rem !important;
}

[data-container='boxed'][data-sidebar-style='modern'][data-layout='horizontal'] .header .header-content {
	width: calc(100% - 16.7rem);
}

[data-container='boxed'][data-sidebar-style='modern'][data-layout='horizontal'] .content-body {
	padding-top: 15rem;
}

[data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav {
	border-radius: 0 0 0 0 !important;
}
@media only screen and (max-width: 47.9375rem) {
	[data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav {
		border-radius: 0 0 0 0 !important;
	}
}

[data-sidebar-style='overlay'][data-layout='vertical'] .nav-header {
	border-radius: 0;
}

[data-sidebar-style='overlay'][data-layout='vertical'] .menu-toggle .nav-header {
	border-radius: 0 0 0 0;
}

[data-sidebar-style='overlay'] .dlabnav {
	left: -100%;
	transition: all 0.5s;
	/* @include respond ('phone-land'){
			.metismenu{
				&>li{
					&>a{
						font-size: 0.875rem;
						padding: 0.75rem 0.875rem;
						i{
							font-size:1.125rem;
						}
						&:hover{
							color: #fff;
						}
					}
				}
				ul li a{
					padding-left:2.8rem;
				}
			}
		} */
}
[data-sidebar-style='overlay'] .dlabnav .metismenu > li {
	padding: 0 1rem;
}
[data-sidebar-style='overlay'] .dlabnav .metismenu > li > a {
	font-size: 0.938rem;
	padding: 0.7375rem 1rem;
	color: #7f7184;
	border-radius: 0.375rem;
	transition: all 0.5s;
}
[data-sidebar-style='overlay'] .dlabnav .metismenu > li > a i {
	height: auto;
	width: auto;
	line-height: 1;
}
[data-sidebar-style='overlay'] .dlabnav .metismenu > li:hover > a {
	color: var(--primary);
}
[data-sidebar-style='overlay'] .dlabnav .metismenu > li:hover > a i {
	color: var(--primary);
}
[data-sidebar-style='overlay'] .dlabnav .metismenu > li.mm-active > a {
	background: var(--primary);
	color: #fff;
}
[data-sidebar-style='overlay'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
@media only screen and (max-width: 35.9375rem) {
	[data-sidebar-style='overlay'] .dlabnav .metismenu > li {
		padding: 0rem 0.9375rem;
	}
}
[data-sidebar-style='overlay'] .dlabnav .metismenu ul a {
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
	position: relative;
	font-size: 0.9375rem;
	padding-left: 3.2rem;
}
[data-sidebar-style='overlay'] .dlabnav .metismenu ul a:before {
	left: 1.5625rem;
}
[direction='rtl'][data-sidebar-style='overlay'] .dlabnav {
	left: auto;
	right: -100%;
}

[data-sidebar-style='overlay'] .content-body {
	margin-left: 0;
}

[data-sidebar-style='overlay'] .nav-header {
	position: absolute;
}
[data-sidebar-style='overlay'] .nav-header .hamburger.is-active {
	left: 0;
}
[data-sidebar-style='overlay'] .nav-header .hamburger.is-active .line {
	background-color: var(--primary);
	opacity: 1;
}

[data-sidebar-style='overlay'] .menu-toggle .nav-header {
	position: absolute;
	left: auto;
}

[data-sidebar-style='overlay'] .menu-toggle .dlabnav {
	left: 0;
}
[direction='rtl'][data-sidebar-style='overlay'] .menu-toggle .dlabnav {
	left: auto;
	right: 0;
}

[data-sidebar-style='overlay'] .footer {
	padding-left: 0;
}
[data-sidebar-style='overlay'] .footer.footer-outer {
	width: calc(100% - 25.225rem);
}
[data-sidebar-style='overlay'] .footer.style-2 {
	width: calc(100% - 3.925rem);
}
[data-sidebar-style='overlay'] .footer.style-1 {
	width: calc(100% - 22.325rem);
	margin-right: 20.475rem;
}

[data-sidebar-style='overlay'][data-header-position='fixed'] .nav-header {
	position: fixed;
}

[data-sidebar-position='fixed'][data-header-position='fixed'] .nav-header {
	position: fixed;
}

[data-sidebar-position='fixed'][data-layout='vertical'] .nav-header {
	position: fixed;
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}

[data-sidebar-position='fixed'][data-layout='vertical'] .dlabnav {
	position: fixed;
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}
[data-sidebar-position='fixed'][data-layout='vertical'] .dlabnav .dlabnav-scroll {
	border-top-left-radius: 0rem;
	border-top-right-radius: 0rem;
}

[data-sidebar-position='fixed'][data-layout='vertical'] .menu-toggle .dlabnav {
	position: fixed;
}

[data-layout='vertical'] .nav-header {
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}

[data-layout='vertical'] .dlabnav {
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}

[data-sidebar-style='icon-hover'][data-layout='vertical'][data-container='wide-boxed'] .dlabnav,
[data-sidebar-style='icon-hover'][data-layout='vertical'][data-container='boxed'] .dlabnav,
[data-header-position='fixed'][data-sidebar-position='fixed'][data-sidebar-style='icon-hover'][data-layout='vertical'][data-container='wide-boxed']
	.dlabnav,
[data-header-position='fixed'][data-sidebar-position='fixed'][data-sidebar-style='icon-hover'][data-layout='vertical'][data-container='boxed']
	.dlabnav,
[data-sidebar-style='overlay'][data-layout='vertical'][data-container='wide-boxed'] .dlabnav,
[data-sidebar-style='overlay'][data-layout='vertical'][data-container='boxed'] .dlabnav,
[data-header-position='fixed'][data-sidebar-position='fixed'][data-sidebar-style='overlay'][data-layout='vertical'][data-container='wide-boxed']
	.dlabnav,
[data-header-position='fixed'][data-sidebar-position='fixed'][data-sidebar-style='overlay'][data-layout='vertical'][data-container='boxed']
	.dlabnav {
	position: absolute;
}

.sidebar-right-trigger {
	position: absolute;
	z-index: 9;
	top: 14.75rem;
	right: 100%;
	background-color: var(--primary);
	color: #fff;
	display: inline-block;
	height: 3rem;
	width: 3rem;
	text-align: center;
	font-size: 1.75rem;
	line-height: 3rem;
	border-radius: 0.3125rem 0 0 0.3125rem;
}
[data-theme-version='dark'] .sidebar-right-trigger {
	color: #fff;
}
@media only screen and (max-width: 64rem) {
	.sidebar-right-trigger {
		display: none;
	}
}
.sidebar-right-trigger:hover {
	color: #fff;
}

.sidebar-right {
	right: -50rem;
	position: fixed;
	top: 0;
	width: 50rem;
	background-color: #fff;
	margin-top: 3.5rem;
	transition: all 0.5s ease-in-out;
	border-radius: 0.375rem;
	z-index: 9999;
}
.sidebar-right .note-text {
	position: absolute;
	bottom: 0;
	left: 0;
	padding: 20px;
	opacity: 0.7;
	font-size: 12px;
}
.sidebar-right .bg-label-pattern {
	background: transparent;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
	background-size: 130%;
}
.sidebar-right .bootstrap-select {
	height: 3rem;
	border-radius: 0.375rem;
}
.sidebar-right .bootstrap-select .btn {
	padding: 0.75rem 0.9375rem;
	font-size: 0.9375rem;
	border-color: #d1d1d1;
	border-radius: 0.375rem;
}
[direction='rtl'] .sidebar-right .slimScrollDiv {
	overflow: visible !important;
}
.sidebar-right .sidebar-close-trigger {
	position: absolute;
	z-index: 2;
	font-size: 1.75rem;
	top: 0;
	right: -3rem;
	height: 3rem;
	width: 3rem;
	line-height: 3rem;
	text-align: center;
	background: black;
	color: #fff;
}
.sidebar-right.show {
	right: 5.25rem;
	box-shadow: 0rem 0rem 3.125rem rgba(0, 0, 0, 0.2);
	z-index: 9999;
}
.sidebar-right.show .bg-overlay {
	position: fixed;
	width: 100%;
	cursor: pointer;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.2);
}
.sidebar-right .card-tabs .nav-tabs {
	justify-content: space-between;
	position: sticky;
	top: 0;
	width: 100%;
	background-color: #fff;
	z-index: 2;
	border-bottom: 4px solid var(--rgba-primary-1);
}
.sidebar-right .card-tabs .nav-tabs .nav-item {
	margin-bottom: 0;
	flex: 1 1;
}
.sidebar-right .card-tabs .nav-tabs .nav-item .nav-link {
	border: 0;
	font-size: 1.125rem;
	position: relative;
	text-align: center;
	background-color: #fff;
	border-radius: 0;
	margin: 0;
}
.sidebar-right .card-tabs .nav-tabs .nav-item .nav-link.active {
	background: var(--rgba-primary-1);
	color: #000;
}
[data-theme-version='dark'] .sidebar-right .card-tabs .nav-tabs .nav-item .nav-link.active {
	border-right: none;
	border-left: none;
	border-top: none;
}
.sidebar-right .sidebar-right-inner > h4,
.sidebar-right .sidebar-right-inner > .h4 {
	padding: 0.625rem 1.25rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #000;
	background: #fff;
	margin: 0rem 0rem 0rem 0rem;
}
.sidebar-right .tab-content {
	padding: 1.25rem 1.25rem 0;
	min-height: 480px;
	background: #fff;
}
.sidebar-right .tab-content .tab-pane .admin-settings .row > div {
	margin-bottom: 1.25rem;
}
.sidebar-right .tab-content .tab-pane .admin-settings p {
	color: #353535;
	font-weight: 500;
	margin-bottom: 0.5rem;
	font-size: 1rem;
}
.sidebar-right .tab-content .tab-pane .admin-settings input[type='radio'] {
	display: none;
}
.sidebar-right .tab-content .tab-pane .admin-settings input[type='radio'] + label {
	display: inline-block;
	width: 2.1875rem;
	height: 2.1875rem;
	cursor: pointer;
	transition: all 0.1s ease;
	border-radius: 0.25rem;
	margin-right: 0.3125rem;
	margin-bottom: 0.1875rem;
}
.sidebar-right .tab-content .tab-pane .admin-settings input[type='radio']:checked + label {
	position: relative;
}
.sidebar-right .tab-content .tab-pane .admin-settings input[type='radio']:checked + label::after {
	height: 2.0625rem;
	width: 2.0625rem;
	left: -0.25rem;
	top: -0.25rem;
	content: '';
	position: absolute;
	background-color: inherit;
	border-radius: 0.375rem;
	opacity: 0.4;
}
.sidebar-right #nav_header_color_1 + label,
.sidebar-right #header_color_1 + label,
.sidebar-right #sidebar_color_1 + label,
.sidebar-right #primary_color_1 + label {
	background-color: #fff;
}
.sidebar-right #nav_header_color_2 + label,
.sidebar-right #header_color_2 + label,
.sidebar-right #sidebar_color_2 + label,
.sidebar-right #primary_color_2 + label {
	background-color: #4d44b5;
}
.sidebar-right #nav_header_color_3 + label,
.sidebar-right #header_color_3 + label,
.sidebar-right #sidebar_color_3 + label,
.sidebar-right #primary_color_3 + label {
	background-color: #056468;
}
.sidebar-right #nav_header_color_4 + label,
.sidebar-right #header_color_4 + label,
.sidebar-right #sidebar_color_4 + label,
.sidebar-right #primary_color_4 + label {
	background-color: #4d06a5;
}
.sidebar-right #nav_header_color_5 + label,
.sidebar-right #header_color_5 + label,
.sidebar-right #sidebar_color_5 + label,
.sidebar-right #primary_color_5 + label {
	background-color: #dc3545;
}
.sidebar-right #nav_header_color_6 + label,
.sidebar-right #header_color_6 + label,
.sidebar-right #sidebar_color_6 + label,
.sidebar-right #primary_color_6 + label {
	background-color: #fd7e14;
}
.sidebar-right #nav_header_color_7 + label,
.sidebar-right #header_color_7 + label,
.sidebar-right #sidebar_color_7 + label,
.sidebar-right #primary_color_7 + label {
	background-color: #5155c3;
}
.sidebar-right #nav_header_color_8 + label,
.sidebar-right #header_color_8 + label,
.sidebar-right #sidebar_color_8 + label,
.sidebar-right #primary_color_8 + label {
	background-color: #854df3;
}
.sidebar-right #nav_header_color_9 + label,
.sidebar-right #header_color_9 + label,
.sidebar-right #sidebar_color_9 + label,
.sidebar-right #primary_color_9 + label {
	background-color: #20c997;
}
.sidebar-right #nav_header_color_10 + label,
.sidebar-right #header_color_10 + label,
.sidebar-right #sidebar_color_10 + label,
.sidebar-right #primary_color_10 + label {
	background-color: #17a2b8;
}
.sidebar-right #nav_header_color_11 + label,
.sidebar-right #header_color_11 + label,
.sidebar-right #sidebar_color_11 + label,
.sidebar-right #primary_color_11 + label {
	background-color: #94618e;
}
.sidebar-right #nav_header_color_12 + label,
.sidebar-right #header_color_12 + label,
.sidebar-right #sidebar_color_12 + label,
.sidebar-right #primary_color_12 + label {
	background-color: #00273a;
}
.sidebar-right #nav_header_color_13 + label,
.sidebar-right #header_color_13 + label,
.sidebar-right #sidebar_color_13 + label,
.sidebar-right #primary_color_13 + label {
	background-color: #432d29;
}
.sidebar-right #nav_header_color_14 + label,
.sidebar-right #header_color_14 + label,
.sidebar-right #sidebar_color_14 + label,
.sidebar-right #primary_color_14 + label {
	background-color: #4885ed;
}
.sidebar-right #nav_header_color_15 + label,
.sidebar-right #header_color_15 + label,
.sidebar-right #sidebar_color_15 + label,
.sidebar-right #primary_color_15 + label {
	background-color: #4cb32b;
}
.sidebar-right #nav_header_color_1 + label,
.sidebar-right #header_color_1 + label,
.sidebar-right #sidebar_color_1 + label,
.sidebar-right #primary_color_1 + label {
	border: 0.0625rem solid #c4c4c4;
}
.sidebar-right.style-1 {
	height: 100vh;
	width: 15.625rem;
	margin-top: 0;
	right: -15.625rem;
}
.sidebar-right.style-1 .sidebar-right-inner {
	background: #fff;
}
.sidebar-right.style-1 .sidebar-right-trigger {
	top: 12.4rem;
}
.sidebar-right.style-1.show {
	right: 0;
}
.sidebar-right.style-1.show .sidebar-right-trigger {
	display: block;
}

.nice-select.wide {
	line-height: 2.8125rem;
}

@keyframes bounce {
	0% {
		transform: translateX(-8%);
		-webkit-transform: translateX(-8%);
	}
	50% {
		transform: translateX(8%);
		-webkit-transform: translateX(8%);
	}
	100% {
		transform: translateX(-8%);
		-webkit-transform: translateX(-8%);
	}
}

@media only screen and (max-width: 87.5rem) {
	.nice-select.wide {
		line-height: 2rem;
	}
}

.nav-user {
	background: var(--primary);
	margin-bottom: 0.625rem;
	padding: 1.25rem 1.5625rem 0.9375rem;
}
@media only screen and (min-width: 48rem) and (max-width: 74.9375rem) {
	.nav-user {
		padding: 1.25rem 0.9375rem 0.9375rem;
	}
}
.nav-user img {
	width: 2.1875rem;
	height: 2.1875rem;
}
@media only screen and (min-width: 48rem) and (max-width: 74.9375rem) {
	.nav-user img {
		width: 2.1875rem;
		height: 2.1875rem;
		margin-bottom: 0.625rem;
	}
}
.nav-user h5,
.nav-user .h5 {
	margin-left: 0.625rem;
	margin-bottom: 0.1875rem;
	color: #fff;
}
@media only screen and (min-width: 48rem) and (max-width: 74.9375rem) {
	.nav-user h5,
	.nav-user .h5 {
		display: none;
	}
}
[data-sibebarbg='color_2'] .nav-user h5,
[data-sibebarbg='color_2'] .nav-user .h5 {
	color: #fff;
}
.nav-user p {
	margin-left: 0.625rem;
	margin-bottom: 0.5rem;
	color: #afcff7;
}
@media only screen and (min-width: 48rem) and (max-width: 74.9375rem) {
	.nav-user p {
		display: none;
	}
}
@media only screen and (min-width: 48rem) and (max-width: 74.9375rem) {
	.nav-user i {
		margin-top: 0.9375rem;
		display: block;
	}
}

.menu-toggle .nav-user {
	padding: 1.25rem 0.9375rem 0.9375rem;
}
.menu-toggle .nav-user img {
	width: 2.1875rem;
	height: 2.1875rem;
	margin-bottom: 0.625rem;
}
.menu-toggle .nav-user h5,
.menu-toggle .nav-user .h5,
.menu-toggle .nav-user p {
	display: none;
}
.menu-toggle .nav-user i {
	margin-top: 0.9375rem;
	display: block;
}
.menu-toggle .nav-user .dropdown-menu {
	left: 2.8125rem !important;
	top: 1.375rem !important;
}

.chatbox {
	width: 21.25rem;
	height: 100vh;
	position: fixed;
	right: -31.25rem;
	top: 0;
	z-index: 1004;
	background: #fff;
	box-shadow: 0rem 0rem 1.875rem 0rem rgba(82, 63, 105, 0.15);
	transition: all 0.8s;
}
[data-theme-version='dark'] .chatbox {
	background: #272738;
}
.chatbox .chatbox-close {
	position: absolute;
	transition: all 0.2s;
	width: 0;
	height: 100%;
	right: 21.25rem;
	background: #000;
	z-index: 1;
	opacity: 0.1;
	cursor: pointer;
}
.chatbox .card-fotter {
	padding: 0.75rem 1rem;
}
.chatbox .card-body {
	padding: 1rem;
}
.chatbox.active {
	right: 0;
}
.chatbox.active .chatbox-close {
	width: 100vw;
}
.chatbox .type_msg {
	padding-top: 0.625rem;
}
.chatbox .type_msg .input-group {
	align-items: center;
}
.chatbox .nav {
	padding: 1rem 1rem 0 1rem;
	background: var(--rgba-primary-1);
	border: 0;
	justify-content: space-between;
}
.chatbox .nav .nav-link {
	color: var(--primary);
	opacity: 0.7;
	text-transform: uppercase;
}
.chatbox .nav .nav-link:hover,
.chatbox .nav .nav-link.active {
	background: transparent;
	color: var(--primary);
	opacity: 1;
	border-color: var(--primary);
}
.chatbox .img_cont {
	width: 2.5rem;
	border-radius: 2.5rem;
	margin-right: 0.625rem;
	position: relative;
	height: 2.5rem;
	background: #eee;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 600;
	font-size: 0.875rem;
	min-width: 2.5rem;
	min-height: 2.5rem;
}
.chatbox .img_cont .icon {
	color: #fff;
}
.chatbox .img_cont.primary {
	background: var(--rgba-primary-1);
	color: var(--primary);
}
[data-theme-version='dark'] .chatbox .img_cont.primary {
	background: var(--rgba-primary-1);
}
.chatbox .img_cont.warning {
	background: #fffaee;
	color: #fcc43e;
}
[data-theme-version='dark'] .chatbox .img_cont.warning {
	background: rgba(252, 196, 62, 0.1);
}
.chatbox .img_cont.success {
	background: #ddfaea;
	color: #1eba62;
}
[data-theme-version='dark'] .chatbox .img_cont.success {
	background: rgba(30, 186, 98, 0.1);
}
.chatbox .img_cont.info {
	background: #94fff9;
	color: #00ada3;
}
[data-theme-version='dark'] .chatbox .img_cont.info {
	background: rgba(0, 173, 163, 0.1);
}
.chatbox .img_cont img {
	width: 100%;
}
.chatbox .img_cont .online_icon {
	background: #1eba62;
	position: absolute;
	width: 0.75rem;
	height: 0.75rem;
	border-radius: 0.9375rem;
	right: -0.0625rem;
	bottom: 0rem;
	border: 0.125rem solid #fff;
}
.chatbox .img_cont .online_icon.offline {
	background: #fd5353;
}
.chatbox .card {
	box-shadow: none;
}
.chatbox .search {
	height: 2.5rem;
}
.chatbox .user_info span {
	font-size: 0.9375rem;
	color: #000;
	display: block;
	font-weight: 500;
	line-height: 1;
	margin-bottom: 0.3125rem;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	display: block;
	max-width: 10.625rem;
}
[data-theme-version='dark'] .chatbox .user_info span {
	color: #fff;
}
.chatbox .user_info p {
	font-size: 0.8125rem;
	margin-bottom: 0;
	line-height: 1;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
	display: block;
	max-width: 10.625rem;
}
.chatbox .contacts li {
	padding: 0.4375rem 1rem;
	border-bottom: 0.0625rem solid #eee;
	cursor: pointer;
}
[data-theme-version='dark'] .chatbox .contacts li {
	border-color: rgba(255, 255, 255, 0.1);
}
.chatbox .contacts li > div {
	display: flex;
	align-items: center;
}
.chatbox .contacts li:hover {
	background: #f4f7ff;
}
[data-theme-version='dark'] .chatbox .contacts li:hover {
	background-color: #202020;
}
.chatbox .contacts .name-first-letter {
	background: #e6ebee;
	padding: 0.25rem 1rem;
	font-weight: 700;
	color: #000;
	position: sticky;
	top: 0;
	z-index: 1;
}
[data-theme-version='dark'] .chatbox .contacts .name-first-letter {
	color: #fff;
	background: #202020;
}
.chatbox .msg_card_body {
	height: calc(100vh - 195px);
}
.chatbox .contacts_body {
	height: calc(100vh - 120px);
}
.chatbox .card-header {
	background: #f4f7ff;
	padding: 0.9375rem 1.25rem;
	justify-content: center;
}
.chatbox .card-header h6,
.chatbox .card-header .h6 {
	font-size: 0.9375rem;
}
.chatbox .card-header p {
	line-height: 1.2;
	font-size: 0.75rem;
	color: #a098ae;
}
.chatbox .chat-list-header {
	justify-content: space-between;
	background: #fff;
}
[data-theme-version='dark'] .chatbox .chat-list-header {
	background: #272738;
}
.chatbox .chat-list-header a {
	text-align: center;
	width: 1.875rem;
	height: 1.875rem;
	background: #e6ebee;
	border-radius: 0.375rem;
	line-height: 1.675rem;
	display: block;
}
[data-theme-version='dark'] .chatbox .chat-list-header a {
	background: var(--rgba-primary-1);
}
[data-theme-version='dark'] .chatbox .chat-list-header a svg g [fill] {
	fill: #fff;
}
.chatbox .img_cont_msg {
	width: 1.875rem;
	height: 1.875rem;
	display: block;
	max-width: 1.875rem;
	min-width: 1.875rem;
}
.chatbox .img_cont_msg img {
	width: 100%;
}
.chatbox .msg_cotainer {
	background: var(--primary);
	margin-left: 0.625rem;
	border-radius: 0 0.375rem 0.375rem 0.375rem;
	padding: 0.625rem 0.9375rem;
	color: #fff;
	position: relative;
}
.chatbox .msg_cotainer .msg_time {
	display: block;
	font-size: 0.6875rem;
	color: #fff;
	margin-top: 0.3125rem;
	opacity: 0.5;
}
.chatbox .msg_cotainer:after {
	content: '';
	position: absolute;
	left: -0.625rem;
	border-right: 0.625rem solid var(--primary);
	border-bottom: 0.625rem solid transparent;
	border-top: 0rem solid;
	top: 0;
}
.chatbox .msg_cotainer_send {
	background: #e6ebee;
	padding: 0.625rem 0.9375rem;
	border-radius: 0.375rem 0rem 0.375rem 0.375rem;
	margin-right: 0.625rem;
	color: #222;
	position: relative;
	text-align: right;
}
[data-theme-version='dark'] .chatbox .msg_cotainer_send {
	background: #202020;
	color: #fff;
}
.chatbox .msg_cotainer_send .msg_time_send {
	display: block;
	font-size: 0.6875rem;
	text-align: right;
	margin-top: 0.3125rem;
	opacity: 0.6;
}
.chatbox .msg_cotainer_send:after {
	content: '';
	position: absolute;
	right: -0.625rem;
	border-left: 0.625rem solid #e6ebee;
	border-bottom: 0.625rem solid transparent;
	border-top: 0rem solid;
	top: 0;
}
[data-theme-version='dark'] .chatbox .msg_cotainer_send:after {
	border-left: 0.625rem solid #202020;
}
.chatbox .type_msg .form-control {
	padding: 0.625rem 14px;
	height: 3.125rem;
	border: 0;
	resize: none;
	line-height: unset;
}
.chatbox .type_msg .form-control:focus {
	z-index: 0;
}
.chatbox .type_msg .btn {
	font-size: 1.125rem;
	border-radius: 2.375rem !important;
	width: 2.375rem;
	height: 2.375rem;
	padding: 0;
	margin-top: -22px;
	line-height: 1px;
}
.chatbox .video_cam {
	margin-left: 0.9375rem;
}
.chatbox .video_cam span {
	width: 2.1875rem;
	height: 2.1875rem;
	background: #10ca93;
	text-align: center;
	line-height: 2.1875rem;
	border-radius: 2.1875rem;
	color: #fff;
	margin-right: 0.3125rem;
	align-self: center;
	font-size: 1rem;
	padding: 0 0.1875rem;
	display: inline-block;
}
.chatbox .note_card .contacts li {
	padding: 0.75rem 1rem;
}

@media only screen and (max-width: 36rem) {
	.chatbox {
		width: 17.5rem;
	}
	.chatbox .chatbox-close {
		right: 17.5rem;
	}
}

.bd-highlight a.sharp {
	margin-bottom: 0.5rem;
	display: inline-block;
}

.dlab-demo-panel {
	right: -23.75rem;
	position: fixed;
	top: 0;
	width: 23.75rem;
	background-color: #fff;
	height: 100vh;
	transition: all 0.5s ease-in-out;
	z-index: 9999;
}
.dlab-demo-panel .dlab-demo-trigger {
	position: absolute;
	z-index: 9;
	top: 21.75rem;
	right: 100%;
	background-color: #627eea;
	color: #fff;
	display: inline-block;
	height: 3rem;
	width: 3rem;
	text-align: center;
	font-size: 1.75rem;
	line-height: 3rem;
	border-radius: 0.3125rem 0 0 0.3125rem;
	box-shadow: -0.3125rem 0.1875rem 0.3125rem 0rem rgba(119, 119, 119, 0.15);
}
@media only screen and (max-width: 63.9375rem) {
	.dlab-demo-panel .dlab-demo-trigger {
		display: none;
	}
}
.dlab-demo-panel .dlab-demo-close {
	height: 1.875rem;
	color: #fff;
	width: 1.875rem;
	border-radius: 0.375rem;
	background: rgba(0, 0, 0, 0.5);
	line-height: 1.875rem;
	text-align: center;
}
.dlab-demo-panel.show {
	right: 0;
	box-shadow: 0rem 0rem 3.125rem rgba(0, 0, 0, 0.2);
	z-index: 99999;
	overflow: hidden;
}
.dlab-demo-panel.show .sidebar-right-trigger {
	display: none;
}
.dlab-demo-panel.show .bg-close {
	position: fixed;
	z-index: -2;
	cursor: pointer;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.15);
}
.dlab-demo-panel .dlab-demo-inner {
	padding: 1.875rem 1.875rem;
	background: #fff;
}
.dlab-demo-panel .dlab-demo-content {
	height: calc(100vh - 210px);
}
.dlab-demo-panel .dlab-demo-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1.25rem;
}
.dlab-demo-panel .dlab-demo-header h4,
.dlab-demo-panel .dlab-demo-header .h4 {
	margin-bottom: 0;
	color: #000;
}
.dlab-demo-panel .dlab-demo-bx {
	height: 12.5rem;
	overflow: hidden;
	border: 0.3125rem solid #efefef;
	box-shadow: 0rem 0rem 0.3125rem rgba(0, 0, 0, 0.1);
	margin-bottom: 0.625rem;
	border-radius: 0.375rem;
}
.dlab-demo-panel .dlab-demo-bx.demo-active {
	border-color: #fb7d5b;
}
.dlab-demo-panel .dlab-demo-bx.demo-active .overlay-layer {
	opacity: 1;
}
.dlab-demo-panel .overlay-bx {
	position: relative;
}
.dlab-demo-panel .overlay-bx .overlay-layer {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.1);
	transition: all 0.3s ease;
	opacity: 0;
}
.dlab-demo-panel .overlay-bx:hover .overlay-layer {
	transition: all 0.3s ease;
	opacity: 1;
}

:root {
	--right-space: 23.75rem;
}

.wallet-open .header .page-titles,
.wallet-open .header .header-content {
	padding-right: 1.875rem;
	transition: all 0.5s;
}
@media only screen and (max-width: 47.9375rem) {
	.wallet-open .header .page-titles,
	.wallet-open .header .header-content {
		padding-right: 1.4rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.wallet-open .header .page-titles,
	.wallet-open .header .header-content {
		padding-right: 1.1rem;
	}
}

.wallet-open .content-body {
	padding-right: 0;
	transition: all 0.5s;
}

.wallet-open .wallet-bar {
	right: -26.25rem;
}

.wallet-open.active .header .page-titles,
.wallet-open.active .header .header-content {
	padding-right: var(--right-space);
}
@media only screen and (max-width: 87.5rem) {
	.wallet-open.active .header .page-titles,
	.wallet-open.active .header .header-content {
		padding-right: 4.775rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.wallet-open.active .header .page-titles,
	.wallet-open.active .header .header-content {
		padding-right: 12px;
	}
}

.wallet-open.active .content-body {
	padding-right: calc(var(--right-space) - 1.75rem);
	transition: all 0.5s;
}
@media only screen and (max-width: 87.5rem) {
	.wallet-open.active .content-body {
		padding-right: 0;
	}
}

.wallet-open.active .wallet-bar {
	right: 0rem;
}

.wallet-open.active .wallet-bar-close {
	position: fixed;
	width: 100%;
	cursor: pointer;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.2);
	display: block;
	z-index: 3;
}
/* @media only screen and (max-width: 87.5rem) {
    .wallet-open.active .wallet-bar-close {
      display: block;
      z-index: 3; } }
  @media only screen and (max-width: 35.9375rem) {
    .wallet-open.active .wallet-bar-close {
      z-index: 3; } } */

.wallet-bar {
	position: fixed;
	box-sizing: content-box;
	width: 22rem;
	padding: 2.375rem 15px;
	padding-top: 0.375rem;
	padding-bottom: 0;
	transition: all 0.5s;
	top: 0px;
	z-index: 999;
	height: 100%;
	scrollbar-width: none;
	box-sizing: border-box;
}
@media only screen and (max-width: 87.5rem) {
	.wallet-bar {
		width: 23rem;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.wallet-bar {
		background: rgba(0, 0, 0, 0.2);
		backdrop-filter: blur(5px);
		box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.25);
		height: 100vh;
		overflow-y: scroll;
	}
}
.wallet-bar .closed-icon {
	height: 25px;
	width: 25px;
	color: #303972;
	font-size: 20px;
	display: block;
	margin-bottom: 17px;
	cursor: pointer;
	display: none;
}
@media only screen and (max-width: 35.9375rem) {
	.wallet-bar .closed-icon {
		display: block;
	}
}

:root {
	--nav-headbg: #fff;
	--sidebar-bg: #fff;
	--headerbg: #e6ebee;
}

[data-nav-headerbg='color_2'][data-theme-version='dark'],
[data-nav-headerbg='color_2'] {
	--nav-headbg: #4d44b5;
}
[data-nav-headerbg='color_2'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,
[data-nav-headerbg='color_2'] .nav-header .brand-logo .logo-abbr path {
	fill: #fff;
}
[data-nav-headerbg='color_2'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,
[data-nav-headerbg='color_2'] .nav-header .brand-logo .brand-title svg path {
	fill: #fff;
}
[data-nav-headerbg='color_2'][data-theme-version='dark'] .nav-header .hamburger .line,
[data-nav-headerbg='color_2'] .nav-header .hamburger .line {
	background: #fff;
}

[data-nav-headerbg='color_3'][data-theme-version='dark'],
[data-nav-headerbg='color_3'] {
	--nav-headbg: #056468;
}
[data-nav-headerbg='color_3'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,
[data-nav-headerbg='color_3'] .nav-header .brand-logo .logo-abbr path {
	fill: #fff;
}
[data-nav-headerbg='color_3'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,
[data-nav-headerbg='color_3'] .nav-header .brand-logo .brand-title svg path {
	fill: #fff;
}
[data-nav-headerbg='color_3'][data-theme-version='dark'] .nav-header .hamburger .line,
[data-nav-headerbg='color_3'] .nav-header .hamburger .line {
	background: #fff;
}

[data-nav-headerbg='color_4'][data-theme-version='dark'],
[data-nav-headerbg='color_4'] {
	--nav-headbg: #4d06a5;
}
[data-nav-headerbg='color_4'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,
[data-nav-headerbg='color_4'] .nav-header .brand-logo .logo-abbr path {
	fill: #fff;
}
[data-nav-headerbg='color_4'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,
[data-nav-headerbg='color_4'] .nav-header .brand-logo .brand-title svg path {
	fill: #fff;
}
[data-nav-headerbg='color_4'][data-theme-version='dark'] .nav-header .hamburger .line,
[data-nav-headerbg='color_4'] .nav-header .hamburger .line {
	background: #fff;
}

[data-nav-headerbg='color_5'][data-theme-version='dark'],
[data-nav-headerbg='color_5'] {
	--nav-headbg: #dc3545;
}
[data-nav-headerbg='color_5'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,
[data-nav-headerbg='color_5'] .nav-header .brand-logo .logo-abbr path {
	fill: #fff;
}
[data-nav-headerbg='color_5'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,
[data-nav-headerbg='color_5'] .nav-header .brand-logo .brand-title svg path {
	fill: #fff;
}
[data-nav-headerbg='color_5'][data-theme-version='dark'] .nav-header .hamburger .line,
[data-nav-headerbg='color_5'] .nav-header .hamburger .line {
	background: #fff;
}

[data-nav-headerbg='color_6'][data-theme-version='dark'],
[data-nav-headerbg='color_6'] {
	--nav-headbg: #fd7e14;
}
[data-nav-headerbg='color_6'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,
[data-nav-headerbg='color_6'] .nav-header .brand-logo .logo-abbr path {
	fill: #fff;
}
[data-nav-headerbg='color_6'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,
[data-nav-headerbg='color_6'] .nav-header .brand-logo .brand-title svg path {
	fill: #fff;
}
[data-nav-headerbg='color_6'][data-theme-version='dark'] .nav-header .hamburger .line,
[data-nav-headerbg='color_6'] .nav-header .hamburger .line {
	background: #fff;
}

[data-nav-headerbg='color_7'][data-theme-version='dark'],
[data-nav-headerbg='color_7'] {
	--nav-headbg: #5155c3;
}
[data-nav-headerbg='color_7'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,
[data-nav-headerbg='color_7'] .nav-header .brand-logo .logo-abbr path {
	fill: #fff;
}
[data-nav-headerbg='color_7'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,
[data-nav-headerbg='color_7'] .nav-header .brand-logo .brand-title svg path {
	fill: #fff;
}
[data-nav-headerbg='color_7'][data-theme-version='dark'] .nav-header .hamburger .line,
[data-nav-headerbg='color_7'] .nav-header .hamburger .line {
	background: #fff;
}

[data-nav-headerbg='color_8'][data-theme-version='dark'],
[data-nav-headerbg='color_8'] {
	--nav-headbg: #854df3;
}
[data-nav-headerbg='color_8'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,
[data-nav-headerbg='color_8'] .nav-header .brand-logo .logo-abbr path {
	fill: #fff;
}
[data-nav-headerbg='color_8'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,
[data-nav-headerbg='color_8'] .nav-header .brand-logo .brand-title svg path {
	fill: #fff;
}
[data-nav-headerbg='color_8'][data-theme-version='dark'] .nav-header .hamburger .line,
[data-nav-headerbg='color_8'] .nav-header .hamburger .line {
	background: #fff;
}

[data-nav-headerbg='color_9'][data-theme-version='dark'],
[data-nav-headerbg='color_9'] {
	--nav-headbg: #20c997;
}
[data-nav-headerbg='color_9'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,
[data-nav-headerbg='color_9'] .nav-header .brand-logo .logo-abbr path {
	fill: #fff;
}
[data-nav-headerbg='color_9'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,
[data-nav-headerbg='color_9'] .nav-header .brand-logo .brand-title svg path {
	fill: #fff;
}
[data-nav-headerbg='color_9'][data-theme-version='dark'] .nav-header .hamburger .line,
[data-nav-headerbg='color_9'] .nav-header .hamburger .line {
	background: #fff;
}

[data-nav-headerbg='color_10'][data-theme-version='dark'],
[data-nav-headerbg='color_10'] {
	--nav-headbg: #17a2b8;
}
[data-nav-headerbg='color_10'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,
[data-nav-headerbg='color_10'] .nav-header .brand-logo .logo-abbr path {
	fill: #fff;
}
[data-nav-headerbg='color_10'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,
[data-nav-headerbg='color_10'] .nav-header .brand-logo .brand-title svg path {
	fill: #fff;
}
[data-nav-headerbg='color_10'][data-theme-version='dark'] .nav-header .hamburger .line,
[data-nav-headerbg='color_10'] .nav-header .hamburger .line {
	background: #fff;
}

[data-nav-headerbg='color_11'][data-theme-version='dark'],
[data-nav-headerbg='color_11'] {
	--nav-headbg: #94618e;
}
[data-nav-headerbg='color_11'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,
[data-nav-headerbg='color_11'] .nav-header .brand-logo .logo-abbr path {
	fill: #fff;
}
[data-nav-headerbg='color_11'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,
[data-nav-headerbg='color_11'] .nav-header .brand-logo .brand-title svg path {
	fill: #fff;
}
[data-nav-headerbg='color_11'][data-theme-version='dark'] .nav-header .hamburger .line,
[data-nav-headerbg='color_11'] .nav-header .hamburger .line {
	background: #fff;
}

[data-nav-headerbg='color_12'][data-theme-version='dark'],
[data-nav-headerbg='color_12'] {
	--nav-headbg: #00273a;
}
[data-nav-headerbg='color_12'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,
[data-nav-headerbg='color_12'] .nav-header .brand-logo .logo-abbr path {
	fill: #fff;
}
[data-nav-headerbg='color_12'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,
[data-nav-headerbg='color_12'] .nav-header .brand-logo .brand-title svg path {
	fill: #fff;
}
[data-nav-headerbg='color_12'][data-theme-version='dark'] .nav-header .hamburger .line,
[data-nav-headerbg='color_12'] .nav-header .hamburger .line {
	background: #fff;
}

[data-nav-headerbg='color_13'][data-theme-version='dark'],
[data-nav-headerbg='color_13'] {
	--nav-headbg: #432d29;
}
[data-nav-headerbg='color_13'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,
[data-nav-headerbg='color_13'] .nav-header .brand-logo .logo-abbr path {
	fill: #fff;
}
[data-nav-headerbg='color_13'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,
[data-nav-headerbg='color_13'] .nav-header .brand-logo .brand-title svg path {
	fill: #fff;
}
[data-nav-headerbg='color_13'][data-theme-version='dark'] .nav-header .hamburger .line,
[data-nav-headerbg='color_13'] .nav-header .hamburger .line {
	background: #fff;
}

[data-nav-headerbg='color_14'][data-theme-version='dark'],
[data-nav-headerbg='color_14'] {
	--nav-headbg: #4885ed;
}
[data-nav-headerbg='color_14'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,
[data-nav-headerbg='color_14'] .nav-header .brand-logo .logo-abbr path {
	fill: #fff;
}
[data-nav-headerbg='color_14'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,
[data-nav-headerbg='color_14'] .nav-header .brand-logo .brand-title svg path {
	fill: #fff;
}
[data-nav-headerbg='color_14'][data-theme-version='dark'] .nav-header .hamburger .line,
[data-nav-headerbg='color_14'] .nav-header .hamburger .line {
	background: #fff;
}

[data-nav-headerbg='color_15'][data-theme-version='dark'],
[data-nav-headerbg='color_15'] {
	--nav-headbg: #4cb32b;
}
[data-nav-headerbg='color_15'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,
[data-nav-headerbg='color_15'] .nav-header .brand-logo .logo-abbr path {
	fill: #fff;
}
[data-nav-headerbg='color_15'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,
[data-nav-headerbg='color_15'] .nav-header .brand-logo .brand-title svg path {
	fill: #fff;
}
[data-nav-headerbg='color_15'][data-theme-version='dark'] .nav-header .hamburger .line,
[data-nav-headerbg='color_15'] .nav-header .hamburger .line {
	background: #fff;
}

[data-sidebarbg='color_2'][data-theme-version='dark'],
[data-sidebarbg='color_2'] {
	--sidebar-bg: #4d44b5;
	/* &[data-sidebar-style="full"][data-layout="vertical"]{
				.dlabnav .metismenu > li.mm-active > a,
				.dlabnav .metismenu > li:hover > a{
						background:transparent;
				}	
			} */
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav,
[data-sidebarbg='color_2'] .dlabnav {
	border-color: #4d44b5;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu > li:after,
[data-sidebarbg='color_2'] .dlabnav .metismenu > li:after {
	background: #fff !important;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,
[data-sidebarbg='color_2'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #4d44b5 !important;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,
[data-sidebarbg='color_2'] .dlabnav .metismenu ul a:before {
	background: rgba(255, 255, 255, 0.5);
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .header-info2,
[data-sidebarbg='color_2'] .dlabnav .header-info2 {
	border-color: rgba(255, 255, 255, 0.2) !important;
}
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_2'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_2'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_2'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_2'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_2'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_2'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_2'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_2'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {
	background-color: #6e66c6;
}
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_2'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_2'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_2'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_2'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_2'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_2'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_2'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_2'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_2'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_2'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {
	background: rgba(255, 255, 255, 0.15) !important;
}
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	a:hover,
[data-sidebarbg='color_2'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {
	color: #fff;
}
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	> a
	> i,
[data-sidebarbg='color_2'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
	background: #554cbc !important;
	color: rgba(255, 255, 255, 0.7);
}
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_2'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_2'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
	box-shadow: none;
	background: transparent !important;
	color: #fff !important;
}
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a
	i,
[data-sidebarbg='color_2'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_2'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
	background: #6e66c6 !important;
	color: #fff !important;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu a,
[data-sidebarbg='color_2'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,
[data-sidebarbg='color_2'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_2'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_2'] .dlabnav .metismenu li ul a.mm-active {
	color: #fff !important;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu > li > a,
[data-sidebarbg='color_2'] .dlabnav .metismenu > li > a {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,
[data-sidebarbg='color_2'] .dlabnav .metismenu > li > a i {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_2'] .dlabnav .metismenu > li.mm-active > a {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #fff !important;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_2'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,
[data-sidebarbg='color_2'] .dlabnav .metismenu > li.mm-active > a:before {
	background: #fff !important;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,
[data-sidebarbg='color_2'] .dlabnav .metismenu .has-arrow:after {
	border-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .header-info2 span,
[data-sidebarbg='color_2'] .dlabnav .header-info2 span {
	color: #fff;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .sidebar-info,
[data-sidebarbg='color_2'] .dlabnav .sidebar-info {
	color: #fff;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .sidebar-info i,
[data-sidebarbg='color_2'] .dlabnav .sidebar-info i {
	color: #fff;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .plus-box,
[data-sidebarbg='color_2'] .plus-box {
	background-color: #6e66c6;
}
[data-sidebarbg='color_2'][data-theme-version='dark'] .copyright,
[data-sidebarbg='color_2'] .copyright {
	color: #fff;
}

[data-sidebarbg='color_3'][data-theme-version='dark'],
[data-sidebarbg='color_3'] {
	--sidebar-bg: #056468;
	/* &[data-sidebar-style="full"][data-layout="vertical"]{
				.dlabnav .metismenu > li.mm-active > a,
				.dlabnav .metismenu > li:hover > a{
						background:transparent;
				}	
			} */
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav,
[data-sidebarbg='color_3'] .dlabnav {
	border-color: #056468;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu > li:after,
[data-sidebarbg='color_3'] .dlabnav .metismenu > li:after {
	background: #fff !important;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,
[data-sidebarbg='color_3'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #056468 !important;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,
[data-sidebarbg='color_3'] .dlabnav .metismenu ul a:before {
	background: rgba(255, 255, 255, 0.5);
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .header-info2,
[data-sidebarbg='color_3'] .dlabnav .header-info2 {
	border-color: rgba(255, 255, 255, 0.2) !important;
}
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_3'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_3'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_3'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_3'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_3'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_3'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_3'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_3'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {
	background-color: #079399;
}
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_3'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_3'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_3'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_3'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_3'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_3'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_3'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_3'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_3'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_3'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {
	background: rgba(255, 255, 255, 0.15) !important;
}
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	a:hover,
[data-sidebarbg='color_3'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {
	color: #fff;
}
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	> a
	> i,
[data-sidebarbg='color_3'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
	background: #067277 !important;
	color: rgba(255, 255, 255, 0.7);
}
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_3'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_3'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
	box-shadow: none;
	background: transparent !important;
	color: #fff !important;
}
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a
	i,
[data-sidebarbg='color_3'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_3'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
	background: #079399 !important;
	color: #fff !important;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu a,
[data-sidebarbg='color_3'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,
[data-sidebarbg='color_3'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_3'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_3'] .dlabnav .metismenu li ul a.mm-active {
	color: #fff !important;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu > li > a,
[data-sidebarbg='color_3'] .dlabnav .metismenu > li > a {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,
[data-sidebarbg='color_3'] .dlabnav .metismenu > li > a i {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_3'] .dlabnav .metismenu > li.mm-active > a {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #fff !important;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_3'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,
[data-sidebarbg='color_3'] .dlabnav .metismenu > li.mm-active > a:before {
	background: #fff !important;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,
[data-sidebarbg='color_3'] .dlabnav .metismenu .has-arrow:after {
	border-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .header-info2 span,
[data-sidebarbg='color_3'] .dlabnav .header-info2 span {
	color: #fff;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .sidebar-info,
[data-sidebarbg='color_3'] .dlabnav .sidebar-info {
	color: #fff;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .sidebar-info i,
[data-sidebarbg='color_3'] .dlabnav .sidebar-info i {
	color: #fff;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .plus-box,
[data-sidebarbg='color_3'] .plus-box {
	background-color: #079399;
}
[data-sidebarbg='color_3'][data-theme-version='dark'] .copyright,
[data-sidebarbg='color_3'] .copyright {
	color: #fff;
}

[data-sidebarbg='color_4'][data-theme-version='dark'],
[data-sidebarbg='color_4'] {
	--sidebar-bg: #4d06a5;
	/* &[data-sidebar-style="full"][data-layout="vertical"]{
				.dlabnav .metismenu > li.mm-active > a,
				.dlabnav .metismenu > li:hover > a{
						background:transparent;
				}	
			} */
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav,
[data-sidebarbg='color_4'] .dlabnav {
	border-color: #4d06a5;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu > li:after,
[data-sidebarbg='color_4'] .dlabnav .metismenu > li:after {
	background: #fff !important;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,
[data-sidebarbg='color_4'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #4d06a5 !important;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,
[data-sidebarbg='color_4'] .dlabnav .metismenu ul a:before {
	background: rgba(255, 255, 255, 0.5);
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .header-info2,
[data-sidebarbg='color_4'] .dlabnav .header-info2 {
	border-color: rgba(255, 255, 255, 0.2) !important;
}
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_4'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_4'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_4'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_4'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_4'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_4'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_4'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_4'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {
	background-color: #6408d6;
}
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_4'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_4'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_4'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_4'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_4'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_4'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_4'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_4'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_4'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_4'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {
	background: rgba(255, 255, 255, 0.15) !important;
}
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	a:hover,
[data-sidebarbg='color_4'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {
	color: #fff;
}
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	> a
	> i,
[data-sidebarbg='color_4'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
	background: #5407b4 !important;
	color: rgba(255, 255, 255, 0.7);
}
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_4'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_4'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
	box-shadow: none;
	background: transparent !important;
	color: #fff !important;
}
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a
	i,
[data-sidebarbg='color_4'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_4'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
	background: #6408d6 !important;
	color: #fff !important;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu a,
[data-sidebarbg='color_4'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,
[data-sidebarbg='color_4'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_4'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_4'] .dlabnav .metismenu li ul a.mm-active {
	color: #fff !important;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu > li > a,
[data-sidebarbg='color_4'] .dlabnav .metismenu > li > a {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,
[data-sidebarbg='color_4'] .dlabnav .metismenu > li > a i {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_4'] .dlabnav .metismenu > li.mm-active > a {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #fff !important;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_4'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,
[data-sidebarbg='color_4'] .dlabnav .metismenu > li.mm-active > a:before {
	background: #fff !important;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,
[data-sidebarbg='color_4'] .dlabnav .metismenu .has-arrow:after {
	border-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .header-info2 span,
[data-sidebarbg='color_4'] .dlabnav .header-info2 span {
	color: #fff;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .sidebar-info,
[data-sidebarbg='color_4'] .dlabnav .sidebar-info {
	color: #fff;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .sidebar-info i,
[data-sidebarbg='color_4'] .dlabnav .sidebar-info i {
	color: #fff;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .plus-box,
[data-sidebarbg='color_4'] .plus-box {
	background-color: #6408d6;
}
[data-sidebarbg='color_4'][data-theme-version='dark'] .copyright,
[data-sidebarbg='color_4'] .copyright {
	color: #fff;
}

[data-sidebarbg='color_5'][data-theme-version='dark'],
[data-sidebarbg='color_5'] {
	--sidebar-bg: #dc3545;
	/* &[data-sidebar-style="full"][data-layout="vertical"]{
				.dlabnav .metismenu > li.mm-active > a,
				.dlabnav .metismenu > li:hover > a{
						background:transparent;
				}	
			} */
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav,
[data-sidebarbg='color_5'] .dlabnav {
	border-color: #dc3545;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu > li:after,
[data-sidebarbg='color_5'] .dlabnav .metismenu > li:after {
	background: #fff !important;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,
[data-sidebarbg='color_5'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #dc3545 !important;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,
[data-sidebarbg='color_5'] .dlabnav .metismenu ul a:before {
	background: rgba(255, 255, 255, 0.5);
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .header-info2,
[data-sidebarbg='color_5'] .dlabnav .header-info2 {
	border-color: rgba(255, 255, 255, 0.2) !important;
}
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_5'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_5'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_5'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_5'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_5'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_5'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_5'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_5'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {
	background-color: #e4606d;
}
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_5'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_5'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_5'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_5'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_5'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_5'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_5'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_5'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_5'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_5'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {
	background: rgba(255, 255, 255, 0.15) !important;
}
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	a:hover,
[data-sidebarbg='color_5'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {
	color: #fff;
}
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	> a
	> i,
[data-sidebarbg='color_5'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
	background: #de4251 !important;
	color: rgba(255, 255, 255, 0.7);
}
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_5'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_5'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
	box-shadow: none;
	background: transparent !important;
	color: #fff !important;
}
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a
	i,
[data-sidebarbg='color_5'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_5'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
	background: #e4606d !important;
	color: #fff !important;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu a,
[data-sidebarbg='color_5'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,
[data-sidebarbg='color_5'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_5'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_5'] .dlabnav .metismenu li ul a.mm-active {
	color: #fff !important;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu > li > a,
[data-sidebarbg='color_5'] .dlabnav .metismenu > li > a {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,
[data-sidebarbg='color_5'] .dlabnav .metismenu > li > a i {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_5'] .dlabnav .metismenu > li.mm-active > a {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #fff !important;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_5'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,
[data-sidebarbg='color_5'] .dlabnav .metismenu > li.mm-active > a:before {
	background: #fff !important;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,
[data-sidebarbg='color_5'] .dlabnav .metismenu .has-arrow:after {
	border-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .header-info2 span,
[data-sidebarbg='color_5'] .dlabnav .header-info2 span {
	color: #fff;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .sidebar-info,
[data-sidebarbg='color_5'] .dlabnav .sidebar-info {
	color: #fff;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .sidebar-info i,
[data-sidebarbg='color_5'] .dlabnav .sidebar-info i {
	color: #fff;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .plus-box,
[data-sidebarbg='color_5'] .plus-box {
	background-color: #e4606d;
}
[data-sidebarbg='color_5'][data-theme-version='dark'] .copyright,
[data-sidebarbg='color_5'] .copyright {
	color: #fff;
}

[data-sidebarbg='color_6'][data-theme-version='dark'],
[data-sidebarbg='color_6'] {
	--sidebar-bg: #fd7e14;
	/* &[data-sidebar-style="full"][data-layout="vertical"]{
				.dlabnav .metismenu > li.mm-active > a,
				.dlabnav .metismenu > li:hover > a{
						background:transparent;
				}	
			} */
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav,
[data-sidebarbg='color_6'] .dlabnav {
	border-color: #fd7e14;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu > li:after,
[data-sidebarbg='color_6'] .dlabnav .metismenu > li:after {
	background: #fff !important;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,
[data-sidebarbg='color_6'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #fd7e14 !important;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,
[data-sidebarbg='color_6'] .dlabnav .metismenu ul a:before {
	background: rgba(255, 255, 255, 0.5);
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .header-info2,
[data-sidebarbg='color_6'] .dlabnav .header-info2 {
	border-color: rgba(255, 255, 255, 0.2) !important;
}
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_6'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_6'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_6'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_6'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_6'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_6'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_6'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_6'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {
	background-color: #fd9a47;
}
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_6'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_6'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_6'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_6'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_6'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_6'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_6'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_6'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_6'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_6'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {
	background: rgba(255, 255, 255, 0.15) !important;
}
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	a:hover,
[data-sidebarbg='color_6'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {
	color: #fff;
}
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	> a
	> i,
[data-sidebarbg='color_6'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
	background: #fd8623 !important;
	color: rgba(255, 255, 255, 0.7);
}
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_6'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_6'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
	box-shadow: none;
	background: transparent !important;
	color: #fff !important;
}
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a
	i,
[data-sidebarbg='color_6'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_6'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
	background: #fd9a47 !important;
	color: #fff !important;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu a,
[data-sidebarbg='color_6'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,
[data-sidebarbg='color_6'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_6'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_6'] .dlabnav .metismenu li ul a.mm-active {
	color: #fff !important;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu > li > a,
[data-sidebarbg='color_6'] .dlabnav .metismenu > li > a {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,
[data-sidebarbg='color_6'] .dlabnav .metismenu > li > a i {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_6'] .dlabnav .metismenu > li.mm-active > a {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #fff !important;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_6'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,
[data-sidebarbg='color_6'] .dlabnav .metismenu > li.mm-active > a:before {
	background: #fff !important;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,
[data-sidebarbg='color_6'] .dlabnav .metismenu .has-arrow:after {
	border-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .header-info2 span,
[data-sidebarbg='color_6'] .dlabnav .header-info2 span {
	color: #fff;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .sidebar-info,
[data-sidebarbg='color_6'] .dlabnav .sidebar-info {
	color: #fff;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .sidebar-info i,
[data-sidebarbg='color_6'] .dlabnav .sidebar-info i {
	color: #fff;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .plus-box,
[data-sidebarbg='color_6'] .plus-box {
	background-color: #fd9a47;
}
[data-sidebarbg='color_6'][data-theme-version='dark'] .copyright,
[data-sidebarbg='color_6'] .copyright {
	color: #fff;
}

[data-sidebarbg='color_7'][data-theme-version='dark'],
[data-sidebarbg='color_7'] {
	--sidebar-bg: #5155c3;
	/* &[data-sidebar-style="full"][data-layout="vertical"]{
				.dlabnav .metismenu > li.mm-active > a,
				.dlabnav .metismenu > li:hover > a{
						background:transparent;
				}	
			} */
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav,
[data-sidebarbg='color_7'] .dlabnav {
	border-color: #5155c3;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu > li:after,
[data-sidebarbg='color_7'] .dlabnav .metismenu > li:after {
	background: #fff !important;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,
[data-sidebarbg='color_7'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #5155c3 !important;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,
[data-sidebarbg='color_7'] .dlabnav .metismenu ul a:before {
	background: rgba(255, 255, 255, 0.5);
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .header-info2,
[data-sidebarbg='color_7'] .dlabnav .header-info2 {
	border-color: rgba(255, 255, 255, 0.2) !important;
}
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_7'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_7'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_7'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_7'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_7'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_7'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_7'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_7'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {
	background-color: #777ad0;
}
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_7'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_7'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_7'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_7'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_7'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_7'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_7'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_7'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_7'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_7'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {
	background: rgba(255, 255, 255, 0.15) !important;
}
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	a:hover,
[data-sidebarbg='color_7'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {
	color: #fff;
}
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	> a
	> i,
[data-sidebarbg='color_7'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
	background: #5c60c7 !important;
	color: rgba(255, 255, 255, 0.7);
}
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_7'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_7'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
	box-shadow: none;
	background: transparent !important;
	color: #fff !important;
}
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a
	i,
[data-sidebarbg='color_7'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_7'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
	background: #777ad0 !important;
	color: #fff !important;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu a,
[data-sidebarbg='color_7'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,
[data-sidebarbg='color_7'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_7'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_7'] .dlabnav .metismenu li ul a.mm-active {
	color: #fff !important;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu > li > a,
[data-sidebarbg='color_7'] .dlabnav .metismenu > li > a {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,
[data-sidebarbg='color_7'] .dlabnav .metismenu > li > a i {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_7'] .dlabnav .metismenu > li.mm-active > a {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #fff !important;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_7'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,
[data-sidebarbg='color_7'] .dlabnav .metismenu > li.mm-active > a:before {
	background: #fff !important;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,
[data-sidebarbg='color_7'] .dlabnav .metismenu .has-arrow:after {
	border-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .header-info2 span,
[data-sidebarbg='color_7'] .dlabnav .header-info2 span {
	color: #fff;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .sidebar-info,
[data-sidebarbg='color_7'] .dlabnav .sidebar-info {
	color: #fff;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .sidebar-info i,
[data-sidebarbg='color_7'] .dlabnav .sidebar-info i {
	color: #fff;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .plus-box,
[data-sidebarbg='color_7'] .plus-box {
	background-color: #777ad0;
}
[data-sidebarbg='color_7'][data-theme-version='dark'] .copyright,
[data-sidebarbg='color_7'] .copyright {
	color: #fff;
}

[data-sidebarbg='color_8'][data-theme-version='dark'],
[data-sidebarbg='color_8'] {
	--sidebar-bg: #854df3;
	/* &[data-sidebar-style="full"][data-layout="vertical"]{
				.dlabnav .metismenu > li.mm-active > a,
				.dlabnav .metismenu > li:hover > a{
						background:transparent;
				}	
			} */
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav,
[data-sidebarbg='color_8'] .dlabnav {
	border-color: #854df3;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu > li:after,
[data-sidebarbg='color_8'] .dlabnav .metismenu > li:after {
	background: #fff !important;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,
[data-sidebarbg='color_8'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #854df3 !important;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,
[data-sidebarbg='color_8'] .dlabnav .metismenu ul a:before {
	background: rgba(255, 255, 255, 0.5);
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .header-info2,
[data-sidebarbg='color_8'] .dlabnav .header-info2 {
	border-color: rgba(255, 255, 255, 0.2) !important;
}
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_8'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_8'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_8'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_8'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_8'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_8'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_8'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_8'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {
	background-color: #a67df6;
}
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_8'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_8'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_8'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_8'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_8'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_8'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_8'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_8'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_8'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_8'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {
	background: rgba(255, 255, 255, 0.15) !important;
}
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	a:hover,
[data-sidebarbg='color_8'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {
	color: #fff;
}
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	> a
	> i,
[data-sidebarbg='color_8'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
	background: #8f5bf4 !important;
	color: rgba(255, 255, 255, 0.7);
}
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_8'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_8'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
	box-shadow: none;
	background: transparent !important;
	color: #fff !important;
}
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a
	i,
[data-sidebarbg='color_8'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_8'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
	background: #a67df6 !important;
	color: #fff !important;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu a,
[data-sidebarbg='color_8'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,
[data-sidebarbg='color_8'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_8'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_8'] .dlabnav .metismenu li ul a.mm-active {
	color: #fff !important;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu > li > a,
[data-sidebarbg='color_8'] .dlabnav .metismenu > li > a {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,
[data-sidebarbg='color_8'] .dlabnav .metismenu > li > a i {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_8'] .dlabnav .metismenu > li.mm-active > a {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #fff !important;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_8'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,
[data-sidebarbg='color_8'] .dlabnav .metismenu > li.mm-active > a:before {
	background: #fff !important;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,
[data-sidebarbg='color_8'] .dlabnav .metismenu .has-arrow:after {
	border-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .header-info2 span,
[data-sidebarbg='color_8'] .dlabnav .header-info2 span {
	color: #fff;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .sidebar-info,
[data-sidebarbg='color_8'] .dlabnav .sidebar-info {
	color: #fff;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .sidebar-info i,
[data-sidebarbg='color_8'] .dlabnav .sidebar-info i {
	color: #fff;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .plus-box,
[data-sidebarbg='color_8'] .plus-box {
	background-color: #a67df6;
}
[data-sidebarbg='color_8'][data-theme-version='dark'] .copyright,
[data-sidebarbg='color_8'] .copyright {
	color: #fff;
}

[data-sidebarbg='color_9'][data-theme-version='dark'],
[data-sidebarbg='color_9'] {
	--sidebar-bg: #20c997;
	/* &[data-sidebar-style="full"][data-layout="vertical"]{
				.dlabnav .metismenu > li.mm-active > a,
				.dlabnav .metismenu > li:hover > a{
						background:transparent;
				}	
			} */
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav,
[data-sidebarbg='color_9'] .dlabnav {
	border-color: #20c997;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu > li:after,
[data-sidebarbg='color_9'] .dlabnav .metismenu > li:after {
	background: #fff !important;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,
[data-sidebarbg='color_9'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #20c997 !important;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,
[data-sidebarbg='color_9'] .dlabnav .metismenu ul a:before {
	background: rgba(255, 255, 255, 0.5);
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .header-info2,
[data-sidebarbg='color_9'] .dlabnav .header-info2 {
	border-color: rgba(255, 255, 255, 0.2) !important;
}
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_9'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_9'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_9'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_9'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_9'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_9'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_9'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_9'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {
	background-color: #3ce0af;
}
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_9'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_9'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_9'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_9'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_9'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_9'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_9'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_9'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_9'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_9'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {
	background: rgba(255, 255, 255, 0.15) !important;
}
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	a:hover,
[data-sidebarbg='color_9'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {
	color: #fff;
}
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	> a
	> i,
[data-sidebarbg='color_9'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
	background: #22d6a1 !important;
	color: rgba(255, 255, 255, 0.7);
}
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_9'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_9'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
	box-shadow: none;
	background: transparent !important;
	color: #fff !important;
}
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a
	i,
[data-sidebarbg='color_9'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_9'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
	background: #3ce0af !important;
	color: #fff !important;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu a,
[data-sidebarbg='color_9'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,
[data-sidebarbg='color_9'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_9'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_9'] .dlabnav .metismenu li ul a.mm-active {
	color: #fff !important;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu > li > a,
[data-sidebarbg='color_9'] .dlabnav .metismenu > li > a {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,
[data-sidebarbg='color_9'] .dlabnav .metismenu > li > a i {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_9'] .dlabnav .metismenu > li.mm-active > a {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #fff !important;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_9'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,
[data-sidebarbg='color_9'] .dlabnav .metismenu > li.mm-active > a:before {
	background: #fff !important;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,
[data-sidebarbg='color_9'] .dlabnav .metismenu .has-arrow:after {
	border-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .header-info2 span,
[data-sidebarbg='color_9'] .dlabnav .header-info2 span {
	color: #fff;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .sidebar-info,
[data-sidebarbg='color_9'] .dlabnav .sidebar-info {
	color: #fff;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .sidebar-info i,
[data-sidebarbg='color_9'] .dlabnav .sidebar-info i {
	color: #fff;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .plus-box,
[data-sidebarbg='color_9'] .plus-box {
	background-color: #3ce0af;
}
[data-sidebarbg='color_9'][data-theme-version='dark'] .copyright,
[data-sidebarbg='color_9'] .copyright {
	color: #fff;
}

[data-sidebarbg='color_10'][data-theme-version='dark'],
[data-sidebarbg='color_10'] {
	--sidebar-bg: #17a2b8;
	/* &[data-sidebar-style="full"][data-layout="vertical"]{
				.dlabnav .metismenu > li.mm-active > a,
				.dlabnav .metismenu > li:hover > a{
						background:transparent;
				}	
			} */
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav,
[data-sidebarbg='color_10'] .dlabnav {
	border-color: #17a2b8;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu > li:after,
[data-sidebarbg='color_10'] .dlabnav .metismenu > li:after {
	background: #fff !important;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,
[data-sidebarbg='color_10'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #17a2b8 !important;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,
[data-sidebarbg='color_10'] .dlabnav .metismenu ul a:before {
	background: rgba(255, 255, 255, 0.5);
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .header-info2,
[data-sidebarbg='color_10'] .dlabnav .header-info2 {
	border-color: rgba(255, 255, 255, 0.2) !important;
}
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_10'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_10'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_10'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_10'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_10'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_10'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_10'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_10'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {
	background-color: #1fc8e3;
}
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_10'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_10'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_10'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_10'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_10'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_10'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_10'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_10'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_10'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_10'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {
	background: rgba(255, 255, 255, 0.15) !important;
}
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	a:hover,
[data-sidebarbg='color_10'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {
	color: #fff;
}
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	> a
	> i,
[data-sidebarbg='color_10'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
	background: #19aec6 !important;
	color: rgba(255, 255, 255, 0.7);
}
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_10'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_10'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
	box-shadow: none;
	background: transparent !important;
	color: #fff !important;
}
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a
	i,
[data-sidebarbg='color_10'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_10'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
	background: #1fc8e3 !important;
	color: #fff !important;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu a,
[data-sidebarbg='color_10'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,
[data-sidebarbg='color_10'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_10'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_10'] .dlabnav .metismenu li ul a.mm-active {
	color: #fff !important;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu > li > a,
[data-sidebarbg='color_10'] .dlabnav .metismenu > li > a {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,
[data-sidebarbg='color_10'] .dlabnav .metismenu > li > a i {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_10'] .dlabnav .metismenu > li.mm-active > a {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #fff !important;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_10'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,
[data-sidebarbg='color_10'] .dlabnav .metismenu > li.mm-active > a:before {
	background: #fff !important;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,
[data-sidebarbg='color_10'] .dlabnav .metismenu .has-arrow:after {
	border-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .header-info2 span,
[data-sidebarbg='color_10'] .dlabnav .header-info2 span {
	color: #fff;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .sidebar-info,
[data-sidebarbg='color_10'] .dlabnav .sidebar-info {
	color: #fff;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .sidebar-info i,
[data-sidebarbg='color_10'] .dlabnav .sidebar-info i {
	color: #fff;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .plus-box,
[data-sidebarbg='color_10'] .plus-box {
	background-color: #1fc8e3;
}
[data-sidebarbg='color_10'][data-theme-version='dark'] .copyright,
[data-sidebarbg='color_10'] .copyright {
	color: #fff;
}

[data-sidebarbg='color_11'][data-theme-version='dark'],
[data-sidebarbg='color_11'] {
	--sidebar-bg: #94618e;
	/* &[data-sidebar-style="full"][data-layout="vertical"]{
				.dlabnav .metismenu > li.mm-active > a,
				.dlabnav .metismenu > li:hover > a{
						background:transparent;
				}	
			} */
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav,
[data-sidebarbg='color_11'] .dlabnav {
	border-color: #94618e;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu > li:after,
[data-sidebarbg='color_11'] .dlabnav .metismenu > li:after {
	background: #fff !important;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,
[data-sidebarbg='color_11'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #94618e !important;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,
[data-sidebarbg='color_11'] .dlabnav .metismenu ul a:before {
	background: rgba(255, 255, 255, 0.5);
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .header-info2,
[data-sidebarbg='color_11'] .dlabnav .header-info2 {
	border-color: rgba(255, 255, 255, 0.2) !important;
}
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_11'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_11'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_11'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_11'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_11'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_11'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_11'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_11'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {
	background-color: #aa7ea5;
}
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_11'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_11'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_11'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_11'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_11'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_11'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_11'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_11'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_11'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_11'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {
	background: rgba(255, 255, 255, 0.15) !important;
}
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	a:hover,
[data-sidebarbg='color_11'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {
	color: #fff;
}
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	> a
	> i,
[data-sidebarbg='color_11'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
	background: #9c6896 !important;
	color: rgba(255, 255, 255, 0.7);
}
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_11'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_11'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
	box-shadow: none;
	background: transparent !important;
	color: #fff !important;
}
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a
	i,
[data-sidebarbg='color_11'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_11'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
	background: #aa7ea5 !important;
	color: #fff !important;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu a,
[data-sidebarbg='color_11'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,
[data-sidebarbg='color_11'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_11'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_11'] .dlabnav .metismenu li ul a.mm-active {
	color: #fff !important;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu > li > a,
[data-sidebarbg='color_11'] .dlabnav .metismenu > li > a {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,
[data-sidebarbg='color_11'] .dlabnav .metismenu > li > a i {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_11'] .dlabnav .metismenu > li.mm-active > a {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #fff !important;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_11'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,
[data-sidebarbg='color_11'] .dlabnav .metismenu > li.mm-active > a:before {
	background: #fff !important;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,
[data-sidebarbg='color_11'] .dlabnav .metismenu .has-arrow:after {
	border-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .header-info2 span,
[data-sidebarbg='color_11'] .dlabnav .header-info2 span {
	color: #fff;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .sidebar-info,
[data-sidebarbg='color_11'] .dlabnav .sidebar-info {
	color: #fff;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .sidebar-info i,
[data-sidebarbg='color_11'] .dlabnav .sidebar-info i {
	color: #fff;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .plus-box,
[data-sidebarbg='color_11'] .plus-box {
	background-color: #aa7ea5;
}
[data-sidebarbg='color_11'][data-theme-version='dark'] .copyright,
[data-sidebarbg='color_11'] .copyright {
	color: #fff;
}

[data-sidebarbg='color_12'][data-theme-version='dark'],
[data-sidebarbg='color_12'] {
	--sidebar-bg: #00273a;
	/* &[data-sidebar-style="full"][data-layout="vertical"]{
				.dlabnav .metismenu > li.mm-active > a,
				.dlabnav .metismenu > li:hover > a{
						background:transparent;
				}	
			} */
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav,
[data-sidebarbg='color_12'] .dlabnav {
	border-color: #00273a;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu > li:after,
[data-sidebarbg='color_12'] .dlabnav .metismenu > li:after {
	background: #fff !important;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,
[data-sidebarbg='color_12'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #00273a !important;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,
[data-sidebarbg='color_12'] .dlabnav .metismenu ul a:before {
	background: rgba(255, 255, 255, 0.5);
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .header-info2,
[data-sidebarbg='color_12'] .dlabnav .header-info2 {
	border-color: rgba(255, 255, 255, 0.2) !important;
}
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_12'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_12'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_12'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_12'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_12'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_12'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_12'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_12'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {
	background-color: #00496d;
}
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_12'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_12'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_12'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_12'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_12'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_12'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_12'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_12'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_12'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_12'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {
	background: rgba(255, 255, 255, 0.15) !important;
}
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	a:hover,
[data-sidebarbg='color_12'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {
	color: #fff;
}
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	> a
	> i,
[data-sidebarbg='color_12'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
	background: #003149 !important;
	color: rgba(255, 255, 255, 0.7);
}
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_12'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_12'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
	box-shadow: none;
	background: transparent !important;
	color: #fff !important;
}
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a
	i,
[data-sidebarbg='color_12'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_12'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
	background: #00496d !important;
	color: #fff !important;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu a,
[data-sidebarbg='color_12'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,
[data-sidebarbg='color_12'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_12'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_12'] .dlabnav .metismenu li ul a.mm-active {
	color: #fff !important;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu > li > a,
[data-sidebarbg='color_12'] .dlabnav .metismenu > li > a {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,
[data-sidebarbg='color_12'] .dlabnav .metismenu > li > a i {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_12'] .dlabnav .metismenu > li.mm-active > a {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #fff !important;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_12'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,
[data-sidebarbg='color_12'] .dlabnav .metismenu > li.mm-active > a:before {
	background: #fff !important;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,
[data-sidebarbg='color_12'] .dlabnav .metismenu .has-arrow:after {
	border-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .header-info2 span,
[data-sidebarbg='color_12'] .dlabnav .header-info2 span {
	color: #fff;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .sidebar-info,
[data-sidebarbg='color_12'] .dlabnav .sidebar-info {
	color: #fff;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .sidebar-info i,
[data-sidebarbg='color_12'] .dlabnav .sidebar-info i {
	color: #fff;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .plus-box,
[data-sidebarbg='color_12'] .plus-box {
	background-color: #00496d;
}
[data-sidebarbg='color_12'][data-theme-version='dark'] .copyright,
[data-sidebarbg='color_12'] .copyright {
	color: #fff;
}

[data-sidebarbg='color_13'][data-theme-version='dark'],
[data-sidebarbg='color_13'] {
	--sidebar-bg: #432d29;
	/* &[data-sidebar-style="full"][data-layout="vertical"]{
				.dlabnav .metismenu > li.mm-active > a,
				.dlabnav .metismenu > li:hover > a{
						background:transparent;
				}	
			} */
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav,
[data-sidebarbg='color_13'] .dlabnav {
	border-color: #432d29;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu > li:after,
[data-sidebarbg='color_13'] .dlabnav .metismenu > li:after {
	background: #fff !important;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,
[data-sidebarbg='color_13'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #432d29 !important;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,
[data-sidebarbg='color_13'] .dlabnav .metismenu ul a:before {
	background: rgba(255, 255, 255, 0.5);
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .header-info2,
[data-sidebarbg='color_13'] .dlabnav .header-info2 {
	border-color: rgba(255, 255, 255, 0.2) !important;
}
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_13'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_13'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_13'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_13'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_13'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_13'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_13'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_13'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {
	background-color: #63423c;
}
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_13'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_13'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_13'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_13'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_13'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_13'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_13'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_13'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_13'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_13'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {
	background: rgba(255, 255, 255, 0.15) !important;
}
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	a:hover,
[data-sidebarbg='color_13'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {
	color: #fff;
}
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	> a
	> i,
[data-sidebarbg='color_13'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
	background: #4c332f !important;
	color: rgba(255, 255, 255, 0.7);
}
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_13'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_13'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
	box-shadow: none;
	background: transparent !important;
	color: #fff !important;
}
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a
	i,
[data-sidebarbg='color_13'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_13'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
	background: #63423c !important;
	color: #fff !important;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu a,
[data-sidebarbg='color_13'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,
[data-sidebarbg='color_13'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_13'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_13'] .dlabnav .metismenu li ul a.mm-active {
	color: #fff !important;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu > li > a,
[data-sidebarbg='color_13'] .dlabnav .metismenu > li > a {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,
[data-sidebarbg='color_13'] .dlabnav .metismenu > li > a i {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_13'] .dlabnav .metismenu > li.mm-active > a {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #fff !important;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_13'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,
[data-sidebarbg='color_13'] .dlabnav .metismenu > li.mm-active > a:before {
	background: #fff !important;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,
[data-sidebarbg='color_13'] .dlabnav .metismenu .has-arrow:after {
	border-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .header-info2 span,
[data-sidebarbg='color_13'] .dlabnav .header-info2 span {
	color: #fff;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .sidebar-info,
[data-sidebarbg='color_13'] .dlabnav .sidebar-info {
	color: #fff;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .sidebar-info i,
[data-sidebarbg='color_13'] .dlabnav .sidebar-info i {
	color: #fff;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .plus-box,
[data-sidebarbg='color_13'] .plus-box {
	background-color: #63423c;
}
[data-sidebarbg='color_13'][data-theme-version='dark'] .copyright,
[data-sidebarbg='color_13'] .copyright {
	color: #fff;
}

[data-sidebarbg='color_14'][data-theme-version='dark'],
[data-sidebarbg='color_14'] {
	--sidebar-bg: #4885ed;
	/* &[data-sidebar-style="full"][data-layout="vertical"]{
				.dlabnav .metismenu > li.mm-active > a,
				.dlabnav .metismenu > li:hover > a{
						background:transparent;
				}	
			} */
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav,
[data-sidebarbg='color_14'] .dlabnav {
	border-color: #4885ed;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu > li:after,
[data-sidebarbg='color_14'] .dlabnav .metismenu > li:after {
	background: #fff !important;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,
[data-sidebarbg='color_14'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #4885ed !important;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,
[data-sidebarbg='color_14'] .dlabnav .metismenu ul a:before {
	background: rgba(255, 255, 255, 0.5);
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .header-info2,
[data-sidebarbg='color_14'] .dlabnav .header-info2 {
	border-color: rgba(255, 255, 255, 0.2) !important;
}
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_14'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_14'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_14'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_14'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_14'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_14'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_14'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_14'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {
	background-color: #76a4f2;
}
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_14'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_14'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_14'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_14'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_14'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_14'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_14'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_14'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_14'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_14'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {
	background: rgba(255, 255, 255, 0.15) !important;
}
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	a:hover,
[data-sidebarbg='color_14'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {
	color: #fff;
}
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	> a
	> i,
[data-sidebarbg='color_14'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
	background: #568eee !important;
	color: rgba(255, 255, 255, 0.7);
}
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_14'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_14'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
	box-shadow: none;
	background: transparent !important;
	color: #fff !important;
}
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a
	i,
[data-sidebarbg='color_14'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_14'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
	background: #76a4f2 !important;
	color: #fff !important;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu a,
[data-sidebarbg='color_14'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,
[data-sidebarbg='color_14'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_14'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_14'] .dlabnav .metismenu li ul a.mm-active {
	color: #fff !important;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu > li > a,
[data-sidebarbg='color_14'] .dlabnav .metismenu > li > a {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,
[data-sidebarbg='color_14'] .dlabnav .metismenu > li > a i {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_14'] .dlabnav .metismenu > li.mm-active > a {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #fff !important;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_14'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,
[data-sidebarbg='color_14'] .dlabnav .metismenu > li.mm-active > a:before {
	background: #fff !important;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,
[data-sidebarbg='color_14'] .dlabnav .metismenu .has-arrow:after {
	border-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .header-info2 span,
[data-sidebarbg='color_14'] .dlabnav .header-info2 span {
	color: #fff;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .sidebar-info,
[data-sidebarbg='color_14'] .dlabnav .sidebar-info {
	color: #fff;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .sidebar-info i,
[data-sidebarbg='color_14'] .dlabnav .sidebar-info i {
	color: #fff;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .plus-box,
[data-sidebarbg='color_14'] .plus-box {
	background-color: #76a4f2;
}
[data-sidebarbg='color_14'][data-theme-version='dark'] .copyright,
[data-sidebarbg='color_14'] .copyright {
	color: #fff;
}

[data-sidebarbg='color_15'][data-theme-version='dark'],
[data-sidebarbg='color_15'] {
	--sidebar-bg: #4cb32b;
	/* &[data-sidebar-style="full"][data-layout="vertical"]{
				.dlabnav .metismenu > li.mm-active > a,
				.dlabnav .metismenu > li:hover > a{
						background:transparent;
				}	
			} */
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav,
[data-sidebarbg='color_15'] .dlabnav {
	border-color: #4cb32b;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu > li:after,
[data-sidebarbg='color_15'] .dlabnav .metismenu > li:after {
	background: #fff !important;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,
[data-sidebarbg='color_15'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #4cb32b !important;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,
[data-sidebarbg='color_15'] .dlabnav .metismenu ul a:before {
	background: rgba(255, 255, 255, 0.5);
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .header-info2,
[data-sidebarbg='color_15'] .dlabnav .header-info2 {
	border-color: rgba(255, 255, 255, 0.2) !important;
}
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_15'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff;
}
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_15'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,
[data-sidebarbg='color_15'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {
	color: #fff;
}
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_15'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_15'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_15'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_15'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,
[data-sidebarbg='color_15'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {
	background-color: #63d140;
}
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_15'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_15'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_15'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_15'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_15'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_15'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_15'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_15'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,
[data-sidebarbg='color_15'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_15'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {
	background: rgba(255, 255, 255, 0.15) !important;
}
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	a:hover,
[data-sidebarbg='color_15'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {
	color: #fff;
}
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li
	> a
	> i,
[data-sidebarbg='color_15'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {
	background: #51bf2e !important;
	color: rgba(255, 255, 255, 0.7);
}
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a,
[data-sidebarbg='color_15'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_15'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {
	box-shadow: none;
	background: transparent !important;
	color: #fff !important;
}
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li.mm-active
	> a
	i,
[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']
	.dlabnav
	.metismenu
	> li:hover
	> a
	i,
[data-sidebarbg='color_15'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_15'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {
	background: #63d140 !important;
	color: #fff !important;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu a,
[data-sidebarbg='color_15'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.8) !important;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,
[data-sidebarbg='color_15'] .dlabnav .metismenu li ul a:hover,
[data-sidebarbg='color_15'] .dlabnav .metismenu li ul a:focus,
[data-sidebarbg='color_15'] .dlabnav .metismenu li ul a.mm-active {
	color: #fff !important;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu > li > a,
[data-sidebarbg='color_15'] .dlabnav .metismenu > li > a {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,
[data-sidebarbg='color_15'] .dlabnav .metismenu > li > a i {
	color: rgba(255, 255, 255, 0.85) !important;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,
[data-sidebarbg='color_15'] .dlabnav .metismenu > li.mm-active > a {
	background: rgba(255, 255, 255, 0.15) !important;
	color: #fff !important;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,
[data-sidebarbg='color_15'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,
[data-sidebarbg='color_15'] .dlabnav .metismenu > li.mm-active > a:before {
	background: #fff !important;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,
[data-sidebarbg='color_15'] .dlabnav .metismenu .has-arrow:after {
	border-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .header-info2 span,
[data-sidebarbg='color_15'] .dlabnav .header-info2 span {
	color: #fff;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .sidebar-info,
[data-sidebarbg='color_15'] .dlabnav .sidebar-info {
	color: #fff;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .sidebar-info i,
[data-sidebarbg='color_15'] .dlabnav .sidebar-info i {
	color: #fff;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .plus-box,
[data-sidebarbg='color_15'] .plus-box {
	background-color: #63d140;
}
[data-sidebarbg='color_15'][data-theme-version='dark'] .copyright,
[data-sidebarbg='color_15'] .copyright {
	color: #fff;
}

[data-headerbg='color_2'][data-theme-version='dark'],
[data-headerbg='color_2'] {
	--headerbg: #4d44b5;
}
[data-headerbg='color_2'][data-theme-version='dark'] .header.is-fixed,
[data-headerbg='color_2'] .header.is-fixed {
	border-color: #6e66c6 !important;
}
[data-headerbg='color_2'][data-theme-version='dark'] .header,
[data-headerbg='color_2'] .header {
	border: 0;
}
[data-headerbg='color_2'][data-theme-version='dark'] .header-left .dashboard_bar,
[data-headerbg='color_2'] .header-left .dashboard_bar {
	color: #fff;
}
[data-headerbg='color_2'][data-theme-version='dark'] .hamburger svg rect,
[data-headerbg='color_2'] .hamburger svg rect {
	fill: #fff;
}
[data-headerbg='color_2'][data-theme-version='dark'] .header-right,
[data-headerbg='color_2'] .header-right {
	/* .sidebar-info h4, .sidebar-info .h4,
					.header-profile2 span{
						color:\$white;
				
					} */
}
[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,
[data-headerbg='color_2'] .header-right .notification_dropdown .nav-link {
	background-color: #6e66c6;
	border-color: #6e66c6;
}
[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,
[data-headerbg='color_2'] .header-right .notification_dropdown .nav-link .setting-svg path {
	fill: #fff;
}
[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,
[data-headerbg='color_2'] .header-right .notification_dropdown .menu-wallet svg path {
	fill: #fff;
}
[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,
[data-headerbg='color_2'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_2'] .header-right .notification_dropdown.search-area-header svg path {
	fill: #fff;
}
[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,
[data-headerbg='color_2'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_2'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_2'] .header-right .notification_dropdown .bell-link svg path {
	stroke: #fff;
}
[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,
[data-headerbg='color_2'] .header-right .notification_dropdown .search-area svg path {
	fill: var(--primary);
}
[data-headerbg='color_2'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,
[data-headerbg='color_2'] .header-right .header-profile2 .dropdown-menu a span {
	color: #000;
}
[data-headerbg='color_2'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_2'] .header-right .bootstrap-select .btn {
	background-color: #6e66c6 !important;
}
[data-headerbg='color_2'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,
[data-headerbg='color_2'] .header-right .bootstrap-select.countrypicker {
	border-color: #6e66c6 !important;
}
[data-headerbg='color_2'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_2'] .header-right .bootstrap-select .btn {
	color: #fff !important;
	border-color: #6e66c6 !important;
}
[data-headerbg='color_2'][data-theme-version='dark'] .hamburger .line,
[data-headerbg='color_2'] .hamburger .line {
	background-color: #fff !important;
}

[data-headerbg='color_3'][data-theme-version='dark'],
[data-headerbg='color_3'] {
	--headerbg: #056468;
}
[data-headerbg='color_3'][data-theme-version='dark'] .header.is-fixed,
[data-headerbg='color_3'] .header.is-fixed {
	border-color: #079399 !important;
}
[data-headerbg='color_3'][data-theme-version='dark'] .header,
[data-headerbg='color_3'] .header {
	border: 0;
}
[data-headerbg='color_3'][data-theme-version='dark'] .header-left .dashboard_bar,
[data-headerbg='color_3'] .header-left .dashboard_bar {
	color: #fff;
}
[data-headerbg='color_3'][data-theme-version='dark'] .hamburger svg rect,
[data-headerbg='color_3'] .hamburger svg rect {
	fill: #fff;
}
[data-headerbg='color_3'][data-theme-version='dark'] .header-right,
[data-headerbg='color_3'] .header-right {
	/* .sidebar-info h4, .sidebar-info .h4,
					.header-profile2 span{
						color:\$white;
				
					} */
}
[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,
[data-headerbg='color_3'] .header-right .notification_dropdown .nav-link {
	background-color: #079399;
	border-color: #079399;
}
[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,
[data-headerbg='color_3'] .header-right .notification_dropdown .nav-link .setting-svg path {
	fill: #fff;
}
[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,
[data-headerbg='color_3'] .header-right .notification_dropdown .menu-wallet svg path {
	fill: #fff;
}
[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,
[data-headerbg='color_3'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_3'] .header-right .notification_dropdown.search-area-header svg path {
	fill: #fff;
}
[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,
[data-headerbg='color_3'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_3'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_3'] .header-right .notification_dropdown .bell-link svg path {
	stroke: #fff;
}
[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,
[data-headerbg='color_3'] .header-right .notification_dropdown .search-area svg path {
	fill: var(--primary);
}
[data-headerbg='color_3'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,
[data-headerbg='color_3'] .header-right .header-profile2 .dropdown-menu a span {
	color: #000;
}
[data-headerbg='color_3'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_3'] .header-right .bootstrap-select .btn {
	background-color: #079399 !important;
}
[data-headerbg='color_3'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,
[data-headerbg='color_3'] .header-right .bootstrap-select.countrypicker {
	border-color: #079399 !important;
}
[data-headerbg='color_3'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_3'] .header-right .bootstrap-select .btn {
	color: #fff !important;
	border-color: #079399 !important;
}
[data-headerbg='color_3'][data-theme-version='dark'] .hamburger .line,
[data-headerbg='color_3'] .hamburger .line {
	background-color: #fff !important;
}

[data-headerbg='color_4'][data-theme-version='dark'],
[data-headerbg='color_4'] {
	--headerbg: #4d06a5;
}
[data-headerbg='color_4'][data-theme-version='dark'] .header.is-fixed,
[data-headerbg='color_4'] .header.is-fixed {
	border-color: #6408d6 !important;
}
[data-headerbg='color_4'][data-theme-version='dark'] .header,
[data-headerbg='color_4'] .header {
	border: 0;
}
[data-headerbg='color_4'][data-theme-version='dark'] .header-left .dashboard_bar,
[data-headerbg='color_4'] .header-left .dashboard_bar {
	color: #fff;
}
[data-headerbg='color_4'][data-theme-version='dark'] .hamburger svg rect,
[data-headerbg='color_4'] .hamburger svg rect {
	fill: #fff;
}
[data-headerbg='color_4'][data-theme-version='dark'] .header-right,
[data-headerbg='color_4'] .header-right {
	/* .sidebar-info h4, .sidebar-info .h4,
					.header-profile2 span{
						color:\$white;
				
					} */
}
[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,
[data-headerbg='color_4'] .header-right .notification_dropdown .nav-link {
	background-color: #6408d6;
	border-color: #6408d6;
}
[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,
[data-headerbg='color_4'] .header-right .notification_dropdown .nav-link .setting-svg path {
	fill: #fff;
}
[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,
[data-headerbg='color_4'] .header-right .notification_dropdown .menu-wallet svg path {
	fill: #fff;
}
[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,
[data-headerbg='color_4'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_4'] .header-right .notification_dropdown.search-area-header svg path {
	fill: #fff;
}
[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,
[data-headerbg='color_4'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_4'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_4'] .header-right .notification_dropdown .bell-link svg path {
	stroke: #fff;
}
[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,
[data-headerbg='color_4'] .header-right .notification_dropdown .search-area svg path {
	fill: var(--primary);
}
[data-headerbg='color_4'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,
[data-headerbg='color_4'] .header-right .header-profile2 .dropdown-menu a span {
	color: #000;
}
[data-headerbg='color_4'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_4'] .header-right .bootstrap-select .btn {
	background-color: #6408d6 !important;
}
[data-headerbg='color_4'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,
[data-headerbg='color_4'] .header-right .bootstrap-select.countrypicker {
	border-color: #6408d6 !important;
}
[data-headerbg='color_4'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_4'] .header-right .bootstrap-select .btn {
	color: #fff !important;
	border-color: #6408d6 !important;
}
[data-headerbg='color_4'][data-theme-version='dark'] .hamburger .line,
[data-headerbg='color_4'] .hamburger .line {
	background-color: #fff !important;
}

[data-headerbg='color_5'][data-theme-version='dark'],
[data-headerbg='color_5'] {
	--headerbg: #dc3545;
}
[data-headerbg='color_5'][data-theme-version='dark'] .header.is-fixed,
[data-headerbg='color_5'] .header.is-fixed {
	border-color: #e4606d !important;
}
[data-headerbg='color_5'][data-theme-version='dark'] .header,
[data-headerbg='color_5'] .header {
	border: 0;
}
[data-headerbg='color_5'][data-theme-version='dark'] .header-left .dashboard_bar,
[data-headerbg='color_5'] .header-left .dashboard_bar {
	color: #fff;
}
[data-headerbg='color_5'][data-theme-version='dark'] .hamburger svg rect,
[data-headerbg='color_5'] .hamburger svg rect {
	fill: #fff;
}
[data-headerbg='color_5'][data-theme-version='dark'] .header-right,
[data-headerbg='color_5'] .header-right {
	/* .sidebar-info h4, .sidebar-info .h4,
					.header-profile2 span{
						color:\$white;
				
					} */
}
[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,
[data-headerbg='color_5'] .header-right .notification_dropdown .nav-link {
	background-color: #e4606d;
	border-color: #e4606d;
}
[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,
[data-headerbg='color_5'] .header-right .notification_dropdown .nav-link .setting-svg path {
	fill: #fff;
}
[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,
[data-headerbg='color_5'] .header-right .notification_dropdown .menu-wallet svg path {
	fill: #fff;
}
[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,
[data-headerbg='color_5'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_5'] .header-right .notification_dropdown.search-area-header svg path {
	fill: #fff;
}
[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,
[data-headerbg='color_5'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_5'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_5'] .header-right .notification_dropdown .bell-link svg path {
	stroke: #fff;
}
[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,
[data-headerbg='color_5'] .header-right .notification_dropdown .search-area svg path {
	fill: var(--primary);
}
[data-headerbg='color_5'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,
[data-headerbg='color_5'] .header-right .header-profile2 .dropdown-menu a span {
	color: #000;
}
[data-headerbg='color_5'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_5'] .header-right .bootstrap-select .btn {
	background-color: #e4606d !important;
}
[data-headerbg='color_5'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,
[data-headerbg='color_5'] .header-right .bootstrap-select.countrypicker {
	border-color: #e4606d !important;
}
[data-headerbg='color_5'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_5'] .header-right .bootstrap-select .btn {
	color: #fff !important;
	border-color: #e4606d !important;
}
[data-headerbg='color_5'][data-theme-version='dark'] .hamburger .line,
[data-headerbg='color_5'] .hamburger .line {
	background-color: #fff !important;
}

[data-headerbg='color_6'][data-theme-version='dark'],
[data-headerbg='color_6'] {
	--headerbg: #fd7e14;
}
[data-headerbg='color_6'][data-theme-version='dark'] .header.is-fixed,
[data-headerbg='color_6'] .header.is-fixed {
	border-color: #fd9a47 !important;
}
[data-headerbg='color_6'][data-theme-version='dark'] .header,
[data-headerbg='color_6'] .header {
	border: 0;
}
[data-headerbg='color_6'][data-theme-version='dark'] .header-left .dashboard_bar,
[data-headerbg='color_6'] .header-left .dashboard_bar {
	color: #fff;
}
[data-headerbg='color_6'][data-theme-version='dark'] .hamburger svg rect,
[data-headerbg='color_6'] .hamburger svg rect {
	fill: #fff;
}
[data-headerbg='color_6'][data-theme-version='dark'] .header-right,
[data-headerbg='color_6'] .header-right {
	/* .sidebar-info h4, .sidebar-info .h4,
					.header-profile2 span{
						color:\$white;
				
					} */
}
[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,
[data-headerbg='color_6'] .header-right .notification_dropdown .nav-link {
	background-color: #fd9a47;
	border-color: #fd9a47;
}
[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,
[data-headerbg='color_6'] .header-right .notification_dropdown .nav-link .setting-svg path {
	fill: #fff;
}
[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,
[data-headerbg='color_6'] .header-right .notification_dropdown .menu-wallet svg path {
	fill: #fff;
}
[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,
[data-headerbg='color_6'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_6'] .header-right .notification_dropdown.search-area-header svg path {
	fill: #fff;
}
[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,
[data-headerbg='color_6'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_6'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_6'] .header-right .notification_dropdown .bell-link svg path {
	stroke: #fff;
}
[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,
[data-headerbg='color_6'] .header-right .notification_dropdown .search-area svg path {
	fill: var(--primary);
}
[data-headerbg='color_6'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,
[data-headerbg='color_6'] .header-right .header-profile2 .dropdown-menu a span {
	color: #000;
}
[data-headerbg='color_6'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_6'] .header-right .bootstrap-select .btn {
	background-color: #fd9a47 !important;
}
[data-headerbg='color_6'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,
[data-headerbg='color_6'] .header-right .bootstrap-select.countrypicker {
	border-color: #fd9a47 !important;
}
[data-headerbg='color_6'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_6'] .header-right .bootstrap-select .btn {
	color: #fff !important;
	border-color: #fd9a47 !important;
}
[data-headerbg='color_6'][data-theme-version='dark'] .hamburger .line,
[data-headerbg='color_6'] .hamburger .line {
	background-color: #fff !important;
}

[data-headerbg='color_7'][data-theme-version='dark'],
[data-headerbg='color_7'] {
	--headerbg: #5155c3;
}
[data-headerbg='color_7'][data-theme-version='dark'] .header.is-fixed,
[data-headerbg='color_7'] .header.is-fixed {
	border-color: #777ad0 !important;
}
[data-headerbg='color_7'][data-theme-version='dark'] .header,
[data-headerbg='color_7'] .header {
	border: 0;
}
[data-headerbg='color_7'][data-theme-version='dark'] .header-left .dashboard_bar,
[data-headerbg='color_7'] .header-left .dashboard_bar {
	color: #fff;
}
[data-headerbg='color_7'][data-theme-version='dark'] .hamburger svg rect,
[data-headerbg='color_7'] .hamburger svg rect {
	fill: #fff;
}
[data-headerbg='color_7'][data-theme-version='dark'] .header-right,
[data-headerbg='color_7'] .header-right {
	/* .sidebar-info h4, .sidebar-info .h4,
					.header-profile2 span{
						color:\$white;
				
					} */
}
[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,
[data-headerbg='color_7'] .header-right .notification_dropdown .nav-link {
	background-color: #777ad0;
	border-color: #777ad0;
}
[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,
[data-headerbg='color_7'] .header-right .notification_dropdown .nav-link .setting-svg path {
	fill: #fff;
}
[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,
[data-headerbg='color_7'] .header-right .notification_dropdown .menu-wallet svg path {
	fill: #fff;
}
[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,
[data-headerbg='color_7'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_7'] .header-right .notification_dropdown.search-area-header svg path {
	fill: #fff;
}
[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,
[data-headerbg='color_7'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_7'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_7'] .header-right .notification_dropdown .bell-link svg path {
	stroke: #fff;
}
[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,
[data-headerbg='color_7'] .header-right .notification_dropdown .search-area svg path {
	fill: var(--primary);
}
[data-headerbg='color_7'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,
[data-headerbg='color_7'] .header-right .header-profile2 .dropdown-menu a span {
	color: #000;
}
[data-headerbg='color_7'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_7'] .header-right .bootstrap-select .btn {
	background-color: #777ad0 !important;
}
[data-headerbg='color_7'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,
[data-headerbg='color_7'] .header-right .bootstrap-select.countrypicker {
	border-color: #777ad0 !important;
}
[data-headerbg='color_7'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_7'] .header-right .bootstrap-select .btn {
	color: #fff !important;
	border-color: #777ad0 !important;
}
[data-headerbg='color_7'][data-theme-version='dark'] .hamburger .line,
[data-headerbg='color_7'] .hamburger .line {
	background-color: #fff !important;
}

[data-headerbg='color_8'][data-theme-version='dark'],
[data-headerbg='color_8'] {
	--headerbg: #854df3;
}
[data-headerbg='color_8'][data-theme-version='dark'] .header.is-fixed,
[data-headerbg='color_8'] .header.is-fixed {
	border-color: #a67df6 !important;
}
[data-headerbg='color_8'][data-theme-version='dark'] .header,
[data-headerbg='color_8'] .header {
	border: 0;
}
[data-headerbg='color_8'][data-theme-version='dark'] .header-left .dashboard_bar,
[data-headerbg='color_8'] .header-left .dashboard_bar {
	color: #fff;
}
[data-headerbg='color_8'][data-theme-version='dark'] .hamburger svg rect,
[data-headerbg='color_8'] .hamburger svg rect {
	fill: #fff;
}
[data-headerbg='color_8'][data-theme-version='dark'] .header-right,
[data-headerbg='color_8'] .header-right {
	/* .sidebar-info h4, .sidebar-info .h4,
					.header-profile2 span{
						color:\$white;
				
					} */
}
[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,
[data-headerbg='color_8'] .header-right .notification_dropdown .nav-link {
	background-color: #a67df6;
	border-color: #a67df6;
}
[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,
[data-headerbg='color_8'] .header-right .notification_dropdown .nav-link .setting-svg path {
	fill: #fff;
}
[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,
[data-headerbg='color_8'] .header-right .notification_dropdown .menu-wallet svg path {
	fill: #fff;
}
[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,
[data-headerbg='color_8'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_8'] .header-right .notification_dropdown.search-area-header svg path {
	fill: #fff;
}
[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,
[data-headerbg='color_8'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_8'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_8'] .header-right .notification_dropdown .bell-link svg path {
	stroke: #fff;
}
[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,
[data-headerbg='color_8'] .header-right .notification_dropdown .search-area svg path {
	fill: var(--primary);
}
[data-headerbg='color_8'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,
[data-headerbg='color_8'] .header-right .header-profile2 .dropdown-menu a span {
	color: #000;
}
[data-headerbg='color_8'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_8'] .header-right .bootstrap-select .btn {
	background-color: #a67df6 !important;
}
[data-headerbg='color_8'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,
[data-headerbg='color_8'] .header-right .bootstrap-select.countrypicker {
	border-color: #a67df6 !important;
}
[data-headerbg='color_8'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_8'] .header-right .bootstrap-select .btn {
	color: #fff !important;
	border-color: #a67df6 !important;
}
[data-headerbg='color_8'][data-theme-version='dark'] .hamburger .line,
[data-headerbg='color_8'] .hamburger .line {
	background-color: #fff !important;
}

[data-headerbg='color_9'][data-theme-version='dark'],
[data-headerbg='color_9'] {
	--headerbg: #20c997;
}
[data-headerbg='color_9'][data-theme-version='dark'] .header.is-fixed,
[data-headerbg='color_9'] .header.is-fixed {
	border-color: #3ce0af !important;
}
[data-headerbg='color_9'][data-theme-version='dark'] .header,
[data-headerbg='color_9'] .header {
	border: 0;
}
[data-headerbg='color_9'][data-theme-version='dark'] .header-left .dashboard_bar,
[data-headerbg='color_9'] .header-left .dashboard_bar {
	color: #fff;
}
[data-headerbg='color_9'][data-theme-version='dark'] .hamburger svg rect,
[data-headerbg='color_9'] .hamburger svg rect {
	fill: #fff;
}
[data-headerbg='color_9'][data-theme-version='dark'] .header-right,
[data-headerbg='color_9'] .header-right {
	/* .sidebar-info h4, .sidebar-info .h4,
					.header-profile2 span{
						color:\$white;
				
					} */
}
[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,
[data-headerbg='color_9'] .header-right .notification_dropdown .nav-link {
	background-color: #3ce0af;
	border-color: #3ce0af;
}
[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,
[data-headerbg='color_9'] .header-right .notification_dropdown .nav-link .setting-svg path {
	fill: #fff;
}
[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,
[data-headerbg='color_9'] .header-right .notification_dropdown .menu-wallet svg path {
	fill: #fff;
}
[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,
[data-headerbg='color_9'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_9'] .header-right .notification_dropdown.search-area-header svg path {
	fill: #fff;
}
[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,
[data-headerbg='color_9'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_9'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_9'] .header-right .notification_dropdown .bell-link svg path {
	stroke: #fff;
}
[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,
[data-headerbg='color_9'] .header-right .notification_dropdown .search-area svg path {
	fill: var(--primary);
}
[data-headerbg='color_9'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,
[data-headerbg='color_9'] .header-right .header-profile2 .dropdown-menu a span {
	color: #000;
}
[data-headerbg='color_9'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_9'] .header-right .bootstrap-select .btn {
	background-color: #3ce0af !important;
}
[data-headerbg='color_9'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,
[data-headerbg='color_9'] .header-right .bootstrap-select.countrypicker {
	border-color: #3ce0af !important;
}
[data-headerbg='color_9'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_9'] .header-right .bootstrap-select .btn {
	color: #fff !important;
	border-color: #3ce0af !important;
}
[data-headerbg='color_9'][data-theme-version='dark'] .hamburger .line,
[data-headerbg='color_9'] .hamburger .line {
	background-color: #fff !important;
}

[data-headerbg='color_10'][data-theme-version='dark'],
[data-headerbg='color_10'] {
	--headerbg: #17a2b8;
}
[data-headerbg='color_10'][data-theme-version='dark'] .header.is-fixed,
[data-headerbg='color_10'] .header.is-fixed {
	border-color: #1fc8e3 !important;
}
[data-headerbg='color_10'][data-theme-version='dark'] .header,
[data-headerbg='color_10'] .header {
	border: 0;
}
[data-headerbg='color_10'][data-theme-version='dark'] .header-left .dashboard_bar,
[data-headerbg='color_10'] .header-left .dashboard_bar {
	color: #fff;
}
[data-headerbg='color_10'][data-theme-version='dark'] .hamburger svg rect,
[data-headerbg='color_10'] .hamburger svg rect {
	fill: #fff;
}
[data-headerbg='color_10'][data-theme-version='dark'] .header-right,
[data-headerbg='color_10'] .header-right {
	/* .sidebar-info h4, .sidebar-info .h4,
					.header-profile2 span{
						color:\$white;
				
					} */
}
[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,
[data-headerbg='color_10'] .header-right .notification_dropdown .nav-link {
	background-color: #1fc8e3;
	border-color: #1fc8e3;
}
[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,
[data-headerbg='color_10'] .header-right .notification_dropdown .nav-link .setting-svg path {
	fill: #fff;
}
[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,
[data-headerbg='color_10'] .header-right .notification_dropdown .menu-wallet svg path {
	fill: #fff;
}
[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,
[data-headerbg='color_10'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_10'] .header-right .notification_dropdown.search-area-header svg path {
	fill: #fff;
}
[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,
[data-headerbg='color_10'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_10'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_10'] .header-right .notification_dropdown .bell-link svg path {
	stroke: #fff;
}
[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,
[data-headerbg='color_10'] .header-right .notification_dropdown .search-area svg path {
	fill: var(--primary);
}
[data-headerbg='color_10'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,
[data-headerbg='color_10'] .header-right .header-profile2 .dropdown-menu a span {
	color: #000;
}
[data-headerbg='color_10'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_10'] .header-right .bootstrap-select .btn {
	background-color: #1fc8e3 !important;
}
[data-headerbg='color_10'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,
[data-headerbg='color_10'] .header-right .bootstrap-select.countrypicker {
	border-color: #1fc8e3 !important;
}
[data-headerbg='color_10'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_10'] .header-right .bootstrap-select .btn {
	color: #fff !important;
	border-color: #1fc8e3 !important;
}
[data-headerbg='color_10'][data-theme-version='dark'] .hamburger .line,
[data-headerbg='color_10'] .hamburger .line {
	background-color: #fff !important;
}

[data-headerbg='color_11'][data-theme-version='dark'],
[data-headerbg='color_11'] {
	--headerbg: #94618e;
}
[data-headerbg='color_11'][data-theme-version='dark'] .header.is-fixed,
[data-headerbg='color_11'] .header.is-fixed {
	border-color: #aa7ea5 !important;
}
[data-headerbg='color_11'][data-theme-version='dark'] .header,
[data-headerbg='color_11'] .header {
	border: 0;
}
[data-headerbg='color_11'][data-theme-version='dark'] .header-left .dashboard_bar,
[data-headerbg='color_11'] .header-left .dashboard_bar {
	color: #fff;
}
[data-headerbg='color_11'][data-theme-version='dark'] .hamburger svg rect,
[data-headerbg='color_11'] .hamburger svg rect {
	fill: #fff;
}
[data-headerbg='color_11'][data-theme-version='dark'] .header-right,
[data-headerbg='color_11'] .header-right {
	/* .sidebar-info h4, .sidebar-info .h4,
					.header-profile2 span{
						color:\$white;
				
					} */
}
[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,
[data-headerbg='color_11'] .header-right .notification_dropdown .nav-link {
	background-color: #aa7ea5;
	border-color: #aa7ea5;
}
[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,
[data-headerbg='color_11'] .header-right .notification_dropdown .nav-link .setting-svg path {
	fill: #fff;
}
[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,
[data-headerbg='color_11'] .header-right .notification_dropdown .menu-wallet svg path {
	fill: #fff;
}
[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,
[data-headerbg='color_11'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_11'] .header-right .notification_dropdown.search-area-header svg path {
	fill: #fff;
}
[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,
[data-headerbg='color_11'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_11'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_11'] .header-right .notification_dropdown .bell-link svg path {
	stroke: #fff;
}
[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,
[data-headerbg='color_11'] .header-right .notification_dropdown .search-area svg path {
	fill: var(--primary);
}
[data-headerbg='color_11'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,
[data-headerbg='color_11'] .header-right .header-profile2 .dropdown-menu a span {
	color: #000;
}
[data-headerbg='color_11'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_11'] .header-right .bootstrap-select .btn {
	background-color: #aa7ea5 !important;
}
[data-headerbg='color_11'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,
[data-headerbg='color_11'] .header-right .bootstrap-select.countrypicker {
	border-color: #aa7ea5 !important;
}
[data-headerbg='color_11'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_11'] .header-right .bootstrap-select .btn {
	color: #fff !important;
	border-color: #aa7ea5 !important;
}
[data-headerbg='color_11'][data-theme-version='dark'] .hamburger .line,
[data-headerbg='color_11'] .hamburger .line {
	background-color: #fff !important;
}

[data-headerbg='color_12'][data-theme-version='dark'],
[data-headerbg='color_12'] {
	--headerbg: #00273a;
}
[data-headerbg='color_12'][data-theme-version='dark'] .header.is-fixed,
[data-headerbg='color_12'] .header.is-fixed {
	border-color: #00496d !important;
}
[data-headerbg='color_12'][data-theme-version='dark'] .header,
[data-headerbg='color_12'] .header {
	border: 0;
}
[data-headerbg='color_12'][data-theme-version='dark'] .header-left .dashboard_bar,
[data-headerbg='color_12'] .header-left .dashboard_bar {
	color: #fff;
}
[data-headerbg='color_12'][data-theme-version='dark'] .hamburger svg rect,
[data-headerbg='color_12'] .hamburger svg rect {
	fill: #fff;
}
[data-headerbg='color_12'][data-theme-version='dark'] .header-right,
[data-headerbg='color_12'] .header-right {
	/* .sidebar-info h4, .sidebar-info .h4,
					.header-profile2 span{
						color:\$white;
				
					} */
}
[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,
[data-headerbg='color_12'] .header-right .notification_dropdown .nav-link {
	background-color: #00496d;
	border-color: #00496d;
}
[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,
[data-headerbg='color_12'] .header-right .notification_dropdown .nav-link .setting-svg path {
	fill: #fff;
}
[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,
[data-headerbg='color_12'] .header-right .notification_dropdown .menu-wallet svg path {
	fill: #fff;
}
[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,
[data-headerbg='color_12'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_12'] .header-right .notification_dropdown.search-area-header svg path {
	fill: #fff;
}
[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,
[data-headerbg='color_12'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_12'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_12'] .header-right .notification_dropdown .bell-link svg path {
	stroke: #fff;
}
[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,
[data-headerbg='color_12'] .header-right .notification_dropdown .search-area svg path {
	fill: var(--primary);
}
[data-headerbg='color_12'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,
[data-headerbg='color_12'] .header-right .header-profile2 .dropdown-menu a span {
	color: #000;
}
[data-headerbg='color_12'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_12'] .header-right .bootstrap-select .btn {
	background-color: #00496d !important;
}
[data-headerbg='color_12'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,
[data-headerbg='color_12'] .header-right .bootstrap-select.countrypicker {
	border-color: #00496d !important;
}
[data-headerbg='color_12'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_12'] .header-right .bootstrap-select .btn {
	color: #fff !important;
	border-color: #00496d !important;
}
[data-headerbg='color_12'][data-theme-version='dark'] .hamburger .line,
[data-headerbg='color_12'] .hamburger .line {
	background-color: #fff !important;
}

[data-headerbg='color_13'][data-theme-version='dark'],
[data-headerbg='color_13'] {
	--headerbg: #432d29;
}
[data-headerbg='color_13'][data-theme-version='dark'] .header.is-fixed,
[data-headerbg='color_13'] .header.is-fixed {
	border-color: #63423c !important;
}
[data-headerbg='color_13'][data-theme-version='dark'] .header,
[data-headerbg='color_13'] .header {
	border: 0;
}
[data-headerbg='color_13'][data-theme-version='dark'] .header-left .dashboard_bar,
[data-headerbg='color_13'] .header-left .dashboard_bar {
	color: #fff;
}
[data-headerbg='color_13'][data-theme-version='dark'] .hamburger svg rect,
[data-headerbg='color_13'] .hamburger svg rect {
	fill: #fff;
}
[data-headerbg='color_13'][data-theme-version='dark'] .header-right,
[data-headerbg='color_13'] .header-right {
	/* .sidebar-info h4, .sidebar-info .h4,
					.header-profile2 span{
						color:\$white;
				
					} */
}
[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,
[data-headerbg='color_13'] .header-right .notification_dropdown .nav-link {
	background-color: #63423c;
	border-color: #63423c;
}
[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,
[data-headerbg='color_13'] .header-right .notification_dropdown .nav-link .setting-svg path {
	fill: #fff;
}
[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,
[data-headerbg='color_13'] .header-right .notification_dropdown .menu-wallet svg path {
	fill: #fff;
}
[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,
[data-headerbg='color_13'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_13'] .header-right .notification_dropdown.search-area-header svg path {
	fill: #fff;
}
[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,
[data-headerbg='color_13'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_13'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_13'] .header-right .notification_dropdown .bell-link svg path {
	stroke: #fff;
}
[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,
[data-headerbg='color_13'] .header-right .notification_dropdown .search-area svg path {
	fill: var(--primary);
}
[data-headerbg='color_13'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,
[data-headerbg='color_13'] .header-right .header-profile2 .dropdown-menu a span {
	color: #000;
}
[data-headerbg='color_13'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_13'] .header-right .bootstrap-select .btn {
	background-color: #63423c !important;
}
[data-headerbg='color_13'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,
[data-headerbg='color_13'] .header-right .bootstrap-select.countrypicker {
	border-color: #63423c !important;
}
[data-headerbg='color_13'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_13'] .header-right .bootstrap-select .btn {
	color: #fff !important;
	border-color: #63423c !important;
}
[data-headerbg='color_13'][data-theme-version='dark'] .hamburger .line,
[data-headerbg='color_13'] .hamburger .line {
	background-color: #fff !important;
}

[data-headerbg='color_14'][data-theme-version='dark'],
[data-headerbg='color_14'] {
	--headerbg: #4885ed;
}
[data-headerbg='color_14'][data-theme-version='dark'] .header.is-fixed,
[data-headerbg='color_14'] .header.is-fixed {
	border-color: #76a4f2 !important;
}
[data-headerbg='color_14'][data-theme-version='dark'] .header,
[data-headerbg='color_14'] .header {
	border: 0;
}
[data-headerbg='color_14'][data-theme-version='dark'] .header-left .dashboard_bar,
[data-headerbg='color_14'] .header-left .dashboard_bar {
	color: #fff;
}
[data-headerbg='color_14'][data-theme-version='dark'] .hamburger svg rect,
[data-headerbg='color_14'] .hamburger svg rect {
	fill: #fff;
}
[data-headerbg='color_14'][data-theme-version='dark'] .header-right,
[data-headerbg='color_14'] .header-right {
	/* .sidebar-info h4, .sidebar-info .h4,
					.header-profile2 span{
						color:\$white;
				
					} */
}
[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,
[data-headerbg='color_14'] .header-right .notification_dropdown .nav-link {
	background-color: #76a4f2;
	border-color: #76a4f2;
}
[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,
[data-headerbg='color_14'] .header-right .notification_dropdown .nav-link .setting-svg path {
	fill: #fff;
}
[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,
[data-headerbg='color_14'] .header-right .notification_dropdown .menu-wallet svg path {
	fill: #fff;
}
[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,
[data-headerbg='color_14'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_14'] .header-right .notification_dropdown.search-area-header svg path {
	fill: #fff;
}
[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,
[data-headerbg='color_14'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_14'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_14'] .header-right .notification_dropdown .bell-link svg path {
	stroke: #fff;
}
[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,
[data-headerbg='color_14'] .header-right .notification_dropdown .search-area svg path {
	fill: var(--primary);
}
[data-headerbg='color_14'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,
[data-headerbg='color_14'] .header-right .header-profile2 .dropdown-menu a span {
	color: #000;
}
[data-headerbg='color_14'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_14'] .header-right .bootstrap-select .btn {
	background-color: #76a4f2 !important;
}
[data-headerbg='color_14'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,
[data-headerbg='color_14'] .header-right .bootstrap-select.countrypicker {
	border-color: #76a4f2 !important;
}
[data-headerbg='color_14'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_14'] .header-right .bootstrap-select .btn {
	color: #fff !important;
	border-color: #76a4f2 !important;
}
[data-headerbg='color_14'][data-theme-version='dark'] .hamburger .line,
[data-headerbg='color_14'] .hamburger .line {
	background-color: #fff !important;
}

[data-headerbg='color_15'][data-theme-version='dark'],
[data-headerbg='color_15'] {
	--headerbg: #4cb32b;
}
[data-headerbg='color_15'][data-theme-version='dark'] .header.is-fixed,
[data-headerbg='color_15'] .header.is-fixed {
	border-color: #63d140 !important;
}
[data-headerbg='color_15'][data-theme-version='dark'] .header,
[data-headerbg='color_15'] .header {
	border: 0;
}
[data-headerbg='color_15'][data-theme-version='dark'] .header-left .dashboard_bar,
[data-headerbg='color_15'] .header-left .dashboard_bar {
	color: #fff;
}
[data-headerbg='color_15'][data-theme-version='dark'] .hamburger svg rect,
[data-headerbg='color_15'] .hamburger svg rect {
	fill: #fff;
}
[data-headerbg='color_15'][data-theme-version='dark'] .header-right,
[data-headerbg='color_15'] .header-right {
	/* .sidebar-info h4, .sidebar-info .h4,
					.header-profile2 span{
						color:\$white;
				
					} */
}
[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,
[data-headerbg='color_15'] .header-right .notification_dropdown .nav-link {
	background-color: #63d140;
	border-color: #63d140;
}
[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,
[data-headerbg='color_15'] .header-right .notification_dropdown .nav-link .setting-svg path {
	fill: #fff;
}
[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,
[data-headerbg='color_15'] .header-right .notification_dropdown .menu-wallet svg path {
	fill: #fff;
}
[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,
[data-headerbg='color_15'] .header-right .notification_dropdown.bell-icon svg path,
[data-headerbg='color_15'] .header-right .notification_dropdown.search-area-header svg path {
	fill: #fff;
}
[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,
[data-headerbg='color_15'] .header-right .notification_dropdown .dz-theme-mode svg path,
[data-headerbg='color_15'] .header-right .notification_dropdown .dz-fullscreen svg path,
[data-headerbg='color_15'] .header-right .notification_dropdown .bell-link svg path {
	stroke: #fff;
}
[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,
[data-headerbg='color_15'] .header-right .notification_dropdown .search-area svg path {
	fill: var(--primary);
}
[data-headerbg='color_15'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,
[data-headerbg='color_15'] .header-right .header-profile2 .dropdown-menu a span {
	color: #000;
}
[data-headerbg='color_15'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_15'] .header-right .bootstrap-select .btn {
	background-color: #63d140 !important;
}
[data-headerbg='color_15'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,
[data-headerbg='color_15'] .header-right .bootstrap-select.countrypicker {
	border-color: #63d140 !important;
}
[data-headerbg='color_15'][data-theme-version='dark'] .header-right .bootstrap-select .btn,
[data-headerbg='color_15'] .header-right .bootstrap-select .btn {
	color: #fff !important;
	border-color: #63d140 !important;
}
[data-headerbg='color_15'][data-theme-version='dark'] .hamburger .line,
[data-headerbg='color_15'] .hamburger .line {
	background-color: #fff !important;
}

@media (min-width: 62rem) {
	[data-container='boxed'] {
		--right-space: 0;
		/* .wallet-open .content-body{
			padding-right: 0;
		} */
	}
	[data-container='boxed'] #main-wrapper {
		max-width: 74.9375rem;
		margin: 0 auto;
		box-shadow: 0 0 1.875rem 0 rgba(0, 0, 0, 0.1);
		overflow: hidden;
	}
	[direction='rtl'][data-container='boxed'] #main-wrapper {
		text-align: right;
	}
	[data-container='boxed'] .invoice-num {
		font-size: 1.375rem;
	}
	[data-container='boxed'] .wallet-open .header .header-content {
		padding-right: 1.875rem;
	}
	[data-container='boxed'] .wallet-bar {
		display: none;
	}
	[data-container='boxed'] .nav-link.menu-wallet {
		display: none;
	}
	[data-container='boxed'] .header-left .dashboard_bar {
		display: none;
	}
	[data-container='boxed'] .footer.style-2 {
		width: calc(100% - 3.625rem);
	}
	[data-container='boxed'] .footer.footer-outer {
		width: calc(100% - 3.725rem);
		margin-right: 1.875rem;
	}
}

@media only screen and (min-width: 84.375rem) {
	[data-layout='vertical'][data-sidebar-style='overlay'][data-container='boxed'][data-header-position='fixed'] .header {
		width: 74.9375rem;
	}
}

@media only screen and (min-width: 75rem) and (max-width: 84.3125rem) {
	[data-layout='vertical'][data-sidebar-style='overlay'][data-container='boxed'][data-header-position='fixed'] .header {
		width: 74.9375rem;
	}
}

[data-header-position='fixed'][data-layout='horizontal'][data-container='boxed'] .dlabnav {
	max-width: 74.9375rem;
}

[data-header-position='fixed'][data-layout='horizontal'][data-container='boxed'] .content-body {
	padding-top: 14rem !important;
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'] .header,
[data-layout='horizontal'][data-container='boxed'][data-header-position='fixed'] .header {
	width: 74.9375rem;
}

[data-layout='horizontal'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='mini'] .header {
	width: 74.9375rem;
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='mini'] .footer.footer-outer {
	width: calc(100% - 10.325rem);
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='mini'] .footer.out-footer.style-2 {
	width: calc(100% - 9.625rem);
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='mini'] .footer.out-footer.style-1 {
	width: calc(100% - 28.125rem);
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='compact'] .footer.footer-outer {
	width: calc(100% - 15.225rem);
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='compact'] .footer.out-footer.style-2 {
	width: calc(100% - 15.625rem);
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='compact'] .footer.out-footer.style-1 {
	width: calc(100% - 33.225rem);
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='compact'] .header .header-content {
	padding-right: 11.275rem;
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='overlay'] .footer.footer-outer {
	width: calc(100% - 4.225rem);
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='overlay'] .footer.out-footer.style-2 {
	width: calc(100% - 15.625rem);
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='overlay'] .footer.out-footer.style-1 {
	width: calc(100% - 22.225rem);
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='overlay'] .header .header-content {
	padding-right: 312px;
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='icon-hover'] .footer.footer-outer {
	width: calc(100% - 9.725rem);
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='icon-hover'] .footer.out-footer.style-2 {
	width: calc(100% - 15.625rem);
}

[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='icon-hover'] .footer.out-footer.style-1 {
	width: calc(100% - 22.225rem);
}

[data-layout='horizontal'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='full']
	.wallet-open.show.active.dlabnav-scroll {
	padding-right: 0;
}

[data-layout='horizontal'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='compact']
	.wallet-open.show.active
	.dlabnav-scroll {
	padding-right: 0;
}

[data-layout='horizontal'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='modern'] .footer.style-2 {
	width: calc(100% - 3.625rem);
	margin-left: auto;
}

[data-layout='horizontal'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='modern'] .footer.footer-outer {
	width: calc(100% - 3.225rem);
}

[data-layout='horizontal'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='modern']
	.wallet-open.show.active.dlabnav-scroll {
	padding-right: 0;
}

[data-container='boxed'] .metismenu.fixed {
	left: auto;
	max-width: 74.9375rem;
}

[data-container='boxed'] .page-titles {
	margin-bottom: 3rem;
	padding: 0.9375rem 0.9375rem;
}

[data-container='boxed'] .content-body .container-fluid,
[data-container='boxed'] .content-body .container-sm,
[data-container='boxed'] .content-body .container-md,
[data-container='boxed'] .content-body .container-lg,
[data-container='boxed'] .content-body .container-xl,
[data-container='boxed'] .content-body .container-xxl {
	padding: 1.875rem;
}

[data-container='boxed'][data-layout='vertical'] .page-titles {
	margin-left: 0;
	margin-right: 0;
}

[data-layout='vertical'][data-container='boxed'][data-sidebar-position='fixed'][data-header-position='static'][data-sidebar-style='overlay']
	.nav-header {
	position: absolute;
}

[data-layout='vertical'][data-container='boxed'][data-sidebar-position='fixed'][data-header-position='static'][data-sidebar-style='overlay']
	.menu-toggle
	.dlabnav {
	position: absolute;
}

[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .dlabnav.fixed {
	left: auto;
	max-width: 74.9375rem;
}

[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .container-fluid,
[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .container-sm,
[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .container-md,
[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .container-lg,
[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .container-xl,
[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .container-xxl {
	padding-bottom: 0;
}

[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] {
	/* &[data-sidebar-style="full"],
	&[data-sidebar-style="icon-hover"]{
		.content-body{
			padding-top: 9rem;
		}
	} */
	/* &[data-sidebar-style="modern"]{
		.content-body{
			padding-top: 6.5rem;
		}
	} */
}
[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'][data-sidebar-style='compact'] .content-body {
	padding-top: 18rem !important;
}
[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'][data-sidebar-style='mini'] .content-body {
	padding-top: 10rem !important;
}

[data-container='boxed'] .nav-header,
[data-container='wide-boxed'] .nav-header,
[data-sidebar-position='static'][data-header-position='static'][data-layout='horizontal'] .nav-header {
	height: 5.5rem;
}

[data-container='boxed'][data-sidebar-position='static'][data-header-position='fixed'][data-layout='horizontal'] .nav-header {
	height: 5rem;
}

[data-container='boxed'][data-sidebar-position='static'][data-header-position='fixed'][data-layout='horizontal'][data-sidebar-style='mini']
	.content-body {
	padding-top: 10rem !important;
}

[data-container='boxed'][data-sidebar-position='static'][data-header-position='fixed'][data-layout='horizontal'][data-sidebar-style='modern']
	.content-body {
	padding-top: 6.5rem;
}

[data-container='wide-boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] {
	/* &[data-sidebar-style="full"],
	&[data-sidebar-style="icon-hover"]{
		.content-body{
			padding-top: 9rem;
		}
	} */
	/* &[data-sidebar-style="compact"]{
		.content-body{
			padding-top: 7.5rem;
		}
	} */
	/* &[data-sidebar-style="modern"]{
		.content-body{
			padding-top: 6.5rem;
		}
	} */
}
[data-container='wide-boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .footer.footer-outer {
	width: calc(100% - 4.925rem);
	margin-left: 2.6rem;
}

[data-container='wide-boxed'][data-sidebar-position='static'][data-layout='horizontal'][data-sidebar-style='compact']
	.header
	.header-content {
	margin-left: 13.2rem;
}

[data-container='wide-boxed'] .nav-header,
[data-container='boxed'] .nav-header,
[data-container='wide'] .nav-header,
[data-sidebar-position='static'][data-layout='horizontal'][data-header-position='static'] .nav-header {
	height: 5rem;
	z-index: 8;
}

[data-container='wide'][data-sidebar-position='fixed'][data-layout='horizontal'][data-sidebar-style='compact'] .header .header-content {
	margin-left: 12.2rem;
}

[data-container='boxed'] .header-left .search-area {
	display: none;
}

@media (min-width: 62rem) {
	[data-container='wide-boxed'] {
		--right-space: 0;
	}
	[data-container='wide-boxed'] #main-wrapper {
		max-width: 92.5rem;
		margin: 0 auto;
		box-shadow: 0 0 1.875rem 0 rgba(0, 0, 0, 0.1);
		overflow: hidden;
	}
	[direction='rtl'][data-container='wide-boxed'] #main-wrapper {
		text-align: right;
	}
	[data-container='wide-boxed'] .wallet-open .header .header-content {
		padding-right: 1.875rem;
	}
	[data-container='wide-boxed'] .wallet-bar {
		display: none;
	}
	[data-container='wide-boxed'] .nav-link.menu-wallet {
		display: none;
	}
	[data-container='wide-boxed'] .footer.footer-outer {
		width: calc(100% - 15.725rem);
		margin-right: 1.875rem;
	}
}

@media only screen and (min-width: 84.375rem) {
	[data-layout='vertical'][data-sidebar-style='overlay'][data-container='wide-boxed'][data-header-position='fixed'] .header {
		width: 92.5rem;
	}
}

@media only screen and (min-width: 75rem) and (max-width: 100rem) {
	[data-layout='vertical'][data-sidebar-style='overlay'][data-container='wide-boxed'][data-header-position='fixed'] .header {
		width: 92.5rem;
	}
}

[data-layout='vertical'][data-sidebar-style='overlay'][data-container='wide-boxed'][data-header-position='fixed']
	.footer.out-footer.style-1 {
	width: calc(100% - 23.525rem);
	margin-right: 20.775rem;
}

[data-layout='vertical'][data-sidebar-style='overlay'][data-container='wide-boxed'][data-header-position='fixed'] .footer.footer-outer {
	width: calc(100% - 4.725rem);
	margin-right: 1.875rem;
}

[data-layout='vertical'][data-sidebar-style='overlay'][data-container='wide-boxed'][data-header-position='fixed']
	.footer.out-footer.style-2 {
	width: calc(100% - 4.325rem);
}

[data-layout='vertical'][data-sidebar-style='overlay'][data-container='wide-boxed'][data-header-position='fixed'] .header .header-content {
	padding-right: 19.875rem;
}

[data-layout='vertical'][data-sidebar-style='icon-hover'][data-container='wide-boxed'][data-header-position='fixed']
	.footer.out-footer.style-1 {
	width: calc(100% - 28.725rem);
	margin-right: 20.875rem;
}

[data-layout='vertical'][data-sidebar-style='icon-hover'][data-container='wide-boxed'][data-header-position='fixed'] .footer.footer-outer {
	width: calc(100% - 9.725rem);
	margin-right: 1.875rem;
}

[data-layout='vertical'][data-sidebar-style='icon-hover'][data-container='wide-boxed'][data-header-position='fixed']
	.footer.out-footer.style-2 {
	width: calc(100% - 9.725rem);
	margin-right: 1.875rem;
}

[data-layout='vertical'][data-sidebar-style='mini'][data-container='wide-boxed'][data-header-position='fixed'] .footer.out-footer.style-1 {
	width: calc(100% - 28.525rem);
	margin-right: 19.775rem;
}

[data-layout='vertical'][data-sidebar-style='mini'][data-container='wide-boxed'][data-header-position='fixed'] .footer.footer-outer {
	width: calc(100% - 10.725rem);
	margin-right: 1.875rem;
}

[data-layout='vertical'][data-sidebar-style='mini'][data-container='wide-boxed'][data-header-position='fixed'] .footer.out-footer.style-2 {
	width: calc(100% - 11.125rem);
}

[data-sidebar-style='compact'][data-header-position='fixed'][data-container='wide-boxed'][data-layout='vertical'] .header {
	width: 92.5rem;
}
[data-sidebar-style='compact'][data-header-position='fixed'][data-container='wide-boxed'][data-layout='vertical'] .header .header-content {
	padding-left: 3rem !important;
	width: calc(100% - 10.1rem);
}

[data-sidebar-style='compact'][data-header-position='fixed'][data-container='wide-boxed'][data-layout='vertical']
	.footer.out-footer.style-2 {
	width: calc(100% - 15.625rem);
}

[data-sidebar-style='compact'][data-header-position='fixed'][data-container='wide-boxed'][data-layout='vertical']
	.footer.out-footer.style-1 {
	width: calc(100% - 35.225rem);
	margin-right: 20.975rem;
}

[data-header-position='fixed'][data-layout='horizontal'][data-container='wide-boxed'] .dlabnav {
	max-width: 92.5rem;
}

[data-layout='vertical'][data-container='wide-boxed'][data-header-position='fixed'] .header,
[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'] .header {
	width: 92.5rem;
}

[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='mini'] .header {
	width: 92.5rem;
}

[data-layout='vertical'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='full'] .header {
	width: 92.5rem;
}
[data-layout='vertical'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='full'] .header .header-content {
	padding-right: 19.875rem;
}

[data-layout='vertical'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='full'] .footer.footer-outer {
	width: calc(100% - 21.725rem);
	margin-right: 1.875rem;
}

[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='compact']
	.wallet-open.show.active
	.dlabnav-scroll {
	padding-right: 0px;
}

[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='icon-hover']
	.footer.footer-outer {
	width: calc(100% - 5.025rem);
	margin-left: 1.775rem;
}

[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='icon-hover']
	.wallet-open.show.active
	.dlabnav-scroll {
	padding-right: 0px;
}

[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='modern']
	.wallet-open.show.active
	.dlabnav-scroll {
	padding-right: 0px;
}

[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='modern'] .header .header-content {
	padding-right: 19.875rem;
}

[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='modern'] .footer.footer-outer {
	width: calc(100% - 4.225rem);
	margin-left: 2.775rem !important;
}

[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='modern'] .footer.style-1 {
	width: calc(100% - 24.225rem);
	margin-left: 2.775rem !important;
}

[data-container='wide-boxed'] .metismenu.fixed {
	left: auto;
	max-width: 92.5rem;
}

[data-container='wide-boxed'] .page-titles {
	margin-bottom: 3rem;
	padding: 0.9375rem 0.9375rem;
}

[data-container='wide-boxed'] .content-body .container-fluid,
[data-container='wide-boxed'] .content-body .container-sm,
[data-container='wide-boxed'] .content-body .container-md,
[data-container='wide-boxed'] .content-body .container-lg,
[data-container='wide-boxed'] .content-body .container-xl,
[data-container='wide-boxed'] .content-body .container-xxl {
	padding: 2.5rem;
}

[data-container='wide-boxed'][data-layout='vertical'] .page-titles {
	margin-left: 0;
	margin-right: 0;
}

[data-layout='vertical'][data-container='wide-boxed'][data-sidebar-position='fixed'][data-header-position='static'][data-sidebar-style='overlay']
	.nav-header {
	position: absolute;
}

[data-layout='vertical'][data-container='wide-boxed'][data-sidebar-position='fixed'][data-header-position='static'][data-sidebar-style='overlay']
	.menu-toggle
	.dlabnav {
	position: absolute;
}

[data-container='wide-boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .dlabnav.fixed {
	left: auto;
	max-width: 92.5rem;
}

[data-container='wide-boxed'][data-layout='horizontal'][data-header-position='fixed'][data-sidebar-style='icon-hover'] .content-body,
[data-container='wide-boxed'][data-layout='horizontal'][data-header-position='fixed'][data-sidebar-style='full'] .content-body {
	padding-top: 14rem;
}

[data-container='wide-boxed'][data-layout='horizontal'][data-header-position='fixed'][data-sidebar-style='compact'] .content-body,
[data-container='wide-boxed'][data-layout='horizontal'][data-header-position='fixed'][data-sidebar-style='modern'] .content-body {
	padding-top: 12rem;
}

[data-primary='color_2'] {
	--primary: #4d44b5;
	--secondary: #fb7d5b;
	--primary-hover: #3d3690;
	--primary-dark: #1e1a46;
	--rgba-primary-1: rgba(77, 68, 181, 0.1);
	--rgba-primary-2: rgba(77, 68, 181, 0.2);
	--rgba-primary-3: rgba(77, 68, 181, 0.3);
	--rgba-primary-4: rgba(77, 68, 181, 0.4);
	--rgba-primary-5: rgba(77, 68, 181, 0.5);
	--rgba-primary-6: rgba(77, 68, 181, 0.6);
	--rgba-primary-7: rgba(77, 68, 181, 0.7);
	--rgba-primary-8: rgba(77, 68, 181, 0.8);
	--rgba-primary-9: rgba(77, 68, 181, 0.9);
}

[data-primary='color_3'] {
	--primary: #056468;
	--secondary: #fb7d5b;
	--primary-hover: #033537;
	--primary-dark: black;
	--rgba-primary-1: rgba(5, 100, 104, 0.1);
	--rgba-primary-2: rgba(5, 100, 104, 0.2);
	--rgba-primary-3: rgba(5, 100, 104, 0.3);
	--rgba-primary-4: rgba(5, 100, 104, 0.4);
	--rgba-primary-5: rgba(5, 100, 104, 0.5);
	--rgba-primary-6: rgba(5, 100, 104, 0.6);
	--rgba-primary-7: rgba(5, 100, 104, 0.7);
	--rgba-primary-8: rgba(5, 100, 104, 0.8);
	--rgba-primary-9: rgba(5, 100, 104, 0.9);
}

[data-primary='color_4'] {
	--primary: #4d06a5;
	--secondary: #fb7d5b;
	--primary-hover: #360474;
	--primary-dark: #080111;
	--rgba-primary-1: rgba(77, 6, 165, 0.1);
	--rgba-primary-2: rgba(77, 6, 165, 0.2);
	--rgba-primary-3: rgba(77, 6, 165, 0.3);
	--rgba-primary-4: rgba(77, 6, 165, 0.4);
	--rgba-primary-5: rgba(77, 6, 165, 0.5);
	--rgba-primary-6: rgba(77, 6, 165, 0.6);
	--rgba-primary-7: rgba(77, 6, 165, 0.7);
	--rgba-primary-8: rgba(77, 6, 165, 0.8);
	--rgba-primary-9: rgba(77, 6, 165, 0.9);
}

[data-primary='color_5'] {
	--primary: #dc3545;
	--secondary: #fb7d5b;
	--primary-hover: #bd2130;
	--primary-dark: #66121a;
	--rgba-primary-1: rgba(220, 53, 69, 0.1);
	--rgba-primary-2: rgba(220, 53, 69, 0.2);
	--rgba-primary-3: rgba(220, 53, 69, 0.3);
	--rgba-primary-4: rgba(220, 53, 69, 0.4);
	--rgba-primary-5: rgba(220, 53, 69, 0.5);
	--rgba-primary-6: rgba(220, 53, 69, 0.6);
	--rgba-primary-7: rgba(220, 53, 69, 0.7);
	--rgba-primary-8: rgba(220, 53, 69, 0.8);
	--rgba-primary-9: rgba(220, 53, 69, 0.9);
}

[data-primary='color_6'] {
	--primary: #fd7e14;
	--secondary: #fb7d5b;
	--primary-hover: #dc6502;
	--primary-dark: #773701;
	--rgba-primary-1: rgba(253, 126, 20, 0.1);
	--rgba-primary-2: rgba(253, 126, 20, 0.2);
	--rgba-primary-3: rgba(253, 126, 20, 0.3);
	--rgba-primary-4: rgba(253, 126, 20, 0.4);
	--rgba-primary-5: rgba(253, 126, 20, 0.5);
	--rgba-primary-6: rgba(253, 126, 20, 0.6);
	--rgba-primary-7: rgba(253, 126, 20, 0.7);
	--rgba-primary-8: rgba(253, 126, 20, 0.8);
	--rgba-primary-9: rgba(253, 126, 20, 0.9);
}

[data-primary='color_7'] {
	--primary: #5155c3;
	--secondary: #fb7d5b;
	--primary-hover: #3a3ea7;
	--primary-dark: #20225b;
	--rgba-primary-1: rgba(81, 85, 195, 0.1);
	--rgba-primary-2: rgba(81, 85, 195, 0.2);
	--rgba-primary-3: rgba(81, 85, 195, 0.3);
	--rgba-primary-4: rgba(81, 85, 195, 0.4);
	--rgba-primary-5: rgba(81, 85, 195, 0.5);
	--rgba-primary-6: rgba(81, 85, 195, 0.6);
	--rgba-primary-7: rgba(81, 85, 195, 0.7);
	--rgba-primary-8: rgba(81, 85, 195, 0.8);
	--rgba-primary-9: rgba(81, 85, 195, 0.9);
}

[data-primary='color_8'] {
	--primary: #854df3;
	--secondary: #fb7d5b;
	--primary-hover: #641df0;
	--primary-dark: #3c0b9c;
	--rgba-primary-1: rgba(133, 77, 243, 0.1);
	--rgba-primary-2: rgba(133, 77, 243, 0.2);
	--rgba-primary-3: rgba(133, 77, 243, 0.3);
	--rgba-primary-4: rgba(133, 77, 243, 0.4);
	--rgba-primary-5: rgba(133, 77, 243, 0.5);
	--rgba-primary-6: rgba(133, 77, 243, 0.6);
	--rgba-primary-7: rgba(133, 77, 243, 0.7);
	--rgba-primary-8: rgba(133, 77, 243, 0.8);
	--rgba-primary-9: rgba(133, 77, 243, 0.9);
}

[data-primary='color_9'] {
	--primary: #20c997;
	--secondary: #fb7d5b;
	--primary-hover: #199d76;
	--primary-dark: #0b4534;
	--rgba-primary-1: rgba(32, 201, 151, 0.1);
	--rgba-primary-2: rgba(32, 201, 151, 0.2);
	--rgba-primary-3: rgba(32, 201, 151, 0.3);
	--rgba-primary-4: rgba(32, 201, 151, 0.4);
	--rgba-primary-5: rgba(32, 201, 151, 0.5);
	--rgba-primary-6: rgba(32, 201, 151, 0.6);
	--rgba-primary-7: rgba(32, 201, 151, 0.7);
	--rgba-primary-8: rgba(32, 201, 151, 0.8);
	--rgba-primary-9: rgba(32, 201, 151, 0.9);
}

[data-primary='color_10'] {
	--primary: #17a2b8;
	--secondary: #fb7d5b;
	--primary-hover: #117a8b;
	--primary-dark: #062a30;
	--rgba-primary-1: rgba(23, 162, 184, 0.1);
	--rgba-primary-2: rgba(23, 162, 184, 0.2);
	--rgba-primary-3: rgba(23, 162, 184, 0.3);
	--rgba-primary-4: rgba(23, 162, 184, 0.4);
	--rgba-primary-5: rgba(23, 162, 184, 0.5);
	--rgba-primary-6: rgba(23, 162, 184, 0.6);
	--rgba-primary-7: rgba(23, 162, 184, 0.7);
	--rgba-primary-8: rgba(23, 162, 184, 0.8);
	--rgba-primary-9: rgba(23, 162, 184, 0.9);
}

[data-primary='color_11'] {
	--primary: #94618e;
	--secondary: #fb7d5b;
	--primary-hover: #754d70;
	--primary-dark: #382435;
	--rgba-primary-1: rgba(148, 97, 142, 0.1);
	--rgba-primary-2: rgba(148, 97, 142, 0.2);
	--rgba-primary-3: rgba(148, 97, 142, 0.3);
	--rgba-primary-4: rgba(148, 97, 142, 0.4);
	--rgba-primary-5: rgba(148, 97, 142, 0.5);
	--rgba-primary-6: rgba(148, 97, 142, 0.6);
	--rgba-primary-7: rgba(148, 97, 142, 0.7);
	--rgba-primary-8: rgba(148, 97, 142, 0.8);
	--rgba-primary-9: rgba(148, 97, 142, 0.9);
}

[data-primary='color_12'] {
	--primary: #00273a;
	--secondary: #fb7d5b;
	--primary-hover: #000507;
	--primary-dark: black;
	--rgba-primary-1: rgba(0, 39, 58, 0.1);
	--rgba-primary-2: rgba(0, 39, 58, 0.2);
	--rgba-primary-3: rgba(0, 39, 58, 0.3);
	--rgba-primary-4: rgba(0, 39, 58, 0.4);
	--rgba-primary-5: rgba(0, 39, 58, 0.5);
	--rgba-primary-6: rgba(0, 39, 58, 0.6);
	--rgba-primary-7: rgba(0, 39, 58, 0.7);
	--rgba-primary-8: rgba(0, 39, 58, 0.8);
	--rgba-primary-9: rgba(0, 39, 58, 0.9);
}

[data-primary='color_13'] {
	--primary: #432d29;
	--secondary: #fb7d5b;
	--primary-hover: #231816;
	--primary-dark: black;
	--rgba-primary-1: rgba(67, 45, 41, 0.1);
	--rgba-primary-2: rgba(67, 45, 41, 0.2);
	--rgba-primary-3: rgba(67, 45, 41, 0.3);
	--rgba-primary-4: rgba(67, 45, 41, 0.4);
	--rgba-primary-5: rgba(67, 45, 41, 0.5);
	--rgba-primary-6: rgba(67, 45, 41, 0.6);
	--rgba-primary-7: rgba(67, 45, 41, 0.7);
	--rgba-primary-8: rgba(67, 45, 41, 0.8);
	--rgba-primary-9: rgba(67, 45, 41, 0.9);
}

[data-primary='color_14'] {
	--primary: #4885ed;
	--secondary: #fb7d5b;
	--primary-hover: #1a66e8;
	--primary-dark: #0e3d8e;
	--rgba-primary-1: rgba(72, 133, 237, 0.1);
	--rgba-primary-2: rgba(72, 133, 237, 0.2);
	--rgba-primary-3: rgba(72, 133, 237, 0.3);
	--rgba-primary-4: rgba(72, 133, 237, 0.4);
	--rgba-primary-5: rgba(72, 133, 237, 0.5);
	--rgba-primary-6: rgba(72, 133, 237, 0.6);
	--rgba-primary-7: rgba(72, 133, 237, 0.7);
	--rgba-primary-8: rgba(72, 133, 237, 0.8);
	--rgba-primary-9: rgba(72, 133, 237, 0.9);
}

[data-primary='color_15'] {
	--primary: #4cb32b;
	--secondary: #fb7d5b;
	--primary-hover: #3b8a21;
	--primary-dark: #18380d;
	--rgba-primary-1: rgba(76, 179, 43, 0.1);
	--rgba-primary-2: rgba(76, 179, 43, 0.2);
	--rgba-primary-3: rgba(76, 179, 43, 0.3);
	--rgba-primary-4: rgba(76, 179, 43, 0.4);
	--rgba-primary-5: rgba(76, 179, 43, 0.5);
	--rgba-primary-6: rgba(76, 179, 43, 0.6);
	--rgba-primary-7: rgba(76, 179, 43, 0.7);
	--rgba-primary-8: rgba(76, 179, 43, 0.8);
	--rgba-primary-9: rgba(76, 179, 43, 0.9);
}

[data-typography='opensans'] {
	font-family: 'Open Sans', sans-serif;
}

[data-typography='poppins'] {
	font-family: 'poppins', sans-serif;
}

[data-typography='Nunito'] {
	font-family: 'Nunito Sans', sans-serif;
}

[data-typography='roboto'] {
	font-family: 'Roboto', sans-serif;
}

[data-typography='helvetica'] {
	font-family: 'HelveticaNeue';
}

:root {
	--primary: #4d44b5;
	--secondary: #fb7d5b;
	--primary-hover: #3d3690;
	--primary-dark: #1e1a46;
	--rgba-primary-1: rgba(77, 68, 181, 0.1);
	--rgba-primary-2: rgba(77, 68, 181, 0.2);
	--rgba-primary-3: rgba(77, 68, 181, 0.3);
	--rgba-primary-4: rgba(77, 68, 181, 0.4);
	--rgba-primary-5: rgba(77, 68, 181, 0.5);
	--rgba-primary-6: rgba(77, 68, 181, 0.6);
	--rgba-primary-7: rgba(77, 68, 181, 0.7);
	--rgba-primary-8: rgba(77, 68, 181, 0.8);
	--rgba-primary-9: rgba(77, 68, 181, 0.9);
	--rgba-secondary-1: rgba(251, 125, 91, 0.1);
	--rgba-secondary-2: rgba(251, 125, 91, 0.2);
	--rgba-secondary-3: rgba(251, 125, 91, 0.3);
	--rgba-secondary-4: rgba(251, 125, 91, 0.4);
	--rgba-secondary-5: rgba(251, 125, 91, 0.5);
	--rgba-secondary-6: rgba(251, 125, 91, 0.6);
	--rgba-secondary-7: rgba(251, 125, 91, 0.7);
	--rgba-secondary-8: rgba(251, 125, 91, 0.8);
	--rgba-secondary-9: rgba(251, 125, 91, 0.9);
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--title: #303972;
}

[data-theme-version='transparent'] {
	background-repeat: no-repeat;
	background-attachment: fixed;
	background-size: cover;
	background-position: center;
	position: relative;
	color: #fff;
}
[data-theme-version='transparent'] h1,
[data-theme-version='transparent'] .h1,
[data-theme-version='transparent'] h2,
[data-theme-version='transparent'] .h2,
[data-theme-version='transparent'] h3,
[data-theme-version='transparent'] .h3,
[data-theme-version='transparent'] h4,
[data-theme-version='transparent'] .h4,
[data-theme-version='transparent'] h5,
[data-theme-version='transparent'] .h5,
[data-theme-version='transparent'] h6,
[data-theme-version='transparent'] .h6 {
	color: #fff !important;
}
[data-theme-version='transparent'] a.link {
	color: #ddd;
}
[data-theme-version='transparent'] a.link:focus,
[data-theme-version='transparent'] a.link:hover {
	color: #00ada3;
}
[data-theme-version='transparent'] a {
	color: #fff;
}
[data-theme-version='transparent'] a:hover {
	color: #7e8dbf;
}
[data-theme-version='transparent'] .border-right {
	border-right: 1px solid rgba(255, 255, 255, 0.1) !important;
}
[data-theme-version='transparent'] .border-left {
	border-left: 1px solid rgba(255, 255, 255, 0.1) !important;
}
[data-theme-version='transparent'] .border-top {
	border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
}
[data-theme-version='transparent'] .border-bottom {
	border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}
[data-theme-version='transparent'] .border {
	border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='transparent'] .dropdown-menu {
	background-color: #272738;
}

[data-theme-version='transparent'] .dropdown-item:hover,
[data-theme-version='transparent'] .dropdown-item:focus {
	background-color: #202020;
	color: #fff;
}

[data-theme-version='transparent'] .form-control {
	background-color: #202020;
	border-color: rgba(255, 255, 255, 0.1);
	color: #fff;
}

[data-theme-version='transparent'] .card {
	background-color: rgba(0, 0, 0, 0.15);
}

[data-theme-version='transparent'] .header {
	background-color: rgba(0, 0, 0, 0.15);
}

[data-theme-version='transparent'] .header-left input {
	border-color: rgba(255, 255, 255, 0.1);
	color: #fff;
}
[data-theme-version='transparent'] .header-left input:focus {
	box-shadow: none;
	border-color: var(--primary);
}
[data-theme-version='transparent'] .header-left input::placeholder {
	color: #fff;
}

[data-theme-version='transparent'] .header-right .dropdown .nav-link:hover {
	color: #fff;
}

[data-theme-version='transparent'] .header-right .notification_dropdown .dropdown-item a {
	color: #fff;
}

[data-theme-version='transparent'] .nav-header,
[data-theme-version='transparent'] .nav-control {
	background-color: rgba(0, 0, 0, 0.15) !important;
}

[data-theme-version='transparent'] .nav-control {
	color: #fff;
}

[data-theme-version='transparent'] .brand-logo {
	color: #fff;
}
[data-theme-version='transparent'] .brand-logo:hover {
	color: #fff;
}

[data-theme-version='transparent'] .nav-header,
[data-theme-version='transparent'] .nav-control {
	background-color: rgba(0, 0, 0, 0.15) !important;
}

[data-theme-version='transparent'] .nav-control {
	color: #fff;
}

[data-theme-version='transparent'] .brand-logo {
	color: #fff;
}
[data-theme-version='transparent'] .brand-logo:hover {
	color: #fff;
}

[data-theme-version='transparent'] .dlabnav {
	background-color: rgba(0, 0, 0, 0.15) !important;
}
[data-theme-version='transparent'] .dlabnav .metismenu > li > a {
	color: rgba(0, 0, 0, 0.15);
}
[data-theme-version='transparent'] .dlabnav .metismenu > li:hover > a,
[data-theme-version='transparent'] .dlabnav .metismenu > li:focus > a,
[data-theme-version='transparent'] .dlabnav .metismenu > li.mm-active > a {
	background-color: rgba(0, 0, 0, 0.15) !important;
	color: #fff;
}
[data-theme-version='transparent'] .dlabnav .metismenu > li:hover > a::after,
[data-theme-version='transparent'] .dlabnav .metismenu > li:focus > a::after,
[data-theme-version='transparent'] .dlabnav .metismenu > li.mm-active > a::after {
	border-color: transparent transparent #fff transparent;
}
[data-theme-version='transparent'] .dlabnav .metismenu > li.mm-active ul ul {
	background-color: transparent;
}
[data-theme-version='transparent'] .dlabnav .metismenu ul {
	background-color: rgba(0, 0, 0, 0.15);
}
[data-theme-version='transparent'] .dlabnav .metismenu ul a:hover,
[data-theme-version='transparent'] .dlabnav .metismenu ul a:focus,
[data-theme-version='transparent'] .dlabnav .metismenu ul a.mm-active {
	color: #fff;
}
[data-theme-version='transparent'] .dlabnav .metismenu a {
	color: rgba(0, 0, 0, 0.15);
}
[data-theme-version='transparent'] .dlabnav .metismenu ul {
	background-color: rgba(0, 0, 0, 0.15) !important;
}
[data-theme-version='transparent'] .dlabnav .metismenu .has-arrow:after {
	border-color: transparent transparent rgba(0, 0, 0, 0.15) transparent;
}

:root {
	--primary: #4d44b5;
	--secondary: #fb7d5b;
	--primary-hover: #3d3690;
	--primary-dark: #1e1a46;
	--rgba-primary-1: rgba(77, 68, 181, 0.1);
	--rgba-primary-2: rgba(77, 68, 181, 0.2);
	--rgba-primary-3: rgba(77, 68, 181, 0.3);
	--rgba-primary-4: rgba(77, 68, 181, 0.4);
	--rgba-primary-5: rgba(77, 68, 181, 0.5);
	--rgba-primary-6: rgba(77, 68, 181, 0.6);
	--rgba-primary-7: rgba(77, 68, 181, 0.7);
	--rgba-primary-8: rgba(77, 68, 181, 0.8);
	--rgba-primary-9: rgba(77, 68, 181, 0.9);
	--rgba-secondary-1: rgba(251, 125, 91, 0.1);
	--rgba-secondary-2: rgba(251, 125, 91, 0.2);
	--rgba-secondary-3: rgba(251, 125, 91, 0.3);
	--rgba-secondary-4: rgba(251, 125, 91, 0.4);
	--rgba-secondary-5: rgba(251, 125, 91, 0.5);
	--rgba-secondary-6: rgba(251, 125, 91, 0.6);
	--rgba-secondary-7: rgba(251, 125, 91, 0.7);
	--rgba-secondary-8: rgba(251, 125, 91, 0.8);
	--rgba-secondary-9: rgba(251, 125, 91, 0.9);
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--title: #303972;
}

[data-theme-version='dark'] {
	background: #202020;
	color: rgba(255, 255, 255, 0.6);
	--nav-headbg: #272738;
	--sidebar-bg: #202020;
	--headerbg: #272738;
}
[data-theme-version='dark'] h1,
[data-theme-version='dark'] .h1,
[data-theme-version='dark'] h2,
[data-theme-version='dark'] .h2,
[data-theme-version='dark'] h3,
[data-theme-version='dark'] .h3,
[data-theme-version='dark'] h4,
[data-theme-version='dark'] .h4,
[data-theme-version='dark'] h5,
[data-theme-version='dark'] .h5,
[data-theme-version='dark'] h6,
[data-theme-version='dark'] .h6 {
	color: #fff !important;
}
[data-theme-version='dark'] a.link {
	color: #ddd;
}
[data-theme-version='dark'] a.link:focus,
[data-theme-version='dark'] a.link:hover {
	color: #00ada3;
}
[data-theme-version='dark'] a:hover {
	color: #fff;
}
[data-theme-version='dark'] .border-right {
	border-right: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;
}
[data-theme-version='dark'] .border-left {
	border-left: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;
}
[data-theme-version='dark'] .border-top {
	border-top: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;
}
[data-theme-version='dark'] .border-bottom {
	border-bottom: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;
}
[data-theme-version='dark'] .border {
	border: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .card {
	background-color: #272738;
	box-shadow: none;
}

[data-theme-version='dark'] .dropdown-menu {
	background-color: #272738;
	box-shadow: 0rem 0rem 0rem 0.0625rem rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .dropdown-menu .dropdown-item {
	color: #777777;
}
[data-theme-version='dark'] .dropdown-menu .dropdown-item.selected,
[data-theme-version='dark'] .dropdown-menu .dropdown-item.selected.active,
[data-theme-version='dark'] .dropdown-menu .dropdown-item.active,
[data-theme-version='dark'] .dropdown-menu .dropdown-item:hover,
[data-theme-version='dark'] .dropdown-menu .dropdown-item:focus {
	background-color: #272738;
	color: #fff;
}

[data-theme-version='dark'] a {
	color: #fff;
}

[data-theme-version='dark'] .btn-link g [fill] {
	fill: #fff;
}

[data-theme-version='dark'] .btn-light:active,
[data-theme-version='dark'] .btn-light:focus,
[data-theme-version='dark'] .btn-light:hover {
	color: #000;
}

[data-theme-version='dark'] .form-control {
	background-color: #202020;
	border-color: rgba(255, 255, 255, 0.1);
	color: #fff;
}

[data-theme-version='dark'] .modal-content {
	background: #272738;
}

[data-theme-version='dark'] .modal-footer,
[data-theme-version='dark'] .modal-header {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .close {
	font-weight: 400;
	color: #fff;
	text-shadow: none;
}
[data-theme-version='dark'] .close:hover {
	color: #fff;
}

[data-theme-version='dark'] .star-rating .product-review,
[data-theme-version='dark'] .new-arrival-content .item {
	color: #fff;
}

[data-theme-version='dark'] .custom-dropdown .dropdown-menu {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .widget-stat .media > span {
	background: rgba(255, 255, 255, 0.1);
	border-color: rgba(255, 255, 255, 0.1);
	color: #fff;
}

[data-theme-version='dark'] .plus-minus-input .custom-btn {
	background: #202020;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dropdown-divider,
[data-theme-version='dark'] .size-filter ul li {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .custom-select {
	border-color: rgba(255, 255, 255, 0.1);
	color: #7e8dbf;
	background: #202020;
}

[data-theme-version='dark'] .nav-tabs {
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .mail-list .list-group-item.active i {
	color: #fff;
}

[data-theme-version='dark'] hr {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .grid-col {
	background: #202020;
}

[data-theme-version='dark'] .noUi-target {
	border-color: rgba(255, 255, 255, 0.1);
	border-radius: 0.5rem;
	box-shadow: none;
}
[data-theme-version='dark'] .noUi-target .noUi-connects {
	background: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .noUi-marker-large,
[data-theme-version='dark'] .noUi-marker {
	background: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .input-group-text {
	background: #272738;
	color: #fff;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .note-editor.note-frame {
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .note-editor.note-frame .btn {
	color: #fff;
}
[data-theme-version='dark'] .note-editor.note-frame .note-editing-area .note-editable {
	color: #fff;
}

[data-theme-version='dark'] .widget-media .timeline .timeline-panel {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .notification_dropdown .dropdown-menu-right .all-notification {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] #user-activity .nav-tabs .nav-link {
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] #user-activity .nav-tabs .nav-link.active {
	background: #202020;
	color: #fff;
}

[data-theme-version='dark'] .list-group-item-action {
	color: #a098ae;
}

[data-theme-version='dark'] .list-group-item-action:focus,
[data-theme-version='dark'] .list-group-item-action:hover,
[data-theme-version='dark'] .list-group-item-action:focus {
	background-color: #202020;
	border-color: #202020;
}

[data-theme-version='dark'] .list-group-item.active {
	color: #fff;
	border-color: var(--primary);
}
[data-theme-version='dark'] .list-group-item.active:focus,
[data-theme-version='dark'] .list-group-item.active:hover,
[data-theme-version='dark'] .list-group-item.active:focus {
	background-color: var(--primary);
	border-color: var(--primary);
	color: #fff;
}

[data-theme-version='dark'] .swal2-popup {
	background: #272738;
}

[data-theme-version='dark'] .form-head .btn-outline-primary {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .form-head .btn-outline-primary:hover {
	border-color: var(--primary);
}

[data-theme-version='dark'] .review-tab.nav-pills li a.nav-link.active {
	background: transparent;
}

[data-theme-version='dark'] .new-arrival-content h4 a,
[data-theme-version='dark'] .new-arrival-content .h4 a {
	color: #fff;
}

[data-theme-version='dark'] .text-black {
	color: #fff !important;
}

[data-theme-version='dark'] .abilities-chart .ct-chart .ct-label {
	fill: #fff;
}

[data-theme-version='dark'] .morris_chart_height text tspan {
	fill: #fff;
}

[data-theme-version='dark'] .btn-link {
	color: #fff;
}
[data-theme-version='dark'] .btn-link svg path {
	stroke: #fff;
}

[data-theme-version='dark'] .order-bg {
	background: #202020;
}

[data-theme-version='dark'] .detault-daterange {
	background: #202020;
	color: #fff;
}
[data-theme-version='dark'] .detault-daterange .input-group-text {
	background: #272738;
	border: 0;
}

[data-theme-version='dark'] .dataTablesCard {
	background-color: #272738;
}

[data-theme-version='dark'] .compose-content .dropzone {
	background: #202020 !important;
}
[data-theme-version='dark'] .compose-content .dropzone .dlab-message .dlab-button {
	color: #fff;
}

[data-theme-version='dark'] .daterangepicker {
	background: #202020;
	border-color: var(--primary);
}
[data-theme-version='dark'] .daterangepicker .calendar-table {
	border-color: var(--primary);
	background: #202020;
}
[data-theme-version='dark'] .daterangepicker .calendar-table .table-condensed td:hover {
	background-color: var(--primary);
	color: #fff;
}
[data-theme-version='dark'] .daterangepicker:after {
	border-bottom: 0.375rem solid #202020;
}

[data-theme-version='dark'] .daterangepicker select.hourselect,
[data-theme-version='dark'] .daterangepicker select.minuteselect,
[data-theme-version='dark'] .daterangepicker select.secondselect,
[data-theme-version='dark'] .daterangepicker select.ampmselect {
	background: #202020;
	border: 0.0625rem solid rgba(255, 255, 255, 0.1);
	color: #fff;
}

[data-theme-version='dark'] .daterangepicker td.off,
[data-theme-version='dark'] .daterangepicker td.off.in-range,
[data-theme-version='dark'] .daterangepicker td.off.start-date,
[data-theme-version='dark'] .daterangepicker td.off.end-date {
	background-color: #272738;
}
[data-theme-version='dark'] .daterangepicker td.off:hover,
[data-theme-version='dark'] .daterangepicker td.off.in-range:hover,
[data-theme-version='dark'] .daterangepicker td.off.start-date:hover,
[data-theme-version='dark'] .daterangepicker td.off.end-date:hover {
	background-color: var(--primary);
	color: #fff;
}

[data-theme-version='dark'] .round .checkmark {
	background-color: #202020;
}

[data-theme-version='dark'] .round:hover input ~ .checkmark {
	background-color: #202020;
}

[data-theme-version='dark'] .round span {
	color: #fff;
}

[data-theme-version='dark'] .app-fullcalendar .fc-button {
	background-color: #202020;
	border-color: var(--primary);
	color: #fff;
	text-shadow: none;
}
[data-theme-version='dark'] .app-fullcalendar .fc-button:hover,
[data-theme-version='dark'] .app-fullcalendar .fc-button.fc-stat-hover {
	background-color: var(--primary);
}

[data-theme-version='dark'] .swal2-popup .swal2-styled:focus {
	outline: 0;
	box-shadow: 0 0 0 0.125rem rgba(255, 255, 255, 0.1), 0 0 0 0.25rem var(--rgba-primary-1);
}

[data-theme-version='dark'] .dd-handle {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #272738 !important;
}

[data-theme-version='dark'] .header-right .notification_dropdown .nav-link {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .nav-tabs .nav-link:hover,
[data-theme-version='dark'] .nav-tabs .nav-link.active {
	border-color: transparent;
	background: transparent;
	color: white !important;
}

[data-theme-version='dark'] .clockpicker-popover .popover-content {
	background-color: #272738;
}

[data-theme-version='dark'] .clockpicker-plate {
	background-color: #202020;
}

[data-theme-version='dark'] .clockpicker-popover .popover-title {
	background-color: #202020;
	color: #fff;
}

[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link span {
	background-color: #202020;
}

[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link:after {
	background: #202020;
}

[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.active:after,
[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.done:after {
	background: var(--primary);
}

[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.active span,
[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.done span {
	background: var(--primary);
}

[data-theme-version='dark'] .check-switch .custom-control-label:after,
[data-theme-version='dark'] .check-switch .custom-control-label:before {
	border-color: var(--primary);
}

[data-theme-version='dark'] .fc-unthemed .fc-today {
	background: #202020;
}

[data-theme-version='dark'] .fc-unthemed .fc-divider,
[data-theme-version='dark'] .fc-unthemed .fc-list-heading td,
[data-theme-version='dark'] .fc-unthemed .fc-popover .fc-header {
	background: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .picker__box {
	background: #202020;
}
[data-theme-version='dark'] .picker__box .picker__button--clear,
[data-theme-version='dark'] .picker__box .picker__button--close,
[data-theme-version='dark'] .picker__box .picker__button--today {
	background: #272738;
	color: #fff;
}
[data-theme-version='dark'] .picker__box .picker__button--clear:hover:before,
[data-theme-version='dark'] .picker__box .picker__button--close:hover:before,
[data-theme-version='dark'] .picker__box .picker__button--today:hover:before {
	color: #fff;
}

[data-theme-version='dark'] .picker {
	color: #999;
}

[data-theme-version='dark'] .dtp > .dtp-content {
	background: #202020;
}

[data-theme-version='dark'] .dtp table.dtp-picker-days tr > td > a {
	color: #68686a;
}
[data-theme-version='dark'] .dtp table.dtp-picker-days tr > td > a.selected {
	color: #fff;
}

[data-theme-version='dark'] .order-request tbody tr {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .card-list li {
	color: #fff;
}

[data-theme-version='dark'] .card-bx .change-btn:hover {
	color: var(--primary);
}

[data-theme-version='dark'] .invoice-card.bg-warning {
	background-color: #5b3c1f !important;
}

[data-theme-version='dark'] .invoice-card.bg-success {
	background-color: #2a6729 !important;
}

[data-theme-version='dark'] .invoice-card.bg-info {
	background-color: #4c276a !important;
}

[data-theme-version='dark'] .invoice-card.bg-secondary {
	background-color: #1c3e52 !important;
}

[data-theme-version='dark'] .user-list li {
	border-color: #272738;
}

[data-theme-version='dark'] .toggle-switch {
	color: #fff;
}

[data-theme-version='dark'] .bar-chart .apexcharts-text tspan {
	fill: #969ba0;
}

[data-theme-version='dark'] .bar-chart line {
	stroke: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .accordion.style-1 .accordion-item,
[data-theme-version='dark'] .invoice-list,
[data-theme-version='dark'] .form-check-input[type='checkbox'] {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .accordion.style-1 .accordion-header.collapsed .user-info a,
[data-theme-version='dark'] .accordion.style-1 .accordion-header.collapsed .user-info,
[data-theme-version='dark'] .accordion.style-1 .accordion-header.collapsed > span {
	color: #fff;
}

[data-theme-version='dark'] .ic-card > a {
	background: #25479f;
}
[data-theme-version='dark'] .ic-card > a:first-child {
	border-color: #25479f;
}

[data-theme-version='dark'] .ic-card span {
	color: #fff;
}

[data-theme-version='dark'] table.dataTable thead th,
[data-theme-version='dark'] table.dataTable thead td {
	border-color: #272738 !important;
}

[data-theme-version='dark'] .form-check .form-check-input:checked {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

[data-theme-version='dark'] .dataTables_info {
	color: #fff;
}

[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate span .paginate_button.current,
[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate span .paginate_button:hover {
	background: var(--primary);
	color: #fff !important;
}

[data-theme-version='dark'] .dashboard-select {
	background: #272738;
	color: white !important;
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .dashboard-select .list {
	background: #272738;
}

[data-theme-version='dark'] .dashboard-select .option:hover,
[data-theme-version='dark'] .dashboard-select .option.focus,
[data-theme-version='dark'] .dashboard-select .option.selected.focus {
	background: #202020;
}

[data-theme-version='dark'] .card-tabs.style-1 .nav-tabs {
	background: #272738;
}

[data-theme-version='dark'] .transaction-details {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .description {
	color: #fff;
}

[data-theme-version='dark'] .apexcharts-legend-text {
	color: #fff !important;
}

[data-theme-version='dark'] .area-theme line {
	stroke: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .transaction-details .amount-bx {
	background: #272738;
}
[data-theme-version='dark'] .transaction-details .amount-bx i {
	background: #8d3b0c;
}

[data-theme-version='dark'] .nice-select .option {
	background: #272738;
}

[data-theme-version='dark'] .nice-select .option:hover,
[data-theme-version='dark'] .nice-select .option.focus,
[data-theme-version='dark'] .nice-select .option.selected.focus {
	background: #272738;
}

[data-theme-version='dark'] .card-tabs.style-1 {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .nice-select .list {
	background: #202020;
}

[data-theme-version='dark'] .table-search .input-group .input-group-text {
	background: #272738;
}

[data-theme-version='dark'] .dark-btn svg path {
	stroke: #fff;
}

[data-theme-version='dark'] .bar-chart .apexcharts-legend-text {
	color: #fff !important;
}

[data-theme-version='dark'] .Sales tspan {
	fill: #fff;
}

[data-theme-version='dark'] .timeline-chart rect {
	fill: #202020;
}

[data-theme-version='dark'] .header-info span {
	color: #fff !important;
}

[data-theme-version='dark'] .ck-editor__editable {
	background: #202020 !important;
}

[data-theme-version='dark'] .ck.ck-editor .ck.ck-toolbar {
	background: #272738;
}

[data-theme-version='dark'] .ck.ck-toolbar .ck.ck-toolbar__separator {
	background: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .search-area .form-control {
	background: #202020;
	border: none;
}
[data-theme-version='dark'] .search-area .form-control:hover {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .search-area .input-group-text {
	background: #202020;
	border: none;
}

[data-theme-version='dark'] .chartBarRunning tspan {
	fill: #fff;
}

[data-theme-version='dark'] .chartBarRunning line {
	stroke: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .reservationChart tspan {
	fill: #fff;
}

[data-theme-version='dark'] .reservationChart line {
	stroke: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .table-condensed i:hover {
	background: #272738;
}

[data-theme-version='dark'] .booking-calender thead .picker-switch {
	color: #fff;
}
[data-theme-version='dark'] .booking-calender thead .picker-switch:hover {
	background: #272738;
}

[data-theme-version='dark'] .booking-calender .prev:hover,
[data-theme-version='dark'] .booking-calender .next:hover {
	background: #272738;
}

[data-theme-version='dark'] .dlabnav .header-info2 span {
	color: #fff;
}

[data-theme-version='dark'] .booking-calender tbody tr .day {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .booking-calender thead .dow {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .customer-search .search-area .form-control {
	background: #272738;
}

[data-theme-version='dark'] .customer-search .search-area .input-group-text {
	background: #272738;
}

[data-theme-version='dark'] .paging_simple_numbers.dataTables_paginate {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .primary-icon path {
	stroke: #fff;
}

[data-theme-version='dark'] .pagin {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .nav-header .brand-title .brand-sub-title {
	color: #fff;
}

[data-theme-version='dark'] .dashboard-calendar .fc-daygrid-day-frame.fc-scrollgrid-sync-inner {
	background: #272738;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dashboard-calendar .fc-non-business {
	background: #272738;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dashboard-calendar .fc-daygrid-day-number {
	color: #fff;
}

[data-theme-version='dark'] .event-calend .fc .fc-button-group > .fc-button {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dashboard-calendar .fc-theme-standard td,
[data-theme-version='dark'] .dashboard-calendar .fc-theme-standard th {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dashboard-calendar .fc .fc-daygrid-more-link {
	color: #fff;
}

[data-theme-version='dark'] .fc-theme-standard td,
[data-theme-version='dark'] .fc-theme-standard th {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .fc-theme-standard .fc-scrollgrid.fc-scrollgrid-liquid,
[data-theme-version='dark'] .fc-scrollgrid,
[data-theme-version='dark'] table {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .fc-direction-ltr .fc-daygrid-event.fc-event-end,
[data-theme-version='dark'] .fc-direction-rtl .fc-daygrid-event.fc-event-start {
	background: var(--primary);
}

[data-theme-version='dark'] .dlab-demo-panel .dlab-demo-inner {
	background: #202020;
}

[data-theme-version='dark'] .food-list-row {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .popover-body {
	color: #fff;
}

[data-theme-version='dark'] .swal2-popup .swal2-content {
	color: #fff;
}

[data-theme-version='dark'] .modal-header .close {
	background: none;
}

[data-theme-version='dark'] .timeline-panel .media-body small,
[data-theme-version='dark'] .timeline-panel .media-body .small {
	color: #fff;
}

[data-theme-version='dark'] .chatbox .card-header p {
	color: #fff;
}

[data-theme-version='dark'] .date-ds-btn {
	background: #272738;
	color: white;
}

[data-theme-version='dark'] .food-list-row .media-bx h5 a,
[data-theme-version='dark'] .food-list-row .media-bx .h5 a,
[data-theme-version='dark'] .food-list-row .media-bx .h5 a {
	color: #fff;
}

[data-theme-version='dark'] .staff-bx .card-footer {
	background: #3f4056;
}

[data-theme-version='dark'] .page-titles .breadcrumb .breadcrumb-item + .breadcrumb-item:before {
	color: #fff;
}

[data-theme-version='dark'] .table-striped > tbody > tr:nth-of-type(odd) > * {
	color: #706f6f;
}

[data-theme-version='dark'] .accordion .accordion-item {
	background: transparent;
}

[data-theme-version='dark'] .list-group-item {
	color: #fff;
}

[data-theme-version='dark'] .form-control-plaintext {
	color: #fff;
}

[data-theme-version='dark'] label {
	color: #fff;
}

[data-theme-version='dark'] .form-control.custom-image-select-2 .filter-option-inner-inner {
	color: #fff;
}

[data-theme-version='dark'] .table tbody tr td {
	color: #7e8dbf;
}

[data-theme-version='dark'] .wallet-bar .order-history .price-list .chart-title .text-secondary {
	color: var(--secondary) !important;
}

[data-theme-version='dark'] .apexcharts-text tspan {
	fill: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .apexcharts-xaxis line {
	stroke: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .price-list .card-footer .text-secondary {
	color: var(--primary) !important;
}

[data-theme-version='dark'] .chart-title .text-pink {
	color: #eb62d0 !important;
}

[data-theme-version='dark'] .form-control.custom-image-select-2.style-1 .dropdown-toggle {
	background: rgba(172, 76, 188, 0.1) !important;
}

[data-theme-version='dark'] .form-control.custom-image-select-2 .dropdown-toggle {
	background: var(--rgba-primary-2) !important;
}

[data-theme-version='dark'] .transaction-table .card-body .table-responsive thead th {
	background: #202020;
	color: #fff;
}

[data-theme-version='dark'] .market-chart .text-secondary {
	color: var(--secondary) !important;
}
[data-theme-version='dark'] .market-chart .text-secondary svg path {
	fill: var(--secondary);
}

[data-theme-version='dark'] .chart-title p {
	color: #7e8dbf;
}

[data-theme-version='dark'] .market-coin .coin-search-area .form-control {
	border-color: #272738;
	background: #272738;
}

[data-theme-version='dark'] .market-coin .coin-search-area .input-group-text {
	border-color: #272738;
	background: #272738;
}
[data-theme-version='dark'] .market-coin .coin-search-area .input-group-text svg path {
	fill: #fff;
}

[data-theme-version='dark'] .market-coin .coin-box {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .market-overview .get-report {
	color: var(--primary) !important;
}

[data-theme-version='dark'] .coin-content .guest-calendar {
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .coin-content .guest-calendar span svg path {
	fill: #fff;
}
[data-theme-version='dark'] .coin-content .guest-calendar .reportrange span {
	color: #7e8dbf;
}

[data-theme-version='dark'] .coin-content .default-select {
	border-color: rgba(255, 255, 255, 0.1);
	color: #7e8dbf;
}

[data-theme-version='dark'] .digital-cash .media .media-content p {
	border-color: rgba(255, 255, 255, 0.1);
	color: #7e8dbf;
}

[data-theme-version='dark'] .digital-cash .card-footer .btn {
	color: var(--primary) !important;
}

[data-theme-version='dark'] .form-control.custom-image-select-1 .dropdown-toggle {
	background: #202020 !important;
	color: #fff !important;
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .form-control.custom-image-select-1 .filter-option-inner-inner {
	color: #fff;
}

[data-theme-version='dark'] .coin-warpper .search-area .form-control {
	color: #7e8dbf;
}

[data-theme-version='dark'] .coin-warpper .search-area .input-group-text svg path {
	fill: #fff;
}

[data-theme-version='dark'] .form-wrapper.trade-form .input-group .input-group-text {
	background: #202020;
	color: #7e8dbf;
}

[data-theme-version='dark'] .market-overview .get-report,
[data-theme-version='dark'] .market-preview,
[data-theme-version='dark'] .market-overview .card-header h4,
[data-theme-version='dark'] .market-overview .card-header .h4,
[data-theme-version='dark'] .market-overview .card-header .h4,
[data-theme-version='dark'] .form-wrapper.trade-form .input-group .form-control:focus,
[data-theme-version='dark'] .coin-warpper .nav .nav-item {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .coin-warpper {
	background: #272738;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .coin-warpper .nav .nav-item .nav-link svg path {
	fill: #fff;
}

[data-theme-version='dark'] .daterangepicker .calendar-table .next span,
[data-theme-version='dark'] .daterangepicker .calendar-table .prev span {
	border-color: #fff;
}

[data-theme-version='dark'] .tbl-orders-style .tp-btn svg path {
	stroke: #fff;
}

[data-theme-version='dark'] .customer-search .search-area .input-group-text svg path {
	fill: #fff;
}

[data-theme-version='dark'] .student-tbl tbody tr td span .text-secondary {
	color: #fff !important;
}

[data-theme-version='dark'] .market-preview:hover {
	background: #202020;
}

[data-theme-version='dark'] .bg-ripple-hover thead tr th {
	color: #677686;
}

[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate span .paginate_button {
	color: #7e8dbf !important;
}

[data-theme-version='dark'] .portofolio .my-profile .media .media-img a,
[data-theme-version='dark'] .portofolio .my-profile .portofolio-social li a {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .coin-holding {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .tp-btn svg path {
	stroke: #fff;
}

[data-theme-version='dark'] .copyright strong {
	color: #9fa4a6;
}

[data-theme-version='dark'] .support-box .info a {
	color: #000 !important;
}

[data-theme-version='dark'] .btn-icon-end {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .donut-chart-sale small,
[data-theme-version='dark'] .donut-chart-sale .small,
[data-theme-version='dark'] .donut-chart-sale .small,
[data-theme-version='dark'] .donut-chart-sale .small {
	color: #fff;
}

[data-theme-version='dark'] .border-end {
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .ck.ck-editor__main > .ck-editor__editable {
	background: #202020 !important;
}

[data-theme-version='dark'] .change-btn a:hover {
	color: #000;
}

[data-theme-version='dark'] .dlabnav .main-menu {
	color: #fff;
}

[data-theme-version='dark'] .nav-pills .nav-link.active,
[data-theme-version='dark'] .nav-pills:hover .show > .nav-link {
	background: var(--rgba-secondary-1);
	color: var(--secondary);
}

[data-theme-version='dark'] .toggle-switch .form-check-input:checked:after {
	background: var(--secondary);
}

[data-theme-version='dark'] .nav-pills .nav-link:hover {
	color: var(--secondary);
}

[data-theme-version='dark'] .table.bg-primary-hover th {
	color: var(--secondary);
}

[data-theme-version='dark'] .table.bg-primary-hover tr:hover td,
[data-theme-version='dark'] .table.bg-primary-hover tr:hover th {
	background: var(--secondary);
}

[data-theme-version='dark'] .get-report {
	color: var(--secondary);
}

[data-theme-version='dark'] .btn-close {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

[data-theme-version='dark'] .coin-holding .coin-box-warper a {
	background: #202020;
}

[data-theme-version='dark'] .card .card-box-icon {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .toggle-btn .check {
	background-color: #202020;
}

[data-theme-version='dark'] .toggle-btn .check:after {
	background: #fff;
}

[data-theme-version='dark'] .toggle-btn input:checked ~ .check:after {
	display: block;
}

[data-theme-version='dark'] .toggle-btn input:checked ~ .check {
	background-color: #202020;
}

[data-theme-version='dark'] .toggle-btn.expense .check:after {
	background-color: #fffa6f;
}

[data-theme-version='dark'] .bootstrap-select .btn {
	color: #fff;
}

[data-theme-version='dark'] #wallet-bar {
	background-color: #272738;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .page-titles {
	background: #272738;
}

[data-theme-version='dark'] .tags .tag {
	color: #fff;
	background: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .server-content .progress {
	background-color: transparent;
}

[data-theme-version='dark'] .student .indox a::before {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] #redial circle {
	fill: white;
}

[data-theme-version='dark'] .dashboard-select .bootstrap-select .btn {
	background: #383844;
}

[data-theme-version='dark'] #activity line {
	stroke: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .quick-info {
	background-color: #202020;
	border: 1px solid rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .pagination.no-bg li:not(.page-indicator):not(.active) .page-link {
	background: #202020;
	border-color: transparent;
}

[data-theme-version='dark'] .lastest_trans .trans-table .doller,
[data-theme-version='dark'] .table-pagenation p span,
[data-theme-version='dark'] .email-list .message .hader,
[data-theme-version='dark'] .email-list .message .col-mail-2 .date,
[data-theme-version='dark'] .dz-card .card-footer {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .email-list .message:hover {
	background: #272738;
}

[data-theme-version='dark'] .print svg path {
	fill: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .right-box-padding.border-start {
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .demo-right-inner {
	background-color: #272738;
}

[data-theme-version='dark'] .dzm-tabs {
	background-color: #202020;
}

[data-theme-version='dark'] .notification p {
	color: #000;
}

[data-theme-version='dark'] .Modal-box {
	background-color: #272738;
}

[data-theme-version='dark'] .Modal-box .box3 {
	background-color: #202020;
}

[data-theme-version='dark'] .lastest_trans .trans-table .print,
[data-theme-version='dark'] .lastest_trans .trans-table .btn.tp-btn.btn-primary {
	background-color: #202020;
}

[data-theme-version='dark'] .lastest_trans .trans-table .btn.tp-btn.btn-primary {
	background-color: #202020;
}
[data-theme-version='dark'] .lastest_trans .trans-table .btn.tp-btn.btn-primary svg circle {
	fill: #fff;
}

[data-theme-version='dark'] .lastest_trans .trans-table:hover {
	background-color: #202020;
}

[data-theme-version='dark'] .previews-info:hover {
	background-color: #202020;
}

[data-theme-version='dark'] #activity1 line {
	stroke: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button.previous.disabled,
[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button.next.disabled {
	color: #fff !important;
}

[data-theme-version='dark'] .plus-bx a {
	background: #272738;
}

[data-theme-version='dark'] .kanbanimg li span,
[data-theme-version='dark'] .kanbanimg img {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .drive,
[data-theme-version='dark'] .file-header,
[data-theme-version='dark'] .folder-structure li,
[data-theme-version='dark'] .file-drive,
[data-theme-version='dark'] .input-group.search-area,
[data-theme-version='dark'] .user-photo img,
[data-theme-version='dark'] .messages .student,
[data-theme-version='dark'] .fc .fc-button-group > .fc-button,
[data-theme-version='dark'] .fc-daygrid-dot-event,
[data-theme-version='dark'] .box-2 .flow,
[data-theme-version='dark'] .type-massage,
[data-theme-version='dark'] .chat-box-area .media .message-received .dz-media,
[data-theme-version='dark'] .chat-left-area .chat-sidebar,
[data-theme-version='dark'] .email-right-box .table-pagenation,
[data-theme-version='dark'] .email-list .message {
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .timeline-active li:before {
	background: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .selling .form_exchange .input_exchange .input-select {
	background-color: #272738;
	border-color: rgba(255, 255, 255, 0.1);
	color: #fff;
}

[data-theme-version='dark'] .hamburger svg rect {
	fill: #fff;
}

[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a {
	color: #fff !important;
}

[data-theme-version='dark'] .file_area .table-pagenation {
	background-color: #202020;
}

[data-theme-version='dark'] .email-list {
	background: #202020;
}

[data-theme-version='dark'] .email-list .message .col-mail-2 .subject {
	color: #fff;
}

[data-theme-version='dark'] .email-right-box .table-pagenation,
[data-theme-version='dark'] .email-right-box .pagination {
	background-color: #272738;
}

[data-theme-version='dark'] .email-left-box .mail-list a {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .messages .input-group.search-area input.form-control,
[data-theme-version='dark'] .messages .input-group.search-area .input-group-text {
	background-color: #202020;
}

[data-theme-version='dark'] .dz-info svg path {
	fill: #fff;
}

[data-theme-version='dark'] .message-box,
[data-theme-version='dark'] .type-massage,
[data-theme-version='dark'] .chat-box-area .media {
	background: #272738;
	color: white;
}

[data-theme-version='dark'] .chat-tabs .chat-bx:after,
[data-theme-version='dark'] .message-box .input-group.search-area input.form-control,
[data-theme-version='dark'] .message-box .input-group.search-area .input-group-text {
	background: #202020;
}

[data-theme-version='dark'] .search-coundry {
	background-color: #272738;
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .search-coundry .bootstrap-select .btn {
	background: #272738 !important;
	color: #fff;
}

[data-theme-version='dark'] .header.is-fixed {
	background: var(--headerbg);
}

[data-theme-version='dark'] .datepicker.datepicker-dropdown th.datepicker-switch {
	color: rgba(255, 255, 255, 0.6);
}
[data-theme-version='dark'] .datepicker.datepicker-dropdown th.datepicker-switch:hover {
	color: #000;
}

[data-theme-version='dark'] .datepicker.datepicker-dropdown {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .datepicker.datepicker-dropdown .datepicker-days .table-condensed td.day {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .notification_dropdown .dropdown-menu-end .all-notification {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .header-profile2 .dropdown-menu a span {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .profile-card .card-header,
[data-theme-version='dark'] .profile-card {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .profile-form .form-label {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .author-profile .info-list li,
[data-theme-version='dark'] .profile-card .card-footer,
[data-theme-version='dark'] .author-profile .upload-link {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .author-profile .info-list li a,
[data-theme-version='dark'] .author-profile .author-info span,
[data-theme-version='dark'] .author-profile .info-list li span {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .author-profile .card-footer .form-control {
	border-color: rgba(255, 255, 255, 0.1);
	background: #202020 !important;
}

[data-theme-version='dark'] .header-profile2 .dropdown-menu .ai-icon:hover {
	background: #202020;
}

[data-theme-version='dark'] .wallet-bar .closed-icon {
	color: #fff;
}

[data-theme-version='dark'] .select2-container--default .select2-selection--multiple .select2-selection__choice,
[data-theme-version='dark'] .select2-container--classic .select2-selection--multiple .select2-selection__choice {
	background-color: #272738;
	border-color: #272738;
}

[data-theme-version='dark'] mark,
[data-theme-version='dark'] .mark,
[data-theme-version='dark'] .mark,
[data-theme-version='dark'] .select2-container--classic .select2-search--inline .select2-search__field {
	background-color: #202020;
	color: #fff;
}

[data-theme-version='dark'] .select2-container--default .select2-search--inline .select2-search__field {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .select2-container--default .select2-results__option[aria-selected='true'] {
	background-color: #202020;
}

[data-theme-version='dark'] .trans-info .icon {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .legendLabel {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .statistic-content {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] p {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .header-profile2 span {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .page-titles .datepicker.datepicker-dropdown th.prev:hover {
	color: #fff !important;
}

[data-theme-version='dark'] .compose-content .dropzone {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] #alert-link a {
	color: #768783;
}

[data-theme-version='dark'] #message-alert p {
	color: #666666;
}

[data-theme-version='dark'] #AlertLeftIcon h5,
[data-theme-version='dark'] #AlertLeftIcon .h5 {
	color: #2a353a !important;
}

[data-theme-version='dark'] #AlertLeftIcon p {
	color: #666666;
}

[data-theme-version='dark'] .header.is-fixed {
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .sidebar-right-inner .bootstrap-select .btn {
	background: transparent !important;
	color: #2a353a;
	border-color: #eeeeee !important;
}

[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu {
	background-color: #fff;
}
[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item {
	color: #777777;
}
[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item.selected,
[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item.selected.active,
[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item.active,
[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item:hover,
[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item:focus {
	background-color: var(--rgba-primary-1);
	color: #2a353a;
}

[data-theme-version='dark'] .type_msg .form-control {
	background-color: #272738;
	box-shadow: none;
}

[data-theme-version='dark'] .email-left-box {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .alert .btn-close {
	background-image: none !important;
}

[data-theme-version='dark'] #main-wrapper {
	background-color: #202020;
}

[data-theme-version='dark'] .prot-blog .fill a:hover {
	color: black;
}

[data-theme-version='dark'] .table-striped > tbody > tr:nth-of-type(odd) > * {
	background: #1e1e25;
	color: white !important;
}

[data-theme-version='dark'] .dlabnav {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .kanban-user .users li span,
[data-theme-version='dark'] .kanban-user .users li img {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .plus-bx a svg path {
	fill: #fff;
}

[data-theme-version='dark'] .page-title {
	background-color: #272738;
}

[data-theme-version='dark'] .chat-mid-area.bg-white {
	background-color: #272738 !important;
}

[data-theme-version='dark'] .message-box {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .message-received p {
	background-color: #202020 !important;
	color: #fff !important;
}

[data-theme-version='dark'] .input-group.user-search-area .input-group-text {
	background-color: #202020;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .input-group.user-search-area .form-control {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .datepicker-days .table-condensed td.day {
	color: #fff;
}

[data-theme-version='dark'] .datepicker-days .table-condensed thead th.picker-switch {
	color: #fff;
}

[data-theme-version='dark'] .datepicker-days .table-condensed thead th.prev,
[data-theme-version='dark'] .datepicker-days .table-condensed thead th.picker-switch,
[data-theme-version='dark'] .datepicker-days .table-condensed thead th.next {
	color: #fff;
}

@keyframes blinking {
	0% {
		background-color: var(--primary);
	}
	100% {
		background-color: transparent;
	}
}

[data-theme-version='dark'] input-group.search-area {
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .doller {
	color: #fff;
}

[data-theme-version='dark'] .apexcharts-tooltip.apexcharts-theme-light {
	background-color: rgba(255, 255, 255, 0.96);
	color: #000;
}

[data-theme-version='dark'] .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .all .show .card-header {
	background-color: rgba(255, 255, 255, 0.1) !important;
	border-radius: 0.375rem !important;
}

[data-theme-version='dark'] .all .show .nav-link {
	width: 2.5rem;
	min-width: 2.5rem;
	height: 2.5rem;
	margin: 5px;
	background-color: #272738 !important;
}

[data-theme-version='dark'] .note-text {
	color: #000;
}

[data-theme-version='dark'] .timeline-active.style-1 .timeline-list:before {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .authincation {
	background-color: #202020;
}

[data-theme-version='dark'] .authincation-content.style-2 .form-control {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .label-color,
[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed td.day,
[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.prev,
[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.picker-switch,
[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.next {
	color: #fff;
}

[data-theme-version='dark'] .authincation {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) !important;
}

[data-theme-version='dark'] .table-responsive .table-striped th {
	background-color: var(--rgba-primary-1);
	color: #fff;
}

[data-theme-version='dark'] .dz-card .card-body.code-area,
[data-theme-version='dark'] .demo-view .code-area {
	background-color: #272738;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dz-calender .react-datepicker__day-name,
[data-theme-version='dark'] .dz-calender .react-datepicker__day,
[data-theme-version='dark'] .dz-calender .react-datepicker__time-name {
	color: #fff;
}

[data-theme-version='dark'] .dz-calender .react-datepicker__current-month {
	color: #fff;
}

[data-theme-version='dark'] .dz-calender .react-datepicker__navigation {
	background: none;
}

[data-theme-version='dark'] .dz-calender .react-datepicker__navigation-icon:before {
	border-color: #fff;
}

[data-theme-version='dark'] #overiewChart line {
	stroke: #444;
}

[data-theme-version='dark'][data-layout='vertical'][data-sidebar-position='fixed'] .header {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'][data-layout='vertical'][data-sidebar-position='fixed'] .brand-sub-title {
	color: #fff;
}

[data-theme-version='dark'] .header {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .header-left .dashboard_bar {
	color: #fff;
}

[data-theme-version='dark'] .header-left .search-area .form-control {
	background: #272738;
}

[data-theme-version='dark'] .header-left .search-area .input-group-text {
	border: 0;
	background: #272738;
}
[data-theme-version='dark'] .header-left .search-area .input-group-text a {
	color: #4f7086;
}

[data-theme-version='dark'] .header-left .input-group.search-area {
	border-color: #58586a;
}

[data-theme-version='dark'] .header-right .notification_dropdown .nav-link {
	/* background: \$d-bg!important; */
}
[data-theme-version='dark'] .header-right .notification_dropdown .nav-link .badge {
	border-color: #272738;
}

[data-theme-version='dark'] .header-right .dropdown .nav-link {
	color: #fff;
	background-color: #202020 !important;
	border-color: rgba(255, 255, 255, 0.1) !important;
}
[data-theme-version='dark'] .header-right .dropdown .nav-link:hover {
	color: #fff;
}

[data-theme-version='dark'] .header-right .dropdown.header-profile2 .nav-link {
	background-color: transparent !important;
}

[data-theme-version='dark'] .nav-header .hamburger .line {
	background: #fff !important;
}

[data-theme-version='dark'] .menu-toggle .nav-header .nav-control .hamburger .line {
	background-color: #fff !important;
}

.change-btn a {
	color: #000;
}

[data-theme-version='dark'] .nav-header {
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .nav-header .brand-title svg path {
	fill: #fff;
}

[data-theme-version='dark'] .nav-control {
	color: #fff;
}

[data-theme-version='dark'] .brand-logo {
	color: #fff;
}
[data-theme-version='dark'] .brand-logo:hover {
	color: #fff;
}

[data-theme-version='dark'] .svg-title-path {
	fill: #fff;
}

[data-theme-version='dark'] .nav-header {
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .nav-header .brand-title svg path {
	fill: #fff;
}

[data-theme-version='dark'] .nav-control {
	color: #fff;
}

[data-theme-version='dark'] .brand-logo {
	color: #fff;
}
[data-theme-version='dark'] .brand-logo:hover {
	color: #fff;
}

[data-theme-version='dark'] .svg-title-path {
	fill: #fff;
}

[data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li > ul {
	background-color: #272738;
}

[data-theme-version='dark'] .fixed-content-box {
	background-color: #272738;
}
[data-theme-version='dark'] .fixed-content-box .head-name {
	background: #272738;
	color: #fff;
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .fixed-content-box + .header + .dlabnav {
	background-color: #202020;
}

[data-theme-version='dark'][data-layout='vertical'][data-sidebar-position='fixed'] .dlabnav {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a {
	background: transparent;
}
[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a i,
[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a i {
	color: var(--primary);
	background: var(--rgba-primary-1);
}

[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li a > i {
	color: rgba(255, 255, 255, 0.3);
}

[data-theme-version='dark'] .ps__thumb-y {
	background-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a {
	color: #fff !important;
}

[data-theme-version='dark'] .dlabnav .header-profile > a.nav-link {
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .dlabnav .header-profile > a.nav-link .header-info span {
	color: #fff;
}

[data-theme-version='dark'] .dlabnav .metismenu > li > a {
	color: #b3b3b3;
}

[data-theme-version='dark'] .dlabnav .metismenu > li:hover > a,
[data-theme-version='dark'] .dlabnav .metismenu > li:focus > a,
[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a {
	color: #fff;
	background: var(--primary) !important;
}
[data-theme-version='dark'] .dlabnav .metismenu > li:hover > a::after,
[data-theme-version='dark'] .dlabnav .metismenu > li:focus > a::after,
[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a::after {
	border-left: 0.2125rem solid #fff;
	border-top: 0.2125rem solid #fff;
	border-bottom: 0.2125rem solid transparent;
	border-right: 0.2125rem solid transparent;
}
[data-theme-version='dark'] .dlabnav .metismenu > li:hover > a i,
[data-theme-version='dark'] .dlabnav .metismenu > li:focus > a i,
[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}

[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active ul ul {
	background-color: transparent;
}

[data-theme-version='dark'] .dlabnav .metismenu ul:after {
	background-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dlabnav .metismenu ul a:hover,
[data-theme-version='dark'] .dlabnav .metismenu ul a:focus,
[data-theme-version='dark'] .dlabnav .metismenu ul a.mm-active {
	color: #fff !important;
}

[data-theme-version='dark'] .dlabnav .metismenu ul a:before {
	background-color: #fff;
}

[data-theme-version='dark'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.6) !important;
}

[data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after {
	border-top: 0.2125rem solid #b3b3b3;
	border-left: 0.2125rem solid #b3b3b3;
	border-bottom: 0.2125rem solid transparent;
	border-right: 0.2125rem solid transparent;
}

[data-theme-version='dark'] .sidebar-right .card-tabs .nav-tabs {
	border-color: var(--rgba-primary-1) !important;
}
[data-theme-version='dark'] .sidebar-right .card-tabs .nav-tabs .nav-item .nav-link {
	color: #000 !important;
}

[data-theme-version='dark'] .sidebar-right .form-control {
	background: #fff;
	color: #000;
	border-color: #eeeeee;
}

[data-theme-version='dark'] .sidebar-right .default-select .list {
	background: #fff;
}
[data-theme-version='dark'] .sidebar-right .default-select .list .option.selected,
[data-theme-version='dark'] .sidebar-right .default-select .list .option.focus,
[data-theme-version='dark'] .sidebar-right .default-select .list .option:hover {
	background: rgba(0, 0, 0, 0.05) !important;
}

[data-theme-version='dark'] .sidebar-right .sidebar-right-inner > h4,
[data-theme-version='dark'] .sidebar-right .sidebar-right-inner > .h4 {
	color: #000 !important;
}

[data-theme-version='dark'] .sidebar-right .nice-select .option {
	background: #fff;
}

[data-theme-version='dark'] .footer {
	background-color: #272738;
}
[data-theme-version='dark'] .footer .copyright {
	background-color: transparent;
}
[data-theme-version='dark'] .footer .copyright p {
	color: #fff;
}

pre {
	display: block;
	margin-top: 0;
	margin-bottom: 1rem;
	overflow: auto;
	font-size: 0.875em;
	tab-size: 2;
}
pre code.hljs {
	display: block;
	overflow-x: auto;
	color: #fff;
	padding: 0;
}

.hljs-tag .hljs-attr,
.hljs-tag .hljs-name {
	color: var(--primary);
}

.hljs-punctuation,
.hljs-tag {
	color: var(--secondary);
}

.hljs-deletion,
.hljs-number,
.hljs-quote,
.hljs-selector-class,
.hljs-selector-id,
.hljs-string,
.hljs-template-tag,
.hljs-type {
	color: #ffa8a8;
}

/* =============
   Calendar
============= */
.app-fullcalender button {
	border-radius: 0rem;
	color: #303972;
}

.app-fullcalender td {
	border-color: #f2f2f2;
}

.calendar {
	float: left;
	margin-bottom: 0;
}

.fc-view {
	margin-top: 1.875rem;
}

.fc-toolbar {
	margin-bottom: 0.3125rem;
	margin-top: 0.9375rem;
}
.fc-toolbar .fc-left {
	display: flex;
	justify-content: space-between;
	margin-bottom: 0.625rem;
	float: none;
}
.fc-toolbar .fc-right {
	display: flex;
	justify-content: center;
	float: none;
	margin-bottom: 0.3125rem;
}
.fc-toolbar .fc-center {
	display: flex;
	justify-content: center;
}
.fc-toolbar .fc-center * {
	float: none;
}

.fc-toolbar h2,
.fc-toolbar .h2 {
	font-size: 1rem;
	font-weight: 600;
	line-height: 1.875rem;
	text-transform: uppercase;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active,
.fc-toolbar .ui-state-hover,
.fc-toolbar button:focus,
.fc-toolbar button:hover {
	z-index: 0;
	box-shadow: none;
}

.fc-widget-header {
	border: 0.0625rem solid #f2f2f2;
	border-bottom: 0 !important;
}

.fc th.fc-widget-header {
	background: #f2f2f2 !important;
	font-size: 0.875rem;
	line-height: 1.25rem;
	padding: 0.625rem 0;
	text-transform: uppercase;
}

.fc-button {
	border: 0.0625rem solid #f2f2f2;
	text-transform: capitalize;
}
.fc-button.active {
	box-shadow: none !important;
}

.fc-text-arrow {
	font-family: inherit;
	font-size: 1rem;
}

.fc-event,
.external-event {
	border-radius: 0.125rem;
	border: none;
	cursor: move;
	font-size: 0.8125rem;
	margin: 0.3125rem 0.4375rem;
	padding: 0.3125rem;
	text-align: center;
}

.external-event {
	cursor: move;
	margin: 0.625rem 0;
	padding: 0.125rem 0;
}

.fc-basic-view td.fc-week-number span {
	padding-right: 0.3125rem;
}

.fc-basic-view td.fc-day-number {
	padding-right: 0.3125rem;
}

#drop-remove {
	margin-right: 0.5rem;
	top: 0.1875rem;
}

#add-category .modal-dialog,
#event-modal .modal-dialog {
	max-width: 37.5rem;
}

.fc-content {
	color: #fff;
}

.fc th.fc-widget-header {
	background: transparent !important;
}

.fc-button {
	background: #fff;
}

.fc-state-hover {
	background: #fff !important;
}

.fc-state-highlight {
	background: #f5f5f5 !important;
}
[data-theme-version='dark'] .fc-state-highlight {
	color: #fff !important;
}

.fc-cell-overlay {
	background: #fff !important;
}

.fc-unthemed .fc-today {
	background: #f5f5f5 !important;
}

.fc-day-top {
	color: #303972 !important;
}
[data-theme-version='dark'] .fc-day-top {
	color: #fff !important;
}

.external-event {
	color: #fff;
}
[data-theme-version='dark'] .external-event {
	color: #fff !important;
}

.fc-basic-view .fc-body .fc-row {
	min-height: 1rem;
}

.fc-scroller.fc-day-grid-container {
	height: 30.625rem !important;
}

.fc-row.fc-week.fc-widget-content.fc-rigid {
	height: 5.0625rem !important;
}

@media only screen and (max-width: 90rem) {
	.email_left_pane {
		display: none;
	}
}

#external-events .external-event:before {
	content: '';
	display: block;
	width: 0.875rem;
	min-width: 0.875rem;
	height: 0.875rem;
	border-radius: 50%;
	margin-right: 0.9rem;
	position: relative;
	top: 0.125rem;
}

[data-theme-version='dark'] #external-events [data-class='bg-primary'] {
	color: #fff !important;
}

#external-events [data-class='bg-primary']::before {
	background: var(--primary);
}

#external-events [data-class='bg-success']::before {
	background: #1eba62;
}

#external-events [data-class='bg-warning']::before {
	background: #fcc43e;
}

#external-events [data-class='bg-dark']::before {
	background: #303972;
}

#external-events [data-class='bg-danger']::before {
	background: #fd5353;
}

#external-events [data-class='bg-info']::before {
	background: #00ada3;
}

#external-events [data-class='bg-pink']::before {
	background: #eb62d0;
}

#external-events [data-class='bg-secondary']::before {
	background: #fb7d5b;
}

.fc .fc-row .fc-content-skeleton table,
.fc .fc-row .fc-content-skeleton td,
.fc .fc-row .fc-helper-skeleton td {
	border-color: #f2f2f2;
}
[data-theme-version='dark'] .fc .fc-row .fc-content-skeleton table,
[data-theme-version='dark'] .fc .fc-row .fc-content-skeleton td,
[data-theme-version='dark'] .fc .fc-row .fc-helper-skeleton td {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .fc-unthemed .fc-content,
[data-theme-version='dark'] .fc-unthemed .fc-divider,
[data-theme-version='dark'] .fc-unthemed .fc-list-heading td,
[data-theme-version='dark'] .fc-unthemed .fc-list-view,
[data-theme-version='dark'] .fc-unthemed .fc-popover,
[data-theme-version='dark'] .fc-unthemed .fc-row,
[data-theme-version='dark'] .fc-unthemed tbody,
[data-theme-version='dark'] .fc-unthemed td,
[data-theme-version='dark'] .fc-unthemed th,
[data-theme-version='dark'] .fc-unthemed thead {
	border-color: rgba(255, 255, 255, 0.1);
}

.email-left-box {
	border-right: 1px solid #eeeeee;
	height: calc(100vh - 83px);
	padding: 1.875rem 1.25rem;
	overflow-y: auto;
}
.email-left-box .btn.text-white.btn-block {
	background-color: var(--bs-body-color);
	font-weight: 500;
	font-size: 0.938rem;
	white-space: nowrap;
}
@media only screen and (max-width: 47.9375rem) {
	.email-left-box {
		width: 100%;
		float: none;
		border: none;
		padding-bottom: 1.875rem !important;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.email-left-box {
		padding-bottom: 0rem !important;
	}
}
.email-left-box .intro-title {
	padding: 1rem;
	margin: 1.875rem 0 1.25rem 0;
}
.email-left-box .intro-title h5,
.email-left-box .intro-title .h5 {
	margin-bottom: 0;
	font-size: 1rem;
	font-weight: 500;
}
.email-left-box .intro-title h5 i,
.email-left-box .intro-title .h5 i {
	font-size: 0.75rem;
	position: relative;
	bottom: 0.0625rem;
}
.email-left-box .intro-title i {
	color: var(--primary);
}
.email-left-box .mail-list {
	margin-top: 2.188rem;
}
.email-left-box .mail-list a {
	border: 0;
	vertical-align: middle;
	padding: 0.625rem 0.9375rem;
	display: block;
	background: transparent;
	color: #464a53;
	font-weight: 600;
	z-index: 1;
}
.email-left-box .mail-list .change {
	color: #666666;
	font-weight: 500;
}
.email-left-box .mail-list .list-group-item {
	border-radius: 10px;
	padding: 0.75rem 1.0625rem;
	font-size: 0.938rem;
	font-weight: 500;
	margin-bottom: 0.625rem;
	overflow: hidden;
}
.email-left-box .mail-list .list-group-item i {
	font-size: 1.125rem;
	padding-right: 1.125rem;
	color: #a098ae;
}
.email-left-box .mail-list .list-group-item svg {
	margin-right: 1.125rem;
}
.email-left-box .mail-list .list-group-item.active {
	color: #fb7d5b;
	background-color: var(--rgba-secondary-1);
}
.email-left-box .mail-list .list-group-item.active span.badge {
	background-color: var(--secondary);
}
.email-left-box .mail-list .list-group-item.active i {
	color: var(--secondary);
}
.email-left-box .mail-list .list-group-item.change {
	margin-bottom: 0;
}
.email-left-box .mail-list .list-group-item::before {
	content: '';
	display: block;
	background-color: var(--rgba-secondary-1);
	color: var(--secondary);
	position: absolute;
	left: 0;
	top: 0;
	width: 0%;
	height: 100%;
	transition: all 0.5s;
}
.email-left-box .mail-list .list-group-item:hover {
	color: var(--secondary);
}
.email-left-box .mail-list .list-group-item:hover::before {
	width: 100%;
}
.email-left-box .mail-list .list-group-item:hover i {
	color: var(--secondary);
}
.email-left-box .mail-list .list-group-item:hover svg path {
	fill: var(--secondary);
	stroke: var(--secondary);
}
@media only screen and (max-width: 35.9375rem) {
	.email-left-box {
		height: calc(100vh - 160px);
	}
}

input#checkAll.form-check-input {
	background-color: #fff;
}

input#checkAll.form-check-input:checked {
	background-color: var(--primary);
}

.email-right-box {
	padding-left: 15rem;
	padding-right: 1rem;
	padding-left: 0;
	padding-right: 0;
}
.email-right-box .pagination {
	padding: 0.7rem 0;
	margin-bottom: 0rem;
	background-color: #fff;
}
@media (min-width: 576px) and (max-width: 767.98px) {
	.email-right-box {
		padding-left: 0;
		padding-right: 0;
		margin-left: 0 !important;
		clear: both;
	}
}
.email-right-box .right-box-border {
	border-right: 0.125rem solid var(--rgba-primary-1);
}
@media screen and (min-width: 40.5625rem) and (max-width: 75rem) {
	.email-right-box .right-box-padding {
		padding-left: 1.25rem;
	}
}
@media (min-width: 106.25rem) {
	.email-right-box .right-box-padding {
		padding-left: 0.9375rem;
	}
}
@media (min-width: 576px) and (max-width: 767.98px) {
	.email-right-box .right-box-padding {
		padding-left: 1rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.email-right-box .right-box-padding {
		padding: 1rem;
	}
}
.email-right-box .table-pagenation {
	background-color: #fff;
	margin-top: 0;
	border: 1px solid #d5dfe7;
	border-width: 1px 0w;
}

.toolbar {
	height: 3.563rem;
}
@media only screen and (max-width: 74.9375rem) {
	.toolbar {
		height: auto;
	}
}
@media only screen and (max-width: 61.9375rem) {
	.toolbar {
		border-top: 1px solid #d5dfe7;
		padding-top: 10px;
	}
}
.toolbar .btn-group .btn.nav-link.active {
	border: 0;
	background-color: transparent;
	color: #303972;
	font-size: 0.938rem;
	padding: 0.5rem 0.2rem;
	color: var(--primary);
}
@media only screen and (max-width: 74.9375rem) {
	.toolbar .btn-group .btn.nav-link.active {
		padding: 0.5rem 1rem;
	}
}
.toolbar .btn-group .btn.nav-link.active::before {
	content: '';
	display: block;
	background-color: var(--primary);
	position: absolute;
	bottom: -0.625rem;
	left: 50%;
	transform: translateX(-50%);
	width: 100%;
	height: 3px;
	transition: all 0.5s;
}
@media only screen and (max-width: 87.5rem) {
	.toolbar .btn-group .btn.nav-link.active::before {
		display: none;
	}
}
.toolbar .btn-group .btn.nav-link.active:focus {
	box-shadow: none;
}
.toolbar .btn-group .btn.nav-link.active svg path {
	fill: var(--primary);
}
.toolbar .btn-group .btn.nav-link::before {
	content: '';
	display: block;
	background-color: var(--primary);
	position: absolute;
	bottom: -0.625rem;
	left: 50%;
	transform: translateX(-50%);
	width: 0%;
	height: 3px;
	transition: all 0.5s;
}
.toolbar .btn-group .btn.nav-link:hover::before {
	width: 100%;
}
.toolbar .btn-group .btn.nav-link:hover svg path {
	fill: var(--primary);
}
.toolbar .btn-group .btn.nav-link svg {
	margin-right: 0.5rem;
	margin-bottom: 0.2rem;
}
.toolbar .btn-group input {
	position: relative;
	top: 0.125rem;
}

.saprat {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 100%;
	flex-wrap: wrap;
}
.saprat .btn-group {
	margin-left: 1.125rem;
}
@media only screen and (max-width: 47.9375rem) {
	.saprat {
		flex-wrap: wrap;
	}
}
@media only screen and (max-width: 74.9375rem) {
	.saprat .mail-tools {
		margin-left: 5.125rem;
	}
}
.saprat .mail-tools a:hover svg {
	background: var(--rgba-primary-1);
	border-radius: 6px;
}

.read-content textarea {
	height: 9.375rem;
	padding: 0.9375rem 1.25rem;
	border-radius: 0.375rem;
}

.read-content-email {
	font-size: 0.875rem;
}

.read-content h5,
.read-content .h5 {
	color: #6a707e;
}

.read-content p strong {
	color: #6a707e;
}

.read-content-body p {
	margin-bottom: 1.875rem;
}

.read-content-attachment {
	padding: 0.5rem 0;
}
.read-content-attachment h6,
.read-content-attachment .h6 {
	font-size: 1.125rem;
	color: #6a707e;
}
.read-content-attachment h6 i,
.read-content-attachment .h6 i {
	padding-right: 0.3125rem;
}
.read-content-attachment .attachment a {
	color: var(--primary) !important;
}
.read-content-attachment .attachment > div:not(:last-child) {
	border-right: 0.0625rem solid #dddfe1;
}

.compose-wrapper {
	height: calc(100vh - 180px);
	overflow-y: scroll;
	padding: 0 1rem;
}
@media only screen and (max-width: 35.9375rem) {
	.compose-wrapper {
		height: calc(100vh - 337.7px);
	}
}

.read-wapper {
	height: calc(100vh - 180px);
	padding: 0 1.25rem;
}

.compose-content .wysihtml5-toolbar {
	border-color: #eaeaea;
}

.compose-content .dropzone {
	background: #f5f5f5 !important;
}

.compose-content h5,
.compose-content .h5 {
	font-size: 1.0625rem;
	color: #6a707e;
}
.compose-content h5 i,
.compose-content .h5 i {
	font-size: 1.125rem;
	transform: rotate(90deg);
}

.compose-content .dropzone {
	border: 0.0625rem dashed #dddfe1;
	min-height: 13.125rem;
	position: relative;
	border-radius: 0.375rem;
}
.compose-content .dropzone .dlab-message {
	margin: 0;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.email-list {
	display: block;
	padding-left: 0;
	background: #f3f3f3;
	height: calc(100vh - 212px);
	overflow-y: scroll;
}
.email-list label {
	margin-bottom: 0px;
}
.email-list .message {
	position: relative;
	display: block;
	height: 3.438rem;
	padding: 0 15px;
	line-height: 3.438rem;
	cursor: default;
	transition-duration: 0.3s;
	border-bottom: 1px solid #d5dfe7;
}
.email-list .message a {
	color: #303972;
}
.email-list .message-single .custom-checkbox {
	margin-top: 0.125rem;
}
.email-list .message-single i {
	color: #89879f;
	font-size: 1.125rem;
	padding-left: 0.4rem;
}
.email-list .message .icon {
	position: absolute;
	top: 16px;
	right: 10px;
	opacity: 0;
	transition-duration: 0.3s;
}
.email-list .message:hover {
	transition-duration: 0.05s;
	background: #f3f5f7;
}
.email-list .message:hover .icon {
	opacity: 1;
}
.email-list .message:hover .col-mail-2 .date {
	opacity: 0;
}
.email-list .message:hover .message-single .form-check-input {
	opacity: 1;
}
.email-list .message .col-mail {
	float: left;
	position: relative;
}
.email-list .message .col-mail-1 {
	width: 5.625rem;
}
.email-list .message .col-mail-1 .star-toggle {
	display: block;
	float: left;
	margin-top: 1.125rem;
	font-size: 1rem;
	margin-left: 0.3125rem;
}
.email-list .message .col-mail-1 .email-checkbox {
	display: block;
	float: left;
	margin: 0.9375rem 0.625rem 0 1.25rem;
}
.email-list .message .col-mail-1 .dot {
	display: block;
	float: left;
	border: 0.4rem solid transparent;
	border-radius: 6.25rem;
	margin: 1.375rem 1.625rem 0;
	height: 0;
	width: 0;
	line-height: 0;
	font-size: 0;
}
.email-list .message .col-mail-2 {
	position: absolute;
	top: 0;
	left: 5.625rem;
	right: 0;
	bottom: 0;
}
.email-list .message .col-mail-2 .subject {
	position: absolute;
	top: 0;
	left: 0;
	right: 5.5rem;
	font-weight: 500;
	color: black;
	margin: 0 220px;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
.email-list .message .col-mail-2 .subject span {
	color: #666666;
}
.email-list .message .col-mail-2 .date {
	position: absolute;
	top: 0;
	right: 15px;
	opacity: 1;
	transition-duration: 0.3s;
	font-weight: 500;
}
.email-list .message .message-single .bookmark-btn input {
	position: absolute;
	cursor: pointer;
	height: 0;
	width: 0;
	display: none;
}
.email-list .message .message-single .bookmark-btn .checkmark {
	font-weight: 900;
	font-family: 'font awesome 5 free';
}
.email-list .message .message-single .bookmark-btn .checkmark:before {
	content: '\\f005';
	font-size: 1.25rem;
	border-color: #666666;
	font-weight: 100;
	color: #c4c4c4;
}
.email-list .message .message-single .bookmark-btn input:checked ~ .checkmark:before {
	color: #ff9838;
	font-weight: 900;
}
.email-list .message .message-single .form-check-input {
	margin-top: 0;
}
.email-list .message .hader {
	font-size: 0.938rem;
	font-weight: 500;
	padding: 0 1.25rem;
}

.email-checkbox {
	cursor: pointer;
	height: 0.9375rem;
	width: 0.9375rem;
	position: relative;
	display: inline-block;
	border-radius: 0.1rem;
	position: relative;
	top: 0.3125rem;
	box-shadow: inset 0 0 0 0.1rem #828690;
}
.email-checkbox input {
	opacity: 0;
	cursor: pointer;
}
.email-checkbox input:checked label {
	opacity: 1;
}
.email-checkbox label {
	position: absolute;
	top: 0.3rem;
	left: 0.3rem;
	right: 0.3rem;
	bottom: 0.3rem;
	cursor: pointer;
	opacity: 0;
	margin-bottom: 0 !important;
	transition-duration: 0.05s;
}

.chat-wrap {
	padding: 1.0625rem 1.875rem;
}
.chat-wrap .media .media-body h6,
.chat-wrap .media .media-body .h6 {
	font-size: 1.0625rem;
	color: #6a707e;
}
.chat-wrap .media .media-body p {
	font-size: 0.875rem;
}

@media (min-width: 40.5rem) {
	.email-filter {
		padding-left: 1.25rem;
	}
}

@media (min-width: 106.25rem) {
	.email-filter {
		padding-left: 1.875rem;
	}
}

.email-filter .input-group-prepend i {
	font-size: 0.875rem;
	color: #89879f;
}

.email-filter .input-group-prepend .input-group-text {
	border: 0;
	border-bottom: 0.0625rem solid #dddfe1 !important;
	background: transparent;
}

.email-filter .input-group .form-control {
	padding: 0 0 0 0.3125rem;
	border: 0;
	font-size: 0.875rem;
	height: 1.875rem;
	color: #89879f;
	border-bottom: 0.0625rem solid #dddfe1;
}
.email-filter .input-group .form-control::placeholder {
	font-size: 0.875rem;
	color: #89879f;
}

.email-filter .input-group > .form-control {
	min-height: 1.875rem;
}

.single-mail {
	display: block;
	padding: 1.5625rem 0;
}
.single-mail .media {
	padding-left: 1.25rem;
	padding-right: 1.25rem;
}
@media (min-width: 106.25rem) {
	.single-mail .media {
		padding-left: 1.875rem;
		padding-right: 1.875rem;
	}
}
.single-mail .media img {
	width: 3.4375rem;
	height: 3.4375rem;
	border-radius: 50%;
	margin-right: 0.9375rem;
}
@media (min-width: 106.25rem) {
	.single-mail .media img {
		margin-right: 1.875rem;
	}
}
.single-mail .media-body h6,
.single-mail .media-body .h6 {
	color: #abafb3;
}
.single-mail .media-body h4,
.single-mail .media-body .h4 {
	font-size: 1rem;
	color: #6a707e;
}
.single-mail .media-body h4 button i,
.single-mail .media-body .h4 button i {
	font-size: 1.125rem;
	color: #abafb3;
	font-weight: bold;
	transform: rotate(90deg);
}
.single-mail .media-body p {
	font-size: 0.875rem;
	color: #abafb3;
}
.single-mail.active {
	background: var(--primary);
}
.single-mail.active h6,
.single-mail.active .h6,
.single-mail.active h4,
.single-mail.active .h4,
.single-mail.active p,
.single-mail.active i {
	color: #fff !important;
}

[direction='rtl'] .email-right-box {
	padding-left: 1rem;
	padding-right: 15rem;
}
@media only screen and (max-width: 61.9375rem) {
	[direction='rtl'] .email-right-box {
		padding-left: 0;
		padding-right: 0;
		margin-right: 0;
	}
}
@media only screen and (max-width: 35.9375rem) {
	[direction='rtl'] .email-right-box {
		padding-left: 0;
		padding-right: 0;
	}
}

[direction='rtl'] .email-left-box {
	float: right;
}

[direction='rtl'] .email-list .message .col-mail-2 {
	right: 5.625rem;
	left: 0;
	float: right;
}
[direction='rtl'] .email-list .message .col-mail-2 .date {
	right: auto;
	left: 0;
}
[direction='rtl'] .email-list .message .col-mail-2 .subject {
	right: 0;
	left: 5.5rem;
}

.pull-end {
	float: right;
}

.photo-content {
	position: relative;
}
.photo-content .cover-photo {
	background-size: cover;
	background-position: center;
	min-height: 15.625rem;
	width: 100%;
}

.profile .profile-photo {
	max-width: 6.25rem;
	position: relative;
	z-index: 1;
	margin-top: -4.5rem;
	margin-right: 0.625rem;
}
@media only screen and (max-width: 35.9375rem) {
	.profile .profile-photo {
		width: 5rem;
		margin-left: auto;
		margin-right: auto;
		margin-top: -3rem;
		margin-bottom: 1.25rem;
	}
}

[direction='rtl'] .profile .profile-photo {
	left: auto;
	right: 0;
	margin-right: 0;
	margin-left: 0.9375rem;
}
@media only screen and (max-width: 74.9375rem) {
	[direction='rtl'] .profile .profile-photo {
		right: 0.9375rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	[direction='rtl'] .profile .profile-photo {
		width: 5rem;
		right: calc(50% - 2.5rem);
		top: -6.25rem;
	}
}

.profile-info {
	padding: 0.9375rem 1.25rem;
}
@media only screen and (max-width: 35.9375rem) {
	.profile-info {
		padding: 0 0 1.25rem;
		text-align: center;
	}
}
.profile-info h4,
.profile-info .h4 {
	color: #464a53 !important;
}
.profile-info h4.text-primary,
.profile-info .text-primary.h4 {
	color: var(--primary) !important;
}
.profile-info p {
	color: #828690;
}
.profile-info .prf-col {
	min-width: 15.625rem;
	padding: 0.625rem 3.125rem 0;
}

.profile-interest .row {
	margin: 0 -0.0437rem;
}
.profile-interest .row .int-col {
	padding: 0 0.0437rem;
}
.profile-interest .row .int-col .interest-cat {
	margin-bottom: 0.0875rem;
	position: relative;
	display: block;
}
.profile-interest .row .int-col .interest-cat:after {
	background: #000;
	bottom: 0;
	content: '';
	left: 0;
	opacity: 0.5;
	position: absolute;
	right: 0;
	top: 0;
	z-index: 0;
}
.profile-interest .row .int-col .interest-cat p {
	position: absolute;
	top: 0;
	width: 100%;
	height: 100%;
	padding: 0.3125rem;
	left: 0;
	margin: 0;
	z-index: 1;
	color: white;
	font-size: 0.075rem;
}

.profile-tab .nav-item .nav-link {
	font-size: 1rem;
	margin-right: 1.875rem;
	transition: all 0.5s ease-in-out;
	border: none;
	border-bottom: 0.0125rem solid transparent;
	color: #828690;
}
.profile-tab .nav-item .nav-link:hover,
.profile-tab .nav-item .nav-link.active {
	border: 0;
	background: transparent;
	background: transparent;
	border-bottom: 0.0125rem solid var(--primary);
	color: var(--primary);
}
@media only screen and (max-width: 35.9375rem) {
	.profile-tab .nav-item .nav-link {
		margin-right: 0rem;
	}
}

.profile-info {
	display: flex;
}
@media only screen and (max-width: 35.9375rem) {
	.profile-info {
		display: block;
	}
}
.profile-info .profile-details {
	display: flex;
	width: 100%;
}
@media only screen and (max-width: 35.9375rem) {
	.profile-info .profile-details {
		display: block;
	}
	.profile-info .profile-details .dropdown {
		position: absolute;
		top: 1.875rem;
		right: 1.875rem;
	}
}

.post-input {
	margin-bottom: 1.875rem;
}
.post-input .form-control {
	height: 4.6875rem;
	font-weight: 400;
	margin: 0.9375rem 0;
}
.post-input .btn-social {
	font-size: 1.25rem;
	height: 3.4375rem;
	display: inline-block;
	padding: 0;
	text-align: center;
	border-radius: 0.375rem;
	color: #fff;
	width: 3.4375rem;
	line-height: 3.375rem;
}
.post-input .btn-social.facebook {
	background-color: #3b5998;
}
.post-input .btn-social.google-plus {
	background-color: #de4e43;
}
.post-input .btn-social.linkedin {
	background-color: #007bb6;
}
.post-input .btn-social.instagram {
	background-color: #8a5a4e;
}
.post-input .btn-social.twitter {
	background-color: #1ea1f3;
}
.post-input .btn-social.youtube {
	background-color: #ce201f;
}
.post-input .btn-social.whatsapp {
	background-color: #01c854;
}
.post-input .btn-social i {
	margin: 0 !important;
}

.profile-uoloaded-post img {
	margin-bottom: 1.25rem;
}

.profile-uoloaded-post a h4,
.profile-uoloaded-post a .h4 {
	margin-bottom: 0.625rem;
	color: #464a53;
}

.event-chat-ryt .chat-area .chat-reciver,
.event-chat-ryt .chat-area .chat-sender {
	margin-bottom: 1.875rem;
	padding: 0;
}
.event-chat-ryt .chat-area .chat-reciver img,
.event-chat-ryt .chat-area .chat-sender img {
	border-radius: 1.875rem;
}

.event-chat-ryt .chat-area .media {
	position: relative;
}
.event-chat-ryt .chat-area .media-body p {
	margin: 0;
	max-width: 100%;
	display: inline-block;
	position: relative;
}
.event-chat-ryt .chat-area .media-body p span {
	padding: 1rem;
	display: inline-block;
	top: 103%;
	position: relative;
	border: 0.0625rem solid #f2f2f2;
}

.event-chat-ryt .chat-reciver {
	padding: 0.5rem 1rem;
	display: flex;
	justify-content: flex-end;
}
.event-chat-ryt .chat-reciver .media {
	flex: 1 1;
}
.event-chat-ryt .chat-reciver .media .media-body {
	margin-right: 2rem;
	text-align: right;
}
[direction='rtl'] .event-chat-ryt .chat-reciver .media .media-body {
	text-align: left;
	margin-left: 2rem;
	margin-right: auto;
}
.event-chat-ryt .chat-reciver .media .media-body p {
	background: #fff;
	margin-bottom: 0;
	border-radius: 0.3125rem 0.3125rem 0 0.3125rem;
}
.event-chat-ryt .chat-reciver .media .media-body p span {
	text-align: left;
	border: 0.0625rem solid #f2f2f2;
}
.event-chat-ryt .chat-reciver .media .media-body p span::after {
	content: '';
	width: 1.25rem;
	height: 1.25rem;
	border-bottom: 0.0625rem solid #f2f2f2;
	border-right: 0.0625rem solid #f2f2f2;
	position: absolute;
	right: 0;
	bottom: 0;
	background: #fff;
	transform: rotate(-45deg) translateX(15px);
}
[direction='rtl'] .event-chat-ryt .chat-reciver .media .media-body p span::after {
	left: 0;
	right: auto;
	transform: rotate(135deg) translateY(15px);
}
.event-chat-ryt .chat-reciver .media .media-body p .time {
	position: absolute;
	font-size: 0.75rem;
	color: #a098ae;
	font-weight: 400;
	bottom: 0;
	left: -5rem;
}
[direction='rtl'] .event-chat-ryt .chat-reciver .media .media-body p .time {
	right: -5rem;
	left: auto;
}

.event-chat-ryt .chat-sender {
	text-align: left;
	padding: 0.5rem 1rem;
}
.event-chat-ryt .chat-sender .media .media-body {
	margin-left: 2rem;
}
[direction='rtl'] .event-chat-ryt .chat-sender .media .media-body {
	text-align: right;
	margin-right: 2rem;
	margin-left: auto;
}
.event-chat-ryt .chat-sender .media .media-body p {
	background-color: #fff;
	margin-bottom: 0;
}
.event-chat-ryt .chat-sender .media .media-body p span::after {
	content: '';
	width: 1.25rem;
	height: 1.25rem;
	border-bottom: 0.0625rem solid #f2f2f2;
	border-left: 0.0625rem solid #f2f2f2;
	position: absolute;
	left: 0;
	bottom: 0;
	background: #fff;
	transform: rotate(45deg) translateX(-15px);
}
[direction='rtl'] .event-chat-ryt .chat-sender .media .media-body p span::after {
	left: auto;
	right: 0;
	transform: rotate(-135deg) translateY(15px);
}
.event-chat-ryt .chat-sender .media .media-body p .time {
	position: absolute;
	font-size: 0.625rem;
	color: #a098ae;
	font-weight: 400;
	bottom: 0;
	right: -5rem;
}
[direction='rtl'] .event-chat-ryt .chat-sender .media .media-body p .time {
	left: -5rem;
	right: auto;
}

.char-type {
	padding-top: 1.875rem;
	padding-bottom: 1.875rem;
}
.char-type form .form-control {
	height: 2.8125rem;
	padding-left: 1.125rem;
	background: #e6ebee;
	border-right: 0;
}
.char-type form .input-group-append i {
	color: #898989;
	font-size: 1.125rem;
}
.char-type form .input-group-append .input-group-text {
	padding-left: 0.7rem;
	padding-right: 0.7rem;
	background: #e6ebee;
	border-color: #f2f2f2;
	border-left: 0;
}
.char-type form .input-group-append .input-group-text:last-child {
	padding-right: 1.8rem;
}

.media-avatar {
	padding: 1.5625rem 0;
	border-bottom: 0.0625rem solid #f2f2f2;
}
.media-avatar:last-child {
	border-bottom: 0rem;
}
.media-avatar p {
	margin-bottom: 0;
}
.media-avatar .avatar-status {
	position: relative;
}
.media-avatar .avatar-status i {
	position: absolute;
	right: 0;
	bottom: 0;
}

.ct-golden-section:before {
	float: none;
}

.ct-chart {
	max-height: 15.7rem;
}

.ct-chart .ct-label {
	fill: #a3afb7;
	color: #a3afb7;
	font-size: 0.75rem;
	line-height: 1;
}

.ct-grid {
	stroke: rgba(49, 58, 70, 0.1);
}

.ct-chart.simple-pie-chart-chartist .ct-label {
	color: #ffffff;
	fill: #ffffff;
	font-size: 0.625rem;
}

.ct-chart .ct-series.ct-series-a .ct-bar,
.ct-chart .ct-series.ct-series-a .ct-line,
.ct-chart .ct-series.ct-series-a .ct-point,
.ct-chart .ct-series.ct-series-a .ct-slice-donut {
	stroke: var(--primary);
}

.ct-chart .ct-series.ct-series-b .ct-bar,
.ct-chart .ct-series.ct-series-b .ct-line,
.ct-chart .ct-series.ct-series-b .ct-point,
.ct-chart .ct-series.ct-series-b .ct-slice-donut {
	stroke: #1eba62;
}

.ct-chart .ct-series.ct-series-c .ct-bar,
.ct-chart .ct-series.ct-series-c .ct-line,
.ct-chart .ct-series.ct-series-c .ct-point,
.ct-chart .ct-series.ct-series-c .ct-slice-donut {
	stroke: #fcc43e;
}

.ct-chart .ct-series.ct-series-d .ct-bar,
.ct-chart .ct-series.ct-series-d .ct-line,
.ct-chart .ct-series.ct-series-d .ct-point,
.ct-chart .ct-series.ct-series-d .ct-slice-donut {
	stroke: #fd5353;
}

.ct-chart .ct-series.ct-series-e .ct-bar,
.ct-chart .ct-series.ct-series-e .ct-line,
.ct-chart .ct-series.ct-series-e .ct-point,
.ct-chart .ct-series.ct-series-e .ct-slice-donut {
	stroke: #00ada3;
}

.ct-chart .ct-series.ct-series-f .ct-bar,
.ct-chart .ct-series.ct-series-f .ct-line,
.ct-chart .ct-series.ct-series-f .ct-point,
.ct-chart .ct-series.ct-series-f .ct-slice-donut {
	stroke: #303972;
}

.ct-chart .ct-series.ct-series-g .ct-bar,
.ct-chart .ct-series.ct-series-g .ct-line,
.ct-chart .ct-series.ct-series-g .ct-point,
.ct-chart .ct-series.ct-series-g .ct-slice-donut {
	stroke: #8d6e63;
}

.ct-series-a .ct-area,
.ct-series-a .ct-slice-pie {
	fill: #fb7d5b;
}

.ct-series-b .ct-area,
.ct-series-b .ct-slice-pie {
	fill: #00a2ff;
}

.ct-series-c .ct-area,
.ct-series-c .ct-slice-pie {
	fill: #ff9800;
}

.ct-series-d .ct-area,
.ct-series-d .ct-slice-pie {
	fill: #ff9800;
}

.chartist-tooltip {
	position: absolute;
	display: inline-block;
	opacity: 0;
	min-width: 0.625rem;
	padding: 0.125rem 0.625rem;
	border-radius: 0.125rem;
	background: #313a46;
	color: #ffffff;
	text-align: center;
	pointer-events: none;
	z-index: 1;
	transition: opacity 0.2s linear;
}

.chartist-tooltip.tooltip-show {
	opacity: 1;
}

#donught_graph .ct-series.ct-series-a .ct-slice-donut {
	stroke: #3fc6d4;
}

#donught_graph .ct-series.ct-series-b .ct-slice-donut {
	stroke: #333333;
}

#donught_graph .ct-series.ct-series-c .ct-slice-donut {
	stroke: #f63465;
}

@media only screen and (max-width: 47.9375rem) {
	#pie-chart .ct-label {
		color: #fff;
		fill: #fff;
	}
}

#visitor_graph {
	height: 15.8125rem !important;
}

#user_rating_graph {
	height: 17.5rem !important;
}

#activity {
	height: 16.875rem !important;
}

#visitorOnline {
	height: 4.5rem !important;
}

#trendMeter {
	height: 4.5rem !important;
}

#widget-revenue1,
#widget-revenue2,
#widget-revenue3 {
	height: 7.3125rem !important;
}

#widget-profit1,
#widget-profit2,
#widget-profit3 {
	height: 10rem !important;
}

#comparison-rate {
	height: 14.375rem;
}

#session_day {
	height: 10.9375rem;
	width: auto !important;
	margin: 0 auto;
}

#walet-status {
	height: 8.75rem;
}

#bar1 {
	height: 9.375rem;
}

#sold-product {
	height: 14.375rem;
}

#chart-venue-expenses,
#chart-online-sale,
#chart-gross-sale {
	height: 9.375rem !important;
}

#areaChart_3 {
	height: 18.4375rem !important;
}

.chart-point {
	display: flex;
	align-items: center;
}
.chart-point .check-point-area {
	width: 6.25rem;
	height: 6.25rem;
	margin-top: -0.625rem;
	margin-left: -0.625rem;
}
.chart-point .chart-point-list {
	margin: 0;
	padding-left: 0.3125rem;
}
.chart-point .chart-point-list li {
	list-style: none;
	font-size: 0.8125rem;
	padding: 0.125rem 0;
}
.chart-point .chart-point-list li i {
	margin-right: 0.3125rem;
	font-size: 0.6875rem;
	position: relative;
	top: -0.0625rem;
}

.c3 {
	height: 15.625rem;
}

.c3-legend-item {
	fill: #9fabb1;
}

.c3 .c3-axis-x path,
.c3 .c3-axis-x line,
.c3 .c3-axis-y path,
.c3 .c3-axis-y line,
.tick text {
	stroke: #fff;
}

.flot-chart {
	height: 15.7rem;
}

.tooltipflot {
	background-color: transparent;
	font-size: 1.4rem;
	padding: 0.5rem 1rem;
	color: rgba(255, 255, 255, 0.7);
	border-radius: 0.2rem;
}

.legendColorBox > div {
	border: 0 !important;
	padding: 0 !important;
}

.legendLabel {
	font-size: 0.825rem;
	padding-left: 0.5rem;
	color: var(--primary);
}

.flotTip {
	background: #000;
	border: 0.0625rem solid #000;
	color: #fff;
}

.legend > div {
	background: transparent !important;
}

#balance_graph {
	height: 16.25rem;
}

.flot-chart .legend table tbody tr:last-child .legendLabel {
	color: var(--secondary);
}

.morris-hover {
	position: absolute;
	z-index: 1;
	background: var(--primary);
	color: #fff;
}

.morris-hover .morris-hover-point {
	color: #fff !important;
	margin: 0.1875rem 0;
	text-align: center;
	padding: 0 1.5625rem;
	color: #fff;
}

.morris-hover .morris-hover-row-label {
	background-color: #303972;
	text-align: center;
	padding: 0.3125rem;
	color: #fff;
	margin-bottom: 0.3125rem;
}

.morris-hover.morris-default-style {
	border-radius: 0.3125rem;
	padding: 0;
	margin: 0;
	border: none;
	overflow: hidden;
}

/* svg text {
    font-weight: 600 !important;
} */
#morris_donught,
#morris_donught_2,
#line_chart_2,
#morris_bar,
#morris_bar_stalked,
#morris_bar_2,
#morris_area_2,
#morris_area {
	height: 15rem !important;
}

#morris_line {
	height: 17.375rem !important;
}

#crypto-btc-card,
#crypto-eth-card,
#crypto-rpl-card,
#crypto-ltc-card {
	height: 9.375rem;
}

#daily-sales,
#comparison-rate,
#usage-chart,
#walet-status {
	width: 100%;
	display: block;
}
#daily-sales canvas,
#comparison-rate canvas,
#usage-chart canvas,
#walet-status canvas {
	max-width: 100% !important;
	width: 100% !important;
}

#sparkline-composite-chart canvas,
#composite-bar canvas,
#sparkline11 canvas,
#StackedBarChart canvas,
#spark-bar canvas,
#tristate canvas {
	height: 6.25rem !important;
}

#sparkline11 canvas {
	width: 6.25rem !important;
}

.easy-pie-chart {
	position: relative;
	text-align: center;
}
.easy-pie-chart .inner {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	display: inline-block;
}
.easy-pie-chart img {
	width: 4.6875rem;
	height: 4.6875rem;
	border-radius: 50%;
}
.easy-pie-chart canvas {
	display: block;
	margin: 0 auto;
}

#revenue-chart {
	height: 27.7rem;
}

#duration-value-axis {
	height: 27.6rem;
	width: 100%;
}

#combined-bullet {
	height: 28.125rem;
	width: 100%;
}

#zoomable-chart {
	height: 28.125rem;
	width: 100%;
}

#chartMap {
	height: 28.125rem;
	width: 100%;
}

#professional-candlesticks {
	width: 100%;
	height: 28.125rem;
}

#comparing-stock-indices {
	width: 100%;
	height: 28.125rem;
}

#multiple-panel-data {
	width: 100%;
	height: 28.125rem;
}

#depth-chart {
	width: 100%;
	height: 28.125rem;
}

.amcharts-export-menu {
	display: none;
}

.amcharts-data-set-selector-div {
	position: absolute;
	left: 0;
	right: 0;
	text-align: center;
	width: 16.875rem;
	margin: 0 auto;
}
.amcharts-data-set-selector-div select {
	border: 0;
	margin-left: 0.625rem;
	background: #ddd;
	color: #000;
}

.amChartsInputField {
	border: 0;
	background: var(--primary);
	color: #fff;
	padding: 0.3125rem 0.9375rem;
	margin: 0 0.9375rem;
}

.amcharts-data-set-select {
	border: 0;
	background: #ddd;
	color: #000;
}

.amcharts-period-input,
.amcharts-period-input-selected {
	border: 0;
	margin-left: 0.625rem;
	background: var(--primary);
	color: #fff;
	padding: 0.3125rem 0.9375rem;
}

.amcharts-graph-g2 .amcharts-graph-stroke {
	stroke-dasharray: 0.1875rem 0.1875rem;
	stroke-linejoin: round;
	stroke-linecap: round;
	animation: am-moving-dashes 1s linear infinite;
}

@keyframes am-moving-dashes {
	100% {
		stroke-dashoffset: -1.9375rem;
	}
}

.lastBullet {
	animation: am-pulsating 1s ease-out infinite;
}

@keyframes am-pulsating {
	0% {
		stroke-opacity: 1;
		stroke-width: 0px;
	}
	100% {
		stroke-opacity: 0;
		stroke-width: 3.125rem;
	}
}

.amcharts-graph-column-front {
	transition: all 0.3s 0.3s ease-out;
}

.amcharts-graph-column-front:hover {
	fill: #496375;
	stroke: #496375;
	transition: all 0.3s ease-out;
}

@keyframes am-draw {
	0% {
		stroke-dashoffset: 500%;
	}
	100% {
		stroke-dashoffset: 0%;
	}
}

@media only screen and (max-width: 61.9375rem) {
	.amChartsPeriodSelector > fieldset > div {
		float: none !important;
		display: block !important;
		margin-bottom: 0.625rem;
	}
}

.highcharts-root text {
	font-weight: 300 !important;
}

.highcharts-credits {
	display: none;
}

#chart_employee_gender,
#chart_employee_status {
	width: auto;
	height: 21.875rem;
}

.form-control {
	background: #fff;
	color: #303972;
	line-height: 1.7;
	font-size: 0.9rem;
	height: 3rem;
	border-radius: 0.375rem;
	border-color: #dddddd;
}
.form-control:hover,
.form-control:focus,
.form-control.active {
	box-shadow: none;
	background: #fff;
	color: #303972;
}
.form-control:focus {
	border-color: var(--primary);
	box-shadow: 0 0 0 0.125rem var(--rgba-primary-2);
}
.form-control.solid {
	background: #e6ebee;
	border-color: #ececec;
	color: #000;
}
.form-control.solid[type='file'] {
	padding: 6px 10px;
}

.bootstrap-select .btn {
	padding: 0.6875rem 1.25rem;
	border-color: #dddddd;
	border-width: 1px;
	line-height: 1.5;
}

.input-rounded {
	border-radius: 6.25rem;
}

[data-theme-version='light'] .input-primary .form-control,
[data-theme-version='dark'] .input-primary .form-control {
	border-color: var(--primary);
}

[data-theme-version='light'] .input-primary .input-group-text,
[data-theme-version='dark'] .input-primary .input-group-text {
	background-color: var(--primary);
	color: #fff;
}

[data-theme-version='light'] .input-danger .form-control,
[data-theme-version='dark'] .input-danger .form-control {
	border-color: #fd5353;
}

[data-theme-version='light'] .input-danger .input-group-text,
[data-theme-version='dark'] .input-danger .input-group-text {
	background-color: #fd5353;
	color: #fff;
}

[data-theme-version='light'] .input-info .form-control,
[data-theme-version='dark'] .input-info .form-control {
	border-color: #00ada3;
}

[data-theme-version='light'] .input-info .input-group-text,
[data-theme-version='dark'] .input-info .input-group-text {
	background-color: #00ada3;
	color: #fff;
}

[data-theme-version='light'] .input-success .form-control,
[data-theme-version='dark'] .input-success .form-control {
	border-color: #1eba62;
}

[data-theme-version='light'] .input-success .input-group-text,
[data-theme-version='dark'] .input-success .input-group-text {
	background-color: #1eba62;
	color: #fff;
}

[data-theme-version='light'] .input-warning .form-control,
[data-theme-version='dark'] .input-warning .form-control {
	border-color: #fcc43e;
}

[data-theme-version='light'] .input-warning .input-group-text,
[data-theme-version='dark'] .input-warning .input-group-text {
	background-color: #fcc43e;
	color: #fff;
}

[data-theme-version='light'] .input-primary-o .form-control,
[data-theme-version='dark'] .input-primary-o .form-control {
	border-color: var(--primary);
}

[data-theme-version='light'] .input-primary-o .input-group-text,
[data-theme-version='dark'] .input-primary-o .input-group-text {
	background-color: transparent;
	border-color: var(--primary);
	color: var(--primary);
}

[data-theme-version='light'] .input-danger-o .form-control,
[data-theme-version='dark'] .input-danger-o .form-control {
	border-color: #fd5353;
}

[data-theme-version='light'] .input-danger-o .input-group-text,
[data-theme-version='dark'] .input-danger-o .input-group-text {
	background-color: transparent;
	border-color: #fd5353;
	color: #fd5353;
}

[data-theme-version='light'] .input-info-o .form-control,
[data-theme-version='dark'] .input-info-o .form-control {
	border-color: #00ada3;
}

[data-theme-version='light'] .input-info-o .input-group-text,
[data-theme-version='dark'] .input-info-o .input-group-text {
	background-color: transparent;
	border-color: #00ada3;
	color: #00ada3;
}

[data-theme-version='light'] .input-success-o .form-control,
[data-theme-version='dark'] .input-success-o .form-control {
	border-color: #1eba62;
}

[data-theme-version='light'] .input-success-o .input-group-text,
[data-theme-version='dark'] .input-success-o .input-group-text {
	background-color: transparent;
	border-color: #1eba62;
	color: #1eba62;
}

[data-theme-version='light'] .input-warning-o .form-control,
[data-theme-version='dark'] .input-warning-o .form-control {
	border-color: #fcc43e;
}

[data-theme-version='light'] .input-warning-o .input-group-text,
[data-theme-version='dark'] .input-warning-o .input-group-text {
	background-color: transparent;
	border-color: #fcc43e;
	color: #fcc43e;
}

.input-group-text {
	min-width: 3.125rem;
	justify-content: center;
	border-radius: 0.375rem;
	font-weight: 600;
	font-size: 1rem;
	background-color: #ededed;
}

.form-file-label {
	height: 2.5rem;
	padding: 0.5rem 0.75rem;
}

.input-group-prepend .btn,
.input-group-append .btn {
	z-index: 0;
}

.custom-select {
	background: none;
	border-color: #f2f2f2;
	color: #303972;
}
.custom-select:focus {
	box-shadow: none;
	border-color: var(--primary);
	color: var(--primary);
}

.form-file-label {
	background: #656c73;
	white-space: nowrap;
	color: #fff;
}
[data-theme-version='dark'] .form-file-label {
	background: rgba(255, 255, 255, 0.1);
	border-color: rgba(255, 255, 255, 0.1);
	color: #a098ae;
}

.custom_file_input .form-file-label::after {
	height: 100%;
}

.form-control:disabled,
.form-control[readonly] {
	background: #fff;
	opacity: 1;
}

.form-file {
	border: 0.0625rem solid #f2f2f2;
	background: #fff;
}
[data-theme-version='dark'] .form-file {
	background: #202020;
	border-color: rgba(255, 255, 255, 0.1);
}

.input-group {
	/* &> .form-file {
		display: flex;
		align-items: center;

		&:not(:last-child) .form-file-label,
		&:not(:last-child) .form-file-label::after { @include border-right-radius(0); }
		&:not(:first-child) .form-file-label { @include border-left-radius(0); }
	  } */
}
.input-group > .form-control-plaintext,
.input-group > .form-select,
.input-group > .form-file {
	position: relative;
	flex: 1 1 auto;
	width: 1%;
	margin-bottom: 0;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
	border-radius: 0.375rem;
}

.form-file .form-control {
	margin: 0;
	border-radius: 0;
	border: 0;
	height: auto;
}

#validationCustomUsername {
	border-radius: 0 0.5rem 0.5rem 0;
}

.show-pass {
	border-radius: 0 0.5rem 0.5rem 0 !important;
}

.form-file .form-control {
	margin: 0;
	border-radius: 0;
	border: 0;
	height: auto;
	line-height: 24.4px;
}

.input-group .input-group-text + .form-file {
	border-radius: 0 0.5rem 0.5rem 0;
}
.input-group .input-group-text + .form-file .form-control {
	border-radius: inherit;
	margin: 0;
}

.custom_file_input .form-file {
	border-radius: 0.5rem;
}
.custom_file_input .form-file .form-control {
	margin: 0;
	border: 0;
	line-height: 2.125rem;
	border-radius: inherit;
	font-size: 16px;
	font-weight: 600;
}

.custom_file_input .form-control {
	padding-left: 12px;
	line-height: 45px;
}

#username {
	border-radius: 0 0.5rem 0.5rem 0;
}

.form-control-lg {
	min-height: 3.75rem;
	padding: 0.5rem 1.1rem;
	font-size: 1.09375rem;
	border-radius: 0.5rem;
	height: calc(1.5em + 1rem + 2px);
}

.form-control-sm {
	min-height: 2.5rem;
	padding: 0.25rem 1.1rem;
	font-size: 0.76563rem;
	border-radius: 0.5rem;
	height: calc(1.5em + 0.5rem + 2px);
}

.card.checkboxes .form-check .form-check-input[type='radio'] {
	margin-left: -1.188rem;
}
@media only screen and (max-width: 35.9375rem) {
	.card.checkboxes .form-check .form-check-input[type='radio'] {
		margin-left: -1.388rem;
	}
}

.modal-grid {
	background: #e6ebee;
}

.nice-select.wide.form-control-lg {
	line-height: 2.7125rem;
}

.nice-select.wide.form-control-sm {
	line-height: 1.8125rem;
}

.inline-check {
	line-height: 1.8rem !important;
}

.form-check {
	font-size: 14px;
	font-weight: 600;
}

.input-full {
	border: 0;
}

.border-1 {
	border-radius: 0.5rem 0 0 0.5rem !important;
}

.border3 {
	border-radius: 0 0.5rem 0.5rem 0 !important;
}

.custome-input .input-group-text {
	border-color: transparent !important;
}

.form-control-sm[type='file'] {
	line-height: 32px;
	padding: 4px;
	padding-left: 8px;
}
@media only screen and (max-width: 35.9375rem) {
	.form-control-sm[type='file'] {
		padding: 3px;
		line-height: 27px;
		padding-left: 7px;
	}
}

.form-control-lg[type='file'] {
	line-height: 42px;
	padding-left: 10px;
}

.input-group.input-group-lg .form-control {
	height: 3.75rem;
}

.input-group.input-group-sm .form-control {
	height: 2.5rem;
}

.right-radius {
	border-top-right-radius: 0 !important;
	border-bottom-right-radius: 0 !important;
}

.left-radius {
	border-top-left-radius: 0 !important;
	border-bottom-left-radius: 0 !important;
}

:root {
	--primary: #4d44b5;
	--secondary: #fb7d5b;
	--primary-hover: #3d3690;
	--primary-dark: #1e1a46;
	--rgba-primary-1: rgba(77, 68, 181, 0.1);
	--rgba-primary-2: rgba(77, 68, 181, 0.2);
	--rgba-primary-3: rgba(77, 68, 181, 0.3);
	--rgba-primary-4: rgba(77, 68, 181, 0.4);
	--rgba-primary-5: rgba(77, 68, 181, 0.5);
	--rgba-primary-6: rgba(77, 68, 181, 0.6);
	--rgba-primary-7: rgba(77, 68, 181, 0.7);
	--rgba-primary-8: rgba(77, 68, 181, 0.8);
	--rgba-primary-9: rgba(77, 68, 181, 0.9);
	--rgba-secondary-1: rgba(251, 125, 91, 0.1);
	--rgba-secondary-2: rgba(251, 125, 91, 0.2);
	--rgba-secondary-3: rgba(251, 125, 91, 0.3);
	--rgba-secondary-4: rgba(251, 125, 91, 0.4);
	--rgba-secondary-5: rgba(251, 125, 91, 0.5);
	--rgba-secondary-6: rgba(251, 125, 91, 0.6);
	--rgba-secondary-7: rgba(251, 125, 91, 0.7);
	--rgba-secondary-8: rgba(251, 125, 91, 0.8);
	--rgba-secondary-9: rgba(251, 125, 91, 0.9);
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--title: #303972;
}

.form-check-label {
	margin-left: 1rem;
	text-transform: capitalize;
	margin-top: 0.1875rem;
}

#example5_wrapper .form-check-input:checked {
	border-color: var(--primary) !important;
}

#example5_wrapper table.dataTable thead .sorting_asc {
	display: flex;
}

#example5_wrapper .btn.tp-btn.btn-primary:hover svg path {
	stroke: #fff;
}

.form-check-inline .form-check-input {
	margin-right: 0.625rem;
	margin-top: 0;
}

.bootstrap-select .dropdown-menu {
	z-index: 9999;
}

.form-control:focus {
	box-shadow: none;
}

.form-check-input {
	top: 0.125rem;
	border-width: 0.125rem;
	width: 1.25rem;
	height: 1.25rem;
	border-color: #c4c4c4;
	background-color: transparent;
}

.rtl .form-check-label:before,
.rtl .form-check-label:after {
	right: -1.5rem !important;
	left: inherit;
}

.form-check {
	line-height: normal;
}

.toggle-switch {
	padding-left: 3.125rem;
	line-height: 1.25;
	display: inline-block;
	color: #000;
	font-weight: 600;
}
.toggle-switch .form-check-input {
	border: 0;
	cursor: pointer;
	background: #d8d8d8;
	width: 2.2125rem;
	border-radius: 1.25rem !important;
	height: 0.875rem;
	position: relative;
	left: -0.3125rem;
	transition: all 0.2s;
	background-image: none;
}
.toggle-switch .form-check-input:focus {
	background-image: none !important;
}
.toggle-switch .form-check-input:checked {
	background: var(--rgba-primary-1);
	background-image: none !important;
}
.toggle-switch .form-check-input:checked:after {
	left: 1.3rem;
	background: var(--primary);
}
.toggle-switch .form-check-input:focus {
	box-shadow: none;
}
.toggle-switch .form-check-input:after {
	width: 1rem;
	background: #909090;
	height: 1rem;
	content: '';
	position: absolute;
	border-radius: 1.5rem;
	top: -0.0475rem;
	left: 0;
	transition: all 0.2s;
}
.toggle-switch.text-end {
	padding-right: 0rem;
	padding-left: 0;
}
.toggle-switch.text-end .form-check-input {
	left: auto;
	margin-left: 0;
	float: right;
	right: 0rem;
}
.toggle-switch.text-end .form-check-label {
	margin-right: 0.9375rem;
	margin-left: 0;
}
.toggle-switch .form-check-label {
	cursor: pointer;
}

.form-check-input:focus ~ .form-check-label::before {
	box-shadow: none !important;
}

.form-check-label::before {
	background-color: transparent;
	border-color: #ebebf9;
	border-width: 0.125rem;
	border-radius: 0.125rem !important;
}
[data-theme-version='dark'] .form-check-label::before {
	background-color: transparent;
	border-color: rgba(255, 255, 255, 0.1);
}

.check-xs .form-check-input {
	width: 1.125rem;
	height: 1.125rem;
}

.check-lg .form-check-input {
	width: 1.5rem;
	height: 1.5rem;
}

.check-xl .form-check-input {
	width: 1.75rem;
	height: 1.75rem;
}

.checkbox-info .form-check-input:focus {
	border-color: #00ada3;
	outline: 0;
	box-shadow: 0 0 0 0.25rem rgba(0, 173, 163, 0.25);
}

.checkbox-info .form-check-input:checked {
	background-color: #00ada3;
	border-color: #00ada3;
}

.checkbox-danger .form-check-input:focus {
	border-color: #fd5353;
	outline: 0;
	box-shadow: 0 0 0 0.25rem rgba(253, 83, 83, 0.25);
}

.checkbox-danger .form-check-input:checked {
	background-color: #fd5353;
	border-color: #fd5353;
}

.checkbox-success .form-check-input:focus {
	border-color: #1eba62;
	outline: 0;
	box-shadow: 0 0 0 0.25rem rgba(30, 186, 98, 0.25);
}

.checkbox-success .form-check-input:checked {
	background-color: #1eba62 !important;
	border-color: #1eba62;
}

.checkbox-warning .form-check-input:focus {
	border-color: #fcc43e;
	outline: 0;
	box-shadow: 0 0 0 0.25rem rgba(252, 196, 62, 0.25);
}

.checkbox-warning .form-check-input:checked {
	background-color: #fcc43e;
	border-color: #fcc43e;
}

.checkbox-secondary .form-check-input:focus {
	border-color: #fb7d5b;
	outline: 0;
	box-shadow: 0 0 0 0.25rem rgba(251, 125, 91, 0.25);
}

.checkbox-secondary .form-check-input:checked {
	background-color: #fb7d5b;
	border-color: #fb7d5b;
}

.check-switch {
	padding-left: 2.5rem;
}
.check-switch .form-check-label {
	line-height: 1.875rem;
	font-weight: 500;
}
.check-switch .form-check-label span {
	line-height: 1;
}
.check-switch .form-check-label:after,
.check-switch .form-check-label:before {
	height: 1.5rem;
	width: 1.5rem;
	left: -2rem;
	border-radius: 3rem !important;
	border-color: var(--rgba-primary-3);
}
.check-switch .form-check-input:checked ~ .form-check-label::before {
	background: #fff;
}

.form-check .form-check-input[type='radio'] {
	margin-left: -1em;
	top: 0.03rem;
}

.form-check-input:checked {
	background-color: var(--primary);
	border-color: var(--primary);
}

.form-check-input:focus {
	border-color: var(--primary);
	box-shadow: var(--rgba-primary-1);
}

.form-check-input[type='radio'] {
	width: 1.313rem;
	min-width: 1.313rem;
	height: 1.313rem;
	position: relative;
	border-color: #a5aab4;
	border-width: 0.125rem;
	border-style: solid;
	top: -0.125rem;
}
.form-check-input[type='radio']:focus {
	box-shadow: none;
}

.form-check-input[type='radio'] + .form-check-label {
	margin-bottom: 0;
}

.form-check-input:checked[type='radio'] {
	background-image: none;
	background-color: var(--rgba-primary-3);
	border-color: transparent !important;
}
.form-check-input:checked[type='radio']:after {
	content: '';
	height: 0.688rem;
	width: 0.688rem;
	background-color: var(--primary);
	position: absolute;
	top: 0.188rem;
	left: 0.188rem;
	border-radius: 50%;
}

.checkbox-info .form-check-input[type='radio'] {
	border-color: #00ada3;
}

.checkbox-info .form-check-input:checked[type='radio'] {
	background-color: #94fff9;
}
.checkbox-info .form-check-input:checked[type='radio']:after {
	background-color: #00ada3;
}

.checkbox-danger .form-check-input[type='radio'] {
	border-color: #fd5353;
}

.checkbox-danger .form-check-input:checked[type='radio'] {
	background-color: #ffeaea;
}
.checkbox-danger .form-check-input:checked[type='radio']:after {
	background-color: #fd5353;
}

.checkbox-success .form-check-input[type='radio'] {
	border-color: #1eba62;
}

.checkbox-success .form-check-input:checked[type='radio'] {
	background-color: #ddfaea;
}
.checkbox-success .form-check-input:checked[type='radio']:after {
	background-color: #1eba62;
}

.checkbox-warning .form-check-input[type='radio'] {
	border-color: #fcc43e;
}

.checkbox-warning .form-check-input:checked[type='radio'] {
	background-color: #fffaee;
}
.checkbox-warning .form-check-input:checked[type='radio']:after {
	background-color: #fcc43e;
}

.checkbox-dark .form-check-input[type='radio'] {
	border-color: #303972;
}

.checkbox-dark .form-check-input:checked[type='radio'] {
	background-color: white;
}
.checkbox-dark .form-check-input:checked[type='radio']:after {
	background-color: var(--primary);
}

.checkbox-secondary .form-check-input[type='radio'] {
	border-color: #fb7d5b;
}

.checkbox-secondary .form-check-input:checked[type='radio'] {
	background-color: #fff3f0;
}
.checkbox-secondary .form-check-input:checked[type='radio']:after {
	background-color: #fb7d5b;
}

.js-switch + .switchery {
	border-radius: 3.125rem;
	margin-right: 4rem;
}
@media (max-width: 575.98px) {
	.js-switch + .switchery {
		margin-right: 1rem;
	}
}
.js-switch + .switchery > small,
.js-switch + .switchery > .small {
	top: 0.125rem;
}

.js-switch.js-switch-lg + .switchery {
	height: 2rem;
	width: 4.5rem;
}
.js-switch.js-switch-lg + .switchery > small,
.js-switch.js-switch-lg + .switchery > .small {
	width: 1.75rem;
	height: 1.75rem;
}

.js-switch.js-switch-md + .switchery {
	height: 1.5rem;
	width: 3.5rem;
}
.js-switch.js-switch-md + .switchery > small,
.js-switch.js-switch-md + .switchery > .small {
	width: 1.25rem;
	height: 1.25rem;
}

.js-switch.js-switch-sm + .switchery {
	height: 1rem;
	width: 2.2rem;
}
.js-switch.js-switch-sm + .switchery > small,
.js-switch.js-switch-sm + .switchery > .small {
	width: 0.875rem;
	height: 0.875rem;
	top: 0.0625rem;
}

.js-switch-square + .switchery {
	border-radius: 0;
}
.js-switch-square + .switchery > small,
.js-switch-square + .switchery > .small {
	border-radius: 0;
	top: 0.125rem;
}

.js-switch-square.js-switch-lg + .switchery {
	height: 2rem;
	width: 4.5rem;
}
.js-switch-square.js-switch-lg + .switchery > small,
.js-switch-square.js-switch-lg + .switchery > .small {
	width: 1.75rem;
	height: 1.75rem;
}

.js-switch-square.js-switch-md + .switchery {
	height: 1.5rem;
	width: 3.5rem;
}
.js-switch-square.js-switch-md + .switchery > small,
.js-switch-square.js-switch-md + .switchery > .small {
	width: 1.25rem;
	height: 1.25rem;
}

.js-switch-square.js-switch-sm + .switchery {
	height: 1rem;
	width: 2.2rem;
}
.js-switch-square.js-switch-sm + .switchery > small,
.js-switch-square.js-switch-sm + .switchery > .small {
	width: 0.875rem;
	height: 0.875rem;
	top: 0.0625rem;
}

.form-control.is-valid {
	border-color: #1eba62 !important;
	border-right: 0rem !important;
}
.form-control.is-valid:focus {
	box-shadow: none;
}

.form-control.is-warning {
	border-color: #fcc43e !important;
	border-right: 0rem !important;
}
.form-control.is-warning:focus {
	box-shadow: none;
}

.form-control.is-invalid {
	border-color: #fd5353 !important;
	border-right: 0rem !important;
}
.form-control.is-invalid:focus {
	box-shadow: none;
}

.is-valid .input-group-prepend .input-group-text i {
	color: #1eba62;
}

.is-invalid .input-group-prepend .input-group-text i {
	color: var(--rgba-primary-2);
}

.show-pass {
	cursor: pointer;
}
.show-pass .fa-eye {
	display: none;
}
.show-pass.active .fa-eye-slash {
	display: none;
}
.show-pass.active .fa-eye {
	display: inline-block;
}

.asColorPicker-dropdown {
	max-width: 26rem;
}

.asColorPicker-trigger {
	background: none;
}

.asColorPicker-trigger {
	border: 0 none;
	height: 100%;
	position: absolute;
	right: 0;
	top: 0;
	width: 2.1875rem;
}

[direction='rtl'] .asColorPicker-trigger {
	left: 0;
	right: auto;
}

.asColorPicker-trigger span {
	border-radius: 0 0.425rem 0.425rem 0;
}

.asColorPicker-clear {
	display: none;
	position: absolute;
	right: 1rem;
	text-decoration: none;
	top: 0.5rem;
}

.daterangepicker td.active {
	background-color: var(--primary);
}
.daterangepicker td.active:hover {
	background-color: var(--primary);
}

.daterangepicker button.applyBtn {
	background-color: var(--primary);
	border-color: var(--primary);
}

.datepicker.datepicker-dropdown {
	background: #fff;
	border-radius: 0.0625rem;
	border: 0.0625rem solid #eeeeee;
}
.datepicker.datepicker-dropdown td.day,
.datepicker.datepicker-dropdown th.next,
.datepicker.datepicker-dropdown th.prev {
	height: 1.875rem;
	width: 1.875rem !important;
	padding: 0;
	text-align: center;
	font-weight: 500;
	border-radius: 0.375rem;
}
.datepicker.datepicker-dropdown td.day:hover,
.datepicker.datepicker-dropdown th.next:hover,
.datepicker.datepicker-dropdown th.prev:hover {
	box-shadow: unset;
	/*  color: \$main-color; */
	background-color: var(--rgba-primary-1);
}
.datepicker.datepicker-dropdown th.datepicker-switch,
.datepicker.datepicker-dropdown th.next,
.datepicker.datepicker-dropdown th.prev {
	font-weight: 600;
	color: #333;
}
.datepicker.datepicker-dropdown th.dow {
	font-weight: 600;
}

.datepicker table tr td.selected,
.datepicker table tr td.active.active {
	background-color: var(--primary);
	border-radius: 0.375rem;
	border: 0;
	color: #fff;
	background-image: none;
	position: relative;
}

.datepicker table tr td.today {
	border-radius: 0.375rem;
	/* color : \$main-color; */
}
.datepicker table tr td.today:hover {
	background-color: var(--primary);
	box-shadow: 0rem 0rem 1.875rem 0.3125rem rgba(243, 30, 122, 0.3);
	color: #ffffff;
}

.datepicker table tr td.today.disabled {
	box-shadow: 0rem 0rem 1.875rem 0.3125rem rgba(243, 30, 122, 0.3);
	color: #ffffff;
}
.datepicker table tr td.today.disabled:hover {
	box-shadow: 0rem 0rem 1.875rem 0.3125rem rgba(243, 30, 122, 0.3);
	color: #ffffff;
}

.datepicker table thead tr:first-child th:hover {
	background: var(--rgba-primary-1);
}

.datepicker table thead tr th:hover {
	background: var(--rgba-primary-1);
}

.datepicker table td.day:hover {
	background: var(--rgba-primary-1);
	border-radius: 0.375rem;
}

.picker__select--month,
.picker__select--year {
	height: 2.5em;
}

.picker__input {
	background-color: transparent !important;
}
[data-theme-version='dark'] .picker__input {
	background-color: transparent !important;
	border: 0.0625rem solid rgba(255, 255, 255, 0.1);
}

.bootstrap-select.form-control-lg .dropdown-toggle {
	min-height: 3.75rem;
	padding: 0.5rem 1.563rem;
}

.bootstrap-select.form-control-sm .dropdown-toggle {
	min-height: 2.5rem;
	padding: 0.25rem 1.563rem;
}

.basic-form .form-check-input[type='radio'] + .form-check-label {
	margin-top: 5px;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
	min-height: 2.5rem;
	padding: 0.25rem 1.1rem;
	border-radius: 0.375rem;
}

.input-group.input-group-lg {
	min-height: 3.75rem;
	border-radius: 0.375rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
	border-radius: 0.375rem;
}

.clockpicker-popover .popover-title {
	padding: 0.625rem 0px;
}

.picker-data .color-time-picker .react-time-picker {
	width: 100%;
}

.picker-data .color-time-picker .react-time-picker__wrapper {
	border: 0;
	color: #7e7e7e;
}
.picker-data .color-time-picker .react-time-picker__wrapper .react-time-picker__clear-button {
	display: none;
}
.picker-data .color-time-picker .react-time-picker__wrapper .react-time-picker__inputGroup {
	border: 1px solid #b7b7b7;
	border-width: 0 0 1px 0;
	padding: 0.35rem 0rem;
}
.picker-data .color-time-picker .react-time-picker__wrapper .react-time-picker__inputGroup__input {
	color: #7e7e7e;
}
.picker-data .color-time-picker .react-time-picker__wrapper .react-time-picker__inputGroup__amPm {
	color: #7e7e7e;
	appearance: none;
}
.picker-data .color-time-picker .react-time-picker__wrapper .react-time-picker__clock-button {
	background: #4d44b5;
	color: #b7b7b7;
	padding: 0.532rem 0.75rem;
	border-radius: 0 0.75rem 0.75rem 0;
	min-width: 3.125rem;
	text-align: center;
	line-height: 1;
}
.picker-data .color-time-picker .react-time-picker__wrapper .react-time-picker__clock-button svg {
	stroke: #fff;
	display: inline-block;
}

.picker-data .color-time-picker .react-clock__face {
	background: #ededed;
	padding: 0.625rem 0.625rem;
	border: 0.625rem solid #ededed;
}

.picker-data .color-time-picker .react-clock__hand__body {
	background-color: #4d44b5;
}

.picker-data .color-time-picker .react-time-picker__clock {
	box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
	border-radius: 4px;
	border: 0 !important;
}

.picker-data .color-time-picker.style-1 .react-time-picker__wrapper .react-time-picker__clock-button {
	display: none;
}

.color-gradian-tixia .gpw {
	padding: 0;
}

.color-gradian-tixia .gpw .trigger .inner {
	height: 1.5rem;
	width: 6.25rem;
}

#image {
	max-width: 100%;
}

.docs-options .dropdown-menu {
	padding: 1.5rem;
}

.docs-preview {
	margin-bottom: 3rem;
}
.docs-preview .img-preview {
	float: left;
	margin-right: 0.5rem;
	margin-bottom: 0.5rem;
	overflow: hidden;
	max-width: 100% !important;
}
.docs-preview .img-preview > img {
	max-width: 100% !important;
}
.docs-preview .img-preview.preview-lg {
	width: 16rem;
	height: 9rem;
}
.docs-preview .img-preview.preview-md {
	width: 8rem;
	height: 4.5rem;
}
.docs-preview .img-preview.preview-sm {
	width: 4rem;
	height: 2.25rem;
}
.docs-preview .img-preview.preview-xs {
	width: 2rem;
	height: 1.125rem;
	margin-right: 0;
}

.select2-container {
	width: 100% !important;
}

.select2-container--default .select2-selection--single {
	border-radius: 0.375rem;
	border: 0.0625rem solid #dddddd;
	height: 3rem;
	background: #fff;
}
[data-theme-version='dark'] .select2-container--default .select2-selection--single {
	background: #202020;
	border-color: rgba(255, 255, 255, 0.1);
}
.select2-container--default .select2-selection--single:hover,
.select2-container--default .select2-selection--single:focus,
.select2-container--default .select2-selection--single.active {
	box-shadow: none;
}

.destroy-selector,
.single-event-unbind {
	width: 100%;
	border-color: #eeee;
	height: 45px;
	padding: 0 13px;
	border-radius: 10px;
}

.select2-container--default .select2-selection--single .select2-selection__rendered {
	line-height: 3rem;
	color: #a098ae;
	padding-left: 0.9375rem;
	min-height: 2.5rem;
}

.select2-container--default .select2-selection--multiple {
	border-color: #dddddd;
	border-radius: 0;
}

.select2-dropdown {
	border-radius: 0;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
	background-color: var(--primary);
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
	border-color: #dddddd;
	background: #fff;
	padding: 0.2rem 0;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
	top: 0.675rem;
	right: 0.9375rem;
}

.select2-container .select2-selection--multiple {
	min-height: 3rem;
	color: #a098ae;
	border-radius: 0.375rem;
	border: 0.0625rem solid #dddddd;
}
[data-theme-version='dark'] .select2-container .select2-selection--multiple {
	background: #202020;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .select2-search--dropdown .select2-search__field {
	background: #272738;
	border-color: rgba(255, 255, 255, 0.1);
	color: rgba(255, 255, 255, 0.6);
}

.select2-dropdown {
	border-color: #ebebf9;
}
[data-theme-version='dark'] .select2-dropdown {
	background: #202020;
	border-color: rgba(255, 255, 255, 0.1);
}

.select2-container .select2-selection--multiple .select2-selection__rendered {
	padding: 2px 12px;
}

.swal2-popup .swal2-content {
	color: #a098ae;
}

:root {
	--primary: #4d44b5;
	--secondary: #fb7d5b;
	--primary-hover: #3d3690;
	--primary-dark: #1e1a46;
	--rgba-primary-1: rgba(77, 68, 181, 0.1);
	--rgba-primary-2: rgba(77, 68, 181, 0.2);
	--rgba-primary-3: rgba(77, 68, 181, 0.3);
	--rgba-primary-4: rgba(77, 68, 181, 0.4);
	--rgba-primary-5: rgba(77, 68, 181, 0.5);
	--rgba-primary-6: rgba(77, 68, 181, 0.6);
	--rgba-primary-7: rgba(77, 68, 181, 0.7);
	--rgba-primary-8: rgba(77, 68, 181, 0.8);
	--rgba-primary-9: rgba(77, 68, 181, 0.9);
	--rgba-secondary-1: rgba(251, 125, 91, 0.1);
	--rgba-secondary-2: rgba(251, 125, 91, 0.2);
	--rgba-secondary-3: rgba(251, 125, 91, 0.3);
	--rgba-secondary-4: rgba(251, 125, 91, 0.4);
	--rgba-secondary-5: rgba(251, 125, 91, 0.5);
	--rgba-secondary-6: rgba(251, 125, 91, 0.6);
	--rgba-secondary-7: rgba(251, 125, 91, 0.7);
	--rgba-secondary-8: rgba(251, 125, 91, 0.8);
	--rgba-secondary-9: rgba(251, 125, 91, 0.9);
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--title: #303972;
}

/*
0 - 600: Phone
600 - 900: Tablet portrait
900 - 1200: Tablet landscape
1200 - 1800: Normal styles
1800+ : Big Desktop
1em = 16px
The smaller device rules always should write below the bigger device rules
Fixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component
*/
.form-wizard {
	border: 0;
}
.form-wizard .nav-wizard {
	box-shadow: none !important;
	margin-bottom: 2rem;
}
.form-wizard .nav-wizard #RFS-ConnectorContainer {
	display: none;
}
.form-wizard .nav-wizard .nav-link {
	position: relative;
	display: block;
	width: 100%;
	height: 100%;
	background-color: transparent !important;
}
.form-wizard .nav-wizard .nav-link span {
	border-radius: 3.125rem;
	width: 3rem;
	height: 3rem;
	border: 0.125rem solid var(--primary);
	display: block;
	line-height: 3rem;
	color: var(--primary);
	font-size: 1.125rem;
	margin: auto;
	background-color: #fff;
	position: relative;
	z-index: 1;
}
.form-wizard .nav-wizard .nav-link:after {
	content: '' !important;
	position: absolute;
	top: 50%;
	left: 50%;
	height: 0.1875rem;
	transform: translateY(-50%);
	background: #bec3e3 !important;
	z-index: 0;
	width: 100%;
}
.form-wizard .nav-wizard .nav-link.active span {
	background: var(--primary);
	color: #fff;
}
.form-wizard .nav-wizard .nav-link.active:after {
	background: var(--primary) !important;
}
.form-wizard .nav-wizard .nav-link.completed span {
	background-color: var(--primary);
	color: #fff;
}
.form-wizard .nav-wizard .nav-link.completed:after {
	background: var(--primary) !important;
}
.form-wizard .nav-wizard > div:last-child .nav-link:after {
	display: none;
}
.form-wizard .toolbar-bottom .btn {
	border: 0;
	padding: 0.75rem 1.125rem;
}
.form-wizard .tab-content .tab-pane {
	padding: 0;
}
.form-wizard .emial-setup label.mailclinet {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	width: 10rem;
	height: 10rem;
	border-radius: 50%;
	cursor: pointer;
	background-color: #eef5f9;
	text-align: center;
	margin: auto;
}
[data-theme-version='dark'] .form-wizard .emial-setup label.mailclinet {
	background-color: #202020;
}
@media only screen and (max-width: 35.9375rem) {
	.form-wizard .emial-setup label.mailclinet {
		width: 7rem;
		height: 7rem;
	}
}
.form-wizard .emial-setup label.mailclinet .mail-icon {
	font-size: 3rem;
	display: inline-block;
	line-height: 1;
	margin-top: -1rem;
}
@media only screen and (max-width: 35.9375rem) {
	.form-wizard .emial-setup label.mailclinet .mail-icon {
		font-size: 2rem;
	}
}
.form-wizard .emial-setup label.mailclinet .mail-text {
	font-size: 1rem;
	text-align: center;
	margin-top: 0.5rem;
}
@media only screen and (max-width: 35.9375rem) {
	.form-wizard .emial-setup label.mailclinet .mail-text {
		font-size: 0.75rem;
		line-height: 1.25rem;
	}
}
.form-wizard .emial-setup label.mailclinet input[type='radio'] {
	display: none;
}
@media only screen and (max-width: 47.9375rem) {
	.form-wizard .nav-wizard {
		flex-direction: unset !important;
	}
	.form-wizard .tab-content {
		height: 100% !important;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.form-wizard .nav-wizard li .nav-link {
		padding: 0;
	}
}

.wizard-style-one {
	border: 0;
	padding: 0 100px;
}
.wizard-style-one .nav-wizard {
	margin-bottom: 40px;
	box-shadow: none;
}
.wizard-style-one label {
	font-size: 14px;
	font-weight: 500;
	color: #000;
}
.wizard-style-one .tab-content {
	overflow: visible;
}

.custom-ekeditor ul {
	padding-left: 1.25rem;
}
.custom-ekeditor ul li {
	list-style: unset;
}

.custom-ekeditor ol li {
	list-style: decimal;
}

.ql-container {
	height: 25rem;
}

#world-datamap {
	padding-bottom: 46% !important;
}

.datamaps-hoverover {
	background: #fff;
	padding: 0.3125rem;
	border-radius: 0.3125rem;
	font-family: 'Roboto' !important;
	color: var(--primary);
	border: 0.0625rem solid var(--rgba-primary-3);
}

@media only screen and (max-width: 90rem) {
	.world_map_card ul.list-group {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		margin-top: 2.1875rem;
	}
}

.jqvmap-zoomin,
.jqvmap-zoomout {
	height: 1.25rem;
	width: 1.25rem;
	line-height: 0.875rem;
	background-color: var(--primary);
	color: #fff;
}

.jqvmap-zoomout {
	top: 2.1875rem;
}

#world-map,
#usa {
	height: 25rem;
}
@media only screen and (max-width: 61.9375rem) {
	#world-map,
	#usa {
		height: 21.875rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	#world-map,
	#usa {
		height: 14.375rem;
	}
}

.blockUI.blockMsg.blockPage {
	border: 0 !important;
}

#loginForm {
	cursor: auto;
}

.blockMsg {
	border: 0rem;
	width: 20% !important;
}
.blockMsg h1,
.blockMsg .h1 {
	font-size: 1rem;
	padding: 0.5rem 0;
	margin-bottom: 0;
}

.bootstrap-select {
	margin-bottom: 0;
}
.bootstrap-select .btn {
	background-color: transparent !important;
	font-weight: 400;
}
[data-theme-version='dark'] .bootstrap-select .btn {
	border-color: rgba(255, 255, 255, 0.1) !important;
	background: #383844 !important;
}
.bootstrap-select .btn:active,
.bootstrap-select .btn:focus,
.bootstrap-select .btn:hover {
	outline: none !important;
	outline-offset: 0;
}
[data-theme-version='dark'] .bootstrap-select .btn:active,
[data-theme-version='dark'] .bootstrap-select .btn:focus,
[data-theme-version='dark'] .bootstrap-select .btn:hover {
	color: #a098ae !important;
}
.bootstrap-select .dropdown-menu {
	border-color: #f2f2f2 !important;
	box-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);
}
.bootstrap-select .dropdown-menu .dropdown-item {
	font-size: 0.875rem;
}
[data-theme-version='dark'] .bootstrap-select .dropdown-menu {
	border-color: #f2f2f2 !important;
}

.input-group > .bootstrap-select:not(:first-child) .dropdown-toggle {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
}

.input-group > .bootstrap-select:not(:last-child) .dropdown-toggle {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}

:root {
	--primary: #4d44b5;
	--secondary: #fb7d5b;
	--primary-hover: #3d3690;
	--primary-dark: #1e1a46;
	--rgba-primary-1: rgba(77, 68, 181, 0.1);
	--rgba-primary-2: rgba(77, 68, 181, 0.2);
	--rgba-primary-3: rgba(77, 68, 181, 0.3);
	--rgba-primary-4: rgba(77, 68, 181, 0.4);
	--rgba-primary-5: rgba(77, 68, 181, 0.5);
	--rgba-primary-6: rgba(77, 68, 181, 0.6);
	--rgba-primary-7: rgba(77, 68, 181, 0.7);
	--rgba-primary-8: rgba(77, 68, 181, 0.8);
	--rgba-primary-9: rgba(77, 68, 181, 0.9);
	--rgba-secondary-1: rgba(251, 125, 91, 0.1);
	--rgba-secondary-2: rgba(251, 125, 91, 0.2);
	--rgba-secondary-3: rgba(251, 125, 91, 0.3);
	--rgba-secondary-4: rgba(251, 125, 91, 0.4);
	--rgba-secondary-5: rgba(251, 125, 91, 0.5);
	--rgba-secondary-6: rgba(251, 125, 91, 0.6);
	--rgba-secondary-7: rgba(251, 125, 91, 0.7);
	--rgba-secondary-8: rgba(251, 125, 91, 0.8);
	--rgba-secondary-9: rgba(251, 125, 91, 0.9);
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--title: #303972;
}

.clipboard-btn {
	transition: all 0.1s ease-in-out;
}
.clipboard-btn:hover {
	background-color: var(--primary);
	color: #fff;
}

:root {
	--primary: #4d44b5;
	--secondary: #fb7d5b;
	--primary-hover: #3d3690;
	--primary-dark: #1e1a46;
	--rgba-primary-1: rgba(77, 68, 181, 0.1);
	--rgba-primary-2: rgba(77, 68, 181, 0.2);
	--rgba-primary-3: rgba(77, 68, 181, 0.3);
	--rgba-primary-4: rgba(77, 68, 181, 0.4);
	--rgba-primary-5: rgba(77, 68, 181, 0.5);
	--rgba-primary-6: rgba(77, 68, 181, 0.6);
	--rgba-primary-7: rgba(77, 68, 181, 0.7);
	--rgba-primary-8: rgba(77, 68, 181, 0.8);
	--rgba-primary-9: rgba(77, 68, 181, 0.9);
	--rgba-secondary-1: rgba(251, 125, 91, 0.1);
	--rgba-secondary-2: rgba(251, 125, 91, 0.2);
	--rgba-secondary-3: rgba(251, 125, 91, 0.3);
	--rgba-secondary-4: rgba(251, 125, 91, 0.4);
	--rgba-secondary-5: rgba(251, 125, 91, 0.5);
	--rgba-secondary-6: rgba(251, 125, 91, 0.6);
	--rgba-secondary-7: rgba(251, 125, 91, 0.7);
	--rgba-secondary-8: rgba(251, 125, 91, 0.8);
	--rgba-secondary-9: rgba(251, 125, 91, 0.9);
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--title: #303972;
}

.bootstrap-tagsinput {
	flex: 1 1;
	padding: 0;
	padding-left: 0.5rem;
	border-radius: 0;
	border-color: #f2f2f2;
	background-color: #fff;
	width: 100%;
}
.bootstrap-tagsinput .tag {
	font-size: 0.875rem;
	background-color: var(--primary);
	border-radius: 0;
	align-items: center;
	border: 0.0625rem solid #f2f2f2;
}
.bootstrap-tagsinput input[type='text'] {
	flex: 1 1;
	height: 2.1rem;
	border-radius: 0;
	border-color: #f2f2f2;
}
.bootstrap-tagsinput label {
	margin-bottom: 0.5rem;
}

:root {
	--primary: #4d44b5;
	--secondary: #fb7d5b;
	--primary-hover: #3d3690;
	--primary-dark: #1e1a46;
	--rgba-primary-1: rgba(77, 68, 181, 0.1);
	--rgba-primary-2: rgba(77, 68, 181, 0.2);
	--rgba-primary-3: rgba(77, 68, 181, 0.3);
	--rgba-primary-4: rgba(77, 68, 181, 0.4);
	--rgba-primary-5: rgba(77, 68, 181, 0.5);
	--rgba-primary-6: rgba(77, 68, 181, 0.6);
	--rgba-primary-7: rgba(77, 68, 181, 0.7);
	--rgba-primary-8: rgba(77, 68, 181, 0.8);
	--rgba-primary-9: rgba(77, 68, 181, 0.9);
	--rgba-secondary-1: rgba(251, 125, 91, 0.1);
	--rgba-secondary-2: rgba(251, 125, 91, 0.2);
	--rgba-secondary-3: rgba(251, 125, 91, 0.3);
	--rgba-secondary-4: rgba(251, 125, 91, 0.4);
	--rgba-secondary-5: rgba(251, 125, 91, 0.5);
	--rgba-secondary-6: rgba(251, 125, 91, 0.6);
	--rgba-secondary-7: rgba(251, 125, 91, 0.7);
	--rgba-secondary-8: rgba(251, 125, 91, 0.8);
	--rgba-secondary-9: rgba(251, 125, 91, 0.9);
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--title: #303972;
}

.twitter-typeahead {
	width: 100%;
}
.twitter-typeahead .tt-dataset.tt-dataset-states {
	border: 1px solid #f2f2f2;
}
.twitter-typeahead .tt-menu {
	width: 100%;
	background-color: #fff;
}
.twitter-typeahead .tt-menu .tt-suggestion {
	padding: 0.625rem;
	cursor: pointer;
}
.twitter-typeahead .tt-menu .tt-suggestion:hover {
	background-color: var(--primary);
	color: #fff;
}

.weather-one i {
	font-size: 8rem;
	position: relative;
	top: 0.5rem;
}

.weather-one h2,
.weather-one .h2 {
	display: inline-block;
	float: right;
	font-size: 4.8rem;
}

.weather-one .city {
	position: relative;
	text-align: right;
	top: -2.5rem;
}

.weather-one .currently {
	font-size: 1.6rem;
	font-weight: 400;
	position: relative;
	top: 2.5rem;
}

.weather-one .celcious {
	text-align: right;
	font-size: 2rem;
}

:root {
	--primary: #4d44b5;
	--secondary: #fb7d5b;
	--primary-hover: #3d3690;
	--primary-dark: #1e1a46;
	--rgba-primary-1: rgba(77, 68, 181, 0.1);
	--rgba-primary-2: rgba(77, 68, 181, 0.2);
	--rgba-primary-3: rgba(77, 68, 181, 0.3);
	--rgba-primary-4: rgba(77, 68, 181, 0.4);
	--rgba-primary-5: rgba(77, 68, 181, 0.5);
	--rgba-primary-6: rgba(77, 68, 181, 0.6);
	--rgba-primary-7: rgba(77, 68, 181, 0.7);
	--rgba-primary-8: rgba(77, 68, 181, 0.8);
	--rgba-primary-9: rgba(77, 68, 181, 0.9);
	--rgba-secondary-1: rgba(251, 125, 91, 0.1);
	--rgba-secondary-2: rgba(251, 125, 91, 0.2);
	--rgba-secondary-3: rgba(251, 125, 91, 0.3);
	--rgba-secondary-4: rgba(251, 125, 91, 0.4);
	--rgba-secondary-5: rgba(251, 125, 91, 0.5);
	--rgba-secondary-6: rgba(251, 125, 91, 0.6);
	--rgba-secondary-7: rgba(251, 125, 91, 0.7);
	--rgba-secondary-8: rgba(251, 125, 91, 0.8);
	--rgba-secondary-9: rgba(251, 125, 91, 0.9);
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--title: #303972;
}

.noUi-target {
	border-color: transparent;
	border-radius: 0;
}

.noUi-connect {
	background-color: var(--primary);
}
.noUi-connects {
	background-color: #d2d6de;
}
.noUi-connect.c-1-color {
	background-color: #1eba62;
}
.noUi-connect.c-2-color {
	background-color: #00ada3;
}
.noUi-connect.c-3-color {
	background-color: var(--primary);
}
.noUi-connect.c-4-color {
	background-color: #fcc43e;
}

.noUi-vertical {
	width: 0.375rem;
}

.noUi-horizontal {
	height: 0.125rem;
	border: 0;
	margin-bottom: 0.625rem;
}

.noUi-horizontal .noUi-handle,
.noUi-vertical .noUi-handle {
	height: 0.9375rem;
	width: 0.9375rem;
	border-radius: 3.125rem;
	box-shadow: none;
	border: none;
	background-color: var(--primary);
}
.noUi-horizontal .noUi-handle::after,
.noUi-horizontal .noUi-handle::before,
.noUi-vertical .noUi-handle::after,
.noUi-vertical .noUi-handle::before {
	display: none;
}

.noUi-vertical .noUi-handle {
	left: -0.35rem;
	top: -0.375rem;
}

.noUi-horizontal .noUi-handle {
	top: -0.4375rem;
	cursor: pointer;
}

html:not([dir='rtl']) .noUi-horizontal .noUi-handle {
	right: -0.375rem;
}

#slider-toggle {
	height: 3.125rem;
}

#slider-toggle.off .noUi-handle {
	border-color: var(--primary);
}

.colorpicker-slider .sliders.noUi-target#red,
.colorpicker-slider .sliders.noUi-target#green,
.colorpicker-slider .sliders.noUi-target#blue {
	margin: 0.625rem;
	display: inline-block;
	height: 12.5rem;
}

.colorpicker-slider .sliders.noUi-target#red .noUi-connect {
	background: #c0392b;
}

.colorpicker-slider .sliders.noUi-target#green .noUi-connect {
	background: #27ae60;
}

.colorpicker-slider .sliders.noUi-target#blue .noUi-connect {
	background: #2980b9;
}

.colorpicker-slider #result {
	margin: 3.75rem 1.625rem;
	height: 6.25rem;
	width: 6.25rem;
	display: inline-block;
	vertical-align: top;
	color: #7f7f7f;
	background: #7f7f7f;
	border: 0.0625rem solid #fff;
	box-shadow: 0 0 0.625rem;
}

.slider-vertical {
	height: 18rem;
}

.nestable-cart {
	overflow: hidden;
}

.dd-handle {
	color: #fff;
	background: var(--primary);
	border-radius: 0.3125rem;
	padding: 0.5rem 1rem;
	height: auto;
	border: 1px solid #f2f2f2;
}

.dd-handle:hover {
	color: #fff;
	background: var(--primary);
}

.dd3-content:hover {
	color: #fff;
	background: var(--primary);
}

.dd3-content {
	color: #fff;
}

.dd-item > button {
	line-height: 28px;
	color: #fff;
}

.pignose-calendar {
	box-shadow: none;
	width: 100%;
	max-width: none;
	border-color: var(--primary);
}
.pignose-calendar .pignose-calendar-top-date {
	background-color: var(--primary);
}
.pignose-calendar .pignose-calendar-top-date .pignose-calendar-top-month {
	color: #fff;
}

.pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {
	background-color: var(--primary);
	box-shadow: none;
}

.pignose-calendar .pignose-calendar-top {
	box-shadow: none;
	border-bottom: 0;
}

.pignose-calendar.pignose-calendar-blue {
	background-color: rgba(0, 0, 0, 0.15);
}

.pignose-calendar .pignose-calendar-unit {
	height: 4.8em;
}

.cd-h-timeline {
	opacity: 0;
	transition: opacity 0.2s;
}

.cd-h-timeline--loaded {
	opacity: 1;
}

.cd-h-timeline__container {
	position: relative;
	height: 6.25rem;
	max-width: 50rem;
}

.cd-h-timeline__dates {
	position: relative;
	height: 100%;
	margin: 0 2.5rem;
	overflow: hidden;
}
.cd-h-timeline__dates::after,
.cd-h-timeline__dates::before {
	content: '';
	position: absolute;
	z-index: 2;
	top: 0;
	height: 100%;
	width: 1.25rem;
}
.cd-h-timeline__dates::before {
	left: 0;
	background: var(--primary);
}
.cd-h-timeline__dates::after {
	right: 0;
	background: var(--primary);
}

.cd-h-timeline__line {
	position: absolute;
	z-index: 1;
	left: 0;
	top: 3.0625rem;
	height: 0.125rem;
	background-color: var(--primary);
	transition: transform 0.4s;
}

.cd-h-timeline__filling-line {
	position: absolute;
	z-index: 1;
	left: 0;
	top: 0;
	height: 100%;
	width: 100%;
	background-color: #1eba62;
	transform: scaleX(0);
	transform-origin: left center;
	transition: transform 0.3s;
}

.cd-h-timeline__date {
	position: absolute;
	bottom: 0;
	z-index: 2;
	text-align: center;
	font-size: 0.8em;
	padding-bottom: var(--space-sm);
	color: var(--cd-color-1);
	-webkit-user-select: none;
	        user-select: none;
	text-decoration: none;
}
.cd-h-timeline__date::after {
	content: '';
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	bottom: -0.3125rem;
	height: 0.75rem;
	width: 0.75rem;
	border-radius: 50%;
	border-width: 0.125rem;
	border-style: solid;
	border-color: var(--rgba-primary-6);
	background-color: var(--primary);
	transition: background-color 0.3s, border-color 0.3s;
}
.cd-h-timeline__date:hover::after {
	background-color: #1eba62;
	border-color: #1eba62;
}

.cd-h-timeline__date--selected {
	pointer-events: none;
}
.cd-h-timeline__date--selected::after {
	background-color: #1eba62;
	border-color: #1eba62;
}

.cd-h-timeline__date--older-event::after {
	border-color: #1eba62;
}

.cd-h-timeline__navigation {
	position: absolute;
	z-index: 1;
	top: 50%;
	transform: translateY(-50%);
	height: 2.125rem;
	width: 2.125rem;
	border-radius: 50%;
	border-width: 0.125rem;
	border-style: solid;
	border-color: var(--rgba-primary-6);
	transition: border-color 0.3s;
}
.cd-h-timeline__navigation::after {
	content: '';
	position: absolute;
	height: 1rem;
	width: 1rem;
	top: 50%;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
}
.cd-h-timeline__navigation:hover {
	border-color: #1eba62;
}

.cd-h-timeline__navigation--prev {
	left: 0;
	transform: translateY(-50%) rotate(180deg);
}

.cd-h-timeline__navigation--next {
	right: 0;
}

.cd-h-timeline__navigation--inactive {
	cursor: not-allowed;
}
.cd-h-timeline__navigation--inactive::after {
	background-position: 0 -1rem;
}
.cd-h-timeline__navigation--inactive:hover {
	border-color: var(--rgba-primary-6);
}

.cd-h-timeline__events {
	position: relative;
	width: 100%;
	overflow: hidden;
	transition: height 0.4s;
}

.cd-h-timeline__event {
	position: absolute;
	z-index: 1;
	width: 100%;
	left: 0;
	top: 0;
	transform: translateX(-100%);
	padding: 0.0625rem 5%;
	opacity: 0;
	animation-duration: 0.4s;
	animation-timing-function: ease-in-out;
}

.cd-h-timeline__event--selected {
	position: relative;
	z-index: 2;
	opacity: 1;
	transform: translateX(0);
}

.cd-h-timeline__event--enter-right,
.cd-h-timeline__event--leave-right {
	animation-name: cd-enter-right;
}

.cd-h-timeline__event--enter-left,
.cd-h-timeline__event--leave-left {
	animation-name: cd-enter-left;
}

.cd-h-timeline__event--leave-right,
.cd-h-timeline__event--leave-left {
	animation-direction: reverse;
}

.cd-h-timeline__event-content {
	max-width: 50rem;
}

.cd-h-timeline__event-title {
	color: var(--cd-color-1);
	font-family: var(--font-secondary);
	font-weight: 700;
	font-size: var(--text-xxxl);
}

.cd-h-timeline__event-date {
	display: block;
	font-style: italic;
	margin: var(--space-xs) auto;
}
.cd-h-timeline__event-date::before {
	content: '- ';
}

@keyframes cd-enter-right {
	0% {
		opacity: 0;
		transform: translateX(100%);
	}
	100% {
		opacity: 1;
		transform: translateX(0%);
	}
}

@keyframes cd-enter-left {
	0% {
		opacity: 0;
		transform: translateX(-100%);
	}
	100% {
		opacity: 1;
		transform: translateX(0%);
	}
}

.toast-success {
	background-color: var(--primary);
}

.toast-info {
	background-color: #00ada3;
}

.toast-warning {
	background-color: #fcc43e;
}

.toast-error {
	background-color: #fd5353;
}

#toast-container > div {
	box-shadow: none;
	border-radius: 0.375rem;
	width: auto;
	max-width: 15.625rem;
	opacity: 1;
}
[direction='rtl'] #toast-container > div {
	padding: 0.9375rem 3.125rem 0.9375rem 0.9375rem;
	background-position: calc(100% - 0.9375rem);
	text-align: right;
}
#toast-container > div:hover {
	box-shadow: none;
}

#toast-container .toast-title {
	margin-bottom: 0.3125rem;
	font-weight: 600;
}

#toast-container .toast-message {
	font-size: 0.75rem;
}

#toast-container .toast-close-button {
	opacity: 1;
	font-size: 1.25rem;
	font-weight: normal;
	text-shadow: none;
}

#toast-container.toast-bottom-full-width > div,
#toast-container.toast-top-full-width > div {
	width: 100%;
	min-width: 300px;
	display: block;
	padding: 15px 15px 18px 60px;
	box-shadow: 0 0 50px rgba(0, 0, 0, 0.15);
}

.toast-progress {
	background-color: #fff;
}

[direction='rtl'] .toast-top-right.demo_rtl_class {
	left: 0.75rem;
	right: auto;
}

/* Light Gallery */
.lg-actions .lg-next,
.lg-actions .lg-prev,
.lg-sub-html,
.lg-toolbar {
	background-color: rgba(30, 30, 30, 0.6);
}

.lg-outer .lg-toogle-thumb,
.lg-outer .lg-thumb-outer,
.lg-outer .lg-img-wrap,
.lg-outer .lg-item {
	background-color: transparent;
}

.lg-thumb-outer.lg-grab,
.lg-toogle-thumb.lg-icon {
	background-color: rgba(30, 30, 30, 0.6);
}

.lg-backdrop {
	background-color: rgba(30, 30, 30, 0.9);
}

.lg-outer .lg-toogle-thumb,
.lg-actions .lg-next,
.lg-actions .lg-prev,
.lg-toolbar .lg-icon,
#lg-counter {
	color: #fff;
}

.lg-outer .lg-thumb-item.active,
.lg-outer .lg-thumb-item:hover {
	border-color: var(--primary);
}

.lightimg {
	cursor: pointer;
}

.jqvmap-zoomin,
.jqvmap-zoomout {
	position: absolute;
	left: 0.625rem;
	border-radius: 0.1875rem;
	background: #000000;
	padding: 0.1875rem;
	color: white;
	width: 1.0625rem;
	height: 1.0625rem;
	cursor: pointer;
	line-height: 0.625rem;
	text-align: center;
}

.jqvmap-zoomin {
	top: 0.625rem;
}

.jqvmap-zoomout {
	top: 1.875rem;
}

.ps__rail-x:hover,
.ps__rail-y:hover,
.ps__rail-x:focus,
.ps__rail-y:focus,
.ps__rail-x.ps--clicking,
.ps__rail-y.ps--clicking {
	background-color: transparent !important;
	opacity: 0.9;
}

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y {
	background-color: #dae2f3;
	width: 0.25rem;
}

.ps__thumb-y {
	background-color: #dae2f3;
	width: 0.25rem;
}

.total-average {
	position: relative;
	height: 18.75rem;
}

.widget-chat {
	position: relative;
	height: 15.625rem;
}

.widget-todo {
	position: relative;
	height: 13.125rem;
}

.widget-team {
	position: relative;
	height: 17.8125rem;
}

.widget-timeline {
	position: relative;
}

.widget-comments {
	position: relative;
	height: 25rem;
}

.sidebar-right-inner {
	position: relative;
	height: 100%;
}

.widget-team .ps .ps__rail-x:hover,
.widget-team .ps .ps__rail-y:hover,
.widget-team .ps .ps__rail-x:focus,
.widget-team .ps .ps__rail-y:focus,
.widget-team .ps .ps__rail-x.ps--clicking,
.widget-team .ps .ps__rail-y.ps--clicking {
	background-color: transparent !important;
	opacity: 0.9;
}

.ck.ck-editor .ck.ck-button {
	padding: 6px 8px;
	background-color: var(--rgba-primary-1);
	color: var(--primary);
	font-weight: 900;
	cursor: pointer;
}

.ck.ck-editor .ck.ck-toolbar {
	background-color: var(--bs-card-bg);
	border-color: #dddddd;
	border-radius: 0.375rem;
	padding: 5px 10px;
}

.ck.ck-editor .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar {
	border-radius: 0.375rem !important;
}

.ck.ck-editor .ck.ck-toolbar__separator {
	display: none !important;
}

.ck.ck-editor .ck-content {
	background-color: #f7f7f7;
	border-width: 1px 0 0;
	border-color: #e7e5ef;
}

.ck-editor__editable {
	background-color: var(--bs-card-bg) !important;
}

.ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred {
	border-color: #dddddd;
	padding: 0.865rem var(--ck-spacing-standard);
}

.ck.ck-toolbar .ck-toolbar__items .ck.ck-toolbar__separator {
	background: #dddddd;
}

.ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred {
	min-height: 9.375rem;
	border-width: 1px;
}

button.ck.ck-button.ck-off:hover {
	background-color: #dddddd;
}

.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused {
	min-height: 9.375rem;
}

.editor-title .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred,
.editor-title .ck-focused {
	width: 57.313rem;
}
@media only screen and (max-width: 87.5rem) {
	.editor-title .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred,
	.editor-title .ck-focused {
		width: 100%;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.editor-title .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred,
	.editor-title .ck-focused {
		width: 500px;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.editor-title .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred,
	.editor-title .ck-focused {
		width: 100%;
	}
}

.fc-h-event,
.fc-v-event {
	background: var(--primary);
	border-radius: 0.42rem;
}

.fc-h-event .fc-event-title {
	color: #fff;
}

.fc-theme-standard td,
.fc-theme-standard th {
	border-color: #ebedf3;
}

.fc-unthemed .fc-h-event,
.fc-unthemed .fc-event-dot {
	padding: 0;
	border-radius: 0.42rem;
}

.fc-theme-standard th {
	padding: 0.75rem 0.5rem;
	font-size: 1rem;
	font-weight: 500;
	color: #b5b5c3;
}
@media only screen and (max-width: 35.9375rem) {
	.fc-theme-standard th {
		font-size: 14px;
		font-weight: 400;
		padding: 3px 0px;
	}
}

.fc-theme-standard .fc-scrollgrid.fc-scrollgrid-liquid,
.fc-scrollgrid,
table {
	border-color: #ebedf3;
}

.fc-daygrid-dot-event {
	background: #fff;
	border: 1px solid #ebedf3;
	box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.1);
}
.fc-daygrid-dot-event .fc-daygrid-event-dot {
	border-color: var(--primary);
}

.fc-daygrid-dot-event .fc-event-title {
	font-weight: 500;
}

.fc-event.bg-primary,
.fc-event.bg-success,
.fc-event.bg-warning,
.fc-event.bg-secondary,
.fc-event.bg-dark,
.fc-event.bg-info {
	color: #fff !important;
	border-radius: 8px;
}
.fc-event.bg-primary .fc-daygrid-event-dot,
.fc-event.bg-success .fc-daygrid-event-dot,
.fc-event.bg-warning .fc-daygrid-event-dot,
.fc-event.bg-secondary .fc-daygrid-event-dot,
.fc-event.bg-dark .fc-daygrid-event-dot,
.fc-event.bg-info .fc-daygrid-event-dot {
	border-color: #fff;
}

.fc .fc-scroller-liquid-absolute,
.fc-scroller {
	position: relative;
	overflow: visible !important;
}

.fc .fc-button-group > .fc-button {
	color: black;
	background: 0 0;
	border: 1px solid #ebedf3;
	text-shadow: none !important;
	box-shadow: none !important;
}
.fc .fc-button-group > .fc-button:focus,
.fc .fc-button-group > .fc-button:active,
.fc .fc-button-group > .fc-button:hover,
.fc .fc-button-group > .fc-button.fc-button-active {
	background: var(--primary);
	color: #fff;
	border-color: var(--primary);
}

.fc-button.fc-today-button {
	border: 0;
	opacity: 1;
	margin-bottom: 0.625rem;
}

.fc .fc-button-primary {
	background: var(--primary);
	color: #fff;
}

.fc-unthemed .fc-toolbar .fc-button.fc-button-active,
.fc-unthemed .fc-toolbar .fc-button:active,
.fc-unthemed .fc-toolbar .fc-button:focus {
	background: var(--primary);
	color: #fff;
	border: 1px solid var(--primary);
	box-shadow: none;
	text-shadow: none;
}

.fc .fc-toolbar-title {
	font-size: 20px;
	margin: 0;
}

.external-event {
	padding: 8px 10px;
	display: flex;
	align-items: center;
	border-radius: 5px;
}
.external-event:hover:before {
	background: #fff !important;
}

.fc-event {
	overflow: hidden;
}

.fc .fc-view-harness {
	height: 850px !important;
	overflow-y: auto;
}

@media only screen and (max-width: 35.9375rem) {
	.fc .fc-toolbar.fc-header-toolbar {
		display: block;
	}
	.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk {
		display: flex;
		justify-content: center;
		border-bottom: 0.625rem;
	}
	.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk:first-child {
		justify-content: space-between;
	}
	.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-title {
		margin-bottom: 8px;
	}
}

#external-events .external-event {
	text-align: left;
	font-size: 16px;
}

@media only screen and (max-width: 35.9375rem) {
	.fc.app-fullcalendar .fc-timegrid-slot-label {
		width: 40px !important;
		font-size: 10px;
	}
	.fc.app-fullcalendar .fc-event,
	.fc.app-fullcalendar .external-event {
		font-size: 10px;
		margin: 0;
		padding: 2px 0;
		text-align: center;
		line-height: 1.3;
	}
	.fc.app-fullcalendar .fc-col-header-cell-cushion {
		display: inline-block;
		padding: 2px 4px;
		font-size: 10px;
	}
}

.accordion-button:not(.collapsed) {
	color: inherit;
	background: inherit;
}

.accordion-button.collapsed {
	border-bottom-width: 1px;
}

.accordion-primary .accordion-button {
	background: var(--primary);
	border-color: var(--primary);
	color: #fff;
	box-shadow: 0 0.9375rem 1.25rem 0 var(--rgba-primary-1);
}
.accordion-primary .accordion-button.collapsed {
	background: var(--rgba-primary-1);
	border-color: var(--rgba-primary-1);
	color: var(--primary);
	box-shadow: none;
}
[data-theme-version='dark'] .accordion-primary .accordion-button.collapsed {
	background: var(--rgba-primary-1);
	border-color: var(--rgba-primary-1);
	color: #a098ae;
}

.accordion-primary-solid .accordion-button {
	background: var(--primary);
	border-color: var(--primary);
	color: #fff;
	box-shadow: 0 -0.625rem 1.25rem 0 var(--rgba-primary-1);
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}
.accordion-primary-solid .accordion-button.collapsed {
	background: var(--rgba-primary-1);
	border-color: var(--rgba-primary-1);
	color: var(--primary);
	box-shadow: none;
	border-bottom-left-radius: 0.375rem;
	border-bottom-right-radius: 0.375rem;
}
[data-theme-version='dark'] .accordion-primary-solid .accordion-button.collapsed {
	background: var(--rgba-primary-1);
	border-color: var(--rgba-primary-1);
	color: #a098ae;
}

.accordion-primary-solid .accordion__body {
	border: 0.125rem solid var(--primary);
	border-top: none;
	box-shadow: 0 0.9375rem 1.25rem 0 var(--rgba-primary-1);
	border-bottom-left-radius: 0.375rem;
	border-bottom-right-radius: 0.375rem;
}

.accordion-danger .accordion-button {
	background: #fd5353;
	border-color: #fd5353;
	color: #fff;
	box-shadow: 0 0.9375rem 1.25rem 0 rgba(253, 83, 83, 0.15);
}
.accordion-danger .accordion-button.collapsed {
	background: #ffeaea;
	border-color: #ffeaea;
	color: #211c37;
	box-shadow: none;
}

.accordion-danger-solid .accordion-button {
	background: #fd5353;
	border-color: #fd5353;
	color: #fff;
	box-shadow: 0 -0.625rem 1.25rem 0 rgba(253, 83, 83, 0.15);
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}
.accordion-danger-solid .accordion-button.collapsed {
	background: #ffeaea;
	border-color: #ffeaea;
	color: #211c37;
	box-shadow: none;
	border-bottom-left-radius: 0.375rem;
	border-bottom-right-radius: 0.375rem;
}
[data-theme-version='dark'] .accordion-danger-solid .accordion-button.collapsed {
	background: rgba(253, 83, 83, 0.15);
	border-color: rgba(253, 83, 83, 0.15);
	color: #a098ae;
}

.accordion-danger-solid .accordion__body {
	border: 0.125rem solid #fd5353;
	border-top: none;
	box-shadow: 0 0.9375rem 1.25rem 0 rgba(253, 83, 83, 0.15);
	border-bottom-left-radius: 0.375rem;
	border-bottom-right-radius: 0.375rem;
}

.accordion-item {
	margin-bottom: 1.25rem;
	border: 0;
	background-color: transparent;
}
.accordion-item:first-of-type .accordion-button {
	border-top-left-radius: 0.375rem;
	border-top-right-radius: 0.375rem;
}
.accordion-item:last-of-type .accordion-button.collapsed {
	border-bottom-left-radius: 0.375rem;
	border-bottom-right-radius: 0.375rem;
}

.accordion-button {
	padding: 1rem 1.75rem;
	border: 0.0625rem solid #f2f2f2;
	cursor: pointer;
	position: relative;
	color: #333;
	font-weight: 400;
	border-radius: 0.375rem;
	transition: all 0.5s;
}
[data-theme-version='dark'] .accordion-button {
	color: #fff !important;
	border-color: rgba(255, 255, 255, 0.1);
}
.accordion-button-indicator.indicator_bordered {
	display: inline-block;
	width: 1.5625rem;
	text-align: center;
	height: 1.5625rem;
	border: 0.0625rem solid #f2f2f2;
	border-radius: 50%;
	line-height: 1.5625rem;
}
.accordion-button:not(.collapsed)::after {
	content: '\\e622';
	background-image: none;
	transform: rotate(0) translateY(-50%);
}
.accordion-button:not(.collapsed).style_two::after {
	content: '\\e648';
}
.accordion-button::after {
	content: '\\e61a';
	font-family: 'themify';
	position: absolute;
	right: 1.5625rem;
	top: 50%;
	transform: translateY(-50%);
	background-image: none !important;
	width: auto;
	height: auto;
}
[direction='rtl'] .accordion-button::after {
	right: auto;
	left: 1.5625rem;
}
.accordion-button.collapsed.style_two::after {
	content: '\\e64b';
}

.accordion-body {
	padding: 0.875rem 1.25rem;
}

.accordion-collapse {
	border: 0;
}

.accordion-bordered .accordion__body {
	border: 0.0625rem solid #f2f2f2;
	border-top: none;
	border-bottom-left-radius: 0.375rem;
	border-bottom-right-radius: 0.375rem;
}
[data-theme-version='dark'] .accordion-bordered .accordion__body {
	border-color: rgba(255, 255, 255, 0.1);
}

.accordion-bordered .accordion-button.collapsed {
	border-radius: 0.375rem;
}

.accordion-bordered .accordion-button {
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}

.accordion-no-gutter .accordion-item {
	margin-bottom: 0;
}
.accordion-no-gutter .accordion-item .accordion-button.collapsed {
	border-bottom: none;
}
.accordion-no-gutter .accordion-item:last-child .accordion-button {
	border-bottom: 0.0625rem solid #f2f2f2;
}
[data-theme-version='dark'] .accordion-no-gutter .accordion-item:last-child .accordion-button {
	border-color: rgba(255, 255, 255, 0.1);
}

.accordion-no-gutter.accordion__bordered .accordion-item:not(:last-child) .accordion__body {
	border-bottom: none;
}

.accordion-left-indicator .accordion-button-text {
	padding-left: 2.5rem;
}

.accordion-left-indicator .accordion-button-indicator {
	right: auto;
	left: 1.5625rem;
}

.accordion-with-icon .accordion-button-text {
	padding-left: 2.5rem;
}
[direction='rtl'] .accordion-with-icon .accordion-button-text {
	padding-left: 0;
	padding-right: 2.5rem;
}

.accordion-with-icon .accordion-button-icon {
	position: absolute;
	right: auto;
	left: 1.5625rem;
	font-family: 'themify';
}
[direction='rtl'] .accordion-with-icon .accordion-button-icon {
	left: auto;
	right: 1.5625rem;
}
.accordion-with-icon .accordion-button-icon::before {
	content: '\\e645';
}

.accordion-with-icon .accordion-button .accordion-header-icon {
	position: absolute;
	right: auto;
	left: 1.5625rem;
	font-family: 'themify';
}
.accordion-with-icon .accordion-button .accordion-header-icon::before {
	content: '\\e645';
}

.accordion-with-icon .accordion-button .accordion-header-text {
	padding-left: 2.5rem;
}

.accordion-header-bg .accordion-header .accordion-button {
	background-color: #ebebf9;
}
[data-theme-version='dark'] .accordion-header-bg .accordion-header .accordion-button {
	background-color: #202020;
}

.accordion-header-bg .accordion-header-primary .accordion-button {
	background-color: var(--primary);
	color: #fff;
	border-color: var(--primary);
}
[data-theme-version='dark'] .accordion-header-bg .accordion-header-primary .accordion-button {
	background-color: var(--primary);
}

.accordion-header-bg .accordion-header-info .accordion-button {
	background-color: #00ada3;
	color: #fff;
	border-color: #00ada3;
}
[data-theme-version='dark'] .accordion-header-bg .accordion-header-info .accordion-button {
	background-color: #00ada3;
}

.accordion-header-bg .accordion-header-success .accordion-button {
	background-color: #1eba62;
	color: #fff;
	border-color: #1eba62;
}
[data-theme-version='dark'] .accordion-header-bg .accordion-header-success .accordion-button {
	background-color: #1eba62;
}

.accordion-header-bg.accordion-no-gutter .accordion-button {
	border-color: transparent;
	border-radius: 0;
}

.accordion-header-bg.accordion-no-gutter .accordion-item:first-child .accordion-button {
	border-top-left-radius: 0.375rem;
	border-top-right-radius: 0.375rem;
}

.accordion-header-bg.accordion-no-gutter .accordion-item:last-child .accordion-button {
	border-bottom-left-radius: 0.375rem;
	border-bottom-right-radius: 0.375rem;
}

.accordion.accordion-no-gutter .accordion-button {
	border-radius: 0;
}

.accordion.accordion-no-gutter .accordion-button.collapsed {
	border-radius: 0;
}

.accordion.accordion-no-gutter .accordion__body {
	border-radius: 0;
}

.accordion.accordion-no-gutter .accordion-item:first-child .accordion-button {
	border-top-left-radius: 0.375rem;
	border-top-right-radius: 0.375rem;
}

.accordion.accordion-no-gutter .accordion-item:last-child .accordion-button.collapsed {
	border-bottom-left-radius: 0.375rem;
	border-bottom-right-radius: 0.375rem;
}

.accordion.accordion-no-gutter .accordion-item:last-child .accordion__body {
	border-bottom-left-radius: 0.375rem;
	border-bottom-right-radius: 0.375rem;
}

.accordion-solid-bg .accordion-button {
	border-color: transparent;
	background-color: var(--rgba-primary-1);
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}
[data-theme-version='dark'] .accordion-solid-bg .accordion-button {
	background-color: #202020;
}
.accordion-solid-bg .accordion-button.collapsed {
	border-radius: 0.375rem;
}

.accordion-solid-bg .accordion__body {
	border-color: transparent;
	background-color: var(--rgba-primary-1);
	border-bottom-left-radius: 0.375rem;
	border-bottom-right-radius: 0.375rem;
}
[data-theme-version='dark'] .accordion-solid-bg .accordion__body {
	background-color: #202020;
}

.accordion-active-header .accordion-button:not(.collapsed) {
	background-color: #00ada3;
	border-color: #00ada3;
	color: #fff;
}

.accordion-header-shadow .accordion-button {
	border: none;
	box-shadow: 0 0 0.9375rem -0.1875rem rgba(0, 0, 0, 0.3);
}

.accordion-rounded-stylish .accordion-button {
	border-top-left-radius: 0.375rem;
	border-top-right-radius: 0.375rem;
}

.accordion-rounded-stylish .accordion__body {
	border-bottom-left-radius: 0.375rem;
	border-bottom-right-radius: 0.375rem;
}

.accordion-rounded .accordion-button {
	border-radius: 0.3125rem;
}

.accordion-gradient .accordion-button {
	color: #fff;
	background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%, rgba(103, 25, 255, 0.85) 100%);
	border-color: transparent;
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}
.accordion-gradient .accordion-button.collapsed {
	border-bottom-left-radius: 0.375rem;
	border-bottom-right-radius: 0.375rem;
}
.accordion-gradient .accordion-button:not(.collapsed) {
	box-shadow: none;
}

.accordion-gradient .accordion__body {
	color: #fff;
	background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%, rgba(103, 25, 255, 0.85) 100%);
	border-color: transparent;
}

.dzm-tabs {
	padding: 4px;
	border-radius: 0.625rem;
	background-color: var(--bs-body-bg);
	border: none;
	flex-wrap: nowrap;
}
.dzm-tabs .nav-item .nav-link {
	border-radius: 0.625rem;
}
.dzm-tabs .nav-item .nav-link.active {
	background: var(--primary) !important;
	color: #fff;
}
@media only screen and (max-width: 35.9375rem) {
	.dzm-tabs {
		margin-top: 1rem;
	}
}

.dz-card .card-body {
	padding: 1.875rem !important;
	border-radius: 0 0 0.375rem 0.375rem;
}
@media only screen and (max-width: 35.9375rem) {
	.dz-card .card-body {
		padding: 1rem;
	}
}
.dz-card .card-body.code-area code {
	background: transparent;
	color: var(--secondary);
}

.dz-card .card-footer {
	color: #a098ae !important;
}

.dz-card .badge-box {
	position: relative;
	background: black;
	opacity: 0.6;
	border-radius: 0 0 0.625rem 0.625rem;
}

.unorder-list li,
.order-list li {
	list-style: unset;
}

.text-justify {
	text-align: justify;
}

.accordion-left-indicator .accordion-header .accordion-button {
	padding-left: 2.5rem;
}
.accordion-left-indicator .accordion-header .accordion-button:after {
	left: 1rem;
}

.alert {
	border-radius: 0.375rem;
	padding: 1rem 1.5rem;
}
@media only screen and (max-width: 35.9375rem) {
	.alert {
		padding-left: 1rem;
		padding-right: 2rem;
	}
}
.alert p {
	line-height: 1.5;
}

.alert-square {
	border-radius: 0;
}

.alert-rounded {
	border-radius: 3.125rem;
}

.alert-primary {
	background: var(--rgba-primary-1);
	border-color: var(--rgba-primary-1);
	color: var(--primary);
}

.alert-secondary {
	background: #fff3f0;
	border-color: #fff3f0;
	color: #fb7d5b;
}

.alert-success {
	background: #ddfaea;
	border-color: #ddfaea;
	color: #1eba62;
}

.alert-warning {
	background: #fffaee;
	border-color: #fffaee;
	color: #fcc43e;
}

.alert-danger {
	background: #ffeaea;
	border-color: #ffeaea;
	color: #fd5353;
}

.alert-info {
	background: #94fff9;
	border-color: #94fff9;
	color: #00ada3;
}

.alert-dark {
	background: #bec3e3;
	border-color: #bec3e3;
	color: #303972;
}

.alert-light {
	background: #ebebf9;
	border-color: #ebebf9;
	color: #303972;
}

.alert-alt.alert-primary {
	border-left: 0.25rem solid var(--primary);
}

.alert-alt.alert-secondary {
	border-left: 0.25rem solid #fb7d5b;
}

.alert-alt.alert-success {
	border-left: 0.25rem solid #1eba62;
}

.alert-alt.alert-warning {
	border-left: 0.25rem solid #fcc43e;
}

.alert-alt.alert-danger {
	border-left: 0.25rem solid #fd5353;
}

.alert-alt.alert-info {
	border-left: 0.25rem solid #00ada3;
}

.alert-alt.alert-dark {
	border-left: 0.25rem solid #303972;
}

.alert-alt.alert-light {
	border-left: 0.25rem solid #b0b0e7;
}

.alert-alt.alert-primary.solid {
	border-left: 0.25rem solid var(--primary-dark) !important;
}

.alert-alt.alert-secondary.solid {
	border-left: 0.25rem solid #d13105 !important;
}

.alert-alt.alert-success.solid {
	border-left: 0.25rem solid #0c4c28 !important;
}

.alert-alt.alert-warning.solid {
	border-left: 0.25rem solid #b88203 !important;
}

.alert-alt.alert-danger.solid {
	border-left: 0.25rem solid #ce0202 !important;
}

.alert-alt.alert-info.solid {
	border-left: 0.25rem solid #002e2b !important;
}

.alert-alt.alert-dark.solid {
	border-left: 0.25rem solid #0a0c18 !important;
}

.alert-alt.alert-light.solid {
	border-left: 0.25rem solid #8989dc !important;
}

.alert-dismissible.solid .close:hover {
	color: #fff;
	opacity: 1;
}

.alert.alert-primary.solid {
	background: var(--primary);
	color: #fff;
	border-color: var(--primary);
}

.alert.alert-secondary.solid {
	background: #fb7d5b;
	color: #fff;
	border-color: #fb7d5b;
}

.alert.alert-success.solid {
	background: #1eba62;
	color: #fff;
	border-color: #1eba62;
}

.alert.alert-warning.solid {
	background: #fcc43e;
	color: #fff;
	border-color: #fcc43e;
}

.alert.alert-danger.solid {
	background: #fd5353;
	color: #fff;
	border-color: #fd5353;
}

.alert.alert-info.solid {
	background: #00ada3;
	color: #fff;
	border-color: #00ada3;
}

.alert.alert-dark.solid {
	background: #303972;
	color: #fff;
	border-color: #303972;
}

.alert.alert-light.solid {
	background: #ebebf9;
	color: #303972;
	border-color: #ebebf9;
}

.alert-end-icon > span i {
	font-size: 18px;
	margin-right: 5px;
}

.alert-right-icon > span i {
	font-size: 1.125rem;
	margin-right: 0.3125rem;
}

.alert-right-icon .close i {
	font-size: 1rem;
}

.alert.alert-outline-primary {
	background: transparent;
	color: var(--primary);
	border-color: var(--primary);
}

.alert.alert-outline-secondary {
	background: transparent;
	color: #a098ae;
	border-color: #fb7d5b;
}

.alert.alert-outline-success {
	background: transparent;
	color: #1eba62;
	border-color: #1eba62;
}

.alert.alert-outline-info {
	background: transparent;
	color: #00ada3;
	border-color: #00ada3;
}

.alert.alert-outline-warning {
	background: transparent;
	color: #fcc43e;
	border-color: #fcc43e;
}

.alert.alert-outline-danger {
	background: transparent;
	color: #fd5353;
	border-color: #fd5353;
}

.alert.alert-outline-dark {
	background: transparent;
	color: #a098ae;
	border-color: #303972;
}

.alert.alert-outline-light {
	background: transparent;
	color: #303972;
	border-color: #ebebf9;
}

.alert-social {
	color: #fff;
}
.alert-social .alert-social-icon {
	align-self: center;
	margin-right: 0.9375rem;
}
.alert-social .alert-social-icon i {
	font-size: 2.625rem;
}
.alert-social.facebook {
	background-color: #3b5998;
}
.alert-social.twitter {
	background-color: #1da1f2;
}
.alert-social.linkedin {
	background-color: #007bb6;
}
.alert-social.google-plus {
	background-color: #db4439;
}
.alert-social .close:hover {
	opacity: 1 !important;
	color: #fff !important;
}

.left-icon-big .alert-left-icon-big {
	align-self: center;
	margin-right: 0.9375rem;
}
.left-icon-big .alert-left-icon-big i {
	font-size: 2.1875rem;
	line-height: 1;
}

[direction='rtl'] .left-icon-big .alert-left-icon-big,
[direction='rtl'] .alert-social .alert-social-icon {
	margin-right: 0;
	margin-left: 0.9375rem;
}

.alert .btn-close {
	background: none;
	text-shadow: 0 1px 0 #fff;
	opacity: 0.5;
	color: inherit;
}
.alert .btn-close i {
	transform: scale(1.4);
}
.alert .btn-close:focus {
	box-shadow: none;
}

.badge {
	line-height: 1.3;
	border-radius: 0.325rem;
	font-weight: 600;
	padding: 0.25rem 0.515rem;
	border: 0.0625rem solid transparent;
}

.badge-rounded {
	border-radius: 1.25rem;
	padding: 0.1875rem 0.8125rem;
}

.badge-circle {
	border-radius: 6.25rem;
	line-height: 13px;
	padding: 0.1875rem 0.4375rem;
}

.badge-outline-primary {
	border: 0.0625rem solid var(--primary);
	color: var(--primary);
}

.badge-outline-secondary {
	border: 0.0625rem solid #fb7d5b;
	color: #fb7d5b;
}
[data-theme-version='dark'] .badge-outline-secondary {
	color: #a098ae;
}

.badge-outline-success {
	border: 0.0625rem solid #1eba62;
	color: #1eba62;
}

.badge-outline-info {
	border: 0.0625rem solid #00ada3;
	color: #00ada3;
}

.badge-outline-warning {
	border: 0.0625rem solid #fcc43e;
	color: #fcc43e;
}

.badge-outline-danger {
	border: 0.0625rem solid #fd5353;
	color: #fd5353;
}

.badge-outline-light {
	border: 0.0625rem solid #f2f2f2;
	color: #303972;
}
[data-theme-version='dark'] .badge-outline-light {
	color: #a098ae;
}

.badge-outline-dark {
	border: 0.0625rem solid #303972;
	color: #303972;
}
[data-theme-version='dark'] .badge-outline-dark {
	color: #a098ae;
}

.badge-xs {
	font-size: 0.625rem;
	padding: 0rem 0.3125rem;
	line-height: 1.125rem;
}

.badge-sm {
	font-size: 0.6875rem;
	padding: 0.3125rem 0.5rem;
	line-height: 0.6875rem;
}

.badge-lg {
	padding: 0.25rem 0.5rem;
	border-radius: 0.5rem;
	font-weight: 400;
	font-size: 0.813rem;
	line-height: 1.4;
}
.badge-lg:hover {
	color: #fff;
}

.badge-xl {
	font-size: 1rem;
	padding: 0rem 0.9375rem;
	line-height: 2;
}

.badge-default {
	background: #adb6c7;
}

.badge-success {
	background-color: #1eba62;
}
.badge-success:hover {
	color: #fff;
}

.badge-secondary {
	background-color: #fb7d5b;
}
.badge-secondary:hover {
	color: #fff;
}

.badge-info {
	background-color: #00ada3;
}
.badge-info:hover {
	color: #fff;
}

.badge-primary {
	background-color: var(--primary);
}
.badge-primary:hover {
	color: #fff;
}

.badge-warning {
	background-color: #fcc43e;
}
.badge-warning:hover {
	color: #fff;
}

.badge-danger {
	background-color: #fd5353;
}
.badge-danger:hover {
	color: #fff;
}

.badge-dark {
	background-color: #303972;
}
.badge-dark:hover {
	color: #fff;
}

.badge-light {
	background-color: #ebebf9;
}
.badge-light:hover {
	color: #fff;
}

.light.badge-default {
	background: #adb6c7;
}

.light.badge-success {
	background-color: #ddfaea;
	color: #1eba62;
}
[data-theme-version='dark'] .light.badge-success {
	background-color: rgba(30, 186, 98, 0.1);
}

.light.badge-info {
	background-color: #94fff9;
	color: #00ada3;
}
[data-theme-version='dark'] .light.badge-info {
	background-color: rgba(0, 173, 163, 0.1);
}

.light.badge-primary {
	background-color: #eaebf1;
	color: var(--primary);
}
[data-theme-version='dark'] .light.badge-primary {
	background-color: var(--rgba-primary-1);
}

.light.badge-secondary {
	background-color: #fff3f0;
	color: #fb7d5b;
}
[data-theme-version='dark'] .light.badge-secondary {
	background-color: rgba(251, 125, 91, 0.5);
	color: #fff;
}

.light.badge-warning {
	background-color: #fffaee;
	color: #fcc43e;
}
[data-theme-version='dark'] .light.badge-warning {
	background-color: rgba(252, 196, 62, 0.1);
}

.light.badge-danger {
	background-color: #ffeaea;
	color: #fd5353;
}
[data-theme-version='dark'] .light.badge-danger {
	background-color: rgba(253, 83, 83, 0.15);
}

.light.badge-dark {
	background-color: #bec3e3;
	color: #303972;
}
[data-theme-version='dark'] .light.badge-dark {
	background-color: rgba(48, 57, 114, 0.35);
	color: #fff;
}

.light.badge-pink {
	background-color: rgba(235, 98, 208, 0.1);
	color: #eb62d0;
}

.light.badge-light {
	background-color: #eaebf1;
	color: #aaa9ff;
}

.bootstrap-label .label {
	display: inline-block;
	margin-right: 1rem;
}
.bootstrap-label .label:last-child {
	margin-right: 0;
}

.badge-demo .badge {
	margin-right: 0.3125rem;
	margin-bottom: 0.3125rem;
}
.badge-demo .badge:last-child {
	margin-right: 0;
}

.bootstrap-badge-buttons button {
	margin-right: 0.2rem;
	margin-bottom: 1rem;
}
.bootstrap-badge-buttons button:last-child {
	margin-right: 0;
}

.breadcrumb {
	font-size: 1.1875rem;
}
.breadcrumb .breadcrumb-item.active a {
	color: var(--primary);
}
.breadcrumb .breadcrumb-item svg {
	width: 22px;
	margin-bottom: 3px;
}
.breadcrumb .breadcrumb-item + .breadcrumb-item::before {
	color: var(--primary);
}

.page-titles {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.825rem 1.875rem;
	background: #ffffff;
	margin-bottom: 1.875rem;
	border-radius: 0.375rem;
	position: relative;
	z-index: 1;
	flex-wrap: wrap;
}
.page-titles.style1 {
	padding: 0.92rem 1.875rem;
}
.page-titles h2,
.page-titles .h2 {
	margin: 0;
}
@media only screen and (max-width: 100rem) {
	.page-titles h2,
	.page-titles .h2 {
		font-size: 20px;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.page-titles {
		flex-wrap: wrap;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.page-titles {
		padding: 0.6375rem 1rem;
		flex-wrap: wrap;
	}
	.page-titles h2,
	.page-titles .h2 {
		font-size: 1rem;
	}
}
.page-titles .justify-content-sm-end {
	align-items: center;
}
@media only screen and (max-width: 35.9375rem) {
	.page-titles .left-title {
		margin-bottom: 0.5rem;
	}
}
.page-titles h4,
.page-titles .h4 {
	margin-bottom: 0;
	margin-top: 0;
	color: var(--primary);
	font-size: 1.25rem;
}
.page-titles h4 span,
.page-titles .h4 span {
	font-size: 0.875rem;
	font-weight: 400;
}
.page-titles .breadcrumb {
	margin-bottom: 0;
	padding: 0;
	background: transparent;
	align-items: center;
}
@media only screen and (max-width: 47.9375rem) {
	.page-titles .breadcrumb {
		padding-right: 0px;
	}
}
.page-titles .breadcrumb h2,
.page-titles .breadcrumb .h2 {
	margin: 0;
	font-size: 28px;
	font-weight: 500;
}
.page-titles .breadcrumb p {
	margin: 0;
	font-size: 16px;
	color: #fff000;
}
.page-titles .breadcrumb li {
	margin-top: 0;
	margin-bottom: 0;
	padding-left: 2rem;
	align-items: center;
	display: flex;
}
@media only screen and (max-width: 35.9375rem) {
	.page-titles .breadcrumb li:first-child {
		padding-left: 0;
	}
}
.page-titles .breadcrumb li a {
	font-size: 14px;
	font-weight: 400;
	display: flex;
	align-items: center;
}
@media only screen and (max-width: 35.9375rem) {
	.page-titles .breadcrumb li a {
		font-size: 0.95rem;
	}
}
.page-titles .breadcrumb li.active {
	color: var(--primary);
	font-size: 1rem;
}
.page-titles .breadcrumb li.active a {
	color: #ebebf9;
}
.page-titles .breadcrumb .breadcrumb-item + .breadcrumb-item:before {
	content: '\\f105';
	font-family: 'Font Awesome 6 Free';
	font-weight: 600;
	position: absolute;
	font-size: 14px;
	color: #ebebf9;
	margin-left: -20px;
}
.page-titles .breadcrumb-datepicker {
	font-size: 0.75rem;
	color: #89879f;
}
.page-titles .breadcrumb-datepicker__icon {
	font-size: 0.875rem;
}
.page-titles .sub-dz-head {
	display: flex;
	align-items: center;
	width: 100%;
	justify-content: space-between;
	position: relative;
}
.page-titles .sub-dz-head:before {
	content: '';
	top: -18px;
	left: 0;
	width: 100%;
	background: rgba(255, 255, 255, 0.12);
	height: 1px;
	position: absolute;
}
.page-titles .breadcrumb-widget .border-dark {
	border-color: #dee2e6 !important;
}
.page-titles .breadcrumb-widget h4,
.page-titles .breadcrumb-widget .h4 {
	color: #646c9a;
	font-weight: 600;
}
@media only screen and (max-width: 35.9375rem) {
	.page-titles .breadcrumb-widget {
		text-align: left !important;
		margin-bottom: 0.9375rem;
	}
}
.page-titles p {
	margin: 0;
	color: #fff000;
}
@media only screen and (max-width: 74.9375rem) {
	.page-titles .btn svg {
		width: 18px;
		height: 18px;
	}
}
@media only screen and (max-width: 61.9375rem) {
	.page-titles .btn svg {
		width: 18px;
		height: 18px;
	}
}

button {
	cursor: pointer;
}
button:focus {
	outline: 0;
	box-shadow: none;
}

.btn {
	padding: 0.688rem 1.5rem;
	border-radius: 0.5rem;
	font-weight: 500;
	font-size: 1rem;
	line-height: 1.5;
}
.btn:hover,
.btn:focus,
.btn:active,
.btn.active {
	outline: 0 !important;
}
@media only screen and (max-width: 87.5rem) {
	.btn {
		padding: 0.625rem 1rem;
		font-size: 0.813rem;
	}
}
.btn.btn-success,
.btn.btn-secondary,
.btn.btn-warning,
.btn.btn-primary,
.btn.btn-danger,
.btn.btn-info {
	color: #fff;
}
.btn.btn-success:hover,
.btn.btn-secondary:hover,
.btn.btn-warning:hover,
.btn.btn-primary:hover,
.btn.btn-danger:hover,
.btn.btn-info:hover {
	color: #fff !important;
}
.btn-transparent {
	background-color: transparent;
}

.btn-primary {
	border-color: var(--primary);
	background-color: var(--primary);
}
.btn-primary:active,
.btn-primary:focus,
.btn-primary:hover {
	border-color: var(--primary-hover);
	background-color: var(--primary-hover);
}
.btn-primary:focus {
	box-shadow: unset;
}
.btn-primary:disabled,
.btn-primary.disabled {
	background-color: var(--primary);
	border-color: var(--primary);
}

.btn-link {
	color: var(--primary);
	text-decoration: none;
}
.btn-link:hover {
	color: var(--primary-hover);
}

.btn-outline-primary {
	color: var(--primary);
	border-color: var(--primary);
}
.btn-outline-primary:hover {
	border-color: var(--primary-hover);
	background-color: var(--primary-hover);
}

.sharp {
	width: 2.5rem;
	height: 2.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 0.375rem;
	padding: 0;
}

.sharp-sm {
	height: 2.5rem;
	width: 2.5rem;
	line-height: 2.5rem;
}

.sharp-lg {
	height: 3rem;
	width: 3rem;
	line-height: 2.7rem;
}
@media only screen and (max-width: 87.5rem) {
	.sharp-lg {
		height: 2.285rem;
		width: 2.285rem;
		line-height: 2.5rem;
		font-size: 0.813rem;
	}
}

.sharp.btn-xs {
	padding: 0.1875rem;
	width: 1.625rem;
	height: 1.625rem;
	min-width: 1.625rem;
	min-height: 1.625rem;
}

.btn-block {
	display: block;
	width: 100%;
}

.light.tp-btn {
	background-color: transparent;
}

.light.btn-default {
	background: #adb6c7;
}

.light.btn-success {
	background-color: rgba(30, 186, 98, 0.1);
	border-color: #ddfaea;
	color: #1eba62;
}
.light.btn-success g [fill] {
	fill: #1eba62;
}
[data-theme-version='dark'] .light.btn-success {
	background-color: rgba(30, 186, 98, 0.1);
	border-color: transparent;
}
.light.btn-success:hover {
	background-color: #1eba62;
	border-color: #1eba62;
	color: #fff;
}
.light.btn-success:hover g [fill] {
	fill: #fff;
}

.light.btn-info {
	background-color: #94fff9;
	border-color: #94fff9;
	color: #00ada3;
}
.light.btn-info g [fill] {
	fill: #00ada3;
}
[data-theme-version='dark'] .light.btn-info {
	background-color: rgba(0, 173, 163, 0.1);
	border-color: transparent;
}
.light.btn-info:hover {
	background-color: #00ada3;
	border-color: #00ada3;
	color: #fff;
}
.light.btn-info:hover g [fill] {
	fill: #fff;
}

.light.btn-primary {
	background-color: var(--rgba-primary-1);
	border-color: var(--rgba-primary-1);
	color: var(--primary);
}
.light.btn-primary g [fill] {
	fill: var(--primary);
}
[data-theme-version='dark'] .light.btn-primary {
	background-color: var(--rgba-primary-1);
	border-color: transparent;
	color: #fff;
}
.light.btn-primary:hover {
	background-color: var(--primary);
	border-color: var(--primary);
	color: #fff;
}
.light.btn-primary:hover g [fill] {
	fill: #fff;
}

.light.btn-secondary {
	background: rgba(251, 125, 91, 0.2);
	border-color: rgba(251, 125, 91, 0.1);
	color: #fb7d5b !important;
}
.light.btn-secondary g [fill] {
	fill: #fb7d5b;
}
[data-theme-version='dark'] .light.btn-secondary {
	background-color: rgba(251, 125, 91, 0.5);
	border-color: transparent;
	color: #fff;
}
.light.btn-secondary:hover {
	background-color: #fb7d5b;
	border-color: #fb7d5b;
	color: #fff !important;
}
.light.btn-secondary:hover g [fill] {
	fill: #fff;
}

.light.btn-warning {
	background-color: #fffaee;
	border-color: #fffaee;
	color: #fcc43e;
}
.light.btn-warning g [fill] {
	fill: #fcc43e;
}
[data-theme-version='dark'] .light.btn-warning {
	background-color: rgba(252, 196, 62, 0.1);
	border-color: transparent;
}
.light.btn-warning:hover {
	background-color: #fcc43e;
	border-color: #fcc43e;
	color: #fff;
}
.light.btn-warning:hover g [fill] {
	fill: #fff;
}

.light.btn-danger {
	background-color: #ffeaea;
	border-color: #ffeaea;
	color: #fd5353;
}
.light.btn-danger g [fill] {
	fill: #fd5353;
}
[data-theme-version='dark'] .light.btn-danger {
	background-color: rgba(253, 83, 83, 0.15);
	border-color: transparent;
}
.light.btn-danger:hover {
	background-color: #fd5353;
	border-color: #fd5353;
	color: #fff;
}
.light.btn-danger:hover g [fill] {
	fill: #fff;
}

.light.btn-dark {
	background-color: #bec3e3;
	border-color: #bec3e3;
	color: #303972;
}
.light.btn-dark g [fill] {
	fill: #303972;
}
[data-theme-version='dark'] .light.btn-dark {
	background-color: rgba(48, 57, 114, 0.35);
	border-color: transparent;
	color: #fff;
}
.light.btn-dark:hover {
	background-color: #303972;
	border-color: #303972;
	color: #fff;
}
.light.btn-dark:hover g [fill] {
	fill: #fff;
}

.btn.tp-btn {
	background-color: transparent;
	border-color: transparent;
}
.btn.tp-btn.btn-default {
	background: #adb6c7;
}
.btn.tp-btn.btn-success {
	color: #1eba62;
}
.btn.tp-btn.btn-success g [fill] {
	fill: #1eba62;
}
.btn.tp-btn.btn-success:hover {
	background-color: #1eba62;
	border-color: #1eba62;
	color: #fff;
}
.btn.tp-btn.btn-success:hover g [fill] {
	fill: #fff;
}
.btn.tp-btn.btn-info {
	color: #00ada3;
}
.btn.tp-btn.btn-info g [fill] {
	fill: #00ada3;
}
.btn.tp-btn.btn-info:hover {
	background-color: #00ada3;
	border-color: #00ada3;
	color: #fff;
}
.btn.tp-btn.btn-info:hover g [fill] {
	fill: #fff;
}
.btn.tp-btn.btn-primary {
	color: var(--primary);
	background-color: var(--rgba-primary-1);
}
.btn.tp-btn.btn-primary g [fill] {
	fill: var(--primary);
}
.btn.tp-btn.btn-primary:hover {
	background-color: var(--primary);
	border-color: var(--primary);
	color: #fff;
}
.btn.tp-btn.btn-primary:hover g [fill] {
	fill: #fff;
}
.btn.tp-btn.btn-secondary {
	color: var(--secondary);
}
.btn.tp-btn.btn-secondary g [fill] {
	fill: var(--secondary);
}
.btn.tp-btn.btn-secondary:hover {
	background-color: #fb7d5b;
	border-color: #fb7d5b;
	color: #fff;
}
.btn.tp-btn.btn-secondary:hover g [fill] {
	fill: #fff;
}
.btn.tp-btn.btn-warning {
	color: #fcc43e;
}
.btn.tp-btn.btn-warning g [fill] {
	fill: #fcc43e;
}
.btn.tp-btn.btn-warning:hover {
	background-color: #fcc43e;
	border-color: #fcc43e;
	color: #fff;
}
.btn.tp-btn.btn-warning:hover g [fill] {
	fill: #fff;
}
.btn.tp-btn.btn-danger {
	color: #fd5353;
}
.btn.tp-btn.btn-danger g [fill] {
	fill: #fd5353;
}
.btn.tp-btn.btn-danger:hover {
	background-color: #fd5353;
	border-color: #fd5353;
	color: #fff;
}
.btn.tp-btn.btn-danger:hover g [fill] {
	fill: #fff;
}
.btn.tp-btn.btn-light {
	color: #303972;
}
.btn.tp-btn.btn-light g [fill] {
	fill: #303972;
}
.btn.tp-btn.btn-light:hover {
	background-color: #ebebf9;
	border-color: #ebebf9;
	color: #303972;
}
.btn.tp-btn.btn-light:hover g [fill] {
	fill: #fff;
}
.btn.tp-btn.btn-dark {
	color: #303972;
}
.btn.tp-btn.btn-dark g [fill] {
	fill: #303972;
}
.btn.tp-btn.btn-dark:hover {
	background-color: #303972;
	border-color: #303972;
	color: #fff;
}
.btn.tp-btn.btn-dark:hover g [fill] {
	fill: #fff;
}

.btn.tp-btn-light {
	background-color: transparent;
	border-color: transparent;
}
.btn.tp-btn-light.btn-success {
	color: #1eba62;
}
.btn.tp-btn-light.btn-success g [fill] {
	fill: #1eba62;
}
.btn.tp-btn-light.btn-success:hover {
	background-color: #ddfaea;
	border-color: #ddfaea;
	color: #1eba62;
}
.btn.tp-btn-light.btn-success:hover g [fill] {
	fill: #1eba62;
}
.btn.tp-btn-light.btn-info {
	color: #00ada3;
}
.btn.tp-btn-light.btn-info g [fill] {
	fill: #00ada3;
}
.btn.tp-btn-light.btn-info:hover {
	background-color: #94fff9;
	border-color: #94fff9;
	color: #00ada3;
}
.btn.tp-btn-light.btn-info:hover g [fill] {
	fill: #00ada3;
}
.btn.tp-btn-light.btn-primary {
	color: var(--primary);
}
.btn.tp-btn-light.btn-primary g [fill] {
	fill: var(--primary);
}
.btn.tp-btn-light.btn-primary:hover {
	background-color: var(--rgba-primary-1);
	border-color: var(--rgba-primary-1);
	color: var(--primary);
}
.btn.tp-btn-light.btn-primary:hover g [fill] {
	fill: var(--primary);
}
.btn.tp-btn-light.btn-secondary {
	color: var(--secondary);
}
.btn.tp-btn-light.btn-secondary g [fill] {
	fill: var(--secondary);
}
.btn.tp-btn-light.btn-secondary:hover {
	background-color: var(--rgba-secondary-1);
	border-color: var(--rgba-secondary-1);
	color: var(--secondary);
}
.btn.tp-btn-light.btn-secondary:hover g [fill] {
	fill: var(--secondary);
}
.btn.tp-btn-light.btn-warning {
	color: #fcc43e;
}
.btn.tp-btn-light.btn-warning g [fill] {
	fill: #fcc43e;
}
.btn.tp-btn-light.btn-warning:hover {
	background-color: #fffaee;
	border-color: #fffaee;
	color: #fcc43e;
}
.btn.tp-btn-light.btn-warning:hover g [fill] {
	fill: #fcc43e;
}
.btn.tp-btn-light.btn-danger {
	color: #fd5353;
}
.btn.tp-btn-light.btn-danger g [fill] {
	fill: #fd5353;
}
.btn.tp-btn-light.btn-danger:hover {
	background-color: #ffeaea;
	border-color: #ffeaea;
	color: #fd5353;
}
.btn.tp-btn-light.btn-danger:hover g [fill] {
	fill: #fff;
}
.btn.tp-btn-light.btn-dark {
	color: #303972;
}
.btn.tp-btn-light.btn-dark g [fill] {
	fill: #303972;
}
.btn.tp-btn-light.btn-dark:hover {
	background-color: #bec3e3;
	border-color: #bec3e3;
	color: #303972;
}
.btn.tp-btn-light.btn-dark:hover g [fill] {
	fill: #fff;
}

.shadow.btn-primary {
	box-shadow: 0 0.3125rem 0.9375rem 0 var(--rgba-primary-2) !important;
}

.shadow.btn-secondary {
	box-shadow: 0 0.3125rem 0.9375rem 0 rgba(251, 125, 91, 0.2) !important;
}

.shadow.btn-warning {
	box-shadow: 0 0.3125rem 0.9375rem 0 rgba(252, 196, 62, 0.2) !important;
}

.shadow.btn-danger {
	box-shadow: 0 0.3125rem 0.9375rem 0 rgba(253, 83, 83, 0.2) !important;
}

.shadow.btn-info {
	box-shadow: 0 0.3125rem 0.9375rem 0 rgba(0, 173, 163, 0.2) !important;
}

.shadow.btn-success {
	box-shadow: 0 0.3125rem 0.9375rem 0 rgba(30, 186, 98, 0.2) !important;
}

.btn-xxs {
	padding: 0.367rem 0.9375rem;
	font-size: 0.6875rem;
	line-height: 1.3;
}

.btn-xs {
	font-size: 0.75rem;
	padding: 0.375rem 1rem;
	font-weight: 600;
	border-radius: 0.3rem;
}

.btn-sm,
.btn-group-sm > .btn {
	font-size: 0.813rem !important;
	padding: 0.579rem 1rem;
}

.btn-md {
	font-size: 0.875rem !important;
	padding: 0.579rem 1rem;
}

.btn-lg,
.btn-group-lg > .btn {
	padding: 0.969rem 2rem;
	font-size: 1.125rem !important;
}
@media only screen and (max-width: 35.9375rem) {
	.btn-lg,
	.btn-group-lg > .btn {
		padding: 0.75rem 1.25rem;
	}
}

.btn-xl {
	padding: 0.6rem 1rem;
}
.btn-xl.btn-default {
	font-weight: 600;
}

.btn-icon-lg {
	padding: 15px 18px;
	min-width: 20px !important;
}

.btn-icon-md {
	padding: 13px 16px;
	min-width: 20px !important;
}

.btn-icon-sm {
	padding: 11px 14px;
	min-width: 20px !important;
}

.btn-icon-xs {
	padding: 10px 12px;
	min-width: 20px !important;
}

.btn-icon-xxs {
	padding: 8px 10px;
	min-width: 20px !important;
}

.btn-square {
	border-radius: 0;
}

.btn-rounded {
	border-radius: 2.5rem !important;
}

.btn-icon-end {
	border-left: 0.0625rem solid #ebebf9;
	display: inline-block;
	margin: -0.8rem 0 -0.8rem 1rem;
	padding: 0.4375rem 0 0.4375rem 1rem;
	margin: -1rem -0.25rem -1rem 1rem;
	padding: 1rem 0 1rem 1.25rem;
}

.btn-icon-start {
	background: #fff;
	border-radius: 0.5rem;
	display: inline-block;
	margin: -0.2rem 0.55rem -0.4rem -1.188rem;
	padding: 0.3rem 0.6rem 0.2rem;
	float: left;
}
@media only screen and (max-width: 87.5rem) {
	.btn-icon-start {
		margin: -0.2rem 0.5rem -0.2rem -0.48rem;
	}
}

[direction='rtl'] .btn-icon-start {
	margin: -0.5rem 0.5rem -0.5rem -1rem;
}
@media only screen and (max-width: 87.5rem) {
	[direction='rtl'] .btn-icon-start {
		margin: -0.5rem 0.75rem -0.5rem -0.88rem;
	}
}

[direction='rtl'] .btn-icon-end {
	border-left: 0rem solid white;
	display: inline-block;
	margin: -0.8rem 1rem -0.8rem 0;
	padding: 0.4375rem 1rem 0.4375rem 0;
	border-right: 0.0625rem solid white;
}

.toggle-dropdown::after {
	margin-left: 0.755em;
}

.social-btn-icon .btn {
	min-width: 7.5rem;
	margin-bottom: 1.5rem;
}

.social-icon .btn {
	padding: 0.7rem 1.4rem;
}

.btn-circle {
	height: 5rem;
	width: 5rem;
	border-radius: 50% !important;
}
.btn-circle-sm {
	width: 4.5rem;
	height: 4.5rem;
	font-size: 1.8rem;
}
.btn-circle-md {
	width: 6rem;
	height: 6rem;
	font-size: 2.5rem;
}
.btn-circle-md i {
	font-size: 2.4rem;
}
.btn-circle-lg {
	width: 8rem;
	height: 8rem;
	font-size: 3.2rem;
}
.btn-circle-lg i {
	font-size: 3.1rem;
}

.btn-page .btn {
	min-width: 6.875rem;
	margin-right: 0.25rem;
	margin-bottom: 0.5rem;
	overflow: hidden;
}

.size-1 {
	min-width: 10rem !important;
	font-size: 1.5rem;
	padding: 0.68rem 0.75rem;
}

.size-2 {
	font-size: 1.25rem;
	min-width: 8.125rem !important;
	padding: 0.57rem 0.75rem;
}

.size-3 {
	font-size: 0.875rem;
	min-width: 6.875rem !important;
	padding: 0.536rem 0.75rem;
}

.size-4 {
	font-size: 0.875rem;
	min-width: 6.25rem !important;
}

.size-5 {
	font-size: 0.875rem;
	min-width: 5.625rem !important;
	padding: 0.22rem 0.75rem;
}

.size-6 {
	font-size: 0.8125rem;
	min-width: 5rem !important;
	padding: 0.097rem 0.75rem;
}

.size-7 {
	font-size: 0.75rem;
	min-width: 3.75rem !important;
	padding: 0.001rem 0.75rem;
}

.btn-light {
	background: #ebebf9;
	border-color: #ebebf9;
	color: #303972;
}
.btn-light:active,
.btn-light:focus,
.btn-light:hover {
	background: #d7d7db;
	border-color: #d7d7db;
}
.btn-light svg path {
	fill: var(--primary);
}

.btn-outline-primary:hover {
	color: #fff;
}

.btn-outline-warning:hover {
	color: #fff;
}

.btn-outline-danger:hover {
	color: #fff;
}

.btn-outline-success:hover {
	color: #fff;
}

.btn-outline-info:hover {
	color: #fff;
}

.btn-outline-light {
	color: #303972;
}
[data-theme-version='dark'] .btn-outline-light {
	color: #a098ae;
}

[data-theme-version='dark'] .btn-outline-secondary {
	color: #a098ae;
}

.btn-outline-secondary:hover {
	color: #fff;
}

[data-theme-version='dark'] .btn-outline-dark {
	color: #a098ae;
}

.btn-dark {
	background: #303972;
	border-color: #303972;
	color: #fff;
}
.btn-dark:active,
.btn-dark:focus,
.btn-dark:hover {
	background: #21274e;
	color: #fff;
	border-color: #21274e;
}

.btn-group.btn-rounded .btn:first-child {
	border-top-left-radius: 1.875rem;
	border-bottom-left-radius: 1.875rem;
}

.btn-group.btn-rounded .btn:last-child {
	border-top-right-radius: 1.875rem;
	border-bottom-right-radius: 1.875rem;
}

.btn-facebook {
	background: #3b5998;
	border-color: #3b5998;
	color: #fff;
}
.btn-facebook:active,
.btn-facebook:focus,
.btn-facebook:hover {
	background: #2d4373;
	color: #fff;
	border-color: #2d4373;
}

.btn-twitter {
	background: #1da1f2;
	border-color: #1da1f2;
	color: #fff;
}
.btn-twitter:active,
.btn-twitter:focus,
.btn-twitter:hover {
	background: #0c85d0;
	color: #fff;
	border-color: #0c85d0;
}

.btn-youtube {
	background: #ff0000;
	border-color: #ff0000;
	color: #fff;
}
.btn-youtube:active,
.btn-youtube:focus,
.btn-youtube:hover {
	background: #cc0000;
	color: #fff;
	border-color: #cc0000;
}

.btn-instagram {
	background: #c32aa3;
	border-color: #c32aa3;
	color: #fff;
}
.btn-instagram:active,
.btn-instagram:focus,
.btn-instagram:hover {
	background: #992180;
	color: #fff;
	border-color: #992180;
}

.btn-pinterest {
	background: #bd081c;
	border-color: #bd081c;
	color: #fff;
}
.btn-pinterest:active,
.btn-pinterest:focus,
.btn-pinterest:hover {
	background: #8c0615;
	color: #fff;
	border-color: #8c0615;
}

.btn-linkedin {
	background: #007bb6;
	border-color: #007bb6;
	color: #fff;
}
.btn-linkedin:active,
.btn-linkedin:focus,
.btn-linkedin:hover {
	background: #005983;
	color: #fff;
	border-color: #005983;
}

.btn-google-plus {
	background: #db4439;
	border-color: #db4439;
	color: #fff;
}
.btn-google-plus:active,
.btn-google-plus:focus,
.btn-google-plus:hover {
	background: #be2d23;
	color: #fff;
	border-color: #be2d23;
}

.btn-google {
	background: #4285f4;
	border-color: #4285f4;
	color: #fff;
}
.btn-google:active,
.btn-google:focus,
.btn-google:hover {
	background: #1266f1;
	color: #fff;
	border-color: #1266f1;
}

.btn-snapchat {
	background: #fffc00;
	border-color: #fffc00;
	color: #000;
}
.btn-snapchat:active,
.btn-snapchat:focus,
.btn-snapchat:hover {
	background: #ccca00;
	color: #000;
	border-color: #ccca00;
}

.btn-whatsapp {
	background: #25d366;
	border-color: #25d366;
	color: #fff;
}
.btn-whatsapp:active,
.btn-whatsapp:focus,
.btn-whatsapp:hover {
	background: #1da851;
	color: #fff;
	border-color: #1da851;
}

.btn-tumblr {
	background: #35465d;
	border-color: #35465d;
	color: #fff;
}
.btn-tumblr:active,
.btn-tumblr:focus,
.btn-tumblr:hover {
	background: #222e3d;
	color: #fff;
	border-color: #222e3d;
}

.btn-reddit {
	background: #ff4500;
	border-color: #ff4500;
	color: #fff;
}
.btn-reddit:active,
.btn-reddit:focus,
.btn-reddit:hover {
	background: #cc3700;
	color: #fff;
	border-color: #cc3700;
}

.btn-spotify {
	background: #1ed760;
	border-color: #1ed760;
	color: #fff;
}
.btn-spotify:active,
.btn-spotify:focus,
.btn-spotify:hover {
	background: #18aa4c;
	color: #fff;
	border-color: #18aa4c;
}

.btn-yahoo {
	background: #430297;
	border-color: #430297;
	color: #fff;
}
.btn-yahoo:active,
.btn-yahoo:focus,
.btn-yahoo:hover {
	background: #2d0165;
	color: #fff;
	border-color: #2d0165;
}

.btn-dribbble {
	background: #ea4c89;
	border-color: #ea4c89;
	color: #fff;
}
.btn-dribbble:active,
.btn-dribbble:focus,
.btn-dribbble:hover {
	background: #e51e6b;
	color: #fff;
	border-color: #e51e6b;
}

.btn-skype {
	background: #00aff0;
	border-color: #00aff0;
	color: #fff;
}
.btn-skype:active,
.btn-skype:focus,
.btn-skype:hover {
	background: #008abd;
	color: #fff;
	border-color: #008abd;
}

.btn-quora {
	background: #aa2200;
	border-color: #aa2200;
	color: #fff;
}
.btn-quora:active,
.btn-quora:focus,
.btn-quora:hover {
	background: #771800;
	color: #fff;
	border-color: #771800;
}

.btn-vimeo {
	background: #1ab7ea;
	border-color: #1ab7ea;
	color: #fff;
}
.btn-vimeo:active,
.btn-vimeo:focus,
.btn-vimeo:hover {
	background: #1295bf;
	color: #fff;
	border-color: #1295bf;
}

.btn-check:checked + .btn-outline-primary,
.btn-check:active + .btn-outline-primary,
.btn-outline-primary:active,
.btn-outline-primary.active,
.btn-outline-primary.dropdown-toggle.show {
	background-color: var(--primary);
	border-color: var(--primary);
	color: #fff;
}

.btn-check:checked + .btn-outline-primary:focus,
.btn-check:active + .btn-outline-primary:focus,
.btn-outline-primary:active:focus,
.btn-outline-primary.active:focus,
.btn-outline-primary.dropdown-toggle.show:focus {
	box-shadow: 0 0 0 0.25rem var(--rgba-primary-5);
}

.btn-check:focus + .btn-outline-primary,
.btn-outline-primary:focus {
	box-shadow: 0 0 0 0.25rem var(--rgba-primary-5);
}

.btn-close:focus {
	box-shadow: 0 0 0 0.25rem var(--rgba-primary-5);
}

.btn.btn-pink {
	background-color: #eb62d0;
	color: #fff;
}
.btn.btn-pink:hover {
	background-color: rgba(235, 98, 208, 0.8);
}

.btn.light.btn-pink {
	background-color: rgba(235, 98, 208, 0.1);
	color: #eb62d0;
}
.btn.light.btn-pink:hover {
	background-color: #eb62d0;
	color: #fff;
}

.btn.light:hover svg path {
	fill: #fff;
}

.bg-success.light {
	background-color: rgba(30, 186, 98, 0.2) !important;
}
.bg-success.light svg path {
	fill: #1eba62;
}
.bg-success.light:hover {
	background-color: #1eba62 !important;
}
.bg-success.light:hover svg path {
	fill: #fff;
}

.bg-info.light {
	background-color: rgba(0, 173, 163, 0.2) !important;
}
.bg-info.light svg path {
	fill: #00ada3;
}
.bg-info.light:hover {
	background-color: #00ada3 !important;
}
.bg-info.light:hover svg path {
	fill: #fff;
}

.card {
	margin-bottom: 1.875rem;
	background-color: #ffffff;
	transition: all 0.5s ease-in-out;
	position: relative;
	border: 0rem solid transparent;
	border-radius: 0.375rem;
	height: calc(100% - 30px);
}
@media only screen and (max-width: 35.9375rem) {
	.card {
		margin-bottom: 0.938rem;
		height: calc(100% - 0.938rem);
	}
}
.card-body {
	padding: 1.875rem;
}
@media only screen and (max-width: 35.9375rem) {
	.card-body {
		padding: 1rem;
	}
}
.card-title {
	font-size: 1.125rem;
	font-weight: 600;
	color: #303972;
	text-transform: capitalize;
}
.card-title--large {
	font-size: 1.5rem;
}
.card-title--medium {
	font-size: 1rem;
}
.card-title--small {
	font-size: 0.875rem;
}
.card-header {
	border-color: #dddddd;
	position: relative;
	background: transparent;
	padding: 1.5rem 1.875rem 1.25rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-radius: 0.375rem 0.375rem 0px 0px !important;
}
@media only screen and (max-width: 35.9375rem) {
	.card-header {
		padding: 1.25rem 1rem 1.25rem;
	}
}
[data-theme-version='dark'] .card-header {
	border-color: rgba(255, 255, 255, 0.1);
}
.card-header .card-title {
	margin-bottom: 0rem;
}
.card-header .subtitle {
	padding-top: 0.3125rem;
	font-size: 0.875rem;
	line-height: 1.5;
}
.card-footer {
	border-color: #dddddd;
	background: transparent;
	padding: 1.25rem 1.875rem 1.25rem;
}
[data-theme-version='dark'] .card-footer {
	border-color: rgba(255, 255, 255, 0.1);
}

.transparent-card.card {
	background: transparent;
	border: 0.0625rem solid transparent;
	box-shadow: none;
}

.card-action > a {
	display: inline-block;
	width: 1.875rem;
	height: 1.875rem;
	line-height: 1.875rem;
	border-radius: 0.3125rem;
	border-color: transparent;
	text-align: center;
	background: var(--primary-dark);
	color: #fff;
	margin-right: 0.5rem;
}
[data-theme-version='dark'] .card-action > a {
	background: #202020;
}
.card-action > a:last-child {
	margin-right: 0;
}
.card-action > a:hover,
.card-action > a:focus {
	background: var(--primary-dark);
}
[data-theme-version='dark'] .card-action > a:hover,
[data-theme-version='dark'] .card-action > a:focus {
	background: #202020;
}
.card-action > a i,
.card-action > a span {
	font-size: 1rem;
}

.card-action .dropdown {
	width: 1.875rem;
	height: 1.875rem;
	border-radius: 0.3125rem;
	border-color: transparent;
	text-align: center;
	margin-right: 0.5rem;
	top: -0.125rem;
	position: relative;
	display: inline-block;
	background: var(--primary-dark);
	color: var(--primary);
}
[data-theme-version='dark'] .card-action .dropdown {
	background: #202020;
}
.card-action .dropdown:hover,
.card-action .dropdown:focus {
	background: var(--primary-dark);
}
[data-theme-version='dark'] .card-action .dropdown:hover,
[data-theme-version='dark'] .card-action .dropdown:focus {
	background: #202020;
}
.card-action .dropdown .btn {
	padding: 0;
	line-height: 1.6875rem;
	color: #fff;
}
.card-action .dropdown .btn:focus {
	box-shadow: none;
}

.card-fullscreen {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 99999999;
	overflow: auto;
}

.card-loader {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	background-color: rgba(0, 0, 0, 0.75);
	z-index: 999;
}

.card-loader i {
	margin: 0 auto;
	background: var(--primary-dark);
	padding: 0.625rem;
	border-radius: 50%;
	color: #fff;
	font-size: 1rem;
}

.rotate-refresh {
	animation: mymove 0.8s infinite linear;
	display: inline-block;
}

.card-header .date_picker {
	display: inline-block;
	padding: 0.5rem;
	border: 0.0625rem solid #dddddd;
	cursor: pointer;
	border-radius: 0.375rem;
}

.card-header .border-0 {
	padding-bottom: 0;
}

@keyframes mymove {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.select2-container .select2-selection--single .select2-selection__clear {
	display: none;
}

.carousel-custom-prev,
.carousel-custom-next {
	width: 2.5rem;
	height: 2.5rem;
	line-height: 2.5rem;
	display: inline-block;
	border-radius: 50%;
	background: #fff;
	text-align: center;
}
.carousel-custom-prev i,
.carousel-custom-next i {
	font-size: 1rem;
}
.carousel-custom-prev:hover,
.carousel-custom-next:hover {
	background: linear-gradient(to right, rgba(245, 60, 121, 0.99) 0%, rgba(246, 104, 47, 0.99) 100%);
	color: #fff;
}

.carousel-custom-next {
	position: absolute;
	top: 50%;
	right: 30px;
	transform: translateY(-50%);
}

.carousel-custom-prev {
	position: absolute;
	top: 50%;
	left: 30px;
	transform: translateY(-50%);
}

.carousel-caption {
	text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.78);
	z-index: 1;
	background: rgba(0, 0, 0, 0.6);
}
.carousel-caption h5,
.carousel-caption .h5 {
	color: #fff;
	font-size: 1.8rem;
}
.carousel-caption p {
	margin-bottom: 0;
	color: #fff;
}

.carousel-indicators {
	z-index: 1;
}

.dropdown-toggle:focus {
	box-shadow: none !important;
}

.dropdown-outline {
	border: 0.1rem solid var(--primary);
}

.dropdown-menu {
	font-size: inherit;
	border: 0;
	z-index: 8;
	overflow: hidden;
	border-radius: 0.375rem;
	box-shadow: 0 0 3.125rem 0 rgba(82, 63, 105, 0.15);
	margin-top: 0;
}
.dropdown-menu .dropdown-item {
	font-size: 1rem;
	color: #a098ae;
	padding: 0.5rem 1.25rem;
}
@media only screen and (max-width: 87.5rem) {
	.dropdown-menu .dropdown-item {
		padding: 0.375rem 1rem;
		font-size: 0.875rem;
		line-height: 1.5;
	}
}
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus,
.dropdown-menu .dropdown-item:active,
.dropdown-menu .dropdown-item.active {
	color: #514e5f;
}
.dropdown-menu .dropdown-item.active,
.dropdown-menu .dropdown-item:active {
	color: var(--primary);
	background: var(--rgba-primary-1);
}
[direction='rtl'] .dropdown-menu {
	right: auto !important;
}
.dropdown-menu.show {
	right: 0;
	overflow: unset !important;
}

.dropdown-toggle-split {
	padding: 0 0.625rem;
	opacity: 0.85;
}
.dropdown-toggle-split::after {
	display: inline-block;
	margin-left: 0.255em;
	vertical-align: 0.255em;
	content: '';
	border-top: 0.3em solid;
	border-right: 0.3em solid transparent;
	border-bottom: 0;
	border-left: 0.3em solid transparent;
}
.dropdown-toggle-split:after {
	margin-left: 0 !important;
}
.dropdown-toggle-split:active,
.dropdown-toggle-split:focus,
.dropdown-toggle-split:hover {
	opacity: 1;
}

/* .dropleft .dropdown-toggle:before,
.dropright .dropdown-toggle:before,
.dropup .dropdown-toggle:after,
.dropdown-toggle:after {
	content:"\\f107";
	font-family:FontAwesome;
	border: 0;
    vertical-align: middle;
    margin-left: 0.25em;
	line-height: 1;
} */
/* .dropup .dropdown-toggle:after{
	content:"\\f106";
} */
/* .dropleft .dropdown-toggle::before {
	content:"\\f104";
}
.dropright .dropdown-toggle::before {
	content:"\\f105";
} */
.dropright .dropdown-toggle::after {
	content: none;
}

.custom-dropdown {
	display: inline-block;
}
.custom-dropdown .dropdown-menu {
	border: 0rem;
	min-width: 10rem;
}

.card-action .custom-dropdown {
	margin: 0rem;
	background: var(--rgba-primary-1);
}
.card-action .custom-dropdown.show,
.card-action .custom-dropdown:focus,
.card-action .custom-dropdown:hover {
	background: var(--primary);
	color: #fff;
}
.card-action .custom-dropdown i {
	display: inline-block;
	padding-top: 0.5625rem;
}

.dropdown .dropdown-dots {
	position: relative;
	height: 0.3125rem;
	width: 0.3125rem;
	background: rgba(48, 57, 114, 0.4);
	border-radius: 0.3125rem;
	display: block;
}
.dropdown .dropdown-dots:after,
.dropdown .dropdown-dots:before {
	content: '';
	height: 0.3125rem;
	width: 0.3125rem;
	background: rgba(48, 57, 114, 0.4);
	position: absolute;
	border-radius: 0.3125rem;
}
.dropdown .dropdown-dots:after {
	right: -0.5rem;
}
.dropdown .dropdown-dots:before {
	left: -0.5rem;
}
.dropdown .dropdown-dots.text-white {
	background: rgba(255, 255, 255, 0.7);
}
.dropdown .dropdown-dots.text-white:after,
.dropdown .dropdown-dots.text-white:before {
	background: rgba(255, 255, 255, 0.7);
}

div#bs-select-1 {
	min-height: 6.875rem;
}

.dtp > .dtp-content > .dtp-date-view > header.dtp-header,
.dtp div.dtp-date,
.dtp div.dtp-time {
	background: var(--primary);
}

.dtp-date i {
	color: #fff;
}

.dtp-buttons .btn-flat:focus {
	box-shadow: none;
}

.grid-col {
	padding: 0.8rem !important;
	background: #e6ebee;
	border-radius: 0.375rem;
}

.row.grid {
	margin-bottom: 1.5rem;
	text-align: center;
}

.row.grid .grid-col:first-child {
	text-align: left;
}

.label {
	display: inline-block;
	text-align: center;
	font-size: 0.75rem;
	padding: 0.2rem 0.8rem;
}
.label-fixed {
	width: 7.5rem;
	padding: 0.6rem 0;
}
.label-fixed-lg {
	width: 9.5rem;
	padding: 0.6rem 0;
}
.label-big {
	width: 16.8rem;
	font-size: 1.4rem;
	padding: 1.1rem 0;
}
.label-xl {
	width: 10.5rem;
	padding: 1.1rem 0;
	font-size: 1.5rem;
}
.label-lg {
	width: 9.5rem;
	padding: 1.1rem 0;
}
.label-md {
	width: 8.5rem;
	padding: 1.1rem 0;
}
.label-sm {
	width: 7.5rem;
	padding: 1.1rem 0;
}

.label-default {
	background: #adb6c7;
}

.label-primary {
	background: var(--primary);
	color: #fff;
}

.label-secondary {
	background: #fb7d5b;
	color: #fff;
}

.label-info {
	background: #00ada3;
	color: #fff;
}

.label-success {
	background: #1eba62;
	color: #fff;
}

.label-warning {
	background: #fcc43e;
	color: #fff;
}

.label-danger {
	background: #fd5353;
	color: #fff;
}

.label-light {
	background: #ebebf9;
	color: #000;
}

.label-dark {
	background: #303972;
	color: #fff;
}

code {
	word-break: break-word;
	padding: 0.125rem 0.3125rem;
	border-radius: 0.1875rem;
	background: #fff9f9;
	color: #fd5353;
}
[data-theme-version='dark'] code {
	background: rgba(253, 83, 83, 0.1);
}

.heading-labels {
	color: #333333;
}
.heading-labels > * {
	margin-bottom: 0.8rem;
}
.heading-labels h1 .label,
.heading-labels .h1 .label {
	font-size: 1.125rem;
	font-weight: normal;
	padding: 0.4rem 0.9rem;
}
.heading-labels h2 .label,
.heading-labels .h2 .label {
	font-size: 1rem;
	font-weight: normal;
	padding: 0.3rem 0.9rem;
}
.heading-labels h3 .label,
.heading-labels .h3 .label {
	font-size: 0.875rem;
	font-weight: normal;
}
.heading-labels h4 .label,
.heading-labels .h4 .label {
	font-size: 0.75rem;
	font-weight: normal;
}
.heading-labels h5 .label,
.heading-labels .h5 .label {
	font-size: 0.75rem;
	font-weight: normal;
}
.heading-labels h6 .label,
.heading-labels .h6 .label {
	font-size: 0.75rem;
	font-weight: normal;
}

.card-content p code {
	margin-left: 8px;
}

.list-group-item {
	background-color: rgba(255, 255, 255, 0);
	border: 1px solid #dddddd;
	padding: 1rem 1.5rem;
	color: #a098ae;
}
.list-group-item.active {
	background-color: var(--primary);
	border-color: var(--primary);
}
[data-theme-version='dark'] .list-group-item {
	border-color: rgba(255, 255, 255, 0.1);
}

.list-group-item.disabled,
.list-group-item:disabled {
	color: #fff;
	background-color: #fb7d5b;
	border-color: #fb7d5b;
}

[class*='bg-'] .list-group-item {
	border-color: rgba(255, 255, 255, 0.05);
	color: #fff;
}

.bg-warning .list-group-item {
	border-color: rgba(0, 0, 0, 0.05);
}

.media img {
	border-radius: 0.1875rem;
}

.vertical-card__menu:hover {
	box-shadow: none;
}

.vertical-card__menu--image {
	text-align: center;
}
.vertical-card__menu--image img {
	width: 100%;
	border-top-left-radius: 0.25rem;
	border-top-right-radius: 0.25rem;
}

.vertical-card__menu--status.closed {
	background: #fd5353;
}
.vertical-card__menu--status.closed:after {
	border-top: 0.625rem solid #fd5353;
}
.vertical-card__menu--status.closed .ribbon-curve {
	border-top: 0.6875rem solid #fd5353;
	border-bottom: 0.625rem solid #fd5353;
}

.vertical-card__menu--desc p {
	margin-bottom: 0.625rem;
}

.vertical-card__menu--price {
	font-size: 1.25rem;
	margin: 0;
	font-weight: 700;
}

.vertical-card__menu--rating {
	font-size: 0.75rem;
}

.vertical-card__menu--title {
	font-weight: 700;
}

.vertical-card__menu--button button {
	font-size: 0.75rem;
}

.vertical-card__menu .card-footer {
	padding: 0.9375rem 1.25rem;
	background-color: #f2f2f2;
	border-top: none;
}
@media only screen and (min-width: 75rem) and (max-width: 90rem) {
	.vertical-card__menu .card-footer {
		padding: 0.9375rem;
	}
}
.vertical-card__menu .card-footer span {
	color: #303972;
	margin-right: 0.3125rem;
}

.horizontal-card__menu {
	box-shadow: 0 0 0.4375rem rgba(173, 173, 173, 0.32);
	display: flex;
	flex-direction: row;
	display: block;
}
.horizontal-card__menu .card-body {
	padding: 0;
	padding: 1.25rem 1.875rem;
}
.horizontal-card__menu--image {
	flex-basis: 30%;
	max-width: 30%;
	max-width: unset;
	flex-basis: 100%;
}
.horizontal-card__menu--image img {
	height: 100%;
	width: 100%;
}
.horizontal-card__menu--title {
	font-size: 1rem;
	font-weight: 700;
	margin-bottom: 0.3125rem;
}
.horizontal-card__menu--fav {
	margin-right: 0.5rem;
}
.horizontal-card__menu--price {
	margin: 0;
	font-size: 1rem;
	font-weight: 700;
}
.horizontal-card__menu--rating {
	font-size: 0.625rem;
}
.horizontal-card__menu--footer {
	margin-top: 0.625rem;
}

.prev_price {
	text-decoration: line-through;
	font-size: 80%;
	opacity: 0.5;
}

.modal-header {
	padding: 1rem 1.875rem;
}
.modal-header .close {
	padding: 0.875rem 1.815rem;
	margin: 0;
	position: absolute;
	right: 0;
	float: none;
	top: 0;
	font-size: 1.875rem;
	font-weight: 100;
}

.modal-body {
	padding: 1.875rem;
}

.modal-footer {
	padding: 1rem 1.875rem;
}

.modal-content {
	border-radius: 0.375rem;
}

.modal-backdrop {
	z-index: 10 !important;
}

.Modal-box {
	background-color: #fff;
	height: 300px;
	border-radius: 8px;
	overflow: hidden;
}
@media only screen and (max-width: 35.9375rem) {
	.Modal-box {
		margin-bottom: 0.875rem;
	}
}
.Modal-box .box1 {
	display: flex;
	justify-content: space-between;
	padding: 20px 25px;
	border-bottom: 1px solid #3736ae30;
}
.Modal-box .box1 h3,
.Modal-box .box1 .h3 {
	color: black;
}
.Modal-box .box1 i {
	font-size: 20px;
}
.Modal-box .box2 {
	padding: 10px 25px;
	height: 150px;
}
.Modal-box .box3 {
	padding: 20px 25px;
	text-align: end;
	background-color: #f4f4f5;
	border-top: 1px solid #3736ae30;
}
.Modal-box .box3 .bt-1 {
	color: #f34e5f;
	background-color: #e9c7cd;
	padding: 5px 15px;
	border: 1px solid #e9c7cd;
	margin-right: 5px;
	border-radius: 6px;
}
.Modal-box .box3 .bt-2 {
	color: #fff;
	background-color: #3736ae;
	border: 1px solid #3736ae;
	padding: 5px 15px;
	border-radius: 6px;
}

.pagination .page-item .page-link:hover {
	background: var(--primary);
	border-color: var(--primary);
	color: #fff;
}

.pagination .page-item.active .page-link {
	background: var(--primary);
	border-color: var(--primary);
	color: #fff;
}

.pagination {
	margin-bottom: 1.25rem;
}
.pagination .page-item.page-indicator .page-link {
	padding: 0.69rem 0.8rem;
	font-size: 1.2rem;
	border-top-left-radius: unset;
	border-bottom-left-radius: unset;
	border-radius: 0.375rem;
}
.pagination .page-item.page-indicator:hover .page-link {
	color: #303972;
}
.pagination .page-item .page-link {
	z-index: 1;
	padding: 0;
	width: 2.5rem;
	height: 2.5rem;
	border-radius: 0.625rem;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 1rem;
	background: rgba(255, 255, 255, 0.15);
	color: #303972;
	margin-left: 7px;
	border: 0.0625rem solid #dddddd;
}
[data-theme-version='dark'] .pagination .page-item .page-link {
	border-color: rgba(255, 255, 255, 0.1);
	color: #7e8dbf;
	background: rgba(255, 255, 255, 0);
}
.pagination .page-item .page-link:hover i,
.pagination .page-item .page-link span {
	color: #fff;
}
.pagination .page-item .page-link:focus {
	outline: 0;
	box-shadow: none;
}
.pagination .page-item .page-link:hover {
	background: var(--primary);
	color: #fff;
	border-color: var(--primary);
}
.pagination .page-item.active .page-link {
	background-color: var(--primary);
	border-color: var(--primary);
	color: #fff;
}
[data-theme-version='dark'] .pagination .page-item.active .page-link {
	color: #fff;
}
.pagination .page-item .page-link {
	color: #303972;
	transition: all 0.5s;
}
.pagination .page-item:last-child .page-link {
	margin-right: 0;
}
[direction='rtl'] .pagination .page-item:first-child .page-link {
	margin-right: 0;
}
.pagination.no-bg li:not(.page-indicator):not(.active) .page-link {
	background: #fff;
	border-color: transparent;
}
.pagination.no-bg.pagination-primary li:not(.page-indicator):not(.active):hover .page-link {
	background: var(--primary);
	border-color: var(--primary);
}
[data-theme-version='dark'] .pagination.no-bg.pagination-primary li:not(.page-indicator):not(.active):hover .page-link {
	background: var(--primary);
	border-color: var(--primary);
}
.pagination.no-bg.pagination-danger li:not(.page-indicator):not(.active):hover .page-link {
	background: #fd5353;
	border-color: #fd5353;
}
[data-theme-version='dark'] .pagination.no-bg.pagination-danger li:not(.page-indicator):not(.active):hover .page-link {
	background: #fd5353;
	border-color: #fd5353;
}
.pagination.no-bg.pagination-info li:not(.page-indicator):not(.active):hover .page-link {
	background: #00ada3;
	border-color: #00ada3;
}
[data-theme-version='dark'] .pagination.no-bg.pagination-info li:not(.page-indicator):not(.active):hover .page-link {
	background: #00ada3;
	border-color: #00ada3;
}
.pagination.no-bg.pagination-warning li:not(.page-indicator):not(.active):hover .page-link {
	background: #fcc43e;
	border-color: #fcc43e;
}
[data-theme-version='dark'] .pagination.no-bg.pagination-warning li:not(.page-indicator):not(.active):hover .page-link {
	background: #fcc43e;
	border-color: #fcc43e;
}
.pagination-primary .page-item .page-link {
	background: var(--rgba-primary-1);
	border-color: var(--rgba-primary-1);
	color: #303972;
}
[data-theme-version='dark'] .pagination-primary .page-item .page-link {
	background: var(--rgba-primary-1);
	border-color: transparent;
	color: var(--primary);
}
.pagination-primary .page-item:hover .page-link,
.pagination-primary .page-item.active .page-link {
	background: var(--primary);
	border-color: var(--primary);
}
[data-theme-version='dark'] .pagination-primary .page-item:hover .page-link,
[data-theme-version='dark'] .pagination-primary .page-item.active .page-link {
	color: #fff;
}
.pagination-danger .page-item .page-link {
	background: #ffeaea;
	border-color: #ffeaea;
	color: #fd5353;
}
[data-theme-version='dark'] .pagination-danger .page-item .page-link {
	background: rgba(253, 83, 83, 0.15);
	border-color: transparent;
	color: #fd5353;
}
.pagination-danger .page-item:hover .page-link,
.pagination-danger .page-item.active .page-link {
	background: #fd5353;
	border-color: #fd5353;
	box-shadow: 0 0.625rem 1.25rem 0rem rgba(253, 83, 83, 0.2);
}
[data-theme-version='dark'] .pagination-danger .page-item:hover .page-link,
[data-theme-version='dark'] .pagination-danger .page-item.active .page-link {
	color: #fff;
}
.pagination-info .page-item .page-link {
	background: #94fff9;
	border-color: #94fff9;
	color: #00ada3;
}
[data-theme-version='dark'] .pagination-info .page-item .page-link {
	background: rgba(0, 173, 163, 0.1);
	border-color: transparent;
	color: #00ada3;
}
.pagination-info .page-item:hover .page-link,
.pagination-info .page-item.active .page-link {
	background: #00ada3;
	border-color: #00ada3;
	box-shadow: 0 0.625rem 1.25rem 0rem rgba(0, 173, 163, 0.2);
}
.pagination-warning .page-item .page-link {
	background: #fffaee;
	border-color: #fffaee;
	color: #fcc43e;
}
[data-theme-version='dark'] .pagination-warning .page-item .page-link {
	background: rgba(252, 196, 62, 0.1);
	border-color: transparent;
	color: #fcc43e;
}
.pagination-warning .page-item:hover .page-link,
.pagination-warning .page-item.active .page-link {
	background: #fcc43e;
	border-color: #fcc43e;
	box-shadow: 0 0.625rem 1.25rem 0rem rgba(252, 196, 62, 0.2);
}
.pagination-gutter .page-item {
	margin-right: 0.4375rem;
}
.pagination-gutter .page-item .page-link {
	border-radius: 0.375rem !important;
}
.pagination-circle .page-item {
	margin-right: 0.4375rem;
}
.pagination-circle .page-item .page-link,
.pagination-circle .page-item .page-link {
	width: 2.5rem;
	height: 2.5rem;
	padding: 0;
	line-height: 2.5rem;
	border-radius: 50% !important;
	padding: 0;
}
.pagination-circle .page-item.page-indicator .page-link {
	width: 2.5rem;
	border: 1px solid var(--primary);
	border-radius: 22px !important;
	line-height: 1.3rem;
	height: 2.5rem;
	background: var(--rgba-primary-1);
	color: var(--primary);
}
.pagination-circle .page-item.page-indicator .page-link:hover {
	color: #fff;
	background: var(--primary);
}
.pagination.pagination-md .page-item .page-link {
	width: 1.875rem;
	height: 1.875rem;
	line-height: 1.875rem;
	font-size: 0.875rem;
}
.pagination.pagination-sm .page-item.page-indicator .page-link {
	font-size: 0.75rem;
}
.pagination.pagination-sm .page-item .page-link {
	padding: 0;
	width: 2.5rem;
	height: 2.5rem;
	line-height: 2.5rem;
	font-size: 1.125rem;
}
.pagination.pagination-xs .page-item.page-indicator .page-link {
	font-size: 0.625rem;
}
.pagination.pagination-xs .page-item .page-link {
	padding: 0;
	width: 1.5625rem;
	height: 1.5625rem;
	line-height: 1.5625rem;
	font-size: 0.75rem;
}

.popover {
	border: 0.125rem solid #fb7d5b;
	min-width: 13.125rem;
	box-shadow: 0 0 1.875rem 0 rgba(0, 0, 0, 0.1);
	border-radius: 0.375rem;
}
[data-theme-version='dark'] .popover {
	background-color: #202020;
}
.popover-header {
	background: #fb7d5b;
	color: #fff;
	font-weight: 300;
}
.popover-header::before {
	border-bottom: 0 !important;
}
.popover-body {
	font-size: 0.75rem;
}
.popover .popover-header {
	border-radius: 3.5px 3.5px 0px 0px;
}
[data-theme-version='dark'] .popover .popover-header {
	border-color: #272738;
}
@media only screen and (max-width: 47.9375rem) {
	.popover {
		z-index: 1;
	}
}

.bootstrap-popover-wrapper .bootstrap-popover:not(:last-child) {
	margin-right: 0.5rem;
}

.bootstrap-popover-wrapper .bootstrap-popover {
	margin-bottom: 0.5rem;
}
.bootstrap-popover-wrapper .bootstrap-popover button:hover,
.bootstrap-popover-wrapper .bootstrap-popover button:focus {
	background: var(--primary);
	color: #fff;
	box-shadow: none;
}

.bs-popover-top .arrow::after,
.bs-popover-auto[data-popper-placement^='top'] .arrow::after,
.bs-popover-auto[x-placement^='top'] .arrow::after {
	bottom: 0rem;
	border-top-color: #fb7d5b;
}

.bs-popover-left .arrow::after,
.bs-popover-auto[x-placement^='left'] .arrow::after {
	right: 0rem;
	border-left-color: #fb7d5b;
}

.bs-popover-right .arrow::after,
.bs-popover-auto[x-placement^='right'] .arrow::after {
	left: 0rem;
	border-right-color: #fb7d5b;
}

.bs-popover-bottom .arrow::after,
.bs-popover-auto[data-popper-placement^='bottom'] .arrow::after,
.bs-popover-auto[x-placement^='bottom'] .arrow::after {
	top: 0rem;
	border-bottom-color: #fb7d5b;
}

.note-popover {
	display: none;
}

.progress-bar {
	background-color: var(--primary);
}

.progress-bar-primary {
	background-color: var(--primary);
}

.progress-bar-success {
	background-color: #1eba62;
}

.progress-bar-info {
	background-color: #00ada3;
}

.progress-bar-danger {
	background-color: #fd5353;
}

.progress-bar-warning {
	background-color: #fcc43e;
}

.progress-bar-pink {
	background-color: #eb62d0;
}

.progress {
	height: 0.688rem;
	background-color: #f2f2f2;
	overflow: hidden;
}
[data-theme-version='dark'] .progress {
	background-color: #202020;
}
.progress-bar {
	border-radius: 0.375rem;
}

.progress-vertical {
	display: inline-block;
	margin-bottom: 0;
	margin-right: 2rem;
	min-height: 17rem;
	position: relative;
}
@media (max-width: 767.98px) {
	.progress-vertical {
		margin-right: 1rem;
	}
}

.progress-vertical-bottom {
	display: inline-block;
	margin-bottom: 0;
	margin-right: 2rem;
	min-height: 17rem;
	position: relative;
	transform: rotate(180deg);
}
@media (max-width: 767.98px) {
	.progress-vertical-bottom {
		margin-right: 1rem;
	}
}

.progress-animated {
	animation-duration: 5s;
	animation-name: myanimation;
	transition: all 5s ease 0s;
}

@keyframes myanimation {
	0% {
		width: 0;
	}
}

@keyframes myanimation {
	0% {
		width: 0;
	}
}

.ribbon {
	position: absolute;
	z-index: 1;
	text-transform: uppercase;
}
.ribbon__one {
	top: 0.9375rem;
	left: -0.6875rem;
	min-height: 1.25rem;
	min-width: 3.25rem;
	text-align: center;
	padding: 0.1875rem 0.625rem;
	background: #3ab54b;
	color: #fff;
	font-size: 0.625rem;
}
.ribbon__one::after {
	position: absolute;
	width: 0;
	height: 0;
	border-top: 0.625rem solid #239132;
	border-left: 0.6875rem solid transparent;
	left: 0;
	content: '';
	bottom: -0.625rem;
}
.ribbon__two {
	width: 3.125rem;
	height: 3.125rem;
	display: inline-block;
	background: #fcc43e;
	line-height: 3.125rem;
	text-align: center;
	font-size: 1rem;
	color: #fff;
	right: 0.9375rem;
	top: 0.9375rem;
	border-radius: 0.1875rem;
}
.ribbon__three {
	left: -1.875rem;
	top: 0.875rem;
	width: 6.875rem;
	height: 1.5625rem;
	background-color: #fd5353;
	clip-path: polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);
	transform: rotate(-45deg);
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.875rem;
}
.ribbon__four {
	left: 0.5rem;
	top: -0.5rem;
	width: 6.875rem;
	height: 3.125rem;
	background-color: var(--primary);
	z-index: auto;
	color: #fff;
	font-size: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
}
.ribbon__four:after {
	right: -0.3125rem;
}
.ribbon__four:before {
	left: -0.3125rem;
}
.ribbon__four:after,
.ribbon__four:before {
	z-index: -1;
	background-color: var(--rgba-primary-1);
	top: 0.1875rem;
	transform: rotate(45deg);
	content: '';
	height: 0.625rem;
	width: 0.625rem;
	position: absolute;
}
.ribbon__five {
	left: -1.875rem;
	top: 0.625rem;
	width: 6.875rem;
	height: 1.875rem;
	background-color: var(--primary);
	transform: rotate(-45deg);
	font-size: 0.75rem;
	color: #fff;
	padding-bottom: 0.3125rem;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1rem;
}
.ribbon__five::before {
	position: absolute;
	content: '';
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 3.125rem 3.125rem 3.125rem;
	border-color: transparent transparent var(--primary) transparent;
	left: 0.25rem;
	top: -2.8125rem;
}
.ribbon__six {
	left: 0;
	top: 1.125rem;
	width: 6.875rem;
	height: 2.375rem;
	background-color: var(--primary);
	clip-path: polygon(0 0, 100% 0%, 100% 0, 85% 50%, 100% 100%, 100% 100%, 0 100%);
	display: flex;
	font-size: 1.25rem;
	align-items: center;
	justify-content: center;
	color: #fff;
}
.ribbon-curve {
	position: absolute;
	top: 0;
	right: -0.375rem;
	width: 0.625rem;
	height: 0.6875rem;
	border-top: 0.6875rem solid #3ab54b;
	border-bottom: 0.625rem solid #3ab54b;
	border-right: 0.3125rem solid transparent;
}

.jsgrid-grid-body::-webkit-scrollbar,
.dataTables_scrollBody::-webkit-scrollbar,
.table-responsive::-webkit-scrollbar {
	background-color: #f5f5f5;
	width: 0.5rem;
	height: 0.5rem;
}

.jsgrid-grid-body::-webkit-scrollbar-track,
.dataTables_scrollBody::-webkit-scrollbar-track,
.table-responsive::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 0.375rem rgba(0, 0, 0, 0.3);
	border-radius: 0.625rem;
	background-color: #f5f5f5;
}

.jsgrid-grid-body::-webkit-scrollbar-thumb,
.dataTables_scrollBody::-webkit-scrollbar-thumb,
.table-responsive::-webkit-scrollbar-thumb {
	border-radius: 0.625rem;
	-webkit-box-shadow: inset 0 0 0.375rem rgba(0, 0, 0, 0.3);
	background-color: var(--primary);
}

.multi-steps > li.is-active:before,
.multi-steps > li.is-active ~ li:before {
	content: counter(stepNum);
	font-family: inherit;
	font-weight: 400;
}

.multi-steps > li.is-active:after,
.multi-steps > li.is-active ~ li:after {
	background-color: #f2f2f2;
}

.multi-steps {
	display: table;
	table-layout: fixed;
	width: 100%;
}
.multi-steps > li {
	counter-increment: stepNum;
	text-align: center;
	display: table-cell;
	position: relative;
	color: var(--primary);
	font-size: 0.75rem;
}
.multi-steps > li:before {
	content: '\\2713';
	display: block;
	margin: 0 auto 0.25rem;
	background-color: #fff;
	width: 1.5625rem;
	height: 1.5625rem;
	line-height: 1.375rem;
	text-align: center;
	font-weight: bold;
	position: relative;
	z-index: 1;
	width: 1.5625rem;
	height: 1.5625rem;
	line-height: 1.3125rem;
	border-width: 0.125rem;
	border-style: solid;
	border-color: var(--primary);
	border-radius: 0.3125rem;
}
.multi-steps > li:after {
	content: '';
	height: 0.125rem;
	width: 100%;
	background-color: var(--primary);
	position: absolute;
	top: 0.75rem;
	left: 50%;
	top: 0.75rem;
}
[direction='rtl'] .multi-steps > li:after {
	left: auto;
	right: 50%;
}
.multi-steps > li:last-child:after {
	display: none;
}
.multi-steps > li.is-active:before {
	background-color: #fff;
	border-color: var(--primary);
}
.multi-steps > li.is-active ~ li {
	color: #a098ae;
}
.multi-steps > li.is-active ~ li:before {
	background-color: #f2f2f2;
	border-color: #f2f2f2;
}

.nav-pills .nav-link {
	border-radius: 6px;
	padding: 0.5rem 1rem;
	font-size: 14px;
	font-weight: 500;
	color: #5b5e81;
	text-transform: capitalize;
	box-shadow: none;
}
[data-theme-version='dark'] .nav-pills .nav-link {
	color: #7e8dbf;
}
.nav-pills .nav-link:hover {
	color: var(--primary);
}

.default-tab .nav-link {
	background: transparent;
	border-radius: 0rem;
	font-weight: 500;
}
.default-tab .nav-link i {
	display: inline-block;
	transform: scale(1.5);
	color: #5b5e81;
}
.default-tab .nav-link:focus,
.default-tab .nav-link:hover,
.default-tab .nav-link.active {
	color: #495057;
	background-color: #fff;
	border-color: #dee2e6 #dee2e6 #fff #ebeef6;
	border-radius: 0.375rem 0.375rem 0 0;
	color: var(--primary);
}
[data-theme-version='dark'] .default-tab .nav-link:focus,
[data-theme-version='dark'] .default-tab .nav-link:hover,
[data-theme-version='dark'] .default-tab .nav-link.active {
	background-color: var(--rgba-primary-1);
	border-color: transparent transparent rgba(255, 255, 255, 0.1) transparent;
}

.custom-tab-1 .nav-link {
	background: transparent;
	border-radius: 0rem;
	font-weight: 500;
	border-bottom: 0.1875rem solid transparent;
	border-width: 0 0rem 0.1875rem 0;
}
.custom-tab-1 .nav-link i {
	display: inline-block;
	transform: scale(1.5);
	color: var(--primary);
}
.custom-tab-1 .nav-link:focus,
.custom-tab-1 .nav-link:hover,
.custom-tab-1 .nav-link.active {
	color: #495057;
	background-color: #fff;
	border-color: var(--primary);
	border-radius: 0;
	color: var(--primary);
	border-width: 0 0rem 0.1875rem 0;
}
[data-theme-version='dark'] .custom-tab-1 .nav-link:focus,
[data-theme-version='dark'] .custom-tab-1 .nav-link:hover,
[data-theme-version='dark'] .custom-tab-1 .nav-link.active {
	background-color: var(--rgba-primary-1);
}

.nav-pills.light .nav-link.active,
.nav-pills.light .show > .nav-link {
	background: var(--rgba-primary-1);
	color: var(--primary);
	box-shadow: none;
}
[data-theme-version='dark'] .nav-pills.light .nav-link.active,
[data-theme-version='dark'] .nav-pills.light .show > .nav-link {
	background: var(--rgba-primary-1);
}

.nav-pills .nav-link.active,
.nav-pills:hover .show > .nav-link {
	background-color: var(--rgba-primary-1);
	color: var(--primary);
}

.tooltip-wrapper button:not(:last-child) {
	margin-right: 0.5rem;
}

.tooltip-wrapper button:hover {
	background: var(--primary);
	color: #fff;
}

.tooltip-wrapper button {
	margin-bottom: 0.5rem;
}
.tooltip-wrapper button:focus {
	box-shadow: none;
}

.tooltip-inner {
	border-radius: 0;
	background: #333333;
	font-size: 0.75rem;
	font-weight: 300;
	padding: 0.35rem 0.7rem;
}

.bs-tooltip-bottom .arrow::before,
.bs-tooltip-auto[data-popper-placement^='bottom'] .arrow::before,
.bs-tooltip-auto[x-placement^='bottom'] .arrow::before {
	border-bottom-color: #333333;
}

.bs-tooltip-right .arrow::before,
.bs-tooltip-auto[x-placement^='right'] .arrow::before {
	border-right-color: #333333;
}

.bs-tooltip-left .arrow::before,
.bs-tooltip-auto[x-placement^='left'] .arrow::before {
	border-left-color: #333333;
}

.bs-tooltip-top .arrow::before,
.bs-tooltip-auto[data-popper-placement^='top'] .arrow::before,
.bs-tooltip-auto[x-placement^='top'] .arrow::before {
	border-top-color: #333333;
}

.widget-timeline .timeline {
	list-style: none;
	position: relative;
}
.widget-timeline .timeline:before {
	top: 1.25rem;
	bottom: 0;
	position: absolute;
	content: ' ';
	width: 0.1875rem;
	left: 0.5625rem;
	margin-right: -0.0938rem;
	background: #e6ebee;
}
[data-theme-version='dark'] .widget-timeline .timeline:before {
	background: rgba(255, 255, 255, 0.1);
}
[direction='rtl'] .widget-timeline .timeline:before {
	left: auto;
	right: 0.5625rem;
	margin-right: auto;
	margin-left: -0.0938rem;
}
.widget-timeline .timeline > li {
	margin-bottom: 0.9375rem;
	position: relative;
}
.widget-timeline .timeline > li:before {
	content: ' ';
	display: table;
}
.widget-timeline .timeline > li:after {
	content: ' ';
	display: table;
	clear: both;
}
.widget-timeline .timeline > li > .timeline-panel {
	border-radius: 0.375rem;
	padding: 0.9375rem 1.25rem;
	position: relative;
	display: block;
	margin-left: 2.5rem;
	border-width: 0.0625rem;
	border-style: solid;
}
.widget-timeline .timeline > li > .timeline-panel span {
	font-size: 0.75rem;
	display: block;
	margin-bottom: 0.3125rem;
	letter-spacing: 0.0625rem;
}
.widget-timeline .timeline > li > .timeline-panel p {
	font-size: 0.875rem;
}
.widget-timeline .timeline > li > .timeline-panel:after {
	content: '';
	width: 0.625rem;
	height: 0.625rem;
	background: inherit;
	border-color: inherit;
	border-style: solid;
	border-width: 0rem 0rem 0.0625rem 0.0625rem;
	display: block;
	position: absolute;
	left: -0.3125rem;
	transform: rotate(45deg);
	top: 0.9375rem;
}
.widget-timeline .timeline > li > .timeline-badge {
	border-radius: 50%;
	height: 1.375rem;
	left: 0;
	position: absolute;
	top: 0.625rem;
	width: 1.375rem;
	border-width: 0.125rem;
	border-style: solid;
	background: #fff;
	padding: 0.25rem;
}
[data-theme-version='dark'] .widget-timeline .timeline > li > .timeline-badge {
	background-color: #272738;
}
.widget-timeline .timeline > li > .timeline-badge:after {
	content: '';
	width: 0.625rem;
	height: 0.625rem;
	border-radius: 100%;
	display: block;
}
[direction='rtl'] .widget-timeline .timeline > li > .timeline-badge {
	left: auto;
	right: 1.1875rem;
}

.widget-timeline .timeline-body > p {
	font-size: 0.75rem;
}

.widget-timeline .timeline-badge.primary {
	border-color: var(--rgba-primary-1);
}
[data-theme-version='dark'] .widget-timeline .timeline-badge.primary {
	border-color: var(--rgba-primary-1);
}
.widget-timeline .timeline-badge.primary:after {
	background-color: var(--primary);
	box-shadow: 0 0.3125rem 0.625rem 0 var(--rgba-primary-2);
}
.widget-timeline .timeline-badge.primary + .timeline-panel {
	background: var(--rgba-primary-1);
	border-color: var(--rgba-primary-1);
}
[data-theme-version='dark'] .widget-timeline .timeline-badge.primary + .timeline-panel {
	border-color: transparent;
	background-color: var(--rgba-primary-1);
}

.widget-timeline .timeline-badge.success {
	border-color: #ddfaea;
}
[data-theme-version='dark'] .widget-timeline .timeline-badge.success {
	border-color: rgba(30, 186, 98, 0.1);
}
.widget-timeline .timeline-badge.success:after {
	background-color: #1eba62 !important;
	box-shadow: 0 0.3125rem 0.625rem 0 rgba(30, 186, 98, 0.2);
}
.widget-timeline .timeline-badge.success + .timeline-panel {
	background: #ddfaea;
	border-color: #ddfaea;
}
[data-theme-version='dark'] .widget-timeline .timeline-badge.success + .timeline-panel {
	background-color: rgba(30, 186, 98, 0.1);
	border-color: transparent;
}

.widget-timeline .timeline-badge.warning {
	border-color: #fffaee;
}
[data-theme-version='dark'] .widget-timeline .timeline-badge.warning {
	border-color: rgba(252, 196, 62, 0.1);
}
.widget-timeline .timeline-badge.warning:after {
	background-color: #fcc43e !important;
	box-shadow: 0 0.3125rem 0.625rem 0 rgba(252, 196, 62, 0.2);
}
.widget-timeline .timeline-badge.warning + .timeline-panel {
	background: #fffaee;
	border-color: #fffaee;
}
[data-theme-version='dark'] .widget-timeline .timeline-badge.warning + .timeline-panel {
	background-color: rgba(252, 196, 62, 0.1);
	border-color: transparent;
}

.widget-timeline .timeline-badge.danger {
	border-color: #ffeaea;
}
[data-theme-version='dark'] .widget-timeline .timeline-badge.danger {
	border-color: rgba(253, 83, 83, 0.15);
}
.widget-timeline .timeline-badge.danger:after {
	background-color: #fd5353 !important;
	box-shadow: 0 0.3125rem 0.625rem 0 rgba(253, 83, 83, 0.2);
}
.widget-timeline .timeline-badge.danger + .timeline-panel {
	background: #ffeaea;
	border-color: #ffeaea;
}
[data-theme-version='dark'] .widget-timeline .timeline-badge.danger + .timeline-panel {
	background-color: rgba(253, 83, 83, 0.15);
	border-color: transparent;
}

.widget-timeline .timeline-badge.info {
	border-color: var(--rgba-secondary-1);
}
[data-theme-version='dark'] .widget-timeline .timeline-badge.info {
	border-color: var(--rgba-secondary-1);
}
.widget-timeline .timeline-badge.info:after {
	background-color: var(--secondary) !important;
	box-shadow: 0 0.3125rem 0.625rem 0 rgba(0, 173, 163, 0.2);
}
.widget-timeline .timeline-badge.info + .timeline-panel {
	background: var(--rgba-secondary-1);
	border-color: #94fff9;
}
[data-theme-version='dark'] .widget-timeline .timeline-badge.info + .timeline-panel {
	background-color: rgba(0, 173, 163, 0.1);
	border-color: transparent;
}

.widget-timeline .timeline-badge.dark {
	border-color: #bec3e3;
}
[data-theme-version='dark'] .widget-timeline .timeline-badge.dark {
	border-color: rgba(48, 57, 114, 0.35);
}
.widget-timeline .timeline-badge.dark:after {
	background-color: #303972 !important;
	box-shadow: 0 0.3125rem 0.625rem 0 rgba(48, 57, 114, 0.2);
}
.widget-timeline .timeline-badge.dark + .timeline-panel {
	background: #bec3e3;
	border-color: #bec3e3;
}
[data-theme-version='dark'] .widget-timeline .timeline-badge.dark + .timeline-panel {
	background-color: rgba(48, 57, 114, 0.35);
	border-color: transparent;
}

.widget-timeline.style-1 .timeline-panel {
	background: transparent;
}

.widget-timeline.style-1 .timeline .timeline-badge.timeline-badge + .timeline-panel {
	background: transparent !important;
	border-style: solid;
	border-width: 0 0 0 0.3125rem;
	border-radius: 0;
	padding: 0.3125rem 0.625rem 0.3125rem 0.9375rem;
}
.widget-timeline.style-1 .timeline .timeline-badge.timeline-badge + .timeline-panel:after {
	border: 0;
	left: -0.5625rem;
	width: 0.4375rem;
	height: 0.4375rem;
}

.widget-timeline.style-1 .timeline .timeline-badge.primary + .timeline-panel {
	border-color: var(--primary);
}
.widget-timeline.style-1 .timeline .timeline-badge.primary + .timeline-panel:after {
	background: var(--primary);
}

.widget-timeline.style-1 .timeline .timeline-badge.success + .timeline-panel {
	border-color: #1eba62;
}
.widget-timeline.style-1 .timeline .timeline-badge.success + .timeline-panel:after {
	background: #1eba62;
}

.widget-timeline.style-1 .timeline .timeline-badge.warning + .timeline-panel {
	border-color: #fcc43e;
}
.widget-timeline.style-1 .timeline .timeline-badge.warning + .timeline-panel:after {
	background: #fcc43e;
}

.widget-timeline.style-1 .timeline .timeline-badge.danger + .timeline-panel {
	border-color: #fd5353;
}
.widget-timeline.style-1 .timeline .timeline-badge.danger + .timeline-panel:after {
	background: #fd5353;
}

.widget-timeline.style-1 .timeline .timeline-badge.info + .timeline-panel {
	border-color: #00ada3;
}
.widget-timeline.style-1 .timeline .timeline-badge.info + .timeline-panel:after {
	background: #00ada3;
}

.widget-timeline.style-1 .timeline .timeline-badge.dark + .timeline-panel {
	border-color: #303972;
}
.widget-timeline.style-1 .timeline .timeline-badge.dark + .timeline-panel:after {
	background: #303972;
}

#chart_widget_4 {
	height: 15.9375rem !important;
}

#chart_widget_5 .ct-series-a .ct-line,
#chart_widget_5 .ct-series-a .ct-point {
	stroke: #46ffc8;
}

#chart_widget_5 .ct-line {
	stroke-width: 0.0625rem;
}

#chart_widget_5 .ct-point {
	stroke-width: 0.125rem;
}

#chart_widget_5 .ct-series-a .ct-area {
	fill: #20dea6;
}

#chart_widget_5 .ct-area {
	fill-opacity: 1;
}

#chart_widget_6 .ct-series-a .ct-line,
#chart_widget_6 .ct-series-a .ct-point {
	stroke: #00ada3;
}

#chart_widget_6 .ct-line {
	stroke-width: 0.125rem;
}

#chart_widget_6 .ct-point {
	stroke-width: 0.3125rem;
}

#chart_widget_6 .ct-series-a .ct-area {
	fill: #00ada3;
}

#chart_widget_6 .ct-area {
	fill-opacity: 0.5;
}

#chart_widget_8 {
	height: 15.9375rem;
}
#chart_widget_8 .ct-series-a .ct-line,
#chart_widget_8 .ct-series-a .ct-point {
	stroke: #00ada3;
}
#chart_widget_8 .ct-line {
	stroke-width: 0.125rem;
}
#chart_widget_8 .ct-point {
	stroke-width: 0.3125rem;
}
#chart_widget_8 .ct-series-a .ct-area {
	fill: #00ada3;
}
#chart_widget_8 .ct-area {
	fill-opacity: 0.5;
}

#chart_widget_9,
#chart_widget_10 {
	height: 15.625rem !important;
	margin-bottom: -5px;
}

#chart_widget_11 .ct-slice-donut,
#chart_widget_12 .ct-slice-donut,
#chart_widget_13 .ct-slice-donut {
	stroke-width: 1.5625rem !important;
}

#chart_widget_11 {
	height: 16.875rem !important;
	margin-bottom: -5px;
}

#chart_widget_17 {
	height: 9.375rem !important;
}

.chart_widget_tab_one .nav-link {
	border: 0.0625rem solid #ddd;
}
.chart_widget_tab_one .nav-link.active {
	background-color: var(--primary);
	border: 0.0625rem solid var(--primary);
	color: #fff;
}
.chart_widget_tab_one .nav-link.active:hover {
	border: 0.0625rem solid var(--primary);
}
.chart_widget_tab_one .nav-link:hover {
	border: 0.0625rem solid #ddd;
}

[data-theme-version='dark'] .ccc-widget > div {
	background: #272738 !important;
	border-color: rgba(255, 255, 255, 0.1) !important;
}

.social-icon {
	display: inline-block;
	width: 2.5rem;
	height: 2.5rem;
	line-height: 2.5rem;
	border-radius: 0.25rem;
	text-align: center;
	background: #e6ebee;
	margin-bottom: 0.5rem;
	font-size: 1.25rem;
}
.social-icon i {
	color: #fff;
}
.social-icon.youtube {
	background: #ff0000;
}
.social-icon.facebook {
	background: #3b5998;
}
.social-icon.twitter {
	background: #1da1f2;
}

.social-graph-wrapper {
	text-align: center;
	padding: 1.25rem;
	position: relative;
	color: #fff;
	border-top-left-radius: 0.25rem;
	border-top-right-radius: 0.25rem;
}
.social-graph-wrapper.widget-facebook {
	background-color: #3b5998;
}
.social-graph-wrapper.widget-twitter {
	background-color: #1da1f2;
}
.social-graph-wrapper.widget-linkedin {
	background-color: #007bb6;
}
.social-graph-wrapper.widget-googleplus {
	background-color: #db4439;
}
.social-graph-wrapper .s-icon {
	font-size: 1.5rem;
	position: relative;
	padding: 0 0.625rem;
}

.social-icon2 a {
	border: 0.1rem solid var(--primary);
	display: block;
	padding: 1rem;
	margin-top: 1.5rem;
	margin-bottom: 0.5rem;
	border-radius: 0.3rem;
	font-size: 1.6rem;
}

.social-icon2 i {
	font-size: 0.75rem;
	color: var(--primary);
}

.social-icon3 ul li {
	display: inline-block;
}
.social-icon3 ul li a {
	display: block;
}
.social-icon3 ul li a i {
	font-size: 1.4rem;
	padding: 1rem 0.7rem;
	color: #464a53;
}
.social-icon3 ul li a:hover i {
	color: var(--primary);
}

.social-icons-muted ul li a i {
	color: #89879f;
}

.social-links a {
	padding: 0.5rem;
}

.widget-stat .media {
	padding: 0rem 0;
	align-items: center;
}
.widget-stat .media > span {
	height: 5.3125rem;
	width: 5.3125rem;
	border-radius: 3.125rem;
	padding: 0.625rem 0.75rem;
	font-size: 2rem;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #464a53;
	min-width: 5.3125rem;
}
.widget-stat .media .media-body p {
	text-transform: uppercase;
	font-weight: 500;
	font-size: 0.875rem;
}
[data-theme-version='dark'] .widget-stat .media .media-body p {
	color: #fff;
}
.widget-stat .media .media-body h3,
.widget-stat .media .media-body .h3 {
	font-size: 2.5rem;
	font-weight: 600;
	margin: 0;
	line-height: 1.2;
}
.widget-stat .media .media-body h4,
.widget-stat .media .media-body .h4 {
	font-size: 1.5rem;
	display: inline-block;
	vertical-align: middle;
}
.widget-stat .media .media-body span {
	margin-left: 0.3125rem;
}

.widget-stat[class*='bg-'] .media > span {
	background-color: rgba(255, 255, 255, 0.25);
	color: #fff;
}

.widget-stat[class*='bg-'] .progress {
	background-color: rgba(255, 255, 255, 0.25) !important;
}

[direction='rtl'] .widget-stat .media .media-body span {
	margin-left: 0;
	margin-right: 0.625rem;
}

.dez-widget-1 .card {
	background: #ffe7db;
}
.dez-widget-1 .card .card-body p {
	color: #f87533;
}

.dez-widget-1 .icon {
	float: right;
	width: 3.125rem;
	height: 3.125rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 0.375rem;
	font-size: 1.75rem;
}

.bgl-primary {
	background: var(--rgba-primary-1);
	border-color: var(--rgba-primary-1);
}
[data-theme-version='dark'] .bgl-primary {
	background-color: var(--rgba-primary-1);
	border-color: var(--rgba-primary-1);
}

.bgl-secondary {
	background: #fff3f0;
	border-color: #fff3f0;
}
[data-theme-version='dark'] .bgl-secondary {
	background-color: rgba(251, 125, 91, 0.5);
	border-color: rgba(251, 125, 91, 0.5);
}

.bgl-success {
	background: #ddfaea;
	border-color: #ddfaea;
}
[data-theme-version='dark'] .bgl-success {
	background-color: rgba(30, 186, 98, 0.1);
	border-color: rgba(30, 186, 98, 0.1);
}

.bgl-warning {
	background: #fffaee;
	border-color: #fffaee;
}
[data-theme-version='dark'] .bgl-warning {
	background-color: rgba(252, 196, 62, 0.1);
	border-color: rgba(252, 196, 62, 0.1);
}

.bgl-danger {
	background: #ffeaea;
	border-color: #ffeaea;
}
[data-theme-version='dark'] .bgl-danger {
	background-color: rgba(253, 83, 83, 0.15);
	border-color: rgba(253, 83, 83, 0.15);
}

.bgl-info {
	background: #94fff9;
	border-color: #94fff9;
}
[data-theme-version='dark'] .bgl-info {
	background-color: rgba(0, 173, 163, 0.1);
	border-color: rgba(0, 173, 163, 0.1);
}

.bg-primary-light {
	background: var(--rgba-primary-5);
}
[data-theme-version='dark'] .bg-primary-light {
	background-color: var(--rgba-primary-1);
}

.bg-secondary-light {
	background: rgba(255, 243, 240, 0.5);
}
[data-theme-version='dark'] .bg-secondary-light {
	background-color: rgba(251, 125, 91, 0.05);
}

.bg-success-light {
	background: rgba(221, 250, 234, 0.5);
}
[data-theme-version='dark'] .bg-success-light {
	background-color: rgba(30, 186, 98, 0.05);
}

.bg-warning-light {
	background: rgba(255, 250, 238, 0.5);
}
[data-theme-version='dark'] .bg-warning-light {
	background-color: rgba(252, 196, 62, 0.05);
}

.bg-danger-light {
	background: rgba(255, 234, 234, 0.5);
}
[data-theme-version='dark'] .bg-danger-light {
	background-color: rgba(253, 83, 83, 0.05);
}

.bg-info-light {
	background: rgba(148, 255, 249, 0.5);
}
[data-theme-version='dark'] .bg-info-light {
	background-color: rgba(0, 173, 163, 0.05);
}

.bgl-dark {
	background: #bec3e3;
	border-color: #bec3e3;
}

.bgl-light {
	background: #ebebf9;
	border-color: #ebebf9;
}

.overlay-box {
	position: relative;
	z-index: 1;
}
.overlay-box:after {
	content: '';
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	position: absolute;
	opacity: 0.85;
	background: var(--primary);
	z-index: -1;
}

.rating-bar {
	font-size: 0.8125rem;
}

.tdl-holder {
	margin: 0 auto;
}
.tdl-holder ul {
	list-style: none;
	margin: 0;
	padding: 0;
}
.tdl-holder li {
	background-color: #fff;
	border-bottom: 0.0625rem solid #f2f2f2;
	list-style: none none;
	margin: 0;
	padding: 0;
}
.tdl-holder li span {
	margin-left: 2.1875rem;
	font-size: 1rem;
	vertical-align: middle;
	transition: all 0.2s linear;
}
[direction='rtl'] .tdl-holder li span {
	margin-left: auto;
	margin-right: 2.1875rem;
}
.tdl-holder label {
	cursor: pointer;
	display: block;
	line-height: 3.125rem;
	padding-left: 1.5rem;
	position: relative;
	margin: 0 !important;
}
[direction='rtl'] .tdl-holder label {
	padding-left: 0;
	padding-right: 1.5rem;
}
.tdl-holder label:hover {
	background-color: #eef1f6;
	color: #303972;
}
.tdl-holder label:hover a {
	color: #fd5353;
}
.tdl-holder label a {
	color: #fff;
	display: inline-block;
	line-height: normal;
	height: 100%;
	text-align: center;
	text-decoration: none;
	width: 3.125rem;
	transition: all 0.2s linear;
	padding: 1.125rem 0rem;
	font-size: 1.125rem;
	position: absolute;
	right: 0;
}
[direction='rtl'] .tdl-holder label a {
	right: auto;
	left: 0;
}
.tdl-holder input[type='checkbox'] {
	cursor: pointer;
	opacity: 0;
	position: absolute;
}
.tdl-holder input[type='checkbox'] + i {
	background-color: #fff;
	border: 0.0625rem solid #e7e7e7;
	display: block;
	height: 1.25rem;
	position: absolute;
	top: 0.9375rem;
	width: 1.25rem;
	z-index: 1;
	border-radius: 0rem;
	font-size: 0.6875rem;
	border-radius: 0.25rem;
}
.tdl-holder input[type='checkbox']:checked + i {
	background: var(--primary);
	border-color: transparent;
}
.tdl-holder input[type='checkbox']:checked + i::after {
	content: '\\f00c';
	font-family: 'fontAwesome';
	display: block;
	left: 0.125rem;
	position: absolute;
	top: -0.875rem;
	z-index: 2;
	color: #fff;
}
.tdl-holder input[type='checkbox']:checked ~ span {
	text-decoration: line-through;
	position: relative;
}
.tdl-holder input[type='text'] {
	background-color: #fff;
	height: 3.125rem;
	margin-top: 1.8125rem;
	border-radius: 0.1875rem;
}
.tdl-holder input[type='text']::placeholder {
	color: #303972;
}

.widget-message p {
	font-size: 0.875rem;
	line-height: 1.5;
}

.picker .picker__frame {
	min-width: 28.125rem;
	max-width: 28.125rem;
}
.picker .picker__frame .picker__box {
	padding: 1.25rem;
	border: 0;
	box-shadow: 0 0.3125rem 0.625rem rgba(0, 0, 0, 0.1);
}
.picker .picker__frame .picker__box .picker__header {
	margin-top: 0;
}
.picker .picker__frame .picker__box .picker__header .picker__year {
	color: var(--primary);
	font-style: inherit;
	font-size: 1.25rem;
}
.picker .picker__frame .picker__box .picker__header .picker__nav--prev,
.picker .picker__frame .picker__box .picker__header .picker__nav--next {
	width: 2.5rem;
	height: 2.5rem;
	padding: 0;
	line-height: 2.5rem;
	border-radius: 0.125rem;
}
.picker .picker__frame .picker__box .picker__header .picker__nav--prev:before,
.picker .picker__frame .picker__box .picker__header .picker__nav--next:before {
	content: none !important;
}
.picker .picker__frame .picker__box .picker__header .picker__nav--prev:after,
.picker .picker__frame .picker__box .picker__header .picker__nav--next:after {
	font-family: 'Font Awesome 5 Free';
	border: 0;
	margin: 0 auto;
	font-size: 1.375rem;
	font-weight: 900;
}
.picker .picker__frame .picker__box .picker__header .picker__nav--prev:hover,
.picker .picker__frame .picker__box .picker__header .picker__nav--next:hover {
	background-color: var(--primary);
	color: #fff;
}
.picker .picker__frame .picker__box .picker__header .picker__nav--prev {
	left: 0;
}
.picker .picker__frame .picker__box .picker__header .picker__nav--prev:after {
	content: '\\f0d9';
}
.picker .picker__frame .picker__box .picker__header .picker__nav--next {
	right: 0;
}
.picker .picker__frame .picker__box .picker__header .picker__nav--next:after {
	content: '\\f0da';
}
.picker .picker__frame .picker__box .picker__table .picker__weekday {
	padding: 0.625rem 0;
	font-size: 1rem;
}
.picker .picker__frame .picker__box .picker__table .picker__day {
	width: 2.5rem;
	height: 2.5rem;
	border-radius: 3.125rem;
	padding: 0 !important;
	font-size: 1rem;
	line-height: 2.5rem;
	margin: auto;
	border: 0 !important;
}
.picker .picker__frame .picker__box .picker__table .picker__day.picker__day--today:before {
	content: none !important;
}
.picker .picker__frame .picker__box .picker__table .picker__day.picker__day--highlighted {
	border: 0 !important;
	padding: 0;
	background-color: var(--primary);
	color: #fff !important;
}
.picker .picker__frame .picker__box .picker__table .picker__day:hover {
	background-color: var(--primary);
	color: #fff !important;
}
.picker .picker__frame .picker__box .picker__footer .picker__button--today {
	background-color: var(--primary);
	color: #fff !important;
}
.picker .picker__frame .picker__box .picker__footer .picker__button--today:before {
	content: none !important;
}
.picker .picker__frame .picker__box .picker__footer .picker__button--clear,
.picker .picker__frame .picker__box .picker__footer .picker__button--close,
.picker .picker__frame .picker__box .picker__footer .picker__button--today {
	border: 0;
	border-radius: 0.125rem;
	font-size: 1rem;
}
.picker .picker__frame .picker__box .picker__footer .picker__button--clear:hover,
.picker .picker__frame .picker__box .picker__footer .picker__button--close:hover,
.picker .picker__frame .picker__box .picker__footer .picker__button--today:hover {
	background-color: var(--primary);
	color: #fff !important;
}
@media only screen and (max-width: 35.9375rem) {
	.picker .picker__frame {
		min-width: 100% !important;
		max-width: 100% !important;
	}
	.picker .picker__frame .picker__box {
		padding: 0.9375rem;
		margin: 0 0.625rem;
	}
}

.card-list {
	overflow: unset;
	height: calc(100% - 50px);
}
.card-list .card-header {
	padding-top: 0;
	padding-bottom: 0;
}
.card-list .card-header .photo {
	overflow: hidden;
	border-radius: 0.3125rem;
	width: 100%;
}
@media only screen and (max-width: 74.9375rem) {
	.card-list {
		height: calc(100% - 40px);
	}
}
.card-list.list-left {
	margin-top: 0.9375rem;
	margin-left: 0.9375rem;
}
.card-list.list-left .card-header {
	padding-left: 0;
}
.card-list.list-left .card-header .photo {
	margin: -0.9375rem 0.9375rem 0 -0.9375rem;
}
.card-list.list-right {
	margin-top: 0.9375rem;
	margin-right: 0.9375rem;
	text-align: right;
}
.card-list.list-right .card-header {
	padding-right: 0;
}
.card-list.list-right .card-header .photo {
	margin: -0.9375rem -0.9375rem 0 0.9375rem;
}
.card-list.list-right .card-header .photo img {
	width: 100%;
}
.card-list.list-center {
	margin-top: 0.9375rem;
}
.card-list.list-center .card-header .photo {
	margin: -0.9375rem 0 0 0;
}
.card-list .photo img {
	width: 100%;
}

.card-profile .profile-photo {
	margin-top: -1.25rem;
}

.widget-media .timeline .timeline-panel {
	display: flex;
	align-items: center;
	border-bottom: 0.0625rem solid #eaeaea;
	padding-bottom: 0.9375rem;
	margin-bottom: 0.9375rem;
}
.widget-media .timeline .timeline-panel .media {
	width: 3.125rem;
	height: 3.125rem;
	background: #eee;
	border-radius: 0.75rem;
	overflow: hidden;
	font-size: 1.25rem;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 700;
	align-self: start;
}
.widget-media .timeline .timeline-panel .media-primary {
	background: var(--rgba-primary-1);
	color: var(--primary);
}
[data-theme-version='dark'] .widget-media .timeline .timeline-panel .media-primary {
	background-color: var(--rgba-primary-1);
}
.widget-media .timeline .timeline-panel .media-info {
	background: var(--rgba-primary-1);
	color: var(--primary);
}
[data-theme-version='dark'] .widget-media .timeline .timeline-panel .media-info {
	background-color: rgba(0, 173, 163, 0.1);
}
.widget-media .timeline .timeline-panel .media-warning {
	background: #fffaee;
	color: #fcc43e;
}
[data-theme-version='dark'] .widget-media .timeline .timeline-panel .media-warning {
	background-color: rgba(252, 196, 62, 0.1);
}
.widget-media .timeline .timeline-panel .media-danger {
	background: #ffeaea;
	color: #fd5353;
}
[data-theme-version='dark'] .widget-media .timeline .timeline-panel .media-danger {
	background-color: rgba(253, 83, 83, 0.15);
}
.widget-media .timeline .timeline-panel .media-success {
	background: #ddfaea;
	color: #1eba62;
}
[data-theme-version='dark'] .widget-media .timeline .timeline-panel .media-success {
	background-color: rgba(30, 186, 98, 0.1);
}
.widget-media .timeline .timeline-panel .media-body p {
	font-size: 0.875rem;
	line-height: 1.5;
}
.widget-media .timeline .timeline-panel .dropdown {
	align-self: self-end;
	margin-top: 0.3125rem;
}

.widget-media .timeline li:last-child .timeline-panel {
	margin-bottom: 0;
	border-bottom: 0;
	padding-bottom: 0;
}

.card[class*='bg-'] .timeline .timeline-panel {
	border-color: rgba(255, 255, 255, 0.2) !important;
}

.table th,
.table td {
	border-color: #f2f2f2;
	padding: 0.9375rem 1.325rem;
}
[data-theme-version='dark'] .table th,
[data-theme-version='dark'] .table td {
	border-color: rgba(255, 255, 255, 0.1) !important;
	color: #fff;
}

.table td {
	padding: 0.65rem 1.425rem;
}

.table.table-striped tbody tr:nth-of-type(odd),
.table.table-hover tr:hover {
	background-color: #f5f5f5;
}
[data-theme-version='dark'] .table.table-striped tbody tr:nth-of-type(odd),
[data-theme-version='dark'] .table.table-hover tr:hover {
	background-color: #202020;
}

.table.shadow-hover tbody tr:hover {
	background-color: #fff;
	box-shadow: 0 0rem 1.875rem var(--rgba-primary-2);
}
[data-theme-version='dark'] .table.shadow-hover tbody tr:hover {
	background-color: #202020;
}

.table.tr-rounded tr td:first-child,
.table.tr-rounded tr th:first-child {
	border-radius: 0.5rem 0 0 0.5rem;
}

.table.tr-rounded tr td:last-child,
.table.tr-rounded tr th:last-child {
	border-radius: 0 0.5rem 0.5rem 0;
}

.table.order-tbl tr th {
	font-size: 14px;
	font-weight: 600;
	border: 0;
}

.table.order-tbl tr td {
	font-weight: 500;
	border: 0;
}

.table.border-hover tr td {
	border-width: 0.0625rem 0 0.0625rem 0;
	border-bottom: 0.0625rem solid transparent;
	border-color: transparent;
}
.table.border-hover tr td:first-child {
	border-width: 0.0625rem 0 0.0625rem 0.0625rem;
}
.table.border-hover tr td:last-child {
	border-width: 0.0625rem 0.0625rem 0.0625rem 0;
}

.table.border-hover tr:hover td {
	border-color: #eeeeee;
}

.table.bg-secondary-hover td {
	color: #000;
	padding-left: 0;
}

.table.bg-secondary-hover th {
	color: #fb7d5b !important;
}
[data-theme-version='dark'] .table.bg-secondary-hover th {
	color: var(--secondary) !important;
}

.table.bg-secondary-hover tr:hover td,
.table.bg-secondary-hover tr:hover th {
	background: #fb7d5b;
	color: #fff;
	box-shadow: 10px 0 30px rgba(65, 63, 187, 0.3);
}
[data-theme-version='dark'] .table.bg-secondary-hover tr:hover td,
[data-theme-version='dark'] .table.bg-secondary-hover tr:hover th {
	background: var(--secondary);
}

.table.bg-primary-hover td {
	color: #000;
	padding-left: 0;
}

.table.bg-primary-hover th {
	color: var(--primary);
}

.table.bg-primary-hover tr:hover td,
.table.bg-primary-hover tr:hover th {
	background: var(--primary);
	color: #fff;
	box-shadow: 10px 0 30px rgba(54, 147, 255, 0.3);
}

.table.bg-eth-hover td {
	color: #000;
	padding-left: 0;
}

.table.bg-eth-hover th {
	color: #00ada3;
}

.table.bg-eth-hover tr:hover td,
.table.bg-eth-hover tr:hover th {
	background: #00ada3;
	color: #fff;
	box-shadow: 10px 0 30px rgba(0, 173, 163, 0.3);
}

.table.bg-ripple-hover td {
	color: #000;
	padding-left: 0;
}

.table.bg-ripple-hover th {
	color: #23292f;
}

.table.bg-ripple-hover tr:hover td,
.table.bg-ripple-hover tr:hover th {
	background: #23292f;
	color: #fff;
	box-shadow: 10px 0 30px rgba(35, 41, 47, 0.3);
}

.table.bg-pink-hover td {
	color: #5b5e81;
	padding-left: 0;
}

.table.bg-pink-hover th {
	color: #eb62d0;
}

.table.bg-pink-hover tr:hover td,
.table.bg-pink-hover tr:hover th {
	background: #eb62d0;
	color: #fff;
	box-shadow: 10px 0 30px rgba(172, 76, 188, 0.3);
}

.table.bg-secondary-hover td {
	color: #5b5e81;
}

.table.bg-secondary-hover th {
	color: #6c6c6c;
}

.table.bg-secondary-hover tr:hover td,
.table.bg-secondary-hover tr:hover th {
	background: var(--secondary);
	color: #fff !important;
}

.table.bg-info-hover td {
	color: #000;
}

.table.bg-info-hover th {
	color: #6c6c6c;
}

.table.bg-info-hover tr:hover td,
.table.bg-info-hover tr:hover th {
	background: #00ada3;
	color: #fff !important;
}

.table.bg-warning-hover td {
	color: #000;
}

.table.bg-warning-hover th {
	color: #6c6c6c;
}

.table.bg-warning-hover tr:hover td,
.table.bg-warning-hover tr:hover th {
	background: #fcc43e;
	color: #fff !important;
}

.table.border-no td {
	border: 0;
}

.table.short-one tr td:first-child,
.table.short-one tr th:first-child {
	width: 3.75rem;
}

.table thead th {
	color: var(--primary);
	white-space: nowrap;
	font-size: 14px;
	text-transform: capitalize;
	font-weight: 500;
	padding: 11px 20.7px;
}
.table thead th small,
.table thead th .small {
	color: #fff;
}
[data-theme-version='dark'] .table thead th {
	border-color: rgba(255, 255, 255, 0.1) !important;
}

.table tbody tr td {
	vertical-align: middle;
	white-space: nowrap;
	border-color: #f2f2f2;
}
[data-theme-version='dark'] .table tbody tr td {
	/*   border-color: \$d-border; */
}

.table:not(.table-bordered) thead th {
	border-top: none;
}

.table .thead-primary th {
	background-color: var(--primary);
	color: #fff;
}

.table .thead-info th {
	background-color: #00ada3;
	color: #fff;
}

.table .thead-warning th {
	background-color: #fcc43e;
	color: #fff;
}

.table .thead-danger th {
	background-color: #fd5353;
	color: #fff;
}

.table .thead-success th {
	background-color: #1eba62;
	color: #fff;
}

.table.primary-table-bordered {
	border: 0.0625rem solid #f2f2f2;
}
[data-theme-version='dark'] .table.primary-table-bordered {
	border-color: rgba(255, 255, 255, 0.1);
}

.table.primary-table-bg-hover thead th {
	background-color: var(--primary);
	color: #fff;
	border-bottom: none;
	border-color: #fff !important;
}

.table.primary-table-bg-hover tbody tr {
	background-color: var(--primary);
	color: #fff;
	transition: all 0.1s ease;
}
.table.primary-table-bg-hover tbody tr td {
	border-color: #fff;
}
.table.primary-table-bg-hover tbody tr:hover {
	background-color: var(--rgba-primary-8);
}
.table.primary-table-bg-hover tbody tr:not(:last-child) td,
.table.primary-table-bg-hover tbody tr:not(:last-child) th {
	border-bottom: 0.0625rem solid var(--primary-dark);
	border-color: rgba(255, 255, 255, 0.5);
}

.table-responsive-tiny {
	min-width: 18.75rem;
}

.table-responsive-sm {
	min-width: 30rem !important;
}

.table-responsive-md {
	min-width: 36rem !important;
}

.table-responsive-lg {
	min-width: 60.9375rem !important;
}

.table-responsive-xl {
	min-width: 70.9375rem !important;
}

.table-primary,
.table-primary > th,
.table-primary > td {
	background-color: var(--rgba-primary-1);
	color: var(--primary);
}
[data-theme-version='dark'] .table-primary,
[data-theme-version='dark'] .table-primary > th,
[data-theme-version='dark'] .table-primary > td {
	background-color: var(--rgba-primary-1);
}

.table-success,
.table-success > th,
.table-success > td {
	background-color: #ddfaea;
	color: #1eba62;
}
[data-theme-version='dark'] .table-success,
[data-theme-version='dark'] .table-success > th,
[data-theme-version='dark'] .table-success > td {
	background-color: rgba(30, 186, 98, 0.1);
}

.table-info,
.table-info > th,
.table-info > td {
	background-color: #94fff9;
	color: #00ada3;
}
[data-theme-version='dark'] .table-info,
[data-theme-version='dark'] .table-info > th,
[data-theme-version='dark'] .table-info > td {
	background-color: rgba(0, 173, 163, 0.1);
}

.table-warning,
.table-warning > th,
.table-warning > td {
	background-color: #fffaee;
	color: #fcc43e;
}
[data-theme-version='dark'] .table-warning,
[data-theme-version='dark'] .table-warning > th,
[data-theme-version='dark'] .table-warning > td {
	background-color: rgba(252, 196, 62, 0.1);
}

.table-danger,
.table-danger > th,
.table-danger > td {
	background-color: #ffeaea;
	color: #fd5353;
}
[data-theme-version='dark'] .table-danger,
[data-theme-version='dark'] .table-danger > th,
[data-theme-version='dark'] .table-danger > td {
	background-color: rgba(253, 83, 83, 0.15);
}

.table-active,
.table-active > th,
.table-active > td {
	background-color: #f5f5f5;
}
[data-theme-version='dark'] .table-active,
[data-theme-version='dark'] .table-active > th,
[data-theme-version='dark'] .table-active > td {
	background-color: #202020;
}

.card-table th:first-child,
.card-table td:first-child {
	padding-left: 1.875rem;
}
@media only screen and (max-width: 35.9375rem) {
	.card-table th:first-child,
	.card-table td:first-child {
		padding-left: 0.9375rem;
	}
}

.card-table th:last-child,
.card-table td:last-child {
	padding-right: 0;
	text-align: center;
}
@media only screen and (max-width: 35.9375rem) {
	.card-table th:last-child,
	.card-table td:last-child {
		padding-right: 0.9375rem;
	}
}

.table > :not(:first-child) {
	border-top: 1px solid currentColor;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
	color: #303972;
}

.table tbody tr:last-child td,
.table tbody tr:last-child th {
	border-bottom: transparent;
}

.bootgrid-header {
	padding: 0 !important;
	margin: 0;
}
@media only screen and (max-width: 35.9375rem) {
	.bootgrid-header .actionBar {
		padding: 0;
	}
	.bootgrid-header .search {
		margin: 0 0 0.625rem 0;
	}
}

table#example {
	padding: 0rem 0 2rem 0;
}

table.dataTable {
	font-size: 14px;
	overflow: hidden;
}

#example2_wrapper .dataTables_scrollBody {
	max-height: 33.25rem !important;
}

#employees,
#custommers {
	padding: 0.5rem 0 1rem 0;
}

.dataTables_wrapper .dataTables_paginate {
	padding-top: 0.75em;
	padding-bottom: 0.75em;
}

table.dataTable thead th,
table.dataTable thead td {
	border-bottom: 2px solid #eeeeee;
	border-top: 0;
}

table.dataTable tfoot th,
table.dataTable tfoot td {
	border-top: 0;
}

table.dataTable tbody tr,
table.dataTable tbody td {
	background: transparent !important;
}

table.dataTable thead .sorting {
	background-image: none !important;
}

table.dataTable thead sorting sorting_desc {
	background-image: none;
}

.sorting {
	background-image: none;
}

.table.dataTable thead .sorting_desc {
	background-image: none;
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc:after {
	content: '';
	font-family: 'Font Awesome 6 Free';
	font-weight: 900;
	background-image: none;
	margin-left: 10px;
	font-size: calc(100% - 4px);
	opacity: 0.5;
}

table.dataTable thead .sorting:after {
	content: '\\f0dc';
}

table.dataTable thead .sorting_asc:after {
	content: '\\f0de';
	opacity: 1;
}

table.dataTable thead .sorting_desc:after {
	content: '\\f0dd';
	opacity: 1;
}

table.dataTable thead th {
	color: var(--primary);
	white-space: nowrap;
	font-size: 14px;
	text-transform: capitalize;
	font-weight: 500;
	padding: 11px 20.7px;
}
[data-theme-version='dark'] table.dataTable thead th {
	color: #fff;
}
@media only screen and (max-width: 87.5rem) {
	table.dataTable thead th {
		font-size: 13px;
	}
}
@media only screen and (max-width: 35.9375rem) {
	table.dataTable thead th {
		padding: 10px 8px;
	}
}

td.doller {
	color: var(--primary);
}

table.dataTable tbody td {
	border-bottom: 0;
	white-space: nowrap;
	font-size: 14px;
	font-weight: 400;
	padding: 0.65rem 1.425rem;
	color: #a098ae;
}

table.dataTable tr.selected {
	color: var(--primary);
}

table.dataTable tfoot th {
	color: #303972;
	font-weight: 600;
}
[data-theme-version='dark'] table.dataTable tfoot th {
	color: #fff;
}

.dataTables_wrapper .dataTables_paginate {
	align-items: center;
	display: inline-flex;
	flex-flow: wrap;
}
.dataTables_wrapper .dataTables_paginate .paginate_button.previous,
.dataTables_wrapper .dataTables_paginate .paginate_button.next {
	margin-left: 0px;
	font-size: 18px;
	border: 0 !important;
	height: 45px;
	width: 155px;
	padding: 0;
	border-radius: 0.5rem;
	line-height: 45px;
	display: inline-block;
	background: transparent;
}
.dataTables_wrapper .dataTables_paginate .paginate_button.previous:last-child,
.dataTables_wrapper .dataTables_paginate .paginate_button.next:last-child {
	border-top-left-radius: 0;
	border-bottom-left-radius: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 5px 0 5px;
}
.dataTables_wrapper .dataTables_paginate .paginate_button.previous:first-child,
.dataTables_wrapper .dataTables_paginate .paginate_button.next:first-child {
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
}
.dataTables_wrapper .dataTables_paginate .paginate_button.previous i,
.dataTables_wrapper .dataTables_paginate .paginate_button.next i {
	font-size: 1rem;
	padding: 0 10px;
}
.dataTables_wrapper .dataTables_paginate .paginate_button.previous span,
.dataTables_wrapper .dataTables_paginate .paginate_button.next span {
	border: none;
}
.dataTables_wrapper .dataTables_paginate .paginate_button.previous.current:hover,
.dataTables_wrapper .dataTables_paginate .paginate_button.previous.previous:hover,
.dataTables_wrapper .dataTables_paginate .paginate_button.previous.next:hover,
.dataTables_wrapper .dataTables_paginate .paginate_button.next.current:hover,
.dataTables_wrapper .dataTables_paginate .paginate_button.next.previous:hover,
.dataTables_wrapper .dataTables_paginate .paginate_button.next.next:hover {
	color: #fff !important;
	background: var(--primary) !important;
	border-radius: 6px;
}
.dataTables_wrapper .dataTables_paginate .paginate_button.previous.disabled,
.dataTables_wrapper .dataTables_paginate .paginate_button.next.disabled {
	color: #303972 !important;
	display: flex;
	align-items: center;
	justify-content: center;
}
@media only screen and (max-width: 61.9375rem) {
	.dataTables_wrapper .dataTables_paginate .paginate_button.previous,
	.dataTables_wrapper .dataTables_paginate .paginate_button.next {
		height: 45px;
		width: 135px;
		font-size: 16px;
	}
	.dataTables_wrapper .dataTables_paginate .paginate_button.previous i,
	.dataTables_wrapper .dataTables_paginate .paginate_button.next i {
		font-size: 16px;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.dataTables_wrapper .dataTables_paginate .paginate_button.previous,
	.dataTables_wrapper .dataTables_paginate .paginate_button.next {
		width: 45px;
		font-size: 14px;
		height: 40px;
		line-height: 40px;
	}
	.dataTables_wrapper .dataTables_paginate .paginate_button.previous i,
	.dataTables_wrapper .dataTables_paginate .paginate_button.next i {
		font-size: 14px;
	}
	.dataTables_wrapper .dataTables_paginate .paginate_button.previous span,
	.dataTables_wrapper .dataTables_paginate .paginate_button.next span {
		display: none;
	}
}
.dataTables_wrapper .dataTables_paginate span .paginate_button {
	height: 45px;
	width: 45px;
	padding: 0;
	margin-left: 0px;
	line-height: 45px;
	text-align: center;
	font-size: 18px;
	border-radius: 0rem;
	color: #a098ae !important;
	border: 0 !important;
}
@media only screen and (max-width: 35.9375rem) {
	.dataTables_wrapper .dataTables_paginate span .paginate_button {
		height: 40px;
		width: 40px;
		line-height: 40px;
	}
}
.dataTables_wrapper .dataTables_paginate span .paginate_button.current,
.dataTables_wrapper .dataTables_paginate span .paginate_button:hover {
	color: #fff !important;
	background: var(--primary) !important;
	box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
}
.dataTables_wrapper .dataTables_paginate span .paginate_button.current:hover,
.dataTables_wrapper .dataTables_paginate span .paginate_button:hover:hover {
	color: var(--primary) !important;
	background: var(--rgba-primary-1) !important;
}

.dataTables_wrapper input[type='search'],
.dataTables_wrapper input[type='text'],
.dataTables_wrapper select {
	border: 1px solid #dddddd !important;
	padding: 0.3rem 0.5rem;
	color: #303972;
	border-radius: 0.625rem !important;
	margin-left: 14px;
}
[data-theme-version='dark'] .dataTables_wrapper input[type='search'],
[data-theme-version='dark'] .dataTables_wrapper input[type='text'],
[data-theme-version='dark'] .dataTables_wrapper select {
	background: #202020;
	border-color: rgba(255, 255, 255, 0.1) !important;
	color: #fff;
}

.dataTables_wrapper .dataTables_length {
	margin-bottom: 15px;
}
.dataTables_wrapper .dataTables_length .bootstrap-select {
	width: 80px !important;
	margin: 0 5px;
}

table.dataTable.no-footer {
	border-bottom: 0;
}

.rounded-lg {
	min-width: 30px;
}

.dataTables_scroll {
	padding: 1rem 0;
}
.dataTables_scrollFoot {
	padding-top: 1rem;
}

.dataTablesCard {
	background-color: #fff;
	border-radius: 0.375rem;
	overflow: hidden;
}
.dataTablesCard.border-no td {
	border-top: 0 !important;
}

@media (max-width: 767.98px) {
	.dataTables_wrapper .dataTables_length,
	.dataTables_wrapper .dataTables_filter {
		text-align: left;
	}
}

.dataTables_wrapper .dataTables_paginate .paginate_button.disabled,
.dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover,
.dataTables_wrapper .dataTables_paginate .paginate_button.disabled:active {
	color: #a098ae !important;
}

.dataTables_wrapper .dataTables_length,
.dataTables_wrapper .dataTables_filter,
.dataTables_wrapper .dataTables_processing,
.dataTables_wrapper .dataTables_paginate {
	color: #a098ae;
	border-radius: 1rem;
	margin-bottom: 20px;
}
@media only screen and (max-width: 35.9375rem) {
	.dataTables_wrapper .dataTables_length,
	.dataTables_wrapper .dataTables_filter,
	.dataTables_wrapper .dataTables_processing,
	.dataTables_wrapper .dataTables_paginate {
		margin-bottom: 8px;
	}
}

.dataTables_wrapper .dataTables_length,
.dataTables_wrapper .dataTables_filter {
	margin-bottom: 10px;
	padding: 15px 19px 0px 19px;
}

.paging_simple_numbers.dataTables_paginate {
	border: 0.025rem solid var(--primary);
	background: transparent;
	border-radius: 0.5rem;
}
.paging_simple_numbers.dataTables_paginate span {
	border-radius: 0.375rem;
}

.dataTables_wrapper .dataTables_paginate .paginate_button {
	color: #a098ae !important;
}

.dataTables_info {
	font-size: 13px;
	font-weight: 500;
	text-align: start !important;
	display: inline-block;
}

table.dataTable.row-border tbody th,
table.dataTable.row-border tbody td,
table.dataTable.display tbody th,
table.dataTable.display tbody td {
	border-color: #f2f2f2;
}
[data-theme-version='dark'] table.dataTable.row-border tbody th,
[data-theme-version='dark'] table.dataTable.row-border tbody td,
[data-theme-version='dark'] table.dataTable.display tbody th,
[data-theme-version='dark'] table.dataTable.display tbody td {
	border-color: rgba(255, 255, 255, 0.1);
}

.dataTables_wrapper .dataTables_length .bootstrap-select .dropdown-toggle {
	font-size: 0.813rem !important;
	padding: 0.625rem 1rem;
}

.table-responsive thead {
	background-color: var(--rgba-primary-1);
}

.dataTables_wrapper .dataTables_paginate .paginate_button.previous,
.dataTables_wrapper .dataTables_paginate .paginate_button.next {
	height: 30px;
	width: 30px;
	padding: 0;
	font-size: 13px;
	border-radius: 6px;
	line-height: 30px;
	margin: 0 5px;
	text-align: center;
	margin-left: 0;
}
@media only screen and (max-width: 35.9375rem) {
	.dataTables_wrapper .dataTables_paginate .paginate_button.previous,
	.dataTables_wrapper .dataTables_paginate .paginate_button.next {
		height: 36px;
		width: 36px;
		line-height: 36px;
	}
}

.dataTables_wrapper .dataTables_paginate span .paginate_button {
	height: 30px;
	width: 30px;
	padding: 0;
	line-height: 30px;
	display: inline-block;
	margin: 0 5px;
	border-radius: 6px;
}
@media only screen and (max-width: 35.9375rem) {
	.dataTables_wrapper .dataTables_paginate span .paginate_button {
		height: 36px;
		width: 36px;
		line-height: 36px;
		font-size: 14px;
	}
}

.paging_simple_numbers.dataTables_paginate {
	border: none;
}

.dataTables_scrollBody thead {
	display: none;
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc:after {
	content: '';
	font-family: 'Font Awesome 6 Free';
	font-weight: 900;
	background-image: none;
	margin-left: 5px;
	font-size: calc(100% - 2px);
	opacity: 0.5;
}

table.dataTable thead .sorting:after {
	content: '\\f0dc';
}

table.dataTable thead .sorting_asc:after {
	content: '\\f0de';
	opacity: 1;
}

table.dataTable thead .sorting_desc:after {
	content: '\\f0dd';
	opacity: 1;
}

.dlab-scroll {
	overflow-y: scroll;
}

/* .dlab-scroll::-webkit-scrollbar {
	width: 5px;
	opacity:0;
}
.dlab-scroll::-webkit-scrollbar-thumb{
	background:  rgba(111, 133, 147, 0.0); 
}
.dlab-scroll:hover::-webkit-scrollbar-thumb{
	background:  rgba(111, 133, 147, 0.1); 
} */
body > * {
	scrollbar-width: thin;
	scrollbar-color: rgba(111, 133, 147, 0.1) #fff0;
}

::-webkit-scrollbar {
	width: 5px;
	opacity: 0;
}

/* ::-webkit-scrollbar-thumb{
	background:  rgba(111, 133, 147, 0.0); 
} */
::-webkit-scrollbar-thumb {
	background: rgba(111, 133, 147, 0.1);
}

#example2_wrapper #example2_filter {
	float: left;
}

.dataTables_info {
	padding: 1.25rem 0.75rem;
}

.fooicon {
	font-size: 1.25rem;
	color: #303972;
}

.jsgrid-table .jsgrid-header-row > .jsgrid-header-cell {
	color: #303972;
}

.jsgrid-table > tbody > tr > td {
	padding: 1.2em;
}

.jsgrid-table .jsgrid-insert-row input,
.jsgrid-table .jsgrid-insert-row select,
.jsgrid-table .jsgrid-edit-row input,
.jsgrid-table .jsgrid-edit-row select {
	border: 0.0625rem solid #dddfe1;
}

.jsgrid .jsgrid-button {
	border: 0 !important;
	margin-left: 0.625rem;
}

.file-drive {
	border-bottom: 1px solid #d5dfe7;
	border-top: none;
	border-radius: 0;
	margin-bottom: 0;
}
@media only screen and (max-width: 47.9375rem) {
	.file-drive {
		border-top: 1px solid #dddddd;
	}
}

.file_area .table-pagenation {
	margin: 0;
	background-color: #fff;
	padding: 0.813rem 5px;
	flex-wrap: wrap;
}
.file_area .table-pagenation p {
	margin-bottom: 0;
}
.file_area .table-pagenation .pagination {
	margin-bottom: 0;
}
@media only screen and (max-width: 35.9375rem) {
	.file_area .table-pagenation {
		display: none;
	}
}

.drive {
	display: flex;
	padding: 0.625rem;
	justify-content: flex-start;
	align-items: center;
	border: 1px solid #fff;
	border-radius: 0.375rem;
	transition: all 0.5s;
	cursor: pointer;
}
.drive .dz-folder {
	margin-right: 0.625rem;
}
.drive .dz-folder svg path {
	fill: var(--primary);
}
@media only screen and (max-width: 100rem) {
	.drive .dz-folder svg {
		width: 65px;
		height: 60px;
	}
}
@media only screen and (max-width: 87.5rem) {
	.drive .dz-folder svg {
		width: 50px;
		height: 50px;
	}
}
@media only screen and (max-width: 61.9375rem) {
	.drive .dz-folder svg {
		width: 70px;
		height: 50px;
	}
}
.drive .dz-media {
	width: 11.188rem;
}
.drive .drive-content {
	flex: 0 0 60%;
}
.drive .drive-content .title {
	font-size: 1rem;
}
.drive .drive-content span {
	font-size: 0.75rem;
}
.drive .progress {
	margin-bottom: 0.3rem;
	background-color: var(--rgba-primary-1);
	border: 1px solid var(--primary);
	border-radius: 0.188rem;
	width: 100%;
	height: 0.938rem;
}
@media only screen and (max-width: 110rem) {
	.drive .progress {
		width: 100%;
	}
}
.drive .progress .progress-bar {
	border-radius: 0;
}
.drive:hover {
	background-color: var(--rgba-primary-1);
	border: 1px solid var(--primary);
}

.file-header {
	border-bottom: 1px solid #d5dfe7;
}
.file-header .page-titles {
	margin-bottom: 0;
	padding: 0;
	flex-wrap: wrap;
}
.file-header .page-titles .input-group.search-area {
	width: 16rem;
}
@media only screen and (max-width: 61.9375rem) {
	.file-header .page-titles .input-group.search-area {
		width: 12rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.file-header .page-titles .input-group.search-area {
		width: 100%;
	}
	.file-header .page-titles .input-group.search-area svg {
		width: 14px;
		height: 14px;
	}
}
.file-header .file-path {
	display: flex;
	align-items: center;
	margin-right: 0.625rem;
}
.file-header .file-path h4 a,
.file-header .file-path .h4 a {
	font-size: 0.875rem;
	margin-right: 0.5rem;
}
.file-header .file-path svg path {
	fill: var(--primary);
}

.file-list {
	display: flex;
	align-items: center;
	padding: 0.938rem;
}
.file-list .dz-media {
	margin-right: 0.8rem;
	width: 2.813rem;
	height: 2.5rem;
}
.file-list .dz-media .dz-img {
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 0.313rem;
	box-shadow: 0px 4px 10px rgba(0, 25, 39, 0.14);
}
.file-list .dz-info .title {
	font-size: 0.938rem;
	margin-bottom: 0;
}

.folder-layout-tab .feature-btn:first-child {
	background: var(--primary);
	color: #fff;
}
.folder-layout-tab .feature-btn:first-child svg path {
	fill: #fff;
}

.folder-layout-tab.grid .feature-btn:first-child {
	background: var(--rgba-primary-1);
	color: #fff;
}
.folder-layout-tab.grid .feature-btn:first-child svg path {
	fill: var(--primary);
}

.folder-layout-tab.grid .feature-btn:last-child {
	background: var(--primary);
	color: #fff;
}
.folder-layout-tab.grid .feature-btn:last-child svg path {
	fill: #fff;
}

.folder-structure {
	height: calc(100vh - 22.213rem);
	overflow-y: scroll;
}
@media only screen and (max-width: 87.5rem) {
	.folder-structure {
		height: calc(100vh - 25.75rem);
	}
}
@media only screen and (max-width: 74.9375rem) {
	.folder-structure {
		height: calc(100vh - 7.813rem);
		overflow-y: scroll;
	}
}
@media only screen and (max-width: 61.9375rem) {
	.folder-structure {
		height: calc(100vh - 3.313rem);
	}
}
.folder-structure li {
	border-bottom: 1px solid #d5dfe7;
}
.folder-structure.grid {
	padding: 1.875rem;
	display: flex;
	flex-wrap: wrap;
	margin-left: -12px;
	margin-right: -12px;
}
@media only screen and (max-width: 74.9375rem) {
	.folder-structure.grid {
		margin-left: 0;
		margin-right: 0;
	}
}
.folder-structure.grid li {
	border: 0;
	max-width: 20%;
	padding-left: 0.75rem;
	padding-right: 0.75rem;
	margin-bottom: 24px;
	box-sizing: border-box;
}
@media only screen and (max-width: 100rem) {
	.folder-structure.grid li {
		max-width: 25%;
	}
}
@media only screen and (max-width: 87.5rem) {
	.folder-structure.grid li {
		max-width: 33.33%;
	}
}
@media only screen and (max-width: 61.9375rem) {
	.folder-structure.grid li {
		max-width: 50%;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.folder-structure.grid li {
		max-width: 33.33%;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.folder-structure.grid li {
		max-width: 50%;
	}
}
.folder-structure.grid li .file-list {
	display: block;
	align-items: center;
	padding: 1.25rem;
	text-align: center;
	min-width: 15rem;
	border: 1px solid transparent;
	border-radius: 0.375rem;
}
@media only screen and (max-width: 100rem) {
	.folder-structure.grid li .file-list {
		min-width: 13.75rem;
	}
}
@media only screen and (max-width: 87.5rem) {
	.folder-structure.grid li .file-list {
		min-width: 15rem;
	}
}
@media only screen and (max-width: 74.9375rem) {
	.folder-structure.grid li .file-list {
		min-width: 12.5rem;
	}
}
@media only screen and (max-width: 64rem) {
	.folder-structure.grid li .file-list {
		min-width: 11.125rem;
	}
}
@media only screen and (max-width: 61.9375rem) {
	.folder-structure.grid li .file-list {
		min-width: 100%;
		padding: 1rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.folder-structure.grid li .file-list {
		padding: 0.625rem;
	}
}
.folder-structure.grid li .file-list .dz-media {
	height: 110px;
	width: 140px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 10px;
}
.folder-structure.grid li .file-list .dz-media .dz-img {
	max-width: 100%;
	max-height: 100%;
	min-width: 100%;
	border-radius: 10px;
	box-shadow: 0px 10px 10px 0 rgba(0, 0, 0, 0.1);
}
@media only screen and (max-width: 74.9375rem) {
	.folder-structure.grid li .file-list .dz-media {
		height: 90px;
		width: 120px;
	}
}
@media only screen and (max-width: 61.9375rem) {
	.folder-structure.grid li .file-list .dz-media {
		height: 90px;
		width: 90px;
	}
}
.folder-structure.grid li .file-list svg {
	width: 80px;
	height: 80px;
}
@media only screen and (max-width: 61.9375rem) {
	.folder-structure.grid li .file-list svg {
		width: 60px;
		height: 60px;
	}
}
.folder-structure.grid li .file-list:hover {
	border: 1px solid var(--rgba-primary-5);
	background: var(--rgba-primary-1);
}
@media only screen and (max-width: 35.9375rem) {
	.folder-structure.grid {
		padding: 1rem;
	}
}

.chat-left-area .chat-sidebar {
	height: calc(100vh - 82px);
	border-right: 1px solid #d5dfe7;
	border-top: none;
}
@media only screen and (max-width: 74.9375rem) {
	.chat-left-area .chat-sidebar {
		height: calc(100vh - 5.9rem);
	}
}
@media only screen and (max-width: 47.9375rem) {
	.chat-left-area .chat-sidebar {
		box-shadow: 0 0 30px 5px rgba(0, 0, 0, 0.05);
	}
}

.message-body {
	min-height: auto !important;
}

.message-box {
	border-bottom: 1px solid #eeeeee;
	padding-top: 1rem;
	padding-bottom: 1rem;
}
.message-box .input-group.search-area {
	flex-direction: row-reverse;
	margin-right: 0.625rem;
	width: 100%;
}
.message-box .input-group.search-area .input-group-text {
	border: none;
	border-right: none;
	height: 3rem;
	padding: 0;
	background-color: transparent;
}
.message-box .input-group.search-area input.form-control {
	border: none;
	border-left: none;
	padding-left: 0;
	height: 3rem;
}
.message-box img {
	height: 5rem;
	width: 5rem;
	border-radius: 0.375rem;
}
.message-box h4,
.message-box .h4 {
	font-weight: 700;
}
.message-box span {
	font-size: 1.125rem;
}
.message-box .chat-hamburger {
	display: flex;
	align-items: center;
}
.message-box .chat-hamburger .videos-player {
	margin-right: 30px;
}
.message-box.style-1 {
	padding: 1rem;
	height: 5rem;
}
@media only screen and (max-width: 35.9375rem) {
	.message-box.style-1 {
		height: auto;
	}
}
.message-box.style-1 h4,
.message-box.style-1 .h4 {
	margin-bottom: 0.25rem;
}
@media only screen and (max-width: 35.9375rem) {
	.message-box.style-1 h4,
	.message-box.style-1 .h4 {
		margin-bottom: 0;
		font-size: 0.938rem;
	}
}
.message-box.style-1 span {
	font-size: 14px;
}
.message-box.style-1 img {
	height: 3rem;
	width: 3rem;
}
@media only screen and (max-width: 35.9375rem) {
	.message-box.style-1 img {
		height: 3rem;
		width: 3rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.message-box img {
		height: 3rem;
		width: 3rem;
	}
	.message-box h3,
	.message-box .h3 {
		font-size: 1rem;
	}
	.message-box span {
		font-size: 0.85rem;
	}
}
.message-box .add {
	width: 3rem;
	height: 3rem;
	min-width: 3rem;
	border-radius: 0.375rem;
	padding: 0;
	display: flex;
	justify-content: center;
	align-items: center;
}

.chat-people {
	padding: 1.25rem 0;
}

.chat-tabs > h4,
.chat-tabs > .h4 {
	font-size: 1.125rem;
	padding-top: 1.125rem;
	margin: 0;
}

.chat-tabs ul {
	padding: 1rem 0;
}

.chat-tabs .chat-bx.chats {
	position: relative;
}
.chat-tabs .chat-bx.chats .chat-img {
	position: relative;
}
.chat-tabs .chat-bx.chats .chat-img::before {
	content: '';
	display: block;
	background-color: #1eba62;
	border: 2px solid #fff;
	position: absolute;
	bottom: -2px;
	right: -2px;
	width: 1rem;
	height: 1rem;
	border-radius: 50%;
}

.chat-tabs .chat-bx {
	padding: 0.625rem 0;
	position: relative;
	z-index: 1;
	display: flex;
	cursor: pointer;
	align-items: center;
	margin-bottom: 0.5rem;
}
.chat-tabs .chat-bx .right-info {
	width: 4.375rem;
	text-align: right;
}
.chat-tabs .chat-bx .right-info p {
	font-size: 0.8rem;
	margin-top: 0;
	margin-bottom: 0.5rem;
}
@media only screen and (max-width: 87.5rem) {
	.chat-tabs .chat-bx .right-info {
		width: 4rem;
	}
}
.chat-tabs .chat-bx .mid-info {
	width: calc(100% - 9rem);
}
.chat-tabs .chat-bx .mid-info .name {
	font-size: 0.938rem;
	margin-bottom: 0.25rem;
}
.chat-tabs .chat-bx .mid-info span {
	white-space: nowrap;
	text-overflow: ellipsis;
	display: block;
	overflow: hidden;
}
@media only screen and (max-width: 87.5rem) {
	.chat-tabs .chat-bx .mid-info {
		width: calc(100% - 8rem);
	}
}
.chat-tabs .chat-bx .chat-img {
	position: relative;
	margin-right: 1rem;
}
.chat-tabs .chat-bx .chat-img img {
	height: 3rem;
	width: 3rem;
	border-radius: 100%;
	margin-right: 0rem;
	object-fit: cover;
}
@media only screen and (max-width: 87.5rem) {
	.chat-tabs .chat-bx .chat-img img {
		height: 3rem;
		width: 3rem;
	}
}
.chat-tabs .chat-bx .chat-img .active {
	height: 1rem;
	width: 1rem;
	border: 0.125rem solid #fff;
	border-radius: 0.25rem;
	background: #fb7d5b;
	position: absolute;
	bottom: -0.0625rem;
	right: 1rem;
}
.chat-tabs .chat-bx .badge {
	border-radius: 0.375rem;
}
.chat-tabs .chat-bx:last-child {
	border-bottom: 0;
}
@media only screen and (max-width: 87.5rem) {
	.chat-tabs .chat-bx {
		padding: 0.75rem 0;
	}
}
.chat-tabs .chat-bx:after {
	content: none;
	position: absolute;
	top: 0;
	left: 0;
	height: calc(100% + 4px);
	width: calc(100% + 30px);
	z-index: -1;
	background-color: #f0f0f0;
	border-radius: 0.375rem;
	margin: -2px -15px;
}
.chat-tabs .chat-bx:hover::before,
.chat-tabs .chat-bx.active::before {
	content: '';
	display: none;
}
.chat-tabs .chat-bx:hover:after,
.chat-tabs .chat-bx.active:after {
	content: '';
}
.chat-tabs .chat-bx:hover .mid-info h4,
.chat-tabs .chat-bx:hover .mid-info .h4,
.chat-tabs .chat-bx.active .mid-info h4,
.chat-tabs .chat-bx.active .mid-info .h4 {
	color: var(--primary);
}

.chat-box-area {
	height: calc(100vh - 17.125rem);
	overflow-y: scroll;
}
.chat-box-area .media .message-received {
	width: 62%;
	text-align: left;
}
.chat-box-area .media .message-received p {
	background: #f5f5f5;
	text-align: left;
	border-radius: 0.375rem;
	border-top-left-radius: 0;
	padding: 0.625rem 1.25rem;
	display: table;
	color: var(--primary);
}
.chat-box-area .media .message-received span {
	color: var(--primary);
}
.chat-box-area .media .message-received .dz-media {
	width: 22.75rem;
	height: 15.375rem;
	padding: 0.625rem;
	background-color: #e6ebee;
}
@media only screen and (max-width: 35.9375rem) {
	.chat-box-area .media .message-received {
		width: 100%;
	}
}
.chat-box-area .message-sent {
	width: 62%;
	text-align: right;
	max-width: 83%;
}
@media only screen and (max-width: 61.9375rem) {
	.chat-box-area .message-sent {
		width: 84%;
	}
}
.chat-box-area .message-sent span {
	display: block;
}
.chat-box-area .message-sent p {
	background: var(--primary);
	text-align: left;
	border-radius: 0.375rem;
	border-top-right-radius: 0;
	padding: 0.625rem 1.25rem;
	color: #fff;
	display: inline-block;
}
.chat-box-area.style-1 {
	height: 21.5rem;
}
.chat-box-area.style-1 .message-received p {
	background: #eeee;
	font-size: 0.875rem;
}
.chat-box-area.style-1 .message-sent p {
	background: var(--primary);
	font-size: 0.875rem;
	color: #fff;
}
@media only screen and (max-width: 74.9375rem) {
	.chat-box-area {
		height: calc(100vh - 16.8rem);
	}
}
@media only screen and (max-width: 35.9375rem) {
	.chat-box-area {
		height: calc(100vh - 12.8rem);
	}
}

.type-massage {
	padding: 0.625rem;
	border-radius: 0.375rem;
	border: 1px solid #d5dfe7;
}
@media only screen and (max-width: 35.9375rem) {
	.type-massage {
		margin-bottom: 1rem;
	}
}
.type-massage .input-group textarea {
	border: 0;
	height: 3.4375rem !important;
	resize: none;
	padding: 1rem 0.9375rem;
	border-bottom: none;
	background: transparent;
	border-top-left-radius: 0.625rem !important;
	border-bottom-left-radius: 0.625rem !important;
	overflow: hidden;
	white-space: nowrap;
}
.type-massage .input-group textarea:hover,
.type-massage .input-group textarea:focus {
	background: transparent;
}
@media only screen and (max-width: 35.9375rem) {
	.type-massage .input-group textarea {
		height: 2.5rem !important;
		line-height: 1.5;
		padding: 0.4375rem 0.5rem;
	}
}
.type-massage .input-group {
	align-items: center;
}
.type-massage.style-1 {
	border: 0;
	margin: 0;
	padding: 0.375rem;
	background: rgba(219, 219, 219, 0.25);
}
.type-massage.style-1 textarea {
	border: 0;
	height: 2.5rem !important;
	resize: none;
	padding: 0.0625rem 0.9375rem;
	background: transparent;
}
.type-massage .input-group-append {
	display: flex;
	align-items: center;
}
.type-massage .input-group-append .btn {
	text-align: center;
	margin: 0 0.5rem;
}
@media only screen and (max-width: 35.9375rem) {
	.type-massage .input-group-append .btn {
		height: 2.5rem;
		padding: 0 0.625rem;
	}
	.type-massage .input-group-append .btn svg {
		width: 1.125rem;
		height: 1.125rem;
	}
}
.type-massage .share-btn {
	height: 2.5rem;
	width: 2.5rem;
	padding: 0;
	background: var(--rgba-primary-1);
	margin-right: 1.0625rem;
	border-radius: 0.375rem;
}
.type-massage .share-btn svg path {
	fill: var(--primary);
}

.chat-icon {
	border-bottom: 0.0625rem solid #f0f0f0;
	padding-bottom: 1.5625rem;
}
.chat-icon ul {
	display: flex;
	justify-content: space-around;
}
.chat-icon ul li a {
	height: 3rem;
	width: 3rem;
	background: #f0f0f0;
	line-height: 3rem;
	display: block;
	border-radius: 0.375rem;
	text-align: center;
}
.chat-icon ul li a:hover {
	background: var(--primary);
}
.chat-icon ul li a:hover svg path {
	fill: #fff;
}

.share-files {
	border-bottom: 0.0625rem solid #f0f0f0;
	padding-bottom: 1.125rem;
}
.share-files:last-child {
	border-bottom: 0;
}
.share-files ul li {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.5625rem 0;
	cursor: pointer;
}
.share-files ul li:first-child {
	padding-top: 0;
}
.share-files ul li h4,
.share-files ul li .h4 {
	white-space: nowrap;
}
.share-files ul li > div {
	flex: 1 1;
}

.file {
	height: 2.5rem;
	width: 2.5rem;
	min-width: 2.5rem;
	line-height: 2.4rem;
	text-align: center;
	background: #f0f0f0;
	display: block;
	border-radius: 0.375rem;
}
.file svg {
	height: 1.5rem;
	width: 1.5rem;
}

.share-widget {
	height: calc(100vh - 11.25rem);
	overflow: hidden;
}
@media only screen and (max-width: 87.5rem) {
	.share-widget {
		box-shadow: 0 0 30px 5px rgba(0, 0, 0, 0.05);
	}
}
@media only screen and (max-width: 74.9375rem) {
	.share-widget {
		height: calc(100vh - 9.25rem);
	}
}

.file-list li > div {
	width: calc(100% - 3.5rem);
}
.file-list li > div > div {
	width: calc(100% - 3rem);
}

.file-list li h4,
.file-list li .h4 {
	width: 3.5rem;
	text-align: right;
}

.file-list li:hover .file {
	background: var(--primary);
}
.file-list li:hover .file svg path {
	fill: #fff;
}

.file-list .fl-info {
	flex: 1 1;
}
.file-list .fl-info span {
	font-size: 0.8rem;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	display: block;
}

.contact-list li {
	width: 16%;
	padding: 0 0.35rem;
}
.contact-list li img {
	width: 100%;
	border-radius: 0.375rem;
	transition: all 0.5s;
}
@media only screen and (max-width: 87.5rem) {
	.contact-list li {
		padding: 0 0.15rem;
	}
}
.contact-list li:hover img {
	filter: blur(1px);
}

@media only screen and (max-width: 47.9375rem) {
	.chat-left-area {
		width: 22rem;
		position: absolute;
		left: -22rem;
		z-index: 2;
		transition: all 0.2s;
	}
	.chat-left-area.active {
		left: 0rem;
	}
}

.chat-right-area .chat-rightarea-btn {
	display: none;
}

@media only screen and (max-width: 87.5rem) {
	.chat-right-area {
		width: 23rem;
		position: absolute;
		right: -16.5rem;
		transition: all 0.2s;
	}
	.chat-right-area.active {
		right: 4.2rem;
	}
	.chat-right-area .chat-rightarea-btn {
		position: absolute;
		top: 7rem;
		left: -1.1rem;
		width: 2.2rem;
		height: 3rem;
		background: var(--primary);
		display: inline-flex;
		color: #fff;
		font-size: 1.2rem;
		align-items: center;
		justify-content: center;
		border-radius: 0.5rem 0 0 0.5rem;
		transition: all 0.2s;
	}
	.chat-right-area .chat-rightarea-btn.active i {
		transform: rotateY(180deg);
	}
}

@media only screen and (max-width: 47.9375rem) {
	.chat-right-area {
		right: -22rem;
	}
	.chat-right-area.active {
		right: -1.5rem;
	}
}

@media only screen and (max-width: 87.5rem) {
	.chat-mid-area {
		flex: 1 1;
		overflow: hidden;
	}
}

@media only screen and (max-width: 47.9375rem) {
	.chat-mid-area .chat-hamburger {
		display: flex;
		align-items: center;
		cursor: pointer;
		justify-content: center;
		line-height: 45px;
		text-align: center;
		color: #fff;
		border-radius: 50%;
		position: relative;
	}
	.chat-mid-area .chat-hamburger span {
		display: block;
		height: 2px;
		margin: 2px auto;
		width: 20px;
		border-radius: 3px;
		background-color: #000;
	}
}

.chart-content {
	padding: 1rem;
}
@media only screen and (max-width: 61.9375rem) {
	.chart-content {
		padding-bottom: 0;
	}
}
.chart-content .media .dz-media {
	width: 3rem;
	height: 3rem;
	border-radius: 0.375rem;
	overflow: hidden;
	margin-right: 0.625rem;
}
.chart-content .media .dz-media img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.chat-toggle {
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: pointer;
	justify-content: center;
	height: 2.5rem;
	width: 2.5rem;
	line-height: 2.2rem;
	text-align: center;
	color: #fff;
	border-radius: 0.375rem;
	position: relative;
	display: none;
	margin-right: 0.625rem;
	background-color: var(--rgba-primary-1);
}
@media only screen and (max-width: 47.9375rem) {
	.chat-toggle {
		display: flex;
	}
}
.chat-toggle svg {
	width: 25px;
	height: 25px;
}
.chat-toggle svg g path {
	fill: var(--primary);
}
.chat-toggle::before {
	content: '';
	display: block;
	position: absolute;
	top: 0;
	left: -50vw;
	width: 100vw;
	height: 100vh;
}
.chat-toggle span {
	display: block;
	height: 2px;
	margin: 2px auto;
	width: 20px;
	border-radius: 3px;
	background-color: #000;
}

.chat-toggle.active::before {
	z-index: 1;
}

@media only screen and (max-width: 61.9375rem) {
	.error-page {
		text-align: center;
	}
}

.error-page .error-text {
	font-size: 150px;
	line-height: 1;
	font-weight: 700;
	margin-bottom: 0;
}
@media only screen and (max-width: 61.9375rem) {
	.error-page .error-text {
		font-size: 130px;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.error-page .error-text {
		font-size: 80px;
	}
}

.error-page h4,
.error-page .h4 {
	font-size: 44px;
	margin-bottom: 0;
	line-height: 1.2;
}
@media only screen and (max-width: 61.9375rem) {
	.error-page h4,
	.error-page .h4 {
		font-size: 37px;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.error-page h4,
	.error-page .h4 {
		font-size: 27px;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.error-page h4,
	.error-page .h4 {
		font-size: 20px;
	}
}

.error-page p {
	font-size: 18px;
	color: #c2c2c2;
	margin-bottom: 30px;
}
@media only screen and (max-width: 47.9375rem) {
	.error-page p {
		font-size: 1rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.error-page p {
		font-size: 14px;
	}
}

.move-1 {
	animation: move1 5s infinite;
}

.flex-row-fluid {
	flex: 1 1 auto;
	-ms-flex: 1 0 0rem;
	min-width: 0;
}

.page-r-logo img {
	width: 200px;
}

.authincation {
	background: var(--rgba-primary-1);
	display: flex;
	min-height: 100vh;
}
.authincation .login-aside {
	background: #fff;
	padding-top: 5rem;
	max-width: 35rem;
	width: 100%;
	z-index: 1;
	position: relative;
}
.authincation .login-aside:after {
	content: '';
	clip-path: polygon(0% 100%, 100% 0%, 0% 0%);
	width: 8.75rem;
	height: 100%;
	position: absolute;
	right: -8.75rem;
	z-index: -1;
	top: 0;
	background: #fff;
	box-shadow: 0.125rem 0rem 1.875rem rgba(0, 0, 0, 0.15);
}
.authincation .login-aside .aside-image {
	min-height: 28.125rem;
	margin: auto 0;
	min-width: 0;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
}
@media only screen and (max-width: 87.5rem) {
	.authincation .login-aside {
		max-width: 22.5rem;
	}
}
@media only screen and (max-width: 61.9375rem) {
	.authincation .login-aside {
		max-width: 100%;
		padding-top: 0;
	}
	.authincation .login-aside:after {
		content: none;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.authincation .login-aside .aside-image {
		min-height: 18.75rem;
	}
}

.authincation-content {
	background: #fff;
	box-shadow: 0 0 2.1875rem 0 rgba(154, 161, 171, 0.15);
	border-radius: 0.3125rem;
}
[data-theme-version='dark'] .authincation-content {
	background: #272738;
	box-shadow: none;
}
.authincation-content.style-1 {
	background: rgba(255, 255, 255, 0.5);
	backdrop-filter: blur(1.25rem);
}
.authincation-content.style-1 .form-control {
	background: rgba(255, 255, 255, 0.6);
	border-radius: 0.3125rem;
}
.authincation-content.style-1 .user-icon {
	height: 6.25rem;
	background: var(--primary);
	width: 6.25rem;
	text-align: center;
	border-radius: 6.25rem;
	line-height: 6.25rem;
	margin-left: auto;
	font-size: 3.75rem;
	text-align: center;
	color: white;
	margin-right: auto;
	margin-top: -6.25rem;
	margin-bottom: 1.25rem;
}
.authincation-content.style-2 {
	background: transparent;
	box-shadow: none;
	max-width: 33.125rem;
	width: 100%;
}
.authincation-content.style-2 .form-control {
	border: 0;
	border-radius: 0.3125rem;
	box-shadow: 0rem 0rem 0.9375rem rgba(0, 0, 0, 0.08);
}
@media only screen and (max-width: 35.9375rem) {
	.authincation-content.style-2 .auth-form {
		padding: 1.875rem 0rem;
	}
}

.welcome-content {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
	background-size: cover;
	background-position: center;
	height: 100%;
	padding: 4.6875rem 3.125rem;
	position: relative;
	z-index: 1;
	border-top-left-radius: 0.3125rem;
	border-bottom-left-radius: 0.3125rem;
}
.welcome-content::after {
	content: '';
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: var(--primary);
	opacity: 0.75;
	z-index: -1;
	border-top-left-radius: 0.3125rem;
	border-bottom-left-radius: 0.3125rem;
}
.welcome-content .welcome-title {
	color: #fff;
	font-weight: 500;
	font-size: 1.25rem;
}
.welcome-content p {
	color: #fff;
}
.welcome-content .brand-logo a {
	display: inline-block;
	margin-bottom: 1.25rem;
	font-weight: 700;
	color: #fff;
	font-size: 1.25rem;
}
.welcome-content .brand-logo a img {
	width: 6.25rem;
}
.welcome-content .intro-social {
	position: absolute;
	bottom: 4.6875rem;
}
.welcome-content .intro-social ul {
	margin-bottom: 0;
}
.welcome-content .intro-social ul li {
	display: inline-block;
}
.welcome-content .intro-social ul li a {
	color: #fff;
	font-size: 0.875rem;
	padding: 0rem 0.4375rem;
}

.auth-form {
	padding: 3.125rem 3.125rem;
}
@media only screen and (max-width: 35.9375rem) {
	.auth-form {
		padding: 1.875rem;
	}
}
.auth-form .btn {
	height: 3.125rem;
	font-weight: 700;
}
.auth-form .page-back {
	display: inline-block;
	margin-bottom: 0.9375rem;
}

.slideskew {
	animation: 5s ease 0s normal none infinite running slideskew;
}

@keyframes slideskew {
	0% {
		transform: translateY(0px);
		opacity: 1;
	}
	50% {
		transform: translateY(20px);
		-moz-transform: translateY(20px);
		-webkit-transform: translateY(20px);
		-ms-transform: translateY(20px);
		-o-transform: translateY(20px);
	}
	100% {
		transform: translateY(0);
		-moz-transform: translateY(0);
		-webkit-transform: translateY(0);
		-ms-transform: translateY(0);
		-o-transform: translateY(0);
	}
}

.sign-bg {
	background-size: cover;
	background-position: center;
	position: relative;
	z-index: 1;
}
.sign-bg:after {
	content: '';
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	background: #dbe9f3;
	opacity: 0.5;
	height: 100%;
	z-index: -1;
}
.sign-bg .bitcoin-img {
	width: 70%;
}

.sign-in-your {
	padding: 10vh 0;
	margin-left: auto;
	margin-right: auto;
	max-width: 350px;
}
@media only screen and (max-width: 47.9375rem) {
	.sign-in-your {
		padding: 5vh 0;
	}
}

.heading {
	font-size: 1.125rem;
	font-weight: 600;
	line-height: 1.5;
}
@media only screen and (max-width: 87.5rem) {
	.heading {
		font-size: 1rem;
	}
}

.heading-lg {
	font-size: 1.5rem;
}

.subtitle {
	font-size: 2.25rem;
}

.default-select .dropdown-toggle::after {
	display: inline-block;
	margin-left: 0;
	vertical-align: unset;
	content: '';
	width: 0.5rem;
	height: 0.5rem;
	border-top: 2px solid #666;
	border-right: 2px solid #666;
	transform: rotate(135deg);
	border-bottom: none;
	border-left: none;
	margin: 0;
	padding: 0;
	margin-bottom: 0.25rem;
}

.default-select.dropup .dropdown-toggle::after {
	transform: rotate(-45deg);
	margin-bottom: 0;
}

.bootstrap-datetimepicker-widget .datepicker {
	padding: 20px;
	overflow: hidden;
	border-radius: 0.375rem;
}
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th {
	background-color: transparent;
	padding: 10px 5px;
}
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.prev,
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.picker-switch,
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.next {
	color: #303972;
}
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed td.day {
	margin-bottom: 0;
	padding: 0;
	font-size: 14px;
	color: #303972;
	width: 55px;
	height: 55px;
	line-height: 40px;
	border-radius: 0.625rem;
}
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td {
	background-color: transparent !important;
	background-image: none !important;
	text-shadow: none !important;
	box-shadow: none;
	position: relative;
	z-index: 1;
}
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td:before {
	content: '';
	position: absolute;
	z-index: -1;
	height: 30px;
	width: 30px;
	border-radius: 25px;
	top: 50%;
	left: 50%;
	background-color: #4d44b5;
	transform: translate(-50%, -50%);
	border: 0;
	opacity: 0;
}
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td.today:hover {
	background-color: #fff;
	box-shadow: none;
	color: #fff !important;
}
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td.today,
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td.active {
	color: #fff;
}
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td.today:before,
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td.active:before {
	opacity: 1;
}
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td.active:before {
	background-color: #fb7d5b;
}
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed th {
	font-size: 15px;
	font-weight: 500;
}
.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed td.day.active.today:hover {
	border-bottom: transparent;
}

.datepicker {
	padding: 15px;
}
.datepicker th {
	padding: 10px;
}

.table-condensed {
	width: 100%;
}

.picker-switch.accordion-toggle .table-condensed td {
	display: none;
}

.card .card-box-icon {
	width: 4.5rem;
	height: 4.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
	border: 1px solid #eeeeee;
	border-radius: 0.375rem;
	margin-right: 0.938rem;
}

.card .chart-num h2,
.card .chart-num .h2 {
	font-size: 1.5rem;
	margin-bottom: 0;
	line-height: 1;
}

.card .chart-num p {
	font-size: 0.963rem;
	margin-bottom: 0.313rem;
	line-height: 1rem;
}

.counter .chart-num {
	margin-bottom: 0.675rem;
}

.counter .card-body {
	padding: 2.813rem 0 2.813rem 2.813rem;
}
.counter .card-body .card-box-icon {
	margin-right: 1.25rem;
}

.round {
	margin-right: 1.5rem;
	position: relative;
	padding-left: 2.2rem;
	cursor: pointer;
	font-size: 0.875rem;
	-webkit-user-select: none;
	        user-select: none;
}
@media only screen and (max-width: 87.5rem) {
	.round {
		padding-left: 1.8rem;
	}
}
.round input {
	position: absolute;
	top: 0;
	left: 0;
	height: 1.25rem;
	width: 6.25rem;
	background-color: #ffffff;
	opacity: 0;
}
.round span {
	color: #303972;
}
.round .checkmark {
	position: absolute;
	top: 0;
	left: 20%;
	transform: translate(-50%, 50%);
	height: 0.75rem;
	width: 0.75rem;
	background-color: #ffffff;
	border-radius: 50%;
	border: 3px solid var(--secondary);
	padding: 2px;
	margin: 0;
}
.round .checkmark2 {
	position: absolute;
	top: 50%;
	left: 0;
	transform: translateY(-50%);
	height: 1.35rem;
	width: 1.35rem;
	background-color: #ffffff;
	border-radius: 50%;
	border: 2px solid var(--primary);
	padding: 0.2rem;
}

.round.weekly .checkmark {
	border: 3px solid var(--primary);
}

.round:hover input ~ .checkmark {
	background-color: #ffffff;
}

.round input:checked ~ .checkmark {
	background-color: #ffffff;
	border: 2px solid #fcc43e;
}

.round.weekly input:checked ~ .checkmark {
	background-color: #ffffff;
	border: 2px solid var(--secondary);
}

.checkmark:after {
	content: '';
	position: absolute;
	display: none;
}

.round input:checked ~ .checkmark:after {
	display: block;
}

.round.weekly input:checked ~ .checkmark:after {
	display: block;
	background-color: var(--secondary);
}

.round .checkmark:after {
	width: 100%;
	height: 100%;
	background-color: #fcc43e;
	border-radius: 50%;
	position: relative;
}

.round.disabled {
	opacity: 1;
}

.toggle-btn {
	margin-right: 1.8rem;
	position: relative;
	padding-left: 2rem;
	cursor: pointer;
	font-size: 0.875rem;
	-webkit-user-select: none;
	        user-select: none;
}
.toggle-btn input {
	position: absolute;
	top: 0;
	left: 0;
	height: 1.25rem;
	width: 6.25rem;
	background-color: #ffffff;
	opacity: 0;
}
.toggle-btn span {
	color: #ffffff;
}
.toggle-btn h4,
.toggle-btn .h4 {
	color: #ffffff;
}
.toggle-btn .check {
	position: absolute;
	top: 50%;
	left: 0;
	transform: translateY(-50%);
	height: 22px;
	width: 22px;
	background-color: var(--primary);
	border-radius: 50%;
	border: 3px solid #fff;
	padding: 2px;
}

.toggle-btn input:checked ~ .check {
	background-color: var(--primary);
	border: 3px solid #fff;
}

.check:after {
	content: '';
	position: absolute;
	display: none;
}

.toggle-btn input:checked ~ .check:after {
	display: block;
}

.toggle-btn .check:after {
	width: 82%;
	height: 82%;
	background-color: #fff;
	border-radius: 50%;
	top: 1px;
	left: 1px;
	position: relative;
}

.toggle-btn.expense .check {
	border: 3px solid #fffa6f;
}

.toggle-btn.expense input:checked ~ .check {
	background-color: var(--primary);
	border: 3px solid #fffa6f;
}

.toggle-btn.expense .check:after {
	background-color: #fffa6f;
}

.progressbar {
	box-shadow: none;
}

.expense .students1 {
	padding: 0 10px;
}

#wallet-bar {
	background-color: #ffffff;
	z-index: 4;
}
@media only screen and (max-width: 87.5rem) {
	#wallet-bar {
		z-index: 4;
	}
}
@media only screen and (max-width: 74.9375rem) {
	#wallet-bar {
		z-index: 8;
	}
}
@media only screen and (max-width: 35.9375rem) {
	#wallet-bar {
		z-index: 8;
	}
}
#wallet-bar.dlab-scroll {
	overflow-y: scroll;
}

.student {
	position: relative;
	margin: 0;
	z-index: 1;
	padding: 0.925rem 0;
}
.student .dz-media {
	margin-right: 0.938rem;
}
.student .user-info .name {
	font-size: 0.875rem;
	font-weight: 600;
	margin-bottom: 0.2rem;
}
.student .indox {
	margin-left: auto;
}
.student:hover .indox a {
	background-color: var(--rgba-primary-1);
}
.student:hover .indox a svg path {
	fill: var(--primary);
}
.student:hover .indox a::before {
	background-color: var(--primary);
}

a.btn.dlab-load-more {
	padding: 0.69375rem 1.5rem;
	font-weight: 500;
}

.wallet-bar .wallet-bar-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0px 1.125rem;
}

@media only screen and (max-width: 35.9375rem) {
	.p-static {
		display: none;
	}
}

.mail-img {
	position: absolute;
	bottom: 0%;
	right: 0;
}

.user_reviews {
	padding: 1.125rem 0;
}
@media only screen and (max-width: 74.9375rem) {
	.user_reviews {
		padding: 1.125rem 0;
	}
}

.element-area {
	display: flex;
}
.element-area .demo-view {
	width: calc(100% - 270px);
}
@media only screen and (max-width: 100rem) {
	.element-area .demo-view {
		width: calc(100% - 236px);
	}
}
@media only screen and (max-width: 74.9375rem) {
	.element-area .demo-view {
		width: calc(100% - 224px);
	}
}
@media only screen and (max-width: 61.9375rem) {
	.element-area .demo-view {
		width: 100%;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.element-area .demo-view {
		width: 100%;
	}
	.element-area .demo-view .container-sm {
		padding: 0;
	}
}
.element-area .demo-right {
	width: 16.875rem;
	position: sticky;
	top: 7rem;
	height: calc(100% - 140px);
	z-index: 1;
}
@media only screen and (max-width: 74.9375rem) {
	.element-area .demo-right {
		width: 15.875rem;
	}
}
@media only screen and (max-width: 61.9375rem) {
	.element-area .demo-right {
		display: none;
	}
}
@media only screen and (max-width: 47.9375rem) {
	.element-area .demo-right {
		display: none;
	}
}
.element-area .demo-right.sticky {
	top: 100px;
	transition: 0.5s;
}

.demo-right-inner {
	padding: 1rem 2.225rem;
	background-color: #fff;
	border-radius: 0.375rem;
	height: 100%;
	overflow: hidden;
}
.demo-right-inner h4,
.demo-right-inner .h4 {
	padding: 0.625rem 0;
}
.demo-right-inner li {
	font-size: 0.9rem;
}
.demo-right-inner li a {
	display: block;
	padding: 0.375rem 0.25rem;
}

.fc .fc-toolbar.fc-header-toolbar {
	flex-wrap: wrap;
	margin-bottom: 0;
}

.fc .fc-button-group {
	margin-bottom: 0.625rem;
	z-index: 0;
}

/* work */
.food {
	margin-bottom: 25px;
}
.food .dz-media img {
	border-radius: 6px;
	width: 100%;
	height: 160px;
	margin-bottom: 10px;
}

.doller {
	color: #303972;
}

.trans-list {
	display: flex;
	align-items: center;
}
.trans-list h4,
.trans-list .h4 {
	margin-bottom: 0;
	font-size: 14px;
}

.table-pagenation {
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	margin-top: 0.625rem;
	padding: 0 25px;
	/* .page-link {
		background: #fff;
		border-color: transparent;
	} */
}
.table-pagenation p {
	margin-left: 0.475rem;
}
.table-pagenation p span {
	color: var(--primary) !important;
	margin: 0 0.2rem;
}
.table-pagenation .pagination .page-item.page-indicator .page-link {
	background-color: transparent;
	color: #a098ae;
}
.table-pagenation .pagination .page-item.page-indicator .page-link:hover {
	background-color: var(--primary);
}
.table-pagenation .pagination.no-bg li:not(.page-indicator):not(.active) .page-link {
	border: 1px solid var(--primary);
}

.heart {
	width: 60px;
	height: 60px;
	display: inline-block;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
	cursor: pointer;
	margin: -25px -15px;
}

.heart-blast {
	background-position: -1680px 0;
	transition: background 1s steps(28);
}

/* date picker */
.bootstrap-select:not([class*='col-']):not([class*='form-control']):not(.input-group-btn) {
	width: 207px;
}

.bs-select.border-transparent .btn {
	border-color: transparent;
	color: #303972;
}

/* date picker */
tr .trans-td-list {
	font-size: 18px;
}

/* custom css */
.avatar {
	width: 3rem;
	height: 3rem;
	object-fit: cover;
	border-radius: 100%;
	position: relative;
	display: inline-block;
}
.avatar.avatar-lg {
	width: 3.75rem;
	height: 3.75rem;
}
@media only screen and (max-width: 87.5rem) {
	.avatar.avatar-lg {
		width: 2.95rem;
		height: 2.95rem;
	}
}
.avatar.avatar-xl {
	width: 7.5rem;
	height: 7.5rem;
}
@media only screen and (max-width: 74.9375rem) {
	.avatar.avatar-xl {
		width: 5rem;
		height: 5rem;
	}
}
.avatar.avatar-xxl {
	width: 9.375rem;
	height: 9.375rem;
}
@media only screen and (max-width: 35.9375rem) {
	.avatar.avatar-xxl {
		width: 7.375rem;
		height: 7.375rem;
	}
}
.avatar.avatar-sm {
	width: 30px;
	height: 30px;
}

.icon-box {
	width: 48px;
	height: 48px;
	line-height: 45px;
	text-align: center;
	position: relative;
	display: inline-block;
	border-radius: 100%;
	transition: all 0.8s;
}
.icon-box svg {
	width: 1.188rem;
}
.icon-box i {
	transform: scale(2);
}
.icon-box.icon-box-sm {
	height: 2.5rem;
	width: 2.5rem;
	line-height: 2.5rem;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}
.icon-box.icon-box-xs {
	width: 2.188rem;
	height: 2.188rem;
	line-height: 2.188rem;
}
.icon-box.icon-box-lg {
	height: 3.75rem;
	width: 3.75rem;
	line-height: 3.625rem;
	min-width: 3.75rem;
}
@media only screen and (max-width: 87.5rem) {
	.icon-box.icon-box-lg {
		width: 3.125rem;
		height: 3.125rem;
		line-height: 2.938rem;
		min-width: 3.125rem;
	}
}
.icon-box.icon-box-xl {
	height: 3.75rem;
	width: 3.75rem;
	line-height: 3.75rem;
}

.st-box {
	border: 2px solid #a098ae;
}

/* new scss */
.content-box {
	display: flex;
	align-items: center;
}
@media only screen and (max-width: 74.9375rem) {
	.content-box {
		margin-bottom: 15px;
	}
}
.content-box .std-data {
	background-color: var(--primary);
}
.content-box .teach-data {
	background-color: var(--secondary);
}
.content-box .event-data {
	background-color: #fcc43e;
}
.content-box .food-data {
	background-color: #303972;
}
.content-box .std-data,
.content-box .teach-data,
.content-box .event-data,
.content-box .food-data {
	margin-right: 10px;
}

.table.short-one thead th {
	color: #303972;
}

.table.short-one tbody {
	text-align: center;
	font-size: 1rem;
	font-weight: 500;
}

.student.border-bottom {
	border-bottom: 1px solid var #b3b1cb !important;
}

.name {
	margin-bottom: 4px;
}

.modal-dialog-center {
	min-height: calc(100% - 3.5rem);
	display: flex;
	align-items: center;
	justify-content: center;
}

.table-responsive.full-data thead th {
	border-bottom: 0;
}
.table-responsive.full-data thead th:first-child {
	padding-left: 21px;
	padding-right: 0;
}

.table-responsive.full-data td:first-child {
	padding-right: 0;
}

.table-responsive.full-data tbody h6,
.table-responsive.full-data tbody .h6 {
	font-size: 0.875rem;
	font-weight: 500;
}

.table-responsive.full-data tbody .icon-box-sm {
	width: 2.188rem;
	height: 2.188rem;
	line-height: 2.188rem;
	cursor: pointer;
}
.table-responsive.full-data tbody .icon-box-sm svg {
	width: 1rem;
	height: 1rem;
}

.table-responsive.full-data tbody .avatar {
	width: 2.188rem;
	height: 2.188rem;
}

.table-responsive.full-data tbody .sharp {
	width: 1.25rem;
	height: 1.25rem;
}

.table-responsive.full-data .table > :not(:first-child) {
	border-top: 0;
}

.table-responsive .order-table th:first-child,
.table-responsive .order-table td:first-child {
	padding-right: 0;
}

.table-responsive .table-striped th {
	background-color: #fff;
	color: #303972;
	font-weight: 600;
}

/* user */
.bell-icon .nav-link {
	position: relative;
}
.bell-icon .nav-link:before {
	position: absolute;
	content: '';
	background-color: var(--primary);
	width: 7px;
	height: 7px;
	border-radius: 100%;
	top: 10px;
	right: 15px;
	animation: blinking 1s infinite;
}
@media only screen and (max-width: 106.25rem) {
	.bell-icon .nav-link:before {
		top: 8px;
		right: 12px;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.bell-icon .nav-link:before {
		width: 5px;
		height: 5px;
		top: 5px;
		right: 8px;
	}
}

.dd-item {
	cursor: all-scroll;
}

.sweet-image {
	width: 20%;
}

.clockpicker-popover {
	position: absolute;
	border-radius: 0.375rem;
	border-color: transparent;
}

.demo-right-inner li {
	position: relative;
}
.demo-right-inner li.active a {
	color: var(--primary);
	font-weight: 500;
}
.demo-right-inner li.active:after {
	background-color: var(--primary);
}
.demo-right-inner li .scroll:after {
	position: absolute;
	content: '';
	background-color: #ebebf9;
	height: 5px;
	width: 5px;
	border-radius: 100%;
	top: 15px;
	left: -17px;
}
@media only screen and (max-width: 87.5rem) {
	.demo-right-inner li .scroll:after {
		top: 12px;
	}
}
.demo-right-inner li .scroll.active {
	color: var(--primary);
	font-weight: 500;
}
.demo-right-inner li .scroll.active:after {
	background-color: var(--primary);
}

.page-title .bootstrap-select:not([class*='col-']):not([class*='form-control']):not(.input-group-btn) {
	width: 7.688rem;
}

.all {
	display: none !important;
}
.all .dropdown-menu {
	border-radius: 0.375rem;
}
.all .dropdown-menu .nav-link {
	width: 2.5rem;
	min-width: 2.5rem;
	height: 2.5rem;
	margin-right: 0.313rem;
}
.all .svg-main-icon path {
	fill: #a098ae;
}
@media only screen and (max-width: 74.9375rem) {
	.all {
		display: inline-flex !important;
	}
	.all .dropdown-menu.show {
		height: auto;
		width: 8.75rem;
		min-width: 11.15rem;
	}
	.all .dropdown-menu.show svg {
		width: 1rem;
		height: 1rem;
	}
}
@media only screen and (max-width: 74.9375rem) and (max-width: 47.9375rem) {
	.all .dropdown-menu.show {
		right: 13.6rem;
		top: 4.85rem;
	}
}
@media only screen and (max-width: 74.9375rem) and (max-width: 35.9375rem) {
	.all .dropdown-menu.show {
		right: 7.9rem;
		top: 4.85rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.all {
		top: 77px;
		border-radius: 0;
	}
}
@media only screen and (max-width: 74.9375rem) {
	.all .menu-wallet,
	.all .dz-theme-mode,
	.all .dz-fullscreen {
		display: inline-flex !important;
	}
}
.all .card-header {
	border-radius: 0.375rem !important;
	background-color: var(--rgba-primary-1);
}

@media only screen and (max-width: 74.9375rem) {
	.menu-wallet,
	.dz-theme-mode,
	.dz-fullscreen {
		display: none !important;
	}
}

.order-table thead th {
	color: #fff;
}

@keyframes blinking {
	0% {
		background-color: var(--primary);
	}
	100% {
		background-color: transparent;
	}
}

.search-area-header ul li i {
	cursor: pointer;
}

.page-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem 1.25rem;
	margin-bottom: 1.875rem;
	border-radius: 0.375rem;
	position: relative;
	z-index: 1;
	background-color: #fff;
}
.page-title .search-area {
	width: 21.875rem;
	flex-direction: row-reverse;
	border: 1px solid transparent;
	overflow: hidden;
	border-radius: 0.375rem;
	box-sizing: border-box;
	border: 1px solid #eeeeee;
	height: 3rem;
}
.page-title .search-area .form-control {
	border-right: 0;
	border: none;
	padding: 0rem;
	border-radius: 0 0.375rem 0.375rem 0;
	padding-left: 0.2rem;
	height: 3rem;
	line-height: 3rem;
}
.page-title .search-area .form-control:focus {
	border-color: white;
	box-shadow: none;
}
.page-title .search-area .input-group-text {
	background: #fff;
	border: none;
	padding-right: 20px;
	height: 3rem;
	border-radius: 0.375rem 0 0 0.375rem;
}
.page-title .search-area .input-group-text svg {
	transform: scale(1.2);
}
.page-title .search-area .input-group-text svg path {
	fill: var(--primary);
}

.box-1 {
	overflow: hidden;
}
.box-1 .max {
	position: relative;
	background-size: cover;
	background-repeat: no-repeat;
	padding: 30px;
	overflow: hidden;
}
.box-1 .max .item {
	position: absolute;
	bottom: 25px;
}
.box-1 .max .item .text {
	color: white;
	margin-bottom: 20px;
}
.box-1 .max .dropdown {
	position: absolute;
	right: 25px;
}
.box-1 .max-2 {
	padding: 30px;
}
.box-1 .max-2 .ul-li {
	margin-bottom: 20px;
}
.box-1 .max-2 .ul-li ul li {
	display: flex;
	align-items: center;
}
.box-1 .max-2 a {
	font-size: 18px;
	width: 100%;
	margin-top: 1.625rem;
}

.btn-check:checked + .btn:active,
:not(.btn-check) + .btn:active:active,
.btn:first-child:active:active,
.btn.active:active,
.btn.show:active {
	border-color: transparent;
}

.search-area {
	width: 25rem;
	flex-direction: row-reverse;
	border: 1px solid #dddddd;
	overflow: hidden;
	border-radius: 0.375rem;
	box-sizing: border-box;
	height: 3rem;
}
@media only screen and (max-width: 117.5rem) {
	.search-area {
		width: 22rem;
	}
}
@media only screen and (max-width: 81.25rem) {
	.search-area {
		width: 17.5rem;
	}
}
@media only screen and (max-width: 74.9375rem) {
	.search-area {
		width: 15.625rem;
	}
}
.search-area .form-control {
	font-size: 15px;
	border-right: 0;
	border: none;
	padding: 0rem;
	border-radius: 0 0.375rem 0.375rem 0;
	padding-left: 0.2rem;
	height: 3rem;
}
.search-area .form-control:focus {
	border-color: white;
	box-shadow: none;
}
.search-area .input-group-text {
	background: #fff;
	border: none;
	height: 3rem;
	border-radius: 0.375rem 0 0 0.375rem;
}
.search-area .input-group-text svg {
	transform: scale(1.2);
}
.search-area .input-group-text svg path {
	fill: var(--primary);
}

.nav-link.menu-wallet.main {
	background-color: var(--rgba-primary-1);
}
.nav-link.menu-wallet.main svg path {
	fill: #fff;
	stroke: #fff;
}

@media only screen and (max-width: 35.9375rem) {
	.card.Custom-select .input-group-text {
		padding: 0.4875rem 1.25rem;
	}
}

.table.table-details tbody td:first-child {
	padding-left: 0;
}

.table.table-details tbody tr:last-child td {
	border: 0;
}

.table-responsive.basic-tbl thead th:last-child {
	text-align: end;
}

.table-responsive.basic-tbl td:last-child {
	text-align: end;
}

.table-responsive.basic-tbl .dataTables_info {
	padding-top: 18px;
	color: #a098ae;
	padding-left: 25px;
}

.table-responsive.basic-tbl .dataTables_wrapper .dataTables_paginate {
	padding-right: 9px;
}

.student {
	cursor: pointer;
}
.student:hover a {
	color: var(--primary);
}
.student:hover .st-box {
	background-color: var(--primary);
	border-color: var(--primary);
}
.student:hover .st-box svg path {
	fill: #fff;
}

.gallery-media {
	height: 150px;
	object-fit: cover;
	object-position: top;
}
.gallery-media.style-1 {
	height: 300px;
}

.table-clear {
	background-color: #f2f2f2;
}
.table-clear tbody tr td {
	border-color: #c2c2c2;
}

.table.table-invoice {
	margin-bottom: 0;
}
.table.table-invoice tbody tr:last-child td {
	border-bottom: 1px solid #f2f2f2;
}

.dz-calender {
	position: relative;
	z-index: 1;
}
.dz-calender .react-datepicker__day-names,
.dz-calender .react-datepicker__week {
	display: flex;
}
.dz-calender .react-datepicker {
	border: unset;
	width: 100%;
	background-color: transparent;
}
.dz-calender .react-datepicker__header {
	border: unset;
	background-color: transparent;
}
.dz-calender .react-datepicker__header .react-datepicker__day-names {
	color: var(--secondary);
	margin-bottom: -15px;
}
.dz-calender .react-datepicker .react-datepicker__triangle:before {
	box-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.09);
	border-bottom-color: transparent;
}
.dz-calender .react-datepicker__navigation {
	top: 12px;
	line-height: 20px;
	background: var(--rgba-primary-1);
	border-radius: 0.375rem;
}
.dz-calender .react-datepicker__navigation--previous {
	left: 10px;
}
.dz-calender .react-datepicker__navigation--next {
	right: 10px;
}
.dz-calender .react-datepicker__navigation-icon:before {
	border-color: var(--primary);
	border-width: 2px 2px 0 0;
}
.dz-calender .react-datepicker__current-month {
	padding: 10px 0px;
	margin: 0 20px;
	font-size: 15px;
	font-weight: 500;
}
.dz-calender .react-datepicker__day-name,
.dz-calender .react-datepicker__day,
.dz-calender .react-datepicker__time-name {
	height: 55px;
	flex: 1 1;
	line-height: 55px;
	font-size: 13px;
	font-weight: 400;
	margin: 0;
	font-family: 'poppins', sans-serif;
}
.dz-calender .react-datepicker__day--selected {
	background: var(--primary) !important;
	color: #fff !important;
}
.dz-calender svg path {
	fill: var(--primary);
}
.dz-calender .react-datepicker-wrapper {
	width: auto;
}
.dz-calender .react-datepicker__month-container {
	float: inherit;
}

.drop-select {
	width: 130px;
}
.drop-select .drop-select-btn {
	background-color: transparent !important;
	font-weight: 400;
	padding: 0.6875rem 1.25rem;
	border: 1px solid #dddddd;
	border-width: 1px;
	line-height: 1.5;
	font-size: 1rem;
	border-radius: 6px;
	color: #303972;
	display: inline-flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}
.drop-select .drop-select-btn:after {
	display: inline-block;
	margin-left: 0;
	vertical-align: unset;
	content: '';
	width: 0.5rem;
	height: 0.5rem;
	border-top: 2px solid #666;
	border-right: 2px solid #666;
	transform: rotate(135deg);
	border-bottom: none;
	border-left: none;
	margin: 0;
	padding: 0;
	margin-bottom: 0.25rem;
}
.drop-select .dropdown-menu {
	min-width: 8rem;
	z-index: 2;
}
.drop-select .dropdown-menu .dropdown-item {
	font-size: 0.875rem;
}
.drop-select .dropdown-menu .dropdown-item:first-child {
	color: var(--primary);
	background: var(--rgba-primary-1);
}

.contact_list {
	transition: all 0.8s;
}
.contact_list .dropdown {
	position: absolute;
	top: 20px;
	right: 20px;
}
.contact_list:hover {
	box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.contact_list .btn-check:focus + .btn,
.contact_list .btn:focus {
	outline: 0;
}

/* Teacher Detail */
.user-bg {
	height: 140px;
	background-color: var(--primary);
	border-radius: 0.375rem 0.375rem 0 0;
	position: relative;
}
.user-bg .user-svg,
.user-bg .user-svg-1 {
	position: absolute;
	bottom: 0;
	right: 40px;
	z-index: 1;
}
@media only screen and (max-width: 35.9375rem) {
	.user-bg .user-svg,
	.user-bg .user-svg-1 {
		right: 27px;
	}
}
@media only screen and (max-width: 61.9375rem) {
	.user-bg .user-svg svg,
	.user-bg .user-svg-1 svg {
		width: 9.375rem;
		height: 6.25rem;
	}
}
@media only screen and (max-width: 61.9375rem) and (max-width: 35.9375rem) {
	.user-bg .user-svg svg,
	.user-bg .user-svg-1 svg {
		width: 7.738rem;
		height: 4.813rem;
	}
}
.user-bg .user-svg-1 {
	right: 144px;
	z-index: 0;
}
@media only screen and (max-width: 35.9375rem) {
	.user-bg .user-svg-1 {
		right: 68px;
	}
}

.user {
	margin-top: -100px;
}
@media only screen and (max-width: 35.9375rem) {
	.user {
		margin-top: -72px;
	}
}
.user .user-media {
	margin-bottom: 20px;
}
@media only screen and (max-width: 35.9375rem) {
	.user .user-media {
		margin-bottom: 10px;
	}
}
.user .user-media .avatar {
	border: 8px solid #fff;
}
@media only screen and (max-width: 35.9375rem) {
	.user .user-media .avatar {
		border-width: 5px;
	}
}

.user-content .user-img {
	margin-bottom: 1.5rem;
}

@media only screen and (max-width: 74.9375rem) {
	.user-content .sharp {
		width: 2.4rem;
		height: 2.4rem;
	}
}

.teacher-deatails p {
	width: 60%;
}
@media only screen and (max-width: 87.5rem) {
	.teacher-deatails p {
		width: 100%;
	}
}

.teacher-deatails .dots {
	position: relative;
	padding-left: 0.938rem;
	margin-bottom: 1.563rem;
}
.teacher-deatails .dots:after {
	content: '';
	position: absolute;
	background-color: var(--primary);
	width: 5px;
	height: 5px;
	border-radius: 100%;
	top: 0.5rem;
	left: 0;
}

.contact-icon {
	margin-bottom: 30px;
}

@media only screen and (max-width: 74.9375rem) {
	.contact_list .card-body {
		padding: 20px;
	}
}

.image-placeholder {
	position: relative;
	max-width: 130px;
	margin: 10px auto;
}
.image-placeholder .avatar-edit {
	position: absolute;
	right: -5px;
	z-index: 1;
	top: 0px;
}
.image-placeholder .avatar-edit input {
	display: none;
}
.image-placeholder .avatar-edit input + label {
	display: inline-block;
	width: 34px;
	height: 34px;
	margin-bottom: 0;
	border-radius: 100%;
	background: #ffffff;
	border: 1px solid transparent;
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
	cursor: pointer;
	font-weight: normal;
	transition: all 0.2s ease-in-out;
}
.image-placeholder .avatar-edit input + label:hover {
	background: #f1f1f1;
	border-color: #d6d6d6;
}
.image-placeholder .avatar-edit input + label:after {
	content: '\\f303';
	font-family: 'Font Awesome 5 Free';
	font-weight: 900;
	color: #757575;
	position: absolute;
	top: 6px;
	left: 0;
	right: 0;
	text-align: center;
	margin: auto;
}
.image-placeholder .avatar-preview {
	width: 130px;
	height: 130px;
	position: relative;
	border-radius: 100%;
	border: 3px solid #f8f8f8;
	overflow: hidden;
	box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
}
.image-placeholder .avatar-preview > div {
	width: 100%;
	height: 100%;
	border-radius: 30px;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
}
.image-placeholder .avatar-preview > div img {
	height: 100%;
	width: 100%;
	object-fit: cover;
}

.project-boxed {
	overflow: hidden;
}

.food-tabs {
	border-bottom: 2px solid var(--rgba-primary-1);
}
.food-tabs .nav-item .nav-link {
	position: relative;
	color: #c2c2c2;
}
.food-tabs .nav-item .nav-link:after {
	content: '';
	position: absolute;
	background-color: var(--primary);
	width: 0px;
	height: 2px;
	bottom: -2px;
	left: 0px;
}
.food-tabs .nav-item .nav-link.active {
	background-color: unset;
	border: 1px solid transparent;
	color: var(--primary);
}
.food-tabs .nav-item .nav-link.active:after {
	width: 100%;
}
.food-tabs .nav-item .nav-link:hover {
	border: 1px solid transparent;
}
@media only screen and (max-width: 35.9375rem) {
	.food-tabs .nav-item .nav-link {
		padding: 12px;
	}
}

.food-menu {
	display: flex;
	align-items: center;
}

.food-review {
	display: flex;
	align-items: center;
}
.food-review h5,
.food-review .h5 {
	margin-bottom: 0;
}
.food-review i {
	color: #fcc43e;
	margin-right: 0.313rem;
}

/* food-details */
.food-media {
	width: 361px;
	height: 191px;
	object-fit: cover;
}
.food-media img {
	width: 100%;
}
@media only screen and (max-width: 35.9375rem) {
	.food-media {
		width: 100%;
		margin-bottom: 1rem;
	}
}

.food-recipe li {
	list-style: unset;
	margin: 5px 20px;
}

.schedule-card,
.schedule-card-1,
.schedule-card-2,
.schedule-card-3 {
	position: relative;
	overflow: hidden;
}
.schedule-card .card-body,
.schedule-card-1 .card-body,
.schedule-card-2 .card-body,
.schedule-card-3 .card-body {
	padding-top: 24px;
	padding-bottom: 24px;
	margin-left: 3px;
}
.schedule-card:after,
.schedule-card-1:after,
.schedule-card-2:after,
.schedule-card-3:after {
	content: '';
	position: absolute;
	background-color: var(--primary);
	width: 0.438rem;
	height: 12.188rem;
	top: 0;
	left: 0;
}

.schedule-card-1:after {
	background-color: var(--secondary);
}

.schedule-card-2:after {
	background-color: #fcc43e;
}

.schedule-card-3:after {
	background-color: #303972;
}

.student-details {
	display: flex;
	align-items: center;
}
@media only screen and (max-width: 100rem) {
	.student-details {
		margin-bottom: 10px;
	}
}
@media only screen and (max-width: 74.9375rem) {
	.student-details {
		margin-bottom: 10px;
	}
}

.setting-img img {
	width: 7.5rem;
	height: 7.5rem;
	border-radius: 0.375rem;
	object-fit: cover;
}

.setting-img .change {
	border-radius: 6px;
	padding: 0.688rem 0.875rem;
}
@media only screen and (max-width: 35.9375rem) {
	.setting-img .change {
		margin-left: 1rem;
	}
}

@media only screen and (max-width: 35.9375rem) {
	.setting-img {
		flex-wrap: wrap;
	}
}

.avatar-upload .avatar-edit {
	position: absolute;
	right: 0.75rem;
	z-index: 1;
	top: 0.625rem;
}

.avatar-upload .avatar-preview > div {
	display: inline-block;
	width: 6.5rem;
	height: 6.5rem;
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	border-radius: 6px;
}

input.form-control {
	position: relative;
}

input[type='date']::-webkit-calendar-picker-indicator {
	background: transparent;
	bottom: 0;
	color: transparent;
	cursor: pointer;
	height: auto;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;
	width: auto;
}

.p-static .bootstrap-select {
	width: 130px !important;
}

.table-responsive .unpaid-school thead {
	background-color: unset;
}
.table-responsive .unpaid-school thead th {
	color: #000;
}
.table-responsive .unpaid-school thead td span {
	font-size: 14px;
}

.input-group.user-search-area {
	margin-top: 0.875rem;
}
.input-group.user-search-area .input-group-text {
	background-color: transparent;
	border-color: #dddddd;
}
.input-group.user-search-area .form-control {
	border-left: 0;
	border-color: #dddddd;
}
.input-group.user-search-area .form-control:focus {
	border-color: #dddddd;
}

.timeline-active .timeline-list {
	position: relative;
	padding: 1.1rem 0;
}
.timeline-active .timeline-list:before {
	top: 2.275rem;
	bottom: 0;
	position: absolute;
	content: ' ';
	width: 0.125rem;
	height: calc(100% - 0.875rem);
	left: 13.4px;
	margin-right: -0.0938rem;
	background: #dddddd;
}

.timeline-active span,
.timeline-active .time {
	font-size: 13px;
	margin-left: 10px;
}

.plan-bx {
	position: relative;
}
.plan-bx .plan-svg,
.plan-bx .plan-svg-1 {
	position: absolute;
	bottom: 0;
	right: 0;
	z-index: 0;
}
@media only screen and (max-width: 87.5rem) {
	.plan-bx .plan-svg,
	.plan-bx .plan-svg-1 {
		right: -7px;
	}
	.plan-bx .plan-svg svg,
	.plan-bx .plan-svg-1 svg {
		width: 100px;
		height: 100px;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.plan-bx .plan-svg,
	.plan-bx .plan-svg-1 {
		right: 8px;
	}
	.plan-bx .plan-svg svg,
	.plan-bx .plan-svg-1 svg {
		width: 68px;
		height: 146px;
	}
}
@media only screen and (max-width: 74.9375rem) {
	.plan-bx .plan-svg svg,
	.plan-bx .plan-svg-1 svg {
		width: 6.25rem;
		height: 9.375rem;
	}
}
.plan-bx .plan-svg-1 {
	right: 0.825rem;
	z-index: 1;
}
@media only screen and (max-width: 87.5rem) {
	.plan-bx .plan-svg-1 {
		right: 1.25rem;
	}
}
@media only screen and (max-width: 74.9375rem) {
	.plan-bx .plan-svg-1 {
		right: 2.125rem;
	}
}

.photo-content {
	position: relative;
}
.photo-content .cover-photo {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
	background-size: cover;
	background-position: center;
	min-height: 15.625rem;
	width: 100%;
	border-top-left-radius: 0.375rem;
	border-top-right-radius: 0.375rem;
}

.user {
	cursor: pointer;
}
.user:hover .st-box {
	background-color: var(--primary);
	border-color: var(--primary);
}
.user:hover .st-box svg path {
	fill: #fff;
}
.user:hover a {
	color: var(--primary);
}

.author-profile {
	text-align: center;
}
.author-profile .card-body {
	padding: 0;
}
.author-profile .author-media {
	position: relative;
	margin-left: auto;
	margin-right: auto;
	margin-bottom: 20px;
	display: inline-block;
}
.author-profile .author-media img {
	width: 130px;
	border-radius: 100%;
}
.author-profile .author-info .title {
	font-size: 15px;
	font-weight: 500;
	margin-bottom: 0;
}
.author-profile .author-info span {
	display: block;
	color: #a098ae;
}
.author-profile .info-list li {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 15px;
	border-top: 1px solid #eeeeee;
	padding: 18px 30px;
	color: #303972;
}
.author-profile .info-list li a {
	color: #303972;
}
.author-profile .info-list li span {
	color: #a098ae;
	font-weight: 500;
}
.author-profile .card-footer {
	padding: 30px;
	display: block;
}
.author-profile .card-footer .form-control {
	height: 45px;
	border-color: #eeeeee;
	overflow: hidden;
}
.author-profile .upload-link {
	position: absolute;
	width: 35px;
	height: 35px;
	line-height: 32px;
	background: #395ee2;
	bottom: 0;
	right: 0px;
	box-shadow: 0 0 10px 0 rgba(0, 24, 128, 0.1);
	border-radius: 100%;
	color: #fff;
	overflow: hidden;
	border: 2px solid #fff;
}
.author-profile .upload-link .update-flie {
	position: absolute;
	opacity: 0;
	z-index: 0;
	width: 100%;
	cursor: pointer;
	left: 0;
	height: 100%;
}

.m-b30 {
	margin-bottom: 16px;
}

.timeline-active.style-1 .timeline-list {
	position: relative;
	padding: 1.1rem 0;
}
.timeline-active.style-1 .timeline-list:before {
	top: 2.375rem;
	bottom: 0;
	position: absolute;
	content: ' ';
	width: 0.125rem;
	height: calc(100% - 0.875rem);
	left: 0.463rem;
	margin-right: -0.0938rem;
	background: #dddddd;
}
@media only screen and (max-width: 87.5rem) {
	.timeline-active.style-1 .timeline-list:before {
		left: 0.563rem;
		top: 2.575rem;
	}
}
@media only screen and (max-width: 35.9375rem) {
	.timeline-active.style-1 .timeline-list:before {
		left: 0.463rem;
	}
}
.timeline-active.style-1 .timeline-list .modulel {
	display: flex;
	align-items: center;
}
.timeline-active.style-1 .timeline-list .modulel img {
	width: 17.375rem !important;
	height: 10.125rem;
	border-radius: 0.375rem;
	margin-left: 0.625rem;
	object-fit: cover;
}
@media only screen and (max-width: 87.5rem) {
	.timeline-active.style-1 .timeline-list .modulel img {
		margin-bottom: 0.625rem;
	}
}

.timeline-active.style-1 span,
.timeline-active.style-1 .time {
	font-size: 13px;
	margin-left: 10px;
	margin-bottom: 0;
}

.timeline-active.style-1 .last-timeline {
	padding-top: 19px;
}

/*
===================================
    Product detail
===================================*/
.produtct-detail-tag {
	display: inline-block;
}
.produtct-detail-tag a {
	font-style: 0.8125rem;
	color: #303972;
}

.product-detail-content .item-tag {
	background: #828690;
	border-radius: 0.375rem;
	display: inline-block;
	font-size: 0.75rem;
	margin-right: 0.25rem;
	padding: 0.125rem 0.75rem;
	color: #fff;
}

.product-detail-content input.form-control.input-btn.input-number {
	height: 3rem;
}
@media only screen and (max-width: 87.5rem) {
	.product-detail-content input.form-control.input-btn.input-number {
		height: 2.285rem;
	}
}

.filtaring-area h4,
.filtaring-area .h4 {
	color: #1d1d1d;
	font-size: 1rem;
	font-weight: 400;
	text-transform: lowercase;
}

.plus-minus-input .input-icon {
	font-size: 0.8125rem;
	color: #303972;
}

.plus-minus-input {
	display: flex;
	width: 7.5rem;
}
.plus-minus-input .custom-btn {
	border-radius: 0;
	height: 2.5rem;
	padding: 0.75rem 0.5rem;
	background: #fff;
	border: 0.0625rem solid #f2f2f2;
}
.plus-minus-input .form-control:hover,
.plus-minus-input .form-control:focus,
.plus-minus-input .form-control:active {
	border: 0.0625rem solid #f2f2f2;
}

.btn-reveal-trigger .avatar-xl {
	min-width: 1.875rem;
}

.share-view {
	display: inline-block;
}
.share-view ul li {
	display: inline-block;
}
.share-view .share-icon {
	width: 2.5rem;
	height: 2.5rem;
	display: inline-block;
	border: 0.0625rem solid #f2f2f2;
	text-align: center;
	line-height: 2.5rem;
	font-style: 1rem;
	color: #f2f2f2;
	margin-right: 0.5rem;
}

/*--------tab----------*/
.veritical-line {
	padding: 1.25rem 1.875rem;
	border-top: 0.0625rem solid #f2f2f2;
	border-right: 0.0625rem solid #f2f2f2;
	border-bottom: 0.0625rem solid #f2f2f2;
	position: relative;
}
.veritical-line:before {
	background: #f2f2f2;
	bottom: 0;
	content: '';
	height: 100%;
	left: -0.0625rem;
	max-height: 40%;
	position: absolute;
	width: 0.0625rem;
}

.tab-content-text p {
	color: #303972;
	font-size: 0.8125rem;
	font-weight: 400;
	line-height: 1.5rem;
	margin-bottom: 1.5625rem;
}

.tab-item-list li a {
	background: #fff;
	border-top: 0.0625rem solid #f2f2f2;
	border-left: 0.0625rem solid #f2f2f2;
	border-right: 0.0625rem solid #f2f2f2;
	color: #303972;
	display: block;
	font-size: 1rem;
	padding: 1rem;
	text-transform: uppercase;
}
.tab-item-list li a:hover,
.tab-item-list li a:focus {
	background: #fff;
	color: #303972;
	border-right: 0rem;
}

.tab-item-list li:last-child {
	border-bottom: 0.0625rem solid #f2f2f2;
}

.tab-list li {
	margin-bottom: 0.4375rem;
	font-size: 0.8125rem;
}
.tab-list li i {
	font-size: 0.8125rem;
	margin-right: 0.875rem;
}

.slide-item-list {
	text-align: center;
	margin: 0 -0.3125rem;
	border: 0;
}
.slide-item-list .nav-link {
	border: 0;
}
.slide-item-list .nav-link:hover {
	border: 0;
}
.slide-item-list .nav-link.active {
	border: 0;
	background-color: transparent;
}
.slide-item-list li {
	display: inline-block;
	flex: 0 0 25%;
	width: 25%;
	padding: 0 0.3125rem;
}
.slide-item-list li a {
	display: inline-block;
	padding-left: 0;
	padding-right: 0;
	padding-top: 0;
	background: transparent;
	padding-bottom: 0rem;
}
.slide-item-list li a:hover,
.slide-item-list li a:focus {
	background: transparent;
}
.slide-item-list li a img {
	width: 100%;
	border-radius: 0.375rem;
}

.product-detail-text {
	padding-top: 1.75rem;
	padding-left: 1.875rem;
	padding-right: 1.875rem;
	padding-bottom: 4.375rem;
}

.star-rating .product-review {
	font-style: 0.8125rem;
	color: #303972;
	font-weight: 400;
	text-decoration: underline !important;
}

.product-detail .tab-content img {
	display: inline-block;
	width: 100%;
}

.popular-tag ul {
	margin: 0rem;
	padding: 0rem;
}
.popular-tag ul li {
	display: inline-block;
	padding: 0.5rem 0.9375rem;
	background: #f8f8f8;
	font-size: 0.8125rem;
	color: #fff;
	margin-right: 0.625rem;
	margin-bottom: 0.625rem;
}

.size-filter ul li {
	display: inline-block;
}

.intro {
	border: 0.0625rem solid red;
	color: #1d1d1d;
}

#listResults .slider {
	margin: 1.5625rem 0;
}

#listResults .slider-box {
	width: 90%;
	margin: 1.5625rem auto;
}

#listResults input {
	width: 10%;
}

#listResults label {
	border: none;
	display: inline-block;
	margin-right: -0.25rem;
	vertical-align: top;
	width: 30%;
}

.plus-minus-input .input-icon {
	font-size: 0.8125rem;
	color: #aaaaaa;
}

.plus-minus-input .custom-btn {
	border-radius: 0;
	height: 2.5rem;
	padding: 0.5rem 0.75rem;
	background: #ffffff;
	border: 0.0625rem solid #c8c8c8;
}
.plus-minus-input .custom-btn:hover,
.plus-minus-input .custom-btn:focus,
.plus-minus-input .custom-btn.active {
	box-shadow: none;
	outline: none;
}

.plus-minus-input .form-control {
	height: 2.5rem;
	border-top: 0.0625rem solid #c8c8c8;
	border-bottom: 0.0625rem solid #c8c8c8;
	border-left: 0rem solid #c8c8c8;
	border-right: 0.0625rem solid #c8c8c8;
}
.plus-minus-input .form-control:hover,
.plus-minus-input .form-control:focus,
.plus-minus-input .form-control:active {
	border-top: 0.0625rem solid #c8c8c8;
	border-bottom: 0.0625rem solid #c8c8c8;
	border-left: 0rem solid #c8c8c8;
	border-right: 0rem solid #c8c8c8;
}

.new-arrival-product .new-arrivals-img-contnent {
	overflow: hidden;
	position: relative;
}
.new-arrival-product .new-arrivals-img-contnent img {
	width: 100%;
	transition: all 0.5s;
	border-radius: 0.375rem;
}
.new-arrival-product .new-arrivals-img-contnent:after {
	content: '';
	position: absolute;
	top: 0;
	left: -85%;
	z-index: 2;
	display: block;
	content: '';
	width: 50%;
	height: 100%;
	background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 100%);
	transform: skewX(-25deg);
}

.new-arrival-product .discount {
	font-size: 14px;
	margin-right: 8px;
	opacity: 0.8;
	color: var(--primary);
}

.new-arrival-product:hover .new-arrivals-img-contnent:after {
	webkit-animation: shine 0.75s;
	animation: shine 0.75s;
}

@keyframes shine {
	100% {
		left: 125%;
	}
}

.star-rating {
	margin-bottom: 0.625rem;
}

.select-size .btn:not(:first-child),
.select-size .btn:not(last-child) {
	margin: 0 5px;
	box-shadow: none;
}

.card.product-grid-card .card-body {
	padding: 15px;
}

/*
===================================
    list view
===================================*/
.new-arrival-content .item {
	font-size: 0.75rem;
	color: #000;
}

.new-arrival-content h4,
.new-arrival-content .h4 {
	font-size: 1.25rem;
	font-weight: 600;
	margin-bottom: 0.625rem;
}
@media only screen and (max-width: 35.9375rem) {
	.new-arrival-content h4,
	.new-arrival-content .h4 {
		margin-top: 1rem;
	}
}

.new-arrival-content .price {
	font-weight: 500;
	color: var(--primary);
	font-size: 1.25rem;
	margin-bottom: 0;
	float: right;
}
@media only screen and (max-width: 35.9375rem) {
	.new-arrival-content .price {
		float: none;
		margin-top: 0.625rem;
	}
}

.new-arrival-content p {
	font-size: 0.875rem;
	margin-bottom: 0.375rem;
	line-height: 1.5rem;
}

.new-arrival-content .text-content {
	margin-top: 1.125rem;
}

.new-arrival-content.text-center .price {
	float: unset !important;
}

.success-icon {
	color: #1eba62;
	font-size: 1rem;
}

.comment-review {
	margin-bottom: 0.9375rem;
	display: table;
	width: 100%;
}
.comment-review .client-review {
	color: #7e8dbf;
	padding-right: 1.25rem;
	text-decoration: underline !important;
	font-size: 0.875rem;
}
.comment-review .span {
	color: #7e8dbf;
	font-size: 0.875rem;
}
@media only screen and (max-width: 35.9375rem) {
	.comment-review {
		margin-bottom: 0;
	}
}

.star-rating li {
	display: inline-block;
}
.star-rating li i {
	color: gold;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
	background: #ffffff;
}

.table-responsive .table.order-table thead {
	background-color: #fff;
}
.table-responsive .table.order-table thead th {
	color: #303972;
	font-weight: 600;
}
.table-responsive .table.order-table thead th:first-child {
	border-top-left-radius: 0.375rem;
}
.table-responsive .table.order-table thead th:last-child {
	border-top-right-radius: 0.375rem;
}

:root {
	--primary: #4d44b5;
	--secondary: #fb7d5b;
	--primary-hover: #3d3690;
	--primary-dark: #1e1a46;
	--rgba-primary-1: rgba(77, 68, 181, 0.1);
	--rgba-primary-2: rgba(77, 68, 181, 0.2);
	--rgba-primary-3: rgba(77, 68, 181, 0.3);
	--rgba-primary-4: rgba(77, 68, 181, 0.4);
	--rgba-primary-5: rgba(77, 68, 181, 0.5);
	--rgba-primary-6: rgba(77, 68, 181, 0.6);
	--rgba-primary-7: rgba(77, 68, 181, 0.7);
	--rgba-primary-8: rgba(77, 68, 181, 0.8);
	--rgba-primary-9: rgba(77, 68, 181, 0.9);
	--rgba-secondary-1: rgba(251, 125, 91, 0.1);
	--rgba-secondary-2: rgba(251, 125, 91, 0.2);
	--rgba-secondary-3: rgba(251, 125, 91, 0.3);
	--rgba-secondary-4: rgba(251, 125, 91, 0.4);
	--rgba-secondary-5: rgba(251, 125, 91, 0.5);
	--rgba-secondary-6: rgba(251, 125, 91, 0.6);
	--rgba-secondary-7: rgba(251, 125, 91, 0.7);
	--rgba-secondary-8: rgba(251, 125, 91, 0.8);
	--rgba-secondary-9: rgba(251, 125, 91, 0.9);
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--font-family-base: Poppins, sans-serif;
	--font-family-title: Poppins, sans-serif;
	--title: #303972;
}

[data-theme-version='dark'] {
	background: #202020;
	color: rgba(255, 255, 255, 0.6);
	--nav-headbg: #272738;
	--sidebar-bg: #202020;
	--headerbg: #272738;
}
[data-theme-version='dark'] h1,
[data-theme-version='dark'] .h1,
[data-theme-version='dark'] h2,
[data-theme-version='dark'] .h2,
[data-theme-version='dark'] h3,
[data-theme-version='dark'] .h3,
[data-theme-version='dark'] h4,
[data-theme-version='dark'] .h4,
[data-theme-version='dark'] h5,
[data-theme-version='dark'] .h5,
[data-theme-version='dark'] h6,
[data-theme-version='dark'] .h6 {
	color: #fff !important;
}
[data-theme-version='dark'] a.link {
	color: #ddd;
}
[data-theme-version='dark'] a.link:focus,
[data-theme-version='dark'] a.link:hover {
	color: #00ada3;
}
[data-theme-version='dark'] a:hover {
	color: #fff;
}
[data-theme-version='dark'] .border-right {
	border-right: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;
}
[data-theme-version='dark'] .border-left {
	border-left: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;
}
[data-theme-version='dark'] .border-top {
	border-top: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;
}
[data-theme-version='dark'] .border-bottom {
	border-bottom: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;
}
[data-theme-version='dark'] .border {
	border: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .card {
	background-color: #272738;
	box-shadow: none;
}

[data-theme-version='dark'] .dropdown-menu {
	background-color: #272738;
	box-shadow: 0rem 0rem 0rem 0.0625rem rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .dropdown-menu .dropdown-item {
	color: #777777;
}
[data-theme-version='dark'] .dropdown-menu .dropdown-item.selected,
[data-theme-version='dark'] .dropdown-menu .dropdown-item.selected.active,
[data-theme-version='dark'] .dropdown-menu .dropdown-item.active,
[data-theme-version='dark'] .dropdown-menu .dropdown-item:hover,
[data-theme-version='dark'] .dropdown-menu .dropdown-item:focus {
	background-color: #272738;
	color: #fff;
}

[data-theme-version='dark'] a {
	color: #fff;
}

[data-theme-version='dark'] .btn-link g [fill] {
	fill: #fff;
}

[data-theme-version='dark'] .btn-light:active,
[data-theme-version='dark'] .btn-light:focus,
[data-theme-version='dark'] .btn-light:hover {
	color: #000;
}

[data-theme-version='dark'] .form-control {
	background-color: #202020;
	border-color: rgba(255, 255, 255, 0.1);
	color: #fff;
}

[data-theme-version='dark'] .modal-content {
	background: #272738;
}

[data-theme-version='dark'] .modal-footer,
[data-theme-version='dark'] .modal-header {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .close {
	font-weight: 400;
	color: #fff;
	text-shadow: none;
}
[data-theme-version='dark'] .close:hover {
	color: #fff;
}

[data-theme-version='dark'] .star-rating .product-review,
[data-theme-version='dark'] .new-arrival-content .item {
	color: #fff;
}

[data-theme-version='dark'] .custom-dropdown .dropdown-menu {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .widget-stat .media > span {
	background: rgba(255, 255, 255, 0.1);
	border-color: rgba(255, 255, 255, 0.1);
	color: #fff;
}

[data-theme-version='dark'] .plus-minus-input .custom-btn {
	background: #202020;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dropdown-divider,
[data-theme-version='dark'] .size-filter ul li {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .custom-select {
	border-color: rgba(255, 255, 255, 0.1);
	color: #7e8dbf;
	background: #202020;
}

[data-theme-version='dark'] .nav-tabs {
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .mail-list .list-group-item.active i {
	color: #fff;
}

[data-theme-version='dark'] hr {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .grid-col {
	background: #202020;
}

[data-theme-version='dark'] .noUi-target {
	border-color: rgba(255, 255, 255, 0.1);
	border-radius: 0.5rem;
	box-shadow: none;
}
[data-theme-version='dark'] .noUi-target .noUi-connects {
	background: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .noUi-marker-large,
[data-theme-version='dark'] .noUi-marker {
	background: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .input-group-text {
	background: #272738;
	color: #fff;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .note-editor.note-frame {
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .note-editor.note-frame .btn {
	color: #fff;
}
[data-theme-version='dark'] .note-editor.note-frame .note-editing-area .note-editable {
	color: #fff;
}

[data-theme-version='dark'] .widget-media .timeline .timeline-panel {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .notification_dropdown .dropdown-menu-right .all-notification {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] #user-activity .nav-tabs .nav-link {
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] #user-activity .nav-tabs .nav-link.active {
	background: #202020;
	color: #fff;
}

[data-theme-version='dark'] .list-group-item-action {
	color: #a098ae;
}

[data-theme-version='dark'] .list-group-item-action:focus,
[data-theme-version='dark'] .list-group-item-action:hover,
[data-theme-version='dark'] .list-group-item-action:focus {
	background-color: #202020;
	border-color: #202020;
}

[data-theme-version='dark'] .list-group-item.active {
	color: #fff;
	border-color: var(--primary);
}
[data-theme-version='dark'] .list-group-item.active:focus,
[data-theme-version='dark'] .list-group-item.active:hover,
[data-theme-version='dark'] .list-group-item.active:focus {
	background-color: var(--primary);
	border-color: var(--primary);
	color: #fff;
}

[data-theme-version='dark'] .swal2-popup {
	background: #272738;
}

[data-theme-version='dark'] .form-head .btn-outline-primary {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .form-head .btn-outline-primary:hover {
	border-color: var(--primary);
}

[data-theme-version='dark'] .review-tab.nav-pills li a.nav-link.active {
	background: transparent;
}

[data-theme-version='dark'] .new-arrival-content h4 a,
[data-theme-version='dark'] .new-arrival-content .h4 a {
	color: #fff;
}

[data-theme-version='dark'] .text-black {
	color: #fff !important;
}

[data-theme-version='dark'] .abilities-chart .ct-chart .ct-label {
	fill: #fff;
}

[data-theme-version='dark'] .morris_chart_height text tspan {
	fill: #fff;
}

[data-theme-version='dark'] .btn-link {
	color: #fff;
}
[data-theme-version='dark'] .btn-link svg path {
	stroke: #fff;
}

[data-theme-version='dark'] .order-bg {
	background: #202020;
}

[data-theme-version='dark'] .detault-daterange {
	background: #202020;
	color: #fff;
}
[data-theme-version='dark'] .detault-daterange .input-group-text {
	background: #272738;
	border: 0;
}

[data-theme-version='dark'] .dataTablesCard {
	background-color: #272738;
}

[data-theme-version='dark'] .compose-content .dropzone {
	background: #202020 !important;
}
[data-theme-version='dark'] .compose-content .dropzone .dlab-message .dlab-button {
	color: #fff;
}

[data-theme-version='dark'] .daterangepicker {
	background: #202020;
	border-color: var(--primary);
}
[data-theme-version='dark'] .daterangepicker .calendar-table {
	border-color: var(--primary);
	background: #202020;
}
[data-theme-version='dark'] .daterangepicker .calendar-table .table-condensed td:hover {
	background-color: var(--primary);
	color: #fff;
}
[data-theme-version='dark'] .daterangepicker:after {
	border-bottom: 0.375rem solid #202020;
}

[data-theme-version='dark'] .daterangepicker select.hourselect,
[data-theme-version='dark'] .daterangepicker select.minuteselect,
[data-theme-version='dark'] .daterangepicker select.secondselect,
[data-theme-version='dark'] .daterangepicker select.ampmselect {
	background: #202020;
	border: 0.0625rem solid rgba(255, 255, 255, 0.1);
	color: #fff;
}

[data-theme-version='dark'] .daterangepicker td.off,
[data-theme-version='dark'] .daterangepicker td.off.in-range,
[data-theme-version='dark'] .daterangepicker td.off.start-date,
[data-theme-version='dark'] .daterangepicker td.off.end-date {
	background-color: #272738;
}
[data-theme-version='dark'] .daterangepicker td.off:hover,
[data-theme-version='dark'] .daterangepicker td.off.in-range:hover,
[data-theme-version='dark'] .daterangepicker td.off.start-date:hover,
[data-theme-version='dark'] .daterangepicker td.off.end-date:hover {
	background-color: var(--primary);
	color: #fff;
}

[data-theme-version='dark'] .round .checkmark {
	background-color: #202020;
}

[data-theme-version='dark'] .round:hover input ~ .checkmark {
	background-color: #202020;
}

[data-theme-version='dark'] .round span {
	color: #fff;
}

[data-theme-version='dark'] .app-fullcalendar .fc-button {
	background-color: #202020;
	border-color: var(--primary);
	color: #fff;
	text-shadow: none;
}
[data-theme-version='dark'] .app-fullcalendar .fc-button:hover,
[data-theme-version='dark'] .app-fullcalendar .fc-button.fc-stat-hover {
	background-color: var(--primary);
}

[data-theme-version='dark'] .swal2-popup .swal2-styled:focus {
	outline: 0;
	box-shadow: 0 0 0 0.125rem rgba(255, 255, 255, 0.1), 0 0 0 0.25rem var(--rgba-primary-1);
}

[data-theme-version='dark'] .dd-handle {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul {
	background: #272738 !important;
}

[data-theme-version='dark'] .header-right .notification_dropdown .nav-link {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .nav-tabs .nav-link:hover,
[data-theme-version='dark'] .nav-tabs .nav-link.active {
	border-color: transparent;
	background: transparent;
	color: white !important;
}

[data-theme-version='dark'] .clockpicker-popover .popover-content {
	background-color: #272738;
}

[data-theme-version='dark'] .clockpicker-plate {
	background-color: #202020;
}

[data-theme-version='dark'] .clockpicker-popover .popover-title {
	background-color: #202020;
	color: #fff;
}

[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link span {
	background-color: #202020;
}

[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link:after {
	background: #202020;
}

[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.active:after,
[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.done:after {
	background: var(--primary);
}

[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.active span,
[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.done span {
	background: var(--primary);
}

[data-theme-version='dark'] .check-switch .custom-control-label:after,
[data-theme-version='dark'] .check-switch .custom-control-label:before {
	border-color: var(--primary);
}

[data-theme-version='dark'] .fc-unthemed .fc-today {
	background: #202020;
}

[data-theme-version='dark'] .fc-unthemed .fc-divider,
[data-theme-version='dark'] .fc-unthemed .fc-list-heading td,
[data-theme-version='dark'] .fc-unthemed .fc-popover .fc-header {
	background: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .picker__box {
	background: #202020;
}
[data-theme-version='dark'] .picker__box .picker__button--clear,
[data-theme-version='dark'] .picker__box .picker__button--close,
[data-theme-version='dark'] .picker__box .picker__button--today {
	background: #272738;
	color: #fff;
}
[data-theme-version='dark'] .picker__box .picker__button--clear:hover:before,
[data-theme-version='dark'] .picker__box .picker__button--close:hover:before,
[data-theme-version='dark'] .picker__box .picker__button--today:hover:before {
	color: #fff;
}

[data-theme-version='dark'] .picker {
	color: #999;
}

[data-theme-version='dark'] .dtp > .dtp-content {
	background: #202020;
}

[data-theme-version='dark'] .dtp table.dtp-picker-days tr > td > a {
	color: #68686a;
}
[data-theme-version='dark'] .dtp table.dtp-picker-days tr > td > a.selected {
	color: #fff;
}

[data-theme-version='dark'] .order-request tbody tr {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .card-list li {
	color: #fff;
}

[data-theme-version='dark'] .card-bx .change-btn:hover {
	color: var(--primary);
}

[data-theme-version='dark'] .invoice-card.bg-warning {
	background-color: #5b3c1f !important;
}

[data-theme-version='dark'] .invoice-card.bg-success {
	background-color: #2a6729 !important;
}

[data-theme-version='dark'] .invoice-card.bg-info {
	background-color: #4c276a !important;
}

[data-theme-version='dark'] .invoice-card.bg-secondary {
	background-color: #1c3e52 !important;
}

[data-theme-version='dark'] .user-list li {
	border-color: #272738;
}

[data-theme-version='dark'] .toggle-switch {
	color: #fff;
}

[data-theme-version='dark'] .bar-chart .apexcharts-text tspan {
	fill: #969ba0;
}

[data-theme-version='dark'] .bar-chart line {
	stroke: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .accordion.style-1 .accordion-item,
[data-theme-version='dark'] .invoice-list,
[data-theme-version='dark'] .form-check-input[type='checkbox'] {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .accordion.style-1 .accordion-header.collapsed .user-info a,
[data-theme-version='dark'] .accordion.style-1 .accordion-header.collapsed .user-info,
[data-theme-version='dark'] .accordion.style-1 .accordion-header.collapsed > span {
	color: #fff;
}

[data-theme-version='dark'] .ic-card > a {
	background: #25479f;
}
[data-theme-version='dark'] .ic-card > a:first-child {
	border-color: #25479f;
}

[data-theme-version='dark'] .ic-card span {
	color: #fff;
}

[data-theme-version='dark'] table.dataTable thead th,
[data-theme-version='dark'] table.dataTable thead td {
	border-color: #272738 !important;
}

[data-theme-version='dark'] .form-check .form-check-input:checked {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

[data-theme-version='dark'] .dataTables_info {
	color: #fff;
}

[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate span .paginate_button.current,
[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate span .paginate_button:hover {
	background: var(--primary);
	color: #fff !important;
}

[data-theme-version='dark'] .dashboard-select {
	background: #272738;
	color: white !important;
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .dashboard-select .list {
	background: #272738;
}

[data-theme-version='dark'] .dashboard-select .option:hover,
[data-theme-version='dark'] .dashboard-select .option.focus,
[data-theme-version='dark'] .dashboard-select .option.selected.focus {
	background: #202020;
}

[data-theme-version='dark'] .card-tabs.style-1 .nav-tabs {
	background: #272738;
}

[data-theme-version='dark'] .transaction-details {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .description {
	color: #fff;
}

[data-theme-version='dark'] .apexcharts-legend-text {
	color: #fff !important;
}

[data-theme-version='dark'] .area-theme line {
	stroke: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .transaction-details .amount-bx {
	background: #272738;
}
[data-theme-version='dark'] .transaction-details .amount-bx i {
	background: #8d3b0c;
}

[data-theme-version='dark'] .nice-select .option {
	background: #272738;
}

[data-theme-version='dark'] .nice-select .option:hover,
[data-theme-version='dark'] .nice-select .option.focus,
[data-theme-version='dark'] .nice-select .option.selected.focus {
	background: #272738;
}

[data-theme-version='dark'] .card-tabs.style-1 {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .nice-select .list {
	background: #202020;
}

[data-theme-version='dark'] .table-search .input-group .input-group-text {
	background: #272738;
}

[data-theme-version='dark'] .dark-btn svg path {
	stroke: #fff;
}

[data-theme-version='dark'] .bar-chart .apexcharts-legend-text {
	color: #fff !important;
}

[data-theme-version='dark'] .Sales tspan {
	fill: #fff;
}

[data-theme-version='dark'] .timeline-chart rect {
	fill: #202020;
}

[data-theme-version='dark'] .header-info span {
	color: #fff !important;
}

[data-theme-version='dark'] .ck-editor__editable {
	background: #202020 !important;
}

[data-theme-version='dark'] .ck.ck-editor .ck.ck-toolbar {
	background: #272738;
}

[data-theme-version='dark'] .ck.ck-toolbar .ck.ck-toolbar__separator {
	background: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .search-area .form-control {
	background: #202020;
	border: none;
}
[data-theme-version='dark'] .search-area .form-control:hover {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .search-area .input-group-text {
	background: #202020;
	border: none;
}

[data-theme-version='dark'] .chartBarRunning tspan {
	fill: #fff;
}

[data-theme-version='dark'] .chartBarRunning line {
	stroke: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .reservationChart tspan {
	fill: #fff;
}

[data-theme-version='dark'] .reservationChart line {
	stroke: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .table-condensed i:hover {
	background: #272738;
}

[data-theme-version='dark'] .booking-calender thead .picker-switch {
	color: #fff;
}
[data-theme-version='dark'] .booking-calender thead .picker-switch:hover {
	background: #272738;
}

[data-theme-version='dark'] .booking-calender .prev:hover,
[data-theme-version='dark'] .booking-calender .next:hover {
	background: #272738;
}

[data-theme-version='dark'] .dlabnav .header-info2 span {
	color: #fff;
}

[data-theme-version='dark'] .booking-calender tbody tr .day {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .booking-calender thead .dow {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .customer-search .search-area .form-control {
	background: #272738;
}

[data-theme-version='dark'] .customer-search .search-area .input-group-text {
	background: #272738;
}

[data-theme-version='dark'] .paging_simple_numbers.dataTables_paginate {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .primary-icon path {
	stroke: #fff;
}

[data-theme-version='dark'] .pagin {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .nav-header .brand-title .brand-sub-title {
	color: #fff;
}

[data-theme-version='dark'] .dashboard-calendar .fc-daygrid-day-frame.fc-scrollgrid-sync-inner {
	background: #272738;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dashboard-calendar .fc-non-business {
	background: #272738;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dashboard-calendar .fc-daygrid-day-number {
	color: #fff;
}

[data-theme-version='dark'] .event-calend .fc .fc-button-group > .fc-button {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dashboard-calendar .fc-theme-standard td,
[data-theme-version='dark'] .dashboard-calendar .fc-theme-standard th {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dashboard-calendar .fc .fc-daygrid-more-link {
	color: #fff;
}

[data-theme-version='dark'] .fc-theme-standard td,
[data-theme-version='dark'] .fc-theme-standard th {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .fc-theme-standard .fc-scrollgrid.fc-scrollgrid-liquid,
[data-theme-version='dark'] .fc-scrollgrid,
[data-theme-version='dark'] table {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .fc-direction-ltr .fc-daygrid-event.fc-event-end,
[data-theme-version='dark'] .fc-direction-rtl .fc-daygrid-event.fc-event-start {
	background: var(--primary);
}

[data-theme-version='dark'] .dlab-demo-panel .dlab-demo-inner {
	background: #202020;
}

[data-theme-version='dark'] .food-list-row {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .popover-body {
	color: #fff;
}

[data-theme-version='dark'] .swal2-popup .swal2-content {
	color: #fff;
}

[data-theme-version='dark'] .modal-header .close {
	background: none;
}

[data-theme-version='dark'] .timeline-panel .media-body small,
[data-theme-version='dark'] .timeline-panel .media-body .small {
	color: #fff;
}

[data-theme-version='dark'] .chatbox .card-header p {
	color: #fff;
}

[data-theme-version='dark'] .date-ds-btn {
	background: #272738;
	color: white;
}

[data-theme-version='dark'] .food-list-row .media-bx h5 a,
[data-theme-version='dark'] .food-list-row .media-bx .h5 a,
[data-theme-version='dark'] .food-list-row .media-bx .h5 a {
	color: #fff;
}

[data-theme-version='dark'] .staff-bx .card-footer {
	background: #3f4056;
}

[data-theme-version='dark'] .page-titles .breadcrumb .breadcrumb-item + .breadcrumb-item:before {
	color: #fff;
}

[data-theme-version='dark'] .table-striped > tbody > tr:nth-of-type(odd) > * {
	color: #706f6f;
}

[data-theme-version='dark'] .accordion .accordion-item {
	background: transparent;
}

[data-theme-version='dark'] .list-group-item {
	color: #fff;
}

[data-theme-version='dark'] .form-control-plaintext {
	color: #fff;
}

[data-theme-version='dark'] label {
	color: #fff;
}

[data-theme-version='dark'] .form-control.custom-image-select-2 .filter-option-inner-inner {
	color: #fff;
}

[data-theme-version='dark'] .table tbody tr td {
	color: #7e8dbf;
}

[data-theme-version='dark'] .wallet-bar .order-history .price-list .chart-title .text-secondary {
	color: var(--secondary) !important;
}

[data-theme-version='dark'] .apexcharts-text tspan {
	fill: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .apexcharts-xaxis line {
	stroke: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .price-list .card-footer .text-secondary {
	color: var(--primary) !important;
}

[data-theme-version='dark'] .chart-title .text-pink {
	color: #eb62d0 !important;
}

[data-theme-version='dark'] .form-control.custom-image-select-2.style-1 .dropdown-toggle {
	background: rgba(172, 76, 188, 0.1) !important;
}

[data-theme-version='dark'] .form-control.custom-image-select-2 .dropdown-toggle {
	background: var(--rgba-primary-2) !important;
}

[data-theme-version='dark'] .transaction-table .card-body .table-responsive thead th {
	background: #202020;
	color: #fff;
}

[data-theme-version='dark'] .market-chart .text-secondary {
	color: var(--secondary) !important;
}
[data-theme-version='dark'] .market-chart .text-secondary svg path {
	fill: var(--secondary);
}

[data-theme-version='dark'] .chart-title p {
	color: #7e8dbf;
}

[data-theme-version='dark'] .market-coin .coin-search-area .form-control {
	border-color: #272738;
	background: #272738;
}

[data-theme-version='dark'] .market-coin .coin-search-area .input-group-text {
	border-color: #272738;
	background: #272738;
}
[data-theme-version='dark'] .market-coin .coin-search-area .input-group-text svg path {
	fill: #fff;
}

[data-theme-version='dark'] .market-coin .coin-box {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .market-overview .get-report {
	color: var(--primary) !important;
}

[data-theme-version='dark'] .coin-content .guest-calendar {
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .coin-content .guest-calendar span svg path {
	fill: #fff;
}
[data-theme-version='dark'] .coin-content .guest-calendar .reportrange span {
	color: #7e8dbf;
}

[data-theme-version='dark'] .coin-content .default-select {
	border-color: rgba(255, 255, 255, 0.1);
	color: #7e8dbf;
}

[data-theme-version='dark'] .digital-cash .media .media-content p {
	border-color: rgba(255, 255, 255, 0.1);
	color: #7e8dbf;
}

[data-theme-version='dark'] .digital-cash .card-footer .btn {
	color: var(--primary) !important;
}

[data-theme-version='dark'] .form-control.custom-image-select-1 .dropdown-toggle {
	background: #202020 !important;
	color: #fff !important;
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .form-control.custom-image-select-1 .filter-option-inner-inner {
	color: #fff;
}

[data-theme-version='dark'] .coin-warpper .search-area .form-control {
	color: #7e8dbf;
}

[data-theme-version='dark'] .coin-warpper .search-area .input-group-text svg path {
	fill: #fff;
}

[data-theme-version='dark'] .form-wrapper.trade-form .input-group .input-group-text {
	background: #202020;
	color: #7e8dbf;
}

[data-theme-version='dark'] .market-overview .get-report,
[data-theme-version='dark'] .market-preview,
[data-theme-version='dark'] .market-overview .card-header h4,
[data-theme-version='dark'] .market-overview .card-header .h4,
[data-theme-version='dark'] .market-overview .card-header .h4,
[data-theme-version='dark'] .form-wrapper.trade-form .input-group .form-control:focus,
[data-theme-version='dark'] .coin-warpper .nav .nav-item {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .coin-warpper {
	background: #272738;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .coin-warpper .nav .nav-item .nav-link svg path {
	fill: #fff;
}

[data-theme-version='dark'] .daterangepicker .calendar-table .next span,
[data-theme-version='dark'] .daterangepicker .calendar-table .prev span {
	border-color: #fff;
}

[data-theme-version='dark'] .tbl-orders-style .tp-btn svg path {
	stroke: #fff;
}

[data-theme-version='dark'] .customer-search .search-area .input-group-text svg path {
	fill: #fff;
}

[data-theme-version='dark'] .student-tbl tbody tr td span .text-secondary {
	color: #fff !important;
}

[data-theme-version='dark'] .market-preview:hover {
	background: #202020;
}

[data-theme-version='dark'] .bg-ripple-hover thead tr th {
	color: #677686;
}

[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate span .paginate_button {
	color: #7e8dbf !important;
}

[data-theme-version='dark'] .portofolio .my-profile .media .media-img a,
[data-theme-version='dark'] .portofolio .my-profile .portofolio-social li a {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .coin-holding {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .tp-btn svg path {
	stroke: #fff;
}

[data-theme-version='dark'] .copyright strong {
	color: #9fa4a6;
}

[data-theme-version='dark'] .support-box .info a {
	color: #000 !important;
}

[data-theme-version='dark'] .btn-icon-end {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .donut-chart-sale small,
[data-theme-version='dark'] .donut-chart-sale .small,
[data-theme-version='dark'] .donut-chart-sale .small,
[data-theme-version='dark'] .donut-chart-sale .small {
	color: #fff;
}

[data-theme-version='dark'] .border-end {
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .ck.ck-editor__main > .ck-editor__editable {
	background: #202020 !important;
}

[data-theme-version='dark'] .change-btn a:hover {
	color: #000;
}

[data-theme-version='dark'] .dlabnav .main-menu {
	color: #fff;
}

[data-theme-version='dark'] .nav-pills .nav-link.active,
[data-theme-version='dark'] .nav-pills:hover .show > .nav-link {
	background: var(--rgba-secondary-1);
	color: var(--secondary);
}

[data-theme-version='dark'] .toggle-switch .form-check-input:checked:after {
	background: var(--secondary);
}

[data-theme-version='dark'] .nav-pills .nav-link:hover {
	color: var(--secondary);
}

[data-theme-version='dark'] .table.bg-primary-hover th {
	color: var(--secondary);
}

[data-theme-version='dark'] .table.bg-primary-hover tr:hover td,
[data-theme-version='dark'] .table.bg-primary-hover tr:hover th {
	background: var(--secondary);
}

[data-theme-version='dark'] .get-report {
	color: var(--secondary);
}

[data-theme-version='dark'] .btn-close {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}

[data-theme-version='dark'] .coin-holding .coin-box-warper a {
	background: #202020;
}

[data-theme-version='dark'] .card .card-box-icon {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .toggle-btn .check {
	background-color: #202020;
}

[data-theme-version='dark'] .toggle-btn .check:after {
	background: #fff;
}

[data-theme-version='dark'] .toggle-btn input:checked ~ .check:after {
	display: block;
}

[data-theme-version='dark'] .toggle-btn input:checked ~ .check {
	background-color: #202020;
}

[data-theme-version='dark'] .toggle-btn.expense .check:after {
	background-color: #fffa6f;
}

[data-theme-version='dark'] .bootstrap-select .btn {
	color: #fff;
}

[data-theme-version='dark'] #wallet-bar {
	background-color: #272738;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .page-titles {
	background: #272738;
}

[data-theme-version='dark'] .tags .tag {
	color: #fff;
	background: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .server-content .progress {
	background-color: transparent;
}

[data-theme-version='dark'] .student .indox a::before {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] #redial circle {
	fill: white;
}

[data-theme-version='dark'] .dashboard-select .bootstrap-select .btn {
	background: #383844;
}

[data-theme-version='dark'] #activity line {
	stroke: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .quick-info {
	background-color: #202020;
	border: 1px solid rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .pagination.no-bg li:not(.page-indicator):not(.active) .page-link {
	background: #202020;
	border-color: transparent;
}

[data-theme-version='dark'] .lastest_trans .trans-table .doller,
[data-theme-version='dark'] .table-pagenation p span,
[data-theme-version='dark'] .email-list .message .hader,
[data-theme-version='dark'] .email-list .message .col-mail-2 .date,
[data-theme-version='dark'] .dz-card .card-footer {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .email-list .message:hover {
	background: #272738;
}

[data-theme-version='dark'] .print svg path {
	fill: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .right-box-padding.border-start {
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .demo-right-inner {
	background-color: #272738;
}

[data-theme-version='dark'] .dzm-tabs {
	background-color: #202020;
}

[data-theme-version='dark'] .notification p {
	color: #000;
}

[data-theme-version='dark'] .Modal-box {
	background-color: #272738;
}

[data-theme-version='dark'] .Modal-box .box3 {
	background-color: #202020;
}

[data-theme-version='dark'] .lastest_trans .trans-table .print,
[data-theme-version='dark'] .lastest_trans .trans-table .btn.tp-btn.btn-primary {
	background-color: #202020;
}

[data-theme-version='dark'] .lastest_trans .trans-table .btn.tp-btn.btn-primary {
	background-color: #202020;
}
[data-theme-version='dark'] .lastest_trans .trans-table .btn.tp-btn.btn-primary svg circle {
	fill: #fff;
}

[data-theme-version='dark'] .lastest_trans .trans-table:hover {
	background-color: #202020;
}

[data-theme-version='dark'] .previews-info:hover {
	background-color: #202020;
}

[data-theme-version='dark'] #activity1 line {
	stroke: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button.previous.disabled,
[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button.next.disabled {
	color: #fff !important;
}

[data-theme-version='dark'] .plus-bx a {
	background: #272738;
}

[data-theme-version='dark'] .kanbanimg li span,
[data-theme-version='dark'] .kanbanimg img {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .drive,
[data-theme-version='dark'] .file-header,
[data-theme-version='dark'] .folder-structure li,
[data-theme-version='dark'] .file-drive,
[data-theme-version='dark'] .input-group.search-area,
[data-theme-version='dark'] .user-photo img,
[data-theme-version='dark'] .messages .student,
[data-theme-version='dark'] .fc .fc-button-group > .fc-button,
[data-theme-version='dark'] .fc-daygrid-dot-event,
[data-theme-version='dark'] .box-2 .flow,
[data-theme-version='dark'] .type-massage,
[data-theme-version='dark'] .chat-box-area .media .message-received .dz-media,
[data-theme-version='dark'] .chat-left-area .chat-sidebar,
[data-theme-version='dark'] .email-right-box .table-pagenation,
[data-theme-version='dark'] .email-list .message {
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .timeline-active li:before {
	background: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .selling .form_exchange .input_exchange .input-select {
	background-color: #272738;
	border-color: rgba(255, 255, 255, 0.1);
	color: #fff;
}

[data-theme-version='dark'] .hamburger svg rect {
	fill: #fff;
}

[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a {
	color: #fff !important;
}

[data-theme-version='dark'] .file_area .table-pagenation {
	background-color: #202020;
}

[data-theme-version='dark'] .email-list {
	background: #202020;
}

[data-theme-version='dark'] .email-list .message .col-mail-2 .subject {
	color: #fff;
}

[data-theme-version='dark'] .email-right-box .table-pagenation,
[data-theme-version='dark'] .email-right-box .pagination {
	background-color: #272738;
}

[data-theme-version='dark'] .email-left-box .mail-list a {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .messages .input-group.search-area input.form-control,
[data-theme-version='dark'] .messages .input-group.search-area .input-group-text {
	background-color: #202020;
}

[data-theme-version='dark'] .dz-info svg path {
	fill: #fff;
}

[data-theme-version='dark'] .message-box,
[data-theme-version='dark'] .type-massage,
[data-theme-version='dark'] .chat-box-area .media {
	background: #272738;
	color: white;
}

[data-theme-version='dark'] .chat-tabs .chat-bx:after,
[data-theme-version='dark'] .message-box .input-group.search-area input.form-control,
[data-theme-version='dark'] .message-box .input-group.search-area .input-group-text {
	background: #202020;
}

[data-theme-version='dark'] .search-coundry {
	background-color: #272738;
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .search-coundry .bootstrap-select .btn {
	background: #272738 !important;
	color: #fff;
}

[data-theme-version='dark'] .header.is-fixed {
	background: var(--headerbg);
}

[data-theme-version='dark'] .datepicker.datepicker-dropdown th.datepicker-switch {
	color: rgba(255, 255, 255, 0.6);
}
[data-theme-version='dark'] .datepicker.datepicker-dropdown th.datepicker-switch:hover {
	color: #000;
}

[data-theme-version='dark'] .datepicker.datepicker-dropdown {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .datepicker.datepicker-dropdown .datepicker-days .table-condensed td.day {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .notification_dropdown .dropdown-menu-end .all-notification {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .header-profile2 .dropdown-menu a span {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .profile-card .card-header,
[data-theme-version='dark'] .profile-card {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .profile-form .form-label {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .author-profile .info-list li,
[data-theme-version='dark'] .profile-card .card-footer,
[data-theme-version='dark'] .author-profile .upload-link {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .author-profile .info-list li a,
[data-theme-version='dark'] .author-profile .author-info span,
[data-theme-version='dark'] .author-profile .info-list li span {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .author-profile .card-footer .form-control {
	border-color: rgba(255, 255, 255, 0.1);
	background: #202020 !important;
}

[data-theme-version='dark'] .header-profile2 .dropdown-menu .ai-icon:hover {
	background: #202020;
}

[data-theme-version='dark'] .wallet-bar .closed-icon {
	color: #fff;
}

[data-theme-version='dark'] .select2-container--default .select2-selection--multiple .select2-selection__choice,
[data-theme-version='dark'] .select2-container--classic .select2-selection--multiple .select2-selection__choice {
	background-color: #272738;
	border-color: #272738;
}

[data-theme-version='dark'] mark,
[data-theme-version='dark'] .mark,
[data-theme-version='dark'] .mark,
[data-theme-version='dark'] .select2-container--classic .select2-search--inline .select2-search__field {
	background-color: #202020;
	color: #fff;
}

[data-theme-version='dark'] .select2-container--default .select2-search--inline .select2-search__field {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .select2-container--default .select2-results__option[aria-selected='true'] {
	background-color: #202020;
}

[data-theme-version='dark'] .trans-info .icon {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .legendLabel {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .statistic-content {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] p {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .header-profile2 span {
	color: rgba(255, 255, 255, 0.6);
}

[data-theme-version='dark'] .page-titles .datepicker.datepicker-dropdown th.prev:hover {
	color: #fff !important;
}

[data-theme-version='dark'] .compose-content .dropzone {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] #alert-link a {
	color: #768783;
}

[data-theme-version='dark'] #message-alert p {
	color: #666666;
}

[data-theme-version='dark'] #AlertLeftIcon h5,
[data-theme-version='dark'] #AlertLeftIcon .h5 {
	color: #2a353a !important;
}

[data-theme-version='dark'] #AlertLeftIcon p {
	color: #666666;
}

[data-theme-version='dark'] .header.is-fixed {
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .sidebar-right-inner .bootstrap-select .btn {
	background: transparent !important;
	color: #2a353a;
	border-color: #eeeeee !important;
}

[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu {
	background-color: #fff;
}
[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item {
	color: #777777;
}
[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item.selected,
[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item.selected.active,
[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item.active,
[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item:hover,
[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item:focus {
	background-color: var(--rgba-primary-1);
	color: #2a353a;
}

[data-theme-version='dark'] .type_msg .form-control {
	background-color: #272738;
	box-shadow: none;
}

[data-theme-version='dark'] .email-left-box {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .alert .btn-close {
	background-image: none !important;
}

[data-theme-version='dark'] #main-wrapper {
	background-color: #202020;
}

[data-theme-version='dark'] .prot-blog .fill a:hover {
	color: black;
}

[data-theme-version='dark'] .table-striped > tbody > tr:nth-of-type(odd) > * {
	background: #1e1e25;
	color: white !important;
}

[data-theme-version='dark'] .dlabnav {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .kanban-user .users li span,
[data-theme-version='dark'] .kanban-user .users li img {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .plus-bx a svg path {
	fill: #fff;
}

[data-theme-version='dark'] .page-title {
	background-color: #272738;
}

[data-theme-version='dark'] .chat-mid-area.bg-white {
	background-color: #272738 !important;
}

[data-theme-version='dark'] .message-box {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .message-received p {
	background-color: #202020 !important;
	color: #fff !important;
}

[data-theme-version='dark'] .input-group.user-search-area .input-group-text {
	background-color: #202020;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .input-group.user-search-area .form-control {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .datepicker-days .table-condensed td.day {
	color: #fff;
}

[data-theme-version='dark'] .datepicker-days .table-condensed thead th.picker-switch {
	color: #fff;
}

[data-theme-version='dark'] .datepicker-days .table-condensed thead th.prev,
[data-theme-version='dark'] .datepicker-days .table-condensed thead th.picker-switch,
[data-theme-version='dark'] .datepicker-days .table-condensed thead th.next {
	color: #fff;
}

@keyframes blinking {
	0% {
		background-color: var(--primary);
	}
	100% {
		background-color: transparent;
	}
}

[data-theme-version='dark'] input-group.search-area {
	border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme-version='dark'] .doller {
	color: #fff;
}

[data-theme-version='dark'] .apexcharts-tooltip.apexcharts-theme-light {
	background-color: rgba(255, 255, 255, 0.96);
	color: #000;
}

[data-theme-version='dark'] .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .all .show .card-header {
	background-color: rgba(255, 255, 255, 0.1) !important;
	border-radius: 0.375rem !important;
}

[data-theme-version='dark'] .all .show .nav-link {
	width: 2.5rem;
	min-width: 2.5rem;
	height: 2.5rem;
	margin: 5px;
	background-color: #272738 !important;
}

[data-theme-version='dark'] .note-text {
	color: #000;
}

[data-theme-version='dark'] .timeline-active.style-1 .timeline-list:before {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .authincation {
	background-color: #202020;
}

[data-theme-version='dark'] .authincation-content.style-2 .form-control {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .label-color,
[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed td.day,
[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.prev,
[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.picker-switch,
[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.next {
	color: #fff;
}

[data-theme-version='dark'] .authincation {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) !important;
}

[data-theme-version='dark'] .table-responsive .table-striped th {
	background-color: var(--rgba-primary-1);
	color: #fff;
}

[data-theme-version='dark'] .dz-card .card-body.code-area,
[data-theme-version='dark'] .demo-view .code-area {
	background-color: #272738;
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dz-calender .react-datepicker__day-name,
[data-theme-version='dark'] .dz-calender .react-datepicker__day,
[data-theme-version='dark'] .dz-calender .react-datepicker__time-name {
	color: #fff;
}

[data-theme-version='dark'] .dz-calender .react-datepicker__current-month {
	color: #fff;
}

[data-theme-version='dark'] .dz-calender .react-datepicker__navigation {
	background: none;
}

[data-theme-version='dark'] .dz-calender .react-datepicker__navigation-icon:before {
	border-color: #fff;
}

[data-theme-version='dark'] #overiewChart line {
	stroke: #444;
}

[data-theme-version='dark'][data-layout='vertical'][data-sidebar-position='fixed'] .header {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'][data-layout='vertical'][data-sidebar-position='fixed'] .brand-sub-title {
	color: #fff;
}

[data-theme-version='dark'] .header {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .header-left .dashboard_bar {
	color: #fff;
}

[data-theme-version='dark'] .header-left .search-area .form-control {
	background: #272738;
}

[data-theme-version='dark'] .header-left .search-area .input-group-text {
	border: 0;
	background: #272738;
}
[data-theme-version='dark'] .header-left .search-area .input-group-text a {
	color: #4f7086;
}

[data-theme-version='dark'] .header-left .input-group.search-area {
	border-color: #58586a;
}

[data-theme-version='dark'] .header-right .notification_dropdown .nav-link {
	/* background: \$d-bg!important; */
}
[data-theme-version='dark'] .header-right .notification_dropdown .nav-link .badge {
	border-color: #272738;
}

[data-theme-version='dark'] .header-right .dropdown .nav-link {
	color: #fff;
	background-color: #202020 !important;
	border-color: rgba(255, 255, 255, 0.1) !important;
}
[data-theme-version='dark'] .header-right .dropdown .nav-link:hover {
	color: #fff;
}

[data-theme-version='dark'] .header-right .dropdown.header-profile2 .nav-link {
	background-color: transparent !important;
}

[data-theme-version='dark'] .nav-header .hamburger .line {
	background: #fff !important;
}

[data-theme-version='dark'] .menu-toggle .nav-header .nav-control .hamburger .line {
	background-color: #fff !important;
}

.change-btn a {
	color: #000;
}

[data-theme-version='dark'] .nav-header {
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .nav-header .brand-title svg path {
	fill: #fff;
}

[data-theme-version='dark'] .nav-control {
	color: #fff;
}

[data-theme-version='dark'] .brand-logo {
	color: #fff;
}
[data-theme-version='dark'] .brand-logo:hover {
	color: #fff;
}

[data-theme-version='dark'] .svg-title-path {
	fill: #fff;
}

[data-theme-version='dark'] .nav-header {
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .nav-header .brand-title svg path {
	fill: #fff;
}

[data-theme-version='dark'] .nav-control {
	color: #fff;
}

[data-theme-version='dark'] .brand-logo {
	color: #fff;
}
[data-theme-version='dark'] .brand-logo:hover {
	color: #fff;
}

[data-theme-version='dark'] .svg-title-path {
	fill: #fff;
}

[data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li > ul {
	background-color: #272738;
}

[data-theme-version='dark'] .fixed-content-box {
	background-color: #272738;
}
[data-theme-version='dark'] .fixed-content-box .head-name {
	background: #272738;
	color: #fff;
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .fixed-content-box + .header + .dlabnav {
	background-color: #202020;
}

[data-theme-version='dark'][data-layout='vertical'][data-sidebar-position='fixed'] .dlabnav {
	border-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,
[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a {
	background: transparent;
}
[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a i,
[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a i {
	color: var(--primary);
	background: var(--rgba-primary-1);
}

[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li a > i {
	color: rgba(255, 255, 255, 0.3);
}

[data-theme-version='dark'] .ps__thumb-y {
	background-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a {
	color: #fff !important;
}

[data-theme-version='dark'] .dlabnav .header-profile > a.nav-link {
	border-color: rgba(255, 255, 255, 0.1);
}
[data-theme-version='dark'] .dlabnav .header-profile > a.nav-link .header-info span {
	color: #fff;
}

[data-theme-version='dark'] .dlabnav .metismenu > li > a {
	color: #b3b3b3;
}

[data-theme-version='dark'] .dlabnav .metismenu > li:hover > a,
[data-theme-version='dark'] .dlabnav .metismenu > li:focus > a,
[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a {
	color: #fff;
	background: var(--primary) !important;
}
[data-theme-version='dark'] .dlabnav .metismenu > li:hover > a::after,
[data-theme-version='dark'] .dlabnav .metismenu > li:focus > a::after,
[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a::after {
	border-left: 0.2125rem solid #fff;
	border-top: 0.2125rem solid #fff;
	border-bottom: 0.2125rem solid transparent;
	border-right: 0.2125rem solid transparent;
}
[data-theme-version='dark'] .dlabnav .metismenu > li:hover > a i,
[data-theme-version='dark'] .dlabnav .metismenu > li:focus > a i,
[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i {
	color: #fff !important;
}

[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active ul ul {
	background-color: transparent;
}

[data-theme-version='dark'] .dlabnav .metismenu ul:after {
	background-color: rgba(255, 255, 255, 0.1);
}

[data-theme-version='dark'] .dlabnav .metismenu ul a:hover,
[data-theme-version='dark'] .dlabnav .metismenu ul a:focus,
[data-theme-version='dark'] .dlabnav .metismenu ul a.mm-active {
	color: #fff !important;
}

[data-theme-version='dark'] .dlabnav .metismenu ul a:before {
	background-color: #fff;
}

[data-theme-version='dark'] .dlabnav .metismenu a {
	color: rgba(255, 255, 255, 0.6) !important;
}

[data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after {
	border-top: 0.2125rem solid #b3b3b3;
	border-left: 0.2125rem solid #b3b3b3;
	border-bottom: 0.2125rem solid transparent;
	border-right: 0.2125rem solid transparent;
}

[data-theme-version='dark'] .sidebar-right .card-tabs .nav-tabs {
	border-color: var(--rgba-primary-1) !important;
}
[data-theme-version='dark'] .sidebar-right .card-tabs .nav-tabs .nav-item .nav-link {
	color: #000 !important;
}

[data-theme-version='dark'] .sidebar-right .form-control {
	background: #fff;
	color: #000;
	border-color: #eeeeee;
}

[data-theme-version='dark'] .sidebar-right .default-select .list {
	background: #fff;
}
[data-theme-version='dark'] .sidebar-right .default-select .list .option.selected,
[data-theme-version='dark'] .sidebar-right .default-select .list .option.focus,
[data-theme-version='dark'] .sidebar-right .default-select .list .option:hover {
	background: rgba(0, 0, 0, 0.05) !important;
}

[data-theme-version='dark'] .sidebar-right .sidebar-right-inner > h4,
[data-theme-version='dark'] .sidebar-right .sidebar-right-inner > .h4 {
	color: #000 !important;
}

[data-theme-version='dark'] .sidebar-right .nice-select .option {
	background: #fff;
}

[data-theme-version='dark'] .footer {
	background-color: #272738;
}
[data-theme-version='dark'] .footer .copyright {
	background-color: transparent;
}
[data-theme-version='dark'] .footer .copyright p {
	color: #fff;
}


.wallet-open.active .admin-body {
	padding-right: calc(var(--right-space) - 1.75rem);
	transition: all 0.5s;
}
@media only screen and (max-width: 87.5rem) {
	.wallet-open.active .admin-body {
		padding-right: 0;
	}
}

.font-8 {
	font-size: 8pt !important;
}
.fc-view {
    margin-top: 4px;
}
.dayBox{
	height: 10px;
	width: 10px;
}
.fc-body .fc-row { min-height: 45px; }
.tx-center {
	text-align: center;
}
.p-name {
	color: #000;
}
.checklist{
	padding: 0.83rem;
	background: transparent;
	border: 1px solid #dddddd;
	border-radius: 0px;
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px
}
.checklist2{
	padding: 0.93rem;
	background: transparent;
	border: 1px solid #dddddd;
	border-radius: 0px
}
.checklist3{
	padding: 0.95rem;
	background: transparent;
	border: 1px solid #dddddd;
	border-radius: 0px;
	border-top-right-radius: 5px;
	border-bottom-right-radius: 5px
}
.checklist4{
	padding: 0.95rem;
	background: transparent;
	border: 1px solid #dddddd;
	border-radius: 0px;
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px
}
.checklist4:focus{
    border-color: var(--primary);
}
.form-list-input:checked {
    background-color: #297f00;
    border-color: #297f00;
}
.form-list-input {
	width: 1.25rem;
    height: 1.25rem;
}
#line .custext{
	border-top-right-radius: 0px !important;
	border-bottom-right-radius: 0px !important;
	border-right:none !important
}
#line2 .custext{
	border-top-left-radius: 0px !important;
	border-bottom-left-radius: 0px !important;
	border-left:none !important
}`, "",{"version":3,"sources":["webpack://./src/scss/main.scss","webpack://./src/css/style.css","webpack://./src/scss/abstracts/_bs-custom.scss","webpack://./src/scss/abstracts/_inheritance.scss","webpack://./src/scss/abstracts/_mixin.scss","webpack://./src/other/bootstrap/scss/bootstrap.scss","webpack://./src/other/bootstrap/scss/_root.scss","webpack://./src/other/bootstrap/scss/_reboot.scss","webpack://./src/other/bootstrap/scss/vendor/_rfs.scss","webpack://./src/other/bootstrap/scss/_functions.scss","webpack://./src/other/bootstrap/scss/_variables.scss","webpack://./src/other/bootstrap/scss/_type.scss","webpack://./src/other/bootstrap/scss/mixins/_lists.scss","webpack://./src/scss/abstracts/_maps.scss","webpack://./src/other/bootstrap/scss/_images.scss","webpack://./src/other/bootstrap/scss/mixins/_image.scss","webpack://./src/other/bootstrap/scss/_containers.scss","webpack://./src/other/bootstrap/scss/mixins/_container.scss","webpack://./src/other/bootstrap/scss/mixins/_breakpoints.scss","webpack://./src/other/bootstrap/scss/_grid.scss","webpack://./src/other/bootstrap/scss/mixins/_grid.scss","webpack://./src/other/bootstrap/scss/_tables.scss","webpack://./src/other/bootstrap/scss/mixins/_table-variants.scss","webpack://./src/scss/abstracts/_variable.scss","webpack://./src/other/bootstrap/scss/forms/_labels.scss","webpack://./src/other/bootstrap/scss/forms/_form-text.scss","webpack://./src/other/bootstrap/scss/forms/_form-control.scss","webpack://./src/other/bootstrap/scss/mixins/_transition.scss","webpack://./src/other/bootstrap/scss/mixins/_border-radius.scss","webpack://./src/other/bootstrap/scss/forms/_form-select.scss","webpack://./src/other/bootstrap/scss/forms/_form-check.scss","webpack://./src/other/bootstrap/scss/forms/_form-range.scss","webpack://./src/other/bootstrap/scss/forms/_floating-labels.scss","webpack://./src/other/bootstrap/scss/forms/_input-group.scss","webpack://./src/other/bootstrap/scss/mixins/_forms.scss","webpack://./src/other/bootstrap/scss/_buttons.scss","webpack://./src/other/bootstrap/scss/mixins/_buttons.scss","webpack://./src/other/bootstrap/scss/mixins/_gradients.scss","webpack://./src/other/bootstrap/scss/_button-group.scss","webpack://./src/other/bootstrap/scss/_transitions.scss","webpack://./src/other/bootstrap/scss/_dropdown.scss","webpack://./src/other/bootstrap/scss/mixins/_caret.scss","webpack://./src/other/bootstrap/scss/_nav.scss","webpack://./src/other/bootstrap/scss/_navbar.scss","webpack://./src/other/bootstrap/scss/_card.scss","webpack://./src/other/bootstrap/scss/_accordion.scss","webpack://./src/other/bootstrap/scss/_breadcrumb.scss","webpack://./src/other/bootstrap/scss/_pagination.scss","webpack://./src/other/bootstrap/scss/mixins/_pagination.scss","webpack://./src/other/bootstrap/scss/_badge.scss","webpack://./src/other/bootstrap/scss/_alert.scss","webpack://./src/other/bootstrap/scss/mixins/_alert.scss","webpack://./src/other/bootstrap/scss/_progress.scss","webpack://./src/other/bootstrap/scss/_list-group.scss","webpack://./src/other/bootstrap/scss/mixins/_list-group.scss","webpack://./src/other/bootstrap/scss/_close.scss","webpack://./src/other/bootstrap/scss/_toasts.scss","webpack://./src/other/bootstrap/scss/_modal.scss","webpack://./src/other/bootstrap/scss/mixins/_backdrop.scss","webpack://./src/other/bootstrap/scss/_tooltip.scss","webpack://./src/other/bootstrap/scss/mixins/_reset-text.scss","webpack://./src/other/bootstrap/scss/_popover.scss","webpack://./src/other/bootstrap/scss/_carousel.scss","webpack://./src/other/bootstrap/scss/mixins/_clearfix.scss","webpack://./src/other/bootstrap/scss/_spinners.scss","webpack://./src/other/bootstrap/scss/_offcanvas.scss","webpack://./src/other/bootstrap/scss/_placeholders.scss","webpack://./src/other/bootstrap/scss/helpers/_colored-links.scss","webpack://./src/other/bootstrap/scss/helpers/_ratio.scss","webpack://./src/other/bootstrap/scss/helpers/_position.scss","webpack://./src/other/bootstrap/scss/helpers/_stacks.scss","webpack://./src/other/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./src/other/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./src/other/bootstrap/scss/helpers/_stretched-link.scss","webpack://./src/other/bootstrap/scss/helpers/_text-truncation.scss","webpack://./src/other/bootstrap/scss/mixins/_text-truncate.scss","webpack://./src/other/bootstrap/scss/helpers/_vr.scss","webpack://./src/other/bootstrap/scss/mixins/_utilities.scss","webpack://./src/other/bootstrap/scss/_utilities.scss","webpack://./src/other/bootstrap/scss/utilities/_api.scss","webpack://./src/scss/base/_helper.scss","webpack://./src/scss/base/_reset.scss","webpack://./src/scss/base/_custom-grid.scss","webpack://./src/scss/_preloader.scss","webpack://./src/scss/layout/footer/_footer.scss","webpack://./src/scss/layout/header/nav-header/_nav-control.scss","webpack://./src/scss/layout/header/_header-global.scss","webpack://./src/scss/layout/header/_header-left.scss","webpack://./src/scss/layout/header/_header-right.scss","webpack://./src/scss/layout/sidebar/_sidebar-global.scss","webpack://./src/scss/layout/sidebar/_mega-menu.scss","webpack://./src/scss/layout/sidebar/_sidebar-full.scss","webpack://./src/scss/layout/sidebar/_sidebar-mini-nav.scss","webpack://./src/scss/layout/sidebar/_sidebar-horizontal.scss","webpack://./src/scss/layout/sidebar/_sidebar-compact-nav.scss","webpack://./src/scss/layout/sidebar/_sidebar-icon-hover.scss","webpack://./src/scss/layout/sidebar/_sidebar-modern.scss","webpack://./src/scss/layout/sidebar/_sidebar-overlay.scss","webpack://./src/scss/layout/sidebar/_sidebar-vertical-nav.scss","webpack://./src/scss/layout/sidebar/_sidebar-right.scss","webpack://./src/scss/layout/sidebar/_sidebar-profile.scss","webpack://./src/scss/layout/sidebar/_fixed-sidebar.scss","webpack://./src/scss/layout/sidebar/_dlab-demo-sidebar.scss","webpack://./src/scss/layout/sidebar/_wallet-sidebar.scss","webpack://./src/scss/layout/theme/_theme-bg.scss","webpack://./src/scss/layout/theme/_theme-boxed.scss","webpack://./src/scss/layout/theme/_theme-wide-boxed.scss","webpack://./src/scss/layout/theme/_theme-color.scss","webpack://./src/scss/layout/typography/_opensans.scss","webpack://./src/scss/layout/typography/_poppins.scss","webpack://./src/scss/layout/typography/_nunito.scss","webpack://./src/scss/layout/typography/_roboto.scss","webpack://./src/scss/layout/typography/_helvetica.scss","webpack://./src/scss/layout/version-transparent/_transparent-reset.scss","webpack://./src/scss/layout/version-transparent/_transparent-global.scss","webpack://./src/scss/layout/version-transparent/_transparent-header.scss","webpack://./src/scss/layout/version-transparent/_transparent-nav-header.scss","webpack://./src/scss/layout/version-transparent/_transparent-left-sidebar.scss","webpack://./src/scss/layout/version-dark/_dark-reset.scss","webpack://./src/scss/layout/version-dark/_dark-global.scss","webpack://./src/scss/layout/version-dark/_dark-header.scss","webpack://./src/scss/layout/version-dark/_dark-left-sidebar.scss","webpack://./src/scss/layout/version-dark/_dark-right-sidebar.scss","webpack://./src/scss/layout/version-dark/_dark-footer.scss","webpack://./src/scss/components/_code.scss","webpack://./src/scss/components/app/_app-calender-event.scss","webpack://./src/scss/components/app/_email.scss","webpack://./src/scss/components/app/_profile.scss","webpack://./src/scss/components/app/_chat.scss","webpack://./src/scss/components/charts/_chart-chartist.scss","webpack://./src/scss/components/charts/_chart-chartjs.scss","webpack://./src/scss/components/charts/_chart-c3.scss","webpack://./src/scss/components/charts/_chart-flot.scss","webpack://./src/scss/components/charts/_chart-morris.scss","webpack://./src/scss/components/charts/_chart-sparkline.scss","webpack://./src/scss/components/charts/_easy-pie-chart.scss","webpack://./src/scss/components/charts/_chart-amchart.scss","webpack://./src/scss/components/charts/_echarts.scss","webpack://./src/scss/components/forms/_form-basic.scss","webpack://./src/scss/components/forms/_form-checkbox.scss","webpack://./src/scss/components/forms/_form-radio-button.scss","webpack://./src/scss/components/forms/_form-switch.scss","webpack://./src/scss/components/forms/_form-validation.scss","webpack://./src/scss/components/forms/_form-pickers.scss","webpack://./src/scss/components/forms/_form-addons-cropper.scss","webpack://./src/scss/components/forms/_form-addons-select2.scss","webpack://./src/scss/components/forms/_form-steps.scss","webpack://./src/scss/components/forms/_form-ckeditor.scss","webpack://./src/scss/components/forms/_form-editor-quill.scss","webpack://./src/scss/components/map/_map-datamap.scss","webpack://./src/scss/components/map/_map-jqvmap.scss","webpack://./src/scss/components/uc/_uc-blockui.scss","webpack://./src/scss/components/uc/_uc-bootstrap-select.scss","webpack://./src/scss/components/uc/_uc-clipboard.scss","webpack://./src/scss/components/uc/_uc-ticker.scss","webpack://./src/scss/components/uc/_uc-typeahead.scss","webpack://./src/scss/components/uc/_uc-weather.scss","webpack://./src/scss/components/uc/_uc-noui-slider.scss","webpack://./src/scss/components/uc/_uc-nestable.scss","webpack://./src/scss/components/uc/_uc-pignose-calender.scss","webpack://./src/scss/components/uc/_uc-horizontal-timeline.scss","webpack://./src/scss/components/uc/_uc-toastr.scss","webpack://./src/scss/components/uc/_uc-lightgallery.scss","webpack://./src/scss/components/uc/_jqvmap.scss","webpack://./src/scss/components/uc/_perfect-scroll.scss","webpack://./src/scss/components/uc/_uc-ckeditor.scss","webpack://./src/scss/components/uc/_uc-calendar.scss","webpack://./src/scss/components/ui/_ui-accordion.scss","webpack://./src/scss/components/ui/_ui-alert.scss","webpack://./src/scss/components/ui/_ui-badge.scss","webpack://./src/scss/components/ui/_ui-breadcrumb.scss","webpack://./src/scss/components/ui/_ui-button.scss","webpack://./src/scss/components/ui/_ui-card.scss","webpack://./src/scss/components/ui/_ui-carousel.scss","webpack://./src/scss/components/ui/_ui-dropdown.scss","webpack://./src/scss/components/ui/_ui-grid.scss","webpack://./src/scss/components/ui/_ui-label.scss","webpack://./src/scss/components/ui/_ui-list-group.scss","webpack://./src/scss/components/ui/_ui-media.scss","webpack://./src/scss/components/ui/_ui-menu.scss","webpack://./src/scss/components/ui/_ui-modal.scss","webpack://./src/scss/components/ui/_ui-pagination.scss","webpack://./src/scss/components/ui/_ui-popover.scss","webpack://./src/scss/components/ui/_ui-progressbar.scss","webpack://./src/scss/components/ui/_ui-ribbon.scss","webpack://./src/scss/components/ui/_ui-scrollbar.scss","webpack://./src/scss/components/ui/_ui-step.scss","webpack://./src/scss/components/ui/_ui-tab.scss","webpack://./src/scss/components/ui/_ui-tooltip.scss","webpack://./src/scss/components/ui/_ui-timeline.scss","webpack://./src/scss/components/widget/_widget-chart.scss","webpack://./src/scss/components/widget/_widget-social.scss","webpack://./src/scss/components/widget/_widget-stat.scss","webpack://./src/scss/components/widget/_widget-todo-list.scss","webpack://./src/scss/components/widget/_widget-messages.scss","webpack://./src/scss/components/widget/_widget-pickadate.scss","webpack://./src/scss/components/widget/_widget-card-list.scss","webpack://./src/scss/components/widget/_widget-media.scss","webpack://./src/scss/components/tables/_table-basic.scss","webpack://./src/scss/components/tables/_table-bootgrid.scss","webpack://./src/scss/components/tables/_table-datatable.scss","webpack://./src/scss/components/tables/_table-footable.scss","webpack://./src/scss/components/tables/_table-jsgrid.scss","webpack://./src/scss/components/file-manager/_file-manager-style.scss","webpack://./src/scss/components/file-manager/_file-chats.scss","webpack://./src/scss/pages/_page-error.scss","webpack://./src/scss/pages/_page-auth.scss","webpack://./src/scss/pages/_homepage.scss","webpack://./src/scss/pages/_teacher.scss","webpack://./src/scss/pages/_food.scss","webpack://./src/scss/pages/_student.scss","webpack://./src/scss/pages/_finance.scss","webpack://./src/scss/pages/_user.scss","webpack://./src/scss/pages/_activity.scss","webpack://./src/scss/pages/_ecom-product-detail.scss","webpack://./src/scss/pages/_ecom-product-grid.scss","webpack://./src/scss/pages/_ecom-product-list.scss","webpack://./src/scss/layout/version-dark/_dark-nav-header.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CCqDC;AC6DD;CDtCC,kBCuCS;CDtCT,oBCuCW;CDtCX,wBCuCe;CDtCf,uBCuCc;CDtCd,wCCuCgB;CDtChB,wCCuCgB;CDtChB,wCCuCgB;CDtChB,wCCuCgB;CDtChB,wCCuCgB;CDtChB,wCCuCgB;CDtChB,wCCuCgB;CDtChB,wCCuCgB;CDtChB,wCCuCgB;CDtChB,2CCuCkB;CDtClB,2CCuCkB;CDtClB,2CCuCkB;CDtClB,2CCuCkB;CDtClB,2CCuCkB;CDtClB,2CCuCkB;CDtClB,2CCuCkB;CDtClB,2CCuCkB;CDtClB,2CCuCkB;CDtClB,uCCuCkB;CDtClB,wCCuCmB;CDtCnB,uCCuCkB;CDtClB,wCCuCmB;CDtCnB,gBCuCQ;ADtCT;;AAEA;CACC,sGAAsG;AEtGvG;;AFyGA;CACC,mBEvGe;CF0Gf,2EAA2E;CErG5E,mHAAY;AFuGZ;;AAEA;CACC,mBEtGe;CAIhB,2EAAY;CFsGX,mHErGsB;AFsGvB;;AAEA;CACC,mBErGW;CFwGX,2EEpGsB;CFqGtB,mHEpGmE;AFqGpE;;AAEA;CACC,mBAAmB;CAGnB,+DEnGe;CFoGf,mHEnGqE;AFoGtE;;AAEA;CEjGA,mBAAY;CFqGX,0EElGqE;CFmGrE,mHElG4E;AFmG7E;;AE/FA;CFkGC,mBEjGe;CFoGf,0EEjGkE;CFkGlE,mHEjGW;AFkGZ;;AAEA;CACC,mBEhGe;CFmGf,0EEhGW;CFiGX,mHAAmH;AE5FpH;;AF+FA;CACC,mBE7Fe;CFgGf,gEAAgE;CE3FjE,mHAAa;AF6Fb;;AAEA;CACC,8BE5Fe;CAIhB,0EAAa;CF4FZ,mHE3FsB;AF4FvB;;AAEA;CACC,8BE3FW;CF8FX,wEE1FsB;CF2FtB,mHE1FmE;AF2FpE;;AAEA;CACC,mBAAmB;CAGnB,+DEzFe;CF0Ff,mHEzFqE;AF0FtE;;AAEA;CEvFA,mBAAa;CF2FZ,+DExFe;CFyFf,mHExF+D;AFyFhE;;AErFA;CFwFC,mBEvFe;CF0Ff,+DEvF+D;CFwF/D,mHEvFW;AFwFZ;;AAEA;CACC,mBEtFe;CFyFf,6DEtFW;CFuFX,mHAAmH;AEpFpH;;AFuFA;CACC,mBErFe;CFwFf,6DAA6D;CEnF9D,mHAAa;AFqFb;;AAEA;CACC,mBEpFe;CChJhB,6DAAA;CHwOC,mHAAmH;AACpH;;AAEA;CACC,mBAAmB;CAGnB,6DAA6D;CAC7D,mHGvOC;ACXF;;AJqPA;CACC,mBAAmB;CCpIpB,+DIlHM;CL0PL,mHKlPoC;ALmPrC;;AAEA;;;;;;;;;CASC;AACD;;;;;EK3PI;ALiQJ;CACC,kBKlQ6C;CLmQ7C,oBKnQ6C;CLoQ7C,oBKhQmC;CLiQnC,kBKjQmC;CLkQnC,iBKlQmC;CLmQnC,oBKnQoC;CLoQpC,oBKpQmC;CLqQnC,mBKrQmC;CLsQnC,kBKtQmC;CLuQnC,kBKvQmC;CLwQnC,gBKpQG;CLqQH,kBKrQG;CLsQH,uBKtQ2C;CLuQ3C,sBKvQ2C;CLwQ3C,sBKxQ2C;CLyQ3C,sBKzQ2C;CL0Q3C,sBK1Q2C;CL2Q3C,sBK3Q2C;CL4Q3C,sBKzQ0C;CL0Q1C,sBKzQ0C;CL0Q1C,sBKzQoD;CL0QpD,sBKzQ8C;CL0Q9C,qBKpQqC;CLqQrC,uBKpQoD;CLqQpD,qBKpQwC;CLqQxC,kBK7PC;CL8PD,qBK7PoD;CL8PpD,oBK7PC;CL8PD,mBK7PC;CL8PD,kBK7P4C;CL8P5C,6BKvPA;CLwPA,gCAAgC;CM9RhC,6BAAA;CACA,0BAAQ;CACR,8BAAQ;CNgSR,4BM9RA;CN+RA,6BAA6B;CMjR1B,0BAAQ;CNmRX,6BMzRK;CN0RL,uBMnRsB;CNoRtB,kCAAkC;CMtQnC,+BAAK;CNwQJ;8EMtQ0E;CNwQ1E,yGO5FoC;CP6FpC,yFMvQ0E;CNwQ1E,0CMvQ0E;CNwQ1E,6BMvQwD;CNwQxD,0BMvQa;CNwQb,0BMvQmB;CNwQnB,wBMvQC;CNwQD,qBMvQC;ANwQF;;AAEA;;;CAGC,sBM/PU;ANgQX;;AM5PA;CN+PC;EACC,uBAAuB;CMrPzB;ANuPA;;AAEA;CACC,SMpPC;CNqPD,uCMnPA;CNoPA,mCAAmC;CMlPpC,uCAAG;CNoPF,uCMjPA;CNkPA,2BO/M4B;CPgN5B,qCMtPE;CNuPF,mCMpPA;CNqPA,8BAA8B;CMnP/B,6CAAG;ANqPH;;AAEA;CACC,cO9CmB;CP+CnB,cAAc;CMpPf,8BAAG;CNsPF,SOxDO;CPyDP,aO3NW;AP4NZ;;AAEA;CMrPA,WAAG;ANuPH;;AMlPA;;;;;;;;;;;;CNgQC,aMjOC;CNkOD,qBMjOa;CNkOb,gBMjOC;CNkOD,gBAAgB;CM5NjB,cAAQ;AN8NR;;AAEA;;CMvNA,gCAAE;AACF;AN0NA;CACC;;EMtNC,kBAAA;CACF;ANyNA;;AAEA;;CMrNA,mCAAK;AACL;AACA;CNwNC;;EMpNC,mBAAC;CNuNF;AACD;;AAEA;;CAEC,iCAAiC;AM9MlC;ANgNA;CACC;;EMvMD,iBAAO;CN0MN;AACD;;AAEA;;CM7LA,mBAAK;ANgML;;AAEA;;CMtLA,eAAI;ANyLJ;;AAEA;;CAEC,mBAAmB;AMtLpB;;ANyLA;CMxLA,aAAI;CN0LH,mBM1LmB;AN2LpB;;AAEA;;CAEC,yCMtLS;SNsLT,iCMtLS;CNuLT,YQjOS;CRkOT,8BAA8B;AM7K/B;;ANgLA;CACC,mBAAmB;CMtKpB,kBAAG;CACH,oBAAI;AACJ;;ANyKA;;CAEC,kBMvKgB;ANwKjB;;AMhKA;;;CNqKC,aMlKC;CNmKD,mBMlKe;ANmKhB;;AAEA;;;;CMzJA,gBAAK;AN8JL;;AAEA;CACC,gBM3JO;AN4JR;;AMvJA;CN0JC,qBS6oCmC;CT5oCnC,cOzPS;AP0PV;;AAEA;CACC,gBMxJK;ANyJN;;AAEA;;CM/IA,mBAAO;ANkJP;;AM3IA;;CN+IC,kBM7IiB;AN8IlB;;AAEA;;CAEC,cAAc;CMrIf,yBAAQ;ANuIR;;AAEA;;CAEC,kBAAkB;CMhInB,iBAAG;CNkIF,cMhIa;CNiIb,wBMhIa;ANiId;;AM7HA;CACA,eAAK;AACL;;AAEA;CNgIC,WM/HC;ANgIF;;AAEA;CMxHA,cAAM;CN0HL,0BMxHA;ANyHD;AMpHA;CNsHC,cMpHc;ANqHf;;AAEA;;CMzGA,cAAK;CACL,qBAAM;AACN;;AAEA;;;;CN+GC,qCM1GA;CN2GA,cAAc;CMxGf,+BAAM;CACN,2BAAO;AN0GP;;AAEA;CACC,cMtGS;CNuGT,aAAa;CMpGd,mBAAO;CNsGN,cMnGY;CNoGZ,kBMjGY;ANkGb;AACA;CM3FA,kBAAM;CN6FL,cM5Fc;CN6Fd,kBAAkB;AMrFnB;;ANwFA;CMrFA,kBAAgB;CNuFf,cMtFC;CNuFD,qBMpFkB;ANqFnB;AACA;CACC,cM3FK;AN4FN;;AMhFA;CNmFC,sBMlFW;CNmFX,kBMlFe;CNmFf,WAAW;CM9EZ,yBAAS;CNgFR,uBM9EA;AN+ED;AMtEA;CNwEC,UMvEU;CNwEV,cMvEW;CNwEX,gBMvEU;ANwEX;;AM/DA;CNkEC,gBMjEY;ANkEb;;AAEA;;CAEC,sBMhEqB;ANiEtB;;AAEA;CACC,oBMlEK;CNmEL,yBMjEE;ANkEH;;AM3DA;CACA,mBAAA;CACA,sBAAA;CACA,cAAA;CACA,gBAAA;AACA;;AN+DA;CM3DA,mBAAA;CN6DC,gCM3DA;AN4DD;;AAEA;;;;;;CAMC,qBAAqB;CACrB,mBAAmB;CACnB,eAAe;AAChB;;AM1CA;CN6CC,qBM5CqB;AN6CtB;;AAEA;CACC,gBAAgB;AMpCjB;;ANuCA;CMhCA,UAAA;ANkCA;;AAEA;;;;;CAKC,SM3BS;CN4BT,oBAAoB;CMrBrB,kBAAQ;CNuBP,oBMtBmB;ANuBpB;;AMdA;;CNkBC,oBAAoB;AACrB;;AAEA;CU9lBA,eAAM;AVgmBN;;AAEA;CU3lBE,iBAAqB;AV6lBvB;AACA;CACC,UU5lBG;AV6lBJ;;AAEA;CACC,aAAa;AUnmBZ;;AVsmBF;;;;CAIC,0BUtmBE;AVumBH;AU3mBE;;;;CVgnBD,eO5gBW;AP6gBZ;;AAEA;CUnnBE,UAAqB;CVqnBtB,kBO9XS;AP+XV;;AAEA;CACC,gBUznBsB;AV0nBvB;;AU1nBE;CV6nBD,YOtYS;CPuYT,UU5nBG;CV6nBH,SU5nBG;CV6nBH,SO5hBW;AP6hBZ;;AAEA;CUnoBE,WAAqB;CVqoBtB,WO/XmB;CPgYnB,UUpoBG;CVqoBH,qBUnoBE;CVooBF,iCOpiB4B;CPqiB5B,oBUzoBsB;AV0oBvB;AACA;CUrnBA;ECrDE,iBAAe;CX6qBhB;AACD;AUpnBA;CVsnBC,WWhrBC;AXirBF;;AUpnBA;;;;;;;CV6nBC,UU7mBC;AV8mBF;;AAEA;CACC,YOpeS;APqeV;;AAEA;CUvmBA,oBAAmB;CVymBlB,6BY/qBY;AZgrBb;;AAEA;;;;;;;CAOC;AapsBD;CbssBC,wBSixByC;AThxB1C;;AAEA;CACC,Uc5sBU;Ad6sBX;;Aa5rBA;Cb+rBC,aa7rBU;Ab8rBX;;AAEA;CACC,aa5rBY;Cb6rBZ,0BAA0B;Aa1rB3B;;Ab6rBA;CACC,qBAAqB;Ae9tBpB;;AAQE;CAAA,SAAA;AAAA;;AAAA;Cf8tBH,kBgBzuBY;ChB0uBZ,egBzuBc;AhB0uBf;;AAEA;CACC,wBAAwB;AiBlrBrB;;AjBqrBJ;CACC,wBAAwB;AiBtrBrB;;AjByrBJ;CACC,qBAAqB;CiB1rBlB,gBAAiB;AjB4rBrB;;AAEA;CiB9rBI,iCAAyB;CjBgsB5B,gBejvBG;CfkvBH,gBSvRK;ATwRN;AiBlsBI;CjBosBH;EACC,eS1RK;CT2RN;AkBhwBC;;AlBmwBF;CACC,iCmBlwBc;CnBmwBd,gBmBlwBgB;CnBmwBhB,gBmBjwBa;AnBkwBd;AACA;CACC;EACC,iBmB1vBc;CnB2vBf;AACD;;AAEA;CACC,iCmB1vByD;CnB2vBzD,gBAAgB;CmB5sBX,gBAAc;AnB8sBpB;AACA;CmB3sBM;EApCJ,eAAc;CnBkvBf;AACD;;AAEA;CACC,iCmBpuBE;CnBquBF,gBAAgB;CmBxuBf,gBAAI;AnB0uBN;AACA;CACC;EmB5uBC,iBAAI;CnB8uBL;AACD;;AmB/uBE;CnBkvBD,iCmBjvBiB;CnBkvBjB,gBmBhvBE;CnBivBF,gBAAgB;AmBpvBf;AnBsvBF;CACC;EACC,eAAe;CmBxvBf;AnB0vBF;;AAEA;CmB3tBM,iCAAmB;CnB6tBxB,gBmB7wBe;CnB8wBf,gBmB5tBM;AnB6tBP;AmBztBU;CnB2tBT;EmB1xBG,iBAA0C;CnB4xB7C;AmB7tBS;;AnBguBV;CACC,eAAe;CmBjuBN,gBAAoB;AnBmuB9B;;AAEA;CmBruBU,eAAoB;CnBuuB7B,gBmBvyBiB;AnBwyBlB;;AmBxuBU;CnB2uBT,qBmB3yBiB;AnB4yBlB;AACA;CmB7uBU,oBAAoB;AnB+uB9B;;AAEA;CmBjvBU,kBAAoB;CnBmvB7B,yBmBnzBiB;AnBozBlB;;AmBpvBU;CnBuvBT,mBmBvzBiB;CnBwzBjB,qBmBtvBU;AnBuvBX;AmBzvBU;CnB2vBT,gBmB3zBiB;AnB4zBlB;;AmB5vBU;CnB+vBT,iBmB/zBiB;CnBg0BjB,mBmB/zB6C;CnBg0B7C,kBAAkB;CmBjwBT,cAAoB;AnBmwB9B;AACA;CACC,qBAAqB;AmBrwBZ;;AnBwwBV;CACC,eAAe;CmBjwBJ,YAAuB;AnBmwBnC;;AmBnwBY;CnBswBX,gBmB9zB+B;CnB+zB/B,yBAAyB;CmBvwBd,yBAAuB;CnBywBlC,uBmBvwBY;CnBwwBZ,eAAe;CmB1wBJ,YAAuB;AnB4wBnC;;AmB5wBY;CnB+wBX,qBmBv0B+B;AnBw0BhC;;AAEA;CACC,qBAAqB;CmBnxBV,cAAuB;AnBqxBnC;;AmBrxBY;CnBwxBX,kBmBh1B+B;CnBi1B/B,cAAc;AmBzxBH;;AnB4xBZ;;;;;;;CmBjxBQ,WAAI;CACJ,uCAAqB;CnByxB5B,sCmBvxBQ;CnBwxBR,kBAAkB;CmBtxBX,iBAAI;AACJ;;AnByxBR;CmB/xBQ;;EAEE,gBAAuC;CnBiyBhD;AmB9xBO;;AnBiyBR;CACC;;;EmBryBS,gBAAuC;CnByyBhD;AmBtyBO;;AnByyBR;CACC;;;;EAIC,gBAAgB;CmB9yBV;AACA;;AnBizBR;CmBvzBQ;;;;;EAMA,iBAAqB;CnBwzB5B;AACD;;AmB9zBQ;CnBi0BP;;;;;;EiBr3BG,iBAAmB;CjB43BtB;AACD;;AAEA;CACC,mBmBh3BM;CnBi3BN,gBmB72BuB;CnB82BvB,amBx4BS;CnBy4BT,eOv2BwD;CPw2BxD,yCmB34BK;CnB44BL,6CmB34BiB;CnB44BjB,4CmB14BE;AnB24BH;AACA;CACC,cO72BY;CP82BZ,WmBj5BC;CnBk5BD,emBj5BS;CnBk5BT,6CmBh5BE;CnBi5BF,4CmBp5BK;CnBq5BL,8BmBp5BiB;AnBq5BlB;;AAEA;CACC,SOt3BY;APu3Bb;;AAEA;CACC,cmBt3B6B;CnBu3B7B,WmBv7BS;AnBw7BV;;AAEA;CACC,cmB17BU;CnB27BV,WmB53B6B;AnB63B9B;;AAEA;CACC,cmBh8BS;CnBi8BT,UmBh8BU;AnBi8BX;;AAEA;CACC,cmBr4B6B;CnBs4B7B,gBmBt8BS;AnBu8BV;;AAEA;CACC,cmBz8BU;CnB08BV,UmB34BkB;AnB44BnB;;AAEA;CACC,cmB/8BS;CnBg9BT,UmB/8BU;AnBg9BX;;AAEA;CACC,cmBp5B6B;CnBq5B7B,gBmBr9BS;AnBs9BV;;AAEA;CACC,cmBx9B6C;CnBy9B7C,WmBl5BW;AnBm5BZ;;AAEA;CACC,cmBt5BkC;CnBu5BlC,emB/8BY;AnBg9Bb;;AAEA;CACC,cmBn9BY;CnBo9BZ,gBmB55BkC;AnB65BnC;;AAEA;CACC,cmBh6BkC;CnBi6BlC,UmBz9BC;AnB09BF;;AAEA;CACC,cmB79BY;CnB89BZ,gBmBt6BkC;AnBu6BnC;;AAEA;CACC,cmB/5Bc;CnBg6Bd,gBmB/5B4B;AnBg6B7B;;AAEA;CACC,cmB75BS;CnB85BT,UmBr6Bc;AnBs6Bf;;AAEA;CACC,cmBn6B4B;CnBo6B5B,gBmBn6BsC;AnBo6BvC;;AAEA;CACC,cmBz6Bc;CnB06Bd,gBmBz6B4B;AnB06B7B;;AAEA;CACC,cmBj7BS;CnBk7BT,UmB/6Bc;AnBg7Bf;;AAEA;CACC,cmBv7B4B;CnBw7B5B,gBmBv7BsC;AnBw7BvC;;AAEA;CACC,cmB77Bc;CnB87Bd,gBmB77B4B;AnB87B7B;;AAEA;CACC,cmB37BS;CnB47BT,WAAW;AiBt/BR;;AjBy/BJ;CACC,qBmB5+ByB;AnB6+B1B;;AAEA;CACC,sBmBpgCiB;AnBqgClB;;AAEA;CACC,gBmBtgCE;AnBugCH;;AAEA;CACC,sBmB7gCK;AnB8gCN;;AAEA;CACC,sBmBhhCiB;AnBihClB;;AAEA;CACC,gBOl/BY;APm/Bb;;AAEA;CACC,sBmBl/B6B;AnBm/B9B;;AAEA;CACC,sBmBtjCiB;AnBujClB;;AAEA;CACC,gBmBx/BU;AnBy/BX;;AAEA;CACC,sBmB9/B6B;AnB+/B9B;;AAEA;CACC,sBmBlkCiB;AnBmkClB;;AAEA;;CAEC,gBmBvgC6B;AnBwgC9B;;AAEA;;CAEC,gBmB1gCU;AnB2gCX;;AAEA;;CAEC,sBmBjlCiB;AnBklClB;;AAEA;;CAEC,sBmB9gCkC;AnB+gCnC;;AAEA;;CAEC,qBmB3kC+B;AnB4kChC;;AAEA;;CAEC,qBmBxhCkC;AnByhCnC;;AAEA;;CAEC,mBmBrlC+B;AnBslChC;;AAEA;;CAEC,mBmBliCkC;AnBmiCnC;;AAEA;;CAEC,uBmB3hC4B;AnB4hC7B;;AAEA;;CAEC,uBmBjiCc;AnBkiCf;;AAEA;;CAEC,mBmB/hCgD;AnBgiCjD;;AAEA;;CAEC,mBmBriC4B;AnBsiC7B;;AAEA;CACC;EmB1iCO,SAAO;CnB4iCd;CACA;EmBljCO,cAAO;EACP,WAAqB;CnBojC5B;CACA;EmBhjCO,cAAqB;EnBkjC3B,WmBjjCQ;CnBkjCT;CACA;EACC,cmBzjCQ;EAGF,UAAO;CnBwjCd;CACA;EACC,cAAc;EiBlnCZ,gBAAiB;CjBonCpB;CACA;EmBvmCK,cAAA;EnBymCJ,UmB7oCM;CnB8oCP;CACA;EACC,cmBhoCQ;EnBioCR,UO/lCW;CPgmCZ;CACA;EACC,cOlmCuD;EYnCvD,gBA2BsB;CnB4mCvB;CACA;EmBxoCC,cA2BsB;EnB+mCtB,WmBzoCQ;CnB0oCT;CACA;EACC,cmB5oCQ;EnB6oCR,emB3oCC;CnB4oCF;CACA;EACC,cO9mCW;EYFP,gBAAmB;CnBknCxB;CACA;EmB7mCS,cAAoB;EnB+mC5B,UmB/qCQ;CnBgrCT;CACA;EACC,cmBlrCQ;EnBmrCR,gBmBlrCS;CnBmrCV;CACA;EACC,cmBrrC4C;EA+DpC,gBAAoB;CnBwnC7B;CACA;EmBznCS,cAAoB;EnB2nC5B,UmB3rCQ;CnB4rCT;CACA;EACC,cmB9rCQ;EnB+rCR,gBmB7nCS;CnB8nCV;CACA;EACC,cmBjsCS;EA+DD,gBAAoB;CnBooC7B;CACA;EmBroCS,cAAoB;EnBuoC5B,UmBvsCQ;CnBwsCT;CACA;EACC,cmB1sCQ;EnB2sCR,gBmB1sCS;CnB2sCV;CACA;EACC,cmB7sCS;EA+DD,gBAAoB;CnBgpC7B;CACA;EmBzoCW,cAAuB;EnB2oCjC,WmBnsCA;CnBosCD;CACA;EmB7oCW,cAAuB;CnB+oClC;CACA;EACC,qBmB/oCW;CnBgpCZ;CACA;EmBnpCW,sBAAuB;CnBqpClC;CACA;EACC,gBmB/sC8B;CnBgtC/B;CACA;EmBzpCW,sBAAuB;CnB2pClC;CACA;EACC,sBmB3pCW;CnB4pCZ;CACA;EmB/pCW,gBAAuB;CnBiqClC;CACA;EmBtpCO,sBAAqB;CnBwpC5B;CACA;EmBppCO,sBAAqB;CnBspC5B;CACA;EmB5pCO,gBAAqB;CnB8pC5B;CACA;EmB1pCO,sBAAqB;CnB4pC5B;CACA;EmBlqCO,sBAAqB;CnBoqC5B;CACA;;EAEC,gBmBjqC+C;CnBkqChD;CACA;;EmBrqCO,gBAAO;CnBwqCd;CACA;;EmB7qCO,sBAAqB;CnBgrC5B;CACA;;EAEC,sBmB7qC+C;CnB8qChD;CACA;;EmBjrCO,qBAAO;CnBorCd;CACA;;EiB7uCG,qBAAmB;CjBgvCtB;CACA;;EAEC,mBmBzwCc;CnB0wCf;CACA;;EAEC,mBmB3vCC;CnB4vCF;CACA;;EmBhwCC,uBAAI;CnBmwCL;CACA;;EAEC,uBmBrwCgB;CnBswCjB;CACA;;EAEC,mBmBvwCC;CnBwwCF;CACA;;EmB3uCK,mBAAmB;CnB8uCxB;AACD;;AAEA;CACC;EmB5uCS,SAAoB;CnB8uC7B;CACA;EmB/uCS,cAAoB;EnBivC5B,WmBjzCQ;CnBkzCT;CACA;EACC,cmBpzCQ;EnBqzCR,WmBpzCS;CnBqzCV;CACA;EACC,cmBvzCS;EA+DD,UAAoB;CnB0vC7B;CACA;EmB3vCS,cAAoB;EnB6vC5B,gBmB7zCgB;CnB8zCjB;CACA;EACC,cmBh0CQ;EnBi0CR,UmBh0CS;CnBi0CV;CACA;EACC,cmBn0C4C;EA+DpC,UAAU;CnBswCnB;CACA;EmBvwCS,cAAoB;EnBywC5B,gBmBz0CgB;CnB00CjB;CACA;EACC,cmB50CQ;EnB60CR,WmB50CS;CnB60CV;CACA;EmBvwCW,cAAuB;EnBywCjC,emBj0C8B;CnBk0C/B;CACA;EmB3wCW,cAAuB;EnB6wCjC,gBmBr0C8B;CnBs0C/B;CACA;EmB/wCW,cAAuB;EnBixCjC,UmBz0CA;CnB00CD;CACA;EmBnxCW,cAAuB;EnBqxCjC,gBmB70C8B;CnB80C/B;CACA;EmBvxCW,cAAuB;EnByxCjC,gBmBj1C8B;CnBk1C/B;CACA;EmB3xCW,cAAuB;EnB6xCjC,UmBr1CA;CnBs1CD;CACA;EACC,cmBnxCQ;EAGF,gBAAO;CnBkxCd;CACA;EmBxxCO,cAAO;EACP,gBAAqB;CnB0xC5B;CACA;EmBtxCO,cAAqB;EnBwxC3B,UmBvxCQ;CnBwxCT;CACA;EACC,cmB/xCQ;EAGF,gBAAO;CnB8xCd;CACA;EmBpyCO,cAAO;EACP,gBAAqB;CnBsyC5B;CACA;EmBlyCO,cAAqB;EnBoyC3B,WmBnyCQ;CnBoyCT;CACA;EACC,cmB3yCQ;CnB4yCT;CACA;EACC,qBmBzyC+C;CnB0yChD;CACA;EACC,sBmBjzCgD;CnBkzCjD;CACA;EACC,gBmB/yC+C;CnBgzChD;CiB12CG;EEUE,sBAAc;CnBm2CnB;CACA;EACC,sBmBr4Cc;CnBs4Cf;CACA;EACC,gBmBx3CgB;CnBy3CjB;CACA;EACC,sBmB33CgB;CnB43CjB;CACA;EACC,sBmB93CgB;CnB+3CjB;CACA;EACC,gBmBj4CgB;CnBk4CjB;CACA;EACC,sBmBp4CgB;CnBq4CjB;CACA;EACC,sBmBv4CgB;CnBw4CjB;CACA;;EAEC,gBmBz2CK;CnB02CN;CACA;;EmBv2CS,gBAAoB;CnB02C7B;CACA;;EAEC,sBmB76CgB;CnB86CjB;CACA;;EAEC,sBmB/2CS;CnBg3CV;CACA;;EmBn3CS,qBAAoB;CnBs3C7B;CACA;;EAEC,qBmBz7CgB;CnB07CjB;CACA;;EAEC,mBmB57C4C;CnB67C7C;CACA;;EmB/3CS,mBAAoB;CnBk4C7B;CACA;;EAEC,uBmBr8CgB;CnBs8CjB;CACA;;EAEC,uBmBv4CS;CnBw4CV;CACA;;EAEC,mBmB77C8B;CnB87C/B;CACA;;EAEC,mBmBj8C8C;CnBk8C/C;AACD;;AAEA;CACC;EACC,SmBv8CA;CnBw8CD;CACA;EmBj5CW,cAAuB;EnBm5CjC,WmB38CA;CnB48CD;CACA;EmBr5CW,cAAc;EnBu5CxB,WmB/8CA;CnBg9CD;CACA;EmB94CO,cAAQ;EACR,UAAqB;CnBg5C5B;CACA;EmB54CO,cAAqB;EnB84C3B,gBmB74C+C;CnB84ChD;CACA;EACC,cmBr5CQ;EAGF,UAAQ;CnBo5Cf;CACA;EmB15CO,cAAQ;EACR,UAAqB;CnB45C5B;CACA;EmBx5CO,cAAqB;EnB05C3B,gBmBz5C+C;CnB05ChD;CACA;EACC,cmBj6CQ;EAGF,WAAQ;CnBg6Cf;CACA;EmBt6CO,cAAQ;EACR,eAAqB;CnBw6C5B;CACA;EmBp6CO,cAAqB;EnBs6C3B,gBmBr6C+C;CnBs6ChD;CACA;EACC,cmB76CQ;EAGF,UAAQ;CnB46Cf;CACA;EACC,cAAc;EoBjiDhB,gBAAO;CpBmiDN;CACA;EoBjiDC,cAAA;EACA,gBAAA;CpBmiDD;CACA;EoBjiDC,cAAA;EACA,UAAA;CpBmiDD;CACA;EoBhiDC,cnBNkB;EmBOlB,gBXkqB4B;CTg4B7B;CACA;EACC,cSv4B4B;ETw4B5B,gBoB3hDE;CpB4hDH;CACA;EoBpjDD,cA4BS;EpB0hDP,UoBzhDE;CpB0hDH;CACA;EoBxjDD,cAqCS;EpBqhDP,gBoBphDc;CpBqhDf;CoB5gDD;EACE,cAAc;EpB8gDd,gBAAgB;CoBtgDlB;CpBwgDC;EACC,cAAc;EoBx/ChB,WAAA;CpB0/CC;CACA;EACC,coBt/CgB;CpBu/CjB;CoBl/CD;EAGI,qBAAqB;CpBk/CxB;CoBr/CD;EAOI,sBACD;CpBg/CF;CoBz+CD;EAEI,gBAAA;CpB0+CH;CACA;EoBl+CD,sBAAc;CpBo+Cb;CACA;EACC,sBAAsB;CoB79CxB;CpB+9CC;EoB59CG,gBAAO;CpB89CV;CqB1lDC;EAME,sBAAwC;CrBulD3C;CACA;EqBrlDG,sBAAqD;CrBulDxD;CACA;EqBrlDG,gBAAA;CrBulDH;CACA;EACC,sBAAsB;CqBrmDtB;CrBumDD;EqBhmDG,sBAAuD;CrBkmD1D;CACA;;EqB/lDG,gBAAA;CrBkmDH;CACA;;EAEC,gBAAgB;CqBhnDhB;CrBknDD;;EqB1mDG,sBAAA;CrB6mDH;CACA;;EqB1mDG,sBAAsC;CrB6mDzC;CACA;;EqB1nDC,qBAAiB;CrB6nDlB;CACA;;EqBrnDG,qBAAqD;CrBwnDxD;CACA;;EqBpnDG,mBCJQ;CtB2nDX;CACA;;EqBhoDG,mBAAuC;CrBmoD1C;CACA;;EqBhoDG,uBAAuC;CrBmoD1C;CACA;;EqB/nDG,uBAAwE;CrBkoD3E;CqBjpDC;;EAOE,mBAAA;CrB8oDH;CACA;;EqB3oDG,mBAAmC;CrB8oDtC;AACD;;AAEA;CqB5pDE;EAME,SAAA;CrBypDH;CACA;EqBvpDG,cAAA;EACA,WAAA;CrBypDH;CACA;EqBtpDG,cCJQ;EDKR,WAAA;CrBwpDH;CqBvqDC;EAME,cAAuC;EACvC,UAAA;CrBoqDH;CACA;EqBlqDG,cAAA;EACA,gBAAA;CrBoqDH;CACA;EqBjqDG,cAAc;ErBmqDhB,UAAU;CoB/hDR;CpBiiDH;EoB/hDK,cAAA;EpBiiDJ,UAAU;CiB5mDR;CjB8mDH;EACC,coBriDgB;EpBsiDhB,gBoBriDI;CpBsiDL;CiBjnDG;EGyEA,cAAA;EpB2iDF,WoB1iDI;CpB2iDL;CACA;EiBtnDG,cAAQ;EGyER,eAAA;CpBgjDH;CACA;EACC,cAAc;EiB3nDZ,gBAAiB;CjB6nDpB;CACA;EACC,coBpjDI;EpBqjDJ,UAAU;CiBhoDR;CjBkoDH;EACC,coBzjDgB;EpB0jDhB,gBoBzjDI;CpB0jDL;CuB7sDD;EACE,cAAa;EvB+sDb,gBAAgB;CuBtsDlB;CvBwsDC;EuBtsDC,cAAc;EACd,UAAA;CvBwsDD;CACA;EACC,cAAc;EuBlsDhB,gBAAkB;CvBosDjB;CACA;EOz7CK,cAvEI;EPkgDR,gBAAgB;CuBjsDlB;CvBmsDC;EuBjsDC,cAAc;EhBwQR,UAAY;CP47CnB;CACA;EACC,cOv7CkB;EPw7ClB,gBAAgB;CwBpuDlB;CxBsuDC;EOr8CK,cAvEI;EiBrNR,gBvBuEkB;CD6pDnB;CyBzuDD;EACE,cAAc;EACd,WAAW;CzB2uDZ;CACA;EyBxuDC,cxBeoB;CD2tDrB;CACA;EyBxuDC,qBxBJW;CD8uDZ;CACA;EyBxuDC,sBAAgB;CzB0uDjB;CACA;E0BvuDK,gBAAQ;C1ByuDb;CACA;EyB1vDD,sBAoBS;CzBwuDR;CACA;EACC,sByBruDG;CzBsuDJ;CACA;EACC,gByBluDE;CzBmuDH;CACA;EACC,sBS3hC8B;CT4hC/B;CACA;EyBtwDD,sBAAa;CzBwwDZ;CACA;EyBzwDD,gBAAa;CzB2wDZ;CACA;EyB5wDD,sBAAa;CzB8wDZ;CACA;EACC,sBCplDgB;CDqlDjB;CACA;;EAEC,gByBtsDgB;CzBusDjB;CACA;;EAEC,gByBtsDe;CzBusDhB;CACA;;EAEC,sB0B3wDsB;C1B4wDvB;CACA;;EAEC,sBCpmDgB;CDqmDjB;CACA;;EAEC,qBChwDS;CDiwDV;CACA;;EAEC,qByBrsDiB;CzBssDlB;CACA;;EAEC,mB0B5xDY;C1B6xDb;CACA;;EAEC,mByBtsDkB;CzBusDnB;CyB9rDD;;EAEE,uBAAW;CzBgsDZ;CACA;;EyB7rDC,uBxBnHkB;CDmzDnB;CACA;;EyBvsDD,mBAAA;CzB0sDC;CACA;;EyBlrDD,mBAAiB;CzBqrDhB;AACD;;AAEA;CACC;EACC,SyB1rDF;CzB2rDC;CACA;EACC,cS1lC4B;ET2lC5B,WS3lC4B;CT4lC7B;CACA;EACC,cS9lC4B;ET+lC5B,WS/lC4B;CTgmC7B;CACA;EyBjrDD,cAAgB;EACd,UAAU;CzBmrDX;CACA;E2Br0DG,cAAa;EFgJjB,gBAAgB;CzBwrDf;CACA;EACC,cyBjrDE;EATJ,UAAA;CzB4rDC;CACA;EACC,cyB/qDE;EzBgrDF,UAAU;CyBzqDZ;CzB2qDC;EACC,cAAc;EyB5qDhB,gBAAQ;CzB8qDP;CACA;EyB/qDD,cAAQ;EAUJ,WAAU;CzBwqDb;CyBnqDD;EACE,chB6qB0C;EgB5qB1C,eAAY;CzBqqDb;CACA;EACC,cyBnqDU;EANZ,gBAAA;CzB2qDC;CACA;EyB5qDD,cAAA;EzB8qDE,UyB/pD6C;CzBgqD9C;CACA;E4Bn3DD,cAAa;EACX,gBAAc;C5Bq3Df;CACA;E4Bl3DC,cAAA;ErB2RI,gBAvEI;CPiqDT;CACA;E4Bj3DC,c3BLkB;E2BMlB,UAAA;C5Bm3DD;CACA;E4Bj3DC,cAAA;EACA,gBAAe;C5Bm3DhB;CACA;E0Bx3DK,cjBo2BkC;EmB31BtC,gBAAgB;C5Bk3DjB;CACA;EACC,c0Bx3DgB;EEhBlB,UAAA;C5B04DC;CACA;EACC,cS97BgC;EmB98BlC,gBAiCG;C5B62DF;CACA;E4B/4DD,cAAY;E5Bi5DV,gB4Bx2DE;C5By2DH;CACA;EACC,c4Bp2Da;E5Bq2Db,WAAW;C4Bj2Db;C5Bm2DC;E4Bj2DC,cAAc;C5Bm2Df;CACA;E2B54DG,qB1BkK0B;CD4uD7B;CACA;EACC,sBOrsDQ;CPssDT;C4Bn2DD;EACE,gBnBqrB4B;CTgrC7B;CACA;EOnoDK,sBAvE+B;CP4sDpC;CACA;E6Bv6DD,sBAAY;C7By6DX;CACA;E6Bv6DC,gBpBq3BwC;CTojCzC;CACA;EACC,sB6Bv6Da;C7Bw6Dd;CACA;E6Bp6DD,sBAAkB;C7Bs6DjB;CACA;E6Bp6DC,gBAAY;C7Bs6Db;CACA;E6Bp6DC,sBAAmB;C7Bs6DpB;CACA;E6Bp6DC,sBPbM;CtBm7DP;CACA;;EAEC,gB2B/6De;C3Bg7DhB;CACA;;EAEC,gBSpkCwC;CTqkCzC;CACA;;EAEC,sBS7tC8B;CT8tC/B;CACA;;EAEC,sB6B97De;C7B+7DhB;CACA;;E6Bh8DD,qBAsDG;C7B64DF;CACA;;E6Bp8DD,qBAAiB;C7Bu8DhB;CACA;;E6Bx8DD,mBAyEG;C7Bk4DF;CACA;;E6Bj3DC,mBpBqzByD;CT+jC1D;CACA;;EAEC,uBQ31De;CR41DhB;CACA;;EAEC,uB0Bl9DY;C1Bm9Db;CACA;;EAEC,mB6Bp3DI;C7Bq3DL;CACA;;EAEC,mBAAmB;C6Bz2DrB;A7B22DA;;AAEA;C6Bx2DA,0BAAW;C7B02DV,iC6Bz2DmB;C7B02DnB,iC6Bz2DuB;C7B02DvB,0C6B/1DA;C7Bg2DA,gC6B72DD;C7B82DC,wC6Bt2DyB;C7Bu2DzB,+B6Bt2DiB;C7Bu2DjB,yC6Br2DI;C7Bs2DJ,WAAW;C8Br/DZ,mBAAY;C9Bu/DX,c8Bt/DY;C9Bu/DZ,mBQvxD4B;CRwxD5B,qB8Bt/DW;A9Bu/DZ;AACA;CACC,sB8Br/DS;C9Bs/DT,oC8B/+DE;C9Bg/DF,wB8Bv/DQ;C9Bw/DR,wDC75DW;AD85DZ;AACA;CACC,uB8BlgEU;A9BmgEX;AACA;CACC,sBSjiC8C;ATkiC/C;AACA;CACC,kCCt6DkB;ADu6DnB;;AAEA;CACC,iB8B/+De;A9Bg/DhB;;AAEA;CACC,wB8BhhEU;A9BihEX;;AAEA;CACC,mBStjCsC;ATujCvC;AACA;CACC,mB8B9+DmB;A9B++DpB;;AAEA;CACC,sBSvjC8C;ATwjC/C;;AAEA;CACC,mBSvjC0C;ATwjC3C;;AAEA;CACC,gD8Bp/DqB;C9Bq/DrB,oC8Bx+DE;A9By+DH;;AAEA;CACC,+CS3kCqC;CT4kCrC,mCS3kCsC;AT4kCvC;;AAEA;CACC,8C8Bz+D4B;C9B0+D5B,kC8Bv+DE;A9Bw+DH;;AAEA;CACC,sB8Br+DqB;C9Bs+DrB,8B8B1+DW;C9B2+DX,8BC/gEiB;CDghEjB,6BAA6B;C+B3jE9B,6BAAe;C/B6jEd,4B+B//DA;C/BggEA,4B+B3jEG;C/B4jEH,W+B/jED;C/BgkEC,qBQt1DkC;ARu1DnC;;AAEA;CACC,sB+BzjES;C/B0jET,8B+BzjEU;C/B0jEV,8B+BzjEe;C/B0jEf,6BCv4DwB;CDw4DxB,6B+BzjEuB;C/B0jEvB,4B+BzjEqC;C/B0jErC,4B+BzjEwB;C/B0jExB,W0B3jEK;C1B4jEL,qB0BxjEa;A1ByjEd;;AAEA;CACC,sBCh5DiB;CDi5DjB,8B+B3jEG;C/B4jEH,8B+BvjEI;C/BwjEJ,6B+B7jEG;C/B8jEH,6BSllCyC;CTmlCzC,4BSllCiC;CTmlCjC,4B+BhkEG;C/BikEH,W+BnjEK;C/BojEL,qBSrlCiC;ATslClC;;AAEA;CACC,sB+B9iEG;C/B+iEH,8B+B9iEG;C/B+iEH,8B+B9iEe;C/B+iEf,6BS3lCoC;CT4lCpC,6BS3lC4C;CT4lC5C,4B+B1iEG;C/B2iEH,4BS9lCoC;CT+lCpC,W+BziEK;C/B0iEL,qBAAqB;AgChmEtB;;AhCmmEA;CACC,sBgCjmEgB;ChCkmEhB,8BgCjmEqB;ChCkmErB,8BgCtkEA;ChCukEA,6BgChmEgB;ChCimEhB,6BgChmEgB;ChCimEhB,4BgChmEqB;ChCimErB,4BgChmEiB;ChCimEjB,WgChmEU;ChCimEV,qBgC/lEE;AhCgmEH;;AAEA;CACC,sBgCxlEM;ChCylEN,8BgCxlEqB;ChCylErB,8BgCnlEE;ChColEF,6BgCvlEW;ChCwlEX,6BgCtlEI;ChCulEJ,4BAA4B;CgC7kE7B,4BAAkB;ChC+kEjB,WgC9kEU;ChC+kEV,qBgC9kEoB;AhC+kErB;;AAEA;CACC,sBC77DqB;CD87DrB,8BCvnEmB;CDwnEnB,8BgC9kEmB;ChC+kEnB,6BgC9kEoB;ChC+kEpB,6BC5lEiB;CD6lEjB,4BsBjoEe;CtBkoEf,4BgC7kEA;ChC8kEA,WAAW;CgCtkEZ,qBAAkB;AAClB;;AAEA;ChCwkEC,sBSp5CiC;CTq5CjC,8BO/6DoC;CPg7DpC,8BgCtkEA;ChCukEA,6BAA6B;CgCrkE9B,6BAAkB;CAClB,4BAAkB;CAClB,4BAAkB;CAClB,WAAA;ChCukEC,qBSh6C6B;ATi6C9B;;AAEA;CACC,gBgC9kED;ChC+kEC,iCgC9kE6B;AhC+kE9B;;AAEA;CACC;EgC1kED,gBAAkB;EAClB,iCAA+B;ChC4kE9B;AACD;;AgCjkEA;ChCokEC;E2BhoEG,gBAAA;E3BkoEF,iCAAiC;CgCtkEnC;AAAA;;AhC0kEA;CACC;EgC3kED,gBAoBI;EACA,iCvBgZ6B;CTyqDhC;AACD;;AgC3jE8D;ChC8jE7D;EiCvpEG,gBAAW;EACX,iCxByxB0C;CTg4C7C;AACD;;AgClkE0C;ChCqkEzC;EiCrpEG,gBAAS;EACT,iCAAU;CjCupEb;AACD;;AAEA;CACC,qBOt6DS;APu6DV;;AAEA;CACC,kCO7jE4B;CP8jE5B,qCiCnqEoB;CjCoqEpB,gBOx+DS;CPy+DT,kBAAkB;CiCjsEf,gBAAe;AAAf;;AACA;CjCqsEH,+BiCvpEI;CjCwpEJ,kCAAkC;CiCvsE/B,qBAkDF;AjCupEF;;AAEA;CACC,gCiCnpEmC;CjCopEnC,mCQz+DkC;CR0+DlC,qBQ1+DkC;AR2+DnC;AACA;CACC;EACC,qBAAqB;CiCltEnB;AjCotEJ;;AAEA;CiCttEI,mBA+EF;CjCyoED,kBCpnEW;CDqnEX,ciCztEG;AjC0tEJ;;AAEA;CACC,ciCpoES;CjCqoET,WiC9tEG;CjC+tEH,0BC3nEkB;CD4nElB,mBSt/C+B;CTu/C/B,gBAAgB;CiCjuEb,gBAoGF;CjC+nED,ciC7nEiB;CjC8nEjB,yBiChoEC;CjCioED,4BCjoEkB;CDkoElB,yBiCloEC;CjCmoED,gBiCttEqB;CjCutErB,uBiCpoEC;CjCqoED,wEiCvnEM;AjCwnEP;AiCrnEE;CjCunED;EACC,gBAAgB;CiC7uEd;AA4HF;AAAA;CjCqnED,gBiC9uEI;AjC+uEL;AACA;CACC,eiCxnEc;AjCynEf;AACA;CgCxoEyG,cAAA;ChC0oExG,yBiCpuEgB;CjCquEhB,qBiCpuEc;CjCquEd,UiCpuEG;CjCquEH,iDOniEoC;APoiErC;AACA;CgC/oEmF,aAAA;AhCipEnF;AACA;CACC,ciCluEa;CjCmuEb,UiCluEY;AjCmuEb;AACA;;CAEC,yBOl/DoC;CPm/DpC,UsBjwEO;AtBkwER;AACA;CACC,0BOzoE4B;CP0oE5B,2BiC/uEoB;CjCgvEpB,0BOpjEoC;CPqjEpC,cAAc;CiC7wEX,yBA4CE;CA5CF,oBAAe;CACf,qBA2CE;CA3CF,mBA4CE;CjCquEL,eiCpuEmB;CjCquEnB,4BAA4B;CiCnxEzB,gBAkDF;CjCmuED,qIC9qEkB;AD+qEnB;AACA;CACC;EiC9tEO,gBAAA;CjCguEP;AACD;AACA;CACC,yBStjD+B;ATujDhC;AiC9xEI;CjCgyEH,0BQ5jEkC;CR6jElC,2BQ7jEkC;CR8jElC,0BAA0B;CiClyEvB,cA+EF;CjCqtED,yBiCjyEI;CjCkyEJ,oBiCttEC;CjCutED,qBSp2CuC;CTq2CvC,mBiChtEyB;CjCitEzB,eiChtES;CjCitET,4BS32CwC;CT42CxC,gBiC3tEC;CjC4tED,6ICpsEkB;CDosElB,qICpsEkB;ADqsEnB;AACA;CiC7yEI;EAsGE,wBhCCM;EgCDN,gBhCCM;CDysEX;AACD;AACA;CACC,yBS5kD+B;AT6kDhC;;AAEA;CiCjsEE,cAAA;CjCmsED,WiCjsEK;CjCksEL,oBAAoB;CiCzzEjB,gBA2HF;CACA,gBAAa;CAAb,cAAa;CjCisEd,6BiC1zEI;CjC2zEJ,yBiCnsEC;CjCosED,mBiCnsEc;AjCosEf;AACA;;CkCn0EA,gBAAK;ClCs0EJ,ekCr0EU;AlCs0EX;;AAEA;CACC,sCkCp0EmB;ClCq0EnB,uBkCp0EyD;ClCq0EzD,qBkCn0EiB;ClCo0EjB,uBkCn0E4C;AlCo0E7C;AACA;CACC;EmCrtEC,qB1BymB4B;CT8mD7B;AACD;AACA;CACC,uB0Br0Ea;C1Bs0Eb,wBkCt1EI;ClCu1EJ,yBkCzyEA;AlC0yED;AACA;CACC,uBkC11ED;ClC21EC,wBkCn0Ea;ClCo0Eb,yBSnnD+B;ATonDhC;;AAEA;CACC,oCkCnzEE;ClCozEF,oBAAoB;CkC1yEnB,qBAAe;ClC4yEhB,uBsB51EW;AtB61EZ;AACA;CACC,oBmCj1ES;CnCk1ET,qBsBh2EW;CtBi2EX,uBQzpES;AR0pEV;AACA;CACC,oBsBp2EW;CtBq2EX,qBQ7pES;CR8pET,uBQ9pES;AR+pEV;;AAEA;CACC,wCmCr0E2B;AnCs0E5B;;AAEA;CACC,sCmCl0EI;AnCm0EL;;AAEA;CACC,oCmC3zEE;AnC4zEH;;AAEA;CACC,WAAW;CkCt0EV,YAAA;ClCw0ED,kBsBv3EW;AtBw3EZ;AACA;CACC,emC72EE;AnC82EH;AACA;CACC,amC72EG;CnC82EH,uBkC/0EC;AlCg1EF;AACA;CACC,amC12EG;CnC22EH,uBSjqD+B;ATkqDhC;;AAEA;CACC,csBt4EW;CtBu4EX,WmCj2EG;CnCk2EH,4CmCr1EE;CnCs1EF,uCmC91EI;CnC+1EJ,mBmCz2EW;CnC02EX,gBkC51EC;ClC61ED,gBmC51EiB;CnC61EjB,cmCx1EC;CnCy1ED,yBsB94EW;CtB+4EX,yDClzEkB;CDmzElB,4BmCp1EE;CnCq1EF,yCAAyC;CkCl2ExC,0BAAe;ClCo2EhB,yBsBn5EW;CtBo5EX,uBCtzEW;CDuzEX,wEkCp2EE;ClCq2EF,gBmCz4EE;AnC04EH;AACA;CACC;EmCt4EC,gBAAgB;CnCw4EjB;AACD;AACA;CACC,qBS7rD+B;CT8rD/B,UmC/3EC;CnCg4ED,iDmC93EE;AnC+3EH;AACA;;CAEC,sBQluES;CRmuET,sBmCr4EmB;AnCs4EpB;AACA;CACC,yBSvsD+B;ATwsDhC;AACA;CACC,kBmCn3EG;CnCo3EH,0BC90EkB;AD+0EnB;;AAEA;CACC,oBCj1EW;CDk1EX,uBCl1EkB;CDm1ElB,oBmCr6ES;CnCs6ET,qBsBn7EW;CtBo7EX,uBQlvES;ARmvEV;AACA;CACC;EACC,qBQtvEQ;CRuvET;AACD;;AAEA;CACC,mBmCz5EU;CnC05EV,sBsB97EW;CtB+7EX,kBmCz5EG;CnC05EH,qBQ9vES;CR+vET,uBmCj6EmB;AnCk6EpB;;AAEA;CACC,cmCh5EE;CnCi5EF,qBsBt8EW;CtBu8EX,mBmC/4EmB;CnCg5EnB,uBCz2EW;AD02EZ;AkC15EE;ClC45ED,WsB38EO;CtB48EP,mBC52EW;AD62EZ;;AAEA;CACC,UoCx9EC;CpCy9ED,WmCj8EG;CnCk8EH,kBmC/7EiB;CnCg8EjB,mBsBn9EW;CtBo9EX,yBQlxES;CRmxET,4BQnxEoC;CRoxEpC,2BSrvD+B;CTsvD/B,wBkCx6EC;ClCy6ED,qCkCz6EC;ClC06ED,gBkC16EC;ClC26ED,iCsB19EW;StB09EX,yBsB19EW;AtB29EZ;AACA;CACC,qBmC77EmB;AnC87EpB;AACA;CACC,kBmCh7EoB;AnCi7ErB;AACA;CACC,uBCn4EW;ADo4EZ;AACA;CkCt7EE,qBAAe;ClCw7EhB,UsBv+EO;CtBw+EP,iDCv4EkB;ADw4EnB;AACA;CACC,yBsB3+EW;CtB4+EX,qBQ1yES;AR2yEV;AACA;CACC,yDsB/+EW;AtBg/EZ;AACA;CACC,yDmCp9EE;AnCq9EH;AACA;CACC,yBmCj9EU;CnCk9EV,qBsBt/EW;CtBu/EX,yDQrzEoC;ARszErC;AACA;CACC,oBmCz9EkB;CnC09ElB,YkC58EC;ClC68ED,UmC58EO;AnC68ER;AACA;;CAEC,UmCr8EG;AnCs8EJ;;AAEA;CACC,mBCl6EW;ADm6EZ;AACA;CACC,YsBvgFO;CtBwgFP,mBoChhFiB;CpCihFjB,yDmCx/EE;CnCy/EF,8KmCt/ES;CnCu/ET,gCsB3gFW;CtB4gFX,kBoCphFC;CpCqhFD,iDQ30EoC;AR40ErC;AACA;CACC;EmC5+EC,gBDWA;ClCm+ED;AACD;AACA;CACC,yDmC1+EU;AnC2+EX;AACA;CACC,iCmCx+E+C;CnCy+E/C,yDmCn+EY;AnCo+Eb;;AAEA;CACC,qBAAqB;CkC9+EpB,kBAAe;AlCg/EjB;;AAEA;CACC,kBmCrhFS;CnCshFT,sBsBpiFW;CtBqiFX,oBoC5iFiB;ApC6iFlB;AACA;;CAEC,oBoChjFiB;CpCijFjB,YmClhFG;CnCmhFH,amC9gFe;AnC+gFhB;;AAEA;CACC,WsB/iFO;CtBgjFP,cmCzgFG;CnC0gFH,UmCvgFG;CnCwgFH,6BkClgFC;ClCmgFD,gBmCjhFW;AnCkhFZ;AACA;CACC,UmChgFE;AnCigFH;AACA;CACC,oEmC5/EE;AnC6/EH;AkCpgFE;ClCsgFD,oEC/9EkB;ADg+EnB;AACA;CACC,SmCl/EQ;AnCm/ET;AACA;CACC,WmCh/EW;CnCi/EX,YmC/+EG;CnCg/EH,oBmC7+EmB;CnC8+EnB,yBkC/gFC;ClCghFD,SmC1+EQ;CnC2+ER,mBmC1+EmB;CnC2+EnB,oHmCh+EE;CnCg+EF,4GmCh+EE;CnCi+EF,gBmCl/EW;AnCm/EZ;AACA;CACC;EACC,wBCh/EiB;EDg/EjB,gBCh/EiB;CDi/ElB;AACD;AkCzhFE;ClC2hFD,yBCn/EkB;ADo/EnB;AACA;CACC,WsBnlFO;CtBolFP,cmCvgFG;CnCwgFH,kBCx/EW;CDy/EX,emCrgFW;CnCsgFX,yBSt3D+B;CTu3D/B,yBkCniFC;ClCoiFD,mBmClgFkB;AnCmgFnB;AACA;CACC,WmC//EG;CnCggFH,YmCvgFC;CnCwgFD,yBkCziFC;ClC0iFD,SmC3/EO;CnC4/EP,mBmCv/EC;CnCw/ED,iHCpgFkB;CDogFlB,4GCpgFkB;CDqgFlB,gBmCt/EG;AnCu/EJ;AkC9iFE;ClCgjFD;EmC5hFC,qBlCqBU;EkCrBV,gBlCqBU;CDygFX;AACD;AACA;CACC,yBC5gFkB;AD6gFnB;AACA;CACC,WmCvhFW;CnCwhFX,cmCvhFW;CnCwhFX,kBsB/mFW;CtBgnFX,emCphFG;CnCqhFH,yBCnhFkB;CDohFlB,yBkC7jFC;ClC8jFD,mBmC5hFW;AnC6hFZ;AACA;CACC,oBCxhFkB;ADyhFnB;AACA;CkCnkFE,yBAAuB;AlCqkFzB;AACA;CACC,yBmCjjFS;AnCkjFV;;AAEA;CACC,kBmC/iFiB;AnCgjFlB;AACA;;CAEC,0BsBpoFW;CtBqoFX,iBmCziFG;AnC0iFJ;AACA;CACC,kBmCjjFW;CnCkjFX,MmCriFO;CnCsiFP,OmCjiFC;CnCkiFD,YC5iFW;CD6iFX,qBmChiFqB;CnCiiFrB,oBAAoB;CkCxlFnB,6BAAuB;ClC0lFxB,qBC/iFkB;CDgjFlB,gEkCzlFE;AlC0lFH;AACA;CACC;EACC,gBCpjFU;CDqjFX;AACD;AACA;CACC,qBkCnmFC;AlComFF;AACA;CACC,kBC3jFW;AD4jFZ;AACA;;CAEC,qBmCtjFE;CnCujFF,wBChkFkB;ADikFnB;AACA;CkC7mFE,qBAAuB;ClC+mFxB,wBCnkFkB;ADokFnB;AACA;CACC,qBsBvqFW;CtBwqFX,wBCvkFW;ADwkFZ;AACA;;;CAGC,amCtlFW;CnCulFX,8DsB9qFW;AtB+qFZ;AACA;CACC,amC3lFW;CnC4lFX,8DkC7nFC;AlC8nFF;;AAEA;CACC,kBmC1kFG;CnC2kFH,aAAa;CkCloFZ,eAAA;ClCooFD,oBCvlFkB;CDwlFlB,WmCjnFC;AnCknFF;AACA;;CAEC,kBC5lFW;CD6lFX,cmC9mFW;CnC+mFX,SmC7mFG;CnC8mFH,YmC3mFW;AnC4mFZ;AACA;;CAEC,UmCxmFG;AnCymFJ;AACA;CACC,kBmCpmFoB;CnCqmFpB,UmChmFC;AnCimFF;AACA;CACC,UAAU;AkCvpFT;;AlC0pFF;CACC,amCroFC;CnCsoFD,mBsBltFW;CtBmtFX,0BC/mFW;CDgnFX,mBChnFW;CDinFX,gBmCnoFW;CnCooFX,gBmCloFgB;CnCmoFhB,cmChoFW;CnCioFX,kBmChoFkB;CnCioFlB,mBsBztFW;CtB0tFX,yBCtnFW;CDunFX,yBCvnFkB;CDwnFlB,uBmCroFmB;AnCsoFpB;;AAEA;;;;CkC7pFA,oBAAU;ClCkqFT,qBShqEgC;CTiqEhC,uBCxoFkB;ADyoFnB;;AAEA;;;;CkC3oFA,uBGxCa;CrCwrFZ,qBShgEiC;CTigEjC,uBO3hFoC;AP4hFrC;AACA;CkC/oFA;;;;E3B2BI,qBAAmB;CP0nFtB;AACD;;AsClwFA;;CtCswFC,mB0BlvFa;A1BmvFd;;AAEA;;CAEC,0BAA0B;CsClwF3B,6BACe;AtCmwFf;;AsC9vFA;;CtCkwFC,0BsChwFiB;CtCiwFjB,6BSvuEyC;ATwuE1C;;AAEA;;CAEC,iBsClwFW;CtCmwFX,yBsClwFe;CtCmwFf,4BS7uEwC;AT8uEzC;;AAEA;CACC,aAAa;CuC5xFd,WAAO;CACP,mBAAQ;CACR,kBAAS;CACT,cAAW;AvC8xFX;;AgChsFuB;ChCmsFtB,kBuC5xFc;CvC6xFd,SwCxwFG;CxCywFH,UwCxwFY;CxCywFZ,awCxwFK;CxCywFL,ewCxwFK;CxCywFL,uBwCxwFgB;CxCywFhB,kBSxwE6B;CTywE7B,qBSzwE6B;CT0wE7B,WwCzyFC;CxC0yFD,wCwCzyF4C;CxC0yF5C,uBwCrvFU;AxCsvFX;AACA;CgC/sF6C;EOjF3C,qBAAkB;CvCmyFnB;AACD;;AAEA;;;;CAIC,cuClyFa;AvCmyFd;;AAEA;;CAEC,qBC5oF6B;CD6oF7B,qCuChyFmB;CvCiyFnB,yDuChyFY;CvCiyFZ,4BuChyFU;CvCiyFV,4DuC/xFE;CvCgyFF,kEAAkE;AuCrxF/D;AvCuxFJ;;CAEC,qBuCrxFkB;CvCsxFlB,iDuCpxFM;AvCqxFP;;AAEA;;CAEC,qCuClxFe;CvCmxFf,oFuCjxFM;AvCkxFP;;AAEA;;CAEC,qBuCryFG;AvCsyFJ;AACA;;;;CAIC,uBuC9xFe;CvC+xFf;yCAC2O;CiB9xFxO,+DAAwB;CjBgyF3B,6EuC/yFiC;AvCgzFlC;AACA;;CAEC,qBuC7yFM;CvC8yFN,iDuC3yF+B;AvC4yFhC;;AAEA;;CAEC,qBAAqB;AiB1yFlB;AjB4yFJ;;CAEC,yBuC7zFG;AvC8zFJ;AACA;;CAEC,iDuCjzFI;AvCkzFL;AACA;;CAEC,cAAc;AiBtzFX;;AjByzFJ;CACC,kBuCz0FG;AvC00FJ;;AAEA;;;;CAIC,UuCl0FW;AvCm0FZ;AiBl0FI;;;;CjBu0FH,UuCl1FY;AvCm1Fb;;AAEA;CACC,auCj1FG;CvCk1FH,WuC90FY;CvC+0FZ,mBuC70FM;CvC80FN,kBAAkB;CuCt0FnB,cACE;AvCu0FF;;AAEA;CACC,kBS5wDmC;CT6wDnC,SAAS;CwCr3FN,UDiDF;CvCs0FD,awCt3Fc;CxCu3Fd,eSj3E6B;CTk3E7B,uBSn3E6B;CTo3E7B,kBwCt3FgB;CxCu3FhB,qBwCh5Fc;CxCi5Fd,WwCh5FC;CxCi5FD,wCwCh5FkC;CxCi5FlC,uBwCh5F2B;AxCi5F5B;AwCn2FI;CxCq2FH;EACC,qBAAqB;CuC50FvB;AvC80FA;;AAEA;;;;CwCt4FI,cD+DF;AvC40FF;;AAEA;;CAEC,qBwC75F0B;CxC85F1B,qCwC75FgB;CxC85FhB,yDwC75F8C;CxC85F9C,4BwCt4FI;CxCu4FJ,4DAA4D;CwCv3FzD,kEAAe;AxCy3FnB;AACA;;CAEC,qBuCr1FI;CvCs1FJ,iDAAiD;AuCl1FlD;;AvCq1FA;;CAEC,qCuCl1FgB;CvCm1FhB,oFuCj1FE;AvCk1FH;;AAEA;;CAEC,qBS95E6B;AT+5E9B;AACA;;;;CwCn5FM,uBD6DJ;CvC21FD;yCSp6E+C;CTs6E/C,+DSv6E+C;CTw6E/C,6EwCv5FkB;AxCw5FnB;AACA;;CAEC,qBAAqB;CwCt5FlB,iDAAe;AxCw5FnB;;AwCj6FM;;CxCq6FL,qBAAqB;AuC91FtB;AvCg2FA;;CAEC,yBuC/1FiB;AvCg2FlB;AACA;;CAEC,iDuC31Fe;AvC41FhB;AACA;;CAEC,cSn5E6B;ATo5E9B;;AAEA;CACC,kBuC31Fc;AvC41Ff;;AAEA;;;;CAIC,UsBl+FO;AtBm+FR;AACA;;;;CAIC,UuCt0FG;AvCu0FJ;;AAEA;CACC,qBAAqB;CuC/zFtB,gBAAiB;CvCi0FhB,gBuCh0Fe;CvCi0Ff,cSr3DmC;CTs3DnC,kBuCh0FiB;CvCi0FjB,qBOluFS;CPmuFT,sBCj9FiB;CDk9FjB,euCh0Fc;CvCi0Fd,yBOx3FW;SPw3FX,iBOx3FW;CPy3FX,6BuCx0FgB;CvCy0FhB,6BuCl0FA;CvCm0FA,yBAAyB;CuCh0F1B,mBAAoB;CvCk0FnB,uBuCj0Fe;CvCk0Ff,qICr0FwB;ADs0FzB;AACA;CuC9zFA;EACE,gBtCjKgB;CDi+FjB;AACD;AACA;CACC,cCp+FU;ADq+FX;AACA;;CAEC,UuCx0FD;CvCy0FC,iDsBvgGW;AtBwgGZ;AACA;;;CAGC,oBsB3gGO;CtB4gGP,auC/0FD;AvCg1FA;;AAEA;CACC,WAAW;CqC3hGZ,yBAAU;CACV,qBAAoB;ArC6hGpB;AACA;CACC,WqC5hGC;CrC6hGD,yBqC3hGO;CrC4hGP,qBqCjiGkB;ArCkiGnB;AACA;;CAEC,WqCtiGS;CrCuiGT,yBqCxhGa;CrCyhGb,qBqCxhGO;CrCyhGP,iDqCxhGc;ArCyhGf;AACA;;;;;CAKC,WqC/iGD;CrCgjGC,yBqC7hGE;CrC8hGF,qBAAqB;AqC1hGtB;ArC4hGA;;;;;CAKC,iDAAiD;AqCvhGlD;AAAA;;CrC2hGC,WAAW;CqC3hGZ,yB3BiCQ;C2BjCR,qBASI;ArCqhGJ;;AAEA;CqChiGA,WAAU;CAAV,yBRuGA;CQvGA,qBAmBI;ArCihGJ;AACA;CACC,WAAW;CqClgGZ,yBAAuB;CrCogGtB,qBqCngGgB;ArCogGjB;AACA;;CAEC,WqCxgGD;CrCygGC,yBqCjgGE;CrCkgGF,qBqC1gGD;CrC2gGC,iDqC//FE;ArCggGH;AqC7/FA;;;;;CrCmgGC,WqC7/FC;CrC8/FD,yBqC5/FA;CrC6/FA,qBAAqB;AqC1+FtB;ArC4+FA;;;;;CAKC,iDqCz+FE;ArC0+FH;AACA;;CAEC,WqCr/FD;CrCs/FC,yBqCr+FG;CrCs+FH,qB2B9jGG;A3B+jGJ;;AAEA;CACC,W2BhlGG;C3BilGH,yB2BhlGG;C3BilGH,qBAAqB;AyCzmGtB;AzC2mGA;CACC,WyC1mGU;CzC2mGV,yByC1mGgB;CzC2mGhB,qByC1mGiB;AzC2mGlB;AACA;;CAEC,WyCzmGU;CzC0mGV,yBS7jEuC;CT8jEvC,qBCjhGkB;CDkhGlB,gDyCvmGyD;AzCwmG1D;AACA;;;;;CAKC,WyCpnGQ;CzCqnGR,yBCtlGiB;CDulGjB,qByCpmGmB;AzCqmGpB;AACA;;;;;CAKC,gDyC7lGmB;AzC8lGpB;AACA;;CAEC,WyCtmGD;CzCumGC,yBCvmGU;CDwmGV,qByC3lGgB;AzC4lGjB;;AAEA;CACC,WyCzlGK;CzC0lGL,yByCtlGU;CzCulGV,qByCtlGU;AzCulGX;AACA;CACC,WyCtlGG;CzCulGH,yByCplGe;CzCqlGf,qBStpFgC;ATupFjC;AACA;;CyC1kGA,WACE;CzC4kGD,yByC3kGmB;CzC4kGnB,qByC3kGY;CzC4kGZ,gDyC1kGE;AzC2kGH;AyChlGA;;;;;CAmBA,WACI;CADJ,yBAEY;CzCmkGX,qByClkGiB;AzCmkGlB;AACA;;;;;CAKC,gDyC9jGE;AzC+jGH;AyC5jGA;;CzC+jGC,WyC5jGU;CzC6jGV,yBAAyB;CyCpjG1B,qBACI;AzCqjGJ;;AyCtjGA;CzCyjGC,WyCpjGY;CzCqjGZ,yBAAyB;C0C7qG1B,qBAAQ;A1C+qGR;AACA;CACC,W0C9qGU;C1C+qGV,yB0C9qGoB;C1C+qGpB,qB0C9qGkB;A1C+qGnB;AACA;;CAEC,W0ChqGG;C1CiqGH,yB0CxqGgB;C1CyqGhB,qB0CxqGqB;C1CyqGrB,iD0CxqGsB;A1CyqGvB;AACA;;;;;CAKC,WO56FiB;CP66FjB,yB0CtpGyD;C1CupGzD,qB0CtpGoB;A1CupGrB;A0C1oGA;;;;;C1CgpGC,iD0CjoGA;A1CkoGD;AACA;;CAEC,W0CppGD;C1CqpGC,yB0CvoGE;C1CwoGF,qBAAqB;A0ChoGtB;;A1CmoGA;CACC,WAAW;C0CtnGZ,yBAAiB;C1CwnGhB,qB0CvnGiB;A1CwnGlB;AACA;CACC,WAAW;C0ClnGZ,yBAAgB;C1ConGf,qBS1oEmC;AT2oEpC;AACA;;CAEC,WS1uF6B;CT2uF7B,yBC5jGqC;CD6jGrC,qBS5oEmC;CT6oEnC,gD0B9tG2C;A1B+tG5C;AACA;;;;;CAKC,W0CnnGU;C1ConGV,yBS7gF+B;CT8gF/B,qBAAqB;A0C9mGtB;A1CgnGA;;;;;CAKC,gD0C/mG4B;A1CgnG7B;AACA;;CAEC,W0C9mGW;C1C+mGX,yB0C7mGA;C1C8mGA,qBAAqB;AiBzsGlB;;AjB4sGJ;CACC,W0CpmGO;C1CqmGP,yB0CnmGO;C1ComGP,qB0CnmGyB;A1ComG1B;AACA;CACC,W0C5mGI;C1C6mGJ,yBS3rEmC;CT4rEnC,qBS5rEmC;AT6rEpC;AACA;;CAEC,W0C3lGS;C1C4lGT,yB0C1lGQ;C1C2lGR,qB0CzlGO;C1C0lGP,kD0CxlGQ;A1CylGT;AACA;;;;;CAKC,W0CrlGS;C1CslGT,yB0CrlGqB;C1CslGrB,qB0CrlGyB;A1CslG1B;AACA;;;;;CAKC,kD0CplGqB;A1CqlGtB;AACA;;CAEC,W0CllGS;C1CmlGT,yB0CllGqB;C1CmlGrB,qB0CllGmB;A1CmlGpB;;AiBlvGI;CjBqvGH,W0C/oGG;C1CgpGH,yB0C9oGwB;C1C+oGxB,qB0C9oGwB;A1C+oGzB;AACA;CACC,W0CppGI;C1CqpGJ,yB0C5oG6B;C1C6oG7B,qB0CtpGI;A1CupGL;AACA;;CAEC,W0CvoGS;C1CwoGT,yB0CroGO;C1CsoGP,qB0CroGkB;C1CsoGlB,gD0CpoGQ;A1CqoGT;AACA;;;;;CAKC,W0C/nGe;C1CgoGf,yB0C/nGsB;C1CgoGtB,qB0C/nGqB;A1CgoGtB;AACA;;;;;CAKC,gD0C9nGqB;A1C+nGtB;AACA;;CAEC,W0C9nGS;C1C+nGT,yB0C5nGO;C1C6nGP,qB0C5nGsB;A1C6nGvB;;AAEA;CACC,cAAc;CiB7xGX,qBAAmB;AjB+xGvB;AACA;CACC,W0CxrGO;C1CyrGP,yB0CvrGO;C1CwrGP,qB0CvrGyB;A1CwrG1B;AACA;;CAEC,gDS/wEwC;ATgxEzC;AACA;;;;;CAKC,W0CxsGI;C1CysGJ,yB0C5qGQ;C1C6qGR,qB0C3qGO;A1C4qGR;AACA;;;;;CAKC,gD0CzqGuC;A1C0qGxC;AACA;;CAEC,c0B12GK;C1B22GL,6B0CxqGQ;A1CyqGT;;AAEA;CACC,c0CxqGS;C1CyqGT,qB0CxqGyB;A1CyqG1B;AACA;CACC,W0CtqGS;C1CuqGT,yB0CtqGmB;C1CuqGnB,qB0CtqGqB;A1CuqGtB;AiBv0GI;;CjB00GH,iD0CluGwB;A1CmuGzB;AACA;;;;;CAKC,W0C9tGW;C1C+tGX,yBS1zEmC;CT2zEnC,qB0C3tGO;A1C4tGR;AACA;;;;;CAKC,iD0CrtGyB;A1CstG1B;AACA;;CAEC,c0CntGkB;C1CotGlB,6B0CntGsB;A1CotGvB;;AAEA;CACC,c0CntGS;C1CotGT,qB0CntGuB;A1CotGxB;AACA;CACC,W0CjwGI;C1CkwGJ,yB0CltGO;C1CmtGP,qB0CltGqB;A1CmtGtB;AACA;;CAEC,gD0ChtGsB;A1CitGvB;AACA;;;;;CAKC,W0C5wGO;C1C6wGP,yB0C5wGwB;C1C6wGxB,qB0ChxGQ;A1CixGT;AACA;;;;;CAKC,gD0CrwG0B;A1CswG3B;AACA;;CAEC,c0CnwGS;C1CowGT,6B0CjwGO;A1CkwGR;;AAEA;CACC,c0ChyGI;C1CiyGJ,qB0C7vGmB;A1C8vGpB;AACA;CACC,W0C7vGS;C1C8vGT,yB0C7vGqB;C1C8vGrB,qB0C7vGyB;A1C8vG1B;AACA;;CAEC,gD0C5vGQ;A1C6vGT;AACA;;;;;CAKC,W0C1vGS;C1C2vGT,yB0C1vGqB;C1C2vGrB,qB0C1vGmB;A1C2vGpB;AACA;;;;;CAKC,gD0C1yGQ;A1C2yGT;AACA;;CAEC,c0CjzGW;C1CkzGX,6B0ChzGU;A1CizGX;;AAEA;CACC,c0C5yGkB;C1C6yGlB,qB0C5yGyB;A1C6yG1B;AACA;CACC,W0C70GD;C1C80GC,yB0CvyGQ;C1CwyGR,qB0CtyGO;A1CuyGR;AACA;;CAEC,iD0CtyGqB;A1CuyGtB;AACA;;;;;CAKC,W0C11GD;C1C21GC,yB0CryGO;C1CsyGP,qB0CryGqB;A1CsyGtB;AACA;;;;;CAKC,iD0ClyGQ;A1CmyGT;A0CvxGA;;C1C0xGC,c0C1xGY;C1C2xGZ,6BsB3/GW;AtB4/GZ;;AAEA;CACC,c0C/xGY;C1CgyGZ,qBsBhgHO;AtBigHR;AACA;CACC,WAAW;C0CnyGZ,yBAwBI;CAxBJ,qBAUE;A1C4xGF;AACA;;CAEC,gDsBzgHW;AtB0gHZ;AACA;;;;;CAKC,WsBhhHO;CtBihHP,yB0C1wGC;C1C2wGD,qB0C3wGC;A1C4wGF;AACA;;;;;CAKC,gD0C/vGI;A1CgwGL;A0CvwGA;;C1C0wGC,c0ChwGC;C1CiwGD,6BsB/hHO;AtBgiHR;;AAEA;C0C9wGA,cAUE;CAVF,qBAUE;A1CuwGF;AACA;C0ClxGA,WAAY;C1CoxGX,yBsBxiHO;CtByiHP,qBsBziHO;AtB0iHR;A0CtxGA;;C1CyxGC,kDAAkD;A0CzxGnD;A1C2xGA;;;;;CAKC,WAAW;C2C3jHZ,yBAAM;C3C6jHL,qB2C5jHmB;A3C6jHpB;AACA;;;;;CAKC,kDsB5jHW;AtB6jHZ;AACA;;CAEC,c2CzjHc;C3C0jHd,6B2CvjHe;A3CwjHhB;;AAEA;CACC,c2CtjHK;C3CujHL,qB2BtjHG;A3BujHJ;AACA;CACC,W2CrjHK;C3CsjHL,yB2B5iHG;C3B6iHH,qB2B5iHG;A3B6iHJ;AACA;;CAEC,gDAAgD;A2C9iHjD;A3CgjHA;;;;;CAKC,WAAW;C2CziHZ,yBAAe;C3C2iHd,qB2C1iHuC;A3C2iHxC;AACA;;;;;CAKC,gD2CliHE;A3CmiHH;A2C5hHA;;C3C+hHC,c2C7hHc;C3C8hHd,6BsBpmHO;AtBqmHR;;AAEA;CACC,gBAAgB;C2CxhHjB,cAAa;C3C0hHZ,0BY9lHY;AZ+lHb;AACA;CACC,c2C7hHW;A3C8hHZ;AACA;;CAEC,c2ChhHa;A3CihHd;;AAEA;;CAEC,oB2C9gHqB;C3C+gHrB,qB2C9gHK;C3C+gHL,uBAAuB;A2C1gHxB;;A3C6gHA;;C2CvgHA,uBAAkB;C3C0gHjB,qB2CzgHmB;C3C0gHnB,uB2CzgHO;A3C0gHR;AACA;CACC;;E2B3nHG,qBnB+O+B;CR+4GlC;A2CvgHD;;AAEA;C3CygHC,gC2CvgHA;A3CwgHD;A2CtgHA;CACA;EhBrHI,gBAAA;C3B8nHH;AACD;A2CtgHA;CACA,UAAA;A3CwgHA;;AAEA;C2CjgHA,aAGI;A3CggHJ;;AiBnmHI;CjBsmHH,S2CtgHD;C3CugHC,gB2C//GgB;C3CggHhB,6B2Ch9GA;A3Ci9GD;AACA;CACC;EACC,gB2C5gHS;C3C6gHV;AACD;AACA;CACC,Q2B5oHG;C3B6oHH,Y2B5oHG;C3B6oHH,4B2CtgHU;A3CugHX;AACA;CACC;EACC,gB2CthHF;C3CuhHC;AACD;;AAEA;;;;CAIC,kB2C9hHU;A3C+hHX;;AAEA;C4C5rHA,mBAAkB;A5C8rHlB;AACA;CACC,qB4C7rHoB;C5C8rHpB,oB4C7rHY;C5C8rHZ,uBS18EgD;CT28EhD,WOl6GiB;CPm6GjB,uBC9rHmB;CD+rHnB,qC4C7rHiB;C5C8rHjB,gB4C7rHC;C5C8rHD,oC4C7rHU;A5C8rHX;AACA;CACC,cSz6F6B;AT06F9B;;AAEA;CACC,kB4C9sHgB;C5C+sHhB,aQhgHS;CRigHT,a4C/rHG;C5CgsHH,gB4C/rHe;C5CgsHf,iB4CltHD;C5CmtHC,S4C9rHK;C5C+rHL,mBSl8EyC;CTm8EzC,c4CrtHD;C5CstHC,gB4C1rHgB;C5C2rHhB,gBSz8EyC;CT08EzC,sBS18EgD;CT28EhD,4B4C1rHoB;C5C2rHpB,qC4C1rHc;C5C2rHd,uBQxlHgB;ARylHjB;AACA;CACC,S0BltHK;C1BmtHL,O0B/sHK;C1BgtHL,oB4ChuHD;A5CiuHA;;AAEA;CACC,oB4CpuHgB;A5CquHjB;AACA;CACC,W4CzrHU;C5C0rHV,O4CzrHG;A5C0rHJ;;AAEA;CACC,kBAAkB;A4CrrHnB;A5CurHA;CACC,Q4CtrHO;C5CurHP,U4CzrHD;A5C0rHA;;AAEA;CACC;EACC,oB2B5tHE;C3B6tHH;CACA;E4ChsHD,WAAA;E5CksHE,O2BntHE;C3BotHH;CACA;EACC,kB2BttHE;C3ButHH;CACA;EACC,Q2BztHE;E3B0tHF,U2BztHE;C3B0tHH;A4C1qHD;;A5C6qHA;C4CpqHA;EAEI,oBACD;C5CoqHF;C4CvqHD;EAMI,WAAA;EACA,OAAA;C5CoqHH;CACA;EACC,kB4CnqHmC;C5CoqHpC;CACA;E4C/qHD,QAAA;E5CirHE,U2BlwHE;C3BmwHH;A6CtxHD;;A7CyxHA;CACC;E6CtxHC,oBpCw/CsC;CTgyEvC;CACA;E6ClxHD,WAAA;EAGI,OAAA;C7CkxHH;CACA;EACC,kBSvyEkC;CTwyEnC;CACA;EACC,QAAQ;E6C1xHV,UAAA;C7C4xHC;AACD;;AAEA;CACC;EWtyHC,oBmCFD;C9C0yHA;C8CxyHD;EACE,WAAU;EACV,OAAO;C9C0yHR;CACA;E8CxyHC,kBxBCM;CtByyHP;CACA;E0BjyHK,QAAQ;E1BmyHZ,U8ClzHF;C9CmzHC;AACD;;AAEA;CACC;EACC,oBCpxHS;CDqxHV;CACA;EACC,WQ7mHQ;ER8mHR,O8CxyHE;C9CyyHH;CACA;EACC,kBAAkB;C8CryHpB;C9CuyHC;EACC,QAAQ;E8CxyHV,UAAU;C9C0yHT;AACD;;AAEA;CACC,SAAS;C8C9yHV,YAAU;C9CgzHT,aCnyHU;CDoyHV,uB8CnyHuB;A9CoyHxB;;AAEA;C8C90HA,qBCDa;C/Ci1HZ,oBS/pFmC;CTgqFnC,uBAAuB;C+C70HtB,WAAU;C/C+0HX,a2BvyHG;C3BwyHH,qCCrqHqC;CDsqHrC,0BAA0B;C+Cj1HzB,oCASiB;A/C00HnB;;AAEA;C+C11HE,cAAA;A/C41HF;;AAEA;C+Ct1HQ,MAAA;C/Cw1HP,W2BnzHG;C3BozHH,U2BnzHG;C3BozHH,aAAa;C+Cp1HN,qBATN;A/C+1HF;;AAEA;C+Ct2HE,qBAAA;C/Cw2HD,oBSprFmC;CTqrFnC,uBOnlHoC;CPolHpC,WOvuHW;CPwuHX,mC+C32HY;C/C42HZ,eOhkHmB;CPikHnB,sCAAsC;C+Cr2H/B,wBAHI;A/C02HZ;;AAEA;C+Cn2HQ,cATN;A/C82HF;;AAEA;CgDp3HA,iBAAO;AhDs3HP;;AAEA;CACC,MgDr3HC;ChDs3HD,WgDr3HC;ChDs3HD,UsBr3HO;CtBs3HP,agDr3Ha;ChDs3Hb,sBgDr3HoB;AhDs3HrB;;AAEA;CACC,qBgDj3HE;ChDk3HF,oBAAoB;CgD92HrB,uBAAY;ChDg3HX,WgD/2HW;AhDg3HZ;;AiDt4HA;CjDy4HC,aiDx4HW;AjDy4HZ;;AAEA;CACC,qBC7tH6B;CD8tH7B,qBAAqB;CiDr4HtB,uBAAe;CjDu4Hd,WiDr4HQ;CjDs4HR,mCAAmC;CiDl4HpC,yBAAY;CjDo4HX,sCiDl4HA;AjDm4HD;;AAEA;CACC,ciD/3HD;AjDg4HA;;AAEA;CACC,iBS59G0C;AT69G3C;;AiD52HE;CjD+2HD,SQhtHS;CRitHT,gBoCh6HC;CpCi6HD,gBQvtHS;CRwtHT,yCkDh6Ha;AlDi6Hd;;AiDn3HE;CjDs3HD,cQvtHS;CRwtHT,WoCv6HC;CpCw6HD,wBQ9tHoC;CR+tHpC,WkDv6HC;ClDw6HD,gBQ3tHS;CR4tHT,cAAc;CiD33Hb,mBAAiB;CjD63HlB,qBQ9tHoC;CR+tHpC,mBQpuHS;CRquHT,6BiD73HE;CjD83HF,SkD96HC;AlD+6HF;AACA;;CAEC,cQruHS;CRsuHT,yBQ3uHS;AR4uHV;AACA;;CAEC,WAAW;CiDz4HV,qBAAiB;CjD24HlB,yBiD74HwF;AjD84HzF;AACA;;CAEC,cQhvHS;CRivHT,oBAAoB;CiDh5HnB,6BAAiB;AjDk5HnB;;AAEA;CACC,ciDr5Hc;AjDs5Hf;;AiDt5HE;CjDy5HD,ciD35HiB;CjD45HjB,uBQhwHS;CRiwHT,gBQjwHS;CRkwHT,qBkD18HC;ClD28HD,cQ9vHS;CR+vHT,mBAAmB;AiD95HlB;AjDg6HF;CACC;EkDj9HC,qB1C0MmC;CRywHpC;AACD;;AmDp9HE;CnDu9HD,cmDt9HK;CnDu9HL,wBmDv9H6B;CnDw9H7B,cAAc;AmDn9Hf;;AnDs9HA;CACC,cmDp9HW;CnDq9HX,yBOpwHoC;CPqwHpC,iCC37HiB;AD47HlB;AACA;CmDj9HA,cAAc;AnDm9Hd;AACA;;CAEC,WmDl9HW;CnDm9HX,2CsBh+HW;AtBi+HZ;AACA;;CAEC,W0B/9He;C1Bg+Hf,yB0B59Ha;A1B69Hd;AACA;;CmDl9HA,cAAA;AnDq9HA;AACA;CACC,iCAAiC;AmDj9HhC;AnDm9HF;CACC,cmDh9Ha;AnDi9Hd;AACA;CACC,cAAc;AoDz/Hf;;ApD4/HA;;CAEC,kBoDx/HiB;CpDy/HjB,oBC/0H6B;CDg1H7B,sBAAsB;AoDt/HvB;ApDw/HA;;CAEC,kBoD1/HD;CpD2/HC,coDr/HY;ApDs/Hb;AACA;;;;;;;;;;;;CAYC,UoDx+HG;ApDy+HJ;;AAEA;CACC,aoDj+HU;CpDk+HV,eShlFmC;CTilFnC,2BC9+HiB;AD++HlB;AACA;CACC,WS3hH6B;AT4hH9B;;AAEA;;CAEC,iB2B3/HG;A3B4/HJ;;AAEA;;CAEC,0BsB/hIW;CtBgiIX,6BoD19HU;ApD29HX;;AAEA;;;CAGC,yBoDl9HE;CpDm9HF,4BoD1/HD;ApD2/HA;;AAEA;CoD18HI,wBAAgC;CpD48HnC,uBoDh7HI;ApDi7HL;AACA;;;CAGC,c2B9/HG;A3B+/HJ;AACA;CACC,eoDr8HqB;ApDs8HtB;;AAEA;;CAEC,uBS/jHgC;CTgkHhC,sBoDl8H4B;ApDm8H7B;;AAEA;;CAEC,sBoD/9HG;CpDg+HH,qB2BjgIG;A3BkgIJ;;AAEA;CACC,sB2BrgIG;C3BsgIH,uBoDr+HG;CpDs+HH,uBoDt9HQ;ApDu9HT;AACA;;CAEC,WoD1+HG;ApD2+HJ;AACA;;CiBxhII,gBAAiB;AjB2hIrB;AACA;;CAEC,6B2BnhIG;C3BohIH,4B2BhiI0B;A3BiiI3B;AACA;;CAEC,yBoDv/HG;CpDw/HH,0BoDx+HQ;ApDy+HT;;AAEA;CACC,aoD5/HG;CpD6/HH,eoDt+HW;CpDu+HX,eoDt+HW;CpDu+HX,gBAAgB;CiB3iIb,gBAAiB;AjB6iIrB;;AAEA;CACC,c2BriIG;C3BsiIH,oB2BljIG;C3BmjIH,coDtgIG;CpDugIH,qB2BpjIG;C3BqjIH,uGoD5/HQ;ApD6/HT;AACA;CACC;EACC,gBoDz/HQ;CpD0/HT;AACD;AACA;;CAEC,cAAc;AiB7jIX;AjB+jIJ;CACC,coDnhIK;CpDohIL,oBoDrhIG;CpDshIH,e2BvjIG;A3BwjIJ;;AAEA;CACC,gCoD/gI6C;ApDghI9C;AACA;CACC,mBoD7hIG;CpD8hIH,gBoD3gIS;CpD4gIT,6BoDrgIQ;CpDsgIR,gCoDhiI4B;CpDiiI5B,iCSvoHgC;ATwoHjC;AACA;;CAEC,qCoDriImC;CpDsiInC,kBoDriImB;ApDsiIpB;AACA;CACC,c2BtlIG;C3BulIH,6BoD1iI6B;CpD2iI7B,yB2BxlIG;A3BylIJ;AACA;;CAEC,coD/iIG;CpDgjIH,yBStpH6B;CTupH7B,qCoDvhIQ;ApDwhIT;AACA;CACC,gBoD5hIW;CpD6hIX,yBAAyB;CoD/gI1B,0BAAkB;ApDihIlB;;AAEA;CACC,gBoDphID;CpDqhIC,SoD9gIK;CpD+gIL,uBAAuB;AqDnqItB;;ArDsqIF;;CAEC,WQz9HS;CR09HT,yBQ19HS;AR29HV;;AAEA;;CAEC,cAAc;CqD9qIb,kBAAA;ArDgrIF;;AAEA;;CAEC,aqD5qIO;CrD6qIP,YqDrrIC;CrDsrID,kBsB/qIW;AtBgrIZ;;AAEA;;CAEC,WQ5+HS;AR6+HV;;AAEA;CACC,aqDvrIO;ArDwrIR;;AAEA;CACC,cqDrrIO;ArDsrIR;;AAEA;CACC,kBqDrsImB;CrDssInB,aqDxsIC;CrDysID,eQ1/HS;CR2/HT,mBqDlsIuB;CrDmsIvB,8BqD3sIsB;CrD4sItB,mBsBrsIW;CtBssIX,sBQ9/HS;AR+/HV;AACA;;;;;;;CAOC,aqDttIC;CrDutID,kBsBhtIW;CtBitIX,mBqD3sIuB;CrD4sIvB,8BqD1sIM;ArD2sIP;;AAEA;CACC,uBQnhIS;CRohIT,0BqD9tIwB;CrD+tIxB,kBQhhIoC;CRihIpC,qBQjhIS;CRkhIT,qBqDjuIC;CrDkuID,mBsB3tIW;AtB4tIZ;;AAEA;CqDruIE,aAAA;CrDuuID,sBoDnkIoH;CpDokIpH,eqDtuIG;CrDuuIH,gBqDzuIC;CrD0uID,gBoDtkI8B;ApDukI/B;AACA;CACC,gBsBtuIW;CtBuuIX,eqDjuIO;ArDkuIR;AACA;CqDhvIE,gBAAA;ArDkvIF;;AAEA;CACC,mBQtiIoC;CRuiIpC,sBQviIS;ARwiIV;;AAEA;CACC,gBqD5uImB;CrD6uInB,YAAY;CsD1vIb,mBAAW;AtD4vIX;;AAEA;CACC,wBStsFiC;CTusFjC,qBsBzvIW;CtB0vIX,csD3vIa;CtD4vIb,6BsD3vIU;CtD4vIV,6BCplIqC;CDqlIrC,uBsDtuIA;CtDuuIA,wCsDzvIS;AtD0vIV;AACA;CACC;EsDxwID,gBAkBS;CtDwvIR;AACD;AACA;CACC,qBsDrvIW;AtDsvIZ;AACA;CACC,qBsDnvIE;CtDovIF,UAAU;CsDjvIX,yBAAiB;AtDmvIjB;;AuDxxIA;CvD2xIC,qBSl8FwC;CTm8FxC,YuD1xIY;CvD2xIZ,aO/jIS;CPgkIT,sBuDzxIqB;CvD0xIrB,4BsBpxIO;CtBqxIP,2BuDzxIkB;CvD0xIlB,qBsBrxIO;AtBsxIR;;AAEA;CACC,yCuDvxIE;CvDwxIF,gBsCnyIO;AtCoyIR;;AuDlxIA;CvDqxIC;EuDnxIC,iBAAe;EACf,2BAKD;CvDgxIA;CACA;EACC,mBAAmB;CuDhxIrB;CvDkxIC;EuDhxIC,kBAAa;CvDkxId;CACA;EuDhxIC,qBjCzBM;EiC0BN,oBAAiB;CvDkxIlB;CACA;E2B3xIG,iBAAA;C3B6xIH;CACA;EACC,wBSl+FwC;ETm+FxC,gBAAgB;CuD9wIlB;CvDgxIC;EuD9wIC,aAAW;CvDgxIZ;CwD1zID;EACE,aAAU;CxD4zIX;CACA;EwD1zIC,iB/CsiCsC;E+CriCtC,SAAS;EACT,aAAW;EACX,YAAY;EACZ,8BAAkB;EAClB,6BAAgB;EAGhB,eAID;ExDszIC,cAAc;EwDnzIhB,gBAAc;EACZ,eAAU;CxDqzIX;CACA;;EwD/yIC,YARF;ExD0zIE,a0Bp0Ic;E1Bq0Id,gBS17FkC;CT27FnC;CACA;EACC,a0Bn0IM;E8BiBN,YAZF;ExDg0IE,UwDnzIE;EAIF,mBAAmB;CxDizIpB;AACD;;AAEA;CACC;EACC,iBwD7yIc;ExD8yId,2BwD5yIC;CxD6yIF;CACA;EACC,mBAAmB;CwDxyIrB;CxD0yIC;EwDxyIC,kBAAa;CxD0yId;CACA;EwDtyID,qBAAe;EACb,oBAAkB;CxDwyInB;CACA;EwDtyIC,iBAAW;CxDwyIZ;CACA;EwDpyIC,wBAAiB;EACjB,gBAAoC;CxDsyIrC;CACA;EACC,aAAa;CwDhyIf;CxDkyIC;EyDr3IC,aAAM;CzDu3IP;CACA;EyDr3IC,iBAAY;EACZ,SAAQ;EACR,aAAA;EAGA,YAAA;EzDq3IA,8ByDr3IuB;EACvB,6BAAO;EzDs3IP,eSr/FoC;ETs/FpC,cAAc;EwDvyIhB,gBAAc;EACZ,eAAa;CxDyyId;CACA;;EwDtyIC,Y5CzEO;E4C0EP,aAAa;E7BtEX,gBAAA;C3Bg3IH;CACA;EACC,awDxyIW;ExDyyIX,YwDxyIU;ExDyyIV,UAAU;EwDpyIZ,mBAAa;CxDsyIZ;AACD;;AwDhyIA;CxDmyIC;EwD/xIC,iBAAc;EACd,2BACD;CxDgyIA;CwD7xID;EACE,mBAAa;CxD+xId;CACA;EwD7xIC,kBAAa;CxD+xId;CACA;EwD7xIC,qBAA4C;E7BzF1C,oBAAA;C3By3IH;CACA;EACC,iBwD3xI2C;CxD4xI5C;CiBv2IG;EuCrCJ,wBAuHgB;ExDwxId,gBSlhGkC;CTmhGnC;CACA;EACC,aQ1qIiC;CR2qIlC;CACA;EwD5wIC,aAAU;CxD8wIX;CACA;EiBl3IG,iBAAmB;EuCuGrB,SAAS;EACT,aAAU;ExD8wIV,YwD7wIW;ExD8wIX,8BAA8B;EiBv3I5B,6BAAyB;EuC8G3B,eAAU;ExD4wIV,cShiGkC;ETiiGlC,gBAAgB;EwDpwId,eAAiB;CxDswIpB;CACA;;EwDnwIK,YAmBD;EAvBD,aAAA;ExD2wIF,gBwDpwIkB;CxDqwInB;CACA;EwD7wIG,aAAA;ExD+wIF,Y2Bl7IE;E6BmKA,UAAA;ExDixIF,mBwDhwIsB;CxDiwIvB;AACD;;AiB73II;CjBg4IH;EACC,iBwDtxIgB;ExDuxIhB,2BwDtxImB;CxDuxIpB;CACA;EACC,mBwD3xIE;CxD4xIH;CACA;EACC,kB2Bj8Ie;C3Bk8IhB;CACA;EACC,qBwDjyIE;ExDkyIF,oBwDjxIsB;CxDkxIvB;CACA;EACC,iBAAiB;CiB/4If;CjBi5IH;EACC,wBwDvyIgB;ExDwyIhB,gBwDvyIe;CxDwyIhB;CACA;EACC,awD5yIE;CxD6yIH;CACA;EACC,a2Bl9IE;C3Bm9IH;CACA;EACC,iBwDlzIE;ExDmzIF,SwDlyIM;ExDmyIN,awDpzIE;ExDqzIF,Y2Bx9IE;E3By9IF,8BAA8B;EiBh6I5B,6BAA2B;EuC0G3B,eAAA;ExDyzIF,cwDxzIgB;ExDyzIhB,gBwDxzIe;ExDyzIf,ewDxzIgB;CxDyzIjB;CACA;;EAEC,YwDvzIc;ExDwzId,a2Bn+IE;E3Bo+IF,gBwDj0IE;CxDk0IH;CACA;EACC,awDnzIM;ExDozIN,YwDr0IE;ExDs0IF,U2Bz+IE;E3B0+IF,mBAAmB;CiBj7IjB;AjBm7IJ;;AAEA;CACC;EACC,iBwDtzIG;ExDuzIH,2BwD90I2B;CxD+0I5B;CACA;EACC,mBwDx0I6B;CxDy0I9B;CACA;EACC,kBwDp1IE;CxDq1IH;CACA;EACC,qBwDl0I8B;ExDm0I9B,oBAAoB;CiBl8IlB;CjBo8IH;EACC,iBwD11IgB;CxD21IjB;CACA;EACC,wBwDv0IG;ExDw0IH,gBwD/1IE;CxDg2IH;CACA;EACC,a2BrgJE;C3BsgJH;CACA;EACC,awDr2IE;CxDs2IH;CACA;EACC,iB2B3gJe;E3B4gJf,SAAS;E0D9hJX,aAAS;EACP,YAAU;EACV,8BjDgjCsC;EiD/iCtC,6BAAc;EACd,ejDkyCmC;EkDtyCnC,c1DmBiB;E0DjBjB,gBAAY;EACZ,elD2kB4B;CTy9H7B;CACA;;E2DjiJC,YAAA;EACA,aAAa;EACb,gBAAgB;C3DoiJjB;CACA;E2DliJC,aAAY;EACZ,YAAW;EACX,UAAU;EpD0RJ,mBAfE;CP0xIT;AACD;;AAEA;CACC,iBO11IS;CP21IT,2B0D3iJQ;A1D4iJT;AACA;CACC,mB0D3iJa;A1D4iJd;AACA;CACC,kBSrxGwC;ATsxGzC;AACA;CACC,qB0D1iJgB;C1D2iJhB,oB0D1iJmB;A1D2iJpB;AACA;C0DtiJA,iBA4DA;A1D4+IA;AACA;CACC,wB0D/hJE;C1DgiJF,gB0D3iJD;A1D4iJA;AACA;CACC,a0DriJK;A1DsiJN;A0DjiJA;C1DmiJC,aStyGmC;ATuyGpC;AACA;CACC,iBSzyGwC;CT0yGxC,S0DjiJS;C1DkiJT,a0DxiJD;C1DyiJC,Y0DhiJY;C1DiiJZ,8BS7yGmC;CT8yGnC,6BsB5kJW;CtB6kJX,eAAe;C0D5hJhB,cAAA;C1D8hJC,gBSjzGwC;CTkzGxC,e0D/hJD;A1DgiJA;AACA;;CAEC,Y0D3hJK;C1D4hJL,a0D3hJK;C1D4hJL,gBAAgB;A0DvhJjB;A1DyhJA;CACC,a0D1hJD;C1D2hJC,Y0DvhJW;C1DwhJX,US7zGmC;CT8zGnC,mBS/zGwC;ATg0GzC;;AAEA;CACC,yBsBhmJO;AtBimJR;A0DlgJA;;C1DqgJC,yBS10G+C;AT20GhD;;AAEA;CACC,0BCh8IqC;ADi8ItC;A4DrnJA;;C5DwnJC,yB4DtnJO;A5DunJR;AACA;CACC,yB4DtnJe;A5DunJhB;;AAEA;;CAEC,yBS3iIgC;AT4iIjC;;AAEA;CACC,0B2D3nJkB;C3D4nJlB,gC2D3nJqB;A3D4nJtB;;AAEA;CACC,yD2D3nJoB;A3D4nJrB;;AAEA;CACC,0BsBloJW;AtBmoJZ;AACA;;;CAGC,yB4DlpJQ;A5DmpJT;;AAEA;CACC,W4DjoJU;A5DkoJX;AACA;;CAEC,W4D/nJK;A5DgoJN;;AAEA;CACC,gC4D9nJI;A5D+nJL;A4D3nJA;;C5D8nJC,gC4D7nJG;A5D8nJJ;AACA;CACC,gCSn1GmC;ATo1GpC;;AAEA;;CAEC,WAAW;A4DpnJZ;;A5DunJA;CACC,gC4DvmJE;C5DwmJF,sC4DxnJiB;A5DynJlB;;AAEA;CACC,yD4DjnJY;A5DknJb;;AAEA;CACC,gCAAgC;A4D7mJjC;A5D+mJA;;;CAGC,W4D5mJK;A5D6mJN;;AAEA;CACC,kB4D1mJoB;C5D2mJpB,a4D1mJK;C5D2mJL,sBAAsB;C4DxnJvB,YAAA;C5D0nJC,qB4DvmJqB;C5DwmJrB,sB4DvmJS;C5DwmJT,2B4DvmJY;C5DwmJZ,sC4DvmJiB;C5DwmJjB,uBS13GuC;AT23GxC;AACA;CACC,e4DvmJgB;C5DwmJhB,cAAc;A4DpmJf;A5DsmJA;CACC,mBSh4GwC;CTi4GxC,sB4DvlJE;A5DwlJH;AACA;CACC,mB4DnmJmB;C5DomJnB,4C4DlmJI;C5DmmJJ,6C4DzlJD;A5D0lJA;AACA;CACC,sBsB7sJO;CtB8sJP,gDAAgD;C4D7kJjD,+CAAgB;A5D+kJhB;AACA;;CAEC,aCntJgB;ADotJjB;;AAEA;CACC,c2BrsJG;C3BssJH,kB4DvlJc;A5DwlJf;;A4D1kJA;C5D6kJC,qBY/sJY;AZgtJb;;A6D3tJA;C7D8tJC,oB6D7tJmB;C7D8tJnB,gBAAgB;A6D3tJjB;;A7D8tJA;C6D1tJA,gBAAgB;A7D4tJhB;;AAEA;CACC,iB8DlvJE;A9DmvJH;;AAEA;CACC,oBAAoB;C6D5tJrB,gBAAe;C7D8tJd,qC6D7tJmB;C7D8tJnB,6C6D7tJc;A7D8tJf;AACA;CACC,4D6D7tJoB;A7D8tJrB;;AAEA;CACC,oB6DtuJc;C7DuuJd,qC6D/tJA;C7DguJA,0CAA0C;A6D9tJ3C;AACA;CACA,4DAAoB;A7DguJpB;;A6D5tJA;CACA,qBAAmB;CACnB,sBAAO;C7D+tJN,oB6D9tJY;C7D+tJZ,gBAAgB;A6D5tJjB;AACA;C7D8tJC,sB6D7tJY;C7D8tJZ,yBAAyB;A6D3tJ1B;;A7D8tJA;CACC,qB6DrtJsB;C7DstJtB,oB6DptJE;A7DqtJH;;A6D1tJA;CAAA,kBASE;C7DqtJD,M6DptJG;C7DqtJH,Q6DptJU;C7DqtJV,SAAS;C6DhuJV,OAAA;CAAA,aAAc;C7DmuJb,mC6DntJa;A7DotJd;;AAEA;;;CAGC,W0BlxJO;A1BmxJR;;A6D9sJA;;C7DktJC,4C6DhtJO;C7DitJP,6C6DhtJU;A7DitJX;;AAEA;;CAEC,gDSzyGuC;CT0yGvC,+C6D/sJW;A7DgtJZ;;AAEA;CACC,mB6D/sJU;A7DgtJX;;AAEA;CACC;EACC,a6DluJF;E7DmuJE,mB0BxyJkB;C1ByyJnB;CACA;E6DruJD,SAAA;E7DuuJE,gBsBtzJU;CtBuzJX;CACA;EACC,cSzzGqC;ET0zGrC,cAAc;C6DhtJhB;C7DktJC;EACC,0BAA0B;E6D/sJ5B,6BAAuB;C7DitJtB;CACA;;E6D3sJD,0BAA4B;C7D8sJ3B;CACA;;E6D3sJC,6BAA4B;C7D8sJ7B;CACA;EACC,yBAAyB;E6D3sJ3B,4BAAA;C7D6sJC;CACA;;EAEC,yBAAyB;CAC1B;CACA;;E6D1sJD,4BAA4B;C7D6sJ3B;AACD;;AAEA;CACC,kBAAkB;C6DrsJnB,aAAA;C7DusJC,mB6DtsJmB;C7DusJnB,W6DtsJS;C7DusJT,qB6DtsJU;C7DusJV,mB6DtsJQ;C7DusJR,c6DtsJW;C7DusJX,gB6DtsJc;C7DusJd,yB6DtsJwB;C7DusJxB,S6DtsJQ;C7DusJR,gBSn2GoC;CTo2GpC,qB6DrsJoB;C7DssJpB;0B6D3qJA;A7D6qJD;AACA;CACC;EACC,gBSr2GuC;CTs2GxC;AACD;AACA;CACC,c6DpsJc;C7DqsJd,yB6DpsJsB;C7DqsJtB,+C6DpsJkB;A7DqsJnB;AACA;CACC,0D6DpsJY;C7DqsJZ,0B6DnsJyD;A7DosJ1D;AACA;CACC,c0Bh3Je;C1Bi3Jf,c0B72Ja;C1B82Jb,e6DruJD;C7DsuJC,iB0B92JiB;C1B+2JjB,W6DvuJD;C7DwuJC,0D6DnsJE;C7DosJF,4BAA4B;C6D5rJ7B,wBAAkB;C7D8rJjB,sC6D7rJmB;A7D8rJpB;AACA;CACC;E6D5rJC,gBpD00CmC;CTo3GpC;AACD;AACA;CACC,UAAU;A6DzrJX;AAAA;C7D4rJC,US72GoC;CT82GpC,qBAAqB;C6D7rJtB,UAAA;C7D+rJC,iD6DvrJE;A7DwrJH;;AAEA;CACC,gBAAgB;A+Dr5JjB;;A/Dw5JA;CACC,yBAAyB;C+Dp5J1B,sCAAgB;A/Ds5JhB;AACA;CACC,gCSr3G6B;CTs3G7B,iCSp3GgC;ATq3GjC;AACA;CACC,4C+Dp5JmB;C/Dq5JnB,6C+Dp5JqD;A/Dq5JtD;A+Dl5JA;C/Do5JC,aSv3G6B;ATw3G9B;AACA;CACC,oCAAoC;C+D54JrC,mCAAU;A/D84JV;AACA;CACC,gD+D54JI;C/D64JJ,+C+D54Ja;A/D64Jd;AACA;C+Dx4JA,oCAAc;C/D04Jb,mC+Dz4JsB;A/D04JvB;;AAEA;CACC,qB+Dz4JmB;A/D04JpB;;AAEA;CACC,eAAe;A+Dt4JhB;;A/Dy4JA;CACC,eAAe;C+Dp4Jd,cAAQ;C/Ds4JT,gB+Dr4JkB;A/Ds4JnB;AACA;CACC,aAAa;AgEv8Jd;AhEy8JA;CACC,gBgEx8JU;AhEy8JX;AACA;CACC,gBgEx8Je;AhEy8JhB;;AAEA;CACC,agEv8JC;ChEw8JD,egEv8JW;ChEw8JX,Y0Bn8Je;C1Bo8Jf,mB0Bh8Ja;C1Bi8Jb,gBgEr9JU;AhEs9JX;;AgEt8JA;ChEy8JC,oByDv9JgB;AzDw9JjB;AACA;CACC,WS96HmC;CT+6HnC,qByDv9Ja;CzDw9Jb,cyDv9Jc;CzDw9Jd,uFgE78JA;AhE88JD;;AAEA;CACC,cStlHmC;ATulHpC;;AAEA;CACC,agEj9JY;ChEk9JZ,egEj9JC;ChEk9JD,gBYj9JQ;AZk9JT;;AAEA;CACC,kBgEh9JiB;ChEi9JjB,cgEh9JG;ChEi9JH,cAAc;CgE78Jf,qBAAiB;ChE+8JhB,sBgE98JiB;ChE+8JjB,yBgE78JA;ChE88JA,qIAAqI;AgE58JtI;AhE88JA;CACC;EgE58JC,gBAAgB;ChE88JjB;AgE38JD;AhE68JA;CACC,UgE58JQ;ChE68JR,cS56GwC;CT66GxC,yBsBj/JO;CtBk/JP,qBgE58JY;AhE68Jb;AgE18JA;ChE48JC,YgE38JO;AhE48JR;AACA;CACC,UgE38JC;ChE48JD,cgE38JY;ChE48JZ,yBAAyB;CgEz8J1B,UAAA;ChE28JC,iDgE18JO;AhE28JR;;AAEA;CACC,iBgE18JiB;AhE28JlB;;AAEA;CgEx8JA,UAAA;ChE08JC,WgEz8JS;ChE08JT,yBgEz8JQ;ChE08JR,qBSl8GuC;ATm8GxC;;AAEA;CACC,cAAc;CgEv8Jf,oBAAgB;ChEy8Jf,sBgEv8JA;ChEw8JA,qBAAqB;AiE1hKtB;;AjE6hKA;CACC,yBiE3hKuB;AjE4hKxB;;AAEA;CACC,gCiE1hKe;CjE2hKf,mCiE1hKwB;AjE2hKzB;;AiErhKA;CjEwhKC,iCiEthKA;CjEuhKA,oCAAoC;AiErhKrC;;AjEwhKA;CiEphKA,uBAAgB;CjEshKf,qBiEphKA;AjEqhKD;;AAEA;CACC,gCAAgC;CiE/gKjC,mCAAU;AjEihKV;;AAEA;CiE7gKA,iCAAkB;CjE+gKjB,oCiE9gKa;AjE+gKd;;AAEA;CiE5gKA,uBAAA;CjE8gKC,qBiE7gKK;AjE8gKN;AACA;C8D5jKE;EACE,qBAAc;C9D8jKjB;AACD;;AkEjkKE;ClEokKD,gCkE3jKE;ClE4jKF,mCkErkKc;AlEskKf;;AkEtkKE;ClEykKD,iCkEhkKE;ClEikKF,oCkE1kKC;AlE2kKF;;AkE3kKE;ClE8kKD,qBkErkKE;ClEskKF,sBkE/kKC;ClEglKD,iBQn4JoC;CRo4JpC,gBAAgB;CkEjlKf,cAAgB;ClEmlKjB,WCz+JW;CD0+JX,kBkEhlKY;ClEilKZ,mBQx4JoC;CRy4JpC,wBAAwB;CkEtlKvB,uBAAgB;AlEwlKlB;AACA;CACC,aQ74JS;AR84JV;;AAEA;CACC,kBkE9lKa;ClE+lKb,SkEzlKY;AlE0lKb;;AAEA;CACC,kBkE/lKY;ClEgmKZ,kBQv5JoC;CRw5JpC,mBAAmB;CkErmKlB,6BAAgB;ClEumKjB,uBkE9lKE;AlE+lKH;;AAEA;CmEzmKA,cAAO;AnE2mKP;;AAEA;CACC,gBmEzmKY;AnE0mKb;;AAEA;CACC,mBmEvmKa;AnEwmKd;AACA;CACC,kBmEvmKc;CnEwmKd,MmEvmKG;CnEwmKH,QAAQ;CmEnmKP,UAAe;CnEqmKhB,qBmEpmKkD;AnEqmKnD;;AAEA;CACC,cAAc;CmEzmKb,yBAAe;CnE2mKhB,qBmE1mKkD;AnE2mKnD;AmE5mKE;CnE8mKD,cmE7mKG;AnE8mKJ;;AAEA;CACC,coEpoKO;CpEqoKP,yBoEpoKS;CpEqoKT,qBoEpoKQ;ApEqoKT;AACA;CoEloKA,cAAc;ApEooKd;;AAEA;CACC,coEnoKQ;CpEooKR,yBoEloKA;CpEmoKA,qBAAqB;AoE5nKlB;ApE8nKJ;CACC,coE7nKW;ApE8nKZ;;AiBxlKI;CjB2lKH,coEnoKG;CpEooKH,yBoEnoKqB;CpEooKrB,qBoEnoKW;ApEooKZ;AACA;CiB/lKI,cAAQ;AjBimKZ;;AAEA;CACC,cSvnImC;CTwnInC,yBAAyB;CiBrmKtB,qBAAmB;AjBumKvB;AACA;CACC,coE/oKW;ApEgpKZ;;AiB1mKI;CjB6mKH,coErpKG;CpEspKH,yBoErpKqB;CpEspKrB,qBoErpKW;ApEspKZ;AACA;CiBjnKI,cAAQ;AjBmnKZ;;AAEA;CACC,cSzoImC;CT0oInC,yBAAyB;CqErrK1B,qBAAQ;ArEurKR;AACA;CACC,cqEtrKc;ArEurKf;;AqEnrKA;CrEsrKC,cqErrKc;CrEsrKd,yBqErrKe;CrEsrKf,qBqErrKiB;ArEsrKlB;AACA;CsE9rKA,cAAA;AACA;;AtEisKA;CACC;EuE5rKC,2BAAqB;CvE8rKtB;AACD;;AAEA;CACC,auE7rKS;CvE8rKT,YAAY;CwE1sKb,gBAAe;CxE4sKd,qBwE1sKqB;CxE2sKrB,yBwE1sKS;CxE2sKT,uBwE1sKW;AxE2sKZ;;AAEA;CACC,awE1sKc;CxE2sKd,sBAAsB;CyEntKvB,uBAAe;CzEqtKd,gB0ErtKW;C1EstKX,W0ErtKC;C1EstKD,kB0ErtKc;C1EstKd,mBAAmB;C2E5tKpB,yBAAI;C3E8tKH,2B2E7tKsB;A3E8tKvB;AACA;CACC;E2E5tKC,gBAAgB;C3E8tKjB;AACD;;AAEA;CACC;;;;;;;;;EASC;C4EjrKM,0BAAwD;A5EmrKhE;;A4EnrKQ;C5EsrKP,kD4E7qKQ;A5E8qKT;A4EvrKQ;C5EyrKP;EACC,eAAe;C4E1rKT;A5E4rKR;;A4E5rKQ;C5E+rKP,a4ExrKgE;C5EyrKhE,sBAAsB;C4EhsKf,eAAwD;C5EksK/D,gB4E3rKgE;C5E4rKhE,uBAAuB;A4EnsKhB;;A5EssKR;C4EtsKQ,qBAAwD;C5EwsK/D,sB4EjsKgE;A5EksKjE;A4EzsKQ;C5E2sKP,oC4ElsKQ;C5EmsKR,0BAA0B;A4E5sKnB;;A5E+sKR;C4E/sKQ,WAAA;C5EitKP,c6EtuKa;C7EuuKb,mBAAmB;A4EltKZ;A5EotKR;;C4EptKQ,UAAA;C5EutKP,c6E5uKyB;C7E6uKzB,qBAAqB;C4ExtKd,yBAAwD;A5E0tKhE;AACA;C4E3tKQ,cAAwD;C5E6tK/D,yB4EttKgE;A5EutKjE;;AAEA;CACC,kBAAkB;C4EjuKX,cAAwD;C5EmuK/D,oB4E5tKgE;C5E6tKhE,cAAc;C4EpuKP,qBAAwD;C5EsuK/D,sB4E/tKgE;C5EguKhE,sCAAsC;A4EvuK/B;A5EyuKR;CACC,+BAA+B;C4E1uKxB,gCAAwD;A5E4uKhE;AACA;C4E7uKQ,mCAAwD;C5E+uK/D,kC4EtuKQ;A5EuuKT;A4EhvKQ;;C5EmvKP,cAAc;C4EnvKP,oBAAwD;C5EqvK/D,sB4E9uKgE;A5E+uKjE;A4EtvKQ;C5EwvKP,U6EpwKwF;C7EqwKxF,WAAW;C4EzvKJ,yBAAwD;C5E2vK/D,qBSjyJoC;ATkyJrC;A4E5vKQ;C5E8vKP,mBSnyJ+B;AToyJhC;A4E/vKQ;C5EiwKP,gBSryJ+B;CTsyJ/B,qBAAqB;A4ElwKd;;A5EqwKR;C4ErwKQ,mBAAwD;A5EuwKhE;AACA;C4ExwKQ,mCAAwD;C5E0wK/D,0B4EnwKgE;A5EowKjE;A4E3wKQ;C5E6wKP,iC4EpwKQ;C5EqwKR,4BAA4B;A4E9wKrB;A5EgxKR;CACC,aAAa;A4EjxKN;A5EmxKR;CACC,qBAAqB;C4EpxKd,oBAAwD;A5EsxKhE;AACA;C4EvxKQ,iBAAwD;C5EyxK/D,sB4ElxK0E;A5EmxK3E;;AAEA;CACC;E4E7xKO,mBAAwD;C5E+xK/D;CACA;E4EhyKO,mCAAwD;EAOpD,0BAEH;C5E0xKR;C4EnyKO;EAOI,iCAEH;E5E6xKP,4BAA4B;C4EtyKtB;C5EwyKP;EACC,aAAa;C4EzyKP;C5E2yKP;EACC,qBAAqB;E4E5yKf,oBAAwD;C5E8yK/D;CACA;E4E/yKO,iBAAwD;EAOpD,sBAEH;C5EyyKR;A4ElzKO;;A5EqzKR;C4ErzKQ;EAOI,mBAAqD;C5EizKhE;C4ExzKO;EAOI,mCAAqD;E5EozK/D,0BAA0B;C4E3zKpB;C5E6zKP;EACC,iCAAiC;E4E9zK3B,4BAAwD;C5Eg0K/D;CACA;E4Ej0KO,aAAwD;C5Em0K/D;CACA;E4Ep0KO,qBAAwD;EAOpD,oBAA+D;C5Eg0K1E;C4Ev0KO;EAOI,iBCwCgB;E7E2xK1B,sBAAsB;C4E10KhB;A5E40KR;;A4E50KQ;C5E+0KP;EACC,mBAAmB;C4Eh1Kb;C5Ek1KP;EACC,mCAAmC;E4En1K7B,0BAAwD;C5Eq1K/D;CACA;E4Et1KO,iCAAwD;EAOpD,4BAA+D;C5Ek1K1E;C4Ez1KO;EAOI,anE+bkB;CTs5J7B;C4E51KO;EAOI,qBAAqD;E5Ew1K/D,oBAAoB;C4E/1Kd;C5Ei2KP;EACC,iBAAiB;E4El2KX,sBAAwD;C5Eo2K/D;AACD;;AAEA;CACC;E4Ex2KO,mBAAwD;C5E02K/D;CACA;E4E32KO,mCAAwD;EAOpD,0BAAqD;C5Eu2KhE;C4E92KO;EAOI,iCAA+D;E5E02KzE,4BAA4B;C4Ej3KtB;C5Em3KP;EACC,aAAa;C4Ep3KP;C5Es3KP;EACC,qBAAqB;E4Ev3Kf,oBAAwD;C5Ey3K/D;CACA;E4E13KO,iBAAwD;EAOpD,sBAAqD;C5Es3KhE;A4E73KO;;A5Eg4KR;C4Eh4KQ;EAOI,mBAAqD;C5E43KhE;C4En4KO;EAOI,mCAEH;E5E63KP,0BAA0B;C4Et4KpB;C5Ew4KP;EACC,iCAAiC;E4Ez4K3B,4BAAwD;C5E24K/D;CACA;E4E54KO,aAAwD;C5E84K/D;CACA;E4E/4KO,qBAAwD;EAOpD,oBAAqD;C5E24KhE;C4El5KO;EAOI,iBAAqD;E5E84K/D,sBAAsB;C4Er5KhB;A5Eu5KR;;A4Ev5KQ;C5E05KP,gB6ErzKuB;A7EszKxB;A4E35KQ;C5E65KP,qB4Et5KgE;A5Eu5KjE;A4E95KQ;C5Eg6KP,sB4Ez5KgE;A5E05KjE;;AAEA;CACC,cAAc;C4Ep6KP,yBAAwD;A5Es6KhE;AACA;;CAEC,c4El6KgE;C5Em6KhE,yBAAyB;A4E16KlB;A5E46KR;CACC,WAAW;C4E76KJ,yBAAwD;C5E+6K/D,qB4Ex6KgE;A5Ey6KjE;;AAEA;CACC,cAAc;C4En7KP,yBAAwD;A5Eq7KhE;AACA;;CAEC,c6E/yKmB;C7EgzKnB,yBAAyB;A4Ez7KlB;A5E27KR;CACC,WAAW;C4E57KJ,yBAAwD;C5E87K/D,qB4Ev7KgE;A5Ew7KjE;;AAEA;CACC,cAAc;C4El8KP,yBAAwD;A5Eo8KhE;AACA;;CAEC,c4Eh8KW;C5Ei8KX,yBAAyB;A4Ex8KlB;A5E08KR;CACC,WAAW;C4E38KJ,yBAAwD;C5E68K/D,qB4Et8KgE;A5Eu8KjE;;AAEA;CACC,cAAc;C4Ej9KP,yBAAwD;A5Em9KhE;AACA;;CAEC,c6EvyKa;C7EwyKb,yBAAyB;A4Ev9KlB;A5Ey9KR;CACC,WAAW;C4E19KJ,yBAAwD;C5E49K/D,qB6E7yKyB;A7E8yK1B;;AAEA;CACC,cAAc;C4Eh+KP,yBAAwD;A5Ek+KhE;AACA;;CAEC,c4E99KgE;C5E+9KhE,yBAAyB;A4Et+KlB;A5Ew+KR;CACC,WAAW;C4Ez+KJ,yBAAwD;C5E2+K/D,qB4Ep+KgE;A5Eq+KjE;;AAEA;CACC,cAAc;C4E/+KP,yBAAwD;A5Ei/KhE;AACA;;CAEC,c4E7+KW;C5E8+KX,yBAAyB;A4Er/KlB;A5Eu/KR;CACC,WAAW;C4Ex/KJ,yBAAwD;C5E0/K/D,qB6E5zKgB;A7E6zKjB;;AAEA;CACC,cAAc;C4E9/KP,yBAAwD;A5EggLhE;AACA;;CAEC,c6E5zKc;C7E6zKd,yBAAyB;A4EpgLlB;A5EsgLR;CACC,WAAW;C4EvgLJ,yBAAwD;C5EygL/D,qB4ElgLgE;A5EmgLjE;;AAEA;CACC,cAAc;C4E7gLP,yBAAwD;A5E+gLhE;AACA;;CAEC,c4E3gLuB;C5E4gLvB,yBAAyB;A4EnhLlB;A5EqhLR;CACC,WAAW;C4EthLJ,yBAAwD;C5EwhL/D,qB6Ep0Ke;A7Eq0KhB;;AAEA;CACC,uBAAuB;C4E5hLhB,UAAA;C5E8hLP,W4EvhLW;C5EwhLX,sBAAsB;C4E/hLf,WAAA;C5EiiLP;;2B4EjiL+D;C5EoiL/D,S4E7hLW;C5E8hLX,uBAAuB;C4EriLhB,YAAA;A5EuiLR;AACA;C4ExiLQ,WAAA;C5E0iLP,qB6E10KoB;C7E20KpB,aAAa;A4E3iLN;A5E6iLR;CACC,UAAU;C4E9iLH,iDAAwD;C5EgjL/D,U4EziLW;A5E0iLZ;A4EjjLQ;;C5EojLP,oBAAoB;C4EpjLb,yBAAwD;SAAxD,iBAAwD;C5EsjL/D,a4E/iLgE;A5EgjLjE;;AAEA;CACC,kDAAkD;A4E1jL3C;;A5E6jLR;C4E7jLQ,YAAwD;C5E+jL/D,e4ExjLgE;C5EyjLhE,mBAAmB;C4EhkLZ,oBAAwD;C5EkkL/D,2C4EzjLQ;C5E0jLR,4BAA4B;C4EnkLrB,oCAAwD;C5EqkL/D,6C4E5jLQ;C5E6jLR,uBAAuB;A4EtkLhB;A5EwkLR;CACC,UAAU;A4EzkLH;A5E2kLR;CACC,aAAa;A4E5kLN;;A5E+kLR;C4E/kLQ,kBAAwD;C5EilL/D,eYrnLI;CZsnLJ,oBAAoB;A4EllLb;A5EolLR;CACC,mBAAmB;A4ErlLZ;;A5EwlLR;C4ExlLQ,aAAwD;C5E0lL/D,mB4EnlLgE;C5EolLhE,uBAAuB;C4E3lLhB,cAAwD;C5E6lL/D,2C4EplLQ;C5EqlLR,4BAA4B;C4E9lLrB,4CAAwD;C5EgmL/D,4C4EvlLQ;C5EwlLR,6CAA6C;A4EjmLtC;A5EmmLR;CACC,uB4E7lLgE;C5E8lLhE,oBAAoB;A4ErmLb;;A5EwmLR;CACC,gBAAgB;C4EzmLT,qBAAwD;A5E2mLhE;;AAEA;C4E7mLQ,eAAwD;C5E+mL/D,M4ExmLW;C5EymLX,O4EzmLW;C5E0mLX,aAAa;C4EjnLN,aAAwD;C5EmnL/D,W4E5mLW;C5E6mLX,Y4E7mLuB;C5E8mLvB,kBAAkB;C4ErnLX,gBAAwD;C5EunL/D,U4EhnLW;A5EinLZ;;A4ExnLQ;C5E2nLP,kB6E13KwC;C7E23KxC,W4ErnLW;C5EsnLX,cAAc;C4E7nLP,oBAAwD;A5E+nLhE;AACA;CACC,mCAAmC;C4EjoL5B,8BAAwD;A5EmoLhE;AACA;CACC;E4EroLO,gBAAwD;C5EuoL/D;AACD;AACA;C4EzoLQ,eAAwD;A5E2oLhE;AACA;CACC,sBAAsB;A4E7oLf;;A5EgpLR;CACC,yBAAyB;A4EjpLlB;A5EmpLR;CACC,gBYprLI;CZqrLJ,gBAAgB;A4ErpLT;A5EupLR;CACC,gB6Ej5KwC;A7Ek5KzC;;AAEA;CACC,aAAa;C4E5pLN,mBAAwD;C5E8pL/D,6B4EvpLgE;A5EwpLjE;;AAEA;CACC,kBAAkB;C4ElqLX,aAAwD;C5EoqL/D,sB4E7pLgE;C5E8pLhE,WAAW;C4ErqLJ,oBAAwD;C5EuqL/D,sB4EhqLgE;C5EiqLhE,4BAA4B;C4ExqLrB,oCAAwD;C5E0qL/D,uB4EnqLgE;C5EoqLhE,UAAU;A4E3qLH;;A5E8qLR;C4E9qLQ,eAAwD;C5EgrL/D,M4EzqLW;C5E0qLX,OAAO;C4EjrLA,aAAwD;C5EmrL/D,Y4E5qLW;C5E6qLX,aAAa;C4EprLN,sBAAwD;A5EsrLhE;AACA;C4EvrLQ,UAAwD;A5EyrLhE;AACA;C4E1rLQ,YAAwD;A5E4rLhE;;A4E5rLQ;C5E+rLP,a4ExrLuB;C5EyrLvB,cAAc;C4EhsLP,mBAAwD;C5EksL/D,8B4E3rL0E;C5E4rL1E,kBAAkB;C4EnsLX,gCAAwD;C5EqsL/D,4C4E5rLQ;C5E6rLR,6CAA6C;A4EtsLtC;A5EwsLR;CACC,sBAAsB;C4EzsLf,oCAAwD;A5E2sLhE;;A4E3sLQ;C5E8sLP,gBYrvLQ;CZsvLR,gBAAgB;A4E/sLT;;A5EktLR;C4EltLQ,kBAAwD;C5EotL/D,c4E7sLuB;C5E8sLvB,aAAa;A4ErtLN;;A5EwtLR;C4ExtLQ,aAAwD;C5E0tL/D,eY/vLK;CZgwLL,cAAc;C4E3tLP,mBAAwD;C5E6tL/D,yB4EttLgE;C5EutLhE,gBAAgB;C4E9tLT,6BAAwD;C5EguL/D,gD4EvtLQ;C5EwtLR,+CAA+C;A4EjuLxC;A5EmuLR;CACC,eAAe;A4EpuLR;;A5EuuLR;C4EvuLQ;EAOI,gBhEvCP;EZ0wLH,oBAAoB;C4E1uLd;C5E4uLP;EACC,2BAA2B;C4E7uLrB;C5E+uLP;EACC,+BAA+B;C4EhvLzB;C5EkvLP;EACC,gBAAgB;C4EnvLV;A5EqvLR;;A4ErvLQ;C5EwvLP;;E4ExvLO,gBAAwD;C5E2vL/D;AACD;;AAEA;CACC;E4E/vLO,iBAAwD;C5EiwL/D;AACD;;A4ElwLQ;C5EqwLP,Y4E9vLW;C5E+vLX,eY1yLI;CZ2yLJ,YAAY;C4EvwLL,SAAwD;A5EywLhE;AACA;CACC,YAAY;C4E3wLL,SAAwD;C5E6wL/D,gBYpzLQ;AZqzLT;AACA;C4E/wLQ,gBAAwD;A5EixLhE;AACA;CACC,gBAAgB;A4EnxLT;A5EqxLR;CACC,gBYtzLI;AZuzLL;;AAEA;CACC;EACC,YAAY;E4E3xLN,eAAwD;EAOpD,YAAY;EAAZ,SAAA;C5EwxLX;C4E/xLO;EAOI,YAAY;EAAZ,SAAA;E5E4xLV,gBAAgB;C4EnyLV;C5EqyLP;E4E9xLW,gBhE9CH;CZ80LR;C4EvyLO;EAOI,gBhExCP;CZ20LJ;CACA;E4E3yLO,gBAAwD;C5E6yL/D;AACD;;A4E9yLQ;C5EizLP;EACC,YAAY;E4ElzLN,eAAwD;EAOpD,YAAY;E5E8yLtB,SAAS;C4ErzLH;C5EuzLP;EACC,YAAY;E4ExzLN,SAAwD;EAOpD,gBhE9CH;CZk2LR;C4E3zLO;EAOI,gBhExCP;CZ+1LJ;C4E9zLO;EAOI,gBhEvCP;CZi2LJ;C4Ej0LO;EAOI,gBhE5CN;CZy2LL;A4Ep0LO;;A5Eu0LR;C4Ev0LQ;EAOI,YAAA;E5Em0LV,eAAe;E4E10LT,YAAwD;EAOpD,SAAA;C5Es0LX;C4E70LO;EAOI,YAAA;E5Ey0LV,SAAS;E4Eh1LH,gBAAwD;C5Ek1L/D;CACA;E4En1LO,gBAAwD;C5Eq1L/D;CACA;E4Et1LO,gBAAwD;C5Ew1L/D;CACA;E4Ez1LO,gBAAwD;C5E21L/D;AACD;;AAEA;CACC;E4E/1LO,YAAwD;EAOpD,eAAY;E5E21LtB,YAAY;E4El2LN,SAAwD;C5Eo2L/D;CACA;E4Er2LO,YAAwD;EAOpD,SAAA;E5Ei2LV,gBAAgB;C4Ex2LV;C5E02LP;EACC,gBAAgB;C4E32LV;C5E62LP;EACC,gBAAgB;C4E92LV;C5Eg3LP;EACC,gBAAgB;C4Ej3LV;A5Em3LR;;A4En3LQ;C5Es3LP;EACC,YAAY;E4Ev3LN,eAAwD;EAOpD,YAAY;E5Em3LtB,SAAS;C4E13LH;C5E43LP;EACC,YAAY;E4E73LN,SAAwD;EAOpD,gBrEoNF;CPqqLT;C4Eh4LO;EAOI,gBrEoNF;CPwqLT;C4En4LO;EAOI,gBrEoNF;CP2qLT;C4Et4LO;EAOI,gBAAqD;C5Ek4LhE;A4Ez4LO;;A5E44LR;C4E54LQ,kBAAwD;C5E84L/D,a6EtgLa;C7EugLb,cAAc;C4E/4LP,SAAA;C5Ei5LP,kC4Ex4LQ;C5Ey4LR,kBAAkB;C4El5LX,gBAAwD;C5Eo5L/D,gBSr4K6B;CTs4K7B,gBAAgB;C4Er5LT,iBAAwD;C5Eu5L/D,qBSz4KoC;CT04KpC,iBAAiB;C4Ex5LV,oBAAwD;C5E05L/D,sB4En5LgE;C5Eo5LhE,kBAAkB;C4E35LX,oBAAwD;C5E65L/D,mB4Et5LgE;C5Eu5LhE,gBAAgB;C4E95LT,qBAAwD;C5Eg6L/D,qB4Ez5LgE;C5E05LhE,UAAU;A4Ej6LH;A5Em6LR;CACC;E4Ep6LO,qBAAwD;C5Es6L/D;AACD;A4Ev6LQ;C5Ey6LP,Y4El6LuB;A5Em6LxB;A4E16LQ;C5E46LP,kB4Er6LgE;C5Es6LhE,cAAc;C4E76LP,aAAwD;C5E+6L/D,c6E3gLc;A7E4gLf;A4Eh7LQ;C5Ek7LP,kB6E7gLiB;C7E8gLjB,WAAW;C4En7LJ,yBAAwD;C5Eq7L/D,mB6E/gLqB;A7EghLtB;;AAEA;;C4Ex7LQ,iBAAA;A5E27LR;AACA;;CAEC,S4Ev7LW;A5Ew7LZ;A4E/7LQ;;C5Ek8LP,SAAS;C4El8LF,6BAAwD;C5Eo8L/D,sB6EphLuB;A7EqhLxB;;AAEA;;C4Ev8LQ,iBAAwD;A5E08LhE;AACA;;CAEC,O4Et8LW;C5Eu8LX,aAAa;C4E59LN,cAAA;AAcA;A5Ei9LR;;CAEC,WAAW;C4E97LJ,oCAAoB;CArBpB,wBAAwD;A5Es9LhE;;AAEA;;CAEC,iB4Et9Le;A5Eu9LhB;AACA;;CAEC,M4E19Le;A5E29LhB;AACA;;CAEC,Y4E99Le;C5E+9Lf,6BQp/LW;CRq/LX,yBAAyB;A4Ep+LlB;;A5Eu+LR;;C4Ev+LQ,iBAAwD;A5E0+LhE;AACA;;C4E3+LQ,QAAA;C5E8+LP,a4E1+Le;C5E2+Lf,cQhgMW;ARigMZ;A4Eh/LQ;;C5Em/LP,UQpgMW;CRqgMX,oCAAoC;C4Ep/L7B,uBAAwD;A5Es/LhE;;AAEA;C4Ex/LQ,gBAAwD;C5E0/L/D,uB4Et/LoD;C5Eu/LpD,WQ5gMW;CR6gMX,kBAAkB;C4E5/LX,sBAAwD;C5E8/L/D,uB4E1/LoD;A5E2/LrD;;A4E//LQ;C5EkgMP,kB4E9/LiD;C5E+/LjD,M4E5/LuB;C5E6/LvB,wBAAwB;C4EpgMjB,aAAc;C5EsgMrB,c4ElgMe;C5EmgMf,gBsB1jMO;CtB2jMP,kCAAkC;C4ExgM3B,kBAAwD;C5E0gM/D,gB4EtgMe;C5EugMf,gBsB/jMO;CtBgkMP,gBAAgB;C4E5gMT,iBAAwD;C5E8gM/D,qB4E1gMoD;C5E2gMpD,iB4ExgMgE;C5EygMhE,oBAAoB;C4E1hMb,sBAAwD;C5E4hM/D,kB4E3hMgD;C5E4hMhD,oBAAoB;C4E7hMb,mBAAwD;C5E+hM/D,gB4E9hMS;C5E+hMT,qBAAqB;C4EhiMd,qBAAwD;C5EkiM/D,sB4EjiMkD;C5EkiMlD,4BAA4B;C4EniMrB,oCAAwD;C5EqiM/D,uB4EpiMmD;A5EqiMpD;A4E5hMQ;C5E8hMP;E4EvhMW,qBpExBA;CRijMX;A4EhiMO;A5EkiMR;CACC,kB4E5hMuB;C5E6hMvB,cAAc;C4EpiMP,WAAwD;C5EsiM/D,c4EliMe;A5EmiMhB;AACA;;CAEC,kB4EtiMmD;C5EuiMnD,c4EpiMW;C5EqiMX,WAAW;C4E5iMJ,yBAAwD;C5E8iM/D,mB4E1iMoD;A5E2iMrD;;A4E/iMQ;;C5EmjMP,2BQpkMW;ARqkMZ;A4EpjMQ;;C5EujMP,S4EhjMW;C5EijMX,6BAA6B;C4ExjMtB,qCAAwD;A5E0jMhE;AACA;;C4E3jMQ,WAAwD;C5E8jM/D,6B4E1jMoD;C5E2jMpD,sBQhlMW;ARilMZ;;AAEA;;CAEC,yBAAyB;C4EpkMlB,aAAwD;C5EskM/D,Y4ElkMe;A5EmkMhB;AACA;;CAEC,O4EtkMe;C5EukMf,oC4EpkMgE;C5EqkMhE,uCAAuC;A4EtlMhC;A5EwlMR;;C4ExlMQ,SAAA;C5E2lMP,oC4EzlMQ;C5E0lMR,wBAAwB;A4E5lMjB;;A5E+lMR;;CAEC,wB4EhmMmD;A5EimMpD;A4ElmMQ;;C5EqmMP,MAAM;C4E3lMC,oCAAwD;C5E6lM/D,wC4EtlMgE;A5EulMjE;A4E9lMQ;;C5EimMP,QAAQ;C4EjmMD,oCAAwD;C5EmmM/D,yB4E5lMgE;A5E6lMjE;;AAEA;;C4EtmMQ,kBAAwD;C5EymM/D,M4ElmMW;C5EmmMX,SAAS;C4E1mMF,cAAwD;C5E4mM/D,W4ErmMW;C5EsmMX,oBAAoB;C4E7mMb,WAAwD;C5E+mM/D,gC4ExmMgE;A5EymMjE;;AAEA;;C4ElnMQ,0BAAwD;C5EqnM/D,a4E9mMW;C5E+mMX,YAAY;A4EtnML;A5EwnMR;;C4ExnMQ,QAAA;C5E2nMP,oC4EpnM0E;C5EqnM1E,sCAAsC;A4E5nM/B;A5E8nMR;;C4E9nMQ,UAAA;C5EioMP,oC4E1nM0E;C5E2nM1E,uBAAuB;A4EloMhB;;A5EqoMR;CACC,oBAAoB;C4EtoMb,gBAAwD;C5EwoM/D,mB4EjoMW;C5EkoMX,c4EloMW;C5EmoMX,yBAAyB;C4E1oMlB,2CAAwD;C5E4oM/D,4C4EroMgE;C5EsoMhE,6C4EtoMgE;A5EuoMjE;A4E9oMQ;C5EgpMP,a4EzoMW;A5E0oMZ;;A4EjpMQ;C5EopMP,kB6ErmLgB;C7EsmLhB,cAAc;A4ErpMP;;A5EwpMR;CiBxpMI,kBAAmB;AjB0pMvB;;AAEA;CACC,mB4EtpMgE;A5EupMjE;;AAEA;CACC,kB6E7qMmB;C7E8qMnB,W4ElqMO;C5EmqMP,gB6E/qMoB;A7EgrMrB;AACA;CACC,c4EtqM+D;C5EuqM/D,W4EhqMuB;C5EiqMvB,W4ExqMO;A5EyqMR;;AAEA;CACC,kB4E5qM+D;C5E6qM/D,a6EzrM4D;C7E0rM5D,W4E9qMiB;C5E+qMjB,W4ExqMuB;C5EyqMvB,mB4EhrM+D;C5EirM/D,2B4E1qMgE;C5E2qMhE,sC4ElrM+D;A5EmrMhE;AACA;CACC;E4ErrMO,gBAAwD;C5EurM/D;AACD;;AAEA;;;CAGC,c4EtrMW;A5EurMZ;;AAEA,qB4EhsMgE;A5EisMhE;;CAEC,2B4E5rMgE;A5E6rMjE;;AAEA;;CAEC,4B4ExsM+D;A5EysMhE;;AAEA,mB6E5hM0B;A7E6hM1B;CACC,U4EtsMgE;C5EusMhE,4B4E9sM+D;C5E+sM/D,eYnvMiB;AZovMlB;;AAEA;;;CAGC,UYtvMI;CZuvMJ,U4EttMgB;A5EutMjB;;AAEA;;CAEC,U4EptMW;C5EqtMX,U4E5tMO;C5E6tMP,2B4EttMgE;A5EutMjE;AACA;CACC;;E4EhuMO,gBAAA;C5EmuMP;AACD;;AAEA;;CAEC,kB4ExuMO;C5EyuMP,M4EluMW;C5EmuMX,S4E1uMO;C5E2uMP,U4EpuMW;C5EquMX,a4E5uMO;C5E6uMP,mB6EliMgB;C7EmiMhB,uB4E9uMO;C5E+uMP,U4ExuMW;C5EyuMX,U4EhvMO;C5EivMP,W4E1uMW;C5E2uMX,kB4ElvMO;C5EmvMP,gB4E5uMuB;C5E6uMvB,S4EpvMO;C5EqvMP,Y4E9uMW;C5E+uMX,8B4EtvM+D;A5EuvMhE;AACA;CACC;;EAEC,gB6E7hMY;C7E8hMb;AACD;AACA;;;;CAIC,W4ElwMO;C5EmwMP,qB6EjiMiB;C7EkiMjB,U4EpwMO;C5EqwMP,Y4E9vMW;A5E+vMZ;;AAEA;CACC,O4ElwMW;A5EmwMZ;;AAEA;CACC,Q4EtwMuB;A5EuwMxB;;AAEA;;CAEC,qB4ElxM+D;C5EmxM/D,W6EniMW;C7EoiMX,Y4EpxMO;C5EqxMP,4B4E5wMQ;C5E6wMR,wB4EtxM+D;C5EuxM/D,0B4E9wMQ;A5E+wMT;;AAEA;;;;;;;GAOG;AACH;CACC,0D4E1xMQ;A5E2xMT;;AAEA;CACC,0D4EvyM+D;A5EwyMhE;;AAEA;CACC,kBY90MI;CZ+0MJ,Q4EryMW;C5EsyMX,S4E7yMe;C5E8yMf,O4EvyMW;C5EwyMX,U4ExyMW;C5EyyMX,a4EhzM+D;C5EizM/D,uBYl1MI;CZm1MJ,U4E3yMW;C5E4yMX,iB4EnzM+D;C5EozM/D,mBYp1MI;CZq1MJ,gBYr1MI;CZs1MJ,gB4EtzM+D;A5EuzMhE;AACA;CACC,uB4EzzM+D;C5E0zM/D,c4EnzMuB;C5EozMvB,W4EpzMW;C5EqzMX,W4E5zM+D;C5E6zM/D,U4EtzMW;C5EuzMX,iB4EvzMuB;C5EwzMvB,gB4E/zM+D;C5Eg0M/D,mBYn2MI;CZo2MJ,e4E1zMW;C5E2zMX,sB4El0M+D;C5Em0M/D,4B4E5zMgE;C5E6zMhE,S4E7zMW;C5E8zMX,kC4Er0M+D;C5Es0M/D,qC4E/zM0E;C5Eg0M1E,Y4Eh0MW;C5Ei0MX,6B4Ex0M+D;A5Ey0MhE;AACA;CACC;EACC,gB6ErkMuC;C7EskMxC;AACD;AACA;CACC,U4Eh1M+D;A5Ei1MhE;;AAEA;CACC,kB4Ep1M+D;C5Eq1M/D,U4E90MW;C5E+0MX,e4Et1M+D;C5Eu1M/D,S4Eh1MW;C5Ei1MX,oB4Ex1M+D;C5Ey1M/D,uB4El1MgE;C5Em1MhE,W4E11MO;C5E21MP,kB6E9kMwC;A7E+kMzC;;AAEA;;CAEC,gC4Eh2M+D;A5Ei2MhE;;AAEA;CACC,sB4Ep2M+D;A5Eq2MhE;;AAEA;CACC,W4Ex2MO;A5Ey2MR;;AAEA;CACC;EACC,0C4Ep2MO;C5Eq2MR;AACD;;AAEA;CACC,qB4El3M+D;C5Em3M/D,W4E52MW;C5E62MX,Y4Ep3M+D;C5Eq3M/D,wB4E92MgE;C5E+2MhE,iC4Et3M+D;C5Eu3M/D,+B4Eh3MgE;C5Ei3MhE,kB4Ex3M+D;C5Ey3M/D,+C4Eh3MQ;A5Ei3MT;;AAEA;CACC,W4Et3MW;C5Eu3MX,Y4E93M+D;C5E+3M/D,mBYt6MQ;AZu6MT;;AAEA;CACC;E4En4MO,mBAAwD;C5Eq4M/D;CACA;EACC,U4Eh4MsB;EAPhB,eAAwD;C5Ey4M/D;AACD;;AAEA;CACC,qB4Et4MgE;C5Eu4MhE,W4E94M+D;C5E+4M/D,YYh7MI;CZi7MJ,wB4Eh5M+D;C5Ei5M/D,8B4Ex4MQ;C5Ey4MR,kB4El5M+D;C5Em5M/D,U4E54MW;C5E64MX,6C4E34MQ;A5E44MT;;AAEA;CACC,W4Ex5M+D;C5Ey5M/D,Y4El5MW;A5Em5MZ;;AAEA;CACC;;EAEC,wBYh8MG;CZi8MJ;AACD;;AAEA;CACC,e4Ep6M+D;C5Eq6M/D,S4E95MW;C5E+5MX,a4E/5MW;C5Eg6MX,a4Ev6M+D;C5Ew6M/D,sBY58MI;CZ68MJ,e4El6MW;C5Em6MX,kB4E16M+D;C5E26M/D,sBY98MgB;CZ+8MhB,4B4Er6MgE;C5Es6MhE,U4E76M+D;C5E86M/D,sC4Ev6M0E;A5Ew6M3E;AACA;CACC;EACC,gB4E36MsB;C5E46MvB;AACD;;AAEA;CACC,e4Eh7MuB;C5Ei7MvB,M4Ex7MO;C5Ey7MP,O4El7MW;C5Em7MX,a4E17M+D;C5E27M/D,Y4Ep7MW;C5Eq7MX,a4E57M+D;C5E67M/D,sB4Et7MgE;A5Eu7MjE;AACA;CACC,U4Eh8M+D;A5Ei8MhE;AACA;CACC,Y4E57MW;A5E67MZ;;AAEA;CACC,a4Eh8MW;C5Ei8MX,mB4Ex8M+D;C5Ey8M/D,8B4El8MgE;C5Em8MhE,kB4E18M+D;A5E28MhE;AACA;CACC,sBY7+Me;CZ8+Mf,mB4E98M+D;C5E+8M/D,qB4Ex8MgE;C5Ey8MhE,sB4Eh9M+D;A5Ei9MhE;;AAEA;CACC,gB4Ep9M+D;C5Eq9M/D,gB4E98MW;A5E+8MZ;;AAEA;CACC,Y4El9MW;C5Em9MX,kB4E19M+D;C5E29M/D,gB4Ep9MuB;A5Eq9MxB;;AAEA;CACC,M4Ex9MW;C5Ey9MX,O4Eh+MO;C5Ei+MP,Y4E19MW;C5E29MX,0C4El+M+D;C5Em+M/D,4B4E59MgE;A5E69MjE;;AAEA;CACC,M4Eh+MW;C5Ei+MX,Q4Ex+MO;C5Ey+MP,Y4El+MW;C5Em+MX,yC4E1+M+D;C5E2+M/D,2B4Ep+MgE;A5Eq+MjE;;AAEA;CACC,M4Ex+MW;C5Ey+MX,Q4Eh/MO;C5Ei/MP,O4E1+MW;C5E2+MX,Y4El/MO;C5Em/MP,gB4E5+MgE;C5E6+MhE,2C4Ep/M+D;C5Eq/M/D,4B4E9+MgE;A5E++MjE;;AAEA;CACC,Q4El/MW;C5Em/MX,O4E1/MO;C5E2/MP,Y6EvgNuC;C7EwgNvC,gB4E5/M+D;C5E6/M/D,wC4Ep/MQ;C5Eq/MR,2B4E9/M+D;A5E+/MhE;;AAEA;CACC,e4ElgN+D;A5EmgNhE;;AAEA;CACC,qB4EtgN+D;C5EugN/D,e6EnhNwF;C7EohNxF,sB4ExgN+D;C5EygN/D,Y6Ex3MuB;C7Ey3MvB,8B4E1gN+D;C5E2gN/D,Y4EpgNW;A5EqgNZ;AACA;CACC,qB4E9gN2B;C5E+gN3B,W4ExgNW;A5EygNZ;;AAEA;CACC,iB4E5gNgE;A5E6gNjE;;AAEA;CACC,iB6Eh3MkB;A7Ei3MnB;;AAEA;CACC,iB6E52Ma;A7E62Md;;AAEA;CACC,mD4EthNQ;A5EuhNT;;AAEA;CACC;E4EniNO,YAAwD;C5EqiN/D;AACD;;AAEA;CACC,+E4EhiNQ;C5EiiNR,oB4E1iN+D;C5E2iN/D,8C4EliNQ;A5EmiNT;;AAEA;CACC;E4E/iNO,uBAAA;C5EijNP;AACD;;AAEA;CACC,c4E9iNW;C5E+iNX,W4EtjNO;C5EujNP,W4EhjNW;A5EijNZ;;AAEA;CACC,c4EpjNuB;A5EqjNxB;AACA;;CAEC,c4ExjNuB;A5EyjNxB;;AAEA;CACC,c4E5jNW;A5E6jNZ;AACA;;CAEC,c4EhkNW;A5EikNZ;;AAEA;CACC,c4EpkNW;A5EqkNZ;AACA;;CAEC,c4ExkNuB;A5EykNxB;;AAEA;CACC,c4E5kNuB;A5E6kNxB;AACA;;CAEC,c4EhlNuB;A5EilNxB;;AAEA;CACC,c4EplNgE;A5EqlNjE;AACA;;CAEC,c4ExlNgE;A5EylNjE;;AAEA;CACC,c4E5lNgE;A5E6lNjE;AACA;;CAEC,c4EhmNgE;A5EimNjE;;AAEA;CACC,c4EpmNgE;A5EqmNjE;AACA;;CAEC,cYlpNI;AZmpNL;;AAEA;CACC,cYppNI;AZqpNL;AACA;;CAEC,c6E53MwC;A7E63MzC;;AAEA;CACC,kB4E3nN+D;C5E4nN/D,W4ErnNW;A5EsnNZ;AACA;CACC,c4ExnNW;C5EynNX,mC4EznN0E;C5E0nN1E,W4EjoN+D;A5EkoNhE;AACA;CACC,kB4EpoN+D;C5EqoN/D,M4E9nNW;C5E+nNX,O4E/nNW;C5EgoNX,W4EvoN+D;C5EwoN/D,Y4EjoNW;A5EkoNZ;;AAEA;CACC,uB4EroNgE;A5EsoNjE;;AAEA;CACC,qC4EhpN+D;A5EipNhE;;AAEA;CACC,sC4E7oN0E;A5E8oN3E;;AAEA;CACC,sC4E/oNQ;A5EgpNT;;AAEA;CACC,e4E5pN+D;C5E6pN/D,M4EtpNW;C5EupNX,Q4EvpNW;C5EwpNX,O4E/pNO;C5EgqNP,a4EzpNuB;A5E0pNxB;;AAEA;CACC,e4EpqN+D;C5EqqN/D,Q4E9pNW;C5E+pNX,S4EtqNe;C5EuqNf,O4EhqNW;C5EiqNX,a4ExqN+D;A5EyqNhE;;AAEA;CACC,gB4E5qN+D;C5E6qN/D,M4EtqNW;C5EuqNX,a4E9qN+D;A5E+qNhE;;AAEA;CACC;EACC,gBYvtNG;EgEoCG,MAAA;E5EqrNN,a4E9qNU;C5E+qNX;AACD;;AAEA;CACC;EACC,gBY3tNG;EgEgCG,MAAA;E5E6rNN,a4EtrNU;C5EurNX;AACD;;AAEA;CACC;EACC,gB4E5rNsB;EAPhB,MAAA;E5EqsNN,a4E9rNU;C5E+rNX;AACD;;AAEA;CACC;EACC,gB4EpsNsB;EAPhB,MAAA;E5E6sNN,a4EtsNsB;C5EusNvB;AACD;;AAEA;CACC;EACC,gBY1vNO;EgEuCD,MAAA;E5EqtNN,a4E9sNsB;C5E+sNvB;AACD;;AAEA;CACC,a4E1tN+D;C5E2tN/D,mB4EptNgE;C5EqtNhE,mB4E5tN+D;C5E6tN/D,mBYjwNiB;AZkwNlB;;AAEA;CACC,aYxwNQ;CZywNR,c4EluN+D;C5EmuN/D,sB4E5tNgE;C5E6tNhE,mB4EpuN+D;A5EquNhE;;AAEA;;CAEC,6B4EzuN+D;C5E0uN/D,qBY9wNI;CZ+wNJ,sBY/wNI;CZgxNJ,qB4E5uN+D;C5E6uN/D,uBYhxNI;CZixNJ,2B4EvuNgE;C5EwuNhE,iC4E/uN+D;C5EgvN/D,8B4EzuNgE;C5E0uNhE,oBYxxNQ;AZyxNT;;AAEA;CACC,kB4ErvN+D;C5EsvN/D,M4E/uNW;C5EgvNX,Q4EhvNW;C5EivNX,S4ExvNe;C5EyvNf,O4ElvNW;C5EmvNX,U4EnvNW;C5EovNX,W4E3vN+D;A5E4vNhE;;AAEA;CACC,gBYlyNI;CZmyNJ,uBYnyNI;CZoyNJ,mB4EjwN+D;A5EkwNhE;;AAEA;CACC,qBYtyNI;CZuyNJ,mBYvyNI;CZwyNJ,U4EvwN+D;C5EwwN/D,e4EjwNuB;C5EkwNvB,8B4ElwNgE;C5EmwNhE,a4E1wN+D;A5E2wNhE;;AAEA;CACC,mC4E9wN+D;A5E+wNhE;;AAEA;CACC,8B4ElxN+D;A5EmxNhE;;AAEA;CACC,iC4EtxN+D;A5EuxNhE;;AAEA;CACC,iC4E1xN+D;A5E2xNhE;;AAEA;CACC,sC4E9xN+D;A5E+xNhE;;AAEA;CACC,mC4ElyN+D;A5EmyNhE;;AAEA;CACC,sB4EtyN+D;A5EuyNhE;;AAEA;CACC,uB4E1yN+D;A5E2yNhE;;AAEA;CACC,sB4E9yN+D;A5E+yNhE;;AAEA;CACC,qB4ElzN+D;A5EmzNhE;;AAEA;CACC,wB4EtzN+D;A5EuzNhE;;AAEA;CACC,uB4E1zN+D;A5E2zNhE;;AAEA;CACC,wB4E9zN+D;A5E+zNhE;;AiB/zNI;CjBk0NH,qB4El0N+D;A5Em0NhE;;AAEA;CACC,yB4Et0N+D;A5Eu0NhE;;AAEA;CACC,2B4E10N+D;A5E20NhE;;AAEA;CACC,4B4E90N+D;A5E+0NhE;;AAEA;CACC,2B4El1N+D;A5Em1NhE;;AAEA;CACC,0B4Et1N+D;A5Eu1NhE;;AAEA;CACC,gC4E11N+D;A5E21NhE;;AAEA;CACC,yB4E91N+D;A5E+1NhE;;AAEA;CACC,wB4El2N+D;A5Em2NhE;;AAEA;CACC,yB4Et2N+D;A5Eu2NhE;;AAEA;CACC,6B4E12N+D;A5E22NhE;;AAEA;CACC,8B4E92N+D;A5E+2NhE;;AAEA;CACC,wB4El3N+D;A5Em3NhE;;AAEA;CACC,+B4Et3N+D;A5Eu3NhE;;AAEA;CACC,wB4E13N+D;A5E23NhE;;AAEA;CACC,wD4E93N+D;A5E+3NhE;;AAEA;CACC,8D4El4N+D;A5Em4NhE;;AAEA;CACC,uD4Et4N+D;A5Eu4NhE;;AAEA;CACC,2B4E14NiC;A5E24NlC;;AAEA;CACC,2B4E94N+D;A5E+4NhE;;AAEA;CACC,6B4El5N+D;A5Em5NhE;;AAEA;CACC,6B4Et5N+D;A5Eu5NhE;;AAEA;CACC,0B4E15N+D;A5E25NhE;;AAEA;CACC,2B4E95N+D;A5E+5NhE;;AAEA;CACC,iB4El6NO;A5Em6NR;;AAEA;CACC,mB4Et6NyB;A5Eu6N1B;;AAEA;CACC,oB4E16NO;A5E26NR;;AAEA;CACC,oB4E96N+D;A5E+6NhE;;AAEA;CACC,sB4El7N+D;A5Em7NhE;;AAEA;CACC,uB4Et7N+D;A5Eu7NhE;;AAEA;CACC,kB4E17N+D;A5E27NhE;;AAEA;CACC,oB4E97N+D;A5E+7NhE;;AAEA;CACC,qB4El8N+D;A5Em8NhE;;AAEA;CACC,mB4Et8N+D;A5Eu8NhE;;AAEA;CACC,qB4E18N+D;A5E28NhE;;AAEA;CACC,sB4Ev8NgE;A5Ew8NjE;;AAEA;CACC,2C4El9N+D;A5Em9NhE;;AAEA;CACC,sC4E/8N0E;A5Eg9N3E;;AAEA;CACC,sC4Ej9NQ;A5Ek9NT;;AAEA;CACC,oC4E99N+D;A5E+9NhE;;AAEA;CACC,oB4E39NgE;A5E49NjE;;AAEA;CACC,wC4E79NQ;A5E89NT;;AAEA;CACC,wB4E1+N+D;A5E2+NhE;;AAEA;CACC,0C4Ev+N0E;A5Ew+N3E;;AAEA;CACC,0B4E3+NgE;A5E4+NjE;;AAEA;CACC,2C4Et/N+D;A5Eu/NhE;;AAEA;CACC,2B4E1/N+D;A5E2/NhE;;AAEA;CACC,yC4E9/N+D;A5E+/NhE;;AAEA;CACC,yB4ElgO+D;A5EmgOhE;;AAEA;CACC,gC4EtgO+D;A5EugOhE;;AAEA;CACC,oC4E1gO+D;A5E2gOhE;;AAEA;CACC,gC4E9gO+D;A5E+gOhE;;AAEA;CACC,gC4ElhO+D;A5EmhOhE;;AAEA;CACC,gC4EthO+D;A5EuhOhE;;AAEA;CACC,gC4E1hO+D;A5E2hOhE;;AAEA;CACC,gC4E9hO+D;A5E+hOhE;;AAEA;CACC,gC4EliO+D;A5EmiOhE;;AAEA;CACC,gC4EtiO+D;A5EuiOhE;;AAEA;CACC,6B4E1iO+D;A5E2iOhE;;AAEA;CACC,4B4E9iO+D;A5E+iOhE;;AAEA;CACC,4B4EljO+D;A5EmjOhE;;AAEA;CACC,4B4EtjO+D;A5EujOhE;;AAEA;CACC,4B4E1jO+D;A5E2jOhE;;AAEA;CACC,4B4EvjOgE;A5EwjOjE;;AAEA;CACC,qBYrmOI;AZsmOL;;AAEA;CACC,qB4EtkO+D;A5EukOhE;;AAEA;CACC,qBY1mOI;AZ2mOL;;AAEA;CACC,sB4EvkOgE;A5EwkOjE;;AAEA;CACC,sB4EllO+D;A5EmlOhE;;AAEA;CACC,0B4E/kOgE;A5EglOjE;;AAEA;CACC,uBY3nOI;AZ4nOL;;AAEA;CACC,2B4E9lO+D;A5E+lOhE;;AAEA;CACC,sB4ElmO+D;A5EmmOhE;;AAEA;CACC,sB4EtmO+D;A5EumOhE;;AAEA;CACC,sB4E1mO+D;A5E2mOhE;;AAEA;CACC,uB4E9mO+D;A5E+mOhE;;AAEA;CACC,uB4ElnO+D;A5EmnOhE;;AAEA;CACC,2B4EtnO+D;A5EunOhE;;AAEA;CACC,wB4E1nO+D;A5E2nOhE;;AAEA;CACC,4B4E9nO+D;A5E+nOhE;;AAEA;CACC,yB4EloO+D;A5EmoOhE;;AAEA;CACC,8B4EtoO+D;A5EuoOhE;;AAEA;CACC,iC4E1oO+D;A5E2oOhE;;AAEA;CACC,sC4E9oO+D;A5E+oOhE;;AAEA;CACC,yC4ElpO+D;A5EmpOhE;;AiBnpOI;CjBspOH,uB4EtpO+D;A5EupOhE;;AAEA;CACC,uB4E1pO+D;A5E2pOhE;;AAEA;CACC,yB4E9pO+D;A5E+pOhE;;AAEA;CACC,yB4ElqO+D;A5EmqOhE;;AAEA;CACC,0B4EtqO+D;A5EuqOhE;;AAEA;CACC,4B4E1qO+D;A5E2qOhE;;AAEA;CACC,kC4E9qO+D;A5E+qOhE;;AAEA;CACC,iB4ElrO+D;A5EmrOhE;;AAEA;CACC,uB4EtrO+D;A5EurOhE;;AAEA;CACC,sB4E1rO+D;A5E2rOhE;;AAEA;CACC,oB4E9rO+D;A5E+rOhE;;AAEA;CACC,wB4ElsO+D;A5EmsOhE;;AAEA;CACC,oB4EtsOO;A5EusOR;;AAEA;CACC,sC4E1sO+D;A5E2sOhE;;AAEA;CACC,oC4E9sO+D;A5E+sOhE;;AAEA;CACC,kC4EltO+D;A5EmtOhE;;AAEA;CACC,yC4EttO+D;A5EutOhE;;AAEA;CACC,wC4E1tO+D;A5E2tOhE;;AAEA;CACC,wC4E9tO+D;A5E+tOhE;;AAEA;CACC,kC4EluO+D;A5EmuOhE;;AAEA;CACC,gC4EtuO+D;A5EuuOhE;;AAEA;CACC,8B4E1uO+D;A5E2uOhE;;AAEA;CACC,gC4E9uO+D;A5E+uOhE;;AAEA;CACC,+B4ElvO+D;A5EmvOhE;;AAEA;CACC,oC4EtvO+D;A5EuvOhE;;AAEA;CACC,kC4E1vO+D;A5E2vOhE;;AAEA;CACC,gC4E9vO+D;A5E+vOhE;;AAEA;CACC,uC4ElwO+D;A5EmwOhE;;AAEA;CACC,sC4EtwO+D;A5EuwOhE;;AAEA;CACC,iC4E1wO+D;A5E2wOhE;;AAEA;CACC,2B4E9wO+D;A5E+wOhE;;AAEA;CACC,iC4ElxO+D;A5EmxOhE;;AAEA;CACC,+B4EtxO+D;A5EuxOhE;;AAEA;CACC,6B4E1xO+D;A5E2xOhE;;AAEA;CACC,+B4E9xO+D;A5E+xOhE;;AAEA;CACC,8B4E3xO0E;A5E4xO3E;;AAEA;CACC,oB4EtyO+D;A5EuyOhE;;AAEA;CACC,mBYj1OQ;AZk1OT;;AAEA;CACC,mBY/0OI;AZg1OL;;AAEA;CACC,mB4ElzO+D;A5EmzOhE;;AAEA;CACC,mB4E/yOgE;A5EgzOjE;;AAEA;CACC,mBY91OI;AZ+1OL;;AAEA;CACC,mB4E9zO+D;A5E+zOhE;;AAEA;CACC,mBYn2OI;AZo2OL;;AAEA;CACC,oBYt2OI;AZu2OL;;AAEA;CACC,0B4E10O+D;A5E20OhE;;AAEA;CACC,yB4E90O+D;A5E+0OhE;;AAEA;CACC,uB4El1O+D;A5Em1OhE;;AAEA;CACC,2B4Et1O+D;A5Eu1OhE;;AAEA;CACC,uB4E11O+D;A5E21OhE;;AAEA;CACC,uB4E91O+D;A5E+1OhE;;AAEA;CACC,0B4El2O+D;C5Em2O/D,yB4E51OgE;A5E61OjE;;AAEA;CACC,gC4Eh2O0E;C5Ei2O1E,+B4Ex2O+D;A5Ey2OhE;;AAEA;CACC,+B4E52O+D;C5E62O/D,8B4Et2OgE;A5Eu2OjE;;AAEA;CACC,6B4E12OgE;C5E22OhE,4B4El3O+D;A5Em3OhE;;AAEA;CACC,iC4Et3O+D;C5Eu3O/D,gC4Eh3OgE;A5Ei3OjE;;AAEA;CACC,6B4Ep3OgE;C5Eq3OhE,4B4E53O+D;A5E63OhE;;AAEA;CACC,6B4Eh4O+D;C5Ei4O/D,4B4E13OgE;A5E23OjE;;AAEA;CACC,wB4E93OgE;C5E+3OhE,2B4Et4O+D;A5Eu4OhE;;AAEA;CACC,8B4E14O+D;C5E24O/D,iC4Ep4O0E;A5Eq4O3E;;AAEA;CACC,6B4Ex4OgE;C5Ey4OhE,gC4Ev4OQ;A5Ew4OT;;AAEA;CACC,2B4Ep5O+D;C5Eq5O/D,8B4E94OgE;A5E+4OjE;;AAEA;CACC,+B4El5OgE;C5Em5OhE,kC4E15O+D;A5E25OhE;;AAEA;CACC,2B4Ev5OgE;C5Ew5OhE,8B4Ex5OgE;A5Ey5OjE;;AAEA;CACC,2B4En6O+D;C5Eo6O/D,8B4E75OgE;A5E85OjE;;AAEA;CACC,wBY38OI;AZ48OL;;AAEA;CACC,8B4E56O+D;A5E66OhE;;AAEA;CACC,6B4Ez6OgE;A5E06OjE;;AAEA;CACC,2B4Ep7O+D;A5Eq7OhE;;AAEA;CACC,+B4Ex7O+D;A5Ey7OhE;;AAEA;CACC,2B4E57O+D;A5E67OhE;;AAEA;CACC,2B4Eh8O+D;A5Ei8OhE;;AAEA;CACC,0B4Ep8O+D;A5Eq8OhE;;AAEA;CACC,gC4Ex8O+D;A5Ey8OhE;;AAEA;CACC,+B4E58O+D;A5E68OhE;;AAEA;CACC,6B4Eh9O+D;A5Ei9OhE;;AAEA;CACC,iC4Ep9O+D;A5Eq9OhE;;AAEA;CACC,6B4Ex9O+D;A5Ey9OhE;;AAEA;CACC,6B4E59O+D;A5E69OhE;;AAEA;CACC,2B4Eh+O+D;A5Ei+OhE;;AAEA;CACC,iC4Ep+O+D;A5Eq+OhE;;AAEA;CACC,gCAAgC;AiBx+O7B;;AjB2+OJ;CACC,8B4E5+O+D;A5E6+OhE;;AAEA;CACC,kC4Eh/O+D;A5Ei/OhE;;AAEA;CACC,8B4Ep/O+D;A5Eq/OhE;;AAEA;CACC,8B4Ex/O+D;A5Ey/OhE;;AAEA;CACC,yB4E5/O+D;A5E6/OhE;;AAEA;CACC,+B4EhgP+D;A5EigPhE;;AAEA;CACC,8B4EpgP+D;A5EqgPhE;;AAEA;CACC,4B4ExgP+D;A5EygPhE;;AAEA;CACC,gC4E5gP+D;A5E6gPhE;;AAEA;CACC,4B4EhhP+D;A5EihPhE;;AAEA;CACC,4B4EphP+D;A5EqhPhE;;AAEA;CACC,qB4ExhP+D;A5EyhPhE;;AAEA;CACC,2B4E5hP+D;A5E6hPhE;;AAEA;CACC,0B4EhiP+D;A5EiiPhE;;AAEA;CACC,wB4EpiP+D;A5EqiPhE;;AAEA;CACC,4B4ExiP+D;A5EyiPhE;;AAEA;CACC,wB4E5iPO;A5E6iPR;;AAEA;CACC,2B4EhjPO;C5EijPP,0B6El3Oe;A7Em3OhB;;AAEA;CACC,iC4E9iPgE;C5E+iPhE,gC4EtjP+D;A5EujPhE;;AAEA;CACC,gC4E1jP+D;C5E2jP/D,+B4EpjPgE;A5EqjPjE;;AAEA;CACC,8B4ExjPgE;C5EyjPhE,6B4EhkP+D;A5EikPhE;;AAEA;CACC,kC4EpkP+D;C5EqkP/D,iC4E9jPgE;A5E+jPjE;;AAEA;CACC,8B4ElkPgE;C5EmkPhE,6B4E1kP+D;A5E2kPhE;;AAEA;CACC,yB4E9kP+D;C5E+kP/D,4B4ExkPgE;A5EykPjE;;AAEA;CACC,+B4E5kPgE;C5E6kPhE,kC4EplP+D;A5EqlPhE;;AAEA;CACC,8B4ExlP+D;C5EylP/D,iC4EhlPQ;A5EilPT;;AAEA;CACC,4B4EplPQ;C5EqlPR,+B4E9lP+D;A5E+lPhE;;AAEA;CACC,gC4ElmP+D;C5EmmP/D,mC4E1lPQ;A5E2lPT;;AAEA;CACC,4B4E9lPQ;C5E+lPR,+B4ExmP+D;A5EymPhE;;AAEA;CACC,yB4E5mP+D;A5E6mPhE;;AAEA;CACC,+B4EhnP+D;A5EinPhE;;AAEA;CACC,8B4EpnP+D;A5EqnPhE;;AAEA;CACC,4B4EjnPgE;A5EknPjE;;AAEA;CACC,gC4ErnPgE;A5EsnPjE;;AAEA;CACC,4B4EhoP+D;A5EioPhE;;AAEA;CACC,2B4E7nPgE;A5E8nPjE;;AAEA;CACC,iC4EjoP0E;A5EkoP3E;;AAEA;CACC,gC4E5oP+D;A5E6oPhE;;AAEA;CACC,8B4EzoPgE;A5E0oPjE;;AAEA;CACC,kC4E7oP0E;A5E8oP3E;;AAEA;CACC,8B4ExpP+D;A5EypPhE;;AAEA;CACC,4B4ErpPgE;A5EspPjE;;AAEA;CACC,kC4EhqP+D;A5EiqPhE;;AAEA;CACC,iC4EpqP+D;A5EqqPhE;;AAEA;CACC,+B4ExqP+D;A5EyqPhE;;AAEA;CACC,mC4E5qP+D;A5E6qPhE;;AAEA;CACC,+B4EhrP+D;A5EirPhE;;AAEA;CACC,0B4EprP+D;A5EqrPhE;;AAEA;CACC,gC4ExrP+D;A5EyrPhE;;AAEA;CACC,+B4E5rP+D;A5E6rPhE;;AAEA;CACC,6B4EhsP+D;A5EisPhE;;AAEA;CACC,iC4EpsP+D;A5EqsPhE;;AAEA;CACC,6B4ExsP+D;A5EysPhE;;AAEA;CACC,gD4E5sP+D;A5E6sPhE;;AAEA;CACC,2C4EhtP+D;A5EitPhE;;AAEA;CACC,8C4EptP+D;A5EqtPhE;;AAEA;CACC,4C4ExtP+D;A5EytPhE;;AAEA;CACC,8B4E5tP+D;A5E6tPhE;;AAEA;CACC,0B4EhuP+D;A5EiuPhE;;AAEA;CACC,8B4E7tP0E;A5E8tP3E;;AAEA;CACC,6B4ExuP+D;A5EyuPhE;;AAEA;CACC,6B4EruPgE;A5EsuPjE;;AAEA;CACC,2B4EzuPgE;A5E0uPjE;;AAEA;CACC,+B4EpvP+D;A5EqvPhE;;AAEA;CACC,2B4EjvPgE;A5EkvPjE;;AAEA;CACC,2B4ErvPgE;A5EsvPjE;;AAEA;CACC,2B4EhwP+D;A5EiwPhE;;AAEA;CACC,8B4E7vPgE;A5E8vPjE;;AAEA;CACC,yB4ExwP+D;A5EywPhE;;AAEA;CACC,4B4E5wP+D;A5E6wPhE;;AAEA;CACC,2B4EhxP+D;A5EixPhE;;AAEA;CACC,yB4EpxP+D;A5EqxPhE;;AAEA;CACC,2B4ExxP+D;A5EyxPhE;;AAEA;CACC,4B4E5xP+D;A5E6xPhE;;AAEA;CACC,6B4EhyP+D;A5EiyPhE;;AAEA;CACC,gC4EpyP+D;A5EqyPhE;;AAEA;CACC,qC4ExyP+D;A5EyyPhE;;AAEA;CACC,wC4E5yP+D;A5E6yPhE;;AAEA;CACC,oC4EhzP+D;A5EizPhE;;AAEA;CACC,oC4EpzP+D;A5EqzPhE;;AAEA;CACC,qC4ExzP+D;A5EyzPhE;;AAEA;CACC,8BAA8B;A8Ex2P/B;;A9E22PA;CACC,8B4Eh0P+D;A5Ei0PhE;;AAEA,qBOpqPqC;APqqPrC;C8E71PA,gCAAY;C9E+1PX,iC4Et0P+D;A5Eu0PhE;;AAEA,mB6Er1PqB;A7Es1PrB;CACC,oB4Ep0PgE;C5Eq0PhE,qE4E50P+D;A5E60PhE;;AAEA;CACC,oB4Eh1P+D;C5Ei1P/D,uE4Ex0PQ;A5Ey0PT;;AAEA;CACC,oB4E90PgE;C5E+0PhE,qE4Et1P+D;A5Eu1PhE;;AAEA;CACC,oBAAoB;C+Ez5PrB,kEAAW;A/E25PX;;AgFt5PA;ChFy5PC,oBgFx5PgB;ChFy5PhB,qEgF/4PA;AhFg5PD;;AAEA;CACC,oBgFv5Pa;ChFw5Pb,oEgFv5PgB;AhFw5PjB;;AgFp5PA;ChFu5PC,oBgFt5Pc;ChFu5Pd,mEgFr5PA;AhFs5PD;;AAEA;CACC,oBAAoB;CgFr5PrB,kEAAiB;AhFu5PjB;;AAEA;CACC,oBAAoB;CgFl5PrB,mEAAW;AhFo5PX;;AAEA;CACC,oBgFj5PC;ChFk5PD,mEAAmE;AACpE;;AAEA;CM34PA,oB0EHK;ChFg5PJ,wEgF/4PyB;AhFg5P1B;;AgF34PA;ChF84PC,oBgF54PA;ChF64PA,yBAAyB;AGt4PlB;;AHy4PR;CACC,oBAAoB;CMt5PrB,oC0EaK;AhF24PL;;AAEA;CACC,oBgF14PkB;ChF24PlB,0CgFt4PA;AhFu4PD;;AAEA;CACC,oBAAoB;CyBvxPrB,yBuDlHqB;AhF24PrB;;AAEA;CuBh9PA,uByDuEW;AhF24PX;;AgFx4PA;ChF24PC,sBgF14Pa;AhF24Pd;;AAEA;CACC,uBgF14PmB;AhF24PpB;;AgFv4PA;ChF04PC,oBgFz4PmB;AhF04PpB;;AAEA;CACC,kBgFx4PgB;ChFy4PhB,8EAA8E;AgFv4P/E;;AhF04PA;CgFt4PA,kBAAc;ChFw4Pb,gFgFv4Pa;AhFw4Pd;;AAEA;CACC,kBgF54PY;ChF64PZ,8EgFr4PI;AhFs4PL;;AAEA;CACC,kBAAkB;CgFp4PnB,2EAAG;AhFs4PH;;AAEA;CgFn4PA,kBAAG;ChFq4PF,8EgFn4PA;AhFo4PD;;AAEA;CACC,kBgFn4PgB;ChFo4PhB,6EgFj4PY;AhFk4Pb;;AgF93PA;ChFi4PC,kBgF73PiB;ChF83PjB,4EAA4E;A4Er8PrE;;A5Ew8PR;C4Ex8PQ,kBI8EM;ChF43Pb,2EgF13PA;AhF23PD;;AAEA;CACC,kBgF73PmD;ChF83PnD,4EAA4E;AgF73P7E;;AhFg4PA;CACC,kBAAkB;CgFh4PnB,4EAAM;AhFk4PN;;AAEA;CgFn4PA,kBAAM;ChFq4PL,8EgFr4PmC;AhFs4PpC;;AgFr4PA;ChFw4PC,kBgFv4PU;ChFw4PV,wCgFn4PA;AhFo4PD;;AAEA;CACC,oBAAoB;AgFt4PrB;;AhFy4PA;CACC,qBGphQmB;AHqhQpB;;AAEA;CgFt4PA,oBAAM;AhFw4PN;;AAEA;CgFz4PA,qBAAM;AhF24PN;;AAEA;CgF54PA,kBAAM;AhF84PN;;AAEA;CgF/4PA,+CAAM;AhFi5PN;;AAEA;CgFl5PA,mCAAM;SAAN,2BAAM;AhFo5PN;;AAEA;CACC,oCgFv5PK;ShFu5PL,4BgFv5PK;AhFw5PN;;AgFj5PA;ChFo5PC,oCgFp5PgB;ShFo5PhB,4BgFp5PgB;AhFq5PjB;;AgFp5PA;ChFu5PC,+BgFv5P+B;AhFw5PhC;;AgFv5PA;ChF05PC,+BgF15PmC;AhF25PpC;;AgF15PA;ChF65PC,kCgF75PoC;AhF85PrC;;AgF75PA;ChFg6PC,2BgFh6PgB;AhFi6PjB;;AgFh6PA;ChFm6PC,kCgFn6PmC;AhFo6PpC;;AgFn6PA;ChFs6PC,kCgFt6PmC;AhFu6PpC;;AgFt6PA;ChFy6PC,kCgFz6P+B;AhF06PhC;;AgFz6PA;ChF46PC,6BgF56P4B;AhF66P7B;;AAEA;CACC,kCAAkC;AgF96PnC;;AhFi7PA;CgFh7PA,2CAAU;ChFk7PT,4CgFl7PuC;AhFm7PxC;;AAEA;CACC,4CAA4C;CgFp7P7C,+CAAU;AhFs7PV;;AgFr7PA;ChFw7PC,+CgFx7P4B;ChFy7P5B,8CAA8C;AgFx7P/C;;AhF27PA;CgF17PA,8CAAU;ChF47PT,2CgF57P4B;AhF67P7B;;AAEA;CACC,8BgF17PA;AhF27PD;;AAEA;CACC,6BAA6B;AgF/6P9B;;AhFk7PA;CgFl7PA;EAKQ,sBAAqB;ChFg7P5B;CACA;EG5kQO,uBAAkB;CH8kQzB;CACA;EACC,sBgFh7PgB;ChFi7PjB;CACA;EACC,0BgFz7PE;ChF07PH;CACA;EACC,gCgFx6PG;ChFy6PJ;CACA;EACC,yBgFh7PkB;ChFi7PnB;CACA;EACC,wBAAwB;CgF36P1B;CACA;EACA,yBAAI;ChF66PH;CACA;EgF/6PD,6BAIE;ChF66PD;CACA;EACC,8BgF56PA;ChF66PD;CgF16PD;EAAK,wBAAc;ChF66PlB;CgF56PD;EAAK,+BAAc;ChF+6PlB;CgF96PD;EAAK,wBAAc;ChFi7PlB;CgFh7PD;EAAK,yBAAc;ChFm7PlB;CgFl7PD;EAAK,8BAAc;ChFq7PlB;CgFp7PD;EAAK,iCAAc;ChFu7PlB;CgFt7PD;EAAK,sCAAc;ChFy7PlB;CgFx7PD;EAAK,yCAAc;ChF27PlB;CgF17PD;EAAK,uBAAc;ChF67PlB;CgF17PD;EACI,uBAAe;ChF47PlB;CACA;EgF17PG,yBAAyB;ChF47P5B;CACA;EACC,yBgF17PG;ChF27PJ;CgFt7PI;EAKe,0BACH;ChFm7PhB;C4E1oQO;EIiOJ,4BACH;ChF26PA;CgF16PD;EACI,kCAAW;ChF46Pd;CACA;EACC,iBAAiB;CgFz6PnB;ChF26PC;EgFz6PG,uBAAgB;ChF26PnB;CACA;EACC,sBAAsB;CgFx6PxB;ChF06PC;EgFx6PG,oBAAmB;ChF06PtB;CACA;EgFx6PG,wBAAW;ChF06Pd;CACA;EgFx6PG,oBAAS;ChF06PZ;CACA;EgFx6PG,sCAAoC;ChF06PvC;CACA;EACC,oCAAoC;CgFt6PtC;ChFw6PC;EACC,kCAAkC;CgFx6PpC;ChF06PC;EACC,yCAAyC;CgF16P3C;ChF46PC;EACC,wCAAwC;CgF56P1C;ChF86PC;EACC,wCAAwC;CgF96P1C;ChFg7PC;EACC,kCAAkC;CgFh7PpC;ChFk7PC;EACC,gCAAgC;CgFl7PlC;ChFo7PC;EACC,8BAA8B;CgFp7PhC;ChFs7PC;EACC,gCAAgC;CgFt7PlC;ChFw7PC;EACC,+BAA+B;CgFx7PjC;ChF07PC;EACC,oCAAoC;CgFz7PtC;ChF27PC;EACC,kCAAkC;CACnC;CACA;EACC,gCAAgC;CACjC;CACA;EACC,uCAAuC;CACxC;CACA;EACC,sCgF17PE;CACJ;ChF27PC;EACC,iCAAiC;CgFz7PnC;ChF27PC;EACC,2BAA2B;CgFz7P7B;ChF27PC;EACC,iCAAiC;CgFz7PnC;ChF27PC;EACC,+BAA+B;CgFz7PjC;ChF27PC;EACC,6BAA6B;CgFz7P/B;ChF27PC;EACC,+BAA+B;CAChC;CACA;EACC,8BAA8B;CAC/B;CACA;EACC,oBgF17PE;CJ/SI;C5E2uQP;EACC,mBAAmB;C4E5uQb;C5E8uQP;EACC,mBAAmB;CgFz7PrB;ChF27PC;EACC,mBAAmB;CgFx7PrB;ChF07PC;EgFx7PA,mBAAe;ChF07Pf;CACA;EgFx7PA,mBAAa;ChF07Pb;CACA;EgFx7PD,mBAAO;ChF07PN;CACA;EgFx7PA,mBAAkB;ChF07PlB;CACA;EgFx7PA,oBAAQ;ChF07PR;CgFx7PD;EACC,0BAAoB;ChF07PpB;CACA;EgFx7PA,yBAAwB;ChF07PxB;CACA;EACC,uBAAuB;CgFx7PzB;ChF07PC;EgFx7PA,2BAAyB;ChF07PzB;CACA;EgFx7PA,uBAAa;ChF07Pb;CACA;EgFx7PD,uBAAO;ChF07PN;CACA;EgFx7PA,0BAAkB;EAClB,yBAAwB;ChF07PxB;CACA;EACC,gCAAgC;EgFx7PlC,+BAAQ;ChF07PP;CACA;EgFx7PA,+BAA0B;EAC1B,8BAAsB;ChF07PtB;CACA;EACC,6BAA6B;EgFl7P/B,4BAAkB;ChFo7PjB;CACA;EACC,iCgFn7PqB;EhFo7PrB,gCgFn7PiB;ChFo7PlB;CACA;EACC,6BgFl7PqB;EhFm7PrB,4BgFl7PiB;ChFm7PlB;CgF/6PD;EACI,6BAA2B;EhFi7P7B,4BAA4B;CgF/6P9B;ChFi7PC;EgF/6PG,wBAAsB;EACtB,2BAeH;ChFk6PA;CACA;EACC,8BgFj7PO;E7ExYD,iCAAiC;CH2zQxC;CACA;EG71QC,6BAAwB;EH+1QxB,gCgF37PS;ChF47PV;CACA;EACC,2BgF97PS;EhF+7PT,8BgF76PD;ChF86PA;CgF76PD;EACI,+BACH;EhF86PC,kCAAkC;CgF76PpC;ChF+6PC;EACC,2BAA2B;EgF/6P7B,8BAAU;ChFi7PT;CACA;EgFj7PD,2BAAU;EAAE,8BAAmB;ChFo7P9B;CgFn7PD;EAAY,wBAAiB;ChFs7P5B;CgFr7PD;EAAY,8BAAmB;ChFw7P9B;CgFv7PD;EAAY,6BAAkB;ChF07P7B;CgFz7PD;EAAY,2BAAmB;ChF47P9B;CgF37PD;EAAY,+BAAe;ChF87P1B;CgF77PD;EAAY,2BAAmB;ChFg8P9B;CgF/7PD;EAAY,2BAAkB;ChFk8P7B;CgFj8PD;EAAa,0BAAmB;ChFo8P/B;CgFn8PD;EAAa,gCAAiB;ChFs8P7B;CgFr8PD;EAAa,+BAAmB;ChFw8P/B;CgFv8PD;EAAa,6BAAkB;ChF08P9B;CgFz8PD;EAAa,iCAAmB;ChF48P/B;CgF38PD;EAAa,6BAAgB;ChF88P5B;CgF78PD;EAAa,6BAAoB;ChFg9PhC;CgF/8PD;EAAa,2BAAmB;ChFk9P/B;CgFj9PD;EAAa,iCAAoB;ChFo9PhC;CgFn9PD;EAAY,gCAAkB;ChFs9P7B;CgFr9PD;EAAa,8BAAoB;ChFw9PhC;CgFv9PD;EAAa,kCAAmB;ChF09P/B;CgFz9PD;EAAa,8BAAoB;ChF49PhC;CgF39PD;EAAa,8BAAgB;ChF89P5B;CgF79PD;EAAa,yBAAoB;ChFg+PhC;CgF/9PD;EAAa,+BAAmB;ChFk+P/B;CgFj+PD;EAAa,8BAAoB;ChFo+PhC;CgFn+PD;EAAa,4BAAkB;ChFs+P9B;CgFr+PD;EAAa,gCAAoB;ChFw+PhC;CgFv+PD;EAAY,4BAAmB;ChF0+P9B;CgFz+PD;EAAa,4BAAoB;ChF4+PhC;CgF3+PD;EAAa,qBAAgB;ChF8+P5B;CgF7+PD;EAAa,2BAAoB;ChFg/PhC;CgF/+PD;EAAa,0BAAmB;ChFk/P/B;CgFj/PD;EAAa,wBAAoB;ChFo/PhC;CgFn/PD;EAAa,4BAAkB;ChFs/P9B;CgFr/PD;EAAa,wBAAoB;ChFw/PhC;CgFv/PD;EAAa,2BAAmB;EhF0/P9B,0BAA0B;CgFz/P5B;ChF2/PC;EACC,iCAAiC;EgF3/PnC,gCAAU;ChF6/PT;CACA;EgF7/PD,gCAAU;EAAE,+BAAqB;ChFggQhC;CgF//PD;EAAY,8BAAoB;EhFkgQ9B,6BAA6B;CgFjgQ/B;ChFmgQC;EACC,kCAAkC;EgFngQpC,iCAAU;ChFqgQT;CACA;EgFrgQD,8BAAU;EAAE,6BAAkB;ChFwgQ7B;CgFvgQD;EAAY,yBAAoB;EhF0gQ9B,4BAA4B;CgFzgQ9B;ChF2gQC;EACC,+BAA+B;EgF3gQjC,kCAAU;ChF6gQT;CACA;EgF7gQD,8BAAU;EAAE,iCAAgB;ChFghQ3B;CgF/gQD;EAAY,4BAAkB;EhFkhQ5B,+BAA+B;CgFjhQjC;ChFmhQC;EACC,gCAAgC;EgFnhQlC,mCAAU;ChFqhQT;CACA;EgFrhQD,4BAAU;EAAE,+BAAgB;ChFwhQ3B;CgFvhQD;EAAY,yBAAkB;ChF0hQ7B;CgFzhQD;EAAY,+BAAiB;ChF4hQ5B;CgF3hQD;EAAY,8BAAkB;ChF8hQ7B;CgF7hQD;EAAY,4BAAc;ChFgiQzB;CgF/hQD;EAAY,gCAAkB;ChFkiQ7B;CgFjiQD;EAAY,4BAAiB;ChFoiQ5B;CgFniQD;EAAY,2BAAkB;ChFsiQ7B;CgFriQD;EAAY,iCAAgB;ChFwiQ3B;CgFviQD;EAAY,gCAAkB;ChF0iQ7B;CgFziQD;EAAY,8BAAiB;ChF4iQ5B;CgF3iQD;EAAY,kCAAkB;ChF8iQ7B;CgF7iQD;EAAY,8BAAe;ChFgjQ1B;CgF/iQD;EAAY,4BAAmB;ChFkjQ9B;CgFjjQD;EAAY,kCAAkB;ChFojQ7B;CgFnjQD;EAAY,iCAAmB;ChFsjQ9B;CgFrjQD;EAAY,+BAAiB;ChFwjQ5B;CgFvjQD;EAAY,mCAAmB;ChF0jQ9B;CgFzjQD;EAAY,+BAAkB;ChF4jQ7B;CgF3jQD;EAAY,0BAAmB;ChF8jQ9B;CgF7jQD;EAAY,gCAAe;ChFgkQ1B;CgF/jQD;EAAY,+BAAmB;ChFkkQ9B;CgFjkQD;EAAY,6BAAkB;ChFokQ7B;CgFnkQD;EAAY,iCAAmB;ChFskQ9B;CgFrkQD;EAAY,6BAAiB;ChFwkQ5B;CgFvkQD;EAAY,2BAAmB;ChF0kQ9B;CgFzkQD;EAAY,4BAAkB;ChF4kQ7B;CgF3kQD;EAAY,6BAAmB;ChF8kQ9B;AgF7kQD;;AhFglQA;CgF/kQA;EAAY,sBAAmB;ChFklQ9B;CgFjlQD;EAAY,uBAAkB;ChFolQ7B;CgFnlQD;EAAY,sBAAmB;ChFslQ9B;CgFrlQD;EAAY,0BAAiB;ChFwlQ5B;CgFvlQD;EAAY,gCAAmB;ChF0lQ9B;CgFzlQD;EAAY,yBAAkB;ChF4lQ7B;CgF3lQD;EAAY,wBAAmB;ChF8lQ9B;CgF7lQD;EAAY,yBAAe;ChFgmQ1B;C4E9kRO;EIkfC,6BAAqB;ChF+lQ7B;CM1wQD;E0E8KC,8BACA;ChF8lQA;CgF5lQD;EACI,wBAAI;ChF8lQP;CACA;EACC,+BgF7lQiB;ChF8lQlB;CACA;EACC,wBgF5lQqB;ChF6lQtB;CACA;EgFzlQD,yBAAU;ChF2lQT;CACA;EACC,8BgF1lQqB;ChF2lQtB;CACA;EACC,iCgFzlQyB;ChF0lQ1B;CACA;EACC,sCAAsC;CgFtlQxC;ChFwlQC;EACC,yCgFvlQyB;ChFwlQ1B;CACA;EgFrlQG,uBAAE;ChFulQL;CACA;EACC,uBgFtlQiB;ChFulQlB;CgFplQD;EACC,yB/ExiBe;CD8nRf;CgFplQD;EACE,yBACD;ChFqlQA;CiF3qRD;E9DmFU,0B8DjFa;CjF4qRtB;CACA;EmB5lRS,4B8DjFa;CjF+qRtB;CACA;EmB/lRS,kC8DjFa;CjFkrRtB;CACA;EmBlmRS,iB8DjFa;CjFqrRtB;CACA;EmBrmRS,uB8DjFa;CjFwrRtB;CACA;EmBxmRS,sB8DjFa;CjF2rRtB;CACA;EmB3mRS,oB8DjFa;CjF8rRtB;CACA;EmB9mRS,wB8DjFa;CjFisRtB;CACA;EmBjnRS,oB8DjFa;CjFosRtB;CACA;EmBpnRS,sC8DjFa;CjFusRtB;CACA;EmBvnRS,oC8DjFa;CjF0sRtB;CACA;EmB1nRS,kC8DjFa;CjF6sRtB;CACA;E4E7pRO,yCK5CE;CjF2sRT;CACA;EkF9tRD,wCAAU;ClFguRT;CACA;EkF9tRG,wCAAuB;ClFguR1B;CACA;EkF9tRG,kCAAW;ClFguRd;CACA;EACC,gCkF5tR2B;ClF6tR5B;CACA;EACC,8BkF5tRmB;ClF6tRpB;CACA;EkF7uRD,gCAoBiB;ClF2tRhB;CACA;EACC,+BkFxtRW;ClFytRZ;CACA;EkFnvRD,oCAgCkB;ClFqtRjB;CACA;EACC,kCkFltR+B;ClFmtRhC;CkFhtRD;EACE,gCAAE;ClFktRH;CACA;EACC,uCkFhtRqC;ClFitRtC;CACA;EkF7sRC,sCAAG;ClF+sRJ;CACA;EACC,iCkF7sRsB;ClF8sRvB;CkF1sRD;EACE,2BAAE;ClF4sRH;CACA;EACC,iCkF1sR8B;ClF2sR/B;CACA;EkFvsRC,+BAAG;ClFysRJ;CACA;EACC,6BkFvsR0B;ClFwsR3B;CkFpsRD;EACE,+BAAE;ClFssRH;CACA;EACC,8BkFpsRa;ClFqsRd;CACA;EkFjsRC,oBAAG;ClFmsRJ;CACA;EACC,mBkFjsRa;ClFksRd;CkF9rRD;EACE,mBAAE;ClFgsRH;CACA;EACC,mBkF9rRa;ClF+rRd;CACA;EkF3rRC,mBAAG;ClF6rRJ;CACA;EACC,mBkF3rRa;ClF4rRd;CkFxrRD;EACE,mBAAE;ClF0rRH;CACA;EACC,mBkFxrRa;ClFyrRd;CACA;EkFrrRC,oBAAG;ClFurRJ;CACA;EACC,0BkFrrRsB;ClFsrRvB;CmFrzRD;EACI,yBAAoB;CnFuzRvB;CACA;EmFrzRG,uBAAsB;CnFuzRzB;CACA;EmF5zRD,2BAOe;CnFuzRd;CACA;EACC,uBmFrzRQ;CnFszRT;CACA;EACC,uBmFlzRO;CnFmzRR;CACA;EACC,0BmFhzRO;EnFizRP,yBmFhzRuB;CnFizRxB;CACA;EACC,gCmFrzRa;EnFszRb,+BmFhzRiB;CnFizRlB;CACA;EACC,+BmFzzRa;EnF0zRb,8BmFhzRiB;CnFizRlB;CACA;EACC,6BG5zR8B;EH6zR9B,4BmF9zRa;CnF+zRd;CACA;EACC,iCmFj0Ra;EnFk0Rb,gCmF/yRgB;CnFgzRjB;CACA;EACC,6BmF3yRa;EnF4yRb,4BmF/xRG;CnFgyRJ;CACA;EACC,6BmF3yRM;EnF4yRN,4BmF3yRqB;CnF4yRtB;CACA;EACC,wBmF3yRM;EnF4yRN,2BmF3yRa;CnF4yRd;CACA;EACC,8BG30RwB;EH40RxB,iCmF1yRW;CnF2yRZ;CACA;EACC,6BmF7yRW;EnF8yRX,gCmFtyRM;CnFuyRP;CACA;EACC,2BmFjzRW;EnFkzRX,8BmFtyRM;CnFuyRP;CoFh3RD;EACA,+BACI;EACI,kCACH;CpFg3RJ;CG91RO;EHg2RN,2BoF/2RkB;EpFg3RlB,8BoF52RO;CpF62RR;CoFz2RD;EAEQ,2BACH;EpFy2RH,8BAA8B;CoFt2RhC;CpFw2RC;EoFt2RG,wBAAkB;CpFw2RrB;CACA;EoFt2RG,8BAAgB;CpFw2RnB;CACA;EoFr2RG,6BAAwB;CpFu2R3B;CACA;EACC,2BoF71RG;CpF81RJ;CACA;EACC,+BoFh2RG;CpFi2RJ;CACA;EACC,2BoFt2RgB;CpFu2RjB;CACA;EACC,2BoFn2RG;CpFo2RJ;CACA;EACC,0BoFn2Ra;CpFo2Rd;CACA;EACC,gCoFl2RmB;CpFm2RpB;CACA;EACC,+BoFl2RiC;CpFm2RlC;CACA;EACC,6BsBj5RU;CtBk5RX;CACA;EACC,iCoFl2RuB;CpFm2RxB;CACA;EACC,6BoF/2Rc;CpFg3Rf;CACA;EACC,6BoFh2R0B;CpFi2R3B;CACA;EACC,2BoFh2R0B;CpFi2R3B;CACA;EACC,iCoFx3Rc;CpFy3Rf;CACA;EACC,gCoF91RG;CpF+1RJ;CACA;EACC,8BoF91RkB;CpF+1RnB;CACA;EACC,kCoF11RW;CpF21RZ;CACA;EACC,8BoFx1RE;CpFy1RH;CACA;EACC,8BoFx1RkB;CpFy1RnB;CACA;EACC,yBoFv1RmB;CpFw1RpB;CACA;EACC,+BoFr1RC;CpFs1RF;CACA;EACC,8BoFr1RO;CpFs1RR;CACA;EACC,4BoFj7RU;CpFk7RX;CACA;EACC,gCoFl1RA;CpFm1RD;CG16RC;EiFXF,4BAsGa;CpFk1RZ;CACA;EGl5RO,4BAAwB;CHo5R/B;CACA;EACC,qBoFj4RE;CpFk4RH;CACA;EoF50RD,2BAAa;CpF80RZ;CACA;EoF50RG,0BAAY;CpF80Rf;CACA;EoF50RG,wBAAW;CpF80Rd;CACA;EoF50RA,4BAAuB;CpF80RvB;CACA;EoF50RA,wBAAa;CpF80Rb;CACA;EoF50RG,2BAoBH;EjFvIO,0BAAwB;CHk8R/B;CACA;EACC,iCoF7zRD;EjF3IC,gCAAwB;CH08RzB;CACA;EGr9RO,gCAAwB;EHu9R9B,+BoFr2RW;CpFs2RZ;CACA;EACC,8BoF90RY;EpF+0RZ,6BoFt0RD;CpFu0RA;CACA;EACC,kCoF90Rc;EpF+0Rd,iCoF90RY;CpF+0Rb;CACA;EACC,8BAA8B;EoFx0RhC,6BAAW;CpF00RV;CACA;EoFx0RG,yBAAkB;EAClB,4BAAoB;CpF00RvB;CACA;EoFx0RG,+BAOH;EAdD,kCAQO;CpF00RN;CACA;EACC,8BoFz0Ra;EpF00Rb,iCoFx0RG;CpFy0RJ;CoFt0RD;EACI,4BnFpLe;EmFqLf,+BAAc;CpFw0RjB;CACA;EoFt0RG,gCAAmB;EACnB,mCAAsB;CpFw0RzB;CACA;EoFt0RG,4BAAY;EACZ,+BACH;CpFu0RA;CoFt0RD;EACC,yBAOA;CpFi0RA;CACA;EoF10RD,+BAKQ;CpFu0RP;CACA;EoFp0RD,8BAA8B;CpFs0R7B;CACA;EoFn0RD,4BAA8B;CpFq0R7B;CACA;EoFl0RD,gCAA8B;CpFo0R7B;CACA;EoFj0RD,4BAAiB;CpFm0RhB;CACA;EoFh0RD,2BAAuB;CpFk0RtB;CACA;EoF9zRD,iCAA0B;CAC1B;CpFg0RC;EoF9zRG,gCACH;CpF+zRA;CoF7zRD;EACI,8BAAmB;CpF+zRtB;CACA;EoF7zRG,kCACH;CpF8zRA;CoF5zRD;EACI,8BAAmB;CpF8zRtB;CACA;EoF3zRD,4BAA0B;CpF6zRzB;CACA;EACC,kCAAkC;CoFzzRpC;CpF2zRC;EACC,iCoFxzRO;CpFyzRR;CACA;EACC,+BAA+B;CoFpzRjC;CpFszRC;EACC,mCAAmC;CoFvzRrC;CpFyzRC;EACC,+BAA+B;CoF7yRjC;CpF+yRC;EACC,0BAA0B;CoF1yR5B;CpF4yRC;EACC,gCoF5yRE;CpF6yRH;CACA;EACC,+BoF/yRE;CpFgzRH;CACA;EACC,6BoFnzRD;CpFozRA;CACA;EoFtyRD,iCAA8B;CpFwyR7B;CACA;EoFzyRD,6BAA8B;CpF2yR7B;CACA;EoFlyRD,2BAAC;CpFoyRA;CACA;EoFjyRC,4BACG;CpFkyRJ;CoFhyRD;EAEQ,6BAOH;CpF0xRJ;AACD;;AAEA;CACC;EqFpmSD,sBAAQ;CrFsmSP;CACA;EqFpmSG,uBAAa;CrFsmShB;CACA;EqFpmSG,sBAAmB;CrFsmStB;CACA;EqFpmSG,0BAAsB;CrFsmSzB;CACA;EACC,gCqFnmSA;CrFomSD;CACA;EACC,yBqFlmSoB;CrFmmSrB;CACA;EACC,wBqFlmSa;CrFmmSd;CACA;EACC,yBqFlmSM;CrFmmSP;CACA;EACC,6BqFjmSsB;CrFkmSvB;CACA;EACC,8BqFhnSkB;CrFinSnB;CACA;EACC,wBqFjmS2B;CrFkmS5B;CACA;EACC,+BqFtnSkB;CrFunSnB;CACA;EACC,wBqFtlSG;CrFulSJ;CACA;EACC,yBqFjmSwB;CrFkmSzB;CACA;EACC,8BqF/nSkB;CrFgoSnB;CACA;EqFjpSD,iCAoDY;CrF+lSX;CACA;EACC,sCqFzlSG;CrF0lSJ;CACA;EACC,yCqF7lSO;CrF8lSR;CqF1kSA;EACC,uBAAW;CrF4kSZ;CqF7kSA;EACC,uBAAW;CrF+kSZ;CqFhlSA;EACC,yBAAW;CrFklSZ;CqFnlSA;EACC,yBAAW;CrFqlSZ;CqFtlSA;EACC,0BAAW;CrFwlSZ;CqFzlSA;EACC,4BAA0B;CrF2lS3B;CqF5lSA;EACC,kCAEA;CrF4lSD;CqF/lSA;EACC,iBAAW;CrFimSZ;CqFlmSA;EACC,uBAAW;CrFomSZ;CqFrmSA;EACC,sBAAW;CrFumSZ;CqFxmSA;EACC,oBAAW;CrF0mSZ;CqF3mSA;EACC,wBAAW;CrF6mSZ;CqF9mSA;EACC,oBAAW;CrFgnSZ;CqFjnSA;EACC,sCAEA;CrFinSD;CqF9mSA;EACC,oCAEA;CrF8mSD;CqFjnSA;EACC,kCAEA;CrFinSD;CqFpnSA;EACC,yCAEA;CrFonSD;CqFvnSA;EACC,wCAEA;CrFunSD;CqF1nSA;EACC,wCAEA;CrF0nSD;CqF7nSA;EACC,kCAEA;CrF6nSD;CqFhoSA;EACC,gCAEA;CrFgoSD;CqFnoSA;EACC,8BAA4B;CrFqoS7B;CqFtoSA;EACC,gCAEA;CrFsoSD;CqFzoSA;EACC,+BAA4B;CrF2oS7B;CqF5oSA;EACC,oCAEA;CrF4oSD;CqF/oSA;EACC,kCAEA;CrF+oSD;CqFlpSA;EACC,gCAEA;CrFkpSD;CqFrpSA;EACC,uCAEA;CrFqpSD;CqFjpSD;EAEA,sCAAc;CrFkpSb;CACA;EACC,iCqFjpSmC;CrFkpSpC;CACA;EACC,2BqFjpSwB;CrFkpSzB;CACA;EACC,iCqFhpSG;CrFipSJ;CACA;EACC,+BqF9oSG;CrF+oSJ;CACA;EACC,6BqF5oSG;CrF6oSJ;CqFzoSD;EAEA,+BAAW;CrF0oSV;CACA;EqF7rSG,8BAA4B;CrF+rS/B;CACA;EqF1oSG,oBAAkB;CrF4oSrB;CACA;EqF1oSG,mBAAc;CrF4oSjB;CACA;EqFppSD,mBAAA;CrFspSC;CACA;EACC,mBqF3oS0B;CrF4oS3B;CACA;EACC,mBqF5oSY;CrF6oSb;CACA;EACC,mBqF5oSkB;CrF6oSnB;CACA;EACC,mBqF5oSuB;CrF6oSxB;CACA;EACC,mBqF5oSsB;CrF6oSvB;CACA;EACC,oBqFvqSF;CrFwqSC;CACA;EGhwSO,0BAAwB;CHkwS/B;CACA;EACC,yBqFzoSD;CrF0oSA;CqFxoSD;EACI,uBAAE;CrF0oSL;CACA;EACC,2BqFzoSgB;CrF0oSjB;CACA;EqFtoSG,uBAAG;CrFwoSN;CACA;EACC,uBqFtoSyB;CrFuoS1B;CACA;EACC,0BAA0B;EqFnoS5B,yBAAU;CrFqoST;CACA;EACC,gCqFpoS2B;ErFqoS3B,+BqFpoSgB;CrFqoSjB;CACA;EqFjoSG,+BAAG;ErFmoSL,8BqFloSmB;CrFmoSpB;CACA;EACC,6BqFjoSyB;ErFkoSzB,4BqFjoSgB;CrFkoSjB;CqF9nSD;EACA,iCAEI;EACI,gCAAW;CrF8nSlB;CACA;EACC,6BAA6B;EAC7B,4BqFpnSG;CrFqnSJ;CACA;EACC,6BqFvoSkB;ErFwoSlB,4BqFloSqB;CrFmoStB;CACA;EACC,wBqF5oSkB;ErF6oSlB,2BqF5oSkB;CrF6oSnB;CACA;EACC,8BAA8B;EqF5nShC,iCACW;CrF6nSV;CACA;EqF3nSC,6BAIG;ElFvKG,gCAAwB;CHiyS/B;CACA;EACC,2BAA2B;EqFznS7B,8BACI;CrF0nSH;CACA;EACC,+BqF5nSE;ErF6nSF,kCqFznSqB;CrF0nStB;CACA;EACC,2BqFvnSC;ErFwnSD,8BAA8B;CqFpnShC;CrFsnSC;EqFnnSO,2BAAM;EACN,8BACH;CrFonSJ;CqFznSD;EAOE,wBACG;CrFonSJ;CqF5nSD;EAUQ,8BACH;CrFonSJ;CqFlnSD;EAEQ,6BACH;CrFknSJ;CqFhnSD;EAEE,2BAAW;CrFinSZ;CACA;EqFpnSD,+BAOE;CrF+mSD;CACA;EqFvnSD,2BAAC;CrFynSA;CACA;EqFvmSD,2BAAiB;CrFymShB;CACA;EGxzSA,0BAAoB;CH0zSpB;CACA;EqFzmSA,gCAAA;CrF2mSA;CACA;EACC,+BAA+B;CAChC;CACA;EACC,6BAA6B;CqFxmS/B;CrF0mSC;EACC,iCqFzmSoB;CrF0mSrB;CACA;EACC,6BAA6B;CqFxmS/B;CrF0mSC;EACC,6BqFzmSuB;CrF0mSxB;CACA;EACC,2BAA2B;CqFxmS7B;CrF0mSC;EACC,iCqFzmSoB;CrF0mSrB;CACA;EACC,gCAAgC;CqFxmSlC;CrF0mSC;EACC,8BqFzmSoB;CrF0mSrB;CACA;EACC,kCAAkC;CqFxmSpC;CrF0mSC;EqFvmSO,8BAAgB;CrFymSvB;CACA;EsF16SD,8BAAa;CtF46SZ;CACA;EsF16SG,yBAyFH;CtFm1SA;CACA;EACC,+BsF36S2B;CtF46S5B;CACA;EACC,8BsBzzSkB;CtB0zSnB;CACA;EACC,4BG33S8B;CH43S/B;CACA;EACC,gCG93S8B;CH+3S/B;CACA;EACC,4BG75SwB;CH85SzB;CACA;EACC,4BGp4S8B;CHq4S/B;CACA;EACC,qBsF/7SD;CtFg8SA;CACA;EACC,2BsF36Sa;CtF46Sd;CACA;EACC,0BsF36SqB;CtF46StB;CACA;EACC,wBsF36Se;CtF46ShB;CACA;EACC,4BsFz6SmB;CtF06SpB;CACA;EACC,wBsFz6Sa;CtF06Sd;CACA;EACC,2BsFz6SuB;EtF06SvB,0BsFl9SD;CtFm9SA;CACA;EACC,iCsFl6SA;EAvDF,gCAyDG;CtFk6SF;CACA;EACC,gCsF75SE;EtF85SF,+BG17S8B;CH27S/B;CACA;EACC,8BGr6S8B;EHs6S9B,6BsFz6SC;CtF06SF;CACA;EACC,kCsFj6S8B;EtFk6S9B,iCsFj6SG;CtFk6SJ;CACA;EGv9SC,8BAAwB;EHy9SxB,6BsFl7SM;CtFm7SP;CACA;EACC,yBsF75SmB;EtF85SnB,4BsF75SgB;CtF85SjB;CACA;EACC,+BsFl6Sa;EtFm6Sb,kCsFx5SA;CtFy5SD;CACA;EACC,8BAA8B;EsFv5ShC,iCACI;CtFw5SH;CACA;EsFp5SD,4BAAS;EAEP,+BAAkB;CtFq5SnB;CACA;EACC,gCAAgC;EAChC,mCAAmC;CACpC;CACA;EACC,4BAA4B;EAC5B,+BAA+B;CAChC;CACA;EACC,yBAAyB;CAC1B;CACA;EACC,+BAA+B;CsFp6SjC;CtFs6SC;EsFl5SE,8BACA;CtFm5SF;CsF/4SD;EAGG,4BhELS;CtBo5SX;CACA;EuFhhTD,gCAAc;CvFkhTb;CACA;EuFnhTD,4BAKc;CvFghTb;CACA;EACC,2BuF1gTG;CvF2gTJ;CACA;EuFzhTD,iCAce;CvF6gTd;CACA;EACC,gCuF5gTa;CvF6gTd;CACA;EACC,8BuF5gTwB;CvF6gTzB;CACA;EACC,kCCr7SU;CDs7SX;CACA;EACC,8BuFpgTO;CvFqgTR;CACA;EACC,4BuFvgTO;CvFwgTR;CACA;EACC,kCuFn4SG;CvFo4SJ;CACA;EACC,iCuFrgT+B;CvFsgThC;CACA;EACC,+BuFrgTW;CvFsgTZ;CACA;EACC,mCuFrgTe;CvFsgThB;CACA;EACC,+BuFpgTwB;CvFqgTzB;CACA;EACC,0BuFvhTE;CvFwhTH;CACA;EACC,gCuF1hTE;CvF2hTH;CACA;EACC,+BGhjTwB;CHijTzB;CACA;EACC,6BuFrgTsB;CvFsgTvB;CACA;EACC,iCuF76SO;CvF86SR;CACA;EACC,6BuF9/SW;CvF+/SZ;CACA;EACC,2BuFpgTsB;CvFqgTvB;CACA;EACC,4BuFhgTgB;CvFigTjB;CACA;EACC,6BuF/iTE;CvFgjTH;AACD;;AAEA;CACC;EACC,sBuFt/SI;CvFu/SL;CACA;EACC,uBuFxjTE;CvFyjTH;CACA;EACC,sBuF3jTE;CvF4jTH;CACA;EACC,0BuF1+SI;CvF2+SL;CACA;EACC,gCuFx+SiC;CvFy+SlC;CACA;EACC,yBuFx+SU;CvFy+SX;CACA;EACC,wBuFx+Sa;CvFy+Sd;CACA;EACC,yBuFx+Sc;CvFy+Sf;CACA;EACC,6BuF7kTE;CvF8kTH;CACA;EACC,8BuFx+SyB;CvFy+S1B;CACA;EACC,wBGtmTkB;CHumTnB;CACA;EACC,+BuFx+SiB;CvFy+SlB;CACA;EACC,wBuFx+Sc;CvFy+Sf;CACA;EACC,yBuFh+Se;CvFi+ShB;CACA;EACC,8BuF/lTE;CvFgmTH;CACA;EACC,iCuF39SoB;CvF49SrB;CACA;EACC,sCuF39SgB;CvF49SjB;CACA;EACC,yCuFj7SG;CvFk7SJ;CACA;EACC,uBuF39Se;CvF49ShB;CACA;EACC,uBuFx+SE;CvFy+SH;CACA;EACC,yBuFp9SO;CvFq9SR;CACA;EACC,yBuF9+SE;CvF++SH;CACA;EACC,0BuFz8SyB;CvF08S1B;CACA;EuF7pTD,4BA6Na;CvFk8SZ;CACA;EACC,kCuFj8SgB;CvFk8SjB;CACA;EACC,iBuFj8Se;CvFk8ShB;CACA;EACC,uBuF18SD;CvF28SA;CACA;EACC,sBuF78SD;CvF88SA;CACA;EACC,oBuFh9SD;CvFi9SA;CACA;EACC,wBuFh8Se;CvFi8ShB;CACA;EACC,oBuFh8Sc;CvFi8Sf;CACA;EACC,sCuF37SC;CvF47SF;CACA;EACC,oCuF/7SE;CvFg8SH;CACA;EACC,kCuF97Sa;CvF+7Sd;CACA;EACC,yCsBpkTkB;CtBqkTnB;CACA;EACC,wCuFt8SA;CvFu8SD;CACA;EuFr5SD,wCACe;CvFs5Sd;CACA;EuFx5SD,kCAKY;CvFq5SX;CACA;EuF35SD,gCAQE;CvFq5SD;CACA;EuF95SD,8BAce;CvFk5Sd;CACA;EuFp5SD,gCAKE;CvFi5SD;CACA;EuFv5SD,+BAQE;CvFi5SD;CACA;EuF74SD,oCAAA;CvF+4SC;CACA;EACC,kCAAkC;CACnC;CACA;EACC,gCAAgC;CACjC;CACA;EACC,uCAAuC;CACxC;CACA;EACC,sCAAsC;CACvC;CACA;EACC,iCAAiC;CAClC;CACA;EACC,2BAA2B;CAC5B;CACA;EACC,iCAAiC;CAClC;CACA;EACC,+BAA+B;CAChC;CACA;EACC,6BAA6B;CAC9B;CACA;EACC,+BAA+B;CAChC;CACA;EACC,8BAA8B;CAC/B;CACA;EACC,oBAAoB;CACrB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,yBAAyB;CAC1B;CACA;EACC,uBAAuB;CACxB;CACA;EACC,2BAA2B;CAC5B;CACA;EACC,uBAAuB;CACxB;CACA;EACC,uBAAuB;CACxB;CACA;EuFz4SD,0BACI;EACE,yBAAoB;CvF04SzB;CACA;EuF74SD,gCACI;EvF84SF,+BuFz4Sa;CvF04Sd;CACA;EACC,+BuFv4SoC;EvFw4SpC,8BsBtyTU;CtBuyTX;CACA;EACC,6BsBzyTU;EtB0yTV,4BuFv4SsC;CvFw4SvC;CACA;EACC,iCuFr4SmB;EvFs4SnB,gCuFr1SO;CvFs1SR;CACA;EACC,6BuF75SE;EvF85SF,4BuFh4S8B;CvFi4S/B;CACA;EACC,6BuFh4SmC;EvFi4SnC,4BuFh4SuB;CvFi4SxB;CACA;EACC,wBuFh4SmB;EvFi4SnB,2BuF/3SE;CvFg4SH;CACA;EACC,8BuF93Se;EvF+3Sf,iCuF16SE;CvF26SH;CACA;EACC,6BuF76SE;EvF86SF,gCsB3yTkC;CtB4yTnC;CACA;EACC,2BuF33SyB;EvF43SzB,8BuF33S6B;CvF43S9B;CACA;EACC,+BuF13SqC;EvF23SrC,kCuF13S8B;CvF23S/B;CACA;EACC,2BuF13S8B;EvF23S9B,8BuFt3SW;CvFu3SZ;CACA;EACC,2BuF33SwB;EAnE1B,8BACI;CvF+7SH;CACA;EACC,wBuFx3SqB;CvFy3StB;CACA;EACC,8BuFn3SO;CvFo3SR;CACA;EG/0TO,6BAAwB;CHi1T/B;CACA;EACC,2BuFt3Sa;CvFu3Sd;CACA;EACC,+BuFt3SgB;CvFu3SjB;CACA;EACC,2BsBpvTkB;CtBqvTnB;CACA;EGh2TC,2BAAwB;CHk2TzB;CACA;EACC,0BuFr3Sa;CvFs3Sd;CACA;EuFz9SD,gCAsGM;CvFq3SL;CACA;EuFn3SC,+BAAyB;CvFq3S1B;CACA;EuF/9SD,6BA6GE;CvFo3SD;CACA;EuFl+SD,iCAiHE;CvFm3SD;CACA;EACC,6BuFh3SE;CvFi3SH;CACA;EACC,6BuF92SE;CvF+2SH;CuF12SA;EAEE,2BAAS;CvF22SX;CACA;EuFz2SE,iCA4CM;CvF+zSR;CACA;EuFj3SA,gCASE;CvF02SF;CACA;EACC,8BG/2T8B;CHg3T/B;CACA;EACC,kCGr4TwB;CHs4TzB;CACA;EACC,8BuF13SkB;CvF23SnB;CACA;EACC,8BuFz2SiB;CvF02SlB;CACA;EACC,yBuFv2SG;CvFw2SJ;CACA;EACC,+BuFv2SuB;CvFw2SxB;CACA;EACC,8BuFt2SG;CvFu2SJ;CACA;EACC,4BuFt2SmB;CvFu2SpB;CACA;EACC,gCuFp2SI;CvFq2SL;CACA;EACC,4BuFn2SmB;CvFo2SpB;CACA;EACC,4BAA4B;CuFn5S7B;CvFq5SA;EuFj2SW,qBAQH;CvF21SR;CACA;EACC,2BAA2B;CuFz5S5B;CvF25SA;EuF51SW,0BAAc;CvF81SzB;CACA;EACC,wBuFl2SU;CvFm2SX;CACA;EACC,4BAA4B;CuFl6S7B;CvFo6SA;EACC,wBAAwB;CGl7TxB;CHo7TD;EACC,2BuF11SW;EvF21SX,0BAA0B;CuFz6S3B;CvF26SA;EuFz1SW,iCjErmBA;EiEsmBA,gCAKH;CvFs1SR;CACA;EACC,gCuFz1SW;EvF01SX,+BAA+B;CuFj7ShC;CvFm7SA;EACC,8BAA8B;EuFp1S/B,6BACC;CvFq1SD;CACA;EGj7TO,kCAAiC;EHm7TvC,iCuFx1SA;CvFy1SD;CACA;EACC,8BuF31SA;EvF41SA,6BuFj1SC;CvFk1SF;CuF90SD;EAEC,yBAAQ;EvF+0SP,4BuF90SwB;CvF+0SzB;CACA;EuF30SA,+BAAG;EvF60SF,kCuF50S0B;CvF60S3B;CuF10SD;EACI,8BACH;EvF20SC,iCAAiC;CuF10SnC;CvF40SC;EACC,4BAA4B;EuF10S9B,+BAAgC;CvF40S/B;CACA;EuF10SD,gCAA6B;EAC5B,mCACA;CvF20SA;CuF10SD;EACI,4BACH;EvF20SC,+BAA+B;CuF10SjC;CvF40SC;EACC,yBAAyB;CuFx0S3B;CvF00SC;EACC,+BAA+B;CuFx0SjC;CvF00SC;EACC,8BAA8B;CuFx0ShC;CvF00SC;EACC,4BAA4B;CuFx0S9B;CvF00SC;EACC,gCAAgC;CuFx0SlC;CvF00SC;EACC,4BAA4B;CuFv0S9B;CvFy0SC;EACC,2BAA2B;CCt5T7B;CDw5TC;EwFtgUD,iCAEE;CxFsgUD;CACA;EwFjgUD,gCAAW;CxFmgUV;CACA;EwFjgUG,8BAAyB;CxFmgU5B;CACA;EwFjgUG,kClEoCO;CtB+9TV;CACA;EACC,8BsBngUQ;CtBogUT;CACA;EACC,4BwF//TG;CxFggUJ;CwF9/TD;EACI,kCAAkB;CxFggUrB;CACA;EACC,iCAAiC;CwF9/TnC;CxFggUC;EwF9/TA,+BACA;CxF+/TA;CwF7/TD;EACI,mCAAwB;CxF+/T3B;CACA;EGpgUO,+BAAwB;CHsgU/B;CACA;EACC,0BAA0B;CwF3/T5B;CxF6/TC;EwF3/TA,gCAA0B;CxF6/T1B;CACA;EwF3/TA,+BAAW;CxF6/TX;CwF1/TD;EACE,6BAAE;CxF4/TH;CACA;EACC,iCwF7/TwB;CxF8/TzB;CACA;EwF7/TC,6BAAE;CxF+/TH;CACA;EACC,2BwFhgUwB;CxFigUzB;CACA;EwFhgUC,4BAAG;CxFkgUJ;CACA;EACC,6BwFngUyB;CxFogU1B;AACD;;AAEA;CACC;EACC,sBwFtgUyB;CxFugU1B;CACA;EwFtgUC,uBAAG;CxFwgUJ;CACA;EACC,sBwFzgUyB;CxF0gU1B;CACA;EwFzgUC,0BAAG;CxF2gUJ;CACA;EACC,gCwF5gUyB;CxF6gU1B;CACA;EwF5gUC,yBAAG;CxF8gUJ;CACA;EACC,wBwF/gUyB;CxFghU1B;CACA;EwF/gUC,yBAAG;CxFihUJ;CACA;EACC,6BwFlhUyB;CxFmhU1B;CACA;EACC,8BAA8B;CwFlhUhC;CxFohUC;EACC,wBwFphUqB;CxFqhUtB;CACA;EwFphUC,+BAAE;CxFshUH;CACA;EACC,wBwFvhUqB;CxFwhUtB;CACA;EwFvhUC,yBAAE;CxFyhUH;CACA;EACC,8BwF1hUsB;CxF2hUvB;CACA;EwF1hUC,iCAAG;CxF4hUJ;CACA;EACC,sCwF7hUmC;CxF8hUpC;CACA;EwF7hUC,yCAAG;CxF+hUJ;CACA;EACC,uBwFhiUsB;CxFiiUvB;CACA;EwFhiUC,uBAAG;CxFkiUJ;CACA;EACC,yBwFniUsB;CxFoiUvB;CACA;EwFniUC,yBAAG;CxFqiUJ;CACA;EACC,0BwFtiUsB;CxFuiUvB;CACA;EwFtiUC,4BAAG;CxFwiUJ;CACA;EACC,kCwFziUkC;CxF0iUnC;CACA;EwFziUC,iBAAI;CxF2iUL;CACA;EwF1iUD,uBAAU;CxF4iUT;CACA;EwF3iUC,sBAAE;CxF6iUH;CACA;EACC,oBwF9iUgB;CxF+iUjB;CACA;EwF9iUC,wBAAE;CxFgjUH;CACA;EACC,oBwFjjUgB;CxFkjUjB;CACA;EwFjjUC,sCAAG;CxFmjUJ;CACA;EACC,oCwFpjU+B;CxFqjUhC;CACA;EwFpjUC,kCAAG;CxFsjUJ;CACA;EACC,yCwFvjU8B;CxFwjU/B;CACA;EwFvjUC,wCAAG;CxFyjUJ;CACA;EACC,wCwF1jU+B;CxF2jUhC;CACA;EwF1jUC,kCAAG;CxF4jUJ;CACA;EACC,gCwF7jU6B;CxF8jU9B;CACA;EwF7jUC,8BAAG;CxF+jUJ;CACA;EACC,gCwFhkU8B;CxFikU/B;CACA;EwFhkUC,+BAAG;CxFkkUJ;CACA;EACC,oCwFnkU2B;CxFokU5B;CwF7jUD;EACI,kCAAkB;CxF+jUrB;CACA;EwF7jUG,gCAAkB;CxF+jUrB;CACA;EwF7jUG,uCAAU;CxF+jUb;CACA;EwF7jUG,sCAAwB;CxF+jU3B;CACA;EACC,iCwF3kUO;CxF4kUR;CACA;EACC,2BwF9kUO;CxF+kUR;CACA;EACC,iCwFjlUO;CxFklUR;CACA;EACC,+BwFplUO;CxFqlUR;CACA;EACC,6BwFrjUA;CxFsjUD;CACA;EACC,+BwFxjUA;CxFyjUD;CACA;EACC,8BwFxjUW;CxFyjUZ;CACA;EACC,oBwFhmUO;CxFimUR;CACA;EACC,mBwFnjUgB;CxFojUjB;CACA;EwFrmUD,mBAoDc;CxFmjUb;CACA;EACC,mBwFljUkB;CxFmjUnB;CACA;EACC,mBwFhjUgB;CxFijUjB;CACA;EACC,mBwF3jUE;CxF4jUH;CACA;EACC,mBwF/iUc;CxFgjUf;CACA;EACC,mBwF3iU2B;CxF4iU5B;CACA;EACC,oBwF3iUwB;CxF4iUzB;CACA;EACC,0BwF3iUoB;CxF4iUrB;CACA;EACC,yBwF3iUgB;CxF4iUjB;CACA;EACC,uBwF1iUiB;CxF2iUlB;CACA;EACC,2BwF1iUI;CxF2iUL;CACA;EACC,uBwF1iUmB;CxF2iUpB;CACA;EACC,uBwF1iUiB;CxF2iUlB;CACA;EACC,0BwFvjUY;ExFwjUZ,yBwFziUK;CxF0iUN;CACA;EACC,gCwFxiUe;ExFyiUf,+BwFxiUgB;CxFyiUjB;CACA;EACC,+BwFxiUc;ExFyiUd,8BwFtiUe;CxFuiUhB;CACA;EACC,6BwFriUuB;ExFsiUvB,4BwFriUqB;CxFsiUtB;CACA;EACC,iCwFriUoB;ExFsiUpB,gCwFriUqB;CxFsiUtB;CACA;EACC,6BwFriUe;ExFsiUf,4BwFriUU;CxFsiUX;CACA;EACC,6BwFpiUqB;ExFqiUrB,4BwFpiUG;CxFqiUJ;CACA;EACC,wBwFrnUE;ExFsnUF,2BwFliUG;CxFmiUJ;CACA;EACC,8BwFthUe;ExFuhUf,iCwF9mUU;CxF+mUX;CACA;EACC,6BwF7hUwB;ExF8hUxB,gCwF7hU0B;CxF8hU3B;CACA;EACC,2BwFxhUc;ExFyhUd,8BwFxhUmB;CxFyhUpB;CACA;EACC,+BwFvhUI;ExFwhUJ,kCwF1nUU;CxF2nUX;CACA;EACC,2BwFzoUY;ExF0oUZ,8BwFphUwB;CxFqhUzB;CACA;EACC,2BwFnhUiB;ExFohUjB,8BwFjhU+B;CxFkhUhC;CACA;EACC,wBwFzgUQ;CxF0gUT;CACA;EACC,8BwFrgUsB;CxFsgUvB;CACA;EACC,6BwFz8TO;CxF08TR;CACA;EACC,2BwFpgUuB;CxFqgUxB;CACA;EACC,+BwFpgUsB;CxFqgUvB;CACA;EACC,2BGnxUmB;CHoxUpB;CACA;EACC,2BAA2B;CAC5B;CACA;EACC,0BAA0B;CAC3B;CACA;EACC,gCAAgC;CACjC;CACA;EACC,+BAA+B;CAChC;CACA;EACC,6BAA6B;CAC9B;CACA;EACC,iCAAiC;CAClC;CACA;EACC,6BAA6B;CAC9B;CACA;EACC,6BwF3iUM;CxF4iUP;CACA;EACC,2BwF3rUY;CxF4rUb;CACA;EACC,iCwF1iUW;CxF2iUZ;CACA;EACC,gCwF7iUW;CxF8iUZ;CACA;EACC,8BwFngUkB;CxFogUnB;CACA;EACC,kCwFlgUe;CxFmgUhB;CACA;EACC,8BG90UwB;CH+0UzB;CACA;EACC,8BwF9/TQ;CxF+/TT;CACA;EACC,yBwF9/TU;CxF+/TX;CACA;EACC,+BwF/+TO;CxFg/TR;CACA;EACC,8BwF//TW;CxFggUZ;CACA;EACC,4BwF5/T0B;CxF6/T3B;CACA;EACC,gCwFv/TgB;CxFw/TjB;CACA;EACC,4BAA4B;CAC7B;CACA;EACC,4BwFt/TiB;CxFu/TlB;CACA;EACC,qBwFt/TsB;CxFu/TvB;CACA;EACC,2BwFn/TM;CxFo/TP;CACA;EACC,0BwFn/TqB;CxFo/TtB;CACA;EACC,wBwFh/TS;CxFi/TV;CACA;EACC,4BwFh/ToB;CxFi/TrB;CACA;EwF3+TD,wBACU;CxF4+TT;CACA;EwF9+TD,2BAII;EACF,0BAAW;CxF4+TZ;CACA;EwF1+TC,iCAAmB;EACnB,gCASA;CxFm+TD;CACA;EACC,gCwFr+TA;ErFzcA,+BAAwB;CHg7UzB;CACA;EACC,8BwF5+TgB;ExF6+ThB,6BwF1+TA;CxF2+TD;CwF7/TD;EAqBE,kCAIA;ErF7bM,iCAAiC;CHq6UxC;CACA;EACC,8BAA8B;EwFngUhC,6BA0BE;CxF2+TD;CACA;EACC,yBAAyB;EG36UnB,4BAAwB;CH66U/B;CACA;EACC,+BwFt8TD;ExFu8TC,kCAAkC;CG97U5B;CHg8UP;EACC,8BwFz+TyB;ExF0+TzB,iCwF7+Ta;CxF8+Td;CACA;EGz8UC,4BAAwB;EqFub1B,+BAAgB;CxFqhUf;CACA;EwFthUD,gCA6CG;EAEE,mCACA;CxFy+TJ;CGh9UC;EqFubF,4BA2CC;ExFi/TC,+BwFz+TgB;CxF0+TjB;CACA;EwF9hUD,yBA2CC;CxFq/TA;CACA;EwFv+TG,+BAKA;CxFo+TH;CACA;EACC,8BwFt+TE;CxFu+TH;CwFtiUD;EAkEG,4BACA;CxFs+TF;CwFl+TA;EACA,gCAAkB;CxFo+TlB;CACA;EwFl+TA,4BAAA;CxFo+TA;CACA;EACC,2BwF39TD;CxF49TA;CACA;EACC,iCwFn+TmB;CxFo+TpB;CACA;EACC,gCwFl+TA;CxFm+TD;CGp8UO;EiFvCR,8BI2gBY;CxFm+TX;CACA;EwF99TD,kCAA6B;CxFg+T5B;CACA;EmFvgVD,8BK2iBY;CxF89TX;CACA;EACC,4BwF59Ta;CxF69Td;CACA;EGr9UO,kCAAmC;CHu9U1C;CACA;EACC,iCAAiC;CwFt9TnC;CxFw9TC;EACC,+BAA+B;CwFp9TjC;CxFs9TC;EACC,mCAAmC;CyFthVrC;CACA;EAQwB,+BACH;CzFghVpB;CyF1hVD;EACA,0BAA2B;CzF4hV1B;CACA;EyF9hVD,gCAA2B;CAC3B;CzFgiVC;EyF9gV2B,+BAAe;CzFghV1C;CACA;EyF9gV2B,6BAKH;CzF2gVxB;CACA;EACC,iCyF9gV2B;CzF+gV5B;CyFziVD;EACA,6BAA2B;CzF2iV1B;CACA;EyF7iVD,2BAA2B;CAC3B;CzF+iVC;EyF1gV+B,4BAKH;CzFugV5B;CACA;EACC,6ByF1gV+B;CzF2gVhC;AACD;;AAEA;CACC;EyFzjVD,6BAA2B;CAC3B;CzF2jVC;EyFpgV+B,8BAKH;CzFigV5B;CACA;EACC,4ByFpgV+B;CzFqgVhC;AACD;;AAEA;CACC;EyFrkVD,0BAA2B;CAC3B;CzFukVC;EyFhgV+B,gCAKH;CzF6/U5B;CACA;EACC,yByFhgV+B;CzFigVhC;CyF7kVD;EACA,wBAAC;CzF+kVA;CACA;EyFjlVD,yBAAC;CACD;CzFmlVC;EyF5/U+B,6BAKH;CzFy/U5B;CACA;EACC,8ByF5/U+B;CzF6/UhC;CyFl/UD;EAS4B,wBAAO;CzF4+UlC;CyFr/UD;EAY4B,+BAAa;CzF4+UxC;CACA;EyF1+U2B,wBAAiB;CzF4+U5C;AACD;;AAEA;CyF9/UA,eAAA;AzFggVA;;AAEA;CACC,ayFr+U2C;CzFs+U3C,UyFr+UsC;AzFs+UvC;AACA;CACC,SyF/9UsC;CzFg+UtC,UAAU;AACX;AACA;CACC,SyF99UsC;CzF+9UtC,UAAU;AACX;;AAEA;CyF/gVA,WAAA;CzFihVC,0ByFz9UmD;AzF09UpD;;AAEA;CACC,ayFp9UsC;AzFq9UvC;;AAEA;;;;;;;;;;;;CAYC,cyF17U+B;AzF27UhC;AACA;;;;;;;;;;;;CAYC,gCyF36U4B;AzF46U7B;;AAEA;CACC,ayFx6UyC;AzFy6U1C;;AAEA;CyFx+UA,cAAa;AzF0+Ub;;AAEA;CACC,ayFl6UuC;AzFm6UxC;;AAEA;CACC,wByFj6U0C;CzFk6U1C,qByFj6U2C;AzFk6U5C;;AAEA;CACC,ayFj6UsC;AzFk6UvC;;AAEA;CACC;EACC,mByF95UkC;CzF+5UnC;AACD;;AAEA;CACC,kByFx5UwC;CzFy5UxC,YyFx5UmC;CzFy5UnC,kByFt5UwC;CzFu5UxC,eyFt5UmC;CzFu5UnC,mByFp5UuD;AzFq5UxD;AACA;CACC;EACC,mByFh5UsD;CzFi5UvD;AACD;;AAEA;CACC,2ByF14U4B;CzF24U5B,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,yByF/3Ue;AzFg4UhB;;AAEA;CACC,gBAAgB;CyF1hVjB,gBAAa;CzF4hVZ,cyFz3U2C;AzF03U5C;;AAEA;CACC,2ByFv3U4B;AzFw3U7B;;AAEA;CACC,ayFn3U0C;CzFo3U1C,uBGtqVyB;AHuqV1B;;AAEA;CyFx2UA,SAAA;AzF02UA;;AAEA;CACC,UAAU;CyF72UX,6BAA0B;CzF+2UzB,kByF/1U2C;CzFg2U3C,yByF91U4B;AzF+1U7B;AACA;CACC,UyFx1U+B;AzFy1UhC;;AAEA;CACC,uByFn1UmD;AzFo1UpD;;AAEA;CACC,UyF90U+B;CzF+0U/B,SyF90UsC;AzF+0UvC;;AAEA;CACC,gBCroVW;ADsoVZ;;AAEA;CACC,cCroVA;CDsoVA,qBCroVgB;ADsoVjB;AACA;;;CAGC,qBCroVgB;ADsoVjB;;AAEA;;;CAGC,qBCroVkB;ADsoVnB;;AAEA;CACC,2CCroVkB;ADsoVnB;;AAEA;CACC,gCCroVmB;ADsoVpB;;AGhxVA;CHmxVC,6BAA6B;CAC7B,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,8B0FvxV8B;C1FwxV9B,gB0F9xVD;A1F+xVA;;AAEA;CACC,8BsBzqVmB;CtB0qVnB,gBG1tVA;AH2tVD;;AAEA;CACC,0B0FxxVI;C1FyxVJ,gBAAgB;AACjB;AACA;CACC;EACC,8BAA8B;CAC/B;AACD;;AAEA;CACC,8BAA8B;CAC9B,gB0FtxVI;A1FuxVL;AACA;CACC;EACC,0B0FhwVI;C1FiwVL;AACD;;AAEA;CACC,6B0FlxVM;C1FmxVN,gB0F5zVD;A1F6zVA;;AAEA;CACC,8B0F3wVM;C1F4wVN,gB0Fj0VD;A1Fk0VA;;AAEA;CACC,4B0FlwVwB;C1FmwVxB,gB0FnvVQ;A1FovVT;;AAEA;CACC,8B0FjwVY;C1FkwVZ,gB0F30VD;A1F40VA;;AAEA;CACC,6B0F/vVoB;C1FgwVpB,gBAAgB;AACjB;AACA;CACC;EACC,4BAA4B;C0Fp1V9B;A1Fs1VA;;AAEA;CACC,8B0F7vVmC;C1F8vVnC,gB0F7vV4B;A1F8vV7B;;AAEA;CACC,0B0F3vVG;C1F4vVH,iB0F/1VD;A1Fg2VA;;AAEA;CACC,8B0F1vVwB;C1F2vVxB,iB0F1vVqB;A1F2vVtB;;AAEA;CACC,+B0Fx2V0B;C1Fy2V1B,iB0Fz2VD;A1F02VA;;AAEA;CACC,6B0F72VA;C1F82VA,iB0FxvVe;A1FyvVhB;;AAEA;CACC,8B0FpvVG;C1FqvVH,iB0Fn3VD;A1Fo3VA;;AAEA;CACC,8B0FnuVoB;C1FouVpB,iB0Fx3VD;A1Fy3VA;;AAEA;CACC,0B0F53VmB;C1F63VnB,iB0F9uVc;A1F+uVf;;AAEA;CACC,gB0F3uViC;A1F4uVlC;;AAEA;CACC,gB0F3uVc;A1F4uVf;;AAEA;CACC,gB0F3uVe;A1F4uVhB;;AAEA;CACC,2B0F1tVoB;A1F2tVrB;;AAEA;CACC,gB0Fj5VD;A1Fk5VA;;AAEA;CACC,gB0FtuVe;A1FuuVhB;;AAEA;CACC,gB0FluViC;A1FmuVlC;;AAEA;CACC,gB0F75VD;A1F85VA;;AAEA;CACC,gB0Fj6VD;A1Fk6VA;;AAEA;;;;;;;;;;;;;;;;;;CAkBC,gB0FltVc;C1FmtVd,c0FltVc;A1FmtVf;;AAEA;CACC,mB0F37VD;A1F47VA;;AAEA;CACC,kB0F7sVgB;A1F8sVjB;;AAEA;;;;;;CAMC,qB0Fx8VmB;C1Fy8VnB,uB0FnsVG;C1FosVH,sBAAsB;AACvB;AACA;CACC;;;;;;E0F5rVW,qBAAoB;E1FmsV9B,uB0FlsVmC;E1FmsVnC,sB0FlsV6B;C1FmsV9B;AACD;AACA;CACC;;;;;;EAMC,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;CACtB;AACD;AACA;CCp3VA;;;;;;EAMC,iBAAgB;EAChB,mBAAgB;EAChB,kBAAgB;CDs3VhB;AACD;;AAEA,KCr3VC;ADs3VD;;CAEC,sBCr3VkB;CDs3VlB,uBCr3VkB;ADs3VnB;AACA;;CAEC,sBCr3VkB;CDs3VlB,uBCr3VkB;ADs3VnB;;AAEA;CACC,YCr3VA;ADs3VD;;AAEA;CGn8VQ,YAAY;AHq8VpB;;AAEA;CACC,Y2F7/VsB;A3F8/VvB;;AAEA;CACC,Y2F7/VuB;A3F8/VxB;;AAEA;CACC,Y2Fz/VsB;A3F0/VvB;;AAEA;CACC,Y2Fv/VE;A3Fw/VH;;AAEA;CACC,Y2Fv/VG;A3Fw/VJ;;AAEA;CACC,Y2Fr/VmB;A3Fs/VpB;;AAEA;CACC,Y2F3hWG;A3F4hWJ;;AAEA;CACC,e2F/hWG;C3FgiWH,uB2FhiWuB;C3FiiWvB,oB2Fl/VyB;C3Fm/VzB,sC2FngWO;C3FogWP,wB2Fj/ViC;A3Fk/VlC;AACA;CACC,iB2FtiWG;A3FuiWJ;;AAEA;;CAEC,gB2F3iWG;A3F4iWJ;;AAEA;CACC,wB2F7+VkB;A3F8+VnB;;AAEA;CACC,W2FnjWG;C3FojWH,Y2Fr+V8B;C3Fs+V9B,iB2FrjWG;A3FsjWJ;;AAEA;CACC,e2Fn+VY;C3Fo+VZ,gB2Fn+VM;C3Fo+VN,gB2Fn+Vc;C3Fo+Vd,e2F5jWG;A3F6jWJ;;AAEA;CACC,c2Fh+V8B;C3Fi+V9B,mB2Fh+VoC;C3Fi+VpC,wE2Fh+VoC;C3Fi+VpC,uB2Fh+VqC;C3Fi+VrC,W2Fh+VuB;C3Fi+VvB,iB2Fh+V+B;C3Fi+V/B,e2Fh+VK;C3Fi+VL,qC2Fz9VoB;C3F09VpB,kB2F/9V0C;C3Fg+V1C,qB2F/9VqC;C3Fg+VrC,8D2F/9VyC;A3Fg+V1C;AACA;;CAEC,W2F9kWG;A3F+kWJ;;AAEA;CACC,c2F59VK;A3F69VN;;AAEA;CACC,c2F59VK;A3F69VN;;AAEA;CACC,c2F39VK;A3F49VN;;AAEA;CACC,yB2Fx9V4B;A3Fy9V7B;;AAEA;CACC,c2FlmWG;A3FmmWJ;;AAEA;CACC,c2FtmWG;A3FumWJ;;AAEA;CACC,c2F1mWG;A3F2mWJ;;AAEA;CACC,c2Ft8VG;A3Fu8VJ;;AAEA;CACC,c2F18VG;A3F28VJ;;AAEA;CACC,c2F/7VM;A3Fg8VP;;AAEA;;;;;;;;;;;GAWG;AACH;CACC,8BG3kW+B;AH4kWhC;;AAEA;CACC,8BAA8B;AG/kWvB;;AHklWR;CACC,8B2Ft+VuB;A3Fu+VxB;;AAEA;CACC,8B2Fn7VmB;A3Fo7VpB;;AAEA;CACC,8B2F36V4B;A3F46V7B;;AAEA;;;;;;;;GAQG;AACH;CACC,gBsB7pWO;AtB8pWR;;AAEA;CACC,sB2F//VG;A3FggWJ;;AAEA;CACC,kB2Fh6VM;A3Fi6VP;;AAEA;CACC,qB2F55VkD;C3F65VlD,0B2F55ViD;C3F65VjD,6B2F55VkD;C3F65VlD,yB2F1gWuB;C3F2gWvB,wB2Fz5VmC;C3F05VnC,qB2Fz5VqC;A3F05VtC;;AAEA;CACC,qB2Fz5VkB;C3F05VlB,0BsBnkWW;CtBokWX,6B2Fz5Vc;C3F05Vd,yB2Fz5Ve;C3F05Vf,wB2F13VwB;C3F23VxB,qB2Fx5Vc;A3Fy5Vf;;AAEA;CACC,qB2Fv5Vc;C3Fw5Vd,0B2F1hWI;C3F2hWJ,6B2Ft5VwC;C3Fu5VxC,yB2F5hWG;C3F6hWH,wB2Fr5VoB;C3Fs5VpB,qB2F9hWG;A3F+hWJ;;AAEA;CACC,qB2F94VmB;C3F+4VnB,0B2FniWG;C3FoiWH,6B2F74VS;C3F84VT,yB2FriWuB;C3FsiWvB,wB2Ft4VG;C3Fu4VH,qB2FviWG;A3FwiWJ;;AAEA;CACC,qB2F93VoB;C3F+3VpB,0B2Fn2VI;C3Fo2VJ,6B2Fh4VC;C3Fi4VD,yB2Fz2VK;C3F02VL,wB2Fl4VC;C3Fm4VD,qB2Fx3VgB;A3Fy3VjB;;AAEA;CACC,mB2Fz3VwB;C3F03VxB,wB2Fv3VqB;C3Fw3VrB,2B2Fz4VoB;C3F04VpB,uB2Fr3VqB;C3Fs3VrB,sB2Fr3VmB;C3Fs3VnB,qB2F54VA;A3F64VD;;AAeA;CACC,2BC7nWgB;AD8nWjB;;AAEA;CACC,6BC7nWgB;CD8nWhB,sBC7nWgB;CD8nWhB,iBC7nWA;AD8nWD;AACA;CACC;EC5nWA,6BAAkB;CD8nWlB;AACD;AACA;CACC;EC5nWA,6BAAkB;CD8nWlB;AACD;AACA;CACC;EACC,6BAA6B;C4FtwW/B;A5FwwWA;AACA;CACC;EACC,W4FtwWE;C5FuwWH;AACD;;AAEA;CACC,kB4FnwWc;A5FowWf;;AAEA;CACC,gB4FnxWgB;A5FoxWjB;;AAEA;CACC,e4F9vWsB;A5F+vWvB;;AAEA;CACC,gB4F3xWgB;A5F4xWjB;;AAEA;CACC,c4F5vWW;A5F6vWZ;;AAEA;CACC,gB4F3vWyB;A5F4vW1B;;AAEA;CACC,e4FxvWa;A5FyvWd;;AAEA;CACC,gB4FtvWG;A5FuvWJ;;AAEA;CACC,Y4FtvWK;A5FuvWN;;AAEA;CACC,gB4FnzWG;A5FozWJ;;AAEA;CACC,e4FlvWW;A5FmvWZ;;AAEA;CACC,gB4F3zWgB;A5F4zWjB;;AAEA;CACC,c4F5uWW;A5F6uWZ;;AAEA;CACC,gB4Fn0WG;A5Fo0WJ;;AAEA;CACC,e4F3uWY;A5F4uWb;;AAEA;CACC,gB4FzuW2B;A5F0uW5B;;AAEA;CACC,a4FpuWuB;A5FquWxB;;AAEA;CACC,iB4FpuWuB;A5FquWxB;;AAEA;CACC,gB4FpuW8B;A5FquW/B;;AAEA;CACC,iB4FpuWK;A5FquWN;;AAEA;CACC,e4FnuWQ;A5FouWT;;AAEA;CACC,iB4FhuW+B;A5FiuWhC;;AAEA;CACC,gB4FhuWQ;A5FiuWT;;AAEA;CACC,iB4F/tWQ;A5FguWT;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iB4FztWiC;A5F0tWlC;;AAEA;CACC,gB4FztWO;A5F0tWR;;AAEA;CACC,iB4FptW6B;A5FqtW9B;;AAEA;CACC,e4FntWK;A5FotWN;;AAEA;CACC,iB4F7sWY;A5F8sWb;;AAEA;CACC,gB4F7sWM;A5F8sWP;;AAEA;CACC,iB4F7sWO;A5F8sWR;;AAEA;CACC,a4FjsW2B;A5FksW5B;;AAEA;CACC,iB4F/rW+B;A5FgsWhC;;AAEA;CACC,gB4F7rWM;A5F8rWP;;AAEA;CACC,iB4F7rW+B;A5F8rWhC;;AAEA;CACC,e4F1rW2B;A5F2rW5B;;AAEA;CACC,iB4Fn6WG;A5Fo6WJ;;AAEA;CACC,gB4FvrW2B;A5FwrW5B;;AAEA;CACC,iB4FtrWO;A5FurWR;;AAEA;CACC,a4F/qWmC;A5FgrWpC;;AAEA;CACC,kB4Fn7WG;A5Fo7WJ;;AAEA;CACC,iB4FxqW4C;A5FyqW7C;;AAEA;CACC,gB4F37WG;A5F47WJ;;AAEA;CACC,iB4FhqWQ;A5FiqWT;;AAEA;CACC,e4FxpWc;A5FypWf;;AAEA;CACC,iB4FlpW4B;A5FmpW7B;;AAEA;CACC,a4F7oW2C;A5F8oW5C;;AAEA;CACC,iB4F/8WgB;A5Fg9WjB;;AAEA;CACC,a4Fn9WG;A5Fo9WJ;;AAEA;CACC,e4F/nWI;A5FgoWL;;AAEA;CACC,c4F/nWe;A5FgoWhB;;AAEA;CACC,e4F5nWsB;A5F6nWvB;;AAEA;CACC,a4F3nWsB;A5F4nWvB;;AAEA;CACC,e4Fv+WI;A5Fw+WL;;AAEA;CACC,c4FhnWoB;A5FinWrB;;AAEA;CACC,e4F/mWG;A5FgnWJ;;AAEA;CACC,W4F1mWG;A5F2mWJ;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,c4FloWG;A5FmoWJ;;AAEA;CACC,eAAe;AGz8WR;;AH48WR;CACC,aAAa;A4FpgXd;;A5FugXA;CACC,e4F7lWgB;A5F8lWjB;;AAEA;CACC,c4FvlWgB;A5FwlWjB;;AAEA;CACC,e4F3lWgB;A5F4lWjB;;AAEA;CACC,Y4FplWG;A5FqlWJ;;AAEA;CACC,gB4FxlWgB;A5FylWjB;;AAEA;CACC,e4F3kWgB;A5F4kWjB;;AAEA;CACC,gB4F/kWgB;A5FglWjB;;AAEA;CACC,c4FnlWG;A5FolWJ;;AAEA;CACC,gB4FvlWgB;A5FwlWjB;;AAEA;CACC,e4F3lWI;A5F4lWL;;AAEA;CACC,gB4F7jWc;A5F8jWf;;AAEA;CACC,Y4F7jWM;A5F8jWP;;AAEA;CACC,gB4F3jWmC;A5F4jWpC;;AAEA;CACC,e4FpjWE;A5FqjWH;;AAEA;CACC,gB4FnjWI;A5FojWL;;AAEA;CACC,c4FhkWG;A5FikWJ;;AAEA;CACC,gB4FliWG;A5FmiWJ;;AAEA;CACC,e4F7hWW;A5F8hWZ;;AAEA;CACC,gB4F7hWY;A5F8hWb;;AAEA;CACC,Y4FnhWK;A5FohWN;;AAEA;CACC,gB6FtlXS;A7FulXV;;AAEA;CACC,e6FnlXG;A7FolXJ;;AAEA;CACC,gB6FnlXY;A7FolXb;;AAEA;CACC,c6FllXK;A7FmlXN;;AAEA;CACC,gB6FnlXM;A7FolXP;;AAEA;CACC,e6F9kXY;A7F+kXb;;AAEA;CACC,gB6FxkX+B;A7FykXhC;;AAEA;CACC,Y6FvkXM;A7FwkXP;;AAEA;CACC,kC6FtkXM;A7FukXP;;AAEA;CACC,qBGpjXY;AHqjXb;;AAEA;CACC;EAGC,2C6F/jXE;C7FgkXH;CACA;EAGC,oC6F1jXE;C7F2jXH;AACD;;AAEA;CACC;EAGC,2C6F1jXC;C7F2jXF;CACA;EAGC,oC6FrjXM;C7FsjXP;AACD;;AAEA;CACC;EAGC,2C6F3iXO;C7F4iXR;CACA;EAGC,oC6FthX+B;C7FuhXhC;AACD;;AAEA;C6FngXA,oCAA0B;A7FqgX1B;;AAEA;;;;CAIC,qB6FlgXC;A7FmgXF;;AAEA;CACC;E6FjgXD,kBAAa;EAEL,mBA4DH;C7Fs8WJ;CACA;EACC,mB6F9/WU;E7F+/WV,oB6F9/Wc;C7F+/Wf;CACA;EACC,a6F7/WG;E7F8/WH,c6F3gXD;C7F4gXA;CACA;EACC,mB6Fv/WY;E7Fw/WZ,oB6F/gXW;C7FghXZ;CACA;EACC,mB6Fj/WgC;E7Fk/WhC,oB6Fj/WY;C7Fk/Wb;CACA;EACC,a6Fj/Wa;E7Fk/Wb,c6Fj/WU;C7Fk/WX;CACA;EACC,mB6F/+WY;E7Fg/WZ,oB6F/+Wc;C7Fg/Wf;CACA;EACC,mB6F9hXW;E7F+hXX,oB6F5+We;C7F6+WhB;CACA;E8FvtXD,aAAQ;E9FytXN,c8FvtXE;C9FwtXH;CACA;EACC,mB8FzsXI;E9F0sXJ,oB8FltXsB;C9FmtXvB;CACA;EACC,mB8FvsXU;E9FwsXV,oB8FtsXE;C9FusXH;CACA;EACC,c8FztXE;E9F0tXF,e8FxrXQ;C9FyrXT;CACA;EACC,gC8FxrXW;C9FyrXZ;AACD;;AAEA;CACC,a8FluXG;C9FmuXH,mB8FvrX4B;C9FwrX5B,uB8FpuXG;C9FquXH,a8FrrXmB;C9FsrXnB,e8FtuXG;C9FuuXH,W8FlrXe;C9FmrXf,e8FxuXG;A9FyuXJ;AACA;CACC,0B8F9qXkC;C9F+qXlC,kB8F9qX2B;C9F+qX3B,qB8F7uXG;C9F8uXH,kB8F5qX2B;C9F6qX3B,W8F5qXS;C9F6qXT,Y8F5qXU;A9F6qXX;AACA;CACC,+B8F3qX0C;A9F4qX3C;AACA;CACC,gC8FvqX4B;A9FwqX7B;AACA;CACC,+B8FpwXO;A9FqwXR;AACA;CACC,gCAAgC;A8FvwXjC;A9FywXA;CACC,+B8FtqXyB;A9FuqX1B;;AAEA;CACC;EACC,iC8FjqXG;C9FkqXJ;CACA;EACC,mC8FjqX2B;C9FkqX5B;CACA;EACC,iC8F7nXe;C9F8nXhB;CACA;EACC,qC8F9pXoD;C9F+pXrD;CACA;EACC,iC8F7oXmB;C9F8oXpB;AACD;;AAEA;CACC;EACC,0B8F7pXqB;C9F8pXtB;CACA;EACC,4B8FxpXuB;C9FypXxB;CACA;EACC,0B8F7pXqB;C9F8pXtB;CACA;EACC,4B8FzpXe;C9F0pXhB;CACA;EACC,wB8FlyXE;C9FmyXH;AACD;;AAEA;CACC;EACC,0B8FrpX4B;C9FspX7B;CACA;EACC,6B8FppX+B;C9FqpXhC;CACA;EACC,0B8FnpXa;C9FopXd;CACA;EACC,4B8FnpXiB;C9FopXlB;CACA;EACC,wB8FjpXwC;C9FkpXzC;AACD;;AAEA;CACC;EACC,0B8F1oXuB;C9F2oXxB;CACA;EACC,6B8F9oX2B;C9F+oX5B;CACA;EACC,0B8FnoXmB;C9FooXpB;CACA;EACC,2B8FvoXuB;C9FwoXxB;CACA;EACC,wB8FloXE;C9FmoXH;AACD;;AAEA;CACC;EACC,iC8FtnXe;C9FunXhB;CACA;EGrzXO,sC2FpCW;C9F21XlB;CACA;EACC,iCAAiC;C8F71XnC;C9F+1XC;EACC,mC8FxnXE;C9FynXH;CACA;EACC,iC8FvnX2B;C9FwnX5B;AACD;;AAEA;CACC,oB8F71XG;C9F81XH,mB8FhnXI;C9FinXJ,yB8F/mXwC;C9FgnXxC,gC8F/mX6B;C9FgnX7B,iC8F9mXgB;C9F+mXhB,gB8Fl2XG;A9Fm2XJ;AACA;CACC,kB8F1mXwB;C9F2mXxB,S8FzmXmB;A9F0mXpB;AACA;CACC,kB8Fz2XG;C9F02XH,S8FvmXW;A9FwmXZ;AACA;CACC,qB8FtmX6B;A9FumX9B;AACA;CACC,mC8FpmXG;C9FqmXH,kB8Fj3XG;C9Fk3XH,oB8FpmXS;A9FqmXV;AACA;CACC;E+Fh4XD,6BAA6B;E/Fk4X3B,sB+Fj4XsB;C/Fk4XvB;AACD;AACA;CACC;EACC,4B+F53X0B;E/F63X1B,sB+Fv4XsB;E/Fw4XtB,+B+F53XgB;C/F63XjB;AACD;AACA;CACC;EACC,uC+Fr4XM;C/Fs4XP;AACD;AACA;CACC;EACC,uC+Fv3XI;E/Fw3XJ,sB+Fn5XE;C/Fo5XH;AACD;AACA;CACC,6B+Fv5XuB;C/Fw5XvB,uB+Fn3XgC;A/Fo3XjC;AACA;CACC;EACC,4B+Fr2XmB;E/Fs2XnB,sB+F75XE;C/F85XH;AACD;AACA;CACC;EACC,uC+F/1XI;E/Fg2XJ,iC+Fn6XG;C/Fo6XJ;AACD;AACA;CACC,6B+Fv6XuB;A/Fw6XxB;AACA;CACC;EACC,4B+Fp2X+C;C/Fq2XhD;AACD;AACA;CACC;EACC,uC+Fl5XU;E/Fm5XV,sB+F51XI;C/F61XL;AACD;AACA;CACC;EACC,uC+Ft1XU;C/Fu1XX;AACD;;AAEA;;CAEC,a+F57XG;A/F67XJ;;AAEA;CACC;EACC,c+Fj8XE;C/Fk8XH;AACD;;AAEA;CACC,e+Fj0XG;A/Fk0XJ;;AAEA;CACC,Y+F/zXS;C/Fg0XT,mB+F9zXG;C/F+zXH,qB+Fv0XG;C/Fw0XH,mC+Fx0XgC;C/Fy0XhC,gB+F7zXyB;C/F8zXzB,kB+F10XG;C/F20XH,M+F3zXG;C/F4zXH,yB+F50XuB;C/F60XvB,U+F1zXK;A/F2zXN;AACA;CACC,oB+F1zXa;A/F2zXd;AACA;CACC;EACC,oB+F1zXK;C/F2zXN;AACD;AACA;CACC;EACC,gB+FpzX4B;E/FqzX5B,iB+F11XE;C/F21XH;AACD;AACA;CACC,a+F91XG;A/F+1XJ;AACA;CACC;EACC,c+FhzX4B;E/FizX5B,Y+FhzXsB;C/FizXvB;AACD;AACA;CACC,a+F9yXM;C/F+yXN,Y+F9yXM;C/F+yXN,W+F5yX+B;C/F6yX/B,2B+F5yXqC;C/F6yXrC,mB+F5yXkC;C/F6yXlC,mB+F52XG;C/F62XH,W+FxyXM;C/FyyXN,qB+FxyXgB;C/FyyXhB,sB+FxyXe;C/FyyXf,uB+FxyXoB;C/FyyXpB,gB+FxyXY;A/FyyXb;AACA;CACC;EACC,qB+FvyXgB;E/FwyXhB,sB+FryX6C;C/FsyX9C;AACD;AACA;;CAEC,e+F9xXwB;C/F+xXxB,gB+F53XG;C/F63XH,uB+F5xX6B;A/F6xX9B;AACA;CACC;EACC,e+Fj4XE;E/Fk4XF,gB+FxxXQ;E/FyxXR,uB+Fn4XsB;C/Fo4XvB;AACD;AACA;CACC,sB+Fv4XuB;C/Fw4XvB,kB+FpxXqB;C/FqxXrB,W+Fz4XG;A/F04XJ;AACA;CACC,oB+FjxXY;A/FkxXb;AACA;CACC,2B+FhxXuB;A/FixXxB;AACA;;CAEC,c+FpxXG;C/FqxXH,iB+FzwXU;C/F0wXV,kB+FzwXgB;C/F0wXhB,mB+FvxXG;A/FwxXJ;AACA;CACC,mB+FxwXgB;C/FywXhB,gB+F3xXG;C/F4xXH,mB+F5xXG;C/F6xXH,mB+FxwXU;A/FywXX;AACA;CACC;EACC,Q+FhwXU;E/FiwXV,uB+FlyXsB;C/FmyXvB;AACD;AACA;CACC;E+F7uXD,QAAA;CACA;A/F+uXA;AACA;CACC,oB+F3uXU;A/F4uXX;;AAEA;CACC;E+FpuXD,YAAA;C/FsuXC;AACD;;AAEA;CACC;EgG1jYD,WAAA;ChG4jYC;CACA;EACC,agG9jYF;ChG+jYC;AACD;;AAEA;CACC,eAAe;CgGnkYhB,kBAAC;ChGqkYA,YgGxjYG;ChGyjYH,kBAAkB;CgGtkYnB,QAAA;ChGwkYC,2BgGtjYkB;ChGujYlB,aG9/XA;CH+/XA,iBG9/XgB;CH+/XhB,uBG9/XoB;CH+/XpB,cgGjgYC;ChGkgYD,aAAa;CACb,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,uBAAuB;AACxB;AACA;CACC;EACC,cAAc;EACd,QAAQ;CACT;AACD;AACA;CACC;EACC,QAAQ;CACT;AACD;AACA;CACC;EACC,YgG1kYW;EhG2kYX,QgGjmYF;EhGkmYE,YgG1kYG;EhG2kYH,WgG1kYU;ChG2kYX;AACD;AACA;CACC;EACC,QgG1kYG;EhG2kYH,YgGzmYF;EhG0mYE,WgG1kYI;EhG2kYJ,gBgG1kYU;ChG2kYX;AACD;;AAEA;CACC,qBgGxkYW;ChGykYX,YgGjnYD;ChGknYC,kBgGtkYe;ChGwkYf,mCgGpnYA;ChGqnYA,esB1mYO;CtB2mYP,YGrmYO;AHsmYR;AACA;CACC,kBgGznYD;ChG0nYC,MgGlkYM;ChGmkYN,OgGlkYG;ChGmkYH,UgGlkYG;AhGmkYJ;;AAEA;CACC,mBgGlkYS;ChGmkYT,cgG3jYoB;ChG4jYpB,gBgG3jYqB;ChG4jYrB,wBgG1jYQ;ChG2jYR,mBAAmB;CgGpoYpB,sBAAoB;ChGsoYnB,kBgGriYI;CAjGL,gCAkGI;ChGuiYH,UgGtiYe;AhGuiYhB;;AAEA;CACC,agGtiYe;AhGuiYhB;AACA;CgG/oYA,aAAA;AhGipYA;AACA;CACC,UAAU;AACX;;AAEA;CACC,egGniYyB;AhGoiY1B;;AAEA;CACC,egGjiYqB;AhGkiYtB;;AAEA;CACC,egG/hYQ;AhGgiYT;;AAEA;CACC,eAAe;AAChB;;AAEA;CgGthYA,eAAA;AhGwhYA;;AAEA;;CAEC,eiGxqYO;CjGyqYP,gBiGxqYO;AjGyqYR;;AAEA;CAEC,0BiGlqYC;CjGmqYD,eiGnrYD;CjGorYC,gBiGxqYW;AjGyqYZ;;AAEA;CAEC,yDAAyD;AAC1D;;AAEA;CiGnqYA,2DAMa;AjGgqYb;;AAEA;CiG7pYA;EACA,aAAA;CACA;CACA;EACA,eAAA;CACA;AjG+pYA;;AAEA;CACC,aAAa;AkG3sYd;;AlG8sYA;CACC,ckG5sYa;AlG6sYd;;AAEA;CACC,akG5sYS;AlG6sYV;;AAEA;CACC,ckG5sYW;AlG6sYZ;AACA;CACC,ckG3sYQ;AlG4sYT;AACA;CACC;EACC,ckG3sYQ;ClG4sYT;AACD;AACA;CkGvsYA;EACI,cAAa;ClGysYhB;AACD;;AAEA;CACC,akGxsYe;AlGysYhB;;AAEA;CACC,oBkGvsYA;AlGwsYD;;AAEA;CACC,sBkGvsYc;ClGwsYd,uBkGvsYa;ClGwsYb,sBkGrsYC;AlGssYF;;AAEA;CACC,gBkGrsYC;AlGssYF;AACA;CACC,akGpsYC;AlGqsYF;AACA;CACC,akGpsYE;AlGqsYH;;AAEA;CACC,UkGhsYW;ClGisYX,kBkG7rYA;ClG8rYA,akG7rYU;ClG8rYV,2BkG7rYW;ClG8rYX,UkG7rYC;ClG8rYD,mBkG7rYM;ClG8rYN,yBkG7rYY;ClG8rYZ,2BkG7rYa;ClG8rYb,sBkG7rYkB;ClG8rYlB,sBkG7rYiB;AlG8rYlB;AACA;CACC,mBkG5rYC;AlG6rYF;AACA;CACC,YkG1rYC;ClG2rYD,oBkG/qYI;ClGgrYJ,mBkGvvYa;ClGwvYb,mBkGzrYW;ClG0rYX,akGzrYQ;ClG0rYR,akGzrYS;ClG0rYT,ekGzrYS;ClG0rYT,MkGzrYE;ClG0rYF,gCkGzrYQ;ClG0rYR,yBsB5wYO;CtB6wYP,gBkGvrYA;ClGwrYA,mBkGtrYiB;AlGurYlB;AACA;CACC;EACC,kBkGtrYiB;ElGurYjB,wBkGtrYW;ElGurYX,iBkGtrYgB;ElGurYhB,YkGvwYF;ClGwwYC;AACD;AACA;CACC;EACC,YkGhrYG;ElGirYH,wBkGhrYqB;ElGirYrB,YkGhrYG;ClGirYJ;AACD;AACA;CACC;EACC,qBkGtqYgB;ElGuqYhB,uBkGrqYI;ClGsqYL;AACD;AACA;CACC;EkGxxYD,UAAA;ElG0xYE,0BkGrqYU;ClGsqYX;AACD;AACA;CACC,UsB5yYO;CtB6yYP,YkGrqYE;ClGsqYF,WkGrqYU;AlGsqYX;AACA;CACC,YkGnqYC;ClGoqYD,WkGnqYC;AlGoqYF;;AAEA;CACC,2BkG/pYiC;AlGgqYlC;;AAEA;CACC,2BkG9qYG;AlG+qYJ;;AAEA;CACC,2BkG3pYuC;AlG4pYxC;;AAEA;CACC,2BkG3pYoB;AlG4pYrB;;AAEA;CACC,2BkGxpY6C;AlGypY9C;;AAEA;CACC,2BkGvpY6C;AlGwpY9C;;AAEA;CACC,2BkGvpYiD;AlGwpYlD;;AAEA;CACC,2BkGvoYY;AlGwoYb;;AAEA;CACC,2BkG3oYY;AlG4oYb;;AAEA;CACC,2BC9vYW;AD+vYZ;;AAEA;CACC,2BkGnpYY;AlGopYb;;AAEA;CACC,2BkGvpYY;AlGwpYb;;AAEA;CACC,2BkG3pYY;AlG4pYb;;AAEA;CACC,2BkG/pYY;AlGgqYb;;AAEA;CACC,6BsB7wYyB;AtB8wY1B;;AAEA;CACC,6BkGvqYY;AlGwqYb;;AAEA;CACC,6BkG3qYY;AlG4qYb;;AAEA;CACC,6BkG/qYY;AlGgrYb;;AAEA;CACC,6BkGnrYY;AlGorYb;;AAEA;CACC,6BsB7xY0B;AtB8xY3B;;AAEA;CACC,6BkG3rYY;AlG4rYb;;AAEA;CACC,6BkG/rYY;AlGgsYb;;AAEA;CACC,6BkGnsYY;AlGosYb;;AAEA;CACC,6BkGvsYY;AlGwsYb;;AAEA;CACC,6BsB7yYyB;AtB8yY1B;;AAEA;CACC,6BkG/sYY;AlGgtYb;;AAEA;CACC,6BkGntYY;AlGotYb;;AAEA;CACC,6BkGxsYa;AlGysYd;;AAEA,iBkGxsYQ;AlGysYR;CACC,iBsBx6YO;AtBy6YR;AACA;;;CAIC,qBkGtsYgB;CAKjB,+BAAiB;ClGqsYhB,sCAAsC;CkGjsYvC,oBAAU;AlGmsYV;AACA;CAEC,mBkGjsYG;AlGksYJ;AACA;CAEC,mBkGhsYkB;AlGisYnB;;AkG5rYA,iBAAA;AlG+rYA;CACC,WkG9rYO;ClG+rYP,YkG9rYO;ClG+rYP,qBkG7rYG;ClG8rYH,qBkG7rYkB;ClG8rYlB,ekG7rYO;ClG8rYP,kBkG5rYI;ClG6rYJ,mBkG5rYkB;ClG6rYlB,ekG5rYO;ClG6rYP,cAAc;CG/6YP,0BAAwB;CHi7Y/B,ckG7tYW;AlG8tYZ;AACA;;CAEC,WmGp9Ya;CnGq9Yb,WmGp9YG;CnGq9YH,YmGp9YY;CnGq9YZ,qBGp6YyB;CHq6YzB,kBmG19YS;CnG29YT,MmGr9YO;CnGs9YP,QmG59YD;CnG69YC,SmGp9YY;CnGq9YZ,amGp9Ye;CnGq9Yf,yBG16YyB;CH26YzB,YmGh+YD;CnGk+YC,qBmGr9YmB;CnGu9YnB,+BmGn9YM;CnGq9YN,sCmGn9Y+B;AnGo9YhC;AACA;;CAEC,UmGp9YW;CnGq9YX,cmGn9Ye;AnGo9YhB;AACA;CACC;EACC,YmGj9YM;EnGk9YN,WmGj9Ya;CnGk9Yd;AACD;;AAqBA;CACC;EoG1gZA,qBAAc;EACd,UAAO;CpG6gZP;CACA;EoG3gZA,YAAK;CpG6gZL;CACA;EoG3gZA,aAAY;CpG6gZZ;CACA;EAEC,mBoG9gZS;EpG+gZT,UoG9gZA;CpG+gZD;AACD;;AAEA;;CAEC,WoG/gZS;CpGghZT,eoG/gZa;CpGghZb;;KoG7gZC;ApGghZF;AACA;CACC;;EoGtiZD,WA2BC;EpG8gZC,mBoG5gZA;CpG6gZD;AACD;AACA;CACC;;EAEC,WoGzgZA;EpG0gZA,kBoG3gZD;CpG4gZA;AACD;;AAEA;CACC,WoGvgZS;CpGwgZT,YoGvgZC;CpGwgZD,qBoGtgZC;ApGugZF;AACA;CACC;EACC,kBoG1gZA;CpG2gZD;AACD;;AAEA;CACC,WoGlgZA;CpGmgZA,qBoGlgZc;ApGmgZf;AACA;CACC,oBoGlgZW;CpGmgZX,aoGlgZS;CpGmgZT,WoGlgZC;CpGmgZD,mBoGlgZc;ApGmgZf;;AAEA;CACC,eoGlgZY;CpGmgZZ,MoGlgZC;CpGmgZD,WoGlgZC;ApGmgZF;;AAEA;CACC,iBoGhgZa;ApGigZd;;AAEA;CACC,aoGvhZA;ApGwhZD;;AAEA;CACC,iBoG9/Ya;ApG+/Yd;;AAEA;CACC,WoG5/YU;CpG6/YV,kBoG5/Ya;ApG6/Yd;;AAEA;CACC,sBoG1/YU;ApG2/YX;;AAEA;CACC,sBoGt/YC;ApGu/YF;;AAEA;CACC,eoGt/YW;CpGu/YX,mBoGt/YgB;CpGy/YhB,oBoGt/YW;CpGu/YX;;;;;yEoGp+YC;ApG0+YF;;AA6BA;CACC;EACC,kBoGl+Yc;CpGm+Yf;CACA;EACC,aoGj+YU;CpGk+YX;AACD;;AAEA;;CAEC,mBoG99Ya;CpG+9Yb,gBoG99YY;CpG+9YZ,mBoG99YQ;ApG+9YT;;AAEA;CACC,YoG79YG;CpG89YH,aoG19YA;CpG29YA,mBoG19YS;ApG29YV;AACA;CACC,YoGx9YA;CpGy9YA,2BoGx9YmB;CpGy9YnB,yBoGx9YU;CpGy9YV,gBoGx9YC;CpGy9YD,uBoG59YA;CpG69YA,sBoGx9YY;CpGy9YZ,YoG99YA;ApG+9YD;AACA;CACC;EoGjrZD,YA6NC;CpGs9YA;AACD;AACA;CACC;EACC,coG19YD;CpG29YA;AACD;AACA;CACC;EACC,gBoGp9YC;CpGq9YF;AACD;AACA;CACC;EACC,aoGt9YU;CpGu9YX;AACD;AACA;CACC,eoGh9YS;CpGi9YT,eoGh9YU;CpGi9YV,YoGh9YU;CpGi9YV,aoGh9YU;CpGi9YV,oCoG/8YI;CpGg9YJ,oBoG98YE;CpG+8YF,YoG78YA;ApG88YD;AACA;CACC,mBoG78YiB;CpG88YjB,gBoG78YU;ApG88YX;AACA;CACC,2BoG78YC;CpG88YD,YoG78YS;CpG88YT,gBoG78Ya;CpG88Yb,YoG78YS;CpG88YT,oCoG78YuB;ApG88YxB;AACA;CACC,qBoG58Ya;ApG68Yd;AACA;CACC,oBoG58YgB;ApG68YjB;AACA;CACC,gBoG38YE;ApG48YH;AACA;CACC,sBoG18YU;ApG28YX;AACA;CACC,qBoG18YY;ApG28Yb;AACA;CACC;EACC,kBsBptZK;CtBqtZN;AACD;AACA;CACC;EACC,YoGv8YC;EpGw8YD,sBoGv8Ya;EpGw8Yb,4BoGt8YC;CpGu8YF;CACA;EACC,kBoGt8YW;EpGu8YX,eoGt8YQ;CpGu8YT;AACD;AACA;CACC;EACC,aoGt8YS;CpGu8YV;AACD;AACA;CACC,mBoGl8YkB;CpGm8YlB,gBoGl8YW;CpGm8YX,coGl8YU;ApGm8YX;AACA;CACC;EoGlwZD,aAwTC;CpG48YA;AACD;AACA;CACC,mBoGh8YkB;ApGi8YnB;;AAEA;CACC,coG97YA;ApG+7YD;;AAEA;CACC,kBoG97YU;CpG+7YV;;;;;;;;;;;;IAYG;AGhuZI;;AHmuZR;CACC,WoGhyZO;CpGiyZP,aoGz7YS;ApG07YV;;AAEA;CACC,4CoGp7YC;CpGq7YD,+CAA+C;AqGpyZhD;;ArGuyZA;CACC,YqGpyZS;CrGqyZT,mBqGpyZkB;ArGqyZnB;AACA;CACC,YqGpyZa;CrGqyZb,aqGpyZS;CrGqyZT,mBqGpyZG;ArGqyZJ;AACA;CACC,cqGpyZM;ArGqyZP;AACA;CACC,uBqGpyZY;ArGqyZb;AACA;CACC,YqGpyZQ;CrGqyZR,WqGpyZC;CrGqyZD,kBqGpyZY;CrGqyZZ,uBqGpyZkB;CrGqyZlB,aqGpyZC;CrGqyZD,mBqGpyZc;CrGqyZd,oCGnwZwC;AHowZzC;AACA;CACC;EACC,kBqGlyZe;CrGmyZhB;AACD;AACA;CACC;EACC,eqGlyZY;CrGmyZb;AACD;AACA;CACC;EACC,gBqGjyZoB;CrGkyZrB;AACD;AACA;CACC,kBqG/0ZD;CrGg1ZC,qBqGhyZgB;CrGiyZhB,uBqGhyZa;CrGiyZb,yBqGhyZgB;CrGiyZhB,WqGhyZO;CrGiyZP,eqGhyZS;CrGiyZT,YqGhyZO;CrGiyZP,cqGhyZQ;CrGiyZR,sBsB70ZO;CtB80ZP,aqGx1ZD;CrGy1ZC,uBqG9xZU;CrG+xZV,mBsBj1ZW;AtBk1ZZ;AACA;CACC;EACC,sBqG5xZY;CrG6xZb;AACD;AACA;CACC;EACC,iBqG5xZc;ErG6xZd,sBqG3xZC;CrG4xZF;AACD;AACA;CACC;EACC,iBqG1xZW;ErG2xZX,+BqG1xZuB;ErG2xZvB,aqG1xZA;ErG2xZA,cqG52ZF;ErG62ZE,iBqG1xZa;CrG2xZd;AACD;AACA;CACC,iBqGvxZU;CrGwxZV,cqGl3ZD;ArGm3ZA;AACA;CACC;EACC,mBqGvxZQ;CrGwxZT;AACD;AACA;CACC;EACC,cqGvxZC;ErGwxZD,eqGvxZC;CrGwxZF;AACD;AACA;CACC;EACC,aqGvxZC;ErGwxZD,cqGvxZC;CrGwxZF;AACD;AACA;CACC,eqGrxZG;ArGsxZJ;AACA;CACC,eAAe;ACzxZhB;AD2xZA;CACC,eAAe;AsG34ZhB;AAAA;;;;CtGi5ZC,cGv0ZY;AHw0Zb;AACA;CACC,asGp5ZD;AtGq5ZA;AACA;CACC,kBsGt5ZA;CtGu5ZA,mBsGv5ZA;CtGw5ZA,kBsG/4ZgB;CtGg5ZhB,UAAU;CsG15ZX,QAAA;CtG45ZC,mBsG54ZiB;CtG64ZjB,YGr1ZA;CHs1ZA,WGr1ZA;CHs1ZA,iBGr1ZY;CHs1ZZ,kBAAkB;CsGh6ZnB,YAmBC;CtG+4ZA,esG94ZQ;AtG+4ZT;AsGn6ZA;CAAA;EA2BI,eAAe;EnGMX,cAAY;EHu4ZlB,sBsGh5ZA;EtGi5ZA,sBsGj5ZA;EtGk5ZA,oBsG74ZkB;CtG84ZnB;AACD;AACA;CACC;EACC,gBAAgB;EsG/6ZlB,eAAY;EAuCT,UAAA;EnGiCF,sBAAoB;EACpB,WAAA;EACA,cAAY;CH22ZZ;AACD;AACA;;CsGv7ZA,WAAY;AtG07ZZ;AACA;CsG37ZA,cAAY;AtG67ZZ;AACA;CACC,qBsG34ZiB;AtG44ZlB;AACA;CACC,esG34ZS;CtG44ZT,iDsG34ZgC;CtG44ZhC,SsG34ZS;CtG44ZT,gBsGj4ZE;CtGk4ZF,SGr6Za;CHs6Zb,8BsGt5ZC;CtGu5ZD,gBsG14ZW;AtG24ZZ;AACA;CACC;EACC,gBsG14ZW;CtG24ZZ;CsGt4ZD;;EAEC,eAAY;CtGw4ZZ;CACA;EsGt4ZA,eAAY;CtGw4ZZ;AACD;AACA;CACC,gBG74ZY;AH84Zb;AACA;CACC,gBsGz4Zc;AtG04Zf;AACA;CACC,kBG57ZmB;AH67ZpB;AACA;CACC,sBG78ZyB;AH88Z1B;AACA;CACC,YsG14ZC;AtG24ZF;AACA;CACC,gBsG14ZW;CtG24ZX,2BsGz4ZY;CtG04ZZ,gBsGz4ZY;CtG04ZZ,uBsGz4ZW;CtG04ZX,sBCh+ZkB;CDi+ZlB,YsGz4ZU;CtG04ZV,oCsGz4Ze;AtG04ZhB;AACA;CACC;EACC,YGl+ZM;CHm+ZP;AACD;AACA;CCp4ZA;EsGjHC,cAAY;CvGw/ZZ;AACD;AACA;CuGn/ZC;EACG,gBAAC;CvGq/ZJ;AACD;AACA;CACC,esBt/ZW;CtBu/ZX,euG1/ZA;CvG2/ZA,YuG1/ZG;CvG2/ZH,asBz/ZW;CtB0/ZX,oCuG7/Z6B;CvG8/Z7B,oBuG7/ZsB;CvG8/ZtB,YuG1+ZI;AvG2+ZL;AACA;CuGhgaI,mBAAmB;CvGkgatB,gBuGhgac;AvGigaf;AACA;CACC,gBuG7/ZM;CvG8/ZN,YuGvgaA;CvGwgaA,mBuGvgaI;CvGwgaJ,YsBtgaO;CtBugaP,oCuG1ga6B;AvG2ga9B;AACA;CACC,qBAAqB;AACtB;AACA;CACC,oBuG7gac;AvG8gaf;;AAEA;CACC,auGphaA;AvGqhaD;;AAEA;CACC,auGvhaG;AvGwhaJ;;AAEA;CuG1haI,qBAAmB;AvG4havB;;AAEA;CACC,asB7haW;AtB8haZ;;AAEA;CACC,auGpiaA;AvGqiaD;;AAEA;CuGviaC,qBAAmB;AvGyiapB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgFG;AACH;CACC,oBuG5nasB;CvG6natB,oBuG/maO;CvGgnaP,SuG/naA;AvGgoaD;AACA;CACC,QAAQ;CuGloaR,0BAAmB;AvGooapB;AACA;CACC,0BuGtoamB;CvGuoanB,WuGtoaG;CvGuoaH,yBuG/naM;AvGgoaP;AACA;;CAEC,WuG5oaA;CvG6oaA,wBuG5oasB;AvG6oavB;AACA;CuG/oaC,gBAAA;CACG,iBAAC;CvGipaJ,mBuG/oac;AvGgpaf;AACA;CACC,sCuG5oaM;AvG6oaP;AACA;CACC,gBuGzoaO;CvG0oaP,iBuGzpaA;CvG0paA,uBuGzpasB;CvG0patB,qBsBxpaW;CtBypaX,4BAA4B;CuG5pa5B,sBAAmB;AvG8papB;AACA;CACC,euGhqaA;CvGiqaA,qBuGhqasB;AvGiqavB;AACA;CACC,mBuGnqaI;CvGoqaJ,csBlqaW;AtBmqaZ;AACA;CACC,iCuGlpaI;CvGmpaJ,qBAAqB;AACtB;AACA;CACC,mBuG5oac;CvG6oad,cuG7kaE;AvG8kaH;AACA;CACC,WAAW;CACX,eAAe;CACf,cuG/+ZC;AvGg/ZF;AACA;CACC,uBCrlaW;CDslaX,gBuGzpaC;CvG0paD,mBuGzpamB;CvG0panB,kBsBrraO;CtBsraP,gBuG5paC;CvG6paD,qBuG5pamB;AvG6papB;AACA;CACC;EACC,kBsB3raM;CtB4raP;AACD;AACA;CACC,cuGrqaA;CvGsqaA,6BuGlpaG;CvGmpaH,qBuG3oaS;CvG4oaT,kBuGxqagB;CvGyqahB,mCuGrpaG;CvGspaH,mBuGroaK;AvGsoaN;AACA;CACC,qBuG9naK;AvG+naN;AACA;CACC;EACC,QuGhraE;EvGiraF,auGjraE;EvGkraF,SuGlraE;EvGmraF,wBuG1nasB;EvG2natB,gBuGrrae;EvGsraf,YuGtraD;EvGuraC,wBuGvrae;EvGwraf,uBuGxrae;CvGyrahB;CACA;EACC,yBuG1raG;CvG2raJ;AACD;AACA;CACC;EACC,kBuG/rakB;EvGgsalB,YuGhsaE;EvGisaF,SuGjsaE;CvGksaH;AACD;;AAEA;CACC,auGtsaG;CvGusaH,uBuGxnaQ;CvGynaR,yBuGzsagB;CvG0sahB,uBuGzsamB;CvG0sanB,0BuGvnawD;AvGwnazD;AACA;CACC,kBuG7samB;CvG8sanB,sBuG9samB;AvG+sapB;AACA;;CAEC,mBuGntagB;CvGotahB,iBuGntaG;CvGotaH,gBuGptaG;AvGqtaJ;AACA;CACC,yBuGxtagB;CvGytahB,kBuGxtamB;AvGytapB;;AAEA;CACC,UuG5taG;CvG6taH,auG7taG;CvG8taH,mBuG1maoB;CvG2mapB,sBuGhuagB;AvGiuajB;AACA;CACC,gBuGnuaA;AvGouaD;AACA;CACC,kBuGtuagB;CvGuuahB,gBuGtuaI;AvGuuaL;AACA;CACC;EACC,sBuG1uakB;CvG2uanB;AACD;AACA;CACC;EACC,auGhvaD;CvGivaA;AACD;AACA;CACC,euGnvaG;CvGovaH,WsB/waO;CtBgxaP,cuGtvaA;CvGuvaA,gBuGtvaI;AvGuvaL;AACA;CACC,cuGzvaG;AvG0vaJ;AACA;;CAEC,cuG9laG;CvG+laH,oBuG/vagB;CvGgwahB,cuG/vaG;CvGgwaH,gBsB3xaW;CtB4xaX,gBAAgB;AACjB;AACA;CACC;EuGlsaE,iBAAA;EvGosaD,kBAAkB;CACnB;CACA;EACC,eAAe;CAChB;AACD;AACA;CACC;EACC,iBuG/wae;EvGgxaf,kBuG/wakB;EvGgxalB,csB3yaM;CtB4yaP;AACD;;AAEA;CACC,oBuGrxamB;CvGsxanB,kBsBjzaO;AtBkzaR;AACA;;;CAGC,qBuG3xamB;AvG4xapB;;AAEA;CACC,auG7vaW;CvG8vaX,cuGjyaA;CvGkyaA,uBuGjyamB;AvGkyapB;AACA;CACC;EACC,gBuGryakB;EvGsyalB,iBuGtyakB;CvGuyanB;AACD;;AAEA;CACC,kBuG5yagB;AvG6yajB;;AAEA;CACC;EACC,auGhzaE;CvGizaH;AACD;;AAEA;CACC,mBuGrzamB;CvGszanB,WuGtzaG;CvGuzaH,yBuGvzamB;AvGwzapB;AACA;;CAEC,WuG5zaA;CvG6zaA,wBuG5zamB;AvG6zapB;;AAEA;CACC,sBuG7uawD;AvG8uazD;;AAEA;CACC,iBuGp0amB;CvGq0anB,gBuG5uamB;AvG6uapB;AACA;CACC;EACC,iBuGz0aG;CvG00aJ;AACD;AACA;CACC;EACC,euG90aG;CvG+0aJ;AACD;;AAEA;CACC;;EAEC,wBuGt1ae;CvGu1ahB;CACA;EACC,2BuGz1aA;CvG01aD;CACA;EACC,0BuG51aA;CvG61aD;AACD;;AAEA;CACC,auGh2aG;AvGi2aJ;;AAEA;CACC,qBsB/3aW;AtBg4aZ;;AAEA;CACC,auGz2aA;AvG02aD;;AAEA;CACC,auG52aG;AvG62aJ;;AAEA;CACC,qBuGrtaK;AvGstaN;;AAEA;CACC,auGr3aA;AvGs3aD;;AAEA;CuGx3aC,aAAA;AvG03aD;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,auG3taC;AvG4taF;;AAEA;CACC,auGr4aA;AvGs4aD;;AAEA;CACC,qBuGx4amB;AvGy4apB;;AAEA;CACC,auG/3aa;AvGg4ad;;AAEA;CACC,gBuGj5aC;AvGk5aF;AACA;CACC,gBuGp5aC;AvGq5aF;;AAEA;CACC,2BuGv5aI;CvGw5aJ,6BuG12aK;CvG22aL,yBuG15agB;CvG25ahB,kBuG15amB;CvG25anB,uBuG35amB;CvG45anB,mCuGz2aG;CvG02aH,cuG75aG;AvG85aJ;AACA;CACC,sCuGj6a0B;AvGk6a3B;AACA;CACC,YuGp6aA;CvGq6aA,gBuGr6aC;AvGs6aF;;AAEA;CACC,kBuGx6amB;CvGy6anB,gBuGz6aI;CvG06aJ,auG16aG;AvG26aJ;;AAEA;CACC,OuG96aG;CvG+6aH,UuG/6aG;AvGg7aJ;;AAEA;CACC,yBuGp2aQ;CvGq2aR,UuGr7aA;CvGs7aA,yBuGr7amB;AvGs7apB;AACA;CACC;EACC,kBuGz7akB;CvG07anB;AACD;;AAEA;CACC,oDuG/7a8C;CvGg8a9C,qCuGv3aG;CvGw3aH,iDuGx3auB;CvGy3avB,kCuGp2a0D;CvGq2a1D,4CuGn2aS;AvGo2aV;;AAwJA;CACC;EACC,oBuG9lbe;CvG+lbhB;CACA;EACC,wBuGjmbe;CvGkmbhB;CACA;EACC,yBAAyB;CuGpmb1B;CACG;EAED,wBAAa;CvGqmbf;CACA;EACC,yBAAyB;CAC1B;CACA;EACC,wBuGv8aA;CvGw8aD;CACA;EACC,yBsBxibwB;CtByibzB;CACA;EACC,wBuG3mbmB;CvG4mbpB;CACA;EACC,yBuG3mbmB;CvG4mbpB;CACA;EACC,wBsBnpbM;CtBopbP;CACA;EACC,yBsBtpbM;CtBupbP;CACA;EACC,wBuGnmbQ;CvGombT;CACA;EACC,yBuG7lbI;CvG8lbL;CACA;EACC,wBuGtlbI;CvGulbL;CACA;EACC,yBuGvobG;CvGwobJ;CACA;EACC,wBuG1obkB;CvG2obnB;CACA;EACC,wBuG9obe;CvG+obhB;CACA;EACC,uBuGjpbe;CvGkpbhB;CACA;EACC,wBuGnpbkB;CvGopbnB;CACA;EACC,uBuGtpbkB;CvGupbnB;CACA;EACC,wBuGzpbkB;CvG0pbnB;CACA;EACC,uBsBvrbM;CtBwrbP;CACA;EACC,oBuGhlbO;CvGilbR;CACA;EACC,oBuG/kbmB;CvGglbpB;AACD;;AAEA;CACC,mBuG9kbuB;CvG+kbvB,iBuG9kbmB;CvG+kbnB,2BuG9kb8B;CvG+kb9B,kBuG3qbC;CvG4qbD,SuG3qbG;CvG4qbH,cuG5qbG;CvG6qbH,UuGhlbS;CvGilbT,mCuG/kbS;CvGglbT,gBuGhrbC;CvGirbD,yBuGhrbmB;CvGirbnB,4DuGpkbK;AvGqkbN;AACA;CACC;EACC,WuGrrbE;CvGsrbH;AACD;AACA;CACC;EACC,2BuG3rbA;CvG4rbD;AACD;AACA;CACC;EACC,yBsB1tbM;CtB2tbP;AACD;AACA;CACC;EACC,YuGrsbD;CvGssbA;AACD;AACA;CACC,euGxsbG;AvGysbJ;AACA;CACC;EACC,esBvubU;CtBwubX;AACD;AACA;CACC,kBuGjtbC;CvGktbD,YuGjtbG;CvGktbH,kBsB7ubW;AtB8ubZ;AACA;CACC;EACC,YuGvtbD;CvGwtbA;AACD;AACA;CuG1tbC,UAAA;CACG,SAAA;CvG4tbH,gBuG1tbc;AvG2tbf;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,iBAAiB;AAClB;AACA;CACC,euGpubG;CvGqubH,MuGjubG;CvGkubH,WuGvubA;CvGwubA,OuGvubG;AvGwubJ;AACA;CACC,auG1ubG;CvG2ubH,sBsBnqbwB;CtBoqbxB,auG7ubA;AvG8ubD;AACA;CACC,iBuGhvbgB;CvGivbhB,qBuGhvbmB;CvGivbnB,sBsB5wbO;CtB6wbP,kBuGnvbgB;CvGovbhB,MuGnvbG;CvGovbH,YsB/wbO;CtBgxbP,WuGtvbA;CvGuvbA,kBuGtvbmB;CvGuvbnB,qBuGntbK;CvGotbL,uBuGzvbgB;CvG0vbhB,cuGzvbG;AvG0vbJ;AACA;CACC,cuG5vbG;CvG6vbH,UuG7vbG;CvG8vbH,+BuG3sbG;CvG4sbH,iCuG3sbG;CvG4sbH,yBuGhwbmB;CvGiwbnB,cuGxsbK;CvGysbL,euGnwbA;CvGowbA,uBuGpwbgB;CvGqwbhB,oBuGrwbgB;CvGswbhB,iBuGtwbgB;CvGuwbhB,kBuGvwbgB;CvGwwbhB,wBuGxwbgB;AvGywbjB;AACA;CACC,WuG1wbG;AvG2wbJ;AACA;CACC;EACC,YuG9wbE;EvG+wbF,sBuG/wbkB;EvGgxblB,WuGhxbE;EvGixbF,iBuGjxbkB;EvGkxblB,UuGntbI;EvGotbJ,cuGpxbD;CvGqxbA;AACD;AACA;CACC,gBuGvxbI;CvGwxbJ,qBuGrsboB;CvGssbpB,mBsBpzbO;CtBqzbP,cuG3xbA;AvG4xbD;AACA;CACC,iBuGpsbmB;CvGqsbnB,kBuGpsbmB;CvGqsbnB,YsB1zbO;CtB2zbP,sBuGjybgB;CvGkybhB,sBuGjybmB;CvGkybnB,qBuGlybmB;AvGmybpB;AACA;CACC,6BuGtyb0B;CvGuyb1B,kBuGtybmB;CvGuybnB,qCuG5rb2B;CvG6rb3B,mCuGzyb0B;CvG0yb1B,mBuGzybmB;AvG0ybpB;AACA;CACC,asBv0bO;AtBw0bR;AACA;;CAEC,gEuGxsbE;CvGysbF,qBuGjzbmB;AvGkzbpB;AACA;;CAEC,oBsBh1bO;AtBi1bR;AACA;;CAEC,0CuGnrbQ;CvGorbR,2CuG3zb0B;AvG4zb3B;AACA;CACC,WuG9zbA;CvG+zbA,0BuG9zbI;CvG+zbJ,gBuG9qbiB;CvG+qbjB,gBuGj0bC;AvGk0bF;AACA;CACC,gBuGp0bC;AvGq0bF;AACA;CACC,UuGv0bA;CvGw0bA,YuGv0bG;AvGw0bJ;AACA;CACC,oBuG10bmB;AvG20bpB;AACA;CACC,0CuG5qbY;CvG6qbZ,2CuG3qbG;AvG4qbJ;AACA;CuGh1bI,0BAA4B;CvGk1b/B,WuGh1bE;AvGi1bH;AACA;CACC,kBAAkB;AACnB;AACA;CACC,gCuGnrbC;CvGorbD,kBuG11bgB;CvG21bhB,UuG11bG;CvG21bH,iBsBlxbiB;AtBmxblB;AACA;CACC,mBsBz3bW;CtB03bX,sBuGh2bgB;CvGi2bhB,kBuGh2bmB;CvGi2bnB,mBsBxxbiB;CtByxbjB,oBuGn2bgB;CvGs2bhB,oBuGt2bgB;CvGu2bhB;;;;;;;;;;;;;;;;;;;;;OuGv2bA;AvG63bD;AACA;CACC;EACC,oBuG/3bkB;CvGg4bnB;AACD;AACA;CACC;EACC,oBuGp4bkB;EvGq4blB,mBuGr4bkB;CvGs4bnB;AACD;AACA;;;CAGC,qBuG5zbQ;CvG6zbR,qBuG74bgB;AvG84bjB;AACA;CACC,kBsB16bO;CtB26bP,auGj5bA;CvGk5bA,gBuGj5bI;CvGk5bJ,auGl5bG;CvGm5bH,QuG1zbQ;CvG2zbR,auG1zbkB;CvG2zblB,sBuG1zboB;CvG2zbpB,2BuGv5bgB;AvGw5bjB;AACA;CACC;EACC,esBr7bU;CtBs7bX;AACD;AACA;CACC,kBuG/5bgB;CvGg6bhB,cuG/5bG;CvGg6bH,yBuGh6bmB;CvGi6bnB,gBuGj6bI;CvGk6bJ,csB77bW;CtB87bX,qBuGp6bgB;AvGq6bjB;AACA;CACC;EACC,yBuGv6bkB;CvGw6bnB;AACD;AACA;CACC,oBsBt8bO;CtBu8bP,sBuGzybmB;AvG0ybpB;AACA;CACC,qBuG1yboB;AvG2ybrB;AACA;CACC;;wCuGz0bG;CvG40bH,mCsBh9bO;CtBi9bP,oCuGv7b0B;CvGw7b1B,0CuGnybG;CvGoybH,yCuGlybI;CvGmybJ,euG17bA;CvG27bA,QuG17bG;CvG47bH,2CuG77b0B;AvG87b3B;AACA;;CAGC,2CuGjybG;CvGkybH,wBuGn8bgB;AvGo8bjB;AACA;CACC,0BAA0B;CuGt8b1B,cAAC;CACE,iBAAgB;CvGw8bnB,qBuGt8bc;CvGu8bd,0BuGv4bE;AvGw4bH;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,YuG78bG;CvG88bH,WuGn9bA;CvGo9bA,uBuGn9bmB;CvGo9bnB,mBsB/+bW;CtBg/bX,mBuGt9bgB;AvGu9bjB;AACA;CACC;EACC,mBuGz9bkB;CvG09bnB;AACD;AACA;CACC;EACC,gBuG/9be;EvGg+bf,euG/9bG;EvGg+bH,csB3/bU;CtB4/bX;AACD;;AAEA;CACC,cuGr+bG;AvGs+bJ;AACA;CACC;EACC,iBuGz+bkB;CvG0+bnB;AACD;;AAEA;CACC,iBuG/+bgB;CvGg/bhB,iBuGh/bgB;AvGi/bjB;;AAEA;CACC;EACC,sBuGp/bkB;EvGq/blB,gBuGr/bkB;CvGs/bnB;AACD;;AAEA;CACC;EACC,2BuGv8bE;CvGw8bH;CACA;EACC,wBsBzhcM;CtB0hcP;AACD;;AAEA;CACC;EACC,UuGj7bO;CvGk7bR;AACD;;AAEA;CACC,oBuGh7buB;AvGi7bxB;;AAEA;CACC;EACC,cuG9gcE;EvG+gcF,euGl7bkB;CvGm7bnB;AACD;;AAEA;CACC,euGrhcA;CvGshcA,gBuGrhcI;CvGshcJ,cuGthcG;AvGuhcJ;AACA;CACC;EACC,euG1hcG;CvG2hcJ;AACD;;AAEA;CACC,uBuGhicgB;AvGiicjB;;AAEA;CACC,mBuGpicgB;CvGqichB,cuGpicG;CvGqicH,oBuGh6boB;CvGi6bpB;;;IuGvicA;AvG2icD;AACA;CACC,cuG7icA;CvG8icA,mBuG7icmB;CvG8icnB,gBsBzkcW;CtB0kcX,qBuGhjcgB;CvGijchB,mBuGhjcmB;AvGijcpB;;AAEA;CACC;EACC,WuGtjcD;CvGujcA;AACD;;AAEA;CACC;EACC,aAAa;CuG5jcd;CACG;EAED,eAAY;CvG6jcd;CACA;EACC,OAAO;EACP,SAAS;CACV;AACD;;AAEA;CACC;EACC,6BuGzkc0B;CvG0kc3B;AACD;;AAEA;CACC,4BuGnkcoB;AvGokcrB;;AAEA;CACC,kBuGllcgB;AvGmlcjB;;AAEA;;CAEC,2BuG3jcS;AvG4jcV;;AAEA;;CAEC,2BuG3lcI;AvG4lcL;;AAEA;;CAEC,auGhmcG;CvGimcH,euGjmcG;CvGkmcH,sBuGlmcmB;CvGmmcnB,oBuG1icqB;CvG2icrB,WuGrmcA;AvGsmcD;AACA;;CAEC,WuGzmcA;AvG0mcD;;AAEA;;CAEC,wBuG7mcmB;AvG8mcpB;;AAEA;;CAEC,mBuGlncmB;CvGmncnB,WuGnncG;AvGoncJ;AACA;;CAEC,WsBlpcO;AtBmpcR;;AAEA;;CAEC,wBuG7ncgB;AvG8ncjB;;AAEA;;CAEC,mBuGticoB;CvGuicpB,WuGnocA;AvGoocD;AACA;;CAEC,WuGxicc;AvGyicf;;AAEA;;CAEC,qBuG3ocmB;AvG4ocpB;;AAEA;;CAEC,oBuGhpcmB;CvGipcnB,WsB5qcO;AtB6qcR;AACA;;CAEC,WuGtpcA;AvGupcD;;AAEA;;CAEC,qBuG1pcmB;AvG2pcpB;;AAEA;;CAEC,qBuGhqcgB;CvGiqchB,WuGhqcG;AvGiqcJ;AACA;;CAEC,WsB/rcO;AtBgscR;;AAEA;CACC,2BuGzqcgB;AvG0qcjB;;AAEA;CACC,auG5qcG;CvG6qcH,euG9gcG;CvG+gcH,sBuG/qcgB;CvGgrchB,iBuG/qcmB;CvGgrcnB,WsB3scO;AtB4scR;AACA;CuGlrcI,WAAA;AvGorcJ;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,qBuG5rcgB;CvG6rchB,WuG5rcG;AvG6rcJ;;AAEA;CACC,2BuGzrcoB;AvG0rcrB;;AAEA;CACC,oBuGrscgB;CvGsschB,WuGrscG;AvGsscJ;;AAEA;CACC,2BsBpucO;AtBqucR;;AAEA;CACC,oBuG9scgB;CvG+schB,WuG9scG;AvG+scJ;;AAEA;CACC,2BuGpqcK;AvGqqcN;;AAEA;CACC,qBuGttcmB;CvGutcnB,WuGvtcG;AvGwtcJ;;AAEA;CACC,gBuG5tcC;AvG6tcF;;AAEA;CACC,OuGhucA;CvGiucA,QuGhucG;AvGiucJ;AACA;CACC,sCuGjrcG;AvGkrcJ;AACA;CACC,qBuGtucmB;AvGuucpB;AACA;CACC,qBuGzucmB;AvG0ucpB;AACA;CACC,qBuG5ucmB;AvG6ucpB;AACA;CACC,qBuG/ucmB;AvGgvcpB;AACA;CACC,qBuGnvcgB;AvGovcjB;AACA;CACC,qBuG5pcuB;AvG6pcxB;AACA;CACC,qBuGzvcgB;AvG0vcjB;AACA;CACC,qBuG9pcqB;AvG+pctB;AACA;CACC,qBuG9vcmB;AvG+vcpB;AACA;CACC,gCuGzpcE;AvG0pcH;AACA;CACC,sBuGhpcoB;AvGipcrB;;AAEA;CACC,auGzwcA;CvG0wcA,euGzwcG;CvG0wcH,sBsBrycO;CtBsycP,oBuG5wcgB;CvG6wchB,WuG5wcG;CvG6wcH,WuG3ocO;AvG4ocR;AACA;CACC,WuGhxcG;CvGixcH,YsB5ycO;CtB6ycP,gBuGnxcA;CvGoxcA,kBuGnxcI;CvGoxcJ,sBuG5ocyB;CvG6oczB,gBuGtxcC;CvGuxcD,MuGtxcG;AvGuxcJ;AACA;CACC,yBuGzxcmB;AvG0xcpB;AACA;CACC,yBuG5xcmB;AvG6xcpB;AACA;CACC,yBuG/xcmB;AvGgycpB;AACA;CACC,yBuGlycmB;AvGmycpB;AACA;CACC,yBuGrycmB;AvGsycpB;AACA;CuGxycC,yBAAC;AvG0ycF;AACA;CACC,yBuGzucE;AvG0ucH;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBuGlzcgB;AvGmzcjB;AACA;CACC,yBuGrzcgB;AvGszcjB;AACA;CACC,WuGxzcA;AvGyzcD;;AAEA;CACC,qBuG3zcmB;CvG4zcnB,WuG/ycG;AvGgzcJ;;AAEA;CACC,qBuGj0cgB;CvGk0chB,euGj0cG;CvGk0cH,4BuGvycS;AvGwycV;AACA;CACC;EACC,euGv0cA;CvGw0cD;AACD;;AAEA;CACC,iBuG30cmB;CvG40cnB,WuG50cG;AvG60cJ;AACA;CACC;EACC,WuGj1cD;CvGk1cA;AACD;;AAEA;CACC,iBuGt1cgB;CvGu1chB,WuGt1cG;AvGu1cJ;AACA;CACC;EACC,WuG11cE;CvG21cH;AACD;;AAEA;CACC,auG/1cG;CvGg2cH,esB33cO;CtB43cP,sBuGl2cgB;AvGm2cjB;;AAEA;CACC,qBuGr2cmB;CvGs2cnB,WuGnxcQ;AvGoxcT;;AAEA;CACC,qBuG12cmB;CvG22cnB,WuGlxcQ;AvGmxcT;;AAEA;CACC,oBuG/2cmB;CvGg3cnB,WuGh3cG;AvGi3cJ;;AAEA;CACC,qBuGp3cmB;CvGq3cnB,WsBh5cO;AtBi5cR;;AAEA;CACC,kBuGz3cmB;CvG03cnB,oBuGtwcoB;CvGuwcpB,wBuG53cgB;CvG63chB,uBuG53cmB;CvG63cnB,wCuGlwc6B;CvGmwc7B,wCuG/3c2B;CvGg4c3B,wCuGtxcG;CvGuxcH,wCuGnwc8B;CvGowc9B,wCuGl4c2B;CvGm4c3B,wCuGzxcG;CvG0xcH,wCsB95cW;CtB+5cX,wCuG1vcO;CvG2vcP,wCuGt4c2B;CvGu4c3B,2CuG7xcG;CvG8xcH,2CuGjwcQ;CvGkwcR,2CuGz4c2B;CvG04c3B,2CuGhycG;CvGiycH,2CuGjwcQ;CvGkwcR,2CuG54c2B;CvG64c3B,2CuGnycG;CvGoycH,2CuG5vcqC;CvG6vcrC,2CuG/4c2B;CvGg5c3B,uCuG3vcG;CvG4vcH,wCuG1vcI;CvG2vcJ,uCuGl5c2B;CvGm5c3B,wCuG3vcG;CvG4vcH,gBsB96cW;AtB+6cZ;;AAEA;;;;;;;;;CuGt5cI;AvGg6cJ;CACC,4BuG/1cE;AvGg2cH;AACA;CACC,mBAAmB;CACnB,wBAAwB;CACxB,gBuGjwcC;CvGkwcD,uBuGx6cgB;CvG26chB,oBuG36cgB;CvG46chB,mBuG36cmB;CvG46cnB;;;;;;;;;;;QuG56cG;AvGw7cJ;AACA;CACC,gBuG17cI;CvG27cJ,6BuGv5cK;CvGw5cL,qBuG77cgB;AvG87cjB;AACA;CACC,euGh8cA;AvGi8cD;AACA;CACC;EACC,auGn8cE;CvGo8cH;AACD;AACA;CACC,oBuGx8cgB;AvGy8cjB;AACA;CACC,qBuG38cgB;CvG48chB,gBuG58cC;AvG68cF;AACA;CACC,auG98cG;AvG+8cJ;;AAEA;CACC,auGl9cG;CvGm9cH,YuGn9cG;AvGo9cJ;AACA;CACC,esBj/cO;CtBk/cP,gBuGx9cC;CvGy9cD,uBuGx9cmB;CvGy9cnB;EACC,UuG39cD;CvG49cA;AACD;AACA;CACC,UuG/9cA;AvGg+cD;AACA;CACC,cuGx4ckB;AvGy4cnB;AACA;CACC,yBuGr+cgB;CvGs+chB,UuGr+cG;AvGs+cJ;;AAEA;;CAEC,auG1+cG;AvG2+cJ;;AAEA;CACC,oBuG9+cmB;CvG++cnB,WuG/+cG;AvGg/cJ;AACA;CACC,oBuGl/cmB;CvGm/cnB,qBsB9gdO;AtB+gdR;AACA;CACC,wBsBjhdO;CtBkhdP,YuGx/cA;CvGy/cA,iBuGx/cmB;AvGy/cpB;AACA;CACC,oBuG5/cgB;AvG6/cjB;;AAEA;CACC,auG//cG;CvGggdH,iBsB3hdO;CtB4hdP,kBuGlgdgB;AvGmgdjB;AACA;CACC,auGrgdA;AvGsgdD;AACA;;CAEC,4BuGxgdI;AvGygdL;AACA;CACC,UuG3gdG;AvG4gdJ;AACA;CACC,kBuG9gdmB;AvG+gdpB;AACA;CACC,wBuGjhdmB;AvGkhdpB;AACA;CuGphdC,gBAAgB;AvGshdjB;AACA;CACC,kBuGr9cE;AvGs9cH;AACA;CACC,uBAAuB;CACvB,kBAAkB;AACnB;AACA;CACC,iBuG9hdmB;CvG+hdnB,kBsBh9ckB;CtBi9clB,euGjidA;AvGkidD;AACA;CACC,auGpidA;AvGqidD;AACA;CACC,SuGvidA;AvGwidD;AACA;CACC,kBuG1idgB;CvG2idhB,YuG1idG;CvG2idH,MuG3hdG;CvG4hdH,YuG7idA;CvG8idA,auG7idG;CvG8idH,asBzkdO;CtB0kdP,uBuGhjdgB;CvGijdhB,uBuGhjdmB;CvGijdnB,wDuG7gdK;CvG8gdL,uBuGnjdgB;CvGojdhB,cuGnjdG;CvGojdH,SuGxgdU;CvGygdV,gBuGtjdC;AvGujdF;AACA;CACC,UuGxjdG;CvGyjdH,WuGzjdG;AvG0jdJ;AACA;CACC,gBuG7jdC;CvG8jdD,MuG9jdA;AvG+jdD;AACA;CACC,auGjkdA;AvGkkdD;AACA;CACC,cuGnkdG;CvGokdH,YuGpkdG;CvGqkdH,iBuGrkdmB;AvGskdpB;AACA;CACC,gCuGphdG;CvGqhdH,mBuGzkdmB;AvG0kdpB;AACA;CACC,yBsBvmdO;CtBwmdP,kBuG9kdgB;CvG+kdhB,qBuG9kdmB;AvG+kdpB;AACA;CACC,auGjldG;AvGkldJ;AACA;CACC,0BuGrldgB;CvGsldhB,uBuGrldmB;AvGsldpB;AACA;CACC,WuG9/cQ;CvG+/cR,UsBpndO;AtBqndR;AACA;CACC,SuG5ldG;CvG6ldH,SuGhgdS;AvGigdV;AACA;CACC,uBuGhmdmB;CvGimdnB,0BsB5ndO;CtB6ndP,WuGnmdA;AvGomdD;AACA;CACC,0BuGrmdmB;AvGsmdpB;AACA;CACC,WuGxmdG;CvGymdH,yBsBpodO;AtBqodR;AACA;CACC,UuG/+cY;CvGg/cZ,YuG9mdA;AvG+mdD;AACA;CACC,uBuG7+cmB;CvG8+cnB,mBuGlndgB;AvGmndjB;AACA;CACC,0CuGrnd2B;CvGsnd3B,oBuGrndmB;AvGsndpB;AACA;CACC,mBuGxndmB;AvGyndpB;AACA;CACC,0CuGv+cG;CvGw+cH,oBuGt+cI;AvGu+cL;AACA;;CAEC,auGjodA;AvGkodD;AACA;CACC,auGpodA;AvGqodD;AACA;CACC,auGvodA;AvGwodD;;AAEA;CuG1odC,mBAAgB;AvG4odjB;AACA;CACC,oBuG3kdE;CvG4kdF,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,oBuGppdgB;AvGqpdjB;AACA;CACC,euGvpdA;CvGwpdA,qBuGvpdmB;AvGwpdpB;;AAEA;CACC,sBsB3kdyB;AtB4kd1B;;AAEA;;;;;;;;;CASC;AACD;CACC,kBuGzqdmB;CvG0qdnB,oBuG5ndK;CvG6ndL,wBuG5qdgB;CvG6qdhB,uBuG5qdmB;CvG6qdnB,wCuG3ndG;CvG4ndH,wCuG3ndG;CvG4ndH,wCuG3ndG;CvG4ndH,wCuG3ndG;CvG4ndH,wCuGvndK;CvGwndL,wCuGnrd2B;CvGord3B,wCuGprd2B;CvGqrd3B,wCuGrrd2B;CvGsrd3B,wCuGtrd2B;CvGurd3B,2CuGvrd2B;CvGwrd3B,2CuGxrd2B;CvGyrd3B,2CuGvodG;CvGwodH,2CuGxodG;CvGyodH,2CuGxodG;CvGyodH,2CuGzodG;CvG0odH,2CuGzodG;CvG0odH,2CuG1odG;CvG2odH,2CuG1odG;CvG2odH,uCuG3odG;CvG4odH,wCuG3odG;CvG4odH,uCuG5odG;CvG6odH,wCsB7tdW;CtB8tdX,gBuGpsdC;AvGqsdF;;AAEA;CACC;EACC,cuGrndmB;CvGsndpB;CACA;EACC,WuG3sdE;CvG4sdH;CACA;EACC,wBuGpndkB;CvGqndnB;CACA;EACC,oCuGzodE;CvG0odH;CACA;EACC,asB/udM;CtBgvdP;CACA;EACC,asBlvdM;CtBmvdP;CACA;EACC,sBuG1tdkB;EvG2tdlB,auG3tdE;EvG4tdF,mBuGxmdmB;EvGymdnB,WuG9tdD;EvG+tdC,cuG9tdE;CvG+tdH;CACA;EACC,uBuGjudkB;CvGkudnB;CACA;EACC,cuGpudE;EvGqudF,iBsBhwdM;EtBiwdN,kBuGnmdkB;EvGomdlB,UuGxudD;EvGyudC,SuGxudE;CvGyudH;CACA;;EAEC,auGpmdO;CvGqmdR;CACA;EACC,auG9ldI;CvG+ldL;CACA;;EAEC,4BuGpvd0B;CvGqvd3B;CACA;EACC,kBuGvvde;CvGwvdhB;CACA;EACC,auG1vdD;CvG2vdA;CACA;EACC,gBuG7vde;EvG8vdf,mBuG7vdkB;CvG8vdnB;CACA;EuGrldA,mBAAe;CACZ;CvGuldH;EACC,WuGzldD;EvG0ldC,YuGzldE;CvG0ldH;CACA;EACC,mBuG5ldiB;EvG6ldjB,4BuGrldG;CvGsldJ;CACA;EACC,asBtydU;CtBuydX;CACA;EACC,0BuGhldI;CvGildL;CACA;EACC,euGlgdG;CvGmgdJ;CACA;EACC,YAAY;EACZ,WuGp/cG;EvGq/cH,cuG5mdD;EvG6mdC,SuG5mdE;CvG6mdH;CACA;EACC,kBuGhndA;EvGindA,auGhndE;EvGindF,csBvzdM;EtBwzdN,gBuGnndA;EvGondA,auGnndE;EvGondF,asB1zdM;EtB2zdN,uBuGtndc;EvGundd,wDuG/ldG;EvGgmdH,uBuGvndiB;EvGwndjB,uBuG5jdQ;EvG6jdR,gBuG1ndA;CvG2ndD;CACA;EACC,UuG5ndE;EvG6ndF,cuG7ndE;EvG8ndF,wDuGvmdG;CvGwmdJ;CACA;EACC,yBuGjodiB;CvGkodlB;CACA;EACC,0BuGpodG;EvGqodH;qBuGtodc;EvGwodd,kBuGvodiB;EvGwodjB,cuG9hdI;EvG+hdJ,oBuG1odc;EvG2odd,yBuG1odiB;EvG2odjB,4BuG7hdsD;EvG8hdtD,wBuG7odc;EvG8odd,uBuG7odiB;CvG8odlB;CACA;EACC,UuGjpdD;EvGkpdC,iBuGjpdiB;EvGkpdjB,gBuGlhdE;CvGmhdH;CuGppdA;EACG,aAAe;CvGspdlB;CACA;;EAEC,auGrpdG;CvGspdJ;CACA;EACC,UuGrpdU;CvGspdX;CACA;EACC,kBuGlpdK;CvGmpdN;CACA;EACC,wBuG/odI;CvGgpdL;CACA;EACC,gBuGjkdG;CvGkkdJ;CACA;EACC,oBAAoB;CACrB;CACA;EACC,kBuG3qdiB;CvG4qdlB;CACA;EACC,kBuG/qdA;CvGgrdD;CACA;EACC,cuGlrdD;CvGmrdA;CACA;EACC,kBuGrrdc;CvGsrdf;CACA;EACC,WsB73dM;EtB83dN,kBuGzrdc;EvG0rdd,MuG1rdD;EvG2rdC,QuG3rdD;EvG4rdC,0BuG3rdG;EvG4rdH,UuG5rdE;EvG6rdF,SuG7rdE;EvG8rdF,asBp4dM;EtBu4dN,oBuGjndY;CvGkndb;CACA;EACC,SuGrmdY;EvGsmdZ,oBuGtsdc;CvGusdf;CACA;EACC,SuGzsdD;EvG0sdC,euGzsdE;CvG0sdH;AACD;AACA;CACC;EACC,SuG5ldI;EvG6ldJ,oBuGhtdc;CvGitdf;AACD;;AAEA;CuGntdI;EAEA,iBAAU;CvGotdb;CACA;EACC,auGptdG;CvGqtdJ;CACA;EACC,mBuGntdG;EvGotdH,YuG7tdD;EvG8tdC,WuG7tdE;EvG8tdF,csBp6dU;EtBq6dV,SuGhudD;EvGiudC,SuGhudE;CvGiudH;CACA;EACC,auGnudE;CvGoudH;CACA;EACC,UAAU;EACV,YAAY;CACb;CACA;EACC,YuG1udE;CvG2udH;CACA;EACC,0BuG9udc;EvG+udd,WuG9udE;EvG+udF,uBuGhtdQ;CvGitdT;CACA;EACC,WsBx7dM;CtBy7dP;CACA;EACC,UuGrvdE;EvGsvdF,YsB57dM;CtB67dP;CACA;EACC,0BuG1vdA;EvG2vdA,WuG1vdE;EvG2vdF,oDuGpudG;EvGqudH,uBuG5vdiB;EvG6vdjB,esBn8dM;CtBo8dP;CACA;EACC,WuGhrdY;CvGirdb;CACA;EACC,kBuGnqdO;EvGoqdP,wBuGrwdc;CvGswdf;CACA;EACC,uBuGxwdc;EvGywdd,iBuGxwdiB;EvGywdjB,SuG3pdI;EvG4pdJ,cuG3wdD;EvG4wdC,auG3wdE;EvG4wdF,YsBl9dM;EtBm9dN,uBuG3pdiB;EvG4pdjB,SuG/wdD;EvGgxdC,mBuG/wdiB;EvGgxdjB,MuGhpdE;CvGipdH;CuGlxdA;EACG,wDAA2B;CvGoxd9B;CACA;EACC,UuGtxdE;EvGuxdF,cuGnxde;CvGoxdhB;CACA;EACC,0CuGlxdG;CvGmxdJ;CACA;EACC,asBn+dU;CtBo+dX;CACA;EACC,csBt+dU;CtBu+dX;CACA;EACC,0CuG/rdG;EvGgsdH,oBAAoB;CACrB;CACA;EACC,auGjrdG;CvGkrdJ;CACA;EACC,auGjxdK;CvGkxdN;CACA;EACC,auG7ydE;CvG8ydH;CACA;EACC,iBuGhzdiB;CvGizdlB;CACA;EACC,UuGnzdE;CvGozdH;CACA;EACC,iBuGvzdc;CvGwzdf;CACA;EACC,UuGzzdE;EvG0zdF,SuG1zdE;CvG2zdH;CACA;EACC,iBuG9zdc;CvG+zdf;CACA;EACC,cuGj0dD;CvGk0dA;CACA;EACC,euGp0dD;EvGq0dC,auGp0dE;CvGq0dH;CACA;EACC,sCuGjzdE;CvGkzdH;AACD;;AAEA;CACC;EACC,uBuG90dc;CvG+0df;CACA;EACC,2CAA2C;CuGj1d5C;AvGm1dD;;AAEA;CACC,kBuGr1dkB;CvGs1dlB,oBuGl1diB;CvGm1djB,wBuGx1de;CvGy1df,uBuGx1dkB;CvGy1dlB,wCuGj1dI;CvGk1dJ,wCuG31dyB;CvG41dzB,wCuGj1dK;CvGk1dL,wCuG/0dM;CvGg1dN,wCuG91dyB;CvG+1dzB,wCuG90dc;CvG+0dd,wCuG50dK;CvG60dL,wCuGj2dyB;CvGk2dzB,wCuG30dgB;CvG40dhB,2CuG9vdI;CvG+vdJ,2CAA2C;CAC3C,2CAA2C;CAC3C,2CAA2C;CAC3C,2CuGhvdI;CvGivdJ,2CuGx2dyB;CvGy2dzB,2CuGj1dI;CvGk1dJ,2CuGh1d6D;CvGi1d7D,2CuGj0dM;CvGk0dN,uCuG52dyB;CvG62dzB,wCuGt1dG;CvGu1dH,uCuG90dS;CvG+0dT,wCuG/2dyB;CvGg3dzB,gBuG/2dG;AvGg3dJ;;AAEA;CACC;EACC,sBuGxzdQ;CvGyzdT;CACA;EACC,yBuGx3dc;CvGy3df;CACA;EACC,auG13dE;CvG23dH;CACA;EACC,gBuG73dG;EvG83dH,YuG9ydY;EvG+ydZ,MuGh4dD;CvGi4dA;CACA;EACC,auGn4dD;CvGo4dA;CACA;EACC,oBuGt4dc;EvGu4dd,qBuGt4diB;CvGu4dlB;CACA;EACC,WuGz4dE;EvG04dF,YsBhleM;EtBileN,euGzxdI;EvG0xdJ,cuG74dA;CvG84dD;CACA;EACC,WAAW;EuGh5dZ,kBAAe;EACZ,YAAC;EAED,iBAAU;EvGi5dZ,MuGp5dD;EvGq5dC,UuGp5dE;CvGq5dH;CACA;EACC,4BuGj5dE;CvGk5dH;CACA;EACC,4BuGj5dE;CvGk5dH;CACA;EACC,4BuG74dE;CvG84dH;CACA;EACC,wBuGh6dG;CvGi6dJ;CACA;EACC,uBAAuB;EACvB,gBAAgB;EAChB,auG/ydG;CvGgzdJ;CACA;EACC,mBuG/4dK;CvGg5dN;CACA;EACC,iBuG36dE;EvG46dF,gBsBlneU;CtBmneX;CACA;EACC,mBuGh4dO;EvGi4dP,4BuGj7dwB;CvGk7dzB;CACA;EACC,asBzneM;CtB0neP;CACA;EACC,auGv7dD;CvGw7dA;CACA;;EAEC,asBhoeM;CtBioeP;CACA;EACC,mBuG72dY;EvG82dZ,yBuG/7dc;EvGg8dd,gBuG/7dG;EvGg8dH,oBuGh2dO;EvGi2dP,euGl8dD;CvGm8dA;CACA;EACC,auGr8dD;CvGs8dA;CACA;EACC,cuGx8dD;CvGy8dA;CACA;EACC,wDuGv1dI;CvGw1dL;CACA;EACC,sBsBnpeM;EtBopeN,kBAAkB;CuG/8dnB;CACG;EAEA,cAAU;CvGg9db;CACA;EACC,kBuGh9dgB;EvGi9dhB,uBuGt9dc;EvGu9dd,SuGt9dE;EvGu9dF,WuGh9dW;EvGi9dX,mBuGz9dc;EvG09dd,YuGz9dE;EvG09dF,UsBhqeM;EtBiqeN,WuG59dD;EvG69dC,iBuG59diB;EvG69djB,asBnqeU;EtBoqeV,wDuGx8dE;EvGy8dF,SuG/9dE;EvGg+dF,gBuG53dG;EvG63dH,uBAAuB;CACxB;CACA;EACC,wDuG92dG;EvG+2dH,mBuGt+dc;CvGu+df;CACA;EACC,UuG98dK;CvG+8dN;CACA;EACC,gCuG58dQ;EvG68dR,sCuG7+dwB;EvG8+dxB,oBuG7+diB;CvG8+dlB;CACA;EACC,sCuG19dE;EvG29dF,iBuGj/diB;CvGk/dlB;CACA;EACC,qBuGr/dc;EvGs/dd,qBuGt/dc;CvGu/df;CACA;EACC,auGx/dE;EvGy/dF,csB/reM;CtBgseP;CACA;EACC,UuG56dY;EvG66dZ,euG9/dD;CvG+/dA;CACA;EACC,UuGjgeD;EvGkgeC,MuGjgeE;EvGkgeF,wDuGt5dI;CvGu5dL;CACA;EACC,UuGv5dI;EvGw5dJ,WuGvgeD;CvGwgeA;CACA;EACC,cuGv5dI;EvGw5dJ,kBuG3gec;CvG4gef;CACA;EACC,uBAAuB;CuG9gexB;CACG;EAEA,uCAiIF;CvG84dD;CACA;EACC,yBuG/geqD;CvGghetD;CACA;;EAEC,UuGxheD;CvGyheA;CACA;;EAEC,0BuG3geE;EvG4geF,WsBlueM;EtBmueN,uBuG9hec;CvG+hef;CACA;;EAEC,WAAW;EACX,uBAAuB;EACvB,gBuG76dG;CvG86dJ;CACA;EACC,euG7geK;CvG8geN;CACA;EACC,sCuGnheE;CvGoheH;CACA;EACC,6CuGrheG;EvGsheH,yBuG9/dO;CvG+/dR;CACA;EACC,6CuGzheG;CvG0heJ;CACA;EACC,wBuGpjec;EvGqjed,YuGrjeD;EvGsjeC,WuGrjeE;EvGsjeF,cuGtjeE;CvGujeH;CACA;EACC,wBuG1jec;CvG2jef;CACA;EACC,auG7jeD;CvG8jeA;CACA;EACC,cuGhkeD;EvGikeC,2CuGv9dG;CvGw9dJ;CACA;EACC,yBuGnkeiB;CvGokelB;CACA;EACC,wBuGtkeiB;EvGukejB,sBuGt9dgB;EvGu9dhB,euGt9dI;EvGu9dJ,uBuG1kec;EvG2ked,kEuG58diB;EvG68djB,uBsBjxeM;CtBkxeP;CuG7keA;EACG,gEAA2B;EAE3B,mBAAW;CvG8ked;CACA;EACC,yBuG9keqD;EvG+kerD,kBuGplec;EvGqled,qBuGpleiB;EvGqlejB,uBuG7keG;EvG8keH,iBuGvlec;CvGwlef;CACA;EACC,UuG1leD;EvG2leC,QuG1leE;CvG2leH;CACA;EACC,sBuG7leiB;EvG8lejB,sBuG1/dG;CvG2/dJ;CACA;EACC,OAAO;CACR;CACA;EACC,qBuGpmeiB;CvGqmelB;CACA;EACC,UuGxmeD;EvGymeC,QuGxmeE;CvGymeH;CACA;EACC,WuG3meE;CvG4meH;CACA;EACC,UuG9meE;CvG+meH;CACA;EACC,UuGlneD;EvGmneC,WuGnneD;CvGoneA;CACA;EACC,OuGrneE;EvGsneF,WuGtneE;CvGuneH;CACA;EACC,uBuGzneiB;EvG0nejB,qBuG1ieY;CvG2ieb;CACA;;;EAGC,auG/neE;CvGgoeH;CACA;EACC,cuGloeE;CvGmoeH;CACA;;;;;;EAMC,mBuG1gekB;CvG2genB;AACD;AACA;CACC;;;;;;EAMC,mBuG5oeG;CvG6oeJ;AACD;;AAEA;CACC;EACC,yBuGvoeI;EvGwoeJ,0BuG5peA;EvG6peA,uBuG5peiB;CvG6pelB;CACA;EACC,cAAc;EACd,cAAc;EACd,euG3ieG;CvG4ieJ;CACA;EACC,6BuG3oe4D;EvG4oe5D,qBuG3oemB;CvG4oepB;CACA;EACC,4BuGzoeQ;CvG0oeT;CACA;EACC,6BuG5neO;EvG6neP,kCuG7qeyB;CvG8qe1B;CACA;EACC,SuGpneY;CvGqneb;CACA;EACC,YuGnreD;CvGoreA;CACA;EACC,gCuG/peE;CvGgqeH;CACA;EACC,iBuGxreiB;CvGyrelB;CACA;EACC;;;;;;;IAOE;CACH;CACA;EACC,esB34eU;CtB44eX;CACA;EACC,kBuGxseiB;CvGyselB;AACD;;AAEA;CACC;EACC,kBuG/sec;CvGgtef;AACD;;AAEA;CACC;EACC,kBuGrtec;CvGstef;CACA;EACC,cuGxteA;EvGyteA,qBuGxteiB;EvGytejB,csB/5eU;CtBg6eX;CACA;EACC,sBuGxneG;EvGyneH,uBAAuB;EACvB,aAAa;CACd;CACA;EACC,auGlueD;CvGmueA;CACA;EACC,gBuG1seiB;CvG2selB;CACA;EACC,esB76eM;EtB86eN,cuGzueD;EvG0ueC,2BuGzueG;CvG0ueJ;CACA;EACC,+BuGtteE;EvGuteF,wBuG7ueiB;EvG8uejB,mBuGlreQ;CvGmreT;CACA;EACC,auGlveD;CvGmveA;CACA;EACC,gBuGpveG;CvGqveJ;CACA;EACC,euGvveE;EvGwveF,cuGxqeY;EvGyqeZ,2BuG1veA;CvG2veD;CACA;EACC,+BuG7veyB;CvG8ve1B;CACA;EACC,WuGhweD;CvGiweA;CACA;EACC,0CuGnweyB;CvGowe1B;CACA;EACC,auGnpeI;CvGopeL;CACA;EACC,qBsB98eM;CtB+8eP;CuG1weA;EACG,WAAA;EAEA,SAAA;EvG2weF,YuG9weD;EvG+weC,cuG9weG;EvG+weH,UuG3weG;EvG4weH,uBuGjxec;EvGkxed,gBuGjxeiB;EvGkxejB,gBuG1weG;CvG2weJ;CACA;EACC,gBuGxweK;CvGyweN;CACA;EACC,csB99eU;EtB+9eV,oBuG1xec;EvG2xed,qBuG1xeiB;CvG2xelB;CACA;EACC,sBAAsB;EACtB,eAAe;EACf,gBuGzqeG;CvG0qeJ;CACA;EACC,WuGzweK;EvG0weL,qBuGzwemB;CvG0wepB;CACA;EACC,WuGxweY;CvGyweb;CACA;EACC,asB/+eM;CtBg/eP;CACA;EACC,oBuG5yeiB;CvG6yelB;CACA;EACC,euGhzeD;EvGizeC,oBuGjzec;EvGkzed,OuGjzeE;EvGkzeF,MuGlzeE;EvGmzeF,gBuGnzeG;EvGozeH,WuG9uec;CvG+uef;CACA;EACC,oBuGvueY;CvGwueb;CACA;EACC,kBuG1teO;CvG2teR;AACD;;AAEA;CACC;EACC,euGlteI;CvGmteL;CACA;;EAEC,euGlteI;CvGmteL;CACA;EACC,wBsB7gfU;CtB8gfX;CuGz0eA;EACG,cAAe;EAEf,kBAAU;EvG00eZ,SuG70eD;CvG80eA;CACA;EACC,wBuGh1ec;CvGi1ef;CACA;EACC,yBuGn1eA;EvGo1eA,kBuGn1eiB;EvGo1ejB,asB1hfU;CtB2hfX;CACA;;EAEC,6BuGz1eyB;CvG01e1B;CACA;EACC,gBAAgB;CACjB;CACA;EACC,yBuGxueG;CvGyueJ;CACA;EACC,auGx0eK;CvGy0eN;CACA;EACC,kBuGp2eG;CvGq2eJ;CACA;EACC,sBuGv2eiB;CvGw2elB;CACA;EACC,oBuG12eiB;EvG22ejB,qBuG32eiB;EvG42ejB,csBljfU;EtBmjfV,iBuG92ec;EvG+2ed,kBuG/2ec;CvGg3ef;CACA;EAGC,oBuG5yeQ;CvG6yeT;CACA;EACC,auGtyeY;CvGuyeb;CACA;EACC,gBsB9jfU;EtB+jfV,oBuG33ec;CvG43ef;CACA;;EAEC,auG93eE;CvG+3eH;CACA;EACC,kBuGj4eiB;EvGk4ejB,mBuGjxegB;CvGkxejB;CACA;EACC,UuGr4eE;CvGs4eH;CACA;EuGx4eA,kBAAe;CACZ;CvG04eH;EACC,wBuG54ec;CvG64ef;CACA;EACC,cuG/4eA;CvGg5eD;CACA;;EAEC,auGl5eE;CvGm5eH;CACA;EACC,qBuGr5eiB;EvGs5ejB,qBuGn4eI;CvGo4eL;CACA;EACC,auGrzeG;CvGszeJ;CACA;EACC,aAAa;CACd;CACA;EACC,euG/5eE;EvGg6eF,6BuGv4e4D;CvGw4e7D;CACA;EACC,oBuGn6eiB;CvGo6elB;CACA;EACC,WuGt6eE;CvGu6eH;CACA;EACC,0BuGz6eiB;EvG06ejB,WuG16eE;CvG26eH;CACA;EACC,0BuG96ec;EvG+6ed,WuG/6eD;CvGg7eA;AACD;;AAEA;CACC,euGp7eA;AvGq7eD;;AAEA;CACC,cuGv7eG;AvGw7eJ;;AAEA;CACC,gBuGj1eK;AvGk1eN;;AAEA;CACC,euGh8eA;AvGi8eD;;AAEA;CACC,euGp8eC;AvGq8eF;AACA;CACC,cAAc;CwGvpff,SAAQ;CxGypfP,+BwGxpf4B;CxGypf5B,mBwGxpfgB;AxGypfjB;AACA;CACC,+BwGzmfI;AxG0mfL;AACA;CACC,awG1pfmB;AxG2pfpB;AACA;CACC,2BwG1pfoC;AxG2pfrC;AACA;CACC,sBwGvpfa;AxGwpfd;AACA;CACC,cwGxqfG;CxGyqfH,qBwGhpfE;CxGipfF,WwG1qfG;CxG2qfH,sBwG9ofG;CxG+ofH,kBwG5qfI;CxG6qfJ,gBwG5ofW;CxG6ofX,iBwG9qfG;CxG+qfH,yCwGrofE;AxGsofH;AACA;CACC,UwGlofe;CxGmoff,cAAc;CGpnfP,uBAAwB;AHsnfhC;AACA;CACC,uBAAuB;CGhofhB,qBAAkB;AHkof1B;;AAEA;CwGpnfA;EAEQ,sBAAqB;CxGqnf5B;CwGvnfD;EAKE,aAAa;CxGqnfd;CwGjnfD;EACA,8BAA0B;CxGmnfzB;CACA;EwG9mfD,QAAA;EAEQ,eAAO;CxG+mfd;CwG5mfD;EAEE,cAAM;CxG6mfP;CwG/mfD;EAKE,cAAM;ExG6mfN,iCAAiC;CwGlnfnC;CxGonfC;EACC,UAAU;EwGzmfZ,oBAAa;CxG2mfZ;CACA;EwG5mfD,sBAAC;EAKC,uBAAM;CxG0mfP;CwG/mfD;EAQE,cAAM;CxG0mfP;CwGlnfD;EAYG,aAAa;CxGymff;CwGpmfD;EAEE,aAAM;CxGqmfP;CwGvmfD;EAKE,kBAAM;CxGqmfP;CwG1mfD;EAQE,mBAAM;ExGqmfN,uBAAuB;CwG7mfzB;CxG+mfC;EACC,kBAAkB;EwG/lfpB,UAAC;EAEC,WAAM;ExGgmfN,mBAAmB;CwGlmfrB;CxGomfC;EACC,uBAAuB;EwGrmfzB,eAAa;CxGumfZ;CACA;EwG3lfD,iBAAa;EAEV,kBAAe;ExG4lfhB,cAAc;CwGzlfhB;AxG2lfA;AACA;CwGtlfA;EAEE,YAAO;CxGulfR;AACD;;AAEA;CACC;EwG7lfD,UAAC;EASE,iBAAe;CxGulfjB;CwGjlfD;EAEQ,aAAU;CxGklfjB;CACA;EwGrlfD,QAAA;CxGulfC;CACA;EACC,yBAAyB;EwGzlf3B,0BAWI;EACI,sBACH;CxG+kfJ;CwG5kfD;EAEQ,eAAc;CxG6kfrB;CACA;EwGzkfD,aAAa;EAEL,8BACH;ExGykfH,mBAAmB;EwG5kfrB,uBAAwB;EAOZ,mBAAkB;CxGwkf7B;CwGnkfD;;EAGQ,QAAA;ExGokfN,eAAe;EwGvkfjB,aAAC;EAOC,gBAAgB;ExGmkfhB,YAAY;EwG/jfd,WAAA;EACC,cAAA;CxGikfA;CACA;;EAEC,eAAe;EACf,gBwGhkfG;CxGikfJ;CACA;;EAEC,0BAA0B;EAC1B,WwGrjfD;CxGsjfA;CACA;;EAEC,WwG5jfC;CxG6jfF;CwGzjfD;EACA,cAAgB;EAChB,eAAA;EAEE,gBAAa;CxG0jfd;CwGvjfD;EAEE,gBACA;ExGujfA,eAAe;CwG1jfjB;CxG4jfC;EACC,sCAAsC;CwG7jfxC;CxG+jfC;EACC,UAAU;EwGhjfZ,cAAgB;CxGkjff;CACA;EACC,aAAa;EACb,WAAW;CACZ;CACA;EwGhjfA,kBAAA;ExGkjfC,oBAAoB;CACrB;CACA;EACC,sBwGjjfG;CxGkjfJ;CACA;EACC,aAAa;EACb,WAAW;CACZ;CACA;EACC,WwG7ifQ;ExG8ifR,gBwG7ifc;CxG8iff;CwG1ifD;EAIG,WAAW;ExGyifZ,UAAU;CwGrifZ;CACA;EACA,WAAA;EACA,UAAA;CxGuifC;CACA;;EwGjifD,aAAC;CxGoifA;CACA;EwG5hfD,aAAC;CxG8hfA;CACA;EyGn2fD,cAAQ;CzGq2fP;CACA;EACC,oByGt2fkB;CzGu2fnB;CACA;EACC,cyGn2fW;CzGo2fZ;AACD;AACA;CACC;EACC,WyGh2fC;CzGi2fF;AACD;;AAEA;CACC;EACC,cyG11fqB;CzG21ftB;CACA;EGvzfO,qBAAkB;CHyzfzB;CACA;EACC,sBAAsB;EGn0fhB,uBAAwB;CHq0f/B;CACA;EACC,OAAO;CyGz0fT;CzG20fC;EyGx0fE,UAAA;CzG00fF;CyG70fD;EAOE,UAAO;EACP,QAAA;CzGy0fD;CyGj1fD;EAWE,cAAM;CzGy0fP;CyGp1fD;EAgBG,mBAAc;CzGu0fhB;CyGn0fD;EAEE,cAAO;EACP,kBAAc;CzGo0ff;CyGv0fD;EAOE,kBAAO;CzGm0fR;CACA;EyG30fD,cAAa;EAYX,kBAAO;CzGk0fR;CACA;EyG7zfD,6BAAwB;EAEjB,uBAAO;CzG8zfb;CACA;EyGj0fD,6BAAwB;CzGm0fvB;CACA;EACC,4BAA4B;CyGr0f9B;AzGu0fA;;AAEA;CACC;EACC,gByG7zfF;CzG8zfC;CACA;EACC,uBAAuB;CyGh0fzB;CzGk0fC;EACC,wBAAwB;CyGn0f1B;CzGq0fC;EyGrzfC,cAAa;EzGuzfb,kBAAkB;EyGnzfpB,6BAA8B;EAEtB,2BACH;EzGmzfH,uBAAuB;CyGhzfzB;CACA;EAEQ,wBACH;CzGgzfJ;CyG7yfD;EAEQ,yBACH;EzG6yfH,kBAAkB;EyG3yfpB,aAAa;CzG6yfZ;CACA;;EAEC,6BAA6B;CyGhzf/B;CzGkzfC;EyGtyfE,kBAAc;CzGwyfhB;CyGnyfD;EAEE,4CACA;EzGmyfA,kBAAkB;EyG9xflB,oBAAY;CzGkyfb;CyGryfD;EAME,aAAa;CzGkyfd;CyG9xfD;;;;EAMG,qCACA;CzG6xfF;CyGpyfD;;EAYG,UAAA;CzG4xfF;CyGxyfD;;EAgBG,0BAAa;EzG4xfd,WAAW;EyGtxfb,uBAAgB;CzGwxff;CACA;;EyGzxfD,WAAA;CzG4xfC;CACA;EACC,gBAAgB;CyG9xflB;CzGgyfC;EACC,iBAAiB;CyGjxfnB;CzGmxfC;EyGhxfO,8CACH;EzGixfH,oBAAoB;CyG9wftB;CzGgxfC;EACC,aAAa;CyGjxff;CzGmxfC;EACC,uBAAuB;CyGxwfzB;CzG0wfC;EyGvwfO,aAAW;CzGywflB;CyGtwfD;EAIG,aAAa;CzGqwff;CyGzwfD;EAUG,cAAa;EzGkwfd,qBAAqB;C0Gz/fnB;C1G2/fH;;;E0Gt/fE,aAAA;C1G0/fF;CACA;E0Gx/fE,qBAAgB;C1G0/flB;CACA;E0Gx/fE,oBAAgB;C1G0/flB;CACA;E0Gx/fE,UAAA;E1G0/fD,SAAS;C0GxggBP;C1G0ggBH;E0GvggBE,gBAAW;EACX,OAAA;C1GyggBF;CACA;E0GvggBE,UAAA;EACA,QAAA;C1GyggBF;CACA;;E0GtggBE,4BAAgB;C1GyggBlB;CACA;EACC,0BAA0B;C0GvhgBxB;C1GyhgBH;E0GthgBE,iCAAY;C1GwhgBd;CACA;E0GthgBE,UAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,wBAAgB;C1GwhgBlB;CACA;E0GthgBE,aAAA;E1GwhgBD,2BAA2B;C0GtigBzB;C1GwigBH;E0GrigBE,kBAAW;C1GuigBb;CACA;E0GrigBE,kBAAgB;C1GuigBlB;CACA;E0GrigBE,aAAA;C1GuigBF;CACA;E0GrigBE,kBAAgB;EAChB,UAAA;EACA,MAAA;E1GuigBD,YAAY;E0GrjgBV,sBAAC;EAEF,+BAAU;EACV,cAAW;C1GsjgBb;CACA;E0GpjgBE,mBAAgB;EAChB,uDAAiB;C1GsjgBnB;CACA;E0GpjgBE,UAAA;EACA,WAAA;C1GsjgBF;CACA;E0GpjgBE,cAAA;E1GsjgBD,UAAU;E0GpkgBR,eAAc;EAEf,cAAS;EACT,SAAA;EACA,kEAAgB;EAChB,uBAAe;C1GqkgBjB;CACA;E0GnkgBE,kEAAiB;C1GqkgBnB;CACA;E0GnkgBE,UAAA;EACA,WAAA;EACA,mEAAiB;C1GqkgBnB;CACA;E0GnlgBG,aAAc;C1GqlgBjB;CACA;E0GllgBE,cAAA;EACA,aAAA;C1GolgBF;CACA;E0GllgBE,iBAAgB;C1GolgBlB;CACA;E0GllgBE,eAAA;C1GolgBF;CACA;E0GllgBE,kBAAgB;E1GolgBjB,aAAa;E0GlmgBX,4BAA0B;C1GomgB7B;CACA;;E0GhmgBE,gBAAc;C1GmmgBhB;CACA;E0GjmgBE,eAAA;C1GmmgBF;CACA;E0GjmgBE,cAAA;C1GmmgBF;CACA;E0GjmgBE,eAAA;C1GmmgBF;C0GjngBG;;EAGD,cAAW;C1GkngBb;CACA;;E0G/mgBE,6BAAgB;EAChB,gCAAgB;C1GkngBlB;CACA;;E0G/mgBE,4BAAgB;EAChB,gCAAgB;C1GkngBlB;CACA;;E0G9ngBE,6BAAU;EACV,gCAAY;C1GiogBd;CACA;E0G/ngBE,8CAAiB;EACjB,kBAAgB;C1GiogBlB;CACA;E0G/ngBE,WAAA;C1GiogBF;CACA;E0G/ngBE,0BAAgB;C1GiogBlB;AACD;;AAEA;;;;CAIC,kB0G/ogBkB;C1GgpgBlB,0B0G/ogBkB;A1GgpgBnB;;AAEA;CACC,+B0G/ogBkB;A1GgpgBnB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,kB0G9pgBiB;A1G+pgBlB;;AAEA;CACC,iC0G9pgBkB;A1G+pgBnB;AACA;CACC;E0G7pgBE,iCAAgB;C1G+pgBlB;AACD;;AAEA;CACC,gB0G7qgBW;A1G8qgBZ;;AAEA;CACC,sB0G7qgBkB;A1G8qgBnB;;AAEA;CACC,W0G7qgBE;C1GgrgBF,oB0G7qgBkB;C1G8qgBlB;;;;;;;;;;;;;;;;;;K2G5rgBG;A3G+sgBJ;AACA;CACC,e4GjtgBgB;A5GktgBjB;AACA;CACC,mB6GptgBe;C7GqtgBf,uBAAuB;C8GttgBxB,cAAA;C9GwtgBC,uB8GvtgBgB;C9G0tgBhB,oB+G1tgBgB;A/G2tgBjB;AC1mgBA;CD4mgBC,YC3mgBS;CD4mgBT,WC3mgBA;CD4mgBA,cC3mgBA;AD4mgBD;AACA;CACC,qBC3mgBgB;AD4mgBjB;AACA;CACC,qBC3mgBgB;AD4mgBjB;AACA;CACC,0BC3mgBgB;CD4mgBhB,WC3mgBA;AD4mgBD;AACA;CACC,WC3mgBA;AD4mgBD;AACA;CACC;EC1mgBA,uBAAkB;CD4mgBlB;AACD;AACA;CACC,mBC3mgBA;CD4mgBA,sBC3mgBkB;CD4mgBlB,kBC3mgBA;CD4mgBA,oBC1mgBA;CD2mgBA,oBAAoB;AACrB;AACA;CACC,egHpvgBG;AhHqvgBJ;AACA;CACC,UgHpvgBW;ChHqvgBX,YsBrvgBW;AtBsvgBZ;;AAEA;CACC,cgHhwgBD;AhHiwgBA;;AAEA;CACC,kBgHpwgBD;AhHqwgBA;AACA;CACC,OgHvwgBD;AhHwwgBA;AACA;CACC,gCgHrvgBI;ChHsvgBJ,UgH3wgBD;AhH4wgBA;;AAEA;CACC,kBgH9ugBI;ChH+ugBJ,UgHhxgBD;AhHixgBA;;AAEA;CACC,OgHpxgBD;AhHqxgBA;AACA;CACC,UgH3ugBe;ChH4ugBf,QgHxxgBD;AhHyxgBA;;AAEA;CACC,eAAe;AAChB;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,4BiH5xgBQ;AjH6xgBT;AACA;CACC,6BsBpxgBa;CtBqxgBb,uBsBtxgBS;AtBuxgBV;;AAEA;CACC,eiH1xgBO;AjH2xgBR;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,ekHtzgBD;ClHuzgBC,yBkH1ygB+B;ClH2ygB/B,0BkH1ygB6B;AlH2ygB9B;;AAEA;CkH3zgBA,eAAA;ClH6zgBC,4BkHhygBgB;ClHiygBhB,6BAA6B;AAC9B;AACA;CACC,4BAA4B;CmHj0gB7B,6BAAoB;AnHm0gBpB;;AAEA;CmHr0gBA,eAAA;AnHu0gBA;;AAEA;CACC,yBmH1zgBI;CnH2zgBJ,0BmH30gBmB;AnH40gBpB;;AAEA;CmH90gBA,4BAAoB;CnHg1gBnB,6BmH70gByB;AnH80gB1B;;AAEA;;;;;;;;;;;;CAYC,kBoH50gBuB;ApH60gBxB;;AAEA;CACC,kBoHn2gBD;CpHo2gBC,UoHp0gB2B;CpHq0gB3B,aoHr2gBD;CpHs2gBC,WoH9zgBe;CpH+zgBf,gCoHv2gBmB;CpHw2gBnB,WoHzzgB4B;CpH0zgB5B,qBoHz2gBmB;CpH02gBnB,YoHrzgBsB;CpHszgBtB,WoH32gBD;CpH42gBC,kBoHpzgBe;CpHqzgBf,kBoH72gBD;CpH82gBC,iBoHjzgBiC;CpHkzgBjC,sCAAsC;AC7vgBvC;AD+vgBA;CACC,WC9vgBA;AD+vgBD;AACA;CACC;EC7vgBA,aAAA;CD+vgBA;AACD;AACA;CACC,WC9vgBA;AD+vgBD;;AAEA;CACC,aC9vgBA;CD+vgBA,eC9vgBA;CD+vgBA,MC9vgBA;CD+vgBA,YC9vgBA;CD+vgBA,sBC9vgBkB;CD+vgBlB,kBC9vgBA;CD+vgBA,gCC9vgBkB;CD+vgBlB,uBC9vgBkB;CD+vgBlB,aC9vgBA;AD+vgBD;AACA;CACC,kBC9vgBA;CD+vgBA,SC9vgBA;CD+vgBA,OC9vgBC;CD+vgBD,aAAa;CqHx4gBd,YAAA;CrH04gBC,esBz3gBM;AtB03gBP;AACA;CACC,uBqHx4gBc;CrHy4gBd,0DqHl2gBA;CrHm2gBA,qBqH/4gBmB;ArHg5gBpB;AACA;CACC,YqHl5gBD;CrHm5gBC,uBqHn5gBmB;ArHo5gBpB;AACA;CACC,0BqHt5gBmB;CrHu5gBnB,oBqHv5gBA;CrHw5gBA,qBqHx5gBmB;CrHy5gBnB,uBqHz5gBmB;ArH05gBpB;AACA;CACC,4BqH14gBI;ArH24gBL;AACA;CACC,kBCxzgBkB;CDyzgBlB,UqHh6gBD;CrHi6gBC,kBqHt4gBQ;CrHu4gBR,MqHl6gBD;CrHm6gBC,YqH73gBe;CrH83gBf,YqHp6gBD;CrHq6gBC,WqH/3gBe;CrHg4gBf,iBqHt6gBD;CrHu6gBC,kBqHj4gBwC;CrHk4gBxC,iBqHx6gBD;CrHy6gBC,WqHn4gBe;ArHo4gBhB;AACA;CACC,cAAc;CsHh7gBf,iDACO;CtHi7gBN,asHh7gBO;AtHi7gBR;AACA;CsHp7gBA,eAAA;CtHs7gBC,WsHh7gBO;CtHi7gBP,esHh7gBa;CtHi7gBb,YsHx7gBD;CtHy7gBC,MsHh7gBE;CtHi7gBF,OsH17gBD;CtH27gBC,8BsBr6gBkB;AtBs6gBnB;AACA;CsH77gBA,8BAoBE;CtH26gBD,gBsHz6gBC;CtH06gBD,MAAM;CsHh8gBP,WAAA;CtHk8gBC,sBsHz6gBC;CtH06gBD,UAAU;CsHn8gBX,8CA0BkB;AtH26gBlB;AACA;CACC,gBsHz6gBC;CtH06gBD,SAAO;AACR;AACA;CACC,SsH16gBO;CtH26gBP,mBsHx6gBI;CtHy6gBJ,kBAAkB;CsH78gBnB,kBAAC;CtH+8gBA,sBsBz7gBkB;CtB07gBlB,gBAAgB;CsHh9gBjB,SAAA;AtHk9gBA;AACA;CACC,iCAAiC;CsHp9gBlC,WAAA;AtHs9gBA;AACA;CACC,kBsHx6gBkB;CtHy6gBlB,iBsHz9gBD;CtH09gBC,gBsB/8gBW;AtBg9gBZ;AACA;;CAEC,yBsHr6gBC;CtHs6gBD,aAAa;CsH/9gBd,8BA2DC;CtHs6gBA,mBsB78gBS;CtB88gBT,WAAW;CsHl+gBZ,gBAAA;CtHo+gBC,2BsBh9gBS;AtBi9gBV;AACA;CACC,0BAA0B;CsHv+gB3B,iBAAA;CtHy+gBC,gBsBp9gBM;AtBq9gBP;AACA;CsH3+gBA,sBAAoB;AtH6+gBpB;AACA;CACC,cAAc;CsH/+gBf,gBAAA;CtHi/gBC,qBsB79gBS;CtB89gBT,esB/9gBc;AtBg+gBf;AACA;CsHp/gBA,aAAA;AtHs/gBA;AACA;CsHv/gBA,qBAAoB;CtHy/gBnB,gBsHp6gBC;CtHq6gBD,iBAAiB;CsH1/gBlB,eAAA;CtH4/gBC,yBsBx+gBS;CtBy+gBT,sBAAsB;CsH7/gBvB,uBAAoB;CtH+/gBnB,wBsHp6gBC;AtHq6gBF;AACA;CACC,kBsB9+gBS;AtB++gBV;AACA;CACC,iBsHrghBD;CtHsghBC,gBsBl/gBS;CtBm/gBT,cAAc;CsHvghBf,aAAA;CAAA,WAAA;CtH0ghBC,kBsBt/gBS;CtBu/gBT,yBAAyB;CsH3ghB1B,uBAAoB;CtH6ghBnB,YsHl6gBW;AtHm6gBZ;AACA;;;;CAIC,sBsHnhhBmB;AtHohhBpB;AACA;;;;CAIC,yBsBrghBS;AtBsghBV;AACA;;;;CAIC,yBsB3ghBS;AtB4ghBV;AACA;;;;CAIC,yBsH95gBC;AtH+5gBF;AACA;;;;CAIC,yBsH95gBC;AtH+5gBF;AACA;;;;CAIC,yBsH75gBmB;AtH85gBpB;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;;;;CAIC,yBsH/khBmB;AtHglhBpB;AACA;;;;CsHjlhBA,yBAAC;AtHslhBD;AACA;;;;CAIC,yBAAyB;AAC1B;AACA;;;;CAIC,yBsHjmhBmB;AtHkmhBpB;AACA;;;;CAIC,yBsHvmhBmB;AtHwmhBpB;AACA;;;;CAIC,+BsH15gBA;AtH25gBD;AACA;CsH/mhBA,aAAA;CtHinhBC,gBsB5lhBM;CtB6lhBN,asHt4gBmB;CtHu4gBnB,iBsHr4gBI;AtHs4gBL;AACA;CsHrnhBA,gBAAA;AtHunhBA;AACA;CACC,YsHr4gBC;AtHs4gBF;AACA;CACC,QsH5nhBD;AtH6nhBA;AACA;CACC,csBpnhBW;AtBqnhBZ;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CsHtohBA;EAmQI,0BACH;EtHq4gBC,kCAAkC;CsHzohBpC;CtH2ohBC;EsHn4gBE,yBAAa;EACb,iChG9PS;CtBmohBX;CACA;EACC,0BsHp4gBmB;EtHq4gBnB,kCAAkC;CsHjphBpC;AtHmphBA;;AAiBA;CACC;EACC,iBAAiB;CsHtqhBnB;AtHwqhBA;;AAEA;CACC,0BsBtphBa;CtBuphBb,uBsH/3gBC;CtHg4gBD,oCAAoC;AACrC;AACA;CACC;EsHhrhBD,oCAiTC;CtHi4gBA;AACD;AACA;CACC,gBsHh4gBY;CtHi4gBZ,iBAAiB;AAClB;AACA;CACC;EsHzrhBD,gBAAA;EA6TQ,iBAAa;EtH+3gBnB,uBAAuB;CsH5rhBzB;AtH8rhBA;AACA;;CAEC,qBsB7qhBS;CtB8qhBT,wBAAwB;CsHlshBzB,WAAA;AtHoshBA;AACA;CACC;;EAEC,asHxshBF;CtHyshBC;AACD;AACA;;CAEC,WAAW;AACZ;AACA;CACC,qBAAqB;CsHhthBtB,qBAAoB;CtHkthBnB,csHx3gBa;AtHy3gBd;AACA;CACC;EsHrthBD,aAAA;CtHuthBC;AACD;AACA;CACC;EACC,qBAAqB;EsH3thBvB,cAAA;CtH6thBC;AACD;;AAEA;CACC,oCAAoC;AACrC;AACA;CACC,gBAAgB;CsHpuhBjB,iBAAA;CtHsuhBC,uBsHt3gBmB;AtHu3gBpB;AACA;;;CsHxuhBA,aAAA;AtH4uhBA;AACA;CsH7uhBA,qBAAoB;CtH+uhBnB,csBpuhBW;AtBquhBZ;AACA;CACC,0BsHn3gBE;CtHo3gBF,wBAAwB;AACzB;;AAEA;CsHtvhBA,eAAA;CAAA,aAAA;CtHyvhBC,esBruhBS;CtBsuhBT,gBAAgB;CsH1vhBjB,MAAA;CtH4vhBC,asBjvhBW;CtBkvhBX,gBAAgB;CsH7vhBjB,2DA8YK;CtHm3gBJ,oBsHh3gBgB;AtHi3gBjB;AACA;CACC,mBsH92gBE;AtH+2gBH;AACA;CACC,kBsBjvhBW;CtBovhBX,oBsH52gBmB;CtH62gBnB,QAAQ;CsH3whBT,YAAA;CtH6whBC,esHv2gBC;CtHw2gBD,gBAAgB;CsH9whBjB,UAAA;CAAA,YAAA;CtHixhBC,esHx2gBY;AtHy2gBb;AACA;CsHnxhBA,qBAAoB;AtHqxhBpB;AACA;CACC,asHx2gBa;AtHy2gBd;AACA;CACC,QsHx2gBC;AtHy2gBF;AACA;CACC,YsHx2gBW;AtHy2gBZ;AACA;CACC,qBsB1whBkB;AtB2whBnB;AACA;CACC,mBsB/whBS;AtBgxhBV;AACA;CACC,yBsHv2gBC;CtHw2gBD,iCAAiC;CsHvyhBlC,SAAA;CtHyyhBC,8BsHv2gBC;AtHw2gBF;AACA;CACC,qBsBxxhBS;CtByxhBT,YAAY;CsH7yhBb,yBAAC;AtH+yhBD;AACA;;CAEC,uBAAuB;CsHlzhBxB,qBAAoB;CtHozhBnB,UsHr2gBC;CtHs2gBD,4BAA4B;AAC7B;AACA;CACC,aAAa;CsHxzhBd,qBAAoB;CtH0zhBnB,sBsBtyhBS;CtBuyhBT,kBAAkB;CsH3zhBnB,cAAA;CtH6zhBC,gBsBxyhBM;CtByyhBN,aAAa;CsH9zhBd,mBAAoB;CtHg0hBnB,uBsHn2gBC;CtHo2gBD,gBAAgB;CsHj0hBjB,mBAAoB;CtHm0hBnB,iBsHj2gBG;CtHk2gBH,kBAAkB;AACnB;AACA;CACC,WAAW;AACZ;AACA;CACC,iCAAiC;CsH10hBlC,qBAAoB;AtH40hBpB;AACA;CsH70hBA,iCAqfC;AtH01gBD;AACA;CsHh1hBA,mBAAoB;CtHk1hBnB,csB7zhBM;AtB8zhBP;AACA;CACC,mCsHt1gBC;AtHu1gBF;AACA;CACC,mBsBp0hBS;CtBq0hBT,cAAc;AACf;AACA;CACC,kCAAkC;AACnC;AACA;CACC,mBsHh1gBE;CtHi1gBF,csHh2hBD;AtHi2hBA;AACA;CsHl2hBA,kCAwgBC;AtH41gBD;AACA;CACC,WAAW;AACZ;AACA;CACC,mBAAmB;CsHz2hBpB,kBAAC;CtH22hBA,csBv1hBS;CtBw1hBT,eAAe;CsH52hBhB,wBAAoB;CtH82hBnB,iBsH90gBE;CtH+0gBF,YAAY;CsH/2hBb,2BA6hBC;AtHo1gBD;AACA;CsHl3hBA,mBAAoB;AtHo3hBpB;AACA;CsHr3hBA,gBAAA;AtHu3hBA;AACA;CACC,csH10gBY;AtH20gBb;AACA;CsH33hBA,oBAAoB;CtH63hBnB,WsHt0gBa;CtHu0gBb,cAAc;CsH93hBf,gBAAA;CtHg4hBC,csBr3hBW;CtBs3hBX,wBAAwB;CsHj4hBzB,uBAAoB;CtHm4hBnB,mBsB/2hBS;CtBg3hBT,gBAAgB;CsHp4hBjB,cAAA;CtHs4hBC,oBsBl3hBS;AtBm3hBV;AACA;CACC,WsHl0gBa;AtHm0gBd;AACA;CACC,oBsBt3hBkB;CtBu3hBlB,gBAAgB;CsH74hBjB,cAAA;CtH+4hBC,uBsB33hBS;CtB43hBT,mBAAmB;CsHh5hBpB,gBAAA;CtHk5hBC,csBv4hBW;CtBw4hBX,oBAAoB;AACrB;AACA;CACC,uBAAuB;CsHt5hBxB,mCAylBC;CtH+zgBA,esH7zgBC;AtH8zgBF;AACA;CACC,sCsBr4hBkB;AtBs4hBnB;AACA;CsH75hBA,aAAA;CtH+5hBC,mBsBz4hBW;AtB04hBZ;AACA;CsHj6hBA,mBAAoB;AtHm6hBpB;AACA;CsHp6hBA,yBAAC;AtHs6hBD;AACA;CsHv6hBA,mBAAoB;CtHy6hBnB,qBsBr5hBS;CtBs5hBT,gBAAgB;CsH16hBjB,WAAA;CtH46hBC,gBsH1zgBC;CtH2zgBD,MAAM;CsH76hBP,UAAA;AtH+6hBA;AACA;CsHh7hBA,WAAA;CtHk7hBC,mBsB95hBS;AtB+5hBV;AACA;CACC,2BsH3zgB0B;AtH4zgB3B;AACA;CACC,2BsH1zgBC;AtH2zgBF;AACA;CACC,mBsBv6hBS;CtBw6hBT,0BAA0B;CsH57hB3B,uBAAoB;AtH87hBpB;AACA;;CAEC,oBsH1zgBC;AtH2zgBF;AACA;CACC,gBsH3zgBY;CtH4zgBZ,kBAAkB;CsHr8hBnB,cAAA;AtHu8hBA;AACA;CsHx8hBA,8BAkpBC;CtHwzgBA,gBsHtzgBC;AtHuzgBF;AACA;CACC,mBsBv7hBW;AtBw7hBZ;AACA;CsH/8hBA,kBAAC;CtHi9hBA,esHtzgBC;CtHuzgBD,gBAAgB;CsHl9hBjB,mBAAoB;CtHo9hBnB,uBsHtzgBC;CtHuzgBD,qBAAqB;CsHr9hBtB,cAAA;AtHu9hBA;AACA;CsHx9hBA,iCAkqBC;AtHwzgBD;AACA;CsH39hBA,UAAA;AtH69hBA;AACA;CsH99hBA,eAAA;CtHg+hBC,gBsHtzgBC;CtHuzgBD,cAAc;CsHj+hBf,mBAAoB;CtHm+hBnB,mBsHtzgBC;AtHuzgBF;AACA;CACC,WsB39hBO;AtB49hBR;AACA;CACC,0BsHnzgBC;CtHozgBD,qBAAqB;CsH1+hBtB,2CAurBiB;CtHqzgBhB,2BsHnzgBC;CtHozgBD,WAAW;CsH7+hBZ,kBAAC;AtH++hBD;AACA;CsHh/hBA,cAAA;CtHk/hBC,oBsH9ygBM;CtH+ygBN,WAAW;CsHn/hBZ,qBAAoB;CtHq/hBnB,YsBj+hBS;AtBk+hBV;AACA;CACC,WsH3ygBQ;CtH4ygBR,kBAAkB;CsHz/hBnB,eAAA;CtH2/hBC,2CsHxygBE;CtHyygBF,yCAAyC;CsH5/hB1C,sBAAoB;CtH8/hBnB,MsHxygBC;AtHyygBF;AACA;CACC,mBsHxygBY;CtHyygBZ,2BAA2B;CsHlgiB5B,8CA2tBoB;CtHyygBnB,sBsB/+hBa;CtBg/hBb,WsB1/hBO;CtB2/hBP,kBAAkB;CsHtgiBnB,iBAAA;AtHwgiBA;AACA;CACC,mBsHtygBS;CtHuygBT,WAAW;AACZ;AACA;CACC,cAAc;CsH9giBf,oBAAoB;CtHghiBnB,iBsB1/hBW;CtB2/hBX,qBsB3/hBkB;CtB4/hBlB,YAAY;AACb;AACA;CACC,WsHnygBW;CtHoygBX,kBsHthiBD;CtHuhiBC,gBsHjygBG;CtHkygBH,mCAAmC;CsHxhiBpC,yCAyvBc;CtHiygBb,sBsBtgiBS;CtBugiBT,MAAM;AACP;AACA;CACC,mCAAmC;AACpC;AACA;CACC,sBsHjiiBmB;CtHkiiBnB,gBsH5xgBI;CtH6xgBJ,SsHniiBD;CtHoiiBC,YsBjhiBO;CtBkhiBP,kBAAkB;AACnB;AACA;CACC,UsBrhiBO;AtBshiBR;AACA;CACC,mBsBvhiBS;CtBwhiBT,kCsHtxgBC;CtHuxgBD,eAAe;CsH7iiBhB,gBAAA;CtH+iiBC,UsHvxgBO;CtHwxgBP,iBAAiB;CsHhjiBlB,gBAAA;AtHkjiBA;AACA;CACC,sBsBhiiBS;AtBiiiBV;AACA;CACC,gBsHtxgBC;CtHuxgBD,iBAAiB;CsHxjiBlB,mBAAoB;CtH0jiBnB,kBsHtxgBC;CtHuxgBD,sBAAsB;CsH3jiBvB,wBAAoB;CtH6jiBnB,WsBljiBW;CtBmjiBX,uBAAuB;CsH9jiBxB,kBAAC;CtHgkiBA,esB3iiBM;CtB4iiBN,oBsHlxgBC;CtHmxgBD,qBAAqB;AACtB;AACA;CsHpkiBA,qBAAoB;AtHskiBpB;;AAEA;CACC;EACC,cAAc;CsH1kiBhB;CtH4kiBC;EsHnxgBC,chGryBQ;CtB0jiBT;AACD;;AAEA;CsHjliBA,qBAAoB;CtHmliBnB,qBsBxkiBW;AtBykiBZ;;AAEA;CACC,gBAAgB;CsHvliBjB,eAAA;CtHyliBC,MsHxwgBS;CtHywgBT,eAAe;CsH1liBhB,sBAAoB;CtH4liBnB,asHlwgBe;CtHmwgBf,gCAAgC;CsH7liBjC,aAAA;AtH+liBA;AACA;CsHhmiBA,kBAAC;CtHkmiBA,UsH7vgBU;CtH8vgBV,aAAa;CsHnmiBd,WAAA;CtHqmiBC,yBsH1vgBa;CtH2vgBb,WAAW;CsHtmiBZ,qBAAoB;CAApB,YAAA;CtHymiBC,WsH1vgBC;CtH2vgBD,kBAAkB;CsH1miBnB,kBAAC;CtH4miBA,iBsBxliBS;CtByliBT,sCAAsC;CsH7miBvC,yEAs3BO;AtHyvgBP;AACA;CsHhniBA;EA43BE,aAAM;CtHuvgBP;AACD;AACA;CACC,gBAAgB;CsHtniBjB,WAAA;CtHwniBC,esBpmiBS;CtBqmiBT,uBAAuB;CsHzniBxB,8BAo4BC;CtHuvgBA,qBsHrvgBC;CtHsvgBD,kBAAkB;AACnB;AACA;CACC,QAAQ;CsH/niBT,iDA04BuB;CtHuvgBtB,csB5miBM;CtB6miBN,gBAAgB;AACjB;AACA;CACC,aAAa;AACd;AACA;CACC,eAAe;CsHxoiBhB,WAAA;CtH0oiBC,esHlvgBY;CtHmvgBZ,WsHlvgBO;CtHmvgBP,YAAY;CsH5oiBb,MAAA;CtH8oiBC,OsHlvgBC;CtHmvgBD,+BAA+B;AAChC;AACA;CACC,0BAA0B;CsHlpiB3B,gBAAA;AtHopiBA;AACA;CsHrpiBA,2BAo6BC;AtHmvgBD;AACA;CsHxpiBA,aAAA;CtH0piBC,8BsHjvgBC;CtHkvgBD,mBAAmB;CsH3piBpB,sBAAoB;AtH6piBpB;AACA;;CAEC,gBsB3oiBM;CtB4oiBN,WAAW;AACZ;AACA;CACC,eAAe;CsHpqiBhB,gBAAA;CtHsqiBC,+BsH/ugBC;CtHgvgBD,kDAAkD;CsHvqiBnD,uBAAoB;CtHyqiBnB,uBsH/ugBC;AtHgvgBF;AACA;CACC,qBsH/ugBC;AtHgvgBF;AACA;CACC,UsHhvgBC;AtHivgBF;AACA;CACC,kBsHhvgBiB;AtHivgBlB;AACA;CACC,kBsH9ugBC;CtH+ugBD,MAAM;CsHtriBP,SAAA;CtHwriBC,OsH/ugBC;CtHgvgBD,QsH/ugBC;CtHkvgBD,asBtqiBW;CtByqiBX,uBsBpriBW;CgGXZ,mBAAoB;CtHmsiBnB,oCsH9ugBC;CAr9BF,yBAAC;CtHssiBA,UsH/ugBC;AtHgvgBF;AACA;CAEC,yBAAyB;CsH1siB1B,UAAA;AtH4siBA;;AAEA;CACC,uBsB3riBS;AtB4riBV;;AAEA;;CAEC,uBAAuB;CAGvB,oBsHzugBe;AtH0ugBhB;AACA;CsHztiBA;;EAAA,qBAAoB;CAApB;AtH8tiBA;AACA;CsH/tiBA;;EtHkuiBE,qBAAqB;CsHluiBvB;AtHouiBA;;AAEA;CACC,gBsBntiBS;CtBstiBT,oBsBptiBW;AtBqtiBZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,iCsHhugBC;AtHiugBF;AACA;CACC;;EsHtviBD,uBAAoB;CAApB;AtH0viBA;AACA;CsH3viBA;;EtH8viBE,mBsH9viBD;CtH+viBA;AACD;;AAEA;CACC,iDAAiD;CAGjD,oBAAoB;AACrB;AACA;CACC;EsHzwiBD,gBAAA;CtH2wiBC;AACD;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,eAAe;CsHnxiBhB,WAAA;CAAA,eAAA;CAAA,YAAA;CAAA,MAAA;CAAA,OAAA;CAAA,8BA6jCC;CA7jCD,cAAA;CAAA,UAAA;AtH4xiBA;AACA;;;;;;uBsBzwiBU;;AtBixiBV;CACC,esBlxiBS;CtBmxiBT,uBAAuB;CsHvyiBxB,YAAA;CtHyyiBC,sBsBnxiBW;CtBoxiBX,qBsBtxiBS;CtBuxiBT,iBsH3tgBC;CtH8tgBD,oBsHztgBG;CtH0tgBH,QAAQ;CsH/yiBT,YAAA;CtHiziBC,YsBtyiBW;CtBuyiBX,qBAAqB;CsHlziBtB,sBAAoB;AtHoziBpB;AACA;CsHrziBA;EA+lCE,YhG1kCK;CtBmyiBN;AACD;AACA;CACC;EsH3ziBD,8BAomCC;EApmCD,0BAqmCC;EACC,0CACA;EtHwtgBA,aAAa;EsH/ziBf,kBAAoB;CtHi0iBnB;AACD;AACA;CsHn0iBA,YAAA;CtHq0iBC,WsHxtgBC;CtHytgBD,cAAc;CsHt0iBf,eAAA;CtHw0iBC,csHrtgBG;CtHstgBH,mBAAmB;CsHz0iBpB,eAAA;CAAA,aAAA;AtH40iBA;AACA;CACC;EACC,cAAc;CsH/0iBhB;AtHi1iBA;;AAEA;CACC,kBAAkB;CsHp1iBnB,kBAAC;CtHs1iBA,mBsBh0iBW;AtBi0iBZ;;AAEA;;CAEC,qBAAqB;AACtB;AACA;;CsH71iBA,UAAA;AtHg2iBA;AACA;;CAEC,UAAU;AACX;AACA;;CsHr2iBA,gBAAA;AtHw2iBA;;AAEA;;CAEC,qBAAqB;AACtB;AACA;;CsH92iBA,UAAA;AtHi3iBA;AACA;;CsHl3iBA,UAAA;AtHq3iBA;AACA;;CsHt3iBA,gBAAA;AtHy3iBA;;AAEA;;CsH33iBA,qBAAoB;AtH83iBpB;AACA;;CsH/3iBA,UAAA;AtHk4iBA;AACA;;CsHn4iBA,UAAA;AtHs4iBA;AACA;;CAEC,gBsHzsgBC;AtH0sgBF;;AAEA;;CAEC,qBsBx3iBW;AtBy3iBZ;AACA;;CAEC,UsHzsgBC;AtH0sgBF;AACA;;CAEC,UsHzsgBO;AtH0sgBR;AACA;;CAEC,gBAAgB;AACjB;;AAEA;;CAEC,qBsHzsgBO;AtH0sgBR;AACA;;CAEC,UAAU;AACX;AACA;;CsHr6iBA,UAAA;AtHw6iBA;AACA;;CAEC,gBsHxsgBc;AtHysgBf;;AAEA;;CsH96iBA,qBAAoB;AtHi7iBpB;AACA;;CAEC,UsHpsgBS;AtHqsgBV;AACA;;CAEC,UAAU;AACX;AACA;;CsH17iBA,gBAAA;AtH67iBA;;AAEA;;CAEC,qBsH9rgBgB;AtH+rgBjB;AACA;;CAEC,UsH9rgBE;AtH+rgBH;AACA;;CAEC,UsH1rgBI;AtH2rgBL;AACA;;CAEC,gBsHtrgBE;AtHurgBH;;AAEA;;CAEC,qBAAqB;AACtB;AACA;;CsHp9iBA,UAAA;AtHu9iBA;AACA;;CAEC,UsHprgBQ;AtHqrgBT;AACA;;CAEC,gBsHnrgBa;AtHorgBd;;AAEA;;CsHj+iBA,qBAAoB;AtHo+iBpB;AACA;;CsHr+iBA,UAAA;AtHw+iBA;AACA;;CAEC,UsH3qgBC;AtH4qgBF;AACA;;CAEC,gBAAgB;AACjB;;AAEA;;CAEC,qBsB/9iBM;AtBg+iBP;AACA;;CAEC,UsHnqgBC;AtHoqgBF;AACA;;CAEC,UsHlqgBC;AtHmqgBF;AACA;;CAEC,gBAAgB;AACjB;;AAEA;;CAEC,qBsHhqgBC;AtHiqgBF;AsHhqgBC;;CtHmqgBA,UsHjqgBS;AtHkqgBV;AACA;;CsH3gjBA,UAAA;AtH8gjBA;AACA;;CAEC,gBsH1pgBC;AtH2pgBF;;AAEA;;CAEC,qBAAqB;AACtB;AACA;;CsHxhjBA,UAAA;AtH2hjBA;AACA;;CsH5hjBA,UAAA;AtH+hjBA;AACA;;CAEC,gBsHrpgBc;AtHspgBf;;AAEA;;CAEC,qBAAqB;AACtB;AACA;;CsHzijBA,UAAA;AtH4ijBA;AACA;;CAEC,UsHjpgBC;AtHkpgBF;AACA;;CsHjjjBA,gBAAA;AtHojjBA;;AAEA;;CAEC,qBAAqB;AACtB;AACA;;CAEC,UAAU;AACX;AACA;;CAEC,UsHhpgBC;AtHipgBF;AACA;;CAEC,gBAAgB;AACjB;;AAEA;;CAEC,qBsH7ogBE;CtH8ogBF;;;;;MsHxogBC;AtH8ogBF;AACA;;CAEC,qBAAqB;AACtB;AACA;;CuHrljBA,2BAWI;AvH6kjBJ;AACA;;CAEC,8BuHzkjBE;AvH0kjBH;AACA;;CAEC,oCAAoC;AACrC;AACA;;CAEC,iDuHhljBC;AvHiljBF;AACA;;;;;;;CAOC,WuHnkjBG;AvHokjBJ;AACA;;CAEC,WuH5jjBG;AvH6jjBJ;AACA;;CAEC,WAAW;AACZ;AACA;;;;;;;;;;CAUC,yBAAyB;AAC1B;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAoCC,gDwH7pjBC;AxH8pjBF;AACA;;;;;;CAMC,WwHzpjBG;AxH0pjBJ;AACA;;;;;;;CAOC,8BsB5qjBO;CtB6qjBP,+BAA+B;AAChC;AACA;;;;;;;;;;;;CAYC,gBAAgB;CwHtsjBjB,kCAsDI;CxHkpjBH,sBsB7rjBW;AtB8rjBZ;AACA;;;;;;;;;;;;;;CwH1sjBA,8BAsDI;CxHmqjBH,sBwHzmjBoC;AxH0mjBrC;AACA;;CAEC,0CAA0C;AAC3C;AACA;;;;;;CAMC,sBwHnmjBkB;AxHomjBnB;AACA;;CAEC,2CyHxujBiB;AzHyujBlB;AACA;;CAEC,2CsBlujBW;AtBmujBZ;AACA;;CyH/ujBA,gDAiBE;CzHiujBD,sByH1tjBE;AzH2tjBH;AACA;;CyHpvjBA,sBAAoB;AzHuvjBpB;AACA;;CAEC,2ByH5tjBE;AzH6tjBH;AACA;;CAEC,yF0H1vjBkB;A1H2vjBnB;AACA;;CAEC,WAAW;AMj+iBZ;ANm+iBA;;CAEC,W2HnwjBG;A3HowjBJ;AACA;;CAEC,W2HnwjBa;A3HowjBd;AACA;;CAEC,yB2HnwjBY;A3HowjBb;AACA;;C2HhwjBA,WAAU;A3HmwjBV;;A2HhwjBA;;C3HowjBC,qB2HlwjBU;C3HmwjBV;;;;;M2H7vjBD;AACA;AACA;;C3HowjBC,qB2HjwjBA;A3HkwjBD;A4HlyjBA;;C5HqyjBC,2B4HnyjBe;AAEhB;A5HmyjBA;;CAEC,8BAA8B;A4HryjB/B;A5HuyjBA;;C4H7xjBA,oCAAU;A5HgyjBV;AACA;;C4H5xjBA,iDAAS;A5H+xjBT;AACA;;;;;;;CAOC,W4H3xjBW;A5H4xjBZ;AACA;;CAEC,W4HvxjBW;A5HwxjBZ;AACA;;CAEC,W4HnxjBkB;A5HoxjBnB;AACA;;;;;;;;;;C4HnwjBA,yBAAY;AACZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAmDA,gDAAgB;A5H+vjBhB;AACA;;;;;;C4HtvjBA,WAAA;A5H6vjBA;AACA;;;;;;;CAOC,8B4HvvjBI;C5HwvjBJ,+BAA+B;A4HrvjBhC;A5HuvjBA;;;;;;;;;;;;CAYC,gBsB71jBM;CtB81jBN,kC4HnvjBD;C5HovjBC,sB4HjvjBoB;A5HkvjBrB;A4H/ujBA;;;;;;;;;;;;;;C5H8vjBC,8B4H5ujBI;C5H6ujBJ,sBAAsB;A4H3ujBvB;A5H6ujBA;;C4HzujBA,0CAAmC;A5H4ujBnC;AACA;;;;;;CAMC,sB4HvujBA;A5HwujBD;A4HpujBA;;C5HuujBC,2C4HnujBe;A5HoujBhB;AACA;;CAEC,2C4HnujBmB;A5HoujBpB;AACA;;CAEC,gDAAgD;C4HjujBjC,sBAAqB;A5HmujBrC;AACA;;CAEC,sB4HlujBuB;A5HmujBxB;A4HrvjBA;;C5HwvjBC,2BAA2B;A4HxvjB5B;A5H0vjBA;;C4H1vjBA,yFAiCiB;A5H4tjBjB;AACA;;CAEC,W4HztjBqB;A5H0tjBtB;A4HjwjBA;;C5HowjBC,WAAW;A4HpwjBZ;A5HswjBA;;C4HtwjBA,WAAA;A5HywjBA;AACA;;C4H7sjBA,yBAAY;AACZ;A5HgtjBA;;CAEC,W4HntjBG;A5HotjBJ;;AAEA;;CAEC,qBsBj9jBS;CtBk9jBT;;;;;M6Hl+jBG;A7Hw+jBJ;AACA;;CAEC,qB6Hv+jBkB;A7Hw+jBnB;AACA;;CAEC,2B6Hv+jBY;A7Hw+jBb;AACA;;CAEC,8BGt+jByB;AHu+jB1B;AACA;;CAEC,oC6Hr+jBoB;A7Hs+jBrB;AACA;;CAEC,iD6Hp+jB0B;A7Hq+jB3B;AACA;;;;;;;CAOC,W6H79jBO;A7H89jBR;AACA;;CAEC,W6H79jBW;A7H89jBZ;AACA;;CAEC,W6H59jBW;A7H69jBZ;AACA;;;;;;;;;;CAUC,yB6Hl/jBG;A7Hm/jBJ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAoCC,gD6HlkkBe;A7HmkkBhB;AACA;;;;;;CAMC,WAAW;A6Hr8jBZ;A7Hu8jBA;;;;;;;CAOC,8B6Hr8jBI;C7Hs8jBJ,+BiBz/jB2B;AjB0/jB5B;AACA;;;;;;;;;;;;CAYC,gBiBvgkBW;CjBwgkBX,kC6H57jBG;C7H67jBH,sB6Hp7jBgB;A7Hq7jBjB;AACA;;;;;;;;;;;;;;CAcC,8B6Hp7jBQ;C7Hq7jBR,sB6H/6jBuB;A7Hg7jBxB;AACA;;CAEC,0C6H36jBwC;A7H46jBzC;AACA;;;;;;CAMC,sB6Hv7jBa;A7Hw7jBd;AACA;;CAEC,2C6Hx6jBiC;A7Hy6jBlC;AACA;;CAEC,2C6Hx6jB0B;A7Hy6jB3B;AACA;;CAEC,gD6Hr6jBY;C7Hs6jBZ,sBG1mkBmB;AH2mkBpB;AACA;;CAEC,sB6Hv6jB+B;A7Hw6jBhC;AACA;;CAEC,2B6Hh6jB0B;A7Hi6jB3B;AACA;;CAEC,yF6Hh6jBgC;A7Hi6jBjC;AACA;;CAEC,W6Hh6jBuB;A7Hi6jBxB;AACA;;CAEC,W6Hx9jBG;A7Hy9jBJ;AACA;;CAEC,W6H59jBG;A7H69jBJ;AACA;;CAEC,yB6Ht5jB6B;A7Hu5jB9B;AACA;;CAEC,W6Hl5jBS;A7Hm5jBV;;AAEA;;CAEC,qB6Hl5jBa;C7Hm5jBb;;;;;M6Hz5jBD;A7H+5jBA;AACA;;CAEC,qBsBnkkBc;AtBokkBf;A6Hp4jBA;;C7Hu4jBC,2B6Hp4jB2B;A7Hq4jB5B;AACA;;CAEC,8B6Hl4jBI;A7Hm4jBL;A6H54jBA;;C7H+4jBC,oCAAoC;A6H/4jBrC;A7Hi5jBA;;C6H33jBK,iDAEI;A7H43jBT;AACA;;;;;;;CAOC,W6Hv3jBe;A7Hw3jBhB;AACA;;CAEC,W6Hl3jBe;A7Hm3jBhB;A6H92jBA;;C7Hi3jBC,W6H/2jBa;A7Hg3jBd;AACA;;;;;;;;;;CAUC,yBAAyB;A6H/2jB1B;A7Hi3jBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAoCC,gD6H/1jBgC;A7Hg2jBjC;AACA;;;;;;CAMC,W6H11jBe;A7H21jBhB;AACA;;;;;;;CAOC,8B6Hp1jBgC;C7Hq1jBhC,+B6Ht0jBQ;A7Hu0jBT;AACA;;;;;;;;;;;;CAYC,gB6Hx0jBsB;C7Hy0jBtB,kC6Hx0jBmC;C7Hy0jBnC,sB6Hx0jB8B;A7Hy0jB/B;AACA;;;;;;;;;;;;;;CAcC,8B6Hj0jBO;C7Hk0jBP,sB6Hj0jBqB;A7Hk0jBtB;AACA;;CAEC,0C6HryjBQ;A7HsyjBT;AACA;;;;;;CAMC,sB6Hh0jBkB;A7Hi0jBnB;AACA;;CAEC,2C6H30jBW;A7H40jBZ;AACA;;CAEC,2C6H7zjBqB;A7H8zjBtB;AACA;;CAEC,gD6H1zjBY;C7H2zjBZ,sB6Hl7jBG;A7Hm7jBJ;AACA;;CAEC,sB6HvzjBY;A7HwzjBb;AACA;;CAEC,2B6HtzjBiB;A7HuzjBlB;AACA;;CAEC,yF6HtzjB0B;A7HuzjB3B;AACA;;CAEC,W6HpzjBS;A7HqzjBV;AACA;;CAEC,W6H/8jBD;A7Hg9jBA;AACA;;CAEC,WAAW;A6H3yjBZ;A7H6yjBA;;CAEC,yB6H5yjBmB;A7H6yjBpB;AACA;;CAEC,W6H5yjBa;A7H6yjBd;;AAEA;;CAEC,qB6HpyjBI;C7HqyjBJ;;;;;M6HhyjBO;A7HsyjBR;AACA;;CAEC,qB6HryjBiB;A7HsyjBlB;AACA;;C6H/xjBA,2BAAU;A7HkyjBV;AACA;;CAEC,8B6H3xjBY;A7H4xjBb;AACA;;C6HlxjBI,oCAA0B;A7HqxjB9B;AACA;;C6HlxjBI,iDAA2B;A7HqxjB/B;AACA;;;;;;;CAOC,W6H/wjBwB;A7HgxjBzB;AACA;;C6HryjBA,WAAA;A7HwyjBA;AACA;;CAEC,W6H7wjBmB;A7H8wjBpB;AACA;;;;;;;;;;CAUC,yB6H9sjBA;A7H+sjBD;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAoCC,gD6HlvjBiB;A7HmvjBlB;AACA;;;;;;CAMC,WAAW;AACZ;AACA;;;;;;;CAOC,8B6H9ujBY;C7H+ujBZ,+B6H7ujBE;A7H8ujBH;AACA;;;;;;;;;;;;CAYC,gB8Hx/kBkB;C9Hy/kBlB,kCAAkC;C8Hp/kBnC,sBAAuB;A9Hs/kBvB;AACA;;;;;;;;;;;;;;CAcC,8B8H/+kBS;C9Hg/kBT,sB8H/+kBgB;A9Hg/kBjB;AACA;;CAEC,0C8Ht+kBC;A9Hu+kBF;AACA;;;;;;CAMC,sB8H3+kBY;A9H4+kBb;AACA;;CAEC,2C8Hz9kBA;A9H09kBD;AACA;;CAEC,2C8Hv+kBI;A9Hw+kBL;AACA;;CAEC,gD8Hp+kB2B;C9Hq+kB3B,sB8Hp+kBgB;A9Hq+kBjB;A8Hl+kBA;;C9Hq+kBC,sB8Hp+kBG;A9Hq+kBJ;AACA;;CAEC,2B8Hl+kBiC;A9Hm+kBlC;AACA;;CAEC,yF8Hl+kB4B;A9Hm+kB7B;AACA;;CAEC,W8Hl+kBmB;A9Hm+kBpB;AACA;;CAEC,W8Hr/kBD;A9Hs/kBA;AACA;;CAEC,W8H99kBmB;A9H+9kBpB;AACA;;CAEC,yB8H99kB6B;A9H+9kB9B;AACA;;C8Hv9kBA,WAAY;A9H09kBZ;;AAEA;;CAEC,qB8Hv9kB0B;C9Hw9kB1B;;;;;M8Hj9kBe;A9Hu9kBhB;AACA;;CAEC,qB8Ht9kBgB;A9Hu9kBjB;A8HzilBA;;C9H4ilBC,2BG5klByB;AH6klB1B;AACA;;CAEC,8B8Hl9kBc;A9Hm9kBf;AACA;;CAEC,oC8H58kBC;A9H68kBF;AACA;;CAEC,iD8Hl9kBG;A9Hm9kBJ;A8H98kBA;;;;;;;C9Hs9kBC,W8H98kBC;A9H+8kBF;AACA;;CAEC,W8H98kBC;A9H+8kBF;AACA;;CAEC,W8H98kBC;A9H+8kBF;AACA;;;;;;;;;;CAUC,yB8Hz8kBoB;A9H08kBrB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAoCC,gD+HjolB2B;A/HkolB5B;AACA;;;;;;CAMC,W+HholB0B;A/HiolB3B;AACA;;;;;;;CAOC,8BsBlrlBW;CtBmrlBX,+B+H5nlBmC;A/H6nlBpC;AACA;;;;;;;;;;;;CAYC,gB+H1nlB2B;C/H2nlB3B,kC+H1nlB8C;C/H2nlB9C,sB+H1nlB8C;A/H2nlB/C;AACA;;;;;;;;;;;;;;CAcC,8BAA8B;C+H7tlB/B,sBAiHI;A/H8mlBJ;AACA;;CAEC,0C+HxjlBY;A/HyjlBb;AACA;;;;;;CAMC,sB+HznlBG;A/H0nlBJ;AACA;;CAEC,2CsB3ulBQ;AtB4ulBT;AACA;;CAEC,2C+HrmlBoC;A/HsmlBrC;AACA;;CAEC,gD+HrolBG;C/HsolBH,sB+HpmlByC;A/HqmlB1C;AACA;;CAEC,sB+H1olBG;A/H2olBJ;AACA;;CAEC,2B+HhmlBuC;A/HimlBxC;AACA;;CAEC,yF+H/llBsC;A/HgmlBvC;AACA;;CAEC,W+HtllBG;A/HullBJ;AACA;;CAEC,W+HlllBW;A/HmllBZ;AACA;;CAEC,WsBjtlBM;AtBktlBP;AACA;;CAEC,yB+H5klBuC;A/H6klBxC;AACA;;CAEC,W+HvmlBD;A/HwmlBA;;A+HjklBA;;C/HqklBC,qB+HnklBkB;C/HoklBlB;;;;;M+H5jlBO;A/HkklBR;AACA;;CAEC,qB+HhklBQ;A/HiklBT;AgIrylBA;;ChIwylBC,2BAA2B;AgIrylB1B;AhIuylBF;;CgIpylBE,8BAAoB;AhIuylBtB;AACA;;CAEC,oCgIrylBE;AhIsylBH;AgIrylBE;;ChIwylBD,iDAAiD;AgIrylBhD;AhIuylBF;;;;;;;CgI/xlBE,WAAU;AhIuylBZ;AACA;;CgIpylBE,WAAU;AACV;AACA;;ChIwylBD,WAAW;AgIrylBV;AACA;;;;;;;;;;ChIgzlBD,yBAAyB;AgIrylBxB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;ChI00lBD,gDgItylBa;AhIuylBd;AACA;;;;;;CAMC,WgItylBa;AhIuylBd;AACA;;;;;;;CgI1xlBE,8BACY;ChIiylBb,+BgI/xlBI;AhIgylBL;AgInylBE;;;;;;;;;;;;ChIgzlBD,gBiIx5lBW;CjIy5lBX,kCAAkC;CiIt5lBnC,sBAAmB;AjIw5lBnB;AACA;;;;;;;;;;;;;;CAcC,8BAA8B;CiI74lB/B,sBAAe;AACf;AACA;;CjIg5lBC,0CAA0C;AiI54lB3C;AjI84lBA;;;;;;CAMC,sBAAsB;AiI34lBvB;AjI64lBA;;CiI14lBA,2CAAM;AjI64lBN;AACA;;CAEC,2CiI34lBA;AjI44lBD;AiIz4lBA;;CAEA,gDAAiB;CjI24lBhB,sBiI14lBW;AjI24lBZ;AiIv4lBA;;CjI04lBC,sBAAsB;AiIv4lBvB;AjIy4lBA;;CAEC,2BiIv4lBA;AjIw4lBD;AACA;;CAEC,yFiIt4lBC;AjIu4lBF;AACA;;CAEC,WiIn5lBD;AjIo5lBA;AACA;;CAEC,WiIv5lBD;AjIw5lBA;AACA;;CAEC,WiIp4lBM;AjIq4lBP;AkI99lBA;;ClIi+lBC,yBAAyB;AkI99lB1B;AlIg+lBA;;CkI59lBC,WAAI;AACJ;;AAED;;ClIg+lBC,qBkI/9lB8B;ClIg+lB9B;;;;;MmIr+lBG;AnI2+lBJ;AACA;;CAEC,qBmI1+lBuB;AnI2+lBxB;AmIz+lBE;;CnI4+lBD,2BmI1+lB2B;AnI2+lB5B;AmIz+lBE;;CnI4+lBD,8BmI1+lBsB;AnI2+lBvB;AACA;;CAEC,oCsBr/lBW;AtBs/lBZ;AACA;;CmIt+lBA,iDAAa;AnIy+lBb;AACA;;;;;;;CoIvgmBA,WAAA;ApI+gmBA;AACA;;CAEC,WsBvgmBO;AtBwgmBR;AoI5gmBA;;CpI+gmBC,WoI7gmBQ;ApI8gmBT;AACA;;;;;;;;;;CoIjgmBA,yBAAa;ApI4gmBb;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CqIvhmBA,gDAIU;AAHV;AACA;;;;;;CrIikmBC,WAAW;AsIhlmBZ;AtIklmBA;;;;;;;CAOC,8BsI/kmBI;CtIglmBJ,+BsI9kmBO;AtI+kmBR;AACA;;;;;;;;;;;;CAYC,gBAAgB;CuI3lmBjB,kCAAiB;CvI6lmBhB,sBuI5lmBoB;AvI6lmBrB;AACA;;;;;;;;;;;;;;CAcC,8BuIxlmBc;CvIylmBd,sBuIvlmBA;AvIwlmBD;AuItlmBA;;CvIylmBC,0CuItlmBA;AvIulmBD;AuIrlmBA;;;;;;CvI4lmBC,sBAAsB;AuIvjmBvB;AvIyjmBA;;CAEC,2CuIxjmBW;AvIyjmBZ;AACA;;CAEC,2CuIxjmBU;AvIyjmBX;AACA;;CAEC,gDuIvjmBI;CvIwjmBJ,sBAAsB;AuIrjmBvB;AvIujmBA;;CAEC,sBsB7omBW;AtB8omBZ;AACA;;CuInjmBA,2BAA0B;AvIsjmB1B;AACA;;CAEC,yFAAyF;AuInjmB1F;AACA;;CvIsjmBC,WuIpjmBG;AvIqjmBJ;AACA;;CAEC,WAAW;AuI/imBZ;AvIijmBA;;CAEC,WuIhjmBG;AvIijmBJ;AACA;;CuI7imBA,yBAAA;AvIgjmBA;AACA;;CuI3imBA,WAAA;AvI8imBA;;AAEA;;CAEC,qBuI3imBsB;CvI4imBtB;;;;;MuIrimBO;AvI2imBR;AACA;;CAEC,qBAAqB;AuItimBtB;AvIwimBA;;CAEC,2BuIvimBwB;AvIwimBzB;AACA;;CAEC,8BAA8B;AuInimB/B;AvIqimBA;;CAEC,oCAAoC;AuIlimBrC;AvIoimBA;;CAEC,iDuInimBuC;AvIoimBxC;AACA;;;;;;;CuIxhmBA,WAAA;AvIgimBA;AACA;;CAEC,WuI9hmBO;AvI+hmBR;AGtsmBE;;CHysmBD,WuI3hmBkB;AvI4hmBnB;AACA;;;;;;;;;;CAUC,yBwI7umBA;AxI8umBD;AyB7umBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CgHuCA,gDAKE;AzIuumBF;AACA;;;;;;CyI9umBA,WAAA;AzIqvmBA;AACA;;;;;;;CyItvmBA,8BAoBC;CAnBD,+BAmBC;AzI2umBD;AACA;;;;;;;;;;;;CyI/vmBA,gBAAA;CzI4wmBC,kCyIpumBE;CzIqumBF,sBAAsB;AACvB;AACA;;;;;;;;;;;;;;CyI/tmBA,8BAaC;CAZD,sBAAoB;AzI8umBpB;AACA;;CyI/umBA,0CAYgB;AzIsumBhB;AACA;;;;;;CAMC,sBAAsB;AACvB;AACA;;CAEC,2CC9umBkB;AD+umBnB;AACA;;CyI/vmBA,2CAgCiB;AzIkumBjB;AACA;;CyInwmBA,gDAoCE;CzIkumBD,sByIjumBmB;AzIkumBpB;AACA;;CyIzwmBA,sBAAoB;AzI4wmBpB;AACA;;CyI7wmBA,2BAAC;AzIgxmBD;AACA;;CAEC,yFyIhumBE;AzIiumBH;AgCn0mBA;;ChCs0mBC,WyI7tmBA;AzI8tmBD;AACA;;CAEC,WyI7tmBA;AzI8tmBD;AyI5tmBA;;CzI+tmBC,WyI7tmBS;AzI8tmBV;AyI5tmBA;;CzI+tmBC,yByI5tmBA;AzI6tmBD;AyI5tmBA;;CzI+tmBC,WyI5tmBG;AzI6tmBJ;;AAEA;;CAEC,qByI3tmBc;CzI4tmBd;;;;;MyIntmBQ;AzIytmBT;AACA;;CAEC,qBAAqB;AyIrtmBtB;AzIutmBA;;CyB/4mBA,2BAAA;AzBk5mBA;AACA;;CyIxsmBA,8BAAU;AzI2smBV;AACA;;CAEC,oCsBx4mBa;AtBy4mBd;AACA;;CAEC,iDyI9rmBA;AzI+rmBD;AACA;;;;;;;CAOC,WyIntmBD;AzIotmBA;AACA;;CAEC,WyI/smBQ;AzIgtmBT;AACA;;CAEC,WyIjsmBA;AzIksmBD;AyI/rmBA;;;;;;;;;;CzI0smBC,yByI9rmBwB;AzI+rmBzB;AyI3smBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CzIgvmBC,gDAAgD;AyBp1mBjD;AzBs1mBA;;;;;;CyI/qmBA,WAAK;AzIsrmBL;AACA;;;;;;;CyIzqmBA,8BAAiB;CzIirmBhB,+ByI/qmBA;AzIgrmBD;AyI/qmBA;;;;;;;;;;;;CzI4rmBC,gBAAgB;C4Er8mBT,kC6DsRC;CzIirmBR,sByIhrmBqB;AzIirmBtB;AyI/qmBA;;;;;;;;;;;;;;CzI8rmBC,8ByI5qmBA;CzI6qmBA,sBAAsB;AyI5qmBvB;AzI8qmBA;;CAEC,0CAA0C;AyI3qmB3C;AzI6qmBA;;;;;;CAMC,sByI3qmBA;AzI4qmBD;AACA;;CAEC,2CyI3qmBkC;AzI4qmBnC;AACA;;CAEC,2CCx7mBU;ADy7mBX;AACA;;CAEC,gDCx7mBiB;CDy7mBjB,sBCx7mBgB;ADy7mBjB;AACA;;CAEC,sBCx7mBgB;ADy7mBjB;AACA;;CAEC,2BCx7mBkB;ADy7mBnB;AACA;;CAEC,yFCx7mBmB;ADy7mBpB;AACA;;CAEC,WCx7mBA;ADy7mBD;AACA;;CAEC,WCx7mBA;ADy7mBD;AACA;;CAEC,W0ItknBG;A1IuknBJ;AACA;;CAEC,yB0IrknBc;A1IsknBf;A0IxknBA;;C1I2knBC,WAAW;A0I3knBZ;;A1I8knBA;;CAEC,qB0I5jnBqB;C1I6jnBrB;;;;;MyBllnBD;AzBwlnBA;AACA;;CAEC,qB0IxjnBY;A1IyjnBb;AACA;;CAEC,2B0IxjnBqB;A1IyjnBtB;AACA;;CAEC,8B0ItjnB0B;A1IujnB3B;AACA;;CAEC,oC0IpjnBA;A1IqjnBD;A0IjjnBA;;C1IojnBC,iD0IljnBiB;A1ImjnBlB;AACA;;;;;;;CAOC,W0IljnBC;A1ImjnBF;AACA;;CAEC,WG5inBA;AH6inBD;AACA;;CAEC,W0IrknBD;A1IsknBA;AACA;;;;;;;;;;CAUC,yB0IhjnBoB;A1IijnBrB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAoCC,gD0IrinBC;A1IsinBF;A0IpinBA;;;;;;C1I2inBC,W0IlinBS;A1IminBV;A0I/hnBE;;;;;;;C1IuinBD,8B0I7hnBG;C1I8hnBH,+BAA+B;A0I3hnB9B;A1I6hnBF;;;;;;;;;;;;CAYC,gBAAgB;C0I5hnBf,kCACiB;C1I6hnBlB,sBC1mnBW;AD2mnBZ;AACA;;;;;;;;;;;;;;CAcC,8BAA8B;C0IphnB7B,sBACA;A1IqhnBF;AACA;;C0IngnBA,0CAAa;A1IsgnBb;AACA;;;;;;CAMC,sB0IpgnBe;A1IqgnBhB;AACA;;CAEC,2C0IngnBE;A1IognBH;AACA;;C2IvvnBA,2CACgC;A3IyvnBhC;AACA;;C6B3unBA,gD8GTW;C3IuvnBV,sB2ItvnBmB;A3IuvnBpB;AACA;;CAEC,sB2ItvnBe;A3IuvnBhB;AACA;;CAEC,2B2ItvnBgB;A3IuvnBjB;AACA;;CAEC,yF2ItvnBsB;A3IuvnBvB;AACA;;CAEC,W2IxwnBD;A3IywnBA;AACA;;CAEC,W2InvnBC;A3IovnBF;A6BnwnBA;;C7BswnBC,W2InvnBC;A3IovnBF;AACA;;CAEC,yB2InvnBkB;A3IovnBnB;AACA;;CAEC,W2InvnBO;A3IovnBR;;AAEA;;CAEC,qBCxrnBW;CDyrnBX;;;;;MAKK;A2I1unBJ;A3I4unBF;;C2I5unBE,qBACA;A3I8unBF;AACA;;CAEC,2BAA2B;A2IrunB1B;A3IuunBF;;C2IvunBE,8BACA;A3IyunBF;AACA;;CAEC,oCAAoC;A2IhunBnC;A3IkunBF;;C2IlunBE,iDAKgB;A3IgunBlB;AACA;;;;;;;CAOC,W2I1tnBG;A3I2tnBJ;AACA;;C2IrtnBE,WAAA;A3IwtnBF;AACA;;CAEC,W2IrtnBG;A3IstnBJ;AACA;;;;;;;;;;CAUC,yBAAyB;A4I11nB1B;A5I41nBA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAoCC,gD4I5ynBY;A5I6ynBb;AACA;;;;;;CAMC,W4Ip1nBI;A5Iq1nBL;AACA;;;;;;;CAOC,8B6Iz4nBI;C7I04nBJ,+BAA+B;A6Iv4nBhC;A7Iy4nBA;;;;;;;;;;;;CAYC,gBCtznBkB;CDuznBlB,kCAAkC;C6Iz3nBnC,sBACI;A7I03nBJ;AACA;;;;;;;;;;;;;;CAcC,8B8I56nBA;C9I66nBA,sBAAsB;A8I/6nBvB;A9Ii7nBA;;CAEC,0C8I56nBqB;A9I66nBtB;AACA;;;;;;CAMC,sBAAsB;A8I16nBvB;A9I46nBA;;C8Iv6nBA,2CAAqB;A9I06nBrB;AACA;;CAEC,2C8Iz6nBwB;A9I06nBzB;AACA;;CAEC,gD8Ih6nBI;C9Ii6nBJ,sB8Iv6nBK;A9Iw6nBN;AACA;;CAEC,sB8Il6nByB;A9Im6nB1B;AACA;;CAEC,2BsBz8nBW;AtB08nBZ;AACA;;CAEC,yF8I75nB2B;A9I85nB5B;AACA;;CAEC,W8I75nBW;A9I85nBZ;AACA;;CAEC,W8I55nBc;A9I65nBf;AACA;;CAEC,WsB56nBS;AtB66nBV;AACA;;C8In7nBA,yBAiCa;A9Iq5nBb;AACA;;CAEC,WsBj+nBO;AtBk+nBR;;AAEA;;CAEC,qBsBt3nBW;CtBu3nBX;;;;;MAKK;A8Ip8nBN;A9Is8nBA;;CAEC,qB8I95nBS;A9I+5nBV;AACA;;C8I18nBA,2BAmEiB;A9I04nBjB;AACA;;CAEC,8B8Iz4nBuB;A9I04nBxB;A8Ij9nBA;;C9Io9nBC,oC8Ix4nBQ;A9Iy4nBT;A8In4nBI;;C9Is4nBH,iDAAiD;A8Il4nB9C;A9Io4nBJ;;;;;;;CAOC,W8Ih4nBY;A9Ii4nBb;A8I/3nBA;;C9Ik4nBC,W8Ih4nBY;A9Ii4nBb;A8I/3nBA;;C9Ik4nBC,WAAW;AgCl9nBZ;AACA;;;;;;;;;;ChC69nBC,yBAAyB;AgCv+nB1B;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;ChC4goBC,gDAAgD;A8I35nBjD;A9I65nBA;;;;;;CAMC,WAAW;A8In6nBZ;A9Iq6nBA;;;;;;;C8Iv2nBA,8BACQ;C9I82nBP,+B8I52nBI;A9I62nBL;A8Ih3nBA;;;;;;;;;;;;C9I63nBC,gB+IjmoBC;C/IkmoBD,kC+IjmoBc;C/IkmoBd,sB+IjmoBsB;A/IkmoBvB;AACA;;;;;;;;;;;;;;CAcC,8B+IxloBgB;C/IyloBhB,sB+IxloBqB;A/IyloBtB;AACA;;CAEC,0CgJlooBA;AhJmooBD;AgJjooBA;;;;;;ChJwooBC,sBsBxnoBa;AtBynoBd;AACA;;CAEC,2CAA2C;AgJ7noB5C;AACA;;ChJgooBC,2CgJ9noBsB;AhJ+noBvB;AACA;;CAEC,gDAAgD;CgJ5noBjD,sBAAA;AhJ8noBA;AACA;;CAEC,sBgJ5noBA;AhJ6noBD;AgJ3noBA;;ChJ8noBC,2BgJ1noBA;AhJ2noBD;AgJznoBA;;ChJ4noBC,yFAAyF;AgJxnoB1F;AhJ0noBA;;CgJtnoBA,WAAA;AhJynoBA;AACA;;CAEC,WAAW;AgJvnoBZ;AhJynoBA;;CAEC,WAAW;AgJvnoBZ;AhJynoBA;;CAEC,yBsB3joBmB;AtB4joBpB;AACA;;CAEC,WgJxnoBC;AhJynoBF;;AAEA;;CAEC,qBgJtnoBO;ChJunoBP;;;;;MgJhnoBC;AhJsnoBF;AgJnnoBA;;ChJsnoBC,qBAAqB;AgJnnoBtB;AhJqnoBA;;CCzloBA,2BAAK;AD4loBL;AACA;;CAEC,8BC3loBe;AD4loBhB;AACA;;CAEC,oCC3loBgB;AD4loBjB;AACA;;CAEC,iDC3loBiB;AD4loBlB;AACA;;;;;;;CAOC,WC3loBA;AD4loBD;AACA;;CAEC,WC3loBA;AD4loBD;AACA;;CGtuoBA,WAAA;AHyuoBA;AACA;;;;;;;;;;CAUC,yBiJhvoBW;AjJivoBZ;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAoCC,gDiJtuoBI;AjJuuoBL;AACA;;;;;;CAMC,WiJhyoBD;AjJiyoBA;AACA;;;;;;;CAOC,8BiJltoBiC;CjJmtoBjC,+BiJltoBuB;AjJmtoBxB;AACA;;;;;;;;;;;;CAYC,gBiJhtoB0B;CjJitoB1B,kCiJhtoBoC;CjJitoBpC,sBiJhtoB6B;AjJitoB9B;AACA;;;;;;;;;;;;;;CAcC,8BiJtsoBY;CjJusoBZ,sBiJtsoBkB;AjJusoBnB;AACA;;CAEC,0CiJjsoBY;AjJksoBb;AACA;;;;;;CAMC,sBiJrroBC;AjJsroBF;AACA;;CAEC,2CiJproBC;AjJqroBF;AACA;;CkJj2oBA,2CACG;AlJm2oBH;AACA;;CAEC,gDAAgD;CkJv2oBjD,sBAQI;AlJi2oBJ;AACA;;CAEC,sBmJ12oBA;AnJ22oBD;AoJ72oBA;;CpJg3oBC,2BAA2B;AoJ52oB5B;ApJ82oBA;;CAEC,yFoJ72oB2B;ApJ82oB5B;AACA;;CAEC,WAAW;AG5zoBJ;AH8zoBR;;CAEC,WoJ32oBW;ApJ42oBZ;AACA;;CqJ93oBA,WAAA;AACA;ArJi4oBA;;CAEC,yBqJh4oBwB;ArJi4oBzB;AACA;;CqJ73oBA,WAAA;ArJg4oBA;;AqJ53oBA;;CrJg4oBC,mBGl3oBmB;AHm3oBpB;AACA;;CAEC,gCqJp4oBgB;ArJq4oBjB;AACA;;CAEC,SsJp5oBW;AtJq5oBZ;AsJl5oBA;;CtJq5oBC,WAAW;AsJj5oBZ;AtJm5oBA;;CAEC,UsJr5oBQ;AtJs5oBT;AACA;;CAEC;;;;QuJ75oBC;AvJk6oBF;AACA;;CAEC,yBuJh6oBa;CvJi6oBb,qBuJv6oBE;AvJw6oBH;AACA;;CAEC,UuJ55oBG;AvJ65oBJ;AACA;;CAEC,UuJl7oBD;AvJm7oBA;AACA;;;;CAIC,UuJn5oBG;AvJo5oBJ;AACA;;;;;;CAMC,YC70oBS;AD80oBV;AACA;;CAEC,oBC70oBgB;AD80oBjB;AACA;;CAEC,WC70oBA;AD80oBD;AACA;;CAEC,oCC70oBgB;AD80oBjB;AACA;;CAEC,gCC70oBkB;AD80oBnB;AACA;;CAEC,sBC70oBkB;CD80oBlB,gCC70oBkB;AD80oBnB;AACA;;CAEC,iCC70oBmB;AD80oBpB;;AwJx9oBA;;CxJ49oBC,mBwJ59oBa;AxJ69oBd;AACA;;CC92oBA,gCAAK;ADi3oBL;AACA;;CAEC,SCh3oBA;ADi3oBD;AACA;;CAEC,WCh3oBA;ADi3oBD;AACA;;CAEC,UCh3oBA;ADi3oBD;AACA;;CAEC;;;;QC52oBA;ADi3oBD;AACA;;CAEC,yBCh3oBmB;CDi3oBnB,qBCh3oBkB;ADi3oBnB;AACA;;CyJ3/oBA,UAAA;AzJ8/oBA;AACA;;CAEC,UyJ7/oBG;AzJ8/oBJ;AACA;;;;CAIC,UyJ5/oBO;AzJ6/oBR;AACA;;;;;;CAMC,YyJz/oBO;AzJ0/oBR;AACA;;CCj6oBA,oBAAK;ADo6oBL;AACA;;CAEC,WCn6oBA;ADo6oBD;AACA;;CAEC,oCCn6oBgB;ADo6oBjB;AACA;;CAEC,gCCn6oBgB;ADo6oBjB;AACA;;CAEC,sBCn6oBkB;CDo6oBlB,gCCn6oBkB;ADo6oBnB;AACA;;CAEC,iCCn6oBkB;ADo6oBnB;;AAEA;;CAEC,mBCn6oBA;ADo6oBD;AACA;;CAEC,gC0JxhpBA;A1JyhpBD;AACA;;CAEC,S0JzipBY;A1J0ipBb;AACA;;CAEC,W0JxipBiB;A1JyipBlB;AACA;;CAEC,UAAU;A2J7jpBX;A3J+jpBA;;CAEC;;;;Q2JxjpBY;A3J6jpBb;AACA;;CAEC,yB2J3jpB2B;C3J4jpB3B,qB2J3jpBwB;A3J4jpBzB;AACA;;CAEC,U2J1jpBgB;A3J2jpBjB;AACA;;CAEC,UAAU;A2JllpBX;A3JolpBA;;;;CAIC,UCv+oBS;ADw+oBV;AACA;;;;;;CAMC,YCv+oBA;ADw+oBD;AACA;;CAEC,oBCv+oBgB;ADw+oBjB;AACA;;CAEC,WCv+oBA;ADw+oBD;AACA;;CAEC,oCCv+oBkB;ADw+oBnB;AACA;;CAEC,gCCv+oBkB;ADw+oBnB;AACA;;C4JhnpBA,sBAAa;C5JmnpBZ,gC4JlnpB4B;A5JmnpB7B;AACA;;CAEC,iC4JjnpBmC;A5JknpBpC;;AAEA;;CAEC,mB4JvnpBY;A5JwnpBb;AACA;;CAEC,gC4JxmpBe;A5JympBhB;AACA;;CAEC,S4JtmpBU;A5JumpBX;A4JpmpBA;;C5JumpBC,W4JrmpBQ;A5JsmpBT;AACA;;CAEC,U4JpmpBW;A5JqmpBZ;AACA;;CAEC;;;;QAIO;A4JjmpBR;A5JmmpBA;;CAEC,yBAAyB;C4JjmpB1B,qBAAiB;A5JmmpBjB;AACA;;C4JhmpBA,UAAS;A5JmmpBT;AACA;;CAEC,U4JlmpBQ;A5JmmpBT;A4JjmpBA;;;;C5JsmpBC,U4J5lpBmB;A5J6lpBpB;AACA;;;;;;CAMC,Y4J1lpBqB;A5J2lpBtB;A4J1mpBA;;C5J6mpBC,oBAAoB;A4J7mpBrB;A5J+mpBA;;CAEC,W4JtlpBc;A5JulpBf;AACA;;CAEC,oC4JtlpBqC;A5JulpBtC;AACA;;C4JllpBA,gCAAiB;A5JqlpBjB;AACA;;CAEC,sB6JnspBA;C7JospBA,gCAAgC;A6J/rpBjC;A7JispBA;;CAEC,iC6JhspB2B;A7JispB5B;;AAEA;;C6J9rpBA,mBAAiB;A7JispBjB;AACA;;C6JnrpBA,gCAAmB;A7JsrpBnB;AACA;;C6JnrpBA,SAAA;A7JsrpBA;AACA;;CAEC,W6JrrpBA;A7JsrpBD;AACA;;CAEC,U8JhupBG;A9JiupBJ;AACA;;CAEC;;;;QAIO;A8J1tpBR;A9J4tpBA;;CAEC,yBAAyB;C8JztpB1B,qBAAkB;A9J2tpBlB;AACA;;C8JvtpBA,UAAA;A9J0tpBA;AACA;;CAEC,U8JxtpBW;A9JytpBZ;A+JvvpBA;;;;CAKE,UAAA;A/JwvpBF;AACA;;;;;;C+J/upBE,YAAA;A/JsvpBF;AACA;;CAEC,oB+JjupBE;A/JkupBH;AACA;;CAEC,W+JpvpBY;A/JqvpBb;AACA;;CAEC,oC+JlvpBa;A/JmvpBd;AACA;;CAEC,gC+JhvpBa;A/JivpBd;AACA;;CAEC,sB+J9upBqB;C/J+upBrB,gC+J9upBa;A/J+upBd;AACA;;CAEC,iC+J9upBmC;A/J+upBpC;;A+J3upBE;;C/J+upBD,mB+J7upBa;A/J8upBd;AACA;;CAEC,gC+J7upBc;A/J8upBf;AACA;;CAEC,S+J7upBG;A/J8upBJ;A+J3upBE;;C/J8upBD,W+J5upBY;A/J6upBb;AACA;;CAEC,U+J5upBG;A/J6upBJ;AACA;;CAEC;;;;Q+JvupBK;A/J4upBN;AACA;;CAEC,yB+J3upBuB;C/J4upBvB,qB+J3upBmB;A/J4upBpB;AACA;;CAEC,U+J3upBK;A/J4upBN;AACA;;CAEC,UAAU;A+JhupBT;A/JkupBF;;;;CAIC,UAAU;A+J7tpBT;A/J+tpBF;;;;;;CAMC,Y+J7tpBc;A/J8tpBf;AACA;;CAEC,oB+J7tpBiB;A/J8tpBlB;AACA;;CAEC,W+JzupBC;A/J0upBF;AACA;;CAEC,oC+J5tpBgB;A/J6tpBjB;AACA;;CAEC,gC+JjvpB2B;A/JkvpB5B;AACA;;CAEC,sB+JxtpBU;C/JytpBV,gC+JxtpB+B;A/JytpBhC;A+JttpBE;;C/JytpBD,iCAAiC;A+JrtpBhC;;A/JwtpBF;;CAEC,mB+J1tpBC;A/J2tpBF;AACA;;CAEC,gC+JjtpBqB;A/JktpBtB;AACA;;CAEC,SAAS;A+J/spBR;A/JitpBF;;CAEC,W+JhtpBU;A/JitpBX;AACA;;CAEC,U+JhtpBY;A/JitpBb;AACA;;CAEC;;;;Q+J3spBG;A/JgtpBJ;AACA;;C+J5spBE,yBAAA;C/J+spBD,qB+J9spBmB;A/J+spBpB;A+J5spBE;;C/J+spBD,U+J7spBG;A/J8spBJ;A+J3spBE;;C/J8spBD,U+J5spBG;A/J6spBJ;A+J1spBE;;;;C/J+spBD,U+J1spBU;A/J2spBX;AACA;;;;;;CAMC,Y+JzspBW;A/J0spBZ;AACA;;C+JpspBE,oBAAA;A/JuspBF;AACA;;CAEC,W+JpspBO;A/JqspBR;AACA;;C+JhspBE,oCAAU;A/JmspBZ;AACA;;CAEC,gC+JhspBO;A/JispBR;AACA;;CgKv7pBI,sBAAU;ChK07pBb,gCgKz7pByB;AhK07pB1B;AgKv7pBI;;ChK07pBH,iCAAiC;AgKt7pB9B;;AhKy7pBJ;;CAEC,mBCv1pBW;ADw1pBZ;AgKn7pBA;;ChKs7pBC,gCsB70pBmB;AtB80pBpB;AACA;;CAEC,SgKj7pBe;AhKk7pBhB;AACA;;CAEC,WgK97pBD;AhK+7pBA;AACA;;CAEC,UgK76pBO;AhK86pBR;AACA;;CAEC;;;;QgKv6pBO;AhK46pBR;AACA;;CgKt6pBA,yBAAgB;ChKy6pBf,qBgKx6pBU;AhKy6pBX;AACA;;CAEC,UgKx6pBA;AhKy6pBD;AgKv6pBA;;ChK06pBC,UAAU;AACX;AACA;;;;CiK1+pBA,UAAW;AACX;AACA;;;;;;CAIA,YAGC;AAHD;AjKk/pBA;;CiK1+pBA,oBAAe;AACf;AjK6+pBA;;CiK1+pBA,WAAY;AjK6+pBZ;AACA;;CiK1+pBA,oCAAoB;AACpB;AACA;;CjK8+pBC,gCiK3+pBA;AjK4+pBD;AiK3+pBA;;CjK8+pBC,sBAAsB;CiKt+pBvB,gCAAS;AjKw+pBT;AACA;;CqJ7gqBA,iCaCA;AlK+gqBA;;AAEA;;CAEC,mBkK9gqBe;AlK+gqBhB;AACA;;CAEC,gCkK9gqBgB;AlK+gqBjB;AACA;;CAEC,SkK9gqBA;AlK+gqBD;AkK7gqBA;;ClKghqBC,WAAW;AqJxhqBZ;ArJ0hqBA;;CmK9gqBA,UAAW;AACX;AACA;;CAEA;;;;QnKohqBQ;AmK9gqBR;AACA;;CnKihqBC,yBmK/gqBqB;CnKghqBrB,qBmK9gqBA;AnK+gqBD;AmK7gqBA;;CnKghqBC,UmK9gqBU;AnK+gqBX;AmK5gqBA;;CnK+gqBC,UmK7gqBW;AnK8gqBZ;AmK3gqBA;;;;CAKA,UAAA;AnK4gqBA;AACA;;;;;;CmKngqBA,YAAA;AnK0gqBA;AACA;;CAEC,oBmKxgqBqB;AnKygqBtB;AACA;;CAEC,WmKvgqBa;AnKwgqBd;AACA;;CmKrgqBA,oCAEyB;AAFzB;AAAA;;CAAA,gCAMmB;AnKsgqBnB;AACA;;CoKzlqBA,sBACI;CpK2lqBH,gCoK1lqBiB;ApK2lqBlB;AACA;;CAEC,iCoKxlqBC;ApKylqBF;;AAEA;;CAEC,mBsB3+pBW;AtB4+pBZ;AACA;;CAEC,gCoKzlqBsB;ApK0lqBvB;AoK1mqBA;;CpK6mqBC,SAAS;AoK7mqBV;ApK+mqBA;;CAEC,WoKzlqBC;ApK0lqBF;AoKvlqBA;;CpK0lqBC,UAAU;AoKvlqBX;ApKylqBA;;CAEC;;;;QoK3lqBE;ApKgmqBH;AACA;;CoKtlqBA,yBAA0B;CpKylqBzB,qBCvnqBS;ADwnqBV;AoKtlqBA;;CpKylqBC,UAAU;AoKplqBX;AAAA;;CpKwlqBC,UGvmqBa;AHwmqBd;AACA;;;;CAIC,UoK9lqBD;ApK+lqBA;AACA;;;;;;CAMC,YqKxpqBU;ArKypqBX;AACA;;CAEC,oBqKvpqBA;ArKwpqBD;AqKvpqBA;;CrK0pqBC,WAAW;AqKvpqBZ;ArKypqBA;;CAEC,oCAAoC;AqKvpqBrC;ArKypqBA;;CAEC,gCqKxpqBmB;ArKypqBpB;AACA;;CAEC,sBqKzpqBe;CrK0pqBf,gCqKzpqBgB;ArK0pqBjB;AACA;;CAEC,iCqKvpqBA;ArKwpqBD;;AAEA;;CAEC,mBqKvpqBqB;ArKwpqBtB;AACA;;CAEC,gCAAgC;AqKrpqBjC;ArKupqBA;;CqKppqBA,SAAS;ArKupqBT;AACA;;CAEC,WqKjpqBC;ArKkpqBF;AqK9oqBA;;CrKipqBC,UqK/oqBQ;ArKgpqBT;AqK7oqBA;;CrKgpqBC;;;;QqKzoqBC;ArK8oqBF;AACA;;CAEC,yBqK7oqBe;CrK8oqBf,qBAAqB;AqK1oqBtB;ArK4oqBA;;CAEC,UqK3oqBA;ArK4oqBD;AqK1oqBA;;CrK6oqBC,UsBjtqBO;AtBktqBR;AqK1oqBA;;;;CrK+oqBC,UqK3oqBG;ArK4oqBJ;AACA;;;;;;C4H9mqBA,YAAA;A5HqnqBA;AACA;;CAEC,oBqKzoqBqB;ArK0oqBtB;AACA;;CqKpoqBA,WAAS;ArKuoqBT;AACA;;CAEC,oCqKroqBuB;ArKsoqBxB;AACA;;CAEC,gCqKtoqBc;ArKuoqBf;AACA;;CAEC,sBqKroqBmB;CrKsoqBnB,gCqKjoqBE;ArKkoqBH;AACA;;CAEC,iCqKloqBE;ArKmoqBH;;AAEA;;CAEC,mBAAmB;AGvvqBlB;AHyvqBF;;CAEC,gCqK3nqBE;ArK4nqBH;AACA;;CAEC,SqK3nqBE;ArK4nqBH;AACA;;CAEC,WqK1nqBS;ArK2nqBV;AACA;;C4ClxqBA,UAAA;A5CqxqBA;AACA;;CsKtxqBA;;;;QAkBG;AtK2wqBH;AACA;;CAEC,yBsK1xqBC;CtK2xqBD,qBsKzxqBe;AtK0xqBhB;AACA;;CAEC,UsKzxqBW;AtK0xqBZ;AACA;;CAEC,UAAU;AsKhxqBT;AtKkxqBF;;;;CAIC,UsKnwqBE;AtKowqBH;AACA;;;;;;CAMC,YsKtxqBG;AtKuxqBJ;AACA;;CAEC,oBCrzqBmB;ADszqBpB;AsKnyqBE;;CtKsyqBD,WsK9wqBqB;AtK+wqBtB;AACA;;CAEC,oCAAoC;AsK3wqBnC;AtK6wqBF;;CAEC,gCsBh0qBW;AtBi0qBZ;AACA;;CAEC,sBsB7yqBc;CtB8yqBd,gCsK/wqBiB;AtKgxqBlB;AACA;;CAEC,iCCvuqBkB;ADwuqBnB;;AAEA;;CAEC,mBsK3vqBE;AtK4vqBH;AACA;;CAEC,gCsK9wqBiB;AtK+wqBlB;AACA;;CAEC,SsK9wqBW;AtK+wqBZ;AACA;;CAEC,WAAW;AsK3xqBV;AtK6xqBF;;CAEC,UsKtwqBE;AtKuwqBH;AACA;;C4ChzqBA;;;;QAAA;A5CuzqBA;AACA;;CAEC,yBsK9vqBe;CtK+vqBf,qBsK9vqBe;AtK+vqBhB;A4Cn3qBA;;C5Cs3qBC,UsK1vqBe;AtK2vqBhB;AACA;;CAEC,UsK1vqBO;AtK2vqBR;AACA;;;;CAIC,UsBz3qBO;AtB03qBR;AACA;;;;;;CAMC,YsKtvqBe;AtKuvqBhB;AACA;;CAEC,oBsKjvqBmB;AtKkvqBpB;AACA;;CAEC,W4Ch5qBD;A5Ci5qBA;AACA;;CAEC,oCsKzuqBkB;AtK0uqBnB;AACA;;CAEC,gCsKxuqBa;AtKyuqBd;AACA;;CAEC,sBsKxuqBmB;CtKyuqBnB,gCsKtuqBkB;AtKuuqBnB;AACA;;CAEC,iCsK1tqBI;AtK2tqBL;;AAEA;;CsKxtqBK,mBACG;AtK0tqBR;AACA;;CAEC,gCsBnzqBW;AtBozqBZ;AACA;;CsKhuqBK,SAAA;AtKmuqBL;AACA;;CAEC,WsKxtqBE;AtKytqBH;AACA;;CAEC,UsKntqBW;AtKotqBZ;AACA;;CAEC;;;;QsKlsqBI;AtKusqBL;AACA;;CAEC,yBsK3rqBY;CtK4rqBZ,qBAAqB;AsKhsqBjB;AtKksqBL;;CAEC,UAAU;AsKtrqBN;AtKwrqBL;;CAEC,UsKrrqBI;AtKsrqBL;AACA;;;;CAIC,UsKnrqBqB;AtKorqBtB;AACA;;;;;;CsKlsqBK,YAAA;AtKysqBL;AACA;;CAEC,oBsKhrqBgB;AtKirqBjB;AACA;;CsK9sqBK,WAAA;AtKitqBL;AACA;;CAEC,oCsKpqqBG;AtKqqqBJ;AACA;;CsK7qqBK,gCAUQ;AtKsqqBb;AACA;;CAEC,sBsKpqqBiC;CtKqqqBjC,gCsKpqqBuB;AtKqqqBxB;AsKrrqBK;;CtKwrqBJ,iCsB3+qBW;AtB4+qBZ;;AAEA;CACC;EsK5rqBI,gBAAA;EAkCA;;KAEA;CtK6pqBJ;CACA;EACC,qBAAqB;EsKrpqBlB,cAAA;EAEO,6CAAyB;EAClC,gBAAgB;CtKspqBlB;CsKzpqBI;EAQA,iBAAA;CtKopqBJ;CACA;EsK7pqBI,mBAAU;CtK+pqBd;CACA;EACC,uBAAuB;CsKtgrBzB;CtKwgrBC;EACC,aAAa;CsKzgrBf;CtK2grBC;EACC,aAAa;CsK5grBf;CtK8grBC;EACC,aAAa;CsK/grBf;CtKihrBC;EsK1oqBI,4BhJnRO;CtB+5qBX;CsKnhrBD;EA4YK,4BhJxRO;EgJyRP,sBAAA;CtK0oqBJ;AsKvhrBD;;AtK0hrBA;CACC;EsKpoqBI,iBAAS;CtKsoqBb;AACD;;AAEA;CACC;EACC,iBsKnoqBc;CtKooqBf;AACD;;AsK7oqBK;CtKgpqBJ,qBsKhoqByB;AtKioqB1B;;AAEA;CACC,6BsKppqBI;AtKqpqBL;;AsK1nqBK;;CtK8nqBJ,iBC58qBW;AD68qBZ;;AsKpnqBK;CtKunqBJ,iBsKrnqBuB;AtKsnqBxB;;AsKhnqBK;CtKmnqBJ,6BsKjnqBmC;AtKknqBpC;;AsKpnqBK;CtKunqBJ,4BsKhnqBsC;AtKinqBvC;;AsK3mqBK;CtK8mqBJ,6BsK3mqBQ;AtK4mqBT;;AAEA;CACC,6BsKxmqB6B;AtKymqB9B;;AAEA;CACC,6BsK9mqBO;AtK+mqBR;;AAEA;CACC,6BsKtmqBG;AtKumqBJ;;AAEA;CACC,wBsKrmqB6B;AtKsmqB9B;;AsK/lqBA;CtKkmqBC,4BsKjmqBW;AtKkmqBZ;;AAEA;CACC,6BsKnlqBA;AtKolqBD;;AAEA;CACC,6BsKhmqBc;AtKimqBf;;AAEA;CACC,oBsK7lqBY;AtK8lqBb;;AAEA;CACC,4BsBh/qBmB;AtBi/qBpB;;AAEA;CACC,6BsKjmqBU;AtKkmqBX;;AAEA;CsKrmqBA,6BAgBa;AtKulqBb;;AsKvmqBA;;CtK2mqBC,gBsKtlqBa;AtKulqBd;;AAEA;;;CAGC,gBsKjlqBa;AtKklqBd;;AAEA;CACC,4BAA4B;CsK/kqB7B,iBAAA;AtKilqBA;;AAEA;CACC,4BAA4B;AiDnorB7B;;AjDsorBA;;CAEC,gBuK5orBK;AvK6orBN;;AAEA;CACC,UuKxorBC;CvKyorBD,qBAAqB;AuKtorBtB;;AvKyorBA;CuKtorBA,mBAAc;CvKworBb,4BuKtorBA;AvKuorBD;;AAEA;;;;;;CAMC,iBsBhorBiB;AtBiorBlB;;AiD5mrBE;CjD+mrBD,csBnorBe;CtBoorBf,esBporBe;AtBqorBhB;;AiDjnrBE;;CjDqnrBD,kBsBxorBe;AtByorBhB;;AiDtnrBE;;;CjD2nrBD,kBuKjorBA;AvKkorBD;;AAEA;CACC,UuKlorBG;CvKmorBH,qBuKjorBA;AvKkorBD;;AAEA;;;;;;CAMC,iBC/krBW;ADglrBZ;;AuK5nrBA;CvK+nrBC;;;;;IuKtnrBD;CvK4nrBC;;;;IAIG;AuKxnrBJ;AvK0nrBA;CACC,6BAA6B;AuKvnrB9B;AvKynrBA;CACC,6BAA6B;AuKtnrB9B;;AvKynrBA;;;CAGC,cAAc;AuKjnrBf;;AvKonrBA;CuKhnrBA,YAAU;AvKknrBV;;AuK7mrBA;;CvKinrBC,6BAA6B;AuK7mrB9B;;AvKgnrBA;;CAEC,mBuK7mrBgB;AvK8mrBjB;;AAEA;CACC;;;;;IuKtmrBG;CvK4mrBH;;;;IAIG;CuK5lrBJ;;;;IvKimrBI;AuK3lrBJ;AvK6lrBA;CACC,4BsBhvrBW;CtBivrBX,mBCnprBW;ADoprBZ;;AAEA;;;CAGC,oBAAoB;AuK1lrBrB;;AvK6lrBA;;;;CAIC,YuK1lrBa;CvK2lrBb,UsB/vrBO;AtBgwrBR;;AuKvlrBA;CvK0lrBC,oBCnqrBkB;ADoqrBnB;;AAEA;CuKtlrBA,aAAM;AvKwlrBN;;AAEA;CACC;EuKplrBD,gBAAkB;CvKslrBjB;CACA;EuKplrBG,kBtKvFQ;ED6qrBV,cAAc;EuKnlrBhB,6CAAwB;EACvB,gBAAe;CvKqlrBf;CACA;EuK/krBD,iBAAiB;CvKilrBhB;CACA;EACC,uBAAuB;CuKnlrBzB;CvKqlrBC;EACC,aAAa;CuKzkrBf;CvK2krBC;EuKzkrBG,aAAO;CvK2krBV;CACA;EuKvkrBD,6BAA8B;EAC1B,sBAAY;CvKykrBf;AACD;;AuKpkrBA;CvKukrBC;EuKrkrBG,ctKnIe;CD0srBlB;AACD;;AAEA;CACC;EuKnkrBG,ctK1IQ;CD+srBX;AuKjkrBD;;AvKokrBA;;CAEC,6BAA6B;CuKhkrB9B,uBAAM;AvKkkrBN;;AAEA;CACC,4BAA4B;CuK/jrB7B,sBAAM;AvKikrBN;;AAEA;;CuK7jrBA,4BAA0B;AvKgkrB1B;;AAEA;CACC,wBAAwB;AuK1jrBzB;;AvK6jrBA;;CAEC,6BuKvjrBI;CvKwjrBJ,uBuK9jrBG;AvK+jrBJ;;AAEA;CACC,4BuKxjrBY;CvKyjrBZ,sBsBlxrBS;AtBmxrBV;;AAEA;;CAEC,4BuKpjrBc;CvKqjrBd,sBuKpjrBqB;AvKqjrBtB;;AuK5irBA;CvK+irBC,6BuK7irByB;CvK8irBzB,uBuK7irBqB;AvK8irBtB;;AAEA;CACC,6BAA6B;CuKlirB9B,sBACC;AvKmirBD;;AAEA;CACC,6BAA6B;AuK9hrB9B;;AvKiirBA;CACC,cuK9hrBa;AvK+hrBd;AACA;CACC,6BuK7hrBE;CvK8hrBF,2BuK7hrBQ;AvK8hrBT;;AgDj3rBA;;ChDq3rBC,6BwKr3rB0B;AxKs3rB3B;;AAEA;;CwKl3rBA,6BAAc;CxKq3rBb,uBwKp3rByB;AxKq3rB1B;;AwKl3rBA;CxKq3rBC,kBwKp3rBkB;AxKq3rBnB;;AAEA;;CAEC,cwK/2rBW;AxKg3rBZ;;AwK72rBA;CxKg3rBC,cwK/2rBW;AxKg3rBZ;;AAEA;CACC,cAAc;AwK52rBf;AxK82rBA;CACC,wBwK52rBA;AxK62rBD;;AAEA;CACC,6BwK52rBA;CxK62rBA,sBAAsB;AwK52rBvB;;AxK+2rBA;;;CAGC,kBwK72rBoB;AxK82rBrB;;AwK32rBA;;CxK+2rBC,4BwKz2rBA;CxK02rBA,qBwK72rB6B;AxK82rB9B;;AwK12rBA;;;CxK+2rBC,kBwK52rBQ;AxK62rBT;;AwKt2rBA;;;CxK22rBC,kBwKx2rBgB;AxKy2rBjB;;AAEA;CACC,wBwKx2rBY;AxKy2rBb;;AwKj2rBA;CxKo2rBC,4BwK/1rBuB;CxKg2rBvB,gCwK/1rBqB;AxKg2rBtB;;AAEA;CACC,6BwK/1rBO;CxKg2rBP,gCwK91rBC;AxK+1rBF;;AAEA;CACC,UwK51rBY;CxK61rBZ,kBwK31rBA;AxK41rBD;;AAEA;CACC,mBAAmB;CwK31rBpB,4BAAe;AxK61rBf;;AAEA;;;;;;CAMC,eAAe;AwKz1rBhB;;AxK41rBA;CACC,csB38rBW;CtB48rBX,eAAe;AwKx1rBhB;;AxK21rBA;;CAEC,kBAAkB;AwKv1rBnB;;AxK01rBA;;;CwKp1rBA,kBAAc;AxKw1rBd;;AAEA;CACC,UAAU;CwKr1rBX,kBAAY;AxKu1rBZ;;AAEA;;CwKn1rBA,kBAAa;AxKs1rBb;;AAEA;;CwK/0rBA,kBAAM;AxKk1rBN;;AwK/0rBA;CxKk1rBC,kBwKj1rBmB;CxKk1rBnB,oBwK70rBA;CxK80rBA,wBwKj1rB6B;CxKk1rB7B,uBC94rBW;CD+4rBX,wCAAwC;CwK/0rBzC,wCAAkB;CxKi1rBjB,wCsBx9rB+B;CtBy9rB/B,wCwK50rBA;CxK60rBA,wCwKn1rBK;CxKo1rBL,wCCn5rBW;CDo5rBX,wCAAwC;CwK90rBzC,wCAAqB;CxKg1rBpB,wCwK/0rB4B;AxKg1rB7B;;AAEA;CACC,kBAAkB;CwK70rBnB,oBAAM;CxK+0rBL,wBsBx+rBiB;CtBy+rBjB,qBwKx0rBA;CxKy0rBA,wCwKj1rBK;CxKk1rBL,wCCj6rBW;CDk6rBX,wCwK50rBC;CxK60rBD,wCAAwC;CwK30rBzC,wCAAqB;CxK60rBpB,wCsB7+rBqC;CtB8+rBrC,wCwKx0rBA;CxKy0rBA,wCwK/0rBK;CxKg1rBL,wCCr6rBW;ADs6rBZ;;AAEA;CACC,kBwKv0rBA;CxKw0rBA,oBwK30rBU;CxK40rBV,wBC16rBW;CD26rBX,uBAAuB;CwKz0rBxB,uCAAkB;CxK20rBjB,uCsBt/rB+B;CtBu/rB/B,uCwKr0rBA;CxKs0rBA,uCwK70rBK;CxK80rBL,uCC96rBW;CD+6rBX,uCwKz0rBC;CxK00rBD,uCAAuC;CwKx0rBxC,uCAAkB;CxK00rBjB,uCC3+rBQ;AD4+rBT;;AwKv0rBA;CxK00rBC,kBwKz0rBmB;CxK00rBnB,oBwKx0rBA;CxKy0rBA,wBAAwB;CwKn0rBzB,uBACU;CxKo0rBT,wCwKn0rB4B;CxKo0rB5B,wCwK9zrBI;CxK+zrBJ,wCwKl0rBmB;CxKm0rBnB,wCwKj0rBQ;CxKk0rBR,wCAAwC;CwK9zrBzC,wCAEU;CxK8zrBT,wCwK7zrB8B;CxK8zrB9B,wCwKxzrBI;CxKyzrBJ,wCwK5zrBmB;AxK6zrBpB;;AwKvzrBA;CxK0zrBC,kBwKvzrBqB;CxKwzrBrB,oBwKvzrB0B;CxKwzrB1B,wBwK5zrBD;CxK6zrBC,uBwKrzrBQ;CxKszrBR,yCAAyC;C6CzjsB1C,yC4HAW;CzK2jsBV,yCyK3isBA;CzK4isBA,yCyKxjsBG;CzKyjsBH,yCyKvjsBG;CzKwjsBH,yCyKtjsBI;CzKujsBJ,yCyKtjsBa;CzKujsBb,yCyKrjsBE;CzKsjsBF,yCyKpjsBmB;AzKqjsBpB;;AyKhjsBA;CzKmjsBC,kByKljsBgB;CzKmjsBhB,oByKljsBmB;CzKmjsBnB,wByKljsBoB;CzKmjsBpB,uByKljsBS;CzKmjsBT,wCC3jsBgB;CD4jsBhB,wCyKljsBuB;CzKmjsBvB,wCsBh9rBmB;CtBi9rBnB,wCyKljsBiB;CzKmjsBjB,wCyKljsBS;CzKmjsBT,wCyK94rBA;CzK+4rBA,wCyKljsBQ;CzKmjsBR,wCyKjjsBC;CzKkjsBD,wCyKhjsBE;AzKijsBH;;AAEA;CACC,kByK9isBa;CzK+isBb,oBGhksByB;CHiksBzB,wByKrksBY;CzKsksBZ,uByKx5rBA;CzKy5rBA,yCGxksBoC;CHyksBpC,yCyKxksBY;CzKyksBZ,yCyK5isBwB;CzK6isBxB,yCyK55rBA;CzK65rBA,yCyK5isBG;CzK6isBH,yCyK3isBE;CzK4isBF,yCyKzisB0B;CzK0isB1B,yCyKxisBI;CzKyisBJ,yCGhlsBoC;AHilsBrC;;AAEA;CACC,kByKtisBsB;CzKuisBtB,oByKtisBoB;CzKuisBpB,wByKtisB4B;CzKuisB5B,uByKtisByB;CzKuisBzB,yCU1lsBE;CV2lsBF,yCyKtisB8B;CzKuisB9B,yCyKrisBQ;CzKsisBR,yCyKpisBe;CzKqisBf,yCyKpisBuB;CzKqisBvB,yCyKpisBiB;CzKqisBjB,yCyKpisB8B;CzKqisB9B,yCyKj+rBI;CzKk+rBJ,yCG3lsB0C;AH4lsB3C;;AAEA;CACC,kByKpisBW;CzKqisBX,oByKpisBiB;CzKqisBjB,wByKnisBE;CzKoisBF,uByKhjsBG;CzKijsBH,yCyKnisBW;CzKoisBX,yCyKnisBiB;CzKoisBjB,yCyKlisBE;CzKmisBF,yCyKlisBU;CzKmisBV,yCyKlisBwB;CzKmisBxB,yCyKlisB2B;CzKmisB3B,yCyKlisBoB;CzKmisBpB,yCyKlisBqB;CzKmisBrB,yCyKxgsBQ;AzKygsBT;;AAEA;CACC,kByK7jsBG;CzK8jsBH,oByK/hsBa;CzKgisBb,wByK/hsBkB;CzKgisBlB,uByK9hsBiB;CzK+hsBjB,yCyKzhsBY;CzK0hsBZ,yCGznsBkC;CH0nsBlC,yCyKrisBY;CzKsisBZ,yCyK5hsBY;CzK6hsBZ,yCyK3hsBmB;CzK4hsBnB,yCyK3hsBmC;CzK4hsBnC,yCyKvhsBY;CzKwhsBZ,yCyK9hsBmB;CzK+hsBnB,yCyK1hsBI;AzK2hsBL;;AAEA;CACC,kByKthsB4B;CzKuhsB5B,oByKthsBY;CzKuhsBZ,wByKthsB8B;CzKuhsB9B,qBC1isBkB;CD2isBlB,sCyKrhsBY;CzKshsBZ,sCyKnhsBmB;CzKohsBnB,sCyKnhsB6B;CzKohsB7B,sCyK9gsBQ;CzK+gsBR,sCyKlhsBY;CzKmhsBZ,sCyKjhsBY;CzKkhsBZ,sCyK/gsBY;CzKghsBZ,sCyK/gsBa;CzKghsBb,sCyK/gsBmB;AzKghsBpB;;AAEA;CACC,kByKrhsBA;CzKshsBA,oByK/gsBY;CzKghsBZ,wByK/gsBW;CzKghsBX,qByK/gsBQ;CzKghsBR,uCyK/gsBY;CzKghsBZ,uCyK/gsBa;CzKghsBb,uCyK/gsBY;CzKghsBZ,uCyK9gsBE;CzK+gsBF,uCyK3gsBO;CzK4gsBP,uCyK1gsBQ;CzK2gsBR,uCyK7psBD;CzK8psBC,uCsB7qsBc;CtB8qsBd,uCyKzgsBQ;AzK0gsBT;;AAEA;CACC,kByK1gsBwB;CzK2gsBxB,oByKxgsBC;CzKygsBD,wByKxgsBS;CzKygsBT,uByKvgsBC;CzKwgsBD,yCGzpsBoC;CH0psBpC,yCyKvgsBI;CzKwgsBJ,yCyKtgsBc;CzKugsBd,yCyK//rBE;CzKggsBF,yCGlqsBoC;CHmqsBpC,yCyK3gsBI;CzK4gsBJ,yCyKtgsBc;CzKugsBd,yCyKngsBE;CzKogsBF,yCAAyC;AMpzrB1C;;ANuzrBA;CACC,kB0KhssBiB;C1KissBjB,oB0KhssBuB;C1KissBvB,wBAAwB;CkCnssBzB,uBwISK;C1K4rsBJ,wC0K3rsBwB;C1K4rsBxB,wC0K3rsBwB;C1K4rsBxB,wC0K3rsBmB;C1K4rsBnB,wC0K3rsBkB;C1K4rsBlB,wC0KtqsBA;C1KuqsBA,wC0KjssBD;C1KkssBC,wC0K1rsBI;C1K2rsBJ,wCG5qsB0C;CH6qsB1C,wC0KpssBI;A1KqssBL;;AAEA;CACC,oC0KrrsBC;A1KsrsBF;;AAEA;CACC,kC0KtrsBoC;A1KursBrC;;AAEA;CACC,sC0KpqsBA;A1KqqsBD;;AAEA;CACC,iC0KhrsBO;A1KirsBR;;AAEA;CACC,4B0K9qsBe;A1K+qsBhB;;AAEA;CACC,kB0K5qsBiB;C1K6qsBjB,oB0K5qsBO;C1K6qsBP,wB0K5qsBO;C1K6qsBP,uBAAuB;CkC3qsBtB,wCwICmB;C1K4qsBpB,wC0K3qsBoB;C1K4qsBpB,wC0KtqsBA;C1KuqsBA,wC0K3qsBO;C1K4qsBP,wC0K3qsBkC;C1K4qsBlC,wC0K3qsBkB;C1K4qsBlB,wCAAwC;C0KzqsBzC,wCAAO;C1K2qsBN,wC0K1qsBa;C1K2qsBb,2C0K1qsBiB;C1K2qsBjB,2C0K1qsBa;C1K2qsBb,2C0K1qsBuB;C1K2qsBvB,2C0K1qsBmB;C1K2qsBnB,2CsB/nsBmB;CtBgosBnB,2C0KxqsBA;C1KyqsBA,2CAA2C;C0KxqsB5C,2CAAS;C1K0qsBR,2C0KzqsBc;C1K0qsBd,uC0KzqsBa;C1K0qsBb,wC0KxqsBA;C1KyqsBA,uCAAuC;C0KxqsBxC,wCAAS;C1K0qsBR,gB0KzqsBW;A1K0qsBZ;;AAEA;CACC,4B0K9qsBQ;C1K+qsBR,4B0K1qsBgB;C1K2qsBhB,sB0K1qsBe;C1K2qsBf,2B0K1qsBmB;C1K2qsBnB,kB0K1qsBY;C1K2qsBZ,WAAW;A0KxqsBZ;A1K0qsBA;;;;;;;;;;;;CAYC,sBAAsB;A0KzqsBvB;A1K2qsBA;CACC,WAAW;A0K5qsBZ;A1K8qsBA;;CAEC,cCvrsBW;ADwrsBZ;AACA;CACC,W0KpqsBS;A1KqqsBV;AACA;CACC,c0KtrsBK;A1KursBN;AACA;CACC,2D0K9psBE;A1K+psBH;AACA;CACC,0DAA0D;A0K5rsB3D;A1K8rsBA;CACC,yDsB7wsB+B;AtB8wsBhC;AACA;CACC,4D0K/psBE;A1KgqsBH;AACA;CACC,qD0K9psBE;A1K+psBH;;AAEA;CACC,yB0K1psBE;A1K2psBH;;AAEA;;CAEC,yB0K5psBmB;C1K6psBnB,W0K5psBC;A1K6psBF;;AAEA;CACC,yB0K3psB8B;C1K4psB9B,sC0K3psBoB;C1K4psBpB,W0K3psBE;A1K4psBH;;AAEA;CACC,qC0K1psB8B;A1K2psB/B;;AAEA;CACC,qCAAqC;A0K7tsBtC;;A1KgusBA;CACC,sC0KvosBC;C1KwosBD,W0KlusBK;A1KmusBN;AACA;CACC,gB0KvpsBE;C1KwpsBF,4B0KvpsB0B;A1KwpsB3B;AACA;CACC,W0KtpsBE;A1KupsBH;;AAEA;CACC,WsBn1sBO;AtBo1sBR;;AAEA;CACC,W0KppsBC;A1KqpsBF;;AAEA;;CAEC,gDC3vsBkB;AD4vsBnB;;AAEA;CACC,W0KlpsBE;A1KmpsBH;;AAEA;CACC,WAAW;A0K9vsBZ;A1KgwsBA;CACC,W0KhpsBC;A1KipsBF;;AAEA;;CAEC,gDC1wsBkB;AD2wsBnB;;AAEA;CACC,W0K9osBE;A1K+osBH;;AAEA;CACC,WAAW;A0K9wsBZ;A1KgxsBA;CACC,W0K5osBC;A1K6osBF;;AAEA;CACC,gD0K3osBwC;A1K4osBzC;AACA;CACC,0B0K1osBE;A1K2osBH;AACA;;;CAGC,gD0K1osBU;C1K2osBV,WsBp4sBO;AtBq4sBR;A0KtosBA;;;C1K0osBC,sD0KvosBa;A1KwosBd;AACA;CACC,6B0K1nsBC;A1K2nsBF;AACA;CACC,qC0KrosBQ;A1KsosBT;AACA;;;CAGC,W0KrosBO;A1KsosBR;AACA;CACC,0B0KlosBE;A1KmosBH;AACA;CACC,gDC1zsBkB;AD2zsBnB;AACA;CACC,qE0KjosBU;A1KkosBX;;AAEA;CACC,kB0K9nsBC;C1K+nsBD,oB0KnqsBU;C1KoqsBV,wB0K9nsBO;C1K+nsBP,uB0KrqsBU;C1KsqsBV,wC0K7nsBkC;C1K8nsBlC,wC0K7nsB8B;C1K8nsB9B,wC0KznsBE;C1K0nsBF,wC0K7nsBI;C1K8nsBJ,wC0K5nsBG;C1K6nsBH,wC0K1nsBgB;C1K2nsBhB,wC0K9msBC;C1K+msBD,wC0K1nsBS;C1K2nsBT,wC0KznsBE;C1K0nsBF,2C0KznsBQ;C1K0nsBR,2CCj1sBkB;CDk1sBlB,2CCl1sBkB;CDm1sBlB,2C0KrnsBE;C1KsnsBF,2C0KznsBI;C1K0nsBJ,2C0KxnsBG;C1KynsBH,2C0KtnsBc;C1KunsBd,2C0K1msBC;C1K2msBD,2C0KtnsBS;C1KunsBT,uC0KrnsBE;C1KsnsBF,wC0KrnsBQ;C1KsnsBR,uCCx1sBkB;CDy1sBlB,wCCz1sBkB;CD01sBlB,gB0KrnsBa;A1KsnsBd;;AAEA;CACC,mBC71sBkB;CD81sBlB,+B0KlnsBG;C1KmnsBH,qB0KjnsBE;C1KknsBF,qB0KnssBU;C1KossBV,mB0KjnsBE;A1KknsBH;AACA;;;;;;;;;;;;CAYC,sB0K5msBG;A1K6msBJ;AACA;CACC,W0KrtsBG;A1KstsBJ;AACA;;CAEC,c0KzmsBE;A1K0msBH;AACA;CACC,W0KzmsBO;A1K0msBR;A0KrmsBA;C1KumsBC,iE0KtmsB4B;A1KumsB7B;AACA;CACC,gE0KzlsBC;A1K0lsBF;AACA;CACC,+D0KpmsBQ;A1KqmsBT;AACA;CACC,kE0KhmsBE;A1KimsBH;AACA;CACC,2D0KjmsBW;A1KkmsBZ;;AAEA;CACC,yB0KvnsBgB;C1KwnsBhB,gB0KhmsBE;A1KimsBH;;AAEA;CACC,yB0K/lsBG;C1KgmsBH,6D0K7lsBc;A1K8lsBf;AACA;CACC,c0K7lsBO;A1K8lsBR;AACA;;;;;CAKC,yB0KvosBgB;C1KwosBhB,W0KzlsBO;A1K0lsBR;;AAEA;CACC,W0KxlsBE;A1KylsBH;;AAEA;CACC,U0KxlsBG;A1KylsBJ;;AAEA;;;CAGC,W0KplsBE;A1KqlsBH;;AAEA;CACC,yB0KnlsBG;C1KolsBH,sC0KjlsBa;C1KklsBb,WCj7sBW;ADk7sBZ;;AAEA;CACC,mB0KhlsBE;A1KilsBH;;AAEA;;CAEC,sC0K7ksBW;A1K8ksBZ;;AAEA;CACC,gB0KzqsBG;C1K0qsBH,W0K5ksBE;C1K6ksBF,iB0K5ksBc;A1K6ksBf;AACA;CACC,W0K5ksBO;A1K6ksBR;;AAEA;;CAEC,WAAW;A0KpksBZ;;A1KuksBA;CACC,sCAAsC;A0KpksBvC;;A1KuksBA;CACC,oCAAoC;C0KpksBrC,sCAAmB;C1KsksBlB,W0KrksBG;A1KsksBJ;;A0KnksBA;C1KsksBC,mB0KrksBqB;C1KsksBrB,sCCz9sBW;AD09sBZ;;AAEA;;CAEC,sCAAsC;A0KjksBvC;;A1KoksBA;CACC,sC0KjksBA;C1KkksBA,cAAc;C0KjksBf,mBAAQ;A1KmksBR;;AAEA;CACC,iD0KhksBA;A1KiksBD;;AAEA;CACC,W0KhksBS;A1KiksBV;;AAEA;CACC,sC0K/jsBA;A1KgksBD;;AAEA;CACC,mB0KhksBc;A1KiksBf;;AAEA;CACC,sCAAsC;C0K9jsBvC,qBAAO;C1KgksBN,gB0K/jsBY;A1KgksBb;AACA;CACC,oCAAoC;A0K3jsBrC;;A1K8jsBA;;C0K1jsBA,oCAAa;A1K6jsBb;;AAEA;C0K3jsBA,mBAAa;C1K6jsBZ,W0K5jsBS;C1K6jsBT,sC0K3jsBA;A1K4jsBD;;AAEA;CACC,sC0K3jsBA;A1K4jsBD;A0K3jsBA;C1K6jsBC,W0K5jsBS;A1K6jsBV;AACA;C0K1jsBA,WAAY;A1K4jsBZ;;A0KxjsBA;C1K2jsBC,sC0KzjsBA;A1K0jsBD;;AAEA;CACC,sC0KzjsBwB;A1K0jsBzB;;AAEA;CACC,sC0KxjsBA;A1KyjsBD;A0KvjsBA;C1KyjsBC,mB0KxjsBmB;C1KyjsBnB,W0KxjsBG;A1KyjsBJ;;AAEA;CACC,c0KxjsBc;A1KyjsBf;;AAEA;;;CAGC,yB0KvjsBS;C1KwjsBT,qBGpntByB;AHqntB1B;;AAEA;C0K7jsBA,WAAW;C1K+jsBV,4B0KvjsBc;A1KwjsBf;AACA;;;CAGC,gCAAgC;C0KrjsBjC,4BAAwB;C1KujsBvB,W0KtjsBG;A1KujsBJ;;AAEA;CACC,mB0KpjsBsB;A1KqjsBvB;;AAEA;CACC,sCAAsC;A0K9isBvC;;A1KijsBA;CACC,4B0K/isBkB;A1KgjsBnB;;AAEA;CACC,uB0K7isBI;A1K8isBL;;AAEA;;CAEC,W0KhjsBI;A1KijsBL;;AAEA;CACC,sB0KxisBmB;A1KyisBpB;;AAEA;CACC,UAAU;A0KnisBX;;A1KsisBA;CACC,U0KnisBO;A1KoisBR;;A0K1hsBA;C1K6hsBC,W0K5hsBY;A1K6hsBb;AACA;CACC,YAAY;A0K1hsBb;;A1K6hsBA;CACC,mB0K3hsBY;A1K4hsBb;;AAEA;CACC,mB0K1hsBc;C1K2hsBd,W0K1hsBY;A1K2hsBb;A0KzhsBA;C1K2hsBC,mB0K1hsBc;C1K2hsBd,S0K1hsBG;A1K2hsBJ;;AAEA;CACC,yB0K1hsBc;A1K2hsBf;;A0KxhsBA;C1K2hsBC,8B0K1hsBuB;A1K2hsBxB;AACA;CACC,WAAW;A0KzhsBZ;;A1K4hsBA;CACC,mB0K1hsBY;C1K2hsBZ,4BAA4B;AkC9qtB3B;AlCgrtBF;CACC,4BC9ntBkB;CD+ntBlB,mB0KxgsBA;A1KygsBD;AACA;CACC,gC0KjhsBI;C1KkhsBJ,W0K5hsBS;A1K6hsBV;AACA;CmC5ptBE,qCuIipBM;A1K6gsBR;;AmC9ptBE;;;;CnCoqtBD,mB0KvgsBC;C1KwgsBD,gDAAgD;CmCrqtB/C,WAAA;AnCuqtBF;;AmCvqtBE;;;;CnC6qtBD,yB0K//rBA;A1KggsBD;AACA;;;;CAIC,gCAAgC;CmCnrtB/B,WAAA;AnCqrtBF;;AAEA;CACC,yB0K9/rBC;A1K+/rBF;;AAEA;CACC,yBCpqtBkB;ADqqtBnB;;AAEA;CACC,WsB5wtBO;AtB6wtBR;;A0Kp/rBA;C1Ku/rBC,yB0Kl/rBmC;C1Km/rBnC,4B0Kl/rBsC;C1Km/rBtC,WAAW;C0Kz/rBZ,iBAAU;A1K2/rBV;AACA;;C0Kt+rBA,gCAAc;A1Ky+rBd;;AAEA;CACC,U0K5+rBD;C1K6+rBC,wF0Kr+rB2C;A1Ks+rB5C;;AAEA;C0Kl+rBA,sCAAa;A1Ko+rBb;;AAEA;CACC,8B0Kv+rBD;A1Kw+rBA;;AAEA;CACC,sCAAsC;A0K79rBvC;;A1Kg+rBA;;CAEC,yB0Kl+rBD;C1Km+rBC,uB0K39rB0C;C1K49rB1C,uBsB/ytBW;AtBgztBZ;;A0Kv9rBA;C1K09rBC,yBsBnvtBkB;AtBovtBnB;;AAEA;CACC,yB0Kt9rB4C;A1Ku9rB7C;;AAEA;C0Kn9rBA,yBAAe;C1Kq9rBd,W0Kp9rBa;A1Kq9rBd;;AAEA;CACC,yB0Kj9rB4C;A1Kk9rB7C;;AAEA;C0K98rBA,mBAAc;A1Kg9rBd;;AAEA;;CAEC,0B0K58rB2C;A1K68rB5C;;AAEA;;CAEC,0BsBhxtBoB;AtBixtBrB;;AAEA;;CAEC,4BsBn1tBW;AtBo1tBZ;;A0Kn8rBA;C1Ks8rBC,mBsBrxtBQ;AtBsxtBT;;AAEA;;;CAGC,oC0Kj8rBI;A1Kk8rBL;;AAEA;CACC,mBsB9xtBU;AtB+xtBX;AACA;;;CAGC,mB0K77rBqB;C1K87rBrB,WAAW;A0K17rBZ;A1K47rBA;;;CAGC,W0K/7rBD;A1Kg8rBA;;AAEA;CACC,WAAW;A0Kr7rBZ;;A1Kw7rBA;CACC,mB0K76rBA;A1K86rBD;;AAEA;CACC,c0Kn7rBO;A1Ko7rBR;A0Kh7rBA;C1Kk7rBC,W0Kj7rBa;A1Kk7rBd;;AAEA;CACC,sC0K96rByC;A1K+6rB1C;;AAEA;C0K36rBA,WAAY;A1K66rBZ;;AAEA;CACC,qB0K36rBW;A1K46rBZ;;AAEA;CACC,oCAAoC;A0Kt6rBrC;;A1Ky6rBA;CACC,oC0K95rBA;A1K+5rBD;;AAEA;CACC,oC0Kn6rBI;A1Ko6rBL;;AAEA;CACC,oCsB90tBiB;AtB+0tBlB;;AAEA;CACC,qBsB35tBW;AtB45tBZ;;A0K35rBA;C1K85rBC,W0K75rBa;A1K85rBd;;AAEA;CACC,a0K15rBiB;A1K25rBlB;;AAEA;C0Kv5rBA,gCAAW;A1Ky5rBX;;AAEA;;;CAGC,sCsB76tBW;AtB86tBZ;;A0Kj5rBA;;;C1Ks5rBC,WsBn7tBO;AtBo7tBR;;AAEA;CACC,mB0Kh5rBqB;A1Ki5rBtB;AmCj2tBE;CACA,qBDlCA;AlCq4tBF;;AAEA;CACC,WAAW;AmCv2tBV;;AnC02tBF;;CmC/2tBE,gCD5BA;AlC84tBF;;AsD18tBA;CtD68tBC,yD0Kt4rBA;A1Ku4rBD;;AAEA;CACC,WsB38tBO;AtB48tBR;;AAEA;;CAEC,0BCr6tBQ;CDs6tBR,sB0K/3rBA;A1Kg4rBD;;AAEA;CACC,mBAAmB;C0Kl4rBpB,uBAGG;C1Ki4rBF,iD0K/3rBG;A1Kg4rBJ;;AAEA;CACC,mB0K53rBC;A1K63rBF;;AAEA;;;CAGC,mBAAmB;A0Kn3rBpB;;A1Ks3rBA;CACC,mB0Kj3rBG;A1Kk3rBJ;;AAEA;CACC,sC0K92rBI;A1K+2rBL;;AAEA;CACC,W2Kt/tBG;A3Ku/tBJ;;AAEA;CACC,sBsBj4tBW;AtBk4tBZ;;AAEA;CACC,gC2Kp/tBuB;A3Kq/tBxB;;AAEA;CACC,mBGn/tBa;AHo/tBd;AACA;CACC,mB2K/+tBW;A3Kg/tBZ;;AAEA;CACC,mB2K9+tBuB;A3K++tBxB;;AAEA;;;CAGC,mB2Kx+tBsB;A3Ky+tBvB;;AAEA;CACC,sC2Kr+tB8B;A3Ks+tB/B;;AAEA;CACC,mB2Kr+tBoB;A3Ks+tBrB;;AAEA;CACC,mB2Kr+tBW;A3Ks+tBZ;;AAEA;CACC,Y2Kl+tBW;A3Km+tBZ;;AAEA;CACC,sB2Kj+tBkB;A3Kk+tBnB;;AAEA;CACC,U2K99tBc;A3K+9tBf;;AAEA;C2Kz9tBA,aAAA;A3K29tBA;;AAEA;CACC,sBAAsB;A2Kh9tBvB;;A3Km9tBA;CACC,8B2Kh9tBuB;A3Ki9tBxB;;AAEA;CACC,mB2Kh9tByB;A3Ki9tB1B;;AAEA;CACC,oC2K59tBD;A3K69tBA;;AAEA;CACC,sC2Kh+tBW;A3Ki+tBZ;;AAEA;CACC,mB2Kv8tBQ;C3Kw8tBR,Y2Kv8tBoB;A3Kw8tBrB;A2Kt+tBA;C3Kw+tBC,sC2Kn8tBsB;A3Ko8tBvB;;AAEA;CACC,mB2Kn8tByB;C3Ko8tBzB,Y2Kn8tBO;A3Ko8tBR;;AAEA;CACC,U2Kn8tBO;A3Ko8tBR;;AAEA;CACC,gC2Kr/tBD;A3Ks/tBA;;AAEA;CACC,U2Kz/tBD;A3K0/tBA;;AAEA;CACC,gC2Kh8tBW;A3Ki8tBZ;;A2Kr7tBA;C3Kw7tBC,mB2Kv7tBkB;A3Kw7tBnB;;AAEA;CACC,W2Kv7tBW;A3Kw7tBZ;AACA;CACC,mBAAmB;A2Kr7tBpB;;A3Kw7tBA;;CAEC,mB2Kt7tBc;A3Ku7tBf;;AAEA;CACC,W2Kt7tBY;A3Ku7tBb;;AAEA;CACC,sC2Kt7tBwC;A3Ku7tBzC;;A2Kn7tBA;C3Ks7tBC,sC2Kr7tBiB;A3Ks7tBlB;;AAEA;CACC,mBsBnnuBW;AtBonuBZ;;A2Kl7tBA;C3Kq7tBC,mB2Kp7tBoB;A3Kq7tBrB;;AAEA;C2Kl7tBA,sCACiB;A3Km7tBjB;;AAEA;CACC,Y2Kl7tBe;A3Km7tBhB;;A2Kx7tBA;C3K27tBC,sC2Kj7tBC;A3Kk7tBF;;AAEA;CACC,W2K/6tBO;A3Kg7tBR;;AAEA;CACC,mB2K96tBkB;C3K+6tBlB,sCAAsC;A2K36tBvC;;A3K86tBA;CACC,mB2K56tBkB;C3K66tBlB,sC2K36tBO;A3K46tBR;;AAEA;C2Kx6tBA,WAAA;A3K06tBA;;A4K/puBI;C5KkquBH,sC4KjquBoB;A5KkquBrB;;AAEA;;CAEC,sCsB9puBW;AtB+puBZ;;AAEA;CACC,W4K3quBI;A5K4quBL;;AAEA;;CAEC,sC4K5puByB;A5K6puB1B;;AAEA;;;CAGC,sC4K3puByB;A5K4puB1B;;AAEA;;C6Dj/tBA,0B+GrKiB;A5KypuBjB;;AAEA;CACC,mB4KxpuBG;A5KypuBJ;;AAEA;CACC,sC4KtpuBuB;A5KupuBxB;;A6DziuBA;C7D4iuBC,W4KrpuBY;A5KspuBb;;AAEA;CACC,WAAW;A6KzsuBV;;A7K4suBF;CgC9muB6C,gB6I1F/B;A7K0suBd;;AAEA;;CAEC,W6KzsuBA;A7K0suBD;;AAEA;CACC,W6KxsuBC;A7KysuBF;;AAEA;CACC,mB6KttuBa;C7KutuBb,Y6KxsuBE;A7KysuBH;;AAEA;;;CAGC,W6KlsuBO;A7KmsuBR;;AAEA;CACC,mBuCtjuBa;AvCujuBd;;AAEA;CqCrquBA,WAAA;ArCuquBA;;AAEA;CACC,c6KxruBU;A7KyruBX;;AAEA;CACC,uB6KxruBa;A7KyruBd;;AAEA;CACC,W6KpsuBD;A7KqsuBA;;AAEA;CACC,WAAW;A6KjruBZ;;A7KoruBA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;C6KjruBA,cAAA;A7KmruBA;;A6KhruBA;C7KmruBC,kCAAkC;AACnC;;AAEA;CACC,8B6KlruBG;AACJ;;A7KoruBA;C6KjruBA,gCAAgB;A7KmruBhB;;AAEA;CACC,gC6K7quBI;A7K8quBL;;AAEA;CACC,yB6K3quBmB;A7K4quBpB;;AAEA;CACC,8C6KzquBQ;A7K0quBT;;AAEA;C6KrquBA,4CACe;A7KsquBf;;AAEA;CACC,mBC1ruBW;CD2ruBX,W6KrquBC;A7KsquBF;;AAEA;CACC,kC6KpquBmB;A7KqquBpB;AACA;CACC,sB6KpquBoB;A7KqquBrB;;AAEA;CACC,c6KrruBA;A7KsruBD;;AAEA;CACC,qB6KzruBA;C7K0ruBA,mBsB/yuBO;AtBgzuBR;;AAEA;CACC,qBAAqB;C6K1puBtB,mBAAmB;AACnB;A7K4puBA;CACC,UAAU;A6K1puBX;;A7K6puBA;C6KxpuBA,sCAES;A7KwpuBT;;A8Kv0uBA;C9K00uBC,gC8Kz0uB6B;A9K00uB9B;;AAEA;C8Kp0uBA,sCAAU;A9Ks0uBV;AACA;CACC,UAAU;A8Kn0uBX;A9Kq0uBA;CACC,cAAc;A+Kp1uBf;;A/Ku1uBA;CACC,sC+Kr1uBqB;C/Ks1uBrB,c+Kr1uBY;A/Ks1uBb;;AAEA;CACC,sC+Kn1uBY;C/Ko1uBZ,c+Kn1uBkB;A/Ko1uBnB;;AAEA;CACC,gC+Kh1uBwB;A/Ki1uBzB;;AAEA;CACC,8B+K90uBwB;C/K+0uBxB,sB+K90uBwB;C/K+0uBxB,iD+K50uBQ;A/K60uBT;;AAEA;CACC,W+K10uBc;A/K20uBf;;AAEA;CACC,c+Kx0uBgB;A/Ky0uBjB;;AAEA;CACC,UAAU;A+Kp0uBX;;A/Ku0uBA;CACC,mBAAmB;C+Kn0uBpB,cAAA;A/Kq0uBA;;AAEA;;;;;;;CAOC,sC+Kj0uBA;A/Kk0uBD;;AAEA;CACC,mB+Kh0uBA;C/Ki0uBA,sCAAsC;A+K/zuBvC;;A/Kk0uBA;CACC,UAAU;A+K7zuBX;;A/Kg0uBA;;C+K1zuBA,kBAAW;A/K6zuBX;;AAEA;CMnmuBA,YyKrNI;A/K0zuBJ;;AAEA;CACC,U+KzzuBA;A/K0zuBD;;AAEA;CACC,sBAAsB;A+KtzuBvB;;A/KyzuBA;CACC,mB+KtzuBsB;A/KuzuBvB;;AAEA;CACC,c+KnzuBoB;A/KozuBrB;;AAEA;CACC,yB+K/yuBgC;A/KgzuBjC;;AAEA;;CAEC,sC+KvyuB6B;A/KwyuB9B;;AAEA;CACC,sC+KlyuBQ;A/KmyuBT;;AAEA;CACC,YAAY;A+K5xuBb;;A/K+xuBA;CoDj4uBA,cAAA;ApDm4uBA;;AAEA;CACC,sBgLl7uBA;AhLm7uBD;;AAEA;CACC,sCsH1xtBA;AtH2xtBD;;AoD34uBA;;;;CpDi5uBC,WAAW;AACZ;;AAEA;CACC,iDAAiD;AgLp7uBlD;;AhLu7uBA;CiLh9uBA,8BACO;AjLi9uBP;;AkLl9uBA;ClLq9uBC,WkLj9uBiB;AlLk9uBlB;;AAEA;CACC,WkLl9uBI;AlLm9uBL;;AAEA;;CkL38uBK,mCACY;ClL68uBhB,uBkLl8uBQ;AlLm8uBT;;AAEA;CACC,4BkLz8uBqC;AlL08uBtC;;AkLp8uBK;ClLu8uBJ,uBkLj8uB0B;AlLk8uB3B;;AAEA;CACC,uBkL/7uBgB;AlLg8uBjB;;AkL57uBI;;ClLg8uBH,4BAA4B;AkL57uBzB;;AlL+7uBJ;CkL17uBK,uBAAA;AlL47uBL;;AkLr/uBA;ClLw/uBC,0DkLp7uBiC;AlLq7uBlC;;AAEA;CACC,mBkL5/uBD;AlL6/uBA;;AAEA;CACC,sCkLh7uBQ;AlLi7uBT;;AAEA;CACC,yBkL96uBgB;AlL+6uBjB;;AAEA;CACC,gBkL16uBiB;AlL26uBlB;;AAEA;CACC,ckLt6uBkB;AlLu6uBnB;;AAEA;CACC,yBkLv6uBuB;AlLw6uBxB;;AAEA;CACC,yBkL/5uBuB;AlLg6uBxB;;AAEA;CACC,WkL35uBG;AlL45uBJ;;AAEA;CACC,yBkLz5uBG;ClL05uBH,sCkLx5uBI;AlLy5uBL;;AAEA;CkLp5uBA,mBAAY;AlLs5uBZ;;AAEA;CACC,WAAW;CwDz8uBZ,oC2HVa;AnLq9uBb;;AAEA;CACC,6BmLn9uBU;AnLo9uBX;;AAEA;CACC,sCmLn9uBO;AnLo9uBR;;AAEA;CwD97uBA,W2HnBW;AnLm9uBX;;AwDv7uBA;CxD07uBC,mBmLl9uBS;AnLm9uBV;;AAEA;CACC,gCAAgC;AwDp+uBjC;;AxDu+uBA;CmLh9uBA,yBAAW;CnLk9uBV,0CsBpjvBW;AtBqjvBZ;;AAEA;CACC,mBGljvBmB;CHmjvBnB,yBmLv9uBU;AnLw9uBX;;AAEA;;;;;CAKC,+BmLh9uBE;AnLi9uBH;;AAEA;CACC,mBmL98uBU;AnL+8uBX;;AAEA;CACC,8BmL78uBgB;AnL88uBjB;;AAEA;CACC,iDmL58uBgB;AnL68uBjB;;AAEA;CACC,yBmL58uBmB;AnL68uBpB;;AAEA;CACC,yBmL38uBoB;AnL48uBrB;;AAEA;CACC,WAAW;AoLpmvBZ;;ApLumvBA;CACC,yBoLlmvBE;ApLmmvBH;;AAEA;CACC,yBoLlmvBe;ApLmmvBhB;;A8C7mvBA;;C9CinvBC,yBoLhmvBa;ApLimvBd;;AAEA;CACC,yBoL9lvBM;ApL+lvBP;AACA;CACC,UCzgvBW;AD0gvBZ;;AAEA;CACC,yBoLtlvBe;ApLulvBhB;;AAEA;CACC,yBoLtlvBmB;ApLulvBpB;;AAEA;CACC,gCCrhvBkB;ADshvBnB;;AAEA;;CAEC,sBsBtnvBc;AtBunvBf;;AAEA;CACC,mBoL5nvBG;ApL6nvBJ;;AAEA;;CAEC,sCsBvovBW;AtBwovBZ;;AAEA;;;;;;;;;;;;;;;CAeC,iDsBzpvBW;AtB0pvBZ;;AAEA;CACC,oCoLzjvBG;ApL0jvBJ;;AAEA;CACC,yBoL3kvBO;CpL4kvBP,sCChkvBkB;CDikvBlB,WoL1jvBG;ApL2jvBJ;;AAEA;CACC,UoLpqvBD;ApLqqvBA;;AAEA;CACC,sBC3kvBW;AD4kvBZ;;AAEA;CACC,yBC9kvBkB;AD+kvBnB;;AAEA;CACC,mBoL9ivBC;ApL+ivBF;;AAEA;CACC,WoL5ivBW;ApL6ivBZ;;AAEA;;CAEC,yBoLxivBe;ApLyivBhB;;AAEA;CACC,+BoLjivBE;ApLkivBH;;AAEA;;CAEC,yBCnmvBW;ADomvBZ;;AAEA;CACC,UoL7hvBI;ApL8hvBL;;AAEA;;;CAGC,mBsBvrvBY;CtBwrvBZ,YoLthvBG;ApLuhvBJ;;AAEA;;;CAGC,mBoL/hvBC;ApLgivBF;;AAEA;CACC,yBoL7gvBC;CpL8gvBD,sCsBrsvBqC;AtBssvBtC;AACA;CACC,8BoL5gvBa;CpL6gvBb,WoL5gvBI;ApL6gvBL;;AAEA;CACC,2BClovBkB;ADmovBnB;;AAEA;CACC,+BoL5/uBQ;ApL6/uBT;AACA;CACC,WoL5/uBI;ApL6/uBL;;AAEA;CACC,sCoL1/uB6B;ApL2/uB9B;;AAEA;CACC,+BoLz/uBY;ApL0/uBb;;AAEA;CACC,sCoLx/uBiC;ApLy/uBlC;;AAEA;CACC,+BoLn/uBI;ApLo/uBL;;AAEA;;CAEC,sCoL9+uB8B;ApL++uB/B;;AAEA;CACC,+BoLx+uBO;ApLy+uBR;;AAEA;;;CAGC,sCoLp+uBkC;ApLq+uBnC;;AAEA;;;CAGC,+BoL19uB+B;ApL29uBhC;;AAEA;CACC,sCAAsC;C4D9xvBvC,8ByHAQ;ArLgyvBR;;AAEA;CACC,mBsBxqvBW;AtByqvBZ;;AAEA;CACC,WqL9xvBO;ArL+xvBR;;AAEA;;CAEC,yBqL1xvBS;CrL2xvBT,qBqL1xvByB;ArL2xvB1B;;AAEA;;;;CAIC,yBqLtxvBA;CrLuxvBA,WAAW;AqLrxvBZ;;ArLwxvBA;CqLxxvBA,+BAKI;ArLqxvBJ;;AAEA;CACC,yBsBlzvBW;AtBmzvBZ;;AqLzwvBA;CrL4wvBC,sCqL3wvBe;ArL4wvBhB;;AqLxwvBA;CrL2wvBC,+BqL1wvBc;ArL2wvBf;;AqLvwvBA;CrL0wvBC,sCqLzwvBa;ArL0wvBd;;AqLtwvBA;CrLywvBC,+BqLxwvBY;ArLywvBb;;AqLrwvBA;CrLwwvBC,+BqLtwvBA;ArLuwvBD;;AAEA;CACC,sBAAsB;AsLh1vBtB;;AtLm1vBD;CsL/0vBC,sCAAsB;AtLi1vBvB;;AsL70vBC;CtLg1vBA,csL/0vBI;AtLg1vBL;;AAEA;CACC,cAAc;AsL50vBd;;AtL+0vBD;;CAEC,yBChzvBQ;ADizvBT;;AAEA;CACC,csL30vBA;AtL40vBD;;AAEA;CACC,iDsLz0vBQ;AtL00vBT;;AsLp0vBC;CtLu0vBA,kCsLt0vByB;CtLu0vBzB,csLt0vBiB;CtLu0vBjB,gCsLt0vBsB;AtLu0vBvB;;AAEA;CACC,sBsL70vBmB;AtL80vBpB;AACA;CsLn0vBC,cAAA;AtLq0vBD;AACA;;;;;CAKC,uCiBtzvB8B;CjBuzvB9B,csL50vBA;AtL60vBD;;AsLh0vBC;CtLm0vBA,yBsLl0vB0B;CtLm0vB1B,gBsLl0vBkB;AtLm0vBnB;;AsL/zvBC;CtLk0vBA,sCsLj0vBM;AtLk0vBP;;AsL7zvBC;CtLg0vBA,iCsL/zvBM;AtLg0vBP;;AuLj5vBA;CvLo5vBC,yBuLn5vBqB;AvLo5vBtB;;AAEA;CACC,YuLl5vBY;AvLm5vBb;;AAEA;CACC,mBuLl5vBmB;CvLm5vBnB,uBuLl5vBgB;AvLm5vBjB;;AAEA;CACC,sCuLj5vBgB;AvLk5vBjB;;AAEA;;CAEC,sCuLj5vBwB;AvLk5vBzB;;AAEA;CACC,UuL94vBG;AvL+4vBJ;;AAEA;CACC,yBCl0vBkB;ADm0vBnB;;AAEA;CACC,oCsBv6vBW;AtBw6vBZ;;AAEA;CACC,sCuL/3vBY;AvLg4vBb;;AAEA;CACC,oCuL/3vBwB;CvLg4vBxB,sBC90vBW;AD+0vBZ;;AAEA;CACC,yBuL/3vBoB;CvLg4vBpB,sCuL/3vB0B;AvLg4vB3B;;AAEA;CACC,sCuL73vBmB;AvL83vBpB;;AAEA;CACC,WuL73vBO;AvL83vBR;;AAEA;CACC,WuL73vBc;AvL83vBf;;AAEA;;;CAGC,WuL13vBiB;AvL23vBlB;;AAEA;CACC;EACC,gCuLp3vBkC;CvLq3vBnC;CACA;EACC,6BuLp3vByB;CvLq3vB1B;AACD;;AAEA;CACC,iDuLj3vBsB;AvLk3vBvB;;AAEA;CACC,WuLj3vBO;AvLk3vBR;;AAEA;CACC,2CuLj3vB0B;CvLk3vB1B,WuLj3vBO;AvLk3vBR;;AAEA;CACC,sCuLh3vBsB;AvLi3vBvB;;AAEA;CACC,qDuLh3vBqD;CvLi3vBrD,kCuLh3vBqC;AvLi3vBtC;;AAEA;CACC,auL72vBc;CvL82vBd,iBuL72vBoB;CvL82vBpB,cuL72vBc;CvL82vBd,WuL72vBe;CvL82vBf,oCuL72vBuC;AvL82vBxC;;AAEA;CACC,WuL72vBO;AvL82vBR;;AAEA;CACC,sCuL32vBW;AvL42vBZ;;AAEA;CACC,yBuL32vBsB;AvL42vBvB;;AAEA;CACC,sCuL32vBqB;AvL42vBtB;;AwLzgwBA;;;;;CxLghwBC,WAAW;AwLjhwBZ;;AAEA;CxLmhwBC,qEwL3gwB6D;AxL4gwB9D;;AAEA;CwLxhwBA,uCAAiB;CACjB,WAAA;AACA;;AxL2hwBA;;CAEC,yBAAyB;CyL3hwBtB,sCAWJ;AzLkhwBA;;AAEA;;;CAGC,WyL3hwBO;AzL4hwBR;;AAEA;CACC,WyLzhwBG;AzL0hwBJ;;AAEA;CACC,gByLxhwBmB;AzLyhwBpB;;AAEA;CACC,kByLthwBsB;AzLuhwBvB;;AAEA;CACC,YyLphwBiB;AzLqhwBlB;;AAEA;CACC,sCyLphwBgC;AzLqhwBjC;;AAEA;CACC,WyLphwBW;AzLqhwBZ;;AAEA;CACC,sCyL/gwB8B;AzLghwB/B;;AAEA;CACC,WyLvjwBD;AzLwjwBA;;AAEA;CACC,mByL5gwBW;AzL6gwBZ;;AAEA;CACC,SyLrgwBkB;CzLsgwBlB,mByL5gwB8B;AzL6gwB/B;AACA;CACC,cyLnkwBD;AzLokwBA;;AAEA;CACC,qByL9/vB6B;AzL+/vB9B;;AAEA;CACC,iCsBtlwBe;AtBulwBhB;AACA;CyCzgwBA,qBiJlFc;A1L6lwBd;;AAEA;CACC,W0L5lwBC;C1L6lwBD,oC0L5lwBe;C1L6lwBf,iD0L5lwB2B;A1L6lwB5B;AACA;CACC,WsBnlwBO;AtBolwBR;;AAEA;C0LvlwBA,wCACa;A1LwlwBb;;AAEA;CACC,2B0LvlwBE;A1LwlwBH;;AAEA;CACC,iC0LhmwBD;A1LimwBA;;AAEA;CACC,W0LllwBE;A1LmlwBH;;AAEA;CACC,sC0LllwB6B;A1LmlwB9B;A0L7kwBA;C1L+kwBC,U0L7kwBO;A1L8kwBR;;AAEA;CACC,W0L7kwBC;A1L8kwBF;;AAEA;CACC,W0L5kwBQ;A1L6kwBT;AACA;CACC,W0LzkwBE;A1L0kwBH;;AAEA;CACC,U0LzkwBE;A1L0kwBH;;AAEA;C0LpkwBA,sCAGkB;AAHlB;A1LukwBA;CACC,U0LlkwBQ;A1LmkwBT;;AAEA;CACC,W0LnkwBG;A1LokwBJ;;A0L7kwBA;C1LglwBC,W0L/jwBC;A1LgkwBF;AACA;C2L3pwBK,WAAA;A3L6pwBL;;A2L7pwBK;C3LgqwBJ,U2LzpwBW;A3L0pwBZ;;A2LjqwBK;C3LoqwBJ,yB2LnpwBQ;A3LopwBT;;AAEA;C0D9jwBA,yBiIrFW;A3LqpwBX;AACA;CACC,mB2LppwByB;C3LqpwBzB,W2LppwBO;C3LqpwBP,sC2LnpwBI;A3LopwBL;A2LhpwBA;C3LkpwBC,yB2LhpwBwB;A3LipwBzB;;AAEA;CACC,sCAAsC;A2L7owBvC;;A3LgpwBA;;CAEC,uB2L7owBqB;A3L8owBtB;A4L3rwBA;;C5L8rwBC,qB4L1rwBmB;C5L2rwBnB,iC4L7rwBS;A5L8rwBV;;AAEA;CACC,+B4L1rwBc;A5L2rwBf;;AAEA;CACC,0C4L/qwBE;A5LgrwBH;;AAEA;CACC,sB4LzrwBa;A5L0rwBd;;AAEA;CACC,sC4LtrwBM;A5LurwBP;AACA;CACC,W4LltwBD;A5LmtwBA;;AAEA;CACC,c4LrrwBY;A5LsrwBb;;AAEA;;;CAGC,W4LnrwBI;C5LorwBJ,qC4LnrwBiB;A5LorwBlB;AACA;;;CAGC,iC4LnrwBuB;C5LorwBvB,gC4LnrwBmB;C5LorwBnB,0C4LnrwB6B;C5LorwB7B,yC4LlrwBK;A5LmrwBN;AACA;;;CAGC,sB4LjrwBoB;A5LkrwBrB;;AAEA;CACC,6B4LjrwBwB;A5LkrwBzB;;AAEA;CACC,0C4LjrwBqB;A5LkrwBtB;;AAEA;;;CAGC,sB4L/qwBW;A5LgrwBZ;;AAEA;CACC,sB4L/qwBkB;A5LgrwBnB;;AAEA;CACC,0C4LhwwBD;A5LiwwBA;;AAEA;CACC,mC4L9qwBmB;C5L+qwBnB,oC4L9qwBoB;C5L+qwBpB,0C4L9qwBuB;C5L+qwBvB,yC4L7qwBK;A5L8qwBN;;AAEA;CACC,8CAA8C;A4L3wwB/C;A5L6wwBA;CACC,sBAAsB;A4L9wwBvB;;A5LixwBA;CACC,gB4LrqwBc;C5LsqwBd,W4LnxwBD;C5LoxwBC,qB4LpqwBoB;A5LqqwBrB;;AAEA;CACC,gB4LnqwBc;A5LoqwBf;AACA;;;C4L1xwBA,0CA4Ha;A5LkqwBb;;AAEA;;CAEC,sBCzrwBW;AD0rwBZ;;AAEA;CACC,gB4L/pwBc;A5LgqwBf;;AAEA;CACC,yBAAyB;A4L1ywB1B;A5L4ywBA;CACC,6B4L7ywBD;A5L8ywBA;AACA;CACC,W4L5pwBE;A5L6pwBH;;AAEA;CACC,c4L3pwBE;C5L4pwBF,a4L3pwBU;C5L4pwBV,mB4L3pwBG;C5L4pwBH,c4L3pwBG;C5L4pwBH,kBAAkB;CAElB,W4LzpwBC;A5L0pwBF;AACA;CACC,c4L7zwBD;C5L8zwBC,gB4LxpwBG;C5LypwBH,W4LxpwBG;C5LypwBH,U4Lh0wBD;A5Li0wBA;;AAEA;;CAEC,qB4LvpwBiB;A5LwpwBlB;;AAEA;;CAEC,uB4LppwBgB;A5LqpwBjB;;AAEA;;;;;;;;C4L70wBA,cAAA;A5Ls1wBA;;AAEA;;e4L7owBI;A5LgpwBJ;CACC,mB4LnvwBC;C5LovwBD,c4L9owBY;A5L+owBb;;AAEA;CACC,qB4L9owBiB;A5L+owBlB;;AAEA;CACC,WAAW;C4Lr2wBZ,gBAAgB;A5Lu2wBhB;;AAEA;CACC,oB4LtowBqB;A5LuowBtB;;AAEA;CACC,wB4LtowBsB;C5LuowBtB,qB4LtowBsB;A5LuowBvB;AACA;C4Lj3wBA,aAAA;C5Lm3wBC,8B4LnowBgC;C5LoowBhC,uB4Lp3wBe;C5Lq3wBf,W4LnowBM;A5LoowBP;A4Lt3wBA;C5Lw3wBC,a4LhowBiB;C5LiowBjB,uB4Lz3wBe;C5L03wBf,W4LhowBM;C5LiowBN,wBAAwB;A4L33wBzB;A5L63wBA;CACC,a4L93wBD;C5L+3wBC,uBCpxwBkB;ADqxwBnB;A4Lh4wBA;C5Lk4wBC,W4L1nwBK;A5L2nwBN;;AAEA;;CAEC,eC7xwBW;CD8xwBX,gB4Lx4wBD;C5Ly4wBC,qBC/xwBW;CDgywBX,yBAAyB;A4L14wB1B;;A5L64wBA;;;;;CAKC,UAAU;C6L/4wBX,gBACI;AADJ;;A7Lm5wBA;C6Ln5wBA,+BAMa;C7L+4wBZ,2B6L74wBI;A7L84wBL;;AAEA;CACC,8BAA8B;C6Lz5wB/B,mBAcI;C7L64wBH,oB6L34wBI;C7L44wBJ,mBAAmB;C6L55wBpB,yBAkBa;A7L44wBb;;A6Lv4wBA;CAAA,+BAEiB;C7Ly4wBhB,0B6Lv4wBI;A7Lw4wBL;A6L54wBA;C7L84wBC,2B6Lt4wBI;A7Lu4wBL;;AAEA;CACC,oBAAoB;C6Ll5wBrB,eAcI;A7Ls4wBJ;;A6Lp5wBA;;C7Lw5wBC,uBAAuB;C6Lj4wBxB,YAAA;C7Lm4wBC,Y6Ll4wBW;C7Lm4wBX,oB6Lj4wBG;C7Lk4wBH,2B6Lj4wBG;C7Lk4wBH,kBC70wBkB;CD80wBlB,kB6L/3wBG;A7Lg4wBJ;;AAEA;CACC,Y6L34wBD;C7L44wBC,kBCn1wBkB;CDo1wBlB,mB6Lz3wBG;A7L03wBJ;;A6Lr3wBA;C7Lw3wBC,wB6Lv3wBW;A7Lw3wBZ;;A6Lp3wBA;C7Lu3wBC,wB6Lr3wBqB;A7Ls3wBtB;;AAEA;CACC,oB6Ll3wBkB;C7Lm3wBlB,cAAc;A6Lh3wBf;;A7Lm3wBA;;CAEC,kB6L92wBe;A7L+2wBhB;;AAEA;CACC,WsB18wBO;AtB28wBR;;AAEA;CACC,kC6Lx2wBQ;A7Ly2wBT;;AAEA;CACC,gBsBz8wBS;AtB08wBV;;AAEA;CACC,2B8L/9wBgB;A9Lg+wBjB;;AAEA;CACC,8B8L/9wBqB;A9Lg+wBtB;AACA;CACC,sB8Lh9wBA;A9Li9wBD;;AAEA;CACC,2B8L39wBI;A9L49wBL;;AAEA;CACC,8B8Lz9wBI;A9L09wBL;;AAEA;CACC,yB8Lz9wBmB;A9L09wBpB;AACA;CACC,sB8Lz9wBG;A9L09wBJ;;AAEA;CACC,W8Ll+wBD;A9Lm+wBA;AACA;CACC,sBsBp7wBU;AtBq7wBX;;AAEA;CACC,gB8Lp9wBkB;A9Lq9wBnB;;AAEA;C8Lh9wBA,4BACK;A9Li9wBL;;AAEA;CACC,4B8Lh9wByB;A9Li9wB1B;;AAEA;CACC;E8Lz9wBD,aAWK;C9Lg9wBJ;AACD;;A8L38wBA;C9L88wBC,W8L38wBoB;C9L48wBpB,c8L/8wBY;C9Lg9wBZ,e8L38wBwB;C9L48wBxB,mB8Lh9wBK;C9Li9wBL,gB8L38wB8B;C9L48wB9B,kB8L38wB4B;C9L48wB5B,oBsBt+wBc;CtBu+wBd,kB8Lp9wBG;C9Lq9wBH,a8Lz8wB8B;A9L08wB/B;;AAEA;CACC,sBAAsB;A8L/7wBvB;;A9Lk8wBA;C+LnixBA,0BACW;A/LoixBX;;AAEA;CACC,mB+LnixBmB;A/LoixBpB;;AAEA;CACC,mB+LnixB0B;A/LoixB3B;;AAEA;CACC,mBsB5/wBc;AtB6/wBf;;AAEA;CACC,mB+LhixB+B;A/LiixBhC;;AAEA;CACC,mB+LvjxBG;A/LwjxBJ;;AAEA;CACC,mB+L9hxBmB;A/L+hxBpB;;AAEA;CACC,mB+L7hxBmB;A/L8hxBpB;;AAEA;;;CAGC,qB+LxhxBC;A/LyhxBF;A+LvkxBA;;;CAoDA,sCACqB;A/LuhxBrB;;AAEA;;;;;;;;;;CAUC,sC+L9gxBc;A/L+gxBf;;AAEA;CACC,+B+L7gxBC;C/L8gxBD,0BAA0B;C+L5gxB3B,yBAAY;C/L8gxBX,gB+L7gxBe;A/L8gxBhB;AACA;CACC,sC+L7gxBmB;C/L8gxBnB,gB+L7gxBa;C/L8gxBb,mBAAmB;C+L3gxBpB,mBAAc;A/L6gxBd;AACA;CACC;EACC,W+L5gxBA;E/L6gxBA,W+L5gxBA;E/L6gxBA,YAAY;E+LzgxBd,mCAAY;C/L2gxBX;AACD;AACA;CACC;EACC,+BCvgxBU;CDwgxBX;A+LvgxBD;A/LygxBA;CACC,a+LxgxBe;C/LygxBf,4B+LxgxBU;A/LygxBX;AACA;;C+LpgxBA,gBAAW;C/LugxBV,esBzlxBc;CtB0lxBd,gBsB1lxBc;AtB2lxBf;AACA;;CAEC,kBAAkB;C+LngxBnB,kBAAS;C/LqgxBR,iBsB/lxBY;AtBgmxBb;AACA;CACC,qBC1hxBW;AD2hxBZ;AACA;C+LjgxBA,oBAAiB;A/LmgxBjB;AACA;CACC,S+LlgxBC;C/LmgxBD,sBAAsB;C+LhgxBvB,2BAAmB;C/LkgxBlB,csB/mxBiB;CtBgnxBjB,uB+LjgxB+B;C/LkgxB/B,c+LjgxBC;C/LkgxBD,gBAAgB;C+L//wBjB,UAAA;A/LigxBA;AACA;CACC,c+LhgxBC;C/LigxBD,gBAAgB;A+L9/wBjB;A/LggxBA;CACC,mB+L//wBU;C/LggxBV,0BC9ixBW;CD+ixBX,mBAAmB;C+L7/wBpB,gBAAgB;C/L+/wBf,uBsB3nxBc;CtB4nxBd,gB+L9/wBQ;A/L+/wBT;AACA;C+L5/wBA,mBAAc;C/L8/wBb,uBsB/nxBY;CtBgoxBZ,c+L7/wBQ;A/L8/wBT;AACA;C+Lz/wBA,sBAAS;A/L2/wBT;AACA;CACC,cAAc;C+Lz/wBf,yCAAU;A/L2/wBV;AACA;CACC,kCAAkC;A+Lz/wBnC;A/L2/wBA;CACC,uB+L9+wBA;A/L++wBD;AACA;CACC,gB+L1/wBW;A/L2/wBZ;AACA;CACC,W+L1/wBM;C/L2/wBN,c+L1/wBU;C/L2/wBV,yC+L1/wBa;C/L2/wBb,uB+L1/wBY;C/L2/wBZ,kB+Lz/wBC;C/L0/wBD,OAAO;C+Lx/wBR,MAAA;C/L0/wBC,S+Lz/wBG;C/L0/wBH,YAAY;CAGZ,oBgM/rxBI;AhMgsxBL;AACA;CACC,uBgM9rxBE;AhM+rxBH;AACA;CACC,WgM9rxBG;AhM+rxBJ;AACA;CACC,uBgM/qxBE;AhMgrxBH;AACA;CACC,sBgM5rxBoB;ChM6rxBpB,wBgM3rxBqB;AhM4rxBtB;AACA;CACC;EACC,2BgM1rxBoB;ChM2rxBrB;AACD;;AAEA;CACC,sBgMvrxBiB;AhMwrxBlB;;AAEA;CACC,gCgMtrxBoB;AhMurxBrB;;AAEA;CACC,mBChnxBkB;CDinxBlB,mBgMpsxBC;ChMqsxBD,eCpnxBW;CDqnxBX,gBgMtsxBC;AhMusxBF;AACA;CACC,iBgM7qxBgB;ChM8qxBhB,mBgM7qxBiB;ChM8qxBjB,sBgM7qxBiB;AhM8qxBlB;AACA;CACC;EACC,egM7qxBI;EhM8qxBJ,gBgM7qxBI;EhM8qxBJ,yBgM7qxBgB;EhM8qxBhB,WgM7qxBW;ChM8qxBZ;AACD;AACA;CACC,kDgM5qxBoC;AhM6qxBrC;AACA;CACC;EACC,qBgMxqxBmB;ChMyqxBpB;AACD;AACA;CACC;EACC,uBgMxqxBc;ChMyqxBf;AACD;AACA;CACC;EACC,kBgMxqxBoB;ChMyqxBrB;AACD;AACA;CACC;EACC,agMrwxBS;ChMswxBV;AACD;AACA;CACC,sBgMlqxByB;ChMmqxBzB,agMlqxBS;ChMmqxBT,yBgMlqxBuB;ChMmqxBvB,oBgMlqxBuB;AhMmqxBxB;;AAEA;CACC,gBsBrwxBW;AtBswxBZ;AACA;CACC;EgMnxxBD,YA4EE;ChMysxBD;AACD;AACA;CACC;EACC,6BgMnqxBI;EhMoqxBJ,iBC3qxBU;CD4qxBX;AiM3xxBD;AjM6xxBA;CACC,SiM3xxBC;CjM4xxBD,6BAA6B;CkM/xxB9B,cACC;ClMgyxBA,mBkM/xxBY;ClMgyxBZ,sBkM/xxBqB;ClMgyxBrB,qBkMlyxBA;AlMmyxBD;AACA;CACC;EACC,oBkMtyxBD;ClMuyxBA;AACD;AACA;CACC,WkM5xxBI;ClM6xxBJ,ckM5xxBI;ClM6xxBJ,gCkMxyxBC;ClMyyxBD,kBkM7yxBA;ClM8yxBA,iBkM1xxBW;ClM2xxBX,SkM1xxBI;ClM2xxBJ,2BkM1xxBc;ClM2xxBd,WkM1xxBI;ClM2xxBJ,WkM1xxBI;ClM6xxBJ,oBkM3xxBc;AlM4xxBf;AACA;CACC;EACC,akM3xxBI;ClM4xxBL;AACD;AACA;CACC,gBkM7zxBA;AlM8zxBD;AACA;CACC,oBsBtzxBW;AtBuzxBZ;AACA;CACC,WkMp0xBD;ClMq0xBC,ckMzxxBK;ClM0xxBL,gCkMj0xBC;ClMk0xBD,kBkMnxxBI;ClMoxxBJ,iBkMv0xBA;ClMw0xBA,SkMvxxBK;ClMwxxBL,2BkMr0xBC;ClMs0xBD,SkMlxxBI;ClMmxxBJ,WkMlxxBI;ClMqxxBJ,oBkMjxxBkB;AlMkxxBnB;AACA;CACC,WkMjxxBI;AlMkxxBL;AACA;CACC,oBkMjxxBa;AlMkxxBd;AACA;CACC,oBkMv1xBA;ClMw1xBA,qBkM5wxBc;AlM6wxBf;AACA;CACC,kBsBj1xBW;CtBk1xBX,akM51xBA;AlM61xBD;;AAEA;CACC,akMrwxBI;ClMswxBJ,8BkMhwxBI;ClMiwxBJ,mBkMl2xBA;ClMm2xBA,YkMpwxBK;ClMqwxBL,ekMp2xBA;AlMq2xBD;AACA;CACC,qBkMjwxBa;AlMkwxBd;AACA;CACC;EACC,ekM32xBD;ClM42xBA;AACD;AACA;CACC;EACC,qBkMh3xBD;ClMi3xBA;AACD;AACA;CACC,iCkM7vxBqB;ClM8vxBrB,kBkM7vxBW;AlM8vxBZ;;AAEA;CACC,gBmMx3xBQ;CnMy3xBR,0BmMv3xBY;CnMw3xBZ,uBmMv3xBe;AnMw3xBhB;;AAEA;CACC,mBmMt3xBe;AnMu3xBhB;;AAEA;;CAEC,cmMr4xBS;AnMs4xBV;;AAEA;CACC,cmMj3xBE;AnMk3xBH;;AAEA;CACC,uBmM52xBa;AnM62xBd;;AAEA;CACC,iBmM32xBE;AnM42xBH;AACA;;CAEC,mBmM12xBU;CnM22xBV,cmMt5xBS;AnMu5xBV;AACA;;CAEC,wBmM/1xBU;AnMg2xBX;AACA;CmM71xBA,gCACe;AnM81xBf;AACA;CoM/5xBA,qCAEE;ApM+5xBF;;AAEA;CACC,2BoM95xB2B;CpM+5xB3B,kBoM95xBiB;CpM+5xBjB,eoMr6xBA;ApMs6xBD;AACA;CACC;EACC,6BoM75xBwB;CpM85xBzB;AACD;;AAEA;CACC,2BoM75xBsB;CpM85xBtB,kBoM75xBkB;ApM85xBnB;;AAEA;CACC,qBoM55xBe;ApM65xBhB;;AAEA;CACC,8BoMt7xBC;ApMu7xBF;;AAEA;;CAEC,oBoM57xBA;CpM67xBA,coMx5xBI;ApMy5xBL;AACA;;CAEC,mBoMj8xBA;CpMk8xBA,wBsBj6xBmC;AtBk6xBpC;;AAEA;CACC,gCoMr8xBC;CpMs8xBD,qBsBx6xBe;CtBy6xBf,kBC/1xBW;CDg2xBX,uBoMp5xBY;ApMq5xBb;AACA;CACC,SoMh5xBI;CpMi5xBJ,kBoMh5xBgB;CpMi5xBhB,QoM/8xBD;CpMg9xBC,SoM94xBG;CpM+4xBH,gCoM74xBG;ApM84xBJ;;AAEA;CACC,coM54xBgB;CpM64xBhB,eoM54xBiB;CpM64xBjB,mBAAmB;CoMx4xBpB,2BACC;CpMy4xBA,kBoMv4xBe;ApMw4xBhB;AqMz9xBA;CrM29xBC,kBsBx9xBQ;AtBy9xBT;AACA;CACC,kBsB38xBS;CtB48xBT,csBr9xBW;CtBs9xBX,gBAAgB;CqMh+xBjB,eAUG;CrMw9xBF,qBqMv9xBS;CrMw9xBT,eAAe;CqMn+xBhB,yBAasB;CAbtB,gCAcuB;ArMw9xBvB;AACA;CACC,cqMx+xBK;ArMy+xBN;AACA;CqM1+xBA,oBAuBgB;ArMq9xBhB;AACA;CACC,cqMp9xBS;CrMq9xBT,mBqMp9xB2B;CrMq9xB3B,oBAAoB;AqMh/xBrB;ArMk/xBA;CACC,kBAAkB;CqMn/xBnB,SAAM;CrMq/xBL,WqMh9xBI;CrMi9xBJ,UAAU;CqMt/xBX,yBA4CK;ArM48xBL;AACA;CACC,0BqM18xBG;CrM28xBH,mBAAmB;AqM3/xBpB;ArM6/xBA;CACC,UqM38xBW;ArM48xBZ;AqM//xBA;CrMigyBC,UqMv8xBG;ArMw8xBJ;AACA;CACC,UqMpgyBK;ArMqgyBN;AACA;CACC,WqMt8xBI;CrMu8xBJ,kBAAkB;AqMxgyBnB;ArM0gyBA;CACC,eAAe;AqM3gyBhB;ArM6gyBA;CACC,cqMh8xBc;CrMi8xBd,WAAW;CqM/gyBZ,oBAAM;CrMihyBL,eCz6xBkB;CD06xBlB,sBqMh8xB+B;ArMi8xBhC;AACA;CqMphyBA,cAAM;CrMshyBL,WqM97xBa;CrM+7xBb,oCsB7gyBW;AtB8gyBZ;AACA;CACC,cqM97xBc;CrM+7xBd,WAAW;CqM3hyBZ,gCAkGI;CrM27xBH,sBsBlhyBW;CtBmhyBX,2BqMz7xBE;CrM07xBF,SAAS;CqM/hyBV,QAAM;CrMiiyBL,cqM17xBQ;CrM27xBR,YAAY;AqMliyBb;ArMoiyBA;CACC,kBsB3hyBW;CtB4hyBX,MqMz7xBG;CrM07xBH,cAAc;CqMviyBf,QAAM;CrMyiyBL,SsB9hyBO;AtB+hyBR;AACA;CqM3iyBA,kBAkHe;CrM27xBd,MqMr7xBO;CrMs7xBP,OAAO;CqM9iyBR,aAAM;CrMgjyBL,gBqMp7xBc;CrMq7xBd,YsBviyBW;CtBwiyBX,eqMp7xBc;CrMq7xBd,uBAAuB;CqMnjyBxB,gBAAM;CrMqjyBL,mBsB1iyBW;AtB2iyBZ;AACA;CqMvjyBA,cAAM;ArMyjyBN;AACA;CqM1jyBA,kBAAM;CrM4jyBL,MqMh7xBG;CrMi7xBH,WsBnjyBO;CtBojyBP,UqMh7xBG;CrMi7xBH,yBAAyB;CqM/jyB1B,gBAAM;ArMikyBN;AACA;CACC,kBAAkB;CqMnkyBnB,eAAM;CrMqkyBL,SChhyBQ;CDihyBR,QAAQ;CqMtkyBT,aAAM;ArMwkyBN;AACA;CACC,gBqM16xBc;CrM26xBd,kCAAkC;AqM3kyBnC;ArM6kyBA;CACC,gBAAgB;CqM9kyBjB,kBAAM;CrMglyBL,qBqMt6xBE;CrMu6xBF,gBAAgB;CqMjlyBjB,cAAM;ArMmlyBN;AACA;CACC,cAAc;CqMrlyBf,gBAAM;ArMulyBN;AACA;CqMxlyBA,aAAM;ArM0lyBN;AACA;CqM3lyBA,mBAkLgB;CrM26xBf,gBCn/xBW;CDo/xBX,kBqMl6xBe;ArMm6xBhB;;AAEA;CACC,eAAe;CqMlmyBhB,iBAAM;CrMomyBL,gBqM/5xBe;CrMg6xBf,kBAAkB;CqMrmyBnB,qBAAM;CrMumyBL,qBC5/xBkB;CD6/xBlB,kBqM95xBe;CrM+5xBf,cAAc;CqMzmyBf,sCA+MI;ArM45xBJ;AACA;CqM5myBA,UAAM;CrM8myBL,eqMt5xBG;ArMu5xBJ;AqM/myBA;CrMinyBC,UqMp5xBiB;ArMq5xBlB;AACA;CACC,kBqMp5xBkB;CrMq5xBlB,WqMp5xBE;CrMq5xBF,YqMp5xBW;CrMq5xBX,aqM35xBQ;CrM45xBR,cqMn5xBc;CrMo5xBd,eqMl5xBe;CrMm5xBf,UqMl5xBW;CrMm5xBX,2BAA2B;CqM3nyB5B,0BA2OiB;ArMk5xBjB;;AAEA;CACC,2BsHjoyBA;AtHkoyBD;AACA;;CAEC,oBqM14xBQ;CrM24xBR,cAAc;AqMroyBf;ArMuoyBA;CACC,mBqMv4xBI;ArMw4xBL;;AAEA;CACC;EACC,qBAAqB;CqM7oyBvB;ArM+oyBA;;AAEA;CqMjpyBA;EA2QQ,sBpM/JI;CDwiyBX;AACD;;AAEA;CACC,mBqMv4xBI;CrMw4xBJ,cAAc;AqMzpyBf;;ArM4pyBA;CACC,SqMt4xBW;CrMu4xBX,iDAAiD;CqM9pyBlD,uBAAM;ArMgqyBN;;AAEA;CACC,wBqM/3xBqB;CrMg4xBrB,SAAS;CqMpqyBV,mBAAM;CrMsqyBL,gBqM93xBW;CrM+3xBX,csB7pyBW;CtB8pyBX,sCqM12xBQ;ArM22xBT;AACA;CACC,mBqM3qyBK;CrM4qyBL,cqMz3xBe;ArM03xBhB;;AAEA;CACC,oBAAoB;AqM52xBb;;ArM+2xBR;CoB/hyBI,cAAA;CpBiiyBH,oBqMz2xB0B;ArM02xB3B;AoBliyBI;CpBoiyBH,qBqMt2xB0B;CrMu2xB1B,sBAAsB;AoBriyBnB;ApBuiyBJ;CACC;EoBxiyBG,sBiLsMS;EACD,uBAAW;CrMo2xBtB;AqMh2xBD;AACA;CACA,gBAAiB;CrMk2xBhB,iBqMj2xBgB;CrMk2xBhB,kBqMj2xBO;CrMk2xBP,uBqMj2xB6B;ArMk2xB9B;AACA;CACC;EACC,sBAAsB;CqMj2xBxB;AACA;AACA;;CrMo2xBC,cCrmyBW;ADsmyBZ;AACA;;CAEC,eqMp2xBO;CrMq2xBP,cAAc;AqMl2xBf;AACA;;CrMq2xBC,mBsBrryBY;CtBsryBZ,cC9myBW;CD+myBX,iBqMn2xBQ;CrMo2xBR,wBqMp2xBS;ArMq2xBV;AACA;CACC,mBAAmB;CqMn2xBpB,cAAc;AACd;AACA;CrMq2xBC,0BsBjsyBqC;AtBksyBtC;AACA;;;;;;CqM/1xBA,sBAAkB;AAClB;;ArMu2xBA;CACC,kBqMr2xBQ;CrMs2xBR,oBqM12xBiB;ArM22xBlB;AACA;CACC;EqMr2xBD,eAAa;EACb,gBAAkB;EAClB,eAAgB;CrMu2xBf;AACD;AACA;CACC;EACC,eqMx2xBM;ErMy2xBN,gBAAgB;CqMn2xBlB;ArMq2xBA;;AAEA;CACC,YqMn2xBG;ArMo2xBJ;;AAEA;CACC,eqMl2xBc;CrMm2xBd,OGpvyBO;CHqvyBP,YqM92xBD;ArM+2xBA;AACA;CoBpwyBA,WAqCI;CpBiuyBH,OqMh2xBA;ArMi2xBD;AoBpqyBA;CpBsqyBC,QqMh2xBM;CrMi2xBN,YAAY;AqM/1xBb;;ArMk2xBA;CACC,YAAY;AsMlxyBb;;AtMqxyBA;CACC,kBGrwyBa;AHswyBd;AACA;CACC,sBsMhxyBO;CtMixyBP,2BsMhxyBiC;CtMixyBjC,qBAAqB;CuM1xyBtB,WAAK;AvM4xyBL;;AuMzxyBA;CvM4xyBC,kBuM3xyBkB;CvM4xyBlB,kBuM3xyBmB;CvM4xyBnB,UAAU;CuM1xyBX,mBACI;CvM2xyBH,sBuM1xyBmB;AvM2xyBpB;AuMvxyBA;CvMyxyBC;EACC,WAAW;EuMtxyBb,iBAAmB;EACf,kBAAa;EACb,iBAAgB;EvMwxyBlB,sBAAsB;CuMnxyBxB;AvMqxyBA;;AAEA;CuMlxyBA,UAAK;CvMoxyBJ,QuMnxyBG;CvMoxyBH,eAAe;CuMjxyBhB,sBAAsB;AvMmxyBtB;AACA;CuMjxyBA;EACC,gBAAgB;CvMmxyBhB;AuMjxyBD;AvMmxyBA;CACC;EuMjxyBD,WAAQ;EACP,yBACA;EvMkxyBC,aAAa;CuMjxyBf;AvMmxyBA;;AuMhxyBA;CACA,0BAAsB;AACtB;AvMmxyBA;CACC;EuMjxyBG,oBAAgB;EAChB,kBAAkB;CvMmxyBrB;AACD;AACA;;CuMhxyBA,yBAAsB;AvMmxyBtB;AACA;;CAEC,gCuMlxyBkB;AvMmxyBnB;AACA;CuMjxyBA,cAAe;AvMmxyBf;AACA;CACC,oBAAoB;CuMhxyBrB,4BAAwB;AvMkxyBxB;;AAEA;CACC,oBuMjxyBe;AvMkxyBhB;AACA;CACC,oBuMjxyBa;AvMkxyBd;AACA;CACC,wBuM3xyBoB;CvM4xyBpB,kBuMjxyBW;CvMkxyBX,cGp1yBa;AHq1yBd;AACA;CACC,gBAAgB;CuM/wyBjB,SAAU;CvMixyBT,WuMhxyBO;CvMixyBP,OAAO;CuM9wyBR,YAAK;CvMgxyBJ,kBuM9wyBe;CvM+wyBf,QuM9wyBA;CvM+wyBA,MuM9wyBA;CvM+wyBA,UuM9wyBA;AvM+wyBD;AACA;CACC,kBAAkB;CuM3wyBnB,MAAK;CvM6wyBJ,WuM5wyBU;CvM6wyBV,YAAY;CuM1wyBb,kBAAgB;CvM4wyBf,OuM3wyBQ;CvM4wyBR,SuM3wyBG;CvM4wyBH,UuM3wyBW;CvM4wyBX,YsBh3yBO;CtBi3yBP,mBAAmB;AuM12yBpB;;AvM62yBA;CACC,euMzwyBU;CvM0wyBV,sBuM7wyBmB;CvM8wyBnB,gCuMzwyBiB;CvM0wyBjB,YuMzwyBU;CvM0wyBV,0CuMxwyBoB;CvMywyBpB,cuMxwyBQ;AvMywyBT;AACA;;CAEC,SuMxwyBC;CvMywyBD,uBuMxwyBS;CvMywyBT,uBuMxwyBa;CvMywyBb,6CuMpxyBA;CvMqxyBA,qBuMvwyBE;AvMwwyBH;AACA;CACC;EACC,kBuMvwyBC;CvMwwyBF;AACD;;AAEA;CACC,auMlyyBD;AvMmyyBA;AACA;CACC;EACC,cuMpwyBS;CvMqwyBV;AACD;AACA;CACC,auMjwyBE;CvMkwyBF,WuM3yyBD;AvM4yyBA;AACA;CACC;EACC,cuMhwyBC;CvMiwyBF;CACA;EACC,kBuMhwyBY;EvMiwyBZ,auMhwyBO;EvMiwyBP,euMhwyBU;CvMiwyBX;AACD;;AAEA;CACC,uBuM/vyBa;AvMgwyBd;AACA;CACC,iBuM/vyBE;CvMgwyBF,gBuM7zyBD;CvM8zyBC,mBuM/vyBY;AvMgwyBb;AACA;CACC,kBuMj0yBD;CvMk0yBC,iBuMzvyBa;CvM0vyBb,qBuMzvyBY;CvM0vyBZ,UuMzvyBS;CvM0vyBT,kBuMzvyBe;CvM0vyBf,uBuMzvyBkB;CvM0vyBlB,WuMzvyBE;CvM0vyBF,gBuMzvyBY;CvM0vyBZ,qBuMzvyBgB;AvM0vyBjB;AACA;CACC,yBG/6yBmB;AHg7yBpB;AACA;CACC,yBuMzvyBa;AvM0vyBd;AACA;CACC,yBuMxvyBgB;AvMyvyBjB;AACA;CACC,yBuMr1yBmB;AvMs1yBpB;AACA;CACC,yBAAyB;AuMlvyB1B;AvMovyBA;CACC,yBuMlvyB4B;AvMmvyB7B;AACA;CACC,yBuM5uyBI;AvM6uyBL;AACA;CACC,oBsBj8yBS;AtBk8yBV;;AuM5vyBA;CvM+vyBC,sBuMjvyBoB;AvMkvyBrB;;AAEA;;CuM7uyBA,uBAAe;CvMgvyBd,cuM/uyBgB;AvMgvyBjB;;AAEA;;CuM3uyBA,uBAAkB;CvM8uyBjB,UuM7uyBY;AvM8uyBb;AACA;;CuMxuyBA,uBAAe;AvM2uyBf;;AAEA;CACC,kBuM9uyBc;AvM+uyBf;AACA;CiBn6yBI,SAAQ;CjBq6yBX,euMvuyBD;CvMwuyBC,qBuMtuyBuB;CvMuuyBvB,kBAAkB;AuMnuyBnB;AACA;CACA,aAAA;CvMquyBC,qBuMpuyBmB;CvMquyBnB,SAAS;CuMnuyBV,kBAAmB;CACnB,+BAAoB;AACpB;;AvMsuyBA;CACC,oBuMpuyBkB;CvMuuyBlB,auM5uyBD;CvM+uyBC,yBuM5uyBmB;AvM6uyBpB;AACA;CAGC,SuMtuyBG;AvMuuyBJ;AuMpuyBA;CvMsuyBC,kBuMruyBkB;CvMsuyBlB,iBuMruyBW;AvMsuyBZ;AACA;CACC,gBuMruyBc;CvMsuyBd,iBAAiB;CuMnuyBlB,kBAAmB;AvMquyBnB;AACA;CuMluyBA,gBAAgB;CvMouyBf,gBuMnuyBc;CvMouyBd,8CuMnuyBe;AvMouyBhB;AACA;CACC,gBAAgB;CuMjuyBjB,+BAAgC;AAChC;AACA;CACA,WAAK;CvMmuyBJ,cuMluyBe;CvMmuyBf,euMluyBW;CvMmuyBX,sCuMvuyBkC;CvMwuyBlC,qCuMpuyBY;CvMquyBZ,kBuMvuyBc;CvMwuyBd,QuMruyBO;CvMsuyBP,SAAS;CuMluyBV,gBAAA;CvMquyBC,0CuM/tyBG;AvMguyBJ;AuM5tyBA;CvM8tyBC,OuM5tyBC;CvM6tyBD,WAAW;CAEX,0CuMztyBe;AvM0tyBhB;AACA;CACC,kBuMztyBc;CvM0tyBd,kBsBx7yBW;CtBy7yBX,cuMztyBa;CvM0tyBb,gBuMztyBa;CvM0tyBb,SuMztyBA;CvM0tyBA,WuMztyBA;AvM0tyBD;AACA;CACC,YuM1tyBO;CvM2tyBP,UuM1tyBM;AvM2tyBP;;AuMv8yBA;CvM08yBC,gBuMztyBe;CvM0tyBf,oBuMztyBc;AvM0tyBf;AACA;CACC,iBuMztyBY;AvM0tyBb;AACA;CACC,iBGpjzBa;CHqjzBb,kBuMl9yBD;CvMm9yBC,iBuM1tyBa;AvM2tyBd;AACA;CACC,sBuM1tyBe;CvM2tyBf,gBAAgB;AuMryyBjB;AvMuyyBA;CACC,WAAW;CuMttyBZ,cAAA;CvMwtyBC,euMvtyBY;CvMwtyBZ,sCAAsC;CuMhizBvC,oCAAoC;CACpC,kBAAgB;CAChB,OAAK;CvMkizBJ,SuMvtyBO;CvMwtyBP,gBuMvtyBgB;CvMytyBhB,0CuMvtyByB;AvMwtyB1B;AACA;CACC,UuMvtyBY;CvMwtyBZ,QAAQ;CAER,2CuMttyBA;AvMutyBD;AuMhizBA;CvMkizBC,kBuMvtyBkB;CvMwtyBlB,mBuMttyBA;CvMutyBA,cAAc;CuMhizBf,gBAAgB;CvMkizBf,SuMvtyBU;CvMwtyBV,YuMvtyBU;AvMwtyBX;AgFlvyBA;ChFovyBC,WuMrtyBa;CvMstyBb,WAAW;AuMltyBZ;;AvMqtyBA;CACC,qBAAqB;CACrB,wBAAwB;AACzB;AACA;CACC,iBAAiB;CACjB,sBAAsB;CACtB,mBuMntyBG;CAGJ,eAAQ;AvMktyBR;AACA;CACC,cAAc;CuM/syBf,mBAAoB;AvMityBpB;AACA;CACC,oBAAoB;CuM/syBrB,qBAAA;CvMityBC,mBAAmB;CACnB,qBuMhtyBG;CACJ,cAAA;AvMityBA;AACA;CuM/syBA,qBACC;AvMgtyBD;;AuMl1yBA;CvMq1yBC,oBuM9syBS;CvM+syBT,sCAAsC;AwMxozBvC;AxM0ozBA;CACC,mBwMxozBA;AxMyozBD;AyM5ozBA;CzM8ozBC,gBC/hzBkB;ADgizBnB;AyM/ozBA;CzMipzBC,kByMtozBI;AzMuozBL;AyMlpzBA;CzMopzBC,kByMpozBmB;CzMqozBnB,QAAQ;CyMhozBT,SAAQ;AzMkozBR;;AAEA;C0MzpzBA,WAAW;A1M2pzBX;;AAEA;CACC,mB0M1pzBmB;A1M2pzBpB;;AAEA;CACC,aAAa;C0MzpzBd,cACC;C1M0pzBA,kB0MzpzBU;C1M0pzBV,c0MzpzBC;A1M0pzBF;;AAEA;CACC,6B0MxpzBE;A1MypzBH;;AAEA;CACC,c0MnqzBA;C1MoqzBA,a0MxpzBS;C1MypzBT,mBAAmB;A0MrpzBpB;;A1MwpzBA;;;;CAIC,sBsB3jzBW;AtB4jzBZ;;AAEA;;;;CAIC,e0M1pzBA;A1M2pzBD;;AAEA;;;;CAIC,e0MjqzBA;A1MkqzBD;;AAEA;;;;CAIC,e0MnpzBG;A1MopzBJ;;AAEA;;;;CAIC,e0MjpzBW;A1MkpzBZ;;AAEA;;;;CAIC,e0M/ozBS;A1MgpzBV;;AAEA;;;;CAIC,e0MlozBC;A1MmozBF;;A0M9nzBA;;C1MkozBC,a0MlozBW;A1MmozBZ;;AAEA;;CAEC,a0MhozBkB;A1MiozBnB;;AAEA;;CAEC,a0M5ozBD;A1M6ozBA;;AAEA;;CAEC,a0MjpzBW;A1MkpzBZ;;AAEA;CACC,kB0M/nzBG;C1MgozBH,qB0M1nzByB;C1M2nzBzB,U0M1nzBc;C1M2nzBd,mB0MlozBG;C1MmozBH,0B0MvnzBsB;C1MwnzBtB,uBAAuB;C0MlnzBxB,mBAAU;C1MonzBT,c0MnnzBgB;C1MonzBhB,kB0MnnzBgB;C1MonzBhB,oB0MnnzBiB;C1MonzBjB,U0MvnzBD;C1M2nzBC,+B0MjnzBS;A1MknzBV;;AAEA;CACC,U0MjnzBE;A1MknzBH;;AAEA;CACC,e0M5mzBW;A1M6mzBZ;;AAEA;CACC,e0MrmzBC;A1MsmzBF;;AAEA;C0M/mzBA,eAAA;A1MinzBA;;AAEA;CACC;EACC,WAAW;E0MrnzBb,UAAA;C1MunzBC;AACD;;AAEA;CACC,6BAA6B;A0MzlzB9B;;A1M4lzBA;CACC,0BGjwzB+B;AHkwzBhC;;AAEA;CACC,4B0MjmzBgB;A1MkmzBjB;;AAEA;CACC,yB0MrmzBgB;A1MsmzBjB;;AAEA;CACC,yB0MzlzBM;A1M0lzBP;;AAEA;;;CAGC,4BGvxzByB;AHwxzB1B;;AAEA;;;CAGC,wB0MxlzBgB;A1MylzBjB;;AAEA;CACC,iB0MxlzBc;A1MylzBf;;AAEA;CACC,kBGjyzBmB;CHkyzBnB,sB0M9nzBD;C1M+nzBC,c0MzlzBG;A1M0lzBJ;;AAEA;CACC,eGrzzBa;AHszzBd;;AAEA;CACC,gB0MvozBD;A1MwozBA;;AAEA;CACC,iB0MvlzBG;A1MwlzBJ;;AAEA;;;CAGC,2BG7xzByB;AH8xzB1B;;AAEA;CACC,6B0MrpzBgB;A1MspzBjB;;AAEA;CACC,a0MxlzBI;C1MylzBJ,mBGtyzBmB;AHuyzBpB;AACA;CACC,cG10zBO;CH20zBP,e0M9pzBD;C1M+pzBC,qB0MxlzBa;C1MylzBb,sB0MxlzBa;A1MylzBd;AACA;CACC,SAAS;CACT,uB0MpqzBD;A1MqqzBA;AACA;CACC,gB0MtlzBW;C1MulzBX,oB0MtlzBe;C1MulzBf,mB0MtlzBI;A1MulzBL;AACA;CACC,uB0MtlzBiB;C1MulzBjB,oB0M7qzBD;C1M8qzBC,kB0MtlzBK;C1MulzBL,e0MtlzBK;A1MulzBN;;AAEA;CACC,iBG31zBO;AH41zBR;;AAEA;CACC,aGp2zBC;AHq2zBF;;AAEA;;;;;CAKC,Y0M/rzBD;A1MgszBA;;AAEA;CACC,e0MllzBU;A1MmlzBX;;AAEA;CACC,6B0M9kzBC;C1M+kzBD,iBAAiB;C2Mh5zBlB,oBACC;C3Mi5zBA,+B2Mh5zB2B;C3Mi5zB3B,qB2Mz4zBmB;A3M04zBpB;;AAEA;CACC,oB2Ml5zBU;C3Mm5zBV,qBGl4zByB;AHm4zB1B;;AAEA;C2M74zBA,mBAAa;C3M+4zBZ,oB2M94zBe;C3M+4zBf,qBAAqB;A2M54zBtB;;A3M+4zBA;CACC,gB2M74zBc;C3M84zBd,4B2M54zBY;C3M64zBZ,W2M54zBC;A3M64zBF;;AAEA;CACC,kC2M54zBc;A3M64zBf;;AAEA;CACC,gB2M34zBE;A3M44zBH;;AAEA;CACC,uB2Mz4zBiB;A3M04zBlB;;AAEA;CACC,kB2Mt4zBW;C3Mu4zBX,U2Mt4zBC;C3Mu4zBD,0B2Mp6zBD;C3Mq6zBC,W2Mr4zBC;A3Ms4zBF;;AAEA;CACC,sB2Mn4zBc;C3Mo4zBd,mB2Mn4zBc;C3Mo4zBd,kB2Mt4zBA;C3Mu4zBA,oB2Mn4zBe;C3Mo4zBf,W2M76zBD;A3M86zBA;;AAEA;CACC,yB2Mp4zBS;C3Mq4zBT,kB2Mh4zBU;C3Mi4zBV,kB2Mn7zBW;C3Mo7zBX,W2M/3zBE;C3Mg4zBF,wBGt7zBmB;AHu7zBpB;;AAEA;CACC,wB2M93zBC;C3M+3zBD,U2M93zBE;C3M+3zBF,S2M37zBD;C3M47zBC,Y2M73zBQ;C3M83zBR,gB2M73zBY;A3M83zBb;;AAEA;;GGj8zBE;AHo8zBF;;;;;;;;CAQC,wB2Mv3zBY;A3Mw3zBb;;AAEA;CACC,4B2Mv3zBW;A3Mw3zBZ;;AAEA;;;;CAIC,gBAAgB;A2Mr3zBjB;;A3Mw3zBA;;;;CAIC,W2Mp3zBU;C3Mq3zBV,cAAc;A2M73zBf;A3M+3zBA;;;;CAIC,0B2Mn3zBc;C3Mo3zBd,sB2Mn3zBiB;A3Mo3zBlB;;AAEA;;;;;;CAMC,0BAA0B;A2M74zB3B;;A3Mg5zBA;CACC,yB2Mh3zBU;A3Mi3zBX;;AAEA;CACC,kB2Mh3zBgB;C3Mi3zBhB,kB2Mx3zBA;A3My3zBD;AACA;CACC,kB2M33zBA;C3M43zBA,S2Mh3zBG;C3Mi3zBH,Q2Mh3zBG;C3Mi3zBH,gC2M/2zBG;C3Mg3zBH,qBG5+zByB;AH6+zB1B;AACA;CACC,gB2Ml4zBA;C3Mm4zBA,iB2M92zBS;C3M+2zBT,kB2Mp4zBA;A3Mq4zBD;AACA;CACC,c2Mv4zBA;C3Mw4zBA,c2M72zBG;A3M82zBJ;;AAEA;CACC,eGz/zBmB;AH0/zBpB;;AAEA;CACC,e2M12zBY;C3M22zBZ,W2M12zBE;A3M22zBH;;AAEA;CACC,iB2M12zBG;C3M22zBH,W2M12zBG;A3M22zBJ;;AAEA;CACC,iB2M32zBY;C3M42zBZ,W2M32zBI;A3M42zBL;;AAEA;CACC,iB2Mz2zBU;C3M02zBV,W2Mz2zBG;A3M02zBJ;;AAEA;CACC,W2Mz2zBQ;C3M02zBR,iB2Mr6zBA;A3Ms6zBD;;AAEA;CACC,WGth0Ba;CHuh0Bb,iB2M16zBA;A3M26zBD;;AAEA;CACC,W2Mp2zBU;C3Mq2zBV,iB2Mp2zBO;A3Mq2zBR;;AAEA;CACC,W2Mp2zBS;C3Mq2zBT,iB2Mp2zBE;A3Mq2zBH;;AAEA;CACC,a2Mj2zBY;A3Mk2zBb;;AAEA;CACC,kB2M57zBA;C3M67zBA,O2M91zBI;C3M+1zBJ,QAAQ;C2Mz1zBT,kBAAc;C3M21zBb,gB2M11zBQ;C3M21zBR,c2M11zBe;A3M21zBhB;AACA;CACC,S2Mz1zBE;C3M01zBF,qB2M71zBA;C3M81zBA,gB2Mx1zBc;C3My1zBd,W2Mx1zBI;A3My1zBL;;AAEA;CACC,S2Mx1zBI;C3My1zBJ,0B2Mx1zBwB;C3My1zBxB,W2Mx2zBD;C3My2zBC,4B2Mv1zByB;C3Mw1zBzB,mB2Mv2zBA;A3Mw2zBD;;AAEA;CACC,S2Mr1zBK;C3Ms1zBL,gBGpl0Ba;CHql0Bb,W2Mh3zBD;A3Mi3zBA;;AAEA;;CAEC,S2Mh1zBC;C3Mi1zBD,qBGjl0BmB;CHkl0BnB,0B2Mr1zBA;C3Ms1zBA,W2Mj1zBE;C3Mk1zBF,4B2Mv1zBA;A3Mw1zBD;;AAEA;CACC,qC2M90zBiB;C3M+0zBjB,sBsBz/zBW;CtB0/zBX,qB2M90zBC;C3Mg1zBD,8C2M90zBY;A3M+0zBb;;AAQA;CACC;EGjm0BC,6BAAwB;CHmm0BzB;AACD;;AAEA;CAEC,4CAA4C;A2Mr0zB7C;;A3Mm1zBA;CACC;EACC,iB2Mn0zBC;E3Mo0zBD,iB2Mn0zBW;C3Mo0zBZ;CACA;EACC,iB2Ml0zBc;E3Mm0zBd,sBG5o0BkB;CH6o0BnB;AACD;;AAEA;CAEC,kC2M9zzBC;A3M+zzBF;;AAEA;CACC,a2M9zzBU;C3M+zzBV,e2M9zzBY;C3Mg0zBZ,6B2M9zzBW;A3M+zzBZ;;AAWA;CACC;EACC,uB2M5zzBW;C3M6zzBZ;CACA;EACC,qB2M5zzBW;C3M6zzBZ;AACD;;AAEA;CACC;EACC,sB2MxzzBc;E3MyzzBd,yBsBvk0BkB;EtBwk0BlB,uB2M/zzBD;C3Mg0zBA;AACD;;AAEA;CACC,2B2MjzzBwB;A3MkzzBzB;;AAEA;CACC,a2MvzzBS;A3MwzzBV;;AAEA;;CAEC,W2MhzzBG;C3MizzBH,iB2MhzzBG;A3MizzBJ;;AAEA;CACC,gB2Mj0zBD;C3Mk0zBC,c2M/yzBU;C3MgzzBV,gBAAgB;C2MvyzBjB,iBAAY;C3MyyzBX,Y2MxyzBA;C3MyyzBA,uB2MxyzBgB;C3MyyzBhB,qB2M3yzBW;A3M4yzBZ;AACA;;;CAGC,gB2MtyzBc;C3MuyzBd,gB2MtyzBW;C3MuyzBX,c2MtyzBU;A3MuyzBX;AACA;CACC,4B2MrzzBD;C3MszzBC,gD2MpyzBG;A3MqyzBJ;AACA;CACC,mBAAmB;C2MhyzBpB,qBAAK;C3MkyzBJ,W2MjyzBO;A3MkyzBR;AACA;CACC,iB2MjyzBY;A3MkyzBb;;AAEA;CACC,0BsBxn0BmB;CtByn0BnB,qB2MjyzBG;C3MkyzBH,iB2MjyzBc;C3MkyzBd,gB2MjyzBa;A3MkyzBd;;AAEA;CACC,sB2MvxzBA;A3MwxzBD;;AAEA;;CAEC,4B2MryzBY;A3MsyzBb;;A2M3xzBA;;C3M+xzBC,gC2M3xzBS;C3M4xzBT,W2M3xzBS;A3M4xzBV;;AAEA;;CAEC,qBAAqB;A2MryzBtB;;A3MwyzBA;;CAEC,yBAAyB;C2M1yzB1B,WAuBC;A3MqxzBD;;AAEA;;CAEC,qB2MpxzBiB;A3MqxzBlB;;AAEA;;CAEC,yB2MjxzBU;C3MkxzBV,W2MjxzBU;A3MkxzBX;;AAEA;;CAEC,qBGpt0BgB;AHqt0BjB;;AAEA;;CAEC,yB2MhxzBG;C3MixzBH,W2MhxzBY;A3MixzBb;;AAEA;;CAEC,qB2M5wzBmB;A3M6wzBpB;;AAEA;;CAEC,yBG9t0BoB;CH+t0BpB,W2MrxzBD;A3MsxzBA;;A2M1wzBA;;C3M8wzBC,4BAA4B;AGlx0BrB;;AHqx0BR;;CAEC,6B2M5wzBgB;C3M6wzBhB,4BG5u0BoB;CH6u0BpB,qBG5u0BgB;AH6u0BjB;;AAEA;;CAEC,qB2M7wzBY;A3M8wzBb;;AAEA;;CAEC,6B2M7wzBc;C3M8wzBd,qB2M7wzBW;C3M8wzBX,c2M7wzBS;A3M8wzBV;;AAEA;;CAEC,qBG9v0BA;AH+v0BD;;AAEA;;CAEC,6BAA6B;CG7z0BtB,qBAAkB;CH+z0BzB,c2M7yzBD;A3M8yzBA;;AAEA;;CGpz0BQ,qBAAkB;AHuz0B1B;;AAEA;;CGv00BQ,6BAAwB;CH000B/B,qB2M1wzBC;C3M2wzBD,c2M1wzBW;A3M2wzBZ;;AAEA;;CAEC,qB2M1wzBoB;A3M2wzBrB;;AAEA;;CAEC,6B2MxwzBiB;C3MywzBjB,qB2MxwzBc;C3MywzBd,c2MxwzBW;A3MywzBZ;;AAEA;CACC,mBAAmB;C2MlwzBpB,uBAAe;C3MowzBd,uB2MhvzBA;C3MivzBA,gBGz10Ba;CH010Bb,e2MtwzBD;C3MuwzBC,yB2MnvzBA;A3MovzBD;;AAEA;CACC,c2MjwzBE;C3MkwzBF,uB2MjwzBkB;A3MkwzBnB;;AAEA;;CAEC,U2MjwzBG;A3MkwzBJ;;AAEA;CACC,gB2M5vzBiB;C3M6vzBjB,qB2M5vzBsB;C3M6vzBtB,c2M5vzBW;A3M6vzBZ;AACA;CACC,gB2M5vzBgB;C3M6vzBhB,4B2M5vzBsB;C3M6vzBtB,qB2M5vzBqB;A3M6vzBtB;;AAEA;CACC,mB2M5vzBgB;C3M6vzBhB,mB2M5vzBc;C3M6vzBd,W2M5vzBA;A3M6vzBD;AACA;CACC,oC2MhuzBA;C3MiuzBA,sC2M5vzBG;C3M6vzBH,c2M5vzBY;A3M6vzBb;;AAEA;CACC,Y2MpxzBD;A3MqxzBA;;AAEA;;CAEC,gB2MvvzBY;C3MwvzBZ,U2MvvzBQ;A3MwvzBT;;AAEA;CACC,+B2MtvzBkB;C3MuvzBlB,gB2MtvzBe;A3MuvzBhB;AACA;CACC,mB2MtvzBuB;C3MuvzBvB,sCAAsC;A2MpvzBvC;;A3MuvzBA;CGj50BE;;;;;;;MyMnBA;A5M660BF;AACA;;;CAGC,kBGx60Ba;CHy60Bb,c4M170BU;C5M270BV,S4M360BE;C5M460BF,gBAAgB;A4M570BjB;;A5M+70BA;CACC,uB4M950BC;A5M+50BF;;AAEA;CACC,SG960Ba;CH+60Bb,gB4Ml70BA;C5Mm70BA,S4M160BE;C5M260BF,YGt70BO;AHu70BR;;AAEA;C4M180BA,gCAmCE;A5My60BF;;AAEA;CACC,2CGz70B0C;AH070B3C;;AAEA;CACC,S4Mn90BD;C5Mo90BC,gB4Mv60Ba;C5Mw60Bb,SAAS;C4Mn60BV,YAAQ;C5Mq60BP,mB4Mp60BkB;A5Mq60BnB;;A4Mj60BA;C5Mo60BC,gC4Mn60BG;A5Mo60BJ;AACA;CACC,sB4Mn60BI;C5Mo60BJ,S4Mn60BG;A5Mo60BJ;;AAEA;CACC,qB4Mn60Bc;A5Mo60Bf;A6Mp+0BA;C7Ms+0BC,S6Mr+0BA;C7Ms+0BA,S6Mr+0BS;C7Ms+0BT,qB6Mr+0BqB;C7Ms+0BrB,sB6Mp+0BA;C7Mq+0BA,eAAe;C6Mp+0BhB,gBACI;A7Mq+0BJ;;A6Mh+0BA;C7Mm+0BC,kB6Ml+0BW;C7Mm+0BX,iB6Mj+0BY;A7Mk+0Bb;;AAEA;CACC,gC6Mj+0BkB;A7Mk+0BnB;;AAEA;CACC,mB6Mj+0BU;C7Mk+0BV,sB6Mx+0BA;C7My+0BA,qB6Mj+0BY;C7Mk+0BZ,qB6Mj+0Ba;C7Mk+0Bb,gC6Mj+0Be;A7Mk+0BhB;;AAEA;CACC,kB6Mj+0BY;C7Mk+0BZ,uB6Mj+0BO;C7Mk+0BP,qBsBv/0BW;CtBw/0BX,qB6Mj+0Bc;C7Mk+0Bd,kC6Mh+0BC;A7Mi+0BF;;AAEA;CACC,sB6Mh+0BmB;A7Mi+0BpB;AACA;CACC;EACC,sB6M3/0BD;C7M4/0BA;AACD;;AAEA;CACC,mB6M590BgB;A7M690BjB;;AAEA;CACC,sB6Mpg1BA;A7Mqg1BD;;A6Ml90BA;C7Mq90BC,sBsB9g1BW;AtB+g1BZ;;AAEA;CACC,8BsBvg1BkB;AtBwg1BnB;;AAEA;CACC,e6Mn90BC;C7Mo90BD,gB6M990BD;A7M+90BA;;AAEA;CACC,S6Ml90BE;A7Mm90BH;;AAEA;CACC,2C6Ml90BwB;A7Mm90BzB;;AAEA;CACC,2C6Ml90BoB;A7Mm90BrB;;AAEA;CACC,oC6Mj90BE;A7Mk90BH;;AAEA;CACC,iB6Mh90BY;C7Mi90BZ,Y6Mh90BQ;C7Mi90BR,iB6Mp/0BD;A7Mq/0BA;AACA;CACC;EACC,YG3i1BM;EH4i1BN,iB6Mz/0BF;E7M0/0BE,iB6M/80BW;C7Mg90BZ;A6M180BD;;A7M680BA;CACC,iB6M380BG;C7M480BH,kB6M380Be;A7M480BhB;;AAEA;CACC,e6M380BG;A7M480BJ;;AAEA;CACC,c6M380BiB;A7M480BlB;;AAEA;CACC,qC6M380BgB;C7M480BhB,wC6M380BiC;A7M480BlC;;AAEA;CACC,oC6M380BkC;C7M480BlC,uC6M180BiB;A7M280BlB;;AAEA;CACC,kB6Mz80BG;C7M080BH,oB6Mx80BI;C7My80BJ,wB6Mv80BG;C7Mw80BH,uB6Mt80BoB;C7Mu80BpB,wC6Mt80BiC;C7Mu80BjC,wC6Mt80B2B;C7Mu80B3B,wCsBrl1BW;CtBsl1BX,wC6Ml80BQ;C7Mm80BR,wC6Mt80BU;C7Mu80BV,wC6Mr80BQ;C7Ms80BR,wC6Ml80BgB;C7Mm80BhB,wC6Ml80ByB;C7Mm80BzB,wC6Mt70BI;C7Mu70BJ,2C6Ml80BS;C7Mm80BT,2C6Mz70BQ;C7M070BR,2C6Ml80Ba;C7Mm80Bb,2C6M570BY;C7M670BZ,2C6Mp80Ba;C7Mq80Bb,2CsBjm1BW;CtBkm1BX,2C6Ml80BsC;C7Mm80BtC,2C6Mj80BgB;C7Mk80BhB,2CAA2C;C6M570B5C,uCAAU;C7M870BT,wC6Mj70BA;C7Mk70BA,uCGjm1BoC;CHkm1BpC,wC6Mh80BS;C7Mi80BT,gB6M970BU;A7M+70BX;;AAEA;CACC,iB6M570BG;C7M670BH,0B6M570B4B;C7M670B5B,qB6M570BsB;A7M670BvB;;AAEA;CACC,uCAAuC;A6Mv70BxC;;A7M070BA;CACC,a6Mx70BW;A7My70BZ;;AAEA;CACC,Y6Mv70BC;A7Mw70BF;;AAEA;CACC,sB6Mt70BW;C7Mu70BX,a6Mt70BC;A7Mu70BF;;AAEA;CACC,aAAa;A6Ml70Bd;;A7Mq70BA;CACC,gB6Mn70Ba;A7Mo70Bd;;AAEA;CACC,a6Mn70BW;C7Mo70BX,sB6Mn70BQ;C7Mo70BR,c6Mn70BO;C7Mo70BP,e6Mn70BY;C7Mo70BZ,qB6Mn70Ba;C7Mo70Bb,6B6Mn70Ba;A7Mo70Bd;;AAEA;;CAEC,yBAAyB;C6Mh70B1B,aAAa;A7Mk70Bb;;AAEA;CACC,mB6Mj70BgB;A7Mk70BjB;;AAEA;CACC,sBAAsB;C8Mrq1BvB,iBAAQ;C9Muq1BP,qB8Mtq1BsB;C9Muq1BtB,W8Mtq1BG;C9Muq1BH,gB8Mtq1Ba;A9Muq1Bd;AACA;CACC,S8Mrq1BC;C9Msq1BD,eAAe;C8Mnq1BhB,mBAAW;C9Mqq1BV,gB8Mpq1Bc;C9Mqq1Bd,iCAAiC;C8Mjq1BlC,gBAAS;C9Mmq1BR,kB8Mlq1Bc;C9Mmq1Bd,gBAAgB;CAGhB,oB8Mjq1BqB;C9Mkq1BrB,sB8Mjq1B4B;A9Mkq1B7B;AACA;CACC,iC8Mjq1BqB;A9Mkq1BtB;AACA;CACC,iC8Mjq1BgC;C9Mkq1BhC,iC8Mjq1B0B;A9Mkq1B3B;AACA;CACC,Y8Mjq1BiB;C9Mkq1BjB,0B8Mhq1BI;A9Miq1BL;A8M/p1BA;C9Miq1BC,gB8Mhq1Bc;A9Miq1Bf;AACA;C8M/p1BA,WAAA;C9Miq1BC,mB8M/p1Bc;C9Mgq1Bd,Y8M/p1BY;C9Mgq1BZ,W8M/p1BE;C9Mgq1BF,kB8Mpq1BD;C9Mqq1BC,qB8M3p1BsB;C9M4p1BtB,e8M3p1Ba;C9M4p1Bb,O8Mvq1BD;C9M0q1BC,oB8Mxp1BmB;A9Myp1BpB;AACA;CACC,mBC7s1BkB;CD8s1BlB,e8Mxp1Bc;A9Myp1Bf;AACA;CACC,U8Mxp1BG;C9Myp1BH,c8Mlr1BD;C9Mmr1BC,Y8Mrp1BI;C9Msp1BJ,W8Mrp1BI;A9Msp1BL;AACA;CACC,uB8Mrp1BsB;C9Msp1BtB,c8Mrp1Bc;A9Msp1Bf;AACA;CACC,e8Mpp1Bc;A9Mqp1Bf;;AAEA;CACC,2B8Mpp1BuB;A9Mqp1BxB;;AAEA;CACC,6B8Mpp1Be;C9Mqp1Bf,qB8Mpp1Ba;C9Mqp1Bb,sB8Mnp1BK;C9Mop1BL,kC8Mts1BD;A9Mus1BA;AACA;CACC,6B8Mlp1B4B;C9Mmp1B5B,sC8Mzs1BC;A9M0s1BF;;AAEA;CACC,e8M9s1BD;C9M+s1BC,gB8M5o1BM;A9M6o1BP;;AAEA;CACC,a8Mnt1BD;C9Mot1BC,c8Mro1BI;A9Mso1BL;;AAEA;CACC,c8M/n1BA;C9Mgo1BA,e8M/n1BS;A9Mgo1BV;;AAEA;CACC,qBAAqB;C8Mxn1BtB,UAAA;C9M0n1BC,iD8Mpn1BI;A9Mqn1BL;;AAEA;CACC,yB8M9m1BqB;C9M+m1BrB,qB8M9m1BoB;A9M+m1BrB;;AAEA;CACC,qBsB1p1BW;CtB2p1BX,U8M9m1BC;C9M+m1BD,iDAAiD;A8Mxn1BlD;;A9M2n1BA;CACC,yB8M5m1BQ;C9M6m1BR,qBAAqB;A8M7n1BtB;;A9Mgo1BA;CACC,qB8M5m1BQ;C9M6m1BR,UAAU;C8M1m1BX,iDACc;A9M2m1Bd;;A8M5m1BA;C9M+m1BC,oC8M1m1BU;C9M2m1BV,qB8M1m1BC;A9M2m1BF;;A8Mnm1BA;C9Msm1BC,qB8Mrm1BuB;C9Msm1BvB,U8Mrm1BW;C9Msm1BX,kD8Mrm1BuB;A9Msm1BxB;;AAEA;CACC,yBG7w1B+B;CH8w1B/B,qB8M7m1BM;A9M8m1BP;;AAEA;CACC,qB8Mpm1Ba;C9Mqm1Bb,U8Mpm1Bc;C9Mqm1Bd,kD8Mpm1BsB;A9Mqm1BvB;;AAEA;CACC,yB8Mnm1BO;C9Mom1BP,qB8Mlm1BI;A9Mmm1BL;;AAEA;CACC,oB8Mlm1BU;A9Mmm1BX;AACA;CACC,qB8Mlm1BqB;C9Mmm1BrB,gB8Mlm1BO;A9Mmm1BR;AACA;CACC,c8Mlm1BgB;A9Mmm1BjB;AACA;;CAEC,c8Mjm1Be;C9Mkm1Bf,a8Mjm1Bc;C9Mkm1Bd,W8Mjm1BO;C9Mkm1BP,8B8Mjm1BsB;C9Mkm1BtB,mC8Mjm1BqB;A9Mkm1BtB;AACA;CACC,gB8Mjm1BmB;A9Mkm1BpB;;A8M7l1BA;C9Mgm1BC,iB8M9l1BmB;C9M+l1BnB,YAAY;A8M5l1BX;;A9M+l1BF;C8M3l1BE,gCAAiC;C9M6l1BlC,4BC/01BgB;ADg11BjB;;A8M1l1BE;C9M6l1BD,4BCn11BgB;CDo11BhB,iC8M5l1BqB;A9M6l1BtB;;AAEA;CACC,e8M3l1Ba;C9M4l1Bb,mB8M1l1BE;C9M2l1BF,gBAAgB;C8Mxl1Bf,kBAAY;C9M0l1Bb,qB8Mxl1BE;C9Myl1BF,sBAAsB;C8Mxl1BrB,mBAAmB;C9M0l1BpB,c8Mzl1BY;A9M0l1Bb;AACA;C8Mxl1BE,gBAAiB;A9M0l1BnB;;AAEA;CACC,gB8Mzl1BkB;A9M0l1BnB;;A8Mvl1BE;C9M0l1BD,sB8Mxl1BA;C9Myl1BA,uCAAuC;C8Mtl1BxC,oCAAY;A9Mwl1BZ;AACA;CACC,W8Mvl1BG;C9Mwl1BH,gB8Mvl1BkB;C9Mwl1BlB,e8Mvl1Bc;C9Mwl1Bd,gC8M1j1BA;C9M2j1BA,kB8Mvl1BQ;C9Mwl1BR,a8Mvl1BiB;C9Mwl1BjB,c8Mvl1Ba;C9Mwl1Bb,kB8Mvl1Bc;A9Mwl1Bf;;AAEA;CACC,qB8Mtl1BM;A9Mul1BP;;AAEA;CACC,yB8Mpl1BI;A9Mql1BL;AACA;CACC,yB8Mpl1Be;A9Mql1BhB;;AAEA;CACC,qB8Mpl1BkB;A9Mql1BnB;;AAEA;CACC,yB8Mnl1BM;A9Mol1BP;A8Mhl1BE;C9Mkl1BD,yB8Mjl1BqB;A9Mkl1BtB;;A8M9k1BE;C9Mil1BD,qB8Mhl1Bc;A9Mil1Bf;;AAEA;C8M7k1BE,yBAAyB;A9M+k1B3B;AACA;C8M7k1BE,yBAAyB;A9M+k1B3B;;AAEA;CACC,qB8M9k1BqB;A9M+k1BtB;;AAEA;CACC,yBAAyB;A8M7k1BxB;A9M+k1BF;CACC,yBAAyB;A8M1k1BxB;;A9M6k1BF;CACC,qBAAqB;A8M1k1BpB;;A9M6k1BF;C8Mvk1BE,uBAAY;A9Myk1Bd;AACA;C8Mtk1BA,gCACW;A9Muk1BX;;A8Mlk1BA;C9Mqk1BC,qBCj71BS;ADk71BV;;AAEA;CACC,yB8Mrj1BA;A9Msj1BD;AACA;CACC,yB8Mxj1BA;A9Myj1BD;;AAEA;CACC,uB8Mhl1BU;C9Mil1BV,kB8Mlk1BY;A9Mmk1Bb;A8M5j1BA;C9M8j1BC;E8M5j1BA,kBAAS;C9M8j1BT;AACD;AACA;;CAEC,a8M5j1BG;A9M6j1BJ;;AAEA;CACC,Y8Mxj1BG;C9Myj1BH,a8Mxj1BO;A9Myj1BR;AACA;;CAEC,c8Mlj1BW;C9Mmj1BX,e8M9k1BO;A9M+k1BR;;A8Mvi1BA;C9M0i1BC,c8Mzi1BY;C9M0i1BZ,a8Mzi1Bc;A9M0i1Bf;A8Mri1BA;;C9Mwi1BC,c8Mri1BC;C9Msi1BD,e8Mri1Bc;A9Msi1Bf;;AGx91BE;CH291BD,Y8Mni1BQ;C9Moi1BR,a8Mli1BS;A9Mmi1BV;A8M/h1BA;;C9Mki1BC,e8Mhi1Ba;C9Mii1Bb,gB8M/h1BA;C9Mgi1BA,cAAc;A8M7h1Bf;;A9Mgi1BA;CACC,gB8Mji1BY;A9Mki1Bb;AACA;;CAEC,gB8Mxh1BgB;C9Myh1BhB,a8M1h1BD;A9M2h1BA;;AAEA;CACC,Y8Mzh1BO;C9M0h1BP,aGj+1BO;AHk+1BR;AACA;;CAEC,c8Mni1BD;C9Moi1BC,e8Mzh1BkB;A9M0h1BnB;;AAEA;CACC,c8Mxi1BD;C9Myi1BC,a8Mzh1BG;A9M0h1BJ;AACA;;CAEC,c8Mrh1BgB;C9Msh1BhB,e8Mrh1Be;A9Msh1BhB;;AAEA;CACC,Y8Mth1BgB;C9Muh1BhB,aG1/1BO;AH2/1BR;AACA;;CAEC,e8Mvj1BD;C9Mwj1BC,gB8Mth1BoB;C9Muh1BpB,c8Mzj1BY;A9M0j1Bb;;AAEA;C8Mhh1BA,gCAAkB;C9Mkh1BjB,6B8Mjh1ByB;A9Mkh1B1B;AACA;CACC,gB8Mjh1Be;A9Mkh1BhB;;AAEA;CACC,gC8Mhh1BK;C9Mih1BL,6B8M3g1BI;A9M4g1BL;AACA;CACC,gB8Mhh1BoB;A9Mih1BrB;;AAEA;CACC,gC8M5g1BA;C9M6g1BA,6BAA6B;A8M5g1B9B;A9M8g1BA;CACC,gB8M5g1BA;A9M6g1BD;;A8Mxg1BA;C9M2g1BC,c8M1g1Ba;A9M2g1Bd;;AAEA;CACC,4B8Mzg1Be;A9M0g1BhB;;A8Mrg1BA;C9Mwg1BC,eClj2BkB;ADmj2BnB;A8Mtg1BA;C9Mwg1BC,a8Mvg1BS;A9Mwg1BV;AACA;CACC,a8Mvg1BC;A9Mwg1BF;AACA;C8Mpg1BA,qBAAiB;A9Msg1BjB;;AAEA;CACC,gB8Mrg1BkB;A9Msg1BnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,c8Mxg1BkB;C9Myg1BlB,Y8Mlh1BD;C9Mmh1BC,kB8Mxg1BQ;C9Myg1BR,Q8Mxg1BW;C9Myg1BX,M8Mrh1BD;C9Msh1BC,gB8Mtg1BO;A9Mug1BR;;AAEA;CACC,O8M1h1BD;C9M2h1BC,W8Mpg1Be;A9Mqg1BhB;;AAEA;CACC,oC8M9/0Be;A9M+/0BhB;;AAEA;CACC,a8M9/0BW;C9M+/0BX,kBAAkB;C8M7/0BnB,WAAY;C9M+/0BX,qB8M9/0BsB;C9M+/0BtB,W8M9/0Ba;A9M+/0Bd;;A8M5/0BC;C9M+/0BA,gC8M3/0BC;A9M4/0BF;A8M3/0BC;C9M6/0BA,gC8M1/0B4B;A9M2/0B7B;;A8Mr/0BA;CACA,gCACgB;C9Mu/0Bf,4B8Mr/0BC;A9Ms/0BF;;A8Ml/0BA;C9Mq/0BC,gB8Mp/0BW;C9Mq/0BX,wB8Mp/0BY;C9Mq/0BZ,+B8Mp/0BiB;A9Mq/0BlB;AACA;;;CAGC,gB8Mp/0BO;C9Mq/0BP,0B8M/+0BC;C9Mg/0BD,UG/l2Ba;CHgm2Bb,kB8M//0BM;C9Mgg1BN,gB8Mr/0BQ;C9Ms/0BR,uB8Mr/0BgB;A9Ms/0BjB;AACA;;;CAGC,iB8Mtg1BM;C9Mug1BN,yB8Mn/0BY;C9Mo/0BZ,uC8Mh/0BC;A9Mi/0BF;AACA;;;CAGC,gB8M7g1BM;C9M8g1BN,W8Mh/0BE;A9Mi/0BH;AACA;CACC,gB8M9+0BW;A9M++0BZ;;A8M1+0BA;;C9M8+0BC,gC8M5+0BY;C9M6+0BZ,uB8M5+0BiB;C9M6+0BjB,S8M5+0BA;C9M6+0BA,W8M5+0BU;C9M6+0BV,sB8M5+0BqB;C9M6+0BrB,kB8M5+0Be;A9M6+0BhB;;AAEA;CACC,uB8M9+0BG;C9M++0BH,yB8M7+0BC;A9M8+0BF;AACA;CACC,gC8M5+0Ba;C9M6+0Bb,gE8M5+0Be;C9M6+0Bf,c8M5+0BQ;A9M6+0BT;;AAEA;CACC,gE8M3+0BC;C9M4+0BD,c8Mlg1BQ;A9Mmg1BT;AACA;CACC,gE8Mx+0BC;C9My+0BD,c8Mtg1BQ;A9Mug1BT;;AAEA;CACC,iC8M/90BC;A9Mg+0BF;;AAEA;CACC,iC8Mx+0B0B;A9My+0B3B;;AAEA;CACC,iC8Mr+0BgB;C9Ms+0BhB,uB8Mr+0Be;A9Ms+0BhB;;A8Mj+0BA;;C9Mq+0BC,aAAa;A8M/90Bd;;A9Mk+0BA;CACC,wC8Mx80BA;A9My80BD;AACA;CACC,wC8M380BA;C9M480BA,gD8M990BS;A9M+90BV;;AAEA;CACC,mB8M590BA;C9M690BA,wB8M590BkB;A9M690BnB;;AAEA;CACC,kB8M190BA;C9M290BA,yB8M190BW;A9M290BZ;;AAEA;C8Mx90BA,eACY;A9My90BZ;;A8M190BA;;;;C9Mg+0BC,kBAAkB;C8Ml90BnB,uBACgB;C9Mm90Bf,uB8Ml90BmB;A9Mm90BpB;;AAEA;CACC,mBAAmB;C8Mh90BpB,uBAAoB;A9Mk90BpB;;AAEA;;;;CAIC,uB8Mx80BG;A9My80BJ;;AAEA;CACC,qBAAqB;A8Mr90BrB;;A9Mw90BD;C8Mx90BC,WAAA;A9M090BD;;AAEA;C8M590BC,SAAA;C9M890BA,c8Mx80BS;A9My80BV;AACA;CACC,a8Mx80BW;A9My80BZ;AACA;CACC,yB8Mt80BI;C9Mu80BJ,uBAAuB;C8Mr+0BvB,qBAAiB;A9Mu+0BlB;AACA;CACC,cAAc;A8Mz+0Bd;A9M2+0BD;CACC,c8Mr80BU;C9Ms80BV,gBAAgB;A8M7+0BhB;A9M++0BD;CACC,mBAAmB;C8Mj80BpB,cAAA;C9Mm80BC,yB8M970BG;C9M+70BH,kCAAkC;C8Mp80BnC,mBAQC;C9M870BA,kB8M570BkB;C9M670BlB,cCtq2BW;ADuq2BZ;AACA;C8Mx70BA,YAAU;CAIV,qBACa;A9Ms70Bb;;AAEA;CACC,mB8Mr70B0B;C9Ms70B1B,0B8Mr70BiC;C9Ms70BjC,8B8Mr70ByB;A9Ms70B1B;;AAEA;CACC,yB8Mr70B0B;A9Ms70B3B;;AAEA;CACC,8H8Mr70B0B;C9Ms70B1B,kB8Mr70B6B;C9Ms70B7B,oBGxx2Ba;AHyx2Bd;;AAEA;CACC,a8Mp70BuB;A9Mq70BxB;;A8M960BA;C9Mi70BC,U8Mh70BW;A9Mi70BZ;;AAEA;CACC,cAAc;C8M960Bf,cAAA;A9Mg70BA;;AAEA;CACC,eAAe;A8M5y1BhB;;A9M+y1BA;CACC,e8M560BS;A9M660BV;;AAEA;CACC,mB8Mp70BA;A9Mq70BD;AACA;CACC,W8Mv60BG;C9Mw60BH,oB8Mv60Ba;C9Mw60Bb,qB8Mv60Ba;C9Mw60Bb,gB8Mv60BgB;C9Mw60BhB,0B8Mv60BW;A9Mw60BZ;AACA;CACC,0B8Ml70BC;A9Mm70BF;AACA;CACC,Y8Mt60BS;C9Mu60BT,Y8Mt60BG;A9Mu60BJ;AACA;CACC,WAAW;C8M/50BZ,cACE;A9Mg60BF;AACA;C8M550BA,WAAI;C9M850BH,e8Mv40BY;A9Mw40Bb;AACA;CACC,W8Mh60BA;C9Mi60BA,gB8M750BQ;C9M850BR,e8M750BU;A9M850BX;;AAEA;CACC,sB8Mr50BE;A9Ms50BH;;AAEA;CACC,uB8Mh50BC;C9Mi50BD,+B8M/40Bc;C9Mg50Bd,Y8M/40BQ;C9Mg50BR,gB8M/40BY;A9Mg50Bb;AACA;CACC,mB8M740BW;C9M840BX,sCG502BoC;AH602BrC;AACA;;;CAGC,gB8M550BC;A9M650BF;;AAEA;;CAEC,W8Mv40BK;C9Mw40BL,mB8Mv40Bc;C9Mw40Bd,YGx12BO;CHy12BP,e8Mv40BA;C9Mw40BA,mB8Mv40BA;A9Mw40BD;;AAEA;CACC,iB8Mp40Bc;C9Mq40Bd,c8Mp40BC;C9Mq40BD,uBAAuB;CGh22BtB,kBAAkB;AHk22BpB;;AAEA;CACC,qB8M730Ba;C9M830Bb,gBAAgB;A8M330BjB;;A9M830BA;C8Mn30BI,gBAAA;A9Mq30BJ;;AAEA;CACC,gC8Ml30BqC;A9Mm30BtC;;AAEA;CACC,qBAAqB;C8Mn20BtB,gBAAY;C9Mq20BX,iB8Mp20BgB;A9Mq20BjB;;AAEA;CACC,a8Mp20BA;C9Mq20BA,gBsB9x2BW;AtB+x2BZ;;AAEA;CACC,gB8Mp20BA;C9Mq20BA,c8Mp20BQ;C9Mq20BR,uB8Mp20BiB;C9Mq20BjB,+B8Mp20BS;A9Mq20BV;AACA;CACC,mB8Mp20Ba;C9Mq20Bb,sCC3v2BuB;AD4v2BxB;;AAEA;CACC,mB8Mn20Bc;C9Mo20Bd,sC8Mn20Be;C9Mo20Bf,+BsB/y2BW;AtBgz2BZ;;AAEA;CACC,qB8Mr30BA;A9Ms30BD;AACA;CACC,mB8Mx30BA;C9My30BA,sCsBv62BW;AtBw62BZ;;AAEA;CACC,iB8Mj20BE;A9Mk20BH;;AAEA;CACC,c8Mj20BQ;A9Mk20BT;;AAEA;CACC,kB8M110BK;C9M210BL,oB8M110BW;C9M210BX,wB8M110BkB;C9M210BlB,uB8M110BwB;C9M210BxB,wC8M110Bc;C9M210Bd,wC8M700BC;C9M800BD,wC8M110BO;C9M210BP,wC8M110BoB;C9M210BpB,wC8Mr10BE;C9Ms10BF,wC8M110BO;C9M210BP,wC8M110Be;C9M210Bf,wC8Mz10BG;C9M010BH,wC8Mx10BW;C9My10BX,2C8Mx10BoB;C9My10BpB,2C8Mv10BE;C9Mw10BF,2C8Mt10BO;C9Mu10BP,2C8Mv00BC;C9Mw00BD,2C8Mt10BQ;C9Mu10BR,2C8M/00BE;C9Mg10BF,2C8Mr10BM;C9Ms10BN,2C8Mr10BiB;C9Ms10BjB,2C8Mp10BI;C9Mq10BJ,uC8Ml10BG;C9Mm10BH,wC8Ml10BiB;C9Mm10BjB,uC8Ml10Ba;C9Mm10Bb,wC8Mj10BE;C9Mk10BF,gBAAgB;A8M/00BjB;;A9Mk10BA;;;;;;;;;CASC;AACD;CACC,S8M700BE;A9M800BH;AACA;CACC,2B8M1y0BC;C9M2y0BD,mBG182BmB;AH282BpB;AACA;CACC,a8M710Ba;A9M810Bd;AACA;CACC,kB8Mz00Bc;C9M000Bd,c8Mz00BW;C9M000BX,W8Mz00BE;C9M000BF,Y8Mz00BE;C9M000BF,wC8Mp00BE;A9Mq00BH;AACA;CACC,uB8Mz00BmB;C9M000BnB,W8Mx20BC;C9My20BD,Y8Mv00BE;C9Mw00BF,qC8Mv00Bc;C9Mw00Bd,c8Mt00BU;C9Mu00BV,iB8Mt00Be;C9Mu00Bf,qB8M500BC;C9M600BD,mB8Mt00Bc;C9Mu00Bd,Y8M/20BC;C9Mg30BD,sB8Mt00BS;C9Mu00BT,kBAAkB;C8Mh00BnB,UAAS;A9Mk00BT;AACA;CACC,sBsB1/2BW;CtB2/2BX,kB8M1z0BI;C9M2z0BJ,QAAQ;CGt/2BP,SAAM;CHw/2BP,iB8Mpz0BI;C9Mqz0BJ,2B8Mjz0BW;C9Mkz0BX,8BAA8B;C8M1y0B/B,UAAM;C9M4y0BL,W8Mvy0BI;A9Mwy0BL;A8M7y0BA;C9M+y0BC,0B8Mny0BK;C9Moy0BL,WAAW;A8M7x0BX;A9M+x0BD;CACC,qCAAqC;A8Mhy0BrC;A9Mky0BD;CACC,gCAAgC;C8M1w0BjC,WAAA;A9M4w0BA;AACA;CACC,qC8Mxw0BG;A9Myw0BJ;A8M/w0BA;C9Mix0BC,a8Mzw0BG;A9M0w0BJ;A8M/o2BA;C9Mip2BC,S8Mtw0BO;C9Muw0BP,yB8Mrw0BE;A9Msw0BH;AACA;CACC,U8Mpw0BE;A9Mqw0BH;AACA;CACC,asB7h3BO;CtB8h3BP,mBAAmB;C8M7v0BpB,uBAAc;C9M+v0Bb,sB8M9v0BY;C9M+v0BZ,Y8M9v0BU;C9M+v0BV,a8M9v0BA;C9M+v0BA,kB8Mlw0Ba;C9Mmw0Bb,e8M7v0BQ;C9M8v0BR,yBAAyB;C8M1v0B1B,kBAAY;C9M4v0BX,Y8M3v0BA;A9M4v0BD;AACA;CACC,yBAAyB;A8Mxv0B1B;A9M0v0BA;CACC;EACC,W8Mxv0BC;E9Myv0BD,YAAY;C8Mjv0Bd;A9Mmv0BA;AACA;CACC,e8Mlv0BA;C9Mmv0BA,qB8Mjv0BC;C9Mkv0BD,c8Mjv0BA;C9Mkv0BA,iB8Mjv0Bc;A9Mkv0Bf;AACA;CACC;EACC,e8Mhv0BS;C9Miv0BV;AACD;AACA;CACC,e8Mhv0BG;C9Miv0BH,kB8M3v0BA;C9M4v0BA,kB8M5u0BgB;A9M6u0BjB;AACA;CACC;EACC,kB8M1u0Bc;E9M2u0Bd,oB8M1u0Ba;C9M2u0Bd;AACD;AACA;CACC,a8M3w0BD;A9M4w0BA;AACA;CACC;EACC,gC8Mnu0BE;C9Mou0BH;CACA;EACC,uB8M/t0Be;C9Mgu0BhB;AACD;AACA;CACC;EACC,U8M3t0BO;C9M4t0BR;AACD;;AAEA;CACC,S8M1t0BC;C9M2t0BD,gB8Mzt0BA;A9M0t0BD;AACA;CACC,mB8Mlt0BC;C9Mmt0BD,gB8Mlt0BO;A9Mmt0BR;AACA;CACC,e8M/s0BA;C9Mgt0BA,gB8M/s0BQ;C9Mgt0BR,WAAW;A8M5s0BZ;A9M8s0BA;CACC,iB8M7s0BA;A9M8s0BD;;AAEA;CACC,qB8M7s0BS;A9M8s0BV;AACA;CACC,iB8M7s0BY;A9M8s0Bb;;AAEA;CACC,mB8M7s0Bc;A9M8s0Bf;;AAEA;CACC,a8M7s0BS;A9M8s0BV;;AAEA;CACC,8B8M7s0Be;A9M8s0BhB;;AAEA;CACC,gB8M7s0Ba;C9M8s0Bb,kB8M7s0Be;C9M8s0Bf,wB8M7s0BmB;C9M8s0BnB,gC8M7s0BW;C9M8s0BX,qB8M7s0BY;C9M8s0BZ,6C8M5s0BE;A9M6s0BH;;AAEA;CACC;EACC,a8M3s0BU;E9M4s0BV,e8Mjv0BF;E9Mkv0BE,mB8M3s0BS;E9M4s0BT,qB8M3s0Bc;C9M4s0Bf;A+Mvp3BD;;A/M0p3BA;;CAEC,e+M1p3BA;C/M2p3BA,c+M1p3BW;C/M2p3BX,qB+M1p3BU;C/M2p3BV,gC+Mzp3BC;C/M0p3BD,W+Mhq3BD;A/Miq3BA;;AAEA;CACC,cAAc;A+Mjp3Bf;;A/Mop3BA;;CAEC,a+Mjp3BA;A/Mkp3BD;AACA;CACC;;EAEC,iB+Mhp3BQ;C/Mip3BT;AACD;AACA;CACC;;EAEC,iB+Mjp3BW;C/Mkp3BZ;AACD;;AAEA;CACC,oB+Mhp3BU;A/Mip3BX;;AAEA;CACC,Y+Mjp3BU;A/Mkp3BX;;AAEA;CACC,Y+Mzo3BS;C/M0o3BT,qBGjr3BmB;AHkr3BpB;AACA;;C+Mpo3BA,eAAK;C/Muo3BJ,iB+Mto3BY;C/Muo3BZ,gBGvr3Ba;AHwr3Bd;;AAEA;CACC,gB+Mto3Bc;A/Muo3Bf;AACA;CACC,wC+M5n3BC;C/M6n3BD,gB+M3o3BA;A/M4o3BD;AACA;CACC,iD+Mxo3BQ;C/Myo3BR,8B+Mlo3BE;A/Mmo3BH;A+M/n3BA;;;C5MtDE,wBAAwB;CH0r3BzB,iB+M7n3BA;A/M8n3BD;AACA;;;CAGC,yB+Mln3BC;A/Mmn3BF;AACA;CACC,gC+Mrn3BC;C/Msn3BD,wDAAwD;A+M9n3BzD;A/Mgo3BA;CACC,mB+Mtn3Bc;A/Mun3Bf;AACA;CACC,gC+Mrn3BY;A/Msn3Bb;;AAEA;CACC,yB+Mrn3BY;C/Msn3BZ,4B+Mrn3BoB;A/Msn3BrB;;AAEA;C+Mln3BA,0BAAa;C/Mon3BZ,6B+Mln3BA;A/Mmn3BD;;AAEA;CACC,kB+Mln3Bc;C/Mmn3Bd,oBAAoB;C+M7m3BrB,wBAAmB;C/M+m3BlB,uB+M9m3BqB;C/M+m3BrB,wC+M9m3BmB;C/M+m3BnB,wC+Mhj3BA;C/Mij3BA,wC+M9m3BgB;C/M+m3BhB,wC+M9m3ByB;C/M+m3BzB,wC+M9m3BkB;C/M+m3BlB,wC+M9m3BiB;C/M+m3BjB,wC+M7k3BI;C/M8k3BJ,wC+M9m3BY;C/M+m3BZ,wC+Mhl3BQ;C/Mil3BR,2C+Mhn3BY;C/Min3BZ,2C+M9m3BoC;C/M+m3BpC,2C+M9m3B0B;C/M+m3B1B,2C+M9m3B2B;C/M+m3B3B,2C+M9m3B+B;C/M+m3B/B,2C+M9m3BkC;C/M+m3BlC,2C+M9m3BkC;C/M+m3BlC,2C+M9m3B4C;C/M+m3B5C,2C+M9m3B2C;C/M+m3B3C,uC+M9m3B8B;C/M+m3B9B,wC+M9m3BkC;C/M+m3BlC,uC+M9m3B8C;C/M+m3B9C,wC+M5n3BO;C/M6n3BP,gB+M9m3BmB;A/M+m3BpB;;AAEA;CACC,gC+M7m3BgC;A/M8m3BjC;AACA;CACC,gC+M7m3BqC;C/M8m3BrC,W+M7m3BmB;A/M8m3BpB;;AAEA;CACC,kB+M7m3B2B;C/M8m3B3B,oB+Mzm3BG;C/M0m3BH,wB+Mzm3BmB;C/M0m3BnB,uB+Mzm3BoB;C/M0m3BpB,wC+Mzm3ByB;C/M0m3BzB,wC+Mzm3B0B;C/M0m3B1B,wC+Mzm3BgC;C/M0m3BhC,wC+Mzm3BiB;C/M0m3BjB,wC+Mzm3BmC;C/M0m3BnC,wC+Mzm3BW;C/M0m3BX,wC+Mzm3BsB;C/M0m3BtB,wC+Mzm3Bc;C/M0m3Bd,wC+Mzm3B8B;C/M0m3B9B,2C+Mzm3BiC;C/M0m3BjC,2C+Mzm3BuC;C/M0m3BvC,2C+Mlm3BQ;C/Mmm3BR,2C+Mhn3BW;C/Min3BX,2C+Mxm3Be;C/Mym3Bf,2C+Mxm3Bc;C/Mym3Bd,2C+Mvm3BG;C/Mwm3BH,2CAA2C;C+Mpm3B5C,2CAAe;C/Msm3Bd,uC+Mpm3BA;C/Mqm3BA,wCAAwC;CgNpz3BzC,uCAAU;ChNsz3BT,wCgNrz3ByB;ChNsz3BzB,gBgNrz3BA;AhNsz3BD;;AAEA;CACC,SgNrz3BG;ChNsz3BH,UgNrz3BG;ChNsz3BH,oBgNrz3BG;ChNsz3BH,gBgNrz3Ba;ChNsz3Bb,qBgNrz3Bc;ChNsz3Bd,sBgNrz3Be;ChNsz3Bf,WgNrz3BS;AhNsz3BV;AACA;CACC,mBgNpz3BU;ChNqz3BV,gCgNhz3BG;ChNiz3BH,gBgNp03BA;ChNq03BA,mBgNpz3Bc;ChNqz3Bd,+BgNr03BC;AhNs03BF;AACA;CACC,SgN303BD;ChN403BC,cgNjz3BU;ChNkz3BV,gBAAgB;CgN5y3BjB,qBAAU;AhN8y3BV;AACA;CACC,qBAAqB;AgN1y3BtB;;AhN6y3BA;CACC,kBgN9y3BD;ChN+y3BC,oBgN3y3BgB;ChN4y3BhB,wBgNzy3BC;ChN0y3BD,uBC5u3BkB;CD6u3BlB,wCgNxy3BC;ChNyy3BD,wCAAwC;CgNty3BzC,wCAAkB;CAElB,wCAAW;ChNuy3BV,wCgNty3BW;ChNuy3BX,wCgNty3BY;ChNuy3BZ,wCgN5x3BA;ChN6x3BA,wCgNty3BG;ChNuy3BH,wCgNpy3BC;ChNqy3BD,2CGj13BoC;CHk13BpC,2CgN7y3BU;ChN8y3BV,2CgNpy3BW;ChNqy3BX,2CgNly3BA;ChNmy3BA,2CAA2C;CgNly3B5C,2CACG;ChNmy3BF,2CgNly3BiB;ChNmy3BjB,2CgNjy3BC;ChNky3BD,2CAA2C;CiN123B5C,uCAAc;CACd,wCAAgB;CAChB,uCAAgB;CAChB,wCAAgB;CjN423Bf,gBiN323BS;AjN423BV;;AAEA;CACC,WiNj33BD;AjNk33BA;AACA;CACC,yBiN923BoB;AjN+23BrB;AACA;CACC,WiNx33BD;CjNy33BC,sBiNx33Be;AjNy33BhB;AACA;CACC,iBiN/23BU;CjNg33BV,eiN/23BC;AjNg33BF;AACA;CACC,gCiN/23BM;CjNg33BN,WiN/23BO;AjNg33BR;;AAEA;CACC,eAAe;CiN323BhB,kBAAgB;CjN623Bf,WiN323BC;AjN423BF;;AAEA;;CiNt23BA,qBAAgB;CjNy23Bf,YiNx23BQ;CjNy23BR,iBiNx23BY;AjNy23Bb;;AAEA;CACC,kBGn33Ba;CHo33Bb,iBiN/23BD;CjNg33BC,YiNv23BC;AjNw23BF;;AAEA;CACC,iBiNl23Bc;CjNm23Bd,gBsB/x3BW;CtBgy3BX,kBiNl23BiB;CjNm23BjB,WAAW;AiNx23BZ;;AjN223BA;CACC,iBG/43Ba;CHg53Bb,eiN723BW;AjN823BZ;;AGj53BE;CHo53BD,kBiNj33BW;CjNk33BX,oBiNj23BoB;CjNk23BpB,wBAAwB;CiN/13BzB,uBACI;CjNg23BH,wCiN/13ByB;CjNg23BzB,wCiN/13BqB;CjNg23BrB,wCiN/13BiB;CjNg23BjB,wCiN913BI;CjN+13BJ,wCAAwC;CiNr23BzC,wCAQc;CjN+13Bb,wCiN913B6B;CjN+13B7B,wCiN913Bc;CjN+13Bd,wCiN913Be;CjN+13Bf,2CiN913BuB;CjN+13BvB,2CiN913B6B;CjN+13B7B,2CiN913B6B;CjN+13B7B,2CiN713BQ;CjN813BR,2CAA2C;CiN313B3C,2CAAkB;CjN613BlB,2CiN313BA;CjN413BA,2CAA2C;CiN313B5C,2CAAkB;CjN613BjB,uCiN513B0B;CjN613B1B,wCiN513BY;CjN613BZ,uCiN513BqB;CjN613BrB,wCiN513BkB;CjN613BlB,gBiN513Be;AjN613BhB;;AAEA;CACC,yBiN513BS;CjN613BT,gBiN313BA;AjN413BD;;AAEA;CACC,gCAAgC;AkNn83BjC;AlNq83BA;CACC,yBkNr83BA;AlNs83BD;AACA;CACC,yBkN/73BI;AlNg83BL;AmN/83BA;CnNi93BC,yBmNl83BC;AnNm83BF;AACA;CACC,gCmN783BE;AnN883BH;AACA;CACC,yBCt83ByB;ADu83B1B;;AAEA;CmNz83BA,eAAgB;AnN283BhB;;AAEA;CACC,gBmNx83BmB;CnNy83BnB,SmNx83BS;CnNy83BT,uBmNx83BqB;AnNy83BtB;;AAEA;;CAEC,iBmNx83BiB;CnNy83BjB,gBCt93BkB;CDu93BlB,uBAAuB;CmNv93BxB,gBAiBE;CAjBF,YAAA;CnN093BC,gCmNv83BgB;AnNw83BjB;AACA;;;;CAIC,amNp83BA;AnNq83BD;;AAEA;CACC,cmNp83BU;CnNq83BV,cGl93Ba;AHm93Bd;;AAEA;CACC,emNh93BO;CnNi93BP,emNj93BO;AnNk93BR;;AAEA;CACC,gBmNn93BA;AnNo93BD;;AAEA;CACC,gBmNt93BA;AnNu93BD;;AAEA;CACC,4BmNn93BK;AnNo93BN;;AAEA;;;CAGC,gBmNl73BC;CnNm73BD,qBG1+3ByB;CH2+3BzB,emN/73BA;AnNg83BD;;AAEA;CACC,mBmN173BQ;AnN273BT;;AAEA;CACC,mB8Hrh4BG;A9Hsh4BJ;;AAEA;CACC,mBmNv73BmB;AnNw73BpB;;AAEA;CACC,wBAAwB;C+M/93BzB,eI2CK;CnNs73BJ,cmNr73BO;CnNs73BP,qBmNp73BQ;CnNq73BR,mBmNp73BkB;CnNq73BlB,cmNp73BE;CnNq73BF,mBmNv73BC;CnNw73BD,4BmNl73BI;CnNm73BJ,wBmNh73BE;AnNi73BH;;AmN563BA;CnN+63BC,amN963BW;AnN+63BZ;;AAEA;CACC,gBmN763BW;AnN863BZ;;AAEA;CACC,WmN763BQ;CnN863BR,0BmNn73BA;CnNo73BA,wBmN763Bc;CnN863Bd,oBmN763BiB;CnN863BjB,YmN373BD;CnN473BC,yBmN163BgB;AnN263BjB;;AAEA;CACC,WmNz63BS;CnN063BT,0BmNx63BE;AnNy63BH;;AAEA;CACC,WmNt63BE;CnNu63BF,0BmNt63BiB;AnNu63BlB;;AAEA;CACC,WmN183BD;AnN283BA;;AAEA;CACC,iBmNr63Bc;CnNs63Bd,WmN/83BD;AnNg93BA;;AAEA;CACC,gBmNl63BU;CnNm63BV,WmNl63BE;CnNm63BF,emNl63BW;CnNm63BX,4BmNh63BA;AnNi63BD;AACA;CACC,gCmNh63Ba;AnNi63Bd;AACA;CACC,WmNh63BS;AnNi63BV;;AAEA;CACC,gCmNh63BY;CnNi63BZ,gBmNh63BW;AnNi63BZ;;AAEA;CACC,gBmNh63BY;CnNi63BZ,gBmNh63BY;AnNi63Bb;;AAEA;CACC,qCmN/53BE;AnNg63BH;;AAEA;CACC,aAAa;AoN1m4Bd;;ApN6m4BA;CACC,UoN9m4BD;CpN+m4BC,wBoNxm4BoB;ApNym4BrB;;AAEA;CACC,UoNxm4Bc;ApNym4Bf;;AAEA;CACC,kBCtm4BkB;CDum4BlB,eGpl4BmB;CHql4BnB,gBoNzn4BD;ApN0n4BA;;AAEA;CACC,kBoN7n4BD;CpN8n4BC,YoNzm4BQ;CpN0m4BR,gBoN/n4BD;CpNgo4BC,gBoNtm4Be;ApNum4BhB;AACA;;CAEC,WoNrm4BU;CpNsm4BV,kBoNrm4BiB;CpNsm4BjB,UoNrm4BI;CpNsm4BJ,MoNrm4BI;CpNsm4BJ,YGpm4Ba;CHqm4Bb,coNzo4BD;ApN0o4BA;AACA;CoN3o4BA,OAAA;CAAA,0BA2CE;ApNmm4BF;AACA;CACC,QoNlm4BE;CpNmm4BF,0BAA0B;AoNjp4B3B;;ApNop4BA;CqNpp4BA,kBAAA;CrNsp4BC,UAAU;CACV,OAAO;CACP,cAAc;CqNnp4Bf,gBAAA;CrNqp4BC,gCqN/o4BA;CrNgp4BA,0BqNpp4BK;ArNqp4BN;;AAEA;CqNjp4BA,kBAAA;CrNmp4BC,UqNjp4BO;CrNkp4BP,OqNjp4BO;CrNkp4BP,MqNjp4BO;CrNkp4BP,YqNjp4BkB;CrNkp4BlB,WqNjp4BO;CrNkp4BP,yBqNjp4BgB;CrNkp4BhB,oBqNhp4BI;CrNip4BJ,6BAA6B;CqN1p4B9B,0BAUI;ArNkp4BJ;;AAEA;CACC,kBqNlp4BS;CrNmp4BT,SAAS;CqN9o4BV,UAAA;CrNgp4BC,kBqN9o4BqB;CrN+o4BrB,gBqN9o4BsB;CrN+o4BtB,+BqN9o4BuB;CrN+o4BvB,wBqN9o4BuB;CrN+o4BvB,yBAAiB;SAAjB,iBAAiB;CqN3o4BlB,qBACI;ArN4o4BJ;AACA;CACC,WAAW;CqNxo4BZ,kBAAkB;CrN0o4BjB,SqNzo4BU;CrN0o4BV,2BqN1n4BA;CrN2n4BA,kBqN5o4BgB;CrN6o4BhB,eqNzo4BO;CrN0o4BP,cqNzo4Be;CrN0o4Bf,kBqNzo4BgB;CrN0o4BhB,sBsBpr4BW;CtBqr4BX,mBqNzo4Be;CrN0o4Bf,mCqNxo4BgB;CrNyo4BhB,gCsB9r4BQ;CtB+r4BR,oDAAoD;AqNlo4BrD;ArNoo4BA;CACC,yBAAyB;CqNlo4B1B,qBAAY;ArNoo4BZ;;AAEA;CACC,oBqN/n4BG;ArNgo4BJ;AACA;CACC,yBqN/n4B4B;CrNgo4B5B,qBqN/n4ByB;ArNgo4B1B;;AAEA;CACC,qBsB/s4Be;AtBgt4BhB;;AqN1n4BA;CAEA,kBAAgB;CrN4n4Bf,UqN3n4BY;CrN4n4BZ,QqN3n4BG;CrN4n4BH,2BqN3n4B2B;CrN4n4B3B,gBqN3n4BkB;CrN4n4BlB,eqN3n4Ba;CrN4n4Bb,kBqNjo4Bc;CrNko4Bd,sBsB1t4Be;CtB2t4Bf,mBqN3n4BgB;CrN4n4BhB,mCqN3n4BkB;CrN4n4BlB,6BqN3n4BmB;ArN4n4BpB;AACA;CACC,WqN3n4Be;CrN4n4Bf,kBqN3n4Bc;CrN4n4Bd,YAAY;CqNxn4Bb,WAAA;CrN0n4BC,QCzn4BW;CD0n4BX,SqNxn4BO;CrNyn4BP,4CqNxn4BuB;ArNyn4BxB;AACA;CACC,qBAAqB;AqNrn4BtB;;ArNwn4BA;CACC,OqNpn4BW;CrNqn4BX,0CsB9u4Be;AtB+u4BhB;;AAEA;CACC,QqNpn4BkB;ArNqn4BnB;;AAEA;CACC,mBC3o4BkB;AD4o4BnB;AACA;CqNpo4BA,4BAmBqB;ArNmn4BrB;AACA;CqN9m4BA,mCACO;ArN+m4BP;;AAEA;CACC,kBqN9m4BsB;CrN+m4BtB,WqN9m4BW;CrN+m4BX,gBAAgB;CqN1m4BjB,uBAAiB;ArN4m4BjB;;AAEA;CACC,kBqN3m4BG;CrN4m4BH,UqN3m4Ba;CrN4m4Bb,WqNjn4BD;CrNkn4BC,OqN1m4BW;CrN2m4BX,MqNnn4BD;CrNon4BC,4BqNzm4BmB;CrN0m4BnB,qBqNzm4B2B;CrN0m4B3B,UqNtn4BD;CrNun4BC,wBqNpm4B4B;CrNqm4B5B,sCqNpm4Bc;ArNqm4Bf;;AAEA;CACC,kBqNnm4BoB;CrNom4BpB,UqNlm4BW;CrNmm4BX,UqNlm4BW;CrNmm4BX,wBqNlm4ByB;ArNmm4B1B;;AAEA;;CAEC,8BqNhm4Bc;ArNim4Bf;;AAEA;;CAEC,6BqN5l4BuB;ArN6l4BxB;;AAEA;;CqNzl4BA,4BACoB;ArN2l4BpB;;AAEA;CACC,gBqN1l4BsB;ArN2l4BvB;;AAEA;CACC,wBqNrl4BQ;CrNsl4BR,kCAAkC;CqNll4BnC,gBAAgB;CrNol4Bf,2BqNnl4Be;ArNol4BhB;;AAEA;CACC,cqNnl4BgB;CrNol4BhB,kBqNnl4BmB;CrNol4BnB,4BqNnl4B2B;ArNol4B5B;AACA;CACC,aqNnl4BO;ArNol4BR;;AAEA;CACC;EqN/k4BD,UAAO;EACH,2BAA2B;CrNil4B9B;CACA;EqN9k4BD,UAAY;EAEJ,yBACH;CrN8k4BJ;AqNjl4BD;;ArNol4BA;CACC;EqNrl4BD,UAAY;EASJ,4BACH;CrN8k4BJ;CqNxl4BD;EAYQ,UAAQ;EACR,yBAAqB;CrN+k4B5B;AACD;;AAEA;CqN/y4BA,gCA4OgB;ArNqk4BhB;;AAEA;CqN5y4BA,yBAGI;ArN2y4BJ;;AAEA;CACC,yBqNpk4B0B;ArNqk4B3B;;AAEA;CACC,yBqNjk4BQ;ArNkk4BT;;AAEA;CACC,gBqNjk4BmB;CrNkk4BnB,uBqNjk4BsB;CrNkk4BtB,WqNjk4BO;CrNkk4BP,oBqNjk4BqB;CrNkk4BrB,UqN7z4BD;ArN8z4BA;AACA;CACC,+CqN/j4B0C;CrNgk4B1C,2CqN9j4BQ;CrN+j4BR,iBAAiB;AsNj34BlB;AtNm34BA;CACC,gBsNj34BW;AtNk34BZ;;AAEA;CACC,wBG5y4BgB;CH6y4BhB,gBG5y4BY;AH6y4Bb;;AAEA;CACC,kBsNj34BY;AtNk34Bb;;AAEA;CACC,UsNj34BS;CtNk34BT,kBsNj34Ba;CtNk34Bb,mBsNj34BY;CtNk34BZ,iBsNj34Bc;AtNk34Bf;;AAEA;;CsNv44BA,WAAA;CtN044BC,gBsN/24BgB;CtNg34BhB,csN/24Bc;CtNg34Bd,4BsN/24Ba;CtNg34Bb,wCsN924BE;AtN+24BH;;AAEA;CACC,sBsN724BwB;AtN824BzB;;AAEA;CACC,asNx24BW;CtNy24BX,WAAW;AsNt24BZ;;AtNy24BA,kBsNv24BY;AtNw24BZ;;;;CsNl24BA,uCAAA;AtNu24BA;;AAEA;;;;CuNj64BA,6BAAA;AvNs64BA;;AAEA;;CAEC,uCuNn64ByB;AvNo64B1B;;AuNt64BA;CvNy64BC,uCuNn64ByB;AvNo64B1B;;AAEA;;;;;CAKC,WuNn64BO;AvNo64BR;;AAEA;;CAEC,4BG164ByB;AH264B1B;;AAEA;CACC,eAAe;AuN174BhB;;AvN674BA;;CAEC,kBAAkB;CuN/74BnB,cAAA;CAiCA,wBAAoB;CvNm64BnB,mBuNl64BY;CvNm64BZ,kBAAkB;CuNh64BnB,YAAa;CvNk64BZ,gBCl24BkB;CDm24BlB,iBuNj64BkB;CvNk64BlB,eAAe;CuN/54BhB,qBAAgB;CvNi64Bf,kBuNh64BkB;AvNi64BnB;;AAEA;CACC,asBj84BO;AtBk84BR;;AAEA;CACC,auNz64BD;AvN064BA;;AAEA;;;;;;CAMC,wCuN754BK;CvN854BL,YuN754Bc;AvN854Bf;;AAEA;;;CAGC,yBsB794BW;CtB894BX,cuN954BD;AvN+54BA;;AAEA;CACC,yBuNx54BuB;CvNy54BvB,cuNn64BD;AvNo64BA;;AC734BA;CDg44BC,kBC/34BS;CDg44BT,gBC/34BW;ADg44BZ;;AAEA;CACC,kBC/34BgB;CDg44BhB,iBC/34BgB;ADg44BjB;;AAEA;CACC,kBC/34BgB;CDg44BhB,iBC/34BgB;ADg44BjB;;AAEA;CACC,kBC/34BA;CDg44BA,kBC/34BA;ADg44BD;;AAEA;CACC,kBC/34BA;ADg44BD;;AAEA;CACC,kBC/34BA;CDg44BA,aC/34BA;ADg44BD;;AAEA;CACC,kBsB1/4BM;CtB2/4BN,YsBv/4BW;AtBw/4BZ;;AAEA;;;;;;CAMC,wCqH1g5BK;CrH2g5BL,YqHth5BD;ArHuh5BA;;AAEA;CACC,gBqH1h5BD;CrH2h5BC,uCqH5g5BI;CrH6g5BJ,qBqH5h5BmB;CrH6h5BnB,gBsB/g5BW;CtBgh5BX,eqH9h5BD;ArH+h5BA;;AAEA;CACC,mCqHvg5BQ;CrHwg5BR,qBqHni5BmB;CrHoi5BnB,uBqH9/4BwC;CrH+/4BxC,iBqHri5BD;ArHsi5BA;;AAEA;CACC,kCqHpg5BW;ArHqg5BZ;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;CsHrj5B1B,qBAAoB;CtHuj5BnB,qBsBji5BW;AtBki5BZ;;AAEA;CACC,8CsHnj5BC;AtHoj5BF;;AAEA;CsH9j5BA,qBAAoB;CtHgk5BnB,4CsH1i5BC;AtH2i5BF;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oBsH1i5BC;CtH2i5BD,iBAAiB;AAClB;;AAEA;CACC,yBsHzi5BI;AtH0i5BL;;AAEA;CACC,oBAAoB;AACrB;;AAEA;;CsHpl5BA,gBAAA;AtHul5BA;AACA;CACC;;EAEC,WsBhl5BM;CtBil5BP;AACD;AACA;CACC;;EsH/l5BD,YAAA;CtHkm5BC;AACD;AACA;CACC;;EsHpi5BC,WhGtDU;CtB6l5BX;AACD;;AAEA;;CsH3m5BA,0BAAC;CAAD,sBAAoB;AtH+m5BpB;;AAEA;CACC,WsHti5BI;AtHui5BL;;AAEA;;CAEC,qBsBnm5BS;AtBom5BV;;AAEA;;CsH1n5BA,UAAA;CtH6n5BC,sBsBzm5BS;AtB0m5BV;;AAEA;CACC,uBAAuB;CsHjo5BxB,eAAA;CtHmo5BC,gBsB/m5BS;CtBgn5BT,csHri5Bc;AtHsi5Bf;AACA;CACC;EACC,eAAe;EsHxo5BjB,gBAAA;EAAA,gBAAA;CtH2o5BC;AACD;;AAEA;;;CAGC,qBAAqB;AACtB;;AAEA;CACC,gBsB1o5BW;CtB2o5BX,yBsHtp5BmB;CtHwp5BnB,wCAAwC;AACzC;AACA;CACC,4BAA4B;AAC7B;;AAEA;CsH9p5BA,gBAAA;AtHgq5BA;;AAEA;;;;;;CsHlq5BA,sBAAoB;CAApB,kBAAC;AtH0q5BD;AACA;;;;;;CAMC,kBsHjr5BD;AtHkr5BA;;AAEA;;CsHpr5BA,kBAAC;CtHur5BA,4BsH5h5BC;AtH6h5BF;;AAEA;CACC,YAAY;CsH3r5Bb,eAAA;CtH6r5BC,yBsH7h5Bc;CtH8h5Bd,4BAA4B;CAE5B,2BsH5h5BC;AtH6h5BF;AACA;;;;CAIC,0BsHxh5BC;CtHyh5BD,WAAW;CsHvs5BZ,4BA+KC;AtH0h5BD;;AAEA;CACC,SsBjs5BO;CtBks5BP,UAAU;CsH7s5BX,uBAAoB;AtH+s5BpB;;AAEA;CACC,0BAA0B;CsHlt5B3B,WAAA;AtHot5BA;;AAEA;;;CAGC,0BsHzt5BmB;CtH0t5BnB,WsHth5BE;CtHuh5BF,gCsHph5BE;CAvMH,gBAAA;CtH8t5BC,iBsHnh5BiB;AtHoh5BlB;;AAEA;CACC,esHlu5BD;CtHmu5BC,SsHnh5BO;AtHoh5BR;;AAEA;CACC,iBsHlh5Bc;CtHmh5Bd,asHxu5BD;CtHyu5BC,mBsHlh5Be;CtHmh5Bf,kBsBrt5BM;AtBst5BP;AACA;CACC,2BsH/g5BK;AtHgh5BN;;AAEA;CsHhv5BA,gBAAA;AtHkv5BA;;AAEA;CACC,wBAAwB;CsHrv5BzB,gBAAA;AtHuv5BA;;AAEA;CACC;EACC,csH3v5BF;CtH4v5BC;CACA;EACC,asH9v5BF;EtH+v5BE,uBsHzg5BkB;EtH0g5BlB,uBsHxg5BC;CtHyg5BF;CsHjw5BD;EA6PC,8BACA;CtHsg5BA;CsHpw5BD;EAgQC,kBhG3OM;CtBkv5BN;AACD;;AAEA;CsH1w5BA,gBAAA;CtH4w5BC,esHrg5BE;AtHsg5BH;;AAEA;CACC;EACC,sBsHrg5BmB;EtHsg5BnB,eAAe;CsHlx5BjB;CtHox5BC;;EAEC,eAAe;EsHtx5BjB,SAAA;EAqRE,chGjQQ;EtBqw5BR,kBAAkB;EsHzx5BpB,gBAAA;CtH2x5BC;CACA;EsH5x5BD,qBAAoB;EA2RlB,gBhGvQQ;EtB2w5BR,eAAe;CsH/x5BjB;AtHiy5BA;;AAEA;CACC,cAAc;CsHpy5Bf,mBAAoB;AtHsy5BpB;;AAEA;CACC,wBsBpx5BM;AtBqx5BP;;AAEA;CACC,0BsHhg5BC;CtHig5BD,4BAA4B;CsH9y5B7B,WAAA;CtHgz5BC,uDsHhg5BC;AtHig5BF;AACA;CACC,iCsHhg5BC;CtHig5BD,mCAAmC;CsHpz5BpC,qBAAoB;CtHsz5BnB,gBsHjg5BY;AtHkg5Bb;AACA;CACC,iCsH//4BC;CtHgg5BD,mCAAmC;CsH1z5BpC,cAAA;AtH4z5BA;;AAEA;CACC,0BsH9/4BI;CtH+/4BJ,4BAA4B;CsHh05B7B,WAAA;CtHk05BC,uDsH9/4BI;CtH+/4BJ,4BAA4B;CsHn05B7B,6BAqUI;AtHgg5BJ;AACA;CACC,iCsBjz5BkB;CtBkz5BlB,mCsHv/4BQ;CtHw/4BR,qBsHz05BD;CtH005BC,gBsB/z5BW;CtBg05BX,mCAAmC;CsH305BpC,oCAmVW;AtH0/4BX;AACA;CsH905BA,iCAsVQ;CtH0/4BP,mCsHx/4BI;CtHy/4BJ,cAAc;AACf;;AAEA;CACC,qCsHx/4BO;CtHy/4BP,gBAAgB;CsHt15BjB,uDA+VwB;CtHy/4BvB,mCsBp05BS;CtBq05BT,oCAAoC;AACrC;;AAEA;CsH515BA,mBAAoB;CtH815BnB,qBsHx/4BO;CtHy/4BP,WAAW;CsH/15BZ,yDAyWc;AtHw/4Bd;AACA;CsHl25BA,mBAAoB;CtHo25BnB,qBsHv/4BmB;CtHw/4BnB,cAAc;CsHr25Bf,gBAAA;AtHu25BA;;AAEA;CACC,mBsHv/4BmB;CtHw/4BnB,qBAAqB;CsH325BtB,WAAA;CtH625BC,yDsHr/4BC;CtHs/4BD,4BAA4B;CsH925B7B,6BAyXC;AtHu/4BD;AACA;CsHj35BA,mBAAoB;CtHm35BnB,qBsHp/4BE;CtHq/4BF,cAAc;CsHp35Bf,gBAAA;CtHs35BC,mCsBl25BiC;CtBm25BjC,oCAAoC;AACrC;AACA;CACC,mCsBt25BS;CtBu25BT,qCAAqC;CsH335BtC,cAAA;AtH635BA;;AAEA;CACC,8BsH7+4BE;CtH8+4BF,gBsHj45BD;CtHk45BC,yDsHh/4BG;CtHi/4BH,mCAAmC;CsHn45BpC,oCAoZE;AtHi/4BF;;AAEA;CACC,sBsBl35BkB;CtBm35BlB,SAAS;CsHz45BV,6BA2ZC;AtHg/4BD;AACA;CsH545BA,gCAoaC;CtH0+4BA,iCsHx+4BC;AtHy+4BF;AACA;CsHh55BA,mCAwaC;CtH0+4BA,oCsHz+4B0B;AtH0+4B3B;;AAEA;CACC,qBsBh45BkB;CtBi45BlB,+BsHz+4BuB;CtH0+4BvB,esBp45BS;CtBq45BT,kBAAkB;CsHz55BnB,WAAA;CtH255BC,gBsBr45BW;CtBs45BX,uBAAuB;CAGvB,oBAAoB;AACrB;AACA;CACC,sBAAsB;CsHl65BvB,sCA0bC;AtH0+4BD;AACA;CsHr65BA,qBAAoB;CtHu65BnB,gBsHx+4BC;CtHy+4BD,kBAAkB;CsHx65BnB,iBAAA;CtH065BC,+BsHx+4BC;CtHy+4BD,kBAAkB;CsH365BnB,sBAAoB;AtH665BpB;AACA;CsH965BA,gBAAA;CtHg75BC,sBsB155BkB;CtB255BlB,qCsHz+4BA;AtH0+4BD;AACA;CsHn75BA,gBAAA;AtHq75BA;AACA;CsHt75BA,gBAAA;CtHw75BC,sBsBl65BkB;CtBm65BlB,kBAAkB;CsHz75BnB,gBAAA;CtH275BC,QsHt+4BC;CtHu+4BD,2BAA2B;CsH575B5B,iCAwdC;CtHs+4BA,WsHr+4BW;CtHs+4BX,YAAY;AACb;AACA;CACC,WAAW;CsHl85BZ,eAAA;AtHo85BA;AACA;CsHr85BA,gBAAA;AtHu85BA;;AAEA;CACC,yBsH594BE;AtH694BH;;AAEA;CACC,SAAS;AACV;;AAEA;CsHj95BA,+BA0fC;CtHy94BA,gBsB975BM;CtB+75BN,mCAAmC;CsHp95BpC,oCA6fI;AtHy94BJ;AACA;CsHv95BA,sCAggBI;AtHy94BJ;;AAEA;CACC,uBsBx85BS;AtBy85BV;;AAEA;CACC,4BsHj94BE;CtHk94BF,6BsHz94BA;AtH094BD;;AAEA;CACC,gBsBh95BM;AtBi95BP;AACA;CsHv+5BA,mBAAoB;AtHy+5BpB;AACA;CsH1+5BA,sCAqhBC;AtHu94BD;AACA;CsH7+5BA,sCA6hBC;AtHk94BD;;AAEA;CACC,mBsB995BS;AtB+95BV;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,WsH384BE;CtH484BF,eAAe;AAChB;;AAEA;CACC,oBAAoB;AACrB;AACA;CACC,eAAe;CsHlg6BhB,qBAAoB;AtHog6BpB;;AAEA;CACC,kBsBn/5BS;CtBo/5BT,WAAW;CsHxg6BZ,eAAA;CtH0g6BC,sBsBp/5BkB;AtBq/5BnB;AACA;CACC,UsHn84BG;CtHo84BH,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;;AAEA;CsHph6BA,kBAAC;CtHsh6BA,WsH/74BC;CtHg84BD,eAAe;CsHvh6BhB,sBAAoB;AtHyh6BpB;AACA;CsH1h6BA,gBAAA;AtH4h6BA;;AAEA;CsH9h6BA,oBAAoB;AtHgi6BpB;;AAEA;CsHli6BA,yBAAC;AtHoi6BD;AACA;CsHri6BA,yBAAC;AtHui6BD;;AAEA;CACC,gCsBth6BS;CtBuh6BT,WAAW;CsH3i6BZ,4BAgnBC;AtH674BD;AACA;CsH9i6BA,gCAmnBC;AtH674BD;;AAEA;CACC,yBsB/h6BS;CtBgi6BT,WAAW;CsHpj6BZ,qBAAoB;AtHsj6BpB;AACA;CsHvj6BA,yBAAC;AtHyj6BD;;AAEA;CACC,yBsBxi6BS;CtByi6BT,WAAW;CsH7j6BZ,qBAAoB;AtH+j6BpB;AACA;CsHhk6BA,yBAAC;AtHkk6BD;;AAEA;CACC,yBsH374BC;CtH474BD,gBAAgB;AACjB;;AAEA;CsHzk6BA,gCAkpBC;CtHy74BA,iCsHv74BC;AtHw74BF;;AAEA;CACC,mCsHv74BC;CtHw74BD,oCAAoC;AACrC;;AAEA;CsHnl6BA,gBAAA;AtHql6BA;;AAEA;CACC,gBsHv74BC;AtHw74BF;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CsH/l6BA,gCAwqBC;CtHy74BA,iCsHv74BC;AtHw74BF;;AAEA;CACC,mCAAmC;CsHrm6BpC,oCA8qBM;AtHy74BN;;AAEA;CACC,mCsHp74BC;CtHq74BD,oCAAoC;AACrC;;AAEA;CsH9m6BA,yBAAC;CtHgn6BA,uCsHj74BI;CtHk74BJ,4BAA4B;CsHjn6B7B,6BAmsBC;AtHg74BD;AACA;CsHpn6BA,yBAAC;AtHsn6BD;AACA;CsHvn6BA,uBAAoB;AtHyn6BpB;;AAEA;CACC,yBsH164Ba;CtH264Bb,uCAAuC;CsH7n6BxC,mCAqtBC;CtH064BA,oCsHz64BoC;AtH064BrC;AACA;CACC,yBsHz64BY;AtH064Bb;;AAEA;CACC,yBsHx64BC;CtHy64BD,qBAAqB;CsHvo6BtB,WAAA;AtHyo6BA;;AAEA;CACC,YAAY;CsH5o6Bb,uDAyuBe;AtHq64Bf;;AAEA;CACC,gCsB3n6BkB;CtB4n6BlB,iCsHn64BC;AtHo64BF;;AAEA;CACC,mCsH954BC;CtH+54BD,oCsHv64BA;AtHw64BD;;AAEA;CACC,wBsBvo6BS;AtBwo6BV;;AAEA;CACC,WAAW;CsH/p6BZ,sGAgwB8B;CtHi64B7B,yBsB7o6BS;CtB8o6BT,4BsHlq6BA;CtHmq6BA,6BsH754BI;AtH854BL;AACA;CACC,mCAAmC;CsHtq6BpC,oCA+wBC;AtHy54BD;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CsH9q6BZ,sGAuxBgC;CtHy54B/B,yBsHx54BqB;AtHy54BtB;;AAEA;CACC,YsBzq6BW;CtB0q6BX,uBsBjq6BS;CtBkq6BT,mCAAmC;CsHtr6BpC,YAAA;CtHwr6BC,iBsHv54BC;AtHw54BF;AACA;CACC,uBsHv54BC;AtHw54BF;AACA;CACC,qCsHr54BG;CtHs54BH,WAAW;AACZ;AACA;CACC;EACC,gBAAgB;CsHns6BlB;AtHqs6BA;;AAEA;CsHvs6BA,4BAmzBC;CAnzBD,oCAozBC;AtHs54BD;AACA;CsH3s6BA;EAwzBE,ahGlyBU;CtBwr6BX;AACD;AACA;CACC,uBsHn54BE;CtHo54BF,uBAAuB;AACxB;;AAEA;CsHrt6BA,yBAAC;AtHut6BD;;AAEA;CACC,kBsHx44BK;CtHy44BL,iBAAiB;CsH3t6BlB,YAAA;CtH6t6BC,oCsHl44BG;AtHm44BJ;;AAEA;;CsHhu6BA,iBAAA;AtHmu6BA;;AAEA;CACC,mBsH334Ba;AtH434Bd;;AAEA;CACC,oBsBtt6BS;AtBut6BV;AACA;CACC,UsH334BC;AtH434BF;;AAEA;CACC,uBAAuB;CsHjv6BxB,oBAAoB;AtHmv6BpB;AACA;CsHpv6BA;EA+3BE,kBAAY;EtHw34BZ,mBAAmB;CsHvv6BrB;AtHyv6BA;AACA;CsH1v6BA,gBAAA;AtH4v6BA;;AAEA;CACC,gBsB3u6BS;AtB4u6BV;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CsHtw6BA,iCAo5BC;CtHo34BA,mCsHl34BC;CtHm34BD,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CsH7w6BpB,qBAAoB;CtH+w6BnB,csHn34Ba;AtHo34Bd;;AAEA;CACC,mBAAmB;CsHnx6BpB,qBAAoB;CtHqx6BnB,csHn34BO;AtHo34BR;;AAEA;CACC,mBAAmB;CsHzx6BpB,qBAAoB;CtH2x6BnB,csHn34BO;AtHo34BR;;AAEA;CACC,mBAAmB;CsH/x6BpB,qBAAoB;CtHiy6BnB,csB5w6BM;AtB6w6BP;;AAEA;CACC,mBAAmB;CsHry6BpB,qBAAoB;CtHuy6BnB,csHj34BC;AtHk34BF;;AAEA;CACC,mBAAmB;CsH3y6BpB,qBAAoB;CtH6y6BnB,csHj34BU;AtHk34BX;;AAEA;CACC,mBAAmB;CsHjz6BpB,qBAAoB;CtHmz6BnB,csHj34BC;AtHk34BF;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CsH9z6BA,kCA+8BO;AtHi34BP;;AAEA;CsHl06BA,kCAm9BC;AtHi34BD;;AAEA;CACC,kCsBnz6BS;AtBoz6BV;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CsH906BA,kCAm+BC;AtH624BD;;AAEA;CACC,kCsB9z6Ba;AtB+z6Bd;;AAEA;CACC,yDsBl06Ba;AtBm06Bd;;AAEA;CsH116BA,6CAi/BmB;AtH224BnB;;AAEA;CACC,6CsHz24BC;AtH024BF;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CsHt26BA,6CAigCmB;AtHu24BnB;;AAEA;CACC,6CsHn24BC;AtHo24BF;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CsHl36BA,6CAihCW;AtHm24BX;;AAEA;CACC,WsHl24BC;CtHm24BD,UAAU;AACX;;AAEA;CACC,0BAA0B;CsH536B3B,WAAA;CtH836BC,4BsBz26Ba;AtB026Bd;;AAEA;CsHj46BA,mBAAoB;CtHm46BnB,WsH/14BC;CtHg24BD,qBAAqB;AACtB;;AAEA;CsHv46BA,mBAAoB;CtHy46BnB,WsBr36BS;CtBs36BT,qBAAqB;AACtB;;AAEA;CsH746BA,mBAAoB;CtH+46BnB,WsH714BW;CtH814BX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CsHp56BpB,WAAA;CAAA,qBAAoB;AtHu56BpB;;AAEA;CsHz56BA,mBAAoB;CAApB,WAAA;CAAA,qBAAoB;AtH656BpB;;AAEA;CsH/56BA,mBAAoB;CAApB,WAAA;CAAA,qBAAoB;AtHm66BpB;;AAEA;CsHr66BA,mBAAoB;CtHu66BnB,csBn56BS;CtBo56BT,qBAAqB;AACtB;;AAEA;CACC,esH514BC;CtH614BD,iBAAiB;AAClB;;AAEA;CsHh76BA,mBAAoB;CtHk76BnB,uBsHz14BuB;AtH014BxB;;AAEA;CACC,eAAe;AAChB;;AAEA;CsHz76BA,uBAAoB;CtH276BnB,qBsHx14BC;CtHy14BD,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;CsHh86BxB,cAAA;CtHk86BC,qBsHz14BQ;AtH014BT;;AAEA;CACC,uBsBj76BM;CtBk76BN,cAAc;CsHv86Bf,qBAAoB;AtHy86BpB;;AAEA;CsH386BA,uBAAoB;CAApB,cAAA;CtH886BC,qBsBx76BkB;AtBy76BnB;;AAEA;CsHj96BA,uBAAoB;CAApB,cAAA;CtHo96BC,qBsB/76Ba;AtBg86Bd;;AAEA;CACC,uBsBp86BS;CtBq86BT,csHz96BD;CtH096BC,qBsBp86BW;AtBq86BZ;;AAEA;CACC,uBsHn14BY;CtHo14BZ,cAAc;CsH/96Bf,qBAAoB;AtHi+6BpB;;AAEA;CACC,uBAAuB;CsHp+6BxB,cAAA;CtHs+6BC,qBsBl96BS;AtBm96BV;;AAEA;CACC,WAAW;AACZ;AACA;CACC,kBAAkB;CsH7+6BnB,uBAAoB;AtH++6BpB;AACA;CsHh/6BA,mBAAoB;AtHk/6BpB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CsHz/6BA,yBAAC;AtH2/6BD;AACA;CsH5/6BA,yBAAC;AtH8/6BD;AACA;CACC,qBsHl14BO;CtHm14BP,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CsHrg7BnB,uBAAoB;AtHug7BpB;AACA;CsHxg7BA,oBAAoB;CtH0g7BnB,csB//6BW;AtBgg7BZ;;AAEA;;CAEC,esBz/6BW;CtB0/6BX,sBAAsB;AACvB;;AAEA;CACC,gBsHz04BC;CtH004BD,yBAAyB;CsHrh7B1B,YAAA;CtHuh7BC,csH104BO;AtH204BR;AACA;CACC,qBsBrg7BM;AtBsg7BP;AACA;CACC,gBsBzg7BS;AtB0g7BV;;AAEA;CACC,gBAAgB;CsHji7BjB,uBAAoB;CtHmi7BnB,gBsB/g7BS;CtBgh7BT,yBAAyB;CsHpi7B1B,mCA2tCE;AtH204BF;;AAEA;CACC,sBsBhh7BW;CtBih7BX,4BAA4B;AAC7B;;AAEA;CsH7i7BA,sBAAoB;CtH+i7BnB,iBsB3h7BS;CtB4h7BT,4BAA4B;AAC7B;;AAEA;CsHnj7BA,sCA8uCC;CtHu04BA,qBsHp04BE;AtHq04BH;;AAEA;CACC,+BAA+B;CsHzj7BhC,cAAA;AtH2j7BA;AACA;CsH5j7BA,cAAA;AtH8j7BA;;AAEA;CACC,+BsH/z4BwB;CtHg04BxB,csH/z4BS;AtHg04BV;;AAEA;CACC,+BsHnz4BE;CtHoz4BF,csHvk7BD;AtHwk7BA;;AAEA;CACC,+BsH1z4BI;CtH2z4BJ,cAAc;AACf;;AAEA;CACC,+BAA+B;CsHhl7BhC,cAAA;AtHkl7BA;;AAEA;CACC,+BsHtz4BuB;CtHuz4BvB,cAAc;AACf;AACA;CACC,cAAc;AACf;;AAEA;CsH5l7BA,+BAkqBC;CtH475BA,csHpz4Ba;AtHqz4Bd;AACA;CsHhm7BA,cAAA;AtHkm7BA;;AAEA;CsHpm7BA,mBAAoB;CtHsm7BnB,uBsBll7BS;CtBml7BT,qBAAqB;AACtB;;AAEA;CsH1m7BA,oBAAoB;CtH4m7BnB,yBsBtl7BW;CtBul7BX,sBAAsB;AACvB;;AAEA;CsHhn7BA,uBAAoB;CtHkn7BnB,qBsB9l7BS;CtB+l7BT,gBAAgB;CsHnn7BjB,mBAAoB;CtHqn7BnB,gBsHry4BE;AtHsy4BH;AACA;CsHvn7BA,WAAA;AtHyn7BA;;AAEA;CsH3n7BA,eAAA;CtH6n7BC,uBsBzm7BS;CtB0m7BT,cAAc;AACf;;AAEA;CsHjo7BA,mBAAoB;AtHmo7BpB;;AAEA;CACC,yBsHjy4BC;AtHky4BF;AsHjy4BC;CtHmy4BA,WsHly4BS;AtHmy4BV;;AAEA;CACC,yBAAyB;AAC1B;AACA;CACC,WAAW;AACZ;;AAEA;CsHnp7BA,yBAAC;AtHqp7BD;AACA;CACC,WAAW;AACZ;;AAEA;CsH1p7BA,gCAi4CE;AtH2x4BF;AACA;CACC,WAAW;AACZ;;AAEA;CACC,yBsHtx4BgB;AtHux4BjB;AACA;CACC,WAAW;AACZ;;AAEA;CsHxq7BA,yBAAC;AtH0q7BD;AACA;CsH3q7BA,WAAA;AtH6q7BA;;AAEA;CACC,yBsB5p7BS;AtB6p7BV;AACA;CsHlr7BA,WAAA;AtHor7BA;;AAEA;CsHtr7BA,yBAAC;AtHwr7BD;AACA;CsHzr7BA,WAAA;AtH2r7BA;;AAEA;CsH7r7BA,mBAAoB;AtH+r7BpB;;AAEA;CACC,yBAAyB;CsHls7B1B,cAAA;AtHos7BA;AACA;CsHrs7BA,wCAu7CE;AtHgx4BF;;AAEA;CACC,yBsH9w4BE;CtH+w4BF,cAAc;AACf;AACA;CACC,wCAAwC;AACzC;;AAEA;CuHjt7BA,yBAAC;CvHmt7BA,qBsB/r7BS;AtBgs7BV;AACA;CACC,uCuH9s7BG;AvH+s7BJ;;AAEA;CACC,yBAAyB;CuH1t7B1B,cAAA;AvH4t7BA;AACA;CuH7t7BA,yCAmBE;CvH4s7BD,WuH1s7Ba;AvH2s7Bd;;AAEA;CACC,yBuHts7BG;CvHus7BH,cuHpu7BD;AvHqu7BA;AACA;CuHtu7BA,yCA+BE;AvHys7BF;;AAEA;CACC,yBuHps7BE;CvHqs7BF,cuH5u7BD;AvH6u7BA;AACA;CuH9u7BA,yCAiDQ;AvH+r7BR;;AAEA;CACC,yBuHnv7BmB;CvHov7BnB,csBzu7BW;AtB0u7BZ;AACA;CACC,yCuH3r7B2C;CvH4r7B3C,WAAW;AACZ;;AAEA;CuH3v7BA,yCAuEc;CvHsr7Bb,cuHrr7BC;AvHsr7BF;;AAEA;CACC,yBAAyB;CwNjw7B1B,cAAA;AxNmw7BA;;AAEA;CACC,qBAAqB;CwNtw7BtB,kBAAC;AxNww7BD;AACA;CwNzw7BA,eAAA;AxN2w7BA;;AAEA;CACC,uBAAuB;CwN9w7BxB,wBAAoB;AxNgx7BpB;AACA;CwNjx7BA,eAAA;AxNmx7BA;;AAEA;CACC,oBAAoB;CwNtx7BrB,mBAAoB;AxNwx7BpB;AACA;CwNzx7BA,eAAA;AxN2x7BA;;AAEA;CACC,oBAAoB;AACrB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,WAAW;CwHpy7BZ,kBAAC;AxHsy7BD;AACA;CACC,qBsBlx7BW;AtBmx7BZ;;AAEA;CACC,awH7x7BE;CxH8x7BF,mBAAmB;CwH7y7BpB,8BAkBG;CxH6x7BF,0BsB3x7BS;CtB4x7BT,mBAAmB;CwHhz7BpB,uBAAoB;CxHkz7BnB,uBwHnx7BkB;CxHox7BlB,kBwHnz7BD;CxHoz7BC,UwHnx7Bc;CxHox7Bd,ewHnx7BmB;AxHox7BpB;AACA;CACC,yBsB7y7BO;AtB8y7BR;AACA;;CAEC,SAAS;AACV;AACA;CACC;;EwHvw7BE,elGpCO;CtB8y7BT;AACD;AACA;CwHp07BA;EAmEoB,eAA2C;CxHow7B9D;AACD;AACA;CACC;EACC,uBwH307BkB;ExH407BlB,ewH9v7BkB;CxH+v7BnB;CACA;;EAEC,ewHh17BF;CxHi17BC;AACD;AACA;CACC,mBwHtv7B6C;AxHuv7B9C;AACA;CACC;EACC,qBAAqB;CwHx17BvB;AxH017BA;AACA;;CAEC,gBwH1u7BK;CxH2u7BL,aAAa;CwH917Bd,qBAAoB;CxHg27BnB,kBwHtu7BqB;AxHuu7BtB;AACA;;CAEC,mBwHpu7BiB;CxHqu7BjB,gBwHpu7BmB;AxHqu7BpB;AACA;CyHv27BA,gBAAA;CzHy27BC,UyHr27BG;CzHs27BH,uByH127BmB;CzH227BnB,mByHp27BiB;AzHq27BlB;AACA;CACC;EyHh27BE,kBnGFS;CtBo27BX;AACD;AACA;;CAEC,SyHp37BD;CzHq37BC,esBz27BO;CtB027BP,gBAAgB;AACjB;AACA;CACC,SAAS;CyHz37BV,eAAA;CzH237BC,cyH917Bc;AzH+17Bf;AACA;CACC,a0H537BO;C1H637BP,gB0H/37BD;C1Hg47BC,kB0H337BW;C1H437BX,mB0Hj47BD;C1Hk47BC,asBv37BO;AtBw37BR;AACA;CACC;EACC,eAAe;CAChB;AACD;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,mBAAmB;AACpB;AACA;CACC;EACC,kBAAkB;CACnB;AACD;AACA;CACC,qBAAqB;CACrB,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,8BAA8B;CAC9B,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,UAAU;CACV,OAAO;CACP,WAAW;CACX,qCAAqC;CACrC,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,gCAAgC;AACjC;AACA;;CAEC,cAAc;CACd,gBAAgB;AACjB;AACA;CACC;EACC,2BAA2B;EAC3B,wBAAwB;CACzB;AACD;AACA;CACC,SAAS;CACT,cAAc;AACf;AACA;CACC;EACC,WAAW;EACX,YAAY;CACb;AACD;AACA;CACC;EACC,WAAW;EACX,YAAY;CACb;AACD;;AAEA;CACC,eAAe;AAChB;AACA;CACC,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,wBAAwB;CACxB,qBAAqB;CACrB,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;AACA;;;;CAIC,qBAAqB;AACtB;AACA;CACC;EACC,sBAAsB;EACtB,mBAAmB;CACpB;AACD;AACA;;;;;;CAMC,WAAW;AACZ;AACA;;;;;;CAMC,sBAAsB;AACvB;AACA;CACC,6BAA6B;AAC9B;;AAEA;CACC,4BAA4B;CAC5B,gCAAgC;AACjC;AACA;;;CAGC,kCAAkC;CAClC,sCAAsC;AACvC;AACA;CACC,iBAAiB;AAClB;AACA;;CAEC,gCAAgC;CAChC,4BAA4B;AAC7B;;AAEA;CACC,qBAAqB;CACrB,qBAAqB;AACtB;AACA;CACC,2BAA2B;AAC5B;;AAEA;CACC,qBAAqB;CACrB,4BAA4B;AAC7B;AACA;CACC,kCAAkC;CAClC,sCAAsC;AACvC;;AAEA;CACC,aAAa;CACb,cAAc;CACd,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,uBAAuB;CACvB,UAAU;AACX;;AAEA;CACC,cAAc;CACd,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,mBAAmB;AACpB;AACA;CACC;EACC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;CACpB;AACD;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,wCAAwC;CACxC,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,wCAAwC;CACxC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,wCAAwC;CACxC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,mCAAmC;CACnC,qBAAqB;AACtB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,uCAAuC;CACvC,yBAAyB;CACzB,WAAW;AACZ;AACA;CACC,gCAAgC;CAChC,4BAA4B;CAC5B,WAAW;AACZ;AACA;CACC,UAAU;AACX;;AAEA;CACC,mCAAmC;CACnC,qCAAqC;CACrC,yBAAyB;AAC1B;AACA;CACC,aAAa;AACd;AACA;CACC,yCAAyC;CACzC,yBAAyB;CACzB,WAAW;AACZ;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,sBAAsB;AACvB;AACA;CACC,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,yCAAyC;CACzC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,yCAAyC;CACzC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,yCAAyC;CACzC,yBAAyB;CACzB,WAAW;AACZ;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,UAAU;AACX;;AAEA;CACC,6BAA6B;CAC7B,yBAAyB;AAC1B;AACA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,UAAU;AACX;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,UAAU;AACX;AACA;CACC,qBAAqB;CACrB,uCAAuC;AACxC;AACA;CACC,oBAAoB;AACrB;AACA;CACC,gCAAgC;CAChC,4BAA4B;CAC5B,WAAW;AACZ;AACA;CACC,UAAU;AACX;AACA;CACC,uBAAuB;AACxB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,UAAU;AACX;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,UAAU;AACX;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,UAAU;AACX;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,UAAU;AACX;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,UAAU;AACX;;AAEA;CACC,6BAA6B;CAC7B,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,qBAAqB;AACtB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,uCAAuC;CACvC,mCAAmC;CACnC,qBAAqB;AACtB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,yCAAyC;CACzC,qCAAqC;CACrC,uBAAuB;AACxB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,UAAU;AACX;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,UAAU;AACX;;AAEA;CAEC,oEAAoE;AACrE;;AAEA;CAEC,sEAAsE;AACvE;;AAEA;CAEC,sEAAsE;AACvE;;AAEA;CAEC,qEAAqE;AACtE;;AAEA;CAEC,qEAAqE;AACtE;;AAEA;CAEC,qEAAqE;AACtE;;AAEA;CACC,2BAA2B;CAC3B,oBAAoB;CACpB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;;CAEC,8BAA8B;CAC9B,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;CAC9B,sBAAsB;AACvB;;AAEA;;CAEC,sBAAsB;CACtB,8BAA8B;AAC/B;AACA;CACC;;EAEC,wBAAwB;CACzB;AACD;;AAEA;CACC,oBAAoB;AACrB;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;AAC3B;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;AAC3B;;AAEA;CACC,iBAAiB;CACjB,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,oCAAoC;CACpC,qBAAqB;CACrB,8BAA8B;CAC9B,mCAAmC;CACnC,iCAAiC;CACjC,4BAA4B;AAC7B;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;CACrB,qBAAqB;CACrB,yCAAyC;CACzC,6BAA6B;CAC7B,WAAW;AACZ;AACA;CACC;EACC,uCAAuC;CACxC;AACD;;AAEA;CACC,oCAAoC;AACrC;AACA;CACC;EACC,wCAAwC;CACzC;AACD;;AAEA;CACC,6BAA6B;CAC7B,qBAAqB;CACrB,8BAA8B;CAC9B,mCAAmC;CACnC,mCAAmC;AACpC;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,6BAA6B;AAC9B;AACA;CACC,aAAa;CACb,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;CAC3B,iBAAiB;CACjB,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,8BAA8B;CAC9B,wBAAwB;AACzB;;AAEA;CACC,mBAAmB;CACnB,8BAA8B;CAC9B,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,6BAA6B;AAC9B;;AAEA;CACC,mBAAmB;CACnB,8BAA8B;CAC9B,wBAAwB;AACzB;;AAEA;CACC,oBAAoB;CACpB,0BAA0B;CAC1B,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,6BAA6B;CAC7B,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,cAAc;AACf;AACA;;;CAGC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,oBAAoB;AACrB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,gCAAgC;CAChC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;CACjC,oCAAoC;AACrC;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,mBAAmB;CACnB,WAAW;CACX,qBAAqB;AACtB;;AAEA;;;;;CAKC,gCAAgC;CAChC,4BAA4B;CAC5B,WAAW;AACZ;;AAEA;;;;;CAKC,+CAA+C;AAChD;;AAEA;;CAEC,+CAA+C;AAChD;;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;AACA;CACC,yCAAyC;AAC1C;;AAEA;CACC,yCAAyC;CACzC,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,mDAAmD;AACpD;AACA;CACC,aAAa;AACd;AACA;CACC,oCAAoC;AACrC;AACA;CACC,UAAU;AACX;;AAEA;CACC,mDAAmD;AACpD;AACA;CACC,aAAa;AACd;AACA;CACC,oCAAoC;AACrC;AACA;CACC,UAAU;AACX;;AAEA;CACC,uBAAuB;CACvB,yBAAyB;CACzB,gCAAgC;CAChC,kBAAkB;CAClB,8BAA8B;CAC9B,uBAAuB;CACvB,yBAAyB;AAC1B;AACA;CACC;EACC,uBAAuB;EACvB,6BAA6B;CAC9B;AACD;AACA;CACC,iBAAiB;AAClB;AACA;CACC;EACC,aAAa;CACd;AACD;AACA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;CACd,0BAA0B;AAC3B;AACA;CACC,iBAAiB;AAClB;AACA;CACC,eAAe;AAChB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,uBAAuB;CACvB,gCAAgC;CAChC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,mDAAmD;AACpD;AACA;CACC;EACC,6BAA6B;CAC9B;AACD;AACA;CACC,sCAAsC;AACvC;AACA;CACC,mBAAmB;AACpB;AACA;CACC,sBAAsB;CACtB,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,qBAAqB;CACrB,uBAAuB;CACvB,iCAAiC;AAClC;AACA;CACC,sCAAsC;AACvC;;AAEA;CACC,uBAAuB;CACvB,mCAAmC;CACnC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,wBAAwB;CACxB,yBAAyB;CACzB,kBAAkB;CAClB,+BAA+B;CAC/B,WAAW;CACX,oBAAoB;AACrB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;AAChB;AACA;;CAEC,+BAA+B;AAChC;AACA;;CAEC,mBAAmB;AACpB;AACA;;CAEC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,wBAAwB;CACxB,yBAAyB;CACzB,kBAAkB;CAClB,oBAAoB;CACpB,cAAc;CACd,kBAAkB;CAClB,qBAAqB;CACrB,+BAA+B;CAC/B,qBAAqB;AACtB;AACA;CACC,mBAAmB;AACpB;AACA;;CAEC,+BAA+B;AAChC;AACA;;CAEC,mBAAmB;AACpB;AACA;CACC,UAAU;CACV,sBAAsB;CACtB,WAAW;AACZ;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CAGZ,aAAa;CAGb,mBAAmB;CACnB,qCAAqC;CACrC,YAAY;AACb;;AAEA;CACC,cAAc;CACd,+BAA+B;CAC/B,iBAAiB;CACjB,kBAAkB;CAClB,WAAW;CACX,eAAe;AAChB;;AAEA;CAEC,sCAAsC;CACtC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,eAAe;CACf,+BAA+B;CAC/B,eAAe;CACf,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;AAClB;;AAaA;CACC;EAEC,uBAAuB;CACxB;CACA;EAEC,yBAAyB;CAC1B;AACD;;AAEA;CACC,aAAa;AACd;;AAEA;;CAEC,aAAa;CACb,cAAc;CACd,mBAAmB;CACnB,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;AACnB;AACA;;CAEC,eAAe;AAChB;AACA;;CAEC,iGAAiG;CACjG,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,2BAA2B;AAC5B;;AAEA;CACC,4CAA4C;CAC5C,UAAU;CACV,8BAA8B;AAC/B;AACA;;CAEC,WAAW;CACX,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,gBAAgB;CAChB,uBAAuB;CACvB,kDAAkD;CAClD,aAAa;AACd;AACA;CACC,eAAe;CACf,cAAc;CACd,uBAAuB;AACxB;AACA;CACC;EACC,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;CACjB;AACD;AACA;;;;CAIC,cAAc;AACf;AACA;;CAEC,qBAAqB;CACrB,iCAAiC;AAClC;AACA;CACC,sBAAsB;AACvB;AACA;CACC,QAAQ;CACR,0BAA0B;AAC3B;;AAEA;CACC,mBAAmB;CACnB,aAAa;AACd;AACA;CACC,qBAAqB;CACrB,oBAAoB;CACpB,uBAAuB;CACvB,WAAW;CACX,uBAAuB;CACvB,qCAAqC;CACrC,gBAAgB;CAChB,oCAAoC;AACrC;AACA;CACC,yBAAyB;AAC1B;AACA;;;CAGC,UAAU;AACX;;AAEA;;;;;;;;;;GAUG;AACH;;GAEG;AACH;;;;;GAKG;AACH;CACC,aAAa;AACd;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,iCAAiC;AAClC;AACA;;;CAGC,0BAA0B;CAC1B,WAAW;AACZ;AACA;CACC,qBAAqB;CACrB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;CAChB,kCAAkC;CAClC,wBAAwB;CACxB,cAAc;AACf;AACA;;CAEC,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,kCAAkC;CAClC,kBAAkB;CAClB,wBAAwB;AACzB;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,oCAAoC;AACrC;AACA;;CAEC,oCAAoC;AACrC;;AAEA;CACC,oBAAoB;AACrB;;AAEA;;;CAGC,0BAA0B;AAC3B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;CAC1B,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,kBAAkB;CAClB,sBAAsB;AACvB;AACA;CACC,aAAa;CACb,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,iBAAiB;CACjB,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,iBAAiB;CACjB,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;CAC1B,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,sBAAsB;CACtB,2BAA2B;CAC3B,wBAAwB;CACxB,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,kCAAkC;AACnC;;AAEA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;AACA;;CAEC,mBAAmB;CACnB,mBAAmB;CACnB,sBAAsB;AACvB;AACA;;CAEC,eAAe;CACf,mBAAmB;CACnB,sBAAsB;AACvB;AACA;;CAEC,mBAAmB;CACnB,mBAAmB;AACpB;AACA;;CAEC,kBAAkB;CAClB,mBAAmB;AACpB;AACA;;CAEC,kBAAkB;CAClB,mBAAmB;AACpB;AACA;;CAEC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,wCAAwC;CACxC,yBAAyB;CACzB,oBAAoB;CACpB,cAAc;AACf;AACA;CACC,gCAAgC;CAChC,4BAA4B;AAC7B;AACA;CACC,sCAAsC;AACvC;;AAEA;;CAEC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,WAAW;AACZ;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,mBAAmB;AACpB;AACA;CACC,kCAAkC;AACnC;AACA;CACC,mCAAmC;CACnC,qCAAqC;AACtC;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;CAC1B,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC;EACC,kBAAkB;CACnB;AACD;AACA;CACC,cAAc;CACd,uBAAuB;AACxB;;AAEA;CACC,mDAAmD;CACnD,aAAa;CACb,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,UAAU;CACV,yBAAyB;AAC1B;AACA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,WAAW;AACZ;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,wBAAwB;AACzB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,SAAS;CACT,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,oBAAoB;AACrB;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd,YAAY;AACb;;AAEA;CACC,sBAAsB;AACvB;AACA;CACC,0BAA0B;CAC1B,SAAS;CACT,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,MAAM;CACN,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;CACtB,aAAa;CACb,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC;EACC,uBAAuB;CACxB;AACD;AACA;CACC,aAAa;CACb,8BAA8B;CAC9B,kBAAkB;CAClB,kCAAkC;AACnC;AACA;;CAEC,YAAY;AACb;AACA;CACC,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,yBAAyB;CACzB,+BAA+B;AAChC;AACA;CACC,cAAc;CACd,yBAAyB;CACzB,iBAAiB;CACjB,yBAAyB;CACzB,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,yBAAyB;CACzB,yBAAyB;CACzB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;CAC1B,4BAA4B;CAC5B,WAAW;AACZ;;AAEA;CACC,0BAA0B;CAC1B,4BAA4B;CAC5B,WAAW;AACZ;;AAEA;CACC,sBAAsB;AACvB;AACA;CACC,uBAAuB;CACvB,iBAAiB;CACjB,6BAA6B;CAC7B,gCAAgC;CAChC,uBAAuB;AACxB;AACA;CACC,cAAc;AACf;AACA;CACC,UAAU;CACV,UAAU;CACV,aAAa;CACb,cAAc;CACd,uBAAuB;CACvB,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,eAAe;CACf,qCAAqC;CACrC,cAAc;CACd,gBAAgB;CAChB,+BAA+B;AAChC;AACA;CACC,sCAAsC;CACtC,cAAc;CACd,kCAAkC;AACnC;AACA;;CAEC,WAAW;AACZ;AACA;CACC,UAAU;CACV,gBAAgB;AACjB;AACA;CACC,0BAA0B;CAC1B,WAAW;CACX,4BAA4B;AAC7B;AACA;CACC,gCAAgC;CAChC,4BAA4B;CAC5B,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,cAAc;CAGd,oBAAoB;AACrB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,yBAAyB;AAC1B;AACA;CACC,0BAA0B;CAC1B,4BAA4B;AAC7B;AACA;CACC,0BAA0B;CAC1B,4BAA4B;AAC7B;AACA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,iCAAiC;CACjC,mCAAmC;CACnC,cAAc;AACf;AACA;CACC,iCAAiC;CACjC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;CAEC,0BAA0B;CAC1B,4BAA4B;AAC7B;AACA;;CAEC,WAAW;AACZ;AACA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,mCAAmC;CACnC,yBAAyB;CACzB,cAAc;AACf;AACA;;CAEC,mBAAmB;CACnB,qBAAqB;CACrB,0DAA0D;AAC3D;AACA;;CAEC,WAAW;AACZ;AACA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,kCAAkC;CAClC,yBAAyB;CACzB,cAAc;AACf;AACA;;CAEC,mBAAmB;CACnB,qBAAqB;CACrB,0DAA0D;AAC3D;AACA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,cAAc;AACf;AACA;CACC,mCAAmC;CACnC,yBAAyB;CACzB,cAAc;AACf;AACA;;CAEC,mBAAmB;CACnB,qBAAqB;CACrB,2DAA2D;AAC5D;AACA;CACC,uBAAuB;AACxB;AACA;CACC,kCAAkC;AACnC;AACA;CACC,uBAAuB;AACxB;AACA;;CAEC,aAAa;CACb,cAAc;CACd,UAAU;CACV,mBAAmB;CACnB,6BAA6B;CAC7B,UAAU;AACX;AACA;CACC,aAAa;CACb,gCAAgC;CAChC,8BAA8B;CAC9B,mBAAmB;CACnB,cAAc;CACd,iCAAiC;CACjC,qBAAqB;AACtB;AACA;CACC,WAAW;CACX,0BAA0B;AAC3B;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,UAAU;CACV,aAAa;CACb,cAAc;CACd,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,UAAU;CACV,gBAAgB;CAChB,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;CAC9B,oBAAoB;CACpB,6CAA6C;CAC7C,uBAAuB;AACxB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,mBAAmB;CACnB,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kCAAkC;AACnC;AACA;CACC,qBAAqB;AACtB;AACA;CACC;EACC,UAAU;CACX;AACD;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;AACtB;AACA;;CAEC,0BAA0B;CAC1B,WAAW;CACX,gBAAgB;AACjB;;AAEA;;;CAGC,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;;CAEC,WAAW;CACX,0BAA0B;AAC3B;;AAEA;;CAEC,UAAU;CACV,2BAA2B;AAC5B;;AAEA;;;CAGC,SAAS;CACT,4BAA4B;AAC7B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,yBAAyB;AAC1B;AACA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC,sBAAsB;CACtB,2BAA2B;CAC3B,0BAA0B;AAC3B;;AAEA;CACC;EACC,QAAQ;CACT;AACD;;AAEA;CACC;EACC,QAAQ;CACT;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,2BAA2B;CAC3B,mBAAmB;CACnB,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,kCAAkC;CAClC,wCAAwC;CACxC,OAAO;CACP,WAAW;CACX,iBAAiB;AAClB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,mBAAmB;CACnB,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,gBAAgB;CAChB,cAAc;CACd,wBAAwB;AACzB;AACA;CACC,eAAe;CACf,aAAa;CACb,eAAe;CACf,iBAAiB;CACjB,yBAAyB;CACzB,sDAAsD;CACtD,yBAAyB;CACzB,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,gCAAgC;CAChC,aAAa;CACb,WAAW;CACX,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;;CAEC,WAAW;CACX,uCAAuC;CACvC,cAAc;CACd,wBAAwB;CACxB,WAAW;CACX,gBAAgB;CAChB,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,gCAAgC;CAChC,yBAAyB;CACzB,kBAAkB;CAClB,WAAW;CACX,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,SAAS;CACT,mBAAmB;CACnB,0CAA0C;CAC1C,gEAAgE;CAChE,aAAa;CACb,eAAe;AAChB;AACA;CACC,OAAO;CACP,aAAa;CACb,eAAe;CACf,gBAAgB;CAChB,gCAAgC;CAEhC,+EAA+E;CAC/E,aAAa;CACb,kBAAkB;CAClB,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;AACZ;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,mCAAmC;CACnC,qCAAqC;CACrC,yCAAyC;AAC1C;;AAEA;;;CAGC,yBAAyB;CACzB,aAAa;CACb,cAAc;AACf;;AAEA;;;CAGC,yDAAyD;CACzD,uBAAuB;CACvB,yBAAyB;AAC1B;;AAEA;;;CAGC,uBAAuB;CACvB,yDAAyD;CACzD,gCAAgC;AACjC;;AAEA;;CAEC,yBAAyB;CACzB,oBAAoB;CACpB,gBAAgB;AACjB;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB,WAAW;AACZ;AACA;CACC,0BAA0B;CAC1B,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,cAAc;CACd,sBAAsB;CACtB,sBAAsB;CACtB,gBAAgB;CAChB,iBAAiB;CACjB,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,UAAU;CACV,gBAAgB;CAChB,iBAAiB;CACjB,sBAAsB;CACtB,sBAAsB;CACtB,mBAAmB;CACnB,4BAA4B;CAC5B,wBAAwB;AACzB;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,WAAW;CACX,gCAAgC;CAChC,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,YAAY;AACb;AACA;CACC,UAAU;CACV,UAAU;AACX;AACA;CACC,aAAa;AACd;AACA;CACC,sBAAsB;CACtB,4BAA4B;AAC7B;AACA;CACC,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,0BAA0B;CAC1B,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,qBAAqB;CACrB,qBAAqB;CACrB,cAAc;AACf;AACA;;;CAGC,cAAc;CACd,sBAAsB;CACtB,0CAA0C;CAC1C,oCAAoC;CACpC,qBAAqB;AACtB;AACA;;;CAGC,uCAAuC;CACvC,0EAA0E;AAC3E;;AAEA;CACC,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;CAChB,0CAA0C;CAC1C,gCAAgC;AACjC;AACA;CACC,qBAAqB;CACrB,qBAAqB;CACrB,qBAAqB;AACtB;AACA;;;CAGC,cAAc;CACd,sBAAsB;CACtB,4BAA4B;CAC5B,gBAAgB;CAChB,qBAAqB;CACrB,gCAAgC;AACjC;AACA;;;CAGC,uCAAuC;AACxC;;AAEA;;CAEC,iCAAiC;CACjC,qBAAqB;CACrB,gBAAgB;AACjB;AACA;;CAEC,iCAAiC;AAClC;;AAEA;;CAEC,uCAAuC;CACvC,qBAAqB;AACtB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,0BAA0B;CAC1B,WAAW;AACZ;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;;;CAGC,4BAA4B;AAC7B;;AAEA;;CAEC,2BAA2B;AAC5B;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,YAAY;CACZ,SAAS;CACT,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,wBAAwB;CACxB,mBAAmB;AACpB;AACA;CACC,oCAAoC;AACrC;AACA;CACC,UAAU;CACV,gBAAgB;CAChB,kBAAkB;CAClB,uBAAuB;AACxB;AACA;CACC,wBAAwB;CACxB,kBAAkB;AACnB;AACA;CACC,YAAY;CACZ,cAAc;AACf;AACA;CACC,YAAY;CACZ,cAAc;CACd,WAAW;AACZ;AACA;CACC,uBAAuB;CACvB,0BAA0B;CAC1B,kBAAkB;CAClB,cAAc;CACd,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,cAAc;CACd,wBAAwB;CACxB,yBAAyB;AAC1B;AACA;CACC,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,qBAAqB;CACrB,mBAAmB;CACnB,2CAA2C;CAC3C,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,wBAAwB;CACxB,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,OAAO;CACP,kBAAkB;CAClB,aAAa;CACb,eAAe;CACf,sBAAsB;CACtB,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mCAAmC;AACpC;AACA;CACC,mCAAmC;AACpC;AACA;CACC,gCAAgC;CAChC,wDAAwD;AACzD;AACA;CACC,iCAAiC;CACjC,mCAAmC;AACpC;AACA;CACC,yBAAyB;CACzB,uCAAuC;AACxC;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,oCAAoC;AACrC;AACA;CACC,oCAAoC;CACpC,yDAAyD;AAC1D;AACA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,wCAAwC;CACxC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,qCAAqC;AACtC;AACA;CACC,oCAAoC;CACpC,0DAA0D;AAC3D;AACA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,yCAAyC;CACzC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,qCAAqC;AACtC;AACA;CACC,oCAAoC;CACpC,yDAAyD;AAC1D;AACA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,yCAAyC;CACzC,yBAAyB;AAC1B;;AAEA;CACC,qCAAqC;AACtC;AACA;CACC,qCAAqC;AACtC;AACA;CACC,6CAA6C;CAC7C,yDAAyD;AAC1D;AACA;CACC,mCAAmC;CACnC,qBAAqB;AACtB;AACA;CACC,wCAAwC;CACxC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,qCAAqC;AACtC;AACA;CACC,oCAAoC;CACpC,yDAAyD;AAC1D;AACA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,yCAAyC;CACzC,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,kCAAkC;CAClC,mBAAmB;CACnB,6BAA6B;CAC7B,gBAAgB;CAChB,+CAA+C;AAChD;AACA;CACC,SAAS;CACT,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,4BAA4B;AAC7B;AACA;CACC,0BAA0B;AAC3B;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;AACA;;CAEC,eAAe;AAChB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,aAAa;AACd;AACA;CACC,iBAAiB;AAClB;;AAEA;;CAEC,4BAA4B;CAC5B,mBAAmB;AACpB;;AAEA;;;CAGC,kCAAkC;AACnC;;AAEA;CACC,4BAA4B;CAC5B,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;AACA;CACC,gCAAgC;CAChC,sCAAsC;CACtC,WAAW;AACZ;AACA;CACC,sCAAsC;AACvC;AACA;CACC,4BAA4B;AAC7B;;AAEA;CACC,8BAA8B;CAC9B,iDAAiD;AAClD;;AAEA;CACC,qBAAqB;CACrB,aAAa;CACb,cAAc;CACd,mBAAmB;CACnB,sBAAsB;CACtB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,kBAAkB;AACnB;AACA;CACC,WAAW;AACZ;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX,+BAA+B;CAC/B,gCAAgC;AACjC;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,mCAAmC;CACnC,cAAc;CACd,aAAa;CACb,kBAAkB;CAClB,qBAAqB;CACrB,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,cAAc;AACf;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,uBAAuB;CACvB,yBAAyB;CACzB,eAAe;CACf,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,WAAW;AACZ;AACA;;CAEC,iBAAiB;CACjB,gBAAgB;CAChB,SAAS;CACT,gBAAgB;AACjB;AACA;;CAEC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;AACvB;AACA;CACC,sBAAsB;AACvB;;AAEA;CACC,2CAA2C;CAC3C,WAAW;AACZ;;AAEA;CACC,sDAAsD;AACvD;;AAEA;CACC,cAAc;CACd,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,iCAAiC;CACjC,mCAAmC;AACpC;AACA;CACC,uCAAuC;CACvC,mCAAmC;AACpC;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,yCAAyC;CACzC,qCAAqC;AACtC;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,wCAAwC;CACxC,oCAAoC;AACrC;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,yCAAyC;CACzC,qCAAqC;AACtC;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,yCAAyC;CACzC,qCAAqC;AACtC;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,wCAAwC;CACxC,oCAAoC;AACrC;;AAEA;CACC,iCAAiC;AAClC;AACA;CACC,uCAAuC;AACxC;;AAEA;CACC,oCAAoC;AACrC;AACA;CACC,0CAA0C;AAC3C;;AAEA;CACC,oCAAoC;AACrC;AACA;CACC,yCAAyC;AAC1C;;AAEA;CACC,oCAAoC;AACrC;AACA;CACC,0CAA0C;AAC3C;;AAEA;CACC,oCAAoC;AACrC;AACA;CACC,yCAAyC;AAC1C;;AAEA;CACC,oCAAoC;AACrC;AACA;CACC,yCAAyC;AAC1C;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,WAAW;CACX,WAAW;CACX,YAAY;CACZ,OAAO;CACP,MAAM;CACN,kBAAkB;CAClB,aAAa;CACb,0BAA0B;CAC1B,WAAW;AACZ;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;AACA;CACC,sBAAsB;CACtB,sCAAsC;CACtC,qBAAqB;CACrB,SAAS;CACT,UAAU;AACX;AACA;CACC,sBAAsB;CACtB,eAAe;CACf,sBAAsB;CACtB,2BAA2B;AAC5B;AACA;CACC,iBAAiB;CACjB,uBAAuB;AACxB;AACA;CACC,eAAe;CACf,cAAc;CACd,qBAAqB;CACrB,oBAAoB;CACpB,kBAAkB;CAClB,oBAAoB;AACrB;AACA;CACC,eAAe;CACf,qBAAqB;AACtB;AACA;CACC,yBAAyB;CACzB,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;CACX,qBAAqB;CACrB,mBAAmB;CACnB,YAAY;CACZ,kBAAkB;CAClB,qBAAqB;CACrB,eAAe;CAIf,2BAA2B;CAC3B,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;CAClB,QAAQ;AACT;AACA;CACC,WAAW;CACX,OAAO;AACR;AACA;CACC,eAAe;CACf,UAAU;CACV,kBAAkB;AACnB;AACA;CACC,sBAAsB;CACtB,+BAA+B;CAC/B,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,cAAc;CACd,UAAU;CACV,mBAAmB;CACnB,oBAAoB;CACpB,sBAAsB;AACvB;AACA;CACC,0BAA0B;CAC1B,yBAAyB;AAC1B;AACA;CACC,gBAAgB;CAChB,0BAA0B;CAC1B,cAAc;CACd,cAAc;CACd,kBAAkB;CAClB,cAAc;CACd,UAAU;CACV,WAAW;AACZ;AACA;CACC,6BAA6B;CAC7B,kBAAkB;AACnB;AACA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,qBAAqB;CACrB,wBAAwB;AACzB;AACA;CACC,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;AACrB;AACA;CACC,gBAAgB;CAChB,SAAS;CACT,mDAAmD;AACpD;AACA;CACC,aAAa;AACd;AACA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;;CAEC,aAAa;CACb,cAAc;CACd,UAAU;CACV,mBAAmB;CACnB,uBAAuB;AACxB;AACA;;CAEC,wBAAwB;AACzB;AACA;;CAEC,kCAAkC;CAClC,SAAS;CACT,cAAc;CACd,mBAAmB;CACnB,gBAAgB;AACjB;AACA;;CAEC,gCAAgC;CAChC,WAAW;AACZ;AACA;CACC,OAAO;AACR;AACA;CACC,gBAAgB;AACjB;AACA;CACC,QAAQ;AACT;AACA;CACC,gBAAgB;AACjB;AACA;CACC,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC,aAAa;CACb,cAAc;CACd,uBAAuB;CACvB,qBAAqB;CACrB,eAAe;CACf,mBAAmB;CACnB,YAAY;CACZ,oBAAoB;AACrB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,oBAAoB;CACpB,UAAU;CACV,gCAAgC;CAChC,sBAAsB;AACvB;AACA;CACC,gCAAgC;CAChC,sBAAsB;AACvB;AACA;CACC,gCAAgC;CAChC,sBAAsB;AACvB;AACA;CACC,wBAAwB;AACzB;AACA;;;CAGC,SAAS;CACT,uBAAuB;CACvB,eAAe;AAChB;AACA;;;CAGC,gCAAgC;CAChC,sBAAsB;AACvB;AACA;CACC;EACC,0BAA0B;EAC1B,0BAA0B;CAC3B;CACA;EACC,kBAAkB;EAClB,kBAAkB;CACnB;AACD;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;AACA;CACC,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,wBAAwB;CACxB,WAAW;AACZ;AACA;CACC;EACC,yBAAyB;CAC1B;AACD;AACA;CACC,qBAAqB;CACrB,sBAAsB;AACvB;AACA;CACC,eAAe;AAChB;AACA;CACC,yCAAyC;AAC1C;AACA;CACC,qBAAqB;CACrB,uBAAuB;CACvB,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,yCAAyC;AAC1C;AACA;CACC,WAAW;AACZ;AACA;CACC,qBAAqB;AACtB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,WAAW;AACZ;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,sCAAsC;CACtC,yBAAyB;CACzB,wBAAwB;AACzB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,iCAAiC;CACjC,qBAAqB;AACtB;AACA;CACC,uCAAuC;AACxC;AACA;CACC,iCAAiC;CACjC,qBAAqB;AACtB;AACA;CACC,wCAAwC;AACzC;AACA;CACC,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,yCAAyC;AAC1C;AACA;CACC,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,yCAAyC;AAC1C;AACA;CACC,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,wCAAwC;AACzC;AACA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,oBAAoB;CACpB,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,iDAAiD;AAClD;;AAEA;;CAEC,qBAAqB;CACrB,2BAA2B;AAC5B;AACA;;CAEC,iDAAiD;CACjD,WAAW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,sBAAsB;CACtB,iDAAiD;AAClD;AACA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,gCAAgC;AACjC;;AAEA;;CAEC,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,qCAAqC;CACrC,0CAA0C;CAC1C,yBAAyB;AAC1B;AACA;CACC,6CAA6C;AAC9C;AACA;CACC,6CAA6C;AAC9C;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;AACA;CACC,kCAAkC;AACnC;;AAEA;;CAEC,mBAAmB;CACnB,WAAW;CACX,8CAA8C;AAC/C;AACA;;CAEC,4BAA4B;AAC7B;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;CAEC,0BAA0B;CAC1B,WAAW;CACX,+CAA+C;AAChD;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,mBAAmB;CACnB,WAAW;CACX,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,mBAAmB;CACnB,WAAW;CACX,6CAA6C;AAC9C;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,mBAAmB;CACnB,WAAW;CACX,+CAA+C;AAChD;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,4BAA4B;CAC5B,sBAAsB;AACvB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,SAAS;AACV;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,eAAe;CACf,0BAA0B;CAC1B,gBAAgB;CAChB,oBAAoB;AACrB;AACA;;CAEC,WAAW;AACZ;AACA;CACC,iDAAiD;AAClD;;AAEA;CACC,sBAAsB;CACtB,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,+BAA+B;AAChC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gCAAgC;CAChC,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,+BAA+B;AAChC;AACA;CACC,sCAAsC;AACvC;;AAEA;CACC,gCAAgC;CAChC,WAAW;CACX,mBAAmB;CACnB,6BAA6B;AAC9B;;AAEA;CACC,gCAAgC;CAChC,WAAW;CACX,yBAAyB;AAC1B;AACA;CACC,kBAAkB;AACnB;AACA;CACC,uCAAuC;AACxC;AACA;;CAEC,kDAAkD;CAClD,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;;;CAGC,uCAAuC;CACvC,qBAAqB;AACtB;AACA;;;CAGC,uCAAuC;AACxC;;AAEA;;;CAGC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,wCAAwC;AACzC;;AAEA;;;CAGC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,wCAAwC;AACzC;;AAEA;;;CAGC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,yCAAyC;AAC1C;;AAEA;;;CAGC,yBAAyB;CACzB,cAAc;AACf;AACA;;;CAGC,yCAAyC;AAC1C;;AAEA;;;CAGC,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;AAC1B;;AAEA;;CAEC,sBAAsB;AACvB;AACA;CACC;;EAEC,uBAAuB;CACxB;AACD;;AAEA;;CAEC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC;;EAEC,wBAAwB;CACzB;AACD;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;CACC,qBAAqB;CACrB,SAAS;AACV;AACA;CACC;EACC,UAAU;CACX;CACA;EACC,sBAAsB;CACvB;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;AAChC;;AAEA;;CAEC,wBAAwB;AACzB;;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;;CAEC,gCAAgC;CAChC,aAAa;AACd;;AAEA;;CAEC,aAAa;AACd;;AAEA;;CAEC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;;;CAGC,WAAW;CACX,kCAAkC;CAClC,gBAAgB;CAChB,sBAAsB;CACtB,iBAAiB;CACjB,2BAA2B;CAC3B,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,eAAe;CACf,0BAA0B;CAC1B,gBAAgB;CAChB,oBAAoB;AACrB;AACA;CACC,WAAW;AACZ;AACA;CACC;EACC,eAAe;CAChB;AACD;AACA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,oBAAoB;CACpB,eAAe;AAChB;AACA;;CAEC,gBAAgB;CAChB,eAAe;CACf,oBAAoB;CACpB,YAAY;CACZ,YAAY;CACZ,UAAU;CACV,qBAAqB;CACrB,iBAAiB;CACjB,qBAAqB;CACrB,uBAAuB;AACxB;AACA;;CAEC,yBAAyB;CACzB,4BAA4B;CAC5B,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;AACpB;AACA;;CAEC,0BAA0B;CAC1B,6BAA6B;AAC9B;AACA;;CAEC,eAAe;CACf,eAAe;AAChB;AACA;;CAEC,YAAY;AACb;AACA;;;;;;CAMC,sBAAsB;CACtB,qCAAqC;CACrC,kBAAkB;AACnB;AACA;;CAEC,yBAAyB;CACzB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;AACA;CACC;;EAEC,YAAY;EACZ,YAAY;EACZ,eAAe;CAChB;CACA;;EAEC,eAAe;CAChB;AACD;AACA;CACC;;EAEC,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;CAClB;CACA;;EAEC,eAAe;CAChB;CACA;;EAEC,aAAa;CACd;AACD;AACA;CACC,YAAY;CACZ,WAAW;CACX,UAAU;CACV,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;CACf,mBAAmB;CACnB,yBAAyB;CACzB,oBAAoB;AACrB;AACA;CACC;EACC,YAAY;EACZ,WAAW;EACX,iBAAiB;CAClB;AACD;AACA;;CAEC,sBAAsB;CACtB,qCAAqC;CACrC,0CAA0C;AAC3C;AACA;;CAEC,gCAAgC;CAChC,4CAA4C;AAC7C;;AAEA;;;CAGC,oCAAoC;CACpC,sBAAsB;CACtB,cAAc;CACd,kCAAkC;CAClC,iBAAiB;AAClB;AACA;;;CAGC,mBAAmB;CACnB,iDAAiD;CACjD,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;AACA;CACC,sBAAsB;CACtB,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;AACA;CACC,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,gBAAgB;AACjB;AACA;CACC,wBAAwB;AACzB;;AAEA;CACC;;EAEC,gBAAgB;CACjB;AACD;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;;;;CAIC,cAAc;CACd,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC;;;;EAIC,kBAAkB;CACnB;AACD;;AAEA;;CAEC,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,qCAAqC;CACrC,uBAAuB;CACvB,qBAAqB;AACtB;AACA;CACC,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,4BAA4B;CAC5B,qBAAqB;AACtB;;AAEA;;;;CAIC,qBAAqB;AACtB;AACA;;;;CAIC,sCAAsC;AACvC;;AAEA;CACC,8BAA8B;CAC9B,sBAAsB;AACvB;;AAEA;CACC,uCAAuC;AACxC;;AAEA;;CAEC,YAAY;CACZ,WAAW;CACX,UAAU;CACV,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,aAAa;CACb,kBAAkB;CAClB,cAAc;AACf;AACA;CACC;;EAEC,YAAY;EACZ,WAAW;EACX,iBAAiB;CAClB;AACD;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,UAAU;CACV,iBAAiB;CACjB,qBAAqB;CACrB,aAAa;CACb,kBAAkB;AACnB;AACA;CACC;EACC,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;CAChB;AACD;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;;;CAGC,WAAW;CACX,kCAAkC;CAClC,gBAAgB;CAChB,sBAAsB;CACtB,gBAAgB;CAChB,2BAA2B;CAC3B,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;;;;;;;;GASG;AACH;CACC,qBAAqB;CACrB,+CAA+C;AAChD;;AAEA;CACC,UAAU;CACV,UAAU;AACX;;AAEA;;GAEG;AACH;CACC,oCAAoC;AACrC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;;;CAIC,+BAA+B;AAChC;;AAEA;CACC,oBAAoB;CACpB,qBAAqB;AACtB;;AAEA;CACC,gCAAgC;CAChC,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC;EACC,6BAA6B;CAC9B;AACD;;AAEA;CACC,SAAS;CACT,sBAAsB;CACtB,qBAAqB;CACrB,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,2BAA2B;CAC3B,mBAAmB;CACnB,sBAAsB;CACtB,uBAAuB;CAGvB,oBAAoB;CACpB,eAAe;AAChB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,oBAAoB;AACrB;AACA;CACC;EACC,WAAW;EACX,YAAY;CACb;AACD;AACA;CACC;EACC,WAAW;EACX,YAAY;CACb;AACD;AACA;CACC;EACC,WAAW;EACX,YAAY;CACb;AACD;AACA;CACC,gBAAgB;AACjB;AACA;CACC,aAAa;AACd;AACA;CACC,eAAe;AAChB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,qBAAqB;CACrB,uCAAuC;CACvC,gCAAgC;CAChC,uBAAuB;CACvB,WAAW;CACX,gBAAgB;AACjB;AACA;CACC;EACC,WAAW;CACZ;AACD;AACA;CACC,gBAAgB;AACjB;AACA;CACC,uCAAuC;CACvC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;AACjC;AACA;CACC,gBAAgB;CAChB,UAAU;CACV,eAAe;AAChB;AACA;CACC,YAAY;AACb;AACA;CACC;EACC,YAAY;CACb;AACD;AACA;CACC;EACC,WAAW;CACZ;CACA;EACC,WAAW;EACX,YAAY;CACb;AACD;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,sBAAsB;AACvB;AACA;;CAEC,mBAAmB;CACnB,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,iBAAiB;AAClB;AACA;CACC,oBAAoB;CACpB,eAAe;CACf,cAAc;AACf;AACA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,uBAAuB;CACvB,8CAA8C;AAC/C;AACA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;CAC1B,WAAW;AACZ;AACA;CACC,UAAU;AACX;;AAEA;CACC,iCAAiC;CACjC,WAAW;AACZ;AACA;CACC,oBAAoB;AACrB;;AAEA;CACC,0BAA0B;CAC1B,WAAW;AACZ;AACA;CACC,UAAU;AACX;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;AACnB;AACA;CACC;EACC,8BAA8B;CAC/B;AACD;AACA;CACC;EACC,8BAA8B;EAC9B,kBAAkB;CACnB;AACD;AACA;CACC;EACC,8BAA8B;CAC/B;AACD;AACA;CACC,gCAAgC;AACjC;AACA;CACC,iBAAiB;CACjB,aAAa;CACb,eAAe;CACf,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC;EACC,cAAc;EACd,eAAe;CAChB;AACD;AACA;CACC,SAAS;CACT,cAAc;CACd,qBAAqB;CACrB,sBAAsB;CACtB,mBAAmB;CACnB,sBAAsB;AACvB;AACA;CACC;EACC,cAAc;CACf;AACD;AACA;CACC;EACC,iBAAiB;CAClB;AACD;AACA;CACC;EACC,cAAc;CACf;AACD;AACA;CACC;EACC,iBAAiB;CAClB;AACD;AACA;CACC;EACC,cAAc;CACf;AACD;AACA;CACC,cAAc;CACd,mBAAmB;CACnB,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;CAChB,6BAA6B;CAC7B,uBAAuB;AACxB;AACA;CACC;EACC,mBAAmB;CACpB;AACD;AACA;CACC;EACC,gBAAgB;CACjB;AACD;AACA;CACC;EACC,kBAAkB;CACnB;AACD;AACA;CACC;EACC,oBAAoB;CACrB;AACD;AACA;CACC;EACC,eAAe;EACf,aAAa;CACd;AACD;AACA;CACC;EACC,iBAAiB;CAClB;AACD;AACA;CACC,aAAa;CACb,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,eAAe;CACf,mBAAmB;CACnB,8CAA8C;AAC/C;AACA;CACC;EACC,YAAY;EACZ,YAAY;CACb;AACD;AACA;CACC;EACC,YAAY;EACZ,WAAW;CACZ;AACD;AACA;CACC,WAAW;CACX,YAAY;AACb;AACA;CACC;EACC,WAAW;EACX,YAAY;CACb;AACD;AACA;CACC,uCAAuC;CACvC,iCAAiC;AAClC;AACA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC,0BAA0B;CAC1B,+BAA+B;CAC/B,gBAAgB;AACjB;AACA;CACC;EACC,4BAA4B;CAC7B;AACD;AACA;CACC;EACC,4CAA4C;CAC7C;AACD;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,gCAAgC;CAChC,iBAAiB;CACjB,oBAAoB;AACrB;AACA;CACC,2BAA2B;CAC3B,sBAAsB;CACtB,WAAW;AACZ;AACA;CACC,YAAY;CACZ,kBAAkB;CAClB,YAAY;CACZ,UAAU;CACV,6BAA6B;AAC9B;AACA;CACC,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,YAAY;AACb;AACA;CACC,YAAY;CACZ,WAAW;CACX,uBAAuB;AACxB;AACA;;CAEC,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;CACb,YAAY;AACb;AACA;CACC;EACC,YAAY;CACb;AACD;AACA;;CAEC,sBAAsB;AACvB;AACA;CACC;;EAEC,gBAAgB;EAChB,mBAAmB;CACpB;AACD;AACA;CACC,eAAe;AAChB;AACA;CACC,YAAY;CACZ,WAAW;AACZ;AACA;CACC;EACC,YAAY;EACZ,WAAW;CACZ;AACD;AACA;CACC;EACC,YAAY;EACZ,WAAW;CACZ;CACA;;EAEC,eAAe;CAChB;CACA;EACC,kBAAkB;CACnB;AACD;AACA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,uBAAuB;CACvB,UAAU;CACV,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,mBAAmB;CACnB,qBAAqB;CACrB,SAAS;AACV;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,cAAc;CACd,yBAAyB;CACzB,sBAAsB;CACtB,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,UAAU;CACV,aAAa;CACb,eAAe;CACf,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,iBAAiB;CACjB,aAAa;CACb,qBAAqB;AACtB;AACA;CACC;EACC,WAAW;CACZ;AACD;AACA;CACC,wBAAwB;AACzB;AACA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;AACA;CACC,mBAAmB;CACnB,uBAAuB;CACvB,cAAc;CACd,gBAAgB;AACjB;AACA;CACC;EACC,wBAAwB;CACzB;AACD;AACA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,kBAAkB;CAClB,iBAAiB;AAClB;AACA;CACC;EACC,YAAY;EACZ,WAAW;CACZ;AACD;AACA;CACC,YAAY;CACZ,WAAW;CACX,2BAA2B;CAC3B,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,uBAAuB;AACxB;AACA;CACC,gBAAgB;AACjB;AACA;CACC;EACC,kBAAkB;CACnB;AACD;AACA;CACC,aAAa;CACb,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,wBAAwB;CACxB,wBAAwB;CACxB,WAAW;CACX,yBAAyB;CACzB,uBAAuB;CACvB,kBAAkB;AACnB;AACA;;CAEC,WAAW;CACX,aAAa;AACd;AACA;;CAEC,WAAW;AACZ;AACA;;;;CAIC,qBAAqB;AACtB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;AACnB;AACA;CACC,UAAU;CACV,gBAAgB;AACjB;AACA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,yBAAyB;CACzB,yBAAyB;CACzB,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,yBAAyB;AAC1B;AACA;CACC;EACC,WAAW;CACZ;AACD;AACA;CACC,UAAU;CACV,iBAAiB;CACjB,cAAc;AACf;AACA;CACC;EACC,UAAU;CACX;AACD;AACA;CACC,cAAc;AACf;AACA;CACC,0BAA0B;CAC1B,gBAAgB;CAChB,uBAAuB;CACvB,0BAA0B;CAC1B,yBAAyB;CACzB,WAAW;CACX,qBAAqB;AACtB;AACA;CACC,eAAe;AAChB;AACA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,0BAA0B;CAC1B,mBAAmB;CACnB,WAAW;AACZ;AACA;CACC;EACC,6BAA6B;CAC9B;AACD;AACA;CACC;EACC,6BAA6B;CAC9B;AACD;;AAEA;CACC,iBAAiB;CACjB,uBAAuB;CACvB,yBAAyB;AAC1B;AACA;CACC;EACC,mBAAmB;CACpB;AACD;AACA;CACC,SAAS;CACT,4BAA4B;CAC5B,YAAY;CACZ,uBAAuB;CACvB,mBAAmB;CACnB,uBAAuB;CACvB,2CAA2C;CAC3C,8CAA8C;CAC9C,gBAAgB;CAChB,mBAAmB;AACpB;AACA;;CAEC,uBAAuB;AACxB;AACA;CACC;EACC,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;CAC1B;AACD;AACA;CACC,mBAAmB;AACpB;AACA;CACC,SAAS;CACT,SAAS;CACT,iBAAiB;CACjB,qCAAqC;AACtC;AACA;CACC,SAAS;CACT,yBAAyB;CACzB,YAAY;CACZ,4BAA4B;CAC5B,uBAAuB;AACxB;AACA;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;CACA;EACC,eAAe;EACf,gBAAgB;CACjB;AACD;AACA;CACC,cAAc;CACd,aAAa;CACb,UAAU;CACV,iCAAiC;CACjC,uBAAuB;CACvB,uBAAuB;AACxB;AACA;CACC,oBAAoB;AACrB;;AAEA;CACC,sCAAsC;CACtC,yBAAyB;AAC1B;AACA;CACC,aAAa;CACb,6BAA6B;AAC9B;AACA;CACC,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,iBAAiB;CACjB,cAAc;CACd,uBAAuB;CACvB,kBAAkB;AACnB;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,UAAU;AACX;;AAEA;CACC,sCAAsC;CACtC,wBAAwB;AACzB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,oBAAoB;CACpB,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;;CAEC,mBAAmB;AACpB;AACA;CACC,SAAO;AACR;;AAEA;CACC,cAAc;CACd,aAAa;CACb,iBAAiB;CACjB,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;CACd,uBAAuB;AACxB;AACA;CACC,cAAc;CACd,aAAa;AACd;;AAEA;CACC,8BAA8B;CAC9B,gBAAgB;AACjB;AACA;CACC;EACC,4CAA4C;CAC7C;AACD;AACA;CACC;EACC,6BAA6B;CAC9B;AACD;;AAEA;CACC,0BAA0B;AAC3B;AACA;CACC,wBAAwB;AACzB;;AAEA;;CAEC,aAAa;CACb,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;AAC3B;AACA;CACC,UAAU;AACX;;AAEA;CACC,SAAO;AACR;AACA;CACC,iBAAiB;CACjB,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,UAAU;CACV,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,uBAAuB;CAGvB,oBAAoB;AACrB;AACA;CACC;EACC,kBAAkB;CACnB;AACD;AACA;CACC,iBAAiB;AAClB;;AAEA;CACC;EACC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,UAAU;EAGV,oBAAoB;CACrB;CACA;EACC,UAAU;CACX;AACD;;AAEA;CACC,aAAa;AACd;;AAEA;CACC;EACC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EAGf,oBAAoB;CACrB;CACA;EACC,aAAa;CACd;CACA;EACC,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAGhC,oBAAoB;CACrB;CACA;EACC,0BAA0B;CAC3B;AACD;;AAEA;CACC;EACC,aAAa;CACd;CACA;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,SAAO;EACP,gBAAgB;CACjB;AACD;;AAEA;CACC;EACC,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;CACA;EACC,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;CACvB;AACD;;AAEA;CACC,aAAa;AACd;AACA;CACC;EACC,iBAAiB;CAClB;AACD;AACA;CACC,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,gBAAgB;CAChB,sBAAsB;AACvB;AACA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,eAAe;CACf,uBAAuB;CACvB,cAAc;CACd,aAAa;CACb,mBAAmB;CACnB,kBAAkB;CAClB,WAAW;CACX,uBAAuB;CACvB,kBAAkB;CAClB,aAAa;CACb,sBAAsB;CACtB,uCAAuC;AACxC;AACA;CACC;EACC,aAAa;CACd;AACD;AACA;CACC,WAAW;CACX,YAAY;AACb;AACA;CACC,oBAAoB;AACrB;AACA;CACC,WAAW;CACX,cAAc;CACd,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,YAAY;CACZ,aAAa;AACd;AACA;CACC,cAAc;CACd,WAAW;CACX,gBAAgB;CAChB,WAAW;CACX,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC;EACC,gBAAgB;CACjB;AACD;AACA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;;CAEC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC;;EAEC,eAAe;CAChB;AACD;AACA;CACC;;EAEC,eAAe;CAChB;AACD;AACA;CACC;;EAEC,eAAe;CAChB;AACD;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;AACpB;AACA;CACC;EACC,eAAe;CAChB;AACD;AACA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CAEC,4BAA4B;AAC7B;;AAiBA;CAEC,cAAY;CACZ,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,iCAAiC;CACjC,aAAa;CACb,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,gBAAgB;CAChB,WAAW;CACX,UAAU;CACV,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,2CAA2C;CAC3C,cAAc;CACd,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,WAAW;CACX,MAAM;CACN,gBAAgB;CAChB,sDAAsD;AACvD;AACA;CACC,qBAAqB;CACrB,cAAc;CACd,YAAY;CACZ,wBAAwB;CACxB,4BAA4B;CAC5B,2BAA2B;AAC5B;AACA;CACC;EACC,kBAAkB;CACnB;AACD;AACA;CACC;EACC,eAAe;EACf,cAAc;CACf;CACA;EACC,aAAa;CACd;AACD;AACA;CACC;EACC,oBAAoB;CACrB;AACD;;AAEA;CACC,gBAAgB;CAChB,qDAAqD;CACrD,wBAAwB;AACzB;AACA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,oCAAoC;CACpC,8BAA8B;AAC/B;AACA;CACC,oCAAoC;CACpC,wBAAwB;AACzB;AACA;CACC,eAAe;CACf,0BAA0B;CAC1B,cAAc;CACd,kBAAkB;CAClB,sBAAsB;CACtB,oBAAoB;CACpB,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;CACZ,kBAAkB;CAClB,oBAAoB;CACpB,sBAAsB;AACvB;AACA;CACC,uBAAuB;CACvB,gBAAgB;CAChB,oBAAoB;CACpB,WAAW;AACZ;AACA;CACC,SAAS;CACT,wBAAwB;CACxB,mDAAmD;AACpD;AACA;CACC;EACC,sBAAsB;CACvB;AACD;;AAEA;CACC,oDAAoC;CACpC,sBAAsB;CACtB,2BAA2B;CAC3B,YAAY;CACZ,2BAA2B;CAC3B,kBAAkB;CAClB,UAAU;CACV,iCAAiC;CACjC,oCAAoC;AACrC;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,MAAM;CACN,SAAS;CACT,0BAA0B;CAC1B,aAAa;CACb,WAAW;CACX,iCAAiC;CACjC,oCAAoC;AACrC;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,WAAW;AACZ;AACA;CACC,qBAAqB;CACrB,sBAAsB;CACtB,gBAAgB;CAChB,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,WAAW;CACX,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,0BAA0B;AAC3B;AACA;CACC;EACC,iBAAiB;CAClB;AACD;AACA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,4DAA4D;AAC7D;;AAEA;CACC;EACC,0BAA0B;EAC1B,UAAU;CACX;CACA;EACC,2BAA2B;EAC3B,gCAAgC;EAChC,mCAAmC;EACnC,+BAA+B;EAC/B,8BAA8B;CAC/B;CACA;EACC,wBAAwB;EACxB,6BAA6B;EAC7B,gCAAgC;EAChC,4BAA4B;EAC5B,2BAA2B;CAC5B;AACD;;AAEA;CACC,sBAAsB;CACtB,2BAA2B;CAC3B,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,WAAW;CACX,mBAAmB;CACnB,YAAY;CACZ,YAAY;CACZ,WAAW;AACZ;AACA;CACC,UAAU;AACX;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,qBAAqB;CACrB,WAAW;CACX,aAAa;CACb,cAAc;CACd,0BAA0B;CAC1B,4BAA4B;CAC5B,yBAAyB;CACzB,mBAAmB;CACnB,iBAAiB;CACjB,SAAS;CACT,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,uBAAuB;AACxB;AACA;CACC,6BAA6B;CAC7B,iBAAiB;AAClB;AACA;;;CAGC,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,UAAU;CACV,eAAe;CACf,cAAc;CACd,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,uBAAuB;AACxB;AACA;CACC,wCAAwC;CACxC,iCAAiC;CACjC,4BAA4B;CAC5B,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,WAAW;CACX,mBAAmB;CACnB,QAAQ;CACR,SAAS;CACT,yBAAyB;CACzB,gCAAgC;CAChC,SAAS;CACT,UAAU;AACX;AACA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,sBAAsB;AACvB;AACA;;CAEC,WAAW;AACZ;AACA;;CAEC,UAAU;AACX;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,0BAA0B;AAC3B;;AAEA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,cAAc;CACd,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,yBAAyB;CACzB,uBAAuB;CACvB,sBAAsB;AACvB;;AAEA;;CAEC,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,qCAAqC;AACtC;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,mBAAmB;CACnB,yBAAiB;SAAjB,iBAAiB;AAClB;AACA;CACC;EACC,oBAAoB;CACrB;AACD;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,eAAe;CACf,cAAc;CACd,yBAAyB;CACzB,UAAU;AACX;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,SAAS;CACT,+BAA+B;CAC/B,eAAe;CACf,cAAc;CACd,yBAAyB;CACzB,kBAAkB;CAClB,kCAAkC;CAClC,YAAY;CACZ,SAAS;AACV;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,2BAA2B;CAC3B,eAAe;CACf,cAAc;CACd,yBAAyB;CACzB,kBAAkB;CAClB,gCAAgC;CAChC,eAAe;AAChB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,kCAAkC;AACnC;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,kCAAkC;AACnC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,oBAAoB;CACpB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,mBAAmB;CACnB,yBAAiB;SAAjB,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,eAAe;CACf,cAAc;CACd,yBAAyB;CACzB,UAAU;AACX;AACA;CACC,cAAc;AACf;AACA;;CAEC,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,2BAA2B;CAC3B,YAAY;CACZ,WAAW;CACX,gCAAgC;CAChC,kBAAkB;CAClB,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,gCAAgC;CAChC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,UAAU;CACV,WAAW;CACX,sBAAsB;CACtB,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gCAAgC;CAChC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,UAAU;AACX;AACA;CACC;EACC,UAAU;CACX;AACD;AACA;CACC;EACC,UAAU;CACX;AACD;AACA;CACC;EACC,UAAU;CACX;AACD;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,mBAAmB;AACpB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,mBAAmB;CACnB,gBAAgB;CAChB,qBAAqB;AACtB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,uCAAuC;AACxC;AACA;CACC,oBAAoB;AACrB;AACA;CACC,gCAAgC;AACjC;;AAEA;CACC,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;AACT;;AAEA;CACC,mBAAmB;AACpB;AACA;CACC;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;AAC1B;AACA;CACC;EACC,yBAAyB;CAC1B;AACD;AACA;CACC;EACC,yBAAyB;CAC1B;AACD;AACA;CACC;EACC,WAAW;CACZ;AACD;AACA;CACC;EACC,WAAW;CACZ;CACA;EACC,UAAU;CACX;AACD;AACA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,SAAS;CACT,0BAA0B;CAC1B,UAAU;AACX;AACA;CACC;EACC,gBAAgB;CACjB;AACD;AACA;CACC;EACC,aAAa;CACd;AACD;AACA;CACC;EACC,aAAa;CACd;AACD;AACA;CACC,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,YAAY;CACZ,gBAAgB;AACjB;AACA;;CAEC,mBAAmB;AACpB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,UAAU;AACX;;AAEA,SAAS;AACT;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;;CAEC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,eAAe;CACf,oBAAoB;CACpB,eAAe;CACf;;;IAGG;AACJ;AACA;CACC,qBAAqB;AACtB;AACA;CACC,gCAAgC;CAChC,gBAAgB;AACjB;AACA;CACC,6BAA6B;CAC7B,cAAc;AACf;AACA;CACC,gCAAgC;AACjC;AACA;CACC,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,oDAAqC;CACrC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;CAC9B,mCAAmC;AACpC;;AAEA,gBAAgB;AAChB;CACC,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,cAAc;AACf;;AAEA,gBAAgB;AAChB;CACC,eAAe;AAChB;;AAEA,eAAe;AACf;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,mBAAmB;CACnB,kBAAkB;CAClB,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,eAAe;AAChB;AACA;CACC;EACC,cAAc;EACd,eAAe;CAChB;AACD;AACA;CACC,aAAa;CACb,cAAc;AACf;AACA;CACC;EACC,WAAW;EACX,YAAY;CACb;AACD;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC;EACC,eAAe;EACf,gBAAgB;CACjB;AACD;AACA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,qBAAqB;CACrB,mBAAmB;CAGnB,oBAAoB;AACrB;AACA;CACC,eAAe;AAChB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,aAAa;CACb,mBAAmB;CACnB,oBAAoB;CACpB,mBAAmB;CACnB,uBAAuB;AACxB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;AACtB;AACA;CACC,eAAe;CACf,cAAc;CACd,qBAAqB;CACrB,kBAAkB;AACnB;AACA;CACC;EACC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;CACpB;AACD;AACA;CACC,eAAe;CACf,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA,aAAa;AACb;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;CACC;EACC,mBAAmB;CACpB;AACD;AACA;CACC,gCAAgC;AACjC;AACA;CACC,kCAAkC;AACnC;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;;;;CAIC,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,+CAA+C;AAChD;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,+BAA+B;CAC/B,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;CACrB,eAAe;AAChB;AACA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,gBAAgB;AACjB;;AAEA,SAAS;AACT;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,gCAAgC;CAChC,UAAU;CACV,WAAW;CACX,mBAAmB;CACnB,SAAS;CACT,WAAW;CACX,+BAA+B;AAChC;AACA;CACC;EACC,QAAQ;EACR,WAAW;CACZ;AACD;AACA;CACC;EACC,UAAU;EACV,WAAW;EACX,QAAQ;EACR,UAAU;CACX;AACD;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,gCAAgC;AACjC;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,yBAAyB;CACzB,WAAW;CACX,UAAU;CACV,mBAAmB;CACnB,SAAS;CACT,WAAW;AACZ;AACA;CACC;EACC,SAAS;CACV;AACD;AACA;CACC,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,gCAAgC;AACjC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,wBAAwB;AACzB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,aAAa;CACb,iBAAiB;CACjB,cAAc;CACd,sBAAsB;AACvB;AACA;CACC,aAAa;AACd;AACA;CACC;EACC,+BAA+B;CAChC;CACA;EACC,YAAY;EACZ,cAAc;EACd,mBAAmB;CACpB;CACA;EACC,WAAW;EACX,YAAY;CACb;AACD;AACA;CACC;EACC,cAAc;EACd,YAAY;CACb;AACD;AACA;CACC;EACC,aAAa;EACb,YAAY;CACb;AACD;AACA;CACC;EACC,SAAS;EACT,gBAAgB;CACjB;AACD;AACA;CACC;;;EAGC,+BAA+B;CAChC;AACD;AACA;CACC,kCAAkC;CAClC,uCAAuC;AACxC;;AAEA;CACC;;;EAGC,wBAAwB;CACzB;AACD;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC;EACC,gCAAgC;CACjC;CACA;EACC,6BAA6B;CAC9B;AACD;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,qBAAqB;CACrB,uBAAuB;CACvB,uBAAuB;CACvB,kBAAkB;CAClB,UAAU;CACV,sBAAsB;AACvB;AACA;CACC,gBAAgB;CAChB,2BAA2B;CAC3B,6BAA6B;CAC7B,gBAAgB;CAChB,uBAAuB;CACvB,sBAAsB;CACtB,yBAAyB;CACzB,YAAY;AACb;AACA;CACC,eAAe;CACf,YAAY;CACZ,aAAa;CACb,oCAAoC;CACpC,oBAAoB;CACpB,YAAY;CACZ,iBAAiB;AAClB;AACA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;CACnB,YAAY;CACZ,oCAAoC;AACrC;AACA;CACC,qBAAqB;AACtB;AACA;CACC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,4BAA4B;CAC5B,aAAa;CACb,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,YAAY;CACZ,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,aAAa;AACd;AACA;CACC,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,WAAW;CACX,oBAAoB;AACrB;;AAEA;;;;;CAKC,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,2BAA2B;CAC3B,yBAAyB;CACzB,gBAAgB;CAChB,uBAAuB;CACvB,sBAAsB;CACtB,YAAY;AACb;AACA;CACC;EACC,YAAY;CACb;AACD;AACA;CACC;EACC,cAAc;CACf;AACD;AACA;CACC;EACC,gBAAgB;CACjB;AACD;AACA;CACC,eAAe;CACf,eAAe;CACf,YAAY;CACZ,aAAa;CACb,oCAAoC;CACpC,oBAAoB;CACpB,YAAY;AACb;AACA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,YAAY;CACZ,YAAY;CACZ,oCAAoC;AACrC;AACA;CACC,qBAAqB;AACtB;AACA;CACC,oBAAoB;AACrB;;AAEA;CACC,uCAAuC;AACxC;AACA;CACC,UAAU;CACV,YAAY;AACb;;AAEA;CACC;EACC,0BAA0B;CAC3B;AACD;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,gCAAgC;CAChC,4BAA4B;AAC7B;AACA;CACC,UAAU;AACX;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,oBAAoB;AACrB;AACA;CACC,aAAa;AACd;;AAEA;CACC,yBAAyB;AAC1B;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;AACA;;CAEC,aAAa;AACd;AACA;CACC,aAAa;CACb,WAAW;CACX,6BAA6B;AAC9B;AACA;CACC,aAAa;CACb,6BAA6B;AAC9B;AACA;CACC,uBAAuB;CACvB,oBAAoB;AACrB;AACA;CACC,4CAA4C;CAC5C,gCAAgC;AACjC;AACA;CACC,SAAS;CACT,iBAAiB;CACjB,iCAAiC;CACjC,uBAAuB;AACxB;AACA;CACC,UAAU;AACX;AACA;CACC,WAAW;AACZ;AACA;CACC,4BAA4B;CAC5B,yBAAyB;AAC1B;AACA;CACC,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;AACA;;;CAGC,YAAY;CACZ,SAAO;CACP,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,SAAS;CACT,kCAAkC;AACnC;AACA;CACC,qCAAqC;CACrC,sBAAsB;AACvB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,WAAW;AACZ;AACA;CACC,cAAc;AACf;;AAEA;CACC,YAAY;AACb;AACA;CACC,wCAAwC;CACxC,gBAAgB;CAChB,0BAA0B;CAC1B,yBAAyB;CACzB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,oBAAoB;CACpB,mBAAmB;CACnB,8BAA8B;CAC9B,WAAW;AACZ;AACA;CACC,qBAAqB;CACrB,cAAc;CACd,qBAAqB;CACrB,WAAW;CACX,aAAa;CACb,cAAc;CACd,0BAA0B;CAC1B,4BAA4B;CAC5B,yBAAyB;CACzB,mBAAmB;CACnB,iBAAiB;CACjB,SAAS;CACT,UAAU;CACV,sBAAsB;AACvB;AACA;CACC,eAAe;CACf,UAAU;AACX;AACA;CACC,mBAAmB;AACpB;AACA;CACC,qBAAqB;CACrB,iCAAiC;AAClC;;AAEA;CAGC,oBAAoB;AACrB;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ;AACA;CACC,qDAAqD;AACtD;AACA;;CAEC,UAAU;AACX;;AAEA,mBAAmB;AACnB;CACC,aAAa;CACb,gCAAgC;CAChC,oCAAoC;CACpC,kBAAkB;AACnB;AACA;;CAEC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,UAAU;AACX;AACA;CACC;;EAEC,WAAW;CACZ;AACD;AACA;CACC;;EAEC,eAAe;EACf,eAAe;CAChB;AACD;AACA;CACC;;EAEC,eAAe;EACf,gBAAgB;CACjB;AACD;AACA;CACC,YAAY;CACZ,UAAU;AACX;AACA;CACC;EACC,WAAW;CACZ;AACD;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC;EACC,iBAAiB;CAClB;AACD;AACA;CACC,mBAAmB;AACpB;AACA;CACC;EACC,mBAAmB;CACpB;AACD;AACA;CACC,sBAAsB;AACvB;AACA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC;EACC,aAAa;EACb,cAAc;CACf;AACD;;AAEA;CACC,UAAU;AACX;AACA;CACC;EACC,WAAW;CACZ;AACD;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,uBAAuB;AACxB;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,gCAAgC;CAChC,UAAU;CACV,WAAW;CACX,mBAAmB;CACnB,WAAW;CACX,OAAO;AACR;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,QAAQ;AACT;AACA;CACC,aAAa;AACd;AACA;CACC,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;CACnB,6BAA6B;CAC7B,+CAA+C;CAC/C,eAAe;CACf,mBAAmB;CACnB,gCAAgC;AACjC;AACA;CACC,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,QAAQ;CACR,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,8CAA8C;AAC/C;AACA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,sBAAsB;CACtB,4BAA4B;CAC5B,2BAA2B;AAC5B;AACA;CACC,YAAY;CACZ,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,8CAA8C;AAC/C;AACA;CACC,kBAAkB;CAClB,cAAc;AACf;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,gCAAgC;CAChC,UAAU;CACV,WAAW;CACX,YAAY;CACZ,SAAS;AACV;AACA;CACC,uBAAuB;CACvB,6BAA6B;CAC7B,qBAAqB;AACtB;AACA;CACC,WAAW;AACZ;AACA;CACC,6BAA6B;AAC9B;AACA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;;CAEC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,sBAAsB;AACvB;;AAEA,iBAAiB;AACjB;CACC,YAAY;CACZ,aAAa;CACb,iBAAiB;AAClB;AACA;CACC,WAAW;AACZ;AACA;CACC;EACC,WAAW;EACX,mBAAmB;CACpB;AACD;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;;;;CAIC,kBAAkB;CAClB,gBAAgB;AACjB;AACA;;;;CAIC,iBAAiB;CACjB,oBAAoB;CACpB,gBAAgB;AACjB;AACA;;;;CAIC,WAAW;CACX,kBAAkB;CAClB,gCAAgC;CAChC,eAAe;CACf,iBAAiB;CACjB,MAAM;CACN,OAAO;AACR;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;CACC;EACC,mBAAmB;CACpB;AACD;AACA;CACC;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC,aAAa;CACb,cAAc;CACd,uBAAuB;CACvB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;AAC3B;AACA;CACC;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,UAAU;CACV,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,aAAa;CACb,cAAc;CACd,sBAAsB;CACtB,4BAA4B;CAC5B,2BAA2B;CAC3B,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,uBAAuB;CACvB,SAAS;CACT,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,OAAO;CACP,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,WAAW;AACZ;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB;AACA;CACC,WAAW;AACZ;AACA;CACC,eAAe;AAChB;;AAEA;CACC,oBAAoB;AACrB;AACA;CACC,6BAA6B;CAC7B,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,SAAS;CACT,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,6BAA6B;CAC7B,YAAY;CACZ,wBAAwB;CACxB,mBAAmB;AACpB;;AAEA;;CAEC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;AACnB;AACA;;CAEC,kBAAkB;CAClB,SAAS;CACT,QAAQ;CACR,UAAU;AACX;AACA;CACC;;EAEC,WAAW;CACZ;CACA;;EAEC,YAAY;EACZ,aAAa;CACd;AACD;AACA;CACC;;EAEC,UAAU;CACX;CACA;;EAEC,WAAW;EACX,aAAa;CACd;AACD;AACA;CACC;;EAEC,cAAc;EACd,gBAAgB;CACjB;AACD;AACA;CACC,eAAe;CACf,UAAU;AACX;AACA;CACC;EACC,cAAc;CACf;AACD;AACA;CACC;EACC,eAAe;CAChB;AACD;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,oDAAyC;CACzC,sBAAsB;CACtB,2BAA2B;CAC3B,qBAAqB;CACrB,WAAW;CACX,gCAAgC;CAChC,iCAAiC;AAClC;;AAEA;CACC,eAAe;AAChB;AACA;CACC,gCAAgC;CAChC,4BAA4B;AAC7B;AACA;CACC,UAAU;AACX;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,UAAU;AACX;AACA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,YAAY;CACZ,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,cAAc;AACf;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,eAAe;CACf,6BAA6B;CAC7B,kBAAkB;CAClB,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,aAAa;CACb,cAAc;AACf;AACA;CACC,YAAY;CACZ,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,mBAAmB;CACnB,SAAS;CACT,UAAU;CACV,4CAA4C;CAC5C,mBAAmB;CACnB,WAAW;CACX,gBAAgB;CAChB,sBAAsB;AACvB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;CACV,WAAW;CACX,eAAe;CACf,OAAO;CACP,YAAY;AACb;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,SAAS;CACT,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,6BAA6B;CAC7B,cAAc;CACd,wBAAwB;CACxB,mBAAmB;AACpB;AACA;CACC;EACC,cAAc;EACd,aAAa;CACd;AACD;AACA;CACC;EACC,cAAc;CACf;AACD;AACA;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,2BAA2B;CAC3B,iBAAiB;CACjB,uBAAuB;CACvB,qBAAqB;CACrB,iBAAiB;AAClB;AACA;CACC;EACC,uBAAuB;CACxB;AACD;;AAEA;;CAEC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;;oCAGoC;AACpC;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,uBAAuB;CACvB,qBAAqB;CACrB,kBAAkB;CAClB,qBAAqB;CACrB,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;AACA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;;CAEC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,oBAAoB;CACpB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,aAAa;AACd;AACA;CACC,gBAAgB;CAChB,cAAc;CACd,uBAAuB;CACvB,gBAAgB;CAChB,+BAA+B;AAChC;AACA;;;CAGC,+BAA+B;AAChC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,aAAa;CACb,cAAc;CACd,qBAAqB;CACrB,+BAA+B;CAC/B,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;CACd,oBAAoB;AACrB;;AAEA,wBAAwB;AACxB;CACC,yBAAyB;CACzB,mCAAmC;CACnC,qCAAqC;CACrC,sCAAsC;CACtC,kBAAkB;AACnB;AACA;CACC,mBAAmB;CACnB,SAAS;CACT,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,gBAAgB;CAChB,mBAAmB;CACnB,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;CAChB,mCAAmC;CACnC,oCAAoC;CACpC,qCAAqC;CACrC,cAAc;CACd,cAAc;CACd,eAAe;CACf,aAAa;CACb,yBAAyB;AAC1B;AACA;;CAEC,gBAAgB;CAChB,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,wBAAwB;CACxB,oBAAoB;AACrB;AACA;CACC,oBAAoB;CACpB,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,SAAS;AACV;AACA;CACC,SAAS;AACV;AACA;CACC,SAAS;AACV;AACA;CACC,SAAS;CACT,6BAA6B;AAC9B;AACA;CACC,qBAAqB;CACrB,aAAa;CACb,UAAU;CACV,oBAAoB;AACrB;AACA;CACC,qBAAqB;CACrB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,uBAAuB;CACvB,oBAAoB;AACrB;AACA;;CAEC,uBAAuB;AACxB;AACA;CACC,WAAW;CACX,uBAAuB;AACxB;;AAEA;CACC,oBAAoB;CACpB,sBAAsB;CACtB,uBAAuB;CACvB,wBAAwB;AACzB;;AAEA;CACC,qBAAqB;CACrB,cAAc;CACd,gBAAgB;CAChB,qCAAqC;AACtC;;AAEA;CACC,qBAAqB;CACrB,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,aAAa;AACd;AACA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,mBAAmB;CACnB,oBAAoB;CACpB,WAAW;CACX,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,2BAA2B;CAC3B,cAAc;AACf;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,qBAAqB;CACrB,sBAAsB;CACtB,mBAAmB;CACnB,UAAU;AACX;;AAEA;CACC,oBAAoB;CACpB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,uBAAuB;CACvB,mBAAmB;CACnB,+BAA+B;AAChC;AACA;;;CAGC,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,cAAc;CACd,mCAAmC;CACnC,sCAAsC;CACtC,+BAA+B;CAC/B,qCAAqC;AACtC;AACA;;;CAGC,mCAAmC;CACnC,sCAAsC;CACtC,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,WAAW;CAGX,oBAAoB;CACpB,uBAAuB;AACxB;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,MAAM;CACN,UAAU;CACV,UAAU;CACV,cAAc;CACd,WAAW;CACX,UAAU;CACV,YAAY;CACZ,+FAA+F;CAE/F,wBAAwB;AACzB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,YAAY;CACZ,qBAAqB;AACtB;;AAEA;CACC,6BAA6B;CAC7B,sBAAsB;AACvB;;AAQA;CACC;EACC,UAAU;CACX;AACD;;AAEA;CACC,uBAAuB;AACxB;;AAEA;;CAEC,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,aAAa;AACd;;AAEA;;;oCAGoC;AACpC;CACC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;;CAEC,kBAAkB;CAClB,gBAAgB;CAChB,uBAAuB;AACxB;AACA;CACC;;EAEC,gBAAgB;CACjB;AACD;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;CAChB,YAAY;AACb;AACA;CACC;EACC,WAAW;EACX,oBAAoB;CACrB;AACD;;AAEA;CACC,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,wBAAwB;CACxB,cAAc;CACd,WAAW;AACZ;AACA;CACC,cAAc;CACd,sBAAsB;CACtB,qCAAqC;CACrC,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,mBAAmB;AACpB;AACA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;AACA;CACC,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,gCAAgC;AACjC;AACA;CACC,iCAAiC;AAClC;;AAEA;CACC,kBAAkB;CAClB,oBAAoB;CACpB,wBAAwB;CACxB,uBAAuB;CACvB,wCAAwC;CACxC,wCAAwC;CACxC,wCAAwC;CACxC,wCAAwC;CACxC,wCAAwC;CACxC,wCAAwC;CACxC,wCAAwC;CACxC,wCAAwC;CACxC,wCAAwC;CACxC,2CAA2C;CAC3C,2CAA2C;CAC3C,2CAA2C;CAC3C,2CAA2C;CAC3C,2CAA2C;CAC3C,2CAA2C;CAC3C,2CAA2C;CAC3C,2CAA2C;CAC3C,2CAA2C;CAC3C,uCAAuC;CACvC,wCAAwC;CACxC,uCAAuC;CACvC,wCAAwC;CACxC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,+BAA+B;CAC/B,qBAAqB;CACrB,qBAAqB;CACrB,mBAAmB;AACpB;AACA;;;;;;;;;;;;CAYC,sBAAsB;AACvB;AACA;CACC,WAAW;AACZ;AACA;;CAEC,cAAc;AACf;AACA;CACC,WAAW;AACZ;AACA;CACC,iEAAiE;AAClE;AACA;CACC,gEAAgE;AACjE;AACA;CACC,+DAA+D;AAChE;AACA;CACC,kEAAkE;AACnE;AACA;CACC,2DAA2D;AAC5D;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,6DAA6D;AAC9D;AACA;CACC,cAAc;AACf;AACA;;;;;CAKC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,UAAU;AACX;;AAEA;;;CAGC,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,sCAAsC;CACtC,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,sCAAsC;AACvC;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,iBAAiB;AAClB;AACA;CACC,WAAW;AACZ;;AAEA;;CAEC,WAAW;AACZ;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,oCAAoC;CACpC,sCAAsC;CACtC,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,sCAAsC;AACvC;;AAEA;;CAEC,sCAAsC;AACvC;;AAEA;CACC,sCAAsC;CACtC,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sCAAsC;CACtC,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,oCAAoC;AACrC;;AAEA;;CAEC,oCAAoC;AACrC;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,sCAAsC;AACvC;;AAEA;CACC,sCAAsC;AACvC;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,sCAAsC;AACvC;AACA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,4BAA4B;AAC7B;AACA;;;CAGC,gCAAgC;CAChC,4BAA4B;CAC5B,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;;CAEC,WAAW;AACZ;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;AACA;CACC,YAAY;AACb;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;AACA;CACC,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,8BAA8B;AAC/B;AACA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,4BAA4B;AAC7B;AACA;CACC,4BAA4B;CAC5B,mBAAmB;AACpB;AACA;CACC,gCAAgC;CAChC,WAAW;AACZ;AACA;CACC,qCAAqC;AACtC;;AAEA;;;;CAIC,mBAAmB;CACnB,gDAAgD;CAChD,WAAW;AACZ;;AAEA;;;;CAIC,yBAAyB;AAC1B;AACA;;;;CAIC,gCAAgC;CAChC,WAAW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,4BAA4B;CAC5B,WAAW;CACX,iBAAiB;AAClB;AACA;;CAEC,gCAAgC;AACjC;;AAEA;CACC,UAAU;CACV,wFAAwF;AACzF;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,sCAAsC;AACvC;;AAEA;;CAEC,yBAAyB;CACzB,uBAAuB;CACvB,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;;CAEC,4BAA4B;AAC7B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;;CAGC,oCAAoC;AACrC;;AAEA;CACC,mBAAmB;AACpB;AACA;;;CAGC,mBAAmB;CACnB,WAAW;AACZ;AACA;;;CAGC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;AACA;CACC,WAAW;AACZ;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gCAAgC;AACjC;;AAEA;;;CAGC,sCAAsC;AACvC;;AAEA;;;CAGC,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,gCAAgC;AACjC;;AAEA;CACC,yDAA+O;AAChP;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,0BAA0B;CAC1B,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,uBAAuB;CACvB,iDAAiD;AAClD;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;;CAGC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;;CAGC,mBAAmB;AACpB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;CACnB,YAAY;AACb;AACA;CACC,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;AACA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;CACnB,sCAAsC;AACvC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sCAAsC;AACvC;;AAEA;;CAEC,sCAAsC;AACvC;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,sCAAsC;AACvC;;AAEA;;;CAGC,sCAAsC;AACvC;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,YAAY;AACb;;AAEA;;;CAGC,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,8CAA8C;AAC/C;;AAEA;CACC,4CAA4C;AAC7C;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kCAAkC;AACnC;AACA;CACC,sBAAsB;AACvB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;AACpB;AACA;CACC,UAAU;AACX;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,sCAAsC;AACvC;AACA;CACC,UAAU;AACX;AACA;CACC,cAAc;AACf;;AAEA;CACC,sCAAsC;CACtC,cAAc;AACf;;AAEA;CACC,sCAAsC;CACtC,cAAc;AACf;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,8BAA8B;CAC9B,sBAAsB;CACtB,iDAAiD;AAClD;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,cAAc;AACf;;AAEA;;;;;;;CAOC,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;CACnB,sCAAsC;AACvC;;AAEA;CACC,UAAU;AACX;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,sCAAsC;AACvC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;;;;CAIC,WAAW;AACZ;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,mCAAmC;CACnC,uBAAuB;AACxB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;;CAEC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,0DAAksB;AACnsB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,sCAAsC;AACvC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,oCAAoC;AACrC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,yBAAyB;CACzB,0CAA0C;AAC3C;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;;;;;CAKC,+BAA+B;AAChC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;AACA;CACC,UAAU;AACX;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;;CAEC,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,sCAAsC;AACvC;;AAEA;;;;;;;;;;;;;;;CAeC,iDAAiD;AAClD;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,yBAAyB;CACzB,sCAAsC;CACtC,WAAW;AACZ;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,UAAU;AACX;;AAEA;;;CAGC,mBAAmB;CACnB,YAAY;AACb;;AAEA;;;CAGC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,sCAAsC;AACvC;AACA;CACC,8BAA8B;CAC9B,WAAW;AACZ;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,+BAA+B;AAChC;AACA;CACC,WAAW;AACZ;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;;CAEC,sCAAsC;AACvC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;;;CAGC,sCAAsC;AACvC;;AAEA;;;CAGC,+BAA+B;AAChC;;AAEA;CACC,sCAAsC;CACtC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;;;CAIC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,kCAAkC;CAClC,cAAc;CACd,gCAAgC;AACjC;;AAEA;CACC,sBAAsB;AACvB;AACA;CACC,cAAc;AACf;AACA;;;;;CAKC,uCAAuC;CACvC,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,sCAAsC;AACvC;;AAEA;;CAEC,sCAAsC;AACvC;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,oCAAoC;CACpC,sBAAsB;AACvB;;AAEA;CACC,yBAAyB;CACzB,sCAAsC;AACvC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;;;CAGC,WAAW;AACZ;;AAEA;CACC;EACC,gCAAgC;CACjC;CACA;EACC,6BAA6B;CAC9B;AACD;;AAEA;CACC,iDAAiD;AAClD;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,2CAA2C;CAC3C,WAAW;AACZ;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,qDAAqD;CACrD,kCAAkC;AACnC;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,cAAc;CACd,WAAW;CACX,oCAAoC;AACrC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,sCAAsC;AACvC;;AAEA;;;;;CAKC,WAAW;AACZ;;AAEA;CACC,qEAAsE;AACvE;;AAEA;CACC,uCAAuC;CACvC,WAAW;AACZ;;AAEA;;CAEC,yBAAyB;CACzB,sCAAsC;AACvC;;AAEA;;;CAGC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,iCAAiC;AAClC;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,oCAAoC;CACpC,iDAAiD;AAClD;AACA;CACC,WAAW;AACZ;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,sCAAsC;AACvC;AACA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,sCAAsC;AACvC;AACA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;AACA;CACC,mBAAmB;CACnB,WAAW;CACX,sCAAsC;AACvC;AACA;CACC,yBAAyB;AAC1B;;AAEA;CACC,sCAAsC;AACvC;;AAEA;;CAEC,uBAAuB;AACxB;AACA;;CAEC,qBAAqB;CACrB,iCAAiC;AAClC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sCAAsC;AACvC;AACA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;;;CAGC,WAAW;CACX,qCAAqC;AACtC;AACA;;;CAGC,iCAAiC;CACjC,gCAAgC;CAChC,0CAA0C;CAC1C,yCAAyC;AAC1C;AACA;;;CAGC,sBAAsB;AACvB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;;;CAGC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,mCAAmC;CACnC,oCAAoC;CACpC,0CAA0C;CAC1C,yCAAyC;AAC1C;;AAEA;CACC,8CAA8C;AAC/C;AACA;CACC,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;AACA;;;CAGC,0CAA0C;AAC3C;;AAEA;;CAEC,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,WAAW;AACZ;;;AAGA;CACC,iDAAiD;CAGjD,oBAAoB;AACrB;AACA;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC,yBAAyB;AAC1B;AACA;IACI,eAAe;AACnB;AACA;CACC,YAAY;CACZ,WAAW;AACZ;AACA,mBAAmB,gBAAgB,EAAE;AACrC;CACC,kBAAkB;AACnB;AACA;CACC,WAAW;AACZ;AACA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,yBAAyB;CACzB,kBAAkB;CAClB,2BAA2B;CAC3B;AACD;AACA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,yBAAyB;CACzB;AACD;AACA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,yBAAyB;CACzB,kBAAkB;CAClB,4BAA4B;CAC5B;AACD;AACA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,yBAAyB;CACzB,kBAAkB;CAClB,2BAA2B;CAC3B;AACD;AACA;IACI,4BAA4B;AAChC;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;CACC,cAAc;IACX,eAAe;AACnB;AACA;CACC,uCAAuC;CACvC,0CAA0C;CAC1C;AACD;AACA;CACC,sCAAsC;CACtC,yCAAyC;CACzC;AACD","sourcesContent":["/*\n    Table of Contents\n\n    Name                 : Akadmi\n    Author               : DexignLab\n    Author Portfolio     : https://themeforest.net/user/dexignlab/portfolio\n    \n\n\n    Table of Sass Contents\n    1. Abstracts\n        _bs-custom\n        _inheritance\n        _maps\n        _mixin\n        _variable\n\n    2. bootstrap \n        -Here goes all official bootstrap scss files\n\n    3. Global/Base\n        _color\n        _custom-grid\n        _fonts\n        _helper\n        _reset\n\n    4. layout\n        +footer\n        +header\n        +rtl\n        +sidebar\n        +tables\n        +theme\n        +version-dark\n\n    5. Conponents\n        +app\n        +charts\n        +forms\n        +map\n        +uc\n        +ui\n        +widget\n\n    6. Page\n        _index-1\n        _page-error\n        _page-register\n        _page-signin\n        _page-user-lock\n        _page-user-lock\n\n*/\n\n\n\n\n\n\n\n\n////////////////////\n// Abstracts\n////////////////////\n@import \"./abstracts/abstracts\";\n\n//bootstrap library scss files\n\n@import \"./../other/bootstrap/scss/bootstrap.scss\";\n\n\n\n////////////////////\n// Global\n////////////////////\n@import \"./base/base\";\n\n@import \"./preloader\";\n\n\n////////////////////\n// Components\n////////////////////\n@import \"./layout/layout\";\n\n\n////////////////////\n// Components\n////////////////////\n@import \"./components/components\";\n\n\n////////////////////\n// All pages\n////////////////////\n@import \"./pages/pages\";\n\n\n\n////////////////////\n// RTL\n////////////////////\n\n\n////////////////////\n// Version Color\n////////////////////\n@import \"./layout/version-dark/main\";","/*\n    Table of Contents\n\n    Name                 : Akadmi\n    Author               : DexignLab\n    Author Portfolio     : https://themeforest.net/user/dexignlab/portfolio\n    \n\n\n    Table of Sass Contents\n    1. Abstracts\n        _bs-custom\n        _inheritance\n        _maps\n        _mixin\n        _variable\n\n    2. bootstrap \n        -Here goes all official bootstrap scss files\n\n    3. Global/Base\n        _color\n        _custom-grid\n        _fonts\n        _helper\n        _reset\n\n    4. layout\n        +footer\n        +header\n        +rtl\n        +sidebar\n        +tables\n        +theme\n        +version-dark\n\n    5. Conponents\n        +app\n        +charts\n        +forms\n        +map\n        +uc\n        +ui\n        +widget\n\n    6. Page\n        _index-1\n        _page-error\n        _page-register\n        _page-signin\n        _page-user-lock\n        _page-user-lock\n\n*/\n@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,600;1,700;1,800;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css?family=Poppins:300,400,500,600,700,800');\n@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,600,700');\n@import url('https://fonts.googleapis.com/css?family=Montserrat:400,500,600,700');\n@import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700');\n@import url('https://fonts.googleapis.com/css?family=Nunito:400,600,700');\n@import url('https://fonts.googleapis.com/css2?family=Material+Icons');\n@import url('./../icons/simple-line-icons/css/simple-line-icons.css');\n@import url('./../icons/fontawesome/css/all.min.css');\n@import url('./../icons/material-design-iconic-font/css/materialdesignicons.min.css');\n@import url('./../icons/themify-icons/css/themify-icons.css');\n@import url('./../icons/line-awesome/css/line-awesome.min.css');\n@import url('./../icons/avasta/css/style.css');\n@import url('./../icons/flaticon/flaticon.css');\n@import url('./../icons/flaticon-1/font/flaticon-1.css');\n@import url('./../icons/icomoon/icomoon.css');\n@import url('./../icons/bootstrap-icons/font/bootstrap-icons.css');\n@import url(./../other/animate/animate.min.css);\n@import url(./../other/aos/css/aos.min.css);\n@import url(./../other/perfect-scrollbar/css/perfect-scrollbar.css);\n@import url(./../other/metismenu/css/metisMenu.min.css);\n:root {\n\t--primary: #4d44b5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3d3690;\n\t--primary-dark: #1e1a46;\n\t--rgba-primary-1: rgba(77, 68, 181, 0.1);\n\t--rgba-primary-2: rgba(77, 68, 181, 0.2);\n\t--rgba-primary-3: rgba(77, 68, 181, 0.3);\n\t--rgba-primary-4: rgba(77, 68, 181, 0.4);\n\t--rgba-primary-5: rgba(77, 68, 181, 0.5);\n\t--rgba-primary-6: rgba(77, 68, 181, 0.6);\n\t--rgba-primary-7: rgba(77, 68, 181, 0.7);\n\t--rgba-primary-8: rgba(77, 68, 181, 0.8);\n\t--rgba-primary-9: rgba(77, 68, 181, 0.9);\n\t--rgba-secondary-1: rgba(251, 125, 91, 0.1);\n\t--rgba-secondary-2: rgba(251, 125, 91, 0.2);\n\t--rgba-secondary-3: rgba(251, 125, 91, 0.3);\n\t--rgba-secondary-4: rgba(251, 125, 91, 0.4);\n\t--rgba-secondary-5: rgba(251, 125, 91, 0.5);\n\t--rgba-secondary-6: rgba(251, 125, 91, 0.6);\n\t--rgba-secondary-7: rgba(251, 125, 91, 0.7);\n\t--rgba-secondary-8: rgba(251, 125, 91, 0.8);\n\t--rgba-secondary-9: rgba(251, 125, 91, 0.9);\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--title: #303972;\n}\n\n.gradient_one {\n\tbackground-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%, rgba(103, 25, 255, 0.85) 100%);\n}\n\n.gradient-1 {\n\tbackground: #f0a907;\n\tbackground: -moz-linear-gradient(top, #f0a907 0%, #f53c79 100%);\n\tbackground: -webkit-linear-gradient(top, #f0a907 0%, #f53c79 100%);\n\tbackground: linear-gradient(to bottom, #f0a907 0%, #f53c79 100%) !important;\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f0a907', endColorstr='#f53c79',GradientType=0 );\n}\n\n.gradient-2 {\n\tbackground: #4dedf5;\n\tbackground: -moz-linear-gradient(top, #4dedf5 0%, #480ceb 100%);\n\tbackground: -webkit-linear-gradient(top, #4dedf5 0%, #480ceb 100%);\n\tbackground: linear-gradient(to bottom, #4dedf5 0%, #480ceb 100%) !important;\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4dedf5', endColorstr='#480ceb',GradientType=0 );\n}\n\n.gradient-3 {\n\tbackground: #51f5ae;\n\tbackground: -moz-linear-gradient(top, #51f5ae 0%, #3fbcda 100%);\n\tbackground: -webkit-linear-gradient(top, #51f5ae 0%, #3fbcda 100%);\n\tbackground: linear-gradient(to bottom, #51f5ae 0%, #3fbcda 100%) !important;\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#51f5ae', endColorstr='#3fbcda',GradientType=0 );\n}\n\n.gradient-4 {\n\tbackground: #f25521;\n\tbackground: -moz-linear-gradient(left, #f25521 0%, #f9c70a 100%);\n\tbackground: -webkit-linear-gradient(left, #f25521 0%, #f9c70a 100%);\n\tbackground: linear-gradient(to right, #f25521 0%, #f9c70a 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f25521', endColorstr='#f9c70a',GradientType=1 );\n}\n\n.gradient-5 {\n\tbackground: #f53c79;\n\tbackground: -moz-linear-gradient(left, #f53c79 0%, #f0a907 100%);\n\tbackground: -webkit-linear-gradient(left, #f53c79 0%, #f0a907 100%);\n\tbackground: linear-gradient(to right, #f53c79 0%, #f0a907 100%) !important;\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f53c79', endColorstr='#f0a907',GradientType=1 );\n}\n\n.gradient-6 {\n\tbackground: #36b9d8;\n\tbackground: -moz-linear-gradient(left, #36b9d8 0%, #4bffa2 100%);\n\tbackground: -webkit-linear-gradient(left, #36b9d8 0%, #4bffa2 100%);\n\tbackground: linear-gradient(to right, #36b9d8 0%, #4bffa2 100%) !important;\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#36b9d8', endColorstr='#4bffa2',GradientType=1 );\n}\n\n.gradient-7 {\n\tbackground: #4400eb;\n\tbackground: -moz-linear-gradient(left, #4400eb 0%, #44e7f5 100%);\n\tbackground: -webkit-linear-gradient(left, #4400eb 0%, #44e7f5 100%);\n\tbackground: linear-gradient(to right, #4400eb 0%, #44e7f5 100%) !important;\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4400eb', endColorstr='#44e7f5',GradientType=1 );\n}\n\n.gradient-8 {\n\tbackground: #f7b00f;\n\tbackground: -moz-linear-gradient(top, #f7b00f 0%, #f25521 100%);\n\tbackground: -webkit-linear-gradient(top, #f7b00f 0%, #f25521 100%);\n\tbackground: linear-gradient(to bottom, #f7b00f 0%, #f25521 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#F7B00F', endColorstr='#F25521',GradientType=1 );\n}\n\n.gradient-9 {\n\tbackground: #f31e7a !important;\n\tbackground: -moz-linear-gradient(left, #f31e7a 0%, #fd712c 100%);\n\tbackground: -webkit-linear-gradient(left, #f31e7a 0%, #fd712c 100%);\n\tbackground: linear-gradient(to right, #f31e7a 0%, #fd712c 100%) !important;\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f31e7a', endColorstr='#fd712c',GradientType=1 );\n}\n\n.gradient-10 {\n\tbackground: #f25521 !important;\n\tbackground: -moz-linear-gradient(left, #f25521 0%, #f9c70a 100%);\n\tbackground: -webkit-linear-gradient(left, #f25521 0%, #f9c70a 100%);\n\tbackground: linear-gradient(to top, #f25521 0%, #f9c70a 100%) !important;\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f25521', endColorstr='#f9c70a',GradientType=1 );\n}\n\n.gradient-11 {\n\tbackground: #3398fb;\n\tbackground: -moz-linear-gradient(left, #3398fb 0%, #8553ee 100%);\n\tbackground: -webkit-linear-gradient(left, #3398fb 0%, #8553ee 100%);\n\tbackground: linear-gradient(to right, #3398fb 0%, #8553ee 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3398fb', endColorstr='#8553ee',GradientType=1 );\n}\n\n.gradient-12 {\n\tbackground: #36e1b4;\n\tbackground: -moz-linear-gradient(left, #36e1b4 0%, #11cae7 100%);\n\tbackground: -webkit-linear-gradient(left, #36e1b4 0%, #11cae7 100%);\n\tbackground: linear-gradient(to right, #36e1b4 0%, #11cae7 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#36e1b4', endColorstr='#11cae7',GradientType=1 );\n}\n\n.gradient-13 {\n\tbackground: #ffbf31;\n\tbackground: -moz-linear-gradient(left, #ffbf31 0%, #ff890e 100%);\n\tbackground: -webkit-linear-gradient(left, #ffbf31 0%, #ff890e 100%);\n\tbackground: linear-gradient(to right, #ffbf31 0%, #ff890e 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffbf31', endColorstr='#ff890e',GradientType=1 );\n}\n\n.gradient-14 {\n\tbackground: #23bdb8;\n\tbackground: -moz-linear-gradient(-45deg, #23bdb8 0%, #43e794 100%);\n\tbackground: -webkit-linear-gradient(-45deg, #23bdb8 0%, #43e794 100%);\n\tbackground: linear-gradient(135deg, #23bdb8 0%, #43e794 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#23bdb8', endColorstr='#43e794',GradientType=1 );\n}\n\n.gradient-15 {\n\tbackground: #9a56ff;\n\tbackground: -moz-linear-gradient(-45deg, #9a56ff 0%, #e36cd9 100%);\n\tbackground: -webkit-linear-gradient(-45deg, #9a56ff 0%, #e36cd9 100%);\n\tbackground: linear-gradient(135deg, #9a56ff 0%, #e36cd9 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#9a56ff', endColorstr='#e36cd9',GradientType=1 );\n}\n\n.gradient-16 {\n\tbackground: #f48665;\n\tbackground: -moz-linear-gradient(-45deg, #f48665 0%, #fda23f 100%);\n\tbackground: -webkit-linear-gradient(-45deg, #f48665 0%, #fda23f 100%);\n\tbackground: linear-gradient(135deg, #f48665 0%, #fda23f 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f48665', endColorstr='#fda23f',GradientType=1 );\n}\n\n.gradient-17 {\n\tbackground: #e36cd9;\n\tbackground: -moz-linear-gradient(-45deg, #e36cd9 0%, #fe60ae 100%);\n\tbackground: -webkit-linear-gradient(-45deg, #e36cd9 0%, #fe60ae 100%);\n\tbackground: linear-gradient(135deg, #e36cd9 0%, #fe60ae 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e36cd9', endColorstr='#fe60ae',GradientType=1 );\n}\n\n.gradient-18 {\n\tbackground: #a15cff;\n\tbackground: -moz-linear-gradient(left, #a15cff 0%, #ce82fd 100%);\n\tbackground: -webkit-linear-gradient(left, #a15cff 0%, #ce82fd 100%);\n\tbackground: linear-gradient(to right, #a15cff 0%, #ce82fd 100%);\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a15cff', endColorstr='#ce82fd',GradientType=1 );\n}\n\n/*\n0 - 600: Phone\n600 - 900: Tablet portrait\n900 - 1200: Tablet landscape\n1200 - 1800: Normal styles\n1800+ : Big Desktop\n1em = 16px\nThe smaller device rules always should write below the bigger device rules\nFixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component\n*/\n/*!\n * Bootstrap v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root {\n\t--bs-blue: #374c98;\n\t--bs-indigo: #6610f2;\n\t--bs-purple: #6f42c1;\n\t--bs-pink: #eb62d0;\n\t--bs-red: #ee3232;\n\t--bs-orange: #ff9900;\n\t--bs-yellow: #fffa6f;\n\t--bs-green: #297f00;\n\t--bs-teal: #20c997;\n\t--bs-cyan: #3065d0;\n\t--bs-white: #fff;\n\t--bs-gray: #6c757d;\n\t--bs-gray-dark: #343a40;\n\t--bs-gray-100: #f8f9fa;\n\t--bs-gray-200: #e9ecef;\n\t--bs-gray-300: #dee2e6;\n\t--bs-gray-400: #ced4da;\n\t--bs-gray-500: #adb5bd;\n\t--bs-gray-600: #6c757d;\n\t--bs-gray-700: #495057;\n\t--bs-gray-800: #343a40;\n\t--bs-gray-900: #212529;\n\t--bs-primary: #4d44b5;\n\t--bs-secondary: #fb7d5b;\n\t--bs-success: #1eba62;\n\t--bs-info: #00ada3;\n\t--bs-warning: #fcc43e;\n\t--bs-danger: #fd5353;\n\t--bs-light: #ebebf9;\n\t--bs-dark: #303972;\n\t--bs-primary-rgb: 77, 68, 181;\n\t--bs-secondary-rgb: 251, 125, 91;\n\t--bs-success-rgb: 30, 186, 98;\n\t--bs-info-rgb: 0, 173, 163;\n\t--bs-warning-rgb: 252, 196, 62;\n\t--bs-danger-rgb: 253, 83, 83;\n\t--bs-light-rgb: 235, 235, 249;\n\t--bs-dark-rgb: 48, 57, 114;\n\t--bs-white-rgb: 255, 255, 255;\n\t--bs-black-rgb: 0, 0, 0;\n\t--bs-body-color-rgb: 160, 152, 174;\n\t--bs-body-bg-rgb: 230, 235, 238;\n\t--bs-font-sans-serif: system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif,\n\t\t'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n\t--bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;\n\t--bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n\t--bs-body-font-family: Poppins, sans-serif;\n\t--bs-body-font-size: 0.875rem;\n\t--bs-body-font-weight: 400;\n\t--bs-body-line-height: 1.5;\n\t--bs-body-color: #a098ae;\n\t--bs-body-bg: #e6ebee;\n}\n\n*,\n*::before,\n*::after {\n\tbox-sizing: border-box;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n\t:root {\n\t\tscroll-behavior: smooth;\n\t}\n}\n\nbody {\n\tmargin: 0;\n\tfont-family: var(--bs-body-font-family);\n\tfont-size: var(--bs-body-font-size);\n\tfont-weight: var(--bs-body-font-weight);\n\tline-height: var(--bs-body-line-height);\n\tcolor: var(--bs-body-color);\n\ttext-align: var(--bs-body-text-align);\n\tbackground-color: var(--bs-body-bg);\n\t-webkit-text-size-adjust: 100%;\n\t-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n\tmargin: 1rem 0;\n\tcolor: inherit;\n\tbackground-color: currentColor;\n\tborder: 0;\n\topacity: 0.25;\n}\n\nhr:not([size]) {\n\theight: 1px;\n}\n\nh1,\n.h1,\nh2,\n.h2,\nh3,\n.h3,\nh4,\n.h4,\nh5,\n.h5,\nh6,\n.h6 {\n\tmargin-top: 0;\n\tmargin-bottom: 0.5rem;\n\tfont-weight: 600;\n\tline-height: 1.2;\n\tcolor: #303972;\n}\n\nh1,\n.h1 {\n\tfont-size: calc(1.35rem + 1.2vw);\n}\n@media (min-width: 1200px) {\n\th1,\n\t.h1 {\n\t\tfont-size: 2.25rem;\n\t}\n}\n\nh2,\n.h2 {\n\tfont-size: calc(1.3125rem + 0.75vw);\n}\n@media (min-width: 1200px) {\n\th2,\n\t.h2 {\n\t\tfont-size: 1.875rem;\n\t}\n}\n\nh3,\n.h3 {\n\tfont-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n\th3,\n\t.h3 {\n\t\tfont-size: 1.5rem;\n\t}\n}\n\nh4,\n.h4 {\n\tfont-size: 1.125rem;\n}\n\nh5,\n.h5 {\n\tfont-size: 1rem;\n}\n\nh6,\n.h6 {\n\tfont-size: 0.938rem;\n}\n\np {\n\tmargin-top: 0;\n\tmargin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-bs-original-title] {\n\ttext-decoration: underline dotted;\n\tcursor: help;\n\ttext-decoration-skip-ink: none;\n}\n\naddress {\n\tmargin-bottom: 1rem;\n\tfont-style: normal;\n\tline-height: inherit;\n}\n\nol,\nul {\n\tpadding-left: 2rem;\n}\n\nol,\nul,\ndl {\n\tmargin-top: 0;\n\tmargin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n\tmargin-bottom: 0;\n}\n\ndt {\n\tfont-weight: 700;\n}\n\ndd {\n\tmargin-bottom: 0.5rem;\n\tmargin-left: 0;\n}\n\nblockquote {\n\tmargin: 0 0 1rem;\n}\n\nb,\nstrong {\n\tfont-weight: bolder;\n}\n\nsmall,\n.small {\n\tfont-size: 0.875em;\n}\n\nmark,\n.mark {\n\tpadding: 0.2em;\n\tbackground-color: #fcf8e3;\n}\n\nsub,\nsup {\n\tposition: relative;\n\tfont-size: 0.75em;\n\tline-height: 0;\n\tvertical-align: baseline;\n}\n\nsub {\n\tbottom: -0.25em;\n}\n\nsup {\n\ttop: -0.5em;\n}\n\na {\n\tcolor: #4d44b5;\n\ttext-decoration: underline;\n}\na:hover {\n\tcolor: #3e3691;\n}\n\na:not([href]):not([class]),\na:not([href]):not([class]):hover {\n\tcolor: inherit;\n\ttext-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n\tfont-family: var(--bs-font-monospace);\n\tfont-size: 1em;\n\tdirection: ltr /* rtl:ignore */;\n\tunicode-bidi: bidi-override;\n}\n\npre {\n\tdisplay: block;\n\tmargin-top: 0;\n\tmargin-bottom: 1rem;\n\toverflow: auto;\n\tfont-size: 0.875em;\n}\npre code {\n\tfont-size: inherit;\n\tcolor: inherit;\n\tword-break: normal;\n}\n\ncode {\n\tfont-size: 0.875em;\n\tcolor: #eb62d0;\n\tword-wrap: break-word;\n}\na > code {\n\tcolor: inherit;\n}\n\nkbd {\n\tpadding: 0.2rem 0.4rem;\n\tfont-size: 0.875em;\n\tcolor: #fff;\n\tbackground-color: #212529;\n\tborder-radius: 0.625rem;\n}\nkbd kbd {\n\tpadding: 0;\n\tfont-size: 1em;\n\tfont-weight: 700;\n}\n\nfigure {\n\tmargin: 0 0 1rem;\n}\n\nimg,\nsvg {\n\tvertical-align: middle;\n}\n\ntable {\n\tcaption-side: bottom;\n\tborder-collapse: collapse;\n}\n\ncaption {\n\tpadding-top: 0.5rem;\n\tpadding-bottom: 0.5rem;\n\tcolor: #89879f;\n\ttext-align: left;\n}\n\nth {\n\ttext-align: inherit;\n\ttext-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n\tborder-color: inherit;\n\tborder-style: solid;\n\tborder-width: 0;\n}\n\nlabel {\n\tdisplay: inline-block;\n}\n\nbutton {\n\tborder-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n\toutline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n\tmargin: 0;\n\tfont-family: inherit;\n\tfont-size: inherit;\n\tline-height: inherit;\n}\n\nbutton,\nselect {\n\ttext-transform: none;\n}\n\n[role='button'] {\n\tcursor: pointer;\n}\n\nselect {\n\tword-wrap: normal;\n}\nselect:disabled {\n\topacity: 1;\n}\n\n[list]::-webkit-calendar-picker-indicator {\n\tdisplay: none;\n}\n\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n\t-webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type='button']:not(:disabled),\n[type='reset']:not(:disabled),\n[type='submit']:not(:disabled) {\n\tcursor: pointer;\n}\n\n::-moz-focus-inner {\n\tpadding: 0;\n\tborder-style: none;\n}\n\ntextarea {\n\tresize: vertical;\n}\n\nfieldset {\n\tmin-width: 0;\n\tpadding: 0;\n\tmargin: 0;\n\tborder: 0;\n}\n\nlegend {\n\tfloat: left;\n\twidth: 100%;\n\tpadding: 0;\n\tmargin-bottom: 0.5rem;\n\tfont-size: calc(1.275rem + 0.3vw);\n\tline-height: inherit;\n}\n@media (min-width: 1200px) {\n\tlegend {\n\t\tfont-size: 1.5rem;\n\t}\n}\nlegend + * {\n\tclear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n\tpadding: 0;\n}\n\n::-webkit-inner-spin-button {\n\theight: auto;\n}\n\n[type='search'] {\n\toutline-offset: -2px;\n\t-webkit-appearance: textfield;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n\t-webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n\tpadding: 0;\n}\n\n::file-selector-button {\n\tfont: inherit;\n}\n\n::-webkit-file-upload-button {\n\tfont: inherit;\n\t-webkit-appearance: button;\n}\n\noutput {\n\tdisplay: inline-block;\n}\n\niframe {\n\tborder: 0;\n}\n\nsummary {\n\tdisplay: list-item;\n\tcursor: pointer;\n}\n\nprogress {\n\tvertical-align: baseline;\n}\n\n[hidden] {\n\tdisplay: none !important;\n}\n\n.lead {\n\tfont-size: 1.09375rem;\n\tfont-weight: 300;\n}\n\n.display-1 {\n\tfont-size: calc(1.625rem + 4.5vw);\n\tfont-weight: 300;\n\tline-height: 1.2;\n}\n@media (min-width: 1200px) {\n\t.display-1 {\n\t\tfont-size: 5rem;\n\t}\n}\n\n.display-2 {\n\tfont-size: calc(1.575rem + 3.9vw);\n\tfont-weight: 300;\n\tline-height: 1.2;\n}\n@media (min-width: 1200px) {\n\t.display-2 {\n\t\tfont-size: 4.5rem;\n\t}\n}\n\n.display-3 {\n\tfont-size: calc(1.525rem + 3.3vw);\n\tfont-weight: 300;\n\tline-height: 1.2;\n}\n@media (min-width: 1200px) {\n\t.display-3 {\n\t\tfont-size: 4rem;\n\t}\n}\n\n.display-4 {\n\tfont-size: calc(1.475rem + 2.7vw);\n\tfont-weight: 300;\n\tline-height: 1.2;\n}\n@media (min-width: 1200px) {\n\t.display-4 {\n\t\tfont-size: 3.5rem;\n\t}\n}\n\n.display-5 {\n\tfont-size: calc(1.425rem + 2.1vw);\n\tfont-weight: 300;\n\tline-height: 1.2;\n}\n@media (min-width: 1200px) {\n\t.display-5 {\n\t\tfont-size: 3rem;\n\t}\n}\n\n.display-6 {\n\tfont-size: calc(1.375rem + 1.5vw);\n\tfont-weight: 300;\n\tline-height: 1.2;\n}\n@media (min-width: 1200px) {\n\t.display-6 {\n\t\tfont-size: 2.5rem;\n\t}\n}\n\n.list-unstyled {\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n.list-inline {\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n.list-inline-item {\n\tdisplay: inline-block;\n}\n.list-inline-item:not(:last-child) {\n\tmargin-right: 0.5rem;\n}\n\n.initialism {\n\tfont-size: 0.875em;\n\ttext-transform: uppercase;\n}\n\n.blockquote {\n\tmargin-bottom: 1rem;\n\tfont-size: 1.09375rem;\n}\n.blockquote > :last-child {\n\tmargin-bottom: 0;\n}\n\n.blockquote-footer {\n\tmargin-top: -1rem;\n\tmargin-bottom: 1rem;\n\tfont-size: 0.875em;\n\tcolor: #6c757d;\n}\n.blockquote-footer::before {\n\tcontent: '\\2014\\00A0';\n}\n\n.img-fluid {\n\tmax-width: 100%;\n\theight: auto;\n}\n\n.img-thumbnail {\n\tpadding: 0.25rem;\n\tbackground-color: #e6ebee;\n\tborder: 1px solid #dee2e6;\n\tborder-radius: 0.625rem;\n\tmax-width: 100%;\n\theight: auto;\n}\n\n.figure {\n\tdisplay: inline-block;\n}\n\n.figure-img {\n\tmargin-bottom: 0.5rem;\n\tline-height: 1;\n}\n\n.figure-caption {\n\tfont-size: 0.875em;\n\tcolor: #6c757d;\n}\n\n.container,\n.container-fluid,\n.container-sm,\n.container-md,\n.container-lg,\n.container-xl,\n.container-xxl {\n\twidth: 100%;\n\tpadding-right: var(--bs-gutter-x, 15px);\n\tpadding-left: var(--bs-gutter-x, 15px);\n\tmargin-right: auto;\n\tmargin-left: auto;\n}\n\n@media (min-width: 576px) {\n\t.container,\n\t.container-sm {\n\t\tmax-width: 540px;\n\t}\n}\n\n@media (min-width: 768px) {\n\t.container,\n\t.container-sm,\n\t.container-md {\n\t\tmax-width: 720px;\n\t}\n}\n\n@media (min-width: 992px) {\n\t.container,\n\t.container-sm,\n\t.container-md,\n\t.container-lg {\n\t\tmax-width: 960px;\n\t}\n}\n\n@media (min-width: 1200px) {\n\t.container,\n\t.container-sm,\n\t.container-md,\n\t.container-lg,\n\t.container-xl {\n\t\tmax-width: 1140px;\n\t}\n}\n\n@media (min-width: 1440) {\n\t.container,\n\t.container-sm,\n\t.container-md,\n\t.container-lg,\n\t.container-xl,\n\t.container-xxl {\n\t\tmax-width: 1320px;\n\t}\n}\n\n.row {\n\t--bs-gutter-x: 30px;\n\t--bs-gutter-y: 0;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmargin-top: calc(-1 * var(--bs-gutter-y));\n\tmargin-right: calc(-0.5 * var(--bs-gutter-x));\n\tmargin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.row > * {\n\tflex-shrink: 0;\n\twidth: 100%;\n\tmax-width: 100%;\n\tpadding-right: calc(var(--bs-gutter-x) * 0.5);\n\tpadding-left: calc(var(--bs-gutter-x) * 0.5);\n\tmargin-top: var(--bs-gutter-y);\n}\n\n.col {\n\tflex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n\tflex: 0 0 auto;\n\twidth: auto;\n}\n\n.row-cols-1 > * {\n\tflex: 0 0 auto;\n\twidth: 100%;\n}\n\n.row-cols-2 > * {\n\tflex: 0 0 auto;\n\twidth: 50%;\n}\n\n.row-cols-3 > * {\n\tflex: 0 0 auto;\n\twidth: 33.33333%;\n}\n\n.row-cols-4 > * {\n\tflex: 0 0 auto;\n\twidth: 25%;\n}\n\n.row-cols-5 > * {\n\tflex: 0 0 auto;\n\twidth: 20%;\n}\n\n.row-cols-6 > * {\n\tflex: 0 0 auto;\n\twidth: 16.66667%;\n}\n\n.col-auto {\n\tflex: 0 0 auto;\n\twidth: auto;\n}\n\n.col-1 {\n\tflex: 0 0 auto;\n\twidth: 8.33333%;\n}\n\n.col-2 {\n\tflex: 0 0 auto;\n\twidth: 16.66667%;\n}\n\n.col-3 {\n\tflex: 0 0 auto;\n\twidth: 25%;\n}\n\n.col-4 {\n\tflex: 0 0 auto;\n\twidth: 33.33333%;\n}\n\n.col-5 {\n\tflex: 0 0 auto;\n\twidth: 41.66667%;\n}\n\n.col-6 {\n\tflex: 0 0 auto;\n\twidth: 50%;\n}\n\n.col-7 {\n\tflex: 0 0 auto;\n\twidth: 58.33333%;\n}\n\n.col-8 {\n\tflex: 0 0 auto;\n\twidth: 66.66667%;\n}\n\n.col-9 {\n\tflex: 0 0 auto;\n\twidth: 75%;\n}\n\n.col-10 {\n\tflex: 0 0 auto;\n\twidth: 83.33333%;\n}\n\n.col-11 {\n\tflex: 0 0 auto;\n\twidth: 91.66667%;\n}\n\n.col-12 {\n\tflex: 0 0 auto;\n\twidth: 100%;\n}\n\n.offset-1 {\n\tmargin-left: 8.33333%;\n}\n\n.offset-2 {\n\tmargin-left: 16.66667%;\n}\n\n.offset-3 {\n\tmargin-left: 25%;\n}\n\n.offset-4 {\n\tmargin-left: 33.33333%;\n}\n\n.offset-5 {\n\tmargin-left: 41.66667%;\n}\n\n.offset-6 {\n\tmargin-left: 50%;\n}\n\n.offset-7 {\n\tmargin-left: 58.33333%;\n}\n\n.offset-8 {\n\tmargin-left: 66.66667%;\n}\n\n.offset-9 {\n\tmargin-left: 75%;\n}\n\n.offset-10 {\n\tmargin-left: 83.33333%;\n}\n\n.offset-11 {\n\tmargin-left: 91.66667%;\n}\n\n.g-0,\n.gx-0 {\n\t--bs-gutter-x: 0;\n}\n\n.g-0,\n.gy-0 {\n\t--bs-gutter-y: 0;\n}\n\n.g-1,\n.gx-1 {\n\t--bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n\t--bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n\t--bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n\t--bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n\t--bs-gutter-x: 1rem;\n}\n\n.g-3,\n.gy-3 {\n\t--bs-gutter-y: 1rem;\n}\n\n.g-4,\n.gx-4 {\n\t--bs-gutter-x: 1.875rem;\n}\n\n.g-4,\n.gy-4 {\n\t--bs-gutter-y: 1.875rem;\n}\n\n.g-5,\n.gx-5 {\n\t--bs-gutter-x: 3rem;\n}\n\n.g-5,\n.gy-5 {\n\t--bs-gutter-y: 3rem;\n}\n\n@media (min-width: 576px) {\n\t.col-sm {\n\t\tflex: 1 0 0%;\n\t}\n\t.row-cols-sm-auto > * {\n\t\tflex: 0 0 auto;\n\t\twidth: auto;\n\t}\n\t.row-cols-sm-1 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 100%;\n\t}\n\t.row-cols-sm-2 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 50%;\n\t}\n\t.row-cols-sm-3 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 33.33333%;\n\t}\n\t.row-cols-sm-4 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 25%;\n\t}\n\t.row-cols-sm-5 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 20%;\n\t}\n\t.row-cols-sm-6 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 16.66667%;\n\t}\n\t.col-sm-auto {\n\t\tflex: 0 0 auto;\n\t\twidth: auto;\n\t}\n\t.col-sm-1 {\n\t\tflex: 0 0 auto;\n\t\twidth: 8.33333%;\n\t}\n\t.col-sm-2 {\n\t\tflex: 0 0 auto;\n\t\twidth: 16.66667%;\n\t}\n\t.col-sm-3 {\n\t\tflex: 0 0 auto;\n\t\twidth: 25%;\n\t}\n\t.col-sm-4 {\n\t\tflex: 0 0 auto;\n\t\twidth: 33.33333%;\n\t}\n\t.col-sm-5 {\n\t\tflex: 0 0 auto;\n\t\twidth: 41.66667%;\n\t}\n\t.col-sm-6 {\n\t\tflex: 0 0 auto;\n\t\twidth: 50%;\n\t}\n\t.col-sm-7 {\n\t\tflex: 0 0 auto;\n\t\twidth: 58.33333%;\n\t}\n\t.col-sm-8 {\n\t\tflex: 0 0 auto;\n\t\twidth: 66.66667%;\n\t}\n\t.col-sm-9 {\n\t\tflex: 0 0 auto;\n\t\twidth: 75%;\n\t}\n\t.col-sm-10 {\n\t\tflex: 0 0 auto;\n\t\twidth: 83.33333%;\n\t}\n\t.col-sm-11 {\n\t\tflex: 0 0 auto;\n\t\twidth: 91.66667%;\n\t}\n\t.col-sm-12 {\n\t\tflex: 0 0 auto;\n\t\twidth: 100%;\n\t}\n\t.offset-sm-0 {\n\t\tmargin-left: 0;\n\t}\n\t.offset-sm-1 {\n\t\tmargin-left: 8.33333%;\n\t}\n\t.offset-sm-2 {\n\t\tmargin-left: 16.66667%;\n\t}\n\t.offset-sm-3 {\n\t\tmargin-left: 25%;\n\t}\n\t.offset-sm-4 {\n\t\tmargin-left: 33.33333%;\n\t}\n\t.offset-sm-5 {\n\t\tmargin-left: 41.66667%;\n\t}\n\t.offset-sm-6 {\n\t\tmargin-left: 50%;\n\t}\n\t.offset-sm-7 {\n\t\tmargin-left: 58.33333%;\n\t}\n\t.offset-sm-8 {\n\t\tmargin-left: 66.66667%;\n\t}\n\t.offset-sm-9 {\n\t\tmargin-left: 75%;\n\t}\n\t.offset-sm-10 {\n\t\tmargin-left: 83.33333%;\n\t}\n\t.offset-sm-11 {\n\t\tmargin-left: 91.66667%;\n\t}\n\t.g-sm-0,\n\t.gx-sm-0 {\n\t\t--bs-gutter-x: 0;\n\t}\n\t.g-sm-0,\n\t.gy-sm-0 {\n\t\t--bs-gutter-y: 0;\n\t}\n\t.g-sm-1,\n\t.gx-sm-1 {\n\t\t--bs-gutter-x: 0.25rem;\n\t}\n\t.g-sm-1,\n\t.gy-sm-1 {\n\t\t--bs-gutter-y: 0.25rem;\n\t}\n\t.g-sm-2,\n\t.gx-sm-2 {\n\t\t--bs-gutter-x: 0.5rem;\n\t}\n\t.g-sm-2,\n\t.gy-sm-2 {\n\t\t--bs-gutter-y: 0.5rem;\n\t}\n\t.g-sm-3,\n\t.gx-sm-3 {\n\t\t--bs-gutter-x: 1rem;\n\t}\n\t.g-sm-3,\n\t.gy-sm-3 {\n\t\t--bs-gutter-y: 1rem;\n\t}\n\t.g-sm-4,\n\t.gx-sm-4 {\n\t\t--bs-gutter-x: 1.875rem;\n\t}\n\t.g-sm-4,\n\t.gy-sm-4 {\n\t\t--bs-gutter-y: 1.875rem;\n\t}\n\t.g-sm-5,\n\t.gx-sm-5 {\n\t\t--bs-gutter-x: 3rem;\n\t}\n\t.g-sm-5,\n\t.gy-sm-5 {\n\t\t--bs-gutter-y: 3rem;\n\t}\n}\n\n@media (min-width: 768px) {\n\t.col-md {\n\t\tflex: 1 0 0%;\n\t}\n\t.row-cols-md-auto > * {\n\t\tflex: 0 0 auto;\n\t\twidth: auto;\n\t}\n\t.row-cols-md-1 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 100%;\n\t}\n\t.row-cols-md-2 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 50%;\n\t}\n\t.row-cols-md-3 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 33.33333%;\n\t}\n\t.row-cols-md-4 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 25%;\n\t}\n\t.row-cols-md-5 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 20%;\n\t}\n\t.row-cols-md-6 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 16.66667%;\n\t}\n\t.col-md-auto {\n\t\tflex: 0 0 auto;\n\t\twidth: auto;\n\t}\n\t.col-md-1 {\n\t\tflex: 0 0 auto;\n\t\twidth: 8.33333%;\n\t}\n\t.col-md-2 {\n\t\tflex: 0 0 auto;\n\t\twidth: 16.66667%;\n\t}\n\t.col-md-3 {\n\t\tflex: 0 0 auto;\n\t\twidth: 25%;\n\t}\n\t.col-md-4 {\n\t\tflex: 0 0 auto;\n\t\twidth: 33.33333%;\n\t}\n\t.col-md-5 {\n\t\tflex: 0 0 auto;\n\t\twidth: 41.66667%;\n\t}\n\t.col-md-6 {\n\t\tflex: 0 0 auto;\n\t\twidth: 50%;\n\t}\n\t.col-md-7 {\n\t\tflex: 0 0 auto;\n\t\twidth: 58.33333%;\n\t}\n\t.col-md-8 {\n\t\tflex: 0 0 auto;\n\t\twidth: 66.66667%;\n\t}\n\t.col-md-9 {\n\t\tflex: 0 0 auto;\n\t\twidth: 75%;\n\t}\n\t.col-md-10 {\n\t\tflex: 0 0 auto;\n\t\twidth: 83.33333%;\n\t}\n\t.col-md-11 {\n\t\tflex: 0 0 auto;\n\t\twidth: 91.66667%;\n\t}\n\t.col-md-12 {\n\t\tflex: 0 0 auto;\n\t\twidth: 100%;\n\t}\n\t.offset-md-0 {\n\t\tmargin-left: 0;\n\t}\n\t.offset-md-1 {\n\t\tmargin-left: 8.33333%;\n\t}\n\t.offset-md-2 {\n\t\tmargin-left: 16.66667%;\n\t}\n\t.offset-md-3 {\n\t\tmargin-left: 25%;\n\t}\n\t.offset-md-4 {\n\t\tmargin-left: 33.33333%;\n\t}\n\t.offset-md-5 {\n\t\tmargin-left: 41.66667%;\n\t}\n\t.offset-md-6 {\n\t\tmargin-left: 50%;\n\t}\n\t.offset-md-7 {\n\t\tmargin-left: 58.33333%;\n\t}\n\t.offset-md-8 {\n\t\tmargin-left: 66.66667%;\n\t}\n\t.offset-md-9 {\n\t\tmargin-left: 75%;\n\t}\n\t.offset-md-10 {\n\t\tmargin-left: 83.33333%;\n\t}\n\t.offset-md-11 {\n\t\tmargin-left: 91.66667%;\n\t}\n\t.g-md-0,\n\t.gx-md-0 {\n\t\t--bs-gutter-x: 0;\n\t}\n\t.g-md-0,\n\t.gy-md-0 {\n\t\t--bs-gutter-y: 0;\n\t}\n\t.g-md-1,\n\t.gx-md-1 {\n\t\t--bs-gutter-x: 0.25rem;\n\t}\n\t.g-md-1,\n\t.gy-md-1 {\n\t\t--bs-gutter-y: 0.25rem;\n\t}\n\t.g-md-2,\n\t.gx-md-2 {\n\t\t--bs-gutter-x: 0.5rem;\n\t}\n\t.g-md-2,\n\t.gy-md-2 {\n\t\t--bs-gutter-y: 0.5rem;\n\t}\n\t.g-md-3,\n\t.gx-md-3 {\n\t\t--bs-gutter-x: 1rem;\n\t}\n\t.g-md-3,\n\t.gy-md-3 {\n\t\t--bs-gutter-y: 1rem;\n\t}\n\t.g-md-4,\n\t.gx-md-4 {\n\t\t--bs-gutter-x: 1.875rem;\n\t}\n\t.g-md-4,\n\t.gy-md-4 {\n\t\t--bs-gutter-y: 1.875rem;\n\t}\n\t.g-md-5,\n\t.gx-md-5 {\n\t\t--bs-gutter-x: 3rem;\n\t}\n\t.g-md-5,\n\t.gy-md-5 {\n\t\t--bs-gutter-y: 3rem;\n\t}\n}\n\n@media (min-width: 992px) {\n\t.col-lg {\n\t\tflex: 1 0 0%;\n\t}\n\t.row-cols-lg-auto > * {\n\t\tflex: 0 0 auto;\n\t\twidth: auto;\n\t}\n\t.row-cols-lg-1 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 100%;\n\t}\n\t.row-cols-lg-2 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 50%;\n\t}\n\t.row-cols-lg-3 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 33.33333%;\n\t}\n\t.row-cols-lg-4 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 25%;\n\t}\n\t.row-cols-lg-5 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 20%;\n\t}\n\t.row-cols-lg-6 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 16.66667%;\n\t}\n\t.col-lg-auto {\n\t\tflex: 0 0 auto;\n\t\twidth: auto;\n\t}\n\t.col-lg-1 {\n\t\tflex: 0 0 auto;\n\t\twidth: 8.33333%;\n\t}\n\t.col-lg-2 {\n\t\tflex: 0 0 auto;\n\t\twidth: 16.66667%;\n\t}\n\t.col-lg-3 {\n\t\tflex: 0 0 auto;\n\t\twidth: 25%;\n\t}\n\t.col-lg-4 {\n\t\tflex: 0 0 auto;\n\t\twidth: 33.33333%;\n\t}\n\t.col-lg-5 {\n\t\tflex: 0 0 auto;\n\t\twidth: 41.66667%;\n\t}\n\t.col-lg-6 {\n\t\tflex: 0 0 auto;\n\t\twidth: 50%;\n\t}\n\t.col-lg-7 {\n\t\tflex: 0 0 auto;\n\t\twidth: 58.33333%;\n\t}\n\t.col-lg-8 {\n\t\tflex: 0 0 auto;\n\t\twidth: 66.66667%;\n\t}\n\t.col-lg-9 {\n\t\tflex: 0 0 auto;\n\t\twidth: 75%;\n\t}\n\t.col-lg-10 {\n\t\tflex: 0 0 auto;\n\t\twidth: 83.33333%;\n\t}\n\t.col-lg-11 {\n\t\tflex: 0 0 auto;\n\t\twidth: 91.66667%;\n\t}\n\t.col-lg-12 {\n\t\tflex: 0 0 auto;\n\t\twidth: 100%;\n\t}\n\t.offset-lg-0 {\n\t\tmargin-left: 0;\n\t}\n\t.offset-lg-1 {\n\t\tmargin-left: 8.33333%;\n\t}\n\t.offset-lg-2 {\n\t\tmargin-left: 16.66667%;\n\t}\n\t.offset-lg-3 {\n\t\tmargin-left: 25%;\n\t}\n\t.offset-lg-4 {\n\t\tmargin-left: 33.33333%;\n\t}\n\t.offset-lg-5 {\n\t\tmargin-left: 41.66667%;\n\t}\n\t.offset-lg-6 {\n\t\tmargin-left: 50%;\n\t}\n\t.offset-lg-7 {\n\t\tmargin-left: 58.33333%;\n\t}\n\t.offset-lg-8 {\n\t\tmargin-left: 66.66667%;\n\t}\n\t.offset-lg-9 {\n\t\tmargin-left: 75%;\n\t}\n\t.offset-lg-10 {\n\t\tmargin-left: 83.33333%;\n\t}\n\t.offset-lg-11 {\n\t\tmargin-left: 91.66667%;\n\t}\n\t.g-lg-0,\n\t.gx-lg-0 {\n\t\t--bs-gutter-x: 0;\n\t}\n\t.g-lg-0,\n\t.gy-lg-0 {\n\t\t--bs-gutter-y: 0;\n\t}\n\t.g-lg-1,\n\t.gx-lg-1 {\n\t\t--bs-gutter-x: 0.25rem;\n\t}\n\t.g-lg-1,\n\t.gy-lg-1 {\n\t\t--bs-gutter-y: 0.25rem;\n\t}\n\t.g-lg-2,\n\t.gx-lg-2 {\n\t\t--bs-gutter-x: 0.5rem;\n\t}\n\t.g-lg-2,\n\t.gy-lg-2 {\n\t\t--bs-gutter-y: 0.5rem;\n\t}\n\t.g-lg-3,\n\t.gx-lg-3 {\n\t\t--bs-gutter-x: 1rem;\n\t}\n\t.g-lg-3,\n\t.gy-lg-3 {\n\t\t--bs-gutter-y: 1rem;\n\t}\n\t.g-lg-4,\n\t.gx-lg-4 {\n\t\t--bs-gutter-x: 1.875rem;\n\t}\n\t.g-lg-4,\n\t.gy-lg-4 {\n\t\t--bs-gutter-y: 1.875rem;\n\t}\n\t.g-lg-5,\n\t.gx-lg-5 {\n\t\t--bs-gutter-x: 3rem;\n\t}\n\t.g-lg-5,\n\t.gy-lg-5 {\n\t\t--bs-gutter-y: 3rem;\n\t}\n}\n\n@media (min-width: 1200px) {\n\t.col-xl {\n\t\tflex: 1 0 0%;\n\t}\n\t.row-cols-xl-auto > * {\n\t\tflex: 0 0 auto;\n\t\twidth: auto;\n\t}\n\t.row-cols-xl-1 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 100%;\n\t}\n\t.row-cols-xl-2 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 50%;\n\t}\n\t.row-cols-xl-3 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 33.33333%;\n\t}\n\t.row-cols-xl-4 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 25%;\n\t}\n\t.row-cols-xl-5 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 20%;\n\t}\n\t.row-cols-xl-6 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 16.66667%;\n\t}\n\t.col-xl-auto {\n\t\tflex: 0 0 auto;\n\t\twidth: auto;\n\t}\n\t.col-xl-1 {\n\t\tflex: 0 0 auto;\n\t\twidth: 8.33333%;\n\t}\n\t.col-xl-2 {\n\t\tflex: 0 0 auto;\n\t\twidth: 16.66667%;\n\t}\n\t.col-xl-3 {\n\t\tflex: 0 0 auto;\n\t\twidth: 25%;\n\t}\n\t.col-xl-4 {\n\t\tflex: 0 0 auto;\n\t\twidth: 33.33333%;\n\t}\n\t.col-xl-5 {\n\t\tflex: 0 0 auto;\n\t\twidth: 41.66667%;\n\t}\n\t.col-xl-6 {\n\t\tflex: 0 0 auto;\n\t\twidth: 50%;\n\t}\n\t.col-xl-7 {\n\t\tflex: 0 0 auto;\n\t\twidth: 58.33333%;\n\t}\n\t.col-xl-8 {\n\t\tflex: 0 0 auto;\n\t\twidth: 66.66667%;\n\t}\n\t.col-xl-9 {\n\t\tflex: 0 0 auto;\n\t\twidth: 75%;\n\t}\n\t.col-xl-10 {\n\t\tflex: 0 0 auto;\n\t\twidth: 83.33333%;\n\t}\n\t.col-xl-11 {\n\t\tflex: 0 0 auto;\n\t\twidth: 91.66667%;\n\t}\n\t.col-xl-12 {\n\t\tflex: 0 0 auto;\n\t\twidth: 100%;\n\t}\n\t.offset-xl-0 {\n\t\tmargin-left: 0;\n\t}\n\t.offset-xl-1 {\n\t\tmargin-left: 8.33333%;\n\t}\n\t.offset-xl-2 {\n\t\tmargin-left: 16.66667%;\n\t}\n\t.offset-xl-3 {\n\t\tmargin-left: 25%;\n\t}\n\t.offset-xl-4 {\n\t\tmargin-left: 33.33333%;\n\t}\n\t.offset-xl-5 {\n\t\tmargin-left: 41.66667%;\n\t}\n\t.offset-xl-6 {\n\t\tmargin-left: 50%;\n\t}\n\t.offset-xl-7 {\n\t\tmargin-left: 58.33333%;\n\t}\n\t.offset-xl-8 {\n\t\tmargin-left: 66.66667%;\n\t}\n\t.offset-xl-9 {\n\t\tmargin-left: 75%;\n\t}\n\t.offset-xl-10 {\n\t\tmargin-left: 83.33333%;\n\t}\n\t.offset-xl-11 {\n\t\tmargin-left: 91.66667%;\n\t}\n\t.g-xl-0,\n\t.gx-xl-0 {\n\t\t--bs-gutter-x: 0;\n\t}\n\t.g-xl-0,\n\t.gy-xl-0 {\n\t\t--bs-gutter-y: 0;\n\t}\n\t.g-xl-1,\n\t.gx-xl-1 {\n\t\t--bs-gutter-x: 0.25rem;\n\t}\n\t.g-xl-1,\n\t.gy-xl-1 {\n\t\t--bs-gutter-y: 0.25rem;\n\t}\n\t.g-xl-2,\n\t.gx-xl-2 {\n\t\t--bs-gutter-x: 0.5rem;\n\t}\n\t.g-xl-2,\n\t.gy-xl-2 {\n\t\t--bs-gutter-y: 0.5rem;\n\t}\n\t.g-xl-3,\n\t.gx-xl-3 {\n\t\t--bs-gutter-x: 1rem;\n\t}\n\t.g-xl-3,\n\t.gy-xl-3 {\n\t\t--bs-gutter-y: 1rem;\n\t}\n\t.g-xl-4,\n\t.gx-xl-4 {\n\t\t--bs-gutter-x: 1.875rem;\n\t}\n\t.g-xl-4,\n\t.gy-xl-4 {\n\t\t--bs-gutter-y: 1.875rem;\n\t}\n\t.g-xl-5,\n\t.gx-xl-5 {\n\t\t--bs-gutter-x: 3rem;\n\t}\n\t.g-xl-5,\n\t.gy-xl-5 {\n\t\t--bs-gutter-y: 3rem;\n\t}\n}\n\n@media (min-width: 1440) {\n\t.col-xxl {\n\t\tflex: 1 0 0%;\n\t}\n\t.row-cols-xxl-auto > * {\n\t\tflex: 0 0 auto;\n\t\twidth: auto;\n\t}\n\t.row-cols-xxl-1 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 100%;\n\t}\n\t.row-cols-xxl-2 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 50%;\n\t}\n\t.row-cols-xxl-3 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 33.33333%;\n\t}\n\t.row-cols-xxl-4 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 25%;\n\t}\n\t.row-cols-xxl-5 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 20%;\n\t}\n\t.row-cols-xxl-6 > * {\n\t\tflex: 0 0 auto;\n\t\twidth: 16.66667%;\n\t}\n\t.col-xxl-auto {\n\t\tflex: 0 0 auto;\n\t\twidth: auto;\n\t}\n\t.col-xxl-1 {\n\t\tflex: 0 0 auto;\n\t\twidth: 8.33333%;\n\t}\n\t.col-xxl-2 {\n\t\tflex: 0 0 auto;\n\t\twidth: 16.66667%;\n\t}\n\t.col-xxl-3 {\n\t\tflex: 0 0 auto;\n\t\twidth: 25%;\n\t}\n\t.col-xxl-4 {\n\t\tflex: 0 0 auto;\n\t\twidth: 33.33333%;\n\t}\n\t.col-xxl-5 {\n\t\tflex: 0 0 auto;\n\t\twidth: 41.66667%;\n\t}\n\t.col-xxl-6 {\n\t\tflex: 0 0 auto;\n\t\twidth: 50%;\n\t}\n\t.col-xxl-7 {\n\t\tflex: 0 0 auto;\n\t\twidth: 58.33333%;\n\t}\n\t.col-xxl-8 {\n\t\tflex: 0 0 auto;\n\t\twidth: 66.66667%;\n\t}\n\t.col-xxl-9 {\n\t\tflex: 0 0 auto;\n\t\twidth: 75%;\n\t}\n\t.col-xxl-10 {\n\t\tflex: 0 0 auto;\n\t\twidth: 83.33333%;\n\t}\n\t.col-xxl-11 {\n\t\tflex: 0 0 auto;\n\t\twidth: 91.66667%;\n\t}\n\t.col-xxl-12 {\n\t\tflex: 0 0 auto;\n\t\twidth: 100%;\n\t}\n\t.offset-xxl-0 {\n\t\tmargin-left: 0;\n\t}\n\t.offset-xxl-1 {\n\t\tmargin-left: 8.33333%;\n\t}\n\t.offset-xxl-2 {\n\t\tmargin-left: 16.66667%;\n\t}\n\t.offset-xxl-3 {\n\t\tmargin-left: 25%;\n\t}\n\t.offset-xxl-4 {\n\t\tmargin-left: 33.33333%;\n\t}\n\t.offset-xxl-5 {\n\t\tmargin-left: 41.66667%;\n\t}\n\t.offset-xxl-6 {\n\t\tmargin-left: 50%;\n\t}\n\t.offset-xxl-7 {\n\t\tmargin-left: 58.33333%;\n\t}\n\t.offset-xxl-8 {\n\t\tmargin-left: 66.66667%;\n\t}\n\t.offset-xxl-9 {\n\t\tmargin-left: 75%;\n\t}\n\t.offset-xxl-10 {\n\t\tmargin-left: 83.33333%;\n\t}\n\t.offset-xxl-11 {\n\t\tmargin-left: 91.66667%;\n\t}\n\t.g-xxl-0,\n\t.gx-xxl-0 {\n\t\t--bs-gutter-x: 0;\n\t}\n\t.g-xxl-0,\n\t.gy-xxl-0 {\n\t\t--bs-gutter-y: 0;\n\t}\n\t.g-xxl-1,\n\t.gx-xxl-1 {\n\t\t--bs-gutter-x: 0.25rem;\n\t}\n\t.g-xxl-1,\n\t.gy-xxl-1 {\n\t\t--bs-gutter-y: 0.25rem;\n\t}\n\t.g-xxl-2,\n\t.gx-xxl-2 {\n\t\t--bs-gutter-x: 0.5rem;\n\t}\n\t.g-xxl-2,\n\t.gy-xxl-2 {\n\t\t--bs-gutter-y: 0.5rem;\n\t}\n\t.g-xxl-3,\n\t.gx-xxl-3 {\n\t\t--bs-gutter-x: 1rem;\n\t}\n\t.g-xxl-3,\n\t.gy-xxl-3 {\n\t\t--bs-gutter-y: 1rem;\n\t}\n\t.g-xxl-4,\n\t.gx-xxl-4 {\n\t\t--bs-gutter-x: 1.875rem;\n\t}\n\t.g-xxl-4,\n\t.gy-xxl-4 {\n\t\t--bs-gutter-y: 1.875rem;\n\t}\n\t.g-xxl-5,\n\t.gx-xxl-5 {\n\t\t--bs-gutter-x: 3rem;\n\t}\n\t.g-xxl-5,\n\t.gy-xxl-5 {\n\t\t--bs-gutter-y: 3rem;\n\t}\n}\n\n.table {\n\t--bs-table-bg: transparent;\n\t--bs-table-accent-bg: transparent;\n\t--bs-table-striped-color: #a098ae;\n\t--bs-table-striped-bg: rgba(0, 0, 0, 0.05);\n\t--bs-table-active-color: #a098ae;\n\t--bs-table-active-bg: rgba(0, 0, 0, 0.1);\n\t--bs-table-hover-color: #a098ae;\n\t--bs-table-hover-bg: rgba(0, 0, 0, 0.075);\n\twidth: 100%;\n\tmargin-bottom: 1rem;\n\tcolor: #a098ae;\n\tvertical-align: top;\n\tborder-color: #eeeeee;\n}\n.table > :not(caption) > * > * {\n\tpadding: 0.5rem 0.5rem;\n\tbackground-color: var(--bs-table-bg);\n\tborder-bottom-width: 1px;\n\tbox-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n}\n.table > tbody {\n\tvertical-align: inherit;\n}\n.table > thead {\n\tvertical-align: bottom;\n}\n.table > :not(:first-child) {\n\tborder-top: 2px solid currentColor;\n}\n\n.caption-top {\n\tcaption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n\tpadding: 0.25rem 0.25rem;\n}\n\n.table-bordered > :not(caption) > * {\n\tborder-width: 1px 0;\n}\n.table-bordered > :not(caption) > * > * {\n\tborder-width: 0 1px;\n}\n\n.table-borderless > :not(caption) > * > * {\n\tborder-bottom-width: 0;\n}\n\n.table-borderless > :not(:first-child) {\n\tborder-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n\t--bs-table-accent-bg: var(--bs-table-striped-bg);\n\tcolor: var(--bs-table-striped-color);\n}\n\n.table-active {\n\t--bs-table-accent-bg: var(--bs-table-active-bg);\n\tcolor: var(--bs-table-active-color);\n}\n\n.table-hover > tbody > tr:hover > * {\n\t--bs-table-accent-bg: var(--bs-table-hover-bg);\n\tcolor: var(--bs-table-hover-color);\n}\n\n.table-primary {\n\t--bs-table-bg: #dbdaf0;\n\t--bs-table-striped-bg: #d0cfe4;\n\t--bs-table-striped-color: #000;\n\t--bs-table-active-bg: #c5c4d8;\n\t--bs-table-active-color: #000;\n\t--bs-table-hover-bg: #cbcade;\n\t--bs-table-hover-color: #000;\n\tcolor: #000;\n\tborder-color: #c5c4d8;\n}\n\n.table-secondary {\n\t--bs-table-bg: #fee5de;\n\t--bs-table-striped-bg: #f1dad3;\n\t--bs-table-striped-color: #000;\n\t--bs-table-active-bg: #e5cec8;\n\t--bs-table-active-color: #000;\n\t--bs-table-hover-bg: #ebd4cd;\n\t--bs-table-hover-color: #000;\n\tcolor: #000;\n\tborder-color: #e5cec8;\n}\n\n.table-success {\n\t--bs-table-bg: #d2f1e0;\n\t--bs-table-striped-bg: #c8e5d5;\n\t--bs-table-striped-color: #000;\n\t--bs-table-active-bg: #bdd9ca;\n\t--bs-table-active-color: #000;\n\t--bs-table-hover-bg: #c2dfcf;\n\t--bs-table-hover-color: #000;\n\tcolor: #000;\n\tborder-color: #bdd9ca;\n}\n\n.table-info {\n\t--bs-table-bg: #ccefed;\n\t--bs-table-striped-bg: #c2e3e1;\n\t--bs-table-striped-color: #000;\n\t--bs-table-active-bg: #b8d7d5;\n\t--bs-table-active-color: #000;\n\t--bs-table-hover-bg: #bddddb;\n\t--bs-table-hover-color: #000;\n\tcolor: #000;\n\tborder-color: #b8d7d5;\n}\n\n.table-warning {\n\t--bs-table-bg: #fef3d8;\n\t--bs-table-striped-bg: #f1e7cd;\n\t--bs-table-striped-color: #000;\n\t--bs-table-active-bg: #e5dbc2;\n\t--bs-table-active-color: #000;\n\t--bs-table-hover-bg: #ebe1c8;\n\t--bs-table-hover-color: #000;\n\tcolor: #000;\n\tborder-color: #e5dbc2;\n}\n\n.table-danger {\n\t--bs-table-bg: #ffdddd;\n\t--bs-table-striped-bg: #f2d2d2;\n\t--bs-table-striped-color: #000;\n\t--bs-table-active-bg: #e6c7c7;\n\t--bs-table-active-color: #000;\n\t--bs-table-hover-bg: #eccccc;\n\t--bs-table-hover-color: #000;\n\tcolor: #000;\n\tborder-color: #e6c7c7;\n}\n\n.table-light {\n\t--bs-table-bg: #ebebf9;\n\t--bs-table-striped-bg: #dfdfed;\n\t--bs-table-striped-color: #000;\n\t--bs-table-active-bg: #d4d4e0;\n\t--bs-table-active-color: #000;\n\t--bs-table-hover-bg: #d9d9e6;\n\t--bs-table-hover-color: #000;\n\tcolor: #000;\n\tborder-color: #d4d4e0;\n}\n\n.table-dark {\n\t--bs-table-bg: #303972;\n\t--bs-table-striped-bg: #3a4379;\n\t--bs-table-striped-color: #fff;\n\t--bs-table-active-bg: #454d80;\n\t--bs-table-active-color: #fff;\n\t--bs-table-hover-bg: #40487d;\n\t--bs-table-hover-color: #fff;\n\tcolor: #fff;\n\tborder-color: #454d80;\n}\n\n.table-responsive {\n\toverflow-x: auto;\n\t-webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n\t.table-responsive-sm {\n\t\toverflow-x: auto;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n}\n\n@media (max-width: 767.98px) {\n\t.table-responsive-md {\n\t\toverflow-x: auto;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n}\n\n@media (max-width: 991.98px) {\n\t.table-responsive-lg {\n\t\toverflow-x: auto;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n}\n\n@media (max-width: 1199.98px) {\n\t.table-responsive-xl {\n\t\toverflow-x: auto;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n}\n\n@media (max-width: 1439.98) {\n\t.table-responsive-xxl {\n\t\toverflow-x: auto;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n}\n\n.form-label {\n\tmargin-bottom: 0.5rem;\n}\n\n.col-form-label {\n\tpadding-top: calc(0.6875rem + 1px);\n\tpadding-bottom: calc(0.6875rem + 1px);\n\tmargin-bottom: 0;\n\tfont-size: inherit;\n\tline-height: 1.5;\n}\n\n.col-form-label-lg {\n\tpadding-top: calc(0.5rem + 1px);\n\tpadding-bottom: calc(0.5rem + 1px);\n\tfont-size: 1.09375rem;\n}\n\n.col-form-label-sm {\n\tpadding-top: calc(0.25rem + 1px);\n\tpadding-bottom: calc(0.25rem + 1px);\n\tfont-size: 0.76563rem;\n}\n@media (min-width: 1200px) {\n\t.col-form-label-sm {\n\t\tfont-size: 0.76562rem;\n\t}\n}\n\n.form-text {\n\tmargin-top: 0.25rem;\n\tfont-size: 0.875em;\n\tcolor: #89879f;\n}\n\n.form-control {\n\tdisplay: block;\n\twidth: 100%;\n\tpadding: 0.6875rem 1.25rem;\n\tfont-size: 0.875rem;\n\tfont-weight: 400;\n\tline-height: 1.5;\n\tcolor: #a098ae;\n\tbackground-color: #e6ebee;\n\tbackground-clip: padding-box;\n\tborder: 1px solid #f2f2f2;\n\tappearance: none;\n\tborder-radius: 0.625rem;\n\ttransition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.form-control {\n\t\ttransition: none;\n\t}\n}\n.form-control[type='file'] {\n\toverflow: hidden;\n}\n.form-control[type='file']:not(:disabled):not([readonly]) {\n\tcursor: pointer;\n}\n.form-control:focus {\n\tcolor: #a098ae;\n\tbackground-color: #e6ebee;\n\tborder-color: #a6a2da;\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.25);\n}\n.form-control::-webkit-date-and-time-value {\n\theight: 1.5em;\n}\n.form-control::placeholder {\n\tcolor: #6c757d;\n\topacity: 1;\n}\n.form-control:disabled,\n.form-control[readonly] {\n\tbackground-color: #e9ecef;\n\topacity: 1;\n}\n.form-control::file-selector-button {\n\tpadding: 0.6875rem 1.25rem;\n\tmargin: -0.6875rem -1.25rem;\n\tmargin-inline-end: 1.25rem;\n\tcolor: #a098ae;\n\tbackground-color: #e9ecef;\n\tpointer-events: none;\n\tborder-color: inherit;\n\tborder-style: solid;\n\tborder-width: 0;\n\tborder-inline-end-width: 1px;\n\tborder-radius: 0;\n\ttransition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.form-control::file-selector-button {\n\t\ttransition: none;\n\t}\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n\tbackground-color: #dde0e3;\n}\n.form-control::-webkit-file-upload-button {\n\tpadding: 0.6875rem 1.25rem;\n\tmargin: -0.6875rem -1.25rem;\n\tmargin-inline-end: 1.25rem;\n\tcolor: #a098ae;\n\tbackground-color: #e9ecef;\n\tpointer-events: none;\n\tborder-color: inherit;\n\tborder-style: solid;\n\tborder-width: 0;\n\tborder-inline-end-width: 1px;\n\tborder-radius: 0;\n\ttransition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.form-control::-webkit-file-upload-button {\n\t\ttransition: none;\n\t}\n}\n.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n\tbackground-color: #dde0e3;\n}\n\n.form-control-plaintext {\n\tdisplay: block;\n\twidth: 100%;\n\tpadding: 0.6875rem 0;\n\tmargin-bottom: 0;\n\tline-height: 1.5;\n\tcolor: #a098ae;\n\tbackground-color: transparent;\n\tborder: solid transparent;\n\tborder-width: 1px 0;\n}\n.form-control-plaintext.form-control-sm,\n.form-control-plaintext.form-control-lg {\n\tpadding-right: 0;\n\tpadding-left: 0;\n}\n\n.form-control-sm {\n\tmin-height: calc(1.5em + 0.5rem + 2px);\n\tpadding: 0.25rem 0.5rem;\n\tfont-size: 0.76563rem;\n\tborder-radius: 0.625rem;\n}\n@media (min-width: 1200px) {\n\t.form-control-sm {\n\t\tfont-size: 0.76562rem;\n\t}\n}\n.form-control-sm::file-selector-button {\n\tpadding: 0.25rem 0.5rem;\n\tmargin: -0.25rem -0.5rem;\n\tmargin-inline-end: 0.5rem;\n}\n.form-control-sm::-webkit-file-upload-button {\n\tpadding: 0.25rem 0.5rem;\n\tmargin: -0.25rem -0.5rem;\n\tmargin-inline-end: 0.5rem;\n}\n\n.form-control-lg {\n\tmin-height: calc(1.5em + 1rem + 2px);\n\tpadding: 0.5rem 1rem;\n\tfont-size: 1.09375rem;\n\tborder-radius: 0.625rem;\n}\n.form-control-lg::file-selector-button {\n\tpadding: 0.5rem 1rem;\n\tmargin: -0.5rem -1rem;\n\tmargin-inline-end: 1rem;\n}\n.form-control-lg::-webkit-file-upload-button {\n\tpadding: 0.5rem 1rem;\n\tmargin: -0.5rem -1rem;\n\tmargin-inline-end: 1rem;\n}\n\ntextarea.form-control {\n\tmin-height: calc(1.5em + 1.375rem + 2px);\n}\n\ntextarea.form-control-sm {\n\tmin-height: calc(1.5em + 0.5rem + 2px);\n}\n\ntextarea.form-control-lg {\n\tmin-height: calc(1.5em + 1rem + 2px);\n}\n\n.form-control-color {\n\twidth: 3rem;\n\theight: auto;\n\tpadding: 0.6875rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n\tcursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n\theight: 1.5em;\n\tborder-radius: 0.625rem;\n}\n.form-control-color::-webkit-color-swatch {\n\theight: 1.5em;\n\tborder-radius: 0.625rem;\n}\n\n.form-select {\n\tdisplay: block;\n\twidth: 100%;\n\tpadding: 0.6875rem 3.75rem 0.6875rem 1.25rem;\n\t-moz-padding-start: calc(1.25rem - 3px);\n\tfont-size: 0.875rem;\n\tfont-weight: 400;\n\tline-height: 1.5;\n\tcolor: #a098ae;\n\tbackground-color: #e6ebee;\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n\tbackground-repeat: no-repeat;\n\tbackground-position: right 1.25rem center;\n\tbackground-size: 16px 12px;\n\tborder: 1px solid #f2f2f2;\n\tborder-radius: 0.625rem;\n\ttransition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\tappearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.form-select {\n\t\ttransition: none;\n\t}\n}\n.form-select:focus {\n\tborder-color: #a6a2da;\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.25);\n}\n.form-select[multiple],\n.form-select[size]:not([size='1']) {\n\tpadding-right: 1.25rem;\n\tbackground-image: none;\n}\n.form-select:disabled {\n\tbackground-color: #e9ecef;\n}\n.form-select:-moz-focusring {\n\tcolor: transparent;\n\ttext-shadow: 0 0 0 #a098ae;\n}\n\n.form-select-sm {\n\tpadding-top: 0.25rem;\n\tpadding-bottom: 0.25rem;\n\tpadding-left: 0.5rem;\n\tfont-size: 0.76563rem;\n\tborder-radius: 0.625rem;\n}\n@media (min-width: 1200px) {\n\t.form-select-sm {\n\t\tfont-size: 0.76562rem;\n\t}\n}\n\n.form-select-lg {\n\tpadding-top: 0.5rem;\n\tpadding-bottom: 0.5rem;\n\tpadding-left: 1rem;\n\tfont-size: 1.09375rem;\n\tborder-radius: 0.625rem;\n}\n\n.form-check {\n\tdisplay: block;\n\tmin-height: 1.3125rem;\n\tpadding-left: 1.5em;\n\tmargin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n\tfloat: left;\n\tmargin-left: -1.5em;\n}\n\n.form-check-input {\n\twidth: 1em;\n\theight: 1em;\n\tmargin-top: 0.25em;\n\tvertical-align: top;\n\tbackground-color: #e6ebee;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: contain;\n\tborder: 1px solid rgba(0, 0, 0, 0.25);\n\tappearance: none;\n\tprint-color-adjust: exact;\n}\n.form-check-input[type='checkbox'] {\n\tborder-radius: 0.25em;\n}\n.form-check-input[type='radio'] {\n\tborder-radius: 50%;\n}\n.form-check-input:active {\n\tfilter: brightness(90%);\n}\n.form-check-input:focus {\n\tborder-color: #a6a2da;\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.25);\n}\n.form-check-input:checked {\n\tbackground-color: #4d44b5;\n\tborder-color: #4d44b5;\n}\n.form-check-input:checked[type='checkbox'] {\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type='radio'] {\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23fff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type='checkbox']:indeterminate {\n\tbackground-color: #4d44b5;\n\tborder-color: #4d44b5;\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n\tpointer-events: none;\n\tfilter: none;\n\topacity: 1;\n}\n.form-check-input[disabled] ~ .form-check-label,\n.form-check-input:disabled ~ .form-check-label {\n\topacity: 1;\n}\n\n.form-switch {\n\tpadding-left: 2.5em;\n}\n.form-switch .form-check-input {\n\twidth: 2.5em;\n\tmargin-left: -2.5em;\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23a6a2da'/%3e%3c/svg%3e\");\n\t/* background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\"); */\n\tbackground-position: left center;\n\tborder-radius: 2em;\n\ttransition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.form-switch .form-check-input {\n\t\ttransition: none;\n\t}\n}\n.form-switch .form-check-input:focus {\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23a6a2da'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n\tbackground-position: right center;\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n\n.form-check-inline {\n\tdisplay: inline-block;\n\tmargin-right: 1rem;\n}\n\n.btn-check {\n\tposition: absolute;\n\tclip: rect(0, 0, 0, 0);\n\tpointer-events: none;\n}\n.btn-check[disabled] + .btn,\n.btn-check:disabled + .btn {\n\tpointer-events: none;\n\tfilter: none;\n\topacity: 0.65;\n}\n\n.form-range {\n\twidth: 100%;\n\theight: 1.5rem;\n\tpadding: 0;\n\tbackground-color: transparent;\n\tappearance: none;\n}\n.form-range:focus {\n\toutline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n\tbox-shadow: 0 0 0 1px #e6ebee, 0 0 0 0.25rem rgba(77, 68, 181, 0.25);\n}\n.form-range:focus::-moz-range-thumb {\n\tbox-shadow: 0 0 0 1px #e6ebee, 0 0 0 0.25rem rgba(77, 68, 181, 0.25);\n}\n.form-range::-moz-focus-outer {\n\tborder: 0;\n}\n.form-range::-webkit-slider-thumb {\n\twidth: 1rem;\n\theight: 1rem;\n\tmargin-top: -0.25rem;\n\tbackground-color: #4d44b5;\n\tborder: 0;\n\tborder-radius: 1rem;\n\ttransition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\tappearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.form-range::-webkit-slider-thumb {\n\t\ttransition: none;\n\t}\n}\n.form-range::-webkit-slider-thumb:active {\n\tbackground-color: #cac7e9;\n}\n.form-range::-webkit-slider-runnable-track {\n\twidth: 100%;\n\theight: 0.5rem;\n\tcolor: transparent;\n\tcursor: pointer;\n\tbackground-color: #dee2e6;\n\tborder-color: transparent;\n\tborder-radius: 1rem;\n}\n.form-range::-moz-range-thumb {\n\twidth: 1rem;\n\theight: 1rem;\n\tbackground-color: #4d44b5;\n\tborder: 0;\n\tborder-radius: 1rem;\n\ttransition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n\tappearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.form-range::-moz-range-thumb {\n\t\ttransition: none;\n\t}\n}\n.form-range::-moz-range-thumb:active {\n\tbackground-color: #cac7e9;\n}\n.form-range::-moz-range-track {\n\twidth: 100%;\n\theight: 0.5rem;\n\tcolor: transparent;\n\tcursor: pointer;\n\tbackground-color: #dee2e6;\n\tborder-color: transparent;\n\tborder-radius: 1rem;\n}\n.form-range:disabled {\n\tpointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n\tbackground-color: #adb5bd;\n}\n.form-range:disabled::-moz-range-thumb {\n\tbackground-color: #adb5bd;\n}\n\n.form-floating {\n\tposition: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-select {\n\theight: calc(3.5rem + 2px);\n\tline-height: 1.25;\n}\n.form-floating > label {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\theight: 100%;\n\tpadding: 1rem 1.25rem;\n\tpointer-events: none;\n\tborder: 1px solid transparent;\n\ttransform-origin: 0 0;\n\ttransition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.form-floating > label {\n\t\ttransition: none;\n\t}\n}\n.form-floating > .form-control {\n\tpadding: 1rem 1.25rem;\n}\n.form-floating > .form-control::placeholder {\n\tcolor: transparent;\n}\n.form-floating > .form-control:focus,\n.form-floating > .form-control:not(:placeholder-shown) {\n\tpadding-top: 1.625rem;\n\tpadding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill {\n\tpadding-top: 1.625rem;\n\tpadding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n\tpadding-top: 1.625rem;\n\tpadding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-select ~ label {\n\topacity: 0.65;\n\ttransform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n\topacity: 0.65;\n\ttransform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n\n.input-group {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: stretch;\n\twidth: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select {\n\tposition: relative;\n\tflex: 1 1 auto;\n\twidth: 1%;\n\tmin-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus {\n\tz-index: 3;\n}\n.input-group .btn {\n\tposition: relative;\n\tz-index: 2;\n}\n.input-group .btn:focus {\n\tz-index: 3;\n}\n\n.input-group-text {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0.6875rem 1.25rem;\n\tfont-size: 0.875rem;\n\tfont-weight: 400;\n\tline-height: 1.5;\n\tcolor: #a098ae;\n\ttext-align: center;\n\twhite-space: nowrap;\n\tbackground-color: #e9ecef;\n\tborder: 1px solid #f2f2f2;\n\tborder-radius: 0.625rem;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n\tpadding: 0.5rem 1rem;\n\tfont-size: 1.09375rem;\n\tborder-radius: 0.625rem;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n\tpadding: 0.25rem 0.5rem;\n\tfont-size: 0.76563rem;\n\tborder-radius: 0.625rem;\n}\n@media (min-width: 1200px) {\n\t.input-group-sm > .form-control,\n\t.input-group-sm > .form-select,\n\t.input-group-sm > .input-group-text,\n\t.input-group-sm > .btn {\n\t\tfont-size: 0.76562rem;\n\t}\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n\tpadding-right: 5rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3) {\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n.input-group.has-validation > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4) {\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n.input-group\n\t> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n\tmargin-left: -1px;\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n\tdisplay: none;\n\twidth: 100%;\n\tmargin-top: 0.25rem;\n\tfont-size: 0.875em;\n\tcolor: #1eba62;\n}\n\n.valid-tooltip {\n\tposition: absolute;\n\ttop: 100%;\n\tz-index: 5;\n\tdisplay: none;\n\tmax-width: 100%;\n\tpadding: 0.25rem 0.5rem;\n\tmargin-top: 0.1rem;\n\tfont-size: 0.76563rem;\n\tcolor: #000;\n\tbackground-color: rgba(30, 186, 98, 0.9);\n\tborder-radius: 0.625rem;\n}\n@media (min-width: 1200px) {\n\t.valid-tooltip {\n\t\tfont-size: 0.76562rem;\n\t}\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n\tdisplay: block;\n}\n\n.was-validated .form-control:valid,\n.form-control.is-valid {\n\tborder-color: #1eba62;\n\tpadding-right: calc(1.5em + 1.375rem);\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%231EBA62' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n\tbackground-repeat: no-repeat;\n\tbackground-position: right calc(0.375em + 0.34375rem) center;\n\tbackground-size: calc(0.75em + 0.6875rem) calc(0.75em + 0.6875rem);\n}\n.was-validated .form-control:valid:focus,\n.form-control.is-valid:focus {\n\tborder-color: #1eba62;\n\tbox-shadow: 0 0 0 0.25rem rgba(30, 186, 98, 0.25);\n}\n\n.was-validated textarea.form-control:valid,\ntextarea.form-control.is-valid {\n\tpadding-right: calc(1.5em + 1.375rem);\n\tbackground-position: top calc(0.375em + 0.34375rem) right calc(0.375em + 0.34375rem);\n}\n\n.was-validated .form-select:valid,\n.form-select.is-valid {\n\tborder-color: #1eba62;\n}\n.was-validated .form-select:valid:not([multiple]):not([size]),\n.was-validated .form-select:valid:not([multiple])[size='1'],\n.form-select.is-valid:not([multiple]):not([size]),\n.form-select.is-valid:not([multiple])[size='1'] {\n\tpadding-right: 6.875rem;\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\"),\n\t\turl(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%231EBA62' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n\tbackground-position: right 1.25rem center, center right 3.75rem;\n\tbackground-size: 16px 12px, calc(0.75em + 0.6875rem) calc(0.75em + 0.6875rem);\n}\n.was-validated .form-select:valid:focus,\n.form-select.is-valid:focus {\n\tborder-color: #1eba62;\n\tbox-shadow: 0 0 0 0.25rem rgba(30, 186, 98, 0.25);\n}\n\n.was-validated .form-check-input:valid,\n.form-check-input.is-valid {\n\tborder-color: #1eba62;\n}\n.was-validated .form-check-input:valid:checked,\n.form-check-input.is-valid:checked {\n\tbackground-color: #1eba62;\n}\n.was-validated .form-check-input:valid:focus,\n.form-check-input.is-valid:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(30, 186, 98, 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label,\n.form-check-input.is-valid ~ .form-check-label {\n\tcolor: #1eba62;\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n\tmargin-left: 0.5em;\n}\n\n.was-validated .input-group .form-control:valid,\n.input-group .form-control.is-valid,\n.was-validated .input-group .form-select:valid,\n.input-group .form-select.is-valid {\n\tz-index: 1;\n}\n.was-validated .input-group .form-control:valid:focus,\n.input-group .form-control.is-valid:focus,\n.was-validated .input-group .form-select:valid:focus,\n.input-group .form-select.is-valid:focus {\n\tz-index: 3;\n}\n\n.invalid-feedback {\n\tdisplay: none;\n\twidth: 100%;\n\tmargin-top: 0.25rem;\n\tfont-size: 0.875em;\n\tcolor: #fd5353;\n}\n\n.invalid-tooltip {\n\tposition: absolute;\n\ttop: 100%;\n\tz-index: 5;\n\tdisplay: none;\n\tmax-width: 100%;\n\tpadding: 0.25rem 0.5rem;\n\tmargin-top: 0.1rem;\n\tfont-size: 0.76563rem;\n\tcolor: #000;\n\tbackground-color: rgba(253, 83, 83, 0.9);\n\tborder-radius: 0.625rem;\n}\n@media (min-width: 1200px) {\n\t.invalid-tooltip {\n\t\tfont-size: 0.76562rem;\n\t}\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n\tdisplay: block;\n}\n\n.was-validated .form-control:invalid,\n.form-control.is-invalid {\n\tborder-color: #fd5353;\n\tpadding-right: calc(1.5em + 1.375rem);\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23fd5353'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23fd5353' stroke='none'/%3e%3c/svg%3e\");\n\tbackground-repeat: no-repeat;\n\tbackground-position: right calc(0.375em + 0.34375rem) center;\n\tbackground-size: calc(0.75em + 0.6875rem) calc(0.75em + 0.6875rem);\n}\n.was-validated .form-control:invalid:focus,\n.form-control.is-invalid:focus {\n\tborder-color: #fd5353;\n\tbox-shadow: 0 0 0 0.25rem rgba(253, 83, 83, 0.25);\n}\n\n.was-validated textarea.form-control:invalid,\ntextarea.form-control.is-invalid {\n\tpadding-right: calc(1.5em + 1.375rem);\n\tbackground-position: top calc(0.375em + 0.34375rem) right calc(0.375em + 0.34375rem);\n}\n\n.was-validated .form-select:invalid,\n.form-select.is-invalid {\n\tborder-color: #fd5353;\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]),\n.was-validated .form-select:invalid:not([multiple])[size='1'],\n.form-select.is-invalid:not([multiple]):not([size]),\n.form-select.is-invalid:not([multiple])[size='1'] {\n\tpadding-right: 6.875rem;\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\"),\n\t\turl(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23fd5353'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23fd5353' stroke='none'/%3e%3c/svg%3e\");\n\tbackground-position: right 1.25rem center, center right 3.75rem;\n\tbackground-size: 16px 12px, calc(0.75em + 0.6875rem) calc(0.75em + 0.6875rem);\n}\n.was-validated .form-select:invalid:focus,\n.form-select.is-invalid:focus {\n\tborder-color: #fd5353;\n\tbox-shadow: 0 0 0 0.25rem rgba(253, 83, 83, 0.25);\n}\n\n.was-validated .form-check-input:invalid,\n.form-check-input.is-invalid {\n\tborder-color: #fd5353;\n}\n.was-validated .form-check-input:invalid:checked,\n.form-check-input.is-invalid:checked {\n\tbackground-color: #fd5353;\n}\n.was-validated .form-check-input:invalid:focus,\n.form-check-input.is-invalid:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(253, 83, 83, 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label,\n.form-check-input.is-invalid ~ .form-check-label {\n\tcolor: #fd5353;\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n\tmargin-left: 0.5em;\n}\n\n.was-validated .input-group .form-control:invalid,\n.input-group .form-control.is-invalid,\n.was-validated .input-group .form-select:invalid,\n.input-group .form-select.is-invalid {\n\tz-index: 2;\n}\n.was-validated .input-group .form-control:invalid:focus,\n.input-group .form-control.is-invalid:focus,\n.was-validated .input-group .form-select:invalid:focus,\n.input-group .form-select.is-invalid:focus {\n\tz-index: 3;\n}\n\n.btn {\n\tdisplay: inline-block;\n\tfont-weight: 400;\n\tline-height: 1.5;\n\tcolor: #a098ae;\n\ttext-align: center;\n\ttext-decoration: none;\n\tvertical-align: middle;\n\tcursor: pointer;\n\tuser-select: none;\n\tbackground-color: transparent;\n\tborder: 1px solid transparent;\n\tpadding: 0.375rem 0.75rem;\n\tfont-size: 0.875rem;\n\tborder-radius: 0.625rem;\n\ttransition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.btn {\n\t\ttransition: none;\n\t}\n}\n.btn:hover {\n\tcolor: #a098ae;\n}\n.btn-check:focus + .btn,\n.btn:focus {\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.25);\n}\n.btn:disabled,\n.btn.disabled,\nfieldset:disabled .btn {\n\tpointer-events: none;\n\topacity: 0.65;\n}\n\n.btn-primary {\n\tcolor: #fff;\n\tbackground-color: #4d44b5;\n\tborder-color: #4d44b5;\n}\n.btn-primary:hover {\n\tcolor: #fff;\n\tbackground-color: #413a9a;\n\tborder-color: #3e3691;\n}\n.btn-check:focus + .btn-primary,\n.btn-primary:focus {\n\tcolor: #fff;\n\tbackground-color: #413a9a;\n\tborder-color: #3e3691;\n\tbox-shadow: 0 0 0 0.25rem rgba(104, 96, 192, 0.5);\n}\n.btn-check:checked + .btn-primary,\n.btn-check:active + .btn-primary,\n.btn-primary:active,\n.btn-primary.active,\n.show > .btn-primary.dropdown-toggle {\n\tcolor: #fff;\n\tbackground-color: #3e3691;\n\tborder-color: #3a3388;\n}\n.btn-check:checked + .btn-primary:focus,\n.btn-check:active + .btn-primary:focus,\n.btn-primary:active:focus,\n.btn-primary.active:focus,\n.show > .btn-primary.dropdown-toggle:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(104, 96, 192, 0.5);\n}\n.btn-primary:disabled,\n.btn-primary.disabled {\n\tcolor: #fff;\n\tbackground-color: #4d44b5;\n\tborder-color: #4d44b5;\n}\n\n.btn-secondary {\n\tcolor: #000;\n\tbackground-color: #fb7d5b;\n\tborder-color: #fb7d5b;\n}\n.btn-secondary:hover {\n\tcolor: #000;\n\tbackground-color: #fc9174;\n\tborder-color: #fb8a6b;\n}\n.btn-check:focus + .btn-secondary,\n.btn-secondary:focus {\n\tcolor: #000;\n\tbackground-color: #fc9174;\n\tborder-color: #fb8a6b;\n\tbox-shadow: 0 0 0 0.25rem rgba(213, 106, 77, 0.5);\n}\n.btn-check:checked + .btn-secondary,\n.btn-check:active + .btn-secondary,\n.btn-secondary:active,\n.btn-secondary.active,\n.show > .btn-secondary.dropdown-toggle {\n\tcolor: #000;\n\tbackground-color: #fc977c;\n\tborder-color: #fb8a6b;\n}\n.btn-check:checked + .btn-secondary:focus,\n.btn-check:active + .btn-secondary:focus,\n.btn-secondary:active:focus,\n.btn-secondary.active:focus,\n.show > .btn-secondary.dropdown-toggle:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(213, 106, 77, 0.5);\n}\n.btn-secondary:disabled,\n.btn-secondary.disabled {\n\tcolor: #000;\n\tbackground-color: #fb7d5b;\n\tborder-color: #fb7d5b;\n}\n\n.btn-success {\n\tcolor: #000;\n\tbackground-color: #1eba62;\n\tborder-color: #1eba62;\n}\n.btn-success:hover {\n\tcolor: #000;\n\tbackground-color: #40c47a;\n\tborder-color: #35c172;\n}\n.btn-check:focus + .btn-success,\n.btn-success:focus {\n\tcolor: #000;\n\tbackground-color: #40c47a;\n\tborder-color: #35c172;\n\tbox-shadow: 0 0 0 0.25rem rgba(26, 158, 83, 0.5);\n}\n.btn-check:checked + .btn-success,\n.btn-check:active + .btn-success,\n.btn-success:active,\n.btn-success.active,\n.show > .btn-success.dropdown-toggle {\n\tcolor: #000;\n\tbackground-color: #4bc881;\n\tborder-color: #35c172;\n}\n.btn-check:checked + .btn-success:focus,\n.btn-check:active + .btn-success:focus,\n.btn-success:active:focus,\n.btn-success.active:focus,\n.show > .btn-success.dropdown-toggle:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(26, 158, 83, 0.5);\n}\n.btn-success:disabled,\n.btn-success.disabled {\n\tcolor: #000;\n\tbackground-color: #1eba62;\n\tborder-color: #1eba62;\n}\n\n.btn-info {\n\tcolor: #000;\n\tbackground-color: #00ada3;\n\tborder-color: #00ada3;\n}\n.btn-info:hover {\n\tcolor: #000;\n\tbackground-color: #26b9b1;\n\tborder-color: #1ab5ac;\n}\n.btn-check:focus + .btn-info,\n.btn-info:focus {\n\tcolor: #000;\n\tbackground-color: #26b9b1;\n\tborder-color: #1ab5ac;\n\tbox-shadow: 0 0 0 0.25rem rgba(0, 147, 139, 0.5);\n}\n.btn-check:checked + .btn-info,\n.btn-check:active + .btn-info,\n.btn-info:active,\n.btn-info.active,\n.show > .btn-info.dropdown-toggle {\n\tcolor: #000;\n\tbackground-color: #33bdb5;\n\tborder-color: #1ab5ac;\n}\n.btn-check:checked + .btn-info:focus,\n.btn-check:active + .btn-info:focus,\n.btn-info:active:focus,\n.btn-info.active:focus,\n.show > .btn-info.dropdown-toggle:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(0, 147, 139, 0.5);\n}\n.btn-info:disabled,\n.btn-info.disabled {\n\tcolor: #000;\n\tbackground-color: #00ada3;\n\tborder-color: #00ada3;\n}\n\n.btn-warning {\n\tcolor: #000;\n\tbackground-color: #fcc43e;\n\tborder-color: #fcc43e;\n}\n.btn-warning:hover {\n\tcolor: #000;\n\tbackground-color: #fccd5b;\n\tborder-color: #fcca51;\n}\n.btn-check:focus + .btn-warning,\n.btn-warning:focus {\n\tcolor: #000;\n\tbackground-color: #fccd5b;\n\tborder-color: #fcca51;\n\tbox-shadow: 0 0 0 0.25rem rgba(214, 167, 53, 0.5);\n}\n.btn-check:checked + .btn-warning,\n.btn-check:active + .btn-warning,\n.btn-warning:active,\n.btn-warning.active,\n.show > .btn-warning.dropdown-toggle {\n\tcolor: #000;\n\tbackground-color: #fdd065;\n\tborder-color: #fcca51;\n}\n.btn-check:checked + .btn-warning:focus,\n.btn-check:active + .btn-warning:focus,\n.btn-warning:active:focus,\n.btn-warning.active:focus,\n.show > .btn-warning.dropdown-toggle:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(214, 167, 53, 0.5);\n}\n.btn-warning:disabled,\n.btn-warning.disabled {\n\tcolor: #000;\n\tbackground-color: #fcc43e;\n\tborder-color: #fcc43e;\n}\n\n.btn-danger {\n\tcolor: #000;\n\tbackground-color: #fd5353;\n\tborder-color: #fd5353;\n}\n.btn-danger:hover {\n\tcolor: #000;\n\tbackground-color: #fd6d6d;\n\tborder-color: #fd6464;\n}\n.btn-check:focus + .btn-danger,\n.btn-danger:focus {\n\tcolor: #000;\n\tbackground-color: #fd6d6d;\n\tborder-color: #fd6464;\n\tbox-shadow: 0 0 0 0.25rem rgba(215, 71, 71, 0.5);\n}\n.btn-check:checked + .btn-danger,\n.btn-check:active + .btn-danger,\n.btn-danger:active,\n.btn-danger.active,\n.show > .btn-danger.dropdown-toggle {\n\tcolor: #000;\n\tbackground-color: #fd7575;\n\tborder-color: #fd6464;\n}\n.btn-check:checked + .btn-danger:focus,\n.btn-check:active + .btn-danger:focus,\n.btn-danger:active:focus,\n.btn-danger.active:focus,\n.show > .btn-danger.dropdown-toggle:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(215, 71, 71, 0.5);\n}\n.btn-danger:disabled,\n.btn-danger.disabled {\n\tcolor: #000;\n\tbackground-color: #fd5353;\n\tborder-color: #fd5353;\n}\n\n.btn-light {\n\tcolor: #000;\n\tbackground-color: #ebebf9;\n\tborder-color: #ebebf9;\n}\n.btn-light:hover {\n\tcolor: #000;\n\tbackground-color: #eeeefa;\n\tborder-color: #ededfa;\n}\n.btn-check:focus + .btn-light,\n.btn-light:focus {\n\tcolor: #000;\n\tbackground-color: #eeeefa;\n\tborder-color: #ededfa;\n\tbox-shadow: 0 0 0 0.25rem rgba(200, 200, 212, 0.5);\n}\n.btn-check:checked + .btn-light,\n.btn-check:active + .btn-light,\n.btn-light:active,\n.btn-light.active,\n.show > .btn-light.dropdown-toggle {\n\tcolor: #000;\n\tbackground-color: #efeffa;\n\tborder-color: #ededfa;\n}\n.btn-check:checked + .btn-light:focus,\n.btn-check:active + .btn-light:focus,\n.btn-light:active:focus,\n.btn-light.active:focus,\n.show > .btn-light.dropdown-toggle:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(200, 200, 212, 0.5);\n}\n.btn-light:disabled,\n.btn-light.disabled {\n\tcolor: #000;\n\tbackground-color: #ebebf9;\n\tborder-color: #ebebf9;\n}\n\n.btn-dark {\n\tcolor: #fff;\n\tbackground-color: #303972;\n\tborder-color: #303972;\n}\n.btn-dark:hover {\n\tcolor: #fff;\n\tbackground-color: #293061;\n\tborder-color: #262e5b;\n}\n.btn-check:focus + .btn-dark,\n.btn-dark:focus {\n\tcolor: #fff;\n\tbackground-color: #293061;\n\tborder-color: #262e5b;\n\tbox-shadow: 0 0 0 0.25rem rgba(79, 87, 135, 0.5);\n}\n.btn-check:checked + .btn-dark,\n.btn-check:active + .btn-dark,\n.btn-dark:active,\n.btn-dark.active,\n.show > .btn-dark.dropdown-toggle {\n\tcolor: #fff;\n\tbackground-color: #262e5b;\n\tborder-color: #242b56;\n}\n.btn-check:checked + .btn-dark:focus,\n.btn-check:active + .btn-dark:focus,\n.btn-dark:active:focus,\n.btn-dark.active:focus,\n.show > .btn-dark.dropdown-toggle:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(79, 87, 135, 0.5);\n}\n.btn-dark:disabled,\n.btn-dark.disabled {\n\tcolor: #fff;\n\tbackground-color: #303972;\n\tborder-color: #303972;\n}\n\n.btn-outline-primary {\n\tcolor: #4d44b5;\n\tborder-color: #4d44b5;\n}\n.btn-outline-primary:hover {\n\tcolor: #fff;\n\tbackground-color: #4d44b5;\n\tborder-color: #4d44b5;\n}\n.btn-check:focus + .btn-outline-primary,\n.btn-outline-primary:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.5);\n}\n.btn-check:checked + .btn-outline-primary,\n.btn-check:active + .btn-outline-primary,\n.btn-outline-primary:active,\n.btn-outline-primary.active,\n.btn-outline-primary.dropdown-toggle.show {\n\tcolor: #fff;\n\tbackground-color: #4d44b5;\n\tborder-color: #4d44b5;\n}\n.btn-check:checked + .btn-outline-primary:focus,\n.btn-check:active + .btn-outline-primary:focus,\n.btn-outline-primary:active:focus,\n.btn-outline-primary.active:focus,\n.btn-outline-primary.dropdown-toggle.show:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.5);\n}\n.btn-outline-primary:disabled,\n.btn-outline-primary.disabled {\n\tcolor: #4d44b5;\n\tbackground-color: transparent;\n}\n\n.btn-outline-secondary {\n\tcolor: #fb7d5b;\n\tborder-color: #fb7d5b;\n}\n.btn-outline-secondary:hover {\n\tcolor: #000;\n\tbackground-color: #fb7d5b;\n\tborder-color: #fb7d5b;\n}\n.btn-check:focus + .btn-outline-secondary,\n.btn-outline-secondary:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(251, 125, 91, 0.5);\n}\n.btn-check:checked + .btn-outline-secondary,\n.btn-check:active + .btn-outline-secondary,\n.btn-outline-secondary:active,\n.btn-outline-secondary.active,\n.btn-outline-secondary.dropdown-toggle.show {\n\tcolor: #000;\n\tbackground-color: #fb7d5b;\n\tborder-color: #fb7d5b;\n}\n.btn-check:checked + .btn-outline-secondary:focus,\n.btn-check:active + .btn-outline-secondary:focus,\n.btn-outline-secondary:active:focus,\n.btn-outline-secondary.active:focus,\n.btn-outline-secondary.dropdown-toggle.show:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(251, 125, 91, 0.5);\n}\n.btn-outline-secondary:disabled,\n.btn-outline-secondary.disabled {\n\tcolor: #fb7d5b;\n\tbackground-color: transparent;\n}\n\n.btn-outline-success {\n\tcolor: #1eba62;\n\tborder-color: #1eba62;\n}\n.btn-outline-success:hover {\n\tcolor: #000;\n\tbackground-color: #1eba62;\n\tborder-color: #1eba62;\n}\n.btn-check:focus + .btn-outline-success,\n.btn-outline-success:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(30, 186, 98, 0.5);\n}\n.btn-check:checked + .btn-outline-success,\n.btn-check:active + .btn-outline-success,\n.btn-outline-success:active,\n.btn-outline-success.active,\n.btn-outline-success.dropdown-toggle.show {\n\tcolor: #000;\n\tbackground-color: #1eba62;\n\tborder-color: #1eba62;\n}\n.btn-check:checked + .btn-outline-success:focus,\n.btn-check:active + .btn-outline-success:focus,\n.btn-outline-success:active:focus,\n.btn-outline-success.active:focus,\n.btn-outline-success.dropdown-toggle.show:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(30, 186, 98, 0.5);\n}\n.btn-outline-success:disabled,\n.btn-outline-success.disabled {\n\tcolor: #1eba62;\n\tbackground-color: transparent;\n}\n\n.btn-outline-info {\n\tcolor: #00ada3;\n\tborder-color: #00ada3;\n}\n.btn-outline-info:hover {\n\tcolor: #000;\n\tbackground-color: #00ada3;\n\tborder-color: #00ada3;\n}\n.btn-check:focus + .btn-outline-info,\n.btn-outline-info:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(0, 173, 163, 0.5);\n}\n.btn-check:checked + .btn-outline-info,\n.btn-check:active + .btn-outline-info,\n.btn-outline-info:active,\n.btn-outline-info.active,\n.btn-outline-info.dropdown-toggle.show {\n\tcolor: #000;\n\tbackground-color: #00ada3;\n\tborder-color: #00ada3;\n}\n.btn-check:checked + .btn-outline-info:focus,\n.btn-check:active + .btn-outline-info:focus,\n.btn-outline-info:active:focus,\n.btn-outline-info.active:focus,\n.btn-outline-info.dropdown-toggle.show:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(0, 173, 163, 0.5);\n}\n.btn-outline-info:disabled,\n.btn-outline-info.disabled {\n\tcolor: #00ada3;\n\tbackground-color: transparent;\n}\n\n.btn-outline-warning {\n\tcolor: #fcc43e;\n\tborder-color: #fcc43e;\n}\n.btn-outline-warning:hover {\n\tcolor: #000;\n\tbackground-color: #fcc43e;\n\tborder-color: #fcc43e;\n}\n.btn-check:focus + .btn-outline-warning,\n.btn-outline-warning:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(252, 196, 62, 0.5);\n}\n.btn-check:checked + .btn-outline-warning,\n.btn-check:active + .btn-outline-warning,\n.btn-outline-warning:active,\n.btn-outline-warning.active,\n.btn-outline-warning.dropdown-toggle.show {\n\tcolor: #000;\n\tbackground-color: #fcc43e;\n\tborder-color: #fcc43e;\n}\n.btn-check:checked + .btn-outline-warning:focus,\n.btn-check:active + .btn-outline-warning:focus,\n.btn-outline-warning:active:focus,\n.btn-outline-warning.active:focus,\n.btn-outline-warning.dropdown-toggle.show:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(252, 196, 62, 0.5);\n}\n.btn-outline-warning:disabled,\n.btn-outline-warning.disabled {\n\tcolor: #fcc43e;\n\tbackground-color: transparent;\n}\n\n.btn-outline-danger {\n\tcolor: #fd5353;\n\tborder-color: #fd5353;\n}\n.btn-outline-danger:hover {\n\tcolor: #000;\n\tbackground-color: #fd5353;\n\tborder-color: #fd5353;\n}\n.btn-check:focus + .btn-outline-danger,\n.btn-outline-danger:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(253, 83, 83, 0.5);\n}\n.btn-check:checked + .btn-outline-danger,\n.btn-check:active + .btn-outline-danger,\n.btn-outline-danger:active,\n.btn-outline-danger.active,\n.btn-outline-danger.dropdown-toggle.show {\n\tcolor: #000;\n\tbackground-color: #fd5353;\n\tborder-color: #fd5353;\n}\n.btn-check:checked + .btn-outline-danger:focus,\n.btn-check:active + .btn-outline-danger:focus,\n.btn-outline-danger:active:focus,\n.btn-outline-danger.active:focus,\n.btn-outline-danger.dropdown-toggle.show:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(253, 83, 83, 0.5);\n}\n.btn-outline-danger:disabled,\n.btn-outline-danger.disabled {\n\tcolor: #fd5353;\n\tbackground-color: transparent;\n}\n\n.btn-outline-light {\n\tcolor: #ebebf9;\n\tborder-color: #ebebf9;\n}\n.btn-outline-light:hover {\n\tcolor: #000;\n\tbackground-color: #ebebf9;\n\tborder-color: #ebebf9;\n}\n.btn-check:focus + .btn-outline-light,\n.btn-outline-light:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(235, 235, 249, 0.5);\n}\n.btn-check:checked + .btn-outline-light,\n.btn-check:active + .btn-outline-light,\n.btn-outline-light:active,\n.btn-outline-light.active,\n.btn-outline-light.dropdown-toggle.show {\n\tcolor: #000;\n\tbackground-color: #ebebf9;\n\tborder-color: #ebebf9;\n}\n.btn-check:checked + .btn-outline-light:focus,\n.btn-check:active + .btn-outline-light:focus,\n.btn-outline-light:active:focus,\n.btn-outline-light.active:focus,\n.btn-outline-light.dropdown-toggle.show:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(235, 235, 249, 0.5);\n}\n.btn-outline-light:disabled,\n.btn-outline-light.disabled {\n\tcolor: #ebebf9;\n\tbackground-color: transparent;\n}\n\n.btn-outline-dark {\n\tcolor: #303972;\n\tborder-color: #303972;\n}\n.btn-outline-dark:hover {\n\tcolor: #fff;\n\tbackground-color: #303972;\n\tborder-color: #303972;\n}\n.btn-check:focus + .btn-outline-dark,\n.btn-outline-dark:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(48, 57, 114, 0.5);\n}\n.btn-check:checked + .btn-outline-dark,\n.btn-check:active + .btn-outline-dark,\n.btn-outline-dark:active,\n.btn-outline-dark.active,\n.btn-outline-dark.dropdown-toggle.show {\n\tcolor: #fff;\n\tbackground-color: #303972;\n\tborder-color: #303972;\n}\n.btn-check:checked + .btn-outline-dark:focus,\n.btn-check:active + .btn-outline-dark:focus,\n.btn-outline-dark:active:focus,\n.btn-outline-dark.active:focus,\n.btn-outline-dark.dropdown-toggle.show:focus {\n\tbox-shadow: 0 0 0 0.25rem rgba(48, 57, 114, 0.5);\n}\n.btn-outline-dark:disabled,\n.btn-outline-dark.disabled {\n\tcolor: #303972;\n\tbackground-color: transparent;\n}\n\n.btn-link {\n\tfont-weight: 400;\n\tcolor: #4d44b5;\n\ttext-decoration: underline;\n}\n.btn-link:hover {\n\tcolor: #3e3691;\n}\n.btn-link:disabled,\n.btn-link.disabled {\n\tcolor: #6c757d;\n}\n\n.btn-lg,\n.btn-group-lg > .btn {\n\tpadding: 0.5rem 1rem;\n\tfont-size: 1.09375rem;\n\tborder-radius: 0.625rem;\n}\n\n.btn-sm,\n.btn-group-sm > .btn {\n\tpadding: 0.25rem 0.5rem;\n\tfont-size: 0.76563rem;\n\tborder-radius: 0.625rem;\n}\n@media (min-width: 1200px) {\n\t.btn-sm,\n\t.btn-group-sm > .btn {\n\t\tfont-size: 0.76562rem;\n\t}\n}\n\n.fade {\n\ttransition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.fade {\n\t\ttransition: none;\n\t}\n}\n.fade:not(.show) {\n\topacity: 0;\n}\n\n.collapse:not(.show) {\n\tdisplay: none;\n}\n\n.collapsing {\n\theight: 0;\n\toverflow: hidden;\n\ttransition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.collapsing {\n\t\ttransition: none;\n\t}\n}\n.collapsing.collapse-horizontal {\n\twidth: 0;\n\theight: auto;\n\ttransition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.collapsing.collapse-horizontal {\n\t\ttransition: none;\n\t}\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart {\n\tposition: relative;\n}\n\n.dropdown-toggle {\n\twhite-space: nowrap;\n}\n.dropdown-toggle::after {\n\tdisplay: inline-block;\n\tmargin-left: 0.255em;\n\tvertical-align: 0.255em;\n\tcontent: '';\n\tborder-top: 0.3em solid;\n\tborder-right: 0.3em solid transparent;\n\tborder-bottom: 0;\n\tborder-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n\tmargin-left: 0;\n}\n\n.dropdown-menu {\n\tposition: absolute;\n\tz-index: 1000;\n\tdisplay: none;\n\tmin-width: 10rem;\n\tpadding: 0.5rem 0;\n\tmargin: 0;\n\tfont-size: 0.875rem;\n\tcolor: #a098ae;\n\ttext-align: left;\n\tlist-style: none;\n\tbackground-color: #fff;\n\tbackground-clip: padding-box;\n\tborder: 1px solid rgba(0, 0, 0, 0.15);\n\tborder-radius: 0.625rem;\n}\n.dropdown-menu[data-bs-popper] {\n\ttop: 100%;\n\tleft: 0;\n\tmargin-top: 0.125rem;\n}\n\n.dropdown-menu-start {\n\t--bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n\tright: auto;\n\tleft: 0;\n}\n\n.dropdown-menu-end {\n\t--bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n\tright: 0;\n\tleft: auto;\n}\n\n@media (min-width: 576px) {\n\t.dropdown-menu-sm-start {\n\t\t--bs-position: start;\n\t}\n\t.dropdown-menu-sm-start[data-bs-popper] {\n\t\tright: auto;\n\t\tleft: 0;\n\t}\n\t.dropdown-menu-sm-end {\n\t\t--bs-position: end;\n\t}\n\t.dropdown-menu-sm-end[data-bs-popper] {\n\t\tright: 0;\n\t\tleft: auto;\n\t}\n}\n\n@media (min-width: 768px) {\n\t.dropdown-menu-md-start {\n\t\t--bs-position: start;\n\t}\n\t.dropdown-menu-md-start[data-bs-popper] {\n\t\tright: auto;\n\t\tleft: 0;\n\t}\n\t.dropdown-menu-md-end {\n\t\t--bs-position: end;\n\t}\n\t.dropdown-menu-md-end[data-bs-popper] {\n\t\tright: 0;\n\t\tleft: auto;\n\t}\n}\n\n@media (min-width: 992px) {\n\t.dropdown-menu-lg-start {\n\t\t--bs-position: start;\n\t}\n\t.dropdown-menu-lg-start[data-bs-popper] {\n\t\tright: auto;\n\t\tleft: 0;\n\t}\n\t.dropdown-menu-lg-end {\n\t\t--bs-position: end;\n\t}\n\t.dropdown-menu-lg-end[data-bs-popper] {\n\t\tright: 0;\n\t\tleft: auto;\n\t}\n}\n\n@media (min-width: 1200px) {\n\t.dropdown-menu-xl-start {\n\t\t--bs-position: start;\n\t}\n\t.dropdown-menu-xl-start[data-bs-popper] {\n\t\tright: auto;\n\t\tleft: 0;\n\t}\n\t.dropdown-menu-xl-end {\n\t\t--bs-position: end;\n\t}\n\t.dropdown-menu-xl-end[data-bs-popper] {\n\t\tright: 0;\n\t\tleft: auto;\n\t}\n}\n\n@media (min-width: 1440) {\n\t.dropdown-menu-xxl-start {\n\t\t--bs-position: start;\n\t}\n\t.dropdown-menu-xxl-start[data-bs-popper] {\n\t\tright: auto;\n\t\tleft: 0;\n\t}\n\t.dropdown-menu-xxl-end {\n\t\t--bs-position: end;\n\t}\n\t.dropdown-menu-xxl-end[data-bs-popper] {\n\t\tright: 0;\n\t\tleft: auto;\n\t}\n}\n\n.dropup .dropdown-menu[data-bs-popper] {\n\ttop: auto;\n\tbottom: 100%;\n\tmargin-top: 0;\n\tmargin-bottom: 0.125rem;\n}\n\n.dropup .dropdown-toggle::after {\n\tdisplay: inline-block;\n\tmargin-left: 0.255em;\n\tvertical-align: 0.255em;\n\tcontent: '';\n\tborder-top: 0;\n\tborder-right: 0.3em solid transparent;\n\tborder-bottom: 0.3em solid;\n\tborder-left: 0.3em solid transparent;\n}\n\n.dropup .dropdown-toggle:empty::after {\n\tmargin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n\ttop: 0;\n\tright: auto;\n\tleft: 100%;\n\tmargin-top: 0;\n\tmargin-left: 0.125rem;\n}\n\n.dropend .dropdown-toggle::after {\n\tdisplay: inline-block;\n\tmargin-left: 0.255em;\n\tvertical-align: 0.255em;\n\tcontent: '';\n\tborder-top: 0.3em solid transparent;\n\tborder-right: 0;\n\tborder-bottom: 0.3em solid transparent;\n\tborder-left: 0.3em solid;\n}\n\n.dropend .dropdown-toggle:empty::after {\n\tmargin-left: 0;\n}\n\n.dropend .dropdown-toggle::after {\n\tvertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n\ttop: 0;\n\tright: 100%;\n\tleft: auto;\n\tmargin-top: 0;\n\tmargin-right: 0.125rem;\n}\n\n.dropstart .dropdown-toggle::after {\n\tdisplay: inline-block;\n\tmargin-left: 0.255em;\n\tvertical-align: 0.255em;\n\tcontent: '';\n}\n\n.dropstart .dropdown-toggle::after {\n\tdisplay: none;\n}\n\n.dropstart .dropdown-toggle::before {\n\tdisplay: inline-block;\n\tmargin-right: 0.255em;\n\tvertical-align: 0.255em;\n\tcontent: '';\n\tborder-top: 0.3em solid transparent;\n\tborder-right: 0.3em solid;\n\tborder-bottom: 0.3em solid transparent;\n}\n\n.dropstart .dropdown-toggle:empty::after {\n\tmargin-left: 0;\n}\n\n.dropstart .dropdown-toggle::before {\n\tvertical-align: 0;\n}\n\n.dropdown-divider {\n\theight: 0;\n\tmargin: 0.5rem 0;\n\toverflow: hidden;\n\tborder-top: 1px solid rgba(0, 0, 0, 0.15);\n}\n\n.dropdown-item {\n\tdisplay: block;\n\twidth: 100%;\n\tpadding: 0.25rem 1.25rem;\n\tclear: both;\n\tfont-weight: 400;\n\tcolor: #212529;\n\ttext-align: inherit;\n\ttext-decoration: none;\n\twhite-space: nowrap;\n\tbackground-color: transparent;\n\tborder: 0;\n}\n.dropdown-item:hover,\n.dropdown-item:focus {\n\tcolor: #1e2125;\n\tbackground-color: #e9ecef;\n}\n.dropdown-item.active,\n.dropdown-item:active {\n\tcolor: #fff;\n\ttext-decoration: none;\n\tbackground-color: #4d44b5;\n}\n.dropdown-item.disabled,\n.dropdown-item:disabled {\n\tcolor: #adb5bd;\n\tpointer-events: none;\n\tbackground-color: transparent;\n}\n\n.dropdown-menu.show {\n\tdisplay: block;\n}\n\n.dropdown-header {\n\tdisplay: block;\n\tpadding: 0.5rem 1.25rem;\n\tmargin-bottom: 0;\n\tfont-size: 0.76563rem;\n\tcolor: #6c757d;\n\twhite-space: nowrap;\n}\n@media (min-width: 1200px) {\n\t.dropdown-header {\n\t\tfont-size: 0.76562rem;\n\t}\n}\n\n.dropdown-item-text {\n\tdisplay: block;\n\tpadding: 0.25rem 1.25rem;\n\tcolor: #212529;\n}\n\n.dropdown-menu-dark {\n\tcolor: #dee2e6;\n\tbackground-color: #343a40;\n\tborder-color: rgba(0, 0, 0, 0.15);\n}\n.dropdown-menu-dark .dropdown-item {\n\tcolor: #dee2e6;\n}\n.dropdown-menu-dark .dropdown-item:hover,\n.dropdown-menu-dark .dropdown-item:focus {\n\tcolor: #fff;\n\tbackground-color: rgba(255, 255, 255, 0.15);\n}\n.dropdown-menu-dark .dropdown-item.active,\n.dropdown-menu-dark .dropdown-item:active {\n\tcolor: #fff;\n\tbackground-color: #4d44b5;\n}\n.dropdown-menu-dark .dropdown-item.disabled,\n.dropdown-menu-dark .dropdown-item:disabled {\n\tcolor: #adb5bd;\n}\n.dropdown-menu-dark .dropdown-divider {\n\tborder-color: rgba(0, 0, 0, 0.15);\n}\n.dropdown-menu-dark .dropdown-item-text {\n\tcolor: #dee2e6;\n}\n.dropdown-menu-dark .dropdown-header {\n\tcolor: #adb5bd;\n}\n\n.btn-group,\n.btn-group-vertical {\n\tposition: relative;\n\tdisplay: inline-flex;\n\tvertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n\tposition: relative;\n\tflex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n\tz-index: 1;\n}\n\n.btn-toolbar {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tjustify-content: flex-start;\n}\n.btn-toolbar .input-group {\n\twidth: auto;\n}\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) {\n\tmargin-left: -1px;\n}\n\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n.btn-group > .btn:nth-child(n + 3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n\tpadding-right: 0.5625rem;\n\tpadding-left: 0.5625rem;\n}\n.dropdown-toggle-split::after,\n.dropup .dropdown-toggle-split::after,\n.dropend .dropdown-toggle-split::after {\n\tmargin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n\tmargin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split,\n.btn-group-sm > .btn + .dropdown-toggle-split {\n\tpadding-right: 0.375rem;\n\tpadding-left: 0.375rem;\n}\n\n.btn-lg + .dropdown-toggle-split,\n.btn-group-lg > .btn + .dropdown-toggle-split {\n\tpadding-right: 0.75rem;\n\tpadding-left: 0.75rem;\n}\n\n.btn-group-vertical {\n\tflex-direction: column;\n\talign-items: flex-start;\n\tjustify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n\twidth: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n\tmargin-top: -1px;\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n\tborder-bottom-right-radius: 0;\n\tborder-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n}\n\n.nav {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tpadding-left: 0;\n\tmargin-bottom: 0;\n\tlist-style: none;\n}\n\n.nav-link {\n\tdisplay: block;\n\tpadding: 0.5rem 1rem;\n\tcolor: #4d44b5;\n\ttext-decoration: none;\n\ttransition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.nav-link {\n\t\ttransition: none;\n\t}\n}\n.nav-link:hover,\n.nav-link:focus {\n\tcolor: #3e3691;\n}\n.nav-link.disabled {\n\tcolor: #6c757d;\n\tpointer-events: none;\n\tcursor: default;\n}\n\n.nav-tabs {\n\tborder-bottom: 1px solid #dee2e6;\n}\n.nav-tabs .nav-link {\n\tmargin-bottom: -1px;\n\tbackground: none;\n\tborder: 1px solid transparent;\n\tborder-top-left-radius: 0.625rem;\n\tborder-top-right-radius: 0.625rem;\n}\n.nav-tabs .nav-link:hover,\n.nav-tabs .nav-link:focus {\n\tborder-color: #e9ecef #e9ecef #dee2e6;\n\tisolation: isolate;\n}\n.nav-tabs .nav-link.disabled {\n\tcolor: #6c757d;\n\tbackground-color: transparent;\n\tborder-color: transparent;\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n\tcolor: #495057;\n\tbackground-color: #e6ebee;\n\tborder-color: #dee2e6 #dee2e6 #e6ebee;\n}\n.nav-tabs .dropdown-menu {\n\tmargin-top: -1px;\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n\tbackground: none;\n\tborder: 0;\n\tborder-radius: 0.625rem;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n\tcolor: #fff;\n\tbackground-color: #4d44b5;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n\tflex: 1 1 auto;\n\ttext-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n\tflex-basis: 0;\n\tflex-grow: 1;\n\ttext-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n\twidth: 100%;\n}\n\n.tab-content > .tab-pane {\n\tdisplay: none;\n}\n\n.tab-content > .active {\n\tdisplay: block;\n}\n\n.navbar {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding-top: 0.5rem;\n\tpadding-bottom: 0.5rem;\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n\tdisplay: flex;\n\tflex-wrap: inherit;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n\n.navbar-brand {\n\tpadding-top: 0.33594rem;\n\tpadding-bottom: 0.33594rem;\n\tmargin-right: 1rem;\n\tfont-size: 1.09375rem;\n\ttext-decoration: none;\n\twhite-space: nowrap;\n}\n\n.navbar-nav {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding-left: 0;\n\tmargin-bottom: 0;\n\tlist-style: none;\n}\n.navbar-nav .nav-link {\n\tpadding-right: 0;\n\tpadding-left: 0;\n}\n.navbar-nav .dropdown-menu {\n\tposition: static;\n}\n\n.navbar-text {\n\tpadding-top: 0.5rem;\n\tpadding-bottom: 0.5rem;\n}\n\n.navbar-collapse {\n\tflex-basis: 100%;\n\tflex-grow: 1;\n\talign-items: center;\n}\n\n.navbar-toggler {\n\tpadding: 0.25rem 0.75rem;\n\tfont-size: 1.09375rem;\n\tline-height: 1;\n\tbackground-color: transparent;\n\tborder: 1px solid transparent;\n\tborder-radius: 0.625rem;\n\ttransition: box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.navbar-toggler {\n\t\ttransition: none;\n\t}\n}\n.navbar-toggler:hover {\n\ttext-decoration: none;\n}\n.navbar-toggler:focus {\n\ttext-decoration: none;\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.25rem;\n}\n\n.navbar-toggler-icon {\n\tdisplay: inline-block;\n\twidth: 1.5em;\n\theight: 1.5em;\n\tvertical-align: middle;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tbackground-size: 100%;\n}\n\n.navbar-nav-scroll {\n\tmax-height: var(--bs-scroll-height, 75vh);\n\toverflow-y: auto;\n}\n\n@media (min-width: 576px) {\n\t.navbar-expand-sm {\n\t\tflex-wrap: nowrap;\n\t\tjustify-content: flex-start;\n\t}\n\t.navbar-expand-sm .navbar-nav {\n\t\tflex-direction: row;\n\t}\n\t.navbar-expand-sm .navbar-nav .dropdown-menu {\n\t\tposition: absolute;\n\t}\n\t.navbar-expand-sm .navbar-nav .nav-link {\n\t\tpadding-right: 0.5rem;\n\t\tpadding-left: 0.5rem;\n\t}\n\t.navbar-expand-sm .navbar-nav-scroll {\n\t\toverflow: visible;\n\t}\n\t.navbar-expand-sm .navbar-collapse {\n\t\tdisplay: flex !important;\n\t\tflex-basis: auto;\n\t}\n\t.navbar-expand-sm .navbar-toggler {\n\t\tdisplay: none;\n\t}\n\t.navbar-expand-sm .offcanvas-header {\n\t\tdisplay: none;\n\t}\n\t.navbar-expand-sm .offcanvas {\n\t\tposition: inherit;\n\t\tbottom: 0;\n\t\tz-index: 1000;\n\t\tflex-grow: 1;\n\t\tvisibility: visible !important;\n\t\tbackground-color: transparent;\n\t\tborder-right: 0;\n\t\tborder-left: 0;\n\t\ttransition: none;\n\t\ttransform: none;\n\t}\n\t.navbar-expand-sm .offcanvas-top,\n\t.navbar-expand-sm .offcanvas-bottom {\n\t\theight: auto;\n\t\tborder-top: 0;\n\t\tborder-bottom: 0;\n\t}\n\t.navbar-expand-sm .offcanvas-body {\n\t\tdisplay: flex;\n\t\tflex-grow: 0;\n\t\tpadding: 0;\n\t\toverflow-y: visible;\n\t}\n}\n\n@media (min-width: 768px) {\n\t.navbar-expand-md {\n\t\tflex-wrap: nowrap;\n\t\tjustify-content: flex-start;\n\t}\n\t.navbar-expand-md .navbar-nav {\n\t\tflex-direction: row;\n\t}\n\t.navbar-expand-md .navbar-nav .dropdown-menu {\n\t\tposition: absolute;\n\t}\n\t.navbar-expand-md .navbar-nav .nav-link {\n\t\tpadding-right: 0.5rem;\n\t\tpadding-left: 0.5rem;\n\t}\n\t.navbar-expand-md .navbar-nav-scroll {\n\t\toverflow: visible;\n\t}\n\t.navbar-expand-md .navbar-collapse {\n\t\tdisplay: flex !important;\n\t\tflex-basis: auto;\n\t}\n\t.navbar-expand-md .navbar-toggler {\n\t\tdisplay: none;\n\t}\n\t.navbar-expand-md .offcanvas-header {\n\t\tdisplay: none;\n\t}\n\t.navbar-expand-md .offcanvas {\n\t\tposition: inherit;\n\t\tbottom: 0;\n\t\tz-index: 1000;\n\t\tflex-grow: 1;\n\t\tvisibility: visible !important;\n\t\tbackground-color: transparent;\n\t\tborder-right: 0;\n\t\tborder-left: 0;\n\t\ttransition: none;\n\t\ttransform: none;\n\t}\n\t.navbar-expand-md .offcanvas-top,\n\t.navbar-expand-md .offcanvas-bottom {\n\t\theight: auto;\n\t\tborder-top: 0;\n\t\tborder-bottom: 0;\n\t}\n\t.navbar-expand-md .offcanvas-body {\n\t\tdisplay: flex;\n\t\tflex-grow: 0;\n\t\tpadding: 0;\n\t\toverflow-y: visible;\n\t}\n}\n\n@media (min-width: 992px) {\n\t.navbar-expand-lg {\n\t\tflex-wrap: nowrap;\n\t\tjustify-content: flex-start;\n\t}\n\t.navbar-expand-lg .navbar-nav {\n\t\tflex-direction: row;\n\t}\n\t.navbar-expand-lg .navbar-nav .dropdown-menu {\n\t\tposition: absolute;\n\t}\n\t.navbar-expand-lg .navbar-nav .nav-link {\n\t\tpadding-right: 0.5rem;\n\t\tpadding-left: 0.5rem;\n\t}\n\t.navbar-expand-lg .navbar-nav-scroll {\n\t\toverflow: visible;\n\t}\n\t.navbar-expand-lg .navbar-collapse {\n\t\tdisplay: flex !important;\n\t\tflex-basis: auto;\n\t}\n\t.navbar-expand-lg .navbar-toggler {\n\t\tdisplay: none;\n\t}\n\t.navbar-expand-lg .offcanvas-header {\n\t\tdisplay: none;\n\t}\n\t.navbar-expand-lg .offcanvas {\n\t\tposition: inherit;\n\t\tbottom: 0;\n\t\tz-index: 1000;\n\t\tflex-grow: 1;\n\t\tvisibility: visible !important;\n\t\tbackground-color: transparent;\n\t\tborder-right: 0;\n\t\tborder-left: 0;\n\t\ttransition: none;\n\t\ttransform: none;\n\t}\n\t.navbar-expand-lg .offcanvas-top,\n\t.navbar-expand-lg .offcanvas-bottom {\n\t\theight: auto;\n\t\tborder-top: 0;\n\t\tborder-bottom: 0;\n\t}\n\t.navbar-expand-lg .offcanvas-body {\n\t\tdisplay: flex;\n\t\tflex-grow: 0;\n\t\tpadding: 0;\n\t\toverflow-y: visible;\n\t}\n}\n\n@media (min-width: 1200px) {\n\t.navbar-expand-xl {\n\t\tflex-wrap: nowrap;\n\t\tjustify-content: flex-start;\n\t}\n\t.navbar-expand-xl .navbar-nav {\n\t\tflex-direction: row;\n\t}\n\t.navbar-expand-xl .navbar-nav .dropdown-menu {\n\t\tposition: absolute;\n\t}\n\t.navbar-expand-xl .navbar-nav .nav-link {\n\t\tpadding-right: 0.5rem;\n\t\tpadding-left: 0.5rem;\n\t}\n\t.navbar-expand-xl .navbar-nav-scroll {\n\t\toverflow: visible;\n\t}\n\t.navbar-expand-xl .navbar-collapse {\n\t\tdisplay: flex !important;\n\t\tflex-basis: auto;\n\t}\n\t.navbar-expand-xl .navbar-toggler {\n\t\tdisplay: none;\n\t}\n\t.navbar-expand-xl .offcanvas-header {\n\t\tdisplay: none;\n\t}\n\t.navbar-expand-xl .offcanvas {\n\t\tposition: inherit;\n\t\tbottom: 0;\n\t\tz-index: 1000;\n\t\tflex-grow: 1;\n\t\tvisibility: visible !important;\n\t\tbackground-color: transparent;\n\t\tborder-right: 0;\n\t\tborder-left: 0;\n\t\ttransition: none;\n\t\ttransform: none;\n\t}\n\t.navbar-expand-xl .offcanvas-top,\n\t.navbar-expand-xl .offcanvas-bottom {\n\t\theight: auto;\n\t\tborder-top: 0;\n\t\tborder-bottom: 0;\n\t}\n\t.navbar-expand-xl .offcanvas-body {\n\t\tdisplay: flex;\n\t\tflex-grow: 0;\n\t\tpadding: 0;\n\t\toverflow-y: visible;\n\t}\n}\n\n@media (min-width: 1440) {\n\t.navbar-expand-xxl {\n\t\tflex-wrap: nowrap;\n\t\tjustify-content: flex-start;\n\t}\n\t.navbar-expand-xxl .navbar-nav {\n\t\tflex-direction: row;\n\t}\n\t.navbar-expand-xxl .navbar-nav .dropdown-menu {\n\t\tposition: absolute;\n\t}\n\t.navbar-expand-xxl .navbar-nav .nav-link {\n\t\tpadding-right: 0.5rem;\n\t\tpadding-left: 0.5rem;\n\t}\n\t.navbar-expand-xxl .navbar-nav-scroll {\n\t\toverflow: visible;\n\t}\n\t.navbar-expand-xxl .navbar-collapse {\n\t\tdisplay: flex !important;\n\t\tflex-basis: auto;\n\t}\n\t.navbar-expand-xxl .navbar-toggler {\n\t\tdisplay: none;\n\t}\n\t.navbar-expand-xxl .offcanvas-header {\n\t\tdisplay: none;\n\t}\n\t.navbar-expand-xxl .offcanvas {\n\t\tposition: inherit;\n\t\tbottom: 0;\n\t\tz-index: 1000;\n\t\tflex-grow: 1;\n\t\tvisibility: visible !important;\n\t\tbackground-color: transparent;\n\t\tborder-right: 0;\n\t\tborder-left: 0;\n\t\ttransition: none;\n\t\ttransform: none;\n\t}\n\t.navbar-expand-xxl .offcanvas-top,\n\t.navbar-expand-xxl .offcanvas-bottom {\n\t\theight: auto;\n\t\tborder-top: 0;\n\t\tborder-bottom: 0;\n\t}\n\t.navbar-expand-xxl .offcanvas-body {\n\t\tdisplay: flex;\n\t\tflex-grow: 0;\n\t\tpadding: 0;\n\t\toverflow-y: visible;\n\t}\n}\n\n.navbar-expand {\n\tflex-wrap: nowrap;\n\tjustify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n\tflex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n\tposition: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n\tpadding-right: 0.5rem;\n\tpadding-left: 0.5rem;\n}\n.navbar-expand .navbar-nav-scroll {\n\toverflow: visible;\n}\n.navbar-expand .navbar-collapse {\n\tdisplay: flex !important;\n\tflex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n\tdisplay: none;\n}\n.navbar-expand .offcanvas-header {\n\tdisplay: none;\n}\n.navbar-expand .offcanvas {\n\tposition: inherit;\n\tbottom: 0;\n\tz-index: 1000;\n\tflex-grow: 1;\n\tvisibility: visible !important;\n\tbackground-color: transparent;\n\tborder-right: 0;\n\tborder-left: 0;\n\ttransition: none;\n\ttransform: none;\n}\n.navbar-expand .offcanvas-top,\n.navbar-expand .offcanvas-bottom {\n\theight: auto;\n\tborder-top: 0;\n\tborder-bottom: 0;\n}\n.navbar-expand .offcanvas-body {\n\tdisplay: flex;\n\tflex-grow: 0;\n\tpadding: 0;\n\toverflow-y: visible;\n}\n\n.navbar-light .navbar-brand {\n\tcolor: rgba(0, 0, 0, 0.9);\n}\n.navbar-light .navbar-brand:hover,\n.navbar-light .navbar-brand:focus {\n\tcolor: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-nav .nav-link {\n\tcolor: rgba(0, 0, 0, 0.55);\n}\n.navbar-light .navbar-nav .nav-link:hover,\n.navbar-light .navbar-nav .nav-link:focus {\n\tcolor: rgba(0, 0, 0, 0.7);\n}\n.navbar-light .navbar-nav .nav-link.disabled {\n\tcolor: rgba(0, 0, 0, 0.3);\n}\n\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .nav-link.active {\n\tcolor: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-toggler {\n\tcolor: rgba(0, 0, 0, 0.55);\n\tborder-color: rgba(0, 0, 0, 0.1);\n}\n\n.navbar-light .navbar-toggler-icon {\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.navbar-light .navbar-text {\n\tcolor: rgba(0, 0, 0, 0.55);\n}\n.navbar-light .navbar-text a,\n.navbar-light .navbar-text a:hover,\n.navbar-light .navbar-text a:focus {\n\tcolor: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-dark .navbar-brand {\n\tcolor: #fff;\n}\n.navbar-dark .navbar-brand:hover,\n.navbar-dark .navbar-brand:focus {\n\tcolor: #fff;\n}\n\n.navbar-dark .navbar-nav .nav-link {\n\tcolor: rgba(255, 255, 255, 0.55);\n}\n.navbar-dark .navbar-nav .nav-link:hover,\n.navbar-dark .navbar-nav .nav-link:focus {\n\tcolor: rgba(255, 255, 255, 0.75);\n}\n.navbar-dark .navbar-nav .nav-link.disabled {\n\tcolor: rgba(255, 255, 255, 0.25);\n}\n\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .nav-link.active {\n\tcolor: #fff;\n}\n\n.navbar-dark .navbar-toggler {\n\tcolor: rgba(255, 255, 255, 0.55);\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n.navbar-dark .navbar-toggler-icon {\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.navbar-dark .navbar-text {\n\tcolor: rgba(255, 255, 255, 0.55);\n}\n.navbar-dark .navbar-text a,\n.navbar-dark .navbar-text a:hover,\n.navbar-dark .navbar-text a:focus {\n\tcolor: #fff;\n}\n\n.card {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\tmin-width: 0;\n\tword-wrap: break-word;\n\tbackground-color: #fff;\n\tbackground-clip: border-box;\n\tborder: 1px solid rgba(0, 0, 0, 0.125);\n\tborder-radius: 0.625rem;\n}\n.card > hr {\n\tmargin-right: 0;\n\tmargin-left: 0;\n}\n.card > .list-group {\n\tborder-top: inherit;\n\tborder-bottom: inherit;\n}\n.card > .list-group:first-child {\n\tborder-top-width: 0;\n\tborder-top-left-radius: calc(0.625rem - 1px);\n\tborder-top-right-radius: calc(0.625rem - 1px);\n}\n.card > .list-group:last-child {\n\tborder-bottom-width: 0;\n\tborder-bottom-right-radius: calc(0.625rem - 1px);\n\tborder-bottom-left-radius: calc(0.625rem - 1px);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n\tborder-top: 0;\n}\n\n.card-body {\n\tflex: 1 1 auto;\n\tpadding: 1rem 1rem;\n}\n\n.card-title {\n\tmargin-bottom: 0.5rem;\n}\n\n.card-subtitle {\n\tmargin-top: -0.25rem;\n\tmargin-bottom: 0;\n}\n\n.card-text:last-child {\n\tmargin-bottom: 0;\n}\n\n.card-link + .card-link {\n\tmargin-left: 1rem;\n}\n\n.card-header {\n\tpadding: 0.5rem 1rem;\n\tmargin-bottom: 0;\n\tbackground-color: rgba(0, 0, 0, 0.03);\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.125);\n}\n.card-header:first-child {\n\tborder-radius: calc(0.625rem - 1px) calc(0.625rem - 1px) 0 0;\n}\n\n.card-footer {\n\tpadding: 0.5rem 1rem;\n\tbackground-color: rgba(0, 0, 0, 0.03);\n\tborder-top: 1px solid rgba(0, 0, 0, 0.125);\n}\n.card-footer:last-child {\n\tborder-radius: 0 0 calc(0.625rem - 1px) calc(0.625rem - 1px);\n}\n\n.card-header-tabs {\n\tmargin-right: -0.5rem;\n\tmargin-bottom: -0.5rem;\n\tmargin-left: -0.5rem;\n\tborder-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n\tbackground-color: #fff;\n\tborder-bottom-color: #fff;\n}\n\n.card-header-pills {\n\tmargin-right: -0.5rem;\n\tmargin-left: -0.5rem;\n}\n\n.card-img-overlay {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tpadding: 1rem;\n\tborder-radius: calc(0.625rem - 1px);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n\twidth: 100%;\n}\n\n.card-img,\n.card-img-top {\n\tborder-top-left-radius: calc(0.625rem - 1px);\n\tborder-top-right-radius: calc(0.625rem - 1px);\n}\n\n.card-img,\n.card-img-bottom {\n\tborder-bottom-right-radius: calc(0.625rem - 1px);\n\tborder-bottom-left-radius: calc(0.625rem - 1px);\n}\n\n.card-group > .card {\n\tmargin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n\t.card-group {\n\t\tdisplay: flex;\n\t\tflex-flow: row wrap;\n\t}\n\t.card-group > .card {\n\t\tflex: 1 0 0%;\n\t\tmargin-bottom: 0;\n\t}\n\t.card-group > .card + .card {\n\t\tmargin-left: 0;\n\t\tborder-left: 0;\n\t}\n\t.card-group > .card:not(:last-child) {\n\t\tborder-top-right-radius: 0;\n\t\tborder-bottom-right-radius: 0;\n\t}\n\t.card-group > .card:not(:last-child) .card-img-top,\n\t.card-group > .card:not(:last-child) .card-header {\n\t\tborder-top-right-radius: 0;\n\t}\n\t.card-group > .card:not(:last-child) .card-img-bottom,\n\t.card-group > .card:not(:last-child) .card-footer {\n\t\tborder-bottom-right-radius: 0;\n\t}\n\t.card-group > .card:not(:first-child) {\n\t\tborder-top-left-radius: 0;\n\t\tborder-bottom-left-radius: 0;\n\t}\n\t.card-group > .card:not(:first-child) .card-img-top,\n\t.card-group > .card:not(:first-child) .card-header {\n\t\tborder-top-left-radius: 0;\n\t}\n\t.card-group > .card:not(:first-child) .card-img-bottom,\n\t.card-group > .card:not(:first-child) .card-footer {\n\t\tborder-bottom-left-radius: 0;\n\t}\n}\n\n.accordion-button {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tpadding: 1rem 1.25rem;\n\tfont-size: 0.875rem;\n\tcolor: #a098ae;\n\ttext-align: left;\n\tbackground-color: #e6ebee;\n\tborder: 0;\n\tborder-radius: 0;\n\toverflow-anchor: none;\n\ttransition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n\t\tborder-radius 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.accordion-button {\n\t\ttransition: none;\n\t}\n}\n.accordion-button:not(.collapsed) {\n\tcolor: #453da3;\n\tbackground-color: #edecf8;\n\tbox-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);\n}\n.accordion-button:not(.collapsed)::after {\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23453da3'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n\ttransform: rotate(-180deg);\n}\n.accordion-button::after {\n\tflex-shrink: 0;\n\twidth: 1.25rem;\n\theight: 1.25rem;\n\tmargin-left: auto;\n\tcontent: '';\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23A098AE'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n\tbackground-repeat: no-repeat;\n\tbackground-size: 1.25rem;\n\ttransition: transform 0.2s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.accordion-button::after {\n\t\ttransition: none;\n\t}\n}\n.accordion-button:hover {\n\tz-index: 2;\n}\n.accordion-button:focus {\n\tz-index: 3;\n\tborder-color: #a6a2da;\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.25);\n}\n\n.accordion-header {\n\tmargin-bottom: 0;\n}\n\n.accordion-item {\n\tbackground-color: #e6ebee;\n\tborder: 1px solid rgba(0, 0, 0, 0.125);\n}\n.accordion-item:first-of-type {\n\tborder-top-left-radius: 0.625rem;\n\tborder-top-right-radius: 0.625rem;\n}\n.accordion-item:first-of-type .accordion-button {\n\tborder-top-left-radius: calc(0.625rem - 1px);\n\tborder-top-right-radius: calc(0.625rem - 1px);\n}\n.accordion-item:not(:first-of-type) {\n\tborder-top: 0;\n}\n.accordion-item:last-of-type {\n\tborder-bottom-right-radius: 0.625rem;\n\tborder-bottom-left-radius: 0.625rem;\n}\n.accordion-item:last-of-type .accordion-button.collapsed {\n\tborder-bottom-right-radius: calc(0.625rem - 1px);\n\tborder-bottom-left-radius: calc(0.625rem - 1px);\n}\n.accordion-item:last-of-type .accordion-collapse {\n\tborder-bottom-right-radius: 0.625rem;\n\tborder-bottom-left-radius: 0.625rem;\n}\n\n.accordion-body {\n\tpadding: 1rem 1.25rem;\n}\n\n.accordion-flush .accordion-collapse {\n\tborder-width: 0;\n}\n\n.accordion-flush .accordion-item {\n\tborder-right: 0;\n\tborder-left: 0;\n\tborder-radius: 0;\n}\n.accordion-flush .accordion-item:first-child {\n\tborder-top: 0;\n}\n.accordion-flush .accordion-item:last-child {\n\tborder-bottom: 0;\n}\n.accordion-flush .accordion-item .accordion-button {\n\tborder-radius: 0;\n}\n\n.breadcrumb {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tpadding: 0 0;\n\tmargin-bottom: 1rem;\n\tlist-style: none;\n}\n\n.breadcrumb-item + .breadcrumb-item {\n\tpadding-left: 0.5rem;\n}\n.breadcrumb-item + .breadcrumb-item::before {\n\tfloat: left;\n\tpadding-right: 0.5rem;\n\tcolor: #6c757d;\n\tcontent: var(--bs-breadcrumb-divider, '/') /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n\n.breadcrumb-item.active {\n\tcolor: #6c757d;\n}\n\n.pagination {\n\tdisplay: flex;\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n.page-link {\n\tposition: relative;\n\tdisplay: block;\n\tcolor: #4d44b5;\n\ttext-decoration: none;\n\tbackground-color: #fff;\n\tborder: 1px solid #dee2e6;\n\ttransition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.page-link {\n\t\ttransition: none;\n\t}\n}\n.page-link:hover {\n\tz-index: 2;\n\tcolor: #3e3691;\n\tbackground-color: #e9ecef;\n\tborder-color: #dee2e6;\n}\n.page-link:disabled {\n\topacity: 0.5;\n}\n.page-link:focus {\n\tz-index: 3;\n\tcolor: #3e3691;\n\tbackground-color: #e9ecef;\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.25);\n}\n\n.page-item:not(:first-child) .page-link {\n\tmargin-left: -1px;\n}\n\n.page-item.active .page-link {\n\tz-index: 3;\n\tcolor: #fff;\n\tbackground-color: #4d44b5;\n\tborder-color: #4d44b5;\n}\n\n.page-item.disabled .page-link {\n\tcolor: #6c757d;\n\tpointer-events: none;\n\tbackground-color: #fff;\n\tborder-color: #dee2e6;\n}\n\n.page-link {\n\tpadding: 0.375rem 0.75rem;\n}\n\n.page-item:first-child .page-link {\n\tborder-top-left-radius: 0.625rem;\n\tborder-bottom-left-radius: 0.625rem;\n}\n\n.page-item:last-child .page-link {\n\tborder-top-right-radius: 0.625rem;\n\tborder-bottom-right-radius: 0.625rem;\n}\n\n.pagination-lg .page-link {\n\tpadding: 0.75rem 1.5rem;\n\tfont-size: 1.09375rem;\n}\n\n.pagination-lg .page-item:first-child .page-link {\n\tborder-top-left-radius: 0.625rem;\n\tborder-bottom-left-radius: 0.625rem;\n}\n\n.pagination-lg .page-item:last-child .page-link {\n\tborder-top-right-radius: 0.625rem;\n\tborder-bottom-right-radius: 0.625rem;\n}\n\n.pagination-sm .page-link {\n\tpadding: 0.25rem 0.5rem;\n\tfont-size: 0.76563rem;\n}\n@media (min-width: 1200px) {\n\t.pagination-sm .page-link {\n\t\tfont-size: 0.76562rem;\n\t}\n}\n\n.pagination-sm .page-item:first-child .page-link {\n\tborder-top-left-radius: 0.625rem;\n\tborder-bottom-left-radius: 0.625rem;\n}\n\n.pagination-sm .page-item:last-child .page-link {\n\tborder-top-right-radius: 0.625rem;\n\tborder-bottom-right-radius: 0.625rem;\n}\n\n.badge {\n\tdisplay: inline-block;\n\tpadding: 0.35em 0.65em;\n\tfont-size: 0.75em;\n\tfont-weight: 700;\n\tline-height: 1;\n\tcolor: #fff;\n\ttext-align: center;\n\twhite-space: nowrap;\n\tvertical-align: baseline;\n\tborder-radius: 0.625rem;\n}\n.badge:empty {\n\tdisplay: none;\n}\n\n.btn .badge {\n\tposition: relative;\n\ttop: -1px;\n}\n\n.alert {\n\tposition: relative;\n\tpadding: 1rem 1rem;\n\tmargin-bottom: 1rem;\n\tborder: 1px solid transparent;\n\tborder-radius: 0.625rem;\n}\n\n.alert-heading {\n\tcolor: inherit;\n}\n\n.alert-link {\n\tfont-weight: 700;\n}\n\n.alert-dismissible {\n\tpadding-right: 3rem;\n}\n.alert-dismissible .btn-close {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tz-index: 2;\n\tpadding: 1.25rem 1rem;\n}\n\n.alert-primary {\n\tcolor: #2e296d;\n\tbackground-color: #dbdaf0;\n\tborder-color: #cac7e9;\n}\n.alert-primary .alert-link {\n\tcolor: #252157;\n}\n\n.alert-secondary {\n\tcolor: #974b37;\n\tbackground-color: #fee5de;\n\tborder-color: #fed8ce;\n}\n.alert-secondary .alert-link {\n\tcolor: #793c2c;\n}\n\n.alert-success {\n\tcolor: #12703b;\n\tbackground-color: #d2f1e0;\n\tborder-color: #bcead0;\n}\n.alert-success .alert-link {\n\tcolor: #0e5a2f;\n}\n\n.alert-info {\n\tcolor: #006862;\n\tbackground-color: #ccefed;\n\tborder-color: #b3e6e3;\n}\n.alert-info .alert-link {\n\tcolor: #00534e;\n}\n\n.alert-warning {\n\tcolor: #654e19;\n\tbackground-color: #fef3d8;\n\tborder-color: #feedc5;\n}\n.alert-warning .alert-link {\n\tcolor: #513e14;\n}\n\n.alert-danger {\n\tcolor: #983232;\n\tbackground-color: #ffdddd;\n\tborder-color: #fecbcb;\n}\n.alert-danger .alert-link {\n\tcolor: #7a2828;\n}\n\n.alert-light {\n\tcolor: #5e5e64;\n\tbackground-color: #fbfbfe;\n\tborder-color: #f9f9fd;\n}\n.alert-light .alert-link {\n\tcolor: #4b4b50;\n}\n\n.alert-dark {\n\tcolor: #1d2244;\n\tbackground-color: #d6d7e3;\n\tborder-color: #c1c4d5;\n}\n.alert-dark .alert-link {\n\tcolor: #171b36;\n}\n\n@keyframes progress-bar-stripes {\n\t0% {\n\t\tbackground-position-x: 1rem;\n\t}\n}\n\n.progress {\n\tdisplay: flex;\n\theight: 1rem;\n\toverflow: hidden;\n\tfont-size: 0.65625rem;\n\tbackground-color: #e9ecef;\n\tborder-radius: 0.625rem;\n}\n\n.progress-bar {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\toverflow: hidden;\n\tcolor: #fff;\n\ttext-align: center;\n\twhite-space: nowrap;\n\tbackground-color: #4d44b5;\n\ttransition: width 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.progress-bar {\n\t\ttransition: none;\n\t}\n}\n\n.progress-bar-striped {\n\tbackground-image: linear-gradient(\n\t\t45deg,\n\t\trgba(255, 255, 255, 0.15) 25%,\n\t\ttransparent 25%,\n\t\ttransparent 50%,\n\t\trgba(255, 255, 255, 0.15) 50%,\n\t\trgba(255, 255, 255, 0.15) 75%,\n\t\ttransparent 75%,\n\t\ttransparent\n\t);\n\tbackground-size: 1rem 1rem;\n}\n\n.progress-bar-animated {\n\tanimation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.progress-bar-animated {\n\t\tanimation: none;\n\t}\n}\n\n.list-group {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding-left: 0;\n\tmargin-bottom: 0;\n\tborder-radius: 0.625rem;\n}\n\n.list-group-numbered {\n\tlist-style-type: none;\n\tcounter-reset: section;\n}\n.list-group-numbered > li::before {\n\tcontent: counters(section, '.') '. ';\n\tcounter-increment: section;\n}\n\n.list-group-item-action {\n\twidth: 100%;\n\tcolor: #495057;\n\ttext-align: inherit;\n}\n.list-group-item-action:hover,\n.list-group-item-action:focus {\n\tz-index: 1;\n\tcolor: #495057;\n\ttext-decoration: none;\n\tbackground-color: #f8f9fa;\n}\n.list-group-item-action:active {\n\tcolor: #a098ae;\n\tbackground-color: #e9ecef;\n}\n\n.list-group-item {\n\tposition: relative;\n\tdisplay: block;\n\tpadding: 0.5rem 1rem;\n\tcolor: #212529;\n\ttext-decoration: none;\n\tbackground-color: #fff;\n\tborder: 1px solid rgba(0, 0, 0, 0.125);\n}\n.list-group-item:first-child {\n\tborder-top-left-radius: inherit;\n\tborder-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n\tborder-bottom-right-radius: inherit;\n\tborder-bottom-left-radius: inherit;\n}\n.list-group-item.disabled,\n.list-group-item:disabled {\n\tcolor: #6c757d;\n\tpointer-events: none;\n\tbackground-color: #fff;\n}\n.list-group-item.active {\n\tz-index: 2;\n\tcolor: #fff;\n\tbackground-color: #4d44b5;\n\tborder-color: #4d44b5;\n}\n.list-group-item + .list-group-item {\n\tborder-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n\tmargin-top: -1px;\n\tborder-top-width: 1px;\n}\n\n.list-group-horizontal {\n\tflex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child {\n\tborder-bottom-left-radius: 0.625rem;\n\tborder-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child {\n\tborder-top-right-radius: 0.625rem;\n\tborder-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n\tmargin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n\tborder-top-width: 1px;\n\tborder-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n\tmargin-left: -1px;\n\tborder-left-width: 1px;\n}\n\n@media (min-width: 576px) {\n\t.list-group-horizontal-sm {\n\t\tflex-direction: row;\n\t}\n\t.list-group-horizontal-sm > .list-group-item:first-child {\n\t\tborder-bottom-left-radius: 0.625rem;\n\t\tborder-top-right-radius: 0;\n\t}\n\t.list-group-horizontal-sm > .list-group-item:last-child {\n\t\tborder-top-right-radius: 0.625rem;\n\t\tborder-bottom-left-radius: 0;\n\t}\n\t.list-group-horizontal-sm > .list-group-item.active {\n\t\tmargin-top: 0;\n\t}\n\t.list-group-horizontal-sm > .list-group-item + .list-group-item {\n\t\tborder-top-width: 1px;\n\t\tborder-left-width: 0;\n\t}\n\t.list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n\t\tmargin-left: -1px;\n\t\tborder-left-width: 1px;\n\t}\n}\n\n@media (min-width: 768px) {\n\t.list-group-horizontal-md {\n\t\tflex-direction: row;\n\t}\n\t.list-group-horizontal-md > .list-group-item:first-child {\n\t\tborder-bottom-left-radius: 0.625rem;\n\t\tborder-top-right-radius: 0;\n\t}\n\t.list-group-horizontal-md > .list-group-item:last-child {\n\t\tborder-top-right-radius: 0.625rem;\n\t\tborder-bottom-left-radius: 0;\n\t}\n\t.list-group-horizontal-md > .list-group-item.active {\n\t\tmargin-top: 0;\n\t}\n\t.list-group-horizontal-md > .list-group-item + .list-group-item {\n\t\tborder-top-width: 1px;\n\t\tborder-left-width: 0;\n\t}\n\t.list-group-horizontal-md > .list-group-item + .list-group-item.active {\n\t\tmargin-left: -1px;\n\t\tborder-left-width: 1px;\n\t}\n}\n\n@media (min-width: 992px) {\n\t.list-group-horizontal-lg {\n\t\tflex-direction: row;\n\t}\n\t.list-group-horizontal-lg > .list-group-item:first-child {\n\t\tborder-bottom-left-radius: 0.625rem;\n\t\tborder-top-right-radius: 0;\n\t}\n\t.list-group-horizontal-lg > .list-group-item:last-child {\n\t\tborder-top-right-radius: 0.625rem;\n\t\tborder-bottom-left-radius: 0;\n\t}\n\t.list-group-horizontal-lg > .list-group-item.active {\n\t\tmargin-top: 0;\n\t}\n\t.list-group-horizontal-lg > .list-group-item + .list-group-item {\n\t\tborder-top-width: 1px;\n\t\tborder-left-width: 0;\n\t}\n\t.list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n\t\tmargin-left: -1px;\n\t\tborder-left-width: 1px;\n\t}\n}\n\n@media (min-width: 1200px) {\n\t.list-group-horizontal-xl {\n\t\tflex-direction: row;\n\t}\n\t.list-group-horizontal-xl > .list-group-item:first-child {\n\t\tborder-bottom-left-radius: 0.625rem;\n\t\tborder-top-right-radius: 0;\n\t}\n\t.list-group-horizontal-xl > .list-group-item:last-child {\n\t\tborder-top-right-radius: 0.625rem;\n\t\tborder-bottom-left-radius: 0;\n\t}\n\t.list-group-horizontal-xl > .list-group-item.active {\n\t\tmargin-top: 0;\n\t}\n\t.list-group-horizontal-xl > .list-group-item + .list-group-item {\n\t\tborder-top-width: 1px;\n\t\tborder-left-width: 0;\n\t}\n\t.list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n\t\tmargin-left: -1px;\n\t\tborder-left-width: 1px;\n\t}\n}\n\n@media (min-width: 1440) {\n\t.list-group-horizontal-xxl {\n\t\tflex-direction: row;\n\t}\n\t.list-group-horizontal-xxl > .list-group-item:first-child {\n\t\tborder-bottom-left-radius: 0.625rem;\n\t\tborder-top-right-radius: 0;\n\t}\n\t.list-group-horizontal-xxl > .list-group-item:last-child {\n\t\tborder-top-right-radius: 0.625rem;\n\t\tborder-bottom-left-radius: 0;\n\t}\n\t.list-group-horizontal-xxl > .list-group-item.active {\n\t\tmargin-top: 0;\n\t}\n\t.list-group-horizontal-xxl > .list-group-item + .list-group-item {\n\t\tborder-top-width: 1px;\n\t\tborder-left-width: 0;\n\t}\n\t.list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n\t\tmargin-left: -1px;\n\t\tborder-left-width: 1px;\n\t}\n}\n\n.list-group-flush {\n\tborder-radius: 0;\n}\n.list-group-flush > .list-group-item {\n\tborder-width: 0 0 1px;\n}\n.list-group-flush > .list-group-item:last-child {\n\tborder-bottom-width: 0;\n}\n\n.list-group-item-primary {\n\tcolor: #2e296d;\n\tbackground-color: #dbdaf0;\n}\n.list-group-item-primary.list-group-item-action:hover,\n.list-group-item-primary.list-group-item-action:focus {\n\tcolor: #2e296d;\n\tbackground-color: #c5c4d8;\n}\n.list-group-item-primary.list-group-item-action.active {\n\tcolor: #fff;\n\tbackground-color: #2e296d;\n\tborder-color: #2e296d;\n}\n\n.list-group-item-secondary {\n\tcolor: #974b37;\n\tbackground-color: #fee5de;\n}\n.list-group-item-secondary.list-group-item-action:hover,\n.list-group-item-secondary.list-group-item-action:focus {\n\tcolor: #974b37;\n\tbackground-color: #e5cec8;\n}\n.list-group-item-secondary.list-group-item-action.active {\n\tcolor: #fff;\n\tbackground-color: #974b37;\n\tborder-color: #974b37;\n}\n\n.list-group-item-success {\n\tcolor: #12703b;\n\tbackground-color: #d2f1e0;\n}\n.list-group-item-success.list-group-item-action:hover,\n.list-group-item-success.list-group-item-action:focus {\n\tcolor: #12703b;\n\tbackground-color: #bdd9ca;\n}\n.list-group-item-success.list-group-item-action.active {\n\tcolor: #fff;\n\tbackground-color: #12703b;\n\tborder-color: #12703b;\n}\n\n.list-group-item-info {\n\tcolor: #006862;\n\tbackground-color: #ccefed;\n}\n.list-group-item-info.list-group-item-action:hover,\n.list-group-item-info.list-group-item-action:focus {\n\tcolor: #006862;\n\tbackground-color: #b8d7d5;\n}\n.list-group-item-info.list-group-item-action.active {\n\tcolor: #fff;\n\tbackground-color: #006862;\n\tborder-color: #006862;\n}\n\n.list-group-item-warning {\n\tcolor: #654e19;\n\tbackground-color: #fef3d8;\n}\n.list-group-item-warning.list-group-item-action:hover,\n.list-group-item-warning.list-group-item-action:focus {\n\tcolor: #654e19;\n\tbackground-color: #e5dbc2;\n}\n.list-group-item-warning.list-group-item-action.active {\n\tcolor: #fff;\n\tbackground-color: #654e19;\n\tborder-color: #654e19;\n}\n\n.list-group-item-danger {\n\tcolor: #983232;\n\tbackground-color: #ffdddd;\n}\n.list-group-item-danger.list-group-item-action:hover,\n.list-group-item-danger.list-group-item-action:focus {\n\tcolor: #983232;\n\tbackground-color: #e6c7c7;\n}\n.list-group-item-danger.list-group-item-action.active {\n\tcolor: #fff;\n\tbackground-color: #983232;\n\tborder-color: #983232;\n}\n\n.list-group-item-light {\n\tcolor: #5e5e64;\n\tbackground-color: #fbfbfe;\n}\n.list-group-item-light.list-group-item-action:hover,\n.list-group-item-light.list-group-item-action:focus {\n\tcolor: #5e5e64;\n\tbackground-color: #e2e2e5;\n}\n.list-group-item-light.list-group-item-action.active {\n\tcolor: #fff;\n\tbackground-color: #5e5e64;\n\tborder-color: #5e5e64;\n}\n\n.list-group-item-dark {\n\tcolor: #1d2244;\n\tbackground-color: #d6d7e3;\n}\n.list-group-item-dark.list-group-item-action:hover,\n.list-group-item-dark.list-group-item-action:focus {\n\tcolor: #1d2244;\n\tbackground-color: #c1c2cc;\n}\n.list-group-item-dark.list-group-item-action.active {\n\tcolor: #fff;\n\tbackground-color: #1d2244;\n\tborder-color: #1d2244;\n}\n\n.btn-close {\n\tbox-sizing: content-box;\n\twidth: 1em;\n\theight: 1em;\n\tpadding: 0.25em 0.25em;\n\tcolor: #000;\n\tbackground: transparent\n\t\turl(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\")\n\t\tcenter/1em auto no-repeat;\n\tborder: 0;\n\tborder-radius: 0.625rem;\n\topacity: 0.5;\n}\n.btn-close:hover {\n\tcolor: #000;\n\ttext-decoration: none;\n\topacity: 0.75;\n}\n.btn-close:focus {\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.25rem rgba(77, 68, 181, 0.25);\n\topacity: 1;\n}\n.btn-close:disabled,\n.btn-close.disabled {\n\tpointer-events: none;\n\tuser-select: none;\n\topacity: 0.25;\n}\n\n.btn-close-white {\n\tfilter: invert(1) grayscale(100%) brightness(200%);\n}\n\n.toast {\n\twidth: 350px;\n\tmax-width: 100%;\n\tfont-size: 0.875rem;\n\tpointer-events: auto;\n\tbackground-color: rgba(255, 255, 255, 0.85);\n\tbackground-clip: padding-box;\n\tborder: 1px solid rgba(0, 0, 0, 0.1);\n\tbox-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n\tborder-radius: 0.625rem;\n}\n.toast.showing {\n\topacity: 0;\n}\n.toast:not(.show) {\n\tdisplay: none;\n}\n\n.toast-container {\n\twidth: max-content;\n\tmax-width: 100%;\n\tpointer-events: none;\n}\n.toast-container > :not(:last-child) {\n\tmargin-bottom: 15px;\n}\n\n.toast-header {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0.5rem 0.75rem;\n\tcolor: #6c757d;\n\tbackground-color: rgba(255, 255, 255, 0.85);\n\tbackground-clip: padding-box;\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.05);\n\tborder-top-left-radius: calc(0.625rem - 1px);\n\tborder-top-right-radius: calc(0.625rem - 1px);\n}\n.toast-header .btn-close {\n\tmargin-right: -0.375rem;\n\tmargin-left: 0.75rem;\n}\n\n.toast-body {\n\tpadding: 0.75rem;\n\tword-wrap: break-word;\n}\n\n.modal {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 1055;\n\tdisplay: none;\n\twidth: 100%;\n\theight: 100%;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\toutline: 0;\n}\n\n.modal-dialog {\n\tposition: relative;\n\twidth: auto;\n\tmargin: 0.5rem;\n\tpointer-events: none;\n}\n.modal.fade .modal-dialog {\n\ttransition: transform 0.3s ease-out;\n\ttransform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n\t.modal.fade .modal-dialog {\n\t\ttransition: none;\n\t}\n}\n.modal.show .modal-dialog {\n\ttransform: none;\n}\n.modal.modal-static .modal-dialog {\n\ttransform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n\theight: calc(100% - 1rem);\n}\n.modal-dialog-scrollable .modal-content {\n\tmax-height: 100%;\n\toverflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n\toverflow-y: auto;\n}\n\n.modal-dialog-centered {\n\tdisplay: flex;\n\talign-items: center;\n\tmin-height: calc(100% - 1rem);\n}\n\n.modal-content {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tpointer-events: auto;\n\tbackground-color: #fff;\n\tbackground-clip: padding-box;\n\tborder: 1px solid rgba(0, 0, 0, 0.2);\n\tborder-radius: 0.625rem;\n\toutline: 0;\n}\n\n.modal-backdrop {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 1050;\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground-color: #000;\n}\n.modal-backdrop.fade {\n\topacity: 0;\n}\n.modal-backdrop.show {\n\topacity: 0.5;\n}\n\n.modal-header {\n\tdisplay: flex;\n\tflex-shrink: 0;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 1rem 1rem;\n\tborder-bottom: 1px solid #eeeeee;\n\tborder-top-left-radius: calc(0.625rem - 1px);\n\tborder-top-right-radius: calc(0.625rem - 1px);\n}\n.modal-header .btn-close {\n\tpadding: 0.5rem 0.5rem;\n\tmargin: -0.5rem -0.5rem -0.5rem auto;\n}\n\n.modal-title {\n\tmargin-bottom: 0;\n\tline-height: 1.5;\n}\n\n.modal-body {\n\tposition: relative;\n\tflex: 1 1 auto;\n\tpadding: 1rem;\n}\n\n.modal-footer {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tflex-shrink: 0;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tpadding: 0.75rem;\n\tborder-top: 1px solid #eeeeee;\n\tborder-bottom-right-radius: calc(0.625rem - 1px);\n\tborder-bottom-left-radius: calc(0.625rem - 1px);\n}\n.modal-footer > * {\n\tmargin: 0.25rem;\n}\n\n@media (min-width: 576px) {\n\t.modal-dialog {\n\t\tmax-width: 500px;\n\t\tmargin: 1.75rem auto;\n\t}\n\t.modal-dialog-scrollable {\n\t\theight: calc(100% - 3.5rem);\n\t}\n\t.modal-dialog-centered {\n\t\tmin-height: calc(100% - 3.5rem);\n\t}\n\t.modal-sm {\n\t\tmax-width: 300px;\n\t}\n}\n\n@media (min-width: 992px) {\n\t.modal-lg,\n\t.modal-xl {\n\t\tmax-width: 800px;\n\t}\n}\n\n@media (min-width: 1200px) {\n\t.modal-xl {\n\t\tmax-width: 1140px;\n\t}\n}\n\n.modal-fullscreen {\n\twidth: 100vw;\n\tmax-width: none;\n\theight: 100%;\n\tmargin: 0;\n}\n.modal-fullscreen .modal-content {\n\theight: 100%;\n\tborder: 0;\n\tborder-radius: 0;\n}\n.modal-fullscreen .modal-header {\n\tborder-radius: 0;\n}\n.modal-fullscreen .modal-body {\n\toverflow-y: auto;\n}\n.modal-fullscreen .modal-footer {\n\tborder-radius: 0;\n}\n\n@media (max-width: 575.98px) {\n\t.modal-fullscreen-sm-down {\n\t\twidth: 100vw;\n\t\tmax-width: none;\n\t\theight: 100%;\n\t\tmargin: 0;\n\t}\n\t.modal-fullscreen-sm-down .modal-content {\n\t\theight: 100%;\n\t\tborder: 0;\n\t\tborder-radius: 0;\n\t}\n\t.modal-fullscreen-sm-down .modal-header {\n\t\tborder-radius: 0;\n\t}\n\t.modal-fullscreen-sm-down .modal-body {\n\t\toverflow-y: auto;\n\t}\n\t.modal-fullscreen-sm-down .modal-footer {\n\t\tborder-radius: 0;\n\t}\n}\n\n@media (max-width: 767.98px) {\n\t.modal-fullscreen-md-down {\n\t\twidth: 100vw;\n\t\tmax-width: none;\n\t\theight: 100%;\n\t\tmargin: 0;\n\t}\n\t.modal-fullscreen-md-down .modal-content {\n\t\theight: 100%;\n\t\tborder: 0;\n\t\tborder-radius: 0;\n\t}\n\t.modal-fullscreen-md-down .modal-header {\n\t\tborder-radius: 0;\n\t}\n\t.modal-fullscreen-md-down .modal-body {\n\t\toverflow-y: auto;\n\t}\n\t.modal-fullscreen-md-down .modal-footer {\n\t\tborder-radius: 0;\n\t}\n}\n\n@media (max-width: 991.98px) {\n\t.modal-fullscreen-lg-down {\n\t\twidth: 100vw;\n\t\tmax-width: none;\n\t\theight: 100%;\n\t\tmargin: 0;\n\t}\n\t.modal-fullscreen-lg-down .modal-content {\n\t\theight: 100%;\n\t\tborder: 0;\n\t\tborder-radius: 0;\n\t}\n\t.modal-fullscreen-lg-down .modal-header {\n\t\tborder-radius: 0;\n\t}\n\t.modal-fullscreen-lg-down .modal-body {\n\t\toverflow-y: auto;\n\t}\n\t.modal-fullscreen-lg-down .modal-footer {\n\t\tborder-radius: 0;\n\t}\n}\n\n@media (max-width: 1199.98px) {\n\t.modal-fullscreen-xl-down {\n\t\twidth: 100vw;\n\t\tmax-width: none;\n\t\theight: 100%;\n\t\tmargin: 0;\n\t}\n\t.modal-fullscreen-xl-down .modal-content {\n\t\theight: 100%;\n\t\tborder: 0;\n\t\tborder-radius: 0;\n\t}\n\t.modal-fullscreen-xl-down .modal-header {\n\t\tborder-radius: 0;\n\t}\n\t.modal-fullscreen-xl-down .modal-body {\n\t\toverflow-y: auto;\n\t}\n\t.modal-fullscreen-xl-down .modal-footer {\n\t\tborder-radius: 0;\n\t}\n}\n\n@media (max-width: 1439.98) {\n\t.modal-fullscreen-xxl-down {\n\t\twidth: 100vw;\n\t\tmax-width: none;\n\t\theight: 100%;\n\t\tmargin: 0;\n\t}\n\t.modal-fullscreen-xxl-down .modal-content {\n\t\theight: 100%;\n\t\tborder: 0;\n\t\tborder-radius: 0;\n\t}\n\t.modal-fullscreen-xxl-down .modal-header {\n\t\tborder-radius: 0;\n\t}\n\t.modal-fullscreen-xxl-down .modal-body {\n\t\toverflow-y: auto;\n\t}\n\t.modal-fullscreen-xxl-down .modal-footer {\n\t\tborder-radius: 0;\n\t}\n}\n\n.tooltip {\n\tposition: absolute;\n\tz-index: 1080;\n\tdisplay: block;\n\tmargin: 0;\n\tfont-family: 'Poppins', sans-serif;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 1.5;\n\ttext-align: left;\n\ttext-align: start;\n\ttext-decoration: none;\n\ttext-shadow: none;\n\ttext-transform: none;\n\tletter-spacing: normal;\n\tword-break: normal;\n\tword-spacing: normal;\n\twhite-space: normal;\n\tline-break: auto;\n\tfont-size: 0.76563rem;\n\tword-wrap: break-word;\n\topacity: 0;\n}\n@media (min-width: 1200px) {\n\t.tooltip {\n\t\tfont-size: 0.76562rem;\n\t}\n}\n.tooltip.show {\n\topacity: 0.9;\n}\n.tooltip .tooltip-arrow {\n\tposition: absolute;\n\tdisplay: block;\n\twidth: 0.8rem;\n\theight: 0.4rem;\n}\n.tooltip .tooltip-arrow::before {\n\tposition: absolute;\n\tcontent: '';\n\tborder-color: transparent;\n\tborder-style: solid;\n}\n\n.bs-tooltip-top,\n.bs-tooltip-auto[data-popper-placement^='top'] {\n\tpadding: 0.4rem 0;\n}\n.bs-tooltip-top .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^='top'] .tooltip-arrow {\n\tbottom: 0;\n}\n.bs-tooltip-top .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^='top'] .tooltip-arrow::before {\n\ttop: -1px;\n\tborder-width: 0.4rem 0.4rem 0;\n\tborder-top-color: #000;\n}\n\n.bs-tooltip-end,\n.bs-tooltip-auto[data-popper-placement^='right'] {\n\tpadding: 0 0.4rem;\n}\n.bs-tooltip-end .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^='right'] .tooltip-arrow {\n\tleft: 0;\n\twidth: 0.4rem;\n\theight: 0.8rem;\n}\n.bs-tooltip-end .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^='right'] .tooltip-arrow::before {\n\tright: -1px;\n\tborder-width: 0.4rem 0.4rem 0.4rem 0;\n\tborder-right-color: #000;\n}\n\n.bs-tooltip-bottom,\n.bs-tooltip-auto[data-popper-placement^='bottom'] {\n\tpadding: 0.4rem 0;\n}\n.bs-tooltip-bottom .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^='bottom'] .tooltip-arrow {\n\ttop: 0;\n}\n.bs-tooltip-bottom .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^='bottom'] .tooltip-arrow::before {\n\tbottom: -1px;\n\tborder-width: 0 0.4rem 0.4rem;\n\tborder-bottom-color: #000;\n}\n\n.bs-tooltip-start,\n.bs-tooltip-auto[data-popper-placement^='left'] {\n\tpadding: 0 0.4rem;\n}\n.bs-tooltip-start .tooltip-arrow,\n.bs-tooltip-auto[data-popper-placement^='left'] .tooltip-arrow {\n\tright: 0;\n\twidth: 0.4rem;\n\theight: 0.8rem;\n}\n.bs-tooltip-start .tooltip-arrow::before,\n.bs-tooltip-auto[data-popper-placement^='left'] .tooltip-arrow::before {\n\tleft: -1px;\n\tborder-width: 0.4rem 0 0.4rem 0.4rem;\n\tborder-left-color: #000;\n}\n\n.tooltip-inner {\n\tmax-width: 200px;\n\tpadding: 0.25rem 0.5rem;\n\tcolor: #fff;\n\ttext-align: center;\n\tbackground-color: #000;\n\tborder-radius: 0.625rem;\n}\n\n.popover {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0 /* rtl:ignore */;\n\tz-index: 1070;\n\tdisplay: block;\n\tmax-width: 276px;\n\tfont-family: 'Poppins', sans-serif;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 1.5;\n\ttext-align: left;\n\ttext-align: start;\n\ttext-decoration: none;\n\ttext-shadow: none;\n\ttext-transform: none;\n\tletter-spacing: normal;\n\tword-break: normal;\n\tword-spacing: normal;\n\twhite-space: normal;\n\tline-break: auto;\n\tfont-size: 0.76563rem;\n\tword-wrap: break-word;\n\tbackground-color: #fff;\n\tbackground-clip: padding-box;\n\tborder: 1px solid rgba(0, 0, 0, 0.2);\n\tborder-radius: 0.625rem;\n}\n@media (min-width: 1200px) {\n\t.popover {\n\t\tfont-size: 0.76562rem;\n\t}\n}\n.popover .popover-arrow {\n\tposition: absolute;\n\tdisplay: block;\n\twidth: 1rem;\n\theight: 0.5rem;\n}\n.popover .popover-arrow::before,\n.popover .popover-arrow::after {\n\tposition: absolute;\n\tdisplay: block;\n\tcontent: '';\n\tborder-color: transparent;\n\tborder-style: solid;\n}\n\n.bs-popover-top > .popover-arrow,\n.bs-popover-auto[data-popper-placement^='top'] > .popover-arrow {\n\tbottom: calc(-0.5rem - 1px);\n}\n.bs-popover-top > .popover-arrow::before,\n.bs-popover-auto[data-popper-placement^='top'] > .popover-arrow::before {\n\tbottom: 0;\n\tborder-width: 0.5rem 0.5rem 0;\n\tborder-top-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-top > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^='top'] > .popover-arrow::after {\n\tbottom: 1px;\n\tborder-width: 0.5rem 0.5rem 0;\n\tborder-top-color: #fff;\n}\n\n.bs-popover-end > .popover-arrow,\n.bs-popover-auto[data-popper-placement^='right'] > .popover-arrow {\n\tleft: calc(-0.5rem - 1px);\n\twidth: 0.5rem;\n\theight: 1rem;\n}\n.bs-popover-end > .popover-arrow::before,\n.bs-popover-auto[data-popper-placement^='right'] > .popover-arrow::before {\n\tleft: 0;\n\tborder-width: 0.5rem 0.5rem 0.5rem 0;\n\tborder-right-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-end > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^='right'] > .popover-arrow::after {\n\tleft: 1px;\n\tborder-width: 0.5rem 0.5rem 0.5rem 0;\n\tborder-right-color: #fff;\n}\n\n.bs-popover-bottom > .popover-arrow,\n.bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow {\n\ttop: calc(-0.5rem - 1px);\n}\n.bs-popover-bottom > .popover-arrow::before,\n.bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow::before {\n\ttop: 0;\n\tborder-width: 0 0.5rem 0.5rem 0.5rem;\n\tborder-bottom-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-bottom > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^='bottom'] > .popover-arrow::after {\n\ttop: 1px;\n\tborder-width: 0 0.5rem 0.5rem 0.5rem;\n\tborder-bottom-color: #fff;\n}\n\n.bs-popover-bottom .popover-header::before,\n.bs-popover-auto[data-popper-placement^='bottom'] .popover-header::before {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 50%;\n\tdisplay: block;\n\twidth: 1rem;\n\tmargin-left: -0.5rem;\n\tcontent: '';\n\tborder-bottom: 1px solid #f0f0f0;\n}\n\n.bs-popover-start > .popover-arrow,\n.bs-popover-auto[data-popper-placement^='left'] > .popover-arrow {\n\tright: calc(-0.5rem - 1px);\n\twidth: 0.5rem;\n\theight: 1rem;\n}\n.bs-popover-start > .popover-arrow::before,\n.bs-popover-auto[data-popper-placement^='left'] > .popover-arrow::before {\n\tright: 0;\n\tborder-width: 0.5rem 0 0.5rem 0.5rem;\n\tborder-left-color: rgba(0, 0, 0, 0.25);\n}\n.bs-popover-start > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^='left'] > .popover-arrow::after {\n\tright: 1px;\n\tborder-width: 0.5rem 0 0.5rem 0.5rem;\n\tborder-left-color: #fff;\n}\n\n.popover-header {\n\tpadding: 0.5rem 1rem;\n\tmargin-bottom: 0;\n\tfont-size: 0.875rem;\n\tcolor: #303972;\n\tbackground-color: #f0f0f0;\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.2);\n\tborder-top-left-radius: calc(0.625rem - 1px);\n\tborder-top-right-radius: calc(0.625rem - 1px);\n}\n.popover-header:empty {\n\tdisplay: none;\n}\n\n.popover-body {\n\tpadding: 1rem 1rem;\n\tcolor: #a098ae;\n}\n\n.carousel {\n\tposition: relative;\n}\n\n.carousel.pointer-event {\n\ttouch-action: pan-y;\n}\n\n.carousel-inner {\n\tposition: relative;\n\twidth: 100%;\n\toverflow: hidden;\n}\n.carousel-inner::after {\n\tdisplay: block;\n\tclear: both;\n\tcontent: '';\n}\n\n.carousel-item {\n\tposition: relative;\n\tdisplay: none;\n\tfloat: left;\n\twidth: 100%;\n\tmargin-right: -100%;\n\tbackface-visibility: hidden;\n\ttransition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.carousel-item {\n\t\ttransition: none;\n\t}\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n\tdisplay: block;\n}\n\n/* rtl:begin:ignore */\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n\ttransform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n\ttransform: translateX(-100%);\n}\n\n/* rtl:end:ignore */\n.carousel-fade .carousel-item {\n\topacity: 0;\n\ttransition-property: opacity;\n\ttransform: none;\n}\n\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n\tz-index: 1;\n\topacity: 1;\n}\n\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n\tz-index: 0;\n\topacity: 0;\n\ttransition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.carousel-fade .active.carousel-item-start,\n\t.carousel-fade .active.carousel-item-end {\n\t\ttransition: none;\n\t}\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tz-index: 1;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 15%;\n\tpadding: 0;\n\tcolor: #fff;\n\ttext-align: center;\n\tbackground: none;\n\tborder: 0;\n\topacity: 0.5;\n\ttransition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.carousel-control-prev,\n\t.carousel-control-next {\n\t\ttransition: none;\n\t}\n}\n.carousel-control-prev:hover,\n.carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n\tcolor: #fff;\n\ttext-decoration: none;\n\toutline: 0;\n\topacity: 0.9;\n}\n\n.carousel-control-prev {\n\tleft: 0;\n}\n\n.carousel-control-next {\n\tright: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n\tdisplay: inline-block;\n\twidth: 2rem;\n\theight: 2rem;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50%;\n\tbackground-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: 2;\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 0;\n\tmargin-right: 15%;\n\tmargin-bottom: 1rem;\n\tmargin-left: 15%;\n\tlist-style: none;\n}\n.carousel-indicators [data-bs-target] {\n\tbox-sizing: content-box;\n\tflex: 0 1 auto;\n\twidth: 30px;\n\theight: 3px;\n\tpadding: 0;\n\tmargin-right: 3px;\n\tmargin-left: 3px;\n\ttext-indent: -999px;\n\tcursor: pointer;\n\tbackground-color: #fff;\n\tbackground-clip: padding-box;\n\tborder: 0;\n\tborder-top: 10px solid transparent;\n\tborder-bottom: 10px solid transparent;\n\topacity: 0.5;\n\ttransition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.carousel-indicators [data-bs-target] {\n\t\ttransition: none;\n\t}\n}\n.carousel-indicators .active {\n\topacity: 1;\n}\n\n.carousel-caption {\n\tposition: absolute;\n\tright: 15%;\n\tbottom: 1.25rem;\n\tleft: 15%;\n\tpadding-top: 1.25rem;\n\tpadding-bottom: 1.25rem;\n\tcolor: #fff;\n\ttext-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n\tfilter: invert(1) grayscale(100);\n}\n\n.carousel-dark .carousel-indicators [data-bs-target] {\n\tbackground-color: #000;\n}\n\n.carousel-dark .carousel-caption {\n\tcolor: #000;\n}\n\n@keyframes spinner-border {\n\tto {\n\t\ttransform: rotate(360deg) /* rtl:ignore */;\n\t}\n}\n\n.spinner-border {\n\tdisplay: inline-block;\n\twidth: 2rem;\n\theight: 2rem;\n\tvertical-align: -0.125em;\n\tborder: 0.25em solid currentColor;\n\tborder-right-color: transparent;\n\tborder-radius: 50%;\n\tanimation: 0.75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n\twidth: 1rem;\n\theight: 1rem;\n\tborder-width: 0.2em;\n}\n\n@keyframes spinner-grow {\n\t0% {\n\t\ttransform: scale(0);\n\t}\n\t50% {\n\t\topacity: 1;\n\t\ttransform: none;\n\t}\n}\n\n.spinner-grow {\n\tdisplay: inline-block;\n\twidth: 2rem;\n\theight: 2rem;\n\tvertical-align: -0.125em;\n\tbackground-color: currentColor;\n\tborder-radius: 50%;\n\topacity: 0;\n\tanimation: 0.75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n\twidth: 1rem;\n\theight: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n\t.spinner-border,\n\t.spinner-grow {\n\t\tanimation-duration: 1.5s;\n\t}\n}\n\n.offcanvas {\n\tposition: fixed;\n\tbottom: 0;\n\tz-index: 1045;\n\tdisplay: flex;\n\tflex-direction: column;\n\tmax-width: 100%;\n\tvisibility: hidden;\n\tbackground-color: #fff;\n\tbackground-clip: padding-box;\n\toutline: 0;\n\ttransition: transform 0.3s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n\t.offcanvas {\n\t\ttransition: none;\n\t}\n}\n\n.offcanvas-backdrop {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 1040;\n\twidth: 100vw;\n\theight: 100vh;\n\tbackground-color: #000;\n}\n.offcanvas-backdrop.fade {\n\topacity: 0;\n}\n.offcanvas-backdrop.show {\n\topacity: 0.5;\n}\n\n.offcanvas-header {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 1rem 1rem;\n}\n.offcanvas-header .btn-close {\n\tpadding: 0.5rem 0.5rem;\n\tmargin-top: -0.5rem;\n\tmargin-right: -0.5rem;\n\tmargin-bottom: -0.5rem;\n}\n\n.offcanvas-title {\n\tmargin-bottom: 0;\n\tline-height: 1.5;\n}\n\n.offcanvas-body {\n\tflex-grow: 1;\n\tpadding: 1rem 1rem;\n\toverflow-y: auto;\n}\n\n.offcanvas-start {\n\ttop: 0;\n\tleft: 0;\n\twidth: 400px;\n\tborder-right: 1px solid rgba(0, 0, 0, 0.2);\n\ttransform: translateX(-100%);\n}\n\n.offcanvas-end {\n\ttop: 0;\n\tright: 0;\n\twidth: 400px;\n\tborder-left: 1px solid rgba(0, 0, 0, 0.2);\n\ttransform: translateX(100%);\n}\n\n.offcanvas-top {\n\ttop: 0;\n\tright: 0;\n\tleft: 0;\n\theight: 30vh;\n\tmax-height: 100%;\n\tborder-bottom: 1px solid rgba(0, 0, 0, 0.2);\n\ttransform: translateY(-100%);\n}\n\n.offcanvas-bottom {\n\tright: 0;\n\tleft: 0;\n\theight: 30vh;\n\tmax-height: 100%;\n\tborder-top: 1px solid rgba(0, 0, 0, 0.2);\n\ttransform: translateY(100%);\n}\n\n.offcanvas.show {\n\ttransform: none;\n}\n\n.placeholder {\n\tdisplay: inline-block;\n\tmin-height: 1em;\n\tvertical-align: middle;\n\tcursor: wait;\n\tbackground-color: currentColor;\n\topacity: 0.5;\n}\n.placeholder.btn::before {\n\tdisplay: inline-block;\n\tcontent: '';\n}\n\n.placeholder-xs {\n\tmin-height: 0.6em;\n}\n\n.placeholder-sm {\n\tmin-height: 0.8em;\n}\n\n.placeholder-lg {\n\tmin-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n\tanimation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n\t50% {\n\t\topacity: 0.2;\n\t}\n}\n\n.placeholder-wave {\n\tmask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);\n\tmask-size: 200% 100%;\n\tanimation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n\t100% {\n\t\tmask-position: -200% 0%;\n\t}\n}\n\n.clearfix::after {\n\tdisplay: block;\n\tclear: both;\n\tcontent: '';\n}\n\n.link-primary {\n\tcolor: #4d44b5;\n}\n.link-primary:hover,\n.link-primary:focus {\n\tcolor: #3e3691;\n}\n\n.link-secondary {\n\tcolor: #fb7d5b;\n}\n.link-secondary:hover,\n.link-secondary:focus {\n\tcolor: #fc977c;\n}\n\n.link-success {\n\tcolor: #1eba62;\n}\n.link-success:hover,\n.link-success:focus {\n\tcolor: #4bc881;\n}\n\n.link-info {\n\tcolor: #00ada3;\n}\n.link-info:hover,\n.link-info:focus {\n\tcolor: #33bdb5;\n}\n\n.link-warning {\n\tcolor: #fcc43e;\n}\n.link-warning:hover,\n.link-warning:focus {\n\tcolor: #fdd065;\n}\n\n.link-danger {\n\tcolor: #fd5353;\n}\n.link-danger:hover,\n.link-danger:focus {\n\tcolor: #fd7575;\n}\n\n.link-light {\n\tcolor: #ebebf9;\n}\n.link-light:hover,\n.link-light:focus {\n\tcolor: #efeffa;\n}\n\n.link-dark {\n\tcolor: #303972;\n}\n.link-dark:hover,\n.link-dark:focus {\n\tcolor: #262e5b;\n}\n\n.ratio {\n\tposition: relative;\n\twidth: 100%;\n}\n.ratio::before {\n\tdisplay: block;\n\tpadding-top: var(--bs-aspect-ratio);\n\tcontent: '';\n}\n.ratio > * {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ratio-1x1 {\n\t--bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n\t--bs-aspect-ratio: calc(3 / 4 * 100%);\n}\n\n.ratio-16x9 {\n\t--bs-aspect-ratio: calc(9 / 16 * 100%);\n}\n\n.ratio-21x9 {\n\t--bs-aspect-ratio: calc(9 / 21 * 100%);\n}\n\n.fixed-top {\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tleft: 0;\n\tz-index: 1030;\n}\n\n.fixed-bottom {\n\tposition: fixed;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: 1030;\n}\n\n.sticky-top {\n\tposition: sticky;\n\ttop: 0;\n\tz-index: 1020;\n}\n\n@media (min-width: 576px) {\n\t.sticky-sm-top {\n\t\tposition: sticky;\n\t\ttop: 0;\n\t\tz-index: 1020;\n\t}\n}\n\n@media (min-width: 768px) {\n\t.sticky-md-top {\n\t\tposition: sticky;\n\t\ttop: 0;\n\t\tz-index: 1020;\n\t}\n}\n\n@media (min-width: 992px) {\n\t.sticky-lg-top {\n\t\tposition: sticky;\n\t\ttop: 0;\n\t\tz-index: 1020;\n\t}\n}\n\n@media (min-width: 1200px) {\n\t.sticky-xl-top {\n\t\tposition: sticky;\n\t\ttop: 0;\n\t\tz-index: 1020;\n\t}\n}\n\n@media (min-width: 1440) {\n\t.sticky-xxl-top {\n\t\tposition: sticky;\n\t\ttop: 0;\n\t\tz-index: 1020;\n\t}\n}\n\n.hstack {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\talign-self: stretch;\n}\n\n.vstack {\n\tdisplay: flex;\n\tflex: 1 1 auto;\n\tflex-direction: column;\n\talign-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n\tposition: absolute !important;\n\twidth: 1px !important;\n\theight: 1px !important;\n\tpadding: 0 !important;\n\tmargin: -1px !important;\n\toverflow: hidden !important;\n\tclip: rect(0, 0, 0, 0) !important;\n\twhite-space: nowrap !important;\n\tborder: 0 !important;\n}\n\n.stretched-link::after {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: 1;\n\tcontent: '';\n}\n\n.text-truncate {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.vr {\n\tdisplay: inline-block;\n\talign-self: stretch;\n\twidth: 1px;\n\tmin-height: 1em;\n\tbackground-color: currentColor;\n\topacity: 0.25;\n}\n\n.align-baseline {\n\tvertical-align: baseline !important;\n}\n\n.align-top {\n\tvertical-align: top !important;\n}\n\n.align-middle {\n\tvertical-align: middle !important;\n}\n\n.align-bottom {\n\tvertical-align: bottom !important;\n}\n\n.align-text-bottom {\n\tvertical-align: text-bottom !important;\n}\n\n.align-text-top {\n\tvertical-align: text-top !important;\n}\n\n.float-start {\n\tfloat: left !important;\n}\n\n.float-end {\n\tfloat: right !important;\n}\n\n.float-none {\n\tfloat: none !important;\n}\n\n.opacity-0 {\n\topacity: 0 !important;\n}\n\n.opacity-25 {\n\topacity: 0.25 !important;\n}\n\n.opacity-50 {\n\topacity: 0.5 !important;\n}\n\n.opacity-75 {\n\topacity: 0.75 !important;\n}\n\n.opacity-100 {\n\topacity: 1 !important;\n}\n\n.overflow-auto {\n\toverflow: auto !important;\n}\n\n.overflow-hidden {\n\toverflow: hidden !important;\n}\n\n.overflow-visible {\n\toverflow: visible !important;\n}\n\n.overflow-scroll {\n\toverflow: scroll !important;\n}\n\n.d-inline {\n\tdisplay: inline !important;\n}\n\n.d-inline-block {\n\tdisplay: inline-block !important;\n}\n\n.d-block {\n\tdisplay: block !important;\n}\n\n.d-grid {\n\tdisplay: grid !important;\n}\n\n.d-table {\n\tdisplay: table !important;\n}\n\n.d-table-row {\n\tdisplay: table-row !important;\n}\n\n.d-table-cell {\n\tdisplay: table-cell !important;\n}\n\n.d-flex {\n\tdisplay: flex !important;\n}\n\n.d-inline-flex {\n\tdisplay: inline-flex !important;\n}\n\n.d-none {\n\tdisplay: none !important;\n}\n\n.shadow {\n\tbox-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n\n.shadow-sm {\n\tbox-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n\n.shadow-lg {\n\tbox-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\n}\n\n.shadow-none {\n\tbox-shadow: none !important;\n}\n\n.position-static {\n\tposition: static !important;\n}\n\n.position-relative {\n\tposition: relative !important;\n}\n\n.position-absolute {\n\tposition: absolute !important;\n}\n\n.position-fixed {\n\tposition: fixed !important;\n}\n\n.position-sticky {\n\tposition: sticky !important;\n}\n\n.top-0 {\n\ttop: 0 !important;\n}\n\n.top-50 {\n\ttop: 50% !important;\n}\n\n.top-100 {\n\ttop: 100% !important;\n}\n\n.bottom-0 {\n\tbottom: 0 !important;\n}\n\n.bottom-50 {\n\tbottom: 50% !important;\n}\n\n.bottom-100 {\n\tbottom: 100% !important;\n}\n\n.start-0 {\n\tleft: 0 !important;\n}\n\n.start-50 {\n\tleft: 50% !important;\n}\n\n.start-100 {\n\tleft: 100% !important;\n}\n\n.end-0 {\n\tright: 0 !important;\n}\n\n.end-50 {\n\tright: 50% !important;\n}\n\n.end-100 {\n\tright: 100% !important;\n}\n\n.translate-middle {\n\ttransform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n\ttransform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n\ttransform: translateY(-50%) !important;\n}\n\n.border {\n\tborder: 1px solid #eeeeee !important;\n}\n\n.border-0 {\n\tborder: 0 !important;\n}\n\n.border-top {\n\tborder-top: 1px solid #eeeeee !important;\n}\n\n.border-top-0 {\n\tborder-top: 0 !important;\n}\n\n.border-end {\n\tborder-right: 1px solid #eeeeee !important;\n}\n\n.border-end-0 {\n\tborder-right: 0 !important;\n}\n\n.border-bottom {\n\tborder-bottom: 1px solid #eeeeee !important;\n}\n\n.border-bottom-0 {\n\tborder-bottom: 0 !important;\n}\n\n.border-start {\n\tborder-left: 1px solid #eeeeee !important;\n}\n\n.border-start-0 {\n\tborder-left: 0 !important;\n}\n\n.border-primary {\n\tborder-color: #4d44b5 !important;\n}\n\n.swal-border-danger {\n\tborder: 2px solid #e64942 !important;\n}\n\n.border-secondary {\n\tborder-color: #fb7d5b !important;\n}\n\n.border-success {\n\tborder-color: #1eba62 !important;\n}\n\n.border-info {\n\tborder-color: #00ada3 !important;\n}\n\n.border-warning {\n\tborder-color: #fcc43e !important;\n}\n\n.border-danger {\n\tborder-color: #fd5353 !important;\n}\n\n.border-light {\n\tborder-color: #ebebf9 !important;\n}\n\n.border-dark {\n\tborder-color: #303972 !important;\n}\n\n.border-white {\n\tborder-color: #fff !important;\n}\n\n.border-1 {\n\tborder-width: 1px !important;\n}\n\n.border-2 {\n\tborder-width: 2px !important;\n}\n\n.border-3 {\n\tborder-width: 3px !important;\n}\n\n.border-4 {\n\tborder-width: 4px !important;\n}\n\n.border-5 {\n\tborder-width: 5px !important;\n}\n\n.w-25 {\n\twidth: 25% !important;\n}\n\n.w-50 {\n\twidth: 50% !important;\n}\n\n.w-75 {\n\twidth: 75% !important;\n}\n\n.w-100 {\n\twidth: 100% !important;\n}\n\n.w-auto {\n\twidth: auto !important;\n}\n\n.mw-100 {\n\tmax-width: 100% !important;\n}\n\n.vw-100 {\n\twidth: 100vw !important;\n}\n\n.min-vw-100 {\n\tmin-width: 100vw !important;\n}\n\n.h-25 {\n\theight: 25% !important;\n}\n\n.h-50 {\n\theight: 50% !important;\n}\n\n.h-75 {\n\theight: 75% !important;\n}\n\n.h-100 {\n\theight: 100% !important;\n}\n\n.h-auto {\n\theight: auto !important;\n}\n\n.mh-100 {\n\tmax-height: 100% !important;\n}\n\n.vh-100 {\n\theight: 100vh !important;\n}\n\n.min-vh-100 {\n\tmin-height: 100vh !important;\n}\n\n.flex-fill {\n\tflex: 1 1 auto !important;\n}\n\n.flex-row {\n\tflex-direction: row !important;\n}\n\n.flex-column {\n\tflex-direction: column !important;\n}\n\n.flex-row-reverse {\n\tflex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n\tflex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n\tflex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n\tflex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n\tflex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n\tflex-shrink: 1 !important;\n}\n\n.flex-wrap {\n\tflex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n\tflex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n\tflex-wrap: wrap-reverse !important;\n}\n\n.gap-0 {\n\tgap: 0 !important;\n}\n\n.gap-1 {\n\tgap: 0.25rem !important;\n}\n\n.gap-2 {\n\tgap: 0.5rem !important;\n}\n\n.gap-3 {\n\tgap: 1rem !important;\n}\n\n.gap-4 {\n\tgap: 1.875rem !important;\n}\n\n.gap-5 {\n\tgap: 3rem !important;\n}\n\n.justify-content-start {\n\tjustify-content: flex-start !important;\n}\n\n.justify-content-end {\n\tjustify-content: flex-end !important;\n}\n\n.justify-content-center {\n\tjustify-content: center !important;\n}\n\n.justify-content-between {\n\tjustify-content: space-between !important;\n}\n\n.justify-content-around {\n\tjustify-content: space-around !important;\n}\n\n.justify-content-evenly {\n\tjustify-content: space-evenly !important;\n}\n\n.align-items-start {\n\talign-items: flex-start !important;\n}\n\n.align-items-end {\n\talign-items: flex-end !important;\n}\n\n.align-items-center {\n\talign-items: center !important;\n}\n\n.align-items-baseline {\n\talign-items: baseline !important;\n}\n\n.align-items-stretch {\n\talign-items: stretch !important;\n}\n\n.align-content-start {\n\talign-content: flex-start !important;\n}\n\n.align-content-end {\n\talign-content: flex-end !important;\n}\n\n.align-content-center {\n\talign-content: center !important;\n}\n\n.align-content-between {\n\talign-content: space-between !important;\n}\n\n.align-content-around {\n\talign-content: space-around !important;\n}\n\n.align-content-stretch {\n\talign-content: stretch !important;\n}\n\n.align-self-auto {\n\talign-self: auto !important;\n}\n\n.align-self-start {\n\talign-self: flex-start !important;\n}\n\n.align-self-end {\n\talign-self: flex-end !important;\n}\n\n.align-self-center {\n\talign-self: center !important;\n}\n\n.align-self-baseline {\n\talign-self: baseline !important;\n}\n\n.align-self-stretch {\n\talign-self: stretch !important;\n}\n\n.order-first {\n\torder: -1 !important;\n}\n\n.order-0 {\n\torder: 0 !important;\n}\n\n.order-1 {\n\torder: 1 !important;\n}\n\n.order-2 {\n\torder: 2 !important;\n}\n\n.order-3 {\n\torder: 3 !important;\n}\n\n.order-4 {\n\torder: 4 !important;\n}\n\n.order-5 {\n\torder: 5 !important;\n}\n\n.order-last {\n\torder: 6 !important;\n}\n\n.m-0 {\n\tmargin: 0 !important;\n}\n\n.m-1 {\n\tmargin: 0.25rem !important;\n}\n\n.m-2 {\n\tmargin: 0.5rem !important;\n}\n\n.m-3 {\n\tmargin: 1rem !important;\n}\n\n.m-4 {\n\tmargin: 1.875rem !important;\n}\n\n.m-5 {\n\tmargin: 3rem !important;\n}\n\n.m-auto {\n\tmargin: auto !important;\n}\n\n.mx-0 {\n\tmargin-right: 0 !important;\n\tmargin-left: 0 !important;\n}\n\n.mx-1 {\n\tmargin-right: 0.25rem !important;\n\tmargin-left: 0.25rem !important;\n}\n\n.mx-2 {\n\tmargin-right: 0.5rem !important;\n\tmargin-left: 0.5rem !important;\n}\n\n.mx-3 {\n\tmargin-right: 1rem !important;\n\tmargin-left: 1rem !important;\n}\n\n.mx-4 {\n\tmargin-right: 1.875rem !important;\n\tmargin-left: 1.875rem !important;\n}\n\n.mx-5 {\n\tmargin-right: 3rem !important;\n\tmargin-left: 3rem !important;\n}\n\n.mx-auto {\n\tmargin-right: auto !important;\n\tmargin-left: auto !important;\n}\n\n.my-0 {\n\tmargin-top: 0 !important;\n\tmargin-bottom: 0 !important;\n}\n\n.my-1 {\n\tmargin-top: 0.25rem !important;\n\tmargin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n\tmargin-top: 0.5rem !important;\n\tmargin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n\tmargin-top: 1rem !important;\n\tmargin-bottom: 1rem !important;\n}\n\n.my-4 {\n\tmargin-top: 1.875rem !important;\n\tmargin-bottom: 1.875rem !important;\n}\n\n.my-5 {\n\tmargin-top: 3rem !important;\n\tmargin-bottom: 3rem !important;\n}\n\n.my-auto {\n\tmargin-top: auto !important;\n\tmargin-bottom: auto !important;\n}\n\n.mt-0 {\n\tmargin-top: 0 !important;\n}\n\n.mt-1 {\n\tmargin-top: 0.25rem !important;\n}\n\n.mt-2 {\n\tmargin-top: 0.5rem !important;\n}\n\n.mt-3 {\n\tmargin-top: 1rem !important;\n}\n\n.mt-4 {\n\tmargin-top: 1.875rem !important;\n}\n\n.mt-5 {\n\tmargin-top: 3rem !important;\n}\n\n.mt-auto {\n\tmargin-top: auto !important;\n}\n\n.me-0 {\n\tmargin-right: 0 !important;\n}\n\n.me-1 {\n\tmargin-right: 0.25rem !important;\n}\n\n.me-2 {\n\tmargin-right: 0.5rem !important;\n}\n\n.me-3 {\n\tmargin-right: 1rem !important;\n}\n\n.me-4 {\n\tmargin-right: 1.875rem !important;\n}\n\n.me-5 {\n\tmargin-right: 3rem !important;\n}\n\n.me-auto {\n\tmargin-right: auto !important;\n}\n\n.mb-0 {\n\tmargin-bottom: 0 !important;\n}\n\n.mb-1 {\n\tmargin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n\tmargin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n\tmargin-bottom: 1rem !important;\n}\n\n.mb-4 {\n\tmargin-bottom: 1.875rem !important;\n}\n\n.mb-5 {\n\tmargin-bottom: 3rem !important;\n}\n\n.mb-auto {\n\tmargin-bottom: auto !important;\n}\n\n.ms-0 {\n\tmargin-left: 0 !important;\n}\n\n.ms-1 {\n\tmargin-left: 0.25rem !important;\n}\n\n.ms-2 {\n\tmargin-left: 0.5rem !important;\n}\n\n.ms-3 {\n\tmargin-left: 1rem !important;\n}\n\n.ms-4 {\n\tmargin-left: 1.875rem !important;\n}\n\n.ms-5 {\n\tmargin-left: 3rem !important;\n}\n\n.ms-auto {\n\tmargin-left: auto !important;\n}\n\n.p-0 {\n\tpadding: 0 !important;\n}\n\n.p-1 {\n\tpadding: 0.25rem !important;\n}\n\n.p-2 {\n\tpadding: 0.5rem !important;\n}\n\n.p-3 {\n\tpadding: 1rem !important;\n}\n\n.p-4 {\n\tpadding: 1.875rem !important;\n}\n\n.p-5 {\n\tpadding: 3rem !important;\n}\n\n.px-0 {\n\tpadding-right: 0 !important;\n\tpadding-left: 0 !important;\n}\n\n.px-1 {\n\tpadding-right: 0.25rem !important;\n\tpadding-left: 0.25rem !important;\n}\n\n.px-2 {\n\tpadding-right: 0.5rem !important;\n\tpadding-left: 0.5rem !important;\n}\n\n.px-3 {\n\tpadding-right: 1rem !important;\n\tpadding-left: 1rem !important;\n}\n\n.px-4 {\n\tpadding-right: 1.875rem !important;\n\tpadding-left: 1.875rem !important;\n}\n\n.px-5 {\n\tpadding-right: 3rem !important;\n\tpadding-left: 3rem !important;\n}\n\n.py-0 {\n\tpadding-top: 0 !important;\n\tpadding-bottom: 0 !important;\n}\n\n.py-1 {\n\tpadding-top: 0.25rem !important;\n\tpadding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n\tpadding-top: 0.5rem !important;\n\tpadding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n\tpadding-top: 1rem !important;\n\tpadding-bottom: 1rem !important;\n}\n\n.py-4 {\n\tpadding-top: 1.875rem !important;\n\tpadding-bottom: 1.875rem !important;\n}\n\n.py-5 {\n\tpadding-top: 3rem !important;\n\tpadding-bottom: 3rem !important;\n}\n\n.pt-0 {\n\tpadding-top: 0 !important;\n}\n\n.pt-1 {\n\tpadding-top: 0.25rem !important;\n}\n\n.pt-2 {\n\tpadding-top: 0.5rem !important;\n}\n\n.pt-3 {\n\tpadding-top: 1rem !important;\n}\n\n.pt-4 {\n\tpadding-top: 1.875rem !important;\n}\n\n.pt-5 {\n\tpadding-top: 3rem !important;\n}\n\n.pe-0 {\n\tpadding-right: 0 !important;\n}\n\n.pe-1 {\n\tpadding-right: 0.25rem !important;\n}\n\n.pe-2 {\n\tpadding-right: 0.5rem !important;\n}\n\n.pe-3 {\n\tpadding-right: 1rem !important;\n}\n\n.pe-4 {\n\tpadding-right: 1.875rem !important;\n}\n\n.pe-5 {\n\tpadding-right: 3rem !important;\n}\n\n.pb-0 {\n\tpadding-bottom: 0 !important;\n}\n\n.pb-1 {\n\tpadding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n\tpadding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n\tpadding-bottom: 1rem !important;\n}\n\n.pb-4 {\n\tpadding-bottom: 1.875rem !important;\n}\n\n.pb-5 {\n\tpadding-bottom: 3rem !important;\n}\n\n.ps-0 {\n\tpadding-left: 0 !important;\n}\n\n.ps-1 {\n\tpadding-left: 0.25rem !important;\n}\n\n.ps-2 {\n\tpadding-left: 0.5rem !important;\n}\n\n.ps-3 {\n\tpadding-left: 1rem !important;\n}\n\n.ps-4 {\n\tpadding-left: 1.875rem !important;\n}\n\n.ps-5 {\n\tpadding-left: 3rem !important;\n}\n\n.font-monospace {\n\tfont-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n\tfont-size: calc(1.35rem + 1.2vw) !important;\n}\n\n.fs-2 {\n\tfont-size: calc(1.3125rem + 0.75vw) !important;\n}\n\n.fs-3 {\n\tfont-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-4 {\n\tfont-size: 1.125rem !important;\n}\n\n.fs-5 {\n\tfont-size: 1rem !important;\n}\n\n.fs-6 {\n\tfont-size: 0.938rem !important;\n}\n\n.fst-italic {\n\tfont-style: italic !important;\n}\n\n.fst-normal {\n\tfont-style: normal !important;\n}\n\n.fw-light {\n\tfont-weight: 300 !important;\n}\n\n.fw-lighter {\n\tfont-weight: lighter !important;\n}\n\n.fw-normal {\n\tfont-weight: 400 !important;\n}\n\n.fw-semi-bold {\n\tfont-weight: 600 !important;\n}\n\n.fw-bold {\n\tfont-weight: 700 !important;\n}\n\n.fw-bolder {\n\tfont-weight: bolder !important;\n}\n\n.lh-1 {\n\tline-height: 1 !important;\n}\n\n.lh-sm {\n\tline-height: 1.25 !important;\n}\n\n.lh-base {\n\tline-height: 1.5 !important;\n}\n\n.lh-lg {\n\tline-height: 2 !important;\n}\n\n.text-start {\n\ttext-align: left !important;\n}\n\n.text-end {\n\ttext-align: right !important;\n}\n\n.text-center {\n\ttext-align: center !important;\n}\n\n.text-decoration-none {\n\ttext-decoration: none !important;\n}\n\n.text-decoration-underline {\n\ttext-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n\ttext-decoration: line-through !important;\n}\n\n.text-lowercase {\n\ttext-transform: lowercase !important;\n}\n\n.text-uppercase {\n\ttext-transform: uppercase !important;\n}\n\n.text-capitalize {\n\ttext-transform: capitalize !important;\n}\n\n.text-wrap {\n\twhite-space: normal !important;\n}\n\n.text-nowrap {\n\twhite-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n\tword-wrap: break-word !important;\n\tword-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-primary {\n\t--bs-text-opacity: 1;\n\tcolor: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n\t--bs-text-opacity: 1;\n\tcolor: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n\t--bs-text-opacity: 1;\n\tcolor: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n\t--bs-text-opacity: 1;\n\tcolor: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n\t--bs-text-opacity: 1;\n\tcolor: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n\t--bs-text-opacity: 1;\n\tcolor: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n\t--bs-text-opacity: 1;\n\tcolor: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n\t--bs-text-opacity: 1;\n\tcolor: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n\t--bs-text-opacity: 1;\n\tcolor: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-white {\n\t--bs-text-opacity: 1;\n\tcolor: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n\t--bs-text-opacity: 1;\n\tcolor: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n\t--bs-text-opacity: 1;\n\tcolor: #89879f !important;\n}\n\n.text-black-50 {\n\t--bs-text-opacity: 1;\n\tcolor: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n\t--bs-text-opacity: 1;\n\tcolor: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-reset {\n\t--bs-text-opacity: 1;\n\tcolor: inherit !important;\n}\n\n.text-opacity-25 {\n\t--bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n\t--bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n\t--bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n\t--bs-text-opacity: 1;\n}\n\n.bg-primary {\n\t--bs-bg-opacity: 1;\n\tbackground-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n\t--bs-bg-opacity: 1;\n\tbackground-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n\t--bs-bg-opacity: 1;\n\tbackground-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n\t--bs-bg-opacity: 1;\n\tbackground-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n\t--bs-bg-opacity: 1;\n\tbackground-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n\t--bs-bg-opacity: 1;\n\tbackground-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n\t--bs-bg-opacity: 1;\n\tbackground-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n\t--bs-bg-opacity: 1;\n\tbackground-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n\t--bs-bg-opacity: 1;\n\tbackground-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-white {\n\t--bs-bg-opacity: 1;\n\tbackground-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n\t--bs-bg-opacity: 1;\n\tbackground-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n\t--bs-bg-opacity: 1;\n\tbackground-color: transparent !important;\n}\n\n.bg-opacity-10 {\n\t--bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n\t--bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n\t--bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n\t--bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n\t--bs-bg-opacity: 1;\n}\n\n.bg-gradient {\n\tbackground-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n\tuser-select: all !important;\n}\n\n.user-select-auto {\n\tuser-select: auto !important;\n}\n\n.user-select-none {\n\tuser-select: none !important;\n}\n\n.pe-none {\n\tpointer-events: none !important;\n}\n\n.pe-auto {\n\tpointer-events: auto !important;\n}\n\n.rounded {\n\tborder-radius: 0.625rem !important;\n}\n\n.rounded-0 {\n\tborder-radius: 0 !important;\n}\n\n.rounded-1 {\n\tborder-radius: 0.625rem !important;\n}\n\n.rounded-2 {\n\tborder-radius: 0.625rem !important;\n}\n\n.rounded-3 {\n\tborder-radius: 0.625rem !important;\n}\n\n.rounded-circle {\n\tborder-radius: 50% !important;\n}\n\n.rounded-pill {\n\tborder-radius: 0.625rem !important;\n}\n\n.rounded-top {\n\tborder-top-left-radius: 0.625rem !important;\n\tborder-top-right-radius: 0.625rem !important;\n}\n\n.rounded-end {\n\tborder-top-right-radius: 0.625rem !important;\n\tborder-bottom-right-radius: 0.625rem !important;\n}\n\n.rounded-bottom {\n\tborder-bottom-right-radius: 0.625rem !important;\n\tborder-bottom-left-radius: 0.625rem !important;\n}\n\n.rounded-start {\n\tborder-bottom-left-radius: 0.625rem !important;\n\tborder-top-left-radius: 0.625rem !important;\n}\n\n.visible {\n\tvisibility: visible !important;\n}\n\n.invisible {\n\tvisibility: hidden !important;\n}\n\n@media (min-width: 576px) {\n\t.float-sm-start {\n\t\tfloat: left !important;\n\t}\n\t.float-sm-end {\n\t\tfloat: right !important;\n\t}\n\t.float-sm-none {\n\t\tfloat: none !important;\n\t}\n\t.d-sm-inline {\n\t\tdisplay: inline !important;\n\t}\n\t.d-sm-inline-block {\n\t\tdisplay: inline-block !important;\n\t}\n\t.d-sm-block {\n\t\tdisplay: block !important;\n\t}\n\t.d-sm-grid {\n\t\tdisplay: grid !important;\n\t}\n\t.d-sm-table {\n\t\tdisplay: table !important;\n\t}\n\t.d-sm-table-row {\n\t\tdisplay: table-row !important;\n\t}\n\t.d-sm-table-cell {\n\t\tdisplay: table-cell !important;\n\t}\n\t.d-sm-flex {\n\t\tdisplay: flex !important;\n\t}\n\t.d-sm-inline-flex {\n\t\tdisplay: inline-flex !important;\n\t}\n\t.d-sm-none {\n\t\tdisplay: none !important;\n\t}\n\t.flex-sm-fill {\n\t\tflex: 1 1 auto !important;\n\t}\n\t.flex-sm-row {\n\t\tflex-direction: row !important;\n\t}\n\t.flex-sm-column {\n\t\tflex-direction: column !important;\n\t}\n\t.flex-sm-row-reverse {\n\t\tflex-direction: row-reverse !important;\n\t}\n\t.flex-sm-column-reverse {\n\t\tflex-direction: column-reverse !important;\n\t}\n\t.flex-sm-grow-0 {\n\t\tflex-grow: 0 !important;\n\t}\n\t.flex-sm-grow-1 {\n\t\tflex-grow: 1 !important;\n\t}\n\t.flex-sm-shrink-0 {\n\t\tflex-shrink: 0 !important;\n\t}\n\t.flex-sm-shrink-1 {\n\t\tflex-shrink: 1 !important;\n\t}\n\t.flex-sm-wrap {\n\t\tflex-wrap: wrap !important;\n\t}\n\t.flex-sm-nowrap {\n\t\tflex-wrap: nowrap !important;\n\t}\n\t.flex-sm-wrap-reverse {\n\t\tflex-wrap: wrap-reverse !important;\n\t}\n\t.gap-sm-0 {\n\t\tgap: 0 !important;\n\t}\n\t.gap-sm-1 {\n\t\tgap: 0.25rem !important;\n\t}\n\t.gap-sm-2 {\n\t\tgap: 0.5rem !important;\n\t}\n\t.gap-sm-3 {\n\t\tgap: 1rem !important;\n\t}\n\t.gap-sm-4 {\n\t\tgap: 1.875rem !important;\n\t}\n\t.gap-sm-5 {\n\t\tgap: 3rem !important;\n\t}\n\t.justify-content-sm-start {\n\t\tjustify-content: flex-start !important;\n\t}\n\t.justify-content-sm-end {\n\t\tjustify-content: flex-end !important;\n\t}\n\t.justify-content-sm-center {\n\t\tjustify-content: center !important;\n\t}\n\t.justify-content-sm-between {\n\t\tjustify-content: space-between !important;\n\t}\n\t.justify-content-sm-around {\n\t\tjustify-content: space-around !important;\n\t}\n\t.justify-content-sm-evenly {\n\t\tjustify-content: space-evenly !important;\n\t}\n\t.align-items-sm-start {\n\t\talign-items: flex-start !important;\n\t}\n\t.align-items-sm-end {\n\t\talign-items: flex-end !important;\n\t}\n\t.align-items-sm-center {\n\t\talign-items: center !important;\n\t}\n\t.align-items-sm-baseline {\n\t\talign-items: baseline !important;\n\t}\n\t.align-items-sm-stretch {\n\t\talign-items: stretch !important;\n\t}\n\t.align-content-sm-start {\n\t\talign-content: flex-start !important;\n\t}\n\t.align-content-sm-end {\n\t\talign-content: flex-end !important;\n\t}\n\t.align-content-sm-center {\n\t\talign-content: center !important;\n\t}\n\t.align-content-sm-between {\n\t\talign-content: space-between !important;\n\t}\n\t.align-content-sm-around {\n\t\talign-content: space-around !important;\n\t}\n\t.align-content-sm-stretch {\n\t\talign-content: stretch !important;\n\t}\n\t.align-self-sm-auto {\n\t\talign-self: auto !important;\n\t}\n\t.align-self-sm-start {\n\t\talign-self: flex-start !important;\n\t}\n\t.align-self-sm-end {\n\t\talign-self: flex-end !important;\n\t}\n\t.align-self-sm-center {\n\t\talign-self: center !important;\n\t}\n\t.align-self-sm-baseline {\n\t\talign-self: baseline !important;\n\t}\n\t.align-self-sm-stretch {\n\t\talign-self: stretch !important;\n\t}\n\t.order-sm-first {\n\t\torder: -1 !important;\n\t}\n\t.order-sm-0 {\n\t\torder: 0 !important;\n\t}\n\t.order-sm-1 {\n\t\torder: 1 !important;\n\t}\n\t.order-sm-2 {\n\t\torder: 2 !important;\n\t}\n\t.order-sm-3 {\n\t\torder: 3 !important;\n\t}\n\t.order-sm-4 {\n\t\torder: 4 !important;\n\t}\n\t.order-sm-5 {\n\t\torder: 5 !important;\n\t}\n\t.order-sm-last {\n\t\torder: 6 !important;\n\t}\n\t.m-sm-0 {\n\t\tmargin: 0 !important;\n\t}\n\t.m-sm-1 {\n\t\tmargin: 0.25rem !important;\n\t}\n\t.m-sm-2 {\n\t\tmargin: 0.5rem !important;\n\t}\n\t.m-sm-3 {\n\t\tmargin: 1rem !important;\n\t}\n\t.m-sm-4 {\n\t\tmargin: 1.875rem !important;\n\t}\n\t.m-sm-5 {\n\t\tmargin: 3rem !important;\n\t}\n\t.m-sm-auto {\n\t\tmargin: auto !important;\n\t}\n\t.mx-sm-0 {\n\t\tmargin-right: 0 !important;\n\t\tmargin-left: 0 !important;\n\t}\n\t.mx-sm-1 {\n\t\tmargin-right: 0.25rem !important;\n\t\tmargin-left: 0.25rem !important;\n\t}\n\t.mx-sm-2 {\n\t\tmargin-right: 0.5rem !important;\n\t\tmargin-left: 0.5rem !important;\n\t}\n\t.mx-sm-3 {\n\t\tmargin-right: 1rem !important;\n\t\tmargin-left: 1rem !important;\n\t}\n\t.mx-sm-4 {\n\t\tmargin-right: 1.875rem !important;\n\t\tmargin-left: 1.875rem !important;\n\t}\n\t.mx-sm-5 {\n\t\tmargin-right: 3rem !important;\n\t\tmargin-left: 3rem !important;\n\t}\n\t.mx-sm-auto {\n\t\tmargin-right: auto !important;\n\t\tmargin-left: auto !important;\n\t}\n\t.my-sm-0 {\n\t\tmargin-top: 0 !important;\n\t\tmargin-bottom: 0 !important;\n\t}\n\t.my-sm-1 {\n\t\tmargin-top: 0.25rem !important;\n\t\tmargin-bottom: 0.25rem !important;\n\t}\n\t.my-sm-2 {\n\t\tmargin-top: 0.5rem !important;\n\t\tmargin-bottom: 0.5rem !important;\n\t}\n\t.my-sm-3 {\n\t\tmargin-top: 1rem !important;\n\t\tmargin-bottom: 1rem !important;\n\t}\n\t.my-sm-4 {\n\t\tmargin-top: 1.875rem !important;\n\t\tmargin-bottom: 1.875rem !important;\n\t}\n\t.my-sm-5 {\n\t\tmargin-top: 3rem !important;\n\t\tmargin-bottom: 3rem !important;\n\t}\n\t.my-sm-auto {\n\t\tmargin-top: auto !important;\n\t\tmargin-bottom: auto !important;\n\t}\n\t.mt-sm-0 {\n\t\tmargin-top: 0 !important;\n\t}\n\t.mt-sm-1 {\n\t\tmargin-top: 0.25rem !important;\n\t}\n\t.mt-sm-2 {\n\t\tmargin-top: 0.5rem !important;\n\t}\n\t.mt-sm-3 {\n\t\tmargin-top: 1rem !important;\n\t}\n\t.mt-sm-4 {\n\t\tmargin-top: 1.875rem !important;\n\t}\n\t.mt-sm-5 {\n\t\tmargin-top: 3rem !important;\n\t}\n\t.mt-sm-auto {\n\t\tmargin-top: auto !important;\n\t}\n\t.me-sm-0 {\n\t\tmargin-right: 0 !important;\n\t}\n\t.me-sm-1 {\n\t\tmargin-right: 0.25rem !important;\n\t}\n\t.me-sm-2 {\n\t\tmargin-right: 0.5rem !important;\n\t}\n\t.me-sm-3 {\n\t\tmargin-right: 1rem !important;\n\t}\n\t.me-sm-4 {\n\t\tmargin-right: 1.875rem !important;\n\t}\n\t.me-sm-5 {\n\t\tmargin-right: 3rem !important;\n\t}\n\t.me-sm-auto {\n\t\tmargin-right: auto !important;\n\t}\n\t.mb-sm-0 {\n\t\tmargin-bottom: 0 !important;\n\t}\n\t.mb-sm-1 {\n\t\tmargin-bottom: 0.25rem !important;\n\t}\n\t.mb-sm-2 {\n\t\tmargin-bottom: 0.5rem !important;\n\t}\n\t.mb-sm-3 {\n\t\tmargin-bottom: 1rem !important;\n\t}\n\t.mb-sm-4 {\n\t\tmargin-bottom: 1.875rem !important;\n\t}\n\t.mb-sm-5 {\n\t\tmargin-bottom: 3rem !important;\n\t}\n\t.mb-sm-auto {\n\t\tmargin-bottom: auto !important;\n\t}\n\t.ms-sm-0 {\n\t\tmargin-left: 0 !important;\n\t}\n\t.ms-sm-1 {\n\t\tmargin-left: 0.25rem !important;\n\t}\n\t.ms-sm-2 {\n\t\tmargin-left: 0.5rem !important;\n\t}\n\t.ms-sm-3 {\n\t\tmargin-left: 1rem !important;\n\t}\n\t.ms-sm-4 {\n\t\tmargin-left: 1.875rem !important;\n\t}\n\t.ms-sm-5 {\n\t\tmargin-left: 3rem !important;\n\t}\n\t.ms-sm-auto {\n\t\tmargin-left: auto !important;\n\t}\n\t.p-sm-0 {\n\t\tpadding: 0 !important;\n\t}\n\t.p-sm-1 {\n\t\tpadding: 0.25rem !important;\n\t}\n\t.p-sm-2 {\n\t\tpadding: 0.5rem !important;\n\t}\n\t.p-sm-3 {\n\t\tpadding: 1rem !important;\n\t}\n\t.p-sm-4 {\n\t\tpadding: 1.875rem !important;\n\t}\n\t.p-sm-5 {\n\t\tpadding: 3rem !important;\n\t}\n\t.px-sm-0 {\n\t\tpadding-right: 0 !important;\n\t\tpadding-left: 0 !important;\n\t}\n\t.px-sm-1 {\n\t\tpadding-right: 0.25rem !important;\n\t\tpadding-left: 0.25rem !important;\n\t}\n\t.px-sm-2 {\n\t\tpadding-right: 0.5rem !important;\n\t\tpadding-left: 0.5rem !important;\n\t}\n\t.px-sm-3 {\n\t\tpadding-right: 1rem !important;\n\t\tpadding-left: 1rem !important;\n\t}\n\t.px-sm-4 {\n\t\tpadding-right: 1.875rem !important;\n\t\tpadding-left: 1.875rem !important;\n\t}\n\t.px-sm-5 {\n\t\tpadding-right: 3rem !important;\n\t\tpadding-left: 3rem !important;\n\t}\n\t.py-sm-0 {\n\t\tpadding-top: 0 !important;\n\t\tpadding-bottom: 0 !important;\n\t}\n\t.py-sm-1 {\n\t\tpadding-top: 0.25rem !important;\n\t\tpadding-bottom: 0.25rem !important;\n\t}\n\t.py-sm-2 {\n\t\tpadding-top: 0.5rem !important;\n\t\tpadding-bottom: 0.5rem !important;\n\t}\n\t.py-sm-3 {\n\t\tpadding-top: 1rem !important;\n\t\tpadding-bottom: 1rem !important;\n\t}\n\t.py-sm-4 {\n\t\tpadding-top: 1.875rem !important;\n\t\tpadding-bottom: 1.875rem !important;\n\t}\n\t.py-sm-5 {\n\t\tpadding-top: 3rem !important;\n\t\tpadding-bottom: 3rem !important;\n\t}\n\t.pt-sm-0 {\n\t\tpadding-top: 0 !important;\n\t}\n\t.pt-sm-1 {\n\t\tpadding-top: 0.25rem !important;\n\t}\n\t.pt-sm-2 {\n\t\tpadding-top: 0.5rem !important;\n\t}\n\t.pt-sm-3 {\n\t\tpadding-top: 1rem !important;\n\t}\n\t.pt-sm-4 {\n\t\tpadding-top: 1.875rem !important;\n\t}\n\t.pt-sm-5 {\n\t\tpadding-top: 3rem !important;\n\t}\n\t.pe-sm-0 {\n\t\tpadding-right: 0 !important;\n\t}\n\t.pe-sm-1 {\n\t\tpadding-right: 0.25rem !important;\n\t}\n\t.pe-sm-2 {\n\t\tpadding-right: 0.5rem !important;\n\t}\n\t.pe-sm-3 {\n\t\tpadding-right: 1rem !important;\n\t}\n\t.pe-sm-4 {\n\t\tpadding-right: 1.875rem !important;\n\t}\n\t.pe-sm-5 {\n\t\tpadding-right: 3rem !important;\n\t}\n\t.pb-sm-0 {\n\t\tpadding-bottom: 0 !important;\n\t}\n\t.pb-sm-1 {\n\t\tpadding-bottom: 0.25rem !important;\n\t}\n\t.pb-sm-2 {\n\t\tpadding-bottom: 0.5rem !important;\n\t}\n\t.pb-sm-3 {\n\t\tpadding-bottom: 1rem !important;\n\t}\n\t.pb-sm-4 {\n\t\tpadding-bottom: 1.875rem !important;\n\t}\n\t.pb-sm-5 {\n\t\tpadding-bottom: 3rem !important;\n\t}\n\t.ps-sm-0 {\n\t\tpadding-left: 0 !important;\n\t}\n\t.ps-sm-1 {\n\t\tpadding-left: 0.25rem !important;\n\t}\n\t.ps-sm-2 {\n\t\tpadding-left: 0.5rem !important;\n\t}\n\t.ps-sm-3 {\n\t\tpadding-left: 1rem !important;\n\t}\n\t.ps-sm-4 {\n\t\tpadding-left: 1.875rem !important;\n\t}\n\t.ps-sm-5 {\n\t\tpadding-left: 3rem !important;\n\t}\n\t.text-sm-start {\n\t\ttext-align: left !important;\n\t}\n\t.text-sm-end {\n\t\ttext-align: right !important;\n\t}\n\t.text-sm-center {\n\t\ttext-align: center !important;\n\t}\n}\n\n@media (min-width: 768px) {\n\t.float-md-start {\n\t\tfloat: left !important;\n\t}\n\t.float-md-end {\n\t\tfloat: right !important;\n\t}\n\t.float-md-none {\n\t\tfloat: none !important;\n\t}\n\t.d-md-inline {\n\t\tdisplay: inline !important;\n\t}\n\t.d-md-inline-block {\n\t\tdisplay: inline-block !important;\n\t}\n\t.d-md-block {\n\t\tdisplay: block !important;\n\t}\n\t.d-md-grid {\n\t\tdisplay: grid !important;\n\t}\n\t.d-md-table {\n\t\tdisplay: table !important;\n\t}\n\t.d-md-table-row {\n\t\tdisplay: table-row !important;\n\t}\n\t.d-md-table-cell {\n\t\tdisplay: table-cell !important;\n\t}\n\t.d-md-flex {\n\t\tdisplay: flex !important;\n\t}\n\t.d-md-inline-flex {\n\t\tdisplay: inline-flex !important;\n\t}\n\t.d-md-none {\n\t\tdisplay: none !important;\n\t}\n\t.flex-md-fill {\n\t\tflex: 1 1 auto !important;\n\t}\n\t.flex-md-row {\n\t\tflex-direction: row !important;\n\t}\n\t.flex-md-column {\n\t\tflex-direction: column !important;\n\t}\n\t.flex-md-row-reverse {\n\t\tflex-direction: row-reverse !important;\n\t}\n\t.flex-md-column-reverse {\n\t\tflex-direction: column-reverse !important;\n\t}\n\t.flex-md-grow-0 {\n\t\tflex-grow: 0 !important;\n\t}\n\t.flex-md-grow-1 {\n\t\tflex-grow: 1 !important;\n\t}\n\t.flex-md-shrink-0 {\n\t\tflex-shrink: 0 !important;\n\t}\n\t.flex-md-shrink-1 {\n\t\tflex-shrink: 1 !important;\n\t}\n\t.flex-md-wrap {\n\t\tflex-wrap: wrap !important;\n\t}\n\t.flex-md-nowrap {\n\t\tflex-wrap: nowrap !important;\n\t}\n\t.flex-md-wrap-reverse {\n\t\tflex-wrap: wrap-reverse !important;\n\t}\n\t.gap-md-0 {\n\t\tgap: 0 !important;\n\t}\n\t.gap-md-1 {\n\t\tgap: 0.25rem !important;\n\t}\n\t.gap-md-2 {\n\t\tgap: 0.5rem !important;\n\t}\n\t.gap-md-3 {\n\t\tgap: 1rem !important;\n\t}\n\t.gap-md-4 {\n\t\tgap: 1.875rem !important;\n\t}\n\t.gap-md-5 {\n\t\tgap: 3rem !important;\n\t}\n\t.justify-content-md-start {\n\t\tjustify-content: flex-start !important;\n\t}\n\t.justify-content-md-end {\n\t\tjustify-content: flex-end !important;\n\t}\n\t.justify-content-md-center {\n\t\tjustify-content: center !important;\n\t}\n\t.justify-content-md-between {\n\t\tjustify-content: space-between !important;\n\t}\n\t.justify-content-md-around {\n\t\tjustify-content: space-around !important;\n\t}\n\t.justify-content-md-evenly {\n\t\tjustify-content: space-evenly !important;\n\t}\n\t.align-items-md-start {\n\t\talign-items: flex-start !important;\n\t}\n\t.align-items-md-end {\n\t\talign-items: flex-end !important;\n\t}\n\t.align-items-md-center {\n\t\talign-items: center !important;\n\t}\n\t.align-items-md-baseline {\n\t\talign-items: baseline !important;\n\t}\n\t.align-items-md-stretch {\n\t\talign-items: stretch !important;\n\t}\n\t.align-content-md-start {\n\t\talign-content: flex-start !important;\n\t}\n\t.align-content-md-end {\n\t\talign-content: flex-end !important;\n\t}\n\t.align-content-md-center {\n\t\talign-content: center !important;\n\t}\n\t.align-content-md-between {\n\t\talign-content: space-between !important;\n\t}\n\t.align-content-md-around {\n\t\talign-content: space-around !important;\n\t}\n\t.align-content-md-stretch {\n\t\talign-content: stretch !important;\n\t}\n\t.align-self-md-auto {\n\t\talign-self: auto !important;\n\t}\n\t.align-self-md-start {\n\t\talign-self: flex-start !important;\n\t}\n\t.align-self-md-end {\n\t\talign-self: flex-end !important;\n\t}\n\t.align-self-md-center {\n\t\talign-self: center !important;\n\t}\n\t.align-self-md-baseline {\n\t\talign-self: baseline !important;\n\t}\n\t.align-self-md-stretch {\n\t\talign-self: stretch !important;\n\t}\n\t.order-md-first {\n\t\torder: -1 !important;\n\t}\n\t.order-md-0 {\n\t\torder: 0 !important;\n\t}\n\t.order-md-1 {\n\t\torder: 1 !important;\n\t}\n\t.order-md-2 {\n\t\torder: 2 !important;\n\t}\n\t.order-md-3 {\n\t\torder: 3 !important;\n\t}\n\t.order-md-4 {\n\t\torder: 4 !important;\n\t}\n\t.order-md-5 {\n\t\torder: 5 !important;\n\t}\n\t.order-md-last {\n\t\torder: 6 !important;\n\t}\n\t.m-md-0 {\n\t\tmargin: 0 !important;\n\t}\n\t.m-md-1 {\n\t\tmargin: 0.25rem !important;\n\t}\n\t.m-md-2 {\n\t\tmargin: 0.5rem !important;\n\t}\n\t.m-md-3 {\n\t\tmargin: 1rem !important;\n\t}\n\t.m-md-4 {\n\t\tmargin: 1.875rem !important;\n\t}\n\t.m-md-5 {\n\t\tmargin: 3rem !important;\n\t}\n\t.m-md-auto {\n\t\tmargin: auto !important;\n\t}\n\t.mx-md-0 {\n\t\tmargin-right: 0 !important;\n\t\tmargin-left: 0 !important;\n\t}\n\t.mx-md-1 {\n\t\tmargin-right: 0.25rem !important;\n\t\tmargin-left: 0.25rem !important;\n\t}\n\t.mx-md-2 {\n\t\tmargin-right: 0.5rem !important;\n\t\tmargin-left: 0.5rem !important;\n\t}\n\t.mx-md-3 {\n\t\tmargin-right: 1rem !important;\n\t\tmargin-left: 1rem !important;\n\t}\n\t.mx-md-4 {\n\t\tmargin-right: 1.875rem !important;\n\t\tmargin-left: 1.875rem !important;\n\t}\n\t.mx-md-5 {\n\t\tmargin-right: 3rem !important;\n\t\tmargin-left: 3rem !important;\n\t}\n\t.mx-md-auto {\n\t\tmargin-right: auto !important;\n\t\tmargin-left: auto !important;\n\t}\n\t.my-md-0 {\n\t\tmargin-top: 0 !important;\n\t\tmargin-bottom: 0 !important;\n\t}\n\t.my-md-1 {\n\t\tmargin-top: 0.25rem !important;\n\t\tmargin-bottom: 0.25rem !important;\n\t}\n\t.my-md-2 {\n\t\tmargin-top: 0.5rem !important;\n\t\tmargin-bottom: 0.5rem !important;\n\t}\n\t.my-md-3 {\n\t\tmargin-top: 1rem !important;\n\t\tmargin-bottom: 1rem !important;\n\t}\n\t.my-md-4 {\n\t\tmargin-top: 1.875rem !important;\n\t\tmargin-bottom: 1.875rem !important;\n\t}\n\t.my-md-5 {\n\t\tmargin-top: 3rem !important;\n\t\tmargin-bottom: 3rem !important;\n\t}\n\t.my-md-auto {\n\t\tmargin-top: auto !important;\n\t\tmargin-bottom: auto !important;\n\t}\n\t.mt-md-0 {\n\t\tmargin-top: 0 !important;\n\t}\n\t.mt-md-1 {\n\t\tmargin-top: 0.25rem !important;\n\t}\n\t.mt-md-2 {\n\t\tmargin-top: 0.5rem !important;\n\t}\n\t.mt-md-3 {\n\t\tmargin-top: 1rem !important;\n\t}\n\t.mt-md-4 {\n\t\tmargin-top: 1.875rem !important;\n\t}\n\t.mt-md-5 {\n\t\tmargin-top: 3rem !important;\n\t}\n\t.mt-md-auto {\n\t\tmargin-top: auto !important;\n\t}\n\t.me-md-0 {\n\t\tmargin-right: 0 !important;\n\t}\n\t.me-md-1 {\n\t\tmargin-right: 0.25rem !important;\n\t}\n\t.me-md-2 {\n\t\tmargin-right: 0.5rem !important;\n\t}\n\t.me-md-3 {\n\t\tmargin-right: 1rem !important;\n\t}\n\t.me-md-4 {\n\t\tmargin-right: 1.875rem !important;\n\t}\n\t.me-md-5 {\n\t\tmargin-right: 3rem !important;\n\t}\n\t.me-md-auto {\n\t\tmargin-right: auto !important;\n\t}\n\t.mb-md-0 {\n\t\tmargin-bottom: 0 !important;\n\t}\n\t.mb-md-1 {\n\t\tmargin-bottom: 0.25rem !important;\n\t}\n\t.mb-md-2 {\n\t\tmargin-bottom: 0.5rem !important;\n\t}\n\t.mb-md-3 {\n\t\tmargin-bottom: 1rem !important;\n\t}\n\t.mb-md-4 {\n\t\tmargin-bottom: 1.875rem !important;\n\t}\n\t.mb-md-5 {\n\t\tmargin-bottom: 3rem !important;\n\t}\n\t.mb-md-auto {\n\t\tmargin-bottom: auto !important;\n\t}\n\t.ms-md-0 {\n\t\tmargin-left: 0 !important;\n\t}\n\t.ms-md-1 {\n\t\tmargin-left: 0.25rem !important;\n\t}\n\t.ms-md-2 {\n\t\tmargin-left: 0.5rem !important;\n\t}\n\t.ms-md-3 {\n\t\tmargin-left: 1rem !important;\n\t}\n\t.ms-md-4 {\n\t\tmargin-left: 1.875rem !important;\n\t}\n\t.ms-md-5 {\n\t\tmargin-left: 3rem !important;\n\t}\n\t.ms-md-auto {\n\t\tmargin-left: auto !important;\n\t}\n\t.p-md-0 {\n\t\tpadding: 0 !important;\n\t}\n\t.p-md-1 {\n\t\tpadding: 0.25rem !important;\n\t}\n\t.p-md-2 {\n\t\tpadding: 0.5rem !important;\n\t}\n\t.p-md-3 {\n\t\tpadding: 1rem !important;\n\t}\n\t.p-md-4 {\n\t\tpadding: 1.875rem !important;\n\t}\n\t.p-md-5 {\n\t\tpadding: 3rem !important;\n\t}\n\t.px-md-0 {\n\t\tpadding-right: 0 !important;\n\t\tpadding-left: 0 !important;\n\t}\n\t.px-md-1 {\n\t\tpadding-right: 0.25rem !important;\n\t\tpadding-left: 0.25rem !important;\n\t}\n\t.px-md-2 {\n\t\tpadding-right: 0.5rem !important;\n\t\tpadding-left: 0.5rem !important;\n\t}\n\t.px-md-3 {\n\t\tpadding-right: 1rem !important;\n\t\tpadding-left: 1rem !important;\n\t}\n\t.px-md-4 {\n\t\tpadding-right: 1.875rem !important;\n\t\tpadding-left: 1.875rem !important;\n\t}\n\t.px-md-5 {\n\t\tpadding-right: 3rem !important;\n\t\tpadding-left: 3rem !important;\n\t}\n\t.py-md-0 {\n\t\tpadding-top: 0 !important;\n\t\tpadding-bottom: 0 !important;\n\t}\n\t.py-md-1 {\n\t\tpadding-top: 0.25rem !important;\n\t\tpadding-bottom: 0.25rem !important;\n\t}\n\t.py-md-2 {\n\t\tpadding-top: 0.5rem !important;\n\t\tpadding-bottom: 0.5rem !important;\n\t}\n\t.py-md-3 {\n\t\tpadding-top: 1rem !important;\n\t\tpadding-bottom: 1rem !important;\n\t}\n\t.py-md-4 {\n\t\tpadding-top: 1.875rem !important;\n\t\tpadding-bottom: 1.875rem !important;\n\t}\n\t.py-md-5 {\n\t\tpadding-top: 3rem !important;\n\t\tpadding-bottom: 3rem !important;\n\t}\n\t.pt-md-0 {\n\t\tpadding-top: 0 !important;\n\t}\n\t.pt-md-1 {\n\t\tpadding-top: 0.25rem !important;\n\t}\n\t.pt-md-2 {\n\t\tpadding-top: 0.5rem !important;\n\t}\n\t.pt-md-3 {\n\t\tpadding-top: 1rem !important;\n\t}\n\t.pt-md-4 {\n\t\tpadding-top: 1.875rem !important;\n\t}\n\t.pt-md-5 {\n\t\tpadding-top: 3rem !important;\n\t}\n\t.pe-md-0 {\n\t\tpadding-right: 0 !important;\n\t}\n\t.pe-md-1 {\n\t\tpadding-right: 0.25rem !important;\n\t}\n\t.pe-md-2 {\n\t\tpadding-right: 0.5rem !important;\n\t}\n\t.pe-md-3 {\n\t\tpadding-right: 1rem !important;\n\t}\n\t.pe-md-4 {\n\t\tpadding-right: 1.875rem !important;\n\t}\n\t.pe-md-5 {\n\t\tpadding-right: 3rem !important;\n\t}\n\t.pb-md-0 {\n\t\tpadding-bottom: 0 !important;\n\t}\n\t.pb-md-1 {\n\t\tpadding-bottom: 0.25rem !important;\n\t}\n\t.pb-md-2 {\n\t\tpadding-bottom: 0.5rem !important;\n\t}\n\t.pb-md-3 {\n\t\tpadding-bottom: 1rem !important;\n\t}\n\t.pb-md-4 {\n\t\tpadding-bottom: 1.875rem !important;\n\t}\n\t.pb-md-5 {\n\t\tpadding-bottom: 3rem !important;\n\t}\n\t.ps-md-0 {\n\t\tpadding-left: 0 !important;\n\t}\n\t.ps-md-1 {\n\t\tpadding-left: 0.25rem !important;\n\t}\n\t.ps-md-2 {\n\t\tpadding-left: 0.5rem !important;\n\t}\n\t.ps-md-3 {\n\t\tpadding-left: 1rem !important;\n\t}\n\t.ps-md-4 {\n\t\tpadding-left: 1.875rem !important;\n\t}\n\t.ps-md-5 {\n\t\tpadding-left: 3rem !important;\n\t}\n\t.text-md-start {\n\t\ttext-align: left !important;\n\t}\n\t.text-md-end {\n\t\ttext-align: right !important;\n\t}\n\t.text-md-center {\n\t\ttext-align: center !important;\n\t}\n}\n\n@media (min-width: 992px) {\n\t.float-lg-start {\n\t\tfloat: left !important;\n\t}\n\t.float-lg-end {\n\t\tfloat: right !important;\n\t}\n\t.float-lg-none {\n\t\tfloat: none !important;\n\t}\n\t.d-lg-inline {\n\t\tdisplay: inline !important;\n\t}\n\t.d-lg-inline-block {\n\t\tdisplay: inline-block !important;\n\t}\n\t.d-lg-block {\n\t\tdisplay: block !important;\n\t}\n\t.d-lg-grid {\n\t\tdisplay: grid !important;\n\t}\n\t.d-lg-table {\n\t\tdisplay: table !important;\n\t}\n\t.d-lg-table-row {\n\t\tdisplay: table-row !important;\n\t}\n\t.d-lg-table-cell {\n\t\tdisplay: table-cell !important;\n\t}\n\t.d-lg-flex {\n\t\tdisplay: flex !important;\n\t}\n\t.d-lg-inline-flex {\n\t\tdisplay: inline-flex !important;\n\t}\n\t.d-lg-none {\n\t\tdisplay: none !important;\n\t}\n\t.flex-lg-fill {\n\t\tflex: 1 1 auto !important;\n\t}\n\t.flex-lg-row {\n\t\tflex-direction: row !important;\n\t}\n\t.flex-lg-column {\n\t\tflex-direction: column !important;\n\t}\n\t.flex-lg-row-reverse {\n\t\tflex-direction: row-reverse !important;\n\t}\n\t.flex-lg-column-reverse {\n\t\tflex-direction: column-reverse !important;\n\t}\n\t.flex-lg-grow-0 {\n\t\tflex-grow: 0 !important;\n\t}\n\t.flex-lg-grow-1 {\n\t\tflex-grow: 1 !important;\n\t}\n\t.flex-lg-shrink-0 {\n\t\tflex-shrink: 0 !important;\n\t}\n\t.flex-lg-shrink-1 {\n\t\tflex-shrink: 1 !important;\n\t}\n\t.flex-lg-wrap {\n\t\tflex-wrap: wrap !important;\n\t}\n\t.flex-lg-nowrap {\n\t\tflex-wrap: nowrap !important;\n\t}\n\t.flex-lg-wrap-reverse {\n\t\tflex-wrap: wrap-reverse !important;\n\t}\n\t.gap-lg-0 {\n\t\tgap: 0 !important;\n\t}\n\t.gap-lg-1 {\n\t\tgap: 0.25rem !important;\n\t}\n\t.gap-lg-2 {\n\t\tgap: 0.5rem !important;\n\t}\n\t.gap-lg-3 {\n\t\tgap: 1rem !important;\n\t}\n\t.gap-lg-4 {\n\t\tgap: 1.875rem !important;\n\t}\n\t.gap-lg-5 {\n\t\tgap: 3rem !important;\n\t}\n\t.justify-content-lg-start {\n\t\tjustify-content: flex-start !important;\n\t}\n\t.justify-content-lg-end {\n\t\tjustify-content: flex-end !important;\n\t}\n\t.justify-content-lg-center {\n\t\tjustify-content: center !important;\n\t}\n\t.justify-content-lg-between {\n\t\tjustify-content: space-between !important;\n\t}\n\t.justify-content-lg-around {\n\t\tjustify-content: space-around !important;\n\t}\n\t.justify-content-lg-evenly {\n\t\tjustify-content: space-evenly !important;\n\t}\n\t.align-items-lg-start {\n\t\talign-items: flex-start !important;\n\t}\n\t.align-items-lg-end {\n\t\talign-items: flex-end !important;\n\t}\n\t.align-items-lg-center {\n\t\talign-items: center !important;\n\t}\n\t.align-items-lg-baseline {\n\t\talign-items: baseline !important;\n\t}\n\t.align-items-lg-stretch {\n\t\talign-items: stretch !important;\n\t}\n\t.align-content-lg-start {\n\t\talign-content: flex-start !important;\n\t}\n\t.align-content-lg-end {\n\t\talign-content: flex-end !important;\n\t}\n\t.align-content-lg-center {\n\t\talign-content: center !important;\n\t}\n\t.align-content-lg-between {\n\t\talign-content: space-between !important;\n\t}\n\t.align-content-lg-around {\n\t\talign-content: space-around !important;\n\t}\n\t.align-content-lg-stretch {\n\t\talign-content: stretch !important;\n\t}\n\t.align-self-lg-auto {\n\t\talign-self: auto !important;\n\t}\n\t.align-self-lg-start {\n\t\talign-self: flex-start !important;\n\t}\n\t.align-self-lg-end {\n\t\talign-self: flex-end !important;\n\t}\n\t.align-self-lg-center {\n\t\talign-self: center !important;\n\t}\n\t.align-self-lg-baseline {\n\t\talign-self: baseline !important;\n\t}\n\t.align-self-lg-stretch {\n\t\talign-self: stretch !important;\n\t}\n\t.order-lg-first {\n\t\torder: -1 !important;\n\t}\n\t.order-lg-0 {\n\t\torder: 0 !important;\n\t}\n\t.order-lg-1 {\n\t\torder: 1 !important;\n\t}\n\t.order-lg-2 {\n\t\torder: 2 !important;\n\t}\n\t.order-lg-3 {\n\t\torder: 3 !important;\n\t}\n\t.order-lg-4 {\n\t\torder: 4 !important;\n\t}\n\t.order-lg-5 {\n\t\torder: 5 !important;\n\t}\n\t.order-lg-last {\n\t\torder: 6 !important;\n\t}\n\t.m-lg-0 {\n\t\tmargin: 0 !important;\n\t}\n\t.m-lg-1 {\n\t\tmargin: 0.25rem !important;\n\t}\n\t.m-lg-2 {\n\t\tmargin: 0.5rem !important;\n\t}\n\t.m-lg-3 {\n\t\tmargin: 1rem !important;\n\t}\n\t.m-lg-4 {\n\t\tmargin: 1.875rem !important;\n\t}\n\t.m-lg-5 {\n\t\tmargin: 3rem !important;\n\t}\n\t.m-lg-auto {\n\t\tmargin: auto !important;\n\t}\n\t.mx-lg-0 {\n\t\tmargin-right: 0 !important;\n\t\tmargin-left: 0 !important;\n\t}\n\t.mx-lg-1 {\n\t\tmargin-right: 0.25rem !important;\n\t\tmargin-left: 0.25rem !important;\n\t}\n\t.mx-lg-2 {\n\t\tmargin-right: 0.5rem !important;\n\t\tmargin-left: 0.5rem !important;\n\t}\n\t.mx-lg-3 {\n\t\tmargin-right: 1rem !important;\n\t\tmargin-left: 1rem !important;\n\t}\n\t.mx-lg-4 {\n\t\tmargin-right: 1.875rem !important;\n\t\tmargin-left: 1.875rem !important;\n\t}\n\t.mx-lg-5 {\n\t\tmargin-right: 3rem !important;\n\t\tmargin-left: 3rem !important;\n\t}\n\t.mx-lg-auto {\n\t\tmargin-right: auto !important;\n\t\tmargin-left: auto !important;\n\t}\n\t.my-lg-0 {\n\t\tmargin-top: 0 !important;\n\t\tmargin-bottom: 0 !important;\n\t}\n\t.my-lg-1 {\n\t\tmargin-top: 0.25rem !important;\n\t\tmargin-bottom: 0.25rem !important;\n\t}\n\t.my-lg-2 {\n\t\tmargin-top: 0.5rem !important;\n\t\tmargin-bottom: 0.5rem !important;\n\t}\n\t.my-lg-3 {\n\t\tmargin-top: 1rem !important;\n\t\tmargin-bottom: 1rem !important;\n\t}\n\t.my-lg-4 {\n\t\tmargin-top: 1.875rem !important;\n\t\tmargin-bottom: 1.875rem !important;\n\t}\n\t.my-lg-5 {\n\t\tmargin-top: 3rem !important;\n\t\tmargin-bottom: 3rem !important;\n\t}\n\t.my-lg-auto {\n\t\tmargin-top: auto !important;\n\t\tmargin-bottom: auto !important;\n\t}\n\t.mt-lg-0 {\n\t\tmargin-top: 0 !important;\n\t}\n\t.mt-lg-1 {\n\t\tmargin-top: 0.25rem !important;\n\t}\n\t.mt-lg-2 {\n\t\tmargin-top: 0.5rem !important;\n\t}\n\t.mt-lg-3 {\n\t\tmargin-top: 1rem !important;\n\t}\n\t.mt-lg-4 {\n\t\tmargin-top: 1.875rem !important;\n\t}\n\t.mt-lg-5 {\n\t\tmargin-top: 3rem !important;\n\t}\n\t.mt-lg-auto {\n\t\tmargin-top: auto !important;\n\t}\n\t.me-lg-0 {\n\t\tmargin-right: 0 !important;\n\t}\n\t.me-lg-1 {\n\t\tmargin-right: 0.25rem !important;\n\t}\n\t.me-lg-2 {\n\t\tmargin-right: 0.5rem !important;\n\t}\n\t.me-lg-3 {\n\t\tmargin-right: 1rem !important;\n\t}\n\t.me-lg-4 {\n\t\tmargin-right: 1.875rem !important;\n\t}\n\t.me-lg-5 {\n\t\tmargin-right: 3rem !important;\n\t}\n\t.me-lg-auto {\n\t\tmargin-right: auto !important;\n\t}\n\t.mb-lg-0 {\n\t\tmargin-bottom: 0 !important;\n\t}\n\t.mb-lg-1 {\n\t\tmargin-bottom: 0.25rem !important;\n\t}\n\t.mb-lg-2 {\n\t\tmargin-bottom: 0.5rem !important;\n\t}\n\t.mb-lg-3 {\n\t\tmargin-bottom: 1rem !important;\n\t}\n\t.mb-lg-4 {\n\t\tmargin-bottom: 1.875rem !important;\n\t}\n\t.mb-lg-5 {\n\t\tmargin-bottom: 3rem !important;\n\t}\n\t.mb-lg-auto {\n\t\tmargin-bottom: auto !important;\n\t}\n\t.ms-lg-0 {\n\t\tmargin-left: 0 !important;\n\t}\n\t.ms-lg-1 {\n\t\tmargin-left: 0.25rem !important;\n\t}\n\t.ms-lg-2 {\n\t\tmargin-left: 0.5rem !important;\n\t}\n\t.ms-lg-3 {\n\t\tmargin-left: 1rem !important;\n\t}\n\t.ms-lg-4 {\n\t\tmargin-left: 1.875rem !important;\n\t}\n\t.ms-lg-5 {\n\t\tmargin-left: 3rem !important;\n\t}\n\t.ms-lg-auto {\n\t\tmargin-left: auto !important;\n\t}\n\t.p-lg-0 {\n\t\tpadding: 0 !important;\n\t}\n\t.p-lg-1 {\n\t\tpadding: 0.25rem !important;\n\t}\n\t.p-lg-2 {\n\t\tpadding: 0.5rem !important;\n\t}\n\t.p-lg-3 {\n\t\tpadding: 1rem !important;\n\t}\n\t.p-lg-4 {\n\t\tpadding: 1.875rem !important;\n\t}\n\t.p-lg-5 {\n\t\tpadding: 3rem !important;\n\t}\n\t.px-lg-0 {\n\t\tpadding-right: 0 !important;\n\t\tpadding-left: 0 !important;\n\t}\n\t.px-lg-1 {\n\t\tpadding-right: 0.25rem !important;\n\t\tpadding-left: 0.25rem !important;\n\t}\n\t.px-lg-2 {\n\t\tpadding-right: 0.5rem !important;\n\t\tpadding-left: 0.5rem !important;\n\t}\n\t.px-lg-3 {\n\t\tpadding-right: 1rem !important;\n\t\tpadding-left: 1rem !important;\n\t}\n\t.px-lg-4 {\n\t\tpadding-right: 1.875rem !important;\n\t\tpadding-left: 1.875rem !important;\n\t}\n\t.px-lg-5 {\n\t\tpadding-right: 3rem !important;\n\t\tpadding-left: 3rem !important;\n\t}\n\t.py-lg-0 {\n\t\tpadding-top: 0 !important;\n\t\tpadding-bottom: 0 !important;\n\t}\n\t.py-lg-1 {\n\t\tpadding-top: 0.25rem !important;\n\t\tpadding-bottom: 0.25rem !important;\n\t}\n\t.py-lg-2 {\n\t\tpadding-top: 0.5rem !important;\n\t\tpadding-bottom: 0.5rem !important;\n\t}\n\t.py-lg-3 {\n\t\tpadding-top: 1rem !important;\n\t\tpadding-bottom: 1rem !important;\n\t}\n\t.py-lg-4 {\n\t\tpadding-top: 1.875rem !important;\n\t\tpadding-bottom: 1.875rem !important;\n\t}\n\t.py-lg-5 {\n\t\tpadding-top: 3rem !important;\n\t\tpadding-bottom: 3rem !important;\n\t}\n\t.pt-lg-0 {\n\t\tpadding-top: 0 !important;\n\t}\n\t.pt-lg-1 {\n\t\tpadding-top: 0.25rem !important;\n\t}\n\t.pt-lg-2 {\n\t\tpadding-top: 0.5rem !important;\n\t}\n\t.pt-lg-3 {\n\t\tpadding-top: 1rem !important;\n\t}\n\t.pt-lg-4 {\n\t\tpadding-top: 1.875rem !important;\n\t}\n\t.pt-lg-5 {\n\t\tpadding-top: 3rem !important;\n\t}\n\t.pe-lg-0 {\n\t\tpadding-right: 0 !important;\n\t}\n\t.pe-lg-1 {\n\t\tpadding-right: 0.25rem !important;\n\t}\n\t.pe-lg-2 {\n\t\tpadding-right: 0.5rem !important;\n\t}\n\t.pe-lg-3 {\n\t\tpadding-right: 1rem !important;\n\t}\n\t.pe-lg-4 {\n\t\tpadding-right: 1.875rem !important;\n\t}\n\t.pe-lg-5 {\n\t\tpadding-right: 3rem !important;\n\t}\n\t.pb-lg-0 {\n\t\tpadding-bottom: 0 !important;\n\t}\n\t.pb-lg-1 {\n\t\tpadding-bottom: 0.25rem !important;\n\t}\n\t.pb-lg-2 {\n\t\tpadding-bottom: 0.5rem !important;\n\t}\n\t.pb-lg-3 {\n\t\tpadding-bottom: 1rem !important;\n\t}\n\t.pb-lg-4 {\n\t\tpadding-bottom: 1.875rem !important;\n\t}\n\t.pb-lg-5 {\n\t\tpadding-bottom: 3rem !important;\n\t}\n\t.ps-lg-0 {\n\t\tpadding-left: 0 !important;\n\t}\n\t.ps-lg-1 {\n\t\tpadding-left: 0.25rem !important;\n\t}\n\t.ps-lg-2 {\n\t\tpadding-left: 0.5rem !important;\n\t}\n\t.ps-lg-3 {\n\t\tpadding-left: 1rem !important;\n\t}\n\t.ps-lg-4 {\n\t\tpadding-left: 1.875rem !important;\n\t}\n\t.ps-lg-5 {\n\t\tpadding-left: 3rem !important;\n\t}\n\t.text-lg-start {\n\t\ttext-align: left !important;\n\t}\n\t.text-lg-end {\n\t\ttext-align: right !important;\n\t}\n\t.text-lg-center {\n\t\ttext-align: center !important;\n\t}\n}\n\n@media (min-width: 1200px) {\n\t.float-xl-start {\n\t\tfloat: left !important;\n\t}\n\t.float-xl-end {\n\t\tfloat: right !important;\n\t}\n\t.float-xl-none {\n\t\tfloat: none !important;\n\t}\n\t.d-xl-inline {\n\t\tdisplay: inline !important;\n\t}\n\t.d-xl-inline-block {\n\t\tdisplay: inline-block !important;\n\t}\n\t.d-xl-block {\n\t\tdisplay: block !important;\n\t}\n\t.d-xl-grid {\n\t\tdisplay: grid !important;\n\t}\n\t.d-xl-table {\n\t\tdisplay: table !important;\n\t}\n\t.d-xl-table-row {\n\t\tdisplay: table-row !important;\n\t}\n\t.d-xl-table-cell {\n\t\tdisplay: table-cell !important;\n\t}\n\t.d-xl-flex {\n\t\tdisplay: flex !important;\n\t}\n\t.d-xl-inline-flex {\n\t\tdisplay: inline-flex !important;\n\t}\n\t.d-xl-none {\n\t\tdisplay: none !important;\n\t}\n\t.flex-xl-fill {\n\t\tflex: 1 1 auto !important;\n\t}\n\t.flex-xl-row {\n\t\tflex-direction: row !important;\n\t}\n\t.flex-xl-column {\n\t\tflex-direction: column !important;\n\t}\n\t.flex-xl-row-reverse {\n\t\tflex-direction: row-reverse !important;\n\t}\n\t.flex-xl-column-reverse {\n\t\tflex-direction: column-reverse !important;\n\t}\n\t.flex-xl-grow-0 {\n\t\tflex-grow: 0 !important;\n\t}\n\t.flex-xl-grow-1 {\n\t\tflex-grow: 1 !important;\n\t}\n\t.flex-xl-shrink-0 {\n\t\tflex-shrink: 0 !important;\n\t}\n\t.flex-xl-shrink-1 {\n\t\tflex-shrink: 1 !important;\n\t}\n\t.flex-xl-wrap {\n\t\tflex-wrap: wrap !important;\n\t}\n\t.flex-xl-nowrap {\n\t\tflex-wrap: nowrap !important;\n\t}\n\t.flex-xl-wrap-reverse {\n\t\tflex-wrap: wrap-reverse !important;\n\t}\n\t.gap-xl-0 {\n\t\tgap: 0 !important;\n\t}\n\t.gap-xl-1 {\n\t\tgap: 0.25rem !important;\n\t}\n\t.gap-xl-2 {\n\t\tgap: 0.5rem !important;\n\t}\n\t.gap-xl-3 {\n\t\tgap: 1rem !important;\n\t}\n\t.gap-xl-4 {\n\t\tgap: 1.875rem !important;\n\t}\n\t.gap-xl-5 {\n\t\tgap: 3rem !important;\n\t}\n\t.justify-content-xl-start {\n\t\tjustify-content: flex-start !important;\n\t}\n\t.justify-content-xl-end {\n\t\tjustify-content: flex-end !important;\n\t}\n\t.justify-content-xl-center {\n\t\tjustify-content: center !important;\n\t}\n\t.justify-content-xl-between {\n\t\tjustify-content: space-between !important;\n\t}\n\t.justify-content-xl-around {\n\t\tjustify-content: space-around !important;\n\t}\n\t.justify-content-xl-evenly {\n\t\tjustify-content: space-evenly !important;\n\t}\n\t.align-items-xl-start {\n\t\talign-items: flex-start !important;\n\t}\n\t.align-items-xl-end {\n\t\talign-items: flex-end !important;\n\t}\n\t.align-items-xl-center {\n\t\talign-items: center !important;\n\t}\n\t.align-items-xl-baseline {\n\t\talign-items: baseline !important;\n\t}\n\t.align-items-xl-stretch {\n\t\talign-items: stretch !important;\n\t}\n\t.align-content-xl-start {\n\t\talign-content: flex-start !important;\n\t}\n\t.align-content-xl-end {\n\t\talign-content: flex-end !important;\n\t}\n\t.align-content-xl-center {\n\t\talign-content: center !important;\n\t}\n\t.align-content-xl-between {\n\t\talign-content: space-between !important;\n\t}\n\t.align-content-xl-around {\n\t\talign-content: space-around !important;\n\t}\n\t.align-content-xl-stretch {\n\t\talign-content: stretch !important;\n\t}\n\t.align-self-xl-auto {\n\t\talign-self: auto !important;\n\t}\n\t.align-self-xl-start {\n\t\talign-self: flex-start !important;\n\t}\n\t.align-self-xl-end {\n\t\talign-self: flex-end !important;\n\t}\n\t.align-self-xl-center {\n\t\talign-self: center !important;\n\t}\n\t.align-self-xl-baseline {\n\t\talign-self: baseline !important;\n\t}\n\t.align-self-xl-stretch {\n\t\talign-self: stretch !important;\n\t}\n\t.order-xl-first {\n\t\torder: -1 !important;\n\t}\n\t.order-xl-0 {\n\t\torder: 0 !important;\n\t}\n\t.order-xl-1 {\n\t\torder: 1 !important;\n\t}\n\t.order-xl-2 {\n\t\torder: 2 !important;\n\t}\n\t.order-xl-3 {\n\t\torder: 3 !important;\n\t}\n\t.order-xl-4 {\n\t\torder: 4 !important;\n\t}\n\t.order-xl-5 {\n\t\torder: 5 !important;\n\t}\n\t.order-xl-last {\n\t\torder: 6 !important;\n\t}\n\t.m-xl-0 {\n\t\tmargin: 0 !important;\n\t}\n\t.m-xl-1 {\n\t\tmargin: 0.25rem !important;\n\t}\n\t.m-xl-2 {\n\t\tmargin: 0.5rem !important;\n\t}\n\t.m-xl-3 {\n\t\tmargin: 1rem !important;\n\t}\n\t.m-xl-4 {\n\t\tmargin: 1.875rem !important;\n\t}\n\t.m-xl-5 {\n\t\tmargin: 3rem !important;\n\t}\n\t.m-xl-auto {\n\t\tmargin: auto !important;\n\t}\n\t.mx-xl-0 {\n\t\tmargin-right: 0 !important;\n\t\tmargin-left: 0 !important;\n\t}\n\t.mx-xl-1 {\n\t\tmargin-right: 0.25rem !important;\n\t\tmargin-left: 0.25rem !important;\n\t}\n\t.mx-xl-2 {\n\t\tmargin-right: 0.5rem !important;\n\t\tmargin-left: 0.5rem !important;\n\t}\n\t.mx-xl-3 {\n\t\tmargin-right: 1rem !important;\n\t\tmargin-left: 1rem !important;\n\t}\n\t.mx-xl-4 {\n\t\tmargin-right: 1.875rem !important;\n\t\tmargin-left: 1.875rem !important;\n\t}\n\t.mx-xl-5 {\n\t\tmargin-right: 3rem !important;\n\t\tmargin-left: 3rem !important;\n\t}\n\t.mx-xl-auto {\n\t\tmargin-right: auto !important;\n\t\tmargin-left: auto !important;\n\t}\n\t.my-xl-0 {\n\t\tmargin-top: 0 !important;\n\t\tmargin-bottom: 0 !important;\n\t}\n\t.my-xl-1 {\n\t\tmargin-top: 0.25rem !important;\n\t\tmargin-bottom: 0.25rem !important;\n\t}\n\t.my-xl-2 {\n\t\tmargin-top: 0.5rem !important;\n\t\tmargin-bottom: 0.5rem !important;\n\t}\n\t.my-xl-3 {\n\t\tmargin-top: 1rem !important;\n\t\tmargin-bottom: 1rem !important;\n\t}\n\t.my-xl-4 {\n\t\tmargin-top: 1.875rem !important;\n\t\tmargin-bottom: 1.875rem !important;\n\t}\n\t.my-xl-5 {\n\t\tmargin-top: 3rem !important;\n\t\tmargin-bottom: 3rem !important;\n\t}\n\t.my-xl-auto {\n\t\tmargin-top: auto !important;\n\t\tmargin-bottom: auto !important;\n\t}\n\t.mt-xl-0 {\n\t\tmargin-top: 0 !important;\n\t}\n\t.mt-xl-1 {\n\t\tmargin-top: 0.25rem !important;\n\t}\n\t.mt-xl-2 {\n\t\tmargin-top: 0.5rem !important;\n\t}\n\t.mt-xl-3 {\n\t\tmargin-top: 1rem !important;\n\t}\n\t.mt-xl-4 {\n\t\tmargin-top: 1.875rem !important;\n\t}\n\t.mt-xl-5 {\n\t\tmargin-top: 3rem !important;\n\t}\n\t.mt-xl-auto {\n\t\tmargin-top: auto !important;\n\t}\n\t.me-xl-0 {\n\t\tmargin-right: 0 !important;\n\t}\n\t.me-xl-1 {\n\t\tmargin-right: 0.25rem !important;\n\t}\n\t.me-xl-2 {\n\t\tmargin-right: 0.5rem !important;\n\t}\n\t.me-xl-3 {\n\t\tmargin-right: 1rem !important;\n\t}\n\t.me-xl-4 {\n\t\tmargin-right: 1.875rem !important;\n\t}\n\t.me-xl-5 {\n\t\tmargin-right: 3rem !important;\n\t}\n\t.me-xl-auto {\n\t\tmargin-right: auto !important;\n\t}\n\t.mb-xl-0 {\n\t\tmargin-bottom: 0 !important;\n\t}\n\t.mb-xl-1 {\n\t\tmargin-bottom: 0.25rem !important;\n\t}\n\t.mb-xl-2 {\n\t\tmargin-bottom: 0.5rem !important;\n\t}\n\t.mb-xl-3 {\n\t\tmargin-bottom: 1rem !important;\n\t}\n\t.mb-xl-4 {\n\t\tmargin-bottom: 1.875rem !important;\n\t}\n\t.mb-xl-5 {\n\t\tmargin-bottom: 3rem !important;\n\t}\n\t.mb-xl-auto {\n\t\tmargin-bottom: auto !important;\n\t}\n\t.ms-xl-0 {\n\t\tmargin-left: 0 !important;\n\t}\n\t.ms-xl-1 {\n\t\tmargin-left: 0.25rem !important;\n\t}\n\t.ms-xl-2 {\n\t\tmargin-left: 0.5rem !important;\n\t}\n\t.ms-xl-3 {\n\t\tmargin-left: 1rem !important;\n\t}\n\t.ms-xl-4 {\n\t\tmargin-left: 1.875rem !important;\n\t}\n\t.ms-xl-5 {\n\t\tmargin-left: 3rem !important;\n\t}\n\t.ms-xl-auto {\n\t\tmargin-left: auto !important;\n\t}\n\t.p-xl-0 {\n\t\tpadding: 0 !important;\n\t}\n\t.p-xl-1 {\n\t\tpadding: 0.25rem !important;\n\t}\n\t.p-xl-2 {\n\t\tpadding: 0.5rem !important;\n\t}\n\t.p-xl-3 {\n\t\tpadding: 1rem !important;\n\t}\n\t.p-xl-4 {\n\t\tpadding: 1.875rem !important;\n\t}\n\t.p-xl-5 {\n\t\tpadding: 3rem !important;\n\t}\n\t.px-xl-0 {\n\t\tpadding-right: 0 !important;\n\t\tpadding-left: 0 !important;\n\t}\n\t.px-xl-1 {\n\t\tpadding-right: 0.25rem !important;\n\t\tpadding-left: 0.25rem !important;\n\t}\n\t.px-xl-2 {\n\t\tpadding-right: 0.5rem !important;\n\t\tpadding-left: 0.5rem !important;\n\t}\n\t.px-xl-3 {\n\t\tpadding-right: 1rem !important;\n\t\tpadding-left: 1rem !important;\n\t}\n\t.px-xl-4 {\n\t\tpadding-right: 1.875rem !important;\n\t\tpadding-left: 1.875rem !important;\n\t}\n\t.px-xl-5 {\n\t\tpadding-right: 3rem !important;\n\t\tpadding-left: 3rem !important;\n\t}\n\t.py-xl-0 {\n\t\tpadding-top: 0 !important;\n\t\tpadding-bottom: 0 !important;\n\t}\n\t.py-xl-1 {\n\t\tpadding-top: 0.25rem !important;\n\t\tpadding-bottom: 0.25rem !important;\n\t}\n\t.py-xl-2 {\n\t\tpadding-top: 0.5rem !important;\n\t\tpadding-bottom: 0.5rem !important;\n\t}\n\t.py-xl-3 {\n\t\tpadding-top: 1rem !important;\n\t\tpadding-bottom: 1rem !important;\n\t}\n\t.py-xl-4 {\n\t\tpadding-top: 1.875rem !important;\n\t\tpadding-bottom: 1.875rem !important;\n\t}\n\t.py-xl-5 {\n\t\tpadding-top: 3rem !important;\n\t\tpadding-bottom: 3rem !important;\n\t}\n\t.pt-xl-0 {\n\t\tpadding-top: 0 !important;\n\t}\n\t.pt-xl-1 {\n\t\tpadding-top: 0.25rem !important;\n\t}\n\t.pt-xl-2 {\n\t\tpadding-top: 0.5rem !important;\n\t}\n\t.pt-xl-3 {\n\t\tpadding-top: 1rem !important;\n\t}\n\t.pt-xl-4 {\n\t\tpadding-top: 1.875rem !important;\n\t}\n\t.pt-xl-5 {\n\t\tpadding-top: 3rem !important;\n\t}\n\t.pe-xl-0 {\n\t\tpadding-right: 0 !important;\n\t}\n\t.pe-xl-1 {\n\t\tpadding-right: 0.25rem !important;\n\t}\n\t.pe-xl-2 {\n\t\tpadding-right: 0.5rem !important;\n\t}\n\t.pe-xl-3 {\n\t\tpadding-right: 1rem !important;\n\t}\n\t.pe-xl-4 {\n\t\tpadding-right: 1.875rem !important;\n\t}\n\t.pe-xl-5 {\n\t\tpadding-right: 3rem !important;\n\t}\n\t.pb-xl-0 {\n\t\tpadding-bottom: 0 !important;\n\t}\n\t.pb-xl-1 {\n\t\tpadding-bottom: 0.25rem !important;\n\t}\n\t.pb-xl-2 {\n\t\tpadding-bottom: 0.5rem !important;\n\t}\n\t.pb-xl-3 {\n\t\tpadding-bottom: 1rem !important;\n\t}\n\t.pb-xl-4 {\n\t\tpadding-bottom: 1.875rem !important;\n\t}\n\t.pb-xl-5 {\n\t\tpadding-bottom: 3rem !important;\n\t}\n\t.ps-xl-0 {\n\t\tpadding-left: 0 !important;\n\t}\n\t.ps-xl-1 {\n\t\tpadding-left: 0.25rem !important;\n\t}\n\t.ps-xl-2 {\n\t\tpadding-left: 0.5rem !important;\n\t}\n\t.ps-xl-3 {\n\t\tpadding-left: 1rem !important;\n\t}\n\t.ps-xl-4 {\n\t\tpadding-left: 1.875rem !important;\n\t}\n\t.ps-xl-5 {\n\t\tpadding-left: 3rem !important;\n\t}\n\t.text-xl-start {\n\t\ttext-align: left !important;\n\t}\n\t.text-xl-end {\n\t\ttext-align: right !important;\n\t}\n\t.text-xl-center {\n\t\ttext-align: center !important;\n\t}\n}\n\n@media (min-width: 1440) {\n\t.float-xxl-start {\n\t\tfloat: left !important;\n\t}\n\t.float-xxl-end {\n\t\tfloat: right !important;\n\t}\n\t.float-xxl-none {\n\t\tfloat: none !important;\n\t}\n\t.d-xxl-inline {\n\t\tdisplay: inline !important;\n\t}\n\t.d-xxl-inline-block {\n\t\tdisplay: inline-block !important;\n\t}\n\t.d-xxl-block {\n\t\tdisplay: block !important;\n\t}\n\t.d-xxl-grid {\n\t\tdisplay: grid !important;\n\t}\n\t.d-xxl-table {\n\t\tdisplay: table !important;\n\t}\n\t.d-xxl-table-row {\n\t\tdisplay: table-row !important;\n\t}\n\t.d-xxl-table-cell {\n\t\tdisplay: table-cell !important;\n\t}\n\t.d-xxl-flex {\n\t\tdisplay: flex !important;\n\t}\n\t.d-xxl-inline-flex {\n\t\tdisplay: inline-flex !important;\n\t}\n\t.d-xxl-none {\n\t\tdisplay: none !important;\n\t}\n\t.flex-xxl-fill {\n\t\tflex: 1 1 auto !important;\n\t}\n\t.flex-xxl-row {\n\t\tflex-direction: row !important;\n\t}\n\t.flex-xxl-column {\n\t\tflex-direction: column !important;\n\t}\n\t.flex-xxl-row-reverse {\n\t\tflex-direction: row-reverse !important;\n\t}\n\t.flex-xxl-column-reverse {\n\t\tflex-direction: column-reverse !important;\n\t}\n\t.flex-xxl-grow-0 {\n\t\tflex-grow: 0 !important;\n\t}\n\t.flex-xxl-grow-1 {\n\t\tflex-grow: 1 !important;\n\t}\n\t.flex-xxl-shrink-0 {\n\t\tflex-shrink: 0 !important;\n\t}\n\t.flex-xxl-shrink-1 {\n\t\tflex-shrink: 1 !important;\n\t}\n\t.flex-xxl-wrap {\n\t\tflex-wrap: wrap !important;\n\t}\n\t.flex-xxl-nowrap {\n\t\tflex-wrap: nowrap !important;\n\t}\n\t.flex-xxl-wrap-reverse {\n\t\tflex-wrap: wrap-reverse !important;\n\t}\n\t.gap-xxl-0 {\n\t\tgap: 0 !important;\n\t}\n\t.gap-xxl-1 {\n\t\tgap: 0.25rem !important;\n\t}\n\t.gap-xxl-2 {\n\t\tgap: 0.5rem !important;\n\t}\n\t.gap-xxl-3 {\n\t\tgap: 1rem !important;\n\t}\n\t.gap-xxl-4 {\n\t\tgap: 1.875rem !important;\n\t}\n\t.gap-xxl-5 {\n\t\tgap: 3rem !important;\n\t}\n\t.justify-content-xxl-start {\n\t\tjustify-content: flex-start !important;\n\t}\n\t.justify-content-xxl-end {\n\t\tjustify-content: flex-end !important;\n\t}\n\t.justify-content-xxl-center {\n\t\tjustify-content: center !important;\n\t}\n\t.justify-content-xxl-between {\n\t\tjustify-content: space-between !important;\n\t}\n\t.justify-content-xxl-around {\n\t\tjustify-content: space-around !important;\n\t}\n\t.justify-content-xxl-evenly {\n\t\tjustify-content: space-evenly !important;\n\t}\n\t.align-items-xxl-start {\n\t\talign-items: flex-start !important;\n\t}\n\t.align-items-xxl-end {\n\t\talign-items: flex-end !important;\n\t}\n\t.align-items-xxl-center {\n\t\talign-items: center !important;\n\t}\n\t.align-items-xxl-baseline {\n\t\talign-items: baseline !important;\n\t}\n\t.align-items-xxl-stretch {\n\t\talign-items: stretch !important;\n\t}\n\t.align-content-xxl-start {\n\t\talign-content: flex-start !important;\n\t}\n\t.align-content-xxl-end {\n\t\talign-content: flex-end !important;\n\t}\n\t.align-content-xxl-center {\n\t\talign-content: center !important;\n\t}\n\t.align-content-xxl-between {\n\t\talign-content: space-between !important;\n\t}\n\t.align-content-xxl-around {\n\t\talign-content: space-around !important;\n\t}\n\t.align-content-xxl-stretch {\n\t\talign-content: stretch !important;\n\t}\n\t.align-self-xxl-auto {\n\t\talign-self: auto !important;\n\t}\n\t.align-self-xxl-start {\n\t\talign-self: flex-start !important;\n\t}\n\t.align-self-xxl-end {\n\t\talign-self: flex-end !important;\n\t}\n\t.align-self-xxl-center {\n\t\talign-self: center !important;\n\t}\n\t.align-self-xxl-baseline {\n\t\talign-self: baseline !important;\n\t}\n\t.align-self-xxl-stretch {\n\t\talign-self: stretch !important;\n\t}\n\t.order-xxl-first {\n\t\torder: -1 !important;\n\t}\n\t.order-xxl-0 {\n\t\torder: 0 !important;\n\t}\n\t.order-xxl-1 {\n\t\torder: 1 !important;\n\t}\n\t.order-xxl-2 {\n\t\torder: 2 !important;\n\t}\n\t.order-xxl-3 {\n\t\torder: 3 !important;\n\t}\n\t.order-xxl-4 {\n\t\torder: 4 !important;\n\t}\n\t.order-xxl-5 {\n\t\torder: 5 !important;\n\t}\n\t.order-xxl-last {\n\t\torder: 6 !important;\n\t}\n\t.m-xxl-0 {\n\t\tmargin: 0 !important;\n\t}\n\t.m-xxl-1 {\n\t\tmargin: 0.25rem !important;\n\t}\n\t.m-xxl-2 {\n\t\tmargin: 0.5rem !important;\n\t}\n\t.m-xxl-3 {\n\t\tmargin: 1rem !important;\n\t}\n\t.m-xxl-4 {\n\t\tmargin: 1.875rem !important;\n\t}\n\t.m-xxl-5 {\n\t\tmargin: 3rem !important;\n\t}\n\t.m-xxl-auto {\n\t\tmargin: auto !important;\n\t}\n\t.mx-xxl-0 {\n\t\tmargin-right: 0 !important;\n\t\tmargin-left: 0 !important;\n\t}\n\t.mx-xxl-1 {\n\t\tmargin-right: 0.25rem !important;\n\t\tmargin-left: 0.25rem !important;\n\t}\n\t.mx-xxl-2 {\n\t\tmargin-right: 0.5rem !important;\n\t\tmargin-left: 0.5rem !important;\n\t}\n\t.mx-xxl-3 {\n\t\tmargin-right: 1rem !important;\n\t\tmargin-left: 1rem !important;\n\t}\n\t.mx-xxl-4 {\n\t\tmargin-right: 1.875rem !important;\n\t\tmargin-left: 1.875rem !important;\n\t}\n\t.mx-xxl-5 {\n\t\tmargin-right: 3rem !important;\n\t\tmargin-left: 3rem !important;\n\t}\n\t.mx-xxl-auto {\n\t\tmargin-right: auto !important;\n\t\tmargin-left: auto !important;\n\t}\n\t.my-xxl-0 {\n\t\tmargin-top: 0 !important;\n\t\tmargin-bottom: 0 !important;\n\t}\n\t.my-xxl-1 {\n\t\tmargin-top: 0.25rem !important;\n\t\tmargin-bottom: 0.25rem !important;\n\t}\n\t.my-xxl-2 {\n\t\tmargin-top: 0.5rem !important;\n\t\tmargin-bottom: 0.5rem !important;\n\t}\n\t.my-xxl-3 {\n\t\tmargin-top: 1rem !important;\n\t\tmargin-bottom: 1rem !important;\n\t}\n\t.my-xxl-4 {\n\t\tmargin-top: 1.875rem !important;\n\t\tmargin-bottom: 1.875rem !important;\n\t}\n\t.my-xxl-5 {\n\t\tmargin-top: 3rem !important;\n\t\tmargin-bottom: 3rem !important;\n\t}\n\t.my-xxl-auto {\n\t\tmargin-top: auto !important;\n\t\tmargin-bottom: auto !important;\n\t}\n\t.mt-xxl-0 {\n\t\tmargin-top: 0 !important;\n\t}\n\t.mt-xxl-1 {\n\t\tmargin-top: 0.25rem !important;\n\t}\n\t.mt-xxl-2 {\n\t\tmargin-top: 0.5rem !important;\n\t}\n\t.mt-xxl-3 {\n\t\tmargin-top: 1rem !important;\n\t}\n\t.mt-xxl-4 {\n\t\tmargin-top: 1.875rem !important;\n\t}\n\t.mt-xxl-5 {\n\t\tmargin-top: 3rem !important;\n\t}\n\t.mt-xxl-auto {\n\t\tmargin-top: auto !important;\n\t}\n\t.me-xxl-0 {\n\t\tmargin-right: 0 !important;\n\t}\n\t.me-xxl-1 {\n\t\tmargin-right: 0.25rem !important;\n\t}\n\t.me-xxl-2 {\n\t\tmargin-right: 0.5rem !important;\n\t}\n\t.me-xxl-3 {\n\t\tmargin-right: 1rem !important;\n\t}\n\t.me-xxl-4 {\n\t\tmargin-right: 1.875rem !important;\n\t}\n\t.me-xxl-5 {\n\t\tmargin-right: 3rem !important;\n\t}\n\t.me-xxl-auto {\n\t\tmargin-right: auto !important;\n\t}\n\t.mb-xxl-0 {\n\t\tmargin-bottom: 0 !important;\n\t}\n\t.mb-xxl-1 {\n\t\tmargin-bottom: 0.25rem !important;\n\t}\n\t.mb-xxl-2 {\n\t\tmargin-bottom: 0.5rem !important;\n\t}\n\t.mb-xxl-3 {\n\t\tmargin-bottom: 1rem !important;\n\t}\n\t.mb-xxl-4 {\n\t\tmargin-bottom: 1.875rem !important;\n\t}\n\t.mb-xxl-5 {\n\t\tmargin-bottom: 3rem !important;\n\t}\n\t.mb-xxl-auto {\n\t\tmargin-bottom: auto !important;\n\t}\n\t.ms-xxl-0 {\n\t\tmargin-left: 0 !important;\n\t}\n\t.ms-xxl-1 {\n\t\tmargin-left: 0.25rem !important;\n\t}\n\t.ms-xxl-2 {\n\t\tmargin-left: 0.5rem !important;\n\t}\n\t.ms-xxl-3 {\n\t\tmargin-left: 1rem !important;\n\t}\n\t.ms-xxl-4 {\n\t\tmargin-left: 1.875rem !important;\n\t}\n\t.ms-xxl-5 {\n\t\tmargin-left: 3rem !important;\n\t}\n\t.ms-xxl-auto {\n\t\tmargin-left: auto !important;\n\t}\n\t.p-xxl-0 {\n\t\tpadding: 0 !important;\n\t}\n\t.p-xxl-1 {\n\t\tpadding: 0.25rem !important;\n\t}\n\t.p-xxl-2 {\n\t\tpadding: 0.5rem !important;\n\t}\n\t.p-xxl-3 {\n\t\tpadding: 1rem !important;\n\t}\n\t.p-xxl-4 {\n\t\tpadding: 1.875rem !important;\n\t}\n\t.p-xxl-5 {\n\t\tpadding: 3rem !important;\n\t}\n\t.px-xxl-0 {\n\t\tpadding-right: 0 !important;\n\t\tpadding-left: 0 !important;\n\t}\n\t.px-xxl-1 {\n\t\tpadding-right: 0.25rem !important;\n\t\tpadding-left: 0.25rem !important;\n\t}\n\t.px-xxl-2 {\n\t\tpadding-right: 0.5rem !important;\n\t\tpadding-left: 0.5rem !important;\n\t}\n\t.px-xxl-3 {\n\t\tpadding-right: 1rem !important;\n\t\tpadding-left: 1rem !important;\n\t}\n\t.px-xxl-4 {\n\t\tpadding-right: 1.875rem !important;\n\t\tpadding-left: 1.875rem !important;\n\t}\n\t.px-xxl-5 {\n\t\tpadding-right: 3rem !important;\n\t\tpadding-left: 3rem !important;\n\t}\n\t.py-xxl-0 {\n\t\tpadding-top: 0 !important;\n\t\tpadding-bottom: 0 !important;\n\t}\n\t.py-xxl-1 {\n\t\tpadding-top: 0.25rem !important;\n\t\tpadding-bottom: 0.25rem !important;\n\t}\n\t.py-xxl-2 {\n\t\tpadding-top: 0.5rem !important;\n\t\tpadding-bottom: 0.5rem !important;\n\t}\n\t.py-xxl-3 {\n\t\tpadding-top: 1rem !important;\n\t\tpadding-bottom: 1rem !important;\n\t}\n\t.py-xxl-4 {\n\t\tpadding-top: 1.875rem !important;\n\t\tpadding-bottom: 1.875rem !important;\n\t}\n\t.py-xxl-5 {\n\t\tpadding-top: 3rem !important;\n\t\tpadding-bottom: 3rem !important;\n\t}\n\t.pt-xxl-0 {\n\t\tpadding-top: 0 !important;\n\t}\n\t.pt-xxl-1 {\n\t\tpadding-top: 0.25rem !important;\n\t}\n\t.pt-xxl-2 {\n\t\tpadding-top: 0.5rem !important;\n\t}\n\t.pt-xxl-3 {\n\t\tpadding-top: 1rem !important;\n\t}\n\t.pt-xxl-4 {\n\t\tpadding-top: 1.875rem !important;\n\t}\n\t.pt-xxl-5 {\n\t\tpadding-top: 3rem !important;\n\t}\n\t.pe-xxl-0 {\n\t\tpadding-right: 0 !important;\n\t}\n\t.pe-xxl-1 {\n\t\tpadding-right: 0.25rem !important;\n\t}\n\t.pe-xxl-2 {\n\t\tpadding-right: 0.5rem !important;\n\t}\n\t.pe-xxl-3 {\n\t\tpadding-right: 1rem !important;\n\t}\n\t.pe-xxl-4 {\n\t\tpadding-right: 1.875rem !important;\n\t}\n\t.pe-xxl-5 {\n\t\tpadding-right: 3rem !important;\n\t}\n\t.pb-xxl-0 {\n\t\tpadding-bottom: 0 !important;\n\t}\n\t.pb-xxl-1 {\n\t\tpadding-bottom: 0.25rem !important;\n\t}\n\t.pb-xxl-2 {\n\t\tpadding-bottom: 0.5rem !important;\n\t}\n\t.pb-xxl-3 {\n\t\tpadding-bottom: 1rem !important;\n\t}\n\t.pb-xxl-4 {\n\t\tpadding-bottom: 1.875rem !important;\n\t}\n\t.pb-xxl-5 {\n\t\tpadding-bottom: 3rem !important;\n\t}\n\t.ps-xxl-0 {\n\t\tpadding-left: 0 !important;\n\t}\n\t.ps-xxl-1 {\n\t\tpadding-left: 0.25rem !important;\n\t}\n\t.ps-xxl-2 {\n\t\tpadding-left: 0.5rem !important;\n\t}\n\t.ps-xxl-3 {\n\t\tpadding-left: 1rem !important;\n\t}\n\t.ps-xxl-4 {\n\t\tpadding-left: 1.875rem !important;\n\t}\n\t.ps-xxl-5 {\n\t\tpadding-left: 3rem !important;\n\t}\n\t.text-xxl-start {\n\t\ttext-align: left !important;\n\t}\n\t.text-xxl-end {\n\t\ttext-align: right !important;\n\t}\n\t.text-xxl-center {\n\t\ttext-align: center !important;\n\t}\n}\n\n@media (min-width: 1200px) {\n\t.fs-1 {\n\t\tfont-size: 2.25rem !important;\n\t}\n\t.fs-2 {\n\t\tfont-size: 1.875rem !important;\n\t}\n\t.fs-3 {\n\t\tfont-size: 1.5rem !important;\n\t}\n}\n\n@media print {\n\t.d-print-inline {\n\t\tdisplay: inline !important;\n\t}\n\t.d-print-inline-block {\n\t\tdisplay: inline-block !important;\n\t}\n\t.d-print-block {\n\t\tdisplay: block !important;\n\t}\n\t.d-print-grid {\n\t\tdisplay: grid !important;\n\t}\n\t.d-print-table {\n\t\tdisplay: table !important;\n\t}\n\t.d-print-table-row {\n\t\tdisplay: table-row !important;\n\t}\n\t.d-print-table-cell {\n\t\tdisplay: table-cell !important;\n\t}\n\t.d-print-flex {\n\t\tdisplay: flex !important;\n\t}\n\t.d-print-inline-flex {\n\t\tdisplay: inline-flex !important;\n\t}\n\t.d-print-none {\n\t\tdisplay: none !important;\n\t}\n}\n\n.c-pointer {\n\tcursor: pointer;\n}\n\n* {\n\toutline: none;\n\tpadding: 0;\n}\n*::after {\n\tmargin: 0;\n\tpadding: 0;\n}\n*::before {\n\tmargin: 0;\n\tpadding: 0;\n}\n\n::selection {\n\tcolor: #fff;\n\tbackground: var(--primary);\n}\n\n.dropzone .dz-message {\n\tmargin: 5em 0;\n}\n\nh1 a,\n.h1 a,\nh2 a,\n.h2 a,\nh3 a,\n.h3 a,\nh4 a,\n.h4 a,\nh5 a,\n.h5 a,\nh6 a,\n.h6 a {\n\tcolor: #303972;\n}\nh1 a:hover,\n.h1 a:hover,\nh2 a:hover,\n.h2 a:hover,\nh3 a:hover,\n.h3 a:hover,\nh4 a:hover,\n.h4 a:hover,\nh5 a:hover,\n.h5 a:hover,\nh6 a:hover,\n.h6 a:hover {\n\tcolor: var(--primary) !important;\n}\n\n.light-logo {\n\tdisplay: none;\n}\n\n[data-theme-version='dark'] .light-logo {\n\tdisplay: block;\n}\n\n[data-theme-version='dark'] .dark-logo {\n\tdisplay: none;\n}\n\nbody {\n\t-ms-overflow-style: none;\n\tscrollbar-width: none;\n}\n\nbody::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n@media only screen and (max-width: 100rem) {\n\t:root {\n\t\tfont-size: 0.875rem;\n\t}\n}\n\nbody {\n\toverflow-x: hidden;\n\theight: 100%;\n\tposition: relative;\n\tmax-width: 100%;\n\tfont-size: 0.875rem;\n}\n@media only screen and (max-width: 61.9375rem) {\n\tbody {\n\t\tfont-size: 0.875rem;\n\t}\n}\n\ntextarea.form-control {\n\tmin-height: auto !important;\n\theight: auto !important;\n}\n\n.form-label {\n\tmargin-bottom: 0.5rem;\n}\n\n.required {\n\tcolor: #fd5353 !important;\n}\n\np {\n\tline-height: 1.8;\n\tfont-weight: 400;\n\tcolor: #a098ae;\n}\n\n.box-shadow-none {\n\tbox-shadow: none !important;\n}\n\n.media {\n\tdisplay: flex;\n\talign-items: flex-start;\n}\n\n.media-body {\n\tflex: 1;\n}\n\n#main-wrapper {\n\topacity: 0;\n\ttransition: all 0.25s ease-in;\n\tposition: relative;\n\tbackground-color: #e6ebee;\n}\n#main-wrapper.show {\n\topacity: 1;\n}\n\n.rounded-lg {\n\tborder-radius: 0.375rem;\n}\n\nul {\n\tpadding: 0;\n\tmargin: 0;\n}\n\nli {\n\tlist-style: none;\n}\n\na {\n\tcolor: #a098ae;\n\ttext-decoration: none;\n}\na:hover,\na:focus,\na.active {\n\ttext-decoration: none;\n}\n\n.btn-link:hover,\n.btn-link:focus,\n.btn-link.active {\n\ttext-decoration: none;\n}\n\n.bg-primary {\n\tbackground-color: var(--primary) !important;\n}\n\n.text-primary {\n\tcolor: var(--primary) !important;\n}\n\n.fs-12 {\n\tfont-size: 0.75rem !important;\n\tline-height: 1.5;\n}\n\n.fs-13 {\n\tfont-size: 0.8125rem !important;\n\tline-height: 1.5;\n}\n\n.fs-14 {\n\tfont-size: 0.875rem !important;\n\tline-height: 1.6;\n}\n\n.fs-15 {\n\tfont-size: 0.938rem !important;\n\tline-height: 1.5;\n}\n\n.fs-16 {\n\tfont-size: 1rem !important;\n\tline-height: 1.6;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.fs-16 {\n\t\tfont-size: 0.875rem !important;\n\t}\n}\n\n.fs-18 {\n\tfont-size: 1.125rem !important;\n\tline-height: 1.5;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.fs-18 {\n\t\tfont-size: 1rem !important;\n\t}\n}\n\n.fs-20 {\n\tfont-size: 1.25rem !important;\n\tline-height: 1.5;\n}\n\n.fs-22 {\n\tfont-size: 1.375rem !important;\n\tline-height: 1.5;\n}\n\n.fs-24 {\n\tfont-size: 1.5rem !important;\n\tline-height: 1.4;\n}\n\n.fs-26 {\n\tfont-size: 1.625rem !important;\n\tline-height: 1.4;\n}\n\n.fs-28 {\n\tfont-size: 1.75rem !important;\n\tline-height: 1.4;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.fs-28 {\n\t\tfont-size: 1.5rem !important;\n\t}\n}\n\n.fs-30 {\n\tfont-size: 1.875rem !important;\n\tline-height: 1.4;\n}\n\n.fs-32 {\n\tfont-size: 2rem !important;\n\tline-height: 1.25;\n}\n\n.fs-34 {\n\tfont-size: 2.125rem !important;\n\tline-height: 1.25;\n}\n\n.fs-35 {\n\tfont-size: 2.1875rem !important;\n\tline-height: 1.25;\n}\n\n.fs-36 {\n\tfont-size: 2.25rem !important;\n\tline-height: 1.25;\n}\n\n.fs-38 {\n\tfont-size: 2.375rem !important;\n\tline-height: 1.25;\n}\n\n.fs-46 {\n\tfont-size: 2.875rem !important;\n\tline-height: 1.25;\n}\n\n.fs-48 {\n\tfont-size: 3rem !important;\n\tline-height: 1.25;\n}\n\n.font-w100 {\n\tfont-weight: 100;\n}\n\n.font-w200 {\n\tfont-weight: 200;\n}\n\n.font-w300 {\n\tfont-weight: 300;\n}\n\n.font-w400 {\n\tfont-weight: 400 !important;\n}\n\n.font-w500 {\n\tfont-weight: 500;\n}\n\n.font-w600 {\n\tfont-weight: 600;\n}\n\n.font-w700 {\n\tfont-weight: 700;\n}\n\n.font-w800 {\n\tfont-weight: 800;\n}\n\n.font-w900 {\n\tfont-weight: 900;\n}\n\nh1,\n.h1,\n.h1,\nh2,\n.h2,\n.h2,\nh3,\n.h3,\n.h3,\nh4,\n.h4,\n.h4,\nh5,\n.h5,\n.h5,\nh6,\n.h6,\n.h6 {\n\tline-height: 1.5;\n\tcolor: #303972;\n}\n\n.w-space-no {\n\twhite-space: nowrap;\n}\n\n.content-body .container {\n\tmargin-top: 2.5rem;\n}\n\n.content-body .container-fluid,\n.content-body .container-sm,\n.content-body .container-md,\n.content-body .container-lg,\n.content-body .container-xl,\n.content-body .container-xxl {\n\tpadding-top: 1.875rem;\n\tpadding-right: 1.875rem;\n\tpadding-left: 1.875rem;\n}\n@media only screen and (max-width: 75rem) {\n\t.content-body .container-fluid,\n\t.content-body .container-sm,\n\t.content-body .container-md,\n\t.content-body .container-lg,\n\t.content-body .container-xl,\n\t.content-body .container-xxl {\n\t\tpadding-top: 1.875rem;\n\t\tpadding-right: 1.875rem;\n\t\tpadding-left: 1.875rem;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.content-body .container-fluid,\n\t.content-body .container-sm,\n\t.content-body .container-md,\n\t.content-body .container-lg,\n\t.content-body .container-xl,\n\t.content-body .container-xxl {\n\t\tpadding-top: 1.25rem;\n\t\tpadding-right: 1.25rem;\n\t\tpadding-left: 1.25rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.content-body .container-fluid,\n\t.content-body .container-sm,\n\t.content-body .container-md,\n\t.content-body .container-lg,\n\t.content-body .container-xl,\n\t.content-body .container-xxl {\n\t\tpadding-top: 15px;\n\t\tpadding-right: 15px;\n\t\tpadding-left: 15px;\n\t}\n}\n\n/*sp*/\n.row.sp4,\n.sp4 {\n\tmargin-left: -0.125rem;\n\tmargin-right: -0.125rem;\n}\n.row.sp4 [class*='col-'],\n.sp4 [class*='col-'] {\n\tpadding-left: 0.125rem;\n\tpadding-right: 0.125rem;\n}\n\n.op1 {\n\topacity: 0.1;\n}\n\n.op2 {\n\topacity: 0.2;\n}\n\n.op3 {\n\topacity: 0.3;\n}\n\n.op4 {\n\topacity: 0.4;\n}\n\n.op5 {\n\topacity: 0.5;\n}\n\n.op6 {\n\topacity: 0.6;\n}\n\n.op7 {\n\topacity: 0.7;\n}\n\n.op8 {\n\topacity: 0.8;\n}\n\n.op9 {\n\topacity: 0.9;\n}\n\n.content-heading {\n\tfont-size: 1rem;\n\tmargin-bottom: 1.875rem;\n\tmargin-top: 3.125rem;\n\tborder-bottom: 0.0625rem solid #f2f2f2;\n\tpadding-bottom: 0.625rem;\n}\n[direction='rtl'] .content-heading {\n\ttext-align: right;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active:focus,\n.btn-primary:not(:disabled):not(.disabled).active:focus {\n\tbox-shadow: none;\n}\n\n.vh-100 {\n\theight: 100vh !important;\n}\n\n.img-fix {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.support-ticket {\n\tposition: fixed;\n\tbottom: 1.875rem;\n\tright: 0.9375rem;\n\tz-index: 999999;\n}\n\n.support-ticket-btn {\n\twidth: 6.25rem;\n\tbackground: #7cb442;\n\tanimation: 0.7s ease-in-out 0s infinite alternate none running crescendo;\n\tborder-radius: 3.125rem;\n\tcolor: #fff;\n\tfont-size: 0.5rem;\n\tfont-size: 1rem;\n\tpadding: 0.3125rem 0.625rem 0.4375rem;\n\ttext-align: center;\n\tdisplay: inline-block;\n\tbox-shadow: rgba(124, 180, 66, 0.7) 0rem 0.5rem 2.1875rem 0rem;\n}\n.support-ticket-btn:hover,\n.support-ticket-btn:focus {\n\tcolor: #fff;\n}\n\n.text-blue {\n\tcolor: #374c98;\n}\n\n.text-indigo {\n\tcolor: #6610f2;\n}\n\n.text-purple {\n\tcolor: #6f42c1;\n}\n\n.text-pink {\n\tcolor: #eb62d0 !important;\n}\n\n.text-red {\n\tcolor: #ee3232;\n}\n\n.text-orange {\n\tcolor: #ff9900;\n}\n\n.text-yellow {\n\tcolor: #fffa6f;\n}\n\n.text-green {\n\tcolor: #297f00;\n}\n\n.text-teal {\n\tcolor: #20c997;\n}\n\n.text-cyan {\n\tcolor: #3065d0;\n}\n\n/* .bg-gray-dark{\n\tbackground:$color_pallate_2 !important;\n}\n.bg-purpal{\n\tbackground:$color_pallate_4 !important;\n}\n.bg-red{\n\tbackground:$color_pallate_5 !important;\n}\n.bg-blue-dark{\n\tbackground:$color_pallate_6 !important;\n} */\n.bg-blue {\n\tbackground: #496ecc !important;\n}\n\n.bg-orange {\n\tbackground: #ed8030 !important;\n}\n\n.bg-green {\n\tbackground: #299e4a !important;\n}\n\n.bg-purpel {\n\tbackground: #9517c1 !important;\n}\n\n.bg-dark-blue {\n\tbackground: #251e71 !important;\n}\n\n/* .bg-blue-light{\n\tbackground:$color_pallate_8 !important;\n}\n.bg-green-light{\n\tbackground:$color_pallate_9 !important;\n}\n.bg-green{\n\tbackground:$color_pallate_10 !important;\n} */\n.bg-black {\n\tbackground: #000;\n}\n\n.text-black {\n\tcolor: #000 !important;\n}\n\n.dlab-scroll {\n\tposition: relative;\n}\n\n.scale1 {\n\ttransform: scale(1.1);\n\t-moz-transform: scale(1.1);\n\t-webkit-transform: scale(1.1);\n\t-ms-transform: scale(1.1);\n\t-o-transform: scale(1.1);\n\tdisplay: inline-block;\n}\n\n.scale2 {\n\ttransform: scale(1.2);\n\t-moz-transform: scale(1.2);\n\t-webkit-transform: scale(1.2);\n\t-ms-transform: scale(1.2);\n\t-o-transform: scale(1.2);\n\tdisplay: inline-block;\n}\n\n.scale3 {\n\ttransform: scale(1.3);\n\t-moz-transform: scale(1.3);\n\t-webkit-transform: scale(1.3);\n\t-ms-transform: scale(1.3);\n\t-o-transform: scale(1.3);\n\tdisplay: inline-block;\n}\n\n.scale4 {\n\ttransform: scale(1.4);\n\t-moz-transform: scale(1.4);\n\t-webkit-transform: scale(1.4);\n\t-ms-transform: scale(1.4);\n\t-o-transform: scale(1.4);\n\tdisplay: inline-block;\n}\n\n.scale5 {\n\ttransform: scale(1.5);\n\t-moz-transform: scale(1.5);\n\t-webkit-transform: scale(1.5);\n\t-ms-transform: scale(1.5);\n\t-o-transform: scale(1.5);\n\tdisplay: inline-block;\n}\n\n.scale-2 {\n\ttransform: scale(2);\n\t-moz-transform: scale(2);\n\t-webkit-transform: scale(2);\n\t-ms-transform: scale(2);\n\t-o-transform: scale(2);\n\tdisplay: inline-block;\n}\n\n@-webkit-keyframes crescendo {\n\tfrom {\n\t\t-webkit-transform: translateY(0.3125rem) scale(0.8);\n\t\t-ms-transform: translateY(0.3125rem) scale(0.8);\n\t\ttransform: translateY(0.3125rem) scale(0.8);\n\t}\n\tto {\n\t\t-webkit-transform: translateY(0rem) scale(1);\n\t\t-ms-transform: translateY(0rem) scale(1);\n\t\ttransform: translateY(0rem) scale(1);\n\t}\n}\n\n.mh-auto {\n\tmin-height: auto !important;\n}\n\n.out-footer {\n\twidth: calc(100% - 22.625rem);\n\tmargin-right: 1.875rem;\n\tmargin-left: auto;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.out-footer {\n\t\twidth: calc(100% - 20.625rem);\n\t}\n}\n@media only screen and (max-width: 63.938rem) {\n\t.out-footer {\n\t\twidth: calc(100% - 10.125rem);\n\t}\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.out-footer {\n\t\twidth: calc(100% - 10.125rem);\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.out-footer {\n\t\twidth: 100%;\n\t}\n}\n\n.overflow-y-scroll {\n\toverflow-y: scroll;\n}\n\n.height10 {\n\theight: 0.625rem;\n}\n\n.height20 {\n\theight: 1.25rem;\n}\n\n.height30 {\n\theight: 1.875rem;\n}\n\n.height40 {\n\theight: 2.5rem;\n}\n\n.height50 {\n\theight: 3.125rem;\n}\n\n.height60 {\n\theight: 3.75rem;\n}\n\n.height70 {\n\theight: 4.375rem;\n}\n\n.height80 {\n\theight: 5rem;\n}\n\n.height90 {\n\theight: 5.625rem;\n}\n\n.height100 {\n\theight: 6.25rem;\n}\n\n.height110 {\n\theight: 6.875rem;\n}\n\n.height120 {\n\theight: 7.5rem;\n}\n\n.height130 {\n\theight: 8.125rem;\n}\n\n.height140 {\n\theight: 8.75rem;\n}\n\n.height150 {\n\theight: 9.375rem;\n}\n\n.height160 {\n\theight: 10rem;\n}\n\n.height170 {\n\theight: 10.625rem;\n}\n\n.height180 {\n\theight: 11.25rem;\n}\n\n.height190 {\n\theight: 11.875rem;\n}\n\n.height200 {\n\theight: 12.5rem;\n}\n\n.height210 {\n\theight: 13.125rem;\n}\n\n.height220 {\n\theight: 13.75rem;\n}\n\n.height230 {\n\theight: 14.375rem;\n}\n\n.height240 {\n\theight: 15rem;\n}\n\n.height250 {\n\theight: 15.625rem;\n}\n\n.height260 {\n\theight: 16.25rem;\n}\n\n.height270 {\n\theight: 16.875rem;\n}\n\n.height280 {\n\theight: 17.5rem;\n}\n\n.height290 {\n\theight: 18.125rem;\n}\n\n.height300 {\n\theight: 18.75rem;\n}\n\n.height310 {\n\theight: 19.375rem;\n}\n\n.height320 {\n\theight: 20rem;\n}\n\n.height330 {\n\theight: 20.625rem;\n}\n\n.height340 {\n\theight: 21.25rem;\n}\n\n.height350 {\n\theight: 21.875rem;\n}\n\n.height360 {\n\theight: 22.5rem;\n}\n\n.height370 {\n\theight: 23.125rem;\n}\n\n.height380 {\n\theight: 23.75rem;\n}\n\n.height390 {\n\theight: 24.375rem;\n}\n\n.height400 {\n\theight: 25rem;\n}\n\n.height415 {\n\theight: 25.9375rem;\n}\n\n.height450 {\n\theight: 28.125rem;\n}\n\n.height500 {\n\theight: 31.25rem;\n}\n\n.height550 {\n\theight: 34.375rem;\n}\n\n.height600 {\n\theight: 37.5rem;\n}\n\n.height630 {\n\theight: 39.375rem;\n}\n\n.height720 {\n\theight: 45rem;\n}\n\n.height750 {\n\theight: 46.875rem;\n}\n\n.height800 {\n\theight: 50rem;\n}\n\n.width10 {\n\twidth: 0.625rem;\n}\n\n.width20 {\n\twidth: 1.25rem;\n}\n\n.width30 {\n\twidth: 1.875rem;\n}\n\n.width40 {\n\twidth: 2.5rem;\n}\n\n.width50 {\n\twidth: 3.125rem;\n}\n\n.width60 {\n\twidth: 3.75rem;\n}\n\n.width70 {\n\twidth: 4.375rem;\n}\n\n.width80 {\n\twidth: 5rem;\n}\n\n.width90 {\n\twidth: 5.625rem;\n}\n\n.width100 {\n\twidth: 6.25rem;\n}\n\n.width110 {\n\twidth: 6.875rem;\n}\n\n.width120 {\n\twidth: 7.5rem;\n}\n\n.width130 {\n\twidth: 8.125rem;\n}\n\n.width140 {\n\twidth: 8.75rem;\n}\n\n.width150 {\n\twidth: 9.375rem;\n}\n\n.width160 {\n\twidth: 10rem;\n}\n\n.width170 {\n\twidth: 10.625rem;\n}\n\n.width180 {\n\twidth: 11.25rem;\n}\n\n.width190 {\n\twidth: 11.875rem;\n}\n\n.width200 {\n\twidth: 12.5rem;\n}\n\n.width210 {\n\twidth: 13.125rem;\n}\n\n.width220 {\n\twidth: 13.75rem;\n}\n\n.width230 {\n\twidth: 14.375rem;\n}\n\n.width240 {\n\twidth: 15rem;\n}\n\n.width250 {\n\twidth: 15.625rem;\n}\n\n.width260 {\n\twidth: 16.25rem;\n}\n\n.width270 {\n\twidth: 16.875rem;\n}\n\n.width280 {\n\twidth: 17.5rem;\n}\n\n.width290 {\n\twidth: 18.125rem;\n}\n\n.width300 {\n\twidth: 18.75rem;\n}\n\n.width310 {\n\twidth: 19.375rem;\n}\n\n.width320 {\n\twidth: 20rem;\n}\n\n.width330 {\n\twidth: 20.625rem;\n}\n\n.width340 {\n\twidth: 21.25rem;\n}\n\n.width350 {\n\twidth: 21.875rem;\n}\n\n.width360 {\n\twidth: 22.5rem;\n}\n\n.width370 {\n\twidth: 23.125rem;\n}\n\n.width380 {\n\twidth: 23.75rem;\n}\n\n.width390 {\n\twidth: 24.375rem;\n}\n\n.width400 {\n\twidth: 25rem;\n}\n\n.rounded {\n\tborder-radius: 0.375rem !important;\n}\n\nlabel {\n\tmargin-bottom: 0.5rem;\n}\n\n@keyframes gXGDoR {\n\tfrom {\n\t\t-webkit-transform: translateY(0.3125rem) scale(0.8);\n\t\t-ms-transform: translateY(0.3125rem) scale(0.8);\n\t\ttransform: translateY(0.3125rem) scale(0.8);\n\t}\n\tto {\n\t\t-webkit-transform: translateY(0rem) scale(1);\n\t\t-ms-transform: translateY(0rem) scale(1);\n\t\ttransform: translateY(0rem) scale(1);\n\t}\n}\n\n@keyframes crescendo {\n\tfrom {\n\t\t-webkit-transform: translateY(0.3125rem) scale(0.8);\n\t\t-ms-transform: translateY(0.3125rem) scale(0.8);\n\t\ttransform: translateY(0.3125rem) scale(0.8);\n\t}\n\tto {\n\t\t-webkit-transform: translateY(0rem) scale(1);\n\t\t-ms-transform: translateY(0rem) scale(1);\n\t\ttransform: translateY(0rem) scale(1);\n\t}\n}\n\n@keyframes gXGDoR {\n\tfrom {\n\t\t-webkit-transform: translateY(0.3125rem) scale(0.8);\n\t\t-ms-transform: translateY(0.3125rem) scale(0.8);\n\t\ttransform: translateY(0.3125rem) scale(0.8);\n\t}\n\tto {\n\t\t-webkit-transform: translateY(0rem) scale(1);\n\t\t-ms-transform: translateY(0rem) scale(1);\n\t\ttransform: translateY(0rem) scale(1);\n\t}\n}\n\n.bg-pink {\n\tbackground-color: #eb62d0 !important;\n}\n\ndiv,\nspan,\nol,\nul {\n\tscrollbar-width: thin;\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1600px) {\n\t.col-xxl-1 {\n\t\tflex: 0 0 8.33333%;\n\t\tmax-width: 8.33333%;\n\t}\n\t.col-xxl-2 {\n\t\tflex: 0 0 16.66667%;\n\t\tmax-width: 16.66667%;\n\t}\n\t.col-xxl-3 {\n\t\tflex: 0 0 25%;\n\t\tmax-width: 25%;\n\t}\n\t.col-xxl-4 {\n\t\tflex: 0 0 33.33333%;\n\t\tmax-width: 33.33333%;\n\t}\n\t.col-xxl-5 {\n\t\tflex: 0 0 41.66667%;\n\t\tmax-width: 41.66667%;\n\t}\n\t.col-xxl-6 {\n\t\tflex: 0 0 50%;\n\t\tmax-width: 50%;\n\t}\n\t.col-xxl-7 {\n\t\tflex: 0 0 58.33333%;\n\t\tmax-width: 58.33333%;\n\t}\n\t.col-xxl-8 {\n\t\tflex: 0 0 66.66667%;\n\t\tmax-width: 66.66667%;\n\t}\n\t.col-xxl-9 {\n\t\tflex: 0 0 75%;\n\t\tmax-width: 75%;\n\t}\n\t.col-xxl-10 {\n\t\tflex: 0 0 83.33333%;\n\t\tmax-width: 83.33333%;\n\t}\n\t.col-xxl-11 {\n\t\tflex: 0 0 91.66667%;\n\t\tmax-width: 91.66667%;\n\t}\n\t.col-xxl-12 {\n\t\tflex: 0 0 100%;\n\t\tmax-width: 100%;\n\t}\n\t.mb-xxl-4 {\n\t\tmargin-bottom: 1.5rem !important;\n\t}\n}\n\n#preloader {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 100vh;\n\tposition: fixed;\n\twidth: 100%;\n\tz-index: 999999;\n}\n#preloader .dot {\n\tbackground: var(--primary);\n\tborder-radius: 50%;\n\tdisplay: inline-block;\n\tmargin-right: 20px;\n\twidth: 25px;\n\theight: 25px;\n}\n#preloader .dot:first-child {\n\tanimation: FirstDot 3s infinite;\n}\n#preloader .dot:nth-child(2) {\n\tanimation: SecondDot 3s infinite;\n}\n#preloader .dot:nth-child(3) {\n\tanimation: ThirdDot 3s infinite;\n}\n#preloader .dot:nth-child(4) {\n\tanimation: FourthDot 3s infinite;\n}\n#preloader .dot:nth-child(5) {\n\tanimation: FifthDot 3s infinite;\n}\n\n@keyframes FirstDot {\n\t0% {\n\t\ttransform: scale(1) translateX(0);\n\t}\n\t25% {\n\t\ttransform: scale(2.5) translateX(0);\n\t}\n\t50% {\n\t\ttransform: scale(1) translateX(0);\n\t}\n\t83% {\n\t\ttransform: scale(1) translateX(240px);\n\t}\n\t100% {\n\t\ttransform: scale(1) translateX(0);\n\t}\n}\n\n@keyframes SecondDot {\n\t0% {\n\t\ttransform: translateX(0px);\n\t}\n\t27% {\n\t\ttransform: translateX(-40px);\n\t}\n\t50% {\n\t\ttransform: translateX(0px);\n\t}\n\t81% {\n\t\ttransform: translateX(180px);\n\t}\n\t100% {\n\t\ttransform: translateX(0);\n\t}\n}\n\n@keyframes ThirdDot {\n\t0% {\n\t\ttransform: translateX(0px);\n\t}\n\t29% {\n\t\ttransform: translateX(-100px);\n\t}\n\t50% {\n\t\ttransform: translateX(0px);\n\t}\n\t79% {\n\t\ttransform: translateX(120px);\n\t}\n\t100% {\n\t\ttransform: translateX(0);\n\t}\n}\n\n@keyframes FourthDot {\n\t0% {\n\t\ttransform: translateX(0px);\n\t}\n\t31% {\n\t\ttransform: translateX(-160px);\n\t}\n\t50% {\n\t\ttransform: translateX(0px);\n\t}\n\t77% {\n\t\ttransform: translateX(60px);\n\t}\n\t100% {\n\t\ttransform: translateX(0);\n\t}\n}\n\n@keyframes FifthDot {\n\t0% {\n\t\ttransform: scale(1) translateX(0);\n\t}\n\t33% {\n\t\ttransform: scale(1) translateX(-220px);\n\t}\n\t50% {\n\t\ttransform: scale(1) translateX(0);\n\t}\n\t75% {\n\t\ttransform: scale(2.5) translateX(0);\n\t}\n\t100% {\n\t\ttransform: scale(1) translateX(0);\n\t}\n}\n\n.footer {\n\tpadding: 0.3875rem 0;\n\tfont-size: 0.875rem;\n\tbackground-color: #ffffff;\n\tborder-top-left-radius: 0.375rem;\n\tborder-top-right-radius: 0.375rem;\n\tmargin-top: 1rem;\n}\n.footer .copyright {\n\tpadding: 0.5375rem;\n\tmargin: 0;\n}\n.footer .copyright p {\n\ttext-align: center;\n\tmargin: 0;\n}\n.footer .copyright a {\n\tcolor: var(--primary);\n}\n.footer.footer-outer {\n\t/* width: calc(100% - 43.225rem); */\n\tmargin-right: 2rem;\n\tmargin-left: 20.5rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.footer.footer-outer {\n\t\twidth: calc(100% - 20.525rem);\n\t\tmargin-right: 1.575rem;\n\t}\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.footer.footer-outer {\n\t\twidth: calc(100% - 9.625rem);\n\t\tmargin-right: 1.575rem;\n\t\tpadding-left: 0.8rem !important;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.footer.footer-outer {\n\t\twidth: calc(100% - 2.825rem) !important;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.footer.footer-outer {\n\t\twidth: calc(100% - 2.025rem) !important;\n\t\tmargin-right: 0.875rem;\n\t}\n}\n.footer.style-1 {\n\twidth: calc(100% - 39.125rem);\n\tmargin-right: 19.975rem;\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.footer.style-1 {\n\t\twidth: calc(100% - 9.625rem);\n\t\tmargin-right: 1.475rem;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.footer.style-1 {\n\t\twidth: calc(100% - 2.725rem) !important;\n\t\tmargin-right: 1.475rem !important;\n\t}\n}\n.footer.style-2 {\n\twidth: calc(100% - 21.325rem);\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.footer.style-2 {\n\t\twidth: calc(100% - 9.925rem);\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.footer.style-2 {\n\t\twidth: calc(100% - 2.325rem) !important;\n\t\tmargin-right: 0.975rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.footer.style-2 {\n\t\twidth: calc(100% - 1.825rem) !important;\n\t}\n}\n\n[data-sidebar-style='mini'] .nav-control,\n[data-layout='horizontal'] .nav-control {\n\tdisplay: none;\n}\n\n@media only screen and (max-width: 47.9375rem) {\n\t[data-sidebar-style='overlay'] .nav-header .logo-abbr {\n\t\tdisplay: block;\n\t}\n}\n\n[data-header-position='fixed'] .nav-header {\n\tposition: fixed;\n}\n\n.nav-header {\n\theight: 5rem;\n\twidth: var(--width);\n\tdisplay: inline-block;\n\tbackground-color: var(--nav-headbg);\n\ttext-align: left;\n\tposition: absolute;\n\ttop: 0;\n\ttransition: all 0.2s ease;\n\tz-index: 5;\n}\n.nav-header .logo-abbr {\n\tmax-width: 2.9375rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.nav-header .logo-abbr {\n\t\tmax-width: 2.8125rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.nav-header .logo-abbr {\n\t\twidth: 4.1875rem;\n\t\theight: 4.1875rem;\n\t}\n}\n.nav-header .logo-compact {\n\tdisplay: none;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.nav-header {\n\t\theight: 6.5rem;\n\t\twidth: 17rem;\n\t}\n}\n.nav-header .brand-logo {\n\tdisplay: flex;\n\theight: 100%;\n\twidth: 100%;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tfont-size: 1.125rem;\n\tcolor: #fff;\n\ttext-decoration: none;\n\tpadding-left: 1.675rem;\n\tpadding-right: 1.675rem;\n\tfont-weight: 700;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.nav-header .brand-logo {\n\t\tpadding-left: 1.25rem;\n\t\tpadding-right: 1.25rem;\n\t}\n}\n[data-sidebar-style='compact'] .nav-header .brand-logo,\n[data-sidebar-style='mini'] .nav-header .brand-logo {\n\tpadding-left: 0;\n\tpadding-right: 0;\n\tjustify-content: center;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.nav-header .brand-logo {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t\tjustify-content: center;\n\t}\n}\n.nav-header .brand-title {\n\tmargin-left: 0.9375rem;\n\tmax-width: 8.75rem;\n\tcolor: #000;\n}\n.nav-header .brand-title svg path {\n\tfill: var(--primary);\n}\n[data-theme-version='dark'] .nav-header .brand-title {\n\tbackground-position: 0 120%;\n}\n.nav-header .brand-title h2,\n.nav-header .brand-title .h2 {\n\tline-height: 0;\n\tfont-weight: bold;\n\tfont-size: 1.75rem;\n\tmargin-bottom: 12px;\n}\n.nav-header .brand-title .brand-sub-title {\n\tfont-size: 0.875rem;\n\tfont-weight: 400;\n\twhite-space: nowrap;\n\tfont-family: Nunito;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.nav-header {\n\t\ttop: 0px;\n\t\tbackground: transparent;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.nav-header {\n\t\ttop: 0px;\n\t}\n}\n.nav-header .rect-primary-rect {\n\tfill: var(--primary);\n}\n\n@media only screen and (max-width: 74.9375rem) {\n\t.nav-header {\n\t\theight: 5rem;\n\t}\n}\n\n@media only screen and (max-width: 63.9375rem) {\n\t.nav-header {\n\t\twidth: 5rem;\n\t}\n\t.nav-header .brand-title {\n\t\tdisplay: none;\n\t}\n}\n\n.nav-control {\n\tcursor: pointer;\n\tposition: absolute;\n\tright: -4rem;\n\ttext-align: center;\n\ttop: 46%;\n\ttransform: translateY(-43%);\n\tz-index: 9999;\n\tfont-size: 1.4rem;\n\tbackground: transparent;\n\theight: 2.5rem;\n\twidth: 2.5rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 0.375rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.nav-control {\n\t\tright: -4.1rem;\n\t\ttop: 40%;\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.nav-control {\n\t\ttop: 45%;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.nav-control {\n\t\tright: -3rem;\n\t\ttop: 43%;\n\t\theight: 43px;\n\t\twidth: 43px;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.nav-control {\n\t\ttop: 43%;\n\t\theight: 39px;\n\t\twidth: 39px;\n\t\tright: -1.875rem;\n\t}\n}\n\n.hamburger {\n\tdisplay: inline-block;\n\tleft: 0.2rem;\n\tposition: relative;\n\t-webkit-transition: all 0.3s ease-in-out 0s;\n\ttransition: all 0.3s ease-in-out 0s;\n\twidth: 1.625rem;\n\tz-index: 999;\n}\n.hamburger svg {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 1;\n}\n\n.hamburger .line {\n\tbackground: #303972;\n\tdisplay: block;\n\theight: 0.188rem;\n\tborder-radius: 0.1875rem;\n\tmargin-top: 0.25rem;\n\tmargin-bottom: 0.25rem;\n\tmargin-right: auto;\n\t-webkit-transition: all 0.3s ease-in-out;\n\ttransition: all 0.3s ease-in-out;\n\topacity: 0;\n}\n\n.hamburger.is-active {\n\tleft: -0.9rem;\n}\n.hamburger.is-active svg {\n\tdisplay: none;\n}\n.hamburger.is-active line {\n\topacity: 1;\n}\n\n.hamburger .line:nth-child(1) {\n\twidth: 1.375rem;\n}\n\n.hamburger .line:nth-child(2) {\n\twidth: 1.375rem;\n}\n\n.hamburger .line:nth-child(3) {\n\twidth: 0.875rem;\n}\n\n.hamburger:hover {\n\tcursor: pointer;\n}\n\n.hamburger:hover .line {\n\twidth: 1.625rem;\n}\n\n.hamburger.is-active .line:nth-child(1),\n.hamburger.is-active .line:nth-child(3) {\n\twidth: 0.625rem;\n\theight: 0.125rem;\n}\n\n.hamburger.is-active .line:nth-child(2) {\n\t-webkit-transform: translateX(0px);\n\ttransform: translateX(0px);\n\twidth: 1.375rem;\n\theight: 0.125rem;\n}\n\n.hamburger.is-active .line:nth-child(1) {\n\t-webkit-transform: translateY(2px) translateX(12px) rotate(45deg);\n\ttransform: translateY(2px) translateX(12px) rotate(45deg);\n}\n\n.hamburger.is-active .line:nth-child(3) {\n\t-webkit-transform: translateY(-2px) translateX(12px) rotate(-45deg);\n\ttransform: translateY(-2px) translateX(12px) rotate(-45deg);\n}\n\n@media (min-width: 47.9375rem) {\n\t[data-sidebar-style='compact'] .nav-control {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='compact'] .nav-header {\n\t\twidth: 11.25rem;\n\t}\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .brand-title {\n\tdisplay: none;\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .nav-header .logo-abbr {\n\tdisplay: block;\n}\n\n[data-sidebar-style='full'][data-layout='horizontal'] .logo-compact {\n\tdisplay: none;\n}\n\n[data-sidebar-style='mini'] .nav-header {\n\theight: 5.3rem;\n}\n[data-sidebar-style='mini'] .nav-header .logo-abbr {\n\tdisplay: block;\n}\n@media only screen and (max-width: 100rem) {\n\t[data-sidebar-style='mini'] .nav-header {\n\t\theight: 6.1rem;\n\t}\n}\n@media only screen and (max-width: 64rem) {\n\t[data-sidebar-style='mini'] .nav-header {\n\t\theight: 5.5rem;\n\t}\n}\n\n[data-sidebar-style='compact'][data-layout='vertical'] .nav-header .brand-title {\n\tdisplay: none;\n}\n\n[data-sidebar-style='compact'][data-layout='vertical'] .nav-header .logo-compact {\n\tmax-width: 4.6875rem;\n}\n\n[data-sidebar-style='compact'][data-layout='horizontal'] .nav-header .brand-logo {\n\tpadding-left: 1.875rem;\n\tpadding-right: 1.875rem;\n\tjustify-content: start;\n}\n\n[data-sidebar-style='modern'][data-layout='vertical'] .nav-header {\n\twidth: 14.625rem;\n}\n[data-sidebar-style='modern'][data-layout='vertical'] .nav-header .brand-title {\n\tdisplay: none;\n}\n[data-sidebar-style='modern'][data-layout='vertical'] .nav-header .logo-compact {\n\tdisplay: none;\n}\n\n.header {\n\tz-index: 1;\n\tposition: relative;\n\tpadding: 0rem;\n\tbackground: var(--headerbg);\n\tz-index: 3;\n\tpadding-left: 17rem;\n\ttransition: all 0.2s ease;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tbox-sizing: border-box;\n}\n.header .is-fixed {\n\tbackground: #3736af;\n}\n.header .header-content {\n\theight: 5rem;\n\tpadding-left: 5.5rem;\n\tpadding-right: 0rem;\n\talign-items: center;\n\tdisplay: flex;\n\tleft: 16.2rem;\n\tposition: unset;\n\ttop: 0;\n\twidth: calc(100% - var(--width));\n\tmargin-left: var(--width);\n\tborder-top: none;\n\tpadding-right: 2rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.header .header-content {\n\t\tpadding-left: 5rem;\n\t\twidth: calc(100% - 0rem);\n\t\tmargin-left: 0rem;\n\t\theight: 100%;\n\t}\n}\n@media only screen and (max-width: 64rem) {\n\t.header .header-content {\n\t\tleft: 6.3rem;\n\t\twidth: calc(100% - 0rem);\n\t\theight: 5rem;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.header .header-content {\n\t\tpadding-left: 3.75rem;\n\t\tpadding-right: 0.938rem;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.header .header-content {\n\t\tleft: 0rem;\n\t\twidth: calc(100% - 0.3rem);\n\t}\n}\n.header .navbar {\n\tpadding: 0;\n\theight: 100%;\n\twidth: 100%;\n}\n.header .navbar .navbar-collapse {\n\theight: 100%;\n\twidth: 100%;\n}\n\n[data-headerbg='color_2'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-headerbg='color_3'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-headerbg='color_4'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-headerbg='color_5'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-headerbg='color_6'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-headerbg='color_7'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-headerbg='color_8'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-headerbg='color_9'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-headerbg='color_10'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-headerbg='color_11'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-headerbg='color_12'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-headerbg='color_13'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-headerbg='color_14'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-headerbg='color_15'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-nav-headbg='color_2'] .nav-header {\n\tbackground: var(--nav-headbg);\n}\n\n[data-nav-headbg='color_3'] .nav-header {\n\tbackground: var(--nav-headbg);\n}\n\n[data-nav-headbg='color_4'] .nav-header {\n\tbackground: var(--nav-headbg);\n}\n\n[data-nav-headbg='color_5'] .nav-header {\n\tbackground: var(--nav-headbg);\n}\n\n[data-nav-headbg='color_6'] .nav-header {\n\tbackground: var(--nav-headbg);\n}\n\n[data-nav-headbg='color_7'] .nav-header {\n\tbackground: var(--nav-headbg);\n}\n\n[data-nav-headbg='color_8'] .nav-header {\n\tbackground: var(--nav-headbg);\n}\n\n[data-nav-headbg='color_9'] .nav-header {\n\tbackground: var(--nav-headbg);\n}\n\n[data-nav-headbg='color_10'] .nav-header {\n\tbackground: var(--nav-headbg);\n}\n\n[data-nav-headbg='color_11'] .nav-header {\n\tbackground: var(--nav-headbg);\n}\n\n[data-nav-headbg='color_12'] .nav-header {\n\tbackground: var(--nav-headbg);\n}\n\n[data-nav-headbg='color_13'] .nav-header {\n\tbackground: var(--nav-headbg);\n}\n\n[data-nav-headbg='color_14'] .nav-header {\n\tbackground: var(--nav-headbg);\n}\n\n[data-nav-headbg='color_15'] .nav-header {\n\tbackground: var(--nav-headbg);\n}\n\n/* pulse in SVG */\nsvg.pulse-svg {\n\toverflow: visible;\n}\nsvg.pulse-svg .first-circle,\nsvg.pulse-svg .second-circle,\nsvg.pulse-svg .third-circle {\n\t-webkit-transform: scale(0.3);\n\ttransform: scale(0.3);\n\t-webkit-transform-origin: center center;\n\ttransform-origin: center center;\n\t-webkit-animation: pulse-me 3s linear infinite;\n\tanimation: pulse-me 3s linear infinite;\n\tfill: var(--primary);\n}\nsvg.pulse-svg .second-circle {\n\t-webkit-animation-delay: 1s;\n\tanimation-delay: 1s;\n}\nsvg.pulse-svg .third-circle {\n\t-webkit-animation-delay: 2s;\n\tanimation-delay: 2s;\n}\n\n/* pulse in CSS */\n.pulse-css {\n\twidth: 1rem;\n\theight: 1rem;\n\tborder-radius: 0.5rem;\n\tborder-radius: 3.5rem;\n\theight: 1.25rem;\n\tposition: absolute;\n\tbackground: #fe8630;\n\tright: 0.375rem;\n\ttop: 0.3125rem;\n\tborder: 0.25rem solid #fff;\n\twidth: 1.25rem;\n}\n.pulse-css:after,\n.pulse-css:before {\n\tcontent: '';\n\twidth: 1rem;\n\theight: 1rem;\n\tborder-radius: 0.5rem;\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tleft: -0.2rem;\n\tbackground-color: #d8b9c3;\n\tmargin: auto;\n\t-webkit-transform: scale(0.3);\n\ttransform: scale(0.3);\n\t-webkit-transform-origin: center center;\n\ttransform-origin: center center;\n\t-webkit-animation: pulse-me 3s linear infinite;\n\tanimation: pulse-me 3s linear infinite;\n}\n[direction='rtl'] .pulse-css:after,\n[direction='rtl'] .pulse-css:before {\n\tleft: auto;\n\tright: -0.2rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.pulse-css {\n\t\theight: 1rem;\n\t\twidth: 1rem;\n\t}\n}\n\n@-webkit-keyframes pulse-me {\n\t0% {\n\t\t-webkit-transform: scale(0.3);\n\t\ttransform: scale(0.3);\n\t\topacity: 0;\n\t}\n\t50% {\n\t\topacity: 0.1;\n\t}\n\t70% {\n\t\topacity: 0.09;\n\t}\n\t100% {\n\t\t-webkit-transform: scale(3);\n\t\ttransform: scale(3);\n\t\topacity: 0;\n\t}\n}\n\n@keyframes pulse-me {\n\t0% {\n\t\t-webkit-transform: scale(0.3);\n\t\ttransform: scale(0.3);\n\t\topacity: 0;\n\t}\n\t50% {\n\t\topacity: 0.1;\n\t}\n\t70% {\n\t\topacity: 0.09;\n\t}\n\t100% {\n\t\t-webkit-transform: scale(3);\n\t\ttransform: scale(3);\n\t\topacity: 0;\n\t}\n}\n\n[data-sidebar-style='full'] .header,\n[data-sidebar-style='overlay'] .header {\n\twidth: 100%;\n\tpadding-left: 0;\n\t/* .page-titles{\n\t\t\tpadding-left: 20.3rem;\n\t\t} */\n}\n@media only screen and (max-width: 87.5rem) {\n\t[data-sidebar-style='full'] .header,\n\t[data-sidebar-style='overlay'] .header {\n\t\twidth: 100%;\n\t\tpadding-left: 17rem;\n\t}\n}\n@media only screen and (max-width: 63.9375rem) {\n\t[data-sidebar-style='full'] .header,\n\t[data-sidebar-style='overlay'] .header {\n\t\twidth: 100%;\n\t\tpadding-left: 0rem;\n\t}\n}\n\n[data-sidebar-style='mini'] .header {\n\twidth: 100%;\n\theight: 5rem;\n\tpadding-left: 6.32rem;\n}\n@media only screen and (max-width: 63.9375rem) {\n\t[data-sidebar-style='mini'] .header {\n\t\tpadding-left: 6rem;\n\t}\n}\n\n[data-sidebar-style='compact'] .header {\n\twidth: 100%;\n\tpadding-left: 1.75rem;\n}\n[data-sidebar-style='compact'] .header .header-content {\n\tpadding-left: 2.5rem;\n\tleft: 1.75rem;\n\twidth: auto;\n\tmargin-left: 9.2rem;\n}\n\n[data-header-position='fixed'] .header {\n\tposition: fixed;\n\ttop: 0;\n\twidth: 100%;\n}\n\n[data-header-position='fixed'] .content-body {\n\tpadding-top: 5rem;\n}\n\n[data-header-position='fixed'] .dlabnav {\n\tmargin-top: 0;\n}\n\n[data-sidebar-style='compact'][data-header-position='fixed'][data-container='boxed'][data-layout='vertical'] .header {\n\twidth: 74.9375rem;\n}\n\n[data-sidebar-style='modern'] .header {\n\twidth: 100%;\n\tpadding-left: 0rem;\n}\n\n[data-sidebar-style='modern'][data-layout='horizontal'] .nav-header .brand-logo {\n\tjustify-content: start;\n}\n\n[data-sidebar-style='modern'][data-layout='horizontal'] .header .header-content {\n\tpadding-left: 1.875rem;\n}\n\n.header.is-fixed {\n\tposition: fixed;\n\tbackground: #e6ebee;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n\t/*     -webkit-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;\n    -khtml-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;\n    -moz-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;\n    -ms-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;\n    -o-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;\n    animation: 0.95s ease 0s normal forwards 1 running headerSlideDown; */\n}\n\n@-moz-keyframes headerSlideDown {\n\t0% {\n\t\tmargin-top: -150px;\n\t}\n\t100% {\n\t\tmargin-top: 0;\n\t}\n}\n\n@-ms-keyframes headerSlideDown {\n\t0% {\n\t\tmargin-top: -150px;\n\t}\n\t100% {\n\t\tmargin-top: 0;\n\t}\n}\n\n@-webkit-keyframes headerSlideDown {\n\t0% {\n\t\tmargin-top: -150px;\n\t}\n\t100% {\n\t\tmargin-top: 0;\n\t}\n}\n\n@keyframes headerSlideDown {\n\t0% {\n\t\tmargin-top: -150px;\n\t}\n\t100% {\n\t\tmargin-top: 0;\n\t}\n}\n\n.sidebar-info h4,\n.sidebar-info .h4 {\n\tfont-size: 0.875rem;\n\tfont-weight: 700;\n\twhite-space: nowrap;\n}\n\n.header-left {\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n}\n.header-left .search-area {\n\twidth: 25rem;\n\tflex-direction: row-reverse;\n\tborder: 1px solid #dddddd;\n\toverflow: hidden;\n\tborder-radius: 0.375rem;\n\tbox-sizing: border-box;\n\theight: 3rem;\n}\n@media only screen and (max-width: 117.5rem) {\n\t.header-left .search-area {\n\t\twidth: 22rem;\n\t}\n}\n@media only screen and (max-width: 81.25rem) {\n\t.header-left .search-area {\n\t\twidth: 17.5rem;\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.header-left .search-area {\n\t\twidth: 15.625rem;\n\t}\n}\n@media only screen and (max-width: 68.75rem) {\n\t.header-left .search-area {\n\t\tdisplay: none;\n\t}\n}\n.header-left .search-area .form-control {\n\tfont-size: 15px;\n\tborder-right: 0;\n\tborder: none;\n\tpadding: 0rem;\n\tborder-radius: 0 0.375rem 0.375rem 0;\n\tpadding-left: 0.2rem;\n\theight: 3rem;\n}\n.header-left .search-area .form-control:focus {\n\tborder-color: white;\n\tbox-shadow: none;\n}\n.header-left .search-area .input-group-text {\n\tbackground: #fff !important;\n\tborder: none;\n\tpadding-right: 0;\n\theight: 3rem;\n\tborder-radius: 0.375rem 0 0 0.375rem;\n}\n.header-left .search-area .input-group-text svg {\n\ttransform: scale(1.2);\n}\n.header-left .search-area .input-group-text svg path {\n\tfill: var(--primary);\n}\n.header-left .breadcrumb {\n\tmargin-bottom: 0;\n}\n.header-left .agenda a {\n\tborder-radius: 1.75rem;\n}\n.header-left .agenda a i {\n\tmargin-right: 0.75rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.header-left .agenda a i {\n\t\tmargin-right: 0rem;\n\t}\n}\n@media only screen and (max-width: 93.75rem) {\n\t.header-left .agenda a {\n\t\tfont-size: 0;\n\t\tborder-radius: 0.75rem;\n\t\tpadding: 0.8125rem 0.9375rem;\n\t}\n\t.header-left .agenda a i {\n\t\tfont-size: 1.25rem;\n\t\tmargin-right: 0;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.header-left .agenda {\n\t\tdisplay: none;\n\t}\n}\n.header-left .dashboard_bar {\n\tfont-size: 1.563rem;\n\tfont-weight: 600;\n\tcolor: #303972;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.header-left .dashboard_bar {\n\t\tdisplay: none;\n\t}\n}\n.header-left .dashboard_bar.sub-bar {\n\tfont-size: 1.875rem;\n}\n\n[data-sidebar-style='compact'] .header-left {\n\tmargin-left: 0;\n}\n\n.nav-item.notification_dropdown a.nav-link {\n\tposition: relative;\n\t/* &::before{\n\t\t\tcontent: '';\n\t\t\tdisplay: block;\n\t\t\tbackground-color: $pink;\n\t\t\twidth: 0.5rem;\n\t\t\theight: 0.5rem;\n\t\t\tborder-radius: 50%;\n\t\t\tposition: absolute;\n\t\t\ttop: -2px;\n\t\t\tright: 0;\n\t\t\t\n\t\t}\n\t\t */\n}\n\n.nav-item.notification_dropdown .nav-link.menu-wallet::before {\n\tcontent: '';\n\tdisplay: none;\n}\n\n.modal .modal-content input.form-control {\n\tborder-top-right-radius: 0.375rem !important;\n\tborder-bottom-right-radius: 0.375rem !important;\n}\n\n.header-right {\n\theight: 100%;\n\talign-items: center;\n}\n.header-right .nav-item {\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n}\n.header-right .nav-item .nav-link {\n\tcolor: #464a53;\n}\n.header-right .right-sidebar {\n\tmargin-right: -1.875rem;\n}\n.header-right .right-sidebar a {\n\theight: 5rem;\n\twidth: 5rem;\n\ttext-align: center;\n\tjustify-content: center;\n\tdisplay: flex;\n\talign-items: center;\n\tborder-left: 0.0625rem solid #ebebf9;\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.header-right > li:not(:first-child) {\n\t\tpadding-left: 0rem;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.header-right > li:not(:first-child) {\n\t\tpadding-left: 0;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.header-right .notification_dropdown {\n\t\tposition: static;\n\t}\n}\n.header-right .notification_dropdown .nav-link {\n\tposition: relative;\n\tcolor: var(--primary);\n\tborder-radius: 0.375rem;\n\tbackground-color: #ffffff;\n\twidth: 3rem;\n\tmin-width: 3rem;\n\theight: 3rem;\n\tline-height: 1;\n\tmargin-right: 1.125rem;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n@media only screen and (max-width: 112rem) {\n\t.header-right .notification_dropdown .nav-link {\n\t\tmargin-right: 0.625rem;\n\t}\n}\n@media only screen and (max-width: 87.5rem) {\n\t.header-right .notification_dropdown .nav-link {\n\t\tpadding: 0.625rem;\n\t\tmargin-right: 0.625rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.header-right .notification_dropdown .nav-link {\n\t\tpadding: 0.325rem;\n\t\tmargin-right: 0.5rem !important;\n\t\twidth: 2.3rem;\n\t\theight: 2.3rem;\n\t\tmin-width: 2.3rem;\n\t}\n}\n.header-right .notification_dropdown .nav-link i {\n\tfont-size: 1.5rem;\n\tcolor: #666666;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.header-right .notification_dropdown .nav-link i {\n\t\tfont-size: 1.125rem;\n\t}\n}\n@media only screen and (max-width: 87.5rem) {\n\t.header-right .notification_dropdown .nav-link svg {\n\t\twidth: 1.75rem;\n\t\theight: 1.75rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.header-right .notification_dropdown .nav-link svg {\n\t\twidth: 1.3rem;\n\t\theight: 1.3rem;\n\t}\n}\n.header-right .notification_dropdown .nav-link.bell-link svg path {\n\tstroke: #a098ae;\n}\n.header-right .notification_dropdown .nav-link.dz-fullscreen svg path {\n\tstroke: #a098ae;\n}\n.header-right .notification_dropdown .nav-link.dz-theme-mode svg path {\n\tstroke: #a098ae;\n}\n.header-right .notification_dropdown .nav-link #icon-light,\n.header-right .notification_dropdown .nav-link #icon-dark,\n.header-right .notification_dropdown .nav-link #icon-light-1,\n.header-right .notification_dropdown .nav-link #icon-dark-1 {\n\tcolor: #a098ae;\n}\n.header-right .notification_dropdown .nav-link.menu-wallet svg path {\n\tfill: #a098ae;\n}\n.header-right .notification_dropdown .nav-link .badge {\n\tposition: absolute;\n\tfont-size: 0.625rem;\n\tborder-radius: 50%;\n\tright: 5px;\n\ttop: 0px;\n\tfont-weight: normal;\n\theight: 25px;\n\twidth: 25px;\n\tline-height: 16px;\n\ttext-align: center;\n\tpadding: 4px;\n\tfont-size: 11px;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.header-right .notification_dropdown .nav-link .badge {\n\t\theight: 1.25rem;\n\t\twidth: 1.25rem;\n\t\tborder-width: 0.125rem;\n\t\tline-height: 0.4375rem;\n\t\tfont-size: 0.5625rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.header-right .notification_dropdown .nav-link .badge {\n\t\theight: 1.125rem;\n\t\twidth: 1.125rem;\n\t\tpadding: 0;\n\t\tline-height: 0.9375rem;\n\t\tright: 0rem;\n\t\ttop: -0.125rem;\n\t}\n}\n.header-right .notification_dropdown .dropdown-item:focus a,\n.header-right .notification_dropdown .dropdown-item:active a {\n\tcolor: #fff;\n}\n.header-right .notification_dropdown .dropdown-item a {\n\tcolor: #303972;\n}\n.header-right .notification_dropdown .dropdown-item a:hover {\n\ttext-decoration: none;\n}\n.header-right .dropdown-menu {\n\tborder-width: 0;\n\tbox-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n\tmargin: 0;\n\twidth: 14.188rem;\n\tmargin: 0;\n\tborder-radius: 0px 0px 5px 5px;\n\tmargin-top: -8px;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.header-right .dropdown-menu {\n\t\twidth: 11.875rem;\n\t}\n\t.header-right .dropdown-menu h4,\n\t.header-right .dropdown-menu .h4 {\n\t\tfont-size: 14px;\n\t}\n\t.header-right .dropdown-menu span {\n\t\tfont-size: 11px;\n\t}\n}\n[data-theme-version='dark'] .header-right .dropdown-menu {\n\tbox-shadow: none;\n}\n.header-right .dropdown-menu.dropdown-menu-end .card-footer {\n\tborder-radius: 0;\n}\n.header-right .dropdown-menu.dropdown-menu-end .dropdown-item:hover {\n\tborder-radius: 6px;\n}\n.header-right .dropdown-menu.dropdown-menu-end .light.btn-primary:hover span {\n\tcolor: #fff !important;\n}\n.header-right .dropdown-menu.dropdown-menu-end .light.btn-primary:hover svg {\n\tstroke: #fff;\n}\n.header-right .search-area {\n\twidth: 21.875rem;\n\tflex-direction: row-reverse;\n\toverflow: hidden;\n\tborder-radius: 0.375rem;\n\tbox-sizing: border-box;\n\theight: 3rem;\n\tborder: 1px solid #eeeeee !important;\n}\n@media only screen and (max-width: 117.5rem) {\n\t.header-right .search-area {\n\t\twidth: 22rem;\n\t}\n}\n@media only screen and (max-width: 81.25rem) {\n\t.header-right .search-area {\n\t\twidth: 17.5rem;\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.header-right .search-area {\n\t\twidth: 15.625rem;\n\t}\n}\n.header-right .search-area .form-control {\n\tfont-size: 15px;\n\tborder-right: 0;\n\tborder: none;\n\tpadding: 0rem;\n\tborder-radius: 0 0.375rem 0.375rem 0;\n\tpadding-left: 0.2rem;\n\theight: 3rem;\n}\n.header-right .search-area .form-control:focus {\n\tborder-color: white;\n\tbox-shadow: none;\n}\n.header-right .search-area .input-group-text {\n\tbackground: #fff;\n\tborder: none;\n\tpadding-right: 20px;\n\theight: 3rem;\n\tborder-radius: 0.375rem 0 0 0.375rem;\n}\n.header-right .search-area .input-group-text svg {\n\ttransform: scale(1.2);\n}\n.header-right .search-area .input-group-text svg path {\n\tfill: var(--primary);\n}\n\n.dlab-fullscreen #icon-minimize {\n\tdisplay: none;\n}\n\n.dlab-fullscreen.active #icon-full {\n\tdisplay: none;\n}\n\n.dlab-fullscreen.active #icon-minimize {\n\tdisplay: inline-block;\n}\n\n.dlab-fullscreen #icon-minimize {\n\tdisplay: none;\n}\n\n.dlab-fullscreen.active #icon-full-1 {\n\tdisplay: none;\n}\n\n.dlab-fullscreen.active #icon-minimize-1 {\n\tdisplay: inline-block;\n}\n\n/* .notification_dropdown {\n    .dropdown-menu-end {\n        min-width: 19.375rem;\n        padding: 1rem 0 1rem;\n        top: 100%;\n\t\t\n        .notification_title {\n            background: var(--primary);\n            color: $white;\n            padding: 0.625rem 1.25rem;\n            h5 {\n                color: $white;\n                margin-bottom: 0.1875rem;\n            }\n        }\n        .media {\n\t\t\twidth: 2.8125rem ;\n\t\t\theight: 2.8125rem ;\n\t\t\tfont-size: 1.125rem ;\n\t\t\t\n            // &:last-child{\n            //     border-bottom: 0rem;\n            // }\n            @at-root [data-theme-version=\"dark\"] & {\n                border-color: $d-border;\n            }\n            &>span {\n                width: 2.1875rem;\n                height: 2.1875rem;\n                border-radius: 3.125rem;\n                display: inline-block;\n                padding: 0.4375rem 0.5625rem;\n                margin-right: 0.625rem;\n\t\t\t\t@at-root [direction=\"rtl\"] {\n\t\t\t\t\t margin-right: 0;\n\t\t\t\t\t margin-left: 0.625rem\n\t\t\t\t}\n                &.success {\n                    background: $success-light;\n                    color: $success;\n                }\n                &.primary {\n                    background: var(--rgba-primary-1);\n                    color: var(--primary);\n                }\n                &.danger {\n                    background: $danger-light;\n                    color: $danger;\n                }\n            }\n            .notify-time {\n                width: 100%;\n                margin-right: 0;\n                color: $l-ctl;\n            }\n            p {\n                text-overflow: ellipsis;\n                overflow: hidden;\n                white-space: nowrap;\n                max-width: 12.5rem;\n                margin-bottom: 0;\n                margin-top: 0.3125rem;\n\t\t\t\t@include respond('phone') {\n\t\t\t\t    max-width: 6.25rem;\n\t\t\t\t}\n            }\n        }\n        .all-notification {\n            display: block;\n            padding: 0.9375rem 1.875rem 0;\n    }\n\t            // color: $dark;\n            text-align: center;\n\t\t\tborder-top: 0.0625rem solid $b-color;\n\t\t\t\t\n            i {\n                margin-left: 0.625rem;\n            }\n        }\n\n} */\n.notification_dropdown .dropdown-menu-end {\n\tmin-width: 19.375rem;\n\tpadding: 1rem 0 1rem;\n\ttop: 100%;\n}\n.notification_dropdown .dropdown-menu-end.show {\n\tright: 0;\n\toverflow: unset !important;\n}\n.notification_dropdown .dropdown-menu-end .notification_title {\n\tbackground: var(--primary);\n\tcolor: #fff;\n\tpadding: 0.625rem 1.25rem;\n}\n.notification_dropdown .dropdown-menu-end .notification_title h5,\n.notification_dropdown .dropdown-menu-end .notification_title .h5 {\n\tcolor: #fff;\n\tmargin-bottom: 0.1875rem;\n}\n.notification_dropdown .dropdown-menu-end .media {\n\twidth: 2.8125rem;\n\theight: 2.8125rem;\n\tfont-size: 1.125rem;\n}\n[data-theme-version='dark'] .notification_dropdown .dropdown-menu-end .media {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n.notification_dropdown .dropdown-menu-end .media > span {\n\twidth: 2.1875rem;\n\theight: 2.1875rem;\n\tborder-radius: 3.125rem;\n\tdisplay: inline-block;\n\tpadding: 0.4375rem 0.5625rem;\n\tmargin-right: 0.625rem;\n}\n[direction='rtl'].notification_dropdown .dropdown-menu-end .media > span {\n\tmargin-right: 0;\n\tmargin-left: 0.625rem;\n}\n.notification_dropdown .dropdown-menu-end .media > span.success {\n\tbackground: #ddfaea;\n\tcolor: #1eba62;\n}\n.notification_dropdown .dropdown-menu-end .media > span.primary {\n\tbackground: var(--rgba-primary-1);\n\tcolor: var(--primary);\n}\n.notification_dropdown .dropdown-menu-end .media > span.danger {\n\tbackground: #ffeaea;\n\tcolor: #fd5353;\n}\n.notification_dropdown .dropdown-menu-end .media .notify-time {\n\twidth: 100%;\n\tmargin-right: 0;\n\tcolor: #828690;\n}\n.notification_dropdown .dropdown-menu-end .media p {\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\tmax-width: 12.5rem;\n\tmargin-bottom: 0;\n\tmargin-top: 0.3125rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.notification_dropdown .dropdown-menu-end .media p {\n\t\tmax-width: 6.25rem;\n\t}\n}\n.notification_dropdown .dropdown-menu-end .all-notification {\n\tdisplay: block;\n\tpadding: 0.9375rem 1.875rem 0;\n\tcolor: var(--primary);\n\ttext-align: center;\n\tborder-top: 0.0625rem solid #f1f1f1;\n\tfont-size: 0.813rem;\n}\n.notification_dropdown .dropdown-menu-end .all-notification i {\n\tmargin-left: 0.625rem;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.notification_dropdown .dropdown-menu-end {\n\t\tright: 0;\n\t\theight: 27rem;\n\t\ttop: 45px;\n\t\ttransform: translateX(0);\n\t\tpadding-right: 0;\n\t\twidth: 18rem;\n\t\tdisplay: none !important;\n\t\tborder-radius: 0.375rem;\n\t}\n\t.notification_dropdown .dropdown-menu-end.show {\n\t\tdisplay: block !important;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.notification_dropdown .dropdown-menu-end {\n\t\tmin-width: 18.5rem;\n\t\tright: -4rem;\n\t\ttop: 62px;\n\t}\n}\n\n.notification_dropdown .attc {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tborder: 1px solid #f1f1f1;\n\tborder-radius: 0.375rem;\n\tpadding: 0.313rem 0.625rem;\n}\n.notification_dropdown .attc .media {\n\tborder-radius: 6px;\n\tborder: 1px solid #eee;\n}\n.notification_dropdown .attc .media-body h6,\n.notification_dropdown .attc .media-body .h6 {\n\tfont-size: 0.813rem;\n\tline-height: 1rem;\n\tmargin-bottom: 0;\n}\n.notification_dropdown .attc .media-body span {\n\tborder: 1px solid #e6e6e6;\n\tfont-size: 0.75rem;\n}\n\n.header-profile > a.nav-link {\n\tpadding: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-left: 0.9375rem;\n}\n.header-profile > a.nav-link i {\n\tfont-weight: 700;\n}\n.header-profile > a.nav-link .header-info {\n\tpadding-left: 0rem;\n\ttext-align: left;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.header-profile > a.nav-link .header-info {\n\t\tpadding-left: 0.625rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.header-profile > a.nav-link .header-info {\n\t\tdisplay: none;\n\t}\n}\n.header-profile > a.nav-link .header-info span {\n\tfont-size: 1rem;\n\tcolor: #000;\n\tdisplay: block;\n\tfont-weight: 600;\n}\n.header-profile > a.nav-link .header-info strong {\n\tcolor: #303972;\n}\n.header-profile > a.nav-link .header-info small,\n.header-profile > a.nav-link .header-info .small {\n\tdisplay: block;\n\tfont-size: 0.8125rem;\n\tcolor: #89879f;\n\tfont-weight: 400;\n\tline-height: 1.2;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.header-profile > a.nav-link {\n\t\tmargin-left: 0rem;\n\t\tpadding-left: 0rem;\n\t}\n\t.header-profile > a.nav-link .header-info span {\n\t\tfont-size: 1rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.header-profile > a.nav-link {\n\t\tmargin-left: 0rem;\n\t\tpadding-left: 0rem;\n\t\tborder-left: 0;\n\t}\n}\n\n.header-profile .dropdown-menu {\n\tpadding: 0.9375rem 0;\n\tmin-width: 12.5rem;\n}\n.header-profile .dropdown-menu a:hover,\n.header-profile .dropdown-menu a:focus,\n.header-profile .dropdown-menu a.active {\n\tcolor: var(--primary);\n}\n\n.header-profile img {\n\twidth: 3.5rem;\n\theight: 3.5rem;\n\tborder-radius: 0.375rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.header-profile img {\n\t\twidth: 2.4375rem;\n\t\theight: 2.4375rem;\n\t}\n}\n\n.header-profile .dropdown-toggle i {\n\tfont-size: 1.25rem;\n}\n\n@media only screen and (max-width: 35.9375rem) {\n\t.header-profile .dropdown-toggle span {\n\t\tdisplay: none;\n\t}\n}\n\n.header-profile .profile_title {\n\tbackground: #4d44b5;\n\tcolor: #fff;\n\tpadding: 0.625rem 1.25rem;\n}\n.header-profile .profile_title h5,\n.header-profile .profile_title .h5 {\n\tcolor: #fff;\n\tmargin-bottom: 0.1875rem;\n}\n\n.header-profile .dropdown-item {\n\tpadding: 0.5rem 1.5rem;\n}\n\n.dropdown.header-profile2 .nav-link {\n\tmargin-left: 1rem;\n\tpadding-right: 0;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.dropdown.header-profile2 .nav-link {\n\t\tmargin-left: 0rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.dropdown.header-profile2 .nav-link {\n\t\tpadding-left: 0;\n\t}\n}\n\n@keyframes icon-bounce {\n\t100%,\n\t0% {\n\t\ttransform: translateY(0);\n\t}\n\t50% {\n\t\ttransform: translateY(-5px);\n\t}\n\t80% {\n\t\ttransform: translateY(5px);\n\t}\n}\n\n.dz-theme-mode #icon-light {\n\tdisplay: none;\n}\n\n.dz-theme-mode.active #icon-light {\n\tdisplay: inline-block;\n}\n\n.dz-theme-mode.active #icon-dark {\n\tdisplay: none;\n}\n\n.dz-fullscreen #icon-minimize {\n\tdisplay: none;\n}\n\n.dz-fullscreen.active #icon-minimize {\n\tdisplay: inline-block;\n}\n\n.dz-fullscreen.active #icon-full {\n\tdisplay: none;\n}\n\n.dz-theme-mode #icon-light-1 {\n\tdisplay: none;\n}\n\n.dz-theme-mode.active #icon-light-1 {\n\tdisplay: inline-block;\n}\n\n.dz-theme-mode.active #icon-dark-1 {\n\tdisplay: none;\n}\n\n.dz-fullscreen #icon-minimize-1 {\n\tdisplay: none;\n}\n\n.dz-fullscreen.active #icon-minimize-1 {\n\tdisplay: inline-block;\n}\n\n.dz-fullscreen.active #icon-full-1 {\n\tdisplay: none;\n}\n\n:root {\n\t--width: 18.5rem;\n}\n:root [data-sidebar-style='mini'] {\n\t--width: 6.25rem;\n}\n\n.nav-label {\n\tmargin: 0.625rem 1.875rem 0;\n\tpadding: 1.5625rem 0 0.625rem;\n\ttext-transform: uppercase;\n\tfont-size: 0.75rem;\n\tletter-spacing: 0.05rem;\n\tborder-top: 0.0625rem solid #eaeaea;\n\tcolor: #999999;\n}\n[data-theme-version='dark'] .nav-label {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n.nav-label.first {\n\tborder: 0rem;\n\tmargin-top: 0rem;\n}\n\n.nav-badge {\n\tposition: absolute;\n\tright: 2.8125rem;\n\ttop: 0.625rem;\n}\n\n.dlabnav .ps__rail-y {\n\tleft: 0;\n\twidth: 5px;\n}\n\n.content-body {\n\tmargin-left: var(--width);\n\tz-index: 0;\n\ttransition: all 0.2s ease;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.content-body {\n\t\tmargin-left: 17rem;\n\t}\n}\n\n.bell img {\n\t-webkit-animation: ring 8s 0.7s ease-in-out infinite;\n\t-webkit-transform-origin: 50% 0.25rem;\n\t-moz-animation: ring 8s 0.7s ease-in-out infinite;\n\t-moz-transform-origin: 50% 0.25rem;\n\tanimation: ring 8s 0.7s ease-in-out infinite;\n}\n\n@-webkit-keyframes ring {\n\t0% {\n\t\t-webkit-transform: rotateZ(0);\n\t}\n\t1% {\n\t\t-webkit-transform: rotateZ(30deg);\n\t}\n\t3% {\n\t\t-webkit-transform: rotateZ(-28deg);\n\t}\n\t5% {\n\t\t-webkit-transform: rotateZ(34deg);\n\t}\n\t7% {\n\t\t-webkit-transform: rotateZ(-32deg);\n\t}\n\t9% {\n\t\t-webkit-transform: rotateZ(30deg);\n\t}\n\t11% {\n\t\t-webkit-transform: rotateZ(-28deg);\n\t}\n\t13% {\n\t\t-webkit-transform: rotateZ(26deg);\n\t}\n\t15% {\n\t\t-webkit-transform: rotateZ(-24deg);\n\t}\n\t17% {\n\t\t-webkit-transform: rotateZ(22deg);\n\t}\n\t19% {\n\t\t-webkit-transform: rotateZ(-20deg);\n\t}\n\t21% {\n\t\t-webkit-transform: rotateZ(18deg);\n\t}\n\t23% {\n\t\t-webkit-transform: rotateZ(-16deg);\n\t}\n\t25% {\n\t\t-webkit-transform: rotateZ(14deg);\n\t}\n\t27% {\n\t\t-webkit-transform: rotateZ(-12deg);\n\t}\n\t29% {\n\t\t-webkit-transform: rotateZ(10deg);\n\t}\n\t31% {\n\t\t-webkit-transform: rotateZ(-8deg);\n\t}\n\t33% {\n\t\t-webkit-transform: rotateZ(6deg);\n\t}\n\t35% {\n\t\t-webkit-transform: rotateZ(-4deg);\n\t}\n\t37% {\n\t\t-webkit-transform: rotateZ(2deg);\n\t}\n\t39% {\n\t\t-webkit-transform: rotateZ(-1deg);\n\t}\n\t41% {\n\t\t-webkit-transform: rotateZ(1deg);\n\t}\n\t43% {\n\t\t-webkit-transform: rotateZ(0);\n\t}\n\t100% {\n\t\t-webkit-transform: rotateZ(0);\n\t}\n}\n\n@-moz-keyframes ring {\n\t0% {\n\t\t-moz-transform: rotate(0);\n\t}\n\t1% {\n\t\t-moz-transform: rotate(30deg);\n\t}\n\t3% {\n\t\t-moz-transform: rotate(-28deg);\n\t}\n\t5% {\n\t\t-moz-transform: rotate(34deg);\n\t}\n\t7% {\n\t\t-moz-transform: rotate(-32deg);\n\t}\n\t9% {\n\t\t-moz-transform: rotate(30deg);\n\t}\n\t11% {\n\t\t-moz-transform: rotate(-28deg);\n\t}\n\t13% {\n\t\t-moz-transform: rotate(26deg);\n\t}\n\t15% {\n\t\t-moz-transform: rotate(-24deg);\n\t}\n\t17% {\n\t\t-moz-transform: rotate(22deg);\n\t}\n\t19% {\n\t\t-moz-transform: rotate(-20deg);\n\t}\n\t21% {\n\t\t-moz-transform: rotate(18deg);\n\t}\n\t23% {\n\t\t-moz-transform: rotate(-16deg);\n\t}\n\t25% {\n\t\t-moz-transform: rotate(14deg);\n\t}\n\t27% {\n\t\t-moz-transform: rotate(-12deg);\n\t}\n\t29% {\n\t\t-moz-transform: rotate(10deg);\n\t}\n\t31% {\n\t\t-moz-transform: rotate(-8deg);\n\t}\n\t33% {\n\t\t-moz-transform: rotate(6deg);\n\t}\n\t35% {\n\t\t-moz-transform: rotate(-4deg);\n\t}\n\t37% {\n\t\t-moz-transform: rotate(2deg);\n\t}\n\t39% {\n\t\t-moz-transform: rotate(-1deg);\n\t}\n\t41% {\n\t\t-moz-transform: rotate(1deg);\n\t}\n\t43% {\n\t\t-moz-transform: rotate(0);\n\t}\n\t100% {\n\t\t-moz-transform: rotate(0);\n\t}\n}\n\n@keyframes ring {\n\t0% {\n\t\ttransform: rotate(0);\n\t}\n\t1% {\n\t\ttransform: rotate(30deg);\n\t}\n\t3% {\n\t\ttransform: rotate(-28deg);\n\t}\n\t5% {\n\t\ttransform: rotate(34deg);\n\t}\n\t7% {\n\t\ttransform: rotate(-32deg);\n\t}\n\t9% {\n\t\ttransform: rotate(30deg);\n\t}\n\t11% {\n\t\ttransform: rotate(-28deg);\n\t}\n\t13% {\n\t\ttransform: rotate(26deg);\n\t}\n\t15% {\n\t\ttransform: rotate(-24deg);\n\t}\n\t17% {\n\t\ttransform: rotate(22deg);\n\t}\n\t19% {\n\t\ttransform: rotate(-20deg);\n\t}\n\t21% {\n\t\ttransform: rotate(18deg);\n\t}\n\t23% {\n\t\ttransform: rotate(-16deg);\n\t}\n\t25% {\n\t\ttransform: rotate(14deg);\n\t}\n\t27% {\n\t\ttransform: rotate(-12deg);\n\t}\n\t29% {\n\t\ttransform: rotate(10deg);\n\t}\n\t31% {\n\t\ttransform: rotate(-8deg);\n\t}\n\t33% {\n\t\ttransform: rotate(6deg);\n\t}\n\t35% {\n\t\ttransform: rotate(-4deg);\n\t}\n\t37% {\n\t\ttransform: rotate(2deg);\n\t}\n\t39% {\n\t\ttransform: rotate(-1deg);\n\t}\n\t41% {\n\t\ttransform: rotate(1deg);\n\t}\n\t43% {\n\t\ttransform: rotate(0);\n\t}\n\t100% {\n\t\ttransform: rotate(0);\n\t}\n}\n\n.dlabnav {\n\twidth: var(--width);\n\tpadding-bottom: 0;\n\theight: calc(100% - 4.5rem);\n\tposition: absolute;\n\ttop: 5rem;\n\tpadding-top: 0;\n\tz-index: 6;\n\tbackground-color: var(--sidebar-bg);\n\tborder-top: none;\n\ttransition: all 0.2s ease;\n\tbox-shadow: 0rem 0.9375rem 1.875rem 0rem rgba(0, 0, 0, 0.02);\n}\n@media only screen and (max-width: 100rem) {\n\t.dlabnav {\n\t\ttop: 4.9rem;\n\t}\n}\n@media only screen and (max-width: 87.5rem) {\n\t.dlabnav {\n\t\theight: calc(100% - 64.7px);\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.dlabnav {\n\t\theight: calc(100% - 70px);\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.dlabnav {\n\t\twidth: 18rem;\n\t}\n}\n.dlabnav .menu-scroll {\n\theight: 55.4rem;\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.dlabnav .menu-scroll {\n\t\theight: 57.4rem;\n\t}\n}\n.dlabnav .dlabnav-scroll {\n\tposition: relative;\n\theight: 100%;\n\toverflow-y: scroll;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.dlabnav {\n\t\twidth: 17rem;\n\t}\n}\n.dlabnav ul {\n\tpadding: 0;\n\tmargin: 0;\n\tlist-style: none;\n}\n.dlabnav .metismenu {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 0.5rem 0;\n}\n.dlabnav .metismenu.fixed {\n\tposition: fixed;\n\ttop: 0;\n\twidth: 100%;\n\tleft: 0;\n}\n.dlabnav .metismenu > li {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin: 5px 0;\n}\n.dlabnav .metismenu > li a > i {\n\tfont-size: 1.3rem;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tposition: relative;\n\ttop: 0;\n\theight: auto;\n\twidth: auto;\n\ttext-align: center;\n\tmargin-right: 0.75rem;\n\tborder-radius: 0.125rem;\n\tline-height: 1;\n}\n[data-sidebar-style='compact'] .dlabnav .metismenu > li a > i {\n\tdisplay: block;\n\tpadding: 0;\n\tbackground: rgba(0, 0, 0, 0.05);\n\t/* background:rgba($light,0.2); */\n\tcolor: rgba(0, 0, 0, 0.3);\n\twidth: 3.25rem;\n\theight: 3.25rem;\n\tborder-radius: 0.375rem;\n\tline-height: 3.25rem;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tmargin-bottom: 0.3125rem;\n}\n[data-sidebar-style='compact'] .dlabnav .metismenu > li a > i[data-theme-version='dark'] {\n\tcolor: #fff;\n}\n@media only screen and (max-width: 84.375rem) {\n\t.dlabnav .metismenu > li a > i {\n\t\theight: auto;\n\t\tline-height: 0.0625rem;\n\t\twidth: auto;\n\t\tfont-size: 1.5rem;\n\t\tpadding: 0;\n\t\tcolor: #969ba0;\n\t}\n}\n.dlabnav .metismenu > li > a {\n\tfont-weight: 500;\n\tdisplay: inline-block;\n\tfont-size: 0.875rem;\n\tcolor: #a098ae;\n}\n.dlabnav .metismenu > li > a svg {\n\tmax-width: 1.5rem;\n\tmax-height: 1.5rem;\n\theight: 100%;\n\tmargin-right: 0.625rem;\n\tmargin-top: -0.1875rem;\n\tcolor: var(--primary);\n}\n.dlabnav .metismenu > li > a i {\n\tfont-family: 'Material Icons';\n\tfont-style: normal;\n\t-webkit-font-feature-settings: 'liga';\n\t-webkit-font-smoothing: antialiased;\n\tfont-weight: normal;\n}\n.dlabnav .metismenu > li > a g [fill] {\n\tfill: #8088a1;\n}\n.dlabnav .metismenu > li:hover > a,\n.dlabnav .metismenu > li:focus > a {\n\t/*  background-color: lighten($color: $primary, $amount: 40%); */\n\tcolor: var(--primary);\n}\n.dlabnav .metismenu > li:hover > a g [fill],\n.dlabnav .metismenu > li:focus > a g [fill] {\n\tfill: var(--primary);\n}\n.dlabnav .metismenu > li:hover > a::after,\n.dlabnav .metismenu > li:focus > a::after {\n\tborder-top: 0.2125rem solid var(--primary);\n\tborder-left: 0.2125rem solid var(--primary);\n}\n.dlabnav .metismenu > li.mm-active > a {\n\tcolor: #fff;\n\tbackground: var(--primary);\n\tfont-weight: 600;\n\tbox-shadow: none;\n}\n.dlabnav .metismenu > li.mm-active > a i {\n\tfont-weight: 900;\n}\n.dlabnav .metismenu > li.mm-active > a svg path {\n\tfill: #fff;\n\tstroke: #fff;\n}\n.dlabnav .metismenu > li.mm-active > a g [fill] {\n\tfill: var(--primary);\n}\n.dlabnav .metismenu > li.mm-active > a:after {\n\tborder-top: 0.2125rem solid var(--primary);\n\tborder-left: 0.2125rem solid var(--primary);\n}\n[data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a i {\n\tbackground: var(--primary);\n\tcolor: #fff;\n}\n.dlabnav .metismenu li {\n\tposition: relative;\n}\n.dlabnav .metismenu ul {\n\ttransition: all 0.2s ease-in-out;\n\tposition: relative;\n\tz-index: 1;\n\tpadding: 0.5rem 0;\n}\n.dlabnav .metismenu ul a {\n\tpadding-top: 0.5rem;\n\tpadding-bottom: 0.5rem;\n\tposition: relative;\n\tfont-size: 0.875rem;\n\tpadding-left: 3.8rem;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n\t/* @at-root [data-sidebar-style=\"full\"] & {\n\t\t\t\t\t&:before{\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\theight: 0.125rem;\n\t\t\t\t\t\twidth: 0.375rem;\n\t\t\t\t\t\tbackground: var(--rgba-primary-5);\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tleft: 2.5rem;\n\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t\t@include transitionMedium;\n\t\t\t\t\t}\n\t\t\t\t\t&:hover{\n\t\t\t\t\t\tpadding-left:5.5rem;\n\t\t\t\t\t\t@include custommq($max:78.125rem){\n\t\t\t\t\t\t\tpadding-left:4.5rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\twidth:1.25rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t} */\n}\n@media only screen and (max-width: 84.375rem) {\n\t.dlabnav .metismenu ul a {\n\t\tpadding-left: 3.6rem;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.dlabnav .metismenu ul a {\n\t\tpadding-left: 3.5rem;\n\t\tfont-size: 0.875rem;\n\t}\n}\n.dlabnav .metismenu ul a:hover,\n.dlabnav .metismenu ul a:focus,\n.dlabnav .metismenu ul a.mm-active {\n\ttext-decoration: none;\n\tcolor: var(--primary);\n}\n.dlabnav .metismenu ul a:before {\n\tposition: absolute;\n\tcontent: none;\n\theight: 0.125rem;\n\twidth: 0.5rem;\n\ttop: 50%;\n\tleft: 1.75rem;\n\tborder-radius: 3.75rem;\n\ttransform: translateY(-50%);\n}\n@media only screen and (max-width: 84.375rem) {\n\t.dlabnav .metismenu ul a:before {\n\t\tleft: 2.8125rem;\n\t}\n}\n.dlabnav .metismenu a {\n\tposition: relative;\n\tdisplay: block;\n\tpadding: 0.7375rem 1.2rem;\n\toutline-width: 0;\n\tcolor: #373a54;\n\ttext-decoration: none;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.dlabnav .metismenu a {\n\t\tpadding: 0.625rem 1.25rem;\n\t}\n}\n.dlabnav .metismenu a:hover svg path {\n\tfill: var(--primary);\n\tstroke: var(--primary);\n}\n.dlabnav .metismenu a:hover i {\n\tcolor: var(--primary);\n}\n.dlabnav .metismenu .has-arrow:after {\n\t/* width:  .5rem;\n                height: .5rem;\n                border-color: inherit; */\n\tborder-top: 0.2125rem solid #c8c8c8;\n\tborder-left: 0.2125rem solid #c8c8c8;\n\tborder-bottom: 0.2125rem solid transparent;\n\tborder-right: 0.2125rem solid transparent;\n\tright: 1.875rem;\n\ttop: 48%;\n\t-webkit-transform: rotate(-225deg) translateY(-50%);\n\ttransform: rotate(-225deg) translateY(-50%);\n}\n.dlabnav .metismenu .has-arrow[aria-expanded='true']:after,\n.dlabnav .metismenu .mm-active > .has-arrow:after {\n\t-webkit-transform: rotate(-135deg) translateY(-50%);\n\ttransform: rotate(-135deg) translateY(-50%);\n\t/* margin-right: 2rem; */\n}\n.dlabnav .main-menu {\n\tpadding: 1.025rem 1.875rem;\n\tdisplay: block;\n\tpadding-bottom: 0;\n\tcolor: var(--primary);\n\ttext-transform: capitalize;\n}\n\n.header-profile2 .nav-link {\n\tbackground-color: transparent !important;\n}\n\n.header-profile2 img {\n\theight: 3rem;\n\twidth: 3rem;\n\tborder-radius: 0.375rem;\n\tmargin-left: 0.8rem;\n\tobject-fit: contain;\n}\n@media only screen and (max-width: 112rem) {\n\t.header-profile2 img {\n\t\tmargin-left: 0.5rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.header-profile2 img {\n\t\theight: 2.325rem;\n\t\twidth: 2.325rem;\n\t\tmargin-left: 0;\n\t}\n}\n\n.header-profile2 span {\n\tcolor: #666666;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.header-profile2 span {\n\t\tfont-size: 0.9rem;\n\t}\n}\n\n.header-profile2 i {\n\tmargin-left: 1rem;\n\tfont-size: 1.2rem;\n}\n\n@media only screen and (max-width: 87.5rem) {\n\t.header-profile2 {\n\t\tpadding: 0.5rem 0.5rem;\n\t\tpadding-right: 0;\n\t}\n}\n\n@media only screen and (max-width: 47.9375rem) {\n\t.header-profile2 {\n\t\tmargin-left: 2px !important;\n\t}\n\t.header-profile2 .sidebar-info {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media only screen and (max-width: 35.9375rem) {\n\t.header-profile2 {\n\t\tpadding: 0;\n\t}\n}\n\n.header-profile2 .dropdown-menu a svg path {\n\tfill: var(--primary);\n}\n\n@media only screen and (max-width: 35.9375rem) {\n\t.header-profile2 .dropdown-menu a svg {\n\t\twidth: 1.25rem;\n\t\theight: 1.25rem;\n\t}\n}\n\n.header-profile2 .dropdown-menu a span {\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tcolor: #a098ae;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.header-profile2 .dropdown-menu a span {\n\t\tfont-size: 12px;\n\t}\n}\n\n.header-profile2 .dropdown-menu .dropdown-item {\n\tpadding: 0.5rem 0.75rem;\n}\n\n.copyright {\n\tpadding: 0 1.875rem;\n\tcolor: #9fa4a6;\n\tmargin-top: 1.875rem;\n\t/* p{\n\t\tfont-size: 0.875rem;\n\t\t/color:#fff;\n\t} */\n}\n.copyright strong {\n\tdisplay: block;\n\tfont-size: 0.875rem;\n\tfont-weight: 700;\n\tcolor: var(--primary);\n\twhite-space: nowrap;\n}\n\n@media only screen and (max-width: 63.9375rem) {\n\t.nav-header {\n\t\twidth: 5rem;\n\t}\n}\n\n@media (max-width: 47.9375rem) {\n\t.brand-title {\n\t\tdisplay: none;\n\t}\n\t.footer {\n\t\tpadding-left: 0;\n\t}\n\t.dlabnav {\n\t\tleft: 0;\n\t\ttop: 5rem;\n\t}\n}\n\n@media only screen and (min-width: 1024px) and (max-width: 1422px) {\n\t[data-sidebar-style='full'][data-header-position='fixed'][data-layout='horizontal'][data-container='wide'] .content-body {\n\t\tpadding-top: 14rem !important;\n\t}\n}\n\n[data-sidebar-style='full'][data-header-position='fixed'][data-layout='vertical'][data-container='wide-boxed'] .content-body {\n\tpadding-top: 5rem !important;\n}\n\n[data-header-position='fixed'][data-layout='horizontal'][data-container='wide'][data-sidebar-position='static'] .content-body {\n\tpadding-top: 10rem;\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu > ul.collapse:not(.in),\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu > ul.collapse:not(.in) {\n\theight: 15.75rem !important;\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu:hover > a,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu:hover > a {\n\twidth: calc(70vw + 3.75rem);\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu:hover > ul,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu:hover > ul {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tflex-direction: column;\n\tmax-height: 13.75rem;\n\twidth: 70vw;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu:hover > ul ul a,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu:hover > ul ul a {\n\twidth: 101%;\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-xl:hover > a,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-xl:hover > a {\n\twidth: calc(70vw + 3rem);\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-xl:hover > ul,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-xl:hover > ul {\n\tmax-height: 12.5rem;\n\twidth: 70vw;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-xl:hover > ul ul a,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-xl:hover > ul ul a {\n\twidth: 101%;\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-lg:hover > a,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-lg:hover > a {\n\twidth: calc(55vw + 3rem);\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-lg:hover > ul,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-lg:hover > ul {\n\tmax-height: 12.5rem;\n\twidth: 55vw;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-lg:hover > ul ul a,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-lg:hover > ul ul a {\n\twidth: 101%;\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-md:hover > a,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-md:hover > a {\n\twidth: calc(45vw + 3);\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-md:hover > ul,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-md:hover > ul {\n\tmax-height: 18.75rem;\n\twidth: 45vw;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-md:hover > ul ul a,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-md:hover > ul ul a {\n\twidth: 101%;\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-sm:hover > a,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-sm:hover > a {\n\twidth: calc(30vw + 3);\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-sm:hover > ul,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-sm:hover > ul {\n\tmax-height: 18.125rem;\n\twidth: 30vw;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mega-menu-sm:hover > ul ul a,\n[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mega-menu-sm:hover > ul ul a {\n\twidth: 101%;\n}\n\n[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu:hover > a {\n\twidth: calc(60vw + 3.75rem);\n}\n\n[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu:hover > ul {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tflex-direction: column;\n\tmax-height: 25rem;\n\twidth: 60vw;\n}\n[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu:hover > ul ul a {\n\twidth: 101%;\n}\n\n[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-xl:hover > a {\n\twidth: calc(60vw + 3.75rem);\n}\n\n[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-xl:hover > ul {\n\tmax-height: 25.625rem;\n\twidth: 60vw;\n}\n\n[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-lg:hover > a {\n\twidth: calc(50vw + 3.75rem);\n}\n\n[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-lg:hover > ul {\n\tmax-height: 16.25rem;\n\twidth: 50vw;\n}\n\n[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-md:hover > a {\n\twidth: calc(40vw + 3.75rem);\n}\n\n[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-md:hover > ul {\n\tmax-height: 18.75rem;\n\twidth: 40vw;\n}\n\n[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-sm:hover > a {\n\twidth: calc(22vw + 3.75rem);\n}\n\n[data-sidebar-style='mini'][data-layout='vertical'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-sm:hover > ul {\n\tmax-height: 18.125rem;\n\twidth: 22vw;\n}\n\n[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:not(:last-child) {\n\tposition: static;\n}\n\n[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul {\n\tleft: 0;\n\tright: 0;\n}\n[data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-sibebarbg='color_2'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {\n\tborder-color: #2d286b;\n}\n[data-sibebarbg='color_3'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {\n\tborder-color: #000607;\n}\n[data-sibebarbg='color_4'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {\n\tborder-color: #1f0243;\n}\n[data-sibebarbg='color_5'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {\n\tborder-color: #921925;\n}\n[data-sibebarbg='color_6'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {\n\tborder-color: #aa4e01;\n}\n[data-sibebarbg='color_7'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {\n\tborder-color: #2d3081;\n}\n[data-sibebarbg='color_8'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {\n\tborder-color: #4e0ecc;\n}\n[data-sibebarbg='color_9'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {\n\tborder-color: #127155;\n}\n[data-sibebarbg='color_10'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li {\n\tborder-color: #0c525d;\n}\n[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li a {\n\ttransition: all 0.4s ease-in-out;\n}\n[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu ul li a:hover {\n\tborder-radius: 0.25rem;\n}\n\n[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tflex-direction: column;\n\tmax-height: 13.75rem;\n\twidth: 70vw;\n\tz-index: 99;\n}\n[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {\n\tcontent: '';\n\theight: 100%;\n\twidth: 0.0625rem;\n\tposition: absolute;\n\tbackground-color: #fff;\n\tright: 2.8125rem;\n\ttop: 0;\n}\n[data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {\n\tbackground-color: #282828;\n}\n[data-sibebarbg='color_2'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {\n\tbackground-color: #3d3690;\n}\n[data-sibebarbg='color_3'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {\n\tbackground-color: #033537;\n}\n[data-sibebarbg='color_4'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {\n\tbackground-color: #360474;\n}\n[data-sibebarbg='color_5'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {\n\tbackground-color: #bd2130;\n}\n[data-sibebarbg='color_6'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {\n\tbackground-color: #dc6502;\n}\n[data-sibebarbg='color_7'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {\n\tbackground-color: #3a3ea7;\n}\n[data-sibebarbg='color_8'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {\n\tbackground-color: #641df0;\n}\n[data-sibebarbg='color_9'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {\n\tbackground-color: #199d76;\n}\n[data-sibebarbg='color_10'][data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul::after {\n\tbackground-color: #117a8b;\n}\n[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu:hover > ul ul a {\n\twidth: 101%;\n}\n\n[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu-xl:hover > ul {\n\tmax-height: 13.125rem;\n\twidth: 70vw;\n}\n\n[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu-lg:hover > ul {\n\tmax-height: 13.125rem;\n\twidth: 43.75rem;\n\theight: 13.125rem !important;\n}\n@media only screen and (min-width: 75rem) and (max-width: 93.75rem) {\n\t[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu-lg:hover > ul {\n\t\twidth: 43.75rem;\n\t}\n}\n\n[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu-md:hover > ul {\n\tmax-height: 20rem;\n\twidth: 54vw;\n}\n@media only screen and (min-width: 75rem) and (max-width: 93.75rem) {\n\t[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu-md:hover > ul {\n\t\twidth: 60vw;\n\t}\n}\n\n[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu-sm:hover > ul {\n\tmax-height: 20rem;\n\twidth: 25vw;\n}\n@media only screen and (min-width: 75rem) and (max-width: 93.75rem) {\n\t[data-layout='horizontal'] .dlabnav .metismenu > li.mega-menu-sm:hover > ul {\n\t\twidth: 35vw;\n\t}\n}\n\n[data-layout='horizontal'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu:hover > ul {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tflex-direction: column;\n}\n\n[data-layout='horizontal'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-xl:hover > ul {\n\tmax-height: 21.875rem;\n\twidth: 100%;\n}\n\n[data-layout='horizontal'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-lg:hover > ul {\n\tmax-height: 21.875rem;\n\twidth: 55vw;\n}\n\n[data-layout='horizontal'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-md:hover > ul {\n\tmax-height: 18.75rem;\n\twidth: 45vw;\n}\n\n[data-layout='horizontal'][data-container='boxed'] .dlabnav .metismenu > li.mega-menu-sm:hover > ul {\n\tmax-height: 18.125rem;\n\twidth: 50vw;\n}\n\n:root {\n\t--primary: #4d44b5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3d3690;\n\t--primary-dark: #1e1a46;\n\t--rgba-primary-1: rgba(77, 68, 181, 0.1);\n\t--rgba-primary-2: rgba(77, 68, 181, 0.2);\n\t--rgba-primary-3: rgba(77, 68, 181, 0.3);\n\t--rgba-primary-4: rgba(77, 68, 181, 0.4);\n\t--rgba-primary-5: rgba(77, 68, 181, 0.5);\n\t--rgba-primary-6: rgba(77, 68, 181, 0.6);\n\t--rgba-primary-7: rgba(77, 68, 181, 0.7);\n\t--rgba-primary-8: rgba(77, 68, 181, 0.8);\n\t--rgba-primary-9: rgba(77, 68, 181, 0.9);\n\t--rgba-secondary-1: rgba(251, 125, 91, 0.1);\n\t--rgba-secondary-2: rgba(251, 125, 91, 0.2);\n\t--rgba-secondary-3: rgba(251, 125, 91, 0.3);\n\t--rgba-secondary-4: rgba(251, 125, 91, 0.4);\n\t--rgba-secondary-5: rgba(251, 125, 91, 0.5);\n\t--rgba-secondary-6: rgba(251, 125, 91, 0.6);\n\t--rgba-secondary-7: rgba(251, 125, 91, 0.7);\n\t--rgba-secondary-8: rgba(251, 125, 91, 0.8);\n\t--rgba-secondary-9: rgba(251, 125, 91, 0.9);\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--title: #303972;\n}\n\n/*\n0 - 600: Phone\n600 - 900: Tablet portrait\n900 - 1200: Tablet landscape\n1200 - 1800: Normal styles\n1800+ : Big Desktop\n1em = 16px\nThe smaller device rules always should write below the bigger device rules\nFixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component\n*/\n[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li {\n\tpadding: 0 1.25rem 0 1.25rem;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li > a {\n\tfont-size: 0.875rem;\n\tpadding: 0.638rem 1.5rem;\n\tfont-weight: 400;\n\tborder-radius: 0.375rem;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n\tline-height: 1.5rem;\n\t/* &:before{\n\t\t\t\t\t\tposition:absolute;\n\t\t\t\t\t\tcontent:\"\";\n\t\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\t\twidth:0;\n\t\t\t\t\t\theight:100%;\n\t\t\t\t\t\ttop:0;\n\t\t\t\t\t\tleft:0rem;\n\t\t\t\t\t\t@include transitionMedium;\n\t\t\t\t\t\tborder-radius:1.25rem;\n\t\t\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a {\n\tfont-weight: 500;\n\tbackground: var(--bs-body-bg);\n\tcolor: var(--primary);\n}\n[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a:before {\n\twidth: 0.375rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a:before {\n\t\twidth: 0.6rem;\n\t}\n}\n[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a svg path {\n\tfill: var(--primary);\n}\n[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: var(--primary);\n\tfont-weight: 900;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li .has-arrow:after {\n\tright: 1.5rem;\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .nav-header {\n\twidth: 5.5rem;\n\tz-index: 999;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .nav-header .brand-logo {\n\tpadding-left: 0;\n\tpadding-right: 0;\n\tjustify-content: center;\n\t.main-logo {\n\t\twidth: 40%;\n\t}\n}\n.brand-logo .main-logo {\n\twidth: 20%;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .nav-header .nav-control {\n\tright: -5.2rem;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .nav-header .nav-control .hamburger .line {\n\tbackground-color: #303972;\n\topacity: 1;\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .copyright,\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .plus-box {\n\tdisplay: none;\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .header {\n\tpadding-left: 5.5rem;\n\twidth: 100%;\n}\n[direction='rtl'][data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .header {\n\tpadding: 0 0.9375rem;\n\tpadding-right: 7.5rem;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .header .header-content {\n\twidth: calc(100% - 0rem);\n\tleft: 5.5rem;\n\tmargin-left: 0rem;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .header .page-titles {\n\tpadding-left: 7.3rem;\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav {\n\twidth: 5.5rem;\n\toverflow: visible;\n\tposition: absolute;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .nav-text {\n\tdisplay: none;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .slimScrollDiv,\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .dlabnav-scroll {\n\toverflow: visible !important;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .header-info2 {\n\tpadding: 0;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .header-info2 img {\n\tmargin-left: -1rem;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .sidebar-info {\n\tdisplay: none !important;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .header-profile2 {\n\tmargin: 0 0.5rem;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li {\n\tposition: relative;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li a {\n\tbackground: transparent;\n\tmargin: 0.125rem 0;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li a svg {\n\tmax-width: 1.5rem;\n\tmax-height: 1.5rem;\n\tmargin-right: 0;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li a:before {\n\tcontent: none;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li a i {\n\tmargin: 0;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li > ul {\n\tposition: absolute;\n\tleft: 5.5rem;\n\ttop: 0;\n\twidth: 12rem;\n\tz-index: 1001;\n\tdisplay: none;\n\tpadding-left: 0.0625rem;\n\theight: auto !important;\n\tbox-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n\tborder-radius: 0.375rem;\n\tmargin-left: 0;\n\tborder: 0;\n\tbackground: #fff;\n}\n[direction='rtl'][data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li > ul {\n\tleft: auto;\n\tright: 5rem;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li > ul li:hover ul {\n\tleft: 11.8125rem;\n\ttop: 0;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li > ul li:hover ul:after {\n\tcontent: none;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu li:hover > ul {\n\tdisplay: block;\n\theight: auto;\n\toverflow: visible;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li {\n\ttransition: all 0.4s ease-in-out;\n\tpadding: 0 1.125rem;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li > a {\n\tpadding: 0.75rem 0.925rem;\n\ttext-align: center;\n\tborder-radius: 0.5rem;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li > a.has-arrow:after {\n\tdisplay: none;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mm-active > a {\n\tbackground: var(--primary);\n\tborder-radius: 0.375rem;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n\tpadding: 0;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover:nth-last-child(-n + 1) > ul {\n\tbottom: 0;\n\ttop: auto;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > a {\n\tborder-radius: 0.375rem;\n\tbackground: var(--primary);\n\tcolor: #fff;\n}\n[data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > a {\n\tbackground: var(--primary);\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > a i {\n\tcolor: #fff;\n\t/* background:$primary; */\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > a svg path {\n\tfill: #fff;\n\tstroke: #fff;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > ul {\n\theight: auto !important;\n\tpadding: 0.625rem 0;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > ul a {\n\tpadding: 0.375rem 1.25rem 0.375rem 1.25rem;\n\tmargin-left: -0.1rem;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > ul ul {\n\tpadding: 0.625rem 0;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu > li:hover > ul ul a {\n\tpadding: 0.375rem 1.25rem 0.375rem 1.25rem;\n\tmargin-left: -0.1rem;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu .nav-label,\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .metismenu .nav-badge {\n\tdisplay: none;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .feature-box {\n\tdisplay: none;\n}\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .dlabnav .support-box {\n\tdisplay: none;\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .content-body {\n\tmargin-left: 5.5rem;\n}\n[direction='rtl'][data-sidebar-style='full'][data-layout='vertical'] .menu-toggle .content-body {\n\tmargin-right: 5.7rem;\n\tmargin-left: auto;\n\tborder: 0;\n}\n\n[data-sidebar-style='full'][data-layout='vertical'] .menu-toggle + .footer {\n\tpadding-left: 5.7rem;\n}\n[direction='rtl'][data-sidebar-style='full'][data-layout='vertical'] .menu-toggle + .footer {\n\tpadding-left: 0;\n\tpadding-right: 5.7rem;\n}\n\n[data-sidebar-style='full'][data-layout='horizontal'] .header .header-content {\n\tpadding-left: 1.875rem;\n}\n\n/*\n0 - 600: Phone\n600 - 900: Tablet portrait\n900 - 1200: Tablet landscape\n1200 - 1800: Normal styles\n1800+ : Big Desktop\n1em = 16px\nThe smaller device rules always should write below the bigger device rules\nFixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component\n*/\n:root {\n\t--primary: #4d44b5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3d3690;\n\t--primary-dark: #1e1a46;\n\t--rgba-primary-1: rgba(77, 68, 181, 0.1);\n\t--rgba-primary-2: rgba(77, 68, 181, 0.2);\n\t--rgba-primary-3: rgba(77, 68, 181, 0.3);\n\t--rgba-primary-4: rgba(77, 68, 181, 0.4);\n\t--rgba-primary-5: rgba(77, 68, 181, 0.5);\n\t--rgba-primary-6: rgba(77, 68, 181, 0.6);\n\t--rgba-primary-7: rgba(77, 68, 181, 0.7);\n\t--rgba-primary-8: rgba(77, 68, 181, 0.8);\n\t--rgba-primary-9: rgba(77, 68, 181, 0.9);\n\t--rgba-secondary-1: rgba(251, 125, 91, 0.1);\n\t--rgba-secondary-2: rgba(251, 125, 91, 0.2);\n\t--rgba-secondary-3: rgba(251, 125, 91, 0.3);\n\t--rgba-secondary-4: rgba(251, 125, 91, 0.4);\n\t--rgba-secondary-5: rgba(251, 125, 91, 0.5);\n\t--rgba-secondary-6: rgba(251, 125, 91, 0.6);\n\t--rgba-secondary-7: rgba(251, 125, 91, 0.7);\n\t--rgba-secondary-8: rgba(251, 125, 91, 0.8);\n\t--rgba-secondary-9: rgba(251, 125, 91, 0.9);\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--title: #303972;\n}\n\n@media only screen and (min-width: 48rem) {\n\t[data-sidebar-style='mini'] .nav-header {\n\t\twidth: 6.25rem;\n\t}\n\t[data-sidebar-style='mini'] .nav-header .nav-control {\n\t\tz-index: -1;\n\t}\n\t[data-sidebar-style='mini'] .nav-header .nav-control .hamburger {\n\t\tleft: 6.25rem !important;\n\t}\n\t[data-sidebar-style='mini'] .nav-header .nav-control .hamburger .line {\n\t\tbackground-color: #303972 !important;\n\t}\n\t[data-sidebar-style='mini'] .nav-header .brand-title {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='mini'] .nav-header .hamburger {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='mini'] .header .header-content {\n\t\tpadding-left: 1.875rem;\n\t\tleft: 6.32rem;\n\t\tpadding-right: 2rem;\n\t\twidth: auto;\n\t\tmargin-left: 0;\n\t}\n\t[direction='rtl'][data-sidebar-style='mini'] .header .header-content {\n\t\tpadding-right: 1.875rem;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav {\n\t\twidth: 6.25rem;\n\t\toverflow: visible;\n\t\tposition: absolute;\n\t\tz-index: 2;\n\t\ttop: 5rem;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .copyright,\n\t[data-sidebar-style='mini'] .dlabnav .plus-box {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .nav-text {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .slimScrollDiv,\n\t[data-sidebar-style='mini'] .dlabnav .dlabnav-scroll {\n\t\toverflow: visible !important;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .nav-user {\n\t\tpadding: 0.6875rem;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .nav-user .media-body {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .header-profile {\n\t\tmargin-bottom: 0;\n\t\tmargin-top: 0.75rem;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .header-profile:hover > a.nav-link {\n\t\tborder-radius: 3rem;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .header-profile img {\n\t\twidth: 3rem;\n\t\theight: 3rem;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .header-profile > a.nav-link {\n\t\tborder-radius: 3rem;\n\t\tpadding: 0.3125rem 0.3125rem;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .header-profile .header-info {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .metismenu li a {\n\t\tpadding: 0.813rem 0.875rem;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .metismenu li a svg {\n\t\tmargin-right: 0;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .metismenu li a i {\n\t\theight: auto;\n\t\twidth: auto;\n\t\tline-height: 1;\n\t\tmargin: 0;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .metismenu li > ul {\n\t\tposition: absolute;\n\t\tleft: 6.25rem;\n\t\ttop: 2.9375rem;\n\t\twidth: 11.875rem;\n\t\tz-index: 1001;\n\t\tdisplay: none;\n\t\tpadding-left: 0.0625rem;\n\t\tbox-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n\t\theight: auto !important;\n\t\tborder-radius: 0.375rem;\n\t\tbackground: #fff;\n\t}\n\t[direction='rtl']:not([data-layout='horizontal'])[data-sidebar-style='mini'] .dlabnav .metismenu li > ul {\n\t\tleft: auto;\n\t\tright: 6.25rem;\n\t\tbox-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .metismenu > li {\n\t\tpadding: 0.125rem 1.55rem;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .metismenu > li > a {\n\t\tpadding: 0.825rem 0.875rem;\n\t\t/* width: 64px;\n\t\t\t\t\t\theight: 64px; */\n\t\ttext-align: center;\n\t\tline-height: 1;\n\t\ttransition: all 0.5s;\n\t\t-moz-transition: all 0.5s;\n\t\t-webkit-transition: all 0.5s;\n\t\t-ms-transition: all 0.5s;\n\t\t-o-transition: all 0.5s;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .metismenu > li > a > i {\n\t\tpadding: 0;\n\t\tfont-size: 1.2rem;\n\t\tfont-weight: 900;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .metismenu > li > a.has-arrow:after {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .metismenu .nav-label,\n\t[data-sidebar-style='mini'] .dlabnav .metismenu .nav-badge {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .header-info2 {\n\t\tpadding: 0;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .header-info2 img {\n\t\tmargin-left: -1rem;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .sidebar-info {\n\t\tdisplay: none !important;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav .header-profile2 {\n\t\tmargin: 0 0.5rem;\n\t}\n\t[data-sidebar-style='mini'] .content-body {\n\t\tmargin-left: 6.25rem;\n\t}\n\t[data-sidebar-style='mini'] .footer {\n\t\tpadding-left: 1rem;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav {\n\t\tposition: absolute;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu li:hover > ul {\n\t\tdisplay: block;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li {\n\t\tposition: relative;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:after {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbackground: var(--primary);\n\t\twidth: 3px;\n\t\theight: 0;\n\t\tdisplay: none;\n\t\t-webkit-transition: all 0.5s;\n\t\t-ms-transition: all 0.5s;\n\t\ttransition: all 0.5s;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:nth-last-child(-n + 1) > ul {\n\t\tbottom: 0;\n\t\ttop: auto !important;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:nth-last-child(-n + 1) > ul:after {\n\t\ttop: auto;\n\t\tbottom: 1.25rem;\n\t}\n}\n@media only screen and (min-width: 48rem) and (max-width: 74.9375rem) {\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:nth-last-child(-n + 1) > ul {\n\t\tbottom: 0;\n\t\ttop: auto !important;\n\t}\n}\n\n@media only screen and (min-width: 48rem) {\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li > ul {\n\t\toverflow: visible;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li > ul:after {\n\t\tcontent: none;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li > ul li:hover ul {\n\t\tpadding: 0.625rem 0;\n\t\twidth: 13rem;\n\t\tleft: 13rem;\n\t\ttop: -0.625rem;\n\t\tborder: 0;\n\t\tmargin: 0;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li > ul li:hover ul:after {\n\t\tcontent: none;\n\t}\n\t[direction='rtl'][data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li > ul li:hover ul {\n\t\tleft: auto;\n\t\tright: 13rem;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active:after {\n\t\theight: 100%;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a {\n\t\tbackground: var(--primary);\n\t\tcolor: #fff;\n\t\tborder-radius: 0.375rem;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\t\tcolor: #fff;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active svg path {\n\t\tfill: #fff;\n\t\tstroke: #fff;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\t\tbackground: var(--primary);\n\t\tcolor: #fff;\n\t\t/* box-shadow:0 12px 15px 0 var(--rgba-primary-1); */\n\t\tborder-radius: 0.375rem;\n\t\tposition: unset;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\t\tcolor: #fff;\n\t}\n\t[direction='rtl'][data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a .nav-text {\n\t\tpadding-left: auto;\n\t\tpadding-right: 1.6875rem;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul {\n\t\theight: auto !important;\n\t\toverflow: visible;\n\t\tborder: 0;\n\t\tmargin-left: 0;\n\t\tleft: 6.25rem;\n\t\twidth: 13rem;\n\t\tborder-radius: 0.375rem;\n\t\tborder: 0;\n\t\tpadding: 0.625rem 0;\n\t\ttop: 0;\n\t}\n\t[data-theme-version='dark'][data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul {\n\t\tbox-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n\t}\n\t[direction='rtl'][data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul {\n\t\tleft: auto;\n\t\tright: 6.25rem;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul a {\n\t\tpadding: 0.375rem 1.25rem 0.375rem 1.25rem;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul a:before {\n\t\tcontent: none;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul a.has-arrow:after {\n\t\tright: 1.25rem;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul ul a {\n\t\tpadding: 0.375rem 1.25rem 0.375rem 1.25rem;\n\t\tmargin-left: -0.1rem;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .metismenu > li:hover > ul ul a:before {\n\t\tcontent: none;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .feature-box {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='mini'][data-layout='vertical'] .dlabnav .support-box {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='mini'][data-header-position='fixed'][data-container='boxed'][data-layout='vertical'] .header {\n\t\twidth: 74.9375rem;\n\t}\n\t[data-sidebar-style='mini'][data-layout='horizontal'] .dlabnav .metismenu > li {\n\t\tpadding: 0;\n\t}\n\t[data-sidebar-style='mini'][data-layout='horizontal'] .dlabnav .metismenu > li > a {\n\t\tpadding: 0.725rem;\n\t}\n\t[data-sidebar-style='mini'][data-layout='horizontal'] .dlabnav .metismenu > li > a i {\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t}\n\t[direction='rtl'][data-sidebar-style='mini'][data-layout='horizontal'] .dlabnav .metismenu > li > a {\n\t\tpadding: 1.125rem;\n\t}\n\t[direction='rtl'][data-sidebar-style='mini'][data-layout='horizontal'] .dlabnav .metismenu > li > a svg {\n\t\tmargin-left: 0;\n\t}\n\t[data-sidebar-style='mini'][data-layout='horizontal'] .dlabnav .metismenu > li > a svg {\n\t\tmargin-right: 0;\n\t\tmargin-top: 0;\n\t}\n\t[data-sidebar-style='mini'][data-layout='horizontal'] .dlabnav .metismenu > li > ul li a {\n\t\tpadding: 0.5rem 1.25rem 0.5rem 1.25rem;\n\t}\n}\n\n@media only screen and (max-width: 74.9375rem) {\n\t[data-sidebar-style='mini'] .dlabnav li.mm-active ul {\n\t\theight: auto !important;\n\t}\n\t[data-sidebar-style='mini'] .dlabnav li a.has-arrow::after {\n\t\ttransform: rotate(-225deg) translateY(-50%);\n\t}\n}\n\n:root {\n\t--primary: #4d44b5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3d3690;\n\t--primary-dark: #1e1a46;\n\t--rgba-primary-1: rgba(77, 68, 181, 0.1);\n\t--rgba-primary-2: rgba(77, 68, 181, 0.2);\n\t--rgba-primary-3: rgba(77, 68, 181, 0.3);\n\t--rgba-primary-4: rgba(77, 68, 181, 0.4);\n\t--rgba-primary-5: rgba(77, 68, 181, 0.5);\n\t--rgba-primary-6: rgba(77, 68, 181, 0.6);\n\t--rgba-primary-7: rgba(77, 68, 181, 0.7);\n\t--rgba-primary-8: rgba(77, 68, 181, 0.8);\n\t--rgba-primary-9: rgba(77, 68, 181, 0.9);\n\t--rgba-secondary-1: rgba(251, 125, 91, 0.1);\n\t--rgba-secondary-2: rgba(251, 125, 91, 0.2);\n\t--rgba-secondary-3: rgba(251, 125, 91, 0.3);\n\t--rgba-secondary-4: rgba(251, 125, 91, 0.4);\n\t--rgba-secondary-5: rgba(251, 125, 91, 0.5);\n\t--rgba-secondary-6: rgba(251, 125, 91, 0.6);\n\t--rgba-secondary-7: rgba(251, 125, 91, 0.7);\n\t--rgba-secondary-8: rgba(251, 125, 91, 0.8);\n\t--rgba-secondary-9: rgba(251, 125, 91, 0.9);\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--title: #303972;\n}\n\n@media (min-width: 64rem) {\n\t[data-layout='horizontal'][data-sidebarbg='color_1'] .dlabnav {\n\t\tbackground-color: #fff;\n\t}\n\t[data-theme-version='dark'][data-layout='horizontal'][data-sidebarbg='color_1'] .dlabnav {\n\t\tbackground-color: #272738;\n\t}\n\t[data-layout='horizontal'] .dlabnav .menu-scroll {\n\t\theight: unset;\n\t}\n\t[data-layout='horizontal'] .nav-header {\n\t\twidth: 18.563rem;\n\t\theight: 5rem;\n\t\ttop: 0;\n\t}\n\t[data-layout='horizontal'] .nav-header .nav-control {\n\t\tdisplay: none;\n\t}\n\t[data-layout='horizontal'] .nav-header .brand-logo {\n\t\tpadding-left: 2.5rem;\n\t\tpadding-right: 2.5rem;\n\t}\n\t[data-layout='horizontal'] .header {\n\t\twidth: 100%;\n\t\theight: 5rem;\n\t\tpadding-left: 0;\n\t\tpadding-top: 0;\n\t}\n\t[data-layout='horizontal'] .dlabnav {\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\theight: auto;\n\t\tpadding-bottom: 0;\n\t\ttop: 0;\n\t\tz-index: 2;\n\t}\n\t[data-layout='horizontal'] .dlabnav .slimScrollDiv {\n\t\toverflow: visible !important;\n\t}\n\t[data-layout='horizontal'] .dlabnav .slimScrollDiv .dlabnav-scroll {\n\t\toverflow: visible !important;\n\t}\n\t[data-layout='horizontal'] .dlabnav .dlabnav-scroll {\n\t\toverflow: visible !important;\n\t}\n\t[data-layout='horizontal'] .dlabnav .slimScrollBar {\n\t\tdisplay: none !important;\n\t}\n\t[data-layout='horizontal'] .dlabnav .header-profile {\n\t\tmargin-right: 0.9375rem;\n\t\tmargin-bottom: 0;\n\t\tdisplay: none;\n\t}\n\t[data-layout='horizontal'] .dlabnav .header-profile:hover > a.nav-link {\n\t\tborder-radius: 3rem;\n\t}\n\t[data-layout='horizontal'] .dlabnav .header-profile img {\n\t\theight: 2.8125rem;\n\t\twidth: 2.8125rem;\n\t}\n\t[data-layout='horizontal'] .dlabnav .header-profile > a.nav-link {\n\t\tborder-radius: 3rem;\n\t\tpadding: 0.3125rem 0.3125rem;\n\t}\n\t[data-layout='horizontal'] .dlabnav .header-profile .header-info {\n\t\tdisplay: none;\n\t}\n\t[data-layout='horizontal'] .dlabnav .header-profile2 {\n\t\tdisplay: none;\n\t}\n\t[data-layout='horizontal'] .dlabnav .nav-user,\n\t[data-layout='horizontal'] .dlabnav .nav-label {\n\t\tdisplay: none;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu {\n\t\tflex-direction: row;\n\t\tpadding: 0.625rem 1.25rem;\n\t\tmargin-bottom: 0;\n\t\tdisplay: inline-flex;\n\t\tflex-wrap: wrap;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu .collapse.in {\n\t\tdisplay: none;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu ul {\n\t\tborder-left: 0;\n\t}\n\t[data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu ul {\n\t\tbox-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu li {\n\t\tflex-direction: column;\n\t\tposition: relative;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu li:hover > ul {\n\t\tdisplay: block;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu li > ul {\n\t\tposition: absolute;\n\t\theight: auto !important;\n\t\ttop: 100%;\n\t\twidth: 100%;\n\t\tmin-width: 13.75rem;\n\t\tz-index: 999;\n\t\tleft: auto;\n\t\tright: auto;\n\t\tpadding: 0.5rem 0;\n\t\tdisplay: none;\n\t\tbox-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n\t\tmargin: 0;\n\t\tbackground: #fff;\n\t\tborder-radius: 0.375rem;\n\t}\n\t[data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu li > ul {\n\t\tbox-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n\t\tbackground: #272738;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu li > ul li {\n\t\tpadding: 0;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu li > ul li a {\n\t\ttransition: all 0.4s ease-in-out;\n\t\tpadding: 0.5rem 1.25rem 0.5rem 1.25rem;\n\t\tmargin-left: -0.1rem;\n\t}\n\t[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu li > ul li a {\n\t\tpadding: 0.5rem 1.25rem 0.5rem 1.25rem;\n\t\ttext-align: right;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu li > ul li a:hover {\n\t\tborder-radius: 0.4rem;\n\t\tpadding-left: 1.25rem;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu li > ul li a:before {\n\t\tcontent: none;\n\t\tleft: 1.375rem;\n\t}\n\t[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu li > ul li a:before {\n\t\tleft: auto;\n\t\tright: 0.375rem;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu li > ul ul {\n\t\tleft: 100%;\n\t\ttop: 0;\n\t\tbox-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n\t}\n\t[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu li > ul ul {\n\t\tleft: auto;\n\t\tright: 100%;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li {\n\t\tflex: 0 0 auto;\n\t\tposition: relative;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li > a i {\n\t\tmargin-right: 0.3125rem;\n\t}\n\t[data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu > li {\n\t\tborder-color: rgba(255, 255, 255, 0.07);\n\t}\n\t[data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active {\n\t\tborder-color: transparent;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li:hover,\n\t[data-layout='horizontal'] .dlabnav .metismenu > li.mm-active {\n\t\tpadding: 0;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n\t[data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a {\n\t\tbackground: var(--primary);\n\t\tcolor: #fff;\n\t\tborder-radius: 0.375rem;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li:hover > a i,\n\t[data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a i {\n\t\tcolor: #fff;\n\t\tbackground: transparent;\n\t\tbox-shadow: none;\n\t}\n\t[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li:first-child {\n\t\tborder-right: 0;\n\t}\n\t[data-theme-version='dark'][direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li {\n\t\tborder-color: rgba(255, 255, 255, 0.1);\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li > a {\n\t\tpadding: 0.7375rem 2.4rem 0.7375rem 0.7375rem;\n\t\tmargin: 0.125rem 0.125rem;\n\t}\n\t[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li > a {\n\t\tpadding: 0.9375rem 0.9375rem 0.9375rem 2.5rem;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li > a i {\n\t\tpadding: 0 0.4375rem 0 0;\n\t\theight: auto;\n\t\twidth: auto;\n\t\tline-height: 1;\n\t}\n\t[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li > a i {\n\t\tpadding: 0 0 0 0.4375rem;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li > a .nav-badge {\n\t\tdisplay: none;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li > a:after {\n\t\tright: 1.25rem;\n\t\ttransform: rotate(-135deg) translateY(-50%);\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li:hover {\n\t\tborder-color: transparent;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li:hover > ul {\n\t\tdisplay: flex !important;\n\t\tflex-direction: column;\n\t\tflex-wrap: wrap;\n\t\theight: auto !important;\n\t\tbox-shadow: 0.3125rem 0.3125rem 1.875rem 0rem rgba(20, 0, 30, 0.1);\n\t\tborder-radius: 0.375rem;\n\t}\n\t[data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > ul {\n\t\tbox-shadow: 0.3125rem 0.3125rem 1.875rem 0rem rgba(0, 0, 0, 0.1);\n\t\tbackground: #272738;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li > ul > li:hover ul.collapse {\n\t\tdisplay: block !important;\n\t\tposition: absolute;\n\t\tleft: auto !important;\n\t\tright: -100% !important;\n\t\ttop: 0 !important;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li:nth-last-child(-n + 5) > ul {\n\t\tleft: auto;\n\t\tright: 0;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li:nth-last-child(-n + 5) > ul > li:hover ul.collapse {\n\t\tright: auto !important;\n\t\tleft: -100% !important;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li:nth-last-child(-n + 5) > ul.left {\n\t\tleft: 0;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li:nth-last-child(-n + 5) > ul.left > li:hover ul.collapse {\n\t\tleft: 100% !important;\n\t}\n\t[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li:nth-last-child(-n + 5) > ul.left {\n\t\tleft: auto;\n\t\tright: 0;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li:last-child > ul ul {\n\t\tleft: -100%;\n\t}\n\t[data-layout='horizontal'] .dlabnav .metismenu > li:last-child > ul.left ul {\n\t\tleft: 100%;\n\t}\n\t[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li:last-child > ul.left ul {\n\t\tleft: auto;\n\t\tright: 100%;\n\t}\n\t[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li:nth-last-child(-n + 3) > ul {\n\t\tleft: 0;\n\t\tright: auto;\n\t}\n\t[direction='rtl'][data-layout='horizontal'] .dlabnav .metismenu > li:nth-last-child(-n + 3) > ul > li:hover ul.collapse {\n\t\tright: -100% !important;\n\t\tleft: auto !important;\n\t}\n\t[data-layout='horizontal'] .dlabnav .copyright,\n\t[data-layout='horizontal'] .dlabnav .feature-box,\n\t[data-layout='horizontal'] .dlabnav .support-box {\n\t\tdisplay: none;\n\t}\n\t[data-layout='horizontal'] .content-body {\n\t\tmargin-left: 0;\n\t}\n\t[data-layout='horizontal'] .content-body .container-fluid,\n\t[data-layout='horizontal'] .content-body .container-sm,\n\t[data-layout='horizontal'] .content-body .container-md,\n\t[data-layout='horizontal'] .content-body .container-lg,\n\t[data-layout='horizontal'] .content-body .container-xl,\n\t[data-layout='horizontal'] .content-body .container-xxl {\n\t\tpadding-top: 2.5rem;\n\t}\n}\n@media only screen and (min-width: 64rem) and (max-width: 74.9375rem) {\n\t[data-layout='horizontal'] .content-body .container-fluid,\n\t[data-layout='horizontal'] .content-body .container-sm,\n\t[data-layout='horizontal'] .content-body .container-md,\n\t[data-layout='horizontal'] .content-body .container-lg,\n\t[data-layout='horizontal'] .content-body .container-xl,\n\t[data-layout='horizontal'] .content-body .container-xxl {\n\t\tpadding-top: 4.5rem;\n\t}\n}\n\n@media (min-width: 64rem) {\n\t[data-layout='horizontal'] .content-body .page-titles {\n\t\tmargin-left: 0 !important;\n\t\tmargin-right: 0 !important;\n\t\tmargin-bottom: 1.875rem;\n\t}\n\t[data-layout='horizontal'] .footer {\n\t\tmargin-left: 0;\n\t\tmargin: 0 auto;\n\t\tpadding-left: 0;\n\t}\n\t[data-layout='horizontal'] .footer.footer-outer {\n\t\twidth: calc(100% - 25.225rem);\n\t\tmargin-left: 1.775rem;\n\t}\n\t[data-layout='horizontal'] .footer.style-2 {\n\t\twidth: calc(100% - 3.825rem);\n\t}\n\t[data-layout='horizontal'] .footer.style-1 {\n\t\twidth: calc(100% - 22.325rem);\n\t\tmargin-right: 19.975rem !important;\n\t}\n\t[data-header-position='fixed'][data-layout='horizontal'] .dlabnav {\n\t\ttop: 5rem;\n\t}\n\t[data-header-position='fixed'][data-layout='horizontal'] .header {\n\t\theight: 5rem;\n\t}\n\t[data-header-position='fixed'][data-layout='horizontal'] .header.is-fixed {\n\t\tborder-bottom: 1px solid #eeeeee;\n\t}\n\t[data-header-position='fixed'][data-layout='horizontal'] .content-body {\n\t\tpadding-top: 5rem;\n\t}\n\t[data-header-position='fixed'][data-layout='horizontal'] {\n\t\t/* [data-header-position=\"fixed\"][data-sidebar-position=\"static\"] {\n\t\t.dlabnav {\n            top: 0rem;\n        }\n\t\t.content-body {\n\t\t\tpadding-top: 0rem;\n\t\t}\n\t} */\n\t}\n\t[data-header-position='fixed'][data-layout='horizontal'] .dlabnav {\n\t\tposition: fixed;\n\t}\n\t[data-header-position='fixed'][data-layout='horizontal'][data-sidebar-position='fixed'] .content-body {\n\t\tpadding-top: 10rem;\n\t}\n}\n\n@media only screen and (min-width: 64rem) and (max-width: 88.75rem) {\n\t[data-header-position='fixed'][data-layout='horizontal'] [data-sidebar-style='full'] .content-body {\n\t\tpadding-top: 14rem;\n\t}\n}\n\n@media (min-width: 64rem) {\n\t[data-header-position='fixed'][data-layout='horizontal'][data-sidebar-position='fixed'][data-sidebar-style='modern'] .content-body {\n\t\tpadding-top: 13rem;\n\t}\n\t[data-layout='horizontal'][data-container='boxed'] .footer {\n\t\tmargin-left: 0;\n\t\tmax-width: 74.9375rem;\n\t\tmargin: 0 auto;\n\t}\n\t[data-layout='horizontal'][data-container='wide'] .page-titles {\n\t\tmargin-left: -1.875rem;\n\t\tmargin-right: -1.875rem;\n\t\tdisplay: none;\n\t}\n\t[data-layout='horizontal'][data-container='wide'] .header-banner {\n\t\tdisplay: none;\n\t}\n\t[data-layout='horizontal'][data-sidebar-style='modern'] .dlabnav .header-profile {\n\t\tmargin-bottom: 0;\n\t}\n\t[data-layout='horizontal'][data-sidebar-style='modern'] .dlabnav .header-profile img {\n\t\theight: 3.75rem;\n\t\twidth: 3.75rem;\n\t\tmargin-bottom: 0 !important;\n\t}\n\t[data-layout='horizontal'][data-sidebar-style='modern'] .dlabnav .header-profile > a.nav-link {\n\t\tborder: 0.0625rem solid #eeeeee;\n\t\tpadding: 0.25rem 0.25rem;\n\t\tborder-radius: 3rem;\n\t}\n\t[data-layout='horizontal'][data-sidebar-style='compact'] .page-titles {\n\t\tmargin-top: 0;\n\t}\n\t[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .header-profile {\n\t\tmargin-bottom: 0;\n\t}\n\t[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .header-profile img {\n\t\theight: 3.75rem;\n\t\twidth: 3.75rem;\n\t\tmargin-bottom: 0 !important;\n\t}\n\t[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .header-profile > a.nav-link {\n\t\tborder: 0.0625rem solid #eeeeee;\n\t}\n\t[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .metismenu > li > ul {\n\t\ttop: 5.1rem;\n\t}\n\t[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .metismenu > li > a {\n\t\tpadding: 1.125rem 1.25rem 0.625rem 1.25rem;\n\t}\n\t[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .metismenu > li > a::after {\n\t\tdisplay: none;\n\t}\n\t[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .metismenu > li > a .nav-text {\n\t\tmargin-top: 0.3125rem;\n\t}\n\t[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .metismenu > li > a > i {\n\t\twidth: auto;\n\t\tmargin: 0;\n\t\theight: auto;\n\t\tline-height: 1;\n\t\tpadding: 0;\n\t\tbackground: transparent;\n\t\tborder-radius: 0;\n\t\tmargin-bottom: 0;\n\t}\n\t[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav .metismenu > li li {\n\t\ttext-align: left;\n\t}\n\t[data-sidebar-style='mini'][data-layout='horizontal'] .nav-header {\n\t\twidth: 7.75rem;\n\t\tpadding-left: 2.5rem;\n\t\tpadding-right: 2.5rem;\n\t}\n\t[data-sidebar-style='mini'][data-layout='horizontal'] .nav-header .brand-logo {\n\t\tjustify-content: start;\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t}\n\t[data-sidebar-style='mini'][data-layout='horizontal'] .header {\n\t\twidth: 100%;\n\t\tpadding-left: 7.75rem;\n\t}\n\t[data-sidebar-style='mini'][data-layout='horizontal'] .metismenu > li a {\n\t\twidth: auto;\n\t}\n\t[data-sidebar-style='mini'][data-layout='horizontal'] .metismenu > li:hover a .nav-text {\n\t\tdisplay: none;\n\t}\n\t[data-header-position='fixed'][data-layout='horizontal'][data-sidebar-position='fixed'][data-sidebar-style='compact'] .content-body {\n\t\tpadding-top: 11.8rem;\n\t}\n\t[data-sidebar-position='fixed'][data-layout='horizontal'] .dlabnav.fixed {\n\t\tposition: fixed;\n\t\tpadding: 0 0.9375rem;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\tborder-radius: 0;\n\t\twidth: 100%;\n\t}\n\t[data-sidebar-position='fixed'][data-layout='horizontal'] .wallet-open.show.active .dlabnav-scroll {\n\t\tpadding-right: 352px;\n\t}\n\t[data-sidebar-position='fixed'][data-layout='horizontal'] .wallet-open.show.active .content-body {\n\t\tpadding-top: 13rem;\n\t}\n}\n\n@media (min-width: 47.9375rem) {\n\t[data-sidebar-style='compact'] .nav-header {\n\t\twidth: 11.25rem;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .metismenu .has-arrow[aria-expanded='true']:after,\n\t[data-sidebar-style='compact'] .dlabnav .metismenu .mm-active > .has-arrow:after {\n\t\tmargin-right: 0;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .header-profile {\n\t\tmargin-bottom: 0.3125rem;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .header-profile > a.nav-link {\n\t\tdisplay: block;\n\t\ttext-align: center;\n\t\tborder: 0;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .header-profile > a.nav-link img {\n\t\tmargin-bottom: 0.3125rem;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .header-profile > a.nav-link .header-info {\n\t\tmargin-left: 0 !important;\n\t\ttext-align: center;\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .header-profile > a.nav-link .header-info small,\n\t[data-sidebar-style='compact'] .dlabnav .header-profile > a.nav-link .header-info .small {\n\t\ttext-align: center !important;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .header-profile .dropdown-menu {\n\t\tmin-width: 11rem;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .header-profile a svg {\n\t\tdisplay: unset !important;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .nav-user {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .metismenu li {\n\t\ttext-align: center;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .metismenu li a {\n\t\tpadding: 0.7rem 0.5rem;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .metismenu li a svg {\n\t\tmax-width: 1.3125rem;\n\t\tmax-height: 1.3125rem;\n\t\tdisplay: block;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .metismenu li a i {\n\t\t-webkit-transition: all 0.5s;\n\t\t-ms-transition: all 0.5s;\n\t\ttransition: all 0.5s;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .metismenu li ul:after {\n\t\tcontent: none;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .metismenu li > a {\n\t\tbox-shadow: none;\n\t\tfont-size: 0.9375rem;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .plus-box,\n\t[data-sidebar-style='compact'] .dlabnav .copyright {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .copyright {\n\t\tpadding: 0 1.25rem;\n\t\tmargin-top: 1.25rem;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .header-info2 {\n\t\tpadding: 0;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .header-info2 img {\n\t\tmargin-left: -1rem;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .sidebar-info {\n\t\tdisplay: none !important;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .header-profile2 {\n\t\tmargin: 0 3rem;\n\t}\n\t[data-sidebar-style='compact'] .dlabnav .feature-box,\n\t[data-sidebar-style='compact'] .dlabnav .support-box {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='compact'] .nav-text {\n\t\tdisplay: inline-block;\n\t\tmargin-top: 0.3125rem;\n\t}\n\t[data-sidebar-style='compact'] .nav-label.first {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='compact'] .nav-badge {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='compact'] .footer {\n\t\tpadding-left: 0;\n\t\twidth: calc(100% - 37.225rem);\n\t}\n\t[data-sidebar-style='compact'] .content-body {\n\t\tmargin-left: 11.2rem;\n\t}\n\t[data-sidebar-style='compact'][data-theme-version='dark'][data-layout='horizontal'] .dlabnav .metismenu li > a i {\n\t\tcolor: #fff;\n\t}\n\t[data-sidebar-style='compact'][data-theme-version='dark'][data-layout='vertical'] .dlabnav .metismenu li.mm-active > a i {\n\t\tbackground: var(--primary);\n\t\tcolor: #fff;\n\t}\n\t[data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu li:hover > a i {\n\t\tbackground: var(--primary);\n\t\tcolor: #fff;\n\t}\n}\n\n[data-layout='horizontal'][data-sidebar-style='compact'] .footer {\n\tpadding-left: 0;\n}\n\n[data-layout='horizontal'][data-sidebar-style='compact'] .content-body {\n\tmargin-left: 0;\n}\n\n[data-layout='horizontal'][data-sidebar-style='compact'] .dlabnav {\n\tmargin-bottom: 0;\n}\n\n[data-layout='horizontal'][data-sidebar-style='compact'] .nav-header {\n\twidth: 13.25rem;\n}\n\n[data-layout='vertical'][data-sidebar-style='compact'] .dlabnav {\n\twidth: 11.25rem;\n}\n[data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu ul {\n\tmargin-left: 0;\n\tborder: 0;\n\tbackground: rgba(0, 0, 0, 0.02);\n\tpadding: 0.625rem 0;\n}\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu ul {\n\tbackground: 255, 255, 255, 0.05;\n}\n[data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu ul a:before {\n\tcontent: none;\n}\n[data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu ul ul a {\n\tpadding: 0.625rem 0.9375rem;\n}\n[data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li > a {\n\tpadding: 1.2rem 0.5rem;\n}\n[data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li > a.has-arrow::after {\n\ttop: 0.0625rem;\n\tdisplay: inline-block;\n\tright: auto;\n\tmargin-left: 0.3125rem;\n\tposition: relative;\n\twidth: 0.4375rem;\n\theight: 0.4375rem;\n\tborder-width: 0.125rem 0rem 0rem 0.125rem;\n}\n[direction='rtl'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li > a.has-arrow::after {\n\tleft: auto;\n\tmargin-left: 0;\n\tmargin-right: 0.3125rem;\n}\n[data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: transparent;\n\tcolor: var(--primary);\n}\n\n@media (min-width: 47.9375rem) {\n\t[data-sidebar-style='icon-hover'][data-layout='horizontal'] .header .header-content {\n\t\tpadding-left: 1.875rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu li.mm-active > ul {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .header-info2 {\n\t\tjustify-content: space-between;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .header-info2 img {\n\t\torder: 1;\n\t\tmargin-right: 0;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .dlabnav .metismenu li.mm-active > ul {\n\t\tdisplay: block;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .nav-header {\n\t\twidth: 4.36rem;\n\t\tborder-radius: 0 0 0 0 !important;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .nav-header .brand-logo {\n\t\tpadding: 0;\n\t\tpadding-left: 0.5rem;\n\t}\n\t[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .nav-header .brand-logo {\n\t\tpadding-left: 1.875rem;\n\t\tpadding-right: 1.875rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .nav-header .brand-logo .logo-abbr {\n\t\tdisplay: block;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .nav-header .brand-logo .brand-title {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .nav-header .nav-control {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .header {\n\t\tpadding-left: 5rem;\n\t}\n\t[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .header {\n\t\tpadding-right: 7rem;\n\t\tpadding-left: 0.9375rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .header .header-content {\n\t\tpadding-left: 2rem;\n\t\tleft: 5rem;\n\t\twidth: auto;\n\t\tmargin-left: 0.8rem;\n\t}\n\t[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .header .header-content {\n\t\tpadding-right: 1.375rem;\n\t\tpadding-left: 0;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav {\n\t\toverflow: visible;\n\t\tposition: absolute;\n\t\tleft: -13.2rem;\n\t}\n}\n@media only screen and (min-width: 47.9375rem) and (min-width: 47.9375rem) and (max-width: 87.5rem) {\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav {\n\t\tleft: -10rem;\n\t}\n}\n\n@media (min-width: 47.9375rem) {\n\t[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav {\n\t\tleft: auto;\n\t\tright: -14.563rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .nav-label {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .header-profile img {\n\t\torder: 1;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .header-profile .header-info {\n\t\tmargin-left: 0 !important;\n\t\tpadding-left: 0 !important;\n\t\tmargin-right: 0.625rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li {\n\t\tpadding: 0 1rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li > a {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tfont-size: 0.938rem;\n\t\tborder-radius: 0.375rem;\n\t\talign-items: center;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li > a > svg,\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\t\torder: 1;\n\t\tmargin-right: 0;\n\t\tmargin-top: 0;\n\t\tpadding-right: 0;\n\t\theight: auto;\n\t\twidth: auto;\n\t\tline-height: 1;\n\t}\n\t[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li > a > svg,\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a,\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a {\n\t\tbackground: var(--primary);\n\t\tcolor: #fff;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i,\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\t\tcolor: #fff;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul {\n\t\tborder-left: 0;\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t}\n\t[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul {\n\t\tpadding-right: 0;\n\t\tpadding-left: 0;\n\t}\n\t[data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul {\n\t\tborder-color: rgba(255, 255, 255, 0.1);\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul:after {\n\t\tleft: auto;\n\t\tright: 1.75rem;\n\t}\n\t[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul:after {\n\t\tleft: 1.75rem;\n\t\tright: auto;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul a {\n\t\tposition: relative;\n\t\tpadding-left: 1.8rem;\n\t}\n\t[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul a {\n\t\tpadding-right: 1.25rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul a::before {\n\t\tleft: 1.25rem;\n\t\tright: auto;\n\t}\n\t[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu ul a::before {\n\t\tright: auto;\n\t\tleft: -0.3125rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu .has-arrow::after {\n\t\tright: 5rem;\n\t\topacity: 0;\n\t}\n\t[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .metismenu .has-arrow::after {\n\t\tright: auto;\n\t\tleft: 5rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .copyright,\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav .support-box {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .dlabnav.mm-show {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .nav-header {\n\t\twidth: 17.5rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .nav-header .brand-logo {\n\t\tpadding-left: 1.6rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .nav-header .brand-logo .brand-title {\n\t\tdisplay: block;\n\t}\n}\n@media only screen and (min-width: 47.9375rem) and (max-width: 87.5rem) {\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .nav-header {\n\t\twidth: 1rem;\n\t}\n}\n\n@media (min-width: 47.9375rem) {\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle.mm-show {\n\t\tdisplay: block;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .header {\n\t\tpadding-left: 4.38rem;\n\t}\n\t[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .header {\n\t\tpadding-right: 4.38rem;\n\t\tpadding-left: 0.9375rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .dlabnav {\n\t\tleft: 0;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .dlabnav .metismenu .has-arrow:after {\n\t\topacity: 1;\n\t}\n\t[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .dlabnav {\n\t\tleft: auto;\n\t\tright: 0;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .iconhover-toggle .dlabnav .support-box {\n\t\tdisplay: block;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .content-body {\n\t\tmargin-left: 5.6rem;\n\t}\n\t[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .content-body {\n\t\tmargin-left: 0;\n\t\tmargin-right: 7rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .footer {\n\t\tpadding-left: 7rem;\n\t}\n\t[direction='rtl'][data-sidebar-style='icon-hover'][data-layout='vertical'] .footer {\n\t\tmargin-left: 0;\n\t\tmargin-right: 7rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .footer.style-1 {\n\t\twidth: calc(100% - 28.125rem);\n\t\tmargin-right: 20.675rem;\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .footer.footer-outer {\n\t\twidth: calc(100% - 31.225rem);\n\t}\n\t[data-sidebar-style='icon-hover'][data-layout='vertical'] .footer.style-2 {\n\t\twidth: calc(100% - 9.325rem);\n\t}\n}\n\n@media (min-width: 47.9375rem) {\n\t[data-sidebar-style='modern'] .nav-header {\n\t\twidth: 10.625rem;\n\t}\n\t[data-sidebar-style='modern'] .nav-header .brand-logo {\n\t\tjustify-content: center;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .header-profile {\n\t\tmargin-bottom: 0.3125rem;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .header-profile > a.nav-link {\n\t\tdisplay: block;\n\t\ttext-align: center;\n\t\tmargin: 0 -0.625rem 0.9375rem;\n\t\tpadding: 0.9375rem 0.625rem;\n\t\tborder-radius: 0.375rem;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .header-profile > a.nav-link img {\n\t\tmargin-bottom: 0.3125rem;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .header-profile > a.nav-link .header-info {\n\t\tmargin-left: 0 !important;\n\t\ttext-align: center;\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .header-profile > a.nav-link .header-info small,\n\t[data-sidebar-style='modern'] .dlabnav .header-profile > a.nav-link .header-info .small {\n\t\ttext-align: center !important;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .metismenu > li {\n\t\ttext-align: center;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .metismenu > li > a {\n\t\tpadding: 1.25rem 0.9375rem 1.25rem 0.9375rem;\n\t\tmargin: 0.125rem 0;\n\t\t-webkit-transition: all 0.5s;\n\t\t-ms-transition: all 0.5s;\n\t\ttransition: all 0.5s;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .metismenu > li > a::after {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .metismenu > li > a:hover > a,\n\t[data-sidebar-style='modern'] .dlabnav .metismenu > li > a:focus > a,\n\t[data-sidebar-style='modern'] .dlabnav .metismenu > li > a:active > a,\n\t[data-sidebar-style='modern'] .dlabnav .metismenu > li > a.mm-active > a {\n\t\tbackground-color: var(--primary-dark);\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .metismenu > li:hover,\n\t[data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active {\n\t\tpadding: 0;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n\t[data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a {\n\t\tbackground: var(--primary);\n\t\tcolor: #fff;\n\t\tborder-radius: 0.375rem;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a i,\n\t[data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a i {\n\t\tcolor: #fff;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .metismenu > li li {\n\t\ttext-align: left;\n\t}\n\t[direction='rtl'][data-sidebar-style='modern'] .dlabnav .metismenu > li li {\n\t\ttext-align: right;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .metismenu li a {\n\t\tpadding: 0.625rem 0.9375rem 0.625rem 0.9375rem;\n\t\tfont-size: 0.9375rem;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .metismenu li ul:after {\n\t\tcontent: none;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .metismenu li > ul {\n\t\theight: auto !important;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .metismenu .nav-label {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .nav-label {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .nav-text {\n\t\tdisplay: block;\n\t\tmargin-top: 0.3125rem;\n\t}\n\t[data-sidebar-style='modern'] .dlabnav .feature-box,\n\t[data-sidebar-style='modern'] .dlabnav .support-box,\n\t[data-sidebar-style='modern'] .dlabnav .copyright {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='modern'] .footer {\n\t\tpadding-left: 11.9rem;\n\t}\n\t[data-sidebar-style='modern'] .content-body {\n\t\tmargin-left: 10.9rem;\n\t}\n\t[data-sidebar-style='modern'][data-layout='horizontal'] .dlabnav .metismenu li > a i {\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav {\n\t\twidth: 10.625rem;\n\t\tleft: 0;\n\t}\n\t[direction='rtl'][data-sidebar-style='modern'][data-layout='vertical'] .dlabnav {\n\t\tleft: auto;\n\t\tright: 0;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .slimScrollDiv,\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .dlabnav-scroll {\n\t\toverflow: visible !important;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu {\n\t\tpadding: 0.625rem 0.875rem;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu > li > a {\n\t\tpadding: 1.375rem 0.6em 0.9375rem;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu > li > a i {\n\t\tpadding: 0;\n\t\theight: auto;\n\t\twidth: auto;\n\t\tmargin: 0;\n\t\tline-height: 1;\n\t\tmargin-bottom: 0.3125rem;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu > li > ul {\n\t\tdisplay: none;\n\t\tpadding: 1.875rem 0.9375rem;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li {\n\t\tposition: relative;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li a {\n\t\tpadding: 1rem 1rem;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li a:before {\n\t\tcontent: none;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li ul {\n\t\tposition: absolute;\n\t\tleft: 105%;\n\t\ttop: 0;\n\t\tbottom: auto;\n\t\tbackground-color: #fff;\n\t\tborder: 0.0625rem solid #f2f2f2;\n\t\twidth: 12.5rem;\n\t}\n\t[data-theme-version='dark'][data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li ul {\n\t\tbackground: #272738;\n\t\tbox-shadow: 0rem 0rem 0.8125rem 0rem rgba(0, 0, 0, 0.1);\n\t}\n\t[direction='rtl'][data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li ul {\n\t\tleft: auto;\n\t\tright: 105%;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li:hover > ul {\n\t\tdisplay: block;\n\t\tleft: 100%;\n\t\tpadding: 1rem 0;\n\t\tmargin-left: 0;\n\t\tborder: 0;\n\t\tbox-shadow: 0.3125rem 0.3125rem 1.875rem 0rem rgba(20, 0, 30, 0.1);\n\t\tborder-radius: 0.375rem;\n\t}\n\t[data-theme-version='dark'][data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li:hover > ul {\n\t\tbox-shadow: 0.3125rem 0.3125rem 1.875rem 0rem rgba(20, 0, 30, 0.1);\n\t}\n\t[direction='rtl'][data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .metismenu li:hover > ul {\n\t\tleft: auto;\n\t\tright: 100%;\n\t\tbox-shadow: -0.3125rem 0.3125rem 1.875rem 0rem rgba(20, 0, 30, 0.1);\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .nav-label {\n\t\tdisplay: none;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .nav-text {\n\t\tdisplay: block;\n\t\tmargin-top: 0;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .dlabnav .header-profile2 {\n\t\tpadding: 0 2.5rem;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .nav-control {\n\t\tright: -4.25rem;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .header .header-content {\n\t\tpadding-left: 0rem;\n\t\tleft: 13.6rem;\n\t\twidth: calc(100% - 18.75rem);\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .menu-toggle .dlabnav,\n\t[data-sidebar-style='modern'][data-layout='vertical'] .menu-toggle .nav-header {\n\t\tleft: -10.625rem;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .menu-toggle .header {\n\t\tpadding-left: 0;\n\t}\n\t[data-sidebar-style='modern'][data-layout='vertical'] .menu-toggle .content-body {\n\t\tmargin-left: 0;\n\t}\n\t[data-sidebar-style='modern'][data-layout='horizontal'] .nav-header {\n\t\twidth: 17.05rem;\n\t}\n\t[data-sidebar-style='modern'][data-layout='horizontal'] .footer,\n\t[data-sidebar-style='modern'][data-layout='horizontal'] .content-body {\n\t\tmargin-left: 0;\n\t}\n\t[data-sidebar-style='modern'][data-layout='horizontal'] .footer.footer-outer,\n\t[data-sidebar-style='modern'][data-layout='horizontal'] .content-body.footer-outer {\n\t\twidth: calc(100% - 25.225rem);\n\t\tmargin-left: 1.775rem !important;\n\t}\n\t[data-sidebar-style='modern'][data-layout='horizontal'] .footer.style-2,\n\t[data-sidebar-style='modern'][data-layout='horizontal'] .content-body.style-2 {\n\t\twidth: calc(100% - 3.225rem);\n\t\tmargin-left: 1.775rem !important;\n\t}\n\t[data-sidebar-style='modern'][data-layout='horizontal'] .footer.style-1,\n\t[data-sidebar-style='modern'][data-layout='horizontal'] .content-body.style-1 {\n\t\twidth: calc(100% - 22.225rem);\n\t\tmargin-left: 1.775rem !important;\n\t}\n\t[data-sidebar-style='modern'][data-layout='horizontal'] .dlabnav .metismenu > li > a {\n\t\tpadding: 0.9375rem 1.5625rem 0.75rem 1.4625rem;\n\t\tmargin: 0 0.125rem;\n\t}\n\t[data-sidebar-style='modern'][data-layout='horizontal'] .dlabnav .metismenu > li > ul {\n\t\ttop: 4.8rem;\n\t}\n\t[data-sidebar-style='modern'][data-layout='horizontal'][data-container='boxed'] .dlabnav .metismenu > li > a {\n\t\tpadding: 0.8125rem 1.25rem;\n\t}\n}\n\n[data-container='boxed'][data-layout='vertical'] .header .header-content,\n[data-container='boxed'][data-sidebar-style='modern'] .header .header-content,\n[data-container='wide-boxed'][data-layout='vertical'] .header .header-content,\n[data-container='wide-boxed'][data-sidebar-style='modern'] .header .header-content {\n\tpadding-left: 0rem;\n\twidth: calc(100% - 0.1rem);\n}\n\n[data-container='wide-boxed'] .header-content {\n\tpadding-left: 5.2rem !important;\n}\n\n[data-container='boxed'][data-sidebar-style='modern'][data-layout='horizontal'] .header .header-content {\n\twidth: calc(100% - 16.7rem);\n}\n\n[data-container='boxed'][data-sidebar-style='modern'][data-layout='horizontal'] .content-body {\n\tpadding-top: 15rem;\n}\n\n[data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav {\n\tborder-radius: 0 0 0 0 !important;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t[data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav {\n\t\tborder-radius: 0 0 0 0 !important;\n\t}\n}\n\n[data-sidebar-style='overlay'][data-layout='vertical'] .nav-header {\n\tborder-radius: 0;\n}\n\n[data-sidebar-style='overlay'][data-layout='vertical'] .menu-toggle .nav-header {\n\tborder-radius: 0 0 0 0;\n}\n\n[data-sidebar-style='overlay'] .dlabnav {\n\tleft: -100%;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n\t/* @include respond ('phone-land'){\n\t\t\t.metismenu{\n\t\t\t\t&>li{\n\t\t\t\t\t&>a{\n\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\tpadding: 0.75rem 0.875rem;\n\t\t\t\t\t\ti{\n\t\t\t\t\t\t\tfont-size:1.125rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:hover{\n\t\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tul li a{\n\t\t\t\t\tpadding-left:2.8rem;\n\t\t\t\t}\n\t\t\t}\n\t\t} */\n}\n[data-sidebar-style='overlay'] .dlabnav .metismenu > li {\n\tpadding: 0 1rem;\n}\n[data-sidebar-style='overlay'] .dlabnav .metismenu > li > a {\n\tfont-size: 0.938rem;\n\tpadding: 0.7375rem 1rem;\n\tcolor: #7f7184;\n\tborder-radius: 0.375rem;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n}\n[data-sidebar-style='overlay'] .dlabnav .metismenu > li > a i {\n\theight: auto;\n\twidth: auto;\n\tline-height: 1;\n}\n[data-sidebar-style='overlay'] .dlabnav .metismenu > li:hover > a {\n\tcolor: var(--primary);\n}\n[data-sidebar-style='overlay'] .dlabnav .metismenu > li:hover > a i {\n\tcolor: var(--primary);\n}\n[data-sidebar-style='overlay'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: var(--primary);\n\tcolor: #fff;\n}\n[data-sidebar-style='overlay'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t[data-sidebar-style='overlay'] .dlabnav .metismenu > li {\n\t\tpadding: 0rem 0.9375rem;\n\t}\n}\n[data-sidebar-style='overlay'] .dlabnav .metismenu ul a {\n\tpadding-top: 0.5rem;\n\tpadding-bottom: 0.5rem;\n\tposition: relative;\n\tfont-size: 0.9375rem;\n\tpadding-left: 3.2rem;\n}\n[data-sidebar-style='overlay'] .dlabnav .metismenu ul a:before {\n\tleft: 1.5625rem;\n}\n[direction='rtl'][data-sidebar-style='overlay'] .dlabnav {\n\tleft: auto;\n\tright: -100%;\n}\n\n[data-sidebar-style='overlay'] .content-body {\n\tmargin-left: 0;\n}\n\n[data-sidebar-style='overlay'] .nav-header {\n\tposition: absolute;\n}\n[data-sidebar-style='overlay'] .nav-header .hamburger.is-active {\n\tleft: 0;\n}\n[data-sidebar-style='overlay'] .nav-header .hamburger.is-active .line {\n\tbackground-color: var(--primary);\n\topacity: 1;\n}\n\n[data-sidebar-style='overlay'] .menu-toggle .nav-header {\n\tposition: absolute;\n\tleft: auto;\n}\n\n[data-sidebar-style='overlay'] .menu-toggle .dlabnav {\n\tleft: 0;\n}\n[direction='rtl'][data-sidebar-style='overlay'] .menu-toggle .dlabnav {\n\tleft: auto;\n\tright: 0;\n}\n\n[data-sidebar-style='overlay'] .footer {\n\tpadding-left: 0;\n}\n[data-sidebar-style='overlay'] .footer.footer-outer {\n\twidth: calc(100% - 25.225rem);\n}\n[data-sidebar-style='overlay'] .footer.style-2 {\n\twidth: calc(100% - 3.925rem);\n}\n[data-sidebar-style='overlay'] .footer.style-1 {\n\twidth: calc(100% - 22.325rem);\n\tmargin-right: 20.475rem;\n}\n\n[data-sidebar-style='overlay'][data-header-position='fixed'] .nav-header {\n\tposition: fixed;\n}\n\n[data-sidebar-position='fixed'][data-header-position='fixed'] .nav-header {\n\tposition: fixed;\n}\n\n[data-sidebar-position='fixed'][data-layout='vertical'] .nav-header {\n\tposition: fixed;\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n}\n\n[data-sidebar-position='fixed'][data-layout='vertical'] .dlabnav {\n\tposition: fixed;\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n[data-sidebar-position='fixed'][data-layout='vertical'] .dlabnav .dlabnav-scroll {\n\tborder-top-left-radius: 0rem;\n\tborder-top-right-radius: 0rem;\n}\n\n[data-sidebar-position='fixed'][data-layout='vertical'] .menu-toggle .dlabnav {\n\tposition: fixed;\n}\n\n[data-layout='vertical'] .nav-header {\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n}\n\n[data-layout='vertical'] .dlabnav {\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n[data-sidebar-style='icon-hover'][data-layout='vertical'][data-container='wide-boxed'] .dlabnav,\n[data-sidebar-style='icon-hover'][data-layout='vertical'][data-container='boxed'] .dlabnav,\n[data-header-position='fixed'][data-sidebar-position='fixed'][data-sidebar-style='icon-hover'][data-layout='vertical'][data-container='wide-boxed']\n\t.dlabnav,\n[data-header-position='fixed'][data-sidebar-position='fixed'][data-sidebar-style='icon-hover'][data-layout='vertical'][data-container='boxed']\n\t.dlabnav,\n[data-sidebar-style='overlay'][data-layout='vertical'][data-container='wide-boxed'] .dlabnav,\n[data-sidebar-style='overlay'][data-layout='vertical'][data-container='boxed'] .dlabnav,\n[data-header-position='fixed'][data-sidebar-position='fixed'][data-sidebar-style='overlay'][data-layout='vertical'][data-container='wide-boxed']\n\t.dlabnav,\n[data-header-position='fixed'][data-sidebar-position='fixed'][data-sidebar-style='overlay'][data-layout='vertical'][data-container='boxed']\n\t.dlabnav {\n\tposition: absolute;\n}\n\n.sidebar-right-trigger {\n\tposition: absolute;\n\tz-index: 9;\n\ttop: 14.75rem;\n\tright: 100%;\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n\tdisplay: inline-block;\n\theight: 3rem;\n\twidth: 3rem;\n\ttext-align: center;\n\tfont-size: 1.75rem;\n\tline-height: 3rem;\n\tborder-radius: 0.3125rem 0 0 0.3125rem;\n}\n[data-theme-version='dark'] .sidebar-right-trigger {\n\tcolor: #fff;\n}\n@media only screen and (max-width: 64rem) {\n\t.sidebar-right-trigger {\n\t\tdisplay: none;\n\t}\n}\n.sidebar-right-trigger:hover {\n\tcolor: #fff;\n}\n\n.sidebar-right {\n\tright: -50rem;\n\tposition: fixed;\n\ttop: 0;\n\twidth: 50rem;\n\tbackground-color: #fff;\n\tmargin-top: 3.5rem;\n\ttransition: all 0.5s ease-in-out;\n\tborder-radius: 0.375rem;\n\tz-index: 9999;\n}\n.sidebar-right .note-text {\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\tpadding: 20px;\n\topacity: 0.7;\n\tfont-size: 12px;\n}\n.sidebar-right .bg-label-pattern {\n\tbackground: transparent;\n\tbackground-image: url('../images/pattern/pattern5.png');\n\tbackground-size: 130%;\n}\n.sidebar-right .bootstrap-select {\n\theight: 3rem;\n\tborder-radius: 0.375rem;\n}\n.sidebar-right .bootstrap-select .btn {\n\tpadding: 0.75rem 0.9375rem;\n\tfont-size: 0.9375rem;\n\tborder-color: #d1d1d1;\n\tborder-radius: 0.375rem;\n}\n[direction='rtl'] .sidebar-right .slimScrollDiv {\n\toverflow: visible !important;\n}\n.sidebar-right .sidebar-close-trigger {\n\tposition: absolute;\n\tz-index: 2;\n\tfont-size: 1.75rem;\n\ttop: 0;\n\tright: -3rem;\n\theight: 3rem;\n\twidth: 3rem;\n\tline-height: 3rem;\n\ttext-align: center;\n\tbackground: black;\n\tcolor: #fff;\n}\n.sidebar-right.show {\n\tright: 5.25rem;\n\tbox-shadow: 0rem 0rem 3.125rem rgba(0, 0, 0, 0.2);\n\tz-index: 9999;\n}\n.sidebar-right.show .bg-overlay {\n\tposition: fixed;\n\twidth: 100%;\n\tcursor: pointer;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n\tbackground: rgba(0, 0, 0, 0.2);\n}\n.sidebar-right .card-tabs .nav-tabs {\n\tjustify-content: space-between;\n\tposition: sticky;\n\ttop: 0;\n\twidth: 100%;\n\tbackground-color: #fff;\n\tz-index: 2;\n\tborder-bottom: 4px solid var(--rgba-primary-1);\n}\n.sidebar-right .card-tabs .nav-tabs .nav-item {\n\tmargin-bottom: 0;\n\tflex: 1;\n}\n.sidebar-right .card-tabs .nav-tabs .nav-item .nav-link {\n\tborder: 0;\n\tfont-size: 1.125rem;\n\tposition: relative;\n\ttext-align: center;\n\tbackground-color: #fff;\n\tborder-radius: 0;\n\tmargin: 0;\n}\n.sidebar-right .card-tabs .nav-tabs .nav-item .nav-link.active {\n\tbackground: var(--rgba-primary-1);\n\tcolor: #000;\n}\n[data-theme-version='dark'] .sidebar-right .card-tabs .nav-tabs .nav-item .nav-link.active {\n\tborder-right: none;\n\tborder-left: none;\n\tborder-top: none;\n}\n.sidebar-right .sidebar-right-inner > h4,\n.sidebar-right .sidebar-right-inner > .h4 {\n\tpadding: 0.625rem 1.25rem;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tcolor: #000;\n\tbackground: #fff;\n\tmargin: 0rem 0rem 0rem 0rem;\n}\n.sidebar-right .tab-content {\n\tpadding: 1.25rem 1.25rem 0;\n\tmin-height: 480px;\n\tbackground: #fff;\n}\n.sidebar-right .tab-content .tab-pane .admin-settings .row > div {\n\tmargin-bottom: 1.25rem;\n}\n.sidebar-right .tab-content .tab-pane .admin-settings p {\n\tcolor: #353535;\n\tfont-weight: 500;\n\tmargin-bottom: 0.5rem;\n\tfont-size: 1rem;\n}\n.sidebar-right .tab-content .tab-pane .admin-settings input[type='radio'] {\n\tdisplay: none;\n}\n.sidebar-right .tab-content .tab-pane .admin-settings input[type='radio'] + label {\n\tdisplay: inline-block;\n\twidth: 2.1875rem;\n\theight: 2.1875rem;\n\tcursor: pointer;\n\ttransition: all 0.1s ease;\n\tborder-radius: 0.25rem;\n\tmargin-right: 0.3125rem;\n\tmargin-bottom: 0.1875rem;\n}\n.sidebar-right .tab-content .tab-pane .admin-settings input[type='radio']:checked + label {\n\tposition: relative;\n}\n.sidebar-right .tab-content .tab-pane .admin-settings input[type='radio']:checked + label::after {\n\theight: 2.0625rem;\n\twidth: 2.0625rem;\n\tleft: -0.25rem;\n\ttop: -0.25rem;\n\tcontent: '';\n\tposition: absolute;\n\tbackground-color: inherit;\n\tborder-radius: 0.375rem;\n\topacity: 0.4;\n}\n.sidebar-right #nav_header_color_1 + label,\n.sidebar-right #header_color_1 + label,\n.sidebar-right #sidebar_color_1 + label,\n.sidebar-right #primary_color_1 + label {\n\tbackground-color: #fff;\n}\n.sidebar-right #nav_header_color_2 + label,\n.sidebar-right #header_color_2 + label,\n.sidebar-right #sidebar_color_2 + label,\n.sidebar-right #primary_color_2 + label {\n\tbackground-color: #4d44b5;\n}\n.sidebar-right #nav_header_color_3 + label,\n.sidebar-right #header_color_3 + label,\n.sidebar-right #sidebar_color_3 + label,\n.sidebar-right #primary_color_3 + label {\n\tbackground-color: #056468;\n}\n.sidebar-right #nav_header_color_4 + label,\n.sidebar-right #header_color_4 + label,\n.sidebar-right #sidebar_color_4 + label,\n.sidebar-right #primary_color_4 + label {\n\tbackground-color: #4d06a5;\n}\n.sidebar-right #nav_header_color_5 + label,\n.sidebar-right #header_color_5 + label,\n.sidebar-right #sidebar_color_5 + label,\n.sidebar-right #primary_color_5 + label {\n\tbackground-color: #dc3545;\n}\n.sidebar-right #nav_header_color_6 + label,\n.sidebar-right #header_color_6 + label,\n.sidebar-right #sidebar_color_6 + label,\n.sidebar-right #primary_color_6 + label {\n\tbackground-color: #fd7e14;\n}\n.sidebar-right #nav_header_color_7 + label,\n.sidebar-right #header_color_7 + label,\n.sidebar-right #sidebar_color_7 + label,\n.sidebar-right #primary_color_7 + label {\n\tbackground-color: #5155c3;\n}\n.sidebar-right #nav_header_color_8 + label,\n.sidebar-right #header_color_8 + label,\n.sidebar-right #sidebar_color_8 + label,\n.sidebar-right #primary_color_8 + label {\n\tbackground-color: #854df3;\n}\n.sidebar-right #nav_header_color_9 + label,\n.sidebar-right #header_color_9 + label,\n.sidebar-right #sidebar_color_9 + label,\n.sidebar-right #primary_color_9 + label {\n\tbackground-color: #20c997;\n}\n.sidebar-right #nav_header_color_10 + label,\n.sidebar-right #header_color_10 + label,\n.sidebar-right #sidebar_color_10 + label,\n.sidebar-right #primary_color_10 + label {\n\tbackground-color: #17a2b8;\n}\n.sidebar-right #nav_header_color_11 + label,\n.sidebar-right #header_color_11 + label,\n.sidebar-right #sidebar_color_11 + label,\n.sidebar-right #primary_color_11 + label {\n\tbackground-color: #94618e;\n}\n.sidebar-right #nav_header_color_12 + label,\n.sidebar-right #header_color_12 + label,\n.sidebar-right #sidebar_color_12 + label,\n.sidebar-right #primary_color_12 + label {\n\tbackground-color: #00273a;\n}\n.sidebar-right #nav_header_color_13 + label,\n.sidebar-right #header_color_13 + label,\n.sidebar-right #sidebar_color_13 + label,\n.sidebar-right #primary_color_13 + label {\n\tbackground-color: #432d29;\n}\n.sidebar-right #nav_header_color_14 + label,\n.sidebar-right #header_color_14 + label,\n.sidebar-right #sidebar_color_14 + label,\n.sidebar-right #primary_color_14 + label {\n\tbackground-color: #4885ed;\n}\n.sidebar-right #nav_header_color_15 + label,\n.sidebar-right #header_color_15 + label,\n.sidebar-right #sidebar_color_15 + label,\n.sidebar-right #primary_color_15 + label {\n\tbackground-color: #4cb32b;\n}\n.sidebar-right #nav_header_color_1 + label,\n.sidebar-right #header_color_1 + label,\n.sidebar-right #sidebar_color_1 + label,\n.sidebar-right #primary_color_1 + label {\n\tborder: 0.0625rem solid #c4c4c4;\n}\n.sidebar-right.style-1 {\n\theight: 100vh;\n\twidth: 15.625rem;\n\tmargin-top: 0;\n\tright: -15.625rem;\n}\n.sidebar-right.style-1 .sidebar-right-inner {\n\tbackground: #fff;\n}\n.sidebar-right.style-1 .sidebar-right-trigger {\n\ttop: 12.4rem;\n}\n.sidebar-right.style-1.show {\n\tright: 0;\n}\n.sidebar-right.style-1.show .sidebar-right-trigger {\n\tdisplay: block;\n}\n\n.nice-select.wide {\n\tline-height: 2.8125rem;\n}\n\n@keyframes bounce {\n\t0% {\n\t\ttransform: translateX(-8%);\n\t\t-webkit-transform: translateX(-8%);\n\t}\n\t50% {\n\t\ttransform: translateX(8%);\n\t\t-webkit-transform: translateX(8%);\n\t}\n\t100% {\n\t\ttransform: translateX(-8%);\n\t\t-webkit-transform: translateX(-8%);\n\t}\n}\n\n@-webkit-keyframes bounce {\n\t0% {\n\t\ttransform: translateX(-8%);\n\t\t-webkit-transform: translateX(-8%);\n\t}\n\t50% {\n\t\ttransform: translateX(8%);\n\t\t-webkit-transform: translateX(8%);\n\t}\n\t100% {\n\t\ttransform: translateY(-8%);\n\t\t-webkit-transform: translateY(-8%);\n\t}\n}\n\n@media only screen and (max-width: 87.5rem) {\n\t.nice-select.wide {\n\t\tline-height: 2rem;\n\t}\n}\n\n.nav-user {\n\tbackground: var(--primary);\n\tmargin-bottom: 0.625rem;\n\tpadding: 1.25rem 1.5625rem 0.9375rem;\n}\n@media only screen and (min-width: 48rem) and (max-width: 74.9375rem) {\n\t.nav-user {\n\t\tpadding: 1.25rem 0.9375rem 0.9375rem;\n\t}\n}\n.nav-user img {\n\twidth: 2.1875rem;\n\theight: 2.1875rem;\n}\n@media only screen and (min-width: 48rem) and (max-width: 74.9375rem) {\n\t.nav-user img {\n\t\twidth: 2.1875rem;\n\t\theight: 2.1875rem;\n\t\tmargin-bottom: 0.625rem;\n\t}\n}\n.nav-user h5,\n.nav-user .h5 {\n\tmargin-left: 0.625rem;\n\tmargin-bottom: 0.1875rem;\n\tcolor: #fff;\n}\n@media only screen and (min-width: 48rem) and (max-width: 74.9375rem) {\n\t.nav-user h5,\n\t.nav-user .h5 {\n\t\tdisplay: none;\n\t}\n}\n[data-sibebarbg='color_2'] .nav-user h5,\n[data-sibebarbg='color_2'] .nav-user .h5 {\n\tcolor: #fff;\n}\n.nav-user p {\n\tmargin-left: 0.625rem;\n\tmargin-bottom: 0.5rem;\n\tcolor: #afcff7;\n}\n@media only screen and (min-width: 48rem) and (max-width: 74.9375rem) {\n\t.nav-user p {\n\t\tdisplay: none;\n\t}\n}\n@media only screen and (min-width: 48rem) and (max-width: 74.9375rem) {\n\t.nav-user i {\n\t\tmargin-top: 0.9375rem;\n\t\tdisplay: block;\n\t}\n}\n\n.menu-toggle .nav-user {\n\tpadding: 1.25rem 0.9375rem 0.9375rem;\n}\n.menu-toggle .nav-user img {\n\twidth: 2.1875rem;\n\theight: 2.1875rem;\n\tmargin-bottom: 0.625rem;\n}\n.menu-toggle .nav-user h5,\n.menu-toggle .nav-user .h5,\n.menu-toggle .nav-user p {\n\tdisplay: none;\n}\n.menu-toggle .nav-user i {\n\tmargin-top: 0.9375rem;\n\tdisplay: block;\n}\n.menu-toggle .nav-user .dropdown-menu {\n\tleft: 2.8125rem !important;\n\ttop: 1.375rem !important;\n}\n\n.chatbox {\n\twidth: 21.25rem;\n\theight: 100vh;\n\tposition: fixed;\n\tright: -31.25rem;\n\ttop: 0;\n\tz-index: 1004;\n\tbackground: #fff;\n\tbox-shadow: 0rem 0rem 1.875rem 0rem rgba(82, 63, 105, 0.15);\n\t-webkit-transition: all 0.8s;\n\t-ms-transition: all 0.8s;\n\ttransition: all 0.8s;\n}\n[data-theme-version='dark'] .chatbox {\n\tbackground: #272738;\n}\n.chatbox .chatbox-close {\n\tposition: absolute;\n\t-webkit-transition: all 0.2s;\n\t-ms-transition: all 0.2s;\n\ttransition: all 0.2s;\n\twidth: 0;\n\theight: 100%;\n\tright: 21.25rem;\n\tbackground: #000;\n\tz-index: 1;\n\topacity: 0.1;\n\tcursor: pointer;\n}\n.chatbox .card-fotter {\n\tpadding: 0.75rem 1rem;\n}\n.chatbox .card-body {\n\tpadding: 1rem;\n}\n.chatbox.active {\n\tright: 0;\n}\n.chatbox.active .chatbox-close {\n\twidth: 100vw;\n}\n.chatbox .type_msg {\n\tpadding-top: 0.625rem;\n}\n.chatbox .type_msg .input-group {\n\talign-items: center;\n}\n.chatbox .nav {\n\tpadding: 1rem 1rem 0 1rem;\n\tbackground: var(--rgba-primary-1);\n\tborder: 0;\n\tjustify-content: space-between;\n}\n.chatbox .nav .nav-link {\n\tcolor: var(--primary);\n\topacity: 0.7;\n\ttext-transform: uppercase;\n}\n.chatbox .nav .nav-link:hover,\n.chatbox .nav .nav-link.active {\n\tbackground: transparent;\n\tcolor: var(--primary);\n\topacity: 1;\n\tborder-color: var(--primary);\n}\n.chatbox .img_cont {\n\twidth: 2.5rem;\n\tborder-radius: 2.5rem;\n\tmargin-right: 0.625rem;\n\tposition: relative;\n\theight: 2.5rem;\n\tbackground: #eee;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: 600;\n\tfont-size: 0.875rem;\n\tmin-width: 2.5rem;\n\tmin-height: 2.5rem;\n}\n.chatbox .img_cont .icon {\n\tcolor: #fff;\n}\n.chatbox .img_cont.primary {\n\tbackground: var(--rgba-primary-1);\n\tcolor: var(--primary);\n}\n[data-theme-version='dark'] .chatbox .img_cont.primary {\n\tbackground: var(--rgba-primary-1);\n}\n.chatbox .img_cont.warning {\n\tbackground: #fffaee;\n\tcolor: #fcc43e;\n}\n[data-theme-version='dark'] .chatbox .img_cont.warning {\n\tbackground: rgba(252, 196, 62, 0.1);\n}\n.chatbox .img_cont.success {\n\tbackground: #ddfaea;\n\tcolor: #1eba62;\n}\n[data-theme-version='dark'] .chatbox .img_cont.success {\n\tbackground: rgba(30, 186, 98, 0.1);\n}\n.chatbox .img_cont.info {\n\tbackground: #94fff9;\n\tcolor: #00ada3;\n}\n[data-theme-version='dark'] .chatbox .img_cont.info {\n\tbackground: rgba(0, 173, 163, 0.1);\n}\n.chatbox .img_cont img {\n\twidth: 100%;\n}\n.chatbox .img_cont .online_icon {\n\tbackground: #1eba62;\n\tposition: absolute;\n\twidth: 0.75rem;\n\theight: 0.75rem;\n\tborder-radius: 0.9375rem;\n\tright: -0.0625rem;\n\tbottom: 0rem;\n\tborder: 0.125rem solid #fff;\n}\n.chatbox .img_cont .online_icon.offline {\n\tbackground: #fd5353;\n}\n.chatbox .card {\n\tbox-shadow: none;\n}\n.chatbox .search {\n\theight: 2.5rem;\n}\n.chatbox .user_info span {\n\tfont-size: 0.9375rem;\n\tcolor: #000;\n\tdisplay: block;\n\tfont-weight: 500;\n\tline-height: 1;\n\tmargin-bottom: 0.3125rem;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tdisplay: block;\n\tmax-width: 10.625rem;\n}\n[data-theme-version='dark'] .chatbox .user_info span {\n\tcolor: #fff;\n}\n.chatbox .user_info p {\n\tfont-size: 0.8125rem;\n\tmargin-bottom: 0;\n\tline-height: 1;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\tdisplay: block;\n\tmax-width: 10.625rem;\n}\n.chatbox .contacts li {\n\tpadding: 0.4375rem 1rem;\n\tborder-bottom: 0.0625rem solid #eee;\n\tcursor: pointer;\n}\n[data-theme-version='dark'] .chatbox .contacts li {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n.chatbox .contacts li > div {\n\tdisplay: flex;\n\talign-items: center;\n}\n.chatbox .contacts li:hover {\n\tbackground: #f4f7ff;\n}\n[data-theme-version='dark'] .chatbox .contacts li:hover {\n\tbackground-color: #202020;\n}\n.chatbox .contacts .name-first-letter {\n\tbackground: #e6ebee;\n\tpadding: 0.25rem 1rem;\n\tfont-weight: 700;\n\tcolor: #000;\n\tposition: sticky;\n\ttop: 0;\n\tz-index: 1;\n}\n[data-theme-version='dark'] .chatbox .contacts .name-first-letter {\n\tcolor: #fff;\n\tbackground: #202020;\n}\n.chatbox .msg_card_body {\n\theight: calc(100vh - 195px);\n}\n.chatbox .contacts_body {\n\theight: calc(100vh - 120px);\n}\n.chatbox .card-header {\n\tbackground: #f4f7ff;\n\tpadding: 0.9375rem 1.25rem;\n\tjustify-content: center;\n}\n.chatbox .card-header h6,\n.chatbox .card-header .h6 {\n\tfont-size: 0.9375rem;\n}\n.chatbox .card-header p {\n\tline-height: 1.2;\n\tfont-size: 0.75rem;\n\tcolor: #a098ae;\n}\n.chatbox .chat-list-header {\n\tjustify-content: space-between;\n\tbackground: #fff;\n}\n[data-theme-version='dark'] .chatbox .chat-list-header {\n\tbackground: #272738;\n}\n.chatbox .chat-list-header a {\n\ttext-align: center;\n\twidth: 1.875rem;\n\theight: 1.875rem;\n\tbackground: #e6ebee;\n\tborder-radius: 0.375rem;\n\tline-height: 1.675rem;\n\tdisplay: block;\n}\n[data-theme-version='dark'] .chatbox .chat-list-header a {\n\tbackground: var(--rgba-primary-1);\n}\n[data-theme-version='dark'] .chatbox .chat-list-header a svg g [fill] {\n\tfill: #fff;\n}\n.chatbox .img_cont_msg {\n\twidth: 1.875rem;\n\theight: 1.875rem;\n\tdisplay: block;\n\tmax-width: 1.875rem;\n\tmin-width: 1.875rem;\n}\n.chatbox .img_cont_msg img {\n\twidth: 100%;\n}\n.chatbox .msg_cotainer {\n\tbackground: var(--primary);\n\tmargin-left: 0.625rem;\n\tborder-radius: 0 0.375rem 0.375rem 0.375rem;\n\tpadding: 0.625rem 0.9375rem;\n\tcolor: #fff;\n\tposition: relative;\n}\n.chatbox .msg_cotainer .msg_time {\n\tdisplay: block;\n\tfont-size: 0.6875rem;\n\tcolor: #fff;\n\tmargin-top: 0.3125rem;\n\topacity: 0.5;\n}\n.chatbox .msg_cotainer:after {\n\tcontent: '';\n\tposition: absolute;\n\tleft: -0.625rem;\n\tborder-right: 0.625rem solid var(--primary);\n\tborder-bottom: 0.625rem solid transparent;\n\tborder-top: 0rem solid;\n\ttop: 0;\n}\n.chatbox .msg_cotainer_send {\n\tbackground: #e6ebee;\n\tpadding: 0.625rem 0.9375rem;\n\tborder-radius: 0.375rem 0rem 0.375rem 0.375rem;\n\tmargin-right: 0.625rem;\n\tcolor: #222;\n\tposition: relative;\n\ttext-align: right;\n}\n[data-theme-version='dark'] .chatbox .msg_cotainer_send {\n\tbackground: #202020;\n\tcolor: #fff;\n}\n.chatbox .msg_cotainer_send .msg_time_send {\n\tdisplay: block;\n\tfont-size: 0.6875rem;\n\ttext-align: right;\n\tmargin-top: 0.3125rem;\n\topacity: 0.6;\n}\n.chatbox .msg_cotainer_send:after {\n\tcontent: '';\n\tposition: absolute;\n\tright: -0.625rem;\n\tborder-left: 0.625rem solid #e6ebee;\n\tborder-bottom: 0.625rem solid transparent;\n\tborder-top: 0rem solid;\n\ttop: 0;\n}\n[data-theme-version='dark'] .chatbox .msg_cotainer_send:after {\n\tborder-left: 0.625rem solid #202020;\n}\n.chatbox .type_msg .form-control {\n\tpadding: 0.625rem 14px;\n\theight: 3.125rem;\n\tborder: 0;\n\tresize: none;\n\tline-height: unset;\n}\n.chatbox .type_msg .form-control:focus {\n\tz-index: 0;\n}\n.chatbox .type_msg .btn {\n\tfont-size: 1.125rem;\n\tborder-radius: 2.375rem !important;\n\twidth: 2.375rem;\n\theight: 2.375rem;\n\tpadding: 0;\n\tmargin-top: -22px;\n\tline-height: 1px;\n}\n.chatbox .video_cam {\n\tmargin-left: 0.9375rem;\n}\n.chatbox .video_cam span {\n\twidth: 2.1875rem;\n\theight: 2.1875rem;\n\tbackground: #10ca93;\n\ttext-align: center;\n\tline-height: 2.1875rem;\n\tborder-radius: 2.1875rem;\n\tcolor: #fff;\n\tmargin-right: 0.3125rem;\n\talign-self: center;\n\tfont-size: 1rem;\n\tpadding: 0 0.1875rem;\n\tdisplay: inline-block;\n}\n.chatbox .note_card .contacts li {\n\tpadding: 0.75rem 1rem;\n}\n\n@media only screen and (max-width: 36rem) {\n\t.chatbox {\n\t\twidth: 17.5rem;\n\t}\n\t.chatbox .chatbox-close {\n\t\tright: 17.5rem;\n\t}\n}\n\n.bd-highlight a.sharp {\n\tmargin-bottom: 0.5rem;\n\tdisplay: inline-block;\n}\n\n.dlab-demo-panel {\n\tright: -23.75rem;\n\tposition: fixed;\n\ttop: 0;\n\twidth: 23.75rem;\n\tbackground-color: #fff;\n\theight: 100vh;\n\ttransition: all 0.5s ease-in-out;\n\tz-index: 9999;\n}\n.dlab-demo-panel .dlab-demo-trigger {\n\tposition: absolute;\n\tz-index: 9;\n\ttop: 21.75rem;\n\tright: 100%;\n\tbackground-color: #627eea;\n\tcolor: #fff;\n\tdisplay: inline-block;\n\theight: 3rem;\n\twidth: 3rem;\n\ttext-align: center;\n\tfont-size: 1.75rem;\n\tline-height: 3rem;\n\tborder-radius: 0.3125rem 0 0 0.3125rem;\n\tbox-shadow: -0.3125rem 0.1875rem 0.3125rem 0rem rgba(119, 119, 119, 0.15);\n}\n@media only screen and (max-width: 63.9375rem) {\n\t.dlab-demo-panel .dlab-demo-trigger {\n\t\tdisplay: none;\n\t}\n}\n.dlab-demo-panel .dlab-demo-close {\n\theight: 1.875rem;\n\tcolor: #fff;\n\twidth: 1.875rem;\n\tborder-radius: 0.375rem;\n\tbackground: rgba(0, 0, 0, 0.5);\n\tline-height: 1.875rem;\n\ttext-align: center;\n}\n.dlab-demo-panel.show {\n\tright: 0;\n\tbox-shadow: 0rem 0rem 3.125rem rgba(0, 0, 0, 0.2);\n\tz-index: 99999;\n\toverflow: hidden;\n}\n.dlab-demo-panel.show .sidebar-right-trigger {\n\tdisplay: none;\n}\n.dlab-demo-panel.show .bg-close {\n\tposition: fixed;\n\tz-index: -2;\n\tcursor: pointer;\n\twidth: 100%;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n\tbackground: rgba(0, 0, 0, 0.15);\n}\n.dlab-demo-panel .dlab-demo-inner {\n\tpadding: 1.875rem 1.875rem;\n\tbackground: #fff;\n}\n.dlab-demo-panel .dlab-demo-content {\n\theight: calc(100vh - 210px);\n}\n.dlab-demo-panel .dlab-demo-header {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-bottom: 1.25rem;\n}\n.dlab-demo-panel .dlab-demo-header h4,\n.dlab-demo-panel .dlab-demo-header .h4 {\n\tmargin-bottom: 0;\n\tcolor: #000;\n}\n.dlab-demo-panel .dlab-demo-bx {\n\theight: 12.5rem;\n\toverflow: hidden;\n\tborder: 0.3125rem solid #efefef;\n\tbox-shadow: 0rem 0rem 0.3125rem rgba(0, 0, 0, 0.1);\n\tmargin-bottom: 0.625rem;\n\tborder-radius: 0.375rem;\n}\n.dlab-demo-panel .dlab-demo-bx.demo-active {\n\tborder-color: #fb7d5b;\n}\n.dlab-demo-panel .dlab-demo-bx.demo-active .overlay-layer {\n\topacity: 1;\n}\n.dlab-demo-panel .overlay-bx {\n\tposition: relative;\n}\n.dlab-demo-panel .overlay-bx .overlay-layer {\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tbackground-color: rgba(0, 0, 0, 0.1);\n\t-webkit-transition: all 0.3s ease;\n\ttransition: all 0.3s ease;\n\topacity: 0;\n}\n.dlab-demo-panel .overlay-bx:hover .overlay-layer {\n\t-webkit-transition: all 0.3s ease;\n\ttransition: all 0.3s ease;\n\topacity: 1;\n}\n\n:root {\n\t--right-space: 23.75rem;\n}\n\n.wallet-open .header .page-titles,\n.wallet-open .header .header-content {\n\tpadding-right: 1.875rem;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.wallet-open .header .page-titles,\n\t.wallet-open .header .header-content {\n\t\tpadding-right: 1.4rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.wallet-open .header .page-titles,\n\t.wallet-open .header .header-content {\n\t\tpadding-right: 1.1rem;\n\t}\n}\n\n.wallet-open .content-body {\n\tpadding-right: 0;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n}\n\n.wallet-open .wallet-bar {\n\tright: -26.25rem;\n}\n\n.wallet-open.active .header .page-titles,\n.wallet-open.active .header .header-content {\n\tpadding-right: var(--right-space);\n}\n@media only screen and (max-width: 87.5rem) {\n\t.wallet-open.active .header .page-titles,\n\t.wallet-open.active .header .header-content {\n\t\tpadding-right: 4.775rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.wallet-open.active .header .page-titles,\n\t.wallet-open.active .header .header-content {\n\t\tpadding-right: 12px;\n\t}\n}\n\n.wallet-open.active .content-body {\n\tpadding-right: calc(var(--right-space) - 1.75rem);\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.wallet-open.active .content-body {\n\t\tpadding-right: 0;\n\t}\n}\n\n.wallet-open.active .wallet-bar {\n\tright: 0rem;\n}\n\n.wallet-open.active .wallet-bar-close {\n\tposition: fixed;\n\twidth: 100%;\n\tcursor: pointer;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n\tbackground: rgba(0, 0, 0, 0.2);\n\tdisplay: block;\n\tz-index: 3;\n}\n/* @media only screen and (max-width: 87.5rem) {\n    .wallet-open.active .wallet-bar-close {\n      display: block;\n      z-index: 3; } }\n  @media only screen and (max-width: 35.9375rem) {\n    .wallet-open.active .wallet-bar-close {\n      z-index: 3; } } */\n\n.wallet-bar {\n\tposition: fixed;\n\tbox-sizing: content-box;\n\twidth: 22rem;\n\tpadding: 2.375rem 15px;\n\tpadding-top: 0.375rem;\n\tpadding-bottom: 0;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n\ttop: 0px;\n\tz-index: 999;\n\theight: 100%;\n\tscrollbar-width: none;\n\tbox-sizing: border-box;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.wallet-bar {\n\t\twidth: 23rem;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.wallet-bar {\n\t\tbackground: rgba(0, 0, 0, 0.2);\n\t\tbackdrop-filter: blur(5px);\n\t\tbox-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.25);\n\t\theight: 100vh;\n\t\toverflow-y: scroll;\n\t}\n}\n.wallet-bar .closed-icon {\n\theight: 25px;\n\twidth: 25px;\n\tcolor: #303972;\n\tfont-size: 20px;\n\tdisplay: block;\n\tmargin-bottom: 17px;\n\tcursor: pointer;\n\tdisplay: none;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.wallet-bar .closed-icon {\n\t\tdisplay: block;\n\t}\n}\n\n:root {\n\t--nav-headbg: #fff;\n\t--sidebar-bg: #fff;\n\t--headerbg: #e6ebee;\n}\n\n[data-nav-headerbg='color_2'][data-theme-version='dark'],\n[data-nav-headerbg='color_2'] {\n\t--nav-headbg: #4d44b5;\n}\n[data-nav-headerbg='color_2'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,\n[data-nav-headerbg='color_2'] .nav-header .brand-logo .logo-abbr path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_2'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,\n[data-nav-headerbg='color_2'] .nav-header .brand-logo .brand-title svg path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_2'][data-theme-version='dark'] .nav-header .hamburger .line,\n[data-nav-headerbg='color_2'] .nav-header .hamburger .line {\n\tbackground: #fff;\n}\n\n[data-nav-headerbg='color_3'][data-theme-version='dark'],\n[data-nav-headerbg='color_3'] {\n\t--nav-headbg: #056468;\n}\n[data-nav-headerbg='color_3'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,\n[data-nav-headerbg='color_3'] .nav-header .brand-logo .logo-abbr path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_3'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,\n[data-nav-headerbg='color_3'] .nav-header .brand-logo .brand-title svg path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_3'][data-theme-version='dark'] .nav-header .hamburger .line,\n[data-nav-headerbg='color_3'] .nav-header .hamburger .line {\n\tbackground: #fff;\n}\n\n[data-nav-headerbg='color_4'][data-theme-version='dark'],\n[data-nav-headerbg='color_4'] {\n\t--nav-headbg: #4d06a5;\n}\n[data-nav-headerbg='color_4'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,\n[data-nav-headerbg='color_4'] .nav-header .brand-logo .logo-abbr path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_4'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,\n[data-nav-headerbg='color_4'] .nav-header .brand-logo .brand-title svg path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_4'][data-theme-version='dark'] .nav-header .hamburger .line,\n[data-nav-headerbg='color_4'] .nav-header .hamburger .line {\n\tbackground: #fff;\n}\n\n[data-nav-headerbg='color_5'][data-theme-version='dark'],\n[data-nav-headerbg='color_5'] {\n\t--nav-headbg: #dc3545;\n}\n[data-nav-headerbg='color_5'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,\n[data-nav-headerbg='color_5'] .nav-header .brand-logo .logo-abbr path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_5'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,\n[data-nav-headerbg='color_5'] .nav-header .brand-logo .brand-title svg path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_5'][data-theme-version='dark'] .nav-header .hamburger .line,\n[data-nav-headerbg='color_5'] .nav-header .hamburger .line {\n\tbackground: #fff;\n}\n\n[data-nav-headerbg='color_6'][data-theme-version='dark'],\n[data-nav-headerbg='color_6'] {\n\t--nav-headbg: #fd7e14;\n}\n[data-nav-headerbg='color_6'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,\n[data-nav-headerbg='color_6'] .nav-header .brand-logo .logo-abbr path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_6'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,\n[data-nav-headerbg='color_6'] .nav-header .brand-logo .brand-title svg path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_6'][data-theme-version='dark'] .nav-header .hamburger .line,\n[data-nav-headerbg='color_6'] .nav-header .hamburger .line {\n\tbackground: #fff;\n}\n\n[data-nav-headerbg='color_7'][data-theme-version='dark'],\n[data-nav-headerbg='color_7'] {\n\t--nav-headbg: #5155c3;\n}\n[data-nav-headerbg='color_7'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,\n[data-nav-headerbg='color_7'] .nav-header .brand-logo .logo-abbr path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_7'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,\n[data-nav-headerbg='color_7'] .nav-header .brand-logo .brand-title svg path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_7'][data-theme-version='dark'] .nav-header .hamburger .line,\n[data-nav-headerbg='color_7'] .nav-header .hamburger .line {\n\tbackground: #fff;\n}\n\n[data-nav-headerbg='color_8'][data-theme-version='dark'],\n[data-nav-headerbg='color_8'] {\n\t--nav-headbg: #854df3;\n}\n[data-nav-headerbg='color_8'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,\n[data-nav-headerbg='color_8'] .nav-header .brand-logo .logo-abbr path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_8'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,\n[data-nav-headerbg='color_8'] .nav-header .brand-logo .brand-title svg path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_8'][data-theme-version='dark'] .nav-header .hamburger .line,\n[data-nav-headerbg='color_8'] .nav-header .hamburger .line {\n\tbackground: #fff;\n}\n\n[data-nav-headerbg='color_9'][data-theme-version='dark'],\n[data-nav-headerbg='color_9'] {\n\t--nav-headbg: #20c997;\n}\n[data-nav-headerbg='color_9'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,\n[data-nav-headerbg='color_9'] .nav-header .brand-logo .logo-abbr path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_9'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,\n[data-nav-headerbg='color_9'] .nav-header .brand-logo .brand-title svg path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_9'][data-theme-version='dark'] .nav-header .hamburger .line,\n[data-nav-headerbg='color_9'] .nav-header .hamburger .line {\n\tbackground: #fff;\n}\n\n[data-nav-headerbg='color_10'][data-theme-version='dark'],\n[data-nav-headerbg='color_10'] {\n\t--nav-headbg: #17a2b8;\n}\n[data-nav-headerbg='color_10'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,\n[data-nav-headerbg='color_10'] .nav-header .brand-logo .logo-abbr path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_10'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,\n[data-nav-headerbg='color_10'] .nav-header .brand-logo .brand-title svg path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_10'][data-theme-version='dark'] .nav-header .hamburger .line,\n[data-nav-headerbg='color_10'] .nav-header .hamburger .line {\n\tbackground: #fff;\n}\n\n[data-nav-headerbg='color_11'][data-theme-version='dark'],\n[data-nav-headerbg='color_11'] {\n\t--nav-headbg: #94618e;\n}\n[data-nav-headerbg='color_11'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,\n[data-nav-headerbg='color_11'] .nav-header .brand-logo .logo-abbr path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_11'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,\n[data-nav-headerbg='color_11'] .nav-header .brand-logo .brand-title svg path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_11'][data-theme-version='dark'] .nav-header .hamburger .line,\n[data-nav-headerbg='color_11'] .nav-header .hamburger .line {\n\tbackground: #fff;\n}\n\n[data-nav-headerbg='color_12'][data-theme-version='dark'],\n[data-nav-headerbg='color_12'] {\n\t--nav-headbg: #00273a;\n}\n[data-nav-headerbg='color_12'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,\n[data-nav-headerbg='color_12'] .nav-header .brand-logo .logo-abbr path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_12'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,\n[data-nav-headerbg='color_12'] .nav-header .brand-logo .brand-title svg path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_12'][data-theme-version='dark'] .nav-header .hamburger .line,\n[data-nav-headerbg='color_12'] .nav-header .hamburger .line {\n\tbackground: #fff;\n}\n\n[data-nav-headerbg='color_13'][data-theme-version='dark'],\n[data-nav-headerbg='color_13'] {\n\t--nav-headbg: #432d29;\n}\n[data-nav-headerbg='color_13'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,\n[data-nav-headerbg='color_13'] .nav-header .brand-logo .logo-abbr path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_13'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,\n[data-nav-headerbg='color_13'] .nav-header .brand-logo .brand-title svg path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_13'][data-theme-version='dark'] .nav-header .hamburger .line,\n[data-nav-headerbg='color_13'] .nav-header .hamburger .line {\n\tbackground: #fff;\n}\n\n[data-nav-headerbg='color_14'][data-theme-version='dark'],\n[data-nav-headerbg='color_14'] {\n\t--nav-headbg: #4885ed;\n}\n[data-nav-headerbg='color_14'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,\n[data-nav-headerbg='color_14'] .nav-header .brand-logo .logo-abbr path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_14'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,\n[data-nav-headerbg='color_14'] .nav-header .brand-logo .brand-title svg path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_14'][data-theme-version='dark'] .nav-header .hamburger .line,\n[data-nav-headerbg='color_14'] .nav-header .hamburger .line {\n\tbackground: #fff;\n}\n\n[data-nav-headerbg='color_15'][data-theme-version='dark'],\n[data-nav-headerbg='color_15'] {\n\t--nav-headbg: #4cb32b;\n}\n[data-nav-headerbg='color_15'][data-theme-version='dark'] .nav-header .brand-logo .logo-abbr path,\n[data-nav-headerbg='color_15'] .nav-header .brand-logo .logo-abbr path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_15'][data-theme-version='dark'] .nav-header .brand-logo .brand-title svg path,\n[data-nav-headerbg='color_15'] .nav-header .brand-logo .brand-title svg path {\n\tfill: #fff;\n}\n[data-nav-headerbg='color_15'][data-theme-version='dark'] .nav-header .hamburger .line,\n[data-nav-headerbg='color_15'] .nav-header .hamburger .line {\n\tbackground: #fff;\n}\n\n[data-sidebarbg='color_2'][data-theme-version='dark'],\n[data-sidebarbg='color_2'] {\n\t--sidebar-bg: #4d44b5;\n\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav,\n[data-sidebarbg='color_2'] .dlabnav {\n\tborder-color: #4d44b5;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu > li:after,\n[data-sidebarbg='color_2'] .dlabnav .metismenu > li:after {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,\n[data-sidebarbg='color_2'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #4d44b5 !important;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,\n[data-sidebarbg='color_2'] .dlabnav .metismenu ul a:before {\n\tbackground: rgba(255, 255, 255, 0.5);\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .header-info2,\n[data-sidebarbg='color_2'] .dlabnav .header-info2 {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_2'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_2'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_2'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_2'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_2'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_2'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_2'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_2'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {\n\tbackground-color: #6e66c6;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_2'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_2'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_2'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_2'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_2'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_2'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_2'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_2'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_2'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_2'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\ta:hover,\n[data-sidebarbg='color_2'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\t> a\n\t> i,\n[data-sidebarbg='color_2'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\tbackground: #554cbc !important;\n\tcolor: rgba(255, 255, 255, 0.7);\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_2'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_2'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\tbox-shadow: none;\n\tbackground: transparent !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_2'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a\n\ti,\n[data-sidebarbg='color_2'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_2'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\tbackground: #6e66c6 !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu a,\n[data-sidebarbg='color_2'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,\n[data-sidebarbg='color_2'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_2'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_2'] .dlabnav .metismenu li ul a.mm-active {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu > li > a,\n[data-sidebarbg='color_2'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,\n[data-sidebarbg='color_2'] .dlabnav .metismenu > li > a i {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_2'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_2'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,\n[data-sidebarbg='color_2'] .dlabnav .metismenu > li.mm-active > a:before {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,\n[data-sidebarbg='color_2'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .header-info2 span,\n[data-sidebarbg='color_2'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .sidebar-info,\n[data-sidebarbg='color_2'] .dlabnav .sidebar-info {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .dlabnav .sidebar-info i,\n[data-sidebarbg='color_2'] .dlabnav .sidebar-info i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .plus-box,\n[data-sidebarbg='color_2'] .plus-box {\n\tbackground-color: #6e66c6;\n}\n[data-sidebarbg='color_2'][data-theme-version='dark'] .copyright,\n[data-sidebarbg='color_2'] .copyright {\n\tcolor: #fff;\n}\n\n[data-sidebarbg='color_3'][data-theme-version='dark'],\n[data-sidebarbg='color_3'] {\n\t--sidebar-bg: #056468;\n\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav,\n[data-sidebarbg='color_3'] .dlabnav {\n\tborder-color: #056468;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu > li:after,\n[data-sidebarbg='color_3'] .dlabnav .metismenu > li:after {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,\n[data-sidebarbg='color_3'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #056468 !important;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,\n[data-sidebarbg='color_3'] .dlabnav .metismenu ul a:before {\n\tbackground: rgba(255, 255, 255, 0.5);\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .header-info2,\n[data-sidebarbg='color_3'] .dlabnav .header-info2 {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_3'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_3'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_3'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_3'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_3'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_3'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_3'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_3'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {\n\tbackground-color: #079399;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_3'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_3'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_3'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_3'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_3'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_3'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_3'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_3'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_3'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_3'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\ta:hover,\n[data-sidebarbg='color_3'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\t> a\n\t> i,\n[data-sidebarbg='color_3'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\tbackground: #067277 !important;\n\tcolor: rgba(255, 255, 255, 0.7);\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_3'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_3'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\tbox-shadow: none;\n\tbackground: transparent !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_3'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a\n\ti,\n[data-sidebarbg='color_3'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_3'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\tbackground: #079399 !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu a,\n[data-sidebarbg='color_3'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,\n[data-sidebarbg='color_3'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_3'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_3'] .dlabnav .metismenu li ul a.mm-active {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu > li > a,\n[data-sidebarbg='color_3'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,\n[data-sidebarbg='color_3'] .dlabnav .metismenu > li > a i {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_3'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_3'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,\n[data-sidebarbg='color_3'] .dlabnav .metismenu > li.mm-active > a:before {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,\n[data-sidebarbg='color_3'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .header-info2 span,\n[data-sidebarbg='color_3'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .sidebar-info,\n[data-sidebarbg='color_3'] .dlabnav .sidebar-info {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .dlabnav .sidebar-info i,\n[data-sidebarbg='color_3'] .dlabnav .sidebar-info i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .plus-box,\n[data-sidebarbg='color_3'] .plus-box {\n\tbackground-color: #079399;\n}\n[data-sidebarbg='color_3'][data-theme-version='dark'] .copyright,\n[data-sidebarbg='color_3'] .copyright {\n\tcolor: #fff;\n}\n\n[data-sidebarbg='color_4'][data-theme-version='dark'],\n[data-sidebarbg='color_4'] {\n\t--sidebar-bg: #4d06a5;\n\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav,\n[data-sidebarbg='color_4'] .dlabnav {\n\tborder-color: #4d06a5;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu > li:after,\n[data-sidebarbg='color_4'] .dlabnav .metismenu > li:after {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,\n[data-sidebarbg='color_4'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #4d06a5 !important;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,\n[data-sidebarbg='color_4'] .dlabnav .metismenu ul a:before {\n\tbackground: rgba(255, 255, 255, 0.5);\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .header-info2,\n[data-sidebarbg='color_4'] .dlabnav .header-info2 {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_4'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_4'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_4'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_4'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_4'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_4'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_4'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_4'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {\n\tbackground-color: #6408d6;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_4'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_4'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_4'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_4'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_4'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_4'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_4'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_4'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_4'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_4'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\ta:hover,\n[data-sidebarbg='color_4'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\t> a\n\t> i,\n[data-sidebarbg='color_4'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\tbackground: #5407b4 !important;\n\tcolor: rgba(255, 255, 255, 0.7);\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_4'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_4'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\tbox-shadow: none;\n\tbackground: transparent !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_4'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a\n\ti,\n[data-sidebarbg='color_4'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_4'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\tbackground: #6408d6 !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu a,\n[data-sidebarbg='color_4'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,\n[data-sidebarbg='color_4'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_4'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_4'] .dlabnav .metismenu li ul a.mm-active {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu > li > a,\n[data-sidebarbg='color_4'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,\n[data-sidebarbg='color_4'] .dlabnav .metismenu > li > a i {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_4'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_4'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,\n[data-sidebarbg='color_4'] .dlabnav .metismenu > li.mm-active > a:before {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,\n[data-sidebarbg='color_4'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .header-info2 span,\n[data-sidebarbg='color_4'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .sidebar-info,\n[data-sidebarbg='color_4'] .dlabnav .sidebar-info {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .dlabnav .sidebar-info i,\n[data-sidebarbg='color_4'] .dlabnav .sidebar-info i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .plus-box,\n[data-sidebarbg='color_4'] .plus-box {\n\tbackground-color: #6408d6;\n}\n[data-sidebarbg='color_4'][data-theme-version='dark'] .copyright,\n[data-sidebarbg='color_4'] .copyright {\n\tcolor: #fff;\n}\n\n[data-sidebarbg='color_5'][data-theme-version='dark'],\n[data-sidebarbg='color_5'] {\n\t--sidebar-bg: #dc3545;\n\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav,\n[data-sidebarbg='color_5'] .dlabnav {\n\tborder-color: #dc3545;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu > li:after,\n[data-sidebarbg='color_5'] .dlabnav .metismenu > li:after {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,\n[data-sidebarbg='color_5'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #dc3545 !important;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,\n[data-sidebarbg='color_5'] .dlabnav .metismenu ul a:before {\n\tbackground: rgba(255, 255, 255, 0.5);\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .header-info2,\n[data-sidebarbg='color_5'] .dlabnav .header-info2 {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_5'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_5'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_5'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_5'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_5'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_5'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_5'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_5'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {\n\tbackground-color: #e4606d;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_5'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_5'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_5'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_5'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_5'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_5'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_5'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_5'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_5'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_5'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\ta:hover,\n[data-sidebarbg='color_5'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\t> a\n\t> i,\n[data-sidebarbg='color_5'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\tbackground: #de4251 !important;\n\tcolor: rgba(255, 255, 255, 0.7);\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_5'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_5'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\tbox-shadow: none;\n\tbackground: transparent !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_5'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a\n\ti,\n[data-sidebarbg='color_5'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_5'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\tbackground: #e4606d !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu a,\n[data-sidebarbg='color_5'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,\n[data-sidebarbg='color_5'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_5'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_5'] .dlabnav .metismenu li ul a.mm-active {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu > li > a,\n[data-sidebarbg='color_5'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,\n[data-sidebarbg='color_5'] .dlabnav .metismenu > li > a i {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_5'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_5'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,\n[data-sidebarbg='color_5'] .dlabnav .metismenu > li.mm-active > a:before {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,\n[data-sidebarbg='color_5'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .header-info2 span,\n[data-sidebarbg='color_5'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .sidebar-info,\n[data-sidebarbg='color_5'] .dlabnav .sidebar-info {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .dlabnav .sidebar-info i,\n[data-sidebarbg='color_5'] .dlabnav .sidebar-info i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .plus-box,\n[data-sidebarbg='color_5'] .plus-box {\n\tbackground-color: #e4606d;\n}\n[data-sidebarbg='color_5'][data-theme-version='dark'] .copyright,\n[data-sidebarbg='color_5'] .copyright {\n\tcolor: #fff;\n}\n\n[data-sidebarbg='color_6'][data-theme-version='dark'],\n[data-sidebarbg='color_6'] {\n\t--sidebar-bg: #fd7e14;\n\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav,\n[data-sidebarbg='color_6'] .dlabnav {\n\tborder-color: #fd7e14;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu > li:after,\n[data-sidebarbg='color_6'] .dlabnav .metismenu > li:after {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,\n[data-sidebarbg='color_6'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #fd7e14 !important;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,\n[data-sidebarbg='color_6'] .dlabnav .metismenu ul a:before {\n\tbackground: rgba(255, 255, 255, 0.5);\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .header-info2,\n[data-sidebarbg='color_6'] .dlabnav .header-info2 {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_6'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_6'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_6'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_6'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_6'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_6'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_6'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_6'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {\n\tbackground-color: #fd9a47;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_6'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_6'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_6'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_6'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_6'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_6'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_6'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_6'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_6'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_6'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\ta:hover,\n[data-sidebarbg='color_6'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\t> a\n\t> i,\n[data-sidebarbg='color_6'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\tbackground: #fd8623 !important;\n\tcolor: rgba(255, 255, 255, 0.7);\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_6'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_6'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\tbox-shadow: none;\n\tbackground: transparent !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_6'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a\n\ti,\n[data-sidebarbg='color_6'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_6'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\tbackground: #fd9a47 !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu a,\n[data-sidebarbg='color_6'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,\n[data-sidebarbg='color_6'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_6'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_6'] .dlabnav .metismenu li ul a.mm-active {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu > li > a,\n[data-sidebarbg='color_6'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,\n[data-sidebarbg='color_6'] .dlabnav .metismenu > li > a i {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_6'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_6'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,\n[data-sidebarbg='color_6'] .dlabnav .metismenu > li.mm-active > a:before {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,\n[data-sidebarbg='color_6'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .header-info2 span,\n[data-sidebarbg='color_6'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .sidebar-info,\n[data-sidebarbg='color_6'] .dlabnav .sidebar-info {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .dlabnav .sidebar-info i,\n[data-sidebarbg='color_6'] .dlabnav .sidebar-info i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .plus-box,\n[data-sidebarbg='color_6'] .plus-box {\n\tbackground-color: #fd9a47;\n}\n[data-sidebarbg='color_6'][data-theme-version='dark'] .copyright,\n[data-sidebarbg='color_6'] .copyright {\n\tcolor: #fff;\n}\n\n[data-sidebarbg='color_7'][data-theme-version='dark'],\n[data-sidebarbg='color_7'] {\n\t--sidebar-bg: #5155c3;\n\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav,\n[data-sidebarbg='color_7'] .dlabnav {\n\tborder-color: #5155c3;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu > li:after,\n[data-sidebarbg='color_7'] .dlabnav .metismenu > li:after {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,\n[data-sidebarbg='color_7'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #5155c3 !important;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,\n[data-sidebarbg='color_7'] .dlabnav .metismenu ul a:before {\n\tbackground: rgba(255, 255, 255, 0.5);\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .header-info2,\n[data-sidebarbg='color_7'] .dlabnav .header-info2 {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_7'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_7'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_7'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_7'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_7'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_7'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_7'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_7'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {\n\tbackground-color: #777ad0;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_7'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_7'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_7'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_7'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_7'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_7'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_7'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_7'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_7'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_7'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\ta:hover,\n[data-sidebarbg='color_7'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\t> a\n\t> i,\n[data-sidebarbg='color_7'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\tbackground: #5c60c7 !important;\n\tcolor: rgba(255, 255, 255, 0.7);\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_7'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_7'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\tbox-shadow: none;\n\tbackground: transparent !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_7'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a\n\ti,\n[data-sidebarbg='color_7'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_7'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\tbackground: #777ad0 !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu a,\n[data-sidebarbg='color_7'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,\n[data-sidebarbg='color_7'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_7'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_7'] .dlabnav .metismenu li ul a.mm-active {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu > li > a,\n[data-sidebarbg='color_7'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,\n[data-sidebarbg='color_7'] .dlabnav .metismenu > li > a i {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_7'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_7'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,\n[data-sidebarbg='color_7'] .dlabnav .metismenu > li.mm-active > a:before {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,\n[data-sidebarbg='color_7'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .header-info2 span,\n[data-sidebarbg='color_7'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .sidebar-info,\n[data-sidebarbg='color_7'] .dlabnav .sidebar-info {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .dlabnav .sidebar-info i,\n[data-sidebarbg='color_7'] .dlabnav .sidebar-info i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .plus-box,\n[data-sidebarbg='color_7'] .plus-box {\n\tbackground-color: #777ad0;\n}\n[data-sidebarbg='color_7'][data-theme-version='dark'] .copyright,\n[data-sidebarbg='color_7'] .copyright {\n\tcolor: #fff;\n}\n\n[data-sidebarbg='color_8'][data-theme-version='dark'],\n[data-sidebarbg='color_8'] {\n\t--sidebar-bg: #854df3;\n\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav,\n[data-sidebarbg='color_8'] .dlabnav {\n\tborder-color: #854df3;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu > li:after,\n[data-sidebarbg='color_8'] .dlabnav .metismenu > li:after {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,\n[data-sidebarbg='color_8'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #854df3 !important;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,\n[data-sidebarbg='color_8'] .dlabnav .metismenu ul a:before {\n\tbackground: rgba(255, 255, 255, 0.5);\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .header-info2,\n[data-sidebarbg='color_8'] .dlabnav .header-info2 {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_8'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_8'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_8'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_8'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_8'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_8'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_8'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_8'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {\n\tbackground-color: #a67df6;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_8'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_8'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_8'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_8'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_8'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_8'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_8'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_8'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_8'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_8'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\ta:hover,\n[data-sidebarbg='color_8'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\t> a\n\t> i,\n[data-sidebarbg='color_8'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\tbackground: #8f5bf4 !important;\n\tcolor: rgba(255, 255, 255, 0.7);\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_8'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_8'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\tbox-shadow: none;\n\tbackground: transparent !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_8'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a\n\ti,\n[data-sidebarbg='color_8'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_8'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\tbackground: #a67df6 !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu a,\n[data-sidebarbg='color_8'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,\n[data-sidebarbg='color_8'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_8'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_8'] .dlabnav .metismenu li ul a.mm-active {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu > li > a,\n[data-sidebarbg='color_8'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,\n[data-sidebarbg='color_8'] .dlabnav .metismenu > li > a i {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_8'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_8'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,\n[data-sidebarbg='color_8'] .dlabnav .metismenu > li.mm-active > a:before {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,\n[data-sidebarbg='color_8'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .header-info2 span,\n[data-sidebarbg='color_8'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .sidebar-info,\n[data-sidebarbg='color_8'] .dlabnav .sidebar-info {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .dlabnav .sidebar-info i,\n[data-sidebarbg='color_8'] .dlabnav .sidebar-info i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .plus-box,\n[data-sidebarbg='color_8'] .plus-box {\n\tbackground-color: #a67df6;\n}\n[data-sidebarbg='color_8'][data-theme-version='dark'] .copyright,\n[data-sidebarbg='color_8'] .copyright {\n\tcolor: #fff;\n}\n\n[data-sidebarbg='color_9'][data-theme-version='dark'],\n[data-sidebarbg='color_9'] {\n\t--sidebar-bg: #20c997;\n\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav,\n[data-sidebarbg='color_9'] .dlabnav {\n\tborder-color: #20c997;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu > li:after,\n[data-sidebarbg='color_9'] .dlabnav .metismenu > li:after {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,\n[data-sidebarbg='color_9'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #20c997 !important;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,\n[data-sidebarbg='color_9'] .dlabnav .metismenu ul a:before {\n\tbackground: rgba(255, 255, 255, 0.5);\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .header-info2,\n[data-sidebarbg='color_9'] .dlabnav .header-info2 {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_9'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_9'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_9'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_9'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_9'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_9'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_9'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_9'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {\n\tbackground-color: #3ce0af;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_9'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_9'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_9'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_9'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_9'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_9'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_9'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_9'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_9'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_9'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\ta:hover,\n[data-sidebarbg='color_9'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\t> a\n\t> i,\n[data-sidebarbg='color_9'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\tbackground: #22d6a1 !important;\n\tcolor: rgba(255, 255, 255, 0.7);\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_9'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_9'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\tbox-shadow: none;\n\tbackground: transparent !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_9'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a\n\ti,\n[data-sidebarbg='color_9'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_9'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\tbackground: #3ce0af !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu a,\n[data-sidebarbg='color_9'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,\n[data-sidebarbg='color_9'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_9'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_9'] .dlabnav .metismenu li ul a.mm-active {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu > li > a,\n[data-sidebarbg='color_9'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,\n[data-sidebarbg='color_9'] .dlabnav .metismenu > li > a i {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_9'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_9'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,\n[data-sidebarbg='color_9'] .dlabnav .metismenu > li.mm-active > a:before {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,\n[data-sidebarbg='color_9'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .header-info2 span,\n[data-sidebarbg='color_9'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .sidebar-info,\n[data-sidebarbg='color_9'] .dlabnav .sidebar-info {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .dlabnav .sidebar-info i,\n[data-sidebarbg='color_9'] .dlabnav .sidebar-info i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .plus-box,\n[data-sidebarbg='color_9'] .plus-box {\n\tbackground-color: #3ce0af;\n}\n[data-sidebarbg='color_9'][data-theme-version='dark'] .copyright,\n[data-sidebarbg='color_9'] .copyright {\n\tcolor: #fff;\n}\n\n[data-sidebarbg='color_10'][data-theme-version='dark'],\n[data-sidebarbg='color_10'] {\n\t--sidebar-bg: #17a2b8;\n\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav,\n[data-sidebarbg='color_10'] .dlabnav {\n\tborder-color: #17a2b8;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu > li:after,\n[data-sidebarbg='color_10'] .dlabnav .metismenu > li:after {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,\n[data-sidebarbg='color_10'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #17a2b8 !important;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,\n[data-sidebarbg='color_10'] .dlabnav .metismenu ul a:before {\n\tbackground: rgba(255, 255, 255, 0.5);\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .header-info2,\n[data-sidebarbg='color_10'] .dlabnav .header-info2 {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_10'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_10'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_10'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_10'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_10'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_10'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_10'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_10'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {\n\tbackground-color: #1fc8e3;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_10'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_10'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_10'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_10'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_10'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_10'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_10'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_10'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_10'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_10'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\ta:hover,\n[data-sidebarbg='color_10'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\t> a\n\t> i,\n[data-sidebarbg='color_10'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\tbackground: #19aec6 !important;\n\tcolor: rgba(255, 255, 255, 0.7);\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_10'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_10'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\tbox-shadow: none;\n\tbackground: transparent !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_10'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a\n\ti,\n[data-sidebarbg='color_10'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_10'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\tbackground: #1fc8e3 !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu a,\n[data-sidebarbg='color_10'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,\n[data-sidebarbg='color_10'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_10'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_10'] .dlabnav .metismenu li ul a.mm-active {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu > li > a,\n[data-sidebarbg='color_10'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,\n[data-sidebarbg='color_10'] .dlabnav .metismenu > li > a i {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_10'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_10'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,\n[data-sidebarbg='color_10'] .dlabnav .metismenu > li.mm-active > a:before {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,\n[data-sidebarbg='color_10'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .header-info2 span,\n[data-sidebarbg='color_10'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .sidebar-info,\n[data-sidebarbg='color_10'] .dlabnav .sidebar-info {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .dlabnav .sidebar-info i,\n[data-sidebarbg='color_10'] .dlabnav .sidebar-info i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .plus-box,\n[data-sidebarbg='color_10'] .plus-box {\n\tbackground-color: #1fc8e3;\n}\n[data-sidebarbg='color_10'][data-theme-version='dark'] .copyright,\n[data-sidebarbg='color_10'] .copyright {\n\tcolor: #fff;\n}\n\n[data-sidebarbg='color_11'][data-theme-version='dark'],\n[data-sidebarbg='color_11'] {\n\t--sidebar-bg: #94618e;\n\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav,\n[data-sidebarbg='color_11'] .dlabnav {\n\tborder-color: #94618e;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu > li:after,\n[data-sidebarbg='color_11'] .dlabnav .metismenu > li:after {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,\n[data-sidebarbg='color_11'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #94618e !important;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,\n[data-sidebarbg='color_11'] .dlabnav .metismenu ul a:before {\n\tbackground: rgba(255, 255, 255, 0.5);\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .header-info2,\n[data-sidebarbg='color_11'] .dlabnav .header-info2 {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_11'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_11'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_11'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_11'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_11'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_11'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_11'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_11'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {\n\tbackground-color: #aa7ea5;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_11'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_11'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_11'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_11'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_11'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_11'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_11'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_11'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_11'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_11'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\ta:hover,\n[data-sidebarbg='color_11'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\t> a\n\t> i,\n[data-sidebarbg='color_11'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\tbackground: #9c6896 !important;\n\tcolor: rgba(255, 255, 255, 0.7);\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_11'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_11'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\tbox-shadow: none;\n\tbackground: transparent !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_11'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a\n\ti,\n[data-sidebarbg='color_11'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_11'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\tbackground: #aa7ea5 !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu a,\n[data-sidebarbg='color_11'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,\n[data-sidebarbg='color_11'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_11'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_11'] .dlabnav .metismenu li ul a.mm-active {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu > li > a,\n[data-sidebarbg='color_11'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,\n[data-sidebarbg='color_11'] .dlabnav .metismenu > li > a i {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_11'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_11'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,\n[data-sidebarbg='color_11'] .dlabnav .metismenu > li.mm-active > a:before {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,\n[data-sidebarbg='color_11'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .header-info2 span,\n[data-sidebarbg='color_11'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .sidebar-info,\n[data-sidebarbg='color_11'] .dlabnav .sidebar-info {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .dlabnav .sidebar-info i,\n[data-sidebarbg='color_11'] .dlabnav .sidebar-info i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .plus-box,\n[data-sidebarbg='color_11'] .plus-box {\n\tbackground-color: #aa7ea5;\n}\n[data-sidebarbg='color_11'][data-theme-version='dark'] .copyright,\n[data-sidebarbg='color_11'] .copyright {\n\tcolor: #fff;\n}\n\n[data-sidebarbg='color_12'][data-theme-version='dark'],\n[data-sidebarbg='color_12'] {\n\t--sidebar-bg: #00273a;\n\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav,\n[data-sidebarbg='color_12'] .dlabnav {\n\tborder-color: #00273a;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu > li:after,\n[data-sidebarbg='color_12'] .dlabnav .metismenu > li:after {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,\n[data-sidebarbg='color_12'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #00273a !important;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,\n[data-sidebarbg='color_12'] .dlabnav .metismenu ul a:before {\n\tbackground: rgba(255, 255, 255, 0.5);\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .header-info2,\n[data-sidebarbg='color_12'] .dlabnav .header-info2 {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_12'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_12'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_12'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_12'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_12'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_12'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_12'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_12'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {\n\tbackground-color: #00496d;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_12'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_12'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_12'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_12'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_12'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_12'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_12'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_12'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_12'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_12'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\ta:hover,\n[data-sidebarbg='color_12'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\t> a\n\t> i,\n[data-sidebarbg='color_12'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\tbackground: #003149 !important;\n\tcolor: rgba(255, 255, 255, 0.7);\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_12'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_12'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\tbox-shadow: none;\n\tbackground: transparent !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_12'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a\n\ti,\n[data-sidebarbg='color_12'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_12'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\tbackground: #00496d !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu a,\n[data-sidebarbg='color_12'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,\n[data-sidebarbg='color_12'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_12'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_12'] .dlabnav .metismenu li ul a.mm-active {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu > li > a,\n[data-sidebarbg='color_12'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,\n[data-sidebarbg='color_12'] .dlabnav .metismenu > li > a i {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_12'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_12'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,\n[data-sidebarbg='color_12'] .dlabnav .metismenu > li.mm-active > a:before {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,\n[data-sidebarbg='color_12'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .header-info2 span,\n[data-sidebarbg='color_12'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .sidebar-info,\n[data-sidebarbg='color_12'] .dlabnav .sidebar-info {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .dlabnav .sidebar-info i,\n[data-sidebarbg='color_12'] .dlabnav .sidebar-info i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .plus-box,\n[data-sidebarbg='color_12'] .plus-box {\n\tbackground-color: #00496d;\n}\n[data-sidebarbg='color_12'][data-theme-version='dark'] .copyright,\n[data-sidebarbg='color_12'] .copyright {\n\tcolor: #fff;\n}\n\n[data-sidebarbg='color_13'][data-theme-version='dark'],\n[data-sidebarbg='color_13'] {\n\t--sidebar-bg: #432d29;\n\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav,\n[data-sidebarbg='color_13'] .dlabnav {\n\tborder-color: #432d29;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu > li:after,\n[data-sidebarbg='color_13'] .dlabnav .metismenu > li:after {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,\n[data-sidebarbg='color_13'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #432d29 !important;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,\n[data-sidebarbg='color_13'] .dlabnav .metismenu ul a:before {\n\tbackground: rgba(255, 255, 255, 0.5);\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .header-info2,\n[data-sidebarbg='color_13'] .dlabnav .header-info2 {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_13'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_13'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_13'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_13'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_13'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_13'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_13'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_13'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {\n\tbackground-color: #63423c;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_13'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_13'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_13'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_13'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_13'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_13'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_13'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_13'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_13'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_13'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\ta:hover,\n[data-sidebarbg='color_13'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\t> a\n\t> i,\n[data-sidebarbg='color_13'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\tbackground: #4c332f !important;\n\tcolor: rgba(255, 255, 255, 0.7);\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_13'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_13'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\tbox-shadow: none;\n\tbackground: transparent !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_13'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a\n\ti,\n[data-sidebarbg='color_13'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_13'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\tbackground: #63423c !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu a,\n[data-sidebarbg='color_13'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,\n[data-sidebarbg='color_13'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_13'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_13'] .dlabnav .metismenu li ul a.mm-active {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu > li > a,\n[data-sidebarbg='color_13'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,\n[data-sidebarbg='color_13'] .dlabnav .metismenu > li > a i {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_13'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_13'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,\n[data-sidebarbg='color_13'] .dlabnav .metismenu > li.mm-active > a:before {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,\n[data-sidebarbg='color_13'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .header-info2 span,\n[data-sidebarbg='color_13'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .sidebar-info,\n[data-sidebarbg='color_13'] .dlabnav .sidebar-info {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .dlabnav .sidebar-info i,\n[data-sidebarbg='color_13'] .dlabnav .sidebar-info i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .plus-box,\n[data-sidebarbg='color_13'] .plus-box {\n\tbackground-color: #63423c;\n}\n[data-sidebarbg='color_13'][data-theme-version='dark'] .copyright,\n[data-sidebarbg='color_13'] .copyright {\n\tcolor: #fff;\n}\n\n[data-sidebarbg='color_14'][data-theme-version='dark'],\n[data-sidebarbg='color_14'] {\n\t--sidebar-bg: #4885ed;\n\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav,\n[data-sidebarbg='color_14'] .dlabnav {\n\tborder-color: #4885ed;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu > li:after,\n[data-sidebarbg='color_14'] .dlabnav .metismenu > li:after {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,\n[data-sidebarbg='color_14'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #4885ed !important;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,\n[data-sidebarbg='color_14'] .dlabnav .metismenu ul a:before {\n\tbackground: rgba(255, 255, 255, 0.5);\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .header-info2,\n[data-sidebarbg='color_14'] .dlabnav .header-info2 {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_14'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_14'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_14'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_14'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_14'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_14'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_14'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_14'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {\n\tbackground-color: #76a4f2;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_14'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_14'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_14'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_14'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_14'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_14'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_14'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_14'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_14'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_14'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\ta:hover,\n[data-sidebarbg='color_14'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\t> a\n\t> i,\n[data-sidebarbg='color_14'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\tbackground: #568eee !important;\n\tcolor: rgba(255, 255, 255, 0.7);\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_14'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_14'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\tbox-shadow: none;\n\tbackground: transparent !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_14'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a\n\ti,\n[data-sidebarbg='color_14'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_14'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\tbackground: #76a4f2 !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu a,\n[data-sidebarbg='color_14'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,\n[data-sidebarbg='color_14'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_14'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_14'] .dlabnav .metismenu li ul a.mm-active {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu > li > a,\n[data-sidebarbg='color_14'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,\n[data-sidebarbg='color_14'] .dlabnav .metismenu > li > a i {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_14'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_14'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,\n[data-sidebarbg='color_14'] .dlabnav .metismenu > li.mm-active > a:before {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,\n[data-sidebarbg='color_14'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .header-info2 span,\n[data-sidebarbg='color_14'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .sidebar-info,\n[data-sidebarbg='color_14'] .dlabnav .sidebar-info {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .dlabnav .sidebar-info i,\n[data-sidebarbg='color_14'] .dlabnav .sidebar-info i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .plus-box,\n[data-sidebarbg='color_14'] .plus-box {\n\tbackground-color: #76a4f2;\n}\n[data-sidebarbg='color_14'][data-theme-version='dark'] .copyright,\n[data-sidebarbg='color_14'] .copyright {\n\tcolor: #fff;\n}\n\n[data-sidebarbg='color_15'][data-theme-version='dark'],\n[data-sidebarbg='color_15'] {\n\t--sidebar-bg: #4cb32b;\n\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav,\n[data-sidebarbg='color_15'] .dlabnav {\n\tborder-color: #4cb32b;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu > li:after,\n[data-sidebarbg='color_15'] .dlabnav .metismenu > li:after {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul,\n[data-sidebarbg='color_15'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #4cb32b !important;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu ul a:before,\n[data-sidebarbg='color_15'] .dlabnav .metismenu ul a:before {\n\tbackground: rgba(255, 255, 255, 0.5);\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .header-info2,\n[data-sidebarbg='color_15'] .dlabnav .header-info2 {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_15'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_15'][data-sidebar-style='full'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong,\n[data-sidebarbg='color_15'][data-sidebar-style='overlay'][data-layout='vertical'] .dlabnav .copyright strong {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_15'][data-sidebar-style='mini'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_15'][data-sidebar-style='modern'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_15'][data-sidebar-style='compact'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_15'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu li ul,\n[data-sidebarbg='color_15'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu li ul {\n\tbackground-color: #63d140;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='icon-hover'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='full'][data-layout='horizontal']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_15'][data-sidebar-style='mini'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_15'][data-sidebar-style='mini'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_15'][data-sidebar-style='modern'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_15'][data-sidebar-style='modern'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_15'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_15'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_15'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_15'][data-sidebar-style='icon-hover'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a,\n[data-sidebarbg='color_15'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_15'][data-sidebar-style='full'][data-layout='horizontal'] .dlabnav .metismenu > li:hover > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\ta:hover,\n[data-sidebarbg='color_15'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li a:hover {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li\n\t> a\n\t> i,\n[data-sidebarbg='color_15'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li > a > i {\n\tbackground: #51bf2e !important;\n\tcolor: rgba(255, 255, 255, 0.7);\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a,\n[data-sidebarbg='color_15'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_15'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a {\n\tbox-shadow: none;\n\tbackground: transparent !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li.mm-active\n\t> a\n\ti,\n[data-sidebarbg='color_15'][data-theme-version='dark'][data-sidebar-style='compact'][data-layout='vertical']\n\t.dlabnav\n\t.metismenu\n\t> li:hover\n\t> a\n\ti,\n[data-sidebarbg='color_15'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_15'][data-sidebar-style='compact'][data-layout='vertical'] .dlabnav .metismenu > li:hover > a i {\n\tbackground: #63d140 !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu a,\n[data-sidebarbg='color_15'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.8) !important;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu li ul a.mm-active,\n[data-sidebarbg='color_15'] .dlabnav .metismenu li ul a:hover,\n[data-sidebarbg='color_15'] .dlabnav .metismenu li ul a:focus,\n[data-sidebarbg='color_15'] .dlabnav .metismenu li ul a.mm-active {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu > li > a,\n[data-sidebarbg='color_15'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu > li > a i,\n[data-sidebarbg='color_15'] .dlabnav .metismenu > li > a i {\n\tcolor: rgba(255, 255, 255, 0.85) !important;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a,\n[data-sidebarbg='color_15'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground: rgba(255, 255, 255, 0.15) !important;\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i,\n[data-sidebarbg='color_15'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a:before,\n[data-sidebarbg='color_15'] .dlabnav .metismenu > li.mm-active > a:before {\n\tbackground: #fff !important;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after,\n[data-sidebarbg='color_15'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: rgba(255, 255, 255, 0.85) transparent transparent rgba(255, 255, 255, 0.85);\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .header-info2 span,\n[data-sidebarbg='color_15'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .sidebar-info,\n[data-sidebarbg='color_15'] .dlabnav .sidebar-info {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .dlabnav .sidebar-info i,\n[data-sidebarbg='color_15'] .dlabnav .sidebar-info i {\n\tcolor: #fff;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .plus-box,\n[data-sidebarbg='color_15'] .plus-box {\n\tbackground-color: #63d140;\n}\n[data-sidebarbg='color_15'][data-theme-version='dark'] .copyright,\n[data-sidebarbg='color_15'] .copyright {\n\tcolor: #fff;\n}\n\n[data-headerbg='color_2'][data-theme-version='dark'],\n[data-headerbg='color_2'] {\n\t--headerbg: #4d44b5;\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .header.is-fixed,\n[data-headerbg='color_2'] .header.is-fixed {\n\tborder-color: #6e66c6 !important;\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .header,\n[data-headerbg='color_2'] .header {\n\tborder: 0;\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .header-left .dashboard_bar,\n[data-headerbg='color_2'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .hamburger svg rect,\n[data-headerbg='color_2'] .hamburger svg rect {\n\tfill: #fff;\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .header-right,\n[data-headerbg='color_2'] .header-right {\n\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,\n[data-headerbg='color_2'] .header-right .notification_dropdown .nav-link {\n\tbackground-color: #6e66c6;\n\tborder-color: #6e66c6;\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,\n[data-headerbg='color_2'] .header-right .notification_dropdown .nav-link .setting-svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,\n[data-headerbg='color_2'] .header-right .notification_dropdown .menu-wallet svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,\n[data-headerbg='color_2'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_2'] .header-right .notification_dropdown.search-area-header svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,\n[data-headerbg='color_2'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_2'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_2'] .header-right .notification_dropdown .bell-link svg path {\n\tstroke: #fff;\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,\n[data-headerbg='color_2'] .header-right .notification_dropdown .search-area svg path {\n\tfill: var(--primary);\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,\n[data-headerbg='color_2'] .header-right .header-profile2 .dropdown-menu a span {\n\tcolor: #000;\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_2'] .header-right .bootstrap-select .btn {\n\tbackground-color: #6e66c6 !important;\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,\n[data-headerbg='color_2'] .header-right .bootstrap-select.countrypicker {\n\tborder-color: #6e66c6 !important;\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_2'] .header-right .bootstrap-select .btn {\n\tcolor: #fff !important;\n\tborder-color: #6e66c6 !important;\n}\n[data-headerbg='color_2'][data-theme-version='dark'] .hamburger .line,\n[data-headerbg='color_2'] .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n[data-headerbg='color_3'][data-theme-version='dark'],\n[data-headerbg='color_3'] {\n\t--headerbg: #056468;\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .header.is-fixed,\n[data-headerbg='color_3'] .header.is-fixed {\n\tborder-color: #079399 !important;\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .header,\n[data-headerbg='color_3'] .header {\n\tborder: 0;\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .header-left .dashboard_bar,\n[data-headerbg='color_3'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .hamburger svg rect,\n[data-headerbg='color_3'] .hamburger svg rect {\n\tfill: #fff;\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .header-right,\n[data-headerbg='color_3'] .header-right {\n\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,\n[data-headerbg='color_3'] .header-right .notification_dropdown .nav-link {\n\tbackground-color: #079399;\n\tborder-color: #079399;\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,\n[data-headerbg='color_3'] .header-right .notification_dropdown .nav-link .setting-svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,\n[data-headerbg='color_3'] .header-right .notification_dropdown .menu-wallet svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,\n[data-headerbg='color_3'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_3'] .header-right .notification_dropdown.search-area-header svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,\n[data-headerbg='color_3'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_3'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_3'] .header-right .notification_dropdown .bell-link svg path {\n\tstroke: #fff;\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,\n[data-headerbg='color_3'] .header-right .notification_dropdown .search-area svg path {\n\tfill: var(--primary);\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,\n[data-headerbg='color_3'] .header-right .header-profile2 .dropdown-menu a span {\n\tcolor: #000;\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_3'] .header-right .bootstrap-select .btn {\n\tbackground-color: #079399 !important;\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,\n[data-headerbg='color_3'] .header-right .bootstrap-select.countrypicker {\n\tborder-color: #079399 !important;\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_3'] .header-right .bootstrap-select .btn {\n\tcolor: #fff !important;\n\tborder-color: #079399 !important;\n}\n[data-headerbg='color_3'][data-theme-version='dark'] .hamburger .line,\n[data-headerbg='color_3'] .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n[data-headerbg='color_4'][data-theme-version='dark'],\n[data-headerbg='color_4'] {\n\t--headerbg: #4d06a5;\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .header.is-fixed,\n[data-headerbg='color_4'] .header.is-fixed {\n\tborder-color: #6408d6 !important;\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .header,\n[data-headerbg='color_4'] .header {\n\tborder: 0;\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .header-left .dashboard_bar,\n[data-headerbg='color_4'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .hamburger svg rect,\n[data-headerbg='color_4'] .hamburger svg rect {\n\tfill: #fff;\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .header-right,\n[data-headerbg='color_4'] .header-right {\n\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,\n[data-headerbg='color_4'] .header-right .notification_dropdown .nav-link {\n\tbackground-color: #6408d6;\n\tborder-color: #6408d6;\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,\n[data-headerbg='color_4'] .header-right .notification_dropdown .nav-link .setting-svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,\n[data-headerbg='color_4'] .header-right .notification_dropdown .menu-wallet svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,\n[data-headerbg='color_4'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_4'] .header-right .notification_dropdown.search-area-header svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,\n[data-headerbg='color_4'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_4'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_4'] .header-right .notification_dropdown .bell-link svg path {\n\tstroke: #fff;\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,\n[data-headerbg='color_4'] .header-right .notification_dropdown .search-area svg path {\n\tfill: var(--primary);\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,\n[data-headerbg='color_4'] .header-right .header-profile2 .dropdown-menu a span {\n\tcolor: #000;\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_4'] .header-right .bootstrap-select .btn {\n\tbackground-color: #6408d6 !important;\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,\n[data-headerbg='color_4'] .header-right .bootstrap-select.countrypicker {\n\tborder-color: #6408d6 !important;\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_4'] .header-right .bootstrap-select .btn {\n\tcolor: #fff !important;\n\tborder-color: #6408d6 !important;\n}\n[data-headerbg='color_4'][data-theme-version='dark'] .hamburger .line,\n[data-headerbg='color_4'] .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n[data-headerbg='color_5'][data-theme-version='dark'],\n[data-headerbg='color_5'] {\n\t--headerbg: #dc3545;\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .header.is-fixed,\n[data-headerbg='color_5'] .header.is-fixed {\n\tborder-color: #e4606d !important;\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .header,\n[data-headerbg='color_5'] .header {\n\tborder: 0;\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .header-left .dashboard_bar,\n[data-headerbg='color_5'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .hamburger svg rect,\n[data-headerbg='color_5'] .hamburger svg rect {\n\tfill: #fff;\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .header-right,\n[data-headerbg='color_5'] .header-right {\n\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,\n[data-headerbg='color_5'] .header-right .notification_dropdown .nav-link {\n\tbackground-color: #e4606d;\n\tborder-color: #e4606d;\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,\n[data-headerbg='color_5'] .header-right .notification_dropdown .nav-link .setting-svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,\n[data-headerbg='color_5'] .header-right .notification_dropdown .menu-wallet svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,\n[data-headerbg='color_5'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_5'] .header-right .notification_dropdown.search-area-header svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,\n[data-headerbg='color_5'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_5'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_5'] .header-right .notification_dropdown .bell-link svg path {\n\tstroke: #fff;\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,\n[data-headerbg='color_5'] .header-right .notification_dropdown .search-area svg path {\n\tfill: var(--primary);\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,\n[data-headerbg='color_5'] .header-right .header-profile2 .dropdown-menu a span {\n\tcolor: #000;\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_5'] .header-right .bootstrap-select .btn {\n\tbackground-color: #e4606d !important;\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,\n[data-headerbg='color_5'] .header-right .bootstrap-select.countrypicker {\n\tborder-color: #e4606d !important;\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_5'] .header-right .bootstrap-select .btn {\n\tcolor: #fff !important;\n\tborder-color: #e4606d !important;\n}\n[data-headerbg='color_5'][data-theme-version='dark'] .hamburger .line,\n[data-headerbg='color_5'] .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n[data-headerbg='color_6'][data-theme-version='dark'],\n[data-headerbg='color_6'] {\n\t--headerbg: #fd7e14;\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .header.is-fixed,\n[data-headerbg='color_6'] .header.is-fixed {\n\tborder-color: #fd9a47 !important;\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .header,\n[data-headerbg='color_6'] .header {\n\tborder: 0;\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .header-left .dashboard_bar,\n[data-headerbg='color_6'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .hamburger svg rect,\n[data-headerbg='color_6'] .hamburger svg rect {\n\tfill: #fff;\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .header-right,\n[data-headerbg='color_6'] .header-right {\n\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,\n[data-headerbg='color_6'] .header-right .notification_dropdown .nav-link {\n\tbackground-color: #fd9a47;\n\tborder-color: #fd9a47;\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,\n[data-headerbg='color_6'] .header-right .notification_dropdown .nav-link .setting-svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,\n[data-headerbg='color_6'] .header-right .notification_dropdown .menu-wallet svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,\n[data-headerbg='color_6'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_6'] .header-right .notification_dropdown.search-area-header svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,\n[data-headerbg='color_6'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_6'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_6'] .header-right .notification_dropdown .bell-link svg path {\n\tstroke: #fff;\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,\n[data-headerbg='color_6'] .header-right .notification_dropdown .search-area svg path {\n\tfill: var(--primary);\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,\n[data-headerbg='color_6'] .header-right .header-profile2 .dropdown-menu a span {\n\tcolor: #000;\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_6'] .header-right .bootstrap-select .btn {\n\tbackground-color: #fd9a47 !important;\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,\n[data-headerbg='color_6'] .header-right .bootstrap-select.countrypicker {\n\tborder-color: #fd9a47 !important;\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_6'] .header-right .bootstrap-select .btn {\n\tcolor: #fff !important;\n\tborder-color: #fd9a47 !important;\n}\n[data-headerbg='color_6'][data-theme-version='dark'] .hamburger .line,\n[data-headerbg='color_6'] .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n[data-headerbg='color_7'][data-theme-version='dark'],\n[data-headerbg='color_7'] {\n\t--headerbg: #5155c3;\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .header.is-fixed,\n[data-headerbg='color_7'] .header.is-fixed {\n\tborder-color: #777ad0 !important;\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .header,\n[data-headerbg='color_7'] .header {\n\tborder: 0;\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .header-left .dashboard_bar,\n[data-headerbg='color_7'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .hamburger svg rect,\n[data-headerbg='color_7'] .hamburger svg rect {\n\tfill: #fff;\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .header-right,\n[data-headerbg='color_7'] .header-right {\n\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,\n[data-headerbg='color_7'] .header-right .notification_dropdown .nav-link {\n\tbackground-color: #777ad0;\n\tborder-color: #777ad0;\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,\n[data-headerbg='color_7'] .header-right .notification_dropdown .nav-link .setting-svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,\n[data-headerbg='color_7'] .header-right .notification_dropdown .menu-wallet svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,\n[data-headerbg='color_7'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_7'] .header-right .notification_dropdown.search-area-header svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,\n[data-headerbg='color_7'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_7'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_7'] .header-right .notification_dropdown .bell-link svg path {\n\tstroke: #fff;\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,\n[data-headerbg='color_7'] .header-right .notification_dropdown .search-area svg path {\n\tfill: var(--primary);\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,\n[data-headerbg='color_7'] .header-right .header-profile2 .dropdown-menu a span {\n\tcolor: #000;\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_7'] .header-right .bootstrap-select .btn {\n\tbackground-color: #777ad0 !important;\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,\n[data-headerbg='color_7'] .header-right .bootstrap-select.countrypicker {\n\tborder-color: #777ad0 !important;\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_7'] .header-right .bootstrap-select .btn {\n\tcolor: #fff !important;\n\tborder-color: #777ad0 !important;\n}\n[data-headerbg='color_7'][data-theme-version='dark'] .hamburger .line,\n[data-headerbg='color_7'] .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n[data-headerbg='color_8'][data-theme-version='dark'],\n[data-headerbg='color_8'] {\n\t--headerbg: #854df3;\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .header.is-fixed,\n[data-headerbg='color_8'] .header.is-fixed {\n\tborder-color: #a67df6 !important;\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .header,\n[data-headerbg='color_8'] .header {\n\tborder: 0;\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .header-left .dashboard_bar,\n[data-headerbg='color_8'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .hamburger svg rect,\n[data-headerbg='color_8'] .hamburger svg rect {\n\tfill: #fff;\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .header-right,\n[data-headerbg='color_8'] .header-right {\n\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,\n[data-headerbg='color_8'] .header-right .notification_dropdown .nav-link {\n\tbackground-color: #a67df6;\n\tborder-color: #a67df6;\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,\n[data-headerbg='color_8'] .header-right .notification_dropdown .nav-link .setting-svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,\n[data-headerbg='color_8'] .header-right .notification_dropdown .menu-wallet svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,\n[data-headerbg='color_8'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_8'] .header-right .notification_dropdown.search-area-header svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,\n[data-headerbg='color_8'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_8'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_8'] .header-right .notification_dropdown .bell-link svg path {\n\tstroke: #fff;\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,\n[data-headerbg='color_8'] .header-right .notification_dropdown .search-area svg path {\n\tfill: var(--primary);\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,\n[data-headerbg='color_8'] .header-right .header-profile2 .dropdown-menu a span {\n\tcolor: #000;\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_8'] .header-right .bootstrap-select .btn {\n\tbackground-color: #a67df6 !important;\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,\n[data-headerbg='color_8'] .header-right .bootstrap-select.countrypicker {\n\tborder-color: #a67df6 !important;\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_8'] .header-right .bootstrap-select .btn {\n\tcolor: #fff !important;\n\tborder-color: #a67df6 !important;\n}\n[data-headerbg='color_8'][data-theme-version='dark'] .hamburger .line,\n[data-headerbg='color_8'] .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n[data-headerbg='color_9'][data-theme-version='dark'],\n[data-headerbg='color_9'] {\n\t--headerbg: #20c997;\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .header.is-fixed,\n[data-headerbg='color_9'] .header.is-fixed {\n\tborder-color: #3ce0af !important;\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .header,\n[data-headerbg='color_9'] .header {\n\tborder: 0;\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .header-left .dashboard_bar,\n[data-headerbg='color_9'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .hamburger svg rect,\n[data-headerbg='color_9'] .hamburger svg rect {\n\tfill: #fff;\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .header-right,\n[data-headerbg='color_9'] .header-right {\n\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,\n[data-headerbg='color_9'] .header-right .notification_dropdown .nav-link {\n\tbackground-color: #3ce0af;\n\tborder-color: #3ce0af;\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,\n[data-headerbg='color_9'] .header-right .notification_dropdown .nav-link .setting-svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,\n[data-headerbg='color_9'] .header-right .notification_dropdown .menu-wallet svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,\n[data-headerbg='color_9'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_9'] .header-right .notification_dropdown.search-area-header svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,\n[data-headerbg='color_9'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_9'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_9'] .header-right .notification_dropdown .bell-link svg path {\n\tstroke: #fff;\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,\n[data-headerbg='color_9'] .header-right .notification_dropdown .search-area svg path {\n\tfill: var(--primary);\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,\n[data-headerbg='color_9'] .header-right .header-profile2 .dropdown-menu a span {\n\tcolor: #000;\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_9'] .header-right .bootstrap-select .btn {\n\tbackground-color: #3ce0af !important;\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,\n[data-headerbg='color_9'] .header-right .bootstrap-select.countrypicker {\n\tborder-color: #3ce0af !important;\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_9'] .header-right .bootstrap-select .btn {\n\tcolor: #fff !important;\n\tborder-color: #3ce0af !important;\n}\n[data-headerbg='color_9'][data-theme-version='dark'] .hamburger .line,\n[data-headerbg='color_9'] .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n[data-headerbg='color_10'][data-theme-version='dark'],\n[data-headerbg='color_10'] {\n\t--headerbg: #17a2b8;\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .header.is-fixed,\n[data-headerbg='color_10'] .header.is-fixed {\n\tborder-color: #1fc8e3 !important;\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .header,\n[data-headerbg='color_10'] .header {\n\tborder: 0;\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .header-left .dashboard_bar,\n[data-headerbg='color_10'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .hamburger svg rect,\n[data-headerbg='color_10'] .hamburger svg rect {\n\tfill: #fff;\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .header-right,\n[data-headerbg='color_10'] .header-right {\n\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,\n[data-headerbg='color_10'] .header-right .notification_dropdown .nav-link {\n\tbackground-color: #1fc8e3;\n\tborder-color: #1fc8e3;\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,\n[data-headerbg='color_10'] .header-right .notification_dropdown .nav-link .setting-svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,\n[data-headerbg='color_10'] .header-right .notification_dropdown .menu-wallet svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,\n[data-headerbg='color_10'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_10'] .header-right .notification_dropdown.search-area-header svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,\n[data-headerbg='color_10'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_10'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_10'] .header-right .notification_dropdown .bell-link svg path {\n\tstroke: #fff;\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,\n[data-headerbg='color_10'] .header-right .notification_dropdown .search-area svg path {\n\tfill: var(--primary);\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,\n[data-headerbg='color_10'] .header-right .header-profile2 .dropdown-menu a span {\n\tcolor: #000;\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_10'] .header-right .bootstrap-select .btn {\n\tbackground-color: #1fc8e3 !important;\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,\n[data-headerbg='color_10'] .header-right .bootstrap-select.countrypicker {\n\tborder-color: #1fc8e3 !important;\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_10'] .header-right .bootstrap-select .btn {\n\tcolor: #fff !important;\n\tborder-color: #1fc8e3 !important;\n}\n[data-headerbg='color_10'][data-theme-version='dark'] .hamburger .line,\n[data-headerbg='color_10'] .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n[data-headerbg='color_11'][data-theme-version='dark'],\n[data-headerbg='color_11'] {\n\t--headerbg: #94618e;\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .header.is-fixed,\n[data-headerbg='color_11'] .header.is-fixed {\n\tborder-color: #aa7ea5 !important;\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .header,\n[data-headerbg='color_11'] .header {\n\tborder: 0;\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .header-left .dashboard_bar,\n[data-headerbg='color_11'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .hamburger svg rect,\n[data-headerbg='color_11'] .hamburger svg rect {\n\tfill: #fff;\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .header-right,\n[data-headerbg='color_11'] .header-right {\n\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,\n[data-headerbg='color_11'] .header-right .notification_dropdown .nav-link {\n\tbackground-color: #aa7ea5;\n\tborder-color: #aa7ea5;\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,\n[data-headerbg='color_11'] .header-right .notification_dropdown .nav-link .setting-svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,\n[data-headerbg='color_11'] .header-right .notification_dropdown .menu-wallet svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,\n[data-headerbg='color_11'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_11'] .header-right .notification_dropdown.search-area-header svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,\n[data-headerbg='color_11'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_11'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_11'] .header-right .notification_dropdown .bell-link svg path {\n\tstroke: #fff;\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,\n[data-headerbg='color_11'] .header-right .notification_dropdown .search-area svg path {\n\tfill: var(--primary);\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,\n[data-headerbg='color_11'] .header-right .header-profile2 .dropdown-menu a span {\n\tcolor: #000;\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_11'] .header-right .bootstrap-select .btn {\n\tbackground-color: #aa7ea5 !important;\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,\n[data-headerbg='color_11'] .header-right .bootstrap-select.countrypicker {\n\tborder-color: #aa7ea5 !important;\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_11'] .header-right .bootstrap-select .btn {\n\tcolor: #fff !important;\n\tborder-color: #aa7ea5 !important;\n}\n[data-headerbg='color_11'][data-theme-version='dark'] .hamburger .line,\n[data-headerbg='color_11'] .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n[data-headerbg='color_12'][data-theme-version='dark'],\n[data-headerbg='color_12'] {\n\t--headerbg: #00273a;\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .header.is-fixed,\n[data-headerbg='color_12'] .header.is-fixed {\n\tborder-color: #00496d !important;\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .header,\n[data-headerbg='color_12'] .header {\n\tborder: 0;\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .header-left .dashboard_bar,\n[data-headerbg='color_12'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .hamburger svg rect,\n[data-headerbg='color_12'] .hamburger svg rect {\n\tfill: #fff;\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .header-right,\n[data-headerbg='color_12'] .header-right {\n\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,\n[data-headerbg='color_12'] .header-right .notification_dropdown .nav-link {\n\tbackground-color: #00496d;\n\tborder-color: #00496d;\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,\n[data-headerbg='color_12'] .header-right .notification_dropdown .nav-link .setting-svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,\n[data-headerbg='color_12'] .header-right .notification_dropdown .menu-wallet svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,\n[data-headerbg='color_12'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_12'] .header-right .notification_dropdown.search-area-header svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,\n[data-headerbg='color_12'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_12'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_12'] .header-right .notification_dropdown .bell-link svg path {\n\tstroke: #fff;\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,\n[data-headerbg='color_12'] .header-right .notification_dropdown .search-area svg path {\n\tfill: var(--primary);\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,\n[data-headerbg='color_12'] .header-right .header-profile2 .dropdown-menu a span {\n\tcolor: #000;\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_12'] .header-right .bootstrap-select .btn {\n\tbackground-color: #00496d !important;\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,\n[data-headerbg='color_12'] .header-right .bootstrap-select.countrypicker {\n\tborder-color: #00496d !important;\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_12'] .header-right .bootstrap-select .btn {\n\tcolor: #fff !important;\n\tborder-color: #00496d !important;\n}\n[data-headerbg='color_12'][data-theme-version='dark'] .hamburger .line,\n[data-headerbg='color_12'] .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n[data-headerbg='color_13'][data-theme-version='dark'],\n[data-headerbg='color_13'] {\n\t--headerbg: #432d29;\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .header.is-fixed,\n[data-headerbg='color_13'] .header.is-fixed {\n\tborder-color: #63423c !important;\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .header,\n[data-headerbg='color_13'] .header {\n\tborder: 0;\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .header-left .dashboard_bar,\n[data-headerbg='color_13'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .hamburger svg rect,\n[data-headerbg='color_13'] .hamburger svg rect {\n\tfill: #fff;\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .header-right,\n[data-headerbg='color_13'] .header-right {\n\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,\n[data-headerbg='color_13'] .header-right .notification_dropdown .nav-link {\n\tbackground-color: #63423c;\n\tborder-color: #63423c;\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,\n[data-headerbg='color_13'] .header-right .notification_dropdown .nav-link .setting-svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,\n[data-headerbg='color_13'] .header-right .notification_dropdown .menu-wallet svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,\n[data-headerbg='color_13'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_13'] .header-right .notification_dropdown.search-area-header svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,\n[data-headerbg='color_13'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_13'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_13'] .header-right .notification_dropdown .bell-link svg path {\n\tstroke: #fff;\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,\n[data-headerbg='color_13'] .header-right .notification_dropdown .search-area svg path {\n\tfill: var(--primary);\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,\n[data-headerbg='color_13'] .header-right .header-profile2 .dropdown-menu a span {\n\tcolor: #000;\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_13'] .header-right .bootstrap-select .btn {\n\tbackground-color: #63423c !important;\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,\n[data-headerbg='color_13'] .header-right .bootstrap-select.countrypicker {\n\tborder-color: #63423c !important;\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_13'] .header-right .bootstrap-select .btn {\n\tcolor: #fff !important;\n\tborder-color: #63423c !important;\n}\n[data-headerbg='color_13'][data-theme-version='dark'] .hamburger .line,\n[data-headerbg='color_13'] .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n[data-headerbg='color_14'][data-theme-version='dark'],\n[data-headerbg='color_14'] {\n\t--headerbg: #4885ed;\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .header.is-fixed,\n[data-headerbg='color_14'] .header.is-fixed {\n\tborder-color: #76a4f2 !important;\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .header,\n[data-headerbg='color_14'] .header {\n\tborder: 0;\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .header-left .dashboard_bar,\n[data-headerbg='color_14'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .hamburger svg rect,\n[data-headerbg='color_14'] .hamburger svg rect {\n\tfill: #fff;\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .header-right,\n[data-headerbg='color_14'] .header-right {\n\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,\n[data-headerbg='color_14'] .header-right .notification_dropdown .nav-link {\n\tbackground-color: #76a4f2;\n\tborder-color: #76a4f2;\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,\n[data-headerbg='color_14'] .header-right .notification_dropdown .nav-link .setting-svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,\n[data-headerbg='color_14'] .header-right .notification_dropdown .menu-wallet svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,\n[data-headerbg='color_14'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_14'] .header-right .notification_dropdown.search-area-header svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,\n[data-headerbg='color_14'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_14'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_14'] .header-right .notification_dropdown .bell-link svg path {\n\tstroke: #fff;\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,\n[data-headerbg='color_14'] .header-right .notification_dropdown .search-area svg path {\n\tfill: var(--primary);\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,\n[data-headerbg='color_14'] .header-right .header-profile2 .dropdown-menu a span {\n\tcolor: #000;\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_14'] .header-right .bootstrap-select .btn {\n\tbackground-color: #76a4f2 !important;\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,\n[data-headerbg='color_14'] .header-right .bootstrap-select.countrypicker {\n\tborder-color: #76a4f2 !important;\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_14'] .header-right .bootstrap-select .btn {\n\tcolor: #fff !important;\n\tborder-color: #76a4f2 !important;\n}\n[data-headerbg='color_14'][data-theme-version='dark'] .hamburger .line,\n[data-headerbg='color_14'] .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n[data-headerbg='color_15'][data-theme-version='dark'],\n[data-headerbg='color_15'] {\n\t--headerbg: #4cb32b;\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .header.is-fixed,\n[data-headerbg='color_15'] .header.is-fixed {\n\tborder-color: #63d140 !important;\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .header,\n[data-headerbg='color_15'] .header {\n\tborder: 0;\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .header-left .dashboard_bar,\n[data-headerbg='color_15'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .hamburger svg rect,\n[data-headerbg='color_15'] .hamburger svg rect {\n\tfill: #fff;\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .header-right,\n[data-headerbg='color_15'] .header-right {\n\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link,\n[data-headerbg='color_15'] .header-right .notification_dropdown .nav-link {\n\tbackground-color: #63d140;\n\tborder-color: #63d140;\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown .nav-link .setting-svg path,\n[data-headerbg='color_15'] .header-right .notification_dropdown .nav-link .setting-svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown .menu-wallet svg path,\n[data-headerbg='color_15'] .header-right .notification_dropdown .menu-wallet svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown.search-area-header svg path,\n[data-headerbg='color_15'] .header-right .notification_dropdown.bell-icon svg path,\n[data-headerbg='color_15'] .header-right .notification_dropdown.search-area-header svg path {\n\tfill: #fff;\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown .bell-link svg path,\n[data-headerbg='color_15'] .header-right .notification_dropdown .dz-theme-mode svg path,\n[data-headerbg='color_15'] .header-right .notification_dropdown .dz-fullscreen svg path,\n[data-headerbg='color_15'] .header-right .notification_dropdown .bell-link svg path {\n\tstroke: #fff;\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .header-right .notification_dropdown .search-area svg path,\n[data-headerbg='color_15'] .header-right .notification_dropdown .search-area svg path {\n\tfill: var(--primary);\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .header-right .header-profile2 .dropdown-menu a span,\n[data-headerbg='color_15'] .header-right .header-profile2 .dropdown-menu a span {\n\tcolor: #000;\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_15'] .header-right .bootstrap-select .btn {\n\tbackground-color: #63d140 !important;\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .header-right .bootstrap-select.countrypicker,\n[data-headerbg='color_15'] .header-right .bootstrap-select.countrypicker {\n\tborder-color: #63d140 !important;\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .header-right .bootstrap-select .btn,\n[data-headerbg='color_15'] .header-right .bootstrap-select .btn {\n\tcolor: #fff !important;\n\tborder-color: #63d140 !important;\n}\n[data-headerbg='color_15'][data-theme-version='dark'] .hamburger .line,\n[data-headerbg='color_15'] .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n@media (min-width: 62rem) {\n\t[data-container='boxed'] {\n\t\t--right-space: 0;\n\t\t/* .wallet-open .content-body{\n\t\t\tpadding-right: 0;\n\t\t} */\n\t}\n\t[data-container='boxed'] #main-wrapper {\n\t\tmax-width: 74.9375rem;\n\t\tmargin: 0 auto;\n\t\tbox-shadow: 0 0 1.875rem 0 rgba(0, 0, 0, 0.1);\n\t\toverflow: hidden;\n\t}\n\t[direction='rtl'][data-container='boxed'] #main-wrapper {\n\t\ttext-align: right;\n\t}\n\t[data-container='boxed'] .invoice-num {\n\t\tfont-size: 1.375rem;\n\t}\n\t[data-container='boxed'] .wallet-open .header .header-content {\n\t\tpadding-right: 1.875rem;\n\t}\n\t[data-container='boxed'] .wallet-bar {\n\t\tdisplay: none;\n\t}\n\t[data-container='boxed'] .nav-link.menu-wallet {\n\t\tdisplay: none;\n\t}\n\t[data-container='boxed'] .header-left .dashboard_bar {\n\t\tdisplay: none;\n\t}\n\t[data-container='boxed'] .footer.style-2 {\n\t\twidth: calc(100% - 3.625rem);\n\t}\n\t[data-container='boxed'] .footer.footer-outer {\n\t\twidth: calc(100% - 3.725rem);\n\t\tmargin-right: 1.875rem;\n\t}\n}\n\n@media only screen and (min-width: 84.375rem) {\n\t[data-layout='vertical'][data-sidebar-style='overlay'][data-container='boxed'][data-header-position='fixed'] .header {\n\t\twidth: 74.9375rem;\n\t}\n}\n\n@media only screen and (min-width: 75rem) and (max-width: 84.3125rem) {\n\t[data-layout='vertical'][data-sidebar-style='overlay'][data-container='boxed'][data-header-position='fixed'] .header {\n\t\twidth: 74.9375rem;\n\t}\n}\n\n[data-header-position='fixed'][data-layout='horizontal'][data-container='boxed'] .dlabnav {\n\tmax-width: 74.9375rem;\n}\n\n[data-header-position='fixed'][data-layout='horizontal'][data-container='boxed'] .content-body {\n\tpadding-top: 14rem !important;\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'] .header,\n[data-layout='horizontal'][data-container='boxed'][data-header-position='fixed'] .header {\n\twidth: 74.9375rem;\n}\n\n[data-layout='horizontal'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='mini'] .header {\n\twidth: 74.9375rem;\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='mini'] .footer.footer-outer {\n\twidth: calc(100% - 10.325rem);\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='mini'] .footer.out-footer.style-2 {\n\twidth: calc(100% - 9.625rem);\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='mini'] .footer.out-footer.style-1 {\n\twidth: calc(100% - 28.125rem);\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='compact'] .footer.footer-outer {\n\twidth: calc(100% - 15.225rem);\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='compact'] .footer.out-footer.style-2 {\n\twidth: calc(100% - 15.625rem);\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='compact'] .footer.out-footer.style-1 {\n\twidth: calc(100% - 33.225rem);\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='compact'] .header .header-content {\n\tpadding-right: 11.275rem;\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='overlay'] .footer.footer-outer {\n\twidth: calc(100% - 4.225rem);\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='overlay'] .footer.out-footer.style-2 {\n\twidth: calc(100% - 15.625rem);\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='overlay'] .footer.out-footer.style-1 {\n\twidth: calc(100% - 22.225rem);\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='overlay'] .header .header-content {\n\tpadding-right: 312px;\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='icon-hover'] .footer.footer-outer {\n\twidth: calc(100% - 9.725rem);\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='icon-hover'] .footer.out-footer.style-2 {\n\twidth: calc(100% - 15.625rem);\n}\n\n[data-layout='vertical'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='icon-hover'] .footer.out-footer.style-1 {\n\twidth: calc(100% - 22.225rem);\n}\n\n[data-layout='horizontal'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='full']\n\t.wallet-open.show.active.dlabnav-scroll {\n\tpadding-right: 0;\n}\n\n[data-layout='horizontal'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='compact']\n\t.wallet-open.show.active\n\t.dlabnav-scroll {\n\tpadding-right: 0;\n}\n\n[data-layout='horizontal'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='modern'] .footer.style-2 {\n\twidth: calc(100% - 3.625rem);\n\tmargin-left: auto;\n}\n\n[data-layout='horizontal'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='modern'] .footer.footer-outer {\n\twidth: calc(100% - 3.225rem);\n}\n\n[data-layout='horizontal'][data-container='boxed'][data-header-position='fixed'][data-sidebar-style='modern']\n\t.wallet-open.show.active.dlabnav-scroll {\n\tpadding-right: 0;\n}\n\n[data-container='boxed'] .metismenu.fixed {\n\tleft: auto;\n\tmax-width: 74.9375rem;\n}\n\n[data-container='boxed'] .page-titles {\n\tmargin-bottom: 3rem;\n\tpadding: 0.9375rem 0.9375rem;\n}\n\n[data-container='boxed'] .content-body .container-fluid,\n[data-container='boxed'] .content-body .container-sm,\n[data-container='boxed'] .content-body .container-md,\n[data-container='boxed'] .content-body .container-lg,\n[data-container='boxed'] .content-body .container-xl,\n[data-container='boxed'] .content-body .container-xxl {\n\tpadding: 1.875rem;\n}\n\n[data-container='boxed'][data-layout='vertical'] .page-titles {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n[data-layout='vertical'][data-container='boxed'][data-sidebar-position='fixed'][data-header-position='static'][data-sidebar-style='overlay']\n\t.nav-header {\n\tposition: absolute;\n}\n\n[data-layout='vertical'][data-container='boxed'][data-sidebar-position='fixed'][data-header-position='static'][data-sidebar-style='overlay']\n\t.menu-toggle\n\t.dlabnav {\n\tposition: absolute;\n}\n\n[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .dlabnav.fixed {\n\tleft: auto;\n\tmax-width: 74.9375rem;\n}\n\n[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .container-fluid,\n[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .container-sm,\n[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .container-md,\n[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .container-lg,\n[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .container-xl,\n[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .container-xxl {\n\tpadding-bottom: 0;\n}\n\n[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] {\n\t/* &[data-sidebar-style=\"full\"],\n\t&[data-sidebar-style=\"icon-hover\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 9rem;\n\t\t}\n\t} */\n\t/* &[data-sidebar-style=\"modern\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 6.5rem;\n\t\t}\n\t} */\n}\n[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'][data-sidebar-style='compact'] .content-body {\n\tpadding-top: 18rem !important;\n}\n[data-container='boxed'][data-sidebar-position='fixed'][data-layout='horizontal'][data-sidebar-style='mini'] .content-body {\n\tpadding-top: 10rem !important;\n}\n\n[data-container='boxed'] .nav-header,\n[data-container='wide-boxed'] .nav-header,\n[data-sidebar-position='static'][data-header-position='static'][data-layout='horizontal'] .nav-header {\n\theight: 5.5rem;\n}\n\n[data-container='boxed'][data-sidebar-position='static'][data-header-position='fixed'][data-layout='horizontal'] .nav-header {\n\theight: 5rem;\n}\n\n[data-container='boxed'][data-sidebar-position='static'][data-header-position='fixed'][data-layout='horizontal'][data-sidebar-style='mini']\n\t.content-body {\n\tpadding-top: 10rem !important;\n}\n\n[data-container='boxed'][data-sidebar-position='static'][data-header-position='fixed'][data-layout='horizontal'][data-sidebar-style='modern']\n\t.content-body {\n\tpadding-top: 6.5rem;\n}\n\n[data-container='wide-boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] {\n\t/* &[data-sidebar-style=\"full\"],\n\t&[data-sidebar-style=\"icon-hover\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 9rem;\n\t\t}\n\t} */\n\t/* &[data-sidebar-style=\"compact\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 7.5rem;\n\t\t}\n\t} */\n\t/* &[data-sidebar-style=\"modern\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 6.5rem;\n\t\t}\n\t} */\n}\n[data-container='wide-boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .footer.footer-outer {\n\twidth: calc(100% - 4.925rem);\n\tmargin-left: 2.6rem;\n}\n\n[data-container='wide-boxed'][data-sidebar-position='static'][data-layout='horizontal'][data-sidebar-style='compact']\n\t.header\n\t.header-content {\n\tmargin-left: 13.2rem;\n}\n\n[data-container='wide-boxed'] .nav-header,\n[data-container='boxed'] .nav-header,\n[data-container='wide'] .nav-header,\n[data-sidebar-position='static'][data-layout='horizontal'][data-header-position='static'] .nav-header {\n\theight: 5rem;\n\tz-index: 8;\n}\n\n[data-container='wide'][data-sidebar-position='fixed'][data-layout='horizontal'][data-sidebar-style='compact'] .header .header-content {\n\tmargin-left: 12.2rem;\n}\n\n[data-container='boxed'] .header-left .search-area {\n\tdisplay: none;\n}\n\n@media (min-width: 62rem) {\n\t[data-container='wide-boxed'] {\n\t\t--right-space: 0;\n\t}\n\t[data-container='wide-boxed'] #main-wrapper {\n\t\tmax-width: 92.5rem;\n\t\tmargin: 0 auto;\n\t\tbox-shadow: 0 0 1.875rem 0 rgba(0, 0, 0, 0.1);\n\t\toverflow: hidden;\n\t}\n\t[direction='rtl'][data-container='wide-boxed'] #main-wrapper {\n\t\ttext-align: right;\n\t}\n\t[data-container='wide-boxed'] .wallet-open .header .header-content {\n\t\tpadding-right: 1.875rem;\n\t}\n\t[data-container='wide-boxed'] .wallet-bar {\n\t\tdisplay: none;\n\t}\n\t[data-container='wide-boxed'] .nav-link.menu-wallet {\n\t\tdisplay: none;\n\t}\n\t[data-container='wide-boxed'] .footer.footer-outer {\n\t\twidth: calc(100% - 15.725rem);\n\t\tmargin-right: 1.875rem;\n\t}\n}\n\n@media only screen and (min-width: 84.375rem) {\n\t[data-layout='vertical'][data-sidebar-style='overlay'][data-container='wide-boxed'][data-header-position='fixed'] .header {\n\t\twidth: 92.5rem;\n\t}\n}\n\n@media only screen and (min-width: 75rem) and (max-width: 100rem) {\n\t[data-layout='vertical'][data-sidebar-style='overlay'][data-container='wide-boxed'][data-header-position='fixed'] .header {\n\t\twidth: 92.5rem;\n\t}\n}\n\n[data-layout='vertical'][data-sidebar-style='overlay'][data-container='wide-boxed'][data-header-position='fixed']\n\t.footer.out-footer.style-1 {\n\twidth: calc(100% - 23.525rem);\n\tmargin-right: 20.775rem;\n}\n\n[data-layout='vertical'][data-sidebar-style='overlay'][data-container='wide-boxed'][data-header-position='fixed'] .footer.footer-outer {\n\twidth: calc(100% - 4.725rem);\n\tmargin-right: 1.875rem;\n}\n\n[data-layout='vertical'][data-sidebar-style='overlay'][data-container='wide-boxed'][data-header-position='fixed']\n\t.footer.out-footer.style-2 {\n\twidth: calc(100% - 4.325rem);\n}\n\n[data-layout='vertical'][data-sidebar-style='overlay'][data-container='wide-boxed'][data-header-position='fixed'] .header .header-content {\n\tpadding-right: 19.875rem;\n}\n\n[data-layout='vertical'][data-sidebar-style='icon-hover'][data-container='wide-boxed'][data-header-position='fixed']\n\t.footer.out-footer.style-1 {\n\twidth: calc(100% - 28.725rem);\n\tmargin-right: 20.875rem;\n}\n\n[data-layout='vertical'][data-sidebar-style='icon-hover'][data-container='wide-boxed'][data-header-position='fixed'] .footer.footer-outer {\n\twidth: calc(100% - 9.725rem);\n\tmargin-right: 1.875rem;\n}\n\n[data-layout='vertical'][data-sidebar-style='icon-hover'][data-container='wide-boxed'][data-header-position='fixed']\n\t.footer.out-footer.style-2 {\n\twidth: calc(100% - 9.725rem);\n\tmargin-right: 1.875rem;\n}\n\n[data-layout='vertical'][data-sidebar-style='mini'][data-container='wide-boxed'][data-header-position='fixed'] .footer.out-footer.style-1 {\n\twidth: calc(100% - 28.525rem);\n\tmargin-right: 19.775rem;\n}\n\n[data-layout='vertical'][data-sidebar-style='mini'][data-container='wide-boxed'][data-header-position='fixed'] .footer.footer-outer {\n\twidth: calc(100% - 10.725rem);\n\tmargin-right: 1.875rem;\n}\n\n[data-layout='vertical'][data-sidebar-style='mini'][data-container='wide-boxed'][data-header-position='fixed'] .footer.out-footer.style-2 {\n\twidth: calc(100% - 11.125rem);\n}\n\n[data-sidebar-style='compact'][data-header-position='fixed'][data-container='wide-boxed'][data-layout='vertical'] .header {\n\twidth: 92.5rem;\n}\n[data-sidebar-style='compact'][data-header-position='fixed'][data-container='wide-boxed'][data-layout='vertical'] .header .header-content {\n\tpadding-left: 3rem !important;\n\twidth: calc(100% - 10.1rem);\n}\n\n[data-sidebar-style='compact'][data-header-position='fixed'][data-container='wide-boxed'][data-layout='vertical']\n\t.footer.out-footer.style-2 {\n\twidth: calc(100% - 15.625rem);\n}\n\n[data-sidebar-style='compact'][data-header-position='fixed'][data-container='wide-boxed'][data-layout='vertical']\n\t.footer.out-footer.style-1 {\n\twidth: calc(100% - 35.225rem);\n\tmargin-right: 20.975rem;\n}\n\n[data-header-position='fixed'][data-layout='horizontal'][data-container='wide-boxed'] .dlabnav {\n\tmax-width: 92.5rem;\n}\n\n[data-layout='vertical'][data-container='wide-boxed'][data-header-position='fixed'] .header,\n[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'] .header {\n\twidth: 92.5rem;\n}\n\n[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='mini'] .header {\n\twidth: 92.5rem;\n}\n\n[data-layout='vertical'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='full'] .header {\n\twidth: 92.5rem;\n}\n[data-layout='vertical'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='full'] .header .header-content {\n\tpadding-right: 19.875rem;\n}\n\n[data-layout='vertical'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='full'] .footer.footer-outer {\n\twidth: calc(100% - 21.725rem);\n\tmargin-right: 1.875rem;\n}\n\n[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='compact']\n\t.wallet-open.show.active\n\t.dlabnav-scroll {\n\tpadding-right: 0px;\n}\n\n[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='icon-hover']\n\t.footer.footer-outer {\n\twidth: calc(100% - 5.025rem);\n\tmargin-left: 1.775rem;\n}\n\n[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='icon-hover']\n\t.wallet-open.show.active\n\t.dlabnav-scroll {\n\tpadding-right: 0px;\n}\n\n[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='modern']\n\t.wallet-open.show.active\n\t.dlabnav-scroll {\n\tpadding-right: 0px;\n}\n\n[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='modern'] .header .header-content {\n\tpadding-right: 19.875rem;\n}\n\n[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='modern'] .footer.footer-outer {\n\twidth: calc(100% - 4.225rem);\n\tmargin-left: 2.775rem !important;\n}\n\n[data-layout='horizontal'][data-container='wide-boxed'][data-header-position='fixed'][data-sidebar-style='modern'] .footer.style-1 {\n\twidth: calc(100% - 24.225rem);\n\tmargin-left: 2.775rem !important;\n}\n\n[data-container='wide-boxed'] .metismenu.fixed {\n\tleft: auto;\n\tmax-width: 92.5rem;\n}\n\n[data-container='wide-boxed'] .page-titles {\n\tmargin-bottom: 3rem;\n\tpadding: 0.9375rem 0.9375rem;\n}\n\n[data-container='wide-boxed'] .content-body .container-fluid,\n[data-container='wide-boxed'] .content-body .container-sm,\n[data-container='wide-boxed'] .content-body .container-md,\n[data-container='wide-boxed'] .content-body .container-lg,\n[data-container='wide-boxed'] .content-body .container-xl,\n[data-container='wide-boxed'] .content-body .container-xxl {\n\tpadding: 2.5rem;\n}\n\n[data-container='wide-boxed'][data-layout='vertical'] .page-titles {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n[data-layout='vertical'][data-container='wide-boxed'][data-sidebar-position='fixed'][data-header-position='static'][data-sidebar-style='overlay']\n\t.nav-header {\n\tposition: absolute;\n}\n\n[data-layout='vertical'][data-container='wide-boxed'][data-sidebar-position='fixed'][data-header-position='static'][data-sidebar-style='overlay']\n\t.menu-toggle\n\t.dlabnav {\n\tposition: absolute;\n}\n\n[data-container='wide-boxed'][data-sidebar-position='fixed'][data-layout='horizontal'] .dlabnav.fixed {\n\tleft: auto;\n\tmax-width: 92.5rem;\n}\n\n[data-container='wide-boxed'][data-layout='horizontal'][data-header-position='fixed'][data-sidebar-style='icon-hover'] .content-body,\n[data-container='wide-boxed'][data-layout='horizontal'][data-header-position='fixed'][data-sidebar-style='full'] .content-body {\n\tpadding-top: 14rem;\n}\n\n[data-container='wide-boxed'][data-layout='horizontal'][data-header-position='fixed'][data-sidebar-style='compact'] .content-body,\n[data-container='wide-boxed'][data-layout='horizontal'][data-header-position='fixed'][data-sidebar-style='modern'] .content-body {\n\tpadding-top: 12rem;\n}\n\n[data-primary='color_2'] {\n\t--primary: #4d44b5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3d3690;\n\t--primary-dark: #1e1a46;\n\t--rgba-primary-1: rgba(77, 68, 181, 0.1);\n\t--rgba-primary-2: rgba(77, 68, 181, 0.2);\n\t--rgba-primary-3: rgba(77, 68, 181, 0.3);\n\t--rgba-primary-4: rgba(77, 68, 181, 0.4);\n\t--rgba-primary-5: rgba(77, 68, 181, 0.5);\n\t--rgba-primary-6: rgba(77, 68, 181, 0.6);\n\t--rgba-primary-7: rgba(77, 68, 181, 0.7);\n\t--rgba-primary-8: rgba(77, 68, 181, 0.8);\n\t--rgba-primary-9: rgba(77, 68, 181, 0.9);\n}\n\n[data-primary='color_3'] {\n\t--primary: #056468;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #033537;\n\t--primary-dark: black;\n\t--rgba-primary-1: rgba(5, 100, 104, 0.1);\n\t--rgba-primary-2: rgba(5, 100, 104, 0.2);\n\t--rgba-primary-3: rgba(5, 100, 104, 0.3);\n\t--rgba-primary-4: rgba(5, 100, 104, 0.4);\n\t--rgba-primary-5: rgba(5, 100, 104, 0.5);\n\t--rgba-primary-6: rgba(5, 100, 104, 0.6);\n\t--rgba-primary-7: rgba(5, 100, 104, 0.7);\n\t--rgba-primary-8: rgba(5, 100, 104, 0.8);\n\t--rgba-primary-9: rgba(5, 100, 104, 0.9);\n}\n\n[data-primary='color_4'] {\n\t--primary: #4d06a5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #360474;\n\t--primary-dark: #080111;\n\t--rgba-primary-1: rgba(77, 6, 165, 0.1);\n\t--rgba-primary-2: rgba(77, 6, 165, 0.2);\n\t--rgba-primary-3: rgba(77, 6, 165, 0.3);\n\t--rgba-primary-4: rgba(77, 6, 165, 0.4);\n\t--rgba-primary-5: rgba(77, 6, 165, 0.5);\n\t--rgba-primary-6: rgba(77, 6, 165, 0.6);\n\t--rgba-primary-7: rgba(77, 6, 165, 0.7);\n\t--rgba-primary-8: rgba(77, 6, 165, 0.8);\n\t--rgba-primary-9: rgba(77, 6, 165, 0.9);\n}\n\n[data-primary='color_5'] {\n\t--primary: #dc3545;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #bd2130;\n\t--primary-dark: #66121a;\n\t--rgba-primary-1: rgba(220, 53, 69, 0.1);\n\t--rgba-primary-2: rgba(220, 53, 69, 0.2);\n\t--rgba-primary-3: rgba(220, 53, 69, 0.3);\n\t--rgba-primary-4: rgba(220, 53, 69, 0.4);\n\t--rgba-primary-5: rgba(220, 53, 69, 0.5);\n\t--rgba-primary-6: rgba(220, 53, 69, 0.6);\n\t--rgba-primary-7: rgba(220, 53, 69, 0.7);\n\t--rgba-primary-8: rgba(220, 53, 69, 0.8);\n\t--rgba-primary-9: rgba(220, 53, 69, 0.9);\n}\n\n[data-primary='color_6'] {\n\t--primary: #fd7e14;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #dc6502;\n\t--primary-dark: #773701;\n\t--rgba-primary-1: rgba(253, 126, 20, 0.1);\n\t--rgba-primary-2: rgba(253, 126, 20, 0.2);\n\t--rgba-primary-3: rgba(253, 126, 20, 0.3);\n\t--rgba-primary-4: rgba(253, 126, 20, 0.4);\n\t--rgba-primary-5: rgba(253, 126, 20, 0.5);\n\t--rgba-primary-6: rgba(253, 126, 20, 0.6);\n\t--rgba-primary-7: rgba(253, 126, 20, 0.7);\n\t--rgba-primary-8: rgba(253, 126, 20, 0.8);\n\t--rgba-primary-9: rgba(253, 126, 20, 0.9);\n}\n\n[data-primary='color_7'] {\n\t--primary: #5155c3;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3a3ea7;\n\t--primary-dark: #20225b;\n\t--rgba-primary-1: rgba(81, 85, 195, 0.1);\n\t--rgba-primary-2: rgba(81, 85, 195, 0.2);\n\t--rgba-primary-3: rgba(81, 85, 195, 0.3);\n\t--rgba-primary-4: rgba(81, 85, 195, 0.4);\n\t--rgba-primary-5: rgba(81, 85, 195, 0.5);\n\t--rgba-primary-6: rgba(81, 85, 195, 0.6);\n\t--rgba-primary-7: rgba(81, 85, 195, 0.7);\n\t--rgba-primary-8: rgba(81, 85, 195, 0.8);\n\t--rgba-primary-9: rgba(81, 85, 195, 0.9);\n}\n\n[data-primary='color_8'] {\n\t--primary: #854df3;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #641df0;\n\t--primary-dark: #3c0b9c;\n\t--rgba-primary-1: rgba(133, 77, 243, 0.1);\n\t--rgba-primary-2: rgba(133, 77, 243, 0.2);\n\t--rgba-primary-3: rgba(133, 77, 243, 0.3);\n\t--rgba-primary-4: rgba(133, 77, 243, 0.4);\n\t--rgba-primary-5: rgba(133, 77, 243, 0.5);\n\t--rgba-primary-6: rgba(133, 77, 243, 0.6);\n\t--rgba-primary-7: rgba(133, 77, 243, 0.7);\n\t--rgba-primary-8: rgba(133, 77, 243, 0.8);\n\t--rgba-primary-9: rgba(133, 77, 243, 0.9);\n}\n\n[data-primary='color_9'] {\n\t--primary: #20c997;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #199d76;\n\t--primary-dark: #0b4534;\n\t--rgba-primary-1: rgba(32, 201, 151, 0.1);\n\t--rgba-primary-2: rgba(32, 201, 151, 0.2);\n\t--rgba-primary-3: rgba(32, 201, 151, 0.3);\n\t--rgba-primary-4: rgba(32, 201, 151, 0.4);\n\t--rgba-primary-5: rgba(32, 201, 151, 0.5);\n\t--rgba-primary-6: rgba(32, 201, 151, 0.6);\n\t--rgba-primary-7: rgba(32, 201, 151, 0.7);\n\t--rgba-primary-8: rgba(32, 201, 151, 0.8);\n\t--rgba-primary-9: rgba(32, 201, 151, 0.9);\n}\n\n[data-primary='color_10'] {\n\t--primary: #17a2b8;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #117a8b;\n\t--primary-dark: #062a30;\n\t--rgba-primary-1: rgba(23, 162, 184, 0.1);\n\t--rgba-primary-2: rgba(23, 162, 184, 0.2);\n\t--rgba-primary-3: rgba(23, 162, 184, 0.3);\n\t--rgba-primary-4: rgba(23, 162, 184, 0.4);\n\t--rgba-primary-5: rgba(23, 162, 184, 0.5);\n\t--rgba-primary-6: rgba(23, 162, 184, 0.6);\n\t--rgba-primary-7: rgba(23, 162, 184, 0.7);\n\t--rgba-primary-8: rgba(23, 162, 184, 0.8);\n\t--rgba-primary-9: rgba(23, 162, 184, 0.9);\n}\n\n[data-primary='color_11'] {\n\t--primary: #94618e;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #754d70;\n\t--primary-dark: #382435;\n\t--rgba-primary-1: rgba(148, 97, 142, 0.1);\n\t--rgba-primary-2: rgba(148, 97, 142, 0.2);\n\t--rgba-primary-3: rgba(148, 97, 142, 0.3);\n\t--rgba-primary-4: rgba(148, 97, 142, 0.4);\n\t--rgba-primary-5: rgba(148, 97, 142, 0.5);\n\t--rgba-primary-6: rgba(148, 97, 142, 0.6);\n\t--rgba-primary-7: rgba(148, 97, 142, 0.7);\n\t--rgba-primary-8: rgba(148, 97, 142, 0.8);\n\t--rgba-primary-9: rgba(148, 97, 142, 0.9);\n}\n\n[data-primary='color_12'] {\n\t--primary: #00273a;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #000507;\n\t--primary-dark: black;\n\t--rgba-primary-1: rgba(0, 39, 58, 0.1);\n\t--rgba-primary-2: rgba(0, 39, 58, 0.2);\n\t--rgba-primary-3: rgba(0, 39, 58, 0.3);\n\t--rgba-primary-4: rgba(0, 39, 58, 0.4);\n\t--rgba-primary-5: rgba(0, 39, 58, 0.5);\n\t--rgba-primary-6: rgba(0, 39, 58, 0.6);\n\t--rgba-primary-7: rgba(0, 39, 58, 0.7);\n\t--rgba-primary-8: rgba(0, 39, 58, 0.8);\n\t--rgba-primary-9: rgba(0, 39, 58, 0.9);\n}\n\n[data-primary='color_13'] {\n\t--primary: #432d29;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #231816;\n\t--primary-dark: black;\n\t--rgba-primary-1: rgba(67, 45, 41, 0.1);\n\t--rgba-primary-2: rgba(67, 45, 41, 0.2);\n\t--rgba-primary-3: rgba(67, 45, 41, 0.3);\n\t--rgba-primary-4: rgba(67, 45, 41, 0.4);\n\t--rgba-primary-5: rgba(67, 45, 41, 0.5);\n\t--rgba-primary-6: rgba(67, 45, 41, 0.6);\n\t--rgba-primary-7: rgba(67, 45, 41, 0.7);\n\t--rgba-primary-8: rgba(67, 45, 41, 0.8);\n\t--rgba-primary-9: rgba(67, 45, 41, 0.9);\n}\n\n[data-primary='color_14'] {\n\t--primary: #4885ed;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #1a66e8;\n\t--primary-dark: #0e3d8e;\n\t--rgba-primary-1: rgba(72, 133, 237, 0.1);\n\t--rgba-primary-2: rgba(72, 133, 237, 0.2);\n\t--rgba-primary-3: rgba(72, 133, 237, 0.3);\n\t--rgba-primary-4: rgba(72, 133, 237, 0.4);\n\t--rgba-primary-5: rgba(72, 133, 237, 0.5);\n\t--rgba-primary-6: rgba(72, 133, 237, 0.6);\n\t--rgba-primary-7: rgba(72, 133, 237, 0.7);\n\t--rgba-primary-8: rgba(72, 133, 237, 0.8);\n\t--rgba-primary-9: rgba(72, 133, 237, 0.9);\n}\n\n[data-primary='color_15'] {\n\t--primary: #4cb32b;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3b8a21;\n\t--primary-dark: #18380d;\n\t--rgba-primary-1: rgba(76, 179, 43, 0.1);\n\t--rgba-primary-2: rgba(76, 179, 43, 0.2);\n\t--rgba-primary-3: rgba(76, 179, 43, 0.3);\n\t--rgba-primary-4: rgba(76, 179, 43, 0.4);\n\t--rgba-primary-5: rgba(76, 179, 43, 0.5);\n\t--rgba-primary-6: rgba(76, 179, 43, 0.6);\n\t--rgba-primary-7: rgba(76, 179, 43, 0.7);\n\t--rgba-primary-8: rgba(76, 179, 43, 0.8);\n\t--rgba-primary-9: rgba(76, 179, 43, 0.9);\n}\n\n[data-typography='opensans'] {\n\tfont-family: 'Open Sans', sans-serif;\n}\n\n[data-typography='poppins'] {\n\tfont-family: 'poppins', sans-serif;\n}\n\n[data-typography='Nunito'] {\n\tfont-family: 'Nunito Sans', sans-serif;\n}\n\n[data-typography='roboto'] {\n\tfont-family: 'Roboto', sans-serif;\n}\n\n[data-typography='helvetica'] {\n\tfont-family: 'HelveticaNeue';\n}\n\n:root {\n\t--primary: #4d44b5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3d3690;\n\t--primary-dark: #1e1a46;\n\t--rgba-primary-1: rgba(77, 68, 181, 0.1);\n\t--rgba-primary-2: rgba(77, 68, 181, 0.2);\n\t--rgba-primary-3: rgba(77, 68, 181, 0.3);\n\t--rgba-primary-4: rgba(77, 68, 181, 0.4);\n\t--rgba-primary-5: rgba(77, 68, 181, 0.5);\n\t--rgba-primary-6: rgba(77, 68, 181, 0.6);\n\t--rgba-primary-7: rgba(77, 68, 181, 0.7);\n\t--rgba-primary-8: rgba(77, 68, 181, 0.8);\n\t--rgba-primary-9: rgba(77, 68, 181, 0.9);\n\t--rgba-secondary-1: rgba(251, 125, 91, 0.1);\n\t--rgba-secondary-2: rgba(251, 125, 91, 0.2);\n\t--rgba-secondary-3: rgba(251, 125, 91, 0.3);\n\t--rgba-secondary-4: rgba(251, 125, 91, 0.4);\n\t--rgba-secondary-5: rgba(251, 125, 91, 0.5);\n\t--rgba-secondary-6: rgba(251, 125, 91, 0.6);\n\t--rgba-secondary-7: rgba(251, 125, 91, 0.7);\n\t--rgba-secondary-8: rgba(251, 125, 91, 0.8);\n\t--rgba-secondary-9: rgba(251, 125, 91, 0.9);\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--title: #303972;\n}\n\n[data-theme-version='transparent'] {\n\tbackground-repeat: no-repeat;\n\tbackground-attachment: fixed;\n\tbackground-size: cover;\n\tbackground-position: center;\n\tposition: relative;\n\tcolor: #fff;\n}\n[data-theme-version='transparent'] h1,\n[data-theme-version='transparent'] .h1,\n[data-theme-version='transparent'] h2,\n[data-theme-version='transparent'] .h2,\n[data-theme-version='transparent'] h3,\n[data-theme-version='transparent'] .h3,\n[data-theme-version='transparent'] h4,\n[data-theme-version='transparent'] .h4,\n[data-theme-version='transparent'] h5,\n[data-theme-version='transparent'] .h5,\n[data-theme-version='transparent'] h6,\n[data-theme-version='transparent'] .h6 {\n\tcolor: #fff !important;\n}\n[data-theme-version='transparent'] a.link {\n\tcolor: #ddd;\n}\n[data-theme-version='transparent'] a.link:focus,\n[data-theme-version='transparent'] a.link:hover {\n\tcolor: #00ada3;\n}\n[data-theme-version='transparent'] a {\n\tcolor: #fff;\n}\n[data-theme-version='transparent'] a:hover {\n\tcolor: #7e8dbf;\n}\n[data-theme-version='transparent'] .border-right {\n\tborder-right: 1px solid rgba(255, 255, 255, 0.1) !important;\n}\n[data-theme-version='transparent'] .border-left {\n\tborder-left: 1px solid rgba(255, 255, 255, 0.1) !important;\n}\n[data-theme-version='transparent'] .border-top {\n\tborder-top: 1px solid rgba(255, 255, 255, 0.1) !important;\n}\n[data-theme-version='transparent'] .border-bottom {\n\tborder-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;\n}\n[data-theme-version='transparent'] .border {\n\tborder: 1px solid rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='transparent'] .dropdown-menu {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='transparent'] .dropdown-item:hover,\n[data-theme-version='transparent'] .dropdown-item:focus {\n\tbackground-color: #202020;\n\tcolor: #fff;\n}\n\n[data-theme-version='transparent'] .form-control {\n\tbackground-color: #202020;\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #fff;\n}\n\n[data-theme-version='transparent'] .card {\n\tbackground-color: rgba(0, 0, 0, 0.15);\n}\n\n[data-theme-version='transparent'] .header {\n\tbackground-color: rgba(0, 0, 0, 0.15);\n}\n\n[data-theme-version='transparent'] .header-left input {\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #fff;\n}\n[data-theme-version='transparent'] .header-left input:focus {\n\tbox-shadow: none;\n\tborder-color: var(--primary);\n}\n[data-theme-version='transparent'] .header-left input::placeholder {\n\tcolor: #fff;\n}\n\n[data-theme-version='transparent'] .header-right .dropdown .nav-link:hover {\n\tcolor: #fff;\n}\n\n[data-theme-version='transparent'] .header-right .notification_dropdown .dropdown-item a {\n\tcolor: #fff;\n}\n\n[data-theme-version='transparent'] .nav-header,\n[data-theme-version='transparent'] .nav-control {\n\tbackground-color: rgba(0, 0, 0, 0.15) !important;\n}\n\n[data-theme-version='transparent'] .nav-control {\n\tcolor: #fff;\n}\n\n[data-theme-version='transparent'] .brand-logo {\n\tcolor: #fff;\n}\n[data-theme-version='transparent'] .brand-logo:hover {\n\tcolor: #fff;\n}\n\n[data-theme-version='transparent'] .nav-header,\n[data-theme-version='transparent'] .nav-control {\n\tbackground-color: rgba(0, 0, 0, 0.15) !important;\n}\n\n[data-theme-version='transparent'] .nav-control {\n\tcolor: #fff;\n}\n\n[data-theme-version='transparent'] .brand-logo {\n\tcolor: #fff;\n}\n[data-theme-version='transparent'] .brand-logo:hover {\n\tcolor: #fff;\n}\n\n[data-theme-version='transparent'] .dlabnav {\n\tbackground-color: rgba(0, 0, 0, 0.15) !important;\n}\n[data-theme-version='transparent'] .dlabnav .metismenu > li > a {\n\tcolor: rgba(0, 0, 0, 0.15);\n}\n[data-theme-version='transparent'] .dlabnav .metismenu > li:hover > a,\n[data-theme-version='transparent'] .dlabnav .metismenu > li:focus > a,\n[data-theme-version='transparent'] .dlabnav .metismenu > li.mm-active > a {\n\tbackground-color: rgba(0, 0, 0, 0.15) !important;\n\tcolor: #fff;\n}\n[data-theme-version='transparent'] .dlabnav .metismenu > li:hover > a::after,\n[data-theme-version='transparent'] .dlabnav .metismenu > li:focus > a::after,\n[data-theme-version='transparent'] .dlabnav .metismenu > li.mm-active > a::after {\n\tborder-color: transparent transparent #fff transparent;\n}\n[data-theme-version='transparent'] .dlabnav .metismenu > li.mm-active ul ul {\n\tbackground-color: transparent;\n}\n[data-theme-version='transparent'] .dlabnav .metismenu ul {\n\tbackground-color: rgba(0, 0, 0, 0.15);\n}\n[data-theme-version='transparent'] .dlabnav .metismenu ul a:hover,\n[data-theme-version='transparent'] .dlabnav .metismenu ul a:focus,\n[data-theme-version='transparent'] .dlabnav .metismenu ul a.mm-active {\n\tcolor: #fff;\n}\n[data-theme-version='transparent'] .dlabnav .metismenu a {\n\tcolor: rgba(0, 0, 0, 0.15);\n}\n[data-theme-version='transparent'] .dlabnav .metismenu ul {\n\tbackground-color: rgba(0, 0, 0, 0.15) !important;\n}\n[data-theme-version='transparent'] .dlabnav .metismenu .has-arrow:after {\n\tborder-color: transparent transparent rgba(0, 0, 0, 0.15) transparent;\n}\n\n:root {\n\t--primary: #4d44b5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3d3690;\n\t--primary-dark: #1e1a46;\n\t--rgba-primary-1: rgba(77, 68, 181, 0.1);\n\t--rgba-primary-2: rgba(77, 68, 181, 0.2);\n\t--rgba-primary-3: rgba(77, 68, 181, 0.3);\n\t--rgba-primary-4: rgba(77, 68, 181, 0.4);\n\t--rgba-primary-5: rgba(77, 68, 181, 0.5);\n\t--rgba-primary-6: rgba(77, 68, 181, 0.6);\n\t--rgba-primary-7: rgba(77, 68, 181, 0.7);\n\t--rgba-primary-8: rgba(77, 68, 181, 0.8);\n\t--rgba-primary-9: rgba(77, 68, 181, 0.9);\n\t--rgba-secondary-1: rgba(251, 125, 91, 0.1);\n\t--rgba-secondary-2: rgba(251, 125, 91, 0.2);\n\t--rgba-secondary-3: rgba(251, 125, 91, 0.3);\n\t--rgba-secondary-4: rgba(251, 125, 91, 0.4);\n\t--rgba-secondary-5: rgba(251, 125, 91, 0.5);\n\t--rgba-secondary-6: rgba(251, 125, 91, 0.6);\n\t--rgba-secondary-7: rgba(251, 125, 91, 0.7);\n\t--rgba-secondary-8: rgba(251, 125, 91, 0.8);\n\t--rgba-secondary-9: rgba(251, 125, 91, 0.9);\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--title: #303972;\n}\n\n[data-theme-version='dark'] {\n\tbackground: #202020;\n\tcolor: rgba(255, 255, 255, 0.6);\n\t--nav-headbg: #272738;\n\t--sidebar-bg: #202020;\n\t--headerbg: #272738;\n}\n[data-theme-version='dark'] h1,\n[data-theme-version='dark'] .h1,\n[data-theme-version='dark'] h2,\n[data-theme-version='dark'] .h2,\n[data-theme-version='dark'] h3,\n[data-theme-version='dark'] .h3,\n[data-theme-version='dark'] h4,\n[data-theme-version='dark'] .h4,\n[data-theme-version='dark'] h5,\n[data-theme-version='dark'] .h5,\n[data-theme-version='dark'] h6,\n[data-theme-version='dark'] .h6 {\n\tcolor: #fff !important;\n}\n[data-theme-version='dark'] a.link {\n\tcolor: #ddd;\n}\n[data-theme-version='dark'] a.link:focus,\n[data-theme-version='dark'] a.link:hover {\n\tcolor: #00ada3;\n}\n[data-theme-version='dark'] a:hover {\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .border-right {\n\tborder-right: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;\n}\n[data-theme-version='dark'] .border-left {\n\tborder-left: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;\n}\n[data-theme-version='dark'] .border-top {\n\tborder-top: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;\n}\n[data-theme-version='dark'] .border-bottom {\n\tborder-bottom: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;\n}\n[data-theme-version='dark'] .border {\n\tborder: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .card {\n\tbackground-color: #272738;\n\tbox-shadow: none;\n}\n\n[data-theme-version='dark'] .dropdown-menu {\n\tbackground-color: #272738;\n\tbox-shadow: 0rem 0rem 0rem 0.0625rem rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .dropdown-menu .dropdown-item {\n\tcolor: #777777;\n}\n[data-theme-version='dark'] .dropdown-menu .dropdown-item.selected,\n[data-theme-version='dark'] .dropdown-menu .dropdown-item.selected.active,\n[data-theme-version='dark'] .dropdown-menu .dropdown-item.active,\n[data-theme-version='dark'] .dropdown-menu .dropdown-item:hover,\n[data-theme-version='dark'] .dropdown-menu .dropdown-item:focus {\n\tbackground-color: #272738;\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] a {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .btn-link g [fill] {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .btn-light:active,\n[data-theme-version='dark'] .btn-light:focus,\n[data-theme-version='dark'] .btn-light:hover {\n\tcolor: #000;\n}\n\n[data-theme-version='dark'] .form-control {\n\tbackground-color: #202020;\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .modal-content {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .modal-footer,\n[data-theme-version='dark'] .modal-header {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .close {\n\tfont-weight: 400;\n\tcolor: #fff;\n\ttext-shadow: none;\n}\n[data-theme-version='dark'] .close:hover {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .star-rating .product-review,\n[data-theme-version='dark'] .new-arrival-content .item {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .custom-dropdown .dropdown-menu {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .widget-stat .media > span {\n\tbackground: rgba(255, 255, 255, 0.1);\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .plus-minus-input .custom-btn {\n\tbackground: #202020;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dropdown-divider,\n[data-theme-version='dark'] .size-filter ul li {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .custom-select {\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #7e8dbf;\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .nav-tabs {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .mail-list .list-group-item.active i {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] hr {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .grid-col {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .noUi-target {\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tborder-radius: 0.5rem;\n\tbox-shadow: none;\n}\n[data-theme-version='dark'] .noUi-target .noUi-connects {\n\tbackground: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .noUi-marker-large,\n[data-theme-version='dark'] .noUi-marker {\n\tbackground: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .input-group-text {\n\tbackground: #272738;\n\tcolor: #fff;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .note-editor.note-frame {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .note-editor.note-frame .btn {\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .note-editor.note-frame .note-editing-area .note-editable {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .widget-media .timeline .timeline-panel {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .notification_dropdown .dropdown-menu-right .all-notification {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] #user-activity .nav-tabs .nav-link {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] #user-activity .nav-tabs .nav-link.active {\n\tbackground: #202020;\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .list-group-item-action {\n\tcolor: #a098ae;\n}\n\n[data-theme-version='dark'] .list-group-item-action:focus,\n[data-theme-version='dark'] .list-group-item-action:hover,\n[data-theme-version='dark'] .list-group-item-action:focus {\n\tbackground-color: #202020;\n\tborder-color: #202020;\n}\n\n[data-theme-version='dark'] .list-group-item.active {\n\tcolor: #fff;\n\tborder-color: var(--primary);\n}\n[data-theme-version='dark'] .list-group-item.active:focus,\n[data-theme-version='dark'] .list-group-item.active:hover,\n[data-theme-version='dark'] .list-group-item.active:focus {\n\tbackground-color: var(--primary);\n\tborder-color: var(--primary);\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .swal2-popup {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .form-head .btn-outline-primary {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .form-head .btn-outline-primary:hover {\n\tborder-color: var(--primary);\n}\n\n[data-theme-version='dark'] .review-tab.nav-pills li a.nav-link.active {\n\tbackground: transparent;\n}\n\n[data-theme-version='dark'] .new-arrival-content h4 a,\n[data-theme-version='dark'] .new-arrival-content .h4 a {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .text-black {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .abilities-chart .ct-chart .ct-label {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .morris_chart_height text tspan {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .btn-link {\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .btn-link svg path {\n\tstroke: #fff;\n}\n\n[data-theme-version='dark'] .order-bg {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .detault-daterange {\n\tbackground: #202020;\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .detault-daterange .input-group-text {\n\tbackground: #272738;\n\tborder: 0;\n}\n\n[data-theme-version='dark'] .dataTablesCard {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='dark'] .compose-content .dropzone {\n\tbackground: #202020 !important;\n}\n[data-theme-version='dark'] .compose-content .dropzone .dlab-message .dlab-button {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .daterangepicker {\n\tbackground: #202020;\n\tborder-color: var(--primary);\n}\n[data-theme-version='dark'] .daterangepicker .calendar-table {\n\tborder-color: var(--primary);\n\tbackground: #202020;\n}\n[data-theme-version='dark'] .daterangepicker .calendar-table .table-condensed td:hover {\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .daterangepicker:after {\n\tborder-bottom: 0.375rem solid #202020;\n}\n\n[data-theme-version='dark'] .daterangepicker select.hourselect,\n[data-theme-version='dark'] .daterangepicker select.minuteselect,\n[data-theme-version='dark'] .daterangepicker select.secondselect,\n[data-theme-version='dark'] .daterangepicker select.ampmselect {\n\tbackground: #202020;\n\tborder: 0.0625rem solid rgba(255, 255, 255, 0.1);\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .daterangepicker td.off,\n[data-theme-version='dark'] .daterangepicker td.off.in-range,\n[data-theme-version='dark'] .daterangepicker td.off.start-date,\n[data-theme-version='dark'] .daterangepicker td.off.end-date {\n\tbackground-color: #272738;\n}\n[data-theme-version='dark'] .daterangepicker td.off:hover,\n[data-theme-version='dark'] .daterangepicker td.off.in-range:hover,\n[data-theme-version='dark'] .daterangepicker td.off.start-date:hover,\n[data-theme-version='dark'] .daterangepicker td.off.end-date:hover {\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .round .checkmark {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .round:hover input ~ .checkmark {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .round span {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .app-fullcalendar .fc-button {\n\tbackground-color: #202020;\n\tborder-color: var(--primary);\n\tcolor: #fff;\n\ttext-shadow: none;\n}\n[data-theme-version='dark'] .app-fullcalendar .fc-button:hover,\n[data-theme-version='dark'] .app-fullcalendar .fc-button.fc-stat-hover {\n\tbackground-color: var(--primary);\n}\n\n[data-theme-version='dark'] .swal2-popup .swal2-styled:focus {\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.125rem rgba(255, 255, 255, 0.1), 0 0 0 0.25rem var(--rgba-primary-1);\n}\n\n[data-theme-version='dark'] .dd-handle {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #272738 !important;\n}\n\n[data-theme-version='dark'] .header-right .notification_dropdown .nav-link {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .nav-tabs .nav-link:hover,\n[data-theme-version='dark'] .nav-tabs .nav-link.active {\n\tborder-color: transparent;\n\tbackground: transparent;\n\tcolor: white !important;\n}\n\n[data-theme-version='dark'] .clockpicker-popover .popover-content {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='dark'] .clockpicker-plate {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .clockpicker-popover .popover-title {\n\tbackground-color: #202020;\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link span {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link:after {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.active:after,\n[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.done:after {\n\tbackground: var(--primary);\n}\n\n[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.active span,\n[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.done span {\n\tbackground: var(--primary);\n}\n\n[data-theme-version='dark'] .check-switch .custom-control-label:after,\n[data-theme-version='dark'] .check-switch .custom-control-label:before {\n\tborder-color: var(--primary);\n}\n\n[data-theme-version='dark'] .fc-unthemed .fc-today {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .fc-unthemed .fc-divider,\n[data-theme-version='dark'] .fc-unthemed .fc-list-heading td,\n[data-theme-version='dark'] .fc-unthemed .fc-popover .fc-header {\n\tbackground: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .picker__box {\n\tbackground: #202020;\n}\n[data-theme-version='dark'] .picker__box .picker__button--clear,\n[data-theme-version='dark'] .picker__box .picker__button--close,\n[data-theme-version='dark'] .picker__box .picker__button--today {\n\tbackground: #272738;\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .picker__box .picker__button--clear:hover:before,\n[data-theme-version='dark'] .picker__box .picker__button--close:hover:before,\n[data-theme-version='dark'] .picker__box .picker__button--today:hover:before {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .picker {\n\tcolor: #999;\n}\n\n[data-theme-version='dark'] .dtp > .dtp-content {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .dtp table.dtp-picker-days tr > td > a {\n\tcolor: #68686a;\n}\n[data-theme-version='dark'] .dtp table.dtp-picker-days tr > td > a.selected {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .order-request tbody tr {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .card-list li {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .card-bx .change-btn:hover {\n\tcolor: var(--primary);\n}\n\n[data-theme-version='dark'] .invoice-card.bg-warning {\n\tbackground-color: #5b3c1f !important;\n}\n\n[data-theme-version='dark'] .invoice-card.bg-success {\n\tbackground-color: #2a6729 !important;\n}\n\n[data-theme-version='dark'] .invoice-card.bg-info {\n\tbackground-color: #4c276a !important;\n}\n\n[data-theme-version='dark'] .invoice-card.bg-secondary {\n\tbackground-color: #1c3e52 !important;\n}\n\n[data-theme-version='dark'] .user-list li {\n\tborder-color: #272738;\n}\n\n[data-theme-version='dark'] .toggle-switch {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .bar-chart .apexcharts-text tspan {\n\tfill: #969ba0;\n}\n\n[data-theme-version='dark'] .bar-chart line {\n\tstroke: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .accordion.style-1 .accordion-item,\n[data-theme-version='dark'] .invoice-list,\n[data-theme-version='dark'] .form-check-input[type='checkbox'] {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .accordion.style-1 .accordion-header.collapsed .user-info a,\n[data-theme-version='dark'] .accordion.style-1 .accordion-header.collapsed .user-info,\n[data-theme-version='dark'] .accordion.style-1 .accordion-header.collapsed > span {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .ic-card > a {\n\tbackground: #25479f;\n}\n[data-theme-version='dark'] .ic-card > a:first-child {\n\tborder-color: #25479f;\n}\n\n[data-theme-version='dark'] .ic-card span {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] table.dataTable thead th,\n[data-theme-version='dark'] table.dataTable thead td {\n\tborder-color: #272738 !important;\n}\n\n[data-theme-version='dark'] .form-check .form-check-input:checked {\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n\n[data-theme-version='dark'] .dataTables_info {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate span .paginate_button.current,\n[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate span .paginate_button:hover {\n\tbackground: var(--primary);\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .dashboard-select {\n\tbackground: #272738;\n\tcolor: white !important;\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .dashboard-select .list {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .dashboard-select .option:hover,\n[data-theme-version='dark'] .dashboard-select .option.focus,\n[data-theme-version='dark'] .dashboard-select .option.selected.focus {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .card-tabs.style-1 .nav-tabs {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .transaction-details {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .description {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .apexcharts-legend-text {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .area-theme line {\n\tstroke: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .transaction-details .amount-bx {\n\tbackground: #272738;\n}\n[data-theme-version='dark'] .transaction-details .amount-bx i {\n\tbackground: #8d3b0c;\n}\n\n[data-theme-version='dark'] .nice-select .option {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .nice-select .option:hover,\n[data-theme-version='dark'] .nice-select .option.focus,\n[data-theme-version='dark'] .nice-select .option.selected.focus {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .card-tabs.style-1 {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .nice-select .list {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .table-search .input-group .input-group-text {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .dark-btn svg path {\n\tstroke: #fff;\n}\n\n[data-theme-version='dark'] .bar-chart .apexcharts-legend-text {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .Sales tspan {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .timeline-chart rect {\n\tfill: #202020;\n}\n\n[data-theme-version='dark'] .header-info span {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .ck-editor__editable {\n\tbackground: #202020 !important;\n}\n\n[data-theme-version='dark'] .ck.ck-editor .ck.ck-toolbar {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .ck.ck-toolbar .ck.ck-toolbar__separator {\n\tbackground: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .search-area .form-control {\n\tbackground: #202020;\n\tborder: none;\n}\n[data-theme-version='dark'] .search-area .form-control:hover {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .search-area .input-group-text {\n\tbackground: #202020;\n\tborder: none;\n}\n\n[data-theme-version='dark'] .chartBarRunning tspan {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .chartBarRunning line {\n\tstroke: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .reservationChart tspan {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .reservationChart line {\n\tstroke: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .table-condensed i:hover {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .booking-calender thead .picker-switch {\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .booking-calender thead .picker-switch:hover {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .booking-calender .prev:hover,\n[data-theme-version='dark'] .booking-calender .next:hover {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .booking-calender tbody tr .day {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .booking-calender thead .dow {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .customer-search .search-area .form-control {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .customer-search .search-area .input-group-text {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .paging_simple_numbers.dataTables_paginate {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .primary-icon path {\n\tstroke: #fff;\n}\n\n[data-theme-version='dark'] .pagin {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .nav-header .brand-title .brand-sub-title {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .dashboard-calendar .fc-daygrid-day-frame.fc-scrollgrid-sync-inner {\n\tbackground: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dashboard-calendar .fc-non-business {\n\tbackground: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dashboard-calendar .fc-daygrid-day-number {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .event-calend .fc .fc-button-group > .fc-button {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dashboard-calendar .fc-theme-standard td,\n[data-theme-version='dark'] .dashboard-calendar .fc-theme-standard th {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dashboard-calendar .fc .fc-daygrid-more-link {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .fc-theme-standard td,\n[data-theme-version='dark'] .fc-theme-standard th {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .fc-theme-standard .fc-scrollgrid.fc-scrollgrid-liquid,\n[data-theme-version='dark'] .fc-scrollgrid,\n[data-theme-version='dark'] table {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .fc-direction-ltr .fc-daygrid-event.fc-event-end,\n[data-theme-version='dark'] .fc-direction-rtl .fc-daygrid-event.fc-event-start {\n\tbackground: var(--primary);\n}\n\n[data-theme-version='dark'] .dlab-demo-panel .dlab-demo-inner {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .food-list-row {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .popover-body {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .swal2-popup .swal2-content {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .modal-header .close {\n\tbackground: none;\n}\n\n[data-theme-version='dark'] .timeline-panel .media-body small,\n[data-theme-version='dark'] .timeline-panel .media-body .small {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .chatbox .card-header p {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .date-ds-btn {\n\tbackground: #272738;\n\tcolor: white;\n}\n\n[data-theme-version='dark'] .food-list-row .media-bx h5 a,\n[data-theme-version='dark'] .food-list-row .media-bx .h5 a,\n[data-theme-version='dark'] .food-list-row .media-bx .h5 a {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .staff-bx .card-footer {\n\tbackground: #3f4056;\n}\n\n[data-theme-version='dark'] .page-titles .breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .table-striped > tbody > tr:nth-of-type(odd) > * {\n\tcolor: #706f6f;\n}\n\n[data-theme-version='dark'] .accordion .accordion-item {\n\tbackground: transparent;\n}\n\n[data-theme-version='dark'] .list-group-item {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .form-control-plaintext {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] label {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .form-control.custom-image-select-2 .filter-option-inner-inner {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .table tbody tr td {\n\tcolor: #7e8dbf;\n}\n\n[data-theme-version='dark'] .wallet-bar .order-history .price-list .chart-title .text-secondary {\n\tcolor: var(--secondary) !important;\n}\n\n[data-theme-version='dark'] .apexcharts-text tspan {\n\tfill: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .apexcharts-xaxis line {\n\tstroke: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .price-list .card-footer .text-secondary {\n\tcolor: var(--primary) !important;\n}\n\n[data-theme-version='dark'] .chart-title .text-pink {\n\tcolor: #eb62d0 !important;\n}\n\n[data-theme-version='dark'] .form-control.custom-image-select-2.style-1 .dropdown-toggle {\n\tbackground: rgba(172, 76, 188, 0.1) !important;\n}\n\n[data-theme-version='dark'] .form-control.custom-image-select-2 .dropdown-toggle {\n\tbackground: var(--rgba-primary-2) !important;\n}\n\n[data-theme-version='dark'] .transaction-table .card-body .table-responsive thead th {\n\tbackground: #202020;\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .market-chart .text-secondary {\n\tcolor: var(--secondary) !important;\n}\n[data-theme-version='dark'] .market-chart .text-secondary svg path {\n\tfill: var(--secondary);\n}\n\n[data-theme-version='dark'] .chart-title p {\n\tcolor: #7e8dbf;\n}\n\n[data-theme-version='dark'] .market-coin .coin-search-area .form-control {\n\tborder-color: #272738;\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .market-coin .coin-search-area .input-group-text {\n\tborder-color: #272738;\n\tbackground: #272738;\n}\n[data-theme-version='dark'] .market-coin .coin-search-area .input-group-text svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .market-coin .coin-box {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .market-overview .get-report {\n\tcolor: var(--primary) !important;\n}\n\n[data-theme-version='dark'] .coin-content .guest-calendar {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .coin-content .guest-calendar span svg path {\n\tfill: #fff;\n}\n[data-theme-version='dark'] .coin-content .guest-calendar .reportrange span {\n\tcolor: #7e8dbf;\n}\n\n[data-theme-version='dark'] .coin-content .default-select {\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #7e8dbf;\n}\n\n[data-theme-version='dark'] .digital-cash .media .media-content p {\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #7e8dbf;\n}\n\n[data-theme-version='dark'] .digital-cash .card-footer .btn {\n\tcolor: var(--primary) !important;\n}\n\n[data-theme-version='dark'] .form-control.custom-image-select-1 .dropdown-toggle {\n\tbackground: #202020 !important;\n\tcolor: #fff !important;\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .form-control.custom-image-select-1 .filter-option-inner-inner {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .coin-warpper .search-area .form-control {\n\tcolor: #7e8dbf;\n}\n\n[data-theme-version='dark'] .coin-warpper .search-area .input-group-text svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .form-wrapper.trade-form .input-group .input-group-text {\n\tbackground: #202020;\n\tcolor: #7e8dbf;\n}\n\n[data-theme-version='dark'] .market-overview .get-report,\n[data-theme-version='dark'] .market-preview,\n[data-theme-version='dark'] .market-overview .card-header h4,\n[data-theme-version='dark'] .market-overview .card-header .h4,\n[data-theme-version='dark'] .market-overview .card-header .h4,\n[data-theme-version='dark'] .form-wrapper.trade-form .input-group .form-control:focus,\n[data-theme-version='dark'] .coin-warpper .nav .nav-item {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .coin-warpper {\n\tbackground: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .coin-warpper .nav .nav-item .nav-link svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .daterangepicker .calendar-table .next span,\n[data-theme-version='dark'] .daterangepicker .calendar-table .prev span {\n\tborder-color: #fff;\n}\n\n[data-theme-version='dark'] .tbl-orders-style .tp-btn svg path {\n\tstroke: #fff;\n}\n\n[data-theme-version='dark'] .customer-search .search-area .input-group-text svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .student-tbl tbody tr td span .text-secondary {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .market-preview:hover {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .bg-ripple-hover thead tr th {\n\tcolor: #677686;\n}\n\n[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate span .paginate_button {\n\tcolor: #7e8dbf !important;\n}\n\n[data-theme-version='dark'] .portofolio .my-profile .media .media-img a,\n[data-theme-version='dark'] .portofolio .my-profile .portofolio-social li a {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .coin-holding {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .tp-btn svg path {\n\tstroke: #fff;\n}\n\n[data-theme-version='dark'] .copyright strong {\n\tcolor: #9fa4a6;\n}\n\n[data-theme-version='dark'] .support-box .info a {\n\tcolor: #000 !important;\n}\n\n[data-theme-version='dark'] .btn-icon-end {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .donut-chart-sale small,\n[data-theme-version='dark'] .donut-chart-sale .small,\n[data-theme-version='dark'] .donut-chart-sale .small,\n[data-theme-version='dark'] .donut-chart-sale .small {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .border-end {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .ck.ck-editor__main > .ck-editor__editable {\n\tbackground: #202020 !important;\n}\n\n[data-theme-version='dark'] .change-btn a:hover {\n\tcolor: #000;\n}\n\n[data-theme-version='dark'] .dlabnav .main-menu {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .nav-pills .nav-link.active,\n[data-theme-version='dark'] .nav-pills:hover .show > .nav-link {\n\tbackground: var(--rgba-secondary-1);\n\tcolor: var(--secondary);\n}\n\n[data-theme-version='dark'] .toggle-switch .form-check-input:checked:after {\n\tbackground: var(--secondary);\n}\n\n[data-theme-version='dark'] .nav-pills .nav-link:hover {\n\tcolor: var(--secondary);\n}\n\n[data-theme-version='dark'] .table.bg-primary-hover th {\n\tcolor: var(--secondary);\n}\n\n[data-theme-version='dark'] .table.bg-primary-hover tr:hover td,\n[data-theme-version='dark'] .table.bg-primary-hover tr:hover th {\n\tbackground: var(--secondary);\n}\n\n[data-theme-version='dark'] .get-report {\n\tcolor: var(--secondary);\n}\n\n[data-theme-version='dark'] .btn-close {\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 352 512'%3E%3C!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --%3E%3Cpath d='M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z' fill='%23fff'/%3E%3C/svg%3E\");\n}\n\n[data-theme-version='dark'] .coin-holding .coin-box-warper a {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .card .card-box-icon {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .toggle-btn .check {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .toggle-btn .check:after {\n\tbackground: #fff;\n}\n\n[data-theme-version='dark'] .toggle-btn input:checked ~ .check:after {\n\tdisplay: block;\n}\n\n[data-theme-version='dark'] .toggle-btn input:checked ~ .check {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .toggle-btn.expense .check:after {\n\tbackground-color: #fffa6f;\n}\n\n[data-theme-version='dark'] .bootstrap-select .btn {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] #wallet-bar {\n\tbackground-color: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .page-titles {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .tags .tag {\n\tcolor: #fff;\n\tbackground: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .server-content .progress {\n\tbackground-color: transparent;\n}\n\n[data-theme-version='dark'] .student .indox a::before {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] #redial circle {\n\tfill: white;\n}\n\n[data-theme-version='dark'] .dashboard-select .bootstrap-select .btn {\n\tbackground: #383844;\n}\n\n[data-theme-version='dark'] #activity line {\n\tstroke: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .quick-info {\n\tbackground-color: #202020;\n\tborder: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .pagination.no-bg li:not(.page-indicator):not(.active) .page-link {\n\tbackground: #202020;\n\tborder-color: transparent;\n}\n\n[data-theme-version='dark'] .lastest_trans .trans-table .doller,\n[data-theme-version='dark'] .table-pagenation p span,\n[data-theme-version='dark'] .email-list .message .hader,\n[data-theme-version='dark'] .email-list .message .col-mail-2 .date,\n[data-theme-version='dark'] .dz-card .card-footer {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .email-list .message:hover {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .print svg path {\n\tfill: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .right-box-padding.border-start {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .demo-right-inner {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='dark'] .dzm-tabs {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .notification p {\n\tcolor: #000;\n}\n\n[data-theme-version='dark'] .Modal-box {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='dark'] .Modal-box .box3 {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .lastest_trans .trans-table .print,\n[data-theme-version='dark'] .lastest_trans .trans-table .btn.tp-btn.btn-primary {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .lastest_trans .trans-table .btn.tp-btn.btn-primary {\n\tbackground-color: #202020;\n}\n[data-theme-version='dark'] .lastest_trans .trans-table .btn.tp-btn.btn-primary svg circle {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .lastest_trans .trans-table:hover {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .previews-info:hover {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] #activity1 line {\n\tstroke: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button.previous.disabled,\n[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button.next.disabled {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .plus-bx a {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .kanbanimg li span,\n[data-theme-version='dark'] .kanbanimg img {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .drive,\n[data-theme-version='dark'] .file-header,\n[data-theme-version='dark'] .folder-structure li,\n[data-theme-version='dark'] .file-drive,\n[data-theme-version='dark'] .input-group.search-area,\n[data-theme-version='dark'] .user-photo img,\n[data-theme-version='dark'] .messages .student,\n[data-theme-version='dark'] .fc .fc-button-group > .fc-button,\n[data-theme-version='dark'] .fc-daygrid-dot-event,\n[data-theme-version='dark'] .box-2 .flow,\n[data-theme-version='dark'] .type-massage,\n[data-theme-version='dark'] .chat-box-area .media .message-received .dz-media,\n[data-theme-version='dark'] .chat-left-area .chat-sidebar,\n[data-theme-version='dark'] .email-right-box .table-pagenation,\n[data-theme-version='dark'] .email-list .message {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .timeline-active li:before {\n\tbackground: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .selling .form_exchange .input_exchange .input-select {\n\tbackground-color: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .hamburger svg rect {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .file_area .table-pagenation {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .email-list {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .email-list .message .col-mail-2 .subject {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .email-right-box .table-pagenation,\n[data-theme-version='dark'] .email-right-box .pagination {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='dark'] .email-left-box .mail-list a {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .messages .input-group.search-area input.form-control,\n[data-theme-version='dark'] .messages .input-group.search-area .input-group-text {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .dz-info svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .message-box,\n[data-theme-version='dark'] .type-massage,\n[data-theme-version='dark'] .chat-box-area .media {\n\tbackground: #272738;\n\tcolor: white;\n}\n\n[data-theme-version='dark'] .chat-tabs .chat-bx:after,\n[data-theme-version='dark'] .message-box .input-group.search-area input.form-control,\n[data-theme-version='dark'] .message-box .input-group.search-area .input-group-text {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .search-coundry {\n\tbackground-color: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .search-coundry .bootstrap-select .btn {\n\tbackground: #272738 !important;\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-theme-version='dark'] .datepicker.datepicker-dropdown th.datepicker-switch {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n[data-theme-version='dark'] .datepicker.datepicker-dropdown th.datepicker-switch:hover {\n\tcolor: #000;\n}\n\n[data-theme-version='dark'] .datepicker.datepicker-dropdown {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .datepicker.datepicker-dropdown .datepicker-days .table-condensed td.day {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .notification_dropdown .dropdown-menu-end .all-notification {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .header-profile2 .dropdown-menu a span {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .profile-card .card-header,\n[data-theme-version='dark'] .profile-card {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .profile-form .form-label {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .author-profile .info-list li,\n[data-theme-version='dark'] .profile-card .card-footer,\n[data-theme-version='dark'] .author-profile .upload-link {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .author-profile .info-list li a,\n[data-theme-version='dark'] .author-profile .author-info span,\n[data-theme-version='dark'] .author-profile .info-list li span {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .author-profile .card-footer .form-control {\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tbackground: #202020 !important;\n}\n\n[data-theme-version='dark'] .header-profile2 .dropdown-menu .ai-icon:hover {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .wallet-bar .closed-icon {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .select2-container--default .select2-selection--multiple .select2-selection__choice,\n[data-theme-version='dark'] .select2-container--classic .select2-selection--multiple .select2-selection__choice {\n\tbackground-color: #272738;\n\tborder-color: #272738;\n}\n\n[data-theme-version='dark'] mark,\n[data-theme-version='dark'] .mark,\n[data-theme-version='dark'] .mark,\n[data-theme-version='dark'] .select2-container--classic .select2-search--inline .select2-search__field {\n\tbackground-color: #202020;\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .select2-container--default .select2-search--inline .select2-search__field {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .select2-container--default .select2-results__option[aria-selected='true'] {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .trans-info .icon {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .legendLabel {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .statistic-content {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] p {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .header-profile2 span {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .page-titles .datepicker.datepicker-dropdown th.prev:hover {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .compose-content .dropzone {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] #alert-link a {\n\tcolor: #768783;\n}\n\n[data-theme-version='dark'] #message-alert p {\n\tcolor: #666666;\n}\n\n[data-theme-version='dark'] #AlertLeftIcon h5,\n[data-theme-version='dark'] #AlertLeftIcon .h5 {\n\tcolor: #2a353a !important;\n}\n\n[data-theme-version='dark'] #AlertLeftIcon p {\n\tcolor: #666666;\n}\n\n[data-theme-version='dark'] .header.is-fixed {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .sidebar-right-inner .bootstrap-select .btn {\n\tbackground: transparent !important;\n\tcolor: #2a353a;\n\tborder-color: #eeeeee !important;\n}\n\n[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu {\n\tbackground-color: #fff;\n}\n[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item {\n\tcolor: #777777;\n}\n[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item.selected,\n[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item.selected.active,\n[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item.active,\n[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item:hover,\n[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item:focus {\n\tbackground-color: var(--rgba-primary-1);\n\tcolor: #2a353a;\n}\n\n[data-theme-version='dark'] .type_msg .form-control {\n\tbackground-color: #272738;\n\tbox-shadow: none;\n}\n\n[data-theme-version='dark'] .email-left-box {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .alert .btn-close {\n\tbackground-image: none !important;\n}\n\n[data-theme-version='dark'] #main-wrapper {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .prot-blog .fill a:hover {\n\tcolor: black;\n}\n\n[data-theme-version='dark'] .table-striped > tbody > tr:nth-of-type(odd) > * {\n\tbackground: #1e1e25;\n\tcolor: white !important;\n}\n\n[data-theme-version='dark'] .dlabnav {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .kanban-user .users li span,\n[data-theme-version='dark'] .kanban-user .users li img {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .plus-bx a svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .page-title {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='dark'] .chat-mid-area.bg-white {\n\tbackground-color: #272738 !important;\n}\n\n[data-theme-version='dark'] .message-box {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .message-received p {\n\tbackground-color: #202020 !important;\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .input-group.user-search-area .input-group-text {\n\tbackground-color: #202020;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .input-group.user-search-area .form-control {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .datepicker-days .table-condensed td.day {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .datepicker-days .table-condensed thead th.picker-switch {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .datepicker-days .table-condensed thead th.prev,\n[data-theme-version='dark'] .datepicker-days .table-condensed thead th.picker-switch,\n[data-theme-version='dark'] .datepicker-days .table-condensed thead th.next {\n\tcolor: #fff;\n}\n\n@keyframes blinking {\n\t0% {\n\t\tbackground-color: var(--primary);\n\t}\n\t100% {\n\t\tbackground-color: transparent;\n\t}\n}\n\n[data-theme-version='dark'] input-group.search-area {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .doller {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .apexcharts-tooltip.apexcharts-theme-light {\n\tbackground-color: rgba(255, 255, 255, 0.96);\n\tcolor: #000;\n}\n\n[data-theme-version='dark'] .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .all .show .card-header {\n\tbackground-color: rgba(255, 255, 255, 0.1) !important;\n\tborder-radius: 0.375rem !important;\n}\n\n[data-theme-version='dark'] .all .show .nav-link {\n\twidth: 2.5rem;\n\tmin-width: 2.5rem;\n\theight: 2.5rem;\n\tmargin: 5px;\n\tbackground-color: #272738 !important;\n}\n\n[data-theme-version='dark'] .note-text {\n\tcolor: #000;\n}\n\n[data-theme-version='dark'] .timeline-active.style-1 .timeline-list:before {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .authincation {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .authincation-content.style-2 .form-control {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .label-color,\n[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed td.day,\n[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.prev,\n[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.picker-switch,\n[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.next {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .authincation {\n\tbackground-image: url('../images/student-bg-Recovered.jpg') !important;\n}\n\n[data-theme-version='dark'] .table-responsive .table-striped th {\n\tbackground-color: var(--rgba-primary-1);\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .dz-card .card-body.code-area,\n[data-theme-version='dark'] .demo-view .code-area {\n\tbackground-color: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dz-calender .react-datepicker__day-name,\n[data-theme-version='dark'] .dz-calender .react-datepicker__day,\n[data-theme-version='dark'] .dz-calender .react-datepicker__time-name {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .dz-calender .react-datepicker__current-month {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .dz-calender .react-datepicker__navigation {\n\tbackground: none;\n}\n\n[data-theme-version='dark'] .dz-calender .react-datepicker__navigation-icon:before {\n\tborder-color: #fff;\n}\n\n[data-theme-version='dark'] #overiewChart line {\n\tstroke: #444;\n}\n\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-position='fixed'] .header {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-position='fixed'] .brand-sub-title {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .header {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .header-left .search-area .form-control {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .header-left .search-area .input-group-text {\n\tborder: 0;\n\tbackground: #272738;\n}\n[data-theme-version='dark'] .header-left .search-area .input-group-text a {\n\tcolor: #4f7086;\n}\n\n[data-theme-version='dark'] .header-left .input-group.search-area {\n\tborder-color: #58586a;\n}\n\n[data-theme-version='dark'] .header-right .notification_dropdown .nav-link {\n\t/* background: $d-bg!important; */\n}\n[data-theme-version='dark'] .header-right .notification_dropdown .nav-link .badge {\n\tborder-color: #272738;\n}\n\n[data-theme-version='dark'] .header-right .dropdown .nav-link {\n\tcolor: #fff;\n\tbackground-color: #202020 !important;\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n[data-theme-version='dark'] .header-right .dropdown .nav-link:hover {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .header-right .dropdown.header-profile2 .nav-link {\n\tbackground-color: transparent !important;\n}\n\n[data-theme-version='dark'] .nav-header .hamburger .line {\n\tbackground: #fff !important;\n}\n\n[data-theme-version='dark'] .menu-toggle .nav-header .nav-control .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n.change-btn a {\n\tcolor: #000;\n}\n\n[data-theme-version='dark'] .nav-header {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .nav-header .brand-title svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .nav-control {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .brand-logo {\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .brand-logo:hover {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .svg-title-path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .nav-header {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .nav-header .brand-title svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .nav-control {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .brand-logo {\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .brand-logo:hover {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .svg-title-path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li > ul {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='dark'] .fixed-content-box {\n\tbackground-color: #272738;\n}\n[data-theme-version='dark'] .fixed-content-box .head-name {\n\tbackground: #272738;\n\tcolor: #fff;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .fixed-content-box + .header + .dlabnav {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-position='fixed'] .dlabnav {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a {\n\tbackground: transparent;\n}\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a i,\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a i {\n\tcolor: var(--primary);\n\tbackground: var(--rgba-primary-1);\n}\n\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li a > i {\n\tcolor: rgba(255, 255, 255, 0.3);\n}\n\n[data-theme-version='dark'] .ps__thumb-y {\n\tbackground-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .dlabnav .header-profile > a.nav-link {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .dlabnav .header-profile > a.nav-link .header-info span {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu > li > a {\n\tcolor: #b3b3b3;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu > li:hover > a,\n[data-theme-version='dark'] .dlabnav .metismenu > li:focus > a,\n[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a {\n\tcolor: #fff;\n\tbackground: var(--primary) !important;\n}\n[data-theme-version='dark'] .dlabnav .metismenu > li:hover > a::after,\n[data-theme-version='dark'] .dlabnav .metismenu > li:focus > a::after,\n[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a::after {\n\tborder-left: 0.2125rem solid #fff;\n\tborder-top: 0.2125rem solid #fff;\n\tborder-bottom: 0.2125rem solid transparent;\n\tborder-right: 0.2125rem solid transparent;\n}\n[data-theme-version='dark'] .dlabnav .metismenu > li:hover > a i,\n[data-theme-version='dark'] .dlabnav .metismenu > li:focus > a i,\n[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active ul ul {\n\tbackground-color: transparent;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu ul:after {\n\tbackground-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu ul a:hover,\n[data-theme-version='dark'] .dlabnav .metismenu ul a:focus,\n[data-theme-version='dark'] .dlabnav .metismenu ul a.mm-active {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu ul a:before {\n\tbackground-color: #fff;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.6) !important;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after {\n\tborder-top: 0.2125rem solid #b3b3b3;\n\tborder-left: 0.2125rem solid #b3b3b3;\n\tborder-bottom: 0.2125rem solid transparent;\n\tborder-right: 0.2125rem solid transparent;\n}\n\n[data-theme-version='dark'] .sidebar-right .card-tabs .nav-tabs {\n\tborder-color: var(--rgba-primary-1) !important;\n}\n[data-theme-version='dark'] .sidebar-right .card-tabs .nav-tabs .nav-item .nav-link {\n\tcolor: #000 !important;\n}\n\n[data-theme-version='dark'] .sidebar-right .form-control {\n\tbackground: #fff;\n\tcolor: #000;\n\tborder-color: #eeeeee;\n}\n\n[data-theme-version='dark'] .sidebar-right .default-select .list {\n\tbackground: #fff;\n}\n[data-theme-version='dark'] .sidebar-right .default-select .list .option.selected,\n[data-theme-version='dark'] .sidebar-right .default-select .list .option.focus,\n[data-theme-version='dark'] .sidebar-right .default-select .list .option:hover {\n\tbackground: rgba(0, 0, 0, 0.05) !important;\n}\n\n[data-theme-version='dark'] .sidebar-right .sidebar-right-inner > h4,\n[data-theme-version='dark'] .sidebar-right .sidebar-right-inner > .h4 {\n\tcolor: #000 !important;\n}\n\n[data-theme-version='dark'] .sidebar-right .nice-select .option {\n\tbackground: #fff;\n}\n\n[data-theme-version='dark'] .footer {\n\tbackground-color: #272738;\n}\n[data-theme-version='dark'] .footer .copyright {\n\tbackground-color: transparent;\n}\n[data-theme-version='dark'] .footer .copyright p {\n\tcolor: #fff;\n}\n\npre {\n\tdisplay: block;\n\tmargin-top: 0;\n\tmargin-bottom: 1rem;\n\toverflow: auto;\n\tfont-size: 0.875em;\n\t-moz-tab-size: 16;\n\ttab-size: 2;\n}\npre code.hljs {\n\tdisplay: block;\n\toverflow-x: auto;\n\tcolor: #fff;\n\tpadding: 0;\n}\n\n.hljs-tag .hljs-attr,\n.hljs-tag .hljs-name {\n\tcolor: var(--primary);\n}\n\n.hljs-punctuation,\n.hljs-tag {\n\tcolor: var(--secondary);\n}\n\n.hljs-deletion,\n.hljs-number,\n.hljs-quote,\n.hljs-selector-class,\n.hljs-selector-id,\n.hljs-string,\n.hljs-template-tag,\n.hljs-type {\n\tcolor: #ffa8a8;\n}\n\n/* =============\n   Calendar\n============= */\n.app-fullcalender button {\n\tborder-radius: 0rem;\n\tcolor: #303972;\n}\n\n.app-fullcalender td {\n\tborder-color: #f2f2f2;\n}\n\n.calendar {\n\tfloat: left;\n\tmargin-bottom: 0;\n}\n\n.fc-view {\n\tmargin-top: 1.875rem;\n}\n\n.fc-toolbar {\n\tmargin-bottom: 0.3125rem;\n\tmargin-top: 0.9375rem;\n}\n.fc-toolbar .fc-left {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: 0.625rem;\n\tfloat: none;\n}\n.fc-toolbar .fc-right {\n\tdisplay: flex;\n\tjustify-content: center;\n\tfloat: none;\n\tmargin-bottom: 0.3125rem;\n}\n.fc-toolbar .fc-center {\n\tdisplay: flex;\n\tjustify-content: center;\n}\n.fc-toolbar .fc-center * {\n\tfloat: none;\n}\n\n.fc-toolbar h2,\n.fc-toolbar .h2 {\n\tfont-size: 1rem;\n\tfont-weight: 600;\n\tline-height: 1.875rem;\n\ttext-transform: uppercase;\n}\n\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active,\n.fc-toolbar .ui-state-hover,\n.fc-toolbar button:focus,\n.fc-toolbar button:hover {\n\tz-index: 0;\n\tbox-shadow: none;\n}\n\n.fc-widget-header {\n\tborder: 0.0625rem solid #f2f2f2;\n\tborder-bottom: 0 !important;\n}\n\n.fc th.fc-widget-header {\n\tbackground: #f2f2f2 !important;\n\tfont-size: 0.875rem;\n\tline-height: 1.25rem;\n\tpadding: 0.625rem 0;\n\ttext-transform: uppercase;\n}\n\n.fc-button {\n\tborder: 0.0625rem solid #f2f2f2;\n\ttext-transform: capitalize;\n}\n.fc-button.active {\n\tbox-shadow: none !important;\n}\n\n.fc-text-arrow {\n\tfont-family: inherit;\n\tfont-size: 1rem;\n}\n\n.fc-event,\n.external-event {\n\tborder-radius: 0.125rem;\n\tborder: none;\n\tcursor: move;\n\tfont-size: 0.8125rem;\n\tmargin: 0.3125rem 0.4375rem;\n\tpadding: 0.3125rem;\n\ttext-align: center;\n}\n\n.external-event {\n\tcursor: move;\n\tmargin: 0.625rem 0;\n\tpadding: 0.125rem 0;\n}\n\n.fc-basic-view td.fc-week-number span {\n\tpadding-right: 0.3125rem;\n}\n\n.fc-basic-view td.fc-day-number {\n\tpadding-right: 0.3125rem;\n}\n\n#drop-remove {\n\tmargin-right: 0.5rem;\n\ttop: 0.1875rem;\n}\n\n#add-category .modal-dialog,\n#event-modal .modal-dialog {\n\tmax-width: 37.5rem;\n}\n\n.fc-content {\n\tcolor: #fff;\n}\n\n.fc th.fc-widget-header {\n\tbackground: transparent !important;\n}\n\n.fc-button {\n\tbackground: #fff;\n}\n\n.fc-state-hover {\n\tbackground: #fff !important;\n}\n\n.fc-state-highlight {\n\tbackground: #f5f5f5 !important;\n}\n[data-theme-version='dark'] .fc-state-highlight {\n\tcolor: #fff !important;\n}\n\n.fc-cell-overlay {\n\tbackground: #fff !important;\n}\n\n.fc-unthemed .fc-today {\n\tbackground: #f5f5f5 !important;\n}\n\n.fc-day-top {\n\tcolor: #303972 !important;\n}\n[data-theme-version='dark'] .fc-day-top {\n\tcolor: #fff !important;\n}\n\n.external-event {\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .external-event {\n\tcolor: #fff !important;\n}\n\n.fc-basic-view .fc-body .fc-row {\n\tmin-height: 1rem;\n}\n\n.fc-scroller.fc-day-grid-container {\n\theight: 30.625rem !important;\n}\n\n.fc-row.fc-week.fc-widget-content.fc-rigid {\n\theight: 5.0625rem !important;\n}\n\n@media only screen and (max-width: 90rem) {\n\t.email_left_pane {\n\t\tdisplay: none;\n\t}\n}\n\n#external-events .external-event:before {\n\tcontent: '';\n\tdisplay: block;\n\twidth: 0.875rem;\n\tmin-width: 0.875rem;\n\theight: 0.875rem;\n\tborder-radius: 50%;\n\tmargin-right: 0.9rem;\n\tposition: relative;\n\ttop: 0.125rem;\n}\n\n[data-theme-version='dark'] #external-events [data-class='bg-primary'] {\n\tcolor: #fff !important;\n}\n\n#external-events [data-class='bg-primary']::before {\n\tbackground: var(--primary);\n}\n\n#external-events [data-class='bg-success']::before {\n\tbackground: #1eba62;\n}\n\n#external-events [data-class='bg-warning']::before {\n\tbackground: #fcc43e;\n}\n\n#external-events [data-class='bg-dark']::before {\n\tbackground: #303972;\n}\n\n#external-events [data-class='bg-danger']::before {\n\tbackground: #fd5353;\n}\n\n#external-events [data-class='bg-info']::before {\n\tbackground: #00ada3;\n}\n\n#external-events [data-class='bg-pink']::before {\n\tbackground: #eb62d0;\n}\n\n#external-events [data-class='bg-secondary']::before {\n\tbackground: #fb7d5b;\n}\n\n.fc .fc-row .fc-content-skeleton table,\n.fc .fc-row .fc-content-skeleton td,\n.fc .fc-row .fc-helper-skeleton td {\n\tborder-color: #f2f2f2;\n}\n[data-theme-version='dark'] .fc .fc-row .fc-content-skeleton table,\n[data-theme-version='dark'] .fc .fc-row .fc-content-skeleton td,\n[data-theme-version='dark'] .fc .fc-row .fc-helper-skeleton td {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .fc-unthemed .fc-content,\n[data-theme-version='dark'] .fc-unthemed .fc-divider,\n[data-theme-version='dark'] .fc-unthemed .fc-list-heading td,\n[data-theme-version='dark'] .fc-unthemed .fc-list-view,\n[data-theme-version='dark'] .fc-unthemed .fc-popover,\n[data-theme-version='dark'] .fc-unthemed .fc-row,\n[data-theme-version='dark'] .fc-unthemed tbody,\n[data-theme-version='dark'] .fc-unthemed td,\n[data-theme-version='dark'] .fc-unthemed th,\n[data-theme-version='dark'] .fc-unthemed thead {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n.email-left-box {\n\tborder-right: 1px solid #eeeeee;\n\theight: calc(100vh - 83px);\n\tpadding: 1.875rem 1.25rem;\n\toverflow-y: auto;\n}\n.email-left-box .btn.text-white.btn-block {\n\tbackground-color: var(--bs-body-color);\n\tfont-weight: 500;\n\tfont-size: 0.938rem;\n\twhite-space: nowrap;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.email-left-box {\n\t\twidth: 100%;\n\t\tfloat: none;\n\t\tborder: none;\n\t\tpadding-bottom: 1.875rem !important;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.email-left-box {\n\t\tpadding-bottom: 0rem !important;\n\t}\n}\n.email-left-box .intro-title {\n\tpadding: 1rem;\n\tmargin: 1.875rem 0 1.25rem 0;\n}\n.email-left-box .intro-title h5,\n.email-left-box .intro-title .h5 {\n\tmargin-bottom: 0;\n\tfont-size: 1rem;\n\tfont-weight: 500;\n}\n.email-left-box .intro-title h5 i,\n.email-left-box .intro-title .h5 i {\n\tfont-size: 0.75rem;\n\tposition: relative;\n\tbottom: 0.0625rem;\n}\n.email-left-box .intro-title i {\n\tcolor: var(--primary);\n}\n.email-left-box .mail-list {\n\tmargin-top: 2.188rem;\n}\n.email-left-box .mail-list a {\n\tborder: 0;\n\tvertical-align: middle;\n\tpadding: 0.625rem 0.9375rem;\n\tdisplay: block;\n\tbackground: transparent;\n\tcolor: #464a53;\n\tfont-weight: 600;\n\tz-index: 1;\n}\n.email-left-box .mail-list .change {\n\tcolor: #666666;\n\tfont-weight: 500;\n}\n.email-left-box .mail-list .list-group-item {\n\tborder-radius: 10px;\n\tpadding: 0.75rem 1.0625rem;\n\tfont-size: 0.938rem;\n\tfont-weight: 500;\n\tmargin-bottom: 0.625rem;\n\toverflow: hidden;\n}\n.email-left-box .mail-list .list-group-item i {\n\tfont-size: 1.125rem;\n\tpadding-right: 1.125rem;\n\tcolor: #a098ae;\n}\n.email-left-box .mail-list .list-group-item svg {\n\tmargin-right: 1.125rem;\n}\n.email-left-box .mail-list .list-group-item.active {\n\tcolor: #fb7d5b;\n\tbackground-color: var(--rgba-secondary-1);\n}\n.email-left-box .mail-list .list-group-item.active span.badge {\n\tbackground-color: var(--secondary);\n}\n.email-left-box .mail-list .list-group-item.active i {\n\tcolor: var(--secondary);\n}\n.email-left-box .mail-list .list-group-item.change {\n\tmargin-bottom: 0;\n}\n.email-left-box .mail-list .list-group-item::before {\n\tcontent: '';\n\tdisplay: block;\n\tbackground-color: var(--rgba-secondary-1);\n\tcolor: var(--secondary);\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 0%;\n\theight: 100%;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n}\n.email-left-box .mail-list .list-group-item:hover {\n\tcolor: var(--secondary);\n}\n.email-left-box .mail-list .list-group-item:hover::before {\n\twidth: 100%;\n}\n.email-left-box .mail-list .list-group-item:hover i {\n\tcolor: var(--secondary);\n}\n.email-left-box .mail-list .list-group-item:hover svg path {\n\tfill: var(--secondary);\n\tstroke: var(--secondary);\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.email-left-box {\n\t\theight: calc(100vh - 160px);\n\t}\n}\n\ninput#checkAll.form-check-input {\n\tbackground-color: #fff;\n}\n\ninput#checkAll.form-check-input:checked {\n\tbackground-color: var(--primary);\n}\n\n.email-right-box {\n\tpadding-left: 15rem;\n\tpadding-right: 1rem;\n\tpadding-left: 0;\n\tpadding-right: 0;\n}\n.email-right-box .pagination {\n\tpadding: 0.7rem 0;\n\tmargin-bottom: 0rem;\n\tbackground-color: #fff;\n}\n@media (min-width: 576px) and (max-width: 767.98px) {\n\t.email-right-box {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t\tmargin-left: 0 !important;\n\t\tclear: both;\n\t}\n}\n.email-right-box .right-box-border {\n\tborder-right: 0.125rem solid var(--rgba-primary-1);\n}\n@media screen and (min-width: 40.5625rem) and (max-width: 75rem) {\n\t.email-right-box .right-box-padding {\n\t\tpadding-left: 1.25rem;\n\t}\n}\n@media (min-width: 106.25rem) {\n\t.email-right-box .right-box-padding {\n\t\tpadding-left: 0.9375rem;\n\t}\n}\n@media (min-width: 576px) and (max-width: 767.98px) {\n\t.email-right-box .right-box-padding {\n\t\tpadding-left: 1rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.email-right-box .right-box-padding {\n\t\tpadding: 1rem;\n\t}\n}\n.email-right-box .table-pagenation {\n\tbackground-color: #fff;\n\tmargin-top: 0;\n\tborder: 1px solid #d5dfe7;\n\tborder-width: 1px 0w;\n}\n\n.toolbar {\n\theight: 3.563rem;\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.toolbar {\n\t\theight: auto;\n\t}\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.toolbar {\n\t\tborder-top: 1px solid #d5dfe7;\n\t\tpadding-top: 10px;\n\t}\n}\n.toolbar .btn-group .btn.nav-link.active {\n\tborder: 0;\n\tbackground-color: transparent;\n\tcolor: #303972;\n\tfont-size: 0.938rem;\n\tpadding: 0.5rem 0.2rem;\n\tcolor: var(--primary);\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.toolbar .btn-group .btn.nav-link.active {\n\t\tpadding: 0.5rem 1rem;\n\t}\n}\n.toolbar .btn-group .btn.nav-link.active::before {\n\tcontent: '';\n\tdisplay: block;\n\tbackground-color: var(--primary);\n\tposition: absolute;\n\tbottom: -0.625rem;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\twidth: 100%;\n\theight: 3px;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.toolbar .btn-group .btn.nav-link.active::before {\n\t\tdisplay: none;\n\t}\n}\n.toolbar .btn-group .btn.nav-link.active:focus {\n\tbox-shadow: none;\n}\n.toolbar .btn-group .btn.nav-link.active svg path {\n\tfill: var(--primary);\n}\n.toolbar .btn-group .btn.nav-link::before {\n\tcontent: '';\n\tdisplay: block;\n\tbackground-color: var(--primary);\n\tposition: absolute;\n\tbottom: -0.625rem;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\twidth: 0%;\n\theight: 3px;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n}\n.toolbar .btn-group .btn.nav-link:hover::before {\n\twidth: 100%;\n}\n.toolbar .btn-group .btn.nav-link:hover svg path {\n\tfill: var(--primary);\n}\n.toolbar .btn-group .btn.nav-link svg {\n\tmargin-right: 0.5rem;\n\tmargin-bottom: 0.2rem;\n}\n.toolbar .btn-group input {\n\tposition: relative;\n\ttop: 0.125rem;\n}\n\n.saprat {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\theight: 100%;\n\tflex-wrap: wrap;\n}\n.saprat .btn-group {\n\tmargin-left: 1.125rem;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.saprat {\n\t\tflex-wrap: wrap;\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.saprat .mail-tools {\n\t\tmargin-left: 5.125rem;\n\t}\n}\n.saprat .mail-tools a:hover svg {\n\tbackground: var(--rgba-primary-1);\n\tborder-radius: 6px;\n}\n\n.read-content textarea {\n\theight: 9.375rem;\n\tpadding: 0.9375rem 1.25rem;\n\tborder-radius: 0.375rem;\n}\n\n.read-content-email {\n\tfont-size: 0.875rem;\n}\n\n.read-content h5,\n.read-content .h5 {\n\tcolor: #6a707e;\n}\n\n.read-content p strong {\n\tcolor: #6a707e;\n}\n\n.read-content-body p {\n\tmargin-bottom: 1.875rem;\n}\n\n.read-content-attachment {\n\tpadding: 0.5rem 0;\n}\n.read-content-attachment h6,\n.read-content-attachment .h6 {\n\tfont-size: 1.125rem;\n\tcolor: #6a707e;\n}\n.read-content-attachment h6 i,\n.read-content-attachment .h6 i {\n\tpadding-right: 0.3125rem;\n}\n.read-content-attachment .attachment a {\n\tcolor: var(--primary) !important;\n}\n.read-content-attachment .attachment > div:not(:last-child) {\n\tborder-right: 0.0625rem solid #dddfe1;\n}\n\n.compose-wrapper {\n\theight: calc(100vh - 180px);\n\toverflow-y: scroll;\n\tpadding: 0 1rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.compose-wrapper {\n\t\theight: calc(100vh - 337.7px);\n\t}\n}\n\n.read-wapper {\n\theight: calc(100vh - 180px);\n\tpadding: 0 1.25rem;\n}\n\n.compose-content .wysihtml5-toolbar {\n\tborder-color: #eaeaea;\n}\n\n.compose-content .dropzone {\n\tbackground: #f5f5f5 !important;\n}\n\n.compose-content h5,\n.compose-content .h5 {\n\tfont-size: 1.0625rem;\n\tcolor: #6a707e;\n}\n.compose-content h5 i,\n.compose-content .h5 i {\n\tfont-size: 1.125rem;\n\ttransform: rotate(90deg);\n}\n\n.compose-content .dropzone {\n\tborder: 0.0625rem dashed #dddfe1;\n\tmin-height: 13.125rem;\n\tposition: relative;\n\tborder-radius: 0.375rem;\n}\n.compose-content .dropzone .dlab-message {\n\tmargin: 0;\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n}\n\n.email-list {\n\tdisplay: block;\n\tpadding-left: 0;\n\tbackground: #f3f3f3;\n\theight: calc(100vh - 212px);\n\toverflow-y: scroll;\n}\n.email-list label {\n\tmargin-bottom: 0px;\n}\n.email-list .message {\n\tposition: relative;\n\tdisplay: block;\n\theight: 3.438rem;\n\tpadding: 0 15px;\n\tline-height: 3.438rem;\n\tcursor: default;\n\ttransition-duration: 0.3s;\n\tborder-bottom: 1px solid #d5dfe7;\n}\n.email-list .message a {\n\tcolor: #303972;\n}\n.email-list .message-single .custom-checkbox {\n\tmargin-top: 0.125rem;\n}\n.email-list .message-single i {\n\tcolor: #89879f;\n\tfont-size: 1.125rem;\n\tpadding-left: 0.4rem;\n}\n.email-list .message .icon {\n\tposition: absolute;\n\ttop: 16px;\n\tright: 10px;\n\topacity: 0;\n\ttransition-duration: 0.3s;\n}\n.email-list .message:hover {\n\ttransition-duration: 0.05s;\n\tbackground: #f3f5f7;\n}\n.email-list .message:hover .icon {\n\topacity: 1;\n}\n.email-list .message:hover .col-mail-2 .date {\n\topacity: 0;\n}\n.email-list .message:hover .message-single .form-check-input {\n\topacity: 1;\n}\n.email-list .message .col-mail {\n\tfloat: left;\n\tposition: relative;\n}\n.email-list .message .col-mail-1 {\n\twidth: 5.625rem;\n}\n.email-list .message .col-mail-1 .star-toggle {\n\tdisplay: block;\n\tfloat: left;\n\tmargin-top: 1.125rem;\n\tfont-size: 1rem;\n\tmargin-left: 0.3125rem;\n}\n.email-list .message .col-mail-1 .email-checkbox {\n\tdisplay: block;\n\tfloat: left;\n\tmargin: 0.9375rem 0.625rem 0 1.25rem;\n}\n.email-list .message .col-mail-1 .dot {\n\tdisplay: block;\n\tfloat: left;\n\tborder: 0.4rem solid transparent;\n\tborder-radius: 6.25rem;\n\tmargin: 1.375rem 1.625rem 0;\n\theight: 0;\n\twidth: 0;\n\tline-height: 0;\n\tfont-size: 0;\n}\n.email-list .message .col-mail-2 {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 5.625rem;\n\tright: 0;\n\tbottom: 0;\n}\n.email-list .message .col-mail-2 .subject {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 5.5rem;\n\tfont-weight: 500;\n\tcolor: black;\n\tmargin: 0 220px;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\twhite-space: nowrap;\n}\n.email-list .message .col-mail-2 .subject span {\n\tcolor: #666666;\n}\n.email-list .message .col-mail-2 .date {\n\tposition: absolute;\n\ttop: 0;\n\tright: 15px;\n\topacity: 1;\n\ttransition-duration: 0.3s;\n\tfont-weight: 500;\n}\n.email-list .message .message-single .bookmark-btn input {\n\tposition: absolute;\n\tcursor: pointer;\n\theight: 0;\n\twidth: 0;\n\tdisplay: none;\n}\n.email-list .message .message-single .bookmark-btn .checkmark {\n\tfont-weight: 900;\n\tfont-family: 'font awesome 5 free';\n}\n.email-list .message .message-single .bookmark-btn .checkmark:before {\n\tcontent: '\\f005';\n\tfont-size: 1.25rem;\n\tborder-color: #666666;\n\tfont-weight: 100;\n\tcolor: #c4c4c4;\n}\n.email-list .message .message-single .bookmark-btn input:checked ~ .checkmark:before {\n\tcolor: #ff9838;\n\tfont-weight: 900;\n}\n.email-list .message .message-single .form-check-input {\n\tmargin-top: 0;\n}\n.email-list .message .hader {\n\tfont-size: 0.938rem;\n\tfont-weight: 500;\n\tpadding: 0 1.25rem;\n}\n\n.email-checkbox {\n\tcursor: pointer;\n\theight: 0.9375rem;\n\twidth: 0.9375rem;\n\tposition: relative;\n\tdisplay: inline-block;\n\tborder-radius: 0.1rem;\n\tposition: relative;\n\ttop: 0.3125rem;\n\tbox-shadow: inset 0 0 0 0.1rem #828690;\n}\n.email-checkbox input {\n\topacity: 0;\n\tcursor: pointer;\n}\n.email-checkbox input:checked label {\n\topacity: 1;\n}\n.email-checkbox label {\n\tposition: absolute;\n\ttop: 0.3rem;\n\tleft: 0.3rem;\n\tright: 0.3rem;\n\tbottom: 0.3rem;\n\tcursor: pointer;\n\topacity: 0;\n\tmargin-bottom: 0 !important;\n\ttransition-duration: 0.05s;\n}\n\n.chat-wrap {\n\tpadding: 1.0625rem 1.875rem;\n}\n.chat-wrap .media .media-body h6,\n.chat-wrap .media .media-body .h6 {\n\tfont-size: 1.0625rem;\n\tcolor: #6a707e;\n}\n.chat-wrap .media .media-body p {\n\tfont-size: 0.875rem;\n}\n\n@media (min-width: 40.5rem) {\n\t.email-filter {\n\t\tpadding-left: 1.25rem;\n\t}\n}\n\n@media (min-width: 106.25rem) {\n\t.email-filter {\n\t\tpadding-left: 1.875rem;\n\t}\n}\n\n.email-filter .input-group-prepend i {\n\tfont-size: 0.875rem;\n\tcolor: #89879f;\n}\n\n.email-filter .input-group-prepend .input-group-text {\n\tborder: 0;\n\tborder-bottom: 0.0625rem solid #dddfe1 !important;\n\tbackground: transparent;\n}\n\n.email-filter .input-group .form-control {\n\tpadding: 0 0 0 0.3125rem;\n\tborder: 0;\n\tfont-size: 0.875rem;\n\theight: 1.875rem;\n\tcolor: #89879f;\n\tborder-bottom: 0.0625rem solid #dddfe1;\n}\n.email-filter .input-group .form-control::placeholder {\n\tfont-size: 0.875rem;\n\tcolor: #89879f;\n}\n\n.email-filter .input-group > .form-control {\n\tmin-height: 1.875rem;\n}\n\n.single-mail {\n\tdisplay: block;\n\tpadding: 1.5625rem 0;\n}\n.single-mail .media {\n\tpadding-left: 1.25rem;\n\tpadding-right: 1.25rem;\n}\n@media (min-width: 106.25rem) {\n\t.single-mail .media {\n\t\tpadding-left: 1.875rem;\n\t\tpadding-right: 1.875rem;\n\t}\n}\n.single-mail .media img {\n\twidth: 3.4375rem;\n\theight: 3.4375rem;\n\tborder-radius: 50%;\n\tmargin-right: 0.9375rem;\n}\n@media (min-width: 106.25rem) {\n\t.single-mail .media img {\n\t\tmargin-right: 1.875rem;\n\t}\n}\n.single-mail .media-body h6,\n.single-mail .media-body .h6 {\n\tcolor: #abafb3;\n}\n.single-mail .media-body h4,\n.single-mail .media-body .h4 {\n\tfont-size: 1rem;\n\tcolor: #6a707e;\n}\n.single-mail .media-body h4 button i,\n.single-mail .media-body .h4 button i {\n\tfont-size: 1.125rem;\n\tcolor: #abafb3;\n\tfont-weight: bold;\n\ttransform: rotate(90deg);\n}\n.single-mail .media-body p {\n\tfont-size: 0.875rem;\n\tcolor: #abafb3;\n}\n.single-mail.active {\n\tbackground: var(--primary);\n}\n.single-mail.active h6,\n.single-mail.active .h6,\n.single-mail.active h4,\n.single-mail.active .h4,\n.single-mail.active p,\n.single-mail.active i {\n\tcolor: #fff !important;\n}\n\n[direction='rtl'] .email-right-box {\n\tpadding-left: 1rem;\n\tpadding-right: 15rem;\n}\n@media only screen and (max-width: 61.9375rem) {\n\t[direction='rtl'] .email-right-box {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t\tmargin-right: 0;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t[direction='rtl'] .email-right-box {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t}\n}\n\n[direction='rtl'] .email-left-box {\n\tfloat: right;\n}\n\n[direction='rtl'] .email-list .message .col-mail-2 {\n\tright: 5.625rem;\n\tleft: 0;\n\tfloat: right;\n}\n[direction='rtl'] .email-list .message .col-mail-2 .date {\n\tright: auto;\n\tleft: 0;\n}\n[direction='rtl'] .email-list .message .col-mail-2 .subject {\n\tright: 0;\n\tleft: 5.5rem;\n}\n\n.pull-end {\n\tfloat: right;\n}\n\n.photo-content {\n\tposition: relative;\n}\n.photo-content .cover-photo {\n\tbackground-size: cover;\n\tbackground-position: center;\n\tmin-height: 15.625rem;\n\twidth: 100%;\n}\n\n.profile .profile-photo {\n\tmax-width: 6.25rem;\n\tposition: relative;\n\tz-index: 1;\n\tmargin-top: -4.5rem;\n\tmargin-right: 0.625rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.profile .profile-photo {\n\t\twidth: 5rem;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t\tmargin-top: -3rem;\n\t\tmargin-bottom: 1.25rem;\n\t}\n}\n\n[direction='rtl'] .profile .profile-photo {\n\tleft: auto;\n\tright: 0;\n\tmargin-right: 0;\n\tmargin-left: 0.9375rem;\n}\n@media only screen and (max-width: 74.9375rem) {\n\t[direction='rtl'] .profile .profile-photo {\n\t\tright: 0.9375rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t[direction='rtl'] .profile .profile-photo {\n\t\twidth: 5rem;\n\t\tright: calc(50% - 2.5rem);\n\t\ttop: -6.25rem;\n\t}\n}\n\n.profile-info {\n\tpadding: 0.9375rem 1.25rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.profile-info {\n\t\tpadding: 0 0 1.25rem;\n\t\ttext-align: center;\n\t}\n}\n.profile-info h4,\n.profile-info .h4 {\n\tcolor: #464a53 !important;\n}\n.profile-info h4.text-primary,\n.profile-info .text-primary.h4 {\n\tcolor: var(--primary) !important;\n}\n.profile-info p {\n\tcolor: #828690;\n}\n.profile-info .prf-col {\n\tmin-width: 15.625rem;\n\tpadding: 0.625rem 3.125rem 0;\n}\n\n.profile-interest .row {\n\tmargin: 0 -0.0437rem;\n}\n.profile-interest .row .int-col {\n\tpadding: 0 0.0437rem;\n}\n.profile-interest .row .int-col .interest-cat {\n\tmargin-bottom: 0.0875rem;\n\tposition: relative;\n\tdisplay: block;\n}\n.profile-interest .row .int-col .interest-cat:after {\n\tbackground: #000;\n\tbottom: 0;\n\tcontent: '';\n\tleft: 0;\n\topacity: 0.5;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\tz-index: 0;\n}\n.profile-interest .row .int-col .interest-cat p {\n\tposition: absolute;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 0.3125rem;\n\tleft: 0;\n\tmargin: 0;\n\tz-index: 1;\n\tcolor: white;\n\tfont-size: 0.075rem;\n}\n\n.profile-tab .nav-item .nav-link {\n\tfont-size: 1rem;\n\tmargin-right: 1.875rem;\n\ttransition: all 0.5s ease-in-out;\n\tborder: none;\n\tborder-bottom: 0.0125rem solid transparent;\n\tcolor: #828690;\n}\n.profile-tab .nav-item .nav-link:hover,\n.profile-tab .nav-item .nav-link.active {\n\tborder: 0;\n\tbackground: transparent;\n\tbackground: transparent;\n\tborder-bottom: 0.0125rem solid var(--primary);\n\tcolor: var(--primary);\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.profile-tab .nav-item .nav-link {\n\t\tmargin-right: 0rem;\n\t}\n}\n\n.profile-info {\n\tdisplay: flex;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.profile-info {\n\t\tdisplay: block;\n\t}\n}\n.profile-info .profile-details {\n\tdisplay: flex;\n\twidth: 100%;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.profile-info .profile-details {\n\t\tdisplay: block;\n\t}\n\t.profile-info .profile-details .dropdown {\n\t\tposition: absolute;\n\t\ttop: 1.875rem;\n\t\tright: 1.875rem;\n\t}\n}\n\n.post-input {\n\tmargin-bottom: 1.875rem;\n}\n.post-input .form-control {\n\theight: 4.6875rem;\n\tfont-weight: 400;\n\tmargin: 0.9375rem 0;\n}\n.post-input .btn-social {\n\tfont-size: 1.25rem;\n\theight: 3.4375rem;\n\tdisplay: inline-block;\n\tpadding: 0;\n\ttext-align: center;\n\tborder-radius: 0.375rem;\n\tcolor: #fff;\n\twidth: 3.4375rem;\n\tline-height: 3.375rem;\n}\n.post-input .btn-social.facebook {\n\tbackground-color: #3b5998;\n}\n.post-input .btn-social.google-plus {\n\tbackground-color: #de4e43;\n}\n.post-input .btn-social.linkedin {\n\tbackground-color: #007bb6;\n}\n.post-input .btn-social.instagram {\n\tbackground-color: #8a5a4e;\n}\n.post-input .btn-social.twitter {\n\tbackground-color: #1ea1f3;\n}\n.post-input .btn-social.youtube {\n\tbackground-color: #ce201f;\n}\n.post-input .btn-social.whatsapp {\n\tbackground-color: #01c854;\n}\n.post-input .btn-social i {\n\tmargin: 0 !important;\n}\n\n.profile-uoloaded-post img {\n\tmargin-bottom: 1.25rem;\n}\n\n.profile-uoloaded-post a h4,\n.profile-uoloaded-post a .h4 {\n\tmargin-bottom: 0.625rem;\n\tcolor: #464a53;\n}\n\n.event-chat-ryt .chat-area .chat-reciver,\n.event-chat-ryt .chat-area .chat-sender {\n\tmargin-bottom: 1.875rem;\n\tpadding: 0;\n}\n.event-chat-ryt .chat-area .chat-reciver img,\n.event-chat-ryt .chat-area .chat-sender img {\n\tborder-radius: 1.875rem;\n}\n\n.event-chat-ryt .chat-area .media {\n\tposition: relative;\n}\n.event-chat-ryt .chat-area .media-body p {\n\tmargin: 0;\n\tmax-width: 100%;\n\tdisplay: inline-block;\n\tposition: relative;\n}\n.event-chat-ryt .chat-area .media-body p span {\n\tpadding: 1rem;\n\tdisplay: inline-block;\n\ttop: 103%;\n\tposition: relative;\n\tborder: 0.0625rem solid #f2f2f2;\n}\n\n.event-chat-ryt .chat-reciver {\n\tpadding: 0.5rem 1rem;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: end;\n\t-ms-flex-pack: end;\n\tjustify-content: flex-end;\n}\n.event-chat-ryt .chat-reciver .media {\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1;\n}\n.event-chat-ryt .chat-reciver .media .media-body {\n\tmargin-right: 2rem;\n\ttext-align: right;\n}\n[direction='rtl'] .event-chat-ryt .chat-reciver .media .media-body {\n\ttext-align: left;\n\tmargin-left: 2rem;\n\tmargin-right: auto;\n}\n.event-chat-ryt .chat-reciver .media .media-body p {\n\tbackground: #fff;\n\tmargin-bottom: 0;\n\tborder-radius: 0.3125rem 0.3125rem 0 0.3125rem;\n}\n.event-chat-ryt .chat-reciver .media .media-body p span {\n\ttext-align: left;\n\tborder: 0.0625rem solid #f2f2f2;\n}\n.event-chat-ryt .chat-reciver .media .media-body p span::after {\n\tcontent: '';\n\twidth: 1.25rem;\n\theight: 1.25rem;\n\tborder-bottom: 0.0625rem solid #f2f2f2;\n\tborder-right: 0.0625rem solid #f2f2f2;\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\tbackground: #fff;\n\t-webkit-transform: rotate(-45deg) translateX(15px);\n\ttransform: rotate(-45deg) translateX(15px);\n}\n[direction='rtl'] .event-chat-ryt .chat-reciver .media .media-body p span::after {\n\tleft: 0;\n\tright: auto;\n\t-webkit-transform: rotate(135deg) translateY(15px);\n\ttransform: rotate(135deg) translateY(15px);\n}\n.event-chat-ryt .chat-reciver .media .media-body p .time {\n\tposition: absolute;\n\tfont-size: 0.75rem;\n\tcolor: #a098ae;\n\tfont-weight: 400;\n\tbottom: 0;\n\tleft: -5rem;\n}\n[direction='rtl'] .event-chat-ryt .chat-reciver .media .media-body p .time {\n\tright: -5rem;\n\tleft: auto;\n}\n\n.event-chat-ryt .chat-sender {\n\ttext-align: left;\n\tpadding: 0.5rem 1rem;\n}\n.event-chat-ryt .chat-sender .media .media-body {\n\tmargin-left: 2rem;\n}\n[direction='rtl'] .event-chat-ryt .chat-sender .media .media-body {\n\ttext-align: right;\n\tmargin-right: 2rem;\n\tmargin-left: auto;\n}\n.event-chat-ryt .chat-sender .media .media-body p {\n\tbackground-color: #fff;\n\tmargin-bottom: 0;\n}\n.event-chat-ryt .chat-sender .media .media-body p span::after {\n\tcontent: '';\n\twidth: 1.25rem;\n\theight: 1.25rem;\n\tborder-bottom: 0.0625rem solid #f2f2f2;\n\tborder-left: 0.0625rem solid #f2f2f2;\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 0;\n\tbackground: #fff;\n\t-webkit-transform: rotate(45deg) translateX(-15px);\n\ttransform: rotate(45deg) translateX(-15px);\n}\n[direction='rtl'] .event-chat-ryt .chat-sender .media .media-body p span::after {\n\tleft: auto;\n\tright: 0;\n\t-webkit-transform: rotate(-135deg) translateY(15px);\n\ttransform: rotate(-135deg) translateY(15px);\n}\n.event-chat-ryt .chat-sender .media .media-body p .time {\n\tposition: absolute;\n\tfont-size: 0.625rem;\n\tcolor: #a098ae;\n\tfont-weight: 400;\n\tbottom: 0;\n\tright: -5rem;\n}\n[direction='rtl'] .event-chat-ryt .chat-sender .media .media-body p .time {\n\tleft: -5rem;\n\tright: auto;\n}\n\n.char-type {\n\tpadding-top: 1.875rem;\n\tpadding-bottom: 1.875rem;\n}\n.char-type form .form-control {\n\theight: 2.8125rem;\n\tpadding-left: 1.125rem;\n\tbackground: #e6ebee;\n\tborder-right: 0;\n}\n.char-type form .input-group-append i {\n\tcolor: #898989;\n\tfont-size: 1.125rem;\n}\n.char-type form .input-group-append .input-group-text {\n\tpadding-left: 0.7rem;\n\tpadding-right: 0.7rem;\n\tbackground: #e6ebee;\n\tborder-color: #f2f2f2;\n\tborder-left: 0;\n}\n.char-type form .input-group-append .input-group-text:last-child {\n\tpadding-right: 1.8rem;\n}\n\n.media-avatar {\n\tpadding: 1.5625rem 0;\n\tborder-bottom: 0.0625rem solid #f2f2f2;\n}\n.media-avatar:last-child {\n\tborder-bottom: 0rem;\n}\n.media-avatar p {\n\tmargin-bottom: 0;\n}\n.media-avatar .avatar-status {\n\tposition: relative;\n}\n.media-avatar .avatar-status i {\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n}\n\n.ct-golden-section:before {\n\tfloat: none;\n}\n\n.ct-chart {\n\tmax-height: 15.7rem;\n}\n\n.ct-chart .ct-label {\n\tfill: #a3afb7;\n\tcolor: #a3afb7;\n\tfont-size: 0.75rem;\n\tline-height: 1;\n}\n\n.ct-grid {\n\tstroke: rgba(49, 58, 70, 0.1);\n}\n\n.ct-chart.simple-pie-chart-chartist .ct-label {\n\tcolor: #ffffff;\n\tfill: #ffffff;\n\tfont-size: 0.625rem;\n}\n\n.ct-chart .ct-series.ct-series-a .ct-bar,\n.ct-chart .ct-series.ct-series-a .ct-line,\n.ct-chart .ct-series.ct-series-a .ct-point,\n.ct-chart .ct-series.ct-series-a .ct-slice-donut {\n\tstroke: var(--primary);\n}\n\n.ct-chart .ct-series.ct-series-b .ct-bar,\n.ct-chart .ct-series.ct-series-b .ct-line,\n.ct-chart .ct-series.ct-series-b .ct-point,\n.ct-chart .ct-series.ct-series-b .ct-slice-donut {\n\tstroke: #1eba62;\n}\n\n.ct-chart .ct-series.ct-series-c .ct-bar,\n.ct-chart .ct-series.ct-series-c .ct-line,\n.ct-chart .ct-series.ct-series-c .ct-point,\n.ct-chart .ct-series.ct-series-c .ct-slice-donut {\n\tstroke: #fcc43e;\n}\n\n.ct-chart .ct-series.ct-series-d .ct-bar,\n.ct-chart .ct-series.ct-series-d .ct-line,\n.ct-chart .ct-series.ct-series-d .ct-point,\n.ct-chart .ct-series.ct-series-d .ct-slice-donut {\n\tstroke: #fd5353;\n}\n\n.ct-chart .ct-series.ct-series-e .ct-bar,\n.ct-chart .ct-series.ct-series-e .ct-line,\n.ct-chart .ct-series.ct-series-e .ct-point,\n.ct-chart .ct-series.ct-series-e .ct-slice-donut {\n\tstroke: #00ada3;\n}\n\n.ct-chart .ct-series.ct-series-f .ct-bar,\n.ct-chart .ct-series.ct-series-f .ct-line,\n.ct-chart .ct-series.ct-series-f .ct-point,\n.ct-chart .ct-series.ct-series-f .ct-slice-donut {\n\tstroke: #303972;\n}\n\n.ct-chart .ct-series.ct-series-g .ct-bar,\n.ct-chart .ct-series.ct-series-g .ct-line,\n.ct-chart .ct-series.ct-series-g .ct-point,\n.ct-chart .ct-series.ct-series-g .ct-slice-donut {\n\tstroke: #8d6e63;\n}\n\n.ct-series-a .ct-area,\n.ct-series-a .ct-slice-pie {\n\tfill: #fb7d5b;\n}\n\n.ct-series-b .ct-area,\n.ct-series-b .ct-slice-pie {\n\tfill: #00a2ff;\n}\n\n.ct-series-c .ct-area,\n.ct-series-c .ct-slice-pie {\n\tfill: #ff9800;\n}\n\n.ct-series-d .ct-area,\n.ct-series-d .ct-slice-pie {\n\tfill: #ff9800;\n}\n\n.chartist-tooltip {\n\tposition: absolute;\n\tdisplay: inline-block;\n\topacity: 0;\n\tmin-width: 0.625rem;\n\tpadding: 0.125rem 0.625rem;\n\tborder-radius: 0.125rem;\n\tbackground: #313a46;\n\tcolor: #ffffff;\n\ttext-align: center;\n\tpointer-events: none;\n\tz-index: 1;\n\t-webkit-transition: opacity 0.2s linear;\n\t-moz-transition: opacity 0.2s linear;\n\t-o-transition: opacity 0.2s linear;\n\ttransition: opacity 0.2s linear;\n}\n\n.chartist-tooltip.tooltip-show {\n\topacity: 1;\n}\n\n#donught_graph .ct-series.ct-series-a .ct-slice-donut {\n\tstroke: #3fc6d4;\n}\n\n#donught_graph .ct-series.ct-series-b .ct-slice-donut {\n\tstroke: #333333;\n}\n\n#donught_graph .ct-series.ct-series-c .ct-slice-donut {\n\tstroke: #f63465;\n}\n\n@media only screen and (max-width: 47.9375rem) {\n\t#pie-chart .ct-label {\n\t\tcolor: #fff;\n\t\tfill: #fff;\n\t}\n}\n\n#visitor_graph {\n\theight: 15.8125rem !important;\n}\n\n#user_rating_graph {\n\theight: 17.5rem !important;\n}\n\n#activity {\n\theight: 16.875rem !important;\n}\n\n#visitorOnline {\n\theight: 4.5rem !important;\n}\n\n#trendMeter {\n\theight: 4.5rem !important;\n}\n\n#widget-revenue1,\n#widget-revenue2,\n#widget-revenue3 {\n\theight: 7.3125rem !important;\n}\n\n#widget-profit1,\n#widget-profit2,\n#widget-profit3 {\n\theight: 10rem !important;\n}\n\n#comparison-rate {\n\theight: 14.375rem;\n}\n\n#session_day {\n\theight: 10.9375rem;\n\twidth: auto !important;\n\tmargin: 0 auto;\n}\n\n#walet-status {\n\theight: 8.75rem;\n}\n\n#bar1 {\n\theight: 9.375rem;\n}\n\n#sold-product {\n\theight: 14.375rem;\n}\n\n#chart-venue-expenses,\n#chart-online-sale,\n#chart-gross-sale {\n\theight: 9.375rem !important;\n}\n\n#areaChart_3 {\n\theight: 18.4375rem !important;\n}\n\n.chart-point {\n\tdisplay: flex;\n\talign-items: center;\n}\n.chart-point .check-point-area {\n\twidth: 6.25rem;\n\theight: 6.25rem;\n\tmargin-top: -0.625rem;\n\tmargin-left: -0.625rem;\n}\n.chart-point .chart-point-list {\n\tmargin: 0;\n\tpadding-left: 0.3125rem;\n}\n.chart-point .chart-point-list li {\n\tlist-style: none;\n\tfont-size: 0.8125rem;\n\tpadding: 0.125rem 0;\n}\n.chart-point .chart-point-list li i {\n\tmargin-right: 0.3125rem;\n\tfont-size: 0.6875rem;\n\tposition: relative;\n\ttop: -0.0625rem;\n}\n\n.c3 {\n\theight: 15.625rem;\n}\n\n.c3-legend-item {\n\tfill: #9fabb1;\n}\n\n.c3 .c3-axis-x path,\n.c3 .c3-axis-x line,\n.c3 .c3-axis-y path,\n.c3 .c3-axis-y line,\n.tick text {\n\tstroke: #fff;\n}\n\n.flot-chart {\n\theight: 15.7rem;\n}\n\n.tooltipflot {\n\tbackground-color: transparent;\n\tfont-size: 1.4rem;\n\tpadding: 0.5rem 1rem;\n\tcolor: rgba(255, 255, 255, 0.7);\n\tborder-radius: 0.2rem;\n}\n\n.legendColorBox > div {\n\tborder: 0 !important;\n\tpadding: 0 !important;\n}\n\n.legendLabel {\n\tfont-size: 0.825rem;\n\tpadding-left: 0.5rem;\n\tcolor: var(--primary);\n}\n\n.flotTip {\n\tbackground: #000;\n\tborder: 0.0625rem solid #000;\n\tcolor: #fff;\n}\n\n.legend > div {\n\tbackground: transparent !important;\n}\n\n#balance_graph {\n\theight: 16.25rem;\n}\n\n.flot-chart .legend table tbody tr:last-child .legendLabel {\n\tcolor: var(--secondary);\n}\n\n.morris-hover {\n\tposition: absolute;\n\tz-index: 1;\n\tbackground: var(--primary);\n\tcolor: #fff;\n}\n\n.morris-hover .morris-hover-point {\n\tcolor: #fff !important;\n\tmargin: 0.1875rem 0;\n\ttext-align: center;\n\tpadding: 0 1.5625rem;\n\tcolor: #fff;\n}\n\n.morris-hover .morris-hover-row-label {\n\tbackground-color: #303972;\n\ttext-align: center;\n\tpadding: 0.3125rem;\n\tcolor: #fff;\n\tmargin-bottom: 0.3125rem;\n}\n\n.morris-hover.morris-default-style {\n\tborder-radius: 0.3125rem;\n\tpadding: 0;\n\tmargin: 0;\n\tborder: none;\n\toverflow: hidden;\n}\n\n/* svg text {\n    font-weight: 600 !important;\n} */\n#morris_donught,\n#morris_donught_2,\n#line_chart_2,\n#morris_bar,\n#morris_bar_stalked,\n#morris_bar_2,\n#morris_area_2,\n#morris_area {\n\theight: 15rem !important;\n}\n\n#morris_line {\n\theight: 17.375rem !important;\n}\n\n#crypto-btc-card,\n#crypto-eth-card,\n#crypto-rpl-card,\n#crypto-ltc-card {\n\theight: 9.375rem;\n}\n\n#daily-sales,\n#comparison-rate,\n#usage-chart,\n#walet-status {\n\twidth: 100%;\n\tdisplay: block;\n}\n#daily-sales canvas,\n#comparison-rate canvas,\n#usage-chart canvas,\n#walet-status canvas {\n\tmax-width: 100% !important;\n\twidth: 100% !important;\n}\n\n#sparkline-composite-chart canvas,\n#composite-bar canvas,\n#sparkline11 canvas,\n#StackedBarChart canvas,\n#spark-bar canvas,\n#tristate canvas {\n\theight: 6.25rem !important;\n}\n\n#sparkline11 canvas {\n\twidth: 6.25rem !important;\n}\n\n.easy-pie-chart {\n\tposition: relative;\n\ttext-align: center;\n}\n.easy-pie-chart .inner {\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n\tdisplay: inline-block;\n}\n.easy-pie-chart img {\n\twidth: 4.6875rem;\n\theight: 4.6875rem;\n\tborder-radius: 50%;\n}\n.easy-pie-chart canvas {\n\tdisplay: block;\n\tmargin: 0 auto;\n}\n\n#revenue-chart {\n\theight: 27.7rem;\n}\n\n#duration-value-axis {\n\theight: 27.6rem;\n\twidth: 100%;\n}\n\n#combined-bullet {\n\theight: 28.125rem;\n\twidth: 100%;\n}\n\n#zoomable-chart {\n\theight: 28.125rem;\n\twidth: 100%;\n}\n\n#chartMap {\n\theight: 28.125rem;\n\twidth: 100%;\n}\n\n#professional-candlesticks {\n\twidth: 100%;\n\theight: 28.125rem;\n}\n\n#comparing-stock-indices {\n\twidth: 100%;\n\theight: 28.125rem;\n}\n\n#multiple-panel-data {\n\twidth: 100%;\n\theight: 28.125rem;\n}\n\n#depth-chart {\n\twidth: 100%;\n\theight: 28.125rem;\n}\n\n.amcharts-export-menu {\n\tdisplay: none;\n}\n\n.amcharts-data-set-selector-div {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttext-align: center;\n\twidth: 16.875rem;\n\tmargin: 0 auto;\n}\n.amcharts-data-set-selector-div select {\n\tborder: 0;\n\tmargin-left: 0.625rem;\n\tbackground: #ddd;\n\tcolor: #000;\n}\n\n.amChartsInputField {\n\tborder: 0;\n\tbackground: var(--primary);\n\tcolor: #fff;\n\tpadding: 0.3125rem 0.9375rem;\n\tmargin: 0 0.9375rem;\n}\n\n.amcharts-data-set-select {\n\tborder: 0;\n\tbackground: #ddd;\n\tcolor: #000;\n}\n\n.amcharts-period-input,\n.amcharts-period-input-selected {\n\tborder: 0;\n\tmargin-left: 0.625rem;\n\tbackground: var(--primary);\n\tcolor: #fff;\n\tpadding: 0.3125rem 0.9375rem;\n}\n\n.amcharts-graph-g2 .amcharts-graph-stroke {\n\tstroke-dasharray: 0.1875rem 0.1875rem;\n\tstroke-linejoin: round;\n\tstroke-linecap: round;\n\t-webkit-animation: am-moving-dashes 1s linear infinite;\n\tanimation: am-moving-dashes 1s linear infinite;\n}\n\n@-webkit-keyframes am-moving-dashes {\n\t100% {\n\t\tstroke-dashoffset: -1.9375rem;\n\t}\n}\n\n@keyframes am-moving-dashes {\n\t100% {\n\t\tstroke-dashoffset: -1.9375rem;\n\t}\n}\n\n.lastBullet {\n\t-webkit-animation: am-pulsating 1s ease-out infinite;\n\tanimation: am-pulsating 1s ease-out infinite;\n}\n\n@-webkit-keyframes am-pulsating {\n\t0% {\n\t\tstroke-opacity: 1;\n\t\tstroke-width: 0px;\n\t}\n\t100% {\n\t\tstroke-opacity: 0;\n\t\tstroke-width: 3.125rem;\n\t}\n}\n\n@keyframes am-pulsating {\n\t0% {\n\t\tstroke-opacity: 1;\n\t\tstroke-width: 0px;\n\t}\n\t100% {\n\t\tstroke-opacity: 0;\n\t\tstroke-width: 3.125rem;\n\t}\n}\n\n.amcharts-graph-column-front {\n\t-webkit-transition: all 0.3s 0.3s ease-out;\n\ttransition: all 0.3s 0.3s ease-out;\n}\n\n.amcharts-graph-column-front:hover {\n\tfill: #496375;\n\tstroke: #496375;\n\t-webkit-transition: all 0.3s ease-out;\n\ttransition: all 0.3s ease-out;\n}\n\n@-webkit-keyframes am-draw {\n\t0% {\n\t\tstroke-dashoffset: 500%;\n\t}\n\t100% {\n\t\tstroke-dashoffset: 0%;\n\t}\n}\n\n@keyframes am-draw {\n\t0% {\n\t\tstroke-dashoffset: 500%;\n\t}\n\t100% {\n\t\tstroke-dashoffset: 0%;\n\t}\n}\n\n@media only screen and (max-width: 61.9375rem) {\n\t.amChartsPeriodSelector > fieldset > div {\n\t\tfloat: none !important;\n\t\tdisplay: block !important;\n\t\tmargin-bottom: 0.625rem;\n\t}\n}\n\n.highcharts-root text {\n\tfont-weight: 300 !important;\n}\n\n.highcharts-credits {\n\tdisplay: none;\n}\n\n#chart_employee_gender,\n#chart_employee_status {\n\twidth: auto;\n\theight: 21.875rem;\n}\n\n.form-control {\n\tbackground: #fff;\n\tcolor: #303972;\n\tline-height: 1.7;\n\tfont-size: 0.9rem;\n\theight: 3rem;\n\tborder-radius: 0.375rem;\n\tborder-color: #dddddd;\n}\n.form-control:hover,\n.form-control:focus,\n.form-control.active {\n\tbox-shadow: none;\n\tbackground: #fff;\n\tcolor: #303972;\n}\n.form-control:focus {\n\tborder-color: var(--primary);\n\tbox-shadow: 0 0 0 0.125rem var(--rgba-primary-2);\n}\n.form-control.solid {\n\tbackground: #e6ebee;\n\tborder-color: #ececec;\n\tcolor: #000;\n}\n.form-control.solid[type='file'] {\n\tpadding: 6px 10px;\n}\n\n.bootstrap-select .btn {\n\tpadding: 0.6875rem 1.25rem;\n\tborder-color: #dddddd;\n\tborder-width: 1px;\n\tline-height: 1.5;\n}\n\n.input-rounded {\n\tborder-radius: 6.25rem;\n}\n\n[data-theme-version='light'] .input-primary .form-control,\n[data-theme-version='dark'] .input-primary .form-control {\n\tborder-color: var(--primary);\n}\n\n[data-theme-version='light'] .input-primary .input-group-text,\n[data-theme-version='dark'] .input-primary .input-group-text {\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n}\n\n[data-theme-version='light'] .input-danger .form-control,\n[data-theme-version='dark'] .input-danger .form-control {\n\tborder-color: #fd5353;\n}\n\n[data-theme-version='light'] .input-danger .input-group-text,\n[data-theme-version='dark'] .input-danger .input-group-text {\n\tbackground-color: #fd5353;\n\tcolor: #fff;\n}\n\n[data-theme-version='light'] .input-info .form-control,\n[data-theme-version='dark'] .input-info .form-control {\n\tborder-color: #00ada3;\n}\n\n[data-theme-version='light'] .input-info .input-group-text,\n[data-theme-version='dark'] .input-info .input-group-text {\n\tbackground-color: #00ada3;\n\tcolor: #fff;\n}\n\n[data-theme-version='light'] .input-success .form-control,\n[data-theme-version='dark'] .input-success .form-control {\n\tborder-color: #1eba62;\n}\n\n[data-theme-version='light'] .input-success .input-group-text,\n[data-theme-version='dark'] .input-success .input-group-text {\n\tbackground-color: #1eba62;\n\tcolor: #fff;\n}\n\n[data-theme-version='light'] .input-warning .form-control,\n[data-theme-version='dark'] .input-warning .form-control {\n\tborder-color: #fcc43e;\n}\n\n[data-theme-version='light'] .input-warning .input-group-text,\n[data-theme-version='dark'] .input-warning .input-group-text {\n\tbackground-color: #fcc43e;\n\tcolor: #fff;\n}\n\n[data-theme-version='light'] .input-primary-o .form-control,\n[data-theme-version='dark'] .input-primary-o .form-control {\n\tborder-color: var(--primary);\n}\n\n[data-theme-version='light'] .input-primary-o .input-group-text,\n[data-theme-version='dark'] .input-primary-o .input-group-text {\n\tbackground-color: transparent;\n\tborder-color: var(--primary);\n\tcolor: var(--primary);\n}\n\n[data-theme-version='light'] .input-danger-o .form-control,\n[data-theme-version='dark'] .input-danger-o .form-control {\n\tborder-color: #fd5353;\n}\n\n[data-theme-version='light'] .input-danger-o .input-group-text,\n[data-theme-version='dark'] .input-danger-o .input-group-text {\n\tbackground-color: transparent;\n\tborder-color: #fd5353;\n\tcolor: #fd5353;\n}\n\n[data-theme-version='light'] .input-info-o .form-control,\n[data-theme-version='dark'] .input-info-o .form-control {\n\tborder-color: #00ada3;\n}\n\n[data-theme-version='light'] .input-info-o .input-group-text,\n[data-theme-version='dark'] .input-info-o .input-group-text {\n\tbackground-color: transparent;\n\tborder-color: #00ada3;\n\tcolor: #00ada3;\n}\n\n[data-theme-version='light'] .input-success-o .form-control,\n[data-theme-version='dark'] .input-success-o .form-control {\n\tborder-color: #1eba62;\n}\n\n[data-theme-version='light'] .input-success-o .input-group-text,\n[data-theme-version='dark'] .input-success-o .input-group-text {\n\tbackground-color: transparent;\n\tborder-color: #1eba62;\n\tcolor: #1eba62;\n}\n\n[data-theme-version='light'] .input-warning-o .form-control,\n[data-theme-version='dark'] .input-warning-o .form-control {\n\tborder-color: #fcc43e;\n}\n\n[data-theme-version='light'] .input-warning-o .input-group-text,\n[data-theme-version='dark'] .input-warning-o .input-group-text {\n\tbackground-color: transparent;\n\tborder-color: #fcc43e;\n\tcolor: #fcc43e;\n}\n\n.input-group-text {\n\tmin-width: 3.125rem;\n\tjustify-content: center;\n\tborder-radius: 0.375rem;\n\tfont-weight: 600;\n\tfont-size: 1rem;\n\tbackground-color: #ededed;\n}\n\n.form-file-label {\n\theight: 2.5rem;\n\tpadding: 0.5rem 0.75rem;\n}\n\n.input-group-prepend .btn,\n.input-group-append .btn {\n\tz-index: 0;\n}\n\n.custom-select {\n\tbackground: none;\n\tborder-color: #f2f2f2;\n\tcolor: #303972;\n}\n.custom-select:focus {\n\tbox-shadow: none;\n\tborder-color: var(--primary);\n\tcolor: var(--primary);\n}\n\n.form-file-label {\n\tbackground: #656c73;\n\twhite-space: nowrap;\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .form-file-label {\n\tbackground: rgba(255, 255, 255, 0.1);\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #a098ae;\n}\n\n.custom_file_input .form-file-label::after {\n\theight: 100%;\n}\n\n.form-control:disabled,\n.form-control[readonly] {\n\tbackground: #fff;\n\topacity: 1;\n}\n\n.form-file {\n\tborder: 0.0625rem solid #f2f2f2;\n\tbackground: #fff;\n}\n[data-theme-version='dark'] .form-file {\n\tbackground: #202020;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n.input-group {\n\t/* &> .form-file {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t&:not(:last-child) .form-file-label,\n\t\t&:not(:last-child) .form-file-label::after { @include border-right-radius(0); }\n\t\t&:not(:first-child) .form-file-label { @include border-left-radius(0); }\n\t  } */\n}\n.input-group > .form-control-plaintext,\n.input-group > .form-select,\n.input-group > .form-file {\n\tposition: relative;\n\tflex: 1 1 auto;\n\twidth: 1%;\n\tmargin-bottom: 0;\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\n\tborder-radius: 0.375rem;\n}\n\n.form-file .form-control {\n\tmargin: 0;\n\tborder-radius: 0;\n\tborder: 0;\n\theight: auto;\n}\n\n#validationCustomUsername {\n\tborder-radius: 0 0.5rem 0.5rem 0;\n}\n\n.show-pass {\n\tborder-radius: 0 0.5rem 0.5rem 0 !important;\n}\n\n.form-file .form-control {\n\tmargin: 0;\n\tborder-radius: 0;\n\tborder: 0;\n\theight: auto;\n\tline-height: 24.4px;\n}\n\n.input-group .input-group-text + .form-file {\n\tborder-radius: 0 0.5rem 0.5rem 0;\n}\n.input-group .input-group-text + .form-file .form-control {\n\tborder-radius: inherit;\n\tmargin: 0;\n}\n\n.custom_file_input .form-file {\n\tborder-radius: 0.5rem;\n}\n.custom_file_input .form-file .form-control {\n\tmargin: 0;\n\tborder: 0;\n\tline-height: 2.125rem;\n\tborder-radius: inherit;\n\tfont-size: 16px;\n\tfont-weight: 600;\n}\n\n.custom_file_input .form-control {\n\tpadding-left: 12px;\n\tline-height: 45px;\n}\n\n#username {\n\tborder-radius: 0 0.5rem 0.5rem 0;\n}\n\n.form-control-lg {\n\tmin-height: 3.75rem;\n\tpadding: 0.5rem 1.1rem;\n\tfont-size: 1.09375rem;\n\tborder-radius: 0.5rem;\n\theight: calc(1.5em + 1rem + 2px);\n}\n\n.form-control-sm {\n\tmin-height: 2.5rem;\n\tpadding: 0.25rem 1.1rem;\n\tfont-size: 0.76563rem;\n\tborder-radius: 0.5rem;\n\theight: calc(1.5em + 0.5rem + 2px);\n}\n\n.card.checkboxes .form-check .form-check-input[type='radio'] {\n\tmargin-left: -1.188rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.card.checkboxes .form-check .form-check-input[type='radio'] {\n\t\tmargin-left: -1.388rem;\n\t}\n}\n\n.modal-grid {\n\tbackground: #e6ebee;\n}\n\n.nice-select.wide.form-control-lg {\n\tline-height: 2.7125rem;\n}\n\n.nice-select.wide.form-control-sm {\n\tline-height: 1.8125rem;\n}\n\n.inline-check {\n\tline-height: 1.8rem !important;\n}\n\n.form-check {\n\tfont-size: 14px;\n\tfont-weight: 600;\n}\n\n.input-full {\n\tborder: 0;\n}\n\n.border-1 {\n\tborder-radius: 0.5rem 0 0 0.5rem !important;\n}\n\n.border3 {\n\tborder-radius: 0 0.5rem 0.5rem 0 !important;\n}\n\n.custome-input .input-group-text {\n\tborder-color: transparent !important;\n}\n\n.form-control-sm[type='file'] {\n\tline-height: 32px;\n\tpadding: 4px;\n\tpadding-left: 8px;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.form-control-sm[type='file'] {\n\t\tpadding: 3px;\n\t\tline-height: 27px;\n\t\tpadding-left: 7px;\n\t}\n}\n\n.form-control-lg[type='file'] {\n\tline-height: 42px;\n\tpadding-left: 10px;\n}\n\n.input-group.input-group-lg .form-control {\n\theight: 3.75rem;\n}\n\n.input-group.input-group-sm .form-control {\n\theight: 2.5rem;\n}\n\n.right-radius {\n\tborder-top-right-radius: 0 !important;\n\tborder-bottom-right-radius: 0 !important;\n}\n\n.left-radius {\n\tborder-top-left-radius: 0 !important;\n\tborder-bottom-left-radius: 0 !important;\n}\n\n:root {\n\t--primary: #4d44b5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3d3690;\n\t--primary-dark: #1e1a46;\n\t--rgba-primary-1: rgba(77, 68, 181, 0.1);\n\t--rgba-primary-2: rgba(77, 68, 181, 0.2);\n\t--rgba-primary-3: rgba(77, 68, 181, 0.3);\n\t--rgba-primary-4: rgba(77, 68, 181, 0.4);\n\t--rgba-primary-5: rgba(77, 68, 181, 0.5);\n\t--rgba-primary-6: rgba(77, 68, 181, 0.6);\n\t--rgba-primary-7: rgba(77, 68, 181, 0.7);\n\t--rgba-primary-8: rgba(77, 68, 181, 0.8);\n\t--rgba-primary-9: rgba(77, 68, 181, 0.9);\n\t--rgba-secondary-1: rgba(251, 125, 91, 0.1);\n\t--rgba-secondary-2: rgba(251, 125, 91, 0.2);\n\t--rgba-secondary-3: rgba(251, 125, 91, 0.3);\n\t--rgba-secondary-4: rgba(251, 125, 91, 0.4);\n\t--rgba-secondary-5: rgba(251, 125, 91, 0.5);\n\t--rgba-secondary-6: rgba(251, 125, 91, 0.6);\n\t--rgba-secondary-7: rgba(251, 125, 91, 0.7);\n\t--rgba-secondary-8: rgba(251, 125, 91, 0.8);\n\t--rgba-secondary-9: rgba(251, 125, 91, 0.9);\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--title: #303972;\n}\n\n.form-check-label {\n\tmargin-left: 1rem;\n\ttext-transform: capitalize;\n\tmargin-top: 0.1875rem;\n}\n\n#example5_wrapper .form-check-input:checked {\n\tborder-color: var(--primary) !important;\n}\n\n#example5_wrapper table.dataTable thead .sorting_asc {\n\tdisplay: flex;\n}\n\n#example5_wrapper .btn.tp-btn.btn-primary:hover svg path {\n\tstroke: #fff;\n}\n\n.form-check-inline .form-check-input {\n\tmargin-right: 0.625rem;\n\tmargin-top: 0;\n}\n\n.bootstrap-select .dropdown-menu {\n\tz-index: 9999;\n}\n\n.form-control:focus {\n\tbox-shadow: none;\n}\n\n.form-check-input {\n\ttop: 0.125rem;\n\tborder-width: 0.125rem;\n\twidth: 1.25rem;\n\theight: 1.25rem;\n\tborder-color: #c4c4c4;\n\tbackground-color: transparent;\n}\n\n.rtl .form-check-label:before,\n.rtl .form-check-label:after {\n\tright: -1.5rem !important;\n\tleft: inherit;\n}\n\n.form-check {\n\tline-height: normal;\n}\n\n.toggle-switch {\n\tpadding-left: 3.125rem;\n\tline-height: 1.25;\n\tdisplay: inline-block;\n\tcolor: #000;\n\tfont-weight: 600;\n}\n.toggle-switch .form-check-input {\n\tborder: 0;\n\tcursor: pointer;\n\tbackground: #d8d8d8;\n\twidth: 2.2125rem;\n\tborder-radius: 1.25rem !important;\n\theight: 0.875rem;\n\tposition: relative;\n\tleft: -0.3125rem;\n\t-webkit-transition: all 0.2s;\n\t-ms-transition: all 0.2s;\n\ttransition: all 0.2s;\n\tbackground-image: none;\n}\n.toggle-switch .form-check-input:focus {\n\tbackground-image: none !important;\n}\n.toggle-switch .form-check-input:checked {\n\tbackground: var(--rgba-primary-1);\n\tbackground-image: none !important;\n}\n.toggle-switch .form-check-input:checked:after {\n\tleft: 1.3rem;\n\tbackground: var(--primary);\n}\n.toggle-switch .form-check-input:focus {\n\tbox-shadow: none;\n}\n.toggle-switch .form-check-input:after {\n\twidth: 1rem;\n\tbackground: #909090;\n\theight: 1rem;\n\tcontent: '';\n\tposition: absolute;\n\tborder-radius: 1.5rem;\n\ttop: -0.0475rem;\n\tleft: 0;\n\t-webkit-transition: all 0.2s;\n\t-ms-transition: all 0.2s;\n\ttransition: all 0.2s;\n}\n.toggle-switch.text-end {\n\tpadding-right: 0rem;\n\tpadding-left: 0;\n}\n.toggle-switch.text-end .form-check-input {\n\tleft: auto;\n\tmargin-left: 0;\n\tfloat: right;\n\tright: 0rem;\n}\n.toggle-switch.text-end .form-check-label {\n\tmargin-right: 0.9375rem;\n\tmargin-left: 0;\n}\n.toggle-switch .form-check-label {\n\tcursor: pointer;\n}\n\n.form-check-input:focus ~ .form-check-label::before {\n\tbox-shadow: none !important;\n}\n\n.form-check-label::before {\n\tbackground-color: transparent;\n\tborder-color: #ebebf9;\n\tborder-width: 0.125rem;\n\tborder-radius: 0.125rem !important;\n}\n[data-theme-version='dark'] .form-check-label::before {\n\tbackground-color: transparent;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n.check-xs .form-check-input {\n\twidth: 1.125rem;\n\theight: 1.125rem;\n}\n\n.check-lg .form-check-input {\n\twidth: 1.5rem;\n\theight: 1.5rem;\n}\n\n.check-xl .form-check-input {\n\twidth: 1.75rem;\n\theight: 1.75rem;\n}\n\n.checkbox-info .form-check-input:focus {\n\tborder-color: #00ada3;\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.25rem rgba(0, 173, 163, 0.25);\n}\n\n.checkbox-info .form-check-input:checked {\n\tbackground-color: #00ada3;\n\tborder-color: #00ada3;\n}\n\n.checkbox-danger .form-check-input:focus {\n\tborder-color: #fd5353;\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.25rem rgba(253, 83, 83, 0.25);\n}\n\n.checkbox-danger .form-check-input:checked {\n\tbackground-color: #fd5353;\n\tborder-color: #fd5353;\n}\n\n.checkbox-success .form-check-input:focus {\n\tborder-color: #1eba62;\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.25rem rgba(30, 186, 98, 0.25);\n}\n\n.checkbox-success .form-check-input:checked {\n\tbackground-color: #1eba62 !important;\n\tborder-color: #1eba62;\n}\n\n.checkbox-warning .form-check-input:focus {\n\tborder-color: #fcc43e;\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.25rem rgba(252, 196, 62, 0.25);\n}\n\n.checkbox-warning .form-check-input:checked {\n\tbackground-color: #fcc43e;\n\tborder-color: #fcc43e;\n}\n\n.checkbox-secondary .form-check-input:focus {\n\tborder-color: #fb7d5b;\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.25rem rgba(251, 125, 91, 0.25);\n}\n\n.checkbox-secondary .form-check-input:checked {\n\tbackground-color: #fb7d5b;\n\tborder-color: #fb7d5b;\n}\n\n.check-switch {\n\tpadding-left: 2.5rem;\n}\n.check-switch .form-check-label {\n\tline-height: 1.875rem;\n\tfont-weight: 500;\n}\n.check-switch .form-check-label span {\n\tline-height: 1;\n}\n.check-switch .form-check-label:after,\n.check-switch .form-check-label:before {\n\theight: 1.5rem;\n\twidth: 1.5rem;\n\tleft: -2rem;\n\tborder-radius: 3rem !important;\n\tborder-color: var(--rgba-primary-3);\n}\n.check-switch .form-check-input:checked ~ .form-check-label::before {\n\tbackground: #fff;\n}\n\n.form-check .form-check-input[type='radio'] {\n\tmargin-left: -1em;\n\ttop: 0.03rem;\n}\n\n.form-check-input:checked {\n\tbackground-color: var(--primary);\n\tborder-color: var(--primary);\n}\n\n.form-check-input:focus {\n\tborder-color: var(--primary);\n\tbox-shadow: var(--rgba-primary-1);\n}\n\n.form-check-input[type='radio'] {\n\twidth: 1.313rem;\n\tmin-width: 1.313rem;\n\theight: 1.313rem;\n\tposition: relative;\n\tborder-color: #a5aab4;\n\tborder-width: 0.125rem;\n\tborder-style: solid;\n\ttop: -0.125rem;\n}\n.form-check-input[type='radio']:focus {\n\tbox-shadow: none;\n}\n\n.form-check-input[type='radio'] + .form-check-label {\n\tmargin-bottom: 0;\n}\n\n.form-check-input:checked[type='radio'] {\n\tbackground-image: none;\n\tbackground-color: var(--rgba-primary-3);\n\tborder-color: transparent !important;\n}\n.form-check-input:checked[type='radio']:after {\n\tcontent: '';\n\theight: 0.688rem;\n\twidth: 0.688rem;\n\tbackground-color: var(--primary);\n\tposition: absolute;\n\ttop: 0.188rem;\n\tleft: 0.188rem;\n\tborder-radius: 50%;\n}\n\n.checkbox-info .form-check-input[type='radio'] {\n\tborder-color: #00ada3;\n}\n\n.checkbox-info .form-check-input:checked[type='radio'] {\n\tbackground-color: #94fff9;\n}\n.checkbox-info .form-check-input:checked[type='radio']:after {\n\tbackground-color: #00ada3;\n}\n\n.checkbox-danger .form-check-input[type='radio'] {\n\tborder-color: #fd5353;\n}\n\n.checkbox-danger .form-check-input:checked[type='radio'] {\n\tbackground-color: #ffeaea;\n}\n.checkbox-danger .form-check-input:checked[type='radio']:after {\n\tbackground-color: #fd5353;\n}\n\n.checkbox-success .form-check-input[type='radio'] {\n\tborder-color: #1eba62;\n}\n\n.checkbox-success .form-check-input:checked[type='radio'] {\n\tbackground-color: #ddfaea;\n}\n.checkbox-success .form-check-input:checked[type='radio']:after {\n\tbackground-color: #1eba62;\n}\n\n.checkbox-warning .form-check-input[type='radio'] {\n\tborder-color: #fcc43e;\n}\n\n.checkbox-warning .form-check-input:checked[type='radio'] {\n\tbackground-color: #fffaee;\n}\n.checkbox-warning .form-check-input:checked[type='radio']:after {\n\tbackground-color: #fcc43e;\n}\n\n.checkbox-dark .form-check-input[type='radio'] {\n\tborder-color: #303972;\n}\n\n.checkbox-dark .form-check-input:checked[type='radio'] {\n\tbackground-color: white;\n}\n.checkbox-dark .form-check-input:checked[type='radio']:after {\n\tbackground-color: var(--primary);\n}\n\n.checkbox-secondary .form-check-input[type='radio'] {\n\tborder-color: #fb7d5b;\n}\n\n.checkbox-secondary .form-check-input:checked[type='radio'] {\n\tbackground-color: #fff3f0;\n}\n.checkbox-secondary .form-check-input:checked[type='radio']:after {\n\tbackground-color: #fb7d5b;\n}\n\n.js-switch + .switchery {\n\tborder-radius: 3.125rem;\n\tmargin-right: 4rem;\n}\n@media (max-width: 575.98px) {\n\t.js-switch + .switchery {\n\t\tmargin-right: 1rem;\n\t}\n}\n.js-switch + .switchery > small,\n.js-switch + .switchery > .small {\n\ttop: 0.125rem;\n}\n\n.js-switch.js-switch-lg + .switchery {\n\theight: 2rem;\n\twidth: 4.5rem;\n}\n.js-switch.js-switch-lg + .switchery > small,\n.js-switch.js-switch-lg + .switchery > .small {\n\twidth: 1.75rem;\n\theight: 1.75rem;\n}\n\n.js-switch.js-switch-md + .switchery {\n\theight: 1.5rem;\n\twidth: 3.5rem;\n}\n.js-switch.js-switch-md + .switchery > small,\n.js-switch.js-switch-md + .switchery > .small {\n\twidth: 1.25rem;\n\theight: 1.25rem;\n}\n\n.js-switch.js-switch-sm + .switchery {\n\theight: 1rem;\n\twidth: 2.2rem;\n}\n.js-switch.js-switch-sm + .switchery > small,\n.js-switch.js-switch-sm + .switchery > .small {\n\twidth: 0.875rem;\n\theight: 0.875rem;\n\ttop: 0.0625rem;\n}\n\n.js-switch-square + .switchery {\n\tborder-radius: 0;\n}\n.js-switch-square + .switchery > small,\n.js-switch-square + .switchery > .small {\n\tborder-radius: 0;\n\ttop: 0.125rem;\n}\n\n.js-switch-square.js-switch-lg + .switchery {\n\theight: 2rem;\n\twidth: 4.5rem;\n}\n.js-switch-square.js-switch-lg + .switchery > small,\n.js-switch-square.js-switch-lg + .switchery > .small {\n\twidth: 1.75rem;\n\theight: 1.75rem;\n}\n\n.js-switch-square.js-switch-md + .switchery {\n\theight: 1.5rem;\n\twidth: 3.5rem;\n}\n.js-switch-square.js-switch-md + .switchery > small,\n.js-switch-square.js-switch-md + .switchery > .small {\n\twidth: 1.25rem;\n\theight: 1.25rem;\n}\n\n.js-switch-square.js-switch-sm + .switchery {\n\theight: 1rem;\n\twidth: 2.2rem;\n}\n.js-switch-square.js-switch-sm + .switchery > small,\n.js-switch-square.js-switch-sm + .switchery > .small {\n\twidth: 0.875rem;\n\theight: 0.875rem;\n\ttop: 0.0625rem;\n}\n\n.form-control.is-valid {\n\tborder-color: #1eba62 !important;\n\tborder-right: 0rem !important;\n}\n.form-control.is-valid:focus {\n\tbox-shadow: none;\n}\n\n.form-control.is-warning {\n\tborder-color: #fcc43e !important;\n\tborder-right: 0rem !important;\n}\n.form-control.is-warning:focus {\n\tbox-shadow: none;\n}\n\n.form-control.is-invalid {\n\tborder-color: #fd5353 !important;\n\tborder-right: 0rem !important;\n}\n.form-control.is-invalid:focus {\n\tbox-shadow: none;\n}\n\n.is-valid .input-group-prepend .input-group-text i {\n\tcolor: #1eba62;\n}\n\n.is-invalid .input-group-prepend .input-group-text i {\n\tcolor: var(--rgba-primary-2);\n}\n\n.show-pass {\n\tcursor: pointer;\n}\n.show-pass .fa-eye {\n\tdisplay: none;\n}\n.show-pass.active .fa-eye-slash {\n\tdisplay: none;\n}\n.show-pass.active .fa-eye {\n\tdisplay: inline-block;\n}\n\n.asColorPicker-dropdown {\n\tmax-width: 26rem;\n}\n\n.asColorPicker-trigger {\n\tbackground: none;\n}\n\n.asColorPicker-trigger {\n\tborder: 0 none;\n\theight: 100%;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\twidth: 2.1875rem;\n}\n\n[direction='rtl'] .asColorPicker-trigger {\n\tleft: 0;\n\tright: auto;\n}\n\n.asColorPicker-trigger span {\n\tborder-radius: 0 0.425rem 0.425rem 0;\n}\n\n.asColorPicker-clear {\n\tdisplay: none;\n\tposition: absolute;\n\tright: 1rem;\n\ttext-decoration: none;\n\ttop: 0.5rem;\n}\n\n.daterangepicker td.active {\n\tbackground-color: var(--primary);\n}\n.daterangepicker td.active:hover {\n\tbackground-color: var(--primary);\n}\n\n.daterangepicker button.applyBtn {\n\tbackground-color: var(--primary);\n\tborder-color: var(--primary);\n}\n\n.datepicker.datepicker-dropdown {\n\tbackground: #fff;\n\tborder-radius: 0.0625rem;\n\tborder: 0.0625rem solid #eeeeee;\n}\n.datepicker.datepicker-dropdown td.day,\n.datepicker.datepicker-dropdown th.next,\n.datepicker.datepicker-dropdown th.prev {\n\theight: 1.875rem;\n\twidth: 1.875rem !important;\n\tpadding: 0;\n\ttext-align: center;\n\tfont-weight: 500;\n\tborder-radius: 0.375rem;\n}\n.datepicker.datepicker-dropdown td.day:hover,\n.datepicker.datepicker-dropdown th.next:hover,\n.datepicker.datepicker-dropdown th.prev:hover {\n\tbox-shadow: unset;\n\t/*  color: $main-color; */\n\tbackground-color: var(--rgba-primary-1);\n}\n.datepicker.datepicker-dropdown th.datepicker-switch,\n.datepicker.datepicker-dropdown th.next,\n.datepicker.datepicker-dropdown th.prev {\n\tfont-weight: 600;\n\tcolor: #333;\n}\n.datepicker.datepicker-dropdown th.dow {\n\tfont-weight: 600;\n}\n\n.datepicker table tr td.selected,\n.datepicker table tr td.active.active {\n\tbackground-color: var(--primary);\n\tborder-radius: 0.375rem;\n\tborder: 0;\n\tcolor: #fff;\n\tbackground-image: none;\n\tposition: relative;\n}\n\n.datepicker table tr td.today {\n\tborder-radius: 0.375rem;\n\t/* color : $main-color; */\n}\n.datepicker table tr td.today:hover {\n\tbackground-color: var(--primary);\n\tbox-shadow: 0rem 0rem 1.875rem 0.3125rem rgba(243, 30, 122, 0.3);\n\tcolor: #ffffff;\n}\n\n.datepicker table tr td.today.disabled {\n\tbox-shadow: 0rem 0rem 1.875rem 0.3125rem rgba(243, 30, 122, 0.3);\n\tcolor: #ffffff;\n}\n.datepicker table tr td.today.disabled:hover {\n\tbox-shadow: 0rem 0rem 1.875rem 0.3125rem rgba(243, 30, 122, 0.3);\n\tcolor: #ffffff;\n}\n\n.datepicker table thead tr:first-child th:hover {\n\tbackground: var(--rgba-primary-1);\n}\n\n.datepicker table thead tr th:hover {\n\tbackground: var(--rgba-primary-1);\n}\n\n.datepicker table td.day:hover {\n\tbackground: var(--rgba-primary-1);\n\tborder-radius: 0.375rem;\n}\n\n.picker__select--month,\n.picker__select--year {\n\theight: 2.5em;\n}\n\n.picker__input {\n\tbackground-color: transparent !important;\n}\n[data-theme-version='dark'] .picker__input {\n\tbackground-color: transparent !important;\n\tborder: 0.0625rem solid rgba(255, 255, 255, 0.1);\n}\n\n.bootstrap-select.form-control-lg .dropdown-toggle {\n\tmin-height: 3.75rem;\n\tpadding: 0.5rem 1.563rem;\n}\n\n.bootstrap-select.form-control-sm .dropdown-toggle {\n\tmin-height: 2.5rem;\n\tpadding: 0.25rem 1.563rem;\n}\n\n.basic-form .form-check-input[type='radio'] + .form-check-label {\n\tmargin-top: 5px;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n\tmin-height: 2.5rem;\n\tpadding: 0.25rem 1.1rem;\n\tborder-radius: 0.375rem;\n}\n\n.input-group.input-group-lg {\n\tmin-height: 3.75rem;\n\tborder-radius: 0.375rem;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n\tborder-radius: 0.375rem;\n}\n\n.clockpicker-popover .popover-title {\n\tpadding: 0.625rem 0px;\n}\n\n.picker-data .color-time-picker .react-time-picker {\n\twidth: 100%;\n}\n\n.picker-data .color-time-picker .react-time-picker__wrapper {\n\tborder: 0;\n\tcolor: #7e7e7e;\n}\n.picker-data .color-time-picker .react-time-picker__wrapper .react-time-picker__clear-button {\n\tdisplay: none;\n}\n.picker-data .color-time-picker .react-time-picker__wrapper .react-time-picker__inputGroup {\n\tborder: 1px solid #b7b7b7;\n\tborder-width: 0 0 1px 0;\n\tpadding: 0.35rem 0rem;\n}\n.picker-data .color-time-picker .react-time-picker__wrapper .react-time-picker__inputGroup__input {\n\tcolor: #7e7e7e;\n}\n.picker-data .color-time-picker .react-time-picker__wrapper .react-time-picker__inputGroup__amPm {\n\tcolor: #7e7e7e;\n\tappearance: none;\n}\n.picker-data .color-time-picker .react-time-picker__wrapper .react-time-picker__clock-button {\n\tbackground: #4d44b5;\n\tcolor: #b7b7b7;\n\tpadding: 0.532rem 0.75rem;\n\tborder-radius: 0 0.75rem 0.75rem 0;\n\tmin-width: 3.125rem;\n\ttext-align: center;\n\tline-height: 1;\n}\n.picker-data .color-time-picker .react-time-picker__wrapper .react-time-picker__clock-button svg {\n\tstroke: #fff;\n\tdisplay: inline-block;\n}\n\n.picker-data .color-time-picker .react-clock__face {\n\tbackground: #ededed;\n\tpadding: 0.625rem 0.625rem;\n\tborder: 0.625rem solid #ededed;\n}\n\n.picker-data .color-time-picker .react-clock__hand__body {\n\tbackground-color: #4d44b5;\n}\n\n.picker-data .color-time-picker .react-time-picker__clock {\n\tbox-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);\n\tborder-radius: 4px;\n\tborder: 0 !important;\n}\n\n.picker-data .color-time-picker.style-1 .react-time-picker__wrapper .react-time-picker__clock-button {\n\tdisplay: none;\n}\n\n.color-gradian-tixia .gpw {\n\tpadding: 0;\n}\n\n.color-gradian-tixia .gpw .trigger .inner {\n\theight: 1.5rem;\n\twidth: 6.25rem;\n}\n\n#image {\n\tmax-width: 100%;\n}\n\n.docs-options .dropdown-menu {\n\tpadding: 1.5rem;\n}\n\n.docs-preview {\n\tmargin-bottom: 3rem;\n}\n.docs-preview .img-preview {\n\tfloat: left;\n\tmargin-right: 0.5rem;\n\tmargin-bottom: 0.5rem;\n\toverflow: hidden;\n\tmax-width: 100% !important;\n}\n.docs-preview .img-preview > img {\n\tmax-width: 100% !important;\n}\n.docs-preview .img-preview.preview-lg {\n\twidth: 16rem;\n\theight: 9rem;\n}\n.docs-preview .img-preview.preview-md {\n\twidth: 8rem;\n\theight: 4.5rem;\n}\n.docs-preview .img-preview.preview-sm {\n\twidth: 4rem;\n\theight: 2.25rem;\n}\n.docs-preview .img-preview.preview-xs {\n\twidth: 2rem;\n\theight: 1.125rem;\n\tmargin-right: 0;\n}\n\n.select2-container {\n\twidth: 100% !important;\n}\n\n.select2-container--default .select2-selection--single {\n\tborder-radius: 0.375rem;\n\tborder: 0.0625rem solid #dddddd;\n\theight: 3rem;\n\tbackground: #fff;\n}\n[data-theme-version='dark'] .select2-container--default .select2-selection--single {\n\tbackground: #202020;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n.select2-container--default .select2-selection--single:hover,\n.select2-container--default .select2-selection--single:focus,\n.select2-container--default .select2-selection--single.active {\n\tbox-shadow: none;\n}\n\n.destroy-selector,\n.single-event-unbind {\n\twidth: 100%;\n\tborder-color: #eeee;\n\theight: 45px;\n\tpadding: 0 13px;\n\tborder-radius: 10px;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__rendered {\n\tline-height: 3rem;\n\tcolor: #a098ae;\n\tpadding-left: 0.9375rem;\n\tmin-height: 2.5rem;\n}\n\n.select2-container--default .select2-selection--multiple {\n\tborder-color: #dddddd;\n\tborder-radius: 0;\n}\n\n.select2-dropdown {\n\tborder-radius: 0;\n}\n\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n\tbackground-color: var(--primary);\n}\n\n.select2-container--default.select2-container--focus .select2-selection--multiple {\n\tborder-color: #dddddd;\n\tbackground: #fff;\n\tpadding: 0.2rem 0;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n\ttop: 0.675rem;\n\tright: 0.9375rem;\n}\n\n.select2-container .select2-selection--multiple {\n\tmin-height: 3rem;\n\tcolor: #a098ae;\n\tborder-radius: 0.375rem;\n\tborder: 0.0625rem solid #dddddd;\n}\n[data-theme-version='dark'] .select2-container .select2-selection--multiple {\n\tbackground: #202020;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .select2-search--dropdown .select2-search__field {\n\tbackground: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n.select2-dropdown {\n\tborder-color: #ebebf9;\n}\n[data-theme-version='dark'] .select2-dropdown {\n\tbackground: #202020;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n.select2-container .select2-selection--multiple .select2-selection__rendered {\n\tpadding: 2px 12px;\n}\n\n.swal2-popup .swal2-content {\n\tcolor: #a098ae;\n}\n\n:root {\n\t--primary: #4d44b5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3d3690;\n\t--primary-dark: #1e1a46;\n\t--rgba-primary-1: rgba(77, 68, 181, 0.1);\n\t--rgba-primary-2: rgba(77, 68, 181, 0.2);\n\t--rgba-primary-3: rgba(77, 68, 181, 0.3);\n\t--rgba-primary-4: rgba(77, 68, 181, 0.4);\n\t--rgba-primary-5: rgba(77, 68, 181, 0.5);\n\t--rgba-primary-6: rgba(77, 68, 181, 0.6);\n\t--rgba-primary-7: rgba(77, 68, 181, 0.7);\n\t--rgba-primary-8: rgba(77, 68, 181, 0.8);\n\t--rgba-primary-9: rgba(77, 68, 181, 0.9);\n\t--rgba-secondary-1: rgba(251, 125, 91, 0.1);\n\t--rgba-secondary-2: rgba(251, 125, 91, 0.2);\n\t--rgba-secondary-3: rgba(251, 125, 91, 0.3);\n\t--rgba-secondary-4: rgba(251, 125, 91, 0.4);\n\t--rgba-secondary-5: rgba(251, 125, 91, 0.5);\n\t--rgba-secondary-6: rgba(251, 125, 91, 0.6);\n\t--rgba-secondary-7: rgba(251, 125, 91, 0.7);\n\t--rgba-secondary-8: rgba(251, 125, 91, 0.8);\n\t--rgba-secondary-9: rgba(251, 125, 91, 0.9);\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--title: #303972;\n}\n\n/*\n0 - 600: Phone\n600 - 900: Tablet portrait\n900 - 1200: Tablet landscape\n1200 - 1800: Normal styles\n1800+ : Big Desktop\n1em = 16px\nThe smaller device rules always should write below the bigger device rules\nFixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component\n*/\n.form-wizard {\n\tborder: 0;\n}\n.form-wizard .nav-wizard {\n\tbox-shadow: none !important;\n\tmargin-bottom: 2rem;\n}\n.form-wizard .nav-wizard #RFS-ConnectorContainer {\n\tdisplay: none;\n}\n.form-wizard .nav-wizard .nav-link {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: transparent !important;\n}\n.form-wizard .nav-wizard .nav-link span {\n\tborder-radius: 3.125rem;\n\twidth: 3rem;\n\theight: 3rem;\n\tborder: 0.125rem solid var(--primary);\n\tdisplay: block;\n\tline-height: 3rem;\n\tcolor: var(--primary);\n\tfont-size: 1.125rem;\n\tmargin: auto;\n\tbackground-color: #fff;\n\tposition: relative;\n\tz-index: 1;\n}\n.form-wizard .nav-wizard .nav-link:after {\n\tcontent: '' !important;\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\theight: 0.1875rem;\n\ttransform: translateY(-50%);\n\tbackground: #bec3e3 !important;\n\tz-index: 0;\n\twidth: 100%;\n}\n.form-wizard .nav-wizard .nav-link.active span {\n\tbackground: var(--primary);\n\tcolor: #fff;\n}\n.form-wizard .nav-wizard .nav-link.active:after {\n\tbackground: var(--primary) !important;\n}\n.form-wizard .nav-wizard .nav-link.completed span {\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n}\n.form-wizard .nav-wizard .nav-link.completed:after {\n\tbackground: var(--primary) !important;\n}\n.form-wizard .nav-wizard > div:last-child .nav-link:after {\n\tdisplay: none;\n}\n.form-wizard .toolbar-bottom .btn {\n\tborder: 0;\n\tpadding: 0.75rem 1.125rem;\n}\n.form-wizard .tab-content .tab-pane {\n\tpadding: 0;\n}\n.form-wizard .emial-setup label.mailclinet {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-direction: column;\n\twidth: 10rem;\n\theight: 10rem;\n\tborder-radius: 50%;\n\tcursor: pointer;\n\tbackground-color: #eef5f9;\n\ttext-align: center;\n\tmargin: auto;\n}\n[data-theme-version='dark'] .form-wizard .emial-setup label.mailclinet {\n\tbackground-color: #202020;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.form-wizard .emial-setup label.mailclinet {\n\t\twidth: 7rem;\n\t\theight: 7rem;\n\t}\n}\n.form-wizard .emial-setup label.mailclinet .mail-icon {\n\tfont-size: 3rem;\n\tdisplay: inline-block;\n\tline-height: 1;\n\tmargin-top: -1rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.form-wizard .emial-setup label.mailclinet .mail-icon {\n\t\tfont-size: 2rem;\n\t}\n}\n.form-wizard .emial-setup label.mailclinet .mail-text {\n\tfont-size: 1rem;\n\ttext-align: center;\n\tmargin-top: 0.5rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.form-wizard .emial-setup label.mailclinet .mail-text {\n\t\tfont-size: 0.75rem;\n\t\tline-height: 1.25rem;\n\t}\n}\n.form-wizard .emial-setup label.mailclinet input[type='radio'] {\n\tdisplay: none;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.form-wizard .nav-wizard {\n\t\tflex-direction: unset !important;\n\t}\n\t.form-wizard .tab-content {\n\t\theight: 100% !important;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.form-wizard .nav-wizard li .nav-link {\n\t\tpadding: 0;\n\t}\n}\n\n.wizard-style-one {\n\tborder: 0;\n\tpadding: 0 100px;\n}\n.wizard-style-one .nav-wizard {\n\tmargin-bottom: 40px;\n\tbox-shadow: none;\n}\n.wizard-style-one label {\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tcolor: #000;\n}\n.wizard-style-one .tab-content {\n\toverflow: visible;\n}\n\n.custom-ekeditor ul {\n\tpadding-left: 1.25rem;\n}\n.custom-ekeditor ul li {\n\tlist-style: unset;\n}\n\n.custom-ekeditor ol li {\n\tlist-style: decimal;\n}\n\n.ql-container {\n\theight: 25rem;\n}\n\n#world-datamap {\n\tpadding-bottom: 46% !important;\n}\n\n.datamaps-hoverover {\n\tbackground: #fff;\n\tpadding: 0.3125rem;\n\tborder-radius: 0.3125rem;\n\tfont-family: 'Roboto' !important;\n\tcolor: var(--primary);\n\tborder: 0.0625rem solid var(--rgba-primary-3);\n}\n\n@media only screen and (max-width: 90rem) {\n\t.world_map_card ul.list-group {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tflex-direction: row;\n\t\tmargin-top: 2.1875rem;\n\t}\n}\n\n.jqvmap-zoomin,\n.jqvmap-zoomout {\n\theight: 1.25rem;\n\twidth: 1.25rem;\n\tline-height: 0.875rem;\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n}\n\n.jqvmap-zoomout {\n\ttop: 2.1875rem;\n}\n\n#world-map,\n#usa {\n\theight: 25rem;\n}\n@media only screen and (max-width: 61.9375rem) {\n\t#world-map,\n\t#usa {\n\t\theight: 21.875rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t#world-map,\n\t#usa {\n\t\theight: 14.375rem;\n\t}\n}\n\n.blockUI.blockMsg.blockPage {\n\tborder: 0 !important;\n}\n\n#loginForm {\n\tcursor: auto;\n}\n\n.blockMsg {\n\tborder: 0rem;\n\twidth: 20% !important;\n}\n.blockMsg h1,\n.blockMsg .h1 {\n\tfont-size: 1rem;\n\tpadding: 0.5rem 0;\n\tmargin-bottom: 0;\n}\n\n.bootstrap-select {\n\tmargin-bottom: 0;\n}\n.bootstrap-select .btn {\n\tbackground-color: transparent !important;\n\tfont-weight: 400;\n}\n[data-theme-version='dark'] .bootstrap-select .btn {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n\tbackground: #383844 !important;\n}\n.bootstrap-select .btn:active,\n.bootstrap-select .btn:focus,\n.bootstrap-select .btn:hover {\n\toutline: none !important;\n\toutline-offset: 0;\n}\n[data-theme-version='dark'] .bootstrap-select .btn:active,\n[data-theme-version='dark'] .bootstrap-select .btn:focus,\n[data-theme-version='dark'] .bootstrap-select .btn:hover {\n\tcolor: #a098ae !important;\n}\n.bootstrap-select .dropdown-menu {\n\tborder-color: #f2f2f2 !important;\n\tbox-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n}\n.bootstrap-select .dropdown-menu .dropdown-item {\n\tfont-size: 0.875rem;\n}\n[data-theme-version='dark'] .bootstrap-select .dropdown-menu {\n\tborder-color: #f2f2f2 !important;\n}\n\n.input-group > .bootstrap-select:not(:first-child) .dropdown-toggle {\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n}\n\n.input-group > .bootstrap-select:not(:last-child) .dropdown-toggle {\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n:root {\n\t--primary: #4d44b5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3d3690;\n\t--primary-dark: #1e1a46;\n\t--rgba-primary-1: rgba(77, 68, 181, 0.1);\n\t--rgba-primary-2: rgba(77, 68, 181, 0.2);\n\t--rgba-primary-3: rgba(77, 68, 181, 0.3);\n\t--rgba-primary-4: rgba(77, 68, 181, 0.4);\n\t--rgba-primary-5: rgba(77, 68, 181, 0.5);\n\t--rgba-primary-6: rgba(77, 68, 181, 0.6);\n\t--rgba-primary-7: rgba(77, 68, 181, 0.7);\n\t--rgba-primary-8: rgba(77, 68, 181, 0.8);\n\t--rgba-primary-9: rgba(77, 68, 181, 0.9);\n\t--rgba-secondary-1: rgba(251, 125, 91, 0.1);\n\t--rgba-secondary-2: rgba(251, 125, 91, 0.2);\n\t--rgba-secondary-3: rgba(251, 125, 91, 0.3);\n\t--rgba-secondary-4: rgba(251, 125, 91, 0.4);\n\t--rgba-secondary-5: rgba(251, 125, 91, 0.5);\n\t--rgba-secondary-6: rgba(251, 125, 91, 0.6);\n\t--rgba-secondary-7: rgba(251, 125, 91, 0.7);\n\t--rgba-secondary-8: rgba(251, 125, 91, 0.8);\n\t--rgba-secondary-9: rgba(251, 125, 91, 0.9);\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--title: #303972;\n}\n\n.clipboard-btn {\n\ttransition: all 0.1s ease-in-out;\n}\n.clipboard-btn:hover {\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n}\n\n:root {\n\t--primary: #4d44b5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3d3690;\n\t--primary-dark: #1e1a46;\n\t--rgba-primary-1: rgba(77, 68, 181, 0.1);\n\t--rgba-primary-2: rgba(77, 68, 181, 0.2);\n\t--rgba-primary-3: rgba(77, 68, 181, 0.3);\n\t--rgba-primary-4: rgba(77, 68, 181, 0.4);\n\t--rgba-primary-5: rgba(77, 68, 181, 0.5);\n\t--rgba-primary-6: rgba(77, 68, 181, 0.6);\n\t--rgba-primary-7: rgba(77, 68, 181, 0.7);\n\t--rgba-primary-8: rgba(77, 68, 181, 0.8);\n\t--rgba-primary-9: rgba(77, 68, 181, 0.9);\n\t--rgba-secondary-1: rgba(251, 125, 91, 0.1);\n\t--rgba-secondary-2: rgba(251, 125, 91, 0.2);\n\t--rgba-secondary-3: rgba(251, 125, 91, 0.3);\n\t--rgba-secondary-4: rgba(251, 125, 91, 0.4);\n\t--rgba-secondary-5: rgba(251, 125, 91, 0.5);\n\t--rgba-secondary-6: rgba(251, 125, 91, 0.6);\n\t--rgba-secondary-7: rgba(251, 125, 91, 0.7);\n\t--rgba-secondary-8: rgba(251, 125, 91, 0.8);\n\t--rgba-secondary-9: rgba(251, 125, 91, 0.9);\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--title: #303972;\n}\n\n.bootstrap-tagsinput {\n\tflex: 1;\n\tpadding: 0;\n\tpadding-left: 0.5rem;\n\tborder-radius: 0;\n\tborder-color: #f2f2f2;\n\tbackground-color: #fff;\n\twidth: 100%;\n}\n.bootstrap-tagsinput .tag {\n\tfont-size: 0.875rem;\n\tbackground-color: var(--primary);\n\tborder-radius: 0;\n\talign-items: center;\n\tborder: 0.0625rem solid #f2f2f2;\n}\n.bootstrap-tagsinput input[type='text'] {\n\tflex: 1;\n\theight: 2.1rem;\n\tborder-radius: 0;\n\tborder-color: #f2f2f2;\n}\n.bootstrap-tagsinput label {\n\tmargin-bottom: 0.5rem;\n}\n\n:root {\n\t--primary: #4d44b5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3d3690;\n\t--primary-dark: #1e1a46;\n\t--rgba-primary-1: rgba(77, 68, 181, 0.1);\n\t--rgba-primary-2: rgba(77, 68, 181, 0.2);\n\t--rgba-primary-3: rgba(77, 68, 181, 0.3);\n\t--rgba-primary-4: rgba(77, 68, 181, 0.4);\n\t--rgba-primary-5: rgba(77, 68, 181, 0.5);\n\t--rgba-primary-6: rgba(77, 68, 181, 0.6);\n\t--rgba-primary-7: rgba(77, 68, 181, 0.7);\n\t--rgba-primary-8: rgba(77, 68, 181, 0.8);\n\t--rgba-primary-9: rgba(77, 68, 181, 0.9);\n\t--rgba-secondary-1: rgba(251, 125, 91, 0.1);\n\t--rgba-secondary-2: rgba(251, 125, 91, 0.2);\n\t--rgba-secondary-3: rgba(251, 125, 91, 0.3);\n\t--rgba-secondary-4: rgba(251, 125, 91, 0.4);\n\t--rgba-secondary-5: rgba(251, 125, 91, 0.5);\n\t--rgba-secondary-6: rgba(251, 125, 91, 0.6);\n\t--rgba-secondary-7: rgba(251, 125, 91, 0.7);\n\t--rgba-secondary-8: rgba(251, 125, 91, 0.8);\n\t--rgba-secondary-9: rgba(251, 125, 91, 0.9);\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--title: #303972;\n}\n\n.twitter-typeahead {\n\twidth: 100%;\n}\n.twitter-typeahead .tt-dataset.tt-dataset-states {\n\tborder: 1px solid #f2f2f2;\n}\n.twitter-typeahead .tt-menu {\n\twidth: 100%;\n\tbackground-color: #fff;\n}\n.twitter-typeahead .tt-menu .tt-suggestion {\n\tpadding: 0.625rem;\n\tcursor: pointer;\n}\n.twitter-typeahead .tt-menu .tt-suggestion:hover {\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n}\n\n.weather-one i {\n\tfont-size: 8rem;\n\tposition: relative;\n\ttop: 0.5rem;\n}\n\n.weather-one h2,\n.weather-one .h2 {\n\tdisplay: inline-block;\n\tfloat: right;\n\tfont-size: 4.8rem;\n}\n\n.weather-one .city {\n\tposition: relative;\n\ttext-align: right;\n\ttop: -2.5rem;\n}\n\n.weather-one .currently {\n\tfont-size: 1.6rem;\n\tfont-weight: 400;\n\tposition: relative;\n\ttop: 2.5rem;\n}\n\n.weather-one .celcious {\n\ttext-align: right;\n\tfont-size: 2rem;\n}\n\n:root {\n\t--primary: #4d44b5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3d3690;\n\t--primary-dark: #1e1a46;\n\t--rgba-primary-1: rgba(77, 68, 181, 0.1);\n\t--rgba-primary-2: rgba(77, 68, 181, 0.2);\n\t--rgba-primary-3: rgba(77, 68, 181, 0.3);\n\t--rgba-primary-4: rgba(77, 68, 181, 0.4);\n\t--rgba-primary-5: rgba(77, 68, 181, 0.5);\n\t--rgba-primary-6: rgba(77, 68, 181, 0.6);\n\t--rgba-primary-7: rgba(77, 68, 181, 0.7);\n\t--rgba-primary-8: rgba(77, 68, 181, 0.8);\n\t--rgba-primary-9: rgba(77, 68, 181, 0.9);\n\t--rgba-secondary-1: rgba(251, 125, 91, 0.1);\n\t--rgba-secondary-2: rgba(251, 125, 91, 0.2);\n\t--rgba-secondary-3: rgba(251, 125, 91, 0.3);\n\t--rgba-secondary-4: rgba(251, 125, 91, 0.4);\n\t--rgba-secondary-5: rgba(251, 125, 91, 0.5);\n\t--rgba-secondary-6: rgba(251, 125, 91, 0.6);\n\t--rgba-secondary-7: rgba(251, 125, 91, 0.7);\n\t--rgba-secondary-8: rgba(251, 125, 91, 0.8);\n\t--rgba-secondary-9: rgba(251, 125, 91, 0.9);\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--title: #303972;\n}\n\n.noUi-target {\n\tborder-color: transparent;\n\tborder-radius: 0;\n}\n\n.noUi-connect {\n\tbackground-color: var(--primary);\n}\n.noUi-connects {\n\tbackground-color: #d2d6de;\n}\n.noUi-connect.c-1-color {\n\tbackground-color: #1eba62;\n}\n.noUi-connect.c-2-color {\n\tbackground-color: #00ada3;\n}\n.noUi-connect.c-3-color {\n\tbackground-color: var(--primary);\n}\n.noUi-connect.c-4-color {\n\tbackground-color: #fcc43e;\n}\n\n.noUi-vertical {\n\twidth: 0.375rem;\n}\n\n.noUi-horizontal {\n\theight: 0.125rem;\n\tborder: 0;\n\tmargin-bottom: 0.625rem;\n}\n\n.noUi-horizontal .noUi-handle,\n.noUi-vertical .noUi-handle {\n\theight: 0.9375rem;\n\twidth: 0.9375rem;\n\tborder-radius: 3.125rem;\n\tbox-shadow: none;\n\tborder: none;\n\tbackground-color: var(--primary);\n}\n.noUi-horizontal .noUi-handle::after,\n.noUi-horizontal .noUi-handle::before,\n.noUi-vertical .noUi-handle::after,\n.noUi-vertical .noUi-handle::before {\n\tdisplay: none;\n}\n\n.noUi-vertical .noUi-handle {\n\tleft: -0.35rem;\n\ttop: -0.375rem;\n}\n\n.noUi-horizontal .noUi-handle {\n\ttop: -0.4375rem;\n\tcursor: pointer;\n}\n\nhtml:not([dir='rtl']) .noUi-horizontal .noUi-handle {\n\tright: -0.375rem;\n}\n\n#slider-toggle {\n\theight: 3.125rem;\n}\n\n#slider-toggle.off .noUi-handle {\n\tborder-color: var(--primary);\n}\n\n.colorpicker-slider .sliders.noUi-target#red,\n.colorpicker-slider .sliders.noUi-target#green,\n.colorpicker-slider .sliders.noUi-target#blue {\n\tmargin: 0.625rem;\n\tdisplay: inline-block;\n\theight: 12.5rem;\n}\n\n.colorpicker-slider .sliders.noUi-target#red .noUi-connect {\n\tbackground: #c0392b;\n}\n\n.colorpicker-slider .sliders.noUi-target#green .noUi-connect {\n\tbackground: #27ae60;\n}\n\n.colorpicker-slider .sliders.noUi-target#blue .noUi-connect {\n\tbackground: #2980b9;\n}\n\n.colorpicker-slider #result {\n\tmargin: 3.75rem 1.625rem;\n\theight: 6.25rem;\n\twidth: 6.25rem;\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tcolor: #7f7f7f;\n\tbackground: #7f7f7f;\n\tborder: 0.0625rem solid #fff;\n\tbox-shadow: 0 0 0.625rem;\n}\n\n.slider-vertical {\n\theight: 18rem;\n}\n\n.nestable-cart {\n\toverflow: hidden;\n}\n\n.dd-handle {\n\tcolor: #fff;\n\tbackground: var(--primary);\n\tborder-radius: 0.3125rem;\n\tpadding: 0.5rem 1rem;\n\theight: auto;\n\tborder: 1px solid #f2f2f2;\n}\n\n.dd-handle:hover {\n\tcolor: #fff;\n\tbackground: var(--primary);\n}\n\n.dd3-content:hover {\n\tcolor: #fff;\n\tbackground: var(--primary);\n}\n\n.dd3-content {\n\tcolor: #fff;\n}\n\n.dd-item > button {\n\tline-height: 28px;\n\tcolor: #fff;\n}\n\n.pignose-calendar {\n\tbox-shadow: none;\n\twidth: 100%;\n\tmax-width: none;\n\tborder-color: var(--primary);\n}\n.pignose-calendar .pignose-calendar-top-date {\n\tbackground-color: var(--primary);\n}\n.pignose-calendar .pignose-calendar-top-date .pignose-calendar-top-month {\n\tcolor: #fff;\n}\n\n.pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n\tbackground-color: var(--primary);\n\tbox-shadow: none;\n}\n\n.pignose-calendar .pignose-calendar-top {\n\tbox-shadow: none;\n\tborder-bottom: 0;\n}\n\n.pignose-calendar.pignose-calendar-blue {\n\tbackground-color: rgba(0, 0, 0, 0.15);\n}\n\n.pignose-calendar .pignose-calendar-unit {\n\theight: 4.8em;\n}\n\n.cd-h-timeline {\n\topacity: 0;\n\ttransition: opacity 0.2s;\n}\n\n.cd-h-timeline--loaded {\n\topacity: 1;\n}\n\n.cd-h-timeline__container {\n\tposition: relative;\n\theight: 6.25rem;\n\tmax-width: 50rem;\n}\n\n.cd-h-timeline__dates {\n\tposition: relative;\n\theight: 100%;\n\tmargin: 0 2.5rem;\n\toverflow: hidden;\n}\n.cd-h-timeline__dates::after,\n.cd-h-timeline__dates::before {\n\tcontent: '';\n\tposition: absolute;\n\tz-index: 2;\n\ttop: 0;\n\theight: 100%;\n\twidth: 1.25rem;\n}\n.cd-h-timeline__dates::before {\n\tleft: 0;\n\tbackground: var(--primary);\n}\n.cd-h-timeline__dates::after {\n\tright: 0;\n\tbackground: var(--primary);\n}\n\n.cd-h-timeline__line {\n\tposition: absolute;\n\tz-index: 1;\n\tleft: 0;\n\ttop: 3.0625rem;\n\theight: 0.125rem;\n\tbackground-color: var(--primary);\n\ttransition: transform 0.4s;\n}\n\n.cd-h-timeline__filling-line {\n\tposition: absolute;\n\tz-index: 1;\n\tleft: 0;\n\ttop: 0;\n\theight: 100%;\n\twidth: 100%;\n\tbackground-color: #1eba62;\n\ttransform: scaleX(0);\n\ttransform-origin: left center;\n\ttransition: transform 0.3s;\n}\n\n.cd-h-timeline__date {\n\tposition: absolute;\n\tbottom: 0;\n\tz-index: 2;\n\ttext-align: center;\n\tfont-size: 0.8em;\n\tpadding-bottom: var(--space-sm);\n\tcolor: var(--cd-color-1);\n\tuser-select: none;\n\ttext-decoration: none;\n}\n.cd-h-timeline__date::after {\n\tcontent: '';\n\tposition: absolute;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tbottom: -0.3125rem;\n\theight: 0.75rem;\n\twidth: 0.75rem;\n\tborder-radius: 50%;\n\tborder-width: 0.125rem;\n\tborder-style: solid;\n\tborder-color: var(--rgba-primary-6);\n\tbackground-color: var(--primary);\n\ttransition: background-color 0.3s, border-color 0.3s;\n}\n.cd-h-timeline__date:hover::after {\n\tbackground-color: #1eba62;\n\tborder-color: #1eba62;\n}\n\n.cd-h-timeline__date--selected {\n\tpointer-events: none;\n}\n.cd-h-timeline__date--selected::after {\n\tbackground-color: #1eba62;\n\tborder-color: #1eba62;\n}\n\n.cd-h-timeline__date--older-event::after {\n\tborder-color: #1eba62;\n}\n\n.cd-h-timeline__navigation {\n\tposition: absolute;\n\tz-index: 1;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\theight: 2.125rem;\n\twidth: 2.125rem;\n\tborder-radius: 50%;\n\tborder-width: 0.125rem;\n\tborder-style: solid;\n\tborder-color: var(--rgba-primary-6);\n\ttransition: border-color 0.3s;\n}\n.cd-h-timeline__navigation::after {\n\tcontent: '';\n\tposition: absolute;\n\theight: 1rem;\n\twidth: 1rem;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translateX(-50%) translateY(-50%);\n}\n.cd-h-timeline__navigation:hover {\n\tborder-color: #1eba62;\n}\n\n.cd-h-timeline__navigation--prev {\n\tleft: 0;\n\ttransform: translateY(-50%) rotate(180deg);\n}\n\n.cd-h-timeline__navigation--next {\n\tright: 0;\n}\n\n.cd-h-timeline__navigation--inactive {\n\tcursor: not-allowed;\n}\n.cd-h-timeline__navigation--inactive::after {\n\tbackground-position: 0 -1rem;\n}\n.cd-h-timeline__navigation--inactive:hover {\n\tborder-color: var(--rgba-primary-6);\n}\n\n.cd-h-timeline__events {\n\tposition: relative;\n\twidth: 100%;\n\toverflow: hidden;\n\ttransition: height 0.4s;\n}\n\n.cd-h-timeline__event {\n\tposition: absolute;\n\tz-index: 1;\n\twidth: 100%;\n\tleft: 0;\n\ttop: 0;\n\ttransform: translateX(-100%);\n\tpadding: 0.0625rem 5%;\n\topacity: 0;\n\tanimation-duration: 0.4s;\n\tanimation-timing-function: ease-in-out;\n}\n\n.cd-h-timeline__event--selected {\n\tposition: relative;\n\tz-index: 2;\n\topacity: 1;\n\ttransform: translateX(0);\n}\n\n.cd-h-timeline__event--enter-right,\n.cd-h-timeline__event--leave-right {\n\tanimation-name: cd-enter-right;\n}\n\n.cd-h-timeline__event--enter-left,\n.cd-h-timeline__event--leave-left {\n\tanimation-name: cd-enter-left;\n}\n\n.cd-h-timeline__event--leave-right,\n.cd-h-timeline__event--leave-left {\n\tanimation-direction: reverse;\n}\n\n.cd-h-timeline__event-content {\n\tmax-width: 50rem;\n}\n\n.cd-h-timeline__event-title {\n\tcolor: var(--cd-color-1);\n\tfont-family: var(--font-secondary);\n\tfont-weight: 700;\n\tfont-size: var(--text-xxxl);\n}\n\n.cd-h-timeline__event-date {\n\tdisplay: block;\n\tfont-style: italic;\n\tmargin: var(--space-xs) auto;\n}\n.cd-h-timeline__event-date::before {\n\tcontent: '- ';\n}\n\n@keyframes cd-enter-right {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: translateX(100%);\n\t}\n\t100% {\n\t\topacity: 1;\n\t\ttransform: translateX(0%);\n\t}\n}\n\n@keyframes cd-enter-left {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: translateX(-100%);\n\t}\n\t100% {\n\t\topacity: 1;\n\t\ttransform: translateX(0%);\n\t}\n}\n\n.toast-success {\n\tbackground-color: var(--primary);\n}\n\n.toast-info {\n\tbackground-color: #00ada3;\n}\n\n.toast-warning {\n\tbackground-color: #fcc43e;\n}\n\n.toast-error {\n\tbackground-color: #fd5353;\n}\n\n#toast-container > div {\n\tbox-shadow: none;\n\tborder-radius: 0.375rem;\n\twidth: auto;\n\tmax-width: 15.625rem;\n\topacity: 1;\n}\n[direction='rtl'] #toast-container > div {\n\tpadding: 0.9375rem 3.125rem 0.9375rem 0.9375rem;\n\tbackground-position: calc(100% - 0.9375rem);\n\ttext-align: right;\n}\n#toast-container > div:hover {\n\tbox-shadow: none;\n}\n\n#toast-container .toast-title {\n\tmargin-bottom: 0.3125rem;\n\tfont-weight: 600;\n}\n\n#toast-container .toast-message {\n\tfont-size: 0.75rem;\n}\n\n#toast-container .toast-close-button {\n\topacity: 1;\n\tfont-size: 1.25rem;\n\tfont-weight: normal;\n\ttext-shadow: none;\n}\n\n#toast-container.toast-bottom-full-width > div,\n#toast-container.toast-top-full-width > div {\n\twidth: 100%;\n\tmin-width: 300px;\n\tdisplay: block;\n\tpadding: 15px 15px 18px 60px;\n\tbox-shadow: 0 0 50px rgba(0, 0, 0, 0.15);\n}\n\n.toast-progress {\n\tbackground-color: #fff;\n}\n\n[direction='rtl'] .toast-top-right.demo_rtl_class {\n\tleft: 0.75rem;\n\tright: auto;\n}\n\n/* Light Gallery */\n.lg-actions .lg-next,\n.lg-actions .lg-prev,\n.lg-sub-html,\n.lg-toolbar {\n\tbackground-color: rgba(30, 30, 30, 0.6);\n}\n\n.lg-outer .lg-toogle-thumb,\n.lg-outer .lg-thumb-outer,\n.lg-outer .lg-img-wrap,\n.lg-outer .lg-item {\n\tbackground-color: transparent;\n}\n\n.lg-thumb-outer.lg-grab,\n.lg-toogle-thumb.lg-icon {\n\tbackground-color: rgba(30, 30, 30, 0.6);\n}\n\n.lg-backdrop {\n\tbackground-color: rgba(30, 30, 30, 0.9);\n}\n\n.lg-outer .lg-toogle-thumb,\n.lg-actions .lg-next,\n.lg-actions .lg-prev,\n.lg-toolbar .lg-icon,\n#lg-counter {\n\tcolor: #fff;\n}\n\n.lg-outer .lg-thumb-item.active,\n.lg-outer .lg-thumb-item:hover {\n\tborder-color: var(--primary);\n}\n\n.lightimg {\n\tcursor: pointer;\n}\n\n.jqvmap-zoomin,\n.jqvmap-zoomout {\n\tposition: absolute;\n\tleft: 0.625rem;\n\t-webkit-border-radius: 0.1875rem;\n\t-moz-border-radius: 0.1875rem;\n\tborder-radius: 0.1875rem;\n\tbackground: #000000;\n\tpadding: 0.1875rem;\n\tcolor: white;\n\twidth: 1.0625rem;\n\theight: 1.0625rem;\n\tcursor: pointer;\n\tline-height: 0.625rem;\n\ttext-align: center;\n}\n\n.jqvmap-zoomin {\n\ttop: 0.625rem;\n}\n\n.jqvmap-zoomout {\n\ttop: 1.875rem;\n}\n\n.ps__rail-x:hover,\n.ps__rail-y:hover,\n.ps__rail-x:focus,\n.ps__rail-y:focus,\n.ps__rail-x.ps--clicking,\n.ps__rail-y.ps--clicking {\n\tbackground-color: transparent !important;\n\topacity: 0.9;\n}\n\n.ps__rail-y:hover > .ps__thumb-y,\n.ps__rail-y:focus > .ps__thumb-y,\n.ps__rail-y.ps--clicking .ps__thumb-y {\n\tbackground-color: #dae2f3;\n\twidth: 0.25rem;\n}\n\n.ps__thumb-y {\n\tbackground-color: #dae2f3;\n\twidth: 0.25rem;\n}\n\n.total-average {\n\tposition: relative;\n\theight: 18.75rem;\n}\n\n.widget-chat {\n\tposition: relative;\n\theight: 15.625rem;\n}\n\n.widget-todo {\n\tposition: relative;\n\theight: 13.125rem;\n}\n\n.widget-team {\n\tposition: relative;\n\theight: 17.8125rem;\n}\n\n.widget-timeline {\n\tposition: relative;\n}\n\n.widget-comments {\n\tposition: relative;\n\theight: 25rem;\n}\n\n.sidebar-right-inner {\n\tposition: relative;\n\theight: 100%;\n}\n\n.widget-team .ps .ps__rail-x:hover,\n.widget-team .ps .ps__rail-y:hover,\n.widget-team .ps .ps__rail-x:focus,\n.widget-team .ps .ps__rail-y:focus,\n.widget-team .ps .ps__rail-x.ps--clicking,\n.widget-team .ps .ps__rail-y.ps--clicking {\n\tbackground-color: transparent !important;\n\topacity: 0.9;\n}\n\n.ck.ck-editor .ck.ck-button {\n\tpadding: 6px 8px;\n\tbackground-color: var(--rgba-primary-1);\n\tcolor: var(--primary);\n\tfont-weight: 900;\n\tcursor: pointer;\n}\n\n.ck.ck-editor .ck.ck-toolbar {\n\tbackground-color: var(--bs-card-bg);\n\tborder-color: #dddddd;\n\tborder-radius: 0.375rem;\n\tpadding: 5px 10px;\n}\n\n.ck.ck-editor .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar {\n\tborder-radius: 0.375rem !important;\n}\n\n.ck.ck-editor .ck.ck-toolbar__separator {\n\tdisplay: none !important;\n}\n\n.ck.ck-editor .ck-content {\n\tbackground-color: #f7f7f7;\n\tborder-width: 1px 0 0;\n\tborder-color: #e7e5ef;\n}\n\n.ck-editor__editable {\n\tbackground-color: var(--bs-card-bg) !important;\n}\n\n.ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred {\n\tborder-color: #dddddd;\n\tpadding: 0.865rem var(--ck-spacing-standard);\n}\n\n.ck.ck-toolbar .ck-toolbar__items .ck.ck-toolbar__separator {\n\tbackground: #dddddd;\n}\n\n.ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred {\n\tmin-height: 9.375rem;\n\tborder-width: 1px;\n}\n\nbutton.ck.ck-button.ck-off:hover {\n\tbackground-color: #dddddd;\n}\n\n.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused {\n\tmin-height: 9.375rem;\n}\n\n.editor-title .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred,\n.editor-title .ck-focused {\n\twidth: 57.313rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.editor-title .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred,\n\t.editor-title .ck-focused {\n\t\twidth: 100%;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.editor-title .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred,\n\t.editor-title .ck-focused {\n\t\twidth: 500px;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.editor-title .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred,\n\t.editor-title .ck-focused {\n\t\twidth: 100%;\n\t}\n}\n\n.fc-h-event,\n.fc-v-event {\n\tbackground: var(--primary);\n\tborder-radius: 0.42rem;\n}\n\n.fc-h-event .fc-event-title {\n\tcolor: #fff;\n}\n\n.fc-theme-standard td,\n.fc-theme-standard th {\n\tborder-color: #ebedf3;\n}\n\n.fc-unthemed .fc-h-event,\n.fc-unthemed .fc-event-dot {\n\tpadding: 0;\n\tborder-radius: 0.42rem;\n}\n\n.fc-theme-standard th {\n\tpadding: 0.75rem 0.5rem;\n\tfont-size: 1rem;\n\tfont-weight: 500;\n\tcolor: #b5b5c3;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.fc-theme-standard th {\n\t\tfont-size: 14px;\n\t\tfont-weight: 400;\n\t\tpadding: 3px 0px;\n\t}\n}\n\n.fc-theme-standard .fc-scrollgrid.fc-scrollgrid-liquid,\n.fc-scrollgrid,\ntable {\n\tborder-color: #ebedf3;\n}\n\n.fc-daygrid-dot-event {\n\tbackground: #fff;\n\tborder: 1px solid #ebedf3;\n\t-webkit-box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.1);\n\tbox-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.1);\n}\n.fc-daygrid-dot-event .fc-daygrid-event-dot {\n\tborder-color: var(--primary);\n}\n\n.fc-daygrid-dot-event .fc-event-title {\n\tfont-weight: 500;\n}\n\n.fc-event.bg-primary,\n.fc-event.bg-success,\n.fc-event.bg-warning,\n.fc-event.bg-secondary,\n.fc-event.bg-dark,\n.fc-event.bg-info {\n\tcolor: #fff !important;\n\tborder-radius: 8px;\n}\n.fc-event.bg-primary .fc-daygrid-event-dot,\n.fc-event.bg-success .fc-daygrid-event-dot,\n.fc-event.bg-warning .fc-daygrid-event-dot,\n.fc-event.bg-secondary .fc-daygrid-event-dot,\n.fc-event.bg-dark .fc-daygrid-event-dot,\n.fc-event.bg-info .fc-daygrid-event-dot {\n\tborder-color: #fff;\n}\n\n.fc .fc-scroller-liquid-absolute,\n.fc-scroller {\n\tposition: relative;\n\toverflow: visible !important;\n}\n\n.fc .fc-button-group > .fc-button {\n\tcolor: black;\n\tbackground: 0 0;\n\tborder: 1px solid #ebedf3;\n\ttext-shadow: none !important;\n\t-webkit-box-shadow: none !important;\n\tbox-shadow: none !important;\n}\n.fc .fc-button-group > .fc-button:focus,\n.fc .fc-button-group > .fc-button:active,\n.fc .fc-button-group > .fc-button:hover,\n.fc .fc-button-group > .fc-button.fc-button-active {\n\tbackground: var(--primary);\n\tcolor: #fff;\n\tborder-color: var(--primary);\n}\n\n.fc-button.fc-today-button {\n\tborder: 0;\n\topacity: 1;\n\tmargin-bottom: 0.625rem;\n}\n\n.fc .fc-button-primary {\n\tbackground: var(--primary);\n\tcolor: #fff;\n}\n\n.fc-unthemed .fc-toolbar .fc-button.fc-button-active,\n.fc-unthemed .fc-toolbar .fc-button:active,\n.fc-unthemed .fc-toolbar .fc-button:focus {\n\tbackground: var(--primary);\n\tcolor: #fff;\n\tborder: 1px solid var(--primary);\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\ttext-shadow: none;\n}\n\n.fc .fc-toolbar-title {\n\tfont-size: 20px;\n\tmargin: 0;\n}\n\n.external-event {\n\tpadding: 8px 10px;\n\tdisplay: flex;\n\talign-items: center;\n\tborder-radius: 5px;\n}\n.external-event:hover:before {\n\tbackground: #fff !important;\n}\n\n.fc-event {\n\toverflow: hidden;\n}\n\n.fc .fc-view-harness {\n\theight: 850px !important;\n\toverflow-y: auto;\n}\n\n@media only screen and (max-width: 35.9375rem) {\n\t.fc .fc-toolbar.fc-header-toolbar {\n\t\tdisplay: block;\n\t}\n\t.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tborder-bottom: 0.625rem;\n\t}\n\t.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-chunk:first-child {\n\t\tjustify-content: space-between;\n\t}\n\t.fc .fc-toolbar.fc-header-toolbar .fc-toolbar-title {\n\t\tmargin-bottom: 8px;\n\t}\n}\n\n#external-events .external-event {\n\ttext-align: left;\n\tfont-size: 16px;\n}\n\n@media only screen and (max-width: 35.9375rem) {\n\t.fc.app-fullcalendar .fc-timegrid-slot-label {\n\t\twidth: 40px !important;\n\t\tfont-size: 10px;\n\t}\n\t.fc.app-fullcalendar .fc-event,\n\t.fc.app-fullcalendar .external-event {\n\t\tfont-size: 10px;\n\t\tmargin: 0;\n\t\tpadding: 2px 0;\n\t\ttext-align: center;\n\t\tline-height: 1.3;\n\t}\n\t.fc.app-fullcalendar .fc-col-header-cell-cushion {\n\t\tdisplay: inline-block;\n\t\tpadding: 2px 4px;\n\t\tfont-size: 10px;\n\t}\n}\n\n.accordion-button:not(.collapsed) {\n\tcolor: inherit;\n\tbackground: inherit;\n}\n\n.accordion-button.collapsed {\n\tborder-bottom-width: 1px;\n}\n\n.accordion-primary .accordion-button {\n\tbackground: var(--primary);\n\tborder-color: var(--primary);\n\tcolor: #fff;\n\tbox-shadow: 0 0.9375rem 1.25rem 0 var(--rgba-primary-1);\n}\n.accordion-primary .accordion-button.collapsed {\n\tbackground: var(--rgba-primary-1);\n\tborder-color: var(--rgba-primary-1);\n\tcolor: var(--primary);\n\tbox-shadow: none;\n}\n[data-theme-version='dark'] .accordion-primary .accordion-button.collapsed {\n\tbackground: var(--rgba-primary-1);\n\tborder-color: var(--rgba-primary-1);\n\tcolor: #a098ae;\n}\n\n.accordion-primary-solid .accordion-button {\n\tbackground: var(--primary);\n\tborder-color: var(--primary);\n\tcolor: #fff;\n\tbox-shadow: 0 -0.625rem 1.25rem 0 var(--rgba-primary-1);\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n.accordion-primary-solid .accordion-button.collapsed {\n\tbackground: var(--rgba-primary-1);\n\tborder-color: var(--rgba-primary-1);\n\tcolor: var(--primary);\n\tbox-shadow: none;\n\tborder-bottom-left-radius: 0.375rem;\n\tborder-bottom-right-radius: 0.375rem;\n}\n[data-theme-version='dark'] .accordion-primary-solid .accordion-button.collapsed {\n\tbackground: var(--rgba-primary-1);\n\tborder-color: var(--rgba-primary-1);\n\tcolor: #a098ae;\n}\n\n.accordion-primary-solid .accordion__body {\n\tborder: 0.125rem solid var(--primary);\n\tborder-top: none;\n\tbox-shadow: 0 0.9375rem 1.25rem 0 var(--rgba-primary-1);\n\tborder-bottom-left-radius: 0.375rem;\n\tborder-bottom-right-radius: 0.375rem;\n}\n\n.accordion-danger .accordion-button {\n\tbackground: #fd5353;\n\tborder-color: #fd5353;\n\tcolor: #fff;\n\tbox-shadow: 0 0.9375rem 1.25rem 0 rgba(253, 83, 83, 0.15);\n}\n.accordion-danger .accordion-button.collapsed {\n\tbackground: #ffeaea;\n\tborder-color: #ffeaea;\n\tcolor: #211c37;\n\tbox-shadow: none;\n}\n\n.accordion-danger-solid .accordion-button {\n\tbackground: #fd5353;\n\tborder-color: #fd5353;\n\tcolor: #fff;\n\tbox-shadow: 0 -0.625rem 1.25rem 0 rgba(253, 83, 83, 0.15);\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n.accordion-danger-solid .accordion-button.collapsed {\n\tbackground: #ffeaea;\n\tborder-color: #ffeaea;\n\tcolor: #211c37;\n\tbox-shadow: none;\n\tborder-bottom-left-radius: 0.375rem;\n\tborder-bottom-right-radius: 0.375rem;\n}\n[data-theme-version='dark'] .accordion-danger-solid .accordion-button.collapsed {\n\tbackground: rgba(253, 83, 83, 0.15);\n\tborder-color: rgba(253, 83, 83, 0.15);\n\tcolor: #a098ae;\n}\n\n.accordion-danger-solid .accordion__body {\n\tborder: 0.125rem solid #fd5353;\n\tborder-top: none;\n\tbox-shadow: 0 0.9375rem 1.25rem 0 rgba(253, 83, 83, 0.15);\n\tborder-bottom-left-radius: 0.375rem;\n\tborder-bottom-right-radius: 0.375rem;\n}\n\n.accordion-item {\n\tmargin-bottom: 1.25rem;\n\tborder: 0;\n\tbackground-color: transparent;\n}\n.accordion-item:first-of-type .accordion-button {\n\tborder-top-left-radius: 0.375rem;\n\tborder-top-right-radius: 0.375rem;\n}\n.accordion-item:last-of-type .accordion-button.collapsed {\n\tborder-bottom-left-radius: 0.375rem;\n\tborder-bottom-right-radius: 0.375rem;\n}\n\n.accordion-button {\n\tpadding: 1rem 1.75rem;\n\tborder: 0.0625rem solid #f2f2f2;\n\tcursor: pointer;\n\tposition: relative;\n\tcolor: #333;\n\tfont-weight: 400;\n\tborder-radius: 0.375rem;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n}\n[data-theme-version='dark'] .accordion-button {\n\tcolor: #fff !important;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n.accordion-button-indicator.indicator_bordered {\n\tdisplay: inline-block;\n\twidth: 1.5625rem;\n\ttext-align: center;\n\theight: 1.5625rem;\n\tborder: 0.0625rem solid #f2f2f2;\n\tborder-radius: 50%;\n\tline-height: 1.5625rem;\n}\n.accordion-button:not(.collapsed)::after {\n\tcontent: '\\e622';\n\tbackground-image: none;\n\ttransform: rotate(0) translateY(-50%);\n}\n.accordion-button:not(.collapsed).style_two::after {\n\tcontent: '\\e648';\n}\n.accordion-button::after {\n\tcontent: '\\e61a';\n\tfont-family: 'themify';\n\tposition: absolute;\n\tright: 1.5625rem;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tbackground-image: none !important;\n\twidth: auto;\n\theight: auto;\n}\n[direction='rtl'] .accordion-button::after {\n\tright: auto;\n\tleft: 1.5625rem;\n}\n.accordion-button.collapsed.style_two::after {\n\tcontent: '\\e64b';\n}\n\n.accordion-body {\n\tpadding: 0.875rem 1.25rem;\n}\n\n.accordion-collapse {\n\tborder: 0;\n}\n\n.accordion-bordered .accordion__body {\n\tborder: 0.0625rem solid #f2f2f2;\n\tborder-top: none;\n\tborder-bottom-left-radius: 0.375rem;\n\tborder-bottom-right-radius: 0.375rem;\n}\n[data-theme-version='dark'] .accordion-bordered .accordion__body {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n.accordion-bordered .accordion-button.collapsed {\n\tborder-radius: 0.375rem;\n}\n\n.accordion-bordered .accordion-button {\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n.accordion-no-gutter .accordion-item {\n\tmargin-bottom: 0;\n}\n.accordion-no-gutter .accordion-item .accordion-button.collapsed {\n\tborder-bottom: none;\n}\n.accordion-no-gutter .accordion-item:last-child .accordion-button {\n\tborder-bottom: 0.0625rem solid #f2f2f2;\n}\n[data-theme-version='dark'] .accordion-no-gutter .accordion-item:last-child .accordion-button {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n.accordion-no-gutter.accordion__bordered .accordion-item:not(:last-child) .accordion__body {\n\tborder-bottom: none;\n}\n\n.accordion-left-indicator .accordion-button-text {\n\tpadding-left: 2.5rem;\n}\n\n.accordion-left-indicator .accordion-button-indicator {\n\tright: auto;\n\tleft: 1.5625rem;\n}\n\n.accordion-with-icon .accordion-button-text {\n\tpadding-left: 2.5rem;\n}\n[direction='rtl'] .accordion-with-icon .accordion-button-text {\n\tpadding-left: 0;\n\tpadding-right: 2.5rem;\n}\n\n.accordion-with-icon .accordion-button-icon {\n\tposition: absolute;\n\tright: auto;\n\tleft: 1.5625rem;\n\tfont-family: 'themify';\n}\n[direction='rtl'] .accordion-with-icon .accordion-button-icon {\n\tleft: auto;\n\tright: 1.5625rem;\n}\n.accordion-with-icon .accordion-button-icon::before {\n\tcontent: '\\e645';\n}\n\n.accordion-with-icon .accordion-button .accordion-header-icon {\n\tposition: absolute;\n\tright: auto;\n\tleft: 1.5625rem;\n\tfont-family: 'themify';\n}\n.accordion-with-icon .accordion-button .accordion-header-icon::before {\n\tcontent: '\\e645';\n}\n\n.accordion-with-icon .accordion-button .accordion-header-text {\n\tpadding-left: 2.5rem;\n}\n\n.accordion-header-bg .accordion-header .accordion-button {\n\tbackground-color: #ebebf9;\n}\n[data-theme-version='dark'] .accordion-header-bg .accordion-header .accordion-button {\n\tbackground-color: #202020;\n}\n\n.accordion-header-bg .accordion-header-primary .accordion-button {\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n\tborder-color: var(--primary);\n}\n[data-theme-version='dark'] .accordion-header-bg .accordion-header-primary .accordion-button {\n\tbackground-color: var(--primary);\n}\n\n.accordion-header-bg .accordion-header-info .accordion-button {\n\tbackground-color: #00ada3;\n\tcolor: #fff;\n\tborder-color: #00ada3;\n}\n[data-theme-version='dark'] .accordion-header-bg .accordion-header-info .accordion-button {\n\tbackground-color: #00ada3;\n}\n\n.accordion-header-bg .accordion-header-success .accordion-button {\n\tbackground-color: #1eba62;\n\tcolor: #fff;\n\tborder-color: #1eba62;\n}\n[data-theme-version='dark'] .accordion-header-bg .accordion-header-success .accordion-button {\n\tbackground-color: #1eba62;\n}\n\n.accordion-header-bg.accordion-no-gutter .accordion-button {\n\tborder-color: transparent;\n\tborder-radius: 0;\n}\n\n.accordion-header-bg.accordion-no-gutter .accordion-item:first-child .accordion-button {\n\tborder-top-left-radius: 0.375rem;\n\tborder-top-right-radius: 0.375rem;\n}\n\n.accordion-header-bg.accordion-no-gutter .accordion-item:last-child .accordion-button {\n\tborder-bottom-left-radius: 0.375rem;\n\tborder-bottom-right-radius: 0.375rem;\n}\n\n.accordion.accordion-no-gutter .accordion-button {\n\tborder-radius: 0;\n}\n\n.accordion.accordion-no-gutter .accordion-button.collapsed {\n\tborder-radius: 0;\n}\n\n.accordion.accordion-no-gutter .accordion__body {\n\tborder-radius: 0;\n}\n\n.accordion.accordion-no-gutter .accordion-item:first-child .accordion-button {\n\tborder-top-left-radius: 0.375rem;\n\tborder-top-right-radius: 0.375rem;\n}\n\n.accordion.accordion-no-gutter .accordion-item:last-child .accordion-button.collapsed {\n\tborder-bottom-left-radius: 0.375rem;\n\tborder-bottom-right-radius: 0.375rem;\n}\n\n.accordion.accordion-no-gutter .accordion-item:last-child .accordion__body {\n\tborder-bottom-left-radius: 0.375rem;\n\tborder-bottom-right-radius: 0.375rem;\n}\n\n.accordion-solid-bg .accordion-button {\n\tborder-color: transparent;\n\tbackground-color: var(--rgba-primary-1);\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n[data-theme-version='dark'] .accordion-solid-bg .accordion-button {\n\tbackground-color: #202020;\n}\n.accordion-solid-bg .accordion-button.collapsed {\n\tborder-radius: 0.375rem;\n}\n\n.accordion-solid-bg .accordion__body {\n\tborder-color: transparent;\n\tbackground-color: var(--rgba-primary-1);\n\tborder-bottom-left-radius: 0.375rem;\n\tborder-bottom-right-radius: 0.375rem;\n}\n[data-theme-version='dark'] .accordion-solid-bg .accordion__body {\n\tbackground-color: #202020;\n}\n\n.accordion-active-header .accordion-button:not(.collapsed) {\n\tbackground-color: #00ada3;\n\tborder-color: #00ada3;\n\tcolor: #fff;\n}\n\n.accordion-header-shadow .accordion-button {\n\tborder: none;\n\tbox-shadow: 0 0 0.9375rem -0.1875rem rgba(0, 0, 0, 0.3);\n}\n\n.accordion-rounded-stylish .accordion-button {\n\tborder-top-left-radius: 0.375rem;\n\tborder-top-right-radius: 0.375rem;\n}\n\n.accordion-rounded-stylish .accordion__body {\n\tborder-bottom-left-radius: 0.375rem;\n\tborder-bottom-right-radius: 0.375rem;\n}\n\n.accordion-rounded .accordion-button {\n\tborder-radius: 0.3125rem;\n}\n\n.accordion-gradient .accordion-button {\n\tcolor: #fff;\n\tbackground-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%, rgba(103, 25, 255, 0.85) 100%);\n\tborder-color: transparent;\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n.accordion-gradient .accordion-button.collapsed {\n\tborder-bottom-left-radius: 0.375rem;\n\tborder-bottom-right-radius: 0.375rem;\n}\n.accordion-gradient .accordion-button:not(.collapsed) {\n\tbox-shadow: none;\n}\n\n.accordion-gradient .accordion__body {\n\tcolor: #fff;\n\tbackground-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%, rgba(103, 25, 255, 0.85) 100%);\n\tborder-color: transparent;\n}\n\n.dzm-tabs {\n\tpadding: 4px;\n\tborder-radius: 0.625rem;\n\tbackground-color: var(--bs-body-bg);\n\tborder: none;\n\tflex-wrap: nowrap;\n}\n.dzm-tabs .nav-item .nav-link {\n\tborder-radius: 0.625rem;\n}\n.dzm-tabs .nav-item .nav-link.active {\n\tbackground: var(--primary) !important;\n\tcolor: #fff;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.dzm-tabs {\n\t\tmargin-top: 1rem;\n\t}\n}\n\n.dz-card .card-body {\n\tpadding: 1.875rem !important;\n\tborder-radius: 0 0 0.375rem 0.375rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.dz-card .card-body {\n\t\tpadding: 1rem;\n\t}\n}\n.dz-card .card-body.code-area code {\n\tbackground: transparent;\n\tcolor: var(--secondary);\n}\n\n.dz-card .card-footer {\n\tcolor: #a098ae !important;\n}\n\n.dz-card .badge-box {\n\tposition: relative;\n\tbackground: black;\n\topacity: 0.6;\n\tborder-radius: 0 0 0.625rem 0.625rem;\n}\n\n.unorder-list li,\n.order-list li {\n\tlist-style: unset;\n}\n\n.text-justify {\n\ttext-align: justify;\n}\n\n.accordion-left-indicator .accordion-header .accordion-button {\n\tpadding-left: 2.5rem;\n}\n.accordion-left-indicator .accordion-header .accordion-button:after {\n\tleft: 1rem;\n}\n\n.alert {\n\tborder-radius: 0.375rem;\n\tpadding: 1rem 1.5rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.alert {\n\t\tpadding-left: 1rem;\n\t\tpadding-right: 2rem;\n\t}\n}\n.alert p {\n\tline-height: 1.5;\n}\n\n.alert-square {\n\tborder-radius: 0;\n}\n\n.alert-rounded {\n\tborder-radius: 3.125rem;\n}\n\n.alert-primary {\n\tbackground: var(--rgba-primary-1);\n\tborder-color: var(--rgba-primary-1);\n\tcolor: var(--primary);\n}\n\n.alert-secondary {\n\tbackground: #fff3f0;\n\tborder-color: #fff3f0;\n\tcolor: #fb7d5b;\n}\n\n.alert-success {\n\tbackground: #ddfaea;\n\tborder-color: #ddfaea;\n\tcolor: #1eba62;\n}\n\n.alert-warning {\n\tbackground: #fffaee;\n\tborder-color: #fffaee;\n\tcolor: #fcc43e;\n}\n\n.alert-danger {\n\tbackground: #ffeaea;\n\tborder-color: #ffeaea;\n\tcolor: #fd5353;\n}\n\n.alert-info {\n\tbackground: #94fff9;\n\tborder-color: #94fff9;\n\tcolor: #00ada3;\n}\n\n.alert-dark {\n\tbackground: #bec3e3;\n\tborder-color: #bec3e3;\n\tcolor: #303972;\n}\n\n.alert-light {\n\tbackground: #ebebf9;\n\tborder-color: #ebebf9;\n\tcolor: #303972;\n}\n\n.alert-alt.alert-primary {\n\tborder-left: 0.25rem solid var(--primary);\n}\n\n.alert-alt.alert-secondary {\n\tborder-left: 0.25rem solid #fb7d5b;\n}\n\n.alert-alt.alert-success {\n\tborder-left: 0.25rem solid #1eba62;\n}\n\n.alert-alt.alert-warning {\n\tborder-left: 0.25rem solid #fcc43e;\n}\n\n.alert-alt.alert-danger {\n\tborder-left: 0.25rem solid #fd5353;\n}\n\n.alert-alt.alert-info {\n\tborder-left: 0.25rem solid #00ada3;\n}\n\n.alert-alt.alert-dark {\n\tborder-left: 0.25rem solid #303972;\n}\n\n.alert-alt.alert-light {\n\tborder-left: 0.25rem solid #b0b0e7;\n}\n\n.alert-alt.alert-primary.solid {\n\tborder-left: 0.25rem solid var(--primary-dark) !important;\n}\n\n.alert-alt.alert-secondary.solid {\n\tborder-left: 0.25rem solid #d13105 !important;\n}\n\n.alert-alt.alert-success.solid {\n\tborder-left: 0.25rem solid #0c4c28 !important;\n}\n\n.alert-alt.alert-warning.solid {\n\tborder-left: 0.25rem solid #b88203 !important;\n}\n\n.alert-alt.alert-danger.solid {\n\tborder-left: 0.25rem solid #ce0202 !important;\n}\n\n.alert-alt.alert-info.solid {\n\tborder-left: 0.25rem solid #002e2b !important;\n}\n\n.alert-alt.alert-dark.solid {\n\tborder-left: 0.25rem solid #0a0c18 !important;\n}\n\n.alert-alt.alert-light.solid {\n\tborder-left: 0.25rem solid #8989dc !important;\n}\n\n.alert-dismissible.solid .close:hover {\n\tcolor: #fff;\n\topacity: 1;\n}\n\n.alert.alert-primary.solid {\n\tbackground: var(--primary);\n\tcolor: #fff;\n\tborder-color: var(--primary);\n}\n\n.alert.alert-secondary.solid {\n\tbackground: #fb7d5b;\n\tcolor: #fff;\n\tborder-color: #fb7d5b;\n}\n\n.alert.alert-success.solid {\n\tbackground: #1eba62;\n\tcolor: #fff;\n\tborder-color: #1eba62;\n}\n\n.alert.alert-warning.solid {\n\tbackground: #fcc43e;\n\tcolor: #fff;\n\tborder-color: #fcc43e;\n}\n\n.alert.alert-danger.solid {\n\tbackground: #fd5353;\n\tcolor: #fff;\n\tborder-color: #fd5353;\n}\n\n.alert.alert-info.solid {\n\tbackground: #00ada3;\n\tcolor: #fff;\n\tborder-color: #00ada3;\n}\n\n.alert.alert-dark.solid {\n\tbackground: #303972;\n\tcolor: #fff;\n\tborder-color: #303972;\n}\n\n.alert.alert-light.solid {\n\tbackground: #ebebf9;\n\tcolor: #303972;\n\tborder-color: #ebebf9;\n}\n\n.alert-end-icon > span i {\n\tfont-size: 18px;\n\tmargin-right: 5px;\n}\n\n.alert-right-icon > span i {\n\tfont-size: 1.125rem;\n\tmargin-right: 0.3125rem;\n}\n\n.alert-right-icon .close i {\n\tfont-size: 1rem;\n}\n\n.alert.alert-outline-primary {\n\tbackground: transparent;\n\tcolor: var(--primary);\n\tborder-color: var(--primary);\n}\n\n.alert.alert-outline-secondary {\n\tbackground: transparent;\n\tcolor: #a098ae;\n\tborder-color: #fb7d5b;\n}\n\n.alert.alert-outline-success {\n\tbackground: transparent;\n\tcolor: #1eba62;\n\tborder-color: #1eba62;\n}\n\n.alert.alert-outline-info {\n\tbackground: transparent;\n\tcolor: #00ada3;\n\tborder-color: #00ada3;\n}\n\n.alert.alert-outline-warning {\n\tbackground: transparent;\n\tcolor: #fcc43e;\n\tborder-color: #fcc43e;\n}\n\n.alert.alert-outline-danger {\n\tbackground: transparent;\n\tcolor: #fd5353;\n\tborder-color: #fd5353;\n}\n\n.alert.alert-outline-dark {\n\tbackground: transparent;\n\tcolor: #a098ae;\n\tborder-color: #303972;\n}\n\n.alert.alert-outline-light {\n\tbackground: transparent;\n\tcolor: #303972;\n\tborder-color: #ebebf9;\n}\n\n.alert-social {\n\tcolor: #fff;\n}\n.alert-social .alert-social-icon {\n\talign-self: center;\n\tmargin-right: 0.9375rem;\n}\n.alert-social .alert-social-icon i {\n\tfont-size: 2.625rem;\n}\n.alert-social.facebook {\n\tbackground-color: #3b5998;\n}\n.alert-social.twitter {\n\tbackground-color: #1da1f2;\n}\n.alert-social.linkedin {\n\tbackground-color: #007bb6;\n}\n.alert-social.google-plus {\n\tbackground-color: #db4439;\n}\n.alert-social .close:hover {\n\topacity: 1 !important;\n\tcolor: #fff !important;\n}\n\n.left-icon-big .alert-left-icon-big {\n\talign-self: center;\n\tmargin-right: 0.9375rem;\n}\n.left-icon-big .alert-left-icon-big i {\n\tfont-size: 2.1875rem;\n\tline-height: 1;\n}\n\n[direction='rtl'] .left-icon-big .alert-left-icon-big,\n[direction='rtl'] .alert-social .alert-social-icon {\n\tmargin-right: 0;\n\tmargin-left: 0.9375rem;\n}\n\n.alert .btn-close {\n\tbackground: none;\n\ttext-shadow: 0 1px 0 #fff;\n\topacity: 0.5;\n\tcolor: inherit;\n}\n.alert .btn-close i {\n\ttransform: scale(1.4);\n}\n.alert .btn-close:focus {\n\tbox-shadow: none;\n}\n\n.badge {\n\tline-height: 1.3;\n\tborder-radius: 0.325rem;\n\tfont-weight: 600;\n\tpadding: 0.25rem 0.515rem;\n\tborder: 0.0625rem solid transparent;\n}\n\n.badge-rounded {\n\tborder-radius: 1.25rem;\n\tpadding: 0.1875rem 0.8125rem;\n}\n\n.badge-circle {\n\tborder-radius: 6.25rem;\n\tline-height: 13px;\n\tpadding: 0.1875rem 0.4375rem;\n}\n\n.badge-outline-primary {\n\tborder: 0.0625rem solid var(--primary);\n\tcolor: var(--primary);\n}\n\n.badge-outline-secondary {\n\tborder: 0.0625rem solid #fb7d5b;\n\tcolor: #fb7d5b;\n}\n[data-theme-version='dark'] .badge-outline-secondary {\n\tcolor: #a098ae;\n}\n\n.badge-outline-success {\n\tborder: 0.0625rem solid #1eba62;\n\tcolor: #1eba62;\n}\n\n.badge-outline-info {\n\tborder: 0.0625rem solid #00ada3;\n\tcolor: #00ada3;\n}\n\n.badge-outline-warning {\n\tborder: 0.0625rem solid #fcc43e;\n\tcolor: #fcc43e;\n}\n\n.badge-outline-danger {\n\tborder: 0.0625rem solid #fd5353;\n\tcolor: #fd5353;\n}\n\n.badge-outline-light {\n\tborder: 0.0625rem solid #f2f2f2;\n\tcolor: #303972;\n}\n[data-theme-version='dark'] .badge-outline-light {\n\tcolor: #a098ae;\n}\n\n.badge-outline-dark {\n\tborder: 0.0625rem solid #303972;\n\tcolor: #303972;\n}\n[data-theme-version='dark'] .badge-outline-dark {\n\tcolor: #a098ae;\n}\n\n.badge-xs {\n\tfont-size: 0.625rem;\n\tpadding: 0rem 0.3125rem;\n\tline-height: 1.125rem;\n}\n\n.badge-sm {\n\tfont-size: 0.6875rem;\n\tpadding: 0.3125rem 0.5rem;\n\tline-height: 0.6875rem;\n}\n\n.badge-lg {\n\tpadding: 0.25rem 0.5rem;\n\tborder-radius: 0.5rem;\n\tfont-weight: 400;\n\tfont-size: 0.813rem;\n\tline-height: 1.4;\n}\n.badge-lg:hover {\n\tcolor: #fff;\n}\n\n.badge-xl {\n\tfont-size: 1rem;\n\tpadding: 0rem 0.9375rem;\n\tline-height: 2;\n}\n\n.badge-default {\n\tbackground: #adb6c7;\n}\n\n.badge-success {\n\tbackground-color: #1eba62;\n}\n.badge-success:hover {\n\tcolor: #fff;\n}\n\n.badge-secondary {\n\tbackground-color: #fb7d5b;\n}\n.badge-secondary:hover {\n\tcolor: #fff;\n}\n\n.badge-info {\n\tbackground-color: #00ada3;\n}\n.badge-info:hover {\n\tcolor: #fff;\n}\n\n.badge-primary {\n\tbackground-color: var(--primary);\n}\n.badge-primary:hover {\n\tcolor: #fff;\n}\n\n.badge-warning {\n\tbackground-color: #fcc43e;\n}\n.badge-warning:hover {\n\tcolor: #fff;\n}\n\n.badge-danger {\n\tbackground-color: #fd5353;\n}\n.badge-danger:hover {\n\tcolor: #fff;\n}\n\n.badge-dark {\n\tbackground-color: #303972;\n}\n.badge-dark:hover {\n\tcolor: #fff;\n}\n\n.badge-light {\n\tbackground-color: #ebebf9;\n}\n.badge-light:hover {\n\tcolor: #fff;\n}\n\n.light.badge-default {\n\tbackground: #adb6c7;\n}\n\n.light.badge-success {\n\tbackground-color: #ddfaea;\n\tcolor: #1eba62;\n}\n[data-theme-version='dark'] .light.badge-success {\n\tbackground-color: rgba(30, 186, 98, 0.1);\n}\n\n.light.badge-info {\n\tbackground-color: #94fff9;\n\tcolor: #00ada3;\n}\n[data-theme-version='dark'] .light.badge-info {\n\tbackground-color: rgba(0, 173, 163, 0.1);\n}\n\n.light.badge-primary {\n\tbackground-color: #eaebf1;\n\tcolor: var(--primary);\n}\n[data-theme-version='dark'] .light.badge-primary {\n\tbackground-color: var(--rgba-primary-1);\n}\n\n.light.badge-secondary {\n\tbackground-color: #fff3f0;\n\tcolor: #fb7d5b;\n}\n[data-theme-version='dark'] .light.badge-secondary {\n\tbackground-color: rgba(251, 125, 91, 0.5);\n\tcolor: #fff;\n}\n\n.light.badge-warning {\n\tbackground-color: #fffaee;\n\tcolor: #fcc43e;\n}\n[data-theme-version='dark'] .light.badge-warning {\n\tbackground-color: rgba(252, 196, 62, 0.1);\n}\n\n.light.badge-danger {\n\tbackground-color: #ffeaea;\n\tcolor: #fd5353;\n}\n[data-theme-version='dark'] .light.badge-danger {\n\tbackground-color: rgba(253, 83, 83, 0.15);\n}\n\n.light.badge-dark {\n\tbackground-color: #bec3e3;\n\tcolor: #303972;\n}\n[data-theme-version='dark'] .light.badge-dark {\n\tbackground-color: rgba(48, 57, 114, 0.35);\n\tcolor: #fff;\n}\n\n.light.badge-pink {\n\tbackground-color: rgba(235, 98, 208, 0.1);\n\tcolor: #eb62d0;\n}\n\n.light.badge-light {\n\tbackground-color: #eaebf1;\n\tcolor: #aaa9ff;\n}\n\n.bootstrap-label .label {\n\tdisplay: inline-block;\n\tmargin-right: 1rem;\n}\n.bootstrap-label .label:last-child {\n\tmargin-right: 0;\n}\n\n.badge-demo .badge {\n\tmargin-right: 0.3125rem;\n\tmargin-bottom: 0.3125rem;\n}\n.badge-demo .badge:last-child {\n\tmargin-right: 0;\n}\n\n.bootstrap-badge-buttons button {\n\tmargin-right: 0.2rem;\n\tmargin-bottom: 1rem;\n}\n.bootstrap-badge-buttons button:last-child {\n\tmargin-right: 0;\n}\n\n.breadcrumb {\n\tfont-size: 1.1875rem;\n}\n.breadcrumb .breadcrumb-item.active a {\n\tcolor: var(--primary);\n}\n.breadcrumb .breadcrumb-item svg {\n\twidth: 22px;\n\tmargin-bottom: 3px;\n}\n.breadcrumb .breadcrumb-item + .breadcrumb-item::before {\n\tcolor: var(--primary);\n}\n\n.page-titles {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 0.825rem 1.875rem;\n\tbackground: #ffffff;\n\tmargin-bottom: 1.875rem;\n\tborder-radius: 0.375rem;\n\tposition: relative;\n\tz-index: 1;\n\tflex-wrap: wrap;\n}\n.page-titles.style1 {\n\tpadding: 0.92rem 1.875rem;\n}\n.page-titles h2,\n.page-titles .h2 {\n\tmargin: 0;\n}\n@media only screen and (max-width: 100rem) {\n\t.page-titles h2,\n\t.page-titles .h2 {\n\t\tfont-size: 20px;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.page-titles {\n\t\tflex-wrap: wrap;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.page-titles {\n\t\tpadding: 0.6375rem 1rem;\n\t\tflex-wrap: wrap;\n\t}\n\t.page-titles h2,\n\t.page-titles .h2 {\n\t\tfont-size: 1rem;\n\t}\n}\n.page-titles .justify-content-sm-end {\n\talign-items: center;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.page-titles .left-title {\n\t\tmargin-bottom: 0.5rem;\n\t}\n}\n.page-titles h4,\n.page-titles .h4 {\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tcolor: var(--primary);\n\tfont-size: 1.25rem;\n}\n.page-titles h4 span,\n.page-titles .h4 span {\n\tfont-size: 0.875rem;\n\tfont-weight: 400;\n}\n.page-titles .breadcrumb {\n\tmargin-bottom: 0;\n\tpadding: 0;\n\tbackground: transparent;\n\talign-items: center;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.page-titles .breadcrumb {\n\t\tpadding-right: 0px;\n\t}\n}\n.page-titles .breadcrumb h2,\n.page-titles .breadcrumb .h2 {\n\tmargin: 0;\n\tfont-size: 28px;\n\tfont-weight: 500;\n}\n.page-titles .breadcrumb p {\n\tmargin: 0;\n\tfont-size: 16px;\n\tcolor: #fff000;\n}\n.page-titles .breadcrumb li {\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n\tpadding-left: 2rem;\n\talign-items: center;\n\tdisplay: flex;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.page-titles .breadcrumb li:first-child {\n\t\tpadding-left: 0;\n\t}\n}\n.page-titles .breadcrumb li a {\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tdisplay: flex;\n\talign-items: center;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.page-titles .breadcrumb li a {\n\t\tfont-size: 0.95rem;\n\t}\n}\n.page-titles .breadcrumb li.active {\n\tcolor: var(--primary);\n\tfont-size: 1rem;\n}\n.page-titles .breadcrumb li.active a {\n\tcolor: #ebebf9;\n}\n.page-titles .breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n\tcontent: '\\f105';\n\tfont-family: 'Font Awesome 6 Free';\n\tfont-weight: 600;\n\tposition: absolute;\n\tfont-size: 14px;\n\tcolor: #ebebf9;\n\tmargin-left: -20px;\n}\n.page-titles .breadcrumb-datepicker {\n\tfont-size: 0.75rem;\n\tcolor: #89879f;\n}\n.page-titles .breadcrumb-datepicker__icon {\n\tfont-size: 0.875rem;\n}\n.page-titles .sub-dz-head {\n\tdisplay: flex;\n\talign-items: center;\n\twidth: 100%;\n\tjustify-content: space-between;\n\tposition: relative;\n}\n.page-titles .sub-dz-head:before {\n\tcontent: '';\n\ttop: -18px;\n\tleft: 0;\n\twidth: 100%;\n\tbackground: rgba(255, 255, 255, 0.12);\n\theight: 1px;\n\tposition: absolute;\n}\n.page-titles .breadcrumb-widget .border-dark {\n\tborder-color: #dee2e6 !important;\n}\n.page-titles .breadcrumb-widget h4,\n.page-titles .breadcrumb-widget .h4 {\n\tcolor: #646c9a;\n\tfont-weight: 600;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.page-titles .breadcrumb-widget {\n\t\ttext-align: left !important;\n\t\tmargin-bottom: 0.9375rem;\n\t}\n}\n.page-titles p {\n\tmargin: 0;\n\tcolor: #fff000;\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.page-titles .btn svg {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t}\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.page-titles .btn svg {\n\t\twidth: 18px;\n\t\theight: 18px;\n\t}\n}\n\nbutton {\n\tcursor: pointer;\n}\nbutton:focus {\n\toutline: 0;\n\tbox-shadow: none;\n}\n\n.btn {\n\tpadding: 0.688rem 1.5rem;\n\tborder-radius: 0.5rem;\n\tfont-weight: 500;\n\tfont-size: 1rem;\n\tline-height: 1.5;\n}\n.btn:hover,\n.btn:focus,\n.btn:active,\n.btn.active {\n\toutline: 0 !important;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.btn {\n\t\tpadding: 0.625rem 1rem;\n\t\tfont-size: 0.813rem;\n\t}\n}\n.btn.btn-success,\n.btn.btn-secondary,\n.btn.btn-warning,\n.btn.btn-primary,\n.btn.btn-danger,\n.btn.btn-info {\n\tcolor: #fff;\n}\n.btn.btn-success:hover,\n.btn.btn-secondary:hover,\n.btn.btn-warning:hover,\n.btn.btn-primary:hover,\n.btn.btn-danger:hover,\n.btn.btn-info:hover {\n\tcolor: #fff !important;\n}\n.btn-transparent {\n\tbackground-color: transparent;\n}\n\n.btn-primary {\n\tborder-color: var(--primary);\n\tbackground-color: var(--primary);\n}\n.btn-primary:active,\n.btn-primary:focus,\n.btn-primary:hover {\n\tborder-color: var(--primary-hover);\n\tbackground-color: var(--primary-hover);\n}\n.btn-primary:focus {\n\tbox-shadow: unset;\n}\n.btn-primary:disabled,\n.btn-primary.disabled {\n\tbackground-color: var(--primary);\n\tborder-color: var(--primary);\n}\n\n.btn-link {\n\tcolor: var(--primary);\n\ttext-decoration: none;\n}\n.btn-link:hover {\n\tcolor: var(--primary-hover);\n}\n\n.btn-outline-primary {\n\tcolor: var(--primary);\n\tborder-color: var(--primary);\n}\n.btn-outline-primary:hover {\n\tborder-color: var(--primary-hover);\n\tbackground-color: var(--primary-hover);\n}\n\n.sharp {\n\twidth: 2.5rem;\n\theight: 2.5rem;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 0.375rem;\n\tpadding: 0;\n}\n\n.sharp-sm {\n\theight: 2.5rem;\n\twidth: 2.5rem;\n\tline-height: 2.5rem;\n}\n\n.sharp-lg {\n\theight: 3rem;\n\twidth: 3rem;\n\tline-height: 2.7rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.sharp-lg {\n\t\theight: 2.285rem;\n\t\twidth: 2.285rem;\n\t\tline-height: 2.5rem;\n\t\tfont-size: 0.813rem;\n\t}\n}\n\n.sharp.btn-xs {\n\tpadding: 0.1875rem;\n\twidth: 1.625rem;\n\theight: 1.625rem;\n\tmin-width: 1.625rem;\n\tmin-height: 1.625rem;\n}\n\n.btn-block {\n\tdisplay: block;\n\twidth: 100%;\n}\n\n.light.tp-btn {\n\tbackground-color: transparent;\n}\n\n.light.btn-default {\n\tbackground: #adb6c7;\n}\n\n.light.btn-success {\n\tbackground-color: rgba(30, 186, 98, 0.1);\n\tborder-color: #ddfaea;\n\tcolor: #1eba62;\n}\n.light.btn-success g [fill] {\n\tfill: #1eba62;\n}\n[data-theme-version='dark'] .light.btn-success {\n\tbackground-color: rgba(30, 186, 98, 0.1);\n\tborder-color: transparent;\n}\n.light.btn-success:hover {\n\tbackground-color: #1eba62;\n\tborder-color: #1eba62;\n\tcolor: #fff;\n}\n.light.btn-success:hover g [fill] {\n\tfill: #fff;\n}\n\n.light.btn-info {\n\tbackground-color: #94fff9;\n\tborder-color: #94fff9;\n\tcolor: #00ada3;\n}\n.light.btn-info g [fill] {\n\tfill: #00ada3;\n}\n[data-theme-version='dark'] .light.btn-info {\n\tbackground-color: rgba(0, 173, 163, 0.1);\n\tborder-color: transparent;\n}\n.light.btn-info:hover {\n\tbackground-color: #00ada3;\n\tborder-color: #00ada3;\n\tcolor: #fff;\n}\n.light.btn-info:hover g [fill] {\n\tfill: #fff;\n}\n\n.light.btn-primary {\n\tbackground-color: var(--rgba-primary-1);\n\tborder-color: var(--rgba-primary-1);\n\tcolor: var(--primary);\n}\n.light.btn-primary g [fill] {\n\tfill: var(--primary);\n}\n[data-theme-version='dark'] .light.btn-primary {\n\tbackground-color: var(--rgba-primary-1);\n\tborder-color: transparent;\n\tcolor: #fff;\n}\n.light.btn-primary:hover {\n\tbackground-color: var(--primary);\n\tborder-color: var(--primary);\n\tcolor: #fff;\n}\n.light.btn-primary:hover g [fill] {\n\tfill: #fff;\n}\n\n.light.btn-secondary {\n\tbackground: rgba(251, 125, 91, 0.2);\n\tborder-color: rgba(251, 125, 91, 0.1);\n\tcolor: #fb7d5b !important;\n}\n.light.btn-secondary g [fill] {\n\tfill: #fb7d5b;\n}\n[data-theme-version='dark'] .light.btn-secondary {\n\tbackground-color: rgba(251, 125, 91, 0.5);\n\tborder-color: transparent;\n\tcolor: #fff;\n}\n.light.btn-secondary:hover {\n\tbackground-color: #fb7d5b;\n\tborder-color: #fb7d5b;\n\tcolor: #fff !important;\n}\n.light.btn-secondary:hover g [fill] {\n\tfill: #fff;\n}\n\n.light.btn-warning {\n\tbackground-color: #fffaee;\n\tborder-color: #fffaee;\n\tcolor: #fcc43e;\n}\n.light.btn-warning g [fill] {\n\tfill: #fcc43e;\n}\n[data-theme-version='dark'] .light.btn-warning {\n\tbackground-color: rgba(252, 196, 62, 0.1);\n\tborder-color: transparent;\n}\n.light.btn-warning:hover {\n\tbackground-color: #fcc43e;\n\tborder-color: #fcc43e;\n\tcolor: #fff;\n}\n.light.btn-warning:hover g [fill] {\n\tfill: #fff;\n}\n\n.light.btn-danger {\n\tbackground-color: #ffeaea;\n\tborder-color: #ffeaea;\n\tcolor: #fd5353;\n}\n.light.btn-danger g [fill] {\n\tfill: #fd5353;\n}\n[data-theme-version='dark'] .light.btn-danger {\n\tbackground-color: rgba(253, 83, 83, 0.15);\n\tborder-color: transparent;\n}\n.light.btn-danger:hover {\n\tbackground-color: #fd5353;\n\tborder-color: #fd5353;\n\tcolor: #fff;\n}\n.light.btn-danger:hover g [fill] {\n\tfill: #fff;\n}\n\n.light.btn-dark {\n\tbackground-color: #bec3e3;\n\tborder-color: #bec3e3;\n\tcolor: #303972;\n}\n.light.btn-dark g [fill] {\n\tfill: #303972;\n}\n[data-theme-version='dark'] .light.btn-dark {\n\tbackground-color: rgba(48, 57, 114, 0.35);\n\tborder-color: transparent;\n\tcolor: #fff;\n}\n.light.btn-dark:hover {\n\tbackground-color: #303972;\n\tborder-color: #303972;\n\tcolor: #fff;\n}\n.light.btn-dark:hover g [fill] {\n\tfill: #fff;\n}\n\n.btn.tp-btn {\n\tbackground-color: transparent;\n\tborder-color: transparent;\n}\n.btn.tp-btn.btn-default {\n\tbackground: #adb6c7;\n}\n.btn.tp-btn.btn-success {\n\tcolor: #1eba62;\n}\n.btn.tp-btn.btn-success g [fill] {\n\tfill: #1eba62;\n}\n.btn.tp-btn.btn-success:hover {\n\tbackground-color: #1eba62;\n\tborder-color: #1eba62;\n\tcolor: #fff;\n}\n.btn.tp-btn.btn-success:hover g [fill] {\n\tfill: #fff;\n}\n.btn.tp-btn.btn-info {\n\tcolor: #00ada3;\n}\n.btn.tp-btn.btn-info g [fill] {\n\tfill: #00ada3;\n}\n.btn.tp-btn.btn-info:hover {\n\tbackground-color: #00ada3;\n\tborder-color: #00ada3;\n\tcolor: #fff;\n}\n.btn.tp-btn.btn-info:hover g [fill] {\n\tfill: #fff;\n}\n.btn.tp-btn.btn-primary {\n\tcolor: var(--primary);\n\tbackground-color: var(--rgba-primary-1);\n}\n.btn.tp-btn.btn-primary g [fill] {\n\tfill: var(--primary);\n}\n.btn.tp-btn.btn-primary:hover {\n\tbackground-color: var(--primary);\n\tborder-color: var(--primary);\n\tcolor: #fff;\n}\n.btn.tp-btn.btn-primary:hover g [fill] {\n\tfill: #fff;\n}\n.btn.tp-btn.btn-secondary {\n\tcolor: var(--secondary);\n}\n.btn.tp-btn.btn-secondary g [fill] {\n\tfill: var(--secondary);\n}\n.btn.tp-btn.btn-secondary:hover {\n\tbackground-color: #fb7d5b;\n\tborder-color: #fb7d5b;\n\tcolor: #fff;\n}\n.btn.tp-btn.btn-secondary:hover g [fill] {\n\tfill: #fff;\n}\n.btn.tp-btn.btn-warning {\n\tcolor: #fcc43e;\n}\n.btn.tp-btn.btn-warning g [fill] {\n\tfill: #fcc43e;\n}\n.btn.tp-btn.btn-warning:hover {\n\tbackground-color: #fcc43e;\n\tborder-color: #fcc43e;\n\tcolor: #fff;\n}\n.btn.tp-btn.btn-warning:hover g [fill] {\n\tfill: #fff;\n}\n.btn.tp-btn.btn-danger {\n\tcolor: #fd5353;\n}\n.btn.tp-btn.btn-danger g [fill] {\n\tfill: #fd5353;\n}\n.btn.tp-btn.btn-danger:hover {\n\tbackground-color: #fd5353;\n\tborder-color: #fd5353;\n\tcolor: #fff;\n}\n.btn.tp-btn.btn-danger:hover g [fill] {\n\tfill: #fff;\n}\n.btn.tp-btn.btn-light {\n\tcolor: #303972;\n}\n.btn.tp-btn.btn-light g [fill] {\n\tfill: #303972;\n}\n.btn.tp-btn.btn-light:hover {\n\tbackground-color: #ebebf9;\n\tborder-color: #ebebf9;\n\tcolor: #303972;\n}\n.btn.tp-btn.btn-light:hover g [fill] {\n\tfill: #fff;\n}\n.btn.tp-btn.btn-dark {\n\tcolor: #303972;\n}\n.btn.tp-btn.btn-dark g [fill] {\n\tfill: #303972;\n}\n.btn.tp-btn.btn-dark:hover {\n\tbackground-color: #303972;\n\tborder-color: #303972;\n\tcolor: #fff;\n}\n.btn.tp-btn.btn-dark:hover g [fill] {\n\tfill: #fff;\n}\n\n.btn.tp-btn-light {\n\tbackground-color: transparent;\n\tborder-color: transparent;\n}\n.btn.tp-btn-light.btn-success {\n\tcolor: #1eba62;\n}\n.btn.tp-btn-light.btn-success g [fill] {\n\tfill: #1eba62;\n}\n.btn.tp-btn-light.btn-success:hover {\n\tbackground-color: #ddfaea;\n\tborder-color: #ddfaea;\n\tcolor: #1eba62;\n}\n.btn.tp-btn-light.btn-success:hover g [fill] {\n\tfill: #1eba62;\n}\n.btn.tp-btn-light.btn-info {\n\tcolor: #00ada3;\n}\n.btn.tp-btn-light.btn-info g [fill] {\n\tfill: #00ada3;\n}\n.btn.tp-btn-light.btn-info:hover {\n\tbackground-color: #94fff9;\n\tborder-color: #94fff9;\n\tcolor: #00ada3;\n}\n.btn.tp-btn-light.btn-info:hover g [fill] {\n\tfill: #00ada3;\n}\n.btn.tp-btn-light.btn-primary {\n\tcolor: var(--primary);\n}\n.btn.tp-btn-light.btn-primary g [fill] {\n\tfill: var(--primary);\n}\n.btn.tp-btn-light.btn-primary:hover {\n\tbackground-color: var(--rgba-primary-1);\n\tborder-color: var(--rgba-primary-1);\n\tcolor: var(--primary);\n}\n.btn.tp-btn-light.btn-primary:hover g [fill] {\n\tfill: var(--primary);\n}\n.btn.tp-btn-light.btn-secondary {\n\tcolor: var(--secondary);\n}\n.btn.tp-btn-light.btn-secondary g [fill] {\n\tfill: var(--secondary);\n}\n.btn.tp-btn-light.btn-secondary:hover {\n\tbackground-color: var(--rgba-secondary-1);\n\tborder-color: var(--rgba-secondary-1);\n\tcolor: var(--secondary);\n}\n.btn.tp-btn-light.btn-secondary:hover g [fill] {\n\tfill: var(--secondary);\n}\n.btn.tp-btn-light.btn-warning {\n\tcolor: #fcc43e;\n}\n.btn.tp-btn-light.btn-warning g [fill] {\n\tfill: #fcc43e;\n}\n.btn.tp-btn-light.btn-warning:hover {\n\tbackground-color: #fffaee;\n\tborder-color: #fffaee;\n\tcolor: #fcc43e;\n}\n.btn.tp-btn-light.btn-warning:hover g [fill] {\n\tfill: #fcc43e;\n}\n.btn.tp-btn-light.btn-danger {\n\tcolor: #fd5353;\n}\n.btn.tp-btn-light.btn-danger g [fill] {\n\tfill: #fd5353;\n}\n.btn.tp-btn-light.btn-danger:hover {\n\tbackground-color: #ffeaea;\n\tborder-color: #ffeaea;\n\tcolor: #fd5353;\n}\n.btn.tp-btn-light.btn-danger:hover g [fill] {\n\tfill: #fff;\n}\n.btn.tp-btn-light.btn-dark {\n\tcolor: #303972;\n}\n.btn.tp-btn-light.btn-dark g [fill] {\n\tfill: #303972;\n}\n.btn.tp-btn-light.btn-dark:hover {\n\tbackground-color: #bec3e3;\n\tborder-color: #bec3e3;\n\tcolor: #303972;\n}\n.btn.tp-btn-light.btn-dark:hover g [fill] {\n\tfill: #fff;\n}\n\n.shadow.btn-primary {\n\t-webkit-box-shadow: 0 0.3125rem 0.9375rem 0 var(--rgba-primary-2) !important;\n\tbox-shadow: 0 0.3125rem 0.9375rem 0 var(--rgba-primary-2) !important;\n}\n\n.shadow.btn-secondary {\n\t-webkit-box-shadow: 0 0.3125rem 0.9375rem 0 rgba(251, 125, 91, 0.2) !important;\n\tbox-shadow: 0 0.3125rem 0.9375rem 0 rgba(251, 125, 91, 0.2) !important;\n}\n\n.shadow.btn-warning {\n\t-webkit-box-shadow: 0 0.3125rem 0.9375rem 0 rgba(252, 196, 62, 0.2) !important;\n\tbox-shadow: 0 0.3125rem 0.9375rem 0 rgba(252, 196, 62, 0.2) !important;\n}\n\n.shadow.btn-danger {\n\t-webkit-box-shadow: 0 0.3125rem 0.9375rem 0 rgba(253, 83, 83, 0.2) !important;\n\tbox-shadow: 0 0.3125rem 0.9375rem 0 rgba(253, 83, 83, 0.2) !important;\n}\n\n.shadow.btn-info {\n\t-webkit-box-shadow: 0 0.3125rem 0.9375rem 0 rgba(0, 173, 163, 0.2) !important;\n\tbox-shadow: 0 0.3125rem 0.9375rem 0 rgba(0, 173, 163, 0.2) !important;\n}\n\n.shadow.btn-success {\n\t-webkit-box-shadow: 0 0.3125rem 0.9375rem 0 rgba(30, 186, 98, 0.2) !important;\n\tbox-shadow: 0 0.3125rem 0.9375rem 0 rgba(30, 186, 98, 0.2) !important;\n}\n\n.btn-xxs {\n\tpadding: 0.367rem 0.9375rem;\n\tfont-size: 0.6875rem;\n\tline-height: 1.3;\n}\n\n.btn-xs {\n\tfont-size: 0.75rem;\n\tpadding: 0.375rem 1rem;\n\tfont-weight: 600;\n\tborder-radius: 0.3rem;\n}\n\n.btn-sm,\n.btn-group-sm > .btn {\n\tfont-size: 0.813rem !important;\n\tpadding: 0.579rem 1rem;\n}\n\n.btn-md {\n\tfont-size: 0.875rem !important;\n\tpadding: 0.579rem 1rem;\n}\n\n.btn-lg,\n.btn-group-lg > .btn {\n\tpadding: 0.969rem 2rem;\n\tfont-size: 1.125rem !important;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.btn-lg,\n\t.btn-group-lg > .btn {\n\t\tpadding: 0.75rem 1.25rem;\n\t}\n}\n\n.btn-xl {\n\tpadding: 0.6rem 1rem;\n}\n.btn-xl.btn-default {\n\tfont-weight: 600;\n}\n\n.btn-icon-lg {\n\tpadding: 15px 18px;\n\tmin-width: 20px !important;\n}\n\n.btn-icon-md {\n\tpadding: 13px 16px;\n\tmin-width: 20px !important;\n}\n\n.btn-icon-sm {\n\tpadding: 11px 14px;\n\tmin-width: 20px !important;\n}\n\n.btn-icon-xs {\n\tpadding: 10px 12px;\n\tmin-width: 20px !important;\n}\n\n.btn-icon-xxs {\n\tpadding: 8px 10px;\n\tmin-width: 20px !important;\n}\n\n.btn-square {\n\tborder-radius: 0;\n}\n\n.btn-rounded {\n\tborder-radius: 2.5rem !important;\n}\n\n.btn-icon-end {\n\tborder-left: 0.0625rem solid #ebebf9;\n\tdisplay: inline-block;\n\tmargin: -0.8rem 0 -0.8rem 1rem;\n\tpadding: 0.4375rem 0 0.4375rem 1rem;\n\tmargin: -1rem -0.25rem -1rem 1rem;\n\tpadding: 1rem 0 1rem 1.25rem;\n}\n\n.btn-icon-start {\n\tbackground: #fff;\n\tborder-radius: 0.5rem;\n\tdisplay: inline-block;\n\tmargin: -0.2rem 0.55rem -0.4rem -1.188rem;\n\tpadding: 0.3rem 0.6rem 0.2rem;\n\tfloat: left;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.btn-icon-start {\n\t\tmargin: -0.2rem 0.5rem -0.2rem -0.48rem;\n\t}\n}\n\n[direction='rtl'] .btn-icon-start {\n\tmargin: -0.5rem 0.5rem -0.5rem -1rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t[direction='rtl'] .btn-icon-start {\n\t\tmargin: -0.5rem 0.75rem -0.5rem -0.88rem;\n\t}\n}\n\n[direction='rtl'] .btn-icon-end {\n\tborder-left: 0rem solid white;\n\tdisplay: inline-block;\n\tmargin: -0.8rem 1rem -0.8rem 0;\n\tpadding: 0.4375rem 1rem 0.4375rem 0;\n\tborder-right: 0.0625rem solid white;\n}\n\n.toggle-dropdown::after {\n\tmargin-left: 0.755em;\n}\n\n.social-btn-icon .btn {\n\tmin-width: 7.5rem;\n\tmargin-bottom: 1.5rem;\n}\n\n.social-icon .btn {\n\tpadding: 0.7rem 1.4rem;\n}\n\n.btn-circle {\n\theight: 5rem;\n\twidth: 5rem;\n\tborder-radius: 50% !important;\n}\n.btn-circle-sm {\n\twidth: 4.5rem;\n\theight: 4.5rem;\n\tfont-size: 1.8rem;\n}\n.btn-circle-md {\n\twidth: 6rem;\n\theight: 6rem;\n\tfont-size: 2.5rem;\n}\n.btn-circle-md i {\n\tfont-size: 2.4rem;\n}\n.btn-circle-lg {\n\twidth: 8rem;\n\theight: 8rem;\n\tfont-size: 3.2rem;\n}\n.btn-circle-lg i {\n\tfont-size: 3.1rem;\n}\n\n.btn-page .btn {\n\tmin-width: 6.875rem;\n\tmargin-right: 0.25rem;\n\tmargin-bottom: 0.5rem;\n\toverflow: hidden;\n}\n\n.size-1 {\n\tmin-width: 10rem !important;\n\tfont-size: 1.5rem;\n\tpadding: 0.68rem 0.75rem;\n}\n\n.size-2 {\n\tfont-size: 1.25rem;\n\tmin-width: 8.125rem !important;\n\tpadding: 0.57rem 0.75rem;\n}\n\n.size-3 {\n\tfont-size: 0.875rem;\n\tmin-width: 6.875rem !important;\n\tpadding: 0.536rem 0.75rem;\n}\n\n.size-4 {\n\tfont-size: 0.875rem;\n\tmin-width: 6.25rem !important;\n}\n\n.size-5 {\n\tfont-size: 0.875rem;\n\tmin-width: 5.625rem !important;\n\tpadding: 0.22rem 0.75rem;\n}\n\n.size-6 {\n\tfont-size: 0.8125rem;\n\tmin-width: 5rem !important;\n\tpadding: 0.097rem 0.75rem;\n}\n\n.size-7 {\n\tfont-size: 0.75rem;\n\tmin-width: 3.75rem !important;\n\tpadding: 0.001rem 0.75rem;\n}\n\n.btn-light {\n\tbackground: #ebebf9;\n\tborder-color: #ebebf9;\n\tcolor: #303972;\n}\n.btn-light:active,\n.btn-light:focus,\n.btn-light:hover {\n\tbackground: #d7d7db;\n\tborder-color: #d7d7db;\n}\n.btn-light svg path {\n\tfill: var(--primary);\n}\n\n.btn-outline-primary:hover {\n\tcolor: #fff;\n}\n\n.btn-outline-warning:hover {\n\tcolor: #fff;\n}\n\n.btn-outline-danger:hover {\n\tcolor: #fff;\n}\n\n.btn-outline-success:hover {\n\tcolor: #fff;\n}\n\n.btn-outline-info:hover {\n\tcolor: #fff;\n}\n\n.btn-outline-light {\n\tcolor: #303972;\n}\n[data-theme-version='dark'] .btn-outline-light {\n\tcolor: #a098ae;\n}\n\n[data-theme-version='dark'] .btn-outline-secondary {\n\tcolor: #a098ae;\n}\n\n.btn-outline-secondary:hover {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .btn-outline-dark {\n\tcolor: #a098ae;\n}\n\n.btn-dark {\n\tbackground: #303972;\n\tborder-color: #303972;\n\tcolor: #fff;\n}\n.btn-dark:active,\n.btn-dark:focus,\n.btn-dark:hover {\n\tbackground: #21274e;\n\tcolor: #fff;\n\tborder-color: #21274e;\n}\n\n.btn-group.btn-rounded .btn:first-child {\n\tborder-top-left-radius: 1.875rem;\n\tborder-bottom-left-radius: 1.875rem;\n}\n\n.btn-group.btn-rounded .btn:last-child {\n\tborder-top-right-radius: 1.875rem;\n\tborder-bottom-right-radius: 1.875rem;\n}\n\n.btn-facebook {\n\tbackground: #3b5998;\n\tborder-color: #3b5998;\n\tcolor: #fff;\n}\n.btn-facebook:active,\n.btn-facebook:focus,\n.btn-facebook:hover {\n\tbackground: #2d4373;\n\tcolor: #fff;\n\tborder-color: #2d4373;\n}\n\n.btn-twitter {\n\tbackground: #1da1f2;\n\tborder-color: #1da1f2;\n\tcolor: #fff;\n}\n.btn-twitter:active,\n.btn-twitter:focus,\n.btn-twitter:hover {\n\tbackground: #0c85d0;\n\tcolor: #fff;\n\tborder-color: #0c85d0;\n}\n\n.btn-youtube {\n\tbackground: #ff0000;\n\tborder-color: #ff0000;\n\tcolor: #fff;\n}\n.btn-youtube:active,\n.btn-youtube:focus,\n.btn-youtube:hover {\n\tbackground: #cc0000;\n\tcolor: #fff;\n\tborder-color: #cc0000;\n}\n\n.btn-instagram {\n\tbackground: #c32aa3;\n\tborder-color: #c32aa3;\n\tcolor: #fff;\n}\n.btn-instagram:active,\n.btn-instagram:focus,\n.btn-instagram:hover {\n\tbackground: #992180;\n\tcolor: #fff;\n\tborder-color: #992180;\n}\n\n.btn-pinterest {\n\tbackground: #bd081c;\n\tborder-color: #bd081c;\n\tcolor: #fff;\n}\n.btn-pinterest:active,\n.btn-pinterest:focus,\n.btn-pinterest:hover {\n\tbackground: #8c0615;\n\tcolor: #fff;\n\tborder-color: #8c0615;\n}\n\n.btn-linkedin {\n\tbackground: #007bb6;\n\tborder-color: #007bb6;\n\tcolor: #fff;\n}\n.btn-linkedin:active,\n.btn-linkedin:focus,\n.btn-linkedin:hover {\n\tbackground: #005983;\n\tcolor: #fff;\n\tborder-color: #005983;\n}\n\n.btn-google-plus {\n\tbackground: #db4439;\n\tborder-color: #db4439;\n\tcolor: #fff;\n}\n.btn-google-plus:active,\n.btn-google-plus:focus,\n.btn-google-plus:hover {\n\tbackground: #be2d23;\n\tcolor: #fff;\n\tborder-color: #be2d23;\n}\n\n.btn-google {\n\tbackground: #4285f4;\n\tborder-color: #4285f4;\n\tcolor: #fff;\n}\n.btn-google:active,\n.btn-google:focus,\n.btn-google:hover {\n\tbackground: #1266f1;\n\tcolor: #fff;\n\tborder-color: #1266f1;\n}\n\n.btn-snapchat {\n\tbackground: #fffc00;\n\tborder-color: #fffc00;\n\tcolor: #000;\n}\n.btn-snapchat:active,\n.btn-snapchat:focus,\n.btn-snapchat:hover {\n\tbackground: #ccca00;\n\tcolor: #000;\n\tborder-color: #ccca00;\n}\n\n.btn-whatsapp {\n\tbackground: #25d366;\n\tborder-color: #25d366;\n\tcolor: #fff;\n}\n.btn-whatsapp:active,\n.btn-whatsapp:focus,\n.btn-whatsapp:hover {\n\tbackground: #1da851;\n\tcolor: #fff;\n\tborder-color: #1da851;\n}\n\n.btn-tumblr {\n\tbackground: #35465d;\n\tborder-color: #35465d;\n\tcolor: #fff;\n}\n.btn-tumblr:active,\n.btn-tumblr:focus,\n.btn-tumblr:hover {\n\tbackground: #222e3d;\n\tcolor: #fff;\n\tborder-color: #222e3d;\n}\n\n.btn-reddit {\n\tbackground: #ff4500;\n\tborder-color: #ff4500;\n\tcolor: #fff;\n}\n.btn-reddit:active,\n.btn-reddit:focus,\n.btn-reddit:hover {\n\tbackground: #cc3700;\n\tcolor: #fff;\n\tborder-color: #cc3700;\n}\n\n.btn-spotify {\n\tbackground: #1ed760;\n\tborder-color: #1ed760;\n\tcolor: #fff;\n}\n.btn-spotify:active,\n.btn-spotify:focus,\n.btn-spotify:hover {\n\tbackground: #18aa4c;\n\tcolor: #fff;\n\tborder-color: #18aa4c;\n}\n\n.btn-yahoo {\n\tbackground: #430297;\n\tborder-color: #430297;\n\tcolor: #fff;\n}\n.btn-yahoo:active,\n.btn-yahoo:focus,\n.btn-yahoo:hover {\n\tbackground: #2d0165;\n\tcolor: #fff;\n\tborder-color: #2d0165;\n}\n\n.btn-dribbble {\n\tbackground: #ea4c89;\n\tborder-color: #ea4c89;\n\tcolor: #fff;\n}\n.btn-dribbble:active,\n.btn-dribbble:focus,\n.btn-dribbble:hover {\n\tbackground: #e51e6b;\n\tcolor: #fff;\n\tborder-color: #e51e6b;\n}\n\n.btn-skype {\n\tbackground: #00aff0;\n\tborder-color: #00aff0;\n\tcolor: #fff;\n}\n.btn-skype:active,\n.btn-skype:focus,\n.btn-skype:hover {\n\tbackground: #008abd;\n\tcolor: #fff;\n\tborder-color: #008abd;\n}\n\n.btn-quora {\n\tbackground: #aa2200;\n\tborder-color: #aa2200;\n\tcolor: #fff;\n}\n.btn-quora:active,\n.btn-quora:focus,\n.btn-quora:hover {\n\tbackground: #771800;\n\tcolor: #fff;\n\tborder-color: #771800;\n}\n\n.btn-vimeo {\n\tbackground: #1ab7ea;\n\tborder-color: #1ab7ea;\n\tcolor: #fff;\n}\n.btn-vimeo:active,\n.btn-vimeo:focus,\n.btn-vimeo:hover {\n\tbackground: #1295bf;\n\tcolor: #fff;\n\tborder-color: #1295bf;\n}\n\n.btn-check:checked + .btn-outline-primary,\n.btn-check:active + .btn-outline-primary,\n.btn-outline-primary:active,\n.btn-outline-primary.active,\n.btn-outline-primary.dropdown-toggle.show {\n\tbackground-color: var(--primary);\n\tborder-color: var(--primary);\n\tcolor: #fff;\n}\n\n.btn-check:checked + .btn-outline-primary:focus,\n.btn-check:active + .btn-outline-primary:focus,\n.btn-outline-primary:active:focus,\n.btn-outline-primary.active:focus,\n.btn-outline-primary.dropdown-toggle.show:focus {\n\tbox-shadow: 0 0 0 0.25rem var(--rgba-primary-5);\n}\n\n.btn-check:focus + .btn-outline-primary,\n.btn-outline-primary:focus {\n\tbox-shadow: 0 0 0 0.25rem var(--rgba-primary-5);\n}\n\n.btn-close:focus {\n\tbox-shadow: 0 0 0 0.25rem var(--rgba-primary-5);\n}\n\n.btn.btn-pink {\n\tbackground-color: #eb62d0;\n\tcolor: #fff;\n}\n.btn.btn-pink:hover {\n\tbackground-color: rgba(235, 98, 208, 0.8);\n}\n\n.btn.light.btn-pink {\n\tbackground-color: rgba(235, 98, 208, 0.1);\n\tcolor: #eb62d0;\n}\n.btn.light.btn-pink:hover {\n\tbackground-color: #eb62d0;\n\tcolor: #fff;\n}\n\n.btn.light:hover svg path {\n\tfill: #fff;\n}\n\n.bg-success.light {\n\tbackground-color: rgba(30, 186, 98, 0.2) !important;\n}\n.bg-success.light svg path {\n\tfill: #1eba62;\n}\n.bg-success.light:hover {\n\tbackground-color: #1eba62 !important;\n}\n.bg-success.light:hover svg path {\n\tfill: #fff;\n}\n\n.bg-info.light {\n\tbackground-color: rgba(0, 173, 163, 0.2) !important;\n}\n.bg-info.light svg path {\n\tfill: #00ada3;\n}\n.bg-info.light:hover {\n\tbackground-color: #00ada3 !important;\n}\n.bg-info.light:hover svg path {\n\tfill: #fff;\n}\n\n.card {\n\tmargin-bottom: 1.875rem;\n\tbackground-color: #ffffff;\n\ttransition: all 0.5s ease-in-out;\n\tposition: relative;\n\tborder: 0rem solid transparent;\n\tborder-radius: 0.375rem;\n\theight: calc(100% - 30px);\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.card {\n\t\tmargin-bottom: 0.938rem;\n\t\theight: calc(100% - 0.938rem);\n\t}\n}\n.card-body {\n\tpadding: 1.875rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.card-body {\n\t\tpadding: 1rem;\n\t}\n}\n.card-title {\n\tfont-size: 1.125rem;\n\tfont-weight: 600;\n\tcolor: #303972;\n\ttext-transform: capitalize;\n}\n.card-title--large {\n\tfont-size: 1.5rem;\n}\n.card-title--medium {\n\tfont-size: 1rem;\n}\n.card-title--small {\n\tfont-size: 0.875rem;\n}\n.card-header {\n\tborder-color: #dddddd;\n\tposition: relative;\n\tbackground: transparent;\n\tpadding: 1.5rem 1.875rem 1.25rem;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tborder-radius: 0.375rem 0.375rem 0px 0px !important;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.card-header {\n\t\tpadding: 1.25rem 1rem 1.25rem;\n\t}\n}\n[data-theme-version='dark'] .card-header {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n.card-header .card-title {\n\tmargin-bottom: 0rem;\n}\n.card-header .subtitle {\n\tpadding-top: 0.3125rem;\n\tfont-size: 0.875rem;\n\tline-height: 1.5;\n}\n.card-footer {\n\tborder-color: #dddddd;\n\tbackground: transparent;\n\tpadding: 1.25rem 1.875rem 1.25rem;\n}\n[data-theme-version='dark'] .card-footer {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n.transparent-card.card {\n\tbackground: transparent;\n\tborder: 0.0625rem solid transparent;\n\tbox-shadow: none;\n}\n\n.card-action > a {\n\tdisplay: inline-block;\n\twidth: 1.875rem;\n\theight: 1.875rem;\n\tline-height: 1.875rem;\n\tborder-radius: 0.3125rem;\n\tborder-color: transparent;\n\ttext-align: center;\n\tbackground: var(--primary-dark);\n\tcolor: #fff;\n\tmargin-right: 0.5rem;\n}\n[data-theme-version='dark'] .card-action > a {\n\tbackground: #202020;\n}\n.card-action > a:last-child {\n\tmargin-right: 0;\n}\n.card-action > a:hover,\n.card-action > a:focus {\n\tbackground: var(--primary-dark);\n}\n[data-theme-version='dark'] .card-action > a:hover,\n[data-theme-version='dark'] .card-action > a:focus {\n\tbackground: #202020;\n}\n.card-action > a i,\n.card-action > a span {\n\tfont-size: 1rem;\n}\n\n.card-action .dropdown {\n\twidth: 1.875rem;\n\theight: 1.875rem;\n\tborder-radius: 0.3125rem;\n\tborder-color: transparent;\n\ttext-align: center;\n\tmargin-right: 0.5rem;\n\ttop: -0.125rem;\n\tposition: relative;\n\tdisplay: inline-block;\n\tbackground: var(--primary-dark);\n\tcolor: var(--primary);\n}\n[data-theme-version='dark'] .card-action .dropdown {\n\tbackground: #202020;\n}\n.card-action .dropdown:hover,\n.card-action .dropdown:focus {\n\tbackground: var(--primary-dark);\n}\n[data-theme-version='dark'] .card-action .dropdown:hover,\n[data-theme-version='dark'] .card-action .dropdown:focus {\n\tbackground: #202020;\n}\n.card-action .dropdown .btn {\n\tpadding: 0;\n\tline-height: 1.6875rem;\n\tcolor: #fff;\n}\n.card-action .dropdown .btn:focus {\n\tbox-shadow: none;\n}\n\n.card-fullscreen {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: 99999999;\n\toverflow: auto;\n}\n\n.card-loader {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tbackground-color: rgba(0, 0, 0, 0.75);\n\tz-index: 999;\n}\n\n.card-loader i {\n\tmargin: 0 auto;\n\tbackground: var(--primary-dark);\n\tpadding: 0.625rem;\n\tborder-radius: 50%;\n\tcolor: #fff;\n\tfont-size: 1rem;\n}\n\n.rotate-refresh {\n\t-webkit-animation: mymove 0.8s infinite linear;\n\tanimation: mymove 0.8s infinite linear;\n\tdisplay: inline-block;\n}\n\n.card-header .date_picker {\n\tdisplay: inline-block;\n\tpadding: 0.5rem;\n\tborder: 0.0625rem solid #dddddd;\n\tcursor: pointer;\n\tborder-radius: 0.375rem;\n}\n\n.card-header .border-0 {\n\tpadding-bottom: 0;\n}\n\n@-webkit-keyframes mymove {\n\t0% {\n\t\t-webkit-transform: rotate(0deg);\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\t-webkit-transform: rotate(360deg);\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n@keyframes mymove {\n\t0% {\n\t\t-webkit-transform: rotate(0deg);\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\t-webkit-transform: rotate(360deg);\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n.select2-container .select2-selection--single .select2-selection__clear {\n\tdisplay: none;\n}\n\n.carousel-custom-prev,\n.carousel-custom-next {\n\twidth: 2.5rem;\n\theight: 2.5rem;\n\tline-height: 2.5rem;\n\tdisplay: inline-block;\n\tborder-radius: 50%;\n\tbackground: #fff;\n\ttext-align: center;\n}\n.carousel-custom-prev i,\n.carousel-custom-next i {\n\tfont-size: 1rem;\n}\n.carousel-custom-prev:hover,\n.carousel-custom-next:hover {\n\tbackground: linear-gradient(to right, rgba(245, 60, 121, 0.99) 0%, rgba(246, 104, 47, 0.99) 100%);\n\tcolor: #fff;\n}\n\n.carousel-custom-next {\n\tposition: absolute;\n\ttop: 50%;\n\tright: 30px;\n\ttransform: translateY(-50%);\n}\n\n.carousel-custom-prev {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 30px;\n\ttransform: translateY(-50%);\n}\n\n.carousel-caption {\n\ttext-shadow: 2px 2px 4px rgba(0, 0, 0, 0.78);\n\tz-index: 1;\n\tbackground: rgba(0, 0, 0, 0.6);\n}\n.carousel-caption h5,\n.carousel-caption .h5 {\n\tcolor: #fff;\n\tfont-size: 1.8rem;\n}\n.carousel-caption p {\n\tmargin-bottom: 0;\n\tcolor: #fff;\n}\n\n.carousel-indicators {\n\tz-index: 1;\n}\n\n.dropdown-toggle:focus {\n\tbox-shadow: none !important;\n}\n\n.dropdown-outline {\n\tborder: 0.1rem solid var(--primary);\n}\n\n.dropdown-menu {\n\tfont-size: inherit;\n\tborder: 0;\n\tz-index: 8;\n\toverflow: hidden;\n\tborder-radius: 0.375rem;\n\tbox-shadow: 0 0 3.125rem 0 rgba(82, 63, 105, 0.15);\n\tmargin-top: 0;\n}\n.dropdown-menu .dropdown-item {\n\tfont-size: 1rem;\n\tcolor: #a098ae;\n\tpadding: 0.5rem 1.25rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.dropdown-menu .dropdown-item {\n\t\tpadding: 0.375rem 1rem;\n\t\tfont-size: 0.875rem;\n\t\tline-height: 1.5;\n\t}\n}\n.dropdown-menu .dropdown-item:hover,\n.dropdown-menu .dropdown-item:focus,\n.dropdown-menu .dropdown-item:active,\n.dropdown-menu .dropdown-item.active {\n\tcolor: #514e5f;\n}\n.dropdown-menu .dropdown-item.active,\n.dropdown-menu .dropdown-item:active {\n\tcolor: var(--primary);\n\tbackground: var(--rgba-primary-1);\n}\n[direction='rtl'] .dropdown-menu {\n\tright: auto !important;\n}\n.dropdown-menu.show {\n\tright: 0;\n\toverflow: unset !important;\n}\n\n.dropdown-toggle-split {\n\tpadding: 0 0.625rem;\n\topacity: 0.85;\n}\n.dropdown-toggle-split::after {\n\tdisplay: inline-block;\n\tmargin-left: 0.255em;\n\tvertical-align: 0.255em;\n\tcontent: '';\n\tborder-top: 0.3em solid;\n\tborder-right: 0.3em solid transparent;\n\tborder-bottom: 0;\n\tborder-left: 0.3em solid transparent;\n}\n.dropdown-toggle-split:after {\n\tmargin-left: 0 !important;\n}\n.dropdown-toggle-split:active,\n.dropdown-toggle-split:focus,\n.dropdown-toggle-split:hover {\n\topacity: 1;\n}\n\n/* .dropleft .dropdown-toggle:before,\n.dropright .dropdown-toggle:before,\n.dropup .dropdown-toggle:after,\n.dropdown-toggle:after {\n\tcontent:\"\\f107\";\n\tfont-family:FontAwesome;\n\tborder: 0;\n    vertical-align: middle;\n    margin-left: 0.25em;\n\tline-height: 1;\n} */\n/* .dropup .dropdown-toggle:after{\n\tcontent:\"\\f106\";\n} */\n/* .dropleft .dropdown-toggle::before {\n\tcontent:\"\\f104\";\n}\n.dropright .dropdown-toggle::before {\n\tcontent:\"\\f105\";\n} */\n.dropright .dropdown-toggle::after {\n\tcontent: none;\n}\n\n.custom-dropdown {\n\tdisplay: inline-block;\n}\n.custom-dropdown .dropdown-menu {\n\tborder: 0rem;\n\tmin-width: 10rem;\n}\n\n.card-action .custom-dropdown {\n\tmargin: 0rem;\n\tbackground: var(--rgba-primary-1);\n}\n.card-action .custom-dropdown.show,\n.card-action .custom-dropdown:focus,\n.card-action .custom-dropdown:hover {\n\tbackground: var(--primary);\n\tcolor: #fff;\n}\n.card-action .custom-dropdown i {\n\tdisplay: inline-block;\n\tpadding-top: 0.5625rem;\n}\n\n.dropdown .dropdown-dots {\n\tposition: relative;\n\theight: 0.3125rem;\n\twidth: 0.3125rem;\n\tbackground: rgba(48, 57, 114, 0.4);\n\tborder-radius: 0.3125rem;\n\tdisplay: block;\n}\n.dropdown .dropdown-dots:after,\n.dropdown .dropdown-dots:before {\n\tcontent: '';\n\theight: 0.3125rem;\n\twidth: 0.3125rem;\n\tbackground: rgba(48, 57, 114, 0.4);\n\tposition: absolute;\n\tborder-radius: 0.3125rem;\n}\n.dropdown .dropdown-dots:after {\n\tright: -0.5rem;\n}\n.dropdown .dropdown-dots:before {\n\tleft: -0.5rem;\n}\n.dropdown .dropdown-dots.text-white {\n\tbackground: rgba(255, 255, 255, 0.7);\n}\n.dropdown .dropdown-dots.text-white:after,\n.dropdown .dropdown-dots.text-white:before {\n\tbackground: rgba(255, 255, 255, 0.7);\n}\n\ndiv#bs-select-1 {\n\tmin-height: 6.875rem;\n}\n\n.dtp > .dtp-content > .dtp-date-view > header.dtp-header,\n.dtp div.dtp-date,\n.dtp div.dtp-time {\n\tbackground: var(--primary);\n}\n\n.dtp-date i {\n\tcolor: #fff;\n}\n\n.dtp-buttons .btn-flat:focus {\n\tbox-shadow: none;\n}\n\n.grid-col {\n\tpadding: 0.8rem !important;\n\tbackground: #e6ebee;\n\tborder-radius: 0.375rem;\n}\n\n.row.grid {\n\tmargin-bottom: 1.5rem;\n\ttext-align: center;\n}\n\n.row.grid .grid-col:first-child {\n\ttext-align: left;\n}\n\n.label {\n\tdisplay: inline-block;\n\ttext-align: center;\n\tfont-size: 0.75rem;\n\tpadding: 0.2rem 0.8rem;\n}\n.label-fixed {\n\twidth: 7.5rem;\n\tpadding: 0.6rem 0;\n}\n.label-fixed-lg {\n\twidth: 9.5rem;\n\tpadding: 0.6rem 0;\n}\n.label-big {\n\twidth: 16.8rem;\n\tfont-size: 1.4rem;\n\tpadding: 1.1rem 0;\n}\n.label-xl {\n\twidth: 10.5rem;\n\tpadding: 1.1rem 0;\n\tfont-size: 1.5rem;\n}\n.label-lg {\n\twidth: 9.5rem;\n\tpadding: 1.1rem 0;\n}\n.label-md {\n\twidth: 8.5rem;\n\tpadding: 1.1rem 0;\n}\n.label-sm {\n\twidth: 7.5rem;\n\tpadding: 1.1rem 0;\n}\n\n.label-default {\n\tbackground: #adb6c7;\n}\n\n.label-primary {\n\tbackground: var(--primary);\n\tcolor: #fff;\n}\n\n.label-secondary {\n\tbackground: #fb7d5b;\n\tcolor: #fff;\n}\n\n.label-info {\n\tbackground: #00ada3;\n\tcolor: #fff;\n}\n\n.label-success {\n\tbackground: #1eba62;\n\tcolor: #fff;\n}\n\n.label-warning {\n\tbackground: #fcc43e;\n\tcolor: #fff;\n}\n\n.label-danger {\n\tbackground: #fd5353;\n\tcolor: #fff;\n}\n\n.label-light {\n\tbackground: #ebebf9;\n\tcolor: #000;\n}\n\n.label-dark {\n\tbackground: #303972;\n\tcolor: #fff;\n}\n\ncode {\n\tword-break: break-word;\n\tpadding: 0.125rem 0.3125rem;\n\tborder-radius: 0.1875rem;\n\tbackground: #fff9f9;\n\tcolor: #fd5353;\n}\n[data-theme-version='dark'] code {\n\tbackground: rgba(253, 83, 83, 0.1);\n}\n\n.heading-labels {\n\tcolor: #333333;\n}\n.heading-labels > * {\n\tmargin-bottom: 0.8rem;\n}\n.heading-labels h1 .label,\n.heading-labels .h1 .label {\n\tfont-size: 1.125rem;\n\tfont-weight: normal;\n\tpadding: 0.4rem 0.9rem;\n}\n.heading-labels h2 .label,\n.heading-labels .h2 .label {\n\tfont-size: 1rem;\n\tfont-weight: normal;\n\tpadding: 0.3rem 0.9rem;\n}\n.heading-labels h3 .label,\n.heading-labels .h3 .label {\n\tfont-size: 0.875rem;\n\tfont-weight: normal;\n}\n.heading-labels h4 .label,\n.heading-labels .h4 .label {\n\tfont-size: 0.75rem;\n\tfont-weight: normal;\n}\n.heading-labels h5 .label,\n.heading-labels .h5 .label {\n\tfont-size: 0.75rem;\n\tfont-weight: normal;\n}\n.heading-labels h6 .label,\n.heading-labels .h6 .label {\n\tfont-size: 0.75rem;\n\tfont-weight: normal;\n}\n\n.card-content p code {\n\tmargin-left: 8px;\n}\n\n.list-group-item {\n\tbackground-color: rgba(255, 255, 255, 0);\n\tborder: 1px solid #dddddd;\n\tpadding: 1rem 1.5rem;\n\tcolor: #a098ae;\n}\n.list-group-item.active {\n\tbackground-color: var(--primary);\n\tborder-color: var(--primary);\n}\n[data-theme-version='dark'] .list-group-item {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n.list-group-item.disabled,\n.list-group-item:disabled {\n\tcolor: #fff;\n\tbackground-color: #fb7d5b;\n\tborder-color: #fb7d5b;\n}\n\n[class*='bg-'] .list-group-item {\n\tborder-color: rgba(255, 255, 255, 0.05);\n\tcolor: #fff;\n}\n\n.bg-warning .list-group-item {\n\tborder-color: rgba(0, 0, 0, 0.05);\n}\n\n.media img {\n\tborder-radius: 0.1875rem;\n}\n\n.vertical-card__menu:hover {\n\tbox-shadow: none;\n}\n\n.vertical-card__menu--image {\n\ttext-align: center;\n}\n.vertical-card__menu--image img {\n\twidth: 100%;\n\tborder-top-left-radius: 0.25rem;\n\tborder-top-right-radius: 0.25rem;\n}\n\n.vertical-card__menu--status.closed {\n\tbackground: #fd5353;\n}\n.vertical-card__menu--status.closed:after {\n\tborder-top: 0.625rem solid #fd5353;\n}\n.vertical-card__menu--status.closed .ribbon-curve {\n\tborder-top: 0.6875rem solid #fd5353;\n\tborder-bottom: 0.625rem solid #fd5353;\n}\n\n.vertical-card__menu--desc p {\n\tmargin-bottom: 0.625rem;\n}\n\n.vertical-card__menu--price {\n\tfont-size: 1.25rem;\n\tmargin: 0;\n\tfont-weight: 700;\n}\n\n.vertical-card__menu--rating {\n\tfont-size: 0.75rem;\n}\n\n.vertical-card__menu--title {\n\tfont-weight: 700;\n}\n\n.vertical-card__menu--button button {\n\tfont-size: 0.75rem;\n}\n\n.vertical-card__menu .card-footer {\n\tpadding: 0.9375rem 1.25rem;\n\tbackground-color: #f2f2f2;\n\tborder-top: none;\n}\n@media only screen and (min-width: 75rem) and (max-width: 90rem) {\n\t.vertical-card__menu .card-footer {\n\t\tpadding: 0.9375rem;\n\t}\n}\n.vertical-card__menu .card-footer span {\n\tcolor: #303972;\n\tmargin-right: 0.3125rem;\n}\n\n.horizontal-card__menu {\n\tbox-shadow: 0 0 0.4375rem rgba(173, 173, 173, 0.32);\n\tdisplay: flex;\n\tflex-direction: row;\n\tdisplay: block;\n}\n.horizontal-card__menu .card-body {\n\tpadding: 0;\n\tpadding: 1.25rem 1.875rem;\n}\n.horizontal-card__menu--image {\n\tflex-basis: 30%;\n\tmax-width: 30%;\n\tmax-width: unset;\n\tflex-basis: 100%;\n}\n.horizontal-card__menu--image img {\n\theight: 100%;\n\twidth: 100%;\n}\n.horizontal-card__menu--title {\n\tfont-size: 1rem;\n\tfont-weight: 700;\n\tmargin-bottom: 0.3125rem;\n}\n.horizontal-card__menu--fav {\n\tmargin-right: 0.5rem;\n}\n.horizontal-card__menu--price {\n\tmargin: 0;\n\tfont-size: 1rem;\n\tfont-weight: 700;\n}\n.horizontal-card__menu--rating {\n\tfont-size: 0.625rem;\n}\n.horizontal-card__menu--footer {\n\tmargin-top: 0.625rem;\n}\n\n.prev_price {\n\ttext-decoration: line-through;\n\tfont-size: 80%;\n\topacity: 0.5;\n}\n\n.modal-header {\n\tpadding: 1rem 1.875rem;\n}\n.modal-header .close {\n\tpadding: 0.875rem 1.815rem;\n\tmargin: 0;\n\tposition: absolute;\n\tright: 0;\n\tfloat: none;\n\ttop: 0;\n\tfont-size: 1.875rem;\n\tfont-weight: 100;\n}\n\n.modal-body {\n\tpadding: 1.875rem;\n}\n\n.modal-footer {\n\tpadding: 1rem 1.875rem;\n}\n\n.modal-content {\n\tborder-radius: 0.375rem;\n}\n\n.modal-backdrop {\n\tz-index: 10 !important;\n}\n\n.Modal-box {\n\tbackground-color: #fff;\n\theight: 300px;\n\tborder-radius: 8px;\n\toverflow: hidden;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.Modal-box {\n\t\tmargin-bottom: 0.875rem;\n\t}\n}\n.Modal-box .box1 {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 20px 25px;\n\tborder-bottom: 1px solid #3736ae30;\n}\n.Modal-box .box1 h3,\n.Modal-box .box1 .h3 {\n\tcolor: black;\n}\n.Modal-box .box1 i {\n\tfont-size: 20px;\n}\n.Modal-box .box2 {\n\tpadding: 10px 25px;\n\theight: 150px;\n}\n.Modal-box .box3 {\n\tpadding: 20px 25px;\n\ttext-align: end;\n\tbackground-color: #f4f4f5;\n\tborder-top: 1px solid #3736ae30;\n}\n.Modal-box .box3 .bt-1 {\n\tcolor: #f34e5f;\n\tbackground-color: #e9c7cd;\n\tpadding: 5px 15px;\n\tborder: 1px solid #e9c7cd;\n\tmargin-right: 5px;\n\tborder-radius: 6px;\n}\n.Modal-box .box3 .bt-2 {\n\tcolor: #fff;\n\tbackground-color: #3736ae;\n\tborder: 1px solid #3736ae;\n\tpadding: 5px 15px;\n\tborder-radius: 6px;\n}\n\n.pagination .page-item .page-link:hover {\n\tbackground: var(--primary);\n\tborder-color: var(--primary);\n\tcolor: #fff;\n}\n\n.pagination .page-item.active .page-link {\n\tbackground: var(--primary);\n\tborder-color: var(--primary);\n\tcolor: #fff;\n}\n\n.pagination {\n\tmargin-bottom: 1.25rem;\n}\n.pagination .page-item.page-indicator .page-link {\n\tpadding: 0.69rem 0.8rem;\n\tfont-size: 1.2rem;\n\tborder-top-left-radius: unset;\n\tborder-bottom-left-radius: unset;\n\tborder-radius: 0.375rem;\n}\n.pagination .page-item.page-indicator:hover .page-link {\n\tcolor: #303972;\n}\n.pagination .page-item .page-link {\n\tz-index: 1;\n\tpadding: 0;\n\twidth: 2.5rem;\n\theight: 2.5rem;\n\tborder-radius: 0.625rem;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tfont-size: 1rem;\n\tbackground: rgba(255, 255, 255, 0.15);\n\tcolor: #303972;\n\tmargin-left: 7px;\n\tborder: 0.0625rem solid #dddddd;\n}\n[data-theme-version='dark'] .pagination .page-item .page-link {\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #7e8dbf;\n\tbackground: rgba(255, 255, 255, 0);\n}\n.pagination .page-item .page-link:hover i,\n.pagination .page-item .page-link span {\n\tcolor: #fff;\n}\n.pagination .page-item .page-link:focus {\n\toutline: 0;\n\tbox-shadow: none;\n}\n.pagination .page-item .page-link:hover {\n\tbackground: var(--primary);\n\tcolor: #fff;\n\tborder-color: var(--primary);\n}\n.pagination .page-item.active .page-link {\n\tbackground-color: var(--primary);\n\tborder-color: var(--primary);\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .pagination .page-item.active .page-link {\n\tcolor: #fff;\n}\n.pagination .page-item .page-link {\n\tcolor: #303972;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n}\n.pagination .page-item:last-child .page-link {\n\tmargin-right: 0;\n}\n[direction='rtl'] .pagination .page-item:first-child .page-link {\n\tmargin-right: 0;\n}\n.pagination.no-bg li:not(.page-indicator):not(.active) .page-link {\n\tbackground: #fff;\n\tborder-color: transparent;\n}\n.pagination.no-bg.pagination-primary li:not(.page-indicator):not(.active):hover .page-link {\n\tbackground: var(--primary);\n\tborder-color: var(--primary);\n}\n[data-theme-version='dark'] .pagination.no-bg.pagination-primary li:not(.page-indicator):not(.active):hover .page-link {\n\tbackground: var(--primary);\n\tborder-color: var(--primary);\n}\n.pagination.no-bg.pagination-danger li:not(.page-indicator):not(.active):hover .page-link {\n\tbackground: #fd5353;\n\tborder-color: #fd5353;\n}\n[data-theme-version='dark'] .pagination.no-bg.pagination-danger li:not(.page-indicator):not(.active):hover .page-link {\n\tbackground: #fd5353;\n\tborder-color: #fd5353;\n}\n.pagination.no-bg.pagination-info li:not(.page-indicator):not(.active):hover .page-link {\n\tbackground: #00ada3;\n\tborder-color: #00ada3;\n}\n[data-theme-version='dark'] .pagination.no-bg.pagination-info li:not(.page-indicator):not(.active):hover .page-link {\n\tbackground: #00ada3;\n\tborder-color: #00ada3;\n}\n.pagination.no-bg.pagination-warning li:not(.page-indicator):not(.active):hover .page-link {\n\tbackground: #fcc43e;\n\tborder-color: #fcc43e;\n}\n[data-theme-version='dark'] .pagination.no-bg.pagination-warning li:not(.page-indicator):not(.active):hover .page-link {\n\tbackground: #fcc43e;\n\tborder-color: #fcc43e;\n}\n.pagination-primary .page-item .page-link {\n\tbackground: var(--rgba-primary-1);\n\tborder-color: var(--rgba-primary-1);\n\tcolor: #303972;\n}\n[data-theme-version='dark'] .pagination-primary .page-item .page-link {\n\tbackground: var(--rgba-primary-1);\n\tborder-color: transparent;\n\tcolor: var(--primary);\n}\n.pagination-primary .page-item:hover .page-link,\n.pagination-primary .page-item.active .page-link {\n\tbackground: var(--primary);\n\tborder-color: var(--primary);\n}\n[data-theme-version='dark'] .pagination-primary .page-item:hover .page-link,\n[data-theme-version='dark'] .pagination-primary .page-item.active .page-link {\n\tcolor: #fff;\n}\n.pagination-danger .page-item .page-link {\n\tbackground: #ffeaea;\n\tborder-color: #ffeaea;\n\tcolor: #fd5353;\n}\n[data-theme-version='dark'] .pagination-danger .page-item .page-link {\n\tbackground: rgba(253, 83, 83, 0.15);\n\tborder-color: transparent;\n\tcolor: #fd5353;\n}\n.pagination-danger .page-item:hover .page-link,\n.pagination-danger .page-item.active .page-link {\n\tbackground: #fd5353;\n\tborder-color: #fd5353;\n\tbox-shadow: 0 0.625rem 1.25rem 0rem rgba(253, 83, 83, 0.2);\n}\n[data-theme-version='dark'] .pagination-danger .page-item:hover .page-link,\n[data-theme-version='dark'] .pagination-danger .page-item.active .page-link {\n\tcolor: #fff;\n}\n.pagination-info .page-item .page-link {\n\tbackground: #94fff9;\n\tborder-color: #94fff9;\n\tcolor: #00ada3;\n}\n[data-theme-version='dark'] .pagination-info .page-item .page-link {\n\tbackground: rgba(0, 173, 163, 0.1);\n\tborder-color: transparent;\n\tcolor: #00ada3;\n}\n.pagination-info .page-item:hover .page-link,\n.pagination-info .page-item.active .page-link {\n\tbackground: #00ada3;\n\tborder-color: #00ada3;\n\tbox-shadow: 0 0.625rem 1.25rem 0rem rgba(0, 173, 163, 0.2);\n}\n.pagination-warning .page-item .page-link {\n\tbackground: #fffaee;\n\tborder-color: #fffaee;\n\tcolor: #fcc43e;\n}\n[data-theme-version='dark'] .pagination-warning .page-item .page-link {\n\tbackground: rgba(252, 196, 62, 0.1);\n\tborder-color: transparent;\n\tcolor: #fcc43e;\n}\n.pagination-warning .page-item:hover .page-link,\n.pagination-warning .page-item.active .page-link {\n\tbackground: #fcc43e;\n\tborder-color: #fcc43e;\n\tbox-shadow: 0 0.625rem 1.25rem 0rem rgba(252, 196, 62, 0.2);\n}\n.pagination-gutter .page-item {\n\tmargin-right: 0.4375rem;\n}\n.pagination-gutter .page-item .page-link {\n\tborder-radius: 0.375rem !important;\n}\n.pagination-circle .page-item {\n\tmargin-right: 0.4375rem;\n}\n.pagination-circle .page-item .page-link,\n.pagination-circle .page-item .page-link {\n\twidth: 2.5rem;\n\theight: 2.5rem;\n\tpadding: 0;\n\tline-height: 2.5rem;\n\tborder-radius: 50% !important;\n\tpadding: 0;\n}\n.pagination-circle .page-item.page-indicator .page-link {\n\twidth: 2.5rem;\n\tborder: 1px solid var(--primary);\n\tborder-radius: 22px !important;\n\tline-height: 1.3rem;\n\theight: 2.5rem;\n\tbackground: var(--rgba-primary-1);\n\tcolor: var(--primary);\n}\n.pagination-circle .page-item.page-indicator .page-link:hover {\n\tcolor: #fff;\n\tbackground: var(--primary);\n}\n.pagination.pagination-md .page-item .page-link {\n\twidth: 1.875rem;\n\theight: 1.875rem;\n\tline-height: 1.875rem;\n\tfont-size: 0.875rem;\n}\n.pagination.pagination-sm .page-item.page-indicator .page-link {\n\tfont-size: 0.75rem;\n}\n.pagination.pagination-sm .page-item .page-link {\n\tpadding: 0;\n\twidth: 2.5rem;\n\theight: 2.5rem;\n\tline-height: 2.5rem;\n\tfont-size: 1.125rem;\n}\n.pagination.pagination-xs .page-item.page-indicator .page-link {\n\tfont-size: 0.625rem;\n}\n.pagination.pagination-xs .page-item .page-link {\n\tpadding: 0;\n\twidth: 1.5625rem;\n\theight: 1.5625rem;\n\tline-height: 1.5625rem;\n\tfont-size: 0.75rem;\n}\n\n.popover {\n\tborder: 0.125rem solid #fb7d5b;\n\tmin-width: 13.125rem;\n\tbox-shadow: 0 0 1.875rem 0 rgba(0, 0, 0, 0.1);\n\tborder-radius: 0.375rem;\n}\n[data-theme-version='dark'] .popover {\n\tbackground-color: #202020;\n}\n.popover-header {\n\tbackground: #fb7d5b;\n\tcolor: #fff;\n\tfont-weight: 300;\n}\n.popover-header::before {\n\tborder-bottom: 0 !important;\n}\n.popover-body {\n\tfont-size: 0.75rem;\n}\n.popover .popover-header {\n\tborder-radius: 3.5px 3.5px 0px 0px;\n}\n[data-theme-version='dark'] .popover .popover-header {\n\tborder-color: #272738;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.popover {\n\t\tz-index: 1;\n\t}\n}\n\n.bootstrap-popover-wrapper .bootstrap-popover:not(:last-child) {\n\tmargin-right: 0.5rem;\n}\n\n.bootstrap-popover-wrapper .bootstrap-popover {\n\tmargin-bottom: 0.5rem;\n}\n.bootstrap-popover-wrapper .bootstrap-popover button:hover,\n.bootstrap-popover-wrapper .bootstrap-popover button:focus {\n\tbackground: var(--primary);\n\tcolor: #fff;\n\tbox-shadow: none;\n}\n\n.bs-popover-top .arrow::after,\n.bs-popover-auto[data-popper-placement^='top'] .arrow::after,\n.bs-popover-auto[x-placement^='top'] .arrow::after {\n\tbottom: 0rem;\n\tborder-top-color: #fb7d5b;\n}\n\n.bs-popover-left .arrow::after,\n.bs-popover-auto[x-placement^='left'] .arrow::after {\n\tright: 0rem;\n\tborder-left-color: #fb7d5b;\n}\n\n.bs-popover-right .arrow::after,\n.bs-popover-auto[x-placement^='right'] .arrow::after {\n\tleft: 0rem;\n\tborder-right-color: #fb7d5b;\n}\n\n.bs-popover-bottom .arrow::after,\n.bs-popover-auto[data-popper-placement^='bottom'] .arrow::after,\n.bs-popover-auto[x-placement^='bottom'] .arrow::after {\n\ttop: 0rem;\n\tborder-bottom-color: #fb7d5b;\n}\n\n.note-popover {\n\tdisplay: none;\n}\n\n.progress-bar {\n\tbackground-color: var(--primary);\n}\n\n.progress-bar-primary {\n\tbackground-color: var(--primary);\n}\n\n.progress-bar-success {\n\tbackground-color: #1eba62;\n}\n\n.progress-bar-info {\n\tbackground-color: #00ada3;\n}\n\n.progress-bar-danger {\n\tbackground-color: #fd5353;\n}\n\n.progress-bar-warning {\n\tbackground-color: #fcc43e;\n}\n\n.progress-bar-pink {\n\tbackground-color: #eb62d0;\n}\n\n.progress {\n\theight: 0.688rem;\n\tbackground-color: #f2f2f2;\n\toverflow: hidden;\n}\n[data-theme-version='dark'] .progress {\n\tbackground-color: #202020;\n}\n.progress-bar {\n\tborder-radius: 0.375rem;\n}\n\n.progress-vertical {\n\tdisplay: inline-block;\n\tmargin-bottom: 0;\n\tmargin-right: 2rem;\n\tmin-height: 17rem;\n\tposition: relative;\n}\n@media (max-width: 767.98px) {\n\t.progress-vertical {\n\t\tmargin-right: 1rem;\n\t}\n}\n\n.progress-vertical-bottom {\n\tdisplay: inline-block;\n\tmargin-bottom: 0;\n\tmargin-right: 2rem;\n\tmin-height: 17rem;\n\tposition: relative;\n\ttransform: rotate(180deg);\n}\n@media (max-width: 767.98px) {\n\t.progress-vertical-bottom {\n\t\tmargin-right: 1rem;\n\t}\n}\n\n.progress-animated {\n\tanimation-duration: 5s;\n\tanimation-name: myanimation;\n\ttransition: all 5s ease 0s;\n}\n\n@keyframes myanimation {\n\t0% {\n\t\twidth: 0;\n\t}\n}\n\n@keyframes myanimation {\n\t0% {\n\t\twidth: 0;\n\t}\n}\n\n.ribbon {\n\tposition: absolute;\n\tz-index: 1;\n\ttext-transform: uppercase;\n}\n.ribbon__one {\n\ttop: 0.9375rem;\n\tleft: -0.6875rem;\n\tmin-height: 1.25rem;\n\tmin-width: 3.25rem;\n\ttext-align: center;\n\tpadding: 0.1875rem 0.625rem;\n\tbackground: #3ab54b;\n\tcolor: #fff;\n\tfont-size: 0.625rem;\n}\n.ribbon__one::after {\n\tposition: absolute;\n\twidth: 0;\n\theight: 0;\n\tborder-top: 0.625rem solid #239132;\n\tborder-left: 0.6875rem solid transparent;\n\tleft: 0;\n\tcontent: '';\n\tbottom: -0.625rem;\n}\n.ribbon__two {\n\twidth: 3.125rem;\n\theight: 3.125rem;\n\tdisplay: inline-block;\n\tbackground: #fcc43e;\n\tline-height: 3.125rem;\n\ttext-align: center;\n\tfont-size: 1rem;\n\tcolor: #fff;\n\tright: 0.9375rem;\n\ttop: 0.9375rem;\n\tborder-radius: 0.1875rem;\n}\n.ribbon__three {\n\tleft: -1.875rem;\n\ttop: 0.875rem;\n\twidth: 6.875rem;\n\theight: 1.5625rem;\n\tbackground-color: #fd5353;\n\tclip-path: polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);\n\ttransform: rotate(-45deg);\n\tcolor: #fff;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 0.875rem;\n}\n.ribbon__four {\n\tleft: 0.5rem;\n\ttop: -0.5rem;\n\twidth: 6.875rem;\n\theight: 3.125rem;\n\tbackground-color: var(--primary);\n\tz-index: auto;\n\tcolor: #fff;\n\tfont-size: 1rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.ribbon__four:after {\n\tright: -0.3125rem;\n}\n.ribbon__four:before {\n\tleft: -0.3125rem;\n}\n.ribbon__four:after,\n.ribbon__four:before {\n\tz-index: -1;\n\tbackground-color: var(--rgba-primary-1);\n\ttop: 0.1875rem;\n\ttransform: rotate(45deg);\n\tcontent: '';\n\theight: 0.625rem;\n\twidth: 0.625rem;\n\tposition: absolute;\n}\n.ribbon__five {\n\tleft: -1.875rem;\n\ttop: 0.625rem;\n\twidth: 6.875rem;\n\theight: 1.875rem;\n\tbackground-color: var(--primary);\n\ttransform: rotate(-45deg);\n\tfont-size: 0.75rem;\n\tcolor: #fff;\n\tpadding-bottom: 0.3125rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 1rem;\n}\n.ribbon__five::before {\n\tposition: absolute;\n\tcontent: '';\n\twidth: 0;\n\theight: 0;\n\tborder-style: solid;\n\tborder-width: 0 3.125rem 3.125rem 3.125rem;\n\tborder-color: transparent transparent var(--primary) transparent;\n\tleft: 0.25rem;\n\ttop: -2.8125rem;\n}\n.ribbon__six {\n\tleft: 0;\n\ttop: 1.125rem;\n\twidth: 6.875rem;\n\theight: 2.375rem;\n\tbackground-color: var(--primary);\n\t-webkit-clip-path: polygon(0 0, 100% 0%, 100% 0, 85% 50%, 100% 100%, 100% 100%, 0 100%);\n\tclip-path: polygon(0 0, 100% 0%, 100% 0, 85% 50%, 100% 100%, 100% 100%, 0 100%);\n\tdisplay: flex;\n\tfont-size: 1.25rem;\n\talign-items: center;\n\tjustify-content: center;\n\tcolor: #fff;\n}\n.ribbon-curve {\n\tposition: absolute;\n\ttop: 0;\n\tright: -0.375rem;\n\twidth: 0.625rem;\n\theight: 0.6875rem;\n\tborder-top: 0.6875rem solid #3ab54b;\n\tborder-bottom: 0.625rem solid #3ab54b;\n\tborder-right: 0.3125rem solid transparent;\n}\n\n.jsgrid-grid-body::-webkit-scrollbar,\n.dataTables_scrollBody::-webkit-scrollbar,\n.table-responsive::-webkit-scrollbar {\n\tbackground-color: #f5f5f5;\n\twidth: 0.5rem;\n\theight: 0.5rem;\n}\n\n.jsgrid-grid-body::-webkit-scrollbar-track,\n.dataTables_scrollBody::-webkit-scrollbar-track,\n.table-responsive::-webkit-scrollbar-track {\n\t-webkit-box-shadow: inset 0 0 0.375rem rgba(0, 0, 0, 0.3);\n\tborder-radius: 0.625rem;\n\tbackground-color: #f5f5f5;\n}\n\n.jsgrid-grid-body::-webkit-scrollbar-thumb,\n.dataTables_scrollBody::-webkit-scrollbar-thumb,\n.table-responsive::-webkit-scrollbar-thumb {\n\tborder-radius: 0.625rem;\n\t-webkit-box-shadow: inset 0 0 0.375rem rgba(0, 0, 0, 0.3);\n\tbackground-color: var(--primary);\n}\n\n.multi-steps > li.is-active:before,\n.multi-steps > li.is-active ~ li:before {\n\tcontent: counter(stepNum);\n\tfont-family: inherit;\n\tfont-weight: 400;\n}\n\n.multi-steps > li.is-active:after,\n.multi-steps > li.is-active ~ li:after {\n\tbackground-color: #f2f2f2;\n}\n\n.multi-steps {\n\tdisplay: table;\n\ttable-layout: fixed;\n\twidth: 100%;\n}\n.multi-steps > li {\n\tcounter-increment: stepNum;\n\ttext-align: center;\n\tdisplay: table-cell;\n\tposition: relative;\n\tcolor: var(--primary);\n\tfont-size: 0.75rem;\n}\n.multi-steps > li:before {\n\tcontent: '\\2713';\n\tdisplay: block;\n\tmargin: 0 auto 0.25rem;\n\tbackground-color: #fff;\n\twidth: 1.5625rem;\n\theight: 1.5625rem;\n\tline-height: 1.375rem;\n\ttext-align: center;\n\tfont-weight: bold;\n\tposition: relative;\n\tz-index: 1;\n\twidth: 1.5625rem;\n\theight: 1.5625rem;\n\tline-height: 1.3125rem;\n\tborder-width: 0.125rem;\n\tborder-style: solid;\n\tborder-color: var(--primary);\n\tborder-radius: 0.3125rem;\n}\n.multi-steps > li:after {\n\tcontent: '';\n\theight: 0.125rem;\n\twidth: 100%;\n\tbackground-color: var(--primary);\n\tposition: absolute;\n\ttop: 0.75rem;\n\tleft: 50%;\n\ttop: 0.75rem;\n}\n[direction='rtl'] .multi-steps > li:after {\n\tleft: auto;\n\tright: 50%;\n}\n.multi-steps > li:last-child:after {\n\tdisplay: none;\n}\n.multi-steps > li.is-active:before {\n\tbackground-color: #fff;\n\tborder-color: var(--primary);\n}\n.multi-steps > li.is-active ~ li {\n\tcolor: #a098ae;\n}\n.multi-steps > li.is-active ~ li:before {\n\tbackground-color: #f2f2f2;\n\tborder-color: #f2f2f2;\n}\n\n.nav-pills .nav-link {\n\tborder-radius: 6px;\n\tpadding: 0.5rem 1rem;\n\tfont-size: 14px;\n\tfont-weight: 500;\n\tcolor: #5b5e81;\n\ttext-transform: capitalize;\n\tbox-shadow: none;\n}\n[data-theme-version='dark'] .nav-pills .nav-link {\n\tcolor: #7e8dbf;\n}\n.nav-pills .nav-link:hover {\n\tcolor: var(--primary);\n}\n\n.default-tab .nav-link {\n\tbackground: transparent;\n\tborder-radius: 0rem;\n\tfont-weight: 500;\n}\n.default-tab .nav-link i {\n\tdisplay: inline-block;\n\ttransform: scale(1.5);\n\tcolor: #5b5e81;\n}\n.default-tab .nav-link:focus,\n.default-tab .nav-link:hover,\n.default-tab .nav-link.active {\n\tcolor: #495057;\n\tbackground-color: #fff;\n\tborder-color: #dee2e6 #dee2e6 #fff #ebeef6;\n\tborder-radius: 0.375rem 0.375rem 0 0;\n\tcolor: var(--primary);\n}\n[data-theme-version='dark'] .default-tab .nav-link:focus,\n[data-theme-version='dark'] .default-tab .nav-link:hover,\n[data-theme-version='dark'] .default-tab .nav-link.active {\n\tbackground-color: var(--rgba-primary-1);\n\tborder-color: transparent transparent rgba(255, 255, 255, 0.1) transparent;\n}\n\n.custom-tab-1 .nav-link {\n\tbackground: transparent;\n\tborder-radius: 0rem;\n\tfont-weight: 500;\n\tborder-bottom: 0.1875rem solid transparent;\n\tborder-width: 0 0rem 0.1875rem 0;\n}\n.custom-tab-1 .nav-link i {\n\tdisplay: inline-block;\n\ttransform: scale(1.5);\n\tcolor: var(--primary);\n}\n.custom-tab-1 .nav-link:focus,\n.custom-tab-1 .nav-link:hover,\n.custom-tab-1 .nav-link.active {\n\tcolor: #495057;\n\tbackground-color: #fff;\n\tborder-color: var(--primary);\n\tborder-radius: 0;\n\tcolor: var(--primary);\n\tborder-width: 0 0rem 0.1875rem 0;\n}\n[data-theme-version='dark'] .custom-tab-1 .nav-link:focus,\n[data-theme-version='dark'] .custom-tab-1 .nav-link:hover,\n[data-theme-version='dark'] .custom-tab-1 .nav-link.active {\n\tbackground-color: var(--rgba-primary-1);\n}\n\n.nav-pills.light .nav-link.active,\n.nav-pills.light .show > .nav-link {\n\tbackground: var(--rgba-primary-1);\n\tcolor: var(--primary);\n\tbox-shadow: none;\n}\n[data-theme-version='dark'] .nav-pills.light .nav-link.active,\n[data-theme-version='dark'] .nav-pills.light .show > .nav-link {\n\tbackground: var(--rgba-primary-1);\n}\n\n.nav-pills .nav-link.active,\n.nav-pills:hover .show > .nav-link {\n\tbackground-color: var(--rgba-primary-1);\n\tcolor: var(--primary);\n}\n\n.tooltip-wrapper button:not(:last-child) {\n\tmargin-right: 0.5rem;\n}\n\n.tooltip-wrapper button:hover {\n\tbackground: var(--primary);\n\tcolor: #fff;\n}\n\n.tooltip-wrapper button {\n\tmargin-bottom: 0.5rem;\n}\n.tooltip-wrapper button:focus {\n\tbox-shadow: none;\n}\n\n.tooltip-inner {\n\tborder-radius: 0;\n\tbackground: #333333;\n\tfont-size: 0.75rem;\n\tfont-weight: 300;\n\tpadding: 0.35rem 0.7rem;\n}\n\n.bs-tooltip-bottom .arrow::before,\n.bs-tooltip-auto[data-popper-placement^='bottom'] .arrow::before,\n.bs-tooltip-auto[x-placement^='bottom'] .arrow::before {\n\tborder-bottom-color: #333333;\n}\n\n.bs-tooltip-right .arrow::before,\n.bs-tooltip-auto[x-placement^='right'] .arrow::before {\n\tborder-right-color: #333333;\n}\n\n.bs-tooltip-left .arrow::before,\n.bs-tooltip-auto[x-placement^='left'] .arrow::before {\n\tborder-left-color: #333333;\n}\n\n.bs-tooltip-top .arrow::before,\n.bs-tooltip-auto[data-popper-placement^='top'] .arrow::before,\n.bs-tooltip-auto[x-placement^='top'] .arrow::before {\n\tborder-top-color: #333333;\n}\n\n.widget-timeline .timeline {\n\tlist-style: none;\n\tposition: relative;\n}\n.widget-timeline .timeline:before {\n\ttop: 1.25rem;\n\tbottom: 0;\n\tposition: absolute;\n\tcontent: ' ';\n\twidth: 0.1875rem;\n\tleft: 0.5625rem;\n\tmargin-right: -0.0938rem;\n\tbackground: #e6ebee;\n}\n[data-theme-version='dark'] .widget-timeline .timeline:before {\n\tbackground: rgba(255, 255, 255, 0.1);\n}\n[direction='rtl'] .widget-timeline .timeline:before {\n\tleft: auto;\n\tright: 0.5625rem;\n\tmargin-right: auto;\n\tmargin-left: -0.0938rem;\n}\n.widget-timeline .timeline > li {\n\tmargin-bottom: 0.9375rem;\n\tposition: relative;\n}\n.widget-timeline .timeline > li:before {\n\tcontent: ' ';\n\tdisplay: table;\n}\n.widget-timeline .timeline > li:after {\n\tcontent: ' ';\n\tdisplay: table;\n\tclear: both;\n}\n.widget-timeline .timeline > li > .timeline-panel {\n\tborder-radius: 0.375rem;\n\tpadding: 0.9375rem 1.25rem;\n\tposition: relative;\n\tdisplay: block;\n\tmargin-left: 2.5rem;\n\tborder-width: 0.0625rem;\n\tborder-style: solid;\n}\n.widget-timeline .timeline > li > .timeline-panel span {\n\tfont-size: 0.75rem;\n\tdisplay: block;\n\tmargin-bottom: 0.3125rem;\n\tletter-spacing: 0.0625rem;\n}\n.widget-timeline .timeline > li > .timeline-panel p {\n\tfont-size: 0.875rem;\n}\n.widget-timeline .timeline > li > .timeline-panel:after {\n\tcontent: '';\n\twidth: 0.625rem;\n\theight: 0.625rem;\n\tbackground: inherit;\n\tborder-color: inherit;\n\tborder-style: solid;\n\tborder-width: 0rem 0rem 0.0625rem 0.0625rem;\n\tdisplay: block;\n\tposition: absolute;\n\tleft: -0.3125rem;\n\ttransform: rotate(45deg);\n\ttop: 0.9375rem;\n}\n.widget-timeline .timeline > li > .timeline-badge {\n\tborder-radius: 50%;\n\theight: 1.375rem;\n\tleft: 0;\n\tposition: absolute;\n\ttop: 0.625rem;\n\twidth: 1.375rem;\n\tborder-width: 0.125rem;\n\tborder-style: solid;\n\tbackground: #fff;\n\tpadding: 0.25rem;\n}\n[data-theme-version='dark'] .widget-timeline .timeline > li > .timeline-badge {\n\tbackground-color: #272738;\n}\n.widget-timeline .timeline > li > .timeline-badge:after {\n\tcontent: '';\n\twidth: 0.625rem;\n\theight: 0.625rem;\n\tborder-radius: 100%;\n\tdisplay: block;\n}\n[direction='rtl'] .widget-timeline .timeline > li > .timeline-badge {\n\tleft: auto;\n\tright: 1.1875rem;\n}\n\n.widget-timeline .timeline-body > p {\n\tfont-size: 0.75rem;\n}\n\n.widget-timeline .timeline-badge.primary {\n\tborder-color: var(--rgba-primary-1);\n}\n[data-theme-version='dark'] .widget-timeline .timeline-badge.primary {\n\tborder-color: var(--rgba-primary-1);\n}\n.widget-timeline .timeline-badge.primary:after {\n\tbackground-color: var(--primary);\n\tbox-shadow: 0 0.3125rem 0.625rem 0 var(--rgba-primary-2);\n}\n.widget-timeline .timeline-badge.primary + .timeline-panel {\n\tbackground: var(--rgba-primary-1);\n\tborder-color: var(--rgba-primary-1);\n}\n[data-theme-version='dark'] .widget-timeline .timeline-badge.primary + .timeline-panel {\n\tborder-color: transparent;\n\tbackground-color: var(--rgba-primary-1);\n}\n\n.widget-timeline .timeline-badge.success {\n\tborder-color: #ddfaea;\n}\n[data-theme-version='dark'] .widget-timeline .timeline-badge.success {\n\tborder-color: rgba(30, 186, 98, 0.1);\n}\n.widget-timeline .timeline-badge.success:after {\n\tbackground-color: #1eba62 !important;\n\tbox-shadow: 0 0.3125rem 0.625rem 0 rgba(30, 186, 98, 0.2);\n}\n.widget-timeline .timeline-badge.success + .timeline-panel {\n\tbackground: #ddfaea;\n\tborder-color: #ddfaea;\n}\n[data-theme-version='dark'] .widget-timeline .timeline-badge.success + .timeline-panel {\n\tbackground-color: rgba(30, 186, 98, 0.1);\n\tborder-color: transparent;\n}\n\n.widget-timeline .timeline-badge.warning {\n\tborder-color: #fffaee;\n}\n[data-theme-version='dark'] .widget-timeline .timeline-badge.warning {\n\tborder-color: rgba(252, 196, 62, 0.1);\n}\n.widget-timeline .timeline-badge.warning:after {\n\tbackground-color: #fcc43e !important;\n\tbox-shadow: 0 0.3125rem 0.625rem 0 rgba(252, 196, 62, 0.2);\n}\n.widget-timeline .timeline-badge.warning + .timeline-panel {\n\tbackground: #fffaee;\n\tborder-color: #fffaee;\n}\n[data-theme-version='dark'] .widget-timeline .timeline-badge.warning + .timeline-panel {\n\tbackground-color: rgba(252, 196, 62, 0.1);\n\tborder-color: transparent;\n}\n\n.widget-timeline .timeline-badge.danger {\n\tborder-color: #ffeaea;\n}\n[data-theme-version='dark'] .widget-timeline .timeline-badge.danger {\n\tborder-color: rgba(253, 83, 83, 0.15);\n}\n.widget-timeline .timeline-badge.danger:after {\n\tbackground-color: #fd5353 !important;\n\tbox-shadow: 0 0.3125rem 0.625rem 0 rgba(253, 83, 83, 0.2);\n}\n.widget-timeline .timeline-badge.danger + .timeline-panel {\n\tbackground: #ffeaea;\n\tborder-color: #ffeaea;\n}\n[data-theme-version='dark'] .widget-timeline .timeline-badge.danger + .timeline-panel {\n\tbackground-color: rgba(253, 83, 83, 0.15);\n\tborder-color: transparent;\n}\n\n.widget-timeline .timeline-badge.info {\n\tborder-color: var(--rgba-secondary-1);\n}\n[data-theme-version='dark'] .widget-timeline .timeline-badge.info {\n\tborder-color: var(--rgba-secondary-1);\n}\n.widget-timeline .timeline-badge.info:after {\n\tbackground-color: var(--secondary) !important;\n\tbox-shadow: 0 0.3125rem 0.625rem 0 rgba(0, 173, 163, 0.2);\n}\n.widget-timeline .timeline-badge.info + .timeline-panel {\n\tbackground: var(--rgba-secondary-1);\n\tborder-color: #94fff9;\n}\n[data-theme-version='dark'] .widget-timeline .timeline-badge.info + .timeline-panel {\n\tbackground-color: rgba(0, 173, 163, 0.1);\n\tborder-color: transparent;\n}\n\n.widget-timeline .timeline-badge.dark {\n\tborder-color: #bec3e3;\n}\n[data-theme-version='dark'] .widget-timeline .timeline-badge.dark {\n\tborder-color: rgba(48, 57, 114, 0.35);\n}\n.widget-timeline .timeline-badge.dark:after {\n\tbackground-color: #303972 !important;\n\tbox-shadow: 0 0.3125rem 0.625rem 0 rgba(48, 57, 114, 0.2);\n}\n.widget-timeline .timeline-badge.dark + .timeline-panel {\n\tbackground: #bec3e3;\n\tborder-color: #bec3e3;\n}\n[data-theme-version='dark'] .widget-timeline .timeline-badge.dark + .timeline-panel {\n\tbackground-color: rgba(48, 57, 114, 0.35);\n\tborder-color: transparent;\n}\n\n.widget-timeline.style-1 .timeline-panel {\n\tbackground: transparent;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.timeline-badge + .timeline-panel {\n\tbackground: transparent !important;\n\tborder-style: solid;\n\tborder-width: 0 0 0 0.3125rem;\n\tborder-radius: 0;\n\tpadding: 0.3125rem 0.625rem 0.3125rem 0.9375rem;\n}\n.widget-timeline.style-1 .timeline .timeline-badge.timeline-badge + .timeline-panel:after {\n\tborder: 0;\n\tleft: -0.5625rem;\n\twidth: 0.4375rem;\n\theight: 0.4375rem;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.primary + .timeline-panel {\n\tborder-color: var(--primary);\n}\n.widget-timeline.style-1 .timeline .timeline-badge.primary + .timeline-panel:after {\n\tbackground: var(--primary);\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.success + .timeline-panel {\n\tborder-color: #1eba62;\n}\n.widget-timeline.style-1 .timeline .timeline-badge.success + .timeline-panel:after {\n\tbackground: #1eba62;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.warning + .timeline-panel {\n\tborder-color: #fcc43e;\n}\n.widget-timeline.style-1 .timeline .timeline-badge.warning + .timeline-panel:after {\n\tbackground: #fcc43e;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.danger + .timeline-panel {\n\tborder-color: #fd5353;\n}\n.widget-timeline.style-1 .timeline .timeline-badge.danger + .timeline-panel:after {\n\tbackground: #fd5353;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.info + .timeline-panel {\n\tborder-color: #00ada3;\n}\n.widget-timeline.style-1 .timeline .timeline-badge.info + .timeline-panel:after {\n\tbackground: #00ada3;\n}\n\n.widget-timeline.style-1 .timeline .timeline-badge.dark + .timeline-panel {\n\tborder-color: #303972;\n}\n.widget-timeline.style-1 .timeline .timeline-badge.dark + .timeline-panel:after {\n\tbackground: #303972;\n}\n\n#chart_widget_4 {\n\theight: 15.9375rem !important;\n}\n\n#chart_widget_5 .ct-series-a .ct-line,\n#chart_widget_5 .ct-series-a .ct-point {\n\tstroke: #46ffc8;\n}\n\n#chart_widget_5 .ct-line {\n\tstroke-width: 0.0625rem;\n}\n\n#chart_widget_5 .ct-point {\n\tstroke-width: 0.125rem;\n}\n\n#chart_widget_5 .ct-series-a .ct-area {\n\tfill: #20dea6;\n}\n\n#chart_widget_5 .ct-area {\n\tfill-opacity: 1;\n}\n\n#chart_widget_6 .ct-series-a .ct-line,\n#chart_widget_6 .ct-series-a .ct-point {\n\tstroke: #00ada3;\n}\n\n#chart_widget_6 .ct-line {\n\tstroke-width: 0.125rem;\n}\n\n#chart_widget_6 .ct-point {\n\tstroke-width: 0.3125rem;\n}\n\n#chart_widget_6 .ct-series-a .ct-area {\n\tfill: #00ada3;\n}\n\n#chart_widget_6 .ct-area {\n\tfill-opacity: 0.5;\n}\n\n#chart_widget_8 {\n\theight: 15.9375rem;\n}\n#chart_widget_8 .ct-series-a .ct-line,\n#chart_widget_8 .ct-series-a .ct-point {\n\tstroke: #00ada3;\n}\n#chart_widget_8 .ct-line {\n\tstroke-width: 0.125rem;\n}\n#chart_widget_8 .ct-point {\n\tstroke-width: 0.3125rem;\n}\n#chart_widget_8 .ct-series-a .ct-area {\n\tfill: #00ada3;\n}\n#chart_widget_8 .ct-area {\n\tfill-opacity: 0.5;\n}\n\n#chart_widget_9,\n#chart_widget_10 {\n\theight: 15.625rem !important;\n\tmargin-bottom: -5px;\n}\n\n#chart_widget_11 .ct-slice-donut,\n#chart_widget_12 .ct-slice-donut,\n#chart_widget_13 .ct-slice-donut {\n\tstroke-width: 1.5625rem !important;\n}\n\n#chart_widget_11 {\n\theight: 16.875rem !important;\n\tmargin-bottom: -5px;\n}\n\n#chart_widget_17 {\n\theight: 9.375rem !important;\n}\n\n.chart_widget_tab_one .nav-link {\n\tborder: 0.0625rem solid #ddd;\n}\n.chart_widget_tab_one .nav-link.active {\n\tbackground-color: var(--primary);\n\tborder: 0.0625rem solid var(--primary);\n\tcolor: #fff;\n}\n.chart_widget_tab_one .nav-link.active:hover {\n\tborder: 0.0625rem solid var(--primary);\n}\n.chart_widget_tab_one .nav-link:hover {\n\tborder: 0.0625rem solid #ddd;\n}\n\n[data-theme-version='dark'] .ccc-widget > div {\n\tbackground: #272738 !important;\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.social-icon {\n\tdisplay: inline-block;\n\twidth: 2.5rem;\n\theight: 2.5rem;\n\tline-height: 2.5rem;\n\tborder-radius: 0.25rem;\n\ttext-align: center;\n\tbackground: #e6ebee;\n\tmargin-bottom: 0.5rem;\n\tfont-size: 1.25rem;\n}\n.social-icon i {\n\tcolor: #fff;\n}\n.social-icon.youtube {\n\tbackground: #ff0000;\n}\n.social-icon.facebook {\n\tbackground: #3b5998;\n}\n.social-icon.twitter {\n\tbackground: #1da1f2;\n}\n\n.social-graph-wrapper {\n\ttext-align: center;\n\tpadding: 1.25rem;\n\tposition: relative;\n\tcolor: #fff;\n\tborder-top-left-radius: 0.25rem;\n\tborder-top-right-radius: 0.25rem;\n}\n.social-graph-wrapper.widget-facebook {\n\tbackground-color: #3b5998;\n}\n.social-graph-wrapper.widget-twitter {\n\tbackground-color: #1da1f2;\n}\n.social-graph-wrapper.widget-linkedin {\n\tbackground-color: #007bb6;\n}\n.social-graph-wrapper.widget-googleplus {\n\tbackground-color: #db4439;\n}\n.social-graph-wrapper .s-icon {\n\tfont-size: 1.5rem;\n\tposition: relative;\n\tpadding: 0 0.625rem;\n}\n\n.social-icon2 a {\n\tborder: 0.1rem solid var(--primary);\n\tdisplay: block;\n\tpadding: 1rem;\n\tmargin-top: 1.5rem;\n\tmargin-bottom: 0.5rem;\n\tborder-radius: 0.3rem;\n\tfont-size: 1.6rem;\n}\n\n.social-icon2 i {\n\tfont-size: 0.75rem;\n\tcolor: var(--primary);\n}\n\n.social-icon3 ul li {\n\tdisplay: inline-block;\n}\n.social-icon3 ul li a {\n\tdisplay: block;\n}\n.social-icon3 ul li a i {\n\tfont-size: 1.4rem;\n\tpadding: 1rem 0.7rem;\n\tcolor: #464a53;\n}\n.social-icon3 ul li a:hover i {\n\tcolor: var(--primary);\n}\n\n.social-icons-muted ul li a i {\n\tcolor: #89879f;\n}\n\n.social-links a {\n\tpadding: 0.5rem;\n}\n\n.widget-stat .media {\n\tpadding: 0rem 0;\n\talign-items: center;\n}\n.widget-stat .media > span {\n\theight: 5.3125rem;\n\twidth: 5.3125rem;\n\tborder-radius: 3.125rem;\n\tpadding: 0.625rem 0.75rem;\n\tfont-size: 2rem;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolor: #464a53;\n\tmin-width: 5.3125rem;\n}\n.widget-stat .media .media-body p {\n\ttext-transform: uppercase;\n\tfont-weight: 500;\n\tfont-size: 0.875rem;\n}\n[data-theme-version='dark'] .widget-stat .media .media-body p {\n\tcolor: #fff;\n}\n.widget-stat .media .media-body h3,\n.widget-stat .media .media-body .h3 {\n\tfont-size: 2.5rem;\n\tfont-weight: 600;\n\tmargin: 0;\n\tline-height: 1.2;\n}\n.widget-stat .media .media-body h4,\n.widget-stat .media .media-body .h4 {\n\tfont-size: 1.5rem;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n}\n.widget-stat .media .media-body span {\n\tmargin-left: 0.3125rem;\n}\n\n.widget-stat[class*='bg-'] .media > span {\n\tbackground-color: rgba(255, 255, 255, 0.25);\n\tcolor: #fff;\n}\n\n.widget-stat[class*='bg-'] .progress {\n\tbackground-color: rgba(255, 255, 255, 0.25) !important;\n}\n\n[direction='rtl'] .widget-stat .media .media-body span {\n\tmargin-left: 0;\n\tmargin-right: 0.625rem;\n}\n\n.dez-widget-1 .card {\n\tbackground: #ffe7db;\n}\n.dez-widget-1 .card .card-body p {\n\tcolor: #f87533;\n}\n\n.dez-widget-1 .icon {\n\tfloat: right;\n\twidth: 3.125rem;\n\theight: 3.125rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder-radius: 0.375rem;\n\tfont-size: 1.75rem;\n}\n\n.bgl-primary {\n\tbackground: var(--rgba-primary-1);\n\tborder-color: var(--rgba-primary-1);\n}\n[data-theme-version='dark'] .bgl-primary {\n\tbackground-color: var(--rgba-primary-1);\n\tborder-color: var(--rgba-primary-1);\n}\n\n.bgl-secondary {\n\tbackground: #fff3f0;\n\tborder-color: #fff3f0;\n}\n[data-theme-version='dark'] .bgl-secondary {\n\tbackground-color: rgba(251, 125, 91, 0.5);\n\tborder-color: rgba(251, 125, 91, 0.5);\n}\n\n.bgl-success {\n\tbackground: #ddfaea;\n\tborder-color: #ddfaea;\n}\n[data-theme-version='dark'] .bgl-success {\n\tbackground-color: rgba(30, 186, 98, 0.1);\n\tborder-color: rgba(30, 186, 98, 0.1);\n}\n\n.bgl-warning {\n\tbackground: #fffaee;\n\tborder-color: #fffaee;\n}\n[data-theme-version='dark'] .bgl-warning {\n\tbackground-color: rgba(252, 196, 62, 0.1);\n\tborder-color: rgba(252, 196, 62, 0.1);\n}\n\n.bgl-danger {\n\tbackground: #ffeaea;\n\tborder-color: #ffeaea;\n}\n[data-theme-version='dark'] .bgl-danger {\n\tbackground-color: rgba(253, 83, 83, 0.15);\n\tborder-color: rgba(253, 83, 83, 0.15);\n}\n\n.bgl-info {\n\tbackground: #94fff9;\n\tborder-color: #94fff9;\n}\n[data-theme-version='dark'] .bgl-info {\n\tbackground-color: rgba(0, 173, 163, 0.1);\n\tborder-color: rgba(0, 173, 163, 0.1);\n}\n\n.bg-primary-light {\n\tbackground: var(--rgba-primary-5);\n}\n[data-theme-version='dark'] .bg-primary-light {\n\tbackground-color: var(--rgba-primary-1);\n}\n\n.bg-secondary-light {\n\tbackground: rgba(255, 243, 240, 0.5);\n}\n[data-theme-version='dark'] .bg-secondary-light {\n\tbackground-color: rgba(251, 125, 91, 0.05);\n}\n\n.bg-success-light {\n\tbackground: rgba(221, 250, 234, 0.5);\n}\n[data-theme-version='dark'] .bg-success-light {\n\tbackground-color: rgba(30, 186, 98, 0.05);\n}\n\n.bg-warning-light {\n\tbackground: rgba(255, 250, 238, 0.5);\n}\n[data-theme-version='dark'] .bg-warning-light {\n\tbackground-color: rgba(252, 196, 62, 0.05);\n}\n\n.bg-danger-light {\n\tbackground: rgba(255, 234, 234, 0.5);\n}\n[data-theme-version='dark'] .bg-danger-light {\n\tbackground-color: rgba(253, 83, 83, 0.05);\n}\n\n.bg-info-light {\n\tbackground: rgba(148, 255, 249, 0.5);\n}\n[data-theme-version='dark'] .bg-info-light {\n\tbackground-color: rgba(0, 173, 163, 0.05);\n}\n\n.bgl-dark {\n\tbackground: #bec3e3;\n\tborder-color: #bec3e3;\n}\n\n.bgl-light {\n\tbackground: #ebebf9;\n\tborder-color: #ebebf9;\n}\n\n.overlay-box {\n\tposition: relative;\n\tz-index: 1;\n}\n.overlay-box:after {\n\tcontent: '';\n\twidth: 100%;\n\theight: 100%;\n\tleft: 0;\n\ttop: 0;\n\tposition: absolute;\n\topacity: 0.85;\n\tbackground: var(--primary);\n\tz-index: -1;\n}\n\n.rating-bar {\n\tfont-size: 0.8125rem;\n}\n\n.tdl-holder {\n\tmargin: 0 auto;\n}\n.tdl-holder ul {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n.tdl-holder li {\n\tbackground-color: #fff;\n\tborder-bottom: 0.0625rem solid #f2f2f2;\n\tlist-style: none none;\n\tmargin: 0;\n\tpadding: 0;\n}\n.tdl-holder li span {\n\tmargin-left: 2.1875rem;\n\tfont-size: 1rem;\n\tvertical-align: middle;\n\ttransition: all 0.2s linear;\n}\n[direction='rtl'] .tdl-holder li span {\n\tmargin-left: auto;\n\tmargin-right: 2.1875rem;\n}\n.tdl-holder label {\n\tcursor: pointer;\n\tdisplay: block;\n\tline-height: 3.125rem;\n\tpadding-left: 1.5rem;\n\tposition: relative;\n\tmargin: 0 !important;\n}\n[direction='rtl'] .tdl-holder label {\n\tpadding-left: 0;\n\tpadding-right: 1.5rem;\n}\n.tdl-holder label:hover {\n\tbackground-color: #eef1f6;\n\tcolor: #303972;\n}\n.tdl-holder label:hover a {\n\tcolor: #fd5353;\n}\n.tdl-holder label a {\n\tcolor: #fff;\n\tdisplay: inline-block;\n\tline-height: normal;\n\theight: 100%;\n\ttext-align: center;\n\ttext-decoration: none;\n\twidth: 3.125rem;\n\t-webkit-transition: all 0.2s linear;\n\t-moz-transition: all 0.2s linear;\n\t-o-transition: all 0.2s linear;\n\ttransition: all 0.2s linear;\n\tpadding: 1.125rem 0rem;\n\tfont-size: 1.125rem;\n\tposition: absolute;\n\tright: 0;\n}\n[direction='rtl'] .tdl-holder label a {\n\tright: auto;\n\tleft: 0;\n}\n.tdl-holder input[type='checkbox'] {\n\tcursor: pointer;\n\topacity: 0;\n\tposition: absolute;\n}\n.tdl-holder input[type='checkbox'] + i {\n\tbackground-color: #fff;\n\tborder: 0.0625rem solid #e7e7e7;\n\tdisplay: block;\n\theight: 1.25rem;\n\tposition: absolute;\n\ttop: 0.9375rem;\n\twidth: 1.25rem;\n\tz-index: 1;\n\tborder-radius: 0rem;\n\tfont-size: 0.6875rem;\n\tborder-radius: 0.25rem;\n}\n.tdl-holder input[type='checkbox']:checked + i {\n\tbackground: var(--primary);\n\tborder-color: transparent;\n}\n.tdl-holder input[type='checkbox']:checked + i::after {\n\tcontent: '\\f00c';\n\tfont-family: 'fontAwesome';\n\tdisplay: block;\n\tleft: 0.125rem;\n\tposition: absolute;\n\ttop: -0.875rem;\n\tz-index: 2;\n\tcolor: #fff;\n}\n.tdl-holder input[type='checkbox']:checked ~ span {\n\ttext-decoration: line-through;\n\tposition: relative;\n}\n.tdl-holder input[type='text'] {\n\tbackground-color: #fff;\n\theight: 3.125rem;\n\tmargin-top: 1.8125rem;\n\tborder-radius: 0.1875rem;\n}\n.tdl-holder input[type='text']::placeholder {\n\tcolor: #303972;\n}\n\n.widget-message p {\n\tfont-size: 0.875rem;\n\tline-height: 1.5;\n}\n\n.picker .picker__frame {\n\tmin-width: 28.125rem;\n\tmax-width: 28.125rem;\n}\n.picker .picker__frame .picker__box {\n\tpadding: 1.25rem;\n\tborder: 0;\n\tbox-shadow: 0 0.3125rem 0.625rem rgba(0, 0, 0, 0.1);\n}\n.picker .picker__frame .picker__box .picker__header {\n\tmargin-top: 0;\n}\n.picker .picker__frame .picker__box .picker__header .picker__year {\n\tcolor: var(--primary);\n\tfont-style: inherit;\n\tfont-size: 1.25rem;\n}\n.picker .picker__frame .picker__box .picker__header .picker__nav--prev,\n.picker .picker__frame .picker__box .picker__header .picker__nav--next {\n\twidth: 2.5rem;\n\theight: 2.5rem;\n\tpadding: 0;\n\tline-height: 2.5rem;\n\tborder-radius: 0.125rem;\n}\n.picker .picker__frame .picker__box .picker__header .picker__nav--prev:before,\n.picker .picker__frame .picker__box .picker__header .picker__nav--next:before {\n\tcontent: none !important;\n}\n.picker .picker__frame .picker__box .picker__header .picker__nav--prev:after,\n.picker .picker__frame .picker__box .picker__header .picker__nav--next:after {\n\tfont-family: 'Font Awesome 5 Free';\n\tborder: 0;\n\tmargin: 0 auto;\n\tfont-size: 1.375rem;\n\tfont-weight: 900;\n}\n.picker .picker__frame .picker__box .picker__header .picker__nav--prev:hover,\n.picker .picker__frame .picker__box .picker__header .picker__nav--next:hover {\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n}\n.picker .picker__frame .picker__box .picker__header .picker__nav--prev {\n\tleft: 0;\n}\n.picker .picker__frame .picker__box .picker__header .picker__nav--prev:after {\n\tcontent: '\\f0d9';\n}\n.picker .picker__frame .picker__box .picker__header .picker__nav--next {\n\tright: 0;\n}\n.picker .picker__frame .picker__box .picker__header .picker__nav--next:after {\n\tcontent: '\\f0da';\n}\n.picker .picker__frame .picker__box .picker__table .picker__weekday {\n\tpadding: 0.625rem 0;\n\tfont-size: 1rem;\n}\n.picker .picker__frame .picker__box .picker__table .picker__day {\n\twidth: 2.5rem;\n\theight: 2.5rem;\n\tborder-radius: 3.125rem;\n\tpadding: 0 !important;\n\tfont-size: 1rem;\n\tline-height: 2.5rem;\n\tmargin: auto;\n\tborder: 0 !important;\n}\n.picker .picker__frame .picker__box .picker__table .picker__day.picker__day--today:before {\n\tcontent: none !important;\n}\n.picker .picker__frame .picker__box .picker__table .picker__day.picker__day--highlighted {\n\tborder: 0 !important;\n\tpadding: 0;\n\tbackground-color: var(--primary);\n\tcolor: #fff !important;\n}\n.picker .picker__frame .picker__box .picker__table .picker__day:hover {\n\tbackground-color: var(--primary);\n\tcolor: #fff !important;\n}\n.picker .picker__frame .picker__box .picker__footer .picker__button--today {\n\tbackground-color: var(--primary);\n\tcolor: #fff !important;\n}\n.picker .picker__frame .picker__box .picker__footer .picker__button--today:before {\n\tcontent: none !important;\n}\n.picker .picker__frame .picker__box .picker__footer .picker__button--clear,\n.picker .picker__frame .picker__box .picker__footer .picker__button--close,\n.picker .picker__frame .picker__box .picker__footer .picker__button--today {\n\tborder: 0;\n\tborder-radius: 0.125rem;\n\tfont-size: 1rem;\n}\n.picker .picker__frame .picker__box .picker__footer .picker__button--clear:hover,\n.picker .picker__frame .picker__box .picker__footer .picker__button--close:hover,\n.picker .picker__frame .picker__box .picker__footer .picker__button--today:hover {\n\tbackground-color: var(--primary);\n\tcolor: #fff !important;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.picker .picker__frame {\n\t\tmin-width: 100% !important;\n\t\tmax-width: 100% !important;\n\t}\n\t.picker .picker__frame .picker__box {\n\t\tpadding: 0.9375rem;\n\t\tmargin: 0 0.625rem;\n\t}\n}\n\n.card-list {\n\toverflow: unset;\n\theight: calc(100% - 50px);\n}\n.card-list .card-header {\n\tpadding-top: 0;\n\tpadding-bottom: 0;\n}\n.card-list .card-header .photo {\n\toverflow: hidden;\n\tborder-radius: 0.3125rem;\n\twidth: 100%;\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.card-list {\n\t\theight: calc(100% - 40px);\n\t}\n}\n.card-list.list-left {\n\tmargin-top: 0.9375rem;\n\tmargin-left: 0.9375rem;\n}\n.card-list.list-left .card-header {\n\tpadding-left: 0;\n}\n.card-list.list-left .card-header .photo {\n\tmargin: -0.9375rem 0.9375rem 0 -0.9375rem;\n}\n.card-list.list-right {\n\tmargin-top: 0.9375rem;\n\tmargin-right: 0.9375rem;\n\ttext-align: right;\n}\n.card-list.list-right .card-header {\n\tpadding-right: 0;\n}\n.card-list.list-right .card-header .photo {\n\tmargin: -0.9375rem -0.9375rem 0 0.9375rem;\n}\n.card-list.list-right .card-header .photo img {\n\twidth: 100%;\n}\n.card-list.list-center {\n\tmargin-top: 0.9375rem;\n}\n.card-list.list-center .card-header .photo {\n\tmargin: -0.9375rem 0 0 0;\n}\n.card-list .photo img {\n\twidth: 100%;\n}\n\n.card-profile .profile-photo {\n\tmargin-top: -1.25rem;\n}\n\n.widget-media .timeline .timeline-panel {\n\tdisplay: flex;\n\talign-items: center;\n\tborder-bottom: 0.0625rem solid #eaeaea;\n\tpadding-bottom: 0.9375rem;\n\tmargin-bottom: 0.9375rem;\n}\n.widget-media .timeline .timeline-panel .media {\n\twidth: 3.125rem;\n\theight: 3.125rem;\n\tbackground: #eee;\n\tborder-radius: 0.75rem;\n\toverflow: hidden;\n\tfont-size: 1.25rem;\n\ttext-align: center;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-weight: 700;\n\talign-self: start;\n}\n.widget-media .timeline .timeline-panel .media-primary {\n\tbackground: var(--rgba-primary-1);\n\tcolor: var(--primary);\n}\n[data-theme-version='dark'] .widget-media .timeline .timeline-panel .media-primary {\n\tbackground-color: var(--rgba-primary-1);\n}\n.widget-media .timeline .timeline-panel .media-info {\n\tbackground: var(--rgba-primary-1);\n\tcolor: var(--primary);\n}\n[data-theme-version='dark'] .widget-media .timeline .timeline-panel .media-info {\n\tbackground-color: rgba(0, 173, 163, 0.1);\n}\n.widget-media .timeline .timeline-panel .media-warning {\n\tbackground: #fffaee;\n\tcolor: #fcc43e;\n}\n[data-theme-version='dark'] .widget-media .timeline .timeline-panel .media-warning {\n\tbackground-color: rgba(252, 196, 62, 0.1);\n}\n.widget-media .timeline .timeline-panel .media-danger {\n\tbackground: #ffeaea;\n\tcolor: #fd5353;\n}\n[data-theme-version='dark'] .widget-media .timeline .timeline-panel .media-danger {\n\tbackground-color: rgba(253, 83, 83, 0.15);\n}\n.widget-media .timeline .timeline-panel .media-success {\n\tbackground: #ddfaea;\n\tcolor: #1eba62;\n}\n[data-theme-version='dark'] .widget-media .timeline .timeline-panel .media-success {\n\tbackground-color: rgba(30, 186, 98, 0.1);\n}\n.widget-media .timeline .timeline-panel .media-body p {\n\tfont-size: 0.875rem;\n\tline-height: 1.5;\n}\n.widget-media .timeline .timeline-panel .dropdown {\n\talign-self: self-end;\n\tmargin-top: 0.3125rem;\n}\n\n.widget-media .timeline li:last-child .timeline-panel {\n\tmargin-bottom: 0;\n\tborder-bottom: 0;\n\tpadding-bottom: 0;\n}\n\n.card[class*='bg-'] .timeline .timeline-panel {\n\tborder-color: rgba(255, 255, 255, 0.2) !important;\n}\n\n.table th,\n.table td {\n\tborder-color: #f2f2f2;\n\tpadding: 0.9375rem 1.325rem;\n}\n[data-theme-version='dark'] .table th,\n[data-theme-version='dark'] .table td {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n\tcolor: #fff;\n}\n\n.table td {\n\tpadding: 0.65rem 1.425rem;\n}\n\n.table.table-striped tbody tr:nth-of-type(odd),\n.table.table-hover tr:hover {\n\tbackground-color: #f5f5f5;\n}\n[data-theme-version='dark'] .table.table-striped tbody tr:nth-of-type(odd),\n[data-theme-version='dark'] .table.table-hover tr:hover {\n\tbackground-color: #202020;\n}\n\n.table.shadow-hover tbody tr:hover {\n\tbackground-color: #fff;\n\tbox-shadow: 0 0rem 1.875rem var(--rgba-primary-2);\n}\n[data-theme-version='dark'] .table.shadow-hover tbody tr:hover {\n\tbackground-color: #202020;\n}\n\n.table.tr-rounded tr td:first-child,\n.table.tr-rounded tr th:first-child {\n\tborder-radius: 0.5rem 0 0 0.5rem;\n}\n\n.table.tr-rounded tr td:last-child,\n.table.tr-rounded tr th:last-child {\n\tborder-radius: 0 0.5rem 0.5rem 0;\n}\n\n.table.order-tbl tr th {\n\tfont-size: 14px;\n\tfont-weight: 600;\n\tborder: 0;\n}\n\n.table.order-tbl tr td {\n\tfont-weight: 500;\n\tborder: 0;\n}\n\n.table.border-hover tr td {\n\tborder-width: 0.0625rem 0 0.0625rem 0;\n\tborder-bottom: 0.0625rem solid transparent;\n\tborder-color: transparent;\n}\n.table.border-hover tr td:first-child {\n\tborder-width: 0.0625rem 0 0.0625rem 0.0625rem;\n}\n.table.border-hover tr td:last-child {\n\tborder-width: 0.0625rem 0.0625rem 0.0625rem 0;\n}\n\n.table.border-hover tr:hover td {\n\tborder-color: #eeeeee;\n}\n\n.table.bg-secondary-hover td {\n\tcolor: #000;\n\tpadding-left: 0;\n}\n\n.table.bg-secondary-hover th {\n\tcolor: #fb7d5b !important;\n}\n[data-theme-version='dark'] .table.bg-secondary-hover th {\n\tcolor: var(--secondary) !important;\n}\n\n.table.bg-secondary-hover tr:hover td,\n.table.bg-secondary-hover tr:hover th {\n\tbackground: #fb7d5b;\n\tcolor: #fff;\n\tbox-shadow: 10px 0 30px rgba(65, 63, 187, 0.3);\n}\n[data-theme-version='dark'] .table.bg-secondary-hover tr:hover td,\n[data-theme-version='dark'] .table.bg-secondary-hover tr:hover th {\n\tbackground: var(--secondary);\n}\n\n.table.bg-primary-hover td {\n\tcolor: #000;\n\tpadding-left: 0;\n}\n\n.table.bg-primary-hover th {\n\tcolor: var(--primary);\n}\n\n.table.bg-primary-hover tr:hover td,\n.table.bg-primary-hover tr:hover th {\n\tbackground: var(--primary);\n\tcolor: #fff;\n\tbox-shadow: 10px 0 30px rgba(54, 147, 255, 0.3);\n}\n\n.table.bg-eth-hover td {\n\tcolor: #000;\n\tpadding-left: 0;\n}\n\n.table.bg-eth-hover th {\n\tcolor: #00ada3;\n}\n\n.table.bg-eth-hover tr:hover td,\n.table.bg-eth-hover tr:hover th {\n\tbackground: #00ada3;\n\tcolor: #fff;\n\tbox-shadow: 10px 0 30px rgba(0, 173, 163, 0.3);\n}\n\n.table.bg-ripple-hover td {\n\tcolor: #000;\n\tpadding-left: 0;\n}\n\n.table.bg-ripple-hover th {\n\tcolor: #23292f;\n}\n\n.table.bg-ripple-hover tr:hover td,\n.table.bg-ripple-hover tr:hover th {\n\tbackground: #23292f;\n\tcolor: #fff;\n\tbox-shadow: 10px 0 30px rgba(35, 41, 47, 0.3);\n}\n\n.table.bg-pink-hover td {\n\tcolor: #5b5e81;\n\tpadding-left: 0;\n}\n\n.table.bg-pink-hover th {\n\tcolor: #eb62d0;\n}\n\n.table.bg-pink-hover tr:hover td,\n.table.bg-pink-hover tr:hover th {\n\tbackground: #eb62d0;\n\tcolor: #fff;\n\tbox-shadow: 10px 0 30px rgba(172, 76, 188, 0.3);\n}\n\n.table.bg-secondary-hover td {\n\tcolor: #5b5e81;\n}\n\n.table.bg-secondary-hover th {\n\tcolor: #6c6c6c;\n}\n\n.table.bg-secondary-hover tr:hover td,\n.table.bg-secondary-hover tr:hover th {\n\tbackground: var(--secondary);\n\tcolor: #fff !important;\n}\n\n.table.bg-info-hover td {\n\tcolor: #000;\n}\n\n.table.bg-info-hover th {\n\tcolor: #6c6c6c;\n}\n\n.table.bg-info-hover tr:hover td,\n.table.bg-info-hover tr:hover th {\n\tbackground: #00ada3;\n\tcolor: #fff !important;\n}\n\n.table.bg-warning-hover td {\n\tcolor: #000;\n}\n\n.table.bg-warning-hover th {\n\tcolor: #6c6c6c;\n}\n\n.table.bg-warning-hover tr:hover td,\n.table.bg-warning-hover tr:hover th {\n\tbackground: #fcc43e;\n\tcolor: #fff !important;\n}\n\n.table.border-no td {\n\tborder: 0;\n}\n\n.table.short-one tr td:first-child,\n.table.short-one tr th:first-child {\n\twidth: 3.75rem;\n}\n\n.table thead th {\n\tcolor: var(--primary);\n\twhite-space: nowrap;\n\tfont-size: 14px;\n\ttext-transform: capitalize;\n\tfont-weight: 500;\n\tpadding: 11px 20.7px;\n}\n.table thead th small,\n.table thead th .small {\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .table thead th {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.table tbody tr td {\n\tvertical-align: middle;\n\twhite-space: nowrap;\n\tborder-color: #f2f2f2;\n}\n[data-theme-version='dark'] .table tbody tr td {\n\t/*   border-color: $d-border; */\n}\n\n.table:not(.table-bordered) thead th {\n\tborder-top: none;\n}\n\n.table .thead-primary th {\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n}\n\n.table .thead-info th {\n\tbackground-color: #00ada3;\n\tcolor: #fff;\n}\n\n.table .thead-warning th {\n\tbackground-color: #fcc43e;\n\tcolor: #fff;\n}\n\n.table .thead-danger th {\n\tbackground-color: #fd5353;\n\tcolor: #fff;\n}\n\n.table .thead-success th {\n\tbackground-color: #1eba62;\n\tcolor: #fff;\n}\n\n.table.primary-table-bordered {\n\tborder: 0.0625rem solid #f2f2f2;\n}\n[data-theme-version='dark'] .table.primary-table-bordered {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n.table.primary-table-bg-hover thead th {\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n\tborder-bottom: none;\n\tborder-color: #fff !important;\n}\n\n.table.primary-table-bg-hover tbody tr {\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n\ttransition: all 0.1s ease;\n}\n.table.primary-table-bg-hover tbody tr td {\n\tborder-color: #fff;\n}\n.table.primary-table-bg-hover tbody tr:hover {\n\tbackground-color: var(--rgba-primary-8);\n}\n.table.primary-table-bg-hover tbody tr:not(:last-child) td,\n.table.primary-table-bg-hover tbody tr:not(:last-child) th {\n\tborder-bottom: 0.0625rem solid var(--primary-dark);\n\tborder-color: rgba(255, 255, 255, 0.5);\n}\n\n.table-responsive-tiny {\n\tmin-width: 18.75rem;\n}\n\n.table-responsive-sm {\n\tmin-width: 30rem !important;\n}\n\n.table-responsive-md {\n\tmin-width: 36rem !important;\n}\n\n.table-responsive-lg {\n\tmin-width: 60.9375rem !important;\n}\n\n.table-responsive-xl {\n\tmin-width: 70.9375rem !important;\n}\n\n.table-primary,\n.table-primary > th,\n.table-primary > td {\n\tbackground-color: var(--rgba-primary-1);\n\tcolor: var(--primary);\n}\n[data-theme-version='dark'] .table-primary,\n[data-theme-version='dark'] .table-primary > th,\n[data-theme-version='dark'] .table-primary > td {\n\tbackground-color: var(--rgba-primary-1);\n}\n\n.table-success,\n.table-success > th,\n.table-success > td {\n\tbackground-color: #ddfaea;\n\tcolor: #1eba62;\n}\n[data-theme-version='dark'] .table-success,\n[data-theme-version='dark'] .table-success > th,\n[data-theme-version='dark'] .table-success > td {\n\tbackground-color: rgba(30, 186, 98, 0.1);\n}\n\n.table-info,\n.table-info > th,\n.table-info > td {\n\tbackground-color: #94fff9;\n\tcolor: #00ada3;\n}\n[data-theme-version='dark'] .table-info,\n[data-theme-version='dark'] .table-info > th,\n[data-theme-version='dark'] .table-info > td {\n\tbackground-color: rgba(0, 173, 163, 0.1);\n}\n\n.table-warning,\n.table-warning > th,\n.table-warning > td {\n\tbackground-color: #fffaee;\n\tcolor: #fcc43e;\n}\n[data-theme-version='dark'] .table-warning,\n[data-theme-version='dark'] .table-warning > th,\n[data-theme-version='dark'] .table-warning > td {\n\tbackground-color: rgba(252, 196, 62, 0.1);\n}\n\n.table-danger,\n.table-danger > th,\n.table-danger > td {\n\tbackground-color: #ffeaea;\n\tcolor: #fd5353;\n}\n[data-theme-version='dark'] .table-danger,\n[data-theme-version='dark'] .table-danger > th,\n[data-theme-version='dark'] .table-danger > td {\n\tbackground-color: rgba(253, 83, 83, 0.15);\n}\n\n.table-active,\n.table-active > th,\n.table-active > td {\n\tbackground-color: #f5f5f5;\n}\n[data-theme-version='dark'] .table-active,\n[data-theme-version='dark'] .table-active > th,\n[data-theme-version='dark'] .table-active > td {\n\tbackground-color: #202020;\n}\n\n.card-table th:first-child,\n.card-table td:first-child {\n\tpadding-left: 1.875rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.card-table th:first-child,\n\t.card-table td:first-child {\n\t\tpadding-left: 0.9375rem;\n\t}\n}\n\n.card-table th:last-child,\n.card-table td:last-child {\n\tpadding-right: 0;\n\ttext-align: center;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.card-table th:last-child,\n\t.card-table td:last-child {\n\t\tpadding-right: 0.9375rem;\n\t}\n}\n\n.table > :not(:first-child) {\n\tborder-top: 1px solid currentColor;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n\tcolor: #303972;\n}\n\n.table tbody tr:last-child td,\n.table tbody tr:last-child th {\n\tborder-bottom: transparent;\n}\n\n.bootgrid-header {\n\tpadding: 0 !important;\n\tmargin: 0;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.bootgrid-header .actionBar {\n\t\tpadding: 0;\n\t}\n\t.bootgrid-header .search {\n\t\tmargin: 0 0 0.625rem 0;\n\t}\n}\n\ntable#example {\n\tpadding: 0rem 0 2rem 0;\n}\n\ntable.dataTable {\n\tfont-size: 14px;\n\toverflow: hidden;\n}\n\n#example2_wrapper .dataTables_scrollBody {\n\tmax-height: 33.25rem !important;\n}\n\n#employees,\n#custommers {\n\tpadding: 0.5rem 0 1rem 0;\n}\n\n.dataTables_wrapper .dataTables_paginate {\n\tpadding-top: 0.75em;\n\tpadding-bottom: 0.75em;\n}\n\ntable.dataTable thead th,\ntable.dataTable thead td {\n\tborder-bottom: 2px solid #eeeeee;\n\tborder-top: 0;\n}\n\ntable.dataTable tfoot th,\ntable.dataTable tfoot td {\n\tborder-top: 0;\n}\n\ntable.dataTable tbody tr,\ntable.dataTable tbody td {\n\tbackground: transparent !important;\n}\n\ntable.dataTable thead .sorting {\n\tbackground-image: none !important;\n}\n\ntable.dataTable thead sorting sorting_desc {\n\tbackground-image: none;\n}\n\n.sorting {\n\tbackground-image: none;\n}\n\n.table.dataTable thead .sorting_desc {\n\tbackground-image: none;\n}\n\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc:after {\n\tcontent: '';\n\tfont-family: 'Font Awesome 6 Free';\n\tfont-weight: 900;\n\tbackground-image: none;\n\tmargin-left: 10px;\n\tfont-size: calc(100% - 4px);\n\topacity: 0.5;\n}\n\ntable.dataTable thead .sorting:after {\n\tcontent: '\\f0dc';\n}\n\ntable.dataTable thead .sorting_asc:after {\n\tcontent: '\\f0de';\n\topacity: 1;\n}\n\ntable.dataTable thead .sorting_desc:after {\n\tcontent: '\\f0dd';\n\topacity: 1;\n}\n\ntable.dataTable thead th {\n\tcolor: var(--primary);\n\twhite-space: nowrap;\n\tfont-size: 14px;\n\ttext-transform: capitalize;\n\tfont-weight: 500;\n\tpadding: 11px 20.7px;\n}\n[data-theme-version='dark'] table.dataTable thead th {\n\tcolor: #fff;\n}\n@media only screen and (max-width: 87.5rem) {\n\ttable.dataTable thead th {\n\t\tfont-size: 13px;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\ttable.dataTable thead th {\n\t\tpadding: 10px 8px;\n\t}\n}\n\ntd.doller {\n\tcolor: var(--primary);\n}\n\ntable.dataTable tbody td {\n\tborder-bottom: 0;\n\twhite-space: nowrap;\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tpadding: 0.65rem 1.425rem;\n\tcolor: #a098ae;\n}\n\ntable.dataTable tr.selected {\n\tcolor: var(--primary);\n}\n\ntable.dataTable tfoot th {\n\tcolor: #303972;\n\tfont-weight: 600;\n}\n[data-theme-version='dark'] table.dataTable tfoot th {\n\tcolor: #fff;\n}\n\n.dataTables_wrapper .dataTables_paginate {\n\talign-items: center;\n\tdisplay: inline-flex;\n\tflex-flow: wrap;\n}\n.dataTables_wrapper .dataTables_paginate .paginate_button.previous,\n.dataTables_wrapper .dataTables_paginate .paginate_button.next {\n\tmargin-left: 0px;\n\tfont-size: 18px;\n\tborder: 0 !important;\n\theight: 45px;\n\twidth: 155px;\n\tpadding: 0;\n\tborder-radius: 0.5rem;\n\tline-height: 45px;\n\tdisplay: inline-block;\n\tbackground: transparent;\n}\n.dataTables_wrapper .dataTables_paginate .paginate_button.previous:last-child,\n.dataTables_wrapper .dataTables_paginate .paginate_button.next:last-child {\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin: 0 5px 0 5px;\n}\n.dataTables_wrapper .dataTables_paginate .paginate_button.previous:first-child,\n.dataTables_wrapper .dataTables_paginate .paginate_button.next:first-child {\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n.dataTables_wrapper .dataTables_paginate .paginate_button.previous i,\n.dataTables_wrapper .dataTables_paginate .paginate_button.next i {\n\tfont-size: 1rem;\n\tpadding: 0 10px;\n}\n.dataTables_wrapper .dataTables_paginate .paginate_button.previous span,\n.dataTables_wrapper .dataTables_paginate .paginate_button.next span {\n\tborder: none;\n}\n.dataTables_wrapper .dataTables_paginate .paginate_button.previous.current:hover,\n.dataTables_wrapper .dataTables_paginate .paginate_button.previous.previous:hover,\n.dataTables_wrapper .dataTables_paginate .paginate_button.previous.next:hover,\n.dataTables_wrapper .dataTables_paginate .paginate_button.next.current:hover,\n.dataTables_wrapper .dataTables_paginate .paginate_button.next.previous:hover,\n.dataTables_wrapper .dataTables_paginate .paginate_button.next.next:hover {\n\tcolor: #fff !important;\n\tbackground: var(--primary) !important;\n\tborder-radius: 6px;\n}\n.dataTables_wrapper .dataTables_paginate .paginate_button.previous.disabled,\n.dataTables_wrapper .dataTables_paginate .paginate_button.next.disabled {\n\tcolor: #303972 !important;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.dataTables_wrapper .dataTables_paginate .paginate_button.previous,\n\t.dataTables_wrapper .dataTables_paginate .paginate_button.next {\n\t\theight: 45px;\n\t\twidth: 135px;\n\t\tfont-size: 16px;\n\t}\n\t.dataTables_wrapper .dataTables_paginate .paginate_button.previous i,\n\t.dataTables_wrapper .dataTables_paginate .paginate_button.next i {\n\t\tfont-size: 16px;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.dataTables_wrapper .dataTables_paginate .paginate_button.previous,\n\t.dataTables_wrapper .dataTables_paginate .paginate_button.next {\n\t\twidth: 45px;\n\t\tfont-size: 14px;\n\t\theight: 40px;\n\t\tline-height: 40px;\n\t}\n\t.dataTables_wrapper .dataTables_paginate .paginate_button.previous i,\n\t.dataTables_wrapper .dataTables_paginate .paginate_button.next i {\n\t\tfont-size: 14px;\n\t}\n\t.dataTables_wrapper .dataTables_paginate .paginate_button.previous span,\n\t.dataTables_wrapper .dataTables_paginate .paginate_button.next span {\n\t\tdisplay: none;\n\t}\n}\n.dataTables_wrapper .dataTables_paginate span .paginate_button {\n\theight: 45px;\n\twidth: 45px;\n\tpadding: 0;\n\tmargin-left: 0px;\n\tline-height: 45px;\n\ttext-align: center;\n\tfont-size: 18px;\n\tborder-radius: 0rem;\n\tcolor: #a098ae !important;\n\tborder: 0 !important;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.dataTables_wrapper .dataTables_paginate span .paginate_button {\n\t\theight: 40px;\n\t\twidth: 40px;\n\t\tline-height: 40px;\n\t}\n}\n.dataTables_wrapper .dataTables_paginate span .paginate_button.current,\n.dataTables_wrapper .dataTables_paginate span .paginate_button:hover {\n\tcolor: #fff !important;\n\tbackground: var(--primary) !important;\n\tbox-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);\n}\n.dataTables_wrapper .dataTables_paginate span .paginate_button.current:hover,\n.dataTables_wrapper .dataTables_paginate span .paginate_button:hover:hover {\n\tcolor: var(--primary) !important;\n\tbackground: var(--rgba-primary-1) !important;\n}\n\n.dataTables_wrapper input[type='search'],\n.dataTables_wrapper input[type='text'],\n.dataTables_wrapper select {\n\tborder: 1px solid #dddddd !important;\n\tpadding: 0.3rem 0.5rem;\n\tcolor: #303972;\n\tborder-radius: 0.625rem !important;\n\tmargin-left: 14px;\n}\n[data-theme-version='dark'] .dataTables_wrapper input[type='search'],\n[data-theme-version='dark'] .dataTables_wrapper input[type='text'],\n[data-theme-version='dark'] .dataTables_wrapper select {\n\tbackground: #202020;\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n\tcolor: #fff;\n}\n\n.dataTables_wrapper .dataTables_length {\n\tmargin-bottom: 15px;\n}\n.dataTables_wrapper .dataTables_length .bootstrap-select {\n\twidth: 80px !important;\n\tmargin: 0 5px;\n}\n\ntable.dataTable.no-footer {\n\tborder-bottom: 0;\n}\n\n.rounded-lg {\n\tmin-width: 30px;\n}\n\n.dataTables_scroll {\n\tpadding: 1rem 0;\n}\n.dataTables_scrollFoot {\n\tpadding-top: 1rem;\n}\n\n.dataTablesCard {\n\tbackground-color: #fff;\n\tborder-radius: 0.375rem;\n\toverflow: hidden;\n}\n.dataTablesCard.border-no td {\n\tborder-top: 0 !important;\n}\n\n@media (max-width: 767.98px) {\n\t.dataTables_wrapper .dataTables_length,\n\t.dataTables_wrapper .dataTables_filter {\n\t\ttext-align: left;\n\t}\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button.disabled,\n.dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover,\n.dataTables_wrapper .dataTables_paginate .paginate_button.disabled:active {\n\tcolor: #a098ae !important;\n}\n\n.dataTables_wrapper .dataTables_length,\n.dataTables_wrapper .dataTables_filter,\n.dataTables_wrapper .dataTables_processing,\n.dataTables_wrapper .dataTables_paginate {\n\tcolor: #a098ae;\n\tborder-radius: 1rem;\n\tmargin-bottom: 20px;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.dataTables_wrapper .dataTables_length,\n\t.dataTables_wrapper .dataTables_filter,\n\t.dataTables_wrapper .dataTables_processing,\n\t.dataTables_wrapper .dataTables_paginate {\n\t\tmargin-bottom: 8px;\n\t}\n}\n\n.dataTables_wrapper .dataTables_length,\n.dataTables_wrapper .dataTables_filter {\n\tmargin-bottom: 10px;\n\tpadding: 15px 19px 0px 19px;\n}\n\n.paging_simple_numbers.dataTables_paginate {\n\tborder: 0.025rem solid var(--primary);\n\tbackground: transparent;\n\tborder-radius: 0.5rem;\n}\n.paging_simple_numbers.dataTables_paginate span {\n\tborder-radius: 0.375rem;\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button {\n\tcolor: #a098ae !important;\n}\n\n.dataTables_info {\n\tfont-size: 13px;\n\tfont-weight: 500;\n\ttext-align: start !important;\n\tdisplay: inline-block;\n}\n\ntable.dataTable.row-border tbody th,\ntable.dataTable.row-border tbody td,\ntable.dataTable.display tbody th,\ntable.dataTable.display tbody td {\n\tborder-color: #f2f2f2;\n}\n[data-theme-version='dark'] table.dataTable.row-border tbody th,\n[data-theme-version='dark'] table.dataTable.row-border tbody td,\n[data-theme-version='dark'] table.dataTable.display tbody th,\n[data-theme-version='dark'] table.dataTable.display tbody td {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n.dataTables_wrapper .dataTables_length .bootstrap-select .dropdown-toggle {\n\tfont-size: 0.813rem !important;\n\tpadding: 0.625rem 1rem;\n}\n\n.table-responsive thead {\n\tbackground-color: var(--rgba-primary-1);\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button.previous,\n.dataTables_wrapper .dataTables_paginate .paginate_button.next {\n\theight: 30px;\n\twidth: 30px;\n\tpadding: 0;\n\tfont-size: 13px;\n\tborder-radius: 6px;\n\tline-height: 30px;\n\tmargin: 0 5px;\n\ttext-align: center;\n\tmargin-left: 0;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.dataTables_wrapper .dataTables_paginate .paginate_button.previous,\n\t.dataTables_wrapper .dataTables_paginate .paginate_button.next {\n\t\theight: 36px;\n\t\twidth: 36px;\n\t\tline-height: 36px;\n\t}\n}\n\n.dataTables_wrapper .dataTables_paginate span .paginate_button {\n\theight: 30px;\n\twidth: 30px;\n\tpadding: 0;\n\tline-height: 30px;\n\tdisplay: inline-block;\n\tmargin: 0 5px;\n\tborder-radius: 6px;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.dataTables_wrapper .dataTables_paginate span .paginate_button {\n\t\theight: 36px;\n\t\twidth: 36px;\n\t\tline-height: 36px;\n\t\tfont-size: 14px;\n\t}\n}\n\n.paging_simple_numbers.dataTables_paginate {\n\tborder: none;\n}\n\n.dataTables_scrollBody thead {\n\tdisplay: none;\n}\n\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc:after {\n\tcontent: '';\n\tfont-family: 'Font Awesome 6 Free';\n\tfont-weight: 900;\n\tbackground-image: none;\n\tmargin-left: 5px;\n\tfont-size: calc(100% - 2px);\n\topacity: 0.5;\n}\n\ntable.dataTable thead .sorting:after {\n\tcontent: '\\f0dc';\n}\n\ntable.dataTable thead .sorting_asc:after {\n\tcontent: '\\f0de';\n\topacity: 1;\n}\n\ntable.dataTable thead .sorting_desc:after {\n\tcontent: '\\f0dd';\n\topacity: 1;\n}\n\n.dlab-scroll {\n\toverflow-y: scroll;\n}\n\n/* .dlab-scroll::-webkit-scrollbar {\n\twidth: 5px;\n\topacity:0;\n}\n.dlab-scroll::-webkit-scrollbar-thumb{\n\tbackground:  rgba(111, 133, 147, 0.0); \n}\n.dlab-scroll:hover::-webkit-scrollbar-thumb{\n\tbackground:  rgba(111, 133, 147, 0.1); \n} */\nbody > * {\n\tscrollbar-width: thin;\n\tscrollbar-color: rgba(111, 133, 147, 0.1) #fff0;\n}\n\n::-webkit-scrollbar {\n\twidth: 5px;\n\topacity: 0;\n}\n\n/* ::-webkit-scrollbar-thumb{\n\tbackground:  rgba(111, 133, 147, 0.0); \n} */\n::-webkit-scrollbar-thumb {\n\tbackground: rgba(111, 133, 147, 0.1);\n}\n\n#example2_wrapper #example2_filter {\n\tfloat: left;\n}\n\n.dataTables_info {\n\tpadding: 1.25rem 0.75rem;\n}\n\n.fooicon {\n\tfont-size: 1.25rem;\n\tcolor: #303972;\n}\n\n.jsgrid-table .jsgrid-header-row > .jsgrid-header-cell {\n\tcolor: #303972;\n}\n\n.jsgrid-table > tbody > tr > td {\n\tpadding: 1.2em;\n}\n\n.jsgrid-table .jsgrid-insert-row input,\n.jsgrid-table .jsgrid-insert-row select,\n.jsgrid-table .jsgrid-edit-row input,\n.jsgrid-table .jsgrid-edit-row select {\n\tborder: 0.0625rem solid #dddfe1;\n}\n\n.jsgrid .jsgrid-button {\n\tborder: 0 !important;\n\tmargin-left: 0.625rem;\n}\n\n.file-drive {\n\tborder-bottom: 1px solid #d5dfe7;\n\tborder-top: none;\n\tborder-radius: 0;\n\tmargin-bottom: 0;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.file-drive {\n\t\tborder-top: 1px solid #dddddd;\n\t}\n}\n\n.file_area .table-pagenation {\n\tmargin: 0;\n\tbackground-color: #fff;\n\tpadding: 0.813rem 5px;\n\tflex-wrap: wrap;\n}\n.file_area .table-pagenation p {\n\tmargin-bottom: 0;\n}\n.file_area .table-pagenation .pagination {\n\tmargin-bottom: 0;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.file_area .table-pagenation {\n\t\tdisplay: none;\n\t}\n}\n\n.drive {\n\tdisplay: flex;\n\tpadding: 0.625rem;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tborder: 1px solid #fff;\n\tborder-radius: 0.375rem;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n\tcursor: pointer;\n}\n.drive .dz-folder {\n\tmargin-right: 0.625rem;\n}\n.drive .dz-folder svg path {\n\tfill: var(--primary);\n}\n@media only screen and (max-width: 100rem) {\n\t.drive .dz-folder svg {\n\t\twidth: 65px;\n\t\theight: 60px;\n\t}\n}\n@media only screen and (max-width: 87.5rem) {\n\t.drive .dz-folder svg {\n\t\twidth: 50px;\n\t\theight: 50px;\n\t}\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.drive .dz-folder svg {\n\t\twidth: 70px;\n\t\theight: 50px;\n\t}\n}\n.drive .dz-media {\n\twidth: 11.188rem;\n}\n.drive .drive-content {\n\tflex: 0 0 60%;\n}\n.drive .drive-content .title {\n\tfont-size: 1rem;\n}\n.drive .drive-content span {\n\tfont-size: 0.75rem;\n}\n.drive .progress {\n\tmargin-bottom: 0.3rem;\n\tbackground-color: var(--rgba-primary-1);\n\tborder: 1px solid var(--primary);\n\tborder-radius: 0.188rem;\n\twidth: 100%;\n\theight: 0.938rem;\n}\n@media only screen and (max-width: 110rem) {\n\t.drive .progress {\n\t\twidth: 100%;\n\t}\n}\n.drive .progress .progress-bar {\n\tborder-radius: 0;\n}\n.drive:hover {\n\tbackground-color: var(--rgba-primary-1);\n\tborder: 1px solid var(--primary);\n}\n\n.file-header {\n\tborder-bottom: 1px solid #d5dfe7;\n}\n.file-header .page-titles {\n\tmargin-bottom: 0;\n\tpadding: 0;\n\tflex-wrap: wrap;\n}\n.file-header .page-titles .input-group.search-area {\n\twidth: 16rem;\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.file-header .page-titles .input-group.search-area {\n\t\twidth: 12rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.file-header .page-titles .input-group.search-area {\n\t\twidth: 100%;\n\t}\n\t.file-header .page-titles .input-group.search-area svg {\n\t\twidth: 14px;\n\t\theight: 14px;\n\t}\n}\n.file-header .file-path {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-right: 0.625rem;\n}\n.file-header .file-path h4 a,\n.file-header .file-path .h4 a {\n\tfont-size: 0.875rem;\n\tmargin-right: 0.5rem;\n}\n.file-header .file-path svg path {\n\tfill: var(--primary);\n}\n\n.file-list {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0.938rem;\n}\n.file-list .dz-media {\n\tmargin-right: 0.8rem;\n\twidth: 2.813rem;\n\theight: 2.5rem;\n}\n.file-list .dz-media .dz-img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n\tborder-radius: 0.313rem;\n\tbox-shadow: 0px 4px 10px rgba(0, 25, 39, 0.14);\n}\n.file-list .dz-info .title {\n\tfont-size: 0.938rem;\n\tmargin-bottom: 0;\n}\n\n.folder-layout-tab .feature-btn:first-child {\n\tbackground: var(--primary);\n\tcolor: #fff;\n}\n.folder-layout-tab .feature-btn:first-child svg path {\n\tfill: #fff;\n}\n\n.folder-layout-tab.grid .feature-btn:first-child {\n\tbackground: var(--rgba-primary-1);\n\tcolor: #fff;\n}\n.folder-layout-tab.grid .feature-btn:first-child svg path {\n\tfill: var(--primary);\n}\n\n.folder-layout-tab.grid .feature-btn:last-child {\n\tbackground: var(--primary);\n\tcolor: #fff;\n}\n.folder-layout-tab.grid .feature-btn:last-child svg path {\n\tfill: #fff;\n}\n\n.folder-structure {\n\theight: calc(100vh - 22.213rem);\n\toverflow-y: scroll;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.folder-structure {\n\t\theight: calc(100vh - 25.75rem);\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.folder-structure {\n\t\theight: calc(100vh - 7.813rem);\n\t\toverflow-y: scroll;\n\t}\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.folder-structure {\n\t\theight: calc(100vh - 3.313rem);\n\t}\n}\n.folder-structure li {\n\tborder-bottom: 1px solid #d5dfe7;\n}\n.folder-structure.grid {\n\tpadding: 1.875rem;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmargin-left: -12px;\n\tmargin-right: -12px;\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.folder-structure.grid {\n\t\tmargin-left: 0;\n\t\tmargin-right: 0;\n\t}\n}\n.folder-structure.grid li {\n\tborder: 0;\n\tmax-width: 20%;\n\tpadding-left: 0.75rem;\n\tpadding-right: 0.75rem;\n\tmargin-bottom: 24px;\n\tbox-sizing: border-box;\n}\n@media only screen and (max-width: 100rem) {\n\t.folder-structure.grid li {\n\t\tmax-width: 25%;\n\t}\n}\n@media only screen and (max-width: 87.5rem) {\n\t.folder-structure.grid li {\n\t\tmax-width: 33.33%;\n\t}\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.folder-structure.grid li {\n\t\tmax-width: 50%;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.folder-structure.grid li {\n\t\tmax-width: 33.33%;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.folder-structure.grid li {\n\t\tmax-width: 50%;\n\t}\n}\n.folder-structure.grid li .file-list {\n\tdisplay: block;\n\talign-items: center;\n\tpadding: 1.25rem;\n\ttext-align: center;\n\tmin-width: 15rem;\n\tborder: 1px solid transparent;\n\tborder-radius: 0.375rem;\n}\n@media only screen and (max-width: 100rem) {\n\t.folder-structure.grid li .file-list {\n\t\tmin-width: 13.75rem;\n\t}\n}\n@media only screen and (max-width: 87.5rem) {\n\t.folder-structure.grid li .file-list {\n\t\tmin-width: 15rem;\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.folder-structure.grid li .file-list {\n\t\tmin-width: 12.5rem;\n\t}\n}\n@media only screen and (max-width: 64rem) {\n\t.folder-structure.grid li .file-list {\n\t\tmin-width: 11.125rem;\n\t}\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.folder-structure.grid li .file-list {\n\t\tmin-width: 100%;\n\t\tpadding: 1rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.folder-structure.grid li .file-list {\n\t\tpadding: 0.625rem;\n\t}\n}\n.folder-structure.grid li .file-list .dz-media {\n\theight: 110px;\n\twidth: 140px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tmargin-bottom: 10px;\n}\n.folder-structure.grid li .file-list .dz-media .dz-img {\n\tmax-width: 100%;\n\tmax-height: 100%;\n\tmin-width: 100%;\n\tborder-radius: 10px;\n\tbox-shadow: 0px 10px 10px 0 rgba(0, 0, 0, 0.1);\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.folder-structure.grid li .file-list .dz-media {\n\t\theight: 90px;\n\t\twidth: 120px;\n\t}\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.folder-structure.grid li .file-list .dz-media {\n\t\theight: 90px;\n\t\twidth: 90px;\n\t}\n}\n.folder-structure.grid li .file-list svg {\n\twidth: 80px;\n\theight: 80px;\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.folder-structure.grid li .file-list svg {\n\t\twidth: 60px;\n\t\theight: 60px;\n\t}\n}\n.folder-structure.grid li .file-list:hover {\n\tborder: 1px solid var(--rgba-primary-5);\n\tbackground: var(--rgba-primary-1);\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.folder-structure.grid {\n\t\tpadding: 1rem;\n\t}\n}\n\n.chat-left-area .chat-sidebar {\n\theight: calc(100vh - 82px);\n\tborder-right: 1px solid #d5dfe7;\n\tborder-top: none;\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.chat-left-area .chat-sidebar {\n\t\theight: calc(100vh - 5.9rem);\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.chat-left-area .chat-sidebar {\n\t\tbox-shadow: 0 0 30px 5px rgba(0, 0, 0, 0.05);\n\t}\n}\n\n.message-body {\n\tmin-height: auto !important;\n}\n\n.message-box {\n\tborder-bottom: 1px solid #eeeeee;\n\tpadding-top: 1rem;\n\tpadding-bottom: 1rem;\n}\n.message-box .input-group.search-area {\n\tflex-direction: row-reverse;\n\tmargin-right: 0.625rem;\n\twidth: 100%;\n}\n.message-box .input-group.search-area .input-group-text {\n\tborder: none;\n\tborder-right: none;\n\theight: 3rem;\n\tpadding: 0;\n\tbackground-color: transparent;\n}\n.message-box .input-group.search-area input.form-control {\n\tborder: none;\n\tborder-left: none;\n\tpadding-left: 0;\n\theight: 3rem;\n}\n.message-box img {\n\theight: 5rem;\n\twidth: 5rem;\n\tborder-radius: 0.375rem;\n}\n.message-box h4,\n.message-box .h4 {\n\tfont-weight: 700;\n}\n.message-box span {\n\tfont-size: 1.125rem;\n}\n.message-box .chat-hamburger {\n\tdisplay: flex;\n\talign-items: center;\n}\n.message-box .chat-hamburger .videos-player {\n\tmargin-right: 30px;\n}\n.message-box.style-1 {\n\tpadding: 1rem;\n\theight: 5rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.message-box.style-1 {\n\t\theight: auto;\n\t}\n}\n.message-box.style-1 h4,\n.message-box.style-1 .h4 {\n\tmargin-bottom: 0.25rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.message-box.style-1 h4,\n\t.message-box.style-1 .h4 {\n\t\tmargin-bottom: 0;\n\t\tfont-size: 0.938rem;\n\t}\n}\n.message-box.style-1 span {\n\tfont-size: 14px;\n}\n.message-box.style-1 img {\n\theight: 3rem;\n\twidth: 3rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.message-box.style-1 img {\n\t\theight: 3rem;\n\t\twidth: 3rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.message-box img {\n\t\theight: 3rem;\n\t\twidth: 3rem;\n\t}\n\t.message-box h3,\n\t.message-box .h3 {\n\t\tfont-size: 1rem;\n\t}\n\t.message-box span {\n\t\tfont-size: 0.85rem;\n\t}\n}\n.message-box .add {\n\twidth: 3rem;\n\theight: 3rem;\n\tmin-width: 3rem;\n\tborder-radius: 0.375rem;\n\tpadding: 0;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.chat-people {\n\tpadding: 1.25rem 0;\n}\n\n.chat-tabs > h4,\n.chat-tabs > .h4 {\n\tfont-size: 1.125rem;\n\tpadding-top: 1.125rem;\n\tmargin: 0;\n}\n\n.chat-tabs ul {\n\tpadding: 1rem 0;\n}\n\n.chat-tabs .chat-bx.chats {\n\tposition: relative;\n}\n.chat-tabs .chat-bx.chats .chat-img {\n\tposition: relative;\n}\n.chat-tabs .chat-bx.chats .chat-img::before {\n\tcontent: '';\n\tdisplay: block;\n\tbackground-color: #1eba62;\n\tborder: 2px solid #fff;\n\tposition: absolute;\n\tbottom: -2px;\n\tright: -2px;\n\twidth: 1rem;\n\theight: 1rem;\n\tborder-radius: 50%;\n}\n\n.chat-tabs .chat-bx {\n\tpadding: 0.625rem 0;\n\tposition: relative;\n\tz-index: 1;\n\tdisplay: flex;\n\tcursor: pointer;\n\talign-items: center;\n\tmargin-bottom: 0.5rem;\n}\n.chat-tabs .chat-bx .right-info {\n\twidth: 4.375rem;\n\ttext-align: right;\n}\n.chat-tabs .chat-bx .right-info p {\n\tfont-size: 0.8rem;\n\tmargin-top: 0;\n\tmargin-bottom: 0.5rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.chat-tabs .chat-bx .right-info {\n\t\twidth: 4rem;\n\t}\n}\n.chat-tabs .chat-bx .mid-info {\n\twidth: calc(100% - 9rem);\n}\n.chat-tabs .chat-bx .mid-info .name {\n\tfont-size: 0.938rem;\n\tmargin-bottom: 0.25rem;\n}\n.chat-tabs .chat-bx .mid-info span {\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\tdisplay: block;\n\toverflow: hidden;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.chat-tabs .chat-bx .mid-info {\n\t\twidth: calc(100% - 8rem);\n\t}\n}\n.chat-tabs .chat-bx .chat-img {\n\tposition: relative;\n\tmargin-right: 1rem;\n}\n.chat-tabs .chat-bx .chat-img img {\n\theight: 3rem;\n\twidth: 3rem;\n\tborder-radius: 100%;\n\tmargin-right: 0rem;\n\tobject-fit: cover;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.chat-tabs .chat-bx .chat-img img {\n\t\theight: 3rem;\n\t\twidth: 3rem;\n\t}\n}\n.chat-tabs .chat-bx .chat-img .active {\n\theight: 1rem;\n\twidth: 1rem;\n\tborder: 0.125rem solid #fff;\n\tborder-radius: 0.25rem;\n\tbackground: #fb7d5b;\n\tposition: absolute;\n\tbottom: -0.0625rem;\n\tright: 1rem;\n}\n.chat-tabs .chat-bx .badge {\n\tborder-radius: 0.375rem;\n}\n.chat-tabs .chat-bx:last-child {\n\tborder-bottom: 0;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.chat-tabs .chat-bx {\n\t\tpadding: 0.75rem 0;\n\t}\n}\n.chat-tabs .chat-bx:after {\n\tcontent: none;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\theight: calc(100% + 4px);\n\twidth: calc(100% + 30px);\n\tz-index: -1;\n\tbackground-color: #f0f0f0;\n\tborder-radius: 0.375rem;\n\tmargin: -2px -15px;\n}\n.chat-tabs .chat-bx:hover::before,\n.chat-tabs .chat-bx.active::before {\n\tcontent: '';\n\tdisplay: none;\n}\n.chat-tabs .chat-bx:hover:after,\n.chat-tabs .chat-bx.active:after {\n\tcontent: '';\n}\n.chat-tabs .chat-bx:hover .mid-info h4,\n.chat-tabs .chat-bx:hover .mid-info .h4,\n.chat-tabs .chat-bx.active .mid-info h4,\n.chat-tabs .chat-bx.active .mid-info .h4 {\n\tcolor: var(--primary);\n}\n\n.chat-box-area {\n\theight: calc(100vh - 17.125rem);\n\toverflow-y: scroll;\n}\n.chat-box-area .media .message-received {\n\twidth: 62%;\n\ttext-align: left;\n}\n.chat-box-area .media .message-received p {\n\tbackground: #f5f5f5;\n\ttext-align: left;\n\tborder-radius: 0.375rem;\n\tborder-top-left-radius: 0;\n\tpadding: 0.625rem 1.25rem;\n\tdisplay: table;\n\tcolor: var(--primary);\n}\n.chat-box-area .media .message-received span {\n\tcolor: var(--primary);\n}\n.chat-box-area .media .message-received .dz-media {\n\twidth: 22.75rem;\n\theight: 15.375rem;\n\tpadding: 0.625rem;\n\tbackground-color: #e6ebee;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.chat-box-area .media .message-received {\n\t\twidth: 100%;\n\t}\n}\n.chat-box-area .message-sent {\n\twidth: 62%;\n\ttext-align: right;\n\tmax-width: 83%;\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.chat-box-area .message-sent {\n\t\twidth: 84%;\n\t}\n}\n.chat-box-area .message-sent span {\n\tdisplay: block;\n}\n.chat-box-area .message-sent p {\n\tbackground: var(--primary);\n\ttext-align: left;\n\tborder-radius: 0.375rem;\n\tborder-top-right-radius: 0;\n\tpadding: 0.625rem 1.25rem;\n\tcolor: #fff;\n\tdisplay: inline-block;\n}\n.chat-box-area.style-1 {\n\theight: 21.5rem;\n}\n.chat-box-area.style-1 .message-received p {\n\tbackground: #eeee;\n\tfont-size: 0.875rem;\n}\n.chat-box-area.style-1 .message-sent p {\n\tbackground: var(--primary);\n\tfont-size: 0.875rem;\n\tcolor: #fff;\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.chat-box-area {\n\t\theight: calc(100vh - 16.8rem);\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.chat-box-area {\n\t\theight: calc(100vh - 12.8rem);\n\t}\n}\n\n.type-massage {\n\tpadding: 0.625rem;\n\tborder-radius: 0.375rem;\n\tborder: 1px solid #d5dfe7;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.type-massage {\n\t\tmargin-bottom: 1rem;\n\t}\n}\n.type-massage .input-group textarea {\n\tborder: 0;\n\theight: 3.4375rem !important;\n\tresize: none;\n\tpadding: 1rem 0.9375rem;\n\tborder-bottom: none;\n\tbackground: transparent;\n\tborder-top-left-radius: 0.625rem !important;\n\tborder-bottom-left-radius: 0.625rem !important;\n\toverflow: hidden;\n\twhite-space: nowrap;\n}\n.type-massage .input-group textarea:hover,\n.type-massage .input-group textarea:focus {\n\tbackground: transparent;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.type-massage .input-group textarea {\n\t\theight: 2.5rem !important;\n\t\tline-height: 1.5;\n\t\tpadding: 0.4375rem 0.5rem;\n\t}\n}\n.type-massage .input-group {\n\talign-items: center;\n}\n.type-massage.style-1 {\n\tborder: 0;\n\tmargin: 0;\n\tpadding: 0.375rem;\n\tbackground: rgba(219, 219, 219, 0.25);\n}\n.type-massage.style-1 textarea {\n\tborder: 0;\n\theight: 2.5rem !important;\n\tresize: none;\n\tpadding: 0.0625rem 0.9375rem;\n\tbackground: transparent;\n}\n.type-massage .input-group-append {\n\tdisplay: flex;\n\talign-items: center;\n}\n.type-massage .input-group-append .btn {\n\ttext-align: center;\n\tmargin: 0 0.5rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.type-massage .input-group-append .btn {\n\t\theight: 2.5rem;\n\t\tpadding: 0 0.625rem;\n\t}\n\t.type-massage .input-group-append .btn svg {\n\t\twidth: 1.125rem;\n\t\theight: 1.125rem;\n\t}\n}\n.type-massage .share-btn {\n\theight: 2.5rem;\n\twidth: 2.5rem;\n\tpadding: 0;\n\tbackground: var(--rgba-primary-1);\n\tmargin-right: 1.0625rem;\n\tborder-radius: 0.375rem;\n}\n.type-massage .share-btn svg path {\n\tfill: var(--primary);\n}\n\n.chat-icon {\n\tborder-bottom: 0.0625rem solid #f0f0f0;\n\tpadding-bottom: 1.5625rem;\n}\n.chat-icon ul {\n\tdisplay: flex;\n\tjustify-content: space-around;\n}\n.chat-icon ul li a {\n\theight: 3rem;\n\twidth: 3rem;\n\tbackground: #f0f0f0;\n\tline-height: 3rem;\n\tdisplay: block;\n\tborder-radius: 0.375rem;\n\ttext-align: center;\n}\n.chat-icon ul li a:hover {\n\tbackground: var(--primary);\n}\n.chat-icon ul li a:hover svg path {\n\tfill: #fff;\n}\n\n.share-files {\n\tborder-bottom: 0.0625rem solid #f0f0f0;\n\tpadding-bottom: 1.125rem;\n}\n.share-files:last-child {\n\tborder-bottom: 0;\n}\n.share-files ul li {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 0.5625rem 0;\n\tcursor: pointer;\n}\n.share-files ul li:first-child {\n\tpadding-top: 0;\n}\n.share-files ul li h4,\n.share-files ul li .h4 {\n\twhite-space: nowrap;\n}\n.share-files ul li > div {\n\tflex: 1;\n}\n\n.file {\n\theight: 2.5rem;\n\twidth: 2.5rem;\n\tmin-width: 2.5rem;\n\tline-height: 2.4rem;\n\ttext-align: center;\n\tbackground: #f0f0f0;\n\tdisplay: block;\n\tborder-radius: 0.375rem;\n}\n.file svg {\n\theight: 1.5rem;\n\twidth: 1.5rem;\n}\n\n.share-widget {\n\theight: calc(100vh - 11.25rem);\n\toverflow: hidden;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.share-widget {\n\t\tbox-shadow: 0 0 30px 5px rgba(0, 0, 0, 0.05);\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.share-widget {\n\t\theight: calc(100vh - 9.25rem);\n\t}\n}\n\n.file-list li > div {\n\twidth: calc(100% - 3.5rem);\n}\n.file-list li > div > div {\n\twidth: calc(100% - 3rem);\n}\n\n.file-list li h4,\n.file-list li .h4 {\n\twidth: 3.5rem;\n\ttext-align: right;\n}\n\n.file-list li:hover .file {\n\tbackground: var(--primary);\n}\n.file-list li:hover .file svg path {\n\tfill: #fff;\n}\n\n.file-list .fl-info {\n\tflex: 1;\n}\n.file-list .fl-info span {\n\tfont-size: 0.8rem;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tdisplay: block;\n}\n\n.contact-list li {\n\twidth: 16%;\n\tpadding: 0 0.35rem;\n}\n.contact-list li img {\n\twidth: 100%;\n\tborder-radius: 0.375rem;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.contact-list li {\n\t\tpadding: 0 0.15rem;\n\t}\n}\n.contact-list li:hover img {\n\tfilter: blur(1px);\n}\n\n@media only screen and (max-width: 47.9375rem) {\n\t.chat-left-area {\n\t\twidth: 22rem;\n\t\tposition: absolute;\n\t\tleft: -22rem;\n\t\tz-index: 2;\n\t\t-webkit-transition: all 0.2s;\n\t\t-ms-transition: all 0.2s;\n\t\ttransition: all 0.2s;\n\t}\n\t.chat-left-area.active {\n\t\tleft: 0rem;\n\t}\n}\n\n.chat-right-area .chat-rightarea-btn {\n\tdisplay: none;\n}\n\n@media only screen and (max-width: 87.5rem) {\n\t.chat-right-area {\n\t\twidth: 23rem;\n\t\tposition: absolute;\n\t\tright: -16.5rem;\n\t\t-webkit-transition: all 0.2s;\n\t\t-ms-transition: all 0.2s;\n\t\ttransition: all 0.2s;\n\t}\n\t.chat-right-area.active {\n\t\tright: 4.2rem;\n\t}\n\t.chat-right-area .chat-rightarea-btn {\n\t\tposition: absolute;\n\t\ttop: 7rem;\n\t\tleft: -1.1rem;\n\t\twidth: 2.2rem;\n\t\theight: 3rem;\n\t\tbackground: var(--primary);\n\t\tdisplay: inline-flex;\n\t\tcolor: #fff;\n\t\tfont-size: 1.2rem;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tborder-radius: 0.5rem 0 0 0.5rem;\n\t\t-webkit-transition: all 0.2s;\n\t\t-ms-transition: all 0.2s;\n\t\ttransition: all 0.2s;\n\t}\n\t.chat-right-area .chat-rightarea-btn.active i {\n\t\ttransform: rotateY(180deg);\n\t}\n}\n\n@media only screen and (max-width: 47.9375rem) {\n\t.chat-right-area {\n\t\tright: -22rem;\n\t}\n\t.chat-right-area.active {\n\t\tright: -1.5rem;\n\t}\n}\n\n@media only screen and (max-width: 87.5rem) {\n\t.chat-mid-area {\n\t\tflex: 1;\n\t\toverflow: hidden;\n\t}\n}\n\n@media only screen and (max-width: 47.9375rem) {\n\t.chat-mid-area .chat-hamburger {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\t\tjustify-content: center;\n\t\tline-height: 45px;\n\t\ttext-align: center;\n\t\tcolor: #fff;\n\t\tborder-radius: 50%;\n\t\tposition: relative;\n\t}\n\t.chat-mid-area .chat-hamburger span {\n\t\tdisplay: block;\n\t\theight: 2px;\n\t\tmargin: 2px auto;\n\t\twidth: 20px;\n\t\tborder-radius: 3px;\n\t\tbackground-color: #000;\n\t}\n}\n\n.chart-content {\n\tpadding: 1rem;\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.chart-content {\n\t\tpadding-bottom: 0;\n\t}\n}\n.chart-content .media .dz-media {\n\twidth: 3rem;\n\theight: 3rem;\n\tborder-radius: 0.375rem;\n\toverflow: hidden;\n\tmargin-right: 0.625rem;\n}\n.chart-content .media .dz-media img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.chat-toggle {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tcursor: pointer;\n\tjustify-content: center;\n\theight: 2.5rem;\n\twidth: 2.5rem;\n\tline-height: 2.2rem;\n\ttext-align: center;\n\tcolor: #fff;\n\tborder-radius: 0.375rem;\n\tposition: relative;\n\tdisplay: none;\n\tmargin-right: 0.625rem;\n\tbackground-color: var(--rgba-primary-1);\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.chat-toggle {\n\t\tdisplay: flex;\n\t}\n}\n.chat-toggle svg {\n\twidth: 25px;\n\theight: 25px;\n}\n.chat-toggle svg g path {\n\tfill: var(--primary);\n}\n.chat-toggle::before {\n\tcontent: '';\n\tdisplay: block;\n\tposition: absolute;\n\ttop: 0;\n\tleft: -50vw;\n\twidth: 100vw;\n\theight: 100vh;\n}\n.chat-toggle span {\n\tdisplay: block;\n\theight: 2px;\n\tmargin: 2px auto;\n\twidth: 20px;\n\tborder-radius: 3px;\n\tbackground-color: #000;\n}\n\n.chat-toggle.active::before {\n\tz-index: 1;\n}\n\n@media only screen and (max-width: 61.9375rem) {\n\t.error-page {\n\t\ttext-align: center;\n\t}\n}\n\n.error-page .error-text {\n\tfont-size: 150px;\n\tline-height: 1;\n\tfont-weight: 700;\n\tmargin-bottom: 0;\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.error-page .error-text {\n\t\tfont-size: 130px;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.error-page .error-text {\n\t\tfont-size: 80px;\n\t}\n}\n\n.error-page h4,\n.error-page .h4 {\n\tfont-size: 44px;\n\tmargin-bottom: 0;\n\tline-height: 1.2;\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.error-page h4,\n\t.error-page .h4 {\n\t\tfont-size: 37px;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.error-page h4,\n\t.error-page .h4 {\n\t\tfont-size: 27px;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.error-page h4,\n\t.error-page .h4 {\n\t\tfont-size: 20px;\n\t}\n}\n\n.error-page p {\n\tfont-size: 18px;\n\tcolor: #c2c2c2;\n\tmargin-bottom: 30px;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.error-page p {\n\t\tfont-size: 1rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.error-page p {\n\t\tfont-size: 14px;\n\t}\n}\n\n.move-1 {\n\t-webkit-animation: move1 5s infinite;\n\tanimation: move1 5s infinite;\n}\n\n@-webkit-keyframes move1 {\n\t0% {\n\t\t-webkit-transform: rotate(-1deg) translate(-2px, -2px);\n\t\ttransform: rotate(-1deg) translate(-2px, -2px);\n\t}\n\t50% {\n\t\t-webkit-transform: rotate(1deg) translate(2px, 2px);\n\t\ttransform: rotate(1deg) translate(2px, 2px);\n\t}\n\t100% {\n\t\t-webkit-transform: rotate(-1deg) translate(-2px, -2px);\n\t\ttransform: rotate(-1deg) translate(-2px, -2px);\n\t}\n}\n\n.flex-row-fluid {\n\t-webkit-box-flex: 1;\n\tflex: 1 auto;\n\t-ms-flex: 1 0 0rem;\n\tmin-width: 0;\n}\n\n.page-r-logo img {\n\twidth: 200px;\n}\n\n.authincation {\n\tbackground: var(--rgba-primary-1);\n\tdisplay: flex;\n\tmin-height: 100vh;\n}\n.authincation .login-aside {\n\tbackground: #fff;\n\tpadding-top: 5rem;\n\tmax-width: 35rem;\n\twidth: 100%;\n\tz-index: 1;\n\tposition: relative;\n}\n.authincation .login-aside:after {\n\tcontent: '';\n\tclip-path: polygon(0% 100%, 100% 0%, 0% 0%);\n\twidth: 8.75rem;\n\theight: 100%;\n\tposition: absolute;\n\tright: -8.75rem;\n\tz-index: -1;\n\ttop: 0;\n\tbackground: #fff;\n\tbox-shadow: 0.125rem 0rem 1.875rem rgba(0, 0, 0, 0.15);\n}\n.authincation .login-aside .aside-image {\n\tmin-height: 28.125rem;\n\tmargin: auto 0;\n\tmin-width: 0;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.authincation .login-aside {\n\t\tmax-width: 22.5rem;\n\t}\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.authincation .login-aside {\n\t\tmax-width: 100%;\n\t\tpadding-top: 0;\n\t}\n\t.authincation .login-aside:after {\n\t\tcontent: none;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.authincation .login-aside .aside-image {\n\t\tmin-height: 18.75rem;\n\t}\n}\n\n.authincation-content {\n\tbackground: #fff;\n\tbox-shadow: 0 0 2.1875rem 0 rgba(154, 161, 171, 0.15);\n\tborder-radius: 0.3125rem;\n}\n[data-theme-version='dark'] .authincation-content {\n\tbackground: #272738;\n\tbox-shadow: none;\n}\n.authincation-content.style-1 {\n\tbackground: rgba(255, 255, 255, 0.5);\n\tbackdrop-filter: blur(1.25rem);\n}\n.authincation-content.style-1 .form-control {\n\tbackground: rgba(255, 255, 255, 0.6);\n\tborder-radius: 0.3125rem;\n}\n.authincation-content.style-1 .user-icon {\n\theight: 6.25rem;\n\tbackground: var(--primary);\n\twidth: 6.25rem;\n\ttext-align: center;\n\tborder-radius: 6.25rem;\n\tline-height: 6.25rem;\n\tmargin-left: auto;\n\tfont-size: 3.75rem;\n\ttext-align: center;\n\tcolor: white;\n\tmargin-right: auto;\n\tmargin-top: -6.25rem;\n\tmargin-bottom: 1.25rem;\n}\n.authincation-content.style-2 {\n\tbackground: transparent;\n\tbox-shadow: none;\n\tmax-width: 33.125rem;\n\twidth: 100%;\n}\n.authincation-content.style-2 .form-control {\n\tborder: 0;\n\tborder-radius: 0.3125rem;\n\tbox-shadow: 0rem 0rem 0.9375rem rgba(0, 0, 0, 0.08);\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.authincation-content.style-2 .auth-form {\n\t\tpadding: 1.875rem 0rem;\n\t}\n}\n\n.welcome-content {\n\tbackground: url('./../images/1.jpg');\n\tbackground-size: cover;\n\tbackground-position: center;\n\theight: 100%;\n\tpadding: 4.6875rem 3.125rem;\n\tposition: relative;\n\tz-index: 1;\n\tborder-top-left-radius: 0.3125rem;\n\tborder-bottom-left-radius: 0.3125rem;\n}\n.welcome-content::after {\n\tcontent: '';\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\tbackground: var(--primary);\n\topacity: 0.75;\n\tz-index: -1;\n\tborder-top-left-radius: 0.3125rem;\n\tborder-bottom-left-radius: 0.3125rem;\n}\n.welcome-content .welcome-title {\n\tcolor: #fff;\n\tfont-weight: 500;\n\tfont-size: 1.25rem;\n}\n.welcome-content p {\n\tcolor: #fff;\n}\n.welcome-content .brand-logo a {\n\tdisplay: inline-block;\n\tmargin-bottom: 1.25rem;\n\tfont-weight: 700;\n\tcolor: #fff;\n\tfont-size: 1.25rem;\n}\n.welcome-content .brand-logo a img {\n\twidth: 6.25rem;\n}\n.welcome-content .intro-social {\n\tposition: absolute;\n\tbottom: 4.6875rem;\n}\n.welcome-content .intro-social ul {\n\tmargin-bottom: 0;\n}\n.welcome-content .intro-social ul li {\n\tdisplay: inline-block;\n}\n.welcome-content .intro-social ul li a {\n\tcolor: #fff;\n\tfont-size: 0.875rem;\n\tpadding: 0rem 0.4375rem;\n}\n\n.auth-form {\n\tpadding: 3.125rem 3.125rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.auth-form {\n\t\tpadding: 1.875rem;\n\t}\n}\n.auth-form .btn {\n\theight: 3.125rem;\n\tfont-weight: 700;\n}\n.auth-form .page-back {\n\tdisplay: inline-block;\n\tmargin-bottom: 0.9375rem;\n}\n\n.slideskew {\n\tanimation: 5s ease 0s normal none infinite running slideskew;\n}\n\n@keyframes slideskew {\n\t0% {\n\t\ttransform: translateY(0px);\n\t\topacity: 1;\n\t}\n\t50% {\n\t\ttransform: translateY(20px);\n\t\t-moz-transform: translateY(20px);\n\t\t-webkit-transform: translateY(20px);\n\t\t-ms-transform: translateY(20px);\n\t\t-o-transform: translateY(20px);\n\t}\n\t100% {\n\t\ttransform: translateY(0);\n\t\t-moz-transform: translateY(0);\n\t\t-webkit-transform: translateY(0);\n\t\t-ms-transform: translateY(0);\n\t\t-o-transform: translateY(0);\n\t}\n}\n\n.sign-bg {\n\tbackground-size: cover;\n\tbackground-position: center;\n\tposition: relative;\n\tz-index: 1;\n}\n.sign-bg:after {\n\tcontent: '';\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\tbackground: #dbe9f3;\n\topacity: 0.5;\n\theight: 100%;\n\tz-index: -1;\n}\n.sign-bg .bitcoin-img {\n\twidth: 70%;\n}\n\n.sign-in-your {\n\tpadding: 10vh 0;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tmax-width: 350px;\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.sign-in-your {\n\t\tpadding: 5vh 0;\n\t}\n}\n\n.heading {\n\tfont-size: 1.125rem;\n\tfont-weight: 600;\n\tline-height: 1.5;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.heading {\n\t\tfont-size: 1rem;\n\t}\n}\n\n.heading-lg {\n\tfont-size: 1.5rem;\n}\n\n.subtitle {\n\tfont-size: 2.25rem;\n}\n\n.default-select .dropdown-toggle::after {\n\tdisplay: inline-block;\n\tmargin-left: 0;\n\tvertical-align: unset;\n\tcontent: '';\n\twidth: 0.5rem;\n\theight: 0.5rem;\n\tborder-top: 2px solid #666;\n\tborder-right: 2px solid #666;\n\ttransform: rotate(135deg);\n\tborder-bottom: none;\n\tborder-left: none;\n\tmargin: 0;\n\tpadding: 0;\n\tmargin-bottom: 0.25rem;\n}\n\n.default-select.dropup .dropdown-toggle::after {\n\ttransform: rotate(-45deg);\n\tmargin-bottom: 0;\n}\n\n.bootstrap-datetimepicker-widget .datepicker {\n\tpadding: 20px;\n\toverflow: hidden;\n\tborder-radius: 0.375rem;\n}\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th {\n\tbackground-color: transparent;\n\tpadding: 10px 5px;\n}\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.prev,\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.picker-switch,\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.next {\n\tcolor: #303972;\n}\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed td.day {\n\tmargin-bottom: 0;\n\tpadding: 0;\n\tfont-size: 14px;\n\tcolor: #303972;\n\twidth: 55px;\n\theight: 55px;\n\tline-height: 40px;\n\tborder-radius: 0.625rem;\n}\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td {\n\tbackground-color: transparent !important;\n\tbackground-image: none !important;\n\ttext-shadow: none !important;\n\tbox-shadow: none;\n\tposition: relative;\n\tz-index: 1;\n}\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td:before {\n\tcontent: '';\n\tposition: absolute;\n\tz-index: -1;\n\theight: 30px;\n\twidth: 30px;\n\tborder-radius: 25px;\n\ttop: 50%;\n\tleft: 50%;\n\tbackground-color: #4d44b5;\n\ttransform: translate(-50%, -50%);\n\tborder: 0;\n\topacity: 0;\n}\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td.today:hover {\n\tbackground-color: #fff;\n\tbox-shadow: none;\n\tcolor: #fff !important;\n}\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td.today,\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td.active {\n\tcolor: #fff;\n}\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td.today:before,\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td.active:before {\n\topacity: 1;\n}\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed tr td.active:before {\n\tbackground-color: #fb7d5b;\n}\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed th {\n\tfont-size: 15px;\n\tfont-weight: 500;\n}\n.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed td.day.active.today:hover {\n\tborder-bottom: transparent;\n}\n\n.datepicker {\n\tpadding: 15px;\n}\n.datepicker th {\n\tpadding: 10px;\n}\n\n.table-condensed {\n\twidth: 100%;\n}\n\n.picker-switch.accordion-toggle .table-condensed td {\n\tdisplay: none;\n}\n\n.card .card-box-icon {\n\twidth: 4.5rem;\n\theight: 4.5rem;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder: 1px solid #eeeeee;\n\tborder-radius: 0.375rem;\n\tmargin-right: 0.938rem;\n}\n\n.card .chart-num h2,\n.card .chart-num .h2 {\n\tfont-size: 1.5rem;\n\tmargin-bottom: 0;\n\tline-height: 1;\n}\n\n.card .chart-num p {\n\tfont-size: 0.963rem;\n\tmargin-bottom: 0.313rem;\n\tline-height: 1rem;\n}\n\n.counter .chart-num {\n\tmargin-bottom: 0.675rem;\n}\n\n.counter .card-body {\n\tpadding: 2.813rem 0 2.813rem 2.813rem;\n}\n.counter .card-body .card-box-icon {\n\tmargin-right: 1.25rem;\n}\n\n.round {\n\tmargin-right: 1.5rem;\n\tposition: relative;\n\tpadding-left: 2.2rem;\n\tcursor: pointer;\n\tfont-size: 0.875rem;\n\tuser-select: none;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.round {\n\t\tpadding-left: 1.8rem;\n\t}\n}\n.round input {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\theight: 1.25rem;\n\twidth: 6.25rem;\n\tbackground-color: #ffffff;\n\topacity: 0;\n}\n.round span {\n\tcolor: #303972;\n}\n.round .checkmark {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 20%;\n\ttransform: translate(-50%, 50%);\n\theight: 0.75rem;\n\twidth: 0.75rem;\n\tbackground-color: #ffffff;\n\tborder-radius: 50%;\n\tborder: 3px solid var(--secondary);\n\tpadding: 2px;\n\tmargin: 0;\n}\n.round .checkmark2 {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 0;\n\ttransform: translateY(-50%);\n\theight: 1.35rem;\n\twidth: 1.35rem;\n\tbackground-color: #ffffff;\n\tborder-radius: 50%;\n\tborder: 2px solid var(--primary);\n\tpadding: 0.2rem;\n}\n\n.round.weekly .checkmark {\n\tborder: 3px solid var(--primary);\n}\n\n.round:hover input ~ .checkmark {\n\tbackground-color: #ffffff;\n}\n\n.round input:checked ~ .checkmark {\n\tbackground-color: #ffffff;\n\tborder: 2px solid #fcc43e;\n}\n\n.round.weekly input:checked ~ .checkmark {\n\tbackground-color: #ffffff;\n\tborder: 2px solid var(--secondary);\n}\n\n.checkmark:after {\n\tcontent: '';\n\tposition: absolute;\n\tdisplay: none;\n}\n\n.round input:checked ~ .checkmark:after {\n\tdisplay: block;\n}\n\n.round.weekly input:checked ~ .checkmark:after {\n\tdisplay: block;\n\tbackground-color: var(--secondary);\n}\n\n.round .checkmark:after {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: #fcc43e;\n\tborder-radius: 50%;\n\tposition: relative;\n}\n\n.round.disabled {\n\topacity: 1;\n}\n\n.toggle-btn {\n\tmargin-right: 1.8rem;\n\tposition: relative;\n\tpadding-left: 2rem;\n\tcursor: pointer;\n\tfont-size: 0.875rem;\n\tuser-select: none;\n}\n.toggle-btn input {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\theight: 1.25rem;\n\twidth: 6.25rem;\n\tbackground-color: #ffffff;\n\topacity: 0;\n}\n.toggle-btn span {\n\tcolor: #ffffff;\n}\n.toggle-btn h4,\n.toggle-btn .h4 {\n\tcolor: #ffffff;\n}\n.toggle-btn .check {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 0;\n\ttransform: translateY(-50%);\n\theight: 22px;\n\twidth: 22px;\n\tbackground-color: var(--primary);\n\tborder-radius: 50%;\n\tborder: 3px solid #fff;\n\tpadding: 2px;\n}\n\n.toggle-btn input:checked ~ .check {\n\tbackground-color: var(--primary);\n\tborder: 3px solid #fff;\n}\n\n.check:after {\n\tcontent: '';\n\tposition: absolute;\n\tdisplay: none;\n}\n\n.toggle-btn input:checked ~ .check:after {\n\tdisplay: block;\n}\n\n.toggle-btn .check:after {\n\twidth: 82%;\n\theight: 82%;\n\tbackground-color: #fff;\n\tborder-radius: 50%;\n\ttop: 1px;\n\tleft: 1px;\n\tposition: relative;\n}\n\n.toggle-btn.expense .check {\n\tborder: 3px solid #fffa6f;\n}\n\n.toggle-btn.expense input:checked ~ .check {\n\tbackground-color: var(--primary);\n\tborder: 3px solid #fffa6f;\n}\n\n.toggle-btn.expense .check:after {\n\tbackground-color: #fffa6f;\n}\n\n.progressbar {\n\tbox-shadow: none;\n}\n\n.expense .students1 {\n\tpadding: 0 10px;\n}\n\n#wallet-bar {\n\tbackground-color: #ffffff;\n\tz-index: 4;\n}\n@media only screen and (max-width: 87.5rem) {\n\t#wallet-bar {\n\t\tz-index: 4;\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t#wallet-bar {\n\t\tz-index: 8;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t#wallet-bar {\n\t\tz-index: 8;\n\t}\n}\n#wallet-bar.dlab-scroll {\n\toverflow-y: scroll;\n}\n\n.student {\n\tposition: relative;\n\tmargin: 0;\n\tz-index: 1;\n\tpadding: 0.925rem 0;\n}\n.student .dz-media {\n\tmargin-right: 0.938rem;\n}\n.student .user-info .name {\n\tfont-size: 0.875rem;\n\tfont-weight: 600;\n\tmargin-bottom: 0.2rem;\n}\n.student .indox {\n\tmargin-left: auto;\n}\n.student:hover .indox a {\n\tbackground-color: var(--rgba-primary-1);\n}\n.student:hover .indox a svg path {\n\tfill: var(--primary);\n}\n.student:hover .indox a::before {\n\tbackground-color: var(--primary);\n}\n\na.btn.dlab-load-more {\n\tpadding: 0.69375rem 1.5rem;\n\tfont-weight: 500;\n}\n\n.wallet-bar .wallet-bar-header {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 0px 1.125rem;\n}\n\n@media only screen and (max-width: 35.9375rem) {\n\t.p-static {\n\t\tdisplay: none;\n\t}\n}\n\n.mail-img {\n\tposition: absolute;\n\tbottom: 0%;\n\tright: 0;\n}\n\n.user_reviews {\n\tpadding: 1.125rem 0;\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.user_reviews {\n\t\tpadding: 1.125rem 0;\n\t}\n}\n\n.element-area {\n\tdisplay: flex;\n}\n.element-area .demo-view {\n\twidth: calc(100% - 270px);\n}\n@media only screen and (max-width: 100rem) {\n\t.element-area .demo-view {\n\t\twidth: calc(100% - 236px);\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.element-area .demo-view {\n\t\twidth: calc(100% - 224px);\n\t}\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.element-area .demo-view {\n\t\twidth: 100%;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.element-area .demo-view {\n\t\twidth: 100%;\n\t}\n\t.element-area .demo-view .container-sm {\n\t\tpadding: 0;\n\t}\n}\n.element-area .demo-right {\n\twidth: 16.875rem;\n\tposition: sticky;\n\ttop: 7rem;\n\theight: calc(100% - 140px);\n\tz-index: 1;\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.element-area .demo-right {\n\t\twidth: 15.875rem;\n\t}\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.element-area .demo-right {\n\t\tdisplay: none;\n\t}\n}\n@media only screen and (max-width: 47.9375rem) {\n\t.element-area .demo-right {\n\t\tdisplay: none;\n\t}\n}\n.element-area .demo-right.sticky {\n\ttop: 100px;\n\ttransition: 0.5s;\n}\n\n.demo-right-inner {\n\tpadding: 1rem 2.225rem;\n\tbackground-color: #fff;\n\tborder-radius: 0.375rem;\n\theight: 100%;\n\toverflow: hidden;\n}\n.demo-right-inner h4,\n.demo-right-inner .h4 {\n\tpadding: 0.625rem 0;\n}\n.demo-right-inner li {\n\tfont-size: 0.9rem;\n}\n.demo-right-inner li a {\n\tdisplay: block;\n\tpadding: 0.375rem 0.25rem;\n}\n\n.fc .fc-toolbar.fc-header-toolbar {\n\tflex-wrap: wrap;\n\tmargin-bottom: 0;\n}\n\n.fc .fc-button-group {\n\tmargin-bottom: 0.625rem;\n\tz-index: 0;\n}\n\n/* work */\n.food {\n\tmargin-bottom: 25px;\n}\n.food .dz-media img {\n\tborder-radius: 6px;\n\twidth: 100%;\n\theight: 160px;\n\tmargin-bottom: 10px;\n}\n\n.doller {\n\tcolor: #303972;\n}\n\n.trans-list {\n\tdisplay: flex;\n\talign-items: center;\n}\n.trans-list h4,\n.trans-list .h4 {\n\tmargin-bottom: 0;\n\tfont-size: 14px;\n}\n\n.table-pagenation {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tflex-wrap: wrap;\n\tmargin-top: 0.625rem;\n\tpadding: 0 25px;\n\t/* .page-link {\n\t\tbackground: #fff;\n\t\tborder-color: transparent;\n\t} */\n}\n.table-pagenation p {\n\tmargin-left: 0.475rem;\n}\n.table-pagenation p span {\n\tcolor: var(--primary) !important;\n\tmargin: 0 0.2rem;\n}\n.table-pagenation .pagination .page-item.page-indicator .page-link {\n\tbackground-color: transparent;\n\tcolor: #a098ae;\n}\n.table-pagenation .pagination .page-item.page-indicator .page-link:hover {\n\tbackground-color: var(--primary);\n}\n.table-pagenation .pagination.no-bg li:not(.page-indicator):not(.active) .page-link {\n\tborder: 1px solid var(--primary);\n}\n\n.heart {\n\twidth: 60px;\n\theight: 60px;\n\tdisplay: inline-block;\n\tbackground: url('../images/like.png');\n\tcursor: pointer;\n\tmargin: -25px -15px;\n}\n\n.heart-blast {\n\tbackground-position: -1680px 0;\n\ttransition: background 1s steps(28);\n}\n\n/* date picker */\n.bootstrap-select:not([class*='col-']):not([class*='form-control']):not(.input-group-btn) {\n\twidth: 207px;\n}\n\n.bs-select.border-transparent .btn {\n\tborder-color: transparent;\n\tcolor: #303972;\n}\n\n/* date picker */\ntr .trans-td-list {\n\tfont-size: 18px;\n}\n\n/* custom css */\n.avatar {\n\twidth: 3rem;\n\theight: 3rem;\n\tobject-fit: cover;\n\tborder-radius: 100%;\n\tposition: relative;\n\tdisplay: inline-block;\n}\n.avatar.avatar-lg {\n\twidth: 3.75rem;\n\theight: 3.75rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.avatar.avatar-lg {\n\t\twidth: 2.95rem;\n\t\theight: 2.95rem;\n\t}\n}\n.avatar.avatar-xl {\n\twidth: 7.5rem;\n\theight: 7.5rem;\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.avatar.avatar-xl {\n\t\twidth: 5rem;\n\t\theight: 5rem;\n\t}\n}\n.avatar.avatar-xxl {\n\twidth: 9.375rem;\n\theight: 9.375rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.avatar.avatar-xxl {\n\t\twidth: 7.375rem;\n\t\theight: 7.375rem;\n\t}\n}\n.avatar.avatar-sm {\n\twidth: 30px;\n\theight: 30px;\n}\n\n.icon-box {\n\twidth: 48px;\n\theight: 48px;\n\tline-height: 45px;\n\ttext-align: center;\n\tposition: relative;\n\tdisplay: inline-block;\n\tborder-radius: 100%;\n\t-webkit-transition: all 0.8s;\n\t-ms-transition: all 0.8s;\n\ttransition: all 0.8s;\n}\n.icon-box svg {\n\twidth: 1.188rem;\n}\n.icon-box i {\n\ttransform: scale(2);\n}\n.icon-box.icon-box-sm {\n\theight: 2.5rem;\n\twidth: 2.5rem;\n\tline-height: 2.5rem;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n.icon-box.icon-box-xs {\n\twidth: 2.188rem;\n\theight: 2.188rem;\n\tline-height: 2.188rem;\n}\n.icon-box.icon-box-lg {\n\theight: 3.75rem;\n\twidth: 3.75rem;\n\tline-height: 3.625rem;\n\tmin-width: 3.75rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.icon-box.icon-box-lg {\n\t\twidth: 3.125rem;\n\t\theight: 3.125rem;\n\t\tline-height: 2.938rem;\n\t\tmin-width: 3.125rem;\n\t}\n}\n.icon-box.icon-box-xl {\n\theight: 3.75rem;\n\twidth: 3.75rem;\n\tline-height: 3.75rem;\n}\n\n.st-box {\n\tborder: 2px solid #a098ae;\n}\n\n/* new scss */\n.content-box {\n\tdisplay: flex;\n\talign-items: center;\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.content-box {\n\t\tmargin-bottom: 15px;\n\t}\n}\n.content-box .std-data {\n\tbackground-color: var(--primary);\n}\n.content-box .teach-data {\n\tbackground-color: var(--secondary);\n}\n.content-box .event-data {\n\tbackground-color: #fcc43e;\n}\n.content-box .food-data {\n\tbackground-color: #303972;\n}\n.content-box .std-data,\n.content-box .teach-data,\n.content-box .event-data,\n.content-box .food-data {\n\tmargin-right: 10px;\n}\n\n.table.short-one thead th {\n\tcolor: #303972;\n}\n\n.table.short-one tbody {\n\ttext-align: center;\n\tfont-size: 1rem;\n\tfont-weight: 500;\n}\n\n.student.border-bottom {\n\tborder-bottom: 1px solid var #b3b1cb !important;\n}\n\n.name {\n\tmargin-bottom: 4px;\n}\n\n.modal-dialog-center {\n\tmin-height: calc(100% - 3.5rem);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.table-responsive.full-data thead th {\n\tborder-bottom: 0;\n}\n.table-responsive.full-data thead th:first-child {\n\tpadding-left: 21px;\n\tpadding-right: 0;\n}\n\n.table-responsive.full-data td:first-child {\n\tpadding-right: 0;\n}\n\n.table-responsive.full-data tbody h6,\n.table-responsive.full-data tbody .h6 {\n\tfont-size: 0.875rem;\n\tfont-weight: 500;\n}\n\n.table-responsive.full-data tbody .icon-box-sm {\n\twidth: 2.188rem;\n\theight: 2.188rem;\n\tline-height: 2.188rem;\n\tcursor: pointer;\n}\n.table-responsive.full-data tbody .icon-box-sm svg {\n\twidth: 1rem;\n\theight: 1rem;\n}\n\n.table-responsive.full-data tbody .avatar {\n\twidth: 2.188rem;\n\theight: 2.188rem;\n}\n\n.table-responsive.full-data tbody .sharp {\n\twidth: 1.25rem;\n\theight: 1.25rem;\n}\n\n.table-responsive.full-data .table > :not(:first-child) {\n\tborder-top: 0;\n}\n\n.table-responsive .order-table th:first-child,\n.table-responsive .order-table td:first-child {\n\tpadding-right: 0;\n}\n\n.table-responsive .table-striped th {\n\tbackground-color: #fff;\n\tcolor: #303972;\n\tfont-weight: 600;\n}\n\n/* user */\n.bell-icon .nav-link {\n\tposition: relative;\n}\n.bell-icon .nav-link:before {\n\tposition: absolute;\n\tcontent: '';\n\tbackground-color: var(--primary);\n\twidth: 7px;\n\theight: 7px;\n\tborder-radius: 100%;\n\ttop: 10px;\n\tright: 15px;\n\tanimation: blinking 1s infinite;\n}\n@media only screen and (max-width: 106.25rem) {\n\t.bell-icon .nav-link:before {\n\t\ttop: 8px;\n\t\tright: 12px;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.bell-icon .nav-link:before {\n\t\twidth: 5px;\n\t\theight: 5px;\n\t\ttop: 5px;\n\t\tright: 8px;\n\t}\n}\n\n.dd-item {\n\tcursor: all-scroll;\n}\n\n.sweet-image {\n\twidth: 20%;\n}\n\n.clockpicker-popover {\n\tposition: absolute;\n\tborder-radius: 0.375rem;\n\tborder-color: transparent;\n}\n\n.demo-right-inner li {\n\tposition: relative;\n}\n.demo-right-inner li.active a {\n\tcolor: var(--primary);\n\tfont-weight: 500;\n}\n.demo-right-inner li.active:after {\n\tbackground-color: var(--primary);\n}\n.demo-right-inner li .scroll:after {\n\tposition: absolute;\n\tcontent: '';\n\tbackground-color: #ebebf9;\n\theight: 5px;\n\twidth: 5px;\n\tborder-radius: 100%;\n\ttop: 15px;\n\tleft: -17px;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.demo-right-inner li .scroll:after {\n\t\ttop: 12px;\n\t}\n}\n.demo-right-inner li .scroll.active {\n\tcolor: var(--primary);\n\tfont-weight: 500;\n}\n.demo-right-inner li .scroll.active:after {\n\tbackground-color: var(--primary);\n}\n\n.page-title .bootstrap-select:not([class*='col-']):not([class*='form-control']):not(.input-group-btn) {\n\twidth: 7.688rem;\n}\n\n.all {\n\tdisplay: none !important;\n}\n.all .dropdown-menu {\n\tborder-radius: 0.375rem;\n}\n.all .dropdown-menu .nav-link {\n\twidth: 2.5rem;\n\tmin-width: 2.5rem;\n\theight: 2.5rem;\n\tmargin-right: 0.313rem;\n}\n.all .svg-main-icon path {\n\tfill: #a098ae;\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.all {\n\t\tdisplay: inline-flex !important;\n\t}\n\t.all .dropdown-menu.show {\n\t\theight: auto;\n\t\twidth: 8.75rem;\n\t\tmin-width: 11.15rem;\n\t}\n\t.all .dropdown-menu.show svg {\n\t\twidth: 1rem;\n\t\theight: 1rem;\n\t}\n}\n@media only screen and (max-width: 74.9375rem) and (max-width: 47.9375rem) {\n\t.all .dropdown-menu.show {\n\t\tright: 13.6rem;\n\t\ttop: 4.85rem;\n\t}\n}\n@media only screen and (max-width: 74.9375rem) and (max-width: 35.9375rem) {\n\t.all .dropdown-menu.show {\n\t\tright: 7.9rem;\n\t\ttop: 4.85rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.all {\n\t\ttop: 77px;\n\t\tborder-radius: 0;\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.all .menu-wallet,\n\t.all .dz-theme-mode,\n\t.all .dz-fullscreen {\n\t\tdisplay: inline-flex !important;\n\t}\n}\n.all .card-header {\n\tborder-radius: 0.375rem !important;\n\tbackground-color: var(--rgba-primary-1);\n}\n\n@media only screen and (max-width: 74.9375rem) {\n\t.menu-wallet,\n\t.dz-theme-mode,\n\t.dz-fullscreen {\n\t\tdisplay: none !important;\n\t}\n}\n\n.order-table thead th {\n\tcolor: #fff;\n}\n\n@keyframes blinking {\n\t0% {\n\t\tbackground-color: var(--primary);\n\t}\n\t100% {\n\t\tbackground-color: transparent;\n\t}\n}\n\n.search-area-header ul li i {\n\tcursor: pointer;\n}\n\n.page-title {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 1rem 1.25rem;\n\tmargin-bottom: 1.875rem;\n\tborder-radius: 0.375rem;\n\tposition: relative;\n\tz-index: 1;\n\tbackground-color: #fff;\n}\n.page-title .search-area {\n\twidth: 21.875rem;\n\tflex-direction: row-reverse;\n\tborder: 1px solid transparent;\n\toverflow: hidden;\n\tborder-radius: 0.375rem;\n\tbox-sizing: border-box;\n\tborder: 1px solid #eeeeee;\n\theight: 3rem;\n}\n.page-title .search-area .form-control {\n\tborder-right: 0;\n\tborder: none;\n\tpadding: 0rem;\n\tborder-radius: 0 0.375rem 0.375rem 0;\n\tpadding-left: 0.2rem;\n\theight: 3rem;\n\tline-height: 3rem;\n}\n.page-title .search-area .form-control:focus {\n\tborder-color: white;\n\tbox-shadow: none;\n}\n.page-title .search-area .input-group-text {\n\tbackground: #fff;\n\tborder: none;\n\tpadding-right: 20px;\n\theight: 3rem;\n\tborder-radius: 0.375rem 0 0 0.375rem;\n}\n.page-title .search-area .input-group-text svg {\n\ttransform: scale(1.2);\n}\n.page-title .search-area .input-group-text svg path {\n\tfill: var(--primary);\n}\n\n.box-1 {\n\toverflow: hidden;\n}\n.box-1 .max {\n\tposition: relative;\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\tpadding: 30px;\n\toverflow: hidden;\n}\n.box-1 .max .item {\n\tposition: absolute;\n\tbottom: 25px;\n}\n.box-1 .max .item .text {\n\tcolor: white;\n\tmargin-bottom: 20px;\n}\n.box-1 .max .dropdown {\n\tposition: absolute;\n\tright: 25px;\n}\n.box-1 .max-2 {\n\tpadding: 30px;\n}\n.box-1 .max-2 .ul-li {\n\tmargin-bottom: 20px;\n}\n.box-1 .max-2 .ul-li ul li {\n\tdisplay: flex;\n\talign-items: center;\n}\n.box-1 .max-2 a {\n\tfont-size: 18px;\n\twidth: 100%;\n\tmargin-top: 1.625rem;\n}\n\n.btn-check:checked + .btn:active,\n:not(.btn-check) + .btn:active:active,\n.btn:first-child:active:active,\n.btn.active:active,\n.btn.show:active {\n\tborder-color: transparent;\n}\n\n.search-area {\n\twidth: 25rem;\n\tflex-direction: row-reverse;\n\tborder: 1px solid #dddddd;\n\toverflow: hidden;\n\tborder-radius: 0.375rem;\n\tbox-sizing: border-box;\n\theight: 3rem;\n}\n@media only screen and (max-width: 117.5rem) {\n\t.search-area {\n\t\twidth: 22rem;\n\t}\n}\n@media only screen and (max-width: 81.25rem) {\n\t.search-area {\n\t\twidth: 17.5rem;\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.search-area {\n\t\twidth: 15.625rem;\n\t}\n}\n.search-area .form-control {\n\tfont-size: 15px;\n\tborder-right: 0;\n\tborder: none;\n\tpadding: 0rem;\n\tborder-radius: 0 0.375rem 0.375rem 0;\n\tpadding-left: 0.2rem;\n\theight: 3rem;\n}\n.search-area .form-control:focus {\n\tborder-color: white;\n\tbox-shadow: none;\n}\n.search-area .input-group-text {\n\tbackground: #fff;\n\tborder: none;\n\theight: 3rem;\n\tborder-radius: 0.375rem 0 0 0.375rem;\n}\n.search-area .input-group-text svg {\n\ttransform: scale(1.2);\n}\n.search-area .input-group-text svg path {\n\tfill: var(--primary);\n}\n\n.nav-link.menu-wallet.main {\n\tbackground-color: var(--rgba-primary-1);\n}\n.nav-link.menu-wallet.main svg path {\n\tfill: #fff;\n\tstroke: #fff;\n}\n\n@media only screen and (max-width: 35.9375rem) {\n\t.card.Custom-select .input-group-text {\n\t\tpadding: 0.4875rem 1.25rem;\n\t}\n}\n\n.table.table-details tbody td:first-child {\n\tpadding-left: 0;\n}\n\n.table.table-details tbody tr:last-child td {\n\tborder: 0;\n}\n\n.table-responsive.basic-tbl thead th:last-child {\n\ttext-align: end;\n}\n\n.table-responsive.basic-tbl td:last-child {\n\ttext-align: end;\n}\n\n.table-responsive.basic-tbl .dataTables_info {\n\tpadding-top: 18px;\n\tcolor: #a098ae;\n\tpadding-left: 25px;\n}\n\n.table-responsive.basic-tbl .dataTables_wrapper .dataTables_paginate {\n\tpadding-right: 9px;\n}\n\n.student {\n\tcursor: pointer;\n}\n.student:hover a {\n\tcolor: var(--primary);\n}\n.student:hover .st-box {\n\tbackground-color: var(--primary);\n\tborder-color: var(--primary);\n}\n.student:hover .st-box svg path {\n\tfill: #fff;\n}\n\n.gallery-media {\n\theight: 150px;\n\tobject-fit: cover;\n\tobject-position: top;\n}\n.gallery-media.style-1 {\n\theight: 300px;\n}\n\n.table-clear {\n\tbackground-color: #f2f2f2;\n}\n.table-clear tbody tr td {\n\tborder-color: #c2c2c2;\n}\n\n.table.table-invoice {\n\tmargin-bottom: 0;\n}\n.table.table-invoice tbody tr:last-child td {\n\tborder-bottom: 1px solid #f2f2f2;\n}\n\n.dz-calender {\n\tposition: relative;\n\tz-index: 1;\n}\n.dz-calender .react-datepicker__day-names,\n.dz-calender .react-datepicker__week {\n\tdisplay: flex;\n}\n.dz-calender .react-datepicker {\n\tborder: unset;\n\twidth: 100%;\n\tbackground-color: transparent;\n}\n.dz-calender .react-datepicker__header {\n\tborder: unset;\n\tbackground-color: transparent;\n}\n.dz-calender .react-datepicker__header .react-datepicker__day-names {\n\tcolor: var(--secondary);\n\tmargin-bottom: -15px;\n}\n.dz-calender .react-datepicker .react-datepicker__triangle:before {\n\tbox-shadow: 0 0 16px 0px rgba(0, 0, 0, 0.09);\n\tborder-bottom-color: transparent;\n}\n.dz-calender .react-datepicker__navigation {\n\ttop: 12px;\n\tline-height: 20px;\n\tbackground: var(--rgba-primary-1);\n\tborder-radius: 0.375rem;\n}\n.dz-calender .react-datepicker__navigation--previous {\n\tleft: 10px;\n}\n.dz-calender .react-datepicker__navigation--next {\n\tright: 10px;\n}\n.dz-calender .react-datepicker__navigation-icon:before {\n\tborder-color: var(--primary);\n\tborder-width: 2px 2px 0 0;\n}\n.dz-calender .react-datepicker__current-month {\n\tpadding: 10px 0px;\n\tmargin: 0 20px;\n\tfont-size: 15px;\n\tfont-weight: 500;\n}\n.dz-calender .react-datepicker__day-name,\n.dz-calender .react-datepicker__day,\n.dz-calender .react-datepicker__time-name {\n\theight: 55px;\n\tflex: 1;\n\tline-height: 55px;\n\tfont-size: 13px;\n\tfont-weight: 400;\n\tmargin: 0;\n\tfont-family: 'poppins', sans-serif;\n}\n.dz-calender .react-datepicker__day--selected {\n\tbackground: var(--primary) !important;\n\tcolor: #fff !important;\n}\n.dz-calender svg path {\n\tfill: var(--primary);\n}\n.dz-calender .react-datepicker-wrapper {\n\twidth: auto;\n}\n.dz-calender .react-datepicker__month-container {\n\tfloat: inherit;\n}\n\n.drop-select {\n\twidth: 130px;\n}\n.drop-select .drop-select-btn {\n\tbackground-color: transparent !important;\n\tfont-weight: 400;\n\tpadding: 0.6875rem 1.25rem;\n\tborder: 1px solid #dddddd;\n\tborder-width: 1px;\n\tline-height: 1.5;\n\tfont-size: 1rem;\n\tborder-radius: 6px;\n\tcolor: #303972;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n}\n.drop-select .drop-select-btn:after {\n\tdisplay: inline-block;\n\tmargin-left: 0;\n\tvertical-align: unset;\n\tcontent: '';\n\twidth: 0.5rem;\n\theight: 0.5rem;\n\tborder-top: 2px solid #666;\n\tborder-right: 2px solid #666;\n\ttransform: rotate(135deg);\n\tborder-bottom: none;\n\tborder-left: none;\n\tmargin: 0;\n\tpadding: 0;\n\tmargin-bottom: 0.25rem;\n}\n.drop-select .dropdown-menu {\n\tmin-width: 8rem;\n\tz-index: 2;\n}\n.drop-select .dropdown-menu .dropdown-item {\n\tfont-size: 0.875rem;\n}\n.drop-select .dropdown-menu .dropdown-item:first-child {\n\tcolor: var(--primary);\n\tbackground: var(--rgba-primary-1);\n}\n\n.contact_list {\n\t-webkit-transition: all 0.8s;\n\t-ms-transition: all 0.8s;\n\ttransition: all 0.8s;\n}\n.contact_list .dropdown {\n\tposition: absolute;\n\ttop: 20px;\n\tright: 20px;\n}\n.contact_list:hover {\n\tbox-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n}\n.contact_list .btn-check:focus + .btn,\n.contact_list .btn:focus {\n\toutline: 0;\n}\n\n/* Teacher Detail */\n.user-bg {\n\theight: 140px;\n\tbackground-color: var(--primary);\n\tborder-radius: 0.375rem 0.375rem 0 0;\n\tposition: relative;\n}\n.user-bg .user-svg,\n.user-bg .user-svg-1 {\n\tposition: absolute;\n\tbottom: 0;\n\tright: 40px;\n\tz-index: 1;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.user-bg .user-svg,\n\t.user-bg .user-svg-1 {\n\t\tright: 27px;\n\t}\n}\n@media only screen and (max-width: 61.9375rem) {\n\t.user-bg .user-svg svg,\n\t.user-bg .user-svg-1 svg {\n\t\twidth: 9.375rem;\n\t\theight: 6.25rem;\n\t}\n}\n@media only screen and (max-width: 61.9375rem) and (max-width: 35.9375rem) {\n\t.user-bg .user-svg svg,\n\t.user-bg .user-svg-1 svg {\n\t\twidth: 7.738rem;\n\t\theight: 4.813rem;\n\t}\n}\n.user-bg .user-svg-1 {\n\tright: 144px;\n\tz-index: 0;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.user-bg .user-svg-1 {\n\t\tright: 68px;\n\t}\n}\n\n.user {\n\tmargin-top: -100px;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.user {\n\t\tmargin-top: -72px;\n\t}\n}\n.user .user-media {\n\tmargin-bottom: 20px;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.user .user-media {\n\t\tmargin-bottom: 10px;\n\t}\n}\n.user .user-media .avatar {\n\tborder: 8px solid #fff;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.user .user-media .avatar {\n\t\tborder-width: 5px;\n\t}\n}\n\n.user-content .user-img {\n\tmargin-bottom: 1.5rem;\n}\n\n@media only screen and (max-width: 74.9375rem) {\n\t.user-content .sharp {\n\t\twidth: 2.4rem;\n\t\theight: 2.4rem;\n\t}\n}\n\n.teacher-deatails p {\n\twidth: 60%;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.teacher-deatails p {\n\t\twidth: 100%;\n\t}\n}\n\n.teacher-deatails .dots {\n\tposition: relative;\n\tpadding-left: 0.938rem;\n\tmargin-bottom: 1.563rem;\n}\n.teacher-deatails .dots:after {\n\tcontent: '';\n\tposition: absolute;\n\tbackground-color: var(--primary);\n\twidth: 5px;\n\theight: 5px;\n\tborder-radius: 100%;\n\ttop: 0.5rem;\n\tleft: 0;\n}\n\n.contact-icon {\n\tmargin-bottom: 30px;\n}\n\n@media only screen and (max-width: 74.9375rem) {\n\t.contact_list .card-body {\n\t\tpadding: 20px;\n\t}\n}\n\n.image-placeholder {\n\tposition: relative;\n\tmax-width: 130px;\n\tmargin: 10px auto;\n}\n.image-placeholder .avatar-edit {\n\tposition: absolute;\n\tright: -5px;\n\tz-index: 1;\n\ttop: 0px;\n}\n.image-placeholder .avatar-edit input {\n\tdisplay: none;\n}\n.image-placeholder .avatar-edit input + label {\n\tdisplay: inline-block;\n\twidth: 34px;\n\theight: 34px;\n\tmargin-bottom: 0;\n\tborder-radius: 100%;\n\tbackground: #ffffff;\n\tborder: 1px solid transparent;\n\tbox-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n\tcursor: pointer;\n\tfont-weight: normal;\n\ttransition: all 0.2s ease-in-out;\n}\n.image-placeholder .avatar-edit input + label:hover {\n\tbackground: #f1f1f1;\n\tborder-color: #d6d6d6;\n}\n.image-placeholder .avatar-edit input + label:after {\n\tcontent: '\\f303';\n\tfont-family: 'Font Awesome 5 Free';\n\tfont-weight: 900;\n\tcolor: #757575;\n\tposition: absolute;\n\ttop: 6px;\n\tleft: 0;\n\tright: 0;\n\ttext-align: center;\n\tmargin: auto;\n}\n.image-placeholder .avatar-preview {\n\twidth: 130px;\n\theight: 130px;\n\tposition: relative;\n\tborder-radius: 100%;\n\tborder: 3px solid #f8f8f8;\n\toverflow: hidden;\n\tbox-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n}\n.image-placeholder .avatar-preview > div {\n\twidth: 100%;\n\theight: 100%;\n\tborder-radius: 30px;\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n}\n.image-placeholder .avatar-preview > div img {\n\theight: 100%;\n\twidth: 100%;\n\tobject-fit: cover;\n}\n\n.project-boxed {\n\toverflow: hidden;\n}\n\n.food-tabs {\n\tborder-bottom: 2px solid var(--rgba-primary-1);\n}\n.food-tabs .nav-item .nav-link {\n\tposition: relative;\n\tcolor: #c2c2c2;\n}\n.food-tabs .nav-item .nav-link:after {\n\tcontent: '';\n\tposition: absolute;\n\tbackground-color: var(--primary);\n\twidth: 0px;\n\theight: 2px;\n\tbottom: -2px;\n\tleft: 0px;\n}\n.food-tabs .nav-item .nav-link.active {\n\tbackground-color: unset;\n\tborder: 1px solid transparent;\n\tcolor: var(--primary);\n}\n.food-tabs .nav-item .nav-link.active:after {\n\twidth: 100%;\n}\n.food-tabs .nav-item .nav-link:hover {\n\tborder: 1px solid transparent;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.food-tabs .nav-item .nav-link {\n\t\tpadding: 12px;\n\t}\n}\n\n.food-menu {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.food-review {\n\tdisplay: flex;\n\talign-items: center;\n}\n.food-review h5,\n.food-review .h5 {\n\tmargin-bottom: 0;\n}\n.food-review i {\n\tcolor: #fcc43e;\n\tmargin-right: 0.313rem;\n}\n\n/* food-details */\n.food-media {\n\twidth: 361px;\n\theight: 191px;\n\tobject-fit: cover;\n}\n.food-media img {\n\twidth: 100%;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.food-media {\n\t\twidth: 100%;\n\t\tmargin-bottom: 1rem;\n\t}\n}\n\n.food-recipe li {\n\tlist-style: unset;\n\tmargin: 5px 20px;\n}\n\n.schedule-card,\n.schedule-card-1,\n.schedule-card-2,\n.schedule-card-3 {\n\tposition: relative;\n\toverflow: hidden;\n}\n.schedule-card .card-body,\n.schedule-card-1 .card-body,\n.schedule-card-2 .card-body,\n.schedule-card-3 .card-body {\n\tpadding-top: 24px;\n\tpadding-bottom: 24px;\n\tmargin-left: 3px;\n}\n.schedule-card:after,\n.schedule-card-1:after,\n.schedule-card-2:after,\n.schedule-card-3:after {\n\tcontent: '';\n\tposition: absolute;\n\tbackground-color: var(--primary);\n\twidth: 0.438rem;\n\theight: 12.188rem;\n\ttop: 0;\n\tleft: 0;\n}\n\n.schedule-card-1:after {\n\tbackground-color: var(--secondary);\n}\n\n.schedule-card-2:after {\n\tbackground-color: #fcc43e;\n}\n\n.schedule-card-3:after {\n\tbackground-color: #303972;\n}\n\n.student-details {\n\tdisplay: flex;\n\talign-items: center;\n}\n@media only screen and (max-width: 100rem) {\n\t.student-details {\n\t\tmargin-bottom: 10px;\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.student-details {\n\t\tmargin-bottom: 10px;\n\t}\n}\n\n.setting-img img {\n\twidth: 7.5rem;\n\theight: 7.5rem;\n\tborder-radius: 0.375rem;\n\tobject-fit: cover;\n}\n\n.setting-img .change {\n\tborder-radius: 6px;\n\tpadding: 0.688rem 0.875rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.setting-img .change {\n\t\tmargin-left: 1rem;\n\t}\n}\n\n@media only screen and (max-width: 35.9375rem) {\n\t.setting-img {\n\t\tflex-wrap: wrap;\n\t}\n}\n\n.avatar-upload .avatar-edit {\n\tposition: absolute;\n\tright: 0.75rem;\n\tz-index: 1;\n\ttop: 0.625rem;\n}\n\n.avatar-upload .avatar-preview > div {\n\tdisplay: inline-block;\n\twidth: 6.5rem;\n\theight: 6.5rem;\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n\tborder-radius: 6px;\n}\n\ninput.form-control {\n\tposition: relative;\n}\n\ninput[type='date']::-webkit-calendar-picker-indicator {\n\tbackground: transparent;\n\tbottom: 0;\n\tcolor: transparent;\n\tcursor: pointer;\n\theight: auto;\n\tleft: 0;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\twidth: auto;\n}\n\n.p-static .bootstrap-select {\n\twidth: 130px !important;\n}\n\n.table-responsive .unpaid-school thead {\n\tbackground-color: unset;\n}\n.table-responsive .unpaid-school thead th {\n\tcolor: #000;\n}\n.table-responsive .unpaid-school thead td span {\n\tfont-size: 14px;\n}\n\n.input-group.user-search-area {\n\tmargin-top: 0.875rem;\n}\n.input-group.user-search-area .input-group-text {\n\tbackground-color: transparent;\n\tborder-color: #dddddd;\n}\n.input-group.user-search-area .form-control {\n\tborder-left: 0;\n\tborder-color: #dddddd;\n}\n.input-group.user-search-area .form-control:focus {\n\tborder-color: #dddddd;\n}\n\n.timeline-active .timeline-list {\n\tposition: relative;\n\tpadding: 1.1rem 0;\n}\n.timeline-active .timeline-list:before {\n\ttop: 2.275rem;\n\tbottom: 0;\n\tposition: absolute;\n\tcontent: ' ';\n\twidth: 0.125rem;\n\theight: calc(100% - 0.875rem);\n\tleft: 13.4px;\n\tmargin-right: -0.0938rem;\n\tbackground: #dddddd;\n}\n\n.timeline-active span,\n.timeline-active .time {\n\tfont-size: 13px;\n\tmargin-left: 10px;\n}\n\n.plan-bx {\n\tposition: relative;\n}\n.plan-bx .plan-svg,\n.plan-bx .plan-svg-1 {\n\tposition: absolute;\n\tbottom: 0;\n\tright: 0;\n\tz-index: 0;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.plan-bx .plan-svg,\n\t.plan-bx .plan-svg-1 {\n\t\tright: -7px;\n\t}\n\t.plan-bx .plan-svg svg,\n\t.plan-bx .plan-svg-1 svg {\n\t\twidth: 100px;\n\t\theight: 100px;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.plan-bx .plan-svg,\n\t.plan-bx .plan-svg-1 {\n\t\tright: 8px;\n\t}\n\t.plan-bx .plan-svg svg,\n\t.plan-bx .plan-svg-1 svg {\n\t\twidth: 68px;\n\t\theight: 146px;\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.plan-bx .plan-svg svg,\n\t.plan-bx .plan-svg-1 svg {\n\t\twidth: 6.25rem;\n\t\theight: 9.375rem;\n\t}\n}\n.plan-bx .plan-svg-1 {\n\tright: 0.825rem;\n\tz-index: 1;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.plan-bx .plan-svg-1 {\n\t\tright: 1.25rem;\n\t}\n}\n@media only screen and (max-width: 74.9375rem) {\n\t.plan-bx .plan-svg-1 {\n\t\tright: 2.125rem;\n\t}\n}\n\n.photo-content {\n\tposition: relative;\n}\n.photo-content .cover-photo {\n\tbackground: url(../images/profile/12.jpg);\n\tbackground-size: cover;\n\tbackground-position: center;\n\tmin-height: 15.625rem;\n\twidth: 100%;\n\tborder-top-left-radius: 0.375rem;\n\tborder-top-right-radius: 0.375rem;\n}\n\n.user {\n\tcursor: pointer;\n}\n.user:hover .st-box {\n\tbackground-color: var(--primary);\n\tborder-color: var(--primary);\n}\n.user:hover .st-box svg path {\n\tfill: #fff;\n}\n.user:hover a {\n\tcolor: var(--primary);\n}\n\n.author-profile {\n\ttext-align: center;\n}\n.author-profile .card-body {\n\tpadding: 0;\n}\n.author-profile .author-media {\n\tposition: relative;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tmargin-bottom: 20px;\n\tdisplay: inline-block;\n}\n.author-profile .author-media img {\n\twidth: 130px;\n\tborder-radius: 100%;\n}\n.author-profile .author-info .title {\n\tfont-size: 15px;\n\tfont-weight: 500;\n\tmargin-bottom: 0;\n}\n.author-profile .author-info span {\n\tdisplay: block;\n\tcolor: #a098ae;\n}\n.author-profile .info-list li {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tfont-size: 15px;\n\tborder-top: 1px solid #eeeeee;\n\tpadding: 18px 30px;\n\tcolor: #303972;\n}\n.author-profile .info-list li a {\n\tcolor: #303972;\n}\n.author-profile .info-list li span {\n\tcolor: #a098ae;\n\tfont-weight: 500;\n}\n.author-profile .card-footer {\n\tpadding: 30px;\n\tdisplay: block;\n}\n.author-profile .card-footer .form-control {\n\theight: 45px;\n\tborder-color: #eeeeee;\n\toverflow: hidden;\n}\n.author-profile .upload-link {\n\tposition: absolute;\n\twidth: 35px;\n\theight: 35px;\n\tline-height: 32px;\n\tbackground: #395ee2;\n\tbottom: 0;\n\tright: 0px;\n\tbox-shadow: 0 0 10px 0 rgba(0, 24, 128, 0.1);\n\tborder-radius: 100%;\n\tcolor: #fff;\n\toverflow: hidden;\n\tborder: 2px solid #fff;\n}\n.author-profile .upload-link .update-flie {\n\tposition: absolute;\n\topacity: 0;\n\tz-index: 0;\n\twidth: 100%;\n\tcursor: pointer;\n\tleft: 0;\n\theight: 100%;\n}\n\n.m-b30 {\n\tmargin-bottom: 16px;\n}\n\n.timeline-active.style-1 .timeline-list {\n\tposition: relative;\n\tpadding: 1.1rem 0;\n}\n.timeline-active.style-1 .timeline-list:before {\n\ttop: 2.375rem;\n\tbottom: 0;\n\tposition: absolute;\n\tcontent: ' ';\n\twidth: 0.125rem;\n\theight: calc(100% - 0.875rem);\n\tleft: 0.463rem;\n\tmargin-right: -0.0938rem;\n\tbackground: #dddddd;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.timeline-active.style-1 .timeline-list:before {\n\t\tleft: 0.563rem;\n\t\ttop: 2.575rem;\n\t}\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.timeline-active.style-1 .timeline-list:before {\n\t\tleft: 0.463rem;\n\t}\n}\n.timeline-active.style-1 .timeline-list .modulel {\n\tdisplay: flex;\n\talign-items: center;\n}\n.timeline-active.style-1 .timeline-list .modulel img {\n\twidth: 17.375rem !important;\n\theight: 10.125rem;\n\tborder-radius: 0.375rem;\n\tmargin-left: 0.625rem;\n\tobject-fit: cover;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.timeline-active.style-1 .timeline-list .modulel img {\n\t\tmargin-bottom: 0.625rem;\n\t}\n}\n\n.timeline-active.style-1 span,\n.timeline-active.style-1 .time {\n\tfont-size: 13px;\n\tmargin-left: 10px;\n\tmargin-bottom: 0;\n}\n\n.timeline-active.style-1 .last-timeline {\n\tpadding-top: 19px;\n}\n\n/*\n===================================\n    Product detail\n===================================*/\n.produtct-detail-tag {\n\tdisplay: inline-block;\n}\n.produtct-detail-tag a {\n\tfont-style: 0.8125rem;\n\tcolor: #303972;\n}\n\n.product-detail-content .item-tag {\n\tbackground: #828690;\n\tborder-radius: 0.375rem;\n\tdisplay: inline-block;\n\tfont-size: 0.75rem;\n\tmargin-right: 0.25rem;\n\tpadding: 0.125rem 0.75rem;\n\tcolor: #fff;\n}\n\n.product-detail-content input.form-control.input-btn.input-number {\n\theight: 3rem;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.product-detail-content input.form-control.input-btn.input-number {\n\t\theight: 2.285rem;\n\t}\n}\n\n.filtaring-area h4,\n.filtaring-area .h4 {\n\tcolor: #1d1d1d;\n\tfont-size: 1rem;\n\tfont-weight: 400;\n\ttext-transform: lowercase;\n}\n\n.plus-minus-input .input-icon {\n\tfont-size: 0.8125rem;\n\tcolor: #303972;\n}\n\n.plus-minus-input {\n\tdisplay: flex;\n\twidth: 7.5rem;\n}\n.plus-minus-input .custom-btn {\n\tborder-radius: 0;\n\theight: 2.5rem;\n\tpadding: 0.75rem 0.5rem;\n\tbackground: #fff;\n\tborder: 0.0625rem solid #f2f2f2;\n}\n.plus-minus-input .form-control:hover,\n.plus-minus-input .form-control:focus,\n.plus-minus-input .form-control:active {\n\tborder: 0.0625rem solid #f2f2f2;\n}\n\n.btn-reveal-trigger .avatar-xl {\n\tmin-width: 1.875rem;\n}\n\n.share-view {\n\tdisplay: inline-block;\n}\n.share-view ul li {\n\tdisplay: inline-block;\n}\n.share-view .share-icon {\n\twidth: 2.5rem;\n\theight: 2.5rem;\n\tdisplay: inline-block;\n\tborder: 0.0625rem solid #f2f2f2;\n\ttext-align: center;\n\tline-height: 2.5rem;\n\tfont-style: 1rem;\n\tcolor: #f2f2f2;\n\tmargin-right: 0.5rem;\n}\n\n/*--------tab----------*/\n.veritical-line {\n\tpadding: 1.25rem 1.875rem;\n\tborder-top: 0.0625rem solid #f2f2f2;\n\tborder-right: 0.0625rem solid #f2f2f2;\n\tborder-bottom: 0.0625rem solid #f2f2f2;\n\tposition: relative;\n}\n.veritical-line:before {\n\tbackground: #f2f2f2;\n\tbottom: 0;\n\tcontent: '';\n\theight: 100%;\n\tleft: -0.0625rem;\n\tmax-height: 40%;\n\tposition: absolute;\n\twidth: 0.0625rem;\n}\n\n.tab-content-text p {\n\tcolor: #303972;\n\tfont-size: 0.8125rem;\n\tfont-weight: 400;\n\tline-height: 1.5rem;\n\tmargin-bottom: 1.5625rem;\n}\n\n.tab-item-list li a {\n\tbackground: #fff;\n\tborder-top: 0.0625rem solid #f2f2f2;\n\tborder-left: 0.0625rem solid #f2f2f2;\n\tborder-right: 0.0625rem solid #f2f2f2;\n\tcolor: #303972;\n\tdisplay: block;\n\tfont-size: 1rem;\n\tpadding: 1rem;\n\ttext-transform: uppercase;\n}\n.tab-item-list li a:hover,\n.tab-item-list li a:focus {\n\tbackground: #fff;\n\tcolor: #303972;\n\tborder-right: 0rem;\n}\n\n.tab-item-list li:last-child {\n\tborder-bottom: 0.0625rem solid #f2f2f2;\n}\n\n.tab-list li {\n\tmargin-bottom: 0.4375rem;\n\tfont-size: 0.8125rem;\n}\n.tab-list li i {\n\tfont-size: 0.8125rem;\n\tmargin-right: 0.875rem;\n}\n\n.slide-item-list {\n\ttext-align: center;\n\tmargin: 0 -0.3125rem;\n\tborder: 0;\n}\n.slide-item-list .nav-link {\n\tborder: 0;\n}\n.slide-item-list .nav-link:hover {\n\tborder: 0;\n}\n.slide-item-list .nav-link.active {\n\tborder: 0;\n\tbackground-color: transparent;\n}\n.slide-item-list li {\n\tdisplay: inline-block;\n\tflex: 0 0 25%;\n\twidth: 25%;\n\tpadding: 0 0.3125rem;\n}\n.slide-item-list li a {\n\tdisplay: inline-block;\n\tpadding-left: 0;\n\tpadding-right: 0;\n\tpadding-top: 0;\n\tbackground: transparent;\n\tpadding-bottom: 0rem;\n}\n.slide-item-list li a:hover,\n.slide-item-list li a:focus {\n\tbackground: transparent;\n}\n.slide-item-list li a img {\n\twidth: 100%;\n\tborder-radius: 0.375rem;\n}\n\n.product-detail-text {\n\tpadding-top: 1.75rem;\n\tpadding-left: 1.875rem;\n\tpadding-right: 1.875rem;\n\tpadding-bottom: 4.375rem;\n}\n\n.star-rating .product-review {\n\tfont-style: 0.8125rem;\n\tcolor: #303972;\n\tfont-weight: 400;\n\ttext-decoration: underline !important;\n}\n\n.product-detail .tab-content img {\n\tdisplay: inline-block;\n\twidth: 100%;\n}\n\n.popular-tag ul {\n\tmargin: 0rem;\n\tpadding: 0rem;\n}\n.popular-tag ul li {\n\tdisplay: inline-block;\n\tpadding: 0.5rem 0.9375rem;\n\tbackground: #f8f8f8;\n\tfont-size: 0.8125rem;\n\tcolor: #fff;\n\tmargin-right: 0.625rem;\n\tmargin-bottom: 0.625rem;\n}\n\n.size-filter ul li {\n\tdisplay: inline-block;\n}\n\n.intro {\n\tborder: 0.0625rem solid red;\n\tcolor: #1d1d1d;\n}\n\n#listResults .slider {\n\tmargin: 1.5625rem 0;\n}\n\n#listResults .slider-box {\n\twidth: 90%;\n\tmargin: 1.5625rem auto;\n}\n\n#listResults input {\n\twidth: 10%;\n}\n\n#listResults label {\n\tborder: none;\n\tdisplay: inline-block;\n\tmargin-right: -0.25rem;\n\tvertical-align: top;\n\twidth: 30%;\n}\n\n.plus-minus-input .input-icon {\n\tfont-size: 0.8125rem;\n\tcolor: #aaaaaa;\n}\n\n.plus-minus-input .custom-btn {\n\tborder-radius: 0;\n\theight: 2.5rem;\n\tpadding: 0.5rem 0.75rem;\n\tbackground: #ffffff;\n\tborder: 0.0625rem solid #c8c8c8;\n}\n.plus-minus-input .custom-btn:hover,\n.plus-minus-input .custom-btn:focus,\n.plus-minus-input .custom-btn.active {\n\tbox-shadow: none;\n\toutline: none;\n}\n\n.plus-minus-input .form-control {\n\theight: 2.5rem;\n\tborder-top: 0.0625rem solid #c8c8c8;\n\tborder-bottom: 0.0625rem solid #c8c8c8;\n\tborder-left: 0rem solid #c8c8c8;\n\tborder-right: 0.0625rem solid #c8c8c8;\n}\n.plus-minus-input .form-control:hover,\n.plus-minus-input .form-control:focus,\n.plus-minus-input .form-control:active {\n\tborder-top: 0.0625rem solid #c8c8c8;\n\tborder-bottom: 0.0625rem solid #c8c8c8;\n\tborder-left: 0rem solid #c8c8c8;\n\tborder-right: 0rem solid #c8c8c8;\n}\n\n.new-arrival-product .new-arrivals-img-contnent {\n\toverflow: hidden;\n\tposition: relative;\n}\n.new-arrival-product .new-arrivals-img-contnent img {\n\twidth: 100%;\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n\tborder-radius: 0.375rem;\n}\n.new-arrival-product .new-arrivals-img-contnent:after {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 0;\n\tleft: -85%;\n\tz-index: 2;\n\tdisplay: block;\n\tcontent: '';\n\twidth: 50%;\n\theight: 100%;\n\tbackground: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 100%);\n\t-webkit-transform: skewX(-25deg);\n\ttransform: skewX(-25deg);\n}\n\n.new-arrival-product .discount {\n\tfont-size: 14px;\n\tmargin-right: 8px;\n\topacity: 0.8;\n\tcolor: var(--primary);\n}\n\n.new-arrival-product:hover .new-arrivals-img-contnent:after {\n\twebkit-animation: shine 0.75s;\n\tanimation: shine 0.75s;\n}\n\n@-webkit-keyframes shine {\n\t100% {\n\t\tleft: 125%;\n\t}\n}\n\n@keyframes shine {\n\t100% {\n\t\tleft: 125%;\n\t}\n}\n\n.star-rating {\n\tmargin-bottom: 0.625rem;\n}\n\n.select-size .btn:not(:first-child),\n.select-size .btn:not(last-child) {\n\tmargin: 0 5px;\n\tbox-shadow: none;\n}\n\n.card.product-grid-card .card-body {\n\tpadding: 15px;\n}\n\n/*\n===================================\n    list view\n===================================*/\n.new-arrival-content .item {\n\tfont-size: 0.75rem;\n\tcolor: #000;\n}\n\n.new-arrival-content h4,\n.new-arrival-content .h4 {\n\tfont-size: 1.25rem;\n\tfont-weight: 600;\n\tmargin-bottom: 0.625rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.new-arrival-content h4,\n\t.new-arrival-content .h4 {\n\t\tmargin-top: 1rem;\n\t}\n}\n\n.new-arrival-content .price {\n\tfont-weight: 500;\n\tcolor: var(--primary);\n\tfont-size: 1.25rem;\n\tmargin-bottom: 0;\n\tfloat: right;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.new-arrival-content .price {\n\t\tfloat: none;\n\t\tmargin-top: 0.625rem;\n\t}\n}\n\n.new-arrival-content p {\n\tfont-size: 0.875rem;\n\tmargin-bottom: 0.375rem;\n\tline-height: 1.5rem;\n}\n\n.new-arrival-content .text-content {\n\tmargin-top: 1.125rem;\n}\n\n.new-arrival-content.text-center .price {\n\tfloat: unset !important;\n}\n\n.success-icon {\n\tcolor: #1eba62;\n\tfont-size: 1rem;\n}\n\n.comment-review {\n\tmargin-bottom: 0.9375rem;\n\tdisplay: table;\n\twidth: 100%;\n}\n.comment-review .client-review {\n\tcolor: #7e8dbf;\n\tpadding-right: 1.25rem;\n\ttext-decoration: underline !important;\n\tfont-size: 0.875rem;\n}\n.comment-review .span {\n\tcolor: #7e8dbf;\n\tfont-size: 0.875rem;\n}\n@media only screen and (max-width: 35.9375rem) {\n\t.comment-review {\n\t\tmargin-bottom: 0;\n\t}\n}\n\n.star-rating li {\n\tdisplay: inline-block;\n}\n.star-rating li i {\n\tcolor: gold;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n\tbackground: #ffffff;\n}\n\n.table-responsive .table.order-table thead {\n\tbackground-color: #fff;\n}\n.table-responsive .table.order-table thead th {\n\tcolor: #303972;\n\tfont-weight: 600;\n}\n.table-responsive .table.order-table thead th:first-child {\n\tborder-top-left-radius: 0.375rem;\n}\n.table-responsive .table.order-table thead th:last-child {\n\tborder-top-right-radius: 0.375rem;\n}\n\n:root {\n\t--primary: #4d44b5;\n\t--secondary: #fb7d5b;\n\t--primary-hover: #3d3690;\n\t--primary-dark: #1e1a46;\n\t--rgba-primary-1: rgba(77, 68, 181, 0.1);\n\t--rgba-primary-2: rgba(77, 68, 181, 0.2);\n\t--rgba-primary-3: rgba(77, 68, 181, 0.3);\n\t--rgba-primary-4: rgba(77, 68, 181, 0.4);\n\t--rgba-primary-5: rgba(77, 68, 181, 0.5);\n\t--rgba-primary-6: rgba(77, 68, 181, 0.6);\n\t--rgba-primary-7: rgba(77, 68, 181, 0.7);\n\t--rgba-primary-8: rgba(77, 68, 181, 0.8);\n\t--rgba-primary-9: rgba(77, 68, 181, 0.9);\n\t--rgba-secondary-1: rgba(251, 125, 91, 0.1);\n\t--rgba-secondary-2: rgba(251, 125, 91, 0.2);\n\t--rgba-secondary-3: rgba(251, 125, 91, 0.3);\n\t--rgba-secondary-4: rgba(251, 125, 91, 0.4);\n\t--rgba-secondary-5: rgba(251, 125, 91, 0.5);\n\t--rgba-secondary-6: rgba(251, 125, 91, 0.6);\n\t--rgba-secondary-7: rgba(251, 125, 91, 0.7);\n\t--rgba-secondary-8: rgba(251, 125, 91, 0.8);\n\t--rgba-secondary-9: rgba(251, 125, 91, 0.9);\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--font-family-base: Poppins, sans-serif;\n\t--font-family-title: Poppins, sans-serif;\n\t--title: #303972;\n}\n\n[data-theme-version='dark'] {\n\tbackground: #202020;\n\tcolor: rgba(255, 255, 255, 0.6);\n\t--nav-headbg: #272738;\n\t--sidebar-bg: #202020;\n\t--headerbg: #272738;\n}\n[data-theme-version='dark'] h1,\n[data-theme-version='dark'] .h1,\n[data-theme-version='dark'] h2,\n[data-theme-version='dark'] .h2,\n[data-theme-version='dark'] h3,\n[data-theme-version='dark'] .h3,\n[data-theme-version='dark'] h4,\n[data-theme-version='dark'] .h4,\n[data-theme-version='dark'] h5,\n[data-theme-version='dark'] .h5,\n[data-theme-version='dark'] h6,\n[data-theme-version='dark'] .h6 {\n\tcolor: #fff !important;\n}\n[data-theme-version='dark'] a.link {\n\tcolor: #ddd;\n}\n[data-theme-version='dark'] a.link:focus,\n[data-theme-version='dark'] a.link:hover {\n\tcolor: #00ada3;\n}\n[data-theme-version='dark'] a:hover {\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .border-right {\n\tborder-right: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;\n}\n[data-theme-version='dark'] .border-left {\n\tborder-left: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;\n}\n[data-theme-version='dark'] .border-top {\n\tborder-top: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;\n}\n[data-theme-version='dark'] .border-bottom {\n\tborder-bottom: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;\n}\n[data-theme-version='dark'] .border {\n\tborder: 0.0625rem solid rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .card {\n\tbackground-color: #272738;\n\tbox-shadow: none;\n}\n\n[data-theme-version='dark'] .dropdown-menu {\n\tbackground-color: #272738;\n\tbox-shadow: 0rem 0rem 0rem 0.0625rem rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .dropdown-menu .dropdown-item {\n\tcolor: #777777;\n}\n[data-theme-version='dark'] .dropdown-menu .dropdown-item.selected,\n[data-theme-version='dark'] .dropdown-menu .dropdown-item.selected.active,\n[data-theme-version='dark'] .dropdown-menu .dropdown-item.active,\n[data-theme-version='dark'] .dropdown-menu .dropdown-item:hover,\n[data-theme-version='dark'] .dropdown-menu .dropdown-item:focus {\n\tbackground-color: #272738;\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] a {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .btn-link g [fill] {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .btn-light:active,\n[data-theme-version='dark'] .btn-light:focus,\n[data-theme-version='dark'] .btn-light:hover {\n\tcolor: #000;\n}\n\n[data-theme-version='dark'] .form-control {\n\tbackground-color: #202020;\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .modal-content {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .modal-footer,\n[data-theme-version='dark'] .modal-header {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .close {\n\tfont-weight: 400;\n\tcolor: #fff;\n\ttext-shadow: none;\n}\n[data-theme-version='dark'] .close:hover {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .star-rating .product-review,\n[data-theme-version='dark'] .new-arrival-content .item {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .custom-dropdown .dropdown-menu {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .widget-stat .media > span {\n\tbackground: rgba(255, 255, 255, 0.1);\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .plus-minus-input .custom-btn {\n\tbackground: #202020;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dropdown-divider,\n[data-theme-version='dark'] .size-filter ul li {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .custom-select {\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #7e8dbf;\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .nav-tabs {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .mail-list .list-group-item.active i {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] hr {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .grid-col {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .noUi-target {\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tborder-radius: 0.5rem;\n\tbox-shadow: none;\n}\n[data-theme-version='dark'] .noUi-target .noUi-connects {\n\tbackground: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .noUi-marker-large,\n[data-theme-version='dark'] .noUi-marker {\n\tbackground: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .input-group-text {\n\tbackground: #272738;\n\tcolor: #fff;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .note-editor.note-frame {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .note-editor.note-frame .btn {\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .note-editor.note-frame .note-editing-area .note-editable {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .widget-media .timeline .timeline-panel {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .notification_dropdown .dropdown-menu-right .all-notification {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] #user-activity .nav-tabs .nav-link {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] #user-activity .nav-tabs .nav-link.active {\n\tbackground: #202020;\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .list-group-item-action {\n\tcolor: #a098ae;\n}\n\n[data-theme-version='dark'] .list-group-item-action:focus,\n[data-theme-version='dark'] .list-group-item-action:hover,\n[data-theme-version='dark'] .list-group-item-action:focus {\n\tbackground-color: #202020;\n\tborder-color: #202020;\n}\n\n[data-theme-version='dark'] .list-group-item.active {\n\tcolor: #fff;\n\tborder-color: var(--primary);\n}\n[data-theme-version='dark'] .list-group-item.active:focus,\n[data-theme-version='dark'] .list-group-item.active:hover,\n[data-theme-version='dark'] .list-group-item.active:focus {\n\tbackground-color: var(--primary);\n\tborder-color: var(--primary);\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .swal2-popup {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .form-head .btn-outline-primary {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .form-head .btn-outline-primary:hover {\n\tborder-color: var(--primary);\n}\n\n[data-theme-version='dark'] .review-tab.nav-pills li a.nav-link.active {\n\tbackground: transparent;\n}\n\n[data-theme-version='dark'] .new-arrival-content h4 a,\n[data-theme-version='dark'] .new-arrival-content .h4 a {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .text-black {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .abilities-chart .ct-chart .ct-label {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .morris_chart_height text tspan {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .btn-link {\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .btn-link svg path {\n\tstroke: #fff;\n}\n\n[data-theme-version='dark'] .order-bg {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .detault-daterange {\n\tbackground: #202020;\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .detault-daterange .input-group-text {\n\tbackground: #272738;\n\tborder: 0;\n}\n\n[data-theme-version='dark'] .dataTablesCard {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='dark'] .compose-content .dropzone {\n\tbackground: #202020 !important;\n}\n[data-theme-version='dark'] .compose-content .dropzone .dlab-message .dlab-button {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .daterangepicker {\n\tbackground: #202020;\n\tborder-color: var(--primary);\n}\n[data-theme-version='dark'] .daterangepicker .calendar-table {\n\tborder-color: var(--primary);\n\tbackground: #202020;\n}\n[data-theme-version='dark'] .daterangepicker .calendar-table .table-condensed td:hover {\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .daterangepicker:after {\n\tborder-bottom: 0.375rem solid #202020;\n}\n\n[data-theme-version='dark'] .daterangepicker select.hourselect,\n[data-theme-version='dark'] .daterangepicker select.minuteselect,\n[data-theme-version='dark'] .daterangepicker select.secondselect,\n[data-theme-version='dark'] .daterangepicker select.ampmselect {\n\tbackground: #202020;\n\tborder: 0.0625rem solid rgba(255, 255, 255, 0.1);\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .daterangepicker td.off,\n[data-theme-version='dark'] .daterangepicker td.off.in-range,\n[data-theme-version='dark'] .daterangepicker td.off.start-date,\n[data-theme-version='dark'] .daterangepicker td.off.end-date {\n\tbackground-color: #272738;\n}\n[data-theme-version='dark'] .daterangepicker td.off:hover,\n[data-theme-version='dark'] .daterangepicker td.off.in-range:hover,\n[data-theme-version='dark'] .daterangepicker td.off.start-date:hover,\n[data-theme-version='dark'] .daterangepicker td.off.end-date:hover {\n\tbackground-color: var(--primary);\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .round .checkmark {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .round:hover input ~ .checkmark {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .round span {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .app-fullcalendar .fc-button {\n\tbackground-color: #202020;\n\tborder-color: var(--primary);\n\tcolor: #fff;\n\ttext-shadow: none;\n}\n[data-theme-version='dark'] .app-fullcalendar .fc-button:hover,\n[data-theme-version='dark'] .app-fullcalendar .fc-button.fc-stat-hover {\n\tbackground-color: var(--primary);\n}\n\n[data-theme-version='dark'] .swal2-popup .swal2-styled:focus {\n\toutline: 0;\n\tbox-shadow: 0 0 0 0.125rem rgba(255, 255, 255, 0.1), 0 0 0 0.25rem var(--rgba-primary-1);\n}\n\n[data-theme-version='dark'] .dd-handle {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .menu-toggle .dlabnav .metismenu li > ul {\n\tbackground: #272738 !important;\n}\n\n[data-theme-version='dark'] .header-right .notification_dropdown .nav-link {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .nav-tabs .nav-link:hover,\n[data-theme-version='dark'] .nav-tabs .nav-link.active {\n\tborder-color: transparent;\n\tbackground: transparent;\n\tcolor: white !important;\n}\n\n[data-theme-version='dark'] .clockpicker-popover .popover-content {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='dark'] .clockpicker-plate {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .clockpicker-popover .popover-title {\n\tbackground-color: #202020;\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link span {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link:after {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.active:after,\n[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.done:after {\n\tbackground: var(--primary);\n}\n\n[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.active span,\n[data-theme-version='dark'] .form-wizard .nav-wizard li .nav-link.done span {\n\tbackground: var(--primary);\n}\n\n[data-theme-version='dark'] .check-switch .custom-control-label:after,\n[data-theme-version='dark'] .check-switch .custom-control-label:before {\n\tborder-color: var(--primary);\n}\n\n[data-theme-version='dark'] .fc-unthemed .fc-today {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .fc-unthemed .fc-divider,\n[data-theme-version='dark'] .fc-unthemed .fc-list-heading td,\n[data-theme-version='dark'] .fc-unthemed .fc-popover .fc-header {\n\tbackground: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .picker__box {\n\tbackground: #202020;\n}\n[data-theme-version='dark'] .picker__box .picker__button--clear,\n[data-theme-version='dark'] .picker__box .picker__button--close,\n[data-theme-version='dark'] .picker__box .picker__button--today {\n\tbackground: #272738;\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .picker__box .picker__button--clear:hover:before,\n[data-theme-version='dark'] .picker__box .picker__button--close:hover:before,\n[data-theme-version='dark'] .picker__box .picker__button--today:hover:before {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .picker {\n\tcolor: #999;\n}\n\n[data-theme-version='dark'] .dtp > .dtp-content {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .dtp table.dtp-picker-days tr > td > a {\n\tcolor: #68686a;\n}\n[data-theme-version='dark'] .dtp table.dtp-picker-days tr > td > a.selected {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .order-request tbody tr {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .card-list li {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .card-bx .change-btn:hover {\n\tcolor: var(--primary);\n}\n\n[data-theme-version='dark'] .invoice-card.bg-warning {\n\tbackground-color: #5b3c1f !important;\n}\n\n[data-theme-version='dark'] .invoice-card.bg-success {\n\tbackground-color: #2a6729 !important;\n}\n\n[data-theme-version='dark'] .invoice-card.bg-info {\n\tbackground-color: #4c276a !important;\n}\n\n[data-theme-version='dark'] .invoice-card.bg-secondary {\n\tbackground-color: #1c3e52 !important;\n}\n\n[data-theme-version='dark'] .user-list li {\n\tborder-color: #272738;\n}\n\n[data-theme-version='dark'] .toggle-switch {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .bar-chart .apexcharts-text tspan {\n\tfill: #969ba0;\n}\n\n[data-theme-version='dark'] .bar-chart line {\n\tstroke: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .accordion.style-1 .accordion-item,\n[data-theme-version='dark'] .invoice-list,\n[data-theme-version='dark'] .form-check-input[type='checkbox'] {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .accordion.style-1 .accordion-header.collapsed .user-info a,\n[data-theme-version='dark'] .accordion.style-1 .accordion-header.collapsed .user-info,\n[data-theme-version='dark'] .accordion.style-1 .accordion-header.collapsed > span {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .ic-card > a {\n\tbackground: #25479f;\n}\n[data-theme-version='dark'] .ic-card > a:first-child {\n\tborder-color: #25479f;\n}\n\n[data-theme-version='dark'] .ic-card span {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] table.dataTable thead th,\n[data-theme-version='dark'] table.dataTable thead td {\n\tborder-color: #272738 !important;\n}\n\n[data-theme-version='dark'] .form-check .form-check-input:checked {\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n\n[data-theme-version='dark'] .dataTables_info {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate span .paginate_button.current,\n[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate span .paginate_button:hover {\n\tbackground: var(--primary);\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .dashboard-select {\n\tbackground: #272738;\n\tcolor: white !important;\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .dashboard-select .list {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .dashboard-select .option:hover,\n[data-theme-version='dark'] .dashboard-select .option.focus,\n[data-theme-version='dark'] .dashboard-select .option.selected.focus {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .card-tabs.style-1 .nav-tabs {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .transaction-details {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .description {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .apexcharts-legend-text {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .area-theme line {\n\tstroke: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .transaction-details .amount-bx {\n\tbackground: #272738;\n}\n[data-theme-version='dark'] .transaction-details .amount-bx i {\n\tbackground: #8d3b0c;\n}\n\n[data-theme-version='dark'] .nice-select .option {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .nice-select .option:hover,\n[data-theme-version='dark'] .nice-select .option.focus,\n[data-theme-version='dark'] .nice-select .option.selected.focus {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .card-tabs.style-1 {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .nice-select .list {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .table-search .input-group .input-group-text {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .dark-btn svg path {\n\tstroke: #fff;\n}\n\n[data-theme-version='dark'] .bar-chart .apexcharts-legend-text {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .Sales tspan {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .timeline-chart rect {\n\tfill: #202020;\n}\n\n[data-theme-version='dark'] .header-info span {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .ck-editor__editable {\n\tbackground: #202020 !important;\n}\n\n[data-theme-version='dark'] .ck.ck-editor .ck.ck-toolbar {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .ck.ck-toolbar .ck.ck-toolbar__separator {\n\tbackground: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .search-area .form-control {\n\tbackground: #202020;\n\tborder: none;\n}\n[data-theme-version='dark'] .search-area .form-control:hover {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .search-area .input-group-text {\n\tbackground: #202020;\n\tborder: none;\n}\n\n[data-theme-version='dark'] .chartBarRunning tspan {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .chartBarRunning line {\n\tstroke: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .reservationChart tspan {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .reservationChart line {\n\tstroke: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .table-condensed i:hover {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .booking-calender thead .picker-switch {\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .booking-calender thead .picker-switch:hover {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .booking-calender .prev:hover,\n[data-theme-version='dark'] .booking-calender .next:hover {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .dlabnav .header-info2 span {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .booking-calender tbody tr .day {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .booking-calender thead .dow {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .customer-search .search-area .form-control {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .customer-search .search-area .input-group-text {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .paging_simple_numbers.dataTables_paginate {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .primary-icon path {\n\tstroke: #fff;\n}\n\n[data-theme-version='dark'] .pagin {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .nav-header .brand-title .brand-sub-title {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .dashboard-calendar .fc-daygrid-day-frame.fc-scrollgrid-sync-inner {\n\tbackground: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dashboard-calendar .fc-non-business {\n\tbackground: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dashboard-calendar .fc-daygrid-day-number {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .event-calend .fc .fc-button-group > .fc-button {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dashboard-calendar .fc-theme-standard td,\n[data-theme-version='dark'] .dashboard-calendar .fc-theme-standard th {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dashboard-calendar .fc .fc-daygrid-more-link {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .fc-theme-standard td,\n[data-theme-version='dark'] .fc-theme-standard th {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .fc-theme-standard .fc-scrollgrid.fc-scrollgrid-liquid,\n[data-theme-version='dark'] .fc-scrollgrid,\n[data-theme-version='dark'] table {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .fc-direction-ltr .fc-daygrid-event.fc-event-end,\n[data-theme-version='dark'] .fc-direction-rtl .fc-daygrid-event.fc-event-start {\n\tbackground: var(--primary);\n}\n\n[data-theme-version='dark'] .dlab-demo-panel .dlab-demo-inner {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .food-list-row {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .popover-body {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .swal2-popup .swal2-content {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .modal-header .close {\n\tbackground: none;\n}\n\n[data-theme-version='dark'] .timeline-panel .media-body small,\n[data-theme-version='dark'] .timeline-panel .media-body .small {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .chatbox .card-header p {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .date-ds-btn {\n\tbackground: #272738;\n\tcolor: white;\n}\n\n[data-theme-version='dark'] .food-list-row .media-bx h5 a,\n[data-theme-version='dark'] .food-list-row .media-bx .h5 a,\n[data-theme-version='dark'] .food-list-row .media-bx .h5 a {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .staff-bx .card-footer {\n\tbackground: #3f4056;\n}\n\n[data-theme-version='dark'] .page-titles .breadcrumb .breadcrumb-item + .breadcrumb-item:before {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .table-striped > tbody > tr:nth-of-type(odd) > * {\n\tcolor: #706f6f;\n}\n\n[data-theme-version='dark'] .accordion .accordion-item {\n\tbackground: transparent;\n}\n\n[data-theme-version='dark'] .list-group-item {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .form-control-plaintext {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] label {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .form-control.custom-image-select-2 .filter-option-inner-inner {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .table tbody tr td {\n\tcolor: #7e8dbf;\n}\n\n[data-theme-version='dark'] .wallet-bar .order-history .price-list .chart-title .text-secondary {\n\tcolor: var(--secondary) !important;\n}\n\n[data-theme-version='dark'] .apexcharts-text tspan {\n\tfill: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .apexcharts-xaxis line {\n\tstroke: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .price-list .card-footer .text-secondary {\n\tcolor: var(--primary) !important;\n}\n\n[data-theme-version='dark'] .chart-title .text-pink {\n\tcolor: #eb62d0 !important;\n}\n\n[data-theme-version='dark'] .form-control.custom-image-select-2.style-1 .dropdown-toggle {\n\tbackground: rgba(172, 76, 188, 0.1) !important;\n}\n\n[data-theme-version='dark'] .form-control.custom-image-select-2 .dropdown-toggle {\n\tbackground: var(--rgba-primary-2) !important;\n}\n\n[data-theme-version='dark'] .transaction-table .card-body .table-responsive thead th {\n\tbackground: #202020;\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .market-chart .text-secondary {\n\tcolor: var(--secondary) !important;\n}\n[data-theme-version='dark'] .market-chart .text-secondary svg path {\n\tfill: var(--secondary);\n}\n\n[data-theme-version='dark'] .chart-title p {\n\tcolor: #7e8dbf;\n}\n\n[data-theme-version='dark'] .market-coin .coin-search-area .form-control {\n\tborder-color: #272738;\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .market-coin .coin-search-area .input-group-text {\n\tborder-color: #272738;\n\tbackground: #272738;\n}\n[data-theme-version='dark'] .market-coin .coin-search-area .input-group-text svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .market-coin .coin-box {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .market-overview .get-report {\n\tcolor: var(--primary) !important;\n}\n\n[data-theme-version='dark'] .coin-content .guest-calendar {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .coin-content .guest-calendar span svg path {\n\tfill: #fff;\n}\n[data-theme-version='dark'] .coin-content .guest-calendar .reportrange span {\n\tcolor: #7e8dbf;\n}\n\n[data-theme-version='dark'] .coin-content .default-select {\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #7e8dbf;\n}\n\n[data-theme-version='dark'] .digital-cash .media .media-content p {\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #7e8dbf;\n}\n\n[data-theme-version='dark'] .digital-cash .card-footer .btn {\n\tcolor: var(--primary) !important;\n}\n\n[data-theme-version='dark'] .form-control.custom-image-select-1 .dropdown-toggle {\n\tbackground: #202020 !important;\n\tcolor: #fff !important;\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .form-control.custom-image-select-1 .filter-option-inner-inner {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .coin-warpper .search-area .form-control {\n\tcolor: #7e8dbf;\n}\n\n[data-theme-version='dark'] .coin-warpper .search-area .input-group-text svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .form-wrapper.trade-form .input-group .input-group-text {\n\tbackground: #202020;\n\tcolor: #7e8dbf;\n}\n\n[data-theme-version='dark'] .market-overview .get-report,\n[data-theme-version='dark'] .market-preview,\n[data-theme-version='dark'] .market-overview .card-header h4,\n[data-theme-version='dark'] .market-overview .card-header .h4,\n[data-theme-version='dark'] .market-overview .card-header .h4,\n[data-theme-version='dark'] .form-wrapper.trade-form .input-group .form-control:focus,\n[data-theme-version='dark'] .coin-warpper .nav .nav-item {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .coin-warpper {\n\tbackground: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .coin-warpper .nav .nav-item .nav-link svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .daterangepicker .calendar-table .next span,\n[data-theme-version='dark'] .daterangepicker .calendar-table .prev span {\n\tborder-color: #fff;\n}\n\n[data-theme-version='dark'] .tbl-orders-style .tp-btn svg path {\n\tstroke: #fff;\n}\n\n[data-theme-version='dark'] .customer-search .search-area .input-group-text svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .student-tbl tbody tr td span .text-secondary {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .market-preview:hover {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .bg-ripple-hover thead tr th {\n\tcolor: #677686;\n}\n\n[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate span .paginate_button {\n\tcolor: #7e8dbf !important;\n}\n\n[data-theme-version='dark'] .portofolio .my-profile .media .media-img a,\n[data-theme-version='dark'] .portofolio .my-profile .portofolio-social li a {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .coin-holding {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .tp-btn svg path {\n\tstroke: #fff;\n}\n\n[data-theme-version='dark'] .copyright strong {\n\tcolor: #9fa4a6;\n}\n\n[data-theme-version='dark'] .support-box .info a {\n\tcolor: #000 !important;\n}\n\n[data-theme-version='dark'] .btn-icon-end {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .donut-chart-sale small,\n[data-theme-version='dark'] .donut-chart-sale .small,\n[data-theme-version='dark'] .donut-chart-sale .small,\n[data-theme-version='dark'] .donut-chart-sale .small {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .border-end {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .ck.ck-editor__main > .ck-editor__editable {\n\tbackground: #202020 !important;\n}\n\n[data-theme-version='dark'] .change-btn a:hover {\n\tcolor: #000;\n}\n\n[data-theme-version='dark'] .dlabnav .main-menu {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .nav-pills .nav-link.active,\n[data-theme-version='dark'] .nav-pills:hover .show > .nav-link {\n\tbackground: var(--rgba-secondary-1);\n\tcolor: var(--secondary);\n}\n\n[data-theme-version='dark'] .toggle-switch .form-check-input:checked:after {\n\tbackground: var(--secondary);\n}\n\n[data-theme-version='dark'] .nav-pills .nav-link:hover {\n\tcolor: var(--secondary);\n}\n\n[data-theme-version='dark'] .table.bg-primary-hover th {\n\tcolor: var(--secondary);\n}\n\n[data-theme-version='dark'] .table.bg-primary-hover tr:hover td,\n[data-theme-version='dark'] .table.bg-primary-hover tr:hover th {\n\tbackground: var(--secondary);\n}\n\n[data-theme-version='dark'] .get-report {\n\tcolor: var(--secondary);\n}\n\n[data-theme-version='dark'] .btn-close {\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 352 512'%3E%3C!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --%3E%3Cpath d='M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z' fill='%23fff'/%3E%3C/svg%3E\");\n}\n\n[data-theme-version='dark'] .coin-holding .coin-box-warper a {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .card .card-box-icon {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .toggle-btn .check {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .toggle-btn .check:after {\n\tbackground: #fff;\n}\n\n[data-theme-version='dark'] .toggle-btn input:checked ~ .check:after {\n\tdisplay: block;\n}\n\n[data-theme-version='dark'] .toggle-btn input:checked ~ .check {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .toggle-btn.expense .check:after {\n\tbackground-color: #fffa6f;\n}\n\n[data-theme-version='dark'] .bootstrap-select .btn {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] #wallet-bar {\n\tbackground-color: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .page-titles {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .tags .tag {\n\tcolor: #fff;\n\tbackground: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .server-content .progress {\n\tbackground-color: transparent;\n}\n\n[data-theme-version='dark'] .student .indox a::before {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] #redial circle {\n\tfill: white;\n}\n\n[data-theme-version='dark'] .dashboard-select .bootstrap-select .btn {\n\tbackground: #383844;\n}\n\n[data-theme-version='dark'] #activity line {\n\tstroke: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .quick-info {\n\tbackground-color: #202020;\n\tborder: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .pagination.no-bg li:not(.page-indicator):not(.active) .page-link {\n\tbackground: #202020;\n\tborder-color: transparent;\n}\n\n[data-theme-version='dark'] .lastest_trans .trans-table .doller,\n[data-theme-version='dark'] .table-pagenation p span,\n[data-theme-version='dark'] .email-list .message .hader,\n[data-theme-version='dark'] .email-list .message .col-mail-2 .date,\n[data-theme-version='dark'] .dz-card .card-footer {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .email-list .message:hover {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .print svg path {\n\tfill: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .right-box-padding.border-start {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .demo-right-inner {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='dark'] .dzm-tabs {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .notification p {\n\tcolor: #000;\n}\n\n[data-theme-version='dark'] .Modal-box {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='dark'] .Modal-box .box3 {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .lastest_trans .trans-table .print,\n[data-theme-version='dark'] .lastest_trans .trans-table .btn.tp-btn.btn-primary {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .lastest_trans .trans-table .btn.tp-btn.btn-primary {\n\tbackground-color: #202020;\n}\n[data-theme-version='dark'] .lastest_trans .trans-table .btn.tp-btn.btn-primary svg circle {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .lastest_trans .trans-table:hover {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .previews-info:hover {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] #activity1 line {\n\tstroke: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button.previous.disabled,\n[data-theme-version='dark'] .dataTables_wrapper .dataTables_paginate .paginate_button.next.disabled {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .plus-bx a {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .kanbanimg li span,\n[data-theme-version='dark'] .kanbanimg img {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .drive,\n[data-theme-version='dark'] .file-header,\n[data-theme-version='dark'] .folder-structure li,\n[data-theme-version='dark'] .file-drive,\n[data-theme-version='dark'] .input-group.search-area,\n[data-theme-version='dark'] .user-photo img,\n[data-theme-version='dark'] .messages .student,\n[data-theme-version='dark'] .fc .fc-button-group > .fc-button,\n[data-theme-version='dark'] .fc-daygrid-dot-event,\n[data-theme-version='dark'] .box-2 .flow,\n[data-theme-version='dark'] .type-massage,\n[data-theme-version='dark'] .chat-box-area .media .message-received .dz-media,\n[data-theme-version='dark'] .chat-left-area .chat-sidebar,\n[data-theme-version='dark'] .email-right-box .table-pagenation,\n[data-theme-version='dark'] .email-list .message {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .timeline-active li:before {\n\tbackground: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .selling .form_exchange .input_exchange .input-select {\n\tbackground-color: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .hamburger svg rect {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .file_area .table-pagenation {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .email-list {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .email-list .message .col-mail-2 .subject {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .email-right-box .table-pagenation,\n[data-theme-version='dark'] .email-right-box .pagination {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='dark'] .email-left-box .mail-list a {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .messages .input-group.search-area input.form-control,\n[data-theme-version='dark'] .messages .input-group.search-area .input-group-text {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .dz-info svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .message-box,\n[data-theme-version='dark'] .type-massage,\n[data-theme-version='dark'] .chat-box-area .media {\n\tbackground: #272738;\n\tcolor: white;\n}\n\n[data-theme-version='dark'] .chat-tabs .chat-bx:after,\n[data-theme-version='dark'] .message-box .input-group.search-area input.form-control,\n[data-theme-version='dark'] .message-box .input-group.search-area .input-group-text {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .search-coundry {\n\tbackground-color: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .search-coundry .bootstrap-select .btn {\n\tbackground: #272738 !important;\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .header.is-fixed {\n\tbackground: var(--headerbg);\n}\n\n[data-theme-version='dark'] .datepicker.datepicker-dropdown th.datepicker-switch {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n[data-theme-version='dark'] .datepicker.datepicker-dropdown th.datepicker-switch:hover {\n\tcolor: #000;\n}\n\n[data-theme-version='dark'] .datepicker.datepicker-dropdown {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .datepicker.datepicker-dropdown .datepicker-days .table-condensed td.day {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .notification_dropdown .dropdown-menu-end .all-notification {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .header-profile2 .dropdown-menu a span {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .profile-card .card-header,\n[data-theme-version='dark'] .profile-card {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .profile-form .form-label {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .author-profile .info-list li,\n[data-theme-version='dark'] .profile-card .card-footer,\n[data-theme-version='dark'] .author-profile .upload-link {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .author-profile .info-list li a,\n[data-theme-version='dark'] .author-profile .author-info span,\n[data-theme-version='dark'] .author-profile .info-list li span {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .author-profile .card-footer .form-control {\n\tborder-color: rgba(255, 255, 255, 0.1);\n\tbackground: #202020 !important;\n}\n\n[data-theme-version='dark'] .header-profile2 .dropdown-menu .ai-icon:hover {\n\tbackground: #202020;\n}\n\n[data-theme-version='dark'] .wallet-bar .closed-icon {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .select2-container--default .select2-selection--multiple .select2-selection__choice,\n[data-theme-version='dark'] .select2-container--classic .select2-selection--multiple .select2-selection__choice {\n\tbackground-color: #272738;\n\tborder-color: #272738;\n}\n\n[data-theme-version='dark'] mark,\n[data-theme-version='dark'] .mark,\n[data-theme-version='dark'] .mark,\n[data-theme-version='dark'] .select2-container--classic .select2-search--inline .select2-search__field {\n\tbackground-color: #202020;\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .select2-container--default .select2-search--inline .select2-search__field {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .select2-container--default .select2-results__option[aria-selected='true'] {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .trans-info .icon {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .legendLabel {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .statistic-content {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] p {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .header-profile2 span {\n\tcolor: rgba(255, 255, 255, 0.6);\n}\n\n[data-theme-version='dark'] .page-titles .datepicker.datepicker-dropdown th.prev:hover {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .compose-content .dropzone {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] #alert-link a {\n\tcolor: #768783;\n}\n\n[data-theme-version='dark'] #message-alert p {\n\tcolor: #666666;\n}\n\n[data-theme-version='dark'] #AlertLeftIcon h5,\n[data-theme-version='dark'] #AlertLeftIcon .h5 {\n\tcolor: #2a353a !important;\n}\n\n[data-theme-version='dark'] #AlertLeftIcon p {\n\tcolor: #666666;\n}\n\n[data-theme-version='dark'] .header.is-fixed {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .sidebar-right-inner .bootstrap-select .btn {\n\tbackground: transparent !important;\n\tcolor: #2a353a;\n\tborder-color: #eeeeee !important;\n}\n\n[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu {\n\tbackground-color: #fff;\n}\n[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item {\n\tcolor: #777777;\n}\n[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item.selected,\n[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item.selected.active,\n[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item.active,\n[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item:hover,\n[data-theme-version='dark'] .sidebar-right-inner .dropdown-menu .dropdown-item:focus {\n\tbackground-color: var(--rgba-primary-1);\n\tcolor: #2a353a;\n}\n\n[data-theme-version='dark'] .type_msg .form-control {\n\tbackground-color: #272738;\n\tbox-shadow: none;\n}\n\n[data-theme-version='dark'] .email-left-box {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .alert .btn-close {\n\tbackground-image: none !important;\n}\n\n[data-theme-version='dark'] #main-wrapper {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .prot-blog .fill a:hover {\n\tcolor: black;\n}\n\n[data-theme-version='dark'] .table-striped > tbody > tr:nth-of-type(odd) > * {\n\tbackground: #1e1e25;\n\tcolor: white !important;\n}\n\n[data-theme-version='dark'] .dlabnav {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .kanban-user .users li span,\n[data-theme-version='dark'] .kanban-user .users li img {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .plus-bx a svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .page-title {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='dark'] .chat-mid-area.bg-white {\n\tbackground-color: #272738 !important;\n}\n\n[data-theme-version='dark'] .message-box {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .message-received p {\n\tbackground-color: #202020 !important;\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .input-group.user-search-area .input-group-text {\n\tbackground-color: #202020;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .input-group.user-search-area .form-control {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .datepicker-days .table-condensed td.day {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .datepicker-days .table-condensed thead th.picker-switch {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .datepicker-days .table-condensed thead th.prev,\n[data-theme-version='dark'] .datepicker-days .table-condensed thead th.picker-switch,\n[data-theme-version='dark'] .datepicker-days .table-condensed thead th.next {\n\tcolor: #fff;\n}\n\n@keyframes blinking {\n\t0% {\n\t\tbackground-color: var(--primary);\n\t}\n\t100% {\n\t\tbackground-color: transparent;\n\t}\n}\n\n[data-theme-version='dark'] input-group.search-area {\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n[data-theme-version='dark'] .doller {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .apexcharts-tooltip.apexcharts-theme-light {\n\tbackground-color: rgba(255, 255, 255, 0.96);\n\tcolor: #000;\n}\n\n[data-theme-version='dark'] .ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .all .show .card-header {\n\tbackground-color: rgba(255, 255, 255, 0.1) !important;\n\tborder-radius: 0.375rem !important;\n}\n\n[data-theme-version='dark'] .all .show .nav-link {\n\twidth: 2.5rem;\n\tmin-width: 2.5rem;\n\theight: 2.5rem;\n\tmargin: 5px;\n\tbackground-color: #272738 !important;\n}\n\n[data-theme-version='dark'] .note-text {\n\tcolor: #000;\n}\n\n[data-theme-version='dark'] .timeline-active.style-1 .timeline-list:before {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .authincation {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'] .authincation-content.style-2 .form-control {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .label-color,\n[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed td.day,\n[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.prev,\n[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.picker-switch,\n[data-theme-version='dark'] .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.next {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .authincation {\n\tbackground-image: url('../images/student-bg-Recovered.jpg') !important;\n}\n\n[data-theme-version='dark'] .table-responsive .table-striped th {\n\tbackground-color: var(--rgba-primary-1);\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .dz-card .card-body.code-area,\n[data-theme-version='dark'] .demo-view .code-area {\n\tbackground-color: #272738;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dz-calender .react-datepicker__day-name,\n[data-theme-version='dark'] .dz-calender .react-datepicker__day,\n[data-theme-version='dark'] .dz-calender .react-datepicker__time-name {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .dz-calender .react-datepicker__current-month {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .dz-calender .react-datepicker__navigation {\n\tbackground: none;\n}\n\n[data-theme-version='dark'] .dz-calender .react-datepicker__navigation-icon:before {\n\tborder-color: #fff;\n}\n\n[data-theme-version='dark'] #overiewChart line {\n\tstroke: #444;\n}\n\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-position='fixed'] .header {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-position='fixed'] .brand-sub-title {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .header {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .header-left .dashboard_bar {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .header-left .search-area .form-control {\n\tbackground: #272738;\n}\n\n[data-theme-version='dark'] .header-left .search-area .input-group-text {\n\tborder: 0;\n\tbackground: #272738;\n}\n[data-theme-version='dark'] .header-left .search-area .input-group-text a {\n\tcolor: #4f7086;\n}\n\n[data-theme-version='dark'] .header-left .input-group.search-area {\n\tborder-color: #58586a;\n}\n\n[data-theme-version='dark'] .header-right .notification_dropdown .nav-link {\n\t/* background: $d-bg!important; */\n}\n[data-theme-version='dark'] .header-right .notification_dropdown .nav-link .badge {\n\tborder-color: #272738;\n}\n\n[data-theme-version='dark'] .header-right .dropdown .nav-link {\n\tcolor: #fff;\n\tbackground-color: #202020 !important;\n\tborder-color: rgba(255, 255, 255, 0.1) !important;\n}\n[data-theme-version='dark'] .header-right .dropdown .nav-link:hover {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .header-right .dropdown.header-profile2 .nav-link {\n\tbackground-color: transparent !important;\n}\n\n[data-theme-version='dark'] .nav-header .hamburger .line {\n\tbackground: #fff !important;\n}\n\n[data-theme-version='dark'] .menu-toggle .nav-header .nav-control .hamburger .line {\n\tbackground-color: #fff !important;\n}\n\n.change-btn a {\n\tcolor: #000;\n}\n\n[data-theme-version='dark'] .nav-header {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .nav-header .brand-title svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .nav-control {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .brand-logo {\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .brand-logo:hover {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .svg-title-path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .nav-header {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .nav-header .brand-title svg path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'] .nav-control {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .brand-logo {\n\tcolor: #fff;\n}\n[data-theme-version='dark'] .brand-logo:hover {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .svg-title-path {\n\tfill: #fff;\n}\n\n[data-theme-version='dark'][data-sidebar-style='mini'] .dlabnav .metismenu li > ul {\n\tbackground-color: #272738;\n}\n\n[data-theme-version='dark'] .fixed-content-box {\n\tbackground-color: #272738;\n}\n[data-theme-version='dark'] .fixed-content-box .head-name {\n\tbackground: #272738;\n\tcolor: #fff;\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .fixed-content-box + .header + .dlabnav {\n\tbackground-color: #202020;\n}\n\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-position='fixed'] .dlabnav {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a,\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a {\n\tbackground: transparent;\n}\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li.mm-active > a i,\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li:hover > a i {\n\tcolor: var(--primary);\n\tbackground: var(--rgba-primary-1);\n}\n\n[data-theme-version='dark'][data-layout='vertical'][data-sidebar-style='compact'] .dlabnav .metismenu > li a > i {\n\tcolor: rgba(255, 255, 255, 0.3);\n}\n\n[data-theme-version='dark'] .ps__thumb-y {\n\tbackground-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .dlabnav .header-profile > a.nav-link {\n\tborder-color: rgba(255, 255, 255, 0.1);\n}\n[data-theme-version='dark'] .dlabnav .header-profile > a.nav-link .header-info span {\n\tcolor: #fff;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu > li > a {\n\tcolor: #b3b3b3;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu > li:hover > a,\n[data-theme-version='dark'] .dlabnav .metismenu > li:focus > a,\n[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a {\n\tcolor: #fff;\n\tbackground: var(--primary) !important;\n}\n[data-theme-version='dark'] .dlabnav .metismenu > li:hover > a::after,\n[data-theme-version='dark'] .dlabnav .metismenu > li:focus > a::after,\n[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a::after {\n\tborder-left: 0.2125rem solid #fff;\n\tborder-top: 0.2125rem solid #fff;\n\tborder-bottom: 0.2125rem solid transparent;\n\tborder-right: 0.2125rem solid transparent;\n}\n[data-theme-version='dark'] .dlabnav .metismenu > li:hover > a i,\n[data-theme-version='dark'] .dlabnav .metismenu > li:focus > a i,\n[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active > a i {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu > li.mm-active ul ul {\n\tbackground-color: transparent;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu ul:after {\n\tbackground-color: rgba(255, 255, 255, 0.1);\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu ul a:hover,\n[data-theme-version='dark'] .dlabnav .metismenu ul a:focus,\n[data-theme-version='dark'] .dlabnav .metismenu ul a.mm-active {\n\tcolor: #fff !important;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu ul a:before {\n\tbackground-color: #fff;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu a {\n\tcolor: rgba(255, 255, 255, 0.6) !important;\n}\n\n[data-theme-version='dark'] .dlabnav .metismenu .has-arrow:after {\n\tborder-top: 0.2125rem solid #b3b3b3;\n\tborder-left: 0.2125rem solid #b3b3b3;\n\tborder-bottom: 0.2125rem solid transparent;\n\tborder-right: 0.2125rem solid transparent;\n}\n\n[data-theme-version='dark'] .sidebar-right .card-tabs .nav-tabs {\n\tborder-color: var(--rgba-primary-1) !important;\n}\n[data-theme-version='dark'] .sidebar-right .card-tabs .nav-tabs .nav-item .nav-link {\n\tcolor: #000 !important;\n}\n\n[data-theme-version='dark'] .sidebar-right .form-control {\n\tbackground: #fff;\n\tcolor: #000;\n\tborder-color: #eeeeee;\n}\n\n[data-theme-version='dark'] .sidebar-right .default-select .list {\n\tbackground: #fff;\n}\n[data-theme-version='dark'] .sidebar-right .default-select .list .option.selected,\n[data-theme-version='dark'] .sidebar-right .default-select .list .option.focus,\n[data-theme-version='dark'] .sidebar-right .default-select .list .option:hover {\n\tbackground: rgba(0, 0, 0, 0.05) !important;\n}\n\n[data-theme-version='dark'] .sidebar-right .sidebar-right-inner > h4,\n[data-theme-version='dark'] .sidebar-right .sidebar-right-inner > .h4 {\n\tcolor: #000 !important;\n}\n\n[data-theme-version='dark'] .sidebar-right .nice-select .option {\n\tbackground: #fff;\n}\n\n[data-theme-version='dark'] .footer {\n\tbackground-color: #272738;\n}\n[data-theme-version='dark'] .footer .copyright {\n\tbackground-color: transparent;\n}\n[data-theme-version='dark'] .footer .copyright p {\n\tcolor: #fff;\n}\n\n\n.wallet-open.active .admin-body {\n\tpadding-right: calc(var(--right-space) - 1.75rem);\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n}\n@media only screen and (max-width: 87.5rem) {\n\t.wallet-open.active .admin-body {\n\t\tpadding-right: 0;\n\t}\n}\n\n.font-8 {\n\tfont-size: 8pt !important;\n}\n.fc-view {\n    margin-top: 4px;\n}\n.dayBox{\n\theight: 10px;\n\twidth: 10px;\n}\n.fc-body .fc-row { min-height: 45px; }\n.tx-center {\n\ttext-align: center;\n}\n.p-name {\n\tcolor: #000;\n}\n.checklist{\n\tpadding: 0.83rem;\n\tbackground: transparent;\n\tborder: 1px solid #dddddd;\n\tborder-radius: 0px;\n\tborder-top-left-radius: 5px;\n\tborder-bottom-left-radius: 5px\n}\n.checklist2{\n\tpadding: 0.93rem;\n\tbackground: transparent;\n\tborder: 1px solid #dddddd;\n\tborder-radius: 0px\n}\n.checklist3{\n\tpadding: 0.95rem;\n\tbackground: transparent;\n\tborder: 1px solid #dddddd;\n\tborder-radius: 0px;\n\tborder-top-right-radius: 5px;\n\tborder-bottom-right-radius: 5px\n}\n.checklist4{\n\tpadding: 0.95rem;\n\tbackground: transparent;\n\tborder: 1px solid #dddddd;\n\tborder-radius: 0px;\n\tborder-top-left-radius: 5px;\n\tborder-bottom-left-radius: 5px\n}\n.checklist4:focus{\n    border-color: var(--primary);\n}\n.form-list-input:checked {\n    background-color: #297f00;\n    border-color: #297f00;\n}\n.form-list-input {\n\twidth: 1.25rem;\n    height: 1.25rem;\n}\n#line .custext{\n\tborder-top-right-radius: 0px !important;\n\tborder-bottom-right-radius: 0px !important;\n\tborder-right:none !important\n}\n#line2 .custext{\n\tborder-top-left-radius: 0px !important;\n\tborder-bottom-left-radius: 0px !important;\n\tborder-left:none !important\n}","//to ignore cli warning about deprecated mixin\n$enable-deprecation-messages: false;\n$ignore-warning             : true;\n\n// Custom class not bootstrap\n$fn:'HelveticaNeue'; // fn = font normal \n$fm:'HelveticaNeueMed'; // fm = font Medium \n$border-radius: 0.5rem;\n// Body\n$body-bg   : #E6EBEE;\n$body-color: #A098AE;\n$headings-color: #303972;\n$b-color: #DDDDDD;\n$main-color:#303972;\n$bg-color:#ffffff;\n$body-text: #A098AE;\n$border-light: #D5DFE7;\n$border-main-color:#dddddd;\n\n// Typography\n$font-family-base: 'Poppins', sans-serif;\n$headings-font-weight   : 600;\n// $headings-font-family:        $fm;\n\n$font-size-base     : 0.875rem !default;\n$font-weight-base   : 400 !default;\n// $line-height-base: 1.6;\n$h1-font-size       : 2.25rem;\n$h2-font-size       : 1.875rem;\n$h3-font-size       : 1.5rem;\n$h4-font-size       : 1.125rem;\n$h5-font-size       : 1rem;\n$h6-font-size       : 0.938rem;\n\n\n//\n// Color system\n//\n$white   : #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black   : #000 !default;\n\n\n$blue  : #374C98;\n$indigo: #6610f2 !default;\n$purple: #6f42c1 !default;\n$pink  : #EB62D0 !default;\n$red   : #EE3232;\n$orange: #ff9900 !default;\n$yellow: #FFFA6F;\n$green : #297F00;\n$teal  : #20c997 !default;\n$cyan  : #3065D0;\n\n\n\n$grays: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$grays: map-merge((\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900),\n  $grays);\n\n\n$muted     : #89879f;\n$text-muted: #89879f;\n$mine-shaft: #262626;\n$ebony-clay: #232833;\n\n$colors: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$colors: map-merge((\n\t\"blue\": $blue,\n    \"indigo\": $indigo,\n    \"purple\": $purple,\n    \"pink\": $pink,\n    \"red\": $red,\n    \"orange\": $orange,\n    \"yellow\": $yellow,\n    \"green\": $green,\n    \"teal\": $teal,\n    \"cyan\": $cyan,\n    \"white\": $white,\n    \"gray\": $gray-600,\n    \"gray-dark\": $gray-800),\n  $colors);\n\n\n  \n$primary  : #4D44B5 !default;\n$secondary: #FB7D5B !default;\n$success  : #1EBA62 !default;\n$info     : #00ADA3 !default;\n$warning  : #FCC43E !default;\n$danger   : #fd5353 !default;\n$light    : #ebebf9 !default;\n$dark     : #303972;\n\n\n:root{\n\t--primary: #{$primary};\n\t--secondary: #{$secondary};\n\t--primary-hover: #{darken($primary, 10)};\n\t--primary-dark: #{darken($primary, 30)};\n\t--rgba-primary-1: #{rgba($primary, 0.1)};\n\t--rgba-primary-2: #{rgba($primary, 0.2)};\n\t--rgba-primary-3: #{rgba($primary, 0.3)};\n\t--rgba-primary-4: #{rgba($primary, 0.4)};\n\t--rgba-primary-5: #{rgba($primary, 0.5)};\n\t--rgba-primary-6: #{rgba($primary, 0.6)};\n\t--rgba-primary-7: #{rgba($primary, 0.7)};\n\t--rgba-primary-8: #{rgba($primary, 0.8)};\n\t--rgba-primary-9: #{rgba($primary, 0.9)};\n\t--rgba-secondary-1: #{rgba($secondary, 0.1)};\n\t--rgba-secondary-2: #{rgba($secondary, 0.2)};\n\t--rgba-secondary-3: #{rgba($secondary, 0.3)};\n\t--rgba-secondary-4: #{rgba($secondary, 0.4)};\n\t--rgba-secondary-5: #{rgba($secondary, 0.5)};\n\t--rgba-secondary-6: #{rgba($secondary, 0.6)};\n\t--rgba-secondary-7: #{rgba($secondary, 0.7)};\n\t--rgba-secondary-8: #{rgba($secondary, 0.8)};\n\t--rgba-secondary-9: #{rgba($secondary, 0.9)};\n\t--font-family-base: #{$font-family-base};\n\t--font-family-title: #{$font-family-base};\n\t--font-family-base: #{$font-family-base};\n\t--font-family-title: #{$font-family-base};\n\t --title: #{$headings-color}; \n}\n\n\n\n\n$theme-colors: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$theme-colors: map-merge((\"primary\": $primary,\n    \"secondary\": $secondary,\n    \"success\": $success,\n    \"info\": $info,\n    \"warning\": $warning,\n    \"danger\": $danger,\n    \"light\": $light,\n    \"dark\": $dark),\n  $theme-colors);\n\n\n// $base-font-size   : 0.8125rem !default;\n$heading-primary-size: 1.8rem;\n$sub-heading-size    : 1.6rem !default;\n\n$grid-gutter-width: 30px;\n\n$dropdown-lik-color: $body-color;\n\n\n$border-color  : #EEEEEE;\n$headings-color:#3d4465 !default;\n$rounded :  0.625rem ;\n\n$grid-breakpoints: (xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1440);\n  \n$border-radius:               0.625rem;\n$border-radius-sm:            0.625rem;\n$border-radius-lg:            0.625rem;\n$border-radius-pill:          0.625rem;\n\n\n\n\n\n\n\n// Form\n$input-padding-x: 1.25rem;\n$input-padding-y: 0.6875rem;\n//$input-border-color\n$input-line-height:1.5;\n$dropdown-item-padding-x:$input-padding-x;","%gradient_one {\n    background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%,rgba(103, 25, 255, .85) 100%);\n}\n\n%gradient-1 {\n    background: #f0a907;\n    background: -moz-linear-gradient(top, #f0a907 0%, #f53c79 100%);\n    background: -webkit-linear-gradient(top, #f0a907 0%,#f53c79 100%);\n    background: linear-gradient(to bottom, #f0a907 0%,#f53c79 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f0a907', endColorstr='#f53c79',GradientType=0 );\n}\n\n%gradient-2 {\n    background: #4dedf5;\n    background: -moz-linear-gradient(top, #4dedf5 0%, #480ceb 100%);\n    background: -webkit-linear-gradient(top, #4dedf5 0%,#480ceb 100%);\n    background: linear-gradient(to bottom, #4dedf5 0%,#480ceb 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4dedf5', endColorstr='#480ceb',GradientType=0 );\n}\n\n%gradient-3 {\n    background: #51f5ae;\n    background: -moz-linear-gradient(top, #51f5ae 0%, #3fbcda 100%);\n    background: -webkit-linear-gradient(top, #51f5ae 0%,#3fbcda 100%);\n    background: linear-gradient(to bottom, #51f5ae 0%,#3fbcda 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#51f5ae', endColorstr='#3fbcda',GradientType=0 );\n}\n\n%gradient-4 {\n    background: #f25521;\n    background: -moz-linear-gradient(left, #f25521 0%, #f9c70a 100%);\n    background: -webkit-linear-gradient(left, #f25521 0%,#f9c70a 100%);\n    background: linear-gradient(to right, #f25521 0%,#f9c70a 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f25521', endColorstr='#f9c70a',GradientType=1 );\n}\n\n%gradient-5 {\n    background: #f53c79;\n    background: -moz-linear-gradient(left, #f53c79 0%, #f0a907 100%);\n    background: -webkit-linear-gradient(left, #f53c79 0%,#f0a907 100%);\n    background: linear-gradient(to right, #f53c79 0%,#f0a907 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f53c79', endColorstr='#f0a907',GradientType=1 );\n}\n\n%gradient-6 {\n    background: #36b9d8;\n    background: -moz-linear-gradient(left, #36b9d8 0%, #4bffa2 100%);\n    background: -webkit-linear-gradient(left, #36b9d8 0%,#4bffa2 100%);\n    background: linear-gradient(to right, #36b9d8 0%,#4bffa2 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#36b9d8', endColorstr='#4bffa2',GradientType=1 );\n}\n\n%gradient-7 {\n    background: #4400eb;\n    background: -moz-linear-gradient(left, #4400eb 0%, #44e7f5 100%);\n    background: -webkit-linear-gradient(left, #4400eb 0%,#44e7f5 100%);\n    background: linear-gradient(to right, #4400eb 0%,#44e7f5 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4400eb', endColorstr='#44e7f5',GradientType=1 );\n}\n\n%gradient-8 {\n    background: #F7B00F;\n    background: -moz-linear-gradient(top, #F7B00F 0%, #F25521 100%);\n    background: -webkit-linear-gradient(top, #F7B00F 0%,#F25521 100%);\n    background: linear-gradient(to bottom, #F7B00F 0%,#F25521 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#F7B00F', endColorstr='#F25521',GradientType=1 );\n\n    // background: linear-gradient(top, #f25521 0%, #f9c70a 100%);\n}\n\n%gradient-9 {\n    background: #f31e7a !important;\n    background: -moz-linear-gradient(left, #f31e7a 0%, #fd712c 100%);\n    background: -webkit-linear-gradient(left, #f31e7a 0%,#fd712c 100%);\n    background: linear-gradient(to right, #f31e7a 0%,#fd712c 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f31e7a', endColorstr='#fd712c',GradientType=1 );\n}\n\n%gradient-10 {\n    background: #f25521 !important;\n    background: -moz-linear-gradient(left, #f25521 0%, #f9c70a 100%);\n    background: -webkit-linear-gradient(left, #f25521 0%,#f9c70a 100%);\n    background: linear-gradient(to top, #f25521 0%,#f9c70a 100%) !important;\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f25521', endColorstr='#f9c70a',GradientType=1 );\n}\n\n%gradient-11 {\n    background: #3398fb;\n    background: -moz-linear-gradient(left, #3398fb 0%, #8553ee 100%);\n    background: -webkit-linear-gradient(left, #3398fb 0%,#8553ee 100%);\n    background: linear-gradient(to right, #3398fb 0%,#8553ee 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#3398fb', endColorstr='#8553ee',GradientType=1 );\n}\n\n%gradient-12 {\n    background: #36e1b4;\n    background: -moz-linear-gradient(left, #36e1b4 0%, #11cae7 100%);\n    background: -webkit-linear-gradient(left, #36e1b4 0%,#11cae7 100%);\n    background: linear-gradient(to right, #36e1b4 0%,#11cae7 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#36e1b4', endColorstr='#11cae7',GradientType=1 );\n}\n\n%gradient-13 {\n    background: #ffbf31;\n    background: -moz-linear-gradient(left, #ffbf31 0%, #ff890e 100%);\n    background: -webkit-linear-gradient(left, #ffbf31 0%,#ff890e 100%);\n    background: linear-gradient(to right, #ffbf31 0%,#ff890e 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffbf31', endColorstr='#ff890e',GradientType=1 );\n}\n\n%gradient-14 {\n    background: #23bdb8;\n    background: -moz-linear-gradient(-45deg, #23bdb8 0%, #43e794 100%);\n    background: -webkit-linear-gradient(-45deg, #23bdb8 0%,#43e794 100%);\n    background: linear-gradient(135deg, #23bdb8 0%,#43e794 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#23bdb8', endColorstr='#43e794',GradientType=1 );\n}\n\n%gradient-15 {\n    background: #9a56ff;\n    background: -moz-linear-gradient(-45deg, #9a56ff 0%, #e36cd9 100%);\n    background: -webkit-linear-gradient(-45deg, #9a56ff 0%,#e36cd9 100%);\n    background: linear-gradient(135deg, #9a56ff 0%,#e36cd9 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#9a56ff', endColorstr='#e36cd9',GradientType=1 );\n}\n\n%gradient-16 {\n    background: #f48665;\n    background: -moz-linear-gradient(-45deg, #f48665 0%, #fda23f 100%);\n    background: -webkit-linear-gradient(-45deg, #f48665 0%,#fda23f 100%);\n    background: linear-gradient(135deg, #f48665 0%,#fda23f 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f48665', endColorstr='#fda23f',GradientType=1 );\n}\n\n%gradient-17 {\n    background: #e36cd9;\n    background: -moz-linear-gradient(-45deg, #e36cd9 0%, #fe60ae 100%);\n    background: -webkit-linear-gradient(-45deg, #e36cd9 0%,#fe60ae 100%);\n    background: linear-gradient(135deg, #e36cd9 0%,#fe60ae 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e36cd9', endColorstr='#fe60ae',GradientType=1 );\n}\n\n%gradient-18 {\n    background: #a15cff;\n    background: -moz-linear-gradient(left, #a15cff 0%, #ce82fd 100%);\n    background: -webkit-linear-gradient(left, #a15cff 0%,#ce82fd 100%);\n    background: linear-gradient(to right, #a15cff 0%,#ce82fd 100%);\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a15cff', endColorstr='#ce82fd',GradientType=1 );\n}\n\n%text-gradient {\n    -webkit-background-clip: text !important;\n    -webkit-text-fill-color: transparent !important;\n}\n","//MEDIA QUERY MANAGER\n\n/*\n0 - 600: Phone\n600 - 900: Tablet portrait\n900 - 1200: Tablet landscape\n1200 - 1800: Normal styles\n1800+ : Big Desktop\n1em = 16px\nThe smaller device rules always should write below the bigger device rules\nFixing Order => Base + Typography >> General Layout + Grid >> Page Layout + Component\n*/\n\n@mixin respond($breakpoint) {\n\n\t@if($breakpoint == \"phone\") { \n\n\t\t@media only screen and (max-width: 35.9375rem) { @content; }     //575\n    } \n    \n    @if($breakpoint == \"phone-land\") {\n\n        @media only screen and (max-width: 47.9375rem) { @content; }   //767\n    }\n\n\t@if($breakpoint == \"tab-port\") {\n\n\t\t@media only screen and (max-width: 61.9375rem) { @content; }   //991\n\t}\n\n\t@if($breakpoint == \"tab-land\") {\n\n\t\t@media only screen and (max-width: 74.9375rem) { @content; } //1199\n    }\n    \n\t@if ($breakpoint == \"laptop\") {\n        @media only screen and (max-width: 87.5rem) { @content; } //1400\n    }\n\t\n    @if ($breakpoint == \"desktop\") {\n        \n        @media only screen and (min-width: 75rem) { @content; } //1200\n    }\n\t\n\t@if($breakpoint == \"big-desktop\") {\n\n\t\t@media only screen and (min-width: 112.5rem) { @content; }  //1800\n\t}\n\n}\n\n\n\n//don't use it untill you need this too much\n@mixin custommq($min: null, $max: null) {\n    @if ($min != null and $max != null) {\n        @media only screen and (min-width: $min) and (max-width: $max) { @content; }\n    }\n\n    @if ($min == null and $max != null) {\n        @media only screen and (max-width: $max) { @content; }\n    }\n\n    @if ($min != null and $max == null) {\n        @media only screen and (min-width: $min) { @content; }\n    }\n}\n\n// transition\n@mixin transitionSlow{\n\t-webkit-transition: all 0.8s;\n\t-ms-transition: all 0.8s;\n\ttransition: all 0.8s;\n}\n@mixin transitionMedium{\n\t-webkit-transition: all 0.5s;\n\t-ms-transition: all 0.5s;\n\ttransition: all 0.5s;\n}\n@mixin transitionFast{\n\t-webkit-transition: all 0.2s;\n\t-ms-transition: all 0.2s;\n\ttransition: all 0.2s;\n}\n@mixin transformScale{\n\ttransform:scale(1);\n\t-moz-transform:scale(1);\n\t-webkit-transform:scale(1);\n\t-ms-transform:scale(1);\n\t-o-transform:scale(1);\n}\n@mixin transformScaleXS{\n\ttransform:scale(0.8);\n\t-moz-transform:scale(0.8);\n\t-webkit-transform:scale(0.8);\n\t-ms-transform:scale(0.8);\n\t-o-transform:scale(0.8);\n}\n@mixin transformScaleSM{\n\ttransform:scale(1.2);\n\t-moz-transform:scale(1.2);\n\t-webkit-transform:scale(1.2);\n\t-ms-transform:scale(1.2);\n\t-o-transform:scale(1.2);\n}\n@mixin transformScaleMD{\n\ttransform:scale(1.5);\n\t-moz-transform:scale(1.5);\n\t-webkit-transform:scale(1.5);\n\t-ms-transform:scale(1.5);\n\t-o-transform:scale(1.5);\n}\n","/*!\n * Bootstrap v5.1.3 (https://getbootstrap.com/)\n * Copyright 2011-2021 The Bootstrap Authors\n * Copyright 2011-2021 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n// scss-docs-start import-stack\n// Configuration\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"utilities\";\n\n// Layout & components\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"images\";\n@import \"containers\";\n@import \"grid\";\n@import \"tables\";\n@import \"forms\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"dropdown\";\n@import \"button-group\";\n@import \"nav\";\n@import \"navbar\";\n@import \"card\";\n@import \"accordion\";\n@import \"breadcrumb\";\n@import \"pagination\";\n@import \"badge\";\n@import \"alert\";\n@import \"progress\";\n@import \"list-group\";\n@import \"close\";\n@import \"toasts\";\n@import \"modal\";\n@import \"tooltip\";\n@import \"popover\";\n@import \"carousel\";\n@import \"spinners\";\n@import \"offcanvas\";\n@import \"placeholders\";\n\n// Helpers\n@import \"helpers\";\n\n// Utilities\n@import \"utilities/api\";\n// scss-docs-end import-stack\n",":root {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$variable-prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$variable-prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$variable-prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$variable-prefix}#{$color}-rgb: #{$value};\n  }\n\n  --#{$variable-prefix}white-rgb: #{to-rgb($white)};\n  --#{$variable-prefix}black-rgb: #{to-rgb($black)};\n  --#{$variable-prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$variable-prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$variable-prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$variable-prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$variable-prefix}gradient: #{$gradient};\n\n  // Root and body\n  // stylelint-disable custom-property-empty-line-before\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$variable-prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$variable-prefix}body-font-family: #{$font-family-base};\n  --#{$variable-prefix}body-font-size: #{$font-size-base};\n  --#{$variable-prefix}body-font-weight: #{$font-weight-base};\n  --#{$variable-prefix}body-line-height: #{$line-height-base};\n  --#{$variable-prefix}body-color: #{$body-color};\n  @if $body-text-align != null {\n    --#{$variable-prefix}body-text-align: #{$body-text-align};\n  }\n  --#{$variable-prefix}body-bg: #{$body-bg};\n  // scss-docs-end root-body-variables\n  // stylelint-enable custom-property-empty-line-before\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    font-size: var(--#{$variable-prefix}root-font-size);\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$variable-prefix}body-font-family);\n  @include font-size(var(--#{$variable-prefix}body-font-size));\n  font-weight: var(--#{$variable-prefix}body-font-weight);\n  line-height: var(--#{$variable-prefix}body-line-height);\n  color: var(--#{$variable-prefix}body-color);\n  text-align: var(--#{$variable-prefix}body-text-align);\n  background-color: var(--#{$variable-prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n// 2. Set correct height and prevent the `size` attribute to make the `hr` look like an input field\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  background-color: currentColor;\n  border: 0;\n  opacity: $hr-opacity;\n}\n\nhr:not([size]) {\n  height: $hr-height; // 2\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-bs-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-bs-original-title] { // 1\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  text-decoration-skip-ink: none; // 4\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n  direction: ltr #{\"/* rtl:ignore */\"};\n  unicode-bidi: bidi-override;\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow in Chrome from inputs built with datalists.\n// See https://stackoverflow.com/a/54997118\n\n[list]::-webkit-calendar-picker-indicator {\n  display: none;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. Correct the outline style in Safari.\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n\n[type=\"search\"] {\n  outline-offset: -2px; // 1\n  -webkit-appearance: textfield; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// Inherit font family and line height for file input buttons\n\n::file-selector-button {\n  font: inherit;\n}\n\n// 1. Change font properties to `inherit`\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::-webkit-file-upload-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + ' ' + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + ' ' + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      }\n      @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + ' ' + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + ' ' + $value;\n      }\n\n      @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + ' ' +  if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + ' calc(' + $min-width + if($value < 0, ' - ', ' + ') + $variable-width + ')';\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluidVal: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluidVal {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluidVal);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule {\n        #{$property}: if($rfs-mode == max-media-query, $fluidVal, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// Bootstrap functions\n//\n// Utility mixins and functions for evaluating source code across our variables, maps, and mixins.\n\n// Ascending\n// Used to evaluate Sass maps like our grid breakpoints.\n@mixin _assert-ascending($map, $map-name) {\n  $prev-key: null;\n  $prev-num: null;\n  @each $key, $num in $map {\n    @if $prev-num == null or unit($num) == \"%\" or unit($prev-num) == \"%\" {\n      // Do nothing\n    } @else if not comparable($prev-num, $num) {\n      @warn \"Potentially invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} whose unit makes it incomparable to #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    } @else if $prev-num >= $num {\n      @warn \"Invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} which isn't greater than #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    }\n    $prev-key: $key;\n    $prev-num: $num;\n  }\n}\n\n// Starts at zero\n// Used to ensure the min-width of the lowest breakpoint starts at 0.\n@mixin _assert-starts-at-zero($map, $map-name: \"$grid-breakpoints\") {\n  @if length($map) > 0 {\n    $values: map-values($map);\n    $first-value: nth($values, 1);\n    @if $first-value != 0 {\n      @warn \"First breakpoint in #{$map-name} must start at 0, but starts at #{$first-value}.\";\n    }\n  }\n}\n\n// Colors\n@function to-rgb($value) {\n  @return red($value), green($value), blue($value);\n}\n\n// stylelint-disable scss/dollar-variable-pattern\n@function rgba-css-var($identifier, $target) {\n  @if $identifier == \"body\" and $target == \"bg\" {\n    @return rgba(var(--#{$variable-prefix}#{$identifier}-bg-rgb), var(--#{$variable-prefix}#{$target}-opacity));\n  } @if $identifier == \"body\" and $target == \"text\" {\n    @return rgba(var(--#{$variable-prefix}#{$identifier}-color-rgb), var(--#{$variable-prefix}#{$target}-opacity));\n  } @else {\n    @return rgba(var(--#{$variable-prefix}#{$identifier}-rgb), var(--#{$variable-prefix}#{$target}-opacity));\n  }\n}\n\n@function map-loop($map, $func, $args...) {\n  $_map: ();\n\n  @each $key, $value in $map {\n    // allow to pass the $key and $value of the map as an function argument\n    $_args: ();\n    @each $arg in $args {\n      $_args: append($_args, if($arg == \"$key\", $key, if($arg == \"$value\", $value, $arg)));\n    }\n\n    $_map: map-merge($_map, ($key: call(get-function($func), $_args...)));\n  }\n\n  @return $_map;\n}\n// stylelint-enable scss/dollar-variable-pattern\n\n@function varify($list) {\n  $result: null;\n  @each $entry in $list {\n    $result: append($result, var(--#{$variable-prefix}#{$entry}), space);\n  }\n  @return $result;\n}\n\n// Internal Bootstrap function to turn maps into its negative variant.\n// It prefixes the keys with `n` and makes the value negative.\n@function negativify-map($map) {\n  $result: ();\n  @each $key, $value in $map {\n    @if $key != 0 {\n      $result: map-merge($result, (\"n\" + $key: (-$value)));\n    }\n  }\n  @return $result;\n}\n\n// Get multiple keys from a sass map\n@function map-get-multiple($map, $values) {\n  $result: ();\n  @each $key, $value in $map {\n    @if (index($values, $key) != null) {\n      $result: map-merge($result, ($key: $value));\n    }\n  }\n  @return $result;\n}\n\n// Merge multiple maps\n@function map-merge-multiple($maps...) {\n  $merged-maps: ();\n\n  @each $map in $maps {\n    $merged-maps: map-merge($merged-maps, $map);\n  }\n  @return $merged-maps;\n}\n\n// Replace `$search` with `$replace` in `$string`\n// Used on our SVG icon backgrounds for custom forms.\n//\n// @author Hugo Giraudel\n// @param {String} $string - Initial string\n// @param {String} $search - Substring to replace\n// @param {String} $replace ('') - New value\n// @return {String} - Updated string\n@function str-replace($string, $search, $replace: \"\") {\n  $index: str-index($string, $search);\n\n  @if $index {\n    @return str-slice($string, 1, $index - 1) + $replace + str-replace(str-slice($string, $index + str-length($search)), $search, $replace);\n  }\n\n  @return $string;\n}\n\n// See https://codepen.io/kevinweber/pen/dXWoRw\n//\n// Requires the use of quotes around data URIs.\n\n@function escape-svg($string) {\n  @if str-index($string, \"data:image/svg+xml\") {\n    @each $char, $encoded in $escaped-characters {\n      // Do not escape the url brackets\n      @if str-index($string, \"url(\") == 1 {\n        $string: url(\"#{str-replace(str-slice($string, 6, -3), $char, $encoded)}\");\n      } @else {\n        $string: str-replace($string, $char, $encoded);\n      }\n    }\n  }\n\n  @return $string;\n}\n\n// Color contrast\n// See https://github.com/twbs/bootstrap/pull/30168\n\n// A list of pre-calculated numbers of pow(divide((divide($value, 255) + .055), 1.055), 2.4). (from 0 to 255)\n// stylelint-disable-next-line scss/dollar-variable-default, scss/dollar-variable-pattern\n$_luminance-list: .0008 .001 .0011 .0013 .0015 .0017 .002 .0022 .0025 .0027 .003 .0033 .0037 .004 .0044 .0048 .0052 .0056 .006 .0065 .007 .0075 .008 .0086 .0091 .0097 .0103 .011 .0116 .0123 .013 .0137 .0144 .0152 .016 .0168 .0176 .0185 .0194 .0203 .0212 .0222 .0232 .0242 .0252 .0262 .0273 .0284 .0296 .0307 .0319 .0331 .0343 .0356 .0369 .0382 .0395 .0409 .0423 .0437 .0452 .0467 .0482 .0497 .0513 .0529 .0545 .0561 .0578 .0595 .0612 .063 .0648 .0666 .0685 .0704 .0723 .0742 .0762 .0782 .0802 .0823 .0844 .0865 .0887 .0908 .0931 .0953 .0976 .0999 .1022 .1046 .107 .1095 .1119 .1144 .117 .1195 .1221 .1248 .1274 .1301 .1329 .1356 .1384 .1413 .1441 .147 .15 .1529 .1559 .159 .162 .1651 .1683 .1714 .1746 .1779 .1812 .1845 .1878 .1912 .1946 .1981 .2016 .2051 .2086 .2122 .2159 .2195 .2232 .227 .2307 .2346 .2384 .2423 .2462 .2502 .2542 .2582 .2623 .2664 .2705 .2747 .2789 .2831 .2874 .2918 .2961 .3005 .305 .3095 .314 .3185 .3231 .3278 .3325 .3372 .3419 .3467 .3515 .3564 .3613 .3663 .3712 .3763 .3813 .3864 .3916 .3968 .402 .4072 .4125 .4179 .4233 .4287 .4342 .4397 .4452 .4508 .4564 .4621 .4678 .4735 .4793 .4851 .491 .4969 .5029 .5089 .5149 .521 .5271 .5333 .5395 .5457 .552 .5583 .5647 .5711 .5776 .5841 .5906 .5972 .6038 .6105 .6172 .624 .6308 .6376 .6445 .6514 .6584 .6654 .6724 .6795 .6867 .6939 .7011 .7084 .7157 .7231 .7305 .7379 .7454 .7529 .7605 .7682 .7758 .7835 .7913 .7991 .807 .8148 .8228 .8308 .8388 .8469 .855 .8632 .8714 .8796 .8879 .8963 .9047 .9131 .9216 .9301 .9387 .9473 .956 .9647 .9734 .9823 .9911 1;\n\n@function color-contrast($background, $color-contrast-dark: $color-contrast-dark, $color-contrast-light: $color-contrast-light, $min-contrast-ratio: $min-contrast-ratio) {\n  $foregrounds: $color-contrast-light, $color-contrast-dark, $white, $black;\n  $max-ratio: 0;\n  $max-ratio-color: null;\n\n  @each $color in $foregrounds {\n    $contrast-ratio: contrast-ratio($background, $color);\n    @if $contrast-ratio > $min-contrast-ratio {\n      @return $color;\n    } @else if $contrast-ratio > $max-ratio {\n      $max-ratio: $contrast-ratio;\n      $max-ratio-color: $color;\n    }\n  }\n\n  @warn \"Found no color leading to #{$min-contrast-ratio}:1 contrast ratio against #{$background}...\";\n\n  @return $max-ratio-color;\n}\n\n@function contrast-ratio($background, $foreground: $color-contrast-light) {\n  $l1: luminance($background);\n  $l2: luminance(opaque($background, $foreground));\n\n  @return if($l1 > $l2, divide($l1 + .05, $l2 + .05), divide($l2 + .05, $l1 + .05));\n}\n\n// Return WCAG2.0 relative luminance\n// See https://www.w3.org/WAI/GL/wiki/Relative_luminance\n// See https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests\n@function luminance($color) {\n  $rgb: (\n    \"r\": red($color),\n    \"g\": green($color),\n    \"b\": blue($color)\n  );\n\n  @each $name, $value in $rgb {\n    $value: if(divide($value, 255) < .03928, divide(divide($value, 255), 12.92), nth($_luminance-list, $value + 1));\n    $rgb: map-merge($rgb, ($name: $value));\n  }\n\n  @return (map-get($rgb, \"r\") * .2126) + (map-get($rgb, \"g\") * .7152) + (map-get($rgb, \"b\") * .0722);\n}\n\n// Return opaque color\n// opaque(#fff, rgba(0, 0, 0, .5)) => #808080\n@function opaque($background, $foreground) {\n  @return mix(rgba($foreground, 1), $background, opacity($foreground) * 100);\n}\n\n// scss-docs-start color-functions\n// Tint a color: mix a color with white\n@function tint-color($color, $weight) {\n  @return mix(white, $color, $weight);\n}\n\n// Shade a color: mix a color with black\n@function shade-color($color, $weight) {\n  @return mix(black, $color, $weight);\n}\n\n// Shade the color if the weight is positive, else tint it\n@function shift-color($color, $weight) {\n  @return if($weight > 0, shade-color($color, $weight), tint-color($color, -$weight));\n}\n// scss-docs-end color-functions\n\n// Return valid calc\n@function add($value1, $value2, $return-calc: true) {\n  @if $value1 == null {\n    @return $value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 + $value2;\n  }\n\n  @return if($return-calc == true, calc(#{$value1} + #{$value2}), $value1 + unquote(\" + \") + $value2);\n}\n\n@function subtract($value1, $value2, $return-calc: true) {\n  @if $value1 == null and $value2 == null {\n    @return null;\n  }\n\n  @if $value1 == null {\n    @return -$value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 - $value2;\n  }\n\n  @if type-of($value2) != number {\n    $value2: unquote(\"(\") + $value2 + unquote(\")\");\n  }\n\n  @return if($return-calc == true, calc(#{$value1} - #{$value2}), $value1 + unquote(\" - \") + $value2);\n}\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-colors-rgb\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\") !default;\n// scss-docs-end theme-colors-rgb\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-200,\n  \"purple-200\": $purple-100,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n$body-text-align:           null !default;\n\n// Utilities maps\n//\n// Extends the default `$theme-colors` maps to help create our utilities.\n\n// Come v6, we'll de-dupe these variables. Until then, for backward compatibility, we keep them to reassign.\n// scss-docs-start utilities-colors\n$utilities-colors: $theme-colors-rgb !default;\n// scss-docs-end utilities-colors\n\n// scss-docs-start utilities-text-colors\n$utilities-text: map-merge(\n  $utilities-colors,\n  (\n    \"black\": to-rgb($black),\n    \"white\": to-rgb($white),\n    \"body\": to-rgb($body-color)\n  )\n) !default;\n$utilities-text-colors: map-loop($utilities-text, rgba-css-var, \"$key\", \"text\") !default;\n// scss-docs-end utilities-text-colors\n\n// scss-docs-start utilities-bg-colors\n$utilities-bg: map-merge(\n  $utilities-colors,\n  (\n    \"black\": to-rgb($black),\n    \"white\": to-rgb($white),\n    \"body\": to-rgb($body-bg)\n  )\n) !default;\n$utilities-bg-colors: map-loop($utilities-bg, rgba-css-var, \"$key\", \"bg\") !default;\n// scss-docs-end utilities-bg-colors\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n$gutters: $spacers !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width * .5 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-color:                $gray-300 !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .25rem !default;\n$border-radius-sm:            .2rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$variable-prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$variable-prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n$hr-height:                   $border-width !default;\n$hr-opacity:                  .25 !default;\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    transparent !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n$table-border-factor:         .1 !default;\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-striped-order:         odd !default;\n\n$table-group-separator-color: currentColor !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         .25rem !default;\n$input-btn-focus-color-opacity: .25 !default;\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity) !default;\n$input-btn-focus-blur:          0 !default;\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              $link-color !default;\n$btn-link-hover-color:        $link-hover-color !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       $text-muted !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              $body-bg !default;\n$input-disabled-bg:                     $gray-200 !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           $body-color !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      $box-shadow-inset !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 1px solid rgba($black, .25) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $gray-200 !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          $box-shadow-inset !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             $gray-300 !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     $box-shadow-inset !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             $gray-500 !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             $input-group-addon-bg !default;\n$form-file-button-hover-bg:       shade-color($form-file-button-bg, 5%) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:       1.25 !default;\n$form-floating-padding-x:         $input-padding-x !default;\n$form-floating-padding-y:         1rem !default;\n$form-floating-input-padding-t:   1.625rem !default;\n$form-floating-input-padding-b:   .625rem !default;\n$form-floating-label-opacity:     .65 !default;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n// scss-docs-end zindex-stack\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    $link-color !default;\n$nav-link-hover-color:              $link-hover-color !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-theme-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .55) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n// scss-docs-end navbar-theme-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               $box-shadow !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         shade-color($dropdown-link-color, 10%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-radius:          $border-radius !default;\n$pagination-margin-start:           -$pagination-border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-color:            $link-hover-color !default;\n$pagination-focus-bg:               $gray-200 !default;\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-border-width:                 $border-width !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-border-radius:                $border-radius !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         $body-color !default;\n$accordion-bg:                            $body-bg !default;\n$accordion-border-width:                  $border-width !default;\n$accordion-border-color:                  rgba($black, .125) !default;\n$accordion-border-radius:                 $border-radius !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  $accordion-color !default;\n$accordion-button-bg:                     $accordion-bg !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $accordion-button-color !default;\n$accordion-icon-active-color:             $accordion-button-active-color !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                $box-shadow !default;\n\n$popover-header-bg:                 shade-color($popover-bg, 6%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n// scss-docs-end popover-variables\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba($black, .1) !default;\n$toast-border-radius:               $border-radius !default;\n$toast-box-shadow:                  $box-shadow !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba($black, .05) !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               $border-radius !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           $border-radius !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            $border-width !default;\n$alert-bg-scale:                -80% !default;\n$alert-border-scale:            -70% !default;\n$alert-color-scale:             40% !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               $box-shadow-inset !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  $gray-900 !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n$list-group-item-bg-scale:          -80% !default;\n$list-group-item-color-scale:       40% !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              $box-shadow-sm !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              $gray-600 !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                $modal-content-bg !default;\n$offcanvas-color:                   $modal-content-color !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         null !default;\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","$borders: (\n    \"right\", \"left\", \"top\", \"bottom\", \"\"\n);\n\n\n$theme_backgrounds: (\n    \"color_1\": $color_pallate_1, \n    \"color_2\": $color_pallate_2, \n    \"color_3\": $color_pallate_3, \n    \"color_4\": $color_pallate_4, \n    \"color_5\": $color_pallate_5, \n    \"color_6\": $color_pallate_6, \n    \"color_7\": $color_pallate_7, \n    \"color_8\": $color_pallate_8, \n    \"color_9\": $color_pallate_9, \n    \"color_10\": $color_pallate_10,\n    \"color_11\": $color_pallate_11,\n    \"color_12\": $color_pallate_12,\n    \"color_13\": $color_pallate_13,\n    \"color_14\": $color_pallate_14,\n    \"color_15\": $color_pallate_15\n);\n\n\n$spacer: 1rem;\n$spacers: (\n  0: 0,\n  1: $spacer * .25, \n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.875,\n  5: $spacer * 3, \n);","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  width: 100%;\n  padding-right: var(--#{$variable-prefix}gutter-x, #{$gutter});\n  padding-left: var(--#{$variable-prefix}gutter-x, #{$gutter});\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$variable-prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$variable-prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$variable-prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$variable-prefix}gutter-x: #{$gutter};\n  --#{$variable-prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$variable-prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$variable-prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$variable-prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$variable-prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$variable-prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$variable-prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$variable-prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$variable-prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  --#{$variable-prefix}table-bg: #{$table-bg};\n  --#{$variable-prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$variable-prefix}table-striped-color: #{$table-striped-color};\n  --#{$variable-prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$variable-prefix}table-active-color: #{$table-active-color};\n  --#{$variable-prefix}table-active-bg: #{$table-active-bg};\n  --#{$variable-prefix}table-hover-color: #{$table-hover-color};\n  --#{$variable-prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  vertical-align: $table-cell-vertical-align;\n  border-color: $table-border-color;\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    background-color: var(--#{$variable-prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$variable-prefix}table-accent-bg);\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n\n  // Highlight border color between thead, tbody and tfoot.\n  > :not(:first-child) {\n    border-top: (2 * $table-border-width) solid $table-group-separator-color;\n  }\n}\n\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-striped-bg);\n    color: var(--#{$variable-prefix}table-striped-color);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-active-bg);\n  color: var(--#{$variable-prefix}table-active-color);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$variable-prefix}table-accent-bg: var(--#{$variable-prefix}table-hover-bg);\n    color: var(--#{$variable-prefix}table-hover-color);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n\n    --#{$variable-prefix}table-bg: #{$background};\n    --#{$variable-prefix}table-striped-bg: #{$striped-bg};\n    --#{$variable-prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$variable-prefix}table-active-bg: #{$active-bg};\n    --#{$variable-prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$variable-prefix}table-hover-bg: #{$hover-bg};\n    --#{$variable-prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: $color;\n    border-color: mix($color, $background, percentage($table-border-factor));\n  }\n}\n// scss-docs-end table-variant\n","//customize bootstrap\n@import './bs-custom';\n\n$strong:#646c9a;\n$border: #f2f2f2;\n$shadow: 0rem 0rem 2.5rem 0rem rgba(82,63,105,0.1);\n\n\n///////////////\n// Solid Color\n///////////////\n$white: #fff;\n$black: #000;\n$charade: #23252F;\n\n/////////////////////////\n// Dark Version Color\n/////////////////////////\n$d-ctd: #ddd;\n$d-ctl: #7e8dbf;\n$d-border:rgba(255, 255, 255, 0.1);\n$d-bg: #202020;\n$dark-card: #272738;\n$dark_bg_lighter: #1E2A4A;\n$dbg-color:#2D2D37;\n$dbody-text:rgba(255,255,255,0.6);\n\n/////////////////////////\n// Primary Light\n/////////////////////////\n$primary-light: lighten($primary, 60%);\n$secondary-light: lighten($secondary, 30%);\n$success-light: lighten($success, 50%);\n$warning-light: lighten($warning, 35%);\n$danger-light: lighten($danger, 30%);\n$info-light: lighten($info, 45%);\n$dark-light: lighten($dark, 50%);\n\n/////////////////////////\n// Opacity \n/////////////////////////\n$primary-opacity: rgba($primary, 0.1);\n$secondary-opacity: rgba($secondary, 0.5);\n$success-opacity: rgba($success, 0.1);\n$warning-opacity: rgba($warning, 0.1);\n$danger-opacity: rgba($danger, 0.15);\n$info-opacity: rgba($info, 0.1);\n$dark-opacity: rgba($dark, 0.35);\n\n////////////////////////\n// Light Version Color\n////////////////////////\n$l-ctd: #464a53;\n$l-ctl: #828690;\n$l-border: #eaeaea;\n$l-bg: #f5f5f5;\n$heading: #333;\n\n///////////////////\n// Material Colors\n///////////////////\n$dusty-gray: #999999;\n$gallery: #EEEEEE;\n$gray: #898989;\n$input-border-color: $border;\n\n\n///////////////////\n// Social Colors\n///////////////////\n$facebook: #3b5998;\n$twitter: #1da1f2;\n$youtube: #FF0000;\n$google-plus: #db4439;\n$linkedin: #007bb6;\n$instagram: #c32aa3;\n$pinterest: #bd081c;\n$google: #4285f4;\n$snapchat: #fffc00;\n$whatsapp: #25d366;\n$tumblr: #35465d;\n$reddit: #ff4500;\n$spotify: #1ed760;\n$yahoo: #430297;\n$dribbble: #ea4c89;\n$skype: #00aff0;\n$quora: #aa2200;\n$riverBed: #4C585C;\n$vimeo: #1ab7ea;\n\n\n///////////////////\n// Misc Colors\n///////////////////\n$iron: #DDDFE1;\n$grey: #D2D6DE;\n$pale-sky: #6a707e;\n$athensGray: #F0F0F2;\n$sky: #2290FF;\n\n\n\n\n\n$color_pallate_1: $white;\n$color_pallate_2: $primary;\n$color_pallate_3: #056468;\n$color_pallate_4: #4d06a5;\n$color_pallate_5: #dc3545;\n$color_pallate_6:  #fd7e14;\n$color_pallate_7: #5155C3;\n$color_pallate_8: #854df3;\n$color_pallate_9:  #20c997;\n$color_pallate_10:  #17a2b8;\n$color_pallate_11: #94618E;\n$color_pallate_12:\t#00273a ;\n$color_pallate_13: #432d29;\n$color_pallate_14: #4885ed;\n$color_pallate_15: #4cb32b;\n\n//utility variables\n\n$radius-sm: 6px;\t\n$radius:    0.375rem;\n$radius-lg: 2.5rem;\n\n\n$loader--width: 15.625rem;\n$loader-dot--size: 1.25rem;\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n\n  &::-webkit-file-upload-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n\n  &::-webkit-file-upload-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n\n  &::-webkit-file-upload-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: auto; // Override fixed browser height\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n    @include border-radius($input-border-radius);\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  // stylelint-disable-next-line property-no-vendor-prefix\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  background-color: $form-select-bg;\n  background-image: escape-svg($form-select-indicator);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n  appearance: none;\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-input {\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  background-color: $form-check-input-bg;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  appearance: none;\n  color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$variable-prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-input-checked-bg-image);\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-radio-checked-bg-image), var(--#{$variable-prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-radio-checked-bg-image);\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image), var(--#{$variable-prefix}gradient);\n    } @else {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image);\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: escape-svg($form-switch-bg-image);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      background-image: escape-svg($form-switch-focus-bg-image);\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        background-image: escape-svg($form-switch-checked-bg-image), var(--#{$variable-prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-switch-checked-bg-image);\n      }\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-select {\n    height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  // stylelint-disable no-duplicate-selectors\n  > .form-control {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-select {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // stylelint-enable no-duplicate-selectors\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus {\n    z-index: 3;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu),\n    > .dropdown-toggle:nth-last-child(n + 3) {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu),\n    > .dropdown-toggle:nth-last-child(n + 4) {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: -$input-border-width;\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity)\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-image: escape-svg($form-select-indicator), escape-svg($icon);\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group .form-control,\n  .input-group .form-select {\n    @include form-validation-state-selector($state) {\n      @if $state == \"valid\" {\n        z-index: 1;\n      } @else if $state == \"invalid\" {\n        z-index: 2;\n      }\n      &:focus {\n        z-index: 3;\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  line-height: $btn-line-height;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-border-radius);\n  @include transition($btn-transition);\n\n  &:hover {\n    color: $body-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active {\n    @include box-shadow($btn-active-box-shadow);\n\n    &:focus {\n      @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    pointer-events: none;\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $btn-link-color;\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: $btn-link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  &:hover {\n    color: $hover-color;\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    color: $hover-color;\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5);\n    }\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active,\n  .show > &.dropdown-toggle {\n    color: $active-color;\n    background-color: $active-background;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix($color, $border, 15%), .5);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $disabled-color;\n    background-color: $disabled-background;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: $disabled-border;\n  }\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  color: $color;\n  border-color: $color;\n\n  &:hover {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  .btn-check:focus + &,\n  &:focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  .btn-check:checked + &,\n  .btn-check:active + &,\n  &:active,\n  &.active,\n  &.dropdown-toggle.show {\n    color: $active-color;\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $color;\n    background-color: transparent;\n  }\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n// scss-docs-end btn-size-mixin\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$variable-prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: 0; // Override default margin of ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: $dropdown-spacer;\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: $dropdown-divider-margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $dropdown-divider-bg;\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  &:hover,\n  &:focus {\n    color: $dropdown-link-hover-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  color: $dropdown-dark-color;\n  background-color: $dropdown-dark-bg;\n  border-color: $dropdown-dark-border-color;\n  @include box-shadow($dropdown-dark-box-shadow);\n\n  .dropdown-item {\n    color: $dropdown-dark-link-color;\n\n    &:hover,\n    &:focus {\n      color: $dropdown-dark-link-hover-color;\n      @include gradient-bg($dropdown-dark-link-hover-bg);\n    }\n\n    &.active,\n    &:active {\n      color: $dropdown-dark-link-active-color;\n      @include gradient-bg($dropdown-dark-link-active-bg);\n    }\n\n    &.disabled,\n    &:disabled {\n      color: $dropdown-dark-link-disabled-color;\n    }\n  }\n\n  .dropdown-divider {\n    border-color: $dropdown-dark-divider-bg;\n  }\n\n  .dropdown-item-text {\n    color: $dropdown-dark-link-color;\n  }\n\n  .dropdown-header {\n    color: $dropdown-dark-header-color;\n  }\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-end {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-start {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == end {\n        @include caret-end();\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-start();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  @include font-size($nav-link-font-size);\n  font-weight: $nav-link-font-weight;\n  color: $nav-link-color;\n  text-decoration: if($link-decoration == none, null, none);\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: $nav-link-hover-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background: none;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    &:hover,\n    &:focus {\n      border-color: $nav-tabs-link-hover-border-color;\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    @include gradient-bg($nav-pills-link-active-bg);\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding-top: $navbar-padding-y;\n  padding-right: $navbar-padding-x; // default: null\n  padding-bottom: $navbar-padding-y;\n  padding-left: $navbar-padding-x; // default: null\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-brand-margin-end;\n  @include font-size($navbar-brand-font-size);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n  @include transition($navbar-toggler-transition);\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 $navbar-toggler-focus-width;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$variable-prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas {\n          position: inherit;\n          bottom: 0;\n          z-index: 1000;\n          flex-grow: 1;\n          visibility: visible !important; // stylelint-disable-line declaration-no-important\n          background-color: transparent;\n          border-right: 0;\n          border-left: 0;\n          @include transition(none);\n          transform: none;\n        }\n        .offcanvas-top,\n        .offcanvas-bottom {\n          height: auto;\n          border-top: 0;\n          border-bottom: 0;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    &:hover,\n    &:focus {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      &:hover,\n      &:focus {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n\n    a,\n    a:hover,\n    a:focus  {\n      color: $navbar-light-active-color;\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    &:hover,\n    &:focus {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      &:hover,\n      &:focus {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a,\n    a:hover,\n    a:focus {\n      color: $navbar-dark-active-color;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n  @include box-shadow($card-box-shadow);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-title-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-title-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-cap-padding-y $card-cap-padding-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-cap-padding-y $card-cap-padding-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-cap-padding-x * .5;\n  margin-bottom: -$card-cap-padding-y;\n  margin-left: -$card-cap-padding-x * .5;\n  border-bottom: 0;\n\n  @if $nav-tabs-link-active-bg != $card-bg {\n    .nav-link.active {\n      background-color: $card-bg;\n      border-bottom-color: $card-bg;\n    }\n  }\n}\n\n.card-header-pills {\n  margin-right: -$card-cap-padding-x * .5;\n  margin-left: -$card-cap-padding-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: $accordion-button-padding-y $accordion-button-padding-x;\n  @include font-size($font-size-base);\n  color: $accordion-button-color;\n  text-align: left; // Reset button style\n  background-color: $accordion-button-bg;\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition($accordion-transition);\n\n  &:not(.collapsed) {\n    color: $accordion-button-active-color;\n    background-color: $accordion-button-active-bg;\n    box-shadow: inset 0 ($accordion-border-width * -1) 0 $accordion-border-color;\n\n    &::after {\n      background-image: escape-svg($accordion-button-active-icon);\n      transform: $accordion-icon-transform;\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: $accordion-icon-width;\n    height: $accordion-icon-width;\n    margin-left: auto;\n    content: \"\";\n    background-image: escape-svg($accordion-button-icon);\n    background-repeat: no-repeat;\n    background-size: $accordion-icon-width;\n    @include transition($accordion-icon-transition);\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: $accordion-button-focus-border-color;\n    outline: 0;\n    box-shadow: $accordion-button-focus-box-shadow;\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  background-color: $accordion-bg;\n  border: $accordion-border-width solid $accordion-border-color;\n\n  &:first-of-type {\n    @include border-top-radius($accordion-border-radius);\n\n    .accordion-button {\n      @include border-top-radius($accordion-inner-border-radius);\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius($accordion-border-radius);\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius($accordion-inner-border-radius);\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius($accordion-border-radius);\n    }\n  }\n}\n\n.accordion-body {\n  padding: $accordion-body-padding-y $accordion-body-padding-x;\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      @include border-radius(0);\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding-x;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding-x;\n      color: $breadcrumb-divider-color;\n      content: var(--#{$variable-prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$variable-prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    color: $pagination-focus-color;\n    background-color: $pagination-focus-bg;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    @include gradient-bg($pagination-active-bg);\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n@include pagination-size($pagination-padding-y, $pagination-padding-x, null, $pagination-border-radius);\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n  }\n\n  .page-item {\n    @if $pagination-margin-start == (-$pagination-border-width) {\n      &:first-child {\n        .page-link {\n          @include border-start-radius($border-radius);\n        }\n      }\n\n      &:last-child {\n        .page-link {\n          @include border-end-radius($border-radius);\n        }\n      }\n    } @else {\n      //Add border-radius to all pageLinks in case they have left margin\n      .page-link {\n        @include border-radius($border-radius);\n      }\n    }\n  }\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  color: $badge-color;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $state, $value in $theme-colors {\n  $alert-background: shift-color($value, $alert-bg-scale);\n  $alert-border: shift-color($value, $alert-border-scale);\n  $alert-color: shift-color($value, $alert-color-scale);\n  @if (contrast-ratio($alert-background, $alert-color) < $min-contrast-ratio) {\n    $alert-color: mix($value, color-contrast($alert-background), abs($alert-color-scale));\n  }\n  .alert-#{$state} {\n    @include alert-variant($alert-background, $alert-border, $alert-color);\n  }\n}\n// scss-docs-end alert-modifiers\n","// scss-docs-start alert-variant-mixin\n@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  .alert-link {\n    color: shade-color($color, 20%);\n  }\n}\n// scss-docs-end alert-variant-mixin\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > li::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-start-radius($list-group-border-radius);\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-end-radius($list-group-border-radius);\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $value in $theme-colors {\n  $list-group-variant-bg: shift-color($value, $list-group-item-bg-scale);\n  $list-group-variant-color: shift-color($value, $list-group-item-color-scale);\n  @if (contrast-ratio($list-group-variant-bg, $list-group-variant-color) < $min-contrast-ratio) {\n    $list-group-variant-color: mix($value, color-contrast($list-group-variant-bg), abs($list-group-item-color-scale));\n  }\n\n  @include list-group-item-variant($state, $list-group-variant-bg, $list-group-variant-color);\n}\n// scss-docs-end list-group-modifiers\n","// List Groups\n\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      &:hover,\n      &:focus {\n        color: $color;\n        background-color: shade-color($background, 10%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n// scss-docs-end list-group-mixin\n","// transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: $btn-close-color;\n  background: transparent escape-svg($btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: $btn-close-opacity;\n\n  // Override <a>'s hover style\n  &:hover {\n    color: $btn-close-color;\n    text-decoration: none;\n    opacity: $btn-close-hover-opacity;\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-close-focus-shadow;\n    opacity: $btn-close-focus-opacity;\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: $btn-close-disabled-opacity;\n  }\n}\n\n.btn-close-white {\n  filter: $btn-close-white-filter;\n}\n",".toast {\n  width: $toast-max-width;\n  max-width: 100%;\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  pointer-events: auto;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  @include border-radius($toast-border-radius);\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: $toast-spacing;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\n\n  .btn-close {\n    margin-right: $toast-padding-x * -.5;\n    margin-left: $toast-padding-x;\n  }\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n  word-wrap: break-word;\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  @include overlay-backdrop($zindex-modal-backdrop, $modal-backdrop-bg, $modal-backdrop-opacity);\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .btn-close {\n    padding: ($modal-header-padding-y * .5) ($modal-header-padding-x * .5);\n    margin: ($modal-header-padding-y * -.5) ($modal-header-padding-x * -.5) ($modal-header-padding-y * -.5) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n\n      .modal-footer {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .tooltip-arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .tooltip-arrow {\n    bottom: 0;\n\n    &::before {\n      top: -1px;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-end {\n  padding: 0 $tooltip-arrow-height;\n\n  .tooltip-arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: -1px;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .tooltip-arrow {\n    top: 0;\n\n    &::before {\n      bottom: -1px;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-start {\n  padding: 0 $tooltip-arrow-height;\n\n  .tooltip-arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: -1px;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0 #{\"/* rtl:ignore */\"};\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .popover-arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-end {\n  > .popover-arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-start {\n  > .popover-arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid $popover-border-color;\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n/* rtl:begin:ignore */\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n/* rtl:end:ignore */\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentColor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: $spinner-animation-speed linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentColor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: $spinner-animation-speed linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: $spinner-animation-speed * 2;\n    }\n  }\n}\n",".offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: $zindex-offcanvas;\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: $offcanvas-color;\n  visibility: hidden;\n  background-color: $offcanvas-bg-color;\n  background-clip: padding-box;\n  outline: 0;\n  @include box-shadow($offcanvas-box-shadow);\n  @include transition(transform $offcanvas-transition-duration ease-in-out);\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: $offcanvas-padding-y $offcanvas-padding-x;\n\n  .btn-close {\n    padding: ($offcanvas-padding-y * .5) ($offcanvas-padding-x * .5);\n    margin-top: $offcanvas-padding-y * -.5;\n    margin-right: $offcanvas-padding-x * -.5;\n    margin-bottom: $offcanvas-padding-y * -.5;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: $offcanvas-title-line-height;\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: $offcanvas-padding-y $offcanvas-padding-x;\n  overflow-y: auto;\n}\n\n.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: $offcanvas-horizontal-width;\n  border-right: $offcanvas-border-width solid $offcanvas-border-color;\n  transform: translateX(-100%);\n}\n\n.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: $offcanvas-horizontal-width;\n  border-left: $offcanvas-border-width solid $offcanvas-border-color;\n  transform: translateX(100%);\n}\n\n.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: $offcanvas-vertical-height;\n  max-height: 100%;\n  border-bottom: $offcanvas-border-width solid $offcanvas-border-color;\n  transform: translateY(-100%);\n}\n\n.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: $offcanvas-vertical-height;\n  max-height: 100%;\n  border-top: $offcanvas-border-width solid $offcanvas-border-color;\n  transform: translateY(100%);\n}\n\n.offcanvas.show {\n  transform: none;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentColor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: $value;\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n      }\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$variable-prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$variable-prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentColor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (eg. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$variable-prefix}#{$property-class}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$variable-prefix}#{$property-class}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $value in $is-local-vars {\n                --#{$variable-prefix}#{$local-var}: #{$value};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// stylelint-disable indentation\n\n// Utilities\n\n$utilities: () !default;\n// stylelint-disable-next-line scss/dollar-variable-default\n$utilities: map-merge(\n  (\n    // scss-docs-start utils-vertical-align\n    \"align\": (\n      property: vertical-align,\n      class: align,\n      values: baseline top middle bottom text-bottom text-top\n    ),\n    // scss-docs-end utils-vertical-align\n    // scss-docs-start utils-float\n    \"float\": (\n      responsive: true,\n      property: float,\n      values: (\n        start: left,\n        end: right,\n        none: none,\n      )\n    ),\n    // scss-docs-end utils-float\n    // Opacity utilities\n    // scss-docs-start utils-opacity\n    \"opacity\": (\n      property: opacity,\n      values: (\n        0: 0,\n        25: .25,\n        50: .5,\n        75: .75,\n        100: 1,\n      )\n    ),\n    // scss-docs-end utils-opacity\n    // scss-docs-start utils-overflow\n    \"overflow\": (\n      property: overflow,\n      values: auto hidden visible scroll,\n    ),\n    // scss-docs-end utils-overflow\n    // scss-docs-start utils-display\n    \"display\": (\n      responsive: true,\n      print: true,\n      property: display,\n      class: d,\n      values: inline inline-block block grid table table-row table-cell flex inline-flex none\n    ),\n    // scss-docs-end utils-display\n    // scss-docs-start utils-shadow\n    \"shadow\": (\n      property: box-shadow,\n      class: shadow,\n      values: (\n        null: $box-shadow,\n        sm: $box-shadow-sm,\n        lg: $box-shadow-lg,\n        none: none,\n      )\n    ),\n    // scss-docs-end utils-shadow\n    // scss-docs-start utils-position\n    \"position\": (\n      property: position,\n      values: static relative absolute fixed sticky\n    ),\n    \"top\": (\n      property: top,\n      values: $position-values\n    ),\n    \"bottom\": (\n      property: bottom,\n      values: $position-values\n    ),\n    \"start\": (\n      property: left,\n      class: start,\n      values: $position-values\n    ),\n    \"end\": (\n      property: right,\n      class: end,\n      values: $position-values\n    ),\n    \"translate-middle\": (\n      property: transform,\n      class: translate-middle,\n      values: (\n        null: translate(-50%, -50%),\n        x: translateX(-50%),\n        y: translateY(-50%),\n      )\n    ),\n    // scss-docs-end utils-position\n    // scss-docs-start utils-borders\n    \"border\": (\n      property: border,\n      values: (\n        null: $border-width solid $border-color,\n        0: 0,\n      )\n    ),\n    \"border-top\": (\n      property: border-top,\n      values: (\n        null: $border-width solid $border-color,\n        0: 0,\n      )\n    ),\n    \"border-end\": (\n      property: border-right,\n      class: border-end,\n      values: (\n        null: $border-width solid $border-color,\n        0: 0,\n      )\n    ),\n    \"border-bottom\": (\n      property: border-bottom,\n      values: (\n        null: $border-width solid $border-color,\n        0: 0,\n      )\n    ),\n    \"border-start\": (\n      property: border-left,\n      class: border-start,\n      values: (\n        null: $border-width solid $border-color,\n        0: 0,\n      )\n    ),\n    \"border-color\": (\n      property: border-color,\n      class: border,\n      values: map-merge($theme-colors, (\"white\": $white))\n    ),\n    \"border-width\": (\n      property: border-width,\n      class: border,\n      values: $border-widths\n    ),\n    // scss-docs-end utils-borders\n    // Sizing utilities\n    // scss-docs-start utils-sizing\n    \"width\": (\n      property: width,\n      class: w,\n      values: (\n        25: 25%,\n        50: 50%,\n        75: 75%,\n        100: 100%,\n        auto: auto\n      )\n    ),\n    \"max-width\": (\n      property: max-width,\n      class: mw,\n      values: (100: 100%)\n    ),\n    \"viewport-width\": (\n      property: width,\n      class: vw,\n      values: (100: 100vw)\n    ),\n    \"min-viewport-width\": (\n      property: min-width,\n      class: min-vw,\n      values: (100: 100vw)\n    ),\n    \"height\": (\n      property: height,\n      class: h,\n      values: (\n        25: 25%,\n        50: 50%,\n        75: 75%,\n        100: 100%,\n        auto: auto\n      )\n    ),\n    \"max-height\": (\n      property: max-height,\n      class: mh,\n      values: (100: 100%)\n    ),\n    \"viewport-height\": (\n      property: height,\n      class: vh,\n      values: (100: 100vh)\n    ),\n    \"min-viewport-height\": (\n      property: min-height,\n      class: min-vh,\n      values: (100: 100vh)\n    ),\n    // scss-docs-end utils-sizing\n    // Flex utilities\n    // scss-docs-start utils-flex\n    \"flex\": (\n      responsive: true,\n      property: flex,\n      values: (fill: 1 1 auto)\n    ),\n    \"flex-direction\": (\n      responsive: true,\n      property: flex-direction,\n      class: flex,\n      values: row column row-reverse column-reverse\n    ),\n    \"flex-grow\": (\n      responsive: true,\n      property: flex-grow,\n      class: flex,\n      values: (\n        grow-0: 0,\n        grow-1: 1,\n      )\n    ),\n    \"flex-shrink\": (\n      responsive: true,\n      property: flex-shrink,\n      class: flex,\n      values: (\n        shrink-0: 0,\n        shrink-1: 1,\n      )\n    ),\n    \"flex-wrap\": (\n      responsive: true,\n      property: flex-wrap,\n      class: flex,\n      values: wrap nowrap wrap-reverse\n    ),\n    \"gap\": (\n      responsive: true,\n      property: gap,\n      class: gap,\n      values: $spacers\n    ),\n    \"justify-content\": (\n      responsive: true,\n      property: justify-content,\n      values: (\n        start: flex-start,\n        end: flex-end,\n        center: center,\n        between: space-between,\n        around: space-around,\n        evenly: space-evenly,\n      )\n    ),\n    \"align-items\": (\n      responsive: true,\n      property: align-items,\n      values: (\n        start: flex-start,\n        end: flex-end,\n        center: center,\n        baseline: baseline,\n        stretch: stretch,\n      )\n    ),\n    \"align-content\": (\n      responsive: true,\n      property: align-content,\n      values: (\n        start: flex-start,\n        end: flex-end,\n        center: center,\n        between: space-between,\n        around: space-around,\n        stretch: stretch,\n      )\n    ),\n    \"align-self\": (\n      responsive: true,\n      property: align-self,\n      values: (\n        auto: auto,\n        start: flex-start,\n        end: flex-end,\n        center: center,\n        baseline: baseline,\n        stretch: stretch,\n      )\n    ),\n    \"order\": (\n      responsive: true,\n      property: order,\n      values: (\n        first: -1,\n        0: 0,\n        1: 1,\n        2: 2,\n        3: 3,\n        4: 4,\n        5: 5,\n        last: 6,\n      ),\n    ),\n    // scss-docs-end utils-flex\n    // Margin utilities\n    // scss-docs-start utils-spacing\n    \"margin\": (\n      responsive: true,\n      property: margin,\n      class: m,\n      values: map-merge($spacers, (auto: auto))\n    ),\n    \"margin-x\": (\n      responsive: true,\n      property: margin-right margin-left,\n      class: mx,\n      values: map-merge($spacers, (auto: auto))\n    ),\n    \"margin-y\": (\n      responsive: true,\n      property: margin-top margin-bottom,\n      class: my,\n      values: map-merge($spacers, (auto: auto))\n    ),\n    \"margin-top\": (\n      responsive: true,\n      property: margin-top,\n      class: mt,\n      values: map-merge($spacers, (auto: auto))\n    ),\n    \"margin-end\": (\n      responsive: true,\n      property: margin-right,\n      class: me,\n      values: map-merge($spacers, (auto: auto))\n    ),\n    \"margin-bottom\": (\n      responsive: true,\n      property: margin-bottom,\n      class: mb,\n      values: map-merge($spacers, (auto: auto))\n    ),\n    \"margin-start\": (\n      responsive: true,\n      property: margin-left,\n      class: ms,\n      values: map-merge($spacers, (auto: auto))\n    ),\n    // Negative margin utilities\n    \"negative-margin\": (\n      responsive: true,\n      property: margin,\n      class: m,\n      values: $negative-spacers\n    ),\n    \"negative-margin-x\": (\n      responsive: true,\n      property: margin-right margin-left,\n      class: mx,\n      values: $negative-spacers\n    ),\n    \"negative-margin-y\": (\n      responsive: true,\n      property: margin-top margin-bottom,\n      class: my,\n      values: $negative-spacers\n    ),\n    \"negative-margin-top\": (\n      responsive: true,\n      property: margin-top,\n      class: mt,\n      values: $negative-spacers\n    ),\n    \"negative-margin-end\": (\n      responsive: true,\n      property: margin-right,\n      class: me,\n      values: $negative-spacers\n    ),\n    \"negative-margin-bottom\": (\n      responsive: true,\n      property: margin-bottom,\n      class: mb,\n      values: $negative-spacers\n    ),\n    \"negative-margin-start\": (\n      responsive: true,\n      property: margin-left,\n      class: ms,\n      values: $negative-spacers\n    ),\n    // Padding utilities\n    \"padding\": (\n      responsive: true,\n      property: padding,\n      class: p,\n      values: $spacers\n    ),\n    \"padding-x\": (\n      responsive: true,\n      property: padding-right padding-left,\n      class: px,\n      values: $spacers\n    ),\n    \"padding-y\": (\n      responsive: true,\n      property: padding-top padding-bottom,\n      class: py,\n      values: $spacers\n    ),\n    \"padding-top\": (\n      responsive: true,\n      property: padding-top,\n      class: pt,\n      values: $spacers\n    ),\n    \"padding-end\": (\n      responsive: true,\n      property: padding-right,\n      class: pe,\n      values: $spacers\n    ),\n    \"padding-bottom\": (\n      responsive: true,\n      property: padding-bottom,\n      class: pb,\n      values: $spacers\n    ),\n    \"padding-start\": (\n      responsive: true,\n      property: padding-left,\n      class: ps,\n      values: $spacers\n    ),\n    // scss-docs-end utils-spacing\n    // Text\n    // scss-docs-start utils-text\n    \"font-family\": (\n      property: font-family,\n      class: font,\n      values: (monospace: var(--#{$variable-prefix}font-monospace))\n    ),\n    \"font-size\": (\n      rfs: true,\n      property: font-size,\n      class: fs,\n      values: $font-sizes\n    ),\n    \"font-style\": (\n      property: font-style,\n      class: fst,\n      values: italic normal\n    ),\n    \"font-weight\": (\n      property: font-weight,\n      class: fw,\n      values: (\n        light: $font-weight-light,\n        lighter: $font-weight-lighter,\n        normal: $font-weight-normal,\n        bold: $font-weight-bold,\n        bolder: $font-weight-bolder\n      )\n    ),\n    \"line-height\": (\n      property: line-height,\n      class: lh,\n      values: (\n        1: 1,\n        sm: $line-height-sm,\n        base: $line-height-base,\n        lg: $line-height-lg,\n      )\n    ),\n    \"text-align\": (\n      responsive: true,\n      property: text-align,\n      class: text,\n      values: (\n        start: left,\n        end: right,\n        center: center,\n      )\n    ),\n    \"text-decoration\": (\n      property: text-decoration,\n      values: none underline line-through\n    ),\n    \"text-transform\": (\n      property: text-transform,\n      class: text,\n      values: lowercase uppercase capitalize\n    ),\n    \"white-space\": (\n      property: white-space,\n      class: text,\n      values: (\n        wrap: normal,\n        nowrap: nowrap,\n      )\n    ),\n    \"word-wrap\": (\n      property: word-wrap word-break,\n      class: text,\n      values: (break: break-word),\n      rtl: false\n    ),\n    // scss-docs-end utils-text\n    // scss-docs-start utils-color\n    \"color\": (\n      property: color,\n      class: text,\n      local-vars: (\n        \"text-opacity\": 1\n      ),\n      values: map-merge(\n        $utilities-text-colors,\n        (\n          \"muted\": $text-muted,\n          \"black-50\": rgba($black, .5), // deprecated\n          \"white-50\": rgba($white, .5), // deprecated\n          \"reset\": inherit,\n        )\n      )\n    ),\n    \"text-opacity\": (\n      css-var: true,\n      class: text-opacity,\n      values: (\n        25: .25,\n        50: .5,\n        75: .75,\n        100: 1\n      )\n    ),\n    // scss-docs-end utils-color\n    // scss-docs-start utils-bg-color\n    \"background-color\": (\n      property: background-color,\n      class: bg,\n      local-vars: (\n        \"bg-opacity\": 1\n      ),\n      values: map-merge(\n        $utilities-bg-colors,\n        (\n          \"transparent\": transparent\n        )\n      )\n    ),\n    \"bg-opacity\": (\n      css-var: true,\n      class: bg-opacity,\n      values: (\n        10: .1,\n        25: .25,\n        50: .5,\n        75: .75,\n        100: 1\n      )\n    ),\n    // scss-docs-end utils-bg-color\n    \"gradient\": (\n      property: background-image,\n      class: bg,\n      values: (gradient: var(--#{$variable-prefix}gradient))\n    ),\n    // scss-docs-start utils-interaction\n    \"user-select\": (\n      property: user-select,\n      values: all auto none\n    ),\n    \"pointer-events\": (\n      property: pointer-events,\n      class: pe,\n      values: none auto,\n    ),\n    // scss-docs-end utils-interaction\n    // scss-docs-start utils-border-radius\n    \"rounded\": (\n      property: border-radius,\n      class: rounded,\n      values: (\n        null: $border-radius,\n        0: 0,\n        1: $border-radius-sm,\n        2: $border-radius,\n        3: $border-radius-lg,\n        circle: 50%,\n        pill: $border-radius-pill\n      )\n    ),\n    \"rounded-top\": (\n      property: border-top-left-radius border-top-right-radius,\n      class: rounded-top,\n      values: (null: $border-radius)\n    ),\n    \"rounded-end\": (\n      property: border-top-right-radius border-bottom-right-radius,\n      class: rounded-end,\n      values: (null: $border-radius)\n    ),\n    \"rounded-bottom\": (\n      property: border-bottom-right-radius border-bottom-left-radius,\n      class: rounded-bottom,\n      values: (null: $border-radius)\n    ),\n    \"rounded-start\": (\n      property: border-bottom-left-radius border-top-left-radius,\n      class: rounded-start,\n      values: (null: $border-radius)\n    ),\n    // scss-docs-end utils-border-radius\n    // scss-docs-start utils-visibility\n    \"visibility\": (\n      property: visibility,\n      class: null,\n      values: (\n        visible: visible,\n        invisible: hidden,\n      )\n    )\n    // scss-docs-end utils-visibility\n  ),\n  $utilities\n);\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n",".c-pointer {\n    cursor: pointer;\n}\n","@import \"../abstracts/maps\";\n@import \"./../other/animate/animate.min.css\";\n@import \"./../other/aos/css/aos.min.css\";\n@import \"./../other/perfect-scrollbar/css/perfect-scrollbar.css\";\n@import \"./../other/metismenu/css/metisMenu.min.css\";\n* {\n    outline: none;\n    padding: 0;\n    &::after {\n        margin: 0;\n        padding: 0;\n    }\n    &::before {\n        margin: 0;\n        padding: 0;\n    }\n}\n::selection {\n    color: #fff;\n    background: var(--primary);\n}\n.dropzone .dz-message{\n\tmargin: 5em 0;\n}\nh1,h2,h3,h4,h5,h6{\n\ta{\n\t\tcolor: $main-color;\n\t\t&:hover{\n\t\t\tcolor: var(--primary)!important;\n\t\t}\n\t}\n}\n.light-logo{\n\tdisplay:none;\n}\n[data-theme-version=\"dark\"] {\n\t.light-logo{\n\t\tdisplay:block;\n\t}\n\t.dark-logo{\n\t\tdisplay:none;\n\t}\n}\n\n// hide scrollbar but allow scrolling /\nbody {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  //overflow-y: scroll; \n}\n\nbody::-webkit-scrollbar {\n  display: none;\n}\n\n@include custommq($max: 100rem) {\n\t:root{\n\t\tfont-size:0.875rem;\n\t}\n}\n\nbody {\n    overflow-x: hidden;\n    height: 100%;\n    position: relative;\n    max-width: 100%;\n\tfont-size:0.875rem;\n\t@include respond('tab-port') {\n\t\tfont-size:0.875rem;\n\t}\n}\ntextarea.form-control{\n\tmin-height:auto!important;\n\theight:auto!important;\n}\n.form-label{\n\tmargin-bottom:0.5rem;\n}\n.required{\n\tcolor:$danger!important;\n}\np{\n    line-height: 1.8;\n    font-weight: 400;\n    color: $body-text;\n}\n\n.box-shadow-none {\n    box-shadow: none!important;\n}\n\n.media {\n    display: flex;\n    align-items: flex-start;\n}\n.media-body {\n    flex: 1;\n}\n\n#main-wrapper {\n    opacity: 0;\n    transition: all 0.25s ease-in;\n    position: relative;\n\tbackground-color:$body-bg;\n    // background: $body-bg;\n    &.show {\n        opacity: 1;\n    }\n}\n.rounded-lg{\n\tborder-radius:$radius;\n}\nul {\n    padding: 0;\n    margin: 0;\n}\n\nli {\n    list-style: none;\n}\n\na {\n    color: $body-text;\n\ttext-decoration:none;\n    &:hover,\n    &:focus,\n    &.active {\n        text-decoration: none;\n    }\n}\n.btn-link{\n\t&:hover,\n    &:focus,\n    &.active{\n\t\ttext-decoration:none;\n\t}\n}\n\n.bg-primary {\n    background-color: var(--primary) !important;\n}\n.text-primary {\n    color:var(--primary) !important;\n}\n.fs-12{font-size:0.75rem !important; line-height:1.5; }\n.fs-13{font-size:0.8125rem !important; line-height:1.5; }\n.fs-14{font-size:0.875rem !important; line-height:1.6; }\n.fs-15{font-size:0.938rem !important; line-height:1.5; }\n.fs-16{\n\tfont-size:1rem !important;\n\tline-height:1.6; \n\t@include respond ('phone'){\n\t\tfont-size:0.875rem !important;\n\t}\n}\n.fs-18{\n\tfont-size:1.125rem !important; \n\tline-height:1.5; \n\t@include respond ('phone'){\n\t\tfont-size:1rem !important; \n\t}\n}\n.fs-20{font-size:1.25rem !important; line-height:1.5; }\n.fs-22{font-size:1.375rem !important; line-height:1.5; }\n.fs-24{font-size:1.5rem !important; line-height:1.4; }\n.fs-26{font-size:1.625rem !important; line-height:1.4; }\n.fs-28{\n\tfont-size:1.75rem !important; \n\tline-height:1.4; \n\t@include respond ('phone'){\n\t\tfont-size:1.5rem !important;\n\t}\n}\n.fs-30{font-size:1.875rem !important; line-height:1.4; }\n.fs-32{font-size:2rem !important; line-height:1.25; }\n.fs-34{font-size:2.125rem !important; line-height:1.25; }\n.fs-35{font-size:2.1875rem !important; line-height:1.25; }\n.fs-36{font-size:2.25rem !important; line-height:1.25; }\n.fs-38{font-size:2.375rem !important; line-height:1.25; }\n.fs-46{font-size:2.875rem !important; line-height:1.25; }\n.fs-48{font-size:3rem !important; line-height:1.25; }\n.font-w100{font-weight:100;}\n.font-w200{font-weight:200;}\n.font-w300{font-weight:300;}\n.font-w400{font-weight:400 !important;}\n.font-w500{font-weight:500;}\n.font-w600{font-weight:600;}\n.font-w700{font-weight:700;}\n.font-w800{font-weight:800;}\n.font-w900{font-weight:900;}\n\n\nh1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6{\n\tline-height:1.5;\n\tcolor:$main-color;\n}\n\n\n.w-space-no{\n\twhite-space:nowrap;\n}\n// .content-body {\n//     .container-fluid {\n//         padding: 0 1.875rem 0;\n//         @include media-breakpoint-down(sm) {\n//             padding: 0 1.5rem 0;\n//             padding: 0 0.9375rem 0;\n//         }\n//     }\n// }\n.content-body {\n    .container {\n        margin-top: 2.5rem;\n    }\n    .container-fluid {\n        padding-top: 1.875rem;\n        padding-right: 1.875rem;\n        padding-left: 1.875rem;\n\t\t@include custommq($max: 75rem) {\n\t\t\tpadding-top: 1.875rem;\n\t\t\tpadding-right: 1.875rem;\n\t\t\tpadding-left: 1.875rem;\n\t\t}\n\t\t@include custommq($max: 47.9375rem) {\n\t\t\tpadding-top: 1.25rem;\n\t\t\tpadding-right: 1.25rem;\n\t\t\tpadding-left: 1.25rem;\n\t\t}\n\t\t@include custommq($max: 35.9375rem) {\n\t\t\tpadding-top: 15px;\n\t\t\tpadding-right: 15px;\n\t\t\tpadding-left: 15px;\n\t\t}\n        \n    }\n}\n\n/*sp*/\n.row.sp4,\n.sp4{\n\tmargin-left:-0.125rem;\n\tmargin-right:-0.125rem;\n\t[class*=\"col-\"]{\n\t\tpadding-left:0.125rem;\n\t\tpadding-right:0.125rem;\n\t}\n}\n\n.op1{opacity:0.1;}\n.op2{opacity:0.2;}\n.op3{opacity:0.3;}\n.op4{opacity:0.4;}\n.op5{opacity:0.5;}\n.op6{opacity:0.6;}\n.op7{opacity:0.7;}\n.op8{opacity:0.8;}\n.op9{opacity:0.9;}\n\n\n.content-heading {\n    font-size: 1rem;\n    margin-bottom: 1.875rem;\n    margin-top: 3.125rem;\n    border-bottom: 0.0625rem solid $border;\n    padding-bottom: 0.625rem;\n    @at-root [direction=\"rtl\"] #{&} {\n        text-align: right;\n    }\n}\n\n//change bootstrap default button behaviour on :focus:active 😢\n.btn {\n    &-primary {\n        &:not(:disabled):not(.disabled) {\n            &:active,\n            &.active {\n                &:focus {\n                    box-shadow: none;\n                }\n            }\n        }\n    }\n}\n\n\n\n\n.vh-100{\n    height:100vh !important;\n}\n.img-fix{\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n// Support ticket btn\n.support-ticket {\n    position: fixed;\n    bottom: 1.875rem;\n    right: 0.9375rem;\n    z-index: 999999;\n}\n\n.support-ticket-btn {\n    width: 6.25rem;\n    background: #7CB442;\n    animation: 0.7s ease-in-out 0s infinite alternate none running crescendo;\n    border-radius: 3.125rem;\n    color: #fff;\n    font-size: 0.5rem;\n    font-size: 1rem;\n    padding: 0.3125rem 0.625rem 0.4375rem;\n    text-align: center;\n    display: inline-block;\n    box-shadow: rgba(124, 180, 66, 0.7) 0rem 0.5rem 2.1875rem 0rem;\n    &:hover,\n    &:focus {\n        color: #fff;\n    }\n}\n.text-blue  { color:$blue  ;}\n.text-indigo{ color:$indigo;}\n.text-purple{ color:$purple;}\n.text-pink  { color:$pink!important;}\n.text-red   { color:$red   ;}\n.text-orange{ color:$orange;}\n.text-yellow{ color:$yellow;}\n.text-green { color:$green ;}\n.text-teal  { color:$teal  ;}\n.text-cyan  { color:$cyan  ;}\n\n/* .bg-gray-dark{\n\tbackground:$color_pallate_2 !important;\n}\n.bg-purpal{\n\tbackground:$color_pallate_4 !important;\n}\n.bg-red{\n\tbackground:$color_pallate_5 !important;\n}\n.bg-blue-dark{\n\tbackground:$color_pallate_6 !important;\n} */\n.bg-blue{\n\tbackground:#496ecc!important;\n}\n.bg-orange{\n\tbackground:#ed8030!important;\n}\n.bg-green{\n\tbackground:#299e4a!important;\n}\n.bg-purpel{\n\tbackground:#9517c1!important;\n}\n.bg-dark-blue{\n\tbackground:#251e71!important;\n}\n/* .bg-blue-light{\n\tbackground:$color_pallate_8 !important;\n}\n.bg-green-light{\n\tbackground:$color_pallate_9 !important;\n}\n.bg-green{\n\tbackground:$color_pallate_10 !important;\n} */\n.bg-black{\n\tbackground:$black;\n}\n.text-black{\n\tcolor:$black !important;\n}\n.dlab-scroll{\n\tposition:relative;\n}\n\n.scale1{\n\ttransform:scale(1.1);\n\t-moz-transform:scale(1.1);\n\t-webkit-transform:scale(1.1);\n\t-ms-transform:scale(1.1);\n\t-o-transform:scale(1.1);\n\tdisplay:inline-block;\n}\n.scale2{\n\ttransform:scale(1.2);\n\t-moz-transform:scale(1.2);\n\t-webkit-transform:scale(1.2);\n\t-ms-transform:scale(1.2);\n\t-o-transform:scale(1.2);\n\tdisplay:inline-block;\n}\n.scale3{\n\ttransform:scale(1.3);\n\t-moz-transform:scale(1.3);\n\t-webkit-transform:scale(1.3);\n\t-ms-transform:scale(1.3);\n\t-o-transform:scale(1.3);\n\tdisplay:inline-block;\n}\n.scale4{\n\ttransform:scale(1.4);\n\t-moz-transform:scale(1.4);\n\t-webkit-transform:scale(1.4);\n\t-ms-transform:scale(1.4);\n\t-o-transform:scale(1.4);\n\tdisplay:inline-block;\n}\n.scale5{\n\ttransform:scale(1.5);\n\t-moz-transform:scale(1.5);\n\t-webkit-transform:scale(1.5);\n\t-ms-transform:scale(1.5);\n\t-o-transform:scale(1.5);\n\tdisplay:inline-block;\n}\n.scale-2{\n\ttransform:scale(2);\n\t-moz-transform:scale(2);\n\t-webkit-transform:scale(2);\n\t-ms-transform:scale(2);\n\t-o-transform:scale(2);\n\tdisplay:inline-block;\n}\n\n\n//   @keyframes crescendo {\n//     0%   {transform: scale(.8);}\n//     50% {transform: scale(1);}\n//   }\n@-webkit-keyframes crescendo {\n    from {\n        -webkit-transform: translateY(0.3125rem) scale(.8);\n        -ms-transform: translateY(0.3125rem) scale(.8);\n        transform: translateY(0.3125rem) scale(.8);\n    }\n    to {\n        -webkit-transform: translateY(0rem) scale(1);\n        -ms-transform: translateY(0rem) scale(1);\n        transform: translateY(0rem) scale(1);\n    }\n}\n\n.mh-auto {\n    min-height: auto !important;\n}\n.out-footer{\n\twidth: calc(100% - 22.625rem);\n    margin-right: 1.875rem;\n    margin-left: auto;\n\t@include respond('laptop'){\n\t\twidth: calc(100% - 20.625rem);\n\t}\n\t@include custommq($max:63.938rem){\n\t\twidth: calc(100% - 10.125rem);\n\t}\n\t@include respond('tab-port'){\n\t\twidth: calc(100% - 10.125rem);\n\t}\n\t@include respond('phone-land'){\n\t\twidth: 100%;\n\t}\n\t\n\t\n}\n.overflow-y-scroll{\n    overflow-y: scroll;\n}\n.height10 { height:0.625rem; }\n.height20 { height:1.25rem; }\n.height30 { height:1.875rem; }\n.height40 { height:2.5rem; }\n.height50 { height:3.125rem; }\n.height60 { height:3.75rem; }\n.height70 { height:4.375rem; }\n.height80 { height:5rem; }\n.height90 { height:5.625rem; }\n.height100{ height:6.25rem; }\n.height110 { height:6.875rem; }\n.height120 { height:7.5rem; }\n.height130 { height:8.125rem; }\n.height140 { height:8.75rem; }\n.height150 { height:9.375rem; }\n.height160 { height:10rem; }\n.height170 { height:10.625rem; }\n.height180 { height:11.25rem; }\n.height190 { height:11.875rem; }\n.height200{ height:12.5rem; }\n.height210 { height:13.125rem; }\n.height220 { height:13.75rem; }\n.height230 { height:14.375rem; }\n.height240 { height:15rem; }\n.height250 { height:15.625rem; }\n.height260 { height:16.25rem; }\n.height270 { height:16.875rem; }\n.height280 { height:17.5rem; }\n.height290 { height:18.125rem; }\n.height300{ height:18.75rem; }\n.height310 { height:19.375rem; }\n.height320 { height:20rem; }\n.height330 { height:20.625rem; }\n.height340 { height:21.25rem; }\n.height350 { height:21.875rem; }\n.height360 { height:22.5rem; }\n.height370 { height:23.125rem; }\n.height380 { height:23.75rem; }\n.height390 { height:24.375rem; }\n.height400{ height:25rem; }\n.height415{ height:25.9375rem; }\n.height450{ height:28.125rem; }\n.height500{ height:31.25rem; }\n.height550{ height:34.375rem; }\n.height600{ height:37.5rem; }\n.height630{ height:39.375rem; }\n.height720{ height:45rem; }\n.height750{ height:46.875rem; }\n.height800{ height:50rem; }\n.width10  { width:0.625rem; }\n.width20  { width:1.25rem; }\n.width30  { width:1.875rem; }\n.width40  { width:2.5rem; }\n.width50  { width:3.125rem; }\n.width60  { width:3.75rem; }\n.width70  { width:4.375rem; }\n.width80  { width:5rem; }\n.width90  { width:5.625rem; }\n.width100 { width:6.25rem; }\n.width110 { width:6.875rem; }\n.width120 { width:7.5rem; }\n.width130 { width:8.125rem; }\n.width140 { width:8.75rem; }\n.width150 { width:9.375rem; }\n.width160 { width:10rem; }\n.width170 { width:10.625rem; }\n.width180 { width:11.25rem; }\n.width190 { width:11.875rem; }\n.width200 { width:12.5rem; }\n.width210 { width:13.125rem; }\n.width220 { width:13.75rem; }\n.width230 { width:14.375rem; }\n.width240 { width:15rem; }\n.width250 { width:15.625rem; }\n.width260 { width:16.25rem; }\n.width270 { width:16.875rem; }\n.width280 { width:17.5rem; }\n.width290 { width:18.125rem; }\n.width300 { width:18.75rem; }\n.width310 { width:19.375rem; }\n.width320 { width:20rem; }\n.width330 { width:20.625rem; }\n.width340 { width:21.25rem; }\n.width350 { width:21.875rem; }\n.width360 { width:22.5rem; }\n.width370 { width:23.125rem; }\n.width380 { width:23.75rem; }\n.width390 { width:24.375rem; }\n.width400 { width:25rem; }\n\n\n\n.rounded{border-radius:$radius!important;}\n\nlabel{\n\tmargin-bottom:0.5rem;\n}\n\n@keyframes gXGDoR {\n    from {\n        -webkit-transform: translateY(0.3125rem) scale(.8);\n        -ms-transform: translateY(0.3125rem) scale(.8);\n        transform: translateY(0.3125rem) scale(.8);\n    }\n    to {\n        -webkit-transform: translateY(0rem) scale(1);\n        -ms-transform: translateY(0rem) scale(1);\n        transform: translateY(0rem) scale(1);\n    }\n}\n\n@keyframes crescendo {\n    from {\n        -webkit-transform: translateY(0.3125rem) scale(.8);\n        -ms-transform: translateY(0.3125rem) scale(.8);\n        transform: translateY(0.3125rem) scale(.8);\n    }\n    to {\n        -webkit-transform: translateY(0rem) scale(1);\n        -ms-transform: translateY(0rem) scale(1);\n        transform: translateY(0rem) scale(1);\n    }\n}\n\n@keyframes gXGDoR {\n    from {\n        -webkit-transform: translateY(0.3125rem) scale(.8);\n        -ms-transform: translateY(0.3125rem) scale(.8);\n        transform: translateY(0.3125rem) scale(.8);\n    }\n    to {\n        -webkit-transform: translateY(0rem) scale(1);\n        -ms-transform: translateY(0rem) scale(1);\n        transform: translateY(0rem) scale(1);\n    }\n}\n.bg-pink{\n\tbackground-color: $pink !important;\n}\ndiv, span, ol, ul {\n  scrollbar-width: thin;\n}","$grid-columns: 12;\n\n\n@mixin make-col($size, $columns: $grid-columns) {\n    flex: 0 0 percentage($size / $columns);\n    // Add a `max-width` to ensure content within each column does not blow out\n    // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n    // do not appear to require this.\n    max-width: percentage($size / $columns);\n}\n\n\n@media only screen and (min-width: 1200px) and (max-width: 1600px) {\n    @for $i from 1 through $grid-columns {\n        .col-xxl-#{$i} {\n            flex: 0 0 percentage($i / $grid-columns);\n            max-width: percentage($i / $grid-columns);\n        }\n    }\n\t.mb-xxl-4{\n\t\tmargin-bottom: 1.5rem !important;\n\t}\n    \n}\n\n\n\n","\n#preloader{\n\tdisplay: flex;\n     align-items: center;\n    justify-content: center;\n    height: 100vh;\n    position: fixed;\n    width: 100%;\n     z-index: 999999;\n \t//background-color: #e6ebee;\n\t\n\t\n\t.dot {\n\t  background: var(--primary);\n\t  border-radius: 50%;\n\t  display: inline-block;\n\t  margin-right: 20px;\n\t  width: 25px;\n\t  height: 25px;\n}\n\n.dot:first-child {\n  animation: FirstDot 3s infinite;\n}\n\n.dot:nth-child(2) {\n  animation: SecondDot 3s infinite;\n}\n\n.dot:nth-child(3) {\n  animation: ThirdDot 3s infinite;\n}\n\n.dot:nth-child(4) {\n  animation: FourthDot 3s infinite;\n}\n\n.dot:nth-child(5) {\n  animation: FifthDot 3s infinite;\n}\n\n@keyframes FirstDot {\n  0% {\n    transform: scale(1) translateX(0);\n  }\n  25% {\n    transform: scale(2.5) translateX(0);\n  }\n  50% {\n    transform: scale(1) translateX(0);\n  }\n  83% {\n    transform: scale(1) translateX(240px);\n  }\n  100% {\n    transform: scale(1) translateX(0);\n  }\n}\n\n@keyframes SecondDot {\n  0% {\n    transform: translateX(0px);\n  }\n  27% {\n    transform: translateX(-40px);\n  }\n  50% {\n    transform: translateX(0px);\n  }\n  81% {\n    transform: translateX(180px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n@keyframes ThirdDot {\n  0% {\n    transform: translateX(0px);\n  }\n  29% {\n    transform: translateX(-100px);\n  }\n  50% {\n    transform: translateX(0px);\n  }\n  79% {\n    transform: translateX(120px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n@keyframes FourthDot {\n  0% {\n    transform: translateX(0px);\n  }\n  31% {\n    transform: translateX(-160px);\n  }\n  50% {\n    transform: translateX(0px);\n  }\n  77% {\n    transform: translateX(60px);\n  }\n  100% {\n    transform: translateX(0);\n  }\n}\n\n@keyframes FifthDot {\n  0% {\n    transform: scale(1) translateX(0);\n  }\n  33% {\n    transform: scale(1) translateX(-220px);\n  }\n  50% {\n    transform: scale(1) translateX(0);\n  }\n  75% {\n    transform: scale(2.5) translateX(0);\n  }\n  100% {\n    transform: scale(1) translateX(0);\n  }\n}\n\n\t\n}",".footer {\n    padding: 0.3875rem 0;\n    font-size: 0.875rem;\n    background-color:$bg-color;\n    border-top-left-radius: $radius;\n    border-top-right-radius: $radius;\n    margin-top: 1rem;\n    .copyright {\n        padding: 0.5375rem;\n        margin: 0;\n       \n        p {\n            text-align: center;\n            margin: 0;\n\t\t\t\n        }\n\n        a{\n            color: var(--primary);\n        }\n    }\n\t&.footer-outer{\n\t\twidth: calc(100% - 43.225rem);\n\t\tmargin-right: 23.875rem;\n\t\tmargin-left: auto;\n\t\t\n        @include respond ('laptop'){\n            width: calc(100% - 20.525rem);\n            margin-right: 1.575rem;\n        }\n        @include respond ('tab-port'){\n            width: calc(100% - 9.625rem);\n            margin-right: 1.575rem;\n            padding-left: 0.8rem!important;\n        }\n        @include respond ('phone-land'){\n\n            width:calc(100% - 2.825rem)!important;\n        }\n        @include respond ('phone'){\n            width:calc(100% - 2.025rem)!important;\n            margin-right:0.875rem;\n        }\n\n        \n\t}\n    &.style-1{\n        width: calc(100% - 39.125rem);\n        margin-right: 19.975rem;\n\t   \n\t   @include respond ('tab-port'){\n\t\twidth:calc(100% - 9.625rem);\n\t\tmargin-right:1.475rem;\n\t   }\n\t   @include respond ('phone-land'){\n\t\twidth:calc(100% - 2.725rem)!important;\n\t\tmargin-right:1.475rem!important;\n\t\t\n\t   }\n\n    }\n    &.style-2{\n\n        width:calc(100% - 21.325rem);\n\t   \n\t   @include respond ('tab-port'){\n\t\twidth:calc(100% - 9.925rem);\n\t   }\n\t   @include respond ('phone-land'){\n\t\twidth:calc(100% - 2.325rem)!important;\n\t\tmargin-right:\t0.975rem;\n\t   }\n\t   @include respond ('phone'){\n\t\twidth:calc(100% - 1.825rem)!important;\n\t   }\n    }\n}\n\n\n","[data-sidebar-style=\"mini\"],\n[data-layout=\"horizontal\"] {\n    .nav-control {\n        display: none;\n    }\n}\n\n[data-sidebar-style=\"overlay\"] {\n    @include respond('phone-land') {\n        .nav-header .logo-abbr {\n            display: block;\n        }\n    }\n}\n\n[data-header-position=\"fixed\"] {\n    .nav-header {\n        position: fixed;\n    }\n}\n\n.nav-header {\n\theight: 5rem;\n    width:var(--width);\n    display: inline-block;\n\tbackground-color: var(--nav-headbg);\n    text-align: left;\n    position: absolute;\n    top:0;\n    // background-color: #D5DFE7;\n    transition: all .2s ease;\n    z-index: 5;\n\t\n    .logo-abbr {\n        max-width: 2.9375rem;\n\t\t@include respond('laptop') {\n\t\t\tmax-width: 2.8125rem;\n\t\t}\n\t\t@include respond('phone') {\n\t\t\twidth:4.1875rem;\n\t\t\theight:4.1875rem;\n\t\t}\n    }\n    .logo-compact {\n        display: none;\n    }\n\t\n\t@include respond ('laptop'){\n\t\theight:6.5rem;\n        width: 17rem;\n\t}\n    .brand-logo {\n        display: flex;\n        height: 100%;\n        width: 100%;\n        justify-content: flex-start;\n        align-items: center;\n        font-size: 1.125rem;\n        color: $white;\n        text-decoration: none;\n        padding-left: 1.675rem;\n\t\tpadding-right: 1.675rem;\n        font-weight: 700;\n\t\t\n\t\t@include respond('laptop') {\n\t\t\tpadding-left: 1.25rem;\n\t\t\tpadding-right:1.25rem;\n\t\t}\n\t\t\n        [data-sidebar-style=\"compact\"] &,\n        [data-sidebar-style=\"mini\"] & {\n            padding-left: 0;\n            padding-right: 0;\n            justify-content: center;\n        }\n        @include respond('phone-land') {\n            padding-left: 0;\n            padding-right: 0;\n            justify-content: center;\n        }\n    }\n    .brand-title {\n\t\tmargin-left: 0.9375rem;\n\t\tmax-width: 8.75rem;\n\t\tcolor: $black;\n        svg{\n\n            path{\n\n                fill:var(--primary      );  \n            }\n        }\n        @at-root [data-theme-version=\"dark\"] & {\n            background-position: 0 120%;\n        }\n\t\th2{\n\t\t\tline-height:0;\n\t\t\tfont-weight:bold;\n\t\t\tfont-size:1.75rem;\n\t\t\tmargin-bottom: 12px;\n\t\t}\n\t\t.brand-sub-title{\n\t\t\tfont-size:0.875rem;\t\n\t\t\tfont-weight:400;\n\t\t\twhite-space:nowrap;\n\t\t\tfont-family: Nunito;\n\t\t\t\n\t\t}\n    }\n\t@include respond ('phone-land'){\n\t\ttop:0px;\n\t\tbackground:transparent;\n\t}\n\t@include respond ('phone'){\n\t\ttop:0px;\n\t}\n\t\n\t.rect-primary-rect{\n\t\tfill:var(--primary);\n\t}\n}\n\n@include respond('tab-land') {\n\t.nav-header {\n\t\theight:5rem;\n    }\n}\n@include custommq($max:63.9375rem) {\n    .nav-header {\n        width: 5rem;\n        .brand-title {\n            display: none;\n        }\n    }\n}\n\n.nav-control {\n    cursor: pointer;\n    position: absolute;\n    right: -4rem;\n    text-align: center;\n    top: 46%;\n    transform: translateY(-43%);\n    z-index: 9999;\n    font-size: 1.4rem;\n\tbackground: transparent;\n\theight: 2.5rem;\n\twidth: 2.5rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n    border-radius: $radius;\n    @include respond('laptop') {\n\t\tright: -4.1rem;\n\t\t top: 40%;\n\t}\n\t@include respond('tab-land') {\n\t\ttop: 45%;\n\t}\n    @include respond('phone-land') {\n        right: -3rem;\n\t\ttop: 43%;\n\t\theight: 43px;\n\t\twidth: 43px;\n    }\n\t@include respond('phone') {\n        top: 43%;\n\t\theight: 39px;\n\t\twidth: 39px;\n        right: -1.875rem;\n    }\n}\n\n////////////////////\n// Humbuger Icon\n////////////////////\n.hamburger {\n    display: inline-block;\n    left: 0.2rem;\n    position: relative;\n    -webkit-transition: all 0.3s ease-in-out 0s;\n    transition: all 0.3s ease-in-out 0s;\n    width: 1.625rem;\n    z-index: 999;\n    svg{\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 1;\n    }\n}\n\n.hamburger .line {\n    background: $main-color;\n    display: block;\n    height: 0.188rem;\n    border-radius: 0.1875rem;\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n    margin-right: auto;\n    -webkit-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n    opacity: 0;\n}\n.hamburger.is-active {\n\tleft: -0.9rem;\n    svg{\n        display: none;\n    }\n    line{\n        opacity: 1;\n    }\n}\n.hamburger .line:nth-child(1) {\n    width: 1.375rem;\n}\n\n.hamburger .line:nth-child(2) {\n    width: 1.375rem;\n}\n\n.hamburger .line:nth-child(3) {\n    width: 0.875rem;\n}\n\n.hamburger:hover {\n    cursor: pointer;\n}\n\n.hamburger:hover .line {\n    width: 1.625rem;\n}\n\n\n.hamburger.is-active .line:nth-child(1),\n.hamburger.is-active .line:nth-child(3) {\n    width: 0.625rem;\n    height: 0.125rem;\n}\n\n.hamburger.is-active .line:nth-child(2) {\n    -webkit-transform: translateX(0px);\n    transform: translateX(0px);\n    width: 1.375rem;\n    height: 0.125rem;\n}\n\n.hamburger.is-active .line:nth-child(1) {\n    -webkit-transform: translateY(2px) translateX(12px) rotate(45deg);\n    transform: translateY(2px) translateX(12px) rotate(45deg);\n}\n\n.hamburger.is-active .line:nth-child(3) {\n    -webkit-transform: translateY(-2px) translateX(12px) rotate(-45deg);\n    transform: translateY(-2px) translateX(12px) rotate(-45deg);\n}\n\n\n@media (min-width:47.9375rem) {\n    [data-sidebar-style=\"compact\"] {\n        .nav-control {\n            display: none;\n        }\n        .nav-header {\n            width: 11.25rem;\n        }\n    }\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] {\n    .menu-toggle {\n        .brand-title {\n            display: none;\n        }\n        .nav-header {\n            .logo-abbr {\n                display: block;\n            }\n        }\n    }\n}\n\n[data-sidebar-style=\"full\"][data-layout=\"horizontal\"] {\n    .logo-compact {\n        display: none;\n    }\n}\n\n[data-sidebar-style=\"mini\"] {\n    .nav-header {\n\t\theight: 5.3rem;\n        .logo-abbr {\n            display: block;\n        }\n\t\t@include custommq($max: 100rem){\n\t\t\theight: 6.1rem;\n\t\t}\n\t\t@include custommq($max: 64rem){\n\t\t\theight: 5.5rem;\n\t\t}\n    }\n}\n\n[data-sidebar-style=\"compact\"][data-layout=\"vertical\"] {\n    .nav-header {\n        .brand-title {\n            display: none;\n        }\n        .logo-compact {\n            max-width: 4.6875rem;\n        }\n    }\n}\n[data-sidebar-style=\"compact\"][data-layout=\"horizontal\"] {\n    .nav-header .brand-logo {\n        padding-left: 1.875rem;\n\t\tpadding-right: 1.875rem;\n\t\tjustify-content: start;\n    }\n}\n[data-sidebar-style=\"modern\"][data-layout=\"vertical\"] {\n    .nav-header {\n        width: 10.625rem;\n        .brand-title {\n            display: none;\n        }\n        .logo-compact {\n            display: none;\n        }\n    }\n}\n","/////////////////\n// Header\n/////////////////\n.header {\n    z-index: 1;\n    position: relative;\n    padding: 0rem;\n    background: var(--headerbg);\n    z-index: 3;\n    padding-left: 17rem;\n    transition: all .2s ease;\n\tbackground-position: center;\n    background-size: cover;\n    \n    box-sizing: border-box;\n\t.is-fixed{\n\t\tbackground:#3736af;\n\t}\n\t\n    .header-content {\n\t\theight: 5rem;\n\t\tpadding-left: 5.5rem;\n\t\tpadding-right: 0rem;\n\t\talign-items: center;\n\t\tdisplay: flex;\n\t\tleft: 16.2rem;\n\t\tposition: unset;\n\t\ttop: 0;\n\t\twidth: calc(100% - var(--width));\n\t\tmargin-left:var(--width);\n      \n        border-top: none;\n        padding-right: 2rem;\n\t\t\n        @include respond ('laptop') {\n\t\t\tpadding-left: 5rem;\n            width: calc(100% - 0rem);\n            margin-left: 0rem;\n            height: 100%;\n\t\t}\n\t\t@include custommq ($max:64rem){\n\t\t\tleft: 6.3rem; \n\t\t\twidth: calc(100% - 0rem);\n\t\t\theight: 5rem;\n\t\t}\n        @include custommq($max: 47.9375rem) {\n            padding-left: 3.75rem;\n\t\t\tpadding-right: 0.938rem;\n        }\n\t\t @include respond ('phone-land') {\n\t\t\tleft: 0rem;\n\t\t\twidth: calc(100% - 0.3rem);\n\t\t }\n\t\t\n    }\n    .navbar {\n        padding: 0;\n        height: 100%;\n        width: 100%;\n        .navbar-collapse {\n            height: 100%;\n            width: 100%;\n        }\n    }\n\t\n}\n\n////////////////////////\n// CSS Pulse Effect\n////////////////////////\n@mixin circle($circleSize) {\n    width: $circleSize;\n    height: $circleSize;\n    border-radius: $circleSize/2;\n}\n@for $i from 2 through 15{\n\t[data-headerbg=\"color_#{$i}\"] .header{\n\t\t// background:var(--headerbg);\n\t\t\n\t}\n}\n@for $i from 2 through 15{\n\t[data-headerbg=\"color_#{$i}\"] .header.is-fixed{\n\t\tbackground:var(--headerbg);\n\t\t\n\t}\n}\n@for $i from 2 through 15{\n\t[data-nav-headbg=\"color_#{$i}\"] .nav-header{\n\t\tbackground:var(--nav-headbg);\n\t\t\n\t}\n}\n\n\n/* pulse in SVG */\n\nsvg.pulse-svg {\n    overflow: visible;\n    .first-circle {\n        -webkit-transform: scale(0.3);\n        transform: scale(0.3);\n        -webkit-transform-origin: center center;\n        transform-origin: center center;\n        -webkit-animation: pulse-me 3s linear infinite;\n        animation: pulse-me 3s linear infinite;\n        fill: var(--primary);\n    }\n    .second-circle {\n        @extend .first-circle;\n        -webkit-animation-delay: 1s;\n        animation-delay: 1s;\n    }\n    .third-circle {\n        @extend .first-circle;\n        -webkit-animation-delay: 2s;\n        animation-delay: 2s;\n    }\n}\n\n\n/* pulse in CSS */\n\n.pulse-css {\n    @include circle(1rem);\n    border-radius: 3.5rem;\n    height: 1.25rem;\n    position: absolute;\n    background: #fe8630;\n    right: 0.375rem;\n    top: 0.3125rem;\n\tborder:0.25rem solid $white;\n    width: 1.25rem;\n    &:after,\n    &:before {\n        content: '';\n        @include circle(1rem);\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: -.2rem;\n        background-color: #D8B9C3;\n        margin: auto;\n        -webkit-transform: scale(0.3);\n        transform: scale(0.3);\n        -webkit-transform-origin: center center;\n        transform-origin: center center;\n        -webkit-animation: pulse-me 3s linear infinite;\n        animation: pulse-me 3s linear infinite;\n        @at-root [direction=\"rtl\"] & {\n            left: auto;\n            right: -.2rem;\n        }\n    }\n\t@include respond ('laptop'){\n\t\theight:1rem;\n\t\twidth:1rem;\n\t}\n}\n\n@-webkit-keyframes pulse-me {\n    0% {\n        -webkit-transform: scale(0.3);\n        transform: scale(0.3);\n        opacity: 0;\n    }\n    50% {\n        opacity: 0.1;\n    }\n    70% {\n        opacity: 0.09;\n    }\n    100% {\n        -webkit-transform: scale(3);\n        transform: scale(3);\n        opacity: 0;\n    }\n}\n\n@keyframes pulse-me {\n    0% {\n        -webkit-transform: scale(0.3);\n        transform: scale(0.3);\n        opacity: 0;\n    }\n    50% {\n        opacity: 0.1;\n    }\n    70% {\n        opacity: 0.09;\n    }\n    100% {\n        -webkit-transform: scale(3);\n        transform: scale(3);\n        opacity: 0;\n    }\n}\n\n[data-sidebar-style=\"full\"],\n[data-sidebar-style=\"overlay\"] {\n\n    .header {\n        width: 100%;\n\t\tpadding-left:0;\n        @include respond ('laptop') {\n            width: 100%;\n            padding-left: 17rem;\n        }\n        @include custommq($max: 63.9375rem) {\n            width: 100%;\n            padding-left: 0rem;\n        }\n\t\t/* .page-titles{\n\t\t\tpadding-left: 20.3rem;\n\t\t} */\n    }\n}\n\n[data-sidebar-style=\"mini\"] {\n    .header {\n        width: 100%;\n\t\theight:5rem;\n\t\tpadding-left: 6.32rem;\n\t\t@include custommq($max: 63.9375rem){\n\t\t\tpadding-left: 6rem;\n\t\t}\n    }\n}\n\n[data-sidebar-style=\"compact\"] {\n    .header {\n        width: 100%;\n        padding-left: 1.75rem;\n\t\t.header-content{\n\t\t\tpadding-left: 2.5rem;\n\t\t\tleft: 1.75rem;\n\t\t\twidth: auto;\n\t\t\tmargin-left: 9.2rem;\n\t\t\t//width: calc(100% - 11.1rem);\n\t\t}\n    }\n}\n\n[data-header-position=\"fixed\"] {\n    .header {\n        position: fixed;\n        top: 0;\n        width: 100%;\n    }\n    .content-body {\n\t\tpadding-top:5rem;\n    }\n    .dlabnav {\n        margin-top: 0;\n    }\n}\n[data-sidebar-style=\"compact\"][data-header-position=\"fixed\"][data-container=\"boxed\"][data-layout=\"vertical\"] {\n    .header {\n        width: 74.9375rem;\n    }\n}\n[data-sidebar-style=\"modern\"] {\n    .header {\n\t\twidth: 100%;\n\t\tpadding-left: 0rem;\n    \n\n    }\n\t&[data-layout=\"horizontal\"] {\n\t\t.nav-header .brand-logo{\n\t\t    justify-content: start;\n\t\t}\n\t\t.header .header-content{\n            padding-left: 1.875rem;\n\t\t\t\n        }\n\t}\n}\n\n// --------sticky-navbar-------\n.header.is-fixed {\n    position: fixed;\n    background: $body-bg;\n\t@include transitionMedium;\n\t/*     -webkit-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;\n    -khtml-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;\n    -moz-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;\n    -ms-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;\n    -o-animation: 0.95s ease 0s normal forwards 1 running headerSlideDown;\n    animation: 0.95s ease 0s normal forwards 1 running headerSlideDown; */\n\t\n}\n@-moz-keyframes headerSlideDown {\n  0% {\n    margin-top: -150px; }\n  100% {\n    margin-top: 0; } }\n\n@-ms-keyframes headerSlideDown {\n  0% {\n    margin-top: -150px; }\n  100% {\n    margin-top: 0; } }\n\n@-webkit-keyframes headerSlideDown {\n  0% {\n    margin-top: -150px; }\n  100% {\n    margin-top: 0; } }\n\n@keyframes headerSlideDown {\n  0% {\n    margin-top: -150px; }\n  100% {\n    margin-top: 0; } }\n\n.sidebar-info{\n    h4{\n        font-size: 0.875rem;\n        font-weight: 700;\n        white-space: nowrap;\n    }\n}",".header-left {\n    height: 100%;\n    display: flex;\n    align-items: center;\n\t.search-area{\n\t\twidth: 25rem;\n\t\tflex-direction: row-reverse;\n\t\tborder: 1px solid $b-color;\n\t\toverflow: hidden;\n\t\tborder-radius:$radius;\n\t\tbox-sizing: border-box;\n   \t\theight: 3rem;\n\t\t@include custommq($max:117.5rem){\n\t\t\twidth: 22rem;\n\t\t}\n\t\t@include custommq($max:81.25rem){\n\t\t\twidth: 17.5rem;\n\t\t}\n\t\t@include respond ('tab-land'){\n\t\t\twidth:\t15.625rem;\n\t\t}\n\t\t@include custommq ($max:68.75rem){\n\t\t\tdisplay:none;\n\t\t}\n\t\t.form-control{\n\t\t\tfont-size:15px;\n\t\t\tborder-right:0;\n\t\t\tborder: none;\n\t\t\tpadding: 0rem;\n\t\t\tborder-radius:0 $radius $radius 0; \n\t\t\tpadding-left: 0.2rem;\n\t\t\theight: 3rem;\n\t\t\t&:focus{\n\t\t\t\tborder-color:white;\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\t\t}\n\t\t.input-group-text{\n\t\t\tbackground:$white !important;\n\t\t\tborder: none;\n\t\t\tpadding-right: 0;\n\t\t\theight: 3rem;\n\t\t\tborder-radius:$radius 0 0 $radius; \n\t\t\tsvg{\n\t\t\t\ttransform: scale(1.2);\n\t\t\t\tpath{\n\t\t\t\t\tfill:var(--primary);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t}\n\t\n\t.breadcrumb{\n\t\tmargin-bottom:0;\n\t}\n\t.agenda{\n\t\ta{\n\t\t\tborder-radius:1.75rem;\n\t\t\ti{\n\t\t\t\tmargin-right:0.75rem;\n\t\t\t\t@include respond ('laptop'){\n\t\t\t\t\tmargin-right:0rem;\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t@include custommq ($max:93.75rem){\n\t\t\t\tfont-size:0;\n\t\t\t\tborder-radius: 0.75rem;\n\t\t\t\tpadding: 0.8125rem 0.9375rem;\n\t\t\t\ti{\n\t\t\t\t\tfont-size:1.25rem;\n\t\t\t\t\tmargin-right:0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t@include respond('phone') {\n\t\t\tdisplay:none;\t\n\t\t}\n\t}\n\t.dashboard_bar {\n\t\tfont-size: 1.563rem;\n\t\tfont-weight: 600;\n\t\tcolor:$headings-color;\n\t\t\n\t\t@include respond('phone-land') {\n\t\t\tdisplay:none;\n\t\t}\n\t\t&.sub-bar{\n\t\t\tfont-size:1.875rem;\n\t\t}\n\t}\n\t\n}\n\n[data-sidebar-style=\"compact\"] {\n    .header-left {\n        margin-left: 0;\n    }\n}\n\n.nav-item.notification_dropdown{\n\ta.nav-link{\n\t\tposition: relative;\n\t\t/* &::before{\n\t\t\tcontent: '';\n\t\t\tdisplay: block;\n\t\t\tbackground-color: $pink;\n\t\t\twidth: 0.5rem;\n\t\t\theight: 0.5rem;\n\t\t\tborder-radius: 50%;\n\t\t\tposition: absolute;\n\t\t\ttop: -2px;\n\t\t\tright: 0;\n\t\t\t\n\t\t}\n\t\t */\n\t}\n\t.nav-link.menu-wallet{\n\t\t&::before{\n\t\t\tcontent: '';\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n.modal{\n\t.modal-content{\n\t\tinput.form-control{\n\t\t\tborder-top-right-radius: $radius !important;\n\t\t\tborder-bottom-right-radius: $radius !important;\n\t\t}\n\t}\n}",".header-right {\n    height: 100%;\n\talign-items: center;\n\t\n\t\n    .nav-item {\n        height: 100%;\n        display: flex;\n        align-items: center;\n        .nav-link {\n            color: $l-ctd;\n           \n        }\n    }\n\t.right-sidebar{\n\t\tmargin-right:-1.875rem;\n\t\ta{\n\t\t\theight: 5rem;\n\t\t\twidth: 5rem;\n\t\t\ttext-align: center;\n\t\t\tjustify-content: center;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tborder-left: 0.0625rem solid $light;\n\t\t}\n\t}\n    &>li {\n        &:not(:first-child) {\n\t\t\t@include respond('tab-land') {\n\t\t\t\tpadding-left:0rem;\n\t\t\t}\n\t\t\t@include respond('phone-land') {\n\t\t\t\tpadding-left:0;\n\t\t\t}\n        }\n    }\n    .notification_dropdown {\n        @include respond('phone-land') {\n            position: static;\n        }\n        .nav-link {\n            position: relative;\n            color: var(--primary);\n\t\t\tborder-radius: $radius;\n\t\t\tbackground-color: $bg-color;\n\t\t\twidth:3rem;\n\t\t\tmin-width:3rem;\n\t\t\theight: 3rem;\n\t\t\tline-height: 1;\n\t\t\tmargin-right: 1.125rem;\n\t\t\t// border: 1px solid $b-color;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\t@include custommq($max:112rem){\n\t\t\t\tmargin-right: 0.625rem;\n\t\t\t}\n\t\t\t @include respond('laptop') {\n\t\t\t\tpadding:0.625rem;\n\t\t\t\tmargin-right: 0.625rem;\n\t\t\t }\n\t\t\t  @include respond('phone') {\n\t\t\t\tpadding: 0.325rem;\n\t\t\t\tmargin-right: 0.5rem!important;\n\t\t\t\twidth:2.3rem;\n\t\t\t\theight:2.3rem;\t\n\t\t\t\tmin-width:2.3rem;\n\t\t\t  }\n\t\t\t\n            i {\n                font-size: 1.5rem;\n\t\t\t\tcolor: #666666;\n\t\t\t\t@include respond('laptop') {\n\t\t\t\t\tfont-size: 1.125rem;\n\t\t\t\t}\n\t\t\t\t\n            }\n\t\t\tsvg{\n\t\t\t\t\n\t\t\t\t@include respond('laptop') {\n\t\t\t\t\twidth:1.75rem;\n\t\t\t\t\theight:1.75rem;\n\t\t\t\t}\n\t\t\t\t@include respond('phone') {\n\t\t\t\t\twidth: 1.3rem;\n\t\t\t\t\theight: 1.3rem;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.bell-link{\n\t\t\t\tsvg{\n\t\t\t\t\tpath{\n\t\t\t\t\t\tstroke:#A098AE;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t }\n\t\t\t &.dz-fullscreen{\n\t\t\t\tsvg{\n\t\t\t\t\tpath{\n\t\t\t\t\t\tstroke:#A098AE;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t }\n\t\t\t &.dz-theme-mode{\n\t\t\t\tsvg{\n\t\t\t\t\tpath{\n\t\t\t\t\t\tstroke:#A098AE;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t }\n\t\t\t #icon-light,\n\t\t\t #icon-dark,\n\t\t\t #icon-light-1,\n\t\t\t #icon-dark-1{\n\t\t\t\tcolor:#A098AE;\n\t\t\t }\n\t\t\t \n\t\t\t  &.menu-wallet{\n\t\t\t\tsvg{\n\t\t\t\t\tpath{\n\t\t\t\t\t\tfill:#A098AE;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t  }\n            .badge {\n                position: absolute;\n                font-size: 0.625rem;\n                border-radius: 50%;\n                right: 5px;\n\t\t\t\ttop: 0px;\n\t\t\t\tfont-weight: normal;\n\t\t\t\theight: 25px;\n\t\t\t\twidth: 25px;\n\t\t\t\tline-height: 16px;\n\t\t\t\ttext-align: center;\n\t\t\t\tpadding: 4px;\n\t\t\t\tfont-size: 11px;\n\t\t\t\t\t\n\t\t\t\t@include respond('laptop') {\n\t\t\t\t\theight: 1.25rem;\n\t\t\t\t\twidth: 1.25rem;\n\t\t\t\t\tborder-width: 0.125rem;\n\t\t\t\t\tline-height: 0.4375rem;\n\t\t\t\t\tfont-size: 0.5625rem;\n\t\t\t\t}\n\t\t\t\t@include respond('phone') {\n\t\t\t\t\theight: 1.125rem;\n\t\t\t\t\twidth:1.125rem;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tline-height: 0.9375rem;\n\t\t\t\t\tright: 0rem;\n\t\t\t\t\ttop: -0.125rem;\n\t\t\t\t}\n            }\n\t\t\t\n        }\n        .dropdown-item {\n            &:focus,\n            &:active {\n                a {\n                    color: $white;\n                }\n            }\n            a {\n                color: $dark;\n                &:hover {\n                    text-decoration: none;\n                }\n            }\n        }\n    }\n    .dropdown-menu {\n        border-width:0;\n        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n\t\tmargin: 0;\n\t\twidth: 14.188rem;\n\t\tmargin: 0;\n\t\tborder-radius: 0px 0px 5px 5px;\n\t\tmargin-top:-8px;\n\t\t\n\t@include respond ('phone'){\n\t\twidth:11.875rem;\n\t\th4{\n\t\t\tfont-size:14px;\n\t\t\t\n\t\t}\n\t\tspan{\n\t\t\tfont-size:11px;\n\t\t}\n\t}\n\t\n\n        @at-root [data-theme-version=\"dark\"] & {\n            box-shadow: none;\n        }\n\t\t&.dropdown-menu-end {\n\t\t\t.card-footer{\n\n\t\t\t\t\n\t\t\t\tborder-radius:0;\n\t\t\t}\n\t\t\t.dropdown-item{\n\t\t\t\t&:hover{\n\t\t\t\t\tborder-radius:$radius-sm;\n\t\t\t\t}\n\t\t\t\t\n\n\t\t\t}\n\t\t\t.light.btn-primary:hover{\n\t\t\t\tspan{\n\n\t\t\t\t\tcolor:$white!important;\n\t\t\t\t}\n\t\t\t\tsvg{\n\t\t\t\t\tstroke:$white;\n\t\t\t\t}\n\n\t\t\t}\n\n\t\t}\n    }\n\t//.search-area\n\t.search-area{\n\t\twidth: 21.875rem;\n\t\tflex-direction: row-reverse;\n\t\toverflow: hidden;\n\t\tborder-radius:$radius;\n\t\tbox-sizing: border-box;\n   \t\theight: 3rem;\n\t\tborder:1px solid $border-color!important;\n\t\t@include custommq($max:117.5rem){\n\t\t\twidth: 22rem;\n\t\t}\n\t\t@include custommq($max:81.25rem){\n\t\t\twidth: 17.5rem;\n\t\t}\n\t\t@include respond ('tab-land'){\n\t\t\twidth:\t15.625rem;\n\t\t}\n\t\t\n\t\t.form-control{\n\t\t\tfont-size:15px;\n\t\t\tborder-right:0;\n\t\t\tborder: none;\n\t\t\tpadding: 0rem;\n\t\t\tborder-radius:0 $radius $radius 0; \n\t\t\tpadding-left: 0.2rem;\n\t\t\theight: 3rem;\n\t\t\t&:focus{\n\t\t\t\tborder-color:white;\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\t\t}\n\t\t.input-group-text{\n\t\t\tbackground:$white;\n\t\t\tborder: none;\n\t\t\tpadding-right: 20px;\n\t\t\theight: 3rem;\n\t\t\tborder-radius:$radius 0 0 $radius; \n\t\t\tsvg{\n\t\t\t\ttransform: scale(1.2);\n\t\t\t\tpath{\n\t\t\t\t\tfill:var(--primary);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t}\n\t//search-area\n\t//.search-area{\n\t//\twidth: 19.75rem;\n\t//\tborder-radius:0.5rem;\n\t//\t.form-control{\n\t//\t\theight: 3rem;\n\t//\t\tborder-right:0;\n\t//\t\tborder-color: #EEEEEE;\n\t//\t\t&:hover,\n\t//\t\t&:focus{\n\t//\t\t\tborder-color:#EEEEEE;\t\n\t//\t\t}\n\t//\t}\t\n\t//\t.input-group-text{\n\t//\t\theight        : 3rem;\n\t//\t\tborder-radius : 0.5rem;\n\t//\t\tbackground    : transparent;\n\t//\t\tpadding       :  0 1.25rem;\n\t//\t\tborder-color: #EEEEEE;\n\t//\t\ti{\n\t//\t\t\tfont-size : 1.5rem;\n\t//\t\t}\n\t//\t}\n\t//\t@include custommq ($max:100rem){\n\t//\t\twidth: 15.625rem;\n\t//\t}\n\t//\t@include respond ('tab-land'){\n\t//\t\tdisplay:none;\n\t//\t}\n\t//}\n\t//.invoices-btn{\n\t//\t@include respond ('phone'){\n\t//\t\tdisplay:none;\t\n\t//\t}\t\n\t//} \n}\n.dlab-fullscreen{\n\t#icon-minimize{\n\t\tdisplay:none;\n\t}\n\t&.active{\n\t\t#icon-full{\n\t\t\tdisplay:none;\n\t\t}\n\t\t#icon-minimize{\n\t\t\tdisplay:inline-block;\n\t\t}\n\t}\n}\n.dlab-fullscreen{\n\t#icon-minimize{\n\t\tdisplay:none;\n\t}\n\t&.active{\n\t\t#icon-full-1{\n\t\t\tdisplay:none;\n\t\t}\n\t\t#icon-minimize-1{\n\t\t\tdisplay:inline-block;\n\t\t}\n\t}\n}\n/* .notification_dropdown {\n    .dropdown-menu-end {\n        min-width: 19.375rem;\n        padding: 1rem 0 1rem;\n        top: 100%;\n\t\t\n        .notification_title {\n            background: var(--primary);\n            color: $white;\n            padding: 0.625rem 1.25rem;\n            h5 {\n                color: $white;\n                margin-bottom: 0.1875rem;\n            }\n        }\n        .media {\n\t\t\twidth: 2.8125rem ;\n\t\t\theight: 2.8125rem ;\n\t\t\tfont-size: 1.125rem ;\n\t\t\t\n            // &:last-child{\n            //     border-bottom: 0rem;\n            // }\n            @at-root [data-theme-version=\"dark\"] & {\n                border-color: $d-border;\n            }\n            &>span {\n                width: 2.1875rem;\n                height: 2.1875rem;\n                border-radius: 3.125rem;\n                display: inline-block;\n                padding: 0.4375rem 0.5625rem;\n                margin-right: 0.625rem;\n\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t margin-right: 0;\n\t\t\t\t\t margin-left: 0.625rem\n\t\t\t\t}\n                &.success {\n                    background: $success-light;\n                    color: $success;\n                }\n                &.primary {\n                    background: var(--rgba-primary-1);\n                    color: var(--primary);\n                }\n                &.danger {\n                    background: $danger-light;\n                    color: $danger;\n                }\n            }\n            .notify-time {\n                width: 100%;\n                margin-right: 0;\n                color: $l-ctl;\n            }\n            p {\n                text-overflow: ellipsis;\n                overflow: hidden;\n                white-space: nowrap;\n                max-width: 12.5rem;\n                margin-bottom: 0;\n                margin-top: 0.3125rem;\n\t\t\t\t@include respond('phone') {\n\t\t\t\t    max-width: 6.25rem;\n\t\t\t\t}\n            }\n        }\n        .all-notification {\n            display: block;\n            padding: 0.9375rem 1.875rem 0;\n    }\n\t            // color: $dark;\n            text-align: center;\n\t\t\tborder-top: 0.0625rem solid $b-color;\n\t\t\t\t\n            i {\n                margin-left: 0.625rem;\n            }\n        }\n\n} */\n\n.style-1{\n\n}\n.notification_dropdown {\n    .dropdown-menu-end {\n\t\t    min-width: 19.375rem;\n\t\t\tpadding: 1rem 0 1rem;\n\t\t\ttop: 100%;\n\t\t&.show{\n\t\t\t    right: 0;\n\t\t\t\toverflow: unset !important;\n\t\t}\n\t\t\n        .notification_title {\n            background: var(--primary);\n            color: $white;\n            padding: 0.625rem 1.25rem;\n            h5 {\n                color: $white;\n                margin-bottom: 0.1875rem;\n            }\n        }\n        .media {\n\t\t\twidth: 2.8125rem ;\n\t\t\theight: 2.8125rem ;\n\t\t\tfont-size: 1.125rem ;\n\t\t\t\n            // &:last-child{\n            //     border-bottom: 0rem;\n            // }\n            @at-root [data-theme-version=\"dark\"] & {\n                border-color: $d-border;\n            }\n            &>span {\n                width: 2.1875rem;\n                height: 2.1875rem;\n                border-radius: 3.125rem;\n                display: inline-block;\n                padding: 0.4375rem 0.5625rem;\n                margin-right: 0.625rem;\n\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t margin-right: 0;\n\t\t\t\t\t margin-left: 0.625rem\n\t\t\t\t}\n                &.success {\n                    background: $success-light;\n                    color: $success;\n                }\n                &.primary {\n                    background: var(--rgba-primary-1);\n                    color: var(--primary);\n                }\n                &.danger {\n                    background: $danger-light;\n                    color: $danger;\n                }\n            }\n            .notify-time {\n                width: 100%;\n                margin-right: 0;\n                color: $l-ctl;\n            }\n            p {\n                text-overflow: ellipsis;\n                overflow: hidden;\n                white-space: nowrap;\n                max-width: 12.5rem;\n                margin-bottom: 0;\n                margin-top: 0.3125rem;\n\t\t\t\t@include respond('phone') {\n\t\t\t\t    max-width: 6.25rem;\n\t\t\t\t}\n            }\n        }\n        .all-notification {\n            display: block;\n            padding: 0.9375rem 1.875rem 0;\n\t\t\tcolor:var(--primary);\t\n            text-align: center;\n\t\t\tborder-top: 0.0625rem solid #f1f1f1;\n\t\t\tfont-size:0.813rem;\n\t\t\t\t\n            i {\n                margin-left: 0.625rem;\n            }\n        }\n\t\t@include respond ('phone-land'){\n\t\t\tright:0;\n\t\t\theight:27rem;\n\t\t\ttop:45px;\n\t\t\ttransform:translateX(0);\n\t\t\tpadding-right:0;\n\t\t\twidth: 18rem;\n\t\t\tdisplay:none!important;\n\t\t\tborder-radius: $radius;\n\t\t\t&.show{\n\t\t\t\tdisplay:block!important;\n\t\t\t}\n\t\t}\n\t\t@include respond ('phone'){\n\t\t\tmin-width: 18.5rem;\n\t\t\tright: -4rem;\n\t\t\ttop:62px;\n\t\t}\n    }\n\t.attc{\n\t\tdisplay: flex;\n\t\talign-items: flex-start;\n\t\tborder: 1px solid #f1f1f1;\n\t\tborder-radius: 0.375rem;\n\t\tpadding: 0.313rem 0.625rem;\n\t\t\n\t\t.media{\n\t\t\tborder-radius:6px;\n\t\t\tborder:1px solid #eee;\n\t\t}\n\t\t.media-body{\n\t\t\th6{\n\t\t\t\tfont-size: 0.813rem;\n\t\t\t\tline-height: 1rem;\n\t\t\t\tmargin-bottom:0;\n\t\t\t}\n\t\t\tspan{\n\t\t\t\tborder: 1px solid #E6E6E6;\n\t\t\t\tfont-size: 0.75rem;\n\t\t\t\t//border-radius: $radius-sm;\n\t\t\t}\n\t\t}\n\t}\n\t\n}\n\t.header-profile {\n        &>a.nav-link {\n\t\t\tpadding:0;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tmargin-left: 0.9375rem;\t\n            i {\n                font-weight: 700;\n            }\n\t\t\t.header-info{\n\t\t\t\tpadding-left: 0rem;\n\t\t\t\ttext-align: left;\n\t\t\t\t@include respond('laptop') {\n\t\t\t\t\tpadding-left: 0.625rem;\n\t\t\t\t}\n\t\t\t\t@include respond('phone') {\n\t\t\t\t\tdisplay:none;\n\t\t\t\t}\n\t\t\t\tspan{\n\t\t\t\t\tfont-size:1rem;\n\t\t\t\t\tcolor:$black;\n\t\t\t\t\tdisplay: block;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t}\n\t\t\t\tstrong{\n\t\t\t\t\tcolor:$dark;\n\t\t\t\t}\n\t\t\t\tsmall{\n\t\t\t\t\tdisplay:block;\n\t\t\t\t\tfont-size: 0.8125rem;\n\t\t\t\t\tcolor:$muted;\n\t\t\t\t\tfont-weight:400;\n\t\t\t\t\tline-height: 1.2;\n\t\t\t\t}\n\t\t\t}\n\t\t\t@include respond ('laptop'){\n\t\t\t\tmargin-left: 0rem;\n\t\t\t\tpadding-left:0rem;\n\t\t\t\t.header-info{\n\t\t\t\t\tspan{\n\t\t\t\t\t\tfont-size:1rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t@include respond ('phone'){\n\t\t\t\tmargin-left: 0rem;\n\t\t\t\tpadding-left:0rem;\n\t\t\t\tborder-left:0;\n\t\t\t}\n        }\n        .dropdown-menu {\n            padding: 0.9375rem 0;\n            min-width: 12.5rem;\n            a {\n                &:hover,\n                &:focus,\n                &.active {\n                    color: var(--primary);\n                }\n            }\n        }\n        img {\n            width: 3.5rem;\n            height: 3.5rem;\n            border-radius: $radius;\n\t\t\t@include respond('laptop') {\n\t\t\t\t width: 2.4375rem;\n\t\t\t\theight: 2.4375rem;\n\t\t\t}\n        }\n        .dropdown-toggle {\n            i {\n                font-size: 1.25rem;\n            }\n            span {\n                @include respond('phone') {\n                    display: none;\n                }\n            }\n        }\n        .profile_title {\n            background: $primary;\n            color: $white;\n            padding: 0.625rem 1.25rem;\n            h5 {\n                color: $white;\n                margin-bottom: 0.1875rem;\n            }\n        }\n        // .dropdown-toggle::after{\n        //     display: none;\n        // }\n        .dropdown-item {\n            padding: 0.5rem 1.5rem;\n        }\n    }\n\t.dropdown.header-profile2{\n\t\t.nav-link{\n\t\t\tmargin-left: 1rem;\n\t\t\tpadding-right: 0;\n\t\t\t@include respond('laptop') {\n\t\t\t\tmargin-left: 0rem;\n\n\t\t\t}\n\t\t\t@include respond('phone'){\n\n\t\t\t\tpadding-left: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\n@keyframes icon-bounce{\n\n\t100%, 0% {\n\t\ttransform: translateY(0);\n\t}\n\t50% {\n\t\ttransform: translateY(-5px);\n\t}\n\t80% {\n\t\ttransform: translateY(5px);\n\t}\n}\n.dz-theme-mode #icon-light {\n    display: none;\n}\n.dz-theme-mode.active #icon-light{\n\tdisplay:inline-block;\n}\n.dz-theme-mode.active #icon-dark{\n\tdisplay:none;\n}\n.dz-fullscreen #icon-minimize{\n\tdisplay:none;\n}\n.dz-fullscreen.active #icon-minimize {\n    display: inline-block;\n}\n.dz-fullscreen.active #icon-full{\n\t    display: none;\n\n\n}\n.dz-theme-mode #icon-light-1 {\n    display: none;\n}\n.dz-theme-mode.active #icon-light-1{\n\tdisplay:inline-block;\n}\n.dz-theme-mode.active #icon-dark-1{\n\tdisplay:none;\n}\n.dz-fullscreen #icon-minimize-1{\n\tdisplay:none;\n}\n.dz-fullscreen.active #icon-minimize-1{\n\n\tdisplay: inline-block;\n}\n.dz-fullscreen.active #icon-full-1{\n\n\tdisplay:none;\n}\n","//.header-profile2///////////////////////////\n// Nav Profile\n///////////////////////////\n\n:root{\n\t--width:17.5rem;\n\t[data-sidebar-style=\"mini\"]{\n\t\t--width:6.25rem;\n\t}\n}\n\n\n.nav-label {\n    margin: 0.625rem 1.875rem 0;\n    padding: 1.5625rem 0 0.625rem;\n    text-transform: uppercase;\n    font-size: 0.75rem;\n    letter-spacing: 0.05rem;\n    border-top: 0.0625rem solid $l-border;\n\tcolor:$dusty-gray;\n\t\n    @at-root [data-theme-version=\"dark\"] & {\n        border-color: $d-border;\n    }\n    &.first {\n        border: 0rem;\n        margin-top: 0rem;\n    }\n}\n.nav-badge {\n    position: absolute;\n    right: 2.8125rem;\n    top: 0.625rem;\n}\n.dlabnav .ps__rail-y{\n\tleft: 0;\n\twidth:5px;\n}\n\n.content-body {\n    margin-left:var(--width);\n    z-index: 0;\n    transition: all .2s ease;\n    @include respond('laptop') {\n        margin-left: 17rem;\n\t\t\n    }\n}\n// Bell //\n.bell img{\n\t-webkit-animation: ring 8s .7s ease-in-out infinite;\n\t-webkit-transform-origin: 50% 0.25rem;\n\t-moz-animation: ring 8s .7s ease-in-out infinite;\n\t-moz-transform-origin: 50% 0.25rem;\n\tanimation: ring 8s .7s ease-in-out infinite;\n}\n// bell //\n@-webkit-keyframes ring {\n  0% { -webkit-transform: rotateZ(0); }\n  1% { -webkit-transform: rotateZ(30deg); }\n  3% { -webkit-transform: rotateZ(-28deg); }\n  5% { -webkit-transform: rotateZ(34deg); }\n  7% { -webkit-transform: rotateZ(-32deg); }\n  9% { -webkit-transform: rotateZ(30deg); }\n  11% { -webkit-transform: rotateZ(-28deg); }\n  13% { -webkit-transform: rotateZ(26deg); }\n  15% { -webkit-transform: rotateZ(-24deg); }\n  17% { -webkit-transform: rotateZ(22deg); }\n  19% { -webkit-transform: rotateZ(-20deg); }\n  21% { -webkit-transform: rotateZ(18deg); }\n  23% { -webkit-transform: rotateZ(-16deg); }\n  25% { -webkit-transform: rotateZ(14deg); }\n  27% { -webkit-transform: rotateZ(-12deg); }\n  29% { -webkit-transform: rotateZ(10deg); }\n  31% { -webkit-transform: rotateZ(-8deg); }\n  33% { -webkit-transform: rotateZ(6deg); }\n  35% { -webkit-transform: rotateZ(-4deg); }\n  37% { -webkit-transform: rotateZ(2deg); }\n  39% { -webkit-transform: rotateZ(-1deg); }\n  41% { -webkit-transform: rotateZ(1deg); }\n  43% { -webkit-transform: rotateZ(0); }\n  100% { -webkit-transform: rotateZ(0); }\n}\n@-moz-keyframes ring {\n  0% { -moz-transform: rotate(0); }\n  1% { -moz-transform: rotate(30deg); }\n  3% { -moz-transform: rotate(-28deg); }\n  5% { -moz-transform: rotate(34deg); }\n  7% { -moz-transform: rotate(-32deg); }\n  9% { -moz-transform: rotate(30deg); }\n  11% { -moz-transform: rotate(-28deg); }\n  13% { -moz-transform: rotate(26deg); }\n  15% { -moz-transform: rotate(-24deg); }\n  17% { -moz-transform: rotate(22deg); }\n  19% { -moz-transform: rotate(-20deg); }\n  21% { -moz-transform: rotate(18deg); }\n  23% { -moz-transform: rotate(-16deg); }\n  25% { -moz-transform: rotate(14deg); }\n  27% { -moz-transform: rotate(-12deg); }\n  29% { -moz-transform: rotate(10deg); }\n  31% { -moz-transform: rotate(-8deg); }\n  33% { -moz-transform: rotate(6deg); }\n  35% { -moz-transform: rotate(-4deg); }\n  37% { -moz-transform: rotate(2deg); }\n  39% { -moz-transform: rotate(-1deg); }\n  41% { -moz-transform: rotate(1deg); }\n  43% { -moz-transform: rotate(0); }\n  100% { -moz-transform: rotate(0); }\n}\n@keyframes ring {\n  0% { transform: rotate(0); }\n  1% { transform: rotate(30deg); }\n  3% { transform: rotate(-28deg); }\n  5% { transform: rotate(34deg); }\n  7% { transform: rotate(-32deg); }\n  9% { transform: rotate(30deg); }\n  11% { transform: rotate(-28deg); }\n  13% { transform: rotate(26deg); }\n  15% { transform: rotate(-24deg); }\n  17% { transform: rotate(22deg); }\n  19% { transform: rotate(-20deg); }\n  21% { transform: rotate(18deg); }\n  23% { transform: rotate(-16deg); }\n  25% { transform: rotate(14deg); }\n  27% { transform: rotate(-12deg); }\n  29% { transform: rotate(10deg); }\n  31% { transform: rotate(-8deg); }\n  33% { transform: rotate(6deg); }\n  35% { transform: rotate(-4deg); }\n  37% { transform: rotate(2deg); }\n  39% { transform: rotate(-1deg); }\n  41% { transform: rotate(1deg); }\n  43% { transform: rotate(0); }\n  100% { transform: rotate(0); }\n}\n\n// 2.375rem + 3.75rem\n///////////////\n// Sidebar\n//////////////\n.dlabnav {\n    width:var(--width);\n    padding-bottom: 0;\n    height: calc(100% - 4.5rem);\n    position: absolute;\n    top: 5rem;\n    padding-top: 0;\n    z-index: 6;\n    background-color: var(--sidebar-bg);\n\tborder-top: none;\n    transition: all .2s ease;\n\tbox-shadow: 0rem 0.9375rem 1.875rem 0rem rgba(0, 0, 0, 0.02);\n\n\t@include custommq($max:100rem){\n\n\t\ttop:4.9rem;\n\t}\n    @include respond('laptop') {\n\t\theight: calc(100% - 64.7px);\n\t}\n    @include respond('tab-land') {\n\t\theight: calc(100% - 70px);\n    }\n\t@include respond('phone-land') {\n         width: 18rem;\n    }\n    // @include respond('big-desktop') {\n    //     left: 6rem;\n    // }\n\t.menu-scroll{\n\t\theight: 55.4rem;\n\t\t@include respond('tab-port'){\n\t\t\theight: 57.4rem;\n\t\t}\n\t}\n    .dlabnav-scroll {\n        position: relative;\n\t\theight:100%;\n\t\toverflow-y: scroll;\n\t\t\n        // overflow: visible!important;\n        // border-top-left-radius: 0.3125rem;\n        // border-top-right-radius: 0.3125rem;\n    }\n    @include respond('laptop') {\n        width: 17rem;\n    }\n    ul {\n        padding: 0;\n        margin: 0;\n        list-style: none;\n    }\n    .metismenu {\n        display: flex;\n        flex-direction: column;\n\t\tpadding: 0.5rem 0 ;\n\t\t\t\n\t\t\n        &.fixed {\n            position: fixed;\n            top: 0;\n            width: 100%;\n            left: 0;\n        }\n        &>li {\n            display: flex;\n            flex-direction: column;\n\t\t\tmargin: 5px 0;\n            a {\n\t\t\t\t\n\t\t\t\t\n                &>i {\n                    //icon will get color from parent \"a\"\n                    font-size: 1.3rem;\n                    display: inline-block;\n                    vertical-align: middle;\n                    position: relative;\n                    top: 0;\n\t\t\t\t\theight:auto;\n\t\t\t\t\twidth:auto;\n\t\t\t\t\ttext-align:center;\n\t\t\t\t\tmargin-right: 0.75rem;\n\t\t\t\t\tborder-radius: 0.125rem;\n\t\t\t\t\tline-height:1;\n\t\t\t\t\tborder-radius:0.125rem;\n\t\t\t\t\t\t\n\t\t\t\t\t@at-root [data-sidebar-style=\"compact\"] & {\n\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t\tbackground: rgba(0,0,0,0.05);\n\t\t\t\t\t\t/* background:rgba($light,0.2); */\n\t\t\t\t\t\tcolor:rgba($black,0.3);\n\t\t\t\t\t\twidth: 3.25rem;\n\t\t\t\t\t\theight: 3.25rem;\n\t\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\t\tline-height: 3.25rem;\n\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t\tmargin-right: auto;\n\t\t\t\t\t\tmargin-bottom: 0.3125rem;\n\t\t\t\t\t\t&[data-theme-version=\"dark\"]{\n\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t\t@include custommq($max:84.375rem) {\n\t\t\t\t\t\theight:auto;\n\t\t\t\t\t\tline-height:0.0625rem;\n\t\t\t\t\t\twidth:auto;\n\t\t\t\t\t\tfont-size: 1.5rem;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tcolor: #969BA0;\n\t\t\t\t\t}\n                }\n            }\n            &>a {\n\t\t\t\tfont-weight: 500;\n\t\t\t\tdisplay: inline-block;\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\tcolor: $body-text;\t\t\n\t\t\t\tsvg {\n\t\t\t\t\tmax-width: 1.5rem;\n\t\t\t\t\tmax-height: 1.5rem;\n\t\t\t\t\theight: 100%;\n\t\t\t\t\tmargin-right:0.625rem;\n\t\t\t\t\tmargin-top: -0.1875rem;\n\t\t\t\t\tcolor: var(--primary);\n\t\t\t\t}\n\t\t\t\ti{\n\t\t\t\t\tfont-family: 'Material Icons';\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\t-webkit-font-feature-settings: 'liga';\n\t\t\t\t\t-webkit-font-smoothing: antialiased;\n\t\t\t\t\tfont-weight: normal;\n\t\t\t\t}\n\t\t\t\tg [fill] {\n\t\t\t\t\tfill: #8088a1;\n\t\t\t\t}\n            }\n            &:hover,\n\t\t\t&:focus {\n\t\t\t\t\n                &>a {\n                /*  background-color: lighten($color: $primary, $amount: 40%); */\n                    color: var(--primary);\n\t\t\t\t\tg [fill] {\n\t\t\t\t\t\tfill: var(--primary);\n\t\t\t\t\t}\n                 &::after {\n\t\t\t\t\tborder-top: 0.2125rem solid var(--primary);\n\t\t\t\t\tborder-left: 0.2125rem solid var(--primary);\n\t\t\t\t }\n                }\n\t\t\t\t\n            }\n            &.mm-active {\n\t\t\t\t&>a {\n\t\t\t\t\tcolor:$white;\n\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tbox-shadow:none;\n\t\t\t\t\ti{\n\t\t\t\t\t\tfont-weight:900;\n\t\t\t\t\t}\n\t\t\t\t\tsvg{\n\t\t\t\t\t\tpath{\n\t\t\t\t\t\t\tfill: #fff;\n\t\t\t\t\t\t\tstroke:#fff;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tg [fill] {\n\t\t\t\t\t\tfill: var(--primary);\n\t\t\t\t\t}\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tborder-top: 0.2125rem solid var(--primary);\n\t\t\t\t\t\tborder-left: 0.2125rem solid var(--primary);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t@at-root [data-sidebar-style=\"compact\"] & {\n\t\t\t\t\t&>a{\n\t\t\t\t\t\t\n\t\t\t\t\t\ti{\n\t\t\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n            }\n        }\n        li {\n            position: relative;\n        }\n\t\t\n        //one step dropdown\n        ul {\n            //background-color: darken($color: $white, $amount: 2%);\n            transition: all .2s ease-in-out;\n\t\t\tposition:relative;\n\t\t\tz-index: 1;\n\t\t\tpadding: 0.5rem 0;\n\t\t\t\t\n            a {\n\t\t\t\tpadding-top: .5rem;\n\t\t\t\tpadding-bottom: .5rem;\n\t\t\t\tposition: relative;\n\t\t\t\tfont-size: 0.875rem;\n\t\t\t\tpadding-left: 3.8rem;\n\t\t\t\t@include transitionMedium;\n\t\t\t\t@include custommq($max: 84.375rem) {\n\t\t\t\t\tpadding-left: 3.6rem;\n\t\t\t\t}\n\t\t\t\t@include respond('phone-land') {\n\t\t\t\t\tpadding-left: 3.5rem;\n\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t}\n\t\t\t\t/* @at-root [data-sidebar-style=\"full\"] & {\n\t\t\t\t\t&:before{\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\theight: 0.125rem;\n\t\t\t\t\t\twidth: 0.375rem;\n\t\t\t\t\t\tbackground: var(--rgba-primary-5);\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tleft: 2.5rem;\n\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t\t@include transitionMedium;\n\t\t\t\t\t}\n\t\t\t\t\t&:hover{\n\t\t\t\t\t\tpadding-left:5.5rem;\n\t\t\t\t\t\t@include custommq($max:78.125rem){\n\t\t\t\t\t\t\tpadding-left:4.5rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\twidth:1.25rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t} */\n                &:hover,\n                &:focus,\n                &.mm-active {\n                    text-decoration: none;\n                    color: var(--primary);\n                }\n\t\t\t\t&:before{\n\t\t\t\t\tposition:absolute;\n\t\t\t\t\tcontent:none;\n\t\t\t\t\theight:0.125rem;\n\t\t\t\t\twidth:0.5rem;\n\t\t\t\t\t//border:0.125rem solid #759791;\n\t\t\t\t\ttop:50%;\n\t\t\t\t\tleft:1.75rem;\n\t\t\t\t\tborder-radius:3.75rem;\n\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t@include custommq($max: 84.375rem) {\n\t\t\t\t\t\tleft:2.8125rem;\n\t\t\t\t\t}\n\t\t\t\t}\n            }\n            \n        }\n        a {\n            position: relative;\n            display: block;\n\t\t\tpadding: 0.7375rem 1.2rem;\n            outline-width: 0;\n            color:#373a54;\n            text-decoration: none;\n\t\t\t@include respond('phone-land') {\n\t\t\t\tpadding: 0.625rem 1.25rem;\n\t\t\t}\n\t\t\t&:hover{\n\t\t\t\tsvg{\n\t\t\t\t\tpath{\n\t\t\t\t\t\tfill: var(--primary);\n\t\t\t\t\t\tstroke: var(--primary);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\ti{\n\t\t\t\t\tcolor: var(--primary);\n\t\t\t\t}\n\t\t\t}\n        }\n        .has-arrow {\n            &:after {\n                /* width:  .5rem;\n                height: .5rem;\n                border-color: inherit; */\n\t\t\t\tborder-top: 0.2125rem solid #C8C8C8;\n\t\t\t\tborder-left: 0.2125rem solid #C8C8C8;\n\t\t\t\tborder-bottom: 0.2125rem solid transparent;\n\t\t\t\tborder-right: 0.2125rem solid transparent;\n                right: 1.875rem;\n                top: 48%;\n                -webkit-transform: rotate(-225deg) translateY(-50%);\n                transform: rotate(-225deg) translateY(-50%);\n\t\t\t\t\n            }\n        }\n        .has-arrow[aria-expanded=true]:after,\n        .mm-active>.has-arrow:after {\n            -webkit-transform: rotate(-135deg) translateY(-50%);\n            transform: rotate(-135deg) translateY(-50%);\n\t\t\t/* margin-right: 2rem; */\n        }\n    }\n\t\n\t.main-menu{\n\t\tpadding: 1.025rem 1.875rem;\n\t\tdisplay: block;\n\t\tpadding-bottom: 0;\n\t\tcolor:var(--primary);\n\t\ttext-transform: capitalize;\n\t\t\n\t}\n\t\n}\n\n.header-profile2{\n\t.nav-link{\n\t\tbackground-color:transparent!important;\n\t}\n\timg{\n\t\theight:3rem;\n\t\twidth:3rem;\n\t\tborder-radius: $radius;\n\t\tmargin-left: 0.8rem;\n\t\tobject-fit: cover;\n\t\t@include custommq($max:112rem){\n\t\t\tmargin-left: 0.5rem;\n\t\t}\n\t\t@include respond ('phone'){\n\t\t\theight: 2.325rem;\n\t\t\twidth: 2.325rem;\n\t\t\tmargin-left: 0;\n\t\t}\n\t}\n\t\n\tspan{\n\t\tcolor:#666666;\n\t\t@include respond ('laptop'){\n\t\t\tfont-size:0.9rem;\t\n\t\t}\n\t}\n\ti{\n\t\tmargin-left:1rem;\n\t\tfont-size: 1.2rem;\n\t}\n\t@include respond('laptop') {\n\t\tpadding:0.5rem 0.5rem;\t\n\t\tpadding-right: 0;\n\t}\n\t@include respond ('phone-land'){\n\t\t.sidebar-info{\n\t\t\tdisplay:none!important;\n\t\t}\n\t\tmargin-left:2px!important;\n\t}\n\t@include respond('phone'){\n\t\tpadding: 0;\n\t}\n\t.dropdown-menu{\n\t\ta{\n\t\t\tsvg{\n\t\t\t\tpath{\n\t\t\t\t\tfill:var(--primary);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t@include respond ('phone'){\n\t\t\t\t\twidth:1.25rem;\n\t\t\t\t\theight:1.25rem;\n\t\t\t\t}\n\t\t\t}\n\t\t\tspan{\n\t\t\t\tfont-size:15px;\n\t\t\t\tfont-weight:400;\n\t\t\t\tcolor:$body-color;\n\t\t\t\t\n\t\t\t\t@include respond ('phone'){\n\t\t\t\t\tfont-size:12px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.dropdown-item{\n\t\t\tpadding: 0.5rem 0.75rem;\n\t\t}\n\t}\n}\n\n .copyright{\n\tpadding:0 1.875rem;\n\tcolor:#9fa4a6;\n\tmargin-top: 1.875rem;\n\t/* p{\n\t\tfont-size: 0.875rem;\n\t\t/color:#fff;\n\t} */\n\tstrong{\n\t\tdisplay:block;\n\t\tfont-size: 0.875rem;\n\t\tfont-weight:700;\n\t\tcolor:var(--primary);\n\t\twhite-space: nowrap;\n\t}\n} \n\n.nav-header {\n\t@include custommq($max:63.9375rem){\n\t\twidth: 5rem;\n\t}\n\n}\n@media (max-width:47.9375rem) {\n\n\t.brand-title {\n\t\tdisplay: none;\n\t}\n    .footer {\n        padding-left: 0;\n    }\n    .dlabnav {\n        left: 0;\n\t\ttop: 5rem;\n    }\n}\n[data-sidebar-style=\"full\"][data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-container=\"wide\"]{\n\t@include custommq($max: 1422px , $min:1024px) {\n\t\t.content-body{\n\t\t\tpadding-top:14rem!important;\n\t\t}\n\t}\n\t\t\n}\n[data-sidebar-style=\"full\"][data-header-position=\"fixed\"][data-layout=\"vertical\"][data-container=\"wide-boxed\"]{\n\t.content-body{\n\t\tpadding-top:5rem!important;\n\t}\n}\n[data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-container=\"wide\"][data-sidebar-position=\"static\"]{\n\t.content-body{\n\t\tpadding-top:10rem;\n\t}\n}\n","//common mega-menu styles\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] .menu-toggle, \n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"] {\n\n    .dlabnav {\n        .metismenu {\n            &>li {\n                &.mega-menu {\n\n                    &> ul.collapse:not(.in) {\n                        height: 15.75rem !important;\n                    }\n\n                    &:hover {\n                        &>a {\n                            width: calc(70vw + 3.75rem);\n                        }\n\n                        &>ul {\n                            display: flex;\n                            flex-wrap: wrap;\n                            flex-direction: column;\n                            max-height: 13.75rem;\n                            width: 70vw;\n\n                            ul a {\n                                width: 101%;\n                            }\n                        }\n                    }\n\n                    &-xl {\n                        &:hover {\n                            &>a {\n                                width: calc(70vw + 3rem);\n                            }\n\n                            &>ul {\n                                max-height: 12.5rem;\n                                width: 70vw;\n\n                                ul a {\n                                    width: 101%;\n                                }\n                            }\n                        }\n                    }\n\n                    &-lg {\n\n                        &:hover {\n                            &>a {\n                                width: calc(55vw + 3rem);\n                            }\n\n                            &>ul {\n                                max-height:12.5rem;\n                                width: 55vw;\n\n                                ul a {\n                                    width: 101%;\n                                }\n                            }\n                        }\n                    }\n\n                    &-md {\n                        &:hover {\n                            &>a {\n                                width: calc(45vw + 3);\n                            }\n                            &>ul {\n                                max-height: 18.75rem;\n                                width: 45vw;\n\n                                ul a {\n                                    width: 101%;\n                                }\n                            }\n                        }\n                    }\n\n                    &-sm {\n                        &:hover {\n                            &>a {\n                                width: calc(30vw + 3);\n                            }\n                            &>ul {\n                                max-height: 18.125rem;\n                                width: 30vw;\n\n                                ul a {\n                                    width: 101%;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n[data-sidebar-style=\"mini\"][data-layout=\"vertical\"][data-container=\"boxed\"] {\n    .dlabnav {\n        .metismenu {\n\n            &>li {\n                &.mega-menu {\n\n                    &:hover {\n                        &>a {\n                            width: calc(60vw + 3.75rem);\n                        }\n                        &>ul {\n                            display: flex;\n                            flex-wrap: wrap;\n                            flex-direction: column;\n                            max-height: 25rem;\n                            width: 60vw;\n\n                            ul a {\n                                width: 101%;\n                            }\n                        }\n                    }\n\n                    &-xl {\n                        &:hover {\n                            &>a {\n                                width: calc(60vw + 3.75rem);\n                            }\n                            &>ul {\n                                max-height: 25.625rem;\n                                width: 60vw;\n                            }\n                        }\n                    }\n\n                    &-lg {\n\n                        &:hover {\n                            &>a {\n                                width: calc(50vw + 3.75rem);\n                            }\n\n                            &>ul {\n                                max-height: 16.25rem;\n                                width: 50vw;\n                            }\n                        }\n                    }\n\n                    &-md {\n                        &:hover {\n                            &>a {\n                                width: calc(40vw + 3.75rem);\n                            }\n                            &>ul {\n                                max-height: 18.75rem;\n                                width: 40vw;\n                            }\n                        }\n                    }\n\n                    &-sm {\n                        &:hover {\n                            &>a {\n                                width: calc(22vw + 3.75rem);\n                            }\n                            &>ul {\n                                max-height: 18.125rem;\n                                width: 22vw;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n//mega menu for horizontal layout\n[data-layout=\"horizontal\"] {\n\n    .dlabnav {\n\n        .metismenu {\n\n            &>li {\n\n                &.mega-menu {\n                    &:not(:last-child) {\n                        position: static;\n                    }\n\n                    ul {\n                        left: 0;\n                        right: 0;\n\t\t\t\t\t\t\n\n                        li {\n                            \n                            @at-root [data-theme-version=\"dark\"]#{&} {\n                                border-color: $d-border;\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_2\"]#{&} {\n                                border-color: darken($color_pallate_2, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_3\"]#{&} {\n                                border-color: darken($color_pallate_3, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_4\"]#{&} {\n                                border-color: darken($color_pallate_4, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_5\"]#{&} {\n                                border-color: darken($color_pallate_5, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_6\"]#{&} {\n                                border-color: darken($color_pallate_6, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_7\"]#{&} {\n                                border-color: darken($color_pallate_7, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_8\"]#{&} {\n                                border-color: darken($color_pallate_8, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_9\"]#{&} {\n                                border-color: darken($color_pallate_9, 20%);\n                            }\n                            \n                            @at-root [data-sibebarbg=\"color_10\"]#{&} {\n                                border-color: darken($color_pallate_10, 20%);\n                            }\n\n                            a {\n                                transition: all .4s ease-in-out;\n\n                                &:hover {\n                                    border-radius: 0.25rem;\n                                }\n                            }\n                        }\n                    }\n\n                    &:hover {\n                        &>ul {\n                            display: flex;\n                            flex-wrap: wrap;\n                            flex-direction: column;\n                            max-height: 13.75rem;\n                            width: 70vw;\n                            z-index: 99;\n\n                            &::after {\n                                content: \"\";\n                                height: 100%;\n                                width: 0.0625rem;\n                                position: absolute;\n                                background-color: $white;\n                                right: 2.8125rem;\n                                top: 0;\n\n                                @at-root [data-theme-version=\"dark\"]#{&} {\n                                    background-color: lighten($color: $d-bg, $amount: 3.2%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_2\"]#{&} {\n                                    background-color: darken($color_pallate_2, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_3\"]#{&} {\n                                    background-color: darken($color_pallate_3, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_4\"]#{&} {\n                                    background-color: darken($color_pallate_4, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_5\"]#{&} {\n                                    background-color: darken($color_pallate_5, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_6\"]#{&} {\n                                    background-color: darken($color_pallate_6, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_7\"]#{&} {\n                                    background-color: darken($color_pallate_7, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_8\"]#{&} {\n                                    background-color: darken($color_pallate_8, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_9\"]#{&} {\n                                    background-color: darken($color_pallate_9, 10%);\n                                }\n                                \n                                @at-root [data-sibebarbg=\"color_10\"]#{&} {\n                                    background-color: darken($color_pallate_10, 10%);\n                                }\n                            }\n\n                            ul a {\n                                width: 101%;\n                            }\n                        }\n                    }\n\n                    &-xl {\n                        &:hover {\n                            &>ul {\n                                max-height: 13.125rem;\n                                width: 70vw;\n                            }\n                        }\n                    }\n\n                    &-lg {\n\n                        &:hover {\n\n                            &>ul {\n\t\t\t\t\t\t\t\tmax-height: 13.125rem;\n\t\t\t\t\t\t\t\twidth: 43.75rem;\n\t\t\t\t\t\t\t\theight: 13.125rem !important;\n\t\t\t\t\t\t\t\t\n                                @include custommq($min: 75rem, $max: 93.75rem) {\n                                    width: 43.75rem;\n                                }\n                            }\n                        }\n                    }\n\n                    &-md {\n                        &:hover {\n                            &>ul {\n                                max-height: 20rem;\n                                width: 54vw;\n\n                                @include custommq($min: 75rem, $max: 93.75rem) {\n                                    width: 60vw;\n                                }\n                            }\n                        }\n                    }\n\n                    &-sm {\n                        &:hover {\n                            &>ul {\n                                max-height: 20rem;\n                                width: 25vw;\n\n                                @include custommq($min: 75rem, $max: 93.75rem) {\n                                    width: 35vw;\n                                }\n                            }\n                        }\n                    }\n                }\n\n            }\n        }\n    }\n}\n\n[data-layout=\"horizontal\"][data-container=\"boxed\"] {\n    .dlabnav {\n        .metismenu {\n            &>li {\n                &.mega-menu {\n                    &:hover {\n                        &>ul {\n                            display: flex;\n                            flex-wrap: wrap;\n                            flex-direction: column;\n                        }\n                    }\n\n                    &-xl {\n                        &:hover {\n                            &>ul {\n                                max-height: 21.875rem;\n                                width: 100%;\n                            }\n                        }\n                    }\n\n                    &-lg {\n\n                        &:hover {\n\n                            &>ul {\n                                max-height: 21.875rem;\n                                width: 55vw;\n                            }\n                        }\n                    }\n\n                    &-md {\n                        &:hover {\n                            &>ul {\n                                max-height: 18.75rem;\n                                width: 45vw;\n                            }\n                        }\n                    }\n\n                    &-sm {\n                        &:hover {\n                            &>ul {\n                                max-height: 18.125rem;\n                                width: 50vw;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}","@import \"../../abstracts/variable\";\n@import \"../../abstracts/mixin\";\n[data-sidebar-style=\"full\"][data-layout=\"vertical\"] {\n    .dlabnav{\n\t\t\n\t\t.metismenu{\n\n\t\t\t& > li{\n\t\t\t\tpadding:0 1.25rem 0 1.25rem;\n\t\t\t\t& > a{\n\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\tpadding: 0.638rem 1.5rem;\n\t\t\t\t\tfont-weight:400;\n\t\t\t\t\t//border-radius:$radius;\n\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\t@include transitionMedium;\n\t\t\t\t\tline-height: 1.5rem;\n\t\t\t\t\t/* &:before{\n\t\t\t\t\t\tposition:absolute;\n\t\t\t\t\t\tcontent:\"\";\n\t\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\t\twidth:0;\n\t\t\t\t\t\theight:100%;\n\t\t\t\t\t\ttop:0;\n\t\t\t\t\t\tleft:0rem;\n\t\t\t\t\t\t@include transitionMedium;\n\t\t\t\t\t\tborder-radius:1.25rem;\n\t\t\t\t\t\t\n\t\t\t\t\t} */\n\t\t\t\t\t\n\t\t\t\t}\n\t\t\t\t&.mm-active{\n\n\t\t\t\t\t& > a{\n\t\t\t\t\t\tfont-weight:500;\n\t\t\t\t\t\tbackground: var(--bs-body-bg);\n\t\t\t\t\t\tcolor:var(--primary);\n\t\t\t\t\t\t//box-shadow: 0px 10px 20px rgba(1, 163, 255, 0.15);\n\t\t\t\t\t\t &:before{\n\t\t\t\t\t\t\twidth:0.375rem;\n\t\t\t\t\t\t\t@include respond ('laptop'){\n\t\t\t\t\t\t\t\twidth:0.600rem;\t\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t svg{\n\t\t\t\t\t\t\tpath{\n\t\t\t\t\t\t\t\tfill:var(--primary);\n\t\t\t\t\t\t\t\t//stroke: var(--primary);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t\ti{\n\t\t\t\t\t\t\tcolor:var(--primary);\n\t\t\t\t\t\t\tfont-weight: 900;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.has-arrow:after{\n\t\t\t\t\tright: 1.5rem;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t\t\n\t\t}\n\t\t\n\t}\n\t.menu-toggle {\n        .nav-header {\n            width: 5.5rem;\n            z-index: 999;\n            .brand-logo {\n                padding-left: 0;\n                padding-right: 0;\n                justify-content: center;\n            }\n            .nav-control {\n\t\t\t\tright: -5.2rem;\n                .hamburger {\n                    .line {\n                        background-color: $main-color;\n\t\t\t\t\t\topacity: 1;\n                    }\n                }\n            }\n        }\n\t\t.copyright,\n\t\t.plus-box{\n\t\t\tdisplay:none;\n\t\t}\n        .header {\n            padding-left: 5.5rem;\n            width: 100%;\n            @at-root [direction=\"rtl\"]#{&} {\n                padding: 0 0.9375rem;\n                padding-right: 7.5rem;\n            }\n\t\t\t.header-content{\n\t\t\t\twidth:calc(100% - 0rem);\n\t\t\t\tleft:5.5rem;\n\t\t\t\tmargin-left: 0rem;\n\t\t\t}\n\t\t\t.page-titles{\n\t\t\t\tpadding-left: 7.3rem;\n\t\t\t}\n        }\n        .dlabnav {\n            width: 5.5rem;\n            overflow: visible;\n            position: absolute;\n            .nav-text {\n                display: none;\n            }\n            .slimScrollDiv,\n            .dlabnav-scroll {\n                overflow: visible !important;\n            }\n\t\t\t.header-info2{\n\t\t\t\tpadding:0;\t\n\t\t\t\timg{\n\t\t\t\t\tmargin-left:-1rem;\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t.sidebar-info{\n\t\t\t\tdisplay:none!important;\t\n\t\t\t}\n\t\t\t.header-profile2{\n\t\t\t\tmargin: 0 0.5rem;\t\n\t\t\t}\n            .metismenu {\n\t\t\t\n\t\t\t\t\n                li {\n                    position: relative;\n\t\t\t\t\t\n                    a {\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t\t\tmargin: 0.125rem 0;\n\t\t\t\t\t\t\n\t\t\t\t\t\tsvg{\n\t\t\t\t\t\t    max-width: 1.5rem;\n\t\t\t\t\t\t\tmax-height: 1.5rem;\n\t\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t}\n\t\t\t\t\t\ti{\n\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t}\n                    }\n                    &>ul {\n                        position: absolute;\n\t\t\t\t\t\tleft: 5.5rem;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\twidth: 12rem;\n\t\t\t\t\t\tz-index: 1001;\n\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\tpadding-left: 0.0625rem;\n\t\t\t\t\t\theight: auto !important;\n\t\t\t\t\t\tbox-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n\t\t\t\t\t\tborder-radius: 0.375rem;\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\tborder:0;\n\t\t\t\t\t\tbackground:$white;\n\n                        @at-root [direction=\"rtl\"]#{&} {\n                            left: auto;\n                            right: 5rem;\n                            // box-shadow: -0.375rem 0.375rem 0.625rem rgba(0, 0, 0, 0.15);\n                        }\n                        li:hover {\n                            ul {\n                                // display: block;\n                                left: 11.8125rem;\n                                top: 0;\n\t\t\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t\t\t}\n                            }\n                        }\n                    }\n                    &:hover>ul {\n                        display: block;\n                        height: auto;\n                        overflow: visible;\n                    }\n                }\n                &>li {\n                    transition: all 0.4s ease-in-out;\n\t\t\t\t\tpadding: 0 1.125rem;\n\t\t\t\t\t\n                    &>a {\n\t\t\t\t\t\tpadding: 0.75rem 0.925rem;\n\t\t\t\t\t\ttext-align:center;\n\t\t\t\t\t\tborder-radius:0.5rem;\n                        &.has-arrow {\n                            &:after {\n                                display: none;\n                            }\n                        }\n                    }\n                    &.mm-active > a{\n\t\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\t\tborder-radius:$radius;\n\t\t\t\t\t\ti{\n\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n                    &:hover{\n                        &:nth-last-child(-n + 1) {\n                            &>ul {\n                                bottom: 0;\n                                top: auto;\n                            }\n                        }\n                        &>a {\n\t\t\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\ti{\n\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t/* background:$primary; */\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\tsvg{\n\t\t\t\t\t\t\t\tpath{\n\t\t\t\t\t\t\t\t\tfill: #fff;\n\t\t\t\t\t\t\t\t\tstroke:#fff;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n                        }\n                        &>ul {\n                            height: auto !important;\n\t\t\t\t\t\t\tpadding: 0.625rem 0;\t\t\t\t\t\t\n\t\t\t\t\t\t\t\n                            a {\n                                padding: 0.375rem 1.25rem 0.375rem 1.25rem;\n                                margin-left: -.1rem;\n                            }\n                            ul{\n\t\t\t\t\t\t\t\tpadding: 0.625rem 0;\n\t\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\t\tpadding: 0.375rem 1.25rem 0.375rem 1.25rem;\n\t\t\t\t\t\t\t\t\tmargin-left: -.1rem;\n\t\t\t\t\t\t\t\t}\n                            }\n                        }\n                    }\n                }\n                .nav-label,\n                .nav-badge {\n                    display: none;\n\t\t\t\t\t\n                }\n            }\n\t\t\t.feature-box{\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t\t.support-box{\n\t\t\t\tdisplay:none;\n\t\t\t}\n        }\n        .content-body {\n            margin-left: 5.5rem;\n            @at-root [direction=\"rtl\"]#{&} {\n                margin-right: 5.7rem;\n                margin-left: auto;\n\t\t\t\tborder: 0;\n            }\n        }\n        &+.footer {\n            padding-left: 5.7rem;\n            @at-root [direction=\"rtl\"]#{&} {\n                padding-left: 0;\n                padding-right: 5.7rem;\n            }\n        }\n\t\t\n    }\n}\n[data-sidebar-style=\"full\"][data-layout=\"horizontal\"] {\n\t.header .header-content{\n\t\tpadding-left: 1.875rem;\n\t}\n\t\n}\n\t","@import \"../../abstracts/_mixin\";\n@import \"../../abstracts/_variable\";\n\n@include custommq($min: 48rem) {\n\n    [data-sidebar-style=\"mini\"] {\n        \n        .nav-header {\n            width: 6.25rem;\n\n            .nav-control {\n                z-index: -1;\n                .hamburger{\n                    left: 6.25rem!important;\n                    .line{\n                        background-color: $dark!important;\n                    }\n                }\n            }\n            .brand-title {\n                display: none;\n            }\n            .hamburger {\n                display: none;\n            }\n        }\n\t\t.header .header-content{\n\t\t\tpadding-left: 1.875rem;\n\t\t\tleft: 6.32rem;\n\t\t\tpadding-right: 2rem;\n\t\t\twidth: auto;\n\t\t\tmargin-left: 0;\n\t\t\t@at-root [direction=\"rtl\"]#{&}{\n\t\t\t\tpadding-right: 1.875rem;\n\t\t\t}\n\t\t}\n        .dlabnav {\n            width: 6.25rem;\n            overflow: visible;\n            position: absolute;\n\t\t\tz-index:2;\n\t\t\ttop:5rem;\n\t\t\t.copyright,\n\t\t\t.plus-box{\n\t\t\t\tdisplay:none;\n\t\t\t}\n            .nav-text {\n                display: none;\n            }\n\n            .slimScrollDiv,\n            .dlabnav-scroll {\n                overflow: visible !important;\n            }\n            .nav-user{\n                padding: 0.6875rem;\n                .media-body{\n                    display: none;\n                }\n            }\n\t\t\t.header-profile{\n\t\t\t\t&:hover{\n\t\t\t\t\t&> a.nav-link{\n\t\t\t\t\t\tborder-radius:3rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\timg {\n\t\t\t\t\twidth: 3rem;\n\t\t\t\t\theight: 3rem;\n\t\t\t\t}\n\t\t\t\t&> a.nav-link{\n\t\t\t\t\tborder-radius:3rem;\n\t\t\t\t\tpadding: 0.3125rem 0.3125rem\n\t\t\t\t}\n\t\t\t\t.header-info{\n\t\t\t\t\tdisplay:none;\n\t\t\t\t}\n\t\t\t\tmargin-bottom:0;\n\t\t\t\tmargin-top:0.75rem;\n\t\t\t}\n            .metismenu {\n               li {\n\t\t\t   \n                    a {\n                        padding: 0.813rem 0.875rem;\n\t\t\t\t\t\t svg{\n\t\t\t\t\t\t\tmargin-right:0;\n\t\t\t\t\t\t\n\t\t\t\t\t\t }\n\t\t\t\t\t\t i{\n\t\t\t\t\t\t\theight:auto;\n\t\t\t\t\t\t\twidth:auto;\n\t\t\t\t\t\t\tline-height:1;\n\t\t\t\t\t\t\tmargin:0;\n\t\t\t\t\t\t }\n                    }\n\n                    &>ul {\n                        position: absolute;\n                        left: 6.25rem;\n                        top: 2.9375rem;\n                        width: 11.875rem;\n                        z-index: 1001;\n                        display: none;\n                        padding-left: 0.0625rem;\n                        box-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n                        height: auto !important;\n\t\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\t\tbackground: #fff;\n\n                        @at-root [direction=\"rtl\"]:not([data-layout=\"horizontal\"])#{&} {\n                            left: auto;\n                            right: 6.25rem;\n                            box-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n                        }\n                    }\n                }\n                &>li {\n\t\t\t\t\tpadding: 0.125rem 1.55rem;\n                    &>a {\n\t\t\t\t\t\tpadding: 0.825rem 0.875rem;\n\t\t\t\t\t\t/* width: 64px;\n\t\t\t\t\t\theight: 64px; */\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\tline-height: 1;\n\t\t\t\t\t\ttransition: all 0.5s;\n\t\t\t\t\t\t-moz-transition: all 0.5s;\n\t\t\t\t\t\t-webkit-transition: all 0.5s;\n\t\t\t\t\t\t-ms-transition: all 0.5s;\n\t\t\t\t\t\t-o-transition: all 0.5s;\n\t\t\t\t\t\t\n\t\t\t\t\t\t& > i{\n\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t\tfont-size: 1.2rem;\n\t\t\t\t\t\tfont-weight:900;\n\t\t\t\t\t\t}\n                        &.has-arrow {\n                            &:after {\n                                display: none;\n                            }\n                        }\n                    }\n\t\t\t\t\t\n                }\n                .nav-label,\n                .nav-badge {\n                    display: none;\n                }\n            }\n\t\t\t.header-info2{\n\t\t\t\tpadding:0;\t\n\t\t\t\timg{\n\t\t\t\t\tmargin-left:-1rem;\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t.sidebar-info{\n\t\t\t\tdisplay:none!important;\t\n\t\t\t}\n\t\t\t.header-profile2{\n\t\t\t\tmargin:0 0.5rem;\t\n\t\t\t}\n        }\n\n        .content-body {\n            margin-left: 6.25rem;\n        }\n\n        .footer {\n            //padding-left: 5.5rem;\n\t\t  padding-left:1rem;\n        }\n    }\n\n    [data-sidebar-style=\"mini\"][data-layout=\"vertical\"] {\n        .dlabnav {\n\t\t\tposition: absolute;\n            .metismenu {\n\n                li {\n                    &:hover>ul {\n                        display: block;\n                    }\n                }\n\n                &>li {\n\t\t\t\t\tposition:relative;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tcontent:\"\";\n\t\t\t\t\t\t\tposition:absolute;\n\t\t\t\t\t\t\ttop:0;\n\t\t\t\t\t\t\tright:0;\n\t\t\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\t\t\twidth:3px;\n\t\t\t\t\t\t\theight:0;\n\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t@include transitionMedium;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n                    &:nth-last-child(-n + 1) {\n                        &>ul {\n                            bottom:0;\n                            top: auto !important;\n\t\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\t\ttop:auto;\n\t\t\t\t\t\t\t\tbottom:1.25rem;\n\t\t\t\t\t\t\t}\n                        }\n                    }\n\n                    @include respond('tab-land') {\n                        &:nth-last-child(-n + 1) {\n                            &>ul {\n                                bottom: 0;\n                                top: auto !important;\n                            }\n                        }\n                    }\n\n                    &>ul {\n                        overflow: visible;\n\t\t\t\t\t\t\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t}\n\n                        li:hover {\n                            ul {\n                                padding: 0.625rem 0;\n\t\t\t\t\t\t\t\twidth: 13rem;\n\t\t\t\t\t\t\t\tleft: 13rem;\n\t\t\t\t\t\t\t\ttop: -0.625rem;\n\t\t\t\t\t\t\t\tborder: 0;\n\t\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t\t\t}\t\t\t\n\t\t\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&}{\n\t\t\t\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\t\t\t\tright: 13rem;\n\t\t\t\t\t\t\t\t}\t\t\t\n                            }\n                        }\n                    }\n\t\t\t\t\t&.mm-active {\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\theight:100%;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&>a {\n\t\t\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\t\t\ti{\n\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t//@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\t\t//\tbackground: $dark-card;\n\t\t\t\t\t\t\t//}\n\t\t\t\t\t\t}\n\t\t\t\t\t\tsvg{\n\t\t\t\t\t\t\tpath{\n\t\t\t\t\t\t\t\tfill: #fff;\n\t\t\t\t\t\t\t\tstroke: #fff;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n                    &:hover {\n\n\n                        &>a {\n                           background: var(--primary);\n\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t/* box-shadow:0 12px 15px 0 var(--rgba-primary-1); */\n\t\t\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\t\t\tposition: unset;\n\t\t\t\t\t\t\ti{\n\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t\t\n                            .nav-text {\n\t\t\t\t\t\t\t\t\n                                @at-root [direction=\"rtl\"]#{&} {\n                                    padding-left: auto;\n                                    padding-right: 1.6875rem;\n                                }\n                            }\n                        }\n                        &>ul {\n                            height: auto !important;\n                            overflow: visible;\n\t\t\t\t\t\t\tborder:0;\n\t\t\t\t\t\t\tmargin-left:0;\n\t\t\t\t\t\t\tleft: 6.25rem;\n\t\t\t\t\t\t\twidth: 13rem;\n\t\t\t\t\t\t\tborder-radius:$radius;\n\t\t\t\t\t\t\tborder:0;\n\t\t\t\t\t\t\tpadding: 0.625rem 0;\n\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\t\t\tbox-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\t\t\tright: 6.25rem;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\ta {\n                                padding: 0.375rem 1.25rem 0.375rem 1.25rem;\n                               \n\t\t\t\t\t\t\t    &:before{\n\t\t\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&.has-arrow:after{\n\t\t\t\t\t\t\t\t\tright: 1.25rem\n\t\t\t\t\t\t\t\t}\n                            }\n\t\t\t\t\t\t\t\n                            ul {\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\t\tpadding: 0.375rem 1.25rem 0.375rem 1.25rem;\n\t\t\t\t\t\t\t\t\tmargin-left: -0.1rem;\n\t\t\t\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n                            }\n                        }\n                    }\n                }\n            }\n\t\t\t.feature-box{\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t\t.support-box{\n\t\t\t\tdisplay:none;\n\t\t\t}\n        }\n    }\n\n    [data-sidebar-style=\"mini\"][data-header-position=\"fixed\"][data-container=\"boxed\"][data-layout=\"vertical\"] {\n        .header {\n            width: 74.9375rem;\n        }\n    }\n\t\n\t[data-sidebar-style=\"mini\"][data-layout=\"horizontal\"] {\n\t\t.dlabnav{\n\t\t\t.metismenu {\n\t\t\t\t\n\t\t\t\t& > li{\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\n\t\t\t\t\t& > a {\n\t\t\t\t\t\tpadding: 0.725rem;\n\t\t\t\t\t\t\n\t\t\t\t\t\ti{\n\t\t\t\t\t\t\tpadding: 0;\t\n\t\t\t\t\t\t\tmargin:0;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\tpadding: 1.125rem;\n\t\t\t\t\t\t\tsvg {\n\t\t\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\tsvg{\n\t\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t\t\tmargin-top: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t& > ul li a{\n\t\t\t\t\t    padding: 0.5rem 1.25rem 0.5rem 1.25rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n}\n\n@include respond('tab-land') {\n    [data-sidebar-style=\"mini\"] {\n        .dlabnav {\n\n            li {\n                &.mm-active {\n                    ul {\n                        height: auto !important;\n                    }\n                }\n\n                a.has-arrow {\n                    &::after {\n                        transform: rotate(-225deg) translateY(-50%);\n                    }\n                }\n            }\n        }\n    }\n}","@import \"../../abstracts/variable\";\n\n////////////////////\n// Horizontal Nav\n////////////////////\n@media (min-width: 64rem) {\n    [data-layout=\"horizontal\"] {\n\t\t&[data-sidebarbg=\"color_1\"] .dlabnav{\n\t\t\tbackground-color:$white;\n\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\tbackground-color:$dark-card;\n\t\t\t}\n\t\t}\n        .dlabnav .menu-scroll{\n\t\t\theight: unset;\n\t\t}\n        .nav-header {\n            width: 18.563rem;\n\t\t\theight: 5rem;\n\t\t\ttop:0;\n            .nav-control {\n                display: none;\n            }\n\n            .brand-logo {\n\t\t\t\tpadding-left: 2.5rem;\n\t\t\t\tpadding-right: 2.5rem;\n            }\n        }\n\n        .header {\n            width: 100%;\n\t\t\theight: 5rem;\n            padding-left: 0;\n\t\t\tpadding-top:0;\n        }\n\n        .dlabnav {\n            width:100%;\n            position: relative;\n            height: auto;\n            padding-bottom: 0;\n            top: 0;\n            z-index: 2;\n\t\t\t\n            .slimScrollDiv {\n                overflow: visible!important;\n\n                .dlabnav-scroll {\n                    overflow: visible!important;\n                }\n            }\n\t\t\t.dlabnav-scroll {\n\t\t\t\toverflow: visible!important;\n\t\t\t}\n            .slimScrollBar {\n                display: none !important;\n            }\n\t\t\t.header-profile{\n\t\t\t\tmargin-right: 0.9375rem;\n\t\t\t\tmargin-bottom:0;\n\t\t\t\t&:hover{\n\t\t\t\t\t&> a.nav-link{\n\t\t\t\t\t\tborder-radius:3rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\timg{\n\t\t\t\t\theight:2.8125rem;\n\t\t\t\t\twidth:2.8125rem;\n\t\t\t\t}\n\t\t\t\t&> a.nav-link{\n\t\t\t\t\tborder-radius:3rem;\n\t\t\t\t\tpadding: 0.3125rem 0.3125rem\n\t\t\t\t}\n\t\t\t\t.header-info{\n\t\t\t\t\tdisplay:none;\n\t\t\t\t}\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t\t.header-profile2{\n\t\t\t\tdisplay:none;\t\n\t\t\t}\n            .nav-user,\n            .nav-label {\n                display: none;\n            }\n\t\t\t\n            .metismenu {\n                flex-direction: row;\n\t\t\t\tpadding:0.625rem 1.25rem;\n\t\t\t\tmargin-bottom: 0;\n                display: inline-flex;\n                flex-wrap: wrap;\t\n                .collapse.in {\n                    display: none;\n                }\n\t\t\t\tul{\n\t\t\t\t\tborder-left:0;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t   box-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n\t\t\t\t\t}\n\t\t\t\t}\n                li {\n                    flex-direction: column;\n                    position: relative;\n\n                    &:hover {\n                        &>ul {\n                            display: block;\n                        }\n                    }\n                    \n                    &>ul {\n                        position: absolute;\n                        height: auto !important;\n                        top: 100%;\n                        width: 100%;\n                        min-width: 13.75rem;\n                        z-index: 999;\n                        left: auto;\n                        right: auto;\n                        padding: 0.5rem 0;\n                        display: none;\n                        box-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n\t\t\t\t\t\tmargin:0;\n\t\t\t\t\t\tbackground:$white;\n                        border-radius: $radius;\n\t\t\t\t\t\t\t\n                        @at-root [data-theme-version=\"dark\"]#{&} {\n                           box-shadow:0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n\t\t\t\t\t\t   background:$dark-card;\n                        }\n\n                        li {\n                            padding: 0;\n    \n                            a {\n                                transition: all .4s ease-in-out;\n                                padding: 0.5rem 1.25rem 0.5rem 1.25rem;\n                                margin-left: -.1rem;\n\t\t\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\t\t\tpadding: 0.5rem 1.25rem 0.5rem 1.25rem;\n\t\t\t\t\t\t\t\t\ttext-align: right;\n\t\t\t\t\t\t\t\t}\n                                &:hover {\n                                    border-radius: .4rem;\n\t\t\t\t\t\t\t\t\tpadding-left:1.25rem;\n                                }\n\t\t\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t\t\t\tleft: 1.375rem;\n\t\t\t\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\t\t\t\t\tright: 0.375rem;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n                            }\n                        }\n                        \n                        ul {\n                            left: 100%;\n                            top: 0;\n\t\t\t\t\t\t\tbox-shadow: 0rem 0rem 2.5rem 0rem rgba(82, 63, 105, 0.1);\n\t\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\t\t\tright: 100%;\n\t\t\t\t\t\t\t}\n                        }\n                    }\n                }\n\n                &>li {\n                    flex: 0 0 auto;\n                    position: relative;\n                    &>a i{\n\t\t\t\t\t\tmargin-right:0.3125rem;\n\t\t\t\t\t}\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\tborder-color: rgba(255,255,255,0.07);\t\t\n\t\t\t\t\t\t\n\t\t\t\t\t\t&.mm-active{\n\t\t\t\t\t\t\tborder-color:transparent;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&.mm-active{\n\t\t\t\t\t\tpadding:0;\t\t\t\n\t\t\t\t\t\t& > a{\n\t\t\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\t\t\ti{\n\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t\t\t\t\tbox-shadow:none;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n                    @at-root [direction=\"rtl\"]#{&} {\n                        //&:not(:first-child) {\n                        //    border-right: lighten($color: $color-pallate-2, $amount: 10%);\n                        //}\n\n                        &:first-child {\n                            border-right: 0;\n                        }\n\n                        \n\n                        @at-root [data-theme-version=\"dark\"]#{&} {\n                            border-color: $d-border;\n                        }\n                    }\n                    &>a {\n                        padding: 0.7375rem  2.4rem 0.7375rem 0.7375rem;\n\t\t\t\t\t\tmargin: 0.125rem 0.125rem;\n                        @at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\tpadding: 0.9375rem 0.9375rem 0.9375rem 2.5rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n                        i{\n                            padding: 0 0.4375rem 0 0;\n\t\t\t\t\t\t\theight:auto;\n\t\t\t\t\t\t\twidth:auto;\n\t\t\t\t\t\t\tline-height:1;\n                            @at-root [direction=\"rtl\"]#{&} {\n                                padding: 0 0 0 0.4375rem;\n                            }\n                        }\n                        .nav-badge {\n                            display: none;\n                        }\n                        &:after {\n                            right: 1.25rem;\n                            transform: rotate(-135deg) translateY(-50%);\n                        }\n                    }\n                    &:hover {\n\t\t\t\t\t\tborder-color:transparent;\n\t\t\t\t\t\t\n                        & > ul {\n                            display: flex !important;\n                            flex-direction: column;\n                            flex-wrap: wrap;\n                            height: auto !important;\n\t\t\t\t\t\t\tbox-shadow: 0.3125rem 0.3125rem 1.875rem 0rem rgba(20, 0, 30, 0.1);\n\t\t\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\t\t\tbox-shadow: 0.3125rem 0.3125rem 1.875rem 0rem rgba(0, 0, 0, 0.1);\n\t\t\t\t\t\t\t\tbackground:$dark-card;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\n                        }\n                    }\n                    &>ul {\n                        &>li {\n                            &:hover {\n                                ul.collapse {\n                                    display: block!important;\n                                    position: absolute;\n                                    left: auto!important;\n                                    right: -100%!important;\n                                    top: 0!important;\n                                }\n                            }\n                        }\n                    }\n                    &:nth-last-child(-n + 5) {\n                        &>ul {\n                        left: auto;\n                        right: 0;\n                            &>li {\n                                &:hover {\n                                    ul.collapse {\n                                        right: auto!important;\n                                        left: -100%!important;\n                                    }\n                                }\n                            }\n\t\t\t\t\t\t\t&.left{\n\t\t\t\t\t\t\t\tleft:0;\n\t\t\t\t\t\t\t\t&>li {\n\t\t\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\t\t\tul.collapse {\n\t\t\t\t\t\t\t\t\t\t\tleft: 100%!important;\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\t\t\tleft:auto;\n\t\t\t\t\t\t\t\t\tright:0;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n                        }\n                    }\n                    &:last-child {\n                        &>ul {\n                            ul {\n                                left: -100%;\n                            }\n\t\t\t\t\t\t\t&.left{\n\t\t\t\t\t\t\t\tul{\n\t\t\t\t\t\t\t\t\tleft: 100%;\n\t\t\t\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\t\t\t\tleft:auto;\n\t\t\t\t\t\t\t\t\t\tright:100%;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\n                        }\n                    }\n                    @at-root [direction=\"rtl\"]#{&} {\n\n                        &:nth-last-child(-n + 3) {\n                            &>ul {\n                            left: 0;\n                            right: auto;\n                                &>li {\n                                    &:hover {\n                                        ul.collapse {\n                                            right: -100% !important;\n                                            left: auto !important;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n\n            \n        \n\t\t\t\n\t\t\t.copyright,\n\t\t\t.feature-box,\n\t\t\t.support-box{\n\t\t\t\tdisplay:none;\n\t\t\t}\n        }\n\t\t\n        .content-body {\n            margin-left: 0;\n\t\t\t.container-fluid{\n\t\t\t\tpadding-top:2.5rem;\n\t\t\t\t@include respond ('tab-land'){\n\t\t\t\t\tpadding-top:4.5rem;\n\t\t\t\t}\n\t\t\t}\n            .page-titles {\n                margin-left: 0!important;\n                margin-right: 0!important;\n                margin-bottom: 1.875rem;\n            }\n        }\n\n        .footer {\n            margin-left: 0;\n            margin: 0 auto;\n            padding-left: 0;\n\n            &.footer-outer{\n                width: calc(100% - 25.225rem);\n                margin-left: 1.775rem;\n\n            }\n            &.style-2{\n\n                width:calc(100% - 3.825rem);\n            }\n            &.style-1{\n\n                  width: calc(100% - 22.325rem);\n                margin-right: 19.975rem!important;\n            \n            }\n        }\n    }\n\n    [data-header-position=\"fixed\"][data-layout=\"horizontal\"] {\n        .dlabnav {\n            top: 5rem;\n        }\n\t\t.header{\n\t\t\theight: 5rem;\n\t\t\t&.is-fixed{\n\t\t\t\tborder-bottom:1px solid $border-color;\n\t\t\t}\n\t\t}\n\t\t.content-body {\n\t\t\tpadding-top: 5rem;\n\t\t}\n    } //ok\n\t[data-header-position=\"fixed\"][data-layout=\"horizontal\"] {\n\n    /* [data-header-position=\"fixed\"][data-sidebar-position=\"static\"] {\n\t\t.dlabnav {\n            top: 0rem;\n        }\n\t\t.content-body {\n\t\t\tpadding-top: 0rem;\n\t\t}\n\t} */\n        .dlabnav {\n            position: fixed;\n        }\n    } //ok\n\n    [data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-sidebar-position=\"fixed\"] {\n        .content-body {\n            padding-top: 10rem;\n        }\n    } //ok\n\t@include custommq($max:88.75rem) {\n\t\t[data-header-position=\"fixed\"][data-layout=\"horizontal\"] [data-sidebar-style=\"full\"]{\n\t\t\t.content-body {\n\t\t\t\tpadding-top: 14rem;\n\t\t\t}\n\t\t}\n\t\t\n\t\t\n\t}\n\t[data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-sidebar-position=\"fixed\"][data-sidebar-style=\"modern\"] {\n        .content-body {\n            padding-top: 13rem;\n        }\n    } //ok\n\t\n    [data-layout=\"horizontal\"][data-container=\"boxed\"] {\n\n        .footer {\n            margin-left: 0;\n            max-width: 74.9375rem;\n            margin: 0 auto;\n        }\n\t\t\n    }\n\n    [data-layout=\"horizontal\"][data-container=\"wide\"] {\n        .page-titles {\n            margin-left: -1.875rem;\n            margin-right: -1.875rem;\n\t\t\tdisplay:none;\n        }\n\t\t.header-banner{\n\t\t\tdisplay:none;\n\t\t}\n    }\n\n    [data-layout=\"horizontal\"][data-sidebar-style=\"modern\"] {\n\t\t .dlabnav {\n\t\t\t.header-profile{\n\t\t\t\tmargin-bottom:0;\n\t\t\t\timg{\n\t\t\t\t\theight: 3.75rem;\n\t\t\t\t\twidth: 3.75rem;\n\t\t\t\t\tmargin-bottom:0!important;\n\t\t\t\t}\n\t\t\t\t&>a.nav-link{\n\t\t\t\t\tborder:0.0625rem solid $border-color;\n\t\t\t\t\tpadding: 0.25rem 0.25rem;\n\t\t\t\t\tborder-radius:3rem;\n\t\t\t\t}\n\t\t\t} \n\t\t }\n\t}\n    [data-layout=\"horizontal\"][data-sidebar-style=\"compact\"] {\n        .page-titles {\n            margin-top: 0;\n        }\n        \n        .dlabnav {\n\t\t\t.header-profile{\n\t\t\t\tmargin-bottom:0;\n\t\t\t\timg{\n\t\t\t\t\theight: 3.75rem;\n\t\t\t\t\twidth: 3.75rem;\n\t\t\t\t\tmargin-bottom:0!important;\n\t\t\t\t}\n\t\t\t\t&>a.nav-link{\n\t\t\t\t\tborder:0.0625rem solid $border-color;\n\t\t\t\t}\n\t\t\t} \n            .metismenu {\n\t\n                &>li {\n                    &>ul {\n                        top: 5.1rem;\n                    }\n                    &>a {\n                        padding: 1.125rem 1.25rem 0.625rem 1.25rem;\n\n                        &::after {\n                            display: none;\n                        }\n\t\t\t\t\t\t.nav-text{\n\t\t\t\t\t\t\tmargin-top: 0.3125rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&>i{\n\t\t\t\t\t\t\twidth:auto;\n\t\t\t\t\t\t\tmargin:0;\n\t\t\t\t\t\t\theight:auto;\n\t\t\t\t\t\t\tline-height:1;\n\t\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t\t}\n                    }\n                    li {\n                        text-align: left;\n                    }\n                }\n            }\n        }\n    }\n\n    [data-sidebar-style=\"mini\"][data-layout=\"horizontal\"] {\n        .nav-header {\n            width: 7.75rem;\n\t\t\tpadding-left: 2.5rem;\n\t\t\tpadding-right: 2.5rem;\n\t\t\t\n\t\t\t    .brand-logo {\n\t\t\t\t    justify-content: start;\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\tpadding-right: 0;\n\t\t\t\t}\n        }\n    \n        .header {\n            width: 100%;\n            padding-left: 7.75rem;\n        }\n\n        .metismenu {\n            &>li {\n\t\t\t\ta{\n\t\t\t\t\twidth: auto;\n\t\t\t\t}\n                &:hover {\n                    a {\n                        .nav-text {\n                            display: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    [data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-sidebar-position=\"fixed\"][data-sidebar-style=\"compact\"] {\n        .content-body {\n            padding-top: 11.8rem;\n        }\n    }\n\n    [data-sidebar-position=\"fixed\"][data-layout=\"horizontal\"] {\n        .dlabnav.fixed {\n            position: fixed;\n\t\t\tpadding: 0 0.9375rem;\n            left: 0;\n            top: 0;\n\t\t\tborder-radius:0;\n\t\t\twidth:100%;\n        }\n    }\n    [data-sidebar-position=\"fixed\"][data-layout=\"horizontal\"] {\n        .wallet-open{\n            &.show{\n\n                &.active{\n\n                    .dlabnav-scroll{\n                        padding-right:352px;\n        \n                    }\n\t\t\t\t\t.content-body{\n\t\t\t\t\t\tpadding-top:13rem;\n\t\t\t\t\t\n\t\t\t\t\t}\n                }\n\n            }\n\n        }  \n\n    }\n}\n","////////////////\n// Compact Nav\n////////////////\n\n@media (min-width:47.9375rem) {\n    [data-sidebar-style=\"compact\"] {\n\t\t.nav-header {\n\t\t\twidth: 11.25rem;\n\t\t}\n\t\t.dlabnav .metismenu .has-arrow[aria-expanded=true]:after, .dlabnav .metismenu .mm-active > .has-arrow:after{\n\t\t\tmargin-right:0;\t\n\t\t}\n        .dlabnav {\n            .header-profile{\n\t\t\t\tmargin-bottom: 0.3125rem;\n\t\t\t\t&>a.nav-link{\n\t\t\t\t\tdisplay:block;\n\t\t\t\t\ttext-align:center;\n\t\t\t\t\tborder:0;\n\t\t\t\t\timg{\n\t\t\t\t\t\tmargin-bottom:0.3125rem;\n\t\t\t\t\t}\n\t\t\t\t\t.header-info{\n\t\t\t\t\t\tmargin-left:0!important;\n\t\t\t\t\t\ttext-align:center;\n\t\t\t\t\t\tsmall{\n\t\t\t\t\t\t\ttext-align:center!important;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.dropdown-menu{\n\t\t\t\t\tmin-width:11rem;\n\t\t\t\t}\n\t\t\t\ta svg{\n\t\t\t\t\tdisplay:unset!important;\n\t\t\t\t}\n\t\t\t}\n            .nav-user{\n                display: none;\n            }\n        \n            .metismenu {\n\t\t\t\n                li {\n                    text-align: center;\n                    a {\n                        padding: 0.7rem 0.5rem;\n\t\t\t\t\t\tsvg{\n\t\t\t\t\t\t\n\t\t\t\t\t\t\tmax-width: 1.3125rem;\n\t\t\t\t\t\t\tmax-height: 1.3125rem;\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\t\t\tmargin-right: auto;\t\n\t\t\t\t\t\t}\n\t\t\t\t\t\ti{\n\t\t\t\t\t\t\t@include transitionMedium;\n\t\t\t\t\t\t}\n                    }\n\t\t\t\t\tul:after{\n\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t& > a{\n\t\t\t\t\t\tbox-shadow: none;\n\t\t\t\t\t\tfont-size: 0.9375rem;\n\t\t\t\t\t}\n                }\n            }\n\t\t\t\n\t\t\t.plus-box,.copyright{\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t.copyright{\n\t\t\t    padding: 0 1.25rem;\n\t\t\t\tmargin-top: 1.25rem;\n\t\t\t}\n\t\t\t.header-info2{\n\t\t\t\tpadding:0;\t\n\t\t\t\timg{\n\t\t\t\t\tmargin-left:-1rem;\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t.sidebar-info{\n\t\t\t\tdisplay:none!important;\t\n\t\t\t}\n\t\t\t.header-profile2{\n\t\t\t\tmargin: 0 3rem;\t\n\t\t\t}\n\t\t\t.feature-box,\n\t\t\t.support-box{\n\t\t\t\tdisplay:none;\n\t\t\t}\n        }\n\n        .nav-text {\n            display: inline-block;\n            margin-top: 0.3125rem;\n        }\n\n        .nav-label {\n            &.first{\n                display: none;\n            }\n        }\n\n        .nav-badge {\n            display: none;\n        }\n\n        .footer {\n            padding-left: 0;\n\t\t\t\n\t\t\twidth:calc(100% - 37.225rem);\n        }\n\n        .content-body {\n           margin-left: 11.2rem;\n        }\n\t\t\n\t\t&[data-theme-version=\"dark\"]{\n\t\t\t&[data-layout=\"horizontal\"]{\n\t\t\t\t.dlabnav {\n\t\t\t\t\t.metismenu {\n\t\t\t\t\t\t li {\n\t\t\t\t\t\t\t&>a i{\n\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t }\n\t\t\t\t\t}\t\n\t\t\t\t}\n\t\t\t}\n            &[data-layout=\"vertical\"]{\n                .dlabnav {\n                    .metismenu {\n                         li {\n                             &>a i{\n                                //background:$d-bg;\n                               // color:#b3b3b3;\n                             }\n                             &.mm-active{\n                                 &>a i{\n                                   background:var(--primary);\n                                    color:$white;\n                                }\n                             }\n                         }\n                    }\n                }\n            }\n\t\t}\n\t\t&[data-layout=\"vertical\"]{\n\t\t\t.dlabnav {\n\t\t\t\t.metismenu {\n\t\t\t\t\t li {\n\t\t\t\t\t\t&:hover{\n\t\t\t\t\t\t\t&>a i{\n\t\t\t\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\t\n\t\t\t\t\t }\n\t\t\t\t}\t\n\t\t\t}\n\t\t}\n    }\n}\n[data-layout=\"horizontal\"][data-sidebar-style=\"compact\"] {\n\t.footer {\n\t\tpadding-left: 0;\n\t}\n\t.content-body {\n\t\tmargin-left:0;\n\t}\n\t.dlabnav{\n\t\tmargin-bottom:0;\n\t}\n\t.nav-header {\n\t\twidth: 13.25rem;\n\t}\n}\n[data-layout=\"vertical\"][data-sidebar-style=\"compact\"] {\n    .dlabnav {\n        width: 11.25rem;\n        \n        .metismenu {\n\t\t\n            ul{\n\t\t\t\tmargin-left:0;\n\t\t\t\tborder:0;\n\t\t\t\tbackground: rgba(0,0,0,0.02);\n\t\t\t\tpadding: 0.625rem 0;\n\t\t\t\t\n\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\tbackground:(255, 255, 255, 0.05);\n\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\ta{\n\t\t\t\t\t&:before{\n\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\tul a {\n\t\t\t\t\tpadding: 0.625rem 0.9375rem;\n\t\t\t\t\t\n\t\t\t\t}\n            }\n\n            &>li {\n\t\t\t\t&>a{\n\t\t\t\t\tpadding:1.2rem 0.5rem;\n\t\t\t\t}\n                &>a.has-arrow::after {\n                    top: 0.0625rem;\n\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\tright: auto;\n\t\t\t\t\tmargin-left: 0.3125rem;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\twidth: 0.4375rem;\n\t\t\t\t\theight: 0.4375rem;\n\t\t\t\t\tborder-width: 0.125rem 0rem 0rem 0.125rem;\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\tmargin-right: 0.3125rem;\n\t\t\t\t\t}\n                }\n\t\t\t\t&.mm-active {\n\t\t\t\t\t&>a {\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t\t\tcolor:var(--primary);\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\t//border-color:var(--primary);\n\t\t\t\t\t\t\t//border-color:$white;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\t\n            }\n        }\n\n    }\n}","@media (min-width: 47.9375rem) {\n\n    [data-sidebar-style=\"icon-hover\"][data-layout=\"horizontal\"] {\n\t\t.header .header-content {\n\t\t    padding-left: 1.875rem;\t\n\t\t}\n\t\t\n\t}\n\t\n\t\n\t\n    [data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"] {\n\t\t\n\t\t\n\t\t.dlabnav{\n\t\t\t.metismenu{\n\t\t\t\tli.mm-active{\n\t\t\t\t\t&>ul{\n\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.header-info2{\n\t\t\t\tjustify-content:space-between;\n\t\t\t\timg{\n\t\t\t\t\torder:1;\n\t\t\t\t\tmargin-right:0\n\t\t\t\t}\t\n\t\t\t}\n\t\t}\n\t\t.iconhover-toggle{\n\t\t\t.dlabnav{\n\t\t\t\t.metismenu{\n\t\t\t\t\tli.mm-active{\n\t\t\t\t\t\t&>ul{\n\t\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t\t\n        .nav-header {\n\t\t\twidth: 4.36rem;\n\t\t\tborder-radius: 0 0 0 0!important;\n            .brand-logo {\n\t\t\t\tpadding:0;\n\t\t\t\tpadding-left: 0.5rem;\n\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\tpadding-left:1.875rem;\n\t\t\t\t\tpadding-right:1.875rem;\n\t\t\t\t}\n                .logo-abbr {\n                    display: block;\n                }\n\n                .brand-title {\n                    display: none;\n                }\n            }\n\n            .nav-control {\n                display: none;\n            }\n        }\n\n        .header {\n            padding-left: 5rem;\n\n            @at-root [direction=\"rtl\"]#{&} {\n                padding-right: 7rem;\n                padding-left: 0.9375rem;\n            }\n\n            .header-content {\n                padding-left: 2rem;\n\t\t\t\tleft: 5rem;\n\t\t\t\twidth: auto;\n\t\t\t\tmargin-left: 0.8rem;\n\n                @at-root [direction=\"rtl\"]#{&} {\n                    padding-right: 1.375rem;\n                    padding-left: 0;\n                }\n            }\n        }\n\n        .dlabnav {\n            overflow: visible;\n            position: absolute;\n            left: -13.2rem;\n            // z-index: 1;\n\t\t\t\n\t\t\t@include custommq($min: 47.9375rem, $max: 87.5rem) {\n                left: -10rem;\n            }\n\n            @at-root [direction=\"rtl\"]#{&} {\n                left: auto;\n                right: -14.563rem;\n            }\n\n            .nav-label {\n                display: none;\n            }\n\t\t\t.header-profile{\n\t\t\t\timg{\n\t\t\t\t\torder:1;\n\t\t\t\t} \n\t\t\t\t.header-info{\n\t\t\t\t\tmargin-left:0!important;\n\t\t\t\t\tpadding-left:0!important;\n\t\t\t\t\tmargin-right:0.625rem;\n\t\t\t\t}\n\t\t\t} \n            .metismenu {\n                &>li {\n\t\t\t\t\tpadding: 0 1rem;\n                    &>a {\n                        display: flex;\n                        justify-content: space-between;\n\t\t\t\t\t\tfont-size: 0.938rem;\n\t\t\t\t\t\tborder-radius:$radius;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\n                        &>svg,\n                        &>i {\n                            order: 1;\n\t\t\t\t\t\t\tmargin-right:0;\n\t\t\t\t\t\t\tmargin-top:0;\n\t\t\t\t\t\t\tpadding-right: 0;\n\t\t\t\t\t\t\theight: auto;\n\t\t\t\t\t\t\twidth: auto;\n\t\t\t\t\t\t\tline-height: 1;\n\t\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\t\tpadding-left:0;\n\t\t\t\t\t\t\t\tpadding-right:0;\n\t\t\t\t\t\t\t}\n                        }\n\t\t\t\t\t\t\n                    }\n\t\t\t\t\t&:hover > a,\n\t\t\t\t\t&.mm-active > a{\n\t\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\ti{\n\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n                }\n\n                ul {\n\t\t\t\t\tborder-left: 0;\n\t\t\t\t\tpadding-left:0;\n\t\t\t\t\tpadding-right:0;\n\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\tpadding-right:0;\n\t\t\t\t\t\tpadding-left:0;\n\t\t\t\t\t}\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\tborder-color:$d-border;\n\t\t\t\t\t}\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tleft:auto;\n\t\t\t\t\t\tright:1.75rem;\n\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\tleft:1.75rem;\n\t\t\t\t\t\t\tright:auto;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n                    a {\n                        position: relative;\n\t\t\t\t\t\tpadding-left: 1.8rem;\n\t\t\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\t\t\t\tpadding-right: 1.25rem;\n\t\t\t\t\t\t}\n                        &::before {\n\t\t\t\t\t\t\tleft: 1.25rem;\n\t\t\t\t\t\t\tright: auto;\n\t\t\t\t\t\t\n                            @at-root [direction=\"rtl\"]#{&} {\n                                right: auto;\n                                left:-0.3125rem;\n                            }\n                        }\n                    }\n                }\n\n                .has-arrow {\n                    &::after {\n                        right: 5rem;\n\t\t\t\t\t\topacity:0;\n\t\t\t\t\t\t\n                        @at-root [direction=\"rtl\"]#{&} {\n                            right: auto;\n                            left: 5rem;\n                        }\n                    }\n                }\n            }\n\t\t\t\n\t\t\t.copyright,\n\t\t\t.support-box{\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t\t&.mm-show{\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t}\n\t\t\n\n        .iconhover-toggle{\n            .nav-header {\n                width: 17.5rem;\n\t\t\n                .brand-logo {\n                    padding-left: 1.6rem;\n    \n    \n                    .brand-title {\n                        display: block;\n                    }\n                }\n\t\t\t\t@include respond ('laptop'){\n\t\t\t\t\twidth:1rem;\n\t\t\t\t}\n            }\n\t\t\t&.mm-show{\n\t\t\t\tdisplay:block;\n\t\t\t}\n            .header {\n                padding-left: 4.38rem;\n\t\t\t\t\n\t\t\t\t@at-root [direction=\"rtl\"]#{&} {\n                    padding-right: 4.38rem;\n                    padding-left: 0.9375rem;\n                }\n            }\n\n            .dlabnav {\n                left: 0;\n\t\t\t\t//.metismenu > li > a > i{\n\t\t\t\t//\topacity:1;\n\t\t\t\t//}\n\t\t\t\t.metismenu .has-arrow:after{\n\t\t\t\t\topacity:1;\n\t\t\t\t}\n\n                @at-root [direction=\"rtl\"]#{&} {\n                    left: auto;\n                    right: 0;\n                }\n\t\t\t\t.support-box{\n\t\t\t\t\tdisplay:block;\n\t\t\t\t}\n            }\n        }\n\n        .content-body {\n            margin-left: 5.6rem;\n\n            @at-root [direction=\"rtl\"]#{&} {\n                margin-left: 0;\n                margin-right: 7rem;\n            }\n        }\n        .footer {\n            padding-left: 7rem;\n\n            @at-root [direction=\"rtl\"]#{&} {\n                margin-left: 0;\n                margin-right: 7rem;\n            }\n\t\t\t&.style-1{\n\t\t\t\twidth: calc(100% - 28.125rem);\n\t\t\t\tmargin-right: 20.675rem;\n\t\t\t}\n\t\t\t&.footer-outer{\n\t\t\t\twidth:calc(100% - 31.225rem);\n\t\t\t}\n\t\t\t&.style-2{\n\t\t\t\twidth:calc(100% - 9.325rem);\n\t\t\t}\n        }\n    }\n}","@media (min-width:47.9375rem) {\n    [data-sidebar-style=\"modern\"] {\n\n        .nav-header {\n            width: 10.625rem;\n\t\t\t.brand-logo{\n\t\t\t\t    justify-content: center;\n\t\t\t}\n        }\n        .dlabnav {\n\t\t\t.header-profile{\n\t\t\t\tmargin-bottom: 0.3125rem;\n\t\t\t\t&>a.nav-link{\n\t\t\t\t\tdisplay:block;\n\t\t\t\t\ttext-align:center;\n\t\t\t\t\tmargin: 0 -0.625rem 0.9375rem;\n\t\t\t\t\tpadding: 0.9375rem 0.625rem;\n\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\timg{\n\t\t\t\t\t\tmargin-bottom:0.3125rem;\n\t\t\t\t\t}\n\t\t\t\t\t.header-info{\n\t\t\t\t\t\tmargin-left:0!important;\n\t\t\t\t\t\ttext-align:center;\n\t\t\t\t\t\tsmall{\n\t\t\t\t\t\t\ttext-align:center!important;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tdisplay:none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n            .metismenu {\n\t\t\t\t\n                &>li {\n                    text-align: center;\n\t\t\t\t\t\n\t\t\t\t\t\n                    &>a {\n                        padding: 1.25rem 0.9375rem 1.25rem 0.9375rem;\n\t\t\t\t\t\tmargin: 0.125rem 0;\n                        // font-weight: 500;\n\t\t\t\t\t\t@include transitionMedium;\n\t\t\t\t\t\t\n\t\t\t\t\t\t\n                        &::after {\n                            display: none;\n                        }\n\n                        &:hover, \n                        &:focus, \n                        &:active, \n                        &.mm-active {\n                            &>a {\n                                background-color: var(--primary-dark);\n                            }\n                        }\n                    }\n\t\t\t\t\t&:hover,\n\t\t\t\t\t&.mm-active{\n\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t\t&>a{\n\t\t\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\t\t\ti{\n\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n                    li {\n                        text-align: left;\n\n                        @at-root [direction=\"rtl\"]#{&} {\n                            text-align: right;\n                        }\n                    }\n                }\n\n                li {\n\n                    a {\n                        padding: 0.625rem 0.9375rem 0.625rem 0.9375rem;\n\t\t\t\t\t\tfont-size:0.9375rem;\n                    }\n\t\t\t\t\tul:after{\n\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t}\n\n                    &>ul {\n                        height: auto !important;\n                    }\n                }\n                .nav-label{\n                    display: none;\n                }\n            }\n\n            .nav-label {\n                display: none;\n            }\n            \n\n            .nav-text {\n                display: block;\n                margin-top: 0.3125rem;\n            }\n\t\t\t.feature-box,\n\t\t\t.support-box,\n\t\t\t.copyright{\n\t\t\t\tdisplay:none;\n\t\t\t}\n        }\n\n        .footer {\n            padding-left: 11.9rem;\n        }\n        .content-body {\n            margin-left: 10.9rem;\n        }\n\t\t\n\t\t&[data-layout=\"horizontal\"]{\n\t\t\t.dlabnav {\n\t\t\t\t.metismenu {\n\t\t\t\t\t li {\n\t\t\t\t\t\t&>a i{\n\t\t\t\t\t\t\tpadding:0;\n\t\t\t\t\t\t\tmargin:0;\n\t\t\t\t\t\t}\n\t\t\t\t\t }\n\t\t\t\t}\t\n\t\t\t}\n\t\t}\n    }\n\n    [data-sidebar-style=\"modern\"][data-layout=\"vertical\"] {\n\t\t\n        .dlabnav {\n            width: 10.625rem;\n            left: 0;\n\t\t\t@at-root [direction=\"rtl\"]#{&} {\n\t\t\t\tleft: auto;\n\t\t\t\tright: 0;\n\t\t\t}  \n\t\t\t\n            .slimScrollDiv, \n            .dlabnav-scroll {\n                overflow: visible !important;\n            }\n        \n            .metismenu {\n\t\t\t\tpadding: 0.625rem 0.875rem;\n                &>li {\n                    &>a{\n\t\t\t\t\t\tpadding: 1.375rem 0.6em 0.9375rem;\n                        i{\n\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t\theight:auto;\n\t\t\t\t\t\t\twidth:auto;\n\t\t\t\t\t\t\tmargin:0;\n\t\t\t\t\t\t\tline-height:1;\n\t\t\t\t\t\t\tmargin-bottom: 0.3125rem;\n                        }\n                    }\n\n                    &>ul {\n                        display: none;\n                        padding: 1.875rem 0.9375rem;\n                    }\n                }\n\n                li {\n                    position: relative;\n\n                    a {\n                        padding:1rem 1rem;\n\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\tcontent:none;\n\t\t\t\t\t\t}\n                    }\n\n                    ul {\n                        position: absolute;\n                        left: 105%;\n                        top: 0;\n                        bottom: auto;\n                        background-color: $white;\n                        border: 0.0625rem solid $border;\n                        width: 12.5rem;\n                        // box-shadow: 0.125rem 0.1875rem 0.625rem 0rem rgba(119, 119, 119, 0.1);\n\t\t\t\t\t\t\n\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\t\tbackground:$dark-card;\n\t\t\t\t\t\t\tbox-shadow: 0rem 0rem 0.8125rem 0rem rgba(0, 0, 0, 0.1);\n\t\t\t\t\t\t}\n\n                        @at-root [direction=\"rtl\"]#{&} {\n                            left: auto;\n                            right: 105%;\n                        }\n                    }\n\n                    &:hover {\n                        &>ul {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\tleft: 100%;\n\t\t\t\t\t\t\tpadding: 1rem 0;\n\t\t\t\t\t\t\tmargin-left: 0;\n\t\t\t\t\t\t\tborder: 0;\n\t\t\t\t\t\t\tbox-shadow: 0.3125rem 0.3125rem 1.875rem 0rem rgba(20, 0, 30, 0.10);\n\t\t\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"]#{&} {\n\t\t\t\t\t\t\t\tbox-shadow: 0.3125rem 0.3125rem 1.875rem 0rem rgba(20, 0, 30, 0.10);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\n                            @at-root [direction=\"rtl\"]#{&} {\n                                left: auto;\n                                right: 100%;\n\t\t\t\t\t\t\t\tbox-shadow: -0.3125rem 0.3125rem 1.875rem 0rem rgba(20, 0, 30, 0.10);\n                            }  \n                        }\n                    }\n                }\n            }\n            \n\n            .nav-label {\n                display: none;\n            }\n\n            .nav-text {\n                display: block;\n                margin-top: 0;\n            }\n\t\t\t.header-profile2{\n\t\t\t\tpadding:0 2.5rem;\t\n\t\t\t}\n        }\n\t\t\n\t\t.nav-control{\n\t\t\tright: -4.25rem;\n\t\t}\n\t\t.header .header-content{\n\t\t\tpadding-left: 0rem;\n\t\t\tleft: 13.6rem;\n\t\t\twidth: calc(100% - 18.75rem);\n\t\t}\n\t\t\n        .menu-toggle {\n            .dlabnav,.nav-header {\n                left: -10.625rem;\n            }\n\t\t\t.header{\n\t\t\t\tpadding-left:0;\n\t\t\t}\n            .content-body {\n                margin-left: 0;\n            }\n        }\n    }\n\n    [data-sidebar-style=\"modern\"][data-layout=\"horizontal\"] {\n\t\t.nav-header {\n\t\t\twidth: 17.05rem;\n\t\t}\n\t\t.header {\n\t\t\t//padding-left: 21.75rem;\n\t\t}\n\t\t.footer,\n\t\t.content-body {\n\t\t\tmargin-left:0;\n\t\t\t\n\t\t\t&.footer-outer{\n\t\t\t\twidth: calc(100% - 25.225rem);\n\t\t\t\tmargin-left: 1.775rem!important;\n\n\t\t\t}\n\t\t\t&.style-2{\n\t\t\t\twidth: calc(100% - 3.225rem);\n\t\t\t\tmargin-left: 1.775rem!important;\n\t\t\t}\n\t\t\t&.style-1{\n\t\t\t\twidth: calc(100% - 22.225rem);\n\t\t\t\tmargin-left: 1.775rem!important;\n\t\t\t}\n\t\t}\n\t\t\n        .dlabnav {\n            .metismenu {\n\n\t\t\t\t\n                &>li {\n                    &>a {\n                        padding: 0.9375rem 1.5625rem 0.75rem 1.4625rem;\n\t\t\t\t\t\tmargin: 0 0.125rem;\n                    }\n\n                    &>ul {\n                        top: 4.8rem;\n                    }\n                }\n            }\n        }\n\t\t\n        &[data-container=\"boxed\"] {\n            .dlabnav {\n                .metismenu {\n    \n                    &>li {\n                        &>a {\n                            padding: 0.8125rem 1.25rem;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n[data-container=\"boxed\"],\n[data-container=\"wide-boxed\"]{\n\t&[data-layout=\"vertical\"],\n\t&[data-sidebar-style=\"modern\"]{\n\t\t.header{\n\t\t\t.header-content{\n\t\t\t\tpadding-left: 0rem;\n\t\t\t\twidth: calc(100% - 0.1rem);\n\t\t\t}\n\t\t}\n\t}\n}\n[data-container=\"wide-boxed\"]{\n\t.header-content{\n\t\tpadding-left: 5.2rem!important;\n\t}\n}\n\n[data-container=\"boxed\"][data-sidebar-style=\"modern\"][data-layout=\"horizontal\"]{\n    .header .header-content{\n            width:calc(100% - 16.7rem);\n\n    }\n    .content-body{\n\n        padding-top:15rem;\n    }\n\n} ","[data-sidebar-style=\"overlay\"] {\n\t&[data-layout=\"vertical\"]{\n\t\t.dlabnav {\n\t\t\tborder-radius:0 0 0 0!important;\n\t\t\t@include respond ('phone-land'){\n\t\t\t\tborder-radius:0 0 0 0!important;\n\t\t\t}\n\t\t}\n\t\t.nav-header {\n\t\t\tborder-radius:0;\n\t\t}\n\t\t.menu-toggle{\n\t\t\t.nav-header {\n\t\t\t\tborder-radius: 0 0 0 0;\n\t\t\t}\n\t\t}\n\t}\n    .dlabnav {\n        left: -100%;\n        @include transitionMedium;\n\t\t.metismenu{\n\t\t\t& > li {\n\t\t\t\tpadding: 0 1rem;\n\t\t\t\t& > a {\n\t\t\t\t\tfont-size: 0.938rem;\n\t\t\t\t\tpadding: 0.7375rem 1rem;\n\t\t\t\t\tcolor: #7f7184;\n\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\t-webkit-transition: all 0.5s;\n\t\t\t\t\t-ms-transition: all 0.5s;\n\t\t\t\t\ttransition: all 0.5s;\n\t\t\t\t\ti{\n\t\t\t\t\t\theight:auto;\n\t\t\t\t\t\twidth:auto;\n\t\t\t\t\t\tline-height:1;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&:hover > a{\n\t\t\t\t\tcolor:var(--primary);\n\t\t\t\t\ti{\n\t\t\t\t\t\tcolor:var(--primary);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.mm-active > a {\n\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\tcolor:$white;\n\t\t\t\t\ti{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t@include respond ('phone'){\n\t\t\t\t\tpadding:0rem 0.9375rem;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t\tul a{\n\t\t\t    padding-top: .5rem;\n\t\t\t\tpadding-bottom: .5rem;\n\t\t\t\tposition: relative;\n\t\t\t\tfont-size: 0.9375rem;\n\t\t\t\tpadding-left: 3.2rem;\n\t\t\t\t&:before{\n\t\t\t\t\tleft:1.5625rem;\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t\n\t\t}\n\t\t\n\t\t\n\t\t@at-root [direction=\"rtl\"]#{&} {\n            left: auto;\n            right: -100%;\n        }\n\t\t\n\t\t/* @include respond ('phone-land'){\n\t\t\t.metismenu{\n\t\t\t\t&>li{\n\t\t\t\t\t&>a{\n\t\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\t\tpadding: 0.75rem 0.875rem;\n\t\t\t\t\t\ti{\n\t\t\t\t\t\t\tfont-size:1.125rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:hover{\n\t\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tul li a{\n\t\t\t\t\tpadding-left:2.8rem;\n\t\t\t\t}\n\t\t\t}\n\t\t} */\n    }\n    .content-body {\n        margin-left: 0;\n    }\n    .nav-header {\n        position: absolute;\n        .hamburger.is-active {\n            left: 0;\n            .line {\n                background-color: var(--primary);\n\t\t\t\topacity: 1;\n            }\n        }\n    }\n    .menu-toggle {\n        .nav-header {\n            position: absolute;\n            left: auto;\n        }\n        .dlabnav {\n            left: 0;\n            @at-root [direction=\"rtl\"]#{&} {\n                left: auto;\n                right: 0;\n            }\n        }\n    }\n    .footer {\n        padding-left: 0;\n\t\t\n\t\t&.footer-outer{\n\t\t\twidth:calc(100% - 25.225rem);\n\t\t}\n\t\t&.style-2{\n\t\t\twidth:calc(100% - 3.925rem);\n\t\t}\n\t\t&.style-1{\n\t\t\twidth: calc(100% - 22.325rem);\n\t\t\tmargin-right: 20.475rem;\n\n\t\t}\n    }\n}\n\n[data-sidebar-style=\"overlay\"][data-header-position=\"fixed\"] {\n    .nav-header {\n        position: fixed;\n    }\n}\n\n[data-sidebar-position=\"fixed\"][data-header-position=\"fixed\"] {\n    .nav-header {\n        position: fixed;\n    }\n}","[data-sidebar-position=\"fixed\"][data-layout=\"vertical\"] {\n    .nav-header {\n        position: fixed;\n        // left: auto;\n        border-top-left-radius:0;\n        border-top-right-radius:0;\n    }\n\n    .dlabnav {\n        position: fixed;\n        // z-index: 0;\n        .dlabnav-scroll {\n            border-top-left-radius: 0rem;\n            border-top-right-radius: 0rem;\n        }\n\t\tborder-bottom-left-radius: 0;\n\t\tborder-bottom-right-radius: 0;\n    }\n\n    .menu-toggle {\n        .dlabnav {\n            position: fixed;\n        }\n    }\n}\n[data-layout=\"vertical\"]{\n\t.nav-header {\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n    }\n\n    .dlabnav {\n\t\tborder-bottom-left-radius: 0;\n\t\tborder-bottom-right-radius: 0;\n    }\n}\n[data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"][data-container=\"wide-boxed\"],\n[data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"][data-container=\"boxed\"],\n[data-header-position=\"fixed\"][data-sidebar-position=\"fixed\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"][data-container=\"wide-boxed\"],\n[data-header-position=\"fixed\"][data-sidebar-position=\"fixed\"][data-sidebar-style=\"icon-hover\"][data-layout=\"vertical\"][data-container=\"boxed\"],\n[data-sidebar-style=\"overlay\"][data-layout=\"vertical\"][data-container=\"wide-boxed\"],\n[data-sidebar-style=\"overlay\"][data-layout=\"vertical\"][data-container=\"boxed\"],\n[data-header-position=\"fixed\"][data-sidebar-position=\"fixed\"][data-sidebar-style=\"overlay\"][data-layout=\"vertical\"][data-container=\"wide-boxed\"],\n[data-header-position=\"fixed\"][data-sidebar-position=\"fixed\"][data-sidebar-style=\"overlay\"][data-layout=\"vertical\"][data-container=\"boxed\"] {\n    .dlabnav {\n        position: absolute;\n    }\n}\n\n\n",".sidebar-right-trigger{\n\tposition: absolute;\n\tz-index: 9;\n\ttop: 14.75rem;\n\tright: 100%;\n\tbackground-color: var(--primary);\n\tcolor: $white;\n\tdisplay: inline-block;\n\theight: 3rem;\n\twidth: 3rem;\n\ttext-align: center;\n\tfont-size: 1.75rem;\n\tline-height: 3rem;\n\tborder-radius: 0.3125rem 0 0 0.3125rem;\n\t\n\t@at-root [data-theme-version=\"dark\"] #{&} {\n\t\tcolor: $white;\n\t}\n\t@include custommq ($max:64rem){\n\t\tdisplay:none;\n\t}\n\t&:hover{\n\t\tcolor:$white;\t\n\t}\n}\n\n.sidebar-right {\n    right: -50rem;\n    position: fixed;\n    top: 0;\n    width: 50rem;\n    background-color: $white;\n    margin-top: 3.5rem;\n    transition: all .5s ease-in-out;\n\tborder-radius: $radius;\n\tz-index: 9999;\n\t\n\t.note-text{\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tpadding: 20px;\n\t\topacity: 0.7;\n\t\tfont-size: 12px;\n\t\t\n\t}\n\t.bg-label-pattern{\n\t\tbackground: transparent;\n\t\tbackground-image: url('../images/pattern/pattern5.png');\n\t\tbackground-size: 130%;\n\t}\n\t.bootstrap-select{\n\t\theight:3rem;\n\t\tborder-radius: 0.375rem;\n\t\t.btn{\n\t\t    padding:0.75rem 0.9375rem;\n\t\t\tfont-size:0.9375rem;\n\t\t\tborder-color:#d1d1d1;\n\t\t\tborder-radius: 0.375rem;\n\t\t}\n\t}\n\t\n    .slimScrollDiv {\n        @at-root [direction=\"rtl\"] #{&} {\n            overflow: visible !important;\n        }\n    }\n    \n\t.sidebar-close-trigger{\n\t\tposition:absolute;\n\t\tz-index: 2;\n\t\tfont-size: 1.75rem;\n\t\ttop:0;\n\t\tright:-3rem;\n\t\theight: 3rem;\n        width: 3rem;\n\t\tline-height:3rem;\n\t\ttext-align:center;\n\t\tbackground:rgba($black,1);\n\t\tcolor:$white;\n\t}\n\t\n\n    &.show {\n        right: 5.25rem;\n\t\tbox-shadow: 0rem 0rem 3.125rem rgba(0 ,0 ,0 ,0.2);\n        z-index: 9999;\n\t\t\n\t\t.bg-overlay{\n\t\t\tposition:fixed;\n\t\t\twidth:100%;\n\t\t\tcursor:pointer;\n\t\t\theight:100%;\n\t\t\ttop:0;\n\t\t\tleft:0;\n\t\t\tbackground:rgba($black,0.2);\n\t\t}\n    }\n\t.card-tabs{\n\t\t.nav-tabs {\n\t\t\tjustify-content: space-between;\n\t\t\tposition: sticky;\n\t\t\ttop: 0;\n\t\t\twidth:100%;\n\t\t\tbackground-color: $white;\n\t\t\tz-index: 2;\n\t\t\tborder-bottom: 4px solid var(--rgba-primary-1);\n\t\t\t@at-root [data-theme-version=\"dark\"] #{&} {\n\t\t\t  \n\t\t\t}\n\t\t\t\n\n\t\t\t.nav-item {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\tflex: 1;\n\n\t\t\t\t.nav-link {\n\t\t\t\t\tborder: 0;\n\t\t\t\t\tfont-size: 1.125rem;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\tbackground-color: $white; \n\t\t\t\t\tborder-radius:0;\n\t\t\t\t\tmargin:0;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] #{&} {\n\t\t\t\t\t   \n\t\t\t\t\t}\n\n\t\t\t\t\t&.active {\n\t\t\t\t\t\t\n\t\t\t\t\t\t@at-root [data-theme-version=\"dark\"] #{&} {\n\t\t\t\t\t\t\tborder-right: none;\n\t\t\t\t\t\t\tborder-left: none;\n\t\t\t\t\t\t\tborder-top: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tbackground: var(--rgba-primary-1);\n\t\t\t\t\t\tcolor: #000;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.sidebar-right-inner > h4{\n\t\t\tpadding: 0.625rem 1.25rem;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\tcolor: $black;\n\t\t\tbackground: $white;\n\t\t\tmargin: 0rem 0rem 0rem 0rem;\n\t}\n\n    .tab-content {\n        padding: 1.25rem 1.25rem 0;\n\t\tmin-height: 480px;\n\t\tbackground:$white;\n        .tab-pane {\n\n            .admin-settings {\n\t\t\t\t.row > div {\n\t\t\t\t\tmargin-bottom: 1.25rem;\n\t\t\t\t}\n                p {\n                    color: #353535;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\tmargin-bottom: 0.5rem;\n\t\t\t\t\tfont-size: 1rem;\n                }\n\n                //All color switcher scss goes here\n                input[type=\"radio\"] {\n                    display: none;\n\n                    + label {\n                        display: inline-block;\n                        width: 2.1875rem;    \n                        height: 2.1875rem;\n                        cursor: pointer;\n                        transition: all .1s ease;\n\t\t\t\t\t\tborder-radius: 0.25rem;\n\t\t\t\t\t\tmargin-right: 0.3125rem;\n\t\t\t\t\t\tmargin-bottom: 0.1875rem;\n                    }\n\n                    &:checked {\n                        + label {\n                            position: relative;\n\n                            &::after {\n                                height: 2.0625rem;\n                                width: 2.0625rem;\n                                left: -0.25rem;\n                                top: -0.25rem;\n                                content: \"\";\n                                position: absolute;\n                                background-color: inherit;\n\t\t\t\t\t\t\t\tborder-radius: 0.375rem;\n\t\t\t\t\t\t\t\topacity: 0.4;\n                            }\n                        }\n                    }\n                }\n            }\n\n        }\n    }\n\n   \n    #nav_header, \n    #header, \n    #sidebar,\n\t#primary{\n\n\n        @each $name, $color in $theme_backgrounds {\n            &_#{$name} {\n                + label {\n                    background-color: $color;            \n                }\n            }\n        }\n\n        &_color_1 {\n            + label {\n                border: 0.0625rem solid #c4c4c4;\n            }\n        }\n    }\n\t\n\t&.style-1{\n\t\theight:100vh;\n\t\twidth:15.625rem;\n\t\tmargin-top:0;\n\t\tright:-15.625rem;\n\t\t.sidebar-right-inner{\n\t\t\tbackground:$white;\n\t\t}\n\t\t.sidebar-right-trigger {\n\t\t\ttop:12.4rem;\n\t\t}\n\t\t&.show{\n\t\t\tright:0;\n\t\t\t.sidebar-right-trigger{\n\t\t\t\tdisplay:block;\n\t\t\t}\n\t\t}\n\t}\n}\n.nice-select.wide{\n\tline-height: 2.8125rem;\t\n}\n\n@keyframes bounce {\n\t0% {\n        transform: translateX(-8%);;\n        -webkit-transform: translateX(-8%);; \n        }\n\t50% {\n        transform: translateX(8%);;\n        -webkit-transform: translateX(8%);; \n        }\n\t100% {\n        transform: translateX(-8%);; \n        -webkit-transform: translateX(-8%);; \n        }\n}\n\n@-webkit-keyframes bounce {\n\t0% {\n        transform: translateX(-8%);;\n        -webkit-transform: translateX(-8%);; \n        }\n\t50% {\n        transform: translateX(8%);;\n        -webkit-transform: translateX(8%);; \n        }\n\t100% {\n        transform: translateY(-8%);; \n        -webkit-transform: translateY(-8%);; \n        }\n}\n.nice-select.wide{\n\t@include respond ('laptop'){\n\t\tline-height:2rem;\n\t}\n}","///////////////////////////\n// Sidebar profile\n///////////////////////////\n.nav-user {\n    // text-align: center;\n    background: var(--primary);\n    margin-bottom: 0.625rem;\n    padding: 1.25rem 1.5625rem 0.9375rem;\n    @include custommq($min: 48rem, $max: 74.9375rem) {\n        padding: 1.25rem 0.9375rem 0.9375rem;\n    }\n    img {\n        width: 2.1875rem;\n        height: 2.1875rem; \n        @include custommq($min: 48rem, $max: 74.9375rem) {\n            width: 2.1875rem;\n            height: 2.1875rem;\n            margin-bottom: 0.625rem;\n        }\n    }\n    h5 {\n        margin-left: 0.625rem;\n        margin-bottom: 0.1875rem;\n        color: $white;\n        @include custommq($min: 48rem, $max: 74.9375rem) {\n            display: none;\n        }\n        @at-root [data-sibebarbg=\"color_2\"] & {\n            color: $white;\n        }\n    } \n    p{\n        margin-left: 0.625rem;\n        margin-bottom: 0.5rem;\n        color: #afcff7;\n        @include custommq($min: 48rem, $max: 74.9375rem) {\n            display: none;\n        }\n    }\n\n    @include custommq($min: 48rem, $max: 74.9375rem) {\n        i{\n            margin-top: 0.9375rem;\n            display: block\n        }\n    }    \n}\n\n\n\n\n\n.menu-toggle{\n    .nav-user {\n        padding: 1.25rem 0.9375rem 0.9375rem;\n        img {\n            width: 2.1875rem;\n            height: 2.1875rem;\n            margin-bottom: 0.625rem;\n        }\n        h5,\n        p {\n            display: none;\n        }\n        i {\n            margin-top: 0.9375rem;\n            display: block\n        }\n        .dropdown-menu {\n            left: 2.8125rem !important;\n            top: 1.375rem !important;\n        }\n    }\n}\n\n",".chatbox{\n\twidth:21.25rem;\n\theight:100vh;\n\tposition:fixed;\n\tright:-31.25rem;\n\ttop:0;\n\tz-index: 1004;\n\tbackground:#fff;\n\tbox-shadow: 0rem 0rem 1.875rem 0rem rgba(82, 63, 105, 0.15) ;\n\t@include transitionSlow;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground:$dark-card;\n\t}\t\n\t.chatbox-close{\n\t\tposition: absolute;\n\t\t@include transitionFast;\n\t\twidth: 0;\n\t\theight: 100%;\n\t\tright: 21.25rem;\n\t\tbackground: #000;\n\t\tz-index: 1;\n\t\topacity: 0.1;\n\t\tcursor:pointer;\n\t}\n\t.card-fotter {\n\t\tpadding: 0.75rem 1rem;\t\n\t}\n\t.card-body {\n\t\tpadding: 1rem;\n\t}\n\t&.active{\n\t\tright:0;\n\t\t\n\t\t.chatbox-close{\n\t\t\twidth: 100vw;\n\t\t}\n\t}\n\t.type_msg {\n\t\tpadding-top: 0.625rem;\n\t\t.input-group{\n\t\t\talign-items: center;\n\t\t}\n\t}\n\t.nav{\n\t    padding: 1rem 1rem 0 1rem;\n\t\tbackground:var(--rgba-primary-1);\n\t\tborder: 0;\n\t\tjustify-content: space-between;\n\t\t\t\n\t\t.nav-link{\n\t\t\tcolor: var(--primary);\n\t\t\topacity: 0.7;\n\t\t\ttext-transform: uppercase;\n\t\t\t&:hover,\t\n\t\t\t&.active{\n\t\t\t\tbackground:transparent;\n\t\t\t\tcolor: var(--primary);\n\t\t\t\topacity: 1;\n\t\t\t\tborder-color: var(--primary);\n\t\t\t}\n\t\t}\n\t}\n\t.img_cont{\n\t\twidth: 2.5rem;\n\t\tborder-radius: 2.5rem;\n\t\tmargin-right: 0.625rem;\n\t\tposition: relative;\n\t\theight: 2.5rem;\n\t\tbackground: #eee;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tfont-weight: 600;\n\t\tfont-size: 0.875rem;\n\t\tmin-width: 2.5rem;\n\t\tmin-height: 2.5rem;\n\t\t\n\t\t.icon{\n\t\t\tcolor:#fff;\n\t\t}\n\t\t&.primary{\n\t\t\tbackground:var(--rgba-primary-1);\n\t\t\tcolor:var(--primary);\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground:var(--rgba-primary-1);\n\t\t\t}\t\n\t\t}\n\t\t&.warning{\n\t\t\tbackground:$warning-light;\n\t\t\tcolor:$warning;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground:$warning-opacity;\n\t\t\t}\t\n\t\t}\n\t\t&.success{\n\t\t\tbackground:$success-light;\n\t\t\tcolor:$success;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground:$success-opacity;\n\t\t\t}\t\n\t\t}\n\t\t&.info{\n\t\t\tbackground:$info-light;\n\t\t\tcolor:$info;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground:$info-opacity;\n\t\t\t}\t\n\t\t}\n\t\t\n\t\timg{\n\t\t\twidth:100%;\n\t\t}\n\t\t.online_icon{\n\t\t\t    background: $success;\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 0.75rem;\n\t\t\t\theight: 0.75rem;\n\t\t\t\tborder-radius: 0.9375rem;\n\t\t\t\tright: -0.0625rem;\n\t\t\t\tbottom: 0rem;\n\t\t\t\tborder: 0.125rem solid #fff;\n\t\t\t\t//box-shadow: 0.3125rem 0.3125rem 0.625rem 0rem rgba($success, 0.3);\n\t\t\t\n\t\t\t&.offline{\n\t\t\t\tbackground:$danger;\n\t\t\t\t//box-shadow: 0.3125rem 0.3125rem 0.625rem 0rem rgba($danger, 0.3);\n\t\t\t}\n\t\t}\n\t\t.online_icon{\n\t\t\n\t\t\t\n\t\t\n\t\t}\n\t}\n\t.card{\n\t\tbox-shadow:none;\n\t}\n\t.search{\n\t\theight:2.5rem;\n\t}\n\t.user_info{\n\t\tspan{\n\t\t\tfont-size: 0.9375rem;\n\t\t\tcolor: #000;\n\t\t\tdisplay: block;\n\t\t\tfont-weight: 500;\n\t\t\tline-height: 1;\n\t\t\tmargin-bottom: 0.3125rem;\n\t\t\ttext-overflow: ellipsis;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t\tdisplay: block;\n\t\t\tmax-width: 10.625rem;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\t\n\t\tp{\n\t\t\tfont-size:0.8125rem;\n\t\t\tmargin-bottom:0;\n\t\t\tline-height: 1;\n\t\t\ttext-overflow: ellipsis;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t\tdisplay: block;\n\t\t\tmax-width: 10.625rem;\n\t\t}\n\t}\n\t.contacts{\n\t\tli{\n\t\t\tpadding: 0.4375rem 1rem;\n\t\t\tborder-bottom: 0.0625rem solid #eee;\n\t\t\tcursor: pointer;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tborder-color: $d-border;\n\t\t\t}\n\t\t\t& > div{\n\t\t\t\tdisplay:flex;\n\t\t\t\talign-items:center;\n\t\t\t}\n\t\t\t&:hover{\n\t\t\t\tbackground:#f4f7ff;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground-color: $d-bg;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.name-first-letter{\n\t\t\tbackground: $body-bg;\n\t\t\tpadding: 0.25rem 1rem;\n\t\t\tfont-weight: 700;\n\t\t\tcolor: #000;\n\t\t\tposition: sticky;\n\t\t\ttop: 0;\n\t\t\tz-index: 1;\n\t\t\t\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tcolor: $white;\n\t\t\t\tbackground:$d-bg;\n\t\t\t}\n\t\t}\n\t}\n\t.msg_card_body{\n\t\theight: calc(100vh - 195px);\n\t}\n\t.contacts_body{\n\t\theight: calc(100vh - 120px);\n\t}\n\t.card-header{\n\t\tbackground:#f4f7ff;\n\t\tpadding: 0.9375rem 1.25rem;\n\t\tjustify-content: center;\n\t\th6{\n\t\t\tfont-size:0.9375rem;\n\t\t}\n\t\tp{\n\t\t\tline-height:1.2;\n\t\t\tfont-size:0.75rem;\n\t\t\tcolor: $body-color;\n\t\t}\n\t}\n\t.chat-list-header{\n\t\tjustify-content: space-between;\n\t\tbackground: #fff;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground: $dark-card;\n\t\t}\t\t\t\t\t\n\t\ta{\n\t\t\ttext-align: center;\n\t\t\twidth: 1.875rem;\n\t\t\theight: 1.875rem;\n\t\t\tbackground: $body-bg;\n\t\t\tborder-radius: 0.375rem;\n\t\t\tline-height: 1.675rem;\n\t\t\tdisplay: block;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground:var(--rgba-primary-1);\n\t\t\t\tsvg g [fill]{\n\t\t\t\t\tfill:$white;\n\t\t\t\t}\n\t\t\t}\t\n\t\t}\n\t}\n\t.img_cont_msg {\n\t\twidth: 1.875rem;\n\t\theight: 1.875rem;\n\t\tdisplay: block;\n\t\tmax-width: 1.875rem;\n\t\tmin-width: 1.875rem;\n\t\t\n\t\timg{\n\t\t\twidth:100%;\n\t\t}\n\t}\n\t.msg_cotainer {\n\t\tbackground: var(--primary);\n\t\tmargin-left: 0.625rem;\n\t\tborder-radius: 0 $radius $radius $radius;\n\t\tpadding: 0.625rem 0.9375rem;\n\t\tcolor:#fff;\n\t\tposition:relative;\n\t\t.msg_time{\n\t\t\tdisplay: block;\n\t\t\tfont-size: 0.6875rem;\n\t\t\tcolor: #fff;\n\t\t\tmargin-top: 0.3125rem;\n\t\t\topacity: 0.5;\n\t\t}\n\t\t&:after{\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: -0.625rem;\n\t\t\tborder-right: 0.625rem solid var(--primary);\n\t\t\tborder-bottom: 0.625rem solid transparent;\n\t\t\tborder-top: 0rem solid;\n\t\t\ttop: 0;\n\t\t}\n\t}\n\t.msg_cotainer_send {\n\t\tbackground: $body-bg;\n\t\tpadding: 0.625rem 0.9375rem;\n\t\tborder-radius: 0.375rem 0rem 0.375rem 0.375rem;\n\t\tmargin-right: 0.625rem;\n\t\tcolor: #222;\n\t\tposition: relative;\n\t\ttext-align: right;\n\t\t\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground:$d-bg;\n\t\t\tcolor:$white;\n\t\t}\t\n\t\t\n\t\t.msg_time_send {\n\t\t\tdisplay: block;\n\t\t\tfont-size: 0.6875rem;\n\t\t\ttext-align: right;\n\t\t\tmargin-top: 0.3125rem;\n\t\t\topacity: 0.6;\n\t\t}\n\t\t&:after{\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tright: -0.625rem;\n\t\t\tborder-left: 0.625rem solid $body-bg;\n\t\t\tborder-bottom: 0.625rem solid transparent;\n\t\t\tborder-top: 0rem solid;\n\t\t\ttop: 0;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tborder-left: 0.625rem solid $d-bg;\n\t\t\t}\t\n\t\t}\n\t}\n\t.type_msg{\n\t\t.form-control{\n\t\t\tpadding: 0.625rem 14px;\n\t\t\theight: 3.125rem;\n\t\t\tborder: 0;\n\t\t\tresize: none;\n\t\t\tline-height: unset;\n\t\t\t&:focus{\n\t\t\t\tz-index:0;\n\t\t\t}\n\t\t}\n\t\t.btn{\n\t\t\tfont-size: 1.125rem;\n\t\t\tborder-radius: 2.375rem !important;\n\t\t\twidth: 2.375rem;\n\t\t\theight: 2.375rem;\n\t\t\tpadding: 0;\n\t\t\tmargin-top: -22px;\n\t\t\tline-height: 1px;\n\t\t}\n\t} \n\t.video_cam{\n\t\tmargin-left:0.9375rem;\n\t\tspan{\n\t\t\twidth: 2.1875rem;\n\t\t\theight: 2.1875rem;\n\t\t\tbackground: #10ca93;\n\t\t\ttext-align: center;\n\t\t\tline-height: 2.1875rem;\n\t\t\tborder-radius: 2.1875rem;\n\t\t\tcolor: #fff;\n\t\t\tmargin-right: 0.3125rem;\n\t\t\talign-self: center;\n\t\t\tfont-size: 1rem;\n\t\t\tpadding: 0 0.1875rem;\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\t.note_card{\n\t\t.contacts li{\n\t\t\tpadding: 0.75rem 1rem;\n\t\t}\n\t}\n}\n@include custommq($max: 36rem) {\n\t.chatbox{\n\t\twidth: 17.5rem;\n\t\t.chatbox-close{\n\t\t\tright: 17.5rem\n\t\t}\n\t}\n}\n\n.bd-highlight {\n\ta.sharp{\n\t\tmargin-bottom: 0.5rem;\n\t\tdisplay: inline-block;\n\t}\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","// @import \"../../abstracts/variable\";\n\n.dlab-demo-panel {\n    // display: none;\n    right: -23.75rem;\n    position: fixed;\n    top: 0;\n    width: 23.75rem;\n    background-color: $white;\n    height: 100vh;\n    transition: all .5s ease-in-out;\n\tz-index: 9999;\n    .dlab-demo-trigger {\n        position: absolute;\n\t\tz-index: 9;\n\t\ttop: 21.75rem;\n\t\tright: 100%;\n\t\tbackground-color: #627EEA;\n\t\tcolor: #fff;\n\t\tdisplay: inline-block;\n\t\theight: 3rem;\n\t\twidth: 3rem;\n\t\ttext-align: center;\n\t\tfont-size: 1.75rem;\n\t\tline-height: 3rem;\n\t\tborder-radius: 0.3125rem 0 0 0.3125rem;\n\t\tbox-shadow: -0.3125rem 0.1875rem 0.3125rem 0rem rgba(119, 119, 119, 0.15);\n\t\t\n        @include custommq($max: 63.9375rem){\n            display:none;\n        }\n    }\n\t.dlab-demo-close{\n\t\theight:1.875rem;\n\t\tcolor:$white;\n\t\twidth:1.875rem;\n\t\tborder-radius:$radius;\n\t\tbackground:rgba($black,0.5);\n\t\tline-height:1.875rem;\n\t\ttext-align:center;\n\t}\n    &.show {\n        right: 0;\n\t\tbox-shadow: 0rem 0rem 3.125rem rgba(0 ,0 ,0 ,0.2);\n        z-index: 99999;\n\t\toverflow:hidden;\n\t\t.sidebar-right-trigger{\n\t\t\tdisplay:none;\n\t\t}\n\t\t.bg-close{\n\t\t\tposition:fixed;\n\t\t\tz-index: -2;\n\t\t\tcursor:pointer;\n\t\t\twidth:100%;\n\t\t\theight:100%;\n\t\t\ttop:0;\n\t\t\tleft:0;\n\t\t\tbackground:rgba($black,0.15);\n\t\t}\n    }\n\t.dlab-demo-inner{\n\t\tpadding: 1.875rem 1.875rem;\n\t\tbackground:$white;\n\t}\n\t.dlab-demo-content{\n\t\theight: calc(100vh - 210px);\n\t}\n\t.dlab-demo-header{\n\t\tdisplay:flex;\n\t\tjustify-content:space-between;\n\t\talign-items:center;\n\t\tmargin-bottom: 1.25rem;\n\t\th4{\n\t\t\tmargin-bottom:0;\n\t\t\tcolor:$black;\n\t\t}\n\t}\n\t.dlab-demo-bx{\n\t\theight:12.5rem;\n\t\toverflow:hidden;\n\t\tborder:0.3125rem solid #efefef;\n\t\tbox-shadow:0rem 0rem 0.3125rem rgba(0,0,0,0.1);\n\t\tmargin-bottom: 0.625rem;\n\t\tborder-radius:$radius;\n\t\t&.demo-active{\n\t\t\tborder-color:$secondary;\n\t\t\t.overlay-layer{\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n\t.overlay-bx{\n\t\tposition:relative;\n\t\t.overlay-layer{\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-pack: center;\n\t\t\t-ms-flex-pack: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tbackground-color: rgba(0,0,0,.1);\n\t\t\t-webkit-transition: all .3s ease;\n\t\t\ttransition: all .3s ease;\n\t\t\topacity: 0;\n\t\t}\n\t\t&:hover{\n\t\t\t.overlay-layer{\n\t\t\t\t-webkit-transition: all .3s ease;\n\t\t\t\ttransition: all .3s ease;\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n",":root{\n\t--right-space:23.75rem;\n}\n.wallet-open{\n\t.header{\n\t\t.page-titles,\n\t\t.header-content{\n\t\t\tpadding-right: 1.875rem;\n\t\t\t@include transitionMedium;\n\t\t\t@include respond ('phone-land'){\n\t\t\t\tpadding-right: 1.4rem;\n\t\t\t}\n\t\t\t@include respond ('phone'){\n\t\t\t\tpadding-right: 1.1rem;\n\t\t\t}\n\t\t}\n\t}\n\t\n\t.content-body{\n\t\tpadding-right: 0;\n\t\t@include transitionMedium;\n\t}\n\t.wallet-bar {\n\t\tright: -26.25rem;\n\t}\n\n\t&.active{\n\t\t.header{\n\t\t\t.page-titles,\n\t\t\t.header-content{\n\t\t\t\tpadding-right: var(--right-space);\n\t\t\t\t@include respond('laptop'){\n\t\t\t\t\tpadding-right: 4.775rem;\n\t\t\t\t\t\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t@include respond ('phone'){\n\t\t\t\t\tpadding-right: 12px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.content-body{\n\t\t\tpadding-right: calc(var(--right-space) - 1.75rem);\n\t\t\t@include transitionMedium;\n\t\t\t@include respond ('laptop'){\n\t\t\t\tpadding-right: 0;\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t\t.wallet-bar {\n\t\t\tright: 0rem;\n\t\t}\n\t\t.wallet-bar-close{\n\t\t\tposition: fixed;\n\t\t\twidth: 100%;\n\t\t\tcursor: pointer;\n\t\t\theight: 100%;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tbackground: rgba(0, 0, 0, 0.2);\n\t\t\tdisplay:none;\n\t\t\tz-index: 1;\n\n\t\t\t@include respond ('laptop'){\n\n\t\t\t\tdisplay:block;\n\t\t\t\tz-index: 3;\n\t\t\t}\n\t\t\t@include respond ('phone'){\n\t\t\t\tz-index:3;\n\t\t\t}\n\t\t}\n\t} \n}\n.wallet-bar {\n    position: fixed;\n\tbox-sizing: content-box;\n    width: 22rem;\n\tpadding: 2.375rem 15px;\n\tpadding-top:0.375rem ;\n\tpadding-bottom: 0;\n\t@include transitionMedium;\n\ttop: 0px;\n    z-index: 999;\n    height:100%;\n\tscrollbar-width: none;\n\tbox-sizing: border-box;\n\t@include respond ('laptop'){\n\t\twidth: 23rem;\n\t}\n\t@include respond ('phone-land'){\n\t\tbackground:rgba(0,0,0,0.2);\n\t\tbackdrop-filter:blur(5px);\n\t\tbox-shadow:0 0 50px 0 rgba(0,0,0, 0.25);\n\t\theight:100vh;\n\t\toverflow-y:scroll;\n\t}\n\t.closed-icon{\n\t\theight:25px;\n\t\twidth:25px;\n\t\tcolor: $main-color;\n\t\tfont-size:20px;\n\t\tdisplay: block;\n\t\tmargin-bottom: 17px;\n\t\tcursor:pointer;\n\t\tdisplay:none;\n\t\t@include respond ('phone'){\n\t\t\tdisplay:block;\n\t\t}\n\t}\n}","\t:root{\n\t--nav-headbg: #fff;\n\t--sidebar-bg: #fff;\n\t--headerbg: #E6EBEE;\n}\n\n//background for nav header\n@each $name, $color in $theme_backgrounds {\n\t[data-nav-headerbg=\"#{$name}\"][data-theme-version=\"dark\"],\n    [data-nav-headerbg=\"#{$name}\"] {\n        @if $name != \"color_1\"  {\n\t\t\t--nav-headbg: #{$color};\n\t\t\t.nav-header{\n\t\t\t\t.brand-logo{\n\t\t\t\t\t.logo-abbr{\n\t\t\t\t\t\tpath{\n\t\t\t\t\t\t\tfill:$white;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.brand-title{\n\t\t\t\t\t\tsvg{\n\t\t\t\t\t\t\tpath{\n\t\t\t\t\t\t\t\tfill:$white;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t}\n\t\t\t\t.hamburger .line{\n\t\t\t\t\tbackground:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n//background for nav header\n@each $name, $color in $theme_backgrounds {\n\t[data-sidebarbg=\"#{$name}\"][data-theme-version=\"dark\"],\n    [data-sidebarbg=\"#{$name}\"] {\n        @if $name != \"color_1\"  {\n\t\t\t--sidebar-bg: #{$color};\n\t\t\t.dlabnav{\n\t\t\t\tborder-color:$color;\t\t\n\t\t\t}\n\t\t\t.dlabnav .metismenu > li:after{\n\t\t\t\tbackground:$white!important;\n\t\t\t}\n\t\t\t.menu-toggle .dlabnav .metismenu li > ul{\n\t\t\t\tbackground:$color!important;\n\t\t\t}\n\t\t\t.dlabnav .metismenu ul a:before{\n\t\t\t\tbackground:rgba($white,0.5);\n\t\t\t}\n\t\t\t.dlabnav .header-info2{\n\t\t\t\tborder-color:rgba($white,0.2)!important;\t\t\n\t\t\t}\n\t\t\t\n\t\t\t&[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav {\n\t\t\t\t\t.metismenu{\n\t\t\t\t\t\t&>li{\n\t\t\t\t\t\t\t&.mm-active{\n\t\t\t\t\t\t\t\t&>a{\n\t\t\t\t\t\t\t\t\ti{\n\t\t\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\t\t\t\t\n\t\t\t\t\t} \n\t\t\t\t\t.copyright strong{\n\t\t\t\t\t\tcolor:#fff;\n\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&[data-sidebar-style=\"overlay\"][data-layout=\"vertical\"]{\n\n\t\t\t\t.dlabnav{\n\n\t\t\t\t\t.copyright strong{\n\t\t\t\t\t\tcolor:#fff;\n\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t&[data-sidebar-style=\"mini\"],\n\t\t\t&[data-sidebar-style=\"modern\"],\n\t\t\t&[data-sidebar-style=\"compact\"],\n\t\t\t&[data-sidebar-style=\"icon-hover\"][data-layout=\"horizontal\"],\n\t\t\t&[data-sidebar-style=\"full\"][data-layout=\"horizontal\"]\n\t\t\t{\n\t\t\t\t.dlabnav{\n\t\t\t\t\t.metismenu li ul{\n\t\t\t\t\t\tbackground-color: lighten($color: $color, $amount: 10%);\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t} \n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:rgba($white,0.15)!important;\n\t\t\t\t}\n\t\t\t}\n\t\t\t/* &[data-sidebar-style=\"full\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav .metismenu > li.mm-active > a,\n\t\t\t\t.dlabnav .metismenu > li:hover > a{\n\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t}\t\n\t\t\t} */\n\t\t\t&[data-sidebar-style=\"compact\"][data-layout=\"vertical\"]{\n\t\t\t\t.dlabnav {\n\t\t\t\t\t.metismenu {\n\t\t\t\t\t\t&>li {\n\t\t\t\t\t\t\ta{\n\t\t\t\t\t\t\t\t&:hover{\n\t\t\t\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&>a{\n\t\t\t\t\t\t\t\t&>i{\n\t\t\t\t\t\t\t\t\tbackground: lighten($color: $color, $amount: 3%)!important;\n\t\t\t\t\t\t\t\t\tcolor:rgba($white,0.7);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&.mm-active,&:hover{\n\t\t\t\t\t\t\t\t&>a {\n\t\t\t\t\t\t\t\t\tbox-shadow:none;\n\t\t\t\t\t\t\t\t\tbackground:transparent!important;\n\t\t\t\t\t\t\t\t\tcolor:$white!important;\n\t\t\t\t\t\t\t\t\ti{\n\t\t\t\t\t\t\t\t\t\tbackground: lighten($color: $color, $amount: 10%)!important;\n\t\t\t\t\t\t\t\t\t\tcolor:$white!important;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t}\n\t\t\t}\n\t\t\t.dlabnav {\n\t\t\t\t.metismenu{\n\t\t\t\t\ta{\n\t\t\t\t\t\tcolor:rgba($white,0.8)!important;\n\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t\tli{\n\t\t\t\t\t\tul{\n\t\t\t\t\t\t\ta{\n\t\t\t\t\t\t\t\t&:hover,\n\t\t\t\t\t\t\t\t&:focus,\n\t\t\t\t\t\t\t\t&.mm-active {\n\t\t\t\t\t\t\t\t\tcolor:$white!important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&>li{\n\t\t\t\t\t\t&>a{\n\t\t\t\t\t\t\tcolor:rgba($white,0.85)!important;\n\t\t\t\t\t\t\ti{\n\t\t\t\t\t\t\t\tcolor:rgba($white,0.85)!important;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.mm-active{\n\t\t\t\t\t\t\t&>a{\n\t\t\t\t\t\t\t\tbackground:rgba($white,0.15)!important;\n\t\t\t\t\t\t\t\tcolor:$white!important;\n\t\t\t\t\t\t\t\ti{\n\t\t\t\t\t\t\t\t\tcolor:$white!important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\t\t\tbackground:$white!important;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t.has-arrow:after{\n\t\t\t\t\t\t\t\t//border-color: var(--primary) transparent transparent var(--primary);\n\t\t\t\t\t\t\t}\t\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.has-arrow:after{\n\t\t\t\t\t\tborder-color: rgba($white,0.85) transparent transparent rgba($white,0.85);\n\t\t\t\t\t}\t\t\t\t\t\n\t\t\t\t} \n\t\t\t\t.header-info2 span{\n\t\t\t\t\tcolor: $white;\n\t\t\t\t}\n\t\t\t\t.sidebar-info{\n\t\t\t\t\tcolor: $white; \n\t\t\t\t\ti{\n\t\t\t\t\t\tcolor: $white; \t\t\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.plus-box{\n\t\t\t\tbackground-color: lighten($color: $color, $amount: 10%);\n\t\t\t}\n\t\t\t.copyright{\n\t\t\t\tcolor:$white;\n\t\t\t}\n\t\t}\n\t}\n}\n\n//background for nav header\n@each $name, $color in $theme_backgrounds {\n\t[data-headerbg=\"#{$name}\"][data-theme-version=\"dark\"],\n    [data-headerbg=\"#{$name}\"] {\n        @if $name != \"color_1\"  {\n\t\t\t --headerbg: #{$color};\n\t\t\t\t.header.is-fixed{\n\t\t\t\t\tborder-color:lighten($color: $color, $amount: 10%)!important;\n\t\t\t\t}\n\t\t\t\t.header{\n\t\t\t\t\tborder:0;\n\t\t\t\t}\n\t\t\t\t.header-left{\n\t\t\t\t\t .dashboard_bar{\n\t\t\t\t\t\tcolor:$white;\n\n\t\t\t\t\t }\n\t\t\t\t\t\n\t\t\t\t}\n\t\t\t\t.hamburger svg{\n\t\t\t\t\trect{\n\t\t\t\t\t\tfill: $white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t.header-right{\n\t\t\t\t\t.notification_dropdown{\n\t\t\t\t\t\t.nav-link{\n\t\t\t\t\t\t\tbackground-color: lighten($color: $color, $amount: 10%);\n\t\t\t\t\t\t\tborder-color: lighten($color: $color, $amount: 10%);\n\t\t\t\t\t\t\t.setting-svg{\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\tpath{\n\t\t\t\t\t\t\t\t\t\tfill:$white;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t// i{\n\t\t\t\t\t\t\t// \tcolor:$white;\n\t\t\t\t\t\t\t// } */\n\t\t\t\t\t\t\t// &:before{\n\t\t\t\t\t\t\t// \tbackground-color:$white;\n\t\t\t\t\t\t\t// }\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.menu-wallet{\n\t\t\t\t\t\t\tsvg{\n\t\t\t\t\t\t\t\tpath{\n\n\t\t\t\t\t\t\t\t\tfill:$white;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\n\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&.bell-icon,\n\t\t\t\t\t\t&.search-area-header{\n\n\t\t\t\t\t\t\t\tsvg{\n\n\t\t\t\t\t\t\t\t\tpath{\n\n\t\t\t\t\t\t\t\t\t\tfill:$white;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.dz-theme-mode,\n\t\t\t\t\t\t.dz-fullscreen,\n\t\t\t\t\t\t.bell-link{\n\t\t\t\t\t\t\t\tsvg{\n\n\t\t\t\t\t\t\t\t\tpath{\n\n\t\t\t\t\t\t\t\t\t\tstroke: $white;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.search-area{\n\t\t\t\t\t\t\tsvg{\n\n\t\t\t\t\t\t\t\tpath{\n\n\t\t\t\t\t\t\t\t\tfill:var(--primary);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\n\t\t\t\t\t.header-profile2{\n\t\t\t\t\t\t.dropdown-menu{\n\t\t\t\t\t\t\ta{\n\t\t\t\t\t\t\t\tspan{\n\t\t\t\t\t\t\t\t\tcolor:$black;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t/* .sidebar-info h4, .sidebar-info .h4,\n\t\t\t\t\t.header-profile2 span{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t\t\t} */\n\t\t\t\t\t.bootstrap-select .btn{\n\t\t\t\t\t\tbackground-color:lighten($color: $color, $amount: 10%)!important;\n\t\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t\t.bootstrap-select.countrypicker{\n\t\t\t\t\t\tborder-color:lighten($color: $color, $amount: 10%)!important;\n\t\t\t\t\t}\n\t\t\t\t\t.bootstrap-select .btn{\n\t\t\t\t\t\tcolor:$white!important;\t\n\t\t\t\t\t\tborder-color:lighten($color: $color, $amount: 10%)!important;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t\n\t\t\t\t\n\t\t\t\t\n\t\t\t\n\t\t\t\n\t\t\t\n\t\t\t.hamburger .line{\n\t\t\t\t// background: var(--title)!important;\n\t\t\t\tbackground-color: $white!important;\n\t\t\t}\n\t\t}\n\t}\n}","@media (min-width: 62rem) {\n    [data-container=\"boxed\"] {\n\t\t --right-space: 0;\t\n\t\t //background-color:var(--primary);\n        #main-wrapper {\n            max-width: 74.9375rem;\n            margin: 0 auto;\n\t\t\tbox-shadow: 0 0 1.875rem 0 rgba(0,0,0,0.1);\n\t\t\t\t\n            @at-root [direction=\"rtl\"]#{&} {\n                text-align: right;\n            }\n\t\t\toverflow: hidden;\n        }\n\t\t.invoice-num {\n\t\t\tfont-size: 1.375rem;\n\t\t}\n\t\t/* .wallet-open .content-body{\n\t\t\tpadding-right: 0;\n\t\t} */\n\t   \n\t\t.wallet-open .header .header-content{\n\t\t\tpadding-right:1.875rem;\n\t\t}\n\t\t.wallet-bar{\n\t\t\tdisplay:none;\n\t\t}\n\t\t.nav-link{\n\t\t\t&.menu-wallet{\n\t\t\t\tdisplay:none;\n\t\t\t}\t\n\t\t}\n\t\t.header-left .dashboard_bar{\n\n\t\t\tdisplay: none;\n\t\t}\n\t\t.header .header-content{\n\n\t\t\t//width:calc(100% - 17.9rem);\n\t\t}\n\t\t.footer.style-2{\n\t\t\twidth:calc(100% - 3.625rem);\n\n\t\t}\n\t\t.footer{\n\n            &.footer-outer{\n\n                width:calc(100% - 3.725rem);\n                margin-right:1.875rem;\n            }\n        }\n    }\n}\n    \n@include custommq($min: 84.375rem) {\n    [data-layout=\"vertical\"][data-sidebar-style=\"overlay\"][data-container=\"boxed\"][data-header-position=\"fixed\"] {\n        .header {\n            width: 74.9375rem;\n        }\n    }\n}\n\n@include custommq($min: 75rem, $max: 84.3125rem) {\n    [data-layout=\"vertical\"][data-sidebar-style=\"overlay\"][data-container=\"boxed\"][data-header-position=\"fixed\"] {\n        .header {\n            width: 74.9375rem;\n        }\n    }\n}\n\n\n[data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-container=\"boxed\"] {\n    .dlabnav {\n        max-width: 74.9375rem;\n    }\n\t.content-body{\n\t\tpadding-top: 14rem!important;\n\t}\n} //ok\n\n[data-layout=\"vertical\"][data-container=\"boxed\"][data-header-position=\"fixed\"],\n[data-layout=\"horizontal\"][data-container=\"boxed\"][data-header-position=\"fixed\"] {\n    .header {\n        width: 74.9375rem;\n    }\n}\n\n[data-layout=\"horizontal\"][data-container=\"boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"mini\"] {\n    .header {\n        width: 74.9375rem;\n    }\n}\n[data-layout=\"vertical\"][data-container=\"boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"mini\"] {\n    .footer.footer-outer{\n\t\twidth:calc(100% - 10.325rem);\n\t}\n\t.footer.out-footer.style-2{\n\t\twidth:calc(100% - 9.625rem);\n\t}\n\t.footer.out-footer.style-1{\n\t\twidth:calc(100% - 28.125rem);\n\t}\n\t\n}\n[data-layout=\"vertical\"][data-container=\"boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"compact\"] {\n    .footer.footer-outer{\n\t\twidth:calc(100% - 15.225rem);\n\t}\n\t.footer.out-footer.style-2{\n\t\twidth:calc(100% - 15.625rem);\n\t}\n\t.footer.out-footer.style-1{\n\t\twidth:calc(100% - 33.225rem);\n\t}\n\t.header{\n\t\t.header-content{\n\t\t\tpadding-right:11.275rem;\n\t\t}\n\t}\n\t\n}\n[data-layout=\"vertical\"][data-container=\"boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"overlay\"]{\n    .footer.footer-outer{\n\t\twidth:calc(100% - 4.225rem);\n\t}\n\t.footer.out-footer.style-2{\n\t\twidth:calc(100% - 15.625rem);\n\t}\n\t.footer.out-footer.style-1{\n\t\twidth:calc(100% - 22.225rem);\n\t}\n\t.header{\n\t\t.header-content{\n\t\t\tpadding-right:312px;\n\t\t}\n\t}\n\t\n}\n[data-layout=\"vertical\"][data-container=\"boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"icon-hover\"]{\n    .footer.footer-outer{\n\t\twidth:calc(100% - 9.725rem);\n\t}\n\t.footer.out-footer.style-2{\n\t\twidth:calc(100% - 15.625rem);\n\t}\n\t.footer.out-footer.style-1{\n\t\twidth:calc(100% - 22.225rem);\n\t}\n\t\n\t\n}\n[data-layout=\"horizontal\"][data-container=\"boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"full\"] {\n   .wallet-open.show.active.dlabnav-scroll{\n\t\t padding-right:0;\n\t}\n}\n[data-layout=\"horizontal\"][data-container=\"boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"compact\"] {\n\t.wallet-open.show.active .dlabnav-scroll{\n\t\t padding-right:0;\n\t}\n  \n}\n[data-layout=\"horizontal\"][data-container=\"boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"modern\"] {\n\t.footer.style-2{\n\t\twidth: calc(100% - 3.625rem);\n\t\tmargin-left: auto;\n\t}\n\t.footer.footer-outer{\n\t\twidth:calc(100% - 3.225rem);\n\t}\n\t.wallet-open.show.active.dlabnav-scroll{\n\t\t padding-right:0;\n\t}\n  \n}\n\n\n[data-container=\"boxed\"] {\n    .metismenu.fixed {\n        left: auto;\n        max-width: 74.9375rem;\n    }\n\n    .page-titles {\n        margin-bottom: 3rem;\n        padding: 0.9375rem 0.9375rem;\n    }\n\n    .content-body .container-fluid {\n        padding:1.875rem;\n    }\n}\n\n[data-container=\"boxed\"][data-layout=\"vertical\"] {\n    .page-titles {\n        margin-left: 0;\n        margin-right: 0;\n    }\n}\n\n[data-layout=\"vertical\"][data-container=\"boxed\"][data-sidebar-position=\"fixed\"][data-header-position=\"static\"][data-sidebar-style=\"overlay\"] {\n    .nav-header {\n        position: absolute;\n    }\n\n    .menu-toggle {\n        .dlabnav {\n            position: absolute;\n        }\n    }\n}\n\n[data-container=\"boxed\"][data-sidebar-position=\"fixed\"][data-layout=\"horizontal\"] {\n    .dlabnav.fixed {\n        left: auto;\n        max-width: 74.9375rem;\n    }\n\t\n\t.container-fluid{\n\t\tpadding-bottom: 0;\n\t}\n\t\n}\n[data-container=\"boxed\"][data-sidebar-position=\"fixed\"][data-layout=\"horizontal\"]{\n\t/* &[data-sidebar-style=\"full\"],\n\t&[data-sidebar-style=\"icon-hover\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 9rem;\n\t\t}\n\t} */\n\t &[data-sidebar-style=\"compact\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 18rem!important;\n\t\t}\n\t} \n\t/* &[data-sidebar-style=\"modern\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 6.5rem;\n\t\t}\n\t} */\n\t&[data-sidebar-style=\"mini\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 10rem!important;\n\t\t}\n\t}\n}\n[data-container=\"boxed\"],\n[data-container=\"wide-boxed\"],\n[data-sidebar-position=\"static\"][data-header-position=\"static\"][data-layout=\"horizontal\"]{\n\t.nav-header{\n\t\theight:5.5rem;\n\t}\n}\n[data-container=\"boxed\"][data-sidebar-position=\"static\"][data-header-position=\"fixed\"][data-layout=\"horizontal\"]{\n\t.nav-header{\n\t\theight:5rem;\n\t}\n\t&[data-sidebar-style=\"mini\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 10rem!important;\n\t\t}\n\t}\n\t&[data-sidebar-style=\"modern\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 6.5rem;\n\t\t}\n\t}\n}\n\n[data-container=\"wide-boxed\"][data-sidebar-position=\"fixed\"][data-layout=\"horizontal\"]{\n\t/* &[data-sidebar-style=\"full\"],\n\t&[data-sidebar-style=\"icon-hover\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 9rem;\n\t\t}\n\t} */\n\t/* &[data-sidebar-style=\"compact\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 7.5rem;\n\t\t}\n\t} */\n\t/* &[data-sidebar-style=\"modern\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 6.5rem;\n\t\t}\n\t} */\n\n\t.footer{\n\n\t\t&.footer-outer{\n\n\t\t\t\twidth:calc(100% - 4.925rem);\n\t\t\t\tmargin-left:2.6rem;\n\t\t}\n\t}\n}\n[data-container=\"wide-boxed\"][data-sidebar-position=\"static\"][data-layout=\"horizontal\"]{\n\t\n\t&[data-sidebar-style=\"compact\"]{\n\t\t.header .header-content{\n\t\t\tmargin-left: 13.2rem;\n\t\t}\n\t}\n}\n[data-container=\"wide-boxed\"],\n[data-container=\"boxed\"],\n[data-container=\"wide\"],\n[data-sidebar-position=\"static\"][data-layout=\"horizontal\"][data-header-position=\"static\"]{\n\t.nav-header{\n\t\theight:5rem;\n\t\tz-index: 8;\n\t}\n}\n\t\n[data-container=\"wide\"][data-sidebar-position=\"fixed\"][data-layout=\"horizontal\"]{\n\t&[data-sidebar-style=\"compact\"]{\n\t\t.header{\n\t\t\t.header-content{\n\t\t\t\tmargin-left: 12.2rem;\n\t\t\t}\n\t\t}\n\t}\n}\n[data-container=\"boxed\"]{\n\t.header-left{\n\t\t.search-area{\n\t\t\tdisplay:none;\n\t\t}\n\t}\n}","@media (min-width: 62rem) {\n    [data-container=\"wide-boxed\"] {\n\t\t--right-space: 0;\t\n\t\t//background-color:var(--primary);\n        #main-wrapper {\n            max-width: 92.5rem;\n            margin: 0 auto;\n\t\t\tbox-shadow: 0 0 1.875rem 0 rgba(0,0,0,0.1);\n\t\t\t\t\n            @at-root [direction=\"rtl\"]#{&} {\n                text-align: right;\n            }\n\t\t\toverflow: hidden;\n        }\n\t\t.wallet-open .header .header-content{\n\t\t\tpadding-right:1.875rem;\n\t\t}\n\t\t.wallet-bar{\n\t\t\tdisplay:none;\n\t\t}\n\t\t.nav-link{\n\t\t\t&.menu-wallet{\n\t\t\t\tdisplay:none;\n\t\t\t}\t\n\t\t}\n        .footer{\n            &.footer-outer{\n                width: calc(100% - 15.725rem);\n                margin-right: 1.875rem;\n                //margin-left: auto;\n            \n            }\n        }\n    }\n}\n\n    \n    \n@include custommq($min: 84.375rem) {\n    [data-layout=\"vertical\"][data-sidebar-style=\"overlay\"][data-container=\"wide-boxed\"][data-header-position=\"fixed\"] {\n        .header {\n            width: 92.5rem;\n        }\n    }\n}\n\n@include custommq($min: 75rem, $max: 100rem) {\n    [data-layout=\"vertical\"][data-sidebar-style=\"overlay\"][data-container=\"wide-boxed\"][data-header-position=\"fixed\"] {\n        .header {\n            width: 92.5rem;\n        }\n\t\t\n    }\n}\n[data-layout=\"vertical\"][data-sidebar-style=\"overlay\"][data-container=\"wide-boxed\"][data-header-position=\"fixed\"] {\n\t.footer.out-footer.style-1{\n\t\t\twidth: calc(100% - 23.525rem);\n\t\t\tmargin-right: 20.775rem;\n\n\t}\t\n\t.footer.footer-outer{\n\t\twidth: calc(100% - 4.725rem);\n\t\tmargin-right: 1.875rem;\n\t}\n\t.footer.out-footer.style-2{\n\t\twidth:calc(100% - 4.325rem);\n\t}\n\t\n\t.header{\n\t\t.header-content{\n\t\t\tpadding-right:19.875rem;\n\t\t}\n\t}\n}\n[data-layout=\"vertical\"][data-sidebar-style=\"icon-hover\"][data-container=\"wide-boxed\"][data-header-position=\"fixed\"] {\n\t.footer.out-footer.style-1{\n\t\twidth: calc(100% - 28.725rem);\n\t\tmargin-right: 20.875rem;\n\n\t}\t\n\t.footer.footer-outer{\n\t\twidth: calc(100% - 9.725rem);\n\t\tmargin-right: 1.875rem;\n\n\t}\n\t.footer.out-footer.style-2{\n\t\twidth: calc(100% - 9.725rem);\n\t\tmargin-right: 1.875rem;\n\t}\n\t\n\t\n}\n[data-layout=\"vertical\"][data-sidebar-style=\"mini\"][data-container=\"wide-boxed\"][data-header-position=\"fixed\"] {\n\t.footer.out-footer.style-1{\n\t\t\t    width: calc(100% - 28.525rem);\n\t\tmargin-right: 19.775rem;\n\n\t}\t\n\t.footer.footer-outer{\n\t\twidth: calc(100% - 10.725rem);\n\t\tmargin-right: 1.875rem;\n\t}\n\t.footer.out-footer.style-2{\n\t\twidth:calc(100% - 11.125rem);\n\t}\n}\n[data-sidebar-style=\"compact\"][data-header-position=\"fixed\"][data-container=\"wide-boxed\"][data-layout=\"vertical\"] {\n    .header {\n        width: 92.5rem;\n\t\t\n\t\t.header-content{\n\t\t\t    padding-left: 3rem!important;\n\t\t\t\twidth: calc(100% - 10.1rem);\n\t\t}\n    }\n\t\n\t\n   .footer.out-footer.style-2{\n\t\twidth:calc(100% - 15.625rem);\n   }\n   .footer.out-footer.style-1{\n\t\twidth:calc(100% - 35.225rem);\n\t\tmargin-right:20.975rem;\n   }\n}\n\n[data-header-position=\"fixed\"][data-layout=\"horizontal\"][data-container=\"wide-boxed\"] {\n    .dlabnav {\n        max-width: 92.5rem;\n    }\n} //ok\n\n[data-layout=\"vertical\"][data-container=\"wide-boxed\"][data-header-position=\"fixed\"],\n[data-layout=\"horizontal\"][data-container=\"wide-boxed\"][data-header-position=\"fixed\"] {\n    .header {\n        width: 92.5rem;\n    }\n}\n\n[data-layout=\"horizontal\"][data-container=\"wide-boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"mini\"] {\n    .header {\n        width: 92.5rem;\n    }\n}\n[data-layout=\"vertical\"][data-container=\"wide-boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"full\"] {\n    .header {\n        width: 92.5rem;\n\t\t.header-content{\n\t\t\tpadding-right:19.875rem;\n\t\t}\n    }\n\t\n\t\n\t.footer{\n\t\t&.footer-outer{\n\t\t\twidth: calc(100% - 21.725rem);\n\t\t\tmargin-right: 1.875rem;\n\t\t}\n\t}\n}\n\n[data-layout=\"horizontal\"][data-container=\"wide-boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"compact\"] {\n    .wallet-open.show.active .dlabnav-scroll{\n\t\tpadding-right:0px;\n\t}\n}\n[data-layout=\"horizontal\"][data-container=\"wide-boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"icon-hover\"] {\n    .footer.footer-outer{\n\t\twidth:calc(100% - 5.025rem);\n\t\tmargin-left:1.775rem;\n\t}\n\t .wallet-open.show.active .dlabnav-scroll{\n\t\tpadding-right:0px;\n\t}\n}\n\n[data-layout=\"horizontal\"][data-container=\"wide-boxed\"][data-header-position=\"fixed\"][data-sidebar-style=\"modern\"] {\n    .wallet-open.show.active .dlabnav-scroll{\n\t\tpadding-right:0px;\n\t}\n\t.header{\n\t\t.header-content{\n\t\t\tpadding-right:19.875rem;\n\t\t}\n\t}\n\t.footer{\n\t\t&.footer-outer{\n\t\t\twidth: calc(100% - 4.225rem);\n\t\t\tmargin-left: 2.775rem !important;\n\t\t}\n\t\t&.style-1{\n\t\t\twidth: calc(100% - 24.225rem);\n\t\t\tmargin-left: 2.775rem !important;\n\t\t}\n\t}\n}\n\n\n[data-container=\"wide-boxed\"] {\n    .metismenu.fixed {\n        left: auto;\n        max-width: 92.5rem;\n    }\n\n    .page-titles {\n        margin-bottom: 3rem;\n        padding: 0.9375rem 0.9375rem;\n    }\n\n    .content-body .container-fluid {\n        padding: 2.5rem;\n    }\n}\n\n[data-container=\"wide-boxed\"][data-layout=\"vertical\"] {\n    .page-titles {\n        margin-left: 0;\n        margin-right: 0;\n    }\n}\n\n[data-layout=\"vertical\"][data-container=\"wide-boxed\"][data-sidebar-position=\"fixed\"][data-header-position=\"static\"][data-sidebar-style=\"overlay\"] {\n    .nav-header {\n        position: absolute;\n    }\n\n    .menu-toggle {\n        .dlabnav {\n            position: absolute;\n        }\n    }\n}\n\n[data-container=\"wide-boxed\"][data-sidebar-position=\"fixed\"][data-layout=\"horizontal\"] {\n    .dlabnav.fixed {\n        left: auto;\n        max-width: 92.5rem;\n    }\n}\n[data-container=\"wide-boxed\"][data-layout=\"horizontal\"][data-header-position=\"fixed\"]{\n\t&[data-sidebar-style=\"icon-hover\"],\n\t&[data-sidebar-style=\"full\"]{\t\n\t\t.content-body{\n\t\t\tpadding-top: 14rem;\n\t\t}\n\t}\n\t&[data-sidebar-style=\"compact\"],\n\t&[data-sidebar-style=\"modern\"]{\n\t\t.content-body{\n\t\t\tpadding-top: 12rem;\n\t\t}\n\t}\n}","//background for nav header\n@each $name, $color in $theme_backgrounds {\n    [data-primary=\"#{$name}\"] {\n        @if $name != \"color_1\"  {\n\t\t\t--primary: #{$color};\n\t\t\t--secondary: #{$secondary};\n\t\t\t--primary-hover: #{darken($color, 10)};\n\t\t\t--primary-dark: #{darken($color, 30)};\n\t\t\t--rgba-primary-1: #{rgba($color, 0.1)};\n\t\t\t--rgba-primary-2: #{rgba($color, 0.2)};\n\t\t\t--rgba-primary-3: #{rgba($color, 0.3)};\n\t\t\t--rgba-primary-4: #{rgba($color, 0.4)};\n\t\t\t--rgba-primary-5: #{rgba($color, 0.5)};\n\t\t\t--rgba-primary-6: #{rgba($color, 0.6)};\n\t\t\t--rgba-primary-7: #{rgba($color, 0.7)};\n\t\t\t--rgba-primary-8: #{rgba($color, 0.8)};\n\t\t\t--rgba-primary-9: #{rgba($color, 0.9)};\n\t\t}\n\t}\n}\n","[data-typography=\"opensans\"] {\n    font-family: 'Open Sans', sans-serif;\n  }\n  \n\n\n  \n","[data-typography=\"poppins\"] {\n    font-family: 'poppins', sans-serif;\n  }\n\n\n  \n"," [data-typography=\"Nunito\"] {\n   font-family: 'Nunito Sans', sans-serif;\n }\n\n","[data-typography=\"roboto\"] {\n    font-family: 'Roboto', sans-serif;\n  }\n  \n\n\n  \n","[data-typography=\"helvetica\"] {\n    font-family: 'HelveticaNeue';\n  }\n\n\n  \n\n  ","@import \"./../../abstracts/variable\";\n\n\n\n[data-theme-version=\"transparent\"] {\n   \n    \n    background-repeat: no-repeat;\n    background-attachment: fixed;\n    background-size: cover;\n    background-position: center;\n    position: relative;\n    // background: $d-bg;s\n    color: $white;\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n        color: $white !important;\n    }\n    a.link {\n        color: $d-ctd;\n    }\n    a.link:focus,\n    a.link:hover {\n        color: $info;\n    }\n\n    a {\n        color: $white;\n\n        &:hover {\n            color: $d-ctl;\n        }\n    }\n\n    \n    //Generating border classess\n    @each $value in $borders {\n        @if $value == \"\" {\n            .border {\n                border: 1px solid $d-border !important;\n            }\n        } @else {\n            .border-#{$value} {\n                border-#{$value}: 1px solid $d-border !important;\n            }\n        }\n    }\n\n\n}","\n[data-theme-version=\"transparent\"] {\n    .dropdown-menu {\n        background-color: $dark-card;\n    }\n\n    .dropdown-item {\n        &:hover, &:focus {\n            background-color: $d-bg;\n            color: $white;\n        }\n    }\n\n    .form-control {\n        background-color: $d-bg;\n        border-color: $d-border;\n        color: $white;\n    }\n    \n    .card {\n        background-color: rgba(0,0,0,0.15);\n    }\n\n}","[data-theme-version=\"transparent\"] {\n    \n    .header {\n        background-color: rgba(0,0,0,0.15);\n    }\n    \n\n    .header-left {\n        input {\n            border-color: $d-border;\n            color: $white;\n\n            &:focus {\n                box-shadow: none;\n                border-color: var(--primary);\n            }\n\n            &::placeholder {\n                color: $white;\n            }\n        }\n    }\n\n\n    .header-right {\n        .dropdown {\n            .nav-link {\n                &:hover {\n                    color: $white;\n                }\n            }\n        }\n\n        .notification_dropdown {\n            .dropdown-item {\n                a {\n                    color: $white;\n                }\n            }\n        }\n    }\n\n}","[data-theme-version=\"transparent\"] {\n    .nav-header, \n    .nav-control {\n        background-color: rgba(0,0,0,0.15)!important;\n    }\n\n    .nav-control {\n        color: $white;\n    }\n\n    .brand-logo {\n        color: $white;\n\n        &:hover {\n            color: $white;\n        }\n    }\n}","[data-theme-version=\"transparent\"] {\n    \n    .dlabnav {\n        background-color: rgba(0,0,0,0.15)!important;\n    \n        .metismenu {\n    \n    \n            &>li {\n    \n                &>a {\n                    color: rgba(0,0,0,0.15);\n                }\n    \n                &:hover, \n                &:focus, \n                &.mm-active {\n    \n                    &>a {\n                        background-color: rgba(0,0,0,0.15)!important;\n                        color: $white;\n    \n                        &::after {\n                            border-color: transparent transparent $white transparent;\n                        }\n                    }\n                }\n    \n                &.mm-active {\n                    ul {\n    \n                        ul {\n                            background-color: transparent;\n                        }\n                    }\n                }\n            }\n    \n            //one step dropdown\n            ul  {\n                background-color: rgba(0,0,0,0.15);\n    \n                a {\n    \n                    &:hover,\n                    &:focus, \n                    &.mm-active {\n                        color: $white;\n                    } \n                }\n            }\n            \n            a {\n                color: rgba(0,0,0,0.15);\n            }\n            ul {\n                background-color: rgba(0,0,0,0.15)!important;\n            }\n    \n            .has-arrow {\n                &:after {\n                    border-color: transparent transparent rgba(0,0,0,0.15) transparent;\n                }\n            }\n        }\n    }\n    \n    \n\n}","@import \"./../../abstracts/variable\";\n\n\n\n[data-theme-version=\"dark\"] {\n    background: $d-bg;\n    color: $dbody-text;\n\t\n\t--nav-headbg : #{$dark-card};\n\t--sidebar-bg : #{$d-bg};\n\t--headerbg : #{$dark-card};\n\t\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n        color: $white !important;\n    }\n    a.link {\n        color: $d-ctd;\n    }\n    a.link:focus,\n    a.link:hover {\n        color: $info;\n    }\n\n    a {\n        &:hover {\n            color: $white;\n        }\n    }\n\t\n    //Generating border classess\n    @each $value in $borders {\n        @if $value == \"\" {\n            .border {\n                border: 0.0625rem solid $d-border !important;\n            }\n        } @else {\n            .border-#{$value} {\n                border-#{$value}: 0.0625rem solid $d-border !important;\n            }\n        }\n    }\n\n\n}","[data-theme-version=\"dark\"]{\n\t.card {\n        background-color: $dark-card;\n\t\tbox-shadow:none;\n    }\n\t.dropdown-menu {\n        background-color: $dark-card;\n\t\tbox-shadow: 0rem 0rem 0rem 0.0625rem rgba(255, 255, 255,0.1);\n\t\t.dropdown-item {\n\t\t\tcolor:#777777;\n\t\t\t&.selected,\n\t\t\t&.selected.active,\n\t\t\t&.active,\n\t\t\t&:hover, \n\t\t\t&:focus {\n\t\t\t\tbackground-color: $dark-card;\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\n    }\n\ta{\n\t\tcolor:$white;\n\t}\n\t.btn-link g [fill]{\n\t\tfill: #fff;\n\t}\n\t.btn-light:active, \n\t.btn-light:focus, \n\t.btn-light:hover{\n\t\tcolor:#000;\n\t}\n\t.form-control {\n        background-color:$d-bg;\n        border-color: $d-border;\n        color:$white;\n\t\t\n    }\n\t\n\t.modal-content{\n\t\tbackground:$dark-card;\n\t}\n\t.modal-footer,\n\t.modal-header{\n\t\tborder-color: $d-border;\n\t}\n\t.close{\n\t    font-weight: 400;\n\t\tcolor: $white;\n\t\ttext-shadow: none;\n\t\t\n\t\t&:hover{\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t.star-rating .product-review,\n\t.new-arrival-content .item{\n\t\tcolor: $white;\n\t}\n\t\n\t.custom-dropdown .dropdown-menu{\n\t\tborder-color: $d-border;\n\t}\n\t.widget-stat .media > span{\n\t    background: $d-border;\n\t    border-color: $d-border;\n\t\tcolor:$white;\n\t}\n\t.plus-minus-input .custom-btn{\n\t\tbackground: $d-bg;\n\t    border-color: $d-border;\n\t}\n\t.dropdown-divider,\n\t.size-filter ul li{\n\t\tborder-color: $d-border;\n\t}\n\t.custom-select{\n\t    border-color: $d-border;\n\t\tcolor: $d-ctl;\n\t\tbackground:$d-bg;\n\t}\n\t.nav-tabs{\n\t\tborder-color: $d-border!important;\n\t}\n\t.mail-list .list-group-item.active i {\n\t\tcolor: $white;\n\t}\n\thr{\n\t\tborder-color: $d-border;\n\t}\n\t.grid-col{\n\t\tbackground:$d-bg;\n\t}\n\t\n\t.noUi-target{\n\t\tborder-color:$d-border;\n\t\tborder-radius: 0.5rem;\n\t\tbox-shadow: none;\n\t\t\n\t\t.noUi-connects{\n\t\t\tbackground:$d-border;\n\t\t}\n\t}\n\t.noUi-marker-large,\n\t.noUi-marker{\n\t\tbackground:$d-border;\n\t}\n\t.input-group-text{\n\t\tbackground:$dark-card;\n\t\tcolor:$white;\n\t\tborder-color:$d-border;\n\t}\n\t.note-editor.note-frame{\n\t\tborder-color:$d-border;\n\t\t.btn{\n\t\t\tcolor:$white;\n\t\t}\n\t\t.note-editing-area .note-editable{\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.widget-media .timeline .timeline-panel{\n\t\tborder-color:$d-border; \n\t}\n\t.notification_dropdown .dropdown-menu-right .all-notification{\n\t\tborder-color:$d-border; \n\t}\n\t#user-activity .nav-tabs .nav-link{\n\t\tborder-color:$d-border; \n        &.active{\n            background:$d-bg;\n            color:$white;\n        }\n\t}\n\t.list-group-item-action{\n\t\tcolor:$body-color;\n\t}\n\t.list-group-item-action:focus, \n\t.list-group-item-action:hover, \n\t.list-group-item-action:focus{\n\t\tbackground-color:$d-bg; \n\t\tborder-color:$d-bg; \n\t}\n\t.list-group-item.active{\n\t\tcolor:$white;\n\t\tborder-color:var(--primary);\n\t\t&:focus, \n\t\t&:hover, \n\t\t&:focus{\n\t\t\tbackground-color:var(--primary); \n\t\t\tborder-color:var(--primary); \n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.swal2-popup{\n\t\tbackground:$dark-card;\n\t}\t\n\t.form-head .btn-outline-primary{\n\t\tborder-color:$d-border;\n\t}\n\t.form-head .btn-outline-primary:hover{\n\t\tborder-color:var(--primary);\n\t}\n\t.review-tab.nav-pills li a.nav-link.active{\n\t\tbackground:transparent;\n\t}\n\t.new-arrival-content {\n\t\t h4 {\n\t\t\ta{\n\t\t\t\tcolor:$white;\n\t\t\t}\n\t\t }\n\t}\n\t.text-black{\n\t\tcolor:$white!important;\n\t}\n\t.abilities-chart .ct-chart .ct-label{\n\t\tfill:$white;\n\t}\n\t.morris_chart_height text tspan{\n\t\tfill:$white;\n\t}\n\t.btn-link{\n\t\tcolor:$white;\n\t\tsvg{\n\t\t\tpath{\n\t\t\t\tstroke:$white;\t\n\t\t\t}\t\n\t\t}\n\t}\n\t.order-bg{\n\t\tbackground:$d-bg;\n\t}\n\t.detault-daterange{\n\t\t\tbackground:$d-bg;\n\t\t\tcolor:$white;\n\t\t.input-group-text{\n\t\t\tbackground:$dark-card;\n\t\t\tborder:0;\n\n\t\t}\t\n\t}\n\t\n\t.dataTablesCard{\n\t\tbackground-color:$dark-card;\n\t}\n\t.compose-content .dropzone{\n\t\tbackground:$d-bg!important;\n\t\t.dlab-message .dlab-button{\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.daterangepicker{\n\t\tbackground:$d-bg;\n\t\tborder-color:var(--primary);\n\t\t.calendar-table{\n\t\t\tborder-color:var(--primary);\n\t\t\tbackground:$d-bg;\n\t\t\t.table-condensed{\n\t\t\t\ttd{\n\t\t\t\t\t&:hover{\n\t\t\t\t\t\tbackground-color:var(--primary);\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n        &:after{\n            border-bottom: 0.375rem solid $d-bg;\n        }\n\t}\n    \n    .daterangepicker select.hourselect\n    , .daterangepicker select.minuteselect\n    , .daterangepicker select.secondselect\n    , .daterangepicker select.ampmselect{\n            background: $d-bg;\n            border: 0.0625rem solid $d-border;\n            color:$white;\n    }\n    \n\t.daterangepicker td.off, \n\t.daterangepicker td.off.in-range,\n\t.daterangepicker td.off.start-date, \n\t.daterangepicker td.off.end-date{\n\t\tbackground-color:$dark-card;\n\t\t&:hover{\n\t\t\tbackground-color:var(--primary);\n\t\t\tcolor:$white;\t\t\t\n\t\t}\n\t}\n\n// ---toggle-btn\n.round .checkmark {\n\tbackground-color: $d-bg;\n}\n.round:hover input ~ .checkmark {\n\tbackground-color: $d-bg;\n}\n.round span {\n    color: $white;\n}\n\t.app-fullcalendar{\n\t\t.fc-button{\n\t\t\tbackground-color:$d-bg;\n\t\t\tborder-color:var(--primary);\n\t\t\tcolor:$white;\n\t\t\ttext-shadow:none;\n\t\t\t&:hover,&.fc-stat-hover{\n\t\t\t\tbackground-color:var(--primary);\n\t\t\t}\n\t\t}\n\t}\n\t.swal2-popup .swal2-styled:focus {\n\t\toutline: 0;\n\t\tbox-shadow: 0 0 0 0.125rem $d-border, 0 0 0 0.25rem var(--rgba-primary-1);\n\t}\n\t.dd-handle{\n\t\tborder-color:$d-border;\n\t}\n\t.menu-toggle .dlabnav .metismenu li > ul{\n\t\tbackground:$dark-card!important;\n\t}\n\t.header-right .notification_dropdown .nav-link{\n\t\tborder-color:$d-border;\n\t}\n\t.nav-tabs .nav-link{\n\t\t&:hover,&.active{\n\t\t\tborder-color:transparent;\n\t\t\tbackground: transparent;\n\t\t\tcolor: white!important;\n\t\t}\n\t}\n\t.clockpicker-popover .popover-content{\n\t\tbackground-color:$dark-card;\n\t}\n\t.clockpicker-plate{\n\t\tbackground-color:$d-bg;\n\t}\n\t.clockpicker-popover .popover-title{\n\t\tbackground-color:$d-bg;\n\t\tcolor:$white;\n\t}\n\t.form-wizard .nav-wizard li .nav-link span{\n\t\tbackground-color:$d-bg;\n\t}\n\t.form-wizard .nav-wizard li .nav-link:after{\n\t\tbackground:$d-bg;\n\t}\n\t.form-wizard .nav-wizard li .nav-link.active:after,.form-wizard .nav-wizard li .nav-link.done:after{\n\t\tbackground:var(--primary);\n\t}\n\t.form-wizard .nav-wizard li .nav-link.active span\n\t,.form-wizard .nav-wizard li .nav-link.done span{\n\t\tbackground:var(--primary);\n\t}\n\t.check-switch .custom-control-label:after\n    , .check-switch .custom-control-label:before{\n        border-color:var(--primary);\n    }\n    .fc-unthemed .fc-today{\n        background:$d-bg;\n    }\n    .fc-unthemed .fc-divider, .fc-unthemed .fc-list-heading td, .fc-unthemed .fc-popover .fc-header{\n        background: $d-border;\n    }\n    .picker__box{\n        background:$d-bg;\n        .picker__button--clear\n        , .picker__button--close\n        , .picker__button--today{\n            background:$dark-card;\n            color:$white;\n            &:hover{\n                &:before{\n                    color:$white;\n                }\n            }\n        }\n    }\n    .picker{\n        color:#999;\n    }\n    .dtp > .dtp-content{\n        background:$d-bg;\n    }\n    .dtp table.dtp-picker-days tr > td > a{\n       color: #68686a; \n       &.selected{\n           color:$white;\n       }\n    }\n\t.order-request tbody tr{\n\t\tborder-color:$d-border;\n\t}\n\t.card-list li{\n\t\tcolor:$white;\n\t}\n\t.card-bx .change-btn:hover{\n\t\tcolor:var(--primary);\n\t}\n\t.invoice-card{\n\t\t&.bg-warning{\n\t\t\tbackground-color:#5b3c1f!important;\n\t\t}\n\t\t&.bg-success{\n\t\t\tbackground-color:#2a6729!important;\n\t\t}\n\t\t&.bg-info{\n\t\t\tbackground-color:#4c276a!important;\n\t\t}\n\t\t&.bg-secondary{\n\t\t\tbackground-color:#1c3e52!important;\n\t\t}\n\t}\n\t.user-list li{\n\t\tborder-color:$dark-card;\n\t}\n\t.toggle-switch{\n\t\tcolor:$white;\n\t}\n\t.bar-chart{\n\t\t.apexcharts-text tspan{\n\t\t\tfill:#969ba0;\n\t\t}\n\t\tline{\n\t\t\tstroke:$d-border;\n\t\t}\n\t}\n\t.accordion.style-1 .accordion-item,.invoice-list,\n\t.form-check-input[type=\"checkbox\"]{\n\t\tborder-color:$d-border;\n\t}\n\t.accordion.style-1 .accordion-header.collapsed {\n\t\t.user-info a,.user-info,&>span{\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.ic-card {\n\t\t&>a{\n\t\t\tbackground:#25479f;\n\t\t\t&:first-child{\n\t\t\t\tborder-color:#25479f;\n\t\t\t}\n\t\t}\n\t\tspan{\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\ttable.dataTable thead th, table.dataTable thead td{\n\t\tborder-color:$dark-card!important;\n\t}\n\t.form-check .form-check-input{\n\t\t//background:$white;\n\t\t&:checked{\n\t\t\tbackground-image:url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n\t\t}\n\t}\n\t.paging_simple_numbers.dataTables_paginate{\n\t\t//background:$d-border;\n\t}\n\t.dataTables_info{\n\t\tcolor:$white;\t\n\t}\n\t.dataTables_wrapper .dataTables_paginate span .paginate_button.current,\n\t.dataTables_wrapper .dataTables_paginate span .paginate_button:hover{\n\t\tbackground:var(--primary);\n\t\tcolor:$white!important;\n\t}\n\t.dashboard-select{\n\t\tbackground:$dark-card;\n\t\tcolor: white!important;\n\t\tborder-color:$d-border!important;\n\t}\n\t.dashboard-select .list{\n\t\tbackground:$dark-card;\n\t}\n\t.dashboard-select .option:hover, .dashboard-select .option.focus, .dashboard-select .option.selected.focus{\n\t\tbackground:$d-bg;\n\t}\n\t.card-tabs.style-1 .nav-tabs{\n\t\tbackground:$dark-card;\n\t}\n\t.transaction-details{\n\t\tborder-color:$d-border;\n\t}\n\t.description{\n\t\tcolor:$white;\n\t}\n\t.apexcharts-legend-text{\n\t\tcolor:$white!important;\t\n\t}\n\t.area-theme{\n\t\tline{\n\t\t\tstroke:$d-border;\n\t\t}\t\n\t}\n\t.transaction-details .amount-bx{\n\t\tbackground:$dark-card;\n\t\ti{\n\t\t\tbackground:#8d3b0c;\t\t\t\n\t\t}\n\t}\n\t.nice-select .option{\n\t\tbackground:$dark-card;\n\t}\n\t.nice-select .option:hover, .nice-select .option.focus, .nice-select .option.selected.focus{\n\t\tbackground:$dark-card;\n\t}\n\t.card-tabs.style-1{\n\t\tborder-color:$d-border;\n\t}\n\t\n\t.nice-select .list{\n\t\tbackground:$d-bg;\n\t}\n\t.table-search .input-group .input-group-text{\n\t\tbackground:$dark-card;\n\t}\n\t.dark-btn{\n\t\tsvg{\n\t\t\tpath{\n\t\t\t\tstroke: #fff;\n\t\t\t}\n\t\t\t\t\n\t\t}\t\n\t}\n\t.bar-chart{\n\t\t.apexcharts-legend-text{\n\t\t\tcolor:$white!important;\t\n\t\t}\t\n\t}\n\t.Sales{\n\t\ttspan{\n\t\t\tfill:$white;\t\n\t\t}\t\n\t}\n\t.timeline-chart{\n\t\trect{\n\t\t\tfill:$d-bg;\t\n\t\t}\t\n\t}\n\t.header-info{\n\t\tspan{\n\t\t\tcolor:$white!important;\t\n\t\t}\t\n\t}\n\t.ck-editor__editable{\n\t\tbackground:$d-bg!important;\n\t}\n\t.ck.ck-editor .ck.ck-toolbar{\n\t\tbackground:$dark-card;\t\n\t}\n\t.ck.ck-toolbar .ck.ck-toolbar__separator{\n\t\tbackground:$d-border;\n\t}\n\t.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){\n\t\tborder-color:$d-border;\n\t}\n\t\n\t\n\t.search-area{\n\t\t.form-control{\n\t\t\tbackground:$d-bg;\t\n\t\t\tborder:none;\n\t\t\t&:hover{\n\t\t\t\tborder-color:$d-border;\t\n\t\t\t}\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground:$d-bg;\t\n\t\t\tborder:none;\n\t\t}\n\t}\n\t.chartBarRunning{\n\t\ttspan{\n\t\t\tfill:$white;\t\n\t\t}\t\n\t\tline{\n\t\t\tstroke:$d-border;\t\n\t\t}\n\t}\n\t.reservationChart{\n\t\ttspan{\n\t\t\tfill:$white;\t\n\t\t}\t\n\t\tline{\n\t\t\tstroke:$d-border;\t\n\t\t}\t\n\t}\n\t.table-condensed{\n\t\ti{\n\t\t\t&:hover{\n\t\t\t\tbackground:$dark-card;\t\n\t\t\t}\t\n\t\t}\t\t\n\t}\n\t.booking-calender thead .picker-switch{\n\t\tcolor:$white;\n\t\t&:hover{\n\t\t\tbackground:$dark-card;\n\t\t\t\n\t\t}\t\n\t}\n\t.booking-calender{\n\t\t.prev,\n\t\t.next{\n\t\t\t&:hover{\n\t\t\t\tbackground:$dark-card;\t\n\t\t\t}\t\n\t\t}\n\t}\n\t.dlabnav .header-info2 span{\n\t\tcolor:$white;\t\n\t}\n\t.booking-calender tbody tr .day{\n\t\tborder-color:$d-border;\t\n\t}\n\t.booking-calender thead .dow{\n\t\tborder-color:$d-border;\t\t\n\t}\n\t.customer-search{\n\t\t.search-area{\n\t\t\t.form-control{\n\t\t\t\tbackground:$dark-card;\t\n\t\t\t}\n\t\t\t.input-group-text{\n\t\t\t\tbackground:$dark-card;\t\t\n\t\t\t}\n\t\t}\t\n\t}\n\t.paging_simple_numbers.dataTables_paginate{\n\t\tborder-color:$d-border;\t\t\t\n\t}\n\t.primary-icon{\n\t\tpath{\n\t\t\tstroke:$white;\t\n\t\t}\t\n\t}\n\t.pagin{\n\t\tborder-color:$d-border;\t\n\t}\n\t.nav-header .brand-title .brand-sub-title{\n\t\tcolor:$white;\t\n\t}\n\t.dashboard-calendar .fc-daygrid-day-frame.fc-scrollgrid-sync-inner{\n\t\tbackground:$dark-card;\n\t\tborder-color:$d-border;\n\t\t\n\t}\n\t.dashboard-calendar{\n\t\t.fc-non-business{\n\t\t\tbackground:$dark-card;\n\t\t\tborder-color:$d-border;\t\n\t\t}\n\t\t.fc-daygrid-day-number{\n\t\t\tcolor:$white;\t\t\n\t\t}\n\t}\n\t.event-calend .fc .fc-button-group > .fc-button{\n\t\tborder-color:$d-border;\t\n\t}\n\t.dashboard-calendar .fc-theme-standard td, .dashboard-calendar .fc-theme-standard th{\n\t\tborder-color:$d-border;\t\t\n\t}\n\t.dashboard-calendar .fc .fc-daygrid-more-link{\n\t\tcolor:$white;\t\n\t}\n\t.fc-theme-standard td, .fc-theme-standard th{\n\t\tborder-color:$d-border;\t\n\t}\n\t.fc-theme-standard .fc-scrollgrid.fc-scrollgrid-liquid, .fc-scrollgrid, table{\n\t\tborder-color:$d-border;\t\t\n\t}\n\t.fc-direction-ltr .fc-daygrid-event.fc-event-end, .fc-direction-rtl .fc-daygrid-event.fc-event-start{\n\t\tbackground:var(--primary);\t\n\t}\n\t.dlab-demo-panel .dlab-demo-inner{\n\t\tbackground:$d-bg;\t\n\t}\n\t.food-list-row{\n\t\tborder-color:$d-border;\t\n\t}\n\t.popover-body{\n\t\tcolor:$white;\t\n\t}\n\t.swal2-popup .swal2-content{\n\t\tcolor:$white;\t\t\n\t}\n\t.modal-header .close{\n\t\tbackground:none;\n\t}\n\t.timeline-panel{\n\t\t.media-body{\n\t\t\tsmall{\n\t\t\t\tcolor:$white;\n\t\t\t}\n\t\t}\n\t}\n\t.chatbox .card-header p{\n\t\tcolor:$white;\n\t}\n\t.date-ds-btn{\n\t\tbackground:$dark-card;\n\t\tcolor: white;\n\t}\n\t.food-list-row .media-bx h5 a, .food-list-row .media-bx .h5 a{\n\t\tcolor:$white;\n\t}\n\t.staff-bx .card-footer{\n\t\tbackground:#3f4056;\n\t}\n\t.page-titles .breadcrumb .breadcrumb-item + .breadcrumb-item:before{\n\t\tcolor:$white;\n\t}\n\t.table-striped > tbody > tr:nth-of-type(odd) > *{\n\t\tcolor: #706f6f;\n\t}\n\t.accordion .accordion-item{\n\t\tbackground: transparent;\n\t}\n\t.list-group-item{\n\t\tcolor:$white;\n\t}\n\t.form-control-plaintext{\n\t\tcolor:$white;\n\t}\n\tlabel{\n\t\tcolor:$white;\n\t}\n\t//jiade\n\t\n\t\n\t.form-control.custom-image-select-2 .filter-option-inner-inner{\n\t\tcolor:$white;\n\t}\n\t.table tbody tr td{\n\t\tcolor:$d-ctl;\n\t}\n\t.wallet-bar .order-history{\n\t\t.price-list{\n\t\t\t.chart-title{\n\t\t\t\t.text-secondary{\n\t\t\t\t\tcolor:var(--secondary)!important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.apexcharts-text tspan{\n\t\tfill:rgba(255,255,255,.6);\n\t}\n\t.apexcharts-xaxis{\n\t\tline{\n\t\t\tstroke:$d-border;\n\t\t}\n\t}\n\t.price-list .card-footer{\n\t\t.text-secondary{\n\t\t\tcolor:var(--primary)!important;\n\t\t}\n\t}\n\t.chart-title{\n\t\t.text-pink{\n\t\t\tcolor:$pink!important;\n\t\t}\n\t}\n\t.form-control.custom-image-select-2.style-1 .dropdown-toggle {\n\t\tbackground: rgba(172, 76, 188, 0.1)!important;\n\t}\n\t.form-control.custom-image-select-2 .dropdown-toggle{\n\t\tbackground:var(--rgba-primary-2)!important;\n\t}\n\t.transaction-table .card-body .table-responsive thead th{\n\t\tbackground:$d-bg;\n\t\tcolor:$white;\n\t}\t\n\t.market-chart{\n\t\t.text-secondary{\n\t\t\tcolor:var(--secondary)!important;\n\t\t\tsvg{\n\t\t\t\tpath{\n\t\t\t\t\tfill:var(--secondary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.chart-title p{\n\t\tcolor:$d-ctl;\n\t}\n\t.market-coin .coin-search-area .form-control{\n\t\tborder-color:$dark-card;\n\t\tbackground:$dark-card;\n\t}\n\t.market-coin .coin-search-area .input-group-text{\n\t\tborder-color:$dark-card;\n\t\tbackground:$dark-card;\n\t\tsvg{\n\t\t\tpath{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t.market-coin .coin-box{\n\t\tborder-color:$d-border;\n\t}\n\t.market-overview .get-report{\n\t\tcolor:var(--primary)!important;\n\t}\n\n\t.coin-content .guest-calendar{\n\t\tborder-color:$d-border;\n\t\tspan{\n\t\t\tsvg{\n\t\t\t\tpath{\n\t\t\t\t\tfill:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.reportrange{\n\t\t\tspan{\n\t\t\t\tcolor:$d-ctl;\n\t\t\t}\n\t\t}\n\t}\n\t.coin-content .default-select{\n\t\tborder-color:$d-border;\n\t\tcolor:$d-ctl;\n\t}\n\t.digital-cash .media .media-content p{\n\t\tborder-color:$d-border;\n\t\tcolor:$d-ctl;\n\t}\n\t.digital-cash .card-footer .btn{\n\t\tcolor:var(--primary)!important;\n\t}\n\t.form-control.custom-image-select-1 .dropdown-toggle{\n\t\tbackground:$d-bg!important;\n\t\tcolor:$white!important;\n\t\tborder-color:$d-border!important;\n\t}\n\t.form-control.custom-image-select-1 .filter-option-inner-inner{\n\t\tcolor:$white;\n\t}\n\t.coin-warpper .search-area .form-control{\n\t\tcolor:$d-ctl;\n\t}\n\t.coin-warpper .search-area .input-group-text{\n\t\tsvg{\n\t\t\tpath{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t.form-wrapper.trade-form .input-group .input-group-text{\n\t\tbackground:$d-bg;\n\t\tcolor:$d-ctl;\n\t}\n\t.market-overview .get-report,\n\t.market-preview,\n\t.market-overview .card-header h4, .market-overview .card-header .h4,\n\t.form-wrapper.trade-form .input-group .form-control:focus,\n\t.coin-warpper .nav .nav-item{\n\t\tborder-color:$d-border;\n\t}\n\t.coin-warpper{\n\t\tbackground:$dark-card;\n\t\tborder-color:$d-border;\n\t}\n\t.coin-warpper .nav .nav-item .nav-link svg{\n\t\tpath{\n\t\t\tfill:$white;\n\t\t}\n\t}\n\t.daterangepicker .calendar-table .next span, .daterangepicker .calendar-table .prev span{\n\t\tborder-color:$white;\n\t}\n\t.tbl-orders-style{\n\t\t.tp-btn{\n\t\t\tsvg{\n\t\t\t\tpath{\n\t\t\t\t\tstroke:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.customer-search{\n\t\t.search-area{\n\t\t\t.input-group-text{\n\t\t\t\tsvg{\n\t\t\t\t\tpath{\n\t\t\t\t\t\tfill:$white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.student-tbl tbody tr td{\n\t\tspan{\n\t\t\t.text-secondary{\n\t\t\t\tcolor:$white!important;\n\t\t\t}\n\t\t}\n\t}\n\t.market-preview:hover{\n\t\tbackground:$d-bg;\n\t}\n\t.bg-ripple-hover{\n\t\tthead{\n\t\t\ttr{\n\t\t\t\tth{\n\t\t\t\t\tcolor:#677686;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.dataTables_wrapper .dataTables_paginate span .paginate_button{\n\t\tcolor:$d-ctl!important;\n\t}\n\t.portofolio .my-profile .media .media-img a,\n\t.portofolio .my-profile .portofolio-social li a{\n\t\tborder-color:$d-border;\n\t}\n\t.coin-holding{\n\t\tborder-color:$d-border;\n\t}\n\t.tp-btn{\n\t\tsvg{\n\t\t\tpath{\n\t\t\t\tstroke:$white;\n\t\t\t}\n\t\t}\n\t}\n\t.copyright strong{\n\t\tcolor:#9fa4a6;\n\t}\n\t.support-box .info a{\n\t\tcolor:$black!important;\n\t}\n\t.btn-icon-end{\n\t\tborder-color:$d-border;\n\t}\n\t.donut-chart-sale small, .donut-chart-sale .small, .donut-chart-sale .small{\n\t\tcolor:$white;\n\t}\n\t.border-end{\n\t\tborder-color:$d-border!important;\n\t}\n\t.ck.ck-editor__main > .ck-editor__editable{\n\t\tbackground:$d-bg!important;\n\t}\n\t.change-btn{\n\t\ta{\n\t\t\t&:hover{\n\t\t\t\tcolor:$black;\n\t\t\t}\n\t\t}\n\t}\n\t.dlabnav .main-menu{\n\t\tcolor:$white;\n\t}\n\t.nav-pills .nav-link.active, .nav-pills:hover .show > .nav-link{\n\t\tbackground:var(--rgba-secondary-1);\n\t\tcolor:var(--secondary);\n\t}\n\t.toggle-switch .form-check-input:checked:after{\n\t\tbackground: var(--secondary);\n\t}\n\t.nav-pills .nav-link:hover{\n\t\tcolor:var(--secondary);\n\t}\n\t.table.bg-primary-hover th{\n\t\tcolor:var(--secondary);\n\t}\n\t.table.bg-primary-hover tr:hover td, .table.bg-primary-hover tr:hover th{\n\t\tbackground: var(--secondary);\n\t}\n\t.get-report{\n\t\tcolor:var(--secondary);\n\t}\n\t.btn-close{\n\t\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 352 512'%3E%3C!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --%3E%3Cpath d='M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z' fill='%23fff'/%3E%3C/svg%3E\");\n\t}\n\t.coin-holding .coin-box-warper a{\n\t\tbackground:$d-bg;\n\t}\n\t//finlab\n\n\t.card .card-box-icon{\n\t\tborder-color:$d-border;\n\t}\n\t.toggle-btn .check{\n\t\tbackground-color: $d-bg;\n\t}\n\t.toggle-btn .check:after{\n\t\tbackground:\t$white;\n\t}\n\t.toggle-btn input:checked ~ .check:after {\n\t\tdisplay: block;\n\t}\n\t.toggle-btn input:checked ~ .check {\n\t\tbackground-color: $d-bg;\n\t}\n\t.toggle-btn.expense .check:after {\n\t\tbackground-color: #FFFA6F;\n\t}\n\t\n\t.bootstrap-select .btn{\n\t\tcolor:$white;\n\t}\n\t#wallet-bar{\n\t\tbackground-color:$dark-card;\n\t\tborder-color:$d-border;\n\t}\n\t.page-titles{\n\t\tbackground:$dark-card;\n\t}\n\t.tags .tag{\n\t\tcolor:$white;\n\t\tbackground:rgba(255,255,255,0.1);\n\t}\n\t.server-content .progress{\n\t\tbackground-color:transparent;\n\t}\n\t.student .indox a::before{\n\t\tborder-color:$d-border;\n\t}\n\t#redial{\n\t\tcircle{\n\t\t\tfill: white;\n\t\t}\n\t}\n\t.dashboard-select{\n\t\t.bootstrap-select .btn{\n\t\t\tbackground:#383844;\n\t\t}\n\t}\n\t#activity{\n\t\tline{\n\t\t\tstroke:$d-border;\n\t\t}\n\t}\n\t.quick-info{\n\t\tbackground-color:$d-bg;\n\t\tborder: 1px solid $d-border;\n\t}\n\t.pagination.no-bg li:not(.page-indicator):not(.active) .page-link{\n\t\tbackground: $d-bg;\n\t\tborder-color: transparent;\n\t}\n\t.lastest_trans .trans-table .doller,\n\t.table-pagenation p span,\n\t.email-list .message .hader,\n\t.email-list .message .col-mail-2 .date,\n\t.dz-card .card-footer{\n\t\tcolor: rgba(255, 255, 255, 0.6);\n\t}\n\t.email-list .message:hover{\n\t\tbackground:$dark-card;\n\t}\n\t.print{\n\t\tsvg{\n\t\t\tpath{\n\t\t\t\tfill:rgba(255, 255, 255, 0.6);\n\t\t\t}\n\t\t}\n\t}\n\t.right-box-padding{\n\t\t&.border-start{\n\t\t\tborder-color:$d-border!important;\n\t\t}\n\t}\n\t.demo-right-inner{\n\t\tbackground-color:$dark-card;\n\t}\n\t.dzm-tabs{\n\t\tbackground-color:$d-bg;\n\t}\n\t.notification{\n\t\tp{\n\t\t\tcolor:$black;\n\t\t}\n\t}\n\t.Modal-box{\n\t\tbackground-color:$dark-card;\n\t}\n\t.Modal-box .box3{\n\t\tbackground-color:$d-bg;\n\t}\n\t.lastest_trans .trans-table .print,\n\t.lastest_trans .trans-table .btn.tp-btn.btn-primary{\n\t\tbackground-color:$d-bg;\n\t}\n\t.lastest_trans .trans-table .btn.tp-btn.btn-primary{\n\t\tbackground-color:$d-bg;\n\t\tsvg{\n\t\t\tcircle{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t.lastest_trans .trans-table:hover{\n\t\tbackground-color:$d-bg;\n\t}\n\t.previews-info:hover{\n\t\tbackground-color:$d-bg;\n\t}\n\t#activity1{\n\t\tline{\n\t\t\tstroke:$d-border;\n\t\t}\n\t}\n\t.dataTables_wrapper .dataTables_paginate .paginate_button.previous.disabled, .dataTables_wrapper .dataTables_paginate .paginate_button.next.disabled{\n\t\tcolor:$white!important;\n\t}\n\t.plus-bx a{\n\t\tbackground:$dark-card;\n\t}\n\t.kanbanimg li span,\n\t.kanbanimg img{\n\t\tborder-color:$d-border;\n\t}\n\t.drive,\n\t.file-header,\n\t.folder-structure li,\n\t.file-drive,\n\t.input-group.search-area,\n\t.user-photo img,\n\t.messages .student,\n\t.fc .fc-button-group > .fc-button,\n\t.fc-daygrid-dot-event,\n\t.box-2 .flow,\n\t.type-massage,\n\t.chat-box-area .media .message-received .dz-media,\n\t.chat-left-area .chat-sidebar,\n\t.email-right-box .table-pagenation,\n\t.email-list .message{\n\t\tborder-color:$d-border!important;\n\t}\n\t.timeline-active li:before{\n\t\tbackground:$d-border;\n\t}\n\t.selling .form_exchange .input_exchange .input-select{\n\t\tbackground-color:$dark-card;\n\t\tborder-color:$d-border;\n\t\tcolor:$white;\n\t}\n\t.hamburger{\n\t\tsvg{\n\t\t\trect{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t.dlabnav .metismenu > li.mm-active > a{\n\t\tcolor:$white!important;\n\t}\n\t.file_area .table-pagenation{\n\t\tbackground-color:$d-bg;\n\t}\n\t.email-list{\n\t\tbackground:$d-bg;\n\t}\n\t.email-list .message .col-mail-2 .subject{\n\t\tcolor:$white;\n\t}\n\t.email-right-box .table-pagenation,\n\t.email-right-box .pagination{\n\t\tbackground-color:$dark-card;\n\t}\n\t.email-left-box .mail-list a{\n\t\tcolor: rgba(255, 255, 255, 0.6);\n\t}\n\t.messages .input-group.search-area input.form-control,\n\t.messages .input-group.search-area .input-group-text{\n\t\tbackground-color:$d-bg;\n\t}\n\t.dz-info{\n\t\tsvg{\n\t\t\tpath{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t.message-box,\n\t.type-massage,\n\t.chat-box-area .media{\n\t\tbackground:$dark-card;\n\t\tcolor: white;\n\t}\n\t.chat-tabs .chat-bx:after,\n\t.message-box .input-group.search-area input.form-control,\n\t.message-box .input-group.search-area .input-group-text{\n\t\tbackground:$d-bg;\n\t}\n\t.search-coundry{\n\t\tbackground-color:$dark-card;\n\t\tborder-color:$d-border;\n\t\t.bootstrap-select .btn{\n\t\t\tbackground:$dark-card!important;\n\t\t\tcolor:$white;\n\t\t\t\n\t\t}\n\t}\n\t.header.is-fixed{\n\t\tbackground:var(--headerbg);\n\t}\n\t.datepicker.datepicker-dropdown th.datepicker-switch{\n\t\tcolor:rgba(255,255,255,0.6);\n\t\t&:hover{\n\t\t\tcolor:$black;\n\t\t}\n\t}\n\t.datepicker.datepicker-dropdown{\n\t\tborder-color:$d-border;\n\t}\n\t.datepicker.datepicker-dropdown .datepicker-days .table-condensed td.day{\n\t\tcolor: rgba(255,255,255,0.6);\n\t}\n\t.notification_dropdown .dropdown-menu-end .all-notification{\n\t\tborder-color:$d-border;\n\t}\n\t.header-profile2 .dropdown-menu a span{\n\t\tcolor:rgba(255,255,255,0.6);\n\t}\n\t.profile-card .card-header,\n\t.profile-card{\n\t\tborder-color:$d-border;\n\t}\n\t.profile-form .form-label{\n\t\tcolor:rgba(255,255,255,0.6);\n\t}\n\t.author-profile .info-list li,\n\t.profile-card .card-footer,\n\t.author-profile .upload-link{\n\t\tborder-color:$d-border;\n\t}\n\t.author-profile .info-list li a,\n\t.author-profile .author-info span,\n\t.author-profile .info-list li span{\n\t\tcolor:rgba(255,255,255,0.6);\n\t}\n\t.author-profile .card-footer .form-control{\n\t\tborder-color:$d-border;\n\t\tbackground:$d-bg!important;\n\t\t\n\t}\n\t.header-profile2{\n\t\t.dropdown-menu{\n\t\t\t.ai-icon{\n\t\t\t\t&:hover{\n\t\t\t\t\tbackground:$d-bg;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.wallet-bar .closed-icon{\n\t\tcolor:$white;\n\t}\n\t.select2-container--default .select2-selection--multiple .select2-selection__choice,\n\t.select2-container--classic .select2-selection--multiple .select2-selection__choice{\n\t\tbackground-color:$dark-card;\n\t\tborder-color:$dark-card;\n\t\t\n\t}\n\tmark, .mark,\n\t.select2-container--classic .select2-search--inline .select2-search__field{\n\t\tbackground-color:$d-bg;\n\t\tcolor:$white;\n\t}\n\t.select2-container--default .select2-search--inline .select2-search__field{\n\t\tcolor:rgba(255,255,255,0.6);\n\t}\n\t.select2-container--default .select2-results__option[aria-selected=true]{\n\t\tbackground-color:$d-bg;\n\t}\n\t.trans-info .icon{\n\t\tborder-color:$d-border;\n\t}\n\t.legendLabel{\n\t\tcolor:rgba(255,255,255,0.6);\n\t}\n\t.statistic-content{\n\t\tborder-color:$d-border;\n\t}\n\tp{\n\t\tcolor:$dbody-text;\n\t}\n\t.header-profile2 span{\n\t\tcolor:$dbody-text;\n\t}\n\t.page-titles{\n\t\t.datepicker.datepicker-dropdown th.prev:hover{\n\t\t\tcolor:$white!important;\n\t\t}\n\t}\n\t.compose-content .dropzone{\n\t\tborder-color:$d-border;\n\t}\n\t#alert-link{\n\t\ta{\n\t\t\tcolor:#768783;\n\t\t}\n\t}\n\t#message-alert{\n\t\tp{\n\t\t\tcolor: #666666;\n\t\t}\n\t}\n\t#AlertLeftIcon{\n\t\th5{\n\t\t\tcolor:#2A353A!important;\n\t\t}\n\t\tp{\n\t\t\tcolor: #666666;\n\t\t}\n\t}\n\t.header{\n\t\t&.is-fixed{\n\t\t\tborder-color:$d-border!important;\n\t\t}\n\t}\n\t.sidebar-right-inner{\n\t\t.bootstrap-select .btn{\n\t\t\tbackground:transparent!important;\n\t\t\tcolor: #2A353A;\n\t\t\tborder-color:$border-color!important;\n\t\t}\n\t\t.dropdown-menu{\n\t\t\tbackground-color: #fff;\n\t\t\t.dropdown-item {\n\t\t\tcolor:#777777;\n\t\t\t\t&.selected,\n\t\t\t\t&.selected.active,\n\t\t\t\t&.active,\n\t\t\t\t&:hover, \n\t\t\t\t&:focus {\n\t\t\t\t\tbackground-color:var(--rgba-primary-1);\n\t\t\t\t\tcolor: #2A353A;\n\t\t\t\t}\n\t\t\t}\t\n\t\t}\n\t}\n\t.type_msg{\n\t\t.form-control{\n\t\t\tbackground-color:$dark-card;\n\t\t\tbox-shadow:none;\n\t\t}\n\t}\n\t.email-left-box{\n\t\tborder-color:$d-border;\n\t}\n\t.alert .btn-close{\n\t\tbackground-image: none!important;\n\t}\n\t#main-wrapper{\n\t\tbackground-color:$d-bg;\n\t}\n\t.prot-blog .fill a{\n\t\t&:hover{\n\t\t\tcolor:black;\n\t\t}\n\t}\n\t.table-striped > tbody > tr:nth-of-type(odd) > *{\n\t\tbackground: #1e1e25;\n\t\tcolor: white!important;\n\t}\n\t\n\t.dlabnav{\n\t\tborder-color:$d-border;\n\t}\n\t.kanban-user .users li span,\n\t.kanban-user .users li img{\n\t\tborder-color:$d-border;\n\t}\n\t.plus-bx{\n\t\ta{\n\t\t\tsvg{\n\t\t\t\tpath{\n\t\t\t\t\tfill:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.page-title{\n\n\t\tbackground-color: $dark-card;\n\t}\n\t.chat-mid-area{\n\t\t&.bg-white{\n\t\t\tbackground-color: $dark-card!important;\n\n\t\t}\n\n\t} \n\t.message-box{\n\t\tborder-color:$d-border;\n\t\t\n\t}\n\t.message-received{\n\t\tp{\n\n\t\t\tbackground-color: $d-bg!important;\n\t\t\tcolor:$white!important;\n\t\t}\n\t}\n\t.input-group.user-search-area .input-group-text{\n\t\tbackground-color: $d-bg;\n\t\tborder-color:$d-border;\n\t}\n\t.input-group.user-search-area .form-control{\n\n\t\tborder-color:$d-border;\n\t}\n\t.datepicker-days .table-condensed td.day{\n\t\tcolor:$white;\n\t}\n\t.datepicker-days .table-condensed thead th.picker-switch{\n\t\tcolor:$white;\n\t}\n\t.datepicker-days .table-condensed thead th.prev, .datepicker-days .table-condensed thead th.picker-switch, .datepicker-days .table-condensed thead th.next{\n\n\t\tcolor:$white;\n\t}\n\t@keyframes blinking {\n        0% {\n          background-color:var(--primary);\n\n        }\n        100% {\n          background-color:transparent;\n\n        }\n    }\n\tinput-group.search-area{\n\t\tborder-color:$d-border!important;\n\n\t}\n\t.doller{\n\n\t\tcolor:$white;\n\t}\n\t.apexcharts-tooltip.apexcharts-theme-light{\n\t\tbackground-color:rgba(255, 255, 255, 0.96);\n\t\tcolor:#000;\n\n\t}\n\t.ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred{\n\t\tborder-color:$d-border;\n\t}\n\t.all{\n\t\t.show{\n\t\t\t\t\n\t\t\t.card-header{\n\n\t\t\t\tbackground-color: $d-border!important;\n\t\t\t\tborder-radius: $radius!important;\n\n\t\t\t}\n\t\t\t.nav-link{\n\t\t\t\twidth:2.5rem;\n\t\t\t\tmin-width:2.5rem;\n\t\t\t\theight:2.5rem;\n\t\t\t\tmargin: 5px;\n\t\t\t\tbackground-color: $dark-card!important;\n\t\t\t}\n\t\t}\n\t}\n\t.note-text{\n\t\tcolor:#000;\n\n\t}\n\t.timeline-active.style-1 .timeline-list:before{\n\t\tborder-color:$d-border;\n\t}\n\t.authincation{\n\t\tbackground-color:$d-bg;\n\t\t\n\t}\n\t.authincation-content.style-2 .form-control{\n\t\tborder-color:$d-border;\n\t}\n\t.label-color,\n\t.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed td.day,\n\t.bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.prev, .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.picker-switch, .bootstrap-datetimepicker-widget .datepicker .datepicker-days .table-condensed thead th.next{\n\t\tcolor:$white;\n\t}\n\t.authincation{\n\t\tbackground-image: url(\"../images/student-bg-Recovered.jpg\")!important;\n\t}\n\t.table-responsive .table-striped th{\n\t\tbackground-color:var(--rgba-primary-1);\n\t\tcolor:$white;\n\t}\n\t.dz-card .card-body.code-area,\n\t.demo-view .code-area{\n\t\n\t\tbackground-color:$dark-card;\n\t\tborder-color:$d-border;\n\t}\n\n\t.dz-calender{\n\t\t.react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name{\n\t\t\tcolor: $white;\n\t\t}\n\t\t.react-datepicker__current-month {\n\t\t\tcolor: $white;\n\t\t}\n\t\t.react-datepicker__navigation{\n\t\t\tbackground: none;\n\t\t}\n\t\t.react-datepicker__navigation-icon:before {\n\t\t\tborder-color: $white;\n\t\t}\n\t}\n\t#overiewChart line {\n\t\tstroke: #444;\n\t}\n}\n","[data-theme-version=\"dark\"] {\n    &[data-layout=\"vertical\"]{\n\t\t&[data-sidebar-position=\"fixed\"]{\n\t\t\t.header{\n\t\t\t\tborder-color:$d-border;\n\t\t\t}\n\t\t\t.brand-sub-title{\n\t\t\t\tcolor:$white;\t\n\t\t\t}\n\t\t}\n\t}\n    .header {\n\t\tborder-color:$d-border;\n    }\n\n    .header-left {\n        .dashboard_bar{\n\t\t\tcolor:$white;\n\t\t}\n\t\t.search-area{\n\t\t\t.form-control{\n\t\t\t\tbackground:$dark-card;\n\t\t\t}\n\t\t\t.input-group-text{\n\t\t\t\tborder:0;\n\t\t\t\tbackground:$dark-card;\n\t\t\t\ta{\n\t\t\t\t\tcolor:#4f7086;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.input-group.search-area{\n\t\t\tborder-color:#58586A;\n\t\t}\n    }\n\n    .header-right {\n\t\t\n\t\t.notification_dropdown .nav-link{\n\t\t\t/* background: $d-bg!important; */\n\t\t\t.badge{\n\t\t\t\tborder-color:$dark-card;\n\t\t\t}\n\t\t\t// svg{\n\t\t\t// \tpath{\n\t\t\t// \t\tfill:$white;\n\t\t\t// \t}\n\t\t\t// }\n\t\t}\n        .dropdown {\n            .nav-link {\n\t\t\t\tcolor: $white;\n\t\t\t\tbackground-color:$d-bg!important;\n\t\t\t\tborder-color:$d-border!important;\n                &:hover {\n                    color: $white;\n                }\n            }\n\t\t\t&.header-profile2{\n\t\t\t\t.nav-link {\n\t\t\t\t\tbackground-color: transparent!important;\n\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n        }\t\n    }\n\t\n\t.nav-header .hamburger .line{\n\t\tbackground:$white!important;\n\t}\n\t.menu-toggle .nav-header .nav-control .hamburger .line {\n\t\tbackground-color: $white !important;\n\t}\n}\n\n//other header component\n.change-btn a{\n\tcolor:$black;\n}","[data-theme-version=\"dark\"] {\n    &[data-sidebar-style=\"mini\"] {\n\t\t.dlabnav .metismenu li > ul{\n\t\t\tbackground-color: $dark-card;\n\t\t}\n\t}\n\t\n\t.fixed-content-box{\n\t\tbackground-color: $dark-card;\n\t\t.head-name{\n\t\t\tbackground:$dark-card;\n\t\t\tcolor: $white;\n\t\t\tborder-color:$d-border; \n\t\t}\n\t\t& + .header + .dlabnav{\n\t\t\tbackground-color: $d-bg;\n\t\t}\n\t}\n\t &[data-layout=\"vertical\"]{\n\t\t&[data-sidebar-position=\"fixed\"]{\n\t\t\t.dlabnav{\n\t\t\t\tborder-color:$d-border;\n\t\t\t}\n\t\t}\n\t\t&[data-sidebar-style=\"compact\"] {\n\t\t\t.dlabnav{\n\t\t\t\t.metismenu{\n\t\t\t\t\t&>li{ \n\t\t\t\t\t\t&.mm-active,\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t&>a {\n\t\t\t\t\t\t\t\tbackground:transparent;\n\t\t\t\t\t\t\t\ti{\n\t\t\t\t\t\t\t\t\tcolor:var(--primary);\n\t\t\t\t\t\t\t\t\tbackground:var(--rgba-primary-1);\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\ta{\n\t\t\t\t\t\t\t&>i{\n\t\t\t\t\t\t\t\tcolor:rgba($white,0.3);\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.ps__thumb-y {\n\t\tbackground-color: $d-border;\n\t}\n\t.dlabnav .metismenu > li.mm-active > a{\n\t\tcolor:$white!important;\n\t}\n    .dlabnav {\n\t\t.header-profile > a.nav-link{\n\t\t\tborder-color:$d-border;\n\t\t\t.header-info span{\n\t\t\t\tcolor:$white;\n\t\t\t}\n\t\t}\n        .metismenu {\n    \n    \n            &>li {\n\t\t\n                &>a {\n                    color: darken($color: $white, $amount: 30%);\n                }\n    \n                &:hover, \n                &:focus, \n                &.mm-active {\n    \n                    &>a {\n                        color: $white;\n\t\t\t\t\t\t background:var(--primary)!important;\n                        &::after {\n\t\t\t\t\t\t\tborder-left: 0.2125rem solid $white;\n                            border-top: 0.2125rem solid $white;\n\t\t\t\t\t\t\tborder-bottom: 0.2125rem solid transparent;\n\t\t\t\t\t\t\tborder-right: 0.2125rem solid transparent;\n                        }\n\t\t\t\t\t\ti{\n\t\t\t\t\t\t\tcolor:$white!important;\n\t\t\t\t\t\t}\n                    }\n                }\n    \n                &.mm-active {\n\t\t\t\t\t\n                    ul {\n\t\t\t\t\t\t\n                        ul {\n                            background-color: transparent;\n                        }\n                    }\n                }\n            }\n    \n            //one step dropdown\n            ul  {\n                \n\t\t\t\t&:after{\n\t\t\t\t\tbackground-color:$d-border;\n\t\t\t\t}\n\t\t\t\t\n                a {\n    \n                    &:hover,\n                    &:focus, \n                    &.mm-active {\n                        color: $white!important;\n                    } \n\t\t\t\t\t&:before{\n\t\t\t\t\t\tbackground-color: $white;\n\t\t\t\t\t}\n\t\t\t\t\t\n                }\n            }\n            \n            a {\n                color:rgba(255, 255, 255, 0.6)!important;\n            }\n    \n            .has-arrow {\n                &:after {\n                    border-top: 0.2125rem solid #b3b3b3;\n\t\t\t\t\tborder-left: 0.2125rem solid #b3b3b3;\n\t\t\t\t\tborder-bottom: 0.2125rem solid transparent;\n\t\t\t\t\tborder-right: 0.2125rem solid transparent;\n                }\n            }\n        }\n    }\n    \n    \n\n}","[data-theme-version=\"dark\"] {\n    .sidebar-right {\n\t\t.card-tabs{\n\t\t\t.nav-tabs{\n\t\t\t\tborder-color: var(--rgba-primary-1)!important;\n\t\t\t\t.nav-item{\n\t\t\t\t\t.nav-link{\n\t\t\t\t\t\tcolor:$black!important;\n\t\t\t\t\t}\n\t\t\t\t} \n\t\t\t}\n\t\t}\n\t\t.form-control{\n\t\t\tbackground:$white;\n\t\t\tcolor:$black;\n\t\t\tborder-color:$border-color;\n\t\t}\n\t\t.default-select .list{\n\t\t\tbackground:$white;\n\t\t\t.option{\n\t\t\t\t&.selected,&.focus,&:hover{\n\t\t\t\t\tbackground:rgba($black,0.05)!important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.sidebar-right-inner>h4{\n\t\t\tcolor:$black!important;\n\t\t}\n\t\t.nice-select .option {\n\t\t\tbackground: #fff;\n\t\t}\n    }\n}","[data-theme-version=\"dark\"] {\n    .footer {\n        background-color:$dark-card;\n\n        .copyright {\n            background-color: transparent;\n\n            p {\n                color: $white;\n            }\n        }\n    }\n}","pre {\n    display: block;\n    margin-top: 0;\n    margin-bottom: 1rem;\n    overflow: auto;\n    font-size: 0.875em;\n\t-moz-tab-size: 16;\n    tab-size: 2;\n\tcode.hljs {\n\t\tdisplay: block;\n\t\toverflow-x: auto;\n\t\tcolor: #fff;\n\t\tpadding:0;\n\t}\n} \n.hljs-tag .hljs-attr, \n.hljs-tag .hljs-name {\n    color: var(--primary);\n}\n.hljs-punctuation, \n.hljs-tag {\n    color: var(--secondary);\n}\n.hljs-deletion, \n.hljs-number, \n.hljs-quote, \n.hljs-selector-class, \n.hljs-selector-id, \n.hljs-string, \n.hljs-template-tag,\n.hljs-type {\n    color: #ffa8a8;\n}","/* =============\n   Calendar\n============= */\n\n.app-fullcalender {\n    button {\n        border-radius: 0rem;\n        color: $dark;\n    }\n    td{\n        border-color: $border;\n    }\n}\n\n.calendar {\n    float        : left;\n    margin-bottom: 0;\n}\n\n.fc-view {\n    margin-top: 1.875rem;\n}\n\n.fc-toolbar {\n    margin-bottom: 0.3125rem;\n    margin-top   : 0.9375rem;\n\n    & .fc-left {\n        @include media-breakpoint-down(xs) {\n            display: flex;\n            justify-content: space-between;\n            margin-bottom: 0.625rem;\n            float: none;\n        }\n    }\n\n    & .fc-right {\n        @include media-breakpoint-down(xs) {\n            display: flex;\n            justify-content: center;\n            float: none;\n            margin-bottom: 0.3125rem;\n        }\n    }\n\n    & .fc-center {\n        @include media-breakpoint-down(xs) {\n            display: flex;\n            justify-content: center;\n            * {\n                float: none;\n            }\n        }\n    }\n}\n\n.fc-toolbar h2 {\n    font-size     : 1rem;\n    font-weight   : 600;\n    line-height   : 1.875rem;\n    text-transform: uppercase;\n}\n\n\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active,\n.fc-toolbar .ui-state-hover,\n.fc-toolbar button:focus,\n.fc-toolbar button:hover {\n    z-index: 0;\n    box-shadow: none;\n}\n\n.fc-widget-header {\n    border: 0.0625rem solid $border;\n    border-bottom: 0 !important;\n}\n\n\n\n// .fc-widget-content {\n//     border: 0.0625rem solid #E5E5E5 !important;\n// }\n\n.fc th.fc-widget-header {\n    background    : $border!important;\n    font-size     : 0.875rem;\n    line-height   : 1.25rem;\n    padding       : 0.625rem 0;\n    text-transform: uppercase;\n}\n\n.fc-button {\n    border        : 0.0625rem solid $border;\n    text-transform: capitalize;\n    &.active{\n        box-shadow: none!important;\n    }\n}\n\n.fc-text-arrow {\n    font-family: inherit;\n    font-size  : 1rem;\n}\n\n\n\n.fc-event ,\n.external-event{\n    border-radius: 0.125rem;\n    border       : none;\n    cursor       : move;\n    font-size    : 0.8125rem;\n    margin       : 0.3125rem 0.4375rem;\n    padding      : 0.3125rem;\n    text-align   : center;\n}\n\n.external-event {\n    cursor : move;\n    margin : 0.625rem 0;\n    padding: 0.125rem 0;\n}\n\n.fc-basic-view td.fc-week-number span {\n    padding-right: 0.3125rem;\n}\n\n.fc-basic-view td.fc-day-number {\n    padding-right: 0.3125rem;\n}\n\n#drop-remove {\n    margin-right: 0.5rem;\n    top   : 0.1875rem;\n}\n\n#add-category,\n#event-modal {\n\n    .modal-dialog {\n        max-width: 37.5rem;\n    }\n}\n\n.fc-content {\n    color: $white;\n}\n// .fc-widget-content {\n//     border: 0.0625rem solid $l-border!important;\n// }\n.fc th.fc-widget-header {\n    // background: $l-border!important;\n    background: transparent !important;\n}\n.fc-button {\n    background: $white;\n    // color: $l-ctl;\n}\n.fc-state-hover {\n    background: $white!important;\n}\n.fc-state-highlight {\n    background: $l-bg!important;\n    @at-root [data-theme-version=\"dark\"] & {\n        color: $white!important;\n    }\n}\n.fc-cell-overlay {\n    background: $white!important;\n}\n.fc-unthemed .fc-today {\n    background: $l-bg!important;\n}\n\n.fc-day-top{\n    color: $dark !important;\n    @at-root [data-theme-version=\"dark\"] & {\n        color: $white!important;\n    }\n}\n\n.external-event {\n    color: $white;\n    @at-root [data-theme-version=\"dark\"] & {\n        color: $white!important;\n    }\n}\n.fc-basic-view .fc-body .fc-row {\n    min-height: 1rem;\n}\n\n.fc-scroller.fc-day-grid-container {\n    height: 30.625rem !important;\n}\n\n.fc-row.fc-week.fc-widget-content.fc-rigid {\n    height: 5.0625rem !important;\n}\n\n.email_left_pane {\n    @include custommq($max: 90rem) {\n        display: none;\n    }\n}\n\n\n\n#external-events{\n    \n\t.external-event:before{\n\t\tcontent: \"\";\n\t\tdisplay: block;\n\t\twidth: 0.875rem;\n\t\tmin-width:0.875rem;\n\t\theight: 0.875rem;\n\t\tborder-radius: 50%;\n\t\tmargin-right: .9rem;\n\t\tposition: relative;\n\t\ttop: 0.125rem;\n\t}\n    [data-class=\"bg-primary\"]{\n        @at-root [data-theme-version=\"dark\"] & {\n            color: $white!important;\n        }\n        &::before{\n            background: var(--primary);\n        }\n    }\n    [data-class=\"bg-success\"]{\n\n        &::before{\n            background: $success;\n        }\n    }\n    [data-class=\"bg-warning\"]{\n        &::before{\n            background: $warning;\n        }\n    }\n    [data-class=\"bg-dark\"]{\n        &::before{\n            background: $dark;\n        }\n    }\n    [data-class=\"bg-danger\"]{\n        &::before{\n            background: $danger;\n        }\n    }\n    [data-class=\"bg-info\"]{\n        &::before{\n            background: $info;\n        }\n    }\n    [data-class=\"bg-pink\"]{\n        &::before{\n            background: $pink;\n        }\n    }\n\t[data-class=\"bg-secondary\"]{\n        &::before{\n            background: $secondary;\n        }\n    }\n}\n\n\n.fc .fc-row .fc-content-skeleton table, \n.fc .fc-row .fc-content-skeleton td, \n.fc .fc-row .fc-helper-skeleton td {\n    border-color: $border;\n    \n    @at-root [data-theme-version=\"dark\"] & {\n        border-color: $d-border;\n    }\n}\n\n.fc-unthemed .fc-content, .fc-unthemed .fc-divider, .fc-unthemed .fc-list-heading td, .fc-unthemed .fc-list-view, .fc-unthemed .fc-popover, .fc-unthemed .fc-row, .fc-unthemed tbody, .fc-unthemed td, .fc-unthemed th, .fc-unthemed thead {\n    @at-root [data-theme-version=\"dark\"] & {\n        border-color: $d-border;\n    }\n}",".email-left-box {\n\tborder-right: 1px solid $border-color;\n    height: calc(100vh - 83px);\n    padding: 1.875rem 1.25rem;\n    overflow-y: auto;\n    .btn.text-white.btn-block{\n        background-color:var(--bs-body-color);\n        font-weight: 500;\n        font-size: 0.938rem;\n        white-space: nowrap;\n    }\n\t@include respond('phone-land') {\n\t\twidth: 100%;\n\t\tfloat: none;\n        border: none;\n\t\tpadding-bottom: 1.875rem !important;\n\t}\n\t@include respond ('phone'){\n\t\tpadding-bottom: 0rem !important;\n\t}\n\n    .intro-title{\n        padding: 1rem;\n        margin: 1.875rem 0 1.25rem 0;\n\n        h5{\n            margin-bottom: 0;\n            font-size: 1rem;\n            font-weight: 500;\n            i{\n                font-size: 0.75rem;\n                position: relative;\n                bottom: 0.0625rem;\n            }\n        }\n\n        i{\n            // font-size: 1.0625rem;\n            color: var(--primary);\n\n        }\n    }\n    .mail-list {\n        margin-top: 2.188rem;\n        a {\n            border: 0;\n            vertical-align: middle;\n            padding: 0.625rem 0.9375rem;\n            display: block;\n            background: transparent;\n            color: $l-ctd;\n            // font-size: 1.0625rem;\n            font-weight: 600;\n            z-index: 1;\n        }\n        \n        .change {\n            color: #666666;\n            font-weight: 500;\n        }\n        \n        .list-group-item{\n            border-radius: 10px;\n            padding: 0.75rem 1.0625rem;\n            font-size: 0.938rem;\n            font-weight: 500;\n            margin-bottom: 0.625rem;\n            overflow: hidden;\n    \n            i{\n                font-size: 1.125rem;\n                padding-right: 1.125rem;\n                color: $body-text;\n            }\n            svg{\n                margin-right: 1.125rem;\n            }\n    \n            &.active{\n                color: $secondary;\n                background-color: var(--rgba-secondary-1);\n                span.badge{\n                    background-color: var(--secondary);\n                }\n    \n                i{\n                    color: var(--secondary);\n                }\n            }\n            &.change{\n                margin-bottom: 0;\n            }\n            &::before{\n                content: '';\n                display: block;\n                background-color: var(--rgba-secondary-1) ;\n                color: var(--secondary);\n                position: absolute;\n                left: 0;\n                top: 0;\n                width: 0%;\n                height: 100%;\n                @include transitionMedium;\n\n            }\n            &:hover{\n                color: var(--secondary);\n                &::before{\n                    width: 100%;\n                }\n                i{\n                    color: var(--secondary);\n                }\n                svg{\n                    path{\n                        fill: var(--secondary);\n                        stroke: var(--secondary);\n                    }\n                }\n            }\n        }\n    }\n\t@include respond ('phone'){\n\t\theight: calc(100vh - 160px);\n\t}\n    \n}\ninput#checkAll.form-check-input {\n    background-color: $white;\n}\ninput#checkAll.form-check-input:checked{\n    background-color: var(--primary);\n}\n.email-right-box {\n    // padding-top: 1.875rem;\n    padding-left: 15rem;\n    padding-right: 1rem;\n\t\n    .pagination {\n        padding :  0.7rem 0;\n        margin-bottom: 0rem;\n        background-color: #fff;\n    }\n    @include media-breakpoint-between(sm, md) {\n        padding-left: 0;\n\t\tpadding-right:0;\n\t\tmargin-left: 0!important;\n\t\tclear:both;\n\t}\n\n    @include media-breakpoint-down(xs) {\n        padding-left: 0;\n        padding-right: 0;\n    }\n\n    // &.generic-position{\n    //     padding-left: 15rem;\n\n    //     @media(min-width: 106.25rem){\n    //         padding-left: 18.75rem;\n    //     }\n    // }\n\n    .right-box-border{\n        border-right: 0.125rem solid var(--rgba-primary-1);\n    }\n\n    .right-box-padding{\n        @media screen and (min-width: 40.5625rem) and (max-width: 75rem){\n            padding-left: 1.25rem;\n        }\n\n        @media(min-width: 106.25rem){\n            padding-left: 0.9375rem;\n        }\n\t\t@include media-breakpoint-between(sm, md) {\n\t\t\tpadding-left: 1rem;\t\t\t\n\t\t}\n        @include respond('phone'){\n            padding: 1rem;\n        }\n    }\n    .table-pagenation{\n        background-color: #fff;\n        margin-top:0;\n        border: 1px solid $border-light;\n        border-width: 1px 0w;\n    }\n    \n\n}\n\n.toolbar {\n    height: 3.563rem;\n    @include respond('tab-land'){\n        height: auto;\n    }\n    @include respond('tab-port'){\n        border-top: 1px solid $border-light;\n\t\tpadding-top:10px;\n    }\n  \n    .btn-group {\n        .btn.nav-link.active {\n            // background: $dark;\n            border: 0;\n            background-color: transparent;\n            color: $main-color;\n            font-size: 0.938rem;\n            padding: 0.5rem 0.2rem;\n             color: var(--primary);\n            // i {\n            //     color: $white!important;\n            // }\n            @include respond('tab-land'){\n                padding: 0.5rem 1rem;\n            }\n            &::before{\n                content: '';\n                display: block;\n                background-color: var(--primary);\n                position: absolute;\n                bottom: -0.625rem;\n                left: 50%;\n                transform: translateX(-50%);\n                width: 100%;\n                height: 3px;\n                @include transitionMedium;\n                @include respond('laptop'){\n                   display: none; \n                }\n\n            }\n          \n            &:focus{\n                box-shadow: none;\n            }\n            svg{\n                path{\n                    fill: var(--primary);\n                }\n            }\n\n        }\n        .btn.nav-link{\n            &::before{\n                content: '';\n                display: block;\n                background-color: var(--primary);\n                position: absolute;\n                bottom: -0.625rem;\n                left: 50%;\n                transform: translateX(-50%);\n                width: 0%;\n                height: 3px;\n                @include transitionMedium;\n\n            }\n            &:hover::before{\n                width: 100%;\n            }\n            &:hover{\n                svg{\n                    path{\n                        fill: var(--primary);\n                    }\n                }\n            }\n            svg{\n                margin-right: 0.5rem;\n                margin-bottom: 0.2rem;\n\n            }\n        }\n\n        input{\n            position: relative;\n            top: 0.125rem;\n        }\n        \n    }\n}\n\n.saprat {\n\tdisplay: flex;\n\tjustify-content: space-between;\n    align-items: center;\n    height: 100%;\n    flex-wrap: wrap;\n    .btn-group{\n        margin-left: 1.125rem;\n    }\n    @include respond('phone-land'){\n        flex-wrap: wrap;\n    }\n    .mail-tools{\n        @include respond('tab-land'){\n            margin-left: 5.125rem;\n        }\n\t\ta{\t\n\t\t\t&:hover{\n\t\t\t\tsvg{\n\t\t\t\t\tbackground:var(--rgba-primary-1);\n\t\t\t\t\tborder-radius:$radius-sm;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t\t\t\n\t\t}\n       \n    }\n\n}\n\n.read-content {\n    textarea {\n        height:9.375rem;\n\t\tpadding: 0.9375rem 1.25rem;\n\t\tborder-radius:$radius;\n    }\n\n    &-email{\n        font-size: 0.875rem;\n    }\n\n    h5{\n        color: #6a707e;\n    }\n\n    p{\n\n        strong{\n            color: #6a707e;\n        }\n    }\n\n    &-body{\n\n        p{\n            margin-bottom: 1.875rem;\n        }\n    }\n\n    &-attachment{\n        padding: 0.5rem 0;\n\n        h6{\n            font-size: 1.125rem;\n            color: #6a707e;\n\n            i{\n                padding-right: 0.3125rem;\n            }\n        }\n\n        .attachment{\n\t\t\ta{\n\t\t\t\tcolor:var(--primary)!important;\n\t\t\t}\n            & > div:not(:last-child){\n                border-right: 0.0625rem solid #DDDFE1;\n            }\n        }\n    }\n}  \n.compose-wrapper{\n    height: calc(100vh - 180px);\n    overflow-y: scroll;\n    padding: 0 1rem;\n\n    @include respond ('phone'){\n\n        height:calc(100vh - 337.7px);\n    }\n}\n.read-wapper{\n    height: calc(100vh - 180px); \n\tpadding: 0 1.25rem;\n}\n.compose-content {\n    \n    .wysihtml5-toolbar {\n        border-color: $l-border;\n    }\n    // .textarea_editor {\n    //     background: $l-bg!important;\n    // }\n    .dropzone {\n        background: $l-bg!important;\n    }\n\n    h5{\n        font-size: 1.0625rem;\n        color: #6a707e;\n\n        i{\n            font-size: 1.125rem;\n            transform: rotate(90deg);\n        }\n    }\n\n    .dropzone{\n        border: 0.0625rem dashed #DDDFE1;\n        min-height: 13.125rem;\n        position: relative;\n\t\tborder-radius:$radius;\n\n        .dlab-message{\n            margin: 0;\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            transform: translate(-50%, -50%);\n        }\n    }\n}\n\n.email-list {\n    display: block;\n    padding-left: 0;\n    background: #f3f3f3;\n    height: calc(100vh - 212px);\n    overflow-y: scroll;\n    label{\n        margin-bottom: 0px;\n    }\n    .message {\n        position: relative;\n        display: block;\n        height: 3.438rem;\n\t\tpadding: 0 15px;\n        line-height: 3.438rem;\n        cursor: default;\n        transition-duration: 0.3s;\n        border-bottom: 1px solid $border-light;\n        a {\n            color: $main-color;\n        }\n\n        &-single{\n            .custom-checkbox{\n                margin-top: 0.125rem;\n            }\n\n            i{\n                color: $muted;\n                font-size: 1.125rem;\n                padding-left: .4rem;\n            }\n        }\n\t\t\n\t\t.icon {\n\t\t\tposition: absolute;\n\t\t\ttop: 16px;\n\t\t\tright: 10px;\n\t\t\topacity: 0;\n\t\t\ttransition-duration: 0.3s;\n\t\t}\n\n\n        &:hover {\n            transition-duration: 0.05s;\n            background: #F3F5F7;\n\t\t\t.icon {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t\t.col-mail-2 {\n\t\t\t\t.date {\n\t\t\t\t\topacity: 0;\n\t\t\t\t}\n\t\t\t}\n            .message-single{\n                .form-check-input{\n                    opacity: 1;\n                }\n            }\n        }\n\n        .col-mail {\n            float: left;\n            position: relative;\n        }\n\n        .col-mail-1 {\n            width: 5.625rem;\n\n            .star-toggle {\n                display: block;\n                float: left;\n                margin-top: 1.125rem;\n                font-size: 1rem;\n                margin-left: 0.3125rem;\n            }\n\n            .email-checkbox {\n                display: block;\n                float: left;\n                margin: 0.9375rem 0.625rem 0 1.25rem;\n            }\n\n            .dot {\n                display: block;\n                float: left;\n                border: .4rem solid transparent;\n                border-radius: 6.25rem;\n                margin: 1.375rem 1.625rem 0;\n                height: 0;\n                width: 0;\n                line-height: 0;\n                font-size: 0;\n            }\n        }\n\n        .col-mail-2 {\n            position: absolute;\n            top: 0;\n            left: 5.625rem;\n            right: 0;\n            bottom: 0;\n\n            .subject {\n                position: absolute;\n\t\t\t\ttop: 0;\n\t\t\t\tleft: 0;\n\t\t\t\tright: 5.5rem;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tcolor: black;\n\t\t\t\tmargin: 0 220px;\n\t\t\t\ttext-overflow: ellipsis;\n\t\t\t\toverflow: hidden;\n\t\t\t\twhite-space: nowrap;\n\t\t\t\tspan {\n\t\t\t\t\tcolor: #666666;\n\t\t\t\t}\n            }\n\n            .date {\n                position: absolute;\n                top: 0;\n                right: 15px;\n\t\t\t\topacity: 1;\n\t\t\t\ttransition-duration: 0.3s;\n                font-weight: 500;\n                // width: 4rem;\n                // padding-left: 5rem;\n            }\n        }\n\t\t.message-single {\n\t\t\t.bookmark-btn {\n\t\t\t\tinput {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\theight: 0;\n\t\t\t\t\twidth: 0;\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t\t.checkmark {\n\t\t\t\t\tfont-weight: 900;\n\t\t\t\t\tfont-family: 'font awesome 5 free';\n\t\t\t\t\t&:before {\n\t\t\t\t\t\tcontent: \"\\f005\";\n\t\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t\t\tborder-color: #666666;\n\t\t\t\t\t\tfont-weight: 100;\n                        color: #C4C4C4;\n\t\t\t\t\t} \n\t\t\t\t}\n\t\t\t\tinput:checked~.checkmark:before {\n\t\t\t\t\tcolor: #ff9838;\n\t\t\t\t\tfont-weight: 900;\n\t\t\t\t}\n\t\t\t}\n            .form-check-input{\n                margin-top: 0;\n            }\n\t\t}\n        .hader {\n            font-size: 0.938rem;\n            font-weight: 500;\n            padding: 0 1.25rem;\n        }\n    }\n    \n}\n\n.email-checkbox {\n    cursor: pointer;\n    height: 0.9375rem;\n    width: 0.9375rem;\n    position: relative;\n    display: inline-block;\n    border-radius: .1rem;\n    position: relative;\n    top: 0.3125rem;\n    box-shadow: inset 0 0 0 .1rem $l-ctl;\n\n    input {\n        opacity: 0;\n        cursor: pointer;\n\n        &:checked {\n            label {\n                opacity: 1;\n            }\n        }\n    }\n\n    label {\n        position: absolute;\n        top: .3rem;\n        left: .3rem;\n        right: .3rem;\n        bottom: .3rem;\n        cursor: pointer;\n        opacity: 0;\n        margin-bottom: 0 !important;\n        transition-duration: 0.05s;\n    }\n}\n\n\n\n.chat-wrap{\n    padding: 1.0625rem 1.875rem;\n\n    .media{\n\n        .media-body{\n\n            h6{\n                font-size: 1.0625rem;\n                color: #6a707e;\n            }\n\n            p{\n                font-size: 0.875rem;\n            }\n        }\n    }\n}\n\n.email-filter{\n\n    @media (min-width: 40.5rem){\n        padding-left: 1.25rem;\n    }\n\n    @media(min-width: 106.25rem){\n        padding-left: 1.875rem;\n    }\n\n    .input-group{\n\n        &-prepend{\n            \n            i{\n                font-size: 0.875rem;\n                color: $muted;\n            }\n\n            .input-group-text{\n                border: 0;\n                border-bottom: 0.0625rem solid #DDDFE1 !important;\n                background: transparent;\n            }\n        }\n\n        .form-control{\n            padding: 0 0 0 0.3125rem;\n            border: 0;\n            font-size: 0.875rem;\n            height: 1.875rem;\n            color: $muted;\n            border-bottom: 0.0625rem solid #DDDFE1;\n\n            &::placeholder{\n                font-size: 0.875rem;\n                color: $muted;\n            }\n        }\n\n        & > .form-control{\n            min-height: 1.875rem;\n        }\n    }\n}\n\n.single-mail{\n    display: block;\n    padding: 1.5625rem 0;\n\n    .media{\n        padding-left: 1.25rem;\n        padding-right: 1.25rem;\n\n        @media(min-width: 106.25rem){\n            padding-left: 1.875rem;\n            padding-right: 1.875rem;\n        }\n\n        img{\n            width: 3.4375rem;\n            height: 3.4375rem;\n            border-radius: 50%;\n            margin-right: 0.9375rem;\n\n            @media(min-width: 106.25rem){\n                margin-right: 1.875rem;\n            }\n        }\n\n        &-body{\n\n            h6{\n                color: #abafb3;\n            }\n\n            h4{\n                font-size: 1rem;\n                color: #6a707e;\n\n                button{\n\n                    i{\n                        font-size: 1.125rem;\n                        color: #abafb3;\n                        font-weight: bold;\n                        transform: rotate(90deg);\n                    }\n                }\n            }\n\n            p{\n                font-size: 0.875rem;\n                color: #abafb3;\n            }\n        }\n    }\n\n    &.active{\n        background: var(--primary);\n\n        h6,h4,p,i{\n            color: $white !important;\n        }\n    }\n}\n[direction=\"rtl\"]{\n\t.email-right-box {\n\t\tpadding-left: 1rem;\n\t\tpadding-right: 15rem;\n\t\t@include respond('tab-port') {\n\t\t\tpadding-left: 0;\n\t\t\tpadding-right: 0;\n\t\t\tmargin-right:0;\n\t\t}\n\t\t@include respond('phone') {\n\t\t\tpadding-left: 0;\n\t\t\tpadding-right: 0;\n\t\t}\n\t}\n\t.email-left-box{\n\t\tfloat:right;\n\t}\n\t.email-list .message .col-mail-2{\n\t\tright: 5.625rem;\n\t\tleft: 0;\n\t\tfloat: right;\n\t\t.date{\n\t\t\tright:auto;\n\t\t\tleft:0;\n\t\t}\n\t\t.subject{\n\t\t\tright: 0;\n\t\t\tleft: 5.5rem;\n\t\t}\n\t}\n\n\t\n}\n.pull-end{\n\tfloat:right;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n",".photo-content{\n    position: relative;\n    .cover-photo{        \n        background-size: cover;\n        background-position: center;\n        min-height: 15.625rem;\n        width: 100%;\n\n    }\n\n}\n.profile .profile-photo {\n\tmax-width: 6.25rem;\n\tposition: relative;\n\tz-index: 1;\n\tmargin-top: -4.5rem;\n\tmargin-right: 0.625rem;\n\t\n\t@include respond('tab-land') {\n\t\t\n\t}\n\t@include respond('phone') {\n\t\twidth: 5rem;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n        margin-top: -3rem;\n\t\tmargin-bottom:1.25rem;\n\t}\n}\n[direction=\"rtl\"]{\n    \n\t.profile .profile-photo {\n\t\tleft: auto;\n\t\tright: 0;\n\t\tmargin-right: 0;\n\t\tmargin-left: 0.9375rem;\n\t\t\n\t\t@include respond('tab-land') {\n\t\t\tright: 0.9375rem;\n\t\t}\n\t\t@include respond('phone') {\n\t\t\twidth: 5rem;\n\t\t\tright: calc(50% - 2.5rem);\n\t\t\ttop: -6.25rem;\n\t\t\t\n\t\t\t\n\t\t}\n\t}\n}\n.profile-info{\n    padding: 0.9375rem 1.25rem;\n    // margin-bottom: 1.875rem;\n\t@include respond('phone') {\n\t\tpadding: 0 0 1.25rem;\n\t\ttext-align:center;\n\t}\n    h4 {\n        color: $l-ctd!important;\n    }\n\n    h4.text-primary {\n        color: var(--primary)!important;\n    }\n\n    p {\n        color: $l-ctl;\n    }\n\n    .prf-col{\n        min-width: 15.625rem;\n        padding: 0.625rem 3.125rem 0;\n    }\n}\n.profile-interest{\n    .row{\n        margin: 0 -0.0437rem;\n        .int-col{\n            padding: 0 0.0437rem;\n            .interest-cat{\n                margin-bottom: 0.0875rem;\n                position: relative;\n                display: block;\n                &:after{\n                    background: $black;\n                    bottom: 0;\n                    content: \"\";\n                    left: 0;\n                    opacity: 0.5;\n                    position: absolute;\n                    right: 0;\n                    top: 0;\n                    z-index: 0;\n                }\n                img{\n                    // margin-bottom: 0.075rem;\n                }\n                p{\n                    position: absolute;\n                    top: 0;\n                    width: 100%;\n                    height: 100%;\n                    padding: 0.3125rem;\n                    left: 0;\n                    margin: 0;\n                    z-index: 1;\n                    color:white;\n                    font-size: 0.075rem;\n                }\n            }\n            \n        }\n    }\n}\n.profile-tab{\n    .nav-item{\n        .nav-link{\n            font-size: 1rem;\n            margin-right: 1.875rem;\n            transition: all 0.5s ease-in-out;\n            border: none;\n            border-bottom: 0.0125rem solid transparent;\n            color: $l-ctl;\n\n            &:hover, &.active{\n                border: 0;\n                background: transparent;\n                background: transparent;\n                border-bottom: 0.0125rem solid var(--primary);\n                color: var(--primary);\n            }\n\t\t\t@include respond ('phone'){\n\t\t\t\tmargin-right:0rem;\n\t\t\t}\n        }\n        \n    }\n}\n.profile-info{\n\tdisplay:flex;\n\t@include respond('phone') {\n\t\tdisplay:block;\n\t}\n\t.profile-details {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\t@include respond('phone') {\n\t\t\tdisplay:block;\n\t\t\t.dropdown{\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 1.875rem;\n\t\t\t\tright: 1.875rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.post-input{\n    margin-bottom: 1.875rem;\n    .form-control{\n        height: 4.6875rem;\n        font-weight: 400;\n        margin: 0.9375rem 0;\n    }\n\t.btn-social{\n\t\tfont-size: 1.25rem;\n\t\theight: 3.4375rem;\n\t\tdisplay:inline-block;\n\t\tpadding: 0;\n\t\ttext-align:center;\n\t\tborder-radius:$radius;\n\t\tcolor:$white;\n\t\twidth: 3.4375rem;\n\t\tline-height: 3.375rem;\n\t\t&.facebook{\n\t\t\tbackground-color: #3B5998;\n\t\t}\n\t\t&.google-plus{\n\t\t\tbackground-color: #DE4E43;\n\t\t}\n\t\t&.linkedin{\n\t\t\tbackground-color: #007BB6;\n\t\t}\n\t\t&.instagram{\n\t\t\tbackground-color: #8A5A4E;\n\t\t}\n\t\t&.twitter{\n\t\t\tbackground-color: #1EA1F3;\n\t\t}\n\t\t&.youtube{\n\t\t\tbackground-color: #CE201F;\n\t\t}\n\t\t&.whatsapp{\n\t\t\tbackground-color: #01C854;\n\t\t}\n\t\ti{\n\t\t\tmargin:0!important;\n\t\t}\n\t}\n    \n}  \n.profile-uoloaded-post{\n    \n    img{\n        margin-bottom: 1.25rem;\n    }\n    a{\n        h4{\n            margin-bottom: 0.625rem;\n            color: $l-ctd;\n        }\n    }\n}\n","\n.event-chat-ryt{\n\n    .chat-area{\n        .chat-reciver, \n        .chat-sender {\n            margin-bottom: 1.875rem;\n            padding: 0;\n            img{\n                border-radius: 1.875rem;\n            }\n        }\n\n        .media {\n            position: relative;\n\n            &-body {\n\n                p {\n                    margin: 0;\n                    max-width: 100%;\n                    display: inline-block;\n                    position: relative;\n\n                    @include media-breakpoint-up(sm) {\n                        // max-width: 60%;\n                    }\n\n                    span {\n                        padding: 1rem;\n                        display: inline-block;\n                        top: 103%;\n                        position: relative;\n                        border: 0.0625rem solid $border;\n                    }\n                }\n            }\n        }\n    }\n\n    .chat-reciver{\n        padding: .5rem 1rem;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-pack: end;\n            -ms-flex-pack: end;\n                justify-content: flex-end;\n\n        .media {\n            -webkit-box-flex: 1;\n                -ms-flex: 1;\n                    flex: 1;\n\n            .media-body {\n                margin-right: 2rem;\n                text-align: right;\n\n                @at-root [direction=\"rtl\"] & {\n                    text-align: left;\n                    margin-left: 2rem;\n                    margin-right: auto;\n                }\n\n                p {\n                    background: $white;\n                    margin-bottom: 0;\n                    border-radius: 0.3125rem 0.3125rem 0 0.3125rem;\n\n                    span {\n                        text-align: left;\n                        border: 0.0625rem solid $border;\n                        \n                        &::after{\n                            content: \"\";\n                            width: 1.25rem;\n                            height: 1.25rem;\n                            border-bottom: 0.0625rem solid $border;\n                            border-right: 0.0625rem solid $border;\n                            position: absolute;\n                            right: 0;\n                            bottom: 0;\n                            background: $white;\n                            -webkit-transform: rotate(-45deg) translateX(15px);\n                                    transform: rotate(-45deg) translateX(15px);\n\n                            @at-root [direction=\"rtl\"] & {\n                                left: 0;\n                                right: auto;\n                                -webkit-transform: rotate(135deg) translateY(15px);\n                                        transform: rotate(135deg) translateY(15px);\n                            }\n                        }\n                        \n                    }\n                    \n                    .time {\n                        position: absolute;\n                        font-size: 0.75rem;\n                        color: $body-color;\n                        font-weight: 400;\n                        bottom: 0;\n                        left: -5rem;\n\n                        @at-root [direction=\"rtl\"] & {\n                            right: -5rem;\n                            left: auto;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .chat-sender{\n        text-align: left;\n        padding: .5rem 1rem;\n\n        .media {\n\n            .media-body {\n                margin-left: 2rem;\n\n                @at-root [direction=\"rtl\"] & {\n                    text-align: right;\n                    margin-right: 2rem;\n                    margin-left: auto;\n                }\n\n                p {\n                    background-color: $white;\n                    margin-bottom: 0;\n                    span {\n                        \n                        &::after {\n                            content: \"\";\n                            width: 1.25rem;\n                            height: 1.25rem;\n                            border-bottom: 0.0625rem solid $border;\n                            border-left: 0.0625rem solid $border;\n                            position: absolute;\n                            left: 0;\n                            bottom: 0;\n                            background: $white;\n                            -webkit-transform: rotate(45deg) translateX(-15px);\n                                    transform: rotate(45deg) translateX(-15px);\n\n                            @at-root [direction=\"rtl\"] & {\n                                left: auto;\n                                right: 0;\n                                -webkit-transform: rotate(-135deg) translateY(15px);\n                                        transform: rotate(-135deg) translateY(15px);\n                            }\n                        }\n                    }\n\n                    .time {\n                        position: absolute;\n                        font-size: 0.625rem;\n                        color: $body-color;\n                        font-weight: 400;\n                        bottom: 0;\n                        right: -5rem;\n\n                        @at-root [direction=\"rtl\"] & {\n                            left: -5rem;\n                            right: auto;\n                        }\n                    }\n\n                }\n            }\n        }\n\n    }\n}\n\n.char-type{\n    padding-top: 1.875rem;\n    padding-bottom: 1.875rem;\n\n    form{\n        \n        .form-control{\n            height: 2.8125rem;\n            // border-radius: 1.875rem;\n            padding-left: 1.125rem;\n            background: $body-bg;\n            border-right: 0;\n        }\n\n        .input-group{\n\n            &-append{\n                i{\n                    color: $gray;\n                    font-size: 1.125rem;\n                }\n                .input-group-text{\n                    padding-left: .7rem;\n                    padding-right: .7rem;\n                    background: $body-bg;\n                    border-color: $border;\n                    border-left: 0;\n\n                    &:last-child{\n                        // border-top-right-radius: 1.875rem;\n                        // border-bottom-right-radius: 1.875rem;\n                        padding-right: 1.8rem;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.media-avatar{\n    padding: 1.5625rem 0;\n    border-bottom: 0.0625rem solid $border;\n    &:last-child{\n        border-bottom: 0rem;\n    }\n    p{\n        margin-bottom: 0;\n    }\n    .avatar-status{\n        position: relative;\n        i{\n            position: absolute;\n            right: 0;\n            bottom: 0;\n        }\n    }\n}\n","\n\n\n.ct-golden-section:before {\n    float: none;\n  }\n  .ct-chart {\n    max-height: 15.7rem;\n  }\n  .ct-chart .ct-label {\n    fill: #a3afb7;\n    color: #a3afb7;\n    font-size: 0.75rem;\n    line-height: 1;\n  }\n  .ct-grid {\n    stroke: rgba(49, 58, 70, 0.1);\n  }\n  .ct-chart.simple-pie-chart-chartist .ct-label {\n    color: #ffffff;\n    fill: #ffffff;\n    font-size: 0.625rem;\n  }\n  .ct-chart .ct-series.ct-series-a .ct-bar,\n  .ct-chart .ct-series.ct-series-a .ct-line,\n  .ct-chart .ct-series.ct-series-a .ct-point,\n  .ct-chart .ct-series.ct-series-a .ct-slice-donut {\n    stroke: var(--primary);\n  }\n  .ct-chart .ct-series.ct-series-b .ct-bar,\n  .ct-chart .ct-series.ct-series-b .ct-line,\n  .ct-chart .ct-series.ct-series-b .ct-point,\n  .ct-chart .ct-series.ct-series-b .ct-slice-donut {\n    stroke: $success;\n  }\n  .ct-chart .ct-series.ct-series-c .ct-bar,\n  .ct-chart .ct-series.ct-series-c .ct-line,\n  .ct-chart .ct-series.ct-series-c .ct-point,\n  .ct-chart .ct-series.ct-series-c .ct-slice-donut {\n    stroke: $warning;\n  }\n  .ct-chart .ct-series.ct-series-d .ct-bar,\n  .ct-chart .ct-series.ct-series-d .ct-line,\n  .ct-chart .ct-series.ct-series-d .ct-point,\n  .ct-chart .ct-series.ct-series-d .ct-slice-donut {\n    stroke: $danger;\n  }\n  .ct-chart .ct-series.ct-series-e .ct-bar,\n  .ct-chart .ct-series.ct-series-e .ct-line,\n  .ct-chart .ct-series.ct-series-e .ct-point,\n  .ct-chart .ct-series.ct-series-e .ct-slice-donut {\n    stroke: $info;\n  }\n  .ct-chart .ct-series.ct-series-f .ct-bar,\n  .ct-chart .ct-series.ct-series-f .ct-line,\n  .ct-chart .ct-series.ct-series-f .ct-point,\n  .ct-chart .ct-series.ct-series-f .ct-slice-donut {\n    stroke: $dark;\n  }\n  .ct-chart .ct-series.ct-series-g .ct-bar,\n  .ct-chart .ct-series.ct-series-g .ct-line,\n  .ct-chart .ct-series.ct-series-g .ct-point,\n  .ct-chart .ct-series.ct-series-g .ct-slice-donut {\n    stroke: #8d6e63;\n  }\n  .ct-series-a .ct-area,\n  .ct-series-a .ct-slice-pie {\n    fill: $secondary;\n  }\n  .ct-series-b .ct-area,\n  .ct-series-b .ct-slice-pie {\n    fill: #00A2FF;\n  }\n  .ct-series-c .ct-area,\n  .ct-series-c .ct-slice-pie {\n    fill: #ff9800;\n  }\n  .ct-series-d .ct-area,\n  .ct-series-d .ct-slice-pie {\n    fill: #ff9800;\n  }\n  .chartist-tooltip {\n    position: absolute;\n    display: inline-block;\n    opacity: 0;\n    min-width: 0.625rem;\n    padding: 0.125rem 0.625rem;\n    border-radius: 0.125rem;\n    background: #313a46;\n    color: #ffffff;\n    text-align: center;\n    pointer-events: none;\n    z-index: 1;\n    -webkit-transition: opacity .2s linear;\n    -moz-transition: opacity .2s linear;\n    -o-transition: opacity .2s linear;\n    transition: opacity .2s linear;\n  }\n  .chartist-tooltip.tooltip-show {\n    opacity: 1;\n  }\n\n\n\n\n\n  #donught_graph {\n    .ct-series.ct-series-a .ct-slice-donut {\n      stroke: #3FC6D4;\n    }\n    \n    .ct-series.ct-series-b .ct-slice-donut {\n      stroke: #333333;\n    }\n\n    .ct-series.ct-series-c .ct-slice-donut {\n      stroke: #F63465;\n    }\n  }\n\n\n#pie-chart .ct-label{\n\t@include respond ('phone-land'){\n\t\tcolor: #fff;\n\t\tfill: #fff;\n\t}\n}\n  ","\n#visitor_graph {\n    height: 15.8125rem !important;\n}\n\n#user_rating_graph {\n    height: 17.5rem !important;\n}\n\n#radar_chart, \n#pie_chart, \n#doughnut_chart, \n#polar_chart {\n    // height: 10.875rem!important;\n}\n\n#activity {\n    height: 16.875rem !important;\n}\n\n#visitorOnline{\n    height: 4.5rem !important;\n}\n#trendMeter{\n    height: 4.5rem !important;\n}\n#widget-revenue1,\n#widget-revenue2,\n#widget-revenue3{\n    height: 7.3125rem !important;\n}\n#widget-profit1,\n#widget-profit2,\n#widget-profit3{\n    height: 10rem !important;\n}\n\n#comparison-rate{\n    height: 14.375rem;\n}\n#session_day{\n    height: 10.9375rem;\n    width: auto!important;\n    margin: 0 auto;\n}\n\n#walet-status {\n    height: 8.75rem;\n}\n#bar1 {\n    height: 9.375rem;\n}\n#sold-product {\n    height: 14.375rem;\n}\n\n\n#chart-venue-expenses,\n#chart-online-sale,\n#chart-gross-sale{\n    height: 9.375rem !important;\n}\n\n\n#areaChart_3{\n    height: 18.4375rem !important;\n}\n.chart-point{\n\tdisplay:flex;\n\talign-items: center;\n\t\n\t.check-point-area{\n\t\twidth:6.25rem;\n\t\theight: 6.25rem;\n\t\tmargin-top: -0.625rem;\n\t\tmargin-left: -0.625rem;\n\t}\n\t.chart-point-list{\n\t\tmargin:0;\n\t\tpadding-left: 0.3125rem;\n\t\t\t\n\t\tli{\n\t\t\tlist-style:none;\n\t\t\tfont-size: 0.8125rem;\n\t\t\tpadding: 0.125rem 0;\n\t\t\t\n\t\t\ti{\n\t\t\t\tmargin-right: 0.3125rem;\n\t\t\t\tfont-size: 0.6875rem;\n\t\t\t\tposition: relative;\n\t\t\t\ttop: -0.0625rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n\n","\n.c3{\n    height: 15.625rem;\n}\n.c3-legend-item {\n    fill: #9fabb1;\n }\n\n .c3 .c3-axis-x path, \n .c3 .c3-axis-x line, \n .c3 .c3-axis-y path, \n.c3 .c3-axis-y line, \n.tick text { stroke: $white; }\n","\n\n.flot-chart{\n    height: 15.7rem;\n}\n\n.tooltipflot {\n    background-color: transparent;\n    font-size: 1.4rem;\n    padding: .5rem 1rem;\n    color: rgba(255, 255, 255, 0.7);\n    border-radius: .2rem; }\n  \n  .legendColorBox > div {\n    border: 0 !important;\n    padding: 0 !important; }\n  \n  .legendLabel {\n    font-size: 0.825rem;\n    padding-left: .5rem; \n    color: var(--primary);\n  }\n    \n.flotTip {\n  background: $black;\n  border: 0.0625rem solid $black;\n  color: $white;\n}\n\n.legend > div{\n  background: transparent!important;\n}\n\n#balance_graph {\n  height: 16.25rem;\n}\n.flot-chart .legend table tbody tr:last-child .legendLabel{\n\tcolor:var(--secondary);\n}",".morris-hover {\n\tposition: absolute;\n\tz-index : 1;\n\tbackground: var(--primary);\n\tcolor: $white;\n}\n\n.morris-hover .morris-hover-point {\n\tcolor: $white !important;\n\tmargin: 0.1875rem 0;\n\ttext-align: center;\n\tpadding: 0 1.5625rem;\n\tcolor: #fff;\n}\n\n.morris-hover .morris-hover-row-label {\n\tbackground-color: $dark;\n\ttext-align: center;\n\tpadding: 0.3125rem;\n\tcolor: #fff;\n\tmargin-bottom: 0.3125rem;\n}\n\n.morris-hover.morris-default-style {\n\tborder-radius: 0.3125rem;\n\tpadding      : 0;\n\tmargin: 0;\n\tborder       : none;\n\toverflow: hidden;\n}\n\n/* svg text {\n    font-weight: 600 !important;\n} */\n\n\n#morris_donught, \n#morris_donught_2, \n#line_chart_2, \n#morris_bar, \n#morris_bar_stalked, \n#morris_bar_2, \n#morris_area_2, \n#morris_area {\n    height: 15rem !important;\n}\n\n#morris_line {\n\theight: 17.375rem !important;\n}\n\n\n#crypto-btc-card, \n#crypto-eth-card, \n#crypto-rpl-card, \n#crypto-ltc-card {\n    height: 9.375rem;\n}\n\n\n","#daily-sales, #comparison-rate, #usage-chart, #walet-status {\n    width: 100%;\n    display: block;\n\n    canvas {\n        max-width: 100% !important;\n        width: 100% !important;\n    }\n}\n\n\n#sparkline-composite-chart, \n#composite-bar, \n#sparkline11, \n#StackedBarChart, \n#spark-bar, \n#tristate {\n    canvas {\n        height: 6.25rem !important;\n    }\n}\n\n#sparkline11 canvas {\n    width: 6.25rem !important;\n}",".easy-pie-chart {\n    position: relative;\n    text-align: center;\n\n    .inner {\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        display: inline-block;\n    }\n\n    img {\n        width: 4.6875rem;\n        height: 4.6875rem;\n        border-radius: 50%;\n    }\n\n    canvas {\n        display: block;\n        margin: 0 auto;\n    }\n}","#revenue-chart {\n    height: 27.7rem;\n}\n\n// #finance_graph, #revenue_graph {\n//     height: 29.625rem;\n// }\n\n#duration-value-axis {\n    height: 27.6rem;\n    width: 100%;\n}\n\n#combined-bullet { \n    height: 28.125rem;\n    width: 100%;\n}\n\n#zoomable-chart {\n    height: 28.125rem;\n    width: 100%;\n}\n\n#chartMap {\n    height: 28.125rem;\n    width: 100%;\n}\n\n#professional-candlesticks {\n    width: 100%;\n    height: 28.125rem;\n}\n\n#comparing-stock-indices {\n    width: 100%;\n    height: 28.125rem;\n}\n\n#multiple-panel-data {\n    width: 100%;\n    height: 28.125rem;\n}\n\n#depth-chart {\n    width: 100%;\n    height: 28.125rem;\n}\n\n// #btc1 {\n//     width: 100%;\n//     height: 31.25rem;\n\n//     @include respond('phone') {\n//         margin-bottom: 5.625rem;\n//         padding-bottom: 2.5rem;\n//         height: 25rem;\n\n//         fieldset {\n\n//             div {\n//                 display: block !important;\n//                 margin-bottom: 0.625rem;\n\n//                 input {\n//                     display: block;\n//                     margin-bottom: 0.3125rem;\n//                 }\n//             }\n    \n//             div:last-child {\n//                 float: none !important;\n//             }\n//         }\n//     }\n// }\n\n.amcharts-export-menu {\n    display: none;\n}\n\n.amcharts-data-set-selector-div {\n    position: absolute;\n    left: 0;\n    right: 0;\n    text-align: center;\n    width: 16.875rem;\n    margin: 0 auto;\n    select {\n        border: 0;\n        margin-left: 0.625rem;\n        background: #ddd;\n        color: $black;\n    }\n}\n\n.amChartsInputField {\n    border: 0;\n    background: var(--primary);\n    color: $white;\n    padding: 0.3125rem 0.9375rem;\n    margin: 0 0.9375rem;\n}\n\n.amcharts-data-set-select {\n    border: 0;\n    background: #ddd;\n    color: $black;\n}\n\n.amcharts-period-input,\n.amcharts-period-input-selected {\n    border: 0;\n    margin-left: 0.625rem;\n    background: var(--primary);\n    color: $white;\n    padding: 0.3125rem 0.9375rem;\n}\n\n/////////////////////\n// CSS Animation\n///////////////////\n.amcharts-graph-g2 .amcharts-graph-stroke {\n    stroke-dasharray: 0.1875rem 0.1875rem;\n    stroke-linejoin: round;\n    stroke-linecap: round;\n    -webkit-animation: am-moving-dashes 1s linear infinite;\n    animation: am-moving-dashes 1s linear infinite;\n}\n\n@-webkit-keyframes am-moving-dashes {\n    100% {\n        stroke-dashoffset: -1.9375rem;\n    }\n}\n\n@keyframes am-moving-dashes {\n    100% {\n        stroke-dashoffset: -1.9375rem;\n    }\n}\n\n.lastBullet {\n    -webkit-animation: am-pulsating 1s ease-out infinite;\n    animation: am-pulsating 1s ease-out infinite;\n}\n\n@-webkit-keyframes am-pulsating {\n    0% {\n        stroke-opacity: 1;\n        stroke-width: 0px;\n    }\n    100% {\n        stroke-opacity: 0;\n        stroke-width: 3.125rem;\n    }\n}\n\n@keyframes am-pulsating {\n    0% {\n        stroke-opacity: 1;\n        stroke-width: 0px;\n    }\n    100% {\n        stroke-opacity: 0;\n        stroke-width: 3.125rem;\n    }\n}\n\n.amcharts-graph-column-front {\n    -webkit-transition: all .3s .3s ease-out;\n    transition: all .3s .3s ease-out;\n}\n\n.amcharts-graph-column-front:hover {\n    fill: #496375;\n    stroke: #496375;\n    -webkit-transition: all .3s ease-out;\n    transition: all .3s ease-out;\n}\n\n@-webkit-keyframes am-draw {\n    0% {\n        stroke-dashoffset: 500%;\n    }\n    100% {\n        stroke-dashoffset: 0%;\n    }\n}\n\n@keyframes am-draw {\n    0% {\n        stroke-dashoffset: 500%;\n    }\n    100% {\n        stroke-dashoffset: 0%;\n    }\n}\n\n.amChartsPeriodSelector {\n    &>fieldset>div {\n        @include respond('tab-port') {\n            float: none !important;\n            display: block !important;\n            margin-bottom: 0.625rem;\n        }\n    }\n}","#chart_employee_gender, #chart_employee_status {\n    width: auto;\n    height: 21.875rem;\n}","\n// Basic Input\n\n.form-control{\n    background: $white;\n    color: $dark;\n\tline-height: 1.7;\n\tfont-size: 0.9rem;\n\theight:3rem;\n\tborder-radius:$radius;\n\tborder-color:$border-main-color;\n    &:hover,&:focus,&.active{\n        box-shadow: none;\n        background: $white;\n        color: $dark;\n    }\n\t&:focus{\n\t\tborder-color:var(--primary);\n\t\tbox-shadow: 0 0 0 0.125rem var(--rgba-primary-2);\n\t}\n\t&.solid{\n\t\tbackground:$body-bg;\n\t\tborder-color:#ececec;\n\t\tcolor:#000;\n\t\t&[type=\"file\"]{\n\t\t\tpadding: 6px 10px;\n\t\t}\n\t}\n}\n.bootstrap-select .btn{\n\tpadding:$input-padding-y $input-padding-x;\n\tborder-color:$border-main-color;\n\tborder-width:$input-border-width;\n    line-height: $input-line-height;\n}\n\n.input-rounded {\n    border-radius: 6.25rem;\n}\n\n\n// Input Color\n[data-theme-version=\"light\"],\n[data-theme-version=\"dark\"] {\n\t.input-primary{\n\t\t.form-control{\n\t\t\tborder-color:var(--primary);\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:var(--primary);\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.input-danger{\n\t\t.form-control{\n\t\t\tborder-color:$danger;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:$danger;\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.input-info{\n\t\t.form-control{\n\t\t\tborder-color:$info;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:$info;\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.input-success{\n\t\t.form-control{\n\t\t\tborder-color:$success;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:$success;\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t.input-warning{\n\t\t.form-control{\n\t\t\tborder-color:$warning;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:$warning;\n\t\t\tcolor:$white;\n\t\t}\n\t}\n}\n// Input Outline\n[data-theme-version=\"light\"],\n[data-theme-version=\"dark\"] {\n\t.input-primary-o{\n\t\t.form-control{\n\t\t\tborder-color:var(--primary);\n\t\t\t\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:var(--primary);\n\t\t\tcolor:var(--primary);\n\t\t}\n\t}\n\t.input-danger-o{\n\t\t.form-control{\n\t\t\tborder-color:$danger;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$danger;\n\t\t\tcolor:$danger;\n\t\t}\n\t}\n\t.input-info-o{\n\t\t.form-control{\n\t\t\tborder-color:$info;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$info;\n\t\t\tcolor:$info;\n\t\t}\n\t}\n\t.input-success-o{\n\t\t.form-control{\n\t\t\tborder-color:$success;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$success;\n\t\t\tcolor:$success;\n\t\t}\n\t}\n\t.input-warning-o{\n\t\t.form-control{\n\t\t\tborder-color:$warning;\n\t\t}\t\n\t\t.input-group-text{\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$warning;\n\t\t\tcolor:$warning;\n\t\t}\n\t}\n}\n\n// Input Group\n.input-group-text{\n    min-width: 3.125rem;\n\tjustify-content: center;\n\tborder-radius: $radius;\n\tfont-weight: 600;\n    font-size: 1rem;\n\tbackground-color:#ededed;\n}\n.form-file-label{\n    height: 2.5rem;\n\tpadding: 0.5rem 0.75rem;\n}\n.input-group-prepend .btn,\n.input-group-append .btn {\n    z-index: 0;\n}\n.custom-select{\n    background: none;\n    // height: 2.8125rem;\n    border-color: $border;\n    color: $dark;\n    // border-radius: 0rem\n    &:focus{\n        box-shadow: none;\n        border-color: var(--primary);\n        color: var(--primary);\n    }\n}\n.form-file-label{\n    // height: 2.8125rem;\n    // border-radius: 0rem\n\tbackground: #656C73;\n\twhite-space: nowrap;\n\tcolor: $white;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground: $d-border;\n\t\tborder-color: $d-border;\n\t\tcolor: $body-color;\n\t}\n}\n\n.custom_file_input {\n    .input-group-prepend, \n    .input-group-append {\n        // height: 2.8125rem;\n    }\n\n    .form-file-label::after {\n        height: 100%;\n        // line-height: 2.4;\n    }\n}\n\n\n.form-control:disabled,\n .form-control[readonly] {\n    background: $white;\n    opacity: 1;\n}\n\n.form-file{\n\tborder: 0.0625rem solid $border;\n    background: $white;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background: $d-bg;\n\t\tborder-color: $d-border;\n    }\n}\n.input-group{\n\t> .form-control-plaintext,\n\t  > .form-select,\n\t  > .form-file {\n\t\tposition: relative; // For focus state's z-index\n\t\tflex: 1 1 auto;\n\t\t// Add width 1% and flex-basis auto to ensure that button will not wrap out\n\t\t// the column. Applies to IE Edge+ and Firefox. Chrome does not require this.\n\t\twidth: 1%;\n\t\tmargin-bottom: 0;\n\n\t  }\n\t/* &> .form-file {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t&:not(:last-child) .form-file-label,\n\t\t&:not(:last-child) .form-file-label::after { @include border-right-radius(0); }\n\t\t&:not(:first-child) .form-file-label { @include border-left-radius(0); }\n\t  } */\n}\n\n\n.select2-container--default \n.select2-selection--multiple\n .select2-selection__choice{\n\tborder-radius:$radius;\n}\n\n.form-file{\n\t.form-control{\n\t\tmargin:0;\n\t\tborder-radius:0;\n\t\tborder:0;\n\t\theight:auto;\n\t}\n}\n#validationCustomUsername{\n\tborder-radius: 0 0.5rem 0.5rem 0;\n}\n.show-pass{\n\tborder-radius: 0 0.5rem 0.5rem 0!important;\n}\n.form-file{\n\t.form-control{\n\t\tmargin:0;\n\t\tborder-radius:0;\n\t\tborder:0;\n\t\theight:auto;\n\t\tline-height: 24.4px;\n\t}\n}\n.input-group{\n\t.input-group-text + .form-file{\n\t\tborder-radius:0 0.5rem 0.5rem 0;\n\t\t.form-control{\n\t\t\tborder-radius: inherit;\n\t\t\tmargin:0;\n\t\t}\n\t}\n}\n\n.custom_file_input{\n\t.form-file{\n\t\tborder-radius:0.5rem;\n\t\t.form-control{\n\t\t\tmargin:0;\n\t\t\tborder:0;\n\t\t\tline-height: 2.125rem;\n\t\t\tborder-radius: inherit;\n\t\t\tfont-size: 16px;\n\t\t\tfont-weight: 600;\n\t\t}\n\t}\n\t.form-control{\n\t\tpadding-left: 12px;\n\t\tline-height: 45px;\n\t}\n}\n#username{\n\tborder-radius:0 0.5rem 0.5rem 0;\n}\n.form-control-lg{\n\tmin-height: 3.75rem;\n\tpadding: 0.5rem 1.1rem;\n    font-size: 1.09375rem;\n    border-radius: 0.5rem;\n\theight: calc(1.5em + 1rem + 2px);\n}\n.form-control-sm{\n\tmin-height:2.5rem;\n   padding: 0.25rem 1.1rem;\n    font-size: 0.76563rem;\n    border-radius: 0.5rem;\n\theight: calc(1.5em + 0.5rem + 2px);\n}\n.card{\n\t&.checkboxes{\n\t\t.form-check .form-check-input[type=\"radio\"]{\n\t\t\tmargin-left:-1.188rem;\n\t\t\t\n\t\t\t@include respond ('phone'){\n\t\t\t\tmargin-left:-1.388rem;\n\t\t\t}\n\t\t}\n\t}\n}\n.modal-grid{\n\tbackground:$body-bg;\n}\n.nice-select.wide.form-control-lg{\n\tline-height: 2.7125rem;\n}\n.nice-select.wide.form-control-sm{\n\tline-height: 1.8125rem;\n}\n.inline-check{\n\tline-height: 1.8rem!important;\n}\n.form-check{\n\tfont-size: 14px;\n    font-weight: 600;\n}\n.input-full{\n\tborder:0;\n}\n.border-1{\n\tborder-radius: 0.5rem 0 0 0.5rem!important;\n}\n.border3{\n\tborder-radius:0 0.5rem 0.5rem 0!important;\n}\n.custome-input{\n\t.input-group-text{\n\t\tborder-color:transparent!important;\n\t}\n}\n.form-control-sm[type=\"file\"]{\n    line-height: 32px;\n    padding: 4px;\n    padding-left: 8px;\n\t\n\t@include respond('phone'){\n\t\tpadding:3px;\n\t\tline-height:27px;\n\t\t padding-left: 7px;\n\t}\n}\n.form-control-lg[type=\"file\"]{\n\tline-height:42px;\n\tpadding-left:10px;\n}\n\n.input-group.input-group-lg .form-control{\n\theight:3.75rem;\n}\n.input-group.input-group-sm .form-control{\n\theight:2.5rem;\n}\n\n.right-radius{\n\tborder-top-right-radius:0!important;\n\tborder-bottom-right-radius:0!important;\n}\n.left-radius{\n\tborder-top-left-radius:0!important;\n\tborder-bottom-left-radius:0!important;\n}","@import \"../../abstracts/variable\";\n.form-check-label{\n    margin-left: 0.3125rem;\n    margin-top: 0.1875rem;\n}\n#example5_wrapper{\n\t.form-check-input:checked{\n\t\tborder-color:var(--primary)!important;\n\t}\n\ttable.dataTable thead .sorting_asc{\n\t\tdisplay:flex;\n\t}\n\t.btn.tp-btn.btn-primary{\n\t\t&:hover{\n\t\t\tsvg{\n\t\t\t\tpath{\n\t\t\t\t\tstroke:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\t\n\n.form-check-inline {\n    .form-check-input {\n        margin-right: 0.625rem;\n\t\tmargin-top:0;\n    }\n\t\n}\n\n.bootstrap-select .dropdown-menu{\n\tz-index: 9999;\n}\n.form-control:focus{\n\tbox-shadow:none;\n}\n\n.form-check-input{\n\ttop:0.125rem;\n\tborder-width:0.125rem;\n\twidth: 1.25rem;\n\theight: 1.25rem;\n\tborder-color: #C4C4C4;\n\tbackground-color:transparent;\n}\n.rtl .form-check-label{\n\t&:before,\n\t&:after{\n\t\tright: -1.5rem !important;\n\t\tleft: inherit;\n\t}\n}\n.form-check {\n    line-height: normal;\n}\n\n\n// Toggle Switch\n.toggle-switch{\n\tpadding-left:3.125rem;\n\tline-height: 1.25;\n\tdisplay:inline-block;\n\tcolor:$black;\n\tfont-weight: 600;\n\t.form-check-input{\n\t\tborder: 0;\n\t\tcursor:pointer;\n\t\tbackground: #d8d8d8;\n\t\twidth: 2.2125rem;\n\t\tborder-radius: 1.25rem !important;\n\t\theight: 0.875rem;\n\t\tposition:relative;\n\t\tleft: -0.3125rem;\n\t\t@include transitionFast;\n\t\tbackground-image:none;\n\t\t&:focus{\n\t\t\tbackground-image:none!important;\n\t\t}\n\t\t&:checked{\n\t\t\tbackground:var(--rgba-primary-1);\n\t\t\tbackground-image:none!important;\n\t\t\t&:after{\n\t\t\t\tleft:1.30rem;\n\t\t\t\tbackground:var(--primary);\n\t\t\t}\n\t\t}\n\t\t&:focus{\n\t\t\tbox-shadow:none;\n\t\t}\n\t\t&:after{\n\t\t\twidth: 1rem;\n\t\t\tbackground:#909090;\n\t\t\theight: 1rem;\n\t\t\tcontent:\"\";\n\t\t\tposition:absolute;\n\t\t\tborder-radius: 1.5rem;\n\t\t\ttop: -0.0475rem;\n\t\t\tleft: 0;\n\t\t\t@include transitionFast;\n\t\t}\n\t}\n\t&.text-end{\n\t\tpadding-right:0rem;\n\t\tpadding-left:0;\n\t\t.form-check-input{\n\t\t\tleft: auto;\n\t\t\tmargin-left: 0;\n\t\t\tfloat:right;\n\t\t\tright: 0rem;\n\t\t}\n\t\t.form-check-label{\n\t\t\tmargin-right: 0.9375rem;\n\t\t\tmargin-left:0;\n\t\t}\n\t}\n\t.form-check-label{\n\t\tcursor:pointer;\n\t}\n}\n\n\n// CheckBox\n.form-check-input:focus ~ .form-check-label::before{\n\tbox-shadow:none !important;\n}\n.form-check-label::before{\n    background-color: transparent;\n    border-color: $light;\n\tborder-width: 0.125rem;\n\tborder-radius: 0.125rem !important;\n\t\t\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: transparent;\n\t\tborder-color: $d-border;\n\t}\n}\n.check-xs{\n\t.form-check-input{\n\t\twidth: 1.125rem;\n\t\theight: 1.125rem;\n\t}\n}\n.check-lg{\n\t.form-check-input{\n\t\twidth: 1.5rem;\n\t\theight: 1.5rem;\n\t}\n}\n.check-xl{\n\t.form-check-input{\n\t\twidth: 1.75rem;\n\t\theight: 1.75rem;\n\t}\n}\n.checkbox{\n\t&-info{\n\t\t.form-check-input{\n\t\t\t&:focus{\n\t\t\t\tborder-color: $info;\n\t\t\t\toutline: 0;\n\t\t\t\tbox-shadow: 0 0 0 0.25rem rgba($info , 0.25);\n\t\t\t}\n\t\t\t&:checked{\n\t\t\t\tbackground-color: $info;\n\t\t\t\tborder-color: $info;\n\t\t\t}\n\t\t}\n\t}\n\t&-danger {\n\t\t.form-check-input{\n\t\t\t&:focus{\n\t\t\t\tborder-color: $danger;\n\t\t\t\toutline: 0;\n\t\t\t\tbox-shadow: 0 0 0 0.25rem rgba($danger , 0.25);\n\t\t\t}\n\t\t\t&:checked{\n\t\t\t\tbackground-color: $danger;\n\t\t\t\tborder-color: $danger;\n\t\t\t}\n\t\t}\n\t}\n\t&-success{\n\t\t.form-check-input{\n\t\t\t&:focus{\n\t\t\t\tborder-color: $success;\n\t\t\t\toutline: 0;\n\t\t\t\tbox-shadow: 0 0 0 0.25rem rgba($success , 0.25);\n\t\t\t}\n\t\t\t&:checked{\n\t\t\t\tbackground-color: $success!important;\n\t\t\t\tborder-color: $success;\n\t\t\t}\n\t\t}\n\t}\n\t&-warning{\n\t\t.form-check-input{\n\t\t\t&:focus{\n\t\t\t\tborder-color: $warning;\n\t\t\t\toutline: 0;\n\t\t\t\tbox-shadow: 0 0 0 0.25rem rgba($warning , 0.25);\n\t\t\t}\n\t\t\t&:checked{\n\t\t\t\tbackground-color: $warning;\n\t\t\t\tborder-color: $warning;\n\t\t\t}\n\t\t}\n\t}\n\t&-secondary{\n\t\t.form-check-input{\n\t\t\t&:focus{\n\t\t\t\tborder-color: $secondary;\n\t\t\t\toutline: 0;\n\t\t\t\tbox-shadow: 0 0 0 0.25rem rgba($secondary , 0.25);\n\t\t\t}\n\t\t\t&:checked{\n\t\t\t\tbackground-color: $secondary;\n\t\t\t\tborder-color: $secondary;\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n\n\n//Check Switch\n.check-switch{\n\tpadding-left: 2.5rem;\n\t.form-check-label{\n\t\tline-height: 1.875rem;\n\t\tfont-weight: 500;\n\t\tspan{\n\t\t\tline-height: 1;\n\t\t}\n\t\t&:after,&:before{\n\t\t\theight:1.5rem;\n\t\t\twidth:1.5rem;\n\t\t\tleft: -2rem;\n\t\t\tborder-radius: 3rem!important;\n\t\t\tborder-color:var(--rgba-primary-3);\n\t\t}\n\t}\n\t.form-check-input:checked ~ .form-check-label::after{\t\t\n\t}\n\t.form-check-input:checked ~ .form-check-label::before{\n\t\tbackground:$white;\n\t}\n}\n\n\n\n\n\n\n\n\n\n\n\n",".form-check{\n\t.form-check-input[type=\"radio\"]{\n\t\tmargin-left: -1em;\n\t\ttop: 0.03rem;\n\t}\n}\n.form-check-input{\n\t&:checked {\n\t\tbackground-color: var(--primary);\n\t\tborder-color: var(--primary);\t\n\t}\n\t&:focus {\n\t\tborder-color: var(--primary);\n\t\tbox-shadow: var(--rgba-primary-1);\n\t}\n\t&[type=\"radio\"]{\n\t\twidth: 1.313rem;\n\t\tmin-width: 1.313rem;\n\t\theight: 1.313rem;\n\t\tposition: relative;\n\t\tborder-color: #A5AAB4;\n\t\tborder-width: 0.125rem;\n\t\tborder-style: solid;\n\t\ttop: -0.125rem;\n\t\t\n\t\t&:focus {\n\t\t\tbox-shadow: none;\n\t\t}\n\t\t\n\t}\n\t&[type=\"radio\"] + .form-check-label{\n\t\tmargin-bottom: 0;\n\t}\n\t&:checked[type=\"radio\"]{\n\t\tbackground-image: none;\n\t\tbackground-color: var(--rgba-primary-3);\n\t\tborder-color: transparent!important;\n\t\t&:after{\n\t\t\tcontent: \"\";\n\t\t\theight: 0.688rem;\n\t\t\twidth: 0.688rem;\n\t\t\tbackground-color: var(--primary);\n\t\t\tposition: absolute;\n\t\t\ttop: 0.188rem;\n\t\t\tleft: 0.188rem;\n\t\t\tborder-radius: 50%;\n\t\t}\n\t}\n}\n.checkbox{\n\t&-info{\n\t\t.form-check-input{\n\t\t\t&[type=\"radio\"]{\n\t\t\t\tborder-color: $info;\n\t\t\t}\n\t\t\t&:checked[type=\"radio\"]{\n\t\t\t\tbackground-color: $info-light;\n\t\t\t\t&:after{\n\t\t\t\t\tbackground-color: $info;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&-danger {\n\t\t.form-check-input{\n\t\t\t&[type=\"radio\"]{\n\t\t\t\tborder-color: $danger;\n\t\t\t}\n\t\t\t&:checked[type=\"radio\"]{\n\t\t\t\tbackground-color: $danger-light;\n\t\t\t\t&:after{\n\t\t\t\t\tbackground-color: $danger;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&-success{\n\t\t.form-check-input{\n\t\t\t&[type=\"radio\"]{\n\t\t\t\tborder-color: $success;\n\t\t\t}\n\t\t\t&:checked[type=\"radio\"]{\n\t\t\t\tbackground-color: $success-light;\n\t\t\t\t&:after{\n\t\t\t\t\tbackground-color: $success;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&-warning{\n\t\t.form-check-input{\n\t\t\t&[type=\"radio\"]{\n\t\t\t\tborder-color: $warning;\n\t\t\t}\n\t\t\t&:checked[type=\"radio\"]{\n\t\t\t\tbackground-color: $warning-light;\n\t\t\t\t&:after{\n\t\t\t\t\tbackground-color: $warning;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&-dark{\n\t\t.form-check-input{\n\t\t\t&[type=\"radio\"]{\n\t\t\t\tborder-color: $dark;\n\t\t\t}\n\t\t\t&:checked[type=\"radio\"]{\n\t\t\t\tbackground-color: $primary-light;\n\t\t\t\t&:after{\n\t\t\t\t\tbackground-color: var(--primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&-secondary{\n\t\t.form-check-input{\n\t\t\t&[type=\"radio\"]{\n\t\t\t\tborder-color: $secondary;\n\t\t\t}\n\t\t\t&:checked[type=\"radio\"]{\n\t\t\t\tbackground-color: $secondary-light;\n\t\t\t\t&:after{\n\t\t\t\t\tbackground-color: $secondary;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".js-switch {\n\n    & + .switchery {\n        border-radius: 3.125rem;\n        margin-right: 4rem;\n\n        @include media-breakpoint-down(sm) {\n            margin-right: 1rem;\n        }\n\n        &>small {\n            top: 0.125rem;\n        }\n    }\n\n    &.js-switch-lg  {\n        & + .switchery {\n            height: 2rem;\n            width: 4.5rem;\n\n            &>small {\n                width: 1.75rem;\n                height: 1.75rem;\n            }\n        }\n    }\n\n    &.js-switch-md  {\n        & + .switchery {\n            height: 1.5rem;\n            width: 3.5rem;\n\n            &>small {\n                width: 1.25rem;\n                height: 1.25rem;\n            }\n        }\n    }\n\n    &.js-switch-sm  {\n        & + .switchery {\n            height: 1rem;\n            width: 2.2rem;\n\n            &>small {\n                width: 0.875rem;\n                height: 0.875rem;\n                top: 0.0625rem;\n            }\n        }\n    }\n\n    &-square {\n\n        & + .switchery {\n            border-radius: 0;\n    \n            &>small {\n                border-radius: 0;\n                top: 0.125rem;\n            }\n        }\n\n        &.js-switch-lg  {\n            & + .switchery {\n                height: 2rem;\n                width: 4.5rem;\n    \n                &>small {\n                    width: 1.75rem;\n                    height: 1.75rem;\n                }\n            }\n        }\n\n        &.js-switch-md  {\n            & + .switchery {\n                height: 1.5rem;\n                width: 3.5rem;\n    \n                &>small {\n                    width: 1.25rem;\n                    height: 1.25rem;\n                }\n            }\n        }\n\n        &.js-switch-sm  {\n            & + .switchery {\n                height: 1rem;\n                width: 2.2rem;\n    \n                &>small {\n                    width: 0.875rem;\n                    height: 0.875rem;\n                    top: 0.0625rem;\n                }\n            }\n        }\n    }\n    \n}","/////////////////////////////\n// Bootstrap validation\n/////////////////////////////\n.form-control.is-valid {\n    border-color: $success !important;\n    border-right: 0rem !important;\n    &:focus {\n        box-shadow: none;\n    }\n}\n\n.form-control.is-warning {\n    border-color: $warning !important;\n    border-right: 0rem !important;\n    &:focus {\n        box-shadow: none;\n    }\n}\n\n.form-control.is-invalid {\n    border-color: $danger !important;\n    border-right: 0rem !important;\n    &:focus {\n        box-shadow: none;\n    }\n}\n\n////////////////////////\n// Jquery Validation \n////////////////////////\n.is-valid {\n    .input-group-prepend {\n        .input-group-text {\n            i {\n                color: $success;\n            }\n        }\n    }\n}\n\n.is-invalid {\n    .input-group-prepend {\n        .input-group-text {\n            i {\n                color: var(--rgba-primary-2);\n            }\n        }\n    }\n}\n\n// Show Pass\n.show-pass{\n\tcursor:pointer;\n\t\n\t.fa-eye{\n\t\tdisplay:none;\n\t}\n\t\n\t&.active{\n\t\t.fa-eye-slash{\n\t\t\tdisplay:none;\n\t\t}\n\t\t.fa-eye{\n\t\t\tdisplay:inline-block;\n\t\t}\n\t}\n}",".asColorPicker-dropdown {\n    max-width: 26rem;\n}\n\n.asColorPicker-trigger {\n\tbackground: none;\n}\n\n.asColorPicker-trigger {\n    border  : 0 none;\n    height  : 100%;\n    position: absolute;\n    right: 0;\n    top     : 0;\n    width   : 2.1875rem;\n}\n[direction=\"rtl\"] .asColorPicker-trigger{\n\tleft: 0;\n\tright: auto;\n}\n\n.asColorPicker-trigger {\n\tspan {\n\t\tborder-radius: 0 0.425rem 0.425rem 0;\n\t}\n}\n.asColorPicker-clear {\n    display        : none;\n    position       : absolute;\n    right          : 1rem;\n    text-decoration: none;\n    top            : .5rem;\n}\n\n\n\n.daterangepicker {\n    td.active {\n        background-color: var(--primary);\n\n        &:hover {\n            background-color: var(--primary);\n        }\n    }\n\n    button.applyBtn {\n        background-color: var(--primary);\n        border-color: var(--primary);\n    }\n}\n\n.datepicker {\n\n    &.datepicker-dropdown {\n        background: $white;\n        border-radius: 0.0625rem;\n        border: 0.0625rem solid $gallery;\n\n        td.day, th.next, th.prev {\n            height: 1.875rem;\n            width: 1.875rem !important;\n            padding: 0;\n            text-align: center;\n            font-weight: 500;\n            border-radius: $radius;\n\n            &:hover {\n                box-shadow: unset;\n               /*  color: $main-color; */\n                background-color: var(--rgba-primary-1);\n               \n            }\n        }\n\n        th.datepicker-switch, th.next, th.prev {\n            font-weight: 600;\n            color: $heading;\n        }\n\n        th.dow {\n            font-weight: 600;\n        }\n    }\n    table {\n        tr td.selected, tr td.active.active {\n            background-color: var(--primary);\n            border-radius: $radius;\n            border: 0;\n            color: $white; \n            background-image: none;\n            position: relative;\n        }\n\n        tr {\n            \n            td.today {\n                border-radius: $radius;\n                /* color : $main-color; */\n\n                &:hover {\n                    background-color: var(--primary);\n                    box-shadow: 0rem 0rem 1.875rem 0.3125rem rgba(243,30,122,0.3);\n                    color : #ffffff;\n                }\n            }\n\n            td.today.disabled {\n               \n                box-shadow: 0rem 0rem 1.875rem 0.3125rem rgba(243,30,122,0.3);\n                color     : #ffffff;\n\n                &:hover {\n                  \n                    box-shadow: 0rem 0rem 1.875rem 0.3125rem rgba(243,30,122,0.3);\n                    color     : #ffffff;\n                }\n            }\n        }\n         thead tr:first-child th:hover {\n            background: var(--rgba-primary-1) ;\n        }\n        thead tr th:hover {\n            background: var(--rgba-primary-1) ;\n        }\n        td.day:hover{\n            background: var(--rgba-primary-1) ;\n            border-radius: $radius;\n        }\n    }\n}\n\n\n.picker {\n    &__select--month, &__select--year {\n        height: 2.5em;\n    }\n\n    &__input {\n        background-color: transparent !important;\n\n        @at-root [data-theme-version=\"dark\"] & {\n            background-color: transparent !important;\n            border: 0.0625rem solid $d-border;\n        }\n    }\n}\n.bootstrap-select.form-control-lg .dropdown-toggle{\n\tmin-height: 3.75rem;\n    padding: 0.5rem 1.563rem;\n}\n.bootstrap-select.form-control-sm .dropdown-toggle{\n\tmin-height: 2.5rem;\n    padding: 0.25rem 1.563rem;\n}\n.basic-form{\n\t.form-check-input[type=\"radio\"] + .form-check-label{\n\t\tmargin-top: 5px;\n\t}\n}\n.input-group-sm > .form-control, .input-group-sm > .form-select, .input-group-sm > .input-group-text, .input-group-sm > .btn{\n\tmin-height: 2.5rem;\n    padding: 0.25rem 1.1rem;\n\tborder-radius:$radius;\n}\n.input-group{\n\t&.input-group-lg{\n\t\tmin-height: 3.75rem;\n\t\tborder-radius:$radius;\n\t}\t\n\t\n}\n.input-group-lg > .form-control, .input-group-lg > .form-select, .input-group-lg > .input-group-text, .input-group-lg > .btn{\n\tborder-radius:$radius;\n}\n\n.clockpicker-popover .popover-title{\n\tpadding: 0.625rem 0px;\n}\n\n.picker-data{\n\t.color-time-picker{\n\t\t.react-time-picker{\n\t\t\twidth:100%;\n\t\t}\n\t\t.react-time-picker__wrapper{\n\t\t\tborder:0;\n\t\t\tcolor:#7e7e7e;\n\t\t\t.react-time-picker__clear-button{\n\t\t\t\tdisplay:none;\n\t\t\t}\n\t\t\t.react-time-picker__inputGroup{\n\t\t\t\tborder:1px solid #b7b7b7;\n\t\t\t\tborder-width:0 0 1px 0;\n\t\t\t\tpadding: .35rem 0rem\n\t\t\t}\n\t\t\t.react-time-picker__inputGroup__input{\n\t\t\t\tcolor:#7e7e7e;\n\t\t\t}\n\t\t\t.react-time-picker__inputGroup__amPm{\n\t\t\t\tcolor:#7e7e7e;\n\t\t\t\tappearance: none;\n\t\t\t}\n\t\t\t.react-time-picker__clock-button{\n\t\t\t\tbackground:$primary;\n\t\t\t\tcolor: #b7b7b7;\n\t\t\t\tpadding: .532rem .75rem;\n\t\t\t\tborder-radius: 0 0.75rem 0.75rem 0;\n\t\t\t\tmin-width: 3.125rem;\n\t\t\t\ttext-align: center;\n\t\t\t\tline-height: 1;\n\t\t\t\tsvg{\n\t\t\t\t\tstroke: #fff;\n\t\t\t\t\tdisplay:inline-block;\n\t\t\t\t}\n\t\t\t} \n\t\t}\n\t\t.react-clock__face{\n\t\t\tbackground: #ededed;\n\t\t\tpadding: 0.625rem 0.625rem;\t\n\t\t\tborder: 0.625rem solid #ededed;\n\t\t}\n\t\t.react-clock__hand__body{\n\t\t\tbackground-color: $primary;\n\t\t}\n\t\t.react-time-picker__clock{\n\t\t\tbox-shadow: 0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12);\n\t\t\tborder-radius:4px;\n\t\t\tborder: 0 !important;\n\t\t}\n\t\t&.style-1{\n\t\t\t.react-time-picker__wrapper{\n\t\t\t\t.react-time-picker__clock-button{\n\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\n\t\t\t\t} \n\t\t\t}\n\t\t\t\n\t\t}\n\t\t\n\t}\n}\n.color-gradian-tixia{\n    .gpw{\n        padding: 0;    \n    }\n    .gpw .trigger .inner{\n        height: 1.5rem;\n        width: 6.25rem;\n    }\n}","#image {\n  max-width: 100%;\n}\n\n.docs-options {\n  .dropdown-menu {\n    padding: 1.5rem;\n  }\n}\n\n.docs-preview {\n  margin-bottom: 3rem;\n\n  .img-preview {\n    float: left;\n    margin-right: .5rem;\n    margin-bottom: .5rem;\n    overflow: hidden;\n    max-width: 100% !important;\n\n    &>img {\n      max-width: 100% !important;\n    }\n\n    &.preview-lg {\n      width: 16rem;\n      height: 9rem;\n    }\n\n    &.preview-md {\n      width: 8rem;\n      height: 4.5rem;\n    }\n\n    &.preview-sm {\n      width: 4rem;\n      height: 2.25rem;\n    }\n\n    &.preview-xs {\n      width: 2rem;\n      height: 1.125rem;\n      margin-right: 0;\n    }\n  }\n}","\n.select2-container {\n    width: 100% !important;\n}\n\n.select2-container--default .select2-selection--single {\n    border-radius: $radius;\n    border: 0.0625rem solid $border-main-color;\n    height: 3rem;\n    background: $white;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background:$d-bg;\n\t\tborder-color:$d-border;\n    }\n\t\t\n\t\t\n    &:hover,&:focus,&.active{\n        box-shadow: none;\n    }\n}\n.destroy-selector,\n.single-event-unbind{\n\twidth: 100%;\n    border-color: #eeee;\n    height: 45px;\n    padding: 0 13px;\n    border-radius: 10px;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__rendered {\n    line-height: 3rem;\n\tcolor:$body-color;\n\tpadding-left: 0.9375rem;\n\tmin-height: 2.5rem;\n}\n\n.select2-container--default .select2-selection--multiple {\n    border-color: $border-main-color;\n    border-radius: 0;\n\t\n}\n\n.select2-dropdown {\n    border-radius: 0;\n}\n\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n    background-color: var(--primary);\n}\n\n.select2-container--default.select2-container--focus .select2-selection--multiple {\n    border-color: $border-main-color;\n    background: $white;\n\tpadding: 0.2rem 0;\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n    top: 0.675rem;\n    right: 0.9375rem;\n}\n.select2-container .select2-selection--multiple{\n\tmin-height: 3rem;\n\tcolor:$body-color;\n\tborder-radius: $radius;\n\tborder: 0.0625rem solid $border-main-color;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background:$d-bg;\n\t\tborder-color:$d-border;\n    }\n}\n.select2-search--dropdown .select2-search__field{\n\t@at-root [data-theme-version=\"dark\"] & {\n        background:$dark-card;\n\t\tborder-color:$d-border;\n\t\tcolor:rgba(255,255,255,0.6);\n    }\n}\n.select2-dropdown{\n\tborder-color: $light;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background:$d-bg;\n\t\tborder-color:$d-border;\n    }\n}\n.select2-container .select2-selection--multiple .select2-selection__rendered{\n\tpadding: 2px 12px;\n}\n.swal2-popup .swal2-content{\n\tcolor:$body-color;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","@import \"../../abstracts/variable\";\n@import \"../../abstracts/mixin\";\n\n// form-wizard\n.form-wizard{\n\tborder: 0;\n\t.nav-wizard{\n\t\tbox-shadow: none!important;\n\t\tmargin-bottom: 2rem;\n\t\t\n\t\t#RFS-ConnectorContainer{\n\t\t\tdisplay: none;\n\t\t}\n\t\t\n\t\t.nav-link{\n\t\t\tposition: relative;\n\t\t\tdisplay: block;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tbackground-color: transparent !important;\n\n\t\t\tspan{\n\t\t\t\tborder-radius: 3.125rem;\n\t\t\t\twidth: 3rem;\n\t\t\t\theight: 3rem;\n\t\t\t\tborder: 0.125rem solid var(--primary);\n\t\t\t\tdisplay: block;\n\t\t\t\tline-height: 3rem;\n\t\t\t\tcolor: var(--primary);\n\t\t\t\tfont-size: 1.125rem;\n\t\t\t\tmargin: auto;\n\t\t\t\tbackground-color: $white;\n\t\t\t\tposition: relative;\n\t\t\t\tz-index: 1;\n\t\t\t}\n\t\t\t&:after{\n\t\t\t\tcontent: \"\" !important;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 50%;\n\t\t\t\tleft: 50%;\n\t\t\t\theight: 0.1875rem;\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tbackground: $dark-light!important;\n\t\t\t\tz-index: 0;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\t\t\t\n\t\t\t&.active{\n\t\t\t\tspan{\n\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\tcolor:$white;\n\t\t\t\t}\t\t\t\t\n\t\t\t\t&:after{\n\t\t\t\t\tbackground: var(--primary)!important;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.completed {\n\t\t\t\tspan{\n\t\t\t\t\tbackground-color: var(--primary);\n\t\t\t\t\tcolor: $white;\n\t\t\t\t}\n\t\t\t\t&:after{\n\t\t\t\t\tbackground: var(--primary)!important;\t\t\t\t\t\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t& > div:last-child{\n\t\t\t.nav-link{\n\t\t\t\t&:after{\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.toolbar-bottom{\n\t\t.btn{\n\t\t\t//background-color: var(--primary);\n\t\t\tborder: 0;\n\t\t\tpadding: 0.75rem 1.125rem;\n\t\t}\n\t}\n\t.tab-content{\n\t\t.tab-pane{\n\t\t\tpadding: 0;\n\t\t}\n\t}\n\t.emial-setup {\n        label.mailclinet {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            flex-direction: column;\n            width: 10rem;\n            height: 10rem;\n            border-radius: 50%;\n            cursor: pointer;\n            background-color: #EEF5F9;\n\t\t\ttext-align: center;\n\t\t\tmargin: auto;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $d-bg;\n\t\t\t}\n            @include respond(phone) {\n                width: 7rem;\n                height: 7rem;\n            }\n\n            .mail-icon {\n                font-size: 3rem;\n                display: inline-block;\n                line-height: 1;\n                margin-top: -1rem;\n\n                @include respond(phone) {\n                    font-size: 2rem;\n                }\n            }\n\n            .mail-text {\n                font-size: 1rem;\n                text-align: center;\n                margin-top: .5rem;\n\n                @include respond(phone) {\n                    font-size: 0.75rem;\n\t\t\t\t\tline-height: 1.25rem;\n                }\n            }\n\n            input[type=\"radio\"] {\n                display: none;\n            }\n        }\n    }\n\t\n\t@include respond('phone-land') {\n\t\t.nav-wizard{\n\t\t\tflex-direction: unset!important;\n\t\t}\n\t\t.tab-content{\n\t\t\theight: 100%!important;\n\t\t}\n\t}\n\t@include respond('phone') {\n\t\t.nav-wizard{\n\t\t\tli{\n\t\t\t\t.nav-link{\n\t\t\t\t\tpadding: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n\n//wizard-style-one\n.wizard-style-one{\n\tborder:0;\n\tpadding: 0 100px;\n\t.nav-wizard{\n\t\tmargin-bottom: 40px;\n\t\tbox-shadow:none;\n\t\t.nav-link{\n\t\t\t\n\t\t}\n\t}\n\tlabel{\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t\tcolor: #000;\n\t}\n\t.tab-content{\n\t\toverflow:visible;\n\t}\n}",".custom-ekeditor{\n\tul{\n\t\tpadding-left:1.25rem;\n\t\tli{\n\t\t\tlist-style:unset;\n\t\t}\n\t}\n\tol{\n\t\tli{\n\t\t\tlist-style:decimal;\n\t\t}\n\t}\n}",".ql-container{\n    height: 25rem;\n}","#world-datamap {\n    padding-bottom: 46% !important;\n}\n\n.datamaps-hoverover {\n    background: $white;\n    padding: 0.3125rem;\n    border-radius: 0.3125rem;\n    font-family: 'Roboto' !important;\n    color: var(--primary);\n    border: 0.0625rem solid var(--rgba-primary-3);\n}\n\n.world_map_card {\n    ul.list-group {\n        @include custommq($max: 90rem) {\n            display: flex;\n            flex-wrap: wrap;\n            flex-direction: row;\n            margin-top: 2.1875rem;\n        }\n\n        // li {\n        //     @include custommq($min: 75rem, $max: 90rem) {\n        //         flex: 1;\n        //     }\n        // }\n    }\n}",".jqvmap-zoomin,\n.jqvmap-zoomout {\n    height: 1.25rem;\n    width: 1.25rem;\n    line-height: 0.875rem;\n    background-color: var(--primary);\n    color: $white;\n}\n\n.jqvmap-zoomout {\n    top: 2.1875rem;\n}\n\n#world-map, #usa {\n    height: 25rem;\n\t@include respond ('tab-port'){\n\t\theight:21.875rem;\n\t}\n\t@include respond ('phone'){\n\t\theight:14.375rem;\n\t}\n}",".blockUI.blockMsg.blockPage {\n    border: 0 !important;\n}\n\n#loginForm {\n    cursor: auto;\n}\n\n.blockMsg {\n    border: 0rem;\n    width: 20%!important;\n    h1{\n        font-size: 1rem;\n        padding: 0.5rem 0;\n        margin-bottom: 0;\n    }\n}",".bootstrap-select{\n    margin-bottom: 0;\n\n   .btn {\n\t\tbackground-color: transparent !important;\n\t\tfont-weight:400;\n\t\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color:$d-border !important;\n\t\t\tbackground:#383844 !important;\n\t\t}\n       \n       &:active,\n       &:focus,\n       &:hover {\n\t\t\toutline: none !important;\n\t\t\toutline-offset: 0;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tcolor: $body-color !important;\n\t\t\t}\n       }\n   }\n    .dropdown-menu{\n\t\tborder-color: $border !important;\n\t\tbox-shadow:$shadow;\n\t\t\n\t\t.dropdown-item{\n\t\t\tfont-size: 0.875rem;\n\t\t}\n\t\t\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: $border !important;\n\t\t}\n\t}\n   \n}\n.input-group > .bootstrap-select:not(:first-child) .dropdown-toggle{\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.input-group > .bootstrap-select:not(:last-child) .dropdown-toggle{\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}","@import \"../../abstracts/variable\";\n\n.clipboard-btn {\n    transition: all .1s ease-in-out;\n\n    &:hover {\n        background-color: var(--primary);\n        color: $white;\n    }\n}","@import \"../../abstracts/variable\";\n\n.bootstrap-tagsinput {\n    flex: 1;\n    padding: 0;\n    padding-left: .5rem;\n    border-radius: 0;\n    border-color: $border;\n    background-color: $white;\n    width: 100%;\n\n    .tag {\n        font-size: 0.875rem;\n        background-color: var(--primary);\n        // color: $white;\n        border-radius: 0;\n        align-items: center;\n        border: 0.0625rem solid $border;\n    }\n\n    input[type=\"text\"] {\n        flex: 1;\n        height: 2.1rem;\n        border-radius: 0;\n        border-color: $border;\n        // max-width: 6.5625rem;\n    }\n\n    label{\n        margin-bottom: .5rem;\n    }\n}","@import \"../../abstracts/variable\";\n\n.twitter-typeahead {\n    width: 100%;\n\n    // .form-control {\n    //     background-color: $l-bg !important;\n    // }\n\n    .tt-dataset.tt-dataset-states {\n        border: 1px solid $border;\n    }\n\n    .tt-menu {\n        width: 100%;\n        background-color: $white;\n\n        .tt-suggestion {\n            padding: 0.625rem;\n            cursor: pointer;\n\n            &:hover {\n                background-color: var(--primary);\n                color: $white;\n            }\n        }\n    }\n}\n\n"," // Variable.scss\n\n.weather-one {\n    i {\n        font-size: 8rem;\n        position : relative;\n        top      : .5rem;\n    }\n\n    h2 {\n        display  : inline-block;\n        float    : right;\n        font-size: 4.8rem;\n    }\n\n    .city {\n        position  : relative;\n        text-align: right;\n        top       : -2.5rem;\n    }\n\n    .currently {\n        font-size  : 1.6rem;\n        font-weight: 400;\n        position   : relative;\n        top        : 2.5rem;\n    }\n\n    .celcious {\n        text-align: right;\n        font-size : 2rem;\n    }\n}","@import \"../../abstracts/variable\";\n\n\n\n.noUi-target {\n    border-color: transparent; \n    border-radius: 0;\n}\n\n.noUi-connect {\n    background-color: var(--primary);\n\n    &s {\n        background-color: $grey;\n    }\n\n    &.c-1-color {\n        background-color: $success;\n    }\n\n    &.c-2-color {\n        background-color: $info;\n    }\n\n    &.c-3-color {\n        background-color: var(--primary);\n    }\n\n    &.c-4-color {\n        background-color: $warning;\n    }\n}\n\n.noUi-vertical {\n    width: 0.375rem;\n}\n\n.noUi-horizontal {\n    height: 0.125rem;\n\tborder:0;\n    margin-bottom: 0.625rem;\n}\n\n.noUi-horizontal .noUi-handle, .noUi-vertical .noUi-handle {\n    height: 0.9375rem;\n    width: 0.9375rem;\n    border-radius: 3.125rem;\n    box-shadow: none;\n    border: none;\n    background-color: var(--primary);\n\n    &::after, &::before {\n        display: none;\n    }\n}\n.noUi-vertical .noUi-handle {\n    left: -0.35rem;\n    top: -0.375rem;\n}\n.noUi-horizontal .noUi-handle {\n    top: -0.4375rem;\n\tcursor:pointer;\n}\nhtml:not([dir=rtl]) .noUi-horizontal .noUi-handle {\n    right: -0.375rem;\n}\n#slider-toggle {\n\theight: 3.125rem;\n}\n#slider-toggle.off .noUi-handle {\n\tborder-color: var(--primary);\n}\n\n\n.colorpicker-slider {\n    .sliders.noUi-target {\n\n\n        &#red, &#green, &#blue {\n            margin: 0.625rem;\n            display: inline-block;\n            height: 12.5rem;\n        }\n\n        &#red .noUi-connect {\n            background: #c0392b;\n        }\n\n        &#green .noUi-connect {\n            background: #27ae60;\n        }\n\n        &#blue .noUi-connect {\n            background: #2980b9;\n        }\n    }\n\n\n    #result {\n        margin: 3.75rem 1.625rem;\n        height: 6.25rem;\n        width: 6.25rem;\n        display: inline-block;\n        vertical-align: top;\n        color: rgb(127, 127, 127);\n        background: rgb(127, 127, 127);\n        border: 0.0625rem solid #fff;\n        box-shadow: 0 0 0.625rem;\n    }\n}\n\n.slider-vertical {\n    height: 18rem;\n}"," // Variable.scss\n\n.nestable-cart {\n    overflow: hidden;\n}\n\n// .dd-item > button {\n//     height: 2.1rem;\n// }\n.dd-handle {\n    color: $white;\n    background: var(--primary);\n    border-radius: 0.3125rem;\n\tpadding: 0.5rem 1rem;\n\theight:auto;\n    border: 1px solid $border;\n}\n.dd-handle:hover {\n    color: $white;\n    background: var(--primary);\n}\n// #nestable2 .dd-handle {\n    // color: $white;\n    // border: 1px solid $border;\n    // background: $primary;\n// }\n// #nestable2 .dd-handle:hover {\n//     background: $primary;\n// }\n// #nestable2 .dd-item>button:before {\n//     color: $white;\n// }\n.dd3-content:hover {\n    color: $white;\n    background: var(--primary);\n}\n.dd3-content {\n    color: $white;\n}\n.dd-item>button{\n\tline-height:28px;\n\tcolor:$white;\n}",".pignose-calendar {\n    box-shadow: none;\n    width: 100%;\n    max-width: none;\n    border-color: var(--primary);\n\n    .pignose-calendar-top-date {\n        background-color: var(--primary);\n\n        .pignose-calendar-top-month {\n            color: $white;\n        }\n    }\n}\n\n.pignose-calendar.pignose-calendar-blue .pignose-calendar-body .pignose-calendar-row .pignose-calendar-unit.pignose-calendar-unit-active a {\n    background-color: var(--primary);\n    box-shadow: none;\n}\n\n.pignose-calendar .pignose-calendar-top {\n    box-shadow: none;\n    border-bottom: 0;\n}\n\n.pignose-calendar.pignose-calendar-blue {\n    background-color: rgba(0, 0, 0, 0.15);\n}\n\n.pignose-calendar .pignose-calendar-unit {\n    height: 4.8em;\n}\n",".cd-h-timeline {\n    opacity: 0;\n    transition: opacity 0.2s;\n  }\n\n  .cd-h-timeline--loaded { // show the timeline after dates position has been set (using JavaScript)\n    opacity: 1;\n  }\n\n  .cd-h-timeline__container {\n    position: relative;\n    height: 6.25rem;\n    max-width: 50rem;\n  }\n\n  .cd-h-timeline__dates {\n    position: relative;\n    height: 100%;\n    margin: 0 2.5rem;\n    overflow: hidden;\n\n    &::after, &::before { // these are used to create a shadow effect at the sides of the timeline\n      content: '';\n      position: absolute;\n      z-index: 2;\n      top: 0;\n      height: 100%;\n      width: 1.25rem;\n    }\n\n    &::before {\n      left: 0;\n      background: var(--primary);\n    }\n\n    &::after {\n      right: 0;\n      background: var(--primary);\n    }\n  }\n\n  .cd-h-timeline__line { // grey line\n    position: absolute;\n    z-index: 1;\n    left: 0;\n    top: 3.0625rem;\n    height: 0.125rem; // width will be set using JavaScript\n    background-color: var(--primary);\n    transition: transform 0.4s;\n  }\n\n  .cd-h-timeline__filling-line { // green filling line\n    position: absolute;\n    z-index: 1;\n    left: 0;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    background-color: $success;\n    transform: scaleX(0);\n    transform-origin: left center;\n    transition: transform 0.3s;\n  }\n\n  .cd-h-timeline__date {\n    position: absolute;\n    bottom: 0; // left position will be set using JavaScript\n    z-index: 2;\n    text-align: center;\n    font-size: 0.8em;\n    padding-bottom: var(--space-sm);\n    color: var(--cd-color-1);\n    user-select: none; // improve swipe\n    text-decoration: none;\n\n    &::after { // this is used to create the event spot\n      content: '';\n      position: absolute;\n      left: 50%;\n      transform: translateX(-50%);\n      bottom: -0.3125rem;\n      height: 0.75rem;\n      width: 0.75rem;\n      border-radius: 50%;\n      border-width: 0.125rem;\n      border-style: solid;\n      border-color: var(--rgba-primary-6);\n      background-color: var(--primary);\n      transition: background-color 0.3s, border-color .3s;\n    }\n\n    &:hover::after {\n      background-color: $success;\n      border-color: $success;\n    }\n\n    // @include breakpoint(md) {\n    //   font-size: 0.7em;\n    // }\n  }\n\n\n\n  .cd-h-timeline__date--selected {\n    pointer-events: none;\n\n    &::after {\n      background-color: $success;\n      border-color: $success;\n    }\n  }\n\n  .cd-h-timeline__date--older-event::after {\n    border-color: $success;\n  }\n\n  .cd-h-timeline__navigation { // arrows to navigate the timeline\n    position: absolute;\n    z-index: 1;\n    top: 50%;\n    transform: translateY(-50%);\n    height: 2.125rem;\n    width: 2.125rem;\n    border-radius: 50%;\n    border-width: 0.125rem;\n    border-style: solid;\n    border-color: var(--rgba-primary-6);\n    transition: border-color 0.3s;\n    \n    &::after { // arrow icon\n      content: '';\n      position: absolute;\n      height: 1rem;\n      width: 1rem;\n      top: 50%;\n      left: 50%;\n      transform: translateX(-50%) translateY(-50%);      \n    }\n\n    &:hover {\n      border-color: $success;\n    }\n  }\n\n  .cd-h-timeline__navigation--prev {\n    left: 0;\n    transform: translateY(-50%) rotate(180deg);\n  }\n\n  .cd-h-timeline__navigation--next {\n    right: 0;\n  }\n\n  .cd-h-timeline__navigation--inactive {\n    cursor: not-allowed;\n\n    &::after {\n      background-position: 0 -1rem;\n    }\n\n    &:hover {\n      border-color: var(--rgba-primary-6);\n    }\n  }\n\n  .cd-h-timeline__events { // container of events info\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    transition: height .4s;\n  }\n\n  .cd-h-timeline__event { // single event info\n    position: absolute;\n    z-index: 1;\n    width: 100%;\n    left: 0;\n    top: 0;\n    transform: translateX(-100%);\n    padding: 0.0625rem 5%;\n    opacity: 0;\n    animation-duration: 0.4s;\n    animation-timing-function: ease-in-out;\n  }\n\n  .cd-h-timeline__event--selected { // selected event info\n    position: relative;\n    z-index: 2;\n    opacity: 1;\n    transform: translateX(0);\n  }\n\n  .cd-h-timeline__event--enter-right, \n  .cd-h-timeline__event--leave-right { // animate event info\n    animation-name: cd-enter-right;\n  }\n\n  .cd-h-timeline__event--enter-left,  \n  .cd-h-timeline__event--leave-left { // animate event info\n    animation-name: cd-enter-left;\n  }\n\n  .cd-h-timeline__event--leave-right, \n  .cd-h-timeline__event--leave-left {\n    animation-direction: reverse;\n  }\n\n  .cd-h-timeline__event-content {\n    max-width: 50rem;\n  }\n\n  .cd-h-timeline__event-title {\n    color: var(--cd-color-1);\n    font-family: var(--font-secondary);\n    font-weight: 700;\n    font-size: var(--text-xxxl);\n  }\n\n  .cd-h-timeline__event-date {\n    display: block;\n    font-style: italic;\n    margin: var(--space-xs) auto;\n\n    &::before {\n      content: '- ';\n    }\n  }\n\n  @keyframes cd-enter-right {\n    0% {\n      opacity: 0;\n      transform: translateX(100%);\n    }\n  \n    100% {\n      opacity: 1;\n      transform: translateX(0%);\n    }\n  }\n  \n  @keyframes cd-enter-left {\n    0% {\n      opacity: 0;\n      transform: translateX(-100%);\n    }\n  \n    100% {\n      opacity: 1;\n      transform: translateX(0%);\n    }\n  }\n\n\n",".toast {\n    &-success {\n        background-color: var(--primary);\n    }\n\n    &-info {\n        background-color: $info;\n    }\n\n    &-warning {\n        background-color: $warning;\n    }\n\n    &-error {\n        background-color: $danger;\n    }\n}\n\n#toast-container {\n\n    &>div {\n        box-shadow: none;\n        border-radius: $radius;\n        width: auto;\n        max-width: 15.625rem;\n        opacity: 1;\n\n        @at-root [direction=\"rtl\"] & {\n            padding: 0.9375rem 3.125rem 0.9375rem 0.9375rem;\n            background-position: calc(100% - 0.9375rem);\n            text-align: right;\n        }\n\n        &:hover {\n            box-shadow: none;\n        }\n    }\n\n    .toast-title {\n        margin-bottom: 0.3125rem;\n        font-weight: 600;\n    }\n\n    .toast-message {\n        font-size: 0.75rem;\n    }\n\n    .toast-close-button {\n        opacity: 1;\n        font-size: 1.25rem;\n        font-weight: normal;\n        text-shadow: none;\n    }\n\n\n}\n#toast-container.toast-bottom-full-width>div, #toast-container.toast-top-full-width>div{\n\twidth:100%;\n\tmin-width:300px;\n\tdisplay:block;\n\tpadding:15px 15px 18px 60px;\n\tbox-shadow:0 0 50px rgba(0,0,0,0.15);\n}\n.toast-progress{\n\tbackground-color:$white;\n}\n\n[direction=\"rtl\"] {\n    .toast-top-right.demo_rtl_class {\n        left: 0.75rem;\n        right: auto;\n    }\n}","/* Light Gallery */\n.lg-actions .lg-next, \n.lg-actions .lg-prev, \n.lg-sub-html, \n.lg-toolbar{\n    background-color: rgba(30, 30, 30, .6);\n}\n.lg-outer{\n\t.lg-toogle-thumb, \n\t.lg-thumb-outer,\n\t.lg-img-wrap, \n\t.lg-item{\n\t\tbackground-color: transparent;\n\t}\n}\n.lg-thumb-outer.lg-grab,\n.lg-toogle-thumb.lg-icon{\n\tbackground-color: rgba(30, 30, 30, .6);\n}\n.lg-backdrop {\n    background-color: rgba(30, 30, 30, 0.9);\n}\n.lg-outer .lg-toogle-thumb, \n.lg-actions .lg-next, \n.lg-actions .lg-prev, \n.lg-toolbar .lg-icon,\n#lg-counter{\n    color: $white;\n}\n.lg-outer{\n\t.lg-thumb-item{\n\t\t&.active,\n\t\t&:hover{\n\t\t\tborder-color: var(--primary);\t\t\t\n\t\t}\n\t}\n}\n.lightimg{\n\tcursor: pointer;\n}","\n.jqvmap-zoomin, .jqvmap-zoomout\n{\n\tposition: absolute;\n\tleft: 0.625rem;\n\t-webkit-border-radius: 0.1875rem;\n\t-moz-border-radius: 0.1875rem;\n\tborder-radius: 0.1875rem;\n\tbackground: #000000;\n\tpadding: 0.1875rem;\n\tcolor: white;\n\twidth: 1.0625rem;\n\theight: 1.0625rem;\n\tcursor: pointer;\n\tline-height: 0.625rem;\n\ttext-align: center;\n}\n.jqvmap-zoomin\n{\n\ttop: 0.625rem;\n}\n.jqvmap-zoomout\n{\n\ttop: 1.875rem;\n}\n\n\n","// .dlabnav-scroll{\n//     .ps__rail-x:hover,\n//     .ps__rail-y:hover,\n//     .ps__rail-x:focus,\n//     .ps__rail-y:focus,\n//     .ps__rail-x.ps--clicking,\n//     .ps__rail-y.ps--clicking {\n//         background-color: #f00;\n//         opacity: 0.9;\n//     }\n//     .ps__rail-y:hover > .ps__thumb-y,\n//     .ps__rail-y:focus > .ps__thumb-y,\n//     .ps__rail-y.ps--clicking .ps__thumb-y {\n//         background-color: #f00;\n//         width: 0.25rem;\n//     }\n//     .ps__thumb-y {\n//         background-color: #f00;\n//         width: 0.25rem;\n//     }\n// }\n.ps__rail-x:hover,\n.ps__rail-y:hover,\n.ps__rail-x:focus,\n.ps__rail-y:focus,\n.ps__rail-x.ps--clicking,\n.ps__rail-y.ps--clicking {\n    background-color: transparent !important;\n    opacity: 0.9;\n}\n\n.ps__rail-y:hover>.ps__thumb-y,\n.ps__rail-y:focus>.ps__thumb-y,\n.ps__rail-y.ps--clicking .ps__thumb-y {\n    background-color: #DAE2F3;\n    width: 0.25rem;\n}\n\n.ps__thumb-y {\n    background-color: #DAE2F3;\n    width: 0.25rem;\n}\n\n.total-average {\n    position: relative;\n    height: 18.75rem;\n}\n\n.widget-chat {\n    position: relative;\n    height: 15.625rem;\n}\n\n.widget-todo {\n    position: relative;\n    height: 13.125rem;\n}\n\n.widget-team {\n    position: relative;\n    height: 17.8125rem;\n}\n\n.widget-timeline {\n    position: relative;\n}\n\n.widget-comments {\n    position: relative;\n    height: 25rem;\n}\n\n.sidebar-right-inner {\n    position: relative;\n    height: 100%;\n}\n\n.widget-team {\n    .ps .ps__rail-x:hover,\n    .ps .ps__rail-y:hover,\n    .ps .ps__rail-x:focus,\n    .ps .ps__rail-y:focus,\n    .ps .ps__rail-x.ps--clicking,\n    .ps .ps__rail-y.ps--clicking {\n        background-color: transparent!important;\n        opacity: 0.9;\n    }\n}","// Ckeditor\n.ck.ck-editor{\n\t.ck.ck-button{\n\t\tpadding: 6px 8px;\n\t\tbackground-color: var(--rgba-primary-1);\n\t\tcolor: var(--primary);\n\t\tfont-weight: 900;\n\t\tcursor:pointer;\n\t\t\n\t}\n\t.ck.ck-toolbar{\n\t\tbackground-color: var(--bs-card-bg);\n\t\tborder-color:$border-main-color;\n\t\tborder-radius:$radius;\n\t\tpadding: 5px 10px;\n\t}\n\t.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar{\n\t\tborder-radius:$radius!important;\n\t}\n\t.ck.ck-toolbar__separator{\n\t\tdisplay: none !important;\n\t}\n\t.ck-content{\n\t\tbackground-color: #f7f7f7;\n\t\tborder-width: 1px 0 0;\n\t\tborder-color: #e7e5ef;\n\t}\n}\n.ck-editor__editable{\n\tbackground-color:\tvar(--bs-card-bg)!important;\t\n}\n.ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred {\n    border-color: $b-color;\n\tpadding: 0.865rem var(--ck-spacing-standard);\n}\n.ck.ck-toolbar .ck-toolbar__items .ck.ck-toolbar__separator {\n    background: $b-color;\n}\n.ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred {\n\tmin-height: 9.375rem;\n\t border-width:1px;\n}\nbutton.ck.ck-button.ck-off:hover {\n    background-color: $b-color;\n   \n}\n.ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused{\n\tmin-height: 9.375rem;\n}\n\n\n.editor-title{\n\t.ck.ck-content.ck-editor__editable.ck-rounded-corners.ck-editor__editable_inline.ck-blurred,\n\t.ck-focused{\n\t\twidth:57.313rem;\n\t\t\n\t\t@include respond ('laptop'){\n\t\t\twidth:100%;\n\t\t}\n\t\t@include respond ('phone-land'){\n\t\t\twidth:500px;\n\t\t}\n\t\t@include respond ('phone'){\n\t\t\twidth:100%;\n\t\t}\n\t}\n}",".fc-h-event,.fc-v-event{\n\tbackground:var(--primary);\n\tborder-radius: .42rem;\n}\n.fc-h-event .fc-event-title{\n\tcolor:$white;\n}\n.fc-theme-standard td, .fc-theme-standard th{\n\tborder-color: #ebedf3;\n}\n.fc-unthemed .fc-h-event, .fc-unthemed .fc-event-dot {\n    padding: 0;\n    border-radius: .42rem;\n}\n.fc-theme-standard th{\n\tpadding: .75rem .5rem;\n    font-size: 1rem;\n    font-weight: 500;\n\tcolor: #b5b5c3;\n\t@include respond ('phone'){\n\t\tfont-size:14px;\n\t\tfont-weight:400;\n\t\tpadding:3px 0px;\n\t}\n}\n.fc-theme-standard .fc-scrollgrid.fc-scrollgrid-liquid,.fc-scrollgrid ,table{\n\tborder-color: #ebedf3;\n}\n\n.fc-daygrid-dot-event{\n\tbackground: #fff;\n    border: 1px solid #ebedf3;\n    -webkit-box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.1);\n    box-shadow: 0 0 9px 0 rgba(0, 0, 0, 0.1);\n\t.fc-daygrid-event-dot{\n\t\tborder-color:var(--primary);\n\t}\n}\n.fc-daygrid-dot-event .fc-event-title{\n\tfont-weight:500;\n}\n.fc-event.bg-primary\n,.fc-event.bg-success\n,.fc-event.bg-warning\n,.fc-event.bg-secondary\n,.fc-event.bg-dark\n,.fc-event.bg-info{\n\tcolor:$white!important;\n\tborder-radius: 8px;\n\t.fc-daygrid-event-dot{\n\t\tborder-color:$white;\n\t}\n}\n\n.fc .fc-scroller-liquid-absolute,.fc-scroller{\n\tposition:relative;\n\toverflow: visible!important;\n}\n\n.fc .fc-button-group{\n\t&>.fc-button{\n\t\tcolor: black;\n\t\tbackground: 0 0;\n\t\tborder: 1px solid #ebedf3;\n\t\ttext-shadow: none!important;\n\t\t-webkit-box-shadow: none!important;\n\t\tbox-shadow: none!important;\n\t\t&:focus,&:active,&:hover,&.fc-button-active{\n\t\t\tbackground:var(--primary);\n\t\t\tcolor:$white;\n\t\t\tborder-color:var(--primary);\n\t\t}\n\t}\n}\n.fc-button.fc-today-button{\n\tborder: 0;\n    opacity: 1;\n\tmargin-bottom: 0.625rem;\n}\n.fc .fc-button-primary{\n\tbackground:var(--primary);\n\tcolor:$white;\n}\n.fc-unthemed .fc-toolbar .fc-button.fc-button-active, .fc-unthemed .fc-toolbar .fc-button:active, .fc-unthemed .fc-toolbar .fc-button:focus{\n\tbackground: var(--primary);\n    color: #fff;\n    border: 1px solid var(--primary);\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    text-shadow: none;\n}\n.fc .fc-toolbar-title {\n    font-size: 20px;\n    margin: 0;\n}\n\n\n.external-event{\n\tpadding: 8px 10px;\n\tdisplay:flex;\n\talign-items:center;\n    border-radius: 5px;\n\t&:hover{\n\t\t&:before{\n\t\t\tbackground:$white!important;\n\t\t}\n\t}\n}\n.fc-event{\n\toverflow:hidden;\n}\n\n.fc .fc-view-harness{\n\theight: 850px!important;\n\toverflow-y: auto;\n}\n.fc .fc-toolbar.fc-header-toolbar{\n\t@include respond ('phone'){\n\t\tdisplay:block;\n\t\t.fc-toolbar-chunk{\n\t\t\tdisplay:flex;\n\t\t\tjustify-content: center;\n\t\t\tborder-bottom: 0.625rem;\n\t\t\t&:first-child{\n\t\t\t\tjustify-content:space-between;\n\t\t\t}\n\t\t}\n\t\t.fc-toolbar-title{\n\t\t\tmargin-bottom: 8px;\n\t\t}\n\t}\n}\n\n#external-events{\n\t.external-event{\n\t\ttext-align: left;\n\t\tfont-size: 16px;\n\t}\n}\n\n.fc.app-fullcalendar{\n\t@include respond ('phone'){\n\t\t.fc-timegrid-slot-label{\n\t\t\twidth:40px!important;\n\t\t\tfont-size: 10px;\n\t\t}\n\t\t.fc-event, .external-event{\n\t\t\tfont-size: 10px;\n\t\t\tmargin:0;\n\t\t\tpadding: 2px 0;\n\t\t\ttext-align: center;\n\t\t\tline-height: 1.3;\n\t\t}\n\t\t.fc-col-header-cell-cushion {\n\t\t\tdisplay: inline-block;\n\t\t\tpadding: 2px 4px;\n\t\t\tfont-size: 10px;\n\t\t}\n\t}\n}",".accordion-button:not(.collapsed) {\n    color: inherit;\n    background: inherit;\n}\n.accordion-button.collapsed {\n    border-bottom-width: 1px;\n}\n.accordion {\n\t// accordion primary\n\t&-primary{\n\t\t.accordion-button {\n\t\t\t&.collapsed{\n\t\t\t\tbackground: var(--rgba-primary-1);\n\t\t\t\tborder-color: var(--rgba-primary-1);\n\t\t\t\tcolor: var(--primary);\n\t\t\t\tbox-shadow:none;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground: var(--rgba-primary-1);\n\t\t\t\t\tborder-color: var(--rgba-primary-1);\n\t\t\t\t\tcolor:$body-color;\n\t\t\t\t}\n\t\t\t}\n\t\t\tbackground:var(--primary);\n\t\t\tborder-color:var(--primary);\n\t\t\tcolor: $white;\n\t\t\tbox-shadow:0 0.9375rem 1.25rem 0 var(--rgba-primary-1);\n\t\t\t\n\t\t}\n\t}\n\t&-primary-solid{\n\t\t.accordion-button {\n\t\t\t&.collapsed{\n\t\t\t\tbackground: var(--rgba-primary-1);\n\t\t\t\tborder-color: var(--rgba-primary-1);\n\t\t\t\tcolor: var(--primary);\n\t\t\t\tbox-shadow:none;\n\t\t\t\tborder-bottom-left-radius:$radius;\n\t\t\t\tborder-bottom-right-radius:$radius;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground: var(--rgba-primary-1);\n\t\t\t\t\tborder-color: var(--rgba-primary-1);\n\t\t\t\t\tcolor:$body-color;\n\t\t\t\t}\n\t\t\t}\n\t\t\tbackground:var(--primary);\n\t\t\tborder-color:var(--primary);\n\t\t\tcolor: $white;\n\t\t\tbox-shadow:0 -0.625rem 1.25rem 0 var(--rgba-primary-1);\n\t\t\tborder-bottom-left-radius:0;\n\t\t\tborder-bottom-right-radius:0;\n\t\t}\n\t\t.accordion__body {\n            border: 0.125rem solid var(--primary);\n            border-top: none;\n\t\t\tbox-shadow:0 0.9375rem 1.25rem 0 var(--rgba-primary-1);\n\t\t\tborder-bottom-left-radius:$radius;\n\t\t\tborder-bottom-right-radius:$radius;\n\t\t}\n\t}\n\n\t&-danger{\n\t\t.accordion-button {\n\t\t\t&.collapsed{\n\t\t\t\tbackground: $danger-light;\n\t\t\t\tborder-color: $danger-light;\n\t\t\t\tcolor: #211c37;\n\t\t\t\tbox-shadow:none;\n\t\t\t}\n\t\t\tbackground:$danger;\n\t\t\tborder-color:$danger;\n\t\t\tcolor: $white;\n\t\t\tbox-shadow:0 0.9375rem 1.25rem 0 rgba($danger, 0.15);\n\t\t}\n\t}\n\t&-danger-solid{\n\t\t.accordion-button {\n\t\t\t&.collapsed{\n\t\t\t\tbackground: $danger-light;\n\t\t\t\tborder-color: $danger-light;\n\t\t\t\tcolor: #211c37;\n\t\t\t\tbox-shadow:none;\n\t\t\t\tborder-bottom-left-radius:$radius;\n\t\t\t\tborder-bottom-right-radius:$radius;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground: $danger-opacity;\n\t\t\t\t\tborder-color: $danger-opacity;\n\t\t\t\t\tcolor:$body-color;\n\t\t\t\t}\n\t\t\t}\n\t\t\tbackground:$danger;\n\t\t\tborder-color:$danger;\n\t\t\tcolor: $white;\n\t\t\tbox-shadow:0 -0.625rem 1.25rem 0 rgba($danger, 0.15);\n\t\t\tborder-bottom-left-radius:0;\n\t\t\tborder-bottom-right-radius:0;\n\t\t}\n\t\t.accordion__body {\n            border: 0.125rem solid $danger;\n            border-top: none;\n\t\t\tbox-shadow:0 0.9375rem 1.25rem 0 rgba($danger, 0.15);\n\t\t\tborder-bottom-left-radius:$radius;\n\t\t\tborder-bottom-right-radius:$radius;\n\t\t}\n\t}\n\n\n    //a single accrodion\n    &-item {\n        margin-bottom: 1.25rem;\n        border: 0;\n        background-color: transparent;\n        &:first-of-type {\n            .accordion-button {\n                border-top-left-radius : $radius;\n                border-top-right-radius: $radius;\n            }\n        }\n        &:last-of-type {\n            .accordion-button.collapsed {\n                border-bottom-left-radius : $radius;\n                border-bottom-right-radius: $radius;\n            }\n        }\n    }\n\n    //accrodion header styles\n    &-button {\n        padding:1rem 1.75rem;\n        border: 0.0625rem solid $border;\n        cursor: pointer;\n        position: relative;\n        color: $heading;\n        font-weight: 400;\n\t\tborder-radius:$radius;\n\t\t@include transitionMedium;\n        @at-root [data-theme-version=\"dark\"] & {\n            color: $white!important;\n            border-color: $d-border;\n        }\n        \n        \n\n        //set the indicator font family\n        &-indicator {\n            &.indicator_bordered {\n                display: inline-block;\n                width: 1.5625rem;\n                text-align: center;\n                height: 1.5625rem;\n                border: 0.0625rem solid $border;\n                border-radius: 50%;\n                line-height: 1.5625rem;\n            }\n        }\n\n        &:not(.collapsed){\n\t\t\t//color: inherit;\n\t\t\t&::after {\n\t\t\t\tcontent: \"\\e622\";\n\t\t\t\tbackground-image:none;\n\t\t\t\ttransform: rotate(0) translateY(-50%);\n\t\t\t\t\n\t\t\t}\n\n\t\t\t//icon style\n\t\t\t&.style_two {\n\t\t\t\t&::after {\n\t\t\t\t\tcontent: \"\\e648\";\n\t\t\t\t}\n\t\t\t}\n        }\n\t\t&::after {\n\t\t\tcontent: \"\\e61a\";\n\t\t\tfont-family: 'themify';\n\t\t\tposition: absolute;\n\t\t\tright: 1.5625rem;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t\tbackground-image: none !important;\n\t\t\t\n\t\t\twidth: auto;\n\t\t\theight: auto;\n\t\t\t@at-root [direction=\"rtl\"] & {\n\t\t\t\t right:auto;\n\t\t\t\t left: 1.5625rem;\n\t\t\t}\n\t\t}\n        &.collapsed {\n\t\t\t\n\n\t\t\t//icon style\n\t\t\t&.style_two {\n\t\t\t\t&::after {\n\t\t\t\t\tcontent: \"\\e64b\";\n\t\t\t\t}\n\t\t\t}\n        }\n    }\n\n    //accordion body styles\n    &-body {\n            padding: 0.875rem 1.25rem;\n\t\t\t    \n    }\n\t&-collapse{\n\t\tborder: 0;\n\t}\n    //accrodion with border\n    &-bordered {\n        .accordion__body {\n            border: 0.0625rem solid $border;\n            border-top: none;\n\t\t\tborder-bottom-left-radius:$radius;\n\t\t\tborder-bottom-right-radius:$radius;\n            @at-root [data-theme-version=\"dark\"] & {\n                border-color: $d-border;\n            }\n        }\n\t\t.accordion-button.collapsed{\n\t\t\tborder-radius:$radius;\n\t\t}\n\t\t.accordion-button{\n\t\t\tborder-bottom-left-radius:0;\n\t\t\tborder-bottom-right-radius:0;\n\t\t}\n\t\t\n    }\n\n    //accrodion without space\n    &-no-gutter {\n        .accordion-item {\n            margin-bottom: 0;\n\n            .accordion-button {\n                &.collapsed {\n                    border-bottom: none;\n                }\n            }\n\n            &:last-child {\n                .accordion-button {\n                    border-bottom: 0.0625rem solid $border;\n                    @at-root [data-theme-version=\"dark\"] & {\n                        border-color: $d-border;\n                    }\n                }\n            }\n            \n        }\n    }\n\n    //not gutter and bordered\n    &-no-gutter.accordion__bordered {\n        .accordion-item {\n            &:not(:last-child) {\n                .accordion__body {\n                    border-bottom: none;\n                }\n            }\n        }\n    }\n\n    //indicator in left positon\n    &-left-indicator {\n        .accordion-button {\n            &-text {\n                padding-left: 2.5rem;\n            }\n\n            &-indicator {\n                right: auto;\n                left: 1.5625rem;\n            }\n        }\n    }\n\n    //with icon\n    &-with-icon {\n        .accordion-button {\n            &-text {\n                padding-left: 2.5rem;\n\t\t\t\t@at-root [direction=\"rtl\"] & {\n\t\t\t\t\tpadding-left: 0;\n\t\t\t\t\tpadding-right: 2.5rem;\n\t\t\t\t}\n            }\n\n            &-icon {\n                position: absolute;\n                right: auto;\n                left: 1.5625rem;\n                font-family: 'themify';\n\t\t\t\t@at-root [direction=\"rtl\"] & {\n\t\t\t\t\tleft: auto;\n\t\t\t\t\tright: 1.5625rem;\n\t\t\t\t}\n                &::before {\n                    content: \"\\e645\";\n                }\n            }\n\t\t\t// for icon scss\n\t\t\t.accordion-header-icon {\n\t\t\t\tposition: absolute;\n\t\t\t\tright: auto;\n\t\t\t\tleft: 1.5625rem;\n\t\t\t\tfont-family: 'themify';\n\t\t\t\t&::before {\n                    content: \"\\e645\";\n                }\n\t\t\t}\n\t\t\t.accordion-header-text{\n\t\t\t\tpadding-left: 2.5rem;\n\t\t\t}\n        }\n\n    }\n\n    //with header background\n    &-header-bg {\n        .accordion-header {\n\t\t\t.accordion-button{\n\t\t\t\tbackground-color: $light;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground-color: $d-bg;\n\t\t\t\t}\n\t\t\t}\n            \n            \n            &-primary {\n\t\t\t\t.accordion-button{\n\t\t\t\t\tbackground-color: var(--primary);\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tborder-color:var(--primary);\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: var(--primary);\n\t\t\t\t\t}\n\t\t\t\t}\n            }\n            \n            &-info {\n\t\t\t\t.accordion-button{\n\t\t\t\t\tbackground-color: $info;\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tborder-color:$info;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: $info;\n\t\t\t\t\t}\n\t\t\t\t}\n            }\n\n            &-success {\n\t\t\t\t.accordion-button{\n\t\t\t\t\tbackground-color: $success;\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tborder-color:$success;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: $success;\n\t\t\t\t\t}\n\t\t\t\t}\n            }\n        }\n    }\n\n    //with header background and no space\n    &-header-bg.accordion-no-gutter {\n        .accordion-button {\n            border-color: transparent;\n\t\t\tborder-radius: 0;\n        }\n\t\t.accordion-item{\n\t\t\t&:first-child{\n\t\t\t\t.accordion-button{\n\t\t\t\t\tborder-top-left-radius:$radius;\n\t\t\t\t\tborder-top-right-radius:$radius;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:last-child{\n\t\t\t\t.accordion-button{\n\t\t\t\t\tborder-bottom-left-radius:$radius;\n\t\t\t\t\tborder-bottom-right-radius:$radius;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n    }\n\t&.accordion-no-gutter {\n        .accordion-button {\n            border-radius: 0;\n        }\n\t\t.accordion-button.collapsed {\n\t\t\tborder-radius: 0;\n\t\t}\n\t\t.accordion__body{\n\t\t\tborder-radius: 0;\n\t\t}\n\t\t.accordion-item{\n\t\t\t&:first-child{\n\t\t\t\t.accordion-button{\n\t\t\t\t\tborder-top-left-radius:$radius;\n\t\t\t\t\tborder-top-right-radius:$radius;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:last-child{\n\t\t\t\t.accordion-button.collapsed{\n\t\t\t\t\tborder-bottom-left-radius:$radius;\n\t\t\t\t\tborder-bottom-right-radius:$radius;\n\t\t\t\t}\n\t\t\t\t.accordion__body{\n\t\t\t\t\tborder-bottom-left-radius:$radius;\n\t\t\t\t\tborder-bottom-right-radius:$radius;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n    }\n    //with solid background\n    &-solid-bg {\n        .accordion-button {\n            border-color: transparent;\n            background-color: var(--rgba-primary-1);\n\t\t\tborder-bottom-left-radius:0;\n\t\t\tborder-bottom-right-radius:0;\n\t\t\t\n            @at-root [data-theme-version=\"dark\"] & {\n                background-color: $d-bg;\n            }\n\t\t\t&.collapsed{\n\t\t\t\tborder-radius:$radius;\n\t\t\t}\n        }\n\t\t\n        .accordion__body {\n            border-color: transparent;\n            background-color: var(--rgba-primary-1);\n\t\t\tborder-bottom-left-radius:$radius;\n\t\t\tborder-bottom-right-radius:$radius;\n            @at-root [data-theme-version=\"dark\"] & {\n                background-color: $d-bg;\n            }\n        }\n    }\n\n    //active header styles\n    &-active-header {\n        .accordion-button {\n            &:not(.collapsed) {\n                background-color: $info;\n                border-color: $info;\n                color: $white;\n            }\n        }\n    }\n\n    //shadow in header\n    &-header-shadow {\n        .accordion-button {\n            border: none;\n            box-shadow: 0 0 0.9375rem -0.1875rem rgba($color: $black, $alpha: .3);\n        }\n    }\n\n    //stylishly rounded borders\n    &-rounded-stylish {\n        .accordion-button {\n            border-top-left-radius: 0.375rem;\n            border-top-right-radius: 0.375rem;\n        }\n\n        .accordion__body {\n            border-bottom-left-radius: 0.375rem;\n            border-bottom-right-radius: 0.375rem;\n        }\n    }\n\n    //smothly rounded accrodion header\n    &-rounded {\n        .accordion-button {\n            border-radius: 0.3125rem;\n        }\n    }\n\n    //accordion gradient\n    &-gradient {\n        .accordion-button {\n            color: $white;\n            background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%,rgba(103, 25, 255, .85) 100%);\n            border-color: transparent;\n\t\t\tborder-bottom-left-radius: 0;\n            border-bottom-right-radius: 0;\n\t\t\t&.collapsed{\n\t\t\t\tborder-bottom-left-radius: 0.375rem;\n\t\t\t\tborder-bottom-right-radius:0.375rem;\n\t\t\t}\n\t\t\t&:not(.collapsed) {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n        }\n\n        .accordion__body {\n            color: $white;\n            background-image: linear-gradient(to right, rgba(186, 1, 181, 0.85) 0%,rgba(103, 25, 255, .85) 100%);\n            border-color: transparent;\n        }\n    }\n\t\n} \n\n.dzm-tabs{\n\tpadding:4px;\n    border-radius:  0.625rem;\n    background-color: var(--bs-body-bg);\n    border: none;\n    flex-wrap: nowrap;\n\t.nav-item{\n\t\t.nav-link{\n\t\t\tborder-radius:0.625rem;\n\t\t\t&.active{\n\t\t\t\tbackground:var(--primary)!important;\n\t\t\t\tcolor:$white;\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t}\n\t@include respond ('phone'){\n\t\tmargin-top:1rem;\n\t}\n}\n.dz-card{\n\t.card-body{\n\t\tpadding: 1.875rem!important;\n\t\tborder-radius:0 0 $radius $radius;\n\t\t@include respond('phone') {\n\t\t\tpadding: 1rem;\n\t\t}\n\t\t&.code-area{\n\t\t\t//background:$main-color;\n\t\t\tcode{\n\t\t\t\tbackground: transparent;\n\t\t\t\tcolor:var(--secondary);\n\t\t\t}\n\t\t}\n\t\t\n\t}\n\t.card-footer{\n\t\tcolor:$body-color!important;\n\t}\n\t.badge-box {\n\t\tposition: relative;\n\t\tbackground: black;\n\t\topacity: 0.6;\n\t\tborder-radius: 0 0 0.625rem 0.625rem;\n\t}\n\t\n}\n\n\n.unorder-list,\n.order-list{\n\tli{\n\t\tlist-style: unset;\n\t}\n}\n.text-justify{\n\ttext-align: justify;\n}\n.accordion-left-indicator {\n\t.accordion-header {\n\t\t.accordion-button {\n\t\t\tpadding-left: 2.5rem;\n\t\t\t&:after{\n\t\t\t\tleft: 1rem;\n\t\t\t}\n\t\t}\n\t}\n}",".alert{\n    border-radius: $radius;\n\tpadding:1rem 1.5rem;\n    @include respond('phone'){\n        padding-left: 1rem;\n        padding-right: 2rem;\n    }\n\tp{\n\t\tline-height:1.5;\n\t}\n}\n.alert-square{\n\tborder-radius: 0;\n}\n.alert-rounded{\n    border-radius: 3.125rem;\n}\n\n// Basic Alert\n\n\n.alert-primary{\n    background: var(--rgba-primary-1);\n    border-color: var(--rgba-primary-1);\n    color: var(--primary);\n}\n\n.alert-secondary{\n    background: $secondary-light;\n    border-color: $secondary-light;\n    color: $secondary;\n}\n.alert-success{\n    background: $success-light;\n    border-color: $success-light;\n    color: $success;\n}\n.alert-warning{\n    background: $warning-light;\n    border-color: $warning-light;\n    color: $warning;\n}\n.alert-danger{\n    background: $danger-light;\n    border-color: $danger-light;\n    color: $danger;\n}\n.alert-info{\n    background: $info-light;\n    border-color: $info-light;\n    color: $info;\n}\n.alert-dark{\n    background: $dark-light;\n    border-color: $dark-light;\n    color: $dark;\n}\n.alert-light{\n    background: $light;\n    border-color: $light;\n    color: $dark;\n}\n\n\n// Alert alt\n\n.alert-alt.alert-primary{\n    border-left: 0.25rem solid var(--primary);\n}\n\n.alert-alt.alert-secondary{\n    border-left: 0.25rem solid $secondary;\n}\n\n\n.alert-alt.alert-success{\n    border-left: 0.25rem solid $success\n}\n\n.alert-alt.alert-warning{\n    border-left: 0.25rem solid $warning;\n}\n\n.alert-alt.alert-danger{\n    border-left: 0.25rem solid $danger;\n}\n\n.alert-alt.alert-info{\n    border-left: 0.25rem solid $info;\n}\n\n.alert-alt.alert-dark{\n    border-left: 0.25rem solid $dark;\n}\n.alert-alt.alert-light{\n    border-left: 0.25rem solid darken($light,15%);\n}\n\n\n\n// Alert alt with solid color\n\n.alert-alt.alert-primary.solid{\n    border-left: 0.25rem solid var(--primary-dark)!important;\n}\n\n.alert-alt.alert-secondary.solid{\n    border-left: 0.25rem solid darken($secondary,25%)!important;\n}\n\n\n.alert-alt.alert-success.solid{\n    border-left: 0.25rem solid darken($success, 25%)!important;\n}\n\n.alert-alt.alert-warning.solid{\n    border-left: 0.25rem solid darken($warning,25%)!important;\n}\n\n.alert-alt.alert-danger.solid{\n    border-left: 0.25rem solid darken($danger,25%)!important;\n}\n\n.alert-alt.alert-info.solid{\n    border-left: 0.25rem solid darken($info,25%)!important;\n}\n\n.alert-alt.alert-dark.solid{\n    border-left: 0.25rem solid darken($dark,25%)!important;\n}\n.alert-alt.alert-light.solid{\n    border-left: 0.25rem solid darken($light,25%)!important;\n}\n\n\n//Alert dismissable with solid color\n.alert-dismissible.solid{\n    .close{\n        &:hover{\n            color: $white;\n            opacity: 1;\n        }\n    }\n}\n\n\n\n\n\n\n// Alert Solid \n.alert.alert-primary.solid{\n    background: var(--primary);\n    color: $white;\n    border-color: var(--primary);\n}\n\n.alert.alert-secondary.solid{\n    background: $secondary;\n    color: $white;\n    border-color: $secondary;\n}\n.alert.alert-success.solid{\n    background: $success;\n    color: $white;\n    border-color: $success;\n}\n\n.alert.alert-warning.solid{\n    background: $warning;\n    color: $white;\n    border-color: $warning;\n}\n\n.alert.alert-danger.solid{\n    background: $danger;\n    color: $white;\n    border-color: $danger;\n}\n\n.alert.alert-info.solid{\n    background: $info;\n    color: $white;\n    border-color: $info;\n}\n\n\n.alert.alert-dark.solid{\n    background: $dark;\n    color: $white;\n    border-color: $dark;\n}\n\n\n.alert.alert-light.solid{\n    background: $light;\n    color: $dark;\n    border-color: $light;\n}\n\n.alert-end-icon > span i{\n\tfont-size: 18px;\n    margin-right: 5px;\n}\n\n\n// Alert right icon\n\n.alert-right-icon{\n    &>span i{\n        font-size: 1.125rem;\n        margin-right: 0.3125rem;\n    }\n    .close{\n        i{\n            font-size: 1rem;\n        }\n    }\n}\n\n// Alert Outline\n.alert.alert-outline-primary{\n    background: transparent;\n    color: var(--primary);\n    border-color: var(--primary);\n}\n\n\n.alert.alert-outline-secondary{\n    background: transparent;\n    color: $body-color;\n    border-color: $secondary;\n}\n\n\n.alert.alert-outline-success{\n    background: transparent;\n    color: $success;\n    border-color: $success;\n}\n\n\n.alert.alert-outline-info{\n    background: transparent;\n    color: $info;\n    border-color: $info;\n}\n\n\n.alert.alert-outline-warning{\n    background: transparent;\n    color: $warning;\n    border-color: $warning;\n}\n\n.alert.alert-outline-danger{\n    background: transparent;\n    color: $danger;\n    border-color: $danger;\n}\n\n.alert.alert-outline-dark{\n    background: transparent;\n    color: $body-color;\n    border-color: $dark;\n}\n\n.alert.alert-outline-light{\n    background: transparent;\n    color: $dark;\n    border-color: $light;\n}\n\n\n\n// Alert Social\n.alert-social{\n    color: $white;\n    .alert-social-icon{\n        align-self: center;\n        margin-right: 0.9375rem;\n        i{\n            font-size: 2.625rem;\n        }\n    }\n    &.facebook{\n        background-color: $facebook;\n    }\n    &.twitter{\n        background-color: $twitter;\n    }\n    &.linkedin{\n        background-color: $linkedin;\n    }\n    &.google-plus{\n        background-color: $google-plus;\n    }\n    .close{\n        &:hover{\n            opacity: 1!important;\n            color: $white!important;\n        }\n    }\n}\n\n\n// Alert left icon\n\n.left-icon-big{\n    .alert-left-icon-big{\n        align-self: center;\n        margin-right: 0.9375rem;\n        i{\n            font-size: 2.1875rem;   \n\t\t\tline-height: 1;\n        }\n\t\t\n        // &.primary{\n        //     background: $primary;\n        //     color: $white;\n        // }\n    }\n    .media-body{\n        // margin-left: 6.25rem;\n    }\n}\n[direction=\"rtl\"]{\n\t.left-icon-big .alert-left-icon-big,\n\t.alert-social .alert-social-icon{\n\t\tmargin-right: 0;\n\t\tmargin-left: 0.9375rem;\n\t}\n}\n\n\n.alert{\n\t.btn-close{\n\t\tbackground:none;\n\t\ttext-shadow: 0 1px 0 #fff;\n\t\topacity: 0.5;\n\t\tcolor: inherit;\n\t\ti{\n\t\t\ttransform: scale(1.4);\n\t\t}\n\t\t&:focus{\n\t\t\tbox-shadow:none;\n\t\t}\n\t}\n}\n\n\n","\n\n\n.badge{\n\tline-height: 1.3;\n    border-radius: 0.325rem;\n    font-weight: 600;\n    padding: 0.25rem 0.515rem;\n\tborder:0.0625rem solid transparent;\n}\n\n.badge-rounded{\n    border-radius: 1.25rem;\n    padding:0.1875rem 0.8125rem ;\n}\n.badge-circle{\n    border-radius: 6.25rem;\n\tline-height: 13px;\n    padding: 0.1875rem 0.4375rem;\n}\n\n\n\n\n\n.badge-outline-primary{\n    border: 0.0625rem solid var(--primary);\n    color: var(--primary);\n}\n.badge-outline-secondary{\n    border: 0.0625rem solid $secondary;\n    color: $secondary;\n\t\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tcolor:$body-color;\n\t}\n}\n.badge-outline-success{\n    border: 0.0625rem solid $success;\n    color: $success;\n}\n.badge-outline-info{\n    border: 0.0625rem solid $info;\n    color: $info;\n}\n.badge-outline-warning{\n    border: 0.0625rem solid $warning;\n    color: $warning;\n}\n.badge-outline-danger{\n    border: 0.0625rem solid $danger;\n    color: $danger;\n}\n.badge-outline-light{\n    border: 0.0625rem solid $border;\n    color: $dark;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tcolor:$body-color;\n\t}\n}\n.badge-outline-dark{\n    border: 0.0625rem solid $dark;\n    color: $dark;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tcolor:$body-color;\n\t}\n}\n\n\n\n.badge-xs {\n    font-size: 0.625rem;\n    padding: 0rem 0.3125rem;\n    line-height: 1.125rem;\n}\n.badge-sm {\n\tfont-size: 0.6875rem;\n    padding: 0.3125rem 0.5rem;\n    line-height: 0.6875rem;\n}\n//.badge-md {\n//    font-size: 0.8125rem;\n//    padding: 0rem 0.5625rem;\n//    line-height: 1.5625rem;\n//}\n.badge-lg {\n    //font-size: 0.875rem;\n    //padding: 0rem 0.625rem;\n    //line-height: 1.875rem;\n\t\n\tpadding: 0.25rem 0.5rem;\n\tborder-radius: 0.5rem;\n    font-weight: 400;\n    font-size: 0.813rem;\n    line-height: 1.4;\n\t&:hover{\n\t\tcolor: #fff;\n\t}\n}\n\n\n.badge-xl {\n    font-size: 1rem;\n    padding: 0rem 0.9375rem;\n   line-height: 2;\n}\n.badge-default{\n    background: #ADB6C7;\n}\n.badge-success {\n    background-color: $success;\n\t&:hover{\n\t\tcolor:$white;\n\t}\n}\n.badge-secondary {\n    background-color: $secondary;\n\t&:hover{\n\t\tcolor:$white;\n\t}\n}\n.badge-info {\n    background-color: $info;\n\t&:hover{\n\t\tcolor:$white;\n\t}\n}\n.badge-primary {\n    background-color: var(--primary);\n\t&:hover{\n\t\tcolor:$white;\n\t}\n}\n.badge-warning {\n    background-color: $warning;\n\t&:hover{\n\t\tcolor:$white;\n\t}\n}\n.badge-danger {\n    background-color: $danger;\n\t&:hover{\n\t\tcolor:$white;\n\t}\n}\n.badge-dark {\n    background-color: $dark;\n\t&:hover{\n\t\tcolor:$white;\n\t}\n}\n.badge-light {\n    background-color: $light;\n\t&:hover{\n\t\tcolor:$white;\n\t}\n}\n\n\n\n.light.badge-default{\n    background: #ADB6C7;\n}\n.light.badge-success {\n    background-color: $success-light;\n\tcolor:$success;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $success-opacity;\n\t}\n}\n.light.badge-info {\n    background-color: $info-light;\n\tcolor:$info;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $info-opacity;\n\t}\n}\n.light.badge-primary {\n    background-color: #eaebf1;\n\tcolor:var(--primary);\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: var(--rgba-primary-1);\n\t}\n}\n.light.badge-secondary {\n    background-color: $secondary-light;\n\tcolor:$secondary;\n\t\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $secondary-opacity;\n\t\tcolor:$white;\n\t}\n}\n.light.badge-warning {\n    background-color: $warning-light;\n\tcolor:$warning;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $warning-opacity;\n\t}\n}\n.light.badge-danger {\n    background-color: $danger-light;\n\tcolor:$danger;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $danger-opacity;\n\t}\n}\n.light.badge-dark {\n    background-color: $dark-light;\n\tcolor:$dark;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $dark-opacity;\n\t\tcolor:$white;\n\t}\n}\n.light.badge-pink {\n    background-color: rgba($pink,0.1);\n    color: $pink;\n}\n.light.badge-light {\n    background-color: #eaebf1;\n    color: #aaa9ff;\n}\n\n\n\n//\n\n.bootstrap-label{\n    .label{\n        display: inline-block;\n        margin-right: 1rem;\n\n        &:last-child{\n            margin-right: 0;\n        }\n    }\n}\n\n.badge-demo{\n\n    .badge{\n        margin-right: 0.3125rem;\n        margin-bottom: 0.3125rem;\n\n        &:last-child{\n            margin-right: 0;\n        }\n    }\n}\n\n.bootstrap-badge-buttons{\n\n    button{\n        margin-right: .2rem;\n        margin-bottom: 1rem;\n\n        &:last-child{\n            margin-right: 0;\n        }\n    }\n}",".breadcrumb{\n\tfont-size:1.1875rem;\n\t.breadcrumb-item{\n\t\t&.active{\n\t\t\ta{\n\t\t\t\tcolor:var(--primary);\n\t\t\t}\n\t\t}\n\t\tsvg{\n\t\t\twidth: 22px;\n\t\t\tmargin-bottom: 3px;\n\t\t}\n\t}\n\t.breadcrumb-item + .breadcrumb-item::before{\n\t\tcolor:var(--primary);\n\t}\n}\n\n.page-titles {\n    display: flex;\n\talign-items: center;\n    justify-content: space-between;\n\tpadding: 0.825rem 1.875rem;\n    background:\t$bg-color;\n\tmargin-bottom: 1.875rem;\n\tborder-radius: $radius;\n\tposition:relative;\n\tz-index:1;\n\tflex-wrap: wrap;\n\t&.style1{\n\t\t  padding: 0.92rem 1.875rem;\n\t}\n\t\n\th2{\n\t\tmargin:0;\n\t}\n\t@include custommq ($max:100rem){\n\t\t//padding: 1.38rem 18.075rem;\n\t\th2{\n\t\t\tfont-size: 20px;\n\t\t}\n\t}\n\t@include respond('phone-land') {\n\t\tflex-wrap: wrap;\n\t\t\n    }\n\t @include respond('phone') {\n\t\tpadding: 0.6375rem 1rem;\n\t\tflex-wrap: wrap;\n\t\th2{\n\t\t\tfont-size:1rem;\n\t\t}\n\t }\n\n    .justify-content-sm-end{\n        align-items: center;\n    }\n\t.left-title{\n\t\t@include respond('phone') {\n\t\t\tmargin-bottom: 0.5rem;\n\t\t}\n\t}\n    h4 {\n        margin-bottom: 0;\n        margin-top: 0;\n        color: var(--primary);\n        font-size: 1.25rem;\n        span {\n            font-size: 0.875rem;\n            font-weight: 400;\n        }\n    }\n    .breadcrumb {\n        margin-bottom: 0;\n        padding: 0;\n        background: transparent;\n\t\talign-items:center;\n\t\t@include respond ('phone-land'){\n\t\t\tpadding-right: 0px;\n\t\t}\n\t\th2{\n\t\t\tmargin: 0;\n\t\t\tfont-size: 28px;\t\n\t\t\tfont-weight: 500;\n\t\t}\n\t\tp{\n\t\t\tmargin: 0;\n\t\t\tfont-size: 16px;\t\n\t\t\tcolor:#fff000;\n\t\t}\n        li {\n            margin-top: 0;\n            margin-bottom: 0;\n\t\t\tpadding-left: 2rem;\n\t\t\talign-items: center;\n\t\t\tdisplay: flex;\n\t\t\t@include respond ('phone'){\n\t\t\t\t&:first-child{\n\t\t\t\t\tpadding-left:0;\n\t\t\t\t}\n\t\t\t}\n\n            a{\n\t\t\t\tfont-size:14px;\n\t\t\t\tfont-weight:400;\n               //color: ; \n\t\t\t   display:flex;\n\t\t\t   align-items:center;\n\t\t\t   @include respond ('phone'){\n\t\t\t\t\tfont-size:0.95rem;\n\t\t\t   }\n\n            }\n\n            &.active{\n                color:var(--primary);\n\t\t\t\tfont-size:1rem;\n\t\t\t\ta{\n\t\t\t\t\tcolor:$light;\n\t\t\t\t}\n            }\n        }\n        \n        .breadcrumb-item + .breadcrumb-item {\n            &:before {\n                content: \"\\f105\";\n                font-family: 'Font Awesome 6 Free';\n                font-weight: 600;\n\t\t\t\tposition:absolute;\n                font-size: 14px;\n\t\t\t\tcolor:$light;\n\t\t\t\tmargin-left: -20px;\n            }\n        }\n\n        &-datepicker{\n            font-size: 0.75rem;\n            color: $muted;\n\n            &__icon{\n                font-size: 0.875rem;\n            }\n        }\n    }\n\t.sub-dz-head{\n\t\tdisplay:flex;\n\t\talign-items:center;\n\t\twidth:100%;\n\t\tjustify-content: space-between;\n\t\tposition:relative;\n\t\t&:before{\n\t\t\tcontent:\"\";\n\t\t\ttop:-18px;\n\t\t\tleft:0;\n\t\t\twidth:100%;\n\t\t\tbackground:rgba(255,255,255,0.12);\n\t\t\theight:1px;\n\t\t\tposition:absolute;\n\t\t}\n\t}\n\n    .breadcrumb-widget{\n        .border-dark{\n            border-color: $gray-300!important;\n        }\n        h4{\n            color: $strong;\n            font-weight: 600;\n        }\n        @include respond('phone') {\n            text-align: left!important;\n            margin-bottom: 0.9375rem;\n        }\n    }\n\tp{\n\t\tmargin:0;\n\t\tcolor:#fff000;\n\t}\n\t.btn{\n\t\tsvg{\n\t\t\t@include respond(\"tab-land\"){\n\t\t\t\twidth: 18px;\n   \t \t\t\theight: 18px;\n\t\t\t}\n\t\t\t@include respond(\"tab-port\"){\n\t\t\t\twidth: 18px;\n   \t \t\t\theight: 18px;\n\t\t\t}\n\t\t\t\n\t\t}\n\t}\n\n}\t\n\n\n","\nbutton{\n    cursor: pointer;\n\n    &:focus{\n        outline: 0;\n        box-shadow: none;\n    }\n}\n\n\n\n\n.btn {\n\tpadding: 0.688rem 1.5rem;\n    border-radius: 0.5rem;\n    font-weight: 500;\n    font-size: 1rem;\n    line-height: 1.5;\n    &:hover, &:focus, &:active, &.active{\n        outline: 0!important;\n    }\n\t\n\t@include respond('laptop') {\n\t\tpadding: 0.625rem 1rem;\n\t\tfont-size: 0.813rem;\n\t}\n\t&.btn-success,&.btn-secondary,&.btn-warning,&.btn-primary,&.btn-danger,&.btn-info{\n\t\tcolor:$white;\n\t\t&:hover{\n\t\t\tcolor:$white!important;\n\t\t}\n\t}\n\t\n    &-transparent {\n        background-color: transparent;\n    }\n\n\n}\n.btn-primary{\n\tborder-color:var(--primary);\t\n\tbackground-color:var(--primary);\n\t&:active,\n\t&:focus,\n\t&:hover{\n\t\tborder-color:var(--primary-hover);\t\n\t\tbackground-color:var(--primary-hover);\t\n\t}\n\t&:focus{\n\t\tbox-shadow:unset;\n\t}\n\t&:disabled,\n\t&.disabled{\n\t\tbackground-color: var(--primary);\n\t\tborder-color: var(--primary);\n\t}\n}\n\n.btn-link{\n\tcolor:var(--primary);\n\ttext-decoration: none;\n\t&:hover{\n\t\tcolor:var(--primary-hover);\t\n\t}\n}\n.btn-outline-primary {\n\tcolor:var(--primary);\t\n\tborder-color:var(--primary);\n\t&:hover{\n\t\tborder-color:var(--primary-hover);\t\n\t\tbackground-color:var(--primary-hover);\t\n\t}\n}\n.sharp {\n\twidth: 2.5rem;\n    height: 2.5rem;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: $radius;\n\tpadding: 0;\n\t\n}\n.sharp-sm{\n\theight: 2.5rem;\n\twidth: 2.5rem;\n\tline-height:2.5rem\n}\n.sharp-lg{\n\theight:3rem;\n\twidth:3rem;\n\tline-height:2.7rem;\n\t@include respond('laptop') {\n\t\theight:2.285rem;\n\t\twidth:2.285rem;\n\t\tline-height:2.5rem;\n\t\tfont-size: 0.813rem;\n\t}\n}\n.sharp.btn-xs{\n    padding: 0.1875rem;\n    width: 1.625rem;\n    height: 1.625rem;\n    min-width: 1.625rem;\n    min-height: 1.625rem;\n}\n\n.btn-block {\n    display: block;\n    width: 100%;\n}\n\n.light{\n\n\t&.tp-btn{\n\t\tbackground-color:transparent;\n\t}\n\t&.btn-default{\n\t\tbackground: #ADB6C7;\n\t}\n\t&.btn-success {\n\t\tbackground-color: rgba($success,0.1);\n\t\tborder-color: $success-light;\n\t\tcolor:$success;\n\t\tg [fill]{\n\t\t\tfill:$success;\n\t\t}\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground-color: $success-opacity;\n\t\t\tborder-color: transparent;\n\t\t}\n\n\t\t&:hover{\n\t\t\tbackground-color: $success;\n\t\t\tborder-color: $success;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-info {\n\t\tbackground-color: $info-light;\n\t\tborder-color: $info-light;\n\t\tcolor:$info;\n\t\tg [fill]{\n\t\t\tfill:$info;\n\t\t}\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground-color: $info-opacity;\n\t\t\tborder-color:transparent;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $info;\n\t\t\tborder-color: $info;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-primary {\n\t\tbackground-color: var(--rgba-primary-1);\n\t\tborder-color: var(--rgba-primary-1);\n\t\tcolor:var(--primary);\n\t\tg [fill]{\n\t\t\tfill:var(--primary);\n\t\t}\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground-color: var(--rgba-primary-1);\n\t\t\tborder-color:transparent;\n\t\t\tcolor:$white;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: var(--primary);\n\t\t\tborder-color: var(--primary);\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-secondary {\n\t\tbackground: rgba($secondary, 0.2);\n\t\tborder-color: rgba($secondary, 0.1);\n\t\tcolor:$secondary!important;\n\t\tg [fill]{\n\t\t\tfill:$secondary;\n\t\t}\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground-color: $secondary-opacity;\n\t\t\tborder-color:transparent;\n\t\t\tcolor:$white;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $secondary;\n\t\t\tborder-color: $secondary;\n\t\t\tcolor: #fff!important;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-warning {\n\t\tbackground-color: $warning-light;\n\t\tborder-color: $warning-light;\n\t\tcolor:$warning;\n\t\tg [fill]{\n\t\t\tfill:$warning;\n\t\t}\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground-color: $warning-opacity;\n\t\t\tborder-color:transparent;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $warning;\n\t\t\tborder-color: $warning;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-danger {\n\t\tbackground-color: $danger-light;\n\t\tborder-color: $danger-light;\n\t\tcolor:$danger;\n\t\tg [fill]{\n\t\t\tfill:$danger;\n\t\t}\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground-color: $danger-opacity;\n\t\t\tborder-color:transparent;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $danger;\n\t\t\tborder-color: $danger;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-dark {\n\t\tbackground-color: $dark-light;\n\t\tborder-color: $dark-light;\n\t\tcolor:$dark;\n\t\tg [fill]{\n\t\t\tfill:$dark;\n\t\t}\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tbackground-color: $dark-opacity;\n\t\t\tborder-color:transparent;\n\t\t\tcolor:$white;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $dark;\n\t\t\tborder-color: $dark;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n}\n.btn.tp-btn{\n\tbackground-color:transparent;\n\tborder-color: transparent;\n\t&.btn-default{\n\t\tbackground: #ADB6C7;\n\t}\n\t&.btn-success {\n\t\tcolor:$success;\n\t\tg [fill]{\n\t\t\tfill:$success;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $success;\n\t\t\tborder-color: $success;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-info {\n\t\tcolor:$info;\n\t\tg [fill]{\n\t\t\tfill:$info;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $info;\n\t\t\tborder-color: $info;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-primary {\n\t\tcolor:var(--primary);\n\t\tbackground-color:var(--rgba-primary-1);\n\t\tg [fill]{\n\t\t\tfill:var(--primary);\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: var(--primary);\n\t\t\tborder-color: var(--primary);\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-secondary {\n\t\tcolor:var(--secondary);\n\t\tg [fill]{\n\t\t\tfill:var(--secondary);\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $secondary;\n\t\t\tborder-color: $secondary;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-warning {\n\t\tcolor:$warning;\n\t\tg [fill]{\n\t\t\tfill:$warning;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $warning;\n\t\t\tborder-color: $warning;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-danger {\n\t\tcolor:$danger;\n\t\tg [fill]{\n\t\t\tfill:$danger;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $danger;\n\t\t\tborder-color: $danger;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-light {\n\t\tcolor:$dark;\n\t\tg [fill]{\n\t\t\tfill:$dark;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $light;\n\t\t\tborder-color: $light;\n\t\t\tcolor: $dark;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-dark {\n\t\tcolor:$dark;\n\t\tg [fill]{\n\t\t\tfill:$dark;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $dark;\n\t\t\tborder-color: $dark;\n\t\t\tcolor: #fff;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n}\n.btn.tp-btn-light{\n\tbackground-color:transparent;\n\tborder-color: transparent;\n\t\n\t&.btn-success {\n\t\tcolor:$success;\n\t\tg [fill]{\n\t\t\tfill:$success;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $success-light;\n\t\t\tborder-color: $success-light;\n\t\t\tcolor:$success;\n\t\t\tg [fill]{\n\t\t\t\tfill:$success;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-info {\n\t\tcolor:$info;\n\t\tg [fill]{\n\t\t\tfill:$info;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $info-light;\n\t\t\tborder-color: $info-light;\n\t\t\tcolor:$info;\n\t\t\tg [fill]{\n\t\t\t\tfill:$info;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-primary {\n\t\tcolor:var(--primary);\n\t\tg [fill]{\n\t\t\tfill:var(--primary);\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: var(--rgba-primary-1);\n\t\t\tborder-color: var(--rgba-primary-1);\n\t\t\tcolor:var(--primary);\n\t\t\tg [fill]{\n\t\t\t\tfill:var(--primary);\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-secondary {\n\t\tcolor:var(--secondary);\n\t\tg [fill]{\n\t\t\tfill:var(--secondary);\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: var(--rgba-secondary-1);\n\t\t\tborder-color: var(--rgba-secondary-1);\n\t\t\tcolor:var(--secondary);\n\t\t\tg [fill]{\n\t\t\t\tfill:var(--secondary);\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-warning {\n\t\tcolor:$warning;\n\t\tg [fill]{\n\t\t\tfill:$warning;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $warning-light;\n\t\t\tborder-color: $warning-light;\n\t\t\tcolor:$warning;\n\t\t\tg [fill]{\n\t\t\t\tfill:$warning;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-danger {\n\t\tcolor:$danger;\n\t\tg [fill]{\n\t\t\tfill:$danger;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $danger-light;\n\t\t\tborder-color: $danger-light;\n\t\t\tcolor:$danger;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n\t&.btn-dark {\n\t\tcolor:$dark;\n\t\tg [fill]{\n\t\t\tfill:$dark;\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color: $dark-light;\n\t\t\tborder-color: $dark-light;\n\t\t\tcolor: $dark;\n\t\t\tg [fill]{\n\t\t\t\tfill:$white;\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n\n\n.shadow.btn-primary {\n    -webkit-box-shadow: 0 0.3125rem 0.9375rem 0 var(--rgba-primary-2) !important;\n    box-shadow: 0 0.3125rem 0.9375rem 0 var(--rgba-primary-2) !important;\n}\n.shadow.btn-secondary {\n    -webkit-box-shadow: 0 0.3125rem 0.9375rem 0 rgba($secondary,0.2) !important;\n    box-shadow: 0 0.3125rem 0.9375rem 0 rgba($secondary,0.2) !important;\n}\n.shadow.btn-warning {\n    -webkit-box-shadow: 0 0.3125rem 0.9375rem 0 rgba($warning,0.2) !important;\n    box-shadow: 0 0.3125rem 0.9375rem 0 rgba($warning,0.2) !important;\n}\n.shadow.btn-danger {\n    -webkit-box-shadow: 0 0.3125rem 0.9375rem 0 rgba($danger,0.2) !important;\n    box-shadow: 0 0.3125rem 0.9375rem 0 rgba($danger,0.2) !important;\n}\n.shadow.btn-info {\n    -webkit-box-shadow: 0 0.3125rem 0.9375rem 0 rgba($info,0.2) !important;\n    box-shadow: 0 0.3125rem 0.9375rem 0 rgba($info,0.2) !important;\n}\n.shadow.btn-success {\n    -webkit-box-shadow: 0 0.3125rem 0.9375rem 0 rgba($success,0.2) !important;\n    box-shadow: 0 0.3125rem 0.9375rem 0 rgba($success,0.2) !important;\n}\n\n\n\n.btn-xxs {\n    padding: 0.367rem 0.9375rem;\n    font-size: 0.6875rem;\n    line-height: 1.3;\n}\n.btn-xs {\n    font-size: 0.75rem;\n   padding: 0.375rem 1rem;\n    // padding  : 0.5 2.5rem !important;\n\tfont-weight: 600;\n\tborder-radius: 0.3rem;\n}\n\n.btn-sm {\n    font-size: 0.813rem  !important;\n\tpadding: 0.579rem 1rem;\n}\n.btn-md {\n    font-size: 0.875rem  !important;\n\tpadding: 0.579rem 1rem;\n}\n.btn-lg{\n    padding: 0.969rem 2rem;\n    font-size: 1.125rem !important;\n\t@include respond('phone') {\n\t\t padding: 0.75rem 1.25rem;\n\t}\n}\n\n.btn-xl{\n    padding: 0.6rem 1rem;\n\n    &.btn-default{\n        font-weight: 600;\n    }\n}\n\n.btn-icon-lg {\n\tpadding: 15px 18px;\n\tmin-width: 20px !important;\n}\n.btn-icon-md {\n\tpadding: 13px 16px;\n\tmin-width: 20px !important;\n}\n.btn-icon-sm {\n\tpadding: 11px 14px;\n\tmin-width: 20px !important;\n}\n.btn-icon-xs {\n\tpadding: 10px 12px;\n\tmin-width: 20px !important;\n}\n.btn-icon-xxs {\n\tpadding: 8px 10px;\n\tmin-width: 20px !important;\n}\n\n.btn-square {\n    border-radius: 0;\n}\n\n.btn-rounded {\n    border-radius: 2.5rem !important;\n}\n\n.btn-icon-end {\n\tborder-left: 0.0625rem solid $light;\n    display: inline-block;\n    margin: -.8rem 0 -.8rem 1rem;\n    padding: 0.4375rem 0 0.4375rem 1rem;\n    margin: -1rem -0.25rem -1rem 1rem;\n    padding: 1rem 0 1rem 1.25rem;\n}\n\n.btn-icon-start {\n    background: #fff;\n    border-radius:\t0.5rem;\n    display: inline-block;\n\tmargin: -0.2rem 0.55rem -0.4rem -1.188rem;\n    padding: 0.3rem 0.6rem 0.2rem;\n    float: left;\n\t@include respond('laptop') {\n\t\tmargin: -0.2rem 0.5rem -0.2rem -0.48rem;\n\t}\n}\n[direction=\"rtl\"]{\n\t.btn-icon-start {\n\t\tmargin: -.5rem 0.5rem -0.5rem -1rem;\n\t\t@include respond('laptop') {\n\t\t\tmargin: -0.5rem 0.75rem -0.5rem -0.880rem;\n\t\t}\n\t}\n\t.btn-icon-end {\n\t\tborder-left: 0rem solid white;\n\t\tdisplay: inline-block;\n\t\tmargin: -.8rem 1rem -.8rem 0;\n\t\tpadding: 0.4375rem 1rem 0.4375rem 0;\n\t\tborder-right: 0.0625rem solid white;\n\t}\n}\n.toggle-dropdown::after {\n    margin-left: 0.755em;\n}\n\n.social-btn-icon {\n    .btn {\n        min-width    : 7.5rem;\n        margin-bottom: 1.5rem;\n    }\n}\n\n.social-icon {\n    .btn {\n        padding: .7rem 1.4rem;\n    }\n}\n\n.btn-circle {\n    height       : 5rem;\n    width        : 5rem;\n    border-radius: 50% !important;\n\n    &-sm {\n        width: 4.5rem;\n        height: 4.5rem;\n        font-size: 1.8rem;\n    }\n\n    &-md {\n        width: 6rem;\n        height: 6rem;\n        font-size: 2.5rem;\n\n        i{\n            font-size: 2.4rem;\n        }\n    }\n\n    &-lg {\n        width: 8rem;\n        height: 8rem;\n        font-size: 3.2rem;\n\n        i{\n            font-size: 3.1rem;\n        }\n    }\n}\n\n.btn-page{\n    .btn{\n        min-width: 6.875rem;\n        margin-right: 0.25rem;\n        margin-bottom: 0.5rem;\n\t\toverflow: hidden;\n\n    }\n\n}\n\n\n\n// btn sizes\n.size-1{\n    min-width: 10rem !important;\n    font-size: 1.5rem;\n    padding: 0.68rem 0.75rem;\n}\n\n.size-2{\n    font-size: 1.25rem;\n    min-width: 8.125rem !important;\n    padding: 0.57rem 0.75rem;\n}\n\n.size-3{\n    font-size: 0.875rem;\n    min-width: 6.875rem !important;\n    padding: 0.536rem 0.75rem;\n}\n.size-4{\n    font-size: 0.875rem;\n    min-width: 6.25rem !important;\n}\n.size-5{\n    font-size: 0.875rem;\n    min-width: 5.625rem !important;\n    padding: .22rem 0.75rem;\n}\n.size-6{\n    font-size: 0.8125rem;\n    min-width: 5rem !important;\n    padding: 0.097rem 0.75rem;\n}\n.size-7{\n    font-size: 0.75rem;\n    min-width: 3.75rem !important;\n    padding: 0.001rem 0.75rem;\n}\n\n\n\n\n\n.btn-light {\n    background  : $light;\n    border-color: $light;\n    color       : $dark;\n    \n    &:active,\n    &:focus,\n    &:hover {\n        background  : #d7d7db;\n\t\tborder-color: #d7d7db;\n    }\n\tsvg{\n\t\tpath{\n\t\t\tfill:var(--primary);\n\t\t}\n\t}\n}\n\n.btn-outline-primary{\n\t&:hover{\n\t\tcolor:$white;\n\t}\n}\n.btn-outline-warning{\n\t&:hover{\n\t\tcolor:$white;\n\t}\n}\n.btn-outline-danger{\n\t&:hover{\n\t\tcolor: $white;\n\t}\n}\n.btn-outline-success{\n\t&:hover{\n\t\tcolor: $white;\n\t}\n}\n.btn-outline-info{\n\t&:hover{\n\t\tcolor: $white;\n\t}\n}\n.btn-outline-light{\n    color: $dark;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tcolor:$body-color;\n\t}\n}\n.btn-outline-secondary{\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tcolor:$body-color;\n\t}\n\t&:hover{\n\t\tcolor: $white;\n\t}\n}\n.btn-outline-dark{\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tcolor:$body-color;\n\t}\n}\n\n\n.btn-dark {\n    background  : $dark;\n    border-color: $dark;\n    color       : $white;\n    \n    \n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($dark, 10%);\n        color       : $white;\n        border-color: darken($dark, 10%);\n    }\n}\n\n.btn-group{\n\n    &.btn-rounded{\n\n        .btn:first-child{\n            border-top-left-radius: 1.875rem;\n            border-bottom-left-radius: 1.875rem;\n        }\n\n        .btn:last-child{\n            border-top-right-radius: 1.875rem;\n            border-bottom-right-radius: 1.875rem;\n        }\n    }\n}\n\n\n\n///////////////////\n// Social Buttons\n///////////////////\n\n.btn-facebook {\n    background  : $facebook;\n    border-color: $facebook;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($facebook, 10%);\n        color       : $white;\n        border-color: darken($facebook, 10%);\n    }\n}\n\n.btn-twitter {\n    background  : $twitter;\n    border-color: $twitter;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($twitter, 10%);\n        color       : $white;\n        border-color: darken($twitter, 10%);\n    }\n}\n\n.btn-youtube {\n    background  : $youtube;\n    border-color: $youtube;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($youtube, 10%);\n        color       : $white;\n        border-color: darken($youtube, 10%);\n    }\n}\n\n.btn-instagram {\n    background  : $instagram;\n    border-color: $instagram;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($instagram, 10%);\n        color       : $white;\n        border-color: darken($instagram, 10%);\n    }\n}\n\n.btn-pinterest {\n    background  : $pinterest;\n    border-color: $pinterest;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($pinterest, 10%);\n        color       : $white;\n        border-color: darken($pinterest, 10%);\n    }\n}\n\n.btn-linkedin {\n    background  : $linkedin;\n    border-color: $linkedin;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($linkedin, 10%);\n        color       : $white;\n        border-color: darken($linkedin, 10%);\n    }\n}\n\n.btn-google-plus {\n    background  : $google-plus;\n    border-color: $google-plus;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($google-plus, 10%);\n        color       : $white;\n        border-color: darken($google-plus, 10%);\n    }\n}\n\n.btn-google {\n    background  : $google;\n    border-color: $google;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($google, 10%);\n        color       : $white;\n        border-color: darken($google, 10%);\n    }\n}\n\n.btn-snapchat {\n    background  : $snapchat;\n    border-color: $snapchat;\n    color       : $black;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($snapchat, 10%);\n        color       : $black;\n        border-color: darken($snapchat, 10%);\n    }\n}\n\n.btn-whatsapp {\n    background  : $whatsapp;\n    border-color: $whatsapp;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($whatsapp, 10%);\n        color       : $white;\n        border-color: darken($whatsapp, 10%);\n    }\n}\n\n.btn-tumblr {\n    background  : $tumblr;\n    border-color: $tumblr;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($tumblr, 10%);\n        color       : $white;\n        border-color: darken($tumblr, 10%);\n    }\n}\n\n.btn-reddit {\n    background  : $reddit;\n    border-color: $reddit;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($reddit, 10%);\n        color       : $white;\n        border-color: darken($reddit, 10%);\n    }\n}\n\n.btn-spotify {\n    background  : $spotify;\n    border-color: $spotify;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($spotify, 10%);\n        color       : $white;\n        border-color: darken($spotify, 10%);\n    }\n}\n\n.btn-yahoo {\n    background  : $yahoo;\n    border-color: $yahoo;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($yahoo, 10%);\n        color       : $white;\n        border-color: darken($yahoo, 10%);\n    }\n}\n\n.btn-dribbble {\n    background  : $dribbble;\n    border-color: $dribbble;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($dribbble, 10%);\n        color       : $white;\n        border-color: darken($dribbble, 10%);\n    }\n}\n\n.btn-skype {\n    background  : $skype;\n    border-color: $skype;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($skype, 10%);\n        color       : $white;\n        border-color: darken($skype, 10%);\n    }\n}\n\n.btn-quora {\n    background  : $quora;\n    border-color: $quora;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($quora, 10%);\n        color       : $white;\n        border-color: darken($quora, 10%);\n    }\n}\n\n.btn-vimeo {\n    background  : $vimeo;\n    border-color: $vimeo;\n    color       : $white;\n\n    &:active,\n    &:focus,\n    &:hover {\n        background  : darken($vimeo, 10%);\n        color       : $white;\n        border-color: darken($vimeo, 10%);\n    }\n}\n\n.btn-check:checked + .btn-outline-primary,\n.btn-check:active + .btn-outline-primary,\n.btn-outline-primary:active,\n.btn-outline-primary.active,\n.btn-outline-primary.dropdown-toggle.show{\n\tbackground-color:var(--primary);\n\tborder-color:var(--primary);\n\tcolor:$white;\n}\n \n.btn-check:checked + .btn-outline-primary:focus,\n.btn-check:active + .btn-outline-primary:focus,\n.btn-outline-primary:active:focus,\n.btn-outline-primary.active:focus,\n.btn-outline-primary.dropdown-toggle.show:focus{\n\tbox-shadow:0 0 0 0.25rem var(--rgba-primary-5);\n}\n.btn-check:focus + .btn-outline-primary, .btn-outline-primary:focus{\n\tbox-shadow:0 0 0 0.25rem var(--rgba-primary-5);\n}\n.btn-close:focus{\n\tbox-shadow:0 0 0 0.25rem var(--rgba-primary-5);\n}\n\n// -----Button----\n.btn.btn-pink{\n    background-color: $pink;\n    color: $white;\n    &:hover{\n        background-color: rgba($pink, 0.8);\n    }\n}\n.btn.light.btn-pink {\n    background-color: rgba($pink,0.1);\n    color: $pink;\n\t&:hover{\n\t\tbackground-color: $pink;\n\t\tcolor: $white;\n\t}\n}\n.btn.light{\n\t&:hover{\n\t\tsvg{\n\t\t\tpath{\n\t\t\t\tfill: $white;\n\t\t\t}\n\t\t}\n\t}\n}\n.bg-success{\n\t&.light{\n\t\tbackground-color:rgba($success , 0.2)!important;\n\t\tsvg{\n\t\t\tpath{\n\t\t\t\tfill:$success;\n\t\t\t}\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color:$success!important;\n\t\t\tsvg{\n\t\t\t\tpath{\n\t\t\t\t\tfill:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.bg-info{\n\t&.light{\n\t\tbackground-color:rgba($info , 0.2)!important;\n\t\tsvg{\n\t\t\tpath{\n\t\t\t\tfill:$info;\n\t\t\t}\n\t\t}\n\t\t&:hover{\n\t\t\tbackground-color:$info!important;\n\t\t\tsvg{\n\t\t\t\tpath{\n\t\t\t\t\tfill:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}",".card {\n    margin-bottom: 1.875rem;\n    background-color: $bg-color;\n    transition: all .5s ease-in-out;\n    position: relative;\n    border: 0rem solid transparent;\n    border-radius: $radius;\n  \n\theight: calc(100% - 30px);\n\t\n\t// z-index: 0;\n\t@include custommq($max: 35.9375rem) {\n\t\tmargin-bottom:0.938rem;\n\t\theight: calc(100% - 0.938rem);\n\t}\n\t\n\n    &-body {\n        padding:  1.875rem ;\n\t\t@include respond('phone') {\n\t\t\tpadding: 1rem;\n\t\t}\n    }\n\n    &-title {\n        font-size: 1.125rem;\n        font-weight: 600;\n        // line-height: 2.2rem;\n        color: $main-color;\n        text-transform: capitalize;\n        // margin-bottom: 1.5rem;\n    \n        &--large{\n            font-size: 1.5rem;\n        }\n    \n        &--medium{\n            font-size: 1rem;\n        }\n    \n        &--small{\n            font-size: 0.875rem;\n        }\n    }\n\n    &-header {\n        border-color: $border-main-color;\n        position: relative;\n        background: transparent;\n        padding:1.5rem 1.875rem 1.25rem;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        border-radius:$radius $radius 0px 0px!important;\n        // min-height: 4.0625rem;\n\t\t@include respond('phone') {\n\t\t\tpadding: 1.25rem 1rem 1.25rem;\n\t\t}\n        @at-root [data-theme-version=\"dark\"] & {\n            border-color: $d-border;\n        }\n\n        .card-title{\n            margin-bottom: 0rem;\n        }\n        .subtitle{\n            padding-top: 0.3125rem;\n            font-size: 0.875rem;\n\t\t\tline-height: 1.5;\n        }\n    }\n\n    &-footer {\n        border-color: $border-main-color;\n        background: transparent;\n        padding: 1.25rem 1.875rem 1.25rem;\n        @at-root [data-theme-version=\"dark\"] & {\n            border-color: $d-border;\n        }\n    }    \n    \n}\n\n.transparent-card{\n    &.card{\n        background: transparent;\n        border: 0.0625rem solid transparent;\n        box-shadow: none;\n    }\n}\n\n\n\n\n///////////////////\n//  Card action\n///////////////////\n.card-action {\n    > a {\n        display: inline-block;\n        width: 1.875rem;\n        height: 1.875rem;\n        line-height: 1.875rem;\n        border-radius: 0.3125rem;\n        border-color: transparent;\n        text-align: center;\n        background: var(--primary-dark);\n        color: $white;\n        margin-right: 0.5rem;\n\n        @at-root [data-theme-version=\"dark\"] & {\n            background: $d-bg;\n        }\n\n        &:last-child{\n            margin-right: 0;\n        }\n        &:hover,&:focus{\n            background: var(--primary-dark);\n\n            @at-root [data-theme-version=\"dark\"] & {\n                background: $d-bg;\n            }\n        }\n\n\n        i,span{\n            font-size: 1rem;\n            // color: #333333;\n        }\n        // padding: 0 .5rem;\n    }\n\n    .dropdown{\n        width: 1.875rem;\n        height: 1.875rem;\n        border-radius: 0.3125rem;\n        border-color: transparent;\n        text-align: center;\n        margin-right: 0.5rem;\n        top: -0.125rem;\n        position: relative;\n        display: inline-block;\n        background: var(--primary-dark);\n        color: var(--primary);\n\n        @at-root [data-theme-version=\"dark\"] & {\n            background: $d-bg;\n        }\n        \n        &:hover,&:focus{\n            background: var(--primary-dark);\n\n            @at-root [data-theme-version=\"dark\"] & {\n                background: $d-bg;\n            }\n        }\n\n        .btn{\n            padding: 0;\n            line-height: 1.6875rem;\n            color: $white;\n\n            &:focus{\n                box-shadow: none;\n            }\n        }\n    }\n}\n\n.card-fullscreen {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 99999999;\n    overflow: auto;\n}\n\n.card-loader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    background-color: rgba(0, 0, 0, 0.75);\n    z-index: 999\n}\n\n.card-loader i {\n    margin: 0 auto;\n    background: var(--primary-dark);\n    padding: 0.625rem;\n    border-radius: 50%;\n    color: $white;\n    font-size: 1rem\n}\n\n.rotate-refresh {\n    -webkit-animation: mymove 0.8s infinite linear;\n    animation: mymove 0.8s infinite linear;\n    display: inline-block\n}\n\n.card-header {\n    .date_picker {\n        display: inline-block;\n        padding: 0.5rem;\n        border: 0.0625rem solid $border-main-color;\n        cursor: pointer;\n        border-radius: .375rem;\n    }\n\t.border-0{\n\t\tpadding-bottom:0;\n\t}\n}\n\n\n@-webkit-keyframes mymove {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg)\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg)\n    }\n}\n\n@keyframes mymove {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg)\n    }\n    100% {\n        -webkit-transform: rotate(360deg);\n        transform: rotate(360deg)\n    }\n}\n\n.select2-container .select2-selection--single .select2-selection__clear {\n\tdisplay: none;\n}","    .carousel-custom{\n\n    &-prev, &-next{\n        width: 2.5rem;\n        height: 2.5rem;\n        line-height: 2.5rem;\n        display: inline-block;\n        border-radius: 50%;\n        background: $white;\n        text-align: center;\n\n        i{\n            font-size: 1rem;\n        }\n\n        &:hover{\n            background: linear-gradient(to right, rgba(245, 60, 121, 0.99) 0%, rgba(246, 104, 47, 0.99) 100%);\n            color: $white;\n        }\n    }\n\n    &-next{\n        position: absolute;\n        top: 50%;\n        right: 30px;\n        transform: translateY(-50%);\n    }\n\n    &-prev{\n        position: absolute;\n        top: 50%;\n        left: 30px;\n        transform: translateY(-50%);\n    }\n}\n\n\n.carousel-caption{\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.78);\n\tz-index:1;\n\tbackground: rgba($black,0.6);\n    h5{\n        color: $white;\n        font-size: 1.8rem;\n    }\n\n    p{\n        margin-bottom: 0;\n\t\tcolor:$white;\n    }\n}\n.carousel-indicators{\n    z-index:1;\n}",".dropdown-toggle:focus {\n    box-shadow: none!important;\n  }\n\n  .dropdown-outline{\n      border: .1rem solid var(--primary);\n  }\n\n.dropdown-menu{\n\tfont-size: inherit;\n\tborder: 0;\n\tz-index: 8;\n\toverflow:hidden;\n\tborder-radius:$radius;\n\tbox-shadow: 0 0 3.125rem 0 rgba(82, 63, 105, 0.15);\n\tmargin-top:0;\n\t\n\t.dropdown-item{\n\t\tfont-size: 1rem;\n\t\tcolor:$body-color;\n\t\tpadding: 0.5rem 1.25rem;\n\t\t\n\t\t@include respond('laptop') {\n\t\t\tpadding: 0.375rem 1rem;\n\t\t\tfont-size: 0.875rem;\n\t\t\tline-height: 1.5;\n\t\t}\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active,\n\t\t&.active{\n\t\t\tcolor: #514e5f;\n\t\t}\n\t\t&.active, \n\t\t&:active{\n\t\t\tcolor: var(--primary);\n\t\t\tbackground:var(--rgba-primary-1);\n\t\t}\n\t}\n\t\n\t@at-root [direction=\"rtl\"] #{&} {\n\t\tright: auto !important;\n\t}\n\t&.show{\n\t\tright: 0;\n\t\toverflow: unset !important;\n\t\t\n\t}\n}\n\n////////////////////\n// Custom Dropdown\n///////////////////\n.dropdown-toggle-split {\n    padding: 0 0.625rem;\n    opacity: 0.85;\n\t&::after {\n\t\tdisplay: inline-block;\n\t\tmargin-left: 0.255em;\n\t\tvertical-align: 0.255em;\n\t\tcontent: \"\";\n\t\tborder-top: 0.3em solid;\n\t\tborder-right: 0.3em solid transparent;\n\t\tborder-bottom: 0;\n\t\tborder-left: 0.3em solid transparent;\n\t}\n\t&:after{\n\t\tmargin-left:0 !important;\n\t}\n\t&:active,\n\t&:focus,\n\t&:hover{\n\t\topacity:1;\n\t}\n\t\n}\n/* .dropleft .dropdown-toggle:before,\n.dropright .dropdown-toggle:before,\n.dropup .dropdown-toggle:after,\n.dropdown-toggle:after {\n\tcontent:\"\\f107\";\n\tfont-family:FontAwesome;\n\tborder: 0;\n    vertical-align: middle;\n    margin-left: 0.25em;\n\tline-height: 1;\n} */\n/* .dropup .dropdown-toggle:after{\n\tcontent:\"\\f106\";\n} */\n/* .dropleft .dropdown-toggle::before {\n\tcontent:\"\\f104\";\n}\n.dropright .dropdown-toggle::before {\n\tcontent:\"\\f105\";\n} */\n.dropright .dropdown-toggle::after {\n\tcontent:none;\n}\n.custom-dropdown{\n    display: inline-block;\n\n    .dropdown-menu{\n        border: 0rem;\n        min-width: 10rem;\n\n        // padding: 1rem;\n\t\t\n    }\n}\n.card-action{\n    .custom-dropdown{\n        // padding: 0.9375rem;\n        margin: 0rem;\n        background: var(--rgba-primary-1);\n        &.show,&:focus,&:hover{\n            background: var(--primary);\n            color: $white;\n        }\n\n        i{\n            display: inline-block;\n            padding-top: 0.5625rem;\n        }\n    }\n}\n\n.dropdown{\n\t.dropdown-dots{\n\t\tposition: relative;\n\t\theight: 0.3125rem;\n\t\twidth: 0.3125rem;\n\t\tbackground: rgba($dark, 0.4);\n\t\tborder-radius: 0.3125rem;\n\t\tdisplay: block;\t\n\t\t&:after,\n\t\t&:before{\n\t\t\tcontent: \"\";\n\t\t\theight: 0.3125rem;\n\t\t\twidth: 0.3125rem;\n\t\t\tbackground: rgba($dark, 0.4);\n\t\t\tposition: absolute;\n\t\t\tborder-radius: 0.3125rem;\n\t\t}\n\t\t&:after{\n\t\t\tright: -0.5rem;\n\t\t}\n\t\t&:before{\n\t\t\tleft: -0.5rem;\t\t\t\n\t\t}\n\t\t\n\t\t&.text-white{\n\t\t\tbackground: rgba($white, 0.7);\n\t\t\t&:after,\n\t\t\t&:before{\n\t\t\t\tbackground: rgba($white, 0.7);\t\t\t\t\n\t\t\t}\n\t\t}\n\t}\n}\n\ndiv#bs-select-1 {\n\tmin-height: 6.875rem;\n}\n.dtp > .dtp-content > .dtp-date-view > header.dtp-header,\n.dtp div.dtp-date, .dtp div.dtp-time{\n\tbackground: var(--primary);\n}\n.dtp-date{\n\ti{\n\t\tcolor:$white;\n\t}\n}\n.dtp-buttons{\n\t.btn-flat{\n\t\t&:focus{\n\t\t\tbox-shadow:none;\n\t\t}\n\t}\t\n}\n",".grid-col {\n    padding: 0.8rem !important;\n    background:$body-bg;\n\tborder-radius:$radius;\n    // box-shadow: 2px 3px 10px 0px rgba(119, 119, 119, 0.1); \n\n \n}\n\n.row.grid {\n    margin-bottom: 1.5rem;\n    text-align: center;\n}\n\n.row.grid .grid-col:first-child{\n    text-align: left;\n}\n\n\n\n\n",".label {\n    display: inline-block;\n    text-align: center;\n    font-size: 0.75rem;\n    padding: .2rem .8rem;\n\n    &-fixed {\n        width: 7.5rem;\n        padding: .6rem 0;\n\n        &-lg {\n            width: 9.5rem;\n            padding: .6rem 0;\n        }\n    }\n\n    &-big {\n        width: 16.8rem;\n        font-size: 1.4rem;\n        padding: 1.1rem 0;\n    }\n\n    &-xl {\n        width: 10.5rem;\n        padding: 1.1rem 0;\n        font-size: 1.5rem;\n    }\n\n    &-lg {\n        width: 9.5rem;\n        padding: 1.1rem 0;\n    }\n\n    &-md {\n        width: 8.5rem;\n        padding: 1.1rem 0;\n    }\n\n    &-sm {\n        width: 7.5rem;\n        padding: 1.1rem 0;\n    }\n}\n\n.label-default{\n    background: #ADB6C7;\n}\n\n.label-primary{\n    background: var(--primary);\n    color: $white;\n}\n\n.label-secondary{\n    background: $secondary;\n    color: $white;\n}\n\n.label-info{\n    background: $info;\n    color: $white;\n}\n\n.label-success{\n    background: $success;\n    color: $white;\n}\n\n.label-warning{\n    background: $warning;\n    color: $white;\n}\n\n.label-danger{\n    background: $danger;\n    color: $white;\n}\n\n\n.label-light{\n    background: $light;\n    color: $black;\n}\n\n\n.label-dark{\n    background: $dark;\n    color: $white;\n}\n\n\n\ncode{\n    word-break: break-word;\n    padding: 0.125rem 0.3125rem;\n    border-radius: 0.1875rem;\n\tbackground: lighten($danger, 33%);\n    color: $danger;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground: rgba($danger, 0.1);\n\t}\n}\n\n.heading-labels{\n    color: #333333;\n\n    & > *{\n        margin-bottom: .8rem;\n    }\n\n    h1{\n        .label{\n            font-size: 1.125rem;\n            font-weight: normal;\n            padding: .4rem .9rem;\n        }\n    }\n\n    h2{\n        .label{\n            font-size: 1rem;\n            font-weight: normal;\n            padding: 0.3rem .9rem;\n        }\n    }\n\n    h3{\n        .label{\n            font-size: 0.875rem;\n            font-weight: normal;\n        }\n    }\n\n    h4{\n        .label{\n            font-size: 0.75rem;\n            font-weight: normal;\n        }\n    }\n\n    h5{\n        .label{\n            font-size: 0.75rem;\n            font-weight: normal;\n        }\n    }\n\n    h6{\n        .label{\n            font-size: 0.75rem;\n            font-weight: normal;\n        }\n    }\n}\n.card-content{\n\tp{\n\t\tcode{\n\t\t\tmargin-left:8px;\n\t\t}\n\t}\n}",".list-group-item {\n    background-color: rgba(255,255,255,0);\n    border: 1px solid $border-main-color;\n\tpadding: 1rem 1.5rem;\n\tcolor:$body-color;\n\t&.active{\n\t\tbackground-color :var(--primary);\n\t\tborder-color :var(--primary);\n\t}\n    @at-root [data-theme-version=\"dark\"] & {\n        border-color: $d-border;\n    }\n}\n\n.list-group-item.disabled, .list-group-item:disabled {\n    color: $white;\n    background-color: $secondary;\n    border-color: $secondary;\n}\n[class*=\"bg-\"]{\n\t.list-group-item{\n\t\tborder-color:rgba($white, 0.05);\n\t\tcolor: $white;\n\t}\n}\n.bg-warning{\n\t.list-group-item{\n\t\tborder-color:rgba($black, 0.05);\n\t}\n}\n// .list-group-item-action {\n//     color: #fff;\n// }",".media{\n    img{\n        border-radius: 0.1875rem;\n    }\n}",".vertical-card__menu {\n    // box-shadow: none;\n\n    &:hover {\n        box-shadow: none;\n    }\n\n    &--image {\n        text-align: center;\n\n        img {\n            width: 100%;\n            border-top-left-radius: 0.25rem;\n            border-top-right-radius: 0.25rem;\n        }\n    }\n\n    &--status {\n        &.closed {\n            background: $danger;\n\n            &:after {\n                border-top: 0.625rem solid $danger;\n            }\n\n            .ribbon-curve {\n                border-top: 0.6875rem solid $danger;\n                border-bottom: 0.625rem solid $danger;\n            }\n        }\n    }\n\n    &--desc {\n        // padding: 0.9375rem 1.25rem;\n        // border-left: 0.0625rem solid #e5e5e5;\n        // border-right: 0.0625rem solid #e5e5e5;\n\n        p {\n            margin-bottom: 0.625rem;\n        }\n    }\n\n    &--price {\n        font-size: 1.25rem;\n        margin: 0;\n        font-weight: 700;\n    }\n\n    &--rating {\n        font-size: 0.75rem;\n    }\n\n    &--title {\n        // margin-bottom: 0.625rem;\n        font-weight: 700;\n    }\n\n    &--button {\n        button {\n            font-size: 0.75rem;\n        }\n    }\n\n    &--location {\n        // font-size: 0.75rem;\n    }\n\n    .card-footer {\n        padding: 0.9375rem 1.25rem;\n        background-color: $border;\n        // border: 0.0625rem solid #e5e5e5;\n        border-top: none;\n\n        @include custommq($min: 75rem, $max: 90rem) {\n            padding: 0.9375rem;\n        }\n\n        span{\n            color: $dark;\n            margin-right: 0.3125rem;\n        }\n    }\n}\n\n.horizontal-card__menu {\n    box-shadow: 0 0 0.4375rem rgba(173, 173, 173, 0.32);\n    display: flex;\n    flex-direction: row;\n\n    @include media-breakpoint-down(xs) {\n        display: block;\n    }\n\n    .card-body {\n        padding: 0;\n        padding: 1.25rem 1.875rem;\n    }\n\n\n\n    &--image {\n        flex-basis: 30%;\n        max-width: 30%;\n\n        img {\n            height: 100%;\n            width: 100%;\n        }\n\n        @include media-breakpoint-down(xs) {\n            max-width: unset;\n            flex-basis: 100%;\n        }\n    }\n\n    &--title {\n        font-size: 1rem;\n        font-weight: 700;\n        margin-bottom: 0.3125rem;\n    }\n\n    &--fav {\n        margin-right: 0.5rem;\n    }\n\n    &--price {\n        margin: 0;\n        font-size: 1rem;\n        font-weight: 700;\n    }\n\n    &--rating {\n        font-size: 0.625rem;\n    }\n\n    &--footer {\n        margin-top: 0.625rem;\n    }\n}\n\n.prev_price {\n    text-decoration: line-through;\n    // color: $muted;\n    font-size: 80%;\n    opacity: 0.5;\n}","// .modal{\n//     border: 0;\n//     z-index: 9999999999;\n    \n//     &-content{\n//         border: 0;\n//         box-shadow: 0rem 0.125rem 1.3125rem 0.375rem rgba(70, 66, 66, 0.26);\n//     }\n// }\n\n// // primary modal rule\n// #primaryModal{\n\n//     .modal-header{\n//         background: $primary;\n\n//         .modal-title,button{\n//             color: #fff;\n//             opacity: 1;\n//         }\n//     }\n// }\n// //danger modal rule\n// #dangerModal{\n\n//     .modal-header{\n//         background: $danger;\n\n//         .modal-title,button{\n//             color: #fff;\n//             opacity: 1;\n//         }\n//     }\n// }\n\n// //warning modal rule\n// #warningModal{\n\n//     .modal-header{\n//         background: $warning;\n\n//         .modal-title,button{\n//             color: #a39e06 ;\n//             opacity: 1;\n//         }\n//     }\n// }\n\n// //success modal rule\n// #successModal{\n\n//     .modal-header{\n//         background: $success;\n\n//         .modal-title,button{\n//             color: #fff;\n//             opacity: 1;\n//         }\n//     }\n// }\n\n\n\n\n\n\n\n// .bootstrap-modal-wrapper{\n\n//     button:not(:last-child){\n//         margin-right: 0.4375rem;\n//     }\n\n//     button{\n//         margin-bottom: .5rem;\n\n//         &:focus{\n//             box-shadow: none;\n//         }\n//     }\n// }\n\n.modal-header{\n\tpadding: 1rem 1.875rem;\n\n\t.close{\n\t\tpadding: 0.875rem 1.815rem;\n\t\tmargin: 0;\n\t\tposition: absolute;\n\t\tright: 0;\n\t\tfloat: none;\n\t\ttop: 0;\n\t\tfont-size: 1.875rem;\n\t\tfont-weight: 100;\n\t}\n}\n.modal-body{\n\tpadding: 1.875rem;\n}\n.modal-footer{\n\tpadding: 1rem 1.875rem;\n}\n.modal-content{\n\tborder-radius:$radius;\n}\n.modal-backdrop{\n    z-index: 10!important;\n}\n\n.Modal-box {\n\tbackground-color: $white;\n\theight: 300px;\n\tborder-radius: 8px;\n\toverflow: hidden;\n\t@include respond('phone'){\n\t\tmargin-bottom: 0.875rem;\n\t}\n\t.box1 {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 20px 25px;\n\t\tborder-bottom: 1px solid #3736ae30;\n\t\th3 {\n\t\t\tcolor: black;\n\t\t}\n\t\ti {\n\t\t\tfont-size: 20px;\n\t\t}\n\t}\n\t.box2 {\n\t\tpadding: 10px 25px;\n\t\theight: 150px;\n\t}\n\t.box3 {\n\t\tpadding: 20px 25px;\n\t\ttext-align: end;\n\t\tbackground-color: #f4f4f5;\n\t\tborder-top: 1px solid #3736ae30;\n\n\t\t.bt-1 {\n\t\t\tcolor: #f34e5f;\n\t\t\tbackground-color: #e9c7cd;\n\t\t\tpadding: 5px 15px;\n\t\t\tborder: 1px solid #e9c7cd;\n\t\t\tmargin-right: 5px;\n\t\t\tborder-radius: 6px;\n\t\t}\n\t\t.bt-2 {\n\t\t\tcolor: $white;\n\t\t\tbackground-color: #3736ae;\n\t\t\tborder: 1px solid #3736ae;\n\t\t\tpadding: 5px 15px;\n\t\t\tborder-radius: 6px;\n\t\t}\n\t\t\n\t}\n\n}",".pagination .page-item{\n\t.page-link{\t\n\t\t&:hover{\n\t\t\tbackground: var(--primary);\n\t\t\tborder-color: var(--primary);\n\t\t\tcolor:$white;\n\t\t}\n\t}\n\t&.active .page-link{\n\t\tbackground: var(--primary);\n\t\tborder-color: var(--primary);\n\t\tcolor:$white;\n\t}\n}\n.pagination {\n    margin-bottom: 1.25rem;\n\n    .page-item {\n\n        &.page-indicator .page-link {\n            padding: .69rem .8rem;\n            font-size: 1.2rem;\n\t\t\tborder-top-left-radius: unset; \n    \t\t border-bottom-left-radius: unset;\n\t\t\t border-radius: $radius;\n        }\n\n        &.page-indicator:hover{\n            .page-link{\n                color: $dark;\n            }\n        }\n\n        .page-link {\n            // height: 3.125rem;\n           \n\t\t\tz-index:1;\n            padding: 0;\n\t\t\twidth: 2.5rem;\n\t\t\theight: 2.5rem;\n\t\t\tborder-radius: 0.625rem;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n            font-size: 1rem;\n            background: rgba(255, 255, 255, 0.15);\n            color: $dark;\n\t\t\tmargin-left: 7px;\n            // line-height: 2.375rem;\n            border: 0.0625rem solid $border-main-color;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tborder-color: $d-border;\n\t\t\t\tcolor: $d-ctl;\n\t\t\t\tbackground: rgba(255, 255, 255, 0);\n\t\t\t}\n            &:hover i,span{\n                color: $white;\n            }\n\n            &:focus{\n                outline: 0;\n                box-shadow: none;\n            }\n\n            &:hover{\n                background: var(--primary);\n                color: $white;\n                border-color: var(--primary);\n            }\n        }\n\n        &.active .page-link {\n            background-color: var(--primary);\n            border-color: var(--primary);\n            color: $white;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tcolor:$white;\n\t\t\t}\n        }\n\n        .page-link {\n            // width: 4.0625rem;\n            color: $dark;\n\t\t\t@include transitionMedium;\n        }\n\n        &:last-child .page-link{\n            margin-right: 0;\n        }\n\n        &:first-child .page-link{\n\n            @at-root [direction=\"rtl\"] #{&} {\n                margin-right: 0;\n            }\n        }\n    }\n\t&.no-bg{\n\t\tli:not(.page-indicator):not(.active) .page-link{\n\t\t \tbackground:$white;\n\t\t \tborder-color:transparent;\n\t\t\t\n\t\t}\n\t\t&.pagination-primary{\n\t\t\tli:not(.page-indicator):not(.active):hover .page-link{\n\t\t\t\tbackground:var(--primary);\n\t\t\t\tborder-color:var(--primary);\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\tborder-color:var(--primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.pagination-danger{\n\t\t\tli:not(.page-indicator):not(.active):hover .page-link{\n\t\t\t\tbackground:$danger;\n\t\t\t\tborder-color:$danger;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:$danger;\n\t\t\t\t\tborder-color:$danger;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.pagination-info{\n\t\t\tli:not(.page-indicator):not(.active):hover .page-link{\n\t\t\t\tbackground:$info;\n\t\t\t\tborder-color:$info;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:$info;\n\t\t\t\t\tborder-color:$info;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t&.pagination-warning{\n\t\t\tli:not(.page-indicator):not(.active):hover .page-link{\n\t\t\t\tbackground:$warning;\n\t\t\t\tborder-color:$warning;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:$warning;\n\t\t\t\t\tborder-color:$warning;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&-primary{\n\t\t.page-item{\n\t\t\t.page-link{\n\t\t\t\tbackground:var(--rgba-primary-1);\n\t\t\t\tborder-color:var(--rgba-primary-1);\n\t\t\t\tcolor:$main-color;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:var(--rgba-primary-1);\n\t\t\t\t\tborder-color:transparent;\n\t\t\t\t\tcolor:var(--primary);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover,\n\t\t\t&.active{\n\t\t\t\t.page-link{\n\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\tborder-color:var(--primary);\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&-danger{\n\t\t.page-item{\n\t\t\t.page-link{\n\t\t\t\tbackground:$danger-light;\n\t\t\t\tborder-color:$danger-light;\n\t\t\t\tcolor:$danger;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:$danger-opacity;\n\t\t\t\t\tborder-color:transparent;\n\t\t\t\t\tcolor:$danger;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover,\n\t\t\t&.active{\n\t\t\t\t.page-link{\n\t\t\t\t\tbackground:$danger;\n\t\t\t\t\tborder-color:$danger;\n\t\t\t\t\tbox-shadow:0 0.625rem 1.25rem 0rem rgba($danger, 0.2);\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&-info{\n\t\t.page-item{\n\t\t\t.page-link{\n\t\t\t\tbackground:$info-light;\n\t\t\t\tborder-color:$info-light;\n\t\t\t\tcolor:$info;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:$info-opacity;\n\t\t\t\t\tborder-color:transparent;\n\t\t\t\t\tcolor:$info;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover,\n\t\t\t&.active{\n\t\t\t\t.page-link{\n\t\t\t\t\tbackground:$info;\n\t\t\t\t\tborder-color:$info;\n\t\t\t\t\tbox-shadow:0 0.625rem 1.25rem 0rem rgba($info, 0.2);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&-warning{\n\t\t.page-item{\n\t\t\t.page-link{\n\t\t\t\tbackground:$warning-light;\n\t\t\t\tborder-color:$warning-light;\n\t\t\t\tcolor:$warning;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:$warning-opacity;\n\t\t\t\t\tborder-color:transparent;\n\t\t\t\t\tcolor:$warning;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover,\n\t\t\t&.active{\n\t\t\t\t.page-link{\n\t\t\t\t\tbackground:$warning;\n\t\t\t\t\tborder-color:$warning;\n\t\t\t\t\tbox-shadow:0 0.625rem 1.25rem 0rem rgba($warning, 0.2);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t\n    &-gutter{\n\n        .page-item{\n            margin-right: 0.4375rem;\n            \n            .page-link{\n                border-radius: $radius !important;\n            }\n        }\n    }\n\n    &-circle{\n        .page-item{\n            margin-right: 0.4375rem;\n            \n            .page-link,  .page-link{\n                width: 2.5rem;\n                height: 2.5rem;\n                padding: 0;\n                line-height: 2.5rem;\n                border-radius: 50% !important;\n                padding: 0;\n            }\n\t\t\t&.page-indicator{\n\t\t\t\t.page-link{\n\t\t\t\t\twidth: 2.5rem;\n\t\t\t\t\tborder: 1px solid var(--primary);\n\t\t\t\t\tborder-radius: 22px!important;\n\t\t\t\t\tline-height: 1.3rem;\n\t\t\t\t\theight: 2.5rem;\t\n\t\t\t\t\tbackground:var(--rgba-primary-1);\n\t\t\t\t\tcolor:var(--primary);\n\t\t\t\t\t&:hover{\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t}\n        }\n    }\n\n    &.pagination-md{\n\n        .page-item{\n\n            .page-link{\n                width: 1.875rem;\n                height: 1.875rem;\n                line-height: 1.875rem;\n                font-size: 0.875rem;\n            }\n        }\n    }\n\n    &.pagination-sm{\n\n        .page-item{\n\n            &.page-indicator .page-link {\n                font-size: 0.75rem;\n            }\n\n            .page-link{\n                padding: 0;\n                width: 2.5rem;\n                height: 2.5rem;\n                line-height: 2.5rem;\n                font-size: 1.125rem;\n            }\n        }\n    }\n\n    &.pagination-xs{\n\n        .page-item{\n\n            &.page-indicator .page-link {\n                font-size: 0.625rem;\n            }\n\n            .page-link{\n                padding: 0;\n                width: 1.5625rem;\n                height: 1.5625rem;\n                line-height: 1.5625rem;\n                font-size: 0.75rem;\n            }\n        }\n    }\n\n    \n}\n\n\n\n\n\n\n\n\n\n\n",".popover{\n    border: 0.125rem solid $secondary;\n    min-width: 13.125rem;\n    box-shadow: 0 0 1.875rem 0 rgba(0,0,0,0.1);\n    border-radius:$radius;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background-color: $d-bg;\n    }\n    &-header{\n        background: $secondary;\n        color: $white;\n        font-weight: 300;\n\n        &::before{\n            border-bottom: 0 !important;\n        }\n    }\n\n    &-body{\n        font-size: 0.75rem;\n    }\n\t.popover-header{\n        border-radius:3.5px 3.5px 0px 0px ;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: $dark-card;\n\t\t}\n    }\n\t@include respond ('phone-land'){\n\t\tz-index:1;\n\t}\n}\n\n.bootstrap-popover-wrapper{\n    .bootstrap-popover:not(:last-child){\n        margin-right: 0.5rem;\n    }\n\n    .bootstrap-popover{\n        margin-bottom: .5rem;\n\n        button:hover,button:focus{\n            background: var(--primary);\n            color: $white;\n            box-shadow: none;\n        }\n    }\n}\n\n// .tooltip {\n//     font-size: 0.9375rem;\n// }\n\n\n.bs-popover-top .arrow::after, .bs-popover-auto[x-placement^=\"top\"] .arrow::after {\n    bottom: 0rem;\n    border-top-color: $secondary;\n}\n\n.bs-popover-left .arrow::after, .bs-popover-auto[x-placement^=\"left\"] .arrow::after {\n    right: 0rem;\n    border-left-color: $secondary;\n}\n\n.bs-popover-right .arrow::after, .bs-popover-auto[x-placement^=\"right\"] .arrow::after {\n    left: 0rem;\n    border-right-color: $secondary;\n}\n\n.bs-popover-bottom .arrow::after, .bs-popover-auto[x-placement^=\"bottom\"] .arrow::after {\n    top: 0rem;\n    border-bottom-color: $secondary;\n}\n\n.note-popover{\n    display: none;\n}"," // Variable.scss\n .progress-bar {\n    background-color: var(--primary);\n }\n \n .progress-bar-primary {\n     background-color: var(--primary);\n }\n \n .progress-bar-success {\n     background-color: $success;\n }\n \n .progress-bar-info {\n     background-color: $info;\n }\n \n .progress-bar-danger {\n     background-color: $danger;\n }\n \n .progress-bar-warning {\n     background-color: $warning;\n }\n \n .progress-bar-pink {\n     background-color: $pink;\n }\n \n.progress {\n\theight: 0.688rem;\n\tbackground-color:$border;\n    overflow: hidden;\n    // box-shadow: inset 0px 0px 5px 0px rgba(0, 0, 0, 0.13);\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $d-bg;\n\t}\n    &-bar{\n        // outline: 1px solid #fff;\n        border-radius: $radius;\n    }\n}\n \n .progress-vertical {\n     display: inline-block;\n     margin-bottom: 0;\n     margin-right: 2rem;\n     min-height: 17rem;\n     position: relative;\n\n     @include media-breakpoint-down(md) {\n        margin-right: 1rem;\n     }\n }\n \n .progress-vertical-bottom {\n     display: inline-block;\n     margin-bottom: 0;\n     margin-right: 2rem;\n     min-height: 17rem;\n     position: relative;\n     transform: rotate(180deg);\n     \n     @include media-breakpoint-down(md) {\n        margin-right: 1rem;\n     }\n }\n \n .progress-animated {\n     animation-duration: 5s;\n     animation-name: myanimation;\n     transition: all 5s ease 0s;\n }\n \n @keyframes myanimation {\n     0% {\n         width: 0;\n     }\n }\n \n @keyframes myanimation {\n     0% {\n         width: 0;\n     }\n }\n \n",".ribbon {\n    position: absolute;\n    z-index: 1;\n    text-transform: uppercase;\n\n    &__one {\n        top: 0.9375rem;\n        left: -0.6875rem;\n        min-height: 1.25rem;\n        min-width: 3.25rem;\n        text-align: center;\n        padding: 0.1875rem 0.625rem;\n        background: #3AB54B;\n        color: #fff;\n        font-size: 0.625rem;\n\n        &::after {\n            position: absolute;\n            width: 0;\n            height: 0;\n            border-top: 0.625rem solid #239132;\n            border-left: 0.6875rem solid transparent;\n            left: 0;\n            content: \"\";\n            bottom: -0.625rem;\n        }\n    }\n\n    &__two {\n        width: 3.125rem;\n        height: 3.125rem;\n        display: inline-block;\n        background: $warning;\n        line-height: 3.125rem;\n        text-align: center;\n        font-size: 1rem;\n        color: $white;\n        right: 0.9375rem;\n        top: 0.9375rem;\n        border-radius: 0.1875rem;\n\n        // &::after {\n        //     position: absolute;\n        //     content: \"\";\n        //     -webkit-clip-path: polygon(90% 0, 100% 100%, 50% 75%, 0 100%, 10% 0, 50% 0);\n        //     clip-path: polygon(90% 0, 100% 100%, 50% 75%, 0 100%, 10% 0, 50% 0);\n        //     height: 1.375rem;\n        //     width: 2.5rem;\n        //     left: 50%;\n        //     top: 75%;\n        //     background: $primary;\n        //     transform: translateX(-50%);\n        // }\n    }\n\n    &__three {\n        left: -1.875rem;\n        top: 0.875rem;\n        width: 6.875rem;\n        height: 1.5625rem;\n        background-color: $danger;\n        clip-path: polygon(20% 0%, 80% 0%, 100% 100%, 0% 100%);\n        transform: rotate(-45deg);\n        color: $white;    \n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 0.875rem;\n    }\n\n    &__four {\n        left: 0.5rem;\n        top: -0.5rem;\n        width: 6.875rem;\n        height: 3.125rem;\n        background-color: var(--primary);\n        z-index: auto;\n        color: $white;\n        font-size: 1rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        \n        &:after {\n            right: -0.3125rem;\n        }\n\n        &:before {\n            left: -0.3125rem;\n        }\n\n        // &:after, &:before {\n\n        // }\n\n        &:after, &:before {\n            z-index: -1;\n            background-color: var(--rgba-primary-1);\n            top: 0.1875rem;\n            transform: rotate(45deg);\n            content: \"\";\n            height: 0.625rem;\n            width: 0.625rem;\n            position: absolute;\n        }\n    }\n\n    &__five {\n        left: -1.875rem;\n        top: 0.625rem;\n        width: 6.875rem;\n        height: 1.875rem;\n        background-color: var(--primary);\n        transform: rotate(-45deg);\n        font-size: 0.75rem;\n        color: $white;\n        padding-bottom: 0.3125rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 1rem;\n\n        &::before {\n            position: absolute;\n            content: \"\";\n            width: 0;\n            height: 0;\n            border-style: solid;\n            border-width: 0 3.125rem 3.125rem 3.125rem;\n            border-color: transparent transparent var(--primary) transparent;\n            left: 0.25rem;\n            top: -2.8125rem;\n        }\n    }\n\n    &__six {\n        left: 0;\n        top: 1.125rem;\n        width: 6.875rem;\n        height: 2.375rem;\n        background-color: var(--primary);\n        -webkit-clip-path: polygon(0 0, 100% 0%, 100% 0, 85% 50%, 100% 100%, 100% 100%, 0 100%);\n        clip-path: polygon(0 0, 100% 0%, 100% 0, 85% 50%, 100% 100%, 100% 100%, 0 100%);\n        display: flex;\n        font-size: 1.25rem;\n        align-items: center;\n        justify-content: center;\n        color: $white;\n    }\n\n    &-curve {\n        position: absolute;\n        top: 0;\n        right: -0.375rem;\n        width: 0.625rem;\n        height: 0.6875rem;\n        border-top: 0.6875rem solid #3AB54B;\n        border-bottom: 0.625rem solid #3AB54B;\n        border-right: 0.3125rem solid transparent;\n    }\n}",".jsgrid-grid-body, \n.dataTables_scrollBody, \n.table-responsive {\n    &::-webkit-scrollbar {\n        background-color: #f5f5f5;\n        width: 0.5rem;\n        height: 0.5rem;\n    }\n\n    &::-webkit-scrollbar-track {\n        -webkit-box-shadow: inset 0 0 0.375rem rgba(0,0,0,0.3);\n        border-radius: 0.625rem;\n        background-color: #f5f5f5;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        border-radius: 0.625rem;\n        -webkit-box-shadow: inset 0 0 0.375rem rgba(0,0,0,.3);\n        background-color: var(--primary);\n    }\n}","\n\n\n%remain-steps {\n    &:before {\n        content: counter(stepNum);\n        font-family: inherit;\n        font-weight: 400;\n    }\n\n    &:after {\n        background-color: $border;\n    }\n}\n\n.multi-steps {\n    display: table;\n    table-layout: fixed;\n    width: 100%;\n\n    >li {\n        counter-increment: stepNum;\n        text-align: center;\n        display: table-cell;\n        position: relative;\n        color: var(--primary);\n\n        @include media-breakpoint-down(xs) {\n            font-size: 0.75rem;\n        }\n\n        &:before {\n            content: '\\2713';\n            display: block;\n            margin: 0 auto 0.25rem;\n            background-color: $white;\n            width: 1.5625rem;\n            height: 1.5625rem;\n            line-height: 1.375rem;\n            text-align: center;\n            font-weight: bold;\n            position: relative;\n            z-index: 1;\n\n            @include media-breakpoint-down(xs) {\n                width: 1.5625rem;\n                height: 1.5625rem;\n                line-height: 1.3125rem;\n            }\n\n            border: {\n                width: 0.125rem;\n                style: solid;\n                color: var(--primary);\n                radius: 0.3125rem;\n            }\n        }\n\n        &:after {\n            content: '';\n            height: 0.125rem;\n            width: 100%;\n            background-color: var(--primary);\n            position: absolute;\n            top: 0.75rem;\n            left: 50%;\n\n            @at-root [direction=\"rtl\"] #{&} {\n              left: auto;\n              right: 50%;\n            }\n\n            @include media-breakpoint-down(xs) {\n                top: 0.75rem;\n            }\n        }\n\n        &:last-child {\n            &:after {\n                display: none;\n            }\n        }\n\n        &.is-active {\n            @extend %remain-steps;\n\n            &:before {\n                background-color: $white;\n                border-color: var(--primary);\n            }\n\n            ~li {\n                color: $body-color;\n                @extend %remain-steps;\n\n                &:before {\n                    background-color: $border;\n                    border-color: $border;\n                }\n            }\n        }\n    }\n}",".nav-pills {\n    .nav-link {\n\t\tborder-radius: $radius-sm;\n\t    padding: 0.5rem 1rem;\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\t\tcolor: #5b5e81;\n\t\ttext-transform: capitalize;\n\t\tbox-shadow: none;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tcolor:$d-ctl;\n\t\t}\n\t\t&:hover{\n\t\t\tcolor:var(--primary);\n\t\t}\n\t}\n}\n\n.default-tab{\n    .nav-link{\n        background: transparent;\n        border-radius: 0rem;\n        font-weight: 500;\n\t\ti{\n\t\t\tdisplay:inline-block;\n\t\t\ttransform:scale(1.5);\n\t\t\tcolor: #5b5e81;\n\t\t\t\n\t\t}\n\t\t\n\t\t&:focus,\n\t\t&:hover,\n\t\t&.active{\n\t\t\tcolor: #495057;\n\t\t\tbackground-color: #fff;\n\t\t\tborder-color: #dee2e6 #dee2e6 #fff #ebeef6;\n\t\t\tborder-radius: $radius $radius 0 0;\n\t\t\tcolor:var(--primary);\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: var(--rgba-primary-1);\n\t\t\t\tborder-color: transparent transparent $d-border transparent;\n\t\t\t}\n\t\t}\n    }\n}\n\n.custom-tab-1{\n    .nav-link{\n        background: transparent;\n        border-radius: 0rem;\n        font-weight: 500;\n\t\tborder-bottom:0.1875rem solid transparent;\n\t\tborder-width: 0 0rem 0.1875rem 0;\n\t\t\n\t\ti{\n\t\t\tdisplay:inline-block;\n\t\t\ttransform:scale(1.5);\n\t\t\tcolor:var(--primary);\n\t\t}\n\t\t&:focus,\n\t\t&:hover,\n\t\t&.active{\n\t\t\tcolor: #495057;\n\t\t\tbackground-color: #fff;\n\t\t\tborder-color:var(--primary) ;\n\t\t\tborder-radius:0;\n\t\t\tcolor: var(--primary);\n\t\t\tborder-width: 0 0rem 0.1875rem 0;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: var(--rgba-primary-1);\n\t\t\t}\n\t\t}\n    }\n\t\n}\n.nav-pills{\n\t\n\t&.light{\n\t\t.nav-link.active, \n\t\t.show > .nav-link{\n\t\t\tbackground:var(--rgba-primary-1);\n\t\t\tcolor:var(--primary);\n\t\t\tbox-shadow:none;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground:var(--rgba-primary-1);\n\t\t\t}\n\t\t}\t\n\t\n\t}\n\t.nav-link.active,\n\t&:hover\t\n\t.show > .nav-link{\n\t\tbackground-color:var(--rgba-primary-1);\n\t\tcolor:var(--primary);\n\t}\n}\n\n",".tooltip{\n\n    &-wrapper{\n\n        button:not(:last-child){\n            margin-right: 0.5rem;\n        }\n\n        button:hover{\n            background: var(--primary);\n            color: $white;\n        }\n\n        button{\n            margin-bottom: .5rem;\n\n            &:focus{\n                box-shadow: none;\n            }\n        }\n    }\n\n    &-inner{\n        border-radius: 0;\n        background: #333333;\n        font-size: 0.75rem;\n        font-weight: 300;\n        padding: 0.35rem 0.7rem;\n    }\n\n    \n}\n.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before{\n    // border-width: 0 0.6rem 0.6rem;\n    border-bottom-color: #333333;\n}\n\n.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=\"right\"] .arrow::before{\n    border-right-color: #333333;\n}\n\n.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=\"left\"] .arrow::before{\n    border-left-color: #333333;\n}\n\n.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=\"top\"] .arrow::before{\n    border-top-color: #333333;\n}","\n.widget-timeline{\n\n\t.timeline {\n\t\tlist-style: none;\n\t\tposition: relative;\n\t\t&:before {\n\t\t\ttop: 1.25rem;\n\t\t\tbottom: 0;\n\t\t\tposition: absolute;\n\t\t\tcontent: \" \";\n\t\t\twidth: 0.1875rem;\n\t\t\tleft: 0.5625rem;\n\t\t\tmargin-right: -0.0938rem;\n\t\t\tbackground: $body-bg;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground: $d-border;\n\t\t\t}\n\t\t\t@at-root [direction=\"rtl\"] #{&} {\n\t\t\t\tleft: auto;\n\t\t\t\tright: 0.5625rem;\n\t\t\t\tmargin-right: auto;\n\t\t\t\tmargin-left: -0.0938rem;\n\t\t\t}\n\t\t\t\n\t\t}\n\t\t> li {\n\t\t\tmargin-bottom: 0.9375rem;\n\t\t\tposition: relative;\n\t\t\t&:before {\n\t\t\t\tcontent: \" \";\n\t\t\t\tdisplay: table;\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\tcontent: \" \";\n\t\t\t\tdisplay: table;\n\t\t\t\tclear: both;\n\t\t\t}\n\t\t\t> {\n\t\t\t\t.timeline-panel {\n\t\t\t\t\tborder-radius: $radius;\n\t\t\t\t\tpadding: 0.9375rem 1.25rem;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay:block;\n\t\t\t\t\tmargin-left: 2.5rem;\n\t\t\t\t\tborder-width:0.0625rem;\n\t\t\t\t\tborder-style:solid;\n\t\t\t\t\tspan{\n\t\t\t\t\t\tfont-size: 0.75rem;\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tmargin-bottom: 0.3125rem;\n\t\t\t\t\t\tletter-spacing: 0.0625rem;\n\t\t\t\t\t}\n\t\t\t\t\tp{\n\t\t\t\t\t\tfont-size:0.875rem;\n\t\t\t\t\t}\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\twidth: 0.625rem;\n\t\t\t\t\t\theight: 0.625rem;\n\t\t\t\t\t\tbackground: inherit;\n\t\t\t\t\t\tborder-color: inherit;\n\t\t\t\t\t\tborder-style: solid;\n\t\t\t\t\t\tborder-width: 0rem 0rem 0.0625rem 0.0625rem;\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tleft: -0.3125rem;\n\t\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\t\ttop: 0.9375rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.timeline-badge {\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\theight: 1.375rem;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 0.625rem;\n\t\t\t\t\twidth: 1.375rem;\n\t\t\t\t\tborder-width: 0.125rem;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tbackground:$white;\n\t\t\t\t\tpadding:0.25rem;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: $dark-card;\n\t\t\t\t\t}\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tcontent:\"\";\n\t\t\t\t\t\twidth:0.625rem;\n\t\t\t\t\t\theight:0.625rem;\n\t\t\t\t\t\tborder-radius:100%;\n\t\t\t\t\t\tdisplay:block;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t@at-root [direction=\"rtl\"] #{&} {\n\t\t\t\t\t\tleft: auto;\n\t\t\t\t\t\tright: 1.1875rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t\n\t.timeline-body > p {\n\t\tfont-size: 0.75rem;\n\t}\n  \n  .timeline-badge {\n    &.primary{\n\t\tborder-color: var(--rgba-primary-1);\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: var(--rgba-primary-1);\n\t\t}\n\t\t&:after{\n\t\t\tbackground-color: var(--primary);\n\t\t\tbox-shadow:0 0.3125rem 0.625rem 0 var(--rgba-primary-2);\n\t\t}\n\t\t& + .timeline-panel{\n\t\t\tbackground:var(--rgba-primary-1);\n\t\t\tborder-color:var(--rgba-primary-1);\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tborder-color: transparent;\n\t\t\t\tbackground-color: var(--rgba-primary-1);\n\t\t\t}\n\t\t}\n    }\n    &.success{\n\t\tborder-color:$success-light;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: $success-opacity;\n\t\t}\n\t\t&:after{\n\t\t\tbackground-color: $success !important;\n\t\t\tbox-shadow:0 0.3125rem 0.625rem 0 rgba($success, 0.2);\n\t\t}\n\t\t& + .timeline-panel{\n\t\t\tbackground:$success-light;\n\t\t\tborder-color:$success-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $success-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n    }\n    &.warning{\n\t\tborder-color:$warning-light;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: $warning-opacity;\n\t\t}\n\t\t&:after{\n\t\t\tbackground-color: $warning !important;\n\t\t\tbox-shadow:0 0.3125rem 0.625rem 0 rgba($warning, 0.2);\n\t\t}\n\t\t& + .timeline-panel{\n\t\t\tbackground:$warning-light;\n\t\t\tborder-color:$warning-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $warning-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n    }\n    &.danger{\n\t\tborder-color:$danger-light;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: $danger-opacity;\n\t\t}\n\t\t&:after{\n\t\t  background-color: $danger !important;\n\t\t  box-shadow:0 0.3125rem 0.625rem 0 rgba($danger, 0.2);\n\t\t}\n\t\t& + .timeline-panel{\n\t\t\tbackground:$danger-light;\n\t\t\tborder-color:$danger-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $danger-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n    }\n\t\n    &.info{\n\t\tborder-color:var(--rgba-secondary-1);\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: var(--rgba-secondary-1);\n\t\t}\n\t\t&:after{\n\t\t\tbackground-color: var(--secondary) !important;\n\t\t\tbox-shadow:0 0.3125rem 0.625rem 0 rgba($info, 0.2);\n\t\t}\n\t\t& + .timeline-panel{\n\t\t\tbackground:var(--rgba-secondary-1);\n\t\t\tborder-color:$info-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $info-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n    }\n    &.dark{\n\t\tborder-color:$dark-light;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\tborder-color: $dark-opacity;\n\t\t}\n\t\t&:after{\n\t\t  background-color: $dark !important;\n\t\t  box-shadow:0 0.3125rem 0.625rem 0 rgba($dark, 0.2);\n\t\t}\n\t\t& + .timeline-panel{\n\t\t\tbackground:$dark-light;\n\t\t\tborder-color:$dark-light;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tbackground-color: $dark-opacity;\n\t\t\t\tborder-color: transparent;\n\t\t\t}\n\t\t}\n    }\n  }\n\t\n\t&.style-1{\n\t\t.timeline-panel{\n\t\t\tbackground:transparent;\n\t\t}\n\t\t.timeline {\n\t\t\t.timeline-badge {\n\t\t\t\t&.timeline-badge{\n\t\t\t\t\t& + .timeline-panel{\n\t\t\t\t\t\tbackground: transparent !important;\n\t\t\t\t\t\tborder-style:solid;\n\t\t\t\t\t\tborder-width: 0 0 0 0.3125rem;\n\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t\tpadding: 0.3125rem 0.625rem 0.3125rem 0.9375rem;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tborder:0;\n\t\t\t\t\t\t\tleft: -0.5625rem;\n\t\t\t\t\t\t\twidth: 0.4375rem;\n\t\t\t\t\t\t\theight: 0.4375rem;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.primary{\n\t\t\t\t\t& + .timeline-panel{\n\t\t\t\t\t\tborder-color:var(--primary);\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.success{\n\t\t\t\t\t& + .timeline-panel{\n\t\t\t\t\t\tborder-color:$success;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tbackground:$success;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.warning{\n\t\t\t\t\t& + .timeline-panel{\n\t\t\t\t\t\tborder-color:$warning;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tbackground:$warning;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.danger{\n\t\t\t\t\t& + .timeline-panel{\n\t\t\t\t\t\tborder-color:$danger;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tbackground:$danger;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.info{\n\t\t\t\t\t& + .timeline-panel{\n\t\t\t\t\t\tborder-color:$info;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tbackground:$info;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&.dark{\n\t\t\t\t\t& + .timeline-panel{\n\t\t\t\t\t\tborder-color:$dark;\n\t\t\t\t\t\t&:after{\n\t\t\t\t\t\t\tbackground:$dark;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\n\t}  \n  \n}\n\n  \n  ","#chart_widget_4 {\n    height: 15.9375rem !important;\n}\n\n#chart_widget_5 {\n    .ct-series-a .ct-line, \n    .ct-series-a .ct-point {\n        stroke: #46ffc8;\n    }\n\n    .ct-line {\n        stroke-width: 0.0625rem;\n    }\n\n    .ct-point {\n        stroke-width: 0.125rem;\n    }\n\n    .ct-series-a .ct-area {\n        fill: #20dea6;\n    }\n\n    .ct-area {\n        fill-opacity: 1;\n    }\n}\n\n#chart_widget_6 {\n    .ct-series-a .ct-line, \n    .ct-series-a .ct-point {\n        stroke: $info;\n    }\n\n    .ct-line {\n        stroke-width: 0.125rem;\n    }\n\n    .ct-point {\n        stroke-width: 0.3125rem;\n    }\n\n    .ct-series-a .ct-area {\n        fill: $info;\n    }\n\n    .ct-area {\n        fill-opacity: .5;\n    }\n}\n\n#chart_widget_8 {\n    height: 15.9375rem;\n\n    .ct-series-a .ct-line, \n    .ct-series-a .ct-point {\n        stroke: $info;\n    }\n\n    .ct-line {\n        stroke-width: 0.125rem;\n    }\n\n    .ct-point {\n        stroke-width: 0.3125rem;\n    }\n\n    .ct-series-a .ct-area {\n        fill: $info;\n    }\n\n    .ct-area {\n        fill-opacity: .5;\n    }\n}\n\n#chart_widget_9, #chart_widget_10 {\n    height: 15.625rem !important;\n\tmargin-bottom:-5px;\n}\n\n#chart_widget_11, #chart_widget_12, #chart_widget_13 {\n    .ct-slice-donut {\n        stroke-width: 1.5625rem !important;\n    }\n}\n\n\n#chart_widget_11 {\n    height: 16.875rem !important;\n\tmargin-bottom:-5px;\n}\n\n#chart_widget_17 {\n    height: 9.375rem !important;\n}\n\n\n.chart_widget_tab_one {\n    .nav-link {\n        border: 0.0625rem solid #ddd;\n\n        &.active {\n            background-color: var(--primary);\n            border: 0.0625rem solid var(--primary);\n            color: $white;\n\n            &:hover {\n                border: 0.0625rem solid var(--primary);\n            }\n        }\n\n        &:hover {\n            border: 0.0625rem solid #ddd;\n        }\n    }\n}\n\n.ccc-widget {\n    &>div {\n        @at-root [data-theme-version=\"dark\"] & {\n            background: $dark-card !important;\n            border-color: $d-border !important;\n        }\n    }\n}",".social-icon{\n    display: inline-block;\n    width: 2.5rem;\n    height: 2.5rem;\n    line-height: 2.5rem;\n    border-radius: 0.25rem;\n    text-align: center;\n    background: $body-bg;\n    margin-bottom: 0.5rem;\n    font-size: 1.25rem;\n\n    i{\n        // font-size: 0.875rem; \n        color: $white\n    }\n    &.youtube{\n        background: $youtube;\n    }\n    &.facebook{\n        background: $facebook;\n    }\n    &.twitter{\n        background: $twitter;\n    }\n}\n.social-graph-wrapper {\n    text-align: center;\n    padding: 1.25rem;\n    position: relative;\n    color: $white;\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n\t\n    &.widget-facebook {\n        background-color: $facebook;\n    }\n    &.widget-twitter {\n        background-color: $twitter;\n    }\n    &.widget-linkedin {\n        background-color: $linkedin;\n    }\n    &.widget-googleplus {\n        background-color: $google-plus;\n    }\n    .s-icon {\n        font-size: 1.5rem;\n        position: relative;\n        // top: 0.625rem;\n        padding: 0 0.625rem;\n    }\n}\n\n.social-icon2{\n    a{\n        border: .1rem solid var(--primary);\n        display: block;\n        padding: 1rem;\n        margin-top: 1.5rem;\n        margin-bottom: .5rem;\n        border-radius: .3rem;\n        font-size: 1.6rem;\n    }\n\n    i{\n        font-size: 0.75rem;\n        color: var(--primary);\n    }\n}\n\n.social-icon3{\n    ul{\n        li{\n            display: inline-block;\n            a{\n                display: block;\n                i{\n                    font-size: 1.4rem;\n                    padding: 1rem .7rem;\n                    color: $l-ctd;\n                }\n                &:hover{\n                    i{\n                        color: var(--primary);\n                    }\n                }\n            }\n        }\n    }\n}\n\n.social-icons-muted{\n    ul li a i{\n        color: $muted;\n    }\n}\n\n.social-links {\n    a {\n        padding: .5rem;\n    }\n}",".widget-stat {\n    .media {\n        padding: 0rem 0;\n        align-items: center;\n        &>span {\n            height: 5.3125rem;\n            width: 5.3125rem;\n            border-radius: 3.125rem;\n            padding: 0.625rem 0.75rem;\n            font-size: 2rem;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            color: $l-ctd;\n            min-width:5.3125rem;\n        }\n        @include custommq($min: 36rem) {}\n        .media-body {\n            p {\n                text-transform: uppercase;\n                font-weight: 500;\n                font-size: 0.875rem;\n                @at-root [data-theme-version=\"dark\"] & {\n                    color: $white;\n                }\n            }\n            h3{\n\t\t\t\tfont-size: 2.5rem;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tmargin: 0;\n\t\t\t\tline-height: 1.2;\n\t\t\t}\n            h4 {\n                font-size: 1.5rem;\n                display: inline-block;\n\t\t\t\tvertical-align: middle;\n            }\n            span {\n                margin-left: 0.3125rem;\n                \n            }\n        }\n    }\n\t&[class*=\"bg-\"] .media > span{\n\t\tbackground-color:rgba(255,255,255,0.25);\n\t\tcolor:$white;\n\t}\n\t&[class*=\"bg-\"] .progress{\n\t\tbackground-color:rgba(255,255,255,0.25) !important;\n\t}\n\t\n}\n[direction=\"rtl\"] {\n\t.widget-stat .media .media-body span{\n\t\tmargin-left: 0;\n\t\tmargin-right: 0.625rem;\n\t}\n}\n.dez-widget-1{\n    .card {\n        background: #FFE7DB;\n        .card-body {\n            p {\n                color: #f87533;\n            }\n        }\n    }\n\t.progress {\n\t\n\t}\n\t.icon{\n\t\tfloat: right;\n\t\twidth: 3.125rem;\n\t\theight: 3.125rem;\n\t\tdisplay: flex;\n\t\talign-items:center;\n\t\tjustify-content:center;\n\t\tborder-radius: 0.375rem;\n\t\tfont-size: 1.75rem;\n\t}\n}\n.bgl-primary{\n    background: var(--rgba-primary-1);\n    border-color: var(--rgba-primary-1);\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: var(--rgba-primary-1);\n\t\tborder-color: var(--rgba-primary-1);\n\t}\n}\n.bgl-secondary{\n    background: $secondary-light;\n    border-color: $secondary-light;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $secondary-opacity;\n\t\tborder-color: $secondary-opacity;\n\t}\n\n}\n.bgl-success{\n    background: $success-light;\n    border-color: $success-light;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $success-opacity;\n\t\tborder-color: $success-opacity;\n\t}\n\n}\n.bgl-warning{\n    background: $warning-light;\n    border-color: $warning-light;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $warning-opacity;\n\t\tborder-color: $warning-opacity;\n\t}\n\n}\n.bgl-danger{\n    background: $danger-light;\n    border-color: $danger-light;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $danger-opacity;\n\t\tborder-color: $danger-opacity;\n\t}\n\n}\n.bgl-info{\n    background: $info-light;\n    border-color: $info-light;\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: $info-opacity;\n\t\tborder-color: $info-opacity;\n\t}\n\n}\n.bg-primary-light{\n    background: var(--rgba-primary-5);\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: var(--rgba-primary-1);\n\t}\n}\n.bg-secondary-light{\n   background: rgba($secondary-light, 0.5);\n   @at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: rgba($secondary, 0.05);\n\t}\n}\n.bg-success-light{\n   background:  rgba($success-light, 0.5);\n   @at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: rgba($success, 0.05);\n\t}\n}\n.bg-warning-light{\n   background:  rgba($warning-light, 0.5);\n   @at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: rgba($warning, 0.05);\n\t}\n}\n.bg-danger-light{\n   background:  rgba($danger-light, 0.5);\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: rgba($danger, 0.05);\n\t}\n}\n.bg-info-light{\n    background:  rgba($info-light, 0.5);\n\t@at-root [data-theme-version=\"dark\"] & {\n\t\tbackground-color: rgba($info, 0.05);\n\t}\n}\n\n\n.bgl-dark{\n    background: $dark-light;\n    border-color: $dark-light;\n}\n.bgl-light{\n    background: $light;\n    border-color: $light;\n}\n.overlay-box{\n\tposition:relative;\n\tz-index:1;\n\t&:after{\n\t\tcontent:\"\";\n\t\twidth:100%;\n\t\theight:100%;\n\t\tleft:0;\n\t\ttop:0;;\n\t\tposition:absolute;\n\t\topacity:0.85;\n\t\tbackground:var(--primary);\n\t\tz-index: -1;\n\t}\n}\n.rating-bar{\n    font-size: 0.8125rem;\n}",".tdl-holder {\n  margin: 0 auto;\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n  li {\n    background-color: $white;\n    border-bottom: 0.0625rem solid $border;\n    // color: #252525;\n    list-style: none none;\n    margin: 0;\n    padding: 0;\n    span {\n      margin-left: 2.1875rem;\n      // color: $l-ctd;\n      font-size: 1rem;\n      // font-weight: 600;\n      vertical-align: middle;\n      transition: all 0.2s linear;\n\n      @at-root [direction=\"rtl\"] #{&} {\n        margin-left: auto;\n        margin-right: 2.1875rem;\n      }\n    }\n  }\n  label {\n    cursor: pointer;\n    display: block;\n    line-height: 3.125rem;\n    padding-left: 1.5rem;\n    position: relative;\n    margin: 0 !important;\n\n    @at-root [direction=\"rtl\"] #{&} {\n      padding-left: 0;\n      padding-right: 1.5rem;\n    }\n\n    &:hover {\n      background-color: #eef1f6;\n      color: $dark;\n\n      \n\n      a {\n        color: $danger;\n      }\n      \n    }\n\n    a {\n      color: $white;\n      display: inline-block;\n      line-height: normal;\n      height: 100%;\n      text-align: center;\n      text-decoration: none;\n      width: 3.125rem;\n      -webkit-transition: all .2s linear;\n      -moz-transition: all .2s linear;\n      -o-transition: all .2s linear;\n      transition: all 0.2s linear;\n      padding: 1.125rem 0rem;\n      font-size: 1.125rem;\n      position: absolute;\n      right: 0;\n\n      @at-root [direction=\"rtl\"] #{&} {\n        right: auto;\n        left: 0;\n      }\n    }\n  }\n  input {\n    &[type=checkbox] {\n      cursor: pointer;\n      opacity: 0;\n      position: absolute;\n      + i {\n        background-color: #fff;\n        border: 0.0625rem solid #e7e7e7;\n        display: block;\n        height: 1.25rem;\n        position: absolute;\n        top: 0.9375rem;\n        width: 1.25rem;\n        z-index: 1;\n        border-radius: 0rem;\n\t\tfont-size: 0.6875rem;\n\t\tborder-radius: 0.25rem;\n      }\n      &:checked {\n\n        + i {\n          background: var(--primary);\n          border-color: transparent;\n\t\t  \n        }\n\n        + i::after {\n          content: \"\\f00c\";\n          font-family: 'fontAwesome';\n          display: block;\n          left: 0.125rem;\n          position: absolute;\n          top: -0.875rem;\n          z-index: 2;\n          color: $white;\n        }\n        ~ span {\n          text-decoration: line-through;\n          position: relative;\n        }\n      }\n    }\n    &[type=text] {\n      background-color: $white;\n      height: 3.125rem;\n      margin-top: 1.8125rem;\n      border-radius: 0.1875rem;\n\n      &::placeholder {\n        color: $dark;\n       }\n    }\n  }\n}",".widget-message {\n\tp{\n\t\tfont-size: 0.875rem;\n\t\tline-height: 1.5;\n\t}\n}",".picker{\n\t.picker__frame {\n\t\tmin-width: 28.125rem;\n\t\tmax-width: 28.125rem;\n\t\t\n\t\t.picker__box{\n\t\t\tpadding: 1.25rem;\n\t\t\tborder: 0;\n\t\t\tbox-shadow: 0 0.3125rem 0.625rem rgba(0,0,0,0.1);\n\t\t\t\n\t\t\t.picker__header{\n\t\t\t\tmargin-top: 0;\n\t\t\t\t\n\t\t\t\t.picker__year{\n\t\t\t\t\tcolor: var(--primary);\n\t\t\t\t\tfont-style: inherit;\n\t\t\t\t\tfont-size: 1.25rem;\n\t\t\t\t}\n\t\t\t\n\t\t\t\t.picker__nav--prev,\n\t\t\t\t.picker__nav--next{\n\t\t\t\t\twidth: 2.5rem;\n\t\t\t\t\theight: 2.5rem;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tline-height: 2.5rem;\n\t\t\t\t\tborder-radius: 0.125rem;\n\t\t\t\t\t&:before{\n\t\t\t\t\t\tcontent: none!important\n\t\t\t\t\t}\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tfont-family: 'Font Awesome 5 Free';\n\t\t\t\t\t\tborder: 0;\n\t\t\t\t\t\tmargin: 0 auto;\n\t\t\t\t\t\tfont-size: 1.375rem;\n\t\t\t\t\t\tfont-weight: 900;\n\t\t\t\t\t}\n\t\t\t\t\t&:hover{\n\t\t\t\t\t\tbackground-color: var(--primary);\n\t\t\t\t\t\tcolor:$white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.picker__nav--prev{\n\t\t\t\t\tleft: 0;\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tcontent: \"\\f0d9\";\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.picker__nav--next{\n\t\t\t\t\tright: 0;\n\t\t\t\t\t&:after{\n\t\t\t\t\t\tcontent: \"\\f0da\";\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t.picker__table{\n\t\t\t\t.picker__weekday {\n\t\t\t\t\tpadding: 0.625rem 0;\n\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t}\n\t\t\t\t.picker__day {\n\t\t\t\t\twidth: 2.5rem;\n\t\t\t\t\theight: 2.5rem;\n\t\t\t\t\tborder-radius: 3.125rem;\n\t\t\t\t\tpadding: 0!important;\n\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\tline-height: 2.5rem;\n\t\t\t\t\tmargin: auto;\n\t\t\t\t\tborder: 0!important;\n\t\t\t\t\t\n\t\t\t\t\t&.picker__day--today{\n\t\t\t\t\t\t&:before {\n\t\t\t\t\t\t\tcontent: none !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t&.picker__day--highlighted {\n\t\t\t\t\t\tborder: 0!important;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tbackground-color: var(--primary);\n\t\t\t\t\t\tcolor: $white!important;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t&:hover{\n\t\t\t\t\t\tbackground-color: var(--primary);\n\t\t\t\t\t\tcolor: $white !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t.picker__footer{\n\t\t\t\t.picker__button--today{\n\t\t\t\t\tbackground-color: var(--primary);\n\t\t\t\t\tcolor: $white !important;\n\t\t\t\t\t\n\t\t\t\t\t&:before{\n\t\t\t\t\t\tcontent: none!important\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t.picker__button--clear, \n\t\t\t\t.picker__button--close, \n\t\t\t\t.picker__button--today{\n\t\t\t\t\tborder: 0;\n\t\t\t\t\tborder-radius: 0.125rem;\n\t\t\t\t\tfont-size: 1rem;\n\t\t\t\t\t&:hover{\n\t\t\t\t\t\tbackground-color:var(--primary);\n\t\t\t\t\t\tcolor: $white !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t}\n\t\t\t\t\n\t\t@include respond('phone') {\n\t\t\tmin-width: 100%!important;\n\t\t\tmax-width: 100%!important;\n\t\t\t\n\t\t\t.picker__box{\n\t\t\t\tpadding: 0.9375rem;\n\t\t\t\tmargin: 0 0.625rem;\n\t\t\t}\n\t\t}\n\t}\n\t\n}\n\n",".card-list{\n\toverflow: unset;\n\theight: calc(100% - 50px);\n\t\n\t.card-header{\n\t\tpadding-top: 0;\t\t\n\t\tpadding-bottom: 0;\n\t\t\n\t\t.photo{\n\t\t\toverflow: hidden;\n\t\t\tborder-radius: 0.3125rem;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\t\n\t@include respond('tab-land') {\n\t\theight: calc(100% - 40px);\n\t}\n\n\t&.list-left{\n\t\tmargin-top: 0.9375rem;\n\t\tmargin-left: 0.9375rem;\n\t\t\n\t\t.card-header{\n\t\t\tpadding-left: 0;\n\t\t\t\n\t\t\t.photo{\n\t\t\t\tmargin: -0.9375rem 0.9375rem 0 -0.9375rem;\n\t\t\t}\n\t\t}\n\t}\n\t\n\t&.list-right{\n\t\tmargin-top: 0.9375rem;\n\t\tmargin-right: 0.9375rem;\n\t\ttext-align: right;\n\t\t\n\t\t.card-header{\n\t\t\tpadding-right: 0;\n\t\t\t\n\t\t\t.photo{\n\t\t\t\tmargin: -0.9375rem -0.9375rem 0 0.9375rem;\n\t\t\t\timg{\n\t\t\t\t\twidth:100%;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t\n\t&.list-center{\n\t\tmargin-top: 0.9375rem;\n\t\t\n\t\t.card-header{\n\t\t\t\n\t\t\t.photo{\n\t\t\t\tmargin: -0.9375rem 0 0 0;\n\t\t\t}\n\t\t}\n\t}\n\t.photo img{\n\t\twidth:100%;\n\t}\n}\n.card-profile{\n\t.profile-photo{\n\t\tmargin-top: -1.25rem;\n\t}\n}",".widget-media{\n\t.timeline{\n\t\t.timeline-panel{\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tborder-bottom:0.0625rem solid $l-border;\n\t\t\tpadding-bottom: 0.9375rem;\n\t\t\tmargin-bottom: 0.9375rem;\n\t\t\t\n\t\t\t.media{\n\t\t\t\twidth: 3.125rem;\n\t\t\t\theight: 3.125rem;\n\t\t\t\tbackground: #eee;\n\t\t\t\tborder-radius: 0.75rem;\n\t\t\t\toverflow: hidden;\n\t\t\t\tfont-size: 1.25rem;\n\t\t\t\ttext-align: center;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\tfont-weight: 700;\n\t\t\t\talign-self: start;\n\t\t\t\t\t\n\t\t\t\t&-primary{\n\t\t\t\t\tbackground:var(--rgba-primary-1);\n\t\t\t\t\tcolor:var(--primary);\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: var(--rgba-primary-1);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&-info{\n\t\t\t\t\tbackground:var(--rgba-primary-1);\n\t\t\t\t\tcolor:var(--primary);\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: $info-opacity;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&-warning{\n\t\t\t\t\tbackground:$warning-light;\n\t\t\t\t\tcolor:$warning;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: $warning-opacity;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&-danger{\n\t\t\t\t\tbackground:$danger-light;\n\t\t\t\t\tcolor:$danger;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: $danger-opacity;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&-success{\n\t\t\t\t\tbackground:$success-light;\n\t\t\t\t\tcolor:$success;\n\t\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t\tbackground-color: $success-opacity;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.media-body{\n\t\t\t\tp{\n\t\t\t\t\tfont-size: 0.875rem;\n\t\t\t\t\tline-height:1.5;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.dropdown {\n\t\t\t\talign-self: self-end;\n\t\t\t\tmargin-top: 0.3125rem;\n\t\t\t}\n\t\t}\n\t\tli:last-child {\n\t\t\t.timeline-panel{\n\t\t\t\tmargin-bottom:0;\n\t\t\t\tborder-bottom:0;\n\t\t\t\tpadding-bottom:0;\n\t\t\t}\n\t\t}\n\t}\n}\n.card[class*=\"bg-\"]{\n\t.timeline{\n\t\t.timeline-panel{\n\t\t\tborder-color:rgba(255,255,255,0.2) !important;\n\t\t}\n\t}\n}","//style for all basic tables\n.table {\n    th, td {\n        border-color: $border;\n\t\tpadding: 0.9375rem 1.325rem;\n\t\t\n        @at-root [data-theme-version=\"dark\"] & {\n            border-color: $d-border!important;\n\t\t\tcolor:$white;\n        }\n    }\n\ttd{\n\t\tpadding:0.65rem 1.425rem;\n\t}\n\t&.table-striped tbody tr:nth-of-type(odd),\n\t&.table-hover tr:hover{\n\t    background-color:$l-bg;\n\t\t\n\t\t@at-root [data-theme-version=\"dark\"] & {\n            background-color: $d-bg;\n\t\t\t\n        }\n\t}\n\n\t&.shadow-hover tbody tr:hover{\n\t    background-color:$white;\n\t\tbox-shadow: 0 0rem 1.875rem var(--rgba-primary-2);\n\t\t@at-root [data-theme-version=\"dark\"] & {\n            background-color: $d-bg;\n        }\n\t}\n\t&.tr-rounded{\n\t\ttr{\n\t\t\ttd,th{\n\t\t\t\t&:first-child{\n\t\t\t\t\tborder-radius:0.5rem 0 0 0.5rem;\n\t\t\t\t}\n\t\t\t\t&:last-child{\n\t\t\t\t\tborder-radius:0 0.5rem 0.5rem 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&.order-tbl{\n\t\ttr{\n\t\t\tth{\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tborder:0;\n\t\t\t}\n\t\t\ttd{\n\t\t\t\tfont-weight:500;\n\t\t\t\tborder:0;\n\t\t\t}\n\t\t}\n\t}\n\t&.border-hover{\n\t\ttr{\n\t\t\ttd{\n\t\t\t\tborder-width:0.0625rem 0 0.0625rem 0;\n\t\t\t\tborder-bottom:0.0625rem solid transparent;\n\t\t\t\tborder-color:transparent;\n\t\t\t\t&:first-child{\n\t\t\t\t\tborder-width:0.0625rem 0 0.0625rem 0.0625rem;\n\t\t\t\t}\n\t\t\t\t&:last-child{\n\t\t\t\t\tborder-width:0.0625rem 0.0625rem 0.0625rem 0;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover{\n\t\t\t\ttd{\n\t\t\t\t\tborder-color:$border-color;\n\t\t\t\t}\n\t\t\t}\n\t\t} \n\t}\n\t&.bg-secondary-hover{\n\t\ttd{\n\t\t\tcolor:$black;\n\t\t\tpadding-left:0;\n\t\t}\n\t\tth{\n\t\t\tcolor:$secondary!important;\n\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\tcolor:var(--secondary)!important;\n\t\t\t}\n\t\t}\n\t\ttr:hover{\n\t\t\ttd,th{\n\t\t\t\tbackground:$secondary;\n\t\t\t\tcolor:$white;\n\t\t\t\tbox-shadow:10px 0 30px rgba(65,63,187,0.3);\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\tbackground:var(--secondary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\t\n\t}\t\n\t&.bg-primary-hover{\n\t\ttd{\n\t\t\tcolor:$black;\n\t\t\tpadding-left:0;\n\t\t}\n\t\tth{\n\t\t\tcolor:var(--primary);\n\t\t}\n\t\ttr:hover{\n\t\t\ttd,th{\n\t\t\t\tbackground:var(--primary);\n\t\t\t\tcolor:$white;\n\t\t\t\tbox-shadow:10px 0 30px rgba(54,147,255,0.3);\n\t\t\t}\n\t\t}\t\n\t}\n\t\t\n\t&.bg-eth-hover{\n\t\ttd{\n\t\t\tcolor:$black;\n\t\t\tpadding-left:0;\n\t\t}\n\t\tth{\n\t\t\tcolor:#00ADA3;\n\t\t}\n\t\ttr:hover{\n\t\t\ttd,th{\n\t\t\t\tbackground:#00ADA3;\n\t\t\t\tcolor:$white;\n\t\t\t\tbox-shadow:10px 0 30px rgba(0,173,163,0.3);\n\t\t\t}\n\t\t}\t\n\t}\t\n\t&.bg-ripple-hover{\n\t\ttd{\n\t\t\tcolor:$black;\n\t\t\tpadding-left:0;\n\t\t}\n\t\tth{\n\t\t\tcolor:#23292F;\n\t\t}\n\t\ttr:hover{\n\t\t\ttd,th{\n\t\t\t\tbackground:#23292F;\n\t\t\t\tcolor:$white;\n\t\t\t\tbox-shadow:10px 0 30px rgba(35,41,47,0.3);\n\t\t\t}\n\t\t}\t\n\t}\t\n\t&.bg-pink-hover{\n\t\tth,td{\n\t\t}\n\t\ttd{\n\t\t\tcolor:#5b5e81;\n\t\t\tpadding-left:0;\n\t\t}\n\t\tth{\n\t\t\tcolor:$pink;\n\t\t}\n\t\ttr:hover{\n\t\t\ttd,th{\n\t\t\t\tbackground:$pink;\n\t\t\t\tcolor:$white;\n\t\t\t\tbox-shadow:10px 0 30px rgba(172,76,188,0.3);\n\t\t\t}\n\t\t}\t\n\t}\t\n\t&.bg-secondary-hover{\n\t\ttd{\n\t\t\tcolor:#5b5e81;\n\t\t}\n\t\tth{\n\t\t\tcolor:#6C6C6C;\n\t\t}\n\t\ttr:hover{\n\t\t\ttd,th{\n\t\t\t\tbackground:var(--secondary);\n\t\t\t\tcolor:$white!important;\n\t\t\t}\n\t\t}\t\n\t}\t\n\t&.bg-info-hover{\n\t\ttd{\n\t\t\tcolor:$black;\n\t\t}\n\t\tth{\n\t\t\tcolor:#6C6C6C;\n\t\t}\n\t\ttr:hover{\n\t\t\ttd,th{\n\t\t\t\tbackground:$info;\n\t\t\t\tcolor:$white!important;\n\t\t\t}\n\t\t}\t\n\t}\t\n\t&.bg-warning-hover{\n\t\ttd{\n\t\t\tcolor:$black;\n\t\t}\n\t\tth{\n\t\t\tcolor:#6C6C6C;\n\t\t}\n\t\ttr:hover{\n\t\t\ttd,th{\n\t\t\t\tbackground:$warning;\n\t\t\t\tcolor:$white!important;\n\t\t\t}\n\t\t}\t\n\t}\t\n\t&.border-no{\n\t\ttd{\n\t\t\tborder:0;\n\t\t}\n\t}\n\t&.short-one{\n\t\ttr{\n\t\t\ttd,th{\n\t\t\t\t&:first-child{\n\t\t\t\t\twidth:3.75rem\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n    thead th {\n           color: var(--primary);\n\t\t\twhite-space: nowrap;\n\t\t\tfont-size: 14px;\n\t\t\ttext-transform: capitalize;\n\t\t\tfont-weight: 500;\n\t\t\tpadding: 11px 20.7px;\n\n\t\tsmall {\n\t\t\tcolor: #fff ;\n\t\t}\n        @at-root [data-theme-version=\"dark\"] & {\n            border-color: $d-border!important;\n        }\n    }\n    tbody  tr td {\n        // color: $l-ctd;\n        // line-height: 2.5rem;\n        vertical-align: middle;\n\t\twhite-space: nowrap;\n        border-color: $border;\n        @at-root [data-theme-version=\"dark\"] & {\n          /*   border-color: $d-border; */\n        }\n    }\n\t\n\t//delete header borders without '.borders tables'\n    &:not(.table-bordered) {\n        thead th {\n            border-top: none;\n        }\n    }\n\n    //heading background\n    .thead-primary th {\n        background-color: var(--primary);\n        color: $white;\n    }\n\t.thead-info th {\n        background-color: $info;\n        color: $white;\n    }\n\t.thead-warning th {\n        background-color: $warning;\n        color: $white;\n    }\n\t.thead-danger th {\n        background-color: $danger;\n        color: $white;\n    }\n\t.thead-success th {\n        background-color: $success;\n        color: $white;\n    }\n\n    //table border\n    &.primary-table-bordered {\n        border: 0.0625rem solid $border;\n\t\t@at-root [data-theme-version=\"dark\"] & {\n            border-color: $d-border;\n        }\n    }\n\n    //table hover\n    &.primary-table-bg-hover {\n\t\ttbody{\n\t\t\t//border-color:$white;\n\t\t}\n        thead th {\n            background-color:var(--primary);\n            color: $white;\n            border-bottom: none;\n\t\t\tborder-color:$white!important;\n        }\n\n        tbody tr {\n            background-color: var(--primary);\n            color: $white;\n            transition: all .1s ease;\n\t\t\ttd{\n\t\t\t\tborder-color:$white;\n\t\t\t\t@at-root [data-theme-version=\"dark\"] & {\n\t\t\t\t\t//color: $white;\n\t\t\t\t}\n\t\t\t}\n\n            &:hover {\n                background-color: var(--rgba-primary-8);\n            }\n\n            &:not(:last-child) {\n                td, th {\n                    border-bottom: 0.0625rem solid var(--primary-dark);\n\t\t\t\t\tborder-color:rgba(255,255,255,0.5);\n\t\t\t\t\t\n                }\n            }\n\t\t\t\n        }\n\t\t\n    }\n\n    //responsive table width\n    &-responsive {\n        &-tiny {\n            // @include media-breakpoint-down(xs) {\n                min-width: 18.75rem;\n            // }\n        }\n\n        &-sm {\n            // @include media-breakpoint-down(sm) {\n                min-width: 30rem !important;\n            // }\n        }\n\n        &-md {\n            // @include media-breakpoint-down(sm) {\n                min-width: 36rem !important;\n            // }\n        }\n\n        &-lg {\n            min-width: 60.9375rem !important;\n        }\n\n        &-xl {\n            min-width: 70.9375rem !important;\n        }\n    }\n}\n.table-primary, \n.table-primary > th, \n.table-primary > td {\n\tbackground-color: var(--rgba-primary-1);\n\tcolor: var(--primary);\n\t@at-root [data-theme-version=\"dark\"] & {\n        background-color: var(--rgba-primary-1);\n    }\n}\n.table-success, \n.table-success > th, \n.table-success > td {\n\tbackground-color: $success-light;\n\tcolor: $success;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background-color: $success-opacity;\n    }\n}\n.table-info, \n.table-info > th, \n.table-info > td {\n\tbackground-color: $info-light;\n\tcolor: $info;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background-color: $info-opacity;\n    }\n}\n.table-warning, \n.table-warning > th, \n.table-warning > td {\n\tbackground-color: $warning-light;\n\tcolor: $warning;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background-color: $warning-opacity;\n    }\n}\n.table-danger, \n.table-danger > th, \n.table-danger > td {\n\tbackground-color: $danger-light;\n\tcolor: $danger;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background-color: $danger-opacity;\n    }\n}\n.table-active, \n.table-active > th, \n.table-active > td {\n    background-color: $l-bg;\n\t@at-root [data-theme-version=\"dark\"] & {\n        background-color: $d-bg;\n    }\n}\n\n\n\n.card-table{\n\tth, td{\n        &:first-child{\n\t\t\tpadding-left: 1.875rem;\n\t\t\t@include respond('phone') {\n\t\t\t\tpadding-left: 0.9375rem;\n\t\t\t}\n\t\t}\n\t\t&:last-child{\n\t\t\tpadding-right: 0;\n\t\t\ttext-align: center;\n\t\t\t@include respond('phone') {\n\t\t\t\tpadding-right: 0.9375rem;\n\t\t\t}\n\t\t}\n    }\n}\n.table > :not(:first-child){\n\tborder-top: 1px solid currentColor;\n}\n.table-striped > tbody > tr:nth-of-type(odd) > *{\n\tcolor:#303972;\n}\n.table{\n\ttbody{\n\t\ttr{\n\t\t\t&:last-child{\n\t\t\t\ttd,\n\t\t\t\tth{\n\t\t\t\t\tborder-bottom:transparent;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t}\n}\n\t\n\n",".bootgrid-header {\n    padding: 0 !important;\n    margin: 0;\n\n    @include respond(phone) {\n        .actionBar {\n            padding: 0;\n        }\n    \n        .search {\n            margin: 0 0 0.625rem 0;\n        }\n    }\n}","//demo styles\ntable#example{\n    padding: 0rem 0 2rem 0;\n}\ntable.dataTable{\n    font-size: 14px;\n    overflow: hidden;\n}\n#example2_wrapper {\n    .dataTables_scrollBody {\n        max-height: 33.25rem !important;\n    }\n}\n\n#employees, #custommers {\n    padding: .5rem 0 1rem 0;\n}\n//////////\n.dataTables_wrapper .dataTables_paginate{\n    padding-top: 0.75em;\n    padding-bottom: 0.75em;\n}\n\n\n\ntable.dataTable thead th, table.dataTable thead td{\n    border-bottom: 2px solid $border-color;\n    border-top: 0;\n}\n\ntable.dataTable tfoot th, table.dataTable tfoot td{\n    border-top: 0;\n}\n\ntable.dataTable tbody tr, table.dataTable tbody td{\n    background: transparent !important;\n}\ntable.dataTable thead .sorting{\n\tbackground-image: none!important;\n}\ntable.dataTable thead sorting sorting_desc{\n\tbackground-image: none;\n}\n.sorting{\n\tbackground-image: none;\n}\n.table.dataTable thead .sorting_desc{\n\tbackground-image: none;\n}\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc:after{\n\tcontent:\"\";\n    font-family: \"Font Awesome 6 Free\";\n    font-weight: 900;\n    background-image: none;\n    margin-left: 10px;\n    font-size: calc(100% - 4px);\n    opacity: 0.5;\n}\ntable.dataTable thead .sorting:after {//both\n    content:\"\\f0dc\";\n}\ntable.dataTable thead .sorting_asc:after {//top\n    content:\"\\f0de\";\n\topacity: 1;\n}\ntable.dataTable thead .sorting_desc:after {//bottom\n    content:\"\\f0dd\";\n\topacity: 1;\n}\n\ntable.dataTable thead th{\n    color: var(--primary);\n\twhite-space:nowrap;\n\tfont-size:14px;\n\ttext-transform:capitalize;\n    font-weight: 500;\n\tpadding:11px 20.7px;\n    @at-root [data-theme-version=\"dark\"] & {\n        color: $white;\n    }\n\t@include respond ('laptop'){\n\t\tfont-size:13px;\n\t}\n\t@include respond ('phone'){\n\t\tpadding: 10px 8px;\n\t}\n}\ntd.doller {\n\tcolor: var(--primary);\n}\n\ntable.dataTable tbody td{\n\n\tborder-bottom:0;\n\twhite-space: nowrap;\n\tfont-size:14px;\n\tfont-weight:400;\n\tpadding:0.65rem 1.425rem;\n\tcolor:$body-color;\n\t\n}\n\ntable.dataTable tr.selected{\n    color: var(--primary);\n}\n\ntable.dataTable tfoot th{\n    color: $dark;\n    font-weight: 600;\n    @at-root [data-theme-version=\"dark\"] & {\n        color: $white;\n    }\n}\n\n.dataTables_wrapper .dataTables_paginate{\n\talign-items: center;\n    display: inline-flex;\n\tflex-flow:wrap;\n\t.paginate_button.previous,.paginate_button.next{\n\t\tmargin-left: 0px;\n\t\tfont-size: 18px;\n\t\t//margin:0 2px;\n\t\tborder: 0!important;\n\t\theight:45px;\n\t\twidth: 155px;\n\t\tpadding: 0;\n\t\tborder-radius:0.5rem;\n\t\tline-height:45px;\n\t\tdisplay:inline-block;\n\t\tbackground:\ttransparent;\n\t\t\n\t\t&:last-child{\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tmargin: 0 5px 0 5px;\n\t\t}\n\t\t&:first-child{\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\t\ti{\n\t\t\tfont-size: 1rem;\n\t\t\tpadding: 0 10px;\n\t\t}\n\t\tspan{\n\t\t\tborder: none;\n\t\t}\n\t\t&.current:hover,\n\t\t&.previous:hover,\n\t\t&.next:hover{\n\t\t\tcolor:$white!important;\n\t\t\tbackground:var(--primary)!important;\n\t\t\tborder-radius: $radius-sm;\n\t\t}\n\t\t&.disabled{\n\t\t\tcolor:$main-color!important;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t}\n\t\t@include respond ('tab-port'){\n\t\t\theight:45px;\n\t\t\twidth:135px;\n\t\t\tfont-size: 16px;\n\t\t\ti{\n\t\t\t\tfont-size: 16px;\n\t\t\t}\n\t\t}\n\t\t@include respond ('phone'){\n\t\t\twidth: 45px;\n\t\t\tfont-size: 14px;\n\t\t\theight:40px;\n\t\t\tline-height:40px;\n\t\t\ti{\n\t\t\t\tfont-size: 14px;\n\t\t\t}\n\t\t\tspan{\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t\t\n\t}\n\tspan{\n\t\t.paginate_button{\n\t\t\theight:45px;\n\t\t\twidth:45px;\n\t\t\tpadding:0;\n\t\t\tmargin-left: 0px;\n\t\t\tline-height:45px;\n\t\t\ttext-align:center;\n\t\t\tfont-size:18px;\n\t\t\tborder-radius:0rem;\n\t\t\tcolor:$body-text!important;\n\t\t\tborder:0!important;\n\t\t\t@include respond ('phone'){\n\t\t\t\n\t\t\t\theight:40px;\n\t\t\t\twidth:40px;\n\t\t\t\tline-height:40px;\n\t\t\t}\n\t\t\t&.current,&:hover{\n\t\t\t\tcolor: $white!important;\n\t\t\t\tbackground:var(--primary)!important;\n\t\t\t\tbox-shadow:0px 0px 5px rgba($black,0.1);\n\t\t\t\t&:hover{\n\t\t\t\t\tcolor:var(--primary)!important;\n\t\t\t\t\tbackground:var(--rgba-primary-1)!important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.dataTables_wrapper {\n    input[type=\"search\"], input[type=\"text\"], select {\n        border: 1px solid $b-color !important;\n        padding: .3rem 0.5rem;\n        color: $main-color;\n        border-radius: 0.625rem  !important;\n\t\tmargin-left: 14px;\n        @at-root [data-theme-version=\"dark\"] & {\n            background: $d-bg;\n            border-color: $d-border!important;\n            color: $white;\n        }\n    }\n\t.dataTables_length{\n\t\tmargin-bottom: 15px;\n\t\t.bootstrap-select{\n\t\t\twidth: 80px!important;\n\t\t\tmargin: 0 5px;\n\t\t}\n\t}\n}\ntable.dataTable.no-footer{\n    border-bottom: 0;\n}\n\n\n.rounded-lg{\n\tmin-width:30px;\n}\n.dataTables_scroll{\n    padding: 1rem 0;\n\n    &Foot{\n        padding-top: 1rem;\n    }\n}\n\n.dataTablesCard{\n\tbackground-color:$white;\n\tborder-radius:$radius;\n\toverflow: hidden;\n\t&.border-no{\n\t\ttd{\n\t\t\tborder-top:0!important;\n\t\t}\n\t}\n}\n\n.dataTables_wrapper .dataTables_length, .dataTables_wrapper .dataTables_filter {\n    @include media-breakpoint-down(md) {\n        text-align: left;\n    }\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button.disabled, \n.dataTables_wrapper .dataTables_paginate .paginate_button.disabled:hover, \n.dataTables_wrapper .dataTables_paginate .paginate_button.disabled:active{\n\tcolor: $body-color !important;\n}\n.dataTables_wrapper .dataTables_length, \n.dataTables_wrapper .dataTables_filter, \n.dataTables_wrapper .dataTables_processing, \n.dataTables_wrapper .dataTables_paginate {\n    color: $body-color;\n\tborder-radius:1rem;\n\tmargin-bottom:20px;\n\t@include respond ('phone'){\n\t\tmargin-bottom:8px;\n\t}\n}\n.dataTables_wrapper .dataTables_length,\n.dataTables_wrapper .dataTables_filter{\n\t    margin-bottom: 10px;\n    padding: 15px 19px 0px 19px;\n}\n\n.paging_simple_numbers.dataTables_paginate {\n\tborder: 0.025rem  solid var(--primary);\t\n\tbackground:transparent;\n\tborder-radius: 0.5rem;\n\tspan{\t\t\n\t\tborder-radius: $radius;\n\t}\n}\n.dataTables_wrapper .dataTables_paginate .paginate_button{\n\tcolor: $body-color !important;\n}\n\n.dataTables_info{\n\tfont-size:13px;\n\tfont-weight:500;\n\ttext-align:start!important;\n\tdisplay: inline-block;\n}\n\ntable.dataTable.row-border tbody th, \ntable.dataTable.row-border tbody td, \ntable.dataTable.display tbody th, \ntable.dataTable.display tbody td {\n    border-color: $border;\n    @at-root [data-theme-version=\"dark\"] & {\n        border-color: $d-border;\n    }\n}\n\n.dataTables_wrapper{\n\t.dataTables_length{\n\t\t.bootstrap-select{\n\t\t\t.dropdown-toggle{\n\t\t\t\tfont-size: 0.813rem !important;\n\t\t\t\tpadding: 0.625rem 1rem;\n\t\t\t}\n\t\t}\n\t}\n}\n.table-responsive {\n\tthead {\n\t\tbackground-color:var(--rgba-primary-1);\n\t}\n}\n\n.dataTables_wrapper .dataTables_paginate .paginate_button.previous,\n .dataTables_wrapper .dataTables_paginate .paginate_button.next {\n    height: 30px;\n    width: 30px;\n    padding: 0;\n\tfont-size:13px;\n    border-radius: $radius-sm;\n\tline-height: 30px;\n\tmargin: 0 5px;\n\ttext-align: center;\n\tmargin-left: 0;\n\t@include respond ('phone'){\n\t\theight: 36px;\n\t\twidth: 36px;\n\t\tline-height: 36px;\n\t}\n}\n.dataTables_wrapper .dataTables_paginate span .paginate_button {\n    height: 30px;\n    width: 30px;\n    padding: 0;\n    line-height: 30px;\n    display: inline-block;\n\tmargin: 0 5px;\n\tborder-radius: $radius-sm;\n\t@include respond ('phone'){\n\t\theight: 36px;\n\t\twidth: 36px;\n\t\tline-height: 36px;\n\t\tfont-size:14px;\n\t}\n}\n.paging_simple_numbers.dataTables_paginate {\n    border: none;\n\t//float:right;\n}\n\n.dataTables_scrollBody thead{\n\tdisplay:none;\n}\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc:after{\n\tcontent:\"\";\n    font-family: \"Font Awesome 6 Free\";\n    font-weight: 900;\n    background-image: none;\n    margin-left: 5px;\n    font-size: calc(100% - 2px);\n    opacity: 0.5;\n}\ntable.dataTable thead .sorting:after {//both\n    content:\"\\f0dc\";\n}\ntable.dataTable thead .sorting_asc:after {//top\n    content:\"\\f0de\";\n\topacity: 1;\n}\ntable.dataTable thead .sorting_desc:after {//bottom\n    content:\"\\f0dd\";\n\topacity: 1;\n}\n\n\n.dlab-scroll{\n    overflow-y: scroll;\n\t//scrollbar-width: thin;\n\t//scrollbar-color: rgba(111, 133, 147, 0.1) #fff0;\n}\n/* .dlab-scroll::-webkit-scrollbar {\n\twidth: 5px;\n\topacity:0;\n}\n.dlab-scroll::-webkit-scrollbar-thumb{\n\tbackground:  rgba(111, 133, 147, 0.0); \n}\n.dlab-scroll:hover::-webkit-scrollbar-thumb{\n\tbackground:  rgba(111, 133, 147, 0.1); \n} */\n\n\nbody > *{\n   // overflow-y: scroll;\n\tscrollbar-width: thin;\n\tscrollbar-color: rgba(111, 133, 147, 0.1) #fff0;\n}\n::-webkit-scrollbar {\n\twidth: 5px;\n\topacity:0;\n}\n/* ::-webkit-scrollbar-thumb{\n\tbackground:  rgba(111, 133, 147, 0.0); \n} */\n::-webkit-scrollbar-thumb{\n\tbackground:  rgba(111, 133, 147, 0.1); \n}\n#example2_wrapper{\n\t#example2_filter{\n\t\tfloat:left;\n\t}\n}\n.dataTables_info{\n\tpadding: 1.25rem 0.75rem;\n}",".fooicon {\n    font-size: 1.25rem;\n    color: $dark;\n}",".jsgrid-table{\n\n    .jsgrid-header-row{\n\n        & > .jsgrid-header-cell{\n            color: $dark;\n        }\n    }\n\n    & > tbody > tr > td{\n        padding: 1.2em;\n    }\n\n    .jsgrid-insert-row, .jsgrid-edit-row{\n\n        input, select{\n            border: 0.0625rem solid #DDDFE1;\n        }\n    }\n}\n\n.jsgrid .jsgrid-button{\n    border: 0 !important;\n    margin-left: 0.625rem;\n}\n",".file-drive{\n    border-bottom: 1px solid $border-light;\n    border-top: none;\n    border-radius: 0;\n    margin-bottom: 0;\n\t@include respond('phone-land'){\n\t\tborder-top:1px solid $b-color;\n\t}\n}\n.file_area{\n\t.table-pagenation{\n\t\tmargin: 0;\n\t\tbackground-color: $white;\n\t\tpadding: 0.813rem 5px;\n\t\tflex-wrap: wrap;\n\t\tp{\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t\t.pagination{\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t\t@include respond ('phone'){\n\t\t\tdisplay:none;\n\t\t}\n\t}\n}\n.drive {\n    display: flex;\n    padding: 0.625rem;\n    justify-content: flex-start;\n    align-items: center;\n\tborder: 1px solid $white;\n\tborder-radius: $radius;\n\t@include transitionMedium ;\n\tcursor: pointer;\n\t.dz-folder{\n\t\tmargin-right: 0.625rem;\n\t\tsvg{\n\t\t\tpath{\n\t\t\t\tfill:var(--primary);\n\t\t\t}\n\t\t\t@include custommq($max:100rem){\n\t\t\t\twidth: 65px;\n\t\t\t\theight: 60px;\n\t\t\t}\n\t\t\t@include respond('laptop'){\n\t\t\t\twidth: 50px;\n\t\t\t\theight: 50px;\n\t\t\t}\n\t\t\t@include respond('tab-port'){\n\t\t\t\twidth: 70px;\n\t\t\t\theight: 50px;\n\t\t\t}\n\t\t}\n\t\n\t}\n    .dz-media{\n        width: 11.188rem;\n    }\n\t.drive-content{\n\t\tflex: 0 0 60%;\n\t\t.title{\n\t\t\tfont-size: 1rem;\n\t\t}\n\t\tspan{\n\t\t\tfont-size: 0.75rem;\n\t\t}\n\t}\n    .progress {\n        margin-bottom: 0.3rem;\n        background-color: var(--rgba-primary-1);\n        border: 1px solid var(--primary);\n        border-radius: 0.188rem;\n\t\twidth: 100%;\n\t\theight: 0.938rem;\n\t\t@include custommq($max:110rem){\n\t\t\twidth: 100%;\n\t\t}\n\t\t\n\t\t// @include respond('laptop'){\n\t\t// \twidth: 7.188rem;\n\t\t// }\n\t\t// @include respond('tab-land'){\n\t\t//     width: 10.188rem;\n\t\t// }\n\t\t// @include respond('tab-port'){\n\t\t// \twidth: 8rem;\n\t\t// }\n\t\n        .progress-bar{\n            border-radius: 0;\n        }\n    }\n\t&:hover{\n\t\tbackground-color: var(--rgba-primary-1);\n\t\tborder: 1px solid var(--primary);\n\t}\n}\n\n.file-header{\n    border-bottom: 1px solid $border-light;\n    .page-titles{\n        margin-bottom: 0;\n        padding: 0;\n\t\tflex-wrap: wrap;\n        .input-group.search-area{\n            width: 16rem;\n\t\t\t@include respond('tab-port'){\n\t\t\t\twidth: 12rem;\n\t\t\t}\n\t\t\t@include respond ('phone'){\n\t\t\t\twidth:100%;\n\t\t\t\tsvg{\n\t\t\t\t\twidth:14px;\n\t\t\t\t\theight:14px;\n\n\t\t\t\t}\n\n\t\t\t}\n        }\n    }\n    .file-path{\n        display: flex;\n        align-items: center;\n        margin-right: 0.625rem;\n        h4{\n            a{\n               font-size: 0.875rem;\n               margin-right: 0.5rem;\n            }\n        }\n\t\tsvg{\n\t\t\tpath{\n\t\t\t\tfill:var(--primary);\n\t\t\t}\n\t\t}\n    } \n   \n}\n.file-list{\n    display: flex;\n    align-items: center;\n\tpadding: 0.938rem;\n  \n\t.dz-media{\n        margin-right: 0.8rem;\n\t\twidth: 2.813rem;\n\t\theight: 2.5rem;\n\t\t\n\t\t .dz-img{\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t\tborder-radius: 0.313rem;\n\t\t\tbox-shadow: 0px 4px 10px rgba(0, 25, 39, 0.14);\n\t\t }\n\t\t\n\n    }\n    .dz-info{\n        .title{\n            font-size: 0.938rem;\n            margin-bottom: 0;\n        }\n    }\n}\n.folder-layout-tab{\n\t.feature-btn:first-child{\n\t\tbackground:var(--primary);\n\t\tcolor:#fff;\n\t\tsvg path{\n\t\t\tfill:#fff;\n\t\t}\n\t}\n\t&.grid{\n\t\t.feature-btn{\n\t\t\t&:first-child{\n\t\t\t\tbackground:var(--rgba-primary-1);\n\t\t\t\tcolor:#fff;\n\t\t\t\tsvg path{\n\t\t\t\t\tfill:var(--primary);\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:last-child{\n\t\t\t\tbackground:var(--primary);\n\t\t\t\tcolor:#fff;\n\t\t\t\tsvg path{\n\t\t\t\t\tfill:#fff;\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\t}\n\t.feature-btn{\n\t\t\n\t}\n\t.file-media{\n\t\t\n\t}\t\n}\n.folder-structure{\n\theight: calc(100vh - 22.213rem);\n\toverflow-y: scroll;\n\t@include respond('laptop'){\n\t\theight: calc(100vh - 25.75rem);\n\t}\n\t@include respond('tab-land'){\n\t\theight: calc(100vh - 7.813rem);\n    \toverflow-y: scroll;\n\t}\n\t@include respond('tab-port'){\n\t\theight: calc(100vh - 3.313rem);\n\t}\n\tli{\n\t\tborder-bottom: 1px solid $border-light;\n\t}\n\t&.grid{ \n\t\tpadding:1.875rem;\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmargin-left: -12px;\n   \t\tmargin-right: -12px;\n\t\t   @include respond('tab-land'){\n\t\t\tmargin-left: 0; \n\t\t\t margin-right: 0;\n\t\t\t \n\t\t   }\n\t\tli{\n\t\t\tborder:0;\n\t\t\tmax-width: 20%;\n\t\t\tpadding-left: 0.75rem;\n\t\t\tpadding-right: 0.75rem;\n\t\t\tmargin-bottom: 24px;\n\t\t\tbox-sizing: border-box;\n\t\t\t@include custommq($max:100rem){\n\t\t\t\tmax-width: 25%;\n\t\t\t}\n\t\t\t@include respond('laptop'){\n\t\t\t\tmax-width: 33.33%;\n\t\t\t}\n\t\t\t@include respond('tab-port'){\n\t\t\t\tmax-width: 50%;\n\t\t\t\t\n\t\t\t}\n\t\t\t@include respond('phone-land'){\n\t\t\t\tmax-width: 33.33%;\n\t\t\t}\n\t\t\t@include respond('phone'){\n\t\t\t\tmax-width: 50%;\n\t\t\t}\n\t\t\t.file-list{\n\t\t\t\tdisplay: block;\t\t\n\t\t\t\talign-items: center;\n\t\t\t\tpadding: 1.25rem;\n\t\t\t\ttext-align: center;\n\t\t\t\tmin-width: 15rem;\n\t\t\t\tborder: 1px solid transparent;\n    \t\t\tborder-radius: $radius;\n\t\t\t\t@include custommq($max:100rem){\n\t\t\t\t\tmin-width: 13.75rem;\n\t\t\t\t}\n\t\t\t\t@include respond('laptop'){\n\t\t\t\t\tmin-width: 15rem;\n\t\t\t\t}\n\t\t\t\t@include respond('tab-land'){\n\t\t\t\t\tmin-width: 12.5rem;\n\t\t\t\t}\n\t\t\t\t@include custommq($max:64rem){\n\t\t\t\t\tmin-width: 11.125rem;\n\t\t\t\t}\n\t\t\t\t@include respond('tab-port'){\n\t\t\t\t\tmin-width: 100%;\n\t\t\t\t\tpadding: 1rem;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t@include respond('phone'){\n\t\t\t\t\tpadding: 0.625rem;\n\t\t\t\t}\n\t\t\t\t.dz-media{\n\t\t\t\t\theight: 110px;\n\t\t\t\t\twidth: 140px;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tmargin-left: auto;\n\t\t\t\t\tmargin-right: auto;\n\t\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t\t.dz-img{\n\t\t\t\t\t\tmax-width: 100%;\n\t\t\t\t\t\tmax-height: 100%;\n\t\t\t\t\t\tmin-width: 100%;\n\t\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\t\tbox-shadow: 0px 10px 10px 0 rgba(0, 0, 0,  0.10);\n\t\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t\t@include respond('tab-land'){\n\t\t\t\t\t\theight: 90px;\n\t\t\t\t\t\twidth: 120px;\n\t\t\t\t\t}\n\t\t\t\t\t@include respond('tab-port'){\n\t\t\t\t\t\theight: 90px;\n\t\t\t\t\t\twidth: 90px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tsvg{\n\t\t\t\t\twidth:80px;\n\t\t\t\t\theight:80px;\n\t\t\t\t\t@include respond('tab-port'){\n\t\t\t\t\t\twidth: 60px;\n\t\t\t\t\t\theight: 60px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&:hover{\n\t\t\t\t\tborder: 1px solid var(--rgba-primary-5);\n\t\t\t\t\tbackground: var(--rgba-primary-1);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t@include respond ('phone'){\n\t\t\tpadding:1rem;\n\t\t}\n\t}\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n",".chat-left-area{\n\t.chat-sidebar{\n\t\theight: calc(100vh - 82px);\n\t\t// height: calc(100vh - 11.25rem);\n\t\t@include respond ('tab-land'){\n\t\t\theight: calc(100vh - 5.9rem);\n\t\t}\n\t\t@include respond ('phone-land'){\n\t\t\tbox-shadow: 0 0 30px 5px rgba(0, 0, 0, 0.05);\n\t\t}\n\t\tborder-right: 1px solid $border-light;\n\t\tborder-top: none;\n\t}\n}\n.message-body{\n\tmin-height:auto!important;\n}\n\n.message-box{\n\tborder-bottom:1px solid $border-color;\n    padding-top: 1rem;\n\tpadding-bottom: 1rem;\n\t\n\t.input-group.search-area{\n\t\tflex-direction: row-reverse;\n    \tmargin-right: 0.625rem;\n\t\twidth:100%;\n\t\t.input-group-text {\n\t\t\tborder: none;\n\t\t\tborder-right: none;\n\t\t\t//background-color: transparent;\n\t\t\theight:3rem;\n\t\t\tpadding:0;\n\t\t\tbackground-color:transparent;\n\t\t}\n\t\tinput.form-control {\n\t\t\tborder: none;\n\t\t\tborder-left: none;\n\t\t\t//background-color: #f3f3f3;\n\t\t\tpadding-left: 0;\n\t\t\theight:3rem;\n\t\t}\n\t\t\n\t}\n\timg{\n\t\theight:5rem;\n\t\twidth:5rem;\n\t\tborder-radius:$radius;\n\t}\n\th4{\n\t\tfont-weight:700;\n\t}\n\tspan{\n\t\tfont-size:1.125rem;\t\n\t}\n\t.chat-hamburger {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\t.videos-player{\n\t\t\tmargin-right:30px;\n\n\t\t}\n\t}\n\t&.style-1{\n\t\tpadding:1rem;\n\t\t//border:0;\n\t\theight: 5rem;\n\t\t@include respond('phone'){\n\t\t\theight: auto;\n\t\t}\n\t\th4{\n\t\t\tmargin-bottom:.25rem;\n\t\t\t@include respond ('phone'){\n\t\t\t\tmargin-bottom:0;\n\t\t\t\tfont-size: 0.938rem;\n\t\t\t}\n\t\t}\n\t\tspan{\n\t\t\tfont-size:14px;\n\t\t}\n\t\timg{\n\t\t\theight:3rem;\n\t\t\twidth:3rem;\n\t\t\t@include respond ('phone'){\n\t\t\t\theight: 3rem;\n\t\t\t\twidth: 3rem;\n\t\t\t}\n\t\t}\n\t}\n\t@include respond ('phone'){\n\t\timg{\n\t\t\theight: 3rem;\n\t\t\twidth: 3rem;\n\t\t}\n\t\th3{\n\t\t\tfont-size: 1rem;\n\t\t}\n\t\tspan{\n\t\t\tfont-size: .85rem;\n\t\t}\n\t}\n\t.add{\n\t\twidth: 3rem;\n\t\theight: 3rem;\n\t\tmin-width:3rem;\n\t\tborder-radius: $radius;\n\t\tpadding: 0;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n}\n.chat-people{\n\tpadding:1.25rem 0;\n}\n.chat-tabs{\n\t& > h4{\n\t\tfont-size: 1.125rem;\n\t\tpadding-top: 1.125rem ;\n\t\tmargin: 0;\n\t\t\n\t}\n\tul{\n\t\tpadding: 1rem 0;\n\t}\n\t.chat-bx.chats{\n\t\tposition: relative;\n\t\t.chat-img{\n\t\t\tposition: relative;\n\t\t\n\t\t\t&::before{\n\t\t\t\tcontent: '';\n\t\t\t\tdisplay: block;\n\t\t\t\tbackground-color: #1EBA62;\n\t\t\t\tborder: 2px solid $white;\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: -2px; \n\t\t\t\tright: -2px;\n\t\t\t\twidth: 1rem;\n\t\t\t\theight: 1rem;\n\t\t\t\tborder-radius: 50%;\n\t\t\t}\n\t\t\t\n\t\t}\n\t}\n\t.chat-bx{\n\t\tpadding: 0.625rem 0;\n\t\tposition:relative;\n\t\tz-index:1;\n\t\tdisplay:flex;\n\t\tcursor:pointer;\n\t\talign-items:center;\n\t\tmargin-bottom: 0.5rem;\n\t\t.right-info{\n\t\t\twidth: 4.375rem;\n\t\t\ttext-align: right;\n\t\t\tp{\n\t\t\t\tfont-size:.8rem;\n\t\t\t\tmargin-top: 0;\n\t\t\t\tmargin-bottom: .5rem;\t\n\t\t\t}\n\t\t\t@include respond ('laptop'){\n\t\t\t\twidth: 4rem;\n\t\t\t}\n\t\t}\n\t\t.mid-info{\n\t\t\twidth: calc(100% - 9rem);\n\t\t\t.name{\n\t\t\t\tfont-size: 0.938rem;\n\t\t\t\tmargin-bottom: .25rem;\n\t\t\t}\n\t\t\tspan{\n\t\t\t\twhite-space:nowrap;\n\t\t\t\ttext-overflow:ellipsis;\n\t\t\t\tdisplay:block;\n\t\t\t\toverflow:hidden;\n\t\t\t}\n\t\t\t@include respond ('laptop'){\n\t\t\t\twidth: calc(100% - 8rem);\n\t\t\t}\n\t\t}\n\t\t\n\t\t.chat-img{\n\t\t\tposition: relative;\n\t\t\tmargin-right: 1rem;\n\t\t\timg{\n\t\t\t\theight: 3rem;\n\t\t\t\twidth: 3rem;\n\t\t\t\tborder-radius:100%;\n\t\t\t\tmargin-right: 0rem;\n\t\t\t\tobject-fit: cover;\n\t\t\t\t@include respond ('laptop'){\n\t\t\t\t\theight: 3rem;\n\t\t\t\t\twidth: 3rem;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.active{\n\t\t\t\theight:1rem;\n\t\t\t\twidth:1rem;\n\t\t\t\tborder:0.125rem solid $white;\n\t\t\t\tborder-radius:0.25rem;\n\t\t\t\tbackground:$secondary;\n\t\t\t\tposition: absolute;\n\t\t\t\tbottom: -0.0625rem;\n\t\t\t\tright: 1rem;\n\t\t\t}\n\t\t\n\t\t}\n\t\t.badge {\n\t\t\tborder-radius:0.375rem;\n\t\t}\n\t\t&:last-child{\n\t\t\tborder-bottom:0;\n\t\t}\n\t\t@include respond ('laptop'){\n\t\t\tpadding: .75rem 0;\n\t\t}\n\t\t&:after{\n\t\t\tcontent:none;\n\t\t\tposition:absolute;\n\t\t\ttop:0;\n\t\t\tleft:0;\n\t\t\theight: calc(100% + 4px);\n\t\t\twidth: calc(100% + 30px);\n\t\t\tz-index:-1;\n\t\t\tbackground-color:#f0f0f0;\n\t\t\tborder-radius:$radius;\n\t\t\tmargin: -2px -15px;\n\t\t}\n\t\t&:hover,\n\t\t&.active{\n\t\t\t&::before{\n\t\t\t\tcontent: '';\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t\t&:after{\n\t\t\t\tcontent:\"\";\n\t\t\t}\n\t\t\t.mid-info{\n\t\t\t\th4{\n\t\t\t\t\tcolor:var(--primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.chat-box-area{\n\theight: calc(100vh - 17.125rem);\n    overflow-y: scroll;\n\t.media{\n\t\t.message-received {\n\t\t\twidth: 62%;\n\t\t\ttext-align: left;\n\t\t\n\t\t\t\tp{\n\t\t\t\t\tbackground:#f5f5f5;\n\t\t\t\t\ttext-align: left;\n\t\t\t\t\tborder-radius:$radius;\n\t\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\t\tpadding: 0.625rem 1.25rem;\n\t\t\t\t\tdisplay: table;\n\t\t\t\t\tcolor:var(--primary);\n\t\t\t\t}\n\t\t\t\tspan{\n\t\t\t\t\tcolor: var(--primary);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t\t.dz-media{\n\t\t\t\t\t\twidth: 22.75rem;\n\t\t\t\t\t\theight: 15.375rem;\n\t\t\t\t\t\tpadding: 0.625rem;\n\t\t\t\t\t\tbackground-color: $body-bg;\n\t\t\t\t\t}\n\t\t\t\t\n\t\t\t\n\t\t\t@include respond('phone'){\n\t\t\t\twidth:100%;\t\n\t\t\t}\n\t\t}\n\t}\n\t.message-sent{\n\t\twidth: 62%;\n\t\ttext-align: right;\n\t\tmax-width: 83%;\n\t\t@include respond ('tab-port'){\n\t\t\twidth: 84%;\n\t\t}\n\t\tspan{\n\t\t\tdisplay:block;\n\t\t}\n\t}\n\t.message-sent p{\n\t\tbackground: var(--primary);\n\t\ttext-align: left;\n\t\tborder-radius:$radius;\n\t\tborder-top-right-radius: 0;\n\t\tpadding: 0.625rem 1.25rem;\n\t\tcolor: #fff;\n\t\tdisplay:inline-block;\n\t}\n\t&.style-1{\n\t\theight: 21.5rem;\n\t\t.message-received {\n\t\t\tp{\n\t\t\t\tbackground:#eeee;\n\t\t\t\tfont-size:0.875rem;\n\t\t\t}\n\t\t}\n\t\t.message-sent{\n\t\t\tp{\n\t\t\t\tbackground:var(--primary);\n\t\t\t\tfont-size:0.875rem;\n\t\t\t\tcolor:$white;\n\t\t\t}\n\t\t}\n\t}\n\t@include respond ('tab-land'){\n\t\theight: calc(100vh - 16.8rem);\n\t}\n\t@include respond ('phone'){\n\t\theight: calc(100vh - 12.8rem);\n\t}\n}\n.type-massage{\n\t//background: #f3f3f3;\n\tpadding: 0.625rem;\n\tborder-radius: $radius;\n\tborder: 1px solid $border-light;\n\t\n\t@include respond ('phone'){\n\t\tmargin-bottom:1rem;\n\t}\n\t.input-group{\n\t\ttextarea{\n\t\t\tborder: 0;\n\t\t\theight: 3.4375rem !important;\n\t\t\tresize: none;\n\t\t\tpadding: 1rem 0.9375rem;\n\t\t\tborder-bottom: none;\n\t\t\tbackground: transparent;\n\t\t\tborder-top-left-radius: 0.625rem !important; \n\t\t\tborder-bottom-left-radius: 0.625rem !important;\n\t\t\toverflow: hidden;\n\t\t\twhite-space: nowrap;\n\t\t\t&:hover,\n\t\t\t&:focus{\n\t\t\t\tbackground: transparent;\n\t\t\t}\n\t\t\t@include respond ('phone'){\n\t\t\t\theight: 2.5rem !important;\n\t\t\t\tline-height: 1.5;\n\t\t\t\tpadding: 0.4375rem 0.5rem;\n\t\t\t}\n\t\t}\n\t}\n\t.input-group{\n\t\talign-items:center;\n\t}\n\t&.style-1{\n\t\tborder: 0;\n\t\tmargin:0;\n\t\tpadding: 0.375rem;\n\t\tbackground:rgba(219, 219, 219, 0.25);\n\t\ttextarea{\n\t\t\tborder: 0;\n\t\t\theight: 2.5rem !important;\n\t\t\tresize: none;\n\t\t\tpadding: 0.0625rem 0.9375rem;\n\t\t\tbackground: transparent;\n\t\t}\n\t}\n\t.input-group-append{\n\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\t\t\n\t\t.btn{\n\t\t\ttext-align:center;\n\t\t\tmargin: 0 0.5rem;\n\t\t\t@include respond ('phone'){\n\t\t\t\theight:2.5rem;\n\t\t\t\tpadding: 0 0.625rem;\n\t\t\t\tsvg{\n\t\t\t\t\twidth: 1.125rem;\n\t\t\t\t\theight: 1.125rem;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.share-btn{\n\t\theight:2.5rem;\n\t\twidth:2.5rem;\n\t\tpadding: 0;\n\t\tbackground: var(--rgba-primary-1);\n\t\tmargin-right: 1.0625rem;\n\t\tborder-radius: $radius;\n\t\tsvg{\n\t\t\tpath{\n\t\t\t\tfill:var(--primary);\n\t\t\t}\n\t\t}\n\t\t\n\t}\n\t\n}\n\n.chat-icon{\n\tborder-bottom:0.0625rem solid #F0F0F0;\n\tpadding-bottom:1.5625rem;\n\tul{\n\t\tdisplay: flex;\n\t\tjustify-content: space-around;\n\t\tli{\n\t\t\ta{\n\t\t\t\theight:3rem;\n\t\t\t\twidth:3rem;\n\t\t\t\tbackground:#F0F0F0;\n\t\t\t\tline-height:3rem;\n\t\t\t\tdisplay:block;\n\t\t\t\tborder-radius:$radius;\n\t\t\t\ttext-align:center;\n\t\t\t\t&:hover{\n\t\t\t\t\tbackground:var(--primary);\n\t\t\t\t\tsvg{\n\t\t\t\t\t\tpath{\n\t\t\t\t\t\t\tfill:$white;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.share-files{\n\tborder-bottom:0.0625rem solid #F0F0F0;\n\tpadding-bottom: 1.125rem;\n\t&:last-child{\n\t\tborder-bottom:0;\n\t}\n\tul{\n\t\tli{\n\t\t\tdisplay:flex;\n\t\t\tjustify-content:space-between;\n\t\t\talign-items:center;\n\t\t\tpadding: 0.5625rem 0;\n\t\t\tcursor: pointer;\n\t\t\t&:first-child{\n\t\t\t\tpadding-top:0;\n\t\t\t}\n\t\t\th4{\n\t\t\t\twhite-space:nowrap;\n\t\t\t}\n\t\t\t& > div{\n\t\t\t\tflex:1;\n\t\t\t}\n\t\t}\n\t}\n}\n.file{\n\theight:2.5rem;\n\twidth:2.5rem;\n\tmin-width:2.5rem;\n\tline-height:2.4rem;\n\ttext-align:center;\n\tbackground:#F0F0F0;\n\tdisplay:block;\n\tborder-radius:$radius;\n\tsvg{\n\t\theight:1.5rem;\n\t\twidth:1.5rem;\n\t}\n\t\n\t\n}\n.share-widget{\n\theight: calc(100vh - 11.25rem);\n    overflow: hidden;\n\t@include respond ('laptop'){\n\t\tbox-shadow: 0 0 30px 5px rgba(0,0,0,.05);\n\t}\n\t@include respond ('tab-land'){\n\t\theight: calc(100vh - 9.25rem);\n\t}\n}\n\n.file-list{\n\tli{\n\t\t& > div{\n\t\t\twidth:calc(100% - 3.5rem);\n\t\t\t& > div{\n\t\t\t\twidth:calc(100% - 3rem);\n\t\t\t}\n\t\t}\n\t\th4{\n\t\t\twidth: 3.5rem;\n\t\t\ttext-align:right;\n\t\t}\n\t\t&:hover{\n\t\t\t.file{\n\t\t\t\tbackground:var(--primary);\n\t\t\t\tsvg{\n\t\t\t\t\tpath{\n\t\t\t\t\t\tfill:$white;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.fl-info{\n\t\tflex:1;\n\t\tspan{\n\t\t\tfont-size:0.8rem;\n\t\t\twhite-space: nowrap;\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n.contact-list{\n\tli{\n\t\twidth:16%;\n\t\tpadding: 0 .35rem;\n\t\timg{\n\t\t\twidth:100%;\n\t\t\tborder-radius:$radius;\n\t\t\t@include transitionMedium;\n\t\t}\n\t\t@include respond ('laptop'){\n\t\t\tpadding:0 .15rem;\n\t\t}\n\t\t&:hover{\n\n\t\t\t\timg{\n\t\t\t\t\tfilter: blur(1px);\n\t\t\t\t}\n\t\t}\n\t}\n\t\n}\n.chat-left-area{\n\t@include respond ('phone-land'){\n\t\twidth: 22rem;\n\t\tposition: absolute;\n\t\tleft: -22rem;\n\t\tz-index: 2;\n\t\t@include transitionFast;\n\t\t&.active{\n\t\t\tleft: 0rem;\n\t\t}\n\t}\n}\n.chat-right-area{\n\t.chat-rightarea-btn{\n\t\tdisplay:none;\n\t}\n\t@include respond ('laptop'){\n\t\twidth: 23rem;\n\t\tposition: absolute;\n\t\tright: -16.5rem;\n\t\t@include transitionFast;\n\t\t&.active{\n\t\t\tright: 4.2rem;\n\t\t}\n\t\t.chat-rightarea-btn{\n\t\t\tposition: absolute;\n\t\t\ttop: 7rem;\n\t\t\tleft: -1.1rem;\n\t\t\twidth: 2.2rem;\n\t\t\theight: 3rem;\n\t\t\tbackground: var(--primary);\n\t\t\tdisplay: inline-flex;\n\t\t\tcolor: #fff;\n\t\t\tfont-size: 1.2rem;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tborder-radius: .5rem 0 0 .5rem;\n\t\t\t@include transitionFast;\n\t\t\t&.active{\n\t\t\t\ti{\n\t\t\t\t\ttransform: rotateY(180deg);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t@include respond ('phone-land'){\n\t\tright: -22rem;\n\t\t&.active{\n\t\t\tright: -1.5rem;\n\t\t}\n\t}\n}\n.chat-mid-area{\n\t@include respond ('laptop'){\n\t\tflex: 1;\n\t\toverflow: hidden;\n\t}\n\t@include respond ('phone-land'){\n\t\t.chat-hamburger {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tcursor:pointer;\n\t\t\tjustify-content: center;\t\n\t\t\tline-height: 45px;\n\t\t\ttext-align: center;\n\t\t\t//background-color: #6418C3;\n\t\t\tcolor: #fff;\n\t\t\tborder-radius: 50%;\n\t\t\tposition:relative;\n\t\t\t//z-index: 5;\n\t\t\tspan {\n\t\t\t\tdisplay: block;\n\t\t\t\theight: 2px;\n\t\t\t\tmargin: 2px auto;\n\t\t\t\twidth: 20px;\n\t\t\t\tborder-radius: 3px;\n\t\t\t\tbackground-color: #000;\n\t\t\t}\n\t\t}\n\t}\n}\n\n// ---chat-content--\n.chart-content {\n    padding: 1rem;\n\t@include respond('tab-port'){\n\t\tpadding-bottom: 0;\n\t}\n\t\n\t.media {\n\t\t.dz-media{\n\t\t\twidth: 3rem;\n\t\t\theight: 3rem;\n\t\t\tborder-radius: $radius;\n\t\t\toverflow: hidden;\n\t\t\tmargin-right: 0.625rem;\n\t\t\timg{\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tobject-fit: cover;\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n.chat-toggle{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    cursor: pointer;\n    justify-content: center;\n    height:\t2.5rem;\n    width: 2.5rem;\n    line-height: 2.2rem;\n    text-align: center;\n    color: #fff;\n    border-radius: $radius;\n    position: relative;\n    display: none;\n\tmargin-right: 0.625rem;\n\tbackground-color: var(--rgba-primary-1);\n    @include respond('phone-land'){\n        display: flex;\n    }\n\tsvg{\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tg{\n\t\t\t\n\t\t\tpath{\n\t\t\t\tfill: var(--primary);\n\t\t\t}\n\t\t}\n\t}\n\t&::before{\n\t\tcontent: '';\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: -50vw;\n\t\twidth: 100vw;\n\t\theight: 100vh;\n\t}\n    span{\n        display: block;\n        height: 2px;\n        margin: 2px auto;\n        width: 20px;\n        border-radius: 3px;\n        background-color: #000;\n    }\n}\n.chat-toggle.active{\n\t&::before{\n\t\tz-index: 1;\n\t}\n}",".error-page{\n\t@include respond ('tab-port'){\n\t\ttext-align:center;\n\t\t\n\t}\n\t.error-text {\n\t\tfont-size: 150px;\n\t\tline-height: 1;\n\t\tfont-weight: 700;\n\t\tmargin-bottom: 0;\n\n\t\t@include respond('tab-port'){\n\t\t\tfont-size:130px;\n\t\t}\n\t\t\n\t\t@include respond('phone') {\n\t\t\tfont-size: 80px;\n\t\t}\n\t}\n\th4{\n\t\tfont-size: 44px;\n\t\tmargin-bottom: 0;\n\t\tline-height: 1.2;\n\t\t\n\t\t@include respond('tab-port'){\n\t\t\tfont-size:37px;\n\t\t}\n\t\t@include respond('phone-land'){\n\t\t\tfont-size:27px;\n\t\t}\n\t\t\n\t\t@include respond('phone') {\n\t\t\tfont-size: 20px;\n\t\t}\n\t}\n\tp{\n\t\tfont-size: 18px;\n\t\tcolor: #c2c2c2;\n\t\tmargin-bottom: 30px;\n\t\t@include respond('phone-land'){\n\t\t\tfont-size:1rem;\n\t\t}\n\n\t\t\n\t\t@include respond('phone') {\n\t\t\tfont-size: 14px;\n\t\t}\n\t}\n\t\n}\n.move-1 {\n  -webkit-animation: move1 5s infinite;\n  animation: move1 5s infinite; }\t\n  \n  \n@-webkit-keyframes move1 {\n  0% {\n    -webkit-transform: rotate(-1deg) translate(-2px, -2px);\n    transform: rotate(-1deg) translate(-2px, -2px); }\n  50% {\n    -webkit-transform: rotate(1deg) translate(2px, 2px);\n    transform: rotate(1deg) translate(2px, 2px); }\n  100% {\n    -webkit-transform: rotate(-1deg) translate(-2px, -2px);\n    transform: rotate(-1deg) translate(-2px, -2px); } }\n",".flex-row-fluid{\n\t-webkit-box-flex: 1;\n    flex: 1 auto;\n    -ms-flex: 1 0 0rem;\n    min-width: 0;\n}\n.page-r-logo{\n\timg{\n\t\twidth:200px;\n\t}\n}\n\n.authincation{\n\tbackground:var(--rgba-primary-1);\n\t// background:$white;\n\tdisplay:flex;\n\tmin-height: 100vh;\n\t.login-aside{\n\t\tbackground: $white;\n\t\tpadding-top: 5rem;\n\t\tmax-width:35rem;\n\t\twidth: 100%;\n\t\tz-index:1;\n\t\tposition:relative;\n\t\t&:after{\n\t\t\tcontent:\"\";\n\t\t\tclip-path: polygon(0% 100%, 100% 0%, 0% 0%);\n\t\t\twidth:8.75rem;\n\t\t\theight:100%;\n\t\t\tposition:absolute;\n\t\t\tright:-8.75rem;\n\t\t\tz-index:-1;\n\t\t\ttop:0;\n\t\t\tbackground: $white;\n\t\t\tbox-shadow: 0.125rem 0rem 1.875rem rgba(0, 0, 0,0.15);\n\t\t}\n\t\t.aside-image{\n\t\t\tmin-height:28.125rem;\n\t\t\tmargin: auto 0;\n\t\t\tmin-width: 0;\n\t\t\tbackground-size: contain;\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-position: center;\n\t\t}\n\t}\n\t@include respond ('laptop'){\n\t\t.login-aside{\n\t\t\tmax-width:22.5rem;\n\t\t}\n\t}\n\t@include respond ('tab-port'){\n\t\t.login-aside{\n\t\t\tmax-width:100%;\n\t\t\tpadding-top: 0;\n\t\t\t&:after{\n\t\t\t\tcontent:none;\n\t\t\t}\n\t\t}\n\t}\n\t@include respond ('phone'){\n\t\t.login-aside{\n\t\t\t.aside-image{\n\t\t\t\tmin-height:18.75rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.authincation-content{\n    background: $white;\n    box-shadow: 0 0 2.1875rem 0 rgba(154, 161, 171, 0.15);\n    border-radius: 0.3125rem;\n    @at-root [data-theme-version=\"dark\"] & {\n        background: $dark-card;\n        box-shadow: none;\n    }\n\t&.style-1{\n\t\tbackground:rgba($white,0.5);\n\t\tbackdrop-filter:blur(1.25rem);\n\t\t.form-control{\n\t\t\tbackground:rgba($white,0.6);\n\t\t\tborder-radius:0.3125rem;\n\t\t}\n\t\t.user-icon{\n\t\t\theight: 6.25rem;\n\t\t\tbackground:var(--primary);\n\t\t\twidth: 6.25rem;\n\t\t\ttext-align:center;\n\t\t\tborder-radius: 6.25rem;\n\t\t\tline-height: 6.25rem;\n\t\t\tmargin-left: auto;\n\t\t\tfont-size: 3.75rem;\n\t\t\ttext-align: center;\n\t\t\tcolor: white;\n\t\t\tmargin-right: auto;\n\t\t\tmargin-top: -6.25rem;\n\t\t\tmargin-bottom: 1.25rem;\n\t\t}\n\t}\n\t&.style-2{\n\t\tbackground:transparent;\n\t\tbox-shadow:none;\n\t\tmax-width: 33.125rem;\n\t\twidth: 100%;\n\t\t.form-control{\n\t\t\tborder:0;\n\t\t\tborder-radius:0.3125rem;\n\t\t\tbox-shadow:0rem 0rem 0.9375rem rgba(0,0,0,0.08);\n\t\t}\n\t\t@include respond ('phone'){\n\t\t\t.auth-form{\n\t\t\t\tpadding: 1.875rem 0rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.welcome-content{\n    background: url('./../images/1.jpg');\n    background-size: cover;\n    background-position: center;\n    height: 100%;\n    padding: 4.6875rem 3.125rem;\n    position: relative;\n    z-index: 1;\n    border-top-left-radius: 0.3125rem;\n    border-bottom-left-radius: 0.3125rem;\n    &::after{\n        content: '';\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        background: var(--primary);\n        opacity: 0.75;\n        z-index: -1;\n        border-top-left-radius: 0.3125rem;\n        border-bottom-left-radius: 0.3125rem;\n    }\n    .welcome-title{\n        color: $white;\n        font-weight: 500;\n        font-size: 1.25rem;\n    }\n    p{\n        color: $white;\n    }\n\n    .brand-logo{\n        a{\n            display: inline-block;\n            margin-bottom: 1.25rem;\n            font-weight: 700;\n            color: $white;\n            font-size: 1.25rem;\n        img{\n            width: 6.25rem;\n        }\n        }\n    }\n\n    .intro-social{\n        position: absolute;\n        bottom: 4.6875rem;\n        ul{\n            margin-bottom: 0;\n            li{\n                display: inline-block;\n                a{\n                    color: $white;\n                    font-size: 0.875rem;\n                    padding: 0rem 0.4375rem;\n                }\n            }\n        }\n    }\n}\n\n.auth-form{\n    padding: 3.125rem 3.125rem;\n\t@include respond('phone') {\n\t\tpadding: 1.875rem;\n\t}\t\n    .btn{\n        height: 3.125rem;\n        font-weight: 700;\n    }\n    .page-back{\n        display: inline-block;\n        margin-bottom: 0.9375rem;\n    }\n}\n\n\n.slideskew {\n    animation: 5s ease 0s normal none infinite running slideskew;\n}\n\n@keyframes slideskew {\n\t0% {\n\t\ttransform:translateY(0px);\n\t\topacity: 1; \n\t}\n\t50% {\n\t\ttransform:translateY(20px); \n\t\t-moz-transform:translateY(20px); \n\t\t-webkit-transform:translateY(20px); \n\t\t-ms-transform:translateY(20px); \n\t\t-o-transform:translateY(20px); \n\t} \n\t100% {\n\t\ttransform:translateY(0); \n\t\t-moz-transform:translateY(0); \n\t\t-webkit-transform:translateY(0); \n\t\t-ms-transform:translateY(0); \n\t\t-o-transform:translateY(0); \n\t} \n}\n\n\n.sign-bg{\n\tbackground-size: cover;\n    background-position: center;\n    position: relative;\n\tz-index: 1;\n\t&:after{\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 0;\n\t\twidth: 100%;\n\t\tbackground: #dbe9f3;\n\t\topacity: 0.5;\n\t\theight: 100%;\n\t\tz-index: -1;\n\t}\n\t.bitcoin-img{\n\t\twidth: 70%;\n\t}\n}\n.sign-in-your{\n\tpadding: 10vh 0;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tmax-width: 350px;\n\n\t@include respond('phone-land') {\n\t\tpadding: 5vh 0;\n\t}\n}\n\n\n\n\n","\n// -------------------------\n//     Dashboard\n// -------------------------\n\n.heading{\n    font-size: 1.125rem;\n    font-weight: 600;\n\tline-height: 1.5;\n    //margin: 7.5px 0;\n    \n    @include respond ('laptop'){\n\t\tfont-size:1rem;\n    }\n}\n.heading-lg{\n    font-size: 1.5rem;\n   \n}\n\n.subtitle{\n    font-size: 2.25rem;\n}\n.default-select {\n    .dropdown-toggle::after {\n        display: inline-block;\n        margin-left: 0;\n        vertical-align: unset;\n        content: \"\";\n        width: 0.5rem;\n        height: 0.5rem;\n        border-top: 2px solid #666;\n        border-right: 2px solid #666;\n        transform: rotate(135deg);\n        border-bottom: none;\n        border-left: none;\n        margin: 0;\n        padding: 0;\n        margin-bottom: 0.25rem;\n    }\n}\n.default-select.dropup  .dropdown-toggle::after {\n    transform: rotate(-45deg);\n    margin-bottom: 0;\n}\n.bootstrap-datetimepicker-widget{\n\t\t.datepicker{\n\t\t\tpadding:20px;\n\t\t\toverflow: hidden;\n\t\t\tborder-radius: $radius;\n\t\t\n\t   .datepicker-days{\n\t\t.table-condensed{\n\t\t\tthead{\n\t\t\t\tth{\n\t\t\t\t\tbackground-color: transparent;\n\t\t\t\t\tpadding: 10px 5px;\n\t\t\t\t\t&.prev, &.picker-switch, &.next{\n\t\t\t\t\t\tcolor: $main-color;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\ttd.day{\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\tpadding: 0;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tcolor: $main-color;\n\t\t\t\twidth: 55px;\n\t\t\t\theight: 55px;\n\t\t\t\tline-height: 40px;\n\t\t\t\tborder-radius: 0.625rem;\n\t\t\t\t//border: 1px solid var(--rgba-primary-1);\n\t\t\t}\n\t\t\ttr{\n\t\t\t\ttd{\n\t\t\t\t\tbackground-color: transparent!important;\n\t\t\t\t\tbackground-image: none!important;\n\t\t\t\t\ttext-shadow: none!important;\n\t\t\t\t\tbox-shadow: none;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tz-index: 1;\n\t\t\t\t\t\n\t\t\t\t\t&:before{\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\tposition:absolute;\n\t\t\t\t\t\tz-index:-1;\n\t\t\t\t\t\theight:30px;\n\t\t\t\t\t\twidth:30px;\n\t\t\t\t\t\tborder-radius:25px;\n\t\t\t\t\t\ttop:50%;\n\t\t\t\t\t\tleft:50%;\n\t\t\t\t\t\tbackground-color: $primary;\n\t\t\t\t\t\ttransform:translate(-50%,-50%);\n\t\t\t\t\t\tborder:0;\n\t\t\t\t\t\topacity: 0;\n\t\t\t\t\t}\n\t\t\t\t\t&.today{\n\t\t\t\t\t\t&:hover{\n\t\t\t\t\t\t\tbackground-color: #fff;\n\t\t\t\t\t\t\tbox-shadow: none;\n\t\t\t\t\t\t\tcolor: #fff !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.today,\n\t\t\t\t\t&.active{\n\t\t\t\t\t\tcolor: #fff;\n\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&.active{\n\t\t\t\t\t\t&:before{\n\t\t\t\t\t\t\tbackground-color: $secondary;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\tth {\n\t\t\t\tfont-size: 15px;\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\t\t\ttd.day.active.today{\n\t\t\t\t&:hover{\n\t\t\t\t\tborder-bottom:transparent;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t\n\t}\n\t}\n}\n.datepicker{\n\tpadding:15px;\n\tth{\n\t\tpadding:10px;\n\t}\n}\n\n\n\n.table-condensed {\n    width: 100%;\n}\n\n\n.picker-switch{\n\t\t\n\t&.accordion-toggle{\n\t\t\t.table-condensed{\n\t\t\t\ttd{\n\t\t\t\t\tdisplay:none;\n\t\t\t\t}\n\t\t\t}\n\t}\n}\t\n\n// --------.card-box-------\n\n.card{\n    .card-box-icon {\n        width:  4.5rem;\n        height: 4.5rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border: 1px solid #EEEEEE;\n        border-radius: $radius;\n\t\tmargin-right: 0.938rem;\n    }\n    .chart-num{\n        h2{\n            font-size: 1.5rem;\n            margin-bottom: 0;\n            line-height: 1;\n        }\n        p{\n            font-size: 0.963rem;\n            margin-bottom: 0.313rem;\n\t\t\tline-height:1rem;\n        }\n    }\n}\n.counter{\n    .chart-num{\n\t\tmargin-bottom: 0.675rem;\n    }\n\t.card-body{\n\t\tpadding: 2.813rem 0 2.813rem 2.813rem;\n\t\t.card-box-icon{\n\t\t\tmargin-right:1.25rem;\n\t\t}\n\t}\n}\n\n\n// ---chackbox-----\n.round {\n    margin-right: 1.5rem;\n    position: relative;\n    padding-left: 2.2rem;\n    cursor: pointer;\n    font-size: 0.875rem;\n    user-select: none;\n    @include respond ('laptop'){\n        padding-left: 1.8rem;\n\n    }\n    input{\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 1.25rem;\n        width: 6.25rem;\n        background-color: $bg-color;\n        opacity: 0;\n      }\n    span{\n        color: $main-color;\n    }\n    .checkmark {\n        position: absolute;\n\t\ttop: 0;\n\t\tleft: 20%;\n\t\ttransform: translate(-50% , 50%);\n        height: 0.75rem;\n        width: 0.75rem;\n        background-color: $bg-color;\n        border-radius: 50%;\n        border: 3px solid var(--secondary);\n        padding: 2px;\n        margin: 0;\n      }\n      .checkmark2 {\n        position: absolute;\n        top: 50%;\n        left: 0;\n        transform: translateY(-50%);\n        height: 1.35rem;\n        width: 1.35rem;\n        background-color: $bg-color;\n        border-radius: 50%;\n        border: 2px solid var(--primary);\n        padding: 0.2rem;\n      }\n      \n}\n.round.weekly{\n    .checkmark {\n        border: 3px solid var(--primary);\n    }\n}\n  .round:hover input ~ .checkmark {\n    background-color: $bg-color;\n  }\n  \n  .round input:checked ~ .checkmark {\n    background-color: $bg-color;\n    border: 2px solid $warning;\n  }\n  .round.weekly input:checked ~ .checkmark {\n    background-color: $bg-color;\n    border: 2px solid var(--secondary);\n  }\n  \n  .checkmark:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n  }\n  \n\n  .round input:checked ~ .checkmark:after {\n    display: block;\n  }\n  .round.weekly input:checked ~ .checkmark:after {\n    display: block;\n    background-color:var(--secondary) ;\n  }\n  .round .checkmark:after {\n    width: 100%;\n    height: 100%;\n    background-color: $warning;\n    border-radius: 50%;\n    position: relative;\n  }\n  .round.disabled {\n    opacity: 1;\n}\n  \n// ------chack---\n.toggle-btn {\n    margin-right: 1.8rem;\n    position: relative;\n    padding-left: 2rem;\n    cursor: pointer;\n    font-size: 0.875rem;\n    user-select: none;\n    input{\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 1.25rem;\n        width: 6.25rem;\n        background-color: $bg-color;\n        opacity: 0;\n      }\n    span{\n        color: $bg-color;\n    }\n    h4{\n        color: $bg-color;\n    }\n    .check {\n        position: absolute;\n        top: 50%;\n        left: 0;\n        transform: translateY(-50%);\n        height: 22px;\n        width: 22px;\n        background-color: var(--primary);\n        border-radius: 50%;\n        border: 3px solid $white;\n        padding:2px;\n      }\n      \n}\n\n  .toggle-btn input:checked ~ .check {\n    background-color: var(--primary);\n    border: 3px solid $white;\n  }\n  \n  .check:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n  }\n  \n\n  .toggle-btn input:checked ~ .check:after {\n    display: block;\n  }\n  .toggle-btn .check:after {\n    width: 82%;\n    height: 82%;\n    background-color: $white;\n    border-radius: 50%;\n\ttop: 1px;\n    left: 1px;\n    position: relative;\n  }\n  .toggle-btn.expense{\n        .check {\n            border: 3px solid $yellow;\n        }\n    } \n\n  .toggle-btn.expense input:checked ~ .check{\n    background-color: var(--primary);\n    border: 3px solid $yellow;\n  }\n  .toggle-btn.expense .check:after{\n    background-color: $yellow;\n  }\n\n// ------porgrass-bar---\n  \n  .progressbar{\n      box-shadow: none;\n  \n}\n.expense{\n\t.students1{\n\t\tpadding: 0 10px;\n\t}\n}\n// ------contact--\n#wallet-bar {\n    background-color:$bg-color;\n\tz-index:3;\n\t@include respond ('laptop'){\n\t\tz-index:4;\n\t\t\n\t}\n\t\n\t@include respond ('tab-land'){\n\t\tz-index:8;\n\t}\n\t@include respond ('phone'){\n\t\tz-index:8;\n\t}\n\t&.dlab-scroll{\n\t\toverflow-y:scroll;\n\t}\n\t@include custommq($max:105rem){\n\t\t//display:none;\n\t}\n}\n\n.student{\n\tposition:relative;\n\tmargin: 0;\n    z-index: 1;\n    padding: 0.925rem 0;\n    .dz-media{\n        margin-right: 0.938rem;\n    }\n    .user-info{\n        .name{\n            font-size: 0.875rem;\n            font-weight: 600;\n            margin-bottom: 0.2rem;\n        }\n    }\n    \n    .indox {\n        margin-left: auto;\n        \n    }\n\t\n\t&:hover{\n\t\t.indox{\n\t\t\ta{\n            background-color: var(--rgba-primary-1);\n\t\t\t\tsvg{\n\t\t\t\t\tpath{\n\t\t\t\t\t\tfill: var(--primary);\n\t\t\t\t\t}\n\t\t\t\t}\n                  \n                &::before{\n                    background-color: var(--primary);\n                }\n            \n\t\t\t}\n\t\t}\n\t}\n}\n\na.btn.dlab-load-more{\n    padding: 0.69375rem 1.5rem;\n    font-weight: 500;\n}\n\n\n\n.wallet-bar{\n\t.wallet-bar-header{\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\tpadding: 0px 1.125rem;\n\t}\n} \n\n\n.p-static{\n\t@include respond ('phone'){\n\t\tdisplay:none;\n\t}\n}\n\n.mail-img{\n    position: absolute;\n    bottom: 0%;\n    right: 0; \n}\n\n// ---------user---reviews---\n.user_reviews {\n    padding: 1.125rem 0;\n    @include respond(\"tab-land\"){\n        padding: 1.125rem 0;\n    }\n}\n\n\n// ***************************\n// -------bootstrap-page-----\n// ***************************\n\n.element-area{\n    display: flex;\n    .demo-view{\n        width: calc(100% - 270px);\n\t\t@include custommq($max:100rem){\n\t\t\twidth: calc(100% - 236px);\n\t\t}\t\n        @include respond(\"tab-land\"){\n            width: calc(100% - 224px)\n        }\n        @include respond('tab-port'){\n            width: 100%;\n        }\n        @include respond ('phone-land') {\n\t\t\twidth: 100%;\n\t\t\t.container-sm{\n\t\t\t\tpadding:0;\n\t\t\t}\n\t\t}   \n\t\t\n    }\n    .demo-right{\n        width:16.875rem;\n        position: sticky;\n        top: 7rem;\n        height: calc(100% - 140px);\n        z-index: 1;\n        @include respond(\"tab-land\"){\n            width: 15.875rem;\n        }\n        @include respond('tab-port'){\n          display: none;\n        }\n        @include respond('phone-land') {\n            display: none;    \n        }\n       \n    }\n    .demo-right.sticky{\n        top: 100px;\n        transition: 0.5s;\n    }\n}\n\n.demo-right-inner {\n    padding: 1rem 2.225rem;\n    background-color: $white;\n    border-radius: $radius;\n    height: 100%;\n    overflow: hidden;\n    h4{\n        padding: 0.625rem 0;\n    }\n    li{\n        font-size: 0.9rem;\n        a{\n            display: block;\n            padding: 0.375rem 0.250rem;\n        }\n    }\n}\n.fc .fc-toolbar.fc-header-toolbar {\n    flex-wrap: wrap;\n\tmargin-bottom:0;\n   \n}\n.fc .fc-button-group{\n    margin-bottom: 0.625rem;\n    z-index: 0  ;\n}\n\n\n/* work */\n\n.food{\n\tmargin-bottom: 25px;\n\t.dz-media{\n\t\timg{ \n\t\t\tborder-radius: $radius-sm;\n\t\t\twidth: 100%;\n\t\t\theight: 160px;\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\t}\n}\n.doller{\n\tcolor: $main-color;\n}\n.trans-list{\n\tdisplay: flex;\n\talign-items: center;\n\th4{\n\t\tmargin-bottom: 0;\n\t\tfont-size:14px;\n\t}\n}\n\n.table-pagenation{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-top: 0.625rem;\n\tpadding: 0 25px;\n\t\n    p{\n        margin-left: 0.475rem;\n\t\tspan{\n\t\t\tcolor:var(--primary)!important;\n            margin: 0 0.2rem;\n\t\t}\n    }\n    .pagination .page-item.page-indicator .page-link {\n        background-color: transparent;\n        color: $body-text;\n        &:hover{\n            background-color:var(--primary);\n        }\n    }\n\t.pagination.no-bg li:not(.page-indicator):not(.active) .page-link {\n        border: 1px solid var(--primary);\n\t}\n\t/* .page-link {\n\t\tbackground: #fff;\n\t\tborder-color: transparent;\n\t} */\n}\n// Heart Blast\n.heart {\n    width: 60px;\n    height: 60px;\n    display: inline-block;\n    background: url('../images/like.png');\n    cursor: pointer;\n    margin: -25px -15px;\n}\n.heart-blast {\n    background-position: -1680px 0;\n    transition: background 1s steps(28);\n}\n/* date picker */\n\t.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn) {\n\t\twidth: 207px;\n\t\t\n\t\t\n\t}\n\t.bs-select{\n\t\t&.border-transparent{\n\t\t\t.btn {\n\t\t\t\tborder-color: transparent;\n\t\t\t\tcolor: $main-color;\n\t\t\t}\n\t\t}\n\t}\n\t\n/* date picker */\ntr{\n\t.trans-td-list {\n\t\tfont-size: 18px;\n\t}\n}\n/* custom css */\n\n.avatar{\n\twidth: 3rem;\n\theight: 3rem;\n\tobject-fit: cover;\n\tborder-radius: 100%;\n\tposition: relative;\n\tdisplay: inline-block;\n\t&.avatar-lg{\n\t\twidth:3.75rem;\n\t\theight: 3.75rem;\n\t\t@include respond ('laptop'){\n\t\t\twidth:2.95rem;\n\t\t\theight:2.95rem;\n\t\t}\n\t}\n\t&.avatar-xl{\n\t\twidth: 7.5rem;\n\t\theight: 7.5rem;\n\t\t\n\t\t@include respond ('tab-land'){\n\t\t\twidth:5rem;\n\t\t\theight:5rem;\n\t\t\t\n\t\t}\n\t}\n\t&.avatar-xxl{\n\t\twidth: 9.375rem;\n\t\theight: 9.375rem;\n\t\t\n\t\t@include respond ('phone'){\n\t\t\twidth:7.375rem;\n\t\t\theight:7.375rem;\n\t\t}\n\t}\n\t&.avatar-sm{\n\t\twidth:30px;\n\t\theight:30px;\n\t}\n}\n\n.icon-box{\n\twidth: 48px;\n\theight: 48px;\n\tline-height: 45px;\n\ttext-align: center;\n\tposition: relative;\n\tdisplay: inline-block;\n\tborder-radius: 100%;\n\t@include transitionSlow;\n\tsvg{\n\t\twidth: 1.188rem;\n\t}\n\ti{\n\t\ttransform: scale(2); \n\t}\n\t&.icon-box-sm{\n\t\theight: 2.5rem;\n\t\twidth: 2.5rem;\n\t\tline-height: 2.5rem;\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n\t&.icon-box-xs{\n\t\twidth:2.188rem;\n\t\theight:2.188rem;\n\t\tline-height:2.188rem;\n\t\t\n\n\t}\n\t&.icon-box-lg{\n\t\theight: 3.75rem;\n\t\twidth: 3.75rem;\n\t\tline-height: 3.625rem;\n        min-width:3.75rem; \n\n        @include respond ('laptop'){\n            width:3.125rem;\n            height:3.125rem;\n            line-height:2.938rem;\n            min-width:3.125rem;\n\n        }\n\t}\n\t&.icon-box-xl{\n\t\theight: 3.75rem;\n\t\twidth: 3.75rem;\n\t\tline-height: 3.75rem;\n\t}\n\t\n}\n.st-box{\n\tborder: 2px solid #A098AE;\n}\n\n\n\n/* new scss */\n\n.content-box{\n\tdisplay:flex;\n\talign-items:center;\n    @include respond ('tab-land'){\n        margin-bottom:15px;\n\n    }\n\t.std-data{\n\t\tbackground-color:var(--primary);\n\t}\n\t.teach-data {\n\t\tbackground-color:var(--secondary);\n\t}\n\t.event-data{\n\t\tbackground-color:#fcc43e;\n\t}\n\t.food-data{\n\t\tbackground-color:#303972;\n\t}\n\t.std-data,\n\t.teach-data,\n\t.event-data,\n\t.food-data{\n\t\tmargin-right:10px;\n\t}\t\n}\n.table{\n\t&.short-one{\n\t\tthead{\n\t\t\tth{\n\t\t\t\tcolor:$dark;\n\t\t\t}\n\t\t}\n\t\ttbody{\n\t\t\ttext-align: center;\n\t\t\tfont-size: 1rem;\n\t\t\tfont-weight: 500;\n\t\t}\n\t}\n}\n.student{\n\t&.border-bottom{\n\t\tborder-bottom:1px solid var#b3b1cb!important;\n\t}\n}\n.name{\n\t\tmargin-bottom:4px;\n}\n.modal-dialog-center{\n\t    min-height: calc(100% - 3.5rem);\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n}\n .table-responsive{\n\t&.full-data{\n\t\tthead{\n\t\t\tth{\n\t\t\t\t&:first-child{\n\t\t\t\t\tpadding-left:21px;\n\t\t\t\t\tpadding-right:0;\n\t\t\t\t}\n\t\t\t\tborder-bottom:0;\n\t\t\t}\n\t\t}\n\t\ttd{\n\t\t\t&:first-child{\n\t\t\t\tpadding-right:0;\n\t\t\t}\n\t\t}\n\t\ttbody{\n\t\t\th6{\n\t\t\t\tfont-size:0.875rem;\n\t\t\t\tfont-weight:500;\n\t\t\t}\n\t\t\t.icon-box-sm{\n\t\t\t\twidth:2.188rem;\n\t\t\t\theight:2.188rem;\n\t\t\t\tline-height:2.188rem;\n\t\t\t\tcursor: pointer;\n\t\t\t\t\n\t\t\t\tsvg{\n\t\t\t\t\twidth:1rem;\n\t\t\t\t\theight:1rem;\n\t\t\t\t}\n\t\t\t\n\t\t\t}\t\n\t\t\t.avatar{\n\t\t\t\twidth:2.188rem;\n\t\t\t\theight:2.188rem;\n\t\t\t}\n\t\t\t.sharp{\n\t\t\t\twidth:1.25rem;\n\t\t\t\theight:1.25rem;\n\t\t\t}\n\t\t}\n\t\t.table > :not(:first-child){\n\t\t\tborder-top:0;\n\t\t}\n\t}\n}\n.table-responsive{\n\t.order-table{\n\t\tth,td{\n\t\t\t&:first-child{\n\t\t\t\tpadding-right:0;\n\t\t\t}\n\t\t}\n\t}\n\t.table-striped{\n\t\tth{\n\t\t\tbackground-color:$white;\n\t\t\tcolor:$dark;\n\t\t\tfont-weight:600;\n\t\t}\n\t}\n}\n\n/* user */\n\n\n\n.bell-icon{\t\n    .nav-link{\n        position: relative;\n            &:before{\n                position: absolute;\n                content: \"\";\n                background-color: var(--primary);\n                width: 7px;\n                height: 7px;\n                border-radius: 100%;\n                top: 10px;\n                right: 15px;\n                animation: blinking 1s infinite;\n\n                @include custommq ($max:106.25rem){\n                    top:8px;\n                    right:12px;\n\n                }\n                @include respond ('phone'){\n                    width:5px;\n                    height:5px;\n                    top:5px;\n                    right:8px;\n\n                }\n            }\n    }\n}\n.dd-item{\n    cursor: all-scroll;\n}\n.sweet-image{\n\n    width:20%;\n}\n.clockpicker-popover{\n\n    position:absolute;\n    border-radius:$radius;\n\tborder-color:transparent;\n}\n.demo-right-inner{   \n\tli{\n\t\tposition: relative;\n\t\t&.active{\n\t\t\ta{\n\t\t\t\tcolor:var(--primary);\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\t\t\t&:after{\n\t\t\t\tbackground-color:var(--primary);\n\t\t\t}\n\t\t}\n\t\t\n\t\t.scroll{\n\t\t\t&:after{\n\t\t\t\tposition: absolute;\n\t\t\t\tcontent: \"\";\n\t\t\t\tbackground-color:$light;\n\t\t\t\theight:5px;\n\t\t\t\twidth: 5px;\n\t\t\t\tborder-radius: 100%;\n\t\t\t\ttop:15px;\n\t\t\t\tleft:-17px;\t\t\t\n\t\t\t\t@include respond ('laptop'){\n\t\t\t\t\ttop:12px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&.active{\n\t\t\t\tcolor:var(--primary);\n\t\t\t\tfont-weight:500;\t\n\t\t\t\t&:after{\n\t\t\t\t\tbackground-color:var(--primary);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n}\n    \n.page-title{\n\t\t.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn){\n\t\t\twidth:7.688rem;\n\t\t}\n}\n\n.all{\n\t.dropdown-menu{\n\t\tborder-radius:$radius;\n\t\t\n\t\t.nav-link{\n\t\t\twidth:2.5rem;\n\t\tmin-width:2.5rem;\n\t\theight:2.5rem;\n\t\tmargin-right: 0.313rem;\n\t\t\n\n\t}\n\n\t\t\n\t}\n\t.svg-main-icon{\n\t\tpath{\n\t\t\tfill:#A098AE;\n\t\t}\n\t}\n\t\n\n\t\n\tdisplay:none!important;\n\t\n\t@include respond ('tab-land'){\n\t\tdisplay:inline-flex!important;\n\t\t.dropdown-menu {\n\t\t\t&.show {\n\t\t\t\theight:auto;\n\t\t\t\twidth:8.75rem;\n\t\t\t\tmin-width:11.15rem;\n\n\t\t\t\tsvg{\n\n\t\t\t\t\twidth:1rem;\n\t\t\t\t\theight:1rem;\n\t\t\t\t}\n\t\t\t\t@include respond ('phone-land'){\n\t\t\t\t\tright: 13.6rem;\n\t\t\t\t\ttop: 4.85rem;\n\t\t\t\t}\n\t\t\t\t@include respond ('phone'){\n\t\t\t\t\tright: 7.9rem;\n\t\t\t\t\ttop: 4.85rem;\n\t\t\t\t}\n\n\t\n\t\t\t}\n\t\t}\n\t}\n\t@include respond('phone'){\n\n\t\ttop:77px;\n\t\tborder-radius:0;\n\t}\n\t.menu-wallet,\n\t.dz-theme-mode,\n\t.dz-fullscreen{\n\t\t@include respond ('tab-land'){\n\t\t\tdisplay:inline-flex!important;\n\t\t}\n\t}\n    .card-header{\n\t\tborder-radius:$radius!important;\n\t\tbackground-color:var(--rgba-primary-1);\n      \n\n    }\n\t\n\t\n   \n}\n\n.menu-wallet,\n.dz-theme-mode,\n.dz-fullscreen{\n\t@include respond ('tab-land'){\n\t\tdisplay:none!important;\n\t}\n}\n.order-table{\n    thead{\n\n        th{\n\n            color:$white;   \n        }\n    }\n\n}\n     \n    @keyframes blinking {\n        0% {\n          background-color:var(--primary);\n\n        }\n        100% {\n          background-color:transparent;\n\n        }\n    }\n.search-area-header{\n\tul{\n\n\t\tli{\n\n\t\t\ti{\n\n\t\t\t\tcursor: pointer;\n\t\t\t}\n\t\t}\n\t}\n\n}\n      \n    \n.page-title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\tpadding: 1rem 1.25rem;\n\tmargin-bottom: 1.875rem;\n\tborder-radius: $radius;\n\tposition:relative;\n\tz-index:1;\n\tbackground-color:$white;\n\t.search-area{\n\t\twidth: 21.875rem;\n\t\tflex-direction: row-reverse;\n\t\tborder: 1px solid transparent;\n\t\toverflow: hidden;\n\t\tborder-radius:$radius;\n\t\tbox-sizing: border-box;\n\t\tborder:1px solid $border-color;\n   \t\theight: 3rem;\n\t\t\n\t\t.form-control{\n\t\t\tborder-right:0;\n\t\t\tborder: none;\n\t\t\tpadding: 0rem;\n\t\t\tborder-radius:0 $radius $radius 0; \n\t\t\tpadding-left: 0.2rem;\n\t\t\theight: 3rem;\n\t\t\tline-height: 3rem;\n\t\t\t&:focus{\n\t\t\t\tborder-color:white;\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\t\t}\n\t\t.input-group-text{\n\t\t\tbackground:$white;\n\t\t\tborder: none;\n\t\t\tpadding-right: 20px;\n\t\t\theight: 3rem;\n\t\t\tborder-radius:$radius 0 0 $radius; \n\t\t\tsvg{\n\t\t\t\ttransform: scale(1.2);\n\t\t\t\tpath{\n\t\t\t\t\tfill:var(--primary);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t\t\n\t}\n}\n\n.box-1 {\n\t\toverflow: hidden;\n\t.max {\n\t\tposition: relative;\n\t\tbackground-size: cover;\n \t   \tbackground-repeat: no-repeat;\n\t\tpadding: 30px;\n\t\toverflow: hidden;\n\t\t.item {\n\t\t\tposition: absolute;\n\t\t\tbottom: 25px;\n\t\t\t.text{\n\t\t\t\tcolor: white;\n\t\t\t\tmargin-bottom: 20px;\n\t\t\t}\n\t\t}\n\t\t.dropdown {\n\t\t\tposition: absolute;\n\t\t\tright: 25px;\n\t\t}\n\t}\n\t.max-2 {\n\t\tpadding: 30px;\n\t\t.ul-li {\n\t\t\tmargin-bottom: 20px;\n\t\t\tul {\n\t\t\t\tli {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\ta {\n\t\t\tfont-size: 18px;\n\t\t\twidth: 100%;\n\t\t\tmargin-top: 1.625rem;\n\t\t}\n\t}\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show{\n\t&:active{\n\t\tborder-color:transparent;\n\t}\n}\n\n\n  .search-area{\n\t\twidth: 25rem;\n\t\tflex-direction: row-reverse;\n\t\tborder: 1px solid $b-color;\n\t\toverflow: hidden;\n\t\tborder-radius:$radius;\n\t\tbox-sizing: border-box;\n   \t\theight: 3rem;\n\t\t@include custommq($max:117.5rem){\n\t\t\twidth: 22rem;\n\t\t}\n\t\t@include custommq($max:81.25rem){\n\t\t\twidth: 17.5rem;\n\t\t}\n\t\t@include respond ('tab-land'){\n\t\t\twidth:\t15.625rem;\n\t\t}\n\t\t@include custommq ($max:68.75rem){\n\t\t\t//display:none;\n\t\t}\n\t\t.form-control{\n\t\t\tfont-size:15px;\n\t\t\tborder-right:0;\n\t\t\tborder: none;\n\t\t\tpadding: 0rem;\n\t\t\tborder-radius:0 $radius $radius 0; \n\t\t\tpadding-left: 0.2rem;\n\t\t\theight: 3rem;\n\t\t\t&:focus{\n\t\t\t\tborder-color:white;\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\t\t}\n\t\t.input-group-text{\n\t\t\tbackground:$white;\n\t\t\tborder: none;\n\t\t\t//padding-right: 0;\n\t\t\theight: 3rem;\n\t\t\tborder-radius:$radius 0 0 $radius; \n\t\t\tsvg{\n\t\t\t\ttransform: scale(1.2);\n\t\t\t\tpath{\n\t\t\t\t\tfill:var(--primary);\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t}\n\n.nav-link{\n\t&.menu-wallet{\n\t\t&.main{\n\t\t\tbackground-color:var(--rgba-primary-1);\n\t\t\t\n\t\t\tsvg{\n\n\t\t\t\tpath{\n\t\t\t\t\tfill:$white;\n\n\t\t\t\t\tstroke:$white;\n\t\t\t\t}\n\t\t\t}\n\n\t\t}\n\n\t} \n\n} \n\n.card{\n\t&.Custom-select{\n\t\t.input-group-text{\n\t\t\t@include respond ('phone'){\n\t\t\t\tpadding:0.4875rem 1.25rem;\n\n\t\t\t}\n\t\t\t\n\t\t}\n\t}\n}\n\n.table{\n\t&.table-details{\n\t\ttbody{\n\t\t\ttd{\n\t\t\t\t&:first-child{\n\t\t\t\t\tpadding-left:0;\n\t\t\t\t}\n\t\t\t}\n\t\t\ttr{\n\t\t\t\t&:last-child{\n\t\t\t\t\ttd{\n\t\t\t\t\t\tborder:0;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n .table-responsive{\n\t&.basic-tbl{\n\t\t\n\t\tthead{\n\t\t\tth{\n\t\t\t\t//&:first-child{\n\t\t\t\t\t//padding-left:18px;\n\t\t\t\t//}\n\t\t\t\t&:last-child{\n\t\t\t\t\ttext-align:end;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t\ttd{\n\t\t\t&:last-child{\n\t\t\t\ttext-align:end;\n\t\t\t}\n\t\t\t//&:first-child{\n\t\t\t\t//padding-left:18px;\n\t\t\t//}\n\t\t}\n\t}\n\t\t\n}\n.table-responsive{\n\t\t&.basic-tbl{\n\t\t\t.dataTables_info{\n\t\t\t\tpadding-top: 18px;\n\t\t\t\tcolor:$body-color;\n\t\t\t\tpadding-left:25px;\n\t\t\t}\n\t\t\t.dataTables_wrapper .dataTables_paginate{\n\t\t\t\tpadding-right:9px;\n\t\t\t}\n\t\t\t\n\t\t}\n} \n.student{\n\tcursor:pointer;\n\t&:hover{\n\t\ta{\n\t\t\tcolor:var(--primary);\n\t\t}\n\t\t.st-box{\n\t\t\tbackground-color: var(--primary);\n\t\t\tborder-color: var(--primary);\n\t\t\t\n\t\t\tsvg{\n\t\t\t\tpath{\n\t\t\t\t\tfill:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.gallery-media{\n\theight:150px;\n\tobject-fit:cover;\n\tobject-position:top;\n\t\n\t&.style-1{\n\t\theight:300px;\n\t}\n}\n\n.table-clear{\n\tbackground-color:#f2f2f2;\n\ttbody tr td{\n\t\tborder-color:#c2c2c2;\n\t}\n\t\n}\n.table{\n\t &.table-invoice{\n\t\tmargin-bottom:0;\n\t\t tbody tr:last-child td{\n\t\t\tborder-bottom:1px solid $border;\n\t\t}\n\t}\n\t\n\n}\n\n//// calender\n.dz-calender{\n\tposition:relative;\n\tz-index: 1;\t\n\t.react-datepicker__day-names, .react-datepicker__week{\n\t\tdisplay: flex;\n\t}\n\t.react-datepicker{\n\t\tborder: unset;\n\t\twidth: 100%;\n\t\tbackground-color: transparent;\n\t\n\t\t&__header{\n\t\t\tborder: unset;\n\t\t\tbackground-color: transparent;\n\t\t\t.react-datepicker__day-names{\n\t\t\t\tcolor: var(--secondary);\n\t\t\t\tmargin-bottom: -15px;\n\t\t\t\t// background: #F0F4F9;\n\t\t\t}\t\t\t\n\t\t}\n\t\t.react-datepicker__triangle{\n\t\t\t&:before{\n\t\t\t\tbox-shadow: 0 0 16px 0px rgba(0 ,0 ,0 ,0.09);\n\t\t\t\tborder-bottom-color: transparent;    \n\t\t\t}\n\t\t}\n\t\t&__navigation{\n\t\t\ttop: 12px;\n\t\t\tline-height: 20px;\n\t\t\tbackground: var(--rgba-primary-1);\n\t\t\tborder-radius: 0.375rem;\n\t\t}\n\t\t&__navigation--previous{\n\t\t\tleft: 10px;\n\t\t\t\n\t\t}\n\t\t&__navigation--next{\n\t\t\tright: 10px;\n\t\t}\n\t\t&__navigation-icon{\n\t\t\t&:before{\n\t\t\t\tborder-color: var(--primary);\n\t\t\t\tborder-width: 2px 2px 0 0;\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t\t&__day--weekend {\n\t\t\t// color: $danger!important;\n\t\t}\n\t\t&__current-month{\n\t\t\tpadding: 10px 0px;\n\t\t\tmargin: 0 20px;\n\t\t\tfont-size: 15px;\n\t\t\tfont-weight: 500;\n\t\t\t// color: var(--secondary);\t\t\t\n\t\t}\n\t}\n\t.react-datepicker__day-name, .react-datepicker__day, .react-datepicker__time-name{\n\t\t// width: 50px;\n\t\theight: 55px;\n\t\tflex: 1;\n\t\tline-height: 55px;\n\t\tfont-size: 13px;\n\t\tfont-weight: 400;\n\t\t// color: var(--secondary);\n\t\tmargin: 0;\n\t\tfont-family: 'poppins', sans-serif;\n\t}\n\t.react-datepicker__day--selected{\n\t\tbackground: var(--primary) !important;\n\t\tcolor: $white !important;\n\t}\n\t\n\t\n\t@include respond ('phone-land'){\n\t\t// display:none;\n\t}\n\tsvg{\n\t\tpath{\n\t\t\tfill:var(--primary);\n\t\t}\n\t}\n\t.react-datepicker-wrapper{\n\t\twidth: auto;\n\t}\n\t.react-datepicker__month-container{\n\t\tfloat: inherit;\n\t}\n}\n\n.drop-select{\n\twidth: 130px;\n\t.drop-select-btn {\n\t\tbackground-color: transparent !important;\n    \tfont-weight: 400;\n\t\tpadding: 0.6875rem 1.25rem;\n\t\tborder: 1px solid #dddddd;\n\t\tborder-width: 1px;\n\t\tline-height: 1.5;\n\t\tfont-size: 1rem;\n\t\tborder-radius: 6px;\n\t\tcolor: #303972;\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\twidth: 100%;\n\t\t&:after {\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-left: 0;\n\t\t\tvertical-align: unset;\n\t\t\tcontent: \"\";\n\t\t\twidth: 0.5rem;\n\t\t\theight: 0.5rem;\n\t\t\tborder-top: 2px solid #666;\n\t\t\tborder-right: 2px solid #666;\n\t\t\ttransform: rotate(135deg);\n\t\t\tborder-bottom: none;\n\t\t\tborder-left: none;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\t\t\tmargin-bottom: 0.25rem;\n\t\t}\n\t}\n\t.dropdown-menu{\n\t\tmin-width: 8rem;\n\t\tz-index: 2;\n\t\t.dropdown-item {\n\t\t\tfont-size: 0.875rem;\n\t\t\t&:first-child {\n\t\t\t\tcolor: var(--primary);\n\t\t\t\tbackground: var(--rgba-primary-1);\n\t\t\t}\n\t\t}\n\t}\n}",".contact_list{\n\t@include transitionSlow;\n\t.dropdown{\n\t\tposition: absolute;\n\t\ttop: 20px;\n\t\tright: 20px;\t\t\t\n\t}\n\t\n\t&:hover{\n\t\tbox-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n\t}\n\t.btn-check:focus + .btn, .btn:focus {\n\t\toutline: 0;\n\t\t\n\t}\n\t\n}\n\n\n/* Teacher Detail */\n\n.user-bg{\n\theight:140px;\n    background-color: var(--primary);\n\tborder-radius:$radius $radius 0 0;\n\tposition:relative;\n\t\n\t.user-svg,\n\t.user-svg-1{\n\t\tposition:absolute;\n\t\tbottom:0;\n\t\tright:40px;\n\t\tz-index:1;\n\t\t\n\t\t@include respond ('phone'){\n\t\t\tright:27px;\n\t\t}\n\n\t\t@include respond('tab-port'){\n\t\t\tsvg{\n\t\t\t\twidth:9.375rem;\n\t\t\t\theight:6.25rem;\n\t\t\t\t\n\t\t\t\t@include respond ('phone'){\n\t\t\t\t\twidth:7.738rem;\n\t\t\t\t\theight:4.813rem;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t\t\n\n\t\t}\n\t}\n\n\t.user-svg-1{\n\t\tright:144px;\n\t\tz-index:0;\n\t\t\n\t\t@include respond ('phone'){\n\t\t\tright:68px;\n\t\t}\n\t}\n\t\n}\n.user{\n\tmargin-top: -100px;\n\t@include respond ('phone'){\n\t\tmargin-top:-72px;\n\t}\n\t.user-media{\n\t\tmargin-bottom: 20px;\n\t\t\n\t\t@include respond ('phone'){\n\t\t\tmargin-bottom:10px;\n\t\t}\n\t\t.avatar{\n\t\t\tborder:8px solid $white;\n\t\t\t\n\t\t\t@include respond ('phone'){\n\t\t\t\tborder-width:5px;\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t}\n}\n\n.user-content{\n\t.user-img{\n\t\tmargin-bottom:1.5rem;\n\t}\n\t.user-details{\n\t\t//margin-bottom:1.875rem;\n\t}\n\t.sharp{\n\t\t@include respond ('tab-land'){\n\t\t\twidth:2.4rem;\n\t\t\theight:2.4rem;\n\t\t}\n\t}\n}\n\n.teacher-deatails{\n\t//margin-top:2.188rem;\n\tp{\n\t\twidth:60%;\n\t\t\n\t\t@include respond ('laptop'){\n\t\t\twidth:100%;\n\t\t}\n\t}\n\t.dots{\n\t\tposition:relative;\n\t\tpadding-left:0.938rem;\n\t\tmargin-bottom:1.563rem;\n\t\t\t\n\t\t&:after{\n\t\t\tcontent:\"\";\n\t\t\tposition:absolute;\n\t\t\tbackground-color:var(--primary);\n\t\t\twidth:5px;\n\t\t\theight:5px;\n\t\t\tborder-radius:100%;\n\t\t\ttop:0.5rem;\n\t\t\tleft:0;\n\t\t}\n\t}\n}\n.contact-icon{\n\tmargin-bottom:30px;\n}\n.contact_list{\n\t.card-body{\n\t\t@include respond ('tab-land'){\n\t\t\tpadding:20px;\n\t\t}\n\t}\n}\n\n\n.image-placeholder {\n    position: relative;\n    max-width: 130px;\n    margin: 10px auto;\n    .avatar-edit {\n        position: absolute;\n        right: -5px;\n        z-index: 1;\n        top: 0px;\n        input {\n            display: none;\n            + label {\n                display: inline-block;\n                width: 34px;\n                height: 34px;\n                margin-bottom: 0;\n                border-radius: 100%;\n                background: #FFFFFF;\n                border: 1px solid transparent;\n                box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n                cursor: pointer;\n                font-weight: normal;\n                transition: all .2s ease-in-out;\n                &:hover {\n                    background: #f1f1f1;\n                    border-color: #d6d6d6;\n                }\n                &:after {\n\t\t\t\t\tcontent: \"\\f303\";\n                    font-family: 'Font Awesome 5 Free';\n\t\t\t\t\tfont-weight: 900;\n                    color: #757575;\n                    position: absolute;\n                    top:6px;\n                    left: 0;\n                    right: 0;\n                    text-align: center;\n                    margin: auto;\n                }\n            }\n        }\n    }\n    .avatar-preview {\n        width: 130px;\n        height: 130px;\n        position: relative;\n        border-radius: 100%;\n        border: 3px solid #F8F8F8;\n\t\toverflow: hidden;\n        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n        & > div {\n            width: 100%;\n\t\t\theight: 100%;\n            border-radius: 30px;\n            background-size: cover;\n            background-repeat: no-repeat;\n            background-position: center;\n\t\t\t\n\t\t\timg{\n\t\t\t\theight: 100%;\n\t\t\t\twidth: 100%;\n\t\t\t\tobject-fit: cover\n\t\t\t}\n        }\n    }\n}\n.project-boxed {\n    overflow: hidden;\n}",".food-tabs{\n\tborder-bottom: 2px solid var(--rgba-primary-1);\n\t.nav-item{\n\t\t.nav-link{\n\t\t\tposition:relative;\n\t\t\t&:after{\n\t\t\t\tcontent: \"\";\n\t\t\t\tposition: absolute;\n\t\t\t\tbackground-color: var(--primary);\n\t\t\t\twidth: 0px;\n\t\t\t\theight: 2px;\n\t\t\t\tbottom: -2px;\n\t\t\t\tleft: 0px\n\t\t\t}\n\t\t\t&.active{\n\t\t\t\tbackground-color:unset;\n\t\t\t\tborder:1px solid transparent;\n\t\t\t\tcolor:var(--primary);\n\t\t\t\t&:after{\n\t\t\t\t\twidth:100%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:hover{\n\t\t\t\t\tborder:1px solid transparent;\n\t\t\t}\n\t\t\tcolor:#c2c2c2;\n\t\t\t@include respond ('phone'){\n\t\t\t\tpadding:12px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.food-menu{\n\tdisplay:flex;\n\talign-items:center;\n\n\t\n}\n.food-review{\n\tdisplay:flex;\n\talign-items:center;\n\th5{\n\t\tmargin-bottom:0;\n\t}\n\t\n\ti{\n\t\tcolor:$warning;\n\t\tmargin-right:0.313rem;\n\t}\n}\n\n/* food-details */\n\n.food-media{\n\twidth:361px;\n\theight:191px;\n\tobject-fit:cover;\n\timg{\n\t\twidth:100%;\n\t\t\n\t}\n\t@include respond ('phone'){\n\n\t\twidth:100%;\n\t\tmargin-bottom: 1rem;\n\t}\n}\n.food-recipe{\n\tli{\n\t\tlist-style:unset;\n\t\tmargin:5px 20px;\n\t}\n\t\n}",".schedule-card,\n.schedule-card-1,\n.schedule-card-2,\n.schedule-card-3{\n\tposition:relative;\n\toverflow:hidden;\n\t.card-body{\n\t\tpadding-top:24px;\n\t\tpadding-bottom:24px;\n\t\tmargin-left:3px;\n\t}\n\t\n\t&:after{\n\t\tcontent:\"\";\n\t\tposition:absolute;\n\t\tbackground-color:var(--primary);\n\t\twidth:0.438rem;\n\t\theight:12.188rem;\n\t\ttop:0;\n\t\tleft:0;\n\t}\n}\n.schedule-card-1{\n\t&:after{\n\t\tbackground-color:var(--secondary);\n\t}\n}\n.schedule-card-2{\n\t&:after{\n\t\tbackground-color:$warning;\n\t}\n}\n.schedule-card-3{\n\t&:after{\n\t\tbackground-color:$dark;\n\t}\n}\n.student-details{\n\tdisplay:flex;\n\talign-items:center;\n\t\n\t@include custommq($max:100rem){\n\t\tmargin-bottom:10px;\n\t}\n\n\t@include respond('tab-land'){\n\t\tmargin-bottom:10px;\n\n\t}\n\n\n}\n.setting-img{\n\timg{\n\t\twidth:7.5rem;\n\t\theight:7.5rem;\n\t\tborder-radius:$radius;\n\t\tobject-fit:cover;\n\t}\n\t.change{\n\t\tborder-radius:$radius-sm;\n\t\t\n\t\tpadding:0.688rem 0.875rem;\n\t\n\t\t@include respond ('phone'){\n\t\t\tmargin-left:1rem;\n\t\t}\n\t}\n\t@include respond ('phone'){\n\t\t    flex-wrap: wrap;\n\t}\n}\n.avatar-upload {\n    .avatar-edit {\n        position: absolute;\n        right: 0.75rem;\n        z-index: 1;\n        top: 0.625rem;\n    }\n    .avatar-preview {\n        > div {\n          display:inline-block;\n\t\t\twidth:6.5rem;\n\t\t\theight:6.5rem;\n\t\t\tbackground-size:cover;\n\t\t\tbackground-repeat:no-repeat;\n\t\t\tbackground-position: center;\n\t\t\tborder-radius:$radius-sm;\n        }\n    }\n}\n input.form-control{\n\tposition:relative;\n}\ninput[type=\"date\"]::-webkit-calendar-picker-indicator {\n    background: transparent;\n    bottom: 0;\n    color: transparent;\n    cursor: pointer;\n    height: auto;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: auto;\n}\n\n",".p-static{\n\t.bootstrap-select{\n\t\twidth:130px!important;\n\t}\n}\n.table-responsive{\n\t.unpaid-school{\n\t\tthead{\n\t\t\tbackground-color:unset;\n\t\t\tth{\n\t\t\t\tcolor:#000;\n\t\t\t}\n\t\t\ttd{\n\t\t\t\tspan{\n\t\t\t\t\tfont-size:14px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n",".input-group{\n\t&.user-search-area{\n\t\tmargin-top:0.875rem;\n\t\t.input-group-text{\n\t\t\tbackground-color:transparent;\n\t\t\tborder-color:$border-main-color\n\t\t\t\n\t\t}\n\t\t.form-control{\n\t\t\t\tborder-left:0;\n\t\t\t\tborder-color:$border-main-color;\n\t\t\t&:focus{\n\t\t\t\tborder-color:$border-main-color;\n\t\t\t}\n\t\t}\n\t}\n}\n.timeline-active{\n\t.timeline-list{\n\t\tposition: relative;\n        padding: 1.1rem 0;\n\t\t\n\t\t&:before{\n\t\t\t    top: 2.275rem;\n    bottom: 0;\n    position: absolute;\n    content: \" \";\n    width: 0.125rem;\n    height: calc(100% - 0.875rem);\n    left: 13.4px;\n    margin-right: -0.0938rem;\n    background: $border-main-color; \t\n\t\t}\n\t}\n\t\tspan,\n\t\t.time{\n\t\t\tfont-size:13px;\n\t\t\tmargin-left:10px;\n\t\t}\n  \n}\n\n.plan-bx{\n\tposition:relative;\n\t.plan-svg,\n\t.plan-svg-1{\n\t\tposition:absolute;\n\t\tbottom:0;\n\t\tright:0;\n\t\tz-index:0;\n\n\t\t@include respond ('laptop'){\n\t\t\tsvg{\n\t\t\t\twidth:100px;\n\t\t\t\theight:100px;\n\t\n\t\t\t}\n\t\t\tright:-7px;\n\n\t\t}\n\t\t@include respond ('phone'){\n\n\t\t\tright:8px;\n\t\t\tsvg{\n\n\t\t\t\twidth: 68px;\n\t\t\t\theight: 146px;\n\t\t\t}\n\t\t}\n\t\t@include respond ('tab-land'){\n\t\t\tsvg{\n\t\t\t\twidth:6.25rem;\n\t\t\t\theight:9.375rem;\n\t\t\t}\n\t\t\t\t\n\n\t\t}\n\n\t\t\n\t}\n\t.plan-svg-1{\n\t\tright:0.825rem;\n\t\tz-index:1;\n\t\t@include respond ('laptop'){\n\t\t\tright:1.25rem;\n\n\t\t}\n\t\t@include respond ('tab-land'){\n\n\t\t\tright:2.125rem;\n\t\t}\n\t}\n\t\n}\n.photo-content{\n    position: relative;\n    .cover-photo{\n        background: url(../images/profile/12.jpg);\n        background-size: cover;\n        background-position: center;\n        min-height: 15.625rem;\n        width: 100%;\n        border-top-left-radius: $radius;\n        border-top-right-radius: $radius;\n    }\n\n}\n.user{\n\tcursor:pointer;\n\t&:hover{\n\t\t.st-box{\n\t\t\tbackground-color:var(--primary);\n\t\t\tborder-color:var(--primary);\n\t\t\tsvg{\n\t\t\t\tpath{\n\t\t\t\t\tfill:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\ta{\n\t\t\tcolor:var(--primary);\n\t\t}\n\t}\n}\n.author-profile{\n\ttext-align:center;\n\t.card-body{\n\t\tpadding: 0;\n\t}\n\t.author-media{\n\t\tposition: relative;\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t\tmargin-bottom: 20px;\n\t\tdisplay: inline-block;\n\t\timg{\n\t\t\twidth: 130px;\n\t\t\tborder-radius: 100%;\n\t\t}\n\t}\t\n\t.author-info{\n\t\t.title{\n\t\t\tfont-size:15px;\n\t\t\tfont-weight:500;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t\tspan{\n\t\t\tdisplay:block;\n\t\t\tcolor: $body-color;\n\t\t}\n\t}\n\t.info-list{\n\t\tli{\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: space-between;\n\t\t\tfont-size: 15px;\n\t\t\tborder-top: 1px solid $border-color;\n\t\t\tpadding: 18px 30px;\n\t\t\tcolor: $dark;\n\t\t\ta{\n\t\t\t\tcolor: $dark;\n\t\t\t}\n\t\t\tspan{\n\t\t\t\tcolor: $body-color;\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\t\t}\n\t}\n\t.card-footer {\n\t\tpadding: 30px;\n\t\tdisplay: block;\n\t\t.form-control {\n\t\t\theight: 45px;\n\t\t\tborder-color: $border-color;\n\t\t\toverflow:hidden;\n\t\t}\n\t}\n\t.upload-link {\n\t\tposition: absolute;\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tline-height: 32px;\n\t\tbackground: #395ee2;\n\t\tbottom: 0;\n\t\tright: 0px;\n\t\tbox-shadow: 0 0 10px 0 rgba(0, 24, 128, 0.1);\n\t\tborder-radius: 100%;\n\t\tcolor: #fff;\n\t\toverflow: hidden;\n\t\tborder: 2px solid #fff;\n\t\t.update-flie {\n\t\t\tposition: absolute;\n\t\t\topacity: 0;\n\t\t\tz-index: 0;\n\t\t\twidth: 100%;\n\t\t\tcursor: pointer;\n\t\t\tleft: 0;\n\t\t\theight: 100%;\n\t\t}\n\t}\n}\n.m-b30{\n\tmargin-bottom:16px;\n}\n\n\n",".timeline-active{\n\t&.style-1{\n\t\t.timeline-list{\n\t\t\tposition: relative;\n\t\t   padding: 1.1rem 0;\n\t\t\t\n\t\t\t&:before{\n\t\t\t\t    top: 2.375rem;\n\t\t\t\t    bottom: 0;\n\t\t\t\t    position: absolute;\n\t\t\t\t    content: \" \";\n\t\t\t\t    width: 0.125rem;\n\t\t\t\t    height: calc(100% - 0.875rem);\n\t\t\t\t    left: 0.463rem;\n\t\t\t\t    margin-right: -0.0938rem;\n\t\t\t\t    background: $border-main-color; \t\n\t\t\t\t @include respond ('laptop'){\n\t\t\t\t\tleft:0.563rem;\n\t\t\t\t\ttop:2.575rem;\n\t\t\t\t }\n\t\t\t\t @include respond ('phone'){\n\t\t\t\t\tleft:0.463rem;\n\t\t\t\t }\n\t\t\t}\n\t\t\t\n\t\t\t.modulel{\n\t\t\t\tdisplay:flex;\n\t\t\t\talign-items:center;\n\t\t\t\t\n\t\t\t\timg{\n\t\t\t\t\twidth:17.375rem!important;\n\t\t\t\t\theight:10.125rem;\n\t\t\t\t\tborder-radius:$radius;\n\t\t\t\t\tmargin-left:0.625rem;\n\t\t\t\t\tobject-fit:cover;\n\t\t\t\t\t@include respond ('laptop'){\n\t\t\t\t\t\tmargin-bottom:0.625rem;\n\t\t\t\t\t\t\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tspan,\n\t\t.time{\n\t\t\tfont-size:13px;\n\t\t\tmargin-left:10px;\n\t\t\tmargin-bottom:0;\n\t\t}\n\t\t.last-timeline{\n\t\t\tpadding-top:19px;\n\t\t}\n\t}\n  \n}\n","/*\n===================================\n    Product detail\n===================================*/\n\n.produtct-detail-tag {\n    display: inline-block;\n    a {\n        font-style: 0.8125rem;\n        color: $dark;\n    }\n}\n\n.product-detail-content {\n    .item-tag {\n        background: $l-ctl;\n        border-radius: 0.375rem;\n        display: inline-block;\n        font-size: 0.75rem;\n        margin-right: 0.25rem;\n        padding: 0.125rem 0.75rem;\n        color: #fff;\n    }\n    input.form-control.input-btn.input-number {\n        height: 3rem;\n\t\t@include respond ('laptop'){\n\t\t\theight:2.285rem;\n\t\t}\n    }\n}\n\n.filtaring-area {\n    h4 {\n        color: #1d1d1d;\n        font-size: 1rem;\n        font-weight: 400;\n        text-transform: lowercase;\n    }\n}\n\n.plus-minus-input {\n    .input-icon {\n        font-size: 0.8125rem;\n        color: $dark;\n    }\n}\n\n.plus-minus-input {\n    display: flex;\n    width: 7.5rem;\n    .custom-btn {\n        border-radius: 0;\n        height: 2.5rem;\n        padding: 0.75rem 0.5rem;\n        background: $white;\n        border: 0.0625rem solid $border;\n    }\n    .form-control {\n        &:hover,\n        &:focus,\n        &:active {\n            border: 0.0625rem solid $border;\n        }\n    }\n}\n.btn-reveal-trigger .avatar-xl {\n    min-width: 1.875rem;\n}\n.share-view {\n    display: inline-block;\n    ul {\n        li {\n            display: inline-block;\n            a {}\n        }\n    }\n    .share-icon {\n        width: 2.5rem;\n        height: 2.5rem;\n        display: inline-block;\n        border: 0.0625rem solid $border;\n        text-align: center;\n        line-height: 2.5rem;\n        font-style: 1rem;\n        color: $border;\n        margin-right: 0.5rem;\n    }\n}\n\n\n/*--------tab----------*/\n\n.veritical-line {\n    padding: 1.25rem 1.875rem;\n    border-top: 0.0625rem solid $border;\n    border-right: 0.0625rem solid $border;\n    border-bottom: 0.0625rem solid $border;\n    position: relative;\n    &:before {\n        background: $border;\n        bottom: 0;\n        content: \"\";\n        height: 100%;\n        left: -0.0625rem;\n        max-height: 40%;\n        position: absolute;\n        width: 0.0625rem;\n    }\n}\n\n.tab-content-text {\n    p {\n        color: $dark;\n        font-size: 0.8125rem;\n        font-weight: 400;\n        line-height: 1.5rem;\n        margin-bottom: 1.5625rem;\n    }\n}\n\n.tab-item-list {\n    li {\n        a {\n            background: $white;\n            border-top: 0.0625rem solid $border;\n            border-left: 0.0625rem solid $border;\n            border-right: 0.0625rem solid $border;\n            color: $dark;\n            display: block;\n            font-size: 1rem;\n            padding: 1rem;\n            text-transform: uppercase;\n            &:hover,\n            &:focus {\n                background: $white;\n                color: $dark;\n                border-right: 0rem;\n            }\n        }\n        &:last-child {\n            border-bottom: 0.0625rem solid $border;\n        }\n    }\n}\n\n.tab-list {\n    li {\n        margin-bottom: 0.4375rem;\n        font-size: 0.8125rem;\n        i {\n            font-size: 0.8125rem;\n            margin-right: 0.875rem;\n        }\n    }\n}\n\n.slide-item-list {\n    text-align: center;\n\tmargin: 0 -0.3125rem;\n    border:0;\n    .nav-link{\n        border:0;\n        &:hover{\n\n            border:0;\n        }\n        &.active{\n            border:0;\n            background-color: transparent;\n\n        }\n\n    } \n\t\n    li {\n        display: inline-block;\n\t\tflex: 0 0 25%;\n\t\twidth: 25%;\n\t\tpadding: 0 0.3125rem;\n\t\t\n        a {\n            display: inline-block;\n            //      float: left;\n            padding-left: 0;\n            padding-right: 0;\n            padding-top: 0;\n            background: transparent;\n            padding-bottom: 0rem;\n            &:hover,\n            &:focus {\n                background: transparent;\n            }\n            img {\n                width: 100%;\n\t\t\t\tborder-radius:$radius;\n            }\n        }\n    }\n}\n\n.product-detail-text {\n    padding-top: 1.75rem;\n    padding-left: 1.875rem;\n    padding-right: 1.875rem;\n    padding-bottom: 4.375rem;\n}\n\n.star-rating {\n    .product-review {\n        font-style: 0.8125rem;\n        color: $dark;\n        font-weight: 400;\n        text-decoration: underline !important;\n    }\n}\n\n.product-detail {\n    .tab-content {\n        img {\n            display: inline-block;\n            width: 100%;\n        }\n    }\n}\n\n.popular-tag ul {\n    margin: 0rem;\n    padding: 0rem;\n    li {\n        display: inline-block;\n        padding: 0.5rem 0.9375rem;\n        background: #f8f8f8;\n        font-size: 0.8125rem;\n        color: #fff;\n        margin-right: 0.625rem;\n        margin-bottom: 0.625rem;\n    }\n}\n\n.size-filter ul li {\n    display: inline-block;\n}\n\n.intro {\n    border: 0.0625rem solid red;\n    color: #1d1d1d;\n}\n\n#listResults {\n    .slider {\n        margin: 1.5625rem 0;\n    }\n    .slider-box {\n        width: 90%;\n        margin: 1.5625rem auto;\n    }\n    input {\n        width: 10%;\n    }\n    label {\n        border: none;\n        display: inline-block;\n        margin-right: -0.25rem;\n        vertical-align: top;\n        width: 30%;\n    }\n}\n\n// input {\n//     border: none;\n//     display: inline-block;\n//     margin-right: -0.25rem;\n//     vertical-align: top;\n//     width: 30%;\n// }\n.plus-minus-input {\n    .input-icon {\n        font-size: 0.8125rem;\n        color: #aaaaaa;\n    }\n    .custom-btn {\n        border-radius: 0;\n        height: 2.5rem;\n        padding: 0.5rem 0.75rem;\n        background: #ffffff;\n        border: 0.0625rem solid #c8c8c8;\n        &:hover,\n        &:focus,\n        &.active {\n            box-shadow: none;\n            outline: none;\n        }\n    }\n    .form-control {\n        height: 2.5rem;\n        border-top: 0.0625rem solid #c8c8c8;\n        border-bottom: 0.0625rem solid #c8c8c8;\n        border-left: 0rem solid #c8c8c8;\n        border-right: 0.0625rem solid #c8c8c8;\n        &:hover,\n        &:focus,\n        &:active {\n            border-top: 0.0625rem solid #c8c8c8;\n            border-bottom: 0.0625rem solid #c8c8c8;\n            border-left: 0rem solid #c8c8c8;\n            border-right: 0rem solid #c8c8c8;\n        }\n    }\n}",".new-arrival-product{\n\t.new-arrivals-img-contnent{\n\t\toverflow:hidden;\n\t\tposition: relative;\n\t\t\n\t\timg{\n\t\t\twidth:100%;\n\t\t\t@include transitionMedium;\n\t\t\tborder-radius:$radius;\n\t\t}\n\t\t&:after{\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: -85%;\n\t\t\tz-index: 2;\n\t\t\tdisplay: block;\n\t\t\tcontent: '';\n\t\t\twidth: 50%;\n\t\t\theight: 100%;\n\t\t\tbackground: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 100%);\n\t\t\t-webkit-transform: skewX(-25deg);\n\t\t\ttransform: skewX(-25deg);\n\t\t}\n\t\t\n\t}\n\t\t.discount{\n\t\t\tfont-size:14px;\n\t\t\tmargin-right:8px;\n\t\t\topacity:0.8;\n\t\t\tcolor:var(--primary);\n\t\t}\n\t&:hover {\n\t\t.new-arrivals-img-contnent{\n\t\t\t&:after{\n\t\t\t\twebkit-animation: shine .75s;\n\t\t\t\tanimation: shine .75s;\n\t\t\t}\n\t\t}\n\t}\n\t\n\t\n}\n@-webkit-keyframes shine {\n\t100% {\n\t\tleft: 125%;\n\t}\n}\n@keyframes shine {\n\t100% {\n\t\tleft: 125%;\n\t}\n}\n.star-rating{\n\tmargin-bottom: 0.625rem;\n}\n.select-size{\n\t.btn{\n\t\t&:not(:first-child),\n\t\t&:not(last-child){\n\t\t\tmargin:0 5px;\n\t\t\tbox-shadow:none;\n\t\t}\n\t\t\n\t}\n}\n\n.card{\n\t&.product-grid-card{\n\t\t.card-body{\n\t\t\tpadding:15px;\n\t\t}\n\t}\n}\n","/*\n===================================\n    list view\n===================================*/\n\n.new-arrival-content {\n    .item {\n        font-size: 0.75rem;\n        color: $black;\n    }\n    h4 {\n        font-size: 1.25rem;\n\t\tfont-weight: 600;\n        margin-bottom: 0.625rem;\n\t\t@include respond ('phone'){\n\t\t\tmargin-top:1rem;\n\t\t}\n    }\n    .price {\n        font-weight: 500;\n\t\tcolor: var(--primary);\n\t\t font-size: 1.25rem;\n\t\tmargin-bottom: 0;\n\t\tfloat: right;\n\t\t@include respond ('phone'){\n\t\t\tfloat:none;\n\t\t\tmargin-top:0.625rem;\n\t\t}\n    }\n    p {\n        font-size: 0.875rem;\n        margin-bottom: 0.375rem;\n        line-height: 1.5rem;\n    }\n    .text-content {\n        margin-top: 1.125rem;\n    }\n}\n.new-arrival-content.text-center .price {\n\tfloat: unset!important;\n}\n\n.success-icon {\n    color: $success;\n    font-size: 1rem;\n}\n\n.comment-review {\n    margin-bottom: 0.9375rem;\n    display: table;\n    width: 100%;\n    .client-review {\n        color: $d-ctl;\n        padding-right: 1.25rem;\n        text-decoration: underline !important;\n        font-size: 0.875rem;\n    }\n    .span {\n        color: $d-ctl;\n        font-size: 0.875rem;\n    }\n\t@include respond ('phone'){\n\t\tmargin-bottom:0;\n\t}\n}\n\n.star-rating li {\n    display: inline-block;\n    i {\n        color: gold;\n    }\n}\n.table-striped > tbody > tr:nth-of-type(odd) > *{\n\tbackground:#ffffff;\n}\n.table-responsive{\n    .table{\n        &.order-table{\n            thead{\n                background-color:$white;\n                th{\n\t\t\t\t\tcolor:$dark;\n\t\t\t\t\tfont-weight:600;\n                    &:first-child{\n\n                        border-top-left-radius: $radius;\n                    }\n                    &:last-child{\n\n                        border-top-right-radius: $radius;\n                    }\n                }\n            }\n        }\n    }\n}","[data-theme-version=\"dark\"] {\n\t.nav-header{\n\t\tborder-color:$d-border;\n\t\t.brand-title{\n\t\t\tsvg{\n\t\t\t\tpath{\n\t\t\t\t\tfill:$white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t&[data-sidebar-position=\"fixed\"][data-layout=\"vertical\"]{\n\t}\t\n  \n\n    .nav-control {\n        color: $white;\n    }\n\n    .brand-logo {\n        color: $white;\n\n        &:hover {\n            color: $white;\n        }\n    }\n\t\n\t.svg-title-path{\n\t\tfill:$white;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
